(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecb85"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecb85"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5OOF9", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $43c8ebcdbcb04ad6$export$ffb0004e005737fa; }, function (v) { return $43c8ebcdbcb04ad6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $43c8ebcdbcb04ad6$export$34b9dba7ce09269b; }, function (v) { return $43c8ebcdbcb04ad6$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $43c8ebcdbcb04ad6$export$25062201e9e25d76; }, function (v) { return $43c8ebcdbcb04ad6$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $43c8ebcdbcb04ad6$export$ffb0004e005737fa;
var $43c8ebcdbcb04ad6$export$34b9dba7ce09269b;
var $43c8ebcdbcb04ad6$export$25062201e9e25d76;
"use strict";

var $4YNlq = parcelRequire("4YNlq");
var $43c8ebcdbcb04ad6$var$k = Symbol.for("react.element"), $43c8ebcdbcb04ad6$var$l = Symbol.for("react.fragment"), $43c8ebcdbcb04ad6$var$m = Object.prototype.hasOwnProperty, $43c8ebcdbcb04ad6$var$n = $4YNlq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $43c8ebcdbcb04ad6$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $43c8ebcdbcb04ad6$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$43c8ebcdbcb04ad6$var$m.call(a, b) && !$43c8ebcdbcb04ad6$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $43c8ebcdbcb04ad6$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $43c8ebcdbcb04ad6$var$n.current
    };
}
$43c8ebcdbcb04ad6$export$ffb0004e005737fa = $43c8ebcdbcb04ad6$var$l;
$43c8ebcdbcb04ad6$export$34b9dba7ce09269b = $43c8ebcdbcb04ad6$var$q;
$43c8ebcdbcb04ad6$export$25062201e9e25d76 = $43c8ebcdbcb04ad6$var$q;

});
parcelRegister("4YNlq", function(module, exports) {
"use strict";

module.exports = (parcelRequire("Fht8V"));

});
parcelRegister("Fht8V", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $07c161707435eb91$export$dca3b0875bd9a954; }, function (v) { return $07c161707435eb91$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $07c161707435eb91$export$16fa2f45be04daa8; }, function (v) { return $07c161707435eb91$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $07c161707435eb91$export$ffb0004e005737fa; }, function (v) { return $07c161707435eb91$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $07c161707435eb91$export$e2c29f18771995cb; }, function (v) { return $07c161707435eb91$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $07c161707435eb91$export$221d75b3f55bb0bd; }, function (v) { return $07c161707435eb91$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $07c161707435eb91$export$5f8d39834fd61797; }, function (v) { return $07c161707435eb91$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $07c161707435eb91$export$74bf444e3cd11ea5; }, function (v) { return $07c161707435eb91$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $07c161707435eb91$export$ae55be85d98224ed; }, function (v) { return $07c161707435eb91$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $07c161707435eb91$export$e530037191fcd5d7; }, function (v) { return $07c161707435eb91$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $07c161707435eb91$export$fd42f52fd3ae1109; }, function (v) { return $07c161707435eb91$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $07c161707435eb91$export$c8a8987d4410bf2d; }, function (v) { return $07c161707435eb91$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $07c161707435eb91$export$d38cd72104c1f0e9; }, function (v) { return $07c161707435eb91$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $07c161707435eb91$export$7d1e3a5e95ceca43; }, function (v) { return $07c161707435eb91$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $07c161707435eb91$export$257a8862b851cb5b; }, function (v) { return $07c161707435eb91$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $07c161707435eb91$export$a8257692ac88316c; }, function (v) { return $07c161707435eb91$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $07c161707435eb91$export$488013bae63b21da; }, function (v) { return $07c161707435eb91$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $07c161707435eb91$export$7c73462e0d25e514; }, function (v) { return $07c161707435eb91$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $07c161707435eb91$export$7568632d0d33d16d; }, function (v) { return $07c161707435eb91$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $07c161707435eb91$export$88948ce120ea2619; }, function (v) { return $07c161707435eb91$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $07c161707435eb91$export$35808ee640e87ca7; }, function (v) { return $07c161707435eb91$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $07c161707435eb91$export$fae74005e78b1a27; }, function (v) { return $07c161707435eb91$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $07c161707435eb91$export$dc8fbce3eb94dc1e; }, function (v) { return $07c161707435eb91$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $07c161707435eb91$export$6a7bc4e911dc01cf; }, function (v) { return $07c161707435eb91$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $07c161707435eb91$export$6d9c69b0de29b591; }, function (v) { return $07c161707435eb91$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $07c161707435eb91$export$f680877a34711e37; }, function (v) { return $07c161707435eb91$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $07c161707435eb91$export$d5a552a76deda3c2; }, function (v) { return $07c161707435eb91$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $07c161707435eb91$export$aaabe4eda9ed9969; }, function (v) { return $07c161707435eb91$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $07c161707435eb91$export$e5c5a5f917a5871c; }, function (v) { return $07c161707435eb91$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $07c161707435eb91$export$1538c33de8887b59; }, function (v) { return $07c161707435eb91$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $07c161707435eb91$export$13e3392192263954; }, function (v) { return $07c161707435eb91$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $07c161707435eb91$export$b8f5890fc79d6aca; }, function (v) { return $07c161707435eb91$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $07c161707435eb91$export$60241385465d0a34; }, function (v) { return $07c161707435eb91$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $07c161707435eb91$export$306c0aa65ff9ec16; }, function (v) { return $07c161707435eb91$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $07c161707435eb91$export$7b286972b8d8ccbf; }, function (v) { return $07c161707435eb91$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $07c161707435eb91$export$83d89fbfd8236492; }, function (v) { return $07c161707435eb91$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $07c161707435eb91$export$dca3b0875bd9a954;
var $07c161707435eb91$export$16fa2f45be04daa8;
var $07c161707435eb91$export$ffb0004e005737fa;
var $07c161707435eb91$export$e2c29f18771995cb;
var $07c161707435eb91$export$221d75b3f55bb0bd;
var $07c161707435eb91$export$5f8d39834fd61797;
var $07c161707435eb91$export$74bf444e3cd11ea5;
var $07c161707435eb91$export$ae55be85d98224ed;
var $07c161707435eb91$export$e530037191fcd5d7;
var $07c161707435eb91$export$fd42f52fd3ae1109;
var $07c161707435eb91$export$c8a8987d4410bf2d;
var $07c161707435eb91$export$d38cd72104c1f0e9;
var $07c161707435eb91$export$7d1e3a5e95ceca43;
var $07c161707435eb91$export$257a8862b851cb5b;
var $07c161707435eb91$export$a8257692ac88316c;
var $07c161707435eb91$export$488013bae63b21da;
var $07c161707435eb91$export$7c73462e0d25e514;
var $07c161707435eb91$export$7568632d0d33d16d;
var $07c161707435eb91$export$88948ce120ea2619;
var $07c161707435eb91$export$35808ee640e87ca7;
var $07c161707435eb91$export$fae74005e78b1a27;
var $07c161707435eb91$export$dc8fbce3eb94dc1e;
var $07c161707435eb91$export$6a7bc4e911dc01cf;
var $07c161707435eb91$export$6d9c69b0de29b591;
var $07c161707435eb91$export$f680877a34711e37;
var $07c161707435eb91$export$d5a552a76deda3c2;
var $07c161707435eb91$export$aaabe4eda9ed9969;
var $07c161707435eb91$export$e5c5a5f917a5871c;
var $07c161707435eb91$export$1538c33de8887b59;
var $07c161707435eb91$export$13e3392192263954;
var $07c161707435eb91$export$b8f5890fc79d6aca;
var $07c161707435eb91$export$60241385465d0a34;
var $07c161707435eb91$export$306c0aa65ff9ec16;
var $07c161707435eb91$export$7b286972b8d8ccbf;
var $07c161707435eb91$export$83d89fbfd8236492;
"use strict";
var $07c161707435eb91$var$l = Symbol.for("react.element"), $07c161707435eb91$var$n = Symbol.for("react.portal"), $07c161707435eb91$var$p = Symbol.for("react.fragment"), $07c161707435eb91$var$q = Symbol.for("react.strict_mode"), $07c161707435eb91$var$r = Symbol.for("react.profiler"), $07c161707435eb91$var$t = Symbol.for("react.provider"), $07c161707435eb91$var$u = Symbol.for("react.context"), $07c161707435eb91$var$v = Symbol.for("react.forward_ref"), $07c161707435eb91$var$w = Symbol.for("react.suspense"), $07c161707435eb91$var$x = Symbol.for("react.memo"), $07c161707435eb91$var$y = Symbol.for("react.lazy"), $07c161707435eb91$var$z = Symbol.iterator;
function $07c161707435eb91$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $07c161707435eb91$var$z && a[$07c161707435eb91$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $07c161707435eb91$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $07c161707435eb91$var$C = Object.assign, $07c161707435eb91$var$D = {};
function $07c161707435eb91$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $07c161707435eb91$var$D;
    this.updater = e || $07c161707435eb91$var$B;
}
$07c161707435eb91$var$E.prototype.isReactComponent = {};
$07c161707435eb91$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$07c161707435eb91$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $07c161707435eb91$var$F() {}
$07c161707435eb91$var$F.prototype = $07c161707435eb91$var$E.prototype;
function $07c161707435eb91$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $07c161707435eb91$var$D;
    this.updater = e || $07c161707435eb91$var$B;
}
var $07c161707435eb91$var$H = $07c161707435eb91$var$G.prototype = new $07c161707435eb91$var$F;
$07c161707435eb91$var$H.constructor = $07c161707435eb91$var$G;
$07c161707435eb91$var$C($07c161707435eb91$var$H, $07c161707435eb91$var$E.prototype);
$07c161707435eb91$var$H.isPureReactComponent = !0;
var $07c161707435eb91$var$I = Array.isArray, $07c161707435eb91$var$J = Object.prototype.hasOwnProperty, $07c161707435eb91$var$K = {
    current: null
}, $07c161707435eb91$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $07c161707435eb91$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$07c161707435eb91$var$J.call(b, d) && !$07c161707435eb91$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $07c161707435eb91$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $07c161707435eb91$var$K.current
    };
}
function $07c161707435eb91$var$N(a, b) {
    return {
        $$typeof: $07c161707435eb91$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $07c161707435eb91$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $07c161707435eb91$var$l;
}
function $07c161707435eb91$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $07c161707435eb91$var$P = /\/+/g;
function $07c161707435eb91$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $07c161707435eb91$var$escape("" + a.key) : b.toString(36);
}
function $07c161707435eb91$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $07c161707435eb91$var$l:
                case $07c161707435eb91$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $07c161707435eb91$var$Q(h, 0) : d, $07c161707435eb91$var$I(c) ? (e = "", null != a && (e = a.replace($07c161707435eb91$var$P, "$&/") + "/"), $07c161707435eb91$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($07c161707435eb91$var$O(c) && (c = $07c161707435eb91$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($07c161707435eb91$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($07c161707435eb91$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $07c161707435eb91$var$Q(k, g);
        h += $07c161707435eb91$var$R(k, b, e, f, c);
    }
    else if (f = $07c161707435eb91$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $07c161707435eb91$var$Q(k, g++), h += $07c161707435eb91$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $07c161707435eb91$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $07c161707435eb91$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $07c161707435eb91$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $07c161707435eb91$var$U = {
    current: null
}, $07c161707435eb91$var$V = {
    transition: null
}, $07c161707435eb91$var$W = {
    ReactCurrentDispatcher: $07c161707435eb91$var$U,
    ReactCurrentBatchConfig: $07c161707435eb91$var$V,
    ReactCurrentOwner: $07c161707435eb91$var$K
};
$07c161707435eb91$export$dca3b0875bd9a954 = {
    map: $07c161707435eb91$var$S,
    forEach: function(a, b, e) {
        $07c161707435eb91$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $07c161707435eb91$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $07c161707435eb91$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$07c161707435eb91$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$07c161707435eb91$export$16fa2f45be04daa8 = $07c161707435eb91$var$E;
$07c161707435eb91$export$ffb0004e005737fa = $07c161707435eb91$var$p;
$07c161707435eb91$export$e2c29f18771995cb = $07c161707435eb91$var$r;
$07c161707435eb91$export$221d75b3f55bb0bd = $07c161707435eb91$var$G;
$07c161707435eb91$export$5f8d39834fd61797 = $07c161707435eb91$var$q;
$07c161707435eb91$export$74bf444e3cd11ea5 = $07c161707435eb91$var$w;
$07c161707435eb91$export$ae55be85d98224ed = $07c161707435eb91$var$W;
$07c161707435eb91$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $07c161707435eb91$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $07c161707435eb91$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$07c161707435eb91$var$J.call(b, f) && !$07c161707435eb91$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $07c161707435eb91$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$07c161707435eb91$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $07c161707435eb91$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $07c161707435eb91$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$07c161707435eb91$export$c8a8987d4410bf2d = $07c161707435eb91$var$M;
$07c161707435eb91$export$d38cd72104c1f0e9 = function(a) {
    var b = $07c161707435eb91$var$M.bind(null, a);
    b.type = a;
    return b;
};
$07c161707435eb91$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$07c161707435eb91$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $07c161707435eb91$var$v,
        render: a
    };
};
$07c161707435eb91$export$a8257692ac88316c = $07c161707435eb91$var$O;
$07c161707435eb91$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $07c161707435eb91$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $07c161707435eb91$var$T
    };
};
$07c161707435eb91$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $07c161707435eb91$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$07c161707435eb91$export$7568632d0d33d16d = function(a) {
    var b = $07c161707435eb91$var$V.transition;
    $07c161707435eb91$var$V.transition = {};
    try {
        a();
    } finally{
        $07c161707435eb91$var$V.transition = b;
    }
};
$07c161707435eb91$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$07c161707435eb91$export$35808ee640e87ca7 = function(a, b) {
    return $07c161707435eb91$var$U.current.useCallback(a, b);
};
$07c161707435eb91$export$fae74005e78b1a27 = function(a) {
    return $07c161707435eb91$var$U.current.useContext(a);
};
$07c161707435eb91$export$dc8fbce3eb94dc1e = function() {};
$07c161707435eb91$export$6a7bc4e911dc01cf = function(a) {
    return $07c161707435eb91$var$U.current.useDeferredValue(a);
};
$07c161707435eb91$export$6d9c69b0de29b591 = function(a, b) {
    return $07c161707435eb91$var$U.current.useEffect(a, b);
};
$07c161707435eb91$export$f680877a34711e37 = function() {
    return $07c161707435eb91$var$U.current.useId();
};
$07c161707435eb91$export$d5a552a76deda3c2 = function(a, b, e) {
    return $07c161707435eb91$var$U.current.useImperativeHandle(a, b, e);
};
$07c161707435eb91$export$aaabe4eda9ed9969 = function(a, b) {
    return $07c161707435eb91$var$U.current.useInsertionEffect(a, b);
};
$07c161707435eb91$export$e5c5a5f917a5871c = function(a, b) {
    return $07c161707435eb91$var$U.current.useLayoutEffect(a, b);
};
$07c161707435eb91$export$1538c33de8887b59 = function(a, b) {
    return $07c161707435eb91$var$U.current.useMemo(a, b);
};
$07c161707435eb91$export$13e3392192263954 = function(a, b, e) {
    return $07c161707435eb91$var$U.current.useReducer(a, b, e);
};
$07c161707435eb91$export$b8f5890fc79d6aca = function(a) {
    return $07c161707435eb91$var$U.current.useRef(a);
};
$07c161707435eb91$export$60241385465d0a34 = function(a) {
    return $07c161707435eb91$var$U.current.useState(a);
};
$07c161707435eb91$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $07c161707435eb91$var$U.current.useSyncExternalStore(a, b, e);
};
$07c161707435eb91$export$7b286972b8d8ccbf = function() {
    return $07c161707435eb91$var$U.current.useTransition();
};
$07c161707435eb91$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("cbAyt", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $8df2de31e4e85614$export$ae55be85d98224ed; }, function (v) { return $8df2de31e4e85614$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $8df2de31e4e85614$export$d39a5bbd09211389; }, function (v) { return $8df2de31e4e85614$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $8df2de31e4e85614$export$882461b6382ed46c; }, function (v) { return $8df2de31e4e85614$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $8df2de31e4e85614$export$466bfc07425424d5; }, function (v) { return $8df2de31e4e85614$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $8df2de31e4e85614$export$cd75ccfd720a3cd4; }, function (v) { return $8df2de31e4e85614$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $8df2de31e4e85614$export$fa8d919ba61d84db; }, function (v) { return $8df2de31e4e85614$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $8df2de31e4e85614$export$757ceba2d55c277e; }, function (v) { return $8df2de31e4e85614$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $8df2de31e4e85614$export$b3890eb0ae9dca99; }, function (v) { return $8df2de31e4e85614$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $8df2de31e4e85614$export$502457920280e6be; }, function (v) { return $8df2de31e4e85614$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $8df2de31e4e85614$export$c78a37762a8d58e1; }, function (v) { return $8df2de31e4e85614$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $8df2de31e4e85614$export$dc54d992c10e8a18; }, function (v) { return $8df2de31e4e85614$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $8df2de31e4e85614$export$83d89fbfd8236492; }, function (v) { return $8df2de31e4e85614$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $8df2de31e4e85614$export$ae55be85d98224ed;
var $8df2de31e4e85614$export$d39a5bbd09211389;
var $8df2de31e4e85614$export$882461b6382ed46c;
var $8df2de31e4e85614$export$466bfc07425424d5;
var $8df2de31e4e85614$export$cd75ccfd720a3cd4;
var $8df2de31e4e85614$export$fa8d919ba61d84db;
var $8df2de31e4e85614$export$757ceba2d55c277e;
var $8df2de31e4e85614$export$b3890eb0ae9dca99;
var $8df2de31e4e85614$export$502457920280e6be;
var $8df2de31e4e85614$export$c78a37762a8d58e1;
var $8df2de31e4e85614$export$dc54d992c10e8a18;
var $8df2de31e4e85614$export$83d89fbfd8236492;
"use strict";

var $4YNlq = parcelRequire("4YNlq");

var $dJVJU = parcelRequire("dJVJU");
function $8df2de31e4e85614$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $8df2de31e4e85614$var$da = new Set, $8df2de31e4e85614$var$ea = {};
function $8df2de31e4e85614$var$fa(a, b) {
    $8df2de31e4e85614$var$ha(a, b);
    $8df2de31e4e85614$var$ha(a + "Capture", b);
}
function $8df2de31e4e85614$var$ha(a, b) {
    $8df2de31e4e85614$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$8df2de31e4e85614$var$da.add(b[a]);
}
var $8df2de31e4e85614$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8df2de31e4e85614$var$ja = Object.prototype.hasOwnProperty, $8df2de31e4e85614$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $8df2de31e4e85614$var$la = {}, $8df2de31e4e85614$var$ma = {};
function $8df2de31e4e85614$var$oa(a) {
    if ($8df2de31e4e85614$var$ja.call($8df2de31e4e85614$var$ma, a)) return !0;
    if ($8df2de31e4e85614$var$ja.call($8df2de31e4e85614$var$la, a)) return !1;
    if ($8df2de31e4e85614$var$ka.test(a)) return $8df2de31e4e85614$var$ma[a] = !0;
    $8df2de31e4e85614$var$la[a] = !0;
    return !1;
}
function $8df2de31e4e85614$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $8df2de31e4e85614$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $8df2de31e4e85614$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $8df2de31e4e85614$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $8df2de31e4e85614$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $8df2de31e4e85614$var$z[a] = new $8df2de31e4e85614$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $8df2de31e4e85614$var$z[b] = new $8df2de31e4e85614$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $8df2de31e4e85614$var$z[a] = new $8df2de31e4e85614$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $8df2de31e4e85614$var$z[a] = new $8df2de31e4e85614$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $8df2de31e4e85614$var$z[a] = new $8df2de31e4e85614$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $8df2de31e4e85614$var$z[a] = new $8df2de31e4e85614$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $8df2de31e4e85614$var$z[a] = new $8df2de31e4e85614$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $8df2de31e4e85614$var$z[a] = new $8df2de31e4e85614$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $8df2de31e4e85614$var$z[a] = new $8df2de31e4e85614$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $8df2de31e4e85614$var$ra = /[\-:]([a-z])/g;
function $8df2de31e4e85614$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($8df2de31e4e85614$var$ra, $8df2de31e4e85614$var$sa);
    $8df2de31e4e85614$var$z[b] = new $8df2de31e4e85614$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($8df2de31e4e85614$var$ra, $8df2de31e4e85614$var$sa);
    $8df2de31e4e85614$var$z[b] = new $8df2de31e4e85614$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($8df2de31e4e85614$var$ra, $8df2de31e4e85614$var$sa);
    $8df2de31e4e85614$var$z[b] = new $8df2de31e4e85614$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $8df2de31e4e85614$var$z[a] = new $8df2de31e4e85614$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$8df2de31e4e85614$var$z.xlinkHref = new $8df2de31e4e85614$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $8df2de31e4e85614$var$z[a] = new $8df2de31e4e85614$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $8df2de31e4e85614$var$ta(a, b, c, d) {
    var e = $8df2de31e4e85614$var$z.hasOwnProperty(b) ? $8df2de31e4e85614$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $8df2de31e4e85614$var$qa(b, c, e, d) && (c = null), d || null === e ? $8df2de31e4e85614$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $8df2de31e4e85614$var$ua = $4YNlq.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $8df2de31e4e85614$var$va = Symbol.for("react.element"), $8df2de31e4e85614$var$wa = Symbol.for("react.portal"), $8df2de31e4e85614$var$ya = Symbol.for("react.fragment"), $8df2de31e4e85614$var$za = Symbol.for("react.strict_mode"), $8df2de31e4e85614$var$Aa = Symbol.for("react.profiler"), $8df2de31e4e85614$var$Ba = Symbol.for("react.provider"), $8df2de31e4e85614$var$Ca = Symbol.for("react.context"), $8df2de31e4e85614$var$Da = Symbol.for("react.forward_ref"), $8df2de31e4e85614$var$Ea = Symbol.for("react.suspense"), $8df2de31e4e85614$var$Fa = Symbol.for("react.suspense_list"), $8df2de31e4e85614$var$Ga = Symbol.for("react.memo"), $8df2de31e4e85614$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $8df2de31e4e85614$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $8df2de31e4e85614$var$Ja = Symbol.iterator;
function $8df2de31e4e85614$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $8df2de31e4e85614$var$Ja && a[$8df2de31e4e85614$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $8df2de31e4e85614$var$A = Object.assign, $8df2de31e4e85614$var$La;
function $8df2de31e4e85614$var$Ma(a) {
    if (void 0 === $8df2de31e4e85614$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $8df2de31e4e85614$var$La = b && b[1] || "";
    }
    return "\n" + $8df2de31e4e85614$var$La + a;
}
var $8df2de31e4e85614$var$Na = !1;
function $8df2de31e4e85614$var$Oa(a, b) {
    if (!a || $8df2de31e4e85614$var$Na) return "";
    $8df2de31e4e85614$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $8df2de31e4e85614$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $8df2de31e4e85614$var$Ma(a) : "";
}
function $8df2de31e4e85614$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $8df2de31e4e85614$var$Ma(a.type);
        case 16:
            return $8df2de31e4e85614$var$Ma("Lazy");
        case 13:
            return $8df2de31e4e85614$var$Ma("Suspense");
        case 19:
            return $8df2de31e4e85614$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $8df2de31e4e85614$var$Oa(a.type, !1), a;
        case 11:
            return a = $8df2de31e4e85614$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $8df2de31e4e85614$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $8df2de31e4e85614$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $8df2de31e4e85614$var$ya:
            return "Fragment";
        case $8df2de31e4e85614$var$wa:
            return "Portal";
        case $8df2de31e4e85614$var$Aa:
            return "Profiler";
        case $8df2de31e4e85614$var$za:
            return "StrictMode";
        case $8df2de31e4e85614$var$Ea:
            return "Suspense";
        case $8df2de31e4e85614$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $8df2de31e4e85614$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $8df2de31e4e85614$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $8df2de31e4e85614$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $8df2de31e4e85614$var$Ga:
            return b = a.displayName || null, null !== b ? b : $8df2de31e4e85614$var$Qa(a.type) || "Memo";
        case $8df2de31e4e85614$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $8df2de31e4e85614$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $8df2de31e4e85614$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $8df2de31e4e85614$var$Qa(b);
        case 8:
            return b === $8df2de31e4e85614$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $8df2de31e4e85614$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $8df2de31e4e85614$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $8df2de31e4e85614$var$Ua(a) {
    var b = $8df2de31e4e85614$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $8df2de31e4e85614$var$Va(a) {
    a._valueTracker || (a._valueTracker = $8df2de31e4e85614$var$Ua(a));
}
function $8df2de31e4e85614$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $8df2de31e4e85614$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $8df2de31e4e85614$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $8df2de31e4e85614$var$Ya(a, b) {
    var c = b.checked;
    return $8df2de31e4e85614$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $8df2de31e4e85614$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $8df2de31e4e85614$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $8df2de31e4e85614$var$ab(a, b) {
    b = b.checked;
    null != b && $8df2de31e4e85614$var$ta(a, "checked", b, !1);
}
function $8df2de31e4e85614$var$bb(a, b) {
    $8df2de31e4e85614$var$ab(a, b);
    var c = $8df2de31e4e85614$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $8df2de31e4e85614$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $8df2de31e4e85614$var$cb(a, b.type, $8df2de31e4e85614$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $8df2de31e4e85614$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $8df2de31e4e85614$var$cb(a, b, c) {
    if ("number" !== b || $8df2de31e4e85614$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $8df2de31e4e85614$var$eb = Array.isArray;
function $8df2de31e4e85614$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $8df2de31e4e85614$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $8df2de31e4e85614$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($8df2de31e4e85614$var$p(91));
    return $8df2de31e4e85614$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $8df2de31e4e85614$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($8df2de31e4e85614$var$p(92));
            if ($8df2de31e4e85614$var$eb(c)) {
                if (1 < c.length) throw Error($8df2de31e4e85614$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $8df2de31e4e85614$var$Sa(c)
    };
}
function $8df2de31e4e85614$var$ib(a, b) {
    var c = $8df2de31e4e85614$var$Sa(b.value), d = $8df2de31e4e85614$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $8df2de31e4e85614$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $8df2de31e4e85614$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $8df2de31e4e85614$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $8df2de31e4e85614$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $8df2de31e4e85614$var$mb, $8df2de31e4e85614$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $8df2de31e4e85614$var$mb = $8df2de31e4e85614$var$mb || document.createElement("div");
        $8df2de31e4e85614$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $8df2de31e4e85614$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $8df2de31e4e85614$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $8df2de31e4e85614$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $8df2de31e4e85614$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($8df2de31e4e85614$var$pb).forEach(function(a) {
    $8df2de31e4e85614$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $8df2de31e4e85614$var$pb[b] = $8df2de31e4e85614$var$pb[a];
    });
});
function $8df2de31e4e85614$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $8df2de31e4e85614$var$pb.hasOwnProperty(a) && $8df2de31e4e85614$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $8df2de31e4e85614$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $8df2de31e4e85614$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $8df2de31e4e85614$var$tb = $8df2de31e4e85614$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $8df2de31e4e85614$var$ub(a, b) {
    if (b) {
        if ($8df2de31e4e85614$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($8df2de31e4e85614$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($8df2de31e4e85614$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($8df2de31e4e85614$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($8df2de31e4e85614$var$p(62));
    }
}
function $8df2de31e4e85614$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8df2de31e4e85614$var$wb = null;
function $8df2de31e4e85614$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $8df2de31e4e85614$var$yb = null, $8df2de31e4e85614$var$zb = null, $8df2de31e4e85614$var$Ab = null;
function $8df2de31e4e85614$var$Bb(a) {
    if (a = $8df2de31e4e85614$var$Cb(a)) {
        if ("function" !== typeof $8df2de31e4e85614$var$yb) throw Error($8df2de31e4e85614$var$p(280));
        var b = a.stateNode;
        b && (b = $8df2de31e4e85614$var$Db(b), $8df2de31e4e85614$var$yb(a.stateNode, a.type, b));
    }
}
function $8df2de31e4e85614$var$Eb(a) {
    $8df2de31e4e85614$var$zb ? $8df2de31e4e85614$var$Ab ? $8df2de31e4e85614$var$Ab.push(a) : $8df2de31e4e85614$var$Ab = [
        a
    ] : $8df2de31e4e85614$var$zb = a;
}
function $8df2de31e4e85614$var$Fb() {
    if ($8df2de31e4e85614$var$zb) {
        var a = $8df2de31e4e85614$var$zb, b = $8df2de31e4e85614$var$Ab;
        $8df2de31e4e85614$var$Ab = $8df2de31e4e85614$var$zb = null;
        $8df2de31e4e85614$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$8df2de31e4e85614$var$Bb(b[a]);
    }
}
function $8df2de31e4e85614$var$Gb(a, b) {
    return a(b);
}
function $8df2de31e4e85614$var$Hb() {}
var $8df2de31e4e85614$var$Ib = !1;
function $8df2de31e4e85614$var$Jb(a, b, c) {
    if ($8df2de31e4e85614$var$Ib) return a(b, c);
    $8df2de31e4e85614$var$Ib = !0;
    try {
        return $8df2de31e4e85614$var$Gb(a, b, c);
    } finally{
        if ($8df2de31e4e85614$var$Ib = !1, null !== $8df2de31e4e85614$var$zb || null !== $8df2de31e4e85614$var$Ab) $8df2de31e4e85614$var$Hb(), $8df2de31e4e85614$var$Fb();
    }
}
function $8df2de31e4e85614$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $8df2de31e4e85614$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($8df2de31e4e85614$var$p(231, b, typeof c));
    return c;
}
var $8df2de31e4e85614$var$Lb = !1;
if ($8df2de31e4e85614$var$ia) try {
    var $8df2de31e4e85614$var$Mb = {};
    Object.defineProperty($8df2de31e4e85614$var$Mb, "passive", {
        get: function() {
            $8df2de31e4e85614$var$Lb = !0;
        }
    });
    window.addEventListener("test", $8df2de31e4e85614$var$Mb, $8df2de31e4e85614$var$Mb);
    window.removeEventListener("test", $8df2de31e4e85614$var$Mb, $8df2de31e4e85614$var$Mb);
} catch (a) {
    $8df2de31e4e85614$var$Lb = !1;
}
function $8df2de31e4e85614$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $8df2de31e4e85614$var$Ob = !1, $8df2de31e4e85614$var$Pb = null, $8df2de31e4e85614$var$Qb = !1, $8df2de31e4e85614$var$Rb = null, $8df2de31e4e85614$var$Sb = {
    onError: function(a) {
        $8df2de31e4e85614$var$Ob = !0;
        $8df2de31e4e85614$var$Pb = a;
    }
};
function $8df2de31e4e85614$var$Tb(a, b, c, d, e, f, g, h, k) {
    $8df2de31e4e85614$var$Ob = !1;
    $8df2de31e4e85614$var$Pb = null;
    $8df2de31e4e85614$var$Nb.apply($8df2de31e4e85614$var$Sb, arguments);
}
function $8df2de31e4e85614$var$Ub(a, b, c, d, e, f, g, h, k) {
    $8df2de31e4e85614$var$Tb.apply(this, arguments);
    if ($8df2de31e4e85614$var$Ob) {
        if ($8df2de31e4e85614$var$Ob) {
            var l = $8df2de31e4e85614$var$Pb;
            $8df2de31e4e85614$var$Ob = !1;
            $8df2de31e4e85614$var$Pb = null;
        } else throw Error($8df2de31e4e85614$var$p(198));
        $8df2de31e4e85614$var$Qb || ($8df2de31e4e85614$var$Qb = !0, $8df2de31e4e85614$var$Rb = l);
    }
}
function $8df2de31e4e85614$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $8df2de31e4e85614$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $8df2de31e4e85614$var$Xb(a) {
    if ($8df2de31e4e85614$var$Vb(a) !== a) throw Error($8df2de31e4e85614$var$p(188));
}
function $8df2de31e4e85614$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $8df2de31e4e85614$var$Vb(a);
        if (null === b) throw Error($8df2de31e4e85614$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $8df2de31e4e85614$var$Xb(e), a;
                if (f === d) return $8df2de31e4e85614$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($8df2de31e4e85614$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($8df2de31e4e85614$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($8df2de31e4e85614$var$p(190));
    }
    if (3 !== c.tag) throw Error($8df2de31e4e85614$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $8df2de31e4e85614$var$Zb(a) {
    a = $8df2de31e4e85614$var$Yb(a);
    return null !== a ? $8df2de31e4e85614$var$$b(a) : null;
}
function $8df2de31e4e85614$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $8df2de31e4e85614$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $8df2de31e4e85614$var$ac = $dJVJU.unstable_scheduleCallback, $8df2de31e4e85614$var$bc = $dJVJU.unstable_cancelCallback, $8df2de31e4e85614$var$cc = $dJVJU.unstable_shouldYield, $8df2de31e4e85614$var$dc = $dJVJU.unstable_requestPaint, $8df2de31e4e85614$var$B = $dJVJU.unstable_now, $8df2de31e4e85614$var$ec = $dJVJU.unstable_getCurrentPriorityLevel, $8df2de31e4e85614$var$fc = $dJVJU.unstable_ImmediatePriority, $8df2de31e4e85614$var$gc = $dJVJU.unstable_UserBlockingPriority, $8df2de31e4e85614$var$hc = $dJVJU.unstable_NormalPriority, $8df2de31e4e85614$var$ic = $dJVJU.unstable_LowPriority, $8df2de31e4e85614$var$jc = $dJVJU.unstable_IdlePriority, $8df2de31e4e85614$var$kc = null, $8df2de31e4e85614$var$lc = null;
function $8df2de31e4e85614$var$mc(a) {
    if ($8df2de31e4e85614$var$lc && "function" === typeof $8df2de31e4e85614$var$lc.onCommitFiberRoot) try {
        $8df2de31e4e85614$var$lc.onCommitFiberRoot($8df2de31e4e85614$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $8df2de31e4e85614$var$oc = Math.clz32 ? Math.clz32 : $8df2de31e4e85614$var$nc, $8df2de31e4e85614$var$pc = Math.log, $8df2de31e4e85614$var$qc = Math.LN2;
function $8df2de31e4e85614$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($8df2de31e4e85614$var$pc(a) / $8df2de31e4e85614$var$qc | 0) | 0;
}
var $8df2de31e4e85614$var$rc = 64, $8df2de31e4e85614$var$sc = 4194304;
function $8df2de31e4e85614$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $8df2de31e4e85614$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $8df2de31e4e85614$var$tc(h) : (f &= g, 0 !== f && (d = $8df2de31e4e85614$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $8df2de31e4e85614$var$tc(g) : 0 !== f && (d = $8df2de31e4e85614$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $8df2de31e4e85614$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $8df2de31e4e85614$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8df2de31e4e85614$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $8df2de31e4e85614$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $8df2de31e4e85614$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $8df2de31e4e85614$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $8df2de31e4e85614$var$yc() {
    var a = $8df2de31e4e85614$var$rc;
    $8df2de31e4e85614$var$rc <<= 1;
    0 === ($8df2de31e4e85614$var$rc & 4194240) && ($8df2de31e4e85614$var$rc = 64);
    return a;
}
function $8df2de31e4e85614$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $8df2de31e4e85614$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $8df2de31e4e85614$var$oc(b);
    a[b] = c;
}
function $8df2de31e4e85614$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $8df2de31e4e85614$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $8df2de31e4e85614$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $8df2de31e4e85614$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $8df2de31e4e85614$var$C = 0;
function $8df2de31e4e85614$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $8df2de31e4e85614$var$Ec, $8df2de31e4e85614$var$Fc, $8df2de31e4e85614$var$Gc, $8df2de31e4e85614$var$Hc, $8df2de31e4e85614$var$Ic, $8df2de31e4e85614$var$Jc = !1, $8df2de31e4e85614$var$Kc = [], $8df2de31e4e85614$var$Lc = null, $8df2de31e4e85614$var$Mc = null, $8df2de31e4e85614$var$Nc = null, $8df2de31e4e85614$var$Oc = new Map, $8df2de31e4e85614$var$Pc = new Map, $8df2de31e4e85614$var$Qc = [], $8df2de31e4e85614$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $8df2de31e4e85614$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $8df2de31e4e85614$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $8df2de31e4e85614$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $8df2de31e4e85614$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $8df2de31e4e85614$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8df2de31e4e85614$var$Pc.delete(b.pointerId);
    }
}
function $8df2de31e4e85614$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $8df2de31e4e85614$var$Cb(b), null !== b && $8df2de31e4e85614$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $8df2de31e4e85614$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $8df2de31e4e85614$var$Lc = $8df2de31e4e85614$var$Tc($8df2de31e4e85614$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $8df2de31e4e85614$var$Mc = $8df2de31e4e85614$var$Tc($8df2de31e4e85614$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $8df2de31e4e85614$var$Nc = $8df2de31e4e85614$var$Tc($8df2de31e4e85614$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $8df2de31e4e85614$var$Oc.set(f, $8df2de31e4e85614$var$Tc($8df2de31e4e85614$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $8df2de31e4e85614$var$Pc.set(f, $8df2de31e4e85614$var$Tc($8df2de31e4e85614$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $8df2de31e4e85614$var$Vc(a) {
    var b = $8df2de31e4e85614$var$Wc(a.target);
    if (null !== b) {
        var c = $8df2de31e4e85614$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $8df2de31e4e85614$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $8df2de31e4e85614$var$Ic(a.priority, function() {
                        $8df2de31e4e85614$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $8df2de31e4e85614$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $8df2de31e4e85614$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $8df2de31e4e85614$var$wb = d;
            c.target.dispatchEvent(d);
            $8df2de31e4e85614$var$wb = null;
        } else return b = $8df2de31e4e85614$var$Cb(c), null !== b && $8df2de31e4e85614$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $8df2de31e4e85614$var$Zc(a, b, c) {
    $8df2de31e4e85614$var$Xc(a) && c.delete(b);
}
function $8df2de31e4e85614$var$$c() {
    $8df2de31e4e85614$var$Jc = !1;
    null !== $8df2de31e4e85614$var$Lc && $8df2de31e4e85614$var$Xc($8df2de31e4e85614$var$Lc) && ($8df2de31e4e85614$var$Lc = null);
    null !== $8df2de31e4e85614$var$Mc && $8df2de31e4e85614$var$Xc($8df2de31e4e85614$var$Mc) && ($8df2de31e4e85614$var$Mc = null);
    null !== $8df2de31e4e85614$var$Nc && $8df2de31e4e85614$var$Xc($8df2de31e4e85614$var$Nc) && ($8df2de31e4e85614$var$Nc = null);
    $8df2de31e4e85614$var$Oc.forEach($8df2de31e4e85614$var$Zc);
    $8df2de31e4e85614$var$Pc.forEach($8df2de31e4e85614$var$Zc);
}
function $8df2de31e4e85614$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $8df2de31e4e85614$var$Jc || ($8df2de31e4e85614$var$Jc = !0, $dJVJU.unstable_scheduleCallback($dJVJU.unstable_NormalPriority, $8df2de31e4e85614$var$$c)));
}
function $8df2de31e4e85614$var$bd(a) {
    function b(b) {
        return $8df2de31e4e85614$var$ad(b, a);
    }
    if (0 < $8df2de31e4e85614$var$Kc.length) {
        $8df2de31e4e85614$var$ad($8df2de31e4e85614$var$Kc[0], a);
        for(var c = 1; c < $8df2de31e4e85614$var$Kc.length; c++){
            var d = $8df2de31e4e85614$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $8df2de31e4e85614$var$Lc && $8df2de31e4e85614$var$ad($8df2de31e4e85614$var$Lc, a);
    null !== $8df2de31e4e85614$var$Mc && $8df2de31e4e85614$var$ad($8df2de31e4e85614$var$Mc, a);
    null !== $8df2de31e4e85614$var$Nc && $8df2de31e4e85614$var$ad($8df2de31e4e85614$var$Nc, a);
    $8df2de31e4e85614$var$Oc.forEach(b);
    $8df2de31e4e85614$var$Pc.forEach(b);
    for(c = 0; c < $8df2de31e4e85614$var$Qc.length; c++)d = $8df2de31e4e85614$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $8df2de31e4e85614$var$Qc.length && (c = $8df2de31e4e85614$var$Qc[0], null === c.blockedOn);)$8df2de31e4e85614$var$Vc(c), null === c.blockedOn && $8df2de31e4e85614$var$Qc.shift();
}
var $8df2de31e4e85614$var$cd = $8df2de31e4e85614$var$ua.ReactCurrentBatchConfig, $8df2de31e4e85614$var$dd = !0;
function $8df2de31e4e85614$var$ed(a, b, c, d) {
    var e = $8df2de31e4e85614$var$C, f = $8df2de31e4e85614$var$cd.transition;
    $8df2de31e4e85614$var$cd.transition = null;
    try {
        $8df2de31e4e85614$var$C = 1, $8df2de31e4e85614$var$fd(a, b, c, d);
    } finally{
        $8df2de31e4e85614$var$C = e, $8df2de31e4e85614$var$cd.transition = f;
    }
}
function $8df2de31e4e85614$var$gd(a, b, c, d) {
    var e = $8df2de31e4e85614$var$C, f = $8df2de31e4e85614$var$cd.transition;
    $8df2de31e4e85614$var$cd.transition = null;
    try {
        $8df2de31e4e85614$var$C = 4, $8df2de31e4e85614$var$fd(a, b, c, d);
    } finally{
        $8df2de31e4e85614$var$C = e, $8df2de31e4e85614$var$cd.transition = f;
    }
}
function $8df2de31e4e85614$var$fd(a, b, c, d) {
    if ($8df2de31e4e85614$var$dd) {
        var e = $8df2de31e4e85614$var$Yc(a, b, c, d);
        if (null === e) $8df2de31e4e85614$var$hd(a, b, d, $8df2de31e4e85614$var$id, c), $8df2de31e4e85614$var$Sc(a, d);
        else if ($8df2de31e4e85614$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($8df2de31e4e85614$var$Sc(a, d), b & 4 && -1 < $8df2de31e4e85614$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $8df2de31e4e85614$var$Cb(e);
                null !== f && $8df2de31e4e85614$var$Ec(f);
                f = $8df2de31e4e85614$var$Yc(a, b, c, d);
                null === f && $8df2de31e4e85614$var$hd(a, b, d, $8df2de31e4e85614$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $8df2de31e4e85614$var$hd(a, b, d, null, c);
    }
}
var $8df2de31e4e85614$var$id = null;
function $8df2de31e4e85614$var$Yc(a, b, c, d) {
    $8df2de31e4e85614$var$id = null;
    a = $8df2de31e4e85614$var$xb(d);
    a = $8df2de31e4e85614$var$Wc(a);
    if (null !== a) {
        if (b = $8df2de31e4e85614$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $8df2de31e4e85614$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $8df2de31e4e85614$var$id = a;
    return null;
}
function $8df2de31e4e85614$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($8df2de31e4e85614$var$ec()){
                case $8df2de31e4e85614$var$fc:
                    return 1;
                case $8df2de31e4e85614$var$gc:
                    return 4;
                case $8df2de31e4e85614$var$hc:
                case $8df2de31e4e85614$var$ic:
                    return 16;
                case $8df2de31e4e85614$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $8df2de31e4e85614$var$kd = null, $8df2de31e4e85614$var$ld = null, $8df2de31e4e85614$var$md = null;
function $8df2de31e4e85614$var$nd() {
    if ($8df2de31e4e85614$var$md) return $8df2de31e4e85614$var$md;
    var a, b = $8df2de31e4e85614$var$ld, c = b.length, d, e = "value" in $8df2de31e4e85614$var$kd ? $8df2de31e4e85614$var$kd.value : $8df2de31e4e85614$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $8df2de31e4e85614$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $8df2de31e4e85614$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $8df2de31e4e85614$var$pd() {
    return !0;
}
function $8df2de31e4e85614$var$qd() {
    return !1;
}
function $8df2de31e4e85614$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $8df2de31e4e85614$var$pd : $8df2de31e4e85614$var$qd;
        this.isPropagationStopped = $8df2de31e4e85614$var$qd;
        return this;
    }
    $8df2de31e4e85614$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $8df2de31e4e85614$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $8df2de31e4e85614$var$pd);
        },
        persist: function() {},
        isPersistent: $8df2de31e4e85614$var$pd
    });
    return b;
}
var $8df2de31e4e85614$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8df2de31e4e85614$var$td = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$sd), $8df2de31e4e85614$var$ud = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$sd, {
    view: 0,
    detail: 0
}), $8df2de31e4e85614$var$vd = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$ud), $8df2de31e4e85614$var$wd, $8df2de31e4e85614$var$xd, $8df2de31e4e85614$var$yd, $8df2de31e4e85614$var$Ad = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8df2de31e4e85614$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $8df2de31e4e85614$var$yd && ($8df2de31e4e85614$var$yd && "mousemove" === a.type ? ($8df2de31e4e85614$var$wd = a.screenX - $8df2de31e4e85614$var$yd.screenX, $8df2de31e4e85614$var$xd = a.screenY - $8df2de31e4e85614$var$yd.screenY) : $8df2de31e4e85614$var$xd = $8df2de31e4e85614$var$wd = 0, $8df2de31e4e85614$var$yd = a);
        return $8df2de31e4e85614$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $8df2de31e4e85614$var$xd;
    }
}), $8df2de31e4e85614$var$Bd = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Ad), $8df2de31e4e85614$var$Cd = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$Ad, {
    dataTransfer: 0
}), $8df2de31e4e85614$var$Dd = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Cd), $8df2de31e4e85614$var$Ed = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$ud, {
    relatedTarget: 0
}), $8df2de31e4e85614$var$Fd = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Ed), $8df2de31e4e85614$var$Gd = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8df2de31e4e85614$var$Hd = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Gd), $8df2de31e4e85614$var$Id = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $8df2de31e4e85614$var$Jd = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Id), $8df2de31e4e85614$var$Kd = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$sd, {
    data: 0
}), $8df2de31e4e85614$var$Ld = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Kd), $8df2de31e4e85614$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8df2de31e4e85614$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8df2de31e4e85614$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8df2de31e4e85614$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $8df2de31e4e85614$var$Od[a]) ? !!b[a] : !1;
}
function $8df2de31e4e85614$var$zd() {
    return $8df2de31e4e85614$var$Pd;
}
var $8df2de31e4e85614$var$Qd = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $8df2de31e4e85614$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $8df2de31e4e85614$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $8df2de31e4e85614$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8df2de31e4e85614$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $8df2de31e4e85614$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $8df2de31e4e85614$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $8df2de31e4e85614$var$Rd = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Qd), $8df2de31e4e85614$var$Sd = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8df2de31e4e85614$var$Td = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Sd), $8df2de31e4e85614$var$Ud = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8df2de31e4e85614$var$zd
}), $8df2de31e4e85614$var$Vd = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Ud), $8df2de31e4e85614$var$Wd = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8df2de31e4e85614$var$Xd = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Wd), $8df2de31e4e85614$var$Yd = $8df2de31e4e85614$var$A({}, $8df2de31e4e85614$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8df2de31e4e85614$var$Zd = $8df2de31e4e85614$var$rd($8df2de31e4e85614$var$Yd), $8df2de31e4e85614$var$$d = [
    9,
    13,
    27,
    32
], $8df2de31e4e85614$var$ae = $8df2de31e4e85614$var$ia && "CompositionEvent" in window, $8df2de31e4e85614$var$be = null;
$8df2de31e4e85614$var$ia && "documentMode" in document && ($8df2de31e4e85614$var$be = document.documentMode);
var $8df2de31e4e85614$var$ce = $8df2de31e4e85614$var$ia && "TextEvent" in window && !$8df2de31e4e85614$var$be, $8df2de31e4e85614$var$de = $8df2de31e4e85614$var$ia && (!$8df2de31e4e85614$var$ae || $8df2de31e4e85614$var$be && 8 < $8df2de31e4e85614$var$be && 11 >= $8df2de31e4e85614$var$be), $8df2de31e4e85614$var$ee = String.fromCharCode(32), $8df2de31e4e85614$var$fe = !1;
function $8df2de31e4e85614$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $8df2de31e4e85614$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8df2de31e4e85614$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $8df2de31e4e85614$var$ie = !1;
function $8df2de31e4e85614$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $8df2de31e4e85614$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $8df2de31e4e85614$var$fe = !0;
            return $8df2de31e4e85614$var$ee;
        case "textInput":
            return a = b.data, a === $8df2de31e4e85614$var$ee && $8df2de31e4e85614$var$fe ? null : a;
        default:
            return null;
    }
}
function $8df2de31e4e85614$var$ke(a, b) {
    if ($8df2de31e4e85614$var$ie) return "compositionend" === a || !$8df2de31e4e85614$var$ae && $8df2de31e4e85614$var$ge(a, b) ? (a = $8df2de31e4e85614$var$nd(), $8df2de31e4e85614$var$md = $8df2de31e4e85614$var$ld = $8df2de31e4e85614$var$kd = null, $8df2de31e4e85614$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $8df2de31e4e85614$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $8df2de31e4e85614$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8df2de31e4e85614$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$8df2de31e4e85614$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $8df2de31e4e85614$var$ne(a, b, c, d) {
    $8df2de31e4e85614$var$Eb(d);
    b = $8df2de31e4e85614$var$oe(b, "onChange");
    0 < b.length && (c = new $8df2de31e4e85614$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $8df2de31e4e85614$var$pe = null, $8df2de31e4e85614$var$qe = null;
function $8df2de31e4e85614$var$re(a) {
    $8df2de31e4e85614$var$se(a, 0);
}
function $8df2de31e4e85614$var$te(a) {
    var b = $8df2de31e4e85614$var$ue(a);
    if ($8df2de31e4e85614$var$Wa(b)) return a;
}
function $8df2de31e4e85614$var$ve(a, b) {
    if ("change" === a) return b;
}
var $8df2de31e4e85614$var$we = !1;
if ($8df2de31e4e85614$var$ia) {
    var $8df2de31e4e85614$var$xe;
    if ($8df2de31e4e85614$var$ia) {
        var $8df2de31e4e85614$var$ye = "oninput" in document;
        if (!$8df2de31e4e85614$var$ye) {
            var $8df2de31e4e85614$var$ze = document.createElement("div");
            $8df2de31e4e85614$var$ze.setAttribute("oninput", "return;");
            $8df2de31e4e85614$var$ye = "function" === typeof $8df2de31e4e85614$var$ze.oninput;
        }
        $8df2de31e4e85614$var$xe = $8df2de31e4e85614$var$ye;
    } else $8df2de31e4e85614$var$xe = !1;
    $8df2de31e4e85614$var$we = $8df2de31e4e85614$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $8df2de31e4e85614$var$Ae() {
    $8df2de31e4e85614$var$pe && ($8df2de31e4e85614$var$pe.detachEvent("onpropertychange", $8df2de31e4e85614$var$Be), $8df2de31e4e85614$var$qe = $8df2de31e4e85614$var$pe = null);
}
function $8df2de31e4e85614$var$Be(a) {
    if ("value" === a.propertyName && $8df2de31e4e85614$var$te($8df2de31e4e85614$var$qe)) {
        var b = [];
        $8df2de31e4e85614$var$ne(b, $8df2de31e4e85614$var$qe, a, $8df2de31e4e85614$var$xb(a));
        $8df2de31e4e85614$var$Jb($8df2de31e4e85614$var$re, b);
    }
}
function $8df2de31e4e85614$var$Ce(a, b, c) {
    "focusin" === a ? ($8df2de31e4e85614$var$Ae(), $8df2de31e4e85614$var$pe = b, $8df2de31e4e85614$var$qe = c, $8df2de31e4e85614$var$pe.attachEvent("onpropertychange", $8df2de31e4e85614$var$Be)) : "focusout" === a && $8df2de31e4e85614$var$Ae();
}
function $8df2de31e4e85614$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $8df2de31e4e85614$var$te($8df2de31e4e85614$var$qe);
}
function $8df2de31e4e85614$var$Ee(a, b) {
    if ("click" === a) return $8df2de31e4e85614$var$te(b);
}
function $8df2de31e4e85614$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $8df2de31e4e85614$var$te(b);
}
function $8df2de31e4e85614$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $8df2de31e4e85614$var$He = "function" === typeof Object.is ? Object.is : $8df2de31e4e85614$var$Ge;
function $8df2de31e4e85614$var$Ie(a, b) {
    if ($8df2de31e4e85614$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$8df2de31e4e85614$var$ja.call(b, e) || !$8df2de31e4e85614$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $8df2de31e4e85614$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $8df2de31e4e85614$var$Ke(a, b) {
    var c = $8df2de31e4e85614$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $8df2de31e4e85614$var$Je(c);
    }
}
function $8df2de31e4e85614$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $8df2de31e4e85614$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $8df2de31e4e85614$var$Me() {
    for(var a = window, b = $8df2de31e4e85614$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $8df2de31e4e85614$var$Xa(a.document);
    }
    return b;
}
function $8df2de31e4e85614$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $8df2de31e4e85614$var$Oe(a) {
    var b = $8df2de31e4e85614$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $8df2de31e4e85614$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $8df2de31e4e85614$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $8df2de31e4e85614$var$Ke(c, f);
                var g = $8df2de31e4e85614$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $8df2de31e4e85614$var$Pe = $8df2de31e4e85614$var$ia && "documentMode" in document && 11 >= document.documentMode, $8df2de31e4e85614$var$Qe = null, $8df2de31e4e85614$var$Re = null, $8df2de31e4e85614$var$Se = null, $8df2de31e4e85614$var$Te = !1;
function $8df2de31e4e85614$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $8df2de31e4e85614$var$Te || null == $8df2de31e4e85614$var$Qe || $8df2de31e4e85614$var$Qe !== $8df2de31e4e85614$var$Xa(d) || (d = $8df2de31e4e85614$var$Qe, "selectionStart" in d && $8df2de31e4e85614$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $8df2de31e4e85614$var$Se && $8df2de31e4e85614$var$Ie($8df2de31e4e85614$var$Se, d) || ($8df2de31e4e85614$var$Se = d, d = $8df2de31e4e85614$var$oe($8df2de31e4e85614$var$Re, "onSelect"), 0 < d.length && (b = new $8df2de31e4e85614$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $8df2de31e4e85614$var$Qe)));
}
function $8df2de31e4e85614$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $8df2de31e4e85614$var$We = {
    animationend: $8df2de31e4e85614$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $8df2de31e4e85614$var$Ve("Animation", "AnimationIteration"),
    animationstart: $8df2de31e4e85614$var$Ve("Animation", "AnimationStart"),
    transitionend: $8df2de31e4e85614$var$Ve("Transition", "TransitionEnd")
}, $8df2de31e4e85614$var$Xe = {}, $8df2de31e4e85614$var$Ye = {};
$8df2de31e4e85614$var$ia && ($8df2de31e4e85614$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $8df2de31e4e85614$var$We.animationend.animation, delete $8df2de31e4e85614$var$We.animationiteration.animation, delete $8df2de31e4e85614$var$We.animationstart.animation), "TransitionEvent" in window || delete $8df2de31e4e85614$var$We.transitionend.transition);
function $8df2de31e4e85614$var$Ze(a) {
    if ($8df2de31e4e85614$var$Xe[a]) return $8df2de31e4e85614$var$Xe[a];
    if (!$8df2de31e4e85614$var$We[a]) return a;
    var b = $8df2de31e4e85614$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $8df2de31e4e85614$var$Ye) return $8df2de31e4e85614$var$Xe[a] = b[c];
    return a;
}
var $8df2de31e4e85614$var$$e = $8df2de31e4e85614$var$Ze("animationend"), $8df2de31e4e85614$var$af = $8df2de31e4e85614$var$Ze("animationiteration"), $8df2de31e4e85614$var$bf = $8df2de31e4e85614$var$Ze("animationstart"), $8df2de31e4e85614$var$cf = $8df2de31e4e85614$var$Ze("transitionend"), $8df2de31e4e85614$var$df = new Map, $8df2de31e4e85614$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $8df2de31e4e85614$var$ff(a, b) {
    $8df2de31e4e85614$var$df.set(a, b);
    $8df2de31e4e85614$var$fa(b, [
        a
    ]);
}
for(var $8df2de31e4e85614$var$gf = 0; $8df2de31e4e85614$var$gf < $8df2de31e4e85614$var$ef.length; $8df2de31e4e85614$var$gf++){
    var $8df2de31e4e85614$var$hf = $8df2de31e4e85614$var$ef[$8df2de31e4e85614$var$gf], $8df2de31e4e85614$var$jf = $8df2de31e4e85614$var$hf.toLowerCase(), $8df2de31e4e85614$var$kf = $8df2de31e4e85614$var$hf[0].toUpperCase() + $8df2de31e4e85614$var$hf.slice(1);
    $8df2de31e4e85614$var$ff($8df2de31e4e85614$var$jf, "on" + $8df2de31e4e85614$var$kf);
}
$8df2de31e4e85614$var$ff($8df2de31e4e85614$var$$e, "onAnimationEnd");
$8df2de31e4e85614$var$ff($8df2de31e4e85614$var$af, "onAnimationIteration");
$8df2de31e4e85614$var$ff($8df2de31e4e85614$var$bf, "onAnimationStart");
$8df2de31e4e85614$var$ff("dblclick", "onDoubleClick");
$8df2de31e4e85614$var$ff("focusin", "onFocus");
$8df2de31e4e85614$var$ff("focusout", "onBlur");
$8df2de31e4e85614$var$ff($8df2de31e4e85614$var$cf, "onTransitionEnd");
$8df2de31e4e85614$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8df2de31e4e85614$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8df2de31e4e85614$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8df2de31e4e85614$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8df2de31e4e85614$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8df2de31e4e85614$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8df2de31e4e85614$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8df2de31e4e85614$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8df2de31e4e85614$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8df2de31e4e85614$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8df2de31e4e85614$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8df2de31e4e85614$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($8df2de31e4e85614$var$lf));
function $8df2de31e4e85614$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $8df2de31e4e85614$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $8df2de31e4e85614$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8df2de31e4e85614$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $8df2de31e4e85614$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($8df2de31e4e85614$var$Qb) throw a = $8df2de31e4e85614$var$Rb, $8df2de31e4e85614$var$Qb = !1, $8df2de31e4e85614$var$Rb = null, a;
}
function $8df2de31e4e85614$var$D(a, b) {
    var c = b[$8df2de31e4e85614$var$of];
    void 0 === c && (c = b[$8df2de31e4e85614$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($8df2de31e4e85614$var$pf(b, a, 2, !1), c.add(d));
}
function $8df2de31e4e85614$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $8df2de31e4e85614$var$pf(c, a, d, b);
}
var $8df2de31e4e85614$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $8df2de31e4e85614$var$sf(a) {
    if (!a[$8df2de31e4e85614$var$rf]) {
        a[$8df2de31e4e85614$var$rf] = !0;
        $8df2de31e4e85614$var$da.forEach(function(b) {
            "selectionchange" !== b && ($8df2de31e4e85614$var$mf.has(b) || $8df2de31e4e85614$var$qf(b, !1, a), $8df2de31e4e85614$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$8df2de31e4e85614$var$rf] || (b[$8df2de31e4e85614$var$rf] = !0, $8df2de31e4e85614$var$qf("selectionchange", !1, b));
    }
}
function $8df2de31e4e85614$var$pf(a, b, c, d) {
    switch($8df2de31e4e85614$var$jd(b)){
        case 1:
            var e = $8df2de31e4e85614$var$ed;
            break;
        case 4:
            e = $8df2de31e4e85614$var$gd;
            break;
        default:
            e = $8df2de31e4e85614$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$8df2de31e4e85614$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $8df2de31e4e85614$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $8df2de31e4e85614$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $8df2de31e4e85614$var$Jb(function() {
        var d = f, e = $8df2de31e4e85614$var$xb(c), g = [];
        a: {
            var h = $8df2de31e4e85614$var$df.get(a);
            if (void 0 !== h) {
                var k = $8df2de31e4e85614$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $8df2de31e4e85614$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $8df2de31e4e85614$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $8df2de31e4e85614$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $8df2de31e4e85614$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $8df2de31e4e85614$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $8df2de31e4e85614$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $8df2de31e4e85614$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $8df2de31e4e85614$var$Vd;
                        break;
                    case $8df2de31e4e85614$var$$e:
                    case $8df2de31e4e85614$var$af:
                    case $8df2de31e4e85614$var$bf:
                        k = $8df2de31e4e85614$var$Hd;
                        break;
                    case $8df2de31e4e85614$var$cf:
                        k = $8df2de31e4e85614$var$Xd;
                        break;
                    case "scroll":
                        k = $8df2de31e4e85614$var$vd;
                        break;
                    case "wheel":
                        k = $8df2de31e4e85614$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $8df2de31e4e85614$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $8df2de31e4e85614$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $8df2de31e4e85614$var$Kb(w, x), null != F && t.push($8df2de31e4e85614$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $8df2de31e4e85614$var$wb && (n = c.relatedTarget || c.fromElement) && ($8df2de31e4e85614$var$Wc(n) || n[$8df2de31e4e85614$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $8df2de31e4e85614$var$Wc(n) : null, null !== n && (J = $8df2de31e4e85614$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $8df2de31e4e85614$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $8df2de31e4e85614$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $8df2de31e4e85614$var$ue(k);
                        u = null == n ? h : $8df2de31e4e85614$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $8df2de31e4e85614$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $8df2de31e4e85614$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $8df2de31e4e85614$var$vf(F))u++;
                            for(; 0 < w - u;)t = $8df2de31e4e85614$var$vf(t), w--;
                            for(; 0 < u - w;)x = $8df2de31e4e85614$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $8df2de31e4e85614$var$vf(t);
                                x = $8df2de31e4e85614$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $8df2de31e4e85614$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $8df2de31e4e85614$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $8df2de31e4e85614$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $8df2de31e4e85614$var$ve;
                else if ($8df2de31e4e85614$var$me(h)) {
                    if ($8df2de31e4e85614$var$we) na = $8df2de31e4e85614$var$Fe;
                    else {
                        na = $8df2de31e4e85614$var$De;
                        var xa = $8df2de31e4e85614$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $8df2de31e4e85614$var$Ee);
                if (na && (na = na(a, d))) {
                    $8df2de31e4e85614$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $8df2de31e4e85614$var$cb(h, "number", h.value);
            }
            xa = d ? $8df2de31e4e85614$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($8df2de31e4e85614$var$me(xa) || "true" === xa.contentEditable) $8df2de31e4e85614$var$Qe = xa, $8df2de31e4e85614$var$Re = d, $8df2de31e4e85614$var$Se = null;
                    break;
                case "focusout":
                    $8df2de31e4e85614$var$Se = $8df2de31e4e85614$var$Re = $8df2de31e4e85614$var$Qe = null;
                    break;
                case "mousedown":
                    $8df2de31e4e85614$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8df2de31e4e85614$var$Te = !1;
                    $8df2de31e4e85614$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($8df2de31e4e85614$var$Pe) break;
                case "keydown":
                case "keyup":
                    $8df2de31e4e85614$var$Ue(g, c, e);
            }
            var $a;
            if ($8df2de31e4e85614$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $8df2de31e4e85614$var$ie ? $8df2de31e4e85614$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($8df2de31e4e85614$var$de && "ko" !== c.locale && ($8df2de31e4e85614$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $8df2de31e4e85614$var$ie && ($a = $8df2de31e4e85614$var$nd()) : ($8df2de31e4e85614$var$kd = e, $8df2de31e4e85614$var$ld = "value" in $8df2de31e4e85614$var$kd ? $8df2de31e4e85614$var$kd.value : $8df2de31e4e85614$var$kd.textContent, $8df2de31e4e85614$var$ie = !0)), xa = $8df2de31e4e85614$var$oe(d, ba), 0 < xa.length && (ba = new $8df2de31e4e85614$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $8df2de31e4e85614$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $8df2de31e4e85614$var$ce ? $8df2de31e4e85614$var$je(a, c) : $8df2de31e4e85614$var$ke(a, c)) d = $8df2de31e4e85614$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $8df2de31e4e85614$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $8df2de31e4e85614$var$se(g, b);
    });
}
function $8df2de31e4e85614$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $8df2de31e4e85614$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $8df2de31e4e85614$var$Kb(a, c), null != f && d.unshift($8df2de31e4e85614$var$tf(a, f, e)), f = $8df2de31e4e85614$var$Kb(a, b), null != f && d.push($8df2de31e4e85614$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $8df2de31e4e85614$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $8df2de31e4e85614$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $8df2de31e4e85614$var$Kb(c, f), null != k && g.unshift($8df2de31e4e85614$var$tf(c, k, h))) : e || (k = $8df2de31e4e85614$var$Kb(c, f), null != k && g.push($8df2de31e4e85614$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $8df2de31e4e85614$var$xf = /\r\n?/g, $8df2de31e4e85614$var$yf = /\u0000|\uFFFD/g;
function $8df2de31e4e85614$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($8df2de31e4e85614$var$xf, "\n").replace($8df2de31e4e85614$var$yf, "");
}
function $8df2de31e4e85614$var$Af(a, b, c) {
    b = $8df2de31e4e85614$var$zf(b);
    if ($8df2de31e4e85614$var$zf(a) !== b && c) throw Error($8df2de31e4e85614$var$p(425));
}
function $8df2de31e4e85614$var$Bf() {}
var $8df2de31e4e85614$var$Cf = null, $8df2de31e4e85614$var$Df = null;
function $8df2de31e4e85614$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $8df2de31e4e85614$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $8df2de31e4e85614$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $8df2de31e4e85614$var$Hf = "function" === typeof Promise ? Promise : void 0, $8df2de31e4e85614$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8df2de31e4e85614$var$Hf ? function(a) {
    return $8df2de31e4e85614$var$Hf.resolve(null).then(a).catch($8df2de31e4e85614$var$If);
} : $8df2de31e4e85614$var$Ff;
function $8df2de31e4e85614$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $8df2de31e4e85614$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $8df2de31e4e85614$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $8df2de31e4e85614$var$bd(b);
}
function $8df2de31e4e85614$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $8df2de31e4e85614$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $8df2de31e4e85614$var$Nf = Math.random().toString(36).slice(2), $8df2de31e4e85614$var$Of = "__reactFiber$" + $8df2de31e4e85614$var$Nf, $8df2de31e4e85614$var$Pf = "__reactProps$" + $8df2de31e4e85614$var$Nf, $8df2de31e4e85614$var$uf = "__reactContainer$" + $8df2de31e4e85614$var$Nf, $8df2de31e4e85614$var$of = "__reactEvents$" + $8df2de31e4e85614$var$Nf, $8df2de31e4e85614$var$Qf = "__reactListeners$" + $8df2de31e4e85614$var$Nf, $8df2de31e4e85614$var$Rf = "__reactHandles$" + $8df2de31e4e85614$var$Nf;
function $8df2de31e4e85614$var$Wc(a) {
    var b = a[$8df2de31e4e85614$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$8df2de31e4e85614$var$uf] || c[$8df2de31e4e85614$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $8df2de31e4e85614$var$Mf(a); null !== a;){
                if (c = a[$8df2de31e4e85614$var$Of]) return c;
                a = $8df2de31e4e85614$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $8df2de31e4e85614$var$Cb(a) {
    a = a[$8df2de31e4e85614$var$Of] || a[$8df2de31e4e85614$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $8df2de31e4e85614$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($8df2de31e4e85614$var$p(33));
}
function $8df2de31e4e85614$var$Db(a) {
    return a[$8df2de31e4e85614$var$Pf] || null;
}
var $8df2de31e4e85614$var$Sf = [], $8df2de31e4e85614$var$Tf = -1;
function $8df2de31e4e85614$var$Uf(a) {
    return {
        current: a
    };
}
function $8df2de31e4e85614$var$E(a) {
    0 > $8df2de31e4e85614$var$Tf || (a.current = $8df2de31e4e85614$var$Sf[$8df2de31e4e85614$var$Tf], $8df2de31e4e85614$var$Sf[$8df2de31e4e85614$var$Tf] = null, $8df2de31e4e85614$var$Tf--);
}
function $8df2de31e4e85614$var$G(a, b) {
    $8df2de31e4e85614$var$Tf++;
    $8df2de31e4e85614$var$Sf[$8df2de31e4e85614$var$Tf] = a.current;
    a.current = b;
}
var $8df2de31e4e85614$var$Vf = {}, $8df2de31e4e85614$var$H = $8df2de31e4e85614$var$Uf($8df2de31e4e85614$var$Vf), $8df2de31e4e85614$var$Wf = $8df2de31e4e85614$var$Uf(!1), $8df2de31e4e85614$var$Xf = $8df2de31e4e85614$var$Vf;
function $8df2de31e4e85614$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $8df2de31e4e85614$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $8df2de31e4e85614$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $8df2de31e4e85614$var$$f() {
    $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Wf);
    $8df2de31e4e85614$var$E($8df2de31e4e85614$var$H);
}
function $8df2de31e4e85614$var$ag(a, b, c) {
    if ($8df2de31e4e85614$var$H.current !== $8df2de31e4e85614$var$Vf) throw Error($8df2de31e4e85614$var$p(168));
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$H, b);
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$Wf, c);
}
function $8df2de31e4e85614$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($8df2de31e4e85614$var$p(108, $8df2de31e4e85614$var$Ra(a) || "Unknown", e));
    return $8df2de31e4e85614$var$A({}, c, d);
}
function $8df2de31e4e85614$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $8df2de31e4e85614$var$Vf;
    $8df2de31e4e85614$var$Xf = $8df2de31e4e85614$var$H.current;
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$H, a);
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$Wf, $8df2de31e4e85614$var$Wf.current);
    return !0;
}
function $8df2de31e4e85614$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($8df2de31e4e85614$var$p(169));
    c ? (a = $8df2de31e4e85614$var$bg(a, b, $8df2de31e4e85614$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Wf), $8df2de31e4e85614$var$E($8df2de31e4e85614$var$H), $8df2de31e4e85614$var$G($8df2de31e4e85614$var$H, a)) : $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Wf);
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$Wf, c);
}
var $8df2de31e4e85614$var$eg = null, $8df2de31e4e85614$var$fg = !1, $8df2de31e4e85614$var$gg = !1;
function $8df2de31e4e85614$var$hg(a) {
    null === $8df2de31e4e85614$var$eg ? $8df2de31e4e85614$var$eg = [
        a
    ] : $8df2de31e4e85614$var$eg.push(a);
}
function $8df2de31e4e85614$var$ig(a) {
    $8df2de31e4e85614$var$fg = !0;
    $8df2de31e4e85614$var$hg(a);
}
function $8df2de31e4e85614$var$jg() {
    if (!$8df2de31e4e85614$var$gg && null !== $8df2de31e4e85614$var$eg) {
        $8df2de31e4e85614$var$gg = !0;
        var a = 0, b = $8df2de31e4e85614$var$C;
        try {
            var c = $8df2de31e4e85614$var$eg;
            for($8df2de31e4e85614$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $8df2de31e4e85614$var$eg = null;
            $8df2de31e4e85614$var$fg = !1;
        } catch (e) {
            throw null !== $8df2de31e4e85614$var$eg && ($8df2de31e4e85614$var$eg = $8df2de31e4e85614$var$eg.slice(a + 1)), $8df2de31e4e85614$var$ac($8df2de31e4e85614$var$fc, $8df2de31e4e85614$var$jg), e;
        } finally{
            $8df2de31e4e85614$var$C = b, $8df2de31e4e85614$var$gg = !1;
        }
    }
    return null;
}
var $8df2de31e4e85614$var$kg = [], $8df2de31e4e85614$var$lg = 0, $8df2de31e4e85614$var$mg = null, $8df2de31e4e85614$var$ng = 0, $8df2de31e4e85614$var$og = [], $8df2de31e4e85614$var$pg = 0, $8df2de31e4e85614$var$qg = null, $8df2de31e4e85614$var$rg = 1, $8df2de31e4e85614$var$sg = "";
function $8df2de31e4e85614$var$tg(a, b) {
    $8df2de31e4e85614$var$kg[$8df2de31e4e85614$var$lg++] = $8df2de31e4e85614$var$ng;
    $8df2de31e4e85614$var$kg[$8df2de31e4e85614$var$lg++] = $8df2de31e4e85614$var$mg;
    $8df2de31e4e85614$var$mg = a;
    $8df2de31e4e85614$var$ng = b;
}
function $8df2de31e4e85614$var$ug(a, b, c) {
    $8df2de31e4e85614$var$og[$8df2de31e4e85614$var$pg++] = $8df2de31e4e85614$var$rg;
    $8df2de31e4e85614$var$og[$8df2de31e4e85614$var$pg++] = $8df2de31e4e85614$var$sg;
    $8df2de31e4e85614$var$og[$8df2de31e4e85614$var$pg++] = $8df2de31e4e85614$var$qg;
    $8df2de31e4e85614$var$qg = a;
    var d = $8df2de31e4e85614$var$rg;
    a = $8df2de31e4e85614$var$sg;
    var e = 32 - $8df2de31e4e85614$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $8df2de31e4e85614$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $8df2de31e4e85614$var$rg = 1 << 32 - $8df2de31e4e85614$var$oc(b) + e | c << e | d;
        $8df2de31e4e85614$var$sg = f + a;
    } else $8df2de31e4e85614$var$rg = 1 << f | c << e | d, $8df2de31e4e85614$var$sg = a;
}
function $8df2de31e4e85614$var$vg(a) {
    null !== a.return && ($8df2de31e4e85614$var$tg(a, 1), $8df2de31e4e85614$var$ug(a, 1, 0));
}
function $8df2de31e4e85614$var$wg(a) {
    for(; a === $8df2de31e4e85614$var$mg;)$8df2de31e4e85614$var$mg = $8df2de31e4e85614$var$kg[--$8df2de31e4e85614$var$lg], $8df2de31e4e85614$var$kg[$8df2de31e4e85614$var$lg] = null, $8df2de31e4e85614$var$ng = $8df2de31e4e85614$var$kg[--$8df2de31e4e85614$var$lg], $8df2de31e4e85614$var$kg[$8df2de31e4e85614$var$lg] = null;
    for(; a === $8df2de31e4e85614$var$qg;)$8df2de31e4e85614$var$qg = $8df2de31e4e85614$var$og[--$8df2de31e4e85614$var$pg], $8df2de31e4e85614$var$og[$8df2de31e4e85614$var$pg] = null, $8df2de31e4e85614$var$sg = $8df2de31e4e85614$var$og[--$8df2de31e4e85614$var$pg], $8df2de31e4e85614$var$og[$8df2de31e4e85614$var$pg] = null, $8df2de31e4e85614$var$rg = $8df2de31e4e85614$var$og[--$8df2de31e4e85614$var$pg], $8df2de31e4e85614$var$og[$8df2de31e4e85614$var$pg] = null;
}
var $8df2de31e4e85614$var$xg = null, $8df2de31e4e85614$var$yg = null, $8df2de31e4e85614$var$I = !1, $8df2de31e4e85614$var$zg = null;
function $8df2de31e4e85614$var$Ag(a, b) {
    var c = $8df2de31e4e85614$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $8df2de31e4e85614$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $8df2de31e4e85614$var$xg = a, $8df2de31e4e85614$var$yg = $8df2de31e4e85614$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $8df2de31e4e85614$var$xg = a, $8df2de31e4e85614$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $8df2de31e4e85614$var$qg ? {
                id: $8df2de31e4e85614$var$rg,
                overflow: $8df2de31e4e85614$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $8df2de31e4e85614$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $8df2de31e4e85614$var$xg = a, $8df2de31e4e85614$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $8df2de31e4e85614$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $8df2de31e4e85614$var$Eg(a) {
    if ($8df2de31e4e85614$var$I) {
        var b = $8df2de31e4e85614$var$yg;
        if (b) {
            var c = b;
            if (!$8df2de31e4e85614$var$Cg(a, b)) {
                if ($8df2de31e4e85614$var$Dg(a)) throw Error($8df2de31e4e85614$var$p(418));
                b = $8df2de31e4e85614$var$Lf(c.nextSibling);
                var d = $8df2de31e4e85614$var$xg;
                b && $8df2de31e4e85614$var$Cg(a, b) ? $8df2de31e4e85614$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $8df2de31e4e85614$var$I = !1, $8df2de31e4e85614$var$xg = a);
            }
        } else {
            if ($8df2de31e4e85614$var$Dg(a)) throw Error($8df2de31e4e85614$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $8df2de31e4e85614$var$I = !1;
            $8df2de31e4e85614$var$xg = a;
        }
    }
}
function $8df2de31e4e85614$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $8df2de31e4e85614$var$xg = a;
}
function $8df2de31e4e85614$var$Gg(a) {
    if (a !== $8df2de31e4e85614$var$xg) return !1;
    if (!$8df2de31e4e85614$var$I) return $8df2de31e4e85614$var$Fg(a), $8df2de31e4e85614$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$8df2de31e4e85614$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $8df2de31e4e85614$var$yg)) {
        if ($8df2de31e4e85614$var$Dg(a)) throw $8df2de31e4e85614$var$Hg(), Error($8df2de31e4e85614$var$p(418));
        for(; b;)$8df2de31e4e85614$var$Ag(a, b), b = $8df2de31e4e85614$var$Lf(b.nextSibling);
    }
    $8df2de31e4e85614$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($8df2de31e4e85614$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $8df2de31e4e85614$var$yg = $8df2de31e4e85614$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $8df2de31e4e85614$var$yg = null;
        }
    } else $8df2de31e4e85614$var$yg = $8df2de31e4e85614$var$xg ? $8df2de31e4e85614$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $8df2de31e4e85614$var$Hg() {
    for(var a = $8df2de31e4e85614$var$yg; a;)a = $8df2de31e4e85614$var$Lf(a.nextSibling);
}
function $8df2de31e4e85614$var$Ig() {
    $8df2de31e4e85614$var$yg = $8df2de31e4e85614$var$xg = null;
    $8df2de31e4e85614$var$I = !1;
}
function $8df2de31e4e85614$var$Jg(a) {
    null === $8df2de31e4e85614$var$zg ? $8df2de31e4e85614$var$zg = [
        a
    ] : $8df2de31e4e85614$var$zg.push(a);
}
var $8df2de31e4e85614$var$Kg = $8df2de31e4e85614$var$ua.ReactCurrentBatchConfig;
function $8df2de31e4e85614$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $8df2de31e4e85614$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $8df2de31e4e85614$var$Mg = $8df2de31e4e85614$var$Uf(null), $8df2de31e4e85614$var$Ng = null, $8df2de31e4e85614$var$Og = null, $8df2de31e4e85614$var$Pg = null;
function $8df2de31e4e85614$var$Qg() {
    $8df2de31e4e85614$var$Pg = $8df2de31e4e85614$var$Og = $8df2de31e4e85614$var$Ng = null;
}
function $8df2de31e4e85614$var$Rg(a) {
    var b = $8df2de31e4e85614$var$Mg.current;
    $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Mg);
    a._currentValue = b;
}
function $8df2de31e4e85614$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $8df2de31e4e85614$var$Tg(a, b) {
    $8df2de31e4e85614$var$Ng = a;
    $8df2de31e4e85614$var$Pg = $8df2de31e4e85614$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($8df2de31e4e85614$var$Ug = !0), a.firstContext = null);
}
function $8df2de31e4e85614$var$Vg(a) {
    var b = a._currentValue;
    if ($8df2de31e4e85614$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $8df2de31e4e85614$var$Og) {
            if (null === $8df2de31e4e85614$var$Ng) throw Error($8df2de31e4e85614$var$p(308));
            $8df2de31e4e85614$var$Og = a;
            $8df2de31e4e85614$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $8df2de31e4e85614$var$Og = $8df2de31e4e85614$var$Og.next = a;
    }
    return b;
}
var $8df2de31e4e85614$var$Wg = null;
function $8df2de31e4e85614$var$Xg(a) {
    null === $8df2de31e4e85614$var$Wg ? $8df2de31e4e85614$var$Wg = [
        a
    ] : $8df2de31e4e85614$var$Wg.push(a);
}
function $8df2de31e4e85614$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $8df2de31e4e85614$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $8df2de31e4e85614$var$Zg(a, d);
}
function $8df2de31e4e85614$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $8df2de31e4e85614$var$$g = !1;
function $8df2de31e4e85614$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $8df2de31e4e85614$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $8df2de31e4e85614$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8df2de31e4e85614$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($8df2de31e4e85614$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $8df2de31e4e85614$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $8df2de31e4e85614$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $8df2de31e4e85614$var$Zg(a, c);
}
function $8df2de31e4e85614$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8df2de31e4e85614$var$Cc(a, c);
    }
}
function $8df2de31e4e85614$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $8df2de31e4e85614$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $8df2de31e4e85614$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $8df2de31e4e85614$var$A({}, q, r);
                            break a;
                        case 2:
                            $8df2de31e4e85614$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $8df2de31e4e85614$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $8df2de31e4e85614$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($8df2de31e4e85614$var$p(191, e));
            e.call(d);
        }
    }
}
var $8df2de31e4e85614$var$jh = (new $4YNlq.Component).refs;
function $8df2de31e4e85614$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8df2de31e4e85614$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $8df2de31e4e85614$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $8df2de31e4e85614$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8df2de31e4e85614$var$L(), e = $8df2de31e4e85614$var$lh(a), f = $8df2de31e4e85614$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8df2de31e4e85614$var$dh(a, f, e);
        null !== b && ($8df2de31e4e85614$var$mh(b, a, e, d), $8df2de31e4e85614$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $8df2de31e4e85614$var$L(), e = $8df2de31e4e85614$var$lh(a), f = $8df2de31e4e85614$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $8df2de31e4e85614$var$dh(a, f, e);
        null !== b && ($8df2de31e4e85614$var$mh(b, a, e, d), $8df2de31e4e85614$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $8df2de31e4e85614$var$L(), d = $8df2de31e4e85614$var$lh(a), e = $8df2de31e4e85614$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $8df2de31e4e85614$var$dh(a, e, d);
        null !== b && ($8df2de31e4e85614$var$mh(b, a, d, c), $8df2de31e4e85614$var$eh(b, a, d));
    }
};
function $8df2de31e4e85614$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$8df2de31e4e85614$var$Ie(c, d) || !$8df2de31e4e85614$var$Ie(e, f) : !0;
}
function $8df2de31e4e85614$var$ph(a, b, c) {
    var d = !1, e = $8df2de31e4e85614$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $8df2de31e4e85614$var$Vg(f) : (e = $8df2de31e4e85614$var$Zf(b) ? $8df2de31e4e85614$var$Xf : $8df2de31e4e85614$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $8df2de31e4e85614$var$Yf(a, e) : $8df2de31e4e85614$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $8df2de31e4e85614$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $8df2de31e4e85614$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $8df2de31e4e85614$var$nh.enqueueReplaceState(b, b.state, null);
}
function $8df2de31e4e85614$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $8df2de31e4e85614$var$jh;
    $8df2de31e4e85614$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $8df2de31e4e85614$var$Vg(f) : (f = $8df2de31e4e85614$var$Zf(b) ? $8df2de31e4e85614$var$Xf : $8df2de31e4e85614$var$H.current, e.context = $8df2de31e4e85614$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($8df2de31e4e85614$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $8df2de31e4e85614$var$nh.enqueueReplaceState(e, e.state, null), $8df2de31e4e85614$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $8df2de31e4e85614$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($8df2de31e4e85614$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($8df2de31e4e85614$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $8df2de31e4e85614$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($8df2de31e4e85614$var$p(284));
        if (!c._owner) throw Error($8df2de31e4e85614$var$p(290, a));
    }
    return a;
}
function $8df2de31e4e85614$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($8df2de31e4e85614$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $8df2de31e4e85614$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $8df2de31e4e85614$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $8df2de31e4e85614$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $8df2de31e4e85614$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $8df2de31e4e85614$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $8df2de31e4e85614$var$Ha && $8df2de31e4e85614$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $8df2de31e4e85614$var$sh(a, b, c), d.return = a, d;
        d = $8df2de31e4e85614$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $8df2de31e4e85614$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $8df2de31e4e85614$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $8df2de31e4e85614$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $8df2de31e4e85614$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $8df2de31e4e85614$var$va:
                    return c = $8df2de31e4e85614$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $8df2de31e4e85614$var$sh(a, null, b), c.return = a, c;
                case $8df2de31e4e85614$var$wa:
                    return b = $8df2de31e4e85614$var$zh(b, a.mode, c), b.return = a, b;
                case $8df2de31e4e85614$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($8df2de31e4e85614$var$eb(b) || $8df2de31e4e85614$var$Ka(b)) return b = $8df2de31e4e85614$var$Ah(b, a.mode, c, null), b.return = a, b;
            $8df2de31e4e85614$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $8df2de31e4e85614$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $8df2de31e4e85614$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $8df2de31e4e85614$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($8df2de31e4e85614$var$eb(c) || $8df2de31e4e85614$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $8df2de31e4e85614$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $8df2de31e4e85614$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $8df2de31e4e85614$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $8df2de31e4e85614$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($8df2de31e4e85614$var$eb(d) || $8df2de31e4e85614$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $8df2de31e4e85614$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $8df2de31e4e85614$var$I && $8df2de31e4e85614$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $8df2de31e4e85614$var$I && $8df2de31e4e85614$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $8df2de31e4e85614$var$I && $8df2de31e4e85614$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $8df2de31e4e85614$var$Ka(h);
        if ("function" !== typeof l) throw Error($8df2de31e4e85614$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($8df2de31e4e85614$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $8df2de31e4e85614$var$I && $8df2de31e4e85614$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $8df2de31e4e85614$var$I && $8df2de31e4e85614$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $8df2de31e4e85614$var$I && $8df2de31e4e85614$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $8df2de31e4e85614$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $8df2de31e4e85614$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $8df2de31e4e85614$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $8df2de31e4e85614$var$Ha && $8df2de31e4e85614$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $8df2de31e4e85614$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $8df2de31e4e85614$var$ya ? (d = $8df2de31e4e85614$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $8df2de31e4e85614$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $8df2de31e4e85614$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $8df2de31e4e85614$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $8df2de31e4e85614$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $8df2de31e4e85614$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($8df2de31e4e85614$var$eb(f)) return n(a, d, f, h);
            if ($8df2de31e4e85614$var$Ka(f)) return t(a, d, f, h);
            $8df2de31e4e85614$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $8df2de31e4e85614$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $8df2de31e4e85614$var$Bh = $8df2de31e4e85614$var$vh(!0), $8df2de31e4e85614$var$Ch = $8df2de31e4e85614$var$vh(!1), $8df2de31e4e85614$var$Dh = {}, $8df2de31e4e85614$var$Eh = $8df2de31e4e85614$var$Uf($8df2de31e4e85614$var$Dh), $8df2de31e4e85614$var$Fh = $8df2de31e4e85614$var$Uf($8df2de31e4e85614$var$Dh), $8df2de31e4e85614$var$Gh = $8df2de31e4e85614$var$Uf($8df2de31e4e85614$var$Dh);
function $8df2de31e4e85614$var$Hh(a) {
    if (a === $8df2de31e4e85614$var$Dh) throw Error($8df2de31e4e85614$var$p(174));
    return a;
}
function $8df2de31e4e85614$var$Ih(a, b) {
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$Gh, b);
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$Fh, a);
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$Eh, $8df2de31e4e85614$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $8df2de31e4e85614$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $8df2de31e4e85614$var$lb(b, a);
    }
    $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Eh);
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$Eh, b);
}
function $8df2de31e4e85614$var$Jh() {
    $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Eh);
    $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Fh);
    $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Gh);
}
function $8df2de31e4e85614$var$Kh(a) {
    $8df2de31e4e85614$var$Hh($8df2de31e4e85614$var$Gh.current);
    var b = $8df2de31e4e85614$var$Hh($8df2de31e4e85614$var$Eh.current);
    var c = $8df2de31e4e85614$var$lb(b, a.type);
    b !== c && ($8df2de31e4e85614$var$G($8df2de31e4e85614$var$Fh, a), $8df2de31e4e85614$var$G($8df2de31e4e85614$var$Eh, c));
}
function $8df2de31e4e85614$var$Lh(a) {
    $8df2de31e4e85614$var$Fh.current === a && ($8df2de31e4e85614$var$E($8df2de31e4e85614$var$Eh), $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Fh));
}
var $8df2de31e4e85614$var$M = $8df2de31e4e85614$var$Uf(0);
function $8df2de31e4e85614$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $8df2de31e4e85614$var$Nh = [];
function $8df2de31e4e85614$var$Oh() {
    for(var a = 0; a < $8df2de31e4e85614$var$Nh.length; a++)$8df2de31e4e85614$var$Nh[a]._workInProgressVersionPrimary = null;
    $8df2de31e4e85614$var$Nh.length = 0;
}
var $8df2de31e4e85614$var$Ph = $8df2de31e4e85614$var$ua.ReactCurrentDispatcher, $8df2de31e4e85614$var$Qh = $8df2de31e4e85614$var$ua.ReactCurrentBatchConfig, $8df2de31e4e85614$var$Rh = 0, $8df2de31e4e85614$var$N = null, $8df2de31e4e85614$var$O = null, $8df2de31e4e85614$var$P = null, $8df2de31e4e85614$var$Sh = !1, $8df2de31e4e85614$var$Th = !1, $8df2de31e4e85614$var$Uh = 0, $8df2de31e4e85614$var$Vh = 0;
function $8df2de31e4e85614$var$Q() {
    throw Error($8df2de31e4e85614$var$p(321));
}
function $8df2de31e4e85614$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$8df2de31e4e85614$var$He(a[c], b[c])) return !1;
    return !0;
}
function $8df2de31e4e85614$var$Xh(a, b, c, d, e, f) {
    $8df2de31e4e85614$var$Rh = f;
    $8df2de31e4e85614$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $8df2de31e4e85614$var$Ph.current = null === a || null === a.memoizedState ? $8df2de31e4e85614$var$Yh : $8df2de31e4e85614$var$Zh;
    a = c(d, e);
    if ($8df2de31e4e85614$var$Th) {
        f = 0;
        do {
            $8df2de31e4e85614$var$Th = !1;
            $8df2de31e4e85614$var$Uh = 0;
            if (25 <= f) throw Error($8df2de31e4e85614$var$p(301));
            f += 1;
            $8df2de31e4e85614$var$P = $8df2de31e4e85614$var$O = null;
            b.updateQueue = null;
            $8df2de31e4e85614$var$Ph.current = $8df2de31e4e85614$var$$h;
            a = c(d, e);
        }while ($8df2de31e4e85614$var$Th);
    }
    $8df2de31e4e85614$var$Ph.current = $8df2de31e4e85614$var$ai;
    b = null !== $8df2de31e4e85614$var$O && null !== $8df2de31e4e85614$var$O.next;
    $8df2de31e4e85614$var$Rh = 0;
    $8df2de31e4e85614$var$P = $8df2de31e4e85614$var$O = $8df2de31e4e85614$var$N = null;
    $8df2de31e4e85614$var$Sh = !1;
    if (b) throw Error($8df2de31e4e85614$var$p(300));
    return a;
}
function $8df2de31e4e85614$var$bi() {
    var a = 0 !== $8df2de31e4e85614$var$Uh;
    $8df2de31e4e85614$var$Uh = 0;
    return a;
}
function $8df2de31e4e85614$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8df2de31e4e85614$var$P ? $8df2de31e4e85614$var$N.memoizedState = $8df2de31e4e85614$var$P = a : $8df2de31e4e85614$var$P = $8df2de31e4e85614$var$P.next = a;
    return $8df2de31e4e85614$var$P;
}
function $8df2de31e4e85614$var$di() {
    if (null === $8df2de31e4e85614$var$O) {
        var a = $8df2de31e4e85614$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $8df2de31e4e85614$var$O.next;
    var b = null === $8df2de31e4e85614$var$P ? $8df2de31e4e85614$var$N.memoizedState : $8df2de31e4e85614$var$P.next;
    if (null !== b) $8df2de31e4e85614$var$P = b, $8df2de31e4e85614$var$O = a;
    else {
        if (null === a) throw Error($8df2de31e4e85614$var$p(310));
        $8df2de31e4e85614$var$O = a;
        a = {
            memoizedState: $8df2de31e4e85614$var$O.memoizedState,
            baseState: $8df2de31e4e85614$var$O.baseState,
            baseQueue: $8df2de31e4e85614$var$O.baseQueue,
            queue: $8df2de31e4e85614$var$O.queue,
            next: null
        };
        null === $8df2de31e4e85614$var$P ? $8df2de31e4e85614$var$N.memoizedState = $8df2de31e4e85614$var$P = a : $8df2de31e4e85614$var$P = $8df2de31e4e85614$var$P.next = a;
    }
    return $8df2de31e4e85614$var$P;
}
function $8df2de31e4e85614$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $8df2de31e4e85614$var$fi(a) {
    var b = $8df2de31e4e85614$var$di(), c = b.queue;
    if (null === c) throw Error($8df2de31e4e85614$var$p(311));
    c.lastRenderedReducer = a;
    var d = $8df2de31e4e85614$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($8df2de31e4e85614$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $8df2de31e4e85614$var$N.lanes |= m;
                $8df2de31e4e85614$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $8df2de31e4e85614$var$He(d, b.memoizedState) || ($8df2de31e4e85614$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $8df2de31e4e85614$var$N.lanes |= f, $8df2de31e4e85614$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $8df2de31e4e85614$var$gi(a) {
    var b = $8df2de31e4e85614$var$di(), c = b.queue;
    if (null === c) throw Error($8df2de31e4e85614$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $8df2de31e4e85614$var$He(f, b.memoizedState) || ($8df2de31e4e85614$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $8df2de31e4e85614$var$hi() {}
function $8df2de31e4e85614$var$ii(a, b) {
    var c = $8df2de31e4e85614$var$N, d = $8df2de31e4e85614$var$di(), e = b(), f = !$8df2de31e4e85614$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $8df2de31e4e85614$var$Ug = !0);
    d = d.queue;
    $8df2de31e4e85614$var$ji($8df2de31e4e85614$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $8df2de31e4e85614$var$P && $8df2de31e4e85614$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $8df2de31e4e85614$var$li(9, $8df2de31e4e85614$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $8df2de31e4e85614$var$R) throw Error($8df2de31e4e85614$var$p(349));
        0 !== ($8df2de31e4e85614$var$Rh & 30) || $8df2de31e4e85614$var$ni(c, b, e);
    }
    return e;
}
function $8df2de31e4e85614$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $8df2de31e4e85614$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8df2de31e4e85614$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $8df2de31e4e85614$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $8df2de31e4e85614$var$oi(b) && $8df2de31e4e85614$var$pi(a);
}
function $8df2de31e4e85614$var$ki(a, b, c) {
    return c(function() {
        $8df2de31e4e85614$var$oi(b) && $8df2de31e4e85614$var$pi(a);
    });
}
function $8df2de31e4e85614$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$8df2de31e4e85614$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $8df2de31e4e85614$var$pi(a) {
    var b = $8df2de31e4e85614$var$Zg(a, 1);
    null !== b && $8df2de31e4e85614$var$mh(b, a, 1, -1);
}
function $8df2de31e4e85614$var$qi(a) {
    var b = $8df2de31e4e85614$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8df2de31e4e85614$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $8df2de31e4e85614$var$ri.bind(null, $8df2de31e4e85614$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $8df2de31e4e85614$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $8df2de31e4e85614$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $8df2de31e4e85614$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $8df2de31e4e85614$var$si() {
    return $8df2de31e4e85614$var$di().memoizedState;
}
function $8df2de31e4e85614$var$ti(a, b, c, d) {
    var e = $8df2de31e4e85614$var$ci();
    $8df2de31e4e85614$var$N.flags |= a;
    e.memoizedState = $8df2de31e4e85614$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $8df2de31e4e85614$var$ui(a, b, c, d) {
    var e = $8df2de31e4e85614$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $8df2de31e4e85614$var$O) {
        var g = $8df2de31e4e85614$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $8df2de31e4e85614$var$Wh(d, g.deps)) {
            e.memoizedState = $8df2de31e4e85614$var$li(b, c, f, d);
            return;
        }
    }
    $8df2de31e4e85614$var$N.flags |= a;
    e.memoizedState = $8df2de31e4e85614$var$li(1 | b, c, f, d);
}
function $8df2de31e4e85614$var$vi(a, b) {
    return $8df2de31e4e85614$var$ti(8390656, 8, a, b);
}
function $8df2de31e4e85614$var$ji(a, b) {
    return $8df2de31e4e85614$var$ui(2048, 8, a, b);
}
function $8df2de31e4e85614$var$wi(a, b) {
    return $8df2de31e4e85614$var$ui(4, 2, a, b);
}
function $8df2de31e4e85614$var$xi(a, b) {
    return $8df2de31e4e85614$var$ui(4, 4, a, b);
}
function $8df2de31e4e85614$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $8df2de31e4e85614$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $8df2de31e4e85614$var$ui(4, 4, $8df2de31e4e85614$var$yi.bind(null, b, a), c);
}
function $8df2de31e4e85614$var$Ai() {}
function $8df2de31e4e85614$var$Bi(a, b) {
    var c = $8df2de31e4e85614$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8df2de31e4e85614$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8df2de31e4e85614$var$Ci(a, b) {
    var c = $8df2de31e4e85614$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $8df2de31e4e85614$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $8df2de31e4e85614$var$Di(a, b, c) {
    if (0 === ($8df2de31e4e85614$var$Rh & 21)) return a.baseState && (a.baseState = !1, $8df2de31e4e85614$var$Ug = !0), a.memoizedState = c;
    $8df2de31e4e85614$var$He(c, b) || (c = $8df2de31e4e85614$var$yc(), $8df2de31e4e85614$var$N.lanes |= c, $8df2de31e4e85614$var$hh |= c, a.baseState = !0);
    return b;
}
function $8df2de31e4e85614$var$Ei(a, b) {
    var c = $8df2de31e4e85614$var$C;
    $8df2de31e4e85614$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $8df2de31e4e85614$var$Qh.transition;
    $8df2de31e4e85614$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $8df2de31e4e85614$var$C = c, $8df2de31e4e85614$var$Qh.transition = d;
    }
}
function $8df2de31e4e85614$var$Fi() {
    return $8df2de31e4e85614$var$di().memoizedState;
}
function $8df2de31e4e85614$var$Gi(a, b, c) {
    var d = $8df2de31e4e85614$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8df2de31e4e85614$var$Hi(a)) $8df2de31e4e85614$var$Ii(b, c);
    else if (c = $8df2de31e4e85614$var$Yg(a, b, c, d), null !== c) {
        var e = $8df2de31e4e85614$var$L();
        $8df2de31e4e85614$var$mh(c, a, d, e);
        $8df2de31e4e85614$var$Ji(c, b, d);
    }
}
function $8df2de31e4e85614$var$ri(a, b, c) {
    var d = $8df2de31e4e85614$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8df2de31e4e85614$var$Hi(a)) $8df2de31e4e85614$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($8df2de31e4e85614$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $8df2de31e4e85614$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $8df2de31e4e85614$var$Yg(a, b, e, d);
        null !== c && (e = $8df2de31e4e85614$var$L(), $8df2de31e4e85614$var$mh(c, a, d, e), $8df2de31e4e85614$var$Ji(c, b, d));
    }
}
function $8df2de31e4e85614$var$Hi(a) {
    var b = a.alternate;
    return a === $8df2de31e4e85614$var$N || null !== b && b === $8df2de31e4e85614$var$N;
}
function $8df2de31e4e85614$var$Ii(a, b) {
    $8df2de31e4e85614$var$Th = $8df2de31e4e85614$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $8df2de31e4e85614$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $8df2de31e4e85614$var$Cc(a, c);
    }
}
var $8df2de31e4e85614$var$ai = {
    readContext: $8df2de31e4e85614$var$Vg,
    useCallback: $8df2de31e4e85614$var$Q,
    useContext: $8df2de31e4e85614$var$Q,
    useEffect: $8df2de31e4e85614$var$Q,
    useImperativeHandle: $8df2de31e4e85614$var$Q,
    useInsertionEffect: $8df2de31e4e85614$var$Q,
    useLayoutEffect: $8df2de31e4e85614$var$Q,
    useMemo: $8df2de31e4e85614$var$Q,
    useReducer: $8df2de31e4e85614$var$Q,
    useRef: $8df2de31e4e85614$var$Q,
    useState: $8df2de31e4e85614$var$Q,
    useDebugValue: $8df2de31e4e85614$var$Q,
    useDeferredValue: $8df2de31e4e85614$var$Q,
    useTransition: $8df2de31e4e85614$var$Q,
    useMutableSource: $8df2de31e4e85614$var$Q,
    useSyncExternalStore: $8df2de31e4e85614$var$Q,
    useId: $8df2de31e4e85614$var$Q,
    unstable_isNewReconciler: !1
}, $8df2de31e4e85614$var$Yh = {
    readContext: $8df2de31e4e85614$var$Vg,
    useCallback: function(a, b) {
        $8df2de31e4e85614$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $8df2de31e4e85614$var$Vg,
    useEffect: $8df2de31e4e85614$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $8df2de31e4e85614$var$ti(4194308, 4, $8df2de31e4e85614$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $8df2de31e4e85614$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $8df2de31e4e85614$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $8df2de31e4e85614$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $8df2de31e4e85614$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $8df2de31e4e85614$var$Gi.bind(null, $8df2de31e4e85614$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $8df2de31e4e85614$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $8df2de31e4e85614$var$qi,
    useDebugValue: $8df2de31e4e85614$var$Ai,
    useDeferredValue: function(a) {
        return $8df2de31e4e85614$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $8df2de31e4e85614$var$qi(!1), b = a[0];
        a = $8df2de31e4e85614$var$Ei.bind(null, a[1]);
        $8df2de31e4e85614$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $8df2de31e4e85614$var$N, e = $8df2de31e4e85614$var$ci();
        if ($8df2de31e4e85614$var$I) {
            if (void 0 === c) throw Error($8df2de31e4e85614$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $8df2de31e4e85614$var$R) throw Error($8df2de31e4e85614$var$p(349));
            0 !== ($8df2de31e4e85614$var$Rh & 30) || $8df2de31e4e85614$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $8df2de31e4e85614$var$vi($8df2de31e4e85614$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $8df2de31e4e85614$var$li(9, $8df2de31e4e85614$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $8df2de31e4e85614$var$ci(), b = $8df2de31e4e85614$var$R.identifierPrefix;
        if ($8df2de31e4e85614$var$I) {
            var c = $8df2de31e4e85614$var$sg;
            var d = $8df2de31e4e85614$var$rg;
            c = (d & ~(1 << 32 - $8df2de31e4e85614$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $8df2de31e4e85614$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $8df2de31e4e85614$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $8df2de31e4e85614$var$Zh = {
    readContext: $8df2de31e4e85614$var$Vg,
    useCallback: $8df2de31e4e85614$var$Bi,
    useContext: $8df2de31e4e85614$var$Vg,
    useEffect: $8df2de31e4e85614$var$ji,
    useImperativeHandle: $8df2de31e4e85614$var$zi,
    useInsertionEffect: $8df2de31e4e85614$var$wi,
    useLayoutEffect: $8df2de31e4e85614$var$xi,
    useMemo: $8df2de31e4e85614$var$Ci,
    useReducer: $8df2de31e4e85614$var$fi,
    useRef: $8df2de31e4e85614$var$si,
    useState: function() {
        return $8df2de31e4e85614$var$fi($8df2de31e4e85614$var$ei);
    },
    useDebugValue: $8df2de31e4e85614$var$Ai,
    useDeferredValue: function(a) {
        var b = $8df2de31e4e85614$var$di();
        return $8df2de31e4e85614$var$Di(b, $8df2de31e4e85614$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $8df2de31e4e85614$var$fi($8df2de31e4e85614$var$ei)[0], b = $8df2de31e4e85614$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8df2de31e4e85614$var$hi,
    useSyncExternalStore: $8df2de31e4e85614$var$ii,
    useId: $8df2de31e4e85614$var$Fi,
    unstable_isNewReconciler: !1
}, $8df2de31e4e85614$var$$h = {
    readContext: $8df2de31e4e85614$var$Vg,
    useCallback: $8df2de31e4e85614$var$Bi,
    useContext: $8df2de31e4e85614$var$Vg,
    useEffect: $8df2de31e4e85614$var$ji,
    useImperativeHandle: $8df2de31e4e85614$var$zi,
    useInsertionEffect: $8df2de31e4e85614$var$wi,
    useLayoutEffect: $8df2de31e4e85614$var$xi,
    useMemo: $8df2de31e4e85614$var$Ci,
    useReducer: $8df2de31e4e85614$var$gi,
    useRef: $8df2de31e4e85614$var$si,
    useState: function() {
        return $8df2de31e4e85614$var$gi($8df2de31e4e85614$var$ei);
    },
    useDebugValue: $8df2de31e4e85614$var$Ai,
    useDeferredValue: function(a) {
        var b = $8df2de31e4e85614$var$di();
        return null === $8df2de31e4e85614$var$O ? b.memoizedState = a : $8df2de31e4e85614$var$Di(b, $8df2de31e4e85614$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $8df2de31e4e85614$var$gi($8df2de31e4e85614$var$ei)[0], b = $8df2de31e4e85614$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $8df2de31e4e85614$var$hi,
    useSyncExternalStore: $8df2de31e4e85614$var$ii,
    useId: $8df2de31e4e85614$var$Fi,
    unstable_isNewReconciler: !1
};
function $8df2de31e4e85614$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $8df2de31e4e85614$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $8df2de31e4e85614$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $8df2de31e4e85614$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $8df2de31e4e85614$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $8df2de31e4e85614$var$Oi(a, b, c) {
    c = $8df2de31e4e85614$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $8df2de31e4e85614$var$Pi || ($8df2de31e4e85614$var$Pi = !0, $8df2de31e4e85614$var$Qi = d);
        $8df2de31e4e85614$var$Mi(a, b);
    };
    return c;
}
function $8df2de31e4e85614$var$Ri(a, b, c) {
    c = $8df2de31e4e85614$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $8df2de31e4e85614$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $8df2de31e4e85614$var$Mi(a, b);
        "function" !== typeof d && (null === $8df2de31e4e85614$var$Si ? $8df2de31e4e85614$var$Si = new Set([
            this
        ]) : $8df2de31e4e85614$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $8df2de31e4e85614$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $8df2de31e4e85614$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $8df2de31e4e85614$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $8df2de31e4e85614$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $8df2de31e4e85614$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $8df2de31e4e85614$var$ch(-1, 1), b.tag = 2, $8df2de31e4e85614$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $8df2de31e4e85614$var$Xi = $8df2de31e4e85614$var$ua.ReactCurrentOwner, $8df2de31e4e85614$var$Ug = !1;
function $8df2de31e4e85614$var$Yi(a, b, c, d) {
    b.child = null === a ? $8df2de31e4e85614$var$Ch(b, null, c, d) : $8df2de31e4e85614$var$Bh(b, a.child, c, d);
}
function $8df2de31e4e85614$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $8df2de31e4e85614$var$Tg(b, e);
    d = $8df2de31e4e85614$var$Xh(a, b, c, d, f, e);
    c = $8df2de31e4e85614$var$bi();
    if (null !== a && !$8df2de31e4e85614$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8df2de31e4e85614$var$$i(a, b, e);
    $8df2de31e4e85614$var$I && c && $8df2de31e4e85614$var$vg(b);
    b.flags |= 1;
    $8df2de31e4e85614$var$Yi(a, b, d, e);
    return b.child;
}
function $8df2de31e4e85614$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$8df2de31e4e85614$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $8df2de31e4e85614$var$cj(a, b, f, d, e);
        a = $8df2de31e4e85614$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $8df2de31e4e85614$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $8df2de31e4e85614$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $8df2de31e4e85614$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $8df2de31e4e85614$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($8df2de31e4e85614$var$Ie(f, d) && a.ref === b.ref) {
            if ($8df2de31e4e85614$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($8df2de31e4e85614$var$Ug = !0);
            else return b.lanes = a.lanes, $8df2de31e4e85614$var$$i(a, b, e);
        }
    }
    return $8df2de31e4e85614$var$dj(a, b, c, d, e);
}
function $8df2de31e4e85614$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $8df2de31e4e85614$var$G($8df2de31e4e85614$var$fj, $8df2de31e4e85614$var$gj), $8df2de31e4e85614$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $8df2de31e4e85614$var$G($8df2de31e4e85614$var$fj, $8df2de31e4e85614$var$gj), $8df2de31e4e85614$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $8df2de31e4e85614$var$G($8df2de31e4e85614$var$fj, $8df2de31e4e85614$var$gj);
            $8df2de31e4e85614$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $8df2de31e4e85614$var$G($8df2de31e4e85614$var$fj, $8df2de31e4e85614$var$gj), $8df2de31e4e85614$var$gj |= d;
    $8df2de31e4e85614$var$Yi(a, b, e, c);
    return b.child;
}
function $8df2de31e4e85614$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $8df2de31e4e85614$var$dj(a, b, c, d, e) {
    var f = $8df2de31e4e85614$var$Zf(c) ? $8df2de31e4e85614$var$Xf : $8df2de31e4e85614$var$H.current;
    f = $8df2de31e4e85614$var$Yf(b, f);
    $8df2de31e4e85614$var$Tg(b, e);
    c = $8df2de31e4e85614$var$Xh(a, b, c, d, f, e);
    d = $8df2de31e4e85614$var$bi();
    if (null !== a && !$8df2de31e4e85614$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $8df2de31e4e85614$var$$i(a, b, e);
    $8df2de31e4e85614$var$I && d && $8df2de31e4e85614$var$vg(b);
    b.flags |= 1;
    $8df2de31e4e85614$var$Yi(a, b, c, e);
    return b.child;
}
function $8df2de31e4e85614$var$ij(a, b, c, d, e) {
    if ($8df2de31e4e85614$var$Zf(c)) {
        var f = !0;
        $8df2de31e4e85614$var$cg(b);
    } else f = !1;
    $8df2de31e4e85614$var$Tg(b, e);
    if (null === b.stateNode) $8df2de31e4e85614$var$jj(a, b), $8df2de31e4e85614$var$ph(b, c, d), $8df2de31e4e85614$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $8df2de31e4e85614$var$Vg(l) : (l = $8df2de31e4e85614$var$Zf(c) ? $8df2de31e4e85614$var$Xf : $8df2de31e4e85614$var$H.current, l = $8df2de31e4e85614$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $8df2de31e4e85614$var$qh(b, g, d, l);
        $8df2de31e4e85614$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $8df2de31e4e85614$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $8df2de31e4e85614$var$Wf.current || $8df2de31e4e85614$var$$g ? ("function" === typeof m && ($8df2de31e4e85614$var$kh(b, c, m, d), k = b.memoizedState), (h = $8df2de31e4e85614$var$$g || $8df2de31e4e85614$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $8df2de31e4e85614$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $8df2de31e4e85614$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $8df2de31e4e85614$var$Vg(k) : (k = $8df2de31e4e85614$var$Zf(c) ? $8df2de31e4e85614$var$Xf : $8df2de31e4e85614$var$H.current, k = $8df2de31e4e85614$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $8df2de31e4e85614$var$qh(b, g, d, k);
        $8df2de31e4e85614$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $8df2de31e4e85614$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $8df2de31e4e85614$var$Wf.current || $8df2de31e4e85614$var$$g ? ("function" === typeof y && ($8df2de31e4e85614$var$kh(b, c, y, d), n = b.memoizedState), (l = $8df2de31e4e85614$var$$g || $8df2de31e4e85614$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $8df2de31e4e85614$var$kj(a, b, c, d, f, e);
}
function $8df2de31e4e85614$var$kj(a, b, c, d, e, f) {
    $8df2de31e4e85614$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $8df2de31e4e85614$var$dg(b, c, !1), $8df2de31e4e85614$var$$i(a, b, f);
    d = b.stateNode;
    $8df2de31e4e85614$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $8df2de31e4e85614$var$Bh(b, a.child, null, f), b.child = $8df2de31e4e85614$var$Bh(b, null, h, f)) : $8df2de31e4e85614$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $8df2de31e4e85614$var$dg(b, c, !0);
    return b.child;
}
function $8df2de31e4e85614$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $8df2de31e4e85614$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $8df2de31e4e85614$var$ag(a, b.context, !1);
    $8df2de31e4e85614$var$Ih(a, b.containerInfo);
}
function $8df2de31e4e85614$var$mj(a, b, c, d, e) {
    $8df2de31e4e85614$var$Ig();
    $8df2de31e4e85614$var$Jg(e);
    b.flags |= 256;
    $8df2de31e4e85614$var$Yi(a, b, c, d);
    return b.child;
}
var $8df2de31e4e85614$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $8df2de31e4e85614$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $8df2de31e4e85614$var$pj(a, b, c) {
    var d = b.pendingProps, e = $8df2de31e4e85614$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$M, e & 1);
    if (null === a) {
        $8df2de31e4e85614$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $8df2de31e4e85614$var$qj(g, d, 0, null), a = $8df2de31e4e85614$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $8df2de31e4e85614$var$oj(c), b.memoizedState = $8df2de31e4e85614$var$nj, a) : $8df2de31e4e85614$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $8df2de31e4e85614$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $8df2de31e4e85614$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $8df2de31e4e85614$var$wh(h, f) : (f = $8df2de31e4e85614$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $8df2de31e4e85614$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $8df2de31e4e85614$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $8df2de31e4e85614$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $8df2de31e4e85614$var$rj(a, b) {
    b = $8df2de31e4e85614$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $8df2de31e4e85614$var$tj(a, b, c, d) {
    null !== d && $8df2de31e4e85614$var$Jg(d);
    $8df2de31e4e85614$var$Bh(b, a.child, null, c);
    a = $8df2de31e4e85614$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $8df2de31e4e85614$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $8df2de31e4e85614$var$Li(Error($8df2de31e4e85614$var$p(422))), $8df2de31e4e85614$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $8df2de31e4e85614$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $8df2de31e4e85614$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $8df2de31e4e85614$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $8df2de31e4e85614$var$oj(g);
        b.memoizedState = $8df2de31e4e85614$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $8df2de31e4e85614$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($8df2de31e4e85614$var$p(419));
        d = $8df2de31e4e85614$var$Li(f, d, void 0);
        return $8df2de31e4e85614$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($8df2de31e4e85614$var$Ug || h) {
        d = $8df2de31e4e85614$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $8df2de31e4e85614$var$Zg(a, e), $8df2de31e4e85614$var$mh(d, a, e, -1));
        }
        $8df2de31e4e85614$var$uj();
        d = $8df2de31e4e85614$var$Li(Error($8df2de31e4e85614$var$p(421)));
        return $8df2de31e4e85614$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $8df2de31e4e85614$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $8df2de31e4e85614$var$yg = $8df2de31e4e85614$var$Lf(e.nextSibling);
    $8df2de31e4e85614$var$xg = b;
    $8df2de31e4e85614$var$I = !0;
    $8df2de31e4e85614$var$zg = null;
    null !== a && ($8df2de31e4e85614$var$og[$8df2de31e4e85614$var$pg++] = $8df2de31e4e85614$var$rg, $8df2de31e4e85614$var$og[$8df2de31e4e85614$var$pg++] = $8df2de31e4e85614$var$sg, $8df2de31e4e85614$var$og[$8df2de31e4e85614$var$pg++] = $8df2de31e4e85614$var$qg, $8df2de31e4e85614$var$rg = a.id, $8df2de31e4e85614$var$sg = a.overflow, $8df2de31e4e85614$var$qg = b);
    b = $8df2de31e4e85614$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $8df2de31e4e85614$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $8df2de31e4e85614$var$Sg(a.return, b, c);
}
function $8df2de31e4e85614$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $8df2de31e4e85614$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $8df2de31e4e85614$var$Yi(a, b, d.children, c);
    d = $8df2de31e4e85614$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $8df2de31e4e85614$var$wj(a, c, b);
            else if (19 === a.tag) $8df2de31e4e85614$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $8df2de31e4e85614$var$G($8df2de31e4e85614$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $8df2de31e4e85614$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $8df2de31e4e85614$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $8df2de31e4e85614$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $8df2de31e4e85614$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $8df2de31e4e85614$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $8df2de31e4e85614$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $8df2de31e4e85614$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $8df2de31e4e85614$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($8df2de31e4e85614$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $8df2de31e4e85614$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $8df2de31e4e85614$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $8df2de31e4e85614$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $8df2de31e4e85614$var$lj(b);
            $8df2de31e4e85614$var$Ig();
            break;
        case 5:
            $8df2de31e4e85614$var$Kh(b);
            break;
        case 1:
            $8df2de31e4e85614$var$Zf(b.type) && $8df2de31e4e85614$var$cg(b);
            break;
        case 4:
            $8df2de31e4e85614$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $8df2de31e4e85614$var$G($8df2de31e4e85614$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $8df2de31e4e85614$var$G($8df2de31e4e85614$var$M, $8df2de31e4e85614$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $8df2de31e4e85614$var$pj(a, b, c);
                $8df2de31e4e85614$var$G($8df2de31e4e85614$var$M, $8df2de31e4e85614$var$M.current & 1);
                a = $8df2de31e4e85614$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $8df2de31e4e85614$var$G($8df2de31e4e85614$var$M, $8df2de31e4e85614$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $8df2de31e4e85614$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $8df2de31e4e85614$var$G($8df2de31e4e85614$var$M, $8df2de31e4e85614$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $8df2de31e4e85614$var$ej(a, b, c);
    }
    return $8df2de31e4e85614$var$$i(a, b, c);
}
var $8df2de31e4e85614$var$Aj, $8df2de31e4e85614$var$Bj, $8df2de31e4e85614$var$Cj, $8df2de31e4e85614$var$Dj;
$8df2de31e4e85614$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$8df2de31e4e85614$var$Bj = function() {};
$8df2de31e4e85614$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $8df2de31e4e85614$var$Hh($8df2de31e4e85614$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $8df2de31e4e85614$var$Ya(a, e);
                d = $8df2de31e4e85614$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $8df2de31e4e85614$var$A({}, e, {
                    value: void 0
                });
                d = $8df2de31e4e85614$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $8df2de31e4e85614$var$gb(a, e);
                d = $8df2de31e4e85614$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $8df2de31e4e85614$var$Bf);
        }
        $8df2de31e4e85614$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($8df2de31e4e85614$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($8df2de31e4e85614$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $8df2de31e4e85614$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$8df2de31e4e85614$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $8df2de31e4e85614$var$Ej(a, b) {
    if (!$8df2de31e4e85614$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $8df2de31e4e85614$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $8df2de31e4e85614$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $8df2de31e4e85614$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8df2de31e4e85614$var$S(b), null;
        case 1:
            return $8df2de31e4e85614$var$Zf(b.type) && $8df2de31e4e85614$var$$f(), $8df2de31e4e85614$var$S(b), null;
        case 3:
            d = b.stateNode;
            $8df2de31e4e85614$var$Jh();
            $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Wf);
            $8df2de31e4e85614$var$E($8df2de31e4e85614$var$H);
            $8df2de31e4e85614$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $8df2de31e4e85614$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $8df2de31e4e85614$var$zg && ($8df2de31e4e85614$var$Gj($8df2de31e4e85614$var$zg), $8df2de31e4e85614$var$zg = null));
            $8df2de31e4e85614$var$Bj(a, b);
            $8df2de31e4e85614$var$S(b);
            return null;
        case 5:
            $8df2de31e4e85614$var$Lh(b);
            var e = $8df2de31e4e85614$var$Hh($8df2de31e4e85614$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $8df2de31e4e85614$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($8df2de31e4e85614$var$p(166));
                    $8df2de31e4e85614$var$S(b);
                    return null;
                }
                a = $8df2de31e4e85614$var$Hh($8df2de31e4e85614$var$Eh.current);
                if ($8df2de31e4e85614$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$8df2de31e4e85614$var$Of] = b;
                    d[$8df2de31e4e85614$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $8df2de31e4e85614$var$D("cancel", d);
                            $8df2de31e4e85614$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $8df2de31e4e85614$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $8df2de31e4e85614$var$lf.length; e++)$8df2de31e4e85614$var$D($8df2de31e4e85614$var$lf[e], d);
                            break;
                        case "source":
                            $8df2de31e4e85614$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $8df2de31e4e85614$var$D("error", d);
                            $8df2de31e4e85614$var$D("load", d);
                            break;
                        case "details":
                            $8df2de31e4e85614$var$D("toggle", d);
                            break;
                        case "input":
                            $8df2de31e4e85614$var$Za(d, f);
                            $8df2de31e4e85614$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $8df2de31e4e85614$var$D("invalid", d);
                            break;
                        case "textarea":
                            $8df2de31e4e85614$var$hb(d, f), $8df2de31e4e85614$var$D("invalid", d);
                    }
                    $8df2de31e4e85614$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $8df2de31e4e85614$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $8df2de31e4e85614$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $8df2de31e4e85614$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $8df2de31e4e85614$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $8df2de31e4e85614$var$Va(d);
                            $8df2de31e4e85614$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $8df2de31e4e85614$var$Va(d);
                            $8df2de31e4e85614$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $8df2de31e4e85614$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $8df2de31e4e85614$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$8df2de31e4e85614$var$Of] = b;
                    a[$8df2de31e4e85614$var$Pf] = d;
                    $8df2de31e4e85614$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $8df2de31e4e85614$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $8df2de31e4e85614$var$D("cancel", a);
                                $8df2de31e4e85614$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $8df2de31e4e85614$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $8df2de31e4e85614$var$lf.length; e++)$8df2de31e4e85614$var$D($8df2de31e4e85614$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $8df2de31e4e85614$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $8df2de31e4e85614$var$D("error", a);
                                $8df2de31e4e85614$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $8df2de31e4e85614$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $8df2de31e4e85614$var$Za(a, d);
                                e = $8df2de31e4e85614$var$Ya(a, d);
                                $8df2de31e4e85614$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $8df2de31e4e85614$var$A({}, d, {
                                    value: void 0
                                });
                                $8df2de31e4e85614$var$D("invalid", a);
                                break;
                            case "textarea":
                                $8df2de31e4e85614$var$hb(a, d);
                                e = $8df2de31e4e85614$var$gb(a, d);
                                $8df2de31e4e85614$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $8df2de31e4e85614$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $8df2de31e4e85614$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $8df2de31e4e85614$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $8df2de31e4e85614$var$ob(a, k) : "number" === typeof k && $8df2de31e4e85614$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($8df2de31e4e85614$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $8df2de31e4e85614$var$D("scroll", a) : null != k && $8df2de31e4e85614$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $8df2de31e4e85614$var$Va(a);
                                $8df2de31e4e85614$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $8df2de31e4e85614$var$Va(a);
                                $8df2de31e4e85614$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $8df2de31e4e85614$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $8df2de31e4e85614$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $8df2de31e4e85614$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $8df2de31e4e85614$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $8df2de31e4e85614$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $8df2de31e4e85614$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($8df2de31e4e85614$var$p(166));
                c = $8df2de31e4e85614$var$Hh($8df2de31e4e85614$var$Gh.current);
                $8df2de31e4e85614$var$Hh($8df2de31e4e85614$var$Eh.current);
                if ($8df2de31e4e85614$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$8df2de31e4e85614$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $8df2de31e4e85614$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $8df2de31e4e85614$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $8df2de31e4e85614$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$8df2de31e4e85614$var$Of] = b, b.stateNode = d;
            }
            $8df2de31e4e85614$var$S(b);
            return null;
        case 13:
            $8df2de31e4e85614$var$E($8df2de31e4e85614$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($8df2de31e4e85614$var$I && null !== $8df2de31e4e85614$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $8df2de31e4e85614$var$Hg(), $8df2de31e4e85614$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $8df2de31e4e85614$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($8df2de31e4e85614$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($8df2de31e4e85614$var$p(317));
                        f[$8df2de31e4e85614$var$Of] = b;
                    } else $8df2de31e4e85614$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $8df2de31e4e85614$var$S(b);
                    f = !1;
                } else null !== $8df2de31e4e85614$var$zg && ($8df2de31e4e85614$var$Gj($8df2de31e4e85614$var$zg), $8df2de31e4e85614$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($8df2de31e4e85614$var$M.current & 1) ? 0 === $8df2de31e4e85614$var$T && ($8df2de31e4e85614$var$T = 3) : $8df2de31e4e85614$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $8df2de31e4e85614$var$S(b);
            return null;
        case 4:
            return $8df2de31e4e85614$var$Jh(), $8df2de31e4e85614$var$Bj(a, b), null === a && $8df2de31e4e85614$var$sf(b.stateNode.containerInfo), $8df2de31e4e85614$var$S(b), null;
        case 10:
            return $8df2de31e4e85614$var$Rg(b.type._context), $8df2de31e4e85614$var$S(b), null;
        case 17:
            return $8df2de31e4e85614$var$Zf(b.type) && $8df2de31e4e85614$var$$f(), $8df2de31e4e85614$var$S(b), null;
        case 19:
            $8df2de31e4e85614$var$E($8df2de31e4e85614$var$M);
            f = b.memoizedState;
            if (null === f) return $8df2de31e4e85614$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $8df2de31e4e85614$var$Ej(f, !1);
                else {
                    if (0 !== $8df2de31e4e85614$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $8df2de31e4e85614$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $8df2de31e4e85614$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $8df2de31e4e85614$var$G($8df2de31e4e85614$var$M, $8df2de31e4e85614$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $8df2de31e4e85614$var$B() > $8df2de31e4e85614$var$Hj && (b.flags |= 128, d = !0, $8df2de31e4e85614$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $8df2de31e4e85614$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $8df2de31e4e85614$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$8df2de31e4e85614$var$I) return $8df2de31e4e85614$var$S(b), null;
                    } else 2 * $8df2de31e4e85614$var$B() - f.renderingStartTime > $8df2de31e4e85614$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $8df2de31e4e85614$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $8df2de31e4e85614$var$B(), b.sibling = null, c = $8df2de31e4e85614$var$M.current, $8df2de31e4e85614$var$G($8df2de31e4e85614$var$M, d ? c & 1 | 2 : c & 1), b;
            $8df2de31e4e85614$var$S(b);
            return null;
        case 22:
        case 23:
            return $8df2de31e4e85614$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($8df2de31e4e85614$var$gj & 1073741824) && ($8df2de31e4e85614$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $8df2de31e4e85614$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($8df2de31e4e85614$var$p(156, b.tag));
}
function $8df2de31e4e85614$var$Jj(a, b) {
    $8df2de31e4e85614$var$wg(b);
    switch(b.tag){
        case 1:
            return $8df2de31e4e85614$var$Zf(b.type) && $8df2de31e4e85614$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $8df2de31e4e85614$var$Jh(), $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Wf), $8df2de31e4e85614$var$E($8df2de31e4e85614$var$H), $8df2de31e4e85614$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $8df2de31e4e85614$var$Lh(b), null;
        case 13:
            $8df2de31e4e85614$var$E($8df2de31e4e85614$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($8df2de31e4e85614$var$p(340));
                $8df2de31e4e85614$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $8df2de31e4e85614$var$E($8df2de31e4e85614$var$M), null;
        case 4:
            return $8df2de31e4e85614$var$Jh(), null;
        case 10:
            return $8df2de31e4e85614$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $8df2de31e4e85614$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $8df2de31e4e85614$var$Kj = !1, $8df2de31e4e85614$var$U = !1, $8df2de31e4e85614$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $8df2de31e4e85614$var$V = null;
function $8df2de31e4e85614$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $8df2de31e4e85614$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $8df2de31e4e85614$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $8df2de31e4e85614$var$W(a, b, d);
    }
}
var $8df2de31e4e85614$var$Oj = !1;
function $8df2de31e4e85614$var$Pj(a, b) {
    $8df2de31e4e85614$var$Cf = $8df2de31e4e85614$var$dd;
    a = $8df2de31e4e85614$var$Me();
    if ($8df2de31e4e85614$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $8df2de31e4e85614$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $8df2de31e4e85614$var$dd = !1;
    for($8df2de31e4e85614$var$V = b; null !== $8df2de31e4e85614$var$V;)if (b = $8df2de31e4e85614$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $8df2de31e4e85614$var$V = a;
    else for(; null !== $8df2de31e4e85614$var$V;){
        b = $8df2de31e4e85614$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $8df2de31e4e85614$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($8df2de31e4e85614$var$p(163));
            }
        } catch (F) {
            $8df2de31e4e85614$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $8df2de31e4e85614$var$V = a;
            break;
        }
        $8df2de31e4e85614$var$V = b.return;
    }
    n = $8df2de31e4e85614$var$Oj;
    $8df2de31e4e85614$var$Oj = !1;
    return n;
}
function $8df2de31e4e85614$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $8df2de31e4e85614$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $8df2de31e4e85614$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $8df2de31e4e85614$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $8df2de31e4e85614$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $8df2de31e4e85614$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$8df2de31e4e85614$var$Of], delete b[$8df2de31e4e85614$var$Pf], delete b[$8df2de31e4e85614$var$of], delete b[$8df2de31e4e85614$var$Qf], delete b[$8df2de31e4e85614$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $8df2de31e4e85614$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $8df2de31e4e85614$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $8df2de31e4e85614$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $8df2de31e4e85614$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $8df2de31e4e85614$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($8df2de31e4e85614$var$Wj(a, b, c), a = a.sibling; null !== a;)$8df2de31e4e85614$var$Wj(a, b, c), a = a.sibling;
}
function $8df2de31e4e85614$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($8df2de31e4e85614$var$Xj(a, b, c), a = a.sibling; null !== a;)$8df2de31e4e85614$var$Xj(a, b, c), a = a.sibling;
}
var $8df2de31e4e85614$var$X = null, $8df2de31e4e85614$var$Yj = !1;
function $8df2de31e4e85614$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$8df2de31e4e85614$var$ak(a, b, c), c = c.sibling;
}
function $8df2de31e4e85614$var$ak(a, b, c) {
    if ($8df2de31e4e85614$var$lc && "function" === typeof $8df2de31e4e85614$var$lc.onCommitFiberUnmount) try {
        $8df2de31e4e85614$var$lc.onCommitFiberUnmount($8df2de31e4e85614$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $8df2de31e4e85614$var$U || $8df2de31e4e85614$var$Mj(c, b);
        case 6:
            var d = $8df2de31e4e85614$var$X, e = $8df2de31e4e85614$var$Yj;
            $8df2de31e4e85614$var$X = null;
            $8df2de31e4e85614$var$Zj(a, b, c);
            $8df2de31e4e85614$var$X = d;
            $8df2de31e4e85614$var$Yj = e;
            null !== $8df2de31e4e85614$var$X && ($8df2de31e4e85614$var$Yj ? (a = $8df2de31e4e85614$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $8df2de31e4e85614$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $8df2de31e4e85614$var$X && ($8df2de31e4e85614$var$Yj ? (a = $8df2de31e4e85614$var$X, c = c.stateNode, 8 === a.nodeType ? $8df2de31e4e85614$var$Kf(a.parentNode, c) : 1 === a.nodeType && $8df2de31e4e85614$var$Kf(a, c), $8df2de31e4e85614$var$bd(a)) : $8df2de31e4e85614$var$Kf($8df2de31e4e85614$var$X, c.stateNode));
            break;
        case 4:
            d = $8df2de31e4e85614$var$X;
            e = $8df2de31e4e85614$var$Yj;
            $8df2de31e4e85614$var$X = c.stateNode.containerInfo;
            $8df2de31e4e85614$var$Yj = !0;
            $8df2de31e4e85614$var$Zj(a, b, c);
            $8df2de31e4e85614$var$X = d;
            $8df2de31e4e85614$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$8df2de31e4e85614$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $8df2de31e4e85614$var$Nj(c, b, g) : 0 !== (f & 4) && $8df2de31e4e85614$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $8df2de31e4e85614$var$Zj(a, b, c);
            break;
        case 1:
            if (!$8df2de31e4e85614$var$U && ($8df2de31e4e85614$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $8df2de31e4e85614$var$W(c, b, h);
            }
            $8df2de31e4e85614$var$Zj(a, b, c);
            break;
        case 21:
            $8df2de31e4e85614$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($8df2de31e4e85614$var$U = (d = $8df2de31e4e85614$var$U) || null !== c.memoizedState, $8df2de31e4e85614$var$Zj(a, b, c), $8df2de31e4e85614$var$U = d) : $8df2de31e4e85614$var$Zj(a, b, c);
            break;
        default:
            $8df2de31e4e85614$var$Zj(a, b, c);
    }
}
function $8df2de31e4e85614$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $8df2de31e4e85614$var$Lj);
        b.forEach(function(b) {
            var d = $8df2de31e4e85614$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $8df2de31e4e85614$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $8df2de31e4e85614$var$X = h.stateNode;
                        $8df2de31e4e85614$var$Yj = !1;
                        break a;
                    case 3:
                        $8df2de31e4e85614$var$X = h.stateNode.containerInfo;
                        $8df2de31e4e85614$var$Yj = !0;
                        break a;
                    case 4:
                        $8df2de31e4e85614$var$X = h.stateNode.containerInfo;
                        $8df2de31e4e85614$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $8df2de31e4e85614$var$X) throw Error($8df2de31e4e85614$var$p(160));
            $8df2de31e4e85614$var$ak(f, g, e);
            $8df2de31e4e85614$var$X = null;
            $8df2de31e4e85614$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $8df2de31e4e85614$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$8df2de31e4e85614$var$ek(b, a), b = b.sibling;
}
function $8df2de31e4e85614$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $8df2de31e4e85614$var$dk(b, a);
            $8df2de31e4e85614$var$fk(a);
            if (d & 4) {
                try {
                    $8df2de31e4e85614$var$Qj(3, a, a.return), $8df2de31e4e85614$var$Rj(3, a);
                } catch (t) {
                    $8df2de31e4e85614$var$W(a, a.return, t);
                }
                try {
                    $8df2de31e4e85614$var$Qj(5, a, a.return);
                } catch (t) {
                    $8df2de31e4e85614$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $8df2de31e4e85614$var$dk(b, a);
            $8df2de31e4e85614$var$fk(a);
            d & 512 && null !== c && $8df2de31e4e85614$var$Mj(c, c.return);
            break;
        case 5:
            $8df2de31e4e85614$var$dk(b, a);
            $8df2de31e4e85614$var$fk(a);
            d & 512 && null !== c && $8df2de31e4e85614$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $8df2de31e4e85614$var$ob(e, "");
                } catch (t) {
                    $8df2de31e4e85614$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $8df2de31e4e85614$var$ab(e, f);
                    $8df2de31e4e85614$var$vb(h, g);
                    var l = $8df2de31e4e85614$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $8df2de31e4e85614$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $8df2de31e4e85614$var$nb(e, q) : "children" === m ? $8df2de31e4e85614$var$ob(e, q) : $8df2de31e4e85614$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $8df2de31e4e85614$var$bb(e, f);
                            break;
                        case "textarea":
                            $8df2de31e4e85614$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $8df2de31e4e85614$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $8df2de31e4e85614$var$fb(e, !!f.multiple, f.defaultValue, !0) : $8df2de31e4e85614$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$8df2de31e4e85614$var$Pf] = f;
                } catch (t) {
                    $8df2de31e4e85614$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $8df2de31e4e85614$var$dk(b, a);
            $8df2de31e4e85614$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($8df2de31e4e85614$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $8df2de31e4e85614$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $8df2de31e4e85614$var$dk(b, a);
            $8df2de31e4e85614$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $8df2de31e4e85614$var$bd(b.containerInfo);
            } catch (t) {
                $8df2de31e4e85614$var$W(a, a.return, t);
            }
            break;
        case 4:
            $8df2de31e4e85614$var$dk(b, a);
            $8df2de31e4e85614$var$fk(a);
            break;
        case 13:
            $8df2de31e4e85614$var$dk(b, a);
            $8df2de31e4e85614$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($8df2de31e4e85614$var$gk = $8df2de31e4e85614$var$B()));
            d & 4 && $8df2de31e4e85614$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($8df2de31e4e85614$var$U = (l = $8df2de31e4e85614$var$U) || m, $8df2de31e4e85614$var$dk(b, a), $8df2de31e4e85614$var$U = l) : $8df2de31e4e85614$var$dk(b, a);
            $8df2de31e4e85614$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($8df2de31e4e85614$var$V = a, m = a.child; null !== m;){
                    for(q = $8df2de31e4e85614$var$V = m; null !== $8df2de31e4e85614$var$V;){
                        r = $8df2de31e4e85614$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $8df2de31e4e85614$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $8df2de31e4e85614$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $8df2de31e4e85614$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $8df2de31e4e85614$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $8df2de31e4e85614$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $8df2de31e4e85614$var$V = y) : $8df2de31e4e85614$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $8df2de31e4e85614$var$rb("display", g));
                            } catch (t) {
                                $8df2de31e4e85614$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $8df2de31e4e85614$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $8df2de31e4e85614$var$dk(b, a);
            $8df2de31e4e85614$var$fk(a);
            d & 4 && $8df2de31e4e85614$var$bk(a);
            break;
        case 21:
            break;
        default:
            $8df2de31e4e85614$var$dk(b, a), $8df2de31e4e85614$var$fk(a);
    }
}
function $8df2de31e4e85614$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($8df2de31e4e85614$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($8df2de31e4e85614$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($8df2de31e4e85614$var$ob(e, ""), d.flags &= -33);
                    var f = $8df2de31e4e85614$var$Vj(a);
                    $8df2de31e4e85614$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $8df2de31e4e85614$var$Vj(a);
                    $8df2de31e4e85614$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($8df2de31e4e85614$var$p(161));
            }
        } catch (k) {
            $8df2de31e4e85614$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $8df2de31e4e85614$var$ik(a, b, c) {
    $8df2de31e4e85614$var$V = a;
    $8df2de31e4e85614$var$jk(a, b, c);
}
function $8df2de31e4e85614$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $8df2de31e4e85614$var$V;){
        var e = $8df2de31e4e85614$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $8df2de31e4e85614$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $8df2de31e4e85614$var$U;
                h = $8df2de31e4e85614$var$Kj;
                var l = $8df2de31e4e85614$var$U;
                $8df2de31e4e85614$var$Kj = g;
                if (($8df2de31e4e85614$var$U = k) && !l) for($8df2de31e4e85614$var$V = e; null !== $8df2de31e4e85614$var$V;)g = $8df2de31e4e85614$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $8df2de31e4e85614$var$kk(e) : null !== k ? (k.return = g, $8df2de31e4e85614$var$V = k) : $8df2de31e4e85614$var$kk(e);
                for(; null !== f;)$8df2de31e4e85614$var$V = f, $8df2de31e4e85614$var$jk(f, b, c), f = f.sibling;
                $8df2de31e4e85614$var$V = e;
                $8df2de31e4e85614$var$Kj = h;
                $8df2de31e4e85614$var$U = l;
            }
            $8df2de31e4e85614$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $8df2de31e4e85614$var$V = f) : $8df2de31e4e85614$var$lk(a, b, c);
    }
}
function $8df2de31e4e85614$var$lk(a) {
    for(; null !== $8df2de31e4e85614$var$V;){
        var b = $8df2de31e4e85614$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $8df2de31e4e85614$var$U || $8df2de31e4e85614$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$8df2de31e4e85614$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $8df2de31e4e85614$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $8df2de31e4e85614$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $8df2de31e4e85614$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $8df2de31e4e85614$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($8df2de31e4e85614$var$p(163));
                }
                $8df2de31e4e85614$var$U || b.flags & 512 && $8df2de31e4e85614$var$Sj(b);
            } catch (r) {
                $8df2de31e4e85614$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $8df2de31e4e85614$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8df2de31e4e85614$var$V = c;
            break;
        }
        $8df2de31e4e85614$var$V = b.return;
    }
}
function $8df2de31e4e85614$var$hk(a) {
    for(; null !== $8df2de31e4e85614$var$V;){
        var b = $8df2de31e4e85614$var$V;
        if (b === a) {
            $8df2de31e4e85614$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $8df2de31e4e85614$var$V = c;
            break;
        }
        $8df2de31e4e85614$var$V = b.return;
    }
}
function $8df2de31e4e85614$var$kk(a) {
    for(; null !== $8df2de31e4e85614$var$V;){
        var b = $8df2de31e4e85614$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $8df2de31e4e85614$var$Rj(4, b);
                    } catch (k) {
                        $8df2de31e4e85614$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $8df2de31e4e85614$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $8df2de31e4e85614$var$Sj(b);
                    } catch (k) {
                        $8df2de31e4e85614$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $8df2de31e4e85614$var$Sj(b);
                    } catch (k) {
                        $8df2de31e4e85614$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $8df2de31e4e85614$var$W(b, b.return, k);
        }
        if (b === a) {
            $8df2de31e4e85614$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $8df2de31e4e85614$var$V = h;
            break;
        }
        $8df2de31e4e85614$var$V = b.return;
    }
}
var $8df2de31e4e85614$var$mk = Math.ceil, $8df2de31e4e85614$var$nk = $8df2de31e4e85614$var$ua.ReactCurrentDispatcher, $8df2de31e4e85614$var$ok = $8df2de31e4e85614$var$ua.ReactCurrentOwner, $8df2de31e4e85614$var$pk = $8df2de31e4e85614$var$ua.ReactCurrentBatchConfig, $8df2de31e4e85614$var$K = 0, $8df2de31e4e85614$var$R = null, $8df2de31e4e85614$var$Y = null, $8df2de31e4e85614$var$Z = 0, $8df2de31e4e85614$var$gj = 0, $8df2de31e4e85614$var$fj = $8df2de31e4e85614$var$Uf(0), $8df2de31e4e85614$var$T = 0, $8df2de31e4e85614$var$qk = null, $8df2de31e4e85614$var$hh = 0, $8df2de31e4e85614$var$rk = 0, $8df2de31e4e85614$var$sk = 0, $8df2de31e4e85614$var$tk = null, $8df2de31e4e85614$var$uk = null, $8df2de31e4e85614$var$gk = 0, $8df2de31e4e85614$var$Hj = Infinity, $8df2de31e4e85614$var$vk = null, $8df2de31e4e85614$var$Pi = !1, $8df2de31e4e85614$var$Qi = null, $8df2de31e4e85614$var$Si = null, $8df2de31e4e85614$var$wk = !1, $8df2de31e4e85614$var$xk = null, $8df2de31e4e85614$var$yk = 0, $8df2de31e4e85614$var$zk = 0, $8df2de31e4e85614$var$Ak = null, $8df2de31e4e85614$var$Bk = -1, $8df2de31e4e85614$var$Ck = 0;
function $8df2de31e4e85614$var$L() {
    return 0 !== ($8df2de31e4e85614$var$K & 6) ? $8df2de31e4e85614$var$B() : -1 !== $8df2de31e4e85614$var$Bk ? $8df2de31e4e85614$var$Bk : $8df2de31e4e85614$var$Bk = $8df2de31e4e85614$var$B();
}
function $8df2de31e4e85614$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($8df2de31e4e85614$var$K & 2) && 0 !== $8df2de31e4e85614$var$Z) return $8df2de31e4e85614$var$Z & -$8df2de31e4e85614$var$Z;
    if (null !== $8df2de31e4e85614$var$Kg.transition) return 0 === $8df2de31e4e85614$var$Ck && ($8df2de31e4e85614$var$Ck = $8df2de31e4e85614$var$yc()), $8df2de31e4e85614$var$Ck;
    a = $8df2de31e4e85614$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $8df2de31e4e85614$var$jd(a.type);
    return a;
}
function $8df2de31e4e85614$var$mh(a, b, c, d) {
    if (50 < $8df2de31e4e85614$var$zk) throw $8df2de31e4e85614$var$zk = 0, $8df2de31e4e85614$var$Ak = null, Error($8df2de31e4e85614$var$p(185));
    $8df2de31e4e85614$var$Ac(a, c, d);
    if (0 === ($8df2de31e4e85614$var$K & 2) || a !== $8df2de31e4e85614$var$R) a === $8df2de31e4e85614$var$R && (0 === ($8df2de31e4e85614$var$K & 2) && ($8df2de31e4e85614$var$rk |= c), 4 === $8df2de31e4e85614$var$T && $8df2de31e4e85614$var$Dk(a, $8df2de31e4e85614$var$Z)), $8df2de31e4e85614$var$Ek(a, d), 1 === c && 0 === $8df2de31e4e85614$var$K && 0 === (b.mode & 1) && ($8df2de31e4e85614$var$Hj = $8df2de31e4e85614$var$B() + 500, $8df2de31e4e85614$var$fg && $8df2de31e4e85614$var$jg());
}
function $8df2de31e4e85614$var$Ek(a, b) {
    var c = a.callbackNode;
    $8df2de31e4e85614$var$wc(a, b);
    var d = $8df2de31e4e85614$var$uc(a, a === $8df2de31e4e85614$var$R ? $8df2de31e4e85614$var$Z : 0);
    if (0 === d) null !== c && $8df2de31e4e85614$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $8df2de31e4e85614$var$bc(c);
        if (1 === b) 0 === a.tag ? $8df2de31e4e85614$var$ig($8df2de31e4e85614$var$Fk.bind(null, a)) : $8df2de31e4e85614$var$hg($8df2de31e4e85614$var$Fk.bind(null, a)), $8df2de31e4e85614$var$Jf(function() {
            0 === ($8df2de31e4e85614$var$K & 6) && $8df2de31e4e85614$var$jg();
        }), c = null;
        else {
            switch($8df2de31e4e85614$var$Dc(d)){
                case 1:
                    c = $8df2de31e4e85614$var$fc;
                    break;
                case 4:
                    c = $8df2de31e4e85614$var$gc;
                    break;
                case 16:
                    c = $8df2de31e4e85614$var$hc;
                    break;
                case 536870912:
                    c = $8df2de31e4e85614$var$jc;
                    break;
                default:
                    c = $8df2de31e4e85614$var$hc;
            }
            c = $8df2de31e4e85614$var$Gk(c, $8df2de31e4e85614$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $8df2de31e4e85614$var$Hk(a, b) {
    $8df2de31e4e85614$var$Bk = -1;
    $8df2de31e4e85614$var$Ck = 0;
    if (0 !== ($8df2de31e4e85614$var$K & 6)) throw Error($8df2de31e4e85614$var$p(327));
    var c = a.callbackNode;
    if ($8df2de31e4e85614$var$Ik() && a.callbackNode !== c) return null;
    var d = $8df2de31e4e85614$var$uc(a, a === $8df2de31e4e85614$var$R ? $8df2de31e4e85614$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $8df2de31e4e85614$var$Jk(a, d);
    else {
        b = d;
        var e = $8df2de31e4e85614$var$K;
        $8df2de31e4e85614$var$K |= 2;
        var f = $8df2de31e4e85614$var$Kk();
        if ($8df2de31e4e85614$var$R !== a || $8df2de31e4e85614$var$Z !== b) $8df2de31e4e85614$var$vk = null, $8df2de31e4e85614$var$Hj = $8df2de31e4e85614$var$B() + 500, $8df2de31e4e85614$var$Lk(a, b);
        for(;;)try {
            $8df2de31e4e85614$var$Mk();
            break;
        } catch (h) {
            $8df2de31e4e85614$var$Nk(a, h);
        }
        $8df2de31e4e85614$var$Qg();
        $8df2de31e4e85614$var$nk.current = f;
        $8df2de31e4e85614$var$K = e;
        null !== $8df2de31e4e85614$var$Y ? b = 0 : ($8df2de31e4e85614$var$R = null, $8df2de31e4e85614$var$Z = 0, b = $8df2de31e4e85614$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $8df2de31e4e85614$var$xc(a), 0 !== e && (d = e, b = $8df2de31e4e85614$var$Ok(a, e)));
        if (1 === b) throw c = $8df2de31e4e85614$var$qk, $8df2de31e4e85614$var$Lk(a, 0), $8df2de31e4e85614$var$Dk(a, d), $8df2de31e4e85614$var$Ek(a, $8df2de31e4e85614$var$B()), c;
        if (6 === b) $8df2de31e4e85614$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$8df2de31e4e85614$var$Pk(e) && (b = $8df2de31e4e85614$var$Jk(a, d), 2 === b && (f = $8df2de31e4e85614$var$xc(a), 0 !== f && (d = f, b = $8df2de31e4e85614$var$Ok(a, f))), 1 === b)) throw c = $8df2de31e4e85614$var$qk, $8df2de31e4e85614$var$Lk(a, 0), $8df2de31e4e85614$var$Dk(a, d), $8df2de31e4e85614$var$Ek(a, $8df2de31e4e85614$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($8df2de31e4e85614$var$p(345));
                case 2:
                    $8df2de31e4e85614$var$Qk(a, $8df2de31e4e85614$var$uk, $8df2de31e4e85614$var$vk);
                    break;
                case 3:
                    $8df2de31e4e85614$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $8df2de31e4e85614$var$gk + 500 - $8df2de31e4e85614$var$B(), 10 < b)) {
                        if (0 !== $8df2de31e4e85614$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $8df2de31e4e85614$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $8df2de31e4e85614$var$Ff($8df2de31e4e85614$var$Qk.bind(null, a, $8df2de31e4e85614$var$uk, $8df2de31e4e85614$var$vk), b);
                        break;
                    }
                    $8df2de31e4e85614$var$Qk(a, $8df2de31e4e85614$var$uk, $8df2de31e4e85614$var$vk);
                    break;
                case 4:
                    $8df2de31e4e85614$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $8df2de31e4e85614$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $8df2de31e4e85614$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $8df2de31e4e85614$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $8df2de31e4e85614$var$Ff($8df2de31e4e85614$var$Qk.bind(null, a, $8df2de31e4e85614$var$uk, $8df2de31e4e85614$var$vk), d);
                        break;
                    }
                    $8df2de31e4e85614$var$Qk(a, $8df2de31e4e85614$var$uk, $8df2de31e4e85614$var$vk);
                    break;
                case 5:
                    $8df2de31e4e85614$var$Qk(a, $8df2de31e4e85614$var$uk, $8df2de31e4e85614$var$vk);
                    break;
                default:
                    throw Error($8df2de31e4e85614$var$p(329));
            }
        }
    }
    $8df2de31e4e85614$var$Ek(a, $8df2de31e4e85614$var$B());
    return a.callbackNode === c ? $8df2de31e4e85614$var$Hk.bind(null, a) : null;
}
function $8df2de31e4e85614$var$Ok(a, b) {
    var c = $8df2de31e4e85614$var$tk;
    a.current.memoizedState.isDehydrated && ($8df2de31e4e85614$var$Lk(a, b).flags |= 256);
    a = $8df2de31e4e85614$var$Jk(a, b);
    2 !== a && (b = $8df2de31e4e85614$var$uk, $8df2de31e4e85614$var$uk = c, null !== b && $8df2de31e4e85614$var$Gj(b));
    return a;
}
function $8df2de31e4e85614$var$Gj(a) {
    null === $8df2de31e4e85614$var$uk ? $8df2de31e4e85614$var$uk = a : $8df2de31e4e85614$var$uk.push.apply($8df2de31e4e85614$var$uk, a);
}
function $8df2de31e4e85614$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$8df2de31e4e85614$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $8df2de31e4e85614$var$Dk(a, b) {
    b &= ~$8df2de31e4e85614$var$sk;
    b &= ~$8df2de31e4e85614$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $8df2de31e4e85614$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $8df2de31e4e85614$var$Fk(a) {
    if (0 !== ($8df2de31e4e85614$var$K & 6)) throw Error($8df2de31e4e85614$var$p(327));
    $8df2de31e4e85614$var$Ik();
    var b = $8df2de31e4e85614$var$uc(a, 0);
    if (0 === (b & 1)) return $8df2de31e4e85614$var$Ek(a, $8df2de31e4e85614$var$B()), null;
    var c = $8df2de31e4e85614$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $8df2de31e4e85614$var$xc(a);
        0 !== d && (b = d, c = $8df2de31e4e85614$var$Ok(a, d));
    }
    if (1 === c) throw c = $8df2de31e4e85614$var$qk, $8df2de31e4e85614$var$Lk(a, 0), $8df2de31e4e85614$var$Dk(a, b), $8df2de31e4e85614$var$Ek(a, $8df2de31e4e85614$var$B()), c;
    if (6 === c) throw Error($8df2de31e4e85614$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $8df2de31e4e85614$var$Qk(a, $8df2de31e4e85614$var$uk, $8df2de31e4e85614$var$vk);
    $8df2de31e4e85614$var$Ek(a, $8df2de31e4e85614$var$B());
    return null;
}
function $8df2de31e4e85614$var$Rk(a, b) {
    var c = $8df2de31e4e85614$var$K;
    $8df2de31e4e85614$var$K |= 1;
    try {
        return a(b);
    } finally{
        $8df2de31e4e85614$var$K = c, 0 === $8df2de31e4e85614$var$K && ($8df2de31e4e85614$var$Hj = $8df2de31e4e85614$var$B() + 500, $8df2de31e4e85614$var$fg && $8df2de31e4e85614$var$jg());
    }
}
function $8df2de31e4e85614$var$Sk(a) {
    null !== $8df2de31e4e85614$var$xk && 0 === $8df2de31e4e85614$var$xk.tag && 0 === ($8df2de31e4e85614$var$K & 6) && $8df2de31e4e85614$var$Ik();
    var b = $8df2de31e4e85614$var$K;
    $8df2de31e4e85614$var$K |= 1;
    var c = $8df2de31e4e85614$var$pk.transition, d = $8df2de31e4e85614$var$C;
    try {
        if ($8df2de31e4e85614$var$pk.transition = null, $8df2de31e4e85614$var$C = 1, a) return a();
    } finally{
        $8df2de31e4e85614$var$C = d, $8df2de31e4e85614$var$pk.transition = c, $8df2de31e4e85614$var$K = b, 0 === ($8df2de31e4e85614$var$K & 6) && $8df2de31e4e85614$var$jg();
    }
}
function $8df2de31e4e85614$var$Ij() {
    $8df2de31e4e85614$var$gj = $8df2de31e4e85614$var$fj.current;
    $8df2de31e4e85614$var$E($8df2de31e4e85614$var$fj);
}
function $8df2de31e4e85614$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $8df2de31e4e85614$var$Gf(c));
    if (null !== $8df2de31e4e85614$var$Y) for(c = $8df2de31e4e85614$var$Y.return; null !== c;){
        var d = c;
        $8df2de31e4e85614$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $8df2de31e4e85614$var$$f();
                break;
            case 3:
                $8df2de31e4e85614$var$Jh();
                $8df2de31e4e85614$var$E($8df2de31e4e85614$var$Wf);
                $8df2de31e4e85614$var$E($8df2de31e4e85614$var$H);
                $8df2de31e4e85614$var$Oh();
                break;
            case 5:
                $8df2de31e4e85614$var$Lh(d);
                break;
            case 4:
                $8df2de31e4e85614$var$Jh();
                break;
            case 13:
                $8df2de31e4e85614$var$E($8df2de31e4e85614$var$M);
                break;
            case 19:
                $8df2de31e4e85614$var$E($8df2de31e4e85614$var$M);
                break;
            case 10:
                $8df2de31e4e85614$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $8df2de31e4e85614$var$Ij();
        }
        c = c.return;
    }
    $8df2de31e4e85614$var$R = a;
    $8df2de31e4e85614$var$Y = a = $8df2de31e4e85614$var$wh(a.current, null);
    $8df2de31e4e85614$var$Z = $8df2de31e4e85614$var$gj = b;
    $8df2de31e4e85614$var$T = 0;
    $8df2de31e4e85614$var$qk = null;
    $8df2de31e4e85614$var$sk = $8df2de31e4e85614$var$rk = $8df2de31e4e85614$var$hh = 0;
    $8df2de31e4e85614$var$uk = $8df2de31e4e85614$var$tk = null;
    if (null !== $8df2de31e4e85614$var$Wg) {
        for(b = 0; b < $8df2de31e4e85614$var$Wg.length; b++)if (c = $8df2de31e4e85614$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $8df2de31e4e85614$var$Wg = null;
    }
    return a;
}
function $8df2de31e4e85614$var$Nk(a, b) {
    do {
        var c = $8df2de31e4e85614$var$Y;
        try {
            $8df2de31e4e85614$var$Qg();
            $8df2de31e4e85614$var$Ph.current = $8df2de31e4e85614$var$ai;
            if ($8df2de31e4e85614$var$Sh) {
                for(var d = $8df2de31e4e85614$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $8df2de31e4e85614$var$Sh = !1;
            }
            $8df2de31e4e85614$var$Rh = 0;
            $8df2de31e4e85614$var$P = $8df2de31e4e85614$var$O = $8df2de31e4e85614$var$N = null;
            $8df2de31e4e85614$var$Th = !1;
            $8df2de31e4e85614$var$Uh = 0;
            $8df2de31e4e85614$var$ok.current = null;
            if (null === c || null === c.return) {
                $8df2de31e4e85614$var$T = 1;
                $8df2de31e4e85614$var$qk = b;
                $8df2de31e4e85614$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $8df2de31e4e85614$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $8df2de31e4e85614$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $8df2de31e4e85614$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $8df2de31e4e85614$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $8df2de31e4e85614$var$Ti(f, l, b);
                            $8df2de31e4e85614$var$uj();
                            break a;
                        }
                        k = Error($8df2de31e4e85614$var$p(426));
                    }
                } else if ($8df2de31e4e85614$var$I && h.mode & 1) {
                    var J = $8df2de31e4e85614$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $8df2de31e4e85614$var$Wi(J, g, h, f, b);
                        $8df2de31e4e85614$var$Jg($8df2de31e4e85614$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $8df2de31e4e85614$var$Ki(k, h);
                4 !== $8df2de31e4e85614$var$T && ($8df2de31e4e85614$var$T = 2);
                null === $8df2de31e4e85614$var$tk ? $8df2de31e4e85614$var$tk = [
                    f
                ] : $8df2de31e4e85614$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $8df2de31e4e85614$var$Oi(f, k, b);
                            $8df2de31e4e85614$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $8df2de31e4e85614$var$Si || !$8df2de31e4e85614$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $8df2de31e4e85614$var$Ri(f, h, b);
                                $8df2de31e4e85614$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $8df2de31e4e85614$var$Tk(c);
        } catch (na) {
            b = na;
            $8df2de31e4e85614$var$Y === c && null !== c && ($8df2de31e4e85614$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $8df2de31e4e85614$var$Kk() {
    var a = $8df2de31e4e85614$var$nk.current;
    $8df2de31e4e85614$var$nk.current = $8df2de31e4e85614$var$ai;
    return null === a ? $8df2de31e4e85614$var$ai : a;
}
function $8df2de31e4e85614$var$uj() {
    if (0 === $8df2de31e4e85614$var$T || 3 === $8df2de31e4e85614$var$T || 2 === $8df2de31e4e85614$var$T) $8df2de31e4e85614$var$T = 4;
    null === $8df2de31e4e85614$var$R || 0 === ($8df2de31e4e85614$var$hh & 268435455) && 0 === ($8df2de31e4e85614$var$rk & 268435455) || $8df2de31e4e85614$var$Dk($8df2de31e4e85614$var$R, $8df2de31e4e85614$var$Z);
}
function $8df2de31e4e85614$var$Jk(a, b) {
    var c = $8df2de31e4e85614$var$K;
    $8df2de31e4e85614$var$K |= 2;
    var d = $8df2de31e4e85614$var$Kk();
    if ($8df2de31e4e85614$var$R !== a || $8df2de31e4e85614$var$Z !== b) $8df2de31e4e85614$var$vk = null, $8df2de31e4e85614$var$Lk(a, b);
    for(;;)try {
        $8df2de31e4e85614$var$Uk();
        break;
    } catch (e) {
        $8df2de31e4e85614$var$Nk(a, e);
    }
    $8df2de31e4e85614$var$Qg();
    $8df2de31e4e85614$var$K = c;
    $8df2de31e4e85614$var$nk.current = d;
    if (null !== $8df2de31e4e85614$var$Y) throw Error($8df2de31e4e85614$var$p(261));
    $8df2de31e4e85614$var$R = null;
    $8df2de31e4e85614$var$Z = 0;
    return $8df2de31e4e85614$var$T;
}
function $8df2de31e4e85614$var$Uk() {
    for(; null !== $8df2de31e4e85614$var$Y;)$8df2de31e4e85614$var$Vk($8df2de31e4e85614$var$Y);
}
function $8df2de31e4e85614$var$Mk() {
    for(; null !== $8df2de31e4e85614$var$Y && !$8df2de31e4e85614$var$cc();)$8df2de31e4e85614$var$Vk($8df2de31e4e85614$var$Y);
}
function $8df2de31e4e85614$var$Vk(a) {
    var b = $8df2de31e4e85614$var$Wk(a.alternate, a, $8df2de31e4e85614$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $8df2de31e4e85614$var$Tk(a) : $8df2de31e4e85614$var$Y = b;
    $8df2de31e4e85614$var$ok.current = null;
}
function $8df2de31e4e85614$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $8df2de31e4e85614$var$Fj(c, b, $8df2de31e4e85614$var$gj), null !== c) {
                $8df2de31e4e85614$var$Y = c;
                return;
            }
        } else {
            c = $8df2de31e4e85614$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $8df2de31e4e85614$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $8df2de31e4e85614$var$T = 6;
                $8df2de31e4e85614$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $8df2de31e4e85614$var$Y = b;
            return;
        }
        $8df2de31e4e85614$var$Y = b = a;
    }while (null !== b);
    0 === $8df2de31e4e85614$var$T && ($8df2de31e4e85614$var$T = 5);
}
function $8df2de31e4e85614$var$Qk(a, b, c) {
    var d = $8df2de31e4e85614$var$C, e = $8df2de31e4e85614$var$pk.transition;
    try {
        $8df2de31e4e85614$var$pk.transition = null, $8df2de31e4e85614$var$C = 1, $8df2de31e4e85614$var$Xk(a, b, c, d);
    } finally{
        $8df2de31e4e85614$var$pk.transition = e, $8df2de31e4e85614$var$C = d;
    }
    return null;
}
function $8df2de31e4e85614$var$Xk(a, b, c, d) {
    do $8df2de31e4e85614$var$Ik();
    while (null !== $8df2de31e4e85614$var$xk);
    if (0 !== ($8df2de31e4e85614$var$K & 6)) throw Error($8df2de31e4e85614$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($8df2de31e4e85614$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $8df2de31e4e85614$var$Bc(a, f);
    a === $8df2de31e4e85614$var$R && ($8df2de31e4e85614$var$Y = $8df2de31e4e85614$var$R = null, $8df2de31e4e85614$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $8df2de31e4e85614$var$wk || ($8df2de31e4e85614$var$wk = !0, $8df2de31e4e85614$var$Gk($8df2de31e4e85614$var$hc, function() {
        $8df2de31e4e85614$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $8df2de31e4e85614$var$pk.transition;
        $8df2de31e4e85614$var$pk.transition = null;
        var g = $8df2de31e4e85614$var$C;
        $8df2de31e4e85614$var$C = 1;
        var h = $8df2de31e4e85614$var$K;
        $8df2de31e4e85614$var$K |= 4;
        $8df2de31e4e85614$var$ok.current = null;
        $8df2de31e4e85614$var$Pj(a, c);
        $8df2de31e4e85614$var$ek(c, a);
        $8df2de31e4e85614$var$Oe($8df2de31e4e85614$var$Df);
        $8df2de31e4e85614$var$dd = !!$8df2de31e4e85614$var$Cf;
        $8df2de31e4e85614$var$Df = $8df2de31e4e85614$var$Cf = null;
        a.current = c;
        $8df2de31e4e85614$var$ik(c, a, e);
        $8df2de31e4e85614$var$dc();
        $8df2de31e4e85614$var$K = h;
        $8df2de31e4e85614$var$C = g;
        $8df2de31e4e85614$var$pk.transition = f;
    } else a.current = c;
    $8df2de31e4e85614$var$wk && ($8df2de31e4e85614$var$wk = !1, $8df2de31e4e85614$var$xk = a, $8df2de31e4e85614$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($8df2de31e4e85614$var$Si = null);
    $8df2de31e4e85614$var$mc(c.stateNode, d);
    $8df2de31e4e85614$var$Ek(a, $8df2de31e4e85614$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($8df2de31e4e85614$var$Pi) throw $8df2de31e4e85614$var$Pi = !1, a = $8df2de31e4e85614$var$Qi, $8df2de31e4e85614$var$Qi = null, a;
    0 !== ($8df2de31e4e85614$var$yk & 1) && 0 !== a.tag && $8df2de31e4e85614$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $8df2de31e4e85614$var$Ak ? $8df2de31e4e85614$var$zk++ : ($8df2de31e4e85614$var$zk = 0, $8df2de31e4e85614$var$Ak = a) : $8df2de31e4e85614$var$zk = 0;
    $8df2de31e4e85614$var$jg();
    return null;
}
function $8df2de31e4e85614$var$Ik() {
    if (null !== $8df2de31e4e85614$var$xk) {
        var a = $8df2de31e4e85614$var$Dc($8df2de31e4e85614$var$yk), b = $8df2de31e4e85614$var$pk.transition, c = $8df2de31e4e85614$var$C;
        try {
            $8df2de31e4e85614$var$pk.transition = null;
            $8df2de31e4e85614$var$C = 16 > a ? 16 : a;
            if (null === $8df2de31e4e85614$var$xk) var d = !1;
            else {
                a = $8df2de31e4e85614$var$xk;
                $8df2de31e4e85614$var$xk = null;
                $8df2de31e4e85614$var$yk = 0;
                if (0 !== ($8df2de31e4e85614$var$K & 6)) throw Error($8df2de31e4e85614$var$p(331));
                var e = $8df2de31e4e85614$var$K;
                $8df2de31e4e85614$var$K |= 4;
                for($8df2de31e4e85614$var$V = a.current; null !== $8df2de31e4e85614$var$V;){
                    var f = $8df2de31e4e85614$var$V, g = f.child;
                    if (0 !== ($8df2de31e4e85614$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($8df2de31e4e85614$var$V = l; null !== $8df2de31e4e85614$var$V;){
                                    var m = $8df2de31e4e85614$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $8df2de31e4e85614$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $8df2de31e4e85614$var$V = q;
                                    else for(; null !== $8df2de31e4e85614$var$V;){
                                        m = $8df2de31e4e85614$var$V;
                                        var r = m.sibling, y = m.return;
                                        $8df2de31e4e85614$var$Tj(m);
                                        if (m === l) {
                                            $8df2de31e4e85614$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $8df2de31e4e85614$var$V = r;
                                            break;
                                        }
                                        $8df2de31e4e85614$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $8df2de31e4e85614$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $8df2de31e4e85614$var$V = g;
                    else b: for(; null !== $8df2de31e4e85614$var$V;){
                        f = $8df2de31e4e85614$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $8df2de31e4e85614$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $8df2de31e4e85614$var$V = x;
                            break b;
                        }
                        $8df2de31e4e85614$var$V = f.return;
                    }
                }
                var w = a.current;
                for($8df2de31e4e85614$var$V = w; null !== $8df2de31e4e85614$var$V;){
                    g = $8df2de31e4e85614$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $8df2de31e4e85614$var$V = u;
                    else b: for(g = w; null !== $8df2de31e4e85614$var$V;){
                        h = $8df2de31e4e85614$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $8df2de31e4e85614$var$Rj(9, h);
                            }
                        } catch (na) {
                            $8df2de31e4e85614$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $8df2de31e4e85614$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $8df2de31e4e85614$var$V = F;
                            break b;
                        }
                        $8df2de31e4e85614$var$V = h.return;
                    }
                }
                $8df2de31e4e85614$var$K = e;
                $8df2de31e4e85614$var$jg();
                if ($8df2de31e4e85614$var$lc && "function" === typeof $8df2de31e4e85614$var$lc.onPostCommitFiberRoot) try {
                    $8df2de31e4e85614$var$lc.onPostCommitFiberRoot($8df2de31e4e85614$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $8df2de31e4e85614$var$C = c, $8df2de31e4e85614$var$pk.transition = b;
        }
    }
    return !1;
}
function $8df2de31e4e85614$var$Yk(a, b, c) {
    b = $8df2de31e4e85614$var$Ki(c, b);
    b = $8df2de31e4e85614$var$Oi(a, b, 1);
    a = $8df2de31e4e85614$var$dh(a, b, 1);
    b = $8df2de31e4e85614$var$L();
    null !== a && ($8df2de31e4e85614$var$Ac(a, 1, b), $8df2de31e4e85614$var$Ek(a, b));
}
function $8df2de31e4e85614$var$W(a, b, c) {
    if (3 === a.tag) $8df2de31e4e85614$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $8df2de31e4e85614$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $8df2de31e4e85614$var$Si || !$8df2de31e4e85614$var$Si.has(d))) {
                a = $8df2de31e4e85614$var$Ki(c, a);
                a = $8df2de31e4e85614$var$Ri(b, a, 1);
                b = $8df2de31e4e85614$var$dh(b, a, 1);
                a = $8df2de31e4e85614$var$L();
                null !== b && ($8df2de31e4e85614$var$Ac(b, 1, a), $8df2de31e4e85614$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $8df2de31e4e85614$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $8df2de31e4e85614$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $8df2de31e4e85614$var$R === a && ($8df2de31e4e85614$var$Z & c) === c && (4 === $8df2de31e4e85614$var$T || 3 === $8df2de31e4e85614$var$T && ($8df2de31e4e85614$var$Z & 130023424) === $8df2de31e4e85614$var$Z && 500 > $8df2de31e4e85614$var$B() - $8df2de31e4e85614$var$gk ? $8df2de31e4e85614$var$Lk(a, 0) : $8df2de31e4e85614$var$sk |= c);
    $8df2de31e4e85614$var$Ek(a, b);
}
function $8df2de31e4e85614$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $8df2de31e4e85614$var$sc, $8df2de31e4e85614$var$sc <<= 1, 0 === ($8df2de31e4e85614$var$sc & 130023424) && ($8df2de31e4e85614$var$sc = 4194304)));
    var c = $8df2de31e4e85614$var$L();
    a = $8df2de31e4e85614$var$Zg(a, b);
    null !== a && ($8df2de31e4e85614$var$Ac(a, b, c), $8df2de31e4e85614$var$Ek(a, c));
}
function $8df2de31e4e85614$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $8df2de31e4e85614$var$Zk(a, c);
}
function $8df2de31e4e85614$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($8df2de31e4e85614$var$p(314));
    }
    null !== d && d.delete(b);
    $8df2de31e4e85614$var$Zk(a, c);
}
var $8df2de31e4e85614$var$Wk;
$8df2de31e4e85614$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $8df2de31e4e85614$var$Wf.current) $8df2de31e4e85614$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $8df2de31e4e85614$var$Ug = !1, $8df2de31e4e85614$var$zj(a, b, c);
            $8df2de31e4e85614$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $8df2de31e4e85614$var$Ug = !1, $8df2de31e4e85614$var$I && 0 !== (b.flags & 1048576) && $8df2de31e4e85614$var$ug(b, $8df2de31e4e85614$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $8df2de31e4e85614$var$jj(a, b);
            a = b.pendingProps;
            var e = $8df2de31e4e85614$var$Yf(b, $8df2de31e4e85614$var$H.current);
            $8df2de31e4e85614$var$Tg(b, c);
            e = $8df2de31e4e85614$var$Xh(null, b, d, a, e, c);
            var f = $8df2de31e4e85614$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $8df2de31e4e85614$var$Zf(d) ? (f = !0, $8df2de31e4e85614$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $8df2de31e4e85614$var$ah(b), e.updater = $8df2de31e4e85614$var$nh, b.stateNode = e, e._reactInternals = b, $8df2de31e4e85614$var$rh(b, d, a, c), b = $8df2de31e4e85614$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $8df2de31e4e85614$var$I && f && $8df2de31e4e85614$var$vg(b), $8df2de31e4e85614$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $8df2de31e4e85614$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $8df2de31e4e85614$var$$k(d);
                a = $8df2de31e4e85614$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $8df2de31e4e85614$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $8df2de31e4e85614$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $8df2de31e4e85614$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $8df2de31e4e85614$var$aj(null, b, d, $8df2de31e4e85614$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($8df2de31e4e85614$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8df2de31e4e85614$var$Lg(d, e), $8df2de31e4e85614$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8df2de31e4e85614$var$Lg(d, e), $8df2de31e4e85614$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $8df2de31e4e85614$var$lj(b);
                if (null === a) throw Error($8df2de31e4e85614$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $8df2de31e4e85614$var$bh(a, b);
                $8df2de31e4e85614$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $8df2de31e4e85614$var$Ki(Error($8df2de31e4e85614$var$p(423)), b);
                        b = $8df2de31e4e85614$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $8df2de31e4e85614$var$Ki(Error($8df2de31e4e85614$var$p(424)), b);
                        b = $8df2de31e4e85614$var$mj(a, b, d, c, e);
                        break a;
                    } else for($8df2de31e4e85614$var$yg = $8df2de31e4e85614$var$Lf(b.stateNode.containerInfo.firstChild), $8df2de31e4e85614$var$xg = b, $8df2de31e4e85614$var$I = !0, $8df2de31e4e85614$var$zg = null, c = $8df2de31e4e85614$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $8df2de31e4e85614$var$Ig();
                    if (d === e) {
                        b = $8df2de31e4e85614$var$$i(a, b, c);
                        break a;
                    }
                    $8df2de31e4e85614$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $8df2de31e4e85614$var$Kh(b), null === a && $8df2de31e4e85614$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $8df2de31e4e85614$var$Ef(d, e) ? g = null : null !== f && $8df2de31e4e85614$var$Ef(d, f) && (b.flags |= 32), $8df2de31e4e85614$var$hj(a, b), $8df2de31e4e85614$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $8df2de31e4e85614$var$Eg(b), null;
        case 13:
            return $8df2de31e4e85614$var$pj(a, b, c);
        case 4:
            return $8df2de31e4e85614$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $8df2de31e4e85614$var$Bh(b, null, d, c) : $8df2de31e4e85614$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8df2de31e4e85614$var$Lg(d, e), $8df2de31e4e85614$var$Zi(a, b, d, e, c);
        case 7:
            return $8df2de31e4e85614$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $8df2de31e4e85614$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $8df2de31e4e85614$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $8df2de31e4e85614$var$G($8df2de31e4e85614$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($8df2de31e4e85614$var$He(f.value, g)) {
                        if (f.children === e.children && !$8df2de31e4e85614$var$Wf.current) {
                            b = $8df2de31e4e85614$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $8df2de31e4e85614$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $8df2de31e4e85614$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($8df2de31e4e85614$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $8df2de31e4e85614$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $8df2de31e4e85614$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $8df2de31e4e85614$var$Tg(b, c), e = $8df2de31e4e85614$var$Vg(e), d = d(e), b.flags |= 1, $8df2de31e4e85614$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $8df2de31e4e85614$var$Lg(d, b.pendingProps), e = $8df2de31e4e85614$var$Lg(d.type, e), $8df2de31e4e85614$var$aj(a, b, d, e, c);
        case 15:
            return $8df2de31e4e85614$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $8df2de31e4e85614$var$Lg(d, e), $8df2de31e4e85614$var$jj(a, b), b.tag = 1, $8df2de31e4e85614$var$Zf(d) ? (a = !0, $8df2de31e4e85614$var$cg(b)) : a = !1, $8df2de31e4e85614$var$Tg(b, c), $8df2de31e4e85614$var$ph(b, d, e), $8df2de31e4e85614$var$rh(b, d, e, c), $8df2de31e4e85614$var$kj(null, b, d, !0, a, c);
        case 19:
            return $8df2de31e4e85614$var$yj(a, b, c);
        case 22:
            return $8df2de31e4e85614$var$ej(a, b, c);
    }
    throw Error($8df2de31e4e85614$var$p(156, b.tag));
};
function $8df2de31e4e85614$var$Gk(a, b) {
    return $8df2de31e4e85614$var$ac(a, b);
}
function $8df2de31e4e85614$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $8df2de31e4e85614$var$Bg(a, b, c, d) {
    return new $8df2de31e4e85614$var$al(a, b, c, d);
}
function $8df2de31e4e85614$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $8df2de31e4e85614$var$$k(a) {
    if ("function" === typeof a) return $8df2de31e4e85614$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $8df2de31e4e85614$var$Da) return 11;
        if (a === $8df2de31e4e85614$var$Ga) return 14;
    }
    return 2;
}
function $8df2de31e4e85614$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $8df2de31e4e85614$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $8df2de31e4e85614$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $8df2de31e4e85614$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $8df2de31e4e85614$var$ya:
            return $8df2de31e4e85614$var$Ah(c.children, e, f, b);
        case $8df2de31e4e85614$var$za:
            g = 8;
            e |= 8;
            break;
        case $8df2de31e4e85614$var$Aa:
            return a = $8df2de31e4e85614$var$Bg(12, c, b, e | 2), a.elementType = $8df2de31e4e85614$var$Aa, a.lanes = f, a;
        case $8df2de31e4e85614$var$Ea:
            return a = $8df2de31e4e85614$var$Bg(13, c, b, e), a.elementType = $8df2de31e4e85614$var$Ea, a.lanes = f, a;
        case $8df2de31e4e85614$var$Fa:
            return a = $8df2de31e4e85614$var$Bg(19, c, b, e), a.elementType = $8df2de31e4e85614$var$Fa, a.lanes = f, a;
        case $8df2de31e4e85614$var$Ia:
            return $8df2de31e4e85614$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $8df2de31e4e85614$var$Ba:
                    g = 10;
                    break a;
                case $8df2de31e4e85614$var$Ca:
                    g = 9;
                    break a;
                case $8df2de31e4e85614$var$Da:
                    g = 11;
                    break a;
                case $8df2de31e4e85614$var$Ga:
                    g = 14;
                    break a;
                case $8df2de31e4e85614$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($8df2de31e4e85614$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $8df2de31e4e85614$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $8df2de31e4e85614$var$Ah(a, b, c, d) {
    a = $8df2de31e4e85614$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $8df2de31e4e85614$var$qj(a, b, c, d) {
    a = $8df2de31e4e85614$var$Bg(22, a, d, b);
    a.elementType = $8df2de31e4e85614$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $8df2de31e4e85614$var$xh(a, b, c) {
    a = $8df2de31e4e85614$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $8df2de31e4e85614$var$zh(a, b, c) {
    b = $8df2de31e4e85614$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $8df2de31e4e85614$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $8df2de31e4e85614$var$zc(0);
    this.expirationTimes = $8df2de31e4e85614$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8df2de31e4e85614$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $8df2de31e4e85614$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $8df2de31e4e85614$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $8df2de31e4e85614$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $8df2de31e4e85614$var$ah(f);
    return a;
}
function $8df2de31e4e85614$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $8df2de31e4e85614$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $8df2de31e4e85614$var$el(a) {
    if (!a) return $8df2de31e4e85614$var$Vf;
    a = a._reactInternals;
    a: {
        if ($8df2de31e4e85614$var$Vb(a) !== a || 1 !== a.tag) throw Error($8df2de31e4e85614$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($8df2de31e4e85614$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($8df2de31e4e85614$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($8df2de31e4e85614$var$Zf(c)) return $8df2de31e4e85614$var$bg(a, c, b);
    }
    return b;
}
function $8df2de31e4e85614$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $8df2de31e4e85614$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $8df2de31e4e85614$var$el(null);
    c = a.current;
    d = $8df2de31e4e85614$var$L();
    e = $8df2de31e4e85614$var$lh(c);
    f = $8df2de31e4e85614$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $8df2de31e4e85614$var$dh(c, f, e);
    a.current.lanes = e;
    $8df2de31e4e85614$var$Ac(a, e, d);
    $8df2de31e4e85614$var$Ek(a, d);
    return a;
}
function $8df2de31e4e85614$var$gl(a, b, c, d) {
    var e = b.current, f = $8df2de31e4e85614$var$L(), g = $8df2de31e4e85614$var$lh(e);
    c = $8df2de31e4e85614$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $8df2de31e4e85614$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $8df2de31e4e85614$var$dh(e, b, g);
    null !== a && ($8df2de31e4e85614$var$mh(a, e, g, f), $8df2de31e4e85614$var$eh(a, e, g));
    return g;
}
function $8df2de31e4e85614$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $8df2de31e4e85614$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $8df2de31e4e85614$var$jl(a, b) {
    $8df2de31e4e85614$var$il(a, b);
    (a = a.alternate) && $8df2de31e4e85614$var$il(a, b);
}
function $8df2de31e4e85614$var$kl() {
    return null;
}
var $8df2de31e4e85614$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $8df2de31e4e85614$var$ml(a) {
    this._internalRoot = a;
}
$8df2de31e4e85614$var$nl.prototype.render = $8df2de31e4e85614$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($8df2de31e4e85614$var$p(409));
    $8df2de31e4e85614$var$gl(a, b, null, null);
};
$8df2de31e4e85614$var$nl.prototype.unmount = $8df2de31e4e85614$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $8df2de31e4e85614$var$Sk(function() {
            $8df2de31e4e85614$var$gl(null, a, null, null);
        });
        b[$8df2de31e4e85614$var$uf] = null;
    }
};
function $8df2de31e4e85614$var$nl(a) {
    this._internalRoot = a;
}
$8df2de31e4e85614$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $8df2de31e4e85614$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $8df2de31e4e85614$var$Qc.length && 0 !== b && b < $8df2de31e4e85614$var$Qc[c].priority; c++);
        $8df2de31e4e85614$var$Qc.splice(c, 0, a);
        0 === c && $8df2de31e4e85614$var$Vc(a);
    }
};
function $8df2de31e4e85614$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $8df2de31e4e85614$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $8df2de31e4e85614$var$ql() {}
function $8df2de31e4e85614$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $8df2de31e4e85614$var$hl(g);
                f.call(a);
            };
        }
        var g = $8df2de31e4e85614$var$fl(b, d, a, 0, null, !1, !1, "", $8df2de31e4e85614$var$ql);
        a._reactRootContainer = g;
        a[$8df2de31e4e85614$var$uf] = g.current;
        $8df2de31e4e85614$var$sf(8 === a.nodeType ? a.parentNode : a);
        $8df2de31e4e85614$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $8df2de31e4e85614$var$hl(k);
            h.call(a);
        };
    }
    var k = $8df2de31e4e85614$var$cl(a, 0, !1, null, null, !1, !1, "", $8df2de31e4e85614$var$ql);
    a._reactRootContainer = k;
    a[$8df2de31e4e85614$var$uf] = k.current;
    $8df2de31e4e85614$var$sf(8 === a.nodeType ? a.parentNode : a);
    $8df2de31e4e85614$var$Sk(function() {
        $8df2de31e4e85614$var$gl(b, k, c, d);
    });
    return k;
}
function $8df2de31e4e85614$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $8df2de31e4e85614$var$hl(g);
                h.call(a);
            };
        }
        $8df2de31e4e85614$var$gl(b, g, a, e);
    } else g = $8df2de31e4e85614$var$rl(c, b, a, e, d);
    return $8df2de31e4e85614$var$hl(g);
}
$8df2de31e4e85614$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $8df2de31e4e85614$var$tc(b.pendingLanes);
                0 !== c && ($8df2de31e4e85614$var$Cc(b, c | 1), $8df2de31e4e85614$var$Ek(b, $8df2de31e4e85614$var$B()), 0 === ($8df2de31e4e85614$var$K & 6) && ($8df2de31e4e85614$var$Hj = $8df2de31e4e85614$var$B() + 500, $8df2de31e4e85614$var$jg()));
            }
            break;
        case 13:
            $8df2de31e4e85614$var$Sk(function() {
                var b = $8df2de31e4e85614$var$Zg(a, 1);
                if (null !== b) {
                    var c = $8df2de31e4e85614$var$L();
                    $8df2de31e4e85614$var$mh(b, a, 1, c);
                }
            }), $8df2de31e4e85614$var$jl(a, 1);
    }
};
$8df2de31e4e85614$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $8df2de31e4e85614$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $8df2de31e4e85614$var$L();
            $8df2de31e4e85614$var$mh(b, a, 134217728, c);
        }
        $8df2de31e4e85614$var$jl(a, 134217728);
    }
};
$8df2de31e4e85614$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $8df2de31e4e85614$var$lh(a), c = $8df2de31e4e85614$var$Zg(a, b);
        if (null !== c) {
            var d = $8df2de31e4e85614$var$L();
            $8df2de31e4e85614$var$mh(c, a, b, d);
        }
        $8df2de31e4e85614$var$jl(a, b);
    }
};
$8df2de31e4e85614$var$Hc = function() {
    return $8df2de31e4e85614$var$C;
};
$8df2de31e4e85614$var$Ic = function(a, b) {
    var c = $8df2de31e4e85614$var$C;
    try {
        return $8df2de31e4e85614$var$C = a, b();
    } finally{
        $8df2de31e4e85614$var$C = c;
    }
};
$8df2de31e4e85614$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $8df2de31e4e85614$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $8df2de31e4e85614$var$Db(d);
                        if (!e) throw Error($8df2de31e4e85614$var$p(90));
                        $8df2de31e4e85614$var$Wa(d);
                        $8df2de31e4e85614$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $8df2de31e4e85614$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $8df2de31e4e85614$var$fb(a, !!c.multiple, b, !1);
    }
};
$8df2de31e4e85614$var$Gb = $8df2de31e4e85614$var$Rk;
$8df2de31e4e85614$var$Hb = $8df2de31e4e85614$var$Sk;
var $8df2de31e4e85614$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $8df2de31e4e85614$var$Cb,
        $8df2de31e4e85614$var$ue,
        $8df2de31e4e85614$var$Db,
        $8df2de31e4e85614$var$Eb,
        $8df2de31e4e85614$var$Fb,
        $8df2de31e4e85614$var$Rk
    ]
}, $8df2de31e4e85614$var$ul = {
    findFiberByHostInstance: $8df2de31e4e85614$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $8df2de31e4e85614$var$vl = {
    bundleType: $8df2de31e4e85614$var$ul.bundleType,
    version: $8df2de31e4e85614$var$ul.version,
    rendererPackageName: $8df2de31e4e85614$var$ul.rendererPackageName,
    rendererConfig: $8df2de31e4e85614$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $8df2de31e4e85614$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $8df2de31e4e85614$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $8df2de31e4e85614$var$ul.findFiberByHostInstance || $8df2de31e4e85614$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $8df2de31e4e85614$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$8df2de31e4e85614$var$wl.isDisabled && $8df2de31e4e85614$var$wl.supportsFiber) try {
        $8df2de31e4e85614$var$kc = $8df2de31e4e85614$var$wl.inject($8df2de31e4e85614$var$vl), $8df2de31e4e85614$var$lc = $8df2de31e4e85614$var$wl;
    } catch (a) {}
}
$8df2de31e4e85614$export$ae55be85d98224ed = $8df2de31e4e85614$var$tl;
$8df2de31e4e85614$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$8df2de31e4e85614$var$ol(b)) throw Error($8df2de31e4e85614$var$p(200));
    return $8df2de31e4e85614$var$dl(a, b, null, c);
};
$8df2de31e4e85614$export$882461b6382ed46c = function(a, b) {
    if (!$8df2de31e4e85614$var$ol(a)) throw Error($8df2de31e4e85614$var$p(299));
    var c = !1, d = "", e = $8df2de31e4e85614$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $8df2de31e4e85614$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$8df2de31e4e85614$var$uf] = b.current;
    $8df2de31e4e85614$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $8df2de31e4e85614$var$ml(b);
};
$8df2de31e4e85614$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($8df2de31e4e85614$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($8df2de31e4e85614$var$p(268, a));
    }
    a = $8df2de31e4e85614$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$8df2de31e4e85614$export$cd75ccfd720a3cd4 = function(a) {
    return $8df2de31e4e85614$var$Sk(a);
};
$8df2de31e4e85614$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$8df2de31e4e85614$var$pl(b)) throw Error($8df2de31e4e85614$var$p(200));
    return $8df2de31e4e85614$var$sl(null, a, b, !0, c);
};
$8df2de31e4e85614$export$757ceba2d55c277e = function(a, b, c) {
    if (!$8df2de31e4e85614$var$ol(a)) throw Error($8df2de31e4e85614$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $8df2de31e4e85614$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $8df2de31e4e85614$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$8df2de31e4e85614$var$uf] = b.current;
    $8df2de31e4e85614$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $8df2de31e4e85614$var$nl(b);
};
$8df2de31e4e85614$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$8df2de31e4e85614$var$pl(b)) throw Error($8df2de31e4e85614$var$p(200));
    return $8df2de31e4e85614$var$sl(null, a, b, !1, c);
};
$8df2de31e4e85614$export$502457920280e6be = function(a) {
    if (!$8df2de31e4e85614$var$pl(a)) throw Error($8df2de31e4e85614$var$p(40));
    return a._reactRootContainer ? ($8df2de31e4e85614$var$Sk(function() {
        $8df2de31e4e85614$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$8df2de31e4e85614$var$uf] = null;
        });
    }), !0) : !1;
};
$8df2de31e4e85614$export$c78a37762a8d58e1 = $8df2de31e4e85614$var$Rk;
$8df2de31e4e85614$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$8df2de31e4e85614$var$pl(c)) throw Error($8df2de31e4e85614$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($8df2de31e4e85614$var$p(38));
    return $8df2de31e4e85614$var$sl(a, b, c, !1, d);
};
$8df2de31e4e85614$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("dJVJU", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2neey"));

});
parcelRegister("2neey", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $1ba8c5461699d370$export$c4744153514ff05d; }, function (v) { return $1ba8c5461699d370$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $1ba8c5461699d370$export$3e506c1ccc9cc1a7; }, function (v) { return $1ba8c5461699d370$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $1ba8c5461699d370$export$e26fe2ed2fa76875; }, function (v) { return $1ba8c5461699d370$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $1ba8c5461699d370$export$502329bbf4b505b1; }, function (v) { return $1ba8c5461699d370$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $1ba8c5461699d370$export$6e3807111c4874c4; }, function (v) { return $1ba8c5461699d370$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $1ba8c5461699d370$export$c27134553091fb3a; }, function (v) { return $1ba8c5461699d370$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $1ba8c5461699d370$export$33ee1acdc04fd2a2; }, function (v) { return $1ba8c5461699d370$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $1ba8c5461699d370$export$b00a404bbd5edef2; }, function (v) { return $1ba8c5461699d370$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $1ba8c5461699d370$export$8352ce38b91d0c62; }, function (v) { return $1ba8c5461699d370$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $1ba8c5461699d370$export$d66a1c1c77bd778b; }, function (v) { return $1ba8c5461699d370$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $1ba8c5461699d370$export$d3dfb8e4810cb555; }, function (v) { return $1ba8c5461699d370$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $1ba8c5461699d370$export$839f9183b0465a69; }, function (v) { return $1ba8c5461699d370$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $1ba8c5461699d370$export$72fdf0e06517287b; }, function (v) { return $1ba8c5461699d370$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $1ba8c5461699d370$export$4b844e58a3e414b4; }, function (v) { return $1ba8c5461699d370$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $1ba8c5461699d370$export$816d2913ae6b83b1; }, function (v) { return $1ba8c5461699d370$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $1ba8c5461699d370$export$61bcfe829111a1d0; }, function (v) { return $1ba8c5461699d370$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $1ba8c5461699d370$export$7ee8c9beb337bc3f; }, function (v) { return $1ba8c5461699d370$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $1ba8c5461699d370$export$b5836b71941fa3ed; }, function (v) { return $1ba8c5461699d370$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $1ba8c5461699d370$export$cf845f2c119da08a; }, function (v) { return $1ba8c5461699d370$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1ba8c5461699d370$export$c4744153514ff05d;
var $1ba8c5461699d370$export$3e506c1ccc9cc1a7;
var $1ba8c5461699d370$export$e26fe2ed2fa76875;
var $1ba8c5461699d370$export$502329bbf4b505b1;
var $1ba8c5461699d370$export$6e3807111c4874c4;
var $1ba8c5461699d370$export$c27134553091fb3a;
var $1ba8c5461699d370$export$33ee1acdc04fd2a2;
var $1ba8c5461699d370$export$b00a404bbd5edef2;
var $1ba8c5461699d370$export$8352ce38b91d0c62;
var $1ba8c5461699d370$export$d66a1c1c77bd778b;
var $1ba8c5461699d370$export$d3dfb8e4810cb555;
var $1ba8c5461699d370$export$839f9183b0465a69;
var $1ba8c5461699d370$export$72fdf0e06517287b;
var $1ba8c5461699d370$export$4b844e58a3e414b4;
var $1ba8c5461699d370$export$816d2913ae6b83b1;
var $1ba8c5461699d370$export$61bcfe829111a1d0;
var $1ba8c5461699d370$export$7ee8c9beb337bc3f;
var $1ba8c5461699d370$export$b5836b71941fa3ed;
var $1ba8c5461699d370$export$cf845f2c119da08a;
"use strict";
function $1ba8c5461699d370$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $1ba8c5461699d370$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $1ba8c5461699d370$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $1ba8c5461699d370$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $1ba8c5461699d370$var$g(C, c)) n < e && 0 > $1ba8c5461699d370$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $1ba8c5461699d370$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $1ba8c5461699d370$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $1ba8c5461699d370$var$l = performance;
    $1ba8c5461699d370$export$c4744153514ff05d = function() {
        return $1ba8c5461699d370$var$l.now();
    };
} else {
    var $1ba8c5461699d370$var$p = Date, $1ba8c5461699d370$var$q = $1ba8c5461699d370$var$p.now();
    $1ba8c5461699d370$export$c4744153514ff05d = function() {
        return $1ba8c5461699d370$var$p.now() - $1ba8c5461699d370$var$q;
    };
}
var $1ba8c5461699d370$var$r = [], $1ba8c5461699d370$var$t = [], $1ba8c5461699d370$var$u = 1, $1ba8c5461699d370$var$v = null, $1ba8c5461699d370$var$y = 3, $1ba8c5461699d370$var$z = !1, $1ba8c5461699d370$var$A = !1, $1ba8c5461699d370$var$B = !1, $1ba8c5461699d370$var$D = "function" === typeof setTimeout ? setTimeout : null, $1ba8c5461699d370$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $1ba8c5461699d370$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $1ba8c5461699d370$var$G(a) {
    for(var b = $1ba8c5461699d370$var$h($1ba8c5461699d370$var$t); null !== b;){
        if (null === b.callback) $1ba8c5461699d370$var$k($1ba8c5461699d370$var$t);
        else if (b.startTime <= a) $1ba8c5461699d370$var$k($1ba8c5461699d370$var$t), b.sortIndex = b.expirationTime, $1ba8c5461699d370$var$f($1ba8c5461699d370$var$r, b);
        else break;
        b = $1ba8c5461699d370$var$h($1ba8c5461699d370$var$t);
    }
}
function $1ba8c5461699d370$var$H(a) {
    $1ba8c5461699d370$var$B = !1;
    $1ba8c5461699d370$var$G(a);
    if (!$1ba8c5461699d370$var$A) {
        if (null !== $1ba8c5461699d370$var$h($1ba8c5461699d370$var$r)) $1ba8c5461699d370$var$A = !0, $1ba8c5461699d370$var$I($1ba8c5461699d370$var$J);
        else {
            var b = $1ba8c5461699d370$var$h($1ba8c5461699d370$var$t);
            null !== b && $1ba8c5461699d370$var$K($1ba8c5461699d370$var$H, b.startTime - a);
        }
    }
}
function $1ba8c5461699d370$var$J(a, b) {
    $1ba8c5461699d370$var$A = !1;
    $1ba8c5461699d370$var$B && ($1ba8c5461699d370$var$B = !1, $1ba8c5461699d370$var$E($1ba8c5461699d370$var$L), $1ba8c5461699d370$var$L = -1);
    $1ba8c5461699d370$var$z = !0;
    var c = $1ba8c5461699d370$var$y;
    try {
        $1ba8c5461699d370$var$G(b);
        for($1ba8c5461699d370$var$v = $1ba8c5461699d370$var$h($1ba8c5461699d370$var$r); null !== $1ba8c5461699d370$var$v && (!($1ba8c5461699d370$var$v.expirationTime > b) || a && !$1ba8c5461699d370$var$M());){
            var d = $1ba8c5461699d370$var$v.callback;
            if ("function" === typeof d) {
                $1ba8c5461699d370$var$v.callback = null;
                $1ba8c5461699d370$var$y = $1ba8c5461699d370$var$v.priorityLevel;
                var e = d($1ba8c5461699d370$var$v.expirationTime <= b);
                b = $1ba8c5461699d370$export$c4744153514ff05d();
                "function" === typeof e ? $1ba8c5461699d370$var$v.callback = e : $1ba8c5461699d370$var$v === $1ba8c5461699d370$var$h($1ba8c5461699d370$var$r) && $1ba8c5461699d370$var$k($1ba8c5461699d370$var$r);
                $1ba8c5461699d370$var$G(b);
            } else $1ba8c5461699d370$var$k($1ba8c5461699d370$var$r);
            $1ba8c5461699d370$var$v = $1ba8c5461699d370$var$h($1ba8c5461699d370$var$r);
        }
        if (null !== $1ba8c5461699d370$var$v) var w = !0;
        else {
            var m = $1ba8c5461699d370$var$h($1ba8c5461699d370$var$t);
            null !== m && $1ba8c5461699d370$var$K($1ba8c5461699d370$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $1ba8c5461699d370$var$v = null, $1ba8c5461699d370$var$y = c, $1ba8c5461699d370$var$z = !1;
    }
}
var $1ba8c5461699d370$var$N = !1, $1ba8c5461699d370$var$O = null, $1ba8c5461699d370$var$L = -1, $1ba8c5461699d370$var$P = 5, $1ba8c5461699d370$var$Q = -1;
function $1ba8c5461699d370$var$M() {
    return $1ba8c5461699d370$export$c4744153514ff05d() - $1ba8c5461699d370$var$Q < $1ba8c5461699d370$var$P ? !1 : !0;
}
function $1ba8c5461699d370$var$R() {
    if (null !== $1ba8c5461699d370$var$O) {
        var a = $1ba8c5461699d370$export$c4744153514ff05d();
        $1ba8c5461699d370$var$Q = a;
        var b = !0;
        try {
            b = $1ba8c5461699d370$var$O(!0, a);
        } finally{
            b ? $1ba8c5461699d370$var$S() : ($1ba8c5461699d370$var$N = !1, $1ba8c5461699d370$var$O = null);
        }
    } else $1ba8c5461699d370$var$N = !1;
}
var $1ba8c5461699d370$var$S;
if ("function" === typeof $1ba8c5461699d370$var$F) $1ba8c5461699d370$var$S = function() {
    $1ba8c5461699d370$var$F($1ba8c5461699d370$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $1ba8c5461699d370$var$T = new MessageChannel, $1ba8c5461699d370$var$U = $1ba8c5461699d370$var$T.port2;
    $1ba8c5461699d370$var$T.port1.onmessage = $1ba8c5461699d370$var$R;
    $1ba8c5461699d370$var$S = function() {
        $1ba8c5461699d370$var$U.postMessage(null);
    };
} else $1ba8c5461699d370$var$S = function() {
    $1ba8c5461699d370$var$D($1ba8c5461699d370$var$R, 0);
};
function $1ba8c5461699d370$var$I(a) {
    $1ba8c5461699d370$var$O = a;
    $1ba8c5461699d370$var$N || ($1ba8c5461699d370$var$N = !0, $1ba8c5461699d370$var$S());
}
function $1ba8c5461699d370$var$K(a, b) {
    $1ba8c5461699d370$var$L = $1ba8c5461699d370$var$D(function() {
        a($1ba8c5461699d370$export$c4744153514ff05d());
    }, b);
}
$1ba8c5461699d370$export$3e506c1ccc9cc1a7 = 5;
$1ba8c5461699d370$export$e26fe2ed2fa76875 = 1;
$1ba8c5461699d370$export$502329bbf4b505b1 = 4;
$1ba8c5461699d370$export$6e3807111c4874c4 = 3;
$1ba8c5461699d370$export$c27134553091fb3a = null;
$1ba8c5461699d370$export$33ee1acdc04fd2a2 = 2;
$1ba8c5461699d370$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$1ba8c5461699d370$export$8352ce38b91d0c62 = function() {
    $1ba8c5461699d370$var$A || $1ba8c5461699d370$var$z || ($1ba8c5461699d370$var$A = !0, $1ba8c5461699d370$var$I($1ba8c5461699d370$var$J));
};
$1ba8c5461699d370$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $1ba8c5461699d370$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$1ba8c5461699d370$export$d3dfb8e4810cb555 = function() {
    return $1ba8c5461699d370$var$y;
};
$1ba8c5461699d370$export$839f9183b0465a69 = function() {
    return $1ba8c5461699d370$var$h($1ba8c5461699d370$var$r);
};
$1ba8c5461699d370$export$72fdf0e06517287b = function(a) {
    switch($1ba8c5461699d370$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $1ba8c5461699d370$var$y;
    }
    var c = $1ba8c5461699d370$var$y;
    $1ba8c5461699d370$var$y = b;
    try {
        return a();
    } finally{
        $1ba8c5461699d370$var$y = c;
    }
};
$1ba8c5461699d370$export$4b844e58a3e414b4 = function() {};
$1ba8c5461699d370$export$816d2913ae6b83b1 = function() {};
$1ba8c5461699d370$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $1ba8c5461699d370$var$y;
    $1ba8c5461699d370$var$y = a;
    try {
        return b();
    } finally{
        $1ba8c5461699d370$var$y = c;
    }
};
$1ba8c5461699d370$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $1ba8c5461699d370$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $1ba8c5461699d370$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $1ba8c5461699d370$var$f($1ba8c5461699d370$var$t, a), null === $1ba8c5461699d370$var$h($1ba8c5461699d370$var$r) && a === $1ba8c5461699d370$var$h($1ba8c5461699d370$var$t) && ($1ba8c5461699d370$var$B ? ($1ba8c5461699d370$var$E($1ba8c5461699d370$var$L), $1ba8c5461699d370$var$L = -1) : $1ba8c5461699d370$var$B = !0, $1ba8c5461699d370$var$K($1ba8c5461699d370$var$H, c - d))) : (a.sortIndex = e, $1ba8c5461699d370$var$f($1ba8c5461699d370$var$r, a), $1ba8c5461699d370$var$A || $1ba8c5461699d370$var$z || ($1ba8c5461699d370$var$A = !0, $1ba8c5461699d370$var$I($1ba8c5461699d370$var$J)));
    return a;
};
$1ba8c5461699d370$export$b5836b71941fa3ed = $1ba8c5461699d370$var$M;
$1ba8c5461699d370$export$cf845f2c119da08a = function(a) {
    var b = $1ba8c5461699d370$var$y;
    return function() {
        var c = $1ba8c5461699d370$var$y;
        $1ba8c5461699d370$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $1ba8c5461699d370$var$y = c;
        }
    };
};

});



parcelRegister("58U8g", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $cEBfe = parcelRequire("cEBfe");
function $3be93dc9c3f31736$var$emptyFunction() {}
function $3be93dc9c3f31736$var$emptyFunctionWithReset() {}
$3be93dc9c3f31736$var$emptyFunctionWithReset.resetWarningCache = $3be93dc9c3f31736$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $cEBfe) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $3be93dc9c3f31736$var$emptyFunctionWithReset,
        resetWarningCache: $3be93dc9c3f31736$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("cEBfe", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $93661c7ef8d250a3$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $93661c7ef8d250a3$var$ReactPropTypesSecret;

});


parcelRegister("dAcci", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $9e3819457addbc4f$export$2b8d127b894957b9; }, function (v) { return $9e3819457addbc4f$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $9e3819457addbc4f$export$cea3a54a6425200c; }, function (v) { return $9e3819457addbc4f$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $9e3819457addbc4f$export$a7c73072b1a182ae; }, function (v) { return $9e3819457addbc4f$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $9e3819457addbc4f$export$9f27bc3417b4524d; }, function (v) { return $9e3819457addbc4f$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $9e3819457addbc4f$export$db77ccec0bb4ccac; }, function (v) { return $9e3819457addbc4f$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $9e3819457addbc4f$export$8392c0c9d3dcbd35; }, function (v) { return $9e3819457addbc4f$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9e3819457addbc4f$export$ffb0004e005737fa; }, function (v) { return $9e3819457addbc4f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $9e3819457addbc4f$export$b624eff549462981; }, function (v) { return $9e3819457addbc4f$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $9e3819457addbc4f$export$7897aa7841a5380c; }, function (v) { return $9e3819457addbc4f$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $9e3819457addbc4f$export$602eac185826482c; }, function (v) { return $9e3819457addbc4f$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $9e3819457addbc4f$export$e2c29f18771995cb; }, function (v) { return $9e3819457addbc4f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9e3819457addbc4f$export$5f8d39834fd61797; }, function (v) { return $9e3819457addbc4f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9e3819457addbc4f$export$74bf444e3cd11ea5; }, function (v) { return $9e3819457addbc4f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $9e3819457addbc4f$export$92387174baf9b227; }, function (v) { return $9e3819457addbc4f$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $9e3819457addbc4f$export$ec112efeb987d9c6; }, function (v) { return $9e3819457addbc4f$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $9e3819457addbc4f$export$b706b080d889d2c9; }, function (v) { return $9e3819457addbc4f$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $9e3819457addbc4f$export$5be5a87408f70ddc; }, function (v) { return $9e3819457addbc4f$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $9e3819457addbc4f$export$45a5e7f76e0caa8d; }, function (v) { return $9e3819457addbc4f$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $9e3819457addbc4f$export$455c2e768291efa6; }, function (v) { return $9e3819457addbc4f$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $9e3819457addbc4f$export$9522e17588c12572; }, function (v) { return $9e3819457addbc4f$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $9e3819457addbc4f$export$2110ac352bb060b9; }, function (v) { return $9e3819457addbc4f$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $9e3819457addbc4f$export$56885ab8b9c456ab; }, function (v) { return $9e3819457addbc4f$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $9e3819457addbc4f$export$d927fcb6adf8f9de; }, function (v) { return $9e3819457addbc4f$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $9e3819457addbc4f$export$b82d16f27459e05a; }, function (v) { return $9e3819457addbc4f$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $9e3819457addbc4f$export$522c17b4f5e123e8; }, function (v) { return $9e3819457addbc4f$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $9e3819457addbc4f$export$1aabd8a0274ecfd6; }, function (v) { return $9e3819457addbc4f$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $9e3819457addbc4f$export$9b621391a187a31a; }, function (v) { return $9e3819457addbc4f$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $9e3819457addbc4f$export$f5bbd400c2f4426f; }, function (v) { return $9e3819457addbc4f$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9e3819457addbc4f$export$2b8d127b894957b9;
var $9e3819457addbc4f$export$cea3a54a6425200c;
var $9e3819457addbc4f$export$a7c73072b1a182ae;
var $9e3819457addbc4f$export$9f27bc3417b4524d;
var $9e3819457addbc4f$export$db77ccec0bb4ccac;
var $9e3819457addbc4f$export$8392c0c9d3dcbd35;
var $9e3819457addbc4f$export$ffb0004e005737fa;
var $9e3819457addbc4f$export$b624eff549462981;
var $9e3819457addbc4f$export$7897aa7841a5380c;
var $9e3819457addbc4f$export$602eac185826482c;
var $9e3819457addbc4f$export$e2c29f18771995cb;
var $9e3819457addbc4f$export$5f8d39834fd61797;
var $9e3819457addbc4f$export$74bf444e3cd11ea5;
var $9e3819457addbc4f$export$92387174baf9b227;
var $9e3819457addbc4f$export$ec112efeb987d9c6;
var $9e3819457addbc4f$export$b706b080d889d2c9;
var $9e3819457addbc4f$export$5be5a87408f70ddc;
var $9e3819457addbc4f$export$45a5e7f76e0caa8d;
var $9e3819457addbc4f$export$455c2e768291efa6;
var $9e3819457addbc4f$export$9522e17588c12572;
var $9e3819457addbc4f$export$2110ac352bb060b9;
var $9e3819457addbc4f$export$56885ab8b9c456ab;
var $9e3819457addbc4f$export$d927fcb6adf8f9de;
var $9e3819457addbc4f$export$b82d16f27459e05a;
var $9e3819457addbc4f$export$522c17b4f5e123e8;
var $9e3819457addbc4f$export$1aabd8a0274ecfd6;
var $9e3819457addbc4f$export$9b621391a187a31a;
var $9e3819457addbc4f$export$f5bbd400c2f4426f;
"use strict";
var $9e3819457addbc4f$var$b = "function" === typeof Symbol && Symbol.for, $9e3819457addbc4f$var$c = $9e3819457addbc4f$var$b ? Symbol.for("react.element") : 60103, $9e3819457addbc4f$var$d = $9e3819457addbc4f$var$b ? Symbol.for("react.portal") : 60106, $9e3819457addbc4f$var$e = $9e3819457addbc4f$var$b ? Symbol.for("react.fragment") : 60107, $9e3819457addbc4f$var$f = $9e3819457addbc4f$var$b ? Symbol.for("react.strict_mode") : 60108, $9e3819457addbc4f$var$g = $9e3819457addbc4f$var$b ? Symbol.for("react.profiler") : 60114, $9e3819457addbc4f$var$h = $9e3819457addbc4f$var$b ? Symbol.for("react.provider") : 60109, $9e3819457addbc4f$var$k = $9e3819457addbc4f$var$b ? Symbol.for("react.context") : 60110, $9e3819457addbc4f$var$l = $9e3819457addbc4f$var$b ? Symbol.for("react.async_mode") : 60111, $9e3819457addbc4f$var$m = $9e3819457addbc4f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9e3819457addbc4f$var$n = $9e3819457addbc4f$var$b ? Symbol.for("react.forward_ref") : 60112, $9e3819457addbc4f$var$p = $9e3819457addbc4f$var$b ? Symbol.for("react.suspense") : 60113, $9e3819457addbc4f$var$q = $9e3819457addbc4f$var$b ? Symbol.for("react.suspense_list") : 60120, $9e3819457addbc4f$var$r = $9e3819457addbc4f$var$b ? Symbol.for("react.memo") : 60115, $9e3819457addbc4f$var$t = $9e3819457addbc4f$var$b ? Symbol.for("react.lazy") : 60116, $9e3819457addbc4f$var$v = $9e3819457addbc4f$var$b ? Symbol.for("react.block") : 60121, $9e3819457addbc4f$var$w = $9e3819457addbc4f$var$b ? Symbol.for("react.fundamental") : 60117, $9e3819457addbc4f$var$x = $9e3819457addbc4f$var$b ? Symbol.for("react.responder") : 60118, $9e3819457addbc4f$var$y = $9e3819457addbc4f$var$b ? Symbol.for("react.scope") : 60119;
function $9e3819457addbc4f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9e3819457addbc4f$var$c:
                switch(a = a.type, a){
                    case $9e3819457addbc4f$var$l:
                    case $9e3819457addbc4f$var$m:
                    case $9e3819457addbc4f$var$e:
                    case $9e3819457addbc4f$var$g:
                    case $9e3819457addbc4f$var$f:
                    case $9e3819457addbc4f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9e3819457addbc4f$var$k:
                            case $9e3819457addbc4f$var$n:
                            case $9e3819457addbc4f$var$t:
                            case $9e3819457addbc4f$var$r:
                            case $9e3819457addbc4f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9e3819457addbc4f$var$d:
                return u;
        }
    }
}
function $9e3819457addbc4f$var$A(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$m;
}
$9e3819457addbc4f$export$2b8d127b894957b9 = $9e3819457addbc4f$var$l;
$9e3819457addbc4f$export$cea3a54a6425200c = $9e3819457addbc4f$var$m;
$9e3819457addbc4f$export$a7c73072b1a182ae = $9e3819457addbc4f$var$k;
$9e3819457addbc4f$export$9f27bc3417b4524d = $9e3819457addbc4f$var$h;
$9e3819457addbc4f$export$db77ccec0bb4ccac = $9e3819457addbc4f$var$c;
$9e3819457addbc4f$export$8392c0c9d3dcbd35 = $9e3819457addbc4f$var$n;
$9e3819457addbc4f$export$ffb0004e005737fa = $9e3819457addbc4f$var$e;
$9e3819457addbc4f$export$b624eff549462981 = $9e3819457addbc4f$var$t;
$9e3819457addbc4f$export$7897aa7841a5380c = $9e3819457addbc4f$var$r;
$9e3819457addbc4f$export$602eac185826482c = $9e3819457addbc4f$var$d;
$9e3819457addbc4f$export$e2c29f18771995cb = $9e3819457addbc4f$var$g;
$9e3819457addbc4f$export$5f8d39834fd61797 = $9e3819457addbc4f$var$f;
$9e3819457addbc4f$export$74bf444e3cd11ea5 = $9e3819457addbc4f$var$p;
$9e3819457addbc4f$export$92387174baf9b227 = function(a) {
    return $9e3819457addbc4f$var$A(a) || $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$l;
};
$9e3819457addbc4f$export$ec112efeb987d9c6 = $9e3819457addbc4f$var$A;
$9e3819457addbc4f$export$b706b080d889d2c9 = function(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$k;
};
$9e3819457addbc4f$export$5be5a87408f70ddc = function(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$h;
};
$9e3819457addbc4f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9e3819457addbc4f$var$c;
};
$9e3819457addbc4f$export$455c2e768291efa6 = function(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$n;
};
$9e3819457addbc4f$export$9522e17588c12572 = function(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$e;
};
$9e3819457addbc4f$export$2110ac352bb060b9 = function(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$t;
};
$9e3819457addbc4f$export$56885ab8b9c456ab = function(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$r;
};
$9e3819457addbc4f$export$d927fcb6adf8f9de = function(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$d;
};
$9e3819457addbc4f$export$b82d16f27459e05a = function(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$g;
};
$9e3819457addbc4f$export$522c17b4f5e123e8 = function(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$f;
};
$9e3819457addbc4f$export$1aabd8a0274ecfd6 = function(a) {
    return $9e3819457addbc4f$var$z(a) === $9e3819457addbc4f$var$p;
};
$9e3819457addbc4f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9e3819457addbc4f$var$e || a === $9e3819457addbc4f$var$m || a === $9e3819457addbc4f$var$g || a === $9e3819457addbc4f$var$f || a === $9e3819457addbc4f$var$p || a === $9e3819457addbc4f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9e3819457addbc4f$var$t || a.$$typeof === $9e3819457addbc4f$var$r || a.$$typeof === $9e3819457addbc4f$var$h || a.$$typeof === $9e3819457addbc4f$var$k || a.$$typeof === $9e3819457addbc4f$var$n || a.$$typeof === $9e3819457addbc4f$var$w || a.$$typeof === $9e3819457addbc4f$var$x || a.$$typeof === $9e3819457addbc4f$var$y || a.$$typeof === $9e3819457addbc4f$var$v);
};
$9e3819457addbc4f$export$f5bbd400c2f4426f = $9e3819457addbc4f$var$z;

});

parcelRegister("8Awal", function(module, exports) {
function $640aa2f8ce1dee36$var$_extends() {
    module.exports = $640aa2f8ce1dee36$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $640aa2f8ce1dee36$var$_extends.apply(this, arguments);
}
module.exports = $640aa2f8ce1dee36$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("d3eXn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("7y3ET")).default; });

var $7y3ET = parcelRequire("7y3ET");

});
parcelRegister("7y3ET", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57ee8be2f7f99fbf$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $57ee8be2f7f99fbf$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});


parcelRegister("gFtJs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gA23F")).default; });

var $gA23F = parcelRequire("gA23F");

});
parcelRegister("gA23F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1219ad13bce1080$export$2e2bcd8739ae039; });
function $c1219ad13bce1080$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $c1219ad13bce1080$export$2e2bcd8739ae039 = $c1219ad13bce1080$var$clamp;

});


parcelRegister("1VU7c", function(module, exports) {
function $1686a49c54443b4d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $1686a49c54443b4d$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("k91z8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $eaa5dcd6771b9ae3$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $eaa5dcd6771b9ae3$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("g89D5")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("8zt0d")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("8zt0d")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("5vBaP")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("hQFs4")).default; });
/**
 * @mui/styled-engine v5.15.11
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bn8NL = parcelRequire("bn8NL");

var $8zt0d = parcelRequire("8zt0d");
var $g89D5 = parcelRequire("g89D5");

var $5vBaP = parcelRequire("5vBaP");

var $hQFs4 = parcelRequire("hQFs4");
"use client";
function $eaa5dcd6771b9ae3$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $bn8NL.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $eaa5dcd6771b9ae3$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("bn8NL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8478ab82edb43368$export$2e2bcd8739ae039; });

var $3p8vX = parcelRequire("3p8vX");
parcelRequire("8Awal");
parcelRequire("4YNlq");
parcelRequire("isI74");

parcelRequire("1iqNI");
parcelRequire("czYvb");
parcelRequire("f5ZwO");
var $8478ab82edb43368$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $8478ab82edb43368$export$2e2bcd8739ae039 = (0, $3p8vX.default).bind();
$8478ab82edb43368$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $8478ab82edb43368$export$2e2bcd8739ae039[tagName] = $8478ab82edb43368$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("3p8vX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27aa4faf81ff1536$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $isI74 = parcelRequire("isI74");
parcelRequire("8zt0d");
var $g89D5 = parcelRequire("g89D5");

var $1iqNI = parcelRequire("1iqNI");

var $czYvb = parcelRequire("czYvb");

var $f5ZwO = parcelRequire("f5ZwO");
var $27aa4faf81ff1536$var$testOmitPropsOnStringTag = (0, $isI74.default);
var $27aa4faf81ff1536$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $27aa4faf81ff1536$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $27aa4faf81ff1536$var$testOmitPropsOnStringTag : $27aa4faf81ff1536$var$testOmitPropsOnComponent;
};
var $27aa4faf81ff1536$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $27aa4faf81ff1536$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $27aa4faf81ff1536$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1iqNI.registerStyles)(cache, serialized, isStringTag);
    (0, $f5ZwO.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $1iqNI.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $27aa4faf81ff1536$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $27aa4faf81ff1536$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $27aa4faf81ff1536$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $g89D5.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $4YNlq.useContext((0, $g89D5.T));
            }
            if (typeof props.className === "string") className = (0, $1iqNI.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $czYvb.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $27aa4faf81ff1536$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $4YNlq.createElement($4YNlq.Fragment, null, /*#__PURE__*/ $4YNlq.createElement($27aa4faf81ff1536$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $4YNlq.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $lzDk3.default)({}, options, nextOptions, {
                shouldForwardProp: $27aa4faf81ff1536$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("lzDk3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb4b5e77a8a21e9e$export$2e2bcd8739ae039; });
function $fb4b5e77a8a21e9e$export$2e2bcd8739ae039() {
    $fb4b5e77a8a21e9e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fb4b5e77a8a21e9e$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRegister("isI74", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d70d0f74a22b2c06$export$2e2bcd8739ae039; });

var $1r7Iy = parcelRequire("1r7Iy");
var $d70d0f74a22b2c06$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $d70d0f74a22b2c06$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $1r7Iy.default)(function(prop) {
    return $d70d0f74a22b2c06$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("1r7Iy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10be4ca335f5ac41$export$2e2bcd8739ae039; });
function $10be4ca335f5ac41$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("8zt0d", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $63d816e47612d997$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $63d816e47612d997$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $63d816e47612d997$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("g89D5")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("g89D5")).w; });

var $g89D5 = parcelRequire("g89D5");

var $4YNlq = parcelRequire("4YNlq");

var $1iqNI = parcelRequire("1iqNI");

var $f5ZwO = parcelRequire("f5ZwO");

var $czYvb = parcelRequire("czYvb");
parcelRequire("6U2ij");
parcelRequire("8Awal");
parcelRequire("690Ou");

parcelRequire("k3pIl");
var $63d816e47612d997$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $63d816e47612d997$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $g89D5.h).call(props, "css")) // $FlowFixMe
    return $4YNlq.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $g89D5.E);
    createElementArgArray[1] = (0, $g89D5.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $4YNlq.createElement.apply(null, createElementArgArray);
};
var $63d816e47612d997$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d816e47612d997$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $g89D5.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $czYvb.serializeStyles)([
        styles
    ], undefined, $4YNlq.useContext((0, $g89D5.T)));
    if (!(0, $g89D5.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $4YNlq.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $4YNlq.useRef();
    (0, $f5ZwO.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $f5ZwO.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1iqNI.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d816e47612d997$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $czYvb.serializeStyles)(args);
}
var $63d816e47612d997$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $63d816e47612d997$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $63d816e47612d997$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $63d816e47612d997$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1iqNI.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d816e47612d997$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $f5ZwO.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1iqNI.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d816e47612d997$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $g89D5.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $czYvb.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1iqNI.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d816e47612d997$var$merge(cache.registered, css, $63d816e47612d997$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $4YNlq.useContext((0, $g89D5.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $4YNlq.createElement($4YNlq.Fragment, null, /*#__PURE__*/ $4YNlq.createElement($63d816e47612d997$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $63d816e47612d997$var$isBrowser, $63d816e47612d997$var$isTestEnv, $63d816e47612d997$var$globalContext, $63d816e47612d997$var$globalKey;

});
parcelRegister("g89D5", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $bbe4dceaa9ec3bf4$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $bbe4dceaa9ec3bf4$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $bbe4dceaa9ec3bf4$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $bbe4dceaa9ec3bf4$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $bbe4dceaa9ec3bf4$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $bbe4dceaa9ec3bf4$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $bbe4dceaa9ec3bf4$export$a9c23c6ac3fc3eca; });

var $4YNlq = parcelRequire("4YNlq");

var $6U2ij = parcelRequire("6U2ij");

var $lzDk3 = parcelRequire("lzDk3");

var $690Ou = parcelRequire("690Ou");

var $7EXVY = parcelRequire("7EXVY");

var $1iqNI = parcelRequire("1iqNI");

var $czYvb = parcelRequire("czYvb");

var $f5ZwO = parcelRequire("f5ZwO");
var $bbe4dceaa9ec3bf4$export$23f2a1d2818174ef = true;
var $bbe4dceaa9ec3bf4$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $bbe4dceaa9ec3bf4$var$EmotionCacheContext = /* #__PURE__ */ $4YNlq.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $6U2ij.default)({
    key: "css"
}) : null);
var $bbe4dceaa9ec3bf4$export$e7094788287c5e9b = $bbe4dceaa9ec3bf4$var$EmotionCacheContext.Provider;
var $bbe4dceaa9ec3bf4$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $4YNlq.useContext)($bbe4dceaa9ec3bf4$var$EmotionCacheContext);
};
var $bbe4dceaa9ec3bf4$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $4YNlq.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $4YNlq.useContext)($bbe4dceaa9ec3bf4$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$bbe4dceaa9ec3bf4$export$23f2a1d2818174ef) $bbe4dceaa9ec3bf4$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $4YNlq.useContext)($bbe4dceaa9ec3bf4$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $6U2ij.default)({
                key: "css"
            });
            return /*#__PURE__*/ $4YNlq.createElement($bbe4dceaa9ec3bf4$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $bbe4dceaa9ec3bf4$export$971d5caa766a69d7 = /* #__PURE__ */ $4YNlq.createContext({});
var $bbe4dceaa9ec3bf4$export$3b14a55fb2447963 = function useTheme() {
    return $4YNlq.useContext($bbe4dceaa9ec3bf4$export$971d5caa766a69d7);
};
var $bbe4dceaa9ec3bf4$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $lzDk3.default)({}, outerTheme, theme);
};
var $bbe4dceaa9ec3bf4$var$createCacheWithTheme = /* #__PURE__ */ (0, $690Ou.default)(function(outerTheme) {
    return (0, $690Ou.default)(function(theme) {
        return $bbe4dceaa9ec3bf4$var$getTheme(outerTheme, theme);
    });
});
var $bbe4dceaa9ec3bf4$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $4YNlq.useContext($bbe4dceaa9ec3bf4$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $bbe4dceaa9ec3bf4$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $4YNlq.createElement($bbe4dceaa9ec3bf4$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $bbe4dceaa9ec3bf4$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $4YNlq.useContext($bbe4dceaa9ec3bf4$export$971d5caa766a69d7);
        return /*#__PURE__*/ $4YNlq.createElement(Component, (0, $lzDk3.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $4YNlq.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $7EXVY.default)(WithTheme, Component);
}
var $bbe4dceaa9ec3bf4$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $bbe4dceaa9ec3bf4$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $bbe4dceaa9ec3bf4$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $bbe4dceaa9ec3bf4$var$getLastPart(match[1]);
    return undefined;
};
var $bbe4dceaa9ec3bf4$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $bbe4dceaa9ec3bf4$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $bbe4dceaa9ec3bf4$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $bbe4dceaa9ec3bf4$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($bbe4dceaa9ec3bf4$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $bbe4dceaa9ec3bf4$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $bbe4dceaa9ec3bf4$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $bbe4dceaa9ec3bf4$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $bbe4dceaa9ec3bf4$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($bbe4dceaa9ec3bf4$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$bbe4dceaa9ec3bf4$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $bbe4dceaa9ec3bf4$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1iqNI.registerStyles)(cache, serialized, isStringTag);
    (0, $f5ZwO.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $1iqNI.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $bbe4dceaa9ec3bf4$var$Emotion = /* #__PURE__ */ $bbe4dceaa9ec3bf4$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$bbe4dceaa9ec3bf4$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $1iqNI.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $czYvb.serializeStyles)(registeredStyles, undefined, $4YNlq.useContext($bbe4dceaa9ec3bf4$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($bbe4dceaa9ec3bf4$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $bbe4dceaa9ec3bf4$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $4YNlq.createElement($4YNlq.Fragment, null, /*#__PURE__*/ $4YNlq.createElement($bbe4dceaa9ec3bf4$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $4YNlq.createElement(WrappedComponent, newProps));
});
var $bbe4dceaa9ec3bf4$export$a9c23c6ac3fc3eca = $bbe4dceaa9ec3bf4$var$Emotion;

});
parcelRegister("6U2ij", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5069c0a6674ea06d$export$2e2bcd8739ae039; });

var $8wjkc = parcelRequire("8wjkc");

var $Z9Jjr = parcelRequire("Z9Jjr");
parcelRequire("690Ou");
parcelRequire("1r7Iy");
var $5069c0a6674ea06d$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $Z9Jjr.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $Z9Jjr.token)(character)) break;
        (0, $Z9Jjr.next)();
    }
    return (0, $Z9Jjr.slice)(begin, (0, $Z9Jjr.position));
};
var $5069c0a6674ea06d$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $Z9Jjr.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $Z9Jjr.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $5069c0a6674ea06d$var$identifierWithPointTracking((0, $Z9Jjr.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $Z9Jjr.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $Z9Jjr.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $Z9Jjr.from)(character);
    }
    while (character = (0, $Z9Jjr.next)());
    return parsed;
};
var $5069c0a6674ea06d$var$getRules = function getRules(value, points) {
    return (0, $Z9Jjr.dealloc)($5069c0a6674ea06d$var$toRules((0, $Z9Jjr.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $5069c0a6674ea06d$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $5069c0a6674ea06d$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$5069c0a6674ea06d$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $5069c0a6674ea06d$var$fixedElements.set(element, true);
    var points = [];
    var rules = $5069c0a6674ea06d$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $5069c0a6674ea06d$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $5069c0a6674ea06d$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $5069c0a6674ea06d$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($5069c0a6674ea06d$var$ignoreFlag) > -1;
};
var $5069c0a6674ea06d$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($5069c0a6674ea06d$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $5069c0a6674ea06d$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $5069c0a6674ea06d$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$5069c0a6674ea06d$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $5069c0a6674ea06d$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $5069c0a6674ea06d$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$5069c0a6674ea06d$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $5069c0a6674ea06d$var$nullifyElement(element);
    } else if ($5069c0a6674ea06d$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $5069c0a6674ea06d$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $5069c0a6674ea06d$var$prefix(value, length) {
    switch((0, $Z9Jjr.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $Z9Jjr.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $Z9Jjr.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MOZ) + value + (0, $Z9Jjr.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + value + value;
        // order
        case 6165:
            return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.replace)(value, /(\w+).+(:[^]+)/, (0, $Z9Jjr.WEBKIT) + "box-$1$2" + (0, $Z9Jjr.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + "flex-item-" + (0, $Z9Jjr.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + "flex-line-pack" + (0, $Z9Jjr.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + (0, $Z9Jjr.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + (0, $Z9Jjr.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $Z9Jjr.WEBKIT) + "box-" + (0, $Z9Jjr.replace)(value, "-grow", "") + (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + (0, $Z9Jjr.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $Z9Jjr.WEBKIT) + (0, $Z9Jjr.replace)(value, /([^-])(transform)/g, "$1" + (0, $Z9Jjr.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $Z9Jjr.replace)((0, $Z9Jjr.replace)((0, $Z9Jjr.replace)(value, /(zoom-|grab)/, (0, $Z9Jjr.WEBKIT) + "$1"), /(image-set)/, (0, $Z9Jjr.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $Z9Jjr.replace)(value, /(image-set\([^]*)/, (0, $Z9Jjr.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $Z9Jjr.replace)((0, $Z9Jjr.replace)(value, /(.+:)(flex-)?(.*)/, (0, $Z9Jjr.WEBKIT) + "box-pack:$3" + (0, $Z9Jjr.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $Z9Jjr.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $Z9Jjr.replace)(value, /(.+)-inline(.+)/, (0, $Z9Jjr.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $Z9Jjr.strlen)(value) - 1 - length > 6) switch((0, $Z9Jjr.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $Z9Jjr.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $Z9Jjr.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $Z9Jjr.WEBKIT) + "$2-$3" + "$1" + (0, $Z9Jjr.MOZ) + ((0, $Z9Jjr.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $Z9Jjr.indexof)(value, "stretch") ? $5069c0a6674ea06d$var$prefix((0, $Z9Jjr.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $Z9Jjr.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $Z9Jjr.charat)(value, (0, $Z9Jjr.strlen)(value) - 3 - (~(0, $Z9Jjr.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $Z9Jjr.replace)(value, ":", ":" + (0, $Z9Jjr.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $Z9Jjr.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $Z9Jjr.WEBKIT) + ((0, $Z9Jjr.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $Z9Jjr.WEBKIT) + "$2$3" + "$1" + (0, $Z9Jjr.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $Z9Jjr.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + (0, $Z9Jjr.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + (0, $Z9Jjr.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + (0, $Z9Jjr.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $Z9Jjr.WEBKIT) + value + (0, $Z9Jjr.MS) + value + value;
    }
    return value;
}
var $5069c0a6674ea06d$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $Z9Jjr.DECLARATION:
                element["return"] = $5069c0a6674ea06d$var$prefix(element.value, element.length);
                break;
            case 0, $Z9Jjr.KEYFRAMES:
                return (0, $Z9Jjr.serialize)([
                    (0, $Z9Jjr.copy)(element, {
                        value: (0, $Z9Jjr.replace)(element.value, "@", "@" + (0, $Z9Jjr.WEBKIT))
                    })
                ], callback);
            case 0, $Z9Jjr.RULESET:
                if (element.length) return (0, $Z9Jjr.combine)(element.props, function(value) {
                    switch((0, $Z9Jjr.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $Z9Jjr.serialize)([
                                (0, $Z9Jjr.copy)(element, {
                                    props: [
                                        (0, $Z9Jjr.replace)(value, /:(read-\w+)/, ":" + (0, $Z9Jjr.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $Z9Jjr.serialize)([
                                (0, $Z9Jjr.copy)(element, {
                                    props: [
                                        (0, $Z9Jjr.replace)(value, /:(plac\w+)/, ":" + (0, $Z9Jjr.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $Z9Jjr.copy)(element, {
                                    props: [
                                        (0, $Z9Jjr.replace)(value, /:(plac\w+)/, ":" + (0, $Z9Jjr.MOZ) + "$1")
                                    ]
                                }),
                                (0, $Z9Jjr.copy)(element, {
                                    props: [
                                        (0, $Z9Jjr.replace)(value, /:(plac\w+)/, (0, $Z9Jjr.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $5069c0a6674ea06d$var$defaultStylisPlugins = [
    $5069c0a6674ea06d$var$prefixer
];
var $5069c0a6674ea06d$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $5069c0a6674ea06d$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $5069c0a6674ea06d$var$compat,
        $5069c0a6674ea06d$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $Z9Jjr.stringify),
        (0, $Z9Jjr.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $Z9Jjr.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $Z9Jjr.serialize)((0, $Z9Jjr.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $8wjkc.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("8wjkc", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $63404d676f6f050f$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $63404d676f6f050f$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $63404d676f6f050f$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $63404d676f6f050f$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($63404d676f6f050f$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $63404d676f6f050f$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("Z9Jjr", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $ed38a01b94ce656a$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $ed38a01b94ce656a$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $ed38a01b94ce656a$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $ed38a01b94ce656a$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $ed38a01b94ce656a$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $ed38a01b94ce656a$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $ed38a01b94ce656a$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $ed38a01b94ce656a$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $ed38a01b94ce656a$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $ed38a01b94ce656a$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $ed38a01b94ce656a$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $ed38a01b94ce656a$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $ed38a01b94ce656a$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $ed38a01b94ce656a$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $ed38a01b94ce656a$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $ed38a01b94ce656a$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $ed38a01b94ce656a$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $ed38a01b94ce656a$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $ed38a01b94ce656a$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $ed38a01b94ce656a$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $ed38a01b94ce656a$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $ed38a01b94ce656a$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $ed38a01b94ce656a$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $ed38a01b94ce656a$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $ed38a01b94ce656a$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $ed38a01b94ce656a$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $ed38a01b94ce656a$export$38bcb760f1d4871c; });
var $ed38a01b94ce656a$export$71ad59f2e432cfe8 = "-ms-";
var $ed38a01b94ce656a$export$2c0f367103c8d01c = "-moz-";
var $ed38a01b94ce656a$export$39dfd62a25e0fe93 = "-webkit-";
var $ed38a01b94ce656a$export$a29989082612d0d9 = "comm";
var $ed38a01b94ce656a$export$aa3a2e812ca8570d = "rule";
var $ed38a01b94ce656a$export$527d108ccf083c2b = "decl";
var $ed38a01b94ce656a$export$d3d35020fa5b54f0 = "@page";
var $ed38a01b94ce656a$export$500415a86c544f73 = "@media";
var $ed38a01b94ce656a$export$a763edbf796b780a = "@import";
var $ed38a01b94ce656a$export$2790aeb8b4e5c826 = "@charset";
var $ed38a01b94ce656a$export$1cc683e23b84b133 = "@viewport";
var $ed38a01b94ce656a$export$9447a5efea57e862 = "@supports";
var $ed38a01b94ce656a$export$ef011b4e114b1fba = "@document";
var $ed38a01b94ce656a$export$6aad947bda0f3f46 = "@namespace";
var $ed38a01b94ce656a$export$b44a8529a35fcb60 = "@keyframes";
var $ed38a01b94ce656a$export$2c16de31893252e6 = "@font-face";
var $ed38a01b94ce656a$export$3d846dd52e150c6f = "@counter-style";
var $ed38a01b94ce656a$export$22314bfbb57653fe = "@font-feature-values";
var $ed38a01b94ce656a$export$d773506282b3cfe6 = "@layer";
var $ed38a01b94ce656a$export$2335f513bbd82c6d = Math.abs;
var $ed38a01b94ce656a$export$6788812c4e6611e6 = String.fromCharCode;
var $ed38a01b94ce656a$export$e6e34fd1f2686227 = Object.assign;
function $ed38a01b94ce656a$export$d6af199866bfb566(e, r) {
    return $ed38a01b94ce656a$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $ed38a01b94ce656a$export$a9db5e087081082d(e, 0)) << 2 ^ $ed38a01b94ce656a$export$a9db5e087081082d(e, 1)) << 2 ^ $ed38a01b94ce656a$export$a9db5e087081082d(e, 2)) << 2 ^ $ed38a01b94ce656a$export$a9db5e087081082d(e, 3) : 0;
}
function $ed38a01b94ce656a$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $ed38a01b94ce656a$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $ed38a01b94ce656a$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $ed38a01b94ce656a$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $ed38a01b94ce656a$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $ed38a01b94ce656a$export$36776f635604f274(e) {
    return e.length;
}
function $ed38a01b94ce656a$export$f9084667e487ed46(e) {
    return e.length;
}
function $ed38a01b94ce656a$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $ed38a01b94ce656a$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $ed38a01b94ce656a$export$53f1d5ea8de3d7c = 1;
var $ed38a01b94ce656a$export$4e0c71f277ca26b3 = 1;
var $ed38a01b94ce656a$export$f24224f1c91d8156 = 0;
var $ed38a01b94ce656a$export$5880b8b5730aff45 = 0;
var $ed38a01b94ce656a$export$c0306caf338ac095 = 0;
var $ed38a01b94ce656a$export$30a86d91af8ff6e6 = "";
function $ed38a01b94ce656a$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $ed38a01b94ce656a$export$53f1d5ea8de3d7c,
        column: $ed38a01b94ce656a$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $ed38a01b94ce656a$export$784d13d8ee351f07(e, r) {
    return $ed38a01b94ce656a$export$e6e34fd1f2686227($ed38a01b94ce656a$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $ed38a01b94ce656a$export$eba6f6f03b0a92e7() {
    return $ed38a01b94ce656a$export$c0306caf338ac095;
}
function $ed38a01b94ce656a$export$232faf9add678146() {
    $ed38a01b94ce656a$export$c0306caf338ac095 = $ed38a01b94ce656a$export$5880b8b5730aff45 > 0 ? $ed38a01b94ce656a$export$a9db5e087081082d($ed38a01b94ce656a$export$30a86d91af8ff6e6, --$ed38a01b94ce656a$export$5880b8b5730aff45) : 0;
    if ($ed38a01b94ce656a$export$4e0c71f277ca26b3--, $ed38a01b94ce656a$export$c0306caf338ac095 === 10) $ed38a01b94ce656a$export$4e0c71f277ca26b3 = 1, $ed38a01b94ce656a$export$53f1d5ea8de3d7c--;
    return $ed38a01b94ce656a$export$c0306caf338ac095;
}
function $ed38a01b94ce656a$export$48cfd1e771a65c4f() {
    $ed38a01b94ce656a$export$c0306caf338ac095 = $ed38a01b94ce656a$export$5880b8b5730aff45 < $ed38a01b94ce656a$export$f24224f1c91d8156 ? $ed38a01b94ce656a$export$a9db5e087081082d($ed38a01b94ce656a$export$30a86d91af8ff6e6, $ed38a01b94ce656a$export$5880b8b5730aff45++) : 0;
    if ($ed38a01b94ce656a$export$4e0c71f277ca26b3++, $ed38a01b94ce656a$export$c0306caf338ac095 === 10) $ed38a01b94ce656a$export$4e0c71f277ca26b3 = 1, $ed38a01b94ce656a$export$53f1d5ea8de3d7c++;
    return $ed38a01b94ce656a$export$c0306caf338ac095;
}
function $ed38a01b94ce656a$export$4d3fb11e950abb9e() {
    return $ed38a01b94ce656a$export$a9db5e087081082d($ed38a01b94ce656a$export$30a86d91af8ff6e6, $ed38a01b94ce656a$export$5880b8b5730aff45);
}
function $ed38a01b94ce656a$export$e88cb2efb12ae807() {
    return $ed38a01b94ce656a$export$5880b8b5730aff45;
}
function $ed38a01b94ce656a$export$58adb3bec8346d0f(e, r) {
    return $ed38a01b94ce656a$export$2f35ab04d2335697($ed38a01b94ce656a$export$30a86d91af8ff6e6, e, r);
}
function $ed38a01b94ce656a$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $ed38a01b94ce656a$export$2de70f21292aac9e(e) {
    return $ed38a01b94ce656a$export$53f1d5ea8de3d7c = $ed38a01b94ce656a$export$4e0c71f277ca26b3 = 1, $ed38a01b94ce656a$export$f24224f1c91d8156 = $ed38a01b94ce656a$export$36776f635604f274($ed38a01b94ce656a$export$30a86d91af8ff6e6 = e), $ed38a01b94ce656a$export$5880b8b5730aff45 = 0, [];
}
function $ed38a01b94ce656a$export$45918ac1574455b1(e) {
    return $ed38a01b94ce656a$export$30a86d91af8ff6e6 = "", e;
}
function $ed38a01b94ce656a$export$410ac95b9ec204b8(e) {
    return $ed38a01b94ce656a$export$87c2784dc9fc4ab($ed38a01b94ce656a$export$58adb3bec8346d0f($ed38a01b94ce656a$export$5880b8b5730aff45 - 1, $ed38a01b94ce656a$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $ed38a01b94ce656a$export$660b2ee2d4fb4eff(e) {
    return $ed38a01b94ce656a$export$45918ac1574455b1($ed38a01b94ce656a$export$5f8c09e3ae6f64e1($ed38a01b94ce656a$export$2de70f21292aac9e(e)));
}
function $ed38a01b94ce656a$export$7af1228ff777d175(e) {
    while($ed38a01b94ce656a$export$c0306caf338ac095 = $ed38a01b94ce656a$export$4d3fb11e950abb9e())if ($ed38a01b94ce656a$export$c0306caf338ac095 < 33) $ed38a01b94ce656a$export$48cfd1e771a65c4f();
    else break;
    return $ed38a01b94ce656a$export$9e1725a4cfeada27(e) > 2 || $ed38a01b94ce656a$export$9e1725a4cfeada27($ed38a01b94ce656a$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $ed38a01b94ce656a$export$5f8c09e3ae6f64e1(e) {
    while($ed38a01b94ce656a$export$48cfd1e771a65c4f())switch($ed38a01b94ce656a$export$9e1725a4cfeada27($ed38a01b94ce656a$export$c0306caf338ac095)){
        case 0:
            $ed38a01b94ce656a$export$10d8903dec122b9d($ed38a01b94ce656a$export$c2ab62c7bf24634($ed38a01b94ce656a$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $ed38a01b94ce656a$export$10d8903dec122b9d($ed38a01b94ce656a$export$410ac95b9ec204b8($ed38a01b94ce656a$export$c0306caf338ac095), e);
            break;
        default:
            $ed38a01b94ce656a$export$10d8903dec122b9d($ed38a01b94ce656a$export$6788812c4e6611e6($ed38a01b94ce656a$export$c0306caf338ac095), e);
    }
    return e;
}
function $ed38a01b94ce656a$export$955ba06d119e085e(e, r) {
    while(--r && $ed38a01b94ce656a$export$48cfd1e771a65c4f())if ($ed38a01b94ce656a$export$c0306caf338ac095 < 48 || $ed38a01b94ce656a$export$c0306caf338ac095 > 102 || $ed38a01b94ce656a$export$c0306caf338ac095 > 57 && $ed38a01b94ce656a$export$c0306caf338ac095 < 65 || $ed38a01b94ce656a$export$c0306caf338ac095 > 70 && $ed38a01b94ce656a$export$c0306caf338ac095 < 97) break;
    return $ed38a01b94ce656a$export$58adb3bec8346d0f(e, $ed38a01b94ce656a$export$e88cb2efb12ae807() + (r < 6 && $ed38a01b94ce656a$export$4d3fb11e950abb9e() == 32 && $ed38a01b94ce656a$export$48cfd1e771a65c4f() == 32));
}
function $ed38a01b94ce656a$export$c889f2fcc19dbf12(e) {
    while($ed38a01b94ce656a$export$48cfd1e771a65c4f())switch($ed38a01b94ce656a$export$c0306caf338ac095){
        case e:
            return $ed38a01b94ce656a$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $ed38a01b94ce656a$export$c889f2fcc19dbf12($ed38a01b94ce656a$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $ed38a01b94ce656a$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $ed38a01b94ce656a$export$48cfd1e771a65c4f();
            break;
    }
    return $ed38a01b94ce656a$export$5880b8b5730aff45;
}
function $ed38a01b94ce656a$export$4254d4e2b3745c4c(e, r) {
    while($ed38a01b94ce656a$export$48cfd1e771a65c4f())if (e + $ed38a01b94ce656a$export$c0306caf338ac095 === 57) break;
    else if (e + $ed38a01b94ce656a$export$c0306caf338ac095 === 84 && $ed38a01b94ce656a$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $ed38a01b94ce656a$export$58adb3bec8346d0f(r, $ed38a01b94ce656a$export$5880b8b5730aff45 - 1) + "*" + $ed38a01b94ce656a$export$6788812c4e6611e6(e === 47 ? e : $ed38a01b94ce656a$export$48cfd1e771a65c4f());
}
function $ed38a01b94ce656a$export$c2ab62c7bf24634(e) {
    while(!$ed38a01b94ce656a$export$9e1725a4cfeada27($ed38a01b94ce656a$export$4d3fb11e950abb9e()))$ed38a01b94ce656a$export$48cfd1e771a65c4f();
    return $ed38a01b94ce656a$export$58adb3bec8346d0f(e, $ed38a01b94ce656a$export$5880b8b5730aff45);
}
function $ed38a01b94ce656a$export$ef7acd7185315e22(e) {
    return $ed38a01b94ce656a$export$45918ac1574455b1($ed38a01b94ce656a$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $ed38a01b94ce656a$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $ed38a01b94ce656a$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $ed38a01b94ce656a$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $ed38a01b94ce656a$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($ed38a01b94ce656a$export$f8e21b1e77979a08(j += $ed38a01b94ce656a$export$77ad94ebf1c2b9ed($ed38a01b94ce656a$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $ed38a01b94ce656a$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $ed38a01b94ce656a$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $ed38a01b94ce656a$export$955ba06d119e085e($ed38a01b94ce656a$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($ed38a01b94ce656a$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $ed38a01b94ce656a$export$10d8903dec122b9d($ed38a01b94ce656a$export$4a34f930e789283c($ed38a01b94ce656a$export$4254d4e2b3745c4c($ed38a01b94ce656a$export$48cfd1e771a65c4f(), $ed38a01b94ce656a$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $ed38a01b94ce656a$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $ed38a01b94ce656a$export$36776f635604f274(j) - l) $ed38a01b94ce656a$export$10d8903dec122b9d(p > 32 ? $ed38a01b94ce656a$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $ed38a01b94ce656a$export$f8483753829ec8f3($ed38a01b94ce656a$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $ed38a01b94ce656a$export$10d8903dec122b9d(y = $ed38a01b94ce656a$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $ed38a01b94ce656a$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $ed38a01b94ce656a$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $ed38a01b94ce656a$export$98e6a39c04603d36(e, y, y, n && $ed38a01b94ce656a$export$10d8903dec122b9d($ed38a01b94ce656a$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $ed38a01b94ce656a$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $ed38a01b94ce656a$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $ed38a01b94ce656a$export$232faf9add678146() == 125) continue;
            }
            switch(j += $ed38a01b94ce656a$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($ed38a01b94ce656a$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($ed38a01b94ce656a$export$4d3fb11e950abb9e() === 45) j += $ed38a01b94ce656a$export$410ac95b9ec204b8($ed38a01b94ce656a$export$48cfd1e771a65c4f());
                    v = $ed38a01b94ce656a$export$4d3fb11e950abb9e(), o = l = $ed38a01b94ce656a$export$36776f635604f274(g = j += $ed38a01b94ce656a$export$c2ab62c7bf24634($ed38a01b94ce656a$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $ed38a01b94ce656a$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $ed38a01b94ce656a$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $ed38a01b94ce656a$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $ed38a01b94ce656a$export$2f35ab04d2335697(e, v + 1, v = $ed38a01b94ce656a$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $ed38a01b94ce656a$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $ed38a01b94ce656a$export$35059013cd4a06db(e, r, a, s === 0 ? $ed38a01b94ce656a$export$aa3a2e812ca8570d : i, f, o, l);
}
function $ed38a01b94ce656a$export$4a34f930e789283c(e, r, a) {
    return $ed38a01b94ce656a$export$35059013cd4a06db(e, r, a, $ed38a01b94ce656a$export$a29989082612d0d9, $ed38a01b94ce656a$export$6788812c4e6611e6($ed38a01b94ce656a$export$eba6f6f03b0a92e7()), $ed38a01b94ce656a$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $ed38a01b94ce656a$export$f8483753829ec8f3(e, r, a, n) {
    return $ed38a01b94ce656a$export$35059013cd4a06db(e, r, a, $ed38a01b94ce656a$export$527d108ccf083c2b, $ed38a01b94ce656a$export$2f35ab04d2335697(e, 0, n), $ed38a01b94ce656a$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $ed38a01b94ce656a$export$82e9f45cca5ba907(n, c, s) {
    switch($ed38a01b94ce656a$export$d6af199866bfb566(n, c)){
        case 5103:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $ed38a01b94ce656a$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$2c0f367103c8d01c + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($ed38a01b94ce656a$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "box-$1$2" + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + "flex-item-" + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$ed38a01b94ce656a$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $ed38a01b94ce656a$export$71ad59f2e432cfe8 + "grid-row-" + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + "flex-line-pack" + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "box-" + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, "-grow", "") + $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $ed38a01b94ce656a$export$39dfd62a25e0fe93 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed($ed38a01b94ce656a$export$77ad94ebf1c2b9ed($ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed($ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "box-pack:$3" + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $ed38a01b94ce656a$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$ed38a01b94ce656a$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $ed38a01b94ce656a$export$71ad59f2e432cfe8 + "grid-column-align" + $ed38a01b94ce656a$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $ed38a01b94ce656a$export$71ad59f2e432cfe8 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $ed38a01b94ce656a$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$ed38a01b94ce656a$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $ed38a01b94ce656a$export$71ad59f2e432cfe8 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$ed38a01b94ce656a$export$f8e21b1e77979a08(s, "span") ? $ed38a01b94ce656a$export$4659b591c19bdf3d(s, /\d+/) : +$ed38a01b94ce656a$export$4659b591c19bdf3d(s, /\d+/) - +$ed38a01b94ce656a$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $ed38a01b94ce656a$export$71ad59f2e432cfe8 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $ed38a01b94ce656a$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $ed38a01b94ce656a$export$71ad59f2e432cfe8 + $ed38a01b94ce656a$export$77ad94ebf1c2b9ed($ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($ed38a01b94ce656a$export$36776f635604f274(n) - 1 - c > 6) switch($ed38a01b94ce656a$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($ed38a01b94ce656a$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $ed38a01b94ce656a$export$2c0f367103c8d01c + ($ed38a01b94ce656a$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$ed38a01b94ce656a$export$f8e21b1e77979a08(n, "stretch") ? $ed38a01b94ce656a$export$82e9f45cca5ba907($ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $ed38a01b94ce656a$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $ed38a01b94ce656a$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($ed38a01b94ce656a$export$a9db5e087081082d(n, c + 6) === 121) return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, ":", ":" + $ed38a01b94ce656a$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($ed38a01b94ce656a$export$a9db5e087081082d(n, $ed38a01b94ce656a$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $ed38a01b94ce656a$export$39dfd62a25e0fe93 + ($ed38a01b94ce656a$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $ed38a01b94ce656a$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, ":", ":" + $ed38a01b94ce656a$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $ed38a01b94ce656a$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $ed38a01b94ce656a$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $ed38a01b94ce656a$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $ed38a01b94ce656a$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $ed38a01b94ce656a$export$a763edbf796b780a:
        case $ed38a01b94ce656a$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $ed38a01b94ce656a$export$a29989082612d0d9:
            return "";
        case $ed38a01b94ce656a$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $ed38a01b94ce656a$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $ed38a01b94ce656a$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $ed38a01b94ce656a$export$36776f635604f274(a = $ed38a01b94ce656a$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $ed38a01b94ce656a$export$5a7767152ae0305f(e) {
    var r = $ed38a01b94ce656a$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $ed38a01b94ce656a$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $ed38a01b94ce656a$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $ed38a01b94ce656a$export$527d108ccf083c2b:
                n.return = $ed38a01b94ce656a$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $ed38a01b94ce656a$export$b44a8529a35fcb60:
                return $ed38a01b94ce656a$export$dfdc1655ccc5b9cb([
                    $ed38a01b94ce656a$export$784d13d8ee351f07(n, {
                        value: $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $ed38a01b94ce656a$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $ed38a01b94ce656a$export$aa3a2e812ca8570d:
                if (n.length) return $ed38a01b94ce656a$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($ed38a01b94ce656a$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $ed38a01b94ce656a$export$dfdc1655ccc5b9cb([
                                $ed38a01b94ce656a$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $ed38a01b94ce656a$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $ed38a01b94ce656a$export$dfdc1655ccc5b9cb([
                                $ed38a01b94ce656a$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $ed38a01b94ce656a$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $ed38a01b94ce656a$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $ed38a01b94ce656a$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $ed38a01b94ce656a$export$784d13d8ee351f07(n, {
                                    props: [
                                        $ed38a01b94ce656a$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $ed38a01b94ce656a$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $ed38a01b94ce656a$export$76a88f7de6507443(e) {
    switch(e.type){
        case $ed38a01b94ce656a$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $ed38a01b94ce656a$export$1be1fc439b849fdf($ed38a01b94ce656a$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($ed38a01b94ce656a$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $ed38a01b94ce656a$export$2f35ab04d2335697(r, 1, $ed38a01b94ce656a$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $ed38a01b94ce656a$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $ed38a01b94ce656a$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $ed38a01b94ce656a$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("690Ou", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $479436dd4d1ca543$export$2e2bcd8739ae039; });
var $479436dd4d1ca543$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});


parcelRegister("7EXVY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $593ac279a56ddcf3$export$2e2bcd8739ae039; });

var $k3pIl = parcelRequire("k3pIl");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $593ac279a56ddcf3$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($k3pIl)))(targetComponent, sourceComponent);
};

});
parcelRegister("k3pIl", function(module, exports) {
"use strict";

var $6OXEB = parcelRequire("6OXEB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $e99808c1a6a4e810$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $e99808c1a6a4e810$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $e99808c1a6a4e810$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $e99808c1a6a4e810$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $e99808c1a6a4e810$var$TYPE_STATICS = {};
$e99808c1a6a4e810$var$TYPE_STATICS[$6OXEB.ForwardRef] = $e99808c1a6a4e810$var$FORWARD_REF_STATICS;
$e99808c1a6a4e810$var$TYPE_STATICS[$6OXEB.Memo] = $e99808c1a6a4e810$var$MEMO_STATICS;
function $e99808c1a6a4e810$var$getStatics(component) {
    // React v16.11 and below
    if ($6OXEB.isMemo(component)) return $e99808c1a6a4e810$var$MEMO_STATICS;
     // React v16.12 and above
    return $e99808c1a6a4e810$var$TYPE_STATICS[component["$$typeof"]] || $e99808c1a6a4e810$var$REACT_STATICS;
}
var $e99808c1a6a4e810$var$defineProperty = Object.defineProperty;
var $e99808c1a6a4e810$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $e99808c1a6a4e810$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $e99808c1a6a4e810$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $e99808c1a6a4e810$var$getPrototypeOf = Object.getPrototypeOf;
var $e99808c1a6a4e810$var$objectPrototype = Object.prototype;
function $e99808c1a6a4e810$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($e99808c1a6a4e810$var$objectPrototype) {
            var inheritedComponent = $e99808c1a6a4e810$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $e99808c1a6a4e810$var$objectPrototype) $e99808c1a6a4e810$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $e99808c1a6a4e810$var$getOwnPropertyNames(sourceComponent);
        if ($e99808c1a6a4e810$var$getOwnPropertySymbols) keys = keys.concat($e99808c1a6a4e810$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $e99808c1a6a4e810$var$getStatics(targetComponent);
        var sourceStatics = $e99808c1a6a4e810$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$e99808c1a6a4e810$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $e99808c1a6a4e810$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $e99808c1a6a4e810$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $e99808c1a6a4e810$var$hoistNonReactStatics;

});
parcelRegister("6OXEB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dAcci"));

});



parcelRegister("1iqNI", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $0f1c42fad801e9e4$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $0f1c42fad801e9e4$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $0f1c42fad801e9e4$export$6f077d94b33a01aa; });
var $0f1c42fad801e9e4$var$isBrowser = true;
function $0f1c42fad801e9e4$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $0f1c42fad801e9e4$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $0f1c42fad801e9e4$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $0f1c42fad801e9e4$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $0f1c42fad801e9e4$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("czYvb", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $9287af588e294b4f$export$6321afa313b251b5; });

var $5A6Qa = parcelRequire("5A6Qa");

var $lcOSZ = parcelRequire("lcOSZ");

var $1r7Iy = parcelRequire("1r7Iy");
var $9287af588e294b4f$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $9287af588e294b4f$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $9287af588e294b4f$var$hyphenateRegex = /[A-Z]|^ms/g;
var $9287af588e294b4f$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $9287af588e294b4f$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $9287af588e294b4f$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $9287af588e294b4f$var$processStyleName = /* #__PURE__ */ (0, $1r7Iy.default)(function(styleName) {
    return $9287af588e294b4f$var$isCustomProperty(styleName) ? styleName : styleName.replace($9287af588e294b4f$var$hyphenateRegex, "-$&").toLowerCase();
});
var $9287af588e294b4f$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($9287af588e294b4f$var$animationRegex, function(match, p1, p2) {
                $9287af588e294b4f$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $9287af588e294b4f$var$cursor
                };
                return p1;
            });
    }
    if ((0, $lcOSZ.default)[key] !== 1 && !$9287af588e294b4f$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $9287af588e294b4f$var$contentValuePattern, $9287af588e294b4f$var$contentValues, $9287af588e294b4f$var$oldProcessStyleValue, $9287af588e294b4f$var$msPattern, $9287af588e294b4f$var$hyphenPattern, $9287af588e294b4f$var$hyphenatedCache;
var $9287af588e294b4f$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $9287af588e294b4f$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $9287af588e294b4f$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $9287af588e294b4f$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $9287af588e294b4f$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $9287af588e294b4f$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $9287af588e294b4f$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $9287af588e294b4f$var$cursor;
                var result = interpolation(mergedProps);
                $9287af588e294b4f$var$cursor = previousCursor;
                return $9287af588e294b4f$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $9287af588e294b4f$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $9287af588e294b4f$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($9287af588e294b4f$var$isProcessableValue(value)) string += $9287af588e294b4f$var$processStyleName(_key) + ":" + $9287af588e294b4f$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($9287af588e294b4f$var$isProcessableValue(value[_i])) string += $9287af588e294b4f$var$processStyleName(_key) + ":" + $9287af588e294b4f$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $9287af588e294b4f$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $9287af588e294b4f$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $9287af588e294b4f$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $9287af588e294b4f$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $9287af588e294b4f$var$cursor;
var $9287af588e294b4f$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $9287af588e294b4f$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $9287af588e294b4f$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $9287af588e294b4f$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $9287af588e294b4f$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $9287af588e294b4f$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $5A6Qa.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $9287af588e294b4f$var$cursor
    };
};

});
parcelRegister("5A6Qa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41059ee550fdeea0$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $41059ee550fdeea0$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("lcOSZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f70230d4bb69691c$export$2e2bcd8739ae039; });
var $f70230d4bb69691c$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("f5ZwO", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $afd70cda5a20554b$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $afd70cda5a20554b$export$811a713a7276cb9d; });

var $4YNlq = parcelRequire("4YNlq");
var $afd70cda5a20554b$var$syncFallback = function syncFallback(create) {
    return create();
};
var $afd70cda5a20554b$var$useInsertionEffect = $4YNlq.useInsertionEffect ? $4YNlq.useInsertionEffect : false;
var $afd70cda5a20554b$export$db21c7ffa21794e7 = $afd70cda5a20554b$var$useInsertionEffect || $afd70cda5a20554b$var$syncFallback;
var $afd70cda5a20554b$export$811a713a7276cb9d = $afd70cda5a20554b$var$useInsertionEffect || $4YNlq.useLayoutEffect;

});





parcelRegister("5vBaP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $402caeebeee0a55b$export$2e2bcd8739ae039; });
parcelRequire("4YNlq");


var $g89D5 = parcelRequire("g89D5");

var $6U2ij = parcelRequire("6U2ij");

var $izf4p = parcelRequire("izf4p");
"use client";
let $402caeebeee0a55b$var$cache;
if (typeof document === "object") $402caeebeee0a55b$var$cache = (0, $6U2ij.default)({
    key: "css",
    prepend: true
});
function $402caeebeee0a55b$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $402caeebeee0a55b$var$cache ? /*#__PURE__*/ (0, $izf4p.jsx)((0, $g89D5.C), {
        value: $402caeebeee0a55b$var$cache,
        children: children
    }) : children;
}

});
parcelRegister("izf4p", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5OOF9"));

});


parcelRegister("hQFs4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfe7726d59797e0a$export$2e2bcd8739ae039; });
parcelRequire("4YNlq");


var $8zt0d = parcelRequire("8zt0d");

var $izf4p = parcelRequire("izf4p");
"use client";
function $cfe7726d59797e0a$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $cfe7726d59797e0a$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($cfe7726d59797e0a$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $8zt0d.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("5RBSQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8KsM1")).default; });

var $8KsM1 = parcelRequire("8KsM1");

});
parcelRegister("8KsM1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65e8f07525366f75$export$2e2bcd8739ae039; });

var $7y3ET = parcelRequire("7y3ET");
function $65e8f07525366f75$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $7y3ET.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("2E4f9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("4N8LC")).default; });

var $4N8LC = parcelRequire("4N8LC");
$parcel$exportWildcard(module.exports, $4N8LC);

});
parcelRegister("4N8LC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $37d289fcbe5e2d9a$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $37d289fcbe5e2d9a$export$2e2bcd8739ae039; });

var $dKCZL = parcelRequire("dKCZL");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $37d289fcbe5e2d9a$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $37d289fcbe5e2d9a$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($37d289fcbe5e2d9a$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $37d289fcbe5e2d9a$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $37d289fcbe5e2d9a$export$aad197c7121a6651(Component) || fallback;
}
function $37d289fcbe5e2d9a$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $37d289fcbe5e2d9a$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $37d289fcbe5e2d9a$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $37d289fcbe5e2d9a$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $dKCZL.ForwardRef:
            return $37d289fcbe5e2d9a$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $dKCZL.Memo:
            return $37d289fcbe5e2d9a$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("dKCZL", function(module, exports) {
"use strict";

module.exports = (parcelRequire("33dqt"));

});
parcelRegister("33dqt", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $238c110babea32fc$export$a7c73072b1a182ae; }, function (v) { return $238c110babea32fc$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $238c110babea32fc$export$9f27bc3417b4524d; }, function (v) { return $238c110babea32fc$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $238c110babea32fc$export$db77ccec0bb4ccac; }, function (v) { return $238c110babea32fc$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $238c110babea32fc$export$8392c0c9d3dcbd35; }, function (v) { return $238c110babea32fc$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $238c110babea32fc$export$ffb0004e005737fa; }, function (v) { return $238c110babea32fc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $238c110babea32fc$export$b624eff549462981; }, function (v) { return $238c110babea32fc$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $238c110babea32fc$export$7897aa7841a5380c; }, function (v) { return $238c110babea32fc$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $238c110babea32fc$export$602eac185826482c; }, function (v) { return $238c110babea32fc$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $238c110babea32fc$export$e2c29f18771995cb; }, function (v) { return $238c110babea32fc$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $238c110babea32fc$export$5f8d39834fd61797; }, function (v) { return $238c110babea32fc$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $238c110babea32fc$export$74bf444e3cd11ea5; }, function (v) { return $238c110babea32fc$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $238c110babea32fc$export$998bcd577473dd93; }, function (v) { return $238c110babea32fc$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $238c110babea32fc$export$92387174baf9b227; }, function (v) { return $238c110babea32fc$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $238c110babea32fc$export$ec112efeb987d9c6; }, function (v) { return $238c110babea32fc$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $238c110babea32fc$export$b706b080d889d2c9; }, function (v) { return $238c110babea32fc$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $238c110babea32fc$export$5be5a87408f70ddc; }, function (v) { return $238c110babea32fc$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $238c110babea32fc$export$45a5e7f76e0caa8d; }, function (v) { return $238c110babea32fc$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $238c110babea32fc$export$455c2e768291efa6; }, function (v) { return $238c110babea32fc$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $238c110babea32fc$export$9522e17588c12572; }, function (v) { return $238c110babea32fc$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $238c110babea32fc$export$2110ac352bb060b9; }, function (v) { return $238c110babea32fc$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $238c110babea32fc$export$56885ab8b9c456ab; }, function (v) { return $238c110babea32fc$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $238c110babea32fc$export$d927fcb6adf8f9de; }, function (v) { return $238c110babea32fc$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $238c110babea32fc$export$b82d16f27459e05a; }, function (v) { return $238c110babea32fc$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $238c110babea32fc$export$522c17b4f5e123e8; }, function (v) { return $238c110babea32fc$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $238c110babea32fc$export$1aabd8a0274ecfd6; }, function (v) { return $238c110babea32fc$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $238c110babea32fc$export$3d6c20d97e46b957; }, function (v) { return $238c110babea32fc$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $238c110babea32fc$export$9b621391a187a31a; }, function (v) { return $238c110babea32fc$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $238c110babea32fc$export$f5bbd400c2f4426f; }, function (v) { return $238c110babea32fc$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $238c110babea32fc$export$a7c73072b1a182ae;
var $238c110babea32fc$export$9f27bc3417b4524d;
var $238c110babea32fc$export$db77ccec0bb4ccac;
var $238c110babea32fc$export$8392c0c9d3dcbd35;
var $238c110babea32fc$export$ffb0004e005737fa;
var $238c110babea32fc$export$b624eff549462981;
var $238c110babea32fc$export$7897aa7841a5380c;
var $238c110babea32fc$export$602eac185826482c;
var $238c110babea32fc$export$e2c29f18771995cb;
var $238c110babea32fc$export$5f8d39834fd61797;
var $238c110babea32fc$export$74bf444e3cd11ea5;
var $238c110babea32fc$export$998bcd577473dd93;
var $238c110babea32fc$export$92387174baf9b227;
var $238c110babea32fc$export$ec112efeb987d9c6;
var $238c110babea32fc$export$b706b080d889d2c9;
var $238c110babea32fc$export$5be5a87408f70ddc;
var $238c110babea32fc$export$45a5e7f76e0caa8d;
var $238c110babea32fc$export$455c2e768291efa6;
var $238c110babea32fc$export$9522e17588c12572;
var $238c110babea32fc$export$2110ac352bb060b9;
var $238c110babea32fc$export$56885ab8b9c456ab;
var $238c110babea32fc$export$d927fcb6adf8f9de;
var $238c110babea32fc$export$b82d16f27459e05a;
var $238c110babea32fc$export$522c17b4f5e123e8;
var $238c110babea32fc$export$1aabd8a0274ecfd6;
var $238c110babea32fc$export$3d6c20d97e46b957;
var $238c110babea32fc$export$9b621391a187a31a;
var $238c110babea32fc$export$f5bbd400c2f4426f;
"use strict";
var $238c110babea32fc$var$b = Symbol.for("react.element"), $238c110babea32fc$var$c = Symbol.for("react.portal"), $238c110babea32fc$var$d = Symbol.for("react.fragment"), $238c110babea32fc$var$e = Symbol.for("react.strict_mode"), $238c110babea32fc$var$f = Symbol.for("react.profiler"), $238c110babea32fc$var$g = Symbol.for("react.provider"), $238c110babea32fc$var$h = Symbol.for("react.context"), $238c110babea32fc$var$k = Symbol.for("react.server_context"), $238c110babea32fc$var$l = Symbol.for("react.forward_ref"), $238c110babea32fc$var$m = Symbol.for("react.suspense"), $238c110babea32fc$var$n = Symbol.for("react.suspense_list"), $238c110babea32fc$var$p = Symbol.for("react.memo"), $238c110babea32fc$var$q = Symbol.for("react.lazy"), $238c110babea32fc$var$t = Symbol.for("react.offscreen"), $238c110babea32fc$var$u;
$238c110babea32fc$var$u = Symbol.for("react.module.reference");
function $238c110babea32fc$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $238c110babea32fc$var$b:
                switch(a = a.type, a){
                    case $238c110babea32fc$var$d:
                    case $238c110babea32fc$var$f:
                    case $238c110babea32fc$var$e:
                    case $238c110babea32fc$var$m:
                    case $238c110babea32fc$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $238c110babea32fc$var$k:
                            case $238c110babea32fc$var$h:
                            case $238c110babea32fc$var$l:
                            case $238c110babea32fc$var$q:
                            case $238c110babea32fc$var$p:
                            case $238c110babea32fc$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $238c110babea32fc$var$c:
                return r;
        }
    }
}
$238c110babea32fc$export$a7c73072b1a182ae = $238c110babea32fc$var$h;
$238c110babea32fc$export$9f27bc3417b4524d = $238c110babea32fc$var$g;
$238c110babea32fc$export$db77ccec0bb4ccac = $238c110babea32fc$var$b;
$238c110babea32fc$export$8392c0c9d3dcbd35 = $238c110babea32fc$var$l;
$238c110babea32fc$export$ffb0004e005737fa = $238c110babea32fc$var$d;
$238c110babea32fc$export$b624eff549462981 = $238c110babea32fc$var$q;
$238c110babea32fc$export$7897aa7841a5380c = $238c110babea32fc$var$p;
$238c110babea32fc$export$602eac185826482c = $238c110babea32fc$var$c;
$238c110babea32fc$export$e2c29f18771995cb = $238c110babea32fc$var$f;
$238c110babea32fc$export$5f8d39834fd61797 = $238c110babea32fc$var$e;
$238c110babea32fc$export$74bf444e3cd11ea5 = $238c110babea32fc$var$m;
$238c110babea32fc$export$998bcd577473dd93 = $238c110babea32fc$var$n;
$238c110babea32fc$export$92387174baf9b227 = function() {
    return !1;
};
$238c110babea32fc$export$ec112efeb987d9c6 = function() {
    return !1;
};
$238c110babea32fc$export$b706b080d889d2c9 = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$h;
};
$238c110babea32fc$export$5be5a87408f70ddc = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$g;
};
$238c110babea32fc$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $238c110babea32fc$var$b;
};
$238c110babea32fc$export$455c2e768291efa6 = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$l;
};
$238c110babea32fc$export$9522e17588c12572 = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$d;
};
$238c110babea32fc$export$2110ac352bb060b9 = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$q;
};
$238c110babea32fc$export$56885ab8b9c456ab = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$p;
};
$238c110babea32fc$export$d927fcb6adf8f9de = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$c;
};
$238c110babea32fc$export$b82d16f27459e05a = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$f;
};
$238c110babea32fc$export$522c17b4f5e123e8 = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$e;
};
$238c110babea32fc$export$1aabd8a0274ecfd6 = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$m;
};
$238c110babea32fc$export$3d6c20d97e46b957 = function(a) {
    return $238c110babea32fc$var$v(a) === $238c110babea32fc$var$n;
};
$238c110babea32fc$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $238c110babea32fc$var$d || a === $238c110babea32fc$var$f || a === $238c110babea32fc$var$e || a === $238c110babea32fc$var$m || a === $238c110babea32fc$var$n || a === $238c110babea32fc$var$t || "object" === typeof a && null !== a && (a.$$typeof === $238c110babea32fc$var$q || a.$$typeof === $238c110babea32fc$var$p || a.$$typeof === $238c110babea32fc$var$g || a.$$typeof === $238c110babea32fc$var$h || a.$$typeof === $238c110babea32fc$var$l || a.$$typeof === $238c110babea32fc$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$238c110babea32fc$export$f5bbd400c2f4426f = $238c110babea32fc$var$v;

});




parcelRegister("gFlR2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3U7IY")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("4M0tZ")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("fRMyW")).default; });

var $3U7IY = parcelRequire("3U7IY");

var $4M0tZ = parcelRequire("4M0tZ");

var $fRMyW = parcelRequire("fRMyW");

});
parcelRegister("3U7IY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d7c97f62fe0018b$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $c4QxQ = parcelRequire("c4QxQ");

var $4M0tZ = parcelRequire("4M0tZ");

var $2RacB = parcelRequire("2RacB");

var $iAFXO = parcelRequire("iAFXO");

var $5eyOE = parcelRequire("5eyOE");

var $95jiN = parcelRequire("95jiN");

var $fRMyW = parcelRequire("fRMyW");
const $2d7c97f62fe0018b$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $2d7c97f62fe0018b$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $g54n0.default)(options, $2d7c97f62fe0018b$var$_excluded);
    const breakpoints = (0, $4M0tZ.default)(breakpointsInput);
    const spacing = (0, $iAFXO.default)(spacingInput);
    let muiTheme = (0, $c4QxQ.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $lzDk3.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $lzDk3.default)({}, (0, $2RacB.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $fRMyW.default);
    muiTheme = args.reduce((acc, argument)=>(0, $c4QxQ.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $lzDk3.default)({}, (0, $95jiN.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $5eyOE.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $2d7c97f62fe0018b$export$2e2bcd8739ae039 = $2d7c97f62fe0018b$var$createTheme;

});
parcelRegister("g54n0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb5080cb5d79b8dc$export$2e2bcd8739ae039; });
function $bb5080cb5d79b8dc$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});

parcelRegister("c4QxQ", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $8cae9e117ce4c913$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $8cae9e117ce4c913$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");
function $8cae9e117ce4c913$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $8cae9e117ce4c913$var$deepClone(source) {
    if (!$8cae9e117ce4c913$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $8cae9e117ce4c913$var$deepClone(source[key]);
    });
    return output;
}
function $8cae9e117ce4c913$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $lzDk3.default)({}, target) : target;
    if ($8cae9e117ce4c913$export$53b83ca8eaab0383(target) && $8cae9e117ce4c913$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($8cae9e117ce4c913$export$53b83ca8eaab0383(source[key]) && key in target && $8cae9e117ce4c913$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $8cae9e117ce4c913$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $8cae9e117ce4c913$export$53b83ca8eaab0383(source[key]) ? $8cae9e117ce4c913$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("4M0tZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $379c04fe67739473$export$2e2bcd8739ae039; });

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");
const $379c04fe67739473$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $379c04fe67739473$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $379c04fe67739473$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $lzDk3.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $379c04fe67739473$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $g54n0.default)(breakpoints, $379c04fe67739473$var$_excluded);
    const sortedValues = $379c04fe67739473$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $lzDk3.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("2RacB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $214871f7869ca09a$export$2e2bcd8739ae039; });
const $214871f7869ca09a$var$shape = {
    borderRadius: 4
};
var $214871f7869ca09a$export$2e2bcd8739ae039 = $214871f7869ca09a$var$shape;

});

parcelRegister("iAFXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d88c23e5278a550c$export$2e2bcd8739ae039; });

var $5UW2l = parcelRequire("5UW2l");
function $d88c23e5278a550c$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $5UW2l.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("5UW2l", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $44ef339b0d684096$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $44ef339b0d684096$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $44ef339b0d684096$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $44ef339b0d684096$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $44ef339b0d684096$export$6f98e8eaf0be1996; });


var $eY9ud = parcelRequire("eY9ud");

var $5vOuM = parcelRequire("5vOuM");

var $f59mu = parcelRequire("f59mu");

var $97RM6 = parcelRequire("97RM6");
const $44ef339b0d684096$var$properties = {
    m: "margin",
    p: "padding"
};
const $44ef339b0d684096$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $44ef339b0d684096$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $44ef339b0d684096$var$getCssProperties = (0, $97RM6.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($44ef339b0d684096$var$aliases[prop]) prop = $44ef339b0d684096$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $44ef339b0d684096$var$properties[a];
    const direction = $44ef339b0d684096$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $44ef339b0d684096$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $44ef339b0d684096$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $44ef339b0d684096$var$spacingKeys = [
    ...$44ef339b0d684096$export$aab52a0dde05ad8a,
    ...$44ef339b0d684096$export$f8397d44f03ab6ad
];
function $44ef339b0d684096$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $5vOuM.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $44ef339b0d684096$export$1def6f833384e3d1(theme) {
    return $44ef339b0d684096$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $44ef339b0d684096$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $44ef339b0d684096$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $44ef339b0d684096$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $44ef339b0d684096$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $44ef339b0d684096$var$getCssProperties(prop);
    const styleFromPropValue = $44ef339b0d684096$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $eY9ud.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $44ef339b0d684096$var$style(props, keys) {
    const transformer = $44ef339b0d684096$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$44ef339b0d684096$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $f59mu.default), {});
}
function $44ef339b0d684096$export$7ede87f9b603dd3c(props) {
    return $44ef339b0d684096$var$style(props, $44ef339b0d684096$export$aab52a0dde05ad8a);
}
$44ef339b0d684096$export$7ede87f9b603dd3c.propTypes = {};
$44ef339b0d684096$export$7ede87f9b603dd3c.filterProps = $44ef339b0d684096$export$aab52a0dde05ad8a;
function $44ef339b0d684096$export$6f98e8eaf0be1996(props) {
    return $44ef339b0d684096$var$style(props, $44ef339b0d684096$export$f8397d44f03ab6ad);
}
$44ef339b0d684096$export$6f98e8eaf0be1996.propTypes = {};
$44ef339b0d684096$export$6f98e8eaf0be1996.filterProps = $44ef339b0d684096$export$f8397d44f03ab6ad;
function $44ef339b0d684096$var$spacing(props) {
    return $44ef339b0d684096$var$style(props, $44ef339b0d684096$var$spacingKeys);
}
$44ef339b0d684096$var$spacing.propTypes = {};
$44ef339b0d684096$var$spacing.filterProps = $44ef339b0d684096$var$spacingKeys;
var $44ef339b0d684096$export$2e2bcd8739ae039 = $44ef339b0d684096$var$spacing;

});
parcelRegister("eY9ud", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $ae5e0715c1336e19$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $ae5e0715c1336e19$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $ae5e0715c1336e19$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $ae5e0715c1336e19$export$8922c90b6e020726; });
$parcel$export(module.exports, "mergeBreakpointsInOrder", function () { return $ae5e0715c1336e19$export$b89a003a1e05c0ee; });
$parcel$export(module.exports, "resolveBreakpointValues", function () { return $ae5e0715c1336e19$export$980e6a259d807490; });

var $lzDk3 = parcelRequire("lzDk3");


var $c4QxQ = parcelRequire("c4QxQ");

var $f59mu = parcelRequire("f59mu");
const $ae5e0715c1336e19$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $ae5e0715c1336e19$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$ae5e0715c1336e19$export$68c286be0e7e55b7[key]}px)`
};
function $ae5e0715c1336e19$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $ae5e0715c1336e19$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $ae5e0715c1336e19$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $ae5e0715c1336e19$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $ae5e0715c1336e19$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $ae5e0715c1336e19$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $lzDk3.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $f59mu.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $ae5e0715c1336e19$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $ae5e0715c1336e19$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $ae5e0715c1336e19$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $ae5e0715c1336e19$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $c4QxQ.default)(prev, next), {});
    return $ae5e0715c1336e19$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $ae5e0715c1336e19$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $ae5e0715c1336e19$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $ae5e0715c1336e19$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $ae5e0715c1336e19$export$2e2bcd8739ae039 = $ae5e0715c1336e19$var$breakpoints;

});
parcelRegister("f59mu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afae95b404a35086$export$2e2bcd8739ae039; });

var $c4QxQ = parcelRequire("c4QxQ");
function $afae95b404a35086$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $c4QxQ.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $afae95b404a35086$export$2e2bcd8739ae039 = $afae95b404a35086$var$merge;

});


parcelRegister("5vOuM", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $40370456fb54235c$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $40370456fb54235c$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $40370456fb54235c$export$2e2bcd8739ae039; });

var $8KsM1 = parcelRequire("8KsM1");


var $eY9ud = parcelRequire("eY9ud");
function $40370456fb54235c$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $40370456fb54235c$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $40370456fb54235c$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $40370456fb54235c$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $40370456fb54235c$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $40370456fb54235c$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $40370456fb54235c$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $8KsM1.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $eY9ud.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $40370456fb54235c$export$2e2bcd8739ae039 = $40370456fb54235c$var$style;

});

parcelRegister("97RM6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a4e7b0ec8e10831$export$2e2bcd8739ae039; });
function $6a4e7b0ec8e10831$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("5eyOE", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $3cf9444390d8bb1f$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $3cf9444390d8bb1f$export$2e2bcd8739ae039; });

var $8KsM1 = parcelRequire("8KsM1");

var $f59mu = parcelRequire("f59mu");

var $5vOuM = parcelRequire("5vOuM");

var $eY9ud = parcelRequire("eY9ud");

var $95jiN = parcelRequire("95jiN");
function $3cf9444390d8bb1f$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $3cf9444390d8bb1f$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $3cf9444390d8bb1f$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $5vOuM.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $5vOuM.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $5vOuM.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $8KsM1.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $eY9ud.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $95jiN.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $eY9ud.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $3cf9444390d8bb1f$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $f59mu.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $eY9ud.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($3cf9444390d8bb1f$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $f59mu.default)(css, breakpointsValues);
                        }
                    } else css = (0, $f59mu.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $eY9ud.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $3cf9444390d8bb1f$var$styleFunctionSx = $3cf9444390d8bb1f$export$7d53d8bf2911e013();
$3cf9444390d8bb1f$var$styleFunctionSx.filterProps = [
    "sx"
];
var $3cf9444390d8bb1f$export$2e2bcd8739ae039 = $3cf9444390d8bb1f$var$styleFunctionSx;

});
parcelRegister("95jiN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69d38dacdb8715bf$export$2e2bcd8739ae039; });

var $5UW2l = parcelRequire("5UW2l");

var $95qzd = parcelRequire("95qzd");

var $i28LB = parcelRequire("i28LB");

var $aWXyF = parcelRequire("aWXyF");

var $2X4Lq = parcelRequire("2X4Lq");
const $69d38dacdb8715bf$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $95qzd.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $95qzd.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $95qzd.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $95qzd.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $95qzd.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $95qzd.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $95qzd.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $aWXyF.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $aWXyF.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $aWXyF.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $5UW2l.padding)
    },
    pt: {
        style: (0, $5UW2l.padding)
    },
    pr: {
        style: (0, $5UW2l.padding)
    },
    pb: {
        style: (0, $5UW2l.padding)
    },
    pl: {
        style: (0, $5UW2l.padding)
    },
    px: {
        style: (0, $5UW2l.padding)
    },
    py: {
        style: (0, $5UW2l.padding)
    },
    padding: {
        style: (0, $5UW2l.padding)
    },
    paddingTop: {
        style: (0, $5UW2l.padding)
    },
    paddingRight: {
        style: (0, $5UW2l.padding)
    },
    paddingBottom: {
        style: (0, $5UW2l.padding)
    },
    paddingLeft: {
        style: (0, $5UW2l.padding)
    },
    paddingX: {
        style: (0, $5UW2l.padding)
    },
    paddingY: {
        style: (0, $5UW2l.padding)
    },
    paddingInline: {
        style: (0, $5UW2l.padding)
    },
    paddingInlineStart: {
        style: (0, $5UW2l.padding)
    },
    paddingInlineEnd: {
        style: (0, $5UW2l.padding)
    },
    paddingBlock: {
        style: (0, $5UW2l.padding)
    },
    paddingBlockStart: {
        style: (0, $5UW2l.padding)
    },
    paddingBlockEnd: {
        style: (0, $5UW2l.padding)
    },
    m: {
        style: (0, $5UW2l.margin)
    },
    mt: {
        style: (0, $5UW2l.margin)
    },
    mr: {
        style: (0, $5UW2l.margin)
    },
    mb: {
        style: (0, $5UW2l.margin)
    },
    ml: {
        style: (0, $5UW2l.margin)
    },
    mx: {
        style: (0, $5UW2l.margin)
    },
    my: {
        style: (0, $5UW2l.margin)
    },
    margin: {
        style: (0, $5UW2l.margin)
    },
    marginTop: {
        style: (0, $5UW2l.margin)
    },
    marginRight: {
        style: (0, $5UW2l.margin)
    },
    marginBottom: {
        style: (0, $5UW2l.margin)
    },
    marginLeft: {
        style: (0, $5UW2l.margin)
    },
    marginX: {
        style: (0, $5UW2l.margin)
    },
    marginY: {
        style: (0, $5UW2l.margin)
    },
    marginInline: {
        style: (0, $5UW2l.margin)
    },
    marginInlineStart: {
        style: (0, $5UW2l.margin)
    },
    marginInlineEnd: {
        style: (0, $5UW2l.margin)
    },
    marginBlock: {
        style: (0, $5UW2l.margin)
    },
    marginBlockStart: {
        style: (0, $5UW2l.margin)
    },
    marginBlockEnd: {
        style: (0, $5UW2l.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $i28LB.gap)
    },
    rowGap: {
        style: (0, $i28LB.rowGap)
    },
    columnGap: {
        style: (0, $i28LB.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $2X4Lq.sizingTransform)
    },
    maxWidth: {
        style: (0, $2X4Lq.maxWidth)
    },
    minWidth: {
        transform: (0, $2X4Lq.sizingTransform)
    },
    height: {
        transform: (0, $2X4Lq.sizingTransform)
    },
    maxHeight: {
        transform: (0, $2X4Lq.sizingTransform)
    },
    minHeight: {
        transform: (0, $2X4Lq.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $69d38dacdb8715bf$export$2e2bcd8739ae039 = $69d38dacdb8715bf$var$defaultSxConfig;

});
parcelRegister("95qzd", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $69d93058e65e8c16$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $69d93058e65e8c16$export$7a57f79000377ca2; });


var $5vOuM = parcelRequire("5vOuM");

var $c5ken = parcelRequire("c5ken");

var $5UW2l = parcelRequire("5UW2l");

var $eY9ud = parcelRequire("eY9ud");
function $69d93058e65e8c16$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $69d93058e65e8c16$var$createBorderStyle(prop, transform) {
    return (0, $5vOuM.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $69d93058e65e8c16$export$1edee58a52776cd9 = $69d93058e65e8c16$var$createBorderStyle("border", $69d93058e65e8c16$export$34e2febe53ae29cc);
const $69d93058e65e8c16$export$f9a7b6bd24892946 = $69d93058e65e8c16$var$createBorderStyle("borderTop", $69d93058e65e8c16$export$34e2febe53ae29cc);
const $69d93058e65e8c16$export$5abca33e6be905d2 = $69d93058e65e8c16$var$createBorderStyle("borderRight", $69d93058e65e8c16$export$34e2febe53ae29cc);
const $69d93058e65e8c16$export$e2ce9f12a980a822 = $69d93058e65e8c16$var$createBorderStyle("borderBottom", $69d93058e65e8c16$export$34e2febe53ae29cc);
const $69d93058e65e8c16$export$47658cca1a909427 = $69d93058e65e8c16$var$createBorderStyle("borderLeft", $69d93058e65e8c16$export$34e2febe53ae29cc);
const $69d93058e65e8c16$export$e7fb0694ba2404fc = $69d93058e65e8c16$var$createBorderStyle("borderColor");
const $69d93058e65e8c16$export$126a92c968acdb85 = $69d93058e65e8c16$var$createBorderStyle("borderTopColor");
const $69d93058e65e8c16$export$85cc51cb8fbb8c0e = $69d93058e65e8c16$var$createBorderStyle("borderRightColor");
const $69d93058e65e8c16$export$340b0327727f6d1a = $69d93058e65e8c16$var$createBorderStyle("borderBottomColor");
const $69d93058e65e8c16$export$60beef91a985b4bf = $69d93058e65e8c16$var$createBorderStyle("borderLeftColor");
const $69d93058e65e8c16$export$f9258c55612cbed7 = $69d93058e65e8c16$var$createBorderStyle("outline", $69d93058e65e8c16$export$34e2febe53ae29cc);
const $69d93058e65e8c16$export$621fe586efeb64b9 = $69d93058e65e8c16$var$createBorderStyle("outlineColor");
const $69d93058e65e8c16$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $5UW2l.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $5UW2l.getValue)(transformer, propValue)
            });
        return (0, $eY9ud.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$69d93058e65e8c16$export$7a57f79000377ca2.propTypes = {};
$69d93058e65e8c16$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $69d93058e65e8c16$var$borders = (0, $c5ken.default)($69d93058e65e8c16$export$1edee58a52776cd9, $69d93058e65e8c16$export$f9a7b6bd24892946, $69d93058e65e8c16$export$5abca33e6be905d2, $69d93058e65e8c16$export$e2ce9f12a980a822, $69d93058e65e8c16$export$47658cca1a909427, $69d93058e65e8c16$export$e7fb0694ba2404fc, $69d93058e65e8c16$export$126a92c968acdb85, $69d93058e65e8c16$export$85cc51cb8fbb8c0e, $69d93058e65e8c16$export$340b0327727f6d1a, $69d93058e65e8c16$export$60beef91a985b4bf, $69d93058e65e8c16$export$7a57f79000377ca2, $69d93058e65e8c16$export$f9258c55612cbed7, $69d93058e65e8c16$export$621fe586efeb64b9);
var $69d93058e65e8c16$export$2e2bcd8739ae039 = $69d93058e65e8c16$var$borders;

});
parcelRegister("c5ken", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cc5a51668d4ce15$export$2e2bcd8739ae039; });

var $f59mu = parcelRequire("f59mu");
function $8cc5a51668d4ce15$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $f59mu.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $8cc5a51668d4ce15$export$2e2bcd8739ae039 = $8cc5a51668d4ce15$var$compose;

});


parcelRegister("i28LB", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $d20f36c70d0b6578$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $d20f36c70d0b6578$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $d20f36c70d0b6578$export$8a833ffa5f5dbeda; });

var $5vOuM = parcelRequire("5vOuM");

var $c5ken = parcelRequire("c5ken");

var $5UW2l = parcelRequire("5UW2l");

var $eY9ud = parcelRequire("eY9ud");

const $d20f36c70d0b6578$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $5UW2l.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $5UW2l.getValue)(transformer, propValue)
            });
        return (0, $eY9ud.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$d20f36c70d0b6578$export$5df9adcb0db95e1e.propTypes = {};
$d20f36c70d0b6578$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $d20f36c70d0b6578$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $5UW2l.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $5UW2l.getValue)(transformer, propValue)
            });
        return (0, $eY9ud.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$d20f36c70d0b6578$export$ec60d70ff941a580.propTypes = {};
$d20f36c70d0b6578$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $d20f36c70d0b6578$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $5UW2l.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $5UW2l.getValue)(transformer, propValue)
            });
        return (0, $eY9ud.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$d20f36c70d0b6578$export$8a833ffa5f5dbeda.propTypes = {};
$d20f36c70d0b6578$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $d20f36c70d0b6578$export$baf44164ca3a34e8 = (0, $5vOuM.default)({
    prop: "gridColumn"
});
const $d20f36c70d0b6578$export$8f7213a1cd01e832 = (0, $5vOuM.default)({
    prop: "gridRow"
});
const $d20f36c70d0b6578$export$b0e0abbc49ba668 = (0, $5vOuM.default)({
    prop: "gridAutoFlow"
});
const $d20f36c70d0b6578$export$bcd8b929d4b4142 = (0, $5vOuM.default)({
    prop: "gridAutoColumns"
});
const $d20f36c70d0b6578$export$e5039a674e14c828 = (0, $5vOuM.default)({
    prop: "gridAutoRows"
});
const $d20f36c70d0b6578$export$42bd9088661ffb03 = (0, $5vOuM.default)({
    prop: "gridTemplateColumns"
});
const $d20f36c70d0b6578$export$920682ae05b999bc = (0, $5vOuM.default)({
    prop: "gridTemplateRows"
});
const $d20f36c70d0b6578$export$1b88fbdd482fd33a = (0, $5vOuM.default)({
    prop: "gridTemplateAreas"
});
const $d20f36c70d0b6578$export$bdb486e40d52d26f = (0, $5vOuM.default)({
    prop: "gridArea"
});
const $d20f36c70d0b6578$var$grid = (0, $c5ken.default)($d20f36c70d0b6578$export$5df9adcb0db95e1e, $d20f36c70d0b6578$export$ec60d70ff941a580, $d20f36c70d0b6578$export$8a833ffa5f5dbeda, $d20f36c70d0b6578$export$baf44164ca3a34e8, $d20f36c70d0b6578$export$8f7213a1cd01e832, $d20f36c70d0b6578$export$b0e0abbc49ba668, $d20f36c70d0b6578$export$bcd8b929d4b4142, $d20f36c70d0b6578$export$e5039a674e14c828, $d20f36c70d0b6578$export$42bd9088661ffb03, $d20f36c70d0b6578$export$920682ae05b999bc, $d20f36c70d0b6578$export$1b88fbdd482fd33a, $d20f36c70d0b6578$export$bdb486e40d52d26f);
var $d20f36c70d0b6578$export$2e2bcd8739ae039 = $d20f36c70d0b6578$var$grid;

});

parcelRegister("aWXyF", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $7f8d8531cc7d3cc8$export$dbaffd4420ea0ac6; });

var $5vOuM = parcelRequire("5vOuM");

var $c5ken = parcelRequire("c5ken");
function $7f8d8531cc7d3cc8$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $7f8d8531cc7d3cc8$export$35e9368ef982300f = (0, $5vOuM.default)({
    prop: "color",
    themeKey: "palette",
    transform: $7f8d8531cc7d3cc8$export$dbaffd4420ea0ac6
});
const $7f8d8531cc7d3cc8$export$2506f56c10355b33 = (0, $5vOuM.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $7f8d8531cc7d3cc8$export$dbaffd4420ea0ac6
});
const $7f8d8531cc7d3cc8$export$8c5a050822fd698c = (0, $5vOuM.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $7f8d8531cc7d3cc8$export$dbaffd4420ea0ac6
});
const $7f8d8531cc7d3cc8$var$palette = (0, $c5ken.default)($7f8d8531cc7d3cc8$export$35e9368ef982300f, $7f8d8531cc7d3cc8$export$2506f56c10355b33, $7f8d8531cc7d3cc8$export$8c5a050822fd698c);
var $7f8d8531cc7d3cc8$export$2e2bcd8739ae039 = $7f8d8531cc7d3cc8$var$palette;

});

parcelRegister("2X4Lq", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $2264c97344baeb07$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $2264c97344baeb07$export$488fda99655ff65a; });

var $5vOuM = parcelRequire("5vOuM");

var $c5ken = parcelRequire("c5ken");

var $eY9ud = parcelRequire("eY9ud");
function $2264c97344baeb07$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $2264c97344baeb07$export$7e3df82ee760448c = (0, $5vOuM.default)({
    prop: "width",
    transform: $2264c97344baeb07$export$8afece71750ec241
});
const $2264c97344baeb07$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $eY9ud.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $2264c97344baeb07$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $eY9ud.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$2264c97344baeb07$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $2264c97344baeb07$export$ee148fbbe8357dd2 = (0, $5vOuM.default)({
    prop: "minWidth",
    transform: $2264c97344baeb07$export$8afece71750ec241
});
const $2264c97344baeb07$export$ac607276a8fe9f0a = (0, $5vOuM.default)({
    prop: "height",
    transform: $2264c97344baeb07$export$8afece71750ec241
});
const $2264c97344baeb07$export$dc0d8bd0b94f8570 = (0, $5vOuM.default)({
    prop: "maxHeight",
    transform: $2264c97344baeb07$export$8afece71750ec241
});
const $2264c97344baeb07$export$a43cf604e12f3b17 = (0, $5vOuM.default)({
    prop: "minHeight",
    transform: $2264c97344baeb07$export$8afece71750ec241
});
const $2264c97344baeb07$export$ffed9f14fb65e276 = (0, $5vOuM.default)({
    prop: "size",
    cssProperty: "width",
    transform: $2264c97344baeb07$export$8afece71750ec241
});
const $2264c97344baeb07$export$905076ed6620e671 = (0, $5vOuM.default)({
    prop: "size",
    cssProperty: "height",
    transform: $2264c97344baeb07$export$8afece71750ec241
});
const $2264c97344baeb07$export$6ccc93f785106a58 = (0, $5vOuM.default)({
    prop: "boxSizing"
});
const $2264c97344baeb07$var$sizing = (0, $c5ken.default)($2264c97344baeb07$export$7e3df82ee760448c, $2264c97344baeb07$export$488fda99655ff65a, $2264c97344baeb07$export$ee148fbbe8357dd2, $2264c97344baeb07$export$ac607276a8fe9f0a, $2264c97344baeb07$export$dc0d8bd0b94f8570, $2264c97344baeb07$export$a43cf604e12f3b17, $2264c97344baeb07$export$6ccc93f785106a58);
var $2264c97344baeb07$export$2e2bcd8739ae039 = $2264c97344baeb07$var$sizing;

});



parcelRegister("fRMyW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8d179c4f3661016$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $b8d179c4f3661016$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("j0VUA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5eyOE")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("5eyOE")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("kvdFq")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("95jiN")).default; });

var $5eyOE = parcelRequire("5eyOE");

var $kvdFq = parcelRequire("kvdFq");

var $95jiN = parcelRequire("95jiN");

});
parcelRegister("kvdFq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eed14dec48c44a0d$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $c4QxQ = parcelRequire("c4QxQ");

var $95jiN = parcelRequire("95jiN");
const $eed14dec48c44a0d$var$_excluded = [
    "sx"
];
const $eed14dec48c44a0d$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $95jiN.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $eed14dec48c44a0d$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $g54n0.default)(props, $eed14dec48c44a0d$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $eed14dec48c44a0d$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $c4QxQ.isPlainObject)(result)) return systemProps;
        return (0, $lzDk3.default)({}, systemProps, result);
    };
    else finalSx = (0, $lzDk3.default)({}, systemProps, inSx);
    return (0, $lzDk3.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("5o1nK", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7ipzf.default;
    }
});

var $7ipzf = parcelRequire("7ipzf");

});
parcelRegister("7ipzf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54fe0c04ab387b0b$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $3iY3j = parcelRequire("3iY3j");

var $izf4p = parcelRequire("izf4p");
"use client";
function $54fe0c04ab387b0b$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $izf4p.jsx)((0, $3iY3j.default), (0, $lzDk3.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $3iY3j.default).muiName;
    return /*#__PURE__*/ $4YNlq.memo(/*#__PURE__*/ $4YNlq.forwardRef(Component));
}

});
parcelRegister("3iY3j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2681a2b186a365e1$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $2qCAA = parcelRequire("2qCAA");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $JdaC3 = parcelRequire("JdaC3");

var $fOybF = parcelRequire("fOybF");

var $izf4p = parcelRequire("izf4p");
"use client";
const $2681a2b186a365e1$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $2681a2b186a365e1$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $2qCAA.default)(color)}`,
            `fontSize${(0, $2qCAA.default)(fontSize)}`
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $fOybF.getSvgIconUtilityClass), classes);
};
const $2681a2b186a365e1$var$SvgIconRoot = (0, $JdaC3.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $2qCAA.default)(ownerState.color)}`],
            styles[`fontSize${(0, $2qCAA.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // e.g. heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $2681a2b186a365e1$var$SvgIcon = /*#__PURE__*/ $4YNlq.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $g54n0.default)(props, $2681a2b186a365e1$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $4YNlq.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $lzDk3.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $2681a2b186a365e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($2681a2b186a365e1$var$SvgIconRoot, (0, $lzDk3.default)({
        as: component,
        className: (0, $fQQpK.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $izf4p.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$2681a2b186a365e1$var$SvgIcon.muiName = "SvgIcon";
var $2681a2b186a365e1$export$2e2bcd8739ae039 = $2681a2b186a365e1$var$SvgIcon;

});
parcelRegister("fQQpK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a6b93804a787f6f$export$2e2bcd8739ae039; });
function $0a6b93804a787f6f$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $0a6b93804a787f6f$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $0a6b93804a787f6f$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $0a6b93804a787f6f$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $0a6b93804a787f6f$export$2e2bcd8739ae039 = $0a6b93804a787f6f$export$4f5d2d50c9deca37;

});

parcelRegister("9JdRu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $715311ae3947349e$export$2e2bcd8739ae039; });
function $715311ae3947349e$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("2qCAA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c4bf17ac6d079f1$export$2e2bcd8739ae039; });

var $8KsM1 = parcelRequire("8KsM1");
var $1c4bf17ac6d079f1$export$2e2bcd8739ae039 = (0, $8KsM1.default);

});

parcelRegister("4Q3YJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $385f1ace4e3e91de$export$2e2bcd8739ae039; });

var $isLaZ = parcelRequire("isLaZ");

var $1w9Ux = parcelRequire("1w9Ux");

var $dRtc1 = parcelRequire("dRtc1");
"use client";
function $385f1ace4e3e91de$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $isLaZ.default)({
        props: props,
        name: name,
        defaultTheme: $1w9Ux.default,
        themeId: (0, $dRtc1.default)
    });
}

});
parcelRegister("isLaZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d70f6fbaa1352128$export$2e2bcd8739ae039; });

var $20TjU = parcelRequire("20TjU");

var $6SUx4 = parcelRequire("6SUx4");
"use client";
function $d70f6fbaa1352128$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $6SUx4.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $20TjU.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("20TjU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17767e43c3c21279$export$2e2bcd8739ae039; });

var $ckn1w = parcelRequire("ckn1w");
function $17767e43c3c21279$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $ckn1w.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("ckn1w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0250ec3b04886acd$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");
function $0250ec3b04886acd$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $lzDk3.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $lzDk3.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $lzDk3.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $0250ec3b04886acd$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("6SUx4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5033a362ed60398e$export$2e2bcd8739ae039; });

var $3U7IY = parcelRequire("3U7IY");

var $7DeAN = parcelRequire("7DeAN");
"use client";
const $5033a362ed60398e$export$35e57303dbd8a66 = (0, $3U7IY.default)();
function $5033a362ed60398e$var$useTheme(defaultTheme = $5033a362ed60398e$export$35e57303dbd8a66) {
    return (0, $7DeAN.default)(defaultTheme);
}
var $5033a362ed60398e$export$2e2bcd8739ae039 = $5033a362ed60398e$var$useTheme;

});
parcelRegister("7DeAN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58e77eb0ca6d286f$export$2e2bcd8739ae039; });

var $4YNlq = parcelRequire("4YNlq");
parcelRequire("8zt0d");
var $g89D5 = parcelRequire("g89D5");
"use client";
function $58e77eb0ca6d286f$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $58e77eb0ca6d286f$var$useTheme(defaultTheme = null) {
    const contextTheme = $4YNlq.useContext((0, $g89D5.T));
    return !contextTheme || $58e77eb0ca6d286f$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $58e77eb0ca6d286f$export$2e2bcd8739ae039 = $58e77eb0ca6d286f$var$useTheme;

});



parcelRegister("1w9Ux", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11b077affdf0f646$export$2e2bcd8739ae039; });

var $hxzCU = parcelRequire("hxzCU");
"use client";
const $11b077affdf0f646$var$defaultTheme = (0, $hxzCU.default)();
var $11b077affdf0f646$export$2e2bcd8739ae039 = $11b077affdf0f646$var$defaultTheme;

});
parcelRegister("hxzCU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc51276918c94e8c$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $7y3ET = parcelRequire("7y3ET");

var $c4QxQ = parcelRequire("c4QxQ");

var $5eyOE = parcelRequire("5eyOE");
var $95jiN = parcelRequire("95jiN");

var $3U7IY = parcelRequire("3U7IY");


var $jb44v = parcelRequire("jb44v");

var $cwuFn = parcelRequire("cwuFn");

var $dZtJS = parcelRequire("dZtJS");

var $h1ECv = parcelRequire("h1ECv");

var $abQbA = parcelRequire("abQbA");

var $cjSSc = parcelRequire("cjSSc");
const $cc51276918c94e8c$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $cc51276918c94e8c$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $g54n0.default)(options, $cc51276918c94e8c$var$_excluded);
    if (options.vars) throw new Error((0, $7y3ET.default)(18));
    const palette = (0, $cwuFn.default)(paletteInput);
    const systemTheme = (0, $3U7IY.default)(options);
    let muiTheme = (0, $c4QxQ.default)(systemTheme, {
        mixins: (0, $jb44v.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $h1ECv.default).slice(),
        typography: (0, $dZtJS.default)(palette, typographyInput),
        transitions: (0, $abQbA.default)(transitionsInput),
        zIndex: (0, $lzDk3.default)({}, (0, $cjSSc.default))
    });
    muiTheme = (0, $c4QxQ.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $c4QxQ.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $lzDk3.default)({}, (0, $95jiN.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $5eyOE.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $cc51276918c94e8c$var$warnedOnce = false;
function $cc51276918c94e8c$export$c469355549431d9b(...args) {
    return $cc51276918c94e8c$var$createTheme(...args);
}
var $cc51276918c94e8c$export$2e2bcd8739ae039 = $cc51276918c94e8c$var$createTheme;

});
parcelRegister("jb44v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df6233ef0a792e35$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");
function $df6233ef0a792e35$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $lzDk3.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("cwuFn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91e042e668e69a90$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $7y3ET = parcelRequire("7y3ET");

var $c4QxQ = parcelRequire("c4QxQ");

var $309LR = parcelRequire("309LR");

var $f8xFe = parcelRequire("f8xFe");

var $gBTaF = parcelRequire("gBTaF");

var $6BGPd = parcelRequire("6BGPd");

var $iX1GP = parcelRequire("iX1GP");

var $3pfRh = parcelRequire("3pfRh");

var $110gc = parcelRequire("110gc");

var $3qsRZ = parcelRequire("3qsRZ");

var $j2c5n = parcelRequire("j2c5n");
const $91e042e668e69a90$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $91e042e668e69a90$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $f8xFe.default).white,
        default: (0, $f8xFe.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $91e042e668e69a90$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $f8xFe.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $f8xFe.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $91e042e668e69a90$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $309LR.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $309LR.darken)(intent.main, tonalOffsetDark);
    }
}
function $91e042e668e69a90$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $110gc.default)[200],
        light: (0, $110gc.default)[50],
        dark: (0, $110gc.default)[400]
    };
    return {
        main: (0, $110gc.default)[700],
        light: (0, $110gc.default)[400],
        dark: (0, $110gc.default)[800]
    };
}
function $91e042e668e69a90$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $6BGPd.default)[200],
        light: (0, $6BGPd.default)[50],
        dark: (0, $6BGPd.default)[400]
    };
    return {
        main: (0, $6BGPd.default)[500],
        light: (0, $6BGPd.default)[300],
        dark: (0, $6BGPd.default)[700]
    };
}
function $91e042e668e69a90$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iX1GP.default)[500],
        light: (0, $iX1GP.default)[300],
        dark: (0, $iX1GP.default)[700]
    };
    return {
        main: (0, $iX1GP.default)[700],
        light: (0, $iX1GP.default)[400],
        dark: (0, $iX1GP.default)[800]
    };
}
function $91e042e668e69a90$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $3qsRZ.default)[400],
        light: (0, $3qsRZ.default)[300],
        dark: (0, $3qsRZ.default)[700]
    };
    return {
        main: (0, $3qsRZ.default)[700],
        light: (0, $3qsRZ.default)[500],
        dark: (0, $3qsRZ.default)[900]
    };
}
function $91e042e668e69a90$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $j2c5n.default)[400],
        light: (0, $j2c5n.default)[300],
        dark: (0, $j2c5n.default)[700]
    };
    return {
        main: (0, $j2c5n.default)[800],
        light: (0, $j2c5n.default)[500],
        dark: (0, $j2c5n.default)[900]
    };
}
function $91e042e668e69a90$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $3pfRh.default)[400],
        light: (0, $3pfRh.default)[300],
        dark: (0, $3pfRh.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $3pfRh.default)[500],
        dark: (0, $3pfRh.default)[900]
    };
}
function $91e042e668e69a90$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $g54n0.default)(palette, $91e042e668e69a90$var$_excluded);
    const primary = palette.primary || $91e042e668e69a90$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $91e042e668e69a90$var$getDefaultSecondary(mode);
    const error = palette.error || $91e042e668e69a90$var$getDefaultError(mode);
    const info = palette.info || $91e042e668e69a90$var$getDefaultInfo(mode);
    const success = palette.success || $91e042e668e69a90$var$getDefaultSuccess(mode);
    const warning = palette.warning || $91e042e668e69a90$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $309LR.getContrastRatio)(background, $91e042e668e69a90$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $91e042e668e69a90$export$55ce6f3a06c59543.text.primary : $91e042e668e69a90$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $lzDk3.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $7y3ET.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $7y3ET.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $91e042e668e69a90$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $91e042e668e69a90$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $91e042e668e69a90$export$55ce6f3a06c59543,
        light: $91e042e668e69a90$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $c4QxQ.default)((0, $lzDk3.default)({
        // A collection of common colors.
        common: (0, $lzDk3.default)({}, (0, $f8xFe.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $gBTaF.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("309LR", function(module, exports) {
"use strict";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $22f8f37caf04726a$var$alpha;
module.exports.blend = $22f8f37caf04726a$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $22f8f37caf04726a$var$darken;
module.exports.decomposeColor = $22f8f37caf04726a$var$decomposeColor;
module.exports.emphasize = $22f8f37caf04726a$var$emphasize;
module.exports.getContrastRatio = $22f8f37caf04726a$var$getContrastRatio;
module.exports.getLuminance = $22f8f37caf04726a$var$getLuminance;
module.exports.hexToRgb = $22f8f37caf04726a$var$hexToRgb;
module.exports.hslToRgb = $22f8f37caf04726a$var$hslToRgb;
module.exports.lighten = $22f8f37caf04726a$var$lighten;
module.exports.private_safeAlpha = $22f8f37caf04726a$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $22f8f37caf04726a$var$private_safeDarken;
module.exports.private_safeEmphasize = $22f8f37caf04726a$var$private_safeEmphasize;
module.exports.private_safeLighten = $22f8f37caf04726a$var$private_safeLighten;
module.exports.recomposeColor = $22f8f37caf04726a$var$recomposeColor;
module.exports.rgbToHex = $22f8f37caf04726a$var$rgbToHex;

var $22f8f37caf04726a$var$_formatMuiErrorMessage2 = $2NJ2K((parcelRequire("d3eXn")));

var $22f8f37caf04726a$var$_clamp = $2NJ2K((parcelRequire("gFtJs")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $22f8f37caf04726a$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $22f8f37caf04726a$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $22f8f37caf04726a$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $22f8f37caf04726a$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $22f8f37caf04726a$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $22f8f37caf04726a$var$decomposeColor($22f8f37caf04726a$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $22f8f37caf04726a$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $22f8f37caf04726a$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $22f8f37caf04726a$var$colorChannel = (color)=>{
    const decomposedColor = $22f8f37caf04726a$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $22f8f37caf04726a$var$colorChannel;
const $22f8f37caf04726a$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $22f8f37caf04726a$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $22f8f37caf04726a$var$private_safeColorChannel;
function $22f8f37caf04726a$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $22f8f37caf04726a$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $22f8f37caf04726a$var$decomposeColor(color);
    return `#${values.map((n, i)=>$22f8f37caf04726a$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $22f8f37caf04726a$var$hslToRgb(color) {
    color = $22f8f37caf04726a$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $22f8f37caf04726a$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $22f8f37caf04726a$var$getLuminance(color) {
    color = $22f8f37caf04726a$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $22f8f37caf04726a$var$decomposeColor($22f8f37caf04726a$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $22f8f37caf04726a$var$getContrastRatio(foreground, background) {
    const lumA = $22f8f37caf04726a$var$getLuminance(foreground);
    const lumB = $22f8f37caf04726a$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $22f8f37caf04726a$var$alpha(color, value) {
    color = $22f8f37caf04726a$var$decomposeColor(color);
    value = $22f8f37caf04726a$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $22f8f37caf04726a$var$recomposeColor(color);
}
function $22f8f37caf04726a$var$private_safeAlpha(color, value, warning) {
    try {
        return $22f8f37caf04726a$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $22f8f37caf04726a$var$darken(color, coefficient) {
    color = $22f8f37caf04726a$var$decomposeColor(color);
    coefficient = $22f8f37caf04726a$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $22f8f37caf04726a$var$recomposeColor(color);
}
function $22f8f37caf04726a$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $22f8f37caf04726a$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $22f8f37caf04726a$var$lighten(color, coefficient) {
    color = $22f8f37caf04726a$var$decomposeColor(color);
    coefficient = $22f8f37caf04726a$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $22f8f37caf04726a$var$recomposeColor(color);
}
function $22f8f37caf04726a$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $22f8f37caf04726a$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $22f8f37caf04726a$var$emphasize(color, coefficient = 0.15) {
    return $22f8f37caf04726a$var$getLuminance(color) > 0.5 ? $22f8f37caf04726a$var$darken(color, coefficient) : $22f8f37caf04726a$var$lighten(color, coefficient);
}
function $22f8f37caf04726a$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $22f8f37caf04726a$var$private_safeEmphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $22f8f37caf04726a$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $22f8f37caf04726a$var$decomposeColor(background);
    const overlayColor = $22f8f37caf04726a$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $22f8f37caf04726a$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("2NJ2K", function(module, exports) {
function $20a3190878b84014$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $20a3190878b84014$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("f8xFe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b051b75259c87454$export$2e2bcd8739ae039; });
const $b051b75259c87454$var$common = {
    black: "#000",
    white: "#fff"
};
var $b051b75259c87454$export$2e2bcd8739ae039 = $b051b75259c87454$var$common;

});

parcelRegister("gBTaF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c17ae5df32316cc7$export$2e2bcd8739ae039; });
const $c17ae5df32316cc7$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $c17ae5df32316cc7$export$2e2bcd8739ae039 = $c17ae5df32316cc7$var$grey;

});

parcelRegister("6BGPd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf76aec84d60719$export$2e2bcd8739ae039; });
const $4cf76aec84d60719$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $4cf76aec84d60719$export$2e2bcd8739ae039 = $4cf76aec84d60719$var$purple;

});

parcelRegister("iX1GP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcbf0c389a458dce$export$2e2bcd8739ae039; });
const $dcbf0c389a458dce$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $dcbf0c389a458dce$export$2e2bcd8739ae039 = $dcbf0c389a458dce$var$red;

});

parcelRegister("3pfRh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27b002065365e7dc$export$2e2bcd8739ae039; });
const $27b002065365e7dc$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $27b002065365e7dc$export$2e2bcd8739ae039 = $27b002065365e7dc$var$orange;

});

parcelRegister("110gc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bd61623f2f24b0f$export$2e2bcd8739ae039; });
const $0bd61623f2f24b0f$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $0bd61623f2f24b0f$export$2e2bcd8739ae039 = $0bd61623f2f24b0f$var$blue;

});

parcelRegister("3qsRZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27ea31c0618b7b11$export$2e2bcd8739ae039; });
const $27ea31c0618b7b11$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $27ea31c0618b7b11$export$2e2bcd8739ae039 = $27ea31c0618b7b11$var$lightBlue;

});

parcelRegister("j2c5n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddb794379b38632c$export$2e2bcd8739ae039; });
const $ddb794379b38632c$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $ddb794379b38632c$export$2e2bcd8739ae039 = $ddb794379b38632c$var$green;

});


parcelRegister("dZtJS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2f80a6cfbd09a41$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $c4QxQ = parcelRequire("c4QxQ");
const $a2f80a6cfbd09a41$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $a2f80a6cfbd09a41$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $a2f80a6cfbd09a41$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $a2f80a6cfbd09a41$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $a2f80a6cfbd09a41$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $a2f80a6cfbd09a41$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $g54n0.default)(_ref, $a2f80a6cfbd09a41$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $lzDk3.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $a2f80a6cfbd09a41$var$defaultFontFamily ? {
            letterSpacing: `${$a2f80a6cfbd09a41$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $a2f80a6cfbd09a41$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $a2f80a6cfbd09a41$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $c4QxQ.default)((0, $lzDk3.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("h1ECv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c65209f019f4d04c$export$2e2bcd8739ae039; });
const $c65209f019f4d04c$var$shadowKeyUmbraOpacity = 0.2;
const $c65209f019f4d04c$var$shadowKeyPenumbraOpacity = 0.14;
const $c65209f019f4d04c$var$shadowAmbientShadowOpacity = 0.12;
function $c65209f019f4d04c$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$c65209f019f4d04c$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$c65209f019f4d04c$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$c65209f019f4d04c$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $c65209f019f4d04c$var$shadows = [
    "none",
    $c65209f019f4d04c$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $c65209f019f4d04c$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $c65209f019f4d04c$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $c65209f019f4d04c$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $c65209f019f4d04c$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $c65209f019f4d04c$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $c65209f019f4d04c$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $c65209f019f4d04c$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $c65209f019f4d04c$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $c65209f019f4d04c$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $c65209f019f4d04c$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $c65209f019f4d04c$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $c65209f019f4d04c$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $c65209f019f4d04c$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $c65209f019f4d04c$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $c65209f019f4d04c$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $c65209f019f4d04c$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $c65209f019f4d04c$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $c65209f019f4d04c$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $c65209f019f4d04c$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $c65209f019f4d04c$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $c65209f019f4d04c$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $c65209f019f4d04c$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $c65209f019f4d04c$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $c65209f019f4d04c$export$2e2bcd8739ae039 = $c65209f019f4d04c$var$shadows;

});

parcelRegister("abQbA", function(module, exports) {

$parcel$export(module.exports, "duration", function () { return $76b369796ad1dd63$export$1f34108aa9eb96ab; });
$parcel$export(module.exports, "default", function () { return $76b369796ad1dd63$export$2e2bcd8739ae039; });

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");
const $76b369796ad1dd63$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $76b369796ad1dd63$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $76b369796ad1dd63$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $76b369796ad1dd63$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $76b369796ad1dd63$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $76b369796ad1dd63$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $lzDk3.default)({}, $76b369796ad1dd63$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $lzDk3.default)({}, $76b369796ad1dd63$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $g54n0.default)(options, $76b369796ad1dd63$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $76b369796ad1dd63$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $76b369796ad1dd63$var$formatMs(delay)}`).join(",");
    };
    return (0, $lzDk3.default)({
        getAutoHeightDuration: $76b369796ad1dd63$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("cjSSc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f81d30c9eed8ecc$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $8f81d30c9eed8ecc$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $8f81d30c9eed8ecc$export$2e2bcd8739ae039 = $8f81d30c9eed8ecc$var$zIndex;

});



parcelRegister("dRtc1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a176deb84310490e$export$2e2bcd8739ae039; });
var $a176deb84310490e$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("JdaC3", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", function () { return $087e6b67f5c723d6$export$effb20ecdbf4d6aa; });
$parcel$export(module.exports, "slotShouldForwardProp", function () { return $087e6b67f5c723d6$export$f10c5a10d27438e5; });
$parcel$export(module.exports, "default", function () { return $087e6b67f5c723d6$export$2e2bcd8739ae039; });

var $erCP5 = parcelRequire("erCP5");

var $1w9Ux = parcelRequire("1w9Ux");

var $dRtc1 = parcelRequire("dRtc1");
"use client";
const $087e6b67f5c723d6$export$effb20ecdbf4d6aa = (prop)=>(0, $erCP5.shouldForwardProp)(prop) && prop !== "classes";
const $087e6b67f5c723d6$export$f10c5a10d27438e5 = (0, $erCP5.shouldForwardProp);
const $087e6b67f5c723d6$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($erCP5)))({
    themeId: (0, $dRtc1.default),
    defaultTheme: $1w9Ux.default,
    rootShouldForwardProp: $087e6b67f5c723d6$export$effb20ecdbf4d6aa
});
var $087e6b67f5c723d6$export$2e2bcd8739ae039 = $087e6b67f5c723d6$var$styled;

});
parcelRegister("erCP5", function(module, exports) {
"use strict";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a841b3bf7d836556$var$createStyled;
module.exports.shouldForwardProp = $a841b3bf7d836556$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $a841b3bf7d836556$var$_extends2 = $2NJ2K((parcelRequire("8Awal")));

var $a841b3bf7d836556$var$_objectWithoutPropertiesLoose2 = $2NJ2K((parcelRequire("1VU7c")));

var $a841b3bf7d836556$var$_styledEngine = $a841b3bf7d836556$var$_interopRequireWildcard((parcelRequire("k91z8")));

var $c4QxQ = parcelRequire("c4QxQ");

var $a841b3bf7d836556$var$_capitalize = $2NJ2K((parcelRequire("5RBSQ")));

var $a841b3bf7d836556$var$_getDisplayName = $2NJ2K((parcelRequire("2E4f9")));

var $a841b3bf7d836556$var$_createTheme = $2NJ2K((parcelRequire("gFlR2")));

var $a841b3bf7d836556$var$_styleFunctionSx = $2NJ2K((parcelRequire("j0VUA")));
const $a841b3bf7d836556$var$_excluded = [
    "ownerState"
], $a841b3bf7d836556$var$_excluded2 = [
    "variants"
], $a841b3bf7d836556$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $a841b3bf7d836556$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a841b3bf7d836556$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $a841b3bf7d836556$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $a841b3bf7d836556$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $a841b3bf7d836556$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $a841b3bf7d836556$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $a841b3bf7d836556$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $a841b3bf7d836556$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $a841b3bf7d836556$var$_createTheme.default)();
const $a841b3bf7d836556$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $a841b3bf7d836556$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $a841b3bf7d836556$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $a841b3bf7d836556$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $a841b3bf7d836556$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $a841b3bf7d836556$var$_objectWithoutPropertiesLoose2.default)(_ref, $a841b3bf7d836556$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $a841b3bf7d836556$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$a841b3bf7d836556$var$processStyleArg(resolvedStyle, (0, $a841b3bf7d836556$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $a841b3bf7d836556$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $a841b3bf7d836556$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $a841b3bf7d836556$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $a841b3bf7d836556$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $a841b3bf7d836556$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $a841b3bf7d836556$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $a841b3bf7d836556$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $a841b3bf7d836556$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $a841b3bf7d836556$var$_styleFunctionSx.default)((0, $a841b3bf7d836556$var$_extends2.default)({}, props, {
            theme: $a841b3bf7d836556$var$resolveTheme((0, $a841b3bf7d836556$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $a841b3bf7d836556$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $a841b3bf7d836556$var$defaultOverridesResolver($a841b3bf7d836556$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $a841b3bf7d836556$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $a841b3bf7d836556$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $a841b3bf7d836556$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($a841b3bf7d836556$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $a841b3bf7d836556$var$_styledEngine.default)(tag, (0, $a841b3bf7d836556$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $c4QxQ.isPlainObject)(stylesArg)) return (props)=>$a841b3bf7d836556$var$processStyleArg(stylesArg, (0, $a841b3bf7d836556$var$_extends2.default)({}, props, {
                    theme: $a841b3bf7d836556$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $a841b3bf7d836556$var$resolveTheme((0, $a841b3bf7d836556$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $a841b3bf7d836556$var$processStyleArg(slotStyle, (0, $a841b3bf7d836556$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $a841b3bf7d836556$var$resolveTheme((0, $a841b3bf7d836556$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $a841b3bf7d836556$var$processStyleArg({
                    variants: themeVariants
                }, (0, $a841b3bf7d836556$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});


parcelRegister("fOybF", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $b8360b5e4560cd9c$export$c7c50641356bdfa5; });

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $b8360b5e4560cd9c$export$c7c50641356bdfa5(slot) {
    return (0, $fx4gX.default)("MuiSvgIcon", slot);
}
const $b8360b5e4560cd9c$var$svgIconClasses = (0, $auO16.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $b8360b5e4560cd9c$export$2e2bcd8739ae039 = $b8360b5e4560cd9c$var$svgIconClasses;

});
parcelRegister("auO16", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a4380ff69db50a3$export$2e2bcd8739ae039; });

var $fx4gX = parcelRequire("fx4gX");
function $7a4380ff69db50a3$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $fx4gX.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("fx4gX", function(module, exports) {

$parcel$export(module.exports, "globalStateClasses", function () { return $b4ed40877ccffc77$export$9d6b9120de57c54; });
$parcel$export(module.exports, "default", function () { return $b4ed40877ccffc77$export$2e2bcd8739ae039; });

var $3GMww = parcelRequire("3GMww");
const $b4ed40877ccffc77$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $b4ed40877ccffc77$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $b4ed40877ccffc77$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $3GMww.default).generate(componentName)}-${slot}`;
}
function $b4ed40877ccffc77$export$34c0130b1f3e8ae3(slot) {
    return $b4ed40877ccffc77$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("3GMww", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2afaef15febec24b$export$2e2bcd8739ae039; });
const $2afaef15febec24b$var$defaultGenerator = (componentName)=>componentName;
const $2afaef15febec24b$var$createClassNameGenerator = ()=>{
    let generate = $2afaef15febec24b$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $2afaef15febec24b$var$defaultGenerator;
        }
    };
};
const $2afaef15febec24b$var$ClassNameGenerator = $2afaef15febec24b$var$createClassNameGenerator();
var $2afaef15febec24b$export$2e2bcd8739ae039 = $2afaef15febec24b$var$ClassNameGenerator;

});







parcelRegister("2T5UA", function(module, exports) {
"use strict";
var $21a54dc8a6b68a50$var$__assign = module.exports && module.exports.__assign || function() {
    $21a54dc8a6b68a50$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $21a54dc8a6b68a50$var$__assign.apply(this, arguments);
};
var $21a54dc8a6b68a50$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $21a54dc8a6b68a50$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $21a54dc8a6b68a50$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $21a54dc8a6b68a50$var$__createBinding(result, mod, k);
    }
    $21a54dc8a6b68a50$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Carousel = void 0;

var $23hck = parcelRequire("23hck");

var $6ZJGQ = parcelRequire("6ZJGQ");

var $hwPtg = parcelRequire("hwPtg");

var $hDp8f = parcelRequire("hDp8f");

var $21a54dc8a6b68a50$var$react_1 = $21a54dc8a6b68a50$var$__importStar((parcelRequire("4YNlq")));
var $21a54dc8a6b68a50$var$Carousel = function(props) {
    var _a = (0, $21a54dc8a6b68a50$var$react_1.useState)({
        active: 0,
        prevActive: 0,
        next: true
    }), state = _a[0], setState = _a[1];
    /** Used to set carousel's height. It is being set by the CarouselItems */ var _b = (0, $21a54dc8a6b68a50$var$react_1.useState)(), childrenHeight = _b[0], setChildrenHeight = _b[1];
    var _c = (0, $21a54dc8a6b68a50$var$react_1.useState)(false), paused = _c[0], setPaused = _c[1];
    var sanitizedProps = (0, $hwPtg.sanitizeProps)(props);
    // componentDidMount & onIndexChange
    (0, $21a54dc8a6b68a50$var$react_1.useEffect)(function() {
        var index = sanitizedProps.index, changeOnFirstRender = sanitizedProps.changeOnFirstRender;
        setNext(index, true, changeOnFirstRender);
    }, [
        sanitizedProps.index
    ]);
    (0, $hwPtg.useInterval)(function() {
        var autoPlay = sanitizedProps.autoPlay;
        if (autoPlay && !paused) next(undefined);
    }, sanitizedProps.interval);
    var next = function(event) {
        var children = sanitizedProps.children, cycleNavigation = sanitizedProps.cycleNavigation;
        var last = Array.isArray(children) ? children.length - 1 : 0;
        var nextActive = state.active + 1 > last ? cycleNavigation ? 0 : state.active : state.active + 1;
        setNext(nextActive, true);
        if (event) event.stopPropagation();
    };
    var prev = function(event) {
        var children = sanitizedProps.children, cycleNavigation = sanitizedProps.cycleNavigation;
        var last = Array.isArray(children) ? children.length - 1 : 0;
        var nextActive = state.active - 1 < 0 ? cycleNavigation ? last : state.active : state.active - 1;
        setNext(nextActive, false);
        if (event) event.stopPropagation();
    };
    var setNext = function(index, isNext, runCallbacks) {
        if (runCallbacks === void 0) runCallbacks = true;
        var onChange = sanitizedProps.onChange, children = sanitizedProps.children, strictIndexing = sanitizedProps.strictIndexing;
        if (Array.isArray(children)) {
            if (strictIndexing && index > children.length - 1) index = children.length - 1;
            if (strictIndexing && index < 0) index = 0;
        } else index = 0;
        if (runCallbacks) {
            if (isNext !== undefined) isNext ? sanitizedProps.next(index, state.active) : sanitizedProps.prev(index, state.active);
            onChange(index, state.active);
        }
        if (isNext === undefined) isNext = index > state.active;
        setState({
            active: index,
            prevActive: state.active,
            next: isNext
        });
    };
    var children = sanitizedProps.children, sx = sanitizedProps.sx, className = sanitizedProps.className, height = sanitizedProps.height, stopAutoPlayOnHover = sanitizedProps.stopAutoPlayOnHover, animation = sanitizedProps.animation, duration = sanitizedProps.duration, swipe = sanitizedProps.swipe, navButtonsAlwaysInvisible = sanitizedProps.navButtonsAlwaysInvisible, navButtonsAlwaysVisible = sanitizedProps.navButtonsAlwaysVisible, cycleNavigation = sanitizedProps.cycleNavigation, fullHeightHover = sanitizedProps.fullHeightHover, navButtonsProps = sanitizedProps.navButtonsProps, navButtonsWrapperProps = sanitizedProps.navButtonsWrapperProps, NavButton = sanitizedProps.NavButton, NextIcon = sanitizedProps.NextIcon, PrevIcon = sanitizedProps.PrevIcon, indicators = sanitizedProps.indicators, indicatorContainerProps = sanitizedProps.indicatorContainerProps, indicatorIconButtonProps = sanitizedProps.indicatorIconButtonProps, activeIndicatorIconButtonProps = sanitizedProps.activeIndicatorIconButtonProps, IndicatorIcon = sanitizedProps.IndicatorIcon;
    var showButton = function(next) {
        if (next === void 0) next = true;
        if (cycleNavigation) return true;
        var last = Array.isArray(children) ? children.length - 1 : 0;
        if (next && state.active === last) return false;
        if (!next && state.active === 0) return false;
        return true;
    };
    return $21a54dc8a6b68a50$var$react_1.default.createElement($hDp8f.StyledRoot, {
        sx: sx,
        className: className,
        onMouseOver: function() {
            stopAutoPlayOnHover && setPaused(true);
        },
        onMouseOut: function() {
            stopAutoPlayOnHover && setPaused(false);
        },
        onFocus: function() {
            stopAutoPlayOnHover && setPaused(true);
        },
        onBlur: function() {
            stopAutoPlayOnHover && setPaused(false);
        }
    }, $21a54dc8a6b68a50$var$react_1.default.createElement($hDp8f.StyledItemWrapper, {
        style: {
            height: height ? height : childrenHeight
        }
    }, Array.isArray(children) ? children.map(function(child, index) {
        return $21a54dc8a6b68a50$var$react_1.default.createElement($23hck.CarouselItem, {
            key: "carousel-item" + index,
            state: state,
            index: index,
            maxIndex: children.length - 1,
            child: child,
            animation: animation,
            duration: duration,
            swipe: swipe,
            next: next,
            prev: prev,
            height: height,
            setHeight: setChildrenHeight
        });
    }) : $21a54dc8a6b68a50$var$react_1.default.createElement($23hck.CarouselItem, {
        key: "carousel-item0",
        state: state,
        index: 0,
        maxIndex: 0,
        child: children,
        animation: animation,
        duration: duration,
        height: height,
        setHeight: setChildrenHeight
    })), !navButtonsAlwaysInvisible && showButton(true) && $21a54dc8a6b68a50$var$react_1.default.createElement($hDp8f.StyledButtonWrapper, $21a54dc8a6b68a50$var$__assign({
        "$next": true,
        "$prev": false,
        "$fullHeightHover": fullHeightHover
    }, navButtonsWrapperProps), NavButton !== undefined ? NavButton($21a54dc8a6b68a50$var$__assign({
        onClick: next,
        next: true,
        prev: false
    }, navButtonsProps)) : $21a54dc8a6b68a50$var$react_1.default.createElement($hDp8f.StyledIconButton, $21a54dc8a6b68a50$var$__assign({
        "$alwaysVisible": navButtonsAlwaysVisible,
        "$fullHeightHover": fullHeightHover,
        onClick: next,
        "aria-label": "Next"
    }, navButtonsProps), NextIcon)), !navButtonsAlwaysInvisible && showButton(false) && $21a54dc8a6b68a50$var$react_1.default.createElement($hDp8f.StyledButtonWrapper, $21a54dc8a6b68a50$var$__assign({
        "$next": false,
        "$prev": true,
        "$fullHeightHover": fullHeightHover
    }, navButtonsWrapperProps), NavButton !== undefined ? NavButton($21a54dc8a6b68a50$var$__assign({
        onClick: prev,
        next: false,
        prev: true
    }, navButtonsProps)) : $21a54dc8a6b68a50$var$react_1.default.createElement($hDp8f.StyledIconButton, $21a54dc8a6b68a50$var$__assign({
        "$alwaysVisible": navButtonsAlwaysVisible,
        "$fullHeightHover": fullHeightHover,
        onClick: prev,
        "aria-label": "Previous"
    }, navButtonsProps), PrevIcon)), indicators ? $21a54dc8a6b68a50$var$react_1.default.createElement($6ZJGQ.Indicators, {
        length: Array.isArray(children) ? children.length : 0,
        active: state.active,
        press: setNext,
        indicatorContainerProps: indicatorContainerProps,
        indicatorIconButtonProps: indicatorIconButtonProps,
        activeIndicatorIconButtonProps: activeIndicatorIconButtonProps,
        IndicatorIcon: IndicatorIcon
    }) : null);
};
module.exports.Carousel = $21a54dc8a6b68a50$var$Carousel;
module.exports.default = module.exports.Carousel;

});
parcelRegister("23hck", function(module, exports) {
"use strict";
var $17e933bd2e300bb7$var$__assign = module.exports && module.exports.__assign || function() {
    $17e933bd2e300bb7$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17e933bd2e300bb7$var$__assign.apply(this, arguments);
};
var $17e933bd2e300bb7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $17e933bd2e300bb7$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $17e933bd2e300bb7$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $17e933bd2e300bb7$var$__createBinding(result, mod, k);
    }
    $17e933bd2e300bb7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CarouselItem = void 0;

var $bf3KY = parcelRequire("bf3KY");
var $9YDGd = parcelRequire("9YDGd");

var $17e933bd2e300bb7$var$react_1 = $17e933bd2e300bb7$var$__importStar((parcelRequire("4YNlq")));

var $hDp8f = parcelRequire("hDp8f");
var $17e933bd2e300bb7$var$CarouselItem = function(_a) {
    var animation = _a.animation, next = _a.next, prev = _a.prev, swipe = _a.swipe, state = _a.state, index = _a.index, maxIndex = _a.maxIndex, duration = _a.duration, child = _a.child, height = _a.height, setHeight = _a.setHeight;
    var slide = animation === "slide";
    var fade = animation === "fade";
    var dragProps = {
        drag: "x",
        layout: true,
        onDragEnd: function(event, info) {
            if (!swipe) return;
            if (info.offset.x > 0) prev && prev();
            else if (info.offset.x < 0) next && next();
            event.stopPropagation();
        },
        dragElastic: 0,
        dragConstraints: {
            left: 0,
            right: 0
        }
    };
    var divRef = (0, $17e933bd2e300bb7$var$react_1.useRef)(null);
    var checkAndSetHeight = (0, $17e933bd2e300bb7$var$react_1.useCallback)(function() {
        if (index !== state.active) return;
        if (!divRef.current) return;
        if (divRef.current.offsetHeight === 0) setTimeout(function() {
            return checkAndSetHeight();
        }, 100);
        else setHeight(divRef.current.offsetHeight);
    }, [
        setHeight,
        state.active,
        index,
        divRef
    ]);
    // Set height on every child change
    (0, $17e933bd2e300bb7$var$react_1.useEffect)(function() {
        checkAndSetHeight();
    }, [
        checkAndSetHeight
    ]);
    var variants = {
        leftwardExit: {
            x: slide ? "-100%" : undefined,
            opacity: fade ? 0 : undefined,
            zIndex: 0
        },
        leftOut: {
            x: slide ? "-100%" : undefined,
            opacity: fade ? 0 : undefined,
            display: "none",
            zIndex: 0
        },
        rightwardExit: {
            x: slide ? "100%" : undefined,
            opacity: fade ? 0 : undefined,
            zIndex: 0
        },
        rightOut: {
            x: slide ? "100%" : undefined,
            opacity: fade ? 0 : undefined,
            display: "none",
            zIndex: 0
        },
        center: {
            x: 0,
            opacity: 1,
            zIndex: 1
        }
    };
    // Handle animation directions and opacity given based on active, prevActive and this item's index
    var active = state.active, isNext = state.next, prevActive = state.prevActive;
    var animate = "center";
    if (index === active) animate = "center";
    else if (index === prevActive) {
        animate = isNext ? "leftwardExit" : "rightwardExit";
        if (active === maxIndex && index === 0) animate = "rightwardExit";
        if (active === 0 && index === maxIndex) animate = "leftwardExit";
    } else {
        animate = index < active ? "leftOut" : "rightOut";
        if (active === maxIndex && index === 0) animate = "rightOut";
        if (active === 0 && index === maxIndex) animate = "leftOut";
    }
    duration = duration / 1000;
    return $17e933bd2e300bb7$var$react_1.default.createElement($hDp8f.StyledItem, null, $17e933bd2e300bb7$var$react_1.default.createElement($bf3KY.AnimatePresence, {
        custom: isNext
    }, $17e933bd2e300bb7$var$react_1.default.createElement($9YDGd.motion.div, $17e933bd2e300bb7$var$__assign({}, swipe && dragProps, {
        style: {
            height: "100%"
        }
    }), $17e933bd2e300bb7$var$react_1.default.createElement($9YDGd.motion.div, {
        custom: isNext,
        variants: variants,
        animate: animate,
        transition: {
            x: {
                type: "tween",
                duration: duration,
                delay: 0
            },
            opacity: {
                duration: duration
            }
        },
        style: {
            position: "relative",
            height: "100%"
        }
    }, $17e933bd2e300bb7$var$react_1.default.createElement("div", {
        ref: divRef,
        style: {
            height: height
        }
    }, child)))));
};
module.exports.CarouselItem = $17e933bd2e300bb7$var$CarouselItem;

});
parcelRegister("bf3KY", function(module, exports) {

$parcel$export(module.exports, "AnimatePresence", function () { return $82f4026f97756ce8$export$3ae376d12526dd6f; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $2oWt9 = parcelRequire("2oWt9");

var $a1t7w = parcelRequire("a1t7w");

var $9rwrj = parcelRequire("9rwrj");
function $82f4026f97756ce8$var$getChildKey(child) {
    return child.key || "";
}
function $82f4026f97756ce8$var$updateChildLookup(children, allChildren) {
    var seenChildren = null;
    children.forEach(function(child) {
        var key = $82f4026f97756ce8$var$getChildKey(child);
        allChildren.set(key, child);
    });
}
function $82f4026f97756ce8$var$onlyElements(children) {
    var filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $4YNlq.Children).forEach(children, function(child) {
        if ((0, $4YNlq.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * @library
 *
 * Any `Frame` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { Frame, AnimatePresence } from 'framer'
 *
 * // As items are added and removed from `items`
 * export function Items({ items }) {
 *   return (
 *     <AnimatePresence>
 *       {items.map(item => (
 *         <Frame
 *           key={item.id}
 *           initial={{ opacity: 0 }}
 *           animate={{ opacity: 1 }}
 *           exit={{ opacity: 0 }}
 *         />
 *       ))}
 *     </AnimatePresence>
 *   )
 * }
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * @motion
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ var $82f4026f97756ce8$export$3ae376d12526dd6f = function(_a) {
    var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
    // We want to force a re-render once all exiting animations have finished. We
    // either use a local forceRender function, or one from a parent context if it exists.
    var forceRender = (0, $2oWt9.useForceUpdate)();
    var layoutContext = (0, $4YNlq.useContext)((0, $9rwrj.SharedLayoutContext));
    if ((0, $9rwrj.isSharedLayout)(layoutContext)) forceRender = layoutContext.forceUpdate;
    var isInitialRender = (0, $4YNlq.useRef)(true);
    // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
    var filteredChildren = $82f4026f97756ce8$var$onlyElements(children);
    // Keep a living record of the children we're actually rendering so we
    // can diff to figure out which are entering and exiting
    var presentChildren = (0, $4YNlq.useRef)(filteredChildren);
    // A lookup table to quickly reference components by key
    var allChildren = (0, $4YNlq.useRef)(new Map()).current;
    // A living record of all currently exiting components.
    var exiting = (0, $4YNlq.useRef)(new Set()).current;
    $82f4026f97756ce8$var$updateChildLookup(filteredChildren, allChildren);
    // If this is the initial component render, just deal with logic surrounding whether
    // we play onMount animations or not.
    if (isInitialRender.current) {
        isInitialRender.current = false;
        return $4YNlq.createElement($4YNlq.Fragment, null, filteredChildren.map(function(child) {
            return $4YNlq.createElement((0, $a1t7w.PresenceChild), {
                key: $82f4026f97756ce8$var$getChildKey(child),
                isPresent: true,
                initial: initial ? undefined : false,
                presenceAffectsLayout: presenceAffectsLayout
            }, child);
        }));
    }
    // If this is a subsequent render, deal with entering and exiting children
    var childrenToRender = (0, $S3LFa.__spreadArray)([], (0, $S3LFa.__read)(filteredChildren));
    // Diff the keys of the currently-present and target children to update our
    // exiting list.
    var presentKeys = presentChildren.current.map($82f4026f97756ce8$var$getChildKey);
    var targetKeys = filteredChildren.map($82f4026f97756ce8$var$getChildKey);
    // Diff the present children with our target children and mark those that are exiting
    var numPresent = presentKeys.length;
    for(var i = 0; i < numPresent; i++){
        var key = presentKeys[i];
        if (targetKeys.indexOf(key) === -1) exiting.add(key);
        else // In case this key has re-entered, remove from the exiting list
        exiting.delete(key);
    }
    // If we currently have exiting children, and we're deferring rendering incoming children
    // until after all current children have exiting, empty the childrenToRender array
    if (exitBeforeEnter && exiting.size) childrenToRender = [];
    // Loop through all currently exiting components and clone them to overwrite `animate`
    // with any `exit` prop they might have defined.
    exiting.forEach(function(key) {
        // If this component is actually entering again, early return
        if (targetKeys.indexOf(key) !== -1) return;
        var child = allChildren.get(key);
        if (!child) return;
        var insertionIndex = presentKeys.indexOf(key);
        var onExit = function() {
            allChildren.delete(key);
            exiting.delete(key);
            // Remove this child from the present children
            var removeIndex = presentChildren.current.findIndex(function(presentChild) {
                return presentChild.key === key;
            });
            presentChildren.current.splice(removeIndex, 1);
            // Defer re-rendering until all exiting children have indeed left
            if (!exiting.size) {
                presentChildren.current = filteredChildren;
                forceRender();
                onExitComplete && onExitComplete();
            }
        };
        childrenToRender.splice(insertionIndex, 0, $4YNlq.createElement((0, $a1t7w.PresenceChild), {
            key: $82f4026f97756ce8$var$getChildKey(child),
            isPresent: false,
            onExitComplete: onExit,
            custom: custom,
            presenceAffectsLayout: presenceAffectsLayout
        }, child));
    });
    // Add `MotionContext` even to children that don't need it to ensure we're rendering
    // the same tree between renders
    childrenToRender = childrenToRender.map(function(child) {
        var key = child.key;
        return exiting.has(key) ? child : $4YNlq.createElement((0, $a1t7w.PresenceChild), {
            key: $82f4026f97756ce8$var$getChildKey(child),
            isPresent: true,
            presenceAffectsLayout: presenceAffectsLayout
        }, child);
    });
    presentChildren.current = childrenToRender;
    return $4YNlq.createElement($4YNlq.Fragment, null, exiting.size ? childrenToRender : childrenToRender.map(function(child) {
        return (0, $4YNlq.cloneElement)(child);
    }));
};

});
parcelRegister("S3LFa", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $0a27f7757811370c$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $0a27f7757811370c$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $0a27f7757811370c$export$3c9a16f847548506; });
$parcel$export(module.exports, "__read", function () { return $0a27f7757811370c$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spreadArray", function () { return $0a27f7757811370c$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $0a27f7757811370c$var$extendStatics = function(d, b) {
    $0a27f7757811370c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $0a27f7757811370c$var$extendStatics(d, b);
};
function $0a27f7757811370c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $0a27f7757811370c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $0a27f7757811370c$export$18ce0697a983be9b = function() {
    $0a27f7757811370c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0a27f7757811370c$export$18ce0697a983be9b.apply(this, arguments);
};
function $0a27f7757811370c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $0a27f7757811370c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $0a27f7757811370c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $0a27f7757811370c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $0a27f7757811370c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $0a27f7757811370c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $0a27f7757811370c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $0a27f7757811370c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $0a27f7757811370c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $0a27f7757811370c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $0a27f7757811370c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $0a27f7757811370c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $0a27f7757811370c$export$45d3717a4c69092e(o, m, p);
}
function $0a27f7757811370c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $0a27f7757811370c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $0a27f7757811370c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($0a27f7757811370c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $0a27f7757811370c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $0a27f7757811370c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $0a27f7757811370c$export$10c90e4f7922046c(v) {
    return this instanceof $0a27f7757811370c$export$10c90e4f7922046c ? (this.v = v, this) : new $0a27f7757811370c$export$10c90e4f7922046c(v);
}
function $0a27f7757811370c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $0a27f7757811370c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $0a27f7757811370c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $0a27f7757811370c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $0a27f7757811370c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $0a27f7757811370c$export$19a8beecd37a4c45 === "function" ? $0a27f7757811370c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $0a27f7757811370c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $0a27f7757811370c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $0a27f7757811370c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0a27f7757811370c$export$45d3717a4c69092e(result, mod, k);
    }
    $0a27f7757811370c$var$__setModuleDefault(result, mod);
    return result;
}
function $0a27f7757811370c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $0a27f7757811370c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $0a27f7757811370c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $0a27f7757811370c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $0a27f7757811370c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $0a27f7757811370c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $0a27f7757811370c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $0a27f7757811370c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $0a27f7757811370c$export$2e2bcd8739ae039 = {
    __extends: $0a27f7757811370c$export$a8ba968b8961cb8a,
    __assign: $0a27f7757811370c$export$18ce0697a983be9b,
    __rest: $0a27f7757811370c$export$3c9a16f847548506,
    __decorate: $0a27f7757811370c$export$29e00dfd3077644b,
    __param: $0a27f7757811370c$export$d5ad3fd78186038f,
    __metadata: $0a27f7757811370c$export$f1db080c865becb9,
    __awaiter: $0a27f7757811370c$export$1050f835b63b671e,
    __generator: $0a27f7757811370c$export$67ebef60e6f28a6,
    __createBinding: $0a27f7757811370c$export$45d3717a4c69092e,
    __exportStar: $0a27f7757811370c$export$f33643c0debef087,
    __values: $0a27f7757811370c$export$19a8beecd37a4c45,
    __read: $0a27f7757811370c$export$8d051b38c9118094,
    __spread: $0a27f7757811370c$export$afc72e2116322959,
    __spreadArrays: $0a27f7757811370c$export$6388937ca91ccae8,
    __spreadArray: $0a27f7757811370c$export$1216008129fb82ed,
    __await: $0a27f7757811370c$export$10c90e4f7922046c,
    __asyncGenerator: $0a27f7757811370c$export$e427f37a30a4de9b,
    __asyncDelegator: $0a27f7757811370c$export$bbd80228419bb833,
    __asyncValues: $0a27f7757811370c$export$e3b29a3d6162315f,
    __makeTemplateObject: $0a27f7757811370c$export$4fb47efe1390b86f,
    __importStar: $0a27f7757811370c$export$c21735bcef00d192,
    __importDefault: $0a27f7757811370c$export$da59b14a69baef04,
    __classPrivateFieldGet: $0a27f7757811370c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $0a27f7757811370c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $0a27f7757811370c$export$81fdc39f203e4e04,
    __addDisposableResource: $0a27f7757811370c$export$88ac25d8e944e405,
    __disposeResources: $0a27f7757811370c$export$8f076105dc360e92
};

});

parcelRegister("2oWt9", function(module, exports) {

$parcel$export(module.exports, "useForceUpdate", function () { return $1bfb2d67305d3a62$export$91db9bc4f8ac944a; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $g7I5q = parcelRequire("g7I5q");
function $1bfb2d67305d3a62$export$91db9bc4f8ac944a() {
    var unloadingRef = (0, $4YNlq.useRef)(false);
    var _a = (0, $S3LFa.__read)((0, $4YNlq.useState)(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
    (0, $g7I5q.useUnmountEffect)(function() {
        return unloadingRef.current = true;
    });
    return (0, $4YNlq.useCallback)(function() {
        !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
    }, [
        forcedRenderCount
    ]);
}

});
parcelRegister("g7I5q", function(module, exports) {

$parcel$export(module.exports, "useUnmountEffect", function () { return $bbcf7f7098dad3ac$export$f3a192d0cbd30b96; });

var $4YNlq = parcelRequire("4YNlq");
function $bbcf7f7098dad3ac$export$f3a192d0cbd30b96(callback) {
    return (0, $4YNlq.useEffect)(function() {
        return function() {
            return callback();
        };
    }, []);
}

});


parcelRegister("a1t7w", function(module, exports) {

$parcel$export(module.exports, "PresenceChild", function () { return $74c0960e3c9fba80$export$979daf65881a382a; });

var $4YNlq = parcelRequire("4YNlq");

var $eVG38 = parcelRequire("eVG38");

var $7nP7f = parcelRequire("7nP7f");
var $74c0960e3c9fba80$var$presenceId = 0;
function $74c0960e3c9fba80$var$getPresenceId() {
    var id = $74c0960e3c9fba80$var$presenceId;
    $74c0960e3c9fba80$var$presenceId++;
    return id;
}
var $74c0960e3c9fba80$export$979daf65881a382a = function(_a) {
    var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
    var presenceChildren = (0, $7nP7f.useConstant)($74c0960e3c9fba80$var$newChildrenMap);
    var id = (0, $7nP7f.useConstant)($74c0960e3c9fba80$var$getPresenceId);
    var context = (0, $4YNlq.useMemo)(function() {
        return {
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: function(childId) {
                presenceChildren.set(childId, true);
                var allComplete = true;
                presenceChildren.forEach(function(isComplete) {
                    if (!isComplete) allComplete = false;
                });
                allComplete && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
            },
            register: function(childId) {
                presenceChildren.set(childId, false);
                return function() {
                    return presenceChildren.delete(childId);
                };
            }
        };
    }, /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? undefined : [
        isPresent
    ]);
    (0, $4YNlq.useMemo)(function() {
        presenceChildren.forEach(function(_, key) {
            return presenceChildren.set(key, false);
        });
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $4YNlq.useEffect(function() {
        !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 || onExitComplete());
    }, [
        isPresent
    ]);
    return $4YNlq.createElement((0, $eVG38.PresenceContext).Provider, {
        value: context
    }, children);
};
function $74c0960e3c9fba80$var$newChildrenMap() {
    return new Map();
}

});
parcelRegister("eVG38", function(module, exports) {

$parcel$export(module.exports, "PresenceContext", function () { return $ade701b6efedaa52$export$f224e4635b6f8ce2; });

var $4YNlq = parcelRequire("4YNlq");
/**
 * @public
 */ var $ade701b6efedaa52$export$f224e4635b6f8ce2 = (0, $4YNlq.createContext)(null);

});

parcelRegister("7nP7f", function(module, exports) {

$parcel$export(module.exports, "useConstant", function () { return $560254ef77fb2fb1$export$fe4300aa8eebea86; });

var $4YNlq = parcelRequire("4YNlq");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $560254ef77fb2fb1$export$fe4300aa8eebea86(init) {
    var ref = (0, $4YNlq.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

});


parcelRegister("9rwrj", function(module, exports) {

$parcel$export(module.exports, "SharedLayoutContext", function () { return $6dffcc80aad47656$export$a3d1a816cb91a642; });
$parcel$export(module.exports, "FramerTreeLayoutContext", function () { return $6dffcc80aad47656$export$88d0442641a5238c; });
$parcel$export(module.exports, "isSharedLayout", function () { return $6dffcc80aad47656$export$8475119b63356082; });

var $4YNlq = parcelRequire("4YNlq");

var $eF9L3 = parcelRequire("eF9L3");
var $6dffcc80aad47656$export$a3d1a816cb91a642 = (0, $4YNlq.createContext)((0, $eF9L3.createBatcher)());
/**
 * @internal
 */ var $6dffcc80aad47656$export$88d0442641a5238c = (0, $4YNlq.createContext)((0, $eF9L3.createBatcher)());
function $6dffcc80aad47656$export$8475119b63356082(context) {
    return !!context.forceUpdate;
}

});
parcelRegister("eF9L3", function(module, exports) {

$parcel$export(module.exports, "createBatcher", function () { return $aacc76c59490b2ab$export$29e5fe0a0fc8f32f; });

var $S3LFa = parcelRequire("S3LFa");

var $iYUpa = parcelRequire("iYUpa");

var $1MwKT = parcelRequire("1MwKT");

var $22P90 = parcelRequire("22P90");

var $2AMJ5 = parcelRequire("2AMJ5");

var $ccUUQ = parcelRequire("ccUUQ");
/**
 * Default handlers for batching VisualElements
 */ var $aacc76c59490b2ab$var$defaultHandler = {
    layoutReady: function(child) {
        return child.notifyLayoutReady();
    }
};
/**
 * Create a batcher to process VisualElements
 */ function $aacc76c59490b2ab$export$29e5fe0a0fc8f32f() {
    var queue = new Set();
    return {
        add: function(child) {
            return queue.add(child);
        },
        flush: function(_a) {
            var _b = _a === void 0 ? $aacc76c59490b2ab$var$defaultHandler : _a, layoutReady = _b.layoutReady, parent = _b.parent;
            (0, $22P90.batchLayout)(function(read, write) {
                var order = Array.from(queue).sort((0, $2AMJ5.compareByDepth));
                var ancestors = parent ? (0, $1MwKT.collectProjectingAncestors)(parent) : [];
                write(function() {
                    var allElements = (0, $S3LFa.__spreadArray)((0, $S3LFa.__spreadArray)([], (0, $S3LFa.__read)(ancestors)), (0, $S3LFa.__read)(order));
                    allElements.forEach(function(element) {
                        return element.resetTransform();
                    });
                });
                read(function() {
                    order.forEach((0, $1MwKT.updateLayoutMeasurement));
                });
                write(function() {
                    ancestors.forEach(function(element) {
                        return element.restoreTransform();
                    });
                    order.forEach(layoutReady);
                });
                read(function() {
                    /**
                     * After all children have started animating, ensure any Entering components are set to Present.
                     * If we add deferred animations (set up all animations and then start them in two loops) this
                     * could be moved to the start loop. But it needs to happen after all the animations configs
                     * are generated in AnimateSharedLayout as this relies on presence data
                     */ order.forEach(function(child) {
                        if (child.isPresent) child.presence = (0, $ccUUQ.Presence).Present;
                    });
                });
                write(function() {
                    /**
                     * Starting these animations will have queued jobs on the frame loop. In some situations,
                     * like when removing an element, these will be processed too late after the DOM is manipulated,
                     * leaving a flash of incorrectly-projected content. By manually flushing these jobs
                     * we ensure there's no flash.
                     */ (0, $iYUpa.flushSync).preRender();
                    (0, $iYUpa.flushSync).render();
                });
                read(function() {
                    /**
                     * Schedule a callback at the end of the following frame to assign the latest projection
                     * box to the prevViewportBox snapshot. Once global batching is in place this could be run
                     * synchronously. But for now it ensures that if any nested `AnimateSharedLayout` top-level
                     * child attempts to calculate its previous relative position against a prevViewportBox
                     * it will be against its latest projection box instead, as the snapshot is useless beyond this
                     * render.
                     */ (0, $iYUpa.default).postRender(function() {
                        return order.forEach($aacc76c59490b2ab$var$assignProjectionToSnapshot);
                    });
                    queue.clear();
                });
            });
            // TODO: Need to find a layout-synchronous way of flushing this
            (0, $22P90.flushLayout)();
        }
    };
}
function $aacc76c59490b2ab$var$assignProjectionToSnapshot(child) {
    child.prevViewportBox = child.projection.target;
}

});
parcelRegister("iYUpa", function(module, exports) {

$parcel$export(module.exports, "cancelSync", function () { return $dd19956970aea93c$export$d93e9c1fe0553512; });
$parcel$export(module.exports, "flushSync", function () { return $dd19956970aea93c$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "getFrameData", function () { return $dd19956970aea93c$export$7244445918e670ed; });
$parcel$export(module.exports, "default", function () { return $dd19956970aea93c$export$2e2bcd8739ae039; });

var $7wKdl = parcelRequire("7wKdl");

var $ekZaK = parcelRequire("ekZaK");
var $dd19956970aea93c$var$maxElapsed = 40;
var $dd19956970aea93c$var$useDefaultElapsed = true;
var $dd19956970aea93c$var$runNextFrame = false;
var $dd19956970aea93c$var$isProcessing = false;
var $dd19956970aea93c$var$frame = {
    delta: 0,
    timestamp: 0
};
var $dd19956970aea93c$var$stepsOrder = [
    "read",
    "update",
    "preRender",
    "render",
    "postRender"
];
var $dd19956970aea93c$var$steps = /*#__PURE__*/ $dd19956970aea93c$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = (0, $ekZaK.createRenderStep)(function() {
        return $dd19956970aea93c$var$runNextFrame = true;
    });
    return acc;
}, {});
var $dd19956970aea93c$var$sync = /*#__PURE__*/ $dd19956970aea93c$var$stepsOrder.reduce(function(acc, key) {
    var step = $dd19956970aea93c$var$steps[key];
    acc[key] = function(process, keepAlive, immediate) {
        if (keepAlive === void 0) keepAlive = false;
        if (immediate === void 0) immediate = false;
        if (!$dd19956970aea93c$var$runNextFrame) $dd19956970aea93c$var$startLoop();
        return step.schedule(process, keepAlive, immediate);
    };
    return acc;
}, {});
var $dd19956970aea93c$export$d93e9c1fe0553512 = /*#__PURE__*/ $dd19956970aea93c$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = $dd19956970aea93c$var$steps[key].cancel;
    return acc;
}, {});
var $dd19956970aea93c$export$cd75ccfd720a3cd4 = /*#__PURE__*/ $dd19956970aea93c$var$stepsOrder.reduce(function(acc, key) {
    acc[key] = function() {
        return $dd19956970aea93c$var$steps[key].process($dd19956970aea93c$var$frame);
    };
    return acc;
}, {});
var $dd19956970aea93c$var$processStep = function(stepId) {
    return $dd19956970aea93c$var$steps[stepId].process($dd19956970aea93c$var$frame);
};
var $dd19956970aea93c$var$processFrame = function(timestamp) {
    $dd19956970aea93c$var$runNextFrame = false;
    $dd19956970aea93c$var$frame.delta = $dd19956970aea93c$var$useDefaultElapsed ? (0, $7wKdl.defaultTimestep) : Math.max(Math.min(timestamp - $dd19956970aea93c$var$frame.timestamp, $dd19956970aea93c$var$maxElapsed), 1);
    $dd19956970aea93c$var$frame.timestamp = timestamp;
    $dd19956970aea93c$var$isProcessing = true;
    $dd19956970aea93c$var$stepsOrder.forEach($dd19956970aea93c$var$processStep);
    $dd19956970aea93c$var$isProcessing = false;
    if ($dd19956970aea93c$var$runNextFrame) {
        $dd19956970aea93c$var$useDefaultElapsed = false;
        (0, $7wKdl.onNextFrame)($dd19956970aea93c$var$processFrame);
    }
};
var $dd19956970aea93c$var$startLoop = function() {
    $dd19956970aea93c$var$runNextFrame = true;
    $dd19956970aea93c$var$useDefaultElapsed = true;
    if (!$dd19956970aea93c$var$isProcessing) (0, $7wKdl.onNextFrame)($dd19956970aea93c$var$processFrame);
};
var $dd19956970aea93c$export$7244445918e670ed = function() {
    return $dd19956970aea93c$var$frame;
};
var $dd19956970aea93c$export$2e2bcd8739ae039 = $dd19956970aea93c$var$sync;

});
parcelRegister("7wKdl", function(module, exports) {

$parcel$export(module.exports, "defaultTimestep", function () { return $57af5ebc31124edd$export$f8caf8121275292d; });
$parcel$export(module.exports, "onNextFrame", function () { return $57af5ebc31124edd$export$4fdea63ab5513fd5; });
var $57af5ebc31124edd$export$f8caf8121275292d = 1 / 60 * 1000;
var $57af5ebc31124edd$var$getCurrentTime = typeof performance !== "undefined" ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
var $57af5ebc31124edd$export$4fdea63ab5513fd5 = typeof window !== "undefined" ? function(callback) {
    return window.requestAnimationFrame(callback);
} : function(callback) {
    return setTimeout(function() {
        return callback($57af5ebc31124edd$var$getCurrentTime());
    }, $57af5ebc31124edd$export$f8caf8121275292d);
};

});

parcelRegister("ekZaK", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $a702627f8a6bee1e$export$b995e5e85f5c8289; });
function $a702627f8a6bee1e$export$b995e5e85f5c8289(runNextFrame) {
    var toRun = [];
    var toRunNextFrame = [];
    var numToRun = 0;
    var isProcessing = false;
    var toKeepAlive = new WeakSet();
    var step = {
        schedule: function(callback, keepAlive, immediate) {
            if (keepAlive === void 0) keepAlive = false;
            if (immediate === void 0) immediate = false;
            var addToCurrentFrame = immediate && isProcessing;
            var buffer = addToCurrentFrame ? toRun : toRunNextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (buffer.indexOf(callback) === -1) {
                buffer.push(callback);
                if (addToCurrentFrame && isProcessing) numToRun = toRun.length;
            }
            return callback;
        },
        cancel: function(callback) {
            var index = toRunNextFrame.indexOf(callback);
            if (index !== -1) toRunNextFrame.splice(index, 1);
            toKeepAlive.delete(callback);
        },
        process: function(frameData) {
            var _a;
            isProcessing = true;
            _a = [
                toRunNextFrame,
                toRun
            ], toRun = _a[0], toRunNextFrame = _a[1];
            toRunNextFrame.length = 0;
            numToRun = toRun.length;
            if (numToRun) for(var i = 0; i < numToRun; i++){
                var callback = toRun[i];
                callback(frameData);
                if (toKeepAlive.has(callback)) {
                    step.schedule(callback);
                    runNextFrame();
                }
            }
            isProcessing = false;
        }
    };
    return step;
}

});


parcelRegister("1MwKT", function(module, exports) {

$parcel$export(module.exports, "collectProjectingAncestors", function () { return $14c3aea4e6dd28e4$export$e900175ee6159829; });
$parcel$export(module.exports, "collectProjectingChildren", function () { return $14c3aea4e6dd28e4$export$99d2ce63b1d58b9f; });
$parcel$export(module.exports, "updateLayoutMeasurement", function () { return $14c3aea4e6dd28e4$export$ec1805441219fc83; });
$parcel$export(module.exports, "snapshotViewportBox", function () { return $14c3aea4e6dd28e4$export$4f13d577f7028d57; });

var $iYUpa = parcelRequire("iYUpa");

var $73ZdR = parcelRequire("73ZdR");

var $2AMJ5 = parcelRequire("2AMJ5");
function $14c3aea4e6dd28e4$var$isProjecting(visualElement) {
    var isEnabled = visualElement.projection.isEnabled;
    return isEnabled || visualElement.shouldResetTransform();
}
function $14c3aea4e6dd28e4$export$e900175ee6159829(visualElement, ancestors) {
    if (ancestors === void 0) ancestors = [];
    var parent = visualElement.parent;
    if (parent) $14c3aea4e6dd28e4$export$e900175ee6159829(parent, ancestors);
    if ($14c3aea4e6dd28e4$var$isProjecting(visualElement)) ancestors.push(visualElement);
    return ancestors;
}
function $14c3aea4e6dd28e4$export$99d2ce63b1d58b9f(visualElement) {
    var children = [];
    var addChild = function(child) {
        if ($14c3aea4e6dd28e4$var$isProjecting(child)) children.push(child);
        child.children.forEach(addChild);
    };
    visualElement.children.forEach(addChild);
    return children.sort((0, $2AMJ5.compareByDepth));
}
/**
 * Update the layoutState by measuring the DOM layout. This
 * should be called after resetting any layout-affecting transforms.
 */ function $14c3aea4e6dd28e4$export$ec1805441219fc83(visualElement) {
    if (visualElement.shouldResetTransform()) return;
    var layoutState = visualElement.getLayoutState();
    visualElement.notifyBeforeLayoutMeasure(layoutState.layout);
    layoutState.isHydrated = true;
    layoutState.layout = visualElement.measureViewportBox();
    layoutState.layoutCorrected = (0, $73ZdR.copyAxisBox)(layoutState.layout);
    visualElement.notifyLayoutMeasure(layoutState.layout, visualElement.prevViewportBox || layoutState.layout);
    (0, $iYUpa.default).update(function() {
        return visualElement.rebaseProjectionTarget();
    });
}
/**
 * Record the viewport box as it was before an expected mutation/re-render
 */ function $14c3aea4e6dd28e4$export$4f13d577f7028d57(visualElement) {
    if (visualElement.shouldResetTransform()) return;
    visualElement.prevViewportBox = visualElement.measureViewportBox(false);
    /**
     * Update targetBox to match the prevViewportBox. This is just to ensure
     * that targetBox is affected by scroll in the same way as the measured box
     */ visualElement.rebaseProjectionTarget(false, visualElement.prevViewportBox);
}

});
parcelRegister("73ZdR", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToAxisBox", function () { return $52484dbd0d30edea$export$a6a6a93acd99480a; });
$parcel$export(module.exports, "convertAxisBoxToBoundingBox", function () { return $52484dbd0d30edea$export$7dccf987ed3cfb10; });
$parcel$export(module.exports, "transformBoundingBox", function () { return $52484dbd0d30edea$export$e79a6921359ce186; });
$parcel$export(module.exports, "axisBox", function () { return $52484dbd0d30edea$export$392205f483678b20; });
$parcel$export(module.exports, "copyAxisBox", function () { return $52484dbd0d30edea$export$cad7f7b798bfcc39; });
$parcel$export(module.exports, "delta", function () { return $52484dbd0d30edea$export$eabbe41f409ce55b; });

var $S3LFa = parcelRequire("S3LFa");

var $hpFoS = parcelRequire("hpFoS");
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $52484dbd0d30edea$export$a6a6a93acd99480a(_a) {
    var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $52484dbd0d30edea$export$7dccf987ed3cfb10(_a) {
    var x = _a.x, y = _a.y;
    return {
        top: y.min,
        bottom: y.max,
        left: x.min,
        right: x.max
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $52484dbd0d30edea$export$e79a6921359ce186(_a, transformPoint) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    if (transformPoint === void 0) transformPoint = (0, $hpFoS.noop);
    var topLeft = transformPoint({
        x: left,
        y: top
    });
    var bottomRight = transformPoint({
        x: right,
        y: bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}
/**
 * Create an empty axis box of zero size
 */ function $52484dbd0d30edea$export$392205f483678b20() {
    return {
        x: {
            min: 0,
            max: 1
        },
        y: {
            min: 0,
            max: 1
        }
    };
}
function $52484dbd0d30edea$export$cad7f7b798bfcc39(box) {
    return {
        x: (0, $S3LFa.__assign)({}, box.x),
        y: (0, $S3LFa.__assign)({}, box.y)
    };
}
/**
 * Create an empty box delta
 */ var $52484dbd0d30edea$var$zeroDelta = {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
};
function $52484dbd0d30edea$export$eabbe41f409ce55b() {
    return {
        x: (0, $S3LFa.__assign)({}, $52484dbd0d30edea$var$zeroDelta),
        y: (0, $S3LFa.__assign)({}, $52484dbd0d30edea$var$zeroDelta)
    };
}

});
parcelRegister("hpFoS", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $cad4e2aadbae0f84$export$8793edee2d425525; });
function $cad4e2aadbae0f84$export$8793edee2d425525(any) {
    return any;
}

});


parcelRegister("2AMJ5", function(module, exports) {

$parcel$export(module.exports, "compareByDepth", function () { return $1e34bd8edd14b42c$export$d689d9dec5ad338; });
var $1e34bd8edd14b42c$export$d689d9dec5ad338 = function(a, b) {
    return a.depth - b.depth;
};

});


parcelRegister("22P90", function(module, exports) {

$parcel$export(module.exports, "batchLayout", function () { return $17d370dde9f497af$export$7e76af4b25f08a69; });
$parcel$export(module.exports, "flushLayout", function () { return $17d370dde9f497af$export$6445c3d91f1ae606; });
var $17d370dde9f497af$var$unresolvedJobs = new Set();
function $17d370dde9f497af$var$pushJob(stack, job, pointer) {
    if (!stack[pointer]) stack[pointer] = [];
    stack[pointer].push(job);
}
function $17d370dde9f497af$export$7e76af4b25f08a69(callback) {
    $17d370dde9f497af$var$unresolvedJobs.add(callback);
    return function() {
        return $17d370dde9f497af$var$unresolvedJobs.delete(callback);
    };
}
function $17d370dde9f497af$export$6445c3d91f1ae606() {
    if (!$17d370dde9f497af$var$unresolvedJobs.size) return;
    var pointer = 0;
    var reads = [
        []
    ];
    var writes = [];
    var setRead = function(job) {
        return $17d370dde9f497af$var$pushJob(reads, job, pointer);
    };
    var setWrite = function(job) {
        $17d370dde9f497af$var$pushJob(writes, job, pointer);
        pointer++;
    };
    /**
     * Resolve jobs into their array stacks
     */ $17d370dde9f497af$var$unresolvedJobs.forEach(function(callback) {
        callback(setRead, setWrite);
        pointer = 0;
    });
    $17d370dde9f497af$var$unresolvedJobs.clear();
    /**
     * Execute jobs
     */ var numStacks = writes.length;
    for(var i = 0; i <= numStacks; i++){
        reads[i] && reads[i].forEach($17d370dde9f497af$var$executeJob);
        writes[i] && writes[i].forEach($17d370dde9f497af$var$executeJob);
    }
}
var $17d370dde9f497af$var$executeJob = function(job) {
    return job();
};

});

parcelRegister("ccUUQ", function(module, exports) {

$parcel$export(module.exports, "Presence", function () { return $8e32c159e241c888$export$99c2b779aa4e8b8b; });
$parcel$export(module.exports, "VisibilityAction", function () { return $8e32c159e241c888$export$560b21f26820dbed; });
/**
 * @public
 */ var $8e32c159e241c888$export$99c2b779aa4e8b8b;
(function(Presence) {
    Presence[Presence["Entering"] = 0] = "Entering";
    Presence[Presence["Present"] = 1] = "Present";
    Presence[Presence["Exiting"] = 2] = "Exiting";
})($8e32c159e241c888$export$99c2b779aa4e8b8b || ($8e32c159e241c888$export$99c2b779aa4e8b8b = {}));
/**
 * @public
 */ var $8e32c159e241c888$export$560b21f26820dbed;
(function(VisibilityAction) {
    VisibilityAction[VisibilityAction["Hide"] = 0] = "Hide";
    VisibilityAction[VisibilityAction["Show"] = 1] = "Show";
})($8e32c159e241c888$export$560b21f26820dbed || ($8e32c159e241c888$export$560b21f26820dbed = {}));

});




parcelRegister("9YDGd", function(module, exports) {

$parcel$export(module.exports, "motion", function () { return $74387f3b7b2678de$export$e25e478948902b8b; });

var $S3LFa = parcelRequire("S3LFa");

var $jzzRJ = parcelRequire("jzzRJ");

var $ldoNF = parcelRequire("ldoNF");

var $jQc1x = parcelRequire("jQc1x");

var $39TFx = parcelRequire("39TFx");

var $9hY3G = parcelRequire("9hY3G");

var $ghUIS = parcelRequire("ghUIS");

var $1jLjz = parcelRequire("1jLjz");

var $9OByi = parcelRequire("9OByi");
var $74387f3b7b2678de$var$featureBundle = (0, $S3LFa.__assign)((0, $S3LFa.__assign)((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, (0, $9hY3G.animations)), (0, $39TFx.gestureAnimations)), (0, $ghUIS.drag)), (0, $1jLjz.layoutAnimations));
/**
 * HTML & SVG components, optimised for use with gestures and animation. These can be used as
 * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
 *
 * @public
 */ var $74387f3b7b2678de$export$e25e478948902b8b = /*@__PURE__*/ (0, $ldoNF.createMotionProxy)(function(Component, config) {
    return (0, $jQc1x.createDomMotionConfig)(Component, config, $74387f3b7b2678de$var$featureBundle, (0, $9OByi.createDomVisualElement));
});
/**
 * Create a DOM `motion` component with the provided string. This is primarily intended
 * as a full alternative to `motion` for consumers who have to support environments that don't
 * support `Proxy`.
 *
 * ```javascript
 * import { createDomMotionComponent } from "framer-motion"
 *
 * const motion = {
 *   div: createDomMotionComponent('div')
 * }
 * ```
 *
 * @public
 */ function $74387f3b7b2678de$export$546614c4a05701f9(key) {
    return (0, $jzzRJ.createMotionComponent)((0, $jQc1x.createDomMotionConfig)(key, {
        forwardMotionProps: false
    }, $74387f3b7b2678de$var$featureBundle, (0, $9OByi.createDomVisualElement)));
}

});
parcelRegister("jzzRJ", function(module, exports) {

$parcel$export(module.exports, "createMotionComponent", function () { return $e3fd1b5b6c8ef147$export$46b7e4b9dc6110c3; });

var $4YNlq = parcelRequire("4YNlq");

var $7sUT1 = parcelRequire("7sUT1");

var $ixf53 = parcelRequire("ixf53");

var $icO7T = parcelRequire("icO7T");

var $3GzAW = parcelRequire("3GzAW");

var $kfclA = parcelRequire("kfclA");

var $2IH6C = parcelRequire("2IH6C");

var $G9Owi = parcelRequire("G9Owi");

var $47zAH = parcelRequire("47zAH");
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 *
 * @internal
 */ function $e3fd1b5b6c8ef147$export$46b7e4b9dc6110c3(_a) {
    var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
    preloadedFeatures && (0, $G9Owi.loadFeatures)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we're rendering in a static environment, we only visually update the component
         * as a result of a React-rerender rather than interactions or animations. This
         * means we don't need to load additional memory structures like VisualElement,
         * or any gesture/animation features.
         */ var isStatic = (0, $4YNlq.useContext)((0, $ixf53.MotionConfigContext)).isStatic;
        var features = null;
        /**
         * Create the tree context. This is memoized and will only trigger renders
         * when the current tree variant changes in static mode.
         */ var context = (0, $2IH6C.useCreateMotionContext)(props, isStatic);
        /**
         *
         */ var visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $47zAH.isBrowser)) {
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $3GzAW.useVisualElement)(Component, visualState, props, createVisualElement);
            /**
             * Load Motion gesture and animation features. These are rendered as renderless
             * components so each feature can optionally make use of React lifecycle methods.
             *
             * TODO: The intention is to move these away from a React-centric to a
             * VisualElement-centric lifecycle scheme.
             */ features = (0, $7sUT1.useFeatures)(props, context.visualElement, preloadedFeatures);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return $4YNlq.createElement($4YNlq.Fragment, null, $4YNlq.createElement((0, $icO7T.MotionContext).Provider, {
            value: context
        }, useRender(Component, props, (0, $kfclA.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic)), features);
    }
    return (0, $4YNlq.forwardRef)(MotionComponent);
}

});
parcelRegister("7sUT1", function(module, exports) {

$parcel$export(module.exports, "useFeatures", function () { return $56f7466340b71c59$export$4a39035bacc4ed76; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $G9Owi = parcelRequire("G9Owi");
parcelRequire("dnSYc");

var $a57SM = parcelRequire("a57SM");
var $56f7466340b71c59$var$featureNames = Object.keys((0, $G9Owi.featureDefinitions));
var $56f7466340b71c59$var$numFeatures = $56f7466340b71c59$var$featureNames.length;
/**
 * Load features via renderless components based on the provided MotionProps.
 */ function $56f7466340b71c59$export$4a39035bacc4ed76(props, visualElement, preloadedFeatures) {
    var features = [];
    var lazyContext = (0, $4YNlq.useContext)((0, $a57SM.LazyContext));
    if (!visualElement) return null;
    for(var i = 0; i < $56f7466340b71c59$var$numFeatures; i++){
        var name_1 = $56f7466340b71c59$var$featureNames[i];
        var _a = (0, $G9Owi.featureDefinitions)[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
        /**
         * It might be possible in the future to use this moment to
         * dynamically request functionality. In initial tests this
         * was producing a lot of duplication amongst bundles.
         */ if (isEnabled(props) && Component) features.push($4YNlq.createElement(Component, (0, $S3LFa.__assign)({
            key: name_1
        }, props, {
            visualElement: visualElement
        })));
    }
    return features;
}

});
parcelRegister("G9Owi", function(module, exports) {

$parcel$export(module.exports, "featureDefinitions", function () { return $07eb892eba7e5e4f$export$65570e08d843624d; });
$parcel$export(module.exports, "loadFeatures", function () { return $07eb892eba7e5e4f$export$449561ec5703cdc8; });
var $07eb892eba7e5e4f$var$createDefinition = function(propNames) {
    return {
        isEnabled: function(props) {
            return propNames.some(function(name) {
                return !!props[name];
            });
        }
    };
};
var $07eb892eba7e5e4f$export$65570e08d843624d = {
    measureLayout: $07eb892eba7e5e4f$var$createDefinition([
        "layout",
        "layoutId",
        "drag",
        "_layoutResetTransform"
    ]),
    animation: $07eb892eba7e5e4f$var$createDefinition([
        "animate",
        "exit",
        "variants",
        "whileHover",
        "whileTap",
        "whileFocus",
        "whileDrag"
    ]),
    exit: $07eb892eba7e5e4f$var$createDefinition([
        "exit"
    ]),
    drag: $07eb892eba7e5e4f$var$createDefinition([
        "drag",
        "dragControls"
    ]),
    focus: $07eb892eba7e5e4f$var$createDefinition([
        "whileFocus"
    ]),
    hover: $07eb892eba7e5e4f$var$createDefinition([
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ]),
    tap: $07eb892eba7e5e4f$var$createDefinition([
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ]),
    pan: $07eb892eba7e5e4f$var$createDefinition([
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ]),
    layoutAnimation: $07eb892eba7e5e4f$var$createDefinition([
        "layout",
        "layoutId"
    ])
};
function $07eb892eba7e5e4f$export$449561ec5703cdc8(features) {
    for(var key in features){
        var Component = features[key];
        if (Component !== null) $07eb892eba7e5e4f$export$65570e08d843624d[key].Component = Component;
    }
}

});

parcelRegister("dnSYc", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $9be8103a3b03fd6d$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $9be8103a3b03fd6d$export$f5708dca728d7177; });
var $9be8103a3b03fd6d$export$491112666e282270 = function() {};
var $9be8103a3b03fd6d$export$f5708dca728d7177 = function() {};

});

parcelRegister("a57SM", function(module, exports) {

$parcel$export(module.exports, "LazyContext", function () { return $75707c4eb578cf42$export$40f10139ecf1f171; });

var $4YNlq = parcelRequire("4YNlq");
var $75707c4eb578cf42$export$40f10139ecf1f171 = (0, $4YNlq.createContext)({
    strict: false
});

});


parcelRegister("ixf53", function(module, exports) {

$parcel$export(module.exports, "MotionConfigContext", function () { return $d7e701bbac70ab80$export$22a697fb29aac98d; });

var $4YNlq = parcelRequire("4YNlq");
/**
 * @public
 */ var $d7e701bbac70ab80$export$22a697fb29aac98d = (0, $4YNlq.createContext)({
    transformPagePoint: function(p) {
        return p;
    },
    isStatic: false
});

});

parcelRegister("icO7T", function(module, exports) {

$parcel$export(module.exports, "MotionContext", function () { return $d4103b0ad4de60ea$export$2285bbca2c666415; });
$parcel$export(module.exports, "useVisualElementContext", function () { return $d4103b0ad4de60ea$export$cd995842eb2ab956; });

var $4YNlq = parcelRequire("4YNlq");
var $d4103b0ad4de60ea$export$2285bbca2c666415 = (0, $4YNlq.createContext)({});
function $d4103b0ad4de60ea$export$cd995842eb2ab956() {
    return (0, $4YNlq.useContext)($d4103b0ad4de60ea$export$2285bbca2c666415).visualElement;
}

});

parcelRegister("3GzAW", function(module, exports) {

$parcel$export(module.exports, "useVisualElement", function () { return $2af0e7beea4a4f18$export$dc0335d73ab0b115; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $eVG38 = parcelRequire("eVG38");

var $ltGQn = parcelRequire("ltGQn");

var $kyAPY = parcelRequire("kyAPY");

var $icO7T = parcelRequire("icO7T");

var $7b2Rd = parcelRequire("7b2Rd");

var $ixf53 = parcelRequire("ixf53");

var $a57SM = parcelRequire("a57SM");
function $2af0e7beea4a4f18$var$useLayoutId(_a) {
    var layoutId = _a.layoutId;
    var layoutGroupId = (0, $4YNlq.useContext)((0, $kyAPY.LayoutGroupContext));
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $2af0e7beea4a4f18$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement) {
    var config = (0, $4YNlq.useContext)((0, $ixf53.MotionConfigContext));
    var lazyContext = (0, $4YNlq.useContext)((0, $a57SM.LazyContext));
    var parent = (0, $icO7T.useVisualElementContext)();
    var presenceContext = (0, $4YNlq.useContext)((0, $eVG38.PresenceContext));
    var layoutId = $2af0e7beea4a4f18$var$useLayoutId(props);
    var visualElementRef = (0, $4YNlq.useRef)(undefined);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ if (!createVisualElement) createVisualElement = lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, props), {
            layoutId: layoutId
        }),
        presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
        blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false
    });
    var visualElement = visualElementRef.current;
    (0, $7b2Rd.useIsomorphicLayoutEffect)(function() {
        if (!visualElement) return;
        visualElement.setProps((0, $S3LFa.__assign)((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, config), props), {
            layoutId: layoutId
        }));
        visualElement.isPresent = (0, $ltGQn.isPresent)(presenceContext);
        visualElement.isPresenceRoot = !parent || parent.presenceId !== (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id);
        /**
         * Fire a render to ensure the latest state is reflected on-screen.
         */ visualElement.syncRender();
    });
    (0, $4YNlq.useEffect)(function() {
        var _a;
        if (!visualElement) return;
        /**
         * In a future refactor we can replace the features-as-components and
         * have this loop through them all firing "effect" listeners
         */ (_a = visualElement.animationState) === null || _a === void 0 || _a.animateChanges();
    });
    (0, $7b2Rd.useIsomorphicLayoutEffect)(function() {
        return function() {
            return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount();
        };
    }, []);
    return visualElement;
}

});
parcelRegister("ltGQn", function(module, exports) {

$parcel$export(module.exports, "usePresence", function () { return $fa2d8a4f56cff43e$export$2a8c16d82a0a0e26; });
$parcel$export(module.exports, "isPresent", function () { return $fa2d8a4f56cff43e$export$ee27c052bca048fb; });

var $4YNlq = parcelRequire("4YNlq");

var $eVG38 = parcelRequire("eVG38");

var $7nP7f = parcelRequire("7nP7f");
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $fa2d8a4f56cff43e$export$2a8c16d82a0a0e26() {
    var context = (0, $4YNlq.useContext)((0, $eVG38.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    // Replace with useOpaqueId when released in React
    var id = $fa2d8a4f56cff43e$var$useUniqueId();
    (0, $4YNlq.useEffect)(function() {
        return register(id);
    }, []);
    var safeToRemove = function() {
        return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id);
    };
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $fa2d8a4f56cff43e$export$8249053f690ea39a() {
    return $fa2d8a4f56cff43e$export$ee27c052bca048fb((0, $4YNlq.useContext)((0, $eVG38.PresenceContext)));
}
function $fa2d8a4f56cff43e$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}
var $fa2d8a4f56cff43e$var$counter = 0;
var $fa2d8a4f56cff43e$var$incrementId = function() {
    return $fa2d8a4f56cff43e$var$counter++;
};
var $fa2d8a4f56cff43e$var$useUniqueId = function() {
    return (0, $7nP7f.useConstant)($fa2d8a4f56cff43e$var$incrementId);
};

});

parcelRegister("kyAPY", function(module, exports) {

$parcel$export(module.exports, "LayoutGroupContext", function () { return $ef738ec2f7ed86a0$export$a3579ca508007a95; });

var $4YNlq = parcelRequire("4YNlq");
/**
 * @internal
 */ var $ef738ec2f7ed86a0$export$a3579ca508007a95 = (0, $4YNlq.createContext)(null);

});

parcelRegister("7b2Rd", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $539bc6e4985a15f4$export$700979bc83e7db82; });

var $4YNlq = parcelRequire("4YNlq");

var $47zAH = parcelRequire("47zAH");
var $539bc6e4985a15f4$export$700979bc83e7db82 = (0, $47zAH.isBrowser) ? (0, $4YNlq.useLayoutEffect) : (0, $4YNlq.useEffect);

});
parcelRegister("47zAH", function(module, exports) {

$parcel$export(module.exports, "isBrowser", function () { return $30036c80aa2bb759$export$4e09c449d6c407f7; });
var $30036c80aa2bb759$export$4e09c449d6c407f7 = typeof window !== "undefined";

});



parcelRegister("kfclA", function(module, exports) {

$parcel$export(module.exports, "useMotionRef", function () { return $ebcec9407a434deb$export$c684914703d321fd; });

var $4YNlq = parcelRequire("4YNlq");

var $d1tA5 = parcelRequire("d1tA5");
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $ebcec9407a434deb$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $4YNlq.useCallback)(function(instance) {
        var _a;
        instance && ((_a = visualState.mount) === null || _a === void 0 || _a.call(visualState, instance));
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $d1tA5.isRefObject)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}

});
parcelRegister("d1tA5", function(module, exports) {

$parcel$export(module.exports, "isRefObject", function () { return $97b2508c26f992b1$export$dedd81df7bc1307; });
function $97b2508c26f992b1$export$dedd81df7bc1307(ref) {
    return typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

});


parcelRegister("2IH6C", function(module, exports) {

$parcel$export(module.exports, "useCreateMotionContext", function () { return $1fb120c2de704016$export$c5638d843b37a176; });

var $4YNlq = parcelRequire("4YNlq");

var $icO7T = parcelRequire("icO7T");

var $dnkcX = parcelRequire("dnkcX");
function $1fb120c2de704016$export$c5638d843b37a176(props, isStatic) {
    var _a = (0, $dnkcX.getCurrentTreeVariants)(props, (0, $4YNlq.useContext)((0, $icO7T.MotionContext))), initial = _a.initial, animate = _a.animate;
    return (0, $4YNlq.useMemo)(function() {
        return {
            initial: initial,
            animate: animate
        };
    }, /**
     * Only break memoisation in static mode
     */ isStatic ? [
        $1fb120c2de704016$var$variantLabelsAsDependency(initial),
        $1fb120c2de704016$var$variantLabelsAsDependency(animate)
    ] : []);
}
function $1fb120c2de704016$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

});
parcelRegister("dnkcX", function(module, exports) {

$parcel$export(module.exports, "getCurrentTreeVariants", function () { return $9bcd193ecf880647$export$12fc32fc096a04a3; });

var $7NspE = parcelRequire("7NspE");
function $9bcd193ecf880647$export$12fc32fc096a04a3(props, context) {
    if ((0, $7NspE.checkIfControllingVariants)(props)) {
        var initial = props.initial, animate = props.animate;
        return {
            initial: initial === false || (0, $7NspE.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, $7NspE.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

});
parcelRegister("7NspE", function(module, exports) {

$parcel$export(module.exports, "isVariantLabels", function () { return $5ad32628b7ef3ae7$export$562271cd22f751d; });
$parcel$export(module.exports, "isVariantLabel", function () { return $5ad32628b7ef3ae7$export$720b90e312cea233; });
$parcel$export(module.exports, "resolveVariantFromProps", function () { return $5ad32628b7ef3ae7$export$d68f140c4d9b48bc; });
$parcel$export(module.exports, "resolveVariant", function () { return $5ad32628b7ef3ae7$export$7b1b1c981f4f0558; });
$parcel$export(module.exports, "checkIfControllingVariants", function () { return $5ad32628b7ef3ae7$export$cf3a7bd331c35bf0; });
$parcel$export(module.exports, "checkIfVariantNode", function () { return $5ad32628b7ef3ae7$export$c0eba02279c18fea; });
/**
 * Decides if the supplied variable is an array of variant labels
 */ function $5ad32628b7ef3ae7$export$562271cd22f751d(v) {
    return Array.isArray(v);
}
/**
 * Decides if the supplied variable is variant label
 */ function $5ad32628b7ef3ae7$export$720b90e312cea233(v) {
    return typeof v === "string" || $5ad32628b7ef3ae7$export$562271cd22f751d(v);
}
/**
 * Creates an object containing the latest state of every MotionValue on a VisualElement
 */ function $5ad32628b7ef3ae7$var$getCurrent(visualElement) {
    var current = {};
    visualElement.forEachValue(function(value, key) {
        return current[key] = value.get();
    });
    return current;
}
/**
 * Creates an object containing the latest velocity of every MotionValue on a VisualElement
 */ function $5ad32628b7ef3ae7$var$getVelocity(visualElement) {
    var velocity = {};
    visualElement.forEachValue(function(value, key) {
        return velocity[key] = value.getVelocity();
    });
    return velocity;
}
function $5ad32628b7ef3ae7$export$d68f140c4d9b48bc(props, definition, custom, currentValues, currentVelocity) {
    var _a;
    if (currentValues === void 0) currentValues = {};
    if (currentVelocity === void 0) currentVelocity = {};
    if (typeof definition === "string") definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
    return typeof definition === "function" ? definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity) : definition;
}
function $5ad32628b7ef3ae7$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return $5ad32628b7ef3ae7$export$d68f140c4d9b48bc(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, $5ad32628b7ef3ae7$var$getCurrent(visualElement), $5ad32628b7ef3ae7$var$getVelocity(visualElement));
}
function $5ad32628b7ef3ae7$export$cf3a7bd331c35bf0(props) {
    var _a;
    return typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" || $5ad32628b7ef3ae7$export$720b90e312cea233(props.initial) || $5ad32628b7ef3ae7$export$720b90e312cea233(props.animate) || $5ad32628b7ef3ae7$export$720b90e312cea233(props.whileHover) || $5ad32628b7ef3ae7$export$720b90e312cea233(props.whileDrag) || $5ad32628b7ef3ae7$export$720b90e312cea233(props.whileTap) || $5ad32628b7ef3ae7$export$720b90e312cea233(props.whileFocus) || $5ad32628b7ef3ae7$export$720b90e312cea233(props.exit);
}
function $5ad32628b7ef3ae7$export$c0eba02279c18fea(props) {
    return Boolean($5ad32628b7ef3ae7$export$cf3a7bd331c35bf0(props) || props.variants);
}

});




parcelRegister("ldoNF", function(module, exports) {

$parcel$export(module.exports, "createMotionProxy", function () { return $f71e0ca41df8325b$export$a28d6df673050e18; });

var $jzzRJ = parcelRequire("jzzRJ");
/**
 * Convert any React component into a `motion` component. The provided component
 * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
 *
 * ```jsx
 * const Component = React.forwardRef((props, ref) => {
 *   return <div ref={ref} />
 * })
 *
 * const MotionComponent = motion(Component)
 * ```
 *
 * @public
 */ function $f71e0ca41df8325b$export$a28d6df673050e18(createConfig) {
    function custom(Component, customMotionComponentConfig) {
        if (customMotionComponentConfig === void 0) customMotionComponentConfig = {};
        return (0, $jzzRJ.createMotionComponent)(createConfig(Component, customMotionComponentConfig));
    }
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ var componentCache = new Map();
    return new Proxy(custom, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: function(_target, key) {
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, custom(key));
            return componentCache.get(key);
        }
    });
}

});

parcelRegister("jQc1x", function(module, exports) {

$parcel$export(module.exports, "createDomMotionConfig", function () { return $e71c3353a21da6b6$export$732916c0e88175fb; });

var $S3LFa = parcelRequire("S3LFa");

var $7vNru = parcelRequire("7vNru");

var $ccOhk = parcelRequire("ccOhk");

var $4bvWv = parcelRequire("4bvWv");

var $hSMCg = parcelRequire("hSMCg");
function $e71c3353a21da6b6$export$732916c0e88175fb(Component, _a, preloadedFeatures, createVisualElement) {
    var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
    var baseConfig = (0, $7vNru.isSVGComponent)(Component) ? (0, $4bvWv.svgMotionConfig) : (0, $hSMCg.htmlMotionConfig);
    return (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, baseConfig), {
        preloadedFeatures: preloadedFeatures,
        useRender: (0, $ccOhk.createUseRender)(forwardMotionProps),
        createVisualElement: createVisualElement,
        Component: Component
    });
}

});
parcelRegister("7vNru", function(module, exports) {

$parcel$export(module.exports, "isSVGComponent", function () { return $5781c7dc0dd546fd$export$88f3fc2fd3766989; });

var $ky2b8 = parcelRequire("ky2b8");
function $5781c7dc0dd546fd$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $ky2b8.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/.test(Component)) return true;
    return false;
}

});
parcelRegister("ky2b8", function(module, exports) {

$parcel$export(module.exports, "lowercaseSVGElements", function () { return $ef58ac3ec38f358d$export$40209c4c512158e6; });
/**
 * We keep these listed seperately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var $ef58ac3ec38f358d$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "tspan",
    "use",
    "view"
];

});


parcelRegister("ccOhk", function(module, exports) {

$parcel$export(module.exports, "createUseRender", function () { return $8e2d9b4a95352da8$export$5d29104eefd89cc8; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $7hlMA = parcelRequire("7hlMA");

var $jBDEm = parcelRequire("jBDEm");

var $7vNru = parcelRequire("7vNru");

var $bt3Gi = parcelRequire("bt3Gi");
function $8e2d9b4a95352da8$export$5d29104eefd89cc8(forwardMotionProps) {
    if (forwardMotionProps === void 0) forwardMotionProps = false;
    var useRender = function(Component, props, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = (0, $7vNru.isSVGComponent)(Component) ? (0, $bt3Gi.useSVGProps) : (0, $7hlMA.useHTMLProps);
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = (0, $jBDEm.filterProps)(props, typeof Component === "string", forwardMotionProps);
        var elementProps = (0, $S3LFa.__assign)((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, filteredProps), visualProps), {
            ref: ref
        });
        return (0, $4YNlq.createElement)(Component, elementProps);
    };
    return useRender;
}

});
parcelRegister("7hlMA", function(module, exports) {

$parcel$export(module.exports, "copyRawValuesOnly", function () { return $54cb047e0c9a00dd$export$40dafdb8630c956b; });
$parcel$export(module.exports, "useHTMLProps", function () { return $54cb047e0c9a00dd$export$57be0a314572d87d; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $4ZcxX = parcelRequire("4ZcxX");

var $67Lja = parcelRequire("67Lja");

var $1avWS = parcelRequire("1avWS");

var $klr2Q = parcelRequire("klr2Q");
function $54cb047e0c9a00dd$export$40dafdb8630c956b(target, source, props) {
    for(var key in source)if (!(0, $67Lja.isMotionValue)(source[key]) && !(0, $4ZcxX.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function $54cb047e0c9a00dd$var$useInitialMotionValues(_a, visualState, isStatic) {
    var transformTemplate = _a.transformTemplate;
    return (0, $4YNlq.useMemo)(function() {
        var state = (0, $klr2Q.createHtmlRenderState)();
        (0, $1avWS.buildHTMLStyles)(state, visualState, undefined, undefined, {
            enableHardwareAcceleration: !isStatic
        }, transformTemplate);
        var vars = state.vars, style = state.style;
        return (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, vars), style);
    }, [
        visualState
    ]);
}
function $54cb047e0c9a00dd$export$72c85e333541e7f(props, visualState, isStatic) {
    var styleProp = props.style || {};
    var style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $54cb047e0c9a00dd$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $54cb047e0c9a00dd$var$useInitialMotionValues(props, visualState, isStatic));
    if (props.transformValues) style = props.transformValues(style);
    return style;
}
function $54cb047e0c9a00dd$export$57be0a314572d87d(props, visualState, isStatic) {
    // The `any` isn't ideal but it is the type of createElement props argument
    var htmlProps = {};
    var style = $54cb047e0c9a00dd$export$72c85e333541e7f(props, visualState, isStatic);
    if (Boolean(props.drag)) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : "pan-" + (props.drag === "x" ? "y" : "x");
    }
    htmlProps.style = style;
    return htmlProps;
}

});
parcelRegister("4ZcxX", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $3a169773c899cf4d$export$6d27ce8e3de1c3cf; });

var $baSNF = parcelRequire("baSNF");

var $479mE = parcelRequire("479mE");
function $3a169773c899cf4d$export$6d27ce8e3de1c3cf(key, _a) {
    var layout = _a.layout, layoutId = _a.layoutId;
    return (0, $479mE.isTransformProp)(key) || (0, $479mE.isTransformOriginProp)(key) || (layout || layoutId !== undefined) && (!!(0, $baSNF.valueScaleCorrection)[key] || key === "opacity");
}

});
parcelRegister("baSNF", function(module, exports) {

$parcel$export(module.exports, "valueScaleCorrection", function () { return $822b2309e102363a$export$d57fad728466ad75; });
$parcel$export(module.exports, "addScaleCorrection", function () { return $822b2309e102363a$export$2cba7fcde4b7b2d5; });
var $822b2309e102363a$export$d57fad728466ad75 = {};
/**
 * @internal
 */ function $822b2309e102363a$export$2cba7fcde4b7b2d5(correctors) {
    for(var key in correctors)$822b2309e102363a$export$d57fad728466ad75[key] = correctors[key];
}

});

parcelRegister("479mE", function(module, exports) {

$parcel$export(module.exports, "transformProps", function () { return $2fef14713c5132bb$export$7b42a0094fb00b6e; });
$parcel$export(module.exports, "sortTransformProps", function () { return $2fef14713c5132bb$export$61f68472e7973485; });
$parcel$export(module.exports, "isTransformProp", function () { return $2fef14713c5132bb$export$15240a8a4379d8de; });
$parcel$export(module.exports, "isTransformOriginProp", function () { return $2fef14713c5132bb$export$91fe49ee9d172523; });
/**
 * A list of all transformable axes. We'll use this list to generated a version
 * of each axes for each transform.
 */ var $2fef14713c5132bb$export$67cd428da31419e1 = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * An ordered array of each transformable value. By default, transform values
 * will be sorted to this order.
 */ var $2fef14713c5132bb$var$order = [
    "translate",
    "scale",
    "rotate",
    "skew"
];
/**
 * Generate a list of every possible transform key.
 */ var $2fef14713c5132bb$export$7b42a0094fb00b6e = [
    "transformPerspective",
    "x",
    "y",
    "z"
];
$2fef14713c5132bb$var$order.forEach(function(operationKey) {
    return $2fef14713c5132bb$export$67cd428da31419e1.forEach(function(axesKey) {
        return $2fef14713c5132bb$export$7b42a0094fb00b6e.push(operationKey + axesKey);
    });
});
/**
 * A function to use with Array.sort to sort transform keys by their default order.
 */ function $2fef14713c5132bb$export$61f68472e7973485(a, b) {
    return $2fef14713c5132bb$export$7b42a0094fb00b6e.indexOf(a) - $2fef14713c5132bb$export$7b42a0094fb00b6e.indexOf(b);
}
/**
 * A quick lookup for transform props.
 */ var $2fef14713c5132bb$var$transformPropSet = new Set($2fef14713c5132bb$export$7b42a0094fb00b6e);
function $2fef14713c5132bb$export$15240a8a4379d8de(key) {
    return $2fef14713c5132bb$var$transformPropSet.has(key);
}
/**
 * A quick lookup for transform origin props
 */ var $2fef14713c5132bb$var$transformOriginProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
function $2fef14713c5132bb$export$91fe49ee9d172523(key) {
    return $2fef14713c5132bb$var$transformOriginProps.has(key);
}

});


parcelRegister("67Lja", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $475817eea7eb669b$export$605d60a2578142d3; });
var $475817eea7eb669b$export$605d60a2578142d3 = function(value) {
    return value !== null && typeof value === "object" && value.getVelocity;
};

});

parcelRegister("1avWS", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $0d9f81eee1973197$export$bb517f8b40f8e99d; });

var $baSNF = parcelRequire("baSNF");

var $lzKHi = parcelRequire("lzKHi");

var $18NTo = parcelRequire("18NTo");

var $479mE = parcelRequire("479mE");

var $e7VgE = parcelRequire("e7VgE");

var $22TE3 = parcelRequire("22TE3");
function $0d9f81eee1973197$export$bb517f8b40f8e99d(state, latestValues, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var _a;
    var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
    // Empty the transformKeys array. As we're throwing out refs to its items
    // this might not be as cheap as suspected. Maybe using the array as a buffer
    // with a manual incrementation would be better.
    transformKeys.length = 0;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    // Does the calculated transform essentially equal "none"?
    var transformIsNone = true;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept seperately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        /**
         * If this is a CSS variable we don't do any further processing.
         */ if ((0, $18NTo.isCSSVariable)(key)) {
            vars[key] = value;
            continue;
        }
        // Convert the value to its default value type, ie 0 -> "0px"
        var valueType = (0, $22TE3.numberValueTypes)[key];
        var valueAsType = (0, $e7VgE.getValueAsType)(value, valueType);
        if ((0, $479mE.isTransformProp)(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            // If we already know we have a non-default transform, early return
            if (!transformIsNone) continue;
            // Otherwise check to see if this is a default transform
            if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0)) transformIsNone = false;
        } else if ((0, $479mE.isTransformOriginProp)(key)) {
            transformOrigin[key] = valueAsType;
            // If this is a transform origin, flag and enable further transform-origin processing
            hasTransformOrigin = true;
        } else /**
             * If layout projection is on, and we need to perform scale correction for this
             * value type, perform it.
             */ if ((projection === null || projection === void 0 ? void 0 : projection.isHydrated) && (layoutState === null || layoutState === void 0 ? void 0 : layoutState.isHydrated) && (0, $baSNF.valueScaleCorrection)[key]) {
            var correctedValue = (0, $baSNF.valueScaleCorrection)[key].process(value, layoutState, projection);
            /**
                 * Scale-correctable values can define a number of other values to break
                 * down into. For instance borderRadius needs applying to borderBottomLeftRadius etc
                 */ var applyTo = (0, $baSNF.valueScaleCorrection)[key].applyTo;
            if (applyTo) {
                var num = applyTo.length;
                for(var i = 0; i < num; i++)style[applyTo[i]] = correctedValue;
            } else style[key] = correctedValue;
        } else style[key] = valueAsType;
    }
    if (layoutState && projection && buildProjectionTransform && buildProjectionTransformOrigin) {
        style.transform = buildProjectionTransform(layoutState.deltaFinal, layoutState.treeScale, hasTransform ? transform : undefined);
        if (transformTemplate) style.transform = transformTemplate(transform, style.transform);
        style.transformOrigin = buildProjectionTransformOrigin(layoutState);
    } else {
        if (hasTransform) style.transform = (0, $lzKHi.buildTransform)(state, options, transformIsNone, transformTemplate);
        if (hasTransformOrigin) style.transformOrigin = (0, $lzKHi.buildTransformOrigin)(transformOrigin);
    }
}

});
parcelRegister("lzKHi", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $fb5116f6960557c4$export$bdc96e0d5c8f914; });
$parcel$export(module.exports, "buildTransformOrigin", function () { return $fb5116f6960557c4$export$22d2fbf39767d07a; });

var $479mE = parcelRequire("479mE");
var $fb5116f6960557c4$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $fb5116f6960557c4$export$bdc96e0d5c8f914(_a, _b, transformIsDefault, transformTemplate) {
    var transform = _a.transform, transformKeys = _a.transformKeys;
    var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
    // The transform string we're going to build into.
    var transformString = "";
    // Transform keys into their default order - this will determine the output order.
    transformKeys.sort((0, $479mE.sortTransformProps));
    // Track whether the defined transform has a defined z so we don't add a
    // second to enable hardware acceleration
    var transformHasZ = false;
    // Loop over each transform and build them into transformString
    var numTransformKeys = transformKeys.length;
    for(var i = 0; i < numTransformKeys; i++){
        var key = transformKeys[i];
        transformString += ($fb5116f6960557c4$var$translateAlias[key] || key) + "(" + transform[key] + ") ";
        if (key === "z") transformHasZ = true;
    }
    if (!transformHasZ && enableHardwareAcceleration) transformString += "translateZ(0)";
    else transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (allowTransformNone && transformIsDefault) transformString = "none";
    return transformString;
}
/**
 * Build a transformOrigin style. Uses the same defaults as the browser for
 * undefined origins.
 */ function $fb5116f6960557c4$export$22d2fbf39767d07a(_a) {
    var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
    return originX + " " + originY + " " + originZ;
}

});

parcelRegister("18NTo", function(module, exports) {

$parcel$export(module.exports, "isCSSVariable", function () { return $0d4d3d60be7a038d$export$451bc42768436155; });
/**
 * Returns true if the provided key is a CSS variable
 */ function $0d4d3d60be7a038d$export$451bc42768436155(key) {
    return key.startsWith("--");
}

});

parcelRegister("e7VgE", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $a48e244d0eb54e3a$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $a48e244d0eb54e3a$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("22TE3", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $17d6ee99e6d1a136$export$eec14432cd1cb67b; });

var $b7dp4 = parcelRequire("b7dp4");
var $avwtz = parcelRequire("avwtz");

var $g4qhD = parcelRequire("g4qhD");
var $17d6ee99e6d1a136$export$eec14432cd1cb67b = {
    // Border props
    borderWidth: (0, $avwtz.px),
    borderTopWidth: (0, $avwtz.px),
    borderRightWidth: (0, $avwtz.px),
    borderBottomWidth: (0, $avwtz.px),
    borderLeftWidth: (0, $avwtz.px),
    borderRadius: (0, $avwtz.px),
    radius: (0, $avwtz.px),
    borderTopLeftRadius: (0, $avwtz.px),
    borderTopRightRadius: (0, $avwtz.px),
    borderBottomRightRadius: (0, $avwtz.px),
    borderBottomLeftRadius: (0, $avwtz.px),
    // Positioning props
    width: (0, $avwtz.px),
    maxWidth: (0, $avwtz.px),
    height: (0, $avwtz.px),
    maxHeight: (0, $avwtz.px),
    size: (0, $avwtz.px),
    top: (0, $avwtz.px),
    right: (0, $avwtz.px),
    bottom: (0, $avwtz.px),
    left: (0, $avwtz.px),
    // Spacing props
    padding: (0, $avwtz.px),
    paddingTop: (0, $avwtz.px),
    paddingRight: (0, $avwtz.px),
    paddingBottom: (0, $avwtz.px),
    paddingLeft: (0, $avwtz.px),
    margin: (0, $avwtz.px),
    marginTop: (0, $avwtz.px),
    marginRight: (0, $avwtz.px),
    marginBottom: (0, $avwtz.px),
    marginLeft: (0, $avwtz.px),
    // Transform props
    rotate: (0, $avwtz.degrees),
    rotateX: (0, $avwtz.degrees),
    rotateY: (0, $avwtz.degrees),
    rotateZ: (0, $avwtz.degrees),
    scale: (0, $b7dp4.scale),
    scaleX: (0, $b7dp4.scale),
    scaleY: (0, $b7dp4.scale),
    scaleZ: (0, $b7dp4.scale),
    skew: (0, $avwtz.degrees),
    skewX: (0, $avwtz.degrees),
    skewY: (0, $avwtz.degrees),
    distance: (0, $avwtz.px),
    translateX: (0, $avwtz.px),
    translateY: (0, $avwtz.px),
    translateZ: (0, $avwtz.px),
    x: (0, $avwtz.px),
    y: (0, $avwtz.px),
    z: (0, $avwtz.px),
    perspective: (0, $avwtz.px),
    transformPerspective: (0, $avwtz.px),
    opacity: (0, $b7dp4.alpha),
    originX: (0, $avwtz.progressPercentage),
    originY: (0, $avwtz.progressPercentage),
    originZ: (0, $avwtz.px),
    // Misc
    zIndex: (0, $g4qhD.int),
    // SVG
    fillOpacity: (0, $b7dp4.alpha),
    strokeOpacity: (0, $b7dp4.alpha),
    numOctaves: (0, $g4qhD.int)
};

});
parcelRegister("b7dp4", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $817abec770ee2183$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $817abec770ee2183$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $817abec770ee2183$export$dcdf75081b88279d; });

var $S3LFa = parcelRequire("S3LFa");

var $eYw7E = parcelRequire("eYw7E");
var $817abec770ee2183$export$98e628dec113755e = {
    test: function(v) {
        return typeof v === "number";
    },
    parse: parseFloat,
    transform: function(v) {
        return v;
    }
};
var $817abec770ee2183$export$58f0f39f63f3cf42 = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, $817abec770ee2183$export$98e628dec113755e), {
    transform: (0, $eYw7E.clamp)(0, 1)
});
var $817abec770ee2183$export$dcdf75081b88279d = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, $817abec770ee2183$export$98e628dec113755e), {
    default: 1
});

});
parcelRegister("eYw7E", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $ae6f961f1989bbb0$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "sanitize", function () { return $ae6f961f1989bbb0$export$83d2e9e3e4ee39ed; });
$parcel$export(module.exports, "floatRegex", function () { return $ae6f961f1989bbb0$export$2444ca58c08448e4; });
$parcel$export(module.exports, "colorRegex", function () { return $ae6f961f1989bbb0$export$740b69c5fad25dba; });
$parcel$export(module.exports, "singleColorRegex", function () { return $ae6f961f1989bbb0$export$ed808ff6ecd39e8d; });
$parcel$export(module.exports, "isString", function () { return $ae6f961f1989bbb0$export$844ec244b1367d54; });
var $ae6f961f1989bbb0$export$7d15b64cf5a3a4c4 = function(min, max) {
    return function(v) {
        return Math.max(Math.min(v, max), min);
    };
};
var $ae6f961f1989bbb0$export$83d2e9e3e4ee39ed = function(v) {
    return v % 1 ? Number(v.toFixed(5)) : v;
};
var $ae6f961f1989bbb0$export$2444ca58c08448e4 = /(-)?([\d]*\.?[\d])+/g;
var $ae6f961f1989bbb0$export$740b69c5fad25dba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
var $ae6f961f1989bbb0$export$ed808ff6ecd39e8d = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function $ae6f961f1989bbb0$export$844ec244b1367d54(v) {
    return typeof v === "string";
}

});


parcelRegister("avwtz", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $7a65fdb4274ebee1$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $7a65fdb4274ebee1$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $7a65fdb4274ebee1$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $7a65fdb4274ebee1$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $7a65fdb4274ebee1$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $7a65fdb4274ebee1$export$44e2e1705876d7ed; });

var $S3LFa = parcelRequire("S3LFa");

var $eYw7E = parcelRequire("eYw7E");
var $7a65fdb4274ebee1$var$createUnitType = function(unit) {
    return {
        test: function(v) {
            return (0, $eYw7E.isString)(v) && v.endsWith(unit) && v.split(" ").length === 1;
        },
        parse: parseFloat,
        transform: function(v) {
            return "" + v + unit;
        }
    };
};
var $7a65fdb4274ebee1$export$41fc368e1a942b97 = $7a65fdb4274ebee1$var$createUnitType("deg");
var $7a65fdb4274ebee1$export$626336c2cd4b14de = $7a65fdb4274ebee1$var$createUnitType("%");
var $7a65fdb4274ebee1$export$91c0eda1d06bf008 = $7a65fdb4274ebee1$var$createUnitType("px");
var $7a65fdb4274ebee1$export$f91e8c45a95a32f2 = $7a65fdb4274ebee1$var$createUnitType("vh");
var $7a65fdb4274ebee1$export$aed3d7b7d206c196 = $7a65fdb4274ebee1$var$createUnitType("vw");
var $7a65fdb4274ebee1$export$44e2e1705876d7ed = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, $7a65fdb4274ebee1$export$626336c2cd4b14de), {
    parse: function(v) {
        return $7a65fdb4274ebee1$export$626336c2cd4b14de.parse(v) / 100;
    },
    transform: function(v) {
        return $7a65fdb4274ebee1$export$626336c2cd4b14de.transform(v * 100);
    }
});

});

parcelRegister("g4qhD", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $bb31686bc286b2d2$export$7d260a2a5f8bc19e; });

var $S3LFa = parcelRequire("S3LFa");

var $b7dp4 = parcelRequire("b7dp4");
var $bb31686bc286b2d2$export$7d260a2a5f8bc19e = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, (0, $b7dp4.number)), {
    transform: Math.round
});

});



parcelRegister("klr2Q", function(module, exports) {

$parcel$export(module.exports, "createHtmlRenderState", function () { return $ecfabf56881679d2$export$8940b483cf52eeda; });
var $ecfabf56881679d2$export$8940b483cf52eeda = function() {
    return {
        style: {},
        transform: {},
        transformKeys: [],
        transformOrigin: {},
        vars: {}
    };
};

});


parcelRegister("jBDEm", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $e4603aa88f3d09c6$export$d697c39a2985a4c; });

var $da79d = parcelRequire("da79d");
var $e4603aa88f3d09c6$var$shouldForward = function(key) {
    return !(0, $da79d.isValidMotionProp)(key);
};

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    var $e4603aa88f3d09c6$var$emotionIsPropValid_1 = (parcelRequire("jRVSa")).default;
    $e4603aa88f3d09c6$var$shouldForward = function(key) {
        // Handle events explicitly as Emotion validates them all as true
        if (key.startsWith("on")) return !(0, $da79d.isValidMotionProp)(key);
        else return $e4603aa88f3d09c6$var$emotionIsPropValid_1(key);
    };
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $e4603aa88f3d09c6$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    var filteredProps = {};
    for(var key in props)if ($e4603aa88f3d09c6$var$shouldForward(key) || forwardMotionProps === true && (0, $da79d.isValidMotionProp)(key) || !isDom && !(0, $da79d.isValidMotionProp)(key)) filteredProps[key] = props[key];
    return filteredProps;
}

});
parcelRegister("da79d", function(module, exports) {

$parcel$export(module.exports, "isValidMotionProp", function () { return $9951c0ed0341800d$export$2f9c46555243bf04; });
/**
 * A list of all valid MotionProps.
 *
 * @internalremarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var $9951c0ed0341800d$var$validMotionProps = new Set([
    "initial",
    "animate",
    "exit",
    "style",
    "variants",
    "transition",
    "transformTemplate",
    "transformValues",
    "custom",
    "inherit",
    "layout",
    "layoutId",
    "_layoutResetTransform",
    "onLayoutAnimationComplete",
    "onViewportBoxUpdate",
    "onLayoutMeasure",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "drag",
    "dragControls",
    "dragListener",
    "dragConstraints",
    "dragDirectionLock",
    "_dragX",
    "_dragY",
    "dragElastic",
    "dragMomentum",
    "dragPropagation",
    "dragTransition",
    "whileDrag",
    "onPan",
    "onPanStart",
    "onPanEnd",
    "onPanSessionStart",
    "onTap",
    "onTapStart",
    "onTapCancel",
    "onHoverStart",
    "onHoverEnd",
    "whileFocus",
    "whileTap",
    "whileHover"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $9951c0ed0341800d$export$2f9c46555243bf04(key) {
    return $9951c0ed0341800d$var$validMotionProps.has(key);
}

});

parcelRegister("jRVSa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e76fdbd9615b5018$export$2e2bcd8739ae039; });

var $aFHC5 = parcelRequire("aFHC5");
var $e76fdbd9615b5018$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e76fdbd9615b5018$var$index = (0, $aFHC5.default)(function(prop) {
    return $e76fdbd9615b5018$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $e76fdbd9615b5018$export$2e2bcd8739ae039 = $e76fdbd9615b5018$var$index;

});
parcelRegister("aFHC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c4f906b63d59bf9$export$2e2bcd8739ae039; });
function $7c4f906b63d59bf9$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $7c4f906b63d59bf9$export$2e2bcd8739ae039 = $7c4f906b63d59bf9$var$memoize;

});



parcelRegister("bt3Gi", function(module, exports) {

$parcel$export(module.exports, "useSVGProps", function () { return $8595422c43a6b86e$export$84309c4f53cb1bd5; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $7hlMA = parcelRequire("7hlMA");

var $ggwHU = parcelRequire("ggwHU");

var $bc2UV = parcelRequire("bc2UV");
function $8595422c43a6b86e$export$84309c4f53cb1bd5(props, visualState) {
    var visualProps = (0, $4YNlq.useMemo)(function() {
        var state = (0, $bc2UV.createSvgRenderState)();
        (0, $ggwHU.buildSVGAttrs)(state, visualState, undefined, undefined, {
            enableHardwareAcceleration: false
        }, props.transformTemplate);
        return (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, state.attrs), {
            style: (0, $S3LFa.__assign)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        var rawStyles = {};
        (0, $7hlMA.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, rawStyles), visualProps.style);
    }
    return visualProps;
}

});
parcelRegister("ggwHU", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $bd7782f211832a5c$export$5475d24f125d7053; });

var $S3LFa = parcelRequire("S3LFa");

var $1avWS = parcelRequire("1avWS");

var $jIw44 = parcelRequire("jIw44");

var $9GGjF = parcelRequire("9GGjF");
/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $bd7782f211832a5c$export$5475d24f125d7053(state, _a, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
    var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, // This is object creation, which we try to avoid per-frame.
    latest = (0, $S3LFa.__rest)(_a, [
        "attrX",
        "attrY",
        "originX",
        "originY",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $1avWS.buildHTMLStyles)(state, latest, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin);
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style, dimensions = state.dimensions, totalPathLength = state.totalPathLength;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $jIw44.calcSVGTransformOrigin)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Treat x/y not as shortcuts but as actual attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    // Build SVG path if one has been measured
    if (totalPathLength !== undefined && pathLength !== undefined) (0, $9GGjF.buildSVGPath)(attrs, totalPathLength, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("jIw44", function(module, exports) {

$parcel$export(module.exports, "calcSVGTransformOrigin", function () { return $e5aaffc5a2ac3ab2$export$d4fbcfc8e5472155; });

var $avwtz = parcelRequire("avwtz");
function $e5aaffc5a2ac3ab2$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $avwtz.px).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $e5aaffc5a2ac3ab2$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    var pxOriginX = $e5aaffc5a2ac3ab2$var$calcOrigin(originX, dimensions.x, dimensions.width);
    var pxOriginY = $e5aaffc5a2ac3ab2$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return pxOriginX + " " + pxOriginY;
}

});

parcelRegister("9GGjF", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $70d8dc7172ac9cab$export$311b43f666da1d82; });

var $avwtz = parcelRequire("avwtz");
// Convert a progress 0-1 to a pixels value based on the provided length
var $70d8dc7172ac9cab$var$progressToPixels = function(progress, length) {
    return (0, $avwtz.px).transform(progress * length);
};
var $70d8dc7172ac9cab$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $70d8dc7172ac9cab$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $70d8dc7172ac9cab$export$311b43f666da1d82(attrs, totalLength, length, spacing, offset, useDashCase) {
    if (spacing === void 0) spacing = 1;
    if (offset === void 0) offset = 0;
    if (useDashCase === void 0) useDashCase = true;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $70d8dc7172ac9cab$var$dashKeys : $70d8dc7172ac9cab$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = $70d8dc7172ac9cab$var$progressToPixels(-offset, totalLength);
    // Build the dash array
    var pathLength = $70d8dc7172ac9cab$var$progressToPixels(length, totalLength);
    var pathSpacing = $70d8dc7172ac9cab$var$progressToPixels(spacing, totalLength);
    attrs[keys.array] = pathLength + " " + pathSpacing;
}

});


parcelRegister("bc2UV", function(module, exports) {

$parcel$export(module.exports, "createSvgRenderState", function () { return $826313f769b9d5f7$export$41be8b43e1c4d4f9; });

var $S3LFa = parcelRequire("S3LFa");

var $klr2Q = parcelRequire("klr2Q");
var $826313f769b9d5f7$export$41be8b43e1c4d4f9 = function() {
    return (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, (0, $klr2Q.createHtmlRenderState)()), {
        attrs: {}
    });
};

});



parcelRegister("4bvWv", function(module, exports) {

$parcel$export(module.exports, "svgMotionConfig", function () { return $30c0f7a46ca5b07d$export$44dabd3fae512e85; });

var $bWfLo = parcelRequire("bWfLo");

var $2VBTm = parcelRequire("2VBTm");

var $2x4zQ = parcelRequire("2x4zQ");

var $bc2UV = parcelRequire("bc2UV");

var $ggwHU = parcelRequire("ggwHU");
var $30c0f7a46ca5b07d$export$44dabd3fae512e85 = {
    useVisualState: (0, $2x4zQ.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $2VBTm.scrapeMotionValuesFromProps),
        createRenderState: (0, $bc2UV.createSvgRenderState),
        onMount: function(props, instance, _a) {
            var renderState = _a.renderState, latestValues = _a.latestValues;
            try {
                renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
            } catch (e) {
                // Most likely trying to measure an unrendered element under Firefox
                renderState.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };
            }
            if ($30c0f7a46ca5b07d$var$isPath(instance)) renderState.totalPathLength = instance.getTotalLength();
            (0, $ggwHU.buildSVGAttrs)(renderState, latestValues, undefined, undefined, {
                enableHardwareAcceleration: false
            }, props.transformTemplate);
            // TODO: Replace with direct assignment
            (0, $bWfLo.renderSVG)(instance, renderState);
        }
    })
};
function $30c0f7a46ca5b07d$var$isPath(element) {
    return element.tagName === "path";
}

});
parcelRegister("bWfLo", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $8b1156cb8a2ff04e$export$c5f8399d19a7394b; });

var $8hfRg = parcelRequire("8hfRg");

var $hz79B = parcelRequire("hz79B");

var $jGXUL = parcelRequire("jGXUL");
function $8b1156cb8a2ff04e$export$c5f8399d19a7394b(element, renderState) {
    (0, $hz79B.renderHTML)(element, renderState);
    for(var key in renderState.attrs)element.setAttribute(!(0, $jGXUL.camelCaseAttributes).has(key) ? (0, $8hfRg.camelToDash)(key) : key, renderState.attrs[key]);
}

});
parcelRegister("8hfRg", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $606c365e2b3b25cb$export$9fd24a634729c672; });
var $606c365e2b3b25cb$var$CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var $606c365e2b3b25cb$var$REPLACE_TEMPLATE = "$1-$2";
/**
 * Convert camelCase to dash-case properties.
 */ var $606c365e2b3b25cb$export$9fd24a634729c672 = function(str) {
    return str.replace($606c365e2b3b25cb$var$CAMEL_CASE_PATTERN, $606c365e2b3b25cb$var$REPLACE_TEMPLATE).toLowerCase();
};

});

parcelRegister("hz79B", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $cc9b412a1c306fbd$export$1a32bf6229c258c0; });
function $cc9b412a1c306fbd$export$1a32bf6229c258c0(element, _a) {
    var style = _a.style, vars = _a.vars;
    // Directly assign style into the Element's style prop. In tests Object.assign is the
    // fastest way to assign styles.
    Object.assign(element.style, style);
    // Loop over any CSS variables and assign those.
    for(var key in vars)element.style.setProperty(key, vars[key]);
}

});

parcelRegister("jGXUL", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $e5606a581b088a00$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ var $e5606a581b088a00$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform"
]);

});


parcelRegister("2VBTm", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $221e4c2af89a549b$export$16da615486abaa45; });

var $67Lja = parcelRequire("67Lja");

var $8ntgB = parcelRequire("8ntgB");
function $221e4c2af89a549b$export$16da615486abaa45(props) {
    var newValues = (0, $8ntgB.scrapeMotionValuesFromProps)(props);
    for(var key in props)if ((0, $67Lja.isMotionValue)(props[key])) {
        var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});
parcelRegister("8ntgB", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $61972c7c5ef2d0c9$export$16da615486abaa45; });

var $4ZcxX = parcelRequire("4ZcxX");

var $67Lja = parcelRequire("67Lja");
function $61972c7c5ef2d0c9$export$16da615486abaa45(props) {
    var style = props.style;
    var newValues = {};
    for(var key in style)if ((0, $67Lja.isMotionValue)(style[key]) || (0, $4ZcxX.isForcedMotionValue)(key, props)) newValues[key] = style[key];
    return newValues;
}

});


parcelRegister("2x4zQ", function(module, exports) {

$parcel$export(module.exports, "makeUseVisualState", function () { return $1d8236c2845f56cf$export$e91e107bc6d03a8e; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $bP8lr = parcelRequire("bP8lr");

var $eVG38 = parcelRequire("eVG38");

var $7NspE = parcelRequire("7NspE");

var $7nP7f = parcelRequire("7nP7f");

var $fX9W5 = parcelRequire("fX9W5");

var $icO7T = parcelRequire("icO7T");
function $1d8236c2845f56cf$var$makeState(_a, props, context, presenceContext) {
    var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
    var state = {
        latestValues: $1d8236c2845f56cf$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onMount) state.mount = function(instance) {
        return onMount(props, instance, state);
    };
    return state;
}
var $1d8236c2845f56cf$export$e91e107bc6d03a8e = function(config) {
    return function(props, isStatic) {
        var context = (0, $4YNlq.useContext)((0, $icO7T.MotionContext));
        var presenceContext = (0, $4YNlq.useContext)((0, $eVG38.PresenceContext));
        return isStatic ? $1d8236c2845f56cf$var$makeState(config, props, context, presenceContext) : (0, $7nP7f.useConstant)(function() {
            return $1d8236c2845f56cf$var$makeState(config, props, context, presenceContext);
        });
    };
};
function $1d8236c2845f56cf$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    var values = {};
    var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
    var motionValues = scrapeMotionValues(props);
    for(var key in motionValues)values[key] = (0, $fX9W5.resolveMotionValue)(motionValues[key]);
    var initial = props.initial, animate = props.animate;
    var isControllingVariants = (0, $7NspE.checkIfControllingVariants)(props);
    var isVariantNode = (0, $7NspE.checkIfVariantNode)(props);
    if (context && isVariantNode && !isControllingVariants && props.inherit !== false) {
        initial !== null && initial !== void 0 ? initial : initial = context.initial;
        animate !== null && animate !== void 0 ? animate : animate = context.animate;
    }
    var variantToSet = blockInitialAnimation || initial === false ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $bP8lr.isAnimationControls)(variantToSet)) {
        var list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        list.forEach(function(definition) {
            var resolved = (0, $7NspE.resolveVariantFromProps)(props, definition);
            if (!resolved) return;
            var transitionEnd = resolved.transitionEnd;
            resolved.transition;
            var target = (0, $S3LFa.__rest)(resolved, [
                "transitionEnd",
                "transition"
            ]);
            for(var key in target)values[key] = target[key];
            for(var key in transitionEnd)values[key] = transitionEnd[key];
        });
    }
    return values;
}

});
parcelRegister("bP8lr", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $89baee3bb557de43$export$aa71198ceeaf53ce; });
function $89baee3bb557de43$export$aa71198ceeaf53ce(v) {
    return typeof v === "object" && typeof v.start === "function";
}

});

parcelRegister("fX9W5", function(module, exports) {

$parcel$export(module.exports, "resolveMotionValue", function () { return $b9d412be65c79565$export$fcc2206ecb6d74b; });

var $cpd6c = parcelRequire("cpd6c");

var $67Lja = parcelRequire("67Lja");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 *
 * @internal
 */ function $b9d412be65c79565$export$fcc2206ecb6d74b(value) {
    var unwrappedValue = (0, $67Lja.isMotionValue)(value) ? value.get() : value;
    return (0, $cpd6c.isCustomValue)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}

});
parcelRegister("cpd6c", function(module, exports) {

$parcel$export(module.exports, "isCustomValue", function () { return $9081fb017fe4f7d2$export$2f308ad9864b3ac9; });
$parcel$export(module.exports, "resolveFinalValueInKeyframes", function () { return $9081fb017fe4f7d2$export$5485128c47bd48bb; });

var $ftmeo = parcelRequire("ftmeo");
var $9081fb017fe4f7d2$export$2f308ad9864b3ac9 = function(v) {
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
var $9081fb017fe4f7d2$export$5485128c47bd48bb = function(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $ftmeo.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
};

});
parcelRegister("ftmeo", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $b43acf1736f0e7a5$export$9153ad4c4999f4a0; });
var $b43acf1736f0e7a5$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};

});





parcelRegister("hSMCg", function(module, exports) {

$parcel$export(module.exports, "htmlMotionConfig", function () { return $d04d30f5c072cb24$export$e13ea21d87ea57c8; });

var $2x4zQ = parcelRequire("2x4zQ");

var $8ntgB = parcelRequire("8ntgB");

var $klr2Q = parcelRequire("klr2Q");
var $d04d30f5c072cb24$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $2x4zQ.makeUseVisualState)({
        scrapeMotionValuesFromProps: (0, $8ntgB.scrapeMotionValuesFromProps),
        createRenderState: (0, $klr2Q.createHtmlRenderState)
    })
};

});


parcelRegister("39TFx", function(module, exports) {

$parcel$export(module.exports, "gestureAnimations", function () { return $24cd650d714af4ac$export$e5b72898e5a201f1; });

var $axkbH = parcelRequire("axkbH");

var $loTP7 = parcelRequire("loTP7");

var $9n89c = parcelRequire("9n89c");

var $dP7E6 = parcelRequire("dP7E6");
var $24cd650d714af4ac$export$e5b72898e5a201f1 = {
    tap: (0, $dP7E6.makeRenderlessComponent)((0, $9n89c.useTapGesture)),
    focus: (0, $dP7E6.makeRenderlessComponent)((0, $axkbH.useFocusGesture)),
    hover: (0, $dP7E6.makeRenderlessComponent)((0, $loTP7.useHoverGesture))
};

});
parcelRegister("axkbH", function(module, exports) {

$parcel$export(module.exports, "useFocusGesture", function () { return $7abca550cce9ca2d$export$cac52d7cca250a66; });

var $9qF7e = parcelRequire("9qF7e");

var $kGUeI = parcelRequire("kGUeI");
/**
 *
 * @param props
 * @param ref
 * @internal
 */ function $7abca550cce9ca2d$export$cac52d7cca250a66(_a) {
    var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
    var onFocus = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $9qF7e.AnimationType).Focus, true);
    };
    var onBlur = function() {
        var _a;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $9qF7e.AnimationType).Focus, false);
    };
    (0, $kGUeI.useDomEvent)(visualElement, "focus", whileFocus ? onFocus : undefined);
    (0, $kGUeI.useDomEvent)(visualElement, "blur", whileFocus ? onBlur : undefined);
}

});
parcelRegister("9qF7e", function(module, exports) {

$parcel$export(module.exports, "AnimationType", function () { return $6dd66f7a5a830634$export$2deb71ebd3734d23; });
var $6dd66f7a5a830634$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["Animate"] = "animate";
    AnimationType["Hover"] = "whileHover";
    AnimationType["Tap"] = "whileTap";
    AnimationType["Drag"] = "whileDrag";
    AnimationType["Focus"] = "whileFocus";
    AnimationType["Exit"] = "exit";
})($6dd66f7a5a830634$export$2deb71ebd3734d23 || ($6dd66f7a5a830634$export$2deb71ebd3734d23 = {}));

});

parcelRegister("kGUeI", function(module, exports) {

$parcel$export(module.exports, "addDomEvent", function () { return $f1035a41671e56c8$export$b1d829ddf82884aa; });
$parcel$export(module.exports, "useDomEvent", function () { return $f1035a41671e56c8$export$c1052189363cb2e0; });

var $4YNlq = parcelRequire("4YNlq");
function $f1035a41671e56c8$export$b1d829ddf82884aa(target, eventName, handler, options) {
    target.addEventListener(eventName, handler, options);
    return function() {
        return target.removeEventListener(eventName, handler, options);
    };
}
/**
 * Attaches an event listener directly to the provided DOM element.
 *
 * Bypassing React's event system can be desirable, for instance when attaching non-passive
 * event handlers.
 *
 * ```jsx
 * const ref = useRef(null)
 *
 * useDomEvent(ref, 'wheel', onWheel, { passive: false })
 *
 * return <div ref={ref} />
 * ```
 *
 * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
 * @param eventName - Name of the event you want listen for.
 * @param handler - Function to fire when receiving the event.
 * @param options - Options to pass to `Event.addEventListener`.
 *
 * @public
 */ function $f1035a41671e56c8$export$c1052189363cb2e0(ref, eventName, handler, options) {
    (0, $4YNlq.useEffect)(function() {
        var element = ref.current;
        if (handler && element) return $f1035a41671e56c8$export$b1d829ddf82884aa(element, eventName, handler, options);
    }, [
        ref,
        eventName,
        handler,
        options
    ]);
}

});


parcelRegister("loTP7", function(module, exports) {

$parcel$export(module.exports, "useHoverGesture", function () { return $f94724406b6154fb$export$dea06860711b7ebc; });

var $hQ42D = parcelRequire("hQ42D");

var $9qF7e = parcelRequire("9qF7e");

var $3Nx2Z = parcelRequire("3Nx2Z");

var $a9iKN = parcelRequire("a9iKN");
function $f94724406b6154fb$var$createHoverEvent(visualElement, isActive, callback) {
    return function(event, info) {
        var _a;
        if (!(0, $hQ42D.isMouseEvent)(event) || (0, $a9iKN.isDragActive)()) return;
        callback === null || callback === void 0 || callback(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $9qF7e.AnimationType).Hover, isActive);
    };
}
function $f94724406b6154fb$export$dea06860711b7ebc(_a) {
    var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
    (0, $3Nx2Z.usePointerEvent)(visualElement, "pointerenter", onHoverStart || whileHover ? $f94724406b6154fb$var$createHoverEvent(visualElement, true, onHoverStart) : undefined);
    (0, $3Nx2Z.usePointerEvent)(visualElement, "pointerleave", onHoverEnd || whileHover ? $f94724406b6154fb$var$createHoverEvent(visualElement, false, onHoverEnd) : undefined);
}

});
parcelRegister("hQ42D", function(module, exports) {

$parcel$export(module.exports, "isMouseEvent", function () { return $cfca6d87c064e75a$export$764db16956f554f8; });
$parcel$export(module.exports, "isTouchEvent", function () { return $cfca6d87c064e75a$export$c4dfce035d43d1e0; });
function $cfca6d87c064e75a$export$764db16956f554f8(event) {
    // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
    if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) return !!(event.pointerType === "mouse");
    return event instanceof MouseEvent;
}
function $cfca6d87c064e75a$export$c4dfce035d43d1e0(event) {
    var hasTouches = !!event.touches;
    return hasTouches;
}

});

parcelRegister("3Nx2Z", function(module, exports) {

$parcel$export(module.exports, "addPointerEvent", function () { return $2c3f952b3efd4c13$export$fcff2e64e6676b81; });
$parcel$export(module.exports, "usePointerEvent", function () { return $2c3f952b3efd4c13$export$734d04395f5243cd; });

var $kGUeI = parcelRequire("kGUeI");

var $3ClZV = parcelRequire("3ClZV");

var $5HEKK = parcelRequire("5HEKK");
var $2c3f952b3efd4c13$var$mouseEventNames = {
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointercancel: "mousecancel",
    pointerover: "mouseover",
    pointerout: "mouseout",
    pointerenter: "mouseenter",
    pointerleave: "mouseleave"
};
var $2c3f952b3efd4c13$var$touchEventNames = {
    pointerdown: "touchstart",
    pointermove: "touchmove",
    pointerup: "touchend",
    pointercancel: "touchcancel"
};
function $2c3f952b3efd4c13$var$getPointerEventName(name) {
    if ((0, $5HEKK.supportsPointerEvents)()) return name;
    else if ((0, $5HEKK.supportsTouchEvents)()) return $2c3f952b3efd4c13$var$touchEventNames[name];
    else if ((0, $5HEKK.supportsMouseEvents)()) return $2c3f952b3efd4c13$var$mouseEventNames[name];
    return name;
}
function $2c3f952b3efd4c13$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $kGUeI.addDomEvent)(target, $2c3f952b3efd4c13$var$getPointerEventName(eventName), (0, $3ClZV.wrapHandler)(handler, eventName === "pointerdown"), options);
}
function $2c3f952b3efd4c13$export$734d04395f5243cd(ref, eventName, handler, options) {
    return (0, $kGUeI.useDomEvent)(ref, $2c3f952b3efd4c13$var$getPointerEventName(eventName), handler && (0, $3ClZV.wrapHandler)(handler, eventName === "pointerdown"), options);
}

});
parcelRegister("3ClZV", function(module, exports) {

$parcel$export(module.exports, "extractEventInfo", function () { return $2a25fbfead4bfbfd$export$12f84bb882d06e1a; });
$parcel$export(module.exports, "getViewportPointFromEvent", function () { return $2a25fbfead4bfbfd$export$750e59ed656e0503; });
$parcel$export(module.exports, "wrapHandler", function () { return $2a25fbfead4bfbfd$export$f4437ba81469b709; });

var $hQ42D = parcelRequire("hQ42D");
/**
 * Filters out events not attached to the primary pointer (currently left mouse button)
 * @param eventHandler
 */ function $2a25fbfead4bfbfd$var$filterPrimaryPointer(eventHandler) {
    return function(event) {
        var isMouseEvent = event instanceof MouseEvent;
        var isPrimaryPointer = !isMouseEvent || isMouseEvent && event.button === 0;
        if (isPrimaryPointer) eventHandler(event);
    };
}
var $2a25fbfead4bfbfd$var$defaultPagePoint = {
    pageX: 0,
    pageY: 0
};
function $2a25fbfead4bfbfd$var$pointFromTouch(e, pointType) {
    if (pointType === void 0) pointType = "page";
    var primaryTouch = e.touches[0] || e.changedTouches[0];
    var point = primaryTouch || $2a25fbfead4bfbfd$var$defaultPagePoint;
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $2a25fbfead4bfbfd$var$pointFromMouse(point, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        x: point[pointType + "X"],
        y: point[pointType + "Y"]
    };
}
function $2a25fbfead4bfbfd$export$12f84bb882d06e1a(event, pointType) {
    if (pointType === void 0) pointType = "page";
    return {
        point: (0, $hQ42D.isTouchEvent)(event) ? $2a25fbfead4bfbfd$var$pointFromTouch(event, pointType) : $2a25fbfead4bfbfd$var$pointFromMouse(event, pointType)
    };
}
function $2a25fbfead4bfbfd$export$750e59ed656e0503(event) {
    return $2a25fbfead4bfbfd$export$12f84bb882d06e1a(event, "client");
}
var $2a25fbfead4bfbfd$export$f4437ba81469b709 = function(handler, shouldFilterPrimaryPointer) {
    if (shouldFilterPrimaryPointer === void 0) shouldFilterPrimaryPointer = false;
    var listener = function(event) {
        return handler(event, $2a25fbfead4bfbfd$export$12f84bb882d06e1a(event));
    };
    return shouldFilterPrimaryPointer ? $2a25fbfead4bfbfd$var$filterPrimaryPointer(listener) : listener;
};

});

parcelRegister("5HEKK", function(module, exports) {

$parcel$export(module.exports, "supportsPointerEvents", function () { return $4270949318afa314$export$ed662207763ba653; });
$parcel$export(module.exports, "supportsTouchEvents", function () { return $4270949318afa314$export$58e9cbc5718eb8c2; });
$parcel$export(module.exports, "supportsMouseEvents", function () { return $4270949318afa314$export$1a3879af679d3ede; });

var $47zAH = parcelRequire("47zAH");
// We check for event support via functions in case they've been mocked by a testing suite.
var $4270949318afa314$export$ed662207763ba653 = function() {
    return (0, $47zAH.isBrowser) && window.onpointerdown === null;
};
var $4270949318afa314$export$58e9cbc5718eb8c2 = function() {
    return (0, $47zAH.isBrowser) && window.ontouchstart === null;
};
var $4270949318afa314$export$1a3879af679d3ede = function() {
    return (0, $47zAH.isBrowser) && window.onmousedown === null;
};

});


parcelRegister("a9iKN", function(module, exports) {

$parcel$export(module.exports, "getGlobalLock", function () { return $76394ac7fc0e2fec$export$2b7959ed03c1a3fe; });
$parcel$export(module.exports, "isDragActive", function () { return $76394ac7fc0e2fec$export$1b3dd616664938e4; });
function $76394ac7fc0e2fec$export$518c5fc2dcb7974b(name) {
    var lock = null;
    return function() {
        var openLock = function() {
            lock = null;
        };
        if (lock === null) {
            lock = name;
            return openLock;
        }
        return false;
    };
}
var $76394ac7fc0e2fec$var$globalHorizontalLock = $76394ac7fc0e2fec$export$518c5fc2dcb7974b("dragHorizontal");
var $76394ac7fc0e2fec$var$globalVerticalLock = $76394ac7fc0e2fec$export$518c5fc2dcb7974b("dragVertical");
function $76394ac7fc0e2fec$export$2b7959ed03c1a3fe(drag) {
    var lock = false;
    if (drag === "y") lock = $76394ac7fc0e2fec$var$globalVerticalLock();
    else if (drag === "x") lock = $76394ac7fc0e2fec$var$globalHorizontalLock();
    else {
        var openHorizontal_1 = $76394ac7fc0e2fec$var$globalHorizontalLock();
        var openVertical_1 = $76394ac7fc0e2fec$var$globalVerticalLock();
        if (openHorizontal_1 && openVertical_1) lock = function() {
            openHorizontal_1();
            openVertical_1();
        };
        else {
            // Release the locks because we don't use them
            if (openHorizontal_1) openHorizontal_1();
            if (openVertical_1) openVertical_1();
        }
    }
    return lock;
}
function $76394ac7fc0e2fec$export$1b3dd616664938e4() {
    // Check the gesture lock - if we get it, it means no drag gesture is active
    // and we can safely fire the tap gesture.
    var openGestureLock = $76394ac7fc0e2fec$export$2b7959ed03c1a3fe(true);
    if (!openGestureLock) return true;
    openGestureLock();
    return false;
}

});


parcelRegister("9n89c", function(module, exports) {

$parcel$export(module.exports, "useTapGesture", function () { return $6d2c94ee2211c909$export$16dee6ef8c34532; });

var $4YNlq = parcelRequire("4YNlq");

var $8nrA5 = parcelRequire("8nrA5");

var $3Nx2Z = parcelRequire("3Nx2Z");

var $g7I5q = parcelRequire("g7I5q");

var $eiL8o = parcelRequire("eiL8o");

var $9qF7e = parcelRequire("9qF7e");

var $a9iKN = parcelRequire("a9iKN");
/**
 * @param handlers -
 * @internal
 */ function $6d2c94ee2211c909$export$16dee6ef8c34532(_a) {
    var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
    var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
    var isPressing = (0, $4YNlq.useRef)(false);
    var cancelPointerEndListeners = (0, $4YNlq.useRef)(null);
    function removePointerEndListener() {
        var _a;
        (_a = cancelPointerEndListeners.current) === null || _a === void 0 || _a.call(cancelPointerEndListeners);
        cancelPointerEndListeners.current = null;
    }
    function checkPointerEnd() {
        var _a;
        removePointerEndListener();
        isPressing.current = false;
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $9qF7e.AnimationType).Tap, false);
        return !(0, $a9iKN.isDragActive)();
    }
    function onPointerUp(event, info) {
        if (!checkPointerEnd()) return;
        /**
         * We only count this as a tap gesture if the event.target is the same
         * as, or a child of, this component's element
         */ !(0, $8nrA5.isNodeOrChild)(visualElement.getInstance(), event.target) ? onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info) : onTap === null || onTap === void 0 || onTap(event, info);
    }
    function onPointerCancel(event, info) {
        if (!checkPointerEnd()) return;
        onTapCancel === null || onTapCancel === void 0 || onTapCancel(event, info);
    }
    function onPointerDown(event, info) {
        var _a;
        removePointerEndListener();
        if (isPressing.current) return;
        isPressing.current = true;
        cancelPointerEndListeners.current = (0, $eiL8o.pipe)((0, $3Nx2Z.addPointerEvent)(window, "pointerup", onPointerUp), (0, $3Nx2Z.addPointerEvent)(window, "pointercancel", onPointerCancel));
        onTapStart === null || onTapStart === void 0 || onTapStart(event, info);
        (_a = visualElement.animationState) === null || _a === void 0 || _a.setActive((0, $9qF7e.AnimationType).Tap, true);
    }
    (0, $3Nx2Z.usePointerEvent)(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
    (0, $g7I5q.useUnmountEffect)(removePointerEndListener);
}

});
parcelRegister("8nrA5", function(module, exports) {

$parcel$export(module.exports, "isNodeOrChild", function () { return $6195ddbb7732887b$export$e841ada32ff745b; });
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var $6195ddbb7732887b$export$e841ada32ff745b = function(parent, child) {
    if (!child) return false;
    else if (parent === child) return true;
    else return $6195ddbb7732887b$export$e841ada32ff745b(parent, child.parentElement);
};

});

parcelRegister("eiL8o", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $a6974f0bf7e5027b$export$a4627e546088548d; });
var $a6974f0bf7e5027b$var$combineFunctions = function(a, b) {
    return function(v) {
        return b(a(v));
    };
};
var $a6974f0bf7e5027b$export$a4627e546088548d = function() {
    var transformers = [];
    for(var _i = 0; _i < arguments.length; _i++)transformers[_i] = arguments[_i];
    return transformers.reduce($a6974f0bf7e5027b$var$combineFunctions);
};

});


parcelRegister("dP7E6", function(module, exports) {

$parcel$export(module.exports, "makeRenderlessComponent", function () { return $a105f815b589c968$export$46d1d6d046f826e4; });
var $a105f815b589c968$export$46d1d6d046f826e4 = function(hook) {
    return function(props) {
        hook(props);
        return null;
    };
};

});


parcelRegister("9hY3G", function(module, exports) {

$parcel$export(module.exports, "animations", function () { return $6c3449f1660c0c0f$export$7f9953c70dacfd7f; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $bP8lr = parcelRequire("bP8lr");

var $ltGQn = parcelRequire("ltGQn");

var $eVG38 = parcelRequire("eVG38");

var $es7Ew = parcelRequire("es7Ew");

var $9qF7e = parcelRequire("9qF7e");

var $dP7E6 = parcelRequire("dP7E6");
var $6c3449f1660c0c0f$export$7f9953c70dacfd7f = {
    animation: (0, $dP7E6.makeRenderlessComponent)(function(_a) {
        var visualElement = _a.visualElement, animate = _a.animate;
        /**
         * We dynamically generate the AnimationState manager as it contains a reference
         * to the underlying animation library. We only want to load that if we load this,
         * so people can optionally code split it out using the `m` component.
         */ visualElement.animationState || (visualElement.animationState = (0, $es7Ew.createAnimationState)(visualElement));
        /**
         * Subscribe any provided AnimationControls to the component's VisualElement
         */ if ((0, $bP8lr.isAnimationControls)(animate)) (0, $4YNlq.useEffect)(function() {
            return animate.subscribe(visualElement);
        }, [
            animate
        ]);
    }),
    exit: (0, $dP7E6.makeRenderlessComponent)(function(props) {
        var custom = props.custom, visualElement = props.visualElement;
        var _a = (0, $S3LFa.__read)((0, $ltGQn.usePresence)(), 2), isPresent = _a[0], onExitComplete = _a[1];
        var presenceContext = (0, $4YNlq.useContext)((0, $eVG38.PresenceContext));
        (0, $4YNlq.useEffect)(function() {
            var _a, _b;
            var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive((0, $9qF7e.AnimationType).Exit, !isPresent, {
                custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom
            });
            !isPresent && (animation === null || animation === void 0 || animation.then(onExitComplete));
        }, [
            isPresent
        ]);
    })
};

});
parcelRegister("es7Ew", function(module, exports) {

$parcel$export(module.exports, "variantPriorityOrder", function () { return $a8599dd9141c3a3b$export$16e45afcc206d3a8; });
$parcel$export(module.exports, "createAnimationState", function () { return $a8599dd9141c3a3b$export$bb53502b7a672aa8; });

var $S3LFa = parcelRequire("S3LFa");

var $bP8lr = parcelRequire("bP8lr");

var $ftmeo = parcelRequire("ftmeo");

var $3cRUD = parcelRequire("3cRUD");

var $2dzub = parcelRequire("2dzub");

var $9qF7e = parcelRequire("9qF7e");

var $7NspE = parcelRequire("7NspE");
var $a8599dd9141c3a3b$export$16e45afcc206d3a8 = [
    (0, $9qF7e.AnimationType).Animate,
    (0, $9qF7e.AnimationType).Hover,
    (0, $9qF7e.AnimationType).Tap,
    (0, $9qF7e.AnimationType).Drag,
    (0, $9qF7e.AnimationType).Focus,
    (0, $9qF7e.AnimationType).Exit
];
var $a8599dd9141c3a3b$var$reversePriorityOrder = (0, $S3LFa.__spreadArray)([], (0, $S3LFa.__read)($a8599dd9141c3a3b$export$16e45afcc206d3a8)).reverse();
var $a8599dd9141c3a3b$var$numAnimationTypes = $a8599dd9141c3a3b$export$16e45afcc206d3a8.length;
function $a8599dd9141c3a3b$var$animateList(visualElement) {
    return function(animations) {
        return Promise.all(animations.map(function(_a) {
            var animation = _a.animation, options = _a.options;
            return (0, $2dzub.animateVisualElement)(visualElement, animation, options);
        }));
    };
}
function $a8599dd9141c3a3b$export$bb53502b7a672aa8(visualElement) {
    var animate = $a8599dd9141c3a3b$var$animateList(visualElement);
    var state = $a8599dd9141c3a3b$var$createState();
    var allAnimatedKeys = {};
    var isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ var buildResolvedTypeValues = function(acc, definition) {
        var resolved = (0, $7NspE.resolveVariant)(visualElement, definition);
        if (resolved) {
            resolved.transition;
            var transitionEnd = resolved.transitionEnd, target = (0, $S3LFa.__rest)(resolved, [
                "transition",
                "transitionEnd"
            ]);
            acc = (0, $S3LFa.__assign)((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, acc), target), transitionEnd);
        }
        return acc;
    };
    function isAnimated(key) {
        return allAnimatedKeys[key] !== undefined;
    }
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(options, changedActiveType) {
        var _a;
        var props = visualElement.getProps();
        var context = visualElement.getVariantContext(true) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ var animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ var removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ var encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ var removedVariantIndex = Infinity;
        var _loop_1 = function(i) {
            var type = $a8599dd9141c3a3b$var$reversePriorityOrder[i];
            var typeState = state[type];
            var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
            var propIsVariant = (0, $7NspE.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ var activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $S3LFa.__assign)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $bP8lr.isAnimationControls)(prop) || typeof prop === "boolean") return "continue";
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ var shouldAnimateType = $a8599dd9141c3a3b$export$b9d9a225005a5327(typeState.prevProp, prop) || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ var definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
            var allKeys = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, prevResolvedValues), resolvedValues);
            var markToAnimate = function(key) {
                shouldAnimateType = true;
                removedKeys.delete(key);
                typeState.needsAnimating[key] = true;
            };
            for(var key in allKeys){
                var next = resolvedValues[key];
                var prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ if (next !== prev) {
                    /**
                     * If both values are keyframes, we need to shallow compare them to
                     * detect whether any value has changed. If it has, we animate it.
                     */ if ((0, $ftmeo.isKeyframesTarget)(next) && (0, $ftmeo.isKeyframesTarget)(prev)) {
                        if (!(0, $3cRUD.shallowCompare)(next, prev)) markToAnimate(key);
                        else /**
                             * If it hasn't changed, we want to ensure it doesn't animate by
                             * adding it to the list of protected keys.
                             */ typeState.protectedKeys[key] = true;
                    } else if (next !== undefined) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, encounteredKeys), resolvedValues);
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to hard-block animations
             * TODO: Test as this should probably still handle animations triggered
             * by removed values?
             */ if (shouldAnimateType && !isInherited) animations.push.apply(animations, (0, $S3LFa.__spreadArray)([], (0, $S3LFa.__read)(definitionList.map(function(animation) {
                return {
                    animation: animation,
                    options: (0, $S3LFa.__assign)({
                        type: type
                    }, options)
                };
            }))));
        };
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(var i = 0; i < $a8599dd9141c3a3b$var$numAnimationTypes; i++)_loop_1(i);
        allAnimatedKeys = (0, $S3LFa.__assign)({}, encounteredKeys);
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            var fallbackAnimation_1 = {};
            removedKeys.forEach(function(key) {
                var fallbackTarget = visualElement.getBaseTarget(key);
                if (fallbackTarget !== undefined) fallbackAnimation_1[key] = fallbackTarget;
            });
            animations.push({
                animation: fallbackAnimation_1
            });
        }
        var shouldAnimate = Boolean(animations.length);
        if (isInitialRender && props.initial === false && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive, options) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        return animateChanges(options, type);
    }
    return {
        isAnimated: isAnimated,
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: function() {
            return state;
        }
    };
}
function $a8599dd9141c3a3b$export$b9d9a225005a5327(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if ((0, $7NspE.isVariantLabels)(next)) return !(0, $3cRUD.shallowCompare)(next, prev);
    return false;
}
function $a8599dd9141c3a3b$var$createTypeState(isActive) {
    if (isActive === void 0) isActive = false;
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $a8599dd9141c3a3b$var$createState() {
    var _a;
    return _a = {}, _a[(0, $9qF7e.AnimationType).Animate] = $a8599dd9141c3a3b$var$createTypeState(true), _a[(0, $9qF7e.AnimationType).Hover] = $a8599dd9141c3a3b$var$createTypeState(), _a[(0, $9qF7e.AnimationType).Tap] = $a8599dd9141c3a3b$var$createTypeState(), _a[(0, $9qF7e.AnimationType).Drag] = $a8599dd9141c3a3b$var$createTypeState(), _a[(0, $9qF7e.AnimationType).Focus] = $a8599dd9141c3a3b$var$createTypeState(), _a[(0, $9qF7e.AnimationType).Exit] = $a8599dd9141c3a3b$var$createTypeState(), _a;
}

});
parcelRegister("3cRUD", function(module, exports) {

$parcel$export(module.exports, "shallowCompare", function () { return $255c4ff74e6f6a1a$export$90e866afbd6b9f1a; });
function $255c4ff74e6f6a1a$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    var prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(var i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

});

parcelRegister("2dzub", function(module, exports) {

$parcel$export(module.exports, "animateVisualElement", function () { return $19d8526f6c3a3b99$export$ff62cf473653f109; });

var $S3LFa = parcelRequire("S3LFa");

var $9OqCr = parcelRequire("9OqCr");

var $f2U56 = parcelRequire("f2U56");

var $7NspE = parcelRequire("7NspE");
/**
 * @internal
 */ function $19d8526f6c3a3b99$export$ff62cf473653f109(visualElement, definition, options) {
    if (options === void 0) options = {};
    visualElement.notifyAnimationStart();
    var animation;
    if (Array.isArray(definition)) {
        var animations = definition.map(function(variant) {
            return $19d8526f6c3a3b99$var$animateVariant(visualElement, variant, options);
        });
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = $19d8526f6c3a3b99$var$animateVariant(visualElement, definition, options);
    else {
        var resolvedDefinition = typeof definition === "function" ? (0, $7NspE.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = $19d8526f6c3a3b99$var$animateTarget(visualElement, resolvedDefinition, options);
    }
    return animation.then(function() {
        return visualElement.notifyAnimationComplete(definition);
    });
}
function $19d8526f6c3a3b99$var$animateVariant(visualElement, variant, options) {
    var _a;
    if (options === void 0) options = {};
    var resolved = (0, $7NspE.resolveVariant)(visualElement, variant, options.custom);
    var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getAnimation = resolved ? function() {
        return $19d8526f6c3a3b99$var$animateTarget(visualElement, resolved, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size) ? function(forwardDelay) {
        if (forwardDelay === void 0) forwardDelay = 0;
        var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
        return $19d8526f6c3a3b99$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : function() {
        return Promise.resolve();
    };
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ var when = transition.when;
    if (when) {
        var _c = (0, $S3LFa.__read)(when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ], 2), first = _c[0], last = _c[1];
        return first().then(last);
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
/**
 * @internal
 */ function $19d8526f6c3a3b99$var$animateTarget(visualElement, definition, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
    var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = (0, $S3LFa.__rest)(_e, [
        "transition",
        "transitionEnd"
    ]);
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
    for(var key in target){
        var value = visualElement.getValue(key);
        var valueTarget = target[key];
        if (!value || valueTarget === undefined || animationTypeState && $19d8526f6c3a3b99$var$shouldBlockAnimation(animationTypeState, key)) continue;
        var animation = (0, $9OqCr.startAnimation)(key, value, valueTarget, (0, $S3LFa.__assign)({
            delay: delay
        }, transition));
        animations.push(animation);
    }
    return Promise.all(animations).then(function() {
        transitionEnd && (0, $f2U56.setTarget)(visualElement, transitionEnd);
    });
}
function $19d8526f6c3a3b99$var$animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
    if (delayChildren === void 0) delayChildren = 0;
    if (staggerChildren === void 0) staggerChildren = 0;
    if (staggerDirection === void 0) staggerDirection = 1;
    var animations = [];
    var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    var generateStaggerDuration = staggerDirection === 1 ? function(i) {
        if (i === void 0) i = 0;
        return i * staggerChildren;
    } : function(i) {
        if (i === void 0) i = 0;
        return maxStaggerDuration - i * staggerChildren;
    };
    Array.from(visualElement.variantChildren).sort($19d8526f6c3a3b99$export$523a0bedf33ad781).forEach(function(child, i) {
        animations.push($19d8526f6c3a3b99$var$animateVariant(child, variant, (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, options), {
            delay: delayChildren + generateStaggerDuration(i)
        })).then(function() {
            return child.notifyAnimationComplete(variant);
        }));
    });
    return Promise.all(animations);
}
function $19d8526f6c3a3b99$export$3cc6f911ef1fd837(visualElement) {
    visualElement.forEachValue(function(value) {
        return value.stop();
    });
}
function $19d8526f6c3a3b99$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $19d8526f6c3a3b99$var$shouldBlockAnimation(_a, key) {
    var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}

});
parcelRegister("9OqCr", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $724d6e8acec2b4de$export$7c1391340308742e; });
$parcel$export(module.exports, "startAnimation", function () { return $724d6e8acec2b4de$export$592dbd515a49cf1b; });

var $S3LFa = parcelRequire("S3LFa");

var $aWAsx = parcelRequire("aWAsx");
var $2v7Ng = parcelRequire("2v7Ng");

var $id4XH = parcelRequire("id4XH");

var $4gesc = parcelRequire("4gesc");

var $GGpy3 = parcelRequire("GGpy3");

var $5cznx = parcelRequire("5cznx");

var $dnSYc = parcelRequire("dnSYc");

var $eaFQn = parcelRequire("eaFQn");
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $724d6e8acec2b4de$export$ca8e47dc8ed5a9d7(_a) {
    _a.when;
    _a.delay;
    _a.delayChildren;
    _a.staggerChildren;
    _a.staggerDirection;
    _a.repeat;
    _a.repeatType;
    _a.repeatDelay;
    _a.from;
    var transition = (0, $S3LFa.__rest)(_a, [
        "when",
        "delay",
        "delayChildren",
        "staggerChildren",
        "staggerDirection",
        "repeat",
        "repeatType",
        "repeatDelay",
        "from"
    ]);
    return !!Object.keys(transition).length;
}
var $724d6e8acec2b4de$var$legacyRepeatWarning = false;
/**
 * Convert Framer Motion's Transition type into Popmotion-compatible options.
 */ function $724d6e8acec2b4de$export$998eb6d72a6574db(_a) {
    var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = (0, $S3LFa.__rest)(_a, [
        "ease",
        "times",
        "yoyo",
        "flip",
        "loop"
    ]);
    var options = (0, $S3LFa.__assign)({}, transition);
    if (times) options["offset"] = times;
    /**
     * Convert any existing durations from seconds to milliseconds
     */ if (transition.duration) options["duration"] = (0, $id4XH.secondsToMilliseconds)(transition.duration);
    if (transition.repeatDelay) options.repeatDelay = (0, $id4XH.secondsToMilliseconds)(transition.repeatDelay);
    /**
     * Map easing names to Popmotion's easing functions
     */ if (ease) options["ease"] = (0, $4gesc.isEasingArray)(ease) ? ease.map((0, $4gesc.easingDefinitionToFunction)) : (0, $4gesc.easingDefinitionToFunction)(ease);
    /**
     * Support legacy transition API
     */ if (transition.type === "tween") options.type = "keyframes";
    /**
     * TODO: These options are officially removed from the API.
     */ if (yoyo || loop || flip) {
        (0, $dnSYc.warning)(!$724d6e8acec2b4de$var$legacyRepeatWarning, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options.");
        $724d6e8acec2b4de$var$legacyRepeatWarning = true;
        if (yoyo) options.repeatType = "reverse";
        else if (loop) options.repeatType = "loop";
        else if (flip) options.repeatType = "mirror";
        options.repeat = loop || yoyo || flip || transition.repeat;
    }
    /**
     * TODO: Popmotion 9 has the ability to automatically detect whether to use
     * a keyframes or spring animation, but does so by detecting velocity and other spring options.
     * It'd be good to introduce a similar thing here.
     */ if (transition.type !== "spring") options.type = "keyframes";
    return options;
}
/**
 * Get the delay for a value by checking Transition with decreasing specificity.
 */ function $724d6e8acec2b4de$export$b55a0e77aebddb70(transition, key) {
    var _a;
    var valueTransition = $724d6e8acec2b4de$export$7c1391340308742e(transition, key) || {};
    return (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : 0;
}
function $724d6e8acec2b4de$export$3d2f5b3e7004e0cf(options) {
    if (Array.isArray(options.to) && options.to[0] === null) {
        options.to = (0, $S3LFa.__spreadArray)([], (0, $S3LFa.__read)(options.to));
        options.to[0] = options.from;
    }
    return options;
}
function $724d6e8acec2b4de$export$9019a69adbea191(transition, options, key) {
    var _a;
    if (Array.isArray(options.to)) (_a = transition.duration) !== null && _a !== void 0 ? _a : transition.duration = 0.8;
    $724d6e8acec2b4de$export$3d2f5b3e7004e0cf(options);
    /**
     * Get a default transition if none is determined to be defined.
     */ if (!$724d6e8acec2b4de$export$ca8e47dc8ed5a9d7(transition)) transition = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, transition), (0, $5cznx.getDefaultTransition)(key, options.to));
    return (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, options), $724d6e8acec2b4de$export$998eb6d72a6574db(transition));
}
/**
 *
 */ function $724d6e8acec2b4de$var$getAnimation(key, value, target, transition, onComplete) {
    var _a;
    var valueTransition = $724d6e8acec2b4de$export$7c1391340308742e(transition, key);
    var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
    var isTargetAnimatable = (0, $GGpy3.isAnimatable)(key, target);
    if (origin === "none" && isTargetAnimatable && typeof target === "string") /**
         * If we're trying to animate from "none", try and get an animatable version
         * of the target. This could be improved to work both ways.
         */ origin = (0, $eaFQn.getAnimatableNone)(key, target);
    else if ($724d6e8acec2b4de$export$c46ec7d82fb1f602(origin) && typeof target === "string") origin = $724d6e8acec2b4de$export$36cd6032f9de8a48(target);
    else if (!Array.isArray(target) && $724d6e8acec2b4de$export$c46ec7d82fb1f602(target) && typeof origin === "string") target = $724d6e8acec2b4de$export$36cd6032f9de8a48(origin);
    var isOriginAnimatable = (0, $GGpy3.isAnimatable)(key, origin);
    (0, $dnSYc.warning)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate " + key + ' from "' + origin + '" to "' + target + '". ' + origin + " is not an animatable value - to enable this animation set " + origin + " to a value animatable to " + target + " via the `style` property.");
    function start() {
        var options = {
            from: origin,
            to: target,
            velocity: value.getVelocity(),
            onComplete: onComplete,
            onUpdate: function(v) {
                return value.set(v);
            }
        };
        return valueTransition.type === "inertia" || valueTransition.type === "decay" ? (0, $2v7Ng.inertia)((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, options), valueTransition)) : (0, $aWAsx.animate)((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, $724d6e8acec2b4de$export$9019a69adbea191(valueTransition, options, key)), {
            onUpdate: function(v) {
                var _a;
                options.onUpdate(v);
                (_a = valueTransition.onUpdate) === null || _a === void 0 || _a.call(valueTransition, v);
            },
            onComplete: function() {
                var _a;
                options.onComplete();
                (_a = valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
            }
        }));
    }
    function set() {
        var _a;
        value.set(target);
        onComplete();
        (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _a === void 0 || _a.call(valueTransition);
        return {
            stop: function() {}
        };
    }
    return !isOriginAnimatable || !isTargetAnimatable || valueTransition.type === false ? set : start;
}
function $724d6e8acec2b4de$export$c46ec7d82fb1f602(value) {
    return value === 0 || typeof value === "string" && parseFloat(value) === 0 && value.indexOf(" ") === -1;
}
function $724d6e8acec2b4de$export$36cd6032f9de8a48(potentialUnitType) {
    return typeof potentialUnitType === "number" ? 0 : (0, $eaFQn.getAnimatableNone)("", potentialUnitType);
}
function $724d6e8acec2b4de$export$7c1391340308742e(transition, key) {
    return transition[key] || transition["default"] || transition;
}
/**
 * Start animation on a MotionValue. This function is an interface between
 * Framer Motion and Popmotion
 *
 * @internal
 */ function $724d6e8acec2b4de$export$592dbd515a49cf1b(key, value, target, transition) {
    if (transition === void 0) transition = {};
    return value.start(function(onComplete) {
        var delayTimer;
        var controls;
        var animation = $724d6e8acec2b4de$var$getAnimation(key, value, target, transition, onComplete);
        var delay = $724d6e8acec2b4de$export$b55a0e77aebddb70(transition, key);
        var start = function() {
            return controls = animation();
        };
        if (delay) delayTimer = setTimeout(start, (0, $id4XH.secondsToMilliseconds)(delay));
        else start();
        return function() {
            clearTimeout(delayTimer);
            controls === null || controls === void 0 || controls.stop();
        };
    });
}

});
parcelRegister("aWAsx", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $7f7b9a32038137f1$export$e3607ec2d7a891c4; });

var $S3LFa = parcelRequire("S3LFa");

var $04dXV = parcelRequire("04dXV");

var $iYUpa = parcelRequire("iYUpa");

var $4t34m = parcelRequire("4t34m");

var $4Vb2z = parcelRequire("4Vb2z");
var $7f7b9a32038137f1$var$framesync = function(update) {
    var passTimestamp = function(_a) {
        var delta = _a.delta;
        return update(delta);
    };
    return {
        start: function() {
            return (0, $iYUpa.default).update(passTimestamp, true);
        },
        stop: function() {
            return (0, $iYUpa.cancelSync).update(passTimestamp);
        }
    };
};
function $7f7b9a32038137f1$export$e3607ec2d7a891c4(_a) {
    var _b, _c;
    var from = _a.from, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, _e = _a.driver, driver = _e === void 0 ? $7f7b9a32038137f1$var$framesync : _e, _f = _a.elapsed, elapsed = _f === void 0 ? 0 : _f, _g = _a.repeat, repeatMax = _g === void 0 ? 0 : _g, _h = _a.repeatType, repeatType = _h === void 0 ? "loop" : _h, _j = _a.repeatDelay, repeatDelay = _j === void 0 ? 0 : _j, onPlay = _a.onPlay, onStop = _a.onStop, onComplete = _a.onComplete, onRepeat = _a.onRepeat, onUpdate = _a.onUpdate, options = (0, $S3LFa.__rest)(_a, [
        "from",
        "autoplay",
        "driver",
        "elapsed",
        "repeat",
        "repeatType",
        "repeatDelay",
        "onPlay",
        "onStop",
        "onComplete",
        "onRepeat",
        "onUpdate"
    ]);
    var to = options.to;
    var driverControls;
    var repeatCount = 0;
    var computedDuration = options.duration;
    var latest;
    var isComplete = false;
    var isForwardPlayback = true;
    var interpolateFromNumber;
    var animator = (0, $04dXV.detectAnimationFromOptions)(options);
    if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
        interpolateFromNumber = (0, $4t34m.interpolate)([
            0,
            100
        ], [
            from,
            to
        ], {
            clamp: false
        });
        from = 0;
        to = 100;
    }
    var animation = animator((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, options), {
        from: from,
        to: to
    }));
    function repeat() {
        repeatCount++;
        if (repeatType === "reverse") {
            isForwardPlayback = repeatCount % 2 === 0;
            elapsed = (0, $4Vb2z.reverseElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback);
        } else {
            elapsed = (0, $4Vb2z.loopElapsed)(elapsed, computedDuration, repeatDelay);
            if (repeatType === "mirror") animation.flipTarget();
        }
        isComplete = false;
        onRepeat && onRepeat();
    }
    function complete() {
        driverControls.stop();
        onComplete && onComplete();
    }
    function update(delta) {
        if (!isForwardPlayback) delta = -delta;
        elapsed += delta;
        if (!isComplete) {
            var state = animation.next(Math.max(0, elapsed));
            latest = state.value;
            if (interpolateFromNumber) latest = interpolateFromNumber(latest);
            isComplete = isForwardPlayback ? state.done : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 || onUpdate(latest);
        if (isComplete) {
            if (repeatCount === 0) computedDuration !== null && computedDuration !== void 0 ? computedDuration : computedDuration = elapsed;
            if (repeatCount < repeatMax) (0, $4Vb2z.hasRepeatDelayElapsed)(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
            else complete();
        }
    }
    function play() {
        onPlay === null || onPlay === void 0 || onPlay();
        driverControls = driver(update);
        driverControls.start();
    }
    autoplay && play();
    return {
        stop: function() {
            onStop === null || onStop === void 0 || onStop();
            driverControls.stop();
        }
    };
}

});
parcelRegister("04dXV", function(module, exports) {

$parcel$export(module.exports, "detectAnimationFromOptions", function () { return $00cb351df87e70f5$export$74df49bbebf8cb2c; });

var $eW7uv = parcelRequire("eW7uv");

var $hEevF = parcelRequire("hEevF");

var $6MAny = parcelRequire("6MAny");
var $00cb351df87e70f5$var$types = {
    keyframes: (0, $hEevF.keyframes),
    spring: (0, $eW7uv.spring),
    decay: (0, $6MAny.decay)
};
function $00cb351df87e70f5$export$74df49bbebf8cb2c(config) {
    if (Array.isArray(config.to)) return 0, $hEevF.keyframes;
    else if ($00cb351df87e70f5$var$types[config.type]) return $00cb351df87e70f5$var$types[config.type];
    var keys = new Set(Object.keys(config));
    if (keys.has("ease") || keys.has("duration") && !keys.has("dampingRatio")) return 0, $hEevF.keyframes;
    else if (keys.has("dampingRatio") || keys.has("stiffness") || keys.has("mass") || keys.has("damping") || keys.has("restSpeed") || keys.has("restDelta")) return 0, $eW7uv.spring;
    return 0, $hEevF.keyframes;
}

});
parcelRegister("eW7uv", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $adfc4b02137e7362$export$b36281d89752ae66; });

var $S3LFa = parcelRequire("S3LFa");

var $4Xdaa = parcelRequire("4Xdaa");
var $adfc4b02137e7362$var$durationKeys = [
    "duration",
    "bounce"
];
var $adfc4b02137e7362$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $adfc4b02137e7362$var$isSpringType(options, keys) {
    return keys.some(function(key) {
        return options[key] !== undefined;
    });
}
function $adfc4b02137e7362$var$getSpringOptions(options) {
    var springOptions = (0, $S3LFa.__assign)({
        velocity: 0.0,
        stiffness: 100,
        damping: 10,
        mass: 1.0,
        isResolvedFromDuration: false
    }, options);
    if (!$adfc4b02137e7362$var$isSpringType(options, $adfc4b02137e7362$var$physicsKeys) && $adfc4b02137e7362$var$isSpringType(options, $adfc4b02137e7362$var$durationKeys)) {
        var derived = (0, $4Xdaa.findSpring)(options);
        springOptions = (0, $S3LFa.__assign)((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, springOptions), derived), {
            velocity: 0.0,
            mass: 1.0
        });
        springOptions.isResolvedFromDuration = true;
    }
    return springOptions;
}
function $adfc4b02137e7362$export$b36281d89752ae66(_a) {
    var _b = _a.from, from = _b === void 0 ? 0.0 : _b, _c = _a.to, to = _c === void 0 ? 1.0 : _c, _d = _a.restSpeed, restSpeed = _d === void 0 ? 2 : _d, restDelta = _a.restDelta, options = (0, $S3LFa.__rest)(_a, [
        "from",
        "to",
        "restSpeed",
        "restDelta"
    ]);
    var state = {
        done: false,
        value: from
    };
    var _e = $adfc4b02137e7362$var$getSpringOptions(options), stiffness = _e.stiffness, damping = _e.damping, mass = _e.mass, velocity = _e.velocity, duration = _e.duration, isResolvedFromDuration = _e.isResolvedFromDuration;
    var resolveSpring = $adfc4b02137e7362$var$zero;
    var resolveVelocity = $adfc4b02137e7362$var$zero;
    function createSpring() {
        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        var initialDelta = to - from;
        var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
        var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
        restDelta !== null && restDelta !== void 0 ? restDelta : restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4;
        if (dampingRatio < 1) {
            var angularFreq_1 = (0, $4Xdaa.calcAngularFreq)(undampedAngularFreq, dampingRatio);
            resolveSpring = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 * Math.sin(angularFreq_1 * t) + initialDelta * Math.cos(angularFreq_1 * t));
            };
            resolveVelocity = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                return dampingRatio * undampedAngularFreq * envelope * (Math.sin(angularFreq_1 * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq_1 + initialDelta * Math.cos(angularFreq_1 * t)) - envelope * (Math.cos(angularFreq_1 * t) * (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) - angularFreq_1 * initialDelta * Math.sin(angularFreq_1 * t));
            };
        } else if (dampingRatio === 1) resolveSpring = function(t) {
            return to - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        };
        else {
            var dampedAngularFreq_1 = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
            resolveSpring = function(t) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                var freqForT = Math.min(dampedAngularFreq_1 * t, 300);
                return to - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq_1 * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq_1;
            };
        }
    }
    createSpring();
    return {
        next: function(t) {
            var current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity = resolveVelocity(t) * 1000;
                var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                var isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? to : current;
            return state;
        },
        flipTarget: function() {
            var _a;
            velocity = -velocity;
            _a = [
                to,
                from
            ], from = _a[0], to = _a[1];
            createSpring();
        }
    };
}
$adfc4b02137e7362$export$b36281d89752ae66.needsInterpolation = function(a, b) {
    return typeof a === "string" || typeof b === "string";
};
var $adfc4b02137e7362$var$zero = function(_t) {
    return 0;
};

});
parcelRegister("4Xdaa", function(module, exports) {

$parcel$export(module.exports, "findSpring", function () { return $39b6e204b0aeef81$export$b15f158dc6d6f458; });
$parcel$export(module.exports, "calcAngularFreq", function () { return $39b6e204b0aeef81$export$5f679887c3a78b15; });

var $dnSYc = parcelRequire("dnSYc");

var $6NMkb = parcelRequire("6NMkb");
var $39b6e204b0aeef81$var$safeMin = 0.001;
var $39b6e204b0aeef81$export$a3cdb76e84ee608e = 0.01;
var $39b6e204b0aeef81$export$1824b851fad8862b = 10.0;
var $39b6e204b0aeef81$export$ff08f2d53484465 = 0.05;
var $39b6e204b0aeef81$export$201ca48e54038115 = 1;
function $39b6e204b0aeef81$export$b15f158dc6d6f458(_a) {
    var _b = _a.duration, duration = _b === void 0 ? 800 : _b, _c = _a.bounce, bounce = _c === void 0 ? 0.25 : _c, _d = _a.velocity, velocity = _d === void 0 ? 0 : _d, _e = _a.mass, mass = _e === void 0 ? 1 : _e;
    var envelope;
    var derivative;
    (0, $dnSYc.warning)(duration <= $39b6e204b0aeef81$export$1824b851fad8862b * 1000, "Spring duration must be 10 seconds or less");
    var dampingRatio = 1 - bounce;
    dampingRatio = (0, $6NMkb.clamp)($39b6e204b0aeef81$export$ff08f2d53484465, $39b6e204b0aeef81$export$201ca48e54038115, dampingRatio);
    duration = (0, $6NMkb.clamp)($39b6e204b0aeef81$export$a3cdb76e84ee608e, $39b6e204b0aeef81$export$1824b851fad8862b, duration / 1000);
    if (dampingRatio < 1) {
        envelope = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = $39b6e204b0aeef81$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return $39b6e204b0aeef81$var$safeMin - a / b * c;
        };
        derivative = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = $39b6e204b0aeef81$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + $39b6e204b0aeef81$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        envelope = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -$39b6e204b0aeef81$var$safeMin + a * b;
        };
        derivative = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = $39b6e204b0aeef81$var$approximateRoot(envelope, derivative, initialGuess);
    duration = duration * 1000;
    if (isNaN(undampedFreq)) return {
        stiffness: 100,
        damping: 10,
        duration: duration
    };
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
var $39b6e204b0aeef81$var$rootIterations = 12;
function $39b6e204b0aeef81$var$approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for(var i = 1; i < $39b6e204b0aeef81$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $39b6e204b0aeef81$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}

});
parcelRegister("6NMkb", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $4f3ccde863c1af81$export$7d15b64cf5a3a4c4; });
var $4f3ccde863c1af81$export$7d15b64cf5a3a4c4 = function(min, max, v) {
    return Math.min(Math.max(v, min), max);
};

});



parcelRegister("hEevF", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $cd916d6f985afb20$export$d25ddfdf17c3ad3e; });

var $4t34m = parcelRequire("4t34m");

var $lyEGJ = parcelRequire("lyEGJ");
function $cd916d6f985afb20$export$6b60b58e4ea7d715(values, easing) {
    return values.map(function() {
        return easing || (0, $lyEGJ.easeInOut);
    }).splice(0, values.length - 1);
}
function $cd916d6f985afb20$export$24dbcec0b26e6d9d(values) {
    var numValues = values.length;
    return values.map(function(_value, i) {
        return i !== 0 ? i / (numValues - 1) : 0;
    });
}
function $cd916d6f985afb20$export$2a91b4e3a4539316(offset, duration) {
    return offset.map(function(o) {
        return o * duration;
    });
}
function $cd916d6f985afb20$export$d25ddfdf17c3ad3e(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, ease = _a.ease, offset = _a.offset, _d = _a.duration, duration = _d === void 0 ? 300 : _d;
    var state = {
        done: false,
        value: from
    };
    var values = Array.isArray(to) ? to : [
        from,
        to
    ];
    var times = $cd916d6f985afb20$export$2a91b4e3a4539316(offset && offset.length === values.length ? offset : $cd916d6f985afb20$export$24dbcec0b26e6d9d(values), duration);
    function createInterpolator() {
        return (0, $4t34m.interpolate)(times, values, {
            ease: Array.isArray(ease) ? ease : $cd916d6f985afb20$export$6b60b58e4ea7d715(values, ease)
        });
    }
    var interpolator = createInterpolator();
    return {
        next: function(t) {
            state.value = interpolator(t);
            state.done = t >= duration;
            return state;
        },
        flipTarget: function() {
            values.reverse();
            interpolator = createInterpolator();
        }
    };
}

});
parcelRegister("4t34m", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $340c4061782ba86c$export$89e29e4ab65e70a9; });

var $4hJwG = parcelRequire("4hJwG");

var $kA2Ry = parcelRequire("kA2Ry");

var $8xk2w = parcelRequire("8xk2w");

var $dWMHN = parcelRequire("dWMHN");

var $ahu22 = parcelRequire("ahu22");

var $6NMkb = parcelRequire("6NMkb");

var $eiL8o = parcelRequire("eiL8o");

var $dnSYc = parcelRequire("dnSYc");
var $340c4061782ba86c$var$mixNumber = function(from, to) {
    return function(p) {
        return (0, $kA2Ry.mix)(from, to, p);
    };
};
function $340c4061782ba86c$var$detectMixerFactory(v) {
    if (typeof v === "number") return $340c4061782ba86c$var$mixNumber;
    else if (typeof v === "string") {
        if ((0, $ahu22.color).test(v)) return 0, $8xk2w.mixColor;
        else return 0, $dWMHN.mixComplex;
    } else if (Array.isArray(v)) return 0, $dWMHN.mixArray;
    else if (typeof v === "object") return 0, $dWMHN.mixObject;
}
function $340c4061782ba86c$var$createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || $340c4061782ba86c$var$detectMixerFactory(output[0]);
    var numMixers = output.length - 1;
    for(var i = 0; i < numMixers; i++){
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
            mixer = (0, $eiL8o.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
function $340c4061782ba86c$var$fastInterpolate(_a, _b) {
    var from = _a[0], to = _a[1];
    var mixer = _b[0];
    return function(v) {
        return mixer((0, $4hJwG.progress)(from, to, v));
    };
}
function $340c4061782ba86c$var$slowInterpolate(input, mixers) {
    var inputLength = input.length;
    var lastInputIndex = inputLength - 1;
    return function(v) {
        var mixerIndex = 0;
        var foundMixerIndex = false;
        if (v <= input[0]) foundMixerIndex = true;
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            var i = 1;
            for(; i < inputLength; i++){
                if (input[i] > v || i === lastInputIndex) break;
            }
            mixerIndex = i - 1;
        }
        var progressInRange = (0, $4hJwG.progress)(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
}
function $340c4061782ba86c$export$89e29e4ab65e70a9(input, output, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.clamp, isClamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
    var inputLength = input.length;
    (0, $dnSYc.invariant)(inputLength === output.length, "Both input and output ranges must be the same length");
    (0, $dnSYc.invariant)(!ease || !Array.isArray(ease) || ease.length === inputLength - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.");
    if (input[0] > input[inputLength - 1]) {
        input = [].concat(input);
        output = [].concat(output);
        input.reverse();
        output.reverse();
    }
    var mixers = $340c4061782ba86c$var$createMixers(output, ease, mixer);
    var interpolator = inputLength === 2 ? $340c4061782ba86c$var$fastInterpolate(input, mixers) : $340c4061782ba86c$var$slowInterpolate(input, mixers);
    return isClamp ? function(v) {
        return interpolator((0, $6NMkb.clamp)(input[0], input[inputLength - 1], v));
    } : interpolator;
}

});
parcelRegister("4hJwG", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $31ec107fc647afee$export$504d7abb21fa8c9; });
var $31ec107fc647afee$export$504d7abb21fa8c9 = function(from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

});

parcelRegister("kA2Ry", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $efb963ea9f2e4f4f$export$2c9e8a9632a706b2; });
var $efb963ea9f2e4f4f$export$2c9e8a9632a706b2 = function(from, to, progress) {
    return -progress * from + progress * to + from;
};

});

parcelRegister("8xk2w", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $6370f341e9fb808e$export$51e568cf5c039bac; });

var $S3LFa = parcelRequire("S3LFa");

var $kA2Ry = parcelRequire("kA2Ry");

var $7SOJZ = parcelRequire("7SOJZ");
var $eitGD = parcelRequire("eitGD");
var $6c3c9 = parcelRequire("6c3c9");

var $dnSYc = parcelRequire("dnSYc");
var $6370f341e9fb808e$export$d4ecea248cce73c = function(from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
var $6370f341e9fb808e$var$colorTypes = [
    (0, $7SOJZ.hex),
    (0, $6c3c9.rgba),
    (0, $eitGD.hsla)
];
var $6370f341e9fb808e$var$getColorType = function(v) {
    return $6370f341e9fb808e$var$colorTypes.find(function(type) {
        return type.test(v);
    });
};
var $6370f341e9fb808e$var$notAnimatable = function(color) {
    return "'" + color + "' is not an animatable color. Use the equivalent color code instead.";
};
var $6370f341e9fb808e$export$51e568cf5c039bac = function(from, to) {
    var fromColorType = $6370f341e9fb808e$var$getColorType(from);
    var toColorType = $6370f341e9fb808e$var$getColorType(to);
    (0, $dnSYc.invariant)(!!fromColorType, $6370f341e9fb808e$var$notAnimatable(from));
    (0, $dnSYc.invariant)(!!toColorType, $6370f341e9fb808e$var$notAnimatable(to));
    (0, $dnSYc.invariant)(fromColorType.transform === toColorType.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);
    var blended = (0, $S3LFa.__assign)({}, fromColor);
    var mixFunc = fromColorType === (0, $eitGD.hsla) ? (0, $kA2Ry.mix) : $6370f341e9fb808e$export$d4ecea248cce73c;
    return function(v) {
        for(var key in blended)if (key !== "alpha") blended[key] = mixFunc(fromColor[key], toColor[key], v);
        blended.alpha = (0, $kA2Ry.mix)(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
};

});
parcelRegister("7SOJZ", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $5bd4ef9e87640d20$export$834dfc94dde4b3d8; });

var $6c3c9 = parcelRequire("6c3c9");

var $gc1jI = parcelRequire("gc1jI");
function $5bd4ef9e87640d20$var$parseHex(v) {
    var r = "";
    var g = "";
    var b = "";
    var a = "";
    if (v.length > 5) {
        r = v.substr(1, 2);
        g = v.substr(3, 2);
        b = v.substr(5, 2);
        a = v.substr(7, 2);
    } else {
        r = v.substr(1, 1);
        g = v.substr(2, 1);
        b = v.substr(3, 1);
        a = v.substr(4, 1);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
var $5bd4ef9e87640d20$export$834dfc94dde4b3d8 = {
    test: (0, $gc1jI.isColorString)("#"),
    parse: $5bd4ef9e87640d20$var$parseHex,
    transform: (0, $6c3c9.rgba).transform
};

});
parcelRegister("6c3c9", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $48265787006beb8d$export$4e46ac54fc82cf3b; });

var $S3LFa = parcelRequire("S3LFa");

var $b7dp4 = parcelRequire("b7dp4");

var $eYw7E = parcelRequire("eYw7E");

var $gc1jI = parcelRequire("gc1jI");
var $48265787006beb8d$var$clampRgbUnit = (0, $eYw7E.clamp)(0, 255);
var $48265787006beb8d$export$7a99c86b5b1f4c9e = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, (0, $b7dp4.number)), {
    transform: function(v) {
        return Math.round($48265787006beb8d$var$clampRgbUnit(v));
    }
});
var $48265787006beb8d$export$4e46ac54fc82cf3b = {
    test: (0, $gc1jI.isColorString)("rgb", "red"),
    parse: (0, $gc1jI.splitColor)("red", "green", "blue"),
    transform: function(_a) {
        var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return "rgba(" + $48265787006beb8d$export$7a99c86b5b1f4c9e.transform(red) + ", " + $48265787006beb8d$export$7a99c86b5b1f4c9e.transform(green) + ", " + $48265787006beb8d$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $eYw7E.sanitize)((0, $b7dp4.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRegister("gc1jI", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $bc9ec9d96682809d$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $bc9ec9d96682809d$export$73d6f35be992df24; });

var $eYw7E = parcelRequire("eYw7E");
var $bc9ec9d96682809d$export$2c8400d58aca05e = function(type, testProp) {
    return function(v) {
        return Boolean((0, $eYw7E.isString)(v) && (0, $eYw7E.singleColorRegex).test(v) && v.startsWith(type) || testProp && Object.prototype.hasOwnProperty.call(v, testProp));
    };
};
var $bc9ec9d96682809d$export$73d6f35be992df24 = function(aName, bName, cName) {
    return function(v) {
        var _a;
        if (!(0, $eYw7E.isString)(v)) return v;
        var _b = v.match((0, $eYw7E.floatRegex)), a = _b[0], b = _b[1], c = _b[2], alpha = _b[3];
        return _a = {}, _a[aName] = parseFloat(a), _a[bName] = parseFloat(b), _a[cName] = parseFloat(c), _a.alpha = alpha !== undefined ? parseFloat(alpha) : 1, _a;
    };
};

});



parcelRegister("eitGD", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $a689c6486005de57$export$810b04175080204c; });

var $b7dp4 = parcelRequire("b7dp4");

var $avwtz = parcelRequire("avwtz");

var $eYw7E = parcelRequire("eYw7E");

var $gc1jI = parcelRequire("gc1jI");
var $a689c6486005de57$export$810b04175080204c = {
    test: (0, $gc1jI.isColorString)("hsl", "hue"),
    parse: (0, $gc1jI.splitColor)("hue", "saturation", "lightness"),
    transform: function(_a) {
        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
        return "hsla(" + Math.round(hue) + ", " + (0, $avwtz.percent).transform((0, $eYw7E.sanitize)(saturation)) + ", " + (0, $avwtz.percent).transform((0, $eYw7E.sanitize)(lightness)) + ", " + (0, $eYw7E.sanitize)((0, $b7dp4.alpha).transform(alpha$1)) + ")";
    }
};

});


parcelRegister("dWMHN", function(module, exports) {

$parcel$export(module.exports, "mixComplex", function () { return $a2767904ead02abe$export$65516310a87d8205; });
$parcel$export(module.exports, "mixArray", function () { return $a2767904ead02abe$export$3bbefa2f402845c4; });
$parcel$export(module.exports, "mixObject", function () { return $a2767904ead02abe$export$ebc23b6840c51ba1; });

var $S3LFa = parcelRequire("S3LFa");

var $ahu22 = parcelRequire("ahu22");
var $fh0dC = parcelRequire("fh0dC");

var $kA2Ry = parcelRequire("kA2Ry");

var $8xk2w = parcelRequire("8xk2w");

var $gFVp8 = parcelRequire("gFVp8");

var $eiL8o = parcelRequire("eiL8o");

var $dnSYc = parcelRequire("dnSYc");
function $a2767904ead02abe$var$getMixer(origin, target) {
    if ((0, $gFVp8.isNum)(origin)) return function(v) {
        return (0, $kA2Ry.mix)(origin, target, v);
    };
    else if ((0, $ahu22.color).test(origin)) return (0, $8xk2w.mixColor)(origin, target);
    else return $a2767904ead02abe$export$65516310a87d8205(origin, target);
}
var $a2767904ead02abe$export$3bbefa2f402845c4 = function(from, to) {
    var output = (0, $S3LFa.__spreadArray)([], from);
    var numValues = output.length;
    var blendValue = from.map(function(fromThis, i) {
        return $a2767904ead02abe$var$getMixer(fromThis, to[i]);
    });
    return function(v) {
        for(var i = 0; i < numValues; i++)output[i] = blendValue[i](v);
        return output;
    };
};
var $a2767904ead02abe$export$ebc23b6840c51ba1 = function(origin, target) {
    var output = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, origin), target);
    var blendValue = {};
    for(var key in output)if (origin[key] !== undefined && target[key] !== undefined) blendValue[key] = $a2767904ead02abe$var$getMixer(origin[key], target[key]);
    return function(v) {
        for(var key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
};
function $a2767904ead02abe$var$analyse(value) {
    var parsed = (0, $fh0dC.complex).parse(value);
    var numValues = parsed.length;
    var numNumbers = 0;
    var numRGB = 0;
    var numHSL = 0;
    for(var i = 0; i < numValues; i++){
        if (numNumbers || typeof parsed[i] === "number") numNumbers++;
        else if (parsed[i].hue !== undefined) numHSL++;
        else numRGB++;
    }
    return {
        parsed: parsed,
        numNumbers: numNumbers,
        numRGB: numRGB,
        numHSL: numHSL
    };
}
var $a2767904ead02abe$export$65516310a87d8205 = function(origin, target) {
    var template = (0, $fh0dC.complex).createTransformer(target);
    var originStats = $a2767904ead02abe$var$analyse(origin);
    var targetStats = $a2767904ead02abe$var$analyse(target);
    (0, $dnSYc.invariant)(originStats.numHSL === targetStats.numHSL && originStats.numRGB === targetStats.numRGB && originStats.numNumbers >= targetStats.numNumbers, "Complex values '" + origin + "' and '" + target + "' too different to mix. Ensure all colors are of the same type.");
    return (0, $eiL8o.pipe)($a2767904ead02abe$export$3bbefa2f402845c4(originStats.parsed, targetStats.parsed), template);
};

});
parcelRegister("ahu22", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $77c2c9a4508a03f4$export$35e9368ef982300f; });

var $eYw7E = parcelRequire("eYw7E");

var $7SOJZ = parcelRequire("7SOJZ");

var $eitGD = parcelRequire("eitGD");

var $6c3c9 = parcelRequire("6c3c9");
var $77c2c9a4508a03f4$export$35e9368ef982300f = {
    test: function(v) {
        return (0, $6c3c9.rgba).test(v) || (0, $7SOJZ.hex).test(v) || (0, $eitGD.hsla).test(v);
    },
    parse: function(v) {
        if ((0, $6c3c9.rgba).test(v)) return (0, $6c3c9.rgba).parse(v);
        else if ((0, $eitGD.hsla).test(v)) return (0, $eitGD.hsla).parse(v);
        else return (0, $7SOJZ.hex).parse(v);
    },
    transform: function(v) {
        return (0, $eYw7E.isString)(v) ? v : v.hasOwnProperty("red") ? (0, $6c3c9.rgba).transform(v) : (0, $eitGD.hsla).transform(v);
    }
};

});

parcelRegister("fh0dC", function(module, exports) {

$parcel$export(module.exports, "complex", function () { return $b1e89cf91f29403e$export$83a0e34f1302825b; });

var $ahu22 = parcelRequire("ahu22");

var $b7dp4 = parcelRequire("b7dp4");

var $eYw7E = parcelRequire("eYw7E");
var $b1e89cf91f29403e$var$colorToken = "${c}";
var $b1e89cf91f29403e$var$numberToken = "${n}";
function $b1e89cf91f29403e$var$test(v) {
    var _a, _b, _c, _d;
    return isNaN(v) && (0, $eYw7E.isString)(v) && ((_b = (_a = v.match((0, $eYw7E.floatRegex))) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match((0, $eYw7E.colorRegex))) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
}
function $b1e89cf91f29403e$var$analyse(v) {
    var values = [];
    var numColors = 0;
    var colors = v.match((0, $eYw7E.colorRegex));
    if (colors) {
        numColors = colors.length;
        v = v.replace((0, $eYw7E.colorRegex), $b1e89cf91f29403e$var$colorToken);
        values.push.apply(values, colors.map((0, $ahu22.color).parse));
    }
    var numbers = v.match((0, $eYw7E.floatRegex));
    if (numbers) {
        v = v.replace((0, $eYw7E.floatRegex), $b1e89cf91f29403e$var$numberToken);
        values.push.apply(values, numbers.map((0, $b7dp4.number).parse));
    }
    return {
        values: values,
        numColors: numColors,
        tokenised: v
    };
}
function $b1e89cf91f29403e$var$parse(v) {
    return $b1e89cf91f29403e$var$analyse(v).values;
}
function $b1e89cf91f29403e$var$createTransformer(v) {
    var _a = $b1e89cf91f29403e$var$analyse(v), values = _a.values, numColors = _a.numColors, tokenised = _a.tokenised;
    var numValues = values.length;
    return function(v) {
        var output = tokenised;
        for(var i = 0; i < numValues; i++)output = output.replace(i < numColors ? $b1e89cf91f29403e$var$colorToken : $b1e89cf91f29403e$var$numberToken, i < numColors ? (0, $ahu22.color).transform(v[i]) : (0, $eYw7E.sanitize)(v[i]));
        return output;
    };
}
var $b1e89cf91f29403e$var$convertNumbersToZero = function(v) {
    return typeof v === "number" ? 0 : v;
};
function $b1e89cf91f29403e$var$getAnimatableNone(v) {
    var parsed = $b1e89cf91f29403e$var$parse(v);
    var transformer = $b1e89cf91f29403e$var$createTransformer(v);
    return transformer(parsed.map($b1e89cf91f29403e$var$convertNumbersToZero));
}
var $b1e89cf91f29403e$export$83a0e34f1302825b = {
    test: $b1e89cf91f29403e$var$test,
    parse: $b1e89cf91f29403e$var$parse,
    createTransformer: $b1e89cf91f29403e$var$createTransformer,
    getAnimatableNone: $b1e89cf91f29403e$var$getAnimatableNone
};

});

parcelRegister("gFVp8", function(module, exports) {

$parcel$export(module.exports, "isNum", function () { return $c23d00fbbb3efd82$export$4e960b977ccfec97; });
var $c23d00fbbb3efd82$export$c0c148ccc4f34a76 = {
    x: 0,
    y: 0,
    z: 0
};
var $c23d00fbbb3efd82$export$4e960b977ccfec97 = function(v) {
    return typeof v === "number";
};

});



parcelRegister("lyEGJ", function(module, exports) {

$parcel$export(module.exports, "linear", function () { return $fb1c55c978d12c95$export$45db2fc2f15997e7; });
$parcel$export(module.exports, "easeIn", function () { return $fb1c55c978d12c95$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $fb1c55c978d12c95$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $fb1c55c978d12c95$export$c07234257a03d5e9; });
$parcel$export(module.exports, "circIn", function () { return $fb1c55c978d12c95$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $fb1c55c978d12c95$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $fb1c55c978d12c95$export$30d3455eee55bed5; });
$parcel$export(module.exports, "backIn", function () { return $fb1c55c978d12c95$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backOut", function () { return $fb1c55c978d12c95$export$77edfce482316a60; });
$parcel$export(module.exports, "backInOut", function () { return $fb1c55c978d12c95$export$ddc5fd596f6c71b2; });
$parcel$export(module.exports, "anticipate", function () { return $fb1c55c978d12c95$export$6b0af63b873d419e; });
$parcel$export(module.exports, "bounceOut", function () { return $fb1c55c978d12c95$export$cccc9e04465dce11; });
$parcel$export(module.exports, "bounceIn", function () { return $fb1c55c978d12c95$export$fccebd7948554554; });
$parcel$export(module.exports, "bounceInOut", function () { return $fb1c55c978d12c95$export$41ad9e9849a703ce; });

var $bmsTX = parcelRequire("bmsTX");
var $fb1c55c978d12c95$var$DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var $fb1c55c978d12c95$var$BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
var $fb1c55c978d12c95$var$BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
var $fb1c55c978d12c95$var$BOUNCE_THIRD_THRESHOLD = 0.9;
var $fb1c55c978d12c95$export$45db2fc2f15997e7 = function(p) {
    return p;
};
var $fb1c55c978d12c95$export$929e5a82286172a6 = (0, $bmsTX.createExpoIn)(2);
var $fb1c55c978d12c95$export$57636bb43b1ccbb0 = (0, $bmsTX.reverseEasing)($fb1c55c978d12c95$export$929e5a82286172a6);
var $fb1c55c978d12c95$export$c07234257a03d5e9 = (0, $bmsTX.mirrorEasing)($fb1c55c978d12c95$export$929e5a82286172a6);
var $fb1c55c978d12c95$export$e444123e42d03385 = function(p) {
    return 1 - Math.sin(Math.acos(p));
};
var $fb1c55c978d12c95$export$c8d67a19199d1a50 = (0, $bmsTX.reverseEasing)($fb1c55c978d12c95$export$e444123e42d03385);
var $fb1c55c978d12c95$export$30d3455eee55bed5 = (0, $bmsTX.mirrorEasing)($fb1c55c978d12c95$export$c8d67a19199d1a50);
var $fb1c55c978d12c95$export$b01116c84cdfe1a2 = (0, $bmsTX.createBackIn)($fb1c55c978d12c95$var$DEFAULT_OVERSHOOT_STRENGTH);
var $fb1c55c978d12c95$export$77edfce482316a60 = (0, $bmsTX.reverseEasing)($fb1c55c978d12c95$export$b01116c84cdfe1a2);
var $fb1c55c978d12c95$export$ddc5fd596f6c71b2 = (0, $bmsTX.mirrorEasing)($fb1c55c978d12c95$export$b01116c84cdfe1a2);
var $fb1c55c978d12c95$export$6b0af63b873d419e = (0, $bmsTX.createAnticipate)($fb1c55c978d12c95$var$DEFAULT_OVERSHOOT_STRENGTH);
var $fb1c55c978d12c95$var$ca = 4356.0 / 361.0;
var $fb1c55c978d12c95$var$cb = 35442.0 / 1805.0;
var $fb1c55c978d12c95$var$cc = 16061.0 / 1805.0;
var $fb1c55c978d12c95$export$cccc9e04465dce11 = function(p) {
    if (p === 1 || p === 0) return p;
    var p2 = p * p;
    return p < $fb1c55c978d12c95$var$BOUNCE_FIRST_THRESHOLD ? 7.5625 * p2 : p < $fb1c55c978d12c95$var$BOUNCE_SECOND_THRESHOLD ? 9.075 * p2 - 9.9 * p + 3.4 : p < $fb1c55c978d12c95$var$BOUNCE_THIRD_THRESHOLD ? $fb1c55c978d12c95$var$ca * p2 - $fb1c55c978d12c95$var$cb * p + $fb1c55c978d12c95$var$cc : 10.8 * p * p - 20.52 * p + 10.72;
};
var $fb1c55c978d12c95$export$fccebd7948554554 = (0, $bmsTX.reverseEasing)($fb1c55c978d12c95$export$cccc9e04465dce11);
var $fb1c55c978d12c95$export$41ad9e9849a703ce = function(p) {
    return p < 0.5 ? 0.5 * (1.0 - $fb1c55c978d12c95$export$cccc9e04465dce11(1.0 - p * 2.0)) : 0.5 * $fb1c55c978d12c95$export$cccc9e04465dce11(p * 2.0 - 1.0) + 0.5;
};

});
parcelRegister("bmsTX", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $84582b0d4795dc16$export$2c07eeff45156d4d; });
$parcel$export(module.exports, "mirrorEasing", function () { return $84582b0d4795dc16$export$f946554fb8aeaf0d; });
$parcel$export(module.exports, "createExpoIn", function () { return $84582b0d4795dc16$export$c90c8c5a3c7a5e80; });
$parcel$export(module.exports, "createBackIn", function () { return $84582b0d4795dc16$export$2a739ba6da1d1495; });
$parcel$export(module.exports, "createAnticipate", function () { return $84582b0d4795dc16$export$222fa0be41d8b537; });
var $84582b0d4795dc16$export$2c07eeff45156d4d = function(easing) {
    return function(p) {
        return 1 - easing(1 - p);
    };
};
var $84582b0d4795dc16$export$f946554fb8aeaf0d = function(easing) {
    return function(p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};
var $84582b0d4795dc16$export$c90c8c5a3c7a5e80 = function(power) {
    return function(p) {
        return Math.pow(p, power);
    };
};
var $84582b0d4795dc16$export$2a739ba6da1d1495 = function(power) {
    return function(p) {
        return p * p * ((power + 1) * p - power);
    };
};
var $84582b0d4795dc16$export$222fa0be41d8b537 = function(power) {
    var backEasing = $84582b0d4795dc16$export$2a739ba6da1d1495(power);
    return function(p) {
        return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};

});



parcelRegister("6MAny", function(module, exports) {

$parcel$export(module.exports, "decay", function () { return $4f0371e1dc4dbf1f$export$e9341ba102272ab9; });
function $4f0371e1dc4dbf1f$export$e9341ba102272ab9(_a) {
    var _b = _a.velocity, velocity = _b === void 0 ? 0 : _b, _c = _a.from, from = _c === void 0 ? 0 : _c, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = _a.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = _a.modifyTarget;
    var state = {
        done: false,
        value: from
    };
    var amplitude = power * velocity;
    var ideal = from + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    if (target !== ideal) amplitude = target - from;
    return {
        next: function(t) {
            var delta = -amplitude * Math.exp(-t / timeConstant);
            state.done = !(delta > restDelta || delta < -restDelta);
            state.value = state.done ? target : target + delta;
            return state;
        },
        flipTarget: function() {}
    };
}

});


parcelRegister("4Vb2z", function(module, exports) {

$parcel$export(module.exports, "loopElapsed", function () { return $39550cb2c4a953f7$export$7d0784e050d8e25f; });
$parcel$export(module.exports, "reverseElapsed", function () { return $39550cb2c4a953f7$export$ab9042754680126b; });
$parcel$export(module.exports, "hasRepeatDelayElapsed", function () { return $39550cb2c4a953f7$export$c9c9437f9b8733b5; });
function $39550cb2c4a953f7$export$7d0784e050d8e25f(elapsed, duration, delay) {
    if (delay === void 0) delay = 0;
    return elapsed - duration - delay;
}
function $39550cb2c4a953f7$export$ab9042754680126b(elapsed, duration, delay, isForwardPlayback) {
    if (delay === void 0) delay = 0;
    if (isForwardPlayback === void 0) isForwardPlayback = true;
    return isForwardPlayback ? $39550cb2c4a953f7$export$7d0784e050d8e25f(duration + -elapsed, duration, delay) : duration - (elapsed - duration) + delay;
}
function $39550cb2c4a953f7$export$c9c9437f9b8733b5(elapsed, duration, delay, isForwardPlayback) {
    return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
}

});


parcelRegister("2v7Ng", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $1d2485a44da25232$export$ee3ff3a17106998; });

var $S3LFa = parcelRequire("S3LFa");

var $aWAsx = parcelRequire("aWAsx");

var $d0crj = parcelRequire("d0crj");

var $iYUpa = parcelRequire("iYUpa");
function $1d2485a44da25232$export$ee3ff3a17106998(_a) {
    var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.velocity, velocity = _c === void 0 ? 0 : _c, min = _a.min, max = _a.max, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 750 : _e, _f = _a.bounceStiffness, bounceStiffness = _f === void 0 ? 500 : _f, _g = _a.bounceDamping, bounceDamping = _g === void 0 ? 10 : _g, _h = _a.restDelta, restDelta = _h === void 0 ? 1 : _h, modifyTarget = _a.modifyTarget, driver = _a.driver, onUpdate = _a.onUpdate, onComplete = _a.onComplete;
    var currentAnimation;
    function isOutOfBounds(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    }
    function boundaryNearest(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    }
    function startAnimation(options) {
        currentAnimation === null || currentAnimation === void 0 || currentAnimation.stop();
        currentAnimation = (0, $aWAsx.animate)((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, options), {
            driver: driver,
            onUpdate: function(v) {
                var _a;
                onUpdate === null || onUpdate === void 0 || onUpdate(v);
                (_a = options.onUpdate) === null || _a === void 0 || _a.call(options, v);
            },
            onComplete: onComplete
        }));
    }
    function startSpring(options) {
        startAnimation((0, $S3LFa.__assign)({
            type: "spring",
            stiffness: bounceStiffness,
            damping: bounceDamping,
            restDelta: restDelta
        }, options));
    }
    if (isOutOfBounds(from)) startSpring({
        from: from,
        velocity: velocity,
        to: boundaryNearest(from)
    });
    else {
        var target = power * velocity + from;
        if (typeof modifyTarget !== "undefined") target = modifyTarget(target);
        var boundary_1 = boundaryNearest(target);
        var heading_1 = boundary_1 === min ? -1 : 1;
        var prev_1;
        var current_1;
        var checkBoundary = function(v) {
            prev_1 = current_1;
            current_1 = v;
            velocity = (0, $d0crj.velocityPerSecond)(v - prev_1, (0, $iYUpa.getFrameData)().delta);
            if (heading_1 === 1 && v > boundary_1 || heading_1 === -1 && v < boundary_1) startSpring({
                from: v,
                to: boundary_1,
                velocity: velocity
            });
        };
        startAnimation({
            type: "decay",
            from: from,
            velocity: velocity,
            timeConstant: timeConstant,
            power: power,
            restDelta: restDelta,
            modifyTarget: modifyTarget,
            onUpdate: isOutOfBounds(target) ? checkBoundary : undefined
        });
    }
    return {
        stop: function() {
            return currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
        }
    };
}

});
parcelRegister("d0crj", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $9774ecad732e43b6$export$eab0632f7ad4f9d7; });
function $9774ecad732e43b6$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRegister("id4XH", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $d41d4a36a2ccc883$export$fc3e7e8557f8c8c7; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ var $d41d4a36a2ccc883$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};

});

parcelRegister("4gesc", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $31a3de45add4e511$export$ef97fe084f156ca4; });
$parcel$export(module.exports, "isEasingArray", function () { return $31a3de45add4e511$export$216948827bbdc797; });

var $S3LFa = parcelRequire("S3LFa");

var $dnSYc = parcelRequire("dnSYc");

var $lyEGJ = parcelRequire("lyEGJ");
var $1wWNB = parcelRequire("1wWNB");
var $31a3de45add4e511$var$easingLookup = {
    linear: (0, $lyEGJ.linear),
    easeIn: (0, $lyEGJ.easeIn),
    easeInOut: (0, $lyEGJ.easeInOut),
    easeOut: (0, $lyEGJ.easeOut),
    circIn: (0, $lyEGJ.circIn),
    circInOut: (0, $lyEGJ.circInOut),
    circOut: (0, $lyEGJ.circOut),
    backIn: (0, $lyEGJ.backIn),
    backInOut: (0, $lyEGJ.backInOut),
    backOut: (0, $lyEGJ.backOut),
    anticipate: (0, $lyEGJ.anticipate),
    bounceIn: (0, $lyEGJ.bounceIn),
    bounceInOut: (0, $lyEGJ.bounceInOut),
    bounceOut: (0, $lyEGJ.bounceOut)
};
var $31a3de45add4e511$export$ef97fe084f156ca4 = function(definition) {
    if (Array.isArray(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $dnSYc.invariant)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.");
        var _a = (0, $S3LFa.__read)(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
        return (0, $1wWNB.cubicBezier)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $dnSYc.invariant)($31a3de45add4e511$var$easingLookup[definition] !== undefined, "Invalid easing type '" + definition + "'");
        return $31a3de45add4e511$var$easingLookup[definition];
    }
    return definition;
};
var $31a3de45add4e511$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});
parcelRegister("1wWNB", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $11d663dba55af70f$export$2c575fa1d20488bd; });

var $lyEGJ = parcelRequire("lyEGJ");
var $11d663dba55af70f$var$a = function(a1, a2) {
    return 1.0 - 3.0 * a2 + 3.0 * a1;
};
var $11d663dba55af70f$var$b = function(a1, a2) {
    return 3.0 * a2 - 6.0 * a1;
};
var $11d663dba55af70f$var$c = function(a1) {
    return 3.0 * a1;
};
var $11d663dba55af70f$var$calcBezier = function(t, a1, a2) {
    return (($11d663dba55af70f$var$a(a1, a2) * t + $11d663dba55af70f$var$b(a1, a2)) * t + $11d663dba55af70f$var$c(a1)) * t;
};
var $11d663dba55af70f$var$getSlope = function(t, a1, a2) {
    return 3.0 * $11d663dba55af70f$var$a(a1, a2) * t * t + 2.0 * $11d663dba55af70f$var$b(a1, a2) * t + $11d663dba55af70f$var$c(a1);
};
var $11d663dba55af70f$var$subdivisionPrecision = 0.0000001;
var $11d663dba55af70f$var$subdivisionMaxIterations = 10;
function $11d663dba55af70f$var$binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $11d663dba55af70f$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $11d663dba55af70f$var$subdivisionPrecision && ++i < $11d663dba55af70f$var$subdivisionMaxIterations);
    return currentT;
}
var $11d663dba55af70f$var$newtonIterations = 8;
var $11d663dba55af70f$var$newtonMinSlope = 0.001;
function $11d663dba55af70f$var$newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $11d663dba55af70f$var$newtonIterations; ++i){
        var currentSlope = $11d663dba55af70f$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $11d663dba55af70f$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
}
var $11d663dba55af70f$var$kSplineTableSize = 11;
var $11d663dba55af70f$var$kSampleStepSize = 1.0 / ($11d663dba55af70f$var$kSplineTableSize - 1.0);
function $11d663dba55af70f$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    if (mX1 === mY1 && mX2 === mY2) return 0, $lyEGJ.linear;
    var sampleValues = new Float32Array($11d663dba55af70f$var$kSplineTableSize);
    for(var i = 0; i < $11d663dba55af70f$var$kSplineTableSize; ++i)sampleValues[i] = $11d663dba55af70f$var$calcBezier(i * $11d663dba55af70f$var$kSampleStepSize, mX1, mX2);
    function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $11d663dba55af70f$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $11d663dba55af70f$var$kSampleStepSize;
        --currentSample;
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $11d663dba55af70f$var$kSampleStepSize;
        var initialSlope = $11d663dba55af70f$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $11d663dba55af70f$var$newtonMinSlope) return $11d663dba55af70f$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        else if (initialSlope === 0.0) return guessForT;
        else return $11d663dba55af70f$var$binarySubdivide(aX, intervalStart, intervalStart + $11d663dba55af70f$var$kSampleStepSize, mX1, mX2);
    }
    return function(t) {
        return t === 0 || t === 1 ? t : $11d663dba55af70f$var$calcBezier(getTForX(t), mY1, mY2);
    };
}

});


parcelRegister("GGpy3", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $0804d25028772388$export$65676b58b122bc38; });

var $fh0dC = parcelRequire("fh0dC");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $0804d25028772388$export$65676b58b122bc38 = function(key, value) {
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (key === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    (0, $fh0dC.complex).test(value) && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});

parcelRegister("5cznx", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $3c99843817615918$export$262124b154b9f1c0; });

var $S3LFa = parcelRequire("S3LFa");

var $ftmeo = parcelRequire("ftmeo");
var $3c99843817615918$export$2577c2184b2254d3 = function() {
    return {
        type: "spring",
        stiffness: 500,
        damping: 25,
        restDelta: 0.5,
        restSpeed: 10
    };
};
var $3c99843817615918$export$a743142a31c132c = function(to) {
    return {
        type: "spring",
        stiffness: 550,
        damping: to === 0 ? 2 * Math.sqrt(550) : 30,
        restDelta: 0.01,
        restSpeed: 10
    };
};
var $3c99843817615918$export$c2d663fbb86d66d6 = function() {
    return {
        type: "keyframes",
        ease: "linear",
        duration: 0.3
    };
};
var $3c99843817615918$var$keyframes = function(values) {
    return {
        type: "keyframes",
        duration: 0.8,
        values: values
    };
};
var $3c99843817615918$var$defaultTransitions = {
    x: $3c99843817615918$export$2577c2184b2254d3,
    y: $3c99843817615918$export$2577c2184b2254d3,
    z: $3c99843817615918$export$2577c2184b2254d3,
    rotate: $3c99843817615918$export$2577c2184b2254d3,
    rotateX: $3c99843817615918$export$2577c2184b2254d3,
    rotateY: $3c99843817615918$export$2577c2184b2254d3,
    rotateZ: $3c99843817615918$export$2577c2184b2254d3,
    scaleX: $3c99843817615918$export$a743142a31c132c,
    scaleY: $3c99843817615918$export$a743142a31c132c,
    scale: $3c99843817615918$export$a743142a31c132c,
    opacity: $3c99843817615918$export$c2d663fbb86d66d6,
    backgroundColor: $3c99843817615918$export$c2d663fbb86d66d6,
    color: $3c99843817615918$export$c2d663fbb86d66d6,
    default: $3c99843817615918$export$a743142a31c132c
};
var $3c99843817615918$export$262124b154b9f1c0 = function(valueKey, to) {
    var transitionFactory;
    if ((0, $ftmeo.isKeyframesTarget)(to)) transitionFactory = $3c99843817615918$var$keyframes;
    else transitionFactory = $3c99843817615918$var$defaultTransitions[valueKey] || $3c99843817615918$var$defaultTransitions.default;
    return (0, $S3LFa.__assign)({
        to: to
    }, transitionFactory(to));
};

});

parcelRegister("eaFQn", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $a5127523f58b6cd6$export$cea0cedcb94873b5; });

var $fh0dC = parcelRequire("fh0dC");
var $fOIPA = parcelRequire("fOIPA");

var $7Wu8u = parcelRequire("7Wu8u");
function $a5127523f58b6cd6$export$cea0cedcb94873b5(key, value) {
    var _a;
    var defaultValueType = (0, $7Wu8u.getDefaultValueType)(key);
    if (defaultValueType !== (0, $fOIPA.filter)) defaultValueType = (0, $fh0dC.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
}

});
parcelRegister("fOIPA", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $b83e4d0ddbc5e6c0$export$3dea766d36a8935f; });

var $S3LFa = parcelRequire("S3LFa");

var $fh0dC = parcelRequire("fh0dC");

var $eYw7E = parcelRequire("eYw7E");
var $b83e4d0ddbc5e6c0$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $b83e4d0ddbc5e6c0$var$applyDefaultFilter(v) {
    var _a = v.slice(0, -1).split("("), name = _a[0], value = _a[1];
    if (name === "drop-shadow") return v;
    var number = (value.match((0, $eYw7E.floatRegex)) || [])[0];
    if (!number) return v;
    var unit = value.replace(number, "");
    var defaultValue = $b83e4d0ddbc5e6c0$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
var $b83e4d0ddbc5e6c0$var$functionRegex = /([a-z-]*)\(.*?\)/g;
var $b83e4d0ddbc5e6c0$export$3dea766d36a8935f = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, (0, $fh0dC.complex)), {
    getAnimatableNone: function(v) {
        var functions = v.match($b83e4d0ddbc5e6c0$var$functionRegex);
        return functions ? functions.map($b83e4d0ddbc5e6c0$var$applyDefaultFilter).join(" ") : v;
    }
});

});

parcelRegister("7Wu8u", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $5c85538e517c4e79$export$67d1babe0338d23b; });

var $S3LFa = parcelRequire("S3LFa");

var $ahu22 = parcelRequire("ahu22");
var $fOIPA = parcelRequire("fOIPA");

var $22TE3 = parcelRequire("22TE3");
/**
 * A map of default value types for common values
 */ var $5c85538e517c4e79$export$98cd7c72c5a731fb = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, (0, $22TE3.numberValueTypes)), {
    // Color props
    color: (0, $ahu22.color),
    backgroundColor: (0, $ahu22.color),
    outlineColor: (0, $ahu22.color),
    fill: (0, $ahu22.color),
    stroke: (0, $ahu22.color),
    // Border props
    borderColor: (0, $ahu22.color),
    borderTopColor: (0, $ahu22.color),
    borderRightColor: (0, $ahu22.color),
    borderBottomColor: (0, $ahu22.color),
    borderLeftColor: (0, $ahu22.color),
    filter: (0, $fOIPA.filter),
    WebkitFilter: (0, $fOIPA.filter)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $5c85538e517c4e79$export$67d1babe0338d23b = function(key) {
    return $5c85538e517c4e79$export$98cd7c72c5a731fb[key];
};

});



parcelRegister("f2U56", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $af428b7beec9ef10$export$1f61c53461aff4a5; });
$parcel$export(module.exports, "checkTargetForNewValues", function () { return $af428b7beec9ef10$export$6afbed164019a54c; });
$parcel$export(module.exports, "getOrigin", function () { return $af428b7beec9ef10$export$5a759dc7a1cfb72a; });

var $S3LFa = parcelRequire("S3LFa");

var $fh0dC = parcelRequire("fh0dC");

var $jhpKV = parcelRequire("jhpKV");

var $cpd6c = parcelRequire("cpd6c");

var $7PUVa = parcelRequire("7PUVa");

var $eaFQn = parcelRequire("eaFQn");

var $44QfV = parcelRequire("44QfV");

var $7NspE = parcelRequire("7NspE");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $af428b7beec9ef10$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $7PUVa.motionValue)(value));
}
function $af428b7beec9ef10$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $7NspE.resolveVariant)(visualElement, definition);
    var _a = resolved ? visualElement.makeTargetAnimatable(resolved, false) : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b;
    _a.transition;
    var target = (0, $S3LFa.__rest)(_a, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, target), transitionEnd);
    for(var key in target){
        var value = (0, $cpd6c.resolveFinalValueInKeyframes)(target[key]);
        $af428b7beec9ef10$var$setMotionValue(visualElement, key, value);
    }
}
function $af428b7beec9ef10$var$setVariants(visualElement, variantLabels) {
    var reversedLabels = (0, $S3LFa.__spreadArray)([], (0, $S3LFa.__read)(variantLabels)).reverse();
    reversedLabels.forEach(function(key) {
        var _a;
        var variant = visualElement.getVariant(key);
        variant && $af428b7beec9ef10$export$1f61c53461aff4a5(visualElement, variant);
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach(function(child) {
            $af428b7beec9ef10$var$setVariants(child, variantLabels);
        });
    });
}
function $af428b7beec9ef10$export$b7771d60d308862f(visualElement, definition) {
    if (Array.isArray(definition)) return $af428b7beec9ef10$var$setVariants(visualElement, definition);
    else if (typeof definition === "string") return $af428b7beec9ef10$var$setVariants(visualElement, [
        definition
    ]);
    else $af428b7beec9ef10$export$1f61c53461aff4a5(visualElement, definition);
}
function $af428b7beec9ef10$export$6afbed164019a54c(visualElement, target, origin) {
    var _a, _b, _c;
    var _d;
    var newValueKeys = Object.keys(target).filter(function(key) {
        return !visualElement.hasValue(key);
    });
    var numNewValues = newValueKeys.length;
    if (!numNewValues) return;
    for(var i = 0; i < numNewValues; i++){
        var key = newValueKeys[i];
        var targetValue = target[key];
        var value = null;
        /**
         * If the target is a series of keyframes, we can use the first value
         * in the array. If this first value is null, we'll still need to read from the DOM.
         */ if (Array.isArray(targetValue)) value = targetValue[0];
        /**
         * If the target isn't keyframes, or the first keyframe was null, we need to
         * first check if an origin value was explicitly defined in the transition as "from",
         * if not read the value from the DOM. As an absolute fallback, take the defined target value.
         */ if (value === null) value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
        /**
         * If value is still undefined or null, ignore it. Preferably this would throw,
         * but this was causing issues in Framer.
         */ if (value === undefined || value === null) continue;
        if (typeof value === "string" && (0, $jhpKV.isNumericalString)(value)) // If this is a number read as a string, ie "0" or "200", convert it to a number
        value = parseFloat(value);
        else if (!(0, $44QfV.findValueType)(value) && (0, $fh0dC.complex).test(targetValue)) value = (0, $eaFQn.getAnimatableNone)(key, targetValue);
        visualElement.addValue(key, (0, $7PUVa.motionValue)(value));
        (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : _d[key] = value;
        visualElement.setBaseTarget(key, value);
    }
}
function $af428b7beec9ef10$export$c3befe8e18686628(key, transition) {
    if (!transition) return;
    var valueTransition = transition[key] || transition["default"] || transition;
    return valueTransition.from;
}
function $af428b7beec9ef10$export$5a759dc7a1cfb72a(target, transition, visualElement) {
    var _a, _b;
    var origin = {};
    for(var key in target)origin[key] = (_a = $af428b7beec9ef10$export$c3befe8e18686628(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
    return origin;
}

});
parcelRegister("jhpKV", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $e0939571b5227026$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $e0939571b5227026$export$65583ed5a868f2d9 = function(v) {
    return /^\-?\d*\.?\d+$/.test(v);
};

});

parcelRegister("7PUVa", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $5b49732a9b4abce6$export$ce8bdc721e76545f; });

var $iYUpa = parcelRequire("iYUpa");

var $d0crj = parcelRequire("d0crj");

var $2e2Mk = parcelRequire("2e2Mk");
var $5b49732a9b4abce6$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $5b49732a9b4abce6$export$8cea36d14ee64562 = /** @class */ function() {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ function MotionValue(init) {
        var _this = this;
        /**
         * Duration, in milliseconds, since last updating frame.
         *
         * @internal
         */ this.timeDelta = 0;
        /**
         * Timestamp of the last time this `MotionValue` was updated.
         *
         * @internal
         */ this.lastUpdated = 0;
        /**
         * Functions to notify when the `MotionValue` updates.
         *
         * @internal
         */ this.updateSubscribers = new (0, $2e2Mk.SubscriptionManager)();
        /**
         * Functions to notify when the velocity updates.
         *
         * @internal
         */ this.velocityUpdateSubscribers = new (0, $2e2Mk.SubscriptionManager)();
        /**
         * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
         *
         * @internal
         */ this.renderSubscribers = new (0, $2e2Mk.SubscriptionManager)();
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = false;
        this.updateAndNotify = function(v, render) {
            if (render === void 0) render = true;
            _this.prev = _this.current;
            _this.current = v;
            // Update timestamp
            var _a = (0, $iYUpa.getFrameData)(), delta = _a.delta, timestamp = _a.timestamp;
            if (_this.lastUpdated !== timestamp) {
                _this.timeDelta = delta;
                _this.lastUpdated = timestamp;
                (0, $iYUpa.default).postRender(_this.scheduleVelocityCheck);
            }
            // Update update subscribers
            if (_this.prev !== _this.current) _this.updateSubscribers.notify(_this.current);
            // Update velocity subscribers
            if (_this.velocityUpdateSubscribers.getSize()) _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            // Update render subscribers
            if (render) _this.renderSubscribers.notify(_this.current);
        };
        /**
         * Schedule a velocity check for the next frame.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.scheduleVelocityCheck = function() {
            return (0, $iYUpa.default).postRender(_this.velocityCheck);
        };
        /**
         * Updates `prev` with `current` if the value hasn't been updated this frame.
         * This ensures velocity calculations return `0`.
         *
         * This is an instanced and bound function to prevent generating a new
         * function once per frame.
         *
         * @internal
         */ this.velocityCheck = function(_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
                _this.velocityUpdateSubscribers.notify(_this.getVelocity());
            }
        };
        this.hasAnimated = false;
        this.prev = this.current = init;
        this.canTrackVelocity = $5b49732a9b4abce6$var$isFloat(this.current);
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * @library
     *
     * ```jsx
     * function MyComponent() {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <Frame x={x} />
     * }
     * ```
     *
     * @motion
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.onChange(updateOpacity)
     *     const unsubscribeY = y.onChange(updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @internalremarks
     *
     * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
     *
     * ```jsx
     * useOnChange(x, () => {})
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @public
     */ MotionValue.prototype.onChange = function(subscription) {
        return this.updateSubscribers.add(subscription);
    };
    MotionValue.prototype.clearListeners = function() {
        this.updateSubscribers.clear();
    };
    /**
     * Adds a function that will be notified when the `MotionValue` requests a render.
     *
     * @param subscriber - A function that's provided the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @internal
     */ MotionValue.prototype.onRenderRequest = function(subscription) {
        // Render immediately
        subscription(this.get());
        return this.renderSubscribers.add(subscription);
    };
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ MotionValue.prototype.attach = function(passiveEffect) {
        this.passiveEffect = passiveEffect;
    };
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ MotionValue.prototype.set = function(v, render) {
        if (render === void 0) render = true;
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    };
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ MotionValue.prototype.get = function() {
        return this.current;
    };
    /**
     * @public
     */ MotionValue.prototype.getPrevious = function() {
        return this.prev;
    };
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ MotionValue.prototype.getVelocity = function() {
        // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
        return this.canTrackVelocity ? (0, $d0crj.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
    };
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ MotionValue.prototype.start = function(animation) {
        var _this = this;
        this.stop();
        return new Promise(function(resolve) {
            _this.hasAnimated = true;
            _this.stopAnimation = animation(resolve);
        }).then(function() {
            return _this.clearAnimation();
        });
    };
    /**
     * Stop the currently active animation.
     *
     * @public
     */ MotionValue.prototype.stop = function() {
        if (this.stopAnimation) this.stopAnimation();
        this.clearAnimation();
    };
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ MotionValue.prototype.isAnimating = function() {
        return !!this.stopAnimation;
    };
    MotionValue.prototype.clearAnimation = function() {
        this.stopAnimation = null;
    };
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ MotionValue.prototype.destroy = function() {
        this.updateSubscribers.clear();
        this.renderSubscribers.clear();
        this.stop();
    };
    return MotionValue;
}();
/**
 * @internal
 */ function $5b49732a9b4abce6$export$ce8bdc721e76545f(init) {
    return new $5b49732a9b4abce6$export$8cea36d14ee64562(init);
}

});
parcelRegister("2e2Mk", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $19ef0b55e0c3dd93$export$e7dff9482a5fd23c; });

var $7eMnS = parcelRequire("7eMnS");
var $19ef0b55e0c3dd93$export$e7dff9482a5fd23c = /** @class */ function() {
    function SubscriptionManager() {
        this.subscriptions = [];
    }
    SubscriptionManager.prototype.add = function(handler) {
        var _this = this;
        (0, $7eMnS.addUniqueItem)(this.subscriptions, handler);
        return function() {
            return (0, $7eMnS.removeItem)(_this.subscriptions, handler);
        };
    };
    SubscriptionManager.prototype.notify = function(a, b, c) {
        var numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(var i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    };
    SubscriptionManager.prototype.getSize = function() {
        return this.subscriptions.length;
    };
    SubscriptionManager.prototype.clear = function() {
        this.subscriptions.length = 0;
    };
    return SubscriptionManager;
}();

});
parcelRegister("7eMnS", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $544f5f4622e18a21$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $544f5f4622e18a21$export$fe2d9b4e03920b4c; });
function $544f5f4622e18a21$export$20e507e47fae79fd(arr, item) {
    arr.indexOf(item) === -1 && arr.push(item);
}
function $544f5f4622e18a21$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    index > -1 && arr.splice(index, 1);
}

});



parcelRegister("44QfV", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $2f80120d92554dc8$export$950e7e59ea1ffed7; });

var $S3LFa = parcelRequire("S3LFa");

var $ahu22 = parcelRequire("ahu22");
var $fh0dC = parcelRequire("fh0dC");

var $aE3WW = parcelRequire("aE3WW");

var $j0PDY = parcelRequire("j0PDY");
/**
 * A list of all ValueTypes
 */ var $2f80120d92554dc8$var$valueTypes = (0, $S3LFa.__spreadArray)((0, $S3LFa.__spreadArray)([], (0, $S3LFa.__read)((0, $aE3WW.dimensionValueTypes))), [
    (0, $ahu22.color),
    (0, $fh0dC.complex)
]);
/**
 * Tests a value against the list of ValueTypes
 */ var $2f80120d92554dc8$export$950e7e59ea1ffed7 = function(v) {
    return $2f80120d92554dc8$var$valueTypes.find((0, $j0PDY.testValueType)(v));
};

});
parcelRegister("aE3WW", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $7c00b4218edb8a59$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $7c00b4218edb8a59$export$eefdd52e3ccae428; });

var $avwtz = parcelRequire("avwtz");
var $b7dp4 = parcelRequire("b7dp4");

var $j0PDY = parcelRequire("j0PDY");

var $4IF5m = parcelRequire("4IF5m");
/**
 * A list of value types commonly used for dimensions
 */ var $7c00b4218edb8a59$export$d176691c1998a1f5 = [
    (0, $b7dp4.number),
    (0, $avwtz.px),
    (0, $avwtz.percent),
    (0, $avwtz.degrees),
    (0, $avwtz.vw),
    (0, $avwtz.vh),
    (0, $4IF5m.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $7c00b4218edb8a59$export$eefdd52e3ccae428 = function(v) {
    return $7c00b4218edb8a59$export$d176691c1998a1f5.find((0, $j0PDY.testValueType)(v));
};

});
parcelRegister("j0PDY", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $dd7613c1feac0ac0$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ var $dd7613c1feac0ac0$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};

});

parcelRegister("4IF5m", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $36fb243007f32475$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ var $36fb243007f32475$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};

});







parcelRegister("ghUIS", function(module, exports) {

$parcel$export(module.exports, "drag", function () { return $bdba3bdbeeb3a086$export$d7d5d435647ed5a0; });

var $1o1xb = parcelRequire("1o1xb");

var $ft8Pe = parcelRequire("ft8Pe");

var $dP7E6 = parcelRequire("dP7E6");
var $bdba3bdbeeb3a086$export$d7d5d435647ed5a0 = {
    pan: (0, $dP7E6.makeRenderlessComponent)((0, $ft8Pe.usePanGesture)),
    drag: (0, $dP7E6.makeRenderlessComponent)((0, $1o1xb.useDrag))
};

});
parcelRegister("1o1xb", function(module, exports) {

$parcel$export(module.exports, "useDrag", function () { return $102938fe874e596c$export$7941f8aafa4b6021; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $ixf53 = parcelRequire("ixf53");

var $5Tk7w = parcelRequire("5Tk7w");

var $7nP7f = parcelRequire("7nP7f");
/**
 * A hook that allows an element to be dragged.
 *
 * @internal
 */ function $102938fe874e596c$export$7941f8aafa4b6021(props) {
    var groupDragControls = props.dragControls, visualElement = props.visualElement;
    var transformPagePoint = (0, $4YNlq.useContext)((0, $ixf53.MotionConfigContext)).transformPagePoint;
    var dragControls = (0, $7nP7f.useConstant)(function() {
        return new (0, $5Tk7w.VisualElementDragControls)({
            visualElement: visualElement
        });
    });
    dragControls.setProps((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, props), {
        transformPagePoint: transformPagePoint
    }));
    // If we've been provided a DragControls for manual control over the drag gesture,
    // subscribe this component to it on mount.
    (0, $4YNlq.useEffect)(function() {
        return groupDragControls && groupDragControls.subscribe(dragControls);
    }, [
        dragControls
    ]);
    // Mount the drag controls with the visualElement
    (0, $4YNlq.useEffect)(function() {
        return dragControls.mount(visualElement);
    }, []);
}

});
parcelRegister("5Tk7w", function(module, exports) {

$parcel$export(module.exports, "VisualElementDragControls", function () { return $44a1b24d49385bd1$export$86bff71f18910307; });

var $S3LFa = parcelRequire("S3LFa");

var $dnSYc = parcelRequire("dnSYc");

var $9X3dA = parcelRequire("9X3dA");

var $a9iKN = parcelRequire("a9iKN");

var $d1tA5 = parcelRequire("d1tA5");

var $3Nx2Z = parcelRequire("3Nx2Z");

var $kGUeI = parcelRequire("kGUeI");

var $3ClZV = parcelRequire("3ClZV");

var $73ZdR = parcelRequire("73ZdR");

var $1EIFq = parcelRequire("1EIFq");

var $5MCZJ = parcelRequire("5MCZJ");

var $d1Jwd = parcelRequire("d1Jwd");

var $6EC5A = parcelRequire("6EC5A");

var $9OqCr = parcelRequire("9OqCr");

var $9qF7e = parcelRequire("9qF7e");

var $1MwKT = parcelRequire("1MwKT");

var $4hJwG = parcelRequire("4hJwG");

var $jgyEn = parcelRequire("jgyEn");

var $d5QYa = parcelRequire("d5QYa");

var $22P90 = parcelRequire("22P90");

var $iYUpa = parcelRequire("iYUpa");
var $44a1b24d49385bd1$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ var $44a1b24d49385bd1$var$lastPointerEvent;
var $44a1b24d49385bd1$export$86bff71f18910307 = /** @class */ function() {
    function VisualElementDragControls(_a) {
        var visualElement = _a.visualElement;
        /**
         * Track whether we're currently dragging.
         *
         * @internal
         */ this.isDragging = false;
        /**
         * The current direction of drag, or `null` if both.
         *
         * @internal
         */ this.currentDirection = null;
        /**
         * The permitted boundaries of travel, in pixels.
         *
         * @internal
         */ this.constraints = false;
        /**
         * The per-axis resolved elastic values.
         *
         * @internal
         */ this.elastic = (0, $73ZdR.axisBox)();
        /**
         * A reference to the host component's latest props.
         *
         * @internal
         */ this.props = {};
        /**
         * @internal
         */ this.hasMutatedConstraints = false;
        /**
         * Track the initial position of the cursor relative to the dragging element
         * when dragging starts as a value of 0-1 on each axis. We then use this to calculate
         * an ideal bounding box for the VisualElement renderer to project into every frame.
         *
         * @internal
         */ this.cursorProgress = {
            x: 0.5,
            y: 0.5
        };
        // When updating _dragX, or _dragY instead of the VisualElement,
        // persist their values between drag gestures.
        this.originPoint = {};
        // This is a reference to the global drag gesture lock, ensuring only one component
        // can "capture" the drag of one or both axes.
        // TODO: Look into moving this into pansession?
        this.openGlobalLock = null;
        /**
         * @internal
         */ this.panSession = null;
        this.visualElement = visualElement;
        this.visualElement.enableLayoutProjection();
        $44a1b24d49385bd1$export$f0a15892c27dc07c.set(visualElement, this);
    }
    /**
     * Instantiate a PanSession for the drag gesture
     *
     * @public
     */ VisualElementDragControls.prototype.start = function(originEvent, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c, cursorProgress = _b.cursorProgress;
        var onSessionStart = function(event) {
            var _a;
            // Stop any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            _this.stopMotion();
            /**
             * Save the initial point. We'll use this to calculate the pointer's position rather
             * than the one we receive when the gesture actually starts. By then, the pointer will
             * have already moved, and the perception will be of the pointer "slipping" across the element
             */ var initialPoint = (0, $3ClZV.getViewportPointFromEvent)(event).point;
            (_a = _this.cancelLayout) === null || _a === void 0 || _a.call(_this);
            _this.cancelLayout = (0, $22P90.batchLayout)(function(read, write) {
                var ancestors = (0, $1MwKT.collectProjectingAncestors)(_this.visualElement);
                var children = (0, $1MwKT.collectProjectingChildren)(_this.visualElement);
                var tree = (0, $S3LFa.__spreadArray)((0, $S3LFa.__spreadArray)([], (0, $S3LFa.__read)(ancestors)), (0, $S3LFa.__read)(children));
                var hasManuallySetCursorOrigin = false;
                /**
                 * Apply a simple lock to the projection target. This ensures no animations
                 * can run on the projection box while this lock is active.
                 */ _this.isLayoutDrag() && _this.visualElement.lockProjectionTarget();
                write(function() {
                    tree.forEach(function(element) {
                        return element.resetTransform();
                    });
                });
                read(function() {
                    (0, $1MwKT.updateLayoutMeasurement)(_this.visualElement);
                    children.forEach((0, $1MwKT.updateLayoutMeasurement));
                });
                write(function() {
                    tree.forEach(function(element) {
                        return element.restoreTransform();
                    });
                    if (snapToCursor) hasManuallySetCursorOrigin = _this.snapToCursor(initialPoint);
                });
                read(function() {
                    var isRelativeDrag = Boolean(_this.getAxisMotionValue("x") && !_this.isExternalDrag());
                    if (!isRelativeDrag) _this.visualElement.rebaseProjectionTarget(true, _this.visualElement.measureViewportBox(false));
                    _this.visualElement.scheduleUpdateLayoutProjection();
                    /**
                     * When dragging starts, we want to find where the cursor is relative to the bounding box
                     * of the element. Every frame, we calculate a new bounding box using this relative position
                     * and let the visualElement renderer figure out how to reproject the element into this bounding
                     * box.
                     *
                     * By doing it this way, rather than applying an x/y transform directly to the element,
                     * we can ensure the component always visually sticks to the cursor as we'd expect, even
                     * if the DOM element itself changes layout as a result of React updates the user might
                     * make based on the drag position.
                     */ var projection = _this.visualElement.projection;
                    (0, $1EIFq.eachAxis)(function(axis) {
                        if (!hasManuallySetCursorOrigin) {
                            var _a = projection.target[axis], min = _a.min, max = _a.max;
                            _this.cursorProgress[axis] = cursorProgress ? cursorProgress[axis] : (0, $4hJwG.progress)(min, max, initialPoint[axis]);
                        }
                        /**
                         * If we have external drag MotionValues, record their origin point. On pointermove
                         * we'll apply the pan gesture offset directly to this value.
                         */ var axisValue = _this.getAxisMotionValue(axis);
                        if (axisValue) _this.originPoint[axis] = axisValue.get();
                    });
                });
                write(function() {
                    (0, $iYUpa.flushSync).update();
                    (0, $iYUpa.flushSync).preRender();
                    (0, $iYUpa.flushSync).render();
                    (0, $iYUpa.flushSync).postRender();
                });
                read(function() {
                    return _this.resolveDragConstraints();
                });
            });
        };
        var onStart = function(event, info) {
            var _a, _b, _c;
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            var _d = _this.props, drag = _d.drag, dragPropagation = _d.dragPropagation;
            if (drag && !dragPropagation) {
                if (_this.openGlobalLock) _this.openGlobalLock();
                _this.openGlobalLock = (0, $a9iKN.getGlobalLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!_this.openGlobalLock) return;
            }
            (0, $22P90.flushLayout)();
            // Set current drag status
            _this.isDragging = true;
            _this.currentDirection = null;
            // Fire onDragStart event
            (_b = (_a = _this.props).onDragStart) === null || _b === void 0 || _b.call(_a, event, info);
            (_c = _this.visualElement.animationState) === null || _c === void 0 || _c.setActive((0, $9qF7e.AnimationType).Drag, true);
        };
        var onMove = function(event, info) {
            var _a, _b, _c, _d;
            var _e = _this.props, dragPropagation = _e.dragPropagation, dragDirectionLock = _e.dragDirectionLock;
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !_this.openGlobalLock) return;
            var offset = info.offset;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && _this.currentDirection === null) {
                _this.currentDirection = $44a1b24d49385bd1$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (_this.currentDirection !== null) (_b = (_a = _this.props).onDirectionLock) === null || _b === void 0 || _b.call(_a, _this.currentDirection);
                return;
            }
            // Update each point with the latest position
            _this.updateAxis("x", info.point, offset);
            _this.updateAxis("y", info.point, offset);
            // Fire onDrag event
            (_d = (_c = _this.props).onDrag) === null || _d === void 0 || _d.call(_c, event, info);
            // Update the last pointer event
            $44a1b24d49385bd1$var$lastPointerEvent = event;
        };
        var onSessionEnd = function(event, info) {
            return _this.stop(event, info);
        };
        var transformPagePoint = this.props.transformPagePoint;
        this.panSession = new (0, $9X3dA.PanSession)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd
        }, {
            transformPagePoint: transformPagePoint
        });
    };
    VisualElementDragControls.prototype.resolveDragConstraints = function() {
        var _this = this;
        var _a = this.props, dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
        var layout = this.visualElement.getLayoutState().layoutCorrected;
        if (dragConstraints) this.constraints = (0, $d1tA5.isRefObject)(dragConstraints) ? this.resolveRefConstraints(layout, dragConstraints) : (0, $5MCZJ.calcRelativeConstraints)(layout, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $5MCZJ.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (this.constraints && !this.hasMutatedConstraints) (0, $1EIFq.eachAxis)(function(axis) {
            if (_this.getAxisMotionValue(axis)) _this.constraints[axis] = (0, $5MCZJ.rebaseAxisConstraints)(layout[axis], _this.constraints[axis]);
        });
    };
    VisualElementDragControls.prototype.resolveRefConstraints = function(layoutBox, constraints) {
        var _a = this.props, onMeasureDragConstraints = _a.onMeasureDragConstraints, transformPagePoint = _a.transformPagePoint;
        var constraintsElement = constraints.current;
        (0, $dnSYc.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        this.constraintsBox = (0, $d1Jwd.getBoundingBox)(constraintsElement, transformPagePoint);
        var measuredConstraints = (0, $5MCZJ.calcViewportConstraints)(layoutBox, this.constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            var userConstraints = onMeasureDragConstraints((0, $73ZdR.convertAxisBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $73ZdR.convertBoundingBoxToAxisBox)(userConstraints);
        }
        return measuredConstraints;
    };
    VisualElementDragControls.prototype.cancelDrag = function() {
        var _a, _b;
        this.visualElement.unlockProjectionTarget();
        (_a = this.cancelLayout) === null || _a === void 0 || _a.call(this);
        this.isDragging = false;
        this.panSession && this.panSession.end();
        this.panSession = null;
        if (!this.props.dragPropagation && this.openGlobalLock) {
            this.openGlobalLock();
            this.openGlobalLock = null;
        }
        (_b = this.visualElement.animationState) === null || _b === void 0 || _b.setActive((0, $9qF7e.AnimationType).Drag, false);
    };
    VisualElementDragControls.prototype.stop = function(event, info) {
        var _a, _b, _c;
        (_a = this.panSession) === null || _a === void 0 || _a.end();
        this.panSession = null;
        var isDragging = this.isDragging;
        this.cancelDrag();
        if (!isDragging) return;
        var velocity = info.velocity;
        this.animateDragEnd(velocity);
        (_c = (_b = this.props).onDragEnd) === null || _c === void 0 || _c.call(_b, event, info);
    };
    VisualElementDragControls.prototype.snapToCursor = function(point) {
        var _this = this;
        return (0, $1EIFq.eachAxis)(function(axis) {
            var drag = _this.props.drag;
            // If we're not dragging this axis, do an early return.
            if (!$44a1b24d49385bd1$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var axisValue = _this.getAxisMotionValue(axis);
            if (axisValue) {
                var box = _this.visualElement.getLayoutState().layout;
                var length_1 = box[axis].max - box[axis].min;
                var center = box[axis].min + length_1 / 2;
                var offset = point[axis] - center;
                _this.originPoint[axis] = point[axis];
                axisValue.set(offset);
            } else {
                _this.cursorProgress[axis] = 0.5;
                return true;
            }
        }).includes(true);
    };
    /**
     * Update the specified axis with the latest pointer information.
     */ VisualElementDragControls.prototype.updateAxis = function(axis, point, offset) {
        var drag = this.props.drag;
        // If we're not dragging this axis, do an early return.
        if (!$44a1b24d49385bd1$var$shouldDrag(axis, drag, this.currentDirection)) return;
        return this.getAxisMotionValue(axis) ? this.updateAxisMotionValue(axis, offset) : this.updateVisualElementAxis(axis, point);
    };
    VisualElementDragControls.prototype.updateAxisMotionValue = function(axis, offset) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!offset || !axisValue) return;
        var nextValue = this.originPoint[axis] + offset[axis];
        var update = this.constraints ? (0, $5MCZJ.applyConstraints)(nextValue, this.constraints[axis], this.elastic[axis]) : nextValue;
        axisValue.set(update);
    };
    VisualElementDragControls.prototype.updateVisualElementAxis = function(axis, point) {
        var _a;
        // Get the actual layout bounding box of the element
        var axisLayout = this.visualElement.getLayoutState().layout[axis];
        // Calculate its current length. In the future we might want to lerp this to animate
        // between lengths if the layout changes as we change the DOM
        var axisLength = axisLayout.max - axisLayout.min;
        // Get the initial progress that the pointer sat on this axis on gesture start.
        var axisProgress = this.cursorProgress[axis];
        // Calculate a new min point based on the latest pointer position, constraints and elastic
        var min = (0, $5MCZJ.calcConstrainedMinPoint)(point[axis], axisLength, axisProgress, (_a = this.constraints) === null || _a === void 0 ? void 0 : _a[axis], this.elastic[axis]);
        // Update the axis viewport target with this new min and the length
        this.visualElement.setProjectionTargetAxis(axis, min, min + axisLength);
    };
    VisualElementDragControls.prototype.setProps = function(_a) {
        var _b = _a.drag, drag = _b === void 0 ? false : _b, _c = _a.dragDirectionLock, dragDirectionLock = _c === void 0 ? false : _c, _d = _a.dragPropagation, dragPropagation = _d === void 0 ? false : _d, _e = _a.dragConstraints, dragConstraints = _e === void 0 ? false : _e, _f = _a.dragElastic, dragElastic = _f === void 0 ? (0, $5MCZJ.defaultElastic) : _f, _g = _a.dragMomentum, dragMomentum = _g === void 0 ? true : _g, remainingProps = (0, $S3LFa.__rest)(_a, [
            "drag",
            "dragDirectionLock",
            "dragPropagation",
            "dragConstraints",
            "dragElastic",
            "dragMomentum"
        ]);
        this.props = (0, $S3LFa.__assign)({
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        }, remainingProps);
    };
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - If the component will perform layout animations, we output the gesture to the component's
     *      visual bounding box
     * - Otherwise, we apply the delta to the x/y motion values.
     */ VisualElementDragControls.prototype.getAxisMotionValue = function(axis) {
        var _a = this.props, layout = _a.layout, layoutId = _a.layoutId;
        var dragKey = "_drag" + axis.toUpperCase();
        if (this.props[dragKey]) return this.props[dragKey];
        else if (!layout && layoutId === undefined) return this.visualElement.getValue(axis, 0);
    };
    VisualElementDragControls.prototype.isLayoutDrag = function() {
        return !this.getAxisMotionValue("x");
    };
    VisualElementDragControls.prototype.isExternalDrag = function() {
        var _a = this.props, _dragX = _a._dragX, _dragY = _a._dragY;
        return _dragX || _dragY;
    };
    VisualElementDragControls.prototype.animateDragEnd = function(velocity) {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition;
        /**
         * Everything beyond the drag gesture should be performed with
         * relative projection so children stay in sync with their parent element.
         */ var isRelative = (0, $jgyEn.convertToRelativeProjection)(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag());
        /**
         * If we had previously resolved constraints relative to the viewport,
         * we need to also convert those to a relative coordinate space for the animation
         */ var constraints = this.constraints || {};
        if (isRelative && Object.keys(constraints).length && this.isLayoutDrag()) {
            var projectionParent = this.visualElement.getProjectionParent();
            if (projectionParent) {
                var relativeConstraints_1 = (0, $d5QYa.calcRelativeOffset)(projectionParent.projection.targetFinal, constraints);
                (0, $1EIFq.eachAxis)(function(axis) {
                    var _a = relativeConstraints_1[axis], min = _a.min, max = _a.max;
                    constraints[axis] = {
                        min: isNaN(min) ? undefined : min,
                        max: isNaN(max) ? undefined : max
                    };
                });
            }
        }
        var momentumAnimations = (0, $1EIFq.eachAxis)(function(axis) {
            var _a;
            if (!$44a1b24d49385bd1$var$shouldDrag(axis, drag, _this.currentDirection)) return;
            var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ var bounceStiffness = dragElastic ? 200 : 1000000;
            var bounceDamping = dragElastic ? 40 : 10000000;
            var inertia = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition), transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return _this.getAxisMotionValue(axis) ? _this.startAxisValueAnimation(axis, inertia) : _this.visualElement.startLayoutAnimation(axis, inertia, isRelative);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(function() {
            var _a, _b;
            (_b = (_a = _this.props).onDragTransitionEnd) === null || _b === void 0 || _b.call(_a);
        });
    };
    VisualElementDragControls.prototype.stopMotion = function() {
        var _this = this;
        (0, $1EIFq.eachAxis)(function(axis) {
            var axisValue = _this.getAxisMotionValue(axis);
            axisValue ? axisValue.stop() : _this.visualElement.stopLayoutAnimation();
        });
    };
    VisualElementDragControls.prototype.startAxisValueAnimation = function(axis, transition) {
        var axisValue = this.getAxisMotionValue(axis);
        if (!axisValue) return;
        var currentValue = axisValue.get();
        axisValue.set(currentValue);
        axisValue.set(currentValue); // Set twice to hard-reset velocity
        return (0, $9OqCr.startAnimation)(axis, axisValue, 0, transition);
    };
    VisualElementDragControls.prototype.scalePoint = function() {
        var _this = this;
        var _a = this.props, drag = _a.drag, dragConstraints = _a.dragConstraints;
        if (!(0, $d1tA5.isRefObject)(dragConstraints) || !this.constraintsBox) return;
        // Stop any current animations as there can be some visual glitching if we resize mid animation
        this.stopMotion();
        // Record the relative progress of the targetBox relative to the constraintsBox
        var boxProgress = {
            x: 0,
            y: 0
        };
        (0, $1EIFq.eachAxis)(function(axis) {
            boxProgress[axis] = (0, $6EC5A.calcOrigin)(_this.visualElement.projection.target[axis], _this.constraintsBox[axis]);
        });
        /**
         * For each axis, calculate the current progress of the layout axis within the constraints.
         * Then, using the latest layout and constraints measurements, reposition the new layout axis
         * proportionally within the constraints.
         */ this.updateConstraints(function() {
            (0, $1EIFq.eachAxis)(function(axis) {
                if (!$44a1b24d49385bd1$var$shouldDrag(axis, drag, null)) return;
                // Calculate the position of the targetBox relative to the constraintsBox using the
                // previously calculated progress
                var _a = (0, $5MCZJ.calcPositionFromProgress)(_this.visualElement.projection.target[axis], _this.constraintsBox[axis], boxProgress[axis]), min = _a.min, max = _a.max;
                _this.visualElement.setProjectionTargetAxis(axis, min, max);
            });
        });
        /**
         * If any other draggable components are queuing the same tasks synchronously
         * this will wait until they've all been scheduled before flushing.
         */ setTimeout((0, $22P90.flushLayout), 1);
    };
    VisualElementDragControls.prototype.updateConstraints = function(onReady) {
        var _this = this;
        this.cancelLayout = (0, $22P90.batchLayout)(function(read, write) {
            var ancestors = (0, $1MwKT.collectProjectingAncestors)(_this.visualElement);
            write(function() {
                return ancestors.forEach(function(element) {
                    return element.resetTransform();
                });
            });
            read(function() {
                return (0, $1MwKT.updateLayoutMeasurement)(_this.visualElement);
            });
            write(function() {
                return ancestors.forEach(function(element) {
                    return element.restoreTransform();
                });
            });
            read(function() {
                _this.resolveDragConstraints();
            });
            if (onReady) write(onReady);
        });
    };
    VisualElementDragControls.prototype.mount = function(visualElement) {
        var _this = this;
        var element = visualElement.getInstance();
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ var stopPointerListener = (0, $3Nx2Z.addPointerEvent)(element, "pointerdown", function(event) {
            var _a = _this.props, drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
            drag && dragListener && _this.start(event);
        });
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ var stopResizeListener = (0, $kGUeI.addDomEvent)(window, "resize", function() {
            _this.scalePoint();
        });
        /**
         * Ensure drag constraints are resolved correctly relative to the dragging element
         * whenever its layout changes.
         */ var stopLayoutUpdateListener = visualElement.onLayoutUpdate(function() {
            if (_this.isDragging) _this.resolveDragConstraints();
        });
        /**
         * If the previous component with this same layoutId was dragging at the time
         * it was unmounted, we want to continue the same gesture on this component.
         */ var prevDragCursor = visualElement.prevDragCursor;
        if (prevDragCursor) this.start($44a1b24d49385bd1$var$lastPointerEvent, {
            cursorProgress: prevDragCursor
        });
        /**
         * Return a function that will teardown the drag gesture
         */ return function() {
            stopPointerListener === null || stopPointerListener === void 0 || stopPointerListener();
            stopResizeListener === null || stopResizeListener === void 0 || stopResizeListener();
            stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 || stopLayoutUpdateListener();
            _this.cancelDrag();
        };
    };
    return VisualElementDragControls;
}();
function $44a1b24d49385bd1$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $44a1b24d49385bd1$var$getCurrentDirection(offset, lockThreshold) {
    if (lockThreshold === void 0) lockThreshold = 10;
    var direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

});
parcelRegister("9X3dA", function(module, exports) {

$parcel$export(module.exports, "PanSession", function () { return $01dea5a88ed69a99$export$d9c66232c9c4689c; });

var $S3LFa = parcelRequire("S3LFa");

var $hQ42D = parcelRequire("hQ42D");

var $3ClZV = parcelRequire("3ClZV");

var $iYUpa = parcelRequire("iYUpa");

var $id4XH = parcelRequire("id4XH");

var $3Nx2Z = parcelRequire("3Nx2Z");

var $9wiik = parcelRequire("9wiik");
var $eiL8o = parcelRequire("eiL8o");
/**
 * @internal
 */ var $01dea5a88ed69a99$export$d9c66232c9c4689c = /** @class */ function() {
    function PanSession(event, handlers, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        this.updatePoint = function() {
            if (!(_this.lastMoveEvent && _this.lastMoveEventInfo)) return;
            var info = $01dea5a88ed69a99$var$getPanInfo(_this.lastMoveEventInfo, _this.history);
            var isPanStarted = _this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            var isDistancePastThreshold = (0, $9wiik.distance)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            var point = info.point;
            var timestamp = (0, $iYUpa.getFrameData)().timestamp;
            _this.history.push((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, point), {
                timestamp: timestamp
            }));
            var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
            if (!isPanStarted) {
                onStart && onStart(_this.lastMoveEvent, info);
                _this.startEvent = _this.lastMoveEvent;
            }
            onMove && onMove(_this.lastMoveEvent, info);
        };
        this.handlePointerMove = function(event, info) {
            _this.lastMoveEvent = event;
            _this.lastMoveEventInfo = $01dea5a88ed69a99$var$transformPoint(info, _this.transformPagePoint);
            // Because Safari doesn't trigger mouseup events when it's above a `<select>`
            if ((0, $hQ42D.isMouseEvent)(event) && event.buttons === 0) {
                _this.handlePointerUp(event, info);
                return;
            }
            // Throttle mouse move event to once per frame
            (0, $iYUpa.default).update(_this.updatePoint, true);
        };
        this.handlePointerUp = function(event, info) {
            _this.end();
            var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
            var panInfo = $01dea5a88ed69a99$var$getPanInfo($01dea5a88ed69a99$var$transformPoint(info, _this.transformPagePoint), _this.history);
            if (_this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if ((0, $hQ42D.isTouchEvent)(event) && event.touches.length > 1) return;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        var info = (0, $3ClZV.extractEventInfo)(event);
        var initialInfo = $01dea5a88ed69a99$var$transformPoint(info, this.transformPagePoint);
        var point = initialInfo.point;
        var timestamp = (0, $iYUpa.getFrameData)().timestamp;
        this.history = [
            (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, point), {
                timestamp: timestamp
            })
        ];
        var onSessionStart = handlers.onSessionStart;
        onSessionStart && onSessionStart(event, $01dea5a88ed69a99$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $eiL8o.pipe)((0, $3Nx2Z.addPointerEvent)(window, "pointermove", this.handlePointerMove), (0, $3Nx2Z.addPointerEvent)(window, "pointerup", this.handlePointerUp), (0, $3Nx2Z.addPointerEvent)(window, "pointercancel", this.handlePointerUp));
    }
    PanSession.prototype.updateHandlers = function(handlers) {
        this.handlers = handlers;
    };
    PanSession.prototype.end = function() {
        this.removeListeners && this.removeListeners();
        (0, $iYUpa.cancelSync).update(this.updatePoint);
    };
    return PanSession;
}();
function $01dea5a88ed69a99$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $01dea5a88ed69a99$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $01dea5a88ed69a99$var$getPanInfo(_a, history) {
    var point = _a.point;
    return {
        point: point,
        delta: $01dea5a88ed69a99$var$subtractPoint(point, $01dea5a88ed69a99$var$lastDevicePoint(history)),
        offset: $01dea5a88ed69a99$var$subtractPoint(point, $01dea5a88ed69a99$var$startDevicePoint(history)),
        velocity: $01dea5a88ed69a99$var$getVelocity(history, 0.1)
    };
}
function $01dea5a88ed69a99$var$startDevicePoint(history) {
    return history[0];
}
function $01dea5a88ed69a99$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $01dea5a88ed69a99$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    var i = history.length - 1;
    var timestampedPoint = null;
    var lastPoint = $01dea5a88ed69a99$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $id4XH.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
    if (time === 0) return {
        x: 0,
        y: 0
    };
    var currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

});
parcelRegister("9wiik", function(module, exports) {

$parcel$export(module.exports, "distance", function () { return $6ee54b263d7eeeed$export$9f17032d917177de; });

var $kYHY8 = parcelRequire("kYHY8");

var $7t2xb = parcelRequire("7t2xb");

var $gFVp8 = parcelRequire("gFVp8");
var $6ee54b263d7eeeed$var$distance1D = function(a, b) {
    return Math.abs(a - b);
};
function $6ee54b263d7eeeed$export$9f17032d917177de(a, b) {
    if ((0, $gFVp8.isNum)(a) && (0, $gFVp8.isNum)(b)) return $6ee54b263d7eeeed$var$distance1D(a, b);
    else if ((0, $kYHY8.isPoint)(a) && (0, $kYHY8.isPoint)(b)) {
        var xDelta = $6ee54b263d7eeeed$var$distance1D(a.x, b.x);
        var yDelta = $6ee54b263d7eeeed$var$distance1D(a.y, b.y);
        var zDelta = (0, $7t2xb.isPoint3D)(a) && (0, $7t2xb.isPoint3D)(b) ? $6ee54b263d7eeeed$var$distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
}

});
parcelRegister("kYHY8", function(module, exports) {

$parcel$export(module.exports, "isPoint", function () { return $f45b848ecba6490b$export$aff838a5553f2a92; });
var $f45b848ecba6490b$export$aff838a5553f2a92 = function(point) {
    return point.hasOwnProperty("x") && point.hasOwnProperty("y");
};

});

parcelRegister("7t2xb", function(module, exports) {

$parcel$export(module.exports, "isPoint3D", function () { return $56fd350ff0618dd2$export$319d74662aaa2966; });

var $kYHY8 = parcelRequire("kYHY8");
var $56fd350ff0618dd2$export$319d74662aaa2966 = function(point) {
    return (0, $kYHY8.isPoint)(point) && point.hasOwnProperty("z");
};

});



parcelRegister("1EIFq", function(module, exports) {

$parcel$export(module.exports, "eachAxis", function () { return $134c2cd42c7e4ffe$export$b789de563eb43b1; });
// Call a handler once for each axis
function $134c2cd42c7e4ffe$export$b789de563eb43b1(handler) {
    return [
        handler("x"),
        handler("y")
    ];
}

});

parcelRegister("5MCZJ", function(module, exports) {

$parcel$export(module.exports, "applyConstraints", function () { return $435faef5a3a62ea5$export$b3c764d3fca3ffe3; });
$parcel$export(module.exports, "calcConstrainedMinPoint", function () { return $435faef5a3a62ea5$export$365d4f5bee5334d2; });
$parcel$export(module.exports, "calcRelativeConstraints", function () { return $435faef5a3a62ea5$export$4e9195bf7793bc78; });
$parcel$export(module.exports, "calcViewportConstraints", function () { return $435faef5a3a62ea5$export$4228500f19d4cdf7; });
$parcel$export(module.exports, "calcPositionFromProgress", function () { return $435faef5a3a62ea5$export$c24202d5faacd1d9; });
$parcel$export(module.exports, "rebaseAxisConstraints", function () { return $435faef5a3a62ea5$export$e9672cc4c36a8b87; });
$parcel$export(module.exports, "defaultElastic", function () { return $435faef5a3a62ea5$export$a3366d3bac43a742; });
$parcel$export(module.exports, "resolveDragElastic", function () { return $435faef5a3a62ea5$export$7c5eaef8f4723d22; });

var $S3LFa = parcelRequire("S3LFa");

var $kA2Ry = parcelRequire("kA2Ry");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $435faef5a3a62ea5$export$b3c764d3fca3ffe3(point, _a, elastic) {
    var min = _a.min, max = _a.max;
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $kA2Ry.mix)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $kA2Ry.mix)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculates a min projection point based on a pointer, pointer progress
 * within the drag target, and constraints.
 *
 * For instance if an element was 100px width, we were dragging from 0.25
 * along this axis, the pointer is at 200px, and there were no constraints,
 * we would calculate a min projection point of 175px.
 */ function $435faef5a3a62ea5$export$365d4f5bee5334d2(point, length, progress, constraints, elastic) {
    // Calculate a min point for this axis and apply it to the current pointer
    var min = point - length * progress;
    return constraints ? $435faef5a3a62ea5$export$b3c764d3fca3ffe3(min, constraints, elastic) : min;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $435faef5a3a62ea5$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $435faef5a3a62ea5$export$4e9195bf7793bc78(layoutBox, _a) {
    var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
    return {
        x: $435faef5a3a62ea5$export$690c180aa5775042(layoutBox.x, left, right),
        y: $435faef5a3a62ea5$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $435faef5a3a62ea5$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    var _a;
    var min = constraintsAxis.min - layoutAxis.min;
    var max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) _a = (0, $S3LFa.__read)([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return {
        min: layoutAxis.min + min,
        max: layoutAxis.min + max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $435faef5a3a62ea5$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $435faef5a3a62ea5$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $435faef5a3a62ea5$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate the an axis position based on two axes and a progress value.
 */ function $435faef5a3a62ea5$export$c24202d5faacd1d9(axis, constraints, progress) {
    var axisLength = axis.max - axis.min;
    var min = (0, $kA2Ry.mix)(constraints.min, constraints.max - axisLength, progress);
    return {
        min: min,
        max: min + axisLength
    };
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $435faef5a3a62ea5$export$e9672cc4c36a8b87(layout, constraints) {
    var relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
var $435faef5a3a62ea5$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $435faef5a3a62ea5$export$7c5eaef8f4723d22(dragElastic) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $435faef5a3a62ea5$export$a3366d3bac43a742;
    return {
        x: $435faef5a3a62ea5$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $435faef5a3a62ea5$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $435faef5a3a62ea5$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $435faef5a3a62ea5$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $435faef5a3a62ea5$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $435faef5a3a62ea5$export$bbbc10b82e6c0afb(dragElastic, label) {
    var _a;
    return typeof dragElastic === "number" ? dragElastic : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
}

});

parcelRegister("d1Jwd", function(module, exports) {

$parcel$export(module.exports, "getBoundingBox", function () { return $97bead643992b58a$export$895c5e634403eaa7; });

var $73ZdR = parcelRequire("73ZdR");
/**
 * Measure and return the element bounding box.
 *
 * We convert the box into an AxisBox2D to make it easier to work with each axis
 * individually and programmatically.
 *
 * This function optionally accepts a transformPagePoint function which allows us to compensate
 * for, for instance, measuring the element within a scaled plane like a Framer devivce preview component.
 */ function $97bead643992b58a$export$895c5e634403eaa7(element, transformPagePoint) {
    var box = element.getBoundingClientRect();
    return (0, $73ZdR.convertBoundingBoxToAxisBox)((0, $73ZdR.transformBoundingBox)(box, transformPagePoint));
}

});

parcelRegister("6EC5A", function(module, exports) {

$parcel$export(module.exports, "calcOrigin", function () { return $4d840630f3bf265b$export$13abbfca044ca46d; });
$parcel$export(module.exports, "updateBoxDelta", function () { return $4d840630f3bf265b$export$1435a2beec546d2e; });
$parcel$export(module.exports, "calcRelativeBox", function () { return $4d840630f3bf265b$export$426154f9d100f99; });

var $6NMkb = parcelRequire("6NMkb");
var $9wiik = parcelRequire("9wiik");
var $kA2Ry = parcelRequire("kA2Ry");
var $4hJwG = parcelRequire("4hJwG");
var $4d840630f3bf265b$var$clampProgress = function(v) {
    return (0, $6NMkb.clamp)(0, 1, v);
};
/**
 * Returns true if the provided value is within maxDistance of the provided target
 */ function $4d840630f3bf265b$export$28d0384c4b79bde2(value, target, maxDistance) {
    if (target === void 0) target = 0;
    if (maxDistance === void 0) maxDistance = 0.01;
    return (0, $9wiik.distance)(value, target) < maxDistance;
}
function $4d840630f3bf265b$var$calcLength(axis) {
    return axis.max - axis.min;
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $4d840630f3bf265b$export$13abbfca044ca46d(source, target) {
    var origin = 0.5;
    var sourceLength = $4d840630f3bf265b$var$calcLength(source);
    var targetLength = $4d840630f3bf265b$var$calcLength(target);
    if (targetLength > sourceLength) origin = (0, $4hJwG.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $4hJwG.progress)(source.min, source.max - targetLength, target.min);
    return $4d840630f3bf265b$var$clampProgress(origin);
}
/**
 * Update the AxisDelta with a transform that projects source into target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */ function $4d840630f3bf265b$export$acf2fd1e22884f56(delta, source, target, origin) {
    if (origin === void 0) origin = 0.5;
    delta.origin = origin;
    delta.originPoint = (0, $kA2Ry.mix)(source.min, source.max, delta.origin);
    delta.scale = $4d840630f3bf265b$var$calcLength(target) / $4d840630f3bf265b$var$calcLength(source);
    if ($4d840630f3bf265b$export$28d0384c4b79bde2(delta.scale, 1, 0.0001)) delta.scale = 1;
    delta.translate = (0, $kA2Ry.mix)(target.min, target.max, delta.origin) - delta.originPoint;
    if ($4d840630f3bf265b$export$28d0384c4b79bde2(delta.translate)) delta.translate = 0;
}
/**
 * Update the BoxDelta with a transform that projects the source into the target.
 *
 * The transform `origin` is optional. If not provided, it'll be automatically
 * calculated based on the relative positions of the two bounding boxes.
 */ function $4d840630f3bf265b$export$1435a2beec546d2e(delta, source, target, origin) {
    $4d840630f3bf265b$export$acf2fd1e22884f56(delta.x, source.x, target.x, $4d840630f3bf265b$var$defaultOrigin(origin.originX));
    $4d840630f3bf265b$export$acf2fd1e22884f56(delta.y, source.y, target.y, $4d840630f3bf265b$var$defaultOrigin(origin.originY));
}
/**
 * Currently this only accepts numerical origins, measured as 0-1, but could
 * accept pixel values by comparing to the target axis.
 */ function $4d840630f3bf265b$var$defaultOrigin(origin) {
    return typeof origin === "number" ? origin : 0.5;
}
function $4d840630f3bf265b$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $4d840630f3bf265b$var$calcLength(relative);
}
function $4d840630f3bf265b$export$426154f9d100f99(projection, parentProjection) {
    $4d840630f3bf265b$export$cabef5b392704b41(projection.target.x, projection.relativeTarget.x, parentProjection.target.x);
    $4d840630f3bf265b$export$cabef5b392704b41(projection.target.y, projection.relativeTarget.y, parentProjection.target.y);
}

});

parcelRegister("jgyEn", function(module, exports) {

$parcel$export(module.exports, "convertToRelativeProjection", function () { return $e06a63c1b165bc74$export$69bccedc5101c4d1; });

var $d5QYa = parcelRequire("d5QYa");

var $1EIFq = parcelRequire("1EIFq");

var $lm5jp = parcelRequire("lm5jp");
/**
 * Returns a boolean stating whether or not we converted the projection
 * to relative projection.
 */ function $e06a63c1b165bc74$export$69bccedc5101c4d1(visualElement, isLayoutDrag) {
    if (isLayoutDrag === void 0) isLayoutDrag = true;
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent) return false;
    var offset;
    if (isLayoutDrag) {
        offset = (0, $d5QYa.calcRelativeOffset)(projectionParent.projection.target, visualElement.projection.target);
        (0, $lm5jp.removeBoxTransforms)(offset, projectionParent.getLatestValues());
    } else offset = (0, $d5QYa.calcRelativeOffset)(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    (0, $1EIFq.eachAxis)(function(axis) {
        return visualElement.setProjectionTargetAxis(axis, offset[axis].min, offset[axis].max, true);
    });
    return true;
}

});
parcelRegister("d5QYa", function(module, exports) {

$parcel$export(module.exports, "tweenAxis", function () { return $9884d49936e69ca1$export$21d180ad0c0013cb; });
$parcel$export(module.exports, "calcRelativeOffset", function () { return $9884d49936e69ca1$export$5d8b2d12fde0857a; });
$parcel$export(module.exports, "checkIfParentHasChanged", function () { return $9884d49936e69ca1$export$d1cc994fa3b9d457; });

var $kA2Ry = parcelRequire("kA2Ry");
function $9884d49936e69ca1$export$21d180ad0c0013cb(target, prev, next, p) {
    target.min = (0, $kA2Ry.mix)(prev.min, next.min, p);
    target.max = (0, $kA2Ry.mix)(prev.max, next.max, p);
}
function $9884d49936e69ca1$export$58fa21d412109d6b(parent, child) {
    return {
        min: child.min - parent.min,
        max: child.max - parent.min
    };
}
function $9884d49936e69ca1$export$5d8b2d12fde0857a(parent, child) {
    return {
        x: $9884d49936e69ca1$export$58fa21d412109d6b(parent.x, child.x),
        y: $9884d49936e69ca1$export$58fa21d412109d6b(parent.y, child.y)
    };
}
function $9884d49936e69ca1$export$d1cc994fa3b9d457(prev, next) {
    var prevId = prev.getLayoutId();
    var nextId = next.getLayoutId();
    return prevId !== nextId || nextId === undefined && prev !== next;
}

});

parcelRegister("lm5jp", function(module, exports) {

$parcel$export(module.exports, "resetBox", function () { return $f8bfc5ee89d7c888$export$d7ad1d43f7ab13a6; });
$parcel$export(module.exports, "applyBoxTransforms", function () { return $f8bfc5ee89d7c888$export$c8fdd2c80d7384dd; });
$parcel$export(module.exports, "removeBoxTransforms", function () { return $f8bfc5ee89d7c888$export$73e1ad0a9694e25c; });
$parcel$export(module.exports, "applyTreeDeltas", function () { return $f8bfc5ee89d7c888$export$e2a980535c55eabb; });

var $S3LFa = parcelRequire("S3LFa");

var $kA2Ry = parcelRequire("kA2Ry");

var $9CGrz = parcelRequire("9CGrz");
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $f8bfc5ee89d7c888$export$ab0da4c5058aa6e9(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $f8bfc5ee89d7c888$export$d7ad1d43f7ab13a6(box, originBox) {
    $f8bfc5ee89d7c888$export$ab0da4c5058aa6e9(box.x, originBox.x);
    $f8bfc5ee89d7c888$export$ab0da4c5058aa6e9(box.y, originBox.y);
}
/**
 * Scales a point based on a factor and an originPoint
 */ function $f8bfc5ee89d7c888$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $f8bfc5ee89d7c888$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $f8bfc5ee89d7c888$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $f8bfc5ee89d7c888$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $f8bfc5ee89d7c888$export$e8e3a712e9ebf422(axis, translate, scale, originPoint, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    axis.min = $f8bfc5ee89d7c888$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $f8bfc5ee89d7c888$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $f8bfc5ee89d7c888$export$d80074982803af5c(box, _a) {
    var x = _a.x, y = _a.y;
    $f8bfc5ee89d7c888$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $f8bfc5ee89d7c888$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $f8bfc5ee89d7c888$export$fe9134d4e4502d7e(final, axis, transforms, _a) {
    var _b = (0, $S3LFa.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    // Copy the current axis to the final axis before mutation
    final.min = axis.min;
    final.max = axis.max;
    var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
    var originPoint = (0, $kA2Ry.mix)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $f8bfc5ee89d7c888$export$e8e3a712e9ebf422(final, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ var $f8bfc5ee89d7c888$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
var $f8bfc5ee89d7c888$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $f8bfc5ee89d7c888$export$c8fdd2c80d7384dd(finalBox, box, transforms) {
    $f8bfc5ee89d7c888$export$fe9134d4e4502d7e(finalBox.x, box.x, transforms, $f8bfc5ee89d7c888$var$xKeys);
    $f8bfc5ee89d7c888$export$fe9134d4e4502d7e(finalBox.y, box.y, transforms, $f8bfc5ee89d7c888$var$yKeys);
}
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $f8bfc5ee89d7c888$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = $f8bfc5ee89d7c888$export$2290ec7febe36dd6(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = $f8bfc5ee89d7c888$export$2290ec7febe36dd6(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $f8bfc5ee89d7c888$export$cc12a0672fae5b4a(axis, translate, scale, origin, boxScale) {
    if (translate === void 0) translate = 0;
    if (scale === void 0) scale = 1;
    if (origin === void 0) origin = 0.5;
    var originPoint = (0, $kA2Ry.mix)(axis.min, axis.max, origin) - translate;
    axis.min = $f8bfc5ee89d7c888$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $f8bfc5ee89d7c888$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $f8bfc5ee89d7c888$export$42b76f1d0d16d5b(axis, transforms, _a) {
    var _b = (0, $S3LFa.__read)(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
    $f8bfc5ee89d7c888$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale);
}
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $f8bfc5ee89d7c888$export$73e1ad0a9694e25c(box, transforms) {
    $f8bfc5ee89d7c888$export$42b76f1d0d16d5b(box.x, transforms, $f8bfc5ee89d7c888$var$xKeys);
    $f8bfc5ee89d7c888$export$42b76f1d0d16d5b(box.y, transforms, $f8bfc5ee89d7c888$var$yKeys);
}
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $f8bfc5ee89d7c888$export$e2a980535c55eabb(box, treeScale, treePath) {
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.getLayoutState().delta;
        // Incoporate each ancestor's scale into a culmulative treeScale for this component
        treeScale.x *= delta.x.scale;
        treeScale.y *= delta.y.scale;
        // Apply each ancestor's calculated delta into this component's recorded layout box
        $f8bfc5ee89d7c888$export$d80074982803af5c(box, delta);
        // If this is a draggable ancestor, also incorporate the node's transform to the layout box
        if ((0, $9CGrz.isDraggable)(node)) $f8bfc5ee89d7c888$export$c8fdd2c80d7384dd(box, box, node.getLatestValues());
    }
}

});
parcelRegister("9CGrz", function(module, exports) {

$parcel$export(module.exports, "isDraggable", function () { return $7018961296df93ff$export$fe8f97248bbe2d04; });
function $7018961296df93ff$export$fe8f97248bbe2d04(visualElement) {
    var _a = visualElement.getProps(), drag = _a.drag, _dragX = _a._dragX;
    return drag && !_dragX;
}

});





parcelRegister("ft8Pe", function(module, exports) {

$parcel$export(module.exports, "usePanGesture", function () { return $b43068fc10838b28$export$eb0f62174cac1aec; });

var $4YNlq = parcelRequire("4YNlq");

var $ixf53 = parcelRequire("ixf53");

var $g7I5q = parcelRequire("g7I5q");

var $3Nx2Z = parcelRequire("3Nx2Z");

var $9X3dA = parcelRequire("9X3dA");
/**
 *
 * @param handlers -
 * @param ref -
 *
 * @internalremarks
 * Currently this sets new pan gesture functions every render. The memo route has been explored
 * in the past but ultimately we're still creating new functions every render. An optimisation
 * to explore is creating the pan gestures and loading them into a `ref`.
 *
 * @internal
 */ function $b43068fc10838b28$export$eb0f62174cac1aec(_a) {
    var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
    var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
    var panSession = (0, $4YNlq.useRef)(null);
    var transformPagePoint = (0, $4YNlq.useContext)((0, $ixf53.MotionConfigContext)).transformPagePoint;
    var handlers = {
        onSessionStart: onPanSessionStart,
        onStart: onPanStart,
        onMove: onPan,
        onEnd: function(event, info) {
            panSession.current = null;
            onPanEnd && onPanEnd(event, info);
        }
    };
    (0, $4YNlq.useEffect)(function() {
        if (panSession.current !== null) panSession.current.updateHandlers(handlers);
    });
    function onPointerDown(event) {
        panSession.current = new (0, $9X3dA.PanSession)(event, handlers, {
            transformPagePoint: transformPagePoint
        });
    }
    (0, $3Nx2Z.usePointerEvent)(visualElement, "pointerdown", hasPanEvents && onPointerDown);
    (0, $g7I5q.useUnmountEffect)(function() {
        return panSession.current && panSession.current.end();
    });
}

});


parcelRegister("1jLjz", function(module, exports) {

$parcel$export(module.exports, "layoutAnimations", function () { return $0f5c4482263bedbd$export$eb704cf7366aa18a; });

var $jkaCu = parcelRequire("jkaCu");

var $1Ivip = parcelRequire("1Ivip");
var $0f5c4482263bedbd$export$eb704cf7366aa18a = {
    measureLayout: (0, $1Ivip.MeasureContextProvider),
    layoutAnimation: (0, $jkaCu.AnimateLayoutContextProvider)
};

});
parcelRegister("jkaCu", function(module, exports) {

$parcel$export(module.exports, "AnimateLayoutContextProvider", function () { return $e1181f6fa7d6433c$export$bd44d4206e0b4eca; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $1EIFq = parcelRequire("1EIFq");

var $9OqCr = parcelRequire("9OqCr");

var $d5QYa = parcelRequire("d5QYa");

var $ccUUQ = parcelRequire("ccUUQ");

var $ltGQn = parcelRequire("ltGQn");

var $73ZdR = parcelRequire("73ZdR");

var $baSNF = parcelRequire("baSNF");

var $fxzlq = parcelRequire("fxzlq");
var $e1181f6fa7d6433c$var$progressTarget = 1000;
var $e1181f6fa7d6433c$var$Animate = /** @class */ function(_super) {
    (0, $S3LFa.__extends)(Animate, _super);
    function Animate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * A mutable object that tracks the target viewport box
         * for the current animation frame.
         */ _this.frameTarget = (0, $73ZdR.axisBox)();
        /**
         * The current animation target, we use this to check whether to start
         * a new animation or continue the existing one.
         */ _this.currentAnimationTarget = (0, $73ZdR.axisBox)();
        /**
         * Track whether we're animating this axis.
         */ _this.isAnimating = {
            x: false,
            y: false
        };
        _this.stopAxisAnimation = {
            x: undefined,
            y: undefined
        };
        _this.isAnimatingTree = false;
        _this.animate = function(target, origin, _a) {
            if (_a === void 0) _a = {};
            var originBox = _a.originBox, targetBox = _a.targetBox, visibilityAction = _a.visibilityAction, shouldStackAnimate = _a.shouldStackAnimate, onComplete = _a.onComplete, prevParent = _a.prevParent, config = (0, $S3LFa.__rest)(_a, [
                "originBox",
                "targetBox",
                "visibilityAction",
                "shouldStackAnimate",
                "onComplete",
                "prevParent"
            ]);
            var _b = _this.props, visualElement = _b.visualElement, layout = _b.layout;
            /**
             * Early return if we've been instructed not to animate this render.
             */ if (shouldStackAnimate === false) {
                _this.isAnimatingTree = false;
                return _this.safeToRemove();
            }
            /**
             * Prioritise tree animations
             */ if (_this.isAnimatingTree && shouldStackAnimate !== true) return;
            else if (shouldStackAnimate) _this.isAnimatingTree = true;
            /**
             * Allow the measured origin (prev bounding box) and target (actual layout) to be
             * overridden by the provided config.
             */ origin = originBox || origin;
            target = targetBox || target;
            /**
             * If this element has a projecting parent, there's an opportunity to animate
             * it relatively to that parent rather than relatively to the viewport. This
             * allows us to add orchestrated animations.
             */ var isRelative = false;
            var projectionParent = visualElement.getProjectionParent();
            if (projectionParent) {
                var prevParentViewportBox = projectionParent.prevViewportBox;
                var parentLayout = projectionParent.getLayoutState().layout;
                /**
                 * If we're being provided a previous parent VisualElement by AnimateSharedLayout
                 */ if (prevParent) {
                    /**
                     * If we've been provided an explicit target box it means we're animating back
                     * to this previous parent. So we can make a relative box by comparing to the previous
                     * parent's layout
                     */ if (targetBox) parentLayout = prevParent.getLayoutState().layout;
                    /**
                     * Likewise if we've been provided an explicit origin box it means we're
                     * animating out from a different element. So we should figure out where that was
                     * on screen relative to the new parent element.
                     */ if (originBox && !(0, $d5QYa.checkIfParentHasChanged)(prevParent, projectionParent) && prevParent.prevViewportBox) prevParentViewportBox = prevParent.prevViewportBox;
                }
                if (prevParentViewportBox && $e1181f6fa7d6433c$var$isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox)) {
                    isRelative = true;
                    origin = (0, $d5QYa.calcRelativeOffset)(prevParentViewportBox, origin);
                    target = (0, $d5QYa.calcRelativeOffset)(parentLayout, target);
                }
            }
            var boxHasMoved = $e1181f6fa7d6433c$var$hasMoved(origin, target);
            var animations = (0, $1EIFq.eachAxis)(function(axis) {
                var _a, _b;
                /**
                 * If layout is set to "position", we can resize the origin box based on the target
                 * box and only animate its position.
                 */ if (layout === "position") {
                    var targetLength = target[axis].max - target[axis].min;
                    origin[axis].max = origin[axis].min + targetLength;
                }
                if (visualElement.projection.isTargetLocked) return;
                else if (visibilityAction !== undefined) visualElement.setVisibility(visibilityAction === (0, $ccUUQ.VisibilityAction).Show);
                else if (boxHasMoved) // If the box has moved, animate between it's current visual state and its
                // final state
                return _this.animateAxis(axis, target[axis], origin[axis], (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, config), {
                    isRelative: isRelative
                }));
                else {
                    (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 || _b.call(_a);
                    // If the box has remained in the same place, immediately set the axis target
                    // to the final desired state
                    return visualElement.setProjectionTargetAxis(axis, target[axis].min, target[axis].max, isRelative);
                }
            });
            // Force a render to ensure there's no flash of uncorrected bounding box.
            visualElement.syncRender();
            /**
             * If this visualElement isn't present (ie it's been removed from the tree by the user but
             * kept in by the tree by AnimatePresence) then call safeToRemove when all axis animations
             * have successfully finished.
             */ return Promise.all(animations).then(function() {
                _this.isAnimatingTree = false;
                onComplete && onComplete();
                visualElement.notifyLayoutAnimationComplete();
            });
        };
        return _this;
    }
    Animate.prototype.componentDidMount = function() {
        var _this = this;
        var visualElement = this.props.visualElement;
        visualElement.animateMotionValue = (0, $9OqCr.startAnimation);
        visualElement.enableLayoutProjection();
        this.unsubLayoutReady = visualElement.onLayoutUpdate(this.animate);
        visualElement.layoutSafeToRemove = function() {
            return _this.safeToRemove();
        };
        (0, $baSNF.addScaleCorrection)((0, $fxzlq.defaultScaleCorrectors));
    };
    Animate.prototype.componentWillUnmount = function() {
        var _this = this;
        this.unsubLayoutReady();
        (0, $1EIFq.eachAxis)(function(axis) {
            var _a, _b;
            return (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
    };
    /**
     * TODO: This manually performs animations on the visualElement's layout progress
     * values. It'd be preferable to amend the startLayoutAxisAnimation
     * API to accept more custom animations like this.
     */ Animate.prototype.animateAxis = function(axis, target, origin, _a) {
        var _this = this;
        var _b, _c;
        var _d = _a === void 0 ? {} : _a, transition = _d.transition, isRelative = _d.isRelative;
        /**
         * If we're not animating to a new target, don't run this animation
         */ if (this.isAnimating[axis] && $e1181f6fa7d6433c$var$axisIsEqual(target, this.currentAnimationTarget[axis])) return;
        (_c = (_b = this.stopAxisAnimation)[axis]) === null || _c === void 0 || _c.call(_b);
        this.isAnimating[axis] = true;
        var visualElement = this.props.visualElement;
        var frameTarget = this.frameTarget[axis];
        var layoutProgress = visualElement.getProjectionAnimationProgress()[axis];
        /**
         * Set layout progress back to 0. We set it twice to hard-reset any velocity that might
         * be re-incoporated into a subsequent spring animation.
         */ layoutProgress.clearListeners();
        layoutProgress.set(0);
        layoutProgress.set(0);
        /**
         * Create an animation function to run once per frame. This will tween the visual bounding box from
         * origin to target using the latest progress value.
         */ var frame = function() {
            // Convert the latest layoutProgress, which is a value from 0-1000, into a 0-1 progress
            var p = layoutProgress.get() / $e1181f6fa7d6433c$var$progressTarget;
            // Tween the axis and update the visualElement with the latest values
            (0, $d5QYa.tweenAxis)(frameTarget, origin, target, p);
            visualElement.setProjectionTargetAxis(axis, frameTarget.min, frameTarget.max, isRelative);
        };
        // Synchronously run a frame to ensure there's no flash of the uncorrected bounding box.
        frame();
        // Create a function to stop animation on this specific axis
        var unsubscribeProgress = layoutProgress.onChange(frame);
        this.stopAxisAnimation[axis] = function() {
            _this.isAnimating[axis] = false;
            layoutProgress.stop();
            unsubscribeProgress();
        };
        this.currentAnimationTarget[axis] = target;
        var layoutTransition = transition || visualElement.getDefaultTransition() || $e1181f6fa7d6433c$var$defaultLayoutTransition;
        // Start the animation on this axis
        var animation = (0, $9OqCr.startAnimation)(axis === "x" ? "layoutX" : "layoutY", layoutProgress, $e1181f6fa7d6433c$var$progressTarget, layoutTransition && (0, $9OqCr.getValueTransition)(layoutTransition, "layout")).then(this.stopAxisAnimation[axis]);
        return animation;
    };
    Animate.prototype.safeToRemove = function() {
        var _a, _b;
        (_b = (_a = this.props).safeToRemove) === null || _b === void 0 || _b.call(_a);
    };
    Animate.prototype.render = function() {
        return null;
    };
    return Animate;
}($4YNlq.Component);
function $e1181f6fa7d6433c$export$bd44d4206e0b4eca(props) {
    var _a = (0, $S3LFa.__read)((0, $ltGQn.usePresence)(), 2), safeToRemove = _a[1];
    return $4YNlq.createElement($e1181f6fa7d6433c$var$Animate, (0, $S3LFa.__assign)({}, props, {
        safeToRemove: safeToRemove
    }));
}
function $e1181f6fa7d6433c$var$hasMoved(a, b) {
    return !$e1181f6fa7d6433c$var$isZeroBox(a) && !$e1181f6fa7d6433c$var$isZeroBox(b) && (!$e1181f6fa7d6433c$var$axisIsEqual(a.x, b.x) || !$e1181f6fa7d6433c$var$axisIsEqual(a.y, b.y));
}
var $e1181f6fa7d6433c$var$zeroAxis = {
    min: 0,
    max: 0
};
function $e1181f6fa7d6433c$var$isZeroBox(a) {
    return $e1181f6fa7d6433c$var$axisIsEqual(a.x, $e1181f6fa7d6433c$var$zeroAxis) && $e1181f6fa7d6433c$var$axisIsEqual(a.y, $e1181f6fa7d6433c$var$zeroAxis);
}
function $e1181f6fa7d6433c$var$axisIsEqual(a, b) {
    return a.min === b.min && a.max === b.max;
}
var $e1181f6fa7d6433c$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
function $e1181f6fa7d6433c$var$isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox) {
    return prevParent || !prevParent && !(originBox || targetBox);
}

});
parcelRegister("fxzlq", function(module, exports) {

$parcel$export(module.exports, "defaultScaleCorrectors", function () { return $b5055acd372134c8$export$f5121daded6e3d5d; });

var $S3LFa = parcelRequire("S3LFa");

var $fh0dC = parcelRequire("fh0dC");
var $avwtz = parcelRequire("avwtz");

var $kA2Ry = parcelRequire("kA2Ry");

var $k5bUl = parcelRequire("k5bUl");
function $b5055acd372134c8$export$fafff692be55225d(pixels, axis) {
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ function $b5055acd372134c8$export$5eafb6257a5844c(latest, _layoutState, _a) {
    var target = _a.target;
    /**
     * If latest is a string, if it's a percentage we can return immediately as it's
     * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
     */ if (typeof latest === "string") {
        if ((0, $avwtz.px).test(latest)) latest = parseFloat(latest);
        else return latest;
    }
    /**
     * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
     * pixel value as a percentage of each axis
     */ var x = $b5055acd372134c8$export$fafff692be55225d(latest, target.x);
    var y = $b5055acd372134c8$export$fafff692be55225d(latest, target.y);
    return x + "% " + y + "%";
}
var $b5055acd372134c8$var$varToken = "_$css";
function $b5055acd372134c8$export$eb0bc629e74dcf8(latest, _a) {
    var delta = _a.delta, treeScale = _a.treeScale;
    var original = latest;
    /**
     * We need to first strip and store CSS variables from the string.
     */ var containsCSSVariables = latest.includes("var(");
    var cssVariables = [];
    if (containsCSSVariables) latest = latest.replace((0, $k5bUl.cssVariableRegex), function(match) {
        cssVariables.push(match);
        return $b5055acd372134c8$var$varToken;
    });
    var shadow = (0, $fh0dC.complex).parse(latest);
    // TODO: Doesn't support multiple shadows
    if (shadow.length > 5) return original;
    var template = (0, $fh0dC.complex).createTransformer(latest);
    var offset = typeof shadow[0] !== "number" ? 1 : 0;
    // Calculate the overall context scale
    var xScale = delta.x.scale * treeScale.x;
    var yScale = delta.y.scale * treeScale.y;
    shadow[0 + offset] /= xScale;
    shadow[1 + offset] /= yScale;
    /**
     * Ideally we'd correct x and y scales individually, but because blur and
     * spread apply to both we have to take a scale average and apply that instead.
     * We could potentially improve the outcome of this by incorporating the ratio between
     * the two scales.
     */ var averageScale = (0, $kA2Ry.mix)(xScale, yScale, 0.5);
    // Blur
    if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
    // Spread
    if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
    var output = template(shadow);
    if (containsCSSVariables) {
        var i_1 = 0;
        output = output.replace($b5055acd372134c8$var$varToken, function() {
            var cssVariable = cssVariables[i_1];
            i_1++;
            return cssVariable;
        });
    }
    return output;
}
var $b5055acd372134c8$var$borderCorrectionDefinition = {
    process: $b5055acd372134c8$export$5eafb6257a5844c
};
var $b5055acd372134c8$export$f5121daded6e3d5d = {
    borderRadius: (0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, $b5055acd372134c8$var$borderCorrectionDefinition), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: $b5055acd372134c8$var$borderCorrectionDefinition,
    borderTopRightRadius: $b5055acd372134c8$var$borderCorrectionDefinition,
    borderBottomLeftRadius: $b5055acd372134c8$var$borderCorrectionDefinition,
    borderBottomRightRadius: $b5055acd372134c8$var$borderCorrectionDefinition,
    boxShadow: {
        process: $b5055acd372134c8$export$eb0bc629e74dcf8
    }
};

});
parcelRegister("k5bUl", function(module, exports) {

$parcel$export(module.exports, "cssVariableRegex", function () { return $e9ed82f0517b1f3f$export$f7c0a352d8ef6313; });
$parcel$export(module.exports, "resolveCSSVariables", function () { return $e9ed82f0517b1f3f$export$669319b042b57350; });

var $S3LFa = parcelRequire("S3LFa");

var $dnSYc = parcelRequire("dnSYc");
function $e9ed82f0517b1f3f$var$isCSSVariable(value) {
    return typeof value === "string" && value.startsWith("var(--");
}
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $e9ed82f0517b1f3f$export$f7c0a352d8ef6313 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function $e9ed82f0517b1f3f$export$b9f0c1f373aee2b0(current) {
    var match = $e9ed82f0517b1f3f$export$f7c0a352d8ef6313.exec(current);
    if (!match) return [
        , 
    ];
    var _a = (0, $S3LFa.__read)(match, 3), token = _a[1], fallback = _a[2];
    return [
        token,
        fallback
    ];
}
var $e9ed82f0517b1f3f$var$maxDepth = 4;
function $e9ed82f0517b1f3f$var$getVariableValue(current, element, depth) {
    if (depth === void 0) depth = 1;
    (0, $dnSYc.invariant)(depth <= $e9ed82f0517b1f3f$var$maxDepth, 'Max CSS variable fallback depth detected in property "' + current + '". This may indicate a circular fallback dependency.');
    var _a = (0, $S3LFa.__read)($e9ed82f0517b1f3f$export$b9f0c1f373aee2b0(current), 2), token = _a[0], fallback = _a[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) return resolved.trim();
    else if ($e9ed82f0517b1f3f$var$isCSSVariable(fallback)) // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
    return $e9ed82f0517b1f3f$var$getVariableValue(fallback, element, depth + 1);
    else return fallback;
}
/**
 * Resolve CSS variables from
 *
 * @internal
 */ function $e9ed82f0517b1f3f$export$669319b042b57350(visualElement, _a, transitionEnd) {
    var _b;
    var target = (0, $S3LFa.__rest)(_a, []);
    var element = visualElement.getInstance();
    if (!(element instanceof HTMLElement)) return {
        target: target,
        transitionEnd: transitionEnd
    };
    // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
    // only if they change but I think this reads clearer and this isn't a performance-critical path.
    if (transitionEnd) transitionEnd = (0, $S3LFa.__assign)({}, transitionEnd);
    // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
    visualElement.forEachValue(function(value) {
        var current = value.get();
        if (!$e9ed82f0517b1f3f$var$isCSSVariable(current)) return;
        var resolved = $e9ed82f0517b1f3f$var$getVariableValue(current, element);
        if (resolved) value.set(resolved);
    });
    // Cycle through every target property and resolve CSS variables. Currently
    // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
    for(var key in target){
        var current = target[key];
        if (!$e9ed82f0517b1f3f$var$isCSSVariable(current)) continue;
        var resolved = $e9ed82f0517b1f3f$var$getVariableValue(current, element);
        if (!resolved) continue;
        // Clone target if it hasn't already been
        target[key] = resolved;
        // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
        // CSS variable. This will ensure that after the animation the component will reflect
        // changes in the value of the CSS variable.
        if (transitionEnd) (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : transitionEnd[key] = current;
    }
    return {
        target: target,
        transitionEnd: transitionEnd
    };
}

});



parcelRegister("1Ivip", function(module, exports) {

$parcel$export(module.exports, "MeasureContextProvider", function () { return $14022d3ca7dfe2cc$export$47ef792ac0e676f6; });

var $S3LFa = parcelRequire("S3LFa");

var $4YNlq = parcelRequire("4YNlq");

var $9rwrj = parcelRequire("9rwrj");

var $1MwKT = parcelRequire("1MwKT");
/**
 * This component is responsible for scheduling the measuring of the motion component
 */ var $14022d3ca7dfe2cc$var$Measure = /** @class */ function(_super) {
    (0, $S3LFa.__extends)(Measure, _super);
    function Measure() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * If this is a child of a SyncContext, register the VisualElement with it on mount.
     */ Measure.prototype.componentDidMount = function() {
        var _a = this.props, syncLayout = _a.syncLayout, framerSyncLayout = _a.framerSyncLayout, visualElement = _a.visualElement;
        (0, $9rwrj.isSharedLayout)(syncLayout) && syncLayout.register(visualElement);
        (0, $9rwrj.isSharedLayout)(framerSyncLayout) && framerSyncLayout.register(visualElement);
        visualElement.onUnmount(function() {
            if ((0, $9rwrj.isSharedLayout)(syncLayout)) syncLayout.remove(visualElement);
            if ((0, $9rwrj.isSharedLayout)(framerSyncLayout)) framerSyncLayout.remove(visualElement);
        });
    };
    /**
     * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
     * handle the snapshotting.
     *
     * If it is stand-alone component, add it to the batcher.
     */ Measure.prototype.getSnapshotBeforeUpdate = function() {
        var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
        if ((0, $9rwrj.isSharedLayout)(syncLayout)) syncLayout.syncUpdate();
        else {
            (0, $1MwKT.snapshotViewportBox)(visualElement);
            syncLayout.add(visualElement);
        }
        return null;
    };
    Measure.prototype.componentDidUpdate = function() {
        var syncLayout = this.props.syncLayout;
        if (!(0, $9rwrj.isSharedLayout)(syncLayout)) syncLayout.flush();
    };
    Measure.prototype.render = function() {
        return null;
    };
    return Measure;
}((0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).Component);
function $14022d3ca7dfe2cc$export$47ef792ac0e676f6(props) {
    var syncLayout = (0, $4YNlq.useContext)((0, $9rwrj.SharedLayoutContext));
    var framerSyncLayout = (0, $4YNlq.useContext)((0, $9rwrj.FramerTreeLayoutContext));
    return (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement($14022d3ca7dfe2cc$var$Measure, (0, $S3LFa.__assign)({}, props, {
        syncLayout: syncLayout,
        framerSyncLayout: framerSyncLayout
    }));
}

});


parcelRegister("9OByi", function(module, exports) {

$parcel$export(module.exports, "createDomVisualElement", function () { return $7255e9a048a5678a$export$56ba0183203348f5; });

var $2A5Ic = parcelRequire("2A5Ic");

var $fayA6 = parcelRequire("fayA6");

var $7vNru = parcelRequire("7vNru");
var $7255e9a048a5678a$export$56ba0183203348f5 = function(Component, options) {
    return (0, $7vNru.isSVGComponent)(Component) ? (0, $fayA6.svgVisualElement)(options, {
        enableHardwareAcceleration: false
    }) : (0, $2A5Ic.htmlVisualElement)(options, {
        enableHardwareAcceleration: true
    });
};

});
parcelRegister("2A5Ic", function(module, exports) {

$parcel$export(module.exports, "htmlConfig", function () { return $1e135fcdda74f555$export$985b1494d4aeee90; });
$parcel$export(module.exports, "htmlVisualElement", function () { return $1e135fcdda74f555$export$9509f7c142585e92; });

var $S3LFa = parcelRequire("S3LFa");

var $7B57i = parcelRequire("7B57i");

var $f2U56 = parcelRequire("f2U56");

var $d1Jwd = parcelRequire("d1Jwd");

var $1avWS = parcelRequire("1avWS");

var $18NTo = parcelRequire("18NTo");

var $hniZj = parcelRequire("hniZj");

var $479mE = parcelRequire("479mE");

var $8ntgB = parcelRequire("8ntgB");

var $hz79B = parcelRequire("hz79B");

var $7Wu8u = parcelRequire("7Wu8u");

var $goc0A = parcelRequire("goc0A");
function $1e135fcdda74f555$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $1e135fcdda74f555$export$985b1494d4aeee90 = {
    treeType: "dom",
    readValueFromInstance: function(domElement, key) {
        if ((0, $479mE.isTransformProp)(key)) {
            var defaultType = (0, $7Wu8u.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            var computedStyle = $1e135fcdda74f555$export$3735103072e4a80(domElement);
            return ((0, $18NTo.isCSSVariable)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
        }
    },
    sortNodePosition: function(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    },
    getBaseTarget: function(props, key) {
        var _a;
        return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
    },
    measureViewportBox: function(element, _a) {
        var transformPagePoint = _a.transformPagePoint;
        return (0, $d1Jwd.getBoundingBox)(element, transformPagePoint);
    },
    /**
     * Reset the transform on the current Element. This is called as part
     * of a batched process across the entire layout tree. To remove this write
     * cycle it'd be interesting to see if it's possible to "undo" all the current
     * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
     * works
     */ resetTransform: function(element, domElement, props) {
        var transformTemplate = props.transformTemplate;
        domElement.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        // Ensure that whatever happens next, we restore our transform on the next frame
        element.scheduleRender();
    },
    restoreTransform: function(instance, mutableState) {
        instance.style.transform = mutableState.style.transform;
    },
    removeValueFromRenderState: function(key, _a) {
        var vars = _a.vars, style = _a.style;
        delete vars[key];
        delete style[key];
    },
    /**
     * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
     * can be animated by Motion.
     */ makeTargetAnimatable: function(element, _a, _b, isMounted) {
        var transformValues = _b.transformValues;
        if (isMounted === void 0) isMounted = true;
        var transition = _a.transition, transitionEnd = _a.transitionEnd, target = (0, $S3LFa.__rest)(_a, [
            "transition",
            "transitionEnd"
        ]);
        var origin = (0, $f2U56.getOrigin)(target, transition || {}, element);
        /**
         * If Framer has provided a function to convert `Color` etc value types, convert them
         */ if (transformValues) {
            if (transitionEnd) transitionEnd = transformValues(transitionEnd);
            if (target) target = transformValues(target);
            if (origin) origin = transformValues(origin);
        }
        if (isMounted) {
            (0, $f2U56.checkTargetForNewValues)(element, target, origin);
            var parsed = (0, $hniZj.parseDomVariant)(element, target, origin, transitionEnd);
            transitionEnd = parsed.transitionEnd;
            target = parsed.target;
        }
        return (0, $S3LFa.__assign)({
            transition: transition,
            transitionEnd: transitionEnd
        }, target);
    },
    scrapeMotionValuesFromProps: (0, $8ntgB.scrapeMotionValuesFromProps),
    build: function(element, renderState, latestValues, projection, layoutState, options, props) {
        if (element.isVisible !== undefined) renderState.style.visibility = element.isVisible ? "visible" : "hidden";
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        (0, $1avWS.buildHTMLStyles)(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? (0, $goc0A.buildLayoutProjectionTransform) : undefined, isProjectionTranform ? (0, $goc0A.buildLayoutProjectionTransformOrigin) : undefined);
    },
    render: (0, $hz79B.renderHTML)
};
var $1e135fcdda74f555$export$9509f7c142585e92 = (0, $7B57i.visualElement)($1e135fcdda74f555$export$985b1494d4aeee90);

});
parcelRegister("7B57i", function(module, exports) {

$parcel$export(module.exports, "visualElement", function () { return $587ff5300def658f$export$5ad594e944c33d76; });

var $S3LFa = parcelRequire("S3LFa");

var $iYUpa = parcelRequire("iYUpa");

var $eiL8o = parcelRequire("eiL8o");

var $ccUUQ = parcelRequire("ccUUQ");

var $1EIFq = parcelRequire("1EIFq");

var $73ZdR = parcelRequire("73ZdR");

var $lm5jp = parcelRequire("lm5jp");

var $6EC5A = parcelRequire("6EC5A");

var $7PUVa = parcelRequire("7PUVa");

var $67Lja = parcelRequire("67Lja");

var $goc0A = parcelRequire("goc0A");

var $es7Ew = parcelRequire("es7Ew");

var $gtNDj = parcelRequire("gtNDj");

var $cLSSX = parcelRequire("cLSSX");

var $6flk0 = parcelRequire("6flk0");

var $2iT87 = parcelRequire("2iT87");

var $kPAVh = parcelRequire("kPAVh");

var $7NspE = parcelRequire("7NspE");

var $5AlHW = parcelRequire("5AlHW");

var $9CGrz = parcelRequire("9CGrz");
var $587ff5300def658f$export$5ad594e944c33d76 = function(_a) {
    var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, resetTransform = _a.resetTransform, restoreTransform = _a.restoreTransform, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
    return function(_a, options) {
        var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
        if (options === void 0) options = {};
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        /**
         * The instance of the render-specific node that will be hydrated by the
         * exposed React ref. So for example, this visual element can host a
         * HTMLElement, plain object, or Three.js object. The functions provided
         * in VisualElementConfig allow us to interface with this instance.
         */ var instance;
        /**
         * Manages the subscriptions for a visual element's lifecycle, for instance
         * onRender and onViewportBoxUpdate.
         */ var lifecycles = (0, $gtNDj.createLifecycles)();
        /**
         *
         */ var projection = (0, $2iT87.createProjectionState)();
        /**
         * A reference to the nearest projecting parent. This is either
         * undefined if we haven't looked for the nearest projecting parent,
         * false if there is no parent performing layout projection, or a reference
         * to the projecting parent.
         */ var projectionParent;
        /**
         * This is a reference to the visual state of the "lead" visual element.
         * Usually, this will be this visual element. But if it shares a layoutId
         * with other visual elements, only one of them will be designated lead by
         * AnimateSharedLayout. All the other visual elements will take on the visual
         * appearance of the lead while they crossfade to it.
         */ var leadProjection = projection;
        var leadLatestValues = latestValues;
        var unsubscribeFromLeadVisualElement;
        /**
         * The latest layout measurements and calculated projections. This
         * is seperate from the target projection data in visualState as
         * many visual elements might point to the same piece of visualState as
         * a target, whereas they might each have different layouts and thus
         * projection calculations needed to project into the same viewport box.
         */ var layoutState = (0, $2iT87.createLayoutState)();
        /**
         *
         */ var crossfader;
        /**
         * Keep track of whether the viewport box has been updated since the
         * last time the layout projection was re-calculated.
         */ var hasViewportBoxUpdated = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ var values = new Map();
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ var valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ var prevMotionValues = {};
        /**
         * x/y motion values that track the progress of initiated layout
         * animations.
         *
         * TODO: Target for removal
         */ var projectionTargetProgress;
        /**
         * When values are removed from all animation props we need to search
         * for a fallback value to animate to. These values are tracked in baseTarget.
         */ var baseTarget = (0, $S3LFa.__assign)({}, latestValues);
        // Internal methods ========================
        /**
         * On mount, this will be hydrated with a callback to disconnect
         * this visual element from its parent on unmount.
         */ var removeFromVariantTree;
        /**
         *
         */ function render() {
            if (!instance) return;
            if (element.isProjectionReady()) {
                /**
                 * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
                 * This is the final box that we will then project into by calculating a transform delta and
                 * applying it to the corrected box.
                 */ (0, $lm5jp.applyBoxTransforms)(leadProjection.targetFinal, leadProjection.target, leadLatestValues);
                /**
                 * Update the delta between the corrected box and the final target box, after
                 * user-set transforms are applied to it. This will be used by the renderer to
                 * create a transform style that will reproject the element from its actual layout
                 * into the desired bounding box.
                 */ (0, $6EC5A.updateBoxDelta)(layoutState.deltaFinal, layoutState.layoutCorrected, leadProjection.targetFinal, latestValues);
            }
            triggerBuild();
            renderInstance(instance, renderState);
        }
        function triggerBuild() {
            var valuesToRender = latestValues;
            if (crossfader && crossfader.isActive()) {
                var crossfadedValues = crossfader.getCrossfadeState(element);
                if (crossfadedValues) valuesToRender = crossfadedValues;
            }
            build(element, renderState, valuesToRender, leadProjection, layoutState, options, props);
        }
        function update() {
            lifecycles.notifyUpdate(latestValues);
        }
        function updateLayoutProjection() {
            if (!element.isProjectionReady()) return;
            var delta = layoutState.delta, treeScale = layoutState.treeScale;
            var prevTreeScaleX = treeScale.x;
            var prevTreeScaleY = treeScale.y;
            var prevDeltaTransform = layoutState.deltaTransform;
            (0, $6flk0.updateLayoutDeltas)(layoutState, leadProjection, element.path, latestValues);
            hasViewportBoxUpdated && element.notifyViewportBoxUpdate(leadProjection.target, delta);
            hasViewportBoxUpdated = false;
            var deltaTransform = (0, $goc0A.buildLayoutProjectionTransform)(delta, treeScale);
            if (deltaTransform !== prevDeltaTransform || // Also compare calculated treeScale, for values that rely on this only for scale correction
            prevTreeScaleX !== treeScale.x || prevTreeScaleY !== treeScale.y) element.scheduleRender();
            layoutState.deltaTransform = deltaTransform;
        }
        function updateTreeLayoutProjection() {
            element.layoutTree.forEach($587ff5300def658f$var$fireUpdateLayoutProjection);
        }
        /**
         *
         */ function bindToMotionValue(key, value) {
            var removeOnChange = value.onChange(function(latestValue) {
                latestValues[key] = latestValue;
                props.onUpdate && (0, $iYUpa.default).update(update, false, true);
            });
            var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
            valueSubscriptions.set(key, function() {
                removeOnChange();
                removeOnRenderRequest();
            });
        }
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't neccessarily a breaking change,
         * more a reflection of the test.
         */ var initialMotionValues = scrapeMotionValuesFromProps(props);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $67Lja.isMotionValue)(value)) value.set(latestValues[key], false);
        }
        /**
         * Determine what role this visual element should take in the variant tree.
         */ var isControllingVariants = (0, $7NspE.checkIfControllingVariants)(props);
        var isVariantNode = (0, $7NspE.checkIfVariantNode)(props);
        var element = (0, $S3LFa.__assign)((0, $S3LFa.__assign)({
            treeType: treeType,
            /**
             * This is a mirror of the internal instance prop, which keeps
             * VisualElement type-compatible with React's RefObject.
             */ current: null,
            /**
             * The depth of this visual element within the visual element tree.
             */ depth: parent ? parent.depth + 1 : 0,
            parent: parent,
            children: new Set(),
            /**
             * An ancestor path back to the root visual element. This is used
             * by layout projection to quickly recurse back up the tree.
             */ path: parent ? (0, $S3LFa.__spreadArray)((0, $S3LFa.__spreadArray)([], (0, $S3LFa.__read)(parent.path)), [
                parent
            ]) : [],
            layoutTree: parent ? parent.layoutTree : new (0, $kPAVh.FlatTree)(),
            /**
             *
             */ presenceId: presenceId,
            projection: projection,
            /**
             * If this component is part of the variant tree, it should track
             * any children that are also part of the tree. This is essentially
             * a shadow tree to simplify logic around how to stagger over children.
             */ variantChildren: isVariantNode ? new Set() : undefined,
            /**
             * Whether this instance is visible. This can be changed imperatively
             * by AnimateSharedLayout, is analogous to CSS's visibility in that
             * hidden elements should take up layout, and needs enacting by the configured
             * render function.
             */ isVisible: undefined,
            /**
             * Normally, if a component is controlled by a parent's variants, it can
             * rely on that ancestor to trigger animations further down the tree.
             * However, if a component is created after its parent is mounted, the parent
             * won't trigger that mount animation so the child needs to.
             *
             * TODO: This might be better replaced with a method isParentMounted
             */ manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()),
            /**
             * This can be set by AnimatePresence to force components that mount
             * at the same time as it to mount as if they have initial={false} set.
             */ blockInitialAnimation: blockInitialAnimation,
            /**
             * Determine whether this component has mounted yet. This is mostly used
             * by variant children to determine whether they need to trigger their
             * own animations on mount.
             */ isMounted: function() {
                return Boolean(instance);
            },
            mount: function(newInstance) {
                instance = element.current = newInstance;
                element.pointTo(element);
                if (isVariantNode && parent && !isControllingVariants) removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                parent === null || parent === void 0 || parent.children.add(element);
            },
            /**
             *
             */ unmount: function() {
                (0, $iYUpa.cancelSync).update(update);
                (0, $iYUpa.cancelSync).render(render);
                (0, $iYUpa.cancelSync).preRender(element.updateLayoutProjection);
                valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                element.stopLayoutAnimation();
                element.layoutTree.remove(element);
                removeFromVariantTree === null || removeFromVariantTree === void 0 || removeFromVariantTree();
                parent === null || parent === void 0 || parent.children.delete(element);
                unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 || unsubscribeFromLeadVisualElement();
                lifecycles.clearAllListeners();
            },
            /**
             * Add a child visual element to our set of children.
             */ addVariantChild: function(child) {
                var _a;
                var closestVariantNode = element.getClosestVariantNode();
                if (closestVariantNode) {
                    (_a = closestVariantNode.variantChildren) === null || _a === void 0 || _a.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            },
            sortNodePosition: function(other) {
                /**
                 * If these nodes aren't even of the same type we can't compare their depth.
                 */ if (!sortNodePosition || treeType !== other.treeType) return 0;
                return sortNodePosition(element.getInstance(), other.getInstance());
            },
            /**
             * Returns the closest variant node in the tree starting from
             * this visual element.
             */ getClosestVariantNode: function() {
                return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
            },
            /**
             * A method that schedules an update to layout projections throughout
             * the tree. We inherit from the parent so there's only ever one
             * job scheduled on the next frame - that of the root visual element.
             */ scheduleUpdateLayoutProjection: parent ? parent.scheduleUpdateLayoutProjection : function() {
                return (0, $iYUpa.default).preRender(element.updateTreeLayoutProjection, false, true);
            },
            /**
             * Expose the latest layoutId prop.
             */ getLayoutId: function() {
                return props.layoutId;
            },
            /**
             * Returns the current instance.
             */ getInstance: function() {
                return instance;
            },
            /**
             * Get/set the latest static values.
             */ getStaticValue: function(key) {
                return latestValues[key];
            },
            setStaticValue: function(key, value) {
                return latestValues[key] = value;
            },
            /**
             * Returns the latest motion value state. Currently only used to take
             * a snapshot of the visual element - perhaps this can return the whole
             * visual state
             */ getLatestValues: function() {
                return latestValues;
            },
            /**
             * Set the visiblity of the visual element. If it's changed, schedule
             * a render to reflect these changes.
             */ setVisibility: function(visibility) {
                if (element.isVisible === visibility) return;
                element.isVisible = visibility;
                element.scheduleRender();
            },
            /**
             * Make a target animatable by Popmotion. For instance, if we're
             * trying to animate width from 100px to 100vw we need to measure 100vw
             * in pixels to determine what we really need to animate to. This is also
             * pluggable to support Framer's custom value types like Color,
             * and CSS variables.
             */ makeTargetAnimatable: function(target, canMutate) {
                if (canMutate === void 0) canMutate = true;
                return makeTargetAnimatable(element, target, props, canMutate);
            },
            // Motion values ========================
            /**
             * Add a motion value and bind it to this visual element.
             */ addValue: function(key, value) {
                // Remove existing value if it exists
                if (element.hasValue(key)) element.removeValue(key);
                values.set(key, value);
                latestValues[key] = value.get();
                bindToMotionValue(key, value);
            },
            /**
             * Remove a motion value and unbind any active subscriptions.
             */ removeValue: function(key) {
                var _a;
                values.delete(key);
                (_a = valueSubscriptions.get(key)) === null || _a === void 0 || _a();
                valueSubscriptions.delete(key);
                delete latestValues[key];
                removeValueFromRenderState(key, renderState);
            },
            /**
             * Check whether we have a motion value for this key
             */ hasValue: function(key) {
                return values.has(key);
            },
            /**
             * Get a motion value for this key. If called with a default
             * value, we'll create one if none exists.
             */ getValue: function(key, defaultValue) {
                var value = values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $7PUVa.motionValue)(defaultValue);
                    element.addValue(key, value);
                }
                return value;
            },
            /**
             * Iterate over our motion values.
             */ forEachValue: function(callback) {
                return values.forEach(callback);
            },
            /**
             * If we're trying to animate to a previously unencountered value,
             * we need to check for it in our state and as a last resort read it
             * directly from the instance (which might have performance implications).
             */ readValue: function(key) {
                var _a;
                return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options);
            },
            /**
             * Set the base target to later animate back to. This is currently
             * only hydrated on creation and when we first read a value.
             */ setBaseTarget: function(key, value) {
                baseTarget[key] = value;
            },
            /**
             * Find the base target for a value thats been removed from all animation
             * props.
             */ getBaseTarget: function(key) {
                if (getBaseTarget) {
                    var target = getBaseTarget(props, key);
                    if (target !== undefined && !(0, $67Lja.isMotionValue)(target)) return target;
                }
                return baseTarget[key];
            }
        }, lifecycles), {
            /**
             * Build the renderer state based on the latest visual state.
             */ build: function() {
                triggerBuild();
                return renderState;
            },
            /**
             * Schedule a render on the next animation frame.
             */ scheduleRender: function() {
                (0, $iYUpa.default).render(render, false, true);
            },
            /**
             * Synchronously fire render. It's prefered that we batch renders but
             * in many circumstances, like layout measurement, we need to run this
             * synchronously. However in those instances other measures should be taken
             * to batch reads/writes.
             */ syncRender: render,
            /**
             * Update the provided props. Ensure any newly-added motion values are
             * added to our map, old ones removed, and listeners updated.
             */ setProps: function(newProps) {
                props = newProps;
                lifecycles.updatePropListeners(newProps);
                prevMotionValues = (0, $cLSSX.updateMotionValuesFromProps)(element, scrapeMotionValuesFromProps(props), prevMotionValues);
            },
            getProps: function() {
                return props;
            },
            // Variants ==============================
            /**
             * Returns the variant definition with a given name.
             */ getVariant: function(name) {
                var _a;
                return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name];
            },
            /**
             * Returns the defined default transition on this component.
             */ getDefaultTransition: function() {
                return props.transition;
            },
            /**
             * Used by child variant nodes to get the closest ancestor variant props.
             */ getVariantContext: function(startAtParent) {
                if (startAtParent === void 0) startAtParent = false;
                if (startAtParent) return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                if (!isControllingVariants) {
                    var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                    if (props.initial !== undefined) context_1.initial = props.initial;
                    return context_1;
                }
                var context = {};
                for(var i = 0; i < $587ff5300def658f$var$numVariantProps; i++){
                    var name_1 = $587ff5300def658f$var$variantProps[i];
                    var prop = props[name_1];
                    if ((0, $7NspE.isVariantLabel)(prop) || prop === false) context[name_1] = prop;
                }
                return context;
            },
            // Layout projection ==============================
            /**
             * Enable layout projection for this visual element. Won't actually
             * occur until we also have hydrated layout measurements.
             */ enableLayoutProjection: function() {
                projection.isEnabled = true;
                element.layoutTree.add(element);
            },
            /**
             * Lock the projection target, for instance when dragging, so
             * nothing else can try and animate it.
             */ lockProjectionTarget: function() {
                projection.isTargetLocked = true;
            },
            unlockProjectionTarget: function() {
                element.stopLayoutAnimation();
                projection.isTargetLocked = false;
            },
            getLayoutState: function() {
                return layoutState;
            },
            setCrossfader: function(newCrossfader) {
                crossfader = newCrossfader;
            },
            isProjectionReady: function() {
                return projection.isEnabled && projection.isHydrated && layoutState.isHydrated;
            },
            /**
             * Start a layout animation on a given axis.
             */ startLayoutAnimation: function(axis, transition, isRelative) {
                if (isRelative === void 0) isRelative = false;
                var progress = element.getProjectionAnimationProgress()[axis];
                var _a = isRelative ? projection.relativeTarget[axis] : projection.target[axis], min = _a.min, max = _a.max;
                var length = max - min;
                progress.clearListeners();
                progress.set(min);
                progress.set(min); // Set twice to hard-reset velocity
                progress.onChange(function(v) {
                    element.setProjectionTargetAxis(axis, v, v + length, isRelative);
                });
                return element.animateMotionValue(axis, progress, 0, transition);
            },
            /**
             * Stop layout animations.
             */ stopLayoutAnimation: function() {
                (0, $1EIFq.eachAxis)(function(axis) {
                    return element.getProjectionAnimationProgress()[axis].stop();
                });
            },
            /**
             * Measure the current viewport box with or without transforms.
             * Only measures axis-aligned boxes, rotate and skew must be manually
             * removed with a re-render to work.
             */ measureViewportBox: function(withTransform) {
                if (withTransform === void 0) withTransform = true;
                var viewportBox = measureViewportBox(instance, options);
                if (!withTransform) (0, $lm5jp.removeBoxTransforms)(viewportBox, latestValues);
                return viewportBox;
            },
            /**
             * Get the motion values tracking the layout animations on each
             * axis. Lazy init if not already created.
             */ getProjectionAnimationProgress: function() {
                projectionTargetProgress || (projectionTargetProgress = {
                    x: (0, $7PUVa.motionValue)(0),
                    y: (0, $7PUVa.motionValue)(0)
                });
                return projectionTargetProgress;
            },
            /**
             * Update the projection of a single axis. Schedule an update to
             * the tree layout projection.
             */ setProjectionTargetAxis: function(axis, min, max, isRelative) {
                if (isRelative === void 0) isRelative = false;
                var target;
                if (isRelative) {
                    if (!projection.relativeTarget) projection.relativeTarget = (0, $73ZdR.axisBox)();
                    target = projection.relativeTarget[axis];
                } else {
                    projection.relativeTarget = undefined;
                    target = projection.target[axis];
                }
                projection.isHydrated = true;
                target.min = min;
                target.max = max;
                // Flag that we want to fire the onViewportBoxUpdate event handler
                hasViewportBoxUpdated = true;
                lifecycles.notifySetAxisTarget();
            },
            /**
             * Rebase the projection target on top of the provided viewport box
             * or the measured layout. This ensures that non-animating elements
             * don't fall out of sync differences in measurements vs projections
             * after a page scroll or other relayout.
             */ rebaseProjectionTarget: function(force, box) {
                if (box === void 0) box = layoutState.layout;
                var _a = element.getProjectionAnimationProgress(), x = _a.x, y = _a.y;
                var shouldRebase = !projection.relativeTarget && !projection.isTargetLocked && !x.isAnimating() && !y.isAnimating();
                if (force || shouldRebase) (0, $1EIFq.eachAxis)(function(axis) {
                    var _a = box[axis], min = _a.min, max = _a.max;
                    element.setProjectionTargetAxis(axis, min, max);
                });
            },
            /**
             * Notify the visual element that its layout is up-to-date.
             * Currently Animate.tsx uses this to check whether a layout animation
             * needs to be performed.
             */ notifyLayoutReady: function(config) {
                (0, $5AlHW.setCurrentViewportBox)(element);
                element.notifyLayoutUpdate(layoutState.layout, element.prevViewportBox || layoutState.layout, config);
            },
            /**
             * Temporarily reset the transform of the instance.
             */ resetTransform: function() {
                return resetTransform(element, instance, props);
            },
            restoreTransform: function() {
                return restoreTransform(instance, renderState);
            },
            updateLayoutProjection: updateLayoutProjection,
            updateTreeLayoutProjection: function() {
                element.layoutTree.forEach($587ff5300def658f$var$fireResolveRelativeTargetBox);
                /**
                 * Schedule the projection updates at the end of the current preRender
                 * step. This will ensure that all layout trees will first resolve
                 * relative projection boxes into viewport boxes, and *then*
                 * update projections.
                 */ (0, $iYUpa.default).preRender(updateTreeLayoutProjection, false, true);
            // sync.postRender(() => element.scheduleUpdateLayoutProjection())
            },
            getProjectionParent: function() {
                if (projectionParent === undefined) {
                    var foundParent = false;
                    // Search backwards through the tree path
                    for(var i = element.path.length - 1; i >= 0; i--){
                        var ancestor = element.path[i];
                        if (ancestor.projection.isEnabled) {
                            foundParent = ancestor;
                            break;
                        }
                    }
                    projectionParent = foundParent;
                }
                return projectionParent;
            },
            resolveRelativeTargetBox: function() {
                var relativeParent = element.getProjectionParent();
                if (!projection.relativeTarget || !relativeParent) return;
                (0, $6EC5A.calcRelativeBox)(projection, relativeParent.projection);
                if ((0, $9CGrz.isDraggable)(relativeParent)) {
                    var target = projection.target;
                    (0, $lm5jp.applyBoxTransforms)(target, target, relativeParent.getLatestValues());
                }
            },
            shouldResetTransform: function() {
                return Boolean(props._layoutResetTransform);
            },
            /**
             *
             */ pointTo: function(newLead) {
                leadProjection = newLead.projection;
                leadLatestValues = newLead.getLatestValues();
                /**
                 * Subscribe to lead component's layout animations
                 */ unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 || unsubscribeFromLeadVisualElement();
                unsubscribeFromLeadVisualElement = (0, $eiL8o.pipe)(newLead.onSetAxisTarget(element.scheduleUpdateLayoutProjection), newLead.onLayoutAnimationComplete(function() {
                    var _a;
                    if (element.isPresent) element.presence = (0, $ccUUQ.Presence).Present;
                    else (_a = element.layoutSafeToRemove) === null || _a === void 0 || _a.call(element);
                }));
            },
            // TODO: Clean this up
            isPresent: true,
            presence: (0, $ccUUQ.Presence).Entering
        });
        return element;
    };
};
function $587ff5300def658f$var$fireResolveRelativeTargetBox(child) {
    child.resolveRelativeTargetBox();
}
function $587ff5300def658f$var$fireUpdateLayoutProjection(child) {
    child.updateLayoutProjection();
}
var $587ff5300def658f$var$variantProps = (0, $S3LFa.__spreadArray)([
    "initial"
], (0, $S3LFa.__read)((0, $es7Ew.variantPriorityOrder)));
var $587ff5300def658f$var$numVariantProps = $587ff5300def658f$var$variantProps.length;

});
parcelRegister("goc0A", function(module, exports) {

$parcel$export(module.exports, "buildLayoutProjectionTransform", function () { return $bee833dde5a24457$export$d842ebfa32edc648; });
$parcel$export(module.exports, "buildLayoutProjectionTransformOrigin", function () { return $bee833dde5a24457$export$9df601cd9cfcf364; });

var $2iT87 = parcelRequire("2iT87");
/**
 * Build a transform style that takes a calculated delta between the element's current
 * space on screen and projects it into the desired space.
 */ function $bee833dde5a24457$export$d842ebfa32edc648(_a, treeScale, latestTransform) {
    var x = _a.x, y = _a.y;
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ var xTranslate = x.translate / treeScale.x;
    var yTranslate = y.translate / treeScale.y;
    var transform = "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) ";
    if (latestTransform) {
        var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
        if (rotate) transform += "rotate(" + rotate + ") ";
        if (rotateX) transform += "rotateX(" + rotateX + ") ";
        if (rotateY) transform += "rotateY(" + rotateY + ") ";
    }
    transform += "scale(" + x.scale + ", " + y.scale + ")";
    return !latestTransform && transform === $bee833dde5a24457$export$f6730f82d2dcfda3 ? "" : transform;
}
/**
 * Take the calculated delta origin and apply it as a transform string.
 */ function $bee833dde5a24457$export$9df601cd9cfcf364(_a) {
    var deltaFinal = _a.deltaFinal;
    return deltaFinal.x.origin * 100 + "% " + deltaFinal.y.origin * 100 + "% 0";
}
var $bee833dde5a24457$export$f6730f82d2dcfda3 = $bee833dde5a24457$export$d842ebfa32edc648((0, $2iT87.zeroLayout).delta, (0, $2iT87.zeroLayout).treeScale, {
    x: 1,
    y: 1
});

});
parcelRegister("2iT87", function(module, exports) {

$parcel$export(module.exports, "createProjectionState", function () { return $1ad806db06b2d0f4$export$3cdcde773d12ad30; });
$parcel$export(module.exports, "createLayoutState", function () { return $1ad806db06b2d0f4$export$e7071b3cce6bc4ce; });
$parcel$export(module.exports, "zeroLayout", function () { return $1ad806db06b2d0f4$export$6ce978c1a0625804; });

var $73ZdR = parcelRequire("73ZdR");
var $1ad806db06b2d0f4$export$3cdcde773d12ad30 = function() {
    return {
        isEnabled: false,
        isHydrated: false,
        isTargetLocked: false,
        target: (0, $73ZdR.axisBox)(),
        targetFinal: (0, $73ZdR.axisBox)()
    };
};
function $1ad806db06b2d0f4$export$e7071b3cce6bc4ce() {
    return {
        isHydrated: false,
        layout: (0, $73ZdR.axisBox)(),
        layoutCorrected: (0, $73ZdR.axisBox)(),
        treeScale: {
            x: 1,
            y: 1
        },
        delta: (0, $73ZdR.delta)(),
        deltaFinal: (0, $73ZdR.delta)(),
        deltaTransform: ""
    };
}
var $1ad806db06b2d0f4$export$6ce978c1a0625804 = $1ad806db06b2d0f4$export$e7071b3cce6bc4ce();

});


parcelRegister("gtNDj", function(module, exports) {

$parcel$export(module.exports, "createLifecycles", function () { return $bff5dae027e61157$export$f6841af6ea5003ab; });

var $S3LFa = parcelRequire("S3LFa");

var $2e2Mk = parcelRequire("2e2Mk");
var $bff5dae027e61157$var$names = [
    "LayoutMeasure",
    "BeforeLayoutMeasure",
    "LayoutUpdate",
    "ViewportBoxUpdate",
    "Update",
    "Render",
    "AnimationComplete",
    "LayoutAnimationComplete",
    "AnimationStart",
    "SetAxisTarget",
    "Unmount"
];
function $bff5dae027e61157$export$f6841af6ea5003ab() {
    var managers = $bff5dae027e61157$var$names.map(function() {
        return new (0, $2e2Mk.SubscriptionManager)();
    });
    var propSubscriptions = {};
    var lifecycles = {
        clearAllListeners: function() {
            return managers.forEach(function(manager) {
                return manager.clear();
            });
        },
        updatePropListeners: function(props) {
            return $bff5dae027e61157$var$names.forEach(function(name) {
                var _a;
                (_a = propSubscriptions[name]) === null || _a === void 0 || _a.call(propSubscriptions);
                var on = "on" + name;
                var propListener = props[on];
                if (propListener) propSubscriptions[name] = lifecycles[on](propListener);
            });
        }
    };
    managers.forEach(function(manager, i) {
        lifecycles["on" + $bff5dae027e61157$var$names[i]] = function(handler) {
            return manager.add(handler);
        };
        lifecycles["notify" + $bff5dae027e61157$var$names[i]] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return manager.notify.apply(manager, (0, $S3LFa.__spreadArray)([], (0, $S3LFa.__read)(args)));
        };
    });
    return lifecycles;
}

});

parcelRegister("cLSSX", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $94c472f1115ba7c2$export$9a552858d5197f6e; });

var $7PUVa = parcelRequire("7PUVa");

var $67Lja = parcelRequire("67Lja");
function $94c472f1115ba7c2$export$9a552858d5197f6e(element, next, prev) {
    var _a;
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $67Lja.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $67Lja.isMotionValue)(prevValue)) /**
             * If we're swapping to a new motion value, create a new motion value
             * from that
             */ element.addValue(key, (0, $7PUVa.motionValue)(nextValue));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                // TODO: Only update values that aren't being animated or even looked at
                !existingValue.hasAnimated && existingValue.set(nextValue);
            } else element.addValue(key, (0, $7PUVa.motionValue)((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
        }
    }
    // Handle removed values
    for(var key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

});

parcelRegister("6flk0", function(module, exports) {

$parcel$export(module.exports, "updateLayoutDeltas", function () { return $48c4aed34242b73f$export$1b3a41764b83e037; });

var $lm5jp = parcelRequire("lm5jp");

var $6EC5A = parcelRequire("6EC5A");
function $48c4aed34242b73f$export$1b3a41764b83e037(_a, _b, treePath, transformOrigin) {
    var delta = _a.delta, layout = _a.layout, layoutCorrected = _a.layoutCorrected, treeScale = _a.treeScale;
    var target = _b.target;
    /**
     * Reset the corrected box with the latest values from box, as we're then going
     * to perform mutative operations on it.
     */ (0, $lm5jp.resetBox)(layoutCorrected, layout);
    /**
     * Apply all the parent deltas to this box to produce the corrected box. This
     * is the layout box, as it will appear on screen as a result of the transforms of its parents.
     */ (0, $lm5jp.applyTreeDeltas)(layoutCorrected, treeScale, treePath);
    /**
     * Update the delta between the corrected box and the target box before user-set transforms were applied.
     * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
     * for our layout reprojection, but still allow them to be scaled correctly by the user.
     * It might be that to simplify this we may want to accept that user-set scale is also corrected
     * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
     * to allow people to choose whether these styles are corrected based on just the
     * layout reprojection or the final bounding box.
     */ (0, $6EC5A.updateBoxDelta)(delta, layoutCorrected, target, transformOrigin);
}

});

parcelRegister("kPAVh", function(module, exports) {

$parcel$export(module.exports, "FlatTree", function () { return $f2a5362c75cd4207$export$1465d17e3de78a96; });

var $7eMnS = parcelRequire("7eMnS");

var $2AMJ5 = parcelRequire("2AMJ5");
var $f2a5362c75cd4207$export$1465d17e3de78a96 = /** @class */ function() {
    function FlatTree() {
        this.children = [];
        this.isDirty = false;
    }
    FlatTree.prototype.add = function(child) {
        (0, $7eMnS.addUniqueItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.remove = function(child) {
        (0, $7eMnS.removeItem)(this.children, child);
        this.isDirty = true;
    };
    FlatTree.prototype.forEach = function(callback) {
        this.isDirty && this.children.sort((0, $2AMJ5.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    };
    return FlatTree;
}();

});

parcelRegister("5AlHW", function(module, exports) {

$parcel$export(module.exports, "setCurrentViewportBox", function () { return $41112738d1079dce$export$8a57a029e604f408; });

var $d5QYa = parcelRequire("d5QYa");

var $1EIFq = parcelRequire("1EIFq");
function $41112738d1079dce$export$8a57a029e604f408(visualElement) {
    var projectionParent = visualElement.getProjectionParent();
    if (!projectionParent) {
        visualElement.rebaseProjectionTarget();
        return;
    }
    var relativeOffset = (0, $d5QYa.calcRelativeOffset)(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
    (0, $1EIFq.eachAxis)(function(axis) {
        visualElement.setProjectionTargetAxis(axis, relativeOffset[axis].min, relativeOffset[axis].max, true);
    });
}

});


parcelRegister("hniZj", function(module, exports) {

$parcel$export(module.exports, "parseDomVariant", function () { return $ca635040105a5b56$export$5849e743e29831d6; });

var $k5bUl = parcelRequire("k5bUl");

var $gPatV = parcelRequire("gPatV");
/**
 * Parse a DOM variant to make it animatable. This involves resolving CSS variables
 * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
 */ var $ca635040105a5b56$export$5849e743e29831d6 = function(visualElement, target, origin, transitionEnd) {
    var resolved = (0, $k5bUl.resolveCSSVariables)(visualElement, target, transitionEnd);
    target = resolved.target;
    transitionEnd = resolved.transitionEnd;
    return (0, $gPatV.unitConversion)(visualElement, target, origin, transitionEnd);
};

});
parcelRegister("gPatV", function(module, exports) {

$parcel$export(module.exports, "unitConversion", function () { return $c3f98a2f95aeff57$export$9e04b0cab841a28; });

var $S3LFa = parcelRequire("S3LFa");

var $b7dp4 = parcelRequire("b7dp4");
var $avwtz = parcelRequire("avwtz");

var $ftmeo = parcelRequire("ftmeo");

var $dnSYc = parcelRequire("dnSYc");

var $479mE = parcelRequire("479mE");

var $aE3WW = parcelRequire("aE3WW");
var $c3f98a2f95aeff57$var$positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    "x",
    "y"
]);
var $c3f98a2f95aeff57$var$isPositionalKey = function(key) {
    return $c3f98a2f95aeff57$var$positionalKeys.has(key);
};
var $c3f98a2f95aeff57$var$hasPositionalKey = function(target) {
    return Object.keys(target).some($c3f98a2f95aeff57$var$isPositionalKey);
};
var $c3f98a2f95aeff57$var$setAndResetVelocity = function(value, to) {
    // Looks odd but setting it twice doesn't render, it'll just
    // set both prev and current to the latest value
    value.set(to, false);
    value.set(to);
};
var $c3f98a2f95aeff57$var$isNumOrPxType = function(v) {
    return v === (0, $b7dp4.number) || v === (0, $avwtz.px);
};
var $c3f98a2f95aeff57$export$d0c75e4fa9e69db8;
(function(BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})($c3f98a2f95aeff57$export$d0c75e4fa9e69db8 || ($c3f98a2f95aeff57$export$d0c75e4fa9e69db8 = {}));
var $c3f98a2f95aeff57$var$getPosFromMatrix = function(matrix, pos) {
    return parseFloat(matrix.split(", ")[pos]);
};
var $c3f98a2f95aeff57$var$getTranslateFromMatrix = function(pos2, pos3) {
    return function(_bbox, _a) {
        var transform = _a.transform;
        if (transform === "none" || !transform) return 0;
        var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return $c3f98a2f95aeff57$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            var matrix = transform.match(/^matrix\((.+)\)$/);
            if (matrix) return $c3f98a2f95aeff57$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
};
var $c3f98a2f95aeff57$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $c3f98a2f95aeff57$var$nonTranslationalTransformKeys = (0, $479mE.transformProps).filter(function(key) {
    return !$c3f98a2f95aeff57$var$transformKeys.has(key);
});
function $c3f98a2f95aeff57$var$removeNonTranslationalTransform(visualElement) {
    var removedTransforms = [];
    $c3f98a2f95aeff57$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    // Apply changes to element before measurement
    if (removedTransforms.length) visualElement.syncRender();
    return removedTransforms;
}
var $c3f98a2f95aeff57$var$positionalValues = {
    // Dimensions
    width: function(_a) {
        var x = _a.x;
        return x.max - x.min;
    },
    height: function(_a) {
        var y = _a.y;
        return y.max - y.min;
    },
    top: function(_bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function(_bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function(_a, _b) {
        var y = _a.y;
        var top = _b.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(_a, _b) {
        var x = _a.x;
        var left = _b.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: $c3f98a2f95aeff57$var$getTranslateFromMatrix(4, 13),
    y: $c3f98a2f95aeff57$var$getTranslateFromMatrix(5, 14)
};
var $c3f98a2f95aeff57$var$convertChangedValueTypes = function(target, visualElement, changedKeys) {
    var originBbox = visualElement.measureViewportBox();
    var element = visualElement.getInstance();
    var elementComputedStyle = getComputedStyle(element);
    var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
    var originComputedStyle = {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        transform: transform
    };
    // If the element is currently set to display: "none", make it visible before
    // measuring the target bounding box
    if (display === "none") visualElement.setStaticValue("display", target.display || "block");
    // Apply the latest values (as set in checkAndConvertChangedValueTypes)
    visualElement.syncRender();
    var targetBbox = visualElement.measureViewportBox();
    changedKeys.forEach(function(key) {
        // Restore styles to their **calculated computed style**, not their actual
        // originally set style. This allows us to animate between equivalent pixel units.
        var value = visualElement.getValue(key);
        $c3f98a2f95aeff57$var$setAndResetVelocity(value, $c3f98a2f95aeff57$var$positionalValues[key](originBbox, originComputedStyle));
        target[key] = $c3f98a2f95aeff57$var$positionalValues[key](targetBbox, elementComputedStyle);
    });
    return target;
};
var $c3f98a2f95aeff57$var$checkAndConvertChangedValueTypes = function(visualElement, target, origin, transitionEnd) {
    if (origin === void 0) origin = {};
    if (transitionEnd === void 0) transitionEnd = {};
    target = (0, $S3LFa.__assign)({}, target);
    transitionEnd = (0, $S3LFa.__assign)({}, transitionEnd);
    var targetPositionalKeys = Object.keys(target).filter($c3f98a2f95aeff57$var$isPositionalKey);
    // We want to remove any transform values that could affect the element's bounding box before
    // it's measured. We'll reapply these later.
    var removedTransformValues = [];
    var hasAttemptedToRemoveTransformValues = false;
    var changedValueTypeKeys = [];
    targetPositionalKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (!visualElement.hasValue(key)) return;
        var from = origin[key];
        var to = target[key];
        var fromType = (0, $aE3WW.findDimensionValueType)(from);
        var toType;
        // TODO: The current implementation of this basically throws an error
        // if you try and do value conversion via keyframes. There's probably
        // a way of doing this but the performance implications would need greater scrutiny,
        // as it'd be doing multiple resize-remeasure operations.
        if ((0, $ftmeo.isKeyframesTarget)(to)) {
            var numKeyframes = to.length;
            for(var i = to[0] === null ? 1 : 0; i < numKeyframes; i++)if (!toType) {
                toType = (0, $aE3WW.findDimensionValueType)(to[i]);
                (0, $dnSYc.invariant)(toType === fromType || $c3f98a2f95aeff57$var$isNumOrPxType(fromType) && $c3f98a2f95aeff57$var$isNumOrPxType(toType), "Keyframes must be of the same dimension as the current value");
            } else (0, $dnSYc.invariant)((0, $aE3WW.findDimensionValueType)(to[i]) === toType, "All keyframes must be of the same type");
        } else toType = (0, $aE3WW.findDimensionValueType)(to);
        if (fromType !== toType) {
            // If they're both just number or px, convert them both to numbers rather than
            // relying on resize/remeasure to convert (which is wasteful in this situation)
            if ($c3f98a2f95aeff57$var$isNumOrPxType(fromType) && $c3f98a2f95aeff57$var$isNumOrPxType(toType)) {
                var current = value.get();
                if (typeof current === "string") value.set(parseFloat(current));
                if (typeof to === "string") target[key] = parseFloat(to);
                else if (Array.isArray(to) && toType === (0, $avwtz.px)) target[key] = to.map(parseFloat);
            } else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) && (toType === null || toType === void 0 ? void 0 : toType.transform) && (from === 0 || to === 0)) {
                // If one or the other value is 0, it's safe to coerce it to the
                // type of the other without measurement
                if (from === 0) value.set(toType.transform(from));
                else target[key] = fromType.transform(to);
            } else {
                // If we're going to do value conversion via DOM measurements, we first
                // need to remove non-positional transform values that could affect the bbox measurements.
                if (!hasAttemptedToRemoveTransformValues) {
                    removedTransformValues = $c3f98a2f95aeff57$var$removeNonTranslationalTransform(visualElement);
                    hasAttemptedToRemoveTransformValues = true;
                }
                changedValueTypeKeys.push(key);
                transitionEnd[key] = transitionEnd[key] !== undefined ? transitionEnd[key] : target[key];
                $c3f98a2f95aeff57$var$setAndResetVelocity(value, to);
            }
        }
    });
    if (changedValueTypeKeys.length) {
        var convertedTarget = $c3f98a2f95aeff57$var$convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
        // If we removed transform values, reapply them before the next render
        if (removedTransformValues.length) removedTransformValues.forEach(function(_a) {
            var _b = (0, $S3LFa.__read)(_a, 2), key = _b[0], value = _b[1];
            visualElement.getValue(key).set(value);
        });
        // Reapply original values
        visualElement.syncRender();
        return {
            target: convertedTarget,
            transitionEnd: transitionEnd
        };
    } else return {
        target: target,
        transitionEnd: transitionEnd
    };
};
/**
 * Convert value types for x/y/width/height/top/left/bottom/right
 *
 * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
 *
 * @internal
 */ function $c3f98a2f95aeff57$export$9e04b0cab841a28(visualElement, target, origin, transitionEnd) {
    return $c3f98a2f95aeff57$var$hasPositionalKey(target) ? $c3f98a2f95aeff57$var$checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd) : {
        target: target,
        transitionEnd: transitionEnd
    };
}

});



parcelRegister("fayA6", function(module, exports) {

$parcel$export(module.exports, "svgVisualElement", function () { return $b0b29d56aa848400$export$3ba8992de7b705bc; });

var $S3LFa = parcelRequire("S3LFa");

var $7B57i = parcelRequire("7B57i");

var $2VBTm = parcelRequire("2VBTm");

var $2A5Ic = parcelRequire("2A5Ic");

var $ggwHU = parcelRequire("ggwHU");

var $8hfRg = parcelRequire("8hfRg");

var $jGXUL = parcelRequire("jGXUL");

var $479mE = parcelRequire("479mE");

var $bWfLo = parcelRequire("bWfLo");

var $7Wu8u = parcelRequire("7Wu8u");

var $goc0A = parcelRequire("goc0A");
var $b0b29d56aa848400$export$3ba8992de7b705bc = (0, $7B57i.visualElement)((0, $S3LFa.__assign)((0, $S3LFa.__assign)({}, (0, $2A5Ic.htmlConfig)), {
    getBaseTarget: function(props, key) {
        return props[key];
    },
    readValueFromInstance: function(domElement, key) {
        var _a;
        if ((0, $479mE.isTransformProp)(key)) return ((_a = (0, $7Wu8u.getDefaultValueType)(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
        key = !(0, $jGXUL.camelCaseAttributes).has(key) ? (0, $8hfRg.camelToDash)(key) : key;
        return domElement.getAttribute(key);
    },
    scrapeMotionValuesFromProps: (0, $2VBTm.scrapeMotionValuesFromProps),
    build: function(_element, renderState, latestValues, projection, layoutState, options, props) {
        var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
        (0, $ggwHU.buildSVGAttrs)(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? (0, $goc0A.buildLayoutProjectionTransform) : undefined, isProjectionTranform ? (0, $goc0A.buildLayoutProjectionTransformOrigin) : undefined);
    },
    render: (0, $bWfLo.renderSVG)
}));

});



parcelRegister("hDp8f", function(module, exports) {
"use strict";
var $cd6992e5a2b6f7b8$var$__assign = module.exports && module.exports.__assign || function() {
    $cd6992e5a2b6f7b8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cd6992e5a2b6f7b8$var$__assign.apply(this, arguments);
};
var $cd6992e5a2b6f7b8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StyledButtonWrapper = module.exports.StyledIconButton = module.exports.StyledIndicatorIconButton = module.exports.StyledFiberManualRecordIcon = module.exports.StyledIndicators = module.exports.StyledItemWrapper = module.exports.StyledItem = module.exports.StyledRoot = void 0;

var $cd6992e5a2b6f7b8$var$FiberManualRecord_1 = $cd6992e5a2b6f7b8$var$__importDefault((parcelRequire("5Ym5G")));

var $5E1Yl = parcelRequire("5E1Yl");
var $9JxvO = parcelRequire("9JxvO");
module.exports.StyledRoot = (0, $9JxvO.default)("div")({
    position: "relative",
    overflow: "hidden"
});
module.exports.StyledItem = (0, $9JxvO.default)("div")({
    position: "absolute",
    height: "100%",
    width: "100%"
});
module.exports.StyledItemWrapper = (0, $9JxvO.default)("div")({
    position: "relative",
    width: "100%",
    height: "100%"
});
module.exports.StyledIndicators = (0, $9JxvO.default)("div")({
    width: "100%",
    marginTop: "10px",
    textAlign: "center"
});
module.exports.StyledFiberManualRecordIcon = (0, $9JxvO.default)($cd6992e5a2b6f7b8$var$FiberManualRecord_1.default)({
    fontSize: "15px"
});
module.exports.StyledIndicatorIconButton = (0, $9JxvO.default)($5E1Yl.default, {
    shouldForwardProp: function(propName) {
        return !propName.startsWith("$");
    }
})(function(_a) {
    var $active = _a.$active;
    return {
        cursor: "pointer",
        transition: "200ms",
        padding: 0,
        color: $active ? "#494949" : "#afafaf",
        "&:hover": {
            color: $active ? "#494949" : "#1f1f1f"
        },
        "&:active": {
            color: $active ? "#494949" : "#1f1f1f"
        }
    };
});
module.exports.StyledIconButton = (0, $9JxvO.default)($5E1Yl.default, {
    shouldForwardProp: function(propName) {
        return !propName.startsWith("$");
    }
})(function(_a) {
    var $alwaysVisible = _a.$alwaysVisible;
    return {
        margin: "0 10px",
        position: "relative",
        backgroundColor: "#494949",
        top: "calc(50% - 20px) !important",
        color: "white",
        fontSize: "30px",
        transition: "200ms",
        cursor: "pointer",
        opacity: $alwaysVisible ? "1" : "0",
        "&:hover": {
            opacity: "0.6 !important"
        }
    };
});
module.exports.StyledButtonWrapper = (0, $9JxvO.default)("div", {
    shouldForwardProp: function(propName) {
        return !propName.startsWith("$");
    }
})(function(_a) {
    var $next = _a.$next, $prev = _a.$prev, $fullHeightHover = _a.$fullHeightHover;
    return $cd6992e5a2b6f7b8$var$__assign($cd6992e5a2b6f7b8$var$__assign($cd6992e5a2b6f7b8$var$__assign({
        position: "absolute",
        height: "100px",
        backgroundColor: "transparent",
        zIndex: 1,
        top: "calc(50% - 70px)",
        "&:hover": {
            "& button": {
                backgroundColor: "black",
                filter: "brightness(120%)",
                opacity: "0.4"
            }
        }
    }, $fullHeightHover ? {
        height: "100%",
        top: "0"
    } : undefined), $next ? {
        right: 0
    } : undefined), $prev ? {
        left: 0
    } : undefined);
});

});
parcelRegister("5Ym5G", function(module, exports) {
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4593b1119371bf60$var$_createSvgIcon = $2NJ2K((parcelRequire("jPQeH")));

var $izf4p = parcelRequire("izf4p");
var $4593b1119371bf60$var$_default = module.exports.default = (0, $4593b1119371bf60$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "8"
}), "FiberManualRecord");

});
parcelRegister("jPQeH", function(module, exports) {
"use strict";
"use client";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8kSwa.default;
    }
});

var $8kSwa = parcelRequire("8kSwa");

});
parcelRegister("8kSwa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0190f1780a06bb1a$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $2IV2K = parcelRequire("2IV2K");

var $izf4p = parcelRequire("izf4p");
"use client";
function $0190f1780a06bb1a$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $izf4p.jsx)((0, $2IV2K.default), (0, $lzDk3.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $2IV2K.default).muiName;
    return /*#__PURE__*/ $4YNlq.memo(/*#__PURE__*/ $4YNlq.forwardRef(Component));
}

});
parcelRegister("2IV2K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fbbf074a294d14d$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $doYRo = parcelRequire("doYRo");

var $9jq0s = parcelRequire("9jq0s");

var $ckQri = parcelRequire("ckQri");

var $9JxvO = parcelRequire("9JxvO");

var $e5rNj = parcelRequire("e5rNj");

var $izf4p = parcelRequire("izf4p");
"use client";
const $1fbbf074a294d14d$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $1fbbf074a294d14d$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            color !== "inherit" && `color${(0, $9jq0s.default)(color)}`,
            `fontSize${(0, $9jq0s.default)(fontSize)}`
        ]
    };
    return (0, $doYRo.default)(slots, (0, $e5rNj.getSvgIconUtilityClass), classes);
};
const $1fbbf074a294d14d$var$SvgIconRoot = (0, $9JxvO.default)("svg", {
    name: "MuiSvgIcon",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "inherit" && styles[`color${(0, $9jq0s.default)(ownerState.color)}`],
            styles[`fontSize${(0, $9jq0s.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: "none",
        width: "1em",
        height: "1em",
        display: "inline-block",
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : "currentColor",
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, "fill", {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: "inherit",
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || "1.25rem",
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || "1.5rem",
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || "2.1875rem"
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $1fbbf074a294d14d$var$SvgIcon = /*#__PURE__*/ $4YNlq.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $ckQri.default)({
        props: inProps,
        name: "MuiSvgIcon"
    });
    const { children: children, className: className, color: color = "inherit", component: component = "svg", fontSize: fontSize = "medium", htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = "0 0 24 24" } = props, other = (0, $g54n0.default)(props, $1fbbf074a294d14d$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $4YNlq.isValidElement(children) && children.type === "svg";
    const ownerState = (0, $lzDk3.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $1fbbf074a294d14d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($1fbbf074a294d14d$var$SvgIconRoot, (0, $lzDk3.default)({
        as: component,
        className: (0, $fQQpK.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? "img" : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $izf4p.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$1fbbf074a294d14d$var$SvgIcon.muiName = "SvgIcon";
var $1fbbf074a294d14d$export$2e2bcd8739ae039 = $1fbbf074a294d14d$var$SvgIcon;

});
parcelRegister("doYRo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $028497a465ecb0fc$export$2e2bcd8739ae039; });
function $028497a465ecb0fc$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== "") acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(" ");
    });
    return output;
}

});

parcelRegister("9jq0s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01bfe77ab229f4ae$export$2e2bcd8739ae039; });

var $f8Qr0 = parcelRequire("f8Qr0");
var $01bfe77ab229f4ae$export$2e2bcd8739ae039 = (0, $f8Qr0.default);

});
parcelRegister("f8Qr0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b06046c5854c2c9a$export$2e2bcd8739ae039; });

var $ctPpH = parcelRequire("ctPpH");
function $b06046c5854c2c9a$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $ctPpH.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("ctPpH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91601319e218d9dc$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $91601319e218d9dc$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("ckQri", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02514a720acf8ab9$export$2e2bcd8739ae039; });

var $4yUyy = parcelRequire("4yUyy");

var $bFD7P = parcelRequire("bFD7P");

var $82Jnz = parcelRequire("82Jnz");
"use client";
function $02514a720acf8ab9$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $4yUyy.default)({
        props: props,
        name: name,
        defaultTheme: $bFD7P.default,
        themeId: (0, $82Jnz.default)
    });
}

});
parcelRegister("4yUyy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3526355251a97cb0$export$2e2bcd8739ae039; });

var $lwBE4 = parcelRequire("lwBE4");

var $fqQIZ = parcelRequire("fqQIZ");
"use client";
function $3526355251a97cb0$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $fqQIZ.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $lwBE4.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("lwBE4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fab9c9b8d4cdaa17$export$2e2bcd8739ae039; });

var $6F5ei = parcelRequire("6F5ei");
function $fab9c9b8d4cdaa17$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $6F5ei.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("6F5ei", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d9aa0e3baf916a9$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");
function $4d9aa0e3baf916a9$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $lzDk3.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $lzDk3.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $lzDk3.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $4d9aa0e3baf916a9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("fqQIZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3c22eb9f0dca88c$export$2e2bcd8739ae039; });

var $7iWPz = parcelRequire("7iWPz");

var $bcmaA = parcelRequire("bcmaA");
"use client";
const $b3c22eb9f0dca88c$export$35e57303dbd8a66 = (0, $7iWPz.default)();
function $b3c22eb9f0dca88c$var$useTheme(defaultTheme = $b3c22eb9f0dca88c$export$35e57303dbd8a66) {
    return (0, $bcmaA.default)(defaultTheme);
}
var $b3c22eb9f0dca88c$export$2e2bcd8739ae039 = $b3c22eb9f0dca88c$var$useTheme;

});
parcelRegister("7iWPz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5517d9655578a68d$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $kg8BC = parcelRequire("kg8BC");

var $gy3fw = parcelRequire("gy3fw");

var $lhbAb = parcelRequire("lhbAb");

var $e8TgX = parcelRequire("e8TgX");

var $kdM0R = parcelRequire("kdM0R");

var $l60DL = parcelRequire("l60DL");

var $42Ilc = parcelRequire("42Ilc");
const $5517d9655578a68d$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $5517d9655578a68d$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $g54n0.default)(options, $5517d9655578a68d$var$_excluded);
    const breakpoints = (0, $gy3fw.default)(breakpointsInput);
    const spacing = (0, $e8TgX.default)(spacingInput);
    let muiTheme = (0, $kg8BC.default)({
        breakpoints: breakpoints,
        direction: "ltr",
        components: {},
        // Inject component definitions.
        palette: (0, $lzDk3.default)({
            mode: "light"
        }, paletteInput),
        spacing: spacing,
        shape: (0, $lzDk3.default)({}, (0, $lhbAb.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $42Ilc.default);
    muiTheme = args.reduce((acc, argument)=>(0, $kg8BC.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $lzDk3.default)({}, (0, $l60DL.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $kdM0R.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $5517d9655578a68d$export$2e2bcd8739ae039 = $5517d9655578a68d$var$createTheme;

});
parcelRegister("kg8BC", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $ebfbfa34d9b4a2fb$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $ebfbfa34d9b4a2fb$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");
function $ebfbfa34d9b4a2fb$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $ebfbfa34d9b4a2fb$var$deepClone(source) {
    if (!$ebfbfa34d9b4a2fb$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $ebfbfa34d9b4a2fb$var$deepClone(source[key]);
    });
    return output;
}
function $ebfbfa34d9b4a2fb$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $lzDk3.default)({}, target) : target;
    if ($ebfbfa34d9b4a2fb$export$53b83ca8eaab0383(target) && $ebfbfa34d9b4a2fb$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($ebfbfa34d9b4a2fb$export$53b83ca8eaab0383(source[key]) && key in target && $ebfbfa34d9b4a2fb$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $ebfbfa34d9b4a2fb$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $ebfbfa34d9b4a2fb$export$53b83ca8eaab0383(source[key]) ? $ebfbfa34d9b4a2fb$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("gy3fw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0c2578edb6ca757$export$2e2bcd8739ae039; });

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");
const $c0c2578edb6ca757$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $c0c2578edb6ca757$export$ebf128a87553cecf = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
const $c0c2578edb6ca757$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $lzDk3.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $c0c2578edb6ca757$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = "px", step: step = 5 } = breakpoints, other = (0, $g54n0.default)(breakpoints, $c0c2578edb6ca757$var$_excluded);
    const sortedValues = $c0c2578edb6ca757$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === "number" ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === "number" ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === "number" ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace("@media", "@media not all and");
    }
    return (0, $lzDk3.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("lhbAb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7d42b980912f5d2$export$2e2bcd8739ae039; });
const $f7d42b980912f5d2$var$shape = {
    borderRadius: 4
};
var $f7d42b980912f5d2$export$2e2bcd8739ae039 = $f7d42b980912f5d2$var$shape;

});

parcelRegister("e8TgX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4bcb0069f2becf5$export$2e2bcd8739ae039; });

var $bKPvM = parcelRequire("bKPvM");
function $a4bcb0069f2becf5$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $bKPvM.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === "number" ? `${output}px` : output;
        }).join(" ");
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("bKPvM", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $88ebf2b75400ece8$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $88ebf2b75400ece8$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $88ebf2b75400ece8$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $88ebf2b75400ece8$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $88ebf2b75400ece8$export$6f98e8eaf0be1996; });


var $73HsT = parcelRequire("73HsT");

var $5lDde = parcelRequire("5lDde");

var $3LK04 = parcelRequire("3LK04");

var $ltKYl = parcelRequire("ltKYl");
const $88ebf2b75400ece8$var$properties = {
    m: "margin",
    p: "padding"
};
const $88ebf2b75400ece8$var$directions = {
    t: "Top",
    r: "Right",
    b: "Bottom",
    l: "Left",
    x: [
        "Left",
        "Right"
    ],
    y: [
        "Top",
        "Bottom"
    ]
};
const $88ebf2b75400ece8$var$aliases = {
    marginX: "mx",
    marginY: "my",
    paddingX: "px",
    paddingY: "py"
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $88ebf2b75400ece8$var$getCssProperties = (0, $ltKYl.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($88ebf2b75400ece8$var$aliases[prop]) prop = $88ebf2b75400ece8$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split("");
    const property = $88ebf2b75400ece8$var$properties[a];
    const direction = $88ebf2b75400ece8$var$directions[b] || "";
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $88ebf2b75400ece8$export$aab52a0dde05ad8a = [
    "m",
    "mt",
    "mr",
    "mb",
    "ml",
    "mx",
    "my",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginX",
    "marginY",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd"
];
const $88ebf2b75400ece8$export$f8397d44f03ab6ad = [
    "p",
    "pt",
    "pr",
    "pb",
    "pl",
    "px",
    "py",
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingX",
    "paddingY",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd"
];
const $88ebf2b75400ece8$var$spacingKeys = [
    ...$88ebf2b75400ece8$export$aab52a0dde05ad8a,
    ...$88ebf2b75400ece8$export$f8397d44f03ab6ad
];
function $88ebf2b75400ece8$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $5lDde.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === "number") return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === "string") return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === "function") return themeSpacing;
    return ()=>undefined;
}
function $88ebf2b75400ece8$export$1def6f833384e3d1(theme) {
    return $88ebf2b75400ece8$export$cb5ee237cce814a2(theme, "spacing", 8, "spacing");
}
function $88ebf2b75400ece8$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === "string" || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === "number") return -transformed;
    return `-${transformed}`;
}
function $88ebf2b75400ece8$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $88ebf2b75400ece8$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $88ebf2b75400ece8$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $88ebf2b75400ece8$var$getCssProperties(prop);
    const styleFromPropValue = $88ebf2b75400ece8$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $73HsT.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $88ebf2b75400ece8$var$style(props, keys) {
    const transformer = $88ebf2b75400ece8$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$88ebf2b75400ece8$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $3LK04.default), {});
}
function $88ebf2b75400ece8$export$7ede87f9b603dd3c(props) {
    return $88ebf2b75400ece8$var$style(props, $88ebf2b75400ece8$export$aab52a0dde05ad8a);
}
$88ebf2b75400ece8$export$7ede87f9b603dd3c.propTypes = {};
$88ebf2b75400ece8$export$7ede87f9b603dd3c.filterProps = $88ebf2b75400ece8$export$aab52a0dde05ad8a;
function $88ebf2b75400ece8$export$6f98e8eaf0be1996(props) {
    return $88ebf2b75400ece8$var$style(props, $88ebf2b75400ece8$export$f8397d44f03ab6ad);
}
$88ebf2b75400ece8$export$6f98e8eaf0be1996.propTypes = {};
$88ebf2b75400ece8$export$6f98e8eaf0be1996.filterProps = $88ebf2b75400ece8$export$f8397d44f03ab6ad;
function $88ebf2b75400ece8$var$spacing(props) {
    return $88ebf2b75400ece8$var$style(props, $88ebf2b75400ece8$var$spacingKeys);
}
$88ebf2b75400ece8$var$spacing.propTypes = {};
$88ebf2b75400ece8$var$spacing.filterProps = $88ebf2b75400ece8$var$spacingKeys;
var $88ebf2b75400ece8$export$2e2bcd8739ae039 = $88ebf2b75400ece8$var$spacing;

});
parcelRegister("73HsT", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $523a877bd8a3662e$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $523a877bd8a3662e$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $523a877bd8a3662e$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $523a877bd8a3662e$export$8922c90b6e020726; });

var $lzDk3 = parcelRequire("lzDk3");


var $kg8BC = parcelRequire("kg8BC");

var $3LK04 = parcelRequire("3LK04");
const $523a877bd8a3662e$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $523a877bd8a3662e$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ],
    up: (key)=>`@media (min-width:${$523a877bd8a3662e$export$68c286be0e7e55b7[key]}px)`
};
function $523a877bd8a3662e$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $523a877bd8a3662e$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === "object") {
        const themeBreakpoints = theme.breakpoints || $523a877bd8a3662e$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $523a877bd8a3662e$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $523a877bd8a3662e$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $523a877bd8a3662e$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $lzDk3.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $3LK04.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        "xs",
        "sm",
        "md",
        "lg",
        "xl",
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $523a877bd8a3662e$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $523a877bd8a3662e$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $523a877bd8a3662e$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $523a877bd8a3662e$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $kg8BC.default)(prev, next), {});
    return $523a877bd8a3662e$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $523a877bd8a3662e$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== "object") return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $523a877bd8a3662e$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $523a877bd8a3662e$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === "object") {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $523a877bd8a3662e$export$2e2bcd8739ae039 = $523a877bd8a3662e$var$breakpoints;

});
parcelRegister("3LK04", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2be9718e4abdc35f$export$2e2bcd8739ae039; });

var $kg8BC = parcelRequire("kg8BC");
function $2be9718e4abdc35f$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $kg8BC.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $2be9718e4abdc35f$export$2e2bcd8739ae039 = $2be9718e4abdc35f$var$merge;

});


parcelRegister("5lDde", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $3e4d54ae34939fb8$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $3e4d54ae34939fb8$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $3e4d54ae34939fb8$export$2e2bcd8739ae039; });

var $8HZ4D = parcelRequire("8HZ4D");


var $73HsT = parcelRequire("73HsT");
function $3e4d54ae34939fb8$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== "string") return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split(".").reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split(".").reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $3e4d54ae34939fb8$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === "function") value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $3e4d54ae34939fb8$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $3e4d54ae34939fb8$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $3e4d54ae34939fb8$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $3e4d54ae34939fb8$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = $3e4d54ae34939fb8$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $8HZ4D.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $73HsT.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $3e4d54ae34939fb8$export$2e2bcd8739ae039 = $3e4d54ae34939fb8$var$style;

});
parcelRegister("8HZ4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6571b6dd293ea4ce$export$2e2bcd8739ae039; });

var $fSD5d = parcelRequire("fSD5d");
function $6571b6dd293ea4ce$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new Error((0, $fSD5d.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("fSD5d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8fa373c071c879c$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $b8fa373c071c879c$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = "https://mui.com/production-error/?code=" + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += "&args[]=" + encodeURIComponent(arguments[i]);
    return "Minified MUI error #" + code + "; visit " + url + " for the full message.";
/* eslint-enable prefer-template */ }

});



parcelRegister("ltKYl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa30be1f02ce436b$export$2e2bcd8739ae039; });
function $fa30be1f02ce436b$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("kdM0R", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $03cc8d7b7f9e1113$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $03cc8d7b7f9e1113$export$2e2bcd8739ae039; });

var $8HZ4D = parcelRequire("8HZ4D");

var $3LK04 = parcelRequire("3LK04");

var $5lDde = parcelRequire("5lDde");

var $73HsT = parcelRequire("73HsT");

var $l60DL = parcelRequire("l60DL");
function $03cc8d7b7f9e1113$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $03cc8d7b7f9e1113$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === "function" ? maybeFn(arg) : maybeFn;
}
function $03cc8d7b7f9e1113$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === "typography" && val === "inherit") return {
            [prop]: val
        };
        const themeMapping = (0, $5lDde.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $5lDde.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === "string") // Haven't found value
            value = (0, $5lDde.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === "default" ? "" : (0, $8HZ4D.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $73HsT.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {} } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $l60DL.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === "function") sxObject = sxInput(theme);
            else if (typeof sxInput !== "object") // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $73HsT.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $03cc8d7b7f9e1113$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === "object") {
                        if (config[styleKey]) css = (0, $3LK04.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $73HsT.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($03cc8d7b7f9e1113$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme
                            });
                            else css = (0, $3LK04.default)(css, breakpointsValues);
                        }
                    } else css = (0, $3LK04.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            return (0, $73HsT.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $03cc8d7b7f9e1113$var$styleFunctionSx = $03cc8d7b7f9e1113$export$7d53d8bf2911e013();
$03cc8d7b7f9e1113$var$styleFunctionSx.filterProps = [
    "sx"
];
var $03cc8d7b7f9e1113$export$2e2bcd8739ae039 = $03cc8d7b7f9e1113$var$styleFunctionSx;

});
parcelRegister("l60DL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5baa7b13c06cd62$export$2e2bcd8739ae039; });

var $bKPvM = parcelRequire("bKPvM");

var $fB8I6 = parcelRequire("fB8I6");

var $kRAzb = parcelRequire("kRAzb");

var $cdjdi = parcelRequire("cdjdi");

var $lAeeA = parcelRequire("lAeeA");
const $f5baa7b13c06cd62$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: "borders",
        transform: (0, $fB8I6.borderTransform)
    },
    borderTop: {
        themeKey: "borders",
        transform: (0, $fB8I6.borderTransform)
    },
    borderRight: {
        themeKey: "borders",
        transform: (0, $fB8I6.borderTransform)
    },
    borderBottom: {
        themeKey: "borders",
        transform: (0, $fB8I6.borderTransform)
    },
    borderLeft: {
        themeKey: "borders",
        transform: (0, $fB8I6.borderTransform)
    },
    borderColor: {
        themeKey: "palette"
    },
    borderTopColor: {
        themeKey: "palette"
    },
    borderRightColor: {
        themeKey: "palette"
    },
    borderBottomColor: {
        themeKey: "palette"
    },
    borderLeftColor: {
        themeKey: "palette"
    },
    outline: {
        themeKey: "borders",
        transform: (0, $fB8I6.borderTransform)
    },
    outlineColor: {
        themeKey: "palette"
    },
    borderRadius: {
        themeKey: "shape.borderRadius",
        style: (0, $fB8I6.borderRadius)
    },
    // palette
    color: {
        themeKey: "palette",
        transform: (0, $cdjdi.paletteTransform)
    },
    bgcolor: {
        themeKey: "palette",
        cssProperty: "backgroundColor",
        transform: (0, $cdjdi.paletteTransform)
    },
    backgroundColor: {
        themeKey: "palette",
        transform: (0, $cdjdi.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $bKPvM.padding)
    },
    pt: {
        style: (0, $bKPvM.padding)
    },
    pr: {
        style: (0, $bKPvM.padding)
    },
    pb: {
        style: (0, $bKPvM.padding)
    },
    pl: {
        style: (0, $bKPvM.padding)
    },
    px: {
        style: (0, $bKPvM.padding)
    },
    py: {
        style: (0, $bKPvM.padding)
    },
    padding: {
        style: (0, $bKPvM.padding)
    },
    paddingTop: {
        style: (0, $bKPvM.padding)
    },
    paddingRight: {
        style: (0, $bKPvM.padding)
    },
    paddingBottom: {
        style: (0, $bKPvM.padding)
    },
    paddingLeft: {
        style: (0, $bKPvM.padding)
    },
    paddingX: {
        style: (0, $bKPvM.padding)
    },
    paddingY: {
        style: (0, $bKPvM.padding)
    },
    paddingInline: {
        style: (0, $bKPvM.padding)
    },
    paddingInlineStart: {
        style: (0, $bKPvM.padding)
    },
    paddingInlineEnd: {
        style: (0, $bKPvM.padding)
    },
    paddingBlock: {
        style: (0, $bKPvM.padding)
    },
    paddingBlockStart: {
        style: (0, $bKPvM.padding)
    },
    paddingBlockEnd: {
        style: (0, $bKPvM.padding)
    },
    m: {
        style: (0, $bKPvM.margin)
    },
    mt: {
        style: (0, $bKPvM.margin)
    },
    mr: {
        style: (0, $bKPvM.margin)
    },
    mb: {
        style: (0, $bKPvM.margin)
    },
    ml: {
        style: (0, $bKPvM.margin)
    },
    mx: {
        style: (0, $bKPvM.margin)
    },
    my: {
        style: (0, $bKPvM.margin)
    },
    margin: {
        style: (0, $bKPvM.margin)
    },
    marginTop: {
        style: (0, $bKPvM.margin)
    },
    marginRight: {
        style: (0, $bKPvM.margin)
    },
    marginBottom: {
        style: (0, $bKPvM.margin)
    },
    marginLeft: {
        style: (0, $bKPvM.margin)
    },
    marginX: {
        style: (0, $bKPvM.margin)
    },
    marginY: {
        style: (0, $bKPvM.margin)
    },
    marginInline: {
        style: (0, $bKPvM.margin)
    },
    marginInlineStart: {
        style: (0, $bKPvM.margin)
    },
    marginInlineEnd: {
        style: (0, $bKPvM.margin)
    },
    marginBlock: {
        style: (0, $bKPvM.margin)
    },
    marginBlockStart: {
        style: (0, $bKPvM.margin)
    },
    marginBlockEnd: {
        style: (0, $bKPvM.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                "@media print": {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $kRAzb.gap)
    },
    rowGap: {
        style: (0, $kRAzb.rowGap)
    },
    columnGap: {
        style: (0, $kRAzb.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: "zIndex"
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: "shadows"
    },
    // sizing
    width: {
        transform: (0, $lAeeA.sizingTransform)
    },
    maxWidth: {
        style: (0, $lAeeA.maxWidth)
    },
    minWidth: {
        transform: (0, $lAeeA.sizingTransform)
    },
    height: {
        transform: (0, $lAeeA.sizingTransform)
    },
    maxHeight: {
        transform: (0, $lAeeA.sizingTransform)
    },
    minHeight: {
        transform: (0, $lAeeA.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: "typography"
    },
    fontSize: {
        themeKey: "typography"
    },
    fontStyle: {
        themeKey: "typography"
    },
    fontWeight: {
        themeKey: "typography"
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: "typography"
    }
};
var $f5baa7b13c06cd62$export$2e2bcd8739ae039 = $f5baa7b13c06cd62$var$defaultSxConfig;

});
parcelRegister("fB8I6", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $b5b11163382b81c2$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $b5b11163382b81c2$export$7a57f79000377ca2; });


var $5lDde = parcelRequire("5lDde");

var $jBgxY = parcelRequire("jBgxY");

var $bKPvM = parcelRequire("bKPvM");

var $73HsT = parcelRequire("73HsT");
function $b5b11163382b81c2$export$34e2febe53ae29cc(value) {
    if (typeof value !== "number") return value;
    return `${value}px solid`;
}
function $b5b11163382b81c2$var$createBorderStyle(prop, transform) {
    return (0, $5lDde.default)({
        prop: prop,
        themeKey: "borders",
        transform: transform
    });
}
const $b5b11163382b81c2$export$1edee58a52776cd9 = $b5b11163382b81c2$var$createBorderStyle("border", $b5b11163382b81c2$export$34e2febe53ae29cc);
const $b5b11163382b81c2$export$f9a7b6bd24892946 = $b5b11163382b81c2$var$createBorderStyle("borderTop", $b5b11163382b81c2$export$34e2febe53ae29cc);
const $b5b11163382b81c2$export$5abca33e6be905d2 = $b5b11163382b81c2$var$createBorderStyle("borderRight", $b5b11163382b81c2$export$34e2febe53ae29cc);
const $b5b11163382b81c2$export$e2ce9f12a980a822 = $b5b11163382b81c2$var$createBorderStyle("borderBottom", $b5b11163382b81c2$export$34e2febe53ae29cc);
const $b5b11163382b81c2$export$47658cca1a909427 = $b5b11163382b81c2$var$createBorderStyle("borderLeft", $b5b11163382b81c2$export$34e2febe53ae29cc);
const $b5b11163382b81c2$export$e7fb0694ba2404fc = $b5b11163382b81c2$var$createBorderStyle("borderColor");
const $b5b11163382b81c2$export$126a92c968acdb85 = $b5b11163382b81c2$var$createBorderStyle("borderTopColor");
const $b5b11163382b81c2$export$85cc51cb8fbb8c0e = $b5b11163382b81c2$var$createBorderStyle("borderRightColor");
const $b5b11163382b81c2$export$340b0327727f6d1a = $b5b11163382b81c2$var$createBorderStyle("borderBottomColor");
const $b5b11163382b81c2$export$60beef91a985b4bf = $b5b11163382b81c2$var$createBorderStyle("borderLeftColor");
const $b5b11163382b81c2$export$f9258c55612cbed7 = $b5b11163382b81c2$var$createBorderStyle("outline", $b5b11163382b81c2$export$34e2febe53ae29cc);
const $b5b11163382b81c2$export$621fe586efeb64b9 = $b5b11163382b81c2$var$createBorderStyle("outlineColor");
const $b5b11163382b81c2$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $bKPvM.createUnaryUnit)(props.theme, "shape.borderRadius", 4, "borderRadius");
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $bKPvM.getValue)(transformer, propValue)
            });
        return (0, $73HsT.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$b5b11163382b81c2$export$7a57f79000377ca2.propTypes = {};
$b5b11163382b81c2$export$7a57f79000377ca2.filterProps = [
    "borderRadius"
];
const $b5b11163382b81c2$var$borders = (0, $jBgxY.default)($b5b11163382b81c2$export$1edee58a52776cd9, $b5b11163382b81c2$export$f9a7b6bd24892946, $b5b11163382b81c2$export$5abca33e6be905d2, $b5b11163382b81c2$export$e2ce9f12a980a822, $b5b11163382b81c2$export$47658cca1a909427, $b5b11163382b81c2$export$e7fb0694ba2404fc, $b5b11163382b81c2$export$126a92c968acdb85, $b5b11163382b81c2$export$85cc51cb8fbb8c0e, $b5b11163382b81c2$export$340b0327727f6d1a, $b5b11163382b81c2$export$60beef91a985b4bf, $b5b11163382b81c2$export$7a57f79000377ca2, $b5b11163382b81c2$export$f9258c55612cbed7, $b5b11163382b81c2$export$621fe586efeb64b9);
var $b5b11163382b81c2$export$2e2bcd8739ae039 = $b5b11163382b81c2$var$borders;

});
parcelRegister("jBgxY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e44e4ee8aca102ed$export$2e2bcd8739ae039; });

var $3LK04 = parcelRequire("3LK04");
function $e44e4ee8aca102ed$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $3LK04.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $e44e4ee8aca102ed$export$2e2bcd8739ae039 = $e44e4ee8aca102ed$var$compose;

});


parcelRegister("kRAzb", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $f3051f3560ba5314$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $f3051f3560ba5314$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $f3051f3560ba5314$export$8a833ffa5f5dbeda; });

var $5lDde = parcelRequire("5lDde");

var $jBgxY = parcelRequire("jBgxY");

var $bKPvM = parcelRequire("bKPvM");

var $73HsT = parcelRequire("73HsT");

const $f3051f3560ba5314$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $bKPvM.createUnaryUnit)(props.theme, "spacing", 8, "gap");
        const styleFromPropValue = (propValue)=>({
                gap: (0, $bKPvM.getValue)(transformer, propValue)
            });
        return (0, $73HsT.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$f3051f3560ba5314$export$5df9adcb0db95e1e.propTypes = {};
$f3051f3560ba5314$export$5df9adcb0db95e1e.filterProps = [
    "gap"
];
const $f3051f3560ba5314$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $bKPvM.createUnaryUnit)(props.theme, "spacing", 8, "columnGap");
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $bKPvM.getValue)(transformer, propValue)
            });
        return (0, $73HsT.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$f3051f3560ba5314$export$ec60d70ff941a580.propTypes = {};
$f3051f3560ba5314$export$ec60d70ff941a580.filterProps = [
    "columnGap"
];
const $f3051f3560ba5314$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $bKPvM.createUnaryUnit)(props.theme, "spacing", 8, "rowGap");
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $bKPvM.getValue)(transformer, propValue)
            });
        return (0, $73HsT.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$f3051f3560ba5314$export$8a833ffa5f5dbeda.propTypes = {};
$f3051f3560ba5314$export$8a833ffa5f5dbeda.filterProps = [
    "rowGap"
];
const $f3051f3560ba5314$export$baf44164ca3a34e8 = (0, $5lDde.default)({
    prop: "gridColumn"
});
const $f3051f3560ba5314$export$8f7213a1cd01e832 = (0, $5lDde.default)({
    prop: "gridRow"
});
const $f3051f3560ba5314$export$b0e0abbc49ba668 = (0, $5lDde.default)({
    prop: "gridAutoFlow"
});
const $f3051f3560ba5314$export$bcd8b929d4b4142 = (0, $5lDde.default)({
    prop: "gridAutoColumns"
});
const $f3051f3560ba5314$export$e5039a674e14c828 = (0, $5lDde.default)({
    prop: "gridAutoRows"
});
const $f3051f3560ba5314$export$42bd9088661ffb03 = (0, $5lDde.default)({
    prop: "gridTemplateColumns"
});
const $f3051f3560ba5314$export$920682ae05b999bc = (0, $5lDde.default)({
    prop: "gridTemplateRows"
});
const $f3051f3560ba5314$export$1b88fbdd482fd33a = (0, $5lDde.default)({
    prop: "gridTemplateAreas"
});
const $f3051f3560ba5314$export$bdb486e40d52d26f = (0, $5lDde.default)({
    prop: "gridArea"
});
const $f3051f3560ba5314$var$grid = (0, $jBgxY.default)($f3051f3560ba5314$export$5df9adcb0db95e1e, $f3051f3560ba5314$export$ec60d70ff941a580, $f3051f3560ba5314$export$8a833ffa5f5dbeda, $f3051f3560ba5314$export$baf44164ca3a34e8, $f3051f3560ba5314$export$8f7213a1cd01e832, $f3051f3560ba5314$export$b0e0abbc49ba668, $f3051f3560ba5314$export$bcd8b929d4b4142, $f3051f3560ba5314$export$e5039a674e14c828, $f3051f3560ba5314$export$42bd9088661ffb03, $f3051f3560ba5314$export$920682ae05b999bc, $f3051f3560ba5314$export$1b88fbdd482fd33a, $f3051f3560ba5314$export$bdb486e40d52d26f);
var $f3051f3560ba5314$export$2e2bcd8739ae039 = $f3051f3560ba5314$var$grid;

});

parcelRegister("cdjdi", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $8e459a52ece03430$export$dbaffd4420ea0ac6; });

var $5lDde = parcelRequire("5lDde");

var $jBgxY = parcelRequire("jBgxY");
function $8e459a52ece03430$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === "grey") return userValue;
    return value;
}
const $8e459a52ece03430$export$35e9368ef982300f = (0, $5lDde.default)({
    prop: "color",
    themeKey: "palette",
    transform: $8e459a52ece03430$export$dbaffd4420ea0ac6
});
const $8e459a52ece03430$export$2506f56c10355b33 = (0, $5lDde.default)({
    prop: "bgcolor",
    cssProperty: "backgroundColor",
    themeKey: "palette",
    transform: $8e459a52ece03430$export$dbaffd4420ea0ac6
});
const $8e459a52ece03430$export$8c5a050822fd698c = (0, $5lDde.default)({
    prop: "backgroundColor",
    themeKey: "palette",
    transform: $8e459a52ece03430$export$dbaffd4420ea0ac6
});
const $8e459a52ece03430$var$palette = (0, $jBgxY.default)($8e459a52ece03430$export$35e9368ef982300f, $8e459a52ece03430$export$2506f56c10355b33, $8e459a52ece03430$export$8c5a050822fd698c);
var $8e459a52ece03430$export$2e2bcd8739ae039 = $8e459a52ece03430$var$palette;

});

parcelRegister("lAeeA", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $fb68005ee52edcc6$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $fb68005ee52edcc6$export$488fda99655ff65a; });

var $5lDde = parcelRequire("5lDde");

var $jBgxY = parcelRequire("jBgxY");

var $73HsT = parcelRequire("73HsT");
function $fb68005ee52edcc6$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $fb68005ee52edcc6$export$7e3df82ee760448c = (0, $5lDde.default)({
    prop: "width",
    transform: $fb68005ee52edcc6$export$8afece71750ec241
});
const $fb68005ee52edcc6$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $73HsT.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $fb68005ee52edcc6$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== "px") return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $73HsT.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$fb68005ee52edcc6$export$488fda99655ff65a.filterProps = [
    "maxWidth"
];
const $fb68005ee52edcc6$export$ee148fbbe8357dd2 = (0, $5lDde.default)({
    prop: "minWidth",
    transform: $fb68005ee52edcc6$export$8afece71750ec241
});
const $fb68005ee52edcc6$export$ac607276a8fe9f0a = (0, $5lDde.default)({
    prop: "height",
    transform: $fb68005ee52edcc6$export$8afece71750ec241
});
const $fb68005ee52edcc6$export$dc0d8bd0b94f8570 = (0, $5lDde.default)({
    prop: "maxHeight",
    transform: $fb68005ee52edcc6$export$8afece71750ec241
});
const $fb68005ee52edcc6$export$a43cf604e12f3b17 = (0, $5lDde.default)({
    prop: "minHeight",
    transform: $fb68005ee52edcc6$export$8afece71750ec241
});
const $fb68005ee52edcc6$export$ffed9f14fb65e276 = (0, $5lDde.default)({
    prop: "size",
    cssProperty: "width",
    transform: $fb68005ee52edcc6$export$8afece71750ec241
});
const $fb68005ee52edcc6$export$905076ed6620e671 = (0, $5lDde.default)({
    prop: "size",
    cssProperty: "height",
    transform: $fb68005ee52edcc6$export$8afece71750ec241
});
const $fb68005ee52edcc6$export$6ccc93f785106a58 = (0, $5lDde.default)({
    prop: "boxSizing"
});
const $fb68005ee52edcc6$var$sizing = (0, $jBgxY.default)($fb68005ee52edcc6$export$7e3df82ee760448c, $fb68005ee52edcc6$export$488fda99655ff65a, $fb68005ee52edcc6$export$ee148fbbe8357dd2, $fb68005ee52edcc6$export$ac607276a8fe9f0a, $fb68005ee52edcc6$export$dc0d8bd0b94f8570, $fb68005ee52edcc6$export$a43cf604e12f3b17, $fb68005ee52edcc6$export$6ccc93f785106a58);
var $fb68005ee52edcc6$export$2e2bcd8739ae039 = $fb68005ee52edcc6$var$sizing;

});



parcelRegister("42Ilc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f19be81787d8fdc$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $2f19be81787d8fdc$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === "function") {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, "*:where($1)");
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("bcmaA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8272032731835b6f$export$2e2bcd8739ae039; });

var $4YNlq = parcelRequire("4YNlq");
parcelRequire("8zt0d");
var $g89D5 = parcelRequire("g89D5");
"use client";
function $8272032731835b6f$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $8272032731835b6f$var$useTheme(defaultTheme = null) {
    const contextTheme = $4YNlq.useContext((0, $g89D5.T));
    return !contextTheme || $8272032731835b6f$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $8272032731835b6f$export$2e2bcd8739ae039 = $8272032731835b6f$var$useTheme;

});



parcelRegister("bFD7P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87f1df8697915365$export$2e2bcd8739ae039; });

var $7KnaE = parcelRequire("7KnaE");
"use client";
const $87f1df8697915365$var$defaultTheme = (0, $7KnaE.default)();
var $87f1df8697915365$export$2e2bcd8739ae039 = $87f1df8697915365$var$defaultTheme;

});
parcelRegister("7KnaE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a3ecd85db799130$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $ctPpH = parcelRequire("ctPpH");

var $jq1sF = parcelRequire("jq1sF");

var $kdM0R = parcelRequire("kdM0R");
var $l60DL = parcelRequire("l60DL");

var $7iWPz = parcelRequire("7iWPz");


var $hNL2W = parcelRequire("hNL2W");

var $aVkFr = parcelRequire("aVkFr");

var $hSqv7 = parcelRequire("hSqv7");

var $2FLwC = parcelRequire("2FLwC");

var $98Xcv = parcelRequire("98Xcv");

var $KOvf9 = parcelRequire("KOvf9");
const $5a3ecd85db799130$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $5a3ecd85db799130$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $g54n0.default)(options, $5a3ecd85db799130$var$_excluded);
    if (options.vars) throw new Error((0, $ctPpH.default)(18));
    const palette = (0, $aVkFr.default)(paletteInput);
    const systemTheme = (0, $7iWPz.default)(options);
    let muiTheme = (0, $jq1sF.default)(systemTheme, {
        mixins: (0, $hNL2W.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $2FLwC.default).slice(),
        typography: (0, $hSqv7.default)(palette, typographyInput),
        transitions: (0, $98Xcv.default)(transitionsInput),
        zIndex: (0, $lzDk3.default)({}, (0, $KOvf9.default))
    });
    muiTheme = (0, $jq1sF.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $jq1sF.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $lzDk3.default)({}, (0, $l60DL.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $kdM0R.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $5a3ecd85db799130$var$warnedOnce = false;
function $5a3ecd85db799130$export$c469355549431d9b(...args) {
    return $5a3ecd85db799130$var$createTheme(...args);
}
var $5a3ecd85db799130$export$2e2bcd8739ae039 = $5a3ecd85db799130$var$createTheme;

});
parcelRegister("jq1sF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e231943924e499b9$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");
function $e231943924e499b9$export$53b83ca8eaab0383(item) {
    if (typeof item !== "object" || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $e231943924e499b9$var$deepClone(source) {
    if (!$e231943924e499b9$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $e231943924e499b9$var$deepClone(source[key]);
    });
    return output;
}
function $e231943924e499b9$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $lzDk3.default)({}, target) : target;
    if ($e231943924e499b9$export$53b83ca8eaab0383(target) && $e231943924e499b9$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        // Avoid prototype pollution
        if (key === "__proto__") return;
        if ($e231943924e499b9$export$53b83ca8eaab0383(source[key]) && key in target && $e231943924e499b9$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $e231943924e499b9$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $e231943924e499b9$export$53b83ca8eaab0383(source[key]) ? $e231943924e499b9$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("hNL2W", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf5b81b1e4f5dce0$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");
function $cf5b81b1e4f5dce0$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $lzDk3.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up("xs")]: {
                "@media (orientation: landscape)": {
                    minHeight: 48
                }
            },
            [breakpoints.up("sm")]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("aVkFr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f3f4259af9250d1$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $ctPpH = parcelRequire("ctPpH");

var $jq1sF = parcelRequire("jq1sF");

var $8SMXk = parcelRequire("8SMXk");

var $8D4JG = parcelRequire("8D4JG");

var $kQnDQ = parcelRequire("kQnDQ");

var $9m6Np = parcelRequire("9m6Np");

var $85JJd = parcelRequire("85JJd");

var $eLIGh = parcelRequire("eLIGh");

var $7FlGy = parcelRequire("7FlGy");

var $iULbc = parcelRequire("iULbc");

var $eM3PH = parcelRequire("eM3PH");
const $7f3f4259af9250d1$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $7f3f4259af9250d1$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: "rgba(0, 0, 0, 0.87)",
        // Secondary text.
        secondary: "rgba(0, 0, 0, 0.6)",
        // Disabled text have even lower visual prominence.
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $8D4JG.default).white,
        default: (0, $8D4JG.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: "rgba(0, 0, 0, 0.54)",
        // The color of an hovered action.
        hover: "rgba(0, 0, 0, 0.04)",
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: "rgba(0, 0, 0, 0.08)",
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: "rgba(0, 0, 0, 0.26)",
        // The background color of a disabled action.
        disabledBackground: "rgba(0, 0, 0, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(0, 0, 0, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $7f3f4259af9250d1$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $8D4JG.default).white,
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
        icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
        paper: "#121212",
        default: "#121212"
    },
    action: {
        active: (0, $8D4JG.default).white,
        hover: "rgba(255, 255, 255, 0.08)",
        hoverOpacity: 0.08,
        selected: "rgba(255, 255, 255, 0.16)",
        selectedOpacity: 0.16,
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        disabledOpacity: 0.38,
        focus: "rgba(255, 255, 255, 0.12)",
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $7f3f4259af9250d1$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === "light") intent.light = (0, $8SMXk.lighten)(intent.main, tonalOffsetLight);
        else if (direction === "dark") intent.dark = (0, $8SMXk.darken)(intent.main, tonalOffsetDark);
    }
}
function $7f3f4259af9250d1$var$getDefaultPrimary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $7FlGy.default)[200],
        light: (0, $7FlGy.default)[50],
        dark: (0, $7FlGy.default)[400]
    };
    return {
        main: (0, $7FlGy.default)[700],
        light: (0, $7FlGy.default)[400],
        dark: (0, $7FlGy.default)[800]
    };
}
function $7f3f4259af9250d1$var$getDefaultSecondary(mode = "light") {
    if (mode === "dark") return {
        main: (0, $9m6Np.default)[200],
        light: (0, $9m6Np.default)[50],
        dark: (0, $9m6Np.default)[400]
    };
    return {
        main: (0, $9m6Np.default)[500],
        light: (0, $9m6Np.default)[300],
        dark: (0, $9m6Np.default)[700]
    };
}
function $7f3f4259af9250d1$var$getDefaultError(mode = "light") {
    if (mode === "dark") return {
        main: (0, $85JJd.default)[500],
        light: (0, $85JJd.default)[300],
        dark: (0, $85JJd.default)[700]
    };
    return {
        main: (0, $85JJd.default)[700],
        light: (0, $85JJd.default)[400],
        dark: (0, $85JJd.default)[800]
    };
}
function $7f3f4259af9250d1$var$getDefaultInfo(mode = "light") {
    if (mode === "dark") return {
        main: (0, $iULbc.default)[400],
        light: (0, $iULbc.default)[300],
        dark: (0, $iULbc.default)[700]
    };
    return {
        main: (0, $iULbc.default)[700],
        light: (0, $iULbc.default)[500],
        dark: (0, $iULbc.default)[900]
    };
}
function $7f3f4259af9250d1$var$getDefaultSuccess(mode = "light") {
    if (mode === "dark") return {
        main: (0, $eM3PH.default)[400],
        light: (0, $eM3PH.default)[300],
        dark: (0, $eM3PH.default)[700]
    };
    return {
        main: (0, $eM3PH.default)[800],
        light: (0, $eM3PH.default)[500],
        dark: (0, $eM3PH.default)[900]
    };
}
function $7f3f4259af9250d1$var$getDefaultWarning(mode = "light") {
    if (mode === "dark") return {
        main: (0, $eLIGh.default)[400],
        light: (0, $eLIGh.default)[300],
        dark: (0, $eLIGh.default)[700]
    };
    return {
        main: "#ed6c02",
        // closest to orange[800] that pass 3:1.
        light: (0, $eLIGh.default)[500],
        dark: (0, $eLIGh.default)[900]
    };
}
function $7f3f4259af9250d1$export$2e2bcd8739ae039(palette) {
    const { mode: mode = "light", contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $g54n0.default)(palette, $7f3f4259af9250d1$var$_excluded);
    const primary = palette.primary || $7f3f4259af9250d1$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $7f3f4259af9250d1$var$getDefaultSecondary(mode);
    const error = palette.error || $7f3f4259af9250d1$var$getDefaultError(mode);
    const info = palette.info || $7f3f4259af9250d1$var$getDefaultInfo(mode);
    const success = palette.success || $7f3f4259af9250d1$var$getDefaultSuccess(mode);
    const warning = palette.warning || $7f3f4259af9250d1$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $8SMXk.getContrastRatio)(background, $7f3f4259af9250d1$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $7f3f4259af9250d1$export$55ce6f3a06c59543.text.primary : $7f3f4259af9250d1$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $lzDk3.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty("main")) throw new Error((0, $ctPpH.default)(11, name ? ` (${name})` : "", mainShade));
        if (typeof color.main !== "string") throw new Error((0, $ctPpH.default)(12, name ? ` (${name})` : "", JSON.stringify(color.main)));
        $7f3f4259af9250d1$var$addLightOrDark(color, "light", lightShade, tonalOffset);
        $7f3f4259af9250d1$var$addLightOrDark(color, "dark", darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $7f3f4259af9250d1$export$55ce6f3a06c59543,
        light: $7f3f4259af9250d1$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $jq1sF.default)((0, $lzDk3.default)({
        // A collection of common colors.
        common: (0, $lzDk3.default)({}, (0, $8D4JG.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: "primary"
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: "secondary",
            mainShade: "A400",
            lightShade: "A200",
            darkShade: "A700"
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: "error"
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: "warning"
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: "info"
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: "success"
        }),
        grey: // The grey colors.
        $kQnDQ.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("8SMXk", function(module, exports) {
"use strict";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $67795779791bdfcf$var$alpha;
module.exports.blend = $67795779791bdfcf$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $67795779791bdfcf$var$darken;
module.exports.decomposeColor = $67795779791bdfcf$var$decomposeColor;
module.exports.emphasize = $67795779791bdfcf$var$emphasize;
module.exports.getContrastRatio = $67795779791bdfcf$var$getContrastRatio;
module.exports.getLuminance = $67795779791bdfcf$var$getLuminance;
module.exports.hexToRgb = $67795779791bdfcf$var$hexToRgb;
module.exports.hslToRgb = $67795779791bdfcf$var$hslToRgb;
module.exports.lighten = $67795779791bdfcf$var$lighten;
module.exports.private_safeAlpha = $67795779791bdfcf$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $67795779791bdfcf$var$private_safeDarken;
module.exports.private_safeEmphasize = $67795779791bdfcf$var$private_safeEmphasize;
module.exports.private_safeLighten = $67795779791bdfcf$var$private_safeLighten;
module.exports.recomposeColor = $67795779791bdfcf$var$recomposeColor;
module.exports.rgbToHex = $67795779791bdfcf$var$rgbToHex;

var $67795779791bdfcf$var$_formatMuiErrorMessage2 = $2NJ2K((parcelRequire("aWVJf")));

var $67795779791bdfcf$var$_clamp = $2NJ2K((parcelRequire("fSJcq")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $67795779791bdfcf$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $67795779791bdfcf$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $67795779791bdfcf$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $67795779791bdfcf$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $67795779791bdfcf$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $67795779791bdfcf$var$decomposeColor($67795779791bdfcf$var$hexToRgb(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $67795779791bdfcf$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $67795779791bdfcf$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $67795779791bdfcf$var$colorChannel = (color)=>{
    const decomposedColor = $67795779791bdfcf$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
module.exports.colorChannel = $67795779791bdfcf$var$colorChannel;
const $67795779791bdfcf$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $67795779791bdfcf$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $67795779791bdfcf$var$private_safeColorChannel;
function $67795779791bdfcf$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $67795779791bdfcf$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $67795779791bdfcf$var$decomposeColor(color);
    return `#${values.map((n, i)=>$67795779791bdfcf$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $67795779791bdfcf$var$hslToRgb(color) {
    color = $67795779791bdfcf$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $67795779791bdfcf$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $67795779791bdfcf$var$getLuminance(color) {
    color = $67795779791bdfcf$var$decomposeColor(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $67795779791bdfcf$var$decomposeColor($67795779791bdfcf$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $67795779791bdfcf$var$getContrastRatio(foreground, background) {
    const lumA = $67795779791bdfcf$var$getLuminance(foreground);
    const lumB = $67795779791bdfcf$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $67795779791bdfcf$var$alpha(color, value) {
    color = $67795779791bdfcf$var$decomposeColor(color);
    value = $67795779791bdfcf$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $67795779791bdfcf$var$recomposeColor(color);
}
function $67795779791bdfcf$var$private_safeAlpha(color, value, warning) {
    try {
        return $67795779791bdfcf$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $67795779791bdfcf$var$darken(color, coefficient) {
    color = $67795779791bdfcf$var$decomposeColor(color);
    coefficient = $67795779791bdfcf$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $67795779791bdfcf$var$recomposeColor(color);
}
function $67795779791bdfcf$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $67795779791bdfcf$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $67795779791bdfcf$var$lighten(color, coefficient) {
    color = $67795779791bdfcf$var$decomposeColor(color);
    coefficient = $67795779791bdfcf$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $67795779791bdfcf$var$recomposeColor(color);
}
function $67795779791bdfcf$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $67795779791bdfcf$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $67795779791bdfcf$var$emphasize(color, coefficient = 0.15) {
    return $67795779791bdfcf$var$getLuminance(color) > 0.5 ? $67795779791bdfcf$var$darken(color, coefficient) : $67795779791bdfcf$var$lighten(color, coefficient);
}
function $67795779791bdfcf$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $67795779791bdfcf$var$private_safeEmphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $67795779791bdfcf$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $67795779791bdfcf$var$decomposeColor(background);
    const overlayColor = $67795779791bdfcf$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $67795779791bdfcf$var$recomposeColor({
        type: "rgb",
        values: rgb
    });
}

});
parcelRegister("aWVJf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fSD5d")).default; });

var $fSD5d = parcelRequire("fSD5d");

});

parcelRegister("fSJcq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("4H2GT")).default; });

var $4H2GT = parcelRequire("4H2GT");

});
parcelRegister("4H2GT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36ad43eee3f73b6d$export$2e2bcd8739ae039; });
function $36ad43eee3f73b6d$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $36ad43eee3f73b6d$export$2e2bcd8739ae039 = $36ad43eee3f73b6d$var$clamp;

});



parcelRegister("8D4JG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6485a3ae778d217b$export$2e2bcd8739ae039; });
const $6485a3ae778d217b$var$common = {
    black: "#000",
    white: "#fff"
};
var $6485a3ae778d217b$export$2e2bcd8739ae039 = $6485a3ae778d217b$var$common;

});

parcelRegister("kQnDQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2cb00bd10e38c9b$export$2e2bcd8739ae039; });
const $f2cb00bd10e38c9b$var$grey = {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
};
var $f2cb00bd10e38c9b$export$2e2bcd8739ae039 = $f2cb00bd10e38c9b$var$grey;

});

parcelRegister("9m6Np", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6cfb70adf87da15b$export$2e2bcd8739ae039; });
const $6cfb70adf87da15b$var$purple = {
    50: "#f3e5f5",
    100: "#e1bee7",
    200: "#ce93d8",
    300: "#ba68c8",
    400: "#ab47bc",
    500: "#9c27b0",
    600: "#8e24aa",
    700: "#7b1fa2",
    800: "#6a1b9a",
    900: "#4a148c",
    A100: "#ea80fc",
    A200: "#e040fb",
    A400: "#d500f9",
    A700: "#aa00ff"
};
var $6cfb70adf87da15b$export$2e2bcd8739ae039 = $6cfb70adf87da15b$var$purple;

});

parcelRegister("85JJd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e42430f10ef1fd8$export$2e2bcd8739ae039; });
const $5e42430f10ef1fd8$var$red = {
    50: "#ffebee",
    100: "#ffcdd2",
    200: "#ef9a9a",
    300: "#e57373",
    400: "#ef5350",
    500: "#f44336",
    600: "#e53935",
    700: "#d32f2f",
    800: "#c62828",
    900: "#b71c1c",
    A100: "#ff8a80",
    A200: "#ff5252",
    A400: "#ff1744",
    A700: "#d50000"
};
var $5e42430f10ef1fd8$export$2e2bcd8739ae039 = $5e42430f10ef1fd8$var$red;

});

parcelRegister("eLIGh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac081d2bfe64d63a$export$2e2bcd8739ae039; });
const $ac081d2bfe64d63a$var$orange = {
    50: "#fff3e0",
    100: "#ffe0b2",
    200: "#ffcc80",
    300: "#ffb74d",
    400: "#ffa726",
    500: "#ff9800",
    600: "#fb8c00",
    700: "#f57c00",
    800: "#ef6c00",
    900: "#e65100",
    A100: "#ffd180",
    A200: "#ffab40",
    A400: "#ff9100",
    A700: "#ff6d00"
};
var $ac081d2bfe64d63a$export$2e2bcd8739ae039 = $ac081d2bfe64d63a$var$orange;

});

parcelRegister("7FlGy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0170ba9088a96c46$export$2e2bcd8739ae039; });
const $0170ba9088a96c46$var$blue = {
    50: "#e3f2fd",
    100: "#bbdefb",
    200: "#90caf9",
    300: "#64b5f6",
    400: "#42a5f5",
    500: "#2196f3",
    600: "#1e88e5",
    700: "#1976d2",
    800: "#1565c0",
    900: "#0d47a1",
    A100: "#82b1ff",
    A200: "#448aff",
    A400: "#2979ff",
    A700: "#2962ff"
};
var $0170ba9088a96c46$export$2e2bcd8739ae039 = $0170ba9088a96c46$var$blue;

});

parcelRegister("iULbc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc520ddb6843e811$export$2e2bcd8739ae039; });
const $dc520ddb6843e811$var$lightBlue = {
    50: "#e1f5fe",
    100: "#b3e5fc",
    200: "#81d4fa",
    300: "#4fc3f7",
    400: "#29b6f6",
    500: "#03a9f4",
    600: "#039be5",
    700: "#0288d1",
    800: "#0277bd",
    900: "#01579b",
    A100: "#80d8ff",
    A200: "#40c4ff",
    A400: "#00b0ff",
    A700: "#0091ea"
};
var $dc520ddb6843e811$export$2e2bcd8739ae039 = $dc520ddb6843e811$var$lightBlue;

});

parcelRegister("eM3PH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac1885846b72990f$export$2e2bcd8739ae039; });
const $ac1885846b72990f$var$green = {
    50: "#e8f5e9",
    100: "#c8e6c9",
    200: "#a5d6a7",
    300: "#81c784",
    400: "#66bb6a",
    500: "#4caf50",
    600: "#43a047",
    700: "#388e3c",
    800: "#2e7d32",
    900: "#1b5e20",
    A100: "#b9f6ca",
    A200: "#69f0ae",
    A400: "#00e676",
    A700: "#00c853"
};
var $ac1885846b72990f$export$2e2bcd8739ae039 = $ac1885846b72990f$var$green;

});


parcelRegister("hSqv7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d03c095958bb337e$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $jq1sF = parcelRequire("jq1sF");
const $d03c095958bb337e$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $d03c095958bb337e$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $d03c095958bb337e$var$caseAllCaps = {
    textTransform: "uppercase"
};
const $d03c095958bb337e$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $d03c095958bb337e$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === "function" ? typography(palette) : typography, { fontFamily: fontFamily = $d03c095958bb337e$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $g54n0.default)(_ref, $d03c095958bb337e$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $lzDk3.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $d03c095958bb337e$var$defaultFontFamily ? {
            letterSpacing: `${$d03c095958bb337e$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $d03c095958bb337e$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $d03c095958bb337e$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: "inherit",
            fontWeight: "inherit",
            fontSize: "inherit",
            lineHeight: "inherit",
            letterSpacing: "inherit"
        }
    };
    return (0, $jq1sF.default)((0, $lzDk3.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("2FLwC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f244695a23fafae$export$2e2bcd8739ae039; });
const $1f244695a23fafae$var$shadowKeyUmbraOpacity = 0.2;
const $1f244695a23fafae$var$shadowKeyPenumbraOpacity = 0.14;
const $1f244695a23fafae$var$shadowAmbientShadowOpacity = 0.12;
function $1f244695a23fafae$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$1f244695a23fafae$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$1f244695a23fafae$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$1f244695a23fafae$var$shadowAmbientShadowOpacity})`
    ].join(",");
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $1f244695a23fafae$var$shadows = [
    "none",
    $1f244695a23fafae$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $1f244695a23fafae$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $1f244695a23fafae$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $1f244695a23fafae$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $1f244695a23fafae$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $1f244695a23fafae$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $1f244695a23fafae$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $1f244695a23fafae$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $1f244695a23fafae$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $1f244695a23fafae$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $1f244695a23fafae$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $1f244695a23fafae$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $1f244695a23fafae$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $1f244695a23fafae$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $1f244695a23fafae$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $1f244695a23fafae$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $1f244695a23fafae$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $1f244695a23fafae$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $1f244695a23fafae$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $1f244695a23fafae$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $1f244695a23fafae$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $1f244695a23fafae$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $1f244695a23fafae$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $1f244695a23fafae$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $1f244695a23fafae$export$2e2bcd8739ae039 = $1f244695a23fafae$var$shadows;

});

parcelRegister("98Xcv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a82c871a44cd89e$export$2e2bcd8739ae039; });

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");
const $6a82c871a44cd89e$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $6a82c871a44cd89e$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: "cubic-bezier(0.4, 0, 1, 1)",
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
const $6a82c871a44cd89e$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $6a82c871a44cd89e$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $6a82c871a44cd89e$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $6a82c871a44cd89e$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $lzDk3.default)({}, $6a82c871a44cd89e$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $lzDk3.default)({}, $6a82c871a44cd89e$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        "all"
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $g54n0.default)(options, $6a82c871a44cd89e$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === "string" ? durationOption : $6a82c871a44cd89e$var$formatMs(durationOption)} ${easingOption} ${typeof delay === "string" ? delay : $6a82c871a44cd89e$var$formatMs(delay)}`).join(",");
    };
    return (0, $lzDk3.default)({
        getAutoHeightDuration: $6a82c871a44cd89e$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("KOvf9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08cb78d24d646ed9$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $08cb78d24d646ed9$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $08cb78d24d646ed9$export$2e2bcd8739ae039 = $08cb78d24d646ed9$var$zIndex;

});



parcelRegister("82Jnz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5db1b60301112564$export$2e2bcd8739ae039; });
var $5db1b60301112564$export$2e2bcd8739ae039 = "$$material";

});


parcelRegister("9JxvO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71624fcfc6d7f6c5$export$2e2bcd8739ae039; });

var $eL1T2 = parcelRequire("eL1T2");

var $bFD7P = parcelRequire("bFD7P");

var $82Jnz = parcelRequire("82Jnz");

var $ftpgK = parcelRequire("ftpgK");

"use client";
const $71624fcfc6d7f6c5$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($eL1T2)))({
    themeId: (0, $82Jnz.default),
    defaultTheme: $bFD7P.default,
    rootShouldForwardProp: $ftpgK.default
});
var $71624fcfc6d7f6c5$export$2e2bcd8739ae039 = $71624fcfc6d7f6c5$var$styled;

});
parcelRegister("eL1T2", function(module, exports) {
"use strict";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $abe6eb26e37f4fc8$var$createStyled;
module.exports.shouldForwardProp = $abe6eb26e37f4fc8$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $abe6eb26e37f4fc8$var$_extends2 = $2NJ2K((parcelRequire("8Awal")));

var $abe6eb26e37f4fc8$var$_objectWithoutPropertiesLoose2 = $2NJ2K((parcelRequire("1VU7c")));

var $abe6eb26e37f4fc8$var$_styledEngine = $abe6eb26e37f4fc8$var$_interopRequireWildcard((parcelRequire("7oEDq")));

var $kg8BC = parcelRequire("kg8BC");

var $abe6eb26e37f4fc8$var$_capitalize = $2NJ2K((parcelRequire("hzUD5")));

var $abe6eb26e37f4fc8$var$_getDisplayName = $2NJ2K((parcelRequire("iSCUI")));

var $abe6eb26e37f4fc8$var$_createTheme = $2NJ2K((parcelRequire("epQjb")));

var $abe6eb26e37f4fc8$var$_styleFunctionSx = $2NJ2K((parcelRequire("DHfzl")));
const $abe6eb26e37f4fc8$var$_excluded = [
    "ownerState"
], $abe6eb26e37f4fc8$var$_excluded2 = [
    "variants"
], $abe6eb26e37f4fc8$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $abe6eb26e37f4fc8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($abe6eb26e37f4fc8$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $abe6eb26e37f4fc8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $abe6eb26e37f4fc8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $abe6eb26e37f4fc8$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $abe6eb26e37f4fc8$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $abe6eb26e37f4fc8$var$shouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $abe6eb26e37f4fc8$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $abe6eb26e37f4fc8$var$_createTheme.default)();
const $abe6eb26e37f4fc8$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $abe6eb26e37f4fc8$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $abe6eb26e37f4fc8$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $abe6eb26e37f4fc8$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $abe6eb26e37f4fc8$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $abe6eb26e37f4fc8$var$_objectWithoutPropertiesLoose2.default)(_ref, $abe6eb26e37f4fc8$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $abe6eb26e37f4fc8$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$abe6eb26e37f4fc8$var$processStyleArg(resolvedStyle, (0, $abe6eb26e37f4fc8$var$_extends2.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $abe6eb26e37f4fc8$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $abe6eb26e37f4fc8$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $abe6eb26e37f4fc8$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $abe6eb26e37f4fc8$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $abe6eb26e37f4fc8$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $abe6eb26e37f4fc8$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $abe6eb26e37f4fc8$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $abe6eb26e37f4fc8$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $abe6eb26e37f4fc8$var$_styleFunctionSx.default)((0, $abe6eb26e37f4fc8$var$_extends2.default)({}, props, {
            theme: $abe6eb26e37f4fc8$var$resolveTheme((0, $abe6eb26e37f4fc8$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $abe6eb26e37f4fc8$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $abe6eb26e37f4fc8$var$defaultOverridesResolver($abe6eb26e37f4fc8$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $abe6eb26e37f4fc8$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $abe6eb26e37f4fc8$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $abe6eb26e37f4fc8$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($abe6eb26e37f4fc8$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $abe6eb26e37f4fc8$var$_styledEngine.default)(tag, (0, $abe6eb26e37f4fc8$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $kg8BC.isPlainObject)(stylesArg)) return (props)=>$abe6eb26e37f4fc8$var$processStyleArg(stylesArg, (0, $abe6eb26e37f4fc8$var$_extends2.default)({}, props, {
                    theme: $abe6eb26e37f4fc8$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $abe6eb26e37f4fc8$var$resolveTheme((0, $abe6eb26e37f4fc8$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $abe6eb26e37f4fc8$var$processStyleArg(slotStyle, (0, $abe6eb26e37f4fc8$var$_extends2.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $abe6eb26e37f4fc8$var$resolveTheme((0, $abe6eb26e37f4fc8$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $abe6eb26e37f4fc8$var$processStyleArg({
                    variants: themeVariants
                }, (0, $abe6eb26e37f4fc8$var$_extends2.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("7oEDq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $562a4b8ca15dd4d8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $562a4b8ca15dd4d8$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("g89D5")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("8zt0d")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("8zt0d")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("jxpyy")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("hHEKe")).default; });
/**
 * @mui/styled-engine v5.15.14
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $bn8NL = parcelRequire("bn8NL");

var $8zt0d = parcelRequire("8zt0d");
var $g89D5 = parcelRequire("g89D5");

var $jxpyy = parcelRequire("jxpyy");

var $hHEKe = parcelRequire("hHEKe");
"use client";
function $562a4b8ca15dd4d8$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $bn8NL.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $562a4b8ca15dd4d8$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};

});
parcelRegister("jxpyy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03abb13b53aaa456$export$2e2bcd8739ae039; });
parcelRequire("4YNlq");


var $g89D5 = parcelRequire("g89D5");

var $6U2ij = parcelRequire("6U2ij");

var $izf4p = parcelRequire("izf4p");
"use client";
let $03abb13b53aaa456$var$cache;
if (typeof document === "object") $03abb13b53aaa456$var$cache = (0, $6U2ij.default)({
    key: "css",
    prepend: true
});
function $03abb13b53aaa456$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, children: children } = props;
    return injectFirst && $03abb13b53aaa456$var$cache ? /*#__PURE__*/ (0, $izf4p.jsx)((0, $g89D5.C), {
        value: $03abb13b53aaa456$var$cache,
        children: children
    }) : children;
}

});

parcelRegister("hHEKe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce360eda609e5fc6$export$2e2bcd8739ae039; });
parcelRequire("4YNlq");


var $8zt0d = parcelRequire("8zt0d");

var $izf4p = parcelRequire("izf4p");
"use client";
function $ce360eda609e5fc6$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $ce360eda609e5fc6$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === "function" ? (themeInput)=>styles($ce360eda609e5fc6$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $8zt0d.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("hzUD5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8HZ4D")).default; });

var $8HZ4D = parcelRequire("8HZ4D");

});

parcelRegister("iSCUI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("lj5GG")).default; });

var $lj5GG = parcelRequire("lj5GG");
$parcel$exportWildcard(module.exports, $lj5GG);

});
parcelRegister("lj5GG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $f82fc8b8ba3e43fa$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $f82fc8b8ba3e43fa$export$2e2bcd8739ae039; });

var $dKCZL = parcelRequire("dKCZL");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $f82fc8b8ba3e43fa$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $f82fc8b8ba3e43fa$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($f82fc8b8ba3e43fa$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || "";
}
function $f82fc8b8ba3e43fa$var$getFunctionComponentName(Component, fallback = "") {
    return Component.displayName || Component.name || $f82fc8b8ba3e43fa$export$aad197c7121a6651(Component) || fallback;
}
function $f82fc8b8ba3e43fa$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $f82fc8b8ba3e43fa$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== "" ? `${wrapperName}(${functionName})` : wrapperName);
}
function $f82fc8b8ba3e43fa$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === "string") return Component;
    if (typeof Component === "function") return $f82fc8b8ba3e43fa$var$getFunctionComponentName(Component, "Component");
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === "object") switch(Component.$$typeof){
        case 0, $dKCZL.ForwardRef:
            return $f82fc8b8ba3e43fa$var$getWrappedName(Component, Component.render, "ForwardRef");
        case 0, $dKCZL.Memo:
            return $f82fc8b8ba3e43fa$var$getWrappedName(Component, Component.type, "memo");
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("epQjb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("7iWPz")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("gy3fw")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("42Ilc")).default; });

var $7iWPz = parcelRequire("7iWPz");

var $gy3fw = parcelRequire("gy3fw");

var $42Ilc = parcelRequire("42Ilc");

});

parcelRegister("DHfzl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("kdM0R")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("kdM0R")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("dYzAO")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("l60DL")).default; });

var $kdM0R = parcelRequire("kdM0R");

var $dYzAO = parcelRequire("dYzAO");

var $l60DL = parcelRequire("l60DL");

});
parcelRegister("dYzAO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2cc7cf66ac07234$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $kg8BC = parcelRequire("kg8BC");

var $l60DL = parcelRequire("l60DL");
const $a2cc7cf66ac07234$var$_excluded = [
    "sx"
];
const $a2cc7cf66ac07234$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $l60DL.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $a2cc7cf66ac07234$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $g54n0.default)(props, $a2cc7cf66ac07234$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $a2cc7cf66ac07234$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === "function") finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $kg8BC.isPlainObject)(result)) return systemProps;
        return (0, $lzDk3.default)({}, systemProps, result);
    };
    else finalSx = (0, $lzDk3.default)({}, systemProps, inSx);
    return (0, $lzDk3.default)({}, otherProps, {
        sx: finalSx
    });
}

});



parcelRegister("ftpgK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b43d2a5d930930c7$export$2e2bcd8739ae039; });

var $6JteZ = parcelRequire("6JteZ");
const $b43d2a5d930930c7$var$rootShouldForwardProp = (prop)=>(0, $6JteZ.default)(prop) && prop !== "classes";
var $b43d2a5d930930c7$export$2e2bcd8739ae039 = $b43d2a5d930930c7$var$rootShouldForwardProp;

});
parcelRegister("6JteZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e6da0a901c6e580$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $4e6da0a901c6e580$var$slotShouldForwardProp(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
var $4e6da0a901c6e580$export$2e2bcd8739ae039 = $4e6da0a901c6e580$var$slotShouldForwardProp;

});



parcelRegister("e5rNj", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $a41717b961e2d001$export$c7c50641356bdfa5; });

var $8SsD1 = parcelRequire("8SsD1");

var $8Q7RY = parcelRequire("8Q7RY");
function $a41717b961e2d001$export$c7c50641356bdfa5(slot) {
    return (0, $8Q7RY.default)("MuiSvgIcon", slot);
}
const $a41717b961e2d001$var$svgIconClasses = (0, $8SsD1.default)("MuiSvgIcon", [
    "root",
    "colorPrimary",
    "colorSecondary",
    "colorAction",
    "colorError",
    "colorDisabled",
    "fontSizeInherit",
    "fontSizeSmall",
    "fontSizeMedium",
    "fontSizeLarge"
]);
var $a41717b961e2d001$export$2e2bcd8739ae039 = $a41717b961e2d001$var$svgIconClasses;

});
parcelRegister("8SsD1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $676992e27f1c5539$export$2e2bcd8739ae039; });

var $8Q7RY = parcelRequire("8Q7RY");
function $676992e27f1c5539$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = "Mui") {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $8Q7RY.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("8Q7RY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66f948cf7feca02a$export$2e2bcd8739ae039; });

var $30MU8 = parcelRequire("30MU8");
const $66f948cf7feca02a$export$9d6b9120de57c54 = {
    active: "active",
    checked: "checked",
    completed: "completed",
    disabled: "disabled",
    error: "error",
    expanded: "expanded",
    focused: "focused",
    focusVisible: "focusVisible",
    open: "open",
    readOnly: "readOnly",
    required: "required",
    selected: "selected"
};
function $66f948cf7feca02a$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = "Mui") {
    const globalStateClass = $66f948cf7feca02a$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $30MU8.default).generate(componentName)}-${slot}`;
}
function $66f948cf7feca02a$export$34c0130b1f3e8ae3(slot) {
    return $66f948cf7feca02a$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("30MU8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23174e9ad54db639$export$2e2bcd8739ae039; });
const $23174e9ad54db639$var$defaultGenerator = (componentName)=>componentName;
const $23174e9ad54db639$var$createClassNameGenerator = ()=>{
    let generate = $23174e9ad54db639$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $23174e9ad54db639$var$defaultGenerator;
        }
    };
};
const $23174e9ad54db639$var$ClassNameGenerator = $23174e9ad54db639$var$createClassNameGenerator();
var $23174e9ad54db639$export$2e2bcd8739ae039 = $23174e9ad54db639$var$ClassNameGenerator;

});








parcelRegister("5E1Yl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41c237d12c089c6a$export$2e2bcd8739ae039; });

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $doYRo = parcelRequire("doYRo");

var $8SMXk = parcelRequire("8SMXk");

var $9JxvO = parcelRequire("9JxvO");

var $ckQri = parcelRequire("ckQri");

var $c4pC3 = parcelRequire("c4pC3");

var $9jq0s = parcelRequire("9jq0s");

var $gHTcu = parcelRequire("gHTcu");

var $izf4p = parcelRequire("izf4p");
"use client";
const $41c237d12c089c6a$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $41c237d12c089c6a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $9jq0s.default)(color)}`,
            edge && `edge${(0, $9jq0s.default)(edge)}`,
            `size${(0, $9jq0s.default)(size)}`
        ]
    };
    return (0, $doYRo.default)(slots, (0, $gHTcu.getIconButtonUtilityClass), classes);
};
const $41c237d12c089c6a$var$IconButtonRoot = (0, $9JxvO.default)((0, $c4pC3.default), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $9jq0s.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $9jq0s.default)(ownerState.edge)}`],
            styles[`size${(0, $9jq0s.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8SMXk.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $lzDk3.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $lzDk3.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $lzDk3.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $8SMXk.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $gHTcu.default).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $41c237d12c089c6a$var$IconButton = /*#__PURE__*/ $4YNlq.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $ckQri.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $g54n0.default)(props, $41c237d12c089c6a$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $41c237d12c089c6a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($41c237d12c089c6a$var$IconButtonRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $41c237d12c089c6a$export$2e2bcd8739ae039 = $41c237d12c089c6a$var$IconButton;

});
parcelRegister("c4pC3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c99b9eebb837d92$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");



var $doYRo = parcelRequire("doYRo");

var $9JxvO = parcelRequire("9JxvO");

var $ckQri = parcelRequire("ckQri");

var $ksMIn = parcelRequire("ksMIn");

var $6IDA6 = parcelRequire("6IDA6");

var $kMiFM = parcelRequire("kMiFM");

var $aSpaB = parcelRequire("aSpaB");

var $bk66D = parcelRequire("bk66D");

var $izf4p = parcelRequire("izf4p");
"use client";
const $8c99b9eebb837d92$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $8c99b9eebb837d92$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $doYRo.default)(slots, (0, $bk66D.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $8c99b9eebb837d92$export$7ec0dcc5e3cdcd36 = (0, $9JxvO.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $bk66D.default).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $8c99b9eebb837d92$var$ButtonBase = /*#__PURE__*/ $4YNlq.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $ckQri.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $g54n0.default)(props, $8c99b9eebb837d92$var$_excluded);
    const buttonRef = $4YNlq.useRef(null);
    const rippleRef = $4YNlq.useRef(null);
    const handleRippleRef = (0, $ksMIn.default)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $kMiFM.default)();
    const [focusVisible, setFocusVisible] = $4YNlq.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $4YNlq.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $4YNlq.useState(false);
    $4YNlq.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $4YNlq.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $6IDA6.default)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $6IDA6.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $4YNlq.useRef(false);
    const handleKeyDown = (0, $6IDA6.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $6IDA6.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $ksMIn.default)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $lzDk3.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $8c99b9eebb837d92$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($8c99b9eebb837d92$export$7ec0dcc5e3cdcd36, (0, $lzDk3.default)({
        as: ComponentProp,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $izf4p.jsx)((0, $aSpaB.default), (0, $lzDk3.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $8c99b9eebb837d92$export$2e2bcd8739ae039 = $8c99b9eebb837d92$var$ButtonBase;

});
parcelRegister("ksMIn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee5c35ec68f10166$export$2e2bcd8739ae039; });

var $e2JCo = parcelRequire("e2JCo");
"use client";
var $ee5c35ec68f10166$export$2e2bcd8739ae039 = (0, $e2JCo.default);

});
parcelRegister("e2JCo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a394a36f51252aa5$export$2e2bcd8739ae039; });

var $4YNlq = parcelRequire("4YNlq");

var $fcFmS = parcelRequire("fcFmS");
"use client";
function $a394a36f51252aa5$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $4YNlq.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $fcFmS.default)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});
parcelRegister("fcFmS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b11810d7dc07e3ad$export$2e2bcd8739ae039; });
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $b11810d7dc07e3ad$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}

});



parcelRegister("6IDA6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e458e294b58f7f0$export$2e2bcd8739ae039; });

var $66N8D = parcelRequire("66N8D");
"use client";
var $4e458e294b58f7f0$export$2e2bcd8739ae039 = (0, $66N8D.default);

});
parcelRegister("66N8D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47296b70e2729b37$export$2e2bcd8739ae039; });

var $4YNlq = parcelRequire("4YNlq");

var $d8w1U = parcelRequire("d8w1U");
"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $47296b70e2729b37$var$useEventCallback(fn) {
    const ref = $4YNlq.useRef(fn);
    (0, $d8w1U.default)(()=>{
        ref.current = fn;
    });
    return $4YNlq.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $47296b70e2729b37$export$2e2bcd8739ae039 = $47296b70e2729b37$var$useEventCallback;

});
parcelRegister("d8w1U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9904de2c06118823$export$2e2bcd8739ae039; });

var $4YNlq = parcelRequire("4YNlq");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $9904de2c06118823$var$useEnhancedEffect = typeof window !== "undefined" ? $4YNlq.useLayoutEffect : $4YNlq.useEffect;
var $9904de2c06118823$export$2e2bcd8739ae039 = $9904de2c06118823$var$useEnhancedEffect;

});



parcelRegister("kMiFM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f206c65d0ba0414c$export$2e2bcd8739ae039; });

var $58cJa = parcelRequire("58cJa");
"use client";
var $f206c65d0ba0414c$export$2e2bcd8739ae039 = (0, $58cJa.default);

});
parcelRegister("58cJa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bc79281d0306328$export$2e2bcd8739ae039; });

var $4YNlq = parcelRequire("4YNlq");

var $2L0xy = parcelRequire("2L0xy");
"use client";
let $3bc79281d0306328$var$hadKeyboardEvent = true;
let $3bc79281d0306328$var$hadFocusVisibleRecently = false;
const $3bc79281d0306328$var$hadFocusVisibleRecentlyTimeout = new (0, $2L0xy.Timeout)();
const $3bc79281d0306328$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $3bc79281d0306328$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $3bc79281d0306328$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $3bc79281d0306328$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $3bc79281d0306328$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $3bc79281d0306328$var$handlePointerDown() {
    $3bc79281d0306328$var$hadKeyboardEvent = false;
}
function $3bc79281d0306328$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($3bc79281d0306328$var$hadFocusVisibleRecently) $3bc79281d0306328$var$hadKeyboardEvent = true;
    }
}
function $3bc79281d0306328$var$prepare(doc) {
    doc.addEventListener("keydown", $3bc79281d0306328$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $3bc79281d0306328$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $3bc79281d0306328$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $3bc79281d0306328$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $3bc79281d0306328$var$handleVisibilityChange, true);
}
function $3bc79281d0306328$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $3bc79281d0306328$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $3bc79281d0306328$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $3bc79281d0306328$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $3bc79281d0306328$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $3bc79281d0306328$var$handleVisibilityChange, true);
}
function $3bc79281d0306328$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $3bc79281d0306328$var$hadKeyboardEvent || $3bc79281d0306328$var$focusTriggersKeyboardModality(target);
}
function $3bc79281d0306328$export$2e2bcd8739ae039() {
    const ref = $4YNlq.useCallback((node)=>{
        if (node != null) $3bc79281d0306328$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $4YNlq.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $3bc79281d0306328$var$hadFocusVisibleRecently = true;
            $3bc79281d0306328$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $3bc79281d0306328$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($3bc79281d0306328$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}

});
parcelRegister("2L0xy", function(module, exports) {

$parcel$export(module.exports, "Timeout", function () { return $202063d5cee6c824$export$786b4da70f00938b; });
$parcel$export(module.exports, "default", function () { return $202063d5cee6c824$export$2e2bcd8739ae039; });

var $inF7i = parcelRequire("inF7i");

var $cYjYg = parcelRequire("cYjYg");
"use client";
class $202063d5cee6c824$export$786b4da70f00938b {
    static create() {
        return new $202063d5cee6c824$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function $202063d5cee6c824$export$2e2bcd8739ae039() {
    const timeout = (0, $inF7i.default)($202063d5cee6c824$export$786b4da70f00938b.create).current;
    (0, $cYjYg.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("inF7i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d61a44eaa2cdee5f$export$2e2bcd8739ae039; });

var $4YNlq = parcelRequire("4YNlq");
"use client";
const $d61a44eaa2cdee5f$var$UNINITIALIZED = {};
function $d61a44eaa2cdee5f$export$2e2bcd8739ae039(init, initArg) {
    const ref = $4YNlq.useRef($d61a44eaa2cdee5f$var$UNINITIALIZED);
    if (ref.current === $d61a44eaa2cdee5f$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});

parcelRegister("cYjYg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $971a9478b4068b29$export$2e2bcd8739ae039; });

var $4YNlq = parcelRequire("4YNlq");
"use client";
const $971a9478b4068b29$var$EMPTY = [];
function $971a9478b4068b29$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $4YNlq.useEffect(fn, $971a9478b4068b29$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});




parcelRegister("aSpaB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7eb278c1580c7b87$export$2e2bcd8739ae039; });

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $1uy3y = parcelRequire("1uy3y");

var $fQQpK = parcelRequire("fQQpK");

var $8zt0d = parcelRequire("8zt0d");

var $2L0xy = parcelRequire("2L0xy");

var $9JxvO = parcelRequire("9JxvO");

var $ckQri = parcelRequire("ckQri");

var $aIKdl = parcelRequire("aIKdl");

var $86GWu = parcelRequire("86GWu");

var $izf4p = parcelRequire("izf4p");
"use client";
const $7eb278c1580c7b87$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $7eb278c1580c7b87$var$_ = (t)=>t, $7eb278c1580c7b87$var$_t, $7eb278c1580c7b87$var$_t2, $7eb278c1580c7b87$var$_t3, $7eb278c1580c7b87$var$_t4;
const $7eb278c1580c7b87$var$DURATION = 550;
const $7eb278c1580c7b87$export$95d0c9356b2231a3 = 80;
const $7eb278c1580c7b87$var$enterKeyframe = (0, $8zt0d.keyframes)($7eb278c1580c7b87$var$_t || ($7eb278c1580c7b87$var$_t = $7eb278c1580c7b87$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $7eb278c1580c7b87$var$exitKeyframe = (0, $8zt0d.keyframes)($7eb278c1580c7b87$var$_t2 || ($7eb278c1580c7b87$var$_t2 = $7eb278c1580c7b87$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $7eb278c1580c7b87$var$pulsateKeyframe = (0, $8zt0d.keyframes)($7eb278c1580c7b87$var$_t3 || ($7eb278c1580c7b87$var$_t3 = $7eb278c1580c7b87$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $7eb278c1580c7b87$export$f6b7418508c72c25 = (0, $9JxvO.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $7eb278c1580c7b87$export$676cfe7b12693c4b = (0, $9JxvO.default)((0, $aIKdl.default), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($7eb278c1580c7b87$var$_t4 || ($7eb278c1580c7b87$var$_t4 = $7eb278c1580c7b87$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $86GWu.default).rippleVisible, $7eb278c1580c7b87$var$enterKeyframe, $7eb278c1580c7b87$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $86GWu.default).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $86GWu.default).child, (0, $86GWu.default).childLeaving, $7eb278c1580c7b87$var$exitKeyframe, $7eb278c1580c7b87$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $86GWu.default).childPulsate, $7eb278c1580c7b87$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $7eb278c1580c7b87$var$TouchRipple = /*#__PURE__*/ $4YNlq.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $ckQri.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $g54n0.default)(props, $7eb278c1580c7b87$var$_excluded);
    const [ripples, setRipples] = $4YNlq.useState([]);
    const nextKey = $4YNlq.useRef(0);
    const rippleCallback = $4YNlq.useRef(null);
    $4YNlq.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $4YNlq.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $2L0xy.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $4YNlq.useRef(null);
    const container = $4YNlq.useRef(null);
    const startCommit = $4YNlq.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $izf4p.jsx)($7eb278c1580c7b87$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $fQQpK.default)(classes.ripple, (0, $86GWu.default).ripple),
                        rippleVisible: (0, $fQQpK.default)(classes.rippleVisible, (0, $86GWu.default).rippleVisible),
                        ripplePulsate: (0, $fQQpK.default)(classes.ripplePulsate, (0, $86GWu.default).ripplePulsate),
                        child: (0, $fQQpK.default)(classes.child, (0, $86GWu.default).child),
                        childLeaving: (0, $fQQpK.default)(classes.childLeaving, (0, $86GWu.default).childLeaving),
                        childPulsate: (0, $fQQpK.default)(classes.childPulsate, (0, $86GWu.default).childPulsate)
                    },
                    timeout: $7eb278c1580c7b87$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $4YNlq.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($7eb278c1580c7b87$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $4YNlq.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $4YNlq.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $4YNlq.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)($7eb278c1580c7b87$export$f6b7418508c72c25, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)((0, $86GWu.default).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $1uy3y.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $7eb278c1580c7b87$export$2e2bcd8739ae039 = $7eb278c1580c7b87$var$TouchRipple;

});
parcelRegister("1uy3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $116302a8681794b1$export$2e2bcd8739ae039; });

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $fDz4Y = parcelRequire("fDz4Y");

var $GxpsF = parcelRequire("GxpsF");


var $4YNlq = parcelRequire("4YNlq");

var $ksBFy = parcelRequire("ksBFy");

var $29iS6 = parcelRequire("29iS6");
var $116302a8681794b1$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $116302a8681794b1$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $116302a8681794b1$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $GxpsF.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $fDz4Y.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $29iS6.getInitialChildMapping)(nextProps, handleExited) : (0, $29iS6.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $29iS6.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $lzDk3.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $g54n0.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $116302a8681794b1$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement((0, $ksBFy.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement((0, $ksBFy.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).Component);
$116302a8681794b1$var$TransitionGroup.propTypes = {};
$116302a8681794b1$var$TransitionGroup.defaultProps = $116302a8681794b1$var$defaultProps;
var $116302a8681794b1$export$2e2bcd8739ae039 = $116302a8681794b1$var$TransitionGroup;

});
parcelRegister("fDz4Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b625b582a973909c$export$2e2bcd8739ae039; });
function $b625b582a973909c$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("GxpsF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07fdd6d274b8634d$export$2e2bcd8739ae039; });

var $hrNKQ = parcelRequire("hrNKQ");
function $07fdd6d274b8634d$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $hrNKQ.default)(subClass, superClass);
}

});
parcelRegister("hrNKQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb3b8d7d148eb12f$export$2e2bcd8739ae039; });
function $cb3b8d7d148eb12f$export$2e2bcd8739ae039(o, p) {
    $cb3b8d7d148eb12f$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cb3b8d7d148eb12f$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("ksBFy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee53a478b3002158$export$2e2bcd8739ae039; });

var $4YNlq = parcelRequire("4YNlq");
var $ee53a478b3002158$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createContext(null);

});

parcelRegister("29iS6", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $190b0f8d8a6fbd61$export$bbc8a025727ea824; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $190b0f8d8a6fbd61$export$fa71e2345c31d7a2; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $190b0f8d8a6fbd61$export$36fd1af28d383ec0; });

var $4YNlq = parcelRequire("4YNlq");
function $190b0f8d8a6fbd61$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $4YNlq.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $4YNlq.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $190b0f8d8a6fbd61$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $190b0f8d8a6fbd61$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $190b0f8d8a6fbd61$export$fa71e2345c31d7a2(props, onExited) {
    return $190b0f8d8a6fbd61$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $4YNlq.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $190b0f8d8a6fbd61$var$getProp(child, "appear", props),
            enter: $190b0f8d8a6fbd61$var$getProp(child, "enter", props),
            exit: $190b0f8d8a6fbd61$var$getProp(child, "exit", props)
        });
    });
}
function $190b0f8d8a6fbd61$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $190b0f8d8a6fbd61$export$bbc8a025727ea824(nextProps.children);
    var children = $190b0f8d8a6fbd61$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $4YNlq.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $4YNlq.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $4YNlq.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $190b0f8d8a6fbd61$var$getProp(child, "exit", nextProps),
            enter: $190b0f8d8a6fbd61$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $4YNlq.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $4YNlq.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $4YNlq.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $190b0f8d8a6fbd61$var$getProp(child, "exit", nextProps),
            enter: $190b0f8d8a6fbd61$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});


parcelRegister("aIKdl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ce1dca6c1c15a4f$export$2e2bcd8739ae039; });

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $izf4p = parcelRequire("izf4p");
"use client";
function $7ce1dca6c1c15a4f$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $4YNlq.useState(false);
    const rippleClassName = (0, $fQQpK.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $fQQpK.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $4YNlq.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $izf4p.jsx)("span", {
            className: childClassName
        })
    });
}
var $7ce1dca6c1c15a4f$export$2e2bcd8739ae039 = $7ce1dca6c1c15a4f$var$Ripple;

});

parcelRegister("86GWu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e7031bbcf3510e7$export$2e2bcd8739ae039; });

var $8SsD1 = parcelRequire("8SsD1");

var $8Q7RY = parcelRequire("8Q7RY");
function $5e7031bbcf3510e7$export$b464606f735ab902(slot) {
    return (0, $8Q7RY.default)("MuiTouchRipple", slot);
}
const $5e7031bbcf3510e7$var$touchRippleClasses = (0, $8SsD1.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $5e7031bbcf3510e7$export$2e2bcd8739ae039 = $5e7031bbcf3510e7$var$touchRippleClasses;

});


parcelRegister("bk66D", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", function () { return $83e64c799fc235c7$export$fccb0498dcd99783; });
$parcel$export(module.exports, "default", function () { return $83e64c799fc235c7$export$2e2bcd8739ae039; });

var $8SsD1 = parcelRequire("8SsD1");

var $8Q7RY = parcelRequire("8Q7RY");
function $83e64c799fc235c7$export$fccb0498dcd99783(slot) {
    return (0, $8Q7RY.default)("MuiButtonBase", slot);
}
const $83e64c799fc235c7$var$buttonBaseClasses = (0, $8SsD1.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $83e64c799fc235c7$export$2e2bcd8739ae039 = $83e64c799fc235c7$var$buttonBaseClasses;

});


parcelRegister("gHTcu", function(module, exports) {

$parcel$export(module.exports, "getIconButtonUtilityClass", function () { return $c29b7b2d0ae2b02f$export$5e8702d71474f093; });
$parcel$export(module.exports, "default", function () { return $c29b7b2d0ae2b02f$export$2e2bcd8739ae039; });

var $8SsD1 = parcelRequire("8SsD1");

var $8Q7RY = parcelRequire("8Q7RY");
function $c29b7b2d0ae2b02f$export$5e8702d71474f093(slot) {
    return (0, $8Q7RY.default)("MuiIconButton", slot);
}
const $c29b7b2d0ae2b02f$var$iconButtonClasses = (0, $8SsD1.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $c29b7b2d0ae2b02f$export$2e2bcd8739ae039 = $c29b7b2d0ae2b02f$var$iconButtonClasses;

});




parcelRegister("6ZJGQ", function(module, exports) {
"use strict";
var $517be1ae2a5f8207$var$__assign = module.exports && module.exports.__assign || function() {
    $517be1ae2a5f8207$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $517be1ae2a5f8207$var$__assign.apply(this, arguments);
};
var $517be1ae2a5f8207$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $517be1ae2a5f8207$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $517be1ae2a5f8207$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $517be1ae2a5f8207$var$__createBinding(result, mod, k);
    }
    $517be1ae2a5f8207$var$__setModuleDefault(result, mod);
    return result;
};
var $517be1ae2a5f8207$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Indicators = void 0;

var $517be1ae2a5f8207$var$react_1 = $517be1ae2a5f8207$var$__importStar((parcelRequire("4YNlq")));

var $hDp8f = parcelRequire("hDp8f");
var $517be1ae2a5f8207$var$Indicators = function(props) {
    var IndicatorIcon = (0, $517be1ae2a5f8207$var$react_1.useMemo)(function() {
        return props.IndicatorIcon !== undefined ? props.IndicatorIcon : $517be1ae2a5f8207$var$react_1.default.createElement($hDp8f.StyledFiberManualRecordIcon, null);
    }, [
        props.IndicatorIcon
    ]);
    var completeListIfRequired = (0, $517be1ae2a5f8207$var$react_1.useCallback)(function(arrayOfIcons) {
        while(arrayOfIcons.length < props.length){
            var index = 0;
            arrayOfIcons.push(arrayOfIcons[index]);
            index += 1;
        }
    }, [
        props.length
    ]);
    var _a = props.indicatorIconButtonProps, indicatorIconButtonClass = _a.className, indicatorIconButtonStyle = _a.style, indicatorIconButtonProps = $517be1ae2a5f8207$var$__rest(_a, [
        "className",
        "style"
    ]);
    var _b = props.activeIndicatorIconButtonProps, activeIndicatorIconButtonClass = _b.className, activeIndicatorIconButtonStyle = _b.style, activeIndicatorIconButtonProps = $517be1ae2a5f8207$var$__rest(_b, [
        "className",
        "style"
    ]);
    var indicators = [];
    var _loop_1 = function(i) {
        var className = i === props.active ? indicatorIconButtonClass + " " + activeIndicatorIconButtonClass : "" + indicatorIconButtonClass;
        var style = i === props.active ? Object.assign({}, indicatorIconButtonStyle, activeIndicatorIconButtonStyle) : indicatorIconButtonStyle;
        var restProps = i === props.active ? Object.assign({}, indicatorIconButtonProps, activeIndicatorIconButtonProps) : indicatorIconButtonProps;
        if (restProps["aria-label"] === undefined) restProps["aria-label"] = "carousel indicator";
        var createIndicator = function(IndicatorIcon) {
            return $517be1ae2a5f8207$var$react_1.default.createElement($hDp8f.StyledIndicatorIconButton, $517be1ae2a5f8207$var$__assign({
                "$active": i === props.active,
                key: i,
                className: className,
                style: style,
                onClick: function() {
                    props.press(i);
                }
            }, restProps, {
                "aria-label": restProps["aria-label"] + " " + (i + 1)
            }), IndicatorIcon);
        };
        Array.isArray(IndicatorIcon) ? indicators.push(createIndicator(IndicatorIcon[i])) && completeListIfRequired(IndicatorIcon) : indicators.push(createIndicator(IndicatorIcon));
    };
    for(var i = 0; i < props.length; i++)_loop_1(i);
    var _c = props.indicatorContainerProps, indicatorContainerClass = _c.className, indicatorContainerStyle = _c.style, indicatorContainerProps = $517be1ae2a5f8207$var$__rest(_c, [
        "className",
        "style"
    ]);
    return $517be1ae2a5f8207$var$react_1.default.createElement($hDp8f.StyledIndicators, $517be1ae2a5f8207$var$__assign({
        className: indicatorContainerClass,
        style: indicatorContainerStyle
    }, indicatorContainerProps), indicators);
};
module.exports.Indicators = $517be1ae2a5f8207$var$Indicators;

});

parcelRegister("hwPtg", function(module, exports) {
"use strict";
var $cc2d59e138f5cd10$var$__assign = module.exports && module.exports.__assign || function() {
    $cc2d59e138f5cd10$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cc2d59e138f5cd10$var$__assign.apply(this, arguments);
};
var $cc2d59e138f5cd10$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cc2d59e138f5cd10$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cc2d59e138f5cd10$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cc2d59e138f5cd10$var$__createBinding(result, mod, k);
    }
    $cc2d59e138f5cd10$var$__setModuleDefault(result, mod);
    return result;
};
var $cc2d59e138f5cd10$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cc2d59e138f5cd10$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useInterval = module.exports.sanitizeProps = module.exports.sanitizeNavProps = void 0;

var $cc2d59e138f5cd10$var$NavigateBefore_1 = $cc2d59e138f5cd10$var$__importDefault((parcelRequire("cO26I")));

var $cc2d59e138f5cd10$var$NavigateNext_1 = $cc2d59e138f5cd10$var$__importDefault((parcelRequire("ihWiU")));

var $cc2d59e138f5cd10$var$react_1 = $cc2d59e138f5cd10$var$__importStar((parcelRequire("4YNlq")));
var $cc2d59e138f5cd10$var$sanitizeNavProps = function(props) {
    var _a = props || {}, className = _a.className, style = _a.style, rest = $cc2d59e138f5cd10$var$__rest(_a, [
        "className",
        "style"
    ]);
    return props !== undefined ? $cc2d59e138f5cd10$var$__assign({
        style: props.style !== undefined ? props.style : {},
        className: props.className !== undefined ? props.className : ""
    }, rest) : $cc2d59e138f5cd10$var$__assign({
        style: {},
        className: ""
    }, rest);
};
module.exports.sanitizeNavProps = $cc2d59e138f5cd10$var$sanitizeNavProps;
var $cc2d59e138f5cd10$var$sanitizeProps = function(props) {
    var animation = props.animation !== undefined ? props.animation : "fade";
    var duration = props.duration !== undefined ? props.duration : animation === "fade" ? 500 : 200;
    return {
        sx: props.sx !== undefined ? props.sx : {},
        className: props.className !== undefined ? props.className : "",
        children: props.children ? props.children : [],
        height: props.height,
        index: props.index !== undefined ? props.index : 0,
        strictIndexing: props.strictIndexing !== undefined ? props.strictIndexing : true,
        autoPlay: props.autoPlay !== undefined ? props.autoPlay : true,
        stopAutoPlayOnHover: props.stopAutoPlayOnHover !== undefined ? props.stopAutoPlayOnHover : true,
        interval: props.interval !== undefined ? props.interval : 4000,
        animation: animation,
        duration: duration,
        swipe: props.swipe !== undefined ? props.swipe : true,
        navButtonsAlwaysInvisible: props.navButtonsAlwaysInvisible !== undefined ? props.navButtonsAlwaysInvisible : false,
        navButtonsAlwaysVisible: props.navButtonsAlwaysVisible !== undefined ? props.navButtonsAlwaysVisible : false,
        cycleNavigation: props.cycleNavigation !== undefined ? props.cycleNavigation : true,
        fullHeightHover: props.fullHeightHover !== undefined ? props.fullHeightHover : true,
        navButtonsWrapperProps: (0, module.exports.sanitizeNavProps)(props.navButtonsWrapperProps),
        navButtonsProps: (0, module.exports.sanitizeNavProps)(props.navButtonsProps),
        NavButton: props.NavButton,
        NextIcon: props.NextIcon !== undefined ? props.NextIcon : $cc2d59e138f5cd10$var$react_1.default.createElement($cc2d59e138f5cd10$var$NavigateNext_1.default, null),
        PrevIcon: props.PrevIcon !== undefined ? props.PrevIcon : $cc2d59e138f5cd10$var$react_1.default.createElement($cc2d59e138f5cd10$var$NavigateBefore_1.default, null),
        indicators: props.indicators !== undefined ? props.indicators : true,
        indicatorContainerProps: (0, module.exports.sanitizeNavProps)(props.indicatorContainerProps),
        indicatorIconButtonProps: (0, module.exports.sanitizeNavProps)(props.indicatorIconButtonProps),
        activeIndicatorIconButtonProps: (0, module.exports.sanitizeNavProps)(props.activeIndicatorIconButtonProps),
        IndicatorIcon: props.IndicatorIcon,
        onChange: props.onChange !== undefined ? props.onChange : function() {},
        changeOnFirstRender: props.changeOnFirstRender !== undefined ? props.changeOnFirstRender : false,
        next: props.next !== undefined ? props.next : function() {},
        prev: props.prev !== undefined ? props.prev : function() {}
    };
};
module.exports.sanitizeProps = $cc2d59e138f5cd10$var$sanitizeProps;
var $cc2d59e138f5cd10$var$useInterval = function(callback, delay) {
    var savedCallback = (0, $cc2d59e138f5cd10$var$react_1.useRef)(function() {});
    // Remember the latest callback.
    (0, $cc2d59e138f5cd10$var$react_1.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0, $cc2d59e138f5cd10$var$react_1.useEffect)(function() {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            var id_1 = setInterval(tick, delay);
            return function() {
                return clearInterval(id_1);
            };
        }
        return function() {};
    }, [
        delay
    ]);
};
module.exports.useInterval = $cc2d59e138f5cd10$var$useInterval;

});
parcelRegister("cO26I", function(module, exports) {
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $952bca0962d705e2$var$_createSvgIcon = $2NJ2K((parcelRequire("jPQeH")));

var $izf4p = parcelRequire("izf4p");
var $952bca0962d705e2$var$_default = module.exports.default = (0, $952bca0962d705e2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore");

});

parcelRegister("ihWiU", function(module, exports) {
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5070a7e061b78c3$var$_createSvgIcon = $2NJ2K((parcelRequire("jPQeH")));

var $izf4p = parcelRequire("izf4p");
var $d5070a7e061b78c3$var$_default = module.exports.default = (0, $d5070a7e061b78c3$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext");

});



parcelRegister("22Tpm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "fetch", function () { return $17d6bf932fdb6b2e$export$e7aa7bc5c1b3cfb3; });
$parcel$export(module.exports, "default", function () { return $17d6bf932fdb6b2e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Headers", function () { return $17d6bf932fdb6b2e$export$79b704688b15c0f4; });
$parcel$export(module.exports, "Request", function () { return $17d6bf932fdb6b2e$export$7fa6c5b6f8193917; });
$parcel$export(module.exports, "Response", function () { return $17d6bf932fdb6b2e$export$9f633d56d7ec90d3; });
"use strict";
// ref: https://github.com/tc39/proposal-global
var $17d6bf932fdb6b2e$var$getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
};
var $17d6bf932fdb6b2e$var$globalObject = $17d6bf932fdb6b2e$var$getGlobal();
const $17d6bf932fdb6b2e$export$e7aa7bc5c1b3cfb3 = $17d6bf932fdb6b2e$var$globalObject.fetch;
var $17d6bf932fdb6b2e$export$2e2bcd8739ae039 = $17d6bf932fdb6b2e$var$globalObject.fetch.bind($17d6bf932fdb6b2e$var$globalObject);
const $17d6bf932fdb6b2e$export$79b704688b15c0f4 = $17d6bf932fdb6b2e$var$globalObject.Headers;
const $17d6bf932fdb6b2e$export$7fa6c5b6f8193917 = $17d6bf932fdb6b2e$var$globalObject.Request;
const $17d6bf932fdb6b2e$export$9f633d56d7ec90d3 = $17d6bf932fdb6b2e$var$globalObject.Response;

});

parcelRegister("gtOsO", function(module, exports) {


module.exports = (parcelRequire("7sgj1"))((parcelRequire("upk3X")).resolve("6vVFt")).then(()=>parcelRequire("gRdgR"));

});
parcelRegister("7sgj1", function(module, exports) {
"use strict";

var $kvqKP = parcelRequire("kvqKP");
module.exports = $kvqKP(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("kvqKP", function(module, exports) {
"use strict";
var $eedb74c3c210d954$var$cachedBundles = {};
var $eedb74c3c210d954$var$cachedPreloads = {};
var $eedb74c3c210d954$var$cachedPrefetches = {};
function $eedb74c3c210d954$var$getCache(type) {
    switch(type){
        case "preload":
            return $eedb74c3c210d954$var$cachedPreloads;
        case "prefetch":
            return $eedb74c3c210d954$var$cachedPrefetches;
        default:
            return $eedb74c3c210d954$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $eedb74c3c210d954$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("7Dpty", function(module, exports) {
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable */ var shared, worker, mapboxgl;
    // define gets called three times: one for each chunk. we rely on the order
    // they're imported to know which is which
    function define(_, chunk) {
        if (!shared) shared = chunk;
        else if (!worker) worker = chunk;
        else {
            var workerBundleString = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(sharedChunk); self.onerror = null;";
            var sharedChunk = {};
            shared(sharedChunk);
            mapboxgl = chunk(sharedChunk);
            if (typeof window !== "undefined" && window && window.URL && window.URL.createObjectURL) mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                workerBundleString
            ], {
                type: "text/javascript"
            }));
        }
    }
    define([
        "exports"
    ], function(e1) {
        "use strict";
        var t = "undefined" != typeof self ? self : {}, i = "3.1.2";
        let r;
        const n = {
            API_URL: "https://api.mapbox.com",
            get API_URL_REGEX () {
                if (null == r) {
                    const e1 = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
                    try {
                        r = e1;
                    } catch (t) {
                        r = e1;
                    }
                }
                return r;
            },
            get API_TILEJSON_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
            },
            get API_SPRITE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
            },
            get API_FONTS_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
            },
            get API_STYLE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
            },
            get API_CDN_URL_REGEX () {
                return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
            },
            get EVENTS_URL () {
                if (!n.API_URL) return null;
                try {
                    const e1 = new URL(n.API_URL);
                    return "api.mapbox.cn" === e1.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === e1.hostname ? "https://events.mapbox.com/events/v2" : null;
                } catch (e1) {
                    return null;
                }
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            DEFAULT_STYLE: "mapbox://styles/mapbox/standard",
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            DRACO_URL: "https://api.mapbox.com/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm",
            GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
        }, o = {
            supported: !1,
            testSupport: function(e1) {
                !l && a && (c ? h(e1) : s = e1);
            }
        };
        let s, a, l = !1, c = !1;
        function h(e1) {
            const t = e1.createTexture();
            e1.bindTexture(e1.TEXTURE_2D, t);
            try {
                if (e1.texImage2D(e1.TEXTURE_2D, 0, e1.RGBA, e1.RGBA, e1.UNSIGNED_BYTE, a), e1.isContextLost()) return;
                o.supported = !0;
            } catch (e1) {}
            e1.deleteTexture(t), l = !0;
        }
        t.document && (a = t.document.createElement("img"), a.onload = function() {
            s && h(s), s = null, c = !0;
        }, a.onerror = function() {
            l = !0, s = null;
        }, a.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const u = "01";
        function d(e1) {
            return e1 && e1.__esModule && Object.prototype.hasOwnProperty.call(e1, "default") ? e1.default : e1;
        }
        var p = f;
        function f(e1, t, i, r) {
            this.cx = 3 * e1, this.bx = 3 * (i - e1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * t, this.by = 3 * (r - t) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = e1, this.p1y = t, this.p2x = i, this.p2y = r;
        }
        f.prototype = {
            sampleCurveX: function(e1) {
                return ((this.ax * e1 + this.bx) * e1 + this.cx) * e1;
            },
            sampleCurveY: function(e1) {
                return ((this.ay * e1 + this.by) * e1 + this.cy) * e1;
            },
            sampleCurveDerivativeX: function(e1) {
                return (3 * this.ax * e1 + 2 * this.bx) * e1 + this.cx;
            },
            solveCurveX: function(e1, t) {
                if (void 0 === t && (t = 1e-6), e1 < 0) return 0;
                if (e1 > 1) return 1;
                for(var i = e1, r = 0; r < 8; r++){
                    var n = this.sampleCurveX(i) - e1;
                    if (Math.abs(n) < t) return i;
                    var o = this.sampleCurveDerivativeX(i);
                    if (Math.abs(o) < 1e-6) break;
                    i -= n / o;
                }
                var s = 0, a = 1;
                for(i = e1, r = 0; r < 20 && (n = this.sampleCurveX(i), !(Math.abs(n - e1) < t)); r++)e1 > n ? s = i : a = i, i = .5 * (a - s) + s;
                return i;
            },
            solve: function(e1, t) {
                return this.sampleCurveY(this.solveCurveX(e1, t));
            }
        };
        var m = d(p), _ = g;
        function g(e1, t) {
            this.x = e1, this.y = t;
        }
        g.prototype = {
            clone: function() {
                return new g(this.x, this.y);
            },
            add: function(e1) {
                return this.clone()._add(e1);
            },
            sub: function(e1) {
                return this.clone()._sub(e1);
            },
            multByPoint: function(e1) {
                return this.clone()._multByPoint(e1);
            },
            divByPoint: function(e1) {
                return this.clone()._divByPoint(e1);
            },
            mult: function(e1) {
                return this.clone()._mult(e1);
            },
            div: function(e1) {
                return this.clone()._div(e1);
            },
            rotate: function(e1) {
                return this.clone()._rotate(e1);
            },
            rotateAround: function(e1, t) {
                return this.clone()._rotateAround(e1, t);
            },
            matMult: function(e1) {
                return this.clone()._matMult(e1);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(e1) {
                return this.x === e1.x && this.y === e1.y;
            },
            dist: function(e1) {
                return Math.sqrt(this.distSqr(e1));
            },
            distSqr: function(e1) {
                var t = e1.x - this.x, i = e1.y - this.y;
                return t * t + i * i;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(e1) {
                return Math.atan2(this.y - e1.y, this.x - e1.x);
            },
            angleWith: function(e1) {
                return this.angleWithSep(e1.x, e1.y);
            },
            angleWithSep: function(e1, t) {
                return Math.atan2(this.x * t - this.y * e1, this.x * e1 + this.y * t);
            },
            _matMult: function(e1) {
                var t = e1[2] * this.x + e1[3] * this.y;
                return this.x = e1[0] * this.x + e1[1] * this.y, this.y = t, this;
            },
            _add: function(e1) {
                return this.x += e1.x, this.y += e1.y, this;
            },
            _sub: function(e1) {
                return this.x -= e1.x, this.y -= e1.y, this;
            },
            _mult: function(e1) {
                return this.x *= e1, this.y *= e1, this;
            },
            _div: function(e1) {
                return this.x /= e1, this.y /= e1, this;
            },
            _multByPoint: function(e1) {
                return this.x *= e1.x, this.y *= e1.y, this;
            },
            _divByPoint: function(e1) {
                return this.x /= e1.x, this.y /= e1.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var e1 = this.y;
                return this.y = this.x, this.x = -e1, this;
            },
            _rotate: function(e1) {
                var t = Math.cos(e1), i = Math.sin(e1), r = i * this.x + t * this.y;
                return this.x = t * this.x - i * this.y, this.y = r, this;
            },
            _rotateAround: function(e1, t) {
                var i = Math.cos(e1), r = Math.sin(e1), n = t.y + r * (this.x - t.x) + i * (this.y - t.y);
                return this.x = t.x + i * (this.x - t.x) - r * (this.y - t.y), this.y = n, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
        }, g.convert = function(e1) {
            return e1 instanceof g ? e1 : Array.isArray(e1) ? new g(e1[0], e1[1]) : e1;
        };
        var y = d(_);
        function x(e1, t) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(t) || e1.length !== t.length) return !1;
                for(let i = 0; i < e1.length; i++)if (!x(e1[i], t[i])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== t) {
                if ("object" != typeof t) return !1;
                if (Object.keys(e1).length !== Object.keys(t).length) return !1;
                for(const i in e1)if (!x(e1[i], t[i])) return !1;
                return !0;
            }
            return e1 === t;
        }
        const v = Math.PI / 180, b = 180 / Math.PI;
        function w(e1) {
            return e1 * v;
        }
        function T(e1) {
            return e1 * b;
        }
        const E = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function M(e1) {
            if (e1 <= 0) return 0;
            if (e1 >= 1) return 1;
            const t = e1 * e1, i = t * e1;
            return 4 * (e1 < .5 ? i : 3 * (e1 - t) + i - .75);
        }
        function A(e1) {
            let t = 1 / 0, i = 1 / 0, r = -1 / 0, n = -1 / 0;
            for (const o of e1)t = Math.min(t, o.x), i = Math.min(i, o.y), r = Math.max(r, o.x), n = Math.max(n, o.y);
            return {
                min: new y(t, i),
                max: new y(r, n)
            };
        }
        function S(e1, t, i = 0, r = !0) {
            const n = new y(i, i), o = e1.sub(n), s = t.add(n), a = [
                o,
                new y(s.x, o.y),
                s,
                new y(o.x, s.y)
            ];
            return r && a.push(o.clone()), a;
        }
        function I(e1, t, i, r) {
            const n = new m(e1, t, i, r);
            return function(e1) {
                return n.solve(e1);
            };
        }
        const C = I(.25, .1, .25, 1);
        function z(e1, t, i) {
            return Math.min(i, Math.max(t, e1));
        }
        function P(e1, t, i) {
            return (i = z((i - e1) / (t - e1), 0, 1)) * i * (3 - 2 * i);
        }
        function D(e1, t, i) {
            const r = i - t, n = ((e1 - t) % r + r) % r + t;
            return n === t ? i : n;
        }
        function R(e1, t, i) {
            if (!e1.length) return i(null, []);
            let r = e1.length;
            const n = new Array(e1.length);
            let o = null;
            e1.forEach((e1, s)=>{
                t(e1, (e1, t)=>{
                    e1 && (o = e1), n[s] = t, 0 == --r && i(o, n);
                });
            });
        }
        function L(e1) {
            const t = [];
            for(const i in e1)t.push(e1[i]);
            return t;
        }
        function k(e1, ...t) {
            for (const i of t)for(const t in i)e1[t] = i[t];
            return e1;
        }
        function O(e1, t) {
            const i = {};
            for(let r = 0; r < t.length; r++){
                const n = t[r];
                n in e1 && (i[n] = e1[n]);
            }
            return i;
        }
        let B = 1;
        function F() {
            return B++;
        }
        function N() {
            return function e1(t) {
                return t ? (t ^ Math.random() * (16 >> t / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, e1);
            }();
        }
        function U(e1) {
            return e1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(e1) / Math.LN2));
        }
        function V(e1) {
            return !!e1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(e1);
        }
        function j(e1, t) {
            e1.forEach((e1)=>{
                t[e1] && (t[e1] = t[e1].bind(t));
            });
        }
        function G(e1, t) {
            return -1 !== e1.indexOf(t, e1.length - t.length);
        }
        function q(e1, t, i) {
            const r = {};
            for(const n in e1)r[n] = t.call(i || this, e1[n], n, e1);
            return r;
        }
        function Z(e1, t, i) {
            const r = {};
            for(const n in e1)t.call(i || this, e1[n], n, e1) && (r[n] = e1[n]);
            return r;
        }
        function $(e1) {
            return Array.isArray(e1) ? e1.map($) : "object" == typeof e1 && e1 ? q(e1, $) : e1;
        }
        const W = {};
        function H(e1) {
            W[e1] || ("undefined" != typeof console && console.warn(e1), W[e1] = !0);
        }
        function X(e1, t, i) {
            return (i.y - e1.y) * (t.x - e1.x) > (t.y - e1.y) * (i.x - e1.x);
        }
        function Y(e1) {
            let t = 0;
            for(let i, r, n = 0, o = e1.length, s = o - 1; n < o; s = n++)i = e1[n], r = e1[s], t += (r.x - i.x) * (i.y + r.y);
            return t;
        }
        function K([e1, t, i]) {
            const r = w(t + 90), n = w(i);
            return {
                x: e1 * Math.cos(r) * Math.sin(n),
                y: e1 * Math.sin(r) * Math.sin(n),
                z: e1 * Math.cos(n),
                azimuthal: t,
                polar: i
            };
        }
        function J(e1, t, i) {
            const r = Math.sqrt(e1 * e1 + t * t + i * i), n = r > 0 ? Math.acos(i / r) * b : 0;
            let o = 0 !== e1 || 0 !== t ? Math.atan2(-t, -e1) * b + 90 : 0;
            return o < 0 && (o += 360), [
                r,
                o,
                n
            ];
        }
        function Q() {
            return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope;
        }
        function ee(e1) {
            const t = {};
            if (e1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (e1, i, r, n)=>{
                const o = r || n;
                return t[i] = !o || o.toLowerCase(), "";
            }), t["max-age"]) {
                const e1 = parseInt(t["max-age"], 10);
                isNaN(e1) ? delete t["max-age"] : t["max-age"] = e1;
            }
            return t;
        }
        let te = null;
        function ie() {
            return !!t.document.fullscreenElement || !!t.document.webkitFullscreenElement;
        }
        function re(e1) {
            try {
                const i = t[e1];
                return i.setItem("_mapbox_test_", 1), i.removeItem("_mapbox_test_"), !0;
            } catch (e1) {
                return !1;
            }
        }
        function ne(e1, t) {
            return [
                e1[4 * t],
                e1[4 * t + 1],
                e1[4 * t + 2],
                e1[4 * t + 3]
            ];
        }
        function oe(e1, t, i) {
            e1[4 * t + 0] = i[0], e1[4 * t + 1] = i[1], e1[4 * t + 2] = i[2], e1[4 * t + 3] = i[3];
        }
        function se(e1, t) {
            return [
                Math.pow(e1[0], 2.2) * t,
                Math.pow(e1[1], 2.2) * t,
                Math.pow(e1[2], 2.2) * t
            ];
        }
        function ae(e1) {
            return [
                Math.pow(e1[0], 1 / 2.2),
                Math.pow(e1[1], 1 / 2.2),
                Math.pow(e1[2], 1 / 2.2)
            ];
        }
        const le = "mapbox-tiles";
        let ce = 500, he = 50;
        let ue, de;
        function pe() {
            try {
                return t.caches;
            } catch (e1) {}
        }
        function fe() {
            pe() && !ue && (ue = t.caches.open(le));
        }
        function me(e1) {
            const t = e1.indexOf("?");
            if (t < 0) return e1;
            const i = function(e1) {
                const t = e1.indexOf("?");
                return t > 0 ? e1.slice(t + 1).split("&") : [];
            }(e1), r = i.filter((e1)=>{
                const t = e1.split("=");
                return "language" === t[0] || "worldview" === t[0];
            });
            return r.length ? `${e1.slice(0, t)}?${r.join("&")}` : e1.slice(0, t);
        }
        let _e = 1 / 0;
        function ge(e1) {
            _e++, _e > he && (e1.getActor().send("enforceCacheSizeLimit", ce), _e = 0);
        }
        const ye = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Image: "Image",
            Model: "Model"
        };
        "function" == typeof Object.freeze && Object.freeze(ye);
        class xe extends Error {
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
            constructor(e1, t, i){
                401 === t && De(i) && (e1 += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(e1), this.status = t, this.url = i;
            }
        }
        const ve = Q() ? ()=>self.worker && self.worker.referrer : ()=>("blob:" === t.location.protocol ? t.parent : t).location.href;
        const be = function(e1, i) {
            if (!(/^file:/.test(r = e1.url) || /^file:/.test(ve()) && !/^\w+:/.test(r))) {
                if (t.fetch && t.Request && t.AbortController && t.Request.prototype.hasOwnProperty("signal")) return function(e1, i) {
                    const r = new t.AbortController, n = new t.Request(e1.url, {
                        method: e1.method || "GET",
                        body: e1.body,
                        credentials: e1.credentials,
                        headers: e1.headers,
                        referrer: ve(),
                        referrerPolicy: e1.referrerPolicy,
                        signal: r.signal
                    });
                    let o = !1, s = !1;
                    const a = (l = n.url).indexOf("sku=") > 0 && De(l);
                    var l;
                    "json" === e1.type && n.headers.set("Accept", "application/json");
                    const c = (r, o, l)=>{
                        if (s) return;
                        if (r && "SecurityError" !== r.message && H(r.toString()), o && l) return h(o);
                        const c = Date.now();
                        t.fetch(n).then((t)=>{
                            if (t.ok) {
                                const e1 = a ? t.clone() : null;
                                return h(t, e1, c);
                            }
                            return i(new xe(t.statusText, t.status, e1.url));
                        }).catch((t)=>{
                            "AbortError" !== t.name && i(new Error(`${t.message} ${e1.url}`));
                        });
                    }, h = (r, a, l)=>{
                        ("arrayBuffer" === e1.type ? r.arrayBuffer() : "json" === e1.type ? r.json() : r.text()).then((e1)=>{
                            s || (a && l && function(e1, i, r) {
                                if (fe(), !ue) return;
                                const n = {
                                    status: i.status,
                                    statusText: i.statusText,
                                    headers: new t.Headers
                                };
                                i.headers.forEach((e1, t)=>n.headers.set(t, e1));
                                const o = ee(i.headers.get("Cache-Control") || "");
                                if (o["no-store"]) return;
                                o["max-age"] && n.headers.set("Expires", new Date(r + 1e3 * o["max-age"]).toUTCString());
                                const s = n.headers.get("Expires");
                                s && (new Date(s).getTime() - r < 42e4 || function(e1, t) {
                                    if (void 0 === de) try {
                                        new Response(new ReadableStream), de = !0;
                                    } catch (e1) {
                                        de = !1;
                                    }
                                    de ? t(e1.body) : e1.blob().then(t);
                                }(i, (i)=>{
                                    const r = new t.Response(i, n);
                                    fe(), ue && ue.then((t)=>t.put(me(e1.url), r)).catch((e1)=>H(e1.message));
                                }));
                            }(n, a, l), o = !0, i(null, e1, r.headers.get("Cache-Control"), r.headers.get("Expires")));
                        }).catch((e1)=>{
                            s || i(new Error(e1.message));
                        });
                    };
                    return a ? function(e1, t) {
                        if (fe(), !ue) return t(null);
                        const i = me(e1.url);
                        ue.then((e1)=>{
                            e1.match(i).then((r)=>{
                                const n = function(e1) {
                                    if (!e1) return !1;
                                    const t = new Date(e1.headers.get("Expires") || 0), i = ee(e1.headers.get("Cache-Control") || "");
                                    return t > Date.now() && !i["no-cache"];
                                }(r);
                                e1.delete(i), n && e1.put(i, r.clone()), t(null, r, n);
                            }).catch(t);
                        }).catch(t);
                    }(n, c) : c(null, null), {
                        cancel: ()=>{
                            s = !0, o || r.abort();
                        }
                    };
                }(e1, i);
                if (Q() && self.worker && self.worker.actor) return self.worker.actor.send("getResource", e1, i, void 0, !0);
            }
            var r;
            return function(e1, i) {
                const r = new t.XMLHttpRequest;
                r.open(e1.method || "GET", e1.url, !0), "arrayBuffer" === e1.type && (r.responseType = "arraybuffer");
                for(const t in e1.headers)r.setRequestHeader(t, e1.headers[t]);
                return "json" === e1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === e1.credentials, r.onerror = ()=>{
                    i(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let t = r.response;
                        if ("json" === e1.type) try {
                            t = JSON.parse(r.response);
                        } catch (e1) {
                            return i(e1);
                        }
                        i(null, t, r.getResponseHeader("Cache-Control"), r.getResponseHeader("Expires"));
                    } else i(new xe(r.statusText, r.status, e1.url));
                }, r.send(e1.body), {
                    cancel: ()=>r.abort()
                };
            }(e1, i);
        }, we = function(e1, t) {
            return be(k(e1, {
                type: "json"
            }), t);
        }, Te = function(e1, t) {
            return be(k(e1, {
                type: "arrayBuffer"
            }), t);
        };
        function Ee(e1) {
            const i = t.document.createElement("a");
            return i.href = e1, i.protocol === t.document.location.protocol && i.host === t.document.location.host;
        }
        const Me = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        let Ae, Se;
        Ae = [], Se = 0;
        const Ie = function(e1, i) {
            if (o.supported && (e1.headers || (e1.headers = {}), e1.headers.accept = "image/webp,*/*"), Se >= n.MAX_PARALLEL_IMAGE_REQUESTS) {
                const t = {
                    requestParameters: e1,
                    callback: i,
                    cancelled: !1,
                    cancel () {
                        this.cancelled = !0;
                    }
                };
                return Ae.push(t), t;
            }
            Se++;
            let r = !1;
            const s = ()=>{
                if (!r) for(r = !0, Se--; Ae.length && Se < n.MAX_PARALLEL_IMAGE_REQUESTS;){
                    const e1 = Ae.shift(), { requestParameters: t, callback: i, cancelled: r } = e1;
                    r || (e1.cancel = Ie(t, i).cancel);
                }
            }, a = Te(e1, (e1, r, n, o)=>{
                s(), e1 ? i(e1) : r && (t.createImageBitmap ? function(e1, i) {
                    const r = new t.Blob([
                        new Uint8Array(e1)
                    ], {
                        type: "image/png"
                    });
                    t.createImageBitmap(r).then((e1)=>{
                        i(null, e1);
                    }).catch((e1)=>{
                        i(new Error(`Could not load image because of ${e1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                    });
                }(r, (e1, t)=>i(e1, t, n, o)) : function(e1, i) {
                    const r = new t.Image, n = t.URL;
                    r.onload = ()=>{
                        i(null, r), n.revokeObjectURL(r.src), r.onload = null, t.requestAnimationFrame(()=>{
                            r.src = Me;
                        });
                    }, r.onerror = ()=>i(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    const o = new t.Blob([
                        new Uint8Array(e1)
                    ], {
                        type: "image/png"
                    });
                    r.src = e1.byteLength ? n.createObjectURL(o) : Me;
                }(r, (e1, t)=>i(e1, t, n, o)));
            });
            return {
                cancel: ()=>{
                    a.cancel(), s();
                }
            };
        }, Ce = "NO_ACCESS_TOKEN";
        class ze {
            _createSkuToken() {
                const e1 = function() {
                    let e1 = "";
                    for(let t = 0; t < 10; t++)e1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            u,
                            e1
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = e1.token, this._skuTokenExpiresAt = e1.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            transformRequest(e1, t) {
                return this._transformRequestFn && this._transformRequestFn(e1, t) || {
                    url: e1
                };
            }
            normalizeStyleURL(e1, t) {
                if (!Pe(e1)) return e1;
                const r = Be(e1);
                return r.params.push(`sdk=js-${i}`), r.path = `/styles/v1${r.path}`, this._makeAPIURL(r, this._customAccessToken || t);
            }
            normalizeGlyphsURL(e1, t) {
                if (!Pe(e1)) return e1;
                const i = Be(e1);
                return i.path = `/fonts/v1${i.path}`, this._makeAPIURL(i, this._customAccessToken || t);
            }
            normalizeModelURL(e1, t) {
                if (!Pe(e1)) return e1;
                const i = Be(e1);
                return i.path = `/models/v1${i.path}`, this._makeAPIURL(i, this._customAccessToken || t);
            }
            normalizeSourceURL(e1, t, i, r) {
                if (!Pe(e1)) return e1;
                const n = Be(e1);
                return n.path = `/v4/${n.authority}.json`, n.params.push("secure"), i && n.params.push(`language=${i}`), r && n.params.push(`worldview=${r}`), this._makeAPIURL(n, this._customAccessToken || t);
            }
            normalizeSpriteURL(e1, t, i, r) {
                const n = Be(e1);
                return Pe(e1) ? (n.path = `/styles/v1${n.path}/sprite${t}${i}`, this._makeAPIURL(n, this._customAccessToken || r)) : (n.path += `${t}${i}`, Fe(n));
            }
            normalizeTileURL(e1, t, i) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), e1 && !Pe(e1)) return e1;
                const r = Be(e1);
                r.path = r.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${t || i && "raster" !== r.authority && 512 === i ? "@2x" : ""}${o.supported ? ".webp" : "$1"}`), "raster" === r.authority ? r.path = `/${n.RASTER_URL_PREFIX}${r.path}` : (r.path = r.path.replace(/^.+\/v4\//, "/"), r.path = `/${n.TILE_URL_VERSION}${r.path}`);
                const s = this._customAccessToken || function(e1) {
                    for (const t of e1){
                        const e1 = t.match(/^access_token=(.*)$/);
                        if (e1) return e1[1];
                    }
                    return null;
                }(r.params) || n.ACCESS_TOKEN;
                return n.REQUIRE_ACCESS_TOKEN && s && this._skuToken && r.params.push(`sku=${this._skuToken}`), this._makeAPIURL(r, s);
            }
            canonicalizeTileURL(e1, t) {
                const i = Be(e1);
                if (!i.path.match(/^(\/v4\/|\/raster\/v1\/)/) || !i.path.match(/\.[\w]+$/)) return e1;
                let r = "mapbox://";
                i.path.match(/^\/raster\/v1\//) ? r += `raster/${i.path.replace(`/${n.RASTER_URL_PREFIX}/`, "")}` : r += `tiles/${i.path.replace(`/${n.TILE_URL_VERSION}/`, "")}`;
                let o = i.params;
                return t && (o = o.filter((e1)=>!e1.match(/^access_token=/))), o.length && (r += `?${o.join("&")}`), r;
            }
            canonicalizeTileset(e1, t) {
                const i = !!t && Pe(t), r = [];
                for (const t of e1.tiles || [])De(t) ? r.push(this.canonicalizeTileURL(t, i)) : r.push(t);
                return r;
            }
            _makeAPIURL(e1, t) {
                const i = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", r = Be(n.API_URL);
                if (e1.protocol = r.protocol, e1.authority = r.authority, "http" === e1.protocol) {
                    const t = e1.params.indexOf("secure");
                    t >= 0 && e1.params.splice(t, 1);
                }
                if ("/" !== r.path && (e1.path = `${r.path}${e1.path}`), !n.REQUIRE_ACCESS_TOKEN) return Fe(e1);
                if (t = t || n.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!t) throw new Error(`An API access token is required to use Mapbox GL. ${i}`);
                    if ("s" === t[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${i}`);
                }
                return e1.params = e1.params.filter((e1)=>-1 === e1.indexOf("access_token")), e1.params.push(`access_token=${t || ""}`), Fe(e1);
            }
            constructor(e1, t, i){
                this._transformRequestFn = e1, this._customAccessToken = t, this._silenceAuthErrors = !!i, this._createSkuToken();
            }
        }
        function Pe(e1) {
            return 0 === e1.indexOf("mapbox:");
        }
        function De(e1) {
            return n.API_URL_REGEX.test(e1);
        }
        function Re(e1) {
            return n.API_CDN_URL_REGEX.test(e1);
        }
        function Le(e1) {
            return n.API_STYLE_REGEX.test(e1) && !ke(e1);
        }
        function ke(e1) {
            return n.API_SPRITE_REGEX.test(e1);
        }
        const Oe = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function Be(e1) {
            const t = e1.match(Oe);
            if (!t) throw new Error("Unable to parse URL object");
            return {
                protocol: t[1],
                authority: t[2],
                path: t[3] || "/",
                params: t[4] ? t[4].split("&") : []
            };
        }
        function Fe(e1) {
            const t = e1.params.length ? `?${e1.params.join("&")}` : "";
            return `${e1.protocol}://${e1.authority}${e1.path}${t}`;
        }
        const Ne = "mapbox.eventData";
        function Ue(e1) {
            if (!e1) return null;
            const i = e1.split(".");
            if (!i || 3 !== i.length) return null;
            try {
                return JSON.parse(decodeURIComponent(t.atob(i[1]).split("").map((e1)=>"%" + ("00" + e1.charCodeAt(0).toString(16)).slice(-2)).join("")));
            } catch (e1) {
                return null;
            }
        }
        class Ve {
            getStorageKey(e1) {
                const i = Ue(n.ACCESS_TOKEN);
                let r = "";
                return r = i && i.u ? t.btoa(encodeURIComponent(i.u).replace(/%([0-9A-F]{2})/g, (e1, t)=>String.fromCharCode(Number("0x" + t)))) : n.ACCESS_TOKEN || "", e1 ? `${Ne}.${e1}:${r}` : `${Ne}:${r}`;
            }
            fetchEventData() {
                const e1 = re("localStorage"), i = this.getStorageKey(), r = this.getStorageKey("uuid");
                if (e1) try {
                    const e1 = t.localStorage.getItem(i);
                    e1 && (this.eventData = JSON.parse(e1));
                    const n = t.localStorage.getItem(r);
                    n && (this.anonId = n);
                } catch (e1) {
                    H("Unable to read from LocalStorage");
                }
            }
            saveEventData() {
                const e1 = re("localStorage"), i = this.getStorageKey(), r = this.getStorageKey("uuid");
                if (e1) try {
                    t.localStorage.setItem(r, this.anonId), Object.keys(this.eventData).length >= 1 && t.localStorage.setItem(i, JSON.stringify(this.eventData));
                } catch (e1) {
                    H("Unable to write to LocalStorage");
                }
            }
            processRequests(e1) {}
            postEvent(e1, t, i, r) {
                if (!n.EVENTS_URL) return;
                const o = Be(n.EVENTS_URL);
                o.params.push(`access_token=${r || n.ACCESS_TOKEN || ""}`);
                const s = {
                    event: this.type,
                    created: new Date(e1).toISOString()
                }, a = t ? k(s, t) : s, l = {
                    url: Fe(o),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        a
                    ])
                };
                this.pendingRequest = function(e1, t) {
                    return be(k(e1, {
                        method: "POST"
                    }), t);
                }(l, (e1)=>{
                    this.pendingRequest = null, i(e1), this.saveEventData(), this.processRequests(r);
                });
            }
            queueRequest(e1, t) {
                this.queue.push(e1), this.processRequests(t);
            }
            constructor(e1){
                this.type = e1, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
            }
        }
        const je = new class extends Ve {
            postTurnstileEvent(e1, t) {
                n.EVENTS_URL && n.ACCESS_TOKEN && Array.isArray(e1) && e1.some((e1)=>Pe(e1) || De(e1)) && this.queueRequest(Date.now(), t);
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const t = Ue(n.ACCESS_TOKEN), r = t ? t.u : n.ACCESS_TOKEN;
                let o = r !== this.eventData.tokenU;
                V(this.anonId) || (this.anonId = N(), o = !0);
                const s = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const e1 = new Date(this.eventData.lastSuccess), t = new Date(s), i = (s - this.eventData.lastSuccess) / 864e5;
                    o = o || i >= 1 || i < -1 || e1.getDate() !== t.getDate();
                } else o = !0;
                o ? this.postEvent(s, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: i,
                    skuId: u,
                    "enabled.telemetry": !1,
                    userId: this.anonId
                }, (e1)=>{
                    e1 || (this.eventData.lastSuccess = s, this.eventData.tokenU = r);
                }, e1) : this.processRequests();
            }
            constructor(e1){
                super("appUserTurnstile"), this._customAccessToken = e1;
            }
        }, Ge = je.postTurnstileEvent.bind(je), qe = new class extends Ve {
            postMapLoadEvent(e1, t, i, r) {
                this.skuToken = t, this.errorCb = r, n.EVENTS_URL && (i || n.ACCESS_TOKEN ? this.queueRequest({
                    id: e1,
                    timestamp: Date.now()
                }, i) : this.errorCb(new Error(Ce)));
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: t, timestamp: r } = this.queue.shift();
                t && this.success[t] || (this.anonId || this.fetchEventData(), V(this.anonId) || (this.anonId = N()), this.postEvent(r, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: i,
                    skuId: u,
                    skuToken: this.skuToken,
                    userId: this.anonId
                }, (e1)=>{
                    e1 ? this.errorCb(e1) : t && (this.success[t] = !0);
                }, e1));
            }
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
        }, Ze = qe.postMapLoadEvent.bind(qe), $e = new class extends Ve {
            postPerformanceEvent(e1, t) {
                n.EVENTS_URL && (e1 || n.ACCESS_TOKEN) && this.queueRequest({
                    timestamp: Date.now(),
                    performanceData: t
                }, e1);
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: r, performanceData: n } = this.queue.shift(), o = function(e1) {
                    const r = t.performance.getEntriesByType("resource"), n = t.performance.getEntriesByType("mark"), o = function(e1) {
                        const t = {};
                        if (e1) {
                            for(const i in e1)if ("other" !== i) for (const r of e1[i]){
                                const e1 = `${i}ResolveRangeMin`, n = `${i}ResolveRangeMax`, o = `${i}RequestCount`, s = `${i}RequestCachedCount`;
                                t[e1] = Math.min(t[e1] || 1 / 0, r.startTime), t[n] = Math.max(t[n] || -1 / 0, r.responseEnd);
                                const a = (e1)=>{
                                    void 0 === t[e1] && (t[e1] = 0), ++t[e1];
                                };
                                void 0 !== r.transferSize && 0 === r.transferSize && a(s), a(o);
                            }
                        }
                        return t;
                    }(function(e1, t) {
                        const i = {};
                        if (e1) for (const r of e1){
                            const e1 = t(r);
                            void 0 === i[e1] && (i[e1] = []), i[e1].push(r);
                        }
                        return i;
                    }(r, et)), s = t.devicePixelRatio, a = t.navigator.connection || t.navigator.mozConnection || t.navigator.webkitConnection, l = {
                        counters: [],
                        metadata: [],
                        attributes: []
                    }, c = (e1, t, i)=>{
                        null != i && e1.push({
                            name: t,
                            value: i.toString()
                        });
                    };
                    for(const e1 in o)c(l.counters, e1, o[e1]);
                    if (e1.interactionRange[0] !== 1 / 0 && e1.interactionRange[1] !== -1 / 0 && (c(l.counters, "interactionRangeMin", e1.interactionRange[0]), c(l.counters, "interactionRangeMax", e1.interactionRange[1])), n) for (const e1 of Object.keys(Je)){
                        const t = Je[e1], i = n.find((e1)=>e1.name === t);
                        i && c(l.counters, t, i.startTime);
                    }
                    return c(l.counters, "visibilityHidden", e1.visibilityHidden), c(l.attributes, "style", function(e1) {
                        if (e1) for (const t of e1){
                            const e1 = t.name.split("?")[0];
                            if (Le(e1)) {
                                const t = e1.split("/").slice(-2);
                                if (2 === t.length) return `mapbox://styles/${t[0]}/${t[1]}`;
                            }
                        }
                    }(r)), c(l.attributes, "terrainEnabled", e1.terrainEnabled ? "true" : "false"), c(l.attributes, "fogEnabled", e1.fogEnabled ? "true" : "false"), c(l.attributes, "projection", e1.projection), c(l.attributes, "zoom", e1.zoom), c(l.metadata, "devicePixelRatio", s), c(l.metadata, "connectionEffectiveType", a ? a.effectiveType : void 0), c(l.metadata, "navigatorUserAgent", t.navigator.userAgent), c(l.metadata, "screenWidth", t.screen.width), c(l.metadata, "screenHeight", t.screen.height), c(l.metadata, "windowWidth", t.innerWidth), c(l.metadata, "windowHeight", t.innerHeight), c(l.metadata, "mapWidth", e1.width / s), c(l.metadata, "mapHeight", e1.height / s), c(l.metadata, "webglRenderer", e1.renderer), c(l.metadata, "webglVendor", e1.vendor), c(l.metadata, "sdkVersion", i), c(l.metadata, "sdkIdentifier", "mapbox-gl-js"), l;
                }(n);
                for (const e1 of o.metadata);
                for (const e1 of o.counters);
                for (const e1 of o.attributes);
                this.postEvent(r, o, ()=>{}, e1);
            }
            constructor(){
                super("gljs.performance");
            }
        }, We = $e.postPerformanceEvent.bind($e), He = new class extends Ve {
            getSession(e1, t, i, r) {
                if (!n.API_URL || !n.SESSION_PATH) return;
                const o = Be(n.API_URL + n.SESSION_PATH);
                o.params.push(`sku=${t || ""}`), o.params.push(`access_token=${r || n.ACCESS_TOKEN || ""}`);
                const s = {
                    url: Fe(o),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = function(e1, t) {
                    return be(k(e1, {
                        method: "GET"
                    }), t);
                }(s, (e1)=>{
                    this.pendingRequest = null, i(e1), this.saveEventData(), this.processRequests(r);
                });
            }
            getSessionAPI(e1, t, i, r) {
                this.skuToken = t, this.errorCb = r, n.SESSION_PATH && n.API_URL && (i || n.ACCESS_TOKEN ? this.queueRequest({
                    id: e1,
                    timestamp: Date.now()
                }, i) : this.errorCb(new Error(Ce)));
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: t, timestamp: i } = this.queue.shift();
                t && this.success[t] || this.getSession(i, this.skuToken, (e1)=>{
                    e1 ? this.errorCb(e1) : t && (this.success[t] = !0);
                }, e1);
            }
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
        }, Xe = He.getSessionAPI.bind(He), Ye = new Set;
        function Ke(e1, t) {
            t ? Ye.add(e1) : Ye.delete(e1);
        }
        const Je = {
            create: "create",
            load: "load",
            fullLoad: "fullLoad"
        }, Qe = {
            mark (e1) {
                t.performance.mark(e1);
            },
            measure (e1, i, r) {
                t.performance.measure(e1, i, r);
            }
        };
        function et(e1) {
            const t = e1.name.split("?")[0];
            return Re(t) && t.includes("mapbox-gl.js") ? "javascript" : Re(t) && t.includes("mapbox-gl.css") ? "css" : function(e1) {
                return n.API_FONTS_REGEX.test(e1);
            }(t) ? "fontRange" : ke(t) ? "sprite" : Le(t) ? "style" : function(e1) {
                return n.API_TILEJSON_REGEX.test(e1);
            }(t) ? "tilejson" : "other";
        }
        const tt = t.performance;
        function it(e1) {
            const t = e1 ? e1.url.toString() : void 0;
            return tt.getEntriesByName(t);
        }
        var rt = nt;
        function nt(e1) {
            return !function(e1) {
                var t;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray ? Function.prototype && Function.prototype.bind ? Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions ? "JSON" in window && "parse" in JSON && "stringify" in JSON ? function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var e1, t, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), r = URL.createObjectURL(i);
                    try {
                        t = new Worker(r), e1 = !0;
                    } catch (t) {
                        e1 = !1;
                    }
                    return t && t.terminate(), URL.revokeObjectURL(r), e1;
                }() ? "Uint8ClampedArray" in window ? ArrayBuffer.isView ? function() {
                    var e1 = document.createElement("canvas");
                    e1.width = e1.height = 1;
                    var t = e1.getContext("2d");
                    if (!t) return !1;
                    var i = t.getImageData(0, 0, 1, 1);
                    return i && i.width === e1.width;
                }() ? (void 0 === ot[t = e1 && e1.failIfMajorPerformanceCaveat] && (ot[t] = function(e1) {
                    var t, i = function(e1) {
                        var t = document.createElement("canvas"), i = Object.create(nt.webGLContextAttributes);
                        return i.failIfMajorPerformanceCaveat = e1, t.getContext("webgl", i) || t.getContext("experimental-webgl", i);
                    }(e1);
                    if (!i) return !1;
                    try {
                        t = i.createShader(i.VERTEX_SHADER);
                    } catch (e1) {
                        return !1;
                    }
                    return !(!t || i.isContextLost()) && (i.shaderSource(t, "void main() {}"), i.compileShader(t), !0 === i.getShaderParameter(t, i.COMPILE_STATUS));
                }(t)), ot[t] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL support") : "insufficient Canvas/getImageData support" : "insufficient ArrayBuffer support" : "insufficient Uint8ClampedArray support" : "insufficient worker support" : "insufficient JSON support" : "insufficient Object support" : "insufficient Function support" : "insufficent Array support";
            }(e1);
        }
        var ot = {};
        let st, at, lt, ct, ht;
        function ut() {
            return null == st && (st = t.OffscreenCanvas && new t.OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof t.createImageBitmap), st;
        }
        nt.webGLContextAttributes = {
            antialias: !1,
            alpha: !0,
            stencil: !0,
            depth: !0
        };
        const dt = {
            now: ()=>void 0 !== ct ? ct : t.performance.now(),
            setNow (e1) {
                ct = e1;
            },
            restoreNow () {
                ct = void 0;
            },
            frame (e1) {
                const i = t.requestAnimationFrame(e1);
                return {
                    cancel: ()=>t.cancelAnimationFrame(i)
                };
            },
            getImageData (e1, i = 0) {
                const { width: r, height: n } = e1;
                ht || (ht = t.document.createElement("canvas"));
                const o = ht.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!o) throw new Error("failed to create canvas 2d context");
                return (r > ht.width || n > ht.height) && (ht.width = r, ht.height = n), o.clearRect(-i, -i, r + 2 * i, n + 2 * i), o.drawImage(e1, 0, 0, r, n), o.getImageData(-i, -i, r + 2 * i, n + 2 * i);
            },
            resolveURL: (e1)=>(at || (at = t.document.createElement("a")), at.href = e1, at.href),
            get devicePixelRatio () {
                return t.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!t.matchMedia && (null == lt && (lt = t.matchMedia("(prefers-reduced-motion: reduce)")), lt.matches);
            },
            hasCanvasFingerprintNoise () {
                if (!ut()) return !1;
                const e1 = new t.OffscreenCanvas(85, 1), i = e1.getContext("2d", {
                    willReadFrequently: !0
                });
                let r = 0;
                for(let t = 0; t < e1.width; ++t)i.fillStyle = `rgba(${r++},${r++},${r++}, 255)`, i.fillRect(t, 0, 1, 1);
                const n = i.getImageData(0, 0, e1.width, e1.height);
                r = 0;
                for(let e1 = 0; e1 < n.data.length; ++e1)if (e1 % 4 != 3 && r++ !== n.data[e1]) return !0;
                return !1;
            }
        };
        function pt(e1, i, r) {
            const n = t.document.createElement(e1);
            return void 0 !== i && (n.className = i), r && r.appendChild(n), n;
        }
        function ft(e1, i, r) {
            const n = t.document.createElementNS("http://www.w3.org/2000/svg", e1);
            for (const e1 of Object.keys(i))n.setAttributeNS(null, e1, i[e1]);
            return r && r.appendChild(n), n;
        }
        const mt = t.document && t.document.documentElement.style, _t = mt && void 0 !== mt.userSelect ? "userSelect" : "WebkitUserSelect";
        let gt;
        function yt() {
            mt && _t && (gt = mt[_t], mt[_t] = "none");
        }
        function xt() {
            mt && _t && (mt[_t] = gt);
        }
        function vt(e1) {
            e1.preventDefault(), e1.stopPropagation(), t.removeEventListener("click", vt, !0);
        }
        function bt() {
            t.addEventListener("click", vt, !0), t.setTimeout(()=>{
                t.removeEventListener("click", vt, !0);
            }, 0);
        }
        function wt(e1, t) {
            const i = e1.getBoundingClientRect();
            return Mt(e1, i, t);
        }
        function Tt(e1, t) {
            const i = e1.getBoundingClientRect(), r = [];
            for(let n = 0; n < t.length; n++)r.push(Mt(e1, i, t[n]));
            return r;
        }
        function Et(e1) {
            return void 0 !== t.InstallTrigger && 2 === e1.button && e1.ctrlKey && t.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : e1.button;
        }
        function Mt(e1, t, i) {
            const r = e1.offsetWidth === t.width ? 1 : e1.offsetWidth / t.width;
            return new y((i.clientX - t.left) * r, (i.clientY - t.top) * r);
        }
        function At(e1, t, i) {
            i[e1] && -1 !== i[e1].indexOf(t) || (i[e1] = i[e1] || [], i[e1].push(t));
        }
        function St(e1, t, i) {
            if (i && i[e1]) {
                const r = i[e1].indexOf(t);
                -1 !== r && i[e1].splice(r, 1);
            }
        }
        class It {
            constructor(e1, t = {}){
                k(this, t), this.type = e1;
            }
        }
        class Ct extends It {
            constructor(e1, t = {}){
                super("error", k({
                    error: e1
                }, t));
            }
        }
        class zt {
            on(e1, t) {
                return this._listeners = this._listeners || {}, At(e1, t, this._listeners), this;
            }
            off(e1, t) {
                return St(e1, t, this._listeners), St(e1, t, this._oneTimeListeners), this;
            }
            once(e1, t) {
                return t ? (this._oneTimeListeners = this._oneTimeListeners || {}, At(e1, t, this._oneTimeListeners), this) : new Promise((t)=>this.once(e1, t));
            }
            fire(e1, t) {
                "string" == typeof e1 && (e1 = new It(e1, t || {}));
                const i = e1.type;
                if (this.listens(i)) {
                    e1.target = this;
                    const t = this._listeners && this._listeners[i] ? this._listeners[i].slice() : [];
                    for (const i of t)i.call(this, e1);
                    const r = this._oneTimeListeners && this._oneTimeListeners[i] ? this._oneTimeListeners[i].slice() : [];
                    for (const t of r)St(i, t, this._oneTimeListeners), t.call(this, e1);
                    const n = this._eventedParent;
                    n && (k(e1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), n.fire(e1));
                } else e1 instanceof Ct && console.error(e1.error);
                return this;
            }
            listens(e1) {
                return !!(this._listeners && this._listeners[e1] && this._listeners[e1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[e1] && this._oneTimeListeners[e1].length > 0 || this._eventedParent && this._eventedParent.listens(e1));
            }
            setEventedParent(e1, t) {
                return this._eventedParent = e1, this._eventedParentData = t, this;
            }
        }
        var Pt = JSON.parse('{"$version":8,"$root":{"version":{"required":true,"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"required":false,"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"camera":{"type":"camera"},"imports":{"type":"array","value":"import"},"schema":{"type":"schema"},"sources":{"required":true,"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"required":true,"type":"array","value":"layer"},"models":{"type":"models"}},"model":{"type":"string","required":true},"import":{"id":{"type":"string","required":true},"url":{"type":"string","required":true},"config":{"type":"config"},"data":{"type":"$root"}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","required":true},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string","required":true},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false,"expression":{},"property-type":"data-constant"},"shadow-intensity":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_ambient":{"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"required":true,"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"required":true,"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"required":true,"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"type":{"required":true,"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"*":{"type":"*"}},"source_geojson":{"type":{"required":true,"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"}},"source_video":{"type":{"required":true,"type":"enum","values":{"video":1}},"urls":{"required":true,"type":"array","value":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"required":true,"type":"enum","values":{"image":1}},"url":{"required":false,"type":"string"},"coordinates":{"required":true,"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_model":{"type":{"required":true,"type":"enum","values":{"model":1,"batched-model":1}},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"}},"layer":{"id":{"type":"string","required":true},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"raster":{},"hillshade":{},"model":{},"background":{},"sky":{},"slot":{}},"required":true},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"}},"layout":["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"},"fill-extrusion-edge-radius":{"type":"number","private":true,"default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"constant"}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-size":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-rotate":{"type":"number","default":0,"period":360,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{},"property-type":"constant"}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*","required":false}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"high-color":{"type":"color","property-type":"data-constant","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"space-color":{"type":"color","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"horizon-blend":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","property-type":"data-constant","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective","property-type":"data-constant"}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"property-type":"data-constant","expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","property-type":"data-constant","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"intensity":{"type":"number","property-type":"data-constant","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator","required":true},"center":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","property-type":"data-constant","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string","required":true},"exaggeration":{"type":"number","property-type":"data-constant","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"fill-extrusion-ambient-occlusion-intensity":{"property-type":"data-constant","type":"number","private":true,"default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"property-type":"data-constant","type":"number","private":true,"default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"property-type":"data-constant","type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"property-type":"data-constant","type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"property-type":"data-constant","type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"property-type":"data-constant","type":"color","default":"#ffffff","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"property-type":"data-constant","type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"property-type":"data-constant","type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"property-type":"data-constant","type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"property-type":"data-constant","type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-gradient":{"type":"color","expression":{"interpolated":true,"parameters":["line-progress"]},"property-type":"color-ramp"},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"property-type":"constant"},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"line-border-width":{"type":"number","private":true,"default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","private":true,"default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"expression":{"interpolated":true,"parameters":["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-image-cross-fade":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"transition":true},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"icon-color-saturation":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{},"property-type":"data-constant"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-color":{"type":"color","expression":{"interpolated":true,"parameters":["raster-value"]},"property-type":"color-ramp"},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","default":[0,1],"length":2,"value":"number","property-type":"data-constant","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"raster-array-band":{"type":"string","required":false,"property-type":"data-constant"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-accent-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_background":{"background-color":{"type":"color","default":"#000000","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-constant"}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100,"property-type":"data-constant"},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]},"property-type":"data-constant"},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"expression":{"interpolated":true,"parameters":["sky-radial-progress"]},"property-type":"color-ramp"},"sky-atmosphere-halo-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-atmosphere-color":{"type":"color","default":"white","property-type":"data-constant"},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d","property-type":"data-constant"},"model-cast-shadows":{"type":"boolean","default":true,"expression":{},"property-type":"data-constant"},"model-receive-shadows":{"type":"boolean","default":true,"expression":{},"property-type":"data-constant"},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"property-type":"data-constant","transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{},"property-type":"data-constant"}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"property-type":{"data-driven":{"type":"property-type"},"color-ramp":{"type":"property-type"},"data-constant":{"type":"property-type"},"constant":{"type":"property-type"}},"promoteId":{"*":{"type":"string"}}}');
        class Dt {
            constructor(e1, t, i, r){
                this.message = (e1 ? `${e1}: ` : "") + i, r && (this.identifier = r), null != t && t.__line__ && (this.line = t.__line__);
            }
        }
        class Rt extends Dt {
        }
        function Lt(e1, ...t) {
            for (const i of t)for(const t in i)e1[t] = i[t];
            return e1;
        }
        function kt(e1) {
            return e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean ? e1.valueOf() : e1;
        }
        function Ot(e1) {
            if (Array.isArray(e1)) return e1.map(Ot);
            if (e1 instanceof Object && !(e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean)) {
                const t = {};
                for(const i in e1)t[i] = Ot(e1[i]);
                return t;
            }
            return kt(e1);
        }
        class Bt extends Error {
            constructor(e1, t){
                super(t), this.message = t, this.key = e1;
            }
        }
        var Ft = Bt;
        class Nt {
            concat(e1) {
                return new Nt(this, e1);
            }
            get(e1) {
                if (this.bindings[e1]) return this.bindings[e1];
                if (this.parent) return this.parent.get(e1);
                throw new Error(`${e1} not found in scope.`);
            }
            has(e1) {
                return !!this.bindings[e1] || !!this.parent && this.parent.has(e1);
            }
            constructor(e1, t = []){
                this.parent = e1, this.bindings = {};
                for (const [e1, i] of t)this.bindings[e1] = i;
            }
        }
        var Ut = Nt;
        const Vt = {
            kind: "null"
        }, jt = {
            kind: "number"
        }, Gt = {
            kind: "string"
        }, qt = {
            kind: "boolean"
        }, Zt = {
            kind: "color"
        }, $t = {
            kind: "object"
        }, Wt = {
            kind: "value"
        }, Ht = {
            kind: "collator"
        }, Xt = {
            kind: "formatted"
        }, Yt = {
            kind: "resolvedImage"
        };
        function Kt(e1, t) {
            return {
                kind: "array",
                itemType: e1,
                N: t
            };
        }
        function Jt(e1) {
            if ("array" === e1.kind) {
                const t = Jt(e1.itemType);
                return "number" == typeof e1.N ? `array<${t}, ${e1.N}>` : "value" === e1.itemType.kind ? "array" : `array<${t}>`;
            }
            return e1.kind;
        }
        const Qt = [
            Vt,
            jt,
            Gt,
            qt,
            Zt,
            Xt,
            $t,
            Kt(Wt),
            Yt
        ];
        function ei(e1, t) {
            if ("error" === t.kind) return null;
            if ("array" === e1.kind) {
                if ("array" === t.kind && (0 === t.N && "value" === t.itemType.kind || !ei(e1.itemType, t.itemType)) && ("number" != typeof e1.N || e1.N === t.N)) return null;
            } else {
                if (e1.kind === t.kind) return null;
                if ("value" === e1.kind) {
                    for (const e1 of Qt)if (!ei(e1, t)) return null;
                }
            }
            return `Expected ${Jt(e1)} but found ${Jt(t)} instead.`;
        }
        function ti(e1, t) {
            return t.some((t)=>t.kind === e1.kind);
        }
        function ii(e1, t) {
            return t.some((t)=>"null" === t ? null === e1 : "array" === t ? Array.isArray(e1) : "object" === t ? e1 && !Array.isArray(e1) && "object" == typeof e1 : t === typeof e1);
        }
        var ri, ni = {
            transparent: [
                0,
                0,
                0,
                0
            ],
            aliceblue: [
                240,
                248,
                255,
                1
            ],
            antiquewhite: [
                250,
                235,
                215,
                1
            ],
            aqua: [
                0,
                255,
                255,
                1
            ],
            aquamarine: [
                127,
                255,
                212,
                1
            ],
            azure: [
                240,
                255,
                255,
                1
            ],
            beige: [
                245,
                245,
                220,
                1
            ],
            bisque: [
                255,
                228,
                196,
                1
            ],
            black: [
                0,
                0,
                0,
                1
            ],
            blanchedalmond: [
                255,
                235,
                205,
                1
            ],
            blue: [
                0,
                0,
                255,
                1
            ],
            blueviolet: [
                138,
                43,
                226,
                1
            ],
            brown: [
                165,
                42,
                42,
                1
            ],
            burlywood: [
                222,
                184,
                135,
                1
            ],
            cadetblue: [
                95,
                158,
                160,
                1
            ],
            chartreuse: [
                127,
                255,
                0,
                1
            ],
            chocolate: [
                210,
                105,
                30,
                1
            ],
            coral: [
                255,
                127,
                80,
                1
            ],
            cornflowerblue: [
                100,
                149,
                237,
                1
            ],
            cornsilk: [
                255,
                248,
                220,
                1
            ],
            crimson: [
                220,
                20,
                60,
                1
            ],
            cyan: [
                0,
                255,
                255,
                1
            ],
            darkblue: [
                0,
                0,
                139,
                1
            ],
            darkcyan: [
                0,
                139,
                139,
                1
            ],
            darkgoldenrod: [
                184,
                134,
                11,
                1
            ],
            darkgray: [
                169,
                169,
                169,
                1
            ],
            darkgreen: [
                0,
                100,
                0,
                1
            ],
            darkgrey: [
                169,
                169,
                169,
                1
            ],
            darkkhaki: [
                189,
                183,
                107,
                1
            ],
            darkmagenta: [
                139,
                0,
                139,
                1
            ],
            darkolivegreen: [
                85,
                107,
                47,
                1
            ],
            darkorange: [
                255,
                140,
                0,
                1
            ],
            darkorchid: [
                153,
                50,
                204,
                1
            ],
            darkred: [
                139,
                0,
                0,
                1
            ],
            darksalmon: [
                233,
                150,
                122,
                1
            ],
            darkseagreen: [
                143,
                188,
                143,
                1
            ],
            darkslateblue: [
                72,
                61,
                139,
                1
            ],
            darkslategray: [
                47,
                79,
                79,
                1
            ],
            darkslategrey: [
                47,
                79,
                79,
                1
            ],
            darkturquoise: [
                0,
                206,
                209,
                1
            ],
            darkviolet: [
                148,
                0,
                211,
                1
            ],
            deeppink: [
                255,
                20,
                147,
                1
            ],
            deepskyblue: [
                0,
                191,
                255,
                1
            ],
            dimgray: [
                105,
                105,
                105,
                1
            ],
            dimgrey: [
                105,
                105,
                105,
                1
            ],
            dodgerblue: [
                30,
                144,
                255,
                1
            ],
            firebrick: [
                178,
                34,
                34,
                1
            ],
            floralwhite: [
                255,
                250,
                240,
                1
            ],
            forestgreen: [
                34,
                139,
                34,
                1
            ],
            fuchsia: [
                255,
                0,
                255,
                1
            ],
            gainsboro: [
                220,
                220,
                220,
                1
            ],
            ghostwhite: [
                248,
                248,
                255,
                1
            ],
            gold: [
                255,
                215,
                0,
                1
            ],
            goldenrod: [
                218,
                165,
                32,
                1
            ],
            gray: [
                128,
                128,
                128,
                1
            ],
            green: [
                0,
                128,
                0,
                1
            ],
            greenyellow: [
                173,
                255,
                47,
                1
            ],
            grey: [
                128,
                128,
                128,
                1
            ],
            honeydew: [
                240,
                255,
                240,
                1
            ],
            hotpink: [
                255,
                105,
                180,
                1
            ],
            indianred: [
                205,
                92,
                92,
                1
            ],
            indigo: [
                75,
                0,
                130,
                1
            ],
            ivory: [
                255,
                255,
                240,
                1
            ],
            khaki: [
                240,
                230,
                140,
                1
            ],
            lavender: [
                230,
                230,
                250,
                1
            ],
            lavenderblush: [
                255,
                240,
                245,
                1
            ],
            lawngreen: [
                124,
                252,
                0,
                1
            ],
            lemonchiffon: [
                255,
                250,
                205,
                1
            ],
            lightblue: [
                173,
                216,
                230,
                1
            ],
            lightcoral: [
                240,
                128,
                128,
                1
            ],
            lightcyan: [
                224,
                255,
                255,
                1
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210,
                1
            ],
            lightgray: [
                211,
                211,
                211,
                1
            ],
            lightgreen: [
                144,
                238,
                144,
                1
            ],
            lightgrey: [
                211,
                211,
                211,
                1
            ],
            lightpink: [
                255,
                182,
                193,
                1
            ],
            lightsalmon: [
                255,
                160,
                122,
                1
            ],
            lightseagreen: [
                32,
                178,
                170,
                1
            ],
            lightskyblue: [
                135,
                206,
                250,
                1
            ],
            lightslategray: [
                119,
                136,
                153,
                1
            ],
            lightslategrey: [
                119,
                136,
                153,
                1
            ],
            lightsteelblue: [
                176,
                196,
                222,
                1
            ],
            lightyellow: [
                255,
                255,
                224,
                1
            ],
            lime: [
                0,
                255,
                0,
                1
            ],
            limegreen: [
                50,
                205,
                50,
                1
            ],
            linen: [
                250,
                240,
                230,
                1
            ],
            magenta: [
                255,
                0,
                255,
                1
            ],
            maroon: [
                128,
                0,
                0,
                1
            ],
            mediumaquamarine: [
                102,
                205,
                170,
                1
            ],
            mediumblue: [
                0,
                0,
                205,
                1
            ],
            mediumorchid: [
                186,
                85,
                211,
                1
            ],
            mediumpurple: [
                147,
                112,
                219,
                1
            ],
            mediumseagreen: [
                60,
                179,
                113,
                1
            ],
            mediumslateblue: [
                123,
                104,
                238,
                1
            ],
            mediumspringgreen: [
                0,
                250,
                154,
                1
            ],
            mediumturquoise: [
                72,
                209,
                204,
                1
            ],
            mediumvioletred: [
                199,
                21,
                133,
                1
            ],
            midnightblue: [
                25,
                25,
                112,
                1
            ],
            mintcream: [
                245,
                255,
                250,
                1
            ],
            mistyrose: [
                255,
                228,
                225,
                1
            ],
            moccasin: [
                255,
                228,
                181,
                1
            ],
            navajowhite: [
                255,
                222,
                173,
                1
            ],
            navy: [
                0,
                0,
                128,
                1
            ],
            oldlace: [
                253,
                245,
                230,
                1
            ],
            olive: [
                128,
                128,
                0,
                1
            ],
            olivedrab: [
                107,
                142,
                35,
                1
            ],
            orange: [
                255,
                165,
                0,
                1
            ],
            orangered: [
                255,
                69,
                0,
                1
            ],
            orchid: [
                218,
                112,
                214,
                1
            ],
            palegoldenrod: [
                238,
                232,
                170,
                1
            ],
            palegreen: [
                152,
                251,
                152,
                1
            ],
            paleturquoise: [
                175,
                238,
                238,
                1
            ],
            palevioletred: [
                219,
                112,
                147,
                1
            ],
            papayawhip: [
                255,
                239,
                213,
                1
            ],
            peachpuff: [
                255,
                218,
                185,
                1
            ],
            peru: [
                205,
                133,
                63,
                1
            ],
            pink: [
                255,
                192,
                203,
                1
            ],
            plum: [
                221,
                160,
                221,
                1
            ],
            powderblue: [
                176,
                224,
                230,
                1
            ],
            purple: [
                128,
                0,
                128,
                1
            ],
            rebeccapurple: [
                102,
                51,
                153,
                1
            ],
            red: [
                255,
                0,
                0,
                1
            ],
            rosybrown: [
                188,
                143,
                143,
                1
            ],
            royalblue: [
                65,
                105,
                225,
                1
            ],
            saddlebrown: [
                139,
                69,
                19,
                1
            ],
            salmon: [
                250,
                128,
                114,
                1
            ],
            sandybrown: [
                244,
                164,
                96,
                1
            ],
            seagreen: [
                46,
                139,
                87,
                1
            ],
            seashell: [
                255,
                245,
                238,
                1
            ],
            sienna: [
                160,
                82,
                45,
                1
            ],
            silver: [
                192,
                192,
                192,
                1
            ],
            skyblue: [
                135,
                206,
                235,
                1
            ],
            slateblue: [
                106,
                90,
                205,
                1
            ],
            slategray: [
                112,
                128,
                144,
                1
            ],
            slategrey: [
                112,
                128,
                144,
                1
            ],
            snow: [
                255,
                250,
                250,
                1
            ],
            springgreen: [
                0,
                255,
                127,
                1
            ],
            steelblue: [
                70,
                130,
                180,
                1
            ],
            tan: [
                210,
                180,
                140,
                1
            ],
            teal: [
                0,
                128,
                128,
                1
            ],
            thistle: [
                216,
                191,
                216,
                1
            ],
            tomato: [
                255,
                99,
                71,
                1
            ],
            turquoise: [
                64,
                224,
                208,
                1
            ],
            violet: [
                238,
                130,
                238,
                1
            ],
            wheat: [
                245,
                222,
                179,
                1
            ],
            white: [
                255,
                255,
                255,
                1
            ],
            whitesmoke: [
                245,
                245,
                245,
                1
            ],
            yellow: [
                255,
                255,
                0,
                1
            ],
            yellowgreen: [
                154,
                205,
                50,
                1
            ]
        };
        function oi(e1) {
            return (e1 = Math.round(e1)) < 0 ? 0 : e1 > 255 ? 255 : e1;
        }
        function si(e1) {
            return oi("%" === e1[e1.length - 1] ? parseFloat(e1) / 100 * 255 : parseInt(e1));
        }
        function ai(e1) {
            var t;
            return (t = "%" === e1[e1.length - 1] ? parseFloat(e1) / 100 : parseFloat(e1)) < 0 ? 0 : t > 1 ? 1 : t;
        }
        function li(e1, t, i) {
            return i < 0 ? i += 1 : i > 1 && (i -= 1), 6 * i < 1 ? e1 + (t - e1) * i * 6 : 2 * i < 1 ? t : 3 * i < 2 ? e1 + (t - e1) * (2 / 3 - i) * 6 : e1;
        }
        try {
            ri = ({}).parseCSSColor = function(e1) {
                var t, i = e1.replace(/ /g, "").toLowerCase();
                if (i in ni) return ni[i].slice();
                if ("#" === i[0]) return 4 === i.length ? (t = parseInt(i.substr(1), 16)) >= 0 && t <= 4095 ? [
                    (3840 & t) >> 4 | (3840 & t) >> 8,
                    240 & t | (240 & t) >> 4,
                    15 & t | (15 & t) << 4,
                    1
                ] : null : 7 === i.length && (t = parseInt(i.substr(1), 16)) >= 0 && t <= 16777215 ? [
                    (16711680 & t) >> 16,
                    (65280 & t) >> 8,
                    255 & t,
                    1
                ] : null;
                var r = i.indexOf("("), n = i.indexOf(")");
                if (-1 !== r && n + 1 === i.length) {
                    var o = i.substr(0, r), s = i.substr(r + 1, n - (r + 1)).split(","), a = 1;
                    switch(o){
                        case "rgba":
                            if (4 !== s.length) return null;
                            a = ai(s.pop());
                        case "rgb":
                            return 3 !== s.length ? null : [
                                si(s[0]),
                                si(s[1]),
                                si(s[2]),
                                a
                            ];
                        case "hsla":
                            if (4 !== s.length) return null;
                            a = ai(s.pop());
                        case "hsl":
                            if (3 !== s.length) return null;
                            var l = (parseFloat(s[0]) % 360 + 360) % 360 / 360, c = ai(s[1]), h = ai(s[2]), u = h <= .5 ? h * (c + 1) : h + c - h * c, d = 2 * h - u;
                            return [
                                oi(255 * li(d, u, l + 1 / 3)),
                                oi(255 * li(d, u, l)),
                                oi(255 * li(d, u, l - 1 / 3)),
                                a
                            ];
                        default:
                            return null;
                    }
                }
                return null;
            };
        } catch (e1) {}
        class ci {
            static parse(e1) {
                if (!e1) return;
                if (e1 instanceof ci) return e1;
                if ("string" != typeof e1) return;
                const t = ri(e1);
                return t ? new ci(t[0] / 255 * t[3], t[1] / 255 * t[3], t[2] / 255 * t[3], t[3]) : void 0;
            }
            toString() {
                const [e1, t, i, r] = this.toArray();
                return `rgba(${Math.round(e1)},${Math.round(t)},${Math.round(i)},${r})`;
            }
            toArray() {
                const { r: e1, g: t, b: i, a: r } = this;
                return 0 === r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    255 * e1 / r,
                    255 * t / r,
                    255 * i / r,
                    r
                ];
            }
            toArray01() {
                const { r: e1, g: t, b: i, a: r } = this;
                return 0 === r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    e1 / r,
                    t / r,
                    i / r,
                    r
                ];
            }
            toArray01Scaled(e1) {
                const { r: t, g: i, b: r, a: n } = this;
                return 0 === n ? [
                    0,
                    0,
                    0
                ] : [
                    t / n * e1,
                    i / n * e1,
                    r / n * e1
                ];
            }
            toArray01PremultipliedAlpha() {
                const { r: e1, g: t, b: i, a: r } = this;
                return [
                    e1,
                    t,
                    i,
                    r
                ];
            }
            toArray01Linear() {
                const { r: e1, g: t, b: i, a: r } = this;
                return 0 === r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    Math.pow(e1 / r, 2.2),
                    Math.pow(t / r, 2.2),
                    Math.pow(i / r, 2.2),
                    r
                ];
            }
            constructor(e1, t, i, r = 1){
                this.r = e1, this.g = t, this.b = i, this.a = r;
            }
        }
        ci.black = new ci(0, 0, 0, 1), ci.white = new ci(1, 1, 1, 1), ci.transparent = new ci(0, 0, 0, 0), ci.red = new ci(1, 0, 0, 1), ci.blue = new ci(0, 0, 1, 1);
        var hi = ci;
        class ui {
            compare(e1, t) {
                return this.collator.compare(e1, t);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
            constructor(e1, t, i){
                this.sensitivity = e1 ? t ? "variant" : "case" : t ? "accent" : "base", this.locale = i, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
        }
        class di {
            constructor(e1, t, i, r, n){
                this.text = e1.normalize ? e1.normalize() : e1, this.image = t, this.scale = i, this.fontStack = r, this.textColor = n;
            }
        }
        class pi {
            static fromString(e1) {
                return new pi([
                    new di(e1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((e1)=>0 !== e1.text.length || e1.image && 0 !== e1.image.namePrimary.length);
            }
            static factory(e1) {
                return e1 instanceof pi ? e1 : pi.fromString(e1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((e1)=>e1.text).join("");
            }
            serialize() {
                const e1 = [
                    "format"
                ];
                for (const t of this.sections){
                    if (t.image) {
                        e1.push([
                            "image",
                            t.image.namePrimary
                        ]);
                        continue;
                    }
                    e1.push(t.text);
                    const i = {};
                    t.fontStack && (i["text-font"] = [
                        "literal",
                        t.fontStack.split(",")
                    ]), t.scale && (i["font-scale"] = t.scale), t.textColor && (i["text-color"] = [
                        "rgba"
                    ].concat(t.textColor.toArray())), e1.push(i);
                }
                return e1;
            }
            constructor(e1){
                this.sections = e1;
            }
        }
        class fi {
            toString() {
                return this.nameSecondary ? `[${this.namePrimary},${this.nameSecondary}]` : this.namePrimary;
            }
            static fromString(e1, t) {
                return e1 ? new fi({
                    namePrimary: e1,
                    nameSecondary: t,
                    available: !1
                }) : null;
            }
            serialize() {
                return this.nameSecondary ? [
                    "image",
                    this.namePrimary,
                    this.nameSecondary
                ] : [
                    "image",
                    this.namePrimary
                ];
            }
            constructor(e1){
                this.namePrimary = e1.namePrimary, e1.nameSecondary && (this.nameSecondary = e1.nameSecondary), this.available = e1.available;
            }
        }
        function mi(e1, t, i, r) {
            return "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof i && i >= 0 && i <= 255 ? void 0 === r || "number" == typeof r && r >= 0 && r <= 1 ? null : `Invalid rgba value [${[
                e1,
                t,
                i,
                r
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof r ? [
                e1,
                t,
                i,
                r
            ] : [
                e1,
                t,
                i
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function _i(e1) {
            if (null === e1) return !0;
            if ("string" == typeof e1) return !0;
            if ("boolean" == typeof e1) return !0;
            if ("number" == typeof e1) return !0;
            if (e1 instanceof hi) return !0;
            if (e1 instanceof ui) return !0;
            if (e1 instanceof pi) return !0;
            if (e1 instanceof fi) return !0;
            if (Array.isArray(e1)) {
                for (const t of e1)if (!_i(t)) return !1;
                return !0;
            }
            if ("object" == typeof e1) {
                for(const t in e1)if (!_i(e1[t])) return !1;
                return !0;
            }
            return !1;
        }
        function gi(e1) {
            if (null === e1) return Vt;
            if ("string" == typeof e1) return Gt;
            if ("boolean" == typeof e1) return qt;
            if ("number" == typeof e1) return jt;
            if (e1 instanceof hi) return Zt;
            if (e1 instanceof ui) return Ht;
            if (e1 instanceof pi) return Xt;
            if (e1 instanceof fi) return Yt;
            if (Array.isArray(e1)) {
                const t = e1.length;
                let i;
                for (const t of e1){
                    const e1 = gi(t);
                    if (i) {
                        if (i === e1) continue;
                        i = Wt;
                        break;
                    }
                    i = e1;
                }
                return Kt(i || Wt, t);
            }
            return $t;
        }
        function yi(e1) {
            const t = typeof e1;
            return null === e1 ? "" : "string" === t || "number" === t || "boolean" === t ? String(e1) : e1 instanceof hi || e1 instanceof pi || e1 instanceof fi ? e1.toString() : JSON.stringify(e1);
        }
        class xi {
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`'literal' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (!_i(e1[1])) return t.error("invalid value");
                const i = e1[1];
                let r = gi(i);
                const n = t.expectedType;
                return "array" !== r.kind || 0 !== r.N || !n || "array" !== n.kind || "number" == typeof n.N && 0 !== n.N || (r = n), new xi(r, i);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof hi ? [
                    "rgba"
                ].concat(this.value.toArray()) : this.value instanceof pi ? this.value.serialize() : this.value;
            }
            constructor(e1, t){
                this.type = e1, this.value = t;
            }
        }
        var vi = xi, bi = class {
            toJSON() {
                return this.message;
            }
            constructor(e1){
                this.name = "ExpressionEvaluationError", this.message = e1;
            }
        };
        const wi = {
            string: Gt,
            number: jt,
            boolean: qt,
            object: $t
        };
        class Ti {
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected at least one argument.");
                let i, r = 1;
                const n = e1[0];
                if ("array" === n) {
                    let n, o;
                    if (e1.length > 2) {
                        const i = e1[1];
                        if ("string" != typeof i || !(i in wi) || "object" === i) return t.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        n = wi[i], r++;
                    } else n = Wt;
                    if (e1.length > 3) {
                        if (null !== e1[2] && ("number" != typeof e1[2] || e1[2] < 0 || e1[2] !== Math.floor(e1[2]))) return t.error('The length argument to "array" must be a positive integer literal', 2);
                        o = e1[2], r++;
                    }
                    i = Kt(n, o);
                } else i = wi[n];
                const o = [];
                for(; r < e1.length; r++){
                    const i = t.parse(e1[r], r, Wt);
                    if (!i) return null;
                    o.push(i);
                }
                return new Ti(i, o);
            }
            evaluate(e1) {
                for(let t = 0; t < this.args.length; t++){
                    const i = this.args[t].evaluate(e1);
                    if (!ei(this.type, gi(i))) return i;
                    if (t === this.args.length - 1) throw new bi(`Expected value to be of type ${Jt(this.type)}, but found ${Jt(gi(i))} instead.`);
                }
                return null;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = this.type, t = [
                    e1.kind
                ];
                if ("array" === e1.kind) {
                    const i = e1.itemType;
                    if ("string" === i.kind || "number" === i.kind || "boolean" === i.kind) {
                        t.push(i.kind);
                        const r = e1.N;
                        ("number" == typeof r || this.args.length > 1) && t.push(r);
                    }
                }
                return t.concat(this.args.map((e1)=>e1.serialize()));
            }
            constructor(e1, t){
                this.type = e1, this.args = t;
            }
        }
        var Ei = Ti;
        class Mi {
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected at least one argument.");
                const i = e1[1];
                if (!Array.isArray(i) && "object" == typeof i) return t.error("First argument must be an image or text section.");
                const r = [];
                let n = !1;
                for(let i = 1; i <= e1.length - 1; ++i){
                    const o = e1[i];
                    if (n && "object" == typeof o && !Array.isArray(o)) {
                        n = !1;
                        let e1 = null;
                        if (o["font-scale"] && (e1 = t.parse(o["font-scale"], 1, jt), !e1)) return null;
                        let i = null;
                        if (o["text-font"] && (i = t.parse(o["text-font"], 1, Kt(Gt)), !i)) return null;
                        let s = null;
                        if (o["text-color"] && (s = t.parse(o["text-color"], 1, Zt), !s)) return null;
                        const a = r[r.length - 1];
                        a.scale = e1, a.font = i, a.textColor = s;
                    } else {
                        const o = t.parse(e1[i], 1, Wt);
                        if (!o) return null;
                        const s = o.type.kind;
                        if ("string" !== s && "value" !== s && "null" !== s && "resolvedImage" !== s) return t.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        n = !0, r.push({
                            content: o,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new Mi(r);
            }
            evaluate(e1) {
                return new pi(this.sections.map((t)=>{
                    const i = t.content.evaluate(e1);
                    return gi(i) === Yt ? new di("", i, null, null, null) : new di(yi(i), null, t.scale ? t.scale.evaluate(e1) : null, t.font ? t.font.evaluate(e1).join(",") : null, t.textColor ? t.textColor.evaluate(e1) : null);
                }));
            }
            eachChild(e1) {
                for (const t of this.sections)e1(t.content), t.scale && e1(t.scale), t.font && e1(t.font), t.textColor && e1(t.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "format"
                ];
                for (const t of this.sections){
                    e1.push(t.content.serialize());
                    const i = {};
                    t.scale && (i["font-scale"] = t.scale.serialize()), t.font && (i["text-font"] = t.font.serialize()), t.textColor && (i["text-color"] = t.textColor.serialize()), e1.push(i);
                }
                return e1;
            }
            constructor(e1){
                this.type = Xt, this.sections = e1;
            }
        }
        class Ai {
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected two or more arguments.");
                const i = t.parse(e1[1], 1, Gt);
                if (!i) return t.error("No image name provided.");
                if (2 === e1.length) return new Ai(i);
                const r = t.parse(e1[2], 1, Gt);
                return r ? new Ai(i, r) : t.error("Secondary image variant is not a string.");
            }
            evaluate(e1) {
                const t = fi.fromString(this.inputPrimary.evaluate(e1), this.inputSecondary ? this.inputSecondary.evaluate(e1) : void 0);
                return t && e1.availableImages && (t.available = e1.availableImages.indexOf(t.namePrimary) > -1, t.nameSecondary && t.available && e1.availableImages && (t.available = e1.availableImages.indexOf(t.nameSecondary) > -1)), t;
            }
            eachChild(e1) {
                e1(this.inputPrimary), this.inputSecondary && e1(this.inputSecondary);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return this.inputSecondary ? [
                    "image",
                    this.inputPrimary.serialize(),
                    this.inputSecondary.serialize()
                ] : [
                    "image",
                    this.inputPrimary.serialize()
                ];
            }
            constructor(e1, t){
                this.type = Yt, this.inputPrimary = e1, this.inputSecondary = t;
            }
        }
        function Si(e1) {
            return e1 instanceof Number ? "number" : e1 instanceof String ? "string" : e1 instanceof Boolean ? "boolean" : Array.isArray(e1) ? "array" : null === e1 ? "null" : typeof e1;
        }
        const Ii = {
            "to-boolean": qt,
            "to-color": Zt,
            "to-number": jt,
            "to-string": Gt
        };
        class Ci {
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expected at least one argument.");
                const i = e1[0], r = [];
                let n = Vt;
                if ("to-array" === i) {
                    if (!Array.isArray(e1[1])) return null;
                    const i = e1[1].length;
                    if (t.expectedType) {
                        if ("array" !== t.expectedType.kind) return t.error(`Expected ${t.expectedType.kind} but found array.`);
                        n = Kt(t.expectedType.itemType, i);
                    } else {
                        if (!(i > 0 && _i(e1[1][0]))) return null;
                        n = Kt(gi(e1[1][0]), i);
                    }
                    for(let o = 0; o < i; o++){
                        const i = e1[1][o];
                        let s;
                        if ("array" === Si(i)) s = t.parse(i, void 0, n.itemType);
                        else {
                            const e1 = Si(i);
                            if (e1 !== n.itemType.kind) return t.error(`Expected ${n.itemType.kind} but found ${e1}.`);
                            s = t.registry.literal.parse([
                                "literal",
                                void 0 === i ? null : i
                            ], t);
                        }
                        if (!s) return null;
                        r.push(s);
                    }
                } else {
                    if (("to-boolean" === i || "to-string" === i) && 2 !== e1.length) return t.error("Expected one argument.");
                    n = Ii[i];
                    for(let i = 1; i < e1.length; i++){
                        const n = t.parse(e1[i], i, Wt);
                        if (!n) return null;
                        r.push(n);
                    }
                }
                return new Ci(n, r);
            }
            evaluate(e1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(e1));
                if ("color" === this.type.kind) {
                    let t, i;
                    for (const r of this.args){
                        if (t = r.evaluate(e1), i = null, t instanceof hi) return t;
                        if ("string" == typeof t) {
                            const i = e1.parseColor(t);
                            if (i) return i;
                        } else if (Array.isArray(t) && (i = t.length < 3 || t.length > 4 ? `Invalid rbga value ${JSON.stringify(t)}: expected an array containing either three or four numeric values.` : mi(t[0], t[1], t[2], t[3]), !i)) return new hi(t[0] / 255, t[1] / 255, t[2] / 255, t[3]);
                    }
                    throw new bi(i || `Could not parse color from value '${"string" == typeof t ? t : String(JSON.stringify(t))}'`);
                }
                if ("number" === this.type.kind) {
                    let t = null;
                    for (const i of this.args){
                        if (t = i.evaluate(e1), null === t) return 0;
                        const r = Number(t);
                        if (!isNaN(r)) return r;
                    }
                    throw new bi(`Could not convert ${JSON.stringify(t)} to number.`);
                }
                return "formatted" === this.type.kind ? pi.fromString(yi(this.args[0].evaluate(e1))) : "resolvedImage" === this.type.kind ? fi.fromString(yi(this.args[0].evaluate(e1))) : "array" === this.type.kind ? this.args.map((t)=>t.evaluate(e1)) : yi(this.args[0].evaluate(e1));
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new Mi([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new Ai(this.args[0]).serialize();
                const e1 = "array" === this.type.kind ? [] : [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((t)=>{
                    e1.push(t.serialize());
                }), e1;
            }
            constructor(e1, t){
                this.type = e1, this.args = t;
            }
        }
        var zi = Ci;
        const Pi = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        var Di = class {
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? Pi[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            measureLight(e1) {
                return this.globals.brightness || 0;
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const e1 = this.featureDistanceData.center, t = this.featureDistanceData.scale, { x: i, y: r } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (i * t - e1[0]) + this.featureDistanceData.bearing[1] * (r * t - e1[1]);
                }
                return 0;
            }
            parseColor(e1) {
                let t = this._parseColorCache[e1];
                return t || (t = this._parseColorCache[e1] = hi.parse(e1)), t;
            }
            getConfig(e1) {
                return this.options ? this.options.get(e1) : null;
            }
            constructor(e1){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.options = e1;
            }
        };
        class Ri {
            evaluate(e1) {
                if (!this._evaluate) {
                    const e1 = Ri.definitions[this.name];
                    this._evaluate = Array.isArray(e1) ? e1[2] : e1.overloads[this._overloadIndex][1];
                }
                return this._evaluate(e1, this.args);
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((e1)=>e1.serialize()));
            }
            static parse(e1, t) {
                const i = e1[0], r = Ri.definitions[i];
                if (!r) return t.error(`Unknown expression "${i}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const n = Array.isArray(r) ? r[0] : r.type, o = Array.isArray(r) ? [
                    [
                        r[1],
                        r[2]
                    ]
                ] : r.overloads, s = [];
                let a = null, l = -1;
                for (const [r, c] of o){
                    if (Array.isArray(r) && r.length !== e1.length - 1) continue;
                    s.push(r), l++, a = new $r(t.registry, t.path, null, t.scope, void 0, t.options);
                    const o = [];
                    let h = !1;
                    for(let t = 1; t < e1.length; t++){
                        const i = e1[t], n = Array.isArray(r) ? r[t - 1] : r.type, s = a.parse(i, 1 + o.length, n);
                        if (!s) {
                            h = !0;
                            break;
                        }
                        o.push(s);
                    }
                    if (!h) {
                        if (Array.isArray(r) && r.length !== o.length) a.error(`Expected ${r.length} arguments, but found ${o.length} instead.`);
                        else {
                            for(let e1 = 0; e1 < o.length; e1++){
                                const t = Array.isArray(r) ? r[e1] : r.type, i = o[e1];
                                a.concat(e1 + 1).checkSubtype(t, i.type);
                            }
                            if (0 === a.errors.length) return new Ri(i, n, c, o, l);
                        }
                    }
                }
                if (1 === s.length) t.errors.push(...a.errors);
                else {
                    const i = (s.length ? s : o.map(([e1])=>e1)).map(Li).join(" | "), r = [];
                    for(let i = 1; i < e1.length; i++){
                        const n = t.parse(e1[i], 1 + r.length);
                        if (!n) return null;
                        r.push(Jt(n.type));
                    }
                    t.error(`Expected arguments of type ${i}, but found (${r.join(", ")}) instead.`);
                }
                return null;
            }
            static register(e1, t) {
                Ri.definitions = t;
                for(const i in t)e1[i] = Ri;
            }
            constructor(e1, t, i, r, n){
                this.name = e1, this.type = t, this._evaluate = i, this.args = r, this._overloadIndex = n;
            }
        }
        function Li(e1) {
            return Array.isArray(e1) ? `(${e1.map(Jt).join(", ")})` : `(${Jt(e1.type)}...)`;
        }
        var ki = Ri;
        class Oi {
            static parse(e1, t) {
                if (2 !== e1.length) return t.error("Expected one argument.");
                const i = e1[1];
                if ("object" != typeof i || Array.isArray(i)) return t.error("Collator options argument must be an object.");
                const r = t.parse(void 0 !== i["case-sensitive"] && i["case-sensitive"], 1, qt);
                if (!r) return null;
                const n = t.parse(void 0 !== i["diacritic-sensitive"] && i["diacritic-sensitive"], 1, qt);
                if (!n) return null;
                let o = null;
                return i.locale && (o = t.parse(i.locale, 1, Gt), !o) ? null : new Oi(r, n, o);
            }
            evaluate(e1) {
                return new ui(this.caseSensitive.evaluate(e1), this.diacriticSensitive.evaluate(e1), this.locale ? this.locale.evaluate(e1) : null);
            }
            eachChild(e1) {
                e1(this.caseSensitive), e1(this.diacriticSensitive), this.locale && e1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = {};
                return e1["case-sensitive"] = this.caseSensitive.serialize(), e1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (e1.locale = this.locale.serialize()), [
                    "collator",
                    e1
                ];
            }
            constructor(e1, t, i){
                this.type = Ht, this.locale = i, this.caseSensitive = e1, this.diacriticSensitive = t;
            }
        }
        var Bi = {
            exports: {}
        };
        Bi.exports = function() {
            function e1(i, r, n, o, s) {
                for(; o > n;){
                    if (o - n > 600) {
                        var a = o - n + 1, l = r - n + 1, c = Math.log(a), h = .5 * Math.exp(2 * c / 3), u = .5 * Math.sqrt(c * h * (a - h) / a) * (l - a / 2 < 0 ? -1 : 1);
                        e1(i, r, Math.max(n, Math.floor(r - l * h / a + u)), Math.min(o, Math.floor(r + (a - l) * h / a + u)), s);
                    }
                    var d = i[r], p = n, f = o;
                    for(t(i, n, r), s(i[o], d) > 0 && t(i, n, o); p < f;){
                        for(t(i, p, f), p++, f--; s(i[p], d) < 0;)p++;
                        for(; s(i[f], d) > 0;)f--;
                    }
                    0 === s(i[n], d) ? t(i, n, f) : t(i, ++f, o), f <= r && (n = f + 1), r <= f && (o = f - 1);
                }
            }
            function t(e1, t, i) {
                var r = e1[t];
                e1[t] = e1[i], e1[i] = r;
            }
            function i(e1, t) {
                return e1 < t ? -1 : e1 > t ? 1 : 0;
            }
            return function(t, r, n, o, s) {
                e1(t, r, n || 0, o || t.length - 1, s || i);
            };
        }();
        var Fi = d(Bi.exports);
        function Ni(e1) {
            let t = 0;
            for(let i, r, n = 0, o = e1.length, s = o - 1; n < o; s = n++)i = e1[n], r = e1[s], t += (r.x - i.x) * (i.y + r.y);
            return t;
        }
        function Ui(e1, t) {
            e1[0] = Math.min(e1[0], t[0]), e1[1] = Math.min(e1[1], t[1]), e1[2] = Math.max(e1[2], t[0]), e1[3] = Math.max(e1[3], t[1]);
        }
        function Vi(e1, t) {
            return !(e1[0] <= t[0] || e1[2] >= t[2] || e1[1] <= t[1] || e1[3] >= t[3]);
        }
        function ji(e1, t, i) {
            const r = e1[0] - t[0], n = e1[1] - t[1], o = e1[0] - i[0], s = e1[1] - i[1];
            return r * s - o * n == 0 && r * o <= 0 && n * s <= 0;
        }
        function Gi(e1, t, i = !1) {
            let r = !1;
            for(let a = 0, l = t.length; a < l; a++){
                const l = t[a];
                for(let t = 0, a = l.length, c = a - 1; t < a; c = t++){
                    const a = l[c], h = l[t];
                    if (ji(e1, a, h)) return i;
                    (o = a)[1] > (n = e1)[1] != (s = h)[1] > n[1] && n[0] < (s[0] - o[0]) * (n[1] - o[1]) / (s[1] - o[1]) + o[0] && (r = !r);
                }
            }
            var n, o, s;
            return r;
        }
        function qi(e1, t, i, r) {
            const n = r[0] - i[0], o = r[1] - i[1], s = (e1[0] - i[0]) * o - n * (e1[1] - i[1]), a = (t[0] - i[0]) * o - n * (t[1] - i[1]);
            return s > 0 && a < 0 || s < 0 && a > 0;
        }
        function Zi(e1, t, i, r) {
            var n, o;
            return 0 != (n = [
                r[0] - i[0],
                r[1] - i[1]
            ])[0] * (o = [
                t[0] - e1[0],
                t[1] - e1[1]
            ])[1] - n[1] * o[0] && !(!qi(e1, t, i, r) || !qi(i, r, e1, t));
        }
        const $i = 8192;
        function Wi(e1, t) {
            const i = (180 + e1[0]) / 360, r = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1[1] * Math.PI / 360))) / 360, n = Math.pow(2, t.z);
            return [
                Math.round(i * n * $i),
                Math.round(r * n * $i)
            ];
        }
        function Hi(e1, t) {
            for(let i = 0; i < t.length; i++)if (Gi(e1, t[i])) return !0;
            return !1;
        }
        function Xi(e1, t, i) {
            for (const r of i)for(let i = 0, n = r.length, o = n - 1; i < n; o = i++)if (Zi(e1, t, r[o], r[i])) return !0;
            return !1;
        }
        function Yi(e1, t) {
            for(let i = 0; i < e1.length; ++i)if (!Gi(e1[i], t)) return !1;
            for(let i = 0; i < e1.length - 1; ++i)if (Xi(e1[i], e1[i + 1], t)) return !1;
            return !0;
        }
        function Ki(e1, t) {
            for(let i = 0; i < t.length; i++)if (Yi(e1, t[i])) return !0;
            return !1;
        }
        function Ji(e1, t, i) {
            const r = [];
            for(let n = 0; n < e1.length; n++){
                const o = [];
                for(let r = 0; r < e1[n].length; r++){
                    const s = Wi(e1[n][r], i);
                    Ui(t, s), o.push(s);
                }
                r.push(o);
            }
            return r;
        }
        function Qi(e1, t, i) {
            const r = [];
            for(let n = 0; n < e1.length; n++){
                const o = Ji(e1[n], t, i);
                r.push(o);
            }
            return r;
        }
        function er(e1, t, i, r) {
            if (e1[0] < i[0] || e1[0] > i[2]) {
                const t = .5 * r;
                let n = e1[0] - i[0] > t ? -r : i[0] - e1[0] > t ? r : 0;
                0 === n && (n = e1[0] - i[2] > t ? -r : i[2] - e1[0] > t ? r : 0), e1[0] += n;
            }
            Ui(t, e1);
        }
        function tr(e1, t, i, r) {
            const n = Math.pow(2, r.z) * $i, o = [
                r.x * $i,
                r.y * $i
            ], s = [];
            if (!e1) return s;
            for (const r of e1)for (const e1 of r){
                const r = [
                    e1.x + o[0],
                    e1.y + o[1]
                ];
                er(r, t, i, n), s.push(r);
            }
            return s;
        }
        function ir(e1, t, i, r) {
            const n = Math.pow(2, r.z) * $i, o = [
                r.x * $i,
                r.y * $i
            ], s = [];
            if (!e1) return s;
            for (const i of e1){
                const e1 = [];
                for (const r of i){
                    const i = [
                        r.x + o[0],
                        r.y + o[1]
                    ];
                    Ui(t, i), e1.push(i);
                }
                s.push(e1);
            }
            if (t[2] - t[0] <= n / 2) {
                (a = t)[0] = a[1] = 1 / 0, a[2] = a[3] = -1 / 0;
                for (const e1 of s)for (const r of e1)er(r, t, i, n);
            }
            var a;
            return s;
        }
        class rr {
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`'within' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (_i(e1[1])) {
                    const t = e1[1];
                    if ("FeatureCollection" === t.type) for(let e1 = 0; e1 < t.features.length; ++e1){
                        const i = t.features[e1].geometry.type;
                        if ("Polygon" === i || "MultiPolygon" === i) return new rr(t, t.features[e1].geometry);
                    }
                    else if ("Feature" === t.type) {
                        const e1 = t.geometry.type;
                        if ("Polygon" === e1 || "MultiPolygon" === e1) return new rr(t, t.geometry);
                    } else if ("Polygon" === t.type || "MultiPolygon" === t.type) return new rr(t, t);
                }
                return t.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(e1) {
                if (null != e1.geometry() && null != e1.canonicalID()) {
                    if ("Point" === e1.geometryType()) return function(e1, t) {
                        const i = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = e1.canonicalID();
                        if (!n) return !1;
                        if ("Polygon" === t.type) {
                            const o = Ji(t.coordinates, r, n), s = tr(e1.geometry(), i, r, n);
                            if (!Vi(i, r)) return !1;
                            for (const e1 of s)if (!Gi(e1, o)) return !1;
                        }
                        if ("MultiPolygon" === t.type) {
                            const o = Qi(t.coordinates, r, n), s = tr(e1.geometry(), i, r, n);
                            if (!Vi(i, r)) return !1;
                            for (const e1 of s)if (!Hi(e1, o)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t) {
                        const i = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = e1.canonicalID();
                        if (!n) return !1;
                        if ("Polygon" === t.type) {
                            const o = Ji(t.coordinates, r, n), s = ir(e1.geometry(), i, r, n);
                            if (!Vi(i, r)) return !1;
                            for (const e1 of s)if (!Yi(e1, o)) return !1;
                        }
                        if ("MultiPolygon" === t.type) {
                            const o = Qi(t.coordinates, r, n), s = ir(e1.geometry(), i, r, n);
                            if (!Vi(i, r)) return !1;
                            for (const e1 of s)if (!Ki(e1, o)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
            constructor(e1, t){
                this.type = qt, this.geojson = e1, this.geometries = t;
            }
        }
        var nr = rr, or = {
            exports: {}
        };
        or.exports = function() {
            var e1 = {
                kilometers: 1,
                miles: 1e3 / 1609.344,
                nauticalmiles: 1e3 / 1852,
                meters: 1e3,
                metres: 1e3,
                yards: 1e3 / .9144,
                feet: 1e3 / .3048,
                inches: 1e3 / .0254
            }, t = 1 / 298.257223563, i = t * (2 - t), r = Math.PI / 180, n = function(t, n) {
                if (void 0 === t) throw new Error("No latitude given.");
                if (n && !e1[n]) throw new Error("Unknown unit " + n + ". Use one of: " + Object.keys(e1).join(", "));
                var o = 6378.137 * r * (n ? e1[n] : 1), s = Math.cos(t * r), a = 1 / (1 - i * (1 - s * s)), l = Math.sqrt(a);
                this.kx = o * l * s, this.ky = o * l * a * (1 - i);
            }, o = {
                units: {
                    configurable: !0
                }
            };
            function s(e1, t) {
                return e1[0] === t[0] && e1[1] === t[1];
            }
            function a(e1, t, i) {
                var r = l(t[0] - e1[0]);
                return [
                    e1[0] + r * i,
                    e1[1] + (t[1] - e1[1]) * i
                ];
            }
            function l(e1) {
                for(; e1 < -180;)e1 += 360;
                for(; e1 > 180;)e1 -= 360;
                return e1;
            }
            return n.fromTile = function(e1, t, i) {
                var o = Math.PI * (1 - 2 * (e1 + .5) / Math.pow(2, t)), s = Math.atan(.5 * (Math.exp(o) - Math.exp(-o))) / r;
                return new n(s, i);
            }, o.units.get = function() {
                return e1;
            }, n.prototype.distance = function(e1, t) {
                var i = l(e1[0] - t[0]) * this.kx, r = (e1[1] - t[1]) * this.ky;
                return Math.sqrt(i * i + r * r);
            }, n.prototype.bearing = function(e1, t) {
                var i = l(t[0] - e1[0]) * this.kx;
                return Math.atan2(i, (t[1] - e1[1]) * this.ky) / r;
            }, n.prototype.destination = function(e1, t, i) {
                var n = i * r;
                return this.offset(e1, Math.sin(n) * t, Math.cos(n) * t);
            }, n.prototype.offset = function(e1, t, i) {
                return [
                    e1[0] + t / this.kx,
                    e1[1] + i / this.ky
                ];
            }, n.prototype.lineDistance = function(e1) {
                for(var t = 0, i = 0; i < e1.length - 1; i++)t += this.distance(e1[i], e1[i + 1]);
                return t;
            }, n.prototype.area = function(e1) {
                for(var t = 0, i = 0; i < e1.length; i++)for(var r = e1[i], n = 0, o = r.length, s = o - 1; n < o; s = n++)t += l(r[n][0] - r[s][0]) * (r[n][1] + r[s][1]) * (i ? -1 : 1);
                return Math.abs(t) / 2 * this.kx * this.ky;
            }, n.prototype.along = function(e1, t) {
                var i = 0;
                if (t <= 0) return e1[0];
                for(var r = 0; r < e1.length - 1; r++){
                    var n = e1[r], o = e1[r + 1], s = this.distance(n, o);
                    if ((i += s) > t) return a(n, o, (t - (i - s)) / s);
                }
                return e1[e1.length - 1];
            }, n.prototype.pointToSegmentDistance = function(e1, t, i) {
                var r = t[0], n = t[1], o = l(i[0] - r) * this.kx, s = (i[1] - n) * this.ky, a = 0;
                return 0 === o && 0 === s || ((a = (l(e1[0] - r) * this.kx * o + (e1[1] - n) * this.ky * s) / (o * o + s * s)) > 1 ? (r = i[0], n = i[1]) : a > 0 && (r += o / this.kx * a, n += s / this.ky * a)), o = l(e1[0] - r) * this.kx, s = (e1[1] - n) * this.ky, Math.sqrt(o * o + s * s);
            }, n.prototype.pointOnLine = function(e1, t) {
                for(var i, r, n, o, s = 1 / 0, a = 0; a < e1.length - 1; a++){
                    var c = e1[a][0], h = e1[a][1], u = l(e1[a + 1][0] - c) * this.kx, d = (e1[a + 1][1] - h) * this.ky, p = 0;
                    0 === u && 0 === d || ((p = (l(t[0] - c) * this.kx * u + (t[1] - h) * this.ky * d) / (u * u + d * d)) > 1 ? (c = e1[a + 1][0], h = e1[a + 1][1]) : p > 0 && (c += u / this.kx * p, h += d / this.ky * p));
                    var f = (u = l(t[0] - c) * this.kx) * u + (d = (t[1] - h) * this.ky) * d;
                    f < s && (s = f, i = c, r = h, n = a, o = p);
                }
                return {
                    point: [
                        i,
                        r
                    ],
                    index: n,
                    t: Math.max(0, Math.min(1, o))
                };
            }, n.prototype.lineSlice = function(e1, t, i) {
                var r = this.pointOnLine(i, e1), n = this.pointOnLine(i, t);
                if (r.index > n.index || r.index === n.index && r.t > n.t) {
                    var o = r;
                    r = n, n = o;
                }
                var a = [
                    r.point
                ], l = r.index + 1, c = n.index;
                !s(i[l], a[0]) && l <= c && a.push(i[l]);
                for(var h = l + 1; h <= c; h++)a.push(i[h]);
                return s(i[c], n.point) || a.push(n.point), a;
            }, n.prototype.lineSliceAlong = function(e1, t, i) {
                for(var r = 0, n = [], o = 0; o < i.length - 1; o++){
                    var s = i[o], l = i[o + 1], c = this.distance(s, l);
                    if ((r += c) > e1 && 0 === n.length && n.push(a(s, l, (e1 - (r - c)) / c)), r >= t) return n.push(a(s, l, (t - (r - c)) / c)), n;
                    r > e1 && n.push(l);
                }
                return n;
            }, n.prototype.bufferPoint = function(e1, t) {
                var i = t / this.ky, r = t / this.kx;
                return [
                    e1[0] - r,
                    e1[1] - i,
                    e1[0] + r,
                    e1[1] + i
                ];
            }, n.prototype.bufferBBox = function(e1, t) {
                var i = t / this.ky, r = t / this.kx;
                return [
                    e1[0] - r,
                    e1[1] - i,
                    e1[2] + r,
                    e1[3] + i
                ];
            }, n.prototype.insideBBox = function(e1, t) {
                return l(e1[0] - t[0]) >= 0 && l(e1[0] - t[2]) <= 0 && e1[1] >= t[1] && e1[1] <= t[3];
            }, Object.defineProperties(n, o), n;
        }();
        var sr = d(or.exports), ar = {
            exports: {}
        };
        ar.exports = function() {
            var e1 = function(e1, i) {
                if (void 0 === e1 && (e1 = []), void 0 === i && (i = t), this.data = e1, this.length = this.data.length, this.compare = i, this.length > 0) for(var r = (this.length >> 1) - 1; r >= 0; r--)this._down(r);
            };
            function t(e1, t) {
                return e1 < t ? -1 : e1 > t ? 1 : 0;
            }
            return e1.prototype.push = function(e1) {
                this.data.push(e1), this.length++, this._up(this.length - 1);
            }, e1.prototype.pop = function() {
                if (0 !== this.length) {
                    var e1 = this.data[0], t = this.data.pop();
                    return this.length--, this.length > 0 && (this.data[0] = t, this._down(0)), e1;
                }
            }, e1.prototype.peek = function() {
                return this.data[0];
            }, e1.prototype._up = function(e1) {
                for(var t = this.data, i = this.compare, r = t[e1]; e1 > 0;){
                    var n = e1 - 1 >> 1, o = t[n];
                    if (i(r, o) >= 0) break;
                    t[e1] = o, e1 = n;
                }
                t[e1] = r;
            }, e1.prototype._down = function(e1) {
                for(var t = this.data, i = this.compare, r = this.length >> 1, n = t[e1]; e1 < r;){
                    var o = 1 + (e1 << 1), s = t[o], a = o + 1;
                    if (a < this.length && i(t[a], s) < 0 && (o = a, s = t[a]), i(s, n) >= 0) break;
                    t[e1] = s, e1 = o;
                }
                t[e1] = n;
            }, e1;
        }();
        var lr = d(ar.exports), cr = 8192;
        function hr(e1, t) {
            return t.dist - e1.dist;
        }
        const ur = 100, dr = 50;
        function pr(e1) {
            const t = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (t.length !== e1.length) return !1;
            for(let i = 0; i < t.length; i++)if (t[i] !== e1[i]) return !1;
            return !0;
        }
        function fr(e1) {
            return e1[1] - e1[0] + 1;
        }
        function mr(e1, t) {
            const i = e1[1] >= e1[0] && e1[1] < t;
            return i || console.warn("Distance Expression: Index is out of range"), i;
        }
        function _r(e1, t) {
            if (e1[0] > e1[1]) return [
                null,
                null
            ];
            const i = fr(e1);
            if (t) {
                if (2 === i) return [
                    e1,
                    null
                ];
                const t = Math.floor(i / 2);
                return [
                    [
                        e1[0],
                        e1[0] + t
                    ],
                    [
                        e1[0] + t,
                        e1[1]
                    ]
                ];
            }
            {
                if (1 === i) return [
                    e1,
                    null
                ];
                const t = Math.floor(i / 2) - 1;
                return [
                    [
                        e1[0],
                        e1[0] + t
                    ],
                    [
                        e1[0] + t + 1,
                        e1[1]
                    ]
                ];
            }
        }
        function gr(e1, t) {
            const i = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (!mr(t, e1.length)) return i;
            for(let r = t[0]; r <= t[1]; ++r)Ui(i, e1[r]);
            return i;
        }
        function yr(e1) {
            const t = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let i = 0; i < e1.length; ++i)for(let r = 0; r < e1[i].length; ++r)Ui(t, e1[i][r]);
            return t;
        }
        function xr(e1, t, i) {
            if (pr(e1) || pr(t)) return NaN;
            let r = 0, n = 0;
            return e1[2] < t[0] && (r = t[0] - e1[2]), e1[0] > t[2] && (r = e1[0] - t[2]), e1[1] > t[3] && (n = e1[1] - t[3]), e1[3] < t[1] && (n = t[1] - e1[3]), i.distance([
                0,
                0
            ], [
                r,
                n
            ]);
        }
        function vr(e1, t) {
            const i = Math.pow(2, t.z);
            var r, n;
            return [
                (n = (e1.x / cr + t.x) / i, 360 * n - 180),
                (r = (e1.y / cr + t.y) / i, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * r) * Math.PI / 180)) - 90)
            ];
        }
        function br(e1, t) {
            const i = [];
            for(let r = 0; r < e1.length; ++r)i.push(vr(e1[r], t));
            return i;
        }
        function wr(e1, t, i) {
            const r = i.pointOnLine(t, e1).point;
            return i.distance(e1, r);
        }
        function Tr(e1, t, i, r, n) {
            const o = i.slice(r[0], r[1] + 1);
            let s = 1 / 0;
            for(let i = t[0]; i <= t[1]; ++i)if (0 === (s = Math.min(s, wr(e1[i], o, n)))) return 0;
            return s;
        }
        function Er(e1, t, i, r, n) {
            const o = Math.min(n.pointToSegmentDistance(e1, i, r), n.pointToSegmentDistance(t, i, r)), s = Math.min(n.pointToSegmentDistance(i, e1, t), n.pointToSegmentDistance(r, e1, t));
            return Math.min(o, s);
        }
        function Mr(e1, t, i, r, n) {
            if (!mr(t, e1.length) || !mr(r, i.length)) return NaN;
            let o = 1 / 0;
            for(let s = t[0]; s < t[1]; ++s)for(let t = r[0]; t < r[1]; ++t){
                if (Zi(e1[s], e1[s + 1], i[t], i[t + 1])) return 0;
                o = Math.min(o, Er(e1[s], e1[s + 1], i[t], i[t + 1], n));
            }
            return o;
        }
        function Ar(e1, t, i, r, n) {
            if (!mr(t, e1.length) || !mr(r, i.length)) return NaN;
            let o = 1 / 0;
            for(let s = t[0]; s <= t[1]; ++s)for(let t = r[0]; t <= r[1]; ++t)if (0 === (o = Math.min(o, n.distance(e1[s], i[t])))) return o;
            return o;
        }
        function Sr(e1, t, i) {
            if (Gi(e1, t, !0)) return 0;
            let r = 1 / 0;
            for (const n of t){
                const t = n.length;
                if (t < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
                if (n[0] !== n[t - 1] && 0 === (r = Math.min(r, i.pointToSegmentDistance(e1, n[t - 1], n[0])))) return r;
                if (0 === (r = Math.min(r, wr(e1, n, i)))) return r;
            }
            return r;
        }
        function Ir(e1, t, i, r) {
            if (!mr(t, e1.length)) return NaN;
            for(let r = t[0]; r <= t[1]; ++r)if (Gi(e1[r], i, !0)) return 0;
            let n = 1 / 0;
            for(let o = t[0]; o < t[1]; ++o)for (const t of i)for(let i = 0, s = t.length, a = s - 1; i < s; a = i++){
                if (Zi(e1[o], e1[o + 1], t[a], t[i])) return 0;
                n = Math.min(n, Er(e1[o], e1[o + 1], t[a], t[i], r));
            }
            return n;
        }
        function Cr(e1, t) {
            for (const i of e1)for(let e1 = 0; e1 <= i.length - 1; ++e1)if (Gi(i[e1], t, !0)) return !0;
            return !1;
        }
        function zr(e1, t, i, r = 1 / 0) {
            const n = yr(e1), o = yr(t);
            if (r !== 1 / 0 && xr(n, o, i) >= r) return r;
            if (Vi(n, o)) {
                if (Cr(e1, t)) return 0;
            } else if (Cr(t, e1)) return 0;
            let s = r;
            for (const r of e1)for(let e1 = 0, n = r.length, o = n - 1; e1 < n; o = e1++)for (const n of t)for(let t = 0, a = n.length, l = a - 1; t < a; l = t++){
                if (Zi(r[o], r[e1], n[l], n[t])) return 0;
                s = Math.min(s, Er(r[o], r[e1], n[l], n[t], i));
            }
            return s;
        }
        function Pr(e1, t, i, r, n, o, s) {
            if (null === o || null === s) return;
            const a = xr(gr(r, o), gr(n, s), i);
            a < t && e1.push({
                dist: a,
                range1: o,
                range2: s
            });
        }
        function Dr(e1, t, i, r, n = 1 / 0) {
            let o = Math.min(r.distance(e1[0], i[0][0]), n);
            if (0 === o) return o;
            const s = new lr([
                {
                    dist: 0,
                    range1: [
                        0,
                        e1.length - 1
                    ],
                    range2: [
                        0,
                        0
                    ]
                }
            ], hr), a = t ? dr : ur, l = yr(i);
            for(; s.length;){
                const n = s.pop();
                if (n.dist >= o) continue;
                const c = n.range1;
                if (fr(c) <= a) {
                    if (!mr(c, e1.length)) return NaN;
                    if (t) {
                        const t = Ir(e1, c, i, r);
                        if (0 === (o = Math.min(o, t))) return o;
                    } else for(let t = c[0]; t <= c[1]; ++t){
                        const n = Sr(e1[t], i, r);
                        if (0 === (o = Math.min(o, n))) return o;
                    }
                } else {
                    const i = _r(c, t);
                    if (null !== i[0]) {
                        const t = xr(gr(e1, i[0]), l, r);
                        t < o && s.push({
                            dist: t,
                            range1: i[0],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                    if (null !== i[1]) {
                        const t = xr(gr(e1, i[1]), l, r);
                        t < o && s.push({
                            dist: t,
                            range1: i[1],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                }
            }
            return o;
        }
        function Rr(e1, t, i, r, n, o = 1 / 0) {
            let s = Math.min(o, n.distance(e1[0], i[0]));
            if (0 === s) return s;
            const a = new lr([
                {
                    dist: 0,
                    range1: [
                        0,
                        e1.length - 1
                    ],
                    range2: [
                        0,
                        i.length - 1
                    ]
                }
            ], hr), l = t ? dr : ur, c = r ? dr : ur;
            for(; a.length;){
                const o = a.pop();
                if (o.dist >= s) continue;
                const h = o.range1, u = o.range2;
                if (fr(h) <= l && fr(u) <= c) {
                    if (!mr(h, e1.length) || !mr(u, i.length)) return NaN;
                    if (t && r ? s = Math.min(s, Mr(e1, h, i, u, n)) : t || r ? t && !r ? s = Math.min(s, Tr(i, u, e1, h, n)) : !t && r && (s = Math.min(s, Tr(e1, h, i, u, n))) : s = Math.min(s, Ar(e1, h, i, u, n)), 0 === s) return s;
                } else {
                    const o = _r(h, t), l = _r(u, r);
                    Pr(a, s, n, e1, i, o[0], l[0]), Pr(a, s, n, e1, i, o[0], l[1]), Pr(a, s, n, e1, i, o[1], l[0]), Pr(a, s, n, e1, i, o[1], l[1]);
                }
            }
            return s;
        }
        function Lr(e1, t, i, r, n = 1 / 0) {
            let o = n;
            const s = gr(e1, [
                0,
                e1.length - 1
            ]);
            for (const n of i)if (!(o !== 1 / 0 && xr(s, gr(n, [
                0,
                n.length - 1
            ]), r) >= o) && (o = Math.min(o, Rr(e1, t, n, !0, r, o)), 0 === o)) return o;
            return o;
        }
        function kr(e1, t, i, r, n = 1 / 0) {
            let o = n;
            const s = gr(e1, [
                0,
                e1.length - 1
            ]);
            for (const n of i){
                if (o !== 1 / 0 && xr(s, yr(n), r) >= o) continue;
                const i = Dr(e1, t, n, r, o);
                if (isNaN(i)) return i;
                if (0 === (o = Math.min(o, i))) return o;
            }
            return o;
        }
        function Or(e1) {
            return "Point" === e1 || "MultiPoint" === e1 || "LineString" === e1 || "MultiLineString" === e1 || "Polygon" === e1 || "MultiPolygon" === e1;
        }
        class Br {
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`'distance' expression requires either one argument, but found ' ${e1.length - 1} instead.`);
                if (_i(e1[1])) {
                    const t = e1[1];
                    if ("FeatureCollection" === t.type) {
                        for(let e1 = 0; e1 < t.features.length; ++e1)if (Or(t.features[e1].geometry.type)) return new Br(t, t.features[e1].geometry);
                    } else if ("Feature" === t.type) {
                        if (Or(t.geometry.type)) return new Br(t, t.geometry);
                    } else if (Or(t.type)) return new Br(t, t);
                }
                return t.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
            }
            evaluate(e1) {
                const t = e1.geometry(), i = e1.canonicalID();
                if (null != t && null != i) {
                    if ("Point" === e1.geometryType()) return function(e1, t, i) {
                        const r = [];
                        for (const i of e1)for (const e1 of i)r.push(vr(e1, t));
                        const n = new sr(r[0][1], "meters");
                        return "Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type ? Rr(r, !1, "Point" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, "LineString" === i.type, n) : "MultiLineString" === i.type ? Lr(r, !1, i.coordinates, n) : "Polygon" === i.type || "MultiPolygon" === i.type ? kr(r, !1, "Polygon" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, n) : null;
                    }(t, i, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t, i) {
                        const r = [];
                        for (const i of e1){
                            const e1 = [];
                            for (const r of i)e1.push(vr(r, t));
                            r.push(e1);
                        }
                        const n = new sr(r[0][0][1], "meters");
                        if ("Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type) return Lr("Point" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, "LineString" === i.type, r, n);
                        if ("MultiLineString" === i.type) {
                            let e1 = 1 / 0;
                            for(let t = 0; t < i.coordinates.length; t++){
                                const o = Lr(i.coordinates[t], !0, r, n, e1);
                                if (isNaN(o)) return o;
                                if (0 === (e1 = Math.min(e1, o))) return e1;
                            }
                            return e1;
                        }
                        if ("Polygon" === i.type || "MultiPolygon" === i.type) {
                            let e1 = 1 / 0;
                            for(let t = 0; t < r.length; t++){
                                const o = kr(r[t], !0, "Polygon" === i.type ? [
                                    i.coordinates
                                ] : i.coordinates, n, e1);
                                if (isNaN(o)) return o;
                                if (0 === (e1 = Math.min(e1, o))) return e1;
                            }
                            return e1;
                        }
                        return null;
                    }(t, i, this.geometries);
                    if ("Polygon" === e1.geometryType()) return function(e1, t, i) {
                        const r = [];
                        for (const i of function(e1, t) {
                            const i = e1.length;
                            if (i <= 1) return [
                                e1
                            ];
                            const r = [];
                            let n, o;
                            for(let t = 0; t < i; t++){
                                const i = Ni(e1[t]);
                                0 !== i && (e1[t].area = Math.abs(i), void 0 === o && (o = i < 0), o === i < 0 ? (n && r.push(n), n = [
                                    e1[t]
                                ]) : n.push(e1[t]));
                            }
                            return n && r.push(n), r;
                        }(e1)){
                            const e1 = [];
                            for(let r = 0; r < i.length; ++r)e1.push(br(i[r], t));
                            r.push(e1);
                        }
                        const n = new sr(r[0][0][0][1], "meters");
                        if ("Point" === i.type || "MultiPoint" === i.type || "LineString" === i.type) return kr("Point" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, "LineString" === i.type, r, n);
                        if ("MultiLineString" === i.type) {
                            let e1 = 1 / 0;
                            for(let t = 0; t < i.coordinates.length; t++){
                                const o = kr(i.coordinates[t], !0, r, n, e1);
                                if (isNaN(o)) return o;
                                if (0 === (e1 = Math.min(e1, o))) return e1;
                            }
                            return e1;
                        }
                        return "Polygon" === i.type || "MultiPolygon" === i.type ? function(e1, t, i) {
                            let r = 1 / 0;
                            for (const n of e1)for (const e1 of t){
                                const t = zr(n, e1, i, r);
                                if (isNaN(t)) return t;
                                if (0 === (r = Math.min(r, t))) return r;
                            }
                            return r;
                        }("Polygon" === i.type ? [
                            i.coordinates
                        ] : i.coordinates, r, n) : null;
                    }(t, i, this.geometries);
                    console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
                } else console.warn("Distance Expression: requirs valid feature and canonical information.");
                return null;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "distance",
                    this.geojson
                ];
            }
            constructor(e1, t){
                this.type = jt, this.geojson = e1, this.geometries = t;
            }
        }
        var Fr = Br;
        function Nr(e1) {
            if (e1 instanceof ki) {
                if ("get" === e1.name && 1 === e1.args.length) return !1;
                if ("feature-state" === e1.name) return !1;
                if ("has" === e1.name && 1 === e1.args.length) return !1;
                if ("properties" === e1.name || "geometry-type" === e1.name || "id" === e1.name) return !1;
                if (/^filter-/.test(e1.name)) return !1;
            }
            if (e1 instanceof nr) return !1;
            if (e1 instanceof Fr) return !1;
            let t = !0;
            return e1.eachChild((e1)=>{
                t && !Nr(e1) && (t = !1);
            }), t;
        }
        function Ur(e1) {
            if (e1 instanceof ki && "feature-state" === e1.name) return !1;
            let t = !0;
            return e1.eachChild((e1)=>{
                t && !Ur(e1) && (t = !1);
            }), t;
        }
        function Vr(e1) {
            if (e1 instanceof ki && "config" === e1.name) return !1;
            let t = !0;
            return e1.eachChild((e1)=>{
                t && !Vr(e1) && (t = !1);
            }), t;
        }
        function jr(e1, t) {
            if (e1 instanceof ki && t.indexOf(e1.name) >= 0) return !1;
            let i = !0;
            return e1.eachChild((e1)=>{
                i && !jr(e1, t) && (i = !1);
            }), i;
        }
        class Gr {
            static parse(e1, t) {
                if (2 !== e1.length || "string" != typeof e1[1]) return t.error("'var' expression requires exactly one string literal argument.");
                const i = e1[1];
                return t.scope.has(i) ? new Gr(i, t.scope.get(i)) : t.error(`Unknown variable "${i}". Make sure "${i}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(e1) {
                return this.boundExpression.evaluate(e1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
            constructor(e1, t){
                this.type = t.type, this.name = e1, this.boundExpression = t;
            }
        }
        var qr = Gr;
        class Zr {
            parse(e1, t, i, r, n = {}) {
                return t || i ? this.concat(t, i, r)._parse(e1, n) : this._parse(e1, n);
            }
            _parse(e1, t) {
                function i(e1, t, i) {
                    return "assert" === i ? new Ei(t, [
                        e1
                    ]) : "coerce" === i ? new zi(t, [
                        e1
                    ]) : e1;
                }
                if (null !== e1 && "string" != typeof e1 && "boolean" != typeof e1 && "number" != typeof e1 || (e1 = [
                    "literal",
                    e1
                ]), Array.isArray(e1)) {
                    if (0 === e1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const r = "string" == typeof e1[0] ? this.registry[e1[0]] : void 0;
                    if (r) {
                        let n = r.parse(e1, this);
                        if (!n) return null;
                        if (this.expectedType) {
                            const e1 = this.expectedType, r = n.type;
                            if ("string" !== e1.kind && "number" !== e1.kind && "boolean" !== e1.kind && "object" !== e1.kind && "array" !== e1.kind || "value" !== r.kind) {
                                if ("color" !== e1.kind && "formatted" !== e1.kind && "resolvedImage" !== e1.kind || "value" !== r.kind && "string" !== r.kind) {
                                    if (this.checkSubtype(e1, r)) return null;
                                } else n = i(n, e1, t.typeAnnotation || "coerce");
                            } else n = i(n, e1, t.typeAnnotation || "assert");
                        }
                        if (!(n instanceof vi) && "resolvedImage" !== n.type.kind && Wr(n)) {
                            const e1 = new Di(this.options);
                            try {
                                n = new vi(n.type, n.evaluate(e1));
                            } catch (e1) {
                                return this.error(e1.message), null;
                            }
                        }
                        return n;
                    }
                    return zi.parse([
                        "to-array",
                        e1
                    ], this);
                }
                return this.error(void 0 === e1 ? "'undefined' value invalid. Use null instead." : "object" == typeof e1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof e1} instead.`);
            }
            concat(e1, t, i) {
                const r = "number" == typeof e1 ? this.path.concat(e1) : this.path, n = i ? this.scope.concat(i) : this.scope;
                return new Zr(this.registry, r, t || null, n, this.errors, this.options);
            }
            error(e1, ...t) {
                const i = `${this.key}${t.map((e1)=>`[${e1}]`).join("")}`;
                this.errors.push(new Ft(i, e1));
            }
            checkSubtype(e1, t) {
                const i = ei(e1, t);
                return i && this.error(i), i;
            }
            constructor(e1, t = [], i, r = new Ut, n = [], o){
                this.registry = e1, this.path = t, this.key = t.map((e1)=>`[${e1}]`).join(""), this.scope = r, this.errors = n, this.expectedType = i, this.options = o;
            }
        }
        var $r = Zr;
        function Wr(e1) {
            if (e1 instanceof qr) return Wr(e1.boundExpression);
            if (e1 instanceof ki && "error" === e1.name) return !1;
            if (e1 instanceof ki && "config" === e1.name) return !1;
            if (e1 instanceof Oi) return !1;
            if (e1 instanceof nr) return !1;
            if (e1 instanceof Fr) return !1;
            const t = e1 instanceof zi || e1 instanceof Ei;
            let i = !0;
            return e1.eachChild((e1)=>{
                i = t ? i && Wr(e1) : i && e1 instanceof vi;
            }), !!i && Nr(e1) && jr(e1, [
                "zoom",
                "heatmap-density",
                "line-progress",
                "raster-value",
                "sky-radial-progress",
                "accumulated",
                "is-supported-script",
                "pitch",
                "distance-from-center",
                "measure-light"
            ]);
        }
        function Hr(e1, t) {
            const i = e1.length - 1;
            let r, n, o = 0, s = i, a = 0;
            for(; o <= s;)if (a = Math.floor((o + s) / 2), r = e1[a], n = e1[a + 1], r <= t) {
                if (a === i || t < n) return a;
                o = a + 1;
            } else {
                if (!(r > t)) throw new bi("Input is not a number.");
                s = a - 1;
            }
            return 0;
        }
        class Xr {
            static parse(e1, t) {
                if (e1.length - 1 < 4) return t.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if ((e1.length - 1) % 2 != 0) return t.error("Expected an even number of arguments.");
                const i = t.parse(e1[1], 1, jt);
                if (!i) return null;
                const r = [];
                let n = null;
                t.expectedType && "value" !== t.expectedType.kind && (n = t.expectedType);
                for(let i = 1; i < e1.length; i += 2){
                    const o = 1 === i ? -1 / 0 : e1[i], s = e1[i + 1], a = i, l = i + 1;
                    if ("number" != typeof o) return t.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a);
                    if (r.length && r[r.length - 1][0] >= o) return t.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', a);
                    const c = t.parse(s, l, n);
                    if (!c) return null;
                    n = n || c.type, r.push([
                        o,
                        c
                    ]);
                }
                return new Xr(n, i, r);
            }
            evaluate(e1) {
                const t = this.labels, i = this.outputs;
                if (1 === t.length) return i[0].evaluate(e1);
                const r = this.input.evaluate(e1);
                if (r <= t[0]) return i[0].evaluate(e1);
                const n = t.length;
                return r >= t[n - 1] ? i[n - 1].evaluate(e1) : i[Hr(t, r)].evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input);
                for (const t of this.outputs)e1(t);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = [
                    "step",
                    this.input.serialize()
                ];
                for(let t = 0; t < this.labels.length; t++)t > 0 && e1.push(this.labels[t]), e1.push(this.outputs[t].serialize());
                return e1;
            }
            constructor(e1, t, i){
                this.type = e1, this.input = t, this.labels = [], this.outputs = [];
                for (const [e1, t] of i)this.labels.push(e1), this.outputs.push(t);
            }
        }
        var Yr = Xr;
        function Kr(e1, t, i) {
            return e1 * (1 - i) + t * i;
        }
        function Jr(e1, t, i) {
            return e1.map((e1, r)=>Kr(e1, t[r], i));
        }
        var Qr = Object.freeze({
            __proto__: null,
            array: Jr,
            color: function(e1, t, i) {
                return new hi(Kr(e1.r, t.r, i), Kr(e1.g, t.g, i), Kr(e1.b, t.b, i), Kr(e1.a, t.a, i));
            },
            number: Kr
        });
        const en = .95047, tn = 1.08883, rn = 4 / 29, nn = 6 / 29, on = 3 * nn * nn, sn = nn * nn * nn, an = Math.PI / 180, ln = 180 / Math.PI;
        function cn(e1) {
            return e1 > sn ? Math.pow(e1, 1 / 3) : e1 / on + rn;
        }
        function hn(e1) {
            return e1 > nn ? e1 * e1 * e1 : on * (e1 - rn);
        }
        function un(e1) {
            return 255 * (e1 <= .0031308 ? 12.92 * e1 : 1.055 * Math.pow(e1, 1 / 2.4) - .055);
        }
        function dn(e1) {
            return (e1 /= 255) <= .04045 ? e1 / 12.92 : Math.pow((e1 + .055) / 1.055, 2.4);
        }
        function pn(e1) {
            const t = dn(e1.r), i = dn(e1.g), r = dn(e1.b), n = cn((.4124564 * t + .3575761 * i + .1804375 * r) / en), o = cn((.2126729 * t + .7151522 * i + .072175 * r) / 1);
            return {
                l: 116 * o - 16,
                a: 500 * (n - o),
                b: 200 * (o - cn((.0193339 * t + .119192 * i + .9503041 * r) / tn)),
                alpha: e1.a
            };
        }
        function fn(e1) {
            let t = (e1.l + 16) / 116, i = isNaN(e1.a) ? t : t + e1.a / 500, r = isNaN(e1.b) ? t : t - e1.b / 200;
            return t = 1 * hn(t), i = en * hn(i), r = tn * hn(r), new hi(un(3.2404542 * i - 1.5371385 * t - .4985314 * r), un(-0.969266 * i + 1.8760108 * t + .041556 * r), un(.0556434 * i - .2040259 * t + 1.0572252 * r), e1.alpha);
        }
        function mn(e1, t, i) {
            const r = t - e1;
            return e1 + i * (r > 180 || r < -180 ? r - 360 * Math.round(r / 360) : r);
        }
        const _n = {
            forward: pn,
            reverse: fn,
            interpolate: function(e1, t, i) {
                return {
                    l: Kr(e1.l, t.l, i),
                    a: Kr(e1.a, t.a, i),
                    b: Kr(e1.b, t.b, i),
                    alpha: Kr(e1.alpha, t.alpha, i)
                };
            }
        }, gn = {
            forward: function(e1) {
                const { l: t, a: i, b: r } = pn(e1), n = Math.atan2(r, i) * ln;
                return {
                    h: n < 0 ? n + 360 : n,
                    c: Math.sqrt(i * i + r * r),
                    l: t,
                    alpha: e1.a
                };
            },
            reverse: function(e1) {
                const t = e1.h * an, i = e1.c;
                return fn({
                    l: e1.l,
                    a: Math.cos(t) * i,
                    b: Math.sin(t) * i,
                    alpha: e1.alpha
                });
            },
            interpolate: function(e1, t, i) {
                return {
                    h: mn(e1.h, t.h, i),
                    c: Kr(e1.c, t.c, i),
                    l: Kr(e1.l, t.l, i),
                    alpha: Kr(e1.alpha, t.alpha, i)
                };
            }
        };
        var yn = Object.freeze({
            __proto__: null,
            hcl: gn,
            lab: _n
        });
        class xn {
            static interpolationFactor(e1, t, i, r) {
                let n = 0;
                if ("exponential" === e1.name) n = vn(t, e1.base, i, r);
                else if ("linear" === e1.name) n = vn(t, 1, i, r);
                else if ("cubic-bezier" === e1.name) {
                    const o = e1.controlPoints;
                    n = new m(o[0], o[1], o[2], o[3]).solve(vn(t, 1, i, r));
                }
                return n;
            }
            static parse(e1, t) {
                let [i, r, n, ...o] = e1;
                if (!Array.isArray(r) || 0 === r.length) return t.error("Expected an interpolation type expression.", 1);
                if ("linear" === r[0]) r = {
                    name: "linear"
                };
                else if ("exponential" === r[0]) {
                    const e1 = r[1];
                    if ("number" != typeof e1) return t.error("Exponential interpolation requires a numeric base.", 1, 1);
                    r = {
                        name: "exponential",
                        base: e1
                    };
                } else {
                    if ("cubic-bezier" !== r[0]) return t.error(`Unknown interpolation type ${String(r[0])}`, 1, 0);
                    {
                        const e1 = r.slice(1);
                        if (4 !== e1.length || e1.some((e1)=>"number" != typeof e1 || e1 < 0 || e1 > 1)) return t.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        r = {
                            name: "cubic-bezier",
                            controlPoints: e1
                        };
                    }
                }
                if (e1.length - 1 < 4) return t.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if ((e1.length - 1) % 2 != 0) return t.error("Expected an even number of arguments.");
                if (n = t.parse(n, 2, jt), !n) return null;
                const s = [];
                let a = null;
                "interpolate-hcl" === i || "interpolate-lab" === i ? a = Zt : t.expectedType && "value" !== t.expectedType.kind && (a = t.expectedType);
                for(let e1 = 0; e1 < o.length; e1 += 2){
                    const i = o[e1], r = o[e1 + 1], n = e1 + 3, l = e1 + 4;
                    if ("number" != typeof i) return t.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', n);
                    if (s.length && s[s.length - 1][0] >= i) return t.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', n);
                    const c = t.parse(r, l, a);
                    if (!c) return null;
                    a = a || c.type, s.push([
                        i,
                        c
                    ]);
                }
                return "number" === a.kind || "color" === a.kind || "array" === a.kind && "number" === a.itemType.kind && "number" == typeof a.N ? new xn(a, i, r, n, s) : t.error(`Type ${Jt(a)} is not interpolatable.`);
            }
            evaluate(e1) {
                const t = this.labels, i = this.outputs;
                if (1 === t.length) return i[0].evaluate(e1);
                const r = this.input.evaluate(e1);
                if (r <= t[0]) return i[0].evaluate(e1);
                const n = t.length;
                if (r >= t[n - 1]) return i[n - 1].evaluate(e1);
                const o = Hr(t, r), s = xn.interpolationFactor(this.interpolation, r, t[o], t[o + 1]), a = i[o].evaluate(e1), l = i[o + 1].evaluate(e1);
                return "interpolate" === this.operator ? Qr[this.type.kind.toLowerCase()](a, l, s) : "interpolate-hcl" === this.operator ? gn.reverse(gn.interpolate(gn.forward(a), gn.forward(l), s)) : _n.reverse(_n.interpolate(_n.forward(a), _n.forward(l), s));
            }
            eachChild(e1) {
                e1(this.input);
                for (const t of this.outputs)e1(t);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
            serialize() {
                let e1;
                e1 = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier"
                ].concat(this.interpolation.controlPoints);
                const t = [
                    this.operator,
                    e1,
                    this.input.serialize()
                ];
                for(let e1 = 0; e1 < this.labels.length; e1++)t.push(this.labels[e1], this.outputs[e1].serialize());
                return t;
            }
            constructor(e1, t, i, r, n){
                this.type = e1, this.operator = t, this.interpolation = i, this.input = r, this.labels = [], this.outputs = [];
                for (const [e1, t] of n)this.labels.push(e1), this.outputs.push(t);
            }
        }
        function vn(e1, t, i, r) {
            const n = r - i, o = e1 - i;
            return 0 === n ? 0 : 1 === t ? o / n : (Math.pow(t, o) - 1) / (Math.pow(t, n) - 1);
        }
        var bn = xn;
        class wn {
            static parse(e1, t) {
                if (e1.length < 2) return t.error("Expectected at least one argument.");
                let i = null;
                const r = t.expectedType;
                r && "value" !== r.kind && (i = r);
                const n = [];
                for (const r of e1.slice(1)){
                    const e1 = t.parse(r, 1 + n.length, i, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!e1) return null;
                    i = i || e1.type, n.push(e1);
                }
                const o = r && n.some((e1)=>ei(r, e1.type));
                return new wn(o ? Wt : i, n);
            }
            evaluate(e1) {
                let t, i = null, r = 0;
                for (const n of this.args){
                    if (r++, i = n.evaluate(e1), i && i instanceof fi && !i.available && (t || (t = i), i = null, r === this.args.length)) return t;
                    if (null !== i) break;
                }
                return i;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = [
                    "coalesce"
                ];
                return this.eachChild((t)=>{
                    e1.push(t.serialize());
                }), e1;
            }
            constructor(e1, t){
                this.type = e1, this.args = t;
            }
        }
        var Tn = wn;
        class En {
            evaluate(e1) {
                return this.result.evaluate(e1);
            }
            eachChild(e1) {
                for (const t of this.bindings)e1(t[1]);
                e1(this.result);
            }
            static parse(e1, t) {
                if (e1.length < 4) return t.error(`Expected at least 3 arguments, but found ${e1.length - 1} instead.`);
                const i = [];
                for(let r = 1; r < e1.length - 1; r += 2){
                    const n = e1[r];
                    if ("string" != typeof n) return t.error(`Expected string, but found ${typeof n} instead.`, r);
                    if (/[^a-zA-Z0-9_]/.test(n)) return t.error("Variable names must contain only alphanumeric characters or '_'.", r);
                    const o = t.parse(e1[r + 1], r + 1);
                    if (!o) return null;
                    i.push([
                        n,
                        o
                    ]);
                }
                const r = t.parse(e1[e1.length - 1], e1.length - 1, t.expectedType, i);
                return r ? new En(i, r) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const e1 = [
                    "let"
                ];
                for (const [t, i] of this.bindings)e1.push(t, i.serialize());
                return e1.push(this.result.serialize()), e1;
            }
            constructor(e1, t){
                this.type = t.type, this.bindings = [].concat(e1), this.result = t;
            }
        }
        var Mn = En;
        class An {
            static parse(e1, t) {
                if (3 !== e1.length) return t.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const i = t.parse(e1[1], 1, jt), r = t.parse(e1[2], 2, Kt(t.expectedType || Wt));
                return i && r ? new An(r.type.itemType, i, r) : null;
            }
            evaluate(e1) {
                const t = this.index.evaluate(e1), i = this.input.evaluate(e1);
                if (t < 0) throw new bi(`Array index out of bounds: ${t} < 0.`);
                if (t >= i.length) throw new bi(`Array index out of bounds: ${t} > ${i.length - 1}.`);
                if (t !== Math.floor(t)) throw new bi(`Array index must be an integer, but found ${t} instead.`);
                return i[t];
            }
            eachChild(e1) {
                e1(this.index), e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
            constructor(e1, t, i){
                this.type = e1, this.index = t, this.input = i;
            }
        }
        var Sn = An;
        class In {
            static parse(e1, t) {
                if (3 !== e1.length) return t.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const i = t.parse(e1[1], 1, Wt), r = t.parse(e1[2], 2, Wt);
                return i && r ? ti(i.type, [
                    qt,
                    Gt,
                    jt,
                    Vt,
                    Wt
                ]) ? new In(i, r) : t.error(`Expected first argument to be of type boolean, string, number or null, but found ${Jt(i.type)} instead`) : null;
            }
            evaluate(e1) {
                const t = this.needle.evaluate(e1), i = this.haystack.evaluate(e1);
                if (null == i) return !1;
                if (!ii(t, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new bi(`Expected first argument to be of type boolean, string, number or null, but found ${Jt(gi(t))} instead.`);
                if (!ii(i, [
                    "string",
                    "array"
                ])) throw new bi(`Expected second argument to be of type array or string, but found ${Jt(gi(i))} instead.`);
                return i.indexOf(t) >= 0;
            }
            eachChild(e1) {
                e1(this.needle), e1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "in",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
            constructor(e1, t){
                this.type = qt, this.needle = e1, this.haystack = t;
            }
        }
        var Cn = In;
        class zn {
            static parse(e1, t) {
                if (e1.length <= 2 || e1.length >= 5) return t.error(`Expected 3 or 4 arguments, but found ${e1.length - 1} instead.`);
                const i = t.parse(e1[1], 1, Wt), r = t.parse(e1[2], 2, Wt);
                if (!i || !r) return null;
                if (!ti(i.type, [
                    qt,
                    Gt,
                    jt,
                    Vt,
                    Wt
                ])) return t.error(`Expected first argument to be of type boolean, string, number or null, but found ${Jt(i.type)} instead`);
                if (4 === e1.length) {
                    const n = t.parse(e1[3], 3, jt);
                    return n ? new zn(i, r, n) : null;
                }
                return new zn(i, r);
            }
            evaluate(e1) {
                const t = this.needle.evaluate(e1), i = this.haystack.evaluate(e1);
                if (!ii(t, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new bi(`Expected first argument to be of type boolean, string, number or null, but found ${Jt(gi(t))} instead.`);
                if (!ii(i, [
                    "string",
                    "array"
                ])) throw new bi(`Expected second argument to be of type array or string, but found ${Jt(gi(i))} instead.`);
                if (this.fromIndex) {
                    const r = this.fromIndex.evaluate(e1);
                    return i.indexOf(t, r);
                }
                return i.indexOf(t);
            }
            eachChild(e1) {
                e1(this.needle), e1(this.haystack), this.fromIndex && e1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.fromIndex && void 0 !== this.fromIndex) {
                    const e1 = this.fromIndex.serialize();
                    return [
                        "index-of",
                        this.needle.serialize(),
                        this.haystack.serialize(),
                        e1
                    ];
                }
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
            constructor(e1, t, i){
                this.type = jt, this.needle = e1, this.haystack = t, this.fromIndex = i;
            }
        }
        var Pn = zn;
        class Dn {
            static parse(e1, t) {
                if (e1.length < 5) return t.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if (e1.length % 2 != 1) return t.error("Expected an even number of arguments.");
                let i, r;
                t.expectedType && "value" !== t.expectedType.kind && (r = t.expectedType);
                const n = {}, o = [];
                for(let s = 2; s < e1.length - 1; s += 2){
                    let a = e1[s];
                    const l = e1[s + 1];
                    Array.isArray(a) || (a = [
                        a
                    ]);
                    const c = t.concat(s);
                    if (0 === a.length) return c.error("Expected at least one branch label.");
                    for (const e1 of a){
                        if ("number" != typeof e1 && "string" != typeof e1) return c.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof e1 && Math.abs(e1) > Number.MAX_SAFE_INTEGER) return c.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof e1 && Math.floor(e1) !== e1) return c.error("Numeric branch labels must be integer values.");
                        if (i) {
                            if (c.checkSubtype(i, gi(e1))) return null;
                        } else i = gi(e1);
                        if (void 0 !== n[String(e1)]) return c.error("Branch labels must be unique.");
                        n[String(e1)] = o.length;
                    }
                    const h = t.parse(l, s, r);
                    if (!h) return null;
                    r = r || h.type, o.push(h);
                }
                const s = t.parse(e1[1], 1, Wt);
                if (!s) return null;
                const a = t.parse(e1[e1.length - 1], e1.length - 1, r);
                return a ? "value" !== s.type.kind && t.concat(1).checkSubtype(i, s.type) ? null : new Dn(i, r, s, n, o, a) : null;
            }
            evaluate(e1) {
                const t = this.input.evaluate(e1);
                return (gi(t) === this.inputType && this.outputs[this.cases[t]] || this.otherwise).evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input), this.outputs.forEach(e1), e1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e1 = [
                    "match",
                    this.input.serialize()
                ], t = Object.keys(this.cases).sort(), i = [], r = {};
                for (const e1 of t){
                    const t = r[this.cases[e1]];
                    void 0 === t ? (r[this.cases[e1]] = i.length, i.push([
                        this.cases[e1],
                        [
                            e1
                        ]
                    ])) : i[t][1].push(e1);
                }
                const n = (e1)=>"number" === this.inputType.kind ? Number(e1) : e1;
                for (const [t, r] of i)e1.push(1 === r.length ? n(r[0]) : r.map(n)), e1.push(this.outputs[t].serialize());
                return e1.push(this.otherwise.serialize()), e1;
            }
            constructor(e1, t, i, r, n, o){
                this.inputType = e1, this.type = t, this.input = i, this.cases = r, this.outputs = n, this.otherwise = o;
            }
        }
        var Rn = Dn;
        class Ln {
            static parse(e1, t) {
                if (e1.length < 4) return t.error(`Expected at least 3 arguments, but found only ${e1.length - 1}.`);
                if (e1.length % 2 != 0) return t.error("Expected an odd number of arguments.");
                let i;
                t.expectedType && "value" !== t.expectedType.kind && (i = t.expectedType);
                const r = [];
                for(let n = 1; n < e1.length - 1; n += 2){
                    const o = t.parse(e1[n], n, qt);
                    if (!o) return null;
                    const s = t.parse(e1[n + 1], n + 1, i);
                    if (!s) return null;
                    r.push([
                        o,
                        s
                    ]), i = i || s.type;
                }
                const n = t.parse(e1[e1.length - 1], e1.length - 1, i);
                return n ? new Ln(i, r, n) : null;
            }
            evaluate(e1) {
                for (const [t, i] of this.branches)if (t.evaluate(e1)) return i.evaluate(e1);
                return this.otherwise.evaluate(e1);
            }
            eachChild(e1) {
                for (const [t, i] of this.branches)e1(t), e1(i);
                e1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([e1, t])=>t.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e1 = [
                    "case"
                ];
                return this.eachChild((t)=>{
                    e1.push(t.serialize());
                }), e1;
            }
            constructor(e1, t, i){
                this.type = e1, this.branches = t, this.otherwise = i;
            }
        }
        var kn = Ln;
        class On {
            static parse(e1, t) {
                if (e1.length <= 2 || e1.length >= 5) return t.error(`Expected 3 or 4 arguments, but found ${e1.length - 1} instead.`);
                const i = t.parse(e1[1], 1, Wt), r = t.parse(e1[2], 2, jt);
                if (!i || !r) return null;
                if (!ti(i.type, [
                    Kt(Wt),
                    Gt,
                    Wt
                ])) return t.error(`Expected first argument to be of type array or string, but found ${Jt(i.type)} instead`);
                if (4 === e1.length) {
                    const n = t.parse(e1[3], 3, jt);
                    return n ? new On(i.type, i, r, n) : null;
                }
                return new On(i.type, i, r);
            }
            evaluate(e1) {
                const t = this.input.evaluate(e1), i = this.beginIndex.evaluate(e1);
                if (!ii(t, [
                    "string",
                    "array"
                ])) throw new bi(`Expected first argument to be of type array or string, but found ${Jt(gi(t))} instead.`);
                if (this.endIndex) {
                    const r = this.endIndex.evaluate(e1);
                    return t.slice(i, r);
                }
                return t.slice(i);
            }
            eachChild(e1) {
                e1(this.input), e1(this.beginIndex), this.endIndex && e1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const e1 = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        e1
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
            constructor(e1, t, i, r){
                this.type = e1, this.input = t, this.beginIndex = i, this.endIndex = r;
            }
        }
        var Bn = On;
        function Fn(e1, t) {
            return "==" === e1 || "!=" === e1 ? "boolean" === t.kind || "string" === t.kind || "number" === t.kind || "null" === t.kind || "value" === t.kind : "string" === t.kind || "number" === t.kind || "value" === t.kind;
        }
        function Nn(e1, t, i, r) {
            return 0 === r.compare(t, i);
        }
        function Un(e1, t, i) {
            const r = "==" !== e1 && "!=" !== e1;
            return class n {
                static parse(e1, t) {
                    if (3 !== e1.length && 4 !== e1.length) return t.error("Expected two or three arguments.");
                    const i = e1[0];
                    let o = t.parse(e1[1], 1, Wt);
                    if (!o) return null;
                    if (!Fn(i, o.type)) return t.concat(1).error(`"${i}" comparisons are not supported for type '${Jt(o.type)}'.`);
                    let s = t.parse(e1[2], 2, Wt);
                    if (!s) return null;
                    if (!Fn(i, s.type)) return t.concat(2).error(`"${i}" comparisons are not supported for type '${Jt(s.type)}'.`);
                    if (o.type.kind !== s.type.kind && "value" !== o.type.kind && "value" !== s.type.kind) return t.error(`Cannot compare types '${Jt(o.type)}' and '${Jt(s.type)}'.`);
                    r && ("value" === o.type.kind && "value" !== s.type.kind ? o = new Ei(s.type, [
                        o
                    ]) : "value" !== o.type.kind && "value" === s.type.kind && (s = new Ei(o.type, [
                        s
                    ])));
                    let a = null;
                    if (4 === e1.length) {
                        if ("string" !== o.type.kind && "string" !== s.type.kind && "value" !== o.type.kind && "value" !== s.type.kind) return t.error("Cannot use collator to compare non-string types.");
                        if (a = t.parse(e1[3], 3, Ht), !a) return null;
                    }
                    return new n(o, s, a);
                }
                evaluate(n) {
                    const o = this.lhs.evaluate(n), s = this.rhs.evaluate(n);
                    if (r && this.hasUntypedArgument) {
                        const t = gi(o), i = gi(s);
                        if (t.kind !== i.kind || "string" !== t.kind && "number" !== t.kind) throw new bi(`Expected arguments for "${e1}" to be (string, string) or (number, number), but found (${t.kind}, ${i.kind}) instead.`);
                    }
                    if (this.collator && !r && this.hasUntypedArgument) {
                        const e1 = gi(o), i = gi(s);
                        if ("string" !== e1.kind || "string" !== i.kind) return t(n, o, s);
                    }
                    return this.collator ? i(n, o, s, this.collator.evaluate(n)) : t(n, o, s);
                }
                eachChild(e1) {
                    e1(this.lhs), e1(this.rhs), this.collator && e1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const t = [
                        e1
                    ];
                    return this.eachChild((e1)=>{
                        t.push(e1.serialize());
                    }), t;
                }
                constructor(e1, t, i){
                    this.type = qt, this.lhs = e1, this.rhs = t, this.collator = i, this.hasUntypedArgument = "value" === e1.type.kind || "value" === t.type.kind;
                }
            };
        }
        const Vn = Un("==", function(e1, t, i) {
            return t === i;
        }, Nn), jn = Un("!=", function(e1, t, i) {
            return t !== i;
        }, function(e1, t, i, r) {
            return !Nn(0, t, i, r);
        }), Gn = Un("<", function(e1, t, i) {
            return t < i;
        }, function(e1, t, i, r) {
            return r.compare(t, i) < 0;
        }), qn = Un(">", function(e1, t, i) {
            return t > i;
        }, function(e1, t, i, r) {
            return r.compare(t, i) > 0;
        }), Zn = Un("<=", function(e1, t, i) {
            return t <= i;
        }, function(e1, t, i, r) {
            return r.compare(t, i) <= 0;
        }), $n = Un(">=", function(e1, t, i) {
            return t >= i;
        }, function(e1, t, i, r) {
            return r.compare(t, i) >= 0;
        });
        class Wn {
            static parse(e1, t) {
                if (3 !== e1.length) return t.error("Expected two arguments.");
                const i = t.parse(e1[1], 1, jt);
                if (!i) return null;
                const r = e1[2];
                if ("object" != typeof r || Array.isArray(r)) return t.error("NumberFormat options argument must be an object.");
                let n = null;
                if (r.locale && (n = t.parse(r.locale, 1, Gt), !n)) return null;
                let o = null;
                if (r.currency && (o = t.parse(r.currency, 1, Gt), !o)) return null;
                let s = null;
                if (r.unit && (s = t.parse(r.unit, 1, Gt), !s)) return null;
                let a = null;
                if (r["min-fraction-digits"] && (a = t.parse(r["min-fraction-digits"], 1, jt), !a)) return null;
                let l = null;
                return r["max-fraction-digits"] && (l = t.parse(r["max-fraction-digits"], 1, jt), !l) ? null : new Wn(i, n, o, s, a, l);
            }
            evaluate(e1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e1) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(e1) : void 0,
                    unit: this.unit ? this.unit.evaluate(e1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e1) : void 0
                }).format(this.number.evaluate(e1));
            }
            eachChild(e1) {
                e1(this.number), this.locale && e1(this.locale), this.currency && e1(this.currency), this.unit && e1(this.unit), this.minFractionDigits && e1(this.minFractionDigits), this.maxFractionDigits && e1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = {};
                return this.locale && (e1.locale = this.locale.serialize()), this.currency && (e1.currency = this.currency.serialize()), this.unit && (e1.unit = this.unit.serialize()), this.minFractionDigits && (e1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (e1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    e1
                ];
            }
            constructor(e1, t, i, r, n, o){
                this.type = Gt, this.number = e1, this.locale = t, this.currency = i, this.unit = r, this.minFractionDigits = n, this.maxFractionDigits = o;
            }
        }
        class Hn {
            static parse(e1, t) {
                if (2 !== e1.length) return t.error(`Expected 1 argument, but found ${e1.length - 1} instead.`);
                const i = t.parse(e1[1], 1);
                return i ? "array" !== i.type.kind && "string" !== i.type.kind && "value" !== i.type.kind ? t.error(`Expected argument of type string or array, but found ${Jt(i.type)} instead.`) : new Hn(i) : null;
            }
            evaluate(e1) {
                const t = this.input.evaluate(e1);
                if ("string" == typeof t) return t.length;
                if (Array.isArray(t)) return t.length;
                throw new bi(`Expected value to be of type string or array, but found ${Jt(gi(t))} instead.`);
            }
            eachChild(e1) {
                e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "length"
                ];
                return this.eachChild((t)=>{
                    e1.push(t.serialize());
                }), e1;
            }
            constructor(e1){
                this.type = jt, this.input = e1;
            }
        }
        function Xn(e1) {
            return function() {
                e1 = 1831565813 + (e1 |= 0) | 0;
                let t = Math.imul(e1 ^ e1 >>> 15, 1 | e1);
                return t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t, ((t ^ t >>> 14) >>> 0) / 4294967296;
            };
        }
        const Yn = {
            "==": Vn,
            "!=": jn,
            ">": qn,
            "<": Gn,
            ">=": $n,
            "<=": Zn,
            array: Ei,
            at: Sn,
            boolean: Ei,
            case: kn,
            coalesce: Tn,
            collator: Oi,
            format: Mi,
            image: Ai,
            in: Cn,
            "index-of": Pn,
            interpolate: bn,
            "interpolate-hcl": bn,
            "interpolate-lab": bn,
            length: Hn,
            let: Mn,
            literal: vi,
            match: Rn,
            number: Ei,
            "number-format": Wn,
            object: Ei,
            slice: Bn,
            step: Yr,
            string: Ei,
            "to-boolean": zi,
            "to-color": zi,
            "to-number": zi,
            "to-string": zi,
            var: qr,
            within: nr,
            distance: Fr
        };
        function Kn(e1, [t, i, r, n]) {
            t = t.evaluate(e1), i = i.evaluate(e1), r = r.evaluate(e1);
            const o = n ? n.evaluate(e1) : 1, s = mi(t, i, r, o);
            if (s) throw new bi(s);
            return new hi(t / 255 * o, i / 255 * o, r / 255 * o, o);
        }
        function Jn(e1, [t, i, r, n]) {
            t = t.evaluate(e1), i = i.evaluate(e1), r = r.evaluate(e1);
            const o = n ? n.evaluate(e1) : 1, s = function(e1, t, i, r) {
                return "number" == typeof e1 && e1 >= 0 && e1 <= 360 ? "number" == typeof t && t >= 0 && t <= 100 && "number" == typeof i && i >= 0 && i <= 100 ? void 0 === r || "number" == typeof r && r >= 0 && r <= 1 ? null : `Invalid hsla value [${[
                    e1,
                    t,
                    i,
                    r
                ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof r ? [
                    e1,
                    t,
                    i,
                    r
                ] : [
                    e1,
                    t,
                    i
                ]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof r ? [
                    e1,
                    t,
                    i,
                    r
                ] : [
                    e1,
                    t,
                    i
                ]).join(", ")}]: 'h' must be between 0 and 360.`;
            }(t, i, r, o);
            if (s) throw new bi(s);
            const a = `hsla(${t}, ${i}%, ${r}%, ${o})`, l = hi.parse(a);
            if (!l) throw new bi(`Failed to parse HSLA color: ${a}`);
            return l;
        }
        function Qn(e1, t) {
            return e1 in t;
        }
        function eo(e1, t) {
            const i = t[e1];
            return void 0 === i ? null : i;
        }
        function to(e1, t) {
            switch(e1){
                case "string":
                    return String(t);
                case "number":
                    return +t;
                case "boolean":
                    return !!t;
                case "color":
                    return hi.parse(t);
            }
            return t;
        }
        function io(e1, t, i, r) {
            return void 0 !== r && (e1 = r * Math.round(e1 / r)), void 0 !== t && e1 < t && (e1 = t), void 0 !== i && e1 > i && (e1 = i), e1;
        }
        function ro(e1, t, i) {
            i.length && (t += `${i}`);
            const r = e1.getConfig(t);
            if (!r) return null;
            const { type: n, value: o, values: s, minValue: a, maxValue: l, stepValue: c } = r, h = r.default.evaluate(e1);
            let u = o ? o.evaluate(e1) : h;
            return n && (u = to(n, u)), void 0 !== o && void 0 !== u && s && !s.includes(u) && (u = h, n && (u = to(n, u))), void 0 === u || void 0 === a && void 0 === l && void 0 === c || ("number" == typeof u ? u = io(u, a, l, c) : Array.isArray(u) && (u = u.map((e1)=>"number" == typeof e1 ? io(e1, a, l, c) : e1))), u;
        }
        function no(e1) {
            return {
                type: e1
            };
        }
        ki.register(Yn, {
            error: [
                {
                    kind: "error"
                },
                [
                    Gt
                ],
                (e1, [t])=>{
                    throw new bi(t.evaluate(e1));
                }
            ],
            typeof: [
                Gt,
                [
                    Wt
                ],
                (e1, [t])=>Jt(gi(t.evaluate(e1)))
            ],
            "to-rgba": [
                Kt(jt, 4),
                [
                    Zt
                ],
                (e1, [t])=>t.evaluate(e1).toArray()
            ],
            rgb: [
                Zt,
                [
                    jt,
                    jt,
                    jt
                ],
                Kn
            ],
            rgba: [
                Zt,
                [
                    jt,
                    jt,
                    jt,
                    jt
                ],
                Kn
            ],
            hsl: [
                Zt,
                [
                    jt,
                    jt,
                    jt
                ],
                Jn
            ],
            hsla: [
                Zt,
                [
                    jt,
                    jt,
                    jt,
                    jt
                ],
                Jn
            ],
            has: {
                type: qt,
                overloads: [
                    [
                        [
                            Gt
                        ],
                        (e1, [t])=>Qn(t.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            Gt,
                            $t
                        ],
                        (e1, [t, i])=>Qn(t.evaluate(e1), i.evaluate(e1))
                    ]
                ]
            },
            get: {
                type: Wt,
                overloads: [
                    [
                        [
                            Gt
                        ],
                        (e1, [t])=>eo(t.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            Gt,
                            $t
                        ],
                        (e1, [t, i])=>eo(t.evaluate(e1), i.evaluate(e1))
                    ]
                ]
            },
            config: {
                type: Wt,
                overloads: [
                    [
                        [
                            Gt
                        ],
                        (e1, [t])=>ro(e1, t.evaluate(e1), "")
                    ],
                    [
                        [
                            Gt,
                            Gt
                        ],
                        (e1, [t, i])=>ro(e1, t.evaluate(e1), i.evaluate(e1))
                    ]
                ]
            },
            "feature-state": [
                Wt,
                [
                    Gt
                ],
                (e1, [t])=>eo(t.evaluate(e1), e1.featureState || {})
            ],
            properties: [
                $t,
                [],
                (e1)=>e1.properties()
            ],
            "geometry-type": [
                Gt,
                [],
                (e1)=>e1.geometryType()
            ],
            id: [
                Wt,
                [],
                (e1)=>e1.id()
            ],
            zoom: [
                jt,
                [],
                (e1)=>e1.globals.zoom
            ],
            pitch: [
                jt,
                [],
                (e1)=>e1.globals.pitch || 0
            ],
            "distance-from-center": [
                jt,
                [],
                (e1)=>e1.distanceFromCenter()
            ],
            "measure-light": [
                jt,
                [
                    Gt
                ],
                (e1, [t])=>e1.measureLight(t.evaluate(e1))
            ],
            "heatmap-density": [
                jt,
                [],
                (e1)=>e1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                jt,
                [],
                (e1)=>e1.globals.lineProgress || 0
            ],
            "raster-value": [
                jt,
                [],
                (e1)=>e1.globals.rasterValue || 0
            ],
            "sky-radial-progress": [
                jt,
                [],
                (e1)=>e1.globals.skyRadialProgress || 0
            ],
            accumulated: [
                Wt,
                [],
                (e1)=>void 0 === e1.globals.accumulated ? null : e1.globals.accumulated
            ],
            "+": [
                jt,
                no(jt),
                (e1, t)=>{
                    let i = 0;
                    for (const r of t)i += r.evaluate(e1);
                    return i;
                }
            ],
            "*": [
                jt,
                no(jt),
                (e1, t)=>{
                    let i = 1;
                    for (const r of t)i *= r.evaluate(e1);
                    return i;
                }
            ],
            "-": {
                type: jt,
                overloads: [
                    [
                        [
                            jt,
                            jt
                        ],
                        (e1, [t, i])=>t.evaluate(e1) - i.evaluate(e1)
                    ],
                    [
                        [
                            jt
                        ],
                        (e1, [t])=>-t.evaluate(e1)
                    ]
                ]
            },
            "/": [
                jt,
                [
                    jt,
                    jt
                ],
                (e1, [t, i])=>t.evaluate(e1) / i.evaluate(e1)
            ],
            "%": [
                jt,
                [
                    jt,
                    jt
                ],
                (e1, [t, i])=>t.evaluate(e1) % i.evaluate(e1)
            ],
            ln2: [
                jt,
                [],
                ()=>Math.LN2
            ],
            pi: [
                jt,
                [],
                ()=>Math.PI
            ],
            e: [
                jt,
                [],
                ()=>Math.E
            ],
            "^": [
                jt,
                [
                    jt,
                    jt
                ],
                (e1, [t, i])=>Math.pow(t.evaluate(e1), i.evaluate(e1))
            ],
            sqrt: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.sqrt(t.evaluate(e1))
            ],
            log10: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.log(t.evaluate(e1)) / Math.LN10
            ],
            ln: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.log(t.evaluate(e1))
            ],
            log2: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.log(t.evaluate(e1)) / Math.LN2
            ],
            sin: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.sin(t.evaluate(e1))
            ],
            cos: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.cos(t.evaluate(e1))
            ],
            tan: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.tan(t.evaluate(e1))
            ],
            asin: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.asin(t.evaluate(e1))
            ],
            acos: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.acos(t.evaluate(e1))
            ],
            atan: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.atan(t.evaluate(e1))
            ],
            min: [
                jt,
                no(jt),
                (e1, t)=>Math.min(...t.map((t)=>t.evaluate(e1)))
            ],
            max: [
                jt,
                no(jt),
                (e1, t)=>Math.max(...t.map((t)=>t.evaluate(e1)))
            ],
            abs: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.abs(t.evaluate(e1))
            ],
            round: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>{
                    const i = t.evaluate(e1);
                    return i < 0 ? -Math.round(-i) : Math.round(i);
                }
            ],
            floor: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.floor(t.evaluate(e1))
            ],
            ceil: [
                jt,
                [
                    jt
                ],
                (e1, [t])=>Math.ceil(t.evaluate(e1))
            ],
            "filter-==": [
                qt,
                [
                    Gt,
                    Wt
                ],
                (e1, [t, i])=>e1.properties()[t.value] === i.value
            ],
            "filter-id-==": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>e1.id() === t.value
            ],
            "filter-type-==": [
                qt,
                [
                    Gt
                ],
                (e1, [t])=>e1.geometryType() === t.value
            ],
            "filter-<": [
                qt,
                [
                    Gt,
                    Wt
                ],
                (e1, [t, i])=>{
                    const r = e1.properties()[t.value], n = i.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter-id-<": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>{
                    const i = e1.id(), r = t.value;
                    return typeof i == typeof r && i < r;
                }
            ],
            "filter->": [
                qt,
                [
                    Gt,
                    Wt
                ],
                (e1, [t, i])=>{
                    const r = e1.properties()[t.value], n = i.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-id->": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>{
                    const i = e1.id(), r = t.value;
                    return typeof i == typeof r && i > r;
                }
            ],
            "filter-<=": [
                qt,
                [
                    Gt,
                    Wt
                ],
                (e1, [t, i])=>{
                    const r = e1.properties()[t.value], n = i.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter-id-<=": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>{
                    const i = e1.id(), r = t.value;
                    return typeof i == typeof r && i <= r;
                }
            ],
            "filter->=": [
                qt,
                [
                    Gt,
                    Wt
                ],
                (e1, [t, i])=>{
                    const r = e1.properties()[t.value], n = i.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-id->=": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>{
                    const i = e1.id(), r = t.value;
                    return typeof i == typeof r && i >= r;
                }
            ],
            "filter-has": [
                qt,
                [
                    Wt
                ],
                (e1, [t])=>t.value in e1.properties()
            ],
            "filter-has-id": [
                qt,
                [],
                (e1)=>null !== e1.id() && void 0 !== e1.id()
            ],
            "filter-type-in": [
                qt,
                [
                    Kt(Gt)
                ],
                (e1, [t])=>t.value.indexOf(e1.geometryType()) >= 0
            ],
            "filter-id-in": [
                qt,
                [
                    Kt(Wt)
                ],
                (e1, [t])=>t.value.indexOf(e1.id()) >= 0
            ],
            "filter-in-small": [
                qt,
                [
                    Gt,
                    Kt(Wt)
                ],
                (e1, [t, i])=>i.value.indexOf(e1.properties()[t.value]) >= 0
            ],
            "filter-in-large": [
                qt,
                [
                    Gt,
                    Kt(Wt)
                ],
                (e1, [t, i])=>(function(e1, t, i, r) {
                        for(; i <= r;){
                            const n = i + r >> 1;
                            if (t[n] === e1) return !0;
                            t[n] > e1 ? r = n - 1 : i = n + 1;
                        }
                        return !1;
                    })(e1.properties()[t.value], i.value, 0, i.value.length - 1)
            ],
            all: {
                type: qt,
                overloads: [
                    [
                        [
                            qt,
                            qt
                        ],
                        (e1, [t, i])=>t.evaluate(e1) && i.evaluate(e1)
                    ],
                    [
                        no(qt),
                        (e1, t)=>{
                            for (const i of t)if (!i.evaluate(e1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: qt,
                overloads: [
                    [
                        [
                            qt,
                            qt
                        ],
                        (e1, [t, i])=>t.evaluate(e1) || i.evaluate(e1)
                    ],
                    [
                        no(qt),
                        (e1, t)=>{
                            for (const i of t)if (i.evaluate(e1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                qt,
                [
                    qt
                ],
                (e1, [t])=>!t.evaluate(e1)
            ],
            "is-supported-script": [
                qt,
                [
                    Gt
                ],
                (e1, [t])=>{
                    const i = e1.globals && e1.globals.isSupportedScript;
                    return !i || i(t.evaluate(e1));
                }
            ],
            upcase: [
                Gt,
                [
                    Gt
                ],
                (e1, [t])=>t.evaluate(e1).toUpperCase()
            ],
            downcase: [
                Gt,
                [
                    Gt
                ],
                (e1, [t])=>t.evaluate(e1).toLowerCase()
            ],
            concat: [
                Gt,
                no(Wt),
                (e1, t)=>t.map((t)=>yi(t.evaluate(e1))).join("")
            ],
            "resolved-locale": [
                Gt,
                [
                    Ht
                ],
                (e1, [t])=>t.evaluate(e1).resolvedLocale()
            ],
            random: [
                jt,
                [
                    jt,
                    jt,
                    Wt
                ],
                (e1, t)=>{
                    const [i, r, n] = t.map((t)=>t.evaluate(e1));
                    if (i > r) return i;
                    if (i === r) return i;
                    let o;
                    if ("string" == typeof n) o = function(e1) {
                        let t = 0;
                        if (0 === e1.length) return t;
                        for(let i = 0; i < e1.length; i++)t = (t << 5) - t + e1.charCodeAt(i), t &= t;
                        return t;
                    }(n);
                    else {
                        if ("number" != typeof n) throw new bi(`Invalid seed input: ${n}`);
                        o = n;
                    }
                    return i + Xn(o)() * (r - i);
                }
            ]
        });
        var oo = Yn;
        function so(e1) {
            return {
                result: "success",
                value: e1
            };
        }
        function ao(e1) {
            return {
                result: "error",
                value: e1
            };
        }
        function lo(e1, t) {
            return !!e1 && !!e1.parameters && e1.parameters.indexOf(t) > -1;
        }
        function co(e1) {
            return "data-driven" === e1["property-type"];
        }
        function ho(e1) {
            return lo(e1.expression, "measure-light");
        }
        function uo(e1) {
            return lo(e1.expression, "zoom");
        }
        function po(e1) {
            return !!e1.expression && e1.expression.interpolated;
        }
        function fo(e1) {
            return "object" == typeof e1 && null !== e1 && !Array.isArray(e1);
        }
        function mo(e1) {
            return e1;
        }
        function _o(e1, t) {
            const i = "color" === t.type, r = e1.stops && "object" == typeof e1.stops[0][0], n = r || !(r || void 0 !== e1.property), o = e1.type || (po(t) ? "exponential" : "interval");
            if (i && ((e1 = Lt({}, e1)).stops && (e1.stops = e1.stops.map((e1)=>[
                    e1[0],
                    hi.parse(e1[1])
                ])), e1.default = hi.parse(e1.default ? e1.default : t.default)), e1.colorSpace && "rgb" !== e1.colorSpace && !yn[e1.colorSpace]) throw new Error(`Unknown color space: ${e1.colorSpace}`);
            let s, a, l;
            if ("exponential" === o) s = vo;
            else if ("interval" === o) s = xo;
            else if ("categorical" === o) {
                s = yo, a = Object.create(null);
                for (const t of e1.stops)a[t[0]] = t[1];
                l = typeof e1.stops[0][0];
            } else {
                if ("identity" !== o) throw new Error(`Unknown function type "${o}"`);
                s = bo;
            }
            if (r) {
                const i = {}, r = [];
                for(let t = 0; t < e1.stops.length; t++){
                    const n = e1.stops[t], o = n[0].zoom;
                    void 0 === i[o] && (i[o] = {
                        zoom: o,
                        type: e1.type,
                        property: e1.property,
                        default: e1.default,
                        stops: []
                    }, r.push(o)), i[o].stops.push([
                        n[0].value,
                        n[1]
                    ]);
                }
                const n = [];
                for (const e1 of r)n.push([
                    i[e1].zoom,
                    _o(i[e1], t)
                ]);
                const o = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: o,
                    interpolationFactor: bn.interpolationFactor.bind(void 0, o),
                    zoomStops: n.map((e1)=>e1[0]),
                    evaluate: ({ zoom: i }, r)=>vo({
                            stops: n,
                            base: e1.base
                        }, t, i).evaluate(i, r)
                };
            }
            if (n) {
                const i = "exponential" === o ? {
                    name: "exponential",
                    base: void 0 !== e1.base ? e1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: i,
                    interpolationFactor: bn.interpolationFactor.bind(void 0, i),
                    zoomStops: e1.stops.map((e1)=>e1[0]),
                    evaluate: ({ zoom: i })=>s(e1, t, i, a, l)
                };
            }
            return {
                kind: "source",
                evaluate (i, r) {
                    const n = r && r.properties ? r.properties[e1.property] : void 0;
                    return void 0 === n ? go(e1.default, t.default) : s(e1, t, n, a, l);
                }
            };
        }
        function go(e1, t, i) {
            return void 0 !== e1 ? e1 : void 0 !== t ? t : void 0 !== i ? i : void 0;
        }
        function yo(e1, t, i, r, n) {
            return go(typeof i === n ? r[i] : void 0, e1.default, t.default);
        }
        function xo(e1, t, i) {
            if ("number" !== Si(i)) return go(e1.default, t.default);
            const r = e1.stops.length;
            if (1 === r) return e1.stops[0][1];
            if (i <= e1.stops[0][0]) return e1.stops[0][1];
            if (i >= e1.stops[r - 1][0]) return e1.stops[r - 1][1];
            const n = Hr(e1.stops.map((e1)=>e1[0]), i);
            return e1.stops[n][1];
        }
        function vo(e1, t, i) {
            const r = void 0 !== e1.base ? e1.base : 1;
            if ("number" !== Si(i)) return go(e1.default, t.default);
            const n = e1.stops.length;
            if (1 === n) return e1.stops[0][1];
            if (i <= e1.stops[0][0]) return e1.stops[0][1];
            if (i >= e1.stops[n - 1][0]) return e1.stops[n - 1][1];
            const o = Hr(e1.stops.map((e1)=>e1[0]), i), s = function(e1, t, i, r) {
                const n = r - i, o = e1 - i;
                return 0 === n ? 0 : 1 === t ? o / n : (Math.pow(t, o) - 1) / (Math.pow(t, n) - 1);
            }(i, r, e1.stops[o][0], e1.stops[o + 1][0]), a = e1.stops[o][1], l = e1.stops[o + 1][1];
            let c = Qr[t.type] || mo;
            if (e1.colorSpace && "rgb" !== e1.colorSpace) {
                const t = yn[e1.colorSpace];
                c = (e1, i)=>t.reverse(t.interpolate(t.forward(e1), t.forward(i), s));
            }
            return "function" == typeof a.evaluate ? {
                evaluate (...e1) {
                    const t = a.evaluate.apply(void 0, e1), i = l.evaluate.apply(void 0, e1);
                    if (void 0 !== t && void 0 !== i) return c(t, i, s);
                }
            } : c(a, l, s);
        }
        function bo(e1, t, i) {
            return "color" === t.type ? i = hi.parse(i) : "formatted" === t.type ? i = pi.fromString(i.toString()) : "resolvedImage" === t.type ? i = fi.fromString(i.toString()) : Si(i) === t.type || "enum" === t.type && t.values[i] || (i = void 0), go(i, e1.default, t.default);
        }
        class wo {
            evaluateWithoutErrorHandling(e1, t, i, r, n, o, s, a) {
                return this._evaluator.globals = e1, this._evaluator.feature = t, this._evaluator.featureState = i, this._evaluator.canonical = r || null, this._evaluator.availableImages = n || null, this._evaluator.formattedSection = o, this._evaluator.featureTileCoord = s || null, this._evaluator.featureDistanceData = a || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(e1, t, i, r, n, o, s, a) {
                this._evaluator.globals = e1, this._evaluator.feature = t || null, this._evaluator.featureState = i || null, this._evaluator.canonical = r || null, this._evaluator.availableImages = n || null, this._evaluator.formattedSection = o || null, this._evaluator.featureTileCoord = s || null, this._evaluator.featureDistanceData = a || null;
                try {
                    const e1 = this.expression.evaluate(this._evaluator);
                    if (null == e1 || "number" == typeof e1 && e1 != e1) return this._defaultValue;
                    if (this._enumValues && !(e1 in this._enumValues)) throw new bi(`Expected value to be one of ${Object.keys(this._enumValues).map((e1)=>JSON.stringify(e1)).join(", ")}, but found ${JSON.stringify(e1)} instead.`);
                    return e1;
                } catch (e1) {
                    return this._warningHistory[e1.message] || (this._warningHistory[e1.message] = !0, "undefined" != typeof console && console.warn(e1.message)), this._defaultValue;
                }
            }
            constructor(e1, t, i){
                this.expression = e1, this._warningHistory = {}, this._evaluator = new Di(i), this._defaultValue = t ? function(e1) {
                    return "color" === e1.type && (fo(e1.default) || Array.isArray(e1.default)) ? new hi(0, 0, 0, 0) : "color" === e1.type ? hi.parse(e1.default) || null : void 0 === e1.default ? null : e1.default;
                }(t) : null, this._enumValues = t && "enum" === t.type ? t.values : null;
            }
        }
        function To(e1) {
            return Array.isArray(e1) && e1.length > 0 && "string" == typeof e1[0] && e1[0] in oo;
        }
        function Eo(e1, t, i) {
            const r = new $r(oo, [], t ? function(e1) {
                const t = {
                    color: Zt,
                    string: Gt,
                    number: jt,
                    enum: Gt,
                    boolean: qt,
                    formatted: Xt,
                    resolvedImage: Yt
                };
                return "array" === e1.type ? Kt(t[e1.value] || Wt, e1.length) : t[e1.type];
            }(t) : void 0, void 0, void 0, i), n = r.parse(e1, void 0, void 0, void 0, t && "string" === t.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return n ? so(new wo(n, t, i)) : ao(r.errors);
        }
        class Mo {
            evaluateWithoutErrorHandling(e1, t, i, r, n, o) {
                return this._styleExpression.evaluateWithoutErrorHandling(e1, t, i, r, n, o);
            }
            evaluate(e1, t, i, r, n, o) {
                return this._styleExpression.evaluate(e1, t, i, r, n, o);
            }
            constructor(e1, t, i){
                this.kind = e1, this._styleExpression = t, this.isLightConstant = i, this.isStateDependent = "constant" !== e1 && !Ur(t.expression), this.isConfigDependent = !Vr(t.expression);
            }
        }
        class Ao {
            evaluateWithoutErrorHandling(e1, t, i, r, n, o) {
                return this._styleExpression.evaluateWithoutErrorHandling(e1, t, i, r, n, o);
            }
            evaluate(e1, t, i, r, n, o) {
                return this._styleExpression.evaluate(e1, t, i, r, n, o);
            }
            interpolationFactor(e1, t, i) {
                return this.interpolationType ? bn.interpolationFactor(this.interpolationType, e1, t, i) : 0;
            }
            constructor(e1, t, i, r, n){
                this.kind = e1, this.zoomStops = i, this._styleExpression = t, this.isStateDependent = "camera" !== e1 && !Ur(t.expression), this.isLightConstant = n, this.isConfigDependent = !Vr(t.expression), this.interpolationType = r;
            }
        }
        function So(e1, t, i) {
            if ("error" === (e1 = Eo(e1, t, i)).result) return e1;
            const r = e1.value.expression, n = Nr(r);
            if (!n && !co(t)) return ao([
                new Ft("", "data expressions not supported")
            ]);
            const o = jr(r, [
                "zoom",
                "pitch",
                "distance-from-center"
            ]);
            if (!o && !uo(t)) return ao([
                new Ft("", "zoom expressions not supported")
            ]);
            const s = jr(r, [
                "measure-light"
            ]);
            if (!s && !ho(t)) return ao([
                new Ft("", "measure-light expression not supported")
            ]);
            const a = t.expression && t.expression.relaxZoomRestriction, l = Co(r);
            return l || o || a ? l instanceof Ft ? ao([
                l
            ]) : l instanceof bn && !po(t) ? ao([
                new Ft("", '"interpolate" expressions cannot be used with this property')
            ]) : so(l ? new Ao(n ? "camera" : "composite", e1.value, l.labels, l instanceof bn ? l.interpolation : void 0, s) : new Mo(n ? "constant" : "source", e1.value, s)) : ao([
                new Ft("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')
            ]);
        }
        class Io {
            static deserialize(e1) {
                return new Io(e1._parameters, e1._specification);
            }
            static serialize(e1) {
                return {
                    _parameters: e1._parameters,
                    _specification: e1._specification
                };
            }
            constructor(e1, t){
                this._parameters = e1, this._specification = t, Lt(this, _o(this._parameters, this._specification));
            }
        }
        function Co(e1) {
            let t = null;
            if (e1 instanceof Mn) t = Co(e1.result);
            else if (e1 instanceof Tn) {
                for (const i of e1.args)if (t = Co(i), t) break;
            } else (e1 instanceof Yr || e1 instanceof bn) && e1.input instanceof ki && "zoom" === e1.input.name && (t = e1);
            return t instanceof Ft || e1.eachChild((e1)=>{
                const i = Co(e1);
                i instanceof Ft ? t = i : t && i && t !== i && (t = new Ft("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), t;
        }
        function zo(e1) {
            const t = e1.key, i = e1.value, r = e1.valueSpec || {}, n = e1.objectElementValidators || {}, o = e1.style, s = e1.styleSpec;
            let a = [];
            const l = Si(i);
            if ("object" !== l) return [
                new Dt(t, i, `object expected, ${l} found`)
            ];
            for(const e1 in i){
                const l = e1.split(".")[0];
                let c;
                n[l] ? c = n[l] : r[l] ? c = ds : n["*"] ? c = n["*"] : r["*"] && (c = ds), c ? a = a.concat(c({
                    key: (t ? `${t}.` : t) + e1,
                    value: i[e1],
                    valueSpec: r[l] || r["*"],
                    style: o,
                    styleSpec: s,
                    object: i,
                    objectKey: e1
                }, i)) : a.push(new Rt(t, i[e1], `unknown property "${e1}"`));
            }
            for(const e1 in r)n[e1] || r[e1].required && void 0 === r[e1].default && void 0 === i[e1] && a.push(new Dt(t, i, `missing required property "${e1}"`));
            return a;
        }
        function Po(e1) {
            const t = e1.value, i = e1.valueSpec, r = e1.style, n = e1.styleSpec, o = e1.key, s = e1.arrayElementValidator || ds;
            if ("array" !== Si(t)) return [
                new Dt(o, t, `array expected, ${Si(t)} found`)
            ];
            if (i.length && t.length !== i.length) return [
                new Dt(o, t, `array length ${i.length} expected, length ${t.length} found`)
            ];
            if (i["min-length"] && t.length < i["min-length"]) return [
                new Dt(o, t, `array length at least ${i["min-length"]} expected, length ${t.length} found`)
            ];
            let a = {
                type: i.value,
                values: i.values,
                minimum: i.minimum,
                maximum: i.maximum,
                function: void 0
            };
            n.$version < 7 && (a.function = i.function), "object" === Si(i.value) && (a = i.value);
            let l = [];
            for(let e1 = 0; e1 < t.length; e1++)l = l.concat(s({
                array: t,
                arrayIndex: e1,
                value: t[e1],
                valueSpec: a,
                style: r,
                styleSpec: n,
                key: `${o}[${e1}]`
            }, !0));
            return l;
        }
        function Do(e1) {
            const t = e1.key, i = e1.value, r = e1.valueSpec;
            let n = Si(i);
            if ("number" === n && i != i && (n = "NaN"), "number" !== n) return [
                new Dt(t, i, `number expected, ${n} found`)
            ];
            if ("minimum" in r) {
                let n = r.minimum;
                if ("array" === Si(r.minimum) && (n = r.minimum[e1.arrayIndex]), i < n) return [
                    new Dt(t, i, `${i} is less than the minimum value ${n}`)
                ];
            }
            if ("maximum" in r) {
                let n = r.maximum;
                if ("array" === Si(r.maximum) && (n = r.maximum[e1.arrayIndex]), i > n) return [
                    new Dt(t, i, `${i} is greater than the maximum value ${n}`)
                ];
            }
            return [];
        }
        function Ro(e1) {
            const t = e1.valueSpec, i = kt(e1.value.type);
            let r, n, o, s = {};
            const a = "categorical" !== i && void 0 === e1.value.property, l = !a, c = "array" === Si(e1.value.stops) && "array" === Si(e1.value.stops[0]) && "object" === Si(e1.value.stops[0][0]), h = zo({
                key: e1.key,
                value: e1.value,
                valueSpec: e1.styleSpec.function,
                style: e1.style,
                styleSpec: e1.styleSpec,
                objectElementValidators: {
                    stops: function(e1) {
                        if ("identity" === i) return [
                            new Dt(e1.key, e1.value, 'identity function may not have a "stops" property')
                        ];
                        let t = [];
                        const r = e1.value;
                        return t = t.concat(Po({
                            key: e1.key,
                            value: r,
                            valueSpec: e1.valueSpec,
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            arrayElementValidator: u
                        })), "array" === Si(r) && 0 === r.length && t.push(new Dt(e1.key, r, "array must have at least one stop")), t;
                    },
                    default: function(e1) {
                        return ds({
                            key: e1.key,
                            value: e1.value,
                            valueSpec: t,
                            style: e1.style,
                            styleSpec: e1.styleSpec
                        });
                    }
                }
            });
            return "identity" === i && a && h.push(new Dt(e1.key, e1.value, 'missing required property "property"')), "identity" === i || e1.value.stops || h.push(new Dt(e1.key, e1.value, 'missing required property "stops"')), "exponential" === i && e1.valueSpec.expression && !po(e1.valueSpec) && h.push(new Dt(e1.key, e1.value, "exponential functions not supported")), e1.styleSpec.$version >= 8 && (l && !co(e1.valueSpec) ? h.push(new Dt(e1.key, e1.value, "property functions not supported")) : a && !uo(e1.valueSpec) && h.push(new Dt(e1.key, e1.value, "zoom functions not supported"))), "categorical" !== i && !c || void 0 !== e1.value.property || h.push(new Dt(e1.key, e1.value, '"property" property is required')), h;
            function u(e1) {
                let i = [];
                const r = e1.value, a = e1.key;
                if ("array" !== Si(r)) return [
                    new Dt(a, r, `array expected, ${Si(r)} found`)
                ];
                if (2 !== r.length) return [
                    new Dt(a, r, `array length 2 expected, length ${r.length} found`)
                ];
                if (c) {
                    if ("object" !== Si(r[0])) return [
                        new Dt(a, r, `object expected, ${Si(r[0])} found`)
                    ];
                    if (void 0 === r[0].zoom) return [
                        new Dt(a, r, "object stop key must have zoom")
                    ];
                    if (void 0 === r[0].value) return [
                        new Dt(a, r, "object stop key must have value")
                    ];
                    const t = kt(r[0].zoom);
                    if ("number" != typeof t) return [
                        new Dt(a, r[0].zoom, "stop zoom values must be numbers")
                    ];
                    if (o && o > t) return [
                        new Dt(a, r[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    t !== o && (o = t, n = void 0, s = {}), i = i.concat(zo({
                        key: `${a}[0]`,
                        value: r[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: e1.style,
                        styleSpec: e1.styleSpec,
                        objectElementValidators: {
                            zoom: Do,
                            value: d
                        }
                    }));
                } else i = i.concat(d({
                    key: `${a}[0]`,
                    value: r[0],
                    valueSpec: {},
                    style: e1.style,
                    styleSpec: e1.styleSpec
                }, r));
                return To(Ot(r[1])) ? i.concat([
                    new Dt(`${a}[1]`, r[1], "expressions are not allowed in function stops.")
                ]) : i.concat(ds({
                    key: `${a}[1]`,
                    value: r[1],
                    valueSpec: t,
                    style: e1.style,
                    styleSpec: e1.styleSpec
                }));
            }
            function d(e1, o) {
                const a = Si(e1.value), l = kt(e1.value), c = null !== e1.value ? e1.value : o;
                if (r) {
                    if (a !== r) return [
                        new Dt(e1.key, c, `${a} stop domain type must match previous stop domain type ${r}`)
                    ];
                } else r = a;
                if ("number" !== a && "string" !== a && "boolean" !== a && "number" != typeof l && "string" != typeof l && "boolean" != typeof l) return [
                    new Dt(e1.key, c, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== a && "categorical" !== i) {
                    let r = `number expected, ${a} found`;
                    return co(t) && void 0 === i && (r += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new Dt(e1.key, c, r)
                    ];
                }
                return "categorical" !== i || "number" !== a || "number" == typeof l && isFinite(l) && Math.floor(l) === l ? "categorical" !== i && "number" === a && "number" == typeof l && "number" == typeof n && void 0 !== n && l < n ? [
                    new Dt(e1.key, c, "stop domain values must appear in ascending order")
                ] : (n = l, "categorical" === i && l in s ? [
                    new Dt(e1.key, c, "stop domain values must be unique")
                ] : (s[l] = !0, [])) : [
                    new Dt(e1.key, c, `integer expected, found ${String(l)}`)
                ];
            }
        }
        function Lo(e1) {
            const t = ("property" === e1.expressionContext ? So : Eo)(Ot(e1.value), e1.valueSpec);
            if ("error" === t.result) return t.value.map((t)=>new Dt(`${e1.key}${t.key}`, e1.value, t.message));
            const i = t.value.expression || t.value._styleExpression.expression;
            if ("property" === e1.expressionContext && "text-font" === e1.propertyKey && !i.outputDefined()) return [
                new Dt(e1.key, e1.value, `Invalid data expression for "${e1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === e1.expressionContext && "layout" === e1.propertyType && !Ur(i)) return [
                new Dt(e1.key, e1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === e1.expressionContext) return ko(i, e1);
            if (e1.expressionContext && 0 === e1.expressionContext.indexOf("cluster")) {
                if (!jr(i, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new Dt(e1.key, e1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === e1.expressionContext && !Nr(i)) return [
                    new Dt(e1.key, e1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function ko(e1, t) {
            const i = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (t.valueSpec && t.valueSpec.expression) for (const e1 of t.valueSpec.expression.parameters)i.delete(e1);
            if (0 === i.size) return [];
            const r = [];
            return e1 instanceof ki && i.has(e1.name) ? [
                new Dt(t.key, t.value, `["${e1.name}"] expression is not supported in a filter for a ${t.object.type} layer with id: ${t.object.id}`)
            ] : (e1.eachChild((e1)=>{
                r.push(...ko(e1, t));
            }), r);
        }
        function Oo(e1) {
            const t = e1.key, i = e1.value, r = e1.valueSpec, n = [];
            return Array.isArray(r.values) ? -1 === r.values.indexOf(kt(i)) && n.push(new Dt(t, i, `expected one of [${r.values.join(", ")}], ${JSON.stringify(i)} found`)) : -1 === Object.keys(r.values).indexOf(kt(i)) && n.push(new Dt(t, i, `expected one of [${Object.keys(r.values).join(", ")}], ${JSON.stringify(i)} found`)), n;
        }
        function Bo(e1) {
            if (!0 === e1 || !1 === e1) return !0;
            if (!Array.isArray(e1) || 0 === e1.length) return !1;
            switch(e1[0]){
                case "has":
                    return e1.length >= 2 && "$id" !== e1[1] && "$type" !== e1[1];
                case "in":
                    return e1.length >= 3 && ("string" != typeof e1[1] || Array.isArray(e1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== e1.length || Array.isArray(e1[1]) || Array.isArray(e1[2]);
                case "any":
                case "all":
                    for (const t of e1.slice(1))if (!Bo(t) && "boolean" != typeof t) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function Fo(e1, t = "fill") {
            if (null == e1) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            Bo(e1) || (e1 = Zo(e1));
            const i = e1;
            let r = !0;
            try {
                r = function(e1) {
                    if (!Vo(e1)) return e1;
                    let t = Ot(e1);
                    return Uo(t), t = No(t), t;
                }(i);
            } catch (e1) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(i, null, 2)}\n        `);
            }
            const n = Pt[`filter_${t}`], o = Eo(r, n);
            let s = null;
            if ("error" === o.result) throw new Error(o.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
            s = (e1, t, i)=>o.value.evaluate(e1, t, {}, i);
            let a = null, l = null;
            if (r !== i) {
                const e1 = Eo(i, n);
                if ("error" === e1.result) throw new Error(e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                a = (t, i, r, n, o)=>e1.value.evaluate(t, i, {}, r, void 0, void 0, n, o), l = !Nr(e1.value.expression);
            }
            return {
                filter: s,
                dynamicFilter: a || void 0,
                needGeometry: qo(r),
                needFeature: !!l
            };
        }
        function No(e1) {
            if (!Array.isArray(e1)) return e1;
            const t = function(e1) {
                if (jo.has(e1[0])) {
                    for(let t = 1; t < e1.length; t++)if (Vo(e1[t])) return !0;
                }
                return e1;
            }(e1);
            return !0 === t ? t : t.map((e1)=>No(e1));
        }
        function Uo(e1) {
            let t = !1;
            const i = [];
            if ("case" === e1[0]) {
                for(let r = 1; r < e1.length - 1; r += 2)t = t || Vo(e1[r]), i.push(e1[r + 1]);
                i.push(e1[e1.length - 1]);
            } else if ("match" === e1[0]) {
                t = t || Vo(e1[1]);
                for(let t = 2; t < e1.length - 1; t += 2)i.push(e1[t + 1]);
                i.push(e1[e1.length - 1]);
            } else if ("step" === e1[0]) {
                t = t || Vo(e1[1]);
                for(let t = 1; t < e1.length - 1; t += 2)i.push(e1[t + 1]);
            }
            t && (e1.length = 0, e1.push("any", ...i));
            for(let t = 1; t < e1.length; t++)Uo(e1[t]);
        }
        function Vo(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("pitch" === (t = e1[0]) || "distance-from-center" === t) return !0;
            var t;
            for(let t = 1; t < e1.length; t++)if (Vo(e1[t])) return !0;
            return !1;
        }
        const jo = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function Go(e1, t) {
            return e1 < t ? -1 : e1 > t ? 1 : 0;
        }
        function qo(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("within" === e1[0] || "distance" === e1[0]) return !0;
            for(let t = 1; t < e1.length; t++)if (qo(e1[t])) return !0;
            return !1;
        }
        function Zo(e1) {
            if (!e1) return !0;
            const t = e1[0];
            var i;
            return e1.length <= 1 ? "any" !== t : "==" === t ? $o(e1[1], e1[2], "==") : "!=" === t ? Xo($o(e1[1], e1[2], "==")) : "<" === t || ">" === t || "<=" === t || ">=" === t ? $o(e1[1], e1[2], t) : "any" === t ? (i = e1.slice(1), [
                "any"
            ].concat(i.map(Zo))) : "all" === t ? [
                "all"
            ].concat(e1.slice(1).map(Zo)) : "none" === t ? [
                "all"
            ].concat(e1.slice(1).map(Zo).map(Xo)) : "in" === t ? Wo(e1[1], e1.slice(2)) : "!in" === t ? Xo(Wo(e1[1], e1.slice(2))) : "has" === t ? Ho(e1[1]) : "!has" !== t || Xo(Ho(e1[1]));
        }
        function $o(e1, t, i) {
            switch(e1){
                case "$type":
                    return [
                        `filter-type-${i}`,
                        t
                    ];
                case "$id":
                    return [
                        `filter-id-${i}`,
                        t
                    ];
                default:
                    return [
                        `filter-${i}`,
                        e1,
                        t
                    ];
            }
        }
        function Wo(e1, t) {
            if (0 === t.length) return !1;
            switch(e1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            t
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            t
                        ]
                    ];
                default:
                    return t.length > 200 && !t.some((e1)=>typeof e1 != typeof t[0]) ? [
                        "filter-in-large",
                        e1,
                        [
                            "literal",
                            t.sort(Go)
                        ]
                    ] : [
                        "filter-in-small",
                        e1,
                        [
                            "literal",
                            t
                        ]
                    ];
            }
        }
        function Ho(e1) {
            switch(e1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        e1
                    ];
            }
        }
        function Xo(e1) {
            return [
                "!",
                e1
            ];
        }
        function Yo(e1) {
            return Bo(Ot(e1.value)) ? Lo(Lt({}, e1, {
                expressionContext: "filter",
                valueSpec: e1.styleSpec[`filter_${e1.layerType || "fill"}`]
            })) : Ko(e1);
        }
        function Ko(e1) {
            const t = e1.value, i = e1.key;
            if ("array" !== Si(t)) return [
                new Dt(i, t, `array expected, ${Si(t)} found`)
            ];
            const r = e1.styleSpec;
            let n, o = [];
            if (t.length < 1) return [
                new Dt(i, t, "filter array must have at least 1 element")
            ];
            switch(o = o.concat(Oo({
                key: `${i}[0]`,
                value: t[0],
                valueSpec: r.filter_operator,
                style: e1.style,
                styleSpec: e1.styleSpec
            })), kt(t[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    t.length >= 2 && "$type" === kt(t[1]) && o.push(new Dt(i, t, `"$type" cannot be use with operator "${t[0]}"`));
                case "==":
                case "!=":
                    3 !== t.length && o.push(new Dt(i, t, `filter array for operator "${t[0]}" must have 3 elements`));
                case "in":
                case "!in":
                    t.length >= 2 && (n = Si(t[1]), "string" !== n && o.push(new Dt(`${i}[1]`, t[1], `string expected, ${n} found`)));
                    for(let s = 2; s < t.length; s++)n = Si(t[s]), "$type" === kt(t[1]) ? o = o.concat(Oo({
                        key: `${i}[${s}]`,
                        value: t[s],
                        valueSpec: r.geometry_type,
                        style: e1.style,
                        styleSpec: e1.styleSpec
                    })) : "string" !== n && "number" !== n && "boolean" !== n && o.push(new Dt(`${i}[${s}]`, t[s], `string, number, or boolean expected, ${n} found`));
                    break;
                case "any":
                case "all":
                case "none":
                    for(let r = 1; r < t.length; r++)o = o.concat(Ko({
                        key: `${i}[${r}]`,
                        value: t[r],
                        style: e1.style,
                        styleSpec: e1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    n = Si(t[1]), 2 !== t.length ? o.push(new Dt(i, t, `filter array for "${t[0]}" operator must have 2 elements`)) : "string" !== n && o.push(new Dt(`${i}[1]`, t[1], `string expected, ${n} found`));
            }
            return o;
        }
        function Jo(e1, t) {
            const i = e1.key, r = e1.style, n = e1.layer, o = e1.styleSpec, s = e1.value, a = e1.objectKey, l = o[`${t}_${e1.layerType}`];
            if (!l) return [];
            const c = a.match(/^(.*)-transition$/);
            if ("paint" === t && c && l[c[1]] && l[c[1]].transition) return ds({
                key: i,
                value: s,
                valueSpec: o.transition,
                style: r,
                styleSpec: o
            });
            const h = e1.valueSpec || l[a];
            if (!h) return [
                new Rt(i, s, `unknown property "${a}"`)
            ];
            let u;
            if ("string" === Si(s) && co(h) && !h.tokens && (u = /^{([^}]+)}$/.exec(s))) {
                const e1 = `\`{ "type": "identity", "property": ${u ? JSON.stringify(u[1]) : '"_"'} }\``;
                return [
                    new Dt(i, s, `"${a}" does not support interpolation syntax\nUse an identity property function instead: ${e1}.`)
                ];
            }
            const d = [];
            if ("symbol" === e1.layerType) "text-field" !== a || !r || r.glyphs || r.imports || d.push(new Dt(i, s, 'use of "text-field" requires a style "glyphs" property')), "text-font" === a && fo(Ot(s)) && "identity" === kt(s.type) && d.push(new Dt(i, s, '"text-font" does not support identity functions'));
            else if ("model" === e1.layerType && "paint" === t && n && n.layout && n.layout.hasOwnProperty("model-id") && co(h) && (ho(h) || uo(h))) {
                const e1 = So(Ot(s), h), t = e1.value.expression || e1.value._styleExpression.expression;
                t && !jr(t, [
                    "measure-light"
                ]) && ("model-emissive-strength" === a && Nr(t) && Ur(t) || d.push(new Dt(i, s, `${a} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
            }
            return d.concat(ds({
                key: e1.key,
                value: s,
                valueSpec: h,
                style: r,
                styleSpec: o,
                expressionContext: "property",
                propertyType: t,
                propertyKey: a
            }));
        }
        function Qo(e1) {
            return Jo(e1, "paint");
        }
        function es(e1) {
            return Jo(e1, "layout");
        }
        function ts(e1) {
            let t = [];
            const i = e1.value, r = e1.key, n = e1.style, o = e1.styleSpec;
            i.type || i.ref || t.push(new Dt(r, i, 'either "type" or "ref" is required'));
            let s = kt(i.type);
            const a = kt(i.ref);
            if (i.id) {
                const o = kt(i.id);
                for(let s = 0; s < e1.arrayIndex; s++){
                    const e1 = n.layers[s];
                    kt(e1.id) === o && t.push(new Dt(r, i.id, `duplicate layer id "${i.id}", previously used at line ${e1.id.__line__}`));
                }
            }
            if ("ref" in i) {
                let e1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((e1)=>{
                    e1 in i && t.push(new Dt(r, i[e1], `"${e1}" is prohibited for ref layers`));
                }), n.layers.forEach((t)=>{
                    kt(t.id) === a && (e1 = t);
                }), e1 ? e1.ref ? t.push(new Dt(r, i.ref, "ref cannot reference another ref layer")) : s = kt(e1.type) : "string" == typeof a && t.push(new Dt(r, i.ref, `ref layer "${a}" not found`));
            } else if ("background" !== s && "sky" !== s && "slot" !== s) {
                if (i.source) {
                    const e1 = n.sources && n.sources[i.source], o = e1 && kt(e1.type);
                    e1 ? "vector" === o && "raster" === s ? t.push(new Dt(r, i.source, `layer "${i.id}" requires a raster source`)) : "raster" === o && "raster" !== s ? t.push(new Dt(r, i.source, `layer "${i.id}" requires a vector source`)) : "vector" !== o || i["source-layer"] ? "raster-dem" === o && "hillshade" !== s ? t.push(new Dt(r, i.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "line" !== s || !i.paint || !i.paint["line-gradient"] && !i.paint["line-trim-offset"] || "geojson" === o && e1.lineMetrics || t.push(new Dt(r, i, `layer "${i.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : t.push(new Dt(r, i, `layer "${i.id}" must specify a "source-layer"`)) : t.push(new Dt(r, i.source, `source "${i.source}" not found`));
                } else t.push(new Dt(r, i, 'missing required property "source"'));
            }
            return t = t.concat(zo({
                key: r,
                value: i,
                valueSpec: o.layer,
                style: e1.style,
                styleSpec: e1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>ds({
                            key: `${r}.type`,
                            value: i.type,
                            valueSpec: o.layer.type,
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            object: i,
                            objectKey: "type"
                        }),
                    filter: (e1)=>Yo(Lt({
                            layerType: s
                        }, e1)),
                    layout: (e1)=>zo({
                            layer: i,
                            key: e1.key,
                            value: e1.value,
                            valueSpec: {},
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            objectElementValidators: {
                                "*": (e1)=>es(Lt({
                                        layerType: s
                                    }, e1))
                            }
                        }),
                    paint: (e1)=>zo({
                            layer: i,
                            key: e1.key,
                            value: e1.value,
                            valueSpec: {},
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            objectElementValidators: {
                                "*": (e1)=>Qo(Lt({
                                        layerType: s,
                                        layer: i
                                    }, e1))
                            }
                        })
                }
            })), t;
        }
        function is(e1) {
            const t = e1.value, i = e1.key, r = Si(t);
            return "string" !== r ? [
                new Dt(i, t, `string expected, ${r} found`)
            ] : [];
        }
        const rs = {
            promoteId: function({ key: e1, value: t }) {
                if ("string" === Si(t)) return is({
                    key: e1,
                    value: t
                });
                {
                    const i = [];
                    for(const r in t)i.push(...is({
                        key: `${e1}.${r}`,
                        value: t[r]
                    }));
                    return i;
                }
            }
        };
        function ns(e1) {
            const t = e1.value, i = e1.key, r = e1.styleSpec, n = e1.style;
            if (!t.type) return [
                new Dt(i, t, '"type" is required')
            ];
            const o = kt(t.type);
            let s = [];
            switch([
                "vector",
                "raster",
                "raster-dem"
            ].includes(o) && (t.url || t.tiles || s.push(new Dt(i, t, 'Either "url" or "tiles" is required.'))), o){
                case "vector":
                case "raster":
                case "raster-dem":
                    return s = s.concat(zo({
                        key: i,
                        value: t,
                        valueSpec: r[`source_${o.replace("-", "_")}`],
                        style: e1.style,
                        styleSpec: r,
                        objectElementValidators: rs
                    })), s;
                case "geojson":
                    if (s = zo({
                        key: i,
                        value: t,
                        valueSpec: r.source_geojson,
                        style: n,
                        styleSpec: r,
                        objectElementValidators: rs
                    }), t.cluster) for(const e1 in t.clusterProperties){
                        const [r, n] = t.clusterProperties[e1], o = "string" == typeof r ? [
                            r,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                e1
                            ]
                        ] : r;
                        s.push(...Lo({
                            key: `${i}.${e1}.map`,
                            value: n,
                            expressionContext: "cluster-map"
                        })), s.push(...Lo({
                            key: `${i}.${e1}.reduce`,
                            value: o,
                            expressionContext: "cluster-reduce"
                        }));
                    }
                    return s;
                case "video":
                    return zo({
                        key: i,
                        value: t,
                        valueSpec: r.source_video,
                        style: n,
                        styleSpec: r
                    });
                case "image":
                    return zo({
                        key: i,
                        value: t,
                        valueSpec: r.source_image,
                        style: n,
                        styleSpec: r
                    });
                case "canvas":
                    return [
                        new Dt(i, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return Oo({
                        key: `${i}.type`,
                        value: t.type,
                        valueSpec: {
                            values: os(r)
                        },
                        style: n,
                        styleSpec: r
                    });
            }
        }
        function os(e1) {
            return e1.source.reduce((t, i)=>{
                const r = e1[i];
                return "enum" === r.type.type && (t = t.concat(Object.keys(r.type.values))), t;
            }, []);
        }
        function ss(e1) {
            const t = e1.value;
            let i = [];
            if (!t) return i;
            const r = Si(t);
            return "string" !== r ? (i = i.concat([
                new Dt(e1.key, t, `string expected, "${r}" found`)
            ]), i) : (function(e1) {
                const t = -1 === e1.indexOf("://");
                try {
                    return new URL(e1, t ? "http://example.com" : void 0), !0;
                } catch (e1) {
                    return !1;
                }
            }(t) || (i = i.concat([
                new Dt(e1.key, t, `invalid url "${t}"`)
            ])), i);
        }
        function as(e1) {
            const t = e1.value, i = e1.styleSpec, r = i.light, n = e1.style;
            let o = [];
            const s = Si(t);
            if (void 0 === t) return o;
            if ("object" !== s) return o = o.concat([
                new Dt("light", t, `object expected, ${s} found`)
            ]), o;
            for(const e1 in t){
                const s = e1.match(/^(.*)-transition$/);
                o = o.concat(s && r[s[1]] && r[s[1]].transition ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: i.transition,
                    style: n,
                    styleSpec: i
                }) : r[e1] ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: r[e1],
                    style: n,
                    styleSpec: i
                }) : [
                    new Dt(e1, t[e1], `unknown property "${e1}"`)
                ]);
            }
            return o;
        }
        function ls(e1) {
            const t = e1.value;
            let i = [];
            if (!t) return i;
            const r = Si(t);
            if ("object" !== r) return i = i.concat([
                new Dt("light-3d", t, `object expected, ${r} found`)
            ]), i;
            const n = e1.styleSpec, o = n["light-3d"], s = e1.key, a = e1.style, l = e1.style.lights;
            for (const e1 of [
                "type",
                "id"
            ])if (!(e1 in t)) return i = i.concat([
                new Dt("light-3d", t, `missing property ${e1} on light`)
            ]), i;
            if (t.type && l) for(let r = 0; r < e1.arrayIndex; r++){
                const e1 = kt(t.type), n = l[r];
                kt(n.type) === e1 && i.push(new Dt(s, t.id, `duplicate light type "${t.type}", previously defined at line ${n.id.__line__}`));
            }
            const c = `properties_light_${t.type}`;
            if (!(c in n)) return i = i.concat([
                new Dt("light-3d", t, `Invalid light type ${t.type}`)
            ]), i;
            const h = n[c];
            for(const r in t)if ("properties" === r) {
                const o = t[r], s = Si(o);
                if ("object" !== s) return i = i.concat([
                    new Dt("properties", o, `object expected, ${s} found`)
                ]), i;
                for(const t in o)i = i.concat(h[t] ? ds({
                    key: t,
                    value: o[t],
                    valueSpec: h[t],
                    style: a,
                    styleSpec: n
                }) : [
                    new Rt(e1.key, o[t], `unknown property "${t}"`)
                ]);
            } else {
                const e1 = r.match(/^(.*)-transition$/);
                i = i.concat(e1 && o[e1[1]] && o[e1[1]].transition ? ds({
                    key: r,
                    value: t[r],
                    valueSpec: n.transition,
                    style: a,
                    styleSpec: n
                }) : o[r] ? ds({
                    key: r,
                    value: t[r],
                    valueSpec: o[r],
                    style: a,
                    styleSpec: n
                }) : [
                    new Rt(r, t[r], `unknown property "${r}"`)
                ]);
            }
            return i;
        }
        function cs(e1) {
            const t = e1.value, i = e1.key, r = e1.style, n = e1.styleSpec, o = n.terrain;
            let s = [];
            const a = Si(t);
            if (void 0 === t) return s;
            if ("null" === a) return s;
            if ("object" !== a) return s = s.concat([
                new Dt("terrain", t, `object expected, ${a} found`)
            ]), s;
            for(const e1 in t){
                const i = e1.match(/^(.*)-transition$/);
                s = s.concat(i && o[i[1]] && o[i[1]].transition ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: n.transition,
                    style: r,
                    styleSpec: n
                }) : o[e1] ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: o[e1],
                    style: r,
                    styleSpec: n
                }) : [
                    new Rt(e1, t[e1], `unknown property "${e1}"`)
                ]);
            }
            if (t.source) {
                const e1 = r.sources && r.sources[t.source], n = e1 && kt(e1.type);
                e1 ? "raster-dem" !== n && s.push(new Dt(i, t.source, `terrain cannot be used with a source of type ${String(n)}, it only be used with a "raster-dem" source type`)) : s.push(new Dt(i, t.source, `source "${t.source}" not found`));
            } else s.push(new Dt(i, t, 'terrain is missing required property "source"'));
            return s;
        }
        function hs(e1) {
            const t = e1.value, i = e1.style, r = e1.styleSpec, n = r.fog;
            let o = [];
            const s = Si(t);
            if (void 0 === t) return o;
            if ("object" !== s) return o = o.concat([
                new Dt("fog", t, `object expected, ${s} found`)
            ]), o;
            for(const e1 in t){
                const s = e1.match(/^(.*)-transition$/);
                o = o.concat(s && n[s[1]] && n[s[1]].transition ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: r.transition,
                    style: i,
                    styleSpec: r
                }) : n[e1] ? ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: n[e1],
                    style: i,
                    styleSpec: r
                }) : [
                    new Rt(e1, t[e1], `unknown property "${e1}"`)
                ]);
            }
            return o;
        }
        const us = {
            "*": ()=>[],
            array: Po,
            boolean: function(e1) {
                const t = e1.value, i = e1.key, r = Si(t);
                return "boolean" !== r ? [
                    new Dt(i, t, `boolean expected, ${r} found`)
                ] : [];
            },
            number: Do,
            color: function(e1) {
                const t = e1.key, i = e1.value, r = Si(i);
                return "string" !== r ? [
                    new Dt(t, i, `color expected, ${r} found`)
                ] : null === ri(i) ? [
                    new Dt(t, i, `color expected, "${i}" found`)
                ] : [];
            },
            enum: Oo,
            filter: Yo,
            function: Ro,
            layer: ts,
            object: zo,
            source: ns,
            model: ss,
            light: as,
            "light-3d": ls,
            terrain: cs,
            fog: hs,
            string: is,
            formatted: function(e1) {
                return 0 === is(e1).length ? [] : Lo(e1);
            },
            resolvedImage: function(e1) {
                return 0 === is(e1).length ? [] : Lo(e1);
            },
            projection: function(e1) {
                const t = e1.value, i = e1.styleSpec, r = i.projection, n = e1.style;
                let o = [];
                const s = Si(t);
                if ("object" === s) for(const e1 in t)o = o.concat(ds({
                    key: e1,
                    value: t[e1],
                    valueSpec: r[e1],
                    style: n,
                    styleSpec: i
                }));
                else "string" !== s && (o = o.concat([
                    new Dt("projection", t, `object or string expected, ${s} found`)
                ]));
                return o;
            },
            import: function(e1) {
                const { value: t, styleSpec: i } = e1, { data: r, ...n } = t;
                Object.defineProperty(n, "__line__", {
                    value: t.__line__,
                    enumerable: !1
                });
                let o = zo(Lt({}, e1, {
                    value: n,
                    valueSpec: i.import
                }));
                return "" === kt(n.id) && o.push(new Dt(`${e1.key}.id`, n, "import id can't be an empty string")), r && (o = o.concat(fs(r, i, {
                    key: `${e1.key}.data`
                }))), o;
            }
        };
        function ds(e1, t = !1) {
            const i = e1.value, r = e1.valueSpec, n = e1.styleSpec;
            if (r.expression && fo(kt(i))) return Ro(e1);
            if (r.expression && To(Ot(i))) return Lo(e1);
            if (r.type && us[r.type]) {
                const i = us[r.type](e1);
                return !0 === t && i.length > 0 && "array" === Si(e1.value) ? Lo(e1) : i;
            }
            return zo(Lt({}, e1, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function ps(e1) {
            const t = e1.value, i = e1.key, r = is(e1);
            return r.length || (-1 === t.indexOf("{fontstack}") && r.push(new Dt(i, t, '"glyphs" url must include a "{fontstack}" token')), -1 === t.indexOf("{range}") && r.push(new Dt(i, t, '"glyphs" url must include a "{range}" token'))), r;
        }
        function fs(e1, t = Pt, i = {}) {
            return ds({
                key: i.key || "",
                value: e1,
                valueSpec: t.$root,
                styleSpec: t,
                style: e1,
                objectElementValidators: {
                    glyphs: ps,
                    "*": ()=>[]
                }
            });
        }
        function ms(e1, t = Pt) {
            return As(fs(e1, t));
        }
        const _s = (e1)=>As(ns(e1)), gs = (e1)=>As(as(e1)), ys = (e1)=>As(ls(e1)), xs = (e1)=>As(cs(e1)), vs = (e1)=>As(hs(e1)), bs = (e1)=>As(ts(e1)), ws = (e1)=>As(Yo(e1)), Ts = (e1)=>As(Qo(e1)), Es = (e1)=>As(es(e1)), Ms = (e1)=>As(ss(e1));
        function As(e1) {
            return e1.slice().sort((e1, t)=>e1.line && t.line ? e1.line - t.line : 0);
        }
        function Ss(e1, t) {
            let i = !1;
            if (t && t.length) for (const r of t)r instanceof Rt ? H(r.message) : (e1.fire(new Ct(new Error(r.message))), i = !0);
            return i;
        }
        var Is = zs, Cs = 3;
        function zs(e1, t, i) {
            var r = this.cells = [];
            if (e1 instanceof ArrayBuffer) {
                this.arrayBuffer = e1;
                var n = new Int32Array(this.arrayBuffer);
                e1 = n[0], this.d = (t = n[1]) + 2 * (i = n[2]);
                for(var o = 0; o < this.d * this.d; o++){
                    var s = n[Cs + o], a = n[Cs + o + 1];
                    r.push(s === a ? null : n.subarray(s, a));
                }
                var l = n[Cs + r.length + 1];
                this.keys = n.subarray(n[Cs + r.length], l), this.bboxes = n.subarray(l), this.insert = this._insertReadonly;
            } else {
                this.d = t + 2 * i;
                for(var c = 0; c < this.d * this.d; c++)r.push([]);
                this.keys = [], this.bboxes = [];
            }
            this.n = t, this.extent = e1, this.padding = i, this.scale = t / e1, this.uid = 0;
            var h = i / t * e1;
            this.min = -h, this.max = e1 + h;
        }
        zs.prototype.insert = function(e1, t, i, r, n) {
            this._forEachCell(t, i, r, n, this._insertCell, this.uid++), this.keys.push(e1), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(r), this.bboxes.push(n);
        }, zs.prototype._insertReadonly = function() {
            throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
        }, zs.prototype._insertCell = function(e1, t, i, r, n, o) {
            this.cells[n].push(o);
        }, zs.prototype.query = function(e1, t, i, r, n) {
            var o = this.min, s = this.max;
            if (e1 <= o && t <= o && s <= i && s <= r && !n) return Array.prototype.slice.call(this.keys);
            var a = [];
            return this._forEachCell(e1, t, i, r, this._queryCell, a, {}, n), a;
        }, zs.prototype._queryCell = function(e1, t, i, r, n, o, s, a) {
            var l = this.cells[n];
            if (null !== l) for(var c = this.keys, h = this.bboxes, u = 0; u < l.length; u++){
                var d = l[u];
                if (void 0 === s[d]) {
                    var p = 4 * d;
                    (a ? a(h[p + 0], h[p + 1], h[p + 2], h[p + 3]) : e1 <= h[p + 2] && t <= h[p + 3] && i >= h[p + 0] && r >= h[p + 1]) ? (s[d] = !0, o.push(c[d])) : s[d] = !1;
                }
            }
        }, zs.prototype._forEachCell = function(e1, t, i, r, n, o, s, a) {
            for(var l = this._convertToCellCoord(e1), c = this._convertToCellCoord(t), h = this._convertToCellCoord(i), u = this._convertToCellCoord(r), d = l; d <= h; d++)for(var p = c; p <= u; p++){
                var f = this.d * p + d;
                if ((!a || a(this._convertFromCellCoord(d), this._convertFromCellCoord(p), this._convertFromCellCoord(d + 1), this._convertFromCellCoord(p + 1))) && n.call(this, e1, t, i, r, f, o, s, a)) return;
            }
        }, zs.prototype._convertFromCellCoord = function(e1) {
            return (e1 - this.padding) / this.scale;
        }, zs.prototype._convertToCellCoord = function(e1) {
            return Math.max(0, Math.min(this.d - 1, Math.floor(e1 * this.scale) + this.padding));
        }, zs.prototype.toArrayBuffer = function() {
            if (this.arrayBuffer) return this.arrayBuffer;
            for(var e1 = this.cells, t = Cs + this.cells.length + 1 + 1, i = 0, r = 0; r < this.cells.length; r++)i += this.cells[r].length;
            var n = new Int32Array(t + i + this.keys.length + this.bboxes.length);
            n[0] = this.extent, n[1] = this.n, n[2] = this.padding;
            for(var o = t, s = 0; s < e1.length; s++){
                var a = e1[s];
                n[Cs + s] = o, n.set(a, o), o += a.length;
            }
            return n[Cs + e1.length] = o, n.set(this.keys, o), n[Cs + e1.length + 1] = o += this.keys.length, n.set(this.bboxes, o), o += this.bboxes.length, n.buffer;
        };
        var Ps = d(Is);
        const Ds = {};
        function Rs(e1, t, i = {}) {
            Object.defineProperty(e1, "_classRegistryKey", {
                value: t,
                writeable: !1
            }), Ds[t] = {
                klass: e1,
                omit: i.omit || []
            };
        }
        Rs(Object, "Object"), Ps.serialize = function(e1, t) {
            const i = e1.toArrayBuffer();
            return t && t.add(i), {
                buffer: i
            };
        }, Ps.deserialize = function(e1) {
            return new Ps(e1.buffer);
        }, Object.defineProperty(Ps, "name", {
            value: "Grid"
        }), Rs(Ps, "Grid"), Rs(hi, "Color"), Rs(Error, "Error"), Rs(xe, "AJAXError"), Rs(fi, "ResolvedImage"), Rs(Io, "StylePropertyFunction"), Rs(wo, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), Rs(Ao, "ZoomDependentExpression"), Rs(Mo, "ZoomConstantExpression"), Rs(ki, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const e1 in oo)Ds[oo[e1]._classRegistryKey] || Rs(oo[e1], `Expression${e1}`);
        function Ls(e1) {
            return e1 && "undefined" != typeof ArrayBuffer && (e1 instanceof ArrayBuffer || e1.constructor && "ArrayBuffer" === e1.constructor.name);
        }
        function ks(e1) {
            return t.ImageBitmap && e1 instanceof t.ImageBitmap;
        }
        function Os(e1, i) {
            if (null == e1 || "boolean" == typeof e1 || "number" == typeof e1 || "string" == typeof e1 || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String || e1 instanceof Date || e1 instanceof RegExp) return e1;
            if (Ls(e1) || ks(e1)) return i && i.add(e1), e1;
            if (ArrayBuffer.isView(e1)) {
                const t = e1;
                return i && i.add(t.buffer), t;
            }
            if (e1 instanceof t.ImageData) return i && i.add(e1.data.buffer), e1;
            if (Array.isArray(e1)) {
                const t = [];
                for (const r of e1)t.push(Os(r, i));
                return t;
            }
            if (e1 instanceof Map) {
                const t = {
                    $name: "Map"
                };
                for (const [i, r] of e1.entries())t[i] = Os(r);
                return t;
            }
            if ("object" == typeof e1) {
                const t = e1.constructor, r = t._classRegistryKey;
                if (!r) throw new Error(`can't serialize object of unregistered class ${r}`);
                const n = t.serialize ? t.serialize(e1, i) : {};
                if (!t.serialize) {
                    for(const t in e1)e1.hasOwnProperty(t) && (Ds[r].omit.indexOf(t) >= 0 || (n[t] = Os(e1[t], i)));
                    e1 instanceof Error && (n.message = e1.message);
                }
                if (n.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== r && (n.$name = r), n;
            }
            throw new Error("can't serialize object of type " + typeof e1);
        }
        function Bs(e1) {
            if (null == e1 || "boolean" == typeof e1 || "number" == typeof e1 || "string" == typeof e1 || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String || e1 instanceof Date || e1 instanceof RegExp || Ls(e1) || ks(e1) || ArrayBuffer.isView(e1) || e1 instanceof t.ImageData) return e1;
            if (Array.isArray(e1)) return e1.map(Bs);
            if ("object" == typeof e1) {
                const t = e1.$name || "Object";
                if ("Map" === t) {
                    const t = new Map;
                    for (const i of Object.keys(e1))"$name" !== i && t.set(i, Bs(e1[i]));
                    return t;
                }
                const { klass: i } = Ds[t];
                if (!i) throw new Error(`can't deserialize unregistered class ${t}`);
                if (i.deserialize) return i.deserialize(e1);
                const r = Object.create(i.prototype);
                for (const t of Object.keys(e1))"$name" !== t && (r[t] = Bs(e1[t]));
                return r;
            }
            throw new Error("can't deserialize object of type " + typeof e1);
        }
        const Fs = {
            "Latin-1 Supplement": (e1)=>e1 >= 128 && e1 <= 255,
            Arabic: (e1)=>e1 >= 1536 && e1 <= 1791,
            "Arabic Supplement": (e1)=>e1 >= 1872 && e1 <= 1919,
            "Arabic Extended-A": (e1)=>e1 >= 2208 && e1 <= 2303,
            "Hangul Jamo": (e1)=>e1 >= 4352 && e1 <= 4607,
            "Unified Canadian Aboriginal Syllabics": (e1)=>e1 >= 5120 && e1 <= 5759,
            Khmer: (e1)=>e1 >= 6016 && e1 <= 6143,
            "Unified Canadian Aboriginal Syllabics Extended": (e1)=>e1 >= 6320 && e1 <= 6399,
            "General Punctuation": (e1)=>e1 >= 8192 && e1 <= 8303,
            "Letterlike Symbols": (e1)=>e1 >= 8448 && e1 <= 8527,
            "Number Forms": (e1)=>e1 >= 8528 && e1 <= 8591,
            "Miscellaneous Technical": (e1)=>e1 >= 8960 && e1 <= 9215,
            "Control Pictures": (e1)=>e1 >= 9216 && e1 <= 9279,
            "Optical Character Recognition": (e1)=>e1 >= 9280 && e1 <= 9311,
            "Enclosed Alphanumerics": (e1)=>e1 >= 9312 && e1 <= 9471,
            "Geometric Shapes": (e1)=>e1 >= 9632 && e1 <= 9727,
            "Miscellaneous Symbols": (e1)=>e1 >= 9728 && e1 <= 9983,
            "Miscellaneous Symbols and Arrows": (e1)=>e1 >= 11008 && e1 <= 11263,
            "CJK Radicals Supplement": (e1)=>e1 >= 11904 && e1 <= 12031,
            "Kangxi Radicals": (e1)=>e1 >= 12032 && e1 <= 12255,
            "Ideographic Description Characters": (e1)=>e1 >= 12272 && e1 <= 12287,
            "CJK Symbols and Punctuation": (e1)=>e1 >= 12288 && e1 <= 12351,
            Hiragana: (e1)=>e1 >= 12352 && e1 <= 12447,
            Katakana: (e1)=>e1 >= 12448 && e1 <= 12543,
            Bopomofo: (e1)=>e1 >= 12544 && e1 <= 12591,
            "Hangul Compatibility Jamo": (e1)=>e1 >= 12592 && e1 <= 12687,
            Kanbun: (e1)=>e1 >= 12688 && e1 <= 12703,
            "Bopomofo Extended": (e1)=>e1 >= 12704 && e1 <= 12735,
            "CJK Strokes": (e1)=>e1 >= 12736 && e1 <= 12783,
            "Katakana Phonetic Extensions": (e1)=>e1 >= 12784 && e1 <= 12799,
            "Enclosed CJK Letters and Months": (e1)=>e1 >= 12800 && e1 <= 13055,
            "CJK Compatibility": (e1)=>e1 >= 13056 && e1 <= 13311,
            "CJK Unified Ideographs Extension A": (e1)=>e1 >= 13312 && e1 <= 19903,
            "Yijing Hexagram Symbols": (e1)=>e1 >= 19904 && e1 <= 19967,
            "CJK Unified Ideographs": (e1)=>e1 >= 19968 && e1 <= 40959,
            "Yi Syllables": (e1)=>e1 >= 40960 && e1 <= 42127,
            "Yi Radicals": (e1)=>e1 >= 42128 && e1 <= 42191,
            "Hangul Jamo Extended-A": (e1)=>e1 >= 43360 && e1 <= 43391,
            "Hangul Syllables": (e1)=>e1 >= 44032 && e1 <= 55215,
            "Hangul Jamo Extended-B": (e1)=>e1 >= 55216 && e1 <= 55295,
            "Private Use Area": (e1)=>e1 >= 57344 && e1 <= 63743,
            "CJK Compatibility Ideographs": (e1)=>e1 >= 63744 && e1 <= 64255,
            "Arabic Presentation Forms-A": (e1)=>e1 >= 64336 && e1 <= 65023,
            "Vertical Forms": (e1)=>e1 >= 65040 && e1 <= 65055,
            "CJK Compatibility Forms": (e1)=>e1 >= 65072 && e1 <= 65103,
            "Small Form Variants": (e1)=>e1 >= 65104 && e1 <= 65135,
            "Arabic Presentation Forms-B": (e1)=>e1 >= 65136 && e1 <= 65279,
            "Halfwidth and Fullwidth Forms": (e1)=>e1 >= 65280 && e1 <= 65519,
            "CJK Unified Ideographs Extension B": (e1)=>e1 >= 131072 && e1 <= 173791
        };
        function Ns(e1) {
            for (const t of e1)if (js(t.charCodeAt(0))) return !0;
            return !1;
        }
        function Us(e1) {
            for (const t of e1)if (!Vs(t.charCodeAt(0))) return !1;
            return !0;
        }
        function Vs(e1) {
            return !(Fs.Arabic(e1) || Fs["Arabic Supplement"](e1) || Fs["Arabic Extended-A"](e1) || Fs["Arabic Presentation Forms-A"](e1) || Fs["Arabic Presentation Forms-B"](e1));
        }
        function js(e1) {
            return !(746 !== e1 && 747 !== e1 && (e1 < 4352 || !(Fs["Bopomofo Extended"](e1) || Fs.Bopomofo(e1) || Fs["CJK Compatibility Forms"](e1) && !(e1 >= 65097 && e1 <= 65103) || Fs["CJK Compatibility Ideographs"](e1) || Fs["CJK Compatibility"](e1) || Fs["CJK Radicals Supplement"](e1) || Fs["CJK Strokes"](e1) || !(!Fs["CJK Symbols and Punctuation"](e1) || e1 >= 12296 && e1 <= 12305 || e1 >= 12308 && e1 <= 12319 || 12336 === e1) || Fs["CJK Unified Ideographs Extension A"](e1) || Fs["CJK Unified Ideographs"](e1) || Fs["Enclosed CJK Letters and Months"](e1) || Fs["Hangul Compatibility Jamo"](e1) || Fs["Hangul Jamo Extended-A"](e1) || Fs["Hangul Jamo Extended-B"](e1) || Fs["Hangul Jamo"](e1) || Fs["Hangul Syllables"](e1) || Fs.Hiragana(e1) || Fs["Ideographic Description Characters"](e1) || Fs.Kanbun(e1) || Fs["Kangxi Radicals"](e1) || Fs["Katakana Phonetic Extensions"](e1) || Fs.Katakana(e1) && 12540 !== e1 || !(!Fs["Halfwidth and Fullwidth Forms"](e1) || 65288 === e1 || 65289 === e1 || 65293 === e1 || e1 >= 65306 && e1 <= 65310 || 65339 === e1 || 65341 === e1 || 65343 === e1 || e1 >= 65371 && e1 <= 65503 || 65507 === e1 || e1 >= 65512 && e1 <= 65519) || !(!Fs["Small Form Variants"](e1) || e1 >= 65112 && e1 <= 65118 || e1 >= 65123 && e1 <= 65126) || Fs["Unified Canadian Aboriginal Syllabics"](e1) || Fs["Unified Canadian Aboriginal Syllabics Extended"](e1) || Fs["Vertical Forms"](e1) || Fs["Yijing Hexagram Symbols"](e1) || Fs["Yi Syllables"](e1) || Fs["Yi Radicals"](e1))));
        }
        function Gs(e1) {
            return !(js(e1) || function(e1) {
                return !!(Fs["Latin-1 Supplement"](e1) && (167 === e1 || 169 === e1 || 174 === e1 || 177 === e1 || 188 === e1 || 189 === e1 || 190 === e1 || 215 === e1 || 247 === e1) || Fs["General Punctuation"](e1) && (8214 === e1 || 8224 === e1 || 8225 === e1 || 8240 === e1 || 8241 === e1 || 8251 === e1 || 8252 === e1 || 8258 === e1 || 8263 === e1 || 8264 === e1 || 8265 === e1 || 8273 === e1) || Fs["Letterlike Symbols"](e1) || Fs["Number Forms"](e1) || Fs["Miscellaneous Technical"](e1) && (e1 >= 8960 && e1 <= 8967 || e1 >= 8972 && e1 <= 8991 || e1 >= 8996 && e1 <= 9e3 || 9003 === e1 || e1 >= 9085 && e1 <= 9114 || e1 >= 9150 && e1 <= 9165 || 9167 === e1 || e1 >= 9169 && e1 <= 9179 || e1 >= 9186 && e1 <= 9215) || Fs["Control Pictures"](e1) && 9251 !== e1 || Fs["Optical Character Recognition"](e1) || Fs["Enclosed Alphanumerics"](e1) || Fs["Geometric Shapes"](e1) || Fs["Miscellaneous Symbols"](e1) && !(e1 >= 9754 && e1 <= 9759) || Fs["Miscellaneous Symbols and Arrows"](e1) && (e1 >= 11026 && e1 <= 11055 || e1 >= 11088 && e1 <= 11097 || e1 >= 11192 && e1 <= 11243) || Fs["CJK Symbols and Punctuation"](e1) || Fs.Katakana(e1) || Fs["Private Use Area"](e1) || Fs["CJK Compatibility Forms"](e1) || Fs["Small Form Variants"](e1) || Fs["Halfwidth and Fullwidth Forms"](e1) || 8734 === e1 || 8756 === e1 || 8757 === e1 || e1 >= 9984 && e1 <= 10087 || e1 >= 10102 && e1 <= 10131 || 65532 === e1 || 65533 === e1);
            }(e1));
        }
        function qs(e1) {
            return e1 >= 1424 && e1 <= 2303 || Fs["Arabic Presentation Forms-A"](e1) || Fs["Arabic Presentation Forms-B"](e1);
        }
        function Zs(e1, t) {
            return !(!t && qs(e1) || e1 >= 2304 && e1 <= 3583 || e1 >= 3840 && e1 <= 4255 || Fs.Khmer(e1));
        }
        function $s(e1) {
            for (const t of e1)if (qs(t.charCodeAt(0))) return !0;
            return !1;
        }
        const Ws = "deferred", Hs = "loading", Xs = "loaded";
        let Ys = null, Ks = "unavailable", Js = null;
        const Qs = function(e1) {
            e1 && "string" == typeof e1 && e1.indexOf("NetworkError") > -1 && (Ks = "error"), Ys && Ys(e1);
        };
        function ea() {
            ta.fire(new It("pluginStateChange", {
                pluginStatus: Ks,
                pluginURL: Js
            }));
        }
        const ta = new zt, ia = function() {
            return Ks;
        }, ra = function() {
            if (Ks !== Ws || !Js) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Ks = Hs, ea(), Js && Te({
                url: Js
            }, (e1)=>{
                e1 ? Qs(e1) : (Ks = Xs, ea());
            });
        }, na = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>Ks === Xs || null != na.applyArabicShaping,
            isLoading: ()=>Ks === Hs,
            setState (e1) {
                Ks = e1.pluginStatus, Js = e1.pluginURL;
            },
            isParsed: ()=>null != na.applyArabicShaping && null != na.processBidirectionalText && null != na.processStyledBidirectionalText,
            getPluginURL: ()=>Js
        };
        class oa {
            isSupportedScript(e1) {
                return function(e1, t) {
                    for (const i of e1)if (!Zs(i.charCodeAt(0), t)) return !1;
                    return !0;
                }(e1, na.isLoaded());
            }
            constructor(e1, t){
                this.zoom = e1, t ? (this.now = t.now, this.fadeDuration = t.fadeDuration, this.transition = t.transition, this.pitch = t.pitch, this.brightness = t.brightness) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
            }
        }
        class sa {
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(e1, t, i) {
                return this.property.possiblyEvaluate(this, e1, t, i);
            }
            constructor(e1, t, i){
                this.property = e1, this.value = t, this.expression = function(e1, t, i) {
                    if (fo(e1)) return new Io(e1, t);
                    if (To(e1) || Array.isArray(e1) && e1.length > 0) {
                        const r = So(e1, t, i);
                        if ("error" === r.result) throw new Error(r.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                        return r.value;
                    }
                    {
                        let i = e1;
                        return "string" == typeof e1 && "color" === t.type && (i = hi.parse(e1)), {
                            kind: "constant",
                            isConfigDependent: !1,
                            evaluate: ()=>i
                        };
                    }
                }(void 0 === t ? e1.specification.default : t, e1.specification, i);
            }
        }
        class aa {
            transitioned(e1, t) {
                return new ca(this.property, this.value, t, k({}, e1.transition, this.transition), e1.now);
            }
            untransitioned() {
                return new ca(this.property, this.value, null, {}, 0);
            }
            constructor(e1, t){
                this.property = e1, this.value = new sa(e1, void 0, t);
            }
        }
        class la {
            getValue(e1) {
                return $(this._values[e1].value.value);
            }
            setValue(e1, t) {
                this._values.hasOwnProperty(e1) || (this._values[e1] = new aa(this._values[e1].property, this._options)), this._values[e1].value = new sa(this._values[e1].property, null === t ? void 0 : $(t), this._options), this.isConfigDependent = this.isConfigDependent || this._values[e1].value.expression.isConfigDependent;
            }
            setTransitionOrValue(e1, t) {
                t && (this._options = t);
                const i = this._properties.properties;
                if (e1) for(const t in e1){
                    const r = e1[t];
                    if (G(t, "-transition")) {
                        const e1 = t.slice(0, -11);
                        i[e1] && this.setTransition(e1, r);
                    } else i[t] && this.setValue(t, r);
                }
            }
            getTransition(e1) {
                return $(this._values[e1].transition);
            }
            setTransition(e1, t) {
                this._values.hasOwnProperty(e1) || (this._values[e1] = new aa(this._values[e1].property)), this._values[e1].transition = $(t) || void 0;
            }
            serialize() {
                const e1 = {};
                for (const t of Object.keys(this._values)){
                    const i = this.getValue(t);
                    void 0 !== i && (e1[t] = i);
                    const r = this.getTransition(t);
                    void 0 !== r && (e1[`${t}-transition`] = r);
                }
                return e1;
            }
            transitioned(e1, t) {
                const i = new ha(this._properties);
                for (const r of Object.keys(this._values))i._values[r] = this._values[r].transitioned(e1, t._values[r]);
                return i;
            }
            untransitioned() {
                const e1 = new ha(this._properties);
                for (const t of Object.keys(this._values))e1._values[t] = this._values[t].untransitioned();
                return e1;
            }
            constructor(e1, t){
                this._properties = e1, this._values = Object.create(e1.defaultTransitionablePropertyValues), this._options = t, this.isConfigDependent = !1;
            }
        }
        class ca {
            possiblyEvaluate(e1, t, i) {
                const r = e1.now || 0, n = this.value.possiblyEvaluate(e1, t, i), o = this.prior;
                if (o) {
                    if (r > this.end) return this.prior = null, n;
                    if (this.value.isDataDriven()) return this.prior = null, n;
                    if (r < this.begin) return o.possiblyEvaluate(e1, t, i);
                    {
                        const s = (r - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(o.possiblyEvaluate(e1, t, i), n, M(s));
                    }
                }
                return n;
            }
            constructor(e1, t, i, r, n){
                const o = r.delay || 0, s = r.duration || 0;
                n = n || 0, this.property = e1, this.value = t, this.begin = n + o, this.end = this.begin + s, e1.specification.transition && (r.delay || r.duration) && (this.prior = i);
            }
        }
        class ha {
            possiblyEvaluate(e1, t, i) {
                const r = new pa(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].possiblyEvaluate(e1, t, i);
                return r;
            }
            hasTransition() {
                for (const e1 of Object.keys(this._values))if (this._values[e1].prior) return !0;
                return !1;
            }
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultTransitioningPropertyValues);
            }
        }
        class ua {
            getValue(e1) {
                return $(this._values[e1].value);
            }
            setValue(e1, t) {
                this._values[e1] = new sa(this._values[e1].property, null === t ? void 0 : $(t), this._options), this.isConfigDependent = this.isConfigDependent || this._values[e1].expression.isConfigDependent;
            }
            serialize() {
                const e1 = {};
                for (const t of Object.keys(this._values)){
                    const i = this.getValue(t);
                    void 0 !== i && (e1[t] = i);
                }
                return e1;
            }
            possiblyEvaluate(e1, t, i) {
                const r = new pa(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].possiblyEvaluate(e1, t, i);
                return r;
            }
            constructor(e1, t){
                this._properties = e1, this._values = Object.create(e1.defaultPropertyValues), this._options = t, this.isConfigDependent = !1;
            }
        }
        class da {
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(e1) {
                return "constant" === this.value.kind ? this.value.value : e1;
            }
            evaluate(e1, t, i, r) {
                return this.property.evaluate(this.value, this.parameters, e1, t, i, r);
            }
            constructor(e1, t, i){
                this.property = e1, this.value = t, this.parameters = i;
            }
        }
        class pa {
            get(e1) {
                return this._values[e1];
            }
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultPossiblyEvaluatedValues);
            }
        }
        class fa {
            possiblyEvaluate(e1, t) {
                return e1.expression.evaluate(t);
            }
            interpolate(e1, t, i) {
                const r = Qr[this.specification.type];
                return r ? r(e1, t, i) : e1;
            }
            constructor(e1){
                this.specification = e1;
            }
        }
        class ma {
            possiblyEvaluate(e1, t, i, r) {
                return new da(this, "constant" === e1.expression.kind || "camera" === e1.expression.kind ? {
                    kind: "constant",
                    value: e1.expression.evaluate(t, null, {}, i, r)
                } : e1.expression, t);
            }
            interpolate(e1, t, i) {
                if ("constant" !== e1.value.kind || "constant" !== t.value.kind) return e1;
                if (void 0 === e1.value.value || void 0 === t.value.value) return new da(this, {
                    kind: "constant",
                    value: void 0
                }, e1.parameters);
                const r = Qr[this.specification.type];
                return r ? new da(this, {
                    kind: "constant",
                    value: r(e1.value.value, t.value.value, i)
                }, e1.parameters) : e1;
            }
            evaluate(e1, t, i, r, n, o) {
                return "constant" === e1.kind ? e1.value : e1.evaluate(t, i, r, n, o);
            }
            constructor(e1, t){
                this.specification = e1, this.overrides = t;
            }
        }
        class _a {
            possiblyEvaluate(e1, t, i, r) {
                return !!e1.expression.evaluate(t, null, {}, i, r);
            }
            interpolate() {
                return !1;
            }
            constructor(e1){
                this.specification = e1;
            }
        }
        class ga {
            constructor(e1){
                this.properties = e1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const t = new oa(0, {});
                for(const i in e1){
                    const r = e1[i];
                    r.specification.overridable && this.overridableProperties.push(i);
                    const n = this.defaultPropertyValues[i] = new sa(r, void 0), o = this.defaultTransitionablePropertyValues[i] = new aa(r);
                    this.defaultTransitioningPropertyValues[i] = o.untransitioned(), this.defaultPossiblyEvaluatedValues[i] = n.possiblyEvaluate(t);
                }
            }
        }
        Rs(ma, "DataDrivenProperty"), Rs(fa, "DataConstantProperty"), Rs(_a, "ColorRampProperty");
        const ya = "\x1f";
        function xa(e1) {
            return e1.indexOf(ya) >= 0;
        }
        function va(e1, t) {
            return t ? `${e1}${ya}${t}` : e1;
        }
        function ba(e1) {
            const t = e1.indexOf(ya);
            return t >= 0 ? e1.slice(0, t) : e1;
        }
        const wa = "-transition";
        class Ta extends zt {
            setScope(e1) {
                this.scope = e1, this.fqid = va(this.id, e1);
            }
            getLayoutProperty(e1) {
                return "visibility" === e1 ? this.visibility : this._unevaluatedLayout.getValue(e1);
            }
            setLayoutProperty(e1, t, i = {}) {
                if (null != t && this._validate(Es, `layers.${this.id}.layout.${e1}`, e1, t, i)) return;
                if ("custom" === this.type && "visibility" === e1) return void (this.visibility = t);
                const r = this._unevaluatedLayout;
                r._properties.properties[e1] && (r.setValue(e1, t), this.isConfigDependent = this.isConfigDependent || r.isConfigDependent, "visibility" === e1 && this.possiblyEvaluateVisibility());
            }
            possiblyEvaluateVisibility() {
                this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({
                    zoom: 0
                });
            }
            getPaintProperty(e1) {
                return G(e1, wa) ? this._transitionablePaint.getTransition(e1.slice(0, -11)) : this._transitionablePaint.getValue(e1);
            }
            setPaintProperty(e1, t, i = {}) {
                if (null != t && this._validate(Ts, `layers.${this.id}.paint.${e1}`, e1, t, i)) return !1;
                const r = this._transitionablePaint, n = r._properties.properties;
                if (G(e1, wa)) {
                    const i = e1.slice(0, -11);
                    return n[i] && r.setTransition(i, t || void 0), !1;
                }
                if (!n[e1]) return !1;
                const o = r._values[e1], s = o.value.isDataDriven(), a = o.value;
                r.setValue(e1, t), this.isConfigDependent = this.isConfigDependent || r.isConfigDependent, this._handleSpecialPaintPropertyUpdate(e1);
                const l = r._values[e1].value, c = l.isDataDriven(), h = G(e1, "pattern") || "line-dasharray" === e1;
                return c || s || h || this._handleOverridablePaintPropertyUpdate(e1, a, l);
            }
            _handleSpecialPaintPropertyUpdate(e1) {}
            getProgramIds() {
                return null;
            }
            getDefaultProgramParams(e1, t) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(e1, t, i) {
                return !1;
            }
            isHidden(e1) {
                return !!(this.minzoom && e1 < this.minzoom) || !!(this.maxzoom && e1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(e1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(e1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(e1, t) {
                this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(e1, void 0, t)), this.paint = this._transitioningPaint.possiblyEvaluate(e1, void 0, t);
            }
            serialize() {
                return Z({
                    id: this.id,
                    type: this.type,
                    slot: this.slot,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                }, (e1, t)=>!(void 0 === e1 || "layout" === t && !Object.keys(e1).length || "paint" === t && !Object.keys(e1).length));
            }
            _validate(e1, t, i, r, n = {}) {
                return (!n || !1 !== n.validate) && Ss(this, e1.call(ms, {
                    key: t,
                    layerType: this.type,
                    objectKey: i,
                    value: r,
                    styleSpec: Pt,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    }
                }));
            }
            is3D() {
                return !1;
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            hasShadowPass() {
                return !1;
            }
            canCastShadows() {
                return !1;
            }
            hasLightBeamPass() {
                return !1;
            }
            cutoffRange() {
                return 0;
            }
            resize() {}
            isStateDependent() {
                for(const e1 in this.paint._values){
                    const t = this.paint.get(e1);
                    if (t instanceof da && co(t.property.specification) && ("source" === t.value.kind || "composite" === t.value.kind) && t.value.isStateDependent) return !0;
                }
                return !1;
            }
            compileFilter() {
                this._filterCompiled || (this._featureFilter = Fo(this.filter), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
            getLayerRenderingStats() {
                return this._stats;
            }
            resetLayerRenderingStats() {
                this._stats && (this._stats.numRenderedVerticesInShadowPass = 0, this._stats.numRenderedVerticesInTransparentPass = 0);
            }
            constructor(e1, t, i){
                if (super(), this.id = e1.id, this.type = e1.type, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, this.isConfigDependent = !1, "custom" !== e1.type && (this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, "background" !== e1.type && "sky" !== e1.type && "slot" !== e1.type && (this.source = e1.source, this.sourceLayer = e1["source-layer"], this.filter = e1.filter), this.options = i, e1.slot && (this.slot = e1.slot), t.layout && (this._unevaluatedLayout = new ua(t.layout, i), this.isConfigDependent = this.isConfigDependent || this._unevaluatedLayout.isConfigDependent), t.paint)) {
                    this._transitionablePaint = new la(t.paint, i);
                    for(const t in e1.paint)this.setPaintProperty(t, e1.paint[t], {
                        validate: !1
                    });
                    for(const t in e1.layout)this.setLayoutProperty(t, e1.layout[t], {
                        validate: !1
                    });
                    this.isConfigDependent = this.isConfigDependent || this._transitionablePaint.isConfigDependent, this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new pa(t.paint);
                }
            }
        }
        class Ea {
            isDirty() {
                return this._changed;
            }
            setDirty() {
                this._changed = !0;
            }
            getUpdatedSourceCaches() {
                return this._updatedSourceCaches;
            }
            updateSourceCache(e1, t) {
                this._updatedSourceCaches[e1] = t, this.setDirty();
            }
            discardSourceCacheUpdate(e1) {
                delete this._updatedSourceCaches[e1];
            }
            updateLayer(e1) {
                const t = e1.scope;
                this._updatedLayers[t] = this._updatedLayers[t] || new Set, this._updatedLayers[t].add(e1.id), this.setDirty();
            }
            removeLayer(e1) {
                const t = e1.scope;
                this._removedLayers[t] = this._removedLayers[t] || {}, this._updatedLayers[t] = this._updatedLayers[t] || new Set, this._removedLayers[t][e1.id] = e1, this._updatedLayers[t].delete(e1.id), this._updatedPaintProps.delete(e1.fqid), this.setDirty();
            }
            getRemovedLayer(e1) {
                return this._removedLayers[e1.scope] ? this._removedLayers[e1.scope][e1.id] : null;
            }
            discardLayerRemoval(e1) {
                this._removedLayers[e1.scope] && delete this._removedLayers[e1.scope][e1.id];
            }
            getLayerUpdatesByScope() {
                const e1 = {};
                for(const t in this._updatedLayers)e1[t] = e1[t] || {}, e1[t].updatedIds = Array.from(this._updatedLayers[t].values());
                for(const t in this._removedLayers)e1[t] = e1[t] || {}, e1[t].removedIds = Object.keys(this._removedLayers[t]);
                return e1;
            }
            getUpdatedPaintProperties() {
                return this._updatedPaintProps;
            }
            updatePaintProperties(e1) {
                this._updatedPaintProps.add(e1.fqid), this.setDirty();
            }
            getUpdatedImages() {
                return Array.from(this._updatedImages.values());
            }
            updateImage(e1) {
                this._updatedImages.add(e1), this.setDirty();
            }
            resetUpdatedImages() {
                this._updatedImages.clear();
            }
            reset() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages.clear();
            }
            constructor(){
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = new Set, this._updatedImages = new Set;
            }
        }
        const Ma = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class Aa {
            constructor(e1, t){
                this._structArray = e1, this._pos1 = t * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        class Sa {
            static serialize(e1, t) {
                return e1._trim(), t && (e1.isTransferred = !0, t.add(e1.arrayBuffer)), {
                    length: e1.length,
                    arrayBuffer: e1.arrayBuffer
                };
            }
            static deserialize(e1) {
                const t = Object.create(this.prototype);
                return t.arrayBuffer = e1.arrayBuffer, t.length = e1.length, t.capacity = e1.arrayBuffer.byteLength / t.bytesPerElement, t._refreshViews(), t;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(e1) {
                this.reserve(e1), this.length = e1;
            }
            reserve(e1) {
                if (e1 > this.capacity) {
                    this.capacity = Math.max(e1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const t = this.uint8;
                    this._refreshViews(), t && this.uint8.set(t);
                }
            }
            _refreshViews() {
                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
            constructor(){
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
        }
        function Ia(e1, t = 1) {
            let i = 0, r = 0;
            return {
                members: e1.map((e1)=>{
                    const n = Ma[e1.type].BYTES_PER_ELEMENT, o = i = Ca(i, Math.max(t, n)), s = e1.components || 1;
                    return r = Math.max(r, n), i += n * s, {
                        name: e1.name,
                        type: e1.type,
                        components: s,
                        offset: o
                    };
                }),
                size: Ca(i, Math.max(r, t)),
                alignment: t
            };
        }
        function Ca(e1, t) {
            return Math.ceil(e1 / t) * t;
        }
        class za extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t);
            }
            emplace(e1, t, i) {
                const r = 2 * e1;
                return this.int16[r + 0] = t, this.int16[r + 1] = i, e1;
            }
        }
        za.prototype.bytesPerElement = 4, Rs(za, "StructArrayLayout2i4");
        class Pa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t, i);
            }
            emplace(e1, t, i, r) {
                const n = 3 * e1;
                return this.int16[n + 0] = t, this.int16[n + 1] = i, this.int16[n + 2] = r, e1;
            }
        }
        Pa.prototype.bytesPerElement = 6, Rs(Pa, "StructArrayLayout3i6");
        class Da extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, i, r);
            }
            emplace(e1, t, i, r, n) {
                const o = 4 * e1;
                return this.int16[o + 0] = t, this.int16[o + 1] = i, this.int16[o + 2] = r, this.int16[o + 3] = n, e1;
            }
        }
        Da.prototype.bytesPerElement = 8, Rs(Da, "StructArrayLayout4i8");
        class Ra extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, i, r, n);
            }
            emplace(e1, t, i, r, n, o) {
                const s = 5 * e1;
                return this.int16[s + 0] = t, this.int16[s + 1] = i, this.int16[s + 2] = r, this.int16[s + 3] = n, this.int16[s + 4] = o, e1;
            }
        }
        Ra.prototype.bytesPerElement = 10, Rs(Ra, "StructArrayLayout5i10");
        class La extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t, i, r, n, o, s);
            }
            emplace(e1, t, i, r, n, o, s, a) {
                const l = 6 * e1, c = 12 * e1, h = 3 * e1;
                return this.int16[l + 0] = t, this.int16[l + 1] = i, this.uint8[c + 4] = r, this.uint8[c + 5] = n, this.uint8[c + 6] = o, this.uint8[c + 7] = s, this.float32[h + 2] = a, e1;
            }
        }
        La.prototype.bytesPerElement = 12, Rs(La, "StructArrayLayout2i4ub1f12");
        class ka extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, i, r);
            }
            emplace(e1, t, i, r, n) {
                const o = 4 * e1;
                return this.float32[o + 0] = t, this.float32[o + 1] = i, this.float32[o + 2] = r, this.float32[o + 3] = n, e1;
            }
        }
        ka.prototype.bytesPerElement = 16, Rs(ka, "StructArrayLayout4f16");
        class Oa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, i, r, n);
            }
            emplace(e1, t, i, r, n, o) {
                const s = 6 * e1, a = 3 * e1;
                return this.uint16[s + 0] = t, this.uint16[s + 1] = i, this.uint16[s + 2] = r, this.uint16[s + 3] = n, this.float32[a + 2] = o, e1;
            }
        }
        Oa.prototype.bytesPerElement = 12, Rs(Oa, "StructArrayLayout4ui1f12");
        class Ba extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, i, r);
            }
            emplace(e1, t, i, r, n) {
                const o = 4 * e1;
                return this.uint16[o + 0] = t, this.uint16[o + 1] = i, this.uint16[o + 2] = r, this.uint16[o + 3] = n, e1;
            }
        }
        Ba.prototype.bytesPerElement = 8, Rs(Ba, "StructArrayLayout4ui8");
        class Fa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t, i, r, n, o);
            }
            emplace(e1, t, i, r, n, o, s) {
                const a = 6 * e1;
                return this.int16[a + 0] = t, this.int16[a + 1] = i, this.int16[a + 2] = r, this.int16[a + 3] = n, this.int16[a + 4] = o, this.int16[a + 5] = s, e1;
            }
        }
        Fa.prototype.bytesPerElement = 12, Rs(Fa, "StructArrayLayout6i12");
        class Na extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s, a, l, c, h, u) {
                const d = this.length;
                return this.resize(d + 1), this.emplace(d, e1, t, i, r, n, o, s, a, l, c, h, u);
            }
            emplace(e1, t, i, r, n, o, s, a, l, c, h, u, d) {
                const p = 12 * e1;
                return this.int16[p + 0] = t, this.int16[p + 1] = i, this.int16[p + 2] = r, this.int16[p + 3] = n, this.uint16[p + 4] = o, this.uint16[p + 5] = s, this.uint16[p + 6] = a, this.uint16[p + 7] = l, this.int16[p + 8] = c, this.int16[p + 9] = h, this.int16[p + 10] = u, this.int16[p + 11] = d, e1;
            }
        }
        Na.prototype.bytesPerElement = 24, Rs(Na, "StructArrayLayout4i4ui4i24");
        class Ua extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t, i, r, n, o);
            }
            emplace(e1, t, i, r, n, o, s) {
                const a = 10 * e1, l = 5 * e1;
                return this.int16[a + 0] = t, this.int16[a + 1] = i, this.int16[a + 2] = r, this.float32[l + 2] = n, this.float32[l + 3] = o, this.float32[l + 4] = s, e1;
            }
        }
        Ua.prototype.bytesPerElement = 20, Rs(Ua, "StructArrayLayout3i3f20");
        class Va extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.uint32[1 * e1 + 0] = t, e1;
            }
        }
        Va.prototype.bytesPerElement = 4, Rs(Va, "StructArrayLayout1ul4");
        class ja extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t);
            }
            emplace(e1, t, i) {
                const r = 2 * e1;
                return this.uint16[r + 0] = t, this.uint16[r + 1] = i, e1;
            }
        }
        ja.prototype.bytesPerElement = 4, Rs(ja, "StructArrayLayout2ui4");
        class Ga extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s, a, l, c, h, u, d) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, e1, t, i, r, n, o, s, a, l, c, h, u, d);
            }
            emplace(e1, t, i, r, n, o, s, a, l, c, h, u, d, p) {
                const f = 20 * e1, m = 10 * e1;
                return this.int16[f + 0] = t, this.int16[f + 1] = i, this.int16[f + 2] = r, this.int16[f + 3] = n, this.int16[f + 4] = o, this.float32[m + 3] = s, this.float32[m + 4] = a, this.float32[m + 5] = l, this.float32[m + 6] = c, this.int16[f + 14] = h, this.uint32[m + 8] = u, this.uint16[f + 18] = d, this.uint16[f + 19] = p, e1;
            }
        }
        Ga.prototype.bytesPerElement = 40, Rs(Ga, "StructArrayLayout5i4f1i1ul2ui40");
        class qa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t, i, r, n, o, s);
            }
            emplace(e1, t, i, r, n, o, s, a) {
                const l = 8 * e1;
                return this.int16[l + 0] = t, this.int16[l + 1] = i, this.int16[l + 2] = r, this.int16[l + 4] = n, this.int16[l + 5] = o, this.int16[l + 6] = s, this.int16[l + 7] = a, e1;
            }
        }
        qa.prototype.bytesPerElement = 16, Rs(qa, "StructArrayLayout3i2i2i16");
        class Za extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, i, r, n);
            }
            emplace(e1, t, i, r, n, o) {
                const s = 4 * e1, a = 8 * e1;
                return this.float32[s + 0] = t, this.float32[s + 1] = i, this.float32[s + 2] = r, this.int16[a + 6] = n, this.int16[a + 7] = o, e1;
            }
        }
        Za.prototype.bytesPerElement = 16, Rs(Za, "StructArrayLayout2f1f2i16");
        class $a extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, i, r);
            }
            emplace(e1, t, i, r, n) {
                const o = 12 * e1, s = 3 * e1;
                return this.uint8[o + 0] = t, this.uint8[o + 1] = i, this.float32[s + 1] = r, this.float32[s + 2] = n, e1;
            }
        }
        $a.prototype.bytesPerElement = 12, Rs($a, "StructArrayLayout2ub2f12");
        class Wa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t, i);
            }
            emplace(e1, t, i, r) {
                const n = 3 * e1;
                return this.uint16[n + 0] = t, this.uint16[n + 1] = i, this.uint16[n + 2] = r, e1;
            }
        }
        Wa.prototype.bytesPerElement = 6, Rs(Wa, "StructArrayLayout3ui6");
        class Ha extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v) {
                const b = this.length;
                return this.resize(b + 1), this.emplace(b, e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v);
            }
            emplace(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b) {
                const w = 30 * e1, T = 15 * e1, E = 60 * e1;
                return this.int16[w + 0] = t, this.int16[w + 1] = i, this.int16[w + 2] = r, this.float32[T + 2] = n, this.float32[T + 3] = o, this.uint16[w + 8] = s, this.uint16[w + 9] = a, this.uint32[T + 5] = l, this.uint32[T + 6] = c, this.uint32[T + 7] = h, this.uint16[w + 16] = u, this.uint16[w + 17] = d, this.uint16[w + 18] = p, this.float32[T + 10] = f, this.float32[T + 11] = m, this.uint8[E + 48] = _, this.uint8[E + 49] = g, this.uint8[E + 50] = y, this.uint32[T + 13] = x, this.int16[w + 28] = v, this.uint8[E + 58] = b, e1;
            }
        }
        Ha.prototype.bytesPerElement = 60, Rs(Ha, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class Xa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b, w, T, E, M, A, S, I, C, z, P) {
                const D = this.length;
                return this.resize(D + 1), this.emplace(D, e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b, w, T, E, M, A, S, I, C, z, P);
            }
            emplace(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b, w, T, E, M, A, S, I, C, z, P, D) {
                const R = 20 * e1, L = 40 * e1, k = 80 * e1;
                return this.float32[R + 0] = t, this.float32[R + 1] = i, this.int16[L + 4] = r, this.int16[L + 5] = n, this.int16[L + 6] = o, this.int16[L + 7] = s, this.int16[L + 8] = a, this.int16[L + 9] = l, this.int16[L + 10] = c, this.int16[L + 11] = h, this.int16[L + 12] = u, this.uint16[L + 13] = d, this.uint16[L + 14] = p, this.uint16[L + 15] = f, this.uint16[L + 16] = m, this.uint16[L + 17] = _, this.uint16[L + 18] = g, this.uint16[L + 19] = y, this.uint16[L + 20] = x, this.uint16[L + 21] = v, this.uint16[L + 22] = b, this.uint16[L + 23] = w, this.uint16[L + 24] = T, this.uint16[L + 25] = E, this.uint16[L + 26] = M, this.uint16[L + 27] = A, this.uint32[R + 14] = S, this.float32[R + 15] = I, this.float32[R + 16] = C, this.float32[R + 17] = z, this.float32[R + 18] = P, this.uint8[k + 76] = D, e1;
            }
        }
        Xa.prototype.bytesPerElement = 80, Rs(Xa, "StructArrayLayout2f9i15ui1ul4f1ub80");
        class Ya extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.float32[1 * e1 + 0] = t, e1;
            }
        }
        Ya.prototype.bytesPerElement = 4, Rs(Ya, "StructArrayLayout1f4");
        class Ka extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t, i, r, n);
            }
            emplace(e1, t, i, r, n, o) {
                const s = 5 * e1;
                return this.float32[s + 0] = t, this.float32[s + 1] = i, this.float32[s + 2] = r, this.float32[s + 3] = n, this.float32[s + 4] = o, e1;
            }
        }
        Ka.prototype.bytesPerElement = 20, Rs(Ka, "StructArrayLayout5f20");
        class Ja extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t, i, r, n, o, s);
            }
            emplace(e1, t, i, r, n, o, s, a) {
                const l = 7 * e1;
                return this.float32[l + 0] = t, this.float32[l + 1] = i, this.float32[l + 2] = r, this.float32[l + 3] = n, this.float32[l + 4] = o, this.float32[l + 5] = s, this.float32[l + 6] = a, e1;
            }
        }
        Ja.prototype.bytesPerElement = 28, Rs(Ja, "StructArrayLayout7f28");
        class Qa extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t, i, r);
            }
            emplace(e1, t, i, r, n) {
                const o = 6 * e1;
                return this.uint32[3 * e1 + 0] = t, this.uint16[o + 2] = i, this.uint16[o + 3] = r, this.uint16[o + 4] = n, e1;
            }
        }
        Qa.prototype.bytesPerElement = 12, Rs(Qa, "StructArrayLayout1ul3ui12");
        class el extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.uint16[1 * e1 + 0] = t, e1;
            }
        }
        el.prototype.bytesPerElement = 2, Rs(el, "StructArrayLayout1ui2");
        class tl extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t, i);
            }
            emplace(e1, t, i, r) {
                const n = 3 * e1;
                return this.float32[n + 0] = t, this.float32[n + 1] = i, this.float32[n + 2] = r, e1;
            }
        }
        tl.prototype.bytesPerElement = 12, Rs(tl, "StructArrayLayout3f12");
        class il extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t);
            }
            emplace(e1, t, i) {
                const r = 2 * e1;
                return this.float32[r + 0] = t, this.float32[r + 1] = i, e1;
            }
        }
        il.prototype.bytesPerElement = 8, Rs(il, "StructArrayLayout2f8");
        class rl extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m) {
                const _ = this.length;
                return this.resize(_ + 1), this.emplace(_, e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m);
            }
            emplace(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _) {
                const g = 16 * e1;
                return this.float32[g + 0] = t, this.float32[g + 1] = i, this.float32[g + 2] = r, this.float32[g + 3] = n, this.float32[g + 4] = o, this.float32[g + 5] = s, this.float32[g + 6] = a, this.float32[g + 7] = l, this.float32[g + 8] = c, this.float32[g + 9] = h, this.float32[g + 10] = u, this.float32[g + 11] = d, this.float32[g + 12] = p, this.float32[g + 13] = f, this.float32[g + 14] = m, this.float32[g + 15] = _, e1;
            }
        }
        rl.prototype.bytesPerElement = 64, Rs(rl, "StructArrayLayout16f64");
        class nl extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t, i, r, n, o, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t, i, r, n, o, s);
            }
            emplace(e1, t, i, r, n, o, s, a) {
                const l = 10 * e1, c = 5 * e1;
                return this.uint16[l + 0] = t, this.uint16[l + 1] = i, this.uint16[l + 2] = r, this.uint16[l + 3] = n, this.float32[c + 2] = o, this.float32[c + 3] = s, this.float32[c + 4] = a, e1;
            }
        }
        nl.prototype.bytesPerElement = 20, Rs(nl, "StructArrayLayout4ui3f20");
        class ol extends Sa {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t = this.length;
                return this.resize(t + 1), this.emplace(t, e1);
            }
            emplace(e1, t) {
                return this.uint8[1 * e1 + 0] = t, e1;
            }
        }
        ol.prototype.bytesPerElement = 1, Rs(ol, "StructArrayLayout1ub1");
        class sl extends Aa {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        sl.prototype.size = 40;
        class al extends Ga {
            get(e1) {
                return new sl(this, e1);
            }
        }
        Rs(al, "CollisionBoxArray");
        class ll extends Aa {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(e1) {
                this._structArray.uint8[this._pos1 + 49] = e1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(e1) {
                this._structArray.uint8[this._pos1 + 50] = e1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 13] = e1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(e1) {
                this._structArray.uint8[this._pos1 + 58] = e1;
            }
        }
        ll.prototype.size = 60;
        class cl extends Ha {
            get(e1) {
                return new ll(this, e1);
            }
        }
        Rs(cl, "PlacedSymbolArray");
        class hl extends Aa {
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 0];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 14];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 14] = e1;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get zOffset() {
                return this._structArray.float32[this._pos4 + 18];
            }
            set zOffset(e1) {
                this._structArray.float32[this._pos4 + 18] = e1;
            }
            get hasIconTextFit() {
                return this._structArray.uint8[this._pos1 + 76];
            }
        }
        hl.prototype.size = 80;
        class ul extends Xa {
            get(e1) {
                return new hl(this, e1);
            }
        }
        Rs(ul, "SymbolInstanceArray");
        class dl extends Ya {
            getoffsetX(e1) {
                return this.float32[1 * e1 + 0];
            }
        }
        Rs(dl, "GlyphOffsetArray");
        class pl extends za {
            getx(e1) {
                return this.int16[2 * e1 + 0];
            }
            gety(e1) {
                return this.int16[2 * e1 + 1];
            }
        }
        Rs(pl, "SymbolLineVertexArray");
        class fl extends Aa {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        fl.prototype.size = 12;
        class ml extends Qa {
            get(e1) {
                return new fl(this, e1);
            }
        }
        Rs(ml, "FeatureIndexArray");
        class _l extends ja {
            geta_centroid_pos0(e1) {
                return this.uint16[2 * e1 + 0];
            }
            geta_centroid_pos1(e1) {
                return this.uint16[2 * e1 + 1];
            }
        }
        Rs(_l, "FillExtrusionCentroidArray");
        const gl = Ia([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), yl = Ia([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class xl {
            _prepareSegment(e1, t, i, r) {
                let n = this.segments[this.segments.length - 1];
                return e1 > xl.MAX_VERTEX_ARRAY_LENGTH && H(`Max vertices per segment is ${xl.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${e1}`), (!n || n.vertexLength + e1 > xl.MAX_VERTEX_ARRAY_LENGTH || n.sortKey !== r) && (n = {
                    vertexOffset: t,
                    primitiveOffset: i,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== r && (n.sortKey = r), this.segments.push(n)), n;
            }
            prepareSegment(e1, t, i, r) {
                return this._prepareSegment(e1, t.length, i.length, r);
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const e1 of this.segments)for(const t in e1.vaos)e1.vaos[t].destroy();
            }
            static simpleSegment(e1, t, i, r) {
                return new xl([
                    {
                        vertexOffset: e1,
                        primitiveOffset: t,
                        vertexLength: i,
                        primitiveLength: r,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
            constructor(e1 = []){
                this.segments = e1;
            }
        }
        function vl(e1, t) {
            return 256 * (e1 = z(Math.floor(e1), 0, 255)) + z(Math.floor(t), 0, 255);
        }
        xl.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Rs(xl, "SegmentVector");
        const bl = Ia([
            {
                name: "a_pattern",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio",
                components: 1,
                type: "Float32"
            }
        ]), wl = Ia([
            {
                name: "a_dash",
                components: 4,
                type: "Uint16"
            }
        ]);
        var Tl = {
            exports: {}
        }, El = {
            exports: {}
        };
        !function(e1) {
            e1.exports = function(e1, t) {
                var i, r, n, o, s, a, l, c;
                for(r = e1.length - (i = 3 & e1.length), n = t, s = 3432918353, a = 461845907, c = 0; c < r;)l = 255 & e1.charCodeAt(c) | (255 & e1.charCodeAt(++c)) << 8 | (255 & e1.charCodeAt(++c)) << 16 | (255 & e1.charCodeAt(++c)) << 24, ++c, n = 27492 + (65535 & (o = 5 * (65535 & (n = (n ^= l = (65535 & (l = (l = (65535 & l) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 13 | n >>> 19)) + ((5 * (n >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (o >>> 16) & 65535) << 16);
                switch(l = 0, i){
                    case 3:
                        l ^= (255 & e1.charCodeAt(c + 2)) << 16;
                    case 2:
                        l ^= (255 & e1.charCodeAt(c + 1)) << 8;
                    case 1:
                        n ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & e1.charCodeAt(c))) * s + (((l >>> 16) * s & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295;
                }
                return n ^= e1.length, n = 2246822507 * (65535 & (n ^= n >>> 16)) + ((2246822507 * (n >>> 16) & 65535) << 16) & 4294967295, n = 3266489909 * (65535 & (n ^= n >>> 13)) + ((3266489909 * (n >>> 16) & 65535) << 16) & 4294967295, (n ^= n >>> 16) >>> 0;
            };
        }(El);
        var Ml = El.exports, Al = {
            exports: {}
        };
        !function(e1) {
            e1.exports = function(e1, t) {
                for(var i, r = e1.length, n = t ^ r, o = 0; r >= 4;)i = 1540483477 * (65535 & (i = 255 & e1.charCodeAt(o) | (255 & e1.charCodeAt(++o)) << 8 | (255 & e1.charCodeAt(++o)) << 16 | (255 & e1.charCodeAt(++o)) << 24)) + ((1540483477 * (i >>> 16) & 65535) << 16), n = 1540483477 * (65535 & n) + ((1540483477 * (n >>> 16) & 65535) << 16) ^ (i = 1540483477 * (65535 & (i ^= i >>> 24)) + ((1540483477 * (i >>> 16) & 65535) << 16)), r -= 4, ++o;
                switch(r){
                    case 3:
                        n ^= (255 & e1.charCodeAt(o + 2)) << 16;
                    case 2:
                        n ^= (255 & e1.charCodeAt(o + 1)) << 8;
                    case 1:
                        n = 1540483477 * (65535 & (n ^= 255 & e1.charCodeAt(o))) + ((1540483477 * (n >>> 16) & 65535) << 16);
                }
                return n = 1540483477 * (65535 & (n ^= n >>> 13)) + ((1540483477 * (n >>> 16) & 65535) << 16), (n ^= n >>> 15) >>> 0;
            };
        }(Al);
        var Sl = Ml, Il = Al.exports;
        Tl.exports = Sl, Tl.exports.murmur3 = Sl, Tl.exports.murmur2 = Il;
        var Cl = d(Tl.exports);
        class zl {
            add(e1, t, i, r) {
                this.ids.push(Pl(e1)), this.positions.push(t, i, r);
            }
            eachPosition(e1, t) {
                const i = Pl(e1);
                let r = 0, n = this.ids.length - 1;
                for(; r < n;){
                    const e1 = r + n >> 1;
                    this.ids[e1] >= i ? n = e1 : r = e1 + 1;
                }
                for(; this.ids[r] === i;)t(this.positions[3 * r], this.positions[3 * r + 1], this.positions[3 * r + 2]), r++;
            }
            static serialize(e1, t) {
                const i = new Float64Array(e1.ids), r = new Uint32Array(e1.positions);
                return Dl(i, r, 0, i.length - 1), t && (t.add(i.buffer), t.add(r.buffer)), {
                    ids: i,
                    positions: r
                };
            }
            static deserialize(e1) {
                const t = new zl;
                let i;
                t.ids = e1.ids, t.positions = e1.positions;
                for (const e1 of t.ids)e1 !== i && t.uniqueIds.push(e1), i = e1;
                return t.indexed = !0, t;
            }
            constructor(){
                this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
            }
        }
        function Pl(e1) {
            const t = +e1;
            return !isNaN(t) && Number.MIN_SAFE_INTEGER <= t && t <= Number.MAX_SAFE_INTEGER ? t : Cl(String(e1));
        }
        function Dl(e1, t, i, r) {
            for(; i < r;){
                const n = e1[i + r >> 1];
                let o = i - 1, s = r + 1;
                for(;;){
                    do o++;
                    while (e1[o] < n);
                    do s--;
                    while (e1[s] > n);
                    if (o >= s) break;
                    Rl(e1, o, s), Rl(t, 3 * o, 3 * s), Rl(t, 3 * o + 1, 3 * s + 1), Rl(t, 3 * o + 2, 3 * s + 2);
                }
                s - i < r - s ? (Dl(e1, t, i, s), i = s + 1) : (Dl(e1, t, s + 1, r), r = s);
            }
        }
        function Rl(e1, t, i) {
            const r = e1[t];
            e1[t] = e1[i], e1[i] = r;
        }
        Rs(zl, "FeaturePositionMap");
        class Ll {
            fetchUniformLocation(e1, t) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(e1, t), this.initialized = !0), !!this.location;
            }
            constructor(e1){
                this.gl = e1.gl, this.initialized = !1;
            }
        }
        class kl extends Ll {
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && this.current !== i && (this.current = i, this.gl.uniform1i(this.location, i));
            }
            constructor(e1){
                super(e1), this.current = 0;
            }
        }
        class Ol extends Ll {
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && this.current !== i && (this.current = i, this.gl.uniform1f(this.location, i));
            }
            constructor(e1){
                super(e1), this.current = 0;
            }
        }
        class Bl extends Ll {
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && (i[0] === this.current[0] && i[1] === this.current[1] || (this.current = i, this.gl.uniform2f(this.location, i[0], i[1])));
            }
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0
                ];
            }
        }
        class Fl extends Ll {
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && (i[0] === this.current[0] && i[1] === this.current[1] && i[2] === this.current[2] || (this.current = i, this.gl.uniform3f(this.location, i[0], i[1], i[2])));
            }
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0
                ];
            }
        }
        class Nl extends Ll {
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && (i[0] === this.current[0] && i[1] === this.current[1] && i[2] === this.current[2] && i[3] === this.current[3] || (this.current = i, this.gl.uniform4f(this.location, i[0], i[1], i[2], i[3])));
            }
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
        }
        class Ul extends Ll {
            set(e1, t, i) {
                this.fetchUniformLocation(e1, t) && (i.r === this.current.r && i.g === this.current.g && i.b === this.current.b && i.a === this.current.a || (this.current = i, this.gl.uniform4f(this.location, i.r, i.g, i.b, i.a)));
            }
            constructor(e1){
                super(e1), this.current = hi.transparent;
            }
        }
        const Vl = new Float32Array(16);
        class jl extends Ll {
            set(e1, t, i) {
                if (this.fetchUniformLocation(e1, t)) {
                    if (i[12] !== this.current[12] || i[0] !== this.current[0]) return this.current = i, void this.gl.uniformMatrix4fv(this.location, !1, i);
                    for(let e1 = 1; e1 < 16; e1++)if (i[e1] !== this.current[e1]) {
                        this.current = i, this.gl.uniformMatrix4fv(this.location, !1, i);
                        break;
                    }
                }
            }
            constructor(e1){
                super(e1), this.current = Vl;
            }
        }
        const Gl = new Float32Array(9);
        class ql extends Ll {
            set(e1, t, i) {
                if (this.fetchUniformLocation(e1, t)) {
                    for(let e1 = 0; e1 < 9; e1++)if (i[e1] !== this.current[e1]) {
                        this.current = i, this.gl.uniformMatrix3fv(this.location, !1, i);
                        break;
                    }
                }
            }
            constructor(e1){
                super(e1), this.current = Gl;
            }
        }
        const Zl = new Float32Array(4);
        class $l extends Ll {
            set(e1, t, i) {
                if (this.fetchUniformLocation(e1, t)) {
                    for(let e1 = 0; e1 < 4; e1++)if (i[e1] !== this.current[e1]) {
                        this.current = i, this.gl.uniformMatrix2fv(this.location, !1, i);
                        break;
                    }
                }
            }
            constructor(e1){
                super(e1), this.current = Zl;
            }
        }
        function Wl(e1) {
            return [
                vl(255 * e1.r, 255 * e1.g),
                vl(255 * e1.b, 255 * e1.a)
            ];
        }
        class Hl {
            setUniform(e1, t, i, r, n) {
                t.set(e1, n, r.constantOr(this.value));
            }
            getBinding(e1, t) {
                return "color" === this.type ? new Ul(e1) : new Ol(e1);
            }
            constructor(e1, t, i){
                this.value = e1, this.uniformNames = t.map((e1)=>`u_${e1}`), this.type = i;
            }
        }
        class Xl {
            setConstantPatternPositions(e1) {
                this.pixelRatio = e1.pixelRatio || 1, this.pattern = e1.tl.concat(e1.br);
            }
            setUniform(e1, t, i, r, n) {
                const o = "u_pattern" === n || "u_dash" === n ? this.pattern : "u_pixel_ratio" === n ? this.pixelRatio : null;
                o && t.set(e1, n, o);
            }
            getBinding(e1, t) {
                return "u_pattern" === t || "u_dash" === t ? new Nl(e1) : new Ol(e1);
            }
            constructor(e1, t){
                this.uniformNames = t.map((e1)=>`u_${e1}`), this.pattern = null, this.pixelRatio = 1;
            }
        }
        class Yl {
            populatePaintArray(e1, t, i, r, n, o, s) {
                const a = this.paintVertexArray.length, l = this.expression.evaluate(new oa(0, {
                    brightness: o
                }), t, {}, n, r, s);
                this.paintVertexArray.resize(e1), this._setPaintValue(a, e1, l);
            }
            updatePaintArray(e1, t, i, r, n, o, s) {
                const a = this.expression.evaluate({
                    zoom: 0,
                    brightness: s
                }, i, r, void 0, n);
                this._setPaintValue(e1, t, a);
            }
            _setPaintValue(e1, t, i) {
                if ("color" === this.type) {
                    const r = Wl(i);
                    for(let i = e1; i < t; i++)this.paintVertexArray.emplace(i, r[0], r[1]);
                } else {
                    for(let r = e1; r < t; r++)this.paintVertexArray.emplace(r, i);
                    this.maxValue = Math.max(this.maxValue, Math.abs(i));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            constructor(e1, t, i, r){
                this.expression = e1, this.type = i, this.maxValue = 0, this.paintVertexAttributes = t.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === i ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new r;
            }
        }
        class Kl {
            populatePaintArray(e1, t, i, r, n, o, s) {
                const a = this.expression.evaluate(new oa(this.zoom, {
                    brightness: o
                }), t, {}, n, r, s), l = this.expression.evaluate(new oa(this.zoom + 1, {
                    brightness: o
                }), t, {}, n, r, s), c = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValue(c, e1, a, l);
            }
            updatePaintArray(e1, t, i, r, n, o, s) {
                const a = this.expression.evaluate({
                    zoom: this.zoom,
                    brightness: s
                }, i, r, void 0, n), l = this.expression.evaluate({
                    zoom: this.zoom + 1,
                    brightness: s
                }, i, r, void 0, n);
                this._setPaintValue(e1, t, a, l);
            }
            _setPaintValue(e1, t, i, r) {
                if ("color" === this.type) {
                    const n = Wl(i), o = Wl(r);
                    for(let i = e1; i < t; i++)this.paintVertexArray.emplace(i, n[0], n[1], o[0], o[1]);
                } else {
                    for(let n = e1; n < t; n++)this.paintVertexArray.emplace(n, i, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(i), Math.abs(r));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(e1, t, i, r, n) {
                const o = this.useIntegerZoom ? Math.floor(i.zoom) : i.zoom, s = z(this.expression.interpolationFactor(o, this.zoom, this.zoom + 1), 0, 1);
                t.set(e1, n, s);
            }
            getBinding(e1, t) {
                return new Ol(e1);
            }
            constructor(e1, t, i, r, n, o){
                this.expression = e1, this.uniformNames = t.map((e1)=>`u_${e1}_t`), this.type = i, this.useIntegerZoom = r, this.zoom = n, this.maxValue = 0, this.paintVertexAttributes = t.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === i ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new o;
            }
        }
        class Jl {
            populatePaintArray(e1, t, i) {
                const r = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValues(r, e1, t.patterns && t.patterns[this.layerId], i);
            }
            updatePaintArray(e1, t, i, r, n, o, s) {
                this._setPaintValues(e1, t, i.patterns && i.patterns[this.layerId], o);
            }
            _setPaintValues(e1, t, i, r) {
                if (!r || !i) return;
                const n = r[i];
                if (!n) return;
                const { tl: o, br: s, pixelRatio: a } = n;
                for(let i = e1; i < t; i++)this.paintVertexArray.emplace(i, o[0], o[1], s[0], s[1], a);
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            constructor(e1, t, i, r, n){
                this.expression = e1, this.layerId = n, this.paintVertexAttributes = ("array" === i ? wl : bl).members;
                for(let e1 = 0; e1 < t.length; ++e1);
                this.paintVertexArray = new r;
            }
        }
        class Ql {
            getMaxValue(e1) {
                const t = this.binders[e1];
                return t instanceof Yl || t instanceof Kl ? t.maxValue : 0;
            }
            populatePaintArrays(e1, t, i, r, n, o, s) {
                for(const a in this.binders){
                    const l = this.binders[a];
                    (l instanceof Yl || l instanceof Kl || l instanceof Jl) && l.populatePaintArray(e1, t, i, r, n, o, s);
                }
            }
            setConstantPatternPositions(e1) {
                for(const t in this.binders){
                    const i = this.binders[t];
                    i instanceof Xl && i.setConstantPatternPositions(e1);
                }
            }
            updatePaintArrays(e1, t, i, r, n, o, s, a) {
                let l = !1;
                const c = Object.keys(e1), h = 0 !== c.length, u = h ? c : t.uniqueIds;
                for(const c in this.binders){
                    const d = this.binders[c];
                    if ((d instanceof Yl || d instanceof Kl || d instanceof Jl) && (!0 === d.expression.isStateDependent || !1 === d.expression.isLightConstant)) {
                        const p = n.paint.get(c);
                        d.expression = p.value;
                        for (const i of u){
                            const n = e1[i.toString()];
                            t.eachPosition(i, (e1, t, i)=>{
                                const l = r.feature(e1);
                                d.updatePaintArray(t, i, l, n, o, s, a);
                            });
                        }
                        if (!h) for (const t of i.uniqueIds){
                            const n = e1[t.toString()];
                            i.eachPosition(t, (e1, t, i)=>{
                                const l = r.feature(e1);
                                d.updatePaintArray(t, i, l, n, o, s, a);
                            });
                        }
                        l = !0;
                    }
                }
                return l;
            }
            defines() {
                const e1 = [];
                for(const t in this.binders){
                    const i = this.binders[t];
                    (i instanceof Hl || i instanceof Xl) && e1.push(...i.uniformNames.map((e1)=>`#define HAS_UNIFORM_${e1}`));
                }
                return e1;
            }
            getBinderAttributes() {
                const e1 = [];
                for(const t in this.binders){
                    const i = this.binders[t];
                    if (i instanceof Yl || i instanceof Kl || i instanceof Jl) for(let t = 0; t < i.paintVertexAttributes.length; t++)e1.push(i.paintVertexAttributes[t].name);
                }
                return e1;
            }
            getBinderUniforms() {
                const e1 = [];
                for(const t in this.binders){
                    const i = this.binders[t];
                    if (i instanceof Hl || i instanceof Xl || i instanceof Kl) for (const t of i.uniformNames)e1.push(t);
                }
                return e1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(e1) {
                const t = [];
                for(const i in this.binders){
                    const r = this.binders[i];
                    if (r instanceof Hl || r instanceof Xl || r instanceof Kl) for (const n of r.uniformNames)t.push({
                        name: n,
                        property: i,
                        binding: r.getBinding(e1, n)
                    });
                }
                return t;
            }
            setUniforms(e1, t, i, r, n) {
                for (const { name: t, property: o, binding: s } of i)this.binders[o].setUniform(e1, s, n, r.get(o), t);
            }
            updatePaintBuffers() {
                this._buffers = [];
                for(const e1 in this.binders){
                    const t = this.binders[e1];
                    (t instanceof Yl || t instanceof Kl || t instanceof Jl) && t.paintVertexBuffer && this._buffers.push(t.paintVertexBuffer);
                }
            }
            upload(e1) {
                for(const t in this.binders){
                    const i = this.binders[t];
                    (i instanceof Yl || i instanceof Kl || i instanceof Jl) && i.upload(e1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const e1 in this.binders){
                    const t = this.binders[e1];
                    (t instanceof Yl || t instanceof Kl || t instanceof Jl) && t.destroy();
                }
            }
            constructor(e1, t, i = ()=>!0){
                this.binders = {}, this._buffers = [];
                const r = [];
                for(const n in e1.paint._values){
                    const o = e1.paint.get(n);
                    if (!i(n)) continue;
                    if (!(o instanceof da && co(o.property.specification))) continue;
                    const s = ic(n, e1.type), a = o.value, l = o.property.specification.type, c = !!o.property.useIntegerZoom, h = "line-dasharray" === n || n.endsWith("pattern"), u = "line-dasharray" === n && "constant" !== e1.layout.get("line-cap").value.kind;
                    if ("constant" !== a.kind || u) {
                        if ("source" === a.kind || u || h) {
                            const t = oc(n, l, "source");
                            this.binders[n] = h ? new Jl(a, s, l, t, e1.id) : new Yl(a, s, l, t), r.push(`/a_${n}`);
                        } else {
                            const e1 = oc(n, l, "composite");
                            this.binders[n] = new Kl(a, s, l, c, t, e1), r.push(`/z_${n}`);
                        }
                    } else this.binders[n] = h ? new Xl(a.value, s) : new Hl(a.value, s, l), r.push(`/u_${n}`);
                }
                this.cacheKey = r.sort().join("");
            }
        }
        class ec {
            populatePaintArrays(e1, t, i, r, n, o, s, a) {
                for(const i in this.programConfigurations)this.programConfigurations[i].populatePaintArrays(e1, t, r, n, o, s, a);
                void 0 !== t.id ? this._featureMap.add(t.id, i, this._bufferOffset, e1) : (this._featureMapWithoutIds.add(this._idlessCounter, i, this._bufferOffset, e1), this._idlessCounter += 1), this._bufferOffset = e1, this.needsUpload = !0;
            }
            updatePaintArrays(e1, t, i, r, n, o) {
                for (const s of i)this.needsUpload = this.programConfigurations[s.id].updatePaintArrays(e1, this._featureMap, this._featureMapWithoutIds, t, s, r, n, o || 0) || this.needsUpload;
            }
            get(e1) {
                return this.programConfigurations[e1];
            }
            upload(e1) {
                if (this.needsUpload) {
                    for(const t in this.programConfigurations)this.programConfigurations[t].upload(e1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const e1 in this.programConfigurations)this.programConfigurations[e1].destroy();
            }
            constructor(e1, t, i = ()=>!0){
                this.programConfigurations = {};
                for (const r of e1)this.programConfigurations[r.id] = new Ql(r, t, i);
                this.needsUpload = !1, this._featureMap = new zl, this._featureMapWithoutIds = new zl, this._bufferOffset = 0, this._idlessCounter = 0;
            }
        }
        const tc = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-emissive-strength": [
                "emissive_strength"
            ],
            "icon-emissive-strength": [
                "emissive_strength"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "fill-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "fill-extrusion-pattern": [
                "pattern",
                "pixel_ratio"
            ],
            "line-dasharray": [
                "dash"
            ]
        };
        function ic(e1, t) {
            return tc[e1] || [
                e1.replace(`${t}-`, "").replace(/-/g, "_")
            ];
        }
        const rc = {
            "line-pattern": {
                source: Oa,
                composite: Oa
            },
            "fill-pattern": {
                source: Oa,
                composite: Oa
            },
            "fill-extrusion-pattern": {
                source: Oa,
                composite: Oa
            },
            "line-dasharray": {
                source: Ba,
                composite: Ba
            }
        }, nc = {
            color: {
                source: il,
                composite: ka
            },
            number: {
                source: Ya,
                composite: il
            }
        };
        function oc(e1, t, i) {
            const r = rc[e1];
            return r && r[i] || nc[t][i];
        }
        Rs(Hl, "ConstantBinder"), Rs(Xl, "PatternConstantBinder"), Rs(Yl, "SourceExpressionBinder"), Rs(Jl, "PatternCompositeBinder"), Rs(Kl, "CompositeExpressionBinder"), Rs(Ql, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), Rs(ec, "ProgramConfigurationSet");
        class sc {
            setNorthEast(e1) {
                return this._ne = e1 instanceof Wd ? new Wd(e1.lng, e1.lat) : Wd.convert(e1), this;
            }
            setSouthWest(e1) {
                return this._sw = e1 instanceof Wd ? new Wd(e1.lng, e1.lat) : Wd.convert(e1), this;
            }
            extend(e1) {
                const t = this._sw, i = this._ne;
                let r, n;
                if (e1 instanceof Wd) r = e1, n = e1;
                else {
                    if (!(e1 instanceof sc)) return Array.isArray(e1) ? 4 === e1.length || e1.every(Array.isArray) ? this.extend(sc.convert(e1)) : this.extend(Wd.convert(e1)) : "object" == typeof e1 && null !== e1 && e1.hasOwnProperty("lat") && (e1.hasOwnProperty("lon") || e1.hasOwnProperty("lng")) ? this.extend(Wd.convert(e1)) : this;
                    if (r = e1._sw, n = e1._ne, !r || !n) return this;
                }
                return t || i ? (t.lng = Math.min(r.lng, t.lng), t.lat = Math.min(r.lat, t.lat), i.lng = Math.max(n.lng, i.lng), i.lat = Math.max(n.lat, i.lat)) : (this._sw = new Wd(r.lng, r.lat), this._ne = new Wd(n.lng, n.lat)), this;
            }
            getCenter() {
                return new Wd((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new Wd(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new Wd(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e1) {
                const { lng: t, lat: i } = Wd.convert(e1);
                let r = this._sw.lng <= t && t <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (r = this._sw.lng >= t && t >= this._ne.lng), this._sw.lat <= i && i <= this._ne.lat && r;
            }
            static convert(e1) {
                return !e1 || e1 instanceof sc ? e1 : new sc(e1);
            }
            constructor(e1, t){
                e1 && (t ? this.setSouthWest(e1).setNorthEast(t) : 4 === e1.length ? this.setSouthWest([
                    e1[0],
                    e1[1]
                ]).setNorthEast([
                    e1[2],
                    e1[3]
                ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1]));
            }
        }
        var ac = {}, lc = {};
        Object.defineProperty(lc, "__esModule", {
            value: !0
        }), lc.setMatrixArrayType = function(e1) {
            lc.ARRAY_TYPE = hc = e1;
        }, lc.toRadian = function(e1) {
            return e1 * dc;
        }, lc.equals = function(e1, t) {
            return Math.abs(e1 - t) <= cc * Math.max(1, Math.abs(e1), Math.abs(t));
        }, lc.RANDOM = lc.ARRAY_TYPE = lc.EPSILON = void 0;
        var cc = 1e-6;
        lc.EPSILON = cc;
        var hc = "undefined" != typeof Float32Array ? Float32Array : Array;
        lc.ARRAY_TYPE = hc;
        var uc = Math.random;
        lc.RANDOM = uc;
        var dc = Math.PI / 180;
        Math.hypot || (Math.hypot = function() {
            for(var e1 = 0, t = arguments.length; t--;)e1 += arguments[t] * arguments[t];
            return Math.sqrt(e1);
        });
        var pc = {};
        function fc(e1) {
            return fc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, fc(e1);
        }
        Object.defineProperty(pc, "__esModule", {
            value: !0
        }), pc.create = function() {
            var e1 = new mc.ARRAY_TYPE(4);
            return mc.ARRAY_TYPE != Float32Array && (e1[1] = 0, e1[2] = 0), e1[0] = 1, e1[3] = 1, e1;
        }, pc.clone = function(e1) {
            var t = new mc.ARRAY_TYPE(4);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t;
        }, pc.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1;
        }, pc.identity = function(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1;
        }, pc.fromValues = function(e1, t, i, r) {
            var n = new mc.ARRAY_TYPE(4);
            return n[0] = e1, n[1] = t, n[2] = i, n[3] = r, n;
        }, pc.set = function(e1, t, i, r, n) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1;
        }, pc.transpose = function(e1, t) {
            if (e1 === t) {
                var i = t[1];
                e1[1] = t[2], e1[2] = i;
            } else e1[0] = t[0], e1[1] = t[2], e1[2] = t[1], e1[3] = t[3];
            return e1;
        }, pc.invert = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = i * o - n * r;
            return s ? (e1[0] = o * (s = 1 / s), e1[1] = -r * s, e1[2] = -n * s, e1[3] = i * s, e1) : null;
        }, pc.adjoint = function(e1, t) {
            var i = t[0];
            return e1[0] = t[3], e1[1] = -t[1], e1[2] = -t[2], e1[3] = i, e1;
        }, pc.determinant = function(e1) {
            return e1[0] * e1[3] - e1[2] * e1[1];
        }, pc.multiply = gc, pc.rotate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = Math.sin(i), l = Math.cos(i);
            return e1[0] = r * l + o * a, e1[1] = n * l + s * a, e1[2] = r * -a + o * l, e1[3] = n * -a + s * l, e1;
        }, pc.scale = function(e1, t, i) {
            var r = t[1], n = t[2], o = t[3], s = i[0], a = i[1];
            return e1[0] = t[0] * s, e1[1] = r * s, e1[2] = n * a, e1[3] = o * a, e1;
        }, pc.fromRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = r, e1[1] = i, e1[2] = -i, e1[3] = r, e1;
        }, pc.fromScaling = function(e1, t) {
            return e1[0] = t[0], e1[1] = 0, e1[2] = 0, e1[3] = t[1], e1;
        }, pc.str = function(e1) {
            return "mat2(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ")";
        }, pc.frob = function(e1) {
            return Math.hypot(e1[0], e1[1], e1[2], e1[3]);
        }, pc.LDU = function(e1, t, i, r) {
            return e1[2] = r[2] / r[0], i[0] = r[0], i[1] = r[1], i[3] = r[3] - e1[2] * i[1], [
                e1,
                t,
                i
            ];
        }, pc.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1;
        }, pc.subtract = yc, pc.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3];
        }, pc.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = t[0], a = t[1], l = t[2], c = t[3];
            return Math.abs(i - s) <= mc.EPSILON * Math.max(1, Math.abs(i), Math.abs(s)) && Math.abs(r - a) <= mc.EPSILON * Math.max(1, Math.abs(r), Math.abs(a)) && Math.abs(n - l) <= mc.EPSILON * Math.max(1, Math.abs(n), Math.abs(l)) && Math.abs(o - c) <= mc.EPSILON * Math.max(1, Math.abs(o), Math.abs(c));
        }, pc.multiplyScalar = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1;
        }, pc.multiplyScalarAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1[3] = t[3] + i[3] * r, e1;
        }, pc.sub = pc.mul = void 0;
        var mc = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== fc(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = _c(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function _c(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (_c = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function gc(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = i[0], l = i[1], c = i[2], h = i[3];
            return e1[0] = r * a + o * l, e1[1] = n * a + s * l, e1[2] = r * c + o * h, e1[3] = n * c + s * h, e1;
        }
        function yc(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1[3] = t[3] - i[3], e1;
        }
        pc.mul = gc, pc.sub = yc;
        var xc = {};
        function vc(e1) {
            return vc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, vc(e1);
        }
        Object.defineProperty(xc, "__esModule", {
            value: !0
        }), xc.create = function() {
            var e1 = new bc.ARRAY_TYPE(6);
            return bc.ARRAY_TYPE != Float32Array && (e1[1] = 0, e1[2] = 0, e1[4] = 0, e1[5] = 0), e1[0] = 1, e1[3] = 1, e1;
        }, xc.clone = function(e1) {
            var t = new bc.ARRAY_TYPE(6);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t;
        }, xc.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1;
        }, xc.identity = function(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1[4] = 0, e1[5] = 0, e1;
        }, xc.fromValues = function(e1, t, i, r, n, o) {
            var s = new bc.ARRAY_TYPE(6);
            return s[0] = e1, s[1] = t, s[2] = i, s[3] = r, s[4] = n, s[5] = o, s;
        }, xc.set = function(e1, t, i, r, n, o, s) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1[4] = o, e1[5] = s, e1;
        }, xc.invert = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = i * o - r * n;
            return l ? (e1[0] = o * (l = 1 / l), e1[1] = -r * l, e1[2] = -n * l, e1[3] = i * l, e1[4] = (n * a - o * s) * l, e1[5] = (r * s - i * a) * l, e1) : null;
        }, xc.determinant = function(e1) {
            return e1[0] * e1[3] - e1[1] * e1[2];
        }, xc.multiply = Tc, xc.rotate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = Math.sin(i), h = Math.cos(i);
            return e1[0] = r * h + o * c, e1[1] = n * h + s * c, e1[2] = r * -c + o * h, e1[3] = n * -c + s * h, e1[4] = a, e1[5] = l, e1;
        }, xc.scale = function(e1, t, i) {
            var r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = i[0], c = i[1];
            return e1[0] = t[0] * l, e1[1] = r * l, e1[2] = n * c, e1[3] = o * c, e1[4] = s, e1[5] = a, e1;
        }, xc.translate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = i[0], h = i[1];
            return e1[0] = r, e1[1] = n, e1[2] = o, e1[3] = s, e1[4] = r * c + o * h + a, e1[5] = n * c + s * h + l, e1;
        }, xc.fromRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = r, e1[1] = i, e1[2] = -i, e1[3] = r, e1[4] = 0, e1[5] = 0, e1;
        }, xc.fromScaling = function(e1, t) {
            return e1[0] = t[0], e1[1] = 0, e1[2] = 0, e1[3] = t[1], e1[4] = 0, e1[5] = 0, e1;
        }, xc.fromTranslation = function(e1, t) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1[4] = t[0], e1[5] = t[1], e1;
        }, xc.str = function(e1) {
            return "mat2d(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ", " + e1[4] + ", " + e1[5] + ")";
        }, xc.frob = function(e1) {
            return Math.hypot(e1[0], e1[1], e1[2], e1[3], e1[4], e1[5], 1);
        }, xc.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1[4] = t[4] + i[4], e1[5] = t[5] + i[5], e1;
        }, xc.subtract = Ec, xc.multiplyScalar = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1[4] = t[4] * i, e1[5] = t[5] * i, e1;
        }, xc.multiplyScalarAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1[3] = t[3] + i[3] * r, e1[4] = t[4] + i[4] * r, e1[5] = t[5] + i[5] * r, e1;
        }, xc.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && e1[4] === t[4] && e1[5] === t[5];
        }, xc.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = e1[4], a = e1[5], l = t[0], c = t[1], h = t[2], u = t[3], d = t[4], p = t[5];
            return Math.abs(i - l) <= bc.EPSILON * Math.max(1, Math.abs(i), Math.abs(l)) && Math.abs(r - c) <= bc.EPSILON * Math.max(1, Math.abs(r), Math.abs(c)) && Math.abs(n - h) <= bc.EPSILON * Math.max(1, Math.abs(n), Math.abs(h)) && Math.abs(o - u) <= bc.EPSILON * Math.max(1, Math.abs(o), Math.abs(u)) && Math.abs(s - d) <= bc.EPSILON * Math.max(1, Math.abs(s), Math.abs(d)) && Math.abs(a - p) <= bc.EPSILON * Math.max(1, Math.abs(a), Math.abs(p));
        }, xc.sub = xc.mul = void 0;
        var bc = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== vc(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = wc(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function wc(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (wc = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function Tc(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = i[0], h = i[1], u = i[2], d = i[3], p = i[4], f = i[5];
            return e1[0] = r * c + o * h, e1[1] = n * c + s * h, e1[2] = r * u + o * d, e1[3] = n * u + s * d, e1[4] = r * p + o * f + a, e1[5] = n * p + s * f + l, e1;
        }
        function Ec(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1[3] = t[3] - i[3], e1[4] = t[4] - i[4], e1[5] = t[5] - i[5], e1;
        }
        xc.mul = Tc, xc.sub = Ec;
        var Mc = {};
        function Ac(e1) {
            return Ac = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, Ac(e1);
        }
        Object.defineProperty(Mc, "__esModule", {
            value: !0
        }), Mc.create = function() {
            var e1 = new Sc.ARRAY_TYPE(9);
            return Sc.ARRAY_TYPE != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0), e1[0] = 1, e1[4] = 1, e1[8] = 1, e1;
        }, Mc.fromMat4 = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[4], e1[4] = t[5], e1[5] = t[6], e1[6] = t[8], e1[7] = t[9], e1[8] = t[10], e1;
        }, Mc.clone = function(e1) {
            var t = new Sc.ARRAY_TYPE(9);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t[8] = e1[8], t;
        }, Mc.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[8] = t[8], e1;
        }, Mc.fromValues = function(e1, t, i, r, n, o, s, a, l) {
            var c = new Sc.ARRAY_TYPE(9);
            return c[0] = e1, c[1] = t, c[2] = i, c[3] = r, c[4] = n, c[5] = o, c[6] = s, c[7] = a, c[8] = l, c;
        }, Mc.set = function(e1, t, i, r, n, o, s, a, l, c) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1[4] = o, e1[5] = s, e1[6] = a, e1[7] = l, e1[8] = c, e1;
        }, Mc.identity = function(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 1, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1, e1;
        }, Mc.transpose = function(e1, t) {
            if (e1 === t) {
                var i = t[1], r = t[2], n = t[5];
                e1[1] = t[3], e1[2] = t[6], e1[3] = i, e1[5] = t[7], e1[6] = r, e1[7] = n;
            } else e1[0] = t[0], e1[1] = t[3], e1[2] = t[6], e1[3] = t[1], e1[4] = t[4], e1[5] = t[7], e1[6] = t[2], e1[7] = t[5], e1[8] = t[8];
            return e1;
        }, Mc.invert = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = t[6], c = t[7], h = t[8], u = h * s - a * c, d = -h * o + a * l, p = c * o - s * l, f = i * u + r * d + n * p;
            return f ? (e1[0] = u * (f = 1 / f), e1[1] = (-h * r + n * c) * f, e1[2] = (a * r - n * s) * f, e1[3] = d * f, e1[4] = (h * i - n * l) * f, e1[5] = (-a * i + n * o) * f, e1[6] = p * f, e1[7] = (-c * i + r * l) * f, e1[8] = (s * i - r * o) * f, e1) : null;
        }, Mc.adjoint = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = t[6], c = t[7], h = t[8];
            return e1[0] = s * h - a * c, e1[1] = n * c - r * h, e1[2] = r * a - n * s, e1[3] = a * l - o * h, e1[4] = i * h - n * l, e1[5] = n * o - i * a, e1[6] = o * c - s * l, e1[7] = r * l - i * c, e1[8] = i * s - r * o, e1;
        }, Mc.determinant = function(e1) {
            var t = e1[3], i = e1[4], r = e1[5], n = e1[6], o = e1[7], s = e1[8];
            return e1[0] * (s * i - r * o) + e1[1] * (-s * t + r * n) + e1[2] * (o * t - i * n);
        }, Mc.multiply = Cc, Mc.translate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = t[8], d = i[0], p = i[1];
            return e1[0] = r, e1[1] = n, e1[2] = o, e1[3] = s, e1[4] = a, e1[5] = l, e1[6] = d * r + p * s + c, e1[7] = d * n + p * a + h, e1[8] = d * o + p * l + u, e1;
        }, Mc.rotate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = t[8], d = Math.sin(i), p = Math.cos(i);
            return e1[0] = p * r + d * s, e1[1] = p * n + d * a, e1[2] = p * o + d * l, e1[3] = p * s - d * r, e1[4] = p * a - d * n, e1[5] = p * l - d * o, e1[6] = c, e1[7] = h, e1[8] = u, e1;
        }, Mc.scale = function(e1, t, i) {
            var r = i[0], n = i[1];
            return e1[0] = r * t[0], e1[1] = r * t[1], e1[2] = r * t[2], e1[3] = n * t[3], e1[4] = n * t[4], e1[5] = n * t[5], e1[6] = t[6], e1[7] = t[7], e1[8] = t[8], e1;
        }, Mc.fromTranslation = function(e1, t) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 1, e1[5] = 0, e1[6] = t[0], e1[7] = t[1], e1[8] = 1, e1;
        }, Mc.fromRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = r, e1[1] = i, e1[2] = 0, e1[3] = -i, e1[4] = r, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1, e1;
        }, Mc.fromScaling = function(e1, t) {
            return e1[0] = t[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = t[1], e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1, e1;
        }, Mc.fromMat2d = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = 0, e1[3] = t[2], e1[4] = t[3], e1[5] = 0, e1[6] = t[4], e1[7] = t[5], e1[8] = 1, e1;
        }, Mc.fromQuat = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = i + i, a = r + r, l = n + n, c = i * s, h = r * s, u = r * a, d = n * s, p = n * a, f = n * l, m = o * s, _ = o * a, g = o * l;
            return e1[0] = 1 - u - f, e1[3] = h - g, e1[6] = d + _, e1[1] = h + g, e1[4] = 1 - c - f, e1[7] = p - m, e1[2] = d - _, e1[5] = p + m, e1[8] = 1 - c - u, e1;
        }, Mc.normalFromMat4 = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = t[6], c = t[7], h = t[8], u = t[9], d = t[10], p = t[11], f = t[12], m = t[13], _ = t[14], g = t[15], y = i * a - r * s, x = i * l - n * s, v = i * c - o * s, b = r * l - n * a, w = r * c - o * a, T = n * c - o * l, E = h * m - u * f, M = h * _ - d * f, A = h * g - p * f, S = u * _ - d * m, I = u * g - p * m, C = d * g - p * _, z = y * C - x * I + v * S + b * A - w * M + T * E;
            return z ? (e1[0] = (a * C - l * I + c * S) * (z = 1 / z), e1[1] = (l * A - s * C - c * M) * z, e1[2] = (s * I - a * A + c * E) * z, e1[3] = (n * I - r * C - o * S) * z, e1[4] = (i * C - n * A + o * M) * z, e1[5] = (r * A - i * I - o * E) * z, e1[6] = (m * T - _ * w + g * b) * z, e1[7] = (_ * v - f * T - g * x) * z, e1[8] = (f * w - m * v + g * y) * z, e1) : null;
        }, Mc.projection = function(e1, t, i) {
            return e1[0] = 2 / t, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = -2 / i, e1[5] = 0, e1[6] = -1, e1[7] = 1, e1[8] = 1, e1;
        }, Mc.str = function(e1) {
            return "mat3(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ", " + e1[4] + ", " + e1[5] + ", " + e1[6] + ", " + e1[7] + ", " + e1[8] + ")";
        }, Mc.frob = function(e1) {
            return Math.hypot(e1[0], e1[1], e1[2], e1[3], e1[4], e1[5], e1[6], e1[7], e1[8]);
        }, Mc.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1[4] = t[4] + i[4], e1[5] = t[5] + i[5], e1[6] = t[6] + i[6], e1[7] = t[7] + i[7], e1[8] = t[8] + i[8], e1;
        }, Mc.subtract = zc, Mc.multiplyScalar = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1[4] = t[4] * i, e1[5] = t[5] * i, e1[6] = t[6] * i, e1[7] = t[7] * i, e1[8] = t[8] * i, e1;
        }, Mc.multiplyScalarAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1[3] = t[3] + i[3] * r, e1[4] = t[4] + i[4] * r, e1[5] = t[5] + i[5] * r, e1[6] = t[6] + i[6] * r, e1[7] = t[7] + i[7] * r, e1[8] = t[8] + i[8] * r, e1;
        }, Mc.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && e1[4] === t[4] && e1[5] === t[5] && e1[6] === t[6] && e1[7] === t[7] && e1[8] === t[8];
        }, Mc.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = e1[4], a = e1[5], l = e1[6], c = e1[7], h = e1[8], u = t[0], d = t[1], p = t[2], f = t[3], m = t[4], _ = t[5], g = t[6], y = t[7], x = t[8];
            return Math.abs(i - u) <= Sc.EPSILON * Math.max(1, Math.abs(i), Math.abs(u)) && Math.abs(r - d) <= Sc.EPSILON * Math.max(1, Math.abs(r), Math.abs(d)) && Math.abs(n - p) <= Sc.EPSILON * Math.max(1, Math.abs(n), Math.abs(p)) && Math.abs(o - f) <= Sc.EPSILON * Math.max(1, Math.abs(o), Math.abs(f)) && Math.abs(s - m) <= Sc.EPSILON * Math.max(1, Math.abs(s), Math.abs(m)) && Math.abs(a - _) <= Sc.EPSILON * Math.max(1, Math.abs(a), Math.abs(_)) && Math.abs(l - g) <= Sc.EPSILON * Math.max(1, Math.abs(l), Math.abs(g)) && Math.abs(c - y) <= Sc.EPSILON * Math.max(1, Math.abs(c), Math.abs(y)) && Math.abs(h - x) <= Sc.EPSILON * Math.max(1, Math.abs(h), Math.abs(x));
        }, Mc.sub = Mc.mul = void 0;
        var Sc = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== Ac(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = Ic(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function Ic(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (Ic = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function Cc(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = t[8], d = i[0], p = i[1], f = i[2], m = i[3], _ = i[4], g = i[5], y = i[6], x = i[7], v = i[8];
            return e1[0] = d * r + p * s + f * c, e1[1] = d * n + p * a + f * h, e1[2] = d * o + p * l + f * u, e1[3] = m * r + _ * s + g * c, e1[4] = m * n + _ * a + g * h, e1[5] = m * o + _ * l + g * u, e1[6] = y * r + x * s + v * c, e1[7] = y * n + x * a + v * h, e1[8] = y * o + x * l + v * u, e1;
        }
        function zc(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1[3] = t[3] - i[3], e1[4] = t[4] - i[4], e1[5] = t[5] - i[5], e1[6] = t[6] - i[6], e1[7] = t[7] - i[7], e1[8] = t[8] - i[8], e1;
        }
        Mc.mul = Cc, Mc.sub = zc;
        var Pc = {};
        function Dc(e1) {
            return Dc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, Dc(e1);
        }
        Object.defineProperty(Pc, "__esModule", {
            value: !0
        }), Pc.create = function() {
            var e1 = new Rc.ARRAY_TYPE(16);
            return Rc.ARRAY_TYPE != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0), e1[0] = 1, e1[5] = 1, e1[10] = 1, e1[15] = 1, e1;
        }, Pc.clone = function(e1) {
            var t = new Rc.ARRAY_TYPE(16);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t[8] = e1[8], t[9] = e1[9], t[10] = e1[10], t[11] = e1[11], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15], t;
        }, Pc.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[8] = t[8], e1[9] = t[9], e1[10] = t[10], e1[11] = t[11], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15], e1;
        }, Pc.fromValues = function(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m) {
            var _ = new Rc.ARRAY_TYPE(16);
            return _[0] = e1, _[1] = t, _[2] = i, _[3] = r, _[4] = n, _[5] = o, _[6] = s, _[7] = a, _[8] = l, _[9] = c, _[10] = h, _[11] = u, _[12] = d, _[13] = p, _[14] = f, _[15] = m, _;
        }, Pc.set = function(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1[4] = o, e1[5] = s, e1[6] = a, e1[7] = l, e1[8] = c, e1[9] = h, e1[10] = u, e1[11] = d, e1[12] = p, e1[13] = f, e1[14] = m, e1[15] = _, e1;
        }, Pc.identity = kc, Pc.transpose = function(e1, t) {
            if (e1 === t) {
                var i = t[1], r = t[2], n = t[3], o = t[6], s = t[7], a = t[11];
                e1[1] = t[4], e1[2] = t[8], e1[3] = t[12], e1[4] = i, e1[6] = t[9], e1[7] = t[13], e1[8] = r, e1[9] = o, e1[11] = t[14], e1[12] = n, e1[13] = s, e1[14] = a;
            } else e1[0] = t[0], e1[1] = t[4], e1[2] = t[8], e1[3] = t[12], e1[4] = t[1], e1[5] = t[5], e1[6] = t[9], e1[7] = t[13], e1[8] = t[2], e1[9] = t[6], e1[10] = t[10], e1[11] = t[14], e1[12] = t[3], e1[13] = t[7], e1[14] = t[11], e1[15] = t[15];
            return e1;
        }, Pc.invert = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = t[6], c = t[7], h = t[8], u = t[9], d = t[10], p = t[11], f = t[12], m = t[13], _ = t[14], g = t[15], y = i * a - r * s, x = i * l - n * s, v = i * c - o * s, b = r * l - n * a, w = r * c - o * a, T = n * c - o * l, E = h * m - u * f, M = h * _ - d * f, A = h * g - p * f, S = u * _ - d * m, I = u * g - p * m, C = d * g - p * _, z = y * C - x * I + v * S + b * A - w * M + T * E;
            return z ? (e1[0] = (a * C - l * I + c * S) * (z = 1 / z), e1[1] = (n * I - r * C - o * S) * z, e1[2] = (m * T - _ * w + g * b) * z, e1[3] = (d * w - u * T - p * b) * z, e1[4] = (l * A - s * C - c * M) * z, e1[5] = (i * C - n * A + o * M) * z, e1[6] = (_ * v - f * T - g * x) * z, e1[7] = (h * T - d * v + p * x) * z, e1[8] = (s * I - a * A + c * E) * z, e1[9] = (r * A - i * I - o * E) * z, e1[10] = (f * w - m * v + g * y) * z, e1[11] = (u * v - h * w - p * y) * z, e1[12] = (a * M - s * S - l * E) * z, e1[13] = (i * S - r * M + n * E) * z, e1[14] = (m * x - f * b - _ * y) * z, e1[15] = (h * b - u * x + d * y) * z, e1) : null;
        }, Pc.adjoint = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = t[4], a = t[5], l = t[6], c = t[7], h = t[8], u = t[9], d = t[10], p = t[11], f = t[12], m = t[13], _ = t[14], g = t[15];
            return e1[0] = a * (d * g - p * _) - u * (l * g - c * _) + m * (l * p - c * d), e1[1] = -(r * (d * g - p * _) - u * (n * g - o * _) + m * (n * p - o * d)), e1[2] = r * (l * g - c * _) - a * (n * g - o * _) + m * (n * c - o * l), e1[3] = -(r * (l * p - c * d) - a * (n * p - o * d) + u * (n * c - o * l)), e1[4] = -(s * (d * g - p * _) - h * (l * g - c * _) + f * (l * p - c * d)), e1[5] = i * (d * g - p * _) - h * (n * g - o * _) + f * (n * p - o * d), e1[6] = -(i * (l * g - c * _) - s * (n * g - o * _) + f * (n * c - o * l)), e1[7] = i * (l * p - c * d) - s * (n * p - o * d) + h * (n * c - o * l), e1[8] = s * (u * g - p * m) - h * (a * g - c * m) + f * (a * p - c * u), e1[9] = -(i * (u * g - p * m) - h * (r * g - o * m) + f * (r * p - o * u)), e1[10] = i * (a * g - c * m) - s * (r * g - o * m) + f * (r * c - o * a), e1[11] = -(i * (a * p - c * u) - s * (r * p - o * u) + h * (r * c - o * a)), e1[12] = -(s * (u * _ - d * m) - h * (a * _ - l * m) + f * (a * d - l * u)), e1[13] = i * (u * _ - d * m) - h * (r * _ - n * m) + f * (r * d - n * u), e1[14] = -(i * (a * _ - l * m) - s * (r * _ - n * m) + f * (r * l - n * a)), e1[15] = i * (a * d - l * u) - s * (r * d - n * u) + h * (r * l - n * a), e1;
        }, Pc.determinant = function(e1) {
            var t = e1[0], i = e1[1], r = e1[2], n = e1[3], o = e1[4], s = e1[5], a = e1[6], l = e1[7], c = e1[8], h = e1[9], u = e1[10], d = e1[11], p = e1[12], f = e1[13], m = e1[14], _ = e1[15];
            return (t * s - i * o) * (u * _ - d * m) - (t * a - r * o) * (h * _ - d * f) + (t * l - n * o) * (h * m - u * f) + (i * a - r * s) * (c * _ - d * p) - (i * l - n * s) * (c * m - u * p) + (r * l - n * a) * (c * f - h * p);
        }, Pc.multiply = Oc, Pc.translate = function(e1, t, i) {
            var r, n, o, s, a, l, c, h, u, d, p, f, m = i[0], _ = i[1], g = i[2];
            return t === e1 ? (e1[12] = t[0] * m + t[4] * _ + t[8] * g + t[12], e1[13] = t[1] * m + t[5] * _ + t[9] * g + t[13], e1[14] = t[2] * m + t[6] * _ + t[10] * g + t[14], e1[15] = t[3] * m + t[7] * _ + t[11] * g + t[15]) : (n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = t[8], d = t[9], p = t[10], f = t[11], e1[0] = r = t[0], e1[1] = n, e1[2] = o, e1[3] = s, e1[4] = a, e1[5] = l, e1[6] = c, e1[7] = h, e1[8] = u, e1[9] = d, e1[10] = p, e1[11] = f, e1[12] = r * m + a * _ + u * g + t[12], e1[13] = n * m + l * _ + d * g + t[13], e1[14] = o * m + c * _ + p * g + t[14], e1[15] = s * m + h * _ + f * g + t[15]), e1;
        }, Pc.scale = function(e1, t, i) {
            var r = i[0], n = i[1], o = i[2];
            return e1[0] = t[0] * r, e1[1] = t[1] * r, e1[2] = t[2] * r, e1[3] = t[3] * r, e1[4] = t[4] * n, e1[5] = t[5] * n, e1[6] = t[6] * n, e1[7] = t[7] * n, e1[8] = t[8] * o, e1[9] = t[9] * o, e1[10] = t[10] * o, e1[11] = t[11] * o, e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15], e1;
        }, Pc.rotate = function(e1, t, i, r) {
            var n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b, w, T, E, M, A, S, I = r[0], C = r[1], z = r[2], P = Math.hypot(I, C, z);
            return P < Rc.EPSILON ? null : (I *= P = 1 / P, C *= P, z *= P, n = Math.sin(i), o = Math.cos(i), l = t[1], c = t[2], h = t[3], d = t[5], p = t[6], f = t[7], _ = t[9], g = t[10], y = t[11], w = I * C * (s = 1 - o) - z * n, T = C * C * s + o, E = z * C * s + I * n, M = I * z * s + C * n, A = C * z * s - I * n, S = z * z * s + o, e1[0] = (a = t[0]) * (x = I * I * s + o) + (u = t[4]) * (v = C * I * s + z * n) + (m = t[8]) * (b = z * I * s - C * n), e1[1] = l * x + d * v + _ * b, e1[2] = c * x + p * v + g * b, e1[3] = h * x + f * v + y * b, e1[4] = a * w + u * T + m * E, e1[5] = l * w + d * T + _ * E, e1[6] = c * w + p * T + g * E, e1[7] = h * w + f * T + y * E, e1[8] = a * M + u * A + m * S, e1[9] = l * M + d * A + _ * S, e1[10] = c * M + p * A + g * S, e1[11] = h * M + f * A + y * S, t !== e1 && (e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1);
        }, Pc.rotateX = function(e1, t, i) {
            var r = Math.sin(i), n = Math.cos(i), o = t[4], s = t[5], a = t[6], l = t[7], c = t[8], h = t[9], u = t[10], d = t[11];
            return t !== e1 && (e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[4] = o * n + c * r, e1[5] = s * n + h * r, e1[6] = a * n + u * r, e1[7] = l * n + d * r, e1[8] = c * n - o * r, e1[9] = h * n - s * r, e1[10] = u * n - a * r, e1[11] = d * n - l * r, e1;
        }, Pc.rotateY = function(e1, t, i) {
            var r = Math.sin(i), n = Math.cos(i), o = t[0], s = t[1], a = t[2], l = t[3], c = t[8], h = t[9], u = t[10], d = t[11];
            return t !== e1 && (e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[0] = o * n - c * r, e1[1] = s * n - h * r, e1[2] = a * n - u * r, e1[3] = l * n - d * r, e1[8] = o * r + c * n, e1[9] = s * r + h * n, e1[10] = a * r + u * n, e1[11] = l * r + d * n, e1;
        }, Pc.rotateZ = function(e1, t, i) {
            var r = Math.sin(i), n = Math.cos(i), o = t[0], s = t[1], a = t[2], l = t[3], c = t[4], h = t[5], u = t[6], d = t[7];
            return t !== e1 && (e1[8] = t[8], e1[9] = t[9], e1[10] = t[10], e1[11] = t[11], e1[12] = t[12], e1[13] = t[13], e1[14] = t[14], e1[15] = t[15]), e1[0] = o * n + c * r, e1[1] = s * n + h * r, e1[2] = a * n + u * r, e1[3] = l * n + d * r, e1[4] = c * n - o * r, e1[5] = h * n - s * r, e1[6] = u * n - a * r, e1[7] = d * n - l * r, e1;
        }, Pc.fromTranslation = function(e1, t) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = t[0], e1[13] = t[1], e1[14] = t[2], e1[15] = 1, e1;
        }, Pc.fromScaling = function(e1, t) {
            return e1[0] = t[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = t[1], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = t[2], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, Pc.fromRotation = function(e1, t, i) {
            var r, n, o, s = i[0], a = i[1], l = i[2], c = Math.hypot(s, a, l);
            return c < Rc.EPSILON ? null : (s *= c = 1 / c, a *= c, l *= c, r = Math.sin(t), n = Math.cos(t), e1[0] = s * s * (o = 1 - n) + n, e1[1] = a * s * o + l * r, e1[2] = l * s * o - a * r, e1[3] = 0, e1[4] = s * a * o - l * r, e1[5] = a * a * o + n, e1[6] = l * a * o + s * r, e1[7] = 0, e1[8] = s * l * o + a * r, e1[9] = a * l * o - s * r, e1[10] = l * l * o + n, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1);
        }, Pc.fromXRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = r, e1[6] = i, e1[7] = 0, e1[8] = 0, e1[9] = -i, e1[10] = r, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, Pc.fromYRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = r, e1[1] = 0, e1[2] = -i, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = i, e1[9] = 0, e1[10] = r, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, Pc.fromZRotation = function(e1, t) {
            var i = Math.sin(t), r = Math.cos(t);
            return e1[0] = r, e1[1] = i, e1[2] = 0, e1[3] = 0, e1[4] = -i, e1[5] = r, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, Pc.fromRotationTranslation = Bc, Pc.fromQuat2 = function(e1, t) {
            var i = new Rc.ARRAY_TYPE(3), r = -t[0], n = -t[1], o = -t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = r * r + n * n + o * o + s * s;
            return u > 0 ? (i[0] = 2 * (a * s + h * r + l * o - c * n) / u, i[1] = 2 * (l * s + h * n + c * r - a * o) / u, i[2] = 2 * (c * s + h * o + a * n - l * r) / u) : (i[0] = 2 * (a * s + h * r + l * o - c * n), i[1] = 2 * (l * s + h * n + c * r - a * o), i[2] = 2 * (c * s + h * o + a * n - l * r)), Bc(e1, t, i), e1;
        }, Pc.getTranslation = function(e1, t) {
            return e1[0] = t[12], e1[1] = t[13], e1[2] = t[14], e1;
        }, Pc.getScaling = Fc, Pc.getRotation = function(e1, t) {
            var i = new Rc.ARRAY_TYPE(3);
            Fc(i, t);
            var r = 1 / i[0], n = 1 / i[1], o = 1 / i[2], s = t[0] * r, a = t[1] * n, l = t[2] * o, c = t[4] * r, h = t[5] * n, u = t[6] * o, d = t[8] * r, p = t[9] * n, f = t[10] * o, m = s + h + f, _ = 0;
            return m > 0 ? (_ = 2 * Math.sqrt(m + 1), e1[3] = .25 * _, e1[0] = (u - p) / _, e1[1] = (d - l) / _, e1[2] = (a - c) / _) : s > h && s > f ? (_ = 2 * Math.sqrt(1 + s - h - f), e1[3] = (u - p) / _, e1[0] = .25 * _, e1[1] = (a + c) / _, e1[2] = (d + l) / _) : h > f ? (_ = 2 * Math.sqrt(1 + h - s - f), e1[3] = (d - l) / _, e1[0] = (a + c) / _, e1[1] = .25 * _, e1[2] = (u + p) / _) : (_ = 2 * Math.sqrt(1 + f - s - h), e1[3] = (a - c) / _, e1[0] = (d + l) / _, e1[1] = (u + p) / _, e1[2] = .25 * _), e1;
        }, Pc.fromRotationTranslationScale = function(e1, t, i, r) {
            var n = t[0], o = t[1], s = t[2], a = t[3], l = n + n, c = o + o, h = s + s, u = n * l, d = n * c, p = n * h, f = o * c, m = o * h, _ = s * h, g = a * l, y = a * c, x = a * h, v = r[0], b = r[1], w = r[2];
            return e1[0] = (1 - (f + _)) * v, e1[1] = (d + x) * v, e1[2] = (p - y) * v, e1[3] = 0, e1[4] = (d - x) * b, e1[5] = (1 - (u + _)) * b, e1[6] = (m + g) * b, e1[7] = 0, e1[8] = (p + y) * w, e1[9] = (m - g) * w, e1[10] = (1 - (u + f)) * w, e1[11] = 0, e1[12] = i[0], e1[13] = i[1], e1[14] = i[2], e1[15] = 1, e1;
        }, Pc.fromRotationTranslationScaleOrigin = function(e1, t, i, r, n) {
            var o = t[0], s = t[1], a = t[2], l = t[3], c = o + o, h = s + s, u = a + a, d = o * c, p = o * h, f = o * u, m = s * h, _ = s * u, g = a * u, y = l * c, x = l * h, v = l * u, b = r[0], w = r[1], T = r[2], E = n[0], M = n[1], A = n[2], S = (1 - (m + g)) * b, I = (p + v) * b, C = (f - x) * b, z = (p - v) * w, P = (1 - (d + g)) * w, D = (_ + y) * w, R = (f + x) * T, L = (_ - y) * T, k = (1 - (d + m)) * T;
            return e1[0] = S, e1[1] = I, e1[2] = C, e1[3] = 0, e1[4] = z, e1[5] = P, e1[6] = D, e1[7] = 0, e1[8] = R, e1[9] = L, e1[10] = k, e1[11] = 0, e1[12] = i[0] + E - (S * E + z * M + R * A), e1[13] = i[1] + M - (I * E + P * M + L * A), e1[14] = i[2] + A - (C * E + D * M + k * A), e1[15] = 1, e1;
        }, Pc.fromQuat = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = i + i, a = r + r, l = n + n, c = i * s, h = r * s, u = r * a, d = n * s, p = n * a, f = n * l, m = o * s, _ = o * a, g = o * l;
            return e1[0] = 1 - u - f, e1[1] = h + g, e1[2] = d - _, e1[3] = 0, e1[4] = h - g, e1[5] = 1 - c - f, e1[6] = p + m, e1[7] = 0, e1[8] = d + _, e1[9] = p - m, e1[10] = 1 - c - u, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }, Pc.frustum = function(e1, t, i, r, n, o, s) {
            var a = 1 / (i - t), l = 1 / (n - r), c = 1 / (o - s);
            return e1[0] = 2 * o * a, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 2 * o * l, e1[6] = 0, e1[7] = 0, e1[8] = (i + t) * a, e1[9] = (n + r) * l, e1[10] = (s + o) * c, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[14] = s * o * 2 * c, e1[15] = 0, e1;
        }, Pc.perspectiveNO = Nc, Pc.perspectiveZO = function(e1, t, i, r, n) {
            var o, s = 1 / Math.tan(t / 2);
            return e1[0] = s / i, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = s, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[15] = 0, null != n && n !== 1 / 0 ? (e1[10] = n * (o = 1 / (r - n)), e1[14] = n * r * o) : (e1[10] = -1, e1[14] = -r), e1;
        }, Pc.perspectiveFromFieldOfView = function(e1, t, i, r) {
            var n = Math.tan(t.upDegrees * Math.PI / 180), o = Math.tan(t.downDegrees * Math.PI / 180), s = Math.tan(t.leftDegrees * Math.PI / 180), a = Math.tan(t.rightDegrees * Math.PI / 180), l = 2 / (s + a), c = 2 / (n + o);
            return e1[0] = l, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = c, e1[6] = 0, e1[7] = 0, e1[8] = -(s - a) * l * .5, e1[9] = (n - o) * c * .5, e1[10] = r / (i - r), e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[14] = r * i / (i - r), e1[15] = 0, e1;
        }, Pc.orthoNO = Uc, Pc.orthoZO = function(e1, t, i, r, n, o, s) {
            var a = 1 / (t - i), l = 1 / (r - n), c = 1 / (o - s);
            return e1[0] = -2 * a, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = -2 * l, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = c, e1[11] = 0, e1[12] = (t + i) * a, e1[13] = (n + r) * l, e1[14] = o * c, e1[15] = 1, e1;
        }, Pc.lookAt = function(e1, t, i, r) {
            var n, o, s, a, l, c, h, u, d, p, f = t[0], m = t[1], _ = t[2], g = r[0], y = r[1], x = r[2], v = i[0], b = i[1], w = i[2];
            return Math.abs(f - v) < Rc.EPSILON && Math.abs(m - b) < Rc.EPSILON && Math.abs(_ - w) < Rc.EPSILON ? kc(e1) : (h = f - v, u = m - b, d = _ - w, n = y * (d *= p = 1 / Math.hypot(h, u, d)) - x * (u *= p), o = x * (h *= p) - g * d, s = g * u - y * h, (p = Math.hypot(n, o, s)) ? (n *= p = 1 / p, o *= p, s *= p) : (n = 0, o = 0, s = 0), a = u * s - d * o, l = d * n - h * s, c = h * o - u * n, (p = Math.hypot(a, l, c)) ? (a *= p = 1 / p, l *= p, c *= p) : (a = 0, l = 0, c = 0), e1[0] = n, e1[1] = a, e1[2] = h, e1[3] = 0, e1[4] = o, e1[5] = l, e1[6] = u, e1[7] = 0, e1[8] = s, e1[9] = c, e1[10] = d, e1[11] = 0, e1[12] = -(n * f + o * m + s * _), e1[13] = -(a * f + l * m + c * _), e1[14] = -(h * f + u * m + d * _), e1[15] = 1, e1);
        }, Pc.targetTo = function(e1, t, i, r) {
            var n = t[0], o = t[1], s = t[2], a = r[0], l = r[1], c = r[2], h = n - i[0], u = o - i[1], d = s - i[2], p = h * h + u * u + d * d;
            p > 0 && (h *= p = 1 / Math.sqrt(p), u *= p, d *= p);
            var f = l * d - c * u, m = c * h - a * d, _ = a * u - l * h;
            return (p = f * f + m * m + _ * _) > 0 && (f *= p = 1 / Math.sqrt(p), m *= p, _ *= p), e1[0] = f, e1[1] = m, e1[2] = _, e1[3] = 0, e1[4] = u * _ - d * m, e1[5] = d * f - h * _, e1[6] = h * m - u * f, e1[7] = 0, e1[8] = h, e1[9] = u, e1[10] = d, e1[11] = 0, e1[12] = n, e1[13] = o, e1[14] = s, e1[15] = 1, e1;
        }, Pc.str = function(e1) {
            return "mat4(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ", " + e1[4] + ", " + e1[5] + ", " + e1[6] + ", " + e1[7] + ", " + e1[8] + ", " + e1[9] + ", " + e1[10] + ", " + e1[11] + ", " + e1[12] + ", " + e1[13] + ", " + e1[14] + ", " + e1[15] + ")";
        }, Pc.frob = function(e1) {
            return Math.hypot(e1[0], e1[1], e1[2], e1[3], e1[4], e1[5], e1[6], e1[7], e1[8], e1[9], e1[10], e1[11], e1[12], e1[13], e1[14], e1[15]);
        }, Pc.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1[4] = t[4] + i[4], e1[5] = t[5] + i[5], e1[6] = t[6] + i[6], e1[7] = t[7] + i[7], e1[8] = t[8] + i[8], e1[9] = t[9] + i[9], e1[10] = t[10] + i[10], e1[11] = t[11] + i[11], e1[12] = t[12] + i[12], e1[13] = t[13] + i[13], e1[14] = t[14] + i[14], e1[15] = t[15] + i[15], e1;
        }, Pc.subtract = Vc, Pc.multiplyScalar = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1[4] = t[4] * i, e1[5] = t[5] * i, e1[6] = t[6] * i, e1[7] = t[7] * i, e1[8] = t[8] * i, e1[9] = t[9] * i, e1[10] = t[10] * i, e1[11] = t[11] * i, e1[12] = t[12] * i, e1[13] = t[13] * i, e1[14] = t[14] * i, e1[15] = t[15] * i, e1;
        }, Pc.multiplyScalarAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1[3] = t[3] + i[3] * r, e1[4] = t[4] + i[4] * r, e1[5] = t[5] + i[5] * r, e1[6] = t[6] + i[6] * r, e1[7] = t[7] + i[7] * r, e1[8] = t[8] + i[8] * r, e1[9] = t[9] + i[9] * r, e1[10] = t[10] + i[10] * r, e1[11] = t[11] + i[11] * r, e1[12] = t[12] + i[12] * r, e1[13] = t[13] + i[13] * r, e1[14] = t[14] + i[14] * r, e1[15] = t[15] + i[15] * r, e1;
        }, Pc.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && e1[4] === t[4] && e1[5] === t[5] && e1[6] === t[6] && e1[7] === t[7] && e1[8] === t[8] && e1[9] === t[9] && e1[10] === t[10] && e1[11] === t[11] && e1[12] === t[12] && e1[13] === t[13] && e1[14] === t[14] && e1[15] === t[15];
        }, Pc.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = e1[4], a = e1[5], l = e1[6], c = e1[7], h = e1[8], u = e1[9], d = e1[10], p = e1[11], f = e1[12], m = e1[13], _ = e1[14], g = e1[15], y = t[0], x = t[1], v = t[2], b = t[3], w = t[4], T = t[5], E = t[6], M = t[7], A = t[8], S = t[9], I = t[10], C = t[11], z = t[12], P = t[13], D = t[14], R = t[15];
            return Math.abs(i - y) <= Rc.EPSILON * Math.max(1, Math.abs(i), Math.abs(y)) && Math.abs(r - x) <= Rc.EPSILON * Math.max(1, Math.abs(r), Math.abs(x)) && Math.abs(n - v) <= Rc.EPSILON * Math.max(1, Math.abs(n), Math.abs(v)) && Math.abs(o - b) <= Rc.EPSILON * Math.max(1, Math.abs(o), Math.abs(b)) && Math.abs(s - w) <= Rc.EPSILON * Math.max(1, Math.abs(s), Math.abs(w)) && Math.abs(a - T) <= Rc.EPSILON * Math.max(1, Math.abs(a), Math.abs(T)) && Math.abs(l - E) <= Rc.EPSILON * Math.max(1, Math.abs(l), Math.abs(E)) && Math.abs(c - M) <= Rc.EPSILON * Math.max(1, Math.abs(c), Math.abs(M)) && Math.abs(h - A) <= Rc.EPSILON * Math.max(1, Math.abs(h), Math.abs(A)) && Math.abs(u - S) <= Rc.EPSILON * Math.max(1, Math.abs(u), Math.abs(S)) && Math.abs(d - I) <= Rc.EPSILON * Math.max(1, Math.abs(d), Math.abs(I)) && Math.abs(p - C) <= Rc.EPSILON * Math.max(1, Math.abs(p), Math.abs(C)) && Math.abs(f - z) <= Rc.EPSILON * Math.max(1, Math.abs(f), Math.abs(z)) && Math.abs(m - P) <= Rc.EPSILON * Math.max(1, Math.abs(m), Math.abs(P)) && Math.abs(_ - D) <= Rc.EPSILON * Math.max(1, Math.abs(_), Math.abs(D)) && Math.abs(g - R) <= Rc.EPSILON * Math.max(1, Math.abs(g), Math.abs(R));
        }, Pc.sub = Pc.mul = Pc.ortho = Pc.perspective = void 0;
        var Rc = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== Dc(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = Lc(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function Lc(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (Lc = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function kc(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        function Oc(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = t[8], d = t[9], p = t[10], f = t[11], m = t[12], _ = t[13], g = t[14], y = t[15], x = i[0], v = i[1], b = i[2], w = i[3];
            return e1[0] = x * r + v * a + b * u + w * m, e1[1] = x * n + v * l + b * d + w * _, e1[2] = x * o + v * c + b * p + w * g, e1[3] = x * s + v * h + b * f + w * y, e1[4] = (x = i[4]) * r + (v = i[5]) * a + (b = i[6]) * u + (w = i[7]) * m, e1[5] = x * n + v * l + b * d + w * _, e1[6] = x * o + v * c + b * p + w * g, e1[7] = x * s + v * h + b * f + w * y, e1[8] = (x = i[8]) * r + (v = i[9]) * a + (b = i[10]) * u + (w = i[11]) * m, e1[9] = x * n + v * l + b * d + w * _, e1[10] = x * o + v * c + b * p + w * g, e1[11] = x * s + v * h + b * f + w * y, e1[12] = (x = i[12]) * r + (v = i[13]) * a + (b = i[14]) * u + (w = i[15]) * m, e1[13] = x * n + v * l + b * d + w * _, e1[14] = x * o + v * c + b * p + w * g, e1[15] = x * s + v * h + b * f + w * y, e1;
        }
        function Bc(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = r + r, l = n + n, c = o + o, h = r * a, u = r * l, d = r * c, p = n * l, f = n * c, m = o * c, _ = s * a, g = s * l, y = s * c;
            return e1[0] = 1 - (p + m), e1[1] = u + y, e1[2] = d - g, e1[3] = 0, e1[4] = u - y, e1[5] = 1 - (h + m), e1[6] = f + _, e1[7] = 0, e1[8] = d + g, e1[9] = f - _, e1[10] = 1 - (h + p), e1[11] = 0, e1[12] = i[0], e1[13] = i[1], e1[14] = i[2], e1[15] = 1, e1;
        }
        function Fc(e1, t) {
            var i = t[4], r = t[5], n = t[6], o = t[8], s = t[9], a = t[10];
            return e1[0] = Math.hypot(t[0], t[1], t[2]), e1[1] = Math.hypot(i, r, n), e1[2] = Math.hypot(o, s, a), e1;
        }
        function Nc(e1, t, i, r, n) {
            var o, s = 1 / Math.tan(t / 2);
            return e1[0] = s / i, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = s, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[15] = 0, null != n && n !== 1 / 0 ? (e1[10] = (n + r) * (o = 1 / (r - n)), e1[14] = 2 * n * r * o) : (e1[10] = -1, e1[14] = -2 * r), e1;
        }
        function Uc(e1, t, i, r, n, o, s) {
            var a = 1 / (t - i), l = 1 / (r - n), c = 1 / (o - s);
            return e1[0] = -2 * a, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = -2 * l, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 2 * c, e1[11] = 0, e1[12] = (t + i) * a, e1[13] = (n + r) * l, e1[14] = (s + o) * c, e1[15] = 1, e1;
        }
        function Vc(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1[3] = t[3] - i[3], e1[4] = t[4] - i[4], e1[5] = t[5] - i[5], e1[6] = t[6] - i[6], e1[7] = t[7] - i[7], e1[8] = t[8] - i[8], e1[9] = t[9] - i[9], e1[10] = t[10] - i[10], e1[11] = t[11] - i[11], e1[12] = t[12] - i[12], e1[13] = t[13] - i[13], e1[14] = t[14] - i[14], e1[15] = t[15] - i[15], e1;
        }
        Pc.perspective = Nc, Pc.ortho = Uc, Pc.mul = Oc, Pc.sub = Vc;
        var jc = {}, Gc = {};
        function qc(e1) {
            return qc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, qc(e1);
        }
        Object.defineProperty(Gc, "__esModule", {
            value: !0
        }), Gc.create = Wc, Gc.clone = function(e1) {
            var t = new Zc.ARRAY_TYPE(3);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t;
        }, Gc.length = Hc, Gc.fromValues = function(e1, t, i) {
            var r = new Zc.ARRAY_TYPE(3);
            return r[0] = e1, r[1] = t, r[2] = i, r;
        }, Gc.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1;
        }, Gc.set = function(e1, t, i, r) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1;
        }, Gc.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1;
        }, Gc.subtract = Xc, Gc.multiply = Yc, Gc.divide = Kc, Gc.ceil = function(e1, t) {
            return e1[0] = Math.ceil(t[0]), e1[1] = Math.ceil(t[1]), e1[2] = Math.ceil(t[2]), e1;
        }, Gc.floor = function(e1, t) {
            return e1[0] = Math.floor(t[0]), e1[1] = Math.floor(t[1]), e1[2] = Math.floor(t[2]), e1;
        }, Gc.min = function(e1, t, i) {
            return e1[0] = Math.min(t[0], i[0]), e1[1] = Math.min(t[1], i[1]), e1[2] = Math.min(t[2], i[2]), e1;
        }, Gc.max = function(e1, t, i) {
            return e1[0] = Math.max(t[0], i[0]), e1[1] = Math.max(t[1], i[1]), e1[2] = Math.max(t[2], i[2]), e1;
        }, Gc.round = function(e1, t) {
            return e1[0] = Math.round(t[0]), e1[1] = Math.round(t[1]), e1[2] = Math.round(t[2]), e1;
        }, Gc.scale = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1;
        }, Gc.scaleAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1;
        }, Gc.distance = Jc, Gc.squaredDistance = Qc, Gc.squaredLength = eh, Gc.negate = function(e1, t) {
            return e1[0] = -t[0], e1[1] = -t[1], e1[2] = -t[2], e1;
        }, Gc.inverse = function(e1, t) {
            return e1[0] = 1 / t[0], e1[1] = 1 / t[1], e1[2] = 1 / t[2], e1;
        }, Gc.normalize = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = i * i + r * r + n * n;
            return o > 0 && (o = 1 / Math.sqrt(o)), e1[0] = t[0] * o, e1[1] = t[1] * o, e1[2] = t[2] * o, e1;
        }, Gc.dot = th, Gc.cross = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = i[0], a = i[1], l = i[2];
            return e1[0] = n * l - o * a, e1[1] = o * s - r * l, e1[2] = r * a - n * s, e1;
        }, Gc.lerp = function(e1, t, i, r) {
            var n = t[0], o = t[1], s = t[2];
            return e1[0] = n + r * (i[0] - n), e1[1] = o + r * (i[1] - o), e1[2] = s + r * (i[2] - s), e1;
        }, Gc.hermite = function(e1, t, i, r, n, o) {
            var s = o * o, a = s * (2 * o - 3) + 1, l = s * (o - 2) + o, c = s * (o - 1), h = s * (3 - 2 * o);
            return e1[0] = t[0] * a + i[0] * l + r[0] * c + n[0] * h, e1[1] = t[1] * a + i[1] * l + r[1] * c + n[1] * h, e1[2] = t[2] * a + i[2] * l + r[2] * c + n[2] * h, e1;
        }, Gc.bezier = function(e1, t, i, r, n, o) {
            var s = 1 - o, a = s * s, l = o * o, c = a * s, h = 3 * o * a, u = 3 * l * s, d = l * o;
            return e1[0] = t[0] * c + i[0] * h + r[0] * u + n[0] * d, e1[1] = t[1] * c + i[1] * h + r[1] * u + n[1] * d, e1[2] = t[2] * c + i[2] * h + r[2] * u + n[2] * d, e1;
        }, Gc.random = function(e1, t) {
            t = t || 1;
            var i = 2 * Zc.RANDOM() * Math.PI, r = 2 * Zc.RANDOM() - 1, n = Math.sqrt(1 - r * r) * t;
            return e1[0] = Math.cos(i) * n, e1[1] = Math.sin(i) * n, e1[2] = r * t, e1;
        }, Gc.transformMat4 = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = i[3] * r + i[7] * n + i[11] * o + i[15];
            return e1[0] = (i[0] * r + i[4] * n + i[8] * o + i[12]) / (s = s || 1), e1[1] = (i[1] * r + i[5] * n + i[9] * o + i[13]) / s, e1[2] = (i[2] * r + i[6] * n + i[10] * o + i[14]) / s, e1;
        }, Gc.transformMat3 = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2];
            return e1[0] = r * i[0] + n * i[3] + o * i[6], e1[1] = r * i[1] + n * i[4] + o * i[7], e1[2] = r * i[2] + n * i[5] + o * i[8], e1;
        }, Gc.transformQuat = function(e1, t, i) {
            var r = i[0], n = i[1], o = i[2], s = t[0], a = t[1], l = t[2], c = n * l - o * a, h = o * s - r * l, u = r * a - n * s, d = n * u - o * h, p = o * c - r * u, f = r * h - n * c, m = 2 * i[3];
            return h *= m, u *= m, p *= 2, f *= 2, e1[0] = s + (c *= m) + (d *= 2), e1[1] = a + h + p, e1[2] = l + u + f, e1;
        }, Gc.rotateX = function(e1, t, i, r) {
            var n = [], o = [];
            return n[0] = t[0] - i[0], n[1] = t[1] - i[1], n[2] = t[2] - i[2], o[0] = n[0], o[1] = n[1] * Math.cos(r) - n[2] * Math.sin(r), o[2] = n[1] * Math.sin(r) + n[2] * Math.cos(r), e1[0] = o[0] + i[0], e1[1] = o[1] + i[1], e1[2] = o[2] + i[2], e1;
        }, Gc.rotateY = function(e1, t, i, r) {
            var n = [], o = [];
            return n[0] = t[0] - i[0], n[1] = t[1] - i[1], n[2] = t[2] - i[2], o[0] = n[2] * Math.sin(r) + n[0] * Math.cos(r), o[1] = n[1], o[2] = n[2] * Math.cos(r) - n[0] * Math.sin(r), e1[0] = o[0] + i[0], e1[1] = o[1] + i[1], e1[2] = o[2] + i[2], e1;
        }, Gc.rotateZ = function(e1, t, i, r) {
            var n = [], o = [];
            return n[0] = t[0] - i[0], n[1] = t[1] - i[1], n[2] = t[2] - i[2], o[0] = n[0] * Math.cos(r) - n[1] * Math.sin(r), o[1] = n[0] * Math.sin(r) + n[1] * Math.cos(r), o[2] = n[2], e1[0] = o[0] + i[0], e1[1] = o[1] + i[1], e1[2] = o[2] + i[2], e1;
        }, Gc.angle = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = t[0], s = t[1], a = t[2], l = Math.sqrt(i * i + r * r + n * n) * Math.sqrt(o * o + s * s + a * a), c = l && th(e1, t) / l;
            return Math.acos(Math.min(Math.max(c, -1), 1));
        }, Gc.zero = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1;
        }, Gc.str = function(e1) {
            return "vec3(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ")";
        }, Gc.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2];
        }, Gc.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = t[0], s = t[1], a = t[2];
            return Math.abs(i - o) <= Zc.EPSILON * Math.max(1, Math.abs(i), Math.abs(o)) && Math.abs(r - s) <= Zc.EPSILON * Math.max(1, Math.abs(r), Math.abs(s)) && Math.abs(n - a) <= Zc.EPSILON * Math.max(1, Math.abs(n), Math.abs(a));
        }, Gc.forEach = Gc.sqrLen = Gc.len = Gc.sqrDist = Gc.dist = Gc.div = Gc.mul = Gc.sub = void 0;
        var Zc = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== qc(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = $c(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function $c(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return ($c = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function Wc() {
            var e1 = new Zc.ARRAY_TYPE(3);
            return Zc.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1;
        }
        function Hc(e1) {
            return Math.hypot(e1[0], e1[1], e1[2]);
        }
        function Xc(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1;
        }
        function Yc(e1, t, i) {
            return e1[0] = t[0] * i[0], e1[1] = t[1] * i[1], e1[2] = t[2] * i[2], e1;
        }
        function Kc(e1, t, i) {
            return e1[0] = t[0] / i[0], e1[1] = t[1] / i[1], e1[2] = t[2] / i[2], e1;
        }
        function Jc(e1, t) {
            return Math.hypot(t[0] - e1[0], t[1] - e1[1], t[2] - e1[2]);
        }
        function Qc(e1, t) {
            var i = t[0] - e1[0], r = t[1] - e1[1], n = t[2] - e1[2];
            return i * i + r * r + n * n;
        }
        function eh(e1) {
            var t = e1[0], i = e1[1], r = e1[2];
            return t * t + i * i + r * r;
        }
        function th(e1, t) {
            return e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2];
        }
        Gc.sub = Xc, Gc.mul = Yc, Gc.div = Kc, Gc.dist = Jc, Gc.sqrDist = Qc, Gc.len = Hc, Gc.sqrLen = eh;
        var ih, rh = (ih = Wc(), function(e1, t, i, r, n, o) {
            var s, a;
            for(t || (t = 3), i || (i = 0), a = r ? Math.min(r * t + i, e1.length) : e1.length, s = i; s < a; s += t)ih[0] = e1[s], ih[1] = e1[s + 1], ih[2] = e1[s + 2], n(ih, ih, o), e1[s] = ih[0], e1[s + 1] = ih[1], e1[s + 2] = ih[2];
            return e1;
        });
        Gc.forEach = rh;
        var nh = {};
        function oh(e1) {
            return oh = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, oh(e1);
        }
        Object.defineProperty(nh, "__esModule", {
            value: !0
        }), nh.create = lh, nh.clone = function(e1) {
            var t = new sh.ARRAY_TYPE(4);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t;
        }, nh.fromValues = function(e1, t, i, r) {
            var n = new sh.ARRAY_TYPE(4);
            return n[0] = e1, n[1] = t, n[2] = i, n[3] = r, n;
        }, nh.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1;
        }, nh.set = function(e1, t, i, r, n) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1;
        }, nh.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1;
        }, nh.subtract = ch, nh.multiply = hh, nh.divide = uh, nh.ceil = function(e1, t) {
            return e1[0] = Math.ceil(t[0]), e1[1] = Math.ceil(t[1]), e1[2] = Math.ceil(t[2]), e1[3] = Math.ceil(t[3]), e1;
        }, nh.floor = function(e1, t) {
            return e1[0] = Math.floor(t[0]), e1[1] = Math.floor(t[1]), e1[2] = Math.floor(t[2]), e1[3] = Math.floor(t[3]), e1;
        }, nh.min = function(e1, t, i) {
            return e1[0] = Math.min(t[0], i[0]), e1[1] = Math.min(t[1], i[1]), e1[2] = Math.min(t[2], i[2]), e1[3] = Math.min(t[3], i[3]), e1;
        }, nh.max = function(e1, t, i) {
            return e1[0] = Math.max(t[0], i[0]), e1[1] = Math.max(t[1], i[1]), e1[2] = Math.max(t[2], i[2]), e1[3] = Math.max(t[3], i[3]), e1;
        }, nh.round = function(e1, t) {
            return e1[0] = Math.round(t[0]), e1[1] = Math.round(t[1]), e1[2] = Math.round(t[2]), e1[3] = Math.round(t[3]), e1;
        }, nh.scale = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1;
        }, nh.scaleAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1[2] = t[2] + i[2] * r, e1[3] = t[3] + i[3] * r, e1;
        }, nh.distance = dh, nh.squaredDistance = ph, nh.length = fh, nh.squaredLength = mh, nh.negate = function(e1, t) {
            return e1[0] = -t[0], e1[1] = -t[1], e1[2] = -t[2], e1[3] = -t[3], e1;
        }, nh.inverse = function(e1, t) {
            return e1[0] = 1 / t[0], e1[1] = 1 / t[1], e1[2] = 1 / t[2], e1[3] = 1 / t[3], e1;
        }, nh.normalize = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = i * i + r * r + n * n + o * o;
            return s > 0 && (s = 1 / Math.sqrt(s)), e1[0] = i * s, e1[1] = r * s, e1[2] = n * s, e1[3] = o * s, e1;
        }, nh.dot = function(e1, t) {
            return e1[0] * t[0] + e1[1] * t[1] + e1[2] * t[2] + e1[3] * t[3];
        }, nh.cross = function(e1, t, i, r) {
            var n = i[0] * r[1] - i[1] * r[0], o = i[0] * r[2] - i[2] * r[0], s = i[0] * r[3] - i[3] * r[0], a = i[1] * r[2] - i[2] * r[1], l = i[1] * r[3] - i[3] * r[1], c = i[2] * r[3] - i[3] * r[2], h = t[0], u = t[1], d = t[2], p = t[3];
            return e1[0] = u * c - d * l + p * a, e1[1] = -h * c + d * s - p * o, e1[2] = h * l - u * s + p * n, e1[3] = -h * a + u * o - d * n, e1;
        }, nh.lerp = function(e1, t, i, r) {
            var n = t[0], o = t[1], s = t[2], a = t[3];
            return e1[0] = n + r * (i[0] - n), e1[1] = o + r * (i[1] - o), e1[2] = s + r * (i[2] - s), e1[3] = a + r * (i[3] - a), e1;
        }, nh.random = function(e1, t) {
            var i, r, n, o, s, a;
            t = t || 1;
            do s = (i = 2 * sh.RANDOM() - 1) * i + (r = 2 * sh.RANDOM() - 1) * r;
            while (s >= 1);
            do a = (n = 2 * sh.RANDOM() - 1) * n + (o = 2 * sh.RANDOM() - 1) * o;
            while (a >= 1);
            var l = Math.sqrt((1 - s) / a);
            return e1[0] = t * i, e1[1] = t * r, e1[2] = t * n * l, e1[3] = t * o * l, e1;
        }, nh.transformMat4 = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3];
            return e1[0] = i[0] * r + i[4] * n + i[8] * o + i[12] * s, e1[1] = i[1] * r + i[5] * n + i[9] * o + i[13] * s, e1[2] = i[2] * r + i[6] * n + i[10] * o + i[14] * s, e1[3] = i[3] * r + i[7] * n + i[11] * o + i[15] * s, e1;
        }, nh.transformQuat = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = i[0], a = i[1], l = i[2], c = i[3], h = c * r + a * o - l * n, u = c * n + l * r - s * o, d = c * o + s * n - a * r, p = -s * r - a * n - l * o;
            return e1[0] = h * c + p * -s + u * -l - d * -a, e1[1] = u * c + p * -a + d * -s - h * -l, e1[2] = d * c + p * -l + h * -a - u * -s, e1[3] = t[3], e1;
        }, nh.zero = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1;
        }, nh.str = function(e1) {
            return "vec4(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ")";
        }, nh.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3];
        }, nh.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = t[0], a = t[1], l = t[2], c = t[3];
            return Math.abs(i - s) <= sh.EPSILON * Math.max(1, Math.abs(i), Math.abs(s)) && Math.abs(r - a) <= sh.EPSILON * Math.max(1, Math.abs(r), Math.abs(a)) && Math.abs(n - l) <= sh.EPSILON * Math.max(1, Math.abs(n), Math.abs(l)) && Math.abs(o - c) <= sh.EPSILON * Math.max(1, Math.abs(o), Math.abs(c));
        }, nh.forEach = nh.sqrLen = nh.len = nh.sqrDist = nh.dist = nh.div = nh.mul = nh.sub = void 0;
        var sh = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== oh(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = ah(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function ah(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (ah = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function lh() {
            var e1 = new sh.ARRAY_TYPE(4);
            return sh.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 0), e1;
        }
        function ch(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1[2] = t[2] - i[2], e1[3] = t[3] - i[3], e1;
        }
        function hh(e1, t, i) {
            return e1[0] = t[0] * i[0], e1[1] = t[1] * i[1], e1[2] = t[2] * i[2], e1[3] = t[3] * i[3], e1;
        }
        function uh(e1, t, i) {
            return e1[0] = t[0] / i[0], e1[1] = t[1] / i[1], e1[2] = t[2] / i[2], e1[3] = t[3] / i[3], e1;
        }
        function dh(e1, t) {
            return Math.hypot(t[0] - e1[0], t[1] - e1[1], t[2] - e1[2], t[3] - e1[3]);
        }
        function ph(e1, t) {
            var i = t[0] - e1[0], r = t[1] - e1[1], n = t[2] - e1[2], o = t[3] - e1[3];
            return i * i + r * r + n * n + o * o;
        }
        function fh(e1) {
            return Math.hypot(e1[0], e1[1], e1[2], e1[3]);
        }
        function mh(e1) {
            var t = e1[0], i = e1[1], r = e1[2], n = e1[3];
            return t * t + i * i + r * r + n * n;
        }
        nh.sub = ch, nh.mul = hh, nh.div = uh, nh.dist = dh, nh.sqrDist = ph, nh.len = fh, nh.sqrLen = mh;
        var _h = function() {
            var e1 = lh();
            return function(t, i, r, n, o, s) {
                var a, l;
                for(i || (i = 4), r || (r = 0), l = n ? Math.min(n * i + r, t.length) : t.length, a = r; a < l; a += i)e1[0] = t[a], e1[1] = t[a + 1], e1[2] = t[a + 2], e1[3] = t[a + 3], o(e1, e1, s), t[a] = e1[0], t[a + 1] = e1[1], t[a + 2] = e1[2], t[a + 3] = e1[3];
                return t;
            };
        }();
        function gh(e1) {
            return gh = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, gh(e1);
        }
        nh.forEach = _h, Object.defineProperty(jc, "__esModule", {
            value: !0
        }), jc.create = Eh, jc.identity = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1;
        }, jc.setAxisAngle = Mh, jc.getAxisAngle = function(e1, t) {
            var i = 2 * Math.acos(t[3]), r = Math.sin(i / 2);
            return r > yh.EPSILON ? (e1[0] = t[0] / r, e1[1] = t[1] / r, e1[2] = t[2] / r) : (e1[0] = 1, e1[1] = 0, e1[2] = 0), i;
        }, jc.getAngle = function(e1, t) {
            var i = Dh(e1, t);
            return Math.acos(2 * i * i - 1);
        }, jc.multiply = Ah, jc.rotateX = function(e1, t, i) {
            i *= .5;
            var r = t[0], n = t[1], o = t[2], s = t[3], a = Math.sin(i), l = Math.cos(i);
            return e1[0] = r * l + s * a, e1[1] = n * l + o * a, e1[2] = o * l - n * a, e1[3] = s * l - r * a, e1;
        }, jc.rotateY = function(e1, t, i) {
            i *= .5;
            var r = t[0], n = t[1], o = t[2], s = t[3], a = Math.sin(i), l = Math.cos(i);
            return e1[0] = r * l - o * a, e1[1] = n * l + s * a, e1[2] = o * l + r * a, e1[3] = s * l - n * a, e1;
        }, jc.rotateZ = function(e1, t, i) {
            i *= .5;
            var r = t[0], n = t[1], o = t[2], s = t[3], a = Math.sin(i), l = Math.cos(i);
            return e1[0] = r * l + n * a, e1[1] = n * l - r * a, e1[2] = o * l + s * a, e1[3] = s * l - o * a, e1;
        }, jc.calculateW = function(e1, t) {
            var i = t[0], r = t[1], n = t[2];
            return e1[0] = i, e1[1] = r, e1[2] = n, e1[3] = Math.sqrt(Math.abs(1 - i * i - r * r - n * n)), e1;
        }, jc.exp = Sh, jc.ln = Ih, jc.pow = function(e1, t, i) {
            return Ih(e1, t), Ph(e1, e1, i), Sh(e1, e1), e1;
        }, jc.slerp = Ch, jc.random = function(e1) {
            var t = yh.RANDOM(), i = yh.RANDOM(), r = yh.RANDOM(), n = Math.sqrt(1 - t), o = Math.sqrt(t);
            return e1[0] = n * Math.sin(2 * Math.PI * i), e1[1] = n * Math.cos(2 * Math.PI * i), e1[2] = o * Math.sin(2 * Math.PI * r), e1[3] = o * Math.cos(2 * Math.PI * r), e1;
        }, jc.invert = function(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = i * i + r * r + n * n + o * o, a = s ? 1 / s : 0;
            return e1[0] = -i * a, e1[1] = -r * a, e1[2] = -n * a, e1[3] = o * a, e1;
        }, jc.conjugate = function(e1, t) {
            return e1[0] = -t[0], e1[1] = -t[1], e1[2] = -t[2], e1[3] = t[3], e1;
        }, jc.fromMat3 = zh, jc.fromEuler = function(e1, t, i, r) {
            var n = .5 * Math.PI / 180;
            t *= n, i *= n, r *= n;
            var o = Math.sin(t), s = Math.cos(t), a = Math.sin(i), l = Math.cos(i), c = Math.sin(r), h = Math.cos(r);
            return e1[0] = o * l * h - s * a * c, e1[1] = s * a * h + o * l * c, e1[2] = s * l * c - o * a * h, e1[3] = s * l * h + o * a * c, e1;
        }, jc.str = function(e1) {
            return "quat(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ")";
        }, jc.setAxes = jc.sqlerp = jc.rotationTo = jc.equals = jc.exactEquals = jc.normalize = jc.sqrLen = jc.squaredLength = jc.len = jc.length = jc.lerp = jc.dot = jc.scale = jc.mul = jc.add = jc.set = jc.copy = jc.fromValues = jc.clone = void 0;
        var yh = Th(lc), xh = Th(Mc), vh = Th(Gc), bh = Th(nh);
        function wh(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (wh = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function Th(e1, t) {
            if (!t && e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== gh(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = wh(t);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }
        function Eh() {
            var e1 = new yh.ARRAY_TYPE(4);
            return yh.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1[3] = 1, e1;
        }
        function Mh(e1, t, i) {
            i *= .5;
            var r = Math.sin(i);
            return e1[0] = r * t[0], e1[1] = r * t[1], e1[2] = r * t[2], e1[3] = Math.cos(i), e1;
        }
        function Ah(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = i[0], l = i[1], c = i[2], h = i[3];
            return e1[0] = r * h + s * a + n * c - o * l, e1[1] = n * h + s * l + o * a - r * c, e1[2] = o * h + s * c + r * l - n * a, e1[3] = s * h - r * a - n * l - o * c, e1;
        }
        function Sh(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = Math.sqrt(i * i + r * r + n * n), a = Math.exp(o), l = s > 0 ? a * Math.sin(s) / s : 0;
            return e1[0] = i * l, e1[1] = r * l, e1[2] = n * l, e1[3] = a * Math.cos(s), e1;
        }
        function Ih(e1, t) {
            var i = t[0], r = t[1], n = t[2], o = t[3], s = Math.sqrt(i * i + r * r + n * n), a = s > 0 ? Math.atan2(s, o) / s : 0;
            return e1[0] = i * a, e1[1] = r * a, e1[2] = n * a, e1[3] = .5 * Math.log(i * i + r * r + n * n + o * o), e1;
        }
        function Ch(e1, t, i, r) {
            var n, o, s, a, l, c = t[0], h = t[1], u = t[2], d = t[3], p = i[0], f = i[1], m = i[2], _ = i[3];
            return (o = c * p + h * f + u * m + d * _) < 0 && (o = -o, p = -p, f = -f, m = -m, _ = -_), 1 - o > yh.EPSILON ? (n = Math.acos(o), s = Math.sin(n), a = Math.sin((1 - r) * n) / s, l = Math.sin(r * n) / s) : (a = 1 - r, l = r), e1[0] = a * c + l * p, e1[1] = a * h + l * f, e1[2] = a * u + l * m, e1[3] = a * d + l * _, e1;
        }
        function zh(e1, t) {
            var i, r = t[0] + t[4] + t[8];
            if (r > 0) i = Math.sqrt(r + 1), e1[3] = .5 * i, e1[0] = (t[5] - t[7]) * (i = .5 / i), e1[1] = (t[6] - t[2]) * i, e1[2] = (t[1] - t[3]) * i;
            else {
                var n = 0;
                t[4] > t[0] && (n = 1), t[8] > t[3 * n + n] && (n = 2);
                var o = (n + 1) % 3, s = (n + 2) % 3;
                i = Math.sqrt(t[3 * n + n] - t[3 * o + o] - t[3 * s + s] + 1), e1[n] = .5 * i, e1[3] = (t[3 * o + s] - t[3 * s + o]) * (i = .5 / i), e1[o] = (t[3 * o + n] + t[3 * n + o]) * i, e1[s] = (t[3 * s + n] + t[3 * n + s]) * i;
            }
            return e1;
        }
        jc.clone = bh.clone, jc.fromValues = bh.fromValues, jc.copy = bh.copy, jc.set = bh.set, jc.add = bh.add, jc.mul = Ah;
        var Ph = bh.scale;
        jc.scale = Ph;
        var Dh = bh.dot;
        jc.dot = Dh, jc.lerp = bh.lerp;
        var Rh = bh.length;
        jc.length = Rh, jc.len = Rh;
        var Lh = bh.squaredLength;
        jc.squaredLength = Lh, jc.sqrLen = Lh;
        var kh = bh.normalize;
        jc.normalize = kh, jc.exactEquals = bh.exactEquals, jc.equals = bh.equals;
        var Oh, Bh, Fh, Nh = (Oh = vh.create(), Bh = vh.fromValues(1, 0, 0), Fh = vh.fromValues(0, 1, 0), function(e1, t, i) {
            var r = vh.dot(t, i);
            return r < -0.999999 ? (vh.cross(Oh, Bh, t), vh.len(Oh) < 1e-6 && vh.cross(Oh, Fh, t), vh.normalize(Oh, Oh), Mh(e1, Oh, Math.PI), e1) : r > .999999 ? (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1) : (vh.cross(Oh, t, i), e1[0] = Oh[0], e1[1] = Oh[1], e1[2] = Oh[2], e1[3] = 1 + r, kh(e1, e1));
        });
        jc.rotationTo = Nh;
        var Uh, Vh, jh = (Uh = Eh(), Vh = Eh(), function(e1, t, i, r, n, o) {
            return Ch(Uh, t, n, o), Ch(Vh, i, r, o), Ch(e1, Uh, Vh, 2 * o * (1 - o)), e1;
        });
        jc.sqlerp = jh;
        var Gh, qh = (Gh = xh.create(), function(e1, t, i, r) {
            return Gh[0] = i[0], Gh[3] = i[1], Gh[6] = i[2], Gh[1] = r[0], Gh[4] = r[1], Gh[7] = r[2], Gh[2] = -t[0], Gh[5] = -t[1], Gh[8] = -t[2], kh(e1, zh(e1, Gh));
        });
        jc.setAxes = qh;
        var Zh = {};
        function $h(e1) {
            return $h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, $h(e1);
        }
        Object.defineProperty(Zh, "__esModule", {
            value: !0
        }), Zh.create = function() {
            var e1 = new Wh.ARRAY_TYPE(8);
            return Wh.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[4] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0), e1[3] = 1, e1;
        }, Zh.clone = function(e1) {
            var t = new Wh.ARRAY_TYPE(8);
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t;
        }, Zh.fromValues = function(e1, t, i, r, n, o, s, a) {
            var l = new Wh.ARRAY_TYPE(8);
            return l[0] = e1, l[1] = t, l[2] = i, l[3] = r, l[4] = n, l[5] = o, l[6] = s, l[7] = a, l;
        }, Zh.fromRotationTranslationValues = function(e1, t, i, r, n, o, s) {
            var a = new Wh.ARRAY_TYPE(8);
            a[0] = e1, a[1] = t, a[2] = i, a[3] = r;
            var l = .5 * n, c = .5 * o, h = .5 * s;
            return a[4] = l * r + c * i - h * t, a[5] = c * r + h * e1 - l * i, a[6] = h * r + l * t - c * e1, a[7] = -l * e1 - c * t - h * i, a;
        }, Zh.fromRotationTranslation = Jh, Zh.fromTranslation = function(e1, t) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1[4] = .5 * t[0], e1[5] = .5 * t[1], e1[6] = .5 * t[2], e1[7] = 0, e1;
        }, Zh.fromRotation = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1;
        }, Zh.fromMat4 = function(e1, t) {
            var i = Hh.create();
            Xh.getRotation(i, t);
            var r = new Wh.ARRAY_TYPE(3);
            return Xh.getTranslation(r, t), Jh(e1, i, r), e1;
        }, Zh.copy = Qh, Zh.identity = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1[4] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1;
        }, Zh.set = function(e1, t, i, r, n, o, s, a, l) {
            return e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = n, e1[4] = o, e1[5] = s, e1[6] = a, e1[7] = l, e1;
        }, Zh.getDual = function(e1, t) {
            return e1[0] = t[4], e1[1] = t[5], e1[2] = t[6], e1[3] = t[7], e1;
        }, Zh.setDual = function(e1, t) {
            return e1[4] = t[0], e1[5] = t[1], e1[6] = t[2], e1[7] = t[3], e1;
        }, Zh.getTranslation = function(e1, t) {
            var i = t[4], r = t[5], n = t[6], o = t[7], s = -t[0], a = -t[1], l = -t[2], c = t[3];
            return e1[0] = 2 * (i * c + o * s + r * l - n * a), e1[1] = 2 * (r * c + o * a + n * s - i * l), e1[2] = 2 * (n * c + o * l + i * a - r * s), e1;
        }, Zh.translate = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = .5 * i[0], l = .5 * i[1], c = .5 * i[2], h = t[4], u = t[5], d = t[6], p = t[7];
            return e1[0] = r, e1[1] = n, e1[2] = o, e1[3] = s, e1[4] = s * a + n * c - o * l + h, e1[5] = s * l + o * a - r * c + u, e1[6] = s * c + r * l - n * a + d, e1[7] = -r * a - n * l - o * c + p, e1;
        }, Zh.rotateX = function(e1, t, i) {
            var r = -t[0], n = -t[1], o = -t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = a * s + h * r + l * o - c * n, d = l * s + h * n + c * r - a * o, p = c * s + h * o + a * n - l * r, f = h * s - a * r - l * n - c * o;
            return Hh.rotateX(e1, t, i), e1[4] = u * (s = e1[3]) + f * (r = e1[0]) + d * (o = e1[2]) - p * (n = e1[1]), e1[5] = d * s + f * n + p * r - u * o, e1[6] = p * s + f * o + u * n - d * r, e1[7] = f * s - u * r - d * n - p * o, e1;
        }, Zh.rotateY = function(e1, t, i) {
            var r = -t[0], n = -t[1], o = -t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = a * s + h * r + l * o - c * n, d = l * s + h * n + c * r - a * o, p = c * s + h * o + a * n - l * r, f = h * s - a * r - l * n - c * o;
            return Hh.rotateY(e1, t, i), e1[4] = u * (s = e1[3]) + f * (r = e1[0]) + d * (o = e1[2]) - p * (n = e1[1]), e1[5] = d * s + f * n + p * r - u * o, e1[6] = p * s + f * o + u * n - d * r, e1[7] = f * s - u * r - d * n - p * o, e1;
        }, Zh.rotateZ = function(e1, t, i) {
            var r = -t[0], n = -t[1], o = -t[2], s = t[3], a = t[4], l = t[5], c = t[6], h = t[7], u = a * s + h * r + l * o - c * n, d = l * s + h * n + c * r - a * o, p = c * s + h * o + a * n - l * r, f = h * s - a * r - l * n - c * o;
            return Hh.rotateZ(e1, t, i), e1[4] = u * (s = e1[3]) + f * (r = e1[0]) + d * (o = e1[2]) - p * (n = e1[1]), e1[5] = d * s + f * n + p * r - u * o, e1[6] = p * s + f * o + u * n - d * r, e1[7] = f * s - u * r - d * n - p * o, e1;
        }, Zh.rotateByQuatAppend = function(e1, t, i) {
            var r = i[0], n = i[1], o = i[2], s = i[3], a = t[0], l = t[1], c = t[2], h = t[3];
            return e1[0] = a * s + h * r + l * o - c * n, e1[1] = l * s + h * n + c * r - a * o, e1[2] = c * s + h * o + a * n - l * r, e1[3] = h * s - a * r - l * n - c * o, e1[4] = (a = t[4]) * s + (h = t[7]) * r + (l = t[5]) * o - (c = t[6]) * n, e1[5] = l * s + h * n + c * r - a * o, e1[6] = c * s + h * o + a * n - l * r, e1[7] = h * s - a * r - l * n - c * o, e1;
        }, Zh.rotateByQuatPrepend = function(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = i[0], l = i[1], c = i[2], h = i[3];
            return e1[0] = r * h + s * a + n * c - o * l, e1[1] = n * h + s * l + o * a - r * c, e1[2] = o * h + s * c + r * l - n * a, e1[3] = s * h - r * a - n * l - o * c, e1[4] = r * (h = i[7]) + s * (a = i[4]) + n * (c = i[6]) - o * (l = i[5]), e1[5] = n * h + s * l + o * a - r * c, e1[6] = o * h + s * c + r * l - n * a, e1[7] = s * h - r * a - n * l - o * c, e1;
        }, Zh.rotateAroundAxis = function(e1, t, i, r) {
            if (Math.abs(r) < Wh.EPSILON) return Qh(e1, t);
            var n = Math.hypot(i[0], i[1], i[2]);
            r *= .5;
            var o = Math.sin(r), s = o * i[0] / n, a = o * i[1] / n, l = o * i[2] / n, c = Math.cos(r), h = t[0], u = t[1], d = t[2], p = t[3];
            e1[0] = h * c + p * s + u * l - d * a, e1[1] = u * c + p * a + d * s - h * l, e1[2] = d * c + p * l + h * a - u * s, e1[3] = p * c - h * s - u * a - d * l;
            var f = t[4], m = t[5], _ = t[6], g = t[7];
            return e1[4] = f * c + g * s + m * l - _ * a, e1[5] = m * c + g * a + _ * s - f * l, e1[6] = _ * c + g * l + f * a - m * s, e1[7] = g * c - f * s - m * a - _ * l, e1;
        }, Zh.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1[2] = t[2] + i[2], e1[3] = t[3] + i[3], e1[4] = t[4] + i[4], e1[5] = t[5] + i[5], e1[6] = t[6] + i[6], e1[7] = t[7] + i[7], e1;
        }, Zh.multiply = eu, Zh.scale = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1[2] = t[2] * i, e1[3] = t[3] * i, e1[4] = t[4] * i, e1[5] = t[5] * i, e1[6] = t[6] * i, e1[7] = t[7] * i, e1;
        }, Zh.lerp = function(e1, t, i, r) {
            var n = 1 - r;
            return tu(t, i) < 0 && (r = -r), e1[0] = t[0] * n + i[0] * r, e1[1] = t[1] * n + i[1] * r, e1[2] = t[2] * n + i[2] * r, e1[3] = t[3] * n + i[3] * r, e1[4] = t[4] * n + i[4] * r, e1[5] = t[5] * n + i[5] * r, e1[6] = t[6] * n + i[6] * r, e1[7] = t[7] * n + i[7] * r, e1;
        }, Zh.invert = function(e1, t) {
            var i = ru(t);
            return e1[0] = -t[0] / i, e1[1] = -t[1] / i, e1[2] = -t[2] / i, e1[3] = t[3] / i, e1[4] = -t[4] / i, e1[5] = -t[5] / i, e1[6] = -t[6] / i, e1[7] = t[7] / i, e1;
        }, Zh.conjugate = function(e1, t) {
            return e1[0] = -t[0], e1[1] = -t[1], e1[2] = -t[2], e1[3] = t[3], e1[4] = -t[4], e1[5] = -t[5], e1[6] = -t[6], e1[7] = t[7], e1;
        }, Zh.normalize = function(e1, t) {
            var i = ru(t);
            if (i > 0) {
                i = Math.sqrt(i);
                var r = t[0] / i, n = t[1] / i, o = t[2] / i, s = t[3] / i, a = t[4], l = t[5], c = t[6], h = t[7], u = r * a + n * l + o * c + s * h;
                e1[0] = r, e1[1] = n, e1[2] = o, e1[3] = s, e1[4] = (a - r * u) / i, e1[5] = (l - n * u) / i, e1[6] = (c - o * u) / i, e1[7] = (h - s * u) / i;
            }
            return e1;
        }, Zh.str = function(e1) {
            return "quat2(" + e1[0] + ", " + e1[1] + ", " + e1[2] + ", " + e1[3] + ", " + e1[4] + ", " + e1[5] + ", " + e1[6] + ", " + e1[7] + ")";
        }, Zh.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1] && e1[2] === t[2] && e1[3] === t[3] && e1[4] === t[4] && e1[5] === t[5] && e1[6] === t[6] && e1[7] === t[7];
        }, Zh.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = e1[2], o = e1[3], s = e1[4], a = e1[5], l = e1[6], c = e1[7], h = t[0], u = t[1], d = t[2], p = t[3], f = t[4], m = t[5], _ = t[6], g = t[7];
            return Math.abs(i - h) <= Wh.EPSILON * Math.max(1, Math.abs(i), Math.abs(h)) && Math.abs(r - u) <= Wh.EPSILON * Math.max(1, Math.abs(r), Math.abs(u)) && Math.abs(n - d) <= Wh.EPSILON * Math.max(1, Math.abs(n), Math.abs(d)) && Math.abs(o - p) <= Wh.EPSILON * Math.max(1, Math.abs(o), Math.abs(p)) && Math.abs(s - f) <= Wh.EPSILON * Math.max(1, Math.abs(s), Math.abs(f)) && Math.abs(a - m) <= Wh.EPSILON * Math.max(1, Math.abs(a), Math.abs(m)) && Math.abs(l - _) <= Wh.EPSILON * Math.max(1, Math.abs(l), Math.abs(_)) && Math.abs(c - g) <= Wh.EPSILON * Math.max(1, Math.abs(c), Math.abs(g));
        }, Zh.sqrLen = Zh.squaredLength = Zh.len = Zh.length = Zh.dot = Zh.mul = Zh.setReal = Zh.getReal = void 0;
        var Wh = Kh(lc), Hh = Kh(jc), Xh = Kh(Pc);
        function Yh(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (Yh = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function Kh(e1, t) {
            if (!t && e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== $h(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = Yh(t);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }
        function Jh(e1, t, i) {
            var r = .5 * i[0], n = .5 * i[1], o = .5 * i[2], s = t[0], a = t[1], l = t[2], c = t[3];
            return e1[0] = s, e1[1] = a, e1[2] = l, e1[3] = c, e1[4] = r * c + n * l - o * a, e1[5] = n * c + o * s - r * l, e1[6] = o * c + r * a - n * s, e1[7] = -r * s - n * a - o * l, e1;
        }
        function Qh(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1[2] = t[2], e1[3] = t[3], e1[4] = t[4], e1[5] = t[5], e1[6] = t[6], e1[7] = t[7], e1;
        }
        function eu(e1, t, i) {
            var r = t[0], n = t[1], o = t[2], s = t[3], a = i[4], l = i[5], c = i[6], h = i[7], u = t[4], d = t[5], p = t[6], f = t[7], m = i[0], _ = i[1], g = i[2], y = i[3];
            return e1[0] = r * y + s * m + n * g - o * _, e1[1] = n * y + s * _ + o * m - r * g, e1[2] = o * y + s * g + r * _ - n * m, e1[3] = s * y - r * m - n * _ - o * g, e1[4] = r * h + s * a + n * c - o * l + u * y + f * m + d * g - p * _, e1[5] = n * h + s * l + o * a - r * c + d * y + f * _ + p * m - u * g, e1[6] = o * h + s * c + r * l - n * a + p * y + f * g + u * _ - d * m, e1[7] = s * h - r * a - n * l - o * c + f * y - u * m - d * _ - p * g, e1;
        }
        Zh.getReal = Hh.copy, Zh.setReal = Hh.copy, Zh.mul = eu;
        var tu = Hh.dot;
        Zh.dot = tu;
        var iu = Hh.length;
        Zh.length = iu, Zh.len = iu;
        var ru = Hh.squaredLength;
        Zh.squaredLength = ru, Zh.sqrLen = ru;
        var nu = {};
        function ou(e1) {
            return ou = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, ou(e1);
        }
        Object.defineProperty(nu, "__esModule", {
            value: !0
        }), nu.create = lu, nu.clone = function(e1) {
            var t = new su.ARRAY_TYPE(2);
            return t[0] = e1[0], t[1] = e1[1], t;
        }, nu.fromValues = function(e1, t) {
            var i = new su.ARRAY_TYPE(2);
            return i[0] = e1, i[1] = t, i;
        }, nu.copy = function(e1, t) {
            return e1[0] = t[0], e1[1] = t[1], e1;
        }, nu.set = function(e1, t, i) {
            return e1[0] = t, e1[1] = i, e1;
        }, nu.add = function(e1, t, i) {
            return e1[0] = t[0] + i[0], e1[1] = t[1] + i[1], e1;
        }, nu.subtract = cu, nu.multiply = hu, nu.divide = uu, nu.ceil = function(e1, t) {
            return e1[0] = Math.ceil(t[0]), e1[1] = Math.ceil(t[1]), e1;
        }, nu.floor = function(e1, t) {
            return e1[0] = Math.floor(t[0]), e1[1] = Math.floor(t[1]), e1;
        }, nu.min = function(e1, t, i) {
            return e1[0] = Math.min(t[0], i[0]), e1[1] = Math.min(t[1], i[1]), e1;
        }, nu.max = function(e1, t, i) {
            return e1[0] = Math.max(t[0], i[0]), e1[1] = Math.max(t[1], i[1]), e1;
        }, nu.round = function(e1, t) {
            return e1[0] = Math.round(t[0]), e1[1] = Math.round(t[1]), e1;
        }, nu.scale = function(e1, t, i) {
            return e1[0] = t[0] * i, e1[1] = t[1] * i, e1;
        }, nu.scaleAndAdd = function(e1, t, i, r) {
            return e1[0] = t[0] + i[0] * r, e1[1] = t[1] + i[1] * r, e1;
        }, nu.distance = du, nu.squaredDistance = pu, nu.length = fu, nu.squaredLength = mu, nu.negate = function(e1, t) {
            return e1[0] = -t[0], e1[1] = -t[1], e1;
        }, nu.inverse = function(e1, t) {
            return e1[0] = 1 / t[0], e1[1] = 1 / t[1], e1;
        }, nu.normalize = function(e1, t) {
            var i = t[0], r = t[1], n = i * i + r * r;
            return n > 0 && (n = 1 / Math.sqrt(n)), e1[0] = t[0] * n, e1[1] = t[1] * n, e1;
        }, nu.dot = function(e1, t) {
            return e1[0] * t[0] + e1[1] * t[1];
        }, nu.cross = function(e1, t, i) {
            var r = t[0] * i[1] - t[1] * i[0];
            return e1[0] = e1[1] = 0, e1[2] = r, e1;
        }, nu.lerp = function(e1, t, i, r) {
            var n = t[0], o = t[1];
            return e1[0] = n + r * (i[0] - n), e1[1] = o + r * (i[1] - o), e1;
        }, nu.random = function(e1, t) {
            t = t || 1;
            var i = 2 * su.RANDOM() * Math.PI;
            return e1[0] = Math.cos(i) * t, e1[1] = Math.sin(i) * t, e1;
        }, nu.transformMat2 = function(e1, t, i) {
            var r = t[0], n = t[1];
            return e1[0] = i[0] * r + i[2] * n, e1[1] = i[1] * r + i[3] * n, e1;
        }, nu.transformMat2d = function(e1, t, i) {
            var r = t[0], n = t[1];
            return e1[0] = i[0] * r + i[2] * n + i[4], e1[1] = i[1] * r + i[3] * n + i[5], e1;
        }, nu.transformMat3 = function(e1, t, i) {
            var r = t[0], n = t[1];
            return e1[0] = i[0] * r + i[3] * n + i[6], e1[1] = i[1] * r + i[4] * n + i[7], e1;
        }, nu.transformMat4 = function(e1, t, i) {
            var r = t[0], n = t[1];
            return e1[0] = i[0] * r + i[4] * n + i[12], e1[1] = i[1] * r + i[5] * n + i[13], e1;
        }, nu.rotate = function(e1, t, i, r) {
            var n = t[0] - i[0], o = t[1] - i[1], s = Math.sin(r), a = Math.cos(r);
            return e1[0] = n * a - o * s + i[0], e1[1] = n * s + o * a + i[1], e1;
        }, nu.angle = function(e1, t) {
            var i = e1[0], r = e1[1], n = t[0], o = t[1], s = Math.sqrt(i * i + r * r) * Math.sqrt(n * n + o * o);
            return Math.acos(Math.min(Math.max(s && (i * n + r * o) / s, -1), 1));
        }, nu.zero = function(e1) {
            return e1[0] = 0, e1[1] = 0, e1;
        }, nu.str = function(e1) {
            return "vec2(" + e1[0] + ", " + e1[1] + ")";
        }, nu.exactEquals = function(e1, t) {
            return e1[0] === t[0] && e1[1] === t[1];
        }, nu.equals = function(e1, t) {
            var i = e1[0], r = e1[1], n = t[0], o = t[1];
            return Math.abs(i - n) <= su.EPSILON * Math.max(1, Math.abs(i), Math.abs(n)) && Math.abs(r - o) <= su.EPSILON * Math.max(1, Math.abs(r), Math.abs(o));
        }, nu.forEach = nu.sqrLen = nu.sqrDist = nu.dist = nu.div = nu.mul = nu.sub = nu.len = void 0;
        var su = function(e1, t) {
            if (e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== ou(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = au(void 0);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }(lc);
        function au(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (au = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function lu() {
            var e1 = new su.ARRAY_TYPE(2);
            return su.ARRAY_TYPE != Float32Array && (e1[0] = 0, e1[1] = 0), e1;
        }
        function cu(e1, t, i) {
            return e1[0] = t[0] - i[0], e1[1] = t[1] - i[1], e1;
        }
        function hu(e1, t, i) {
            return e1[0] = t[0] * i[0], e1[1] = t[1] * i[1], e1;
        }
        function uu(e1, t, i) {
            return e1[0] = t[0] / i[0], e1[1] = t[1] / i[1], e1;
        }
        function du(e1, t) {
            return Math.hypot(t[0] - e1[0], t[1] - e1[1]);
        }
        function pu(e1, t) {
            var i = t[0] - e1[0], r = t[1] - e1[1];
            return i * i + r * r;
        }
        function fu(e1) {
            return Math.hypot(e1[0], e1[1]);
        }
        function mu(e1) {
            var t = e1[0], i = e1[1];
            return t * t + i * i;
        }
        nu.len = fu, nu.sub = cu, nu.mul = hu, nu.div = uu, nu.dist = du, nu.sqrDist = pu, nu.sqrLen = mu;
        var _u = function() {
            var e1 = lu();
            return function(t, i, r, n, o, s) {
                var a, l;
                for(i || (i = 2), r || (r = 0), l = n ? Math.min(n * i + r, t.length) : t.length, a = r; a < l; a += i)e1[0] = t[a], e1[1] = t[a + 1], o(e1, e1, s), t[a] = e1[0], t[a + 1] = e1[1];
                return t;
            };
        }();
        function gu(e1) {
            return gu = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e1) {
                return typeof e1;
            } : function(e1) {
                return e1 && "function" == typeof Symbol && e1.constructor === Symbol && e1 !== Symbol.prototype ? "symbol" : typeof e1;
            }, gu(e1);
        }
        nu.forEach = _u, Object.defineProperty(ac, "__esModule", {
            value: !0
        });
        var yu = ac.vec4 = Du = ac.vec3 = ac.vec2 = ac.quat2 = Iu = ac.quat = Au = ac.mat4 = Eu = ac.mat3 = ac.mat2d = bu = ac.mat2 = ac.glMatrix = void 0, xu = ku(lc);
        ac.glMatrix = xu;
        var vu = ku(pc), bu = ac.mat2 = vu, wu = ku(xc);
        ac.mat2d = wu;
        var Tu = ku(Mc), Eu = ac.mat3 = Tu, Mu = ku(Pc), Au = ac.mat4 = Mu, Su = ku(jc), Iu = ac.quat = Su, Cu = ku(Zh);
        ac.quat2 = Cu;
        var zu = ku(nu);
        ac.vec2 = zu;
        var Pu = ku(Gc), Du = ac.vec3 = Pu, Ru = ku(nh);
        function Lu(e1) {
            if ("function" != typeof WeakMap) return null;
            var t = new WeakMap, i = new WeakMap;
            return (Lu = function(e1) {
                return e1 ? i : t;
            })(e1);
        }
        function ku(e1, t) {
            if (!t && e1 && e1.__esModule) return e1;
            if (null === e1 || "object" !== gu(e1) && "function" != typeof e1) return {
                default: e1
            };
            var i = Lu(t);
            if (i && i.has(e1)) return i.get(e1);
            var r = {}, n = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for(var o in e1)if ("default" !== o && Object.prototype.hasOwnProperty.call(e1, o)) {
                var s = n ? Object.getOwnPropertyDescriptor(e1, o) : null;
                s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e1[o];
            }
            return r.default = e1, i && i.set(e1, r), r;
        }
        yu = ac.vec4 = Ru;
        const Ou = Ia([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: Bu } = Ou, Fu = Ia([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var Nu = Ia([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]), Uu = {};
        !function(e1, t) {
            !function(e1) {
                function t(e1, t, r) {
                    var n = i(256 * e1, 256 * (t = Math.pow(2, r) - t - 1), r), o = i(256 * (e1 + 1), 256 * (t + 1), r);
                    return n[0] + "," + n[1] + "," + o[0] + "," + o[1];
                }
                function i(e1, t, i) {
                    var r = 2 * Math.PI * 6378137 / 256 / Math.pow(2, i);
                    return [
                        e1 * r - 2 * Math.PI * 6378137 / 2,
                        t * r - 2 * Math.PI * 6378137 / 2
                    ];
                }
                e1.getURL = function(e1, i, r, n, o, s) {
                    return s = s || {}, e1 + "?" + [
                        "bbox=" + t(r, n, o),
                        "format=" + (s.format || "image/png"),
                        "service=" + (s.service || "WMS"),
                        "version=" + (s.version || "1.1.1"),
                        "request=" + (s.request || "GetMap"),
                        "srs=" + (s.srs || "EPSG:3857"),
                        "width=" + (s.width || 256),
                        "height=" + (s.height || 256),
                        "layers=" + i
                    ].join("&");
                }, e1.getTileBBox = t, e1.getMercCoords = i, Object.defineProperty(e1, "__esModule", {
                    value: !0
                });
            }(t);
        }(0, Uu);
        var Vu = Uu;
        class ju {
            equals(e1) {
                return this.z === e1.z && this.x === e1.x && this.y === e1.y;
            }
            url(e1, t) {
                const i = Vu.getTileBBox(this.x, this.y, this.z), r = function(e1, t, i) {
                    let r, n = "";
                    for(let o = e1; o > 0; o--)r = 1 << o - 1, n += (t & r ? 1 : 0) + (i & r ? 2 : 0);
                    return n;
                }(this.z, this.x, this.y);
                return e1[(this.x + this.y) % e1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === t ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", r).replace("{bbox-epsg-3857}", i);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
            constructor(e1, t, i){
                this.z = e1, this.x = t, this.y = i, this.key = Zu(0, e1, e1, t, i);
            }
        }
        class Gu {
            constructor(e1, t){
                this.wrap = e1, this.canonical = t, this.key = Zu(e1, t.z, t.z, t.x, t.y);
            }
        }
        class qu {
            equals(e1) {
                return this.overscaledZ === e1.overscaledZ && this.wrap === e1.wrap && this.canonical.equals(e1.canonical);
            }
            scaledTo(e1) {
                const t = this.canonical.z - e1;
                return e1 > this.canonical.z ? new qu(e1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new qu(e1, this.wrap, e1, this.canonical.x >> t, this.canonical.y >> t);
            }
            calculateScaledKey(e1, t = !0) {
                if (this.overscaledZ === e1 && t) return this.key;
                if (e1 > this.canonical.z) return Zu(this.wrap * +t, e1, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const i = this.canonical.z - e1;
                    return Zu(this.wrap * +t, e1, e1, this.canonical.x >> i, this.canonical.y >> i);
                }
            }
            isChildOf(e1) {
                if (e1.wrap !== this.wrap) return !1;
                const t = this.canonical.z - e1.canonical.z;
                return 0 === e1.overscaledZ || e1.overscaledZ < this.overscaledZ && e1.canonical.z < this.canonical.z && e1.canonical.x === this.canonical.x >> t && e1.canonical.y === this.canonical.y >> t;
            }
            children(e1) {
                if (this.overscaledZ >= e1) return [
                    new qu(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const t = this.canonical.z + 1, i = 2 * this.canonical.x, r = 2 * this.canonical.y;
                return [
                    new qu(t, this.wrap, t, i, r),
                    new qu(t, this.wrap, t, i + 1, r),
                    new qu(t, this.wrap, t, i, r + 1),
                    new qu(t, this.wrap, t, i + 1, r + 1)
                ];
            }
            isLessThan(e1) {
                return this.wrap < e1.wrap || !(this.wrap > e1.wrap) && (this.overscaledZ < e1.overscaledZ || !(this.overscaledZ > e1.overscaledZ) && (this.canonical.x < e1.canonical.x || !(this.canonical.x > e1.canonical.x) && this.canonical.y < e1.canonical.y));
            }
            wrapped() {
                return new qu(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(e1) {
                return new qu(this.overscaledZ, e1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new Gu(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
            constructor(e1, t, i, r, n){
                this.overscaledZ = e1, this.wrap = t, this.canonical = new ju(i, +r, +n), this.key = 0 === t && e1 === i ? this.canonical.key : Zu(t, e1, i, r, n);
            }
        }
        function Zu(e1, t, i, r, n) {
            const o = 1 << Math.min(i, 22);
            let s = o * (n % o) + r % o;
            return e1 && i < 22 && (s += o * o * ((e1 < 0 ? -2 * e1 - 1 : 2 * e1) % (1 << 2 * (22 - i)))), 16 * (32 * s + i) + (t - i);
        }
        const $u = [
            (e1)=>{
                let t = e1.canonical.x - 1, i = e1.wrap;
                return t < 0 && (t = (1 << e1.canonical.z) - 1, i--), new qu(e1.overscaledZ, i, e1.canonical.z, t, e1.canonical.y);
            },
            (e1)=>{
                let t = e1.canonical.x + 1, i = e1.wrap;
                return t === 1 << e1.canonical.z && (t = 0, i++), new qu(e1.overscaledZ, i, e1.canonical.z, t, e1.canonical.y);
            },
            (e1)=>new qu(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, (0 === e1.canonical.y ? 1 << e1.canonical.z : e1.canonical.y) - 1),
            (e1)=>new qu(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y === (1 << e1.canonical.z) - 1 ? 0 : e1.canonical.y + 1)
        ];
        Rs(ju, "CanonicalTileID"), Rs(qu, "OverscaledTileID", {
            omit: [
                "projMatrix",
                "expandedProjMatrix"
            ]
        });
        class Wu {
            intersectsPlane(e1, t, i) {
                const r = Du.dot(t, this.dir);
                if (Math.abs(r) < 1e-6) return !1;
                const n = ((e1[0] - this.pos[0]) * t[0] + (e1[1] - this.pos[1]) * t[1] + (e1[2] - this.pos[2]) * t[2]) / r;
                return i[0] = this.pos[0] + this.dir[0] * n, i[1] = this.pos[1] + this.dir[1] * n, i[2] = this.pos[2] + this.dir[2] * n, !0;
            }
            closestPointOnSphere(e1, t, i) {
                if (Du.equals(this.pos, e1) || 0 === t) return i[0] = i[1] = i[2] = 0, !1;
                const [r, n, o] = this.dir, s = this.pos[0] - e1[0], a = this.pos[1] - e1[1], l = this.pos[2] - e1[2], c = r * r + n * n + o * o, h = 2 * (s * r + a * n + l * o), u = h * h - 4 * c * (s * s + a * a + l * l - t * t);
                if (u < 0) {
                    const e1 = Math.max(-h / 2, 0), c = s + r * e1, u = a + n * e1, d = l + o * e1, p = Math.hypot(c, u, d);
                    return i[0] = c * t / p, i[1] = u * t / p, i[2] = d * t / p, !1;
                }
                {
                    const e1 = (-h - Math.sqrt(u)) / (2 * c);
                    if (e1 < 0) {
                        const e1 = Math.hypot(s, a, l);
                        return i[0] = s * t / e1, i[1] = a * t / e1, i[2] = l * t / e1, !1;
                    }
                    return i[0] = s + r * e1, i[1] = a + n * e1, i[2] = l + o * e1, !0;
                }
            }
            constructor(e1, t){
                this.pos = e1, this.dir = t;
            }
        }
        class Hu {
            static fromInvProjectionMatrix(e1, t, i) {
                const r = [
                    -1,
                    1,
                    1
                ], n = [
                    1,
                    1,
                    1
                ], o = [
                    1,
                    -1,
                    1
                ], s = [
                    -1,
                    -1,
                    1
                ], a = Du.transformMat4(r, r, e1), l = Du.transformMat4(n, n, e1), c = Du.transformMat4(o, o, e1), h = Du.transformMat4(s, s, e1);
                return new Hu(a, l, c, h, t / i);
            }
            constructor(e1, t, i, r, n){
                this.TL = e1, this.TR = t, this.BR = i, this.BL = r, this.horizon = n;
            }
        }
        function Xu(e1, t, i) {
            let r = 1 / 0, n = -1 / 0;
            const o = [];
            for (const s of e1){
                Du.sub(o, s, t);
                const e1 = Du.dot(o, i);
                r = Math.min(r, e1), n = Math.max(n, e1);
            }
            return [
                r,
                n
            ];
        }
        function Yu(e1, t) {
            let i = !0;
            for(let r = 0; r < e1.planes.length; r++){
                const n = e1.planes[r];
                let o = 0;
                for(let e1 = 0; e1 < t.length; e1++)o += Du.dot(n, t[e1]) + n[3] >= 0;
                if (0 === o) return 0;
                o !== t.length && (i = !1);
            }
            return i ? 2 : 1;
        }
        function Ku(e1, t) {
            for (const i of e1.projections){
                const r = Xu(t, e1.points[0], i.axis);
                if (i.projection[1] < r[0] || i.projection[0] > r[1]) return 0;
            }
            return 1;
        }
        function Ju(e1, t) {
            let i = 0;
            const r = [
                0,
                0,
                0,
                0
            ];
            for(let n = 0; n < e1.length; n++)r[0] = e1[n][0], r[1] = e1[n][1], r[2] = e1[n][2], r[3] = 1, yu.dot(r, t) >= 0 && i++;
            return i;
        }
        class Qu {
            static fromInvProjectionMatrix(e1, t, i, r) {
                const n = Math.pow(2, i), o = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((i)=>{
                    const o = yu.transformMat4([], i, e1), s = 1 / o[3] / t * n;
                    return yu.mul(o, o, [
                        s,
                        s,
                        r ? 1 / o[3] : s,
                        s
                    ]);
                }), s = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((e1)=>{
                    const t = Du.sub([], o[e1[0]], o[e1[1]]), i = Du.sub([], o[e1[2]], o[e1[1]]), r = Du.normalize([], Du.cross([], t, i)), n = -Du.dot(r, o[e1[1]]);
                    return r.concat(n);
                }), a = [];
                for(let e1 = 0; e1 < o.length; e1++)a.push([
                    o[e1][0],
                    o[e1][1],
                    o[e1][2]
                ]);
                return new Qu(a, s);
            }
            intersectsPrecise(e1, t, i) {
                for(let i = 0; i < t.length; i++)if (!Ju(e1, t[i])) return 0;
                for(let t = 0; t < this.planes.length; t++)if (!Ju(e1, this.planes[t])) return 0;
                for (const t of i)for (const i of this.frustumEdges){
                    const r = Du.cross([], t, i), n = Du.length(r);
                    if (0 === n) continue;
                    Du.scale(r, r, 1 / n);
                    const o = Xu(this.points, this.points[0], r), s = Xu(e1, this.points[0], r);
                    if (o[0] > s[1] || s[0] > o[1]) return 0;
                }
                return 1;
            }
            constructor(e1, t){
                this.points = e1 || new Array(8).fill([
                    0,
                    0,
                    0
                ]), this.planes = t || new Array(6).fill([
                    0,
                    0,
                    0,
                    0
                ]), this.bounds = ed.fromPoints(this.points), this.projections = [], this.frustumEdges = [
                    Du.sub([], this.points[2], this.points[3]),
                    Du.sub([], this.points[0], this.points[3]),
                    Du.sub([], this.points[4], this.points[0]),
                    Du.sub([], this.points[5], this.points[1]),
                    Du.sub([], this.points[6], this.points[2]),
                    Du.sub([], this.points[7], this.points[3])
                ];
                for (const e1 of this.frustumEdges){
                    const t = [
                        0,
                        -e1[2],
                        e1[1]
                    ], i = [
                        e1[2],
                        0,
                        -e1[0]
                    ];
                    this.projections.push({
                        axis: t,
                        projection: Xu(this.points, this.points[0], t)
                    }), this.projections.push({
                        axis: i,
                        projection: Xu(this.points, this.points[0], i)
                    });
                }
            }
        }
        class ed {
            static fromPoints(e1) {
                const t = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], i = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (const r of e1)Du.min(t, t, r), Du.max(i, i, r);
                return new ed(t, i);
            }
            static fromTileIdAndHeight(e1, t, i) {
                const r = 1 << e1.canonical.z, n = e1.canonical.x, o = e1.canonical.y;
                return new ed([
                    n / r,
                    o / r,
                    t
                ], [
                    (n + 1) / r,
                    (o + 1) / r,
                    i
                ]);
            }
            static applyTransform(e1, t) {
                const i = e1.getCorners();
                for(let e1 = 0; e1 < i.length; ++e1)Du.transformMat4(i[e1], i[e1], t);
                return ed.fromPoints(i);
            }
            static projectAabbCorners(e1, t) {
                const i = e1.getCorners();
                for(let e1 = 0; e1 < i.length; ++e1)Du.transformMat4(i[e1], i[e1], t);
                return i;
            }
            quadrant(e1) {
                const t = [
                    e1 % 2 == 0,
                    e1 < 2
                ], i = Du.clone(this.min), r = Du.clone(this.max);
                for(let e1 = 0; e1 < t.length; e1++)i[e1] = t[e1] ? this.min[e1] : this.center[e1], r[e1] = t[e1] ? this.center[e1] : this.max[e1];
                return r[2] = this.max[2], new ed(i, r);
            }
            distanceX(e1) {
                return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
            }
            distanceY(e1) {
                return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
            }
            distanceZ(e1) {
                return Math.max(Math.min(this.max[2], e1[2]), this.min[2]) - e1[2];
            }
            getCorners() {
                const e1 = this.min, t = this.max;
                return [
                    [
                        e1[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t[0],
                        t[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        t[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        e1[1],
                        t[2]
                    ],
                    [
                        t[0],
                        e1[1],
                        t[2]
                    ],
                    [
                        t[0],
                        t[1],
                        t[2]
                    ],
                    [
                        e1[0],
                        t[1],
                        t[2]
                    ]
                ];
            }
            intersects(e1) {
                return this.intersectsAabb(e1.bounds) ? Yu(e1, this.getCorners()) : 0;
            }
            intersectsFlat(e1) {
                return this.intersectsAabb(e1.bounds) ? Yu(e1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsPrecise(e1, t) {
                return t || this.intersects(e1) ? Ku(e1, this.getCorners()) : 0;
            }
            intersectsPreciseFlat(e1, t) {
                return t || this.intersectsFlat(e1) ? Ku(e1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsAabb(e1) {
                for(let t = 0; t < 3; ++t)if (this.min[t] > e1.max[t] || e1.min[t] > this.max[t]) return !1;
                return !0;
            }
            intersectsAabbXY(e1) {
                return !(this.min[0] > e1.max[0] || e1.min[0] > this.max[0] || this.min[1] > e1.max[1] || e1.min[1] > this.max[1]);
            }
            encapsulate(e1) {
                for(let t = 0; t < 3; t++)this.min[t] = Math.min(this.min[t], e1.min[t]), this.max[t] = Math.max(this.max[t], e1.max[t]);
            }
            encapsulatePoint(e1) {
                for(let t = 0; t < 3; t++)this.min[t] = Math.min(this.min[t], e1[t]), this.max[t] = Math.max(this.max[t], e1[t]);
            }
            closestPoint(e1) {
                return [
                    Math.max(Math.min(this.max[0], e1[0]), this.min[0]),
                    Math.max(Math.min(this.max[1], e1[1]), this.min[1]),
                    Math.max(Math.min(this.max[2], e1[2]), this.min[2])
                ];
            }
            constructor(e1, t){
                this.min = e1, this.max = t, this.center = Du.scale([], Du.add([], this.min, this.max), .5);
            }
        }
        Rs(ed, "Aabb");
        const td = 5, id = 6, rd = cr / Math.PI / 2, nd = 16383, od = 64, sd = [
            od,
            32,
            16
        ], ad = -rd, ld = rd, cd = [
            new ed([
                ad,
                ad,
                ad
            ], [
                ld,
                ld,
                ld
            ]),
            new ed([
                ad,
                ad,
                ad
            ], [
                0,
                0,
                ld
            ]),
            new ed([
                0,
                ad,
                ad
            ], [
                ld,
                0,
                ld
            ]),
            new ed([
                ad,
                0,
                ad
            ], [
                0,
                ld,
                ld
            ]),
            new ed([
                0,
                0,
                ad
            ], [
                ld,
                ld,
                ld
            ])
        ];
        function hd(e1) {
            return e1 * rd / qd;
        }
        function ud(e1, t, i, r = !0) {
            const n = Du.scale([], e1._camera.position, e1.worldSize), o = [
                t,
                i,
                1,
                1
            ];
            yu.transformMat4(o, o, e1.pixelMatrixInverse), yu.scale(o, o, 1 / o[3]);
            const s = Du.sub([], o, n), a = Du.normalize([], s), l = e1.globeMatrix, c = [
                l[12],
                l[13],
                l[14]
            ], h = Du.sub([], c, n), u = Du.length(h), d = Du.normalize([], h), p = e1.worldSize / (2 * Math.PI), f = Du.dot(d, a), m = Math.asin(p / u);
            if (m < Math.acos(f)) {
                if (!r) return null;
                const e1 = [], t = [];
                Du.scale(e1, a, u / f), Du.normalize(t, Du.sub(t, e1, h)), Du.normalize(a, Du.add(a, h, Du.scale(a, t, Math.tan(m) * u)));
            }
            const _ = [];
            new Wu(n, a).closestPointOnSphere(c, p, _);
            const g = Du.normalize([], ne(l, 0)), y = Du.normalize([], ne(l, 1)), x = Du.normalize([], ne(l, 2)), v = Du.dot(g, _), b = Du.dot(y, _), w = Du.dot(x, _), E = T(Math.asin(-b / p));
            let M = T(Math.atan2(v, w));
            M = e1.center.lng + function(e1, t) {
                const i = (t - e1 + 180) % 360 - 180;
                return i < -180 ? i + 360 : i;
            }(e1.center.lng, M);
            const A = Kd(M), S = z(Jd(E), 0, 1);
            return new lp(A, S);
        }
        class dd {
            constructor(e1, t, i){
                this.a = Du.sub([], e1, i), this.b = Du.sub([], t, i), this.center = i;
                const r = Du.normalize([], this.a), n = Du.normalize([], this.b);
                this.angle = Math.acos(Du.dot(r, n));
            }
        }
        function pd(e1, t) {
            if (0 === e1.angle) return null;
            let i;
            return i = 0 === e1.a[t] ? 1 / e1.angle * .5 * Math.PI : 1 / e1.angle * Math.atan(e1.b[t] / e1.a[t] / Math.sin(e1.angle) - 1 / Math.tan(e1.angle)), i < 0 || i > 1 ? null : function(e1, t, i, r) {
                const n = Math.sin(i);
                return e1 * (Math.sin((1 - r) * i) / n) + t * (Math.sin(r * i) / n);
            }(e1.a[t], e1.b[t], e1.angle, z(i, 0, 1)) + e1.center[t];
        }
        function fd(e1) {
            if (e1.z <= 1) return cd[e1.z + 2 * e1.y + e1.x];
            const t = vd(xd(e1));
            return ed.fromPoints(t);
        }
        function md(e1, t, i) {
            return Du.scale(e1, e1, 1 - i), Du.scaleAndAdd(e1, e1, t, i);
        }
        function _d(e1, t) {
            const i = Dd(t.zoom);
            if (0 === i) return fd(e1);
            const r = xd(e1), n = vd(r), o = Kd(r.getWest()) * t.worldSize, s = Kd(r.getEast()) * t.worldSize, a = Jd(r.getNorth()) * t.worldSize, l = Jd(r.getSouth()) * t.worldSize, c = [
                o,
                a,
                0
            ], h = [
                s,
                a,
                0
            ], u = [
                o,
                l,
                0
            ], d = [
                s,
                l,
                0
            ], p = Au.invert([], t.globeMatrix);
            return Du.transformMat4(c, c, p), Du.transformMat4(h, h, p), Du.transformMat4(u, u, p), Du.transformMat4(d, d, p), n[0] = md(n[0], u, i), n[1] = md(n[1], d, i), n[2] = md(n[2], h, i), n[3] = md(n[3], c, i), ed.fromPoints(n);
        }
        function gd(e1, t, i) {
            for (const r of e1)Du.transformMat4(r, r, t), Du.scale(r, r, i);
        }
        function yd(e1, t, i, r) {
            const n = t / e1.worldSize, o = e1.globeMatrix;
            if (i.z <= 1) {
                const e1 = fd(i).getCorners();
                return gd(e1, o, n), ed.fromPoints(e1);
            }
            const s = xd(i, r), a = vd(s);
            gd(a, o, n);
            const l = Number.MAX_VALUE, c = [
                -l,
                -l,
                -l
            ], h = [
                l,
                l,
                l
            ];
            if (s.contains(e1.center)) {
                for (const e1 of a)Du.min(h, h, e1), Du.max(c, c, e1);
                c[2] = 0;
                const t = e1.point, i = [
                    t.x * n,
                    t.y * n,
                    0
                ];
                return Du.min(h, h, i), Du.max(c, c, i), new ed(h, c);
            }
            const u = [
                o[12] * n,
                o[13] * n,
                o[14] * n
            ], d = s.getCenter(), p = z(e1.center.lat, -rp, rp), f = z(d.lat, -rp, rp), m = Kd(e1.center.lng), _ = Jd(p);
            let g = m - Kd(d.lng);
            const y = _ - Jd(f);
            g > .5 ? g -= 1 : g < -0.5 && (g += 1);
            let x = 0;
            if (Math.abs(g) > Math.abs(y)) x = g >= 0 ? 1 : 3;
            else {
                x = y >= 0 ? 0 : 2;
                const e1 = [
                    o[4] * n,
                    o[5] * n,
                    o[6] * n
                ], t = -Math.sin(w(y >= 0 ? s.getSouth() : s.getNorth())) * rd;
                Du.scaleAndAdd(u, u, e1, t);
            }
            const v = a[x], b = a[(x + 1) % 4], T = new dd(v, b, u), E = [
                pd(T, 0) || v[0],
                pd(T, 1) || v[1],
                pd(T, 2) || v[2]
            ], M = Dd(e1.zoom);
            if (M > 0) {
                const r = function({ x: e1, y: t, z: i }, r, n, o, s) {
                    const a = 1 / (1 << i);
                    let l = e1 * a, c = l + a, h = t * a, u = h + a, d = 0;
                    const p = (l + c) / 2 - o;
                    return p > .5 ? d = -1 : p < -0.5 && (d = 1), l = ((l + d) * r - (o *= r)) * n + o, c = ((c + d) * r - o) * n + o, h = (h * r - (s *= r)) * n + s, u = (u * r - s) * n + s, [
                        [
                            l,
                            u,
                            0
                        ],
                        [
                            c,
                            u,
                            0
                        ],
                        [
                            c,
                            h,
                            0
                        ],
                        [
                            l,
                            h,
                            0
                        ]
                    ];
                }(i, t, e1._pixelsPerMercatorPixel, m, _);
                for(let e1 = 0; e1 < a.length; e1++)md(a[e1], r[e1], M);
                const n = Du.add([], r[x], r[(x + 1) % 4]);
                Du.scale(n, n, .5), md(E, n, M);
            }
            for (const e1 of a)Du.min(h, h, e1), Du.max(c, c, e1);
            return h[2] = Math.min(v[2], b[2]), Du.min(h, h, E), Du.max(c, c, E), new ed(h, c);
        }
        function xd({ x: e1, y: t, z: i }, r = !1) {
            const n = 1 / (1 << i), o = new Wd(ep(e1 * n), t === (1 << i) - 1 && r ? -90 : tp((t + 1) * n)), s = new Wd(ep((e1 + 1) * n), 0 === t && r ? 90 : tp(t * n));
            return new sc(o, s);
        }
        function vd(e1) {
            const t = w(e1.getNorth()), i = w(e1.getSouth()), r = Math.cos(t), n = Math.cos(i), o = Math.sin(t), s = Math.sin(i), a = e1.getWest(), l = e1.getEast();
            return [
                bd(n, s, a),
                bd(n, s, l),
                bd(r, o, l),
                bd(r, o, a)
            ];
        }
        function bd(e1, t, i, r = rd) {
            return i = w(i), [
                e1 * Math.sin(i) * r,
                -t * r,
                e1 * Math.cos(i) * r
            ];
        }
        function wd(e1, t, i) {
            return bd(Math.cos(w(e1)), Math.sin(w(e1)), t, i);
        }
        function Td(e1, t, i, r) {
            const n = 1 << i.z, o = (e1 / cr + i.x) / n;
            return wd(tp((t / cr + i.y) / n), ep(o), r);
        }
        function Ed({ min: e1, max: t }) {
            return nd / Math.max(t[0] - e1[0], t[1] - e1[1], t[2] - e1[2]);
        }
        const Md = new Float64Array(16);
        function Ad(e1) {
            const t = Ed(e1), i = Au.fromScaling(Md, [
                t,
                t,
                t
            ]);
            return Au.translate(i, i, Du.negate([], e1.min));
        }
        function Sd(e1) {
            const t = Au.fromTranslation(Md, e1.min), i = 1 / Ed(e1);
            return Au.scale(t, t, [
                i,
                i,
                i
            ]);
        }
        function Id(e1) {
            const t = cr / (2 * Math.PI);
            return e1 / (2 * Math.PI) / t;
        }
        function Cd(e1, t) {
            return cr / (512 * Math.pow(2, e1)) * Ed(fd(t));
        }
        function zd(e1, t, i, r, n) {
            const o = Id(i), s = [
                e1,
                t,
                -i / (2 * Math.PI)
            ], a = Au.identity(new Float64Array(16));
            return Au.translate(a, a, s), Au.scale(a, a, [
                o,
                o,
                o
            ]), Au.rotateX(a, a, w(-n)), Au.rotateY(a, a, w(-r)), a;
        }
        function Pd(e1) {
            const t = e1.pixelsPerMeter, i = t / Qd(1, e1.center.lat), r = Au.identity(new Float64Array(16));
            return Au.translate(r, r, [
                e1.point.x,
                e1.point.y,
                0
            ]), Au.scale(r, r, [
                i,
                i,
                t
            ]), Float32Array.from(r);
        }
        function Dd(e1) {
            return P(td, id, e1);
        }
        function Rd(e1, t, i) {
            const r = Au.identity(new Float64Array(16)), n = (t / (1 << e1) - .5) * Math.PI * 2;
            return Au.rotateY(r, i.globeMatrix, n), Float32Array.from(r);
        }
        function Ld(e1, t, i) {
            const r = Dd(i.zoom), n = e1.style.map._antialias, o = t.options.extStandardDerivativesForceOff || e1.terrain && e1.terrain.exaggeration() > 0;
            return 0 === r && !n && !o;
        }
        function kd(e1, t, i, r) {
            const n = t.getNorth(), o = t.getSouth(), s = t.getWest(), a = t.getEast(), l = 1 << e1.z, c = a - s, h = n - o, u = c / od, d = -h / sd[i], p = [
                0,
                u,
                0,
                d,
                0,
                0,
                n,
                s,
                0
            ];
            if (e1.z > 0) {
                const e1 = 180 / r;
                Eu.multiply(p, p, [
                    e1 / c + 1,
                    0,
                    0,
                    0,
                    e1 / h + 1,
                    0,
                    -0.5 * e1 / u,
                    .5 * e1 / d,
                    1
                ]);
            }
            return p[2] = l, p[5] = e1.x, p[8] = e1.y, p;
        }
        function Od(e1) {
            const t = rp - 5;
            e1 = z(e1, -t, t) / t * 90;
            const i = Math.pow(Math.abs(Math.sin(w(e1))), 3);
            return Math.round(i * (sd.length - 1));
        }
        function Bd(e1) {
            const t = [
                0,
                0,
                0
            ], i = Au.identity(new Float64Array(16));
            return Au.multiply(i, e1.pixelMatrix, e1.globeMatrix), Du.transformMat4(t, t, i), new y(t[0], t[1]);
        }
        function Fd(e1, t) {
            const i = wd(t.lat, t.lng), r = function(e1) {
                const t = wd(e1._center.lat, e1._center.lng), i = Du.fromValues(0, 1, 0);
                let r = Du.cross([], i, t);
                const n = Au.fromRotation([], -e1.angle, t);
                r = Du.transformMat4(r, r, n), Au.fromRotation(n, -e1._pitch, r);
                const o = Du.normalize([], t);
                return Du.scale(o, o, hd(e1.cameraToCenterDistance / e1.pixelsPerMeter)), Du.transformMat4(o, o, n), Du.add([], t, o);
            }(e1), n = Du.subtract([], r, i);
            return Du.angle(n, i);
        }
        function Nd(e1, t) {
            return Fd(e1, t) > Math.PI / 2 * 1.01;
        }
        const Ud = w(85), Vd = Math.cos(Ud), jd = Math.sin(Ud);
        class Gd {
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const e1 of this._poleSegments)e1.destroy();
                for (const e1 of this._gridSegments)e1.withSkirts.destroy(), e1.withoutSkirts.destroy();
            }
            _fillGridMeshWithLods(e1, t) {
                const i = new za, r = new Wa, n = [], o = e1 + 1 + 2, s = t[0] + 1, a = t[0] + 1 + (1 + t.length), l = (e1, t, i)=>{
                    let r = e1 === o - 1 ? e1 - 2 : 0 === e1 ? e1 : e1 - 1;
                    return r += i ? 24575 : 0, [
                        r,
                        t
                    ];
                };
                for(let e1 = 0; e1 < o; ++e1)i.emplaceBack(...l(e1, 0, !0));
                for(let e1 = 0; e1 < s; ++e1)for(let t = 0; t < o; ++t)i.emplaceBack(...l(t, e1, (0 === t || t === o - 1) && !0));
                for(let e1 = 0; e1 < t.length; ++e1){
                    const r = t[e1];
                    for(let e1 = 0; e1 < o; ++e1)i.emplaceBack(...l(e1, r, !0));
                }
                for(let e1 = 0; e1 < t.length; ++e1){
                    const s = r.length, l = t[e1] + 1 + 2, c = new Wa;
                    for(let i = 0; i < l - 1; i++){
                        const n = i === l - 2, s = n ? o * (a - t.length + e1 - i) : o;
                        for(let e1 = 0; e1 < o - 1; e1++){
                            const t = i * o + e1;
                            0 === i || n || 0 === e1 || e1 === o - 2 ? (c.emplaceBack(t + 1, t, t + s), c.emplaceBack(t + s, t + s + 1, t + 1)) : (r.emplaceBack(t + 1, t, t + s), r.emplaceBack(t + s, t + s + 1, t + 1));
                        }
                    }
                    const h = xl.simpleSegment(0, s, i.length, r.length - s);
                    for(let e1 = 0; e1 < c.uint16.length; e1 += 3)r.emplaceBack(c.uint16[e1], c.uint16[e1 + 1], c.uint16[e1 + 2]);
                    const u = xl.simpleSegment(0, s, i.length, r.length - s);
                    n.push({
                        withoutSkirts: h,
                        withSkirts: u
                    });
                }
                return {
                    vertices: i,
                    indices: r,
                    segments: n
                };
            }
            _createGrid(e1) {
                const t = this._fillGridMeshWithLods(od, sd);
                this._gridSegments = t.segments, this._gridBuffer = e1.createVertexBuffer(t.vertices, Nu.members), this._gridIndexBuffer = e1.createIndexBuffer(t.indices, !0);
            }
            _createPoles(e1) {
                const t = new Wa;
                for(let e1 = 0; e1 <= od; e1++)t.emplaceBack(0, e1 + 1, e1 + 2);
                this._poleIndexBuffer = e1.createIndexBuffer(t, !0);
                const i = new Ka, r = new Ka, n = new Ka, o = new Ka;
                this._poleSegments = [];
                for(let e1 = 0, t = 0; e1 < td; e1++){
                    const s = 360 / (1 << e1);
                    i.emplaceBack(0, -rd, 0, .5, 0), r.emplaceBack(0, -rd, 0, .5, 1), n.emplaceBack(0, -rd, 0, .5, .5), o.emplaceBack(0, -rd, 0, .5, .5);
                    for(let e1 = 0; e1 <= od; e1++){
                        let t = e1 / od, a = 0;
                        const l = Kr(0, s, t), [c, h, u] = bd(Vd, jd, l, rd);
                        i.emplaceBack(c, h, u, t, a), r.emplaceBack(c, h, u, t, 1 - a);
                        const d = w(l);
                        t = .5 + .5 * Math.sin(d), a = .5 + .5 * Math.cos(d), n.emplaceBack(c, h, u, t, a), o.emplaceBack(c, h, u, t, 1 - a);
                    }
                    this._poleSegments.push(xl.simpleSegment(t, 0, 66, 64)), t += 66;
                }
                this._poleNorthVertexBuffer = e1.createVertexBuffer(i, Bu, !1), this._poleSouthVertexBuffer = e1.createVertexBuffer(r, Bu, !1), this._texturedPoleNorthVertexBuffer = e1.createVertexBuffer(n, Bu, !1), this._texturedPoleSouthVertexBuffer = e1.createVertexBuffer(o, Bu, !1);
            }
            getGridBuffers(e1, t) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    t ? this._gridSegments[e1].withSkirts : this._gridSegments[e1].withoutSkirts
                ];
            }
            getPoleBuffers(e1, t) {
                return [
                    t ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer,
                    t ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[e1]
                ];
            }
            constructor(e1){
                this._createGrid(e1), this._createPoles(e1);
            }
        }
        const qd = 6371008.8, Zd = 2 * Math.PI * qd;
        class $d {
            wrap() {
                return new $d(D(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(e1) {
                const t = Math.PI / 180, i = this.lat * t, r = e1.lat * t, n = Math.sin(i) * Math.sin(r) + Math.cos(i) * Math.cos(r) * Math.cos((e1.lng - this.lng) * t);
                return qd * Math.acos(Math.min(n, 1));
            }
            toBounds(e1 = 0) {
                const t = 360 * e1 / 40075017, i = t / Math.cos(Math.PI / 180 * this.lat);
                return new sc(new $d(this.lng - i, this.lat - t), new $d(this.lng + i, this.lat + t));
            }
            toEcef(e1) {
                const t = hd(e1);
                return wd(this.lat, this.lng, rd + t);
            }
            static convert(e1) {
                if (e1 instanceof $d) return e1;
                if (Array.isArray(e1) && (2 === e1.length || 3 === e1.length)) return new $d(Number(e1[0]), Number(e1[1]));
                if (!Array.isArray(e1) && "object" == typeof e1 && null !== e1) return new $d(Number("lng" in e1 ? e1.lng : e1.lon), Number(e1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
            constructor(e1, t){
                if (isNaN(e1) || isNaN(t)) throw new Error(`Invalid LngLat object: (${e1}, ${t})`);
                if (this.lng = +e1, this.lat = +t, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
        }
        var Wd = $d;
        const Hd = 0, Xd = 25.5;
        function Yd(e1) {
            return Zd * Math.cos(e1 * Math.PI / 180);
        }
        function Kd(e1) {
            return (180 + e1) / 360;
        }
        function Jd(e1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1 * Math.PI / 360))) / 360;
        }
        function Qd(e1, t) {
            return e1 / Yd(t);
        }
        function ep(e1) {
            return 360 * e1 - 180;
        }
        function tp(e1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e1) * Math.PI / 180)) - 90;
        }
        function ip(e1, t) {
            return e1 * Yd(tp(t));
        }
        const rp = 85.051129;
        function np(e1) {
            return Math.cos(w(z(e1, -rp, rp)));
        }
        function op(e1, t) {
            const i = z(t, Hd, Xd), r = Math.pow(2, i);
            return np(e1) * Zd / (512 * r);
        }
        function sp(e1) {
            return 1 / Math.cos(e1 * Math.PI / 180);
        }
        function ap(e1, t = 0) {
            const i = Math.exp(Math.PI * (1 - (e1.y + t / cr) / (1 << e1.z) * 2));
            return 80150034 * i / (i * i + 1) / cr / (1 << e1.z);
        }
        class lp {
            static fromLngLat(e1, t = 0) {
                const i = Wd.convert(e1);
                return new lp(Kd(i.lng), Jd(i.lat), Qd(t, i.lat));
            }
            toLngLat() {
                return new Wd(ep(this.x), tp(this.y));
            }
            toAltitude() {
                return ip(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / Zd * sp(tp(this.y));
            }
            constructor(e1, t, i = 0){
                this.x = +e1, this.y = +t, this.z = +i;
            }
        }
        function cp(e1, t, i, r, n, o, s, a, l) {
            const c = (t + r) / 2, h = (i + n) / 2, u = new y(c, h);
            a(u), function(e1, t, i, r, n, o) {
                const s = i - n, a = r - o;
                return Math.abs((r - t) * s - (i - e1) * a) / Math.hypot(s, a);
            }(u.x, u.y, o.x, o.y, s.x, s.y) >= l ? (cp(e1, t, i, c, h, o, u, a, l), cp(e1, c, h, r, n, u, s, a, l)) : e1.push(s);
        }
        function hp(e1, t, i) {
            let r = e1[0], n = r.x, o = r.y;
            t(r);
            const s = [
                r
            ];
            for(let a = 1; a < e1.length; a++){
                const l = e1[a], { x: c, y: h } = l;
                t(l), cp(s, n, o, c, h, r, l, t, i), n = c, o = h, r = l;
            }
            return s;
        }
        function up(e1, t, i, r) {
            if (r(t, i)) {
                const n = t.add(i)._mult(.5);
                up(e1, t, n, r), up(e1, n, i, r);
            } else e1.push(i);
        }
        function dp(e1, t) {
            let i = e1[0];
            const r = [
                i
            ];
            for(let n = 1; n < e1.length; n++){
                const o = e1[n];
                up(r, i, o, t), i = o;
            }
            return r;
        }
        const pp = Math.pow(2, 14) - 1, fp = -pp - 1;
        function mp(e1, t) {
            const i = Math.round(e1.x * t), r = Math.round(e1.y * t);
            return e1.x = z(i, fp, pp), e1.y = z(r, fp, pp), (i < e1.x || i > e1.x + 1 || r < e1.y || r > e1.y + 1) && H("Geometry exceeds allowed extent, reduce your vector tile buffer size"), e1;
        }
        function _p(e1, t, i) {
            const r = e1.loadGeometry(), n = e1.extent, o = cr / n;
            if (t && i && i.projection.isReprojectedInTileSpace) {
                const o = 1 << t.z, { scale: s, x: a, y: l, projection: c } = i, h = (e1)=>{
                    const i = ep((t.x + e1.x / n) / o), r = tp((t.y + e1.y / n) / o), h = c.project(i, r);
                    e1.x = (h.x * s - a) * n, e1.y = (h.y * s - l) * n;
                };
                for(let t = 0; t < r.length; t++)if (1 !== e1.type) r[t] = hp(r[t], h, 1);
                else {
                    const e1 = [];
                    for (const i of r[t])i.x < 0 || i.x >= n || i.y < 0 || i.y >= n || (h(i), e1.push(i));
                    r[t] = e1;
                }
            }
            for (const e1 of r)for (const t of e1)mp(t, o);
            return r;
        }
        function gp(e1, t) {
            return {
                type: e1.type,
                id: e1.id,
                properties: e1.properties,
                geometry: t ? _p(e1) : []
            };
        }
        function yp(e1, t, i, r, n) {
            e1.emplaceBack(2 * t + (r + 1) / 2, 2 * i + (n + 1) / 2);
        }
        function xp(e1, t, i) {
            const r = 16384;
            e1.emplaceBack(t.x, t.y, t.z, i[0] * r, i[1] * r, i[2] * r);
        }
        class vp {
            populate(e1, t, i, r) {
                const n = this.layers[0], o = [];
                let s = null;
                "circle" === n.type && (s = n.layout.get("circle-sort-key"));
                for (const { feature: t, id: n, index: a, sourceLayerIndex: l } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = gp(t, e1);
                    if (!this.layers[0]._featureFilter.filter(new oa(this.zoom), c, i)) continue;
                    const h = s ? s.evaluate(c, {}, i) : void 0, u = {
                        id: n,
                        properties: t.properties,
                        type: t.type,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: e1 ? c.geometry : _p(t, i, r),
                        patterns: {},
                        sortKey: h
                    };
                    o.push(u);
                }
                s && o.sort((e1, t)=>e1.sortKey - t.sortKey);
                let a = null;
                "globe" === r.projection.name && (this.globeExtVertexArray = new Fa, a = r.projection);
                for (const r of o){
                    const { geometry: n, index: o, sourceLayerIndex: s } = r, l = e1[o].feature;
                    this.addFeature(r, n, o, t.availableImages, i, a, t.brightness), t.featureIndex.insert(l, n, o, s, this.index);
                }
            }
            update(e1, t, i, r, n) {
                const o = 0 !== Object.keys(e1).length;
                o && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(e1, t, o ? this.stateDependentLayers : this.layers, i, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, gl.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = e1.createVertexBuffer(this.globeExtVertexArray, yl.members))), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy());
            }
            addFeature(e1, t, i, r, n, o, s) {
                for (const i of t)for (const t of i){
                    const i = t.x, r = t.y;
                    if (i < 0 || i >= cr || r < 0 || r >= cr) continue;
                    if (o) {
                        const e1 = o.projectTilePoint(i, r, n), t = o.upVector(n, i, r), s = this.globeExtVertexArray;
                        xp(s, e1, t), xp(s, e1, t), xp(s, e1, t), xp(s, e1, t);
                    }
                    const s = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, e1.sortKey), a = s.vertexLength;
                    yp(this.layoutVertexArray, i, r, -1, -1), yp(this.layoutVertexArray, i, r, 1, -1), yp(this.layoutVertexArray, i, r, 1, 1), yp(this.layoutVertexArray, i, r, -1, 1), this.indexArray.emplaceBack(a, a + 1, a + 2), this.indexArray.emplaceBack(a, a + 2, a + 3), s.vertexLength += 4, s.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, {}, r, n, s);
            }
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.projection = e1.projection, this.layoutVertexArray = new za, this.indexArray = new Wa, this.segments = new xl, this.programConfigurations = new ec(e1.layers, e1.zoom), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
            }
        }
        function bp(e1, t) {
            for(let i = 0; i < e1.length; i++)if (zp(t, e1[i])) return !0;
            for(let i = 0; i < t.length; i++)if (zp(e1, t[i])) return !0;
            return !!Mp(e1, t);
        }
        function wp(e1, t, i) {
            return !!zp(e1, t) || !!Sp(t, e1, i);
        }
        function Tp(e1, t) {
            if (1 === e1.length) return Cp(t, e1[0]);
            for(let i = 0; i < t.length; i++){
                const r = t[i];
                for(let t = 0; t < r.length; t++)if (zp(e1, r[t])) return !0;
            }
            for(let i = 0; i < e1.length; i++)if (Cp(t, e1[i])) return !0;
            for(let i = 0; i < t.length; i++)if (Mp(e1, t[i])) return !0;
            return !1;
        }
        function Ep(e1, t, i) {
            if (e1.length > 1) {
                if (Mp(e1, t)) return !0;
                for(let r = 0; r < t.length; r++)if (Sp(t[r], e1, i)) return !0;
            }
            for(let r = 0; r < e1.length; r++)if (Sp(e1[r], t, i)) return !0;
            return !1;
        }
        function Mp(e1, t) {
            if (0 === e1.length || 0 === t.length) return !1;
            for(let i = 0; i < e1.length - 1; i++){
                const r = e1[i], n = e1[i + 1];
                for(let e1 = 0; e1 < t.length - 1; e1++)if (Ap(r, n, t[e1], t[e1 + 1])) return !0;
            }
            return !1;
        }
        function Ap(e1, t, i, r) {
            return X(e1, i, r) !== X(t, i, r) && X(e1, t, i) !== X(e1, t, r);
        }
        function Sp(e1, t, i) {
            const r = i * i;
            if (1 === t.length) return e1.distSqr(t[0]) < r;
            for(let i = 1; i < t.length; i++)if (Ip(e1, t[i - 1], t[i]) < r) return !0;
            return !1;
        }
        function Ip(e1, t, i) {
            const r = t.distSqr(i);
            if (0 === r) return e1.distSqr(t);
            const n = ((e1.x - t.x) * (i.x - t.x) + (e1.y - t.y) * (i.y - t.y)) / r;
            return e1.distSqr(n < 0 ? t : n > 1 ? i : i.sub(t)._mult(n)._add(t));
        }
        function Cp(e1, t) {
            let i, r, n, o = !1;
            for(let s = 0; s < e1.length; s++){
                i = e1[s];
                for(let e1 = 0, s = i.length - 1; e1 < i.length; s = e1++)r = i[e1], n = i[s], r.y > t.y != n.y > t.y && t.x < (n.x - r.x) * (t.y - r.y) / (n.y - r.y) + r.x && (o = !o);
            }
            return o;
        }
        function zp(e1, t) {
            let i = !1;
            for(let r = 0, n = e1.length - 1; r < e1.length; n = r++){
                const o = e1[r], s = e1[n];
                o.y > t.y != s.y > t.y && t.x < (s.x - o.x) * (t.y - o.y) / (s.y - o.y) + o.x && (i = !i);
            }
            return i;
        }
        function Pp(e1, t, i, r, n) {
            for (const o of e1)if (t <= o.x && i <= o.y && r >= o.x && n >= o.y) return !0;
            const o = [
                new y(t, i),
                new y(t, n),
                new y(r, n),
                new y(r, i)
            ];
            if (e1.length > 2) {
                for (const t of o)if (zp(e1, t)) return !0;
            }
            for(let t = 0; t < e1.length - 1; t++)if (Dp(e1[t], e1[t + 1], o)) return !0;
            return !1;
        }
        function Dp(e1, t, i) {
            const r = i[0], n = i[2];
            if (e1.x < r.x && t.x < r.x || e1.x > n.x && t.x > n.x || e1.y < r.y && t.y < r.y || e1.y > n.y && t.y > n.y) return !1;
            const o = X(e1, t, i[0]);
            return o !== X(e1, t, i[1]) || o !== X(e1, t, i[2]) || o !== X(e1, t, i[3]);
        }
        function Rp(e1, t, i, r, n, o) {
            let s = t.y - e1.y, a = e1.x - t.x;
            if (o = o || 0) {
                const e1 = s * s + a * a;
                if (0 === e1) return !0;
                const t = Math.sqrt(e1);
                s /= t, a /= t;
            }
            return !((i.x - e1.x) * s + (i.y - e1.y) * a - o < 0 || (r.x - e1.x) * s + (r.y - e1.y) * a - o < 0 || (n.x - e1.x) * s + (n.y - e1.y) * a - o < 0);
        }
        function Lp(e1, t, i, r, n, o, s) {
            return !(Rp(e1, t, r, n, o, s) || Rp(t, i, r, n, o, s) || Rp(i, e1, r, n, o, s) || Rp(r, n, e1, t, i, s) || Rp(n, o, e1, t, i, s) || Rp(o, r, e1, t, i, s));
        }
        function kp(e1, t, i) {
            const r = t.paint.get(e1).value;
            return "constant" === r.kind ? r.value : i.programConfigurations.get(t.id).getMaxValue(e1);
        }
        function Op(e1) {
            return Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]);
        }
        function Bp(e1, t, i, r, n) {
            if (!t[0] && !t[1]) return e1;
            const o = y.convert(t)._mult(n);
            "viewport" === i && o._rotate(-r);
            const s = [];
            for(let t = 0; t < e1.length; t++)s.push(e1[t].sub(o));
            return s;
        }
        function Fp(e1, t, i, r) {
            const n = y.convert(e1)._mult(r);
            return "viewport" === t && n._rotate(-i), n;
        }
        Rs(vp, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        const Np = new ga({
            "circle-sort-key": new ma(Pt.layout_circle["circle-sort-key"]),
            visibility: new fa(Pt.layout_circle.visibility)
        });
        var Up = {
            paint: new ga({
                "circle-radius": new ma(Pt.paint_circle["circle-radius"]),
                "circle-color": new ma(Pt.paint_circle["circle-color"]),
                "circle-blur": new ma(Pt.paint_circle["circle-blur"]),
                "circle-opacity": new ma(Pt.paint_circle["circle-opacity"]),
                "circle-translate": new fa(Pt.paint_circle["circle-translate"]),
                "circle-translate-anchor": new fa(Pt.paint_circle["circle-translate-anchor"]),
                "circle-pitch-scale": new fa(Pt.paint_circle["circle-pitch-scale"]),
                "circle-pitch-alignment": new fa(Pt.paint_circle["circle-pitch-alignment"]),
                "circle-stroke-width": new ma(Pt.paint_circle["circle-stroke-width"]),
                "circle-stroke-color": new ma(Pt.paint_circle["circle-stroke-color"]),
                "circle-stroke-opacity": new ma(Pt.paint_circle["circle-stroke-opacity"]),
                "circle-emissive-strength": new fa(Pt.paint_circle["circle-emissive-strength"])
            }),
            layout: Np
        };
        const Vp = Au.create(), jp = (e1, t, i, r, n, o)=>{
            const s = e1.transform, a = "globe" === s.projection.name;
            let l;
            if ("map" === o.paint.get("circle-pitch-alignment")) {
                if (a) {
                    const e1 = Cd(s.zoom, t.canonical) * s._pixelsPerMercatorPixel;
                    l = Float32Array.from([
                        e1,
                        0,
                        0,
                        e1
                    ]);
                } else l = s.calculatePixelsToTileUnitsMatrix(i);
            } else l = new Float32Array([
                s.pixelsToGLUnits[0],
                0,
                0,
                s.pixelsToGLUnits[1]
            ]);
            const c = {
                u_camera_to_center_distance: e1.transform.getCameraToCenterDistance(s.projection),
                u_matrix: e1.translatePosMatrix(t.projMatrix, i, o.paint.get("circle-translate"), o.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: dt.devicePixelRatio,
                u_extrude_scale: l,
                u_inv_rot_matrix: Vp,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_emissive_strength: o.paint.get("circle-emissive-strength")
            };
            if (a) {
                c.u_inv_rot_matrix = r, c.u_merc_center = n, c.u_tile_id = [
                    t.canonical.x,
                    t.canonical.y,
                    1 << t.canonical.z
                ], c.u_zoom_transition = Dd(s.zoom);
                const e1 = n[0] * cr, i = n[1] * cr;
                c.u_up_dir = s.projection.upVector(new ju(0, 0, 0), e1, i);
            }
            return c;
        }, Gp = (e1)=>{
            const t = [];
            return "map" === e1.paint.get("circle-pitch-alignment") && t.push("PITCH_WITH_MAP"), "map" === e1.paint.get("circle-pitch-scale") && t.push("SCALE_WITH_MAP"), t;
        };
        function qp(e1, t, i, r, n, o, s, a, l) {
            if (o && e1.queryGeometry.isAboveHorizon) return !1;
            o && (l *= e1.pixelToTileUnitsFactor);
            const c = e1.tileID.canonical, h = i.projection.upVectorScale(c, i.center.lat, i.worldSize).metersToTile;
            for (const u of t)for (const t of u){
                const u = t.add(a), d = n && i.elevation ? i.elevation.exaggeration() * n.getElevationAt(u.x, u.y, !0) : 0, p = i.projection.projectTilePoint(u.x, u.y, c);
                if (d > 0) {
                    const e1 = i.projection.upVector(c, u.x, u.y);
                    p.x += e1[0] * h * d, p.y += e1[1] * h * d, p.z += e1[2] * h * d;
                }
                const f = o ? u : Zp(p.x, p.y, p.z, r), m = o ? e1.tilespaceRays.map((e1)=>Hp(e1, d)) : e1.queryGeometry.screenGeometry, _ = yu.transformMat4([], [
                    p.x,
                    p.y,
                    p.z,
                    1
                ], r);
                if (!s && o ? l *= _[3] / i.cameraToCenterDistance : s && !o && (l *= i.cameraToCenterDistance / _[3]), o) {
                    const e1 = tp((t.y / cr + c.y) / (1 << c.z));
                    l /= i.projection.pixelsPerMeter(e1, 1) / Qd(1, e1);
                }
                if (wp(m, f, l)) return !0;
            }
            return !1;
        }
        function Zp(e1, t, i, r) {
            const n = yu.transformMat4([], [
                e1,
                t,
                i,
                1
            ], r);
            return new y(n[0] / n[3], n[1] / n[3]);
        }
        const $p = Du.fromValues(0, 0, 0), Wp = Du.fromValues(0, 0, 1);
        function Hp(e1, t) {
            const i = Du.create();
            return $p[2] = t, e1.intersectsPlane($p, Wp, i), new y(i[0], i[1]);
        }
        class Xp extends vp {
        }
        function Yp(e1, { width: t, height: i }, r, n) {
            if (n) {
                if (n instanceof Uint8ClampedArray) n = new Uint8Array(n.buffer);
                else if (n.length !== t * i * r) throw new RangeError("mismatched image size");
            } else n = new Uint8Array(t * i * r);
            return e1.width = t, e1.height = i, e1.data = n, e1;
        }
        function Kp(e1, t, i) {
            const { width: r, height: n } = t;
            r === e1.width && n === e1.height || (Jp(e1, t, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(e1.width, r),
                height: Math.min(e1.height, n)
            }, i), e1.width = r, e1.height = n, e1.data = t.data);
        }
        function Jp(e1, t, i, r, n, o) {
            if (0 === n.width || 0 === n.height) return t;
            if (n.width > e1.width || n.height > e1.height || i.x > e1.width - n.width || i.y > e1.height - n.height) throw new RangeError("out of range source coordinates for image copy");
            if (n.width > t.width || n.height > t.height || r.x > t.width - n.width || r.y > t.height - n.height) throw new RangeError("out of range destination coordinates for image copy");
            const s = e1.data, a = t.data;
            for(let l = 0; l < n.height; l++){
                const c = ((i.y + l) * e1.width + i.x) * o, h = ((r.y + l) * t.width + r.x) * o;
                for(let e1 = 0; e1 < n.width * o; e1++)a[h + e1] = s[c + e1];
            }
            return t;
        }
        Rs(Xp, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        class Qp {
            resize(e1) {
                Kp(this, new Qp(e1), 1);
            }
            clone() {
                return new Qp({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t, i, r, n) {
                Jp(e1, t, i, r, n, 1);
            }
            constructor(e1, t){
                Yp(this, e1, 1, t);
            }
        }
        class ef {
            resize(e1) {
                Kp(this, new ef(e1), 4);
            }
            replace(e1, t) {
                t ? this.data.set(e1) : this.data = e1 instanceof Uint8ClampedArray ? new Uint8Array(e1.buffer) : e1;
            }
            clone() {
                return new ef({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t, i, r, n) {
                Jp(e1, t, i, r, n, 4);
            }
            constructor(e1, t){
                Yp(this, e1, 4, t);
            }
        }
        class tf {
            constructor(e1, t){
                this.width = e1.width, this.height = e1.height, this.data = t instanceof Uint8Array ? new Float32Array(t.buffer) : t;
            }
        }
        Rs(Qp, "AlphaImage"), Rs(ef, "RGBAImage");
        const rf = new ga({
            visibility: new fa(Pt.layout_heatmap.visibility)
        });
        var nf = {
            paint: new ga({
                "heatmap-radius": new ma(Pt.paint_heatmap["heatmap-radius"]),
                "heatmap-weight": new ma(Pt.paint_heatmap["heatmap-weight"]),
                "heatmap-intensity": new fa(Pt.paint_heatmap["heatmap-intensity"]),
                "heatmap-color": new _a(Pt.paint_heatmap["heatmap-color"]),
                "heatmap-opacity": new fa(Pt.paint_heatmap["heatmap-opacity"])
            }),
            layout: rf
        };
        function of(e1) {
            const t = {}, i = e1.resolution || 256, r = e1.clips ? e1.clips.length : 1, n = e1.image || new ef({
                width: i,
                height: r
            }), o = (i, r, o)=>{
                t[e1.evaluationKey] = o;
                const s = e1.expression.evaluate(t);
                s && (n.data[i + r + 0] = Math.floor(255 * s.r / s.a), n.data[i + r + 1] = Math.floor(255 * s.g / s.a), n.data[i + r + 2] = Math.floor(255 * s.b / s.a), n.data[i + r + 3] = Math.floor(255 * s.a));
            };
            if (e1.clips) for(let t = 0, n = 0; t < r; ++t, n += 4 * i)for(let r = 0, s = 0; r < i; r++, s += 4){
                const a = r / (i - 1), { start: l, end: c } = e1.clips[t];
                o(n, s, l * (1 - a) + c * a);
            }
            else for(let e1 = 0, t = 0; e1 < i; e1++, t += 4)o(0, t, e1 / (i - 1));
            return n;
        }
        const sf = new ga({
            visibility: new fa(Pt.layout_hillshade.visibility)
        });
        var af = {
            paint: new ga({
                "hillshade-illumination-direction": new fa(Pt.paint_hillshade["hillshade-illumination-direction"]),
                "hillshade-illumination-anchor": new fa(Pt.paint_hillshade["hillshade-illumination-anchor"]),
                "hillshade-exaggeration": new fa(Pt.paint_hillshade["hillshade-exaggeration"]),
                "hillshade-shadow-color": new fa(Pt.paint_hillshade["hillshade-shadow-color"]),
                "hillshade-highlight-color": new fa(Pt.paint_hillshade["hillshade-highlight-color"]),
                "hillshade-accent-color": new fa(Pt.paint_hillshade["hillshade-accent-color"]),
                "hillshade-emissive-strength": new fa(Pt.paint_hillshade["hillshade-emissive-strength"])
            }),
            layout: sf
        };
        const lf = Ia([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), { members: cf } = lf;
        var hf = {
            exports: {}
        };
        function uf(e1, t, i) {
            i = i || 2;
            var r, n, o, s, a, l, c, h = t && t.length, u = h ? t[0] * i : e1.length, d = df(e1, 0, u, i, !0), p = [];
            if (!d || d.next === d.prev) return p;
            if (h && (d = function(e1, t, i, r) {
                var n, o, s, a = [];
                for(n = 0, o = t.length; n < o; n++)(s = df(e1, t[n] * r, n < o - 1 ? t[n + 1] * r : e1.length, r, !1)) === s.next && (s.steiner = !0), a.push(Tf(s));
                for(a.sort(xf), n = 0; n < a.length; n++)i = vf(a[n], i);
                return i;
            }(e1, t, d, i)), e1.length > 80 * i) {
                r = o = e1[0], n = s = e1[1];
                for(var f = i; f < u; f += i)(a = e1[f]) < r && (r = a), (l = e1[f + 1]) < n && (n = l), a > o && (o = a), l > s && (s = l);
                c = 0 !== (c = Math.max(o - r, s - n)) ? 32767 / c : 0;
            }
            return ff(d, p, i, r, n, c, 0), p;
        }
        function df(e1, t, i, r, n) {
            var o, s;
            if (n === Of(e1, t, i, r) > 0) for(o = t; o < i; o += r)s = Rf(o, e1[o], e1[o + 1], s);
            else for(o = i - r; o >= t; o -= r)s = Rf(o, e1[o], e1[o + 1], s);
            return s && Sf(s, s.next) && (Lf(s), s = s.next), s;
        }
        function pf(e1, t) {
            if (!e1) return e1;
            t || (t = e1);
            var i, r = e1;
            do if (i = !1, r.steiner || !Sf(r, r.next) && 0 !== Af(r.prev, r, r.next)) r = r.next;
            else {
                if (Lf(r), (r = t = r.prev) === r.next) break;
                i = !0;
            }
            while (i || r !== t);
            return t;
        }
        function ff(e1, t, i, r, n, o, s) {
            if (e1) {
                !s && o && function(e1, t, i, r) {
                    var n = e1;
                    do 0 === n.z && (n.z = wf(n.x, n.y, t, i, r)), n.prevZ = n.prev, n.nextZ = n.next, n = n.next;
                    while (n !== e1);
                    n.prevZ.nextZ = null, n.prevZ = null, function(e1) {
                        var t, i, r, n, o, s, a, l, c = 1;
                        do {
                            for(i = e1, e1 = null, o = null, s = 0; i;){
                                for(s++, r = i, a = 0, t = 0; t < c && (a++, r = r.nextZ); t++);
                                for(l = c; a > 0 || l > 0 && r;)0 !== a && (0 === l || !r || i.z <= r.z) ? (n = i, i = i.nextZ, a--) : (n = r, r = r.nextZ, l--), o ? o.nextZ = n : e1 = n, n.prevZ = o, o = n;
                                i = r;
                            }
                            o.nextZ = null, c *= 2;
                        }while (s > 1);
                    }(n);
                }(e1, r, n, o);
                for(var a, l, c = e1; e1.prev !== e1.next;)if (a = e1.prev, l = e1.next, o ? _f(e1, r, n, o) : mf(e1)) t.push(a.i / i | 0), t.push(e1.i / i | 0), t.push(l.i / i | 0), Lf(e1), e1 = l.next, c = l.next;
                else if ((e1 = l) === c) {
                    s ? 1 === s ? ff(e1 = gf(pf(e1), t, i), t, i, r, n, o, 2) : 2 === s && yf(e1, t, i, r, n, o) : ff(pf(e1), t, i, r, n, o, 1);
                    break;
                }
            }
        }
        function mf(e1) {
            var t = e1.prev, i = e1, r = e1.next;
            if (Af(t, i, r) >= 0) return !1;
            for(var n = t.x, o = i.x, s = r.x, a = t.y, l = i.y, c = r.y, h = n < o ? n < s ? n : s : o < s ? o : s, u = a < l ? a < c ? a : c : l < c ? l : c, d = n > o ? n > s ? n : s : o > s ? o : s, p = a > l ? a > c ? a : c : l > c ? l : c, f = r.next; f !== t;){
                if (f.x >= h && f.x <= d && f.y >= u && f.y <= p && Ef(n, a, o, l, s, c, f.x, f.y) && Af(f.prev, f, f.next) >= 0) return !1;
                f = f.next;
            }
            return !0;
        }
        function _f(e1, t, i, r) {
            var n = e1.prev, o = e1, s = e1.next;
            if (Af(n, o, s) >= 0) return !1;
            for(var a = n.x, l = o.x, c = s.x, h = n.y, u = o.y, d = s.y, p = a < l ? a < c ? a : c : l < c ? l : c, f = h < u ? h < d ? h : d : u < d ? u : d, m = a > l ? a > c ? a : c : l > c ? l : c, _ = h > u ? h > d ? h : d : u > d ? u : d, g = wf(p, f, t, i, r), y = wf(m, _, t, i, r), x = e1.prevZ, v = e1.nextZ; x && x.z >= g && v && v.z <= y;){
                if (x.x >= p && x.x <= m && x.y >= f && x.y <= _ && x !== n && x !== s && Ef(a, h, l, u, c, d, x.x, x.y) && Af(x.prev, x, x.next) >= 0) return !1;
                if (x = x.prevZ, v.x >= p && v.x <= m && v.y >= f && v.y <= _ && v !== n && v !== s && Ef(a, h, l, u, c, d, v.x, v.y) && Af(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            for(; x && x.z >= g;){
                if (x.x >= p && x.x <= m && x.y >= f && x.y <= _ && x !== n && x !== s && Ef(a, h, l, u, c, d, x.x, x.y) && Af(x.prev, x, x.next) >= 0) return !1;
                x = x.prevZ;
            }
            for(; v && v.z <= y;){
                if (v.x >= p && v.x <= m && v.y >= f && v.y <= _ && v !== n && v !== s && Ef(a, h, l, u, c, d, v.x, v.y) && Af(v.prev, v, v.next) >= 0) return !1;
                v = v.nextZ;
            }
            return !0;
        }
        function gf(e1, t, i) {
            var r = e1;
            do {
                var n = r.prev, o = r.next.next;
                !Sf(n, o) && If(n, r, r.next, o) && Pf(n, o) && Pf(o, n) && (t.push(n.i / i | 0), t.push(r.i / i | 0), t.push(o.i / i | 0), Lf(r), Lf(r.next), r = e1 = o), r = r.next;
            }while (r !== e1);
            return pf(r);
        }
        function yf(e1, t, i, r, n, o) {
            var s = e1;
            do {
                for(var a = s.next.next; a !== s.prev;){
                    if (s.i !== a.i && Mf(s, a)) {
                        var l = Df(s, a);
                        return s = pf(s, s.next), l = pf(l, l.next), ff(s, t, i, r, n, o, 0), void ff(l, t, i, r, n, o, 0);
                    }
                    a = a.next;
                }
                s = s.next;
            }while (s !== e1);
        }
        function xf(e1, t) {
            return e1.x - t.x;
        }
        function vf(e1, t) {
            var i = function(e1, t) {
                var i, r = t, n = e1.x, o = e1.y, s = -1 / 0;
                do {
                    if (o <= r.y && o >= r.next.y && r.next.y !== r.y) {
                        var a = r.x + (o - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (a <= n && a > s && (s = a, i = r.x < r.next.x ? r : r.next, a === n)) return i;
                    }
                    r = r.next;
                }while (r !== t);
                if (!i) return null;
                var l, c = i, h = i.x, u = i.y, d = 1 / 0;
                r = i;
                do n >= r.x && r.x >= h && n !== r.x && Ef(o < u ? n : s, o, h, u, o < u ? s : n, o, r.x, r.y) && (l = Math.abs(o - r.y) / (n - r.x), Pf(r, e1) && (l < d || l === d && (r.x > i.x || r.x === i.x && bf(i, r))) && (i = r, d = l)), r = r.next;
                while (r !== c);
                return i;
            }(e1, t);
            if (!i) return t;
            var r = Df(i, e1);
            return pf(r, r.next), pf(i, i.next);
        }
        function bf(e1, t) {
            return Af(e1.prev, e1, t.prev) < 0 && Af(t.next, e1, e1.next) < 0;
        }
        function wf(e1, t, i, r, n) {
            return (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - i) * n | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * n | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
        }
        function Tf(e1) {
            var t = e1, i = e1;
            do (t.x < i.x || t.x === i.x && t.y < i.y) && (i = t), t = t.next;
            while (t !== e1);
            return i;
        }
        function Ef(e1, t, i, r, n, o, s, a) {
            return (n - s) * (t - a) >= (e1 - s) * (o - a) && (e1 - s) * (r - a) >= (i - s) * (t - a) && (i - s) * (o - a) >= (n - s) * (r - a);
        }
        function Mf(e1, t) {
            return e1.next.i !== t.i && e1.prev.i !== t.i && !function(e1, t) {
                var i = e1;
                do {
                    if (i.i !== e1.i && i.next.i !== e1.i && i.i !== t.i && i.next.i !== t.i && If(i, i.next, e1, t)) return !0;
                    i = i.next;
                }while (i !== e1);
                return !1;
            }(e1, t) && (Pf(e1, t) && Pf(t, e1) && function(e1, t) {
                var i = e1, r = !1, n = (e1.x + t.x) / 2, o = (e1.y + t.y) / 2;
                do i.y > o != i.next.y > o && i.next.y !== i.y && n < (i.next.x - i.x) * (o - i.y) / (i.next.y - i.y) + i.x && (r = !r), i = i.next;
                while (i !== e1);
                return r;
            }(e1, t) && (Af(e1.prev, e1, t.prev) || Af(e1, t.prev, t)) || Sf(e1, t) && Af(e1.prev, e1, e1.next) > 0 && Af(t.prev, t, t.next) > 0);
        }
        function Af(e1, t, i) {
            return (t.y - e1.y) * (i.x - t.x) - (t.x - e1.x) * (i.y - t.y);
        }
        function Sf(e1, t) {
            return e1.x === t.x && e1.y === t.y;
        }
        function If(e1, t, i, r) {
            var n = zf(Af(e1, t, i)), o = zf(Af(e1, t, r)), s = zf(Af(i, r, e1)), a = zf(Af(i, r, t));
            return n !== o && s !== a || !(0 !== n || !Cf(e1, i, t)) || !(0 !== o || !Cf(e1, r, t)) || !(0 !== s || !Cf(i, e1, r)) || !(0 !== a || !Cf(i, t, r));
        }
        function Cf(e1, t, i) {
            return t.x <= Math.max(e1.x, i.x) && t.x >= Math.min(e1.x, i.x) && t.y <= Math.max(e1.y, i.y) && t.y >= Math.min(e1.y, i.y);
        }
        function zf(e1) {
            return e1 > 0 ? 1 : e1 < 0 ? -1 : 0;
        }
        function Pf(e1, t) {
            return Af(e1.prev, e1, e1.next) < 0 ? Af(e1, t, e1.next) >= 0 && Af(e1, e1.prev, t) >= 0 : Af(e1, t, e1.prev) < 0 || Af(e1, e1.next, t) < 0;
        }
        function Df(e1, t) {
            var i = new kf(e1.i, e1.x, e1.y), r = new kf(t.i, t.x, t.y), n = e1.next, o = t.prev;
            return e1.next = t, t.prev = e1, i.next = n, n.prev = i, r.next = i, i.prev = r, o.next = r, r.prev = o, r;
        }
        function Rf(e1, t, i, r) {
            var n = new kf(e1, t, i);
            return r ? (n.next = r.next, n.prev = r, r.next.prev = n, r.next = n) : (n.prev = n, n.next = n), n;
        }
        function Lf(e1) {
            e1.next.prev = e1.prev, e1.prev.next = e1.next, e1.prevZ && (e1.prevZ.nextZ = e1.nextZ), e1.nextZ && (e1.nextZ.prevZ = e1.prevZ);
        }
        function kf(e1, t, i) {
            this.i = e1, this.x = t, this.y = i, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        function Of(e1, t, i, r) {
            for(var n = 0, o = t, s = i - r; o < i; o += r)n += (e1[s] - e1[o]) * (e1[o + 1] + e1[s + 1]), s = o;
            return n;
        }
        hf.exports = uf, hf.exports.default = uf, uf.deviation = function(e1, t, i, r) {
            var n = t && t.length, o = Math.abs(Of(e1, 0, n ? t[0] * i : e1.length, i));
            if (n) for(var s = 0, a = t.length; s < a; s++)o -= Math.abs(Of(e1, t[s] * i, s < a - 1 ? t[s + 1] * i : e1.length, i));
            var l = 0;
            for(s = 0; s < r.length; s += 3){
                var c = r[s] * i, h = r[s + 1] * i, u = r[s + 2] * i;
                l += Math.abs((e1[c] - e1[u]) * (e1[h + 1] - e1[c + 1]) - (e1[c] - e1[h]) * (e1[u + 1] - e1[c + 1]));
            }
            return 0 === o && 0 === l ? 0 : Math.abs((l - o) / o);
        }, uf.flatten = function(e1) {
            for(var t = e1[0][0].length, i = {
                vertices: [],
                holes: [],
                dimensions: t
            }, r = 0, n = 0; n < e1.length; n++){
                for(var o = 0; o < e1[n].length; o++)for(var s = 0; s < t; s++)i.vertices.push(e1[n][o][s]);
                n > 0 && i.holes.push(r += e1[n - 1].length);
            }
            return i;
        };
        var Bf = d(hf.exports);
        function Ff(e1, t) {
            const i = e1.length;
            if (i <= 1) return [
                e1
            ];
            const r = [];
            let n, o;
            for(let t = 0; t < i; t++){
                const i = Y(e1[t]);
                0 !== i && (e1[t].area = Math.abs(i), void 0 === o && (o = i < 0), o === i < 0 ? (n && r.push(n), n = [
                    e1[t]
                ]) : n.push(e1[t]));
            }
            if (n && r.push(n), t > 1) for(let e1 = 0; e1 < r.length; e1++)r[e1].length <= t || (Fi(r[e1], t, 1, r[e1].length - 1, Nf), r[e1] = r[e1].slice(0, t));
            return r;
        }
        function Nf(e1, t) {
            return t.area - e1.area;
        }
        function Uf(e1, t, i) {
            const r = i.patternDependencies;
            let n = !1;
            for (const i of t){
                const t = i.paint.get(`${e1}-pattern`);
                t.isConstant() || (n = !0);
                const o = t.constantOr(null);
                o && (n = !0, r[o] = !0);
            }
            return n;
        }
        function Vf(e1, t, i, r, n) {
            const o = n.patternDependencies;
            for (const s of t){
                const t = s.paint.get(`${e1}-pattern`).value;
                if ("constant" !== t.kind) {
                    let e1 = t.evaluate({
                        zoom: r
                    }, i, {}, n.availableImages);
                    e1 = e1 && e1.name ? e1.name : e1, o[e1] = !0, i.patterns[s.id] = e1;
                }
            }
            return i;
        }
        class jf {
            populate(e1, t, i, r) {
                this.hasPattern = Uf("fill", this.layers, t);
                const n = this.layers[0].layout.get("fill-sort-key"), o = [];
                for (const { feature: s, id: a, index: l, sourceLayerIndex: c } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, h = gp(s, e1);
                    if (!this.layers[0]._featureFilter.filter(new oa(this.zoom), h, i)) continue;
                    const u = n ? n.evaluate(h, {}, i, t.availableImages) : void 0, d = {
                        id: a,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: c,
                        index: l,
                        geometry: e1 ? h.geometry : _p(s, i, r),
                        patterns: {},
                        sortKey: u
                    };
                    o.push(d);
                }
                n && o.sort((e1, t)=>e1.sortKey - t.sortKey);
                for (const r of o){
                    const { geometry: n, index: o, sourceLayerIndex: s } = r;
                    if (this.hasPattern) {
                        const e1 = Vf("fill", this.layers, r, this.zoom, t);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(r, n, o, i, {}, t.availableImages, t.brightness);
                    t.featureIndex.insert(e1[o].feature, n, o, s, this.index);
                }
            }
            update(e1, t, i, r, n) {
                const o = 0 !== Object.keys(e1).length;
                o && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(e1, t, o ? this.stateDependentLayers : this.layers, i, r, n);
            }
            addFeatures(e1, t, i, r, n, o) {
                for (const e1 of this.patternFeatures)this.addFeature(e1, e1.geometry, e1.index, t, i, r, o);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, cf), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.indexBuffer2 = e1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
            }
            addFeature(e1, t, i, r, n, o = [], s) {
                for (const e1 of Ff(t, 500)){
                    let t = 0;
                    for (const i of e1)t += i.length;
                    const i = this.segments.prepareSegment(t, this.layoutVertexArray, this.indexArray), r = i.vertexLength, n = [], o = [];
                    for (const t of e1){
                        if (0 === t.length) continue;
                        t !== e1[0] && o.push(n.length / 2);
                        const i = this.segments2.prepareSegment(t.length, this.layoutVertexArray, this.indexArray2), r = i.vertexLength;
                        this.layoutVertexArray.emplaceBack(t[0].x, t[0].y), this.indexArray2.emplaceBack(r + t.length - 1, r), n.push(t[0].x), n.push(t[0].y);
                        for(let e1 = 1; e1 < t.length; e1++)this.layoutVertexArray.emplaceBack(t[e1].x, t[e1].y), this.indexArray2.emplaceBack(r + e1 - 1, r + e1), n.push(t[e1].x), n.push(t[e1].y);
                        i.vertexLength += t.length, i.primitiveLength += t.length;
                    }
                    const s = Bf(n, o);
                    for(let e1 = 0; e1 < s.length; e1 += 3)this.indexArray.emplaceBack(r + s[e1], r + s[e1 + 1], r + s[e1 + 2]);
                    i.vertexLength += t, i.primitiveLength += s.length / 3;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, n, o, r, s);
            }
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new za, this.indexArray = new Wa, this.indexArray2 = new ja, this.programConfigurations = new ec(e1.layers, e1.zoom), this.segments = new xl, this.segments2 = new xl, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.projection = e1.projection;
            }
        }
        Rs(jf, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        const Gf = new ga({
            "fill-sort-key": new ma(Pt.layout_fill["fill-sort-key"]),
            visibility: new fa(Pt.layout_fill.visibility)
        });
        var qf = {
            paint: new ga({
                "fill-antialias": new fa(Pt.paint_fill["fill-antialias"]),
                "fill-opacity": new ma(Pt.paint_fill["fill-opacity"]),
                "fill-color": new ma(Pt.paint_fill["fill-color"]),
                "fill-outline-color": new ma(Pt.paint_fill["fill-outline-color"]),
                "fill-translate": new fa(Pt.paint_fill["fill-translate"]),
                "fill-translate-anchor": new fa(Pt.paint_fill["fill-translate-anchor"]),
                "fill-pattern": new ma(Pt.paint_fill["fill-pattern"]),
                "fill-emissive-strength": new fa(Pt.paint_fill["fill-emissive-strength"])
            }),
            layout: Gf
        };
        const Zf = Ia([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), $f = Ia([
            {
                name: "a_pos_end",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_angular_offset_factor",
                components: 1,
                type: "Int16"
            }
        ]), Wf = Ia([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), Hf = Ia([
            {
                name: "a_hidden_by_landmark",
                components: 1,
                type: "Uint8"
            }
        ]), Xf = Ia([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: Yf } = Zf;
        var Kf = {}, Jf = _, Qf = em;
        function em(e1, t, i, r, n) {
            this.properties = {}, this.extent = i, this.type = 0, this._pbf = e1, this._geometry = -1, this._keys = r, this._values = n, e1.readFields(tm, this, t);
        }
        function tm(e1, t, i) {
            1 == e1 ? t.id = i.readVarint() : 2 == e1 ? function(e1, t) {
                for(var i = e1.readVarint() + e1.pos; e1.pos < i;){
                    var r = t._keys[e1.readVarint()], n = t._values[e1.readVarint()];
                    t.properties[r] = n;
                }
            }(i, t) : 3 == e1 ? t.type = i.readVarint() : 4 == e1 && (t._geometry = i.pos);
        }
        function im(e1) {
            for(var t, i, r = 0, n = 0, o = e1.length, s = o - 1; n < o; s = n++)r += ((i = e1[s]).x - (t = e1[n]).x) * (t.y + i.y);
            return r;
        }
        em.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ], em.prototype.loadGeometry = function() {
            var e1 = this._pbf;
            e1.pos = this._geometry;
            for(var t, i = e1.readVarint() + e1.pos, r = 1, n = 0, o = 0, s = 0, a = []; e1.pos < i;){
                if (n <= 0) {
                    var l = e1.readVarint();
                    r = 7 & l, n = l >> 3;
                }
                if (n--, 1 === r || 2 === r) o += e1.readSVarint(), s += e1.readSVarint(), 1 === r && (t && a.push(t), t = []), t.push(new Jf(o, s));
                else {
                    if (7 !== r) throw new Error("unknown command " + r);
                    t && t.push(t[0].clone());
                }
            }
            return t && a.push(t), a;
        }, em.prototype.bbox = function() {
            var e1 = this._pbf;
            e1.pos = this._geometry;
            for(var t = e1.readVarint() + e1.pos, i = 1, r = 0, n = 0, o = 0, s = 1 / 0, a = -1 / 0, l = 1 / 0, c = -1 / 0; e1.pos < t;){
                if (r <= 0) {
                    var h = e1.readVarint();
                    i = 7 & h, r = h >> 3;
                }
                if (r--, 1 === i || 2 === i) (n += e1.readSVarint()) < s && (s = n), n > a && (a = n), (o += e1.readSVarint()) < l && (l = o), o > c && (c = o);
                else if (7 !== i) throw new Error("unknown command " + i);
            }
            return [
                s,
                l,
                a,
                c
            ];
        }, em.prototype.toGeoJSON = function(e1, t, i) {
            var r, n, o = this.extent * Math.pow(2, i), s = this.extent * e1, a = this.extent * t, l = this.loadGeometry(), c = em.types[this.type];
            function h(e1) {
                for(var t = 0; t < e1.length; t++){
                    var i = e1[t];
                    e1[t] = [
                        360 * (i.x + s) / o - 180,
                        360 / Math.PI * Math.atan(Math.exp((180 - 360 * (i.y + a) / o) * Math.PI / 180)) - 90
                    ];
                }
            }
            switch(this.type){
                case 1:
                    var u = [];
                    for(r = 0; r < l.length; r++)u[r] = l[r][0];
                    h(l = u);
                    break;
                case 2:
                    for(r = 0; r < l.length; r++)h(l[r]);
                    break;
                case 3:
                    for(l = function(e1) {
                        var t = e1.length;
                        if (t <= 1) return [
                            e1
                        ];
                        for(var i, r, n = [], o = 0; o < t; o++){
                            var s = im(e1[o]);
                            0 !== s && (void 0 === r && (r = s < 0), r === s < 0 ? (i && n.push(i), i = [
                                e1[o]
                            ]) : i.push(e1[o]));
                        }
                        return i && n.push(i), n;
                    }(l), r = 0; r < l.length; r++)for(n = 0; n < l[r].length; n++)h(l[r][n]);
            }
            1 === l.length ? l = l[0] : c = "Multi" + c;
            var d = {
                type: "Feature",
                geometry: {
                    type: c,
                    coordinates: l
                },
                properties: this.properties
            };
            return "id" in this && (d.id = this.id), d;
        };
        var rm = Qf, nm = om;
        function om(e1, t) {
            this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = e1, this._keys = [], this._values = [], this._features = [], e1.readFields(sm, this, t), this.length = this._features.length;
        }
        function sm(e1, t, i) {
            15 === e1 ? t.version = i.readVarint() : 1 === e1 ? t.name = i.readString() : 5 === e1 ? t.extent = i.readVarint() : 2 === e1 ? t._features.push(i.pos) : 3 === e1 ? t._keys.push(i.readString()) : 4 === e1 && t._values.push(function(e1) {
                for(var t = null, i = e1.readVarint() + e1.pos; e1.pos < i;){
                    var r = e1.readVarint() >> 3;
                    t = 1 === r ? e1.readString() : 2 === r ? e1.readFloat() : 3 === r ? e1.readDouble() : 4 === r ? e1.readVarint64() : 5 === r ? e1.readVarint() : 6 === r ? e1.readSVarint() : 7 === r ? e1.readBoolean() : null;
                }
                return t;
            }(i));
        }
        om.prototype.feature = function(e1) {
            if (e1 < 0 || e1 >= this._features.length) throw new Error("feature index out of bounds");
            this._pbf.pos = this._features[e1];
            var t = this._pbf.readVarint() + this._pbf.pos;
            return new rm(this._pbf, t, this.extent, this._keys, this._values);
        };
        var am = nm;
        function lm(e1, t, i) {
            if (3 === e1) {
                var r = new am(i, i.readVarint() + i.pos);
                r.length && (t[r.name] = r);
            }
        }
        var cm = Kf.VectorTile = function(e1, t) {
            this.layers = e1.readFields(lm, {}, t);
        }, hm = Kf.VectorTileFeature = Qf;
        function um(e1, t, i, r) {
            const n = [], o = 0 === r ? (e1, t, i, r, n, o)=>{
                e1.push(new y(o, i + (o - t) / (r - t) * (n - i)));
            } : (e1, t, i, r, n, o)=>{
                e1.push(new y(t + (o - i) / (n - i) * (r - t), o));
            };
            for (const s of e1){
                const e1 = [];
                for (const n of s){
                    if (n.length <= 2) continue;
                    const s = [];
                    for(let e1 = 0; e1 < n.length - 1; e1++){
                        const a = n[e1].x, l = n[e1].y, c = n[e1 + 1].x, h = n[e1 + 1].y, u = 0 === r ? a : l, d = 0 === r ? c : h;
                        u < t ? d > t && o(s, a, l, c, h, t) : u > i ? d < i && o(s, a, l, c, h, i) : s.push(n[e1]), d < t && u >= t && o(s, a, l, c, h, t), d > i && u <= i && o(s, a, l, c, h, i);
                    }
                    let a = n[n.length - 1];
                    const l = 0 === r ? a.x : a.y;
                    l >= t && l <= i && s.push(a), s.length && (a = s[s.length - 1], s[0].x === a.x && s[0].y === a.y || s.push(s[0]), e1.push(s));
                }
                e1.length && n.push(e1);
            }
            return n;
        }
        Kf.VectorTileLayer = nm;
        class dm {
            encode(e1) {
                return this._stringToNumber[e1];
            }
            decode(e1) {
                return this._numberToString[e1];
            }
            constructor(e1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let t = 0; t < e1.length; t++){
                    const i = e1[t];
                    this._stringToNumber[i] = t, this._numberToString[t] = i;
                }
            }
        }
        var pm = {
            /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ read: function(e1, t, i, r, n) {
                var o, s, a = 8 * n - r - 1, l = (1 << a) - 1, c = l >> 1, h = -7, u = i ? n - 1 : 0, d = i ? -1 : 1, p = e1[t + u];
                for(u += d, o = p & (1 << -h) - 1, p >>= -h, h += a; h > 0; o = 256 * o + e1[t + u], u += d, h -= 8);
                for(s = o & (1 << -h) - 1, o >>= -h, h += r; h > 0; s = 256 * s + e1[t + u], u += d, h -= 8);
                if (0 === o) o = 1 - c;
                else {
                    if (o === l) return s ? NaN : 1 / 0 * (p ? -1 : 1);
                    s += Math.pow(2, r), o -= c;
                }
                return (p ? -1 : 1) * s * Math.pow(2, o - r);
            },
            write: function(e1, t, i, r, n, o) {
                var s, a, l, c = 8 * o - n - 1, h = (1 << c) - 1, u = h >> 1, d = 23 === n ? Math.pow(2, -24) - Math.pow(2, -77) : 0, p = r ? 0 : o - 1, f = r ? 1 : -1, m = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
                for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = h) : (s = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), (t += s + u >= 1 ? d / l : d * Math.pow(2, 1 - u)) * l >= 2 && (s++, l /= 2), s + u >= h ? (a = 0, s = h) : s + u >= 1 ? (a = (t * l - 1) * Math.pow(2, n), s += u) : (a = t * Math.pow(2, u - 1) * Math.pow(2, n), s = 0)); n >= 8; e1[i + p] = 255 & a, p += f, a /= 256, n -= 8);
                for(s = s << n | a, c += n; c > 0; e1[i + p] = 255 & s, p += f, s /= 256, c -= 8);
                e1[i + p - f] |= 128 * m;
            }
        }, fm = _m, mm = pm;
        function _m(e1) {
            this.buf = ArrayBuffer.isView && ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1 || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
        }
        _m.Varint = 0, _m.Fixed64 = 1, _m.Bytes = 2, _m.Fixed32 = 5;
        var gm = 4294967296, ym = 1 / gm, xm = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
        function vm(e1) {
            return e1.type === _m.Bytes ? e1.readVarint() + e1.pos : e1.pos + 1;
        }
        function bm(e1, t, i) {
            return i ? 4294967296 * t + (e1 >>> 0) : 4294967296 * (t >>> 0) + (e1 >>> 0);
        }
        function wm(e1, t, i) {
            var r = t <= 16383 ? 1 : t <= 2097151 ? 2 : t <= 268435455 ? 3 : Math.floor(Math.log(t) / (7 * Math.LN2));
            i.realloc(r);
            for(var n = i.pos - 1; n >= e1; n--)i.buf[n + r] = i.buf[n];
        }
        function Tm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeVarint(e1[i]);
        }
        function Em(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeSVarint(e1[i]);
        }
        function Mm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeFloat(e1[i]);
        }
        function Am(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeDouble(e1[i]);
        }
        function Sm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeBoolean(e1[i]);
        }
        function Im(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeFixed32(e1[i]);
        }
        function Cm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeSFixed32(e1[i]);
        }
        function zm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeFixed64(e1[i]);
        }
        function Pm(e1, t) {
            for(var i = 0; i < e1.length; i++)t.writeSFixed64(e1[i]);
        }
        function Dm(e1, t) {
            return (e1[t] | e1[t + 1] << 8 | e1[t + 2] << 16) + 16777216 * e1[t + 3];
        }
        function Rm(e1, t, i) {
            e1[i] = t, e1[i + 1] = t >>> 8, e1[i + 2] = t >>> 16, e1[i + 3] = t >>> 24;
        }
        function Lm(e1, t) {
            return (e1[t] | e1[t + 1] << 8 | e1[t + 2] << 16) + (e1[t + 3] << 24);
        }
        _m.prototype = {
            destroy: function() {
                this.buf = null;
            },
            readFields: function(e1, t, i) {
                for(i = i || this.length; this.pos < i;){
                    var r = this.readVarint(), n = r >> 3, o = this.pos;
                    this.type = 7 & r, e1(n, t, this), this.pos === o && this.skip(r);
                }
                return t;
            },
            readMessage: function(e1, t) {
                return this.readFields(e1, t, this.readVarint() + this.pos);
            },
            readFixed32: function() {
                var e1 = Dm(this.buf, this.pos);
                return this.pos += 4, e1;
            },
            readSFixed32: function() {
                var e1 = Lm(this.buf, this.pos);
                return this.pos += 4, e1;
            },
            readFixed64: function() {
                var e1 = Dm(this.buf, this.pos) + Dm(this.buf, this.pos + 4) * gm;
                return this.pos += 8, e1;
            },
            readSFixed64: function() {
                var e1 = Dm(this.buf, this.pos) + Lm(this.buf, this.pos + 4) * gm;
                return this.pos += 8, e1;
            },
            readFloat: function() {
                var e1 = mm.read(this.buf, this.pos, !0, 23, 4);
                return this.pos += 4, e1;
            },
            readDouble: function() {
                var e1 = mm.read(this.buf, this.pos, !0, 52, 8);
                return this.pos += 8, e1;
            },
            readVarint: function(e1) {
                var t, i, r = this.buf;
                return t = 127 & (i = r[this.pos++]), i < 128 ? t : (t |= (127 & (i = r[this.pos++])) << 7, i < 128 ? t : (t |= (127 & (i = r[this.pos++])) << 14, i < 128 ? t : (t |= (127 & (i = r[this.pos++])) << 21, i < 128 ? t : function(e1, t, i) {
                    var r, n, o = i.buf;
                    if (r = (112 & (n = o[i.pos++])) >> 4, n < 128) return bm(e1, r, t);
                    if (r |= (127 & (n = o[i.pos++])) << 3, n < 128) return bm(e1, r, t);
                    if (r |= (127 & (n = o[i.pos++])) << 10, n < 128) return bm(e1, r, t);
                    if (r |= (127 & (n = o[i.pos++])) << 17, n < 128) return bm(e1, r, t);
                    if (r |= (127 & (n = o[i.pos++])) << 24, n < 128) return bm(e1, r, t);
                    if (r |= (1 & (n = o[i.pos++])) << 31, n < 128) return bm(e1, r, t);
                    throw new Error("Expected varint not more than 10 bytes");
                }(t |= (15 & (i = r[this.pos])) << 28, e1, this))));
            },
            readVarint64: function() {
                return this.readVarint(!0);
            },
            readSVarint: function() {
                var e1 = this.readVarint();
                return e1 % 2 == 1 ? (e1 + 1) / -2 : e1 / 2;
            },
            readBoolean: function() {
                return Boolean(this.readVarint());
            },
            readString: function() {
                var e1 = this.readVarint() + this.pos, t = this.pos;
                return this.pos = e1, e1 - t >= 12 && xm ? function(e1, t, i) {
                    return xm.decode(e1.subarray(t, i));
                }(this.buf, t, e1) : function(e1, t, i) {
                    for(var r = "", n = t; n < i;){
                        var o, s, a, l = e1[n], c = null, h = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                        if (n + h > i) break;
                        1 === h ? l < 128 && (c = l) : 2 === h ? 128 == (192 & (o = e1[n + 1])) && (c = (31 & l) << 6 | 63 & o) <= 127 && (c = null) : 3 === h ? (s = e1[n + 2], 128 == (192 & (o = e1[n + 1])) && 128 == (192 & s) && ((c = (15 & l) << 12 | (63 & o) << 6 | 63 & s) <= 2047 || c >= 55296 && c <= 57343) && (c = null)) : 4 === h && (s = e1[n + 2], a = e1[n + 3], 128 == (192 & (o = e1[n + 1])) && 128 == (192 & s) && 128 == (192 & a) && ((c = (15 & l) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) <= 65535 || c >= 1114112) && (c = null)), null === c ? (c = 65533, h = 1) : c > 65535 && (c -= 65536, r += String.fromCharCode(c >>> 10 & 1023 | 55296), c = 56320 | 1023 & c), r += String.fromCharCode(c), n += h;
                    }
                    return r;
                }(this.buf, t, e1);
            },
            readBytes: function() {
                var e1 = this.readVarint() + this.pos, t = this.buf.subarray(this.pos, e1);
                return this.pos = e1, t;
            },
            readPackedVarint: function(e1, t) {
                if (this.type !== _m.Bytes) return e1.push(this.readVarint(t));
                var i = vm(this);
                for(e1 = e1 || []; this.pos < i;)e1.push(this.readVarint(t));
                return e1;
            },
            readPackedSVarint: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readSVarint());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readSVarint());
                return e1;
            },
            readPackedBoolean: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readBoolean());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readBoolean());
                return e1;
            },
            readPackedFloat: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readFloat());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readFloat());
                return e1;
            },
            readPackedDouble: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readDouble());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readDouble());
                return e1;
            },
            readPackedFixed32: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readFixed32());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readFixed32());
                return e1;
            },
            readPackedSFixed32: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readSFixed32());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readSFixed32());
                return e1;
            },
            readPackedFixed64: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readFixed64());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readFixed64());
                return e1;
            },
            readPackedSFixed64: function(e1) {
                if (this.type !== _m.Bytes) return e1.push(this.readSFixed64());
                var t = vm(this);
                for(e1 = e1 || []; this.pos < t;)e1.push(this.readSFixed64());
                return e1;
            },
            skip: function(e1) {
                var t = 7 & e1;
                if (t === _m.Varint) for(; this.buf[this.pos++] > 127;);
                else if (t === _m.Bytes) this.pos = this.readVarint() + this.pos;
                else if (t === _m.Fixed32) this.pos += 4;
                else {
                    if (t !== _m.Fixed64) throw new Error("Unimplemented type: " + t);
                    this.pos += 8;
                }
            },
            writeTag: function(e1, t) {
                this.writeVarint(e1 << 3 | t);
            },
            realloc: function(e1) {
                for(var t = this.length || 16; t < this.pos + e1;)t *= 2;
                if (t !== this.length) {
                    var i = new Uint8Array(t);
                    i.set(this.buf), this.buf = i, this.length = t;
                }
            },
            finish: function() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            },
            writeFixed32: function(e1) {
                this.realloc(4), Rm(this.buf, e1, this.pos), this.pos += 4;
            },
            writeSFixed32: function(e1) {
                this.realloc(4), Rm(this.buf, e1, this.pos), this.pos += 4;
            },
            writeFixed64: function(e1) {
                this.realloc(8), Rm(this.buf, -1 & e1, this.pos), Rm(this.buf, Math.floor(e1 * ym), this.pos + 4), this.pos += 8;
            },
            writeSFixed64: function(e1) {
                this.realloc(8), Rm(this.buf, -1 & e1, this.pos), Rm(this.buf, Math.floor(e1 * ym), this.pos + 4), this.pos += 8;
            },
            writeVarint: function(e1) {
                (e1 = +e1 || 0) > 268435455 || e1 < 0 ? function(e1, t) {
                    var i, r;
                    if (e1 >= 0 ? (i = e1 % 4294967296 | 0, r = e1 / 4294967296 | 0) : (r = ~(-e1 / 4294967296), 4294967295 ^ (i = ~(-e1 % 4294967296)) ? i = i + 1 | 0 : (i = 0, r = r + 1 | 0)), e1 >= 0x10000000000000000 || e1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    t.realloc(10), function(e1, t, i) {
                        i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, e1 >>>= 7, i.buf[i.pos++] = 127 & e1 | 128, i.buf[i.pos] = 127 & (e1 >>>= 7);
                    }(i, 0, t), function(e1, t) {
                        var i = (7 & e1) << 4;
                        t.buf[t.pos++] |= i | ((e1 >>>= 3) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t.buf[t.pos++] = 127 & e1)))));
                    }(r, t);
                }(e1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & e1 | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = e1 >>> 7 & 127))));
            },
            writeSVarint: function(e1) {
                this.writeVarint(e1 < 0 ? 2 * -e1 - 1 : 2 * e1);
            },
            writeBoolean: function(e1) {
                this.writeVarint(Boolean(e1));
            },
            writeString: function(e1) {
                e1 = String(e1), this.realloc(4 * e1.length), this.pos++;
                var t = this.pos;
                this.pos = function(e1, t, i) {
                    for(var r, n, o = 0; o < t.length; o++){
                        if ((r = t.charCodeAt(o)) > 55295 && r < 57344) {
                            if (!n) {
                                r > 56319 || o + 1 === t.length ? (e1[i++] = 239, e1[i++] = 191, e1[i++] = 189) : n = r;
                                continue;
                            }
                            if (r < 56320) {
                                e1[i++] = 239, e1[i++] = 191, e1[i++] = 189, n = r;
                                continue;
                            }
                            r = n - 55296 << 10 | r - 56320 | 65536, n = null;
                        } else n && (e1[i++] = 239, e1[i++] = 191, e1[i++] = 189, n = null);
                        r < 128 ? e1[i++] = r : (r < 2048 ? e1[i++] = r >> 6 | 192 : (r < 65536 ? e1[i++] = r >> 12 | 224 : (e1[i++] = r >> 18 | 240, e1[i++] = r >> 12 & 63 | 128), e1[i++] = r >> 6 & 63 | 128), e1[i++] = 63 & r | 128);
                    }
                    return i;
                }(this.buf, e1, this.pos);
                var i = this.pos - t;
                i >= 128 && wm(t, i, this), this.pos = t - 1, this.writeVarint(i), this.pos += i;
            },
            writeFloat: function(e1) {
                this.realloc(4), mm.write(this.buf, e1, this.pos, !0, 23, 4), this.pos += 4;
            },
            writeDouble: function(e1) {
                this.realloc(8), mm.write(this.buf, e1, this.pos, !0, 52, 8), this.pos += 8;
            },
            writeBytes: function(e1) {
                var t = e1.length;
                this.writeVarint(t), this.realloc(t);
                for(var i = 0; i < t; i++)this.buf[this.pos++] = e1[i];
            },
            writeRawMessage: function(e1, t) {
                this.pos++;
                var i = this.pos;
                e1(t, this);
                var r = this.pos - i;
                r >= 128 && wm(i, r, this), this.pos = i - 1, this.writeVarint(r), this.pos += r;
            },
            writeMessage: function(e1, t, i) {
                this.writeTag(e1, _m.Bytes), this.writeRawMessage(t, i);
            },
            writePackedVarint: function(e1, t) {
                t.length && this.writeMessage(e1, Tm, t);
            },
            writePackedSVarint: function(e1, t) {
                t.length && this.writeMessage(e1, Em, t);
            },
            writePackedBoolean: function(e1, t) {
                t.length && this.writeMessage(e1, Sm, t);
            },
            writePackedFloat: function(e1, t) {
                t.length && this.writeMessage(e1, Mm, t);
            },
            writePackedDouble: function(e1, t) {
                t.length && this.writeMessage(e1, Am, t);
            },
            writePackedFixed32: function(e1, t) {
                t.length && this.writeMessage(e1, Im, t);
            },
            writePackedSFixed32: function(e1, t) {
                t.length && this.writeMessage(e1, Cm, t);
            },
            writePackedFixed64: function(e1, t) {
                t.length && this.writeMessage(e1, zm, t);
            },
            writePackedSFixed64: function(e1, t) {
                t.length && this.writeMessage(e1, Pm, t);
            },
            writeBytesField: function(e1, t) {
                this.writeTag(e1, _m.Bytes), this.writeBytes(t);
            },
            writeFixed32Field: function(e1, t) {
                this.writeTag(e1, _m.Fixed32), this.writeFixed32(t);
            },
            writeSFixed32Field: function(e1, t) {
                this.writeTag(e1, _m.Fixed32), this.writeSFixed32(t);
            },
            writeFixed64Field: function(e1, t) {
                this.writeTag(e1, _m.Fixed64), this.writeFixed64(t);
            },
            writeSFixed64Field: function(e1, t) {
                this.writeTag(e1, _m.Fixed64), this.writeSFixed64(t);
            },
            writeVarintField: function(e1, t) {
                this.writeTag(e1, _m.Varint), this.writeVarint(t);
            },
            writeSVarintField: function(e1, t) {
                this.writeTag(e1, _m.Varint), this.writeSVarint(t);
            },
            writeStringField: function(e1, t) {
                this.writeTag(e1, _m.Bytes), this.writeString(t);
            },
            writeFloatField: function(e1, t) {
                this.writeTag(e1, _m.Fixed32), this.writeFloat(t);
            },
            writeDoubleField: function(e1, t) {
                this.writeTag(e1, _m.Fixed64), this.writeDouble(t);
            },
            writeBooleanField: function(e1, t) {
                this.writeVarintField(e1, Boolean(t));
            }
        };
        var km = d(fm);
        const Om = [
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class Bm {
            get geometry() {
                return void 0 === this._geometry && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(e1) {
                this._geometry = e1;
            }
            toJSON() {
                const e1 = {
                    type: "Feature",
                    state: void 0,
                    geometry: this.geometry,
                    properties: this.properties
                };
                void 0 !== this.id && (e1.id = this.id);
                for (const t of Om)void 0 !== this[t] && (e1[t] = this[t]);
                return e1;
            }
            constructor(e1, t, i, r, n){
                this.type = "Feature", this._vectorTileFeature = e1, this._z = t, this._x = i, this._y = r, this.properties = e1.properties, this.id = n;
            }
        }
        class Fm {
            updateState(e1, t, i) {
                const r = String(t);
                if (this.stateChanges[e1] = this.stateChanges[e1] || {}, this.stateChanges[e1][r] = this.stateChanges[e1][r] || {}, k(this.stateChanges[e1][r], i), null === this.deletedStates[e1]) {
                    this.deletedStates[e1] = {};
                    for(const t in this.state[e1])t !== r && (this.deletedStates[e1][t] = null);
                } else if (this.deletedStates[e1] && null === this.deletedStates[e1][r]) {
                    this.deletedStates[e1][r] = {};
                    for(const t in this.state[e1][r])i[t] || (this.deletedStates[e1][r][t] = null);
                } else for(const t in i)this.deletedStates[e1] && this.deletedStates[e1][r] && null === this.deletedStates[e1][r][t] && delete this.deletedStates[e1][r][t];
            }
            removeFeatureState(e1, t, i) {
                if (null === this.deletedStates[e1]) return;
                const r = String(t);
                if (this.deletedStates[e1] = this.deletedStates[e1] || {}, i && void 0 !== t) null !== this.deletedStates[e1][r] && (this.deletedStates[e1][r] = this.deletedStates[e1][r] || {}, this.deletedStates[e1][r][i] = null);
                else if (void 0 !== t) {
                    if (this.stateChanges[e1] && this.stateChanges[e1][r]) for(i in this.deletedStates[e1][r] = {}, this.stateChanges[e1][r])this.deletedStates[e1][r][i] = null;
                    else this.deletedStates[e1][r] = null;
                } else this.deletedStates[e1] = null;
            }
            getState(e1, t) {
                const i = String(t), r = k({}, (this.state[e1] || {})[i], (this.stateChanges[e1] || {})[i]);
                if (null === this.deletedStates[e1]) return {};
                if (this.deletedStates[e1]) {
                    const i = this.deletedStates[e1][t];
                    if (null === i) return {};
                    for(const e1 in i)delete r[e1];
                }
                return r;
            }
            initializeTileState(e1, t) {
                e1.setFeatureState(this.state, t);
            }
            coalesceChanges(e1, t) {
                const i = {};
                for(const e1 in this.stateChanges){
                    this.state[e1] = this.state[e1] || {};
                    const t = {};
                    for(const i in this.stateChanges[e1])this.state[e1][i] || (this.state[e1][i] = {}), k(this.state[e1][i], this.stateChanges[e1][i]), t[i] = this.state[e1][i];
                    i[e1] = t;
                }
                for(const e1 in this.deletedStates){
                    this.state[e1] = this.state[e1] || {};
                    const t = {};
                    if (null === this.deletedStates[e1]) for(const i in this.state[e1])t[i] = {}, this.state[e1][i] = {};
                    else for(const i in this.deletedStates[e1]){
                        if (null === this.deletedStates[e1][i]) this.state[e1][i] = {};
                        else if (this.state[e1][i]) for (const t of Object.keys(this.deletedStates[e1][i]))delete this.state[e1][i][t];
                        t[i] = this.state[e1][i];
                    }
                    i[e1] = i[e1] || {}, k(i[e1], t);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(i).length) for(const r in e1)e1[r].setFeatureState(i, t);
            }
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
        }
        class Nm {
            getElevation(e1, t) {
                const i = this.toIdx(e1, t);
                return {
                    min: this.minimums[i],
                    max: this.maximums[i]
                };
            }
            isLeaf(e1, t) {
                return this.leaves[this.toIdx(e1, t)];
            }
            toIdx(e1, t) {
                return t * this.size + e1;
            }
            constructor(e1){
                this.size = e1, this.minimums = [], this.maximums = [], this.leaves = [];
            }
        }
        function Um(e1, t, i, r) {
            let n = 0, o = Number.MAX_VALUE;
            for(let s = 0; s < 3; s++)if (Math.abs(r[s]) < 1e-15) {
                if (i[s] < e1[s] || i[s] > t[s]) return null;
            } else {
                const a = 1 / r[s];
                let l = (e1[s] - i[s]) * a, c = (t[s] - i[s]) * a;
                if (l > c) {
                    const e1 = l;
                    l = c, c = e1;
                }
                if (l > n && (n = l), c < o && (o = c), n > o) return null;
            }
            return n;
        }
        function Vm(e1, t, i, r, n, o, s, a, l, c, h) {
            const u = r - e1, d = n - t, p = o - i, f = s - e1, m = a - t, _ = l - i, g = h[1] * _ - h[2] * m, y = h[2] * f - h[0] * _, x = h[0] * m - h[1] * f, v = u * g + d * y + p * x;
            if (Math.abs(v) < 1e-15) return null;
            const b = 1 / v, w = c[0] - e1, T = c[1] - t, E = c[2] - i, M = (w * g + T * y + E * x) * b;
            if (M < 0 || M > 1) return null;
            const A = T * p - E * d, S = E * u - w * p, I = w * d - T * u, C = (h[0] * A + h[1] * S + h[2] * I) * b;
            return C < 0 || M + C > 1 ? null : (f * A + m * S + _ * I) * b;
        }
        function jm(e1, t, i) {
            return (e1 - t) / (i - t);
        }
        function Gm(e1, t, i, r, n, o, s, a, l) {
            const c = 1 << i, h = o - r, u = s - n, d = (e1 + 1) / c * h + r, p = (t + 0) / c * u + n, f = (t + 1) / c * u + n;
            a[0] = (e1 + 0) / c * h + r, a[1] = p, l[0] = d, l[1] = f;
        }
        class qm {
            raycastRoot(e1, t, i, r, n, o, s = 1) {
                return Um([
                    e1,
                    t,
                    -100
                ], [
                    i,
                    r,
                    this.maximums[0] * s
                ], n, o);
            }
            raycast(e1, t, i, r, n, o, s = 1) {
                if (!this.nodeCount) return null;
                const a = this.raycastRoot(e1, t, i, r, n, o, s);
                if (null == a) return null;
                const l = [], c = [], h = [], u = [], d = [
                    {
                        idx: 0,
                        t: a,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; d.length > 0;){
                    const { idx: a, t: p, nodex: f, nodey: m, depth: _ } = d.pop();
                    if (this.leaves[a]) {
                        Gm(f, m, _, e1, t, i, r, h, u);
                        const a = 1 << _, l = (f + 0) / a, c = (f + 1) / a, d = (m + 0) / a, g = (m + 1) / a, y = $m(l, d, this.dem) * s, x = $m(c, d, this.dem) * s, v = $m(c, g, this.dem) * s, b = $m(l, g, this.dem) * s, w = Vm(h[0], h[1], y, u[0], h[1], x, u[0], u[1], v, n, o), T = Vm(u[0], u[1], v, h[0], u[1], b, h[0], h[1], y, n, o), E = Math.min(null !== w ? w : Number.MAX_VALUE, null !== T ? T : Number.MAX_VALUE);
                        if (E !== Number.MAX_VALUE) return E;
                        {
                            const e1 = Du.scaleAndAdd([], n, o, p);
                            if (Zm(y, x, b, v, jm(e1[0], h[0], u[0]), jm(e1[1], h[1], u[1])) >= e1[2]) return p;
                        }
                        continue;
                    }
                    let g = 0;
                    for(let d = 0; d < this._siblingOffset.length; d++){
                        Gm((f << 1) + this._siblingOffset[d][0], (m << 1) + this._siblingOffset[d][1], _ + 1, e1, t, i, r, h, u), h[2] = -100, u[2] = this.maximums[this.childOffsets[a] + d] * s;
                        const p = Um(h, u, n, o);
                        if (null != p) {
                            const e1 = p;
                            l[d] = e1;
                            let t = !1;
                            for(let i = 0; i < g && !t; i++)e1 >= l[c[i]] && (c.splice(i, 0, d), t = !0);
                            t || (c[g] = d), g++;
                        }
                    }
                    for(let e1 = 0; e1 < g; e1++){
                        const t = c[e1];
                        d.push({
                            idx: this.childOffsets[a] + t,
                            t: l[t],
                            nodex: (f << 1) + this._siblingOffset[t][0],
                            nodey: (m << 1) + this._siblingOffset[t][1],
                            depth: _ + 1
                        });
                    }
                }
                return null;
            }
            _addNode(e1, t, i) {
                return this.minimums.push(e1), this.maximums.push(t), this.leaves.push(i), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(e1, t, i, r, n) {
                if (1 === e1[r].isLeaf(t, i)) return;
                this.childOffsets[n] || (this.childOffsets[n] = this.nodeCount);
                const o = r - 1, s = e1[o];
                let a = 0, l = 0;
                for(let e1 = 0; e1 < this._siblingOffset.length; e1++){
                    const r = 2 * t + this._siblingOffset[e1][0], n = 2 * i + this._siblingOffset[e1][1], o = s.getElevation(r, n), c = s.isLeaf(r, n), h = this._addNode(o.min, o.max, c);
                    c && (a |= 1 << e1), l || (l = h);
                }
                for(let r = 0; r < this._siblingOffset.length; r++)a & 1 << r || this._construct(e1, 2 * t + this._siblingOffset[r][0], 2 * i + this._siblingOffset[r][1], o, l + r);
            }
            constructor(e1){
                if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = e1, this._siblingOffset = [
                    [
                        0,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        1
                    ]
                ], !this.dem) return;
                const t = function(e1) {
                    const t = Math.ceil(Math.log2(e1.dim / 8)), i = [];
                    let r = Math.ceil(Math.pow(2, t));
                    const n = 1 / r, o = (e1, t, i, r, n)=>{
                        const o = r ? 1 : 0, s = (e1 + 1) * i - o, a = t * i, l = (t + 1) * i - o;
                        n[0] = e1 * i, n[1] = a, n[2] = s, n[3] = l;
                    };
                    let s = new Nm(r);
                    const a = [];
                    for(let t = 0; t < r * r; t++){
                        o(t % r, Math.floor(t / r), n, !1, a);
                        const i = $m(a[0], a[1], e1), l = $m(a[2], a[1], e1), c = $m(a[2], a[3], e1), h = $m(a[0], a[3], e1);
                        s.minimums.push(Math.min(i, l, c, h)), s.maximums.push(Math.max(i, l, c, h)), s.leaves.push(1);
                    }
                    for(i.push(s), r /= 2; r >= 1; r /= 2){
                        const e1 = i[i.length - 1];
                        s = new Nm(r);
                        for(let t = 0; t < r * r; t++){
                            o(t % r, Math.floor(t / r), 2, !0, a);
                            const i = e1.getElevation(a[0], a[1]), n = e1.getElevation(a[2], a[1]), l = e1.getElevation(a[2], a[3]), c = e1.getElevation(a[0], a[3]), h = e1.isLeaf(a[0], a[1]), u = e1.isLeaf(a[2], a[1]), d = e1.isLeaf(a[2], a[3]), p = e1.isLeaf(a[0], a[3]), f = Math.min(i.min, n.min, l.min, c.min), m = Math.max(i.max, n.max, l.max, c.max), _ = h && u && d && p;
                            s.maximums.push(m), s.minimums.push(f), s.leaves.push(m - f <= 5 && _ ? 1 : 0);
                        }
                        i.push(s);
                    }
                    return i;
                }(this.dem), i = t.length - 1, r = t[i];
                this._addNode(r.minimums[0], r.maximums[0], r.leaves[0]), this._construct(t, 0, 0, i, 0);
            }
        }
        function Zm(e1, t, i, r, n, o) {
            return Kr(Kr(e1, i, o), Kr(t, r, o), n);
        }
        function $m(e1, t, i) {
            const r = i.dim, n = z(e1 * r - .5, 0, r - 1), o = z(t * r - .5, 0, r - 1), s = Math.floor(n), a = Math.floor(o), l = Math.min(s + 1, r - 1), c = Math.min(a + 1, r - 1);
            return Zm(i.get(s, a), i.get(l, a), i.get(s, c), i.get(l, c), n - s, o - a);
        }
        const Wm = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        function Hm(e1, t, i) {
            return (256 * e1 * 256 + 256 * t + i) / 10 - 1e4;
        }
        function Xm(e1, t, i) {
            return 256 * e1 + t + i / 256 - 32768;
        }
        class Ym {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            _buildQuadTree() {
                this._tree = new qm(this);
            }
            get(e1, t, i = !1) {
                i && (e1 = z(e1, -1, this.dim), t = z(t, -1, this.dim));
                const r = this._idx(e1, t);
                return this.floatView[r];
            }
            set(e1, t, i) {
                const r = this._idx(e1, t), n = this.floatView[r];
                return this.floatView[r] = i, i - n;
            }
            static getUnpackVector(e1) {
                return Wm[e1];
            }
            _idx(e1, t) {
                if (e1 < -1 || e1 >= this.dim + 1 || t < -1 || t >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (t + 1) * this.stride + (e1 + 1);
            }
            static pack(e1, t) {
                const i = [
                    0,
                    0,
                    0,
                    0
                ], r = Ym.getUnpackVector(t);
                let n = Math.floor((e1 + r[3]) / r[2]);
                return i[2] = n % 256, n = Math.floor(n / 256), i[1] = n % 256, n = Math.floor(n / 256), i[0] = n, i;
            }
            getPixels() {
                return new tf({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(e1, t, i) {
                if (this.dim !== e1.dim) throw new Error("dem dimension mismatch");
                let r = t * this.dim, n = t * this.dim + this.dim, o = i * this.dim, s = i * this.dim + this.dim;
                switch(t){
                    case -1:
                        r = n - 1;
                        break;
                    case 1:
                        n = r + 1;
                }
                switch(i){
                    case -1:
                        o = s - 1;
                        break;
                    case 1:
                        s = o + 1;
                }
                const a = -t * this.dim, l = -i * this.dim;
                for(let t = o; t < s; t++)for(let i = r; i < n; i++){
                    const r = 4 * this._idx(i, t), n = 4 * this._idx(i + a, t + l);
                    this.pixels[r + 0] = e1.pixels[n + 0], this.pixels[r + 1] = e1.pixels[n + 1], this.pixels[r + 2] = e1.pixels[n + 2], this.pixels[r + 3] = e1.pixels[n + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
            constructor(e1, t, i, r = !1){
                if (this.uid = e1, t.height !== t.width) throw new RangeError("DEM tiles must be square");
                if (i && "mapbox" !== i && "terrarium" !== i) return H(`"${i}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = t.height;
                const n = this.dim = t.height - 2, o = new Uint32Array(t.data.buffer);
                if (this.pixels = new Uint8Array(t.data.buffer), this.floatView = new Float32Array(t.data.buffer), this.borderReady = r, this._modifiedForSources = {}, !r) {
                    for(let e1 = 0; e1 < n; e1++)o[this._idx(-1, e1)] = o[this._idx(0, e1)], o[this._idx(n, e1)] = o[this._idx(n - 1, e1)], o[this._idx(e1, -1)] = o[this._idx(e1, 0)], o[this._idx(e1, n)] = o[this._idx(e1, n - 1)];
                    o[this._idx(-1, -1)] = o[this._idx(0, 0)], o[this._idx(n, -1)] = o[this._idx(n - 1, 0)], o[this._idx(-1, n)] = o[this._idx(0, n - 1)], o[this._idx(n, n)] = o[this._idx(n - 1, n - 1)];
                }
                const s = "terrarium" === i ? Xm : Hm;
                for(let e1 = 0; e1 < o.length; ++e1){
                    const t = 4 * e1;
                    this.floatView[e1] = s(this.pixels[t], this.pixels[t + 1], this.pixels[t + 2]);
                }
                this._timestamp = dt.now();
            }
        }
        Rs(Ym, "DEMData"), Rs(qm, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        class Km {
            isDataAvailableAtPoint(e1) {
                const t = this._source();
                if (this.isUsingMockSource() || !t || e1.y < 0 || e1.y > 1) return !1;
                const i = t.getSource().maxzoom, r = 1 << i, n = Math.floor(e1.x), o = Math.floor((e1.x - n) * r), s = Math.floor(e1.y * r), a = this.findDEMTileFor(new qu(i, n, i, o, s));
                return !(!a || !a.dem);
            }
            getAtPointOrZero(e1, t = 0) {
                return this.getAtPoint(e1, t) || 0;
            }
            getAtPoint(e1, t, i = !0) {
                if (this.isUsingMockSource()) return null;
                null == t && (t = null);
                const r = this._source();
                if (!r) return t;
                if (e1.y < 0 || e1.y > 1) return t;
                const n = r.getSource().maxzoom, o = 1 << n, s = Math.floor(e1.x), a = e1.x - s, l = new qu(n, s, n, Math.floor(a * o), Math.floor(e1.y * o)), c = this.findDEMTileFor(l);
                if (!c || !c.dem) return t;
                const h = c.dem, u = 1 << c.tileID.canonical.z, d = (a * u - c.tileID.canonical.x) * h.dim, p = (e1.y * u - c.tileID.canonical.y) * h.dim, f = Math.floor(d), m = Math.floor(p);
                return (i ? this.exaggeration() : 1) * Kr(Kr(h.get(f, m), h.get(f, m + 1), p - m), Kr(h.get(f + 1, m), h.get(f + 1, m + 1), p - m), d - f);
            }
            getAtTileOffset(e1, t, i) {
                const r = 1 << e1.canonical.z;
                return this.getAtPointOrZero(new lp(e1.wrap + (e1.canonical.x + t / cr) / r, (e1.canonical.y + i / cr) / r));
            }
            getAtTileOffsetFunc(e1, t, i, r) {
                return (n)=>{
                    const o = this.getAtTileOffset(e1, n.x, n.y), s = r.upVector(e1.canonical, n.x, n.y), a = r.upVectorScale(e1.canonical, t, i).metersToTile;
                    return Du.scale(s, s, o * a), s;
                };
            }
            getForTilePoints(e1, t, i, r) {
                if (this.isUsingMockSource()) return !1;
                const n = Jm.create(this, e1, r);
                return !!n && (t.forEach((e1)=>{
                    e1[2] = this.exaggeration() * n.getElevationAt(e1[0], e1[1], i);
                }), !0);
            }
            getMinMaxForTile(e1) {
                if (this.isUsingMockSource()) return null;
                const t = this.findDEMTileFor(e1);
                if (!t || !t.dem) return null;
                const i = t.dem.tree, r = t.tileID, n = 1 << e1.canonical.z - r.canonical.z;
                let o = e1.canonical.x / n - r.canonical.x, s = e1.canonical.y / n - r.canonical.y, a = 0;
                for(let t = 0; t < e1.canonical.z - r.canonical.z && !i.leaves[a]; t++){
                    o *= 2, s *= 2;
                    const e1 = 2 * Math.floor(s) + Math.floor(o);
                    a = i.childOffsets[a] + e1, o %= 1, s %= 1;
                }
                return {
                    min: this.exaggeration() * i.minimums[a],
                    max: this.exaggeration() * i.maximums[a]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(e1, t, i) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(e1) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(e1) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
            getMinMaxForVisibleTiles() {
                const e1 = this.visibleDemTiles;
                if (0 === e1.length) return null;
                let t = !1, i = Number.MAX_VALUE, r = Number.MIN_VALUE;
                for (const n of e1){
                    const e1 = this.getMinMaxForTile(n.tileID);
                    e1 && (i = Math.min(i, e1.min), r = Math.max(r, e1.max), t = !0);
                }
                return t ? {
                    min: i,
                    max: r
                } : null;
            }
        }
        class Jm {
            static create(e1, t, i) {
                const r = i || e1.findDEMTileFor(t);
                if (!r || !r.dem) return;
                const n = r.dem, o = r.tileID, s = 1 << t.canonical.z - o.canonical.z;
                return new Jm(r, n.dim / cr / s, [
                    (t.canonical.x / s - o.canonical.x) * n.dim,
                    (t.canonical.y / s - o.canonical.y) * n.dim
                ]);
            }
            tileCoordToPixel(e1, t) {
                const i = t * this._scale + this._offset[1], r = Math.floor(e1 * this._scale + this._offset[0]), n = Math.floor(i);
                return new y(r, n);
            }
            getElevationAt(e1, t, i, r) {
                const n = e1 * this._scale + this._offset[0], o = t * this._scale + this._offset[1], s = Math.floor(n), a = Math.floor(o), l = this._dem;
                return r = !!r, i ? Kr(Kr(l.get(s, a, r), l.get(s, a + 1, r), o - a), Kr(l.get(s + 1, a, r), l.get(s + 1, a + 1, r), o - a), n - s) : l.get(s, a, r);
            }
            getElevationAtPixel(e1, t, i) {
                return this._dem.get(e1, t, !!i);
            }
            getMeterToDEM(e1) {
                return (1 << this._demTile.tileID.canonical.z) * Qd(1, e1) * this._dem.stride;
            }
            constructor(e1, t, i){
                this._demTile = e1, this._dem = this._demTile.dem, this._scale = t, this._offset = i;
            }
        }
        class Qm {
            insert(e1, t, i, r, n, o = 0) {
                const s = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(i, r, n, o);
                const a = this.grid;
                for(let e1 = 0; e1 < t.length; e1++){
                    const i = t[e1], r = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let e1 = 0; e1 < i.length; e1++){
                        const t = i[e1];
                        r[0] = Math.min(r[0], t.x), r[1] = Math.min(r[1], t.y), r[2] = Math.max(r[2], t.x), r[3] = Math.max(r[3], t.y);
                    }
                    r[0] < cr && r[1] < cr && r[2] >= 0 && r[3] >= 0 && a.insert(s, r[0], r[1], r[2], r[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new cm(new km(this.rawTileData)).layers, this.sourceLayerCoder = new dm(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const e1 in this.vtLayers)this.vtFeatures[e1] = [];
                }
                return this.vtLayers;
            }
            query(e1, t, i, r) {
                this.loadVTLayers();
                const n = e1.params || {}, o = Fo(n.filter), s = e1.tileResult, a = e1.transform, l = s.bufferedTilespaceBounds, c = this.grid.query(l.min.x, l.min.y, l.max.x, l.max.y, (e1, t, i, r)=>Pp(s.bufferedTilespaceGeometry, e1, t, i, r));
                c.sort(t_);
                let h = null;
                a.elevation && c.length > 0 && (h = Jm.create(a.elevation, this.tileID));
                const u = {};
                let d;
                for(let a = 0; a < c.length; a++){
                    const l = c[a];
                    if (l === d) continue;
                    d = l;
                    const p = this.featureIndexArray.get(l);
                    let f = null;
                    this.loadMatchingFeature(u, p, o, n.layers, n.availableImages, t, i, r, (t, i, r, n = 0)=>(f || (f = _p(t, this.tileID.canonical, e1.tileTransform)), i.queryIntersectsFeature(s, t, r, f, this.z, e1.transform, e1.pixelPosMatrix, h, n)));
                }
                return u;
            }
            loadMatchingFeature(e1, t, i, r, n, o, s, a, l) {
                const { featureIndex: c, bucketIndex: h, sourceLayerIndex: u, layoutVertexArrayOffset: d } = t, p = this.bucketLayerIDs[h];
                if (r && !function(e1, t) {
                    for(let i = 0; i < e1.length; i++)if (t.indexOf(e1[i]) >= 0) return !0;
                    return !1;
                }(r, p)) return;
                const f = this.sourceLayerCoder.decode(u), m = this.vtLayers[f].feature(c);
                if (i.needGeometry) {
                    const e1 = gp(m, !0);
                    if (!i.filter(new oa(this.tileID.overscaledZ), e1, this.tileID.canonical)) return;
                } else if (!i.filter(new oa(this.tileID.overscaledZ), m)) return;
                const _ = this.getId(m, f);
                for(let t = 0; t < p.length; t++){
                    const i = p[t];
                    if (r && r.indexOf(i) < 0) continue;
                    const h = o[i];
                    if (!h) continue;
                    let u = {};
                    void 0 !== _ && a && (u = a.getState(h.sourceLayer || "_geojsonTileLayer", _));
                    const f = k({}, s[i]);
                    f.paint = e_(f.paint, h.paint, m, u, n), f.layout = e_(f.layout, h.layout, m, u, n);
                    const g = !l || l(m, h, u, d);
                    if (!g) continue;
                    const y = new Bm(m, this.z, this.x, this.y, _);
                    y.layer = f;
                    let x = e1[i];
                    void 0 === x && (x = e1[i] = []), x.push({
                        featureIndex: c,
                        feature: y,
                        intersectionZ: g
                    });
                }
            }
            lookupSymbolFeatures(e1, t, i, r, n, o, s, a) {
                const l = {};
                this.loadVTLayers();
                const c = Fo(n);
                for (const n of e1)this.loadMatchingFeature(l, {
                    bucketIndex: i,
                    sourceLayerIndex: r,
                    featureIndex: n,
                    layoutVertexArrayOffset: 0
                }, c, o, s, a, t);
                return l;
            }
            loadFeature(e1) {
                const { featureIndex: t, sourceLayerIndex: i } = e1;
                this.loadVTLayers();
                const r = this.sourceLayerCoder.decode(i), n = this.vtFeatures[r];
                if (n[t]) return n[t];
                const o = this.vtLayers[r].feature(t);
                return n[t] = o, o;
            }
            hasLayer(e1) {
                for (const t of this.bucketLayerIDs)for (const i of t)if (e1 === i) return !0;
                return !1;
            }
            getId(e1, t) {
                let i = e1.id;
                if (this.promoteId) {
                    const r = "string" == typeof this.promoteId ? this.promoteId : this.promoteId[t];
                    null != r && (i = e1.properties[r]), "boolean" == typeof i && (i = Number(i));
                }
                return i;
            }
            constructor(e1, t){
                this.tileID = e1, this.x = e1.canonical.x, this.y = e1.canonical.y, this.z = e1.canonical.z, this.grid = new Ps(cr, 16, 0), this.featureIndexArray = new ml, this.promoteId = t;
            }
        }
        function e_(e1, t, i, r, n) {
            return q(e1, (e1, o)=>{
                const s = t instanceof pa ? t.get(o) : null;
                return s && s.evaluate ? s.evaluate(i, r, n) : s;
            });
        }
        function t_(e1, t) {
            return t - e1;
        }
        Rs(Qm, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        const i_ = Ia([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), r_ = Ia([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), n_ = Ia([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        Ia([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const o_ = Ia([
            {
                name: "a_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), s_ = Ia([
            {
                name: "a_texb",
                components: 2,
                type: "Uint16"
            }
        ]), a_ = Ia([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            }
        ]), l_ = Ia([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_z_offset",
                components: 1,
                type: "Float32"
            }
        ]);
        Ia([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const c_ = Ia([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), h_ = Ia([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        Ia([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), Ia([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), Ia([
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Float32",
                name: "zOffset"
            },
            {
                type: "Uint8",
                name: "hasIconTextFit"
            }
        ]), Ia([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), Ia([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            }
        ]);
        var u_ = 24;
        const d_ = 128;
        function p_(e1, t) {
            const { expression: i } = t;
            if ("constant" === i.kind) return {
                kind: "constant",
                layoutSize: i.evaluate(new oa(e1 + 1))
            };
            if ("source" === i.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: t, interpolationType: r } = i;
                let n = 0;
                for(; n < t.length && t[n] <= e1;)n++;
                n = Math.max(0, n - 1);
                let o = n;
                for(; o < t.length && t[o] < e1 + 1;)o++;
                o = Math.min(t.length - 1, o);
                const s = t[n], a = t[o];
                return "composite" === i.kind ? {
                    kind: "composite",
                    minZoom: s,
                    maxZoom: a,
                    interpolationType: r
                } : {
                    kind: "camera",
                    minZoom: s,
                    maxZoom: a,
                    minSize: i.evaluate(new oa(s)),
                    maxSize: i.evaluate(new oa(a)),
                    interpolationType: r
                };
            }
        }
        function f_(e1, { uSize: t, uSizeT: i }, { lowerSize: r, upperSize: n }) {
            return "source" === e1.kind ? r / d_ : "composite" === e1.kind ? Kr(r / d_, n / d_, i) : t;
        }
        function m_(e1, t) {
            let i = 0, r = 0;
            if ("constant" === e1.kind) r = e1.layoutSize;
            else if ("source" !== e1.kind) {
                const { interpolationType: n, minZoom: o, maxZoom: s } = e1, a = n ? z(bn.interpolationFactor(n, t, o, s), 0, 1) : 0;
                "camera" === e1.kind ? r = Kr(e1.minSize, e1.maxSize, a) : i = a;
            }
            return {
                uSizeT: i,
                uSize: r
            };
        }
        var __ = Object.freeze({
            __proto__: null,
            SIZE_PACK_FACTOR: d_,
            evaluateSizeForFeature: f_,
            evaluateSizeForZoom: m_,
            getSizeData: p_
        });
        function g_(e1, t, i) {
            return e1.sections.forEach((e1)=>{
                e1.text = function(e1, t, i) {
                    const r = t.layout.get("text-transform").evaluate(i, {});
                    return "uppercase" === r ? e1 = e1.toLocaleUpperCase() : "lowercase" === r && (e1 = e1.toLocaleLowerCase()), na.applyArabicShaping && (e1 = na.applyArabicShaping(e1)), e1;
                }(e1.text, t, i);
            }), e1;
        }
        const y_ = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42",
            "\u2190": "\u2191",
            "\u2192": "\u2193"
        };
        function x_(e1) {
            return "\uFE36" === e1 || "\uFE48" === e1 || "\uFE38" === e1 || "\uFE44" === e1 || "\uFE42" === e1 || "\uFE3E" === e1 || "\uFE3C" === e1 || "\uFE3A" === e1 || "\uFE18" === e1 || "\uFE40" === e1 || "\uFE10" === e1 || "\uFE13" === e1 || "\uFE14" === e1 || "\uFF40" === e1 || "\uFFE3" === e1 || "\uFE11" === e1 || "\uFE12" === e1;
        }
        function v_(e1) {
            return "\uFE35" === e1 || "\uFE47" === e1 || "\uFE37" === e1 || "\uFE43" === e1 || "\uFE41" === e1 || "\uFE3D" === e1 || "\uFE3B" === e1 || "\uFE39" === e1 || "\uFE17" === e1 || "\uFE3F" === e1;
        }
        const b_ = 3;
        function w_(e1, t, i) {
            t.glyphs = [], 1 === e1 && i.readMessage(T_, t);
        }
        function T_(e1, t, i) {
            if (3 === e1) {
                const { id: e1, bitmap: r, width: n, height: o, left: s, top: a, advance: l } = i.readMessage(E_, {});
                t.glyphs.push({
                    id: e1,
                    bitmap: new Qp({
                        width: n + 2 * b_,
                        height: o + 2 * b_
                    }, r),
                    metrics: {
                        width: n,
                        height: o,
                        left: s,
                        top: a,
                        advance: l
                    }
                });
            } else 4 === e1 ? t.ascender = i.readSVarint() : 5 === e1 && (t.descender = i.readSVarint());
        }
        function E_(e1, t, i) {
            1 === e1 ? t.id = i.readVarint() : 2 === e1 ? t.bitmap = i.readBytes() : 3 === e1 ? t.width = i.readVarint() : 4 === e1 ? t.height = i.readVarint() : 5 === e1 ? t.left = i.readSVarint() : 6 === e1 ? t.top = i.readSVarint() : 7 === e1 && (t.advance = i.readVarint());
        }
        const M_ = b_, A_ = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        }, S_ = -17;
        class I_ {
            static forText(e1, t) {
                const i = new I_;
                return i.scale = e1 || 1, i.fontStack = t, i;
            }
            static forImage(e1) {
                const t = new I_;
                return t.imageName = e1, t;
            }
            constructor(){
                this.scale = 1, this.fontStack = "", this.imageName = null;
            }
        }
        class C_ {
            static fromFeature(e1, t) {
                const i = new C_;
                for(let r = 0; r < e1.sections.length; r++){
                    const n = e1.sections[r];
                    n.image ? i.addImageSection(n) : i.addTextSection(n, t);
                }
                return i;
            }
            length() {
                return this.text.length;
            }
            getSection(e1) {
                return this.sections[this.sectionIndex[e1]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(e1) {
                return this.sectionIndex[e1];
            }
            getCodePoint(e1) {
                return this.text.codePointAt(e1);
            }
            verticalizePunctuation(e1) {
                this.text = function(e1, t) {
                    let i = "";
                    for(let r = 0; r < e1.length; r++){
                        const n = e1.charCodeAt(r + 1) || null, o = e1.charCodeAt(r - 1) || null;
                        i += !t && (n && Gs(n) && !y_[e1[r + 1]] || o && Gs(o) && !y_[e1[r - 1]]) || !y_[e1[r]] ? e1[r] : y_[e1[r]];
                    }
                    return i;
                }(this.text, e1);
            }
            trim() {
                let e1 = 0;
                for(let t = 0; t < this.text.length && P_[this.text.charCodeAt(t)]; t++)e1++;
                let t = this.text.length;
                for(let i = this.text.length - 1; i >= 0 && i >= e1 && P_[this.text.charCodeAt(i)]; i--)t--;
                this.text = this.text.substring(e1, t), this.sectionIndex = this.sectionIndex.slice(e1, t);
            }
            substring(e1, t) {
                const i = new C_;
                return i.text = this.text.substring(e1, t), i.sectionIndex = this.sectionIndex.slice(e1, t), i.sections = this.sections, i;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((e1, t)=>Math.max(e1, this.sections[t].scale), 0);
            }
            addTextSection(e1, t) {
                this.text += e1.text, this.sections.push(I_.forText(e1.scale, e1.fontStack || t));
                const i = this.sections.length - 1;
                for(let t = 0; t < e1.text.length; ++t)this.sectionIndex.push(i);
            }
            addImageSection(e1) {
                const t = e1.image ? e1.image.namePrimary : "";
                if (0 === t.length) return void H("Can't add FormattedSection with an empty image.");
                const i = this.getNextImageSectionCharCode();
                i ? (this.text += String.fromCodePoint(i), this.sections.push(I_.forImage(t)), this.sectionIndex.push(this.sections.length - 1)) : H("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
        }
        function z_(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f) {
            const m = C_.fromFeature(e1, n);
            u === A_.vertical && m.verticalizePunctuation(d);
            let _ = [];
            const g = function(e1, t, i, r, n, o) {
                if (!e1) return [];
                const s = [], a = function(e1, t, i, r, n, o) {
                    let s = 0;
                    for(let i = 0; i < e1.length(); i++){
                        const a = e1.getSection(i);
                        s += R_(e1.getCodePoint(i), a, r, n, t, o);
                    }
                    return s / Math.max(1, Math.ceil(s / i));
                }(e1, t, i, r, n, o), l = e1.text.indexOf("\u200B") >= 0;
                let c = 0;
                for(let i = 0; i < e1.length(); i++){
                    const u = e1.getSection(i), d = e1.getCodePoint(i);
                    if (P_[d] || (c += R_(d, u, r, n, t, o)), i < e1.length() - 1) {
                        const t = !((h = d) < 11904 || !(Fs["Bopomofo Extended"](h) || Fs.Bopomofo(h) || Fs["CJK Compatibility Forms"](h) || Fs["CJK Compatibility Ideographs"](h) || Fs["CJK Compatibility"](h) || Fs["CJK Radicals Supplement"](h) || Fs["CJK Strokes"](h) || Fs["CJK Symbols and Punctuation"](h) || Fs["CJK Unified Ideographs Extension A"](h) || Fs["CJK Unified Ideographs"](h) || Fs["Enclosed CJK Letters and Months"](h) || Fs["Halfwidth and Fullwidth Forms"](h) || Fs.Hiragana(h) || Fs["Ideographic Description Characters"](h) || Fs["Kangxi Radicals"](h) || Fs["Katakana Phonetic Extensions"](h) || Fs.Katakana(h) || Fs["Vertical Forms"](h) || Fs["Yi Radicals"](h) || Fs["Yi Syllables"](h)));
                        (D_[d] || t || u.imageName) && s.push(O_(i + 1, c, a, s, k_(d, e1.getCodePoint(i + 1), t && l), !1));
                    }
                }
                var h;
                return B_(O_(e1.length(), c, a, s, 0, !0));
            }(m, c, o, t, r, p), { processBidirectionalText: y, processStyledBidirectionalText: x } = na;
            if (y && 1 === m.sections.length) {
                const e1 = y(m.toString(), g);
                for (const t of e1){
                    const e1 = new C_;
                    e1.text = t, e1.sections = m.sections;
                    for(let i = 0; i < t.length; i++)e1.sectionIndex.push(0);
                    _.push(e1);
                }
            } else if (x) {
                const e1 = x(m.text, m.sectionIndex, g);
                for (const t of e1){
                    const e1 = new C_;
                    e1.text = t[0], e1.sectionIndex = t[1], e1.sections = m.sections, _.push(e1);
                }
            } else _ = function(e1, t) {
                const i = [], r = e1.text;
                let n = 0;
                for (const r of t)i.push(e1.substring(n, r)), n = r;
                return n < r.length && i.push(e1.substring(n, r.length)), i;
            }(m, g);
            const v = [], b = {
                positionedLines: v,
                text: m.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: u,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            return function(e1, t, i, r, n, o, s, a, l, c, h, u) {
                let d = 0, p = 0, f = 0;
                const m = "right" === a ? 1 : "left" === a ? 0 : .5;
                let _ = !1;
                for (const e1 of n){
                    const i = e1.getSections();
                    for (const e1 of i){
                        if (e1.imageName) continue;
                        const i = t[e1.fontStack];
                        if (i && (_ = void 0 !== i.ascender && void 0 !== i.descender, !_)) break;
                    }
                    if (!_) break;
                }
                let g = 0;
                for (const s of n){
                    s.trim();
                    const n = s.getMaxScale(), a = (n - 1) * u_, x = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e1.positionedLines[g] = x;
                    const v = x.positionedGlyphs;
                    let b = 0;
                    if (!s.length()) {
                        p += o, ++g;
                        continue;
                    }
                    let w = 0, T = 0;
                    for(let o = 0; o < s.length(); o++){
                        const a = s.getSection(o), f = s.getSectionIndex(o), m = s.getCodePoint(o);
                        let g = a.scale, x = null, E = null, M = null, A = u_, S = 0;
                        const I = !(l === A_.horizontal || !h && !js(m) || h && (P_[m] || (y = m, Fs.Arabic(y) || Fs["Arabic Supplement"](y) || Fs["Arabic Extended-A"](y) || Fs["Arabic Presentation Forms-A"](y) || Fs["Arabic Presentation Forms-B"](y))));
                        if (a.imageName) {
                            const t = r[a.imageName];
                            if (!t) continue;
                            M = a.imageName, e1.iconsInText = e1.iconsInText || !0, E = t.paddedRect;
                            const i = t.displaySize;
                            g = g * u_ / u, x = {
                                width: i[0],
                                height: i[1],
                                left: 0,
                                top: -M_,
                                advance: I ? i[1] : i[0],
                                localGlyph: !1
                            }, S = _ ? -x.height * g : S_ + n * u_ - i[1] * g, A = x.advance;
                            const o = (I ? i[0] : i[1]) * g - u_ * n;
                            o > 0 && o > b && (b = o);
                        } else {
                            const e1 = i[a.fontStack];
                            if (!e1) continue;
                            e1[m] && (E = e1[m]);
                            const r = t[a.fontStack];
                            if (!r) continue;
                            const o = r.glyphs[m];
                            if (!o) continue;
                            if (x = o.metrics, A = 8203 !== m ? u_ : 0, _) {
                                const e1 = void 0 !== r.ascender ? Math.abs(r.ascender) : 0, t = void 0 !== r.descender ? Math.abs(r.descender) : 0, i = (e1 + t) * g;
                                w < i && (w = i, T = (e1 - t) / 2 * g), S = -e1 * g;
                            } else S = S_ + (n - g) * u_;
                        }
                        I ? (e1.verticalizable = !0, v.push({
                            glyph: m,
                            imageName: M,
                            x: d,
                            y: p + S,
                            vertical: I,
                            scale: g,
                            localGlyph: x.localGlyph,
                            fontStack: a.fontStack,
                            sectionIndex: f,
                            metrics: x,
                            rect: E
                        }), d += A * g + c) : (v.push({
                            glyph: m,
                            imageName: M,
                            x: d,
                            y: p + S,
                            vertical: I,
                            scale: g,
                            localGlyph: x.localGlyph,
                            fontStack: a.fontStack,
                            sectionIndex: f,
                            metrics: x,
                            rect: E
                        }), d += x.advance * g + c);
                    }
                    0 !== v.length && (f = Math.max(d - c, f), _ ? N_(v, m, b, T, o * n / 2) : N_(v, m, b, 0, o / 2)), d = 0;
                    const E = o * n + b;
                    x.lineOffset = Math.max(b, a), p += E, ++g;
                }
                var y;
                const x = p, { horizontalAlign: v, verticalAlign: b } = F_(s);
                (function(e1, t, i, r, n, o) {
                    const s = (t - i) * n, a = -o * r;
                    for (const t of e1)for (const e1 of t.positionedGlyphs)e1.x += s, e1.y += a;
                })(e1.positionedLines, m, v, b, f, x), e1.top += -b * x, e1.bottom = e1.top + x, e1.left += -v * f, e1.right = e1.left + f, e1.hasBaseline = _;
            }(b, t, i, r, _, s, a, l, u, c, d, f), !function(e1) {
                for (const t of e1)if (0 !== t.positionedGlyphs.length) return !1;
                return !0;
            }(v) && b;
        }
        const P_ = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, D_ = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function R_(e1, t, i, r, n, o) {
            if (t.imageName) {
                const e1 = r[t.imageName];
                return e1 ? e1.displaySize[0] * t.scale * u_ / o + n : 0;
            }
            {
                const r = i[t.fontStack], o = r && r.glyphs[e1];
                return o ? o.metrics.advance * t.scale + n : 0;
            }
        }
        function L_(e1, t, i, r) {
            const n = Math.pow(e1 - t, 2);
            return r ? e1 < t ? n / 2 : 2 * n : n + Math.abs(i) * i;
        }
        function k_(e1, t, i) {
            let r = 0;
            return 10 === e1 && (r -= 1e4), i && (r += 150), 40 !== e1 && 65288 !== e1 || (r += 50), 41 !== t && 65289 !== t || (r += 50), r;
        }
        function O_(e1, t, i, r, n, o) {
            let s = null, a = L_(t, i, n, o);
            for (const e1 of r){
                const r = L_(t - e1.x, i, n, o) + e1.badness;
                r <= a && (s = e1, a = r);
            }
            return {
                index: e1,
                x: t,
                priorBreak: s,
                badness: a
            };
        }
        function B_(e1) {
            return e1 ? B_(e1.priorBreak).concat(e1.index) : [];
        }
        function F_(e1) {
            let t = .5, i = .5;
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    t = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    t = 0;
            }
            switch(e1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    i = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    i = 0;
            }
            return {
                horizontalAlign: t,
                verticalAlign: i
            };
        }
        function N_(e1, t, i, r, n) {
            if (!(t || i || r || n)) return;
            const o = e1.length - 1, s = e1[o], a = (s.x + s.metrics.advance * s.scale) * t;
            for(let t = 0; t <= o; t++)e1[t].x -= a, e1[t].y += i + r + n;
        }
        function U_(e1, t, i, r) {
            const { horizontalAlign: n, verticalAlign: o } = F_(r), s = i[0] - e1.displaySize[0] * n, a = i[1] - e1.displaySize[1] * o;
            return {
                imagePrimary: e1,
                imageSecondary: t,
                top: a,
                bottom: a + e1.displaySize[1],
                left: s,
                right: s + e1.displaySize[0]
            };
        }
        function V_(e1, t, i, r, n, o) {
            const s = e1.imagePrimary;
            let a;
            if (s.content) {
                const e1 = s.content, t = s.pixelRatio || 1;
                a = [
                    e1[0] / t,
                    e1[1] / t,
                    s.displaySize[0] - e1[2] / t,
                    s.displaySize[1] - e1[3] / t
                ];
            }
            const l = t.left * o, c = t.right * o;
            let h, u, d, p;
            "width" === i || "both" === i ? (p = n[0] + l - r[3], u = n[0] + c + r[1]) : (p = n[0] + (l + c - s.displaySize[0]) / 2, u = p + s.displaySize[0]);
            const f = t.top * o, m = t.bottom * o;
            return "height" === i || "both" === i ? (h = n[1] + f - r[0], d = n[1] + m + r[2]) : (h = n[1] + (f + m - s.displaySize[1]) / 2, d = h + s.displaySize[1]), {
                imagePrimary: s,
                imageSecondary: void 0,
                top: h,
                right: u,
                bottom: d,
                left: p,
                collisionPadding: a
            };
        }
        class j_ extends y {
            clone() {
                return new j_(this.x, this.y, this.z, this.angle, this.segment);
            }
            constructor(e1, t, i, r, n){
                super(e1, t), this.angle = r, this.z = i, void 0 !== n && (this.segment = n);
            }
        }
        function G_(e1, t, i, r, n) {
            if (void 0 === t.segment) return !0;
            let o = t, s = t.segment + 1, a = 0;
            for(; a > -i / 2;){
                if (s--, s < 0) return !1;
                a -= e1[s].dist(o), o = e1[s];
            }
            a += e1[s].dist(e1[s + 1]), s++;
            const l = [];
            let c = 0;
            for(; a < i / 2;){
                const t = e1[s], i = e1[s + 1];
                if (!i) return !1;
                let o = e1[s - 1].angleTo(t) - t.angleTo(i);
                for(o = Math.abs((o + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: a,
                    angleDelta: o
                }), c += o; a - l[0].distance > r;)c -= l.shift().angleDelta;
                if (c > n) return !1;
                s++, a += t.dist(i);
            }
            return !0;
        }
        function q_(e1) {
            let t = 0;
            for(let i = 0; i < e1.length - 1; i++)t += e1[i].dist(e1[i + 1]);
            return t;
        }
        function Z_(e1, t, i) {
            return e1 ? .6 * t * i : 0;
        }
        function $_(e1, t) {
            return Math.max(e1 ? e1.right - e1.left : 0, t ? t.right - t.left : 0);
        }
        function W_(e1, t, i, r, n, o) {
            const s = Z_(i, n, o), a = $_(i, r) * o;
            let l = 0;
            const c = q_(e1) / 2;
            for(let i = 0; i < e1.length - 1; i++){
                const r = e1[i], n = e1[i + 1], o = r.dist(n);
                if (l + o > c) {
                    const h = (c - l) / o, u = Kr(r.x, n.x, h), d = Kr(r.y, n.y, h), p = new j_(u, d, 0, n.angleTo(r), i);
                    return !s || G_(e1, p, a, s, t) ? p : void 0;
                }
                l += o;
            }
        }
        function H_(e1, t, i, r, n, o, s, a, l) {
            const c = Z_(r, o, s), h = $_(r, n), u = h * s, d = 0 === e1[0].x || e1[0].x === l || 0 === e1[0].y || e1[0].y === l;
            return t - u < t / 4 && (t = u + t / 4), X_(e1, d ? t / 2 * a % t : (h / 2 + 2 * o) * s * a % t, t, c, i, u, d, !1, l);
        }
        function X_(e1, t, i, r, n, o, s, a, l) {
            const c = o / 2, h = q_(e1);
            let u = 0, d = t - i, p = [];
            for(let t = 0; t < e1.length - 1; t++){
                const s = e1[t], a = e1[t + 1], f = s.dist(a), m = a.angleTo(s);
                for(; d + i < u + f;){
                    d += i;
                    const _ = (d - u) / f, g = Kr(s.x, a.x, _), y = Kr(s.y, a.y, _);
                    if (g >= 0 && g < l && y >= 0 && y < l && d - c >= 0 && d + c <= h) {
                        const i = new j_(g, y, 0, m, t);
                        r && !G_(e1, i, o, r, n) || p.push(i);
                    }
                }
                u += f;
            }
            return a || p.length || s || (p = X_(e1, u / 2, i, r, n, o, s, !0, l)), p;
        }
        function Y_(e1, t, i, r, n) {
            const o = [];
            for(let s = 0; s < e1.length; s++){
                const a = e1[s];
                let l;
                for(let e1 = 0; e1 < a.length - 1; e1++){
                    let s = a[e1], c = a[e1 + 1];
                    s.x < t && c.x < t || (s.x < t ? s = new y(t, s.y + (t - s.x) / (c.x - s.x) * (c.y - s.y))._round() : c.x < t && (c = new y(t, s.y + (t - s.x) / (c.x - s.x) * (c.y - s.y))._round()), s.y < i && c.y < i || (s.y < i ? s = new y(s.x + (i - s.y) / (c.y - s.y) * (c.x - s.x), i)._round() : c.y < i && (c = new y(s.x + (i - s.y) / (c.y - s.y) * (c.x - s.x), i)._round()), s.x >= r && c.x >= r || (s.x >= r ? s = new y(r, s.y + (r - s.x) / (c.x - s.x) * (c.y - s.y))._round() : c.x >= r && (c = new y(r, s.y + (r - s.x) / (c.x - s.x) * (c.y - s.y))._round()), s.y >= n && c.y >= n || (s.y >= n ? s = new y(s.x + (n - s.y) / (c.y - s.y) * (c.x - s.x), n)._round() : c.y >= n && (c = new y(s.x + (n - s.y) / (c.y - s.y) * (c.x - s.x), n)._round()), l && s.equals(l[l.length - 1]) || (l = [
                        s
                    ], o.push(l)), l.push(c)))));
                }
            }
            return o;
        }
        function K_(e1) {
            let t = 0, i = 0;
            for (const r of e1)t += r.w * r.h, i = Math.max(i, r.w);
            e1.sort((e1, t)=>t.h - e1.h);
            const r = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(t / .95)), i),
                    h: 1 / 0
                }
            ];
            let n = 0, o = 0;
            for (const t of e1)for(let e1 = r.length - 1; e1 >= 0; e1--){
                const i = r[e1];
                if (!(t.w > i.w || t.h > i.h)) {
                    if (t.x = i.x, t.y = i.y, o = Math.max(o, t.y + t.h), n = Math.max(n, t.x + t.w), t.w === i.w && t.h === i.h) {
                        const t = r.pop();
                        e1 < r.length && (r[e1] = t);
                    } else t.h === i.h ? (i.x += t.w, i.w -= t.w) : t.w === i.w ? (i.y += t.h, i.h -= t.h) : (r.push({
                        x: i.x + t.w,
                        y: i.y,
                        w: i.w - t.w,
                        h: t.h
                    }), i.y += t.h, i.h -= t.h);
                    break;
                }
            }
            return {
                w: n,
                h: o,
                fill: t / (n * o) || 0
            };
        }
        Rs(j_, "Anchor");
        const J_ = 1;
        class Q_ {
            get tl() {
                return [
                    this.paddedRect.x + J_,
                    this.paddedRect.y + J_
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - J_,
                    this.paddedRect.y + this.paddedRect.h - J_
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * J_) / this.pixelRatio,
                    (this.paddedRect.h - 2 * J_) / this.pixelRatio
                ];
            }
            constructor(e1, { pixelRatio: t, version: i, stretchX: r, stretchY: n, content: o }){
                this.paddedRect = e1, this.pixelRatio = t, this.stretchX = r, this.stretchY = n, this.content = o, this.version = i;
            }
        }
        class eg {
            addImages(e1, t, i) {
                for(const r in e1){
                    const n = e1[r], o = {
                        x: 0,
                        y: 0,
                        w: n.data.width + 2 * J_,
                        h: n.data.height + 2 * J_
                    };
                    i.push(o), t[r] = new Q_(o, n), n.hasRenderCallback && this.haveRenderCallbacks.push(r);
                }
            }
            patchUpdatedImages(e1, t, i) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((t)=>e1.hasImage(t, i)), e1.dispatchRenderCallbacks(this.haveRenderCallbacks, i);
                for(const r in e1.getUpdatedImages(i))this.patchUpdatedImage(this.iconPositions[r], e1.getImage(r, i), t), this.patchUpdatedImage(this.patternPositions[r], e1.getImage(r, i), t);
            }
            patchUpdatedImage(e1, t, i) {
                if (!e1 || !t) return;
                if (e1.version === t.version) return;
                e1.version = t.version;
                const [r, n] = e1.tl;
                i.update(t.data, void 0, {
                    x: r,
                    y: n
                });
            }
            constructor(e1, t){
                const i = {}, r = {};
                this.haveRenderCallbacks = [];
                const n = [];
                this.addImages(e1, i, n), this.addImages(t, r, n);
                const { w: o, h: s } = K_(n), a = new ef({
                    width: o || 1,
                    height: s || 1
                });
                for(const t in e1){
                    const r = e1[t], n = i[t].paddedRect;
                    ef.copy(r.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: n.x + J_,
                        y: n.y + J_
                    }, r.data);
                }
                for(const e1 in t){
                    const i = t[e1], n = r[e1].paddedRect, o = n.x + J_, s = n.y + J_, l = i.data.width, c = i.data.height;
                    ef.copy(i.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: s
                    }, i.data), ef.copy(i.data, a, {
                        x: 0,
                        y: c - 1
                    }, {
                        x: o,
                        y: s - 1
                    }, {
                        width: l,
                        height: 1
                    }), ef.copy(i.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: s + c
                    }, {
                        width: l,
                        height: 1
                    }), ef.copy(i.data, a, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: o - 1,
                        y: s
                    }, {
                        width: 1,
                        height: c
                    }), ef.copy(i.data, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + l,
                        y: s
                    }, {
                        width: 1,
                        height: c
                    });
                }
                this.image = a, this.iconPositions = i, this.patternPositions = r;
            }
        }
        Rs(Q_, "ImagePosition"), Rs(eg, "ImageAtlas");
        const tg = 1e20;
        function ig(e1, t, i, r, n, o, s, a, l) {
            for(let c = t; c < t + r; c++)rg(e1, i * o + c, o, n, s, a, l);
            for(let c = i; c < i + n; c++)rg(e1, c * o + t, 1, r, s, a, l);
        }
        function rg(e1, t, i, r, n, o, s) {
            o[0] = 0, s[0] = -tg, s[1] = tg, n[0] = e1[t];
            for(let a = 1, l = 0, c = 0; a < r; a++){
                n[a] = e1[t + a * i];
                const r = a * a;
                do {
                    const e1 = o[l];
                    c = (n[a] - n[e1] + r - e1 * e1) / (a - e1) / 2;
                }while (c <= s[l] && --l > -1);
                l++, o[l] = a, s[l] = c, s[l + 1] = tg;
            }
            for(let a = 0, l = 0; a < r; a++){
                for(; s[l + 1] < a;)l++;
                const r = o[l], c = a - r;
                e1[t + a * i] = n[r] + c * c;
            }
        }
        const ng = 2;
        class og {
            setURL(e1, t) {
                this.urls[t] = e1;
            }
            getGlyphs(e1, t, i) {
                const r = [], o = this.urls[t] || n.GLYPHS_URL;
                for(const t in e1)for (const i of e1[t])r.push({
                    stack: t,
                    id: i
                });
                R(r, ({ stack: e1, id: t }, i)=>{
                    let r = this.entries[e1];
                    r || (r = this.entries[e1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let n = r.glyphs[t];
                    if (void 0 !== n) return void i(null, {
                        stack: e1,
                        id: t,
                        glyph: n
                    });
                    if (n = this._tinySDF(r, e1, t), n) return r.glyphs[t] = n, void i(null, {
                        stack: e1,
                        id: t,
                        glyph: n
                    });
                    const s = Math.floor(t / 256);
                    if (256 * s > 65535) return void i(new Error("glyphs > 65535 not supported"));
                    if (r.ranges[s]) return void i(null, {
                        stack: e1,
                        id: t,
                        glyph: n
                    });
                    let a = r.requests[s];
                    a || (a = r.requests[s] = [], og.loadGlyphRange(e1, s, o, this.requestManager, (e1, t)=>{
                        if (t) {
                            r.ascender = t.ascender, r.descender = t.descender;
                            for(const e1 in t.glyphs)this._doesCharSupportLocalGlyph(+e1) || (r.glyphs[+e1] = t.glyphs[+e1]);
                            r.ranges[s] = !0;
                        }
                        for (const i of a)i(e1, t);
                        delete r.requests[s];
                    })), a.push((r, n)=>{
                        r ? i(r) : n && i(null, {
                            stack: e1,
                            id: t,
                            glyph: n.glyphs[t] || null
                        });
                    });
                }, (e1, t)=>{
                    if (e1) i(e1);
                    else if (t) {
                        const e1 = {};
                        for (const { stack: i, id: r, glyph: n } of t)void 0 === e1[i] && (e1[i] = {}), void 0 === e1[i].glyphs && (e1[i].glyphs = {}), e1[i].glyphs[r] = n && {
                            id: n.id,
                            bitmap: n.bitmap.clone(),
                            metrics: n.metrics
                        }, e1[i].ascender = this.entries[i].ascender, e1[i].descender = this.entries[i].descender;
                        i(null, e1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(e1) {
                return 0 !== this.localGlyphMode && (2 === this.localGlyphMode ? !!this.localFontFamily : !!this.localFontFamily && (Fs["CJK Unified Ideographs"](e1) || Fs["Hangul Syllables"](e1) || Fs.Hiragana(e1) || Fs.Katakana(e1) || Fs["CJK Symbols and Punctuation"](e1) || Fs["CJK Unified Ideographs Extension A"](e1) || Fs["CJK Unified Ideographs Extension B"](e1)));
            }
            _tinySDF(e1, t, i) {
                const r = this.localFontFamily;
                if (!r || !this._doesCharSupportLocalGlyph(i)) return;
                let n = e1.tinySDF;
                if (!n) {
                    let i = "400";
                    /bold/i.test(t) ? i = "900" : /medium/i.test(t) ? i = "500" : /light/i.test(t) && (i = "200"), n = e1.tinySDF = new og.TinySDF({
                        fontFamily: r,
                        fontWeight: i,
                        fontSize: 24 * ng,
                        buffer: 3 * ng,
                        radius: 8 * ng
                    }), n.fontWeight = i;
                }
                if (this.localGlyphs[n.fontWeight][i]) return this.localGlyphs[n.fontWeight][i];
                const o = String.fromCodePoint(i), { data: s, width: a, height: l, glyphWidth: c, glyphHeight: h, glyphLeft: u, glyphTop: d, glyphAdvance: p } = n.draw(o);
                return this.localGlyphs[n.fontWeight][i] = {
                    id: i,
                    bitmap: new Qp({
                        width: a,
                        height: l
                    }, s),
                    metrics: {
                        width: c / ng,
                        height: h / ng,
                        left: u / ng,
                        top: d / ng - 27,
                        advance: p / ng,
                        localGlyph: !0
                    }
                };
            }
            constructor(e1, t, i){
                this.requestManager = e1, this.localGlyphMode = t, this.localFontFamily = i, this.urls = {}, this.entries = {}, this.localGlyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                };
            }
        }
        og.loadGlyphRange = function(e1, t, i, r, n) {
            const o = 256 * t, s = o + 255, a = r.transformRequest(r.normalizeGlyphsURL(i).replace("{fontstack}", e1).replace("{range}", `${o}-${s}`), ye.Glyphs);
            Te(a, (e1, t)=>{
                if (e1) n(e1);
                else if (t) {
                    const e1 = {}, i = function(e1) {
                        return new km(e1).readFields(w_, {});
                    }(t);
                    for (const t of i.glyphs)e1[t.id] = t;
                    n(null, {
                        glyphs: e1,
                        ascender: i.ascender,
                        descender: i.descender
                    });
                }
            });
        }, og.TinySDF = class {
            _createCanvas(e1) {
                const t = document.createElement("canvas");
                return t.width = t.height = e1, t;
            }
            draw(e1) {
                const { width: t, actualBoundingBoxAscent: i, actualBoundingBoxDescent: r, actualBoundingBoxLeft: n, actualBoundingBoxRight: o } = this.ctx.measureText(e1), s = Math.ceil(i), a = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(o - n))), l = Math.min(this.size - this.buffer, s + Math.ceil(r)), c = a + 2 * this.buffer, h = l + 2 * this.buffer, u = Math.max(c * h, 0), d = new Uint8ClampedArray(u), p = {
                    data: d,
                    width: c,
                    height: h,
                    glyphWidth: a,
                    glyphHeight: l,
                    glyphTop: s,
                    glyphLeft: 0,
                    glyphAdvance: t
                };
                if (0 === a || 0 === l) return p;
                const { ctx: f, buffer: m, gridInner: _, gridOuter: g } = this;
                f.clearRect(m, m, a, l), f.fillText(e1, m, m + s);
                const y = f.getImageData(m, m, a, l);
                g.fill(tg, 0, u), _.fill(0, 0, u);
                for(let e1 = 0; e1 < l; e1++)for(let t = 0; t < a; t++){
                    const i = y.data[4 * (e1 * a + t) + 3] / 255;
                    if (0 === i) continue;
                    const r = (e1 + m) * c + t + m;
                    if (1 === i) g[r] = 0, _[r] = tg;
                    else {
                        const e1 = .5 - i;
                        g[r] = e1 > 0 ? e1 * e1 : 0, _[r] = e1 < 0 ? e1 * e1 : 0;
                    }
                }
                ig(g, 0, 0, c, h, c, this.f, this.v, this.z), ig(_, m, m, a, l, c, this.f, this.v, this.z);
                for(let e1 = 0; e1 < u; e1++){
                    const t = Math.sqrt(g[e1]) - Math.sqrt(_[e1]);
                    d[e1] = Math.round(255 - 255 * (t / this.radius + this.cutoff));
                }
                return p;
            }
            constructor({ fontSize: e1 = 24, buffer: t = 3, radius: i = 8, cutoff: r = .25, fontFamily: n = "sans-serif", fontWeight: o = "normal", fontStyle: s = "normal" } = {}){
                this.buffer = t, this.cutoff = r, this.radius = i;
                const a = this.size = e1 + 4 * t, l = this._createCanvas(a), c = this.ctx = l.getContext("2d", {
                    willReadFrequently: !0
                });
                c.font = `${s} ${o} ${e1}px ${n}`, c.textBaseline = "alphabetic", c.textAlign = "left", c.fillStyle = "black", this.gridOuter = new Float64Array(a * a), this.gridInner = new Float64Array(a * a), this.f = new Float64Array(a), this.z = new Float64Array(a + 1), this.v = new Uint16Array(a);
            }
        };
        const sg = J_;
        function ag(e1, t, i, r) {
            const n = [], o = e1.imagePrimary, s = o.pixelRatio, a = o.paddedRect.w - 2 * sg, l = o.paddedRect.h - 2 * sg, c = e1.right - e1.left, h = e1.bottom - e1.top, u = o.stretchX || [
                [
                    0,
                    a
                ]
            ], d = o.stretchY || [
                [
                    0,
                    l
                ]
            ], p = (e1, t)=>e1 + t[1] - t[0], f = u.reduce(p, 0), m = d.reduce(p, 0), _ = a - f, g = l - m;
            let x = 0, v = f, b = 0, w = m, T = 0, E = _, M = 0, A = g;
            if (o.content && r) {
                const e1 = o.content;
                x = lg(u, 0, e1[0]), b = lg(d, 0, e1[1]), v = lg(u, e1[0], e1[2]), w = lg(d, e1[1], e1[3]), T = e1[0] - x, M = e1[1] - b, E = e1[2] - e1[0] - v, A = e1[3] - e1[1] - w;
            }
            const S = (r, n, a, l)=>{
                const u = hg(r.stretch - x, v, c, e1.left), d = ug(r.fixed - T, E, r.stretch, f), p = hg(n.stretch - b, w, h, e1.top), _ = ug(n.fixed - M, A, n.stretch, m), g = hg(a.stretch - x, v, c, e1.left), S = ug(a.fixed - T, E, a.stretch, f), I = hg(l.stretch - b, w, h, e1.top), C = ug(l.fixed - M, A, l.stretch, m), z = new y(u, p), P = new y(g, p), D = new y(g, I), R = new y(u, I), L = new y(d / s, _ / s), k = new y(S / s, C / s), O = t * Math.PI / 180;
                if (O) {
                    const e1 = Math.sin(O), t = Math.cos(O), i = [
                        t,
                        -e1,
                        e1,
                        t
                    ];
                    z._matMult(i), P._matMult(i), R._matMult(i), D._matMult(i);
                }
                const B = r.stretch + r.fixed, F = a.stretch + a.fixed, N = n.stretch + n.fixed, U = l.stretch + l.fixed, V = e1.imageSecondary;
                return {
                    tl: z,
                    tr: P,
                    bl: R,
                    br: D,
                    texPrimary: {
                        x: o.paddedRect.x + sg + B,
                        y: o.paddedRect.y + sg + N,
                        w: F - B,
                        h: U - N
                    },
                    texSecondary: V ? {
                        x: V.paddedRect.x + sg + B,
                        y: V.paddedRect.y + sg + N,
                        w: F - B,
                        h: U - N
                    } : void 0,
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: L,
                    pixelOffsetBR: k,
                    minFontScaleX: E / s / c,
                    minFontScaleY: A / s / h,
                    isSDF: i
                };
            };
            if (r && (o.stretchX || o.stretchY)) {
                const e1 = cg(u, _, f), t = cg(d, g, m);
                for(let i = 0; i < e1.length - 1; i++){
                    const r = e1[i], o = e1[i + 1];
                    for(let e1 = 0; e1 < t.length - 1; e1++)n.push(S(r, t[e1], o, t[e1 + 1]));
                }
            } else n.push(S({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: a + 1
            }, {
                fixed: 0,
                stretch: l + 1
            }));
            return n;
        }
        function lg(e1, t, i) {
            let r = 0;
            for (const n of e1)r += Math.max(t, Math.min(i, n[1])) - Math.max(t, Math.min(i, n[0]));
            return r;
        }
        function cg(e1, t, i) {
            const r = [
                {
                    fixed: -sg,
                    stretch: 0
                }
            ];
            for (const [t, i] of e1){
                const e1 = r[r.length - 1];
                r.push({
                    fixed: t - e1.stretch,
                    stretch: e1.stretch
                }), r.push({
                    fixed: t - e1.stretch,
                    stretch: e1.stretch + (i - t)
                });
            }
            return r.push({
                fixed: t + sg,
                stretch: i
            }), r;
        }
        function hg(e1, t, i, r) {
            return e1 / t * i + r;
        }
        function ug(e1, t, i, r) {
            return e1 - t * i / r;
        }
        function dg(e1, t, i, r) {
            const n = t + e1.positionedLines[r].lineOffset;
            return 0 === r ? i + n / 2 : i + (n + (t + e1.positionedLines[r - 1].lineOffset)) / 2;
        }
        function pg(e1, t = 1, i = !1) {
            let r = 1 / 0, n = 1 / 0, o = -1 / 0, s = -1 / 0;
            const a = e1[0];
            for(let e1 = 0; e1 < a.length; e1++){
                const t = a[e1];
                (!e1 || t.x < r) && (r = t.x), (!e1 || t.y < n) && (n = t.y), (!e1 || t.x > o) && (o = t.x), (!e1 || t.y > s) && (s = t.y);
            }
            const l = Math.min(o - r, s - n);
            let c = l / 2;
            const h = new lr([], fg);
            if (0 === l) return new y(r, n);
            for(let t = r; t < o; t += l)for(let i = n; i < s; i += l)h.push(new mg(t + c, i + c, c, e1));
            let u = function(e1) {
                let t = 0, i = 0, r = 0;
                const n = e1[0];
                for(let e1 = 0, o = n.length, s = o - 1; e1 < o; s = e1++){
                    const o = n[e1], a = n[s], l = o.x * a.y - a.x * o.y;
                    i += (o.x + a.x) * l, r += (o.y + a.y) * l, t += 3 * l;
                }
                return new mg(i / t, r / t, 0, e1);
            }(e1), d = h.length;
            for(; h.length;){
                const r = h.pop();
                (r.d > u.d || !u.d) && (u = r, i && console.log("found best %d after %d probes", Math.round(1e4 * r.d) / 1e4, d)), r.max - u.d <= t || (c = r.h / 2, h.push(new mg(r.p.x - c, r.p.y - c, c, e1)), h.push(new mg(r.p.x + c, r.p.y - c, c, e1)), h.push(new mg(r.p.x - c, r.p.y + c, c, e1)), h.push(new mg(r.p.x + c, r.p.y + c, c, e1)), d += 4);
            }
            return i && (console.log(`num probes: ${d}`), console.log(`best distance: ${u.d}`)), u.p;
        }
        function fg(e1, t) {
            return t.max - e1.max;
        }
        class mg {
            constructor(e1, t, i, r){
                this.p = new y(e1, t), this.h = i, this.d = function(e1, t) {
                    let i = !1, r = 1 / 0;
                    for(let n = 0; n < t.length; n++){
                        const o = t[n];
                        for(let t = 0, n = o.length, s = n - 1; t < n; s = t++){
                            const n = o[t], a = o[s];
                            n.y > e1.y != a.y > e1.y && e1.x < (a.x - n.x) * (e1.y - n.y) / (a.y - n.y) + n.x && (i = !i), r = Math.min(r, Ip(e1, n, a));
                        }
                    }
                    return (i ? 1 : -1) * Math.sqrt(r);
                }(this.p, r), this.max = this.d + this.h * Math.SQRT2;
            }
        }
        const _g = 7, gg = Number.POSITIVE_INFINITY, yg = Math.sqrt(2);
        function xg(e1, [t, i]) {
            let r = 0, n = 0;
            if (i === gg) {
                t < 0 && (t = 0);
                const i = t / yg;
                switch(e1){
                    case "top-right":
                    case "top-left":
                        n = i - _g;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        n = -i + _g;
                        break;
                    case "bottom":
                        n = -t + _g;
                        break;
                    case "top":
                        n = t - _g;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                        r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        r = i;
                        break;
                    case "left":
                        r = t;
                        break;
                    case "right":
                        r = -t;
                }
            } else {
                switch(t = Math.abs(t), i = Math.abs(i), e1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        n = i - _g;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        n = -i + _g;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        r = -t;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        r = t;
                }
            }
            return [
                r,
                n
            ];
        }
        function vg(e1, t, i, r, n, o, s, a, l, c, h) {
            e1.createArrays(), e1.tilePixelRatio = cr / (512 * e1.overscaling), e1.compareText = {}, e1.iconsNeedLinear = !1;
            const u = e1.layers[0].layout, d = e1.layers[0]._unevaluatedLayout._values, p = {};
            if ("composite" === e1.textSizeData.kind) {
                const { minZoom: t, maxZoom: i } = e1.textSizeData;
                p.compositeTextSizes = [
                    d["text-size"].possiblyEvaluate(new oa(t), a),
                    d["text-size"].possiblyEvaluate(new oa(i), a)
                ];
            }
            if ("composite" === e1.iconSizeData.kind) {
                const { minZoom: t, maxZoom: i } = e1.iconSizeData;
                p.compositeIconSizes = [
                    d["icon-size"].possiblyEvaluate(new oa(t), a),
                    d["icon-size"].possiblyEvaluate(new oa(i), a)
                ];
            }
            p.layoutTextSize = d["text-size"].possiblyEvaluate(new oa(l + 1), a), p.layoutIconSize = d["icon-size"].possiblyEvaluate(new oa(l + 1), a), p.textMaxSize = d["text-size"].possiblyEvaluate(new oa(18), a);
            const f = "map" === u.get("text-rotation-alignment") && "point" !== u.get("symbol-placement"), m = u.get("text-size");
            let _ = !1;
            for (const t of e1.features)if (t.icon && t.icon.nameSecondary) {
                _ = !0;
                break;
            }
            for (const o of e1.features){
                const l = u.get("text-font").evaluate(o, {}, a).join(","), d = m.evaluate(o, {}, a), g = p.layoutTextSize.evaluate(o, {}, a), y = (p.layoutIconSize.evaluate(o, {}, a), {
                    horizontal: {},
                    vertical: void 0
                }), x = o.text;
                let v, b = [
                    0,
                    0
                ];
                if (x) {
                    const r = x.toString(), s = u.get("text-letter-spacing").evaluate(o, {}, a) * u_, c = u.get("text-line-height").evaluate(o, {}, a) * u_, h = Us(r) ? s : 0, p = u.get("text-anchor").evaluate(o, {}, a), m = u.get("text-variable-anchor");
                    if (!m) {
                        const e1 = u.get("text-radial-offset").evaluate(o, {}, a);
                        b = e1 ? xg(p, [
                            e1 * u_,
                            gg
                        ]) : u.get("text-offset").evaluate(o, {}, a).map((e1)=>e1 * u_);
                    }
                    let _ = f ? "center" : u.get("text-justify").evaluate(o, {}, a);
                    const v = "point" === u.get("symbol-placement"), w = v ? u.get("text-max-width").evaluate(o, {}, a) * u_ : 1 / 0, T = (o)=>{
                        e1.allowVerticalPlacement && Ns(r) && (y.vertical = z_(x, t, i, n, l, w, c, p, o, h, b, A_.vertical, !0, g, d));
                    };
                    if (!f && m) {
                        const e1 = "auto" === _ ? m.map((e1)=>bg(e1)) : [
                            _
                        ];
                        let r = !1;
                        for(let o = 0; o < e1.length; o++){
                            const s = e1[o];
                            if (!y.horizontal[s]) {
                                if (r) y.horizontal[s] = y.horizontal[0];
                                else {
                                    const e1 = z_(x, t, i, n, l, w, c, "center", s, h, b, A_.horizontal, !1, g, d);
                                    e1 && (y.horizontal[s] = e1, r = 1 === e1.positionedLines.length);
                                }
                            }
                        }
                        T("left");
                    } else {
                        if ("auto" === _ && (_ = bg(p)), v || u.get("text-writing-mode").indexOf("horizontal") >= 0 || !Ns(r)) {
                            const e1 = z_(x, t, i, n, l, w, c, p, _, h, b, A_.horizontal, !1, g, d);
                            e1 && (y.horizontal[_] = e1);
                        }
                        T(v ? "left" : _);
                    }
                }
                let w = !1;
                if (o.icon && o.icon.namePrimary) {
                    const t = r[o.icon.namePrimary];
                    t && (v = U_(n[o.icon.namePrimary], o.icon.nameSecondary ? n[o.icon.nameSecondary] : void 0, u.get("icon-offset").evaluate(o, {}, a), u.get("icon-anchor").evaluate(o, {}, a)), w = t.sdf, void 0 === e1.sdfIcons ? e1.sdfIcons = t.sdf : e1.sdfIcons !== t.sdf && H("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (t.pixelRatio !== e1.pixelRatio || 0 !== u.get("icon-rotate").constantOr(1)) && (e1.iconsNeedLinear = !0));
                }
                const T = Ag(y.horizontal) || y.vertical;
                e1.iconsInText || (e1.iconsInText = !!T && T.iconsInText), (T || v) && wg(e1, o, y, v, r, p, g, 0, b, w, s, a, c, h, _);
            }
            o && e1.generateCollisionDebugBuffers(l, e1.collisionBoxArray);
        }
        function bg(e1) {
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function wg(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f) {
            let m = o.textMaxSize.evaluate(t, {}, u);
            void 0 === m && (m = s);
            const _ = e1.layers[0].layout, g = _.get("icon-offset").evaluate(t, {}, u), y = Ag(i.horizontal) || i.vertical, x = "globe" === d.name, v = u_, b = s / v, T = e1.tilePixelRatio * m / v, E = (D = e1.overscaling, e1.zoom > 18 && D > 2 && (D >>= 1), Math.max(cr / (512 * D), 1) * _.get("symbol-spacing")), M = _.get("text-padding") * e1.tilePixelRatio, A = _.get("icon-padding") * e1.tilePixelRatio, S = w(_.get("text-max-angle")), I = "map" === _.get("text-rotation-alignment") && "point" !== _.get("symbol-placement"), C = "map" === _.get("icon-rotation-alignment") && "point" !== _.get("symbol-placement"), z = _.get("symbol-placement"), P = E / 2;
            var D;
            const R = _.get("icon-text-fit").evaluate(t, {}, u), L = _.get("icon-text-fit-padding").evaluate(t, {}, u), k = "none" !== R;
            let O;
            !1 === e1.hasAnyIconTextFit && k && (e1.hasAnyIconTextFit = !0), r && k && (e1.allowVerticalPlacement && i.vertical && (O = V_(r, i.vertical, R, L, g, b)), y && (r = V_(r, y, R, L, g, b)));
            const B = (s, a, m)=>{
                if (a.x < 0 || a.x >= cr || a.y < 0 || a.y >= cr) return;
                let _ = null;
                if (x) {
                    const { x: e1, y: t, z: i } = d.projectTilePoint(a.x, a.y, m);
                    _ = {
                        anchor: new j_(e1, t, i, 0, void 0),
                        up: d.upVector(m, a.x, a.y)
                    };
                }
                !function(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b, w, T, E, M, A) {
                    const S = e1.addToLineVertexArray(t, r);
                    let I, C, z, P, D, R, L, k = 0, O = 0, B = 0, F = 0, N = -1, U = -1;
                    const V = {};
                    let j = Cl("");
                    const G = i ? i.anchor : t, q = "none" !== l.layout.get("icon-text-fit").evaluate(v, {}, E);
                    let Z = 0, $ = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset") ? [Z, $] = l.layout.get("text-offset").evaluate(v, {}, E).map((e1)=>e1 * u_) : (Z = l.layout.get("text-radial-offset").evaluate(v, {}, E) * u_, $ = gg), e1.allowVerticalPlacement && n.vertical) {
                        const e1 = n.vertical;
                        if (f) R = Ig(e1), a && (L = Ig(a));
                        else {
                            const i = l.layout.get("text-rotate").evaluate(v, {}, E) + 90;
                            z = Sg(c, G, t, h, u, d, e1, p, i, m), a && (P = Sg(c, G, t, h, u, d, a, g, i));
                        }
                    }
                    if (o) {
                        const r = l.layout.get("icon-rotate").evaluate(v, {}, E), n = ag(o, r, w, q), s = a ? ag(a, r, w, q) : void 0;
                        C = Sg(c, G, t, h, u, d, o, g, r), k = 4 * n.length;
                        const p = e1.iconSizeData;
                        let f = null;
                        "source" === p.kind ? (f = [
                            d_ * l.layout.get("icon-size").evaluate(v, {}, E)
                        ], f[0] > Eg && H(`${e1.layerIds[0]}: Value for "icon-size" is >= ${Tg}. Reduce your "icon-size".`)) : "composite" === p.kind && (f = [
                            d_ * b.compositeIconSizes[0].evaluate(v, {}, E),
                            d_ * b.compositeIconSizes[1].evaluate(v, {}, E)
                        ], (f[0] > Eg || f[1] > Eg) && H(`${e1.layerIds[0]}: Value for "icon-size" is >= ${Tg}. Reduce your "icon-size".`)), e1.addSymbols(e1.icon, n, f, x, y, v, !1, i, t, S.lineStartIndex, S.lineLength, -1, T, E, M, A), N = e1.icon.placedSymbolArray.length - 1, s && (O = 4 * s.length, e1.addSymbols(e1.icon, s, f, x, y, v, A_.vertical, i, t, S.lineStartIndex, S.lineLength, -1, T, E, M, A), U = e1.icon.placedSymbolArray.length - 1);
                    }
                    for(const r in n.horizontal){
                        const o = n.horizontal[r];
                        I || (j = Cl(o.text), f ? D = Ig(o) : I = Sg(c, G, t, h, u, d, o, p, l.layout.get("text-rotate").evaluate(v, {}, E), m));
                        const a = 1 === o.positionedLines.length;
                        if (B += Mg(e1, i, t, o, s, l, f, v, m, S, n.vertical ? A_.horizontal : A_.horizontalOnly, a ? Object.keys(n.horizontal) : [
                            r
                        ], V, N, b, T, E, M), a) break;
                    }
                    n.vertical && (F += Mg(e1, i, t, n.vertical, s, l, f, v, m, S, A_.vertical, [
                        "vertical"
                    ], V, U, b, T, E, M));
                    let W = -1;
                    const X = (e1, t)=>e1 ? Math.max(e1, t) : t;
                    W = X(D, W), W = X(R, W), W = X(L, W);
                    const Y = W > -1 ? 1 : 0;
                    e1.glyphOffsetArray.length >= gy.MAX_GLYPHS && H("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== v.sortKey && e1.addToSortKeyRanges(e1.symbolInstances.length, v.sortKey), e1.symbolInstances.emplaceBack(t.x, t.y, G.x, G.y, G.z, V.right >= 0 ? V.right : -1, V.center >= 0 ? V.center : -1, V.left >= 0 ? V.left : -1, V.vertical >= 0 ? V.vertical : -1, N, U, j, void 0 !== I ? I : e1.collisionBoxArray.length, void 0 !== I ? I + 1 : e1.collisionBoxArray.length, void 0 !== z ? z : e1.collisionBoxArray.length, void 0 !== z ? z + 1 : e1.collisionBoxArray.length, void 0 !== C ? C : e1.collisionBoxArray.length, void 0 !== C ? C + 1 : e1.collisionBoxArray.length, P || e1.collisionBoxArray.length, P ? P + 1 : e1.collisionBoxArray.length, h, B, F, k, O, Y, 0, Z, $, W, 0, q ? 1 : 0);
                }(e1, a, _, s, i, r, n, O, e1.layers[0], e1.collisionBoxArray, t.index, t.sourceLayerIndex, e1.index, M, I, l, 0, A, C, g, t, o, c, h, u, p, f);
            };
            if ("line" === z) for (const n of Y_(t.geometry, 0, 0, cr, cr)){
                const t = H_(n, E, S, i.vertical || y, r, v, T, e1.overscaling, cr);
                for (const i of t)y && Cg(e1, y.text, P, i) || B(n, i, u);
            }
            else if ("line-center" === z) {
                for (const e1 of t.geometry)if (e1.length > 1) {
                    const t = W_(e1, S, i.vertical || y, r, v, T);
                    t && B(e1, t, u);
                }
            } else if ("Polygon" === t.type) for (const e1 of Ff(t.geometry, 0)){
                const t = pg(e1, 16);
                B(e1[0], new j_(t.x, t.y, 0, 0, void 0), u);
            }
            else if ("LineString" === t.type) for (const e1 of t.geometry)B(e1, new j_(e1[0].x, e1[0].y, 0, 0, void 0), u);
            else if ("Point" === t.type) for (const e1 of t.geometry)for (const t of e1)B([
                t
            ], new j_(t.x, t.y, 0, 0, void 0), u);
        }
        const Tg = 255, Eg = Tg * d_;
        function Mg(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g) {
            const x = function(e1, t, i, r, n, o, s, a) {
                const l = [];
                if (0 === t.positionedLines.length) return l;
                const c = r.layout.get("text-rotate").evaluate(o, {}) * Math.PI / 180, h = function(e1) {
                    const t = e1[0], i = e1[1], r = t * i;
                    return r > 0 ? [
                        t,
                        -i
                    ] : r < 0 ? [
                        -t,
                        i
                    ] : 0 === t ? [
                        i,
                        t
                    ] : [
                        i,
                        -t
                    ];
                }(i);
                let u = Math.abs(t.top - t.bottom);
                for (const e1 of t.positionedLines)u -= e1.lineOffset;
                const d = t.positionedLines.length, p = u / d;
                let f = t.top - i[1];
                for(let e1 = 0; e1 < d; ++e1){
                    const r = t.positionedLines[e1];
                    f = dg(t, p, f, e1);
                    for (const e1 of r.positionedGlyphs){
                        if (!e1.rect) continue;
                        const r = e1.rect || {};
                        let o = M_ + 1, u = !0, d = 1, p = 0;
                        if (e1.imageName) {
                            const t = s[e1.imageName];
                            if (!t) continue;
                            if (t.sdf) {
                                H("SDF images are not supported in formatted text and will be ignored.");
                                continue;
                            }
                            u = !1, d = t.pixelRatio, o = J_ / d;
                        }
                        const m = (n || a) && e1.vertical, _ = e1.metrics.advance * e1.scale / 2, g = e1.metrics, x = e1.rect;
                        if (null === x) continue;
                        a && t.verticalizable && (p = e1.imageName ? _ - e1.metrics.width * e1.scale / 2 : 0);
                        const v = n ? [
                            e1.x + _,
                            e1.y
                        ] : [
                            0,
                            0
                        ];
                        let b = [
                            0,
                            0
                        ], w = [
                            0,
                            0
                        ], T = !1;
                        n || (m ? (w = [
                            e1.x + _ + h[0],
                            e1.y + h[1] - p
                        ], T = !0) : b = [
                            e1.x + _ + i[0],
                            e1.y + i[1] - p
                        ]);
                        const E = x.w * e1.scale / (d * (e1.localGlyph ? ng : 1)), M = x.h * e1.scale / (d * (e1.localGlyph ? ng : 1));
                        let A, S, I, C;
                        if (m) {
                            const t = e1.y - f, i = new y(-_, _ - t), r = -Math.PI / 2, n = new y(...w);
                            A = new y(-_ + b[0], b[1]), A._rotateAround(r, i)._add(n), A.x += -t + _, A.y -= (g.left - o) * e1.scale;
                            const s = e1.imageName ? g.advance * e1.scale : u_ * e1.scale, a = String.fromCodePoint(e1.glyph);
                            x_(a) ? A.x += (1 - o) * e1.scale : v_(a) ? A.x += s - g.height * e1.scale + (-o - 1) * e1.scale : A.x += e1.imageName || g.width + 2 * o === x.w && g.height + 2 * o === x.h ? (s - M) / 2 : (s - (g.height + 2 * o) * e1.scale) / 2, S = new y(A.x, A.y - E), I = new y(A.x + M, A.y), C = new y(A.x + M, A.y - E);
                        } else {
                            const t = (g.left - o) * e1.scale - _ + b[0], i = (-g.top - o) * e1.scale + b[1], r = t + E, n = i + M;
                            A = new y(t, i), S = new y(r, i), I = new y(t, n), C = new y(r, n);
                        }
                        if (c) {
                            let e1;
                            e1 = n ? new y(0, 0) : T ? new y(h[0], h[1]) : new y(i[0], i[1]), A._rotateAround(c, e1), S._rotateAround(c, e1), I._rotateAround(c, e1), C._rotateAround(c, e1);
                        }
                        const z = new y(0, 0), P = new y(0, 0);
                        l.push({
                            tl: A,
                            tr: S,
                            bl: I,
                            br: C,
                            texPrimary: r,
                            texSecondary: void 0,
                            writingMode: t.writingMode,
                            glyphOffset: v,
                            sectionIndex: e1.sectionIndex,
                            isSDF: u,
                            pixelOffsetTL: z,
                            pixelOffsetBR: P,
                            minFontScaleX: 0,
                            minFontScaleY: 0
                        });
                    }
                }
                return l;
            }(0, r, l, o, s, a, n, e1.allowVerticalPlacement), v = e1.textSizeData;
            let b = null;
            "source" === v.kind ? (b = [
                d_ * o.layout.get("text-size").evaluate(a, {}, _)
            ], b[0] > Eg && H(`${e1.layerIds[0]}: Value for "text-size" is >= ${Tg}. Reduce your "text-size".`)) : "composite" === v.kind && (b = [
                d_ * f.compositeTextSizes[0].evaluate(a, {}, _),
                d_ * f.compositeTextSizes[1].evaluate(a, {}, _)
            ], (b[0] > Eg || b[1] > Eg) && H(`${e1.layerIds[0]}: Value for "text-size" is >= ${Tg}. Reduce your "text-size".`)), e1.addSymbols(e1.text, x, b, l, s, a, h, t, i, c.lineStartIndex, c.lineLength, p, m, _, g, !1);
            for (const t of u)d[t] = e1.text.placedSymbolArray.length - 1;
            return 4 * x.length;
        }
        function Ag(e1) {
            for(const t in e1)return e1[t];
            return null;
        }
        function Sg(e1, t, i, r, n, o, s, a, l, c) {
            let h = s.top, u = s.bottom, d = s.left, p = s.right;
            const f = s.collisionPadding;
            if (f && (d -= f[0], h -= f[1], p += f[2], u += f[3]), l) {
                const e1 = new y(d, h), t = new y(p, h), i = new y(d, u), r = new y(p, u), n = w(l);
                let o = new y(0, 0);
                c && (o = new y(c[0], c[1])), e1._rotateAround(n, o), t._rotateAround(n, o), i._rotateAround(n, o), r._rotateAround(n, o), d = Math.min(e1.x, t.x, i.x, r.x), p = Math.max(e1.x, t.x, i.x, r.x), h = Math.min(e1.y, t.y, i.y, r.y), u = Math.max(e1.y, t.y, i.y, r.y);
            }
            return e1.emplaceBack(t.x, t.y, t.z, i.x, i.y, d, h, p, u, a, r, n, o), e1.length - 1;
        }
        function Ig(e1) {
            e1.collisionPadding && (e1.top -= e1.collisionPadding[1], e1.bottom += e1.collisionPadding[3]);
            const t = e1.bottom - e1.top;
            return t > 0 ? Math.max(10, t) : null;
        }
        function Cg(e1, t, i, r) {
            const n = e1.compareText;
            if (t in n) {
                const e1 = n[t];
                for(let t = e1.length - 1; t >= 0; t--)if (r.dist(e1[t]) < i) return !0;
            } else n[t] = [];
            return n[t].push(r), !1;
        }
        function zg(e1, t) {
            const i = e1.fovAboveCenter, r = e1.elevation ? e1.elevation.getMinElevationBelowMSL() * t : 0, n = (e1._camera.position[2] * e1.worldSize - r) / Math.cos(e1._pitch), o = Math.sin(i) * n / Math.sin(Math.max(Math.PI / 2 - e1._pitch - i, .01)), s = Math.sin(e1._pitch) * o + n;
            return Math.min(1.01 * s, n * (1 / e1._horizonShift));
        }
        function Pg(e1, t) {
            if (!t.isReprojectedInTileSpace) return {
                scale: 1 << e1.z,
                x: e1.x,
                y: e1.y,
                x2: e1.x + 1,
                y2: e1.y + 1,
                projection: t
            };
            const i = Math.pow(2, -e1.z), r = e1.x * i, n = (e1.x + 1) * i, o = e1.y * i, s = (e1.y + 1) * i, a = ep(r), l = ep(n), c = tp(o), h = tp(s), u = t.project(a, c), d = t.project(l, c), p = t.project(l, h), f = t.project(a, h);
            let m = Math.min(u.x, d.x, p.x, f.x), _ = Math.min(u.y, d.y, p.y, f.y), g = Math.max(u.x, d.x, p.x, f.x), y = Math.max(u.y, d.y, p.y, f.y);
            const x = i / 16;
            function v(e1, i, r, n, o, s) {
                const a = (r + o) / 2, l = (n + s) / 2, c = t.project(ep(a), tp(l)), h = Math.max(0, m - c.x, _ - c.y, c.x - g, c.y - y);
                m = Math.min(m, c.x), g = Math.max(g, c.x), _ = Math.min(_, c.y), y = Math.max(y, c.y), h > x && (v(e1, c, r, n, a, l), v(c, i, a, l, o, s));
            }
            v(u, d, r, o, n, o), v(d, p, n, o, n, s), v(p, f, n, s, r, s), v(f, u, r, s, r, o), m -= x, _ -= x, g += x, y += x;
            const b = 1 / Math.max(g - m, y - _);
            return {
                scale: b,
                x: m * b,
                y: _ * b,
                x2: g * b,
                y2: y * b,
                projection: t
            };
        }
        function Dg(e1, t, i, r, n, o, s, a, l) {
            if ("globe" === l.name) return yd(e1, t, new ju(i, r, n), !1);
            const c = Pg({
                z: i,
                x: r,
                y: n
            }, l);
            return new ed([
                (o + c.x / c.scale) * t,
                t * (c.y / c.scale),
                s
            ], [
                (o + c.x2 / c.scale) * t,
                t * (c.y2 / c.scale),
                a
            ]);
        }
        function Rg(e1, { x: t, y: i }, r = 0) {
            return new y(((t - r) * e1.scale - e1.x) * cr, (i * e1.scale - e1.y) * cr);
        }
        function Lg(e1, t, i = 0) {
            return Du.fromValues(((t.x - i) * e1.scale - e1.x) * cr, (t.y * e1.scale - e1.y) * cr, ip(t.z, t.y));
        }
        const kg = Au.identity(new Float32Array(16));
        class Og {
            project(e1, t) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(e1, t) {
                return new Wd(0, 0);
            }
            projectTilePoint(e1, t, i) {
                return {
                    x: e1,
                    y: t,
                    z: 0
                };
            }
            locationPoint(e1, t, i = !0) {
                return e1._coordinatePoint(e1.locationCoordinate(t), i);
            }
            pixelsPerMeter(e1, t) {
                return Qd(1, e1) * t;
            }
            pixelSpaceConversion(e1, t, i) {
                return 1;
            }
            farthestPixelDistance(e1) {
                return zg(e1, e1.pixelsPerMeter);
            }
            pointCoordinate(e1, t, i, r) {
                const n = e1.horizonLineFromTop(!1), o = new y(t, Math.max(n, i));
                return e1.rayIntersectionCoordinate(e1.pointRayIntersection(o, r));
            }
            pointCoordinate3D(e1, t, i) {
                const r = new y(t, i);
                if (e1.elevation) return e1.elevation.pointCoordinate(r);
                {
                    const t = this.pointCoordinate(e1, r.x, r.y, 0);
                    return [
                        t.x,
                        t.y,
                        t.z
                    ];
                }
            }
            isPointAboveHorizon(e1, t) {
                if (e1.elevation) return !this.pointCoordinate3D(e1, t.x, t.y);
                const i = e1.horizonLineFromTop();
                return t.y < i;
            }
            createInversionMatrix(e1, t) {
                return kg;
            }
            createTileMatrix(e1, t, i) {
                let r, n, o;
                const s = i.canonical, a = Au.identity(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = Pg(s, this);
                    r = 1, n = l.x + i.wrap * l.scale, o = l.y, Au.scale(a, a, [
                        r / l.scale,
                        r / l.scale,
                        e1.pixelsPerMeter / t
                    ]);
                } else r = t / e1.zoomScale(s.z), n = (s.x + Math.pow(2, s.z) * i.wrap) * r, o = s.y * r;
                return Au.translate(a, a, [
                    n,
                    o,
                    0
                ]), Au.scale(a, a, [
                    r / cr,
                    r / cr,
                    1
                ]), a;
            }
            upVector(e1, t, i) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(e1, t, i) {
                return {
                    metersToTile: 1
                };
            }
            constructor(e1){
                this.spec = e1, this.name = e1.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
        }
        class Bg extends Og {
            project(e1, t) {
                const { n: i, c: r, r0: n } = this, o = w(e1 - this.center[0]), s = w(t), a = Math.sqrt(r - 2 * i * Math.sin(s)) / i;
                return {
                    x: a * Math.sin(o * i),
                    y: a * Math.cos(o * i) - n,
                    z: 0
                };
            }
            unproject(e1, t) {
                const { n: i, c: r, r0: n } = this, o = n + t;
                let s = Math.atan2(e1, Math.abs(o)) * Math.sign(o);
                o * i < 0 && (s -= Math.PI * Math.sign(e1) * Math.sign(o));
                const a = w(this.center[0]) * i;
                s = D(s, -Math.PI - a, Math.PI - a);
                const l = z(T(s / i) + this.center[0], -180, 180), c = Math.asin(z((r - (e1 * e1 + o * o) * i * i) / (2 * i), -1, 1)), h = z(T(c), -rp, rp);
                return new Wd(l, h);
            }
            constructor(e1){
                super(e1), this.range = [
                    4,
                    7
                ], this.center = e1.center || [
                    -96,
                    37.5
                ];
                const [t, i] = this.parallels = e1.parallels || [
                    29.5,
                    45.5
                ], r = Math.sin(w(t));
                this.n = (r + Math.sin(w(i))) / 2, this.c = 1 + r * (2 * this.n - r), this.r0 = Math.sqrt(this.c) / this.n;
            }
        }
        const Fg = 1.340264, Ng = -0.081106, Ug = 893e-6, Vg = .003796, jg = Math.sqrt(3) / 2;
        class Gg extends Og {
            project(e1, t) {
                t = t / 180 * Math.PI, e1 = e1 / 180 * Math.PI;
                const i = Math.asin(jg * Math.sin(t)), r = i * i, n = r * r * r;
                return {
                    x: .5 * (e1 * Math.cos(i) / (jg * (Fg + 3 * Ng * r + n * (7 * Ug + 9 * Vg * r))) / Math.PI + .5),
                    y: 1 - .5 * (i * (Fg + Ng * r + n * (Ug + Vg * r)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t) {
                e1 = (2 * e1 - .5) * Math.PI;
                let i = t = (2 * (1 - t) - 1) * Math.PI, r = i * i, n = r * r * r;
                for(let e1, o, s, a = 0; a < 12 && (o = i * (Fg + Ng * r + n * (Ug + Vg * r)) - t, s = Fg + 3 * Ng * r + n * (7 * Ug + 9 * Vg * r), e1 = o / s, i = z(i - e1, -Math.PI / 3, Math.PI / 3), r = i * i, n = r * r * r, !(Math.abs(e1) < 1e-12)); ++a);
                const o = jg * e1 * (Fg + 3 * Ng * r + n * (7 * Ug + 9 * Vg * r)) / Math.cos(i), s = Math.asin(Math.sin(i) / jg), a = z(180 * o / Math.PI, -180, 180), l = z(180 * s / Math.PI, -rp, rp);
                return new Wd(a, l);
            }
        }
        class qg extends Og {
            project(e1, t) {
                return {
                    x: .5 + e1 / 360,
                    y: .5 - t / 360,
                    z: 0
                };
            }
            unproject(e1, t) {
                const i = 360 * (e1 - .5), r = z(360 * (.5 - t), -rp, rp);
                return new Wd(i, r);
            }
            constructor(e1){
                super(e1), this.wrap = !0, this.supportsWorldCopies = !0;
            }
        }
        const Zg = Math.PI / 2;
        function $g(e1) {
            return Math.tan((Zg + e1) / 2);
        }
        class Wg extends Og {
            project(e1, t) {
                t = w(t), this.southernCenter && (t = -t), e1 = w(e1 - this.center[0]);
                const i = 1e-6, { n: r, f: n } = this;
                n > 0 ? t < -Zg + i && (t = -Zg + i) : t > Zg - i && (t = Zg - i);
                const o = n / Math.pow($g(t), r);
                let s = o * Math.sin(r * e1), a = n - o * Math.cos(r * e1);
                return s = .5 * (s / Math.PI + .5), a = .5 * (a / Math.PI + .5), {
                    x: s,
                    y: this.southernCenter ? a : 1 - a,
                    z: 0
                };
            }
            unproject(e1, t) {
                e1 = (2 * e1 - .5) * Math.PI, this.southernCenter && (t = 1 - t), t = (2 * (1 - t) - .5) * Math.PI;
                const { n: i, f: r } = this, n = r - t, o = Math.sign(n), s = Math.sign(i) * Math.sqrt(e1 * e1 + n * n);
                let a = Math.atan2(e1, Math.abs(n)) * o;
                n * i < 0 && (a -= Math.PI * Math.sign(e1) * o);
                const l = z(T(a / i) + this.center[0], -180, 180), c = z(T(2 * Math.atan(Math.pow(r / s, 1 / i)) - Zg), -rp, rp);
                return new Wd(l, this.southernCenter ? -c : c);
            }
            constructor(e1){
                super(e1), this.center = e1.center || [
                    0,
                    30
                ];
                const [t, i] = this.parallels = e1.parallels || [
                    30,
                    30
                ];
                let r = w(t), n = w(i);
                this.southernCenter = r + n < 0, this.southernCenter && (r = -r, n = -n);
                const o = Math.cos(r), s = $g(r);
                this.n = r === n ? Math.sin(r) : Math.log(o / Math.cos(n)) / Math.log($g(n) / s), this.f = o * Math.pow($g(r), this.n) / this.n;
            }
        }
        class Hg extends Og {
            project(e1, t) {
                return {
                    x: Kd(e1),
                    y: Jd(t),
                    z: 0
                };
            }
            unproject(e1, t) {
                const i = ep(e1), r = tp(t);
                return new Wd(i, r);
            }
            constructor(e1){
                super(e1), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
        }
        const Xg = w(rp);
        class Yg extends Og {
            project(e1, t) {
                const i = (t = w(t)) * t, r = i * i;
                return {
                    x: .5 * ((e1 = w(e1)) * (.8707 - .131979 * i + r * (r * (.003971 * i - .001529 * r) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (t * (1.007226 + i * (.015085 + r * (.028874 * i - .044475 - .005916 * r))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t) {
                e1 = (2 * e1 - .5) * Math.PI;
                let i = t = (2 * (1 - t) - 1) * Math.PI, r = 25, n = 0, o = i * i;
                do {
                    o = i * i;
                    const e1 = o * o;
                    n = (i * (1.007226 + o * (.015085 + e1 * (.028874 * o - .044475 - .005916 * e1))) - t) / (1.007226 + o * (.045255 + e1 * (.259866 * o - .311325 - .005916 * 11 * e1))), i = z(i - n, -Xg, Xg);
                }while (Math.abs(n) > 1e-6 && --r > 0);
                o = i * i;
                const s = z(T(e1 / (.8707 + o * (o * (o * o * o * (.003971 - .001529 * o) - .013791) - .131979))), -180, 180), a = T(i);
                return new Wd(s, a);
            }
        }
        const Kg = w(rp);
        class Jg extends Og {
            project(e1, t) {
                t = w(t), e1 = w(e1);
                const i = Math.cos(t), r = 2 / Math.PI, n = Math.acos(i * Math.cos(e1 / 2)), o = Math.sin(n) / n, s = .5 * (e1 * r + 2 * i * Math.sin(e1 / 2) / o) || 0, a = .5 * (t + Math.sin(t) / o) || 0;
                return {
                    x: .5 * (s / Math.PI + .5),
                    y: 1 - .5 * (a / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t) {
                let i = e1 = (2 * e1 - .5) * Math.PI, r = t = (2 * (1 - t) - 1) * Math.PI, n = 25;
                const o = 1e-6;
                let s = 0, a = 0;
                do {
                    const n = Math.cos(r), o = Math.sin(r), l = 2 * o * n, c = o * o, h = n * n, u = Math.cos(i / 2), d = Math.sin(i / 2), p = 2 * u * d, f = d * d, m = 1 - h * u * u, _ = m ? 1 / m : 0, g = m ? Math.acos(n * u) * Math.sqrt(1 / m) : 0, y = .5 * (2 * g * n * d + 2 * i / Math.PI) - e1, x = .5 * (g * o + r) - t, v = .5 * _ * (h * f + g * n * u * c) + 1 / Math.PI, b = _ * (p * l / 4 - g * o * d), w = .125 * _ * (l * d - g * o * h * p), T = .5 * _ * (c * u + g * f * n) + .5, E = b * w - T * v;
                    s = (x * b - y * T) / E, a = (y * w - x * v) / E, i = z(i - s, -Math.PI, Math.PI), r = z(r - a, -Kg, Kg);
                }while ((Math.abs(s) > o || Math.abs(a) > o) && --n > 0);
                return new Wd(T(i), T(r));
            }
        }
        class Qg extends Og {
            project(e1, t) {
                const { scale: i, cosPhi: r } = this;
                return {
                    x: w(e1) * r * i + .5,
                    y: -Math.sin(w(t)) / r * i + .5,
                    z: 0
                };
            }
            unproject(e1, t) {
                const { scale: i, cosPhi: r } = this, n = -(t - .5) / i, o = z(T((e1 - .5) / i) / r, -180, 180), s = Math.asin(z(n * r, -1, 1)), a = z(T(s), -rp, rp);
                return new Wd(o, a);
            }
            constructor(e1){
                super(e1), this.center = e1.center || [
                    0,
                    0
                ], this.parallels = e1.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(w(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
        }
        class ey extends Hg {
            projectTilePoint(e1, t, i) {
                const r = Td(e1, t, i), n = Ad(fd(i));
                return Du.transformMat4(r, r, n), {
                    x: r[0],
                    y: r[1],
                    z: r[2]
                };
            }
            locationPoint(e1, t) {
                const i = wd(t.lat, t.lng), r = Du.normalize([], i), n = e1.elevation ? e1.elevation.getAtPointOrZero(e1.locationCoordinate(t), e1._centerAltitude) : e1._centerAltitude, o = Qd(1, 0) * cr * n;
                Du.scaleAndAdd(i, i, r, o);
                const s = Au.identity(new Float64Array(16));
                return Au.multiply(s, e1.pixelMatrix, e1.globeMatrix), Du.transformMat4(i, i, s), new y(i[0], i[1]);
            }
            pixelsPerMeter(e1, t) {
                return Qd(1, 0) * t;
            }
            pixelSpaceConversion(e1, t, i) {
                const r = Qd(1, e1) * t, n = Kr(Qd(1, 45) * t, r, i);
                return this.pixelsPerMeter(e1, t) / n;
            }
            createTileMatrix(e1, t, i) {
                const r = Sd(fd(i.canonical));
                return Au.multiply(new Float64Array(16), e1.globeMatrix, r);
            }
            createInversionMatrix(e1, t) {
                const { center: i } = e1, r = Ad(fd(t));
                return Au.rotateY(r, r, w(i.lng)), Au.rotateX(r, r, w(i.lat)), Au.scale(r, r, [
                    e1._pixelsPerMercatorPixel,
                    e1._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(r);
            }
            pointCoordinate(e1, t, i, r) {
                return ud(e1, t, i, !0) || new lp(0, 0);
            }
            pointCoordinate3D(e1, t, i) {
                const r = this.pointCoordinate(e1, t, i, 0);
                return [
                    r.x,
                    r.y,
                    r.z
                ];
            }
            isPointAboveHorizon(e1, t) {
                return !ud(e1, t.x, t.y, !1);
            }
            farthestPixelDistance(e1) {
                const t = function(e1, t) {
                    const i = e1.cameraToCenterDistance, r = e1._centerAltitude * t, n = e1._camera, o = e1._camera.forward(), s = Du.add([], Du.scale([], o, -i), [
                        0,
                        0,
                        r
                    ]), a = e1.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -a
                    ], c = e1.width / e1.height, h = Math.tan(e1.fovAboveCenter), u = Du.scale([], n.up(), h), d = Du.scale([], n.right(), h * c), p = Du.normalize([], Du.add([], Du.add([], o, u), d)), f = [];
                    let m;
                    if (new Wu(s, p).closestPointOnSphere(l, a, f)) {
                        const t = Du.add([], f, l), i = Du.sub([], t, s);
                        m = Math.cos(e1.fovAboveCenter) * Du.length(i);
                    } else {
                        const e1 = Du.sub([], s, l), t = Du.sub([], l, s);
                        Du.normalize(t, t);
                        const i = Du.length(e1) - a;
                        m = Math.sqrt(i * (i + 2 * a));
                        const r = Math.acos(m / (a + i)) - Math.acos(Du.dot(o, t));
                        m *= Math.cos(r);
                    }
                    return 1.01 * m;
                }(e1, this.pixelsPerMeter(e1.center.lat, e1.worldSize)), i = Dd(e1.zoom);
                if (i > 0) {
                    const r = zg(e1, Qd(1, e1.center.lat) * e1.worldSize), n = e1.worldSize / (2 * Math.PI), o = Math.max(e1.width, e1.height) / e1.worldSize * Math.PI;
                    return Kr(t, r + n * (1 - Math.cos(o)), Math.pow(i, 10));
                }
                return t;
            }
            upVector(e1, t, i) {
                return Td(t, i, e1, 1);
            }
            upVectorScale(e1) {
                return {
                    metersToTile: hd(Ed(fd(e1)))
                };
            }
            constructor(e1){
                super(e1), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug"
                ], this.range = [
                    3,
                    5
                ];
            }
        }
        function ty(e1) {
            const t = e1.parallels, i = !!t && Math.abs(t[0] + t[1]) < .01;
            switch(e1.name){
                case "mercator":
                    return new Hg(e1);
                case "equirectangular":
                    return new qg(e1);
                case "naturalEarth":
                    return new Yg(e1);
                case "equalEarth":
                    return new Gg(e1);
                case "winkelTripel":
                    return new Jg(e1);
                case "albers":
                    return i ? new Qg(e1) : new Bg(e1);
                case "lambertConformalConic":
                    return i ? new Qg(e1) : new Wg(e1);
                case "globe":
                    return new ey(e1);
            }
            throw new Error(`Invalid projection name: ${e1.name}`);
        }
        const iy = new ga({
            "symbol-placement": new fa(Pt.layout_symbol["symbol-placement"]),
            "symbol-spacing": new fa(Pt.layout_symbol["symbol-spacing"]),
            "symbol-avoid-edges": new fa(Pt.layout_symbol["symbol-avoid-edges"]),
            "symbol-sort-key": new ma(Pt.layout_symbol["symbol-sort-key"]),
            "symbol-z-order": new fa(Pt.layout_symbol["symbol-z-order"]),
            "symbol-z-elevate": new fa(Pt.layout_symbol["symbol-z-elevate"]),
            "icon-allow-overlap": new fa(Pt.layout_symbol["icon-allow-overlap"]),
            "icon-ignore-placement": new fa(Pt.layout_symbol["icon-ignore-placement"]),
            "icon-optional": new fa(Pt.layout_symbol["icon-optional"]),
            "icon-rotation-alignment": new fa(Pt.layout_symbol["icon-rotation-alignment"]),
            "icon-size": new ma(Pt.layout_symbol["icon-size"]),
            "icon-text-fit": new ma(Pt.layout_symbol["icon-text-fit"]),
            "icon-text-fit-padding": new ma(Pt.layout_symbol["icon-text-fit-padding"]),
            "icon-image": new ma(Pt.layout_symbol["icon-image"]),
            "icon-rotate": new ma(Pt.layout_symbol["icon-rotate"]),
            "icon-padding": new fa(Pt.layout_symbol["icon-padding"]),
            "icon-keep-upright": new fa(Pt.layout_symbol["icon-keep-upright"]),
            "icon-offset": new ma(Pt.layout_symbol["icon-offset"]),
            "icon-anchor": new ma(Pt.layout_symbol["icon-anchor"]),
            "icon-pitch-alignment": new fa(Pt.layout_symbol["icon-pitch-alignment"]),
            "text-pitch-alignment": new fa(Pt.layout_symbol["text-pitch-alignment"]),
            "text-rotation-alignment": new fa(Pt.layout_symbol["text-rotation-alignment"]),
            "text-field": new ma(Pt.layout_symbol["text-field"]),
            "text-font": new ma(Pt.layout_symbol["text-font"]),
            "text-size": new ma(Pt.layout_symbol["text-size"]),
            "text-max-width": new ma(Pt.layout_symbol["text-max-width"]),
            "text-line-height": new ma(Pt.layout_symbol["text-line-height"]),
            "text-letter-spacing": new ma(Pt.layout_symbol["text-letter-spacing"]),
            "text-justify": new ma(Pt.layout_symbol["text-justify"]),
            "text-radial-offset": new ma(Pt.layout_symbol["text-radial-offset"]),
            "text-variable-anchor": new fa(Pt.layout_symbol["text-variable-anchor"]),
            "text-anchor": new ma(Pt.layout_symbol["text-anchor"]),
            "text-max-angle": new fa(Pt.layout_symbol["text-max-angle"]),
            "text-writing-mode": new fa(Pt.layout_symbol["text-writing-mode"]),
            "text-rotate": new ma(Pt.layout_symbol["text-rotate"]),
            "text-padding": new fa(Pt.layout_symbol["text-padding"]),
            "text-keep-upright": new fa(Pt.layout_symbol["text-keep-upright"]),
            "text-transform": new ma(Pt.layout_symbol["text-transform"]),
            "text-offset": new ma(Pt.layout_symbol["text-offset"]),
            "text-allow-overlap": new fa(Pt.layout_symbol["text-allow-overlap"]),
            "text-ignore-placement": new fa(Pt.layout_symbol["text-ignore-placement"]),
            "text-optional": new fa(Pt.layout_symbol["text-optional"]),
            visibility: new fa(Pt.layout_symbol.visibility)
        });
        var ry = {
            paint: new ga({
                "icon-opacity": new ma(Pt.paint_symbol["icon-opacity"]),
                "icon-emissive-strength": new ma(Pt.paint_symbol["icon-emissive-strength"]),
                "text-emissive-strength": new ma(Pt.paint_symbol["text-emissive-strength"]),
                "icon-color": new ma(Pt.paint_symbol["icon-color"]),
                "icon-halo-color": new ma(Pt.paint_symbol["icon-halo-color"]),
                "icon-halo-width": new ma(Pt.paint_symbol["icon-halo-width"]),
                "icon-halo-blur": new ma(Pt.paint_symbol["icon-halo-blur"]),
                "icon-translate": new fa(Pt.paint_symbol["icon-translate"]),
                "icon-translate-anchor": new fa(Pt.paint_symbol["icon-translate-anchor"]),
                "icon-image-cross-fade": new ma(Pt.paint_symbol["icon-image-cross-fade"]),
                "text-opacity": new ma(Pt.paint_symbol["text-opacity"]),
                "text-color": new ma(Pt.paint_symbol["text-color"], {
                    runtimeType: Zt,
                    getOverride: (e1)=>e1.textColor,
                    hasOverride: (e1)=>!!e1.textColor
                }),
                "text-halo-color": new ma(Pt.paint_symbol["text-halo-color"]),
                "text-halo-width": new ma(Pt.paint_symbol["text-halo-width"]),
                "text-halo-blur": new ma(Pt.paint_symbol["text-halo-blur"]),
                "text-translate": new fa(Pt.paint_symbol["text-translate"]),
                "text-translate-anchor": new fa(Pt.paint_symbol["text-translate-anchor"]),
                "icon-color-saturation": new fa(Pt.paint_symbol["icon-color-saturation"])
            }),
            layout: iy
        };
        class ny {
            evaluate(e1) {
                if (e1.formattedSection) {
                    const t = this.defaultValue.property.overrides;
                    if (t && t.hasOverride(e1.formattedSection)) return t.getOverride(e1.formattedSection);
                }
                return e1.feature && e1.featureState ? this.defaultValue.evaluate(e1.feature, e1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(e1) {
                this.defaultValue.isConstant() || e1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
            constructor(e1){
                this.type = e1.property.overrides ? e1.property.overrides.runtimeType : Vt, this.defaultValue = e1;
            }
        }
        Rs(ny, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        class oy extends Ta {
            recalculate(e1, t) {
                super.recalculate(e1, t), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const i = this.layout.get("text-writing-mode");
                if (i) {
                    const e1 = [];
                    for (const t of i)e1.indexOf(t) < 0 && e1.push(t);
                    this.layout._values["text-writing-mode"] = e1;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getValueAndResolveTokens(e1, t, i, r) {
                const n = this.layout.get(e1).evaluate(t, {}, i, r), o = this._unevaluatedLayout._values[e1];
                return o.isDataDriven() || To(o.value) || !n ? n : function(e1, t) {
                    return t.replace(/{([^{}]+)}/g, (t, i)=>i in e1 ? String(e1[i]) : "");
                }(t.properties, n);
            }
            createBucket(e1) {
                return new gy(e1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                for (const e1 of ry.paint.overridableProperties){
                    if (!oy.hasPaintOverride(this.layout, e1)) continue;
                    const t = this.paint.get(e1), i = new ny(t), r = new wo(i, t.property.specification);
                    let n = null;
                    n = "constant" === t.value.kind || "source" === t.value.kind ? new Mo("source", r) : new Ao("composite", r, t.value.zoomStops, t.value._interpolationType), this.paint._values[e1] = new da(t.property, n, t.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(e1, t, i) {
                return !(!this.layout || t.isDataDriven() || i.isDataDriven()) && oy.hasPaintOverride(this.layout, e1);
            }
            static hasPaintOverride(e1, t) {
                const i = e1.get("text-field"), r = ry.paint.properties[t];
                let n = !1;
                const o = (e1)=>{
                    for (const t of e1)if (r.overrides && r.overrides.hasOverride(t)) return void (n = !0);
                };
                if ("constant" === i.value.kind && i.value.value instanceof pi) o(i.value.value.sections);
                else if ("source" === i.value.kind) {
                    const e1 = (t)=>{
                        n || (t instanceof vi && gi(t.value) === Xt ? o(t.value.sections) : t instanceof Mi ? o(t.sections) : t.eachChild(e1));
                    }, t = i.value;
                    t._styleExpression && e1(t._styleExpression.expression);
                }
                return n;
            }
            getProgramIds() {
                const e1 = 0 !== this.paint.get("icon-opacity").constantOr(1), t = 0 !== this.paint.get("text-opacity").constantOr(1), i = [];
                return e1 && i.push("symbolIcon"), t && i.push("symbolSDF"), i;
            }
            getDefaultProgramParams(e1, t) {
                return {
                    config: new Ql(this, t),
                    overrideFog: !1
                };
            }
            constructor(e1, t){
                super(e1, ry, t);
            }
        }
        const sy = hm.types, ay = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function ly(e1, t, i, r, n, o, s, a, l, c, h, u, d) {
            const p = a ? Math.min(Eg, Math.round(a[0])) : 0, f = a ? Math.min(Eg, Math.round(a[1])) : 0;
            e1.emplaceBack(t, i, Math.round(32 * r), Math.round(32 * n), o, s, (p << 1) + (l ? 1 : 0), f, 16 * c, 16 * h, 256 * u, 256 * d);
        }
        function cy(e1, t, i) {
            e1.emplaceBack(t, i);
        }
        function hy(e1, t, i, r, n, o, s) {
            e1.emplaceBack(t, i, r, n, o, s);
        }
        function uy(e1, t, i, r, n) {
            const o = 5 * t + 2;
            e1.float32[o + 0] = i, e1.float32[o + 1] = r, e1.float32[o + 2] = n;
        }
        function dy(e1, t, i, r, n) {
            e1.emplaceBack(t, i, r, n), e1.emplaceBack(t, i, r, n), e1.emplaceBack(t, i, r, n), e1.emplaceBack(t, i, r, n);
        }
        function py(e1) {
            for (const t of e1.sections)if ($s(t.text)) return !0;
            return !1;
        }
        class fy {
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
            }
            upload(e1, t, i, r, n) {
                this.isEmpty() || (i && (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, i_.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray, t), this.dynamicLayoutVertexBuffer = e1.createVertexBuffer(this.dynamicLayoutVertexArray, n_.members, !0), this.opacityVertexBuffer = e1.createVertexBuffer(this.opacityVertexArray, ay, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = e1.createVertexBuffer(this.iconTransitioningVertexArray, s_.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = e1.createVertexBuffer(this.globeExtVertexArray, r_.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || n) && (this.zOffsetVertexBuffer = e1.createVertexBuffer(this.zOffsetVertexArray, o_.members, !0)), this.opacityVertexBuffer.itemSize = 1), (i || r) && this.programConfigurations.upload(e1));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy());
            }
            constructor(e1){
                this.layoutVertexArray = new Na, this.indexArray = new Wa, this.programConfigurations = e1, this.segments = new xl, this.dynamicLayoutVertexArray = new ka, this.opacityVertexArray = new Va, this.placedSymbolArray = new cl, this.iconTransitioningVertexArray = new ja, this.globeExtVertexArray = new Ua, this.zOffsetVertexArray = new Ya;
            }
        }
        Rs(fy, "SymbolBuffers");
        class my {
            upload(e1) {
                this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = e1.createVertexBuffer(this.collisionVertexArray, a_.members, !0), this.collisionVertexBufferExt = e1.createVertexBuffer(this.collisionVertexArrayExt, l_.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
            constructor(e1, t, i){
                this.layoutVertexArray = new e1, this.layoutAttributes = t, this.indexArray = new i, this.segments = new xl, this.collisionVertexArray = new $a, this.collisionVertexArrayExt = new ka;
            }
        }
        Rs(my, "CollisionBuffers");
        class _y {
            createArrays() {
                this.text = new fy(new ec(this.layers, this.zoom, (e1)=>/^text/.test(e1))), this.icon = new fy(new ec(this.layers, this.zoom, (e1)=>/^icon/.test(e1))), this.glyphOffsetArray = new dl, this.lineVertexArray = new pl, this.symbolInstances = new ul;
            }
            calculateGlyphDependencies(e1, t, i, r, n) {
                for(let i = 0; i < e1.length; i++){
                    const o = e1.codePointAt(i);
                    if (void 0 === o) break;
                    if (t[o] = !0, r && n && o <= 65535) {
                        const r = y_[e1.charAt(i)];
                        r && (t[r.charCodeAt(0)] = !0);
                    }
                }
            }
            populate(e1, t, i, r) {
                const n = this.layers[0], o = n.layout, s = "globe" === this.projection.name, a = o.get("text-font"), l = o.get("text-field"), c = o.get("icon-image"), h = ("constant" !== l.value.kind || l.value.value instanceof pi && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), u = "constant" !== c.value.kind || !!c.value.value || Object.keys(c.parameters).length > 0, d = o.get("symbol-sort-key");
                if (this.features = [], !h && !u) return;
                const p = t.iconDependencies, f = t.glyphDependencies, m = t.availableImages, _ = new oa(this.zoom);
                for (const { feature: t, id: l, index: c, sourceLayerIndex: g } of e1){
                    const e1 = n._featureFilter.needGeometry, y = gp(t, e1);
                    if (!n._featureFilter.filter(_, y, i)) continue;
                    if (e1 || (y.geometry = _p(t, i, r)), s && 1 !== t.type && i.z <= 5) {
                        const e1 = y.geometry, t = .98078528056, r = (e1, r)=>{
                            const n = Td(e1.x, e1.y, i, 1), o = Td(r.x, r.y, i, 1);
                            return Du.dot(n, o) < t;
                        };
                        for(let t = 0; t < e1.length; t++)e1[t] = dp(e1[t], r);
                    }
                    let x, v;
                    if (h) {
                        const e1 = n.getValueAndResolveTokens("text-field", y, i, m), t = pi.factory(e1);
                        py(t) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === ia() || this.hasRTLText && na.isParsed()) && (x = g_(t, n, y));
                    }
                    if (u) {
                        const e1 = n.getValueAndResolveTokens("icon-image", y, i, m);
                        v = e1 instanceof fi ? e1 : fi.fromString(e1);
                    }
                    if (!x && !v) continue;
                    const b = this.sortFeaturesByKey ? d.evaluate(y, {}, i) : void 0;
                    if (this.features.push({
                        id: l,
                        text: x,
                        icon: v,
                        index: c,
                        sourceLayerIndex: g,
                        geometry: y.geometry,
                        properties: t.properties,
                        type: sy[t.type],
                        sortKey: b
                    }), v && (p[v.namePrimary] = !0, v.nameSecondary && (p[v.nameSecondary] = !0)), x) {
                        const e1 = a.evaluate(y, {}, i).join(","), t = "map" === o.get("text-rotation-alignment") && "point" !== o.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(A_.vertical) >= 0;
                        for (const i of x.sections)if (i.image) p[i.image.namePrimary] = !0;
                        else {
                            const r = Ns(x.toString()), n = i.fontStack || e1, o = f[n] = f[n] || {};
                            this.calculateGlyphDependencies(i.text, o, t, this.allowVerticalPlacement, r);
                        }
                    }
                }
                "line" === o.get("symbol-placement") && (this.features = function(e1) {
                    const t = {}, i = {}, r = [];
                    let n = 0;
                    function o(t) {
                        r.push(e1[t]), n++;
                    }
                    function s(e1, t, n) {
                        const o = i[e1];
                        return delete i[e1], i[t] = o, r[o].geometry[0].pop(), r[o].geometry[0] = r[o].geometry[0].concat(n[0]), o;
                    }
                    function a(e1, i, n) {
                        const o = t[i];
                        return delete t[i], t[e1] = o, r[o].geometry[0].shift(), r[o].geometry[0] = n[0].concat(r[o].geometry[0]), o;
                    }
                    function l(e1, t, i) {
                        const r = i ? t[0][t[0].length - 1] : t[0][0];
                        return `${e1}:${r.x}:${r.y}`;
                    }
                    for(let c = 0; c < e1.length; c++){
                        const h = e1[c], u = h.geometry, d = h.text ? h.text.toString() : null;
                        if (!d) {
                            o(c);
                            continue;
                        }
                        const p = l(d, u), f = l(d, u, !0);
                        if (p in i && f in t && i[p] !== t[f]) {
                            const e1 = a(p, f, u), n = s(p, f, r[e1].geometry);
                            delete t[p], delete i[f], i[l(d, r[n].geometry, !0)] = n, r[e1].geometry = null;
                        } else p in i ? s(p, f, u) : f in t ? a(p, f, u) : (o(c), t[p] = n - 1, i[f] = n - 1);
                    }
                    return r.filter((e1)=>e1.geometry);
                }(this.features)), this.sortFeaturesByKey && this.features.sort((e1, t)=>e1.sortKey - t.sortKey);
            }
            update(e1, t, i, r, n) {
                const o = 0 !== Object.keys(e1).length;
                if (o && !this.stateDependentLayers.length) return;
                const s = o ? this.stateDependentLayers : this.layers;
                this.text.programConfigurations.updatePaintArrays(e1, t, s, i, r, n), this.icon.programConfigurations.updatePaintArrays(e1, t, s, i, r, n);
            }
            updateZOffset() {
                const e1 = (e1, t, r)=>{
                    i += t, i > e1.length && e1.resize(i);
                    for(let n = -t; n < 0; n++)e1.emplace(n + i, r);
                }, t = (e1, t, i)=>{
                    r += t, r > e1.length && e1.resize(r);
                    for(let n = -t; n < 0; n++)e1.emplace(n + r, i);
                };
                if (!this.zOffsetBuffersNeedUpload) return;
                this.zOffsetBuffersNeedUpload = !1;
                let i = 0, r = 0;
                for(let i = 0; i < this.symbolInstances.length; i++){
                    const r = this.symbolInstances.get(i), { numHorizontalGlyphVertices: n, numVerticalGlyphVertices: o, numIconVertices: s } = r, a = r.zOffset, l = s > 0;
                    if ((n > 0 || o > 0) && (e1(this.text.zOffsetVertexArray, n, a), e1(this.text.zOffsetVertexArray, o, a)), l) {
                        const { placedIconSymbolIndex: e1, verticalPlacedIconSymbolIndex: i } = r;
                        e1 >= 0 && t(this.icon.zOffsetVertexArray, s, a), i >= 0 && t(this.icon.zOffsetVertexArray, r.numVerticalIconVertices, a);
                    }
                }
                this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(e1) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(e1), this.iconCollisionBox.upload(e1)), this.text.upload(e1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.icon.upload(e1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload), this.uploaded = !0;
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = ty(this.projection)), this.projectionInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(e1, t) {
                const i = this.lineVertexArray.length;
                if (void 0 !== e1.segment) for (const { x: e1, y: i } of t)this.lineVertexArray.emplaceBack(e1, i);
                return {
                    lineStartIndex: i,
                    lineLength: this.lineVertexArray.length - i
                };
            }
            addSymbols(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m) {
                const _ = e1.indexArray, g = e1.layoutVertexArray, y = e1.globeExtVertexArray, x = e1.segments.prepareSegment(4 * t.length, g, _, this.canOverlap ? o.sortKey : void 0), v = this.glyphOffsetArray.length, b = x.vertexLength, w = this.allowVerticalPlacement && s === A_.vertical ? Math.PI / 2 : 0, T = o.text && o.text.sections;
                for(let r = 0; r < t.length; r++){
                    const { tl: n, tr: s, bl: c, br: h, texPrimary: u, texSecondary: v, pixelOffsetTL: b, pixelOffsetBR: E, minFontScaleX: M, minFontScaleY: A, glyphOffset: S, isSDF: I, sectionIndex: C } = t[r], z = x.vertexLength, P = S[1];
                    if (ly(g, l.x, l.y, n.x, P + n.y, u.x, u.y, i, I, b.x, b.y, M, A), ly(g, l.x, l.y, s.x, P + s.y, u.x + u.w, u.y, i, I, E.x, b.y, M, A), ly(g, l.x, l.y, c.x, P + c.y, u.x, u.y + u.h, i, I, b.x, E.y, M, A), ly(g, l.x, l.y, h.x, P + h.y, u.x + u.w, u.y + u.h, i, I, E.x, E.y, M, A), a) {
                        const { x: t, y: i, z: r } = a.anchor, [n, o, s] = a.up;
                        hy(y, t, i, r, n, o, s), hy(y, t, i, r, n, o, s), hy(y, t, i, r, n, o, s), hy(y, t, i, r, n, o, s), dy(e1.dynamicLayoutVertexArray, t, i, r, w);
                    } else dy(e1.dynamicLayoutVertexArray, l.x, l.y, l.z, w);
                    if (m) {
                        const t = v || u;
                        cy(e1.iconTransitioningVertexArray, t.x, t.y), cy(e1.iconTransitioningVertexArray, t.x + t.w, t.y), cy(e1.iconTransitioningVertexArray, t.x, t.y + t.h), cy(e1.iconTransitioningVertexArray, t.x + t.w, t.y + t.h);
                    }
                    _.emplaceBack(z, z + 1, z + 2), _.emplaceBack(z + 1, z + 2, z + 3), x.vertexLength += 4, x.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(S[0]), r !== t.length - 1 && C === t[r + 1].sectionIndex || e1.programConfigurations.populatePaintArrays(g.length, o, o.index, {}, d, p, f, T && T[C]);
                }
                const E = a ? a.anchor : l;
                e1.placedSymbolArray.emplaceBack(E.x, E.y, E.z, l.x, l.y, v, this.glyphOffsetArray.length - v, b, c, h, l.segment, i ? i[0] : 0, i ? i[1] : 0, r[0], r[1], s, 0, !1, 0, u, 0);
            }
            _commitLayoutVertex(e1, t, i, r, n, o, s) {
                e1.emplaceBack(t, i, r, n, o, Math.round(s.x), Math.round(s.y));
            }
            _addCollisionDebugVertices(e1, t, i, r, n, o, s) {
                const a = i.segments.prepareSegment(4, i.layoutVertexArray, i.indexArray), l = a.vertexLength, c = s.tileAnchorX, h = s.tileAnchorY;
                for(let e1 = 0; e1 < 4; e1++)i.collisionVertexArray.emplaceBack(0, 0, 0, 0);
                this._commitDebugCollisionVertexUpdate(i.collisionVertexArrayExt, t, e1.padding, s.zOffset), this._commitLayoutVertex(i.layoutVertexArray, r, n, o, c, h, new y(e1.x1, e1.y1)), this._commitLayoutVertex(i.layoutVertexArray, r, n, o, c, h, new y(e1.x2, e1.y1)), this._commitLayoutVertex(i.layoutVertexArray, r, n, o, c, h, new y(e1.x2, e1.y2)), this._commitLayoutVertex(i.layoutVertexArray, r, n, o, c, h, new y(e1.x1, e1.y2)), a.vertexLength += 4;
                const u = i.indexArray;
                u.emplaceBack(l, l + 1), u.emplaceBack(l + 1, l + 2), u.emplaceBack(l + 2, l + 3), u.emplaceBack(l + 3, l), a.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(e1, t, i, r, n, o) {
                for(let s = r; s < n; s++){
                    const r = i.get(s), n = this.getSymbolInstanceTextSize(e1, o, t, s);
                    this._addCollisionDebugVertices(r, n, this.textCollisionBox, r.projectedAnchorX, r.projectedAnchorY, r.projectedAnchorZ, o);
                }
            }
            _addIconDebugCollisionBoxes(e1, t, i, r, n, o) {
                for(let s = r; s < n; s++){
                    const r = i.get(s), n = this.getSymbolInstanceIconSize(e1, t, o.placedIconSymbolIndex);
                    this._addCollisionDebugVertices(r, n, this.iconCollisionBox, r.projectedAnchorX, r.projectedAnchorY, r.projectedAnchorZ, o);
                }
            }
            generateCollisionDebugBuffers(e1, t) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new my(qa, c_.members, ja), this.iconCollisionBox = new my(qa, c_.members, ja);
                const i = m_(this.iconSizeData, e1), r = m_(this.textSizeData, e1);
                for(let n = 0; n < this.symbolInstances.length; n++){
                    const o = this.symbolInstances.get(n);
                    this._addTextDebugCollisionBoxes(r, e1, t, o.textBoxStartIndex, o.textBoxEndIndex, o), this._addTextDebugCollisionBoxes(r, e1, t, o.verticalTextBoxStartIndex, o.verticalTextBoxEndIndex, o), this._addIconDebugCollisionBoxes(i, e1, t, o.iconBoxStartIndex, o.iconBoxEndIndex, o), this._addIconDebugCollisionBoxes(i, e1, t, o.verticalIconBoxStartIndex, o.verticalIconBoxEndIndex, o);
                }
            }
            getSymbolInstanceTextSize(e1, t, i, r) {
                const n = this.text.placedSymbolArray.get(t.rightJustifiedTextSymbolIndex >= 0 ? t.rightJustifiedTextSymbolIndex : t.centerJustifiedTextSymbolIndex >= 0 ? t.centerJustifiedTextSymbolIndex : t.leftJustifiedTextSymbolIndex >= 0 ? t.leftJustifiedTextSymbolIndex : t.verticalPlacedTextSymbolIndex >= 0 ? t.verticalPlacedTextSymbolIndex : r), o = f_(this.textSizeData, e1, n) / u_;
                return this.tilePixelRatio * o;
            }
            getSymbolInstanceIconSize(e1, t, i) {
                const r = this.icon.placedSymbolArray.get(i), n = f_(this.iconSizeData, e1, r);
                return this.tilePixelRatio * n;
            }
            _commitDebugCollisionVertexUpdate(e1, t, i, r) {
                e1.emplaceBack(t, -i, -i, r), e1.emplaceBack(t, i, -i, r), e1.emplaceBack(t, i, i, r), e1.emplaceBack(t, -i, i, r);
            }
            _updateTextDebugCollisionBoxes(e1, t, i, r, n, o) {
                for(let s = r; s < n; s++){
                    const r = i.get(s), n = this.getSymbolInstanceTextSize(e1, o, t, s);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, n, r.padding, o.zOffset);
                }
            }
            _updateIconDebugCollisionBoxes(e1, t, i, r, n, o) {
                for(let s = r; s < n; s++){
                    const r = i.get(s), n = this.getSymbolInstanceIconSize(e1, t, o.placedIconSymbolIndex);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, n, r.padding, o.zOffset);
                }
            }
            updateCollisionDebugBuffers(e1, t) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const i = m_(this.iconSizeData, e1), r = m_(this.textSizeData, e1);
                for(let n = 0; n < this.symbolInstances.length; n++){
                    const o = this.symbolInstances.get(n);
                    this._updateTextDebugCollisionBoxes(r, e1, t, o.textBoxStartIndex, o.textBoxEndIndex, o), this._updateTextDebugCollisionBoxes(r, e1, t, o.verticalTextBoxStartIndex, o.verticalTextBoxEndIndex, o), this._updateIconDebugCollisionBoxes(i, e1, t, o.iconBoxStartIndex, o.iconBoxEndIndex, o), this._updateIconDebugCollisionBoxes(i, e1, t, o.verticalIconBoxStartIndex, o.verticalIconBoxEndIndex, o);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(e1, t, i, r, n, o, s, a, l) {
                const c = {};
                if (t < i) {
                    const { x1: i, y1: r, x2: n, y2: o, padding: s, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: h, tileAnchorX: u, tileAnchorY: d, featureIndex: p } = e1.get(t);
                    c.textBox = {
                        x1: i,
                        y1: r,
                        x2: n,
                        y2: o,
                        padding: s,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: h,
                        tileAnchorX: u,
                        tileAnchorY: d
                    }, c.textFeatureIndex = p;
                }
                if (r < n) {
                    const { x1: t, y1: i, x2: n, y2: o, padding: s, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: h, tileAnchorX: u, tileAnchorY: d, featureIndex: p } = e1.get(r);
                    c.verticalTextBox = {
                        x1: t,
                        y1: i,
                        x2: n,
                        y2: o,
                        padding: s,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: h,
                        tileAnchorX: u,
                        tileAnchorY: d
                    }, c.verticalTextFeatureIndex = p;
                }
                if (o < s) {
                    const { x1: t, y1: i, x2: r, y2: n, padding: s, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: h, tileAnchorX: u, tileAnchorY: d, featureIndex: p } = e1.get(o);
                    c.iconBox = {
                        x1: t,
                        y1: i,
                        x2: r,
                        y2: n,
                        padding: s,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: h,
                        tileAnchorX: u,
                        tileAnchorY: d
                    }, c.iconFeatureIndex = p;
                }
                if (a < l) {
                    const { x1: t, y1: i, x2: r, y2: n, padding: o, projectedAnchorX: s, projectedAnchorY: l, projectedAnchorZ: h, tileAnchorX: u, tileAnchorY: d, featureIndex: p } = e1.get(a);
                    c.verticalIconBox = {
                        x1: t,
                        y1: i,
                        x2: r,
                        y2: n,
                        padding: o,
                        projectedAnchorX: s,
                        projectedAnchorY: l,
                        projectedAnchorZ: h,
                        tileAnchorX: u,
                        tileAnchorY: d
                    }, c.verticalIconFeatureIndex = p;
                }
                return c;
            }
            deserializeCollisionBoxes(e1) {
                this.collisionArrays = [];
                for(let t = 0; t < this.symbolInstances.length; t++){
                    const i = this.symbolInstances.get(t);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(e1, i.textBoxStartIndex, i.textBoxEndIndex, i.verticalTextBoxStartIndex, i.verticalTextBoxEndIndex, i.iconBoxStartIndex, i.iconBoxEndIndex, i.verticalIconBoxStartIndex, i.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            hasIconTextFit() {
                return this.hasAnyIconTextFit;
            }
            addIndicesForPlacedSymbol(e1, t) {
                const i = e1.placedSymbolArray.get(t), r = i.vertexStartIndex + 4 * i.numGlyphs;
                for(let t = i.vertexStartIndex; t < r; t += 4)e1.indexArray.emplaceBack(t, t + 1, t + 2), e1.indexArray.emplaceBack(t + 1, t + 2, t + 3);
            }
            getSortedSymbolIndexes(e1) {
                if (this.sortedAngle === e1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const t = Math.sin(e1), i = Math.cos(e1), r = [], n = [], o = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; ++e1){
                    o.push(e1);
                    const s = this.symbolInstances.get(e1);
                    r.push(0 | Math.round(t * s.tileAnchorX + i * s.tileAnchorY)), n.push(s.featureIndex);
                }
                return o.sort((e1, t)=>r[e1] - r[t] || n[t] - n[e1]), o;
            }
            getSortedIndexesByZOffset() {
                if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
                if (!this.symbolInstanceIndexesSortedZOffset) {
                    this.symbolInstanceIndexesSortedZOffset = [];
                    for(let e1 = 0; e1 < this.symbolInstances.length; ++e1)this.symbolInstanceIndexesSortedZOffset.push(e1);
                }
                return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort((e1, t)=>this.symbolInstances.get(t).zOffset - this.symbolInstances.get(e1).zOffset);
            }
            addToSortKeyRanges(e1, t) {
                const i = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                i && i.sortKey === t ? i.symbolInstanceEnd = e1 + 1 : this.sortKeyRanges.push({
                    sortKey: t,
                    symbolInstanceStart: e1,
                    symbolInstanceEnd: e1 + 1
                });
            }
            sortFeatures(e1) {
                if (this.sortFeaturesByY && this.sortedAngle !== e1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(e1), this.sortedAngle = e1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                    for (const e1 of this.symbolInstanceIndexes){
                        const t = this.symbolInstances.get(e1);
                        this.featureSortOrder.push(t.featureIndex);
                        const { rightJustifiedTextSymbolIndex: i, centerJustifiedTextSymbolIndex: r, leftJustifiedTextSymbolIndex: n, verticalPlacedTextSymbolIndex: o, placedIconSymbolIndex: s, verticalPlacedIconSymbolIndex: a } = t;
                        i >= 0 && this.addIndicesForPlacedSymbol(this.text, i), r >= 0 && r !== i && this.addIndicesForPlacedSymbol(this.text, r), n >= 0 && n !== r && n !== i && this.addIndicesForPlacedSymbol(this.text, n), o >= 0 && this.addIndicesForPlacedSymbol(this.text, o), s >= 0 && this.addIndicesForPlacedSymbol(this.icon, s), a >= 0 && this.addIndicesForPlacedSymbol(this.icon, a);
                    }
                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                }
            }
            constructor(e1){
                this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = Au.identity([]), this.placementViewportMatrix = Au.identity([]);
                const t = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = p_(this.zoom, t["text-size"]), this.iconSizeData = p_(this.zoom, t["icon-size"]);
                const i = this.layers[0].layout, r = i.get("symbol-sort-key"), n = i.get("symbol-z-order");
                this.canOverlap = i.get("text-allow-overlap") || i.get("icon-allow-overlap") || i.get("text-ignore-placement") || i.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== n && void 0 !== r.constantOr(1), this.sortFeaturesByY = ("viewport-y" === n || "auto" === n && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = i.get("text-writing-mode").map((e1)=>A_[e1]), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.sourceID = e1.sourceID, this.projection = e1.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = i.get("symbol-z-elevate");
            }
        }
        Rs(_y, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), _y.MAX_GLYPHS = 65535, _y.addDynamicAttributes = dy;
        var gy = _y;
        const yy = Ia([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            }
        ], 4), { members: xy } = yy, vy = Ia([
            {
                name: "a_packed",
                components: 4,
                type: "Float32"
            }
        ]), { members: by } = vy, wy = hm.types, Ty = Math.cos(Math.PI / 180 * 37.5);
        class Ey {
            populate(e1, t, i, r) {
                this.hasPattern = Uf("line", this.layers, t);
                const n = this.layers[0].layout.get("line-sort-key"), o = [];
                for (const { feature: t, id: s, index: a, sourceLayerIndex: l } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = gp(t, e1);
                    if (!this.layers[0]._featureFilter.filter(new oa(this.zoom), c, i)) continue;
                    const h = n ? n.evaluate(c, {}, i) : void 0, u = {
                        id: s,
                        properties: t.properties,
                        type: t.type,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: e1 ? c.geometry : _p(t, i, r),
                        patterns: {},
                        sortKey: h
                    };
                    o.push(u);
                }
                n && o.sort((e1, t)=>e1.sortKey - t.sortKey);
                const { lineAtlas: s, featureIndex: a } = t, l = this.addConstantDashes(s);
                for (const r of o){
                    const { geometry: n, index: o, sourceLayerIndex: c } = r;
                    if (l && this.addFeatureDashes(r, s), this.hasPattern) {
                        const e1 = Vf("line", this.layers, r, this.zoom, t);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(r, n, o, i, s.positions, t.availableImages, t.brightness);
                    a.insert(e1[o].feature, n, o, c, this.index);
                }
            }
            addConstantDashes(e1) {
                let t = !1;
                for (const i of this.layers){
                    const r = i.paint.get("line-dasharray").value, n = i.layout.get("line-cap").value;
                    if ("constant" !== r.kind || "constant" !== n.kind) t = !0;
                    else {
                        const t = n.value, i = r.value;
                        if (!i) continue;
                        e1.addDash(i, t);
                    }
                }
                return t;
            }
            addFeatureDashes(e1, t) {
                const i = this.zoom;
                for (const r of this.layers){
                    const n = r.paint.get("line-dasharray").value, o = r.layout.get("line-cap").value;
                    if ("constant" === n.kind && "constant" === o.kind) continue;
                    let s, a;
                    if ("constant" === n.kind) {
                        if (s = n.value, !s) continue;
                    } else s = n.evaluate({
                        zoom: i
                    }, e1);
                    a = "constant" === o.kind ? o.value : o.evaluate({
                        zoom: i
                    }, e1), t.addDash(s, a), e1.patterns[r.id] = t.getKey(s, a);
                }
            }
            update(e1, t, i, r, n) {
                const o = 0 !== Object.keys(e1).length;
                o && !this.stateDependentLayers.length || this.programConfigurations.updatePaintArrays(e1, t, o ? this.stateDependentLayers : this.layers, i, r, n);
            }
            addFeatures(e1, t, i, r, n, o) {
                for (const e1 of this.patternFeatures)this.addFeature(e1, e1.geometry, e1.index, t, i, r, o);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = e1.createVertexBuffer(this.layoutVertexArray2, by)), this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, xy), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(e1) {
                if (e1.properties && e1.properties.hasOwnProperty("mapbox_clip_start") && e1.properties.hasOwnProperty("mapbox_clip_end")) return {
                    start: +e1.properties.mapbox_clip_start,
                    end: +e1.properties.mapbox_clip_end
                };
            }
            addFeature(e1, t, i, r, n, o, s) {
                const a = this.layers[0].layout, l = a.get("line-join").evaluate(e1, {}), c = a.get("line-cap").evaluate(e1, {}), h = a.get("line-miter-limit"), u = a.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(e1);
                for (const i of t)this.addLine(i, e1, l, c, h, u);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, n, o, r, s);
            }
            addLine(e1, t, i, r, n, o) {
                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineSoFar = 0, this.lineClips) {
                    this.lineClipsArray.push(this.lineClips);
                    for(let t = 0; t < e1.length - 1; t++)this.totalDistance += e1[t].dist(e1[t + 1]);
                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                }
                const s = "Polygon" === wy[t.type];
                let a = e1.length;
                for(; a >= 2 && e1[a - 1].equals(e1[a - 2]);)a--;
                let l = 0;
                for(; l < a - 1 && e1[l].equals(e1[l + 1]);)l++;
                if (a < (s ? 3 : 2)) return;
                "bevel" === i && (n = 1.05);
                const c = this.overscaling <= 16 ? 15 * cr / (512 * this.overscaling) : 0, h = this.segments.prepareSegment(10 * a, this.layoutVertexArray, this.indexArray);
                let u, d, p, f, m;
                this.e1 = this.e2 = -1, s && (u = e1[a - 2], m = e1[l].sub(u)._unit()._perp());
                for(let t = l; t < a; t++){
                    if (p = t === a - 1 ? s ? e1[l + 1] : void 0 : e1[t + 1], p && e1[t].equals(p)) continue;
                    m && (f = m), u && (d = u), u = e1[t], m = p ? p.sub(u)._unit()._perp() : f, f = f || m;
                    let _ = f.add(m);
                    0 === _.x && 0 === _.y || _._unit();
                    const g = f.x * m.x + f.y * m.y, y = _.x * m.x + _.y * m.y, x = 0 !== y ? 1 / y : 1 / 0, v = 2 * Math.sqrt(2 - 2 * y), b = y < Ty && d && p, w = f.x * m.y - f.y * m.x > 0;
                    if (b && t > l) {
                        const e1 = u.dist(d);
                        if (e1 > 2 * c) {
                            const t = u.sub(u.sub(d)._mult(c / e1)._round());
                            this.updateDistance(d, t), this.addCurrentVertex(t, f, 0, 0, h), d = t;
                        }
                    }
                    const T = d && p;
                    let E = T ? i : s ? "butt" : r;
                    if (T && "round" === E && (x < o ? E = "miter" : x <= 2 && (E = "fakeround")), "miter" === E && x > n && (E = "bevel"), "bevel" === E && (x > 2 && (E = "flipbevel"), x < n && (E = "miter")), d && this.updateDistance(d, u), "miter" === E) _._mult(x), this.addCurrentVertex(u, _, 0, 0, h);
                    else if ("flipbevel" === E) {
                        if (x > 100) _ = m.mult(-1);
                        else {
                            const e1 = x * f.add(m).mag() / f.sub(m).mag();
                            _._perp()._mult(e1 * (w ? -1 : 1));
                        }
                        this.addCurrentVertex(u, _, 0, 0, h), this.addCurrentVertex(u, _.mult(-1), 0, 0, h);
                    } else if ("bevel" === E || "fakeround" === E) {
                        const e1 = -Math.sqrt(x * x - 1), t = w ? e1 : 0, i = w ? 0 : e1;
                        if (d && this.addCurrentVertex(u, f, t, i, h), "fakeround" === E) {
                            const e1 = Math.round(180 * v / Math.PI / 20);
                            for(let t = 1; t < e1; t++){
                                let i = t / e1;
                                if (.5 !== i) {
                                    const e1 = i - .5;
                                    i += i * e1 * (i - 1) * ((1.0904 + g * (g * (3.55645 - 1.43519 * g) - 3.2452)) * e1 * e1 + (.848013 + g * (.215638 * g - 1.06021)));
                                }
                                const r = m.sub(f)._mult(i)._add(f)._unit()._mult(w ? -1 : 1);
                                this.addHalfVertex(u, r.x, r.y, !1, w, 0, h);
                            }
                        }
                        p && this.addCurrentVertex(u, m, -t, -i, h);
                    } else if ("butt" === E) this.addCurrentVertex(u, _, 0, 0, h);
                    else if ("square" === E) {
                        const e1 = d ? 1 : -1;
                        d || this.addCurrentVertex(u, _, e1, e1, h), this.addCurrentVertex(u, _, 0, 0, h), d && this.addCurrentVertex(u, _, e1, e1, h);
                    } else "round" === E && (d && (this.addCurrentVertex(u, f, 0, 0, h), this.addCurrentVertex(u, f, 1, 1, h, !0)), p && (this.addCurrentVertex(u, m, -1, -1, h, !0), this.addCurrentVertex(u, m, 0, 0, h)));
                    if (b && t < a - 1) {
                        const e1 = u.dist(p);
                        if (e1 > 2 * c) {
                            const t = u.add(p.sub(u)._mult(c / e1)._round());
                            this.updateDistance(u, t), this.addCurrentVertex(t, m, 0, 0, h), u = t;
                        }
                    }
                }
            }
            addCurrentVertex(e1, t, i, r, n, o = !1) {
                const s = t.y * r - t.x, a = -t.y - t.x * r;
                this.addHalfVertex(e1, t.x + t.y * i, t.y - t.x * i, o, !1, i, n), this.addHalfVertex(e1, s, a, o, !0, -r, n);
            }
            addHalfVertex({ x: e1, y: t }, i, r, n, o, s, a) {
                this.layoutVertexArray.emplaceBack((e1 << 1) + (n ? 1 : 0), (t << 1) + (o ? 1 : 0), Math.round(63 * i) + 128, Math.round(63 * r) + 128, 1 + (0 === s ? 0 : s < 0 ? -1 : 1), 0, this.lineSoFar), this.lineClips && this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, this.lineClips.start, this.lineClips.end);
                const l = a.vertexLength++;
                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, l), a.primitiveLength++), o ? this.e2 = l : this.e1 = l;
            }
            updateScaledDistance() {
                if (this.lineClips) {
                    const e1 = this.totalDistance / (this.lineClips.end - this.lineClips.start);
                    this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = e1 * this.lineClips.start + this.distance;
                } else this.lineSoFar = this.distance;
            }
            updateDistance(e1, t) {
                this.distance += e1.dist(t), this.updateScaledDistance();
            }
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.projection = e1.projection, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((e1)=>{
                    this.gradients[e1.id] = {};
                }), this.layoutVertexArray = new La, this.layoutVertexArray2 = new ka, this.indexArray = new Wa, this.programConfigurations = new ec(e1.layers, e1.zoom), this.segments = new xl, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id);
            }
        }
        Rs(Ey, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        class My {
            update(e1, i, r) {
                const { width: n, height: o } = e1, { context: s } = this, { gl: a } = s, { HTMLImageElement: l, HTMLCanvasElement: c, HTMLVideoElement: h, ImageData: u, ImageBitmap: d } = t;
                if (a.bindTexture(a.TEXTURE_2D, this.texture), s.pixelStoreUnpackFlipY.set(!1), s.pixelStoreUnpack.set(1), s.pixelStoreUnpackPremultiplyAlpha.set(this.format === a.RGBA && (!i || !1 !== i.premultiply)), r || this.size && this.size[0] === n && this.size[1] === o) {
                    const { x: t, y: i } = r || {
                        x: 0,
                        y: 0
                    };
                    if (e1 instanceof l || e1 instanceof c || e1 instanceof h || e1 instanceof u || d && e1 instanceof d) a.texSubImage2D(a.TEXTURE_2D, 0, t, i, a.RGBA, a.UNSIGNED_BYTE, e1);
                    else {
                        let r = this.format, s = a.UNSIGNED_BYTE;
                        this.format === a.R32F && (r = a.RED, s = a.FLOAT), a.texSubImage2D(a.TEXTURE_2D, 0, t, i, n, o, r, s, e1.data);
                    }
                } else if (this.size = [
                    n,
                    o
                ], e1 instanceof l || e1 instanceof c || e1 instanceof h || e1 instanceof u || d && e1 instanceof d) {
                    let t = this.format;
                    this.format === a.R8 && (t = a.RED), a.texImage2D(a.TEXTURE_2D, 0, this.format, t, a.UNSIGNED_BYTE, e1);
                } else {
                    let t = this.format, i = this.format, r = a.UNSIGNED_BYTE;
                    this.format === a.DEPTH_COMPONENT && (t = a.DEPTH_COMPONENT16, r = a.UNSIGNED_SHORT), this.format === a.R32F && (r = a.FLOAT, i = a.RED), a.texImage2D(a.TEXTURE_2D, 0, t, n, o, 0, i, r, e1.data);
                }
                this.useMipmap = Boolean(i && i.useMipmap), this.useMipmap && a.generateMipmap(a.TEXTURE_2D);
            }
            bind(e1, t) {
                const { context: i } = this, { gl: r } = i;
                r.bindTexture(r.TEXTURE_2D, this.texture), e1 !== this.minFilter && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, e1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, this.useMipmap ? e1 === r.NEAREST ? r.NEAREST_MIPMAP_NEAREST : r.LINEAR_MIPMAP_NEAREST : e1), this.minFilter = e1), t !== this.wrapS && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, t), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, t), this.wrapS = t);
            }
            bindExtraParam(e1, t, i, r) {
                const { context: n } = this, { gl: o } = n;
                o.bindTexture(o.TEXTURE_2D, this.texture), t !== this.magFilter && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, t), this.magFilter = t), e1 !== this.minFilter && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, this.useMipmap ? e1 === o.NEAREST ? o.NEAREST_MIPMAP_NEAREST : o.LINEAR_MIPMAP_NEAREST : e1), this.minFilter = e1), i !== this.wrapS && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, i), this.wrapS = i), r !== this.wrapT && (o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, r), this.wrapT = r);
            }
            destroy() {
                const { gl: e1 } = this.context;
                e1.deleteTexture(this.texture), this.texture = null;
            }
            constructor(e1, t, i, r){
                this.context = e1, this.format = i, this.texture = e1.gl.createTexture(), this.update(t, r);
            }
        }
        class Ay {
            bind(e1, t) {
                const { context: i } = this, { gl: r } = i;
                r.bindTexture(r.TEXTURE_2D, this.texture), e1 !== this.minFilter && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MAG_FILTER, e1), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_MIN_FILTER, e1), this.minFilter = e1), t !== this.wrapS && (r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_S, t), r.texParameteri(r.TEXTURE_2D, r.TEXTURE_WRAP_T, t), this.wrapS = t);
            }
            constructor(e1, t){
                this.context = e1, this.texture = t;
            }
        }
        const Sy = 32, Iy = 33, Cy = new Uint16Array(8184);
        for(let e1 = 0; e1 < 2046; e1++){
            let t = e1 + 2, i = 0, r = 0, n = 0, o = 0, s = 0, a = 0;
            for(1 & t ? n = o = s = Sy : i = r = a = Sy; (t >>= 1) > 1;){
                const e1 = i + n >> 1, l = r + o >> 1;
                1 & t ? (n = i, o = r, i = s, r = a) : (i = n, r = o, n = s, o = a), s = e1, a = l;
            }
            const l = 4 * e1;
            Cy[l + 0] = i, Cy[l + 1] = r, Cy[l + 2] = n, Cy[l + 3] = o;
        }
        const zy = new Uint16Array(2178), Py = new Uint8Array(1089), Dy = new Uint16Array(1089);
        function Ry(e1) {
            return 0 === e1 ? -0.03125 : 32 === e1 ? .03125 : 0;
        }
        var Ly = Ia([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        const ky = {
            type: 2,
            extent: cr,
            loadGeometry: ()=>[
                    [
                        new y(0, 0),
                        new y(cr + 1, 0),
                        new y(cr + 1, cr + 1),
                        new y(0, cr + 1),
                        new y(0, 0)
                    ]
                ]
        };
        class Oy {
            registerFadeDuration(e1) {
                const t = e1 + this.timeAdded;
                t < dt.now() || this.fadeEndTime && t < this.fadeEndTime || (this.fadeEndTime = t);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = Pg(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(e1, t, i) {
                if (this.unloadVectorData(), this.state = "loaded", e1) {
                    e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestFeatureIndex.rawTileData = e1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = function(e1, t) {
                        const i = {};
                        if (!t) return i;
                        for (const r of e1){
                            const e1 = r.layerIds.map((e1)=>t.getLayer(e1)).filter(Boolean);
                            if (0 !== e1.length) {
                                r.layers = e1, r.stateDependentLayerIds && (r.stateDependentLayers = r.stateDependentLayerIds.map((t)=>e1.filter((e1)=>e1.id === t)[0]));
                                for (const t of e1)i[t.fqid] = r;
                            }
                        }
                        return i;
                    }(e1.buckets, t.style), this.hasSymbolBuckets = !1;
                    for(const e1 in this.buckets){
                        const t = this.buckets[e1];
                        if (t instanceof gy) {
                            if (this.hasSymbolBuckets = !0, !i) break;
                            t.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const e1 in this.buckets){
                        const t = this.buckets[e1];
                        if (t instanceof gy && t.hasRTLText) {
                            this.hasRTLText = !0, na.isLoading() || na.isLoaded() || "deferred" !== ia() || ra();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const e1 in this.buckets){
                        const i = this.buckets[e1], r = t.style.getOwnLayer(e1);
                        if (!r) continue;
                        const n = r.queryRadius(i);
                        this.queryPadding = Math.max(this.queryPadding, n);
                    }
                    e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage), e1.lineAtlas && (this.lineAtlas = e1.lineAtlas), this._lastUpdatedBrightness = e1.brightness;
                } else this.collisionBoxArray = new al;
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const e1 in this.buckets)this.buckets[e1].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            getBucket(e1) {
                return this.buckets[e1.fqid];
            }
            upload(e1) {
                for(const t in this.buckets){
                    const i = this.buckets[t];
                    i.uploadPending() && i.upload(e1);
                }
                const t = e1.gl;
                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new My(e1, this.imageAtlas.image, t.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new My(e1, this.glyphAtlasImage, t.ALPHA), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new My(e1, this.lineAtlas.image, t.ALPHA), this.lineAtlas.uploaded = !0);
            }
            prepare(e1, t, i) {
                if (this.imageAtlas && this.imageAtlasTexture && this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture, i), !t || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
                const r = t.style.getBrightness();
                (this._lastUpdatedBrightness || r) && (this._lastUpdatedBrightness && r && Math.abs(this._lastUpdatedBrightness - r) < .001 || (this._lastUpdatedBrightness = r, this.updateBuckets(void 0, t)));
            }
            queryRenderedFeatures(e1, t, i, r, n, o, s, a) {
                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                    tileResult: r,
                    pixelPosMatrix: s,
                    transform: o,
                    params: n,
                    tileTransform: this.tileTransform
                }, e1, t, i) : {};
            }
            querySourceFeatures(e1, t) {
                const i = this.latestFeatureIndex;
                if (!i || !i.rawTileData) return;
                const r = i.loadVTLayers(), n = t ? t.sourceLayer : "", o = r._geojsonTileLayer || r[n];
                if (!o) return;
                const s = Fo(t && t.filter), { z: a, x: l, y: c } = this.tileID.canonical, h = {
                    z: a,
                    x: l,
                    y: c
                };
                for(let t = 0; t < o.length; t++){
                    const r = o.feature(t);
                    if (s.needGeometry) {
                        const e1 = gp(r, !0);
                        if (!s.filter(new oa(this.tileID.overscaledZ), e1, this.tileID.canonical)) continue;
                    } else if (!s.filter(new oa(this.tileID.overscaledZ), r)) continue;
                    const u = i.getId(r, n), d = new Bm(r, a, l, c, u);
                    d.tile = h, e1.push(d);
                }
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            bucketsLoaded() {
                for(const e1 in this.buckets)if (this.buckets[e1].uploadPending()) return !1;
                return !0;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
            }
            setExpiryData(e1) {
                const t = this.expirationTime;
                if (e1.cacheControl) {
                    const t = ee(e1.cacheControl);
                    t["max-age"] && (this.expirationTime = Date.now() + 1e3 * t["max-age"]);
                } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
                if (this.expirationTime) {
                    const e1 = Date.now();
                    let i = !1;
                    if (this.expirationTime > e1) i = !1;
                    else if (t) {
                        if (this.expirationTime < t) i = !0;
                        else {
                            const r = this.expirationTime - t;
                            r ? this.expirationTime = e1 + Math.max(r, 3e4) : i = !0;
                        }
                    } else i = !0;
                    i ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            setFeatureState(e1, t) {
                this.latestFeatureIndex && this.latestFeatureIndex.rawTileData && 0 !== Object.keys(e1).length && t && this.updateBuckets(e1, t);
            }
            updateBuckets(e1, t) {
                if (!this.latestFeatureIndex) return;
                const i = this.latestFeatureIndex.loadVTLayers(), r = t.style.listImages(), n = t.style.getBrightness();
                for(const o in this.buckets){
                    if (!t.style.hasLayer(o)) continue;
                    const s = this.buckets[o], a = s.layers[0].sourceLayer || "_geojsonTileLayer", l = i[a];
                    let c = {};
                    if (e1 && (c = e1[a], !l || !c || 0 === Object.keys(c).length)) continue;
                    if (s.update(c, l, r, this.imageAtlas && this.imageAtlas.patternPositions || {}, n), s instanceof Ey || s instanceof jf) {
                        const e1 = t.style.getOwnSourceCache(s.layers[0].source);
                        t._terrain && t._terrain.enabled && e1 && s.programConfigurations.needsUpload && t._terrain._clearRenderCacheForTile(e1.id, this.tileID);
                    }
                    const h = t && t.style && t.style.getOwnLayer(o);
                    h && (this.queryPadding = Math.max(this.queryPadding, h.queryRadius(s)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < dt.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(e1) {
                this.symbolFadeHoldUntil = dt.now() + e1;
            }
            setTexture(e1, t) {
                const i = t.context, r = i.gl;
                this.texture = this.texture || t.getTileTexture(e1.width), this.texture && this.texture instanceof My ? this.texture.update(e1, {
                    useMipmap: !0
                }) : (this.texture = new My(i, e1, r.RGBA, {
                    useMipmap: !0
                }), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE));
            }
            setDependencies(e1, t) {
                const i = {};
                for (const e1 of t)i[e1] = !0;
                this.dependencies[e1] = i;
            }
            hasDependency(e1, t) {
                for (const i of e1){
                    const e1 = this.dependencies[i];
                    if (e1) {
                        for (const i of t)if (e1[i]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(e1, t) {
                if (!t || "mercator" === t.name || this._tileDebugBuffer) return;
                const i = _p(ky, this.tileID.canonical, this.tileTransform)[0], r = new za, n = new el;
                for(let e1 = 0; e1 < i.length; e1++){
                    const { x: t, y: o } = i[e1];
                    r.emplaceBack(t, o), n.emplaceBack(e1);
                }
                n.emplaceBack(0), this._tileDebugIndexBuffer = e1.createIndexBuffer(n), this._tileDebugBuffer = e1.createVertexBuffer(r, Nu.members), this._tileDebugSegments = xl.simpleSegment(0, 0, r.length, n.length);
            }
            _makeTileBoundsBuffers(e1, t) {
                if (this._tileBoundsBuffer || !t || "mercator" === t.name) return;
                const i = _p(ky, this.tileID.canonical, this.tileTransform)[0];
                let r, n;
                if (this.isRaster) {
                    const e1 = function(e1, t) {
                        const i = Pg(e1, t), r = Math.pow(2, e1.z);
                        for(let n = 0; n < Iy; n++)for(let o = 0; o < Iy; o++){
                            const s = ep((e1.x + (o + Ry(o)) / Sy) / r), a = tp((e1.y + (n + Ry(n)) / Sy) / r), l = t.project(s, a), c = n * Iy + o;
                            zy[2 * c + 0] = Math.round((l.x * i.scale - i.x) * cr), zy[2 * c + 1] = Math.round((l.y * i.scale - i.y) * cr);
                        }
                        Py.fill(0), Dy.fill(0);
                        for(let e1 = 2045; e1 >= 0; e1--){
                            const t = 4 * e1, i = Cy[t + 0], r = Cy[t + 1], n = Cy[t + 2], o = Cy[t + 3], s = i + n >> 1, a = r + o >> 1, l = s + a - r, c = a + i - s, h = r * Iy + i, u = o * Iy + n, d = a * Iy + s, p = Math.hypot((zy[2 * h + 0] + zy[2 * u + 0]) / 2 - zy[2 * d + 0], (zy[2 * h + 1] + zy[2 * u + 1]) / 2 - zy[2 * d + 1]) >= 16;
                            Py[d] = Py[d] || (p ? 1 : 0), e1 < 1022 && (Py[d] = Py[d] || Py[(r + c >> 1) * Iy + (i + l >> 1)] || Py[(o + c >> 1) * Iy + (n + l >> 1)]);
                        }
                        const n = new Da, o = new Wa;
                        let s = 0;
                        function a(e1, t) {
                            const i = t * Iy + e1;
                            return 0 === Dy[i] && (n.emplaceBack(zy[2 * i + 0], zy[2 * i + 1], e1 * cr / Sy, t * cr / Sy), Dy[i] = ++s), Dy[i] - 1;
                        }
                        function l(e1, t, i, r, n, s) {
                            const c = e1 + i >> 1, h = t + r >> 1;
                            if (Math.abs(e1 - n) + Math.abs(t - s) > 1 && Py[h * Iy + c]) l(n, s, e1, t, c, h), l(i, r, n, s, c, h);
                            else {
                                const l = a(e1, t), c = a(i, r), h = a(n, s);
                                o.emplaceBack(l, c, h);
                            }
                        }
                        return l(0, 0, Sy, Sy, Sy, 0), l(Sy, Sy, 0, 0, 0, Sy), {
                            vertices: n,
                            indices: o
                        };
                    }(this.tileID.canonical, t);
                    r = e1.vertices, n = e1.indices;
                } else {
                    r = new Da, n = new Wa;
                    for (const { x: e1, y: t } of i)r.emplaceBack(e1, t, 0, 0);
                    const e1 = Bf(r.int16, void 0, 4);
                    for(let t = 0; t < e1.length; t += 3)n.emplaceBack(e1[t], e1[t + 1], e1[t + 2]);
                }
                this._tileBoundsBuffer = e1.createVertexBuffer(r, Ly.members), this._tileBoundsIndexBuffer = e1.createIndexBuffer(n), this._tileBoundsSegments = xl.simpleSegment(0, 0, r.length, n.length);
            }
            _makeGlobeTileDebugBuffers(e1, t) {
                const i = t.projection;
                if (!i || "globe" !== i.name || t.freezeTileCoverage) return;
                const r = this.tileID.canonical, n = Ad(_d(r, t)), o = Dd(t.zoom);
                let s;
                o > 0 && (s = Au.invert(new Float64Array(16), t.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(e1, r, t, n, s, o), this._makeGlobeTileDebugTextBuffer(e1, r, t, n, s, o);
            }
            _globePoint(e1, t, i, r, n, o, s) {
                let a = Td(e1, t, i);
                if (o) {
                    const n = 1 << i.z, l = Kd(r.center.lng), c = Jd(r.center.lat), h = (i.x + .5) / n - l;
                    let u = 0;
                    h > .5 ? u = -1 : h < -0.5 && (u = 1);
                    let d = (e1 / cr + i.x) / n + u, p = (t / cr + i.y) / n;
                    d = (d - l) * r._pixelsPerMercatorPixel + l, p = (p - c) * r._pixelsPerMercatorPixel + c;
                    const f = [
                        d * r.worldSize,
                        p * r.worldSize,
                        0
                    ];
                    Du.transformMat4(f, f, o), a = md(a, f, s);
                }
                return Du.transformMat4(a, a, n);
            }
            _makeGlobeTileDebugBorderBuffer(e1, t, i, r, n, o) {
                const s = new za, a = new el, l = new Pa, c = (e1, c, h, u, d)=>{
                    const p = (h - e1) / (d - 1), f = (u - c) / (d - 1), m = s.length;
                    for(let h = 0; h < d; h++){
                        const u = e1 + h * p, d = c + h * f;
                        s.emplaceBack(u, d);
                        const _ = this._globePoint(u, d, t, i, r, n, o);
                        l.emplaceBack(_[0], _[1], _[2]), a.emplaceBack(m + h);
                    }
                }, h = cr;
                c(0, 0, h, 0, 16), c(h, 0, h, h, 16), c(h, h, 0, h, 16), c(0, h, 0, 0, 16), this._tileDebugIndexBuffer = e1.createIndexBuffer(a), this._tileDebugBuffer = e1.createVertexBuffer(s, Nu.members), this._globeTileDebugBorderBuffer = e1.createVertexBuffer(l, Fu.members), this._tileDebugSegments = xl.simpleSegment(0, 0, s.length, a.length);
            }
            _makeGlobeTileDebugTextBuffer(e1, t, i, r, n, o) {
                const s = cr / 4, a = new za, l = new Wa, c = new Pa, h = 25;
                l.reserve(32), a.reserve(h), c.reserve(h);
                const u = (e1, t)=>h * e1 + t;
                for(let e1 = 0; e1 < h; e1++){
                    const l = e1 * s;
                    for(let e1 = 0; e1 < h; e1++){
                        const h = e1 * s;
                        a.emplaceBack(h, l);
                        const u = this._globePoint(h, l, t, i, r, n, o);
                        c.emplaceBack(u[0], u[1], u[2]);
                    }
                }
                for(let e1 = 0; e1 < 4; e1++)for(let t = 0; t < 4; t++){
                    const i = u(e1, t), r = u(e1, t + 1), n = u(e1 + 1, t), o = u(e1 + 1, t + 1);
                    l.emplaceBack(i, r, n), l.emplaceBack(n, r, o);
                }
                this._tileDebugTextIndexBuffer = e1.createIndexBuffer(l), this._tileDebugTextBuffer = e1.createVertexBuffer(a, Nu.members), this._globeTileDebugTextBuffer = e1.createVertexBuffer(c, Fu.members), this._tileDebugTextSegments = xl.simpleSegment(0, 0, h, 32);
            }
            destroy(e1 = !1) {
                for(const e1 in this.buckets)this.buckets[e1].destroy();
                this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture.destroy(), delete this.imageAtlasTexture), this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), !e1 && this.texture && this.texture instanceof My && (this.texture.destroy(), delete this.texture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.latestFeatureIndex = null, this.state = "unloaded";
            }
            constructor(e1, t, i, r, n){
                this.tileID = e1, this.uid = F(), this.uses = 0, this.tileSize = t, this.tileZoom = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = n, r && r.style && (this._lastUpdatedBrightness = r.style.getBrightness()), this.expiredRequestCount = 0, this.state = "loading", r && r.transform && (this.projection = r.transform.projection);
            }
        }
        class By {
            reset() {
                for(const e1 in this.data)for (const t of this.data[e1])t.timeout && clearTimeout(t.timeout), this.onRemove(t.value);
                return this.data = {}, this.order = [], this;
            }
            add(e1, t, i) {
                const r = e1.wrapped().key;
                void 0 === this.data[r] && (this.data[r] = []);
                const n = {
                    value: t,
                    timeout: void 0
                };
                if (void 0 !== i && (n.timeout = setTimeout(()=>{
                    this.remove(e1, n);
                }, i)), this.data[r].push(n), this.order.push(r), this.order.length > this.max) {
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            has(e1) {
                return e1.wrapped().key in this.data;
            }
            getAndRemove(e1) {
                return this.has(e1) ? this._getAndRemoveByKey(e1.wrapped().key) : null;
            }
            _getAndRemoveByKey(e1) {
                const t = this.data[e1].shift();
                return t.timeout && clearTimeout(t.timeout), 0 === this.data[e1].length && delete this.data[e1], this.order.splice(this.order.indexOf(e1), 1), t.value;
            }
            getByKey(e1) {
                const t = this.data[e1];
                return t ? t[0].value : null;
            }
            get(e1) {
                return this.has(e1) ? this.data[e1.wrapped().key][0].value : null;
            }
            remove(e1, t) {
                if (!this.has(e1)) return this;
                const i = e1.wrapped().key, r = void 0 === t ? 0 : this.data[i].indexOf(t), n = this.data[i][r];
                return this.data[i].splice(r, 1), n.timeout && clearTimeout(n.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(n.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(e1) {
                for(this.max = e1; this.order.length > this.max;){
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            filter(e1) {
                const t = [];
                for(const i in this.data)for (const r of this.data[i])e1(r.value) || t.push(r);
                for (const e1 of t)this.remove(e1.value.tileID, e1);
            }
            constructor(e1, t){
                this.max = e1, this.onRemove = t, this.reset();
            }
        }
        class Fy {
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e1) {
                this.id = Fy.uniqueIdxCounter, Fy.uniqueIdxCounter++;
                const t = this.context.gl;
                this.context.unbindVAO(), this.bind(), t.bufferSubData(t.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
            constructor(e1, t, i, r){
                this.id = Fy.uniqueIdxCounter, Fy.uniqueIdxCounter++, this.context = e1;
                const n = e1.gl;
                this.buffer = n.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), n.bufferData(n.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? n.DYNAMIC_DRAW : n.STATIC_DRAW), this.dynamicDraw || r || t.destroy();
            }
        }
        Fy.uniqueIdxCounter = 0;
        const Ny = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Uy {
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t = this.context.gl;
                this.bind(), t.bufferSubData(t.ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            enableAttributes(e1, t) {
                for(let i = 0; i < this.attributes.length; i++){
                    const r = t.attributes[this.attributes[i].name];
                    void 0 !== r && e1.enableVertexAttribArray(r);
                }
            }
            setVertexAttribPointers(e1, t, i) {
                for(let r = 0; r < this.attributes.length; r++){
                    const n = this.attributes[r], o = t.attributes[n.name];
                    void 0 !== o && e1.vertexAttribPointer(o, n.components, e1[Ny[n.type]], !1, this.itemSize, n.offset + this.itemSize * (i || 0));
                }
            }
            setVertexAttribDivisor(e1, t, i) {
                for(let r = 0; r < this.attributes.length; r++){
                    const n = t.attributes[this.attributes[r].name];
                    void 0 !== n && this.instanceCount && this.instanceCount > 0 && e1.vertexAttribDivisor(n, i);
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
            constructor(e1, t, i, r, n, o){
                this.length = t.length, this.attributes = i, this.itemSize = t.bytesPerElement, this.dynamicDraw = r, this.instanceCount = o, this.context = e1;
                const s = e1.gl;
                this.buffer = s.createBuffer(), e1.bindVertexBuffer.set(this.buffer), s.bufferData(s.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? s.DYNAMIC_DRAW : s.STATIC_DRAW), this.dynamicDraw || n || t.destroy();
            }
        }
        class Vy {
            get() {
                return this.current;
            }
            set(e1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
            constructor(e1){
                this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
        }
        class jy extends Vy {
            getDefault() {
                return hi.transparent;
            }
            set(e1) {
                const t = this.current;
                (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class Gy extends Vy {
            getDefault() {
                return 1;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
            }
        }
        class qy extends Vy {
            getDefault() {
                return 0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Zy extends Vy {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class $y extends Vy {
            getDefault() {
                return !0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Wy extends Vy {
            getDefault() {
                return 255;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Hy extends Vy {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e1) {
                const t = this.current;
                (e1.func !== t.func || e1.ref !== t.ref || e1.mask !== t.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
            }
        }
        class Xy extends Vy {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.KEEP,
                    e1.KEEP,
                    e1.KEEP
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
            }
        }
        class Yy extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.STENCIL_TEST) : t.disable(t.STENCIL_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Ky extends Vy {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class Jy extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.DEPTH_TEST) : t.disable(t.DEPTH_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class Qy extends Vy {
            getDefault() {
                return this.gl.LESS;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ex extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.BLEND) : t.disable(t.BLEND), this.current = e1, this.dirty = !1;
            }
        }
        class tx extends Vy {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.ONE,
                    e1.ZERO,
                    e1.ONE,
                    e1.ZERO
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.blendFuncSeparate(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class ix extends Vy {
            getDefault() {
                return hi.transparent;
            }
            set(e1) {
                const t = this.current;
                (e1.r !== t.r || e1.g !== t.g || e1.b !== t.b || e1.a !== t.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class rx extends Vy {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e1, e1), this.current = e1, this.dirty = !1);
            }
        }
        class nx extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                e1 ? t.enable(t.CULL_FACE) : t.disable(t.CULL_FACE), this.current = e1, this.dirty = !1;
            }
        }
        class ox extends Vy {
            getDefault() {
                return this.gl.BACK;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class sx extends Vy {
            getDefault() {
                return this.gl.CCW;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        let ax = class extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
            }
        };
        class lx extends Vy {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
            }
        }
        class cx extends Vy {
            getDefault() {
                const e1 = this.gl;
                return [
                    0,
                    0,
                    e1.drawingBufferWidth,
                    e1.drawingBufferHeight
                ];
            }
            set(e1) {
                const t = this.current;
                (e1[0] !== t[0] || e1[1] !== t[1] || e1[2] !== t[2] || e1[3] !== t[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class hx extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindFramebuffer(t.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class ux extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindRenderbuffer(t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class dx extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindTexture(t.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
            }
        }
        class px extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.bindBuffer(t.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class fx extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                const t = this.gl;
                t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class mx extends Vy {
            getDefault() {
                return null;
            }
            set(e1) {
                this.gl && (e1 !== this.current || this.dirty) && (this.gl.bindVertexArray(e1), this.current = e1, this.dirty = !1);
            }
        }
        class _x extends Vy {
            getDefault() {
                return 4;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
            }
        }
        class gx extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class yx extends Vy {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t = this.gl;
                t.pixelStorei(t.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class xx extends Vy {
            getDefault() {
                return null;
            }
            constructor(e1, t){
                super(e1), this.context = e1, this.parent = t;
            }
        }
        class vx extends xx {
            setDirty() {
                this.dirty = !0;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class bx extends xx {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferRenderbuffer(t.FRAMEBUFFER, this.attachment(), t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class wx extends xx {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t = this.gl;
                t.framebufferTexture2D(t.FRAMEBUFFER, this.attachment(), t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class Tx extends bx {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        class Ex {
            destroy() {
                const e1 = this.context.gl;
                if (this.colorAttachment) {
                    const t = this.colorAttachment.get();
                    t && e1.deleteTexture(t);
                }
                if (this.depthAttachment && this.depthAttachmentType) {
                    if ("renderbuffer" === this.depthAttachmentType) {
                        const t = this.depthAttachment.get();
                        t && e1.deleteRenderbuffer(t);
                    } else {
                        const t = this.depthAttachment.get();
                        t && e1.deleteTexture(t);
                    }
                }
                e1.deleteFramebuffer(this.framebuffer);
            }
            constructor(e1, t, i, r, n){
                this.context = e1, this.width = t, this.height = i;
                const o = this.framebuffer = e1.gl.createFramebuffer();
                r && (this.colorAttachment = new vx(e1, o)), n && (this.depthAttachmentType = n, this.depthAttachment = "renderbuffer" === n ? new bx(e1, o) : new wx(e1, o));
            }
        }
        class Mx {
            constructor(e1, t, i){
                this.func = e1, this.mask = t, this.range = i;
            }
        }
        Mx.ReadOnly = !1, Mx.ReadWrite = !0, Mx.disabled = new Mx(519, Mx.ReadOnly, [
            0,
            1
        ]);
        const Ax = 7680;
        class Sx {
            constructor(e1, t, i, r, n, o){
                this.test = e1, this.ref = t, this.mask = i, this.fail = r, this.depthFail = n, this.pass = o;
            }
        }
        Sx.disabled = new Sx({
            func: 519,
            mask: 0
        }, 0, 0, Ax, Ax, Ax);
        const Ix = 771;
        class Cx {
            constructor(e1, t, i, r){
                this.blendFunction = e1, this.blendColor = t, this.mask = i, this.blendEquation = r;
            }
        }
        Cx.Replace = [
            1,
            0,
            1,
            0
        ], Cx.disabled = new Cx(Cx.Replace, hi.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Cx.unblended = new Cx(Cx.Replace, hi.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Cx.alphaBlended = new Cx([
            1,
            Ix,
            1,
            Ix
        ], hi.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Cx.multiply = new Cx([
            774,
            0,
            774,
            0
        ], hi.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        const zx = 1029, Px = 2305;
        class Dx {
            constructor(e1, t, i){
                this.enable = e1, this.mode = t, this.frontFace = i;
            }
        }
        Dx.disabled = new Dx(!1, zx, Px), Dx.backCCW = new Dx(!0, zx, Px), Dx.backCW = new Dx(!0, zx, 2304), Dx.frontCW = new Dx(!0, 1028, 2304), Dx.frontCCW = new Dx(!0, 1028, Px);
        class Rx {
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e1, t, i) {
                return new Fy(this, e1, t, i);
            }
            createVertexBuffer(e1, t, i, r, n) {
                return new Uy(this, e1, t, i, r, n);
            }
            createRenderbuffer(e1, t, i) {
                const r = this.gl, n = r.createRenderbuffer();
                return this.bindRenderbuffer.set(n), r.renderbufferStorage(r.RENDERBUFFER, e1, t, i), this.bindRenderbuffer.set(null), n;
            }
            createFramebuffer(e1, t, i, r) {
                return new Ex(this, e1, t, i, r);
            }
            clear({ color: e1, depth: t, stencil: i, colorMask: r }) {
                const n = this.gl;
                let o = 0;
                e1 && (o |= n.COLOR_BUFFER_BIT, this.clearColor.set(e1), this.colorMask.set(r || [
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t && (o |= n.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t), this.depthMask.set(!0)), void 0 !== i && (o |= n.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), n.clear(o);
            }
            setCullFace(e1) {
                !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
            }
            setDepthMode(e1) {
                e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e1) {
                e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
                    e1.fail,
                    e1.depthFail,
                    e1.pass
                ]), this.stencilFunc.set({
                    func: e1.test.func,
                    ref: e1.ref,
                    mask: e1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(e1) {
                x(e1.blendFunction, Cx.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor), e1.blendEquation ? this.blendEquation.set(e1.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(e1.mask);
            }
            unbindVAO() {
                this.bindVertexArrayOES.set(null);
            }
            constructor(e1, t){
                this.gl = e1, this.clearColor = new jy(this), this.clearDepth = new Gy(this), this.clearStencil = new qy(this), this.colorMask = new Zy(this), this.depthMask = new $y(this), this.stencilMask = new Wy(this), this.stencilFunc = new Hy(this), this.stencilOp = new Xy(this), this.stencilTest = new Yy(this), this.depthRange = new Ky(this), this.depthTest = new Jy(this), this.depthFunc = new Qy(this), this.blend = new ex(this), this.blendFunc = new tx(this), this.blendColor = new ix(this), this.blendEquation = new rx(this), this.cullFace = new nx(this), this.cullFaceSide = new ox(this), this.frontFace = new sx(this), this.program = new ax(this), this.activeTexture = new lx(this), this.viewport = new cx(this), this.bindFramebuffer = new hx(this), this.bindRenderbuffer = new ux(this), this.bindTexture = new dx(this), this.bindVertexBuffer = new px(this), this.bindElementBuffer = new fx(this), this.bindVertexArrayOES = new mx(this), this.pixelStoreUnpack = new _x(this), this.pixelStoreUnpackPremultiplyAlpha = new gx(this), this.pixelStoreUnpackFlipY = new yx(this), this.options = t ? {
                    ...t
                } : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e1.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e1.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e1.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e1.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e1.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e1.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE);
            }
        }
        class Lx extends zt {
            onAdd(e1) {
                this.map = e1, this._minTileCacheSize = void 0 === this._minTileCacheSize && e1 ? e1._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e1 ? e1._maxTileCacheSize : this._maxTileCacheSize;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const e1 in this._tiles){
                    const t = this._tiles[e1];
                    if ("errored" !== t.state && ("loaded" !== t.state || !t.bucketsLoaded())) return !1;
                }
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform);
            }
            _loadTile(e1, t) {
                return e1.isSymbolTile = this._onlySymbols, e1.isExtraShadowCaster = this._shadowCasterTiles[e1.tileID.key], this._source.loadTile(e1, t);
            }
            _unloadTile(e1) {
                if (this._source.unloadTile) return this._source.unloadTile(e1, ()=>{});
            }
            _abortTile(e1) {
                if (this._source.abortTile) return this._source.abortTile(e1, ()=>{});
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e1) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const t in this._tiles){
                    const i = this._tiles[t];
                    i.upload(e1), i.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
                }
            }
            getIds() {
                return L(this._tiles).map((e1)=>e1.tileID).sort(kx).map((e1)=>e1.key);
            }
            getRenderableIds(e1, t) {
                const i = [];
                for(const r in this._tiles)this._isIdRenderable(+r, e1, t) && i.push(this._tiles[r]);
                return e1 ? i.sort((e1, t)=>{
                    const i = e1.tileID, r = t.tileID, n = new y(i.canonical.x, i.canonical.y)._rotate(this.transform.angle), o = new y(r.canonical.x, r.canonical.y)._rotate(this.transform.angle);
                    return i.overscaledZ - r.overscaledZ || o.y - n.y || o.x - n.x;
                }).map((e1)=>e1.tileID.key) : i.map((e1)=>e1.tileID).sort(kx).map((e1)=>e1.key);
            }
            hasRenderableParent(e1) {
                const t = this.findLoadedParent(e1, 0);
                return !!t && this._isIdRenderable(t.tileID.key);
            }
            _isIdRenderable(e1, t, i) {
                return this._tiles[e1] && this._tiles[e1].hasData() && !this._coveredTiles[e1] && (t || !this._tiles[e1].holdingForFade()) && (i || !this._shadowCasterTiles[e1]);
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const e1 in this._tiles)"errored" !== this._tiles[e1].state && this._reloadTile(+e1, "reloading");
                }
            }
            _reloadTile(e1, t) {
                const i = this._tiles[e1];
                i && ("loading" !== i.state && (i.state = t), this._loadTile(i, this._tileLoaded.bind(this, i, e1, t)));
            }
            _tileLoaded(e1, t, i, r) {
                if (r) {
                    if (e1.state = "errored", 404 !== r.status) this._source.fire(new Ct(r, {
                        tile: e1
                    }));
                    else {
                        if (!(e1.tileID.key in this._loadedParentTiles)) return void this._source.fire(new It("data", {
                            dataType: "source",
                            sourceDataType: "error",
                            sourceId: this._source.id
                        }));
                        if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                            const e1 = this.map.painter.terrain;
                            this.update(this.transform, e1.getScaledDemTileSize(), !0), e1.resetTileLookupCache(this.id);
                        } else this.update(this.transform);
                    }
                } else e1.timeAdded = dt.now(), "expired" === i && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(t, e1), "raster-dem" === this._source.type && e1.dem && this._backfillDEM(e1), this._state.initializeTileState(e1, this.map ? this.map.painter : null), this._source.fire(new It("data", {
                    dataType: "source",
                    tile: e1,
                    coord: e1.tileID,
                    sourceCacheId: this.id
                }));
            }
            _backfillDEM(e1) {
                const t = this.getRenderableIds();
                for(let r = 0; r < t.length; r++){
                    const n = t[r];
                    if (e1.neighboringTiles && e1.neighboringTiles[n]) {
                        const t = this.getTileByID(n);
                        i(e1, t), i(t, e1);
                    }
                }
                function i(e1, t) {
                    if (!e1.dem || e1.dem.borderReady) return;
                    e1.needsHillshadePrepare = !0, e1.needsDEMTextureUpload = !0;
                    let i = t.tileID.canonical.x - e1.tileID.canonical.x;
                    const r = t.tileID.canonical.y - e1.tileID.canonical.y, n = Math.pow(2, e1.tileID.canonical.z), o = t.tileID.key;
                    0 === i && 0 === r || Math.abs(r) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + n) ? i += n : 1 === Math.abs(i - n) && (i -= n)), t.dem && e1.dem && (e1.dem.backfillBorder(t.dem, i, r), e1.neighboringTiles && e1.neighboringTiles[o] && (e1.neighboringTiles[o].backfilled = !0)));
                }
            }
            getTile(e1) {
                return this.getTileByID(e1.key);
            }
            getTileByID(e1) {
                return this._tiles[e1];
            }
            _retainLoadedChildren(e1, t, i, r) {
                for(const n in this._tiles){
                    let o = this._tiles[n];
                    if (r[n] || !o.hasData() || o.tileID.overscaledZ <= t || o.tileID.overscaledZ > i) continue;
                    let s = o.tileID;
                    for(; o && o.tileID.overscaledZ > t + 1;){
                        const e1 = o.tileID.scaledTo(o.tileID.overscaledZ - 1);
                        o = this._tiles[e1.key], o && o.hasData() && (s = e1);
                    }
                    let a = s;
                    for(; a.overscaledZ > t;)if (a = a.scaledTo(a.overscaledZ - 1), e1[a.key]) {
                        r[s.key] = s;
                        break;
                    }
                }
            }
            findLoadedParent(e1, t) {
                if (e1.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[e1.key];
                    return i && i.tileID.overscaledZ >= t ? i : null;
                }
                for(let i = e1.overscaledZ - 1; i >= t; i--){
                    const t = e1.scaledTo(i), r = this._getLoadedTile(t);
                    if (r) return r;
                }
            }
            _getLoadedTile(e1) {
                const t = this._tiles[e1.key];
                return t && t.hasData() ? t : this._cache.getByKey(this._source.reparseOverscaled ? e1.wrapped().key : e1.canonical.key);
            }
            updateCacheSize(e1, t) {
                t = t || this._source.tileSize;
                const i = Math.ceil(e1.width / t) + 1, r = Math.ceil(e1.height / t) + 1, n = Math.floor(i * r * 5), o = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, n) : n, s = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, o) : o;
                this._cache.setMaxSize(s);
            }
            handleWrapJump(e1) {
                const t = Math.round((e1 - (void 0 === this._prevLng ? e1 : this._prevLng)) / 360);
                if (this._prevLng = e1, t) {
                    const e1 = {};
                    for(const i in this._tiles){
                        const r = this._tiles[i];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + t), e1[r.tileID.key] = r;
                    }
                    this._tiles = e1;
                    for(const e1 in this._timers)clearTimeout(this._timers[e1]), delete this._timers[e1];
                    for(const e1 in this._tiles)this._setTileReloadTimer(+e1, this._tiles[e1]);
                }
            }
            update(e1, t, i, r) {
                if (this.transform = e1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !i) return;
                let n;
                if (this.updateCacheSize(e1, t), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? n = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map((e1)=>new qu(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y)) : (n = e1.coveringTiles({
                    tileSize: t || this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom && !i,
                    reparseOverscaled: this._source.reparseOverscaled,
                    isTerrainDEM: this.usedForTerrain
                }), this._source.hasTile && (n = n.filter((e1)=>this._source.hasTile(e1)))) : n = [], n.length > 0 && this.castsShadows && r && "globe" !== this.transform.projection.name && !this.usedForTerrain && !Ox(this._source.type)) {
                    const o = e1.coveringZoomLevel({
                        tileSize: t || this._source.tileSize,
                        roundZoom: this._source.roundZoom && !i
                    }), s = Math.min(o, this._source.maxzoom), a = e1.extendTileCoverForShadows(n, r, s);
                    for (const e1 of a)this._shadowCasterTiles[e1.key] = !0, n.push(e1);
                }
                const o = this._updateRetainedTiles(n);
                if (Ox(this._source.type) && 0 !== n.length) {
                    const e1 = {}, t = {}, i = Object.keys(o);
                    for (const r of i){
                        const i = o[r], n = this._tiles[r];
                        if (!n || n.fadeEndTime && n.fadeEndTime <= dt.now()) continue;
                        const s = this.findLoadedParent(i, Math.max(i.overscaledZ - Lx.maxOverzooming, this._source.minzoom));
                        s && (this._addTile(s.tileID), e1[s.tileID.key] = s.tileID), t[r] = i;
                    }
                    const r = n[n.length - 1].overscaledZ;
                    for(const e1 in this._tiles){
                        const i = this._tiles[e1];
                        if (o[e1] || !i.hasData()) continue;
                        let n = i.tileID;
                        for(; n.overscaledZ > r;){
                            n = n.scaledTo(n.overscaledZ - 1);
                            const r = this._tiles[n.key];
                            if (r && r.hasData() && t[n.key]) {
                                o[e1] = i.tileID;
                                break;
                            }
                        }
                    }
                    for(const t in e1)o[t] || (this._coveredTiles[t] = !0, o[t] = e1[t]);
                }
                for(const e1 in o)this._tiles[e1].clearFadeHold();
                const s = function(e1, t) {
                    const i = [];
                    for(const r in e1)r in t || i.push(r);
                    return i;
                }(this._tiles, o);
                for (const e1 of s){
                    const t = this._tiles[e1];
                    t.hasSymbolBuckets && !t.holdingForFade() ? t.setHoldDuration(this.map._fadeDuration) : t.hasSymbolBuckets && !t.symbolFadeFinished() || this._removeTile(+e1);
                }
                this._updateLoadedParentTileCache(), this._onlySymbols && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for(const e1 in this._tiles)this._tiles[e1].holdingForFade() && this._removeTile(+e1);
            }
            _updateRetainedTiles(e1) {
                const t = {};
                if (0 === e1.length) return t;
                const i = {}, r = e1.reduce((e1, t)=>Math.min(e1, t.overscaledZ), 1 / 0), n = e1[0].overscaledZ, o = Math.max(n - Lx.maxOverzooming, this._source.minzoom), s = Math.max(n + Lx.maxUnderzooming, this._source.minzoom), a = {};
                for (const i of e1){
                    const e1 = this._addTile(i);
                    t[i.key] = i, e1.hasData() || r < this._source.maxzoom && (a[i.key] = i);
                }
                this._retainLoadedChildren(a, r, s, t);
                for (const r of e1){
                    let e1 = this._tiles[r.key];
                    if (e1.hasData()) continue;
                    if (r.canonical.z >= this._source.maxzoom) {
                        const e1 = r.children(this._source.maxzoom)[0], i = this.getTile(e1);
                        if (i && i.hasData()) {
                            t[e1.key] = e1;
                            continue;
                        }
                    } else {
                        const e1 = r.children(this._source.maxzoom);
                        if (t[e1[0].key] && t[e1[1].key] && t[e1[2].key] && t[e1[3].key]) continue;
                    }
                    let n = e1.wasRequested();
                    for(let s = r.overscaledZ - 1; s >= o; --s){
                        const o = r.scaledTo(s);
                        if (i[o.key]) break;
                        if (i[o.key] = !0, e1 = this.getTile(o), !e1 && n && (e1 = this._addTile(o)), e1 && (t[o.key] = o, n = e1.wasRequested(), e1.hasData())) break;
                    }
                }
                return t;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const e1 in this._tiles){
                    const t = [];
                    let i, r = this._tiles[e1].tileID;
                    for(; r.overscaledZ > 0;){
                        if (r.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[r.key];
                            break;
                        }
                        t.push(r.key);
                        const e1 = r.scaledTo(r.overscaledZ - 1);
                        if (i = this._getLoadedTile(e1), i) break;
                        r = e1;
                    }
                    for (const e1 of t)this._loadedParentTiles[e1] = i;
                }
            }
            _addTile(e1) {
                let t = this._tiles[e1.key];
                if (t) return !0 !== t.isExtraShadowCaster || !!this._shadowCasterTiles[e1.key] || this._reloadTile(e1.key, "reloading"), t;
                t = this._cache.getAndRemove(e1), t && (this._setTileReloadTimer(e1.key, t), t.tileID = e1, this._state.initializeTileState(t, this.map ? this.map.painter : null), this._cacheTimers[e1.key] && (clearTimeout(this._cacheTimers[e1.key]), delete this._cacheTimers[e1.key], this._setTileReloadTimer(e1.key, t)));
                const i = Boolean(t);
                if (!i) {
                    const i = this.map ? this.map.painter : null;
                    t = new Oy(e1, this._source.tileSize * e1.overscaleFactor(), this.transform.tileZoom, i, this._isRaster), this._loadTile(t, this._tileLoaded.bind(this, t, e1.key, t.state));
                }
                return t ? (t.uses++, this._tiles[e1.key] = t, i || this._source.fire(new It("dataloading", {
                    tile: t,
                    coord: t.tileID,
                    dataType: "source"
                })), t) : null;
            }
            _setTileReloadTimer(e1, t) {
                e1 in this._timers && (clearTimeout(this._timers[e1]), delete this._timers[e1]);
                const i = t.getExpiryTimeout();
                i && (this._timers[e1] = setTimeout(()=>{
                    this._reloadTile(e1, "expired"), delete this._timers[e1];
                }, i));
            }
            _removeTile(e1) {
                const t = this._tiles[e1];
                t && (t.uses--, delete this._tiles[e1], this._timers[e1] && (clearTimeout(this._timers[e1]), delete this._timers[e1]), t.uses > 0 || (t.hasData() && "reloading" !== t.state ? this._cache.add(t.tileID, t, t.getExpiryTimeout()) : (t.aborted = !0, this._abortTile(t), this._unloadTile(t))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const e1 in this._tiles)this._removeTile(+e1);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(e1, t, i) {
                const r = [], n = this.transform;
                if (!n) return r;
                const o = "globe" === n.projection.name, s = Kd(n.center.lng);
                for(const a in this._tiles){
                    const l = this._tiles[a];
                    if (i && l.clearQueryDebugViz(), l.holdingForFade()) continue;
                    let c;
                    if (o) {
                        const e1 = l.tileID.canonical;
                        if (0 === e1.z) {
                            const t = [
                                Math.abs(z(s, ...Bx(e1, -1)) - s),
                                Math.abs(z(s, ...Bx(e1, 1)) - s)
                            ];
                            c = [
                                0,
                                2 * t.indexOf(Math.min(...t)) - 1
                            ];
                        } else {
                            const t = [
                                Math.abs(z(s, ...Bx(e1, -1)) - s),
                                Math.abs(z(s, ...Bx(e1, 0)) - s),
                                Math.abs(z(s, ...Bx(e1, 1)) - s)
                            ];
                            c = [
                                t.indexOf(Math.min(...t)) - 1
                            ];
                        }
                    } else c = [
                        0
                    ];
                    for (const i of c){
                        const o = e1.containsTile(l, n, t, i);
                        o && r.push(o);
                    }
                }
                return r;
            }
            getShadowCasterCoordinates() {
                return this._getRenderableCoordinates(!1, !0);
            }
            getVisibleCoordinates(e1) {
                return this._getRenderableCoordinates(e1);
            }
            _getRenderableCoordinates(e1, t) {
                const i = this.getRenderableIds(e1, t).map((e1)=>this._tiles[e1].tileID), r = "globe" === this.transform.projection.name;
                for (const e1 of i)e1.projMatrix = this.transform.calculateProjMatrix(e1.toUnwrapped()), e1.expandedProjMatrix = r ? this.transform.calculateProjMatrix(e1.toUnwrapped(), !1, !0) : e1.projMatrix;
                return i;
            }
            sortCoordinatesByDistance(e1) {
                const t = e1.slice(), i = this.transform._camera.position, r = this.transform._camera.forward(), n = {};
                for (const e1 of t){
                    const t = 1 / (1 << e1.canonical.z);
                    n[e1.key] = ((e1.canonical.x + .5) * t + e1.wrap - i[0]) * r[0] + ((e1.canonical.y + .5) * t - i[1]) * r[1] - i[2] * r[2];
                }
                return t.sort((e1, t)=>n[e1.key] - n[t.key]), t;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (Ox(this._source.type)) for(const e1 in this._tiles){
                    const t = this._tiles[e1];
                    if (void 0 !== t.fadeEndTime && t.fadeEndTime >= dt.now()) return !0;
                }
                return !1;
            }
            setFeatureState(e1, t, i) {
                this._state.updateState(e1 = e1 || "_geojsonTileLayer", t, i);
            }
            removeFeatureState(e1, t, i) {
                this._state.removeFeatureState(e1 = e1 || "_geojsonTileLayer", t, i);
            }
            getFeatureState(e1, t) {
                return this._state.getState(e1 = e1 || "_geojsonTileLayer", t);
            }
            setDependencies(e1, t, i) {
                const r = this._tiles[e1];
                r && r.setDependencies(t, i);
            }
            reloadTilesForDependencies(e1, t) {
                for(const i in this._tiles)this._tiles[i].hasDependency(e1, t) && this._reloadTile(+i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e1, t));
            }
            _preloadTiles(e1, t) {
                if (!this._sourceLoaded) {
                    const i = ()=>{
                        this._sourceLoaded && (this._source.off("data", i), this._preloadTiles(e1, t));
                    };
                    return void this._source.on("data", i);
                }
                const i = new Map, r = Array.isArray(e1) ? e1 : [
                    e1
                ], n = this.map.painter.terrain, o = this.usedForTerrain && n ? n.getScaledDemTileSize() : this._source.tileSize;
                for (const e1 of r){
                    const t = e1.coveringTiles({
                        tileSize: o,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const e1 of t)i.set(e1.key, e1);
                    this.usedForTerrain && e1.updateElevation(!1);
                }
                R(Array.from(i.values()), (e1, t)=>{
                    const i = new Oy(e1, this._source.tileSize * e1.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster);
                    this._loadTile(i, (e1)=>{
                        "raster-dem" === this._source.type && i.dem && this._backfillDEM(i), t(e1, i);
                    });
                }, t);
            }
            constructor(e1, t, i){
                super(), this.id = e1, this._onlySymbols = i, t.on("data", (e1)=>{
                    "source" === e1.dataType && "metadata" === e1.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === e1.dataType && "content" === e1.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), t.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = t, this._tiles = {}, this._cache = new By(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = t.minTileCacheSize, this._maxTileCacheSize = t.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = !1, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new Fm, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "custom" === this._source.type && "raster" === this._source._dataType;
            }
        }
        function kx(e1, t) {
            const i = Math.abs(2 * e1.wrap) - +(e1.wrap < 0), r = Math.abs(2 * t.wrap) - +(t.wrap < 0);
            return e1.overscaledZ - t.overscaledZ || r - i || t.canonical.y - e1.canonical.y || t.canonical.x - e1.canonical.x;
        }
        function Ox(e1) {
            return "raster" === e1 || "image" === e1 || "video" === e1 || "custom" === e1;
        }
        function Bx(e1, t) {
            const i = 1 << e1.z;
            return [
                e1.x / i + t,
                (e1.x + 1) / i + t
            ];
        }
        Lx.maxOverzooming = 10, Lx.maxUnderzooming = 3;
        const Fx = Ia([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), Nx = Ia([
            {
                name: "a_color_3f",
                components: 3,
                type: "Float32"
            }
        ]), Ux = Ia([
            {
                name: "a_color_4f",
                components: 4,
                type: "Float32"
            }
        ]), Vx = Ia([
            {
                name: "a_uv_2f",
                components: 2,
                type: "Float32"
            }
        ]), jx = Ia([
            {
                name: "a_normal_3f",
                components: 3,
                type: "Float32"
            }
        ]), Gx = Ia([
            {
                name: "a_normal_matrix0",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix1",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix2",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix3",
                components: 4,
                type: "Float32"
            }
        ]), qx = Ia([
            {
                name: "a_pbr",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_heightBasedEmissiveStrength",
                components: 3,
                type: "Float32"
            }
        ]);
        class Zx {
            interpolate(e1, t, i) {
                return null != t.top && null != e1.top && (this.top = Kr(e1.top, t.top, i)), null != t.bottom && null != e1.bottom && (this.bottom = Kr(e1.bottom, t.bottom, i)), null != t.left && null != e1.left && (this.left = Kr(e1.left, t.left, i)), null != t.right && null != e1.right && (this.right = Kr(e1.right, t.right, i)), this;
            }
            getCenter(e1, t) {
                const i = z((this.left + e1 - this.right) / 2, 0, e1), r = z((this.top + t - this.bottom) / 2, 0, t);
                return new y(i, r);
            }
            equals(e1) {
                return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
            }
            clone() {
                return new Zx(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
            constructor(e1 = 0, t = 0, i = 0, r = 0){
                if (isNaN(e1) || e1 < 0 || isNaN(t) || t < 0 || isNaN(i) || i < 0 || isNaN(r) || r < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e1, this.bottom = t, this.left = i, this.right = r;
            }
        }
        function $x(e1, t) {
            const i = ne(e1, 3);
            Au.fromQuat(e1, t), oe(e1, 3, i);
        }
        function Wx(e1, t) {
            const i = Iu.identity([]);
            return Iu.rotateZ(i, i, -t), Iu.rotateX(i, i, -e1), i;
        }
        function Hx(e1, t) {
            const i = [
                e1[0],
                e1[1],
                0
            ], r = [
                t[0],
                t[1],
                0
            ];
            if (Du.length(i) >= 1e-15) {
                const e1 = Du.normalize([], i);
                Du.scale(r, e1, Du.dot(r, e1)), t[0] = r[0], t[1] = r[1];
            }
            const n = Du.cross([], t, e1);
            if (Du.len(n) < 1e-15) return null;
            const o = Math.atan2(-n[1], n[0]);
            return Wx(Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2]), o);
        }
        class Xx {
            get position() {
                return this._position;
            }
            set position(e1) {
                if (e1) {
                    const t = e1 instanceof lp ? e1 : new lp(e1[0], e1[1], e1[2]);
                    this._renderWorldCopies && (t.x = D(t.x, 0, 1)), this._position = t;
                } else this._position = null;
            }
            lookAtPoint(e1, t) {
                if (this.orientation = null, !this.position) return;
                const i = this.position, r = this._elevation ? this._elevation.getAtPointOrZero(lp.fromLngLat(e1)) : 0, n = lp.fromLngLat(e1, r), o = [
                    n.x - i.x,
                    n.y - i.y,
                    n.z - i.z
                ];
                t || (t = [
                    0,
                    0,
                    1
                ]), t[2] = Math.abs(t[2]), this.orientation = Hx(o, t);
            }
            setPitchBearing(e1, t) {
                this.orientation = Wx(w(e1), w(-t));
            }
            constructor(e1, t){
                this.position = e1, this.orientation = t;
            }
        }
        class Yx {
            get mercatorPosition() {
                const e1 = this.position;
                return new lp(e1[0], e1[1], e1[2]);
            }
            get position() {
                const e1 = ne(this._transform, 3);
                return [
                    e1[0],
                    e1[1],
                    e1[2]
                ];
            }
            set position(e1) {
                var t;
                e1 && oe(this._transform, 3, [
                    (t = e1)[0],
                    t[1],
                    t[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(e1) {
                this._orientation = e1 || Iu.identity([]), e1 && $x(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e1 = this.forward(), t = this.right();
                return {
                    bearing: Math.atan2(-t[1], t[0]),
                    pitch: Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2])
                };
            }
            setPitchBearing(e1, t) {
                this._orientation = Wx(e1, t), $x(this._transform, this._orientation);
            }
            forward() {
                const e1 = ne(this._transform, 2);
                return [
                    -e1[0],
                    -e1[1],
                    -e1[2]
                ];
            }
            up() {
                const e1 = ne(this._transform, 1);
                return [
                    -e1[0],
                    -e1[1],
                    -e1[2]
                ];
            }
            right() {
                const e1 = ne(this._transform, 0);
                return [
                    e1[0],
                    e1[1],
                    e1[2]
                ];
            }
            getCameraToWorld(e1, t) {
                const i = new Float64Array(16);
                return Au.invert(i, this.getWorldToCamera(e1, t)), i;
            }
            getCameraToWorldMercator() {
                return this._transform;
            }
            getWorldToCameraPosition(e1, t, i) {
                const r = this.position;
                Du.scale(r, r, -e1);
                const n = new Float64Array(16);
                return Au.fromScaling(n, [
                    i,
                    i,
                    i
                ]), Au.translate(n, n, r), n[10] *= t, n;
            }
            getWorldToCamera(e1, t) {
                const i = new Float64Array(16), r = new Float64Array(4), n = this.position;
                return Iu.conjugate(r, this._orientation), Du.scale(n, n, -e1), Au.fromQuat(i, r), Au.translate(i, i, n), i[1] *= -1, i[5] *= -1, i[9] *= -1, i[13] *= -1, i[8] *= t, i[9] *= t, i[10] *= t, i[11] *= t, i;
            }
            getCameraToClipPerspective(e1, t, i, r) {
                const n = new Float64Array(16);
                return Au.perspective(n, e1, t, i, r), n;
            }
            getCameraToClipOrthographic(e1, t, i, r, n, o) {
                const s = new Float64Array(16);
                return Au.ortho(s, e1, t, i, r, n, o), s;
            }
            getDistanceToElevation(e1, t = !1) {
                const i = 0 === e1 ? 0 : Qd(e1, t ? tp(this.position[1]) : this.position[1]), r = this.forward();
                return (i - this.position[2]) / r[2];
            }
            clone() {
                return new Yx([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
            constructor(e1, t){
                this._transform = Au.identity([]), this.orientation = t, this.position = e1;
            }
        }
        function Kx(e1, t) {
            const i = Qx(e1.projection, e1.zoom, e1.width, e1.height), r = function(e1, t, i, r, n) {
                const o = new Wd(i.lng - 180 * ev, i.lat), s = new Wd(i.lng + 180 * ev, i.lat), a = e1.project(o.lng, o.lat), l = e1.project(s.lng, s.lat), c = -Math.atan2(l.y - a.y, l.x - a.x), h = lp.fromLngLat(i);
                h.y = z(h.y, -1 + ev, 1 - ev);
                const u = h.toLngLat(), d = e1.project(u.lng, u.lat), p = lp.fromLngLat(u);
                p.x += ev;
                const f = p.toLngLat(), m = e1.project(f.lng, f.lat), _ = iv(m.x - d.x, m.y - d.y, c), g = lp.fromLngLat(u);
                g.y += ev;
                const y = g.toLngLat(), x = e1.project(y.lng, y.lat), v = iv(x.x - d.x, x.y - d.y, c), b = Math.abs(_.x) / Math.abs(v.y), w = Au.identity([]);
                Au.rotateZ(w, w, -c * (1 - (n ? 0 : r)));
                const T = Au.identity([]);
                return Au.scale(T, T, [
                    1,
                    1 - (1 - b) * r,
                    1
                ]), T[4] = -v.x / v.y * r, Au.rotateZ(T, T, c), Au.multiply(T, w, T), T;
            }(e1.projection, 0, e1.center, i, t), n = Jx(e1);
            return Au.scale(r, r, [
                n,
                n,
                1
            ]), r;
        }
        function Jx(e1) {
            const t = e1.projection, i = Qx(e1.projection, e1.zoom, e1.width, e1.height), r = tv(t, e1.center), n = tv(t, Wd.convert(t.center));
            return Math.pow(2, r * i + (1 - i) * n);
        }
        function Qx(e1, t, i, r, n = 1 / 0) {
            const o = e1.range;
            if (!o) return 0;
            const s = Math.min(n, Math.max(i, r)), a = Math.log(s / 1024) / Math.LN2;
            return P(o[0] + a, o[1] + a, t);
        }
        const ev = 1 / 4e4;
        function tv(e1, t) {
            const i = z(t.lat, -rp, rp), r = new Wd(t.lng - 180 * ev, i), n = new Wd(t.lng + 180 * ev, i), o = e1.project(r.lng, i), s = e1.project(n.lng, i), a = lp.fromLngLat(r), l = lp.fromLngLat(n), c = s.x - o.x, h = s.y - o.y, u = l.x - a.x, d = l.y - a.y, p = Math.sqrt((u * u + d * d) / (c * c + h * h));
            return Math.log(p) / Math.LN2;
        }
        function iv(e1, t, i) {
            const r = Math.cos(i), n = Math.sin(i);
            return {
                x: e1 * r - t * n,
                y: e1 * n + t * r
            };
        }
        function rv(e1, t, i) {
            return t * (cr / (e1.tileSize * Math.pow(2, i - e1.tileID.overscaledZ)));
        }
        const nv = {
            unknown: 0,
            flipRequired: 1,
            flipNotRequired: 2
        }, ov = Math.tan(85 * Math.PI / 180);
        function sv(e1, t, i, r, n, o, s) {
            const a = Au.create();
            if (i) {
                if ("globe" === o.name) {
                    const e1 = function(e1, t) {
                        const { x: i, y: r } = e1.point, n = zd(i, r, e1.worldSize / e1._pixelsPerMercatorPixel, 0, 0);
                        return Au.multiply(n, n, Sd(fd(t)));
                    }(n, t);
                    Au.multiply(a, a, e1);
                } else {
                    const e1 = bu.invert([], s);
                    a[0] = e1[0], a[1] = e1[1], a[4] = e1[2], a[5] = e1[3], r || Au.rotateZ(a, a, n.angle);
                }
            } else Au.multiply(a, n.labelPlaneMatrix, e1);
            return a;
        }
        function av(e1, t, i, r, n, o, s) {
            const a = sv(e1, t, i, r, n, o, s);
            return "globe" === o.name && i || (a[2] = a[6] = a[10] = a[14] = 0), a;
        }
        function lv(e1, t, i, r, n, o, s) {
            if (i) {
                if ("globe" === o.name) {
                    const a = sv(e1, t, i, r, n, o, s);
                    return Au.invert(a, a), Au.multiply(a, e1, a), a;
                }
                {
                    const t = Au.clone(e1), i = Au.identity([]);
                    return i[0] = s[0], i[1] = s[1], i[4] = s[2], i[5] = s[3], Au.multiply(t, t, i), r || Au.rotateZ(t, t, -n.angle), t;
                }
            }
            return n.glCoordMatrix;
        }
        function cv(e1, t, i, r) {
            const n = [
                e1,
                t,
                i,
                1
            ];
            i ? yu.transformMat4(n, n, r) : vv(n, n, r);
            const o = n[3];
            return n[0] /= o, n[1] /= o, n[2] /= o, n;
        }
        function hv(e1, t) {
            return Math.min(.5 + e1 / t * .5, 1.5);
        }
        function uv(e1, t) {
            const i = e1[0] / e1[3], r = e1[1] / e1[3];
            return i >= -t[0] && i <= t[0] && r >= -t[1] && r <= t[1];
        }
        function dv(e1, t, i, r, n, o, s, a, l, c) {
            const h = i.transform, u = r ? e1.textSizeData : e1.iconSizeData, d = m_(u, i.transform.zoom), p = "globe" === h.projection.name, f = [
                256 / i.width * 2 + 1,
                256 / i.height * 2 + 1
            ], m = r ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            m.clear();
            let _ = null;
            p && (_ = r ? e1.text.globeExtVertexArray : e1.icon.globeExtVertexArray);
            const g = e1.lineVertexArray, x = r ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, v = i.transform.width / i.transform.height;
            let b, w = !1;
            for(let r = 0; r < x.length; r++){
                const p = x.get(r), { numGlyphs: T, writingMode: E } = p;
                if (E !== A_.vertical || w || b === A_.horizontal || (w = !0), b = E, (p.hidden || E === A_.vertical) && !w) {
                    xv(T, m);
                    continue;
                }
                w = !1;
                const M = new y(p.tileAnchorX, p.tileAnchorY);
                let { x: A, y: S, z: I } = h.projection.projectTilePoint(M.x, M.y, c.canonical);
                if (l) {
                    const [e1, t, i] = l(M);
                    A += e1, S += t, I += i;
                }
                const C = [
                    A,
                    S,
                    I,
                    1
                ];
                if (yu.transformMat4(C, C, t), !uv(C, f)) {
                    xv(T, m);
                    continue;
                }
                const z = C[3], P = hv(i.transform.getCameraToCenterDistance(h.projection), z), D = f_(u, d, p), R = s ? D / P : D * P, L = cv(A, S, I, n);
                if (L[3] <= 0) {
                    xv(T, m);
                    continue;
                }
                let k = {};
                const O = s ? null : l, B = mv(p, R, !1, a, t, n, o, e1.glyphOffsetArray, g, m, _, L, M, k, v, O, h.projection, c, s);
                w = B.useVertical, O && B.needsFlipping && (k = {}), (B.notEnoughRoom || w || B.needsFlipping && mv(p, R, !0, a, t, n, o, e1.glyphOffsetArray, g, m, _, L, M, k, v, O, h.projection, c, s).notEnoughRoom) && xv(T, m);
            }
            r ? (e1.text.dynamicLayoutVertexBuffer.updateData(m), _ && e1.text.globeExtVertexBuffer && e1.text.globeExtVertexBuffer.updateData(_)) : (e1.icon.dynamicLayoutVertexBuffer.updateData(m), _ && e1.icon.globeExtVertexBuffer && e1.icon.globeExtVertexBuffer.updateData(_));
        }
        function pv(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m) {
            const { lineStartIndex: _, glyphStartIndex: g, segment: y } = a, x = g + a.numGlyphs, v = _ + a.lineLength, b = t.getoffsetX(g), w = t.getoffsetX(x - 1), T = yv(e1 * b, i, r, n, o, s, y, _, v, l, c, h, u, d, !0, p, f, m);
            if (!T) return null;
            const E = yv(e1 * w, i, r, n, o, s, y, _, v, l, c, h, u, d, !0, p, f, m);
            return E ? {
                first: T,
                last: E
            } : null;
        }
        function fv(e1, t, i, r) {
            return e1 === A_.horizontal && Math.abs(r) > Math.abs(i) ? {
                useVertical: !0
            } : e1 === A_.vertical ? r > 0 ? {
                needsFlipping: !0
            } : null : t !== nv.unknown && function(e1, t) {
                return 0 === e1 || Math.abs(t / e1) > ov;
            }(i, r) ? t === nv.flipRequired ? {
                needsFlipping: !0
            } : null : i < 0 ? {
                needsFlipping: !0
            } : null;
        }
        function mv(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, x) {
            const v = t / 24, b = e1.lineOffsetX * v, w = e1.lineOffsetY * v, { lineStartIndex: T, glyphStartIndex: E, numGlyphs: M, segment: A, writingMode: S, flipState: I } = e1, C = T + e1.lineLength, z = (e1)=>{
                if (h) {
                    const [t, i, r] = e1.up, n = c.length;
                    uy(h, n + 0, t, i, r), uy(h, n + 1, t, i, r), uy(h, n + 2, t, i, r), uy(h, n + 3, t, i, r);
                }
                const [t, i, r] = e1.point;
                dy(c, t, i, r, e1.angle);
            };
            if (M > 1) {
                const t = pv(v, a, b, w, i, u, d, e1, l, o, p, m, !1, _, g, x);
                if (!t) return {
                    notEnoughRoom: !0
                };
                if (r && !i) {
                    let [i, r, n] = t.first.point, [o, a, l] = t.last.point;
                    [i, r] = cv(i, r, n, s), [o, a] = cv(o, a, l, s);
                    const c = fv(S, I, (o - i) * f, a - r);
                    if (e1.flipState = c && c.needsFlipping ? nv.flipRequired : nv.flipNotRequired, c) return c;
                }
                z(t.first);
                for(let e1 = E + 1; e1 < E + M - 1; e1++){
                    const t = yv(v * a.getoffsetX(e1), b, w, i, u, d, A, T, C, l, o, p, m, !1, !1, _, g, x);
                    if (!t) return c.length -= 4 * (e1 - E), {
                        notEnoughRoom: !0
                    };
                    z(t);
                }
                z(t.last);
            } else {
                if (r && !i) {
                    const t = cv(d.x, d.y, 0, n), i = T + A + 1, r = new y(l.getx(i), l.gety(i)), o = cv(r.x, r.y, 0, n), s = o[3] > 0 ? o : gv(d, r, t, 1, n, void 0, _, g.canonical), a = fv(S, I, (s[0] - t[0]) * f, s[1] - t[1]);
                    if (e1.flipState = a && a.needsFlipping ? nv.flipRequired : nv.flipNotRequired, a) return a;
                }
                const t = yv(v * a.getoffsetX(E), b, w, i, u, d, A, T, C, l, o, p, m, !1, !1, _, g, x);
                if (!t) return {
                    notEnoughRoom: !0
                };
                z(t);
            }
            return {};
        }
        function _v(e1, t, i, r, n) {
            const { x: o, y: s, z: a } = r.projectTilePoint(e1.x, e1.y, t);
            if (!n) return cv(o, s, a, i);
            const [l, c, h] = n(e1);
            return cv(o + l, s + c, a + h, i);
        }
        function gv(e1, t, i, r, n, o, s, a) {
            const l = _v(e1.sub(t)._unit()._add(e1), a, n, s, o);
            return Du.sub(l, i, l), Du.normalize(l, l), Du.scaleAndAdd(l, i, l, r);
        }
        function yv(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g) {
            const x = r ? e1 - t : e1 + t;
            let v = x > 0 ? 1 : -1, b = 0;
            r && (v *= -1, b = Math.PI), v < 0 && (b += Math.PI);
            let w = a + s + (v > 0 ? 0 : 1) | 0, T = n, E = n, M = 0, A = 0;
            const S = Math.abs(x), I = [], C = [];
            let z = o, P = z;
            const D = ()=>gv(P, z, E, S - M + 1, h, d, m, _.canonical);
            for(; M + A <= S;){
                if (w += v, w < a || w >= l) return null;
                if (E = T, P = z, I.push(E), p && C.push(P), z = new y(c.getx(w), c.gety(w)), T = u[w], !T) {
                    const e1 = _v(z, _.canonical, h, m, d);
                    T = e1[3] > 0 ? u[w] = e1 : D();
                }
                M += A, A = Du.distance(E, T);
            }
            f && d && (u[w] && (T = D(), A = Du.distance(E, T)), u[w] = T);
            const R = (S - M) / A, L = z.sub(P)._mult(R)._add(P), k = Du.sub([], T, E), O = Du.scaleAndAdd([], E, k, R);
            let B = [
                0,
                0,
                1
            ], F = k[0], N = k[1];
            if (g && (B = m.upVector(_.canonical, L.x, L.y), 0 !== B[0] || 0 !== B[1] || 1 !== B[2])) {
                const e1 = [
                    B[2],
                    0,
                    -B[0]
                ], t = Du.cross([], B, e1);
                Du.normalize(e1, e1), Du.normalize(t, t), F = Du.dot(k, e1), N = Du.dot(k, t);
            }
            if (i) {
                const e1 = Du.cross([], B, k);
                Du.normalize(e1, e1), Du.scaleAndAdd(O, O, e1, i * v);
            }
            const U = b + Math.atan2(N, F);
            return I.push(O), p && C.push(L), {
                point: O,
                angle: U,
                path: I,
                tilePath: C,
                up: B
            };
        }
        function xv(e1, t) {
            const i = t.length, r = i + 4 * e1;
            t.resize(r), t.float32.fill(-1 / 0, 4 * i, 4 * r);
        }
        function vv(e1, t, i) {
            const r = t[0], n = t[1];
            return e1[0] = i[0] * r + i[4] * n + i[12], e1[1] = i[1] * r + i[5] * n + i[13], e1[3] = i[3] * r + i[7] * n + i[15], e1;
        }
        const bv = (e1, t, i)=>(1 - i) * e1 + i * t, wv = (e1)=>e1 * e1 * e1 * e1 * e1;
        class Tv {
            clone() {
                const e1 = new Tv(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection());
                return e1._elevation = this._elevation, e1._centerAltitude = this._centerAltitude, e1._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e1.tileSize = this.tileSize, e1.mercatorFromTransition = this.mercatorFromTransition, e1.width = this.width, e1.height = this.height, e1.cameraElevationReference = this.cameraElevationReference, e1._center = this._center, e1._setZoom(this.zoom), e1._seaLevelZoom = this._seaLevelZoom, e1.angle = this.angle, e1._fov = this._fov, e1._pitch = this._pitch, e1._nearZ = this._nearZ, e1._farZ = this._farZ, e1._averageElevation = this._averageElevation, e1._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e1._unmodified = this._unmodified, e1._edgeInsets = this._edgeInsets.clone(), e1._camera = this._camera.clone(), e1._calcMatrices(), e1.freezeTileCoverage = this.freezeTileCoverage, e1.frustumCorners = this.frustumCorners, e1;
            }
            get isOrthographic() {
                return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < 15;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e1) {
                this._elevation !== e1 && (this._elevation = e1, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            get depthOcclusionForSymbolsAndCircles() {
                return "globe" !== this.projection.name && !this.isOrthographic;
            }
            updateElevation(e1, t = !1) {
                const i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e1 || i) && this._constrainCamera(t), this._calcMatrices();
            }
            getProjection() {
                return O(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(e1) {
                this.projectionOptions = e1 || {
                    name: "mercator"
                };
                const t = this.projection ? this.getProjection() : void 0;
                this.projection = ty(this.projectionOptions);
                const i = !x(t, this.getProjection());
                return i && this._calcMatrices(), this.mercatorFromTransition = !1, i;
            }
            setOrthographicProjectionAtLowPitch(e1) {
                return this._orthographicProjectionAtLowPitch !== e1 && (this._orthographicProjectionAtLowPitch = e1, this._calcMatrices(), !0);
            }
            setMercatorFromTransition() {
                const e1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = ty({
                    name: "mercator"
                });
                const t = e1 !== this.projection.name;
                return t && this._calcMatrices(), t;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e1) {
                this._minZoom !== e1 && (this._minZoom = e1, this.zoom = Math.max(this.zoom, e1));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e1) {
                this._maxZoom !== e1 && (this._maxZoom = e1, this.zoom = Math.min(this.zoom, e1));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e1) {
                this._minPitch !== e1 && (this._minPitch = e1, this.pitch = Math.max(this.pitch, e1));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e1) {
                this._maxPitch !== e1 && (this._maxPitch = e1, this.pitch = Math.min(this.pitch, e1));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e1) {
                void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get cameraWorldSize() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return Qd(1, this.center.lat) * this.cameraWorldSizeForFog;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new y(this.width, this.height);
            }
            get bearing() {
                return D(this.rotation, -180, 180);
            }
            set bearing(e1) {
                this.rotation = e1;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(e1) {
                const t = -e1 * Math.PI / 180;
                this.angle !== t && (this._unmodified = !1, this.angle = t, this._calcMatrices(), this.rotationMatrix = bu.create(), bu.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(e1) {
                const t = z(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== t && (this._unmodified = !1, this._pitch = t, this._calcMatrices());
            }
            get aspect() {
                return this.width / this.height;
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            get fovX() {
                return this._fov;
            }
            get fovY() {
                const e1 = 1 / Math.tan(.5 * this.fovX);
                return 2 * Math.atan(1 / this.aspect / e1);
            }
            set fov(e1) {
                e1 = Math.max(.01, Math.min(60, e1)), this._fov !== e1 && (this._unmodified = !1, this._fov = w(e1), this._calcMatrices());
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e1) {
                this._averageElevation = e1, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e1) {
                const t = Math.min(Math.max(e1, this.minZoom), this.maxZoom);
                this._zoom !== t && (this._unmodified = !1, this._setZoom(t), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e1) {
                this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom;
            }
            _updateCameraOnTerrain() {
                const e1 = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t = this.elevation && e1 === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
                if (!this._elevation || e1 === Number.NEGATIVE_INFINITY && (!t || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const i = this._elevation;
                t || this._centerAltitude && this._centerAltitudeValidForExaggeration && i.exaggeration() && this._centerAltitudeValidForExaggeration !== i.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i.exaggeration(), this._centerAltitudeValidForExaggeration = i.exaggeration()) : (this._centerAltitude = e1 || 0, this._centerAltitudeValidForExaggeration = i.exaggeration()), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                void 0 !== this._centerAltitudeValidForExaggeration && (this._seaLevelZoom = this._zoomFromMercatorZ((this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize));
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const e1 = this._elevation, t = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], i = this.horizonLineFromTop();
                let r = 0, n = 0;
                for(let o = 0; o < t.length; o++){
                    const s = new y(t[o][0] * this.width, i + t[o][1] * (this.height - i)), a = e1.pointCoordinate(s);
                    if (!a) continue;
                    const l = 1 / Math.hypot(a[0] - this._camera.position[0], a[1] - this._camera.position[1]);
                    r += a[3] * l, n += l;
                }
                return 0 === n ? NaN : r / n;
            }
            get center() {
                return this._center;
            }
            set center(e1) {
                e1.lat === this._center.lat && e1.lng === this._center.lng || (this._unmodified = !1, this._center = e1, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e1 = this._seaLevelZoom, t = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t, r = this._mercatorZfromZoom(e1), n = this._mercatorZfromZoom(this._maxZoom), o = Math.max(r - i, n);
                this._setZoom(this._zoomFromMercatorZ(o));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e1) {
                this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
            }
            computeZoomRelativeTo(e1) {
                const t = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, e1.toAltitude()));
                let i;
                i = e1.z < this._camera.position[2] ? [
                    t.x,
                    t.y,
                    t.z
                ] : [
                    e1.x,
                    e1.y,
                    e1.z
                ];
                const r = Du.length(Du.sub([], this._camera.position, i));
                return z(this._zoomFromMercatorZ(r), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(e1) {
                if (!this.height) return;
                if (!e1.position && !e1.orientation) return;
                this._updateCameraState();
                let t = !1;
                if (e1.orientation && !Iu.exactEquals(e1.orientation, this._camera.orientation) && (t = this._setCameraOrientation(e1.orientation)), e1.position) {
                    const i = [
                        e1.position.x,
                        e1.position.y,
                        e1.position.z
                    ];
                    Du.exactEquals(i, this._camera.position) || (this._setCameraPosition(i), t = !0);
                }
                t && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const e1 = this._camera.position, t = new Xx;
                return t.position = new lp(e1[0], e1[1], e1[2]), t.orientation = this._camera.orientation, t._elevation = this.elevation, t._renderWorldCopies = this.renderWorldCopies, t;
            }
            _setCameraOrientation(e1) {
                if (!Iu.length(e1)) return !1;
                Iu.normalize(e1, e1);
                const t = Du.transformQuat([], [
                    0,
                    0,
                    -1
                ], e1), i = Du.transformQuat([], [
                    0,
                    -1,
                    0
                ], e1);
                if (i[2] < 0) return !1;
                const r = Hx(t, i);
                return !!r && (this._camera.orientation = r, !0);
            }
            _setCameraPosition(e1) {
                const t = this.zoomScale(this.minZoom) * this.tileSize, i = this.zoomScale(this.maxZoom) * this.tileSize, r = this.cameraToCenterDistance;
                e1[2] = z(e1[2], r / i, r / t), this._camera.position = e1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e1) {
                return this._edgeInsets.equals(e1);
            }
            interpolatePadding(e1, t, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e1, t, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e1) {
                const t = (e1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e1.tileSize));
                return Math.max(0, t);
            }
            getVisibleUnwrappedCoordinates(e1) {
                const t = [
                    new Gu(0, e1)
                ];
                if (this.renderWorldCopies) {
                    const i = this.pointCoordinate(new y(0, 0)), r = this.pointCoordinate(new y(this.width, 0)), n = this.pointCoordinate(new y(this.width, this.height)), o = this.pointCoordinate(new y(0, this.height)), s = Math.floor(Math.min(i.x, r.x, n.x, o.x)), a = Math.floor(Math.max(i.x, r.x, n.x, o.x)), l = 1;
                    for(let i = s - l; i <= a + l; i++)0 !== i && t.push(new Gu(i, e1));
                }
                return t;
            }
            isLODDisabled(e1) {
                return (!e1 || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
            }
            extendTileCoverForShadows(e1, t, i) {
                let r = [];
                if (0 === t[0] && 0 === t[1]) return r;
                for (const i of e1){
                    const e1 = i.canonical, n = i.overscaledZ, o = i.wrap, s = 1 << e1.z, a = e1.x + 1 < s, l = e1.x > 0, c = e1.y + 1 < s, h = e1.y > 0, u = i.wrap - (l ? 0 : 1), d = i.wrap + (a ? 0 : 1), p = l ? e1.x - 1 : s - 1, f = a ? e1.x + 1 : 0;
                    t[0] < 0 ? (r.push(new qu(n, d, e1.z, f, e1.y)), t[1] < 0 && c && (r.push(new qu(n, o, e1.z, e1.x, e1.y + 1)), r.push(new qu(n, d, e1.z, f, e1.y + 1))), t[1] > 0 && h && (r.push(new qu(n, o, e1.z, e1.x, e1.y - 1)), r.push(new qu(n, d, e1.z, f, e1.y - 1)))) : t[0] > 0 ? (r.push(new qu(n, u, e1.z, p, e1.y)), t[1] < 0 && c && (r.push(new qu(n, o, e1.z, e1.x, e1.y + 1)), r.push(new qu(n, u, e1.z, p, e1.y + 1))), t[1] > 0 && h && (r.push(new qu(n, o, e1.z, e1.x, e1.y - 1)), r.push(new qu(n, u, e1.z, p, e1.y - 1)))) : t[1] < 0 && c ? r.push(new qu(n, o, e1.z, e1.x, e1.y + 1)) : h && r.push(new qu(n, o, e1.z, e1.x, e1.y - 1));
                }
                if (r.length > 1) {
                    r.sort((e1, t)=>e1.overscaledZ - t.overscaledZ || e1.wrap - t.wrap || e1.canonical.z - t.canonical.z || e1.canonical.x - t.canonical.x || e1.canonical.y - t.canonical.y);
                    let e1 = 0, t = 0;
                    for(; t < r.length;)r[t].equals(r[e1]) ? ++t : r[++e1] = r[t++];
                    r.length = e1 + 1;
                }
                const n = [];
                for (const e1 of r)r.some((t)=>e1.isChildOf(t)) || n.push(e1);
                return r = n.filter((t)=>!e1.some((e1)=>!!(t.overscaledZ < i && e1.isChildOf(t)) || t.equals(e1) || t.isChildOf(e1))), r;
            }
            coveringTiles(e1) {
                let t = this.coveringZoomLevel(e1);
                const i = t, r = this.elevation && this.elevation.exaggeration(), n = r && !e1.isTerrainDEM, o = "mercator" === this.projection.name;
                if (void 0 !== e1.minzoom && t < e1.minzoom) return [];
                void 0 !== e1.maxzoom && t > e1.maxzoom && (t = e1.maxzoom);
                const s = this.locationCoordinate(this.center), a = this.center.lat, l = 1 << t, c = [
                    l * s.x,
                    l * s.y,
                    0
                ], h = "globe" === this.projection.name, u = !h, d = Qu.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t, u), p = h ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), f = l * Qd(1, this.center.lat), m = this._camera.position[2] / Qd(1, this.center.lat), _ = [
                    l * p.x,
                    l * p.y,
                    m * (u ? 1 : f)
                ], g = h || r, y = this.cameraToCenterDistance / e1.tileSize * (e1.roundZoom ? 1 : .502), x = this.isLODDisabled(!0) ? t : 0;
                let v;
                if (this._elevation && e1.isTerrainDEM) v = 1e4 * this._elevation.exaggeration();
                else if (this._elevation) {
                    const e1 = this._elevation.getMinMaxForVisibleTiles();
                    v = e1 ? e1.max : this._centerAltitude;
                } else v = this._centerAltitude;
                const b = e1.isTerrainDEM ? -v : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, w = this.projection.isReprojectedInTileSpace ? Jx(this) : 1, T = (e1)=>{
                    const t = 1 / 4e4, i = new lp(e1.x + t, e1.y, e1.z), r = new lp(e1.x, e1.y + t, e1.z), n = e1.toLngLat(), o = i.toLngLat(), s = r.toLngLat(), a = this.locationCoordinate(n), l = this.locationCoordinate(o), c = this.locationCoordinate(s), h = Math.hypot(l.x - a.x, l.y - a.y), u = Math.hypot(c.x - a.x, c.y - a.y);
                    return Math.sqrt(h * u) * w / t;
                }, M = (e1)=>{
                    const t = v, i = b;
                    return {
                        aabb: Dg(this, l, 0, 0, 0, e1, i, t, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: i,
                        maxZ: t,
                        wrap: e1,
                        fullyVisible: !1
                    };
                }, A = [];
                let S = [];
                const I = t, C = e1.reparseOverscaled ? i : t, z = (e1)=>e1 * e1, P = z((m - this._centerAltitude) * f), D = (e1)=>{
                    if (!this._elevation || !e1.tileID || !o) return;
                    const t = this._elevation.getMinMaxForTile(e1.tileID), i = e1.aabb;
                    t ? (i.min[2] = t.min, i.max[2] = t.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e1.shouldSplit = R(e1), e1.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, R = (e1)=>{
                    if (e1.zoom < x) return !0;
                    if (e1.zoom === I) return !1;
                    if (null != e1.shouldSplit) return e1.shouldSplit;
                    const t = e1.aabb.distanceX(_), r = e1.aabb.distanceY(_);
                    let o = P, s = 1;
                    if (h) {
                        o = z(e1.aabb.distanceZ(_));
                        const t = Math.pow(2, e1.zoom), i = tp((e1.y + 1) / t), r = tp(e1.y / t), n = Math.min(Math.max(a, i), r), l = Yd(n) / Yd(a);
                        if (s = n === a ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, l / this._mercatorScaleRatio), this.zoom <= td && e1.zoom === I - 1 && l >= .9) return !0;
                    } else if (n && (o = z(e1.aabb.distanceZ(_) * f)), this.projection.isReprojectedInTileSpace && i <= 5) {
                        const t = Math.pow(2, e1.zoom), i = T(new lp((e1.x + .5) / t, (e1.y + .5) / t));
                        s = i > .85 ? 1 : i;
                    }
                    const l = t * t + r * r + o, c = z((1 << I - e1.zoom) * y * s * ((e1, t)=>{
                        if (t * z(.707) < e1) return 1;
                        const i = Math.sqrt(t / e1);
                        return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                    })(Math.max(o, P), l));
                    return l < c;
                };
                if (this.renderWorldCopies) for(let e1 = 1; e1 <= 3; e1++)A.push(M(-e1)), A.push(M(e1));
                for(A.push(M(0)); A.length > 0;){
                    const i = A.pop(), r = i.x, s = i.y;
                    let a = i.fullyVisible;
                    const u = ()=>"globe" === this.projection.name && (0 === i.y || i.y === (1 << i.zoom) - 1);
                    if (!a) {
                        let e1 = g ? i.aabb.intersects(d) : i.aabb.intersectsFlat(d);
                        if (0 === e1 && u()) {
                            const t = new ju(i.zoom, r, s);
                            e1 = yd(this, l, t, !0).intersects(d);
                        }
                        if (0 === e1) continue;
                        a = 2 === e1;
                    }
                    if (i.zoom !== I && R(i)) for(let e1 = 0; e1 < 4; e1++){
                        const t = (r << 1) + e1 % 2, c = (s << 1) + (e1 >> 1), u = {
                            aabb: o ? i.aabb.quadrant(e1) : Dg(this, l, i.zoom + 1, t, c, i.wrap, i.minZ, i.maxZ, this.projection),
                            zoom: i.zoom + 1,
                            x: t,
                            y: c,
                            wrap: i.wrap,
                            fullyVisible: a,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: i.minZ,
                            maxZ: i.maxZ
                        };
                        n && !h && (u.tileID = new qu(i.zoom + 1 === I ? C : i.zoom + 1, i.wrap, i.zoom + 1, t, c), D(u)), A.push(u);
                    }
                    else {
                        const n = i.zoom === I ? C : i.zoom;
                        if (e1.minzoom && e1.minzoom > n) continue;
                        if (!a) {
                            let e1 = g ? i.aabb.intersectsPrecise(d) : i.aabb.intersectsPreciseFlat(d);
                            if (0 === e1 && u()) {
                                const t = new ju(i.zoom, r, s);
                                e1 = yd(this, l, t, !0).intersectsPrecise(d);
                            }
                            if (0 === e1) continue;
                        }
                        const o = c[0] - (.5 + r + (i.wrap << i.zoom)) * (1 << t - i.zoom), h = c[1] - .5 - s, p = i.tileID ? i.tileID : new qu(n, i.wrap, i.zoom, r, s);
                        S.push({
                            tileID: p,
                            distanceSq: o * o + h * h
                        });
                    }
                }
                if (this.fogCullDistSq) {
                    const t = this.fogCullDistSq, i = this.horizonLineFromTop();
                    S = S.filter((r)=>{
                        const n = [
                            0,
                            0,
                            0,
                            1
                        ], o = [
                            cr,
                            cr,
                            0,
                            1
                        ], s = this.calculateFogTileMatrix(r.tileID.toUnwrapped());
                        yu.transformMat4(n, n, s), yu.transformMat4(o, o, s);
                        const a = function(e1, t, i) {
                            let r = 0;
                            for(let i = 0; i < 2; ++i){
                                const n = 0;
                                e1[i] > n && (r += (e1[i] - n) * (e1[i] - n)), t[i] < n && (r += (n - t[i]) * (n - t[i]));
                            }
                            return r;
                        }(yu.min([], n, o), yu.max([], n, o));
                        if (0 === a) return !0;
                        let l = !1;
                        const c = this._elevation;
                        if (c && a > t && 0 !== i) {
                            const t = this.calculateProjMatrix(r.tileID.toUnwrapped());
                            let n;
                            e1.isTerrainDEM || (n = c.getMinMaxForTile(r.tileID)), n || (n = {
                                min: b,
                                max: v
                            });
                            const o = function(e1) {
                                const t = Math.round((e1 + 45 + 360) % 360 / 90) % 4;
                                return E[t];
                            }(this.rotation), s = [
                                o[0] * cr,
                                o[1] * cr,
                                n.max
                            ];
                            Du.transformMat4(s, s, t), l = (1 - s[1]) * this.height * .5 < i;
                        }
                        return a < t || l;
                    });
                }
                return S.sort((e1, t)=>e1.distanceSq - t.distanceSq).map((e1)=>e1.tileID);
            }
            resize(e1, t) {
                this.width = e1, this.height = t, this.pixelsToGLUnits = [
                    2 / e1,
                    -2 / t
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e1) {
                return Math.pow(2, e1);
            }
            scaleZoom(e1) {
                return Math.log(e1) / Math.LN2;
            }
            project(e1) {
                const t = z(e1.lat, -rp, rp), i = this.projection.project(e1.lng, t);
                return new y(i.x * this.worldSize, i.y * this.worldSize);
            }
            unproject(e1) {
                return this.projection.unproject(e1.x / this.worldSize, e1.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            get pointMerc() {
                return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
                return this.pixelsPerMeter / Qd(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(e1, t) {
                let i, r;
                const n = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e1 = this.worldSize;
                    i = (t.x - n.x) / e1, r = (t.y - n.y) / e1;
                } else {
                    const e1 = this.pointCoordinate(t), o = this.pointCoordinate(n);
                    i = e1.x - o.x, r = e1.y - o.y;
                }
                const o = this.locationCoordinate(e1);
                this.setLocation(new lp(o.x - i, o.y - r));
            }
            setLocation(e1) {
                this.center = this.coordinateLocation(e1), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e1) {
                return this.projection.locationPoint(this, e1);
            }
            locationPoint3D(e1) {
                return this.projection.locationPoint(this, e1, !0);
            }
            pointLocation(e1) {
                return this.coordinateLocation(this.pointCoordinate(e1));
            }
            pointLocation3D(e1) {
                return this.coordinateLocation(this.pointCoordinate3D(e1));
            }
            locationCoordinate(e1, t) {
                const i = t ? Qd(t, e1.lat) : void 0, r = this.projection.project(e1.lng, e1.lat);
                return new lp(r.x, r.y, i);
            }
            coordinateLocation(e1) {
                return this.projection.unproject(e1.x, e1.y);
            }
            pointRayIntersection(e1, t) {
                const i = null != t ? t : this._centerAltitude, r = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], n = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                yu.transformMat4(r, r, this.pixelMatrixInverse), yu.transformMat4(n, n, this.pixelMatrixInverse);
                const o = n[3];
                yu.scale(r, r, 1 / r[3]), yu.scale(n, n, 1 / o);
                const s = r[2], a = n[2];
                return {
                    p0: r,
                    p1: n,
                    t: s === a ? 0 : (i - s) / (a - s)
                };
            }
            screenPointToMercatorRay(e1) {
                const t = [
                    e1.x,
                    e1.y,
                    0,
                    1
                ], i = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                return yu.transformMat4(t, t, this.pixelMatrixInverse), yu.transformMat4(i, i, this.pixelMatrixInverse), yu.scale(t, t, 1 / t[3]), yu.scale(i, i, 1 / i[3]), t[2] = Qd(t[2], this._center.lat) * this.worldSize, i[2] = Qd(i[2], this._center.lat) * this.worldSize, yu.scale(t, t, 1 / this.worldSize), yu.scale(i, i, 1 / this.worldSize), new Wu([
                    t[0],
                    t[1],
                    t[2]
                ], Du.normalize([], Du.sub([], i, t)));
            }
            rayIntersectionCoordinate(e1) {
                const { p0: t, p1: i, t: r } = e1, n = Qd(t[2], this._center.lat), o = Qd(i[2], this._center.lat);
                return new lp(Kr(t[0], i[0], r) / this.worldSize, Kr(t[1], i[1], r) / this.worldSize, Kr(n, o, r));
            }
            pointCoordinate(e1, t = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e1.x, e1.y, t);
            }
            pointCoordinate3D(e1) {
                if (!this.elevation) return this.pointCoordinate(e1);
                let t = this.projection.pointCoordinate3D(this, e1.x, e1.y);
                if (t) return new lp(t[0], t[1], t[2]);
                let i = 0, r = this.horizonLineFromTop();
                if (e1.y > r) return this.pointCoordinate(e1);
                const n = .02 * r, o = e1.clone();
                for(let e1 = 0; e1 < 10 && r - i > n; e1++){
                    o.y = Kr(i, r, .66);
                    const e1 = this.projection.pointCoordinate3D(this, o.x, o.y);
                    e1 ? (r = o.y, t = e1) : i = o.y;
                }
                return t ? new lp(t[0], t[1], t[2]) : this.pointCoordinate(e1);
            }
            isPointAboveHorizon(e1) {
                return this.projection.isPointAboveHorizon(this, e1);
            }
            isPointOnSurface(e1) {
                if (e1.y < 0 || e1.y > this.height || e1.x < 0 || e1.x > this.width) return !1;
                if (this.elevation || this.zoom >= id) return !this.isPointAboveHorizon(e1);
                const t = this.pointCoordinate(e1);
                return t.y >= 0 && t.y <= 1;
            }
            _coordinatePoint(e1, t) {
                const i = t && this.elevation ? this.elevation.getAtPointOrZero(e1, this._centerAltitude) : this._centerAltitude, r = [
                    e1.x * this.worldSize,
                    e1.y * this.worldSize,
                    i + e1.toAltitude(),
                    1
                ];
                return yu.transformMat4(r, r, this.pixelMatrix), r[3] > 0 ? new y(r[0] / r[3], r[1] / r[3]) : new y(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
                const { top: e1, left: t } = this._edgeInsets, i = this.height - this._edgeInsets.bottom, r = this.width - this._edgeInsets.right, n = this.pointLocation3D(new y(t, e1)), o = this.pointLocation3D(new y(r, e1)), s = this.pointLocation3D(new y(r, i)), a = this.pointLocation3D(new y(t, i));
                let l = Math.min(n.lng, o.lng, s.lng, a.lng), c = Math.max(n.lng, o.lng, s.lng, a.lng), h = Math.min(n.lat, o.lat, s.lat, a.lat), u = Math.max(n.lat, o.lat, s.lat, a.lat);
                const d = Math.pow(2, -this.zoom) / 16 * 270, p = "globe" === this.projection.name ? 1 : 4, f = (e1, t, i, r, n)=>{
                    const o = (e1 + i) / 2, s = (t + r) / 2, a = new y(o, s), { lng: m, lat: _ } = this.pointLocation3D(a), g = Math.max(0, l - m, h - _, m - c, _ - u);
                    l = Math.min(l, m), c = Math.max(c, m), h = Math.min(h, _), u = Math.max(u, _), (n < p || g > d) && (f(e1, t, o, s, n + 1), f(o, s, i, r, n + 1));
                };
                if (f(t, e1, r, e1, 1), f(r, e1, r, i, 1), f(r, i, t, i, 1), f(t, i, t, e1, 1), "globe" === this.projection.name) {
                    const [e1, t] = function(e1) {
                        const t = Au.identity(new Float64Array(16));
                        Au.multiply(t, e1.pixelMatrix, e1.globeMatrix);
                        const i = [
                            0,
                            ad,
                            0
                        ], r = [
                            0,
                            ld,
                            0
                        ];
                        return Du.transformMat4(i, i, t), Du.transformMat4(r, r, t), [
                            i[0] > 0 && i[0] <= e1.width && i[1] > 0 && i[1] <= e1.height && !Nd(e1, new Wd(e1.center.lat, 90)),
                            r[0] > 0 && r[0] <= e1.width && r[1] > 0 && r[1] <= e1.height && !Nd(e1, new Wd(e1.center.lat, -90))
                        ];
                    }(this);
                    e1 ? (u = 90, c = 180, l = -180) : t && (h = -90, c = 180, l = -180);
                }
                return new sc(new Wd(l, h), new Wd(c, u));
            }
            _getBoundsRectangular(e1, t) {
                const { top: i, left: r } = this._edgeInsets, n = this.height - this._edgeInsets.bottom, o = this.width - this._edgeInsets.right, s = new y(r, i), a = new y(o, i), l = new y(o, n), c = new y(r, n);
                let h = this.pointCoordinate(s, e1), u = this.pointCoordinate(a, e1);
                const d = this.pointCoordinate(l, t), p = this.pointCoordinate(c, t), f = (e1, t)=>(t.y - e1.y) / (t.x - e1.x);
                return h.y > 1 && u.y >= 0 ? h = new lp((1 - p.y) / f(p, h) + p.x, 1) : h.y < 0 && u.y <= 1 && (h = new lp(-p.y / f(p, h) + p.x, 0)), u.y > 1 && h.y >= 0 ? u = new lp((1 - d.y) / f(d, u) + d.x, 1) : u.y < 0 && h.y <= 1 && (u = new lp(-d.y / f(d, u) + d.x, 0)), (new sc).extend(this.coordinateLocation(h)).extend(this.coordinateLocation(u)).extend(this.coordinateLocation(p)).extend(this.coordinateLocation(d));
            }
            _getBoundsRectangularTerrain() {
                const e1 = this.elevation;
                if (!e1.visibleDemTiles.length || e1.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
                const t = e1.visibleDemTiles.reduce((e1, t)=>{
                    if (t.dem) {
                        const i = t.dem.tree;
                        e1.min = Math.min(e1.min, i.minimums[0]), e1.max = Math.max(e1.max, i.maximums[0]);
                    }
                    return e1;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBoundsRectangular(t.min * e1.exaggeration(), t.max * e1.exaggeration());
            }
            getBounds() {
                return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e1 = !0) {
                const t = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) - this.centerOffset.y, i = this.height / 2 - t * (1 - this._horizonShift);
                return e1 ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(e1) {
                this.maxBounds = e1, this.minLat = -rp, this.maxLat = rp, this.minLng = -180, this.maxLng = 180, e1 && (this.minLat = e1.getSouth(), this.maxLat = e1.getNorth(), this.minLng = e1.getWest(), this.maxLng = e1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = Kd(this.minLng) * this.tileSize, this.worldMaxX = Kd(this.maxLng) * this.tileSize, this.worldMinY = Jd(this.maxLat) * this.tileSize, this.worldMaxY = Jd(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e1, t) {
                return this.projection.createTileMatrix(this, t, e1);
            }
            calculateDistanceTileData(e1) {
                const t = e1.key, i = this._distanceTileDataCache;
                if (i[t]) return i[t];
                const r = e1.canonical, n = 1 / this.height, o = this.cameraWorldSize, s = o / this.zoomScale(r.z), a = (r.x + Math.pow(2, r.z) * e1.wrap) * s, l = r.y * s, c = this.point;
                c.x *= o / this.worldSize, c.y *= o / this.worldSize;
                const h = this.angle, u = Math.sin(-h), d = -Math.cos(-h);
                return i[t] = {
                    bearing: [
                        u,
                        d
                    ],
                    center: [
                        (c.x - a) * n,
                        (c.y - l) * n
                    ],
                    scale: s / cr * n
                }, i[t];
            }
            calculateFogTileMatrix(e1) {
                const t = e1.key, i = this._fogTileMatrixCache;
                if (i[t]) return i[t];
                const r = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, e1);
                return Au.multiply(r, this.worldToFogMatrix, r), i[t] = new Float32Array(r), i[t];
            }
            calculateProjMatrix(e1, t = !1, i = !1) {
                const r = e1.key;
                let n;
                if (n = i ? this._expandedProjMatrixCache : t ? this._alignedProjMatrixCache : this._projMatrixCache, n[r]) return n[r];
                const o = this.calculatePosMatrix(e1, this.worldSize);
                let s;
                return s = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : i ? this.expandedFarZProjMatrix : t ? this.alignedProjMatrix : this.projMatrix, Au.multiply(o, s, o), n[r] = new Float32Array(o), n[r];
            }
            calculatePixelsToTileUnitsMatrix(e1) {
                const t = e1.tileID.key, i = this._pixelsToTileUnitsCache;
                if (i[t]) return i[t];
                const r = function(e1, t) {
                    const { scale: i } = e1.tileTransform, r = i * cr / (e1.tileSize * Math.pow(2, t.zoom - e1.tileID.overscaledZ + e1.tileID.canonical.z));
                    return bu.scale(new Float32Array(4), t.inverseAdjustmentMatrix, [
                        r,
                        r
                    ]);
                }(e1, this);
                return i[t] = r, i[t];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
                if ("globe" === this.projection.name) {
                    const e1 = 1 / this.worldSize, t = Au.fromScaling([], [
                        e1,
                        e1,
                        e1
                    ]);
                    return Au.multiply(t, t, this.globeMatrix), t;
                }
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const e1 = this._elevation;
                this._updateCameraState();
                const t = Qd(1, this._center.lat) * this.worldSize, i = this._computeCameraPosition(t), r = this._camera.forward(), n = Qd(1, this._center.lat);
                i[2] /= n, r[2] /= n, Du.normalize(r, r);
                const o = e1.raycast(i, r, e1.exaggeration());
                if (o) {
                    const e1 = Du.scaleAndAdd([], i, r, o), t = new lp(e1[0], e1[1], Qd(e1[2], tp(e1[1]))), s = (t.z + Du.length([
                        t.x - i[0],
                        t.y - i[1],
                        t.z - i[2] * n
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(s), this._centerAltitude = t.toAltitude(), this._center = this.coordinateLocation(t), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCamera(e1 = !1) {
                if (!this._elevation) return;
                const t = this._elevation, i = Qd(1, this._center.lat) * this.worldSize, r = this._computeCameraPosition(i), n = t.getAtPointOrZero(new lp(...r)), o = this.pixelsPerMeter / this.worldSize * n, s = this._minimumHeightOverTerrain(), a = r[2] - o;
                if (a <= s) {
                    if (a < 0 || e1) {
                        const e1 = this.locationCoordinate(this._center, this._centerAltitude), t = [
                            r[0],
                            r[1],
                            e1.z - r[2]
                        ], i = Du.length(t);
                        t[2] -= (s - a) / this._pixelsPerMercatorPixel;
                        const n = Du.length(t);
                        if (0 === n) return;
                        Du.scale(t, t, i / n * this._pixelsPerMercatorPixel), this._camera.position = [
                            r[0],
                            r[1],
                            e1.z * this._pixelsPerMercatorPixel - t[2]
                        ], this._updateStateFromCamera();
                    } else this._isCameraConstrained = !0;
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const e1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || e1) {
                    const t = this.center;
                    return t.lat = z(t.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !e1) && (t.lng = z(t.lng, this.minLng, this.maxLng)), this.center = t, void (this._constraining = !1);
                }
                const t = this._unmodified, { x: i, y: r } = this.point;
                let n = 0, o = i, s = r;
                const a = this.width / 2, l = this.height / 2, c = this.worldMinY * this.scale, h = this.worldMaxY * this.scale;
                if (r - l < c && (s = c + l), r + l > h && (s = h - l), h - c < this.height && (n = Math.max(n, this.height / (h - c)), s = (h + c) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e1 = this.worldMinX * this.scale, t = this.worldMaxX * this.scale, r = this.worldSize / 2 - (e1 + t) / 2;
                    o = (i + r + this.worldSize) % this.worldSize - r, o - a < e1 && (o = e1 + a), o + a > t && (o = t - a), t - e1 < this.width && (n = Math.max(n, this.width / (t - e1)), o = (t + e1) / 2);
                }
                o === i && s === r || (this.center = this.unproject(new y(o, s))), n && (this.zoom += this.scaleZoom(n)), this._constrainCamera(), this._unmodified = t, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e1 = Math.max(0, this.scaleZoom(this.height / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e1 = Math.max(e1, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e1;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const e1 = this.centerOffset, t = "globe" === this.projection.name, i = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = Qd(1, this.center.lat) / Qd(1, 45));
                const r = Qx(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, r), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const n = "meters" === this.projection.zAxisUnit ? i : 1, o = this._camera.getWorldToCamera(this.worldSize, n);
                let s;
                const a = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                if (a[8] = 2 * -e1.x / this.width, a[9] = 2 * e1.y / this.height, this.isOrthographic) {
                    let t = .5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(.5 * this._fov), i = t * this.aspect, r = -i, n = -t;
                    i -= e1.x, r -= e1.x, t += e1.y, n += e1.y, s = this._camera.getCameraToClipOrthographic(r, i, n, t, this._nearZ, this._farZ), ((e1, t, i, r)=>{
                        for(let n = 0; n < 16; n++)e1[n] = bv(t[n], i[n], r);
                    })(s, s, a, wv(this.pitch >= 15 ? 1 : this.pitch / 15));
                } else s = a;
                const l = Au.mul([], a, o);
                let c = Au.mul([], s, o);
                if (this.projection.isReprojectedInTileSpace) {
                    const e1 = this.locationCoordinate(this.center), t = Au.identity([]);
                    Au.translate(t, t, [
                        e1.x * this.worldSize,
                        e1.y * this.worldSize,
                        0
                    ]), Au.multiply(t, t, Kx(this)), Au.translate(t, t, [
                        -e1.x * this.worldSize,
                        -e1.y * this.worldSize,
                        0
                    ]), Au.multiply(c, c, t), Au.multiply(l, l, t), this.inverseAdjustmentMatrix = function(e1) {
                        const t = Kx(e1, !0);
                        return bu.invert([], [
                            t[0],
                            t[1],
                            t[4],
                            t[5]
                        ]);
                    }(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                if (this.mercatorMatrix = Au.scale([], c, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / n,
                    1
                ]), this.projMatrix = c, this.invProjMatrix = Au.invert(new Float64Array(16), this.projMatrix), t) {
                    const t = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
                    t[8] = 2 * -e1.x / this.width, t[9] = 2 * e1.y / this.height, this.expandedFarZProjMatrix = Au.mul([], t, o);
                } else this.expandedFarZProjMatrix = this.projMatrix;
                const h = Au.invert([], s);
                this.frustumCorners = Hu.fromInvProjectionMatrix(h, this.horizonLineFromTop(), this.height), this.cameraFrustum = Qu.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !t);
                const u = new Float32Array(16);
                Au.identity(u), Au.scale(u, u, [
                    1,
                    -1,
                    1
                ]), Au.rotateX(u, u, this._pitch), Au.rotateZ(u, u, this.angle);
                const d = Au.perspective(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
                this.starsProjMatrix = Au.clone(d);
                const p = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                d[8] = 2 * -e1.x / this.width, d[9] = 2 * (e1.y + p) / this.height, this.skyboxMatrix = Au.multiply(u, d, u);
                const f = this.point, m = f.x, _ = f.y, g = this.width % 2 / 2, y = this.height % 2 / 2, x = Math.cos(this.angle), v = Math.sin(this.angle), b = m - Math.round(m) + x * g + v * y, w = _ - Math.round(_) + x * y + v * g, T = new Float64Array(c);
                if (Au.translate(T, T, [
                    b > .5 ? b - 1 : b,
                    w > .5 ? w - 1 : w,
                    0
                ]), this.alignedProjMatrix = T, c = Au.create(), Au.scale(c, c, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), Au.translate(c, c, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = c, c = Au.create(), Au.scale(c, c, [
                    1,
                    -1,
                    1
                ]), Au.translate(c, c, [
                    -1,
                    -1,
                    0
                ]), Au.scale(c, c, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = c, this.pixelMatrix = Au.multiply(new Float64Array(16), this.labelPlaneMatrix, l), this._calcFogMatrices(), this._distanceTileDataCache = {}, c = Au.invert(new Float64Array(16), this.pixelMatrix), !c) throw new Error("failed to invert matrix");
                if (this.pixelMatrixInverse = c, "globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = function(e1) {
                        const { x: t, y: i } = e1.point, { lng: r, lat: n } = e1._center;
                        return zd(t, i, e1.worldSize, r, n);
                    }(this);
                    const e1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = Du.transformMat4(e1, e1, o), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = c;
                this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache = {};
                const e1 = this.cameraWorldSizeForFog, t = this.cameraPixelsPerMeter, i = this._camera.position, r = 1 / this.height / this._pixelsPerMercatorPixel, n = [
                    e1,
                    e1,
                    t
                ];
                Du.scale(n, n, r), Du.scale(i, i, -1), Du.multiply(i, i, n);
                const o = Au.create();
                Au.translate(o, o, i), Au.scale(o, o, n), this.mercatorFogMatrix = o, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(e1, t, r);
            }
            _computeCameraPosition(e1) {
                const t = (e1 = e1 || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), r = this.point, n = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t - e1 / this.worldSize * this._centerAltitude;
                return [
                    r.x / this.worldSize - i[0] * n,
                    r.y / this.worldSize - i[1] * n,
                    e1 / this.worldSize * this._centerAltitude - i[2] * n
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(e1) {
                const t = this._maxCameraBoundsDistance() * Math.cos(this._pitch), i = this._camera.position[2], r = e1[2];
                let n = 1;
                this.projection.wrap && (this.center = this.center.wrap()), r > 0 && (n = Math.min((t - i) / r, 1)), this._camera.position = Du.scaleAndAdd([], this._camera.position, e1, n), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
                const e1 = this._camera.position, t = this._camera.forward(), { pitch: i, bearing: r } = this._camera.getPitchBearing(), n = Qd(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, o = this._mercatorZfromZoom(this._maxZoom) * Math.cos(w(this._maxPitch)), s = Math.max((e1[2] - n) / Math.cos(i), o), a = this._zoomFromMercatorZ(s);
                Du.scaleAndAdd(e1, e1, t, s), this._pitch = z(i, w(this.minPitch), w(this.maxPitch)), this.angle = D(r, -Math.PI, Math.PI), this._setZoom(z(a, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new lp(e1[0], e1[1], e1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e1) {
                return Math.pow(2, e1) * this.tileSize;
            }
            _mercatorZfromZoom(e1) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e1);
            }
            _minimumHeightOverTerrain() {
                const e1 = Math.min((null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom) + 4, this._maxZoom);
                return this._mercatorZfromZoom(e1);
            }
            _zoomFromMercatorZ(e1) {
                return this.scaleZoom(this.cameraToCenterDistance / (e1 * this.tileSize));
            }
            zoomFromMercatorZAdjusted(e1) {
                let t = 0, i = id, r = 0, n = 1 / 0;
                for(; i - t > 1e-6 && i > t;){
                    const o = t + .5 * (i - t), s = this.tileSize * Math.pow(2, o), a = this.getCameraToCenterDistance(this.projection, o, s), l = this.scaleZoom(a / (e1 * this.tileSize)), c = Math.abs(o - l);
                    c < n && (n = c, r = o), o < l ? t = o : i = o;
                }
                return r;
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (H("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(e1, t) {
                const i = Math.min(e1.x, t.x), r = Math.max(e1.x, t.x), n = Math.min(e1.y, t.y), o = Math.max(e1.y, t.y);
                if (n < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const s = [
                    new y(i, n),
                    new y(r, o),
                    new y(i, o),
                    new y(r, n)
                ], a = this.renderWorldCopies ? -3 : 0, l = this.renderWorldCopies ? 4 : 1;
                for (const e1 of s){
                    const t = this.pointRayIntersection(e1);
                    if (t.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t);
                    if (i.x < a || i.y < 0 || i.x > l || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + T(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new y(0, 0), new y(this.width, this.height));
            }
            zoomDeltaToMovement(e1, t) {
                const i = Du.length(Du.sub([], this._camera.position, e1)), r = this._zoomFromMercatorZ(i) + t;
                return i - this._mercatorZfromZoom(r);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const e1 = function([e1, t, i], r) {
                        const n = [
                            e1,
                            t,
                            i,
                            1
                        ];
                        yu.transformMat4(n, n, r);
                        const o = n[3] = Math.max(n[3], 1e-6);
                        return n[0] /= o, n[1] /= o, n[2] /= o, n;
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new y(e1[0], e1[1]);
                }
                {
                    const e1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new y(0, e1));
                }
            }
            getCameraToCenterDistance(e1, t = this.zoom, i = this.worldSize) {
                const r = Qx(e1, t, this.width, this.height, 1024), n = e1.pixelSpaceConversion(this.center.lat, i, r);
                let o = .5 / Math.tan(.5 * this._fov) * this.height * n;
                return this.isOrthographic && (o = bv(1, o, wv(this.pitch >= 15 ? 1 : this.pitch / 15))), o;
            }
            getWorldToCameraMatrix() {
                const e1 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
                return "globe" === this.projection.name && Au.multiply(e1, e1, this.globeMatrix), e1;
            }
            getFrustum(e1) {
                return Qu.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, e1, "meters" === this.projection.zAxisUnit);
            }
            constructor(e1, t, i, r, n, o, s){
                this.tileSize = 512, this._renderWorldCopies = void 0 === n || n, this._minZoom = e1 || 0, this._maxZoom = t || 22, this._minPitch = null == i ? 0 : i, this._maxPitch = null == r ? 60 : r, this.setProjection(o), this.setMaxBounds(s), this.width = 0, this.height = 0, this._center = new Wd(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._unmodified = !0, this._edgeInsets = new Zx, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new Yx, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._horizonShift = .1, this._orthographicProjectionAtLowPitch = !1;
            }
        }
        function Ev(e1, t, i) {
            Au.identity(e1), Au.rotateZ(e1, e1, w(t[2])), Au.rotateX(e1, e1, w(t[0])), Au.rotateY(e1, e1, w(t[1])), Au.scale(e1, e1, i), Au.multiply(e1, e1, [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1
            ]);
        }
        function Mv(e1, t, i, r, n, o, s, a) {
            const l = [
                i[0] - t[0],
                i[1] - t[1],
                0
            ], c = [
                r[0] - t[0],
                r[1] - t[1],
                0
            ];
            if (Du.length(l) < 1e-12 || Du.length(c) < 1e-12) return Iu.identity(e1);
            const h = Du.cross([], l, c);
            Du.normalize(h, h), Du.subtract(c, r, t), l[2] = (o - n) * a, c[2] = (s - n) * a;
            const u = l;
            return Du.cross(u, l, c), Du.normalize(u, u), Iu.rotationTo(e1, h, u);
        }
        function Av(e1, t, i = !1) {
            const r = Dd(t.zoom), n = function(e1, t, i) {
                const r = t.worldSize, n = [
                    e1[12],
                    e1[13],
                    e1[14]
                ], o = tp(n[1] / r), s = ep(n[0] / r), a = Au.identity([]), l = Qd(1, o) * r, c = Qd(1, 0) * r * op(o, t.zoom), h = 1 / Id(r);
                let u = c * h;
                if (i) {
                    const e1 = Qx(t.projection, t.zoom, t.width, t.height, 1024);
                    u = h * t.projection.pixelSpaceConversion(t.center.lat, r, e1);
                }
                const d = wd(o, s);
                Du.add(d, d, Du.scale([], Du.normalize([], d), l * u * n[2]));
                const p = function(e1) {
                    const t = [
                        e1[0],
                        e1[1],
                        e1[2]
                    ];
                    let i = [
                        0,
                        1,
                        0
                    ];
                    const r = Du.cross([], i, t);
                    return Du.cross(i, t, r), 0 === Du.squaredLength(i) && (i = [
                        0,
                        1,
                        0
                    ], Du.cross(r, t, i)), Du.normalize(r, r), Du.normalize(i, i), Du.normalize(t, t), [
                        r[0],
                        r[1],
                        r[2],
                        0,
                        i[0],
                        i[1],
                        i[2],
                        0,
                        t[0],
                        t[1],
                        t[2],
                        0,
                        e1[0],
                        e1[1],
                        e1[2],
                        1
                    ];
                }(d);
                Au.scale(a, a, [
                    u,
                    u,
                    u * l
                ]), Au.translate(a, a, [
                    -n[0],
                    -n[1],
                    -n[2]
                ]);
                const f = Au.multiply([], t.globeMatrix, p);
                return Au.multiply(f, f, a), Au.multiply(f, f, e1), f;
            }(e1, t, i);
            if (r > 0) {
                const i = function(e1, t) {
                    const i = t.worldSize, r = Qd(1, 0) * i * op(t.center.lat, t.zoom) / Id(i), n = Qd(1, t.center.lat) * i, o = Au.identity([]);
                    return Au.rotateY(o, o, w(t.center.lng)), Au.rotateX(o, o, w(t.center.lat)), Au.translate(o, o, [
                        0,
                        0,
                        rd
                    ]), Au.scale(o, o, [
                        r,
                        r,
                        r * n
                    ]), Au.translate(o, o, [
                        t.point.x - .5 * i,
                        t.point.y - .5 * i,
                        0
                    ]), Au.multiply(o, o, e1), Au.multiply(o, t.globeMatrix, o);
                }(e1, t);
                return function(e1, t, i) {
                    const r = (e1, t, i)=>{
                        const r = Du.length(e1), n = Du.length(t), o = md(e1, t, i);
                        return Du.scale(o, o, 1 / Du.length(o) * Kr(r, n, i));
                    }, n = r([
                        e1[0],
                        e1[1],
                        e1[2]
                    ], [
                        t[0],
                        t[1],
                        t[2]
                    ], i), o = r([
                        e1[4],
                        e1[5],
                        e1[6]
                    ], [
                        t[4],
                        t[5],
                        t[6]
                    ], i), s = r([
                        e1[8],
                        e1[9],
                        e1[10]
                    ], [
                        t[8],
                        t[9],
                        t[10]
                    ], i), a = md([
                        e1[12],
                        e1[13],
                        e1[14]
                    ], [
                        t[12],
                        t[13],
                        t[14]
                    ], i);
                    return [
                        n[0],
                        n[1],
                        n[2],
                        0,
                        o[0],
                        o[1],
                        o[2],
                        0,
                        s[0],
                        s[1],
                        s[2],
                        0,
                        a[0],
                        a[1],
                        a[2],
                        1
                    ];
                }(n, i, r);
            }
            return n;
        }
        const Sv = 64, Iv = [
            1,
            1,
            1
        ];
        class Cv {
            _applyTransformations(e1, t) {
                if (Au.multiply(e1.matrix, t, e1.matrix), e1.meshes) for (const t of e1.meshes){
                    const i = ed.applyTransform(t.aabb, e1.matrix);
                    this.aabb.encapsulate(i);
                }
                if (e1.children) for (const t of e1.children)this._applyTransformations(t, e1.matrix);
            }
            computeBoundsAndApplyParent() {
                const e1 = Au.identity([]);
                for (const t of this.nodes)this._applyTransformations(t, e1);
            }
            _positionModelOnTerrain(e1, t) {
                const i = e1.elevation;
                if (!i) return 0;
                const r = ed.projectAabbCorners(this.aabb, this.matrix), n = Qd(1, this.position.lat) * e1.worldSize, o = function(e1, t) {
                    const i = [
                        0,
                        0,
                        1
                    ], r = [
                        {
                            corners: [
                                0,
                                1,
                                3,
                                2
                            ],
                            dotProductWithUp: 0
                        },
                        {
                            corners: [
                                1,
                                5,
                                2,
                                6
                            ],
                            dotProductWithUp: 0
                        },
                        {
                            corners: [
                                0,
                                4,
                                1,
                                5
                            ],
                            dotProductWithUp: 0
                        },
                        {
                            corners: [
                                2,
                                6,
                                3,
                                7
                            ],
                            dotProductWithUp: 0
                        },
                        {
                            corners: [
                                4,
                                7,
                                5,
                                6
                            ],
                            dotProductWithUp: 0
                        },
                        {
                            corners: [
                                0,
                                3,
                                4,
                                7
                            ],
                            dotProductWithUp: 0
                        }
                    ];
                    for (const n of r){
                        const r = e1[n.corners[0]], o = e1[n.corners[1]], s = e1[n.corners[2]], a = [
                            o[0] - r[0],
                            o[1] - r[1],
                            t * (o[2] - r[2])
                        ], l = Du.cross(a, a, [
                            s[0] - r[0],
                            s[1] - r[1],
                            t * (s[2] - r[2])
                        ]);
                        Du.normalize(l, l), n.dotProductWithUp = Du.dot(l, i);
                    }
                    return r.sort((e1, t)=>e1.dotProductWithUp - t.dotProductWithUp), r[0].corners;
                }(r, n), s = r[o[0]], a = r[o[1]], l = r[o[2]], c = r[o[3]], h = i.getAtPointOrZero(new lp(s[0] / e1.worldSize, s[1] / e1.worldSize), 0), u = i.getAtPointOrZero(new lp(a[0] / e1.worldSize, a[1] / e1.worldSize), 0), d = i.getAtPointOrZero(new lp(l[0] / e1.worldSize, l[1] / e1.worldSize), 0), p = i.getAtPointOrZero(new lp(c[0] / e1.worldSize, c[1] / e1.worldSize), 0), f = (h + p) / 2, m = (u + d) / 2;
                return f > m ? u < d ? Mv(t, a, c, s, u, p, h, n) : Mv(t, l, s, c, d, h, p, n) : h < p ? Mv(t, s, a, l, h, u, d, n) : Mv(t, c, l, a, p, d, u, n), Math.max(f, m);
            }
            computeModelMatrix(e1, t, i, r, n, o, s = !1) {
                const a = e1.transform, l = a.zoom, c = a.project(this.position), h = op(this.position.lat, l), u = 1 / h;
                Au.identity(this.matrix), Au.translate(this.matrix, this.matrix, [
                    c.x + r[0] * u,
                    c.y + r[1] * u,
                    r[2]
                ]);
                let d = 1, p = 1;
                const f = a.worldSize;
                if (s) {
                    if ("mercator" === a.projection.name) {
                        let e1 = 0;
                        a.elevation && (e1 = a.elevation.getAtPointOrZero(new lp(c.x / f, c.y / f), 0));
                        const t = yu.transformMat4([], [
                            c.x,
                            c.y,
                            e1,
                            1
                        ], a.projMatrix)[3] / a.cameraToCenterDistance;
                        d = t, p = t * op(a.center.lat, l);
                    } else if ("globe" === a.projection.name) {
                        const e1 = Av(this.matrix, a), t = Au.multiply([], a.projMatrix, e1), i = [
                            0,
                            0,
                            0,
                            1
                        ];
                        yu.transformMat4(i, i, t);
                        const r = i[3] / a.cameraToCenterDistance, n = Dd(l), o = a.projection.pixelsPerMeter(this.position.lat, f) * op(this.position.lat, l), s = a.projection.pixelsPerMeter(a.center.lat, f) * op(a.center.lat, l);
                        d = r / Kr(o, np(a.center.lat), n), p = r * h / o, d *= s, p *= s;
                    }
                } else d = u;
                Au.scale(this.matrix, this.matrix, [
                    d,
                    d,
                    p
                ]);
                const m = [
                    ...this.matrix
                ], _ = this.orientation, g = [];
                if (Ev(g, [
                    _[0] + t[0],
                    _[1] + t[1],
                    _[2] + t[2]
                ], i), Au.multiply(this.matrix, m, g), n && a.elevation) {
                    let e1 = 0;
                    const t = [];
                    if (o && a.elevation) {
                        e1 = this._positionModelOnTerrain(a, t);
                        const i = Au.fromQuat([], t), r = Au.multiply([], i, g);
                        Au.multiply(this.matrix, m, r);
                    } else e1 = a.elevation.getAtPointOrZero(new lp(c.x / f, c.y / f), 0);
                    0 !== e1 && (this.matrix[14] += e1);
                }
            }
            upload(e1) {
                if (!this.uploaded) {
                    for (const t of this.nodes)Dv(t, e1);
                    for (const e1 of this.nodes)Rv(e1);
                    this.uploaded = !0;
                }
            }
            destroy() {
                for (const e1 of this.nodes)Lv(e1);
            }
            constructor(e1, t, i, r){
                this.id = e1, this.position = null != t ? new Wd(t[0], t[1]) : new Wd(0, 0), this.orientation = null != i ? i : [
                    0,
                    0,
                    0
                ], this.nodes = r, this.uploaded = !1, this.aabb = new ed([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]), this.matrix = [];
            }
        }
        function zv(e1, t, i = !1) {
            e1.uploaded || (e1.gfxTexture = new My(t, e1.image, i ? t.gl.R8 : t.gl.RGBA, {
                useMipmap: e1.sampler.minFilter >= t.gl.NEAREST_MIPMAP_NEAREST
            }), e1.uploaded = !0, e1.image = null);
        }
        function Pv(e1, t, i) {
            e1.indexBuffer = t.createIndexBuffer(e1.indexArray, !1, !0), e1.vertexBuffer = t.createVertexBuffer(e1.vertexArray, Fx.members, !1, !0), e1.normalArray && (e1.normalBuffer = t.createVertexBuffer(e1.normalArray, jx.members, !1, !0)), e1.texcoordArray && (e1.texcoordBuffer = t.createVertexBuffer(e1.texcoordArray, Vx.members, !1, !0)), e1.colorArray && (e1.colorBuffer = t.createVertexBuffer(e1.colorArray, (12 === e1.colorArray.bytesPerElement ? Nx : Ux).members, !1, !0)), e1.featureArray && (e1.pbrBuffer = t.createVertexBuffer(e1.featureArray, qx.members, !0)), e1.segments = xl.simpleSegment(0, 0, e1.vertexArray.length, e1.indexArray.length);
            const r = e1.material;
            r.pbrMetallicRoughness.baseColorTexture && zv(r.pbrMetallicRoughness.baseColorTexture, t), r.pbrMetallicRoughness.metallicRoughnessTexture && zv(r.pbrMetallicRoughness.metallicRoughnessTexture, t), r.normalTexture && zv(r.normalTexture, t), r.occlusionTexture && zv(r.occlusionTexture, t, i), r.emissionTexture && zv(r.emissionTexture, t);
        }
        function Dv(e1, t, i) {
            if (e1.meshes) for (const r of e1.meshes)Pv(r, t, i);
            if (e1.children) for (const r of e1.children)Dv(r, t, i);
        }
        function Rv(e1) {
            if (e1.meshes) for (const t of e1.meshes)t.indexArray.destroy(), t.vertexArray.destroy(), t.colorArray && t.colorArray.destroy(), t.normalArray && t.normalArray.destroy(), t.texcoordArray && t.texcoordArray.destroy(), t.featureArray && t.featureArray.destroy();
            if (e1.children) for (const t of e1.children)Rv(t);
        }
        function Lv(e1) {
            if (e1.meshes) for (const i of e1.meshes)i.vertexBuffer && (i.vertexBuffer.destroy(), i.indexBuffer.destroy(), i.normalBuffer && i.normalBuffer.destroy(), i.texcoordBuffer && i.texcoordBuffer.destroy(), i.colorBuffer && i.colorBuffer.destroy(), i.pbrBuffer && i.pbrBuffer.destroy(), i.segments.destroy(), i.material && ((t = i.material).pbrMetallicRoughness.baseColorTexture && t.pbrMetallicRoughness.baseColorTexture.gfxTexture && t.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), t.pbrMetallicRoughness.metallicRoughnessTexture && t.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && t.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), t.normalTexture && t.normalTexture.gfxTexture && t.normalTexture.gfxTexture.destroy(), t.emissionTexture && t.emissionTexture.gfxTexture && t.emissionTexture.gfxTexture.destroy(), t.occlusionTexture && t.occlusionTexture.gfxTexture && t.occlusionTexture.gfxTexture.destroy()));
            var t;
            if (e1.children) for (const t of e1.children)Lv(t);
        }
        class kv {
            constructor(e1, t){
                this.feature = e1, this.instancedDataOffset = t, this.instancedDataCount = 0, this.rotation = [
                    0,
                    0,
                    0
                ], this.scale = [
                    1,
                    1,
                    1
                ], this.translation = [
                    0,
                    0,
                    0
                ];
            }
        }
        class Ov {
            constructor(){
                this.instancedDataArray = new rl, this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
            }
        }
        class Bv {
            populate(e1, t, i, r) {
                this.tileToMeter = ap(i);
                const n = this.layers[0]._featureFilter.needGeometry;
                this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
                for (const { feature: o, id: s, index: a, sourceLayerIndex: l } of e1){
                    const e1 = gp(o, n);
                    if (!this.layers[0]._featureFilter.filter(new oa(this.zoom), e1, i)) continue;
                    const c = {
                        id: s,
                        sourceLayerIndex: l,
                        index: a,
                        geometry: n ? e1.geometry : _p(o, i, r),
                        properties: o.properties,
                        type: o.type,
                        patterns: {}
                    }, h = this.addFeature(c, c.geometry, e1);
                    h && t.featureIndex.insert(o, c.geometry, a, l, this.index, this.instancesPerModel[h].instancedDataArray.length);
                }
                this.lookup = null;
            }
            update(e1, t, i, r) {
                for(const t in this.instancesPerModel){
                    const i = this.instancesPerModel[t];
                    for(const t in e1)i.idToFeaturesIndex.hasOwnProperty(t) && this.evaluate(i.features[i.idToFeaturesIndex[t]], e1[t], i, !0);
                }
                this.maxHeight = 0;
            }
            updateZoomBasedPaintProperties() {
                if (!this.hasZoomDependentProperties) return !1;
                let e1 = !1;
                for(const t in this.instancesPerModel){
                    const i = this.instancesPerModel[t];
                    for (const t of i.features){
                        const r = this.layers[0], n = t.feature, o = this.canonical, s = r.paint.get("model-rotation").evaluate(n, {}, o), a = r.paint.get("model-scale").evaluate(n, {}, o), l = r.paint.get("model-translation").evaluate(n, {}, o);
                        Du.exactEquals(t.rotation, s) && Du.exactEquals(t.scale, a) && Du.exactEquals(t.translation, l) || (this.evaluate(t, t.featureStates, i, !0), e1 = !0);
                    }
                }
                return e1;
            }
            isEmpty() {
                for(const e1 in this.instancesPerModel)if (0 !== this.instancesPerModel[e1].instancedDataArray.length) return !1;
                return !0;
            }
            uploadPending() {
                return !this.uploaded;
            }
            upload(e1) {
                if (!this.uploaded) for(const t in this.instancesPerModel){
                    const i = this.instancesPerModel[t];
                    i.instancedDataArray.length < 0 || 0 === i.instancedDataArray.length || (i.instancedDataBuffer ? i.instancedDataBuffer.updateData(i.instancedDataArray) : i.instancedDataBuffer = e1.createVertexBuffer(i.instancedDataArray, Gx.members, !0, void 0, this.instanceCount));
                }
                this.uploaded = !0;
            }
            destroy() {
                for(const e1 in this.instancesPerModel){
                    const t = this.instancesPerModel[e1];
                    0 !== t.instancedDataArray.length && t.instancedDataBuffer && t.instancedDataBuffer.destroy();
                }
            }
            addFeature(e1, t, i) {
                const r = this.layers[0], n = r.layout.get("model-id").evaluate(i, {}, this.canonical);
                if (!n) return H(`modelId is not evaluated for layer ${r.id} and it is not going to get rendered.`), n;
                this.instancesPerModel[n] || (this.instancesPerModel[n] = new Ov);
                const o = this.instancesPerModel[n], s = o.instancedDataArray, a = new kv(i, s.length);
                for (const e1 of t)for (const t of e1){
                    if (t.x < 0 || t.x >= cr || t.y < 0 || t.y >= cr) continue;
                    const e1 = (this.lookupDim - 1) / cr, i = this.lookupDim * (t.y * e1 | 0) + t.x * e1 | 0;
                    if (this.lookup) {
                        if (0 !== this.lookup[i]) continue;
                        this.lookup[i] = 1;
                    }
                    this.instanceCount++;
                    const r = s.length;
                    s.resize(r + 1), o.instancesEvaluatedElevation.push(0), s.float32[16 * r] = t.x, s.float32[16 * r + 1] = t.y;
                }
                return a.instancedDataCount = o.instancedDataArray.length - a.instancedDataOffset, a.instancedDataCount > 0 && (e1.id && (o.idToFeaturesIndex[e1.id] = o.features.length), o.features.push(a), this.evaluate(a, {}, o, !1)), n;
            }
            evaluate(e1, t, i, r) {
                const n = this.layers[0], o = e1.feature, s = this.canonical, a = e1.rotation = n.paint.get("model-rotation").evaluate(o, t, s), l = e1.scale = n.paint.get("model-scale").evaluate(o, t, s), c = e1.translation = n.paint.get("model-translation").evaluate(o, t, s), h = n.paint.get("model-color").evaluate(o, t, s);
                h.a = n.paint.get("model-color-mix-intensity").evaluate(o, t, s);
                const u = [];
                this.maxVerticalOffset < c[2] && (this.maxVerticalOffset = c[2]), this.maxScale = Math.max(Math.max(this.maxScale, l[0]), Math.max(l[1], l[2])), Ev(u, a, l);
                const d = Math.round(100 * h.a) + h.b / 1.05;
                for(let t = 0; t < e1.instancedDataCount; ++t){
                    const n = e1.instancedDataOffset + t, o = 16 * n, a = i.instancedDataArray.float32;
                    let l = 0;
                    r && (l = a[o + 6] - i.instancesEvaluatedElevation[n]);
                    const p = 0 | a[o + 1];
                    a[o] = (0 | a[o]) + h.r / 1.05, a[o + 1] = p + h.g / 1.05, a[o + 2] = d, a[o + 3] = 1 / (s.z > 10 ? this.tileToMeter : ap(s, p)), a[o + 4] = c[0], a[o + 5] = c[1], a[o + 6] = c[2] + l, a[o + 7] = u[0], a[o + 8] = u[1], a[o + 9] = u[2], a[o + 10] = u[4], a[o + 11] = u[5], a[o + 12] = u[6], a[o + 13] = u[8], a[o + 14] = u[9], a[o + 15] = u[10], i.instancesEvaluatedElevation[n] = c[2];
                }
            }
            constructor(e1){
                this.zoom = e1.zoom, this.canonical = e1.canonical, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.projection = e1.projection, this.index = e1.index, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = {
                    id: null,
                    timestamp: 0
                };
            }
        }
        Rs(Bv, "ModelBucket", {
            omit: [
                "layers"
            ]
        }), Rs(Ov, "PerModelAttributes"), Rs(kv, "ModelFeature");
        const Fv = new ga({
            visibility: new fa(Pt.layout_model.visibility),
            "model-id": new ma(Pt.layout_model["model-id"])
        });
        var Nv = {
            paint: new ga({
                "model-opacity": new fa(Pt.paint_model["model-opacity"]),
                "model-rotation": new ma(Pt.paint_model["model-rotation"]),
                "model-scale": new ma(Pt.paint_model["model-scale"]),
                "model-translation": new ma(Pt.paint_model["model-translation"]),
                "model-color": new ma(Pt.paint_model["model-color"]),
                "model-color-mix-intensity": new ma(Pt.paint_model["model-color-mix-intensity"]),
                "model-type": new fa(Pt.paint_model["model-type"]),
                "model-cast-shadows": new fa(Pt.paint_model["model-cast-shadows"]),
                "model-receive-shadows": new fa(Pt.paint_model["model-receive-shadows"]),
                "model-ambient-occlusion-intensity": new fa(Pt.paint_model["model-ambient-occlusion-intensity"]),
                "model-emissive-strength": new ma(Pt.paint_model["model-emissive-strength"]),
                "model-roughness": new ma(Pt.paint_model["model-roughness"]),
                "model-height-based-emissive-strength-multiplier": new ma(Pt.paint_model["model-height-based-emissive-strength-multiplier"]),
                "model-cutoff-fade-range": new fa(Pt.paint_model["model-cutoff-fade-range"])
            }),
            layout: Fv
        };
        const Uv = new Float32Array(262144), Vv = new Uint8Array(262144);
        function jv(e1) {
            let t = 0;
            if (e1.meshes) for (const i of e1.meshes)t = Math.max(t, i.aabb.max[2]);
            if (e1.children) for (const i of e1.children)t = Math.max(t, jv(i));
            return t;
        }
        const Gv = [
            "",
            "wall",
            "door",
            "roof",
            "window",
            "lamp",
            "logo"
        ];
        class qv {
            constructor(e1){
                this.node = e1, this.evaluatedRMEA = [
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        .4,
                        1,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ]
                ], this.hiddenByReplacement = !1, this.evaluatedScale = [
                    1,
                    1,
                    1
                ], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.feature = {
                    type: "Point",
                    id: e1.id,
                    geometry: [],
                    properties: {
                        height: jv(e1)
                    }
                };
            }
        }
        class Zv {
            update() {
                console.log("Update 3D model bucket");
            }
            populate() {
                console.log("populate 3D model bucket");
            }
            uploadPending() {
                return !this.uploaded || this.needsUpload;
            }
            upload(e1) {
                if (!this.needsUpload) return;
                const t = this.getNodesInfo();
                for (const i of t){
                    const t = i.node;
                    this.uploaded ? this.updatePbrBuffer(t) : Dv(t, e1, !0);
                }
                for (const e1 of t)Rv(e1.node);
                this.uploaded = !0, this.needsUpload = !1;
            }
            updatePbrBuffer(e1) {
                let t = !1;
                if (!e1.meshes) return t;
                for (const i of e1.meshes)i.pbrBuffer && (i.pbrBuffer.updateData(i.featureArray), t = !0);
                return t;
            }
            needsReEvaluation(e1, t, i) {
                const r = e1.transform.projectionOptions, n = e1.style.getBrightness(), o = this.brightness !== n;
                return !!(!this.uploaded || this.dirty || r.name !== this.projection.name || $v(i.paint.get("model-color").value, o) || $v(i.paint.get("model-color-mix-intensity").value, o) || $v(i.paint.get("model-roughness").value, o) || $v(i.paint.get("model-emissive-strength").value, o) || $v(i.paint.get("model-height-based-emissive-strength-multiplier").value, o)) && (this.projection = r, this.brightness = n, !0);
            }
            evaluateScale(e1, t) {
                if (e1.transform.zoom === this.zoom) return;
                this.zoom = e1.transform.zoom;
                const i = this.getNodesInfo(), r = this.id.canonical;
                for (const e1 of i){
                    const i = e1.feature;
                    e1.evaluatedScale = t.paint.get("model-scale").evaluate(i, {}, r);
                }
            }
            evaluate(e1) {
                const t = this.getNodesInfo();
                for (const i of t){
                    if (!i.node.meshes) continue;
                    const t = i.feature, r = i.node.meshes && i.node.meshes[0].featureData, n = i.evaluatedColor[2], o = i.evaluatedRMEA[2], s = this.id.canonical;
                    if (i.hasTranslucentParts = !1, r) {
                        for(let r = 0; r < Gv.length; r++){
                            const n = Gv[r];
                            n.length && (t.properties.part = n);
                            const o = e1.paint.get("model-color").evaluate(t, {}, s), a = e1.paint.get("model-color-mix-intensity").evaluate(t, {}, s);
                            i.evaluatedColor[r] = [
                                o.r,
                                o.g,
                                o.b,
                                a
                            ], i.evaluatedRMEA[r][0] = e1.paint.get("model-roughness").evaluate(t, {}, s), i.evaluatedRMEA[r][2] = e1.paint.get("model-emissive-strength").evaluate(t, {}, s), i.evaluatedRMEA[r][3] = o.a, i.emissionHeightBasedParams[r] = e1.paint.get("model-height-based-emissive-strength-multiplier").evaluate(t, {}, s), !i.hasTranslucentParts && o.a < 1 && (i.hasTranslucentParts = !0);
                        }
                        delete t.properties.part, Hv(i, n !== i.evaluatedColor[2] || o !== i.evaluatedRMEA[2]);
                    }
                    i.evaluatedScale = e1.paint.get("model-scale").evaluate(t, {}, s), this.updatePbrBuffer(i.node) || (this.needsUpload = !0);
                }
                this.dirty = !1;
            }
            elevationUpdate(e1, t, i, r) {
                const n = e1.findDEMTileFor(i);
                if (n && (n.tileID.canonical !== this.terrainTile || t !== this.terrainExaggeration)) {
                    if (n.dem && n.tileID.overscaledZ !== this.elevationReadFromZ) {
                        this.elevationReadFromZ = n.tileID.overscaledZ;
                        const t = Jm.create(e1, i, n);
                        if (!t) return;
                        4 & this.modelTraits && this.updateDEM(e1, t, i, r);
                        for (const e1 of this.getNodesInfo()){
                            const i = e1.node;
                            if (!i.footprint || !i.footprint.vertices || !i.footprint.vertices.length) continue;
                            const r = i.footprint.vertices;
                            let n = t.getElevationAt(r[0].x, r[0].y, !0, !0);
                            for(let e1 = 1; e1 < r.length; e1++)n = Math.min(n, t.getElevationAt(r[e1].x, r[e1].y, !0, !0));
                            i.elevation = n;
                        }
                    }
                    this.terrainTile = n.tileID.canonical, this.terrainExaggeration = t;
                }
            }
            updateDEM(e1, t, i, r) {
                let n = t._dem._modifiedForSources[r];
                if (void 0 === n && (t._dem._modifiedForSources[r] = [], n = t._dem._modifiedForSources[r]), n.includes(i.canonical)) return;
                const o = t._dem.dim;
                n.push(i.canonical);
                let s = !1;
                for (const e1 of this.getNodesInfo()){
                    const i = e1.node;
                    if (!i.footprint || !i.footprint.grid) continue;
                    const r = i.footprint.grid, n = t.tileCoordToPixel(r.min.x, r.min.y), a = t.tileCoordToPixel(r.max.x, r.max.y), l = Math.min(Math.min(o - a.y, n.x), Math.min(n.y, o - a.x));
                    if (l < 0) continue;
                    const c = z(l, 2, 5);
                    let h = Math.max(0, n.x - c), u = Math.max(0, n.y - c), d = Math.min(a.x + c, o - 1), p = Math.min(a.y + c, o - 1);
                    for(let e1 = u; e1 <= p; ++e1)for(let t = h; t <= d; ++t)Vv[e1 * o + t] = 255;
                    let f = 0, m = 0;
                    for(let e1 = 0; e1 < r.cellsY; ++e1)for(let i = 0; i < r.cellsX; ++i){
                        if (!r.cells[e1 * r.cellsX + i]) continue;
                        const n = t.tileCoordToPixel(r.min.x + i / r.xScale, r.min.y + e1 / r.yScale), s = t.tileCoordToPixel(r.min.x + (i + 1) / r.xScale, r.min.y + (e1 + 1) / r.yScale);
                        for(let e1 = n.y; e1 <= Math.min(s.y + 1, o - 1); ++e1)for(let i = n.x; i <= Math.min(s.x + 1, o - 1); ++i)255 === Vv[e1 * o + i] && (Vv[e1 * o + i] = 0, f += t.getElevationAtPixel(i, e1), m++);
                    }
                    const _ = f / m;
                    h = Math.max(1, n.x - c), u = Math.max(1, n.y - c), d = Math.min(a.x + c, o - 2), p = Math.min(a.y + c, o - 2), s = !0;
                    for(let e1 = u; e1 <= p; ++e1)for(let i = h; i <= d; ++i)0 === Vv[e1 * o + i] && (Uv[e1 * o + i] = t._dem.set(i, e1, _));
                    for(let e1 = 1; e1 < c; ++e1){
                        h = Math.max(1, n.x - e1), u = Math.max(1, n.y - e1), d = Math.min(a.x + e1, o - 2), p = Math.min(a.y + e1, o - 2);
                        for(let i = u; i <= p; ++i)for(let r = h; r <= d; ++r){
                            const n = i * o + r;
                            if (255 === Vv[n]) {
                                let s = 0, a = 0, l = -1, h = -1;
                                for(let t = -1; t <= 1; ++t)for(let n = -1; n <= 1; ++n){
                                    const c = (i + t) * o + r + n;
                                    if (Vv[c] >= e1) continue;
                                    const u = Uv[c], d = Math.abs(u);
                                    d > a && (s = u, a = d, l = n, h = t);
                                }
                                if (a > .1) {
                                    const o = 1 - (e1 + .5 * Math.abs(l * h)) / c;
                                    let a = t._dem.get(r, i) + s * o;
                                    const u = t._dem.get(r + l, i + h), d = t._dem.get(r - l, i - h, !0);
                                    (a - u) * (a - d) > 0 && (a = (u + d) / 2), Uv[n] = t._dem.set(r, i, a), Vv[n] = e1;
                                }
                            }
                        }
                    }
                }
                s && (t._demTile.needsDEMTextureUpload = !0, t._dem._timestamp = dt.now());
            }
            getNodesInfo() {
                if (!this.nodesInfo) {
                    this.nodesInfo = [];
                    for (const e1 of this.nodes)this.nodesInfo.push(new qv(e1));
                    this.freeNodes();
                }
                return this.nodesInfo;
            }
            freeNodes() {
                if (this.nodes) {
                    for (const e1 of this.nodes)Lv(e1);
                    this.nodes.splice(0, this.nodes.length);
                }
            }
            destroy() {
                this.freeNodes();
                const e1 = this.getNodesInfo();
                for (const t of e1)Rv(t.node), Lv(t.node);
            }
            isEmpty() {
                return !this.nodes.length;
            }
            updateReplacement(e1, t) {
                if (t.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t.updateTime;
                const i = t.getReplacementRegionsForTile(e1.toUnwrapped()), r = this.getNodesInfo();
                for(let e1 = 0; e1 < this.nodesInfo.length; e1++){
                    const t = r[e1].node;
                    r[e1].hiddenByReplacement = !!t.footprint && !i.find((e1)=>e1.footprint === t.footprint);
                }
            }
            getHeightAtTileCoord(e1, t) {
                const i = this.getNodesInfo(), r = [];
                for(let n = 0; n < this.nodesInfo.length; n++){
                    const o = i[n], s = o.node.meshes[0];
                    if (e1 < s.aabb.min[0] || t < s.aabb.min[1] || e1 > s.aabb.max[0] || t > s.aabb.max[1]) continue;
                    const a = (e1 - s.aabb.min[0]) / (s.aabb.max[0] - s.aabb.min[0]) * Sv | 0, l = Math.min(63, (t - s.aabb.min[1]) / (s.aabb.max[1] - s.aabb.min[1]) * Sv | 0) * Sv + Math.min(63, a);
                    if (!(s.heightmap[l] < 0 && o.node.footprint)) {
                        if (o.hiddenByReplacement) return;
                        return {
                            height: s.heightmap[l],
                            maxHeight: o.feature.properties.height,
                            hidden: !1,
                            verticalScale: o.evaluatedScale[2]
                        };
                    }
                    if (o.node.footprint.grid.query(new y(e1, t), new y(e1, t), r), r.length > 0) return {
                        height: void 0,
                        maxHeight: o.feature.properties.height,
                        hidden: o.hiddenByReplacement,
                        verticalScale: o.evaluatedScale[2]
                    };
                }
            }
            constructor(e1, t, i, r){
                this.nodes = e1, this.id = t, this.modelTraits |= 1, this.uploaded = !1, this.hasPattern = !1, i && (this.modelTraits |= 4), this.zoom = -1, this.terrainExaggeration = 1, this.projection = {
                    name: "mercator"
                }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = r, this.dirty = !0, this.needsUpload = !1;
            }
        }
        function $v(e1, t) {
            return !e1.isLightConstant && t;
        }
        function Wv(e1, t, i, r, n, o, s, a) {
            let l = (61440 & t | (61440 & t) >> 4) >> 8, c = (3840 & t | (3840 & t) >> 4) >> 4, h = 240 & t | (240 & t) >> 4;
            i[3] > 0 && (l = Kr(l, 255 * i[0], i[3]), c = Kr(c, 255 * i[1], i[3]), h = Kr(h, 255 * i[2], i[3]));
            const u = l << 8 | c, d = h << 8 | Math.floor(255 * r[3]), p = function(e1) {
                const t = z(e1, 0, 2);
                return Math.min(Math.round(.5 * t * 255), 255);
            }(r[2]) << 8 | 15 * r[0] << 4 | 15 * r[1], f = z(n[0], 0, 1), m = z(n[1], 0, 1), _ = z(n[2], 0, 1), g = z(n[3], 0, 1);
            let y, x, v, b;
            if (f !== m && s !== o && m !== f) {
                const e1 = s - o;
                x = 1 / (e1 * (m - f)), v = -(o + e1 * f) / (e1 * (m - f));
                const t = z(n[4], -1, 1);
                b = Math.pow(10, t), y = 255 * _ << 8 | 255 * g;
            } else y = 65535, x = 0, v = 1, b = 1;
            if (e1.emplaceBack(u, d, p, y, x, v, b), a) {
                const e1 = a.length;
                a.clear();
                for(let t = 0; t < e1; t++)a.emplaceBack(u, d, p, y, x, v, b);
            }
        }
        function Hv(e1, t) {
            const i = e1.node;
            let r = 0;
            for (const n of i.meshes){
                if (i.lights && i.lightMeshIndex === r) continue;
                if (!n.featureData) continue;
                n.featureArray = new nl, n.featureArray.reserve(n.featureData.length);
                let o = t;
                for (const t of n.featureData){
                    let r;
                    const s = 65535 & t, a = (15 & s) < 8 ? 15 & s : 0, l = t >> 16 & 65535, c = e1.evaluatedRMEA[a], h = e1.evaluatedColor[a], u = e1.emissionHeightBasedParams[a];
                    if (o && 2 === a && i.lights && (r = new nl, r.resize(10 * i.lights.length)), Wv(n.featureArray, l, h, c, u, n.aabb.min[2], n.aabb.max[2], r), r && o) {
                        o = !1;
                        const e1 = i.meshes[i.lightMeshIndex];
                        e1.featureArray = r, e1.featureArray._trim();
                    }
                }
                n.featureArray._trim(), r++;
            }
        }
        Rs(Zv, "Tiled3dModelBucket", {
            omit: [
                "layers"
            ]
        }), Rs(qv, "Tiled3dModelFeature");
        class Xv {
            clear() {
                this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
            }
            get updateTime() {
                return this._updateTime;
            }
            getReplacementRegionsForTile(e1) {
                const t = Qv(new y(0, 0), new y(cr, cr), e1), i = [];
                for (const r of this._activeRegions){
                    if (r.hiddenByOverlap) continue;
                    if (!Jv(t, r)) continue;
                    const n = eb(r.min, r.max, e1);
                    i.push({
                        min: n.min,
                        max: n.max,
                        sourceId: this._sourceIds[r.priority],
                        footprint: r.footprint,
                        footprintTileId: r.tileId
                    });
                }
                return i;
            }
            setSources(e1) {
                this._setSources(e1.map((e1)=>({
                        getSourceId: ()=>e1.cache.id,
                        getFootprints: ()=>{
                            const t = [];
                            for (const i of e1.cache.getVisibleCoordinates()){
                                const r = e1.cache.getTile(i).buckets[e1.layer];
                                if (r) for (const e1 of r.getNodesInfo()){
                                    const r = e1.node;
                                    r.footprint && t.push({
                                        footprint: r.footprint,
                                        id: i.toUnwrapped()
                                    });
                                }
                            }
                            return t;
                        }
                    })));
            }
            _addSource(e1) {
                const t = e1.getFootprints();
                if (0 !== t.length) {
                    for (const e1 of t){
                        if (!e1.footprint) continue;
                        const t = Qv(e1.footprint.min, e1.footprint.max, e1.id);
                        this._activeRegions.push({
                            min: t.min,
                            max: t.max,
                            hiddenByOverlap: !1,
                            priority: this._sourceIds.length,
                            tileId: e1.id,
                            footprint: e1.footprint
                        });
                    }
                    this._sourceIds.push(e1.getSourceId());
                }
            }
            _computeReplacement() {
                this._activeRegions.sort((e1, t)=>e1.priority - t.priority || Yv(e1.min, t.min) || Yv(e1.max, t.max));
                let e1 = this._activeRegions.length !== this._prevRegions.length;
                if (!e1) {
                    let t = 0, i = 0;
                    for(; !e1 && t !== this._activeRegions.length;){
                        const r = this._activeRegions[t], n = this._prevRegions[i];
                        e1 = r.priority !== n.priority || !Kv(r, n), ++t, ++i;
                    }
                }
                if (e1) {
                    ++this._updateTime;
                    const e1 = (e1)=>{
                        const t = this._activeRegions;
                        if (e1 >= t.length) return e1;
                        const i = t[e1].priority;
                        for(; e1 < t.length && t[e1].priority === i;)++e1;
                        return e1;
                    };
                    if (this._sourceIds.length > 1) {
                        let t = 0, i = e1(t);
                        for(; t !== i;){
                            let r = t;
                            const n = t;
                            for(; r !== i;){
                                const e1 = this._activeRegions[r];
                                e1.hiddenByOverlap = !1;
                                for(let t = 0; t < n; t++){
                                    const i = this._activeRegions[t];
                                    if (!i.hiddenByOverlap && Jv(e1, i) && (e1.hiddenByOverlap = ib(e1.footprint, e1.tileId, i.footprint, i.tileId), e1.hiddenByOverlap)) break;
                                }
                                ++r;
                            }
                            t = i, i = e1(t);
                        }
                    }
                }
            }
            _setSources(e1) {
                [this._prevRegions, this._activeRegions] = [
                    this._activeRegions,
                    []
                ], this._sourceIds = [];
                for(let t = e1.length - 1; t >= 0; t--)this._addSource(e1[t]);
                this._computeReplacement();
            }
            constructor(){
                this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [];
            }
        }
        function Yv(e1, t) {
            return e1.x - t.x || e1.y - t.y;
        }
        function Kv(e1, t) {
            return 0 === Yv(e1.min, t.min) && 0 === Yv(e1.max, t.max);
        }
        function Jv(e1, t) {
            return !(e1.min.x > t.max.x || e1.max.x < t.min.x || e1.min.y > t.max.y || e1.max.y < t.min.y);
        }
        function Qv(e1, t, i) {
            const r = 1 / cr, n = 1 / (1 << i.canonical.z), o = (t.x * r + i.canonical.x) * n + i.wrap, s = (t.y * r + i.canonical.y) * n;
            return {
                min: new y((e1.x * r + i.canonical.x) * n + i.wrap, (e1.y * r + i.canonical.y) * n),
                max: new y(o, s)
            };
        }
        function eb(e1, t, i) {
            const r = 1 << i.canonical.z, n = ((t.x - i.wrap) * r - i.canonical.x) * cr, o = (t.y * r - i.canonical.y) * cr;
            return {
                min: new y(((e1.x - i.wrap) * r - i.canonical.x) * cr, (e1.y * r - i.canonical.y) * cr),
                max: new y(n, o)
            };
        }
        function tb(e1, t, i, r, n, o, s) {
            const a = e1.indices, l = e1.vertices, c = [];
            for(let h = r; h < r + n; h += 3){
                const r = t[i[h + 0] + o], n = t[i[h + 1] + o], u = t[i[h + 2] + o], d = Math.min(r.x, n.x, u.x), p = Math.max(r.x, n.x, u.x), f = Math.min(r.y, n.y, u.y), m = Math.max(r.y, n.y, u.y);
                c.length = 0, e1.grid.query(new y(d, f), new y(p, m), c);
                for(let e1 = 0; e1 < c.length; e1++){
                    const t = c[e1];
                    if (Lp(l[a[3 * t + 0]], l[a[3 * t + 1]], l[a[3 * t + 2]], r, n, u, s)) return !0;
                }
            }
            return !1;
        }
        function ib(e1, t, i, r) {
            if (!e1 || !i) return !1;
            let n = e1.vertices;
            if (!t.canonical.equals(r.canonical) || t.wrap !== r.wrap) {
                if (i.vertices.length < e1.vertices.length) return ib(i, r, e1, t);
                const o = t.canonical, s = r.canonical, a = Math.pow(2, s.z - o.z);
                n = e1.vertices.map((e1)=>new y(e1.x * o.x * cr * a - s.x * cr, e1.y * o.y * cr * a - s.y * cr));
            }
            return tb(i, n, e1.indices, 0, e1.indices.length, 0, 0);
        }
        const rb = hm.types, nb = [
            "fill-extrusion-base",
            "fill-extrusion-height",
            "fill-extrusion-color",
            "fill-extrusion-pattern",
            "fill-extrusion-flood-light-wall-radius"
        ], ob = [
            "fill-extrusion-flood-light-ground-radius"
        ], sb = Math.pow(2, 13), ab = Math.pow(2, 15) - 1, lb = new y(0, 1), cb = 2147483648;
        function hb(e1, t, i, r, n, o, s, a) {
            e1.emplaceBack((t << 1) + s, (i << 1) + o, (Math.floor(r * sb) << 1) + n, Math.round(a));
        }
        function ub(e1, t, i, r, n, o) {
            e1.emplaceBack(t.x, t.y, (i.x << 1) + r, (i.y << 1) + n, o);
        }
        function db(e1, t, i) {
            const r = 16384;
            e1.emplaceBack(t.x, t.y, t.z, i[0] * r, i[1] * r, i[2] * r);
        }
        class pb {
            constructor(){
                this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
            }
        }
        class fb {
            span() {
                return new y(this.max.x - this.min.x, this.max.y - this.min.y);
            }
            constructor(){
                this.centroidXY = new y(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new y(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new y(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0;
            }
        }
        class mb {
            startRing(e1, t) {
                e1.min.x === Number.MAX_VALUE && (e1.min.x = e1.max.x = t.x, e1.min.y = e1.max.y = t.y);
            }
            appendEdge(e1, t, i) {
                this.accCount++, this.acc._add(t);
                let r = !!this.borders;
                t.x < e1.min.x ? (e1.min.x = t.x, r = !0) : t.x > e1.max.x && (e1.max.x = t.x, r = !0), t.y < e1.min.y ? (e1.min.y = t.y, r = !0) : t.y > e1.max.y && (e1.max.y = t.y, r = !0), ((0 === t.x || t.x === cr) && t.x === i.x) != ((0 === t.y || t.y === cr) && t.y === i.y) && this.processBorderOverlap(t, i), r && this.checkBorderIntersection(t, i);
            }
            checkBorderIntersection(e1, t) {
                t.x < 0 != e1.x < 0 && this.addBorderIntersection(0, Kr(t.y, e1.y, (0 - t.x) / (e1.x - t.x))), t.x > cr != e1.x > cr && this.addBorderIntersection(1, Kr(t.y, e1.y, (cr - t.x) / (e1.x - t.x))), t.y < 0 != e1.y < 0 && this.addBorderIntersection(2, Kr(t.x, e1.x, (0 - t.y) / (e1.y - t.y))), t.y > cr != e1.y > cr && this.addBorderIntersection(3, Kr(t.x, e1.x, (cr - t.y) / (e1.y - t.y)));
            }
            addBorderIntersection(e1, t) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const i = this.borders[e1];
                t < i[0] && (i[0] = t), t > i[1] && (i[1] = t);
            }
            processBorderOverlap(e1, t) {
                if (e1.x === t.x) {
                    if (e1.y === t.y) return;
                    const i = 0 === e1.x ? 0 : 1;
                    this.addBorderIntersection(i, t.y), this.addBorderIntersection(i, e1.y);
                } else {
                    const i = 0 === e1.y ? 2 : 3;
                    this.addBorderIntersection(i, t.x), this.addBorderIntersection(i, e1.x);
                }
            }
            centroid() {
                return 0 === this.accCount ? new y(0, 0) : new y(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
            }
            intersectsCount() {
                return this.borders ? this.borders.reduce((e1, t)=>e1 + +(t[0] !== Number.MAX_VALUE), 0) : 0;
            }
            constructor(){
                this.acc = new y(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
            }
        }
        function _b(e1, t) {
            const i = e1.add(t)._unit(), r = z(e1.x * i.x + e1.y * i.y, -1, 1);
            var n, o, s;
            return n = Math.acos(r), Math.min(4, Math.max(-4, Math.tan(n))) / 4 * ab * ((o = e1).x * (s = t).y - o.y * s.x < 0 ? -1 : 1);
        }
        const gb = [
            (e1)=>e1.x < 0,
            (e1)=>e1.x > cr,
            (e1)=>e1.y < 0,
            (e1)=>e1.y > cr
        ];
        function yb(e1, t, i, r) {
            const n = [
                4
            ];
            if (0 === r) return n;
            i._mult(r);
            const o = e1.sub(i), s = t.sub(i), a = [
                e1,
                t,
                o,
                s
            ];
            for(let e1 = 0; e1 < 4; e1++)for (const t of a)if (gb[e1](t)) {
                n.push(e1);
                break;
            }
            return n;
        }
        class xb {
            getDefaultSegment() {
                return this.regionSegments[4];
            }
            hasData() {
                return 0 !== this.vertexArray.length;
            }
            addData(e1, t, i, r = !1) {
                const n = e1.length;
                if (n > 2) {
                    let o = Math.max(0, this._segments.get().length - 1);
                    const s = this._segments._prepareSegment(4 * n, this.vertexArray.length, 2 * this._segmentToGroundQuads[o].length);
                    let a;
                    o !== this._segments.get().length - 1 && (o++, this._segmentToGroundQuads[o] = [], this._segmentToRegionTriCounts[o] = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ]);
                    {
                        const t = e1[0], i = e1[1];
                        a = _b(t.sub(e1[n - 1])._perp()._unit(), i.sub(t)._perp()._unit());
                    }
                    for(let l = 0; l < n; l++){
                        const c = l === n - 1 ? 0 : l + 1, h = e1[l], u = e1[c], d = e1[c === n - 1 ? 0 : c + 1], p = u.sub(h)._perp()._unit(), f = _b(p, d.sub(u)._perp()._unit()), m = a, _ = f;
                        if (Eb(h, u, t) || r && Mb(h, t) && Mb(u, t)) {
                            a = f;
                            continue;
                        }
                        const g = s.vertexLength;
                        ub(this.vertexArray, h, u, 1, 1, m), ub(this.vertexArray, h, u, 1, 0, m), ub(this.vertexArray, h, u, 0, 1, _), ub(this.vertexArray, h, u, 0, 0, _), s.vertexLength += 4;
                        const y = yb(h, u, p, i);
                        for (const e1 of y)this._segmentToGroundQuads[o].push({
                            id: g,
                            region: e1
                        }), this._segmentToRegionTriCounts[o][e1] += 2, s.primitiveLength += 2;
                        a = f;
                    }
                }
            }
            prepareBorderSegments() {
                if (!this.hasData()) return;
                const e1 = this._segments.get(), t = e1.length;
                for(let e1 = 0; e1 < t; e1++)this._segmentToGroundQuads[e1].sort((e1, t)=>e1.region - t.region);
                for(let i = 0; i < t; i++){
                    const t = this._segmentToGroundQuads[i], r = e1[i], n = this._segmentToRegionTriCounts[i];
                    n.reduce((e1, t)=>e1 + t, 0);
                    let o = 0;
                    for(let e1 = 0; e1 <= 4; e1++){
                        const t = n[e1];
                        if (0 !== t) {
                            let i = this.regionSegments[e1];
                            i || (i = this.regionSegments[e1] = new xl);
                            const n = {
                                vertexOffset: r.vertexOffset,
                                primitiveOffset: r.primitiveOffset + o,
                                vertexLength: r.vertexLength,
                                primitiveLength: t
                            };
                            i.get().push(n);
                        }
                        o += t;
                    }
                    for(let e1 = 0; e1 < t.length; e1++){
                        const i = t[e1].id;
                        this.indexArray.emplaceBack(i, i + 1, i + 3), this.indexArray.emplaceBack(i, i + 3, i + 2);
                    }
                }
                this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
            }
            addPaintPropertiesData(e1, t, i, r, n, o) {
                this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, e1, t, i, r, n, o);
            }
            upload(e1) {
                this.hasData() && (this.vertexBuffer = e1.createVertexBuffer(this.vertexArray, $f.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray));
            }
            uploadPaintProperties(e1) {
                this.hasData() && this.programConfigurations.upload(e1);
            }
            update(e1, t, i, r, n, o) {
                this.hasData() && this.programConfigurations.updatePaintArrays(e1, t, i, r, n, o);
            }
            updateHiddenByLandmark(e1) {
                if (!this.hasData()) return;
                const t = e1.groundVertexCount + e1.groundVertexArrayOffset;
                if (0 === e1.groundVertexCount) return;
                const i = e1.flags & cb ? 1 : 0;
                for(let r = e1.groundVertexArrayOffset; r < t; ++r)this.hiddenByLandmarkVertexArray.emplace(r, i);
                this._needsHiddenByLandmarkUpdate = !0;
            }
            uploadHiddenByLandmark(e1) {
                this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = e1.createVertexBuffer(this.hiddenByLandmarkVertexArray, Hf.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
            }
            destroy() {
                if (this.vertexBuffer) {
                    this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
                    for(let e1 = 0; e1 <= 4; e1++){
                        const t = this.regionSegments[e1];
                        t && t.destroy();
                    }
                }
            }
            constructor(e1){
                this.vertexArray = new Ra, this.indexArray = new Wa, this.programConfigurations = new ec(e1.layers, e1.zoom, (e1)=>ob.includes(e1)), this._segments = new xl, this.hiddenByLandmarkVertexArray = new ol, this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [
                    0,
                    0,
                    0,
                    0,
                    0
                ], this.regionSegments = {}, this.regionSegments[4] = new xl;
            }
        }
        class vb {
            populate(e1, t, i, r) {
                this.features = [], this.hasPattern = Uf("fill-extrusion", this.layers, t), this.featuresOnBorder = [], this.borderFeatureIndices = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.tileToMeter = ap(i), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter;
                for (const { feature: n, id: o, index: s, sourceLayerIndex: a } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, l = gp(n, e1);
                    if (!this.layers[0]._featureFilter.filter(new oa(this.zoom), l, i)) continue;
                    const c = {
                        id: o,
                        sourceLayerIndex: a,
                        index: s,
                        geometry: e1 ? l.geometry : _p(n, i, r),
                        properties: n.properties,
                        type: n.type,
                        patterns: {}
                    }, h = this.layoutVertexArray.length;
                    this.hasPattern ? this.features.push(Vf("fill-extrusion", this.layers, c, this.zoom, t)) : this.addFeature(c, c.geometry, s, i, {}, t.availableImages, r, t.brightness), t.featureIndex.insert(n, c.geometry, s, a, this.index, h);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
            }
            addFeatures(e1, t, i, r, n, o) {
                for (const e1 of this.features){
                    const { geometry: s } = e1;
                    this.addFeature(e1, s, e1.index, t, i, r, n, o);
                }
                this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
            }
            update(e1, t, i, r, n) {
                const o = 0 !== Object.keys(e1).length;
                if (o && !this.stateDependentLayers.length) return;
                const s = o ? this.stateDependentLayers : this.layers;
                this.programConfigurations.updatePaintArrays(e1, t, s, i, r, n), this.groundEffect.update(e1, t, s, i, r, n);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, Yf), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = e1.createVertexBuffer(this.layoutVertexExtArray, Xf.members, !0)), this.groundEffect.upload(e1)), this.groundEffect.uploadPaintProperties(e1), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            uploadCentroid(e1) {
                this.groundEffect.uploadHiddenByLandmark(e1), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = e1.createVertexBuffer(this.centroidVertexArray, Wf.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(e1, t, i, r, n, o, s, a) {
                const l = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(e1, {}) / this.tileToMeter, c = [
                    new y(0, 0),
                    new y(cr, cr)
                ], h = s.projection, u = "globe" === h.name, d = "Polygon" === rb[e1.type], p = new mb;
                p.centroidDataIndex = this.centroidData.length;
                const f = new fb, m = this.layers[0].paint.get("fill-extrusion-base").evaluate(e1, {}, r) <= 0, _ = this.layers[0].paint.get("fill-extrusion-height").evaluate(e1, {}, r);
                f.height = _, f.vertexArrayOffset = this.layoutVertexArray.length, f.groundVertexArrayOffset = this.groundEffect.vertexArray.length, u && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new Fa);
                const g = Ff(t, 500);
                for(let e1 = g.length - 1; e1 >= 0; e1--){
                    const t = g[e1];
                    (0 === t.length || (x = t[0]).every((e1)=>e1.x <= 0) || x.every((e1)=>e1.x >= cr) || x.every((e1)=>e1.y <= 0) || x.every((e1)=>e1.y >= cr)) && g.splice(e1, 1);
                }
                var x;
                let v;
                if (u) v = Cb(g, c, r);
                else {
                    v = [];
                    for (const e1 of g)v.push({
                        polygon: e1,
                        bounds: c
                    });
                }
                const b = d ? this.edgeRadius : 0, w = b > 0 && this.zoom < 17, T = (e1, t)=>{
                    if (0 === e1.length) return !1;
                    const i = e1[e1.length - 1];
                    return t.x === i.x && t.y === i.y;
                };
                for (const { polygon: e1, bounds: t } of v){
                    let i = 0, n = 0;
                    for (const t of e1)d && !t[0].equals(t[t.length - 1]) && t.push(t[0]), n += d ? t.length - 1 : t.length;
                    const o = this.segments.prepareSegment((d ? 5 : 4) * n, this.layoutVertexArray, this.indexArray);
                    f.footprintSegIdx < 0 && (f.footprintSegIdx = this.footprintSegments.length), f.polygonSegIdx < 0 && (f.polygonSegIdx = this.polygonSegments.length);
                    const s = {
                        triangleArrayOffset: this.indexArray.length,
                        triangleCount: 0,
                        triangleSegIdx: this.segments.segments.length - 1
                    }, a = new pb;
                    if (a.vertexOffset = this.footprintVertices.length, a.indexOffset = 3 * this.footprintIndices.length, a.ringIndices = [], d) {
                        const n = [], s = [];
                        i = o.vertexLength;
                        for(let i = 0; i < e1.length; i++){
                            const c = e1[i];
                            c.length && 0 !== i && s.push(n.length / 2);
                            const d = [];
                            let p, f;
                            p = c[1].sub(c[0])._perp()._unit(), a.ringIndices.push(c.length - 1);
                            for(let e1 = 1; e1 < c.length; e1++){
                                const t = c[e1], i = c[e1 === c.length - 1 ? 1 : e1 + 1], s = t.clone();
                                if (b) {
                                    f = i.sub(t)._perp()._unit();
                                    const e1 = p.add(f)._unit(), r = b * Math.min(4, 1 / (p.x * e1.x + p.y * e1.y));
                                    s.x += r * e1.x, s.y += r * e1.y, s.x = Math.round(s.x), s.y = Math.round(s.y), p = f;
                                }
                                !m || 0 !== b && !w || T(d, s) || d.push(s), hb(this.layoutVertexArray, s.x, s.y, 0, 0, 1, 1, 0), o.vertexLength++, this.footprintVertices.emplaceBack(t.x, t.y), n.push(t.x, t.y), u && db(this.layoutVertexExtArray, h.projectTilePoint(s.x, s.y, r), h.upVector(r, s.x, s.y));
                            }
                            m && (0 === b || w) && (0 !== d.length && T(d, d[0]) && d.pop(), this.groundEffect.addData(d, t, l));
                        }
                        const c = Bf(n, s);
                        for(let e1 = 0; e1 < c.length; e1 += 3)this.footprintIndices.emplaceBack(a.vertexOffset + c[e1 + 0], a.vertexOffset + c[e1 + 1], a.vertexOffset + c[e1 + 2]), this.indexArray.emplaceBack(i + c[e1], i + c[e1 + 2], i + c[e1 + 1]), o.primitiveLength++;
                        a.indexCount += c.length, a.vertexCount += this.footprintVertices.length - a.vertexOffset;
                    }
                    for(let n = 0; n < e1.length; n++){
                        const s = e1[n];
                        p.startRing(f, s[0]);
                        let a = s.length > 4 && Ab(s[s.length - 2], s[0], s[1]), c = b ? wb(s[s.length - 2], s[0], s[1], b) : 0;
                        const _ = [];
                        let g, y, x;
                        y = s[1].sub(s[0])._perp()._unit();
                        let v = !0;
                        for(let e1 = 1, n = 0; e1 < s.length; e1++){
                            let l = s[e1 - 1], d = s[e1];
                            const w = s[e1 === s.length - 1 ? 1 : e1 + 1];
                            if (p.appendEdge(f, d, l), Eb(d, l, t)) {
                                b && (y = w.sub(d)._perp()._unit(), v = !v);
                                continue;
                            }
                            const E = d.sub(l)._perp(), M = E.x / (Math.abs(E.x) + Math.abs(E.y)), A = E.y > 0 ? 1 : 0, S = l.dist(d);
                            if (n + S > 32768 && (n = 0), b) {
                                x = w.sub(d)._perp()._unit();
                                let e1 = Tb(l, d, w, bb(y, x), b);
                                isNaN(e1) && (e1 = 0);
                                const t = d.sub(l)._unit();
                                l = l.add(t.mult(c))._round(), d = d.add(t.mult(-e1))._round(), c = e1, y = x, m && this.zoom >= 17 && (T(_, l) || _.push(l), T(_, d) || _.push(d));
                            }
                            const I = o.vertexLength, C = s.length > 4 && Ab(l, d, w);
                            let z = Sb(n, a, v);
                            if (hb(this.layoutVertexArray, l.x, l.y, M, A, 0, 0, z), hb(this.layoutVertexArray, l.x, l.y, M, A, 0, 1, z), n += S, z = Sb(n, C, !v), a = C, hb(this.layoutVertexArray, d.x, d.y, M, A, 0, 0, z), hb(this.layoutVertexArray, d.x, d.y, M, A, 0, 1, z), o.vertexLength += 4, this.indexArray.emplaceBack(I + 0, I + 1, I + 2), this.indexArray.emplaceBack(I + 1, I + 3, I + 2), o.primitiveLength += 2, b) {
                                const r = i + (1 === e1 ? s.length - 2 : e1 - 2), n = 1 === e1 ? i : r + 1;
                                if (this.indexArray.emplaceBack(I + 1, r, I + 3), this.indexArray.emplaceBack(r, n, I + 3), o.primitiveLength += 2, void 0 === g && (g = I), !Eb(w, s[e1], t)) {
                                    const t = e1 === s.length - 1 ? g : o.vertexLength;
                                    this.indexArray.emplaceBack(I + 2, I + 3, t), this.indexArray.emplaceBack(I + 3, t + 1, t), this.indexArray.emplaceBack(I + 3, n, t + 1), o.primitiveLength += 3;
                                }
                                v = !v;
                            }
                            if (u) {
                                const e1 = this.layoutVertexExtArray, t = h.projectTilePoint(l.x, l.y, r), i = h.projectTilePoint(d.x, d.y, r), n = h.upVector(r, l.x, l.y), o = h.upVector(r, d.x, d.y);
                                db(e1, t, n), db(e1, t, n), db(e1, i, o), db(e1, i, o);
                            }
                        }
                        d && (i += s.length - 1), m && b && this.zoom >= 17 && (0 !== _.length && T(_, _[0]) && _.pop(), this.groundEffect.addData(_, t, l, b > 0));
                    }
                    this.footprintSegments.push(a), s.triangleCount = this.indexArray.length - s.triangleArrayOffset, this.polygonSegments.push(s), ++f.footprintSegLen, ++f.polygonSegLen;
                }
                if (f.vertexCount = this.layoutVertexArray.length - f.vertexArrayOffset, f.groundVertexCount = this.groundEffect.vertexArray.length - f.groundVertexArrayOffset, 0 !== f.vertexCount) {
                    if (f.centroidXY = p.borders ? lb : this.encodeCentroid(p, f), this.centroidData.push(f), p.borders) {
                        this.featuresOnBorder.push(p);
                        const e1 = this.featuresOnBorder.length - 1;
                        for(let t = 0; t < p.borders.length; t++)p.borders[t][0] !== Number.MAX_VALUE && this.borderFeatureIndices[t].push(e1);
                    }
                    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, i, n, o, r, a), this.groundEffect.addPaintPropertiesData(e1, i, n, o, r, a), this.maxHeight = Math.max(this.maxHeight, _);
                }
            }
            sortBorders() {
                for(let e1 = 0; e1 < this.borderFeatureIndices.length; e1++)this.borderFeatureIndices[e1].sort((t, i)=>this.featuresOnBorder[t].borders[e1][0] - this.featuresOnBorder[i].borders[e1][0]);
            }
            splitToSubtiles() {
                const e1 = [];
                for(let t = 0; t < this.centroidData.length; t++){
                    const i = this.centroidData[t], r = +(i.min.y + i.max.y > cr), n = 2 * r + (+(i.min.x + i.max.x > cr) ^ r);
                    for(let r = 0; r < i.polygonSegLen; r++){
                        const o = i.polygonSegIdx + r;
                        e1.push({
                            centroidIdx: t,
                            subtile: n,
                            polygonSegmentIdx: o,
                            triangleSegmentIdx: this.polygonSegments[o].triangleSegIdx
                        });
                    }
                }
                const t = new Wa;
                e1.sort((e1, t)=>e1.triangleSegmentIdx === t.triangleSegmentIdx ? e1.subtile - t.subtile : e1.triangleSegmentIdx - t.triangleSegmentIdx);
                let i = 0, r = 0, n = 0;
                for (const t of e1){
                    if (t.triangleSegmentIdx !== i) break;
                    n++;
                }
                const o = e1.length;
                for(; r !== e1.length;){
                    i = e1[r].triangleSegmentIdx;
                    let s = 0, a = r, l = r;
                    for(let t = a; t < n && e1[t].subtile === s; t++)l++;
                    for(; a !== n;){
                        const r = e1[a];
                        s = r.subtile;
                        const o = this.centroidData[r.centroidIdx].min.clone(), c = this.centroidData[r.centroidIdx].max.clone(), h = {
                            vertexOffset: this.segments.segments[i].vertexOffset,
                            primitiveOffset: t.length,
                            vertexLength: this.segments.segments[i].vertexLength,
                            primitiveLength: 0,
                            sortKey: void 0,
                            vaos: {}
                        };
                        for(let i = a; i < l; i++){
                            const r = e1[i], n = this.polygonSegments[r.polygonSegmentIdx], s = this.centroidData[r.centroidIdx].min, a = this.centroidData[r.centroidIdx].max, l = this.indexArray.uint16;
                            for(let e1 = n.triangleArrayOffset; e1 < n.triangleArrayOffset + n.triangleCount; e1++)t.emplaceBack(l[3 * e1], l[3 * e1 + 1], l[3 * e1 + 2]);
                            h.primitiveLength += n.triangleCount, o.x = Math.min(o.x, s.x), o.y = Math.min(o.y, s.y), c.x = Math.max(c.x, a.x), c.y = Math.max(c.y, a.y);
                        }
                        h.primitiveLength > 0 && this.triangleSubSegments.push({
                            segment: h,
                            min: o,
                            max: c
                        }), a = l;
                        for(let t = a; t < n && e1[t].subtile === e1[a].subtile; t++)l++;
                    }
                    r = n;
                    for(let t = r; t < o && e1[t].triangleSegmentIdx === e1[r].triangleSegmentIdx; t++)n++;
                }
                t._trim(), this.indexArray = t;
            }
            getVisibleSegments(e1, t, i) {
                let r = 0, n = 0;
                const o = 1 << e1.canonical.z;
                if (t) {
                    const i = t.getMinMaxForTile(e1);
                    i && (r = i.min, n = i.max);
                }
                n += this.maxHeight;
                const s = e1.toUnwrapped();
                let a;
                const l = [
                    s.canonical.x / o + s.wrap,
                    s.canonical.y / o
                ], c = [
                    (s.canonical.x + 1) / o + s.wrap,
                    (s.canonical.y + 1) / o
                ], h = new xl, u = (e1, t, i)=>[
                        e1[0] * (1 - i[0]) + t[0] * i[0],
                        e1[1] * (1 - i[1]) + t[1] * i[1]
                    ], d = [], p = [];
                for (const e1 of this.triangleSubSegments){
                    d[0] = e1.min.x / cr, d[1] = e1.min.y / cr, p[0] = e1.max.x / cr, p[1] = e1.max.y / cr;
                    const t = u(l, c, d), o = u(l, c, p);
                    if (0 === new ed([
                        t[0],
                        t[1],
                        r
                    ], [
                        o[0],
                        o[1],
                        n
                    ]).intersectsPrecise(i)) {
                        a && (h.segments.push(a), a = void 0);
                        continue;
                    }
                    const s = e1.segment;
                    a && a.vertexOffset !== s.vertexOffset && (h.segments.push(a), a = void 0), a ? (a.vertexLength += s.vertexLength, a.primitiveLength += s.primitiveLength) : a = {
                        vertexOffset: s.vertexOffset,
                        primitiveLength: s.primitiveLength,
                        vertexLength: s.vertexLength,
                        primitiveOffset: s.primitiveOffset,
                        sortKey: void 0,
                        vaos: {}
                    };
                }
                return a && h.segments.push(a), h;
            }
            encodeCentroid(e1, t) {
                const i = e1.centroid(), r = t.span(), n = Math.min(7, Math.round(r.x * this.tileToMeter / 10)), o = Math.min(7, Math.round(r.y * this.tileToMeter / 10));
                return new y(z(i.x, 1, cr - 1) << 3 | n, z(i.y, 1, cr - 1) << 3 | o);
            }
            showCentroid(e1) {
                const t = this.centroidData[e1.centroidDataIndex];
                t.flags &= cb, t.centroidXY.x = 0, t.centroidXY.y = 0, this.writeCentroidToBuffer(t);
            }
            writeCentroidToBuffer(e1) {
                this.groundEffect.updateHiddenByLandmark(e1);
                const t = e1.vertexArrayOffset, i = e1.vertexCount + e1.vertexArrayOffset, r = e1.flags & cb ? lb : e1.centroidXY, n = this.centroidVertexArray.geta_centroid_pos0(t);
                if (this.centroidVertexArray.geta_centroid_pos1(t) !== r.y || n !== r.x) {
                    for(let e1 = t; e1 < i; ++e1)this.centroidVertexArray.emplace(e1, r.x, r.y);
                    this.needsCentroidUpdate = !0;
                }
            }
            createCentroidsBuffer() {
                this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const e1 of this.centroidData)this.writeCentroidToBuffer(e1);
            }
            updateReplacement(e1, t) {
                if (t.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t.updateTime;
                const i = t.getReplacementRegionsForTile(e1.toUnwrapped());
                if (function(e1, t) {
                    if (e1.length !== t.length) return !1;
                    for(let i = 0; i < e1.length; i++)if (e1[i].sourceId !== t[i].sourceId || !Kv(e1[i], t[i])) return !1;
                    return !0;
                }(this.activeReplacements, i)) return;
                if (this.activeReplacements = i, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
                else for (const e1 of this.centroidData)e1.flags &= 2147483647;
                const r = [];
                for (const t of this.activeReplacements){
                    const i = Math.pow(2, t.footprintTileId.canonical.z - e1.canonical.z);
                    for (const n of this.centroidData)if (!(n.flags & cb || t.min.x > n.max.x || n.min.x > t.max.x || t.min.y > n.max.y || n.min.y > t.max.y)) for(let o = 0; o < n.footprintSegLen; o++){
                        const s = this.footprintSegments[n.footprintSegIdx + o];
                        if (r.length = 0, zb(this.footprintVertices, s.vertexOffset, s.vertexCount, t.footprintTileId.canonical, e1.canonical, r), tb(t.footprint, r, this.footprintIndices.uint16, s.indexOffset, s.indexCount, -s.vertexOffset, -i)) {
                            n.flags |= cb;
                            break;
                        }
                    }
                }
                for (const e1 of this.centroidData)this.writeCentroidToBuffer(e1);
                this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ];
            }
            footprintContainsPoint(e1, t, i) {
                let r = !1;
                for(let n = 0; n < i.footprintSegLen; n++){
                    const o = this.footprintSegments[i.footprintSegIdx + n];
                    let s = 0;
                    for (const i of o.ringIndices){
                        for(let n = s, a = i + s - 1; n < i + s; a = n++){
                            const i = this.footprintVertices.int16[2 * (n + o.vertexOffset) + 0], s = this.footprintVertices.int16[2 * (n + o.vertexOffset) + 1], l = this.footprintVertices.int16[2 * (a + o.vertexOffset) + 1];
                            s > t != l > t && e1 < (this.footprintVertices.int16[2 * (a + o.vertexOffset) + 0] - i) * (t - s) / (l - s) + i && (r = !r);
                        }
                        s = i;
                    }
                }
                return r;
            }
            getHeightAtTileCoord(e1, t) {
                let i = Number.NEGATIVE_INFINITY, r = !0;
                const n = 4 * (e1 + cr) * cr + (t + cr);
                if (this.partLookup.hasOwnProperty(n)) {
                    const e1 = this.partLookup[n];
                    return e1 ? {
                        height: e1.height,
                        hidden: !!(e1.flags & cb)
                    } : void 0;
                }
                for (const o of this.centroidData)e1 > o.max.x || o.min.x > e1 || t > o.max.y || o.min.y > t || this.footprintContainsPoint(e1, t, o) && o && o.height > i && (i = o.height, this.partLookup[n] = o, r = !!(o.flags & cb));
                if (i !== Number.NEGATIVE_INFINITY) return {
                    height: i,
                    hidden: r
                };
                this.partLookup[n] = void 0;
            }
            constructor(e1){
                this.zoom = e1.zoom, this.canonical = e1.canonical, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = e1.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new Wa, this.footprintVertices = new za, this.footprintSegments = [], this.layoutVertexArray = new Da, this.centroidVertexArray = new _l, this.indexArray = new Wa, this.programConfigurations = new ec(e1.layers, e1.zoom, (e1)=>nb.includes(e1)), this.segments = new xl, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.groundEffect = new xb(e1), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [];
            }
        }
        function bb(e1, t) {
            const i = e1.add(t)._unit();
            return e1.x * i.x + e1.y * i.y;
        }
        function wb(e1, t, i, r) {
            const n = t.sub(e1)._perp()._unit(), o = i.sub(t)._perp()._unit();
            return Tb(e1, t, i, bb(n, o), r);
        }
        function Tb(e1, t, i, r, n) {
            const o = Math.sqrt(1 - r * r);
            return Math.min(e1.dist(t) / 3, t.dist(i) / 3, n * o / r);
        }
        function Eb(e1, t, i) {
            return e1.x < i[0].x && t.x < i[0].x || e1.x > i[1].x && t.x > i[1].x || e1.y < i[0].y && t.y < i[0].y || e1.y > i[1].y && t.y > i[1].y;
        }
        function Mb(e1, t) {
            return e1.x < t[0].x || e1.x > t[1].x || e1.y < t[0].y || e1.y > t[1].y;
        }
        function Ab(e1, t, i) {
            if (e1.x < 0 || e1.x >= cr || t.x < 0 || t.x >= cr || i.x < 0 || i.x >= cr) return !1;
            const r = i.sub(t), n = r.perp(), o = e1.sub(t);
            return (r.x * o.x + r.y * o.y) / Math.sqrt((r.x * r.x + r.y * r.y) * (o.x * o.x + o.y * o.y)) > -0.866 && n.x * o.x + n.y * o.y < 0;
        }
        function Sb(e1, t, i) {
            const r = t ? 2 | e1 : -3 & e1;
            return i ? 1 | r : -2 & r;
        }
        function Ib() {
            const e1 = Math.PI / 32, t = Math.tan(e1), i = qd;
            return i * Math.sqrt(1 + 2 * t * t) - i;
        }
        function Cb(e1, t, i) {
            const r = 1 << i.z, n = ep(i.x / r), o = ep((i.x + 1) / r), s = tp(i.y / r), a = tp((i.y + 1) / r);
            return function(e1, t, i, r, n = 0, o) {
                const s = [];
                if (!e1.length || !i || !r) return s;
                const a = (e1, t)=>{
                    for (const i of e1)s.push({
                        polygon: i,
                        bounds: t
                    });
                }, l = Math.ceil(Math.log2(i)), c = Math.ceil(Math.log2(r)), h = l - c, u = [];
                for(let e1 = 0; e1 < Math.abs(h); e1++)u.push(h > 0 ? 0 : 1);
                for(let e1 = 0; e1 < Math.min(l, c); e1++)u.push(0), u.push(1);
                let d = e1;
                if (d = um(d, t[0].y - n, t[1].y + n, 1), d = um(d, t[0].x - n, t[1].x + n, 0), !d.length) return s;
                const p = [];
                for(u.length ? p.push({
                    polygons: d,
                    bounds: t,
                    depth: 0
                }) : a(d, t); p.length;){
                    const e1 = p.pop(), t = e1.depth, i = u[t], r = e1.bounds[0], s = e1.bounds[1], l = 0 === i ? r.x : r.y, c = 0 === i ? s.x : s.y, h = o ? o(i, l, c) : .5 * (l + c), d = um(e1.polygons, l - n, h + n, i), f = um(e1.polygons, h - n, c + n, i);
                    if (d.length) {
                        const e1 = [
                            r,
                            new y(0 === i ? h : s.x, 1 === i ? h : s.y)
                        ];
                        u.length > t + 1 ? p.push({
                            polygons: d,
                            bounds: e1,
                            depth: t + 1
                        }) : a(d, e1);
                    }
                    if (f.length) {
                        const e1 = [
                            new y(0 === i ? h : r.x, 1 === i ? h : r.y),
                            s
                        ];
                        u.length > t + 1 ? p.push({
                            polygons: f,
                            bounds: e1,
                            depth: t + 1
                        }) : a(f, e1);
                    }
                }
                return s;
            }(e1, t, Math.ceil((o - n) / 11.25), Math.ceil((s - a) / 11.25), 1, (e1, t, n)=>{
                if (0 === e1) return .5 * (t + n);
                {
                    const e1 = tp((i.y + t / cr) / r);
                    return (Jd(.5 * (tp((i.y + n / cr) / r) + e1)) * r - i.y) * cr;
                }
            });
        }
        function zb(e1, t, i, r, n, o) {
            const s = Math.pow(2, r.z - n.z);
            for(let a = 0; a < i; a++){
                let i = e1.int16[2 * (a + t) + 0], l = e1.int16[2 * (a + t) + 1];
                i = (i + n.x * cr) * s - r.x * cr, l = (l + n.y * cr) * s - r.y * cr, o.push(new y(i, l));
            }
        }
        Rs(vb, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), Rs(fb, "PartData"), Rs(pb, "FootprintSegment"), Rs(mb, "BorderCentroidData"), Rs(xb, "GroundEffect");
        const Pb = new ga({
            visibility: new fa(Pt["layout_fill-extrusion"].visibility),
            "fill-extrusion-edge-radius": new fa(Pt["layout_fill-extrusion"]["fill-extrusion-edge-radius"])
        });
        var Db = {
            paint: new ga({
                "fill-extrusion-opacity": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                "fill-extrusion-color": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-color"]),
                "fill-extrusion-translate": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-translate"]),
                "fill-extrusion-translate-anchor": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                "fill-extrusion-pattern": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                "fill-extrusion-height": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-height"]),
                "fill-extrusion-base": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-base"]),
                "fill-extrusion-vertical-gradient": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                "fill-extrusion-ambient-occlusion-intensity": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                "fill-extrusion-ambient-occlusion-radius": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),
                "fill-extrusion-ambient-occlusion-wall-radius": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]),
                "fill-extrusion-ambient-occlusion-ground-radius": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]),
                "fill-extrusion-ambient-occlusion-ground-attenuation": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]),
                "fill-extrusion-flood-light-color": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]),
                "fill-extrusion-flood-light-intensity": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]),
                "fill-extrusion-flood-light-wall-radius": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]),
                "fill-extrusion-flood-light-ground-radius": new ma(Pt["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]),
                "fill-extrusion-flood-light-ground-attenuation": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]),
                "fill-extrusion-vertical-scale": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]),
                "fill-extrusion-rounded-roof": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]),
                "fill-extrusion-cutoff-fade-range": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]),
                "fill-extrusion-emissive-strength": new fa(Pt["paint_fill-extrusion"]["fill-extrusion-emissive-strength"])
            }),
            layout: Pb
        };
        class Rb extends y {
            constructor(e1, t, i){
                super(e1, t), this.z = i;
            }
        }
        function Lb(e1, t) {
            return e1.x * t.x + e1.y * t.y;
        }
        function kb(e1, t) {
            if (1 === e1.length) {
                let i = 0;
                const r = t[i++];
                let n;
                for(; !n || r.equals(n);)if (n = t[i++], !n) return 1 / 0;
                for(; i < t.length; i++){
                    const o = t[i], s = e1[0], a = n.sub(r), l = o.sub(r), c = s.sub(r), h = Lb(a, a), u = Lb(a, l), d = Lb(l, l), p = Lb(c, a), f = Lb(c, l), m = h * d - u * u, _ = (d * p - u * f) / m, g = (h * f - u * p) / m, y = r.z * (1 - _ - g) + n.z * _ + o.z * g;
                    if (isFinite(y)) return y;
                }
                return 1 / 0;
            }
            {
                let e1 = 1 / 0;
                for (const i of t)e1 = Math.min(e1, i.z);
                return e1;
            }
        }
        function Ob(e1, t, i, r, n, o, s, a) {
            const l = s * n.getElevationAt(e1, t, !0, !0), c = 0 !== o[0], h = c ? 0 === o[1] ? s * (o[0] / 7 - 450) : s * function(e1, t, i) {
                const r = Math.floor(t[0] / 8), n = Math.floor(t[1] / 8), o = 10 * (t[0] - 8 * r), s = 10 * (t[1] - 8 * n), a = e1.getElevationAt(r, n, !0, !0), l = e1.getMeterToDEM(i), c = Math.floor(.5 * (o * l - 1)), h = Math.floor(.5 * (s * l - 1)), u = e1.tileCoordToPixel(r, n), d = 2 * c + 1, p = 2 * h + 1, f = function(e1, t, i, r, n) {
                    return [
                        e1.getElevationAtPixel(t, i, !0),
                        e1.getElevationAtPixel(t + n, i, !0),
                        e1.getElevationAtPixel(t, i + n, !0),
                        e1.getElevationAtPixel(t + r, i + n, !0)
                    ];
                }(e1, u.x - c, u.y - h, d, p), m = Math.abs(f[0] - f[1]), _ = Math.abs(f[2] - f[3]), g = Math.abs(f[0] - f[2]) + Math.abs(f[1] - f[3]), y = Math.min(.25, .5 * l * (m + _) / d), x = Math.min(.25, .5 * l * g / p);
                return a + Math.max(y * o, x * s);
            }(n, o, a) : l;
            return {
                base: l + (0 === i) ? -1 : i,
                top: c ? Math.max(h + r, l + i + 2) : l + r
            };
        }
        const Bb = new ga({
            "line-cap": new ma(Pt.layout_line["line-cap"]),
            "line-join": new ma(Pt.layout_line["line-join"]),
            "line-miter-limit": new fa(Pt.layout_line["line-miter-limit"]),
            "line-round-limit": new fa(Pt.layout_line["line-round-limit"]),
            "line-sort-key": new ma(Pt.layout_line["line-sort-key"]),
            visibility: new fa(Pt.layout_line.visibility)
        });
        var Fb = {
            paint: new ga({
                "line-opacity": new ma(Pt.paint_line["line-opacity"]),
                "line-color": new ma(Pt.paint_line["line-color"]),
                "line-translate": new fa(Pt.paint_line["line-translate"]),
                "line-translate-anchor": new fa(Pt.paint_line["line-translate-anchor"]),
                "line-width": new ma(Pt.paint_line["line-width"]),
                "line-gap-width": new ma(Pt.paint_line["line-gap-width"]),
                "line-offset": new ma(Pt.paint_line["line-offset"]),
                "line-blur": new ma(Pt.paint_line["line-blur"]),
                "line-dasharray": new ma(Pt.paint_line["line-dasharray"]),
                "line-pattern": new ma(Pt.paint_line["line-pattern"]),
                "line-gradient": new _a(Pt.paint_line["line-gradient"]),
                "line-trim-offset": new fa(Pt.paint_line["line-trim-offset"]),
                "line-emissive-strength": new fa(Pt.paint_line["line-emissive-strength"]),
                "line-border-width": new ma(Pt.paint_line["line-border-width"]),
                "line-border-color": new ma(Pt.paint_line["line-border-color"])
            }),
            layout: Bb
        };
        const Nb = (e1, t, i, r, n, o, s)=>{
            const a = e1.transform, l = a.calculatePixelsToTileUnitsMatrix(t);
            return {
                u_matrix: jb(e1, t, i, r),
                u_pixels_to_tile_units: l,
                u_device_pixel_ratio: o,
                u_units_to_pixels: [
                    1 / a.pixelsToGLUnits[0],
                    1 / a.pixelsToGLUnits[1]
                ],
                u_dash_image: 0,
                u_gradient_image: 1,
                u_image_height: n,
                u_texsize: qb(i) && t.lineAtlasTexture ? t.lineAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: Vb(t, e1.transform),
                u_alpha_discard_threshold: 0,
                u_trim_offset: s,
                u_emissive_strength: i.paint.get("line-emissive-strength")
            };
        }, Ub = (e1, t, i, r, n)=>{
            const o = e1.transform;
            return {
                u_matrix: jb(e1, t, i, r),
                u_texsize: t.imageAtlasTexture ? t.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_pixels_to_tile_units: o.calculatePixelsToTileUnitsMatrix(t),
                u_device_pixel_ratio: n,
                u_image: 0,
                u_tile_units_to_pixels: Vb(t, o),
                u_units_to_pixels: [
                    1 / o.pixelsToGLUnits[0],
                    1 / o.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0
            };
        };
        function Vb(e1, t) {
            return 1 / rv(e1, 1, t.tileZoom);
        }
        function jb(e1, t, i, r) {
            return e1.translatePosMatrix(r || t.tileID.projMatrix, t, i.paint.get("line-translate"), i.paint.get("line-translate-anchor"));
        }
        const Gb = (e1)=>{
            const t = [];
            qb(e1) && t.push("RENDER_LINE_DASH"), e1.paint.get("line-gradient") && t.push("RENDER_LINE_GRADIENT");
            const i = e1.paint.get("line-trim-offset");
            return 0 === i[0] && 0 === i[1] || t.push("RENDER_LINE_TRIM_OFFSET"), 0 !== e1.paint.get("line-border-width").constantOr(1) && t.push("RENDER_LINE_BORDER"), t;
        };
        function qb(e1) {
            const t = e1.paint.get("line-dasharray").value;
            return t.value || "constant" !== t.kind;
        }
        const Zb = new class extends ma {
            possiblyEvaluate(e1, t) {
                return t = new oa(Math.floor(t.zoom), {
                    now: t.now,
                    fadeDuration: t.fadeDuration,
                    transition: t.transition
                }), super.possiblyEvaluate(e1, t);
            }
            evaluate(e1, t, i, r) {
                return t = k({}, t, {
                    zoom: Math.floor(t.zoom)
                }), super.evaluate(e1, t, i, r);
            }
        }(Fb.paint.properties["line-width"].specification);
        function $b(e1, t) {
            return t > 0 ? t + 2 * e1 : e1;
        }
        Zb.useIntegerZoom = !0;
        const Wb = new ga({
            visibility: new fa(Pt.layout_background.visibility)
        });
        var Hb = {
            paint: new ga({
                "background-color": new fa(Pt.paint_background["background-color"]),
                "background-pattern": new fa(Pt.paint_background["background-pattern"]),
                "background-opacity": new fa(Pt.paint_background["background-opacity"]),
                "background-emissive-strength": new fa(Pt.paint_background["background-emissive-strength"])
            }),
            layout: Wb
        };
        const Xb = new ga({
            visibility: new fa(Pt.layout_raster.visibility)
        });
        var Yb = {
            paint: new ga({
                "raster-opacity": new fa(Pt.paint_raster["raster-opacity"]),
                "raster-color": new _a(Pt.paint_raster["raster-color"]),
                "raster-color-mix": new fa(Pt.paint_raster["raster-color-mix"]),
                "raster-color-range": new fa(Pt.paint_raster["raster-color-range"]),
                "raster-hue-rotate": new fa(Pt.paint_raster["raster-hue-rotate"]),
                "raster-brightness-min": new fa(Pt.paint_raster["raster-brightness-min"]),
                "raster-brightness-max": new fa(Pt.paint_raster["raster-brightness-max"]),
                "raster-saturation": new fa(Pt.paint_raster["raster-saturation"]),
                "raster-contrast": new fa(Pt.paint_raster["raster-contrast"]),
                "raster-resampling": new fa(Pt.paint_raster["raster-resampling"]),
                "raster-fade-duration": new fa(Pt.paint_raster["raster-fade-duration"]),
                "raster-emissive-strength": new fa(Pt.paint_raster["raster-emissive-strength"]),
                "raster-array-band": new fa(Pt.paint_raster["raster-array-band"]),
                "raster-elevation": new fa(Pt.paint_raster["raster-elevation"])
            }),
            layout: Xb
        };
        function Kb(e1, t, i, r, n, o, s, a) {
            const l = [
                e1,
                i,
                n,
                t,
                r,
                o,
                1,
                1,
                1
            ], c = [
                s,
                a,
                1
            ], h = Eu.adjoint([], l), [u, d, p] = Du.transformMat3(c, c, Eu.transpose(h, h));
            return Eu.multiply(l, [
                u,
                0,
                0,
                0,
                d,
                0,
                0,
                0,
                p
            ], l);
        }
        class Jb extends zt {
            load(e1, i) {
                if (this._loaded = i || !1, this.fire(new It("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, !this.url) return e1 && (this.coordinates = e1), this._loaded = !0, void this._finishLoading();
                this._imageRequest = Ie(this.map._requestManager.transformRequest(this.url, ye.Image), (i, r)=>{
                    if (this._imageRequest = null, this._loaded = !0, i) this.fire(new Ct(i));
                    else if (r) {
                        const { HTMLImageElement: i } = t;
                        this.image = r instanceof i ? dt.getImageData(r) : r, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, e1 && (this.coordinates = e1), this._finishLoading();
                    }
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e1) {
                return e1.url ? (this._imageRequest && e1.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = e1.url, this.load(e1.coordinates, this._loaded), this) : this;
            }
            setTexture(e1) {
                if (!(e1.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
                return this.texture = new Ay(this.map.painter.context, e1.handle), this.width = e1.dimensions[0], this.height = e1.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new It("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove() {
                this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof Ay || this.texture.destroy();
            }
            setCoordinates(e1) {
                if (this.coordinates = e1, this._boundsArray = void 0, !e1.length) return this;
                this.onNorthPole = !1, this.onSouthPole = !1;
                let t = e1[0][1], i = e1[0][1];
                for (const r of e1)r[1] > i && (i = r[1]), r[1] < t && (t = r[1]);
                const r = (i + t) / 2;
                if (r > rp ? this.onNorthPole = !0 : r < -rp && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
                    const t = e1.map(lp.fromLngLat);
                    this.tileID = function(e1) {
                        let t = 1 / 0, i = 1 / 0, r = -1 / 0, n = -1 / 0;
                        for (const o of e1)t = Math.min(t, o.x), i = Math.min(i, o.y), r = Math.max(r, o.x), n = Math.max(n, o.y);
                        const o = Math.max(r - t, n - i), s = Math.max(0, Math.floor(-Math.log(o) / Math.LN2)), a = Math.pow(2, s);
                        return new ju(s, Math.floor((t + r) / 2 * a), Math.floor((i + n) / 2 * a));
                    }(t), this.minzoom = this.maxzoom = this.tileID.z;
                }
                return this.fire(new It("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                this._boundsArray = void 0;
            }
            _prepareData(e1) {
                for(const e1 in this.tiles){
                    const t = this.tiles[e1];
                    "loaded" !== t.state && (t.state = "loaded", t.texture = this.texture);
                }
                if (this._boundsArray) return;
                const t = Pg(this.tileID, this.map.transform.projection), [i, r, n, o] = this.coordinates.map((e1)=>{
                    const i = t.projection.project(e1[0], e1[1]);
                    return Rg(t, i)._round();
                });
                this.perspectiveTransform = function(e1, t, i, r, n, o, s, a, l, c) {
                    const h = Kb(0, 0, e1, 0, 0, t, e1, t), u = Kb(i, r, n, o, s, a, l, c);
                    return Eu.multiply(u, Eu.adjoint(h, h), u), [
                        u[6] / u[8] * e1 / cr,
                        u[7] / u[8] * t / cr
                    ];
                }(this.width, this.height, i.x, i.y, r.x, r.y, o.x, o.y, n.x, n.y);
                const s = this._boundsArray = new Da;
                s.emplaceBack(i.x, i.y, 0, 0), s.emplaceBack(r.x, r.y, cr, 0), s.emplaceBack(o.x, o.y, 0, cr), s.emplaceBack(n.x, n.y, cr, cr), this.boundsBuffer && this.boundsBuffer.destroy(), this.boundsBuffer = e1.createVertexBuffer(s, Ly.members), this.boundsSegments = xl.simpleSegment(0, 0, 4, 2);
            }
            prepare() {
                const e1 = 0 !== Object.keys(this.tiles).length;
                if (this.tileID && !e1) return;
                const t = this.map.painter.context, i = t.gl;
                !this._dirty || this.texture instanceof Ay || (this.texture ? this.texture.update(this.image) : (this.texture = new My(t, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE)), this._dirty = !1), e1 && this._prepareData(t);
            }
            loadTile(e1, t) {
                this.tileID && this.tileID.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}, t(null)) : (e1.state = "errored", t(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            constructor(e1, t, i, r){
                super(), this.id = e1, this.dispatcher = i, this.coordinates = t.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.onNorthPole = !1, this.onSouthPole = !1, this.setEventedParent(r), this.options = t, this._dirty = !1;
            }
        }
        class Qb extends Ta {
            is3D() {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            isLayerDraped(e1) {
                return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
                return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(e1) {
                this.implementation.onAdd && this.implementation.onAdd(e1, e1.painter.context.gl);
            }
            onRemove(e1) {
                this.implementation.onRemove && this.implementation.onRemove(e1, e1.painter.context.gl);
            }
            constructor(e1){
                super(e1, {}), this.implementation = e1, e1.slot && (this.slot = e1.slot);
            }
        }
        const ew = new ga({
            visibility: new fa(Pt.layout_sky.visibility)
        });
        var tw = {
            paint: new ga({
                "sky-type": new fa(Pt.paint_sky["sky-type"]),
                "sky-atmosphere-sun": new fa(Pt.paint_sky["sky-atmosphere-sun"]),
                "sky-atmosphere-sun-intensity": new fa(Pt.paint_sky["sky-atmosphere-sun-intensity"]),
                "sky-gradient-center": new fa(Pt.paint_sky["sky-gradient-center"]),
                "sky-gradient-radius": new fa(Pt.paint_sky["sky-gradient-radius"]),
                "sky-gradient": new _a(Pt.paint_sky["sky-gradient"]),
                "sky-atmosphere-halo-color": new fa(Pt.paint_sky["sky-atmosphere-halo-color"]),
                "sky-atmosphere-color": new fa(Pt.paint_sky["sky-atmosphere-color"]),
                "sky-opacity": new fa(Pt.paint_sky["sky-opacity"])
            }),
            layout: ew
        };
        function iw(e1, t, i) {
            const r = [
                0,
                0,
                1
            ], n = Iu.identity([]);
            return Iu.rotateY(n, n, i ? -w(e1) + Math.PI : w(e1)), Iu.rotateX(n, n, -w(t)), Du.transformQuat(r, r, n), Du.normalize(r, r);
        }
        var rw = {
            paint: new ga({})
        };
        const nw = {
            circle: class extends Ta {
                createBucket(e1) {
                    return new vp(e1);
                }
                queryRadius(e1) {
                    const t = e1;
                    return kp("circle-radius", this, t) + kp("circle-stroke-width", this, t) + Op(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(e1, t, i, r, n, o, s, a) {
                    const l = Fp(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), c = this.paint.get("circle-radius").evaluate(t, i) + this.paint.get("circle-stroke-width").evaluate(t, i);
                    return qp(e1, r, o, s, a, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, c);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getDefaultProgramParams(e1, t) {
                    const i = Gp(this);
                    return {
                        config: new Ql(this, t),
                        defines: i,
                        overrideFog: !1
                    };
                }
                constructor(e1, t){
                    super(e1, Up, t);
                }
            },
            heatmap: class extends Ta {
                createBucket(e1) {
                    return new Xp(e1);
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "heatmap-color" === e1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = of({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                queryRadius(e1) {
                    return kp("heatmap-radius", this, e1);
                }
                queryIntersectsFeature(e1, t, i, r, n, o, s, a) {
                    const l = this.paint.get("heatmap-radius").evaluate(t, i);
                    return qp(e1, r, o, s, a, !0, !0, new y(0, 0), l);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getDefaultProgramParams(e1, t) {
                    return "heatmap" === e1 ? {
                        config: new Ql(this, t),
                        overrideFog: !1
                    } : {};
                }
                constructor(e1, t){
                    super(e1, nf, t), this._updateColorRamp();
                }
            },
            hillshade: class extends Ta {
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
                getDefaultProgramParams(e1, t) {
                    return {
                        overrideFog: !1
                    };
                }
                constructor(e1, t){
                    super(e1, af, t);
                }
            },
            fill: class extends Ta {
                getProgramIds() {
                    const e1 = this.paint.get("fill-pattern"), t = e1 && e1.constantOr(1), i = [
                        t ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && i.push(t && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), i;
                }
                getDefaultProgramParams(e1, t) {
                    return {
                        config: new Ql(this, t),
                        overrideFog: !1
                    };
                }
                recalculate(e1, t) {
                    super.recalculate(e1, t);
                    const i = this.paint._values["fill-outline-color"];
                    "constant" === i.value.kind && void 0 === i.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(e1) {
                    return new jf(e1);
                }
                queryRadius() {
                    return Op(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(e1, t, i, r, n, o) {
                    return !e1.queryGeometry.isAboveHorizon && Tp(Bp(e1.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), r);
                }
                isTileClipped() {
                    return !0;
                }
                constructor(e1, t){
                    super(e1, qf, t);
                }
            },
            "fill-extrusion": class extends Ta {
                createBucket(e1) {
                    return new vb(e1);
                }
                queryRadius() {
                    return Op(this.paint.get("fill-extrusion-translate"));
                }
                is3D() {
                    return !0;
                }
                hasShadowPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("fill-extrusion-cutoff-fade-range");
                }
                canCastShadows() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                queryIntersectsFeature(e1, t, i, r, n, o, s, a, l) {
                    const c = Fp(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), h = this.paint.get("fill-extrusion-height").evaluate(t, i), u = this.paint.get("fill-extrusion-base").evaluate(t, i), d = [
                        0,
                        0
                    ], p = a && o.elevation, f = o.elevation ? o.elevation.exaggeration() : 1, m = e1.tile.getBucket(this);
                    if (p && m instanceof vb) {
                        const e1 = m.centroidVertexArray, t = l + 1;
                        t < e1.length && (d[0] = e1.geta_centroid_pos0(t), d[1] = e1.geta_centroid_pos1(t));
                    }
                    if (0 === d[0] && 1 === d[1]) return !1;
                    "globe" === o.projection.name && (r = Cb([
                        r
                    ], [
                        new y(0, 0),
                        new y(cr, cr)
                    ], e1.tileID.canonical).map((e1)=>e1.polygon).flat());
                    const _ = p ? a : null, [g, x] = function(e1, t, i, r, n, o, s, a, l, c, h) {
                        return "globe" === e1.projection.name ? function(e1, t, i, r, n, o, s, a, l, c, h) {
                            const u = [], d = [], p = e1.projection.upVectorScale(h, e1.center.lat, e1.worldSize).metersToTile, f = [
                                0,
                                0,
                                0,
                                1
                            ], m = [
                                0,
                                0,
                                0,
                                1
                            ], _ = (e1, t, i, r)=>{
                                e1[0] = t, e1[1] = i, e1[2] = r, e1[3] = 1;
                            }, g = Ib();
                            i > 0 && (i += g), r += g;
                            for (const g of t){
                                const t = [], y = [];
                                for (const u of g){
                                    const d = u.x + n.x, g = u.y + n.y, x = e1.projection.projectTilePoint(d, g, h), v = e1.projection.upVector(h, u.x, u.y);
                                    let b = i, w = r;
                                    if (s) {
                                        const e1 = Ob(d, g, i, r, s, a, l, c);
                                        b += e1.base, w += e1.top;
                                    }
                                    0 !== i ? _(f, x.x + v[0] * p * b, x.y + v[1] * p * b, x.z + v[2] * p * b) : _(f, x.x, x.y, x.z), _(m, x.x + v[0] * p * w, x.y + v[1] * p * w, x.z + v[2] * p * w), Du.transformMat4(f, f, o), Du.transformMat4(m, m, o), t.push(new Rb(f[0], f[1], f[2])), y.push(new Rb(m[0], m[1], m[2]));
                                }
                                u.push(t), d.push(y);
                            }
                            return [
                                u,
                                d
                            ];
                        }(e1, t, i, r, n, o, s, a, l, c, h) : s ? function(e1, t, i, r, n, o, s, a, l) {
                            const c = [], h = [], u = [
                                0,
                                0,
                                0,
                                1
                            ];
                            for (const d of e1){
                                const e1 = [], p = [];
                                for (const c of d){
                                    const h = c.x + r.x, d = c.y + r.y, f = Ob(h, d, t, i, o, s, a, l);
                                    u[0] = h, u[1] = d, u[2] = f.base, u[3] = 1, yu.transformMat4(u, u, n), u[3] = Math.max(u[3], 1e-5);
                                    const m = new Rb(u[0] / u[3], u[1] / u[3], u[2] / u[3]);
                                    u[0] = h, u[1] = d, u[2] = f.top, u[3] = 1, yu.transformMat4(u, u, n), u[3] = Math.max(u[3], 1e-5);
                                    const _ = new Rb(u[0] / u[3], u[1] / u[3], u[2] / u[3]);
                                    e1.push(m), p.push(_);
                                }
                                c.push(e1), h.push(p);
                            }
                            return [
                                c,
                                h
                            ];
                        }(t, i, r, n, o, s, a, l, c) : function(e1, t, i, r, n) {
                            const o = [], s = [], a = n[8] * t, l = n[9] * t, c = n[10] * t, h = n[11] * t, u = n[8] * i, d = n[9] * i, p = n[10] * i, f = n[11] * i;
                            for (const t of e1){
                                const e1 = [], i = [];
                                for (const o of t){
                                    const t = o.x + r.x, s = o.y + r.y, m = n[0] * t + n[4] * s + n[12], _ = n[1] * t + n[5] * s + n[13], g = n[2] * t + n[6] * s + n[14], y = n[3] * t + n[7] * s + n[15], x = m + a, v = _ + l, b = g + c, w = Math.max(y + h, 1e-5), T = m + u, E = _ + d, M = g + p, A = Math.max(y + f, 1e-5);
                                    e1.push(new Rb(x / w, v / w, b / w)), i.push(new Rb(T / A, E / A, M / A));
                                }
                                o.push(e1), s.push(i);
                            }
                            return [
                                o,
                                s
                            ];
                        }(t, i, r, n, o);
                    }(o, r, u, h, c, s, _, d, f, o.center.lat, e1.tileID.canonical), v = e1.queryGeometry;
                    return function(e1, t, i) {
                        let r = 1 / 0;
                        Tp(i, t) && (r = kb(i, t[0]));
                        for(let n = 0; n < t.length; n++){
                            const o = t[n], s = e1[n];
                            for(let e1 = 0; e1 < o.length - 1; e1++){
                                const t = o[e1], n = [
                                    t,
                                    o[e1 + 1],
                                    s[e1 + 1],
                                    s[e1],
                                    t
                                ];
                                bp(i, n) && (r = Math.min(r, kb(i, n)));
                            }
                        }
                        return r !== 1 / 0 && r;
                    }(g, x, v.isPointQuery() ? v.screenBounds : v.screenGeometry);
                }
                constructor(e1, t){
                    super(e1, Db, t), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
            },
            line: class extends Ta {
                _handleSpecialPaintPropertyUpdate(e1) {
                    if ("line-gradient" === e1) {
                        const e1 = this._transitionablePaint._values["line-gradient"].value.expression;
                        this.stepInterpolant = e1._styleExpression && e1._styleExpression.expression instanceof Yr, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    }
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                widthExpression() {
                    return this._transitionablePaint._values["line-width"].value.expression;
                }
                recalculate(e1, t) {
                    super.recalculate(e1, t), this.paint._values["line-floorwidth"] = Zb.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e1);
                }
                createBucket(e1) {
                    return new Ey(e1);
                }
                getProgramIds() {
                    return [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                }
                getDefaultProgramParams(e1, t) {
                    const i = Gb(this);
                    return {
                        config: new Ql(this, t),
                        defines: i,
                        overrideFog: !1
                    };
                }
                queryRadius(e1) {
                    const t = e1, i = $b(kp("line-width", this, t), kp("line-gap-width", this, t)), r = kp("line-offset", this, t);
                    return i / 2 + Math.abs(r) + Op(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(e1, t, i, r, n, o) {
                    if (e1.queryGeometry.isAboveHorizon) return !1;
                    const s = Bp(e1.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), o.angle, e1.pixelToTileUnitsFactor), a = e1.pixelToTileUnitsFactor / 2 * $b(this.paint.get("line-width").evaluate(t, i), this.paint.get("line-gap-width").evaluate(t, i)), l = this.paint.get("line-offset").evaluate(t, i);
                    return l && (r = function(e1, t) {
                        const i = [], r = new y(0, 0);
                        for(let n = 0; n < e1.length; n++){
                            const o = e1[n], s = [];
                            for(let e1 = 0; e1 < o.length; e1++){
                                const i = o[e1], n = o[e1 + 1], a = 0 === e1 ? r : i.sub(o[e1 - 1])._unit()._perp(), l = e1 === o.length - 1 ? r : n.sub(i)._unit()._perp(), c = a._add(l)._unit();
                                c._mult(1 / (c.x * l.x + c.y * l.y)), s.push(c._mult(t)._add(i));
                            }
                            i.push(s);
                        }
                        return i;
                    }(r, l * e1.pixelToTileUnitsFactor)), function(e1, t, i) {
                        for(let r = 0; r < t.length; r++){
                            const n = t[r];
                            if (e1.length >= 3) {
                                for(let t = 0; t < n.length; t++)if (zp(e1, n[t])) return !0;
                            }
                            if (Ep(e1, n, i)) return !0;
                        }
                        return !1;
                    }(s, r, a);
                }
                isTileClipped() {
                    return !0;
                }
                constructor(e1, t){
                    super(e1, Fb, t), this.gradientVersion = 0;
                }
            },
            symbol: oy,
            background: class extends Ta {
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
                getDefaultProgramParams(e1, t) {
                    return {
                        overrideFog: !1
                    };
                }
                constructor(e1, t){
                    super(e1, Hb, t);
                }
            },
            raster: class extends Ta {
                getProgramIds() {
                    return [
                        "raster"
                    ];
                }
                hasColorMap() {
                    return !!this._transitionablePaint._values["raster-color"].value.value;
                }
                isLayerDraped(e1) {
                    return !(e1 && e1._source instanceof Jb) || !e1._source.onNorthPole && !e1._source.onSouthPole && 0 === this.paint.get("raster-elevation");
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "raster-color" !== e1 && "raster-color-range" !== e1 || this._updateColorRamp();
                }
                _updateColorRamp() {
                    if (!this.hasColorMap()) return;
                    const e1 = this._transitionablePaint._values["raster-color"].value.expression, [t, i] = this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({
                        zoom: 0
                    });
                    this.colorRamp = of({
                        expression: e1,
                        evaluationKey: "rasterValue",
                        image: this.colorRamp,
                        clips: [
                            {
                                start: t,
                                end: i
                            }
                        ],
                        resolution: 256
                    }), this.colorRampTexture = null;
                }
                constructor(e1, t){
                    super(e1, Yb, t), this._updateColorRamp();
                }
            },
            sky: class extends Ta {
                _handleSpecialPaintPropertyUpdate(e1) {
                    "sky-gradient" === e1 ? this._updateColorRamp() : "sky-atmosphere-sun" !== e1 && "sky-atmosphere-halo-color" !== e1 && "sky-atmosphere-color" !== e1 && "sky-atmosphere-sun-intensity" !== e1 || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    this.colorRamp = of({
                        expression: this._transitionablePaint._values["sky-gradient"].value.expression,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(e1) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const t = e1.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== t.azimuthal || this._lightPosition.polar !== t.polar;
                    }
                    return !1;
                }
                getCenter(e1, t) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const i = this.paint.get("sky-atmosphere-sun"), r = !i, n = e1.style.light, o = n.properties.get("position");
                        return r && "viewport" === n.properties.get("anchor") && H("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), r ? iw(o.azimuthal, 90 - o.polar, t) : iw(i[0], 90 - i[1], t);
                    }
                    const i = this.paint.get("sky-gradient-center");
                    return iw(i[0], 90 - i[1], t);
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(e1) {
                    this._skyboxInvalidated = !1, this._lightPosition = e1.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const e1 = this.paint.get("sky-type");
                    return "atmosphere" === e1 ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === e1 ? [
                        "skyboxGradient"
                    ] : null;
                }
                constructor(e1, t){
                    super(e1, tw, t), this._updateColorRamp();
                }
            },
            slot: class extends Ta {
                constructor(e1, t){
                    super(e1, rw);
                }
            },
            model: class extends Ta {
                createBucket(e1) {
                    return new Bv(e1);
                }
                getProgramIds() {
                    return [
                        "model"
                    ];
                }
                is3D() {
                    return !0;
                }
                hasShadowPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                hasLightBeamPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("model-cutoff-fade-range");
                }
                queryRadius() {
                    return 0;
                }
                queryIntersectsFeature() {
                    return !1;
                }
                _handleOverridablePaintPropertyUpdate(e1, t, i) {
                    return !(!this.layout || t.isDataDriven() || i.isDataDriven() || "model-color" !== e1 && "model-color-mix-intensity" !== e1 && "model-rotation" !== e1 && "model-scale" !== e1 && "model-translation" !== e1 && "model-emissive-strength" !== e1);
                }
                _isPropertyZoomDependent(e1) {
                    const t = this._transitionablePaint._values[e1];
                    return null != t && null != t.value && null != t.value.expression && t.value.expression instanceof Ao;
                }
                isZoomDependent() {
                    return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
                }
                constructor(e1, t){
                    super(e1, Nv, t);
                }
            }
        };
        function ow(e1, t) {
            return "custom" === e1.type ? new Qb(e1) : new nw[e1.type](e1, t);
        }
        function sw(e1) {
            const { userImage: t } = e1;
            return !!(t && t.render && t.render()) && (e1.data.replace(new Uint8Array(t.data.buffer)), !0);
        }
        class aw extends zt {
            createScope(e1) {
                this.images[e1] = {}, this.loaded[e1] = !1, this.updatedImages[e1] = {}, this.patterns[e1] = {}, this.callbackDispatchedThisFrame[e1] = {}, this.atlasImage[e1] = new ef({
                    width: 1,
                    height: 1
                });
            }
            isLoaded() {
                for(const e1 in this.loaded)if (!this.loaded[e1]) return !1;
                return !0;
            }
            setLoaded(e1, t) {
                if (this.loaded[t] !== e1 && (this.loaded[t] = e1, e1)) {
                    for (const { ids: e1, callback: i } of this.requestors)this._notify(e1, t, i);
                    this.requestors = [];
                }
            }
            hasImage(e1, t) {
                return !!this.getImage(e1, t);
            }
            getImage(e1, t) {
                return this.images[t][e1];
            }
            addImage(e1, t, i) {
                this._validate(e1, i) && (this.images[t][e1] = i);
            }
            _validate(e1, t) {
                let i = !0;
                return this._validateStretch(t.stretchX, t.data && t.data.width) || (this.fire(new Ct(new Error(`Image "${e1}" has invalid "stretchX" value`))), i = !1), this._validateStretch(t.stretchY, t.data && t.data.height) || (this.fire(new Ct(new Error(`Image "${e1}" has invalid "stretchY" value`))), i = !1), this._validateContent(t.content, t) || (this.fire(new Ct(new Error(`Image "${e1}" has invalid "content" value`))), i = !1), i;
            }
            _validateStretch(e1, t) {
                if (!e1) return !0;
                let i = 0;
                for (const r of e1){
                    if (r[0] < i || r[1] < r[0] || t < r[1]) return !1;
                    i = r[1];
                }
                return !0;
            }
            _validateContent(e1, t) {
                return !(e1 && (4 !== e1.length || e1[0] < 0 || t.data.width < e1[0] || e1[1] < 0 || t.data.height < e1[1] || e1[2] < 0 || t.data.width < e1[2] || e1[3] < 0 || t.data.height < e1[3] || e1[2] < e1[0] || e1[3] < e1[1]));
            }
            updateImage(e1, t, i) {
                i.version = this.images[t][e1].version + 1, this.images[t][e1] = i, this.updatedImages[t][e1] = !0;
            }
            removeImage(e1, t) {
                const i = this.images[t][e1];
                delete this.images[t][e1], delete this.patterns[t][e1], i.userImage && i.userImage.onRemove && i.userImage.onRemove();
            }
            listImages(e1) {
                return Object.keys(this.images[e1]);
            }
            getImages(e1, t, i) {
                let r = !0;
                const n = !!this.loaded[t];
                if (!n) for (const i of e1)this.images[t][i] || (r = !1);
                n || r ? this._notify(e1, t, i) : this.requestors.push({
                    ids: e1,
                    scope: t,
                    callback: i
                });
            }
            getUpdatedImages(e1) {
                return this.updatedImages[e1];
            }
            _notify(e1, t, i) {
                const r = {};
                for (const i of e1){
                    this.images[t][i] || this.fire(new It("styleimagemissing", {
                        id: i
                    }));
                    const e1 = this.images[t][i];
                    e1 ? r[i] = {
                        data: e1.data.clone(),
                        pixelRatio: e1.pixelRatio,
                        sdf: e1.sdf,
                        version: e1.version,
                        stretchX: e1.stretchX,
                        stretchY: e1.stretchY,
                        content: e1.content,
                        hasRenderCallback: Boolean(e1.userImage && e1.userImage.render)
                    } : H(`Image "${i}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                }
                i(null, r);
            }
            getPixelSize(e1) {
                const { width: t, height: i } = this.atlasImage[e1];
                return {
                    width: t,
                    height: i
                };
            }
            getPattern(e1, t) {
                const i = this.patterns[t][e1], r = this.getImage(e1, t);
                if (!r) return null;
                if (i && i.position.version === r.version) return i.position;
                if (i) i.position.version = r.version;
                else {
                    const i = {
                        w: r.data.width + 2,
                        h: r.data.height + 2,
                        x: 0,
                        y: 0
                    }, n = new Q_(i, r);
                    this.patterns[t][e1] = {
                        bin: i,
                        position: n
                    };
                }
                return this._updatePatternAtlas(t), this.patterns[t][e1].position;
            }
            bind(e1, t) {
                const i = e1.gl;
                let r = this.atlasTexture[t];
                r ? this.dirty && (r.update(this.atlasImage[t]), this.dirty = !1) : (r = new My(e1, this.atlasImage[t], i.RGBA), this.atlasTexture[t] = r), r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas(e1) {
                const t = [];
                for(const i in this.patterns[e1])t.push(this.patterns[e1][i].bin);
                const { w: i, h: r } = K_(t), n = this.atlasImage[e1];
                n.resize({
                    width: i || 1,
                    height: r || 1
                });
                for(const t in this.patterns[e1]){
                    const { bin: i } = this.patterns[e1][t], r = i.x + 1, o = i.y + 1, s = this.images[e1][t].data, a = s.width, l = s.height;
                    ef.copy(s, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: r,
                        y: o
                    }, {
                        width: a,
                        height: l
                    }), ef.copy(s, n, {
                        x: 0,
                        y: l - 1
                    }, {
                        x: r,
                        y: o - 1
                    }, {
                        width: a,
                        height: 1
                    }), ef.copy(s, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: r,
                        y: o + l
                    }, {
                        width: a,
                        height: 1
                    }), ef.copy(s, n, {
                        x: a - 1,
                        y: 0
                    }, {
                        x: r - 1,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    }), ef.copy(s, n, {
                        x: 0,
                        y: 0
                    }, {
                        x: r + a,
                        y: o
                    }, {
                        width: 1,
                        height: l
                    });
                }
                this.dirty = !0;
            }
            beginFrame() {
                for(const e1 in this.images)this.callbackDispatchedThisFrame[e1] = {};
            }
            dispatchRenderCallbacks(e1, t) {
                for (const i of e1){
                    if (this.callbackDispatchedThisFrame[t][i]) continue;
                    this.callbackDispatchedThisFrame[t][i] = !0;
                    const e1 = this.images[t][i];
                    sw(e1) && this.updateImage(i, t, e1);
                }
            }
            constructor(){
                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = {}, this.requestors = [], this.patterns = {}, this.atlasImage = {}, this.atlasTexture = {}, this.dirty = !0;
            }
        }
        const lw = new ga({
            anchor: new fa(Pt.light.anchor),
            position: new class {
                possiblyEvaluate(e1, t) {
                    return K(e1.expression.evaluate(t));
                }
                interpolate(e1, t, i) {
                    return {
                        x: Kr(e1.x, t.x, i),
                        y: Kr(e1.y, t.y, i),
                        z: Kr(e1.z, t.z, i),
                        azimuthal: Kr(e1.azimuthal, t.azimuthal, i),
                        polar: Kr(e1.polar, t.polar, i)
                    };
                }
                constructor(e1){
                    this.specification = e1;
                }
            }(Pt.light.position),
            color: new fa(Pt.light.color),
            intensity: new fa(Pt.light.intensity)
        });
        class cw extends zt {
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e1, t, i = {}) {
                this._validate(gs, e1, i) || (this._transitionable.setTransitionOrValue(e1), this.id = t);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(e1, t, i) {
                return (!i || !1 !== i.validate) && Ss(this, e1.call(ms, k({
                    value: t,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: Pt
                })));
            }
            constructor(e1, t = "flat"){
                super(), this._transitionable = new la(lw), this.setLight(e1, t), this._transitioning = this._transitionable.untransitioned();
            }
        }
        const hw = new ga({
            source: new fa(Pt.terrain.source),
            exaggeration: new fa(Pt.terrain.exaggeration)
        });
        let uw = class extends zt {
            get() {
                return this._transitionable.serialize();
            }
            set(e1, t) {
                this._transitionable.setTransitionOrValue(e1, t);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            getExaggeration(e1) {
                return this._transitioning.possiblyEvaluate(new oa(e1)).get("exaggeration");
            }
            isZoomDependent() {
                const e1 = this._transitionable._values.exaggeration;
                return null != e1 && null != e1.value && null != e1.value.expression && e1.value.expression instanceof Ao;
            }
            constructor(e1, t, i, r){
                super(), this.scope = i, this._transitionable = new la(hw, r), this._transitionable.setTransitionOrValue(e1, r), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = t;
            }
        };
        const dw = 45, pw = 65, fw = .05;
        function mw(e1, t, i, r) {
            const n = P(dw, pw, i), [o, s] = _w(e1, r);
            let a = 1 - Math.min(1, Math.exp((t - o) / (s - o) * -6));
            return a *= a * a, a = Math.min(1, 1.00747 * a), a * n * e1.alpha;
        }
        function _w(e1, t) {
            const i = .5 / Math.tan(.5 * t);
            return [
                e1.range[0] + i,
                e1.range[1] + i
            ];
        }
        function gw(e1, t, i, r, n) {
            const o = Du.transformMat4([], [
                t,
                i,
                r
            ], n.mercatorFogMatrix);
            return mw(e1, Du.length(o), n.pitch, n._fov);
        }
        function yw(e1, t, i, r, n, o, s) {
            const a = [
                [
                    i,
                    r,
                    0
                ],
                [
                    n,
                    r,
                    0
                ],
                [
                    n,
                    o,
                    0
                ],
                [
                    i,
                    o,
                    0
                ]
            ];
            let l = Number.MAX_VALUE, c = -Number.MAX_VALUE;
            for (const e1 of a){
                const i = Du.transformMat4([], e1, t), r = Du.length(i);
                l = Math.min(l, r), c = Math.max(c, r);
            }
            return [
                mw(e1, l, s.pitch, s._fov),
                mw(e1, c, s.pitch, s._fov)
            ];
        }
        const xw = new ga({
            range: new fa(Pt.fog.range),
            color: new fa(Pt.fog.color),
            "high-color": new fa(Pt.fog["high-color"]),
            "space-color": new fa(Pt.fog["space-color"]),
            "horizon-blend": new fa(Pt.fog["horizon-blend"]),
            "star-intensity": new fa(Pt.fog["star-intensity"]),
            "vertical-range": new fa(Pt.fog["vertical-range"])
        });
        class vw extends zt {
            get state() {
                const e1 = this._transform, t = "globe" === e1.projection.name, i = Dd(e1.zoom), r = this.properties.get("range"), n = [
                    .5,
                    3
                ];
                return {
                    range: t ? [
                        Kr(n[0], r[0], i),
                        Kr(n[1], r[1], i)
                    ] : r,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e1, t = {}) {
                if (this._validate(vs, e1, t)) return;
                const i = k({}, e1);
                for (const e1 of Object.keys(Pt.fog))void 0 === i[e1] && (i[e1] = Pt.fog[e1].default);
                this._transitionable.setTransitionOrValue(i);
            }
            getOpacity(e1) {
                if (!this._transform.projection.supportsFog) return 0;
                const t = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : P(dw, pw, e1)) * t.a;
            }
            getOpacityAtLatLng(e1, t) {
                return this._transform.projection.supportsFog ? function(e1, t, i) {
                    const r = lp.fromLngLat(t), n = i.elevation ? i.elevation.getAtPointOrZero(r) : 0;
                    return gw(e1, r.x, r.y, n, i);
                }(this.state, e1, t) : 0;
            }
            getOpacityForTile(e1) {
                if (!this._transform.projection.supportsFog) return [
                    1,
                    1
                ];
                const t = this._transform.calculateFogTileMatrix(e1.toUnwrapped());
                return yw(this.state, t, 0, 0, cr, cr, this._transform);
            }
            getOpacityForBounds(e1, t, i, r, n) {
                return this._transform.projection.supportsFog ? yw(this.state, e1, t, i, r, n, this._transform) : [
                    1,
                    1
                ];
            }
            getFovAdjustedRange(e1) {
                return this._transform.projection.supportsFog ? _w(this.state, e1) : [
                    0,
                    1
                ];
            }
            isVisibleOnFrustum(e1) {
                if (!this._transform.projection.supportsFog) return !1;
                const t = [
                    4,
                    5,
                    6,
                    7
                ];
                for (const i of t){
                    const t = e1.points[i];
                    let r;
                    if (t[2] >= 0) r = t;
                    else {
                        const n = e1.points[i - 4];
                        r = Jr(n, t, n[2] / (n[2] - t[2]));
                    }
                    if (gw(this.state, r[0], r[1], 0, this._transform) >= fw) return !0;
                }
                return !1;
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(e1, t, i) {
                return (!i || !1 !== i.validate) && Ss(this, e1.call(ms, k({
                    value: t,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: Pt
                })));
            }
            constructor(e1, t){
                super(), this._transitionable = new la(xw), this.set(e1), this._transitioning = this._transitionable.untransitioned(), this._transform = t;
            }
        }
        class bw {
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel = void 0, this._callback = ()=>{};
            }
            constructor(e1){
                this._callback = e1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
        }
        class ww {
            add(e1, t) {
                const i = this.nextId++, r = function({ type: e1, isSymbolTile: t, zoom: i }) {
                    return i = i || 0, "message" === e1 ? 0 : "maybePrepare" !== e1 || t ? "parseTile" !== e1 || t ? "parseTile" === e1 && t ? 300 - i : "maybePrepare" === e1 && t ? 400 - i : 500 : 200 - i : 100 - i;
                }(t);
                if (0 === r) {
                    Q();
                    e1();
                    return {
                        cancel: ()=>{}
                    };
                }
                return this.tasks[i] = {
                    fn: e1,
                    metadata: t,
                    priority: r,
                    id: i
                }, this.taskQueue.push(i), this.invoker.trigger(), {
                    cancel: ()=>{
                        delete this.tasks[i];
                    }
                };
            }
            process() {
                Q();
                {
                    if (this.taskQueue = this.taskQueue.filter((e1)=>!!this.tasks[e1]), !this.taskQueue.length) return;
                    const e1 = this.pick();
                    if (null === e1) return;
                    const t = this.tasks[e1];
                    if (delete this.tasks[e1], this.taskQueue.length && this.invoker.trigger(), !t) return;
                    t.fn();
                }
            }
            pick() {
                let e1 = null, t = 1 / 0;
                for(let i = 0; i < this.taskQueue.length; i++){
                    const r = this.tasks[this.taskQueue[i]];
                    r.priority < t && (t = r.priority, e1 = i);
                }
                if (null === e1) return null;
                const i = this.taskQueue[e1];
                return this.taskQueue.splice(e1, 1), i;
            }
            remove() {
                this.invoker.remove();
            }
            constructor(){
                this.tasks = {}, this.taskQueue = [], j([
                    "process"
                ], this), this.invoker = new bw(this.process), this.nextId = 0;
            }
        }
        class Tw {
            send(e1, t, i, r, n = !1, o) {
                const s = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                i && (i.metadata = o, this.callbacks[s] = i);
                const a = new Set;
                return this.target.postMessage({
                    id: s,
                    type: e1,
                    hasCallback: !!i,
                    targetMapId: r,
                    mustQueue: n,
                    sourceMapId: this.mapId,
                    data: Os(t, a)
                }, a), {
                    cancel: ()=>{
                        i && delete this.callbacks[s], this.target.postMessage({
                            id: s,
                            type: "<cancel>",
                            targetMapId: r,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(e1) {
                const t = e1.data, i = t.id;
                if (i && (!t.targetMapId || this.mapId === t.targetMapId)) {
                    if ("<cancel>" === t.type) {
                        const e1 = this.cancelCallbacks[i];
                        delete this.cancelCallbacks[i], e1 && e1.cancel();
                    } else if (t.mustQueue || Q()) {
                        const e1 = this.callbacks[i];
                        this.cancelCallbacks[i] = this.scheduler.add(()=>this.processTask(i, t), e1 && e1.metadata || {
                            type: "message"
                        });
                    } else this.processTask(i, t);
                }
            }
            processTask(e1, t) {
                if ("<response>" === t.type) {
                    const i = this.callbacks[e1];
                    delete this.callbacks[e1], i && (t.error ? i(Bs(t.error)) : i(null, Bs(t.data)));
                } else {
                    const i = new Set, r = t.hasCallback ? (t, r)=>{
                        delete this.cancelCallbacks[e1], this.target.postMessage({
                            id: e1,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: t ? Os(t) : null,
                            data: Os(r, i)
                        }, i);
                    } : (e1)=>{}, n = Bs(t.data);
                    if (this.parent[t.type]) this.parent[t.type](t.sourceMapId, n, r);
                    else if (this.parent.getWorkerSource) {
                        const e1 = t.type.split(".");
                        this.parent.getWorkerSource(t.sourceMapId, e1[0], n.source, n.scope)[e1[1]](n, r);
                    } else r(new Error(`Could not find function ${t.type}`));
                }
            }
            remove() {
                this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
            constructor(e1, t, i){
                this.target = e1, this.parent = t, this.mapId = i, this.callbacks = {}, this.cancelCallbacks = {}, j([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new ww;
            }
        }
        class Ew {
            broadcast(e1, t, i) {
                R(this.actors, (i, r)=>{
                    i.send(e1, t, r);
                }, i = i || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((e1)=>{
                    e1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
            constructor(e1, t){
                this.workerPool = e1, this.actors = [], this.currentActor = 0, this.id = F();
                const i = this.workerPool.acquire(this.id);
                for(let e1 = 0; e1 < i.length; e1++){
                    const r = new Ew.Actor(i[e1], t, this.id);
                    r.name = `Worker ${e1}`, this.actors.push(r);
                }
                this.ready = !1, this.broadcast("checkIfReady", null, ()=>{
                    this.ready = !0;
                });
            }
        }
        Ew.Actor = Tw;
        class Mw extends zt {
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._options.properties, new Map(e1));
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            get() {
                return this._options.properties = this._transitionable.serialize(), this._options;
            }
            set(e1, t) {
                this._options = e1, this._transitionable.setTransitionOrValue(e1.properties, t);
            }
            shadowsEnabled() {
                return !!this.properties && !0 === this.properties.get("cast-shadows");
            }
            constructor(e1, t, i, r){
                super(), this.scope = i, this._options = e1, this.properties = new pa(t), this._transitionable = new la(t, new Map(r)), this._transitionable.setTransitionOrValue(e1.properties), this._transitioning = this._transitionable.untransitioned();
            }
        }
        const Aw = new ga({
            color: new fa(Pt.properties_light_ambient.color),
            intensity: new fa(Pt.properties_light_ambient.intensity)
        }), Sw = new ga({
            direction: new class {
                possiblyEvaluate(e1, t) {
                    return function([e1, t]) {
                        const i = K([
                            1,
                            e1,
                            t
                        ]);
                        return {
                            x: i.x,
                            y: i.y,
                            z: i.z
                        };
                    }(e1.expression.evaluate(t));
                }
                interpolate(e1, t, i) {
                    return {
                        x: Kr(e1.x, t.x, i),
                        y: Kr(e1.y, t.y, i),
                        z: Kr(e1.z, t.z, i)
                    };
                }
                constructor(e1){
                    this.specification = e1;
                }
            }(Pt.properties_light_directional.direction),
            color: new fa(Pt.properties_light_directional.color),
            intensity: new fa(Pt.properties_light_directional.intensity),
            "cast-shadows": new fa(Pt.properties_light_directional["cast-shadows"]),
            "shadow-intensity": new fa(Pt.properties_light_directional["shadow-intensity"])
        });
        class Iw {
            static createFromScreenPoints(e1, t) {
                let i, r;
                if (e1 instanceof y || "number" == typeof e1[0]) {
                    const n = y.convert(e1);
                    i = [
                        n
                    ], r = t.isPointAboveHorizon(n);
                } else {
                    const n = y.convert(e1[0]), o = y.convert(e1[1]);
                    i = [
                        n,
                        o
                    ], r = S(n, o).every((e1)=>t.isPointAboveHorizon(e1));
                }
                return new Iw(i, t.getCameraPoint(), r, t);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(e1) {
                return S(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], e1);
            }
            bufferedCameraGeometry(e1) {
                const t = this.screenBounds[0], i = 1 === this.screenBounds.length ? this.screenBounds[0].add(new y(1, 1)) : this.screenBounds[1], r = S(t, i, 0, !1);
                return this.cameraPoint.y > i.y && (this.cameraPoint.x > t.x && this.cameraPoint.x < i.x ? r.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= i.x ? r[2] = this.cameraPoint : this.cameraPoint.x <= t.x && (r[3] = this.cameraPoint)), function(e1, t) {
                    const i = [];
                    for(let r = 0; r < e1.length; r++){
                        const n = D(r - 1, -1, e1.length - 1), o = D(r + 1, -1, e1.length - 1), s = e1[r], a = e1[o], l = e1[n].sub(s).unit(), c = a.sub(s).unit(), h = c.angleWithSep(l.x, l.y), u = l.add(c).unit().mult(-1 * t / Math.sin(h / 2));
                        i.push(s.add(u));
                    }
                    return i;
                }(r, e1);
            }
            bufferedCameraGeometryGlobe(e1) {
                const t = this.screenBounds[0], i = 1 === this.screenBounds.length ? this.screenBounds[0].add(new y(1, 1)) : this.screenBounds[1], r = S(t, i, e1), n = this.cameraPoint.clone();
                switch(3 * ((n.y > t.y) + (n.y > i.y)) + ((n.x > t.x) + (n.x > i.x))){
                    case 0:
                        r[0] = n, r[4] = n.clone();
                        break;
                    case 1:
                        r.splice(1, 0, n);
                        break;
                    case 2:
                        r[1] = n;
                        break;
                    case 3:
                        r.splice(4, 0, n);
                        break;
                    case 5:
                        r.splice(2, 0, n);
                        break;
                    case 6:
                        r[3] = n;
                        break;
                    case 7:
                        r.splice(3, 0, n);
                        break;
                    case 8:
                        r[2] = n;
                }
                return r;
            }
            containsTile(e1, t, i, r = 0) {
                const n = e1.queryPadding / t._pixelsPerMercatorPixel + 1, o = i ? this._bufferedCameraMercator(n, t) : this._bufferedScreenMercator(n, t);
                let s = e1.tileID.wrap + (o.unwrapped ? r : 0);
                const a = o.polygon.map((t)=>Rg(e1.tileTransform, t, s));
                if (!Pp(a, 0, 0, cr, cr)) return;
                s = e1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? r : 0);
                const l = this.screenGeometryMercator.polygon.map((t)=>Lg(e1.tileTransform, t, s)), c = l.map((e1)=>new y(e1[0], e1[1])), h = t.getFreeCameraOptions().position || new lp(0, 0, 0), u = Lg(e1.tileTransform, h, s), d = l.map((e1)=>{
                    const t = Du.sub(e1, e1, u);
                    return Du.normalize(t, t), new Wu(u, t);
                }), p = rv(e1, 1, t.zoom) * t._pixelsPerMercatorPixel;
                var f;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: c,
                    tilespaceRays: d,
                    bufferedTilespaceGeometry: a,
                    bufferedTilespaceBounds: (f = A(a), f.min.x = z(f.min.x, 0, cr), f.min.y = z(f.min.y, 0, cr), f.max.x = z(f.max.x, 0, cr), f.max.y = z(f.max.y, 0, cr), f),
                    tile: e1,
                    tileID: e1.tileID,
                    pixelToTileUnitsFactor: p
                };
            }
            _bufferedScreenMercator(e1, t) {
                const i = Pw(e1);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let r;
                    return r = "globe" === t.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e1), t) : {
                        polygon: this.bufferedScreenGeometry(e1).map((e1)=>t.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = r, r;
                }
            }
            _bufferedCameraMercator(e1, t) {
                const i = Pw(e1);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let r;
                    return r = "globe" === t.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e1), t) : {
                        polygon: this.bufferedCameraGeometry(e1).map((e1)=>t.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = r, r;
                }
            }
            _projectAndResample(e1, t) {
                const i = function(e1, t) {
                    const i = Au.multiply([], t.pixelMatrix, t.globeMatrix), r = [
                        0,
                        -rd,
                        0,
                        1
                    ], n = [
                        0,
                        rd,
                        0,
                        1
                    ], o = [
                        0,
                        0,
                        0,
                        1
                    ];
                    yu.transformMat4(r, r, i), yu.transformMat4(n, n, i), yu.transformMat4(o, o, i);
                    const s = new y(r[0] / r[3], r[1] / r[3]), a = new y(n[0] / n[3], n[1] / n[3]), l = zp(e1, s) && r[3] < o[3], c = zp(e1, a) && n[3] < o[3];
                    if (!l && !c) return null;
                    const h = function(e1, t, i) {
                        for(let r = 1; r < e1.length; r++){
                            const n = zw(t.pointCoordinate3D(e1[r - 1]).x), o = zw(t.pointCoordinate3D(e1[r]).x);
                            if (i < 0) {
                                if (n < o) return {
                                    idx: r,
                                    t: -n / (o - 1 - n)
                                };
                            } else if (o < n) return {
                                idx: r,
                                t: (1 - n) / (o + 1 - n)
                            };
                        }
                        return null;
                    }(e1, t, l ? -1 : 1);
                    if (!h) return null;
                    const { idx: u, t: d } = h;
                    let p = u > 1 ? Cw(e1.slice(0, u), t) : [], f = u < e1.length ? Cw(e1.slice(u), t) : [];
                    p = p.map((e1)=>new y(zw(e1.x), e1.y)), f = f.map((e1)=>new y(zw(e1.x), e1.y));
                    const m = [
                        ...p
                    ];
                    0 === m.length && m.push(f[f.length - 1]);
                    const _ = Kr(m[m.length - 1].y, (0 === f.length ? p[0] : f[0]).y, d);
                    let g;
                    return g = l ? [
                        new y(0, _),
                        new y(0, 0),
                        new y(1, 0),
                        new y(1, _)
                    ] : [
                        new y(1, _),
                        new y(1, 1),
                        new y(0, 1),
                        new y(0, _)
                    ], m.push(...g), 0 === f.length ? m.push(p[0]) : m.push(...f), {
                        polygon: m.map((e1)=>new lp(e1.x, e1.y)),
                        unwrapped: !1
                    };
                }(e1, t);
                if (i) return i;
                const r = function(e1, t) {
                    let i = !1, r = -1 / 0, n = 0;
                    for(let t = 0; t < e1.length - 1; t++)e1[t].x > r && (r = e1[t].x, n = t);
                    for(let t = 0; t < e1.length - 1; t++){
                        const r = (n + t) % (e1.length - 1), o = e1[r], s = e1[r + 1];
                        Math.abs(o.x - s.x) > .5 && (o.x < s.x ? (o.x += 1, 0 === r && (e1[e1.length - 1].x += 1)) : (s.x += 1, r + 1 === e1.length - 1 && (e1[0].x += 1)), i = !0);
                    }
                    const o = Kd(t.center.lng);
                    return i && o < Math.abs(o - 1) && e1.forEach((e1)=>{
                        e1.x -= 1;
                    }), {
                        polygon: e1,
                        unwrapped: i
                    };
                }(Cw(e1, t).map((e1)=>new y(zw(e1.x), e1.y)), t);
                return {
                    polygon: r.polygon.map((e1)=>new lp(e1.x, e1.y)),
                    unwrapped: r.unwrapped
                };
            }
            constructor(e1, t, i, r){
                this.screenBounds = e1, this.cameraPoint = t, this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = i, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, r);
            }
        }
        function Cw(e1, t) {
            return hp(e1, (e1)=>{
                const i = t.pointCoordinate3D(e1);
                e1.x = i.x, e1.y = i.y;
            }, 1 / 256);
        }
        function zw(e1) {
            return e1 < 0 ? 1 + e1 % 1 : e1 % 1;
        }
        function Pw(e1) {
            return 100 * e1 | 0;
        }
        function Dw(e1, t, i, r, n) {
            const o = function(i, r) {
                if (i) return n(i);
                if (r) {
                    e1.url && r.tiles && e1.tiles && delete e1.tiles;
                    const i = O(k(r, e1), [
                        "tiles",
                        "minzoom",
                        "maxzoom",
                        "attribution",
                        "mapbox_logo",
                        "bounds",
                        "scheme",
                        "tileSize",
                        "encoding"
                    ]);
                    r.vector_layers && (i.vectorLayers = r.vector_layers, i.vectorLayerIds = i.vectorLayers.map((e1)=>e1.id)), i.tiles = t.canonicalizeTileset(i, e1.url), n(null, i);
                }
            };
            return e1.url ? we(t.transformRequest(t.normalizeSourceURL(e1.url, null, i, r), ye.Source), o) : dt.frame(()=>o(null, e1));
        }
        class Rw {
            validateBounds(e1) {
                return Array.isArray(e1) && 4 === e1.length ? [
                    Math.max(-180, e1[0]),
                    Math.max(-90, e1[1]),
                    Math.min(180, e1[2]),
                    Math.min(90, e1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            contains(e1) {
                const t = Math.pow(2, e1.z), i = Math.floor(Kd(this.bounds.getWest()) * t), r = Math.floor(Jd(this.bounds.getNorth()) * t), n = Math.ceil(Kd(this.bounds.getEast()) * t), o = Math.ceil(Jd(this.bounds.getSouth()) * t);
                return e1.x >= i && e1.x < n && e1.y >= r && e1.y < o;
            }
            constructor(e1, t, i){
                this.bounds = sc.convert(this.validateBounds(e1)), this.minzoom = t || 0, this.maxzoom = i || 24;
            }
        }
        class Lw {
            getDash(e1, t) {
                const i = this.getKey(e1, t);
                return this.positions[i];
            }
            trim() {
                const e1 = this.width, t = this.height = U(this.nextRow);
                this.image.resize({
                    width: e1,
                    height: t
                });
            }
            getKey(e1, t) {
                return e1.join(",") + t;
            }
            getDashRanges(e1, t, i) {
                const r = [];
                let n = e1.length % 2 == 1 ? -e1[e1.length - 1] * i : 0, o = e1[0] * i, s = !0;
                r.push({
                    left: n,
                    right: o,
                    isDash: s,
                    zeroLength: 0 === e1[0]
                });
                let a = e1[0];
                for(let t = 1; t < e1.length; t++){
                    s = !s;
                    const l = e1[t];
                    n = a * i, a += l, o = a * i, r.push({
                        left: n,
                        right: o,
                        isDash: s,
                        zeroLength: 0 === l
                    });
                }
                return r;
            }
            addRoundDash(e1, t, i) {
                const r = t / 2;
                for(let t = -i; t <= i; t++){
                    const n = this.width * (this.nextRow + i + t);
                    let o = 0, s = e1[o];
                    for(let a = 0; a < this.width; a++){
                        a / s.right > 1 && (s = e1[++o]);
                        const l = Math.abs(a - s.left), c = Math.abs(a - s.right), h = Math.min(l, c);
                        let u;
                        const d = t / i * (r + 1);
                        if (s.isDash) {
                            const e1 = r - Math.abs(d);
                            u = Math.sqrt(h * h + e1 * e1);
                        } else u = r - Math.sqrt(h * h + d * d);
                        this.image.data[n + a] = Math.max(0, Math.min(255, u + 128));
                    }
                }
            }
            addRegularDash(e1, t) {
                for(let t = e1.length - 1; t >= 0; --t){
                    const i = e1[t], r = e1[t + 1];
                    i.zeroLength ? e1.splice(t, 1) : r && r.isDash === i.isDash && (r.left = i.left, e1.splice(t, 1));
                }
                const i = e1[0], r = e1[e1.length - 1];
                i.isDash === r.isDash && (i.left = r.left - this.width, r.right = i.right + this.width);
                const n = this.width * this.nextRow;
                let o = 0, s = e1[o];
                for(let i = 0; i < this.width; i++){
                    i / s.right > 1 && (s = e1[++o]);
                    const r = Math.abs(i - s.left), a = Math.abs(i - s.right), l = Math.min(r, a);
                    this.image.data[n + i] = Math.max(0, Math.min(255, (s.isDash ? l : -l) + t + 128));
                }
            }
            addDash(e1, t) {
                const i = this.getKey(e1, t);
                if (this.positions[i]) return this.positions[i];
                const r = "round" === t, n = r ? 7 : 0, o = 2 * n + 1;
                if (this.nextRow + o > this.height) return H("LineAtlas out of space"), null;
                0 === e1.length && e1.push(1);
                let s = 0;
                for(let t = 0; t < e1.length; t++)e1[t] < 0 && (H("Negative value is found in line dasharray, replacing values with 0"), e1[t] = 0), s += e1[t];
                if (0 !== s) {
                    const i = this.width / s, o = this.getDashRanges(e1, this.width, i);
                    r ? this.addRoundDash(o, i, n) : this.addRegularDash(o, "square" === t ? .5 * i : 0);
                }
                const a = this.nextRow + n;
                this.nextRow += o;
                const l = {
                    tl: [
                        a,
                        n
                    ],
                    br: [
                        s,
                        0
                    ]
                };
                return this.positions[i] = l, l;
            }
            constructor(e1, t){
                this.width = e1, this.height = t, this.nextRow = 0, this.image = new Qp({
                    width: e1,
                    height: t
                }), this.positions = {}, this.uploaded = !1;
            }
        }
        Rs(Lw, "LineAtlas");
        const kw = 1 * ng;
        class Ow {
            constructor(e1){
                const t = {}, i = [];
                for(const r in e1){
                    const n = e1[r], o = t[r] = {};
                    for(const e1 in n.glyphs){
                        const t = n.glyphs[+e1];
                        if (!t || 0 === t.bitmap.width || 0 === t.bitmap.height) continue;
                        const r = t.metrics.localGlyph ? kw : 1, s = {
                            x: 0,
                            y: 0,
                            w: t.bitmap.width + 2 * r,
                            h: t.bitmap.height + 2 * r
                        };
                        i.push(s), o[e1] = s;
                    }
                }
                const { w: r, h: n } = K_(i), o = new Qp({
                    width: r || 1,
                    height: n || 1
                });
                for(const i in e1){
                    const r = e1[i];
                    for(const e1 in r.glyphs){
                        const n = r.glyphs[+e1];
                        if (!n || 0 === n.bitmap.width || 0 === n.bitmap.height) continue;
                        const s = t[i][e1], a = n.metrics.localGlyph ? kw : 1;
                        Qp.copy(n.bitmap, o, {
                            x: 0,
                            y: 0
                        }, {
                            x: s.x + a,
                            y: s.y + a
                        }, n.bitmap);
                    }
                }
                this.image = o, this.positions = t;
            }
        }
        Rs(Ow, "GlyphAtlas");
        class Bw {
            parse(e1, t, i, r, n) {
                this.status = "parsing", this.data = e1, this.collisionBoxArray = new al;
                const o = new dm(Object.keys(e1.layers).sort()), s = new Qm(this.tileID, this.promoteId);
                s.bucketLayerIDs = [];
                const a = {}, l = new Lw(256, 256), c = {
                    featureIndex: s,
                    iconDependencies: {},
                    patternDependencies: {},
                    glyphDependencies: {},
                    lineAtlas: l,
                    availableImages: i,
                    brightness: this.brightness
                }, h = t.familiesBySource[this.source];
                for(const t in h){
                    const r = e1.layers[t];
                    if (!r) continue;
                    let n = !1, l = !1, u = !1;
                    for (const e1 of h[t])"symbol" === e1[0].type ? n = !0 : l = !0, e1[0].is3D() && "model" !== e1[0].type && (u = !0);
                    if (this.extraShadowCaster && !u) continue;
                    if (!0 === this.isSymbolTile && !n) continue;
                    if (!1 === this.isSymbolTile && !l) continue;
                    1 === r.version && H(`Vector tile source "${this.source}" layer "${t}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const d = o.encode(t), p = [];
                    for(let e1 = 0; e1 < r.length; e1++){
                        const i = r.feature(e1), n = s.getId(i, t);
                        p.push({
                            feature: i,
                            id: n,
                            index: e1,
                            sourceLayerIndex: d
                        });
                    }
                    for (const e1 of h[t]){
                        const t = e1[0];
                        (!this.extraShadowCaster || t.is3D() && "model" !== t.type) && (void 0 !== this.isSymbolTile && "symbol" === t.type !== this.isSymbolTile || t.minzoom && this.zoom < Math.floor(t.minzoom) || t.maxzoom && this.zoom >= t.maxzoom || "none" !== t.visibility && (Fw(e1, this.zoom, c.brightness, i), (a[t.id] = t.createBucket({
                            index: s.bucketLayerIDs.length,
                            layers: e1,
                            zoom: this.zoom,
                            canonical: this.canonical,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: d,
                            sourceID: this.source,
                            projection: this.projection.spec
                        })).populate(p, c, this.tileID.canonical, this.tileTransform), s.bucketLayerIDs.push(e1.map((e1)=>e1.id))));
                    }
                }
                let u, d, p, f;
                l.trim();
                const m = {
                    type: "maybePrepare",
                    isSymbolTile: this.isSymbolTile,
                    zoom: this.zoom
                }, _ = ()=>{
                    if (u) return this.status = "done", n(u);
                    if (this.extraShadowCaster) this.status = "done", n(null, {
                        buckets: L(a).filter((e1)=>!e1.isEmpty()),
                        featureIndex: s,
                        collisionBoxArray: null,
                        glyphAtlasImage: null,
                        lineAtlas: null,
                        imageAtlas: null,
                        brightness: c.brightness,
                        glyphMap: null,
                        iconMap: null,
                        glyphPositions: null
                    });
                    else if (d && p && f) {
                        const e1 = new Ow(d), t = new eg(p, f);
                        for(const r in a){
                            const n = a[r];
                            n instanceof gy ? (Fw(n.layers, this.zoom, c.brightness, i), vg(n, d, e1.positions, p, t.iconPositions, this.showCollisionBoxes, i, this.tileID.canonical, this.tileZoom, this.projection, this.brightness)) : n.hasPattern && (n instanceof Ey || n instanceof jf || n instanceof vb) && (Fw(n.layers, this.zoom, c.brightness, i), n.addFeatures(c, this.tileID.canonical, t.patternPositions, i, this.tileTransform, this.brightness));
                        }
                        this.status = "done", n(null, {
                            buckets: L(a).filter((e1)=>!e1.isEmpty()),
                            featureIndex: s,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: e1.image,
                            lineAtlas: l,
                            imageAtlas: t,
                            brightness: c.brightness
                        });
                    }
                };
                if (!this.extraShadowCaster) {
                    const e1 = q(c.glyphDependencies, (e1)=>Object.keys(e1).map(Number));
                    Object.keys(e1).length ? r.send("getGlyphs", {
                        uid: this.uid,
                        stacks: e1,
                        scope: this.scope
                    }, (e1, t)=>{
                        u || (u = e1, d = t, _());
                    }, void 0, !1, m) : d = {};
                    const t = Object.keys(c.iconDependencies);
                    t.length ? r.send("getImages", {
                        icons: t,
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        type: "icons"
                    }, (e1, t)=>{
                        u || (u = e1, p = t, _());
                    }, void 0, !1, m) : p = {};
                    const i = Object.keys(c.patternDependencies);
                    i.length ? r.send("getImages", {
                        icons: i,
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        type: "patterns"
                    }, (e1, t)=>{
                        u || (u = e1, f = t, _());
                    }, void 0, !1, m) : f = {};
                }
                _();
            }
            constructor(e1){
                this.tileID = new qu(e1.tileID.overscaledZ, e1.tileID.wrap, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y), this.tileZoom = e1.tileZoom, this.uid = e1.uid, this.zoom = e1.zoom, this.canonical = e1.tileID.canonical, this.pixelRatio = e1.pixelRatio, this.tileSize = e1.tileSize, this.source = e1.source, this.scope = e1.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = e1.showCollisionBoxes, this.collectResourceTiming = !!e1.collectResourceTiming, this.promoteId = e1.promoteId, this.isSymbolTile = e1.isSymbolTile, this.tileTransform = Pg(e1.tileID.canonical, e1.projection), this.projection = e1.projection, this.brightness = e1.brightness, this.extraShadowCaster = !!e1.extraShadowCaster;
            }
        }
        function Fw(e1, t, i, r) {
            const n = new oa(t, {
                brightness: i
            });
            for (const t of e1)t.recalculate(n, r);
        }
        class Nw {
            request(e1, t, i, r) {
                const n = this.entries[e1] = this.entries[e1] || {
                    callbacks: []
                };
                if (n.result) {
                    const [e1, i] = n.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        r(e1, i);
                    }, t) : r(e1, i), ()=>{};
                }
                return n.callbacks.push(r), n.cancel || (n.cancel = i((i, r)=>{
                    n.result = [
                        i,
                        r
                    ];
                    for (const e1 of n.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        e1(i, r);
                    }, t) : e1(i, r);
                    setTimeout(()=>delete this.entries[e1], 3e3);
                })), ()=>{
                    n.result || (n.callbacks = n.callbacks.filter((e1)=>e1 !== r), n.callbacks.length || (n.cancel(), delete this.entries[e1]));
                };
            }
            constructor(e1){
                this.entries = {}, this.scheduler = e1;
            }
        }
        function Uw(e1, t, i) {
            const r = JSON.stringify(e1.request);
            return e1.data && (this.deduped.entries[r] = {
                result: [
                    null,
                    e1.data
                ]
            }), this.deduped.request(r, {
                type: "parseTile",
                isSymbolTile: e1.isSymbolTile,
                zoom: e1.tileZoom
            }, (t)=>{
                const r = Te(e1.request, (e1, r, n, o)=>{
                    e1 ? t(e1) : r && t(null, {
                        vectorTile: i ? void 0 : new cm(new km(r)),
                        rawData: r,
                        cacheControl: n,
                        expires: o
                    });
                });
                return ()=>{
                    r.cancel(), t();
                };
            }, t);
        }
        class Vw extends zt {
            load(e1) {
                this._loaded = !1, this.fire(new It("dataloading", {
                    dataType: "source"
                }));
                const t = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, i = this.map._worldview;
                this._tileJSONRequest = Dw(this._options, this.map._requestManager, t, i, (r, n)=>{
                    this._tileJSONRequest = null, this._loaded = !0, r ? (t && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${t}`), i && 2 !== i.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${i}`), this.fire(new Ct(r))) : n && (k(this, n), n.bounds && (this.tileBounds = new Rw(n.bounds, this.minzoom, this.maxzoom)), Ge(n.tiles, this.map._requestManager._customAccessToken), this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), e1 && e1(r);
                });
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const e1 = va(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(e1));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove() {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return k({}, this._options);
            }
            loadTile(e1, t) {
                const i = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme)), r = {
                    request: this.map._requestManager.transformRequest(i, ye.Tile),
                    data: void 0,
                    uid: e1.uid,
                    tileID: e1.tileID,
                    tileZoom: e1.tileZoom,
                    zoom: e1.tileID.overscaledZ,
                    tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    pixelRatio: dt.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId,
                    isSymbolTile: e1.isSymbolTile,
                    brightness: this.map.style && this.map.style.getBrightness() || 0,
                    extraShadowCaster: e1.isExtraShadowCaster
                };
                if (r.request.collectResourceTiming = this._collectResourceTiming, e1.actor && "expired" !== e1.state) "loading" === e1.state ? e1.reloadCallback = t : e1.request = e1.actor.send("reloadTile", r, n.bind(this));
                else if (e1.actor = this._tileWorkers[i] = this._tileWorkers[i] || this.dispatcher.getActor(), this.dispatcher.ready) e1.request = e1.actor.send("loadTile", r, n.bind(this), void 0, !0);
                else {
                    const t = Uw.call({
                        deduped: this._deduped
                    }, r, (t, i)=>{
                        t || !i ? n.call(this, t) : (r.data = {
                            cacheControl: i.cacheControl,
                            expires: i.expires,
                            rawData: i.rawData.slice(0)
                        }, e1.actor && e1.actor.send("loadTile", r, n.bind(this), void 0, !0));
                    }, !0);
                    e1.request = {
                        cancel: t
                    };
                }
                function n(i, r) {
                    return delete e1.request, e1.aborted ? t(null) : i && 404 !== i.status ? t(i) : (r && r.resourceTiming && (e1.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && r && e1.setExpiryData(r), e1.loadVectorData(r, this.map.painter), ge(this.dispatcher), t(null), void (e1.reloadCallback && (this.loadTile(e1, e1.reloadCallback), e1.reloadCallback = null)));
                }
            }
            abortTile(e1) {
                e1.request && (e1.request.cancel(), delete e1.request), e1.actor && e1.actor.send("abortTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(e1) {
                e1.actor && e1.actor.send("removeTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                }), e1.destroy();
            }
            hasTransition() {
                return !1;
            }
            afterUpdate() {
                this._tileWorkers = {};
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            constructor(e1, t, i, r){
                if (super(), this.id = e1, this.dispatcher = i, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, k(this, O(t, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = k({
                    type: "vector"
                }, t), this._collectResourceTiming = !!t.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(r), this._tileWorkers = {}, this._deduped = new Nw;
            }
        }
        class jw extends zt {
            load(e1) {
                this._loaded = !1, this.fire(new It("dataloading", {
                    dataType: "source"
                })), this._tileJSONRequest = Dw(this._options, this.map._requestManager, null, null, (t, i)=>{
                    this._tileJSONRequest = null, this._loaded = !0, t ? this.fire(new Ct(t)) : i && (k(this, i), i.bounds && (this.tileBounds = new Rw(i.bounds, this.minzoom, this.maxzoom)), Ge(i.tiles), this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), e1 && e1(t);
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const e1 = va(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(e1));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove() {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return k({}, this._options);
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            loadTile(e1, t) {
                const i = dt.devicePixelRatio >= 2, r = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), i, this.tileSize);
                e1.request = Ie(this.map._requestManager.transformRequest(r, ye.Tile), (i, r, n, o)=>(delete e1.request, e1.aborted ? (e1.state = "unloaded", t(null)) : i ? (e1.state = "errored", t(i)) : r ? (this.map._refreshExpiredTiles && e1.setExpiryData({
                        cacheControl: n,
                        expires: o
                    }), e1.setTexture(r, this.map.painter), e1.state = "loaded", ge(this.dispatcher), void t(null)) : t(null)));
            }
            abortTile(e1, t) {
                e1.request && (e1.request.cancel(), delete e1.request), t();
            }
            unloadTile(e1, t) {
                e1.texture && e1.texture instanceof My ? (e1.destroy(!0), e1.texture && e1.texture instanceof My && this.map.painter.saveTileTexture(e1.texture)) : e1.destroy(), t();
            }
            hasTransition() {
                return !1;
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
            constructor(e1, t, i, r){
                super(), this.id = e1, this.dispatcher = i, this.setEventedParent(r), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = k({
                    type: "raster"
                }, t), k(this, O(t, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
        }
        function Gw() {
            return null != xI.workerClass ? new xI.workerClass : new t.Worker(xI.workerUrl);
        }
        const qw = "mapboxgl_preloaded_worker_pool";
        class Zw {
            acquire(e1) {
                if (!this.workers) for(this.workers = []; this.workers.length < Zw.workerCount;)this.workers.push(new Gw);
                return this.active[e1] = !0, this.workers.slice();
            }
            release(e1) {
                delete this.active[e1], this.workers && 0 === this.numActive() && (this.workers.forEach((e1)=>{
                    e1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[qw];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
            constructor(){
                this.active = {};
            }
        }
        let $w;
        function Ww() {
            return $w || ($w = new Zw), $w;
        }
        Zw.workerCount = 2;
        let Hw, Xw, Yw, Kw = null;
        function Jw() {
            return Q() && self.worker && self.worker.dracoUrl ? self.worker.dracoUrl : Xw || n.DRACO_URL;
        }
        const Qw = 5123, eT = 5126, tT = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            [Qw]: Uint16Array,
            5125: Uint32Array,
            [eT]: Float32Array
        }, iT = {
            5120: "DT_INT8",
            5121: "DT_UINT8",
            5122: "DT_INT16",
            [Qw]: "DT_UINT16",
            5125: "DT_UINT32",
            [eT]: "DT_FLOAT32"
        }, rT = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        };
        function nT(e1, t, i) {
            const r = i.json.bufferViews.length, n = i.buffers.length;
            t.bufferView = r, i.json.bufferViews[r] = {
                buffer: n,
                byteLength: e1.byteLength
            }, i.buffers[n] = e1;
        }
        const oT = "KHR_draco_mesh_compression";
        function sT(e1, t) {
            const i = e1.extensions && e1.extensions[oT];
            if (!i) return;
            const r = new Yw.Decoder, n = uT(t, i.bufferView), o = new Yw.Mesh;
            if (!r.DecodeArrayToMesh(n, n.byteLength, o)) throw new Error("Failed to decode Draco mesh");
            const s = t.json.accessors[e1.indices], a = tT[s.componentType], l = s.count * a.BYTES_PER_ELEMENT, c = Yw._malloc(l);
            a === Uint16Array ? r.GetTrianglesUInt16Array(o, l, c) : r.GetTrianglesUInt32Array(o, l, c), nT(Yw.memory.buffer.slice(c, c + l), s, t), Yw._free(c);
            for (const n of Object.keys(i.attributes)){
                const s = r.GetAttributeByUniqueId(o, i.attributes[n]), a = t.json.accessors[e1.attributes[n]], l = iT[a.componentType], c = a.count * rT[a.type] * tT[a.componentType].BYTES_PER_ELEMENT, h = Yw._malloc(c);
                r.GetAttributeDataArrayForAllPoints(o, s, Yw[l], c, h), nT(Yw.memory.buffer.slice(h, h + c), a, t), Yw._free(h);
            }
            r.destroy(), o.destroy(), delete e1.extensions[oT];
        }
        const aT = 1179937895, lT = new TextDecoder("utf8");
        function cT(e1, t) {
            return new URL(e1, t).href;
        }
        function hT(e1, t, i, r) {
            return fetch(cT(e1.uri, r)).then((e1)=>e1.arrayBuffer()).then((e1)=>{
                t.buffers[i] = e1;
            });
        }
        function uT(e1, t) {
            const i = e1.json.bufferViews[t];
            return new Uint8Array(e1.buffers[i.buffer], i.byteOffset || 0, i.byteLength);
        }
        function dT(e1, i, r, n) {
            if (e1.uri) {
                const o = cT(e1.uri, n);
                return fetch(o).then((e1)=>e1.blob()).then((e1)=>t.createImageBitmap(e1)).then((e1)=>{
                    i.images[r] = e1;
                });
            }
            if (void 0 !== e1.bufferView) {
                const n = uT(i, e1.bufferView), o = new t.Blob([
                    n
                ], {
                    type: e1.mimeType
                });
                return t.createImageBitmap(o).then((e1)=>{
                    i.images[r] = e1;
                });
            }
        }
        function pT(e1, t = 0, i) {
            const r = {
                json: null,
                images: [],
                buffers: []
            };
            if (new Uint32Array(e1, t, 1)[0] === aT) {
                const i = new Uint32Array(e1, t);
                let n = 2;
                const o = (i[n++] >> 2) - 3, s = i[n++] >> 2;
                if (n++, r.json = JSON.parse(lT.decode(i.subarray(n, n + s))), n += s, n < o) {
                    const o = i[n++];
                    n++;
                    const s = t + (n << 2);
                    r.buffers[0] = e1.slice(s, s + o);
                }
            } else r.json = JSON.parse(lT.decode(new Uint8Array(e1, t)));
            const { buffers: n, images: o, meshes: s, extensionsUsed: a } = r.json;
            let l = Promise.resolve();
            if (n) {
                const e1 = [];
                for(let t = 0; t < n.length; t++){
                    const o = n[t];
                    o.uri ? e1.push(hT(o, r, t, i)) : r.buffers[t] || (r.buffers[t] = null);
                }
                l = Promise.all(e1);
            }
            return l.then(()=>{
                const e1 = [], t = a && a.includes(oT);
                if (t && e1.push(function() {
                    if (!Yw) return Hw || (Hw = function(e1) {
                        let t, i = null;
                        function r() {
                            t = new Uint8Array(i.buffer);
                        }
                        function n() {
                            throw new Error("Unexpected Draco error.");
                        }
                        const o = {
                            a: {
                                a: n,
                                d: function(e1, i, r) {
                                    return t.copyWithin(e1, i, i + r);
                                },
                                c: function(e1) {
                                    const n = t.length, o = Math.max(e1 >>> 0, Math.ceil(1.2 * n)), s = Math.ceil((o - n) / 65536);
                                    try {
                                        return i.grow(s), r(), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                },
                                b: n
                            }
                        };
                        return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(e1, o) : e1.then((e1)=>e1.arrayBuffer()).then((e1)=>WebAssembly.instantiate(e1, o))).then((e1)=>{
                            const { Rb: n, Qb: o, P: s, T: a, X: l, Ja: c, La: h, Qa: u, Va: d, Wa: p, eb: f, jb: m, f: _, e: g, yb: y, zb: x, Ab: v, Bb: b, Db: w, Gb: T } = e1.instance.exports;
                            i = g;
                            const E = (()=>{
                                let e1 = 0, i = 0, r = 0, s = 0;
                                return (a)=>{
                                    r && (n(s), n(e1), i += r, r = e1 = 0), e1 || (i += 128, e1 = o(i));
                                    const l = a.length + 7 & -8;
                                    let c = e1;
                                    l >= i && (r = l, c = s = o(l));
                                    for(let e1 = 0; e1 < a.length; e1++)t[c + e1] = a[e1];
                                    return c;
                                };
                            })();
                            return r(), _(), {
                                memory: g,
                                _free: n,
                                _malloc: o,
                                Mesh: class {
                                    destroy() {
                                        a(this.ptr);
                                    }
                                    constructor(){
                                        this.ptr = s();
                                    }
                                },
                                Decoder: class {
                                    destroy() {
                                        m(this.ptr);
                                    }
                                    DecodeArrayToMesh(e1, t, i) {
                                        const r = E(e1), n = h(this.ptr, r, t, i.ptr);
                                        return !!l(n);
                                    }
                                    GetAttributeByUniqueId(e1, t) {
                                        return {
                                            ptr: u(this.ptr, e1.ptr, t)
                                        };
                                    }
                                    GetTrianglesUInt16Array(e1, t, i) {
                                        d(this.ptr, e1.ptr, t, i);
                                    }
                                    GetTrianglesUInt32Array(e1, t, i) {
                                        p(this.ptr, e1.ptr, t, i);
                                    }
                                    GetAttributeDataArrayForAllPoints(e1, t, i, r, n) {
                                        f(this.ptr, e1.ptr, t.ptr, i, r, n);
                                    }
                                    constructor(){
                                        this.ptr = c();
                                    }
                                },
                                DT_INT8: y(),
                                DT_UINT8: x(),
                                DT_INT16: v(),
                                DT_UINT16: b(),
                                DT_UINT32: w(),
                                DT_FLOAT32: T()
                            };
                        });
                    }(fetch(Jw())), Hw.then((e1)=>{
                        Yw = e1, Hw = void 0;
                    }));
                }()), o) for(let t = 0; t < o.length; t++)e1.push(dT(o[t], r, t, i));
                return (e1.length ? Promise.all(e1) : Promise.resolve()).then(()=>{
                    if (t && s) for (const { primitives: e1 } of s)for (const t of e1)sT(t, r);
                    return r;
                });
            });
        }
        function fT(e1) {
            return fetch(e1).then((e1)=>e1.arrayBuffer()).then((t)=>pT(t, 0, e1));
        }
        class mT {
            query(e1, t, i) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (e1.x > this.max.x || this.min.x > t.x) return;
                if (e1.y > this.max.y || this.min.y > t.y) return;
                this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8)));
                for(let e1 = 0; e1 < this.lookup.length; e1++)this.lookup[e1] = 0;
                const r = _T(e1.x - this.min.x, this.xScale, this.cellsX), n = _T(t.x - this.min.x, this.xScale, this.cellsX), o = _T(e1.y - this.min.y, this.yScale, this.cellsY), s = _T(t.y - this.min.y, this.yScale, this.cellsY);
                for(let e1 = o; e1 <= s; e1++)for(let t = r; t <= n; t++){
                    const r = this.cells[e1 * this.cellsX + t];
                    if (r) for(let e1 = 0; e1 < r.len; e1++){
                        const t = this.payload[r.start + e1], n = Math.floor(t / 8), o = 1 << t % 8;
                        if (!(this.lookup[n] & o) && (this.lookup[n] |= o, i.push(t), i.length === this.triangleCount)) return;
                    }
                }
            }
            constructor(e1, t, i){
                if (this.triangleCount = t.length / 3, this.min = new y(0, 0), this.max = new y(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === e1.length || 0 === i) return;
                const r = e1.map((e1)=>e1.x), n = e1.map((e1)=>e1.y);
                this.min = new y(Math.min(...r), Math.min(...n)), this.max = new y(Math.max(...r), Math.max(...n));
                const o = this.max.sub(this.min);
                o.x = Math.max(o.x, 1), o.y = Math.max(o.y, 1);
                const s = Math.max(o.x, o.y) / i;
                this.cellsX = Math.max(1, Math.ceil(o.x / s)), this.cellsY = Math.max(1, Math.ceil(o.y / s)), this.xScale = 1 / s, this.yScale = 1 / s;
                const a = [];
                for(let i = 0; i < this.triangleCount; i++){
                    const r = e1[t[3 * i + 0]].sub(this.min), n = e1[t[3 * i + 1]].sub(this.min), o = e1[t[3 * i + 2]].sub(this.min), l = _T(Math.floor(Math.min(r.x, n.x, o.x)), this.xScale, this.cellsX), c = _T(Math.floor(Math.max(r.x, n.x, o.x)), this.xScale, this.cellsX), h = _T(Math.floor(Math.min(r.y, n.y, o.y)), this.yScale, this.cellsY), u = _T(Math.floor(Math.max(r.y, n.y, o.y)), this.yScale, this.cellsY), d = new y(0, 0), p = new y(0, 0), f = new y(0, 0), m = new y(0, 0);
                    for(let e1 = h; e1 <= u; ++e1){
                        d.y = p.y = e1 * s, f.y = m.y = (e1 + 1) * s;
                        for(let t = l; t <= c; ++t)d.x = f.x = t * s, p.x = m.x = (t + 1) * s, (Lp(r, n, o, d, p, m) || Lp(r, n, o, d, m, f)) && a.push({
                            cellIdx: e1 * this.cellsX + t,
                            triIdx: i
                        });
                    }
                }
                if (0 === a.length) return;
                a.sort((e1, t)=>e1.cellIdx - t.cellIdx || e1.triIdx - t.triIdx);
                let l = 0;
                for(; l < a.length;){
                    const e1 = a[l].cellIdx, t = {
                        start: this.payload.length,
                        len: 0
                    };
                    for(; l < a.length && a[l].cellIdx === e1;)++t.len, this.payload.push(a[l++].triIdx);
                    this.cells[e1] = t;
                }
            }
        }
        function _T(e1, t, i) {
            return Math.max(0, Math.min(i - 1, Math.floor(e1 * t)));
        }
        function gT(e1, t) {
            const i = e1.json.bufferViews[t.bufferView];
            return new tT[t.componentType](e1.buffers[i.buffer], (t.byteOffset || 0) + (i.byteOffset || 0), t.count * rT[t.type]);
        }
        function yT(e1, t, i) {
            const r = e1.indices, n = e1.attributes, o = {};
            o.indexArray = new Wa;
            const s = t.json.accessors[r], a = s.count / 3;
            o.indexArray.reserve(a);
            const l = gT(t, s);
            for(let e1 = 0; e1 < a; e1++)o.indexArray.emplaceBack(l[3 * e1], l[3 * e1 + 1], l[3 * e1 + 2]);
            o.indexArray._trim(), o.vertexArray = new tl;
            const c = t.json.accessors[n.POSITION];
            o.vertexArray.reserve(c.count);
            const h = gT(t, c);
            for(let e1 = 0; e1 < c.count; e1++)o.vertexArray.emplaceBack(h[3 * e1], h[3 * e1 + 1], h[3 * e1 + 2]);
            if (o.vertexArray._trim(), o.aabb = new ed(c.min, c.max), o.centroid = function(e1, t) {
                const i = [
                    0,
                    0,
                    0
                ], r = e1.length;
                if (r > 0) {
                    for(let n = 0; n < r; n++){
                        const r = 3 * e1[n];
                        i[0] += t[r], i[1] += t[r + 1], i[2] += t[r + 2];
                    }
                    i[0] /= r, i[1] /= r, i[2] /= r;
                }
                return i;
            }(l, h), void 0 !== n.COLOR_0) {
                const e1 = t.json.accessors[n.COLOR_0], i = rT[e1.type];
                if (e1.componentType === eT) {
                    o.colorArray = 3 === i ? new tl : new ka, o.colorArray.reserve(e1.count);
                    const r = gT(t, e1);
                    if (3 === i) for(let t = 0; t < e1.count; t++)o.colorArray.emplaceBack(r[3 * t], r[3 * t + 1], r[3 * t + 2]);
                    else for(let t = 0; t < e1.count; t++)o.colorArray.emplaceBack(r[4 * t], r[4 * t + 1], r[4 * t + 2], r[4 * t + 3]);
                    o.colorArray._trim();
                } else if (e1.componentType === Qw && 4 === i) {
                    o.colorArray = new ka, o.colorArray.resize(e1.count);
                    const i = gT(t, e1), r = 1 / 65535, n = o.colorArray.float32;
                    for(let e1 = 0; e1 < 4 * i.length; ++e1)n[e1] = i[e1] * r;
                } else H(`glTF color buffer parsing for accessor ${JSON.stringify(e1)} is not supported`);
            }
            if (void 0 !== n.NORMAL) {
                o.normalArray = new tl;
                const e1 = t.json.accessors[n.NORMAL];
                o.normalArray.reserve(e1.count);
                const i = gT(t, e1);
                for(let t = 0; t < e1.count; t++)o.normalArray.emplaceBack(i[3 * t], i[3 * t + 1], i[3 * t + 2]);
                o.normalArray._trim();
            }
            if (void 0 !== n.TEXCOORD_0 && i.length > 0) {
                o.texcoordArray = new il;
                const e1 = t.json.accessors[n.TEXCOORD_0];
                o.texcoordArray.reserve(e1.count);
                const i = gT(t, e1);
                for(let t = 0; t < e1.count; t++)o.texcoordArray.emplaceBack(i[2 * t], i[2 * t + 1]);
                o.texcoordArray._trim();
            }
            const u = e1.material;
            return o.material = function(e1, t) {
                const { emissiveFactor: i = [
                    0,
                    0,
                    0
                ], alphaMode: r = "OPAQUE", alphaCutoff: n = .5, normalTexture: o, occlusionTexture: s, emissiveTexture: a, doubleSided: l } = e1, { baseColorFactor: c = [
                    1,
                    1,
                    1,
                    1
                ], metallicFactor: h = 1, roughnessFactor: u = 1, baseColorTexture: d, metallicRoughnessTexture: p } = e1.pbrMetallicRoughness || {};
                return {
                    pbrMetallicRoughness: {
                        baseColorFactor: new hi(...c),
                        metallicFactor: h,
                        roughnessFactor: u,
                        baseColorTexture: d ? t[d.index] : void 0,
                        metallicRoughnessTexture: p ? t[p.index] : void 0
                    },
                    doubleSided: l,
                    emissiveFactor: i,
                    alphaMode: r,
                    alphaCutoff: n,
                    normalTexture: o ? t[o.index] : void 0,
                    occlusionTexture: s ? t[s.index] : void 0,
                    emissionTexture: a ? t[a.index] : void 0,
                    defined: void 0 === e1.defined
                };
            }(void 0 !== u ? t.json.materials[u] : {
                defined: !1
            }, i), void 0 !== n._FEATURE_RGBA4444 && (o.featureData = new Uint32Array(gT(t, t.json.accessors[n._FEATURE_RGBA4444]).buffer)), o;
        }
        function xT(e1, t, i) {
            const { matrix: r, rotation: n, translation: o, scale: s, mesh: a, extras: l, children: c } = e1, h = {};
            if (h.matrix = r || Au.fromRotationTranslationScale([], n || [
                0,
                0,
                0,
                1
            ], o || [
                0,
                0,
                0
            ], s || [
                1,
                1,
                1
            ]), void 0 !== a) {
                h.meshes = i[a];
                const e1 = h.anchor = [
                    0,
                    0
                ];
                for (const t of h.meshes){
                    const { min: i, max: r } = t.aabb;
                    e1[0] += i[0] + r[0], e1[1] += i[1] + r[1];
                }
                e1[0] = Math.floor(e1[0] / h.meshes.length / 2), e1[1] = Math.floor(e1[1] / h.meshes.length / 2);
            }
            if (l && (l.id && (h.id = l.id), l.lights && (h.lights = function(e1) {
                if (!e1.length) return [];
                const t = function(e1) {
                    const t = atob(e1), i = new Uint8Array(t.length);
                    for(let e1 = 0; e1 < t.length; e1++)i[e1] = t.codePointAt(e1);
                    return i;
                }(e1), i = [], r = t.length / 24, n = new Uint16Array(t.buffer), o = new Float32Array(t.buffer);
                for(let e1 = 0; e1 < r; e1++){
                    const t = n[2 * e1 * 6] / 30, r = n[2 * e1 * 6 + 1] / 30, s = n[2 * e1 * 6 + 10] / 100, a = o[6 * e1 + 1], l = o[6 * e1 + 2], c = o[6 * e1 + 3], h = o[6 * e1 + 4], u = c - a, d = h - l, p = Math.hypot(u, d);
                    i.push({
                        pos: [
                            a + .5 * u,
                            l + .5 * d,
                            r
                        ],
                        normal: [
                            d / p,
                            -u / p,
                            0
                        ],
                        width: p,
                        height: t,
                        depth: s,
                        points: [
                            a,
                            l,
                            c,
                            h
                        ]
                    });
                }
                return i;
            }(l.lights))), c) {
                const e1 = [];
                for (const r of c)e1.push(xT(t.json.nodes[r], t, i));
                h.children = e1;
            }
            return h;
        }
        function vT(e1) {
            if (0 === e1.vertices.length || 0 === e1.indices.length) return null;
            const [t, i] = [
                e1.vertices[0].clone(),
                e1.vertices[0].clone()
            ];
            for(let r = 1; r < e1.vertices.length; ++r){
                const n = e1.vertices[r];
                t.x = Math.min(t.x, n.x), t.y = Math.min(t.y, n.y), i.x = Math.max(i.x, n.x), i.y = Math.max(i.y, n.y);
            }
            const r = Math.ceil(Math.max(i.x - t.x, i.y - t.y) / 256), n = Math.max(8, r), o = new mT(e1.vertices, e1.indices, n);
            return {
                vertices: e1.vertices,
                indices: e1.indices,
                grid: o,
                min: t,
                max: i
            };
        }
        function bT(e1) {
            if (!e1.extras || !e1.extras.ground) return null;
            const t = e1.extras.ground;
            if (!t || !Array.isArray(t) || 0 === t.length) return null;
            const i = t[0];
            if (!i || !Array.isArray(i) || 0 === i.length) return null;
            const r = [];
            for (const e1 of i){
                if (!Array.isArray(e1) || 2 !== e1.length) continue;
                const t = e1[0], i = e1[1];
                "number" == typeof t && "number" == typeof i && r.push(new y(t, i));
            }
            if (r.length < 3) return null;
            r.length > 1 && r[r.length - 1].equals(r[0]) && r.pop();
            let n = 0;
            for(let e1 = 0; e1 < r.length; e1++){
                const t = r[e1], i = r[(e1 + 1) % r.length], o = r[(e1 + 2) % r.length];
                n += (t.x - i.x) * (o.y - i.y) - (o.x - i.x) * (t.y - i.y);
            }
            n > 0 && r.reverse();
            const o = Bf(r.flatMap((e1)=>[
                    e1.x,
                    e1.y
                ]), []);
            return 0 === o.length ? null : {
                vertices: r,
                indices: o
            };
        }
        function wT(e1) {
            const t = [], i = [];
            let r = 0;
            for (const n of e1){
                r = t.length;
                const e1 = n.vertexArray.float32, o = n.indexArray.uint16;
                for(let i = 0; i < n.vertexArray.length; i++)t.push(new y(e1[3 * i + 0], e1[3 * i + 1]));
                for(let e1 = 0; e1 < 3 * n.indexArray.length; e1++)i.push(o[e1] + r);
            }
            if (i.length % 3 != 0) return null;
            for(let e1 = 0; e1 < i.length; e1 += 3){
                const r = t[i[e1 + 0]], n = t[i[e1 + 1]], o = t[i[e1 + 2]];
                (r.x - n.x) * (o.y - n.y) - (o.x - n.x) * (r.y - n.y) > 0 && ([i[e1 + 1], i[e1 + 2]] = [
                    i[e1 + 2],
                    i[e1 + 1]
                ]);
            }
            return {
                vertices: t,
                indices: i
            };
        }
        function TT(e1) {
            const i = function(e1, i) {
                const r = [], n = t.WebGL2RenderingContext;
                if (e1.json.textures) for (const t of e1.json.textures){
                    const o = {
                        magFilter: n.LINEAR,
                        minFilter: n.NEAREST,
                        wrapS: n.REPEAT,
                        wrapT: n.REPEAT
                    };
                    void 0 !== t.sampler && Object.assign(o, e1.json.samplers[t.sampler]), r.push({
                        image: i[t.source],
                        sampler: o,
                        uploaded: !1
                    });
                }
                return r;
            }(e1, e1.images), r = function(e1, t) {
                const i = [];
                for (const r of e1.json.meshes){
                    const n = [];
                    for (const i of r.primitives)n.push(yT(i, e1, t));
                    i.push(n);
                }
                return i;
            }(e1, i), { scenes: n, scene: o, nodes: s } = e1.json, a = n ? n[o || 0].nodes : s, l = [];
            for (const t of a)l.push(xT(s[t], e1, r));
            return function(e1, t, i) {
                const r = {}, n = new Set;
                for(let o = 0; o < e1.length; o++){
                    const e1 = i[t[o]];
                    if (!e1.extras) continue;
                    const s = e1.extras["mapbox:footprint:version"], a = e1.extras["mapbox:footprint:id"];
                    (s || a) && n.add(o), "1.0.0" === s && a && (r[a] = o);
                }
                for(let o = 0; o < e1.length; o++){
                    if (n.has(o)) continue;
                    const s = e1[o], a = i[t[o]];
                    if (!a.extras) continue;
                    let l = null;
                    s.id in r && (l = wT(e1[r[s.id]].meshes)), l || (l = bT(a)), l && (s.footprint = vT(l));
                }
                if (n.size > 0) {
                    const t = Array.from(n.values()).sort((e1, t)=>e1 - t);
                    for(let i = t.length - 1; i >= 0; i--)e1.splice(t[i], 1);
                }
            }(l, a, e1.json.nodes), l;
        }
        function ET(e1) {
            e1.heightmap = new Float32Array(4096), e1.heightmap.fill(-1);
            const t = e1.vertexArray.float32, i = e1.aabb.min[0] - 1, r = e1.aabb.min[1] - 1, n = Sv / (e1.aabb.max[0] - i + 2), o = Sv / (e1.aabb.max[1] - r + 2);
            for(let s = 0; s < t.length; s += 3){
                const a = t[s + 2], l = (t[s + 0] - i) * n | 0, c = (t[s + 1] - r) * o | 0;
                a > e1.heightmap[c * Sv + l] && (e1.heightmap[c * Sv + l] = a);
            }
        }
        function MT(e1, t) {
            const i = {};
            i.indexArray = new Wa, i.indexArray.reserve(4 * e1.length), i.vertexArray = new tl, i.vertexArray.reserve(10 * e1.length), i.colorArray = new ka, i.vertexArray.reserve(10 * e1.length);
            let r = 0;
            for (const n of e1){
                const e1 = Math.min(10, Math.max(4, 1.3 * n.height)) * t, o = [
                    -n.normal[1],
                    n.normal[0],
                    0
                ], s = Math.min(.29, .1 * n.width / n.depth), a = n.width - 2 * n.depth * t * (s + .01), l = Du.scaleAndAdd([], n.pos, o, a / 2), c = Du.scaleAndAdd([], n.pos, o, -a / 2), h = [
                    l[0],
                    l[1],
                    l[2] + n.height
                ], u = [
                    c[0],
                    c[1],
                    c[2] + n.height
                ], d = Du.scaleAndAdd([], n.normal, o, s);
                Du.scale(d, d, e1);
                const p = Du.scaleAndAdd([], n.normal, o, -s);
                Du.scale(p, p, e1), Du.add(d, l, d), Du.add(p, c, p), l[2] += .1, c[2] += .1, i.vertexArray.emplaceBack(d[0], d[1], d[2]), i.vertexArray.emplaceBack(p[0], p[1], p[2]), i.vertexArray.emplaceBack(l[0], l[1], l[2]), i.vertexArray.emplaceBack(c[0], c[1], c[2]), i.vertexArray.emplaceBack(h[0], h[1], h[2]), i.vertexArray.emplaceBack(u[0], u[1], u[2]), i.vertexArray.emplaceBack(l[0], l[1], l[2]), i.vertexArray.emplaceBack(c[0], c[1], c[2]), i.vertexArray.emplaceBack(d[0], d[1], d[2]), i.vertexArray.emplaceBack(p[0], p[1], p[2]);
                const f = a / e1 / 2;
                i.colorArray.emplaceBack(-f - s, -1, f, .8), i.colorArray.emplaceBack(f + s, -1, f, .8), i.colorArray.emplaceBack(-f, 0, f, 1.3), i.colorArray.emplaceBack(f, 0, f, 1.3), i.colorArray.emplaceBack(f + s, -0.8, f, .7), i.colorArray.emplaceBack(f + s, -0.8, f, .7), i.colorArray.emplaceBack(0, 0, f, 1.3), i.colorArray.emplaceBack(0, 0, f, 1.3), i.colorArray.emplaceBack(f + s, -1.2, f, .8), i.colorArray.emplaceBack(f + s, -1.2, f, .8), i.indexArray.emplaceBack(6 + r, 4 + r, 8 + r), i.indexArray.emplaceBack(7 + r, 9 + r, 5 + r), i.indexArray.emplaceBack(0 + r, 1 + r, 2 + r), i.indexArray.emplaceBack(1 + r, 3 + r, 2 + r), r += 10;
            }
            const n = {
                defined: !0,
                emissiveFactor: [
                    0,
                    0,
                    0
                ]
            }, o = {};
            return o.baseColorFactor = hi.white, n.pbrMetallicRoughness = o, i.material = n, i.aabb = new ed([
                1 / 0,
                1 / 0,
                1 / 0
            ], [
                -1 / 0,
                -1 / 0,
                -1 / 0
            ]), i;
        }
        Rs(mT, "TriangleGridIndex");
        const AT = {
            vector: Vw,
            raster: jw,
            "raster-dem": class extends jw {
                loadTile(e1, i) {
                    const r = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    function n(t, r) {
                        t && (e1.state = "errored", i(t)), r && (e1.dem = r, e1.dem.onDeserialize(), e1.needsHillshadePrepare = !0, e1.needsDEMTextureUpload = !0, e1.state = "loaded", i(null));
                    }
                    e1.request = Ie(this.map._requestManager.transformRequest(r, ye.Tile), (function(r, o, s, a) {
                        if (delete e1.request, e1.aborted) e1.state = "unloaded", i(null);
                        else if (r) e1.state = "errored", i(r);
                        else if (o) {
                            this.map._refreshExpiredTiles && e1.setExpiryData({
                                cacheControl: s,
                                expires: a
                            });
                            const i = t.ImageBitmap && o instanceof t.ImageBitmap && ut(), r = 1 - (o.width - ((l = o.width) <= 1 ? 1 : Math.pow(2, Math.floor(Math.log(l) / Math.LN2)))) / 2;
                            r < 1 || e1.neighboringTiles || (e1.neighboringTiles = this._getNeighboringTiles(e1.tileID));
                            const c = i ? o : dt.getImageData(o, r), h = {
                                uid: e1.uid,
                                coord: e1.tileID,
                                source: this.id,
                                scope: this.scope,
                                rawImageData: c,
                                encoding: this.encoding,
                                padding: r
                            };
                            e1.actor && "expired" !== e1.state || (e1.actor = this.dispatcher.getActor(), e1.actor.send("loadDEMTile", h, n.bind(this), void 0, !0));
                        }
                        var l;
                    }).bind(this));
                }
                _getNeighboringTiles(e1) {
                    const t = e1.canonical, i = Math.pow(2, t.z), r = (t.x - 1 + i) % i, n = 0 === t.x ? e1.wrap - 1 : e1.wrap, o = (t.x + 1 + i) % i, s = t.x + 1 === i ? e1.wrap + 1 : e1.wrap, a = {};
                    return a[new qu(e1.overscaledZ, n, t.z, r, t.y).key] = {
                        backfilled: !1
                    }, a[new qu(e1.overscaledZ, s, t.z, o, t.y).key] = {
                        backfilled: !1
                    }, t.y > 0 && (a[new qu(e1.overscaledZ, n, t.z, r, t.y - 1).key] = {
                        backfilled: !1
                    }, a[new qu(e1.overscaledZ, e1.wrap, t.z, t.x, t.y - 1).key] = {
                        backfilled: !1
                    }, a[new qu(e1.overscaledZ, s, t.z, o, t.y - 1).key] = {
                        backfilled: !1
                    }), t.y + 1 < i && (a[new qu(e1.overscaledZ, n, t.z, r, t.y + 1).key] = {
                        backfilled: !1
                    }, a[new qu(e1.overscaledZ, e1.wrap, t.z, t.x, t.y + 1).key] = {
                        backfilled: !1
                    }, a[new qu(e1.overscaledZ, s, t.z, o, t.y + 1).key] = {
                        backfilled: !1
                    }), a;
                }
                constructor(e1, t, i, r){
                    super(e1, t, i, r), this.type = "raster-dem", this.maxzoom = 22, this._options = k({
                        type: "raster-dem"
                    }, t), this.encoding = t.encoding || "mapbox";
                }
            },
            geojson: class extends zt {
                onAdd(e1) {
                    this.map = e1, this.setData(this._data);
                }
                setData(e1) {
                    return this._data = e1, this._updateWorkerData(), this;
                }
                getClusterExpansionZoom(e1, t) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e1,
                        source: this.id,
                        scope: this.scope
                    }, t), this;
                }
                getClusterChildren(e1, t) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e1,
                        source: this.id,
                        scope: this.scope
                    }, t), this;
                }
                getClusterLeaves(e1, t, i, r) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        scope: this.scope,
                        clusterId: e1,
                        limit: t,
                        offset: i
                    }, r), this;
                }
                _updateWorkerData() {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new It("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const e1 = k({}, this.workerOptions);
                    e1.scope = this.scope;
                    const t = this._data;
                    "string" == typeof t ? (e1.request = this.map._requestManager.transformRequest(dt.resolveURL(t), ye.Source), e1.request.collectResourceTiming = this._collectResourceTiming) : e1.data = JSON.stringify(t), this._pendingLoad = this.actor.send(`${this.type}.loadData`, e1, (e1, t)=>{
                        if (this._loaded = !0, this._pendingLoad = null, e1) this.fire(new Ct(e1));
                        else {
                            const e1 = {
                                dataType: "source",
                                sourceDataType: this._metadataFired ? "content" : "metadata"
                            };
                            this._collectResourceTiming && t && t.resourceTiming && t.resourceTiming[this.id] && (e1.resourceTiming = t.resourceTiming[this.id]), this.fire(new It("data", e1)), this._metadataFired = !0;
                        }
                        this._coalesce && (this._updateWorkerData(), this._coalesce = !1);
                    });
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(e1, t) {
                    const i = e1.actor ? "reloadTile" : "loadTile";
                    e1.actor = this.actor;
                    const r = {
                        type: this.type,
                        uid: e1.uid,
                        tileID: e1.tileID,
                        tileZoom: e1.tileZoom,
                        zoom: e1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        scope: this.scope,
                        pixelRatio: dt.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        brightness: this.map.style && this.map.style.getBrightness() || 0
                    };
                    e1.request = this.actor.send(i, r, (r, n)=>(delete e1.request, e1.destroy(), e1.aborted ? t(null) : r ? t(r) : (e1.loadVectorData(n, this.map.painter, "reloadTile" === i), t(null))), void 0, "loadTile" === i);
                }
                abortTile(e1) {
                    e1.request && (e1.request.cancel(), delete e1.request), e1.aborted = !0;
                }
                unloadTile(e1) {
                    this.actor.send("removeTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), e1.destroy();
                }
                onRemove() {
                    this._pendingLoad && this._pendingLoad.cancel();
                }
                serialize() {
                    return k({}, this._options, {
                        type: this.type,
                        data: this._data
                    });
                }
                hasTransition() {
                    return !1;
                }
                constructor(e1, t, i, r){
                    super(), this.id = e1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = i.getActor(), this.setEventedParent(r), this._data = t.data, this._options = k({}, t), this._collectResourceTiming = t.collectResourceTiming, void 0 !== t.maxzoom && (this.maxzoom = t.maxzoom), t.type && (this.type = t.type), t.attribution && (this.attribution = t.attribution), this.promoteId = t.promoteId;
                    const n = cr / this.tileSize;
                    this.workerOptions = k({
                        source: this.id,
                        scope: this.scope,
                        cluster: t.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== t.buffer ? t.buffer : 128) * n,
                            tolerance: (void 0 !== t.tolerance ? t.tolerance : .375) * n,
                            extent: cr,
                            maxZoom: this.maxzoom,
                            lineMetrics: t.lineMetrics || !1,
                            generateId: t.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== t.clusterMaxZoom ? t.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, t.clusterMinPoints || 2),
                            extent: cr,
                            radius: (void 0 !== t.clusterRadius ? t.clusterRadius : 50) * n,
                            log: !1,
                            generateId: t.generateId || !1
                        },
                        clusterProperties: t.clusterProperties,
                        filter: t.filter
                    }, t.workerOptions);
                }
            },
            video: class extends Jb {
                load() {
                    this._loaded = !1;
                    const e1 = this.options;
                    this.urls = [];
                    for (const t of e1.urls)this.urls.push(this.map._requestManager.transformRequest(t, ye.Source).url);
                    !function(e1, i) {
                        const r = t.document.createElement("video");
                        r.muted = !0, r.onloadstart = function() {
                            i(null, r);
                        };
                        for(let i = 0; i < e1.length; i++){
                            const n = t.document.createElement("source");
                            Ee(e1[i]) || (r.crossOrigin = "Anonymous"), n.src = e1[i], r.appendChild(n);
                        }
                    }(this.urls, (e1, t)=>{
                        this._loaded = !0, e1 ? this.fire(new Ct(e1)) : t && (this.video = t, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(e1) {
                    if (this.video) {
                        const t = this.video.seekable;
                        e1 < t.start(0) || e1 > t.end(0) ? this.fire(new Ct(new Dt(`sources.${this.id}`, null, `Playback for this video can be set only between the ${t.start(0)} and ${t.end(0)}-second mark.`))) : this.video.currentTime = e1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e1) {
                    this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const e1 = this.map.painter.context, t = e1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE), t.texSubImage2D(t.TEXTURE_2D, 0, 0, 0, t.RGBA, t.UNSIGNED_BYTE, this.video)) : (this.texture = new My(e1, this.video, t.RGBA), this.texture.bind(t.LINEAR, t.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(e1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
                constructor(e1, t, i, r){
                    super(e1, t, i, r), this.roundZoom = !0, this.type = "video", this.options = t;
                }
            },
            image: Jb,
            model: class extends zt {
                load() {
                    const e1 = [];
                    for(const t in this._options.models){
                        const i = this._options.models[t], r = fT(this.map._requestManager.transformRequest(i.uri, ye.Model).url).then((e1)=>{
                            if (!e1) return;
                            const r = TT(e1), n = new Cv(t, i.position, i.orientation, r);
                            n.computeBoundsAndApplyParent(), this.models.push(n);
                        }).catch((e1)=>{
                            this.fire(new Ct(new Error(`Could not load model ${t} from ${i.uri}: ${e1.message}`)));
                        });
                        e1.push(r);
                    }
                    return Promise.allSettled(e1).then(()=>{
                        this._loaded = !0, this.fire(new It("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        }));
                    }).catch((e1)=>{
                        this.fire(new Ct(new Error(`Could not load models: ${e1.message}`)));
                    });
                }
                onAdd(e1) {
                    this.map = e1, this.load();
                }
                hasTransition() {
                    return !1;
                }
                loaded() {
                    return this._loaded;
                }
                getModels() {
                    return this.models;
                }
                loadTile(e1, t) {}
                serialize() {
                    return {
                        type: "model"
                    };
                }
                constructor(e1, t, i, r){
                    super(), this.id = e1, this.type = "model", this.models = [], this._loaded = !1, this._options = t;
                }
            },
            "batched-model": class extends zt {
                onAdd(e1) {
                    this.map = e1, this.load();
                }
                load(e1) {
                    this._loaded = !1, this.fire(new It("dataloading", {
                        dataType: "source"
                    }));
                    const t = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, i = this.map._worldview;
                    this._tileJSONRequest = Dw(this._options, this.map._requestManager, t, i, (r, n)=>{
                        this._tileJSONRequest = null, this._loaded = !0, r ? (t && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${t}`), i && 2 !== i.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${i}`), this.fire(new Ct(r))) : n && (k(this, n), n.bounds && (this.tileBounds = new Rw(n.bounds, this.minzoom, this.maxzoom)), Ge(n.tiles, this.map._requestManager._customAccessToken), this.fire(new It("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new It("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), e1 && e1(r);
                    });
                }
                hasTransition() {
                    return !1;
                }
                hasTile(e1) {
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(e1, t) {
                    const i = this.map._requestManager.normalizeTileURL(e1.tileID.canonical.url(this.tiles, this.scheme)), r = {
                        request: this.map._requestManager.transformRequest(i, ye.Tile),
                        data: void 0,
                        uid: e1.uid,
                        tileID: e1.tileID,
                        tileZoom: e1.tileZoom,
                        zoom: e1.tileID.overscaledZ,
                        tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        scope: this.scope,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        isSymbolTile: e1.isSymbolTile,
                        brightness: this.map.style && this.map.style.getBrightness() || 0
                    };
                    if (e1.actor && "expired" !== e1.state) {
                        if ("loading" === e1.state) e1.reloadCallback = t;
                        else {
                            if (e1.buckets) {
                                const t = Object.values(e1.buckets);
                                for (const e1 of t)e1.dirty = !0;
                                return void (e1.state = "loaded");
                            }
                            e1.request = e1.actor.send("reloadTile", r, n.bind(this));
                        }
                    } else e1.actor = this.dispatcher.getActor(), e1.request = e1.actor.send("loadTile", r, n.bind(this), void 0, !0);
                    function n(i, r) {
                        return e1.aborted ? t(null) : i && 404 !== i.status ? t(i) : (r && (r.resourceTiming && (e1.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && e1.setExpiryData(r), e1.buckets = {
                            ...e1.buckets,
                            ...r.buckets
                        }), e1.state = "loaded", void t(null));
                    }
                }
                serialize() {
                    return k({}, this._options);
                }
                constructor(e1, t, i, r){
                    super(), this.type = "batched-model", this.id = e1, this.tileSize = 512, this._options = t, this.tiles = this._options.tiles, this.maxzoom = t.maxzoom || 19, this.minzoom = t.minzoom || 0, this.roundZoom = !0, this.usedInConflation = !0, this.dispatcher = i, this.reparseOverscaled = !1, this.scheme = "xyz", this._loaded = !1, this.setEventedParent(r);
                }
            },
            canvas: class extends Jb {
                load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof t.HTMLCanvasElement ? this.options.canvas : t.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new Ct(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e1) {
                    this.map = e1, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove() {
                    this.pause();
                }
                prepare() {
                    let e1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, e1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, e1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const t = this.map.painter.context;
                    this.texture ? !e1 && !this._playing || this.texture instanceof Ay || this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new My(t, this.canvas, t.gl.RGBA, {
                        premultiply: !0
                    }), this._prepareData(t);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e1 of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e1) || e1 <= 0) return !0;
                    return !1;
                }
                constructor(e1, i, r, n){
                    super(e1, i, r, n), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e1)=>!Array.isArray(e1) || 2 !== e1.length || e1.some((e1)=>"number" != typeof e1)) || this.fire(new Ct(new Dt(`sources.${e1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new Ct(new Dt(`sources.${e1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new Ct(new Dt(`sources.${e1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof t.HTMLCanvasElement || this.fire(new Ct(new Dt(`sources.${e1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new Ct(new Dt(`sources.${e1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
            },
            custom: class extends zt {
                serialize() {
                    return O(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(e1) {
                    this._map = e1, this._loaded = !1, this.fire(new It("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(e1), this.load();
                }
                onRemove(e1) {
                    this._implementation.onRemove && this._implementation.onRemove(e1);
                }
                hasTile(e1) {
                    if (this._implementation.hasTile) {
                        const { x: t, y: i, z: r } = e1.canonical;
                        return this._implementation.hasTile({
                            x: t,
                            y: i,
                            z: r
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                loadTile(e1, i) {
                    const { x: r, y: n, z: o } = e1.tileID.canonical, s = new t.AbortController;
                    e1.request = Promise.resolve(this._implementation.loadTile({
                        x: r,
                        y: n,
                        z: o
                    }, {
                        signal: s.signal
                    })).then((function(r) {
                        return delete e1.request, e1.aborted ? (e1.state = "unloaded", i(null)) : void 0 === r ? (e1.state = "errored", i(null)) : null === r ? (this.loadTileData(e1, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), e1.state = "loaded", i(null)) : function(e1) {
                            return e1 instanceof t.ImageData || e1 instanceof t.HTMLCanvasElement || e1 instanceof t.ImageBitmap || e1 instanceof t.HTMLImageElement;
                        }(r) ? (this.loadTileData(e1, r), e1.state = "loaded", void i(null)) : (e1.state = "errored", i(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
                    }).bind(this)).catch((t)=>{
                        20 !== t.code && (e1.state = "errored", i(t));
                    }), e1.request.cancel = ()=>s.abort();
                }
                loadTileData(e1, t) {
                    e1.setTexture(t, this._map.painter);
                }
                unloadTile(e1, t) {
                    if (e1.texture && e1.texture instanceof My ? (e1.destroy(!0), e1.texture && e1.texture instanceof My && this._map.painter.saveTileTexture(e1.texture)) : e1.destroy(), this._implementation.unloadTile) {
                        const { x: t, y: i, z: r } = e1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: t,
                            y: i,
                            z: r
                        });
                    }
                    t();
                }
                abortTile(e1, t) {
                    e1.request && e1.request.cancel && (e1.request.cancel(), delete e1.request), t();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this._map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e1)=>({
                            x: e1.canonical.x,
                            y: e1.canonical.y,
                            z: e1.canonical.z
                        }));
                }
                _clearTiles() {
                    const e1 = va(this.id, this.scope);
                    this._map.style.clearSource(e1);
                }
                _update() {
                    this.fire(new It("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                constructor(e1, t, i, r){
                    super(), this.id = e1, this.type = "custom", this._dataType = "raster", this._dispatcher = i, this._implementation = t, this.setEventedParent(r), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new Ct(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new Ct(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new Rw(this._implementation.bounds, this.minzoom, this.maxzoom)), t.update = this._update.bind(this), t.clearTiles = this._clearTiles.bind(this), t.coveringTiles = this._coveringTiles.bind(this), k(this, O(t, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ]));
                }
            }
        }, ST = function(e1, t, i, r) {
            const n = new AT[t.type](e1, t, i, r);
            if (n.id !== e1) throw new Error(`Expected Source id to be ${e1} instead of ${n.id}`);
            return j([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], n), n;
        };
        function IT(e1, t) {
            const i = Au.identity([]);
            return Au.scale(i, i, [
                .5 * e1.width,
                .5 * -e1.height,
                1
            ]), Au.translate(i, i, [
                1,
                -1,
                0
            ]), Au.multiply(i, i, e1.calculateProjMatrix(t.toUnwrapped())), Float32Array.from(i);
        }
        function CT(e1, t, i, r, n, o, s, a = !1) {
            const l = e1.tilesIn(r, s, a);
            l.sort(PT);
            const c = [];
            for (const r of l)c.push({
                wrappedTileID: r.tile.tileID.wrapped().key,
                queryResults: r.tile.queryRenderedFeatures(t, i, e1._state, r, n, o, IT(e1.transform, r.tile.tileID), a)
            });
            const h = function(e1) {
                const t = {}, i = {};
                for (const r of e1){
                    const e1 = r.queryResults, n = r.wrappedTileID, o = i[n] = i[n] || {};
                    for(const i in e1){
                        const r = e1[i], n = o[i] = o[i] || {}, s = t[i] = t[i] || [];
                        for (const e1 of r)n[e1.featureIndex] || (n[e1.featureIndex] = !0, s.push(e1));
                    }
                }
                return t;
            }(c);
            for(const t in h)h[t].forEach((t)=>{
                const i = t.feature, r = i.layer;
                r && "background" !== r.type && "sky" !== r.type && "slot" !== r.type && (i.source = r.source, r["source-layer"] && (i.sourceLayer = r["source-layer"]), i.state = void 0 !== i.id ? e1.getFeatureState(r["source-layer"], i.id) : {});
            });
            return h;
        }
        function zT(e1, t) {
            const i = e1.getRenderableIds().map((t)=>e1.getTileByID(t)), r = [], n = {};
            for(let e1 = 0; e1 < i.length; e1++){
                const o = i[e1], s = o.tileID.canonical.key;
                n[s] || (n[s] = !0, o.querySourceFeatures(r, t));
            }
            return r;
        }
        function PT(e1, t) {
            const i = e1.tileID, r = t.tileID;
            return i.overscaledZ - r.overscaledZ || i.canonical.y - r.canonical.y || i.wrap - r.wrap || i.canonical.x - r.canonical.x;
        }
        class DT {
            processLayersChanged() {
                this.layers = [];
                for(const e1 in this.style._mergedLayers){
                    const t = this.style._mergedLayers[e1];
                    if ("fill-extrusion" === t.type) this.layers.push(t);
                    else if ("model" === t.type) {
                        const e1 = this.style.getLayerSource(t);
                        e1 && "batched-model" === e1.type && this.layers.push(t);
                    }
                }
            }
            updateZOffset(e1, t) {
                this.currentBuildingBuckets = [];
                for(let e1 = 0; e1 < this.layers.length; ++e1){
                    const i = this.layers[e1], r = this.style.getLayerSourceCache(i);
                    let n = 1;
                    "fill-extrusion" === i.type && (n = i.paint.get("fill-extrusion-opacity") > 0 ? i.paint.get("fill-extrusion-vertical-scale") : 0);
                    let o = r ? r.getTile(t) : null;
                    if (!o && r && t.canonical.z > r.getSource().minzoom) {
                        let e1 = t.scaledTo(Math.min(r.getSource().maxzoom, t.overscaledZ - 1));
                        for(; e1.overscaledZ >= r.getSource().minzoom && (o = r.getTile(e1), !o && 0 !== e1.overscaledZ);)e1 = e1.scaledTo(e1.overscaledZ - 1);
                    }
                    this.currentBuildingBuckets.push({
                        bucket: o ? o.getBucket(i) : null,
                        tileID: o ? o.tileID : t,
                        verticalScale: n
                    });
                }
                e1.hasAnyZOffset = !1;
                let i = !1;
                for(let r = 0; r < e1.symbolInstances.length; r++){
                    const n = e1.symbolInstances.get(r), o = n.zOffset, s = this._getHeightAtTileOffset(t, n.tileAnchorX, n.tileAnchorY);
                    n.zOffset = -1 !== s ? s : o, i || o === n.zOffset || (i = !0), e1.hasAnyZOffset || 0 === n.zOffset || (e1.hasAnyZOffset = !0);
                }
                i && (e1.zOffsetBuffersNeedUpload = !0, e1.zOffsetSortDirty = !0);
            }
            _mapCoordToOverlappingTile(e1, t, i, r) {
                let n = t, o = i;
                if (e1.canonical.z !== r.canonical.z) {
                    const s = r.canonical, a = 1 / (1 << e1.canonical.z - s.z);
                    n = (t + e1.canonical.x * cr) * a - s.x * cr | 0, o = (i + e1.canonical.y * cr) * a - s.y * cr | 0;
                }
                return {
                    tileX: n,
                    tileY: o
                };
            }
            _getHeightAtTileOffset(e1, t, i) {
                let r;
                for(let n = 0; n < this.layers.length; ++n){
                    if ("fill-extrusion" !== this.layers[n].type) continue;
                    const { bucket: o, tileID: s, verticalScale: a } = this.currentBuildingBuckets[n];
                    if (!o) continue;
                    const { tileX: l, tileY: c } = this._mapCoordToOverlappingTile(e1, t, i, s), h = o.getHeightAtTileCoord(l, c);
                    if (h && void 0 !== h.height) {
                        if (!h.hidden) return h.height * a;
                        r = h.height;
                    }
                }
                for(let n = 0; n < this.layers.length; ++n){
                    if ("model" !== this.layers[n].type) continue;
                    const { bucket: o, tileID: s } = this.currentBuildingBuckets[n];
                    if (!o) continue;
                    const { tileX: a, tileY: l } = this._mapCoordToOverlappingTile(e1, t, i, s), c = o.getHeightAtTileCoord(a, l);
                    if (c && !c.hidden) return void 0 === c.height && void 0 !== r ? Math.min(c.maxHeight, r) * c.verticalScale : (c.height || 0) * c.verticalScale;
                }
                return -1;
            }
            constructor(e1){
                this.style = e1;
            }
        }
        var RT = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ];
        function LT(e1, t) {
            const i = {};
            for(const t in e1)"ref" !== t && (i[t] = e1[t]);
            return RT.forEach((e1)=>{
                e1 in t && (i[e1] = t[e1]);
            }), i;
        }
        function kT(e1) {
            e1 = e1.slice();
            const t = Object.create(null);
            for(let i = 0; i < e1.length; i++)t[e1[i].id] = e1[i];
            for(let i = 0; i < e1.length; i++)"ref" in e1[i] && (e1[i] = LT(e1[i], t[e1[i].ref]));
            return e1;
        }
        const OT = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setSlot: "setSlot",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight",
            setTerrain: "setTerrain",
            setFog: "setFog",
            setCamera: "setCamera",
            setLights: "setLights",
            setProjection: "setProjection",
            addImport: "addImport",
            removeImport: "removeImport",
            setImportUrl: "setImportUrl",
            setImportData: "setImportData",
            setImportConfig: "setImportConfig"
        };
        function BT(e1, t, i) {
            i.push({
                command: OT.addSource,
                args: [
                    e1,
                    t[e1]
                ]
            });
        }
        function FT(e1, t, i) {
            t.push({
                command: OT.removeSource,
                args: [
                    e1
                ]
            }), i[e1] = !0;
        }
        function NT(e1, t, i, r) {
            FT(e1, i, r), BT(e1, t, i);
        }
        function UT(e1, t, i) {
            let r;
            for(r in e1[i])if (e1[i].hasOwnProperty(r) && "data" !== r && !x(e1[i][r], t[i][r])) return !1;
            for(r in t[i])if (t[i].hasOwnProperty(r) && "data" !== r && !x(e1[i][r], t[i][r])) return !1;
            return !0;
        }
        function VT(e1, t, i, r, n, o) {
            let s;
            for(s in t = t || {}, e1 = e1 || {})e1.hasOwnProperty(s) && (x(e1[s], t[s]) || i.push({
                command: o,
                args: [
                    r,
                    s,
                    t[s],
                    n
                ]
            }));
            for(s in t)t.hasOwnProperty(s) && !e1.hasOwnProperty(s) && (x(e1[s], t[s]) || i.push({
                command: o,
                args: [
                    r,
                    s,
                    t[s],
                    n
                ]
            }));
        }
        function jT(e1) {
            return e1.id;
        }
        function GT(e1, t) {
            return e1[t.id] = t, e1;
        }
        class qT {
            reset(e1, t) {
                this.points = e1 || [], this._distances = [
                    0
                ];
                for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(e1) {
                if (1 === this.points.length) return this.points[0];
                e1 = z(e1, 0, 1);
                let t = 1, i = this._distances[t];
                const r = e1 * this.paddedLength + this.padding;
                for(; i < r && t < this._distances.length;)i = this._distances[++t];
                const n = t - 1, o = this._distances[n], s = i - o, a = s > 0 ? (r - o) / s : 0;
                return this.points[n].mult(1 - a).add(this.points[t].mult(a));
            }
            constructor(e1, t){
                this.reset(e1, t);
            }
        }
        class ZT {
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e1, t, i, r, n) {
                this._forEachCell(t, i, r, n, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(r), this.bboxes.push(n);
            }
            insertCircle(e1, t, i, r) {
                this._forEachCell(t - r, i - r, t + r, i + r, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t), this.circles.push(i), this.circles.push(r);
            }
            _insertBoxCell(e1, t, i, r, n, o) {
                this.boxCells[n].push(o);
            }
            _insertCircleCell(e1, t, i, r, n, o) {
                this.circleCells[n].push(o);
            }
            _query(e1, t, i, r, n, o) {
                if (i < 0 || e1 > this.width || r < 0 || t > this.height) return !n && [];
                const s = [];
                if (e1 <= 0 && t <= 0 && this.width <= i && this.height <= r) {
                    if (n) return !0;
                    for(let e1 = 0; e1 < this.boxKeys.length; e1++)s.push({
                        key: this.boxKeys[e1],
                        x1: this.bboxes[4 * e1],
                        y1: this.bboxes[4 * e1 + 1],
                        x2: this.bboxes[4 * e1 + 2],
                        y2: this.bboxes[4 * e1 + 3]
                    });
                    for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                        const t = this.circles[3 * e1], i = this.circles[3 * e1 + 1], r = this.circles[3 * e1 + 2];
                        s.push({
                            key: this.circleKeys[e1],
                            x1: t - r,
                            y1: i - r,
                            x2: t + r,
                            y2: i + r
                        });
                    }
                    return o ? s.filter(o) : s;
                }
                return this._forEachCell(e1, t, i, r, this._queryCell, s, {
                    hitTest: n,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, o), n ? s.length > 0 : s;
            }
            _queryCircle(e1, t, i, r, n) {
                const o = e1 - i, s = e1 + i, a = t - i, l = t + i;
                if (s < 0 || o > this.width || l < 0 || a > this.height) return !r && [];
                const c = [];
                return this._forEachCell(o, a, s, l, this._queryCellCircle, c, {
                    hitTest: r,
                    circle: {
                        x: e1,
                        y: t,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, n), r ? c.length > 0 : c;
            }
            query(e1, t, i, r, n) {
                return this._query(e1, t, i, r, !1, n);
            }
            hitTest(e1, t, i, r, n) {
                return this._query(e1, t, i, r, !0, n);
            }
            hitTestCircle(e1, t, i, r) {
                return this._queryCircle(e1, t, i, !0, r);
            }
            _queryCell(e1, t, i, r, n, o, s, a) {
                const l = s.seenUids, c = this.boxCells[n];
                if (null !== c) {
                    const n = this.bboxes;
                    for (const h of c)if (!l.box[h]) {
                        l.box[h] = !0;
                        const c = 4 * h;
                        if (e1 <= n[c + 2] && t <= n[c + 3] && i >= n[c + 0] && r >= n[c + 1] && (!a || a(this.boxKeys[h]))) {
                            if (s.hitTest) return o.push(!0), !0;
                            o.push({
                                key: this.boxKeys[h],
                                x1: n[c],
                                y1: n[c + 1],
                                x2: n[c + 2],
                                y2: n[c + 3]
                            });
                        }
                    }
                }
                const h = this.circleCells[n];
                if (null !== h) {
                    const n = this.circles;
                    for (const c of h)if (!l.circle[c]) {
                        l.circle[c] = !0;
                        const h = 3 * c;
                        if (this._circleAndRectCollide(n[h], n[h + 1], n[h + 2], e1, t, i, r) && (!a || a(this.circleKeys[c]))) {
                            if (s.hitTest) return o.push(!0), !0;
                            {
                                const e1 = n[h], t = n[h + 1], i = n[h + 2];
                                o.push({
                                    key: this.circleKeys[c],
                                    x1: e1 - i,
                                    y1: t - i,
                                    x2: e1 + i,
                                    y2: t + i
                                });
                            }
                        }
                    }
                }
            }
            _queryCellCircle(e1, t, i, r, n, o, s, a) {
                const l = s.circle, c = s.seenUids, h = this.boxCells[n];
                if (null !== h) {
                    const e1 = this.bboxes;
                    for (const t of h)if (!c.box[t]) {
                        c.box[t] = !0;
                        const i = 4 * t;
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e1[i + 0], e1[i + 1], e1[i + 2], e1[i + 3]) && (!a || a(this.boxKeys[t]))) return o.push(!0), !0;
                    }
                }
                const u = this.circleCells[n];
                if (null !== u) {
                    const e1 = this.circles;
                    for (const t of u)if (!c.circle[t]) {
                        c.circle[t] = !0;
                        const i = 3 * t;
                        if (this._circlesCollide(e1[i], e1[i + 1], e1[i + 2], l.x, l.y, l.radius) && (!a || a(this.circleKeys[t]))) return o.push(!0), !0;
                    }
                }
            }
            _forEachCell(e1, t, i, r, n, o, s, a) {
                const l = this._convertToXCellCoord(e1), c = this._convertToYCellCoord(t), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(r);
                for(let d = l; d <= h; d++)for(let l = c; l <= u; l++)if (n.call(this, e1, t, i, r, this.xCellCount * l + d, o, s, a)) return;
            }
            _convertToXCellCoord(e1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
            }
            _convertToYCellCoord(e1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
            }
            _circlesCollide(e1, t, i, r, n, o) {
                const s = r - e1, a = n - t, l = i + o;
                return l * l > s * s + a * a;
            }
            _circleAndRectCollide(e1, t, i, r, n, o, s) {
                const a = (o - r) / 2, l = Math.abs(e1 - (r + a));
                if (l > a + i) return !1;
                const c = (s - n) / 2, h = Math.abs(t - (n + c));
                if (h > c + i) return !1;
                if (l <= a || h <= c) return !0;
                const u = l - a, d = h - c;
                return u * u + d * d <= i * i;
            }
            constructor(e1, t, i){
                const r = this.boxCells = [], n = this.circleCells = [];
                this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t / i);
                for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)r.push([]), n.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
            }
        }
        const $T = 100;
        class WT {
            placeCollisionBox(e1, t, i, r, n, o, s, a) {
                let l = i.projectedAnchorX, c = i.projectedAnchorY, h = i.projectedAnchorZ;
                const u = i.elevation, d = i.tileID, p = e1.getProjection();
                if (u && d) {
                    const [e1, t, r] = p.upVector(d.canonical, i.tileAnchorX, i.tileAnchorY), n = p.upVectorScale(d.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    l += e1 * u * n, c += t * u * n, h += r * u * n;
                }
                const f = this.projectAndGetPerspectiveRatio(s, l, c, h, i.tileID, "globe" === p.name || !!u || this.transform.pitch > 0, p), m = o * f.perspectiveRatio, _ = (i.x1 * t + r.x - i.padding) * m + f.point.x, g = (i.y1 * t + r.y - i.padding) * m + f.point.y, y = (i.x2 * t + r.x + i.padding) * m + f.point.x, x = (i.y2 * t + r.y + i.padding) * m + f.point.y, v = f.perspectiveRatio <= .55 || f.occluded;
                return !this.isInsideGrid(_, g, y, x) || !n && this.grid.hitTest(_, g, y, x, a) || v ? {
                    box: [],
                    offscreen: !1,
                    occluded: f.occluded
                } : {
                    box: [
                        _,
                        g,
                        y,
                        x
                    ],
                    offscreen: this.isOffscreen(_, g, y, x),
                    occluded: !1
                };
            }
            placeCollisionCircles(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f) {
                const m = [], _ = this.transform.elevation, g = e1.getProjection(), x = _ ? _.getAtTileOffsetFunc(f, this.transform.center.lat, this.transform.worldSize, g) : null, v = new y(i.tileAnchorX, i.tileAnchorY);
                let { x: b, y: w, z: T } = g.projectTilePoint(v.x, v.y, f.canonical);
                if (x) {
                    const [e1, t, i] = x(v);
                    b += e1, w += t, T += i;
                }
                const E = "globe" === g.name, M = this.projectAndGetPerspectiveRatio(s, b, w, T, f, E || !!_ || this.transform.pitch > 0, g), { perspectiveRatio: A } = M, S = (h ? o / A : o * A) / u_, I = cv(b, w, T, a), C = M.signedDistanceFromCamera > 0 ? pv(S, n, i.lineOffsetX * S, i.lineOffsetY * S, !1, I, v, i, r, a, {}, _ && !h ? x : null, h && !!_, g, f, h) : null;
                let z = !1, P = !1, D = !0;
                if (C && !M.occluded) {
                    const e1 = .5 * d * A + p, i = new y(-100, -100), r = new y(this.screenRightBoundary, this.screenBottomBoundary), n = new qT, { first: o, last: s } = C, a = o.path.length;
                    let h = [];
                    for(let e1 = a - 1; e1 >= 1; e1--)h.push(o.path[e1]);
                    for(let e1 = 1; e1 < s.path.length; e1++)h.push(s.path[e1]);
                    const f = 2.5 * e1;
                    l && (h = h.map(([e1, t, i], r)=>(x && !E && (i = x(r < a - 1 ? o.tilePath[a - 1 - r] : s.tilePath[r - a + 2])[2]), cv(e1, t, i, l))), h.some((e1)=>e1[3] <= 0) && (h = []));
                    let _ = [];
                    if (h.length > 0) {
                        let e1 = 1 / 0, t = -1 / 0, n = 1 / 0, o = -1 / 0;
                        for (const i of h)e1 = Math.min(e1, i[0]), n = Math.min(n, i[1]), t = Math.max(t, i[0]), o = Math.max(o, i[1]);
                        t >= i.x && e1 <= r.x && o >= i.y && n <= r.y && (_ = [
                            h.map((e1)=>new y(e1[0], e1[1]))
                        ], (e1 < i.x || t > r.x || n < i.y || o > r.y) && (_ = Y_(_, i.x, i.y, r.x, r.y)));
                    }
                    for (const i of _){
                        n.reset(i, .25 * e1);
                        let r = 0;
                        r = n.length <= .5 * e1 ? 1 : Math.ceil(n.paddedLength / f) + 1;
                        for(let i = 0; i < r; i++){
                            const o = i / Math.max(r - 1, 1), s = n.lerp(o), a = s.x + $T, l = s.y + $T;
                            m.push(a, l, e1, 0);
                            const h = a - e1, d = l - e1, p = a + e1, f = l + e1;
                            if (D = D && this.isOffscreen(h, d, p, f), P = P || this.isInsideGrid(h, d, p, f), !t && this.grid.hitTestCircle(a, l, e1, u) && (z = !0, !c)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: z,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !c && z || !P ? [] : m,
                    offscreen: D,
                    collisionDetected: z,
                    occluded: M.occluded
                };
            }
            queryRenderedSymbols(e1) {
                if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const t = [];
                let i = 1 / 0, r = 1 / 0, n = -1 / 0, o = -1 / 0;
                for (const s of e1){
                    const e1 = new y(s.x + $T, s.y + $T);
                    i = Math.min(i, e1.x), r = Math.min(r, e1.y), n = Math.max(n, e1.x), o = Math.max(o, e1.y), t.push(e1);
                }
                const s = this.grid.query(i, r, n, o).concat(this.ignoredGrid.query(i, r, n, o)), a = {}, l = {};
                for (const e1 of s){
                    const i = e1.key;
                    void 0 === a[i.bucketInstanceId] && (a[i.bucketInstanceId] = {}), a[i.bucketInstanceId][i.featureIndex] || bp(t, [
                        new y(e1.x1, e1.y1),
                        new y(e1.x2, e1.y1),
                        new y(e1.x2, e1.y2),
                        new y(e1.x1, e1.y2)
                    ]) && (a[i.bucketInstanceId][i.featureIndex] = !0, void 0 === l[i.bucketInstanceId] && (l[i.bucketInstanceId] = []), l[i.bucketInstanceId].push(i.featureIndex));
                }
                return l;
            }
            insertCollisionBox(e1, t, i, r, n) {
                (t ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: r,
                    collisionGroupID: n
                }, e1[0], e1[1], e1[2], e1[3]);
            }
            insertCollisionCircles(e1, t, i, r, n) {
                const o = t ? this.ignoredGrid : this.grid, s = {
                    bucketInstanceId: i,
                    featureIndex: r,
                    collisionGroupID: n
                };
                for(let t = 0; t < e1.length; t += 4)o.insertCircle(s, e1[t], e1[t + 1], e1[t + 2]);
            }
            projectAndGetPerspectiveRatio(e1, t, i, r, n, o, s) {
                const a = [
                    t,
                    i,
                    r,
                    1
                ];
                let l = !1;
                if (r || this.transform.pitch > 0) {
                    if (yu.transformMat4(a, a, e1), this.fogState && n && "globe" !== s.name) {
                        const e1 = function(e1, t, i, r, n, o) {
                            const s = o.calculateFogTileMatrix(n), a = [
                                t,
                                i,
                                r
                            ];
                            return Du.transformMat4(a, a, s), mw(e1, Du.length(a), o.pitch, o._fov);
                        }(this.fogState, t, i, r, n.toUnwrapped(), this.transform);
                        l = e1 > .9;
                    }
                } else vv(a, a, e1);
                const c = a[3];
                return {
                    point: new y((a[0] / c + 1) / 2 * this.transform.width + $T, (-a[1] / c + 1) / 2 * this.transform.height + $T),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(s) / c * .5, 1.5),
                    signedDistanceFromCamera: c,
                    occluded: o && a[2] > c || l
                };
            }
            isOffscreen(e1, t, i, r) {
                return i < $T || e1 >= this.screenRightBoundary || r < $T || t > this.screenBottomBoundary;
            }
            isInsideGrid(e1, t, i, r) {
                return i >= 0 && e1 < this.gridRightBoundary && r >= 0 && t < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const e1 = Au.identity([]);
                return Au.translate(e1, e1, [
                    -100,
                    -100,
                    0
                ]), e1;
            }
            constructor(e1, t, i = new ZT(e1.width + 200, e1.height + 200, 25), r = new ZT(e1.width + 200, e1.height + 200, 25)){
                this.transform = e1, this.grid = i, this.ignoredGrid = r, this.pitchfactor = Math.cos(e1._pitch) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + $T, this.screenBottomBoundary = e1.height + $T, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.fogState = t;
            }
        }
        function HT(e1, t, i) {
            const r = t.createTileMatrix(e1, e1.worldSize, i.toUnwrapped());
            return Au.multiply(new Float32Array(16), e1.projMatrix, r);
        }
        function XT(e1, t, i) {
            if (t.projection.name === i.projection.name) return e1.projMatrix;
            const r = i.clone();
            return r.setProjection(t.projection), HT(r, t.getProjection(), e1);
        }
        function YT(e1, t, i) {
            return t.name === i.projection.name ? e1.projMatrix : HT(i, t, e1);
        }
        class KT {
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
            constructor(e1, t, i, r){
                this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t : -t))) : r && i ? 1 : 0, this.placed = i;
            }
        }
        class JT {
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
            constructor(e1, t, i, r, n, o = !1){
                this.text = new KT(e1 ? e1.text : null, t, i, n), this.icon = new KT(e1 ? e1.icon : null, t, r, n), this.clipped = o;
            }
        }
        class QT {
            constructor(e1, t, i, r = !1){
                this.text = e1, this.icon = t, this.skipFade = i, this.clipped = r;
            }
        }
        class eE {
            constructor(){
                this.invProjMatrix = Au.create(), this.viewportMatrix = Au.create(), this.circles = [];
            }
        }
        class tE {
            constructor(e1, t, i, r, n){
                this.bucketInstanceId = e1, this.featureIndex = t, this.sourceLayerIndex = i, this.bucketIndex = r, this.tileID = n;
            }
        }
        class iE {
            get(e1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e1]) {
                    const t = ++this.maxGroupID;
                    this.collisionGroups[e1] = {
                        ID: t,
                        predicate: (e1)=>e1.collisionGroupID === t
                    };
                }
                return this.collisionGroups[e1];
            }
            constructor(e1){
                this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
            }
        }
        function rE(e1, t, i, r, n) {
            const { horizontalAlign: o, verticalAlign: s } = F_(e1), a = -(o - .5) * t, l = -(s - .5) * i, c = xg(e1, r);
            return new y(a + c[0] * n, l + c[1] * n);
        }
        function nE(e1, t, i, r, n) {
            const o = new y(e1, t);
            return i && o._rotate(r ? n : -n), o;
        }
        class oE {
            getBucketParts(e1, t, i, r) {
                const n = i.getBucket(t), o = i.latestFeatureIndex;
                if (!n || !o || t.fqid !== n.layerIds[0]) return;
                const s = n.layers[0].layout, a = i.collisionBoxArray, l = Math.pow(2, this.transform.zoom - i.tileID.overscaledZ), c = i.tileSize / cr, h = i.tileID.toUnwrapped();
                this.transform.setProjection(n.projection);
                const u = (d = i.tileID, p = n.getProjection(), f = this.transform, p.name === this.projection ? f.calculateProjMatrix(d.toUnwrapped()) : HT(f, p, d));
                var d, p, f;
                const m = "map" === s.get("text-pitch-alignment"), _ = "map" === s.get("text-rotation-alignment");
                t.compileFilter();
                const g = t.dynamicFilter(), y = t.dynamicFilterNeedsFeature(), x = this.transform.calculatePixelsToTileUnitsMatrix(i), v = av(u, i.tileID.canonical, m, _, this.transform, n.getProjection(), x);
                let b = null;
                if (m) {
                    const e1 = lv(u, i.tileID.canonical, m, _, this.transform, n.getProjection(), x);
                    b = Au.multiply([], this.transform.labelPlaneMatrix, e1);
                }
                let w = null;
                g && i.latestFeatureIndex && (w = {
                    unwrappedTileID: h,
                    dynamicFilter: g,
                    dynamicFilterNeedsFeature: y,
                    featureIndex: i.latestFeatureIndex
                }), this.retainedQueryData[n.bucketInstanceId] = new tE(n.bucketInstanceId, o, n.sourceLayerIndex, n.index, i.tileID);
                const T = {
                    bucket: n,
                    layout: s,
                    posMatrix: u,
                    textLabelPlaneMatrix: v,
                    labelToScreenMatrix: b,
                    clippingData: w,
                    scale: l,
                    textPixelRatio: c,
                    holdingForFade: i.holdingForFade(),
                    collisionBoxArray: a,
                    partiallyEvaluatedTextSize: m_(n.textSizeData, this.transform.zoom),
                    partiallyEvaluatedIconSize: m_(n.iconSizeData, this.transform.zoom),
                    collisionGroup: this.collisionGroups.get(n.sourceID)
                };
                if (r) for (const t of n.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: r, symbolInstanceEnd: n } = t;
                    e1.push({
                        sortKey: i,
                        symbolInstanceStart: r,
                        symbolInstanceEnd: n,
                        parameters: T
                    });
                }
                else e1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: n.symbolInstances.length,
                    parameters: T
                });
            }
            attemptAnchorPlacement(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g) {
                const { textOffset0: y, textOffset1: x, crossTileID: v } = u, b = [
                    y,
                    x
                ], w = rE(e1, i, r, b, n), T = this.collisionIndex.placeCollisionBox(p, n, t, nE(w.x, w.y, o, s, this.transform.angle), h, a, l, c.predicate);
                if (m) {
                    const e1 = p.getSymbolInstanceIconSize(g, this.transform.zoom, u.placedIconSymbolIndex);
                    if (0 === this.collisionIndex.placeCollisionBox(p, e1, m, nE(w.x, w.y, o, s, this.transform.angle), h, a, l, c.predicate).box.length) return;
                }
                if (T.box.length > 0) {
                    let t;
                    return this.prevPlacement && this.prevPlacement.variableOffsets[v] && this.prevPlacement.placements[v] && this.prevPlacement.placements[v].text && (t = this.prevPlacement.variableOffsets[v].anchor), this.variableOffsets[v] = {
                        textOffset: b,
                        width: i,
                        height: r,
                        anchor: e1,
                        textScale: n,
                        prevAnchor: t
                    }, this.markUsedJustification(p, e1, u, f), p.allowVerticalPlacement && (this.markUsedOrientation(p, f, u), this.placedOrientations[v] = f), {
                        shift: w,
                        placedGlyphBoxes: T
                    };
                }
            }
            placeLayerBucketPart(e1, t, i, r) {
                const { bucket: n, layout: o, posMatrix: s, textLabelPlaneMatrix: a, labelToScreenMatrix: l, clippingData: c, textPixelRatio: h, holdingForFade: u, collisionBoxArray: d, partiallyEvaluatedTextSize: p, partiallyEvaluatedIconSize: f, collisionGroup: m } = e1.parameters, _ = o.get("text-optional"), g = o.get("icon-optional"), x = o.get("text-allow-overlap"), v = o.get("icon-allow-overlap"), b = "map" === o.get("text-rotation-alignment"), w = "map" === o.get("text-pitch-alignment"), T = "viewport-y" === o.get("symbol-z-order"), E = o.get("symbol-z-elevate");
                this.transform.setProjection(n.projection);
                let M = x && (v || !n.hasIconData() || g), A = v && (x || !n.hasTextData() || _);
                !n.collisionArrays && d && n.deserializeCollisionBoxes(d), i && r && n.updateCollisionDebugBuffers(this.transform.zoom, d);
                const S = (e1, r, d)=>{
                    const { crossTileID: T, numVerticalGlyphVertices: E } = e1;
                    if (c) {
                        const i = {
                            zoom: this.transform.zoom,
                            pitch: this.transform.pitch
                        };
                        let r = null;
                        if (c.dynamicFilterNeedsFeature) {
                            const t = this.retainedQueryData[n.bucketInstanceId];
                            r = c.featureIndex.loadFeature({
                                featureIndex: e1.featureIndex,
                                bucketIndex: t.bucketIndex,
                                sourceLayerIndex: t.sourceLayerIndex,
                                layoutVertexArrayOffset: 0
                            });
                        }
                        if (!(0, c.dynamicFilter)(i, r, this.retainedQueryData[n.bucketInstanceId].tileID.canonical, new y(e1.tileAnchorX, e1.tileAnchorY), this.transform.calculateDistanceTileData(c.unwrappedTileID))) return this.placements[T] = new QT(!1, !1, !1, !0), void t.add(T);
                    }
                    if (t.has(T)) return;
                    if (u) return void (this.placements[T] = new QT(!1, !1, !1));
                    let S = !1, I = !1, C = !0, z = !1, P = !1, D = null, R = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, L = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, k = null, O = null, B = null, F = 0, N = 0, U = 0;
                    d.textFeatureIndex ? F = d.textFeatureIndex : e1.useRuntimeCollisionCircles && (F = e1.featureIndex), d.verticalTextFeatureIndex && (N = d.verticalTextFeatureIndex);
                    const V = (t)=>{
                        t.tileID = this.retainedQueryData[n.bucketInstanceId].tileID;
                        const i = this.transform.elevation;
                        t.elevation = e1.zOffset + (i ? i.getAtTileOffset(t.tileID, t.tileAnchorX, t.tileAnchorY) : 0);
                    }, j = d.textBox;
                    if (j) {
                        V(j);
                        const t = (t)=>{
                            let i = A_.horizontal;
                            if (n.allowVerticalPlacement && !t && this.prevPlacement) {
                                const t = this.prevPlacement.placedOrientations[T];
                                t && (this.placedOrientations[T] = t, i = t, this.markUsedOrientation(n, i, e1));
                            }
                            return i;
                        }, i = (e1, t)=>{
                            if (n.allowVerticalPlacement && E > 0 && d.verticalTextBox) {
                                for (const i of n.writingModes)if (i === A_.vertical ? (R = t(), L = R) : R = e1(), R && R.box && R.box.length) break;
                            } else R = e1();
                        };
                        if (o.get("text-variable-anchor")) {
                            let a = o.get("text-variable-anchor");
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[T]) {
                                const e1 = this.prevPlacement.variableOffsets[T];
                                a.indexOf(e1.anchor) > 0 && (a = a.filter((t)=>t !== e1.anchor), a.unshift(e1.anchor));
                            }
                            const l = (t, i, o)=>{
                                const l = n.getSymbolInstanceTextSize(p, e1, this.transform.zoom, r), c = (t.x2 - t.x1) * l + 2 * t.padding, u = (t.y2 - t.y1) * l + 2 * t.padding, d = e1.hasIconTextFit && !v ? i : null;
                                d && V(d);
                                let _ = {
                                    box: [],
                                    offscreen: !1,
                                    occluded: !1
                                };
                                const g = x ? 2 * a.length : a.length;
                                for(let i = 0; i < g; ++i){
                                    const g = this.attemptAnchorPlacement(a[i % a.length], t, c, u, l, b, w, h, s, m, i >= a.length, e1, r, n, o, d, p, f);
                                    if (g && (_ = g.placedGlyphBoxes, _ && _.box && _.box.length)) {
                                        S = !0, D = g.shift;
                                        break;
                                    }
                                }
                                return _;
                            };
                            i(()=>l(j, d.iconBox, A_.horizontal), ()=>{
                                const e1 = d.verticalTextBox;
                                return e1 && V(e1), n.allowVerticalPlacement && !(R && R.box && R.box.length) && E > 0 && e1 ? l(e1, d.verticalIconBox, A_.vertical) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), R && (S = R.box, C = R.offscreen, z = R.occluded);
                            const c = t(!(!R || !R.box));
                            if (!S && this.prevPlacement) {
                                const t = this.prevPlacement.variableOffsets[T];
                                t && (this.variableOffsets[T] = t, this.markUsedJustification(n, t.anchor, e1, c));
                            }
                        } else {
                            const o = (t, i)=>{
                                const o = n.getSymbolInstanceTextSize(p, e1, this.transform.zoom, r), a = this.collisionIndex.placeCollisionBox(n, o, t, new y(0, 0), x, h, s, m.predicate);
                                return a && a.box && a.box.length && (this.markUsedOrientation(n, i, e1), this.placedOrientations[T] = i), a;
                            };
                            i(()=>o(j, A_.horizontal), ()=>{
                                const e1 = d.verticalTextBox;
                                return n.allowVerticalPlacement && E > 0 && e1 ? (V(e1), o(e1, A_.vertical)) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), t(!!(R && R.box && R.box.length));
                        }
                    }
                    if (k = R, S = k && k.box && k.box.length > 0, C = k && k.offscreen, z = k && k.occluded, e1.useRuntimeCollisionCircles) {
                        const t = n.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex >= 0 ? e1.centerJustifiedTextSymbolIndex : e1.verticalPlacedTextSymbolIndex), r = f_(n.textSizeData, p, t), c = o.get("text-padding");
                        O = this.collisionIndex.placeCollisionCircles(n, x, t, n.lineVertexArray, n.glyphOffsetArray, r, s, a, l, i, w, m.predicate, e1.collisionCircleDiameter * r / u_, c, this.retainedQueryData[n.bucketInstanceId].tileID), S = x || O.circles.length > 0 && !O.collisionDetected, C = C && O.offscreen, z = O.occluded;
                    }
                    if (d.iconFeatureIndex && (U = d.iconFeatureIndex), d.iconBox) {
                        const t = (t)=>{
                            V(t);
                            const i = e1.hasIconTextFit && D ? nE(D.x, D.y, b, w, this.transform.angle) : new y(0, 0), r = n.getSymbolInstanceIconSize(f, this.transform.zoom, e1.placedIconSymbolIndex);
                            return this.collisionIndex.placeCollisionBox(n, r, t, i, v, h, s, m.predicate);
                        };
                        L && L.box && L.box.length && d.verticalIconBox ? (B = t(d.verticalIconBox), I = B.box.length > 0) : (B = t(d.iconBox), I = B.box.length > 0), C = C && B.offscreen, P = B.occluded;
                    }
                    const G = _ || 0 === e1.numHorizontalGlyphVertices && 0 === E, q = g || 0 === e1.numIconVertices;
                    if (G || q ? q ? G || (I = I && S) : S = I && S : I = S = I && S, S && k && k.box && this.collisionIndex.insertCollisionBox(k.box, o.get("text-ignore-placement"), n.bucketInstanceId, L && L.box && N ? N : F, m.ID), I && B && this.collisionIndex.insertCollisionBox(B.box, o.get("icon-ignore-placement"), n.bucketInstanceId, U, m.ID), O && (S && this.collisionIndex.insertCollisionCircles(O.circles, o.get("text-ignore-placement"), n.bucketInstanceId, F, m.ID), i)) {
                        const e1 = n.bucketInstanceId;
                        let t = this.collisionCircleArrays[e1];
                        void 0 === t && (t = this.collisionCircleArrays[e1] = new eE);
                        for(let e1 = 0; e1 < O.circles.length; e1 += 4)t.circles.push(O.circles[e1 + 0]), t.circles.push(O.circles[e1 + 1]), t.circles.push(O.circles[e1 + 2]), t.circles.push(O.collisionDetected ? 1 : 0);
                    }
                    const Z = "globe" !== n.projection.name;
                    M = M && (Z || !z), A = A && (Z || !P), this.placements[T] = new QT(S || M, I || A, C || n.justReloaded), t.add(T);
                };
                if (E && this.buildingIndex && (this.buildingIndex.updateZOffset(n, this.retainedQueryData[n.bucketInstanceId].tileID), n.updateZOffset()), T) {
                    const e1 = n.getSortedSymbolIndexes(this.transform.angle);
                    for(let t = e1.length - 1; t >= 0; --t){
                        const i = e1[t];
                        S(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                    }
                    n.hasAnyZOffset && H(`${n.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
                } else if (n.hasAnyZOffset) {
                    const e1 = n.getSortedIndexesByZOffset();
                    for(let t = 0; t < e1.length; ++t){
                        const i = e1[t];
                        S(n.symbolInstances.get(i), i, n.collisionArrays[i]);
                    }
                } else for(let t = e1.symbolInstanceStart; t < e1.symbolInstanceEnd; t++)S(n.symbolInstances.get(t), t, n.collisionArrays[t]);
                if (i && n.bucketInstanceId in this.collisionCircleArrays) {
                    const e1 = this.collisionCircleArrays[n.bucketInstanceId];
                    Au.invert(e1.invProjMatrix, s), e1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                n.justReloaded = !1;
            }
            markUsedJustification(e1, t, i, r) {
                const { leftJustifiedTextSymbolIndex: n, centerJustifiedTextSymbolIndex: o, rightJustifiedTextSymbolIndex: s, verticalPlacedTextSymbolIndex: a, crossTileID: l } = i, c = bg(t), h = r === A_.vertical ? a : "left" === c ? n : "center" === c ? o : "right" === c ? s : -1;
                n >= 0 && (e1.text.placedSymbolArray.get(n).crossTileID = h >= 0 && n !== h ? 0 : l), o >= 0 && (e1.text.placedSymbolArray.get(o).crossTileID = h >= 0 && o !== h ? 0 : l), s >= 0 && (e1.text.placedSymbolArray.get(s).crossTileID = h >= 0 && s !== h ? 0 : l), a >= 0 && (e1.text.placedSymbolArray.get(a).crossTileID = h >= 0 && a !== h ? 0 : l);
            }
            markUsedOrientation(e1, t, i) {
                const r = t === A_.horizontal || t === A_.horizontalOnly ? t : 0, n = t === A_.vertical ? t : 0, { leftJustifiedTextSymbolIndex: o, centerJustifiedTextSymbolIndex: s, rightJustifiedTextSymbolIndex: a, verticalPlacedTextSymbolIndex: l } = i, c = e1.text.placedSymbolArray;
                o >= 0 && (c.get(o).placedOrientation = r), s >= 0 && (c.get(s).placedOrientation = r), a >= 0 && (c.get(a).placedOrientation = r), l >= 0 && (c.get(l).placedOrientation = n);
            }
            commit(e1) {
                this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t ? t.zoomAdjustment(this.transform.zoom) : 0;
                const r = t ? t.symbolFadeChange(e1) : 1, n = t ? t.opacities : {}, o = t ? t.variableOffsets : {}, s = t ? t.placedOrientations : {};
                for(const e1 in this.placements){
                    const t = this.placements[e1], o = n[e1];
                    o ? (this.opacities[e1] = new JT(o, r, t.text, t.icon, null, t.clipped), i = i || t.text !== o.text.placed || t.icon !== o.icon.placed) : (this.opacities[e1] = new JT(null, r, t.text, t.icon, t.skipFade, t.clipped), i = i || t.text || t.icon);
                }
                for(const e1 in n){
                    const t = n[e1];
                    if (!this.opacities[e1]) {
                        const n = new JT(t, r, !1, !1);
                        n.isHidden() || (this.opacities[e1] = n, i = i || t.text.placed || t.icon.placed);
                    }
                }
                for(const e1 in o)this.variableOffsets[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.variableOffsets[e1] = o[e1]);
                for(const e1 in s)this.placedOrientations[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.placedOrientations[e1] = s[e1]);
                i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t ? t.lastPlacementChangeTime : e1);
            }
            updateLayerOpacities(e1, t) {
                const i = new Set;
                for (const r of t){
                    const t = r.getBucket(e1);
                    t && r.latestFeatureIndex && e1.fqid === t.layerIds[0] && (this.updateBucketOpacities(t, i, r.collisionBoxArray), t.layers[0].layout.get("symbol-z-elevate") && this.buildingIndex && (this.buildingIndex.updateZOffset(t, r.tileID), t.updateZOffset()));
                }
            }
            updateBucketOpacities(e1, t, i) {
                e1.hasTextData() && e1.text.opacityVertexArray.clear(), e1.hasIconData() && e1.icon.opacityVertexArray.clear(), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
                const r = e1.layers[0].layout, n = !!e1.layers[0].dynamicFilter(), o = new JT(null, 0, !1, !1, !0), s = r.get("text-allow-overlap"), a = r.get("icon-allow-overlap"), l = r.get("text-variable-anchor"), c = "map" === r.get("text-rotation-alignment"), h = "map" === r.get("text-pitch-alignment"), u = new JT(null, 0, s && (a || !e1.hasIconData() || r.get("icon-optional")), a && (s || !e1.hasTextData() || r.get("text-optional")), !0);
                !e1.collisionArrays && i && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(i);
                const d = (e1, t, i)=>{
                    for(let r = 0; r < t / 4; r++)e1.opacityVertexArray.emplaceBack(i);
                };
                let p = 0;
                for(let i = 0; i < e1.symbolInstances.length; i++){
                    const r = e1.symbolInstances.get(i), { numHorizontalGlyphVertices: s, numVerticalGlyphVertices: a, crossTileID: f, numIconVertices: m } = r, _ = t.has(f);
                    let g = this.opacities[f];
                    _ ? g = o : g || (g = u, this.opacities[f] = g), t.add(f);
                    const x = s > 0 || a > 0, v = m > 0, b = this.placedOrientations[f], w = b === A_.vertical, T = b === A_.horizontal || b === A_.horizontalOnly;
                    if (!x && !v || g.isHidden() || p++, x) {
                        const t = fE(g.text);
                        d(e1.text, s, w ? mE : t), d(e1.text, a, T ? mE : t);
                        const i = g.text.isHidden(), { leftJustifiedTextSymbolIndex: n, centerJustifiedTextSymbolIndex: o, rightJustifiedTextSymbolIndex: l, verticalPlacedTextSymbolIndex: c } = r, h = e1.text.placedSymbolArray, u = i || w ? 1 : 0;
                        n >= 0 && (h.get(n).hidden = u), o >= 0 && (h.get(o).hidden = u), l >= 0 && (h.get(l).hidden = u), c >= 0 && (h.get(c).hidden = i || T ? 1 : 0);
                        const p = this.variableOffsets[f];
                        p && this.markUsedJustification(e1, p.anchor, r, b);
                        const m = this.placedOrientations[f];
                        m && (this.markUsedJustification(e1, "left", r, m), this.markUsedOrientation(e1, m, r));
                    }
                    if (v) {
                        const t = fE(g.icon), { placedIconSymbolIndex: i, verticalPlacedIconSymbolIndex: n } = r, o = e1.icon.placedSymbolArray, s = g.icon.isHidden() ? 1 : 0;
                        i >= 0 && (d(e1.icon, m, w ? mE : t), o.get(i).hidden = s), n >= 0 && (d(e1.icon, r.numVerticalIconVertices, T ? mE : t), o.get(n).hidden = s);
                    }
                    if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                        const t = e1.collisionArrays[i];
                        if (t) {
                            let i = new y(0, 0), o = !0;
                            if (t.textBox || t.verticalTextBox) {
                                if (l) {
                                    const e1 = this.variableOffsets[f];
                                    e1 ? (i = rE(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textScale), c && i._rotate(h ? this.transform.angle : -this.transform.angle)) : o = !1;
                                }
                                n && (o = !g.clipped), t.textBox && sE(e1.textCollisionBox.collisionVertexArray, g.text.placed, !o || w, i.x, i.y), t.verticalTextBox && sE(e1.textCollisionBox.collisionVertexArray, g.text.placed, !o || T, i.x, i.y);
                            }
                            const s = o && Boolean(!T && t.verticalIconBox);
                            t.iconBox && sE(e1.iconCollisionBox.collisionVertexArray, g.icon.placed, s, r.hasIconTextFit ? i.x : 0, r.hasIconTextFit ? i.y : 0), t.verticalIconBox && sE(e1.iconCollisionBox.collisionVertexArray, g.icon.placed, !s, r.hasIconTextFit ? i.x : 0, r.hasIconTextFit ? i.y : 0);
                        }
                    }
                }
                if (e1.fullyClipped = 0 === p, e1.sortFeatures(this.transform.angle), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.bucketInstanceId in this.collisionCircleArrays) {
                    const t = this.collisionCircleArrays[e1.bucketInstanceId];
                    e1.placementInvProjMatrix = t.invProjMatrix, e1.placementViewportMatrix = t.viewportMatrix, e1.collisionCircleArray = t.circles, delete this.collisionCircleArrays[e1.bucketInstanceId];
                }
            }
            symbolFadeChange(e1) {
                return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e1) {
                return Math.max(0, (this.transform.zoom - e1) / 1.5);
            }
            hasTransitions(e1) {
                return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e1, t) {
                const i = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
                return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * i > e1;
            }
            setStale() {
                this.stale = !0;
            }
            constructor(e1, t, i, r, n, o){
                this.transform = e1.clone(), this.projection = e1.projection.name, this.collisionIndex = new WT(this.transform, n), this.buildingIndex = o, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t, this.retainedQueryData = {}, this.collisionGroups = new iE(i), this.collisionCircleArrays = {}, this.prevPlacement = r, r && (r.prevPlacement = void 0), this.placedOrientations = {};
            }
        }
        function sE(e1, t, i, r, n) {
            e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, n || 0), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, n || 0), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, n || 0), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, n || 0);
        }
        const aE = Math.pow(2, 25), lE = Math.pow(2, 24), cE = Math.pow(2, 17), hE = Math.pow(2, 16), uE = Math.pow(2, 9), dE = Math.pow(2, 8), pE = Math.pow(2, 1);
        function fE(e1) {
            if (0 === e1.opacity && !e1.placed) return 0;
            if (1 === e1.opacity && e1.placed) return 4294967295;
            const t = e1.placed ? 1 : 0, i = Math.floor(127 * e1.opacity);
            return i * aE + t * lE + i * cE + t * hE + i * uE + t * dE + i * pE + t;
        }
        const mE = 0;
        class _E {
            continuePlacement(e1, t, i, r, n) {
                const o = this._bucketParts;
                for(; this._currentTileIndex < e1.length;)if (t.getBucketParts(o, r, e1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, n()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, o.sort((e1, t)=>e1.sortKey - t.sortKey)); this._currentPartIndex < o.length;){
                    const e1 = o[this._currentPartIndex];
                    if (t.placeLayerBucketPart(e1, this._seenCrossTileIDs, i, 0 === e1.symbolInstanceStart), this._currentPartIndex++, n()) return !0;
                }
                return !1;
            }
            constructor(e1){
                this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && void 0 !== e1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = new Set, this._bucketParts = [];
            }
        }
        class gE {
            isDone() {
                return this._done;
            }
            continuePlacement(e1, t, i, r) {
                const n = dt.now(), o = ()=>{
                    const e1 = dt.now() - n;
                    return !this._forceFullPlacement && e1 > 2;
                };
                for(; this._currentPlacementIndex >= 0;){
                    const n = t[e1[this._currentPlacementIndex]], s = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === n.type && (!n.minzoom || n.minzoom <= s) && (!n.maxzoom || n.maxzoom > s)) {
                        const e1 = n, t = e1.layout.get("symbol-z-elevate"), s = this._inProgressLayer = this._inProgressLayer || new _E(e1), a = va(n.source, n.scope);
                        if (s.continuePlacement(t ? r[a] : i[a], this.placement, this._showCollisionBoxes, n, o)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._done = !0;
            }
            commit(e1) {
                return this.placement.commit(e1), this.placement;
            }
            constructor(e1, t, i, r, n, o, s, a, l){
                this.placement = new oE(e1, n, o, s, a, l), this._currentPlacementIndex = t.length - 1, this._forceFullPlacement = i, this._showCollisionBoxes = r, this._done = !1;
            }
        }
        const yE = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class xE {
            static from(e1) {
                if (!(e1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [t, i] = new Uint8Array(e1, 0, 2);
                if (219 !== t) throw new Error("Data does not appear to be in a KDBush format.");
                const r = i >> 4;
                if (1 !== r) throw new Error(`Got v${r} data when expected v1.`);
                const n = yE[15 & i];
                if (!n) throw new Error("Unrecognized array type.");
                const [o] = new Uint16Array(e1, 2, 1), [s] = new Uint32Array(e1, 4, 1);
                return new xE(s, o, n, e1);
            }
            add(e1, t) {
                const i = this._pos >> 1;
                return this.ids[i] = i, this.coords[this._pos++] = e1, this.coords[this._pos++] = t, i;
            }
            finish() {
                const e1 = this._pos >> 1;
                if (e1 !== this.numItems) throw new Error(`Added ${e1} items when expected ${this.numItems}.`);
                return vE(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(e1, t, i, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: o, nodeSize: s } = this, a = [
                    0,
                    n.length - 1,
                    0
                ], l = [];
                for(; a.length;){
                    const c = a.pop() || 0, h = a.pop() || 0, u = a.pop() || 0;
                    if (h - u <= s) {
                        for(let s = u; s <= h; s++){
                            const a = o[2 * s], c = o[2 * s + 1];
                            a >= e1 && a <= i && c >= t && c <= r && l.push(n[s]);
                        }
                        continue;
                    }
                    const d = u + h >> 1, p = o[2 * d], f = o[2 * d + 1];
                    p >= e1 && p <= i && f >= t && f <= r && l.push(n[d]), (0 === c ? e1 <= p : t <= f) && (a.push(u), a.push(d - 1), a.push(1 - c)), (0 === c ? i >= p : r >= f) && (a.push(d + 1), a.push(h), a.push(1 - c));
                }
                return l;
            }
            within(e1, t, i) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: r, coords: n, nodeSize: o } = this, s = [
                    0,
                    r.length - 1,
                    0
                ], a = [], l = i * i;
                for(; s.length;){
                    const c = s.pop() || 0, h = s.pop() || 0, u = s.pop() || 0;
                    if (h - u <= o) {
                        for(let i = u; i <= h; i++)EE(n[2 * i], n[2 * i + 1], e1, t) <= l && a.push(r[i]);
                        continue;
                    }
                    const d = u + h >> 1, p = n[2 * d], f = n[2 * d + 1];
                    EE(p, f, e1, t) <= l && a.push(r[d]), (0 === c ? e1 - i <= p : t - i <= f) && (s.push(u), s.push(d - 1), s.push(1 - c)), (0 === c ? e1 + i >= p : t + i >= f) && (s.push(d + 1), s.push(h), s.push(1 - c));
                }
                return a;
            }
            constructor(e1, t = 64, i = Float64Array, r){
                if (isNaN(e1) || e1 < 0) throw new Error(`Unpexpected numItems value: ${e1}.`);
                this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t, 2), 65535), this.ArrayType = i, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
                const n = yE.indexOf(this.ArrayType), o = 2 * e1 * this.ArrayType.BYTES_PER_ELEMENT, s = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, a = (8 - s % 8) % 8;
                if (n < 0) throw new Error(`Unexpected typed array class: ${i}.`);
                r && r instanceof ArrayBuffer ? (this.data = r, this.ids = new this.IndexArrayType(this.data, 8, e1), this.coords = new this.ArrayType(this.data, 8 + s + a, 2 * e1), this._pos = 2 * e1, this._finished = !0) : (this.data = new ArrayBuffer(8 + o + s + a), this.ids = new this.IndexArrayType(this.data, 8, e1), this.coords = new this.ArrayType(this.data, 8 + s + a, 2 * e1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + n
                ]), new Uint16Array(this.data, 2, 1)[0] = t, new Uint32Array(this.data, 4, 1)[0] = e1);
            }
        }
        function vE(e1, t, i, r, n, o) {
            if (n - r <= i) return;
            const s = r + n >> 1;
            bE(e1, t, s, r, n, o), vE(e1, t, i, r, s - 1, 1 - o), vE(e1, t, i, s + 1, n, 1 - o);
        }
        function bE(e1, t, i, r, n, o) {
            for(; n > r;){
                if (n - r > 600) {
                    const s = n - r + 1, a = i - r + 1, l = Math.log(s), c = .5 * Math.exp(2 * l / 3), h = .5 * Math.sqrt(l * c * (s - c) / s) * (a - s / 2 < 0 ? -1 : 1);
                    bE(e1, t, i, Math.max(r, Math.floor(i - a * c / s + h)), Math.min(n, Math.floor(i + (s - a) * c / s + h)), o);
                }
                const s = t[2 * i + o];
                let a = r, l = n;
                for(wE(e1, t, r, i), t[2 * n + o] > s && wE(e1, t, r, n); a < l;){
                    for(wE(e1, t, a, l), a++, l--; t[2 * a + o] < s;)a++;
                    for(; t[2 * l + o] > s;)l--;
                }
                t[2 * r + o] === s ? wE(e1, t, r, l) : (l++, wE(e1, t, l, n)), l <= i && (r = l + 1), i <= l && (n = l - 1);
            }
        }
        function wE(e1, t, i, r) {
            TE(e1, i, r), TE(t, 2 * i, 2 * r), TE(t, 2 * i + 1, 2 * r + 1);
        }
        function TE(e1, t, i) {
            const r = e1[t];
            e1[t] = e1[i], e1[i] = r;
        }
        function EE(e1, t, i, r) {
            const n = e1 - i, o = t - r;
            return n * n + o * o;
        }
        const ME = 512 / cr / 2;
        class AE {
            findMatches(e1, t, i) {
                const r = this.tileID.canonical.z < t.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t.canonical.z), n = ME / Math.pow(2, t.canonical.z - this.tileID.canonical.z), o = t.canonical.x * cr, s = t.canonical.y * cr;
                for(let t = 0; t < e1.length; t++){
                    const a = e1.get(t);
                    if (a.crossTileID) continue;
                    const { key: l, tileAnchorX: c, tileAnchorY: h } = a, u = Math.floor((o + c) * n), d = Math.floor((s + h) * n), p = this.index.range(u - r, d - r, u + r, d + r);
                    for (const e1 of p){
                        const t = this.crossTileIDs[e1];
                        if (this.keys[e1] === l && !i.has(t)) {
                            i.add(t), a.crossTileID = t;
                            break;
                        }
                    }
                }
            }
            constructor(e1, t, i){
                this.tileID = e1, this.bucketInstanceId = i, this.index = new xE(t.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
                const r = e1.canonical.x * cr, n = e1.canonical.y * cr;
                for(let e1 = 0; e1 < t.length; e1++){
                    const { key: i, crossTileID: o, tileAnchorX: s, tileAnchorY: a } = t.get(e1), l = Math.floor((r + s) * ME), c = Math.floor((n + a) * ME);
                    this.index.add(l, c), this.keys.push(i), this.crossTileIDs.push(o);
                }
                this.index.finish();
            }
        }
        class SE {
            generate() {
                return ++this.maxCrossTileID;
            }
            constructor(){
                this.maxCrossTileID = 0;
            }
        }
        class IE {
            handleWrapJump(e1) {
                const t = Math.round((e1 - this.lng) / 360);
                if (0 !== t) for(const e1 in this.indexes){
                    const i = this.indexes[e1], r = {};
                    for(const e1 in i){
                        const n = i[e1];
                        n.tileID = n.tileID.unwrapTo(n.tileID.wrap + t), r[n.tileID.key] = n;
                    }
                    this.indexes[e1] = r;
                }
                this.lng = e1;
            }
            addBucket(e1, t, i) {
                if (this.indexes[e1.overscaledZ] && this.indexes[e1.overscaledZ][e1.key]) {
                    if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
                }
                for(let e1 = 0; e1 < t.symbolInstances.length; e1++)t.symbolInstances.get(e1).crossTileID = 0;
                this.usedCrossTileIDs[e1.overscaledZ] || (this.usedCrossTileIDs[e1.overscaledZ] = new Set);
                const r = this.usedCrossTileIDs[e1.overscaledZ];
                for(const i in this.indexes){
                    const n = this.indexes[i];
                    if (Number(i) > e1.overscaledZ) for(const i in n){
                        const o = n[i];
                        o.tileID.isChildOf(e1) && o.findMatches(t.symbolInstances, e1, r);
                    }
                    else {
                        const o = n[e1.scaledTo(Number(i)).key];
                        o && o.findMatches(t.symbolInstances, e1, r);
                    }
                }
                for(let e1 = 0; e1 < t.symbolInstances.length; e1++){
                    const n = t.symbolInstances.get(e1);
                    n.crossTileID || (n.crossTileID = i.generate(), r.add(n.crossTileID));
                }
                return void 0 === this.indexes[e1.overscaledZ] && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new AE(e1, t.symbolInstances, t.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e1, t) {
                for (const i of t.crossTileIDs)this.usedCrossTileIDs[e1].delete(i);
            }
            removeStaleBuckets(e1) {
                let t = !1;
                for(const i in this.indexes){
                    const r = this.indexes[i];
                    for(const n in r)e1[r[n].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, r[n]), delete r[n], t = !0);
                }
                return t;
            }
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
        }
        class CE {
            addLayer(e1, t, i, r) {
                let n = this.layerIndexes[e1.fqid];
                void 0 === n && (n = this.layerIndexes[e1.fqid] = new IE);
                let o = !1;
                const s = {};
                "globe" !== r.name && n.handleWrapJump(i);
                for (const i of t){
                    const t = i.getBucket(e1);
                    t && e1.fqid === t.layerIds[0] && (t.bucketInstanceId || (t.bucketInstanceId = ++this.maxBucketInstanceId), n.addBucket(i.tileID, t, this.crossTileIDs) && (o = !0), s[t.bucketInstanceId] = !0);
                }
                return n.removeStaleBuckets(s) && (o = !0), o;
            }
            pruneUnusedLayers(e1) {
                const t = {};
                e1.forEach((e1)=>{
                    t[e1] = !0;
                });
                for(const e1 in this.layerIndexes)t[e1] || delete this.layerIndexes[e1];
            }
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new SE, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
        }
        var zE = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w-0.0001;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", PE = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", DE = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;uniform sampler2D u_depth;uniform vec2 u_depth_size_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nhighp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}bool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;float depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5));return coord.z > depth+0.0005;}float occlusionFade(vec4 frag) {vec3 coord=frag.xyz/frag.w;vec3 df=vec3(5.0*u_depth_size_inv,0.0);vec2 uv=0.5*coord.xy+0.5;vec4 depth=vec4(\nunpack_depth(texture(u_depth,uv-df.xz)),unpack_depth(texture(u_depth,uv+df.xz)),unpack_depth(texture(u_depth,uv-df.zy)),unpack_depth(texture(u_depth,uv+df.zy))\n);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z-0.001)-depth),0.0,1.0));}vec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }bool isOccluded(vec4 frag) { return false; }float occlusionFade(vec4 frag) { return 1.0; }\n#endif", RE = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", LE = "highp vec3 hash(highp vec2 p) {highp vec3 p3=fract(p.xyx*vec3(443.8975,397.2973,491.1871));p3+=dot(p3,p3.yxz+19.19);return fract((p3.xxy+p3.yzz)*p3.zyx);}vec3 dither(vec3 color,highp vec2 seed) {vec3 rnd=hash(seed)+hash(seed+0.59374)-0.5;return color+rnd/255.0;}\n#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {\n#ifdef FOG_DITHERING\nvec2 dither_seed=gl_FragCoord.xy+u_fog_temporal_offset;return dither(color,dither_seed);\n#else\nreturn color;\n#endif\n}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", kE = "#ifdef RASTER_ARRAY\nuniform sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);vec4 _raTexLinearCoord(vec2 texCoord,vec2 texResolution,out vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return (texCoord.xxyy+vec2(1.5,0.5).xyxy)/texResolution.xxyy;}vec2 _raTexLinearMix(vec2 fxy,vec4 colorMix,float colorOffset,vec4 t00,vec4 t10,vec4 t01,vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(vec2 texCoord,vec2 texResolution,vec4 colorMix,float colorOffset) {vec2 fxy;vec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texture(u_image0,c.yz),texture(u_image0,c.xz),texture(u_image0,c.yw),texture(u_image0,c.xw)\n);}vec2 raTexture2D_image1_linear(vec2 texCoord,vec2 texResolution,vec4 colorMix,float colorOffset) {vec2 fxy;vec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texture(u_image1,c.yz),texture(u_image1,c.xz),texture(u_image1,c.yw),texture(u_image1,c.xw)\n);}vec2 raTexture2D_image0_nearest(vec2 texCoord,vec2 texResolution,vec4 colorMix,float colorOffset) {vec4 t=texture(u_image0,texCoord);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(vec2 texCoord,vec2 texResolution,vec4 colorMix,float colorOffset) {vec4 t=texture(u_image1,texCoord);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", OE = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif//RENDER_SHADOWS", BE = "#ifdef RENDER_SHADOWS\n#ifdef DEPTH_TEXTURE\nuniform highp sampler2D u_shadowmap_0;uniform highp sampler2D u_shadowmap_1;\n#else\nuniform sampler2D u_shadowmap_0;uniform sampler2D u_shadowmap_1;\n#endif\nuniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;highp float shadow_sample_1(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_1,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_1,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}highp float shadow_sample_0(highp vec2 uv,highp float compare) {highp float shadow_depth;\n#ifdef DEPTH_TEXTURE\nshadow_depth=texture(u_shadowmap_0,uv).r;\n#else\nshadow_depth=unpack_depth(texture(u_shadowmap_0,uv))*0.5+0.5;\n#endif\nreturn step(shadow_depth,compare);}float shadow_occlusion_1(highp vec4 pos,highp float bias) {highp vec2 uv=pos.xy;return shadow_sample_1(uv,pos.z-bias);}float shadow_occlusion_0(highp vec4 pos,highp float bias) {highp float compare0=pos.z-bias;\n#ifdef NATIVE\nhighp vec2 uv=pos.xy;highp vec4 samples=textureGather(u_shadowmap_0,uv,0);lowp vec4 stepSamples=step(samples,vec4(compare0));\n#else\nhighp vec2 uv00=pos.xy-vec2(0.5*u_shadow_texel_size);highp vec2 uv10=uv00+vec2(u_shadow_texel_size,0.0);highp vec2 uv01=uv00+vec2(0.0,u_shadow_texel_size);highp vec2 uv11=uv01+vec2(u_shadow_texel_size,0.0);lowp vec4 stepSamples=vec4(\nshadow_sample_0(uv01,compare0),shadow_sample_0(uv11,compare0),shadow_sample_0(uv10,compare0),shadow_sample_0(uv00,compare0)\n);\n#endif\nvec2 f=fract(pos.xy*u_shadow_map_resolution-vec2(0.5));lowp vec2 lerpx=mix(stepSamples.wx,stepSamples.zy,f.xx);return mix(lerpx.x,lerpx.y,f.y);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {\n#ifdef SHADOWS_SINGLE_CASCADE\nlight_view_pos0.xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);\n#else\nlight_view_pos0.xyz/=light_view_pos0.w;light_view_pos1.xyz/=light_view_pos1.w;vec4 uv=vec4(light_view_pos0.xy,light_view_pos1.xy);vec4 abs_bounds=abs(uv);if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {light_view_pos0.xyz=light_view_pos0.xyz*0.5+0.5;return shadow_occlusion_0(light_view_pos0,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}light_view_pos1.xyz=light_view_pos1.xyz*0.5+0.5;float occlusion1=shadow_occlusion_1(light_view_pos1,bias);return mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth));\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
        const FE = [];
        qE(zE, FE);
        const NE = {
            "_prelude_fog.vertex.glsl": RE,
            "_prelude_terrain.vertex.glsl": DE,
            "_prelude_shadow.vertex.glsl": OE,
            "_prelude_fog.fragment.glsl": LE,
            "_prelude_shadow.fragment.glsl": BE,
            "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif//LIGHTING_3D_MODE",
            "_prelude_raster_array.glsl": kE
        }, UE = {};
        ZE("", DE), ZE(LE, RE), ZE(BE, OE), ZE(kE, "");
        const VE = ZE("\nout vec4 glFragColor;highp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec2 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nvec4 applyCutout(vec4 color) {\n#ifdef INDICATOR_CUTOUT\nfloat holeMinOpacity=u_indicator_cutout_params.x;float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif", "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(vec2 posWithComposedSkirt)\n{float skirt=float(posWithComposedSkirt.x >=skirtOffset);vec2 pos=posWithComposedSkirt-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}"), jE = zE;
        var GE = {
            background: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;uniform float u_emissive_strength;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            backgroundPattern: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in vec2 v_pos;void main() {vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=texture(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            circle: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1,-1),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1,-1),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1,1),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1,1),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*circle_elevation(circle_center);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*circle_elevation(circle_center);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);float height=circle_elevation(circle_center);world_center=vec4(circle_center,height,1);\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'),
            clippingMask: ZE("void main() {glFragColor=vec4(1.0);}", "in vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: ZE('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(a_pos*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=a_pos_normal_3/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=a_pos_3+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            heatmapTexture: ZE("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=a_pos*0.5+0.5;}"),
            collisionBox: ZE("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin vec3 a_pos;in vec2 a_anchor_pos;in vec2 a_extrude;in vec2 a_placed;in vec2 a_shift;in float a_size_scale;in vec2 a_padding;in float a_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;out float v_placed;out float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_pos+elevationVector(a_anchor_pos)*(a_z_offset+elevation(a_anchor_pos)),1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(a_extrude*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}'),
            collisionCircle: ZE("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: ZE("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin vec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {float h=elevation(a_pos);v_uv=a_pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(a_pos_3+elevationVector(a_pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(a_pos*u_overlay_scale,h,1);\n#endif\n}'),
            fill: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillOutline: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec2 v_pos;uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nin vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;out vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillOutlinePattern: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_emissive_strength;in vec2 v_pos;in vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=texture(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos;out vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);v_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillPattern: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;in vec2 v_pos;uniform float u_emissive_strength;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec4 out_color=texture(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,a_pos);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            fillExtrusion: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth;\n#endif\nuniform lowp float u_opacity;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nuniform float u_emissive_strength;in float v_height;void main() {\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,v_depth);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,v_depth);color.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,u_emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef RENDER_CUTOFF\ncolor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\n#ifdef RENDER_CUTOFF\ninvariant gl_Position;\n#endif\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nuniform highp float u_vertical_scale;out vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 pos_nx=floor(a_pos_normal_ed*0.5);vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=0.0;float c_ele;vec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);pos=vec3(pos_nx.xy,h);\n#else\nh=t > 0.0 ? height : base;pos=vec3(pos_nx.xy,h);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);v_flat=vec4(linearProduct(color.rgb,vec3(calculate_NdotL(normal))),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            fillExtrusionDepth: ZE("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_vertical_scale;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\nout highp float v_depth;void main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 pos_nx=floor(a_pos_normal_ed.xyz*0.5);mediump vec3 top_up_ny=a_pos_normal_ed.xyz-2.0*pos_nx;base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;float ele=elevation(pos_nx.xy);float c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;float h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base);pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);v_depth=gl_Position.z/gl_Position.w;}'),
            fillExtrusionPattern: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\nin vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 imagecoord=mod(v_pos,1.0);vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);vec4 out_color=texture(u_image,pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in vec4 a_pos_normal_ed;in vec2 a_centroid_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_pos_3;in vec3 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\nout vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump vec4 pattern\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec4 pos_nx=floor(a_pos_normal_ed*0.5);mediump vec4 top_up_ny_start=a_pos_normal_ed-2.0*pos_nx;mediump vec3 top_up_ny=top_up_ny_start.xyz;float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=a_pos_normal_ed.w;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=a_centroid_pos;\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool flat_roof=centroid_pos.x !=0.0 && t > 0.0;ele=elevation(pos_nx.xy);c_ele=flat_roof ? centroid_pos.y==0.0 ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos) : ele;h=flat_roof ? max(c_ele+height,ele+base+2.0) : ele+(t > 0.0 ? height : base==0.0 ?-5.0 : base);p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(a_pos_normal_3/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=a_pos_3+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat hidden=float(centroid_pos.x==0.0 && centroid_pos.y==1.0);gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif \n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'),
            groundShadow: ZE('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;in float v_depth;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,v_depth));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0)).r);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in vec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);v_depth=gl_Position.w;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);v_fog_opacity=fog(v_fog_pos);\n#endif\n}'),
            fillExtrusionGroundEffect: ZE("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;HANDLE_WIREFRAME_DEBUG;\n#endif\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp vec4 a_pos_end;in highp float a_angular_offset_factor;in highp float a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec2 p=a_pos_end.xy;vec2 q=floor(a_pos_end.zw*0.5);vec2 start_bottom=a_pos_end.zw-q*2.0;float fl_ground_radius=flood_light_ground_radius;\n#ifdef FORCE_ABS_FL_GROUND_RADIUS\nfl_ground_radius=abs(flood_light_ground_radius);\n#endif\nfloat flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=a_angular_offset_factor/NORM*TANGENT_CUTOFF;float angular_offset=angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(1.0,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=a_hidden_by_landmark;\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            hillshadePrepare: ZE("precision highp float;uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\n}'),
            line: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform lowp float u_device_pixel_ratio;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).a;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/dash.z;alpha*=linearstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trimmed=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float start=v_uv[2];highp float end=v_uv[3];highp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=(start+(v_uv.x)*(end-start));if (trim_end > trim_start) {if (line_progress <=trim_end && line_progress >=trim_start) {out_color=vec4(0,0,0,0);trimmed=0.0;}}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\nfloat edgeBlur=(border_width+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2.t-edgeBlur),v_width2.s-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {    \nfloat Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color.rgb=mix(border_color.rgb*border_color.a*trimmed,out_color.rgb,smoothAlpha);}}\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nin highp vec4 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec4 v_uv;\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize lowp vec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nfloat a_uv_x=a_packed[0];float a_split_index=a_packed[1];highp float a_clip_start=a_packed[2];highp float a_clip_end=a_packed[3];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec4(a_uv_x,a_split_index*texel_height-half_texel_height,a_clip_start,a_clip_end);\n#else\nv_uv=vec4(a_uv_x,0.0,a_clip_start,a_clip_end);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nfloat scale=dash.z==0.0 ? 0.0 : u_tile_units_to_pixels/dash.z;float height=dash.y;v_tex=vec2(a_linesofar*scale/floorwidth,(-normal.y*height+dash.x+0.5)/u_texsize.y);\n#endif\nv_width2=vec2(outset,inset);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            linePattern: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_tile_units_to_pixels;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;in float v_width;\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl=pattern.xy;vec2 pattern_br=pattern.zw;vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;vec2 pattern_size=vec2(display_size.x/u_tile_units_to_pixels,display_size.y);float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x=mod(v_linesofar/pattern_size.x*aspect,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));vec4 color=texture(u_image,pos);\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_ground(color);\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;in float a_linesofar;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;out float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern\n#pragma mapbox: define lowp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist*u_pixels_to_tile_units,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude;\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#else\nv_gamma_scale=1.0;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            raster: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform vec4 u_tl_br;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#elif defined(PROJECTION_GLOBE_VIEW)\nin vec2 a_pos;\n#else\nin vec2 a_pos;in vec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;void main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos   ,1.0);uv=a_uv;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);vec2 globe_tl=vec2(u_tl_br.x,u_tl_br.y);vec2 globe_br=vec2(u_tl_br.z,u_tl_br.w);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=1.0-((mercatorY-globe_br.y)/(globe_tl.y-globe_br.y));float mercatorX=mercatorXfromLng(latLng[1]);float uvX=(mercatorX-globe_br.x)/(globe_tl.x-globe_br.x);vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);uv=vec2(uvX,uvY);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nfloat w=1.0+dot(a_texture_pos,u_perspective_transform);gl_Position=u_matrix*vec4(a_pos*w,u_raster_elevation,w);\n#ifdef FOG\nv_fog_pos=fog_position(a_pos);\n#endif\nuv=a_texture_pos/8192.0;\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'),
            symbolIcon: ZE('#include "_prelude_lighting.glsl"\nuniform sampler2D u_texture;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\nin float v_fade_opacity;in vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nuniform mediump float u_icon_saturation;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float emissive_strength\nlowp float alpha=opacity*v_fade_opacity;vec4 out_color;\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b)*alpha;\n#else\nout_color=texture(u_texture,v_tex_a)*alpha;\n#endif\n#ifdef SATURATION\nvec3 luma=vec3(dot(out_color.rgb,vec3(0.2126,0.7152,0.0722)));out_color.rgb=mix(luma,out_color.rgb,u_icon_saturation);\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin vec2 a_texb;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform vec3 u_up_vector;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float emissive_strength\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_min_font_scale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjected_point;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetProjected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\noffsetProjected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetProjected_point.xy/offsetProjected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change))*projection_transition_fade;float alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nv_tex_a=a_tex/u_texsize;\n#ifdef ICON_TRANSITION\nv_tex_b=a_texb/u_texsize;\n#endif\nv_fade_opacity=out_fade_opacity;}'),
            symbolSDF: ZE('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\nuniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;in float v_draw_halo;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);vec4 out_color=color*(alpha*opacity*fade_opacity);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_pixeloffset;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout float v_draw_halo;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(a_globe_anchor+displacement,1);\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);\n#endif\nvec2 a=projected_point.xy/projected_point.w;vec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nvec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;float alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,out_fade_opacity);}'),
            symbolTextAndIcon: ZE('#include "_prelude_lighting.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_halo;in float v_draw_halo;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);vec4 out_color=color*(alpha*opacity*fade_opacity);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\nin vec4 a_pos_offset;in vec4 a_tex_size;in vec4 a_projected_pos;in float a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin vec3 a_globe_anchor;in vec3 a_globe_normal;\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout float v_draw_halo;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_tex_size.xy;vec2 a_size=a_tex_size.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[3];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos=mix_globe_mercator(a_globe_anchor+h,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offset_projected_point=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projected_point.xy/projected_point.w;vec2 b=offset_projected_point.xy/offset_projected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz+h,mercator_pos,u_zoom_transition);projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*font_scale);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\nfloat occlusion_fade=occlusionFade(projected_point)*globe_occlusion_fade;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));float projection_transition_fade=1.0;\n#if defined(PROJECTED_POS_ON_VIEWPORT) && defined(PROJECTION_GLOBE_VIEW)\nprojection_transition_fade=1.0-step(EPSILON,u_zoom_transition);\n#endif\nfloat out_fade_opacity=interpolated_fade_opacity*projection_transition_fade;float alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);gl_Position=mix(u_coord_matrix*vec4(projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y,1.0),AWAY,hidden);\n#else\ngl_Position=mix(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+offset,z,1.0),AWAY,hidden);\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,out_fade_opacity,is_sdf);}'),
            terrainRaster: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;in float v_depth;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nvec3 unlit_base=image_color.rgb*(1.0-image_color.a);vec3 emissive_base=image_color.rgb*image_color.a;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,v_depth,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,v_depth);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor.rgb=mix(color.rgb,image_color.rgb,image_color.a);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in vec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);v_depth=gl_Position.w;\n#endif\n}'),
            terrainDepth: ZE("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in vec2 a_pos;out float v_depth;void main() {float elevation=elevation(a_pos);gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'),
            skybox: ZE('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color.rgb=dither(sky_color.rgb,gl_FragCoord.xy+u_temporal_offset);sky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', PE),
            skyboxGradient: ZE('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;color.rgb=dither(color.rgb,gl_FragCoord.xy+u_temporal_offset);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', PE),
            skyboxCapture: ZE("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeRaster: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nvec2 uv=gl_FragCoord.xy/u_viewport;highp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);vec3 dir=normalize(ray_dir);vec3 closest_point=dot(u_globe_pos,dir)*dir;float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nraster=apply_lighting_with_emission_ground(raster,raster.a);color=vec4(raster.rgb*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\ncolor=apply_lighting_with_emission_ground(color,color.a);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin vec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'),
            globeAtmosphere: ZE('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;\n#ifndef NATIVE\nc=dither(c,gl_FragCoord.xy+u_temporal_offset);\n#endif\nglFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"),
            model: ZE('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;uniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform sampler2D u_depthTexture;uniform vec2 u_inv_depth_size;bool isOccluded() {vec2 coord=gl_FragCoord.xy*u_inv_depth_size;highp float depth=unpack_depth(texture(u_depthTexture,coord));return v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\ntexColor.rgb=sRGBToLinear(texColor.rgb);if(u_baseTextureIsAlpha) {if (texColor.w < 0.5) {discard;}albedo*=mix(vec4(texColor.rgb,texColor.a),vec4(texColor.a),float(u_baseTextureIsAlpha));} else {albedo*=texColor;}\n#endif\nreturn vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;highp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));n=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 diffuse=getDiffuseShadedColor(getBaseColor().rgb,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(diffuse,1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nao=(texture(u_occlusionTexture,uv_2f).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);color=mix(color,v_color_mix.rgb,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp vec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp vec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=u_matrix*pos;pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(pbr.xy);vec2 e_r_m=unpack_float(pbr.z);vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(pbr.w)/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shadow_pos=local_pos;\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normalize(normal_3f));shadow_pos+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shadow_pos,1);v_pos_light_view_1=u_light_matrix_1*vec4(shadow_pos,1);v_depth_shadows=gl_Position.w;\n#endif\n}'),
            modelDepth: ZE("in highp float v_depth;void main() {\n#ifndef DEPTH_TEXTURE\nglFragColor=pack_depth(v_depth);\n#endif\n}", "in vec3 a_pos_3f;uniform mat4 u_matrix;out highp float v_depth;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=u_matrix*pos;\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\nv_depth=gl_Position.z/gl_Position.w;}"),
            stars: ZE("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_fade_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_fade_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}")
        };
        function qE(e1, t) {
            const i = e1.replace(/\s*\/\/[^\n]*\n/g, "\n").split("\n");
            for (let e1 of i)if (e1 = e1.trim(), "#" === e1[0] && e1.includes("if") && !e1.includes("endif")) {
                e1 = e1.replace("#", "").replace(/ifdef|ifndef|elif|if/g, "").replace(/!|defined|\(|\)|\|\||&&/g, "").replace(/\s+/g, " ").trim();
                const i = e1.split(" ");
                for (const e1 of i)t.includes(e1) || t.push(e1);
            }
        }
        function ZE(e1, t) {
            const i = /#include\s+"([^"]+)"/g, r = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g;
            let n = t.match(/(attribute(\S*)|(^\s*|;)in) (highp |mediump |lowp )?([\w]+) ([\w]+)/gm);
            n && (n = n.map((e1)=>{
                const t = e1.split(" ");
                return t[t.length - 1];
            }), n = [
                ...new Set(n)
            ]);
            const o = {}, s = [], a = [];
            e1 = e1.replace(i, (e1, t)=>(a.push(t), "")), t = t.replace(i, (e1, t)=>(s.push(t), ""));
            let l = [
                ...FE
            ];
            qE(e1, l), qE(t, l);
            for (const e1 of [
                ...s,
                ...a
            ])NE[e1] || console.error(`Undefined include: ${e1}`), UE[e1] || (UE[e1] = [], qE(NE[e1], UE[e1])), l = [
                ...l,
                ...UE[e1]
            ];
            return {
                fragmentSource: e1 = e1.replace(r, (e1, t, i, r, n)=>(o[n] = !0, "define" === t ? `\n#ifndef HAS_UNIFORM_u_${n}\nin ${i} ${r} ${n};\n#else\nuniform ${i} ${r} u_${n};\n#endif\n` : "initialize" === t ? `\n#ifdef HAS_UNIFORM_u_${n}\n    ${i} ${r} ${n} = u_${n};\n#endif\n` : "define-attribute" === t ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    in ${i} ${r} ${n};\n#endif\n` : "initialize-attribute" === t ? "" : void 0)),
                vertexSource: t = t.replace(r, (e1, t, i, r, n)=>{
                    const s = "float" === r ? "vec2" : r, a = n.match(/color/) ? "color" : s;
                    return "define-attribute-vertex-shader-only" === t ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\nin ${i} ${r} a_${n};\n#endif\n` : o[n] ? "define" === t ? `\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nin ${i} ${s} a_${n};\nout ${i} ${r} ${n};\n#else\nuniform ${i} ${r} u_${n};\n#endif\n` : "initialize" === t ? "vec4" === a ? `\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = a_${n};\n#else\n    ${i} ${r} ${n} = u_${n};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = unpack_mix_${a}(a_${n}, u_${n}_t);\n#else\n    ${i} ${r} ${n} = u_${n};\n#endif\n` : "define-attribute" === t ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    in ${i} ${r} a_${n};\n    out ${i} ${r} ${n};\n#endif\n` : "initialize-attribute" === t ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    ${n} = a_${n};\n#endif\n` : void 0 : "define" === t ? `\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\nin ${i} ${s} a_${n};\n#else\nuniform ${i} ${r} u_${n};\n#endif\n` : "define-instanced" === t ? "mat4" === a ? `\n#ifdef INSTANCED_ARRAYS\nin vec4 a_${n}0;\nin vec4 a_${n}1;\nin vec4 a_${n}2;\nin vec4 a_${n}3;\n#else\nuniform ${i} ${r} u_${n};\n#endif\n` : `\n#ifdef INSTANCED_ARRAYS\nin ${i} ${s} a_${n};\n#else\nuniform ${i} ${r} u_${n};\n#endif\n` : "initialize-attribute-custom" === t ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    ${i} ${r} ${n} = a_${n};\n#endif\n` : "vec4" === a ? `\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${r} ${n} = a_${n};\n#else\n    ${i} ${r} ${n} = u_${n};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${n}\n    ${i} ${r} ${n} = unpack_mix_${a}(a_${n}, u_${n}_t);\n#else\n    ${i} ${r} ${n} = u_${n};\n#endif\n`;
                }),
                staticAttributes: n,
                usedDefines: l,
                vertexIncludes: s,
                fragmentIncludes: a
            };
        }
        class $E {
            bind(e1, t, i, r, n, o, s, a) {
                this.context = e1;
                let l = this.boundPaintVertexBuffers.length !== r.length;
                for(let e1 = 0; !l && e1 < r.length; e1++)this.boundPaintVertexBuffers[e1] !== r[e1] && (l = !0);
                let c = this.boundDynamicVertexBuffers.length !== s.length;
                for(let e1 = 0; !c && e1 < s.length; e1++)this.boundDynamicVertexBuffers[e1] !== s[e1] && (c = !0);
                if (!this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== i || l || c || this.boundIndexBuffer !== n || this.boundVertexOffset !== o) this.freshBind(t, i, r, n, o, s, a);
                else {
                    e1.bindVertexArrayOES.set(this.vao);
                    for (const i of s)i && (i.bind(), a && i.instanceCount && i.setVertexAttribDivisor(e1.gl, t, a));
                    n && n.dynamicDraw && n.bind();
                }
            }
            freshBind(e1, t, i, r, n, o, s) {
                const a = e1.numAttributes, l = this.context, c = l.gl;
                this.vao && this.destroy(), this.vao = l.gl.createVertexArray(), l.bindVertexArrayOES.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = r, this.boundVertexOffset = n, this.boundDynamicVertexBuffers = o, t.enableAttributes(c, e1), t.bind(), t.setVertexAttribPointers(c, e1, n);
                for (const t of i)t.enableAttributes(c, e1), t.bind(), t.setVertexAttribPointers(c, e1, n);
                for (const t of o)t && (t.enableAttributes(c, e1), t.bind(), t.setVertexAttribPointers(c, e1, n), s && t.instanceCount && t.setVertexAttribDivisor(c, e1, s));
                r && r.bind(), l.currentNumAttributes = a;
            }
            destroy() {
                this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
            }
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
        }
        function WE(e1, t) {
            const i = Math.pow(2, t.canonical.z), r = t.canonical.y;
            return [
                new lp(0, r / i).toLngLat().lat,
                new lp(0, (r + 1) / i).toLngLat().lat
            ];
        }
        function HE(e1, t, i, r, n, o, s) {
            const a = e1.context, l = a.gl, c = i.hillshadeFBO;
            if (!c) return;
            e1.prepareDrawTile();
            const h = e1.isTileAffectedByFog(t), u = e1.getOrCreateProgram("hillshade", {
                overrideFog: h
            });
            a.activeTexture.set(l.TEXTURE0), l.bindTexture(l.TEXTURE_2D, c.colorAttachment.get());
            const d = ((e1, t, i, r)=>{
                const n = i.paint.get("hillshade-shadow-color"), o = i.paint.get("hillshade-highlight-color"), s = i.paint.get("hillshade-accent-color"), a = i.paint.get("hillshade-emissive-strength");
                let l = w(i.paint.get("hillshade-illumination-direction"));
                if ("viewport" === i.paint.get("hillshade-illumination-anchor")) l -= e1.transform.angle;
                else if (e1.style && e1.style.enable3dLights() && e1.style.directionalLight) {
                    const t = e1.style.directionalLight.properties.get("direction");
                    l = w(J(t.x, t.y, t.z)[1]);
                }
                const c = !e1.options.moving;
                return {
                    u_matrix: r || e1.transform.calculateProjMatrix(t.tileID.toUnwrapped(), c),
                    u_image: 0,
                    u_latrange: WE(0, t.tileID),
                    u_light: [
                        i.paint.get("hillshade-exaggeration"),
                        l
                    ],
                    u_shadow: n,
                    u_highlight: o,
                    u_emissive_strength: a,
                    u_accent: s
                };
            })(e1, i, r, e1.terrain ? t.projMatrix : null);
            e1.uploadCommonUniforms(a, u, t.toUnwrapped());
            const { tileBoundsBuffer: p, tileBoundsIndexBuffer: f, tileBoundsSegments: m } = e1.getTileBoundsBuffers(i);
            u.draw(e1, l.TRIANGLES, n, o, s, Dx.disabled, d, r.id, p, f, m);
        }
        function XE(e1, t, i) {
            if (!t.needsDEMTextureUpload) return;
            const r = e1.context, n = r.gl;
            r.pixelStoreUnpackPremultiplyAlpha.set(!1), t.demTexture = t.demTexture || e1.getTileTexture(i.stride);
            const o = i.getPixels();
            t.demTexture ? t.demTexture.update(o, {
                premultiply: !1
            }) : t.demTexture = new My(r, o, n.R32F, {
                premultiply: !1
            }), t.needsDEMTextureUpload = !1;
        }
        function YE(e1, t, i) {
            const r = e1.context, n = r.gl;
            if (!t.dem) return;
            const o = t.dem;
            if (r.activeTexture.set(n.TEXTURE1), XE(e1, t, o), !t.demTexture) return;
            t.demTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE);
            const s = o.dim;
            r.activeTexture.set(n.TEXTURE0);
            let a = t.hillshadeFBO;
            if (!a) {
                const e1 = new My(r, {
                    width: s,
                    height: s,
                    data: null
                }, n.RGBA);
                e1.bind(n.LINEAR, n.CLAMP_TO_EDGE), a = t.hillshadeFBO = r.createFramebuffer(s, s, !0, "renderbuffer"), a.colorAttachment.set(e1.texture);
            }
            r.bindFramebuffer.set(a.framebuffer), r.viewport.set([
                0,
                0,
                s,
                s
            ]);
            const { tileBoundsBuffer: l, tileBoundsIndexBuffer: c, tileBoundsSegments: h } = e1.getMercatorTileBoundsBuffers(), u = [];
            e1.linearFloatFilteringSupported() && u.push("TERRAIN_DEM_FLOAT_FORMAT"), e1.getOrCreateProgram("hillshadePrepare", {
                defines: u
            }).draw(e1, n.TRIANGLES, Mx.disabled, Sx.disabled, Cx.unblended, Dx.disabled, ((e1, t)=>{
                const i = t.stride, r = Au.create();
                return Au.ortho(r, 0, cr, -cr, 0, 0, 1), Au.translate(r, r, [
                    0,
                    -cr,
                    0
                ]), {
                    u_matrix: r,
                    u_image: 1,
                    u_dimension: [
                        i,
                        i
                    ],
                    u_zoom: e1.overscaledZ
                };
            })(t.tileID, o), i.id, l, c, h), t.needsHillshadePrepare = !1;
        }
        const KE = (e1)=>({
                u_matrix: new jl(e1),
                u_image0: new kl(e1),
                u_skirt_height: new Ol(e1),
                u_ground_shadow_factor: new Fl(e1)
            }), JE = (e1, t, i)=>({
                u_matrix: e1,
                u_image0: 0,
                u_skirt_height: t,
                u_ground_shadow_factor: i
            }), QE = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f)=>({
                u_proj_matrix: Float32Array.from(e1),
                u_globe_matrix: t,
                u_normalize_matrix: Float32Array.from(r),
                u_merc_matrix: i,
                u_zoom_transition: n,
                u_merc_center: o,
                u_image0: 0,
                u_frustum_tl: s,
                u_frustum_tr: a,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: u,
                u_viewport: d,
                u_grid_matrix: f ? Float32Array.from(f) : new Float32Array(9),
                u_skirt_height: p
            }), eM = (e1, t)=>{
            if (t > 0 && e1.terrain && H("Cutoff is currently disabled on terrain"), t <= 0 || e1.terrain) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        0
                    ]
                }
            };
            const i = e1.transform, r = Math.max(Math.abs(i._zoom - (e1.minCutoffZoom - 1)), 1), n = i.isLODDisabled(!1) ? P(60, 45, i.pitch) : P(30, 15, i.pitch), o = i._farZ - i._nearZ, s = t * i.height, a = ((1 - (l = n)) * (.75 * i.cameraToCenterDistance) + l * (i._farZ + s)) * r;
            var l;
            return {
                shouldRenderCutoff: n < 1,
                uniformValues: {
                    u_cutoff_params: [
                        i._nearZ,
                        i._farZ,
                        (a - i._nearZ) / o,
                        (a - s - i._nearZ) / o
                    ]
                }
            };
        };
        function tM(e1, t) {
            return null != e1 && null != t && !(!e1.hasData() || !t.hasData()) && null != e1.demTexture && null != t.demTexture && e1.tileID.key !== t.tileID.key;
        }
        const iM = new class {
            newMorphing(e1, t, i, r, n) {
                if (e1 in this.operations) {
                    const t = this.operations[e1];
                    t.to.tileID.key !== i.tileID.key && (t.queued = i);
                } else this.operations[e1] = {
                    startTime: r,
                    phase: 0,
                    duration: n,
                    from: t,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e1) {
                if (!(e1 in this.operations)) return null;
                const t = this.operations[e1];
                return {
                    from: t.from,
                    to: t.to,
                    phase: t.phase
                };
            }
            update(e1) {
                for(const t in this.operations){
                    const i = this.operations[t];
                    for(i.phase = (e1 - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e1)) {
                        delete this.operations[t];
                        break;
                    }
                }
            }
            _nextOp(e1, t) {
                return !!e1.queued && (e1.from = e1.to, e1.to = e1.queued, e1.queued = null, e1.phase = 0, e1.startTime = t, !0);
            }
            _validOp(e1) {
                return e1.from.hasData() && e1.to.hasData();
            }
            constructor(){
                this.operations = {};
            }
        }, rM = {
            0: null,
            1: "TERRAIN_VERTEX_MORPHING"
        };
        function nM(e1, t, i) {
            if (0 === t) return 0;
            const r = t < 1 && 514 === i ? .25 / t : 1;
            return 6 * Math.pow(1.5, 22 - e1) * Math.max(t, 1) * r;
        }
        function oM(e1, t) {
            const i = 1 << e1.z;
            return !t && (0 === e1.x || e1.x === i - 1) || 0 === e1.y || e1.y === i - 1;
        }
        const sM = (e1)=>({
                u_matrix: e1
            });
        function aM(e1, t, i, r, n) {
            if (n > 0) {
                const o = dt.now(), s = (o - e1.timeAdded) / n, a = t ? (o - t.timeAdded) / n : -1, l = i.getSource(), c = r.coveringZoomLevel({
                    tileSize: l.tileSize,
                    roundZoom: l.roundZoom
                }), h = !t || Math.abs(t.tileID.overscaledZ - c) > Math.abs(e1.tileID.overscaledZ - c), u = h && e1.refreshedUponExpiration ? 1 : z(h ? s : 1 - a, 0, 1);
                return e1.refreshedUponExpiration && s >= 1 && (e1.refreshedUponExpiration = !1), t ? {
                    opacity: 1,
                    mix: 1 - u
                } : {
                    opacity: u,
                    mix: 0
                };
            }
            return {
                opacity: 1,
                mix: 0
            };
        }
        class lM extends Lx {
            _loadTile(e1, t) {
                e1.state = "loaded", t(null);
            }
            constructor(e1){
                const t = {
                    type: "raster-dem",
                    maxzoom: e1.transform.maxZoom
                }, i = new Ew(Ww(), null), r = ST("mock-dem", t, i, e1.style);
                super("mock-dem", r, !1), r.setEventedParent(this), this._sourceLoaded = !0;
            }
        }
        class cM extends Lx {
            update(e1, t, i) {
                if (e1.freezeTileCoverage) return;
                this.transform = e1;
                const r = e1.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }).reduce((t, i)=>{
                    if (t[i.key] = "", !this._tiles[i.key]) {
                        const t = new Oy(i, this._source.tileSize * i.overscaleFactor(), e1.tileZoom);
                        t.state = "loaded", this._tiles[i.key] = t;
                    }
                    return t;
                }, {});
                for(const e1 in this._tiles)e1 in r || (this.freeFBO(e1), this._tiles[e1].unloadVectorData(), delete this._tiles[e1]);
            }
            freeFBO(e1) {
                const t = this.proxyCachedFBO[e1];
                if (void 0 !== t) {
                    const i = Object.values(t);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e1];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e1)=>e1.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            constructor(e1){
                const t = ST("proxy", {
                    type: "geojson",
                    maxzoom: e1.transform.maxZoom
                }, new Ew(Ww(), null), e1.style);
                super("proxy", t, !1), t.setEventedParent(this), this.map = this.getSource().map = e1, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class hM extends qu {
            constructor(e1, t, i){
                super(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y), this.proxyTileKey = t, this.projMatrix = i;
            }
        }
        class uM extends Km {
            set style(e1) {
                e1.on("data", this._onStyleDataEvent.bind(this)), this._style = e1, this._style.map.on("moveend", ()=>{
                    this._clearLineLayersFromRenderCache();
                });
            }
            update(e1, t, i) {
                if (e1 && e1.terrain) {
                    this._style !== e1 && (this.style = e1, this._evaluationZoom = void 0);
                    const r = e1.terrain.properties, n = 0 === e1.terrain.drapeRenderMode, o = e1.terrain.isZoomDependent();
                    this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = dt.now();
                    const s = e1.terrain && e1.terrain.scope, a = r.get("source"), l = n ? this._mockSourceCache : e1.getSourceCache(a, s);
                    if (!l) return void H(`Couldn't find terrain source "${a}".`);
                    if (this.sourceCache = l, this._exaggeration = o ? this.calculateExaggeration(t) : r.get("exaggeration"), !t.projection.requiresDraping && o && 0 === this._exaggeration) return void this._disable();
                    this.enabled = !0;
                    const c = ()=>{
                        this.sourceCache.used && H(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const e1 = this.getScaledDemTileSize();
                        this.sourceCache.update(t, e1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, c(), this._initializing = !0), c(), t.updateElevation(!0, i), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(t), this._emptyDEMTextureDirty = !0, this._previousZoom = t.zoom;
                } else this._disable();
            }
            calculateExaggeration(e1) {
                const t = this._previousCameraAltitude, i = e1.getFreeCameraOptions().position.z / e1.pixelsPerMeter * e1.worldSize;
                this._previousCameraAltitude = i;
                const r = null != t ? i - t : Number.MAX_VALUE;
                if (Math.abs(r) < 2) return this._exaggeration;
                const n = e1.zoom, o = this._style.terrain;
                if (!this._previousUpdateTimestamp) return o.getExaggeration(n);
                let s = n - this._previousZoom;
                const a = this._previousUpdateTimestamp;
                let l = n;
                null != this._evaluationZoom && (l = this._evaluationZoom, Math.abs(n - l) > .5 && (s = .5 * (n - l + s)), s * r < 0 && (l += s)), this._evaluationZoom = l;
                const c = o.getExaggeration(l), h = c === o.getExaggeration(Math.max(0, l - .1));
                if (h && Math.abs(c - this._exaggeration) < .01) return c;
                let u = Math.min(.1, .00375 * (this._updateTimestamp - a));
                return (h || c < .1 || Math.abs(s) < 1e-4) && (u = Math.min(.2, 4 * u)), Kr(this._exaggeration, c, u);
            }
            resetTileLookupCache(e1) {
                this._findCoveringTileCache[e1] = {};
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _onStyleDataEvent(e1) {
                e1.coord && "source" === e1.dataType ? this._clearRenderCacheForTile(e1.sourceCacheId, e1.coord) : "style" === e1.dataType && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e1 in this._style._mergedSourceCaches)this._style._mergedSourceCaches[e1].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this._emptyDepthBufferTexture && this._emptyDepthBufferTexture.destroy(), this.pool.forEach((e1)=>e1.fb.destroy()), this.pool = [], this._depthFBO && (this._depthFBO.destroy(), this._depthFBO = void 0, this._depthTexture = void 0), this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
                return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
                return this._exaggeration;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e1 = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e1,
                    e1
                ];
            }
            set useVertexMorphing(e1) {
                this._useVertexMorphing = e1;
            }
            updateTileBinding(e1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const t = this.proxySourceCache, i = this.painter.transform;
                this._initializing && (this._initializing = 0 === i._centerAltitude && -1 === this.getAtPointOrZero(lp.fromLngLat(i.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const r = this.proxyCoords = t.getIds().map((e1)=>{
                    const r = t.getTileByID(e1).tileID;
                    return r.projMatrix = i.calculateProjMatrix(r.toUnwrapped()), r;
                });
                !function(e1, t) {
                    const i = t.transform.pointCoordinate(t.transform.getCameraPoint()), r = new y(i.x, i.y);
                    e1.sort((e1, t)=>{
                        if (t.overscaledZ - e1.overscaledZ) return t.overscaledZ - e1.overscaledZ;
                        const i = new y(e1.canonical.x + (1 << e1.canonical.z) * e1.wrap, e1.canonical.y), n = new y(t.canonical.x + (1 << t.canonical.z) * t.wrap, t.canonical.y), o = r.mult(1 << e1.canonical.z);
                        return o.x -= .5, o.y -= .5, o.distSqr(i) - o.distSqr(n);
                    });
                }(r, this.painter);
                const n = this.proxyToSource || {};
                this.proxyToSource = {}, r.forEach((e1)=>{
                    this.proxyToSource[e1.key] = {};
                }), this.terrainTileForTile = {};
                const o = this._style._mergedSourceCaches;
                for(const t in o){
                    const i = o[t];
                    if (!i.used) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, e1[t], n), i.usedForTerrain) continue;
                    const r = e1[t];
                    i.getSource().reparseOverscaled && this._assignTerrainTiles(r);
                }
                this.proxiedCoords[t.id] = r.map((e1)=>new hM(e1, e1.key, this.orthoMatrix)), this._assignTerrainTiles(r), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(n), this.renderingToTexture = !1;
                const s = {};
                this._visibleDemTiles = [];
                for (const e1 of this.proxyCoords){
                    const t = this.terrainTileForTile[e1.key];
                    if (!t) continue;
                    const i = t.tileID.key;
                    i in s || (this._visibleDemTiles.push(t), s[i] = i);
                }
            }
            _assignTerrainTiles(e1) {
                this._initializing || e1.forEach((e1)=>{
                    if (this.terrainTileForTile[e1.key]) return;
                    const t = this._findTileCoveringTileID(e1, this.sourceCache);
                    t && (this.terrainTileForTile[e1.key] = t);
                });
            }
            _prepareDEMTextures() {
                const e1 = this.painter.context, t = e1.gl;
                for(const i in this.terrainTileForTile){
                    const r = this.terrainTileForTile[i], n = r.dem;
                    !n || r.demTexture && !r.needsDEMTextureUpload || (e1.activeTexture.set(t.TEXTURE1), XE(this.painter, r, n));
                }
            }
            _prepareDemTileUniforms(e1, t, i, r) {
                if (!t || null == t.demTexture) return !1;
                const n = e1.tileID.canonical, o = Math.pow(2, t.tileID.canonical.z - n.z), s = r || "";
                return i[`u_dem_tl${s}`] = [
                    n.x * o % 1,
                    n.y * o % 1
                ], i[`u_dem_scale${s}`] = o, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            get emptyDepthBufferTexture() {
                const e1 = this.painter.context, t = e1.gl;
                if (!this._emptyDepthBufferTexture) {
                    const i = new ef({
                        width: 1,
                        height: 1
                    }, Uint8Array.of(255, 255, 255, 255));
                    this._emptyDepthBufferTexture = new My(e1, i, t.RGBA, {
                        premultiply: !1
                    });
                }
                return this._emptyDepthBufferTexture;
            }
            _getLoadedAreaMinimum() {
                let e1 = 0;
                const t = this._visibleDemTiles.reduce((t, i)=>{
                    if (!i.dem) return t;
                    const r = i.dem.tree.minimums[0];
                    return r > 0 && e1++, t + r;
                }, 0);
                return e1 ? t / e1 : 0;
            }
            _updateEmptyDEMTexture() {
                const e1 = this.painter.context, t = e1.gl;
                e1.activeTexture.set(t.TEXTURE2);
                const i = this._getLoadedAreaMinimum(), [r, n] = (()=>{
                    const e1 = new tf({
                        width: 1,
                        height: 1
                    }, new Float32Array([
                        i
                    ]));
                    return [
                        t.R32F,
                        e1
                    ];
                })();
                this._emptyDEMTextureDirty = !1;
                let o = this._emptyDEMTexture;
                return o ? o.update(n, {
                    premultiply: !1
                }) : o = this._emptyDEMTexture = new My(e1, n, r, {
                    premultiply: !1
                }), o;
            }
            setupElevationDraw(e1, t, i) {
                const r = this.painter.context, n = r.gl, o = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_exaggeration: 0
                };
                o.u_exaggeration = this.exaggeration();
                let s = null, a = null, l = 1;
                if (i && i.morphing && this._useVertexMorphing) {
                    const t = i.morphing.srcDemTile, r = i.morphing.dstDemTile;
                    l = i.morphing.phase, t && r && (this._prepareDemTileUniforms(e1, t, o, "_prev") && (a = t), this._prepareDemTileUniforms(e1, r, o) && (s = r));
                }
                const c = (e1)=>e1 && e1.demTexture && this.painter.linearFloatFilteringSupported() ? n.LINEAR : n.NEAREST, h = (e1)=>{
                    o.u_dem_size = 1 === e1.size[0] ? 1 : e1.size[0] - 2;
                };
                if (a && s) r.activeTexture.set(n.TEXTURE2), s.demTexture.bind(c(s), n.CLAMP_TO_EDGE), r.activeTexture.set(n.TEXTURE4), a.demTexture.bind(c(a), n.CLAMP_TO_EDGE), s.demTexture && h(s.demTexture), o.u_dem_lerp = l;
                else {
                    s = this.terrainTileForTile[e1.tileID.key], r.activeTexture.set(n.TEXTURE2);
                    const t = this._prepareDemTileUniforms(e1, s, o) ? s.demTexture : this.emptyDEMTexture;
                    t.bind(c(s), n.CLAMP_TO_EDGE), h(t);
                }
                if (r.activeTexture.set(n.TEXTURE3), i && i.useDepthForOcclusion ? (this._depthTexture && this._depthTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE), this._depthFBO && (o.u_depth_size_inv = [
                    1 / this._depthFBO.width,
                    1 / this._depthFBO.height
                ])) : (this.emptyDepthBufferTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE), o.u_depth_size_inv = [
                    1,
                    1
                ]), i && i.useMeterToDem && s) {
                    const e1 = (1 << s.tileID.canonical.z) * Qd(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    o.u_meter_to_dem = e1;
                }
                if (i && i.labelPlaneMatrixInv && (o.u_label_plane_matrix_inv = i.labelPlaneMatrixInv), t.setTerrainUniformValues(r, o), "globe" === this.painter.transform.projection.name) {
                    const n = this.globeUniformValues(this.painter.transform, e1.tileID.canonical, i && i.useDenormalizedUpVectorScale);
                    t.setGlobeUniformValues(r, n);
                }
            }
            globeUniformValues(e1, t, i) {
                const r = e1.projection;
                return {
                    u_tile_tl_up: r.upVector(t, 0, 0),
                    u_tile_tr_up: r.upVector(t, cr, 0),
                    u_tile_br_up: r.upVector(t, cr, cr),
                    u_tile_bl_up: r.upVector(t, 0, cr),
                    u_tile_up_scale: i ? hd(1) : r.upVectorScale(t, e1.center.lat, e1.worldSize).metersToTile
                };
            }
            renderToBackBuffer(e1) {
                const t = this.painter, i = this.painter.context;
                0 !== e1.length && (i.bindFramebuffer.set(null), i.viewport.set([
                    0,
                    0,
                    t.width,
                    t.height
                ]), t.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(e1, t, i, r, n) {
                    if ("globe" === e1.transform.projection.name) !function(e1, t, i, r, n) {
                        const o = e1.context, s = o.gl;
                        let a, l;
                        const c = e1.transform, h = Ld(e1, o, c), u = (t, i)=>{
                            if (l === i) return;
                            const r = [
                                rM[i],
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            h && r.push("CUSTOM_ANTIALIASING");
                            const n = e1.isTileAffectedByFog(t);
                            a = e1.getOrCreateProgram("globeRaster", {
                                defines: r,
                                overrideFog: n
                            }), l = i;
                        }, d = e1.colorModeForRenderPass(), p = new Mx(s.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D);
                        iM.update(n);
                        const f = Pd(c), m = [
                            Kd(c.center.lng),
                            Jd(c.center.lat)
                        ], _ = e1.globeSharedBuffers, g = [
                            c.width * dt.devicePixelRatio,
                            c.height * dt.devicePixelRatio
                        ], y = Float32Array.from(c.globeMatrix), x = {
                            useDenormalizedUpVectorScale: !0
                        };
                        {
                            const c = e1.transform, h = nM(c.zoom, t.exaggeration(), t.sourceCache._source.tileSize);
                            l = -1;
                            const v = s.TRIANGLES;
                            for (const l of r){
                                const r = i.getTile(l), b = Sx.disabled, w = t.prevTerrainTileForTile[l.key], T = t.terrainTileForTile[l.key];
                                tM(w, T) && iM.newMorphing(l.key, w, T, n, 250), o.activeTexture.set(s.TEXTURE0), r.texture && r.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                                const E = iM.getMorphValuesForProxy(l.key), A = E ? 1 : 0;
                                E && Lt(x, {
                                    morphing: {
                                        srcDemTile: E.from,
                                        dstDemTile: E.to,
                                        phase: M(E.phase)
                                    }
                                });
                                const S = xd(l.canonical), I = Od(S.getCenter().lat), C = kd(l.canonical, S, I, c.worldSize / c._pixelsPerMercatorPixel), z = Ad(fd(l.canonical)), P = QE(c.expandedFarZProjMatrix, y, f, z, Dd(c.zoom), m, c.frustumCorners.TL, c.frustumCorners.TR, c.frustumCorners.BR, c.frustumCorners.BL, c.globeCenterInViewSpace, c.globeRadius, g, h, C);
                                if (u(l, A), a && (t.setupElevationDraw(r, a, x), e1.uploadCommonUniforms(o, a, l.toUnwrapped()), _)) {
                                    const [t, i, r] = _.getGridBuffers(I, 0 !== h);
                                    a.draw(e1, v, p, b, d, Dx.backCCW, P, "globe_raster", t, i, r);
                                }
                            }
                        }
                        if (_ && (e1.renderDefaultNorthPole || e1.renderDefaultSouthPole)) {
                            const n = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            h && n.push("CUSTOM_ANTIALIASING"), a = e1.getOrCreateProgram("globeRaster", {
                                defines: n
                            });
                            for (const n of r){
                                const { x: r, y: l, z: h } = n.canonical, u = 0 === l, f = l === (1 << h) - 1, [y, v, b, w] = _.getPoleBuffers(h, !1);
                                if (w && (u || f)) {
                                    const l = i.getTile(n);
                                    o.activeTexture.set(s.TEXTURE0), l.texture && l.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                                    let _ = Rd(h, r, c);
                                    const T = Ad(fd(n.canonical)), E = (t, i)=>t.draw(e1, s.TRIANGLES, p, Sx.disabled, d, Dx.disabled, QE(c.expandedFarZProjMatrix, _, _, T, 0, m, c.frustumCorners.TL, c.frustumCorners.TR, c.frustumCorners.BR, c.frustumCorners.BL, c.globeCenterInViewSpace, c.globeRadius, g, 0), "globe_pole_raster", i, b, w);
                                    t.setupElevationDraw(l, a, x), e1.uploadCommonUniforms(o, a, n.toUnwrapped()), u && e1.renderDefaultNorthPole && E(a, y), f && e1.renderDefaultSouthPole && (_ = Au.scale(Au.create(), _, [
                                        1,
                                        -1,
                                        1
                                    ]), E(a, v));
                                }
                            }
                        }
                    }(e1, t, i, r, n);
                    else {
                        const o = e1.context, s = o.gl;
                        let a, l;
                        const c = e1.shadowRenderer, h = eM(e1, e1.longestCutoffRange), u = (t)=>{
                            if (l === t) return;
                            const i = [];
                            i.push(rM[t]), h.shouldRenderCutoff && i.push("RENDER_CUTOFF"), a = e1.getOrCreateProgram("terrainRaster", {
                                defines: i
                            }), l = t;
                        }, d = e1.colorModeForRenderPass(), p = new Mx(s.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D);
                        iM.update(n);
                        const f = e1.transform, m = nM(f.zoom, t.exaggeration(), t.sourceCache._source.tileSize);
                        let _ = [
                            0,
                            0,
                            0
                        ];
                        if (c) {
                            const t = e1.style.directionalLight, i = e1.style.ambientLight;
                            t && i && (_ = WA(t, i));
                        }
                        {
                            l = -1;
                            const g = s.TRIANGLES, [y, x] = [
                                t.gridIndexBuffer,
                                t.gridSegments
                            ];
                            for (const l of r){
                                const r = i.getTile(l), v = Sx.disabled, b = t.prevTerrainTileForTile[l.key], w = t.terrainTileForTile[l.key];
                                tM(b, w) && iM.newMorphing(l.key, b, w, n, 250), o.activeTexture.set(s.TEXTURE0), r.texture && r.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                                const T = iM.getMorphValuesForProxy(l.key), E = T ? 1 : 0;
                                let A;
                                T && (A = {
                                    morphing: {
                                        srcDemTile: T.from,
                                        dstDemTile: T.to,
                                        phase: M(T.phase)
                                    }
                                });
                                const S = JE(l.projMatrix, oM(l.canonical, f.renderWorldCopies) ? m / 10 : m, _);
                                if (u(E), !a) continue;
                                t.setupElevationDraw(r, a, A);
                                const I = l.toUnwrapped();
                                c && c.setupShadows(I, a), e1.uploadCommonUniforms(o, a, I, null, h), a.draw(e1, g, p, v, d, Dx.backCCW, S, "terrain_raster", t.gridBuffer, y, x);
                            }
                        }
                    }
                }(t, this, this.proxySourceCache, e1, this._updateTimestamp), this.renderingToTexture = !0, t.gpuTimingDeferredRenderEnd(), e1.splice(0, e1.length));
            }
            renderBatch(e1) {
                if (0 === this._drapedRenderBatches.length) return e1 + 1;
                this.renderingToTexture = !0;
                const t = this.painter, i = this.painter.context, r = this.proxySourceCache, n = this.proxiedCoords[r.id], o = this._drapedRenderBatches.shift(), s = t.style.order, a = [];
                let l = 0;
                for (const c of n){
                    const n = r.getTileByID(c.proxyTileKey), h = r.proxyCachedFBO[c.key] ? r.proxyCachedFBO[c.key][e1] : void 0, u = void 0 !== h ? r.renderCache[h] : this.pool[l++], d = void 0 !== h;
                    if (n.texture = u.tex, d && !u.dirty) {
                        a.push(n.tileID);
                        continue;
                    }
                    let p;
                    i.bindFramebuffer.set(u.fb.framebuffer), this.renderedToTile = !1, u.dirty && (i.clear({
                        color: hi.transparent,
                        stencil: 0
                    }), u.dirty = !1);
                    for(let e1 = o.start; e1 <= o.end; ++e1){
                        const r = t.style._mergedLayers[s[e1]];
                        if (r.isHidden(t.transform.zoom)) continue;
                        const n = t.style.getLayerSourceCache(r), o = n ? this.proxyToSource[c.key][n.id] : [
                            c
                        ];
                        if (!o) continue;
                        const a = o;
                        i.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), p !== (n ? n.id : null) && (this._setupStencil(u, o, r, n), p = n ? n.id : null), t.renderLayer(t, n, r, a);
                    }
                    if (0 === this._drapedRenderBatches.length) for (const e1 of this._pendingGroundEffectLayers){
                        const r = t.style._mergedLayers[s[e1]];
                        if (r.isHidden(t.transform.zoom)) continue;
                        const n = t.style.getLayerSourceCache(r), o = n ? this.proxyToSource[c.key][n.id] : [
                            c
                        ];
                        if (!o) continue;
                        const a = o;
                        i.viewport.set([
                            0,
                            0,
                            u.fb.width,
                            u.fb.height
                        ]), p !== (n ? n.id : null) && (this._setupStencil(u, o, r, n), p = n ? n.id : null), t.renderLayer(t, n, r, a);
                    }
                    this.renderedToTile ? (u.dirty = !0, a.push(n.tileID)) : d || --l, 5 === l && (l = 0, this.renderToBackBuffer(a));
                }
                return this.renderToBackBuffer(a), this.renderingToTexture = !1, i.bindFramebuffer.set(null), i.viewport.set([
                    0,
                    0,
                    t.width,
                    t.height
                ]), o.end + 1;
            }
            postRender() {}
            isLayerOrderingCorrect(e1) {
                const t = e1.order.length;
                let i = -1, r = t;
                for(let n = 0; n < t; ++n)this._style.isLayerDraped(e1._mergedLayers[e1.order[n]]) ? i = Math.max(i, n) : r = Math.min(r, n);
                return r > i;
            }
            getMinElevationBelowMSL() {
                let e1 = 0;
                return this._visibleDemTiles.filter((e1)=>e1.dem).forEach((t)=>{
                    e1 = Math.min(e1, t.dem.tree.minimums[0]);
                }), 0 === e1 ? e1 : (e1 - 30) * this._exaggeration;
            }
            raycast(e1, t, i) {
                if (!this._visibleDemTiles) return null;
                const r = this._visibleDemTiles.filter((e1)=>e1.dem).map((r)=>{
                    const n = r.tileID, o = 1 << n.overscaledZ, { x: s, y: a } = n.canonical, l = s / o, c = (s + 1) / o, h = a / o, u = (a + 1) / o;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: u,
                        t: r.dem.tree.raycastRoot(l, h, c, u, e1, t, i),
                        tile: r
                    };
                });
                r.sort((e1, t)=>(null !== e1.t ? e1.t : Number.MAX_VALUE) - (null !== t.t ? t.t : Number.MAX_VALUE));
                for (const n of r){
                    if (null == n.t) return null;
                    const r = n.tile.dem.tree.raycast(n.minx, n.miny, n.maxx, n.maxy, e1, t, i);
                    if (null != r) return r;
                }
                return null;
            }
            _createFBO() {
                const e1 = this.painter.context, t = e1.gl, i = this.drapeBufferSize;
                e1.activeTexture.set(t.TEXTURE0);
                const r = new My(e1, {
                    width: i[0],
                    height: i[1],
                    data: null
                }, t.RGBA);
                r.bind(t.LINEAR, t.CLAMP_TO_EDGE);
                const n = e1.createFramebuffer(i[0], i[1], !0, null);
                return n.colorAttachment.set(r.texture), n.depthAttachment = new Tx(e1, n.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = e1.createRenderbuffer(e1.gl.DEPTH_STENCIL, i[0], i[1]), this._stencilRef = 0, n.depthAttachment.set(this._sharedDepthStencil), e1.clear({
                    stencil: 0
                })) : n.depthAttachment.set(this._sharedDepthStencil), e1.extTextureFilterAnisotropic && t.texParameterf(t.TEXTURE_2D, e1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, e1.extTextureFilterAnisotropicMax), {
                    fb: n,
                    tex: r,
                    dirty: !1
                };
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._style.hasLightTransitions()) return !0;
                for(const e1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[e1].hasTransition()) return !0;
                return this._style.order.some((e1)=>{
                    const t = this._style._mergedLayers[e1], i = t.isHidden(this.painter.transform.zoom);
                    return "custom" === t.type ? !i && t.shouldRedrape() : !i && t.hasTransition();
                });
            }
            _clearLineLayersFromRenderCache() {
                let e1 = !1;
                for (const t of this._style.getSources())if (t instanceof Vw) {
                    e1 = !0;
                    break;
                }
                if (!e1) return;
                const t = {};
                for(let e1 = 0; e1 < this._style.order.length; ++e1){
                    const i = this._style._mergedLayers[this._style.order[e1]], r = this._style.getLayerSourceCache(i);
                    if (r && !t[r.id] && !i.isHidden(this.painter.transform.zoom) && "line" === i.type && i.widthExpression() instanceof Ao) {
                        t[r.id] = !0;
                        for (const e1 of this.proxyCoords){
                            const t = this.proxyToSource[e1.key][r.id];
                            if (t) for (const e1 of t)this._clearRenderCacheForTile(r.id, e1);
                        }
                    }
                }
            }
            _clearRasterLayersFromRenderCache() {
                let e1 = !1;
                for(const t in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[t]._source instanceof jw) {
                    e1 = !0;
                    break;
                }
                if (!e1) return;
                const t = {};
                for(let e1 = 0; e1 < this._style.order.length; ++e1){
                    const i = this._style._mergedLayers[this._style.order[e1]], r = this._style.getLayerSourceCache(i);
                    if (!r || t[r.id]) continue;
                    if (i.isHidden(this.painter.transform.zoom) || "raster" !== i.type) continue;
                    const n = i.paint.get("raster-fade-duration");
                    for (const e1 of this.proxyCoords){
                        const t = this.proxyToSource[e1.key][r.id];
                        if (t) for (const e1 of t){
                            const t = aM(r.getTile(e1), r.findLoadedParent(e1, 0), r, this.painter.transform, n);
                            (1 !== t.opacity || 0 !== t.mix) && this._clearRenderCacheForTile(r.id, e1);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                const e1 = this._style.order, t = e1.length;
                if (0 === t) return;
                const i = [];
                this._pendingGroundEffectLayers = [];
                let r, n = 0, o = this._style._mergedLayers[e1[n]];
                for(; !this._style.isLayerDraped(o) && o.isHidden(this.painter.transform.zoom) && ++n < t;)o = this._style._mergedLayers[e1[n]];
                for(; n < t; ++n){
                    const t = this._style._mergedLayers[e1[n]];
                    t.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(t) ? void 0 === r && (r = n) : ("fill-extrusion" === t.type && this._pendingGroundEffectLayers.push(n), void 0 !== r && (i.push({
                        start: r,
                        end: n - 1
                    }), r = void 0)));
                }
                if (void 0 !== r && i.push({
                    start: r,
                    end: n - 1
                }), 0 !== i.length) {
                    const e1 = i[i.length - 1], t = this._pendingGroundEffectLayers.every((t)=>t > e1.end);
                    t || H("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
                }
                this._drapedRenderBatches = i;
            }
            _setupRenderCache(e1) {
                const t = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
                    if (this.invalidateRenderCache = !1, t.renderCache.length > t.renderCachePool.length) {
                        const e1 = Object.values(t.proxyCachedFBO);
                        t.proxyCachedFBO = {};
                        for(let i = 0; i < e1.length; ++i){
                            const r = Object.values(e1[i]);
                            t.renderCachePool.push(...r);
                        }
                    }
                    return;
                }
                this._clearRasterLayersFromRenderCache();
                const i = this.proxyCoords, r = this._tilesDirty;
                for(let n = i.length - 1; n >= 0; n--){
                    const o = i[n];
                    if (t.getTileByID(o.key), void 0 !== t.proxyCachedFBO[o.key]) {
                        const i = e1[o.key], n = this.proxyToSource[o.key];
                        let s = 0;
                        for(const e1 in n){
                            const t = n[e1], o = i[e1];
                            if (!o || o.length !== t.length || t.some((t, i)=>t !== o[i] || r[e1] && r[e1].hasOwnProperty(t.key))) {
                                s = -1;
                                break;
                            }
                            ++s;
                        }
                        for(const e1 in t.proxyCachedFBO[o.key])t.renderCache[t.proxyCachedFBO[o.key][e1]].dirty = s < 0 || s !== Object.values(i).length;
                    }
                }
                const n = [
                    ...this._drapedRenderBatches
                ];
                n.sort((e1, t)=>t.end - t.start - (e1.end - e1.start));
                for (const e1 of n)for (const r of i){
                    if (t.proxyCachedFBO[r.key]) continue;
                    let i = t.renderCachePool.pop();
                    void 0 === i && t.renderCache.length < 50 && (i = t.renderCache.length, t.renderCache.push(this._createFBO())), void 0 !== i && (t.proxyCachedFBO[r.key] = {}, t.proxyCachedFBO[r.key][e1.start] = i, t.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(e1, t, i, r) {
                if (!r || !this._sourceTilesOverlap[r.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const n = this.painter.context, o = n.gl;
                if (t.length <= 1) return void (this._overlapStencilType = !1);
                let s;
                if (i.isTileClipped()) s = t.length, this._overlapStencilMode.test = {
                    func: o.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(t[0].overscaledZ > t[t.length - 1].overscaledZ)) return void (this._overlapStencilType = !1);
                    s = 1, this._overlapStencilMode.test = {
                        func: o.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                this._stencilRef + s > 255 && (n.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += s, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(e1) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[e1.key]), this._overlapStencilMode) : Sx.disabled;
            }
            _renderTileClippingMasks(e1, t) {
                const i = this.painter, r = this.painter.context, n = r.gl;
                i._tileClippingMaskIDs = {}, r.setColorMode(Cx.disabled), r.setDepthMode(Mx.disabled);
                const o = i.getOrCreateProgram("clippingMask");
                for (const r of e1){
                    const e1 = i._tileClippingMaskIDs[r.key] = --t;
                    o.draw(i, n.TRIANGLES, Mx.disabled, new Sx({
                        func: n.ALWAYS,
                        mask: 0
                    }, e1, 255, n.KEEP, n.KEEP, n.REPLACE), Cx.disabled, Dx.disabled, sM(r.projMatrix), "$clipping", i.tileExtentBuffer, i.quadTriangleIndexBuffer, i.tileExtentSegments);
                }
            }
            pointCoordinate(e1) {
                const t = this.painter.transform;
                if (e1.x < 0 || e1.x > t.width || e1.y < 0 || e1.y > t.height) return null;
                const i = [
                    e1.x,
                    e1.y,
                    1,
                    1
                ];
                yu.transformMat4(i, i, t.pixelMatrixInverse), yu.scale(i, i, 1 / i[3]), i[0] /= t.worldSize, i[1] /= t.worldSize;
                const r = t._camera.position, n = Qd(1, t.center.lat), o = [
                    r[0],
                    r[1],
                    r[2] / n,
                    0
                ], s = Du.subtract([], i.slice(0, 3), o);
                Du.normalize(s, s);
                const a = this.raycast(o, s, this._exaggeration);
                return null !== a && a ? (Du.scaleAndAdd(o, o, s, a), o[3] = o[2], o[2] *= n, o) : null;
            }
            drawDepth() {
                const e1 = this.painter, t = e1.context, i = this.proxySourceCache, r = Math.ceil(e1.width), n = Math.ceil(e1.height);
                if (!this._depthFBO || this._depthFBO.width === r && this._depthFBO.height === n || (this._depthFBO.destroy(), this._depthFBO = void 0, this._depthTexture = void 0), !this._depthFBO) {
                    const e1 = t.gl, i = t.createFramebuffer(r, n, !0, "renderbuffer");
                    t.activeTexture.set(e1.TEXTURE0);
                    const o = new My(t, {
                        width: r,
                        height: n,
                        data: null
                    }, e1.RGBA);
                    o.bind(e1.NEAREST, e1.CLAMP_TO_EDGE), i.colorAttachment.set(o.texture);
                    const s = t.createRenderbuffer(t.gl.DEPTH_COMPONENT16, r, n);
                    i.depthAttachment.set(s), this._depthFBO = i, this._depthTexture = o;
                }
                t.bindFramebuffer.set(this._depthFBO.framebuffer), t.viewport.set([
                    0,
                    0,
                    r,
                    n
                ]), function(e1, t, i, r) {
                    if ("globe" === e1.transform.projection.name) return;
                    const n = e1.context, o = n.gl;
                    n.clear({
                        depth: 1
                    });
                    const s = e1.getOrCreateProgram("terrainDepth"), a = new Mx(o.LESS, Mx.ReadWrite, e1.depthRangeFor3D);
                    for (const n of r){
                        const r = i.getTile(n), l = JE(n.projMatrix, 0, [
                            0,
                            0,
                            0
                        ]);
                        t.setupElevationDraw(r, s), s.draw(e1, o.TRIANGLES, a, Sx.disabled, Cx.unblended, Dx.backCCW, l, "terrain_depth", t.gridBuffer, t.gridIndexBuffer, t.gridNoSkirtSegments);
                    }
                }(e1, this, i, this.proxyCoords);
            }
            _setupProxiedCoordsForOrtho(e1, t, i) {
                if (e1.getSource() instanceof Jb) return this._setupProxiedCoordsForImageSource(e1, t, i);
                this._findCoveringTileCache[e1.id] = this._findCoveringTileCache[e1.id] || {};
                const r = this.proxiedCoords[e1.id] = [], n = this.proxyCoords;
                for(let t = 0; t < n.length; t++){
                    const o = n[t], s = this._findTileCoveringTileID(o, e1);
                    if (s) {
                        const t = this._createProxiedId(o, s, i[o.key] && i[o.key][e1.id]);
                        r.push(t), this.proxyToSource[o.key][e1.id] = [
                            t
                        ];
                    }
                }
                let o = !1;
                for(let n = 0; n < t.length; n++){
                    const s = e1.getTile(t[n]);
                    if (!s || !s.hasData()) continue;
                    const a = this._findTileCoveringTileID(s.tileID, this.proxySourceCache);
                    if (a && a.tileID.canonical.z !== s.tileID.canonical.z) {
                        const t = this.proxyToSource[a.tileID.key][e1.id], n = this._createProxiedId(a.tileID, s, i[a.tileID.key] && i[a.tileID.key][e1.id]);
                        t ? t.splice(t.length - 1, 0, n) : this.proxyToSource[a.tileID.key][e1.id] = [
                            n
                        ], r.push(n), o = !0;
                    }
                }
                this._sourceTilesOverlap[e1.id] = o;
            }
            _setupProxiedCoordsForImageSource(e1, t, i) {
                if (!e1.getSource().loaded()) return;
                const r = this.proxiedCoords[e1.id] = [], n = this.proxyCoords, o = e1.getSource(), s = o.tileID;
                if (!s) return;
                const a = new y(s.x, s.y)._div(1 << s.z), l = o.coordinates.map(lp.fromLngLat).reduce((e1, t)=>(e1.min.x = Math.min(e1.min.x, t.x - a.x), e1.min.y = Math.min(e1.min.y, t.y - a.y), e1.max.x = Math.max(e1.max.x, t.x - a.x), e1.max.y = Math.max(e1.max.y, t.y - a.y), e1), {
                    min: new y(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new y(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), c = (e1, t)=>{
                    const i = e1.wrap + e1.canonical.x / (1 << e1.canonical.z), r = e1.canonical.y / (1 << e1.canonical.z), n = cr / (1 << e1.canonical.z), o = t.wrap + t.canonical.x / (1 << t.canonical.z), s = t.canonical.y / (1 << t.canonical.z);
                    return i + n < o + l.min.x || i > o + l.max.x || r + n < s + l.min.y || r > s + l.max.y;
                };
                for(let o = 0; o < n.length; o++){
                    const s = n[o];
                    for(let n = 0; n < t.length; n++){
                        const o = e1.getTile(t[n]);
                        if (!o || !o.hasData()) continue;
                        if (c(s, o.tileID)) continue;
                        const a = this._createProxiedId(s, o, i[s.key] && i[s.key][e1.id]), l = this.proxyToSource[s.key][e1.id];
                        l ? l.push(a) : this.proxyToSource[s.key][e1.id] = [
                            a
                        ], r.push(a);
                    }
                }
            }
            _createProxiedId(e1, t, i) {
                let r = this.orthoMatrix;
                if (i) {
                    const e1 = i.find((e1)=>e1.key === t.tileID.key);
                    if (e1) return e1;
                }
                if (t.tileID.key !== e1.key) {
                    const i = e1.canonical.z - t.tileID.canonical.z;
                    let n, o, s;
                    r = Au.create();
                    const a = t.tileID.wrap - e1.wrap << e1.overscaledZ;
                    i > 0 ? (n = cr >> i, o = n * ((t.tileID.canonical.x << i) - e1.canonical.x + a), s = n * ((t.tileID.canonical.y << i) - e1.canonical.y)) : (n = cr << -i, o = cr * (t.tileID.canonical.x - (e1.canonical.x + a << -i)), s = cr * (t.tileID.canonical.y - (e1.canonical.y << -i))), Au.ortho(r, 0, n, 0, n, 0, 1), Au.translate(r, r, [
                        o,
                        s,
                        0
                    ]);
                }
                return new hM(t.tileID, e1.key, r);
            }
            _findTileCoveringTileID(e1, t) {
                let i = t.getTile(e1);
                if (i && i.hasData()) return i;
                const r = this._findCoveringTileCache[t.id], n = r[e1.key];
                if (i = n ? t.getTileByID(n) : null, i && i.hasData() || null === n) return i;
                let o = i ? i.tileID : e1, s = o.overscaledZ;
                const a = t.getSource().minzoom, l = [];
                if (!n) {
                    const r = t.getSource().maxzoom;
                    if (e1.canonical.z >= r) {
                        const i = e1.canonical.z - r;
                        t.getSource().reparseOverscaled ? (s = Math.max(e1.canonical.z + 2, t.transform.tileZoom), o = new qu(s, e1.wrap, r, e1.canonical.x >> i, e1.canonical.y >> i)) : 0 !== i && (s = r, o = new qu(s, e1.wrap, r, e1.canonical.x >> i, e1.canonical.y >> i));
                    }
                    o.key !== e1.key && (l.push(o.key), i = t.getTile(o));
                }
                const c = (e1)=>{
                    l.forEach((t)=>{
                        r[t] = e1;
                    }), l.length = 0;
                };
                for(s -= 1; s >= a && (!i || !i.hasData()); s--){
                    i && c(i.tileID.key);
                    const e1 = o.calculateScaledKey(s);
                    if (i = t.getTileByID(e1), i && i.hasData()) break;
                    const n = r[e1];
                    if (null === n) break;
                    void 0 === n ? l.push(e1) : i = t.getTileByID(n);
                }
                return c(i ? i.tileID.key : null), i && i.hasData() ? i : null;
            }
            findDEMTileFor(e1) {
                return this.enabled ? this._findTileCoveringTileID(e1, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e1, t) {
                let i = this._tilesDirty[e1];
                i || (i = this._tilesDirty[e1] = {}), i[t.key] = !0;
            }
            constructor(e1, t){
                super(), this.painter = e1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [i, r, n] = function(e1) {
                    const t = new za, i = new Wa, r = 131;
                    t.reserve(17161), i.reserve(33800);
                    const n = cr / 128, o = cr + n / 2, s = o + n;
                    for(let e1 = -n; e1 < s; e1 += n)for(let i = -n; i < s; i += n){
                        const r = i < 0 || i > o || e1 < 0 || e1 > o ? 24575 : 0, n = z(Math.round(i), 0, cr), s = z(Math.round(e1), 0, cr);
                        t.emplaceBack(n + r, s);
                    }
                    const a = (e1, t)=>{
                        const n = t * r + e1;
                        i.emplaceBack(n + 1, n, n + r), i.emplaceBack(n + r, n + r + 1, n + 1);
                    };
                    for(let e1 = 1; e1 < 129; e1++)for(let t = 1; t < 129; t++)a(t, e1);
                    return [
                        0,
                        129
                    ].forEach((e1)=>{
                        for(let t = 0; t < 130; t++)a(t, e1), a(e1, t);
                    }), [
                        t,
                        i,
                        32768
                    ];
                }(), o = e1.context;
                this.gridBuffer = o.createVertexBuffer(i, Nu.members), this.gridIndexBuffer = o.createIndexBuffer(r), this.gridSegments = xl.simpleSegment(0, 0, i.length, r.length), this.gridNoSkirtSegments = xl.simpleSegment(0, 0, i.length, n), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new cM(t.map), this.orthoMatrix = Au.create(), Au.ortho(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? .015 : 0, cr, 0, cr, 0, 1);
                const s = o.gl;
                this._overlapStencilMode = new Sx({
                    func: s.GEQUAL,
                    mask: 255
                }, 0, 255, s.KEEP, s.KEEP, s.REPLACE), this._previousZoom = e1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = t, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new lM(t.map), this._pendingGroundEffectLayers = [];
            }
        }
        function dM(e1, t, i) {
            const r = function(e1, t, i) {
                const r = Du.dot(t, e1), n = Du.dot(i, [
                    .2126,
                    .7152,
                    .0722
                ]), o = (e1, t, i)=>(1 - i) * e1 + i * t, s = o(1 - .3 * Math.min(n, 1), 1, Math.min(r + 1, 1));
                return o(.92, 1, Math.asin(z(t[2], -1, 1)) / Math.PI + .5) * s;
            }(e1, [
                0,
                0,
                1
            ], t), n = [
                0,
                0,
                0
            ];
            Du.scale(n, i.slice(0, 3), r);
            const o = [
                0,
                0,
                0
            ];
            Du.scale(o, t.slice(0, 3), e1[2]);
            const s = [
                0,
                0,
                0
            ];
            return Du.add(s, n, o), ae(s);
        }
        const pM = [
            "fill",
            "fillOutline",
            "fillPattern",
            "line",
            "linePattern",
            "background",
            "backgroundPattern",
            "hillshade",
            "raster"
        ], fM = [
            "stars",
            "fillExtrusion",
            "fillExtrusionGroundEffect",
            "model",
            "symbolSDF",
            "symbolIcon",
            "symbolTextAndIcon"
        ];
        class mM {
            static cacheKey(e1, t, i, r) {
                let n = `${t}${r ? r.cacheKey : ""}`;
                for (const t of i)e1.usedDefines.includes(t) && (n += `/${t}`);
                return n;
            }
            setTerrainUniformValues(e1, t) {
                if (!this.terrainUniforms) return;
                const i = this.terrainUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t)i[e1] && i[e1].set(this.program, e1, t[e1]);
                }
            }
            setGlobeUniformValues(e1, t) {
                if (!this.globeUniforms) return;
                const i = this.globeUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t)i[e1] && i[e1].set(this.program, e1, t[e1]);
                }
            }
            setFogUniformValues(e1, t) {
                if (!this.fogUniforms) return;
                const i = this.fogUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t)i[e1].set(this.program, e1, t[e1]);
                }
            }
            setCutoffUniformValues(e1, t) {
                if (!this.cutoffUniforms) return;
                const i = this.cutoffUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t)i[e1].set(this.program, e1, t[e1]);
                }
            }
            setLightsUniformValues(e1, t) {
                if (!this.lightsUniforms) return;
                const i = this.lightsUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t)i[e1].set(this.program, e1, t[e1]);
                }
            }
            setShadowUniformValues(e1, t) {
                if (this.failedToCreate || !this.shadowUniforms) return;
                const i = this.shadowUniforms;
                e1.program.set(this.program);
                for(const e1 in t)i[e1].set(this.program, e1, t[e1]);
            }
            _drawDebugWireframe(e1, t, i, r, n, o, s, a, l, c) {
                const h = e1.options.wireframe;
                if (!1 === h.terrain && !1 === h.layers2D && !1 === h.layers3D) return;
                const u = e1.context;
                if (!(()=>!(!h.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!h.layers2D || e1._terrain && e1._terrain.renderingToTexture || !pM.includes(this.name)) || !(!h.layers3D || !fM.includes(this.name)))()) return;
                const d = u.gl, p = e1.wireframeDebugCache.getLinesFromTrianglesBuffer(e1.frameCounter, n, u);
                if (!p) return;
                const f = [
                    ...this.fixedDefines
                ];
                f.push("DEBUG_WIREFRAME");
                const m = e1.getOrCreateProgram(this.name, {
                    config: this.configuration,
                    defines: f
                });
                u.program.set(m.program);
                const _ = (e1, t, i)=>{
                    if (t[e1] && i[e1]) for(const r in t[e1])i[e1][r] && i[e1][r].set(i.program, r, t[e1][r].current);
                };
                l && l.setUniforms(m.program, u, m.binderUniforms, s, {
                    zoom: a
                }), _("fixedUniforms", this, m), _("terrainUniforms", this, m), _("globeUniforms", this, m), _("fogUniforms", this, m), _("lightsUniforms", this, m), _("shadowUniforms", this, m), p.bind(), u.setColorMode(new Cx([
                    d.ONE,
                    d.ONE_MINUS_SRC_ALPHA,
                    d.ZERO,
                    d.ONE
                ], hi.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ])), u.setDepthMode(new Mx(t.func === d.LESS ? d.LEQUAL : t.func, Mx.ReadOnly, t.range)), u.setStencilMode(Sx.disabled);
                const g = 3 * o.primitiveLength * 2, y = 3 * o.primitiveOffset * 4;
                c && c > 1 ? d.drawElementsInstanced(d.LINES, g, d.UNSIGNED_SHORT, y, c) : d.drawElements(d.LINES, g, d.UNSIGNED_SHORT, y), n.bind(), u.program.set(this.program), u.setDepthMode(t), u.setStencilMode(i), u.setColorMode(r);
            }
            draw(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m) {
                const _ = e1.context, g = _.gl;
                if (this.failedToCreate) return;
                _.program.set(this.program), _.setDepthMode(i), _.setStencilMode(r), _.setColorMode(n), _.setCullFace(o);
                for (const e1 of Object.keys(this.fixedUniforms))this.fixedUniforms[e1].set(this.program, e1, s[e1]);
                p && p.setUniforms(this.program, _, this.binderUniforms, u, {
                    zoom: d
                });
                const y = {
                    [g.LINES]: 2,
                    [g.TRIANGLES]: 3,
                    [g.LINE_STRIP]: 1
                }[t], x = m && m > 0 ? 1 : void 0;
                for (const o of h.get()){
                    const s = o.vaos || (o.vaos = {});
                    (s[a] || (s[a] = new $E)).bind(_, this, l, p ? p.getPaintVertexBuffers() : [], c, o.vertexOffset, f || [], x), m && m > 1 ? g.drawElementsInstanced(t, o.primitiveLength * y, g.UNSIGNED_SHORT, o.primitiveOffset * y * 2, m) : g.drawElements(t, o.primitiveLength * y, g.UNSIGNED_SHORT, o.primitiveOffset * y * 2), t === g.TRIANGLES && this._drawDebugWireframe(e1, i, r, n, c, o, u, d, p, m);
                }
            }
            constructor(e1, t, i, r, n, o){
                const s = e1.gl;
                this.program = s.createProgram(), this.configuration = r, this.name = t, this.fixedDefines = [
                    ...o
                ];
                const a = r ? r.getBinderAttributes() : [], l = (i.staticAttributes || []).concat(a);
                let c = r ? r.defines() : [];
                c = c.concat(o.map((e1)=>`#define ${e1}`));
                const h = "#version 300 es\n";
                let u = h + c.concat("precision mediump float;", jE, VE.fragmentSource).join("\n");
                for (const e1 of i.fragmentIncludes)u += `\n${NE[e1]}`;
                u += `\n${i.fragmentSource}`;
                let d = h + c.concat("precision highp float;", jE, VE.vertexSource).join("\n");
                for (const e1 of i.vertexIncludes)d += `\n${NE[e1]}`;
                d += `\n${i.vertexSource}`;
                const p = s.createShader(s.FRAGMENT_SHADER);
                if (s.isContextLost()) return void (this.failedToCreate = !0);
                s.shaderSource(p, u), s.compileShader(p), s.attachShader(this.program, p);
                const f = s.createShader(s.VERTEX_SHADER);
                if (s.isContextLost()) this.failedToCreate = !0;
                else {
                    s.shaderSource(f, d), s.compileShader(f), s.attachShader(this.program, f), this.attributes = {}, this.numAttributes = l.length;
                    for(let e1 = 0; e1 < this.numAttributes; e1++)if (l[e1]) {
                        const t = l[e1].startsWith("a_") ? l[e1] : `a_${l[e1]}`;
                        s.bindAttribLocation(this.program, e1, t), this.attributes[t] = e1;
                    }
                    s.linkProgram(this.program), s.deleteShader(f), s.deleteShader(p), this.fixedUniforms = n(e1), this.binderUniforms = r ? r.getUniforms(e1) : [], o.includes("TERRAIN") && (this.terrainUniforms = ((e1)=>({
                            u_dem: new kl(e1),
                            u_dem_prev: new kl(e1),
                            u_dem_tl: new Bl(e1),
                            u_dem_scale: new Ol(e1),
                            u_dem_tl_prev: new Bl(e1),
                            u_dem_scale_prev: new Ol(e1),
                            u_dem_size: new Ol(e1),
                            u_dem_lerp: new Ol(e1),
                            u_exaggeration: new Ol(e1),
                            u_depth: new kl(e1),
                            u_depth_size_inv: new Bl(e1),
                            u_meter_to_dem: new Ol(e1),
                            u_label_plane_matrix_inv: new jl(e1)
                        }))(e1)), o.includes("GLOBE") && (this.globeUniforms = ((e1)=>({
                            u_tile_tl_up: new Fl(e1),
                            u_tile_tr_up: new Fl(e1),
                            u_tile_br_up: new Fl(e1),
                            u_tile_bl_up: new Fl(e1),
                            u_tile_up_scale: new Ol(e1)
                        }))(e1)), o.includes("FOG") && (this.fogUniforms = ((e1)=>({
                            u_fog_matrix: new jl(e1),
                            u_fog_range: new Bl(e1),
                            u_fog_color: new Nl(e1),
                            u_fog_horizon_blend: new Ol(e1),
                            u_fog_vertical_limit: new Bl(e1),
                            u_fog_temporal_offset: new Ol(e1),
                            u_frustum_tl: new Fl(e1),
                            u_frustum_tr: new Fl(e1),
                            u_frustum_br: new Fl(e1),
                            u_frustum_bl: new Fl(e1),
                            u_globe_pos: new Fl(e1),
                            u_globe_radius: new Ol(e1),
                            u_globe_transition: new Ol(e1),
                            u_is_globe: new kl(e1),
                            u_viewport: new Bl(e1)
                        }))(e1)), o.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((e1)=>({
                            u_cutoff_params: new Nl(e1)
                        }))(e1)), o.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((e1)=>({
                            u_lighting_ambient_color: new Fl(e1),
                            u_lighting_directional_dir: new Fl(e1),
                            u_lighting_directional_color: new Fl(e1),
                            u_ground_radiance: new Fl(e1)
                        }))(e1)), o.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((e1)=>({
                            u_light_matrix_0: new jl(e1),
                            u_light_matrix_1: new jl(e1),
                            u_fade_range: new Bl(e1),
                            u_shadow_normal_offset: new Fl(e1),
                            u_shadow_intensity: new Ol(e1),
                            u_shadow_texel_size: new Ol(e1),
                            u_shadow_map_resolution: new Ol(e1),
                            u_shadow_direction: new Fl(e1),
                            u_shadow_bias: new Fl(e1),
                            u_shadowmap_0: new kl(e1),
                            u_shadowmap_1: new kl(e1)
                        }))(e1));
                }
            }
        }
        function _M(e1, t) {
            const i = Math.pow(2, t.tileID.overscaledZ), r = t.tileSize * Math.pow(2, e1.transform.tileZoom) / i, n = r * (t.tileID.canonical.x + t.tileID.wrap * i), o = r * t.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: t.imageAtlasTexture ? t.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: 1 / rv(t, 1, e1.transform.tileZoom),
                u_pixel_coord_upper: [
                    n >> 16,
                    o >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & n,
                    65535 & o
                ]
            };
        }
        const gM = Au.create(), yM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m)=>{
            const _ = t.style.light, g = _.properties.get("position"), y = [
                g.x,
                g.y,
                g.z
            ], x = Eu.create();
            "viewport" === _.properties.get("anchor") && (Eu.fromRotation(x, -t.transform.angle), Du.transformMat3(y, y, x));
            const v = _.properties.get("color"), b = t.transform, w = {
                u_matrix: e1,
                u_lightpos: y,
                u_lightintensity: _.properties.get("intensity"),
                u_lightcolor: [
                    v.r,
                    v.g,
                    v.b
                ],
                u_vertical_gradient: +i,
                u_opacity: r,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: gM,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_ao: n,
                u_edge_radius: o,
                u_flood_light_color: u,
                u_vertical_scale: d,
                u_flood_light_intensity: p,
                u_ground_shadow_factor: f,
                u_emissive_strength: m
            };
            return "globe" === b.projection.name && (w.u_tile_id = [
                s.canonical.x,
                s.canonical.y,
                1 << s.canonical.z
            ], w.u_zoom_transition = l, w.u_inv_rot_matrix = h, w.u_merc_center = c, w.u_up_dir = b.projection.upVector(new ju(0, 0, 0), c[0] * cr, c[1] * cr), w.u_height_lift = a), w;
        }, xM = (e1, t, i)=>({
                u_matrix: e1,
                u_edge_radius: t,
                u_vertical_scale: i
            }), vM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p)=>{
            const f = yM(e1, t, i, r, n, o, s, l, c, h, u, d, p, 1, [
                0,
                0,
                0
            ], 0), m = {
                u_height_factor: -Math.pow(2, s.overscaledZ) / a.tileSize / 8
            };
            return k(f, _M(t, a), m);
        }, bM = (e1, t)=>({
                u_matrix: e1,
                u_emissive_strength: t
            }), wM = (e1, t, i, r)=>k(bM(e1, t), _M(i, r)), TM = (e1, t, i)=>({
                u_matrix: e1,
                u_world: i,
                u_emissive_strength: t
            }), EM = (e1, t, i, r, n)=>k(wM(e1, t, i, r), {
                u_world: n
            }), MM = (e1, t, i, r)=>{
            const n = cr / i.tileSize;
            return {
                u_matrix: e1,
                u_camera_to_center_distance: t.getCameraToCenterDistance(r),
                u_extrude_scale: [
                    t.pixelsToGLUnits[0] / n,
                    t.pixelsToGLUnits[1] / n
                ]
            };
        }, AM = (e1, t, i = 1)=>({
                u_matrix: e1,
                u_color: t,
                u_overlay: 0,
                u_overlay_scale: i
            }), SM = Au.create(), IM = (e1, t, i, r, n, o, s)=>{
            const a = e1.transform, l = "globe" === a.projection.name, c = l ? Cd(a.zoom, t.canonical) * a._pixelsPerMercatorPixel : rv(i, 1, o), h = {
                u_matrix: t.projMatrix,
                u_extrude_scale: c,
                u_intensity: s,
                u_inv_rot_matrix: SM,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (l) {
                h.u_inv_rot_matrix = r, h.u_merc_center = n, h.u_tile_id = [
                    t.canonical.x,
                    t.canonical.y,
                    1 << t.canonical.z
                ], h.u_zoom_transition = Dd(a.zoom);
                const e1 = n[0] * cr, i = n[1] * cr;
                h.u_up_dir = a.projection.upVector(new ju(0, 0, 0), e1, i);
            }
            return h;
        }, CM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y, x, v, b)=>{
            var w, T;
            return {
                u_matrix: e1,
                u_normalize_matrix: t,
                u_globe_matrix: i,
                u_merc_matrix: r,
                u_grid_matrix: n,
                u_tl_parent: o,
                u_scale_parent: h,
                u_fade_t: u.mix,
                u_opacity: u.opacity * d.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: d.paint.get("raster-brightness-min"),
                u_brightness_high: d.paint.get("raster-brightness-max"),
                u_saturation_factor: (T = d.paint.get("raster-saturation"), T > 0 ? 1 - 1 / (1.001 - T) : -T),
                u_contrast_factor: (w = d.paint.get("raster-contrast"), w > 0 ? 1 / (1 - w) : 1 + w),
                u_spin_weights: zM(d.paint.get("raster-hue-rotate")),
                u_perspective_transform: p,
                u_raster_elevation: f,
                u_tl_br: s,
                u_zoom_transition: a,
                u_merc_center: l,
                u_cutoff_params: c,
                u_colorization_mix: PM(_, y),
                u_colorization_offset: DM(g, y),
                u_color_ramp: m,
                u_texture_offset: [
                    v / (x + 2 * v),
                    x / (x + 2 * v)
                ],
                u_texture_res: [
                    x + 2 * v,
                    x + 2 * v
                ],
                u_emissive_strength: b
            };
        };
        function zM(e1) {
            e1 *= Math.PI / 180;
            const t = Math.sin(e1), i = Math.cos(e1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t - i + 1) / 3,
                (Math.sqrt(3) * t - i + 1) / 3
            ];
        }
        function PM([e1, t, i, r], [n, o]) {
            if (n === o) return [
                0,
                0,
                0,
                0
            ];
            const s = 259 / 257 / (o - n);
            return [
                e1 * s,
                t * s,
                i * s,
                r * s
            ];
        }
        function DM(e1, [t, i]) {
            return t === i ? 0 : ((e1 - t) / (i - t) * 259 - 1) / 257;
        }
        const RM = Au.create(), LM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g)=>{
            const y = n.transform, x = {
                u_is_size_zoom_constant: +("constant" === e1 || "source" === e1),
                u_is_size_feature_constant: +("constant" === e1 || "camera" === e1),
                u_size_t: t ? t.uSizeT : 0,
                u_size: t ? t.uSize : 0,
                u_camera_to_center_distance: y.getCameraToCenterDistance(m),
                u_rotate_symbol: +i,
                u_aspect_ratio: y.width / y.height,
                u_fade_change: n.options.fadeDuration ? n.symbolFadeChange : 1,
                u_matrix: o,
                u_label_plane_matrix: s,
                u_coord_matrix: a,
                u_is_text: +l,
                u_pitch_with_map: +r,
                u_texsize: c,
                u_texture: 0,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: RM,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: RM,
                u_up_vector: [
                    0,
                    -1,
                    0
                ],
                u_icon_transition: g || 0,
                u_icon_saturation: _
            };
            return "globe" === m.name && (x.u_tile_id = [
                h.canonical.x,
                h.canonical.y,
                1 << h.canonical.z
            ], x.u_zoom_transition = u, x.u_inv_rot_matrix = p, x.u_merc_center = d, x.u_camera_forward = y._camera.forward(), x.u_ecef_origin = function(e1, t) {
                const i = [
                    0,
                    0,
                    0
                ], r = Ad(fd(t.canonical));
                return Du.transformMat4(i, i, r), Du.transformMat4(i, i, e1), i;
            }(y.globeMatrix, h.toUnwrapped()), x.u_tile_matrix = Float32Array.from(y.globeMatrix), x.u_up_vector = f), x;
        }, kM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _)=>k(LM(e1, t, i, r, n, o, s, a, l, c, u, d, p, f, m, _, 1), {
                u_gamma_scale: r ? n.transform.getCameraToCenterDistance(_) * Math.cos(n.terrain ? 0 : n.transform._pitch) : 1,
                u_device_pixel_ratio: dt.devicePixelRatio,
                u_is_halo: +h,
                undefined: void 0
            }), OM = (e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m)=>k(kM(e1, t, i, r, n, o, s, a, !0, l, !0, h, u, d, p, f, m), {
                u_texsize_icon: c,
                u_texture_icon: 1
            }), BM = (e1, t, i, r)=>({
                u_matrix: e1,
                u_emissive_strength: t,
                u_opacity: i,
                u_color: r
            }), FM = (e1, t, i, r, n, o, s)=>k(function(e1, t, i, r) {
                const n = i.imageManager.getPattern(e1.toString(), t), { width: o, height: s } = i.imageManager.getPixelSize(t), a = Math.pow(2, r.tileID.overscaledZ), l = r.tileSize * Math.pow(2, i.transform.tileZoom) / a, c = l * (r.tileID.canonical.x + r.tileID.wrap * a), h = l * r.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl: n.tl,
                    u_pattern_br: n.br,
                    u_texsize: [
                        o,
                        s
                    ],
                    u_pattern_size: n.displaySize,
                    u_tile_units_to_pixels: 1 / rv(r, 1, i.transform.tileZoom),
                    u_pixel_coord_upper: [
                        c >> 16,
                        h >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & c,
                        65535 & h
                    ]
                };
            }(n, o, r, s), {
                u_matrix: e1,
                u_emissive_strength: t,
                u_opacity: i
            }), NM = {
            BaseColor: 5,
            MetallicRoughness: 6,
            Normal: 7,
            Occlusion: 8,
            Emission: 9,
            ShadowMap0: 10
        }, UM = (e1, t, i, r, n, o, s, a, l, c, h, u, d = [
            0,
            0,
            0
        ])=>{
            const p = r.style.light, f = p.properties.get("position"), m = [
                -f.x,
                -f.y,
                f.z
            ], _ = Eu.create();
            "viewport" === p.properties.get("anchor") && (Eu.fromRotation(_, -r.transform.angle), Du.transformMat3(m, m, _));
            const g = "MASK" === c.alphaMode, y = p.properties.get("color"), x = u.paint.get("model-ambient-occlusion-intensity"), v = u.paint.get("model-color").constantOr(hi.white), b = u.paint.get("model-color-mix-intensity").constantOr(0);
            return {
                u_matrix: e1,
                u_lighting_matrix: t,
                u_normal_matrix: i,
                u_lightpos: m,
                u_lightintensity: p.properties.get("intensity"),
                u_lightcolor: [
                    y.r,
                    y.g,
                    y.b
                ],
                u_camera_pos: d,
                u_opacity: n,
                u_baseTextureIsAlpha: 0,
                u_alphaMask: +g,
                u_alphaCutoff: c.alphaCutoff,
                u_baseColorFactor: [
                    o.r,
                    o.g,
                    o.b,
                    o.a
                ],
                u_emissiveFactor: [
                    s[0],
                    s[1],
                    s[2],
                    1
                ],
                u_metallicFactor: a,
                u_roughnessFactor: l,
                u_baseColorTexture: NM.BaseColor,
                u_metallicRoughnessTexture: NM.MetallicRoughness,
                u_normalTexture: NM.Normal,
                u_occlusionTexture: NM.Occlusion,
                u_emissionTexture: NM.Emission,
                u_color_mix: [
                    v.r,
                    v.g,
                    v.b,
                    b
                ],
                u_aoIntensity: x,
                u_emissive_strength: h
            };
        }, VM = new Float32Array(16), jM = (e1, t = VM, i = VM)=>({
                u_matrix: e1,
                u_instance: t,
                u_node_matrix: i
            }), GM = {
            fillExtrusion: (e1)=>({
                    u_matrix: new jl(e1),
                    u_lightpos: new Fl(e1),
                    u_lightintensity: new Ol(e1),
                    u_lightcolor: new Fl(e1),
                    u_vertical_gradient: new Ol(e1),
                    u_opacity: new Ol(e1),
                    u_edge_radius: new Ol(e1),
                    u_ao: new Bl(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_up_dir: new Fl(e1),
                    u_height_lift: new Ol(e1),
                    u_flood_light_color: new Fl(e1),
                    u_vertical_scale: new Ol(e1),
                    u_flood_light_intensity: new Ol(e1),
                    u_ground_shadow_factor: new Fl(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            fillExtrusionDepth: (e1)=>({
                    u_matrix: new jl(e1),
                    u_edge_radius: new Ol(e1),
                    u_vertical_scale: new Ol(e1)
                }),
            fillExtrusionPattern: (e1)=>({
                    u_matrix: new jl(e1),
                    u_lightpos: new Fl(e1),
                    u_lightintensity: new Ol(e1),
                    u_lightcolor: new Fl(e1),
                    u_vertical_gradient: new Ol(e1),
                    u_height_factor: new Ol(e1),
                    u_edge_radius: new Ol(e1),
                    u_ao: new Bl(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_up_dir: new Fl(e1),
                    u_height_lift: new Ol(e1),
                    u_image: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_pixel_coord_upper: new Bl(e1),
                    u_pixel_coord_lower: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1),
                    u_opacity: new Ol(e1)
                }),
            fillExtrusionGroundEffect: (e1)=>({
                    u_matrix: new jl(e1),
                    u_opacity: new Ol(e1),
                    u_ao_pass: new Ol(e1),
                    u_meter_to_tile: new Ol(e1),
                    u_ao: new Bl(e1),
                    u_flood_light_intensity: new Ol(e1),
                    u_flood_light_color: new Fl(e1),
                    u_attenuation: new Ol(e1),
                    u_edge_radius: new Ol(e1),
                    u_fb: new kl(e1),
                    u_fb_size: new Ol(e1)
                }),
            fill: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            fillPattern: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1),
                    u_image: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_pixel_coord_upper: new Bl(e1),
                    u_pixel_coord_lower: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1)
                }),
            fillOutline: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1),
                    u_world: new Bl(e1)
                }),
            fillOutlinePattern: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1),
                    u_world: new Bl(e1),
                    u_image: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_pixel_coord_upper: new Bl(e1),
                    u_pixel_coord_lower: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1)
                }),
            circle: (e1)=>({
                    u_camera_to_center_distance: new Ol(e1),
                    u_extrude_scale: new $l(e1),
                    u_device_pixel_ratio: new Ol(e1),
                    u_matrix: new jl(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_up_dir: new Fl(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            collisionBox: (e1)=>({
                    u_matrix: new jl(e1),
                    u_camera_to_center_distance: new Ol(e1),
                    u_extrude_scale: new Bl(e1)
                }),
            collisionCircle: (e1)=>({
                    u_matrix: new jl(e1),
                    u_inv_matrix: new jl(e1),
                    u_camera_to_center_distance: new Ol(e1),
                    u_viewport_size: new Bl(e1)
                }),
            debug: (e1)=>({
                    u_color: new Ul(e1),
                    u_matrix: new jl(e1),
                    u_overlay: new kl(e1),
                    u_overlay_scale: new Ol(e1)
                }),
            clippingMask: (e1)=>({
                    u_matrix: new jl(e1)
                }),
            heatmap: (e1)=>({
                    u_extrude_scale: new Ol(e1),
                    u_intensity: new Ol(e1),
                    u_matrix: new jl(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_up_dir: new Fl(e1)
                }),
            heatmapTexture: (e1)=>({
                    u_image: new kl(e1),
                    u_color_ramp: new kl(e1),
                    u_opacity: new Ol(e1)
                }),
            hillshade: (e1)=>({
                    u_matrix: new jl(e1),
                    u_image: new kl(e1),
                    u_latrange: new Bl(e1),
                    u_light: new Bl(e1),
                    u_shadow: new Ul(e1),
                    u_highlight: new Ul(e1),
                    u_emissive_strength: new Ol(e1),
                    u_accent: new Ul(e1)
                }),
            hillshadePrepare: (e1)=>({
                    u_matrix: new jl(e1),
                    u_image: new kl(e1),
                    u_dimension: new Bl(e1),
                    u_zoom: new Ol(e1)
                }),
            line: (e1)=>({
                    u_matrix: new jl(e1),
                    u_pixels_to_tile_units: new $l(e1),
                    u_device_pixel_ratio: new Ol(e1),
                    u_units_to_pixels: new Bl(e1),
                    u_dash_image: new kl(e1),
                    u_gradient_image: new kl(e1),
                    u_image_height: new Ol(e1),
                    u_texsize: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1),
                    u_alpha_discard_threshold: new Ol(e1),
                    u_trim_offset: new Bl(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            linePattern: (e1)=>({
                    u_matrix: new jl(e1),
                    u_texsize: new Bl(e1),
                    u_pixels_to_tile_units: new $l(e1),
                    u_device_pixel_ratio: new Ol(e1),
                    u_image: new kl(e1),
                    u_units_to_pixels: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1),
                    u_alpha_discard_threshold: new Ol(e1)
                }),
            raster: (e1)=>({
                    u_matrix: new jl(e1),
                    u_normalize_matrix: new jl(e1),
                    u_globe_matrix: new jl(e1),
                    u_merc_matrix: new jl(e1),
                    u_grid_matrix: new ql(e1),
                    u_tl_parent: new Bl(e1),
                    u_scale_parent: new Ol(e1),
                    u_fade_t: new Ol(e1),
                    u_opacity: new Ol(e1),
                    u_image0: new kl(e1),
                    u_image1: new kl(e1),
                    u_brightness_low: new Ol(e1),
                    u_brightness_high: new Ol(e1),
                    u_saturation_factor: new Ol(e1),
                    u_contrast_factor: new Ol(e1),
                    u_spin_weights: new Fl(e1),
                    u_perspective_transform: new Bl(e1),
                    u_raster_elevation: new Ol(e1),
                    u_tl_br: new Nl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_merc_center: new Bl(e1),
                    u_cutoff_params: new Nl(e1),
                    u_colorization_mix: new Nl(e1),
                    u_colorization_offset: new Ol(e1),
                    u_color_ramp: new kl(e1),
                    u_texture_offset: new Bl(e1),
                    u_texture_res: new Bl(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            symbolIcon: (e1)=>({
                    u_is_size_zoom_constant: new kl(e1),
                    u_is_size_feature_constant: new kl(e1),
                    u_size_t: new Ol(e1),
                    u_size: new Ol(e1),
                    u_camera_to_center_distance: new Ol(e1),
                    u_rotate_symbol: new kl(e1),
                    u_aspect_ratio: new Ol(e1),
                    u_fade_change: new Ol(e1),
                    u_matrix: new jl(e1),
                    u_label_plane_matrix: new jl(e1),
                    u_coord_matrix: new jl(e1),
                    u_is_text: new kl(e1),
                    u_pitch_with_map: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_camera_forward: new Fl(e1),
                    u_tile_matrix: new jl(e1),
                    u_up_vector: new Fl(e1),
                    u_ecef_origin: new Fl(e1),
                    u_texture: new kl(e1),
                    u_icon_transition: new Ol(e1),
                    u_icon_saturation: new Ol(e1)
                }),
            symbolSDF: (e1)=>({
                    u_is_size_zoom_constant: new kl(e1),
                    u_is_size_feature_constant: new kl(e1),
                    u_size_t: new Ol(e1),
                    u_size: new Ol(e1),
                    u_camera_to_center_distance: new Ol(e1),
                    u_rotate_symbol: new kl(e1),
                    u_aspect_ratio: new Ol(e1),
                    u_fade_change: new Ol(e1),
                    u_matrix: new jl(e1),
                    u_label_plane_matrix: new jl(e1),
                    u_coord_matrix: new jl(e1),
                    u_is_text: new kl(e1),
                    u_pitch_with_map: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_texture: new kl(e1),
                    u_gamma_scale: new Ol(e1),
                    u_device_pixel_ratio: new Ol(e1),
                    u_tile_id: new Fl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_inv_rot_matrix: new jl(e1),
                    u_merc_center: new Bl(e1),
                    u_camera_forward: new Fl(e1),
                    u_tile_matrix: new jl(e1),
                    u_up_vector: new Fl(e1),
                    u_ecef_origin: new Fl(e1),
                    u_is_halo: new kl(e1)
                }),
            symbolTextAndIcon: (e1)=>({
                    u_is_size_zoom_constant: new kl(e1),
                    u_is_size_feature_constant: new kl(e1),
                    u_size_t: new Ol(e1),
                    u_size: new Ol(e1),
                    u_camera_to_center_distance: new Ol(e1),
                    u_rotate_symbol: new kl(e1),
                    u_aspect_ratio: new Ol(e1),
                    u_fade_change: new Ol(e1),
                    u_matrix: new jl(e1),
                    u_label_plane_matrix: new jl(e1),
                    u_coord_matrix: new jl(e1),
                    u_is_text: new kl(e1),
                    u_pitch_with_map: new kl(e1),
                    u_texsize: new Bl(e1),
                    u_texsize_icon: new Bl(e1),
                    u_texture: new kl(e1),
                    u_texture_icon: new kl(e1),
                    u_gamma_scale: new Ol(e1),
                    u_device_pixel_ratio: new Ol(e1),
                    u_is_halo: new kl(e1)
                }),
            background: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1),
                    u_opacity: new Ol(e1),
                    u_color: new Ul(e1)
                }),
            backgroundPattern: (e1)=>({
                    u_matrix: new jl(e1),
                    u_emissive_strength: new Ol(e1),
                    u_opacity: new Ol(e1),
                    u_image: new kl(e1),
                    u_pattern_tl: new Bl(e1),
                    u_pattern_br: new Bl(e1),
                    u_texsize: new Bl(e1),
                    u_pattern_size: new Bl(e1),
                    u_pixel_coord_upper: new Bl(e1),
                    u_pixel_coord_lower: new Bl(e1),
                    u_tile_units_to_pixels: new Ol(e1)
                }),
            terrainRaster: KE,
            terrainDepth: KE,
            skybox: (e1)=>({
                    u_matrix: new jl(e1),
                    u_sun_direction: new Fl(e1),
                    u_cubemap: new kl(e1),
                    u_opacity: new Ol(e1),
                    u_temporal_offset: new Ol(e1)
                }),
            skyboxGradient: (e1)=>({
                    u_matrix: new jl(e1),
                    u_color_ramp: new kl(e1),
                    u_center_direction: new Fl(e1),
                    u_radius: new Ol(e1),
                    u_opacity: new Ol(e1),
                    u_temporal_offset: new Ol(e1)
                }),
            skyboxCapture: (e1)=>({
                    u_matrix_3f: new ql(e1),
                    u_sun_direction: new Fl(e1),
                    u_sun_intensity: new Ol(e1),
                    u_color_tint_r: new Nl(e1),
                    u_color_tint_m: new Nl(e1),
                    u_luminance: new Ol(e1)
                }),
            globeRaster: (e1)=>({
                    u_proj_matrix: new jl(e1),
                    u_globe_matrix: new jl(e1),
                    u_normalize_matrix: new jl(e1),
                    u_merc_matrix: new jl(e1),
                    u_zoom_transition: new Ol(e1),
                    u_merc_center: new Bl(e1),
                    u_image0: new kl(e1),
                    u_grid_matrix: new ql(e1),
                    u_skirt_height: new Ol(e1),
                    u_frustum_tl: new Fl(e1),
                    u_frustum_tr: new Fl(e1),
                    u_frustum_br: new Fl(e1),
                    u_frustum_bl: new Fl(e1),
                    u_globe_pos: new Fl(e1),
                    u_globe_radius: new Ol(e1),
                    u_viewport: new Bl(e1)
                }),
            globeAtmosphere: (e1)=>({
                    u_frustum_tl: new Fl(e1),
                    u_frustum_tr: new Fl(e1),
                    u_frustum_br: new Fl(e1),
                    u_frustum_bl: new Fl(e1),
                    u_horizon: new Ol(e1),
                    u_transition: new Ol(e1),
                    u_fadeout_range: new Ol(e1),
                    u_color: new Nl(e1),
                    u_high_color: new Nl(e1),
                    u_space_color: new Nl(e1),
                    u_temporal_offset: new Ol(e1),
                    u_horizon_angle: new Ol(e1)
                }),
            model: (e1)=>({
                    u_matrix: new jl(e1),
                    u_lighting_matrix: new jl(e1),
                    u_normal_matrix: new jl(e1),
                    u_lightpos: new Fl(e1),
                    u_lightintensity: new Ol(e1),
                    u_lightcolor: new Fl(e1),
                    u_camera_pos: new Fl(e1),
                    u_opacity: new Ol(e1),
                    u_baseColorFactor: new Nl(e1),
                    u_emissiveFactor: new Nl(e1),
                    u_metallicFactor: new Ol(e1),
                    u_roughnessFactor: new Ol(e1),
                    u_baseTextureIsAlpha: new kl(e1),
                    u_alphaMask: new kl(e1),
                    u_alphaCutoff: new Ol(e1),
                    u_baseColorTexture: new kl(e1),
                    u_metallicRoughnessTexture: new kl(e1),
                    u_normalTexture: new kl(e1),
                    u_occlusionTexture: new kl(e1),
                    u_emissionTexture: new kl(e1),
                    u_color_mix: new Nl(e1),
                    u_aoIntensity: new Ol(e1),
                    u_emissive_strength: new Ol(e1)
                }),
            modelDepth: (e1)=>({
                    u_matrix: new jl(e1),
                    u_instance: new jl(e1),
                    u_node_matrix: new jl(e1)
                }),
            groundShadow: (e1)=>({
                    u_matrix: new jl(e1),
                    u_ground_shadow_factor: new Fl(e1)
                }),
            stars: (e1)=>({
                    u_matrix: new jl(e1),
                    u_up: new Fl(e1),
                    u_right: new Fl(e1),
                    u_intensity_multiplier: new Ol(e1)
                })
        };
        let qM;
        function ZM(e1, t, i, r, n, o, s) {
            const a = e1.context, l = a.gl, c = e1.transform, h = e1.getOrCreateProgram("collisionBox"), u = [];
            let d = 0, p = 0;
            for(let a = 0; a < r.length; a++){
                const f = r[a], m = t.getTile(f), _ = m.getBucket(i);
                if (!_) continue;
                const g = XT(f, _, c);
                let y = g;
                0 === n[0] && 0 === n[1] || (y = e1.translatePosMatrix(g, m, n, o));
                const x = s ? _.textCollisionBox : _.iconCollisionBox, v = _.collisionCircleArray;
                if (v.length > 0) {
                    const e1 = Au.create(), t = y;
                    Au.mul(e1, _.placementInvProjMatrix, c.glCoordMatrix), Au.mul(e1, e1, _.placementViewportMatrix), u.push({
                        circleArray: v,
                        circleOffset: p,
                        transform: t,
                        invTransform: e1,
                        projection: _.getProjection()
                    }), d += v.length / 4, p = d;
                }
                x && (e1.terrain && e1.terrain.setupElevationDraw(m, h), h.draw(e1, l.LINES, Mx.disabled, Sx.disabled, e1.colorModeForRenderPass(), Dx.disabled, MM(y, c, m, _.getProjection()), i.id, x.layoutVertexBuffer, x.indexBuffer, x.segments, null, c.zoom, null, [
                    x.collisionVertexBuffer,
                    x.collisionVertexBufferExt
                ]));
            }
            if (!s || !u.length) return;
            const f = e1.getOrCreateProgram("collisionCircle"), m = new Za;
            m.resize(4 * d), m._trim();
            let _ = 0;
            for (const e1 of u)for(let t = 0; t < e1.circleArray.length / 4; t++){
                const i = 4 * t, r = e1.circleArray[i + 0], n = e1.circleArray[i + 1], o = e1.circleArray[i + 2], s = e1.circleArray[i + 3];
                m.emplace(_++, r, n, o, s, 0), m.emplace(_++, r, n, o, s, 1), m.emplace(_++, r, n, o, s, 2), m.emplace(_++, r, n, o, s, 3);
            }
            (!qM || qM.length < 2 * d) && (qM = function(e1) {
                const t = 2 * e1, i = new Wa;
                i.resize(t), i._trim();
                for(let e1 = 0; e1 < t; e1++){
                    const t = 6 * e1;
                    i.uint16[t + 0] = 4 * e1 + 0, i.uint16[t + 1] = 4 * e1 + 1, i.uint16[t + 2] = 4 * e1 + 2, i.uint16[t + 3] = 4 * e1 + 2, i.uint16[t + 4] = 4 * e1 + 3, i.uint16[t + 5] = 4 * e1 + 0;
                }
                return i;
            }(d));
            const g = a.createIndexBuffer(qM, !0), y = a.createVertexBuffer(m, h_.members, !0);
            for (const t of u){
                const r = {
                    u_matrix: t.transform,
                    u_inv_matrix: t.invTransform,
                    u_camera_to_center_distance: (x = c).getCameraToCenterDistance(t.projection),
                    u_viewport_size: [
                        x.width,
                        x.height
                    ]
                };
                f.draw(e1, l.TRIANGLES, Mx.disabled, Sx.disabled, e1.colorModeForRenderPass(), Dx.disabled, r, i.id, y, g, xl.simpleSegment(0, 2 * t.circleOffset, t.circleArray.length, t.circleArray.length / 2), null, c.zoom);
            }
            var x;
            y.destroy(), g.destroy();
        }
        const $M = Au.create();
        function WM({ width: e1, height: t, anchor: i, textOffset: r, textScale: n }, o) {
            const { horizontalAlign: s, verticalAlign: a } = F_(i), l = -(s - .5) * e1, c = -(a - .5) * t, h = xg(i, r);
            return new y((l / n + h[0]) * o, (c / n + h[1]) * o);
        }
        function HM(e1, t, i, r, n, o, s, a, l, c, h) {
            const u = e1.text.placedSymbolArray, d = e1.text.dynamicLayoutVertexArray, p = e1.icon.dynamicLayoutVertexArray, f = {}, m = e1.getProjection(), _ = YT(a, m, o), g = o.elevation, y = m.upVectorScale(a.canonical, o.center.lat, o.worldSize).metersToTile;
            d.clear();
            for(let p = 0; p < u.length; p++){
                const x = u.get(p), { tileAnchorX: v, tileAnchorY: b, numGlyphs: w } = x, T = x.hidden || !x.crossTileID || e1.allowVerticalPlacement && !x.placedOrientation ? null : r[x.crossTileID];
                if (T) {
                    let r = 0, u = 0, p = 0;
                    if (g) {
                        const e1 = g ? g.getAtTileOffset(a, v, b) : 0, [t, i, n] = m.upVector(a.canonical, v, b);
                        r = e1 * t * y, u = e1 * i * y, p = e1 * n * y;
                    }
                    let [E, M, A, S] = cv(x.projectedAnchorX + r, x.projectedAnchorY + u, x.projectedAnchorZ + p, i ? _ : s);
                    const I = hv(o.getCameraToCenterDistance(m), S);
                    let C = n.evaluateSizeForFeature(e1.textSizeData, c, x) * I / u_;
                    i && (C *= e1.tilePixelRatio / l);
                    const z = WM(T, C);
                    i ? ({ x: E, y: M, z: A } = m.projectTilePoint(v + z.x, b + z.y, a.canonical), [E, M, A] = cv(E + r, M + u, A + p, s)) : (t && z._rotate(-o.angle), E += z.x, M += z.y, A = 0);
                    const P = e1.allowVerticalPlacement && x.placedOrientation === A_.vertical ? Math.PI / 2 : 0;
                    for(let e1 = 0; e1 < w; e1++)dy(d, E, M, A, P);
                    h && x.associatedIconIndex >= 0 && (f[x.associatedIconIndex] = {
                        x: E,
                        y: M,
                        z: A,
                        angle: P
                    });
                } else xv(w, d);
            }
            if (h) {
                p.clear();
                const t = e1.icon.placedSymbolArray;
                for(let e1 = 0; e1 < t.length; e1++){
                    const i = t.get(e1), { numGlyphs: r } = i, n = f[e1];
                    if (i.hidden || !n) xv(r, p);
                    else {
                        const { x: e1, y: t, z: i, angle: o } = n;
                        for(let n = 0; n < r; n++)dy(p, e1, t, i, o);
                    }
                }
                e1.icon.dynamicLayoutVertexBuffer.updateData(p);
            }
            e1.text.dynamicLayoutVertexBuffer.updateData(d);
        }
        function XM(e1, t, i) {
            return i.iconsInText && t ? "symbolTextAndIcon" : e1 ? "symbolSDF" : "symbolIcon";
        }
        function YM(e1, t, i, r, n, o, s, a, l, c, h, u, d) {
            const p = e1.context, f = p.gl, m = e1.transform, _ = "map" === a, g = "map" === l, y = _ && "point" !== i.layout.get("symbol-placement"), x = _ && !g && !y, v = void 0 !== i.layout.get("symbol-sort-key").constantOr(1);
            let b = !1;
            const w = e1.depthModeForSublayer(0, Mx.ReadOnly), T = [
                Kd(m.center.lng),
                Jd(m.center.lat)
            ], E = i.layout.get("text-variable-anchor"), M = "globe" === m.projection.name, A = [], S = [
                0,
                -1,
                0
            ];
            let I = S;
            !M && !m.mercatorFromTransition || _ || (I = function(e1) {
                const t = e1._camera.getWorldToCamera(e1.worldSize, 1), i = Au.multiply([], t, e1.globeMatrix);
                Au.invert(i, i);
                const r = [
                    0,
                    0,
                    0
                ], n = [
                    0,
                    1,
                    0,
                    0
                ];
                return yu.transformMat4(n, n, i), r[0] = n[0], r[1] = n[1], r[2] = n[2], Du.normalize(r, r), r;
            }(m));
            for (const a of r){
                const r = t.getTile(a), l = r.getBucket(i);
                if (!l) continue;
                if ("mercator" === l.projection.name && M) continue;
                const u = n ? l.text : l.icon;
                if (!u || l.fullyClipped || !u.segments.get().length) continue;
                const d = u.programConfigurations.get(i.id), p = n || l.sdfIcons, w = n ? l.textSizeData : l.iconSizeData, C = g || 0 !== m.pitch, z = m_(w, m.zoom);
                let P, D, R, L, k = [
                    0,
                    0
                ], O = null;
                if (n) D = r.glyphAtlasTexture ? r.glyphAtlasTexture : null, R = f.LINEAR, P = r.glyphAtlasTexture ? r.glyphAtlasTexture.size : [
                    0,
                    0
                ], l.iconsInText && (k = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                    0,
                    0
                ], O = r.imageAtlasTexture ? r.imageAtlasTexture : null, L = C || e1.options.rotating || e1.options.zooming || "composite" === w.kind || "camera" === w.kind ? f.LINEAR : f.NEAREST);
                else {
                    const t = 1 !== i.layout.get("icon-size").constantOr(0) || l.iconsNeedLinear;
                    D = r.imageAtlasTexture ? r.imageAtlasTexture : null, R = p || e1.options.rotating || e1.options.zooming || t || C ? f.LINEAR : f.NEAREST, P = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                        0,
                        0
                    ];
                }
                const B = "globe" === l.projection.name, F = B ? I : S, N = B ? Dd(m.zoom) : 0, U = YT(a, l.getProjection(), m), V = m.calculatePixelsToTileUnitsMatrix(r), j = sv(U, r.tileID.canonical, g, _, m, l.getProjection(), V), G = e1.terrain && g && y ? Au.invert(Au.create(), j) : $M, q = lv(U, r.tileID.canonical, g, _, m, l.getProjection(), V), Z = E && l.hasTextData(), $ = l.hasIconTextFit() && Z && l.hasIconData();
                if (y) {
                    const t = m.elevation, i = t ? t.getAtTileOffsetFunc(a, m.center.lat, m.worldSize, l.getProjection()) : null, o = av(U, r.tileID.canonical, g, _, m, l.getProjection(), V);
                    dv(l, U, e1, n, o, q, g, c, i, a);
                }
                const W = y || n && E || $, H = e1.translatePosMatrix(U, r, o, s), X = W ? $M : j, Y = e1.translatePosMatrix(q, r, o, s, !0), K = l.getProjection().createInversionMatrix(m, a.canonical), J = i.paint.get("icon-image-cross-fade").constantOr(0), Q = [];
                e1.terrainRenderModeElevated() && g && Q.push("PITCH_WITH_MAP_TERRAIN"), B && (Q.push("PROJECTION_GLOBE_VIEW"), W && Q.push("PROJECTED_POS_ON_VIEWPORT")), J > 0 && Q.push("ICON_TRANSITION"), u.zOffsetVertexBuffer && Q.push("Z_OFFSET");
                const ee = p && 0 !== i.paint.get(n ? "text-halo-width" : "icon-halo-width").constantOr(1);
                let te;
                p ? te = l.iconsInText ? OM(w.kind, z, x, g, e1, H, X, Y, P, k, a, N, T, K, F, l.getProjection()) : kM(w.kind, z, x, g, e1, H, X, Y, n, P, !0, a, N, T, K, F, l.getProjection()) : (h < 1 && Q.push("SATURATION"), te = LM(w.kind, z, x, g, e1, H, X, Y, n, P, a, N, T, K, F, l.getProjection(), h, J));
                const ie = {
                    program: e1.getOrCreateProgram(XM(p, n, l), {
                        config: d,
                        defines: Q
                    }),
                    buffers: u,
                    uniformValues: te,
                    atlasTexture: D,
                    atlasTextureIcon: O,
                    atlasInterpolation: R,
                    atlasInterpolationIcon: L,
                    isSDF: p,
                    hasHalo: ee,
                    tile: r,
                    labelPlaneMatrixInv: G
                };
                if (v && l.canOverlap) {
                    b = !0;
                    const e1 = u.segments.get();
                    for (const t of e1)A.push({
                        segments: new xl([
                            t
                        ]),
                        sortKey: t.sortKey,
                        state: ie
                    });
                } else A.push({
                    segments: u.segments,
                    sortKey: 0,
                    state: ie
                });
            }
            b && A.sort((e1, t)=>e1.sortKey - t.sortKey);
            for (const t of A){
                const r = t.state;
                if (e1.terrain && e1.terrain.setupElevationDraw(r.tile, r.program, {
                    useDepthForOcclusion: m.depthOcclusionForSymbolsAndCircles,
                    labelPlaneMatrixInv: r.labelPlaneMatrixInv
                }), p.activeTexture.set(f.TEXTURE0), r.atlasTexture && r.atlasTexture.bind(r.atlasInterpolation, f.CLAMP_TO_EDGE), r.atlasTextureIcon && (p.activeTexture.set(f.TEXTURE1), r.atlasTextureIcon && r.atlasTextureIcon.bind(r.atlasInterpolationIcon, f.CLAMP_TO_EDGE)), e1.uploadCommonLightUniforms(e1.context, r.program), r.hasHalo) {
                    const n = r.uniformValues;
                    n.u_is_halo = 1, KM(r.buffers, t.segments, i, e1, r.program, w, u, d, n, 2), n.u_is_halo = 0;
                } else {
                    if (r.isSDF) {
                        const n = r.uniformValues;
                        r.hasHalo && (n.u_is_halo = 1, KM(r.buffers, t.segments, i, e1, r.program, w, u, d, n, 1)), n.u_is_halo = 0;
                    }
                    KM(r.buffers, t.segments, i, e1, r.program, w, u, d, r.uniformValues, 1);
                }
            }
        }
        function KM(e1, t, i, r, n, o, s, a, l, c) {
            const h = [
                e1.dynamicLayoutVertexBuffer,
                e1.opacityVertexBuffer,
                e1.iconTransitioningVertexBuffer,
                e1.globeExtVertexBuffer,
                e1.zOffsetVertexBuffer
            ];
            n.draw(r, r.context.gl.TRIANGLES, o, s, a, Dx.disabled, l, i.id, e1.layoutVertexBuffer, e1.indexBuffer, t, i.paint, r.transform.zoom, e1.programConfigurations.get(i.id), h, c);
        }
        function JM(e1, t, i, r, n, o, s) {
            const a = e1.context.gl, l = i.paint.get("fill-pattern"), c = l && l.constantOr(1);
            let h, u, d, p, f;
            s ? (u = c && !i.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", h = a.LINES) : (u = c ? "fillPattern" : "fill", h = a.TRIANGLES);
            for (const m of r){
                const r = t.getTile(m);
                if (c && !r.patternsLoaded()) continue;
                const _ = r.getBucket(i);
                if (!_) continue;
                e1.prepareDrawTile();
                const g = _.programConfigurations.get(i.id), y = e1.isTileAffectedByFog(m), x = e1.getOrCreateProgram(u, {
                    config: g,
                    overrideFog: y
                });
                c && (e1.context.activeTexture.set(a.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), g.updatePaintBuffers());
                const v = l.constantOr(null);
                if (v && r.imageAtlas) {
                    const e1 = r.imageAtlas.patternPositions[v.toString()];
                    e1 && g.setConstantPatternPositions(e1);
                }
                const b = e1.translatePosMatrix(m.projMatrix, r, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor")), w = i.paint.get("fill-emissive-strength");
                if (s) {
                    p = _.indexBuffer2, f = _.segments2;
                    const t = e1.terrain && e1.terrain.renderingToTexture ? e1.terrain.drapeBufferSize : [
                        a.drawingBufferWidth,
                        a.drawingBufferHeight
                    ];
                    d = "fillOutlinePattern" === u && c ? EM(b, w, e1, r, t) : TM(b, w, t);
                } else p = _.indexBuffer, f = _.segments, d = c ? wM(b, w, e1, r) : bM(b, w);
                e1.uploadCommonUniforms(e1.context, x, m.toUnwrapped()), x.draw(e1, h, n, e1.stencilModeForClipping(m), o, Dx.disabled, d, i.id, _.layoutVertexBuffer, p, f, i.paint, e1.transform.zoom, g, void 0);
            }
        }
        function QM(e1, t, i, r, n, o, s, a) {
            i.resetLayerRenderingStats();
            const l = e1.context, c = l.gl, h = e1.transform, u = i.paint.get("fill-extrusion-pattern"), d = u.constantOr(1), p = i.paint.get("fill-extrusion-opacity"), f = e1.style.enable3dLights(), m = i.paint.get(f && !d ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), _ = [
                i.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                m
            ], g = i.layout.get("fill-extrusion-edge-radius"), y = g > 0 && !i.paint.get("fill-extrusion-rounded-roof"), x = y ? 0 : g, v = "globe" === h.projection.name ? Ib() : 0, b = "globe" === h.projection.name, w = b ? Dd(h.zoom) : 0, T = [
                Kd(h.center.lng),
                Jd(h.center.lat)
            ], E = i.paint.get("fill-extrusion-flood-light-color").toArray01().slice(0, 3), M = i.paint.get("fill-extrusion-flood-light-intensity"), A = i.paint.get("fill-extrusion-vertical-scale"), S = eM(e1, i.paint.get("fill-extrusion-cutoff-fade-range")), I = i.paint.get("fill-extrusion-emissive-strength"), C = [];
            let z;
            b && C.push("PROJECTION_GLOBE_VIEW"), _[0] > 0 && C.push("FAUX_AO"), y && C.push("ZERO_ROOF_RADIUS"), a && C.push("HAS_CENTROID"), M > 0 && C.push("FLOOD_LIGHT"), S.shouldRenderCutoff && C.push("RENDER_CUTOFF");
            const P = "shadow" === e1.renderPass, D = e1.shadowRenderer, R = P && !!D;
            e1.shadowRenderer && (e1.shadowRenderer.useNormalOffset = !0);
            let L = [
                0,
                0,
                0
            ];
            if (D) {
                const t = e1.style.directionalLight, i = e1.style.ambientLight;
                t && i && (L = WA(t, i)), z = C.concat([
                    "SHADOWS_SINGLE_CASCADE"
                ]);
            }
            const k = R ? "fillExtrusionDepth" : d ? "fillExtrusionPattern" : "fillExtrusion", O = i.getLayerRenderingStats();
            for (const f of r){
                const r = t.getTile(f), m = r.getBucket(i);
                if (!m || m.projection.name !== h.projection.name) continue;
                let g = !1;
                D && (g = 0 === D.getMaxCascadeForTile(f.toUnwrapped()));
                const y = e1.isTileAffectedByFog(f), R = m.programConfigurations.get(i.id), B = e1.getOrCreateProgram(k, {
                    config: R,
                    defines: g ? z : C,
                    overrideFog: y
                });
                if (e1.terrain && e1.terrain.setupElevationDraw(r, B, {
                    useMeterToDem: !0
                }), !m.centroidVertexBuffer) {
                    const e1 = B.attributes.a_centroid_pos;
                    void 0 !== e1 && c.vertexAttrib2f(e1, 0, 0);
                }
                !P && D && D.setupShadows(r.tileID.toUnwrapped(), B, "vector-tile", r.tileID.overscaledZ), d && (e1.context.activeTexture.set(c.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(c.LINEAR, c.CLAMP_TO_EDGE), R.updatePaintBuffers());
                const F = u.constantOr(null);
                if (F && r.imageAtlas) {
                    const e1 = r.imageAtlas.patternPositions[F.toString()];
                    e1 && R.setConstantPatternPositions(e1);
                }
                const N = i.paint.get("fill-extrusion-vertical-gradient");
                let U;
                if (P && D) {
                    if (oA(r.tileID, m, e1)) continue;
                    const t = D.calculateShadowPassMatrixFromTile(r.tileID.toUnwrapped());
                    U = xM(t, x, A);
                } else {
                    const t = e1.translatePosMatrix(f.expandedProjMatrix, r, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), n = h.projection.createInversionMatrix(h, f.canonical);
                    U = d ? vM(t, e1, N, p, _, x, f, r, v, w, T, n, E, A) : yM(t, e1, N, p, _, x, f, v, w, T, n, E, A, M, L, I);
                }
                e1.uploadCommonUniforms(l, B, f.toUnwrapped(), null, S);
                let V = m.segments;
                if ("mercator" === h.projection.name && !P && (V = m.getVisibleSegments(r.tileID, e1.terrain, e1.transform.getFrustum(0)), !V.get().length)) continue;
                if (O) {
                    if (P) for (const e1 of V.get())O.numRenderedVerticesInShadowPass += e1.primitiveLength;
                    else for (const e1 of V.get())O.numRenderedVerticesInTransparentPass += e1.primitiveLength;
                }
                const j = [];
                (e1.terrain || a) && j.push(m.centroidVertexBuffer), b && j.push(m.layoutVertexExtBuffer), B.draw(e1, l.gl.TRIANGLES, n, o, s, Dx.backCCW, U, i.id, m.layoutVertexBuffer, m.indexBuffer, V, i.paint, e1.transform.zoom, R, j);
            }
            e1.shadowRenderer && (e1.shadowRenderer.useNormalOffset = !1);
        }
        function eA(e1, t, i, r, n, o, s, a, l, c, h, u, d, p, f, m, _, g, y) {
            const x = e1.context, v = x.gl, b = e1.transform, w = e1.transform.zoom, T = [], E = eM(e1, i.paint.get("fill-extrusion-cutoff-fade-range"));
            "clear" === c ? (T.push("CLEAR_SUBPASS"), y && (T.push("CLEAR_FROM_TEXTURE"), x.activeTexture.set(v.TEXTURE0), y.bind(v.LINEAR, v.CLAMP_TO_EDGE))) : "sdf" === c && T.push("SDF_SUBPASS"), _ && T.push("HAS_CENTROID"), E.shouldRenderCutoff && T.push("RENDER_CUTOFF");
            const M = i.layout.get("fill-extrusion-edge-radius"), A = (t, r, c, g, v)=>{
                const b = r.programConfigurations.get(i.id), A = e1.isTileAffectedByFog(t), S = e1.getOrCreateProgram("fillExtrusionGroundEffect", {
                    config: b,
                    defines: T,
                    overrideFog: A
                }), I = ((e1, t, i, r, n, o, s, a, l, c, h)=>({
                        u_matrix: t,
                        u_opacity: i,
                        u_ao_pass: r ? 1 : 0,
                        u_meter_to_tile: n,
                        u_ao: o,
                        u_flood_light_intensity: s,
                        u_flood_light_color: a,
                        u_attenuation: l,
                        u_edge_radius: c,
                        u_fb: 0,
                        u_fb_size: h
                    }))(0, g, h, l, v, [
                    u,
                    d * v
                ], p, f, m, w >= 17 ? 0 : M * v, y ? y.size[0] : 0), C = [];
                _ && C.push(r.hiddenByLandmarkVertexBuffer), e1.uploadCommonUniforms(x, S, t.toUnwrapped(), null, E), S.draw(e1, x.gl.TRIANGLES, n, o, s, a, I, i.id, r.vertexBuffer, r.indexBuffer, c, i.paint, w, b, C);
            };
            for (const n of r){
                const r = t.getTile(n), o = r.getBucket(i);
                if (!o || o.projection.name !== b.projection.name || !o.groundEffect || o.groundEffect && !o.groundEffect.hasData()) continue;
                const s = o.groundEffect, a = 1 / o.tileToMeter;
                {
                    const t = e1.translatePosMatrix(n.projMatrix, r, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), o = s.getDefaultSegment();
                    A(n, s, o, t, a);
                }
                if (g) for(let o = 0; o < 4; o++){
                    const s = $u[o](n), l = t.getTile(s);
                    if (!l) continue;
                    const c = l.getBucket(i);
                    if (!c || c.projection.name !== b.projection.name || !c.groundEffect || c.groundEffect && !c.groundEffect.hasData()) continue;
                    const h = c.groundEffect;
                    let u, d;
                    0 === o ? (u = [
                        -cr,
                        0,
                        0
                    ], d = 1) : 1 === o ? (u = [
                        cr,
                        0,
                        0
                    ], d = 0) : 2 === o ? (u = [
                        0,
                        -cr,
                        0
                    ], d = 3) : (u = [
                        0,
                        cr,
                        0
                    ], d = 2);
                    const p = h.regionSegments[d];
                    if (!p) continue;
                    const f = new Float32Array(16);
                    Au.translate(f, n.projMatrix, u), A(n, h, p, e1.translatePosMatrix(f, r, i.paint.get("fill-extrusion-translate"), i.paint.get("fill-extrusion-translate-anchor")), a);
                }
            }
        }
        function tA(e1, t, i, r, n, o, s) {
            0 === r.centroidVertexArray.length && r.createCentroidsBuffer();
            const a = o ? o.findDEMTileFor(i) : null;
            if (!(a && a.dem || s)) return;
            const l = (e1)=>{
                const i = t.getSource().minzoom, r = (e1)=>{
                    const i = t.getTileByID(e1);
                    if (i && i.hasData()) return i.getBucket(n);
                }, o = [
                    0,
                    -1,
                    1
                ];
                for (const t of o){
                    if (e1.overscaledZ + t < i) continue;
                    const n = r(e1.calculateScaledKey(e1.overscaledZ + t));
                    if (n) return n;
                }
            }, c = [
                0,
                0,
                0
            ], h = (e1, t)=>(c[0] = Math.min(e1.min.y, t.min.y), c[1] = Math.max(e1.max.y, t.max.y), c[2] = cr - t.min.x > e1.max.x ? t.min.x - cr : e1.max.x, c), u = (e1, t)=>(c[0] = Math.min(e1.min.x, t.min.x), c[1] = Math.max(e1.max.x, t.max.x), c[2] = cr - t.min.y > e1.max.y ? t.min.y - cr : e1.max.y, c), d = [
                (e1, t)=>h(e1, t),
                (e1, t)=>h(t, e1),
                (e1, t)=>u(e1, t),
                (e1, t)=>u(t, e1)
            ], p = (e1, t, r, n, s, l, c)=>{
                if (!o) return 0;
                const h = [
                    [
                        l ? r : e1,
                        l ? e1 : r,
                        0
                    ],
                    [
                        l ? r : t,
                        l ? t : r,
                        0
                    ]
                ], u = c < 0 ? cr + c : c, d = [
                    l ? u : (e1 + t) / 2,
                    l ? (e1 + t) / 2 : u,
                    0
                ];
                return 0 === r && c < 0 || 0 !== r && c > 0 ? o.getForTilePoints(s, [
                    d
                ], !0, n) : h.push(d), o.getForTilePoints(i, h, !0, a), Math.max(h[0][2], h[1][2], d[2]) / o.exaggeration();
            };
            for(let e1 = 0; e1 < 4; e1++){
                const t = r.borderFeatureIndices[e1];
                if (0 === t.length) continue;
                const n = $u[e1](i), a = l(n);
                if (!(a && a instanceof vb)) continue;
                if (r.borderDoneWithNeighborZ[e1] === a.canonical.z) continue;
                0 === a.centroidVertexArray.length && a.createCentroidsBuffer();
                const c = o ? o.findDEMTileFor(n) : null;
                if (!(c && c.dem || s)) continue;
                const h = (e1 < 2 ? 1 : 5) - e1, u = a.borderDoneWithNeighborZ[h] !== r.canonical.z, g = a.borderFeatureIndices[h];
                let x = 0;
                if (r.canonical.z !== a.canonical.z) {
                    for (const e1 of t)r.showCentroid(r.featuresOnBorder[e1]);
                    if (u) for (const e1 of g)a.showCentroid(a.featuresOnBorder[e1]);
                    r.borderDoneWithNeighborZ[e1] = a.canonical.z, a.borderDoneWithNeighborZ[h] = r.canonical.z;
                }
                for (const i of t){
                    const t = r.featuresOnBorder[i], o = r.centroidData[t.centroidDataIndex], l = t.borders[e1];
                    let u;
                    for(; x < g.length;){
                        u = a.featuresOnBorder[g[x]];
                        const e1 = u.borders[h];
                        if (e1[1] > l[0] + 3 || e1[0] > l[0] - 3) break;
                        a.showCentroid(u), x++;
                    }
                    if (u && x < g.length) {
                        const i = x;
                        let v = 0;
                        for(; !(u.borders[h][0] > l[1] - 3) && (v++, ++x !== g.length);)u = a.featuresOnBorder[g[x]];
                        if (u = a.featuresOnBorder[g[i]], v > 1) {
                            const e1 = u.borders[h];
                            Math.abs(l[0] - e1[0]) < 3 && Math.abs(l[1] - e1[1]) < 3 && (v = 1, x = i + 1);
                        } else if (0 === v) {
                            r.showCentroid(t);
                            continue;
                        }
                        const b = a.centroidData[u.centroidDataIndex];
                        s && 1 === v && (((m = o).flags | (_ = b).flags) & cb ? (m.flags |= cb, _.flags |= cb) : (m.flags &= 2147483647, _.flags &= 2147483647));
                        let w = new y(0, 0);
                        if (v > 1) x = i;
                        else if (c && c.dem && !(t.intersectsCount() > 1 || u.intersectsCount() > 1)) {
                            const t = d[e1](o, b), i = e1 % 2 ? cr - 1 : 0;
                            f = p(t[0], Math.min(cr - 1, t[1]), i, c, n, e1 < 2, t[2]), w = new y(Math.ceil(7 * (f + 450)), 0);
                        }
                        o.centroidXY = b.centroidXY = w, r.writeCentroidToBuffer(o), a.writeCentroidToBuffer(b);
                    } else r.showCentroid(t);
                }
                r.borderDoneWithNeighborZ[e1] = a.canonical.z, a.borderDoneWithNeighborZ[h] = r.canonical.z;
            }
            var f, m, _;
            (r.needsCentroidUpdate || !r.centroidVertexBuffer && 0 !== r.centroidVertexArray.length) && r.uploadCentroid(e1);
        }
        const iA = [
            1,
            0,
            0
        ], rA = [
            0,
            1,
            0
        ], nA = [
            0,
            0,
            1
        ];
        function oA(e1, t, i) {
            const r = i.transform, n = i.shadowRenderer;
            if (!n) return !0;
            const o = e1.toUnwrapped(), s = r.tileSize * n._cascades[i.currentShadowCascade].scale;
            let a = t.maxHeight;
            if (r.elevation) {
                const t = r.elevation.getMinMaxForTile(e1);
                t && (a += t.max);
            }
            const l = [
                ...n.shadowDirection
            ];
            l[2] = -l[2];
            const c = n.computeSimplifiedTileShadowVolume(o, a, s, l);
            if (!c) return !1;
            const h = [
                iA,
                rA,
                nA,
                l,
                [
                    l[0],
                    0,
                    l[2]
                ],
                [
                    0,
                    l[1],
                    l[2]
                ]
            ], u = "globe" === r.projection.name, d = r.scaleZoom(s), p = Qu.fromInvProjectionMatrix(r.invProjMatrix, r.worldSize, d, !u), f = n.getCurrentCascadeFrustum();
            return 0 === p.intersectsPrecise(c.vertices, c.planes, h) || 0 === f.intersectsPrecise(c.vertices, c.planes, h);
        }
        function sA(e1) {
            const t = e1._nearZ, i = e1.projection.farthestPixelDistance(e1), r = i - t, n = .2 * e1.height, o = t + n;
            return [
                t,
                i,
                (o - n - t) / r,
                (o - t) / r
            ];
        }
        const aA = new hi(1, 0, 0, 1), lA = new hi(0, 1, 0, 1), cA = new hi(0, 0, 1, 1), hA = new hi(1, 0, 1, 1), uA = new hi(0, 1, 1, 1);
        function dA(e1, t, i) {
            const r = e1.context, n = e1.transform, o = r.gl, s = "globe" === n.projection.name, a = s ? [
                "PROJECTION_GLOBE_VIEW"
            ] : [];
            let l = i.projMatrix;
            if (s && Dd(n.zoom) > 0) {
                const e1 = Sd(_d(i.canonical, n));
                l = Au.multiply(new Float32Array(16), n.globeMatrix, e1), Au.multiply(l, n.projMatrix, l);
            }
            const c = e1.getOrCreateProgram("debug", {
                defines: a
            }), h = t.getTileByID(i.key);
            e1.terrain && e1.terrain.setupElevationDraw(h, c);
            const u = Mx.disabled, d = Sx.disabled, p = e1.colorModeForRenderPass(), f = "$debug";
            r.activeTexture.set(o.TEXTURE0), e1.emptyTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE), s ? h._makeGlobeTileDebugBuffers(e1.context, n) : h._makeDebugTileBoundsBuffers(e1.context, n.projection);
            const m = h._tileDebugBuffer || e1.debugBuffer, _ = h._tileDebugIndexBuffer || e1.debugIndexBuffer, g = h._tileDebugSegments || e1.debugSegments;
            c.draw(e1, o.LINE_STRIP, u, d, p, Dx.disabled, AM(l, hi.red), f, m, _, g, null, null, null, [
                h._globeTileDebugBorderBuffer
            ]);
            const y = h.latestRawTileData, x = Math.floor((y && y.byteLength || 0) / 1024), v = t.getTile(i).tileSize, b = 512 / Math.min(v, 512) * (i.overscaledZ / n.zoom) * .5;
            let w = i.canonical.toString();
            i.overscaledZ !== i.canonical.z && (w += ` => ${i.overscaledZ}`), w += ` ${x}kb`, function(e1, t) {
                e1.initDebugOverlayCanvas();
                const i = e1.debugOverlayCanvas, r = e1.context.gl, n = e1.debugOverlayCanvas.getContext("2d");
                n.clearRect(0, 0, i.width, i.height), n.shadowColor = "white", n.shadowBlur = 2, n.lineWidth = 1.5, n.strokeStyle = "white", n.textBaseline = "top", n.font = "bold 36px Open Sans, sans-serif", n.fillText(t, 5, 5), n.strokeText(t, 5, 5), e1.debugOverlayTexture.update(i), e1.debugOverlayTexture.bind(r.LINEAR, r.CLAMP_TO_EDGE);
            }(e1, w);
            const T = h._tileDebugTextBuffer || e1.debugBuffer, E = h._tileDebugTextIndexBuffer || e1.quadTriangleIndexBuffer, M = h._tileDebugTextSegments || e1.debugSegments;
            c.draw(e1, o.TRIANGLES, u, d, Cx.alphaBlended, Dx.disabled, AM(l, hi.transparent, b), f, T, E, M, null, null, null, [
                h._globeTileDebugTextBuffer
            ]);
        }
        function pA(e1, t, i, r) {
            mA(e1, 0, t + i / 2, e1.transform.width, i, r);
        }
        function fA(e1, t, i, r) {
            mA(e1, t - i / 2, 0, i, e1.transform.height, r);
        }
        function mA(e1, t, i, r, n, o) {
            const s = e1.context, a = s.gl;
            a.enable(a.SCISSOR_TEST), a.scissor(t * dt.devicePixelRatio, i * dt.devicePixelRatio, r * dt.devicePixelRatio, n * dt.devicePixelRatio), s.clear({
                color: o
            }), a.disable(a.SCISSOR_TEST);
        }
        const _A = Ia([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: gA } = _A;
        function yA(e1, t, i, r) {
            e1.emplaceBack(t, i, r);
        }
        class xA {
            constructor(e1){
                this.vertexArray = new tl, this.indices = new Wa, yA(this.vertexArray, -1, -1, 1), yA(this.vertexArray, 1, -1, 1), yA(this.vertexArray, -1, 1, 1), yA(this.vertexArray, 1, 1, 1), yA(this.vertexArray, -1, -1, -1), yA(this.vertexArray, 1, -1, -1), yA(this.vertexArray, -1, 1, -1), yA(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = e1.createVertexBuffer(this.vertexArray, gA), this.indexBuffer = e1.createIndexBuffer(this.indices), this.segment = xl.simpleSegment(0, 0, 36, 12);
            }
        }
        function vA(e1, t, i, r, n, o) {
            const s = e1.context.gl, a = t.paint.get("sky-atmosphere-color"), l = t.paint.get("sky-atmosphere-halo-color"), c = t.paint.get("sky-atmosphere-sun-intensity"), h = ((e1, t, i, r, n)=>({
                    u_matrix_3f: e1,
                    u_sun_direction: t,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        r.r,
                        r.g,
                        r.b,
                        r.a
                    ],
                    u_color_tint_m: [
                        n.r,
                        n.g,
                        n.b,
                        n.a
                    ],
                    u_luminance: 5e-5
                }))(Eu.fromMat4(Eu.create(), r), n, c, a, l);
            s.framebufferTexture2D(s.FRAMEBUFFER, s.COLOR_ATTACHMENT0, s.TEXTURE_CUBE_MAP_POSITIVE_X + o, t.skyboxTexture, 0), i.draw(e1, s.TRIANGLES, Mx.disabled, Sx.disabled, Cx.unblended, Dx.frontCW, h, "skyboxCapture", t.skyboxGeometry.vertexBuffer, t.skyboxGeometry.indexBuffer, t.skyboxGeometry.segment);
        }
        const bA = Ia([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class wA {
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
            constructor(e1){
                const t = new Ka;
                t.emplaceBack(-1, 1, 1, 0, 0), t.emplaceBack(1, 1, 1, 1, 0), t.emplaceBack(1, -1, 1, 1, 1), t.emplaceBack(-1, -1, 1, 0, 1);
                const i = new Wa;
                i.emplaceBack(0, 1, 2), i.emplaceBack(2, 3, 0), this.vertexBuffer = e1.createVertexBuffer(t, bA.members), this.indexBuffer = e1.createIndexBuffer(i), this.segments = xl.simpleSegment(0, 0, 4, 2);
            }
        }
        const TA = Ia([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_size_scale",
                components: 1
            },
            {
                type: "Float32",
                name: "a_fade_opacity",
                components: 1
            }
        ]);
        class EA {
            update(e1) {
                const t = e1.context;
                if (!this.atmosphereBuffer) {
                    this.atmosphereBuffer = new wA(t);
                    const e1 = 100, i = 200, r = function(e1) {
                        const t = Xn(30), i = [];
                        for(let e1 = 0; e1 < 16e3; ++e1){
                            const e1 = 2 * Math.PI * t(), r = Math.acos(1 - 2 * t()) - .5 * Math.PI;
                            i.push(Du.fromValues(Math.cos(r) * Math.cos(e1), Math.cos(r) * Math.sin(e1), Math.sin(r)));
                        }
                        return i;
                    }(), n = Xn(300), o = new Ja, s = new Wa;
                    let a = 0;
                    for(let t = 0; t < r.length; ++t){
                        const l = Du.scale([], r[t], 200), c = Math.max(0, 1 + .01 * e1 * (1 * n() - .5)), h = Math.max(0, 1 + .01 * i * (1 * n() - .5));
                        o.emplaceBack(l[0], l[1], l[2], -1, -1, c, h), o.emplaceBack(l[0], l[1], l[2], 1, -1, c, h), o.emplaceBack(l[0], l[1], l[2], 1, 1, c, h), o.emplaceBack(l[0], l[1], l[2], -1, 1, c, h), s.emplaceBack(a + 0, a + 1, a + 2), s.emplaceBack(a + 0, a + 2, a + 3), a += 4;
                    }
                    this.starsVx = t.createVertexBuffer(o, TA.members), this.starsIdx = t.createIndexBuffer(s), this.starsSegments = xl.simpleSegment(0, 0, o.length, s.length);
                }
            }
            destroy() {
                this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
            }
            drawAtmosphereGlow(e1, t) {
                const i = e1.context, r = i.gl, n = e1.transform, o = new Mx(r.LEQUAL, Mx.ReadOnly, [
                    0,
                    1
                ]), s = Dd(n.zoom), a = t.properties.get("color").toArray01(), l = t.properties.get("high-color").toArray01(), c = t.properties.get("space-color").toArray01PremultipliedAlpha(), h = 5e-4, u = z((t.properties.get("horizon-blend") - 0) / 1 * .2495 + h, 5e-4, .25), d = Ld(e1, i, n) && u === h ? n.worldSize / (2 * Math.PI * 1.025) - 1 : n.globeRadius, p = e1.frameCounter / 1e3 % 1, f = Du.length(n.globeCenterInViewSpace), m = Math.sqrt(Math.pow(f, 2) - Math.pow(d, 2)), _ = Math.acos(m / f), g = (t)=>{
                    const h = "globe" === n.projection.name ? [
                        "PROJECTION_GLOBE_VIEW",
                        "FOG"
                    ] : [
                        "FOG"
                    ];
                    t && h.push("ALPHA_PASS");
                    const d = e1.getOrCreateProgram("globeAtmosphere", {
                        defines: h
                    }), f = ((e1, t, i, r, n, o, s, a, l, c, h, u)=>({
                            u_frustum_tl: e1,
                            u_frustum_tr: t,
                            u_frustum_br: i,
                            u_frustum_bl: r,
                            u_horizon: n,
                            u_transition: o,
                            u_fadeout_range: s,
                            u_color: a,
                            u_high_color: l,
                            u_space_color: c,
                            u_temporal_offset: h,
                            u_horizon_angle: u
                        }))(n.frustumCorners.TL, n.frustumCorners.TR, n.frustumCorners.BR, n.frustumCorners.BL, n.frustumCorners.horizon, s, u, a, l, c, p, _);
                    e1.uploadCommonUniforms(i, d);
                    const m = this.atmosphereBuffer;
                    m && d.draw(e1, r.TRIANGLES, o, Sx.disabled, t ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, Dx.backCW, f, t ? "atmosphere_glow_alpha" : "atmosphere_glow", m.vertexBuffer, m.indexBuffer, m.segments);
                };
                g(!1), g(!0);
            }
            drawStars(e1, t) {
                const i = z(t.properties.get("star-intensity"), 0, 1);
                if (0 === i) return;
                const r = e1.context, n = r.gl, o = e1.transform, s = e1.getOrCreateProgram("stars"), a = Iu.identity([]);
                Iu.rotateX(a, a, -o._pitch), Iu.rotateZ(a, a, -o.angle), Iu.rotateX(a, a, w(o._center.lat)), Iu.rotateY(a, a, -w(o._center.lng));
                const l = Au.fromQuat(new Float32Array(16), a), c = Au.multiply([], o.starsProjMatrix, l), h = Eu.fromMat4([], l), u = Eu.invert([], h), d = [
                    0,
                    1,
                    0
                ];
                Du.transformMat3(d, d, u), Du.scale(d, d, .15);
                const p = [
                    1,
                    0,
                    0
                ];
                Du.transformMat3(p, p, u), Du.scale(p, p, .15);
                const f = ((e1, t, i, r)=>({
                        u_matrix: Float32Array.from(e1),
                        u_up: t,
                        u_right: i,
                        u_intensity_multiplier: r
                    }))(c, d, p, i);
                e1.uploadCommonUniforms(r, s), this.starsVx && this.starsIdx && s.draw(e1, n.TRIANGLES, Mx.disabled, Sx.disabled, this.colorModeAlphaBlendedWriteRGB, Dx.disabled, f, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
            }
            constructor(){
                this.colorModeAlphaBlendedWriteRGB = new Cx([
                    1,
                    Ix,
                    1,
                    Ix
                ], hi.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ]), this.colorModeWriteAlpha = new Cx([
                    1,
                    0,
                    1,
                    0
                ], hi.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ]);
            }
        }
        function MA(e1, t) {
            const i = [
                ...e1
            ], r = t.cameraWorldSizeForFog / t.worldSize, n = Au.identity([]);
            return Au.scale(n, n, [
                r,
                r,
                1
            ]), Au.multiply(i, n, i), Au.multiply(i, t.worldToFogMatrix, i), i;
        }
        function AA(e1, t, i, r) {
            const n = i.material, o = r.context, { baseColorTexture: s, metallicRoughnessTexture: a } = n.pbrMetallicRoughness, { normalTexture: l, occlusionTexture: c, emissionTexture: h } = n;
            function u(t, i, r) {
                if (t && (e1.push(i), o.activeTexture.set(o.gl.TEXTURE0 + r), t.gfxTexture)) {
                    const { minFilter: e1, magFilter: i, wrapS: r, wrapT: n } = t.sampler;
                    t.gfxTexture.bindExtraParam(e1, i, r, n);
                }
            }
            u(s, "HAS_TEXTURE_u_baseColorTexture", NM.BaseColor), u(a, "HAS_TEXTURE_u_metallicRoughnessTexture", NM.MetallicRoughness), u(l, "HAS_TEXTURE_u_normalTexture", NM.Normal), u(c, "HAS_TEXTURE_u_occlusionTexture", NM.Occlusion), u(h, "HAS_TEXTURE_u_emissionTexture", NM.Emission), i.texcoordBuffer && (e1.push("HAS_ATTRIBUTE_a_uv_2f"), t.push(i.texcoordBuffer)), i.colorBuffer && (e1.push(12 === i.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), t.push(i.colorBuffer)), i.normalBuffer && (e1.push("HAS_ATTRIBUTE_a_normal_3f"), t.push(i.normalBuffer)), i.pbrBuffer && (e1.push("HAS_ATTRIBUTE_a_pbr"), e1.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), t.push(i.pbrBuffer)), "OPAQUE" !== n.alphaMode && "MASK" !== n.alphaMode || e1.push("UNPREMULT_TEXTURE_IN_SHADER"), n.defined || e1.push("DIFFUSE_SHADED"), e1.push("USE_STANDARD_DERIVATIVES");
        }
        function SA(e1, t, i, r, n, o) {
            const s = i.paint.get("model-opacity"), a = t.context, l = new Mx(t.context.gl.LEQUAL, Mx.ReadWrite, t.depthRangeFor3D), c = t.transform, h = e1.mesh, u = h.material, d = u.pbrMetallicRoughness, p = t.style.fog;
            let f;
            f = "pixels" === t.transform.projection.zAxisUnit ? [
                ...e1.nodeModelMatrix
            ] : Au.multiply([], r.zScaleMatrix, e1.nodeModelMatrix), Au.multiply(f, r.negCameraPosMatrix, f);
            const m = Au.invert([], f);
            Au.transpose(m, m);
            const _ = i.paint.get("model-emissive-strength").constantOr(0), g = UM(new Float32Array(e1.worldViewProjection), new Float32Array(f), new Float32Array(m), t, s, d.baseColorFactor, u.emissiveFactor, d.metallicFactor, d.roughnessFactor, u, _, i), y = {
                defines: []
            }, x = [];
            AA(y.defines, x, h, t);
            const v = t.shadowRenderer;
            v && (v.useNormalOffset = !1);
            let b = null;
            if (p) {
                const i = MA(e1.nodeModelMatrix, t.transform);
                if (b = new Float32Array(i), "globe" !== c.projection.name) {
                    const e1 = h.aabb.min, t = h.aabb.max, [r, n] = p.getOpacityForBounds(i, e1[0], e1[1], t[0], t[1]);
                    y.overrideFog = r >= fw || n >= fw;
                }
            }
            const w = eM(t, i.paint.get("model-cutoff-fade-range"));
            w.shouldRenderCutoff && y.defines.push("RENDER_CUTOFF");
            const T = t.getOrCreateProgram("model", y);
            t.uploadCommonUniforms(a, T, null, b, w), "shadow" !== t.renderPass && v && v.setupShadowsFromMatrix(e1.nodeModelMatrix, T), T.draw(t, a.gl.TRIANGLES, l, n, o, h.material.doubleSided ? Dx.disabled : Dx.backCCW, g, i.id, h.vertexBuffer, h.indexBuffer, h.segments, i.paint, t.transform.zoom, void 0, x);
        }
        function IA(e1, t, i, r, n, o, s) {
            let a;
            a = "globe" === e1.projection.name ? Av(i, e1) : [
                ...i
            ], Au.multiply(a, a, t.matrix);
            const l = Au.multiply([], r, a);
            if (t.meshes) for (const e1 of t.meshes){
                if ("BLEND" !== e1.material.alphaMode) {
                    s.push({
                        mesh: e1,
                        depth: 0,
                        modelIndex: n,
                        worldViewProjection: l,
                        nodeModelMatrix: a
                    });
                    continue;
                }
                const t = Du.transformMat4([], e1.centroid, l);
                t[2] > 0 && o.push({
                    mesh: e1,
                    depth: t[2],
                    modelIndex: n,
                    worldViewProjection: l,
                    nodeModelMatrix: a
                });
            }
            if (t.children) for (const a of t.children)IA(e1, a, i, r, n, o, s);
        }
        function CA(e1, t, i, r) {
            const n = i.shadowRenderer;
            if (!n) return;
            const o = n.getShadowPassDepthMode(), s = n.getShadowPassColorMode(), a = n.calculateShadowPassMatrixFromMatrix(t), l = jM(a);
            i.getOrCreateProgram("modelDepth", {
                defines: [
                    "DEPTH_TEXTURE"
                ]
            }).draw(i, i.context.gl.TRIANGLES, o, Sx.disabled, s, Dx.backCCW, l, r.id, e1.vertexBuffer, e1.indexBuffer, e1.segments, r.paint, i.transform.zoom, void 0, void 0);
        }
        function zA(e1, t, i) {
            const r = t.updateZoomBasedPaintProperties(), n = function(e1, t, i) {
                let r, n, o, s = e1.terrain ? e1.terrain.exaggeration() : 0;
                if (e1.terrain && s > 0) {
                    const t = e1.terrain, n = t.findDEMTileFor(i);
                    n && n.dem ? r = Jm.create(t, i, n) : s = 0;
                }
                if (0 === s && (t.terrainElevationMin = 0, t.terrainElevationMax = 0), s === t.validForExaggeration && (0 === s || r && r._demTile && r._demTile.tileID === t.validForDEMTile.id && r._dem._timestamp === t.validForDEMTile.timestamp)) return !1;
                for(const e1 in t.instancesPerModel){
                    const i = t.instancesPerModel[e1];
                    for(let e1 = 0; e1 < i.instancedDataArray.length; ++e1){
                        const a = (r ? s * r.getElevationAt(0 | i.instancedDataArray.float32[16 * e1], 0 | i.instancedDataArray.float32[16 * e1 + 1], !0, !0) : 0) + i.instancesEvaluatedElevation[e1];
                        i.instancedDataArray.float32[16 * e1 + 6] = a, n = n ? Math.min(t.terrainElevationMin, a) : a, o = o ? Math.max(t.terrainElevationMax, a) : a;
                    }
                }
                return t.terrainElevationMin = n || 0, t.terrainElevationMax = o || 0, t.validForExaggeration = s, t.validForDEMTile = r && r._demTile ? {
                    id: r._demTile.tileID,
                    timestamp: r._dem._timestamp
                } : {
                    id: void 0,
                    timestamp: 0
                }, !0;
            }(e1, t, i);
            (r || n) && (t.uploaded = !1, t.upload(e1.context));
        }
        const PA = {
            shadowUniformsInitialized: !1,
            useSingleShadowCascade: !1,
            tileMatrix: new Float64Array(16),
            shadowTileMatrix: new Float32Array(16),
            aabb: new ed([
                0,
                0,
                0
            ], [
                cr,
                cr,
                0
            ])
        };
        function DA(e1, t) {
            const i = 1 << e1.canonical.z, r = t.getFreeCameraOptions().position, n = t.elevation, o = e1.canonical.x / i, s = (e1.canonical.x + 1) / i, a = e1.canonical.y / i, l = (e1.canonical.y + 1) / i;
            let c = t._centerAltitude;
            if (n) {
                const t = n.getMinMaxForTile(e1);
                t && t.max > c && (c = t.max);
            }
            const h = z(r.x, o, s) - r.x, u = z(r.y, a, l) - r.y, d = Qd(c, t.center.lat) - r.z;
            return t._zoomFromMercatorZ(Math.sqrt(h * h + u * u + d * d));
        }
        function RA(e1, t, i, r, n, o, s) {
            const a = e1.context, l = "shadow" === e1.renderPass, c = e1.shadowRenderer, h = l && c ? c.getShadowPassDepthMode() : new Mx(a.gl.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D), u = e1.isTileAffectedByFog(o);
            if (i.meshes) for (const d of i.meshes){
                const p = [
                    "MODEL_POSITION_ON_GPU"
                ], f = [];
                let m, _, g;
                r.instancedDataArray.length > 20 && p.push("INSTANCED_ARRAYS");
                const y = eM(e1, t.paint.get("model-cutoff-fade-range"));
                if (y.shouldRenderCutoff && p.push("RENDER_CUTOFF"), l && c) m = e1.getOrCreateProgram("modelDepth", {
                    defines: p
                }), _ = jM(s.shadowTileMatrix, s.shadowTileMatrix, Float32Array.from(i.matrix)), g = c.getShadowPassColorMode();
                else {
                    AA(p, f, d, e1), m = e1.getOrCreateProgram("model", {
                        defines: p,
                        overrideFog: u
                    });
                    const r = d.material, l = r.pbrMetallicRoughness, h = t.paint.get("model-opacity"), x = t.paint.get("model-emissive-strength").constantOr(0);
                    _ = UM(o.expandedProjMatrix, Float32Array.from(i.matrix), new Float32Array(16), e1, h, l.baseColorFactor, r.emissiveFactor, l.metallicFactor, l.roughnessFactor, r, x, t, n), c && (s.shadowUniformsInitialized ? m.setShadowUniformValues(a, c.getShadowUniformValues()) : (c.setupShadows(o.toUnwrapped(), m, "model-tile", o.overscaledZ), s.shadowUniformsInitialized = !0)), g = y.shouldRenderCutoff || h < 1 || "OPAQUE" !== r.alphaMode ? Cx.alphaBlended : Cx.unblended;
                }
                e1.uploadCommonUniforms(a, m, o.toUnwrapped(), null, y);
                const x = d.material.doubleSided ? Dx.disabled : Dx.backCCW;
                if (r.instancedDataArray.length > 20) f.push(r.instancedDataBuffer), m.draw(e1, a.gl.TRIANGLES, h, Sx.disabled, g, x, _, t.id, d.vertexBuffer, d.indexBuffer, d.segments, t.paint, e1.transform.zoom, void 0, f, r.instancedDataArray.length);
                else {
                    const i = l ? "u_instance" : "u_normal_matrix";
                    for(let n = 0; n < r.instancedDataArray.length; ++n)_[i] = new Float32Array(r.instancedDataArray.arrayBuffer, 64 * n, 16), m.draw(e1, a.gl.TRIANGLES, h, Sx.disabled, g, x, _, t.id, d.vertexBuffer, d.indexBuffer, d.segments, t.paint, e1.transform.zoom, void 0, f);
                }
            }
            if (i.children) for (const a of i.children)RA(e1, t, a, r, n, o, s);
        }
        const LA = [
            1,
            -1,
            1
        ];
        function kA(e1, t, i, r) {
            if (!i.modelManager) return !0;
            const n = i.modelManager;
            if (!i.shadowRenderer) return !0;
            const o = i.shadowRenderer, s = t.aabb;
            let a = !0, l = e1.maxHeight;
            if (0 === l) {
                let t = 0;
                for(const i in e1.instancesPerModel){
                    const e1 = n.getModel(i, r);
                    e1 ? t = Math.max(t, Math.max(Math.max(e1.aabb.max[0], e1.aabb.max[1]), e1.aabb.max[2])) : a = !1;
                }
                l = e1.maxScale * t * 1.41 + e1.maxVerticalOffset, a && (e1.maxHeight = l);
            }
            s.max[2] = l, s.min[2] += e1.terrainElevationMin, s.max[2] += e1.terrainElevationMax, Du.transformMat4(s.min, s.min, t.tileMatrix), Du.transformMat4(s.max, s.max, t.tileMatrix);
            const c = s.intersects(o.getCurrentCascadeFrustum());
            return 0 === i.currentShadowCascade && (e1.isInsideFirstShadowMapFrustum = 2 === c), 0 === c;
        }
        class OA {
        }
        class BA {
            getLinesFromTrianglesBuffer(e1, t, i) {
                {
                    const i = this._storage.get(t.id);
                    if (i) return i.lastUsedFrameIdx = e1, i.buf;
                }
                const r = i.gl, n = r.getBufferParameter(r.ELEMENT_ARRAY_BUFFER, r.BUFFER_SIZE), o = new ArrayBuffer(n), s = new Int16Array(o);
                r.getBufferSubData(r.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(o));
                const a = new ja;
                for(let e1 = 0; e1 < n / 2; e1 += 3){
                    const t = s[e1], i = s[e1 + 1], r = s[e1 + 2];
                    a.emplaceBack(t, i), a.emplaceBack(i, r), a.emplaceBack(r, t);
                }
                const l = i.bindVertexArrayOES.current, c = new OA;
                return c.buf = new Fy(i, a), c.lastUsedFrameIdx = e1, this._storage.set(t.id, c), i.bindVertexArrayOES.set(l), c.buf;
            }
            update(e1) {
                for (const [t, i] of this._storage)e1 - i.lastUsedFrameIdx > 30 && (i.buf.destroy(), this._storage.delete(t));
            }
            destroy() {
                for (const [e1, t] of this._storage)t.buf.destroy(), this._storage.delete(e1);
            }
            constructor(){
                this._storage = new Map;
            }
        }
        const FA = {
            symbol: function(e1, t, i, r, n) {
                if ("translucent" !== e1.renderPass) return;
                const o = Sx.disabled, s = e1.colorModeForRenderPass();
                i.layout.get("text-variable-anchor") && function(e1, t, i, r, n, o, s) {
                    const a = t.transform, l = "map" === n, c = "map" === o;
                    for (const t of e1){
                        const e1 = r.getTile(t), n = e1.getBucket(i);
                        if (!n || !n.text || !n.text.segments.get().length) continue;
                        const o = m_(n.textSizeData, a.zoom), h = YT(t, n.getProjection(), a), u = a.calculatePixelsToTileUnitsMatrix(e1), d = sv(h, e1.tileID.canonical, c, l, a, n.getProjection(), u), p = n.hasIconTextFit() && n.hasIconData();
                        if (o) {
                            const i = Math.pow(2, a.zoom - e1.tileID.overscaledZ);
                            HM(n, l, c, s, __, a, d, t, i, o, p);
                        }
                    }
                }(r, e1, i, t, i.layout.get("text-rotation-alignment"), i.layout.get("text-pitch-alignment"), n), 0 !== i.paint.get("icon-opacity").constantOr(1) && YM(e1, t, i, r, !1, i.paint.get("icon-translate"), i.paint.get("icon-translate-anchor"), i.layout.get("icon-rotation-alignment"), i.layout.get("icon-pitch-alignment"), i.layout.get("icon-keep-upright"), i.paint.get("icon-color-saturation"), o, s), 0 !== i.paint.get("text-opacity").constantOr(1) && YM(e1, t, i, r, !0, i.paint.get("text-translate"), i.paint.get("text-translate-anchor"), i.layout.get("text-rotation-alignment"), i.layout.get("text-pitch-alignment"), i.layout.get("text-keep-upright"), i.paint.get("icon-color-saturation"), o, s), t.map.showCollisionBoxes && (ZM(e1, t, i, r, i.paint.get("text-translate"), i.paint.get("text-translate-anchor"), !0), ZM(e1, t, i, r, i.paint.get("icon-translate"), i.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(e1, t, i, r) {
                if ("translucent" !== e1.renderPass) return;
                const n = i.paint.get("circle-opacity"), o = i.paint.get("circle-stroke-width"), s = i.paint.get("circle-stroke-opacity"), a = void 0 !== i.layout.get("circle-sort-key").constantOr(1), l = i.paint.get("circle-emissive-strength");
                if (0 === n.constantOr(1) && (0 === o.constantOr(1) || 0 === s.constantOr(1))) return;
                const c = e1.context, h = c.gl, u = e1.transform, d = e1.depthModeForSublayer(0, Mx.ReadOnly), p = Sx.disabled, f = e1.colorModeForDrapableLayerRenderPass(l), m = "globe" === u.projection.name, _ = [
                    Kd(u.center.lng),
                    Jd(u.center.lat)
                ], g = [];
                for(let n = 0; n < r.length; n++){
                    const o = r[n], s = t.getTile(o), l = s.getBucket(i);
                    if (!l || l.projection.name !== u.projection.name) continue;
                    const c = l.programConfigurations.get(i.id), h = Gp(i), d = e1.isTileAffectedByFog(o);
                    m && h.push("PROJECTION_GLOBE_VIEW");
                    const p = e1.getOrCreateProgram("circle", {
                        config: c,
                        defines: h,
                        overrideFog: d
                    }), f = l.layoutVertexBuffer, y = l.globeExtVertexBuffer, x = l.indexBuffer, v = u.projection.createInversionMatrix(u, o.canonical), b = {
                        programConfiguration: c,
                        program: p,
                        layoutVertexBuffer: f,
                        globeExtVertexBuffer: y,
                        indexBuffer: x,
                        uniformValues: jp(e1, o, s, v, _, i),
                        tile: s
                    };
                    if (a) {
                        const e1 = l.segments.get();
                        for (const t of e1)g.push({
                            segments: new xl([
                                t
                            ]),
                            sortKey: t.sortKey,
                            state: b
                        });
                    } else g.push({
                        segments: l.segments,
                        sortKey: 0,
                        state: b
                    });
                }
                a && g.sort((e1, t)=>e1.sortKey - t.sortKey);
                const y = {
                    useDepthForOcclusion: u.depthOcclusionForSymbolsAndCircles
                };
                for (const t of g){
                    const { programConfiguration: r, program: n, layoutVertexBuffer: o, globeExtVertexBuffer: s, indexBuffer: a, uniformValues: l, tile: m } = t.state, _ = t.segments;
                    e1.terrain && e1.terrain.setupElevationDraw(m, n, y), e1.uploadCommonUniforms(c, n, m.tileID.toUnwrapped()), n.draw(e1, h.TRIANGLES, d, p, f, Dx.disabled, l, i.id, o, a, _, i.paint, u.zoom, r, [
                        s
                    ]);
                }
            },
            heatmap: function(e1, t, i, r) {
                if (0 !== i.paint.get("heatmap-opacity")) {
                    if ("offscreen" === e1.renderPass) {
                        const n = e1.context, o = n.gl, s = Sx.disabled, a = new Cx([
                            o.ONE,
                            o.ONE,
                            o.ONE,
                            o.ONE
                        ], hi.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        !function(e1, t, i, r) {
                            const n = e1.gl, o = t.width * r, s = t.height * r;
                            e1.activeTexture.set(n.TEXTURE1), e1.viewport.set([
                                0,
                                0,
                                o,
                                s
                            ]);
                            let a = i.heatmapFbo;
                            if (!a || a && (a.width !== o || a.height !== s)) {
                                a && a.destroy();
                                const t = n.createTexture();
                                n.bindTexture(n.TEXTURE_2D, t), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, n.CLAMP_TO_EDGE), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, n.LINEAR), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, n.LINEAR), a = i.heatmapFbo = e1.createFramebuffer(o, s, !0, null), function(e1, t, i, r, n, o) {
                                    const s = e1.gl;
                                    s.texImage2D(s.TEXTURE_2D, 0, e1.extRenderToTextureHalfFloat ? s.RGBA16F : s.RGBA, n, o, 0, s.RGBA, e1.extRenderToTextureHalfFloat ? s.HALF_FLOAT : s.UNSIGNED_BYTE, null), r.colorAttachment.set(i);
                                }(e1, 0, t, a, o, s);
                            } else n.bindTexture(n.TEXTURE_2D, a.colorAttachment.get()), e1.bindFramebuffer.set(a.framebuffer);
                        }(n, e1, i, "globe" === e1.transform.projection.name ? .5 : .25), n.clear({
                            color: hi.transparent
                        });
                        const l = e1.transform, c = "globe" === l.projection.name, h = c ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : [], u = c ? Dx.frontCCW : Dx.disabled, d = [
                            Kd(l.center.lng),
                            Jd(l.center.lat)
                        ];
                        for(let p = 0; p < r.length; p++){
                            const f = r[p];
                            if (t.hasRenderableParent(f)) continue;
                            const m = t.getTile(f), _ = m.getBucket(i);
                            if (!_ || _.projection.name !== l.projection.name) continue;
                            const g = e1.isTileAffectedByFog(f), y = _.programConfigurations.get(i.id), x = e1.getOrCreateProgram("heatmap", {
                                config: y,
                                defines: h,
                                overrideFog: g
                            }), { zoom: v } = e1.transform;
                            e1.terrain && e1.terrain.setupElevationDraw(m, x), e1.uploadCommonUniforms(n, x, f.toUnwrapped());
                            const b = l.projection.createInversionMatrix(l, f.canonical);
                            x.draw(e1, o.TRIANGLES, Mx.disabled, s, a, u, IM(e1, f, m, b, d, v, i.paint.get("heatmap-intensity")), i.id, _.layoutVertexBuffer, _.indexBuffer, _.segments, i.paint, e1.transform.zoom, y, c ? [
                                _.globeExtVertexBuffer
                            ] : null);
                        }
                        n.viewport.set([
                            0,
                            0,
                            e1.width,
                            e1.height
                        ]);
                    } else "translucent" === e1.renderPass && (e1.context.setColorMode(e1.colorModeForRenderPass()), function(e1, t) {
                        const i = e1.context, r = i.gl, n = t.heatmapFbo;
                        if (!n) return;
                        i.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, n.colorAttachment.get()), i.activeTexture.set(r.TEXTURE1);
                        let o = t.colorRampTexture;
                        o || (o = t.colorRampTexture = new My(i, t.colorRamp, r.RGBA)), o.bind(r.LINEAR, r.CLAMP_TO_EDGE), e1.getOrCreateProgram("heatmapTexture").draw(e1, r.TRIANGLES, Mx.disabled, Sx.disabled, e1.colorModeForRenderPass(), Dx.disabled, ((e1, t, i, r)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t.paint.get("heatmap-opacity")
                            }))(0, t), t.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, t.paint, e1.transform.zoom);
                    }(e1, i));
                }
            },
            line: function(e1, t, i, r) {
                if ("translucent" !== e1.renderPass) return;
                const n = i.paint.get("line-opacity"), o = i.paint.get("line-width");
                if (0 === n.constantOr(1) || 0 === o.constantOr(1)) return;
                const s = i.paint.get("line-emissive-strength"), a = e1.depthModeForSublayer(0, Mx.ReadOnly), l = e1.colorModeForDrapableLayerRenderPass(s), c = e1.terrain && e1.terrain.renderingToTexture ? 1 : dt.devicePixelRatio, h = i.paint.get("line-dasharray"), u = h.constantOr(1), d = i.layout.get("line-cap"), p = i.paint.get("line-pattern"), f = p.constantOr(1), m = i.paint.get("line-pattern").constantOr(1), _ = 1 !== i.paint.get("line-opacity").constantOr(1);
                let g = !m && _;
                const y = i.paint.get("line-gradient"), x = f ? "linePattern" : "line", v = e1.context, b = v.gl, w = Gb(i);
                e1.terrain && e1.terrain.clipOrMaskOverlapStencilType() && (g = !1);
                for (const n of r){
                    const r = t.getTile(n);
                    if (f && !r.patternsLoaded()) continue;
                    const o = r.getBucket(i);
                    if (!o) continue;
                    e1.prepareDrawTile();
                    const s = o.programConfigurations.get(i.id), m = e1.isTileAffectedByFog(n), _ = e1.getOrCreateProgram(x, {
                        config: s,
                        defines: w,
                        overrideFog: m
                    }), T = p.constantOr(null);
                    if (T && r.imageAtlas) {
                        const e1 = r.imageAtlas.patternPositions[T.toString()];
                        e1 && s.setConstantPatternPositions(e1);
                    }
                    const E = h.constantOr(null), M = d.constantOr(null);
                    if (!f && E && M && r.lineAtlas) {
                        const e1 = r.lineAtlas.getDash(E, M);
                        e1 && s.setConstantPatternPositions(e1);
                    }
                    let [A, S] = i.paint.get("line-trim-offset");
                    if ("round" === M || "square" === M) {
                        const e1 = 1;
                        A !== S && (0 === A && (A -= e1), 1 === S && (S += e1));
                    }
                    const I = e1.terrain ? n.projMatrix : null, C = f ? Ub(e1, r, i, I, c) : Nb(e1, r, i, I, o.lineClipsArray.length, c, [
                        A,
                        S
                    ]);
                    if (y) {
                        const r = o.gradients[i.id];
                        let s = r.texture;
                        if (i.gradientVersion !== r.version) {
                            let a = 256;
                            if (i.stepInterpolant) {
                                const i = t.getSource().maxzoom, r = n.canonical.z === i ? Math.ceil(1 << e1.transform.maxZoom - n.canonical.z) : 1;
                                a = z(U(o.maxLineLength / cr * 1024 * r), 256, v.maxTextureSize);
                            }
                            r.gradient = of({
                                expression: i.gradientExpression(),
                                evaluationKey: "lineProgress",
                                resolution: a,
                                image: r.gradient || void 0,
                                clips: o.lineClipsArray
                            }), r.texture ? r.texture.update(r.gradient) : r.texture = new My(v, r.gradient, b.RGBA), r.version = i.gradientVersion, s = r.texture;
                        }
                        v.activeTexture.set(b.TEXTURE1), s.bind(i.stepInterpolant ? b.NEAREST : b.LINEAR, b.CLAMP_TO_EDGE);
                    }
                    u && (v.activeTexture.set(b.TEXTURE0), r.lineAtlasTexture && r.lineAtlasTexture.bind(b.LINEAR, b.REPEAT), s.updatePaintBuffers()), f && (v.activeTexture.set(b.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(b.LINEAR, b.CLAMP_TO_EDGE), s.updatePaintBuffers()), e1.uploadCommonUniforms(v, _, n.toUnwrapped());
                    const P = (t)=>{
                        _.draw(e1, b.TRIANGLES, a, t, l, Dx.disabled, C, i.id, o.layoutVertexBuffer, o.indexBuffer, o.segments, i.paint, e1.transform.zoom, s, [
                            o.layoutVertexBuffer2
                        ]);
                    };
                    if (g) {
                        const t = e1.stencilModeForClipping(n).ref;
                        0 === t && e1.terrain && v.clear({
                            stencil: 0
                        });
                        const i = {
                            func: b.EQUAL,
                            mask: 255
                        };
                        C.u_alpha_discard_threshold = .8, P(new Sx(i, t, 255, b.KEEP, b.KEEP, b.INVERT)), C.u_alpha_discard_threshold = 0, P(new Sx(i, t, 255, b.KEEP, b.KEEP, b.KEEP));
                    } else P(e1.stencilModeForClipping(n));
                }
                g && (e1.resetStencilClippingMasks(), e1.terrain && v.clear({
                    stencil: 0
                }));
            },
            fill: function(e1, t, i, r) {
                const n = i.paint.get("fill-color"), o = i.paint.get("fill-opacity");
                if (0 === o.constantOr(1)) return;
                const s = i.paint.get("fill-emissive-strength"), a = e1.colorModeForDrapableLayerRenderPass(s), l = i.paint.get("fill-pattern"), c = e1.opaquePassEnabledForLayer() && !l.constantOr(1) && 1 === n.constantOr(hi.transparent).a && 1 === o.constantOr(0) ? "opaque" : "translucent";
                if (e1.renderPass === c) {
                    const n = e1.depthModeForSublayer(1, "opaque" === e1.renderPass ? Mx.ReadWrite : Mx.ReadOnly);
                    JM(e1, t, i, r, n, a, !1);
                }
                if ("translucent" === e1.renderPass && i.paint.get("fill-antialias")) {
                    const n = e1.depthModeForSublayer(i.getPaintProperty("fill-outline-color") ? 2 : 0, Mx.ReadOnly);
                    JM(e1, t, i, r, n, a, !0);
                }
            },
            "fill-extrusion": function(e1, t, i, r) {
                const n = i.paint.get("fill-extrusion-opacity"), o = e1.context, s = o.gl, a = e1.terrain, l = a && a.renderingToTexture, c = i.paint.get("fill-extrusion-cutoff-fade-range");
                if (0 === n) return;
                const h = e1.conflationActive && e1.layerUsedInConflation(i, t.getSource());
                if (h && function(e1, t, i, r) {
                    for (const n of r){
                        const r = t.getTile(n).getBucket(i);
                        r && (r.updateReplacement(n, e1.replacementSource), r.uploadCentroid(e1.context));
                    }
                }(e1, t, i, r), a || h) for (const n of r){
                    const r = t.getTile(n).getBucket(i);
                    r && tA(e1.context, t, n, r, i, a, h);
                }
                if ("shadow" === e1.renderPass && e1.shadowRenderer) {
                    const o = e1.shadowRenderer;
                    if (a && n < .65 && i._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof Ao) return;
                    const s = o.getShadowPassDepthMode(), l = o.getShadowPassColorMode();
                    QM(e1, t, i, r, s, Sx.disabled, l, h);
                } else if ("translucent" === e1.renderPass) {
                    const u = !i.paint.get("fill-extrusion-pattern").constantOr(1);
                    if (!l) {
                        const o = new Mx(e1.context.gl.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D);
                        0 === c && 1 === n && u ? QM(e1, t, i, r, o, Sx.disabled, Cx.unblended, h) : (QM(e1, t, i, r, o, Sx.disabled, Cx.disabled, h), QM(e1, t, i, r, o, e1.stencilModeFor3D(), e1.colorModeForRenderPass(), h), e1.resetStencilClippingMasks());
                    }
                    if (e1.style.enable3dLights() && u && (!a && "globe" !== e1.transform.projection.name || l)) {
                        const n = i.paint.get("fill-extrusion-opacity"), c = i.paint.get("fill-extrusion-ambient-occlusion-intensity"), u = i.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), d = i.paint.get("fill-extrusion-flood-light-intensity"), p = i.paint.get("fill-extrusion-flood-light-color").toArray01().slice(0, 3), f = c > 0 && u > 0, m = d > 0, _ = (e1, t, i)=>(1 - i) * e1 + i * t, g = (o)=>{
                            const a = e1.depthModeForSublayer(1, Mx.ReadOnly, s.LEQUAL, !0), l = i.paint.get(o ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), f = _(.1, 3, l), m = e1._showOverdrawInspector;
                            if (!m) {
                                const l = new Sx({
                                    func: s.ALWAYS,
                                    mask: 255
                                }, 255, 255, s.KEEP, s.KEEP, s.REPLACE), m = new Cx([
                                    s.ONE,
                                    s.ONE,
                                    s.ONE,
                                    s.ONE
                                ], hi.transparent, [
                                    !1,
                                    !1,
                                    !1,
                                    !0
                                ], s.MIN);
                                eA(e1, t, i, r, a, l, m, Dx.disabled, o, "sdf", n, c, u, d, p, f, h, !1);
                            }
                            {
                                const l = m ? Sx.disabled : new Sx({
                                    func: s.EQUAL,
                                    mask: 255
                                }, 255, 255, s.KEEP, s.DECR, s.DECR), _ = m ? e1.colorModeForRenderPass() : new Cx([
                                    s.ONE_MINUS_DST_ALPHA,
                                    s.DST_ALPHA,
                                    s.ONE,
                                    s.ONE
                                ], hi.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                eA(e1, t, i, r, a, l, _, Dx.disabled, o, "color", n, c, u, d, p, f, h, !1);
                            }
                        };
                        if (l) {
                            const l = (o, a, l)=>{
                                const f = e1.depthModeForSublayer(1, Mx.ReadOnly, s.LEQUAL, !1), m = i.paint.get(o ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), g = _(.1, 3, m);
                                {
                                    const l = new Cx([
                                        s.ONE,
                                        s.ONE,
                                        s.ONE,
                                        s.ONE
                                    ], hi.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ]);
                                    eA(e1, t, i, r, f, Sx.disabled, l, Dx.disabled, o, "clear", n, c, u, d, p, g, h, a);
                                }
                                {
                                    const l = new Sx({
                                        func: s.ALWAYS,
                                        mask: 255
                                    }, 255, 255, s.KEEP, s.KEEP, s.REPLACE), m = new Cx([
                                        s.ONE,
                                        s.ONE,
                                        s.ONE,
                                        s.ONE
                                    ], hi.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], s.MIN);
                                    eA(e1, t, i, r, f, l, m, Dx.disabled, o, "sdf", n, c, u, d, p, g, h, a);
                                }
                                {
                                    const l = o ? s.ZERO : s.ONE_MINUS_DST_ALPHA, m = new Sx({
                                        func: s.EQUAL,
                                        mask: 255
                                    }, 255, 255, s.KEEP, s.DECR, s.DECR), _ = new Cx([
                                        l,
                                        s.DST_ALPHA,
                                        s.ONE_MINUS_DST_ALPHA,
                                        s.ZERO
                                    ], hi.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    eA(e1, t, i, r, f, m, _, Dx.disabled, o, "color", n, c, u, d, p, g, h, a);
                                }
                                {
                                    const m = new Cx([
                                        s.ONE,
                                        s.ONE,
                                        s.ONE,
                                        o ? s.ZERO : s.ONE
                                    ], hi.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], o ? s.FUNC_ADD : s.MAX);
                                    eA(e1, t, i, r, f, Sx.disabled, m, Dx.disabled, o, "clear", n, c, u, d, p, g, h, a, l);
                                }
                            };
                            if (f || m) {
                                let t;
                                if (e1.prepareDrawTile(), a) {
                                    const e1 = a.drapeBufferSize[0], i = a.drapeBufferSize[1];
                                    t = a.framebufferCopyTexture, t && (!t || t.size[0] === e1 && t.size[1] === i) || (t && t.destroy(), t = a.framebufferCopyTexture = new My(o, new ef({
                                        width: e1,
                                        height: i
                                    }), s.RGBA)), t.bind(s.LINEAR, s.CLAMP_TO_EDGE), s.copyTexImage2D(s.TEXTURE_2D, 0, s.RGBA, 0, 0, e1, i, 0);
                                }
                                f && l(!0, !1, t), m && l(!1, !0, t);
                            }
                        } else f && g(!0), m && g(!1);
                    }
                }
            },
            hillshade: function(e1, t, i, r) {
                if ("offscreen" !== e1.renderPass && "translucent" !== e1.renderPass) return;
                if (e1.style.disableElevatedTerrain) return;
                const n = e1.context, o = e1.terrain && e1.terrain.renderingToTexture, [s, a] = "translucent" !== e1.renderPass || o ? [
                    {},
                    r
                ] : e1.stencilConfigForOverlap(r);
                for (const r of a){
                    const n = t.getTile(r);
                    if (n.needsHillshadePrepare && "offscreen" === e1.renderPass) YE(e1, n, i);
                    else if ("translucent" === e1.renderPass) {
                        const t = e1.depthModeForSublayer(0, Mx.ReadOnly), a = i.paint.get("hillshade-emissive-strength"), l = e1.colorModeForDrapableLayerRenderPass(a), c = o && e1.terrain ? e1.terrain.stencilModeForRTTOverlap(r) : s[r.overscaledZ];
                        HE(e1, r, n, i, t, c, l);
                    }
                }
                n.viewport.set([
                    0,
                    0,
                    e1.width,
                    e1.height
                ]), e1.resetStencilClippingMasks();
            },
            raster: function(e1, t, i, r, n, o) {
                if ("translucent" !== e1.renderPass) return;
                if (0 === i.paint.get("raster-opacity")) return;
                const s = e1.context, a = s.gl, l = t.getSource(), c = function(e1, t, i) {
                    const r = e1.paint.get("raster-color"), n = [], o = e1.paint.get("raster-resampling"), s = e1.paint.get("raster-color-mix"), a = e1.paint.get("raster-color-range"), l = [
                        s[0],
                        s[1],
                        s[2],
                        0
                    ], c = s[3], h = "nearest" === o ? i.NEAREST : i.LINEAR;
                    if (r && n.push("RASTER_COLOR"), r) {
                        t.activeTexture.set(i.TEXTURE2);
                        let r = e1.colorRampTexture;
                        r || (r = e1.colorRampTexture = new My(t, e1.colorRamp, i.RGBA)), r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                    }
                    return {
                        mix: l,
                        range: a,
                        offset: c,
                        defines: n,
                        resampling: h
                    };
                }(i, s, a), h = c.defines, u = "globe" === e1.transform.projection.name;
                let d = !1;
                if (l instanceof Jb && !r.length) {
                    if (!u) return;
                    if (l.onNorthPole) d = !0, h.push("GLOBE_POLES");
                    else {
                        if (!l.onSouthPole) return;
                        d = !0, h.push("GLOBE_POLES");
                    }
                }
                const p = i.paint.get("raster-emissive-strength"), f = e1.colorModeForDrapableLayerRenderPass(p), m = e1.terrain && e1.terrain.renderingToTexture, _ = l instanceof Jb && 0 !== i.paint.get("raster-elevation"), g = !e1.options.moving, y = "nearest" === i.paint.get("raster-resampling") ? a.NEAREST : a.LINEAR;
                if (d) {
                    const r = t.getSource();
                    if (!(r instanceof Jb)) return;
                    const n = r.texture;
                    if (!n) return;
                    const o = e1.globeSharedBuffers;
                    if (!o) return;
                    const l = new Mx(a.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D), h = Float32Array.from(e1.transform.expandedFarZProjMatrix);
                    let u = Rd(0, 0, e1.transform);
                    const d = Float32Array.from(Ad(fd(new ju(0, 0, 0)))), m = {
                        opacity: 1,
                        mix: 0
                    };
                    e1.terrain && e1.terrain.prepareDrawTile(), s.activeTexture.set(a.TEXTURE0), n.bind(y, a.CLAMP_TO_EDGE), s.activeTexture.set(a.TEXTURE1), n.bind(y, a.CLAMP_TO_EDGE), n.useMipmap && s.extTextureFilterAnisotropic && e1.transform.pitch > 20 && a.texParameterf(a.TEXTURE_2D, s.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, s.extTextureFilterAnisotropicMax);
                    const [_, g, x, v] = o.getPoleBuffers(0, !0);
                    let b;
                    r.onNorthPole ? (b = _, e1.renderDefaultNorthPole = !1) : (u = Au.scale(Au.create(), u, [
                        1,
                        -1,
                        1
                    ]), b = g, e1.renderDefaultSouthPole = !1);
                    const w = ((e1, t, i, r, n, o, s, a, l, c, h, u)=>CM(e1, t, i, new Float32Array(16), new Float32Array(9), [
                            0,
                            0
                        ], [
                            0,
                            0,
                            0,
                            0
                        ], 0, [
                            0,
                            0
                        ], [
                            0,
                            0,
                            0,
                            0
                        ], 1, r, n, o || [
                            0,
                            0
                        ], s, 2, l, c, h, 1, 0, u))(h, d, u, m, i, r.perspectiveTransform || [
                        0,
                        0
                    ], i.paint.get("raster-elevation"), 0, c.mix, c.offset, c.range, p), T = e1.getOrCreateProgram("raster", {
                        defines: c.defines
                    });
                    return e1.uploadCommonUniforms(s, T, null), void T.draw(e1, a.TRIANGLES, l, Sx.disabled, f, Dx.disabled, w, i.id, b, x, v);
                }
                if (!r.length) return;
                const [x, v] = l instanceof Jb || m ? [
                    {},
                    r
                ] : e1.stencilConfigForOverlap(r), b = v[v.length - 1].overscaledZ, w = _ && u;
                w && c.defines.push("PROJECTION_GLOBE_VIEW"), _ && c.defines.push("RENDER_CUTOFF");
                for (const r of v){
                    const n = r.toUnwrapped(), h = t.getTile(r);
                    if (m && (!h || !h.hasData())) continue;
                    if (!h.texture) continue;
                    let d, v;
                    m ? (d = Mx.disabled, v = r.projMatrix) : _ ? (d = new Mx(a.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D), v = u ? Float32Array.from(e1.transform.expandedFarZProjMatrix) : e1.transform.calculateProjMatrix(n, g)) : (d = e1.depthModeForSublayer(r.overscaledZ - b, 1 === i.paint.get("raster-opacity") ? Mx.ReadWrite : Mx.ReadOnly, a.LESS), v = e1.transform.calculateProjMatrix(n, g));
                    const T = e1.terrain && m ? e1.terrain.stencilModeForRTTOverlap(r) : x[r.overscaledZ], E = o ? 0 : i.paint.get("raster-fade-duration");
                    h.registerFadeDuration(E);
                    const M = t.findLoadedParent(r, 0), A = aM(h, M, t, e1.transform, E);
                    let S, I;
                    e1.terrain && e1.terrain.prepareDrawTile(), s.activeTexture.set(a.TEXTURE0), h.texture && h.texture.bind(y, a.CLAMP_TO_EDGE), s.activeTexture.set(a.TEXTURE1), M ? (M.texture && M.texture.bind(y, a.CLAMP_TO_EDGE), S = Math.pow(2, M.tileID.overscaledZ - h.tileID.overscaledZ), I = [
                        h.tileID.canonical.x * S % 1,
                        h.tileID.canonical.y * S % 1
                    ]) : h.texture && h.texture.bind(y, a.CLAMP_TO_EDGE), h.texture && h.texture.useMipmap && s.extTextureFilterAnisotropic && e1.transform.pitch > 20 && a.texParameterf(a.TEXTURE_2D, s.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, s.extTextureFilterAnisotropicMax);
                    const C = e1.transform, z = l instanceof Jb ? l.perspectiveTransform : [
                        0,
                        0
                    ], P = _ ? sA(C) : [
                        0,
                        0,
                        0,
                        0
                    ];
                    let D, R, L, k, O, B;
                    if (w && l instanceof Jb && l.coordinates.length > 3) {
                        D = Float32Array.from(Ad(fd(new ju(0, 0, 0)))), R = Float32Array.from(C.globeMatrix), L = Float32Array.from(Pd(C)), k = [
                            Kd(C.center.lng),
                            Jd(C.center.lat)
                        ], B = [
                            Kd(l.coordinates[1][0]),
                            Jd(l.coordinates[1][1]),
                            Kd(l.coordinates[3][0]),
                            Jd(l.coordinates[3][1])
                        ];
                        const t = new sc(l.coordinates[1], l.coordinates[3]);
                        O = Float32Array.from(kd(new ju(0, 0, 0), t, 0, C.worldSize / e1.transform._pixelsPerMercatorPixel));
                    } else D = new Float32Array(16), R = new Float32Array(9), L = new Float32Array(16), k = [
                        0,
                        0
                    ], O = new Float32Array(16), B = [
                        0,
                        0,
                        0,
                        0
                    ];
                    const F = CM(v, D, R, L, O, I || [
                        0,
                        0
                    ], B, Dd(e1.transform.zoom), k, P, S || 1, A, i, z, _ ? i.paint.get("raster-elevation") : 0, 2, c.mix, c.offset, c.range, 1, 0, p), N = e1.isTileAffectedByFog(r), U = e1.getOrCreateProgram("raster", {
                        defines: c.defines,
                        overrideFog: N
                    });
                    if (e1.uploadCommonUniforms(s, U, n), l instanceof Jb) {
                        if (m || !u) l.boundsBuffer && l.boundsSegments && U.draw(e1, a.TRIANGLES, d, Sx.disabled, f, Dx.disabled, F, i.id, l.boundsBuffer, e1.quadTriangleIndexBuffer, l.boundsSegments);
                        else if (e1.globeSharedBuffers) {
                            const [t, r, n] = e1.globeSharedBuffers.getGridBuffers(0, !1);
                            U.draw(e1, a.TRIANGLES, d, Sx.disabled, f, Dx.frontCCW, F, i.id, t, r, n), U.draw(e1, a.TRIANGLES, d, Sx.disabled, f, Dx.backCCW, F, i.id, t, r, n);
                        }
                    } else {
                        const { tileBoundsBuffer: t, tileBoundsIndexBuffer: r, tileBoundsSegments: n } = e1.getTileBoundsBuffers(h);
                        U.draw(e1, a.TRIANGLES, d, T, f, Dx.disabled, F, i.id, t, r, n);
                    }
                }
                e1.resetStencilClippingMasks();
            },
            background: function(e1, t, i, r) {
                const n = i.paint.get("background-color"), o = i.paint.get("background-opacity"), s = i.paint.get("background-emissive-strength");
                if (0 === o) return;
                const a = e1.context, l = a.gl, c = e1.transform, h = c.tileSize, u = i.paint.get("background-pattern");
                if (e1.isPatternMissing(u, i.scope)) return;
                const d = !u && 1 === n.a && 1 === o && e1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (e1.renderPass !== d) return;
                const p = Sx.disabled, f = e1.depthModeForSublayer(0, "opaque" === d ? Mx.ReadWrite : Mx.ReadOnly), m = e1.colorModeForDrapableLayerRenderPass(s), _ = u ? "backgroundPattern" : "background";
                let g, y = r;
                y || (g = e1.getBackgroundTiles(), y = Object.values(g).map((e1)=>e1.tileID)), u && (a.activeTexture.set(l.TEXTURE0), e1.imageManager.bind(e1.context, i.scope));
                for (const d of y){
                    const y = e1.isTileAffectedByFog(d), x = e1.getOrCreateProgram(_, {
                        overrideFog: y
                    }), v = d.toUnwrapped(), b = r ? d.projMatrix : e1.transform.calculateProjMatrix(v);
                    e1.prepareDrawTile();
                    const w = t ? t.getTile(d) : g ? g[d.key] : new Oy(d, h, c.zoom, e1), T = u ? FM(b, s, o, e1, u, i.scope, {
                        tileID: d,
                        tileSize: h
                    }) : BM(b, s, o, n);
                    e1.uploadCommonUniforms(a, x, v);
                    const { tileBoundsBuffer: E, tileBoundsIndexBuffer: M, tileBoundsSegments: A } = e1.getTileBoundsBuffers(w);
                    x.draw(e1, l.TRIANGLES, f, p, m, Dx.disabled, T, i.id, E, M, A);
                }
            },
            sky: function(e1, t, i) {
                const r = e1._atmosphere ? Dd(e1.transform.zoom) : 1, n = i.paint.get("sky-opacity") * r;
                if (0 === n) return;
                const o = e1.context, s = i.paint.get("sky-type"), a = new Mx(o.gl.LEQUAL, Mx.ReadOnly, [
                    0,
                    1
                ]), l = e1.frameCounter / 1e3 % 1;
                "atmosphere" === s ? "offscreen" === e1.renderPass ? i.needsSkyboxCapture(e1) && (function(e1, t, i, r) {
                    const n = e1.context, o = n.gl;
                    let s = t.skyboxFbo;
                    if (!s) {
                        s = t.skyboxFbo = n.createFramebuffer(32, 32, !0, null), t.skyboxGeometry = new xA(n), t.skyboxTexture = n.gl.createTexture(), o.bindTexture(o.TEXTURE_CUBE_MAP, t.skyboxTexture), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_MIN_FILTER, o.LINEAR), o.texParameteri(o.TEXTURE_CUBE_MAP, o.TEXTURE_MAG_FILTER, o.LINEAR);
                        for(let e1 = 0; e1 < 6; ++e1)o.texImage2D(o.TEXTURE_CUBE_MAP_POSITIVE_X + e1, 0, o.RGBA, 32, 32, 0, o.RGBA, o.UNSIGNED_BYTE, null);
                    }
                    n.bindFramebuffer.set(s.framebuffer), n.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const a = t.getCenter(e1, !0), l = e1.getOrCreateProgram("skyboxCapture"), c = new Float64Array(16);
                    Au.identity(c), Au.rotateY(c, c, .5 * -Math.PI), vA(e1, t, l, c, a, 0), Au.identity(c), Au.rotateY(c, c, .5 * Math.PI), vA(e1, t, l, c, a, 1), Au.identity(c), Au.rotateX(c, c, .5 * -Math.PI), vA(e1, t, l, c, a, 2), Au.identity(c), Au.rotateX(c, c, .5 * Math.PI), vA(e1, t, l, c, a, 3), Au.identity(c), vA(e1, t, l, c, a, 4), Au.identity(c), Au.rotateY(c, c, Math.PI), vA(e1, t, l, c, a, 5), n.viewport.set([
                        0,
                        0,
                        e1.width,
                        e1.height
                    ]);
                }(e1, i), i.markSkyboxValid(e1)) : "sky" === e1.renderPass && function(e1, t, i, r, n) {
                    const o = e1.context, s = o.gl, a = e1.transform, l = e1.getOrCreateProgram("skybox");
                    o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_CUBE_MAP, t.skyboxTexture);
                    const c = ((e1, t, i, r, n)=>({
                            u_matrix: e1,
                            u_sun_direction: t,
                            u_cubemap: 0,
                            u_opacity: r,
                            u_temporal_offset: n
                        }))(a.skyboxMatrix, t.getCenter(e1, !1), 0, r, n);
                    e1.uploadCommonUniforms(o, l), l.draw(e1, s.TRIANGLES, i, Sx.disabled, e1.colorModeForRenderPass(), Dx.backCW, c, "skybox", t.skyboxGeometry.vertexBuffer, t.skyboxGeometry.indexBuffer, t.skyboxGeometry.segment);
                }(e1, i, a, n, l) : "gradient" === s && "sky" === e1.renderPass && function(e1, t, i, r, n) {
                    const o = e1.context, s = o.gl, a = e1.transform, l = e1.getOrCreateProgram("skyboxGradient");
                    t.skyboxGeometry || (t.skyboxGeometry = new xA(o)), o.activeTexture.set(s.TEXTURE0);
                    let c = t.colorRampTexture;
                    c || (c = t.colorRampTexture = new My(o, t.colorRamp, s.RGBA)), c.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                    const h = ((e1, t, i, r, n)=>({
                            u_matrix: e1,
                            u_color_ramp: 0,
                            u_center_direction: t,
                            u_radius: w(i),
                            u_opacity: r,
                            u_temporal_offset: n
                        }))(a.skyboxMatrix, t.getCenter(e1, !1), t.paint.get("sky-gradient-radius"), r, n);
                    e1.uploadCommonUniforms(o, l), l.draw(e1, s.TRIANGLES, i, Sx.disabled, e1.colorModeForRenderPass(), Dx.backCW, h, "skyboxGradient", t.skyboxGeometry.vertexBuffer, t.skyboxGeometry.indexBuffer, t.skyboxGeometry.segment);
                }(e1, i, a, n, l);
            },
            debug: function(e1, t, i) {
                for(let r = 0; r < i.length; r++)dA(e1, t, i[r]);
            },
            custom: function(e1, t, i, r) {
                const n = e1.context, o = i.implementation;
                if (!e1.transform.projection.unsupportedLayers || !e1.transform.projection.unsupportedLayers.includes("custom") || e1.terrain && (e1.terrain.renderingToTexture || "offscreen" === e1.renderPass) && i.isLayerDraped(t)) {
                    if ("offscreen" === e1.renderPass) {
                        const t = o.prerender;
                        if (t) {
                            if (e1.setCustomLayerDefaults(), n.setColorMode(e1.colorModeForRenderPass()), "globe" === e1.transform.projection.name) {
                                const i = e1.transform.pointMerc;
                                t.call(o, n.gl, e1.transform.customLayerMatrix(), e1.transform.getProjection(), e1.transform.globeToMercatorMatrix(), Dd(e1.transform.zoom), [
                                    i.x,
                                    i.y
                                ], e1.transform.pixelsPerMeterRatio);
                            } else t.call(o, n.gl, e1.transform.customLayerMatrix());
                            n.setDirty(), e1.setBaseState();
                        }
                    } else if ("translucent" === e1.renderPass) {
                        if (e1.terrain && e1.terrain.renderingToTexture) {
                            const t = o.renderToTile;
                            if (t) {
                                const i = r[0].canonical, s = new lp(i.x + r[0].wrap * (1 << i.z), i.y, i.z);
                                n.setDepthMode(Mx.disabled), n.setStencilMode(Sx.disabled), n.setColorMode(e1.colorModeForRenderPass()), e1.setCustomLayerDefaults(), t.call(o, n.gl, s), n.setDirty(), e1.setBaseState();
                            }
                            return;
                        }
                        e1.setCustomLayerDefaults(), n.setColorMode(e1.colorModeForRenderPass()), n.setStencilMode(Sx.disabled);
                        const t = "3d" === o.renderingMode ? new Mx(e1.context.gl.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D) : e1.depthModeForSublayer(0, Mx.ReadOnly);
                        if (n.setDepthMode(t), "globe" === e1.transform.projection.name) {
                            const t = e1.transform.pointMerc;
                            o.render(n.gl, e1.transform.customLayerMatrix(), e1.transform.getProjection(), e1.transform.globeToMercatorMatrix(), Dd(e1.transform.zoom), [
                                t.x,
                                t.y
                            ], e1.transform.pixelsPerMeterRatio);
                        } else o.render(n.gl, e1.transform.customLayerMatrix());
                        n.setDirty(), e1.setBaseState(), n.bindFramebuffer.set(null);
                    }
                } else H("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
            },
            model: function(e1, t, i, r) {
                if ("opaque" === e1.renderPass) return;
                const n = i.paint.get("model-opacity");
                if (0 === n) return;
                const o = i.paint.get("model-cast-shadows");
                if ("shadow" === e1.renderPass) {
                    if (!o) return;
                    if (e1.terrain && n < .65 && i._transitionablePaint._values["model-opacity"].value.expression instanceof Ao) return;
                }
                const s = e1.shadowRenderer, a = i.paint.get("model-receive-shadows");
                s && (s.useNormalOffset = !0, a || (s.enabled = !1));
                const l = ()=>{
                    s && (s.useNormalOffset = !0, a || (s.enabled = !0));
                }, c = t.getSource();
                if ("light-beam" === e1.renderPass && "batched-model" !== c.type) return;
                if ("vector" === c.type || "geojson" === c.type) return function(e1, t, i, r) {
                    const n = e1.transform;
                    if ("mercator" !== n.projection.name) return void H(`Drawing 3D models for ${n.projection.name} projection is not yet implemented`);
                    const o = n.getFreeCameraOptions().position;
                    if (!e1.modelManager) return;
                    const s = e1.modelManager, a = e1.shadowRenderer;
                    if (!i._unevaluatedLayout._values.hasOwnProperty("model-id")) return;
                    const l = i._unevaluatedLayout._values["model-id"], c = {
                        ...i.layout.get("model-id").parameters
                    };
                    for (const h of r){
                        const r = t.getTile(h).getBucket(i);
                        if (!r || r.projection.name !== n.projection.name) continue;
                        const u = DA(h, n);
                        c.zoom = u;
                        const d = l.possiblyEvaluate(c);
                        if (zA(e1, r, h), PA.shadowUniformsInitialized = !1, PA.useSingleShadowCascade = !!a && 0 === a.getMaxCascadeForTile(h.toUnwrapped()), "shadow" === e1.renderPass && a) {
                            if (1 === e1.currentShadowCascade && r.isInsideFirstShadowMapFrustum) continue;
                            const t = n.calculatePosMatrix(h.toUnwrapped(), n.worldSize);
                            if (PA.tileMatrix.set(t), PA.shadowTileMatrix = Float32Array.from(a.calculateShadowPassMatrixFromMatrix(t)), PA.aabb.min.fill(0), PA.aabb.max[0] = PA.aabb.max[1] = cr, PA.aabb.max[2] = 0, kA(r, PA, e1, i.scope)) continue;
                        }
                        const p = 1 << h.canonical.z, f = [
                            ((o.x - h.wrap) * p - h.canonical.x) * cr,
                            (o.y * p - h.canonical.y) * cr,
                            o.z * p * cr
                        ];
                        for(let t in r.instancesPerModel){
                            const n = r.instancesPerModel[t];
                            n.features.length > 0 && (t = d.evaluate(n.features[0].feature, {}));
                            const o = s.getModel(t, i.scope);
                            if (o && o.uploaded) for (const t of o.nodes)RA(e1, i, t, n, f, h, PA);
                        }
                    }
                }(e1, t, i, r), void l();
                if (!c.loaded()) return;
                if ("batched-model" === c.type) return function(e1, t, i, r) {
                    const n = e1.context, o = e1.transform, s = e1.style.fog, a = e1.shadowRenderer;
                    if ("mercator" !== o.projection.name) return void H(`Drawing 3D landmark models for ${o.projection.name} projection is not yet implemented`);
                    const l = e1.transform.getFreeCameraOptions().position, c = Du.scale([], [
                        l.x,
                        l.y,
                        l.z
                    ], e1.transform.worldSize);
                    Du.negate(c, c);
                    const h = Au.identity([]), u = op(o.center.lat, o.zoom), d = Au.fromScaling([], [
                        1,
                        1,
                        1 / u
                    ]);
                    Au.translate(h, h, c);
                    const p = i.paint.get("model-opacity"), f = new Mx(n.gl.LEQUAL, Mx.ReadWrite, e1.depthRangeFor3D), m = new Mx(n.gl.LEQUAL, Mx.ReadOnly, e1.depthRangeFor3D), _ = function(l, c) {
                        for (const u of r){
                            const r = t.getTile(u).getBucket(i);
                            if (!r || !r.uploaded) continue;
                            let _ = !1;
                            a && (_ = 0 === a.getMaxCascadeForTile(u.toUnwrapped()));
                            const g = o.calculatePosMatrix(u.toUnwrapped(), o.worldSize), y = r.modelTraits;
                            for (const t of r.getNodesInfo()){
                                if (t.hiddenByReplacement) continue;
                                if (!t.node.meshes) continue;
                                const r = t.node, x = "light-beam" === e1.renderPass, v = [
                                    ...g
                                ], b = t.evaluatedScale;
                                let w = 0;
                                e1.terrain && r.elevation && (w = r.elevation * e1.terrain.exaggeration()), Au.translate(v, v, [
                                    (r.anchor ? r.anchor[0] : 0) * (b[0] - 1),
                                    (r.anchor ? r.anchor[1] : 0) * (b[1] - 1),
                                    w
                                ]), b !== Iv && Au.scale(v, v, b), Au.multiply(v, v, r.matrix);
                                const T = Au.multiply([], d, v);
                                Au.multiply(T, h, T);
                                const E = Au.invert([], T);
                                Au.transpose(E, E), Au.scale(E, E, LA);
                                const M = Au.multiply([], o.expandedFarZProjMatrix, v);
                                for(let h = 0; h < r.meshes.length; ++h){
                                    const d = r.meshes[h], g = h === r.lightMeshIndex;
                                    if (g) {
                                        if (!x && !e1.terrain && e1.shadowRenderer) {
                                            e1.currentLayer < e1.firstLightBeamLayer && (e1.firstLightBeamLayer = e1.currentLayer);
                                            continue;
                                        }
                                    } else if (x) continue;
                                    const b = {
                                        defines: []
                                    }, w = [];
                                    AA(b.defines, w, d, e1), 4 & y || b.defines.push("DIFFUSE_SHADED"), _ && b.defines.push("SHADOWS_SINGLE_CASCADE");
                                    const A = "shadow" === e1.renderPass;
                                    if (A) {
                                        CA(d, v, e1, i);
                                        continue;
                                    }
                                    let S = null;
                                    if (s) {
                                        const t = MA(v, e1.transform);
                                        if (S = new Float32Array(t), "globe" !== o.projection.name) {
                                            const e1 = d.aabb.min, i = d.aabb.max, [r, n] = s.getOpacityForBounds(t, e1[0], e1[1], i[0], i[1]);
                                            b.overrideFog = r >= fw || n >= fw;
                                        }
                                    }
                                    const I = e1.getOrCreateProgram("model", b);
                                    !A && a && (a.useNormalOffset = !!d.normalBuffer, a.setupShadowsFromMatrix(v, I, a.useNormalOffset)), e1.uploadCommonUniforms(n, I, u.toUnwrapped(), S);
                                    const C = d.material, z = C.pbrMetallicRoughness;
                                    z.metallicFactor = .9, z.roughnessFactor = .5;
                                    const P = 0, D = UM(new Float32Array(M), new Float32Array(T), new Float32Array(E), e1, p, z.baseColorFactor, C.emissiveFactor, z.metallicFactor, z.roughnessFactor, C, P, i);
                                    I.draw(e1, n.gl.TRIANGLES, c && !g ? f : m, Sx.disabled, l ? g || p < 1 || t.hasTranslucentParts ? Cx.alphaBlended : Cx.unblended : Cx.disabled, Dx.backCCW, D, i.id, d.vertexBuffer, d.indexBuffer, d.segments, i.paint, e1.transform.zoom, void 0, w);
                                }
                            }
                        }
                    };
                    (function(e1, t, i, r) {
                        const n = e1.terrain ? e1.terrain.exaggeration() : 0, o = e1.transform.zoom;
                        for (const s of r){
                            const r = t.getTile(s).getBucket(i);
                            r && (e1.conflationActive && r.updateReplacement(s, e1.replacementSource), r.evaluateScale(e1, i), e1.terrain && n > 0 && r.elevationUpdate(e1.terrain, n, s, i.source), r.needsReEvaluation(e1, o, i) && r.evaluate(i));
                        }
                    })(e1, t, i, r), 1 === p ? _(!0, !0) : (_(!1, !0), _(!0, !1));
                }(e1, t, i, r), void l();
                const h = c.getModels(), u = [], d = e1.transform.getFreeCameraOptions().position, p = Du.scale([], [
                    d.x,
                    d.y,
                    d.z
                ], e1.transform.worldSize);
                Du.negate(p, p);
                const f = [], m = [];
                let _ = 0;
                for (const t of h){
                    const r = i.paint.get("model-rotation").constantOr(null), n = i.paint.get("model-scale").constantOr(null), o = i.paint.get("model-translation").constantOr(null);
                    t.computeModelMatrix(e1, r, n, o, !0, !0, !1);
                    const s = Au.identity([]), a = op(t.position.lat, e1.transform.zoom), l = Au.fromScaling([], [
                        1,
                        1,
                        1 / a
                    ]);
                    Au.translate(s, s, p), u.push({
                        zScaleMatrix: l,
                        negCameraPosMatrix: s
                    });
                    for (const i of t.nodes)IA(e1.transform, i, t.matrix, e1.transform.expandedFarZProjMatrix, _, f, m);
                    _++;
                }
                if (f.sort((e1, t)=>t.depth - e1.depth), "shadow" !== e1.renderPass) {
                    if (1 === n) for (const t of m)SA(t, e1, i, u[t.modelIndex], Sx.disabled, e1.colorModeForRenderPass());
                    else {
                        for (const t of m)SA(t, e1, i, u[t.modelIndex], Sx.disabled, Cx.disabled);
                        for (const t of m)SA(t, e1, i, u[t.modelIndex], e1.stencilModeFor3D(), e1.colorModeForRenderPass());
                        e1.resetStencilClippingMasks();
                    }
                    for (const t of f)SA(t, e1, i, u[t.modelIndex], Sx.disabled, e1.colorModeForRenderPass());
                    l();
                } else {
                    for (const t of m)CA(t.mesh, t.nodeModelMatrix, e1, i);
                    for (const t of f)CA(t.mesh, t.nodeModelMatrix, e1, i);
                    l();
                }
            }
        }, NA = {
            modelUpload: function(e1, t, i) {
                const r = t.getSource();
                if (!r.loaded()) return;
                if ("vector" === r.type || "geojson" === r.type) return void (e1.modelManager && e1.modelManager.upload(e1, i));
                if ("batched-model" === r.type) return;
                const n = r.getModels();
                for (const t of n)t.upload(e1.context);
            }
        };
        class UA {
            updateTerrain(e1, t) {
                const i = !!e1 && !!e1.terrain && this.transform.projection.supportsTerrain;
                if (!(i || this._terrain && this._terrain.enabled)) return;
                this._terrain || (this._terrain = new uM(this, e1));
                const r = this._terrain;
                this.transform.elevation = i ? r : null, r.update(e1, this.transform, t), this.transform.elevation && !r.enabled && (this.transform.elevation = null);
            }
            _updateFog(e1) {
                const t = e1.fog;
                if (!t || "globe" === this.transform.projection.name || t.getOpacity(this.transform.pitch) < 1 || t.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, r] = t.getFovAdjustedRange(this.transform._fov);
                if (i > r) return void (this.transform.fogCullDistSq = null);
                const n = i + .78 * (r - i);
                this.transform.fogCullDistSq = n * n;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled ? this._terrain : null;
            }
            get shadowRenderer() {
                return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
            }
            get wireframeDebugCache() {
                return this._wireframeDebugCache;
            }
            resize(e1, t) {
                if (this.width = e1 * dt.devicePixelRatio, this.height = t * dt.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e1 of this.style.order)this.style._mergedLayers[e1].resize();
            }
            setup() {
                const e1 = this.context, i = new za;
                i.emplaceBack(0, 0), i.emplaceBack(cr, 0), i.emplaceBack(0, cr), i.emplaceBack(cr, cr), this.tileExtentBuffer = e1.createVertexBuffer(i, Nu.members), this.tileExtentSegments = xl.simpleSegment(0, 0, 4, 2);
                const r = new za;
                r.emplaceBack(0, 0), r.emplaceBack(cr, 0), r.emplaceBack(0, cr), r.emplaceBack(cr, cr), this.debugBuffer = e1.createVertexBuffer(r, Nu.members), this.debugSegments = xl.simpleSegment(0, 0, 4, 5);
                const n = new za;
                n.emplaceBack(-1, -1), n.emplaceBack(1, -1), n.emplaceBack(-1, 1), n.emplaceBack(1, 1), this.viewportBuffer = e1.createVertexBuffer(n, Nu.members), this.viewportSegments = xl.simpleSegment(0, 0, 4, 2);
                const o = new Da;
                o.emplaceBack(0, 0, 0, 0), o.emplaceBack(cr, 0, cr, 0), o.emplaceBack(0, cr, 0, cr), o.emplaceBack(cr, cr, cr, cr), this.mercatorBoundsBuffer = e1.createVertexBuffer(o, Ly.members), this.mercatorBoundsSegments = xl.simpleSegment(0, 0, 4, 2);
                const s = new Wa;
                s.emplaceBack(0, 1, 2), s.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = e1.createIndexBuffer(s);
                const a = new el;
                for (const e1 of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])a.emplaceBack(e1);
                this.debugIndexBuffer = e1.createIndexBuffer(a), this.emptyTexture = new My(e1, new ef({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), e1.gl.RGBA), this.identityMat = Au.create();
                const l = this.context.gl;
                this.stencilClearMode = new Sx({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(t.performance.now());
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e1) {
                return e1._makeTileBoundsBuffers(this.context, this.transform.projection), e1._tileBoundsBuffer ? {
                    tileBoundsBuffer: e1._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e1._tileBoundsIndexBuffer,
                    tileBoundsSegments: e1._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const e1 = this.context.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, e1.TRIANGLES, Mx.disabled, this.stencilClearMode, Cx.disabled, Dx.disabled, sM(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(e1, t, i) {
                if (!t || this.currentStencilSource === t.id || !e1.isTileClipped() || !i || 0 === i.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e1 = !1;
                    for (const t of i)if (void 0 === this._tileClippingMaskIDs[t.key]) {
                        e1 = !0;
                        break;
                    }
                    if (!e1) return;
                }
                this.currentStencilSource = t.id;
                const r = this.context, n = r.gl;
                this.nextStencilID + i.length > 256 && this.clearStencil(), r.setColorMode(Cx.disabled), r.setDepthMode(Mx.disabled);
                const o = this.getOrCreateProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const e1 of i){
                    const i = t.getTile(e1), r = this._tileClippingMaskIDs[e1.key] = this.nextStencilID++, { tileBoundsBuffer: s, tileBoundsIndexBuffer: a, tileBoundsSegments: l } = this.getTileBoundsBuffers(i);
                    o.draw(this, n.TRIANGLES, Mx.disabled, new Sx({
                        func: n.ALWAYS,
                        mask: 0
                    }, r, 255, n.KEEP, n.KEEP, n.REPLACE), Cx.disabled, Dx.disabled, sM(e1.projMatrix), "$clipping", s, a, l);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const e1 = this.nextStencilID++, t = this.context.gl;
                return new Sx({
                    func: t.NOTEQUAL,
                    mask: 255
                }, e1, 255, t.KEEP, t.KEEP, t.REPLACE);
            }
            stencilModeForClipping(e1) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(e1);
                const t = this.context.gl;
                return new Sx({
                    func: t.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[e1.key], 0, t.KEEP, t.KEEP, t.REPLACE);
            }
            stencilConfigForOverlap(e1) {
                const t = this.context.gl, i = e1.sort((e1, t)=>t.overscaledZ - e1.overscaledZ), r = i[i.length - 1].overscaledZ, n = i[0].overscaledZ - r + 1;
                if (n > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + n > 256 && this.clearStencil();
                    const e1 = {};
                    for(let i = 0; i < n; i++)e1[i + r] = new Sx({
                        func: t.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, t.KEEP, t.KEEP, t.REPLACE);
                    return this.nextStencilID += n, [
                        e1,
                        i
                    ];
                }
                return [
                    {
                        [r]: Sx.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const e1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const t = 1 / 8;
                    return new Cx([
                        e1.CONSTANT_COLOR,
                        e1.ONE,
                        e1.CONSTANT_COLOR,
                        e1.ONE
                    ], new hi(t, t, t, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? Cx.unblended : Cx.alphaBlended;
            }
            colorModeForDrapableLayerRenderPass(e1) {
                const t = this.context.gl;
                return (()=>this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? new Cx([
                    t.ONE,
                    t.ONE_MINUS_SRC_ALPHA,
                    t.CONSTANT_ALPHA,
                    t.ONE_MINUS_SRC_ALPHA
                ], new hi(0, 0, 0, void 0 === e1 ? 0 : e1), [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : this.colorModeForRenderPass();
            }
            depthModeForSublayer(e1, t, i, r = !1) {
                if (!this.opaquePassEnabledForLayer() && !r) return Mx.disabled;
                const n = 1 - ((1 + this.currentLayer) * this.numSublayers + e1) * this.depthEpsilon;
                return new Mx(i || this.context.gl.LEQUAL, t, [
                    n,
                    n
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            render(e1, i) {
                this._wireframeDebugCache.update(this.frameCounter), this.style = e1, this.options = i;
                const r = this.style._mergedLayers, n = this.style.order, o = n.map((e1)=>r[e1]), s = this.style._mergedSourceCaches;
                this.imageManager = e1.imageManager, this.modelManager = e1.modelManager, this.symbolFadeChange = e1.placement.symbolFadeChange(dt.now()), this.imageManager.beginFrame();
                let a = 0, l = !1;
                for(const e1 in s){
                    const t = s[e1];
                    t.used && (t.prepare(this.context), t.getSource().usedInConflation && ++a);
                }
                const c = {}, h = {}, u = {}, d = {}, p = {};
                for(const e1 in s){
                    const t = s[e1];
                    c[e1] = t.getVisibleCoordinates(), h[e1] = c[e1].slice().reverse(), u[e1] = t.getVisibleCoordinates(!0).reverse(), d[e1] = t.getShadowCasterCoordinates(), p[e1] = t.sortCoordinatesByDistance(c[e1]);
                }
                const f = (e1)=>{
                    const t = this.style.getLayerSourceCache(e1);
                    return t && t.used ? t.getSource() : null;
                };
                if (a) {
                    const e1 = [];
                    for (const t of o)this.layerUsedInConflation(t, f(t)) && e1.push(t);
                    if (e1 && e1.length > 1) {
                        const t = [];
                        for (const i of e1){
                            const e1 = this.style.getLayerSourceCache(i);
                            e1 && e1.used && e1.getSource().usedInConflation && t.push({
                                layer: i.fqid,
                                cache: e1
                            });
                        }
                        this.replacementSource.setSources(t), l = !0;
                    }
                }
                l || this.replacementSource.clear(), this.conflationActive = l, this.minCutoffZoom = 0, this.longestCutoffRange = 0;
                for (const e1 of o){
                    const t = e1.cutoffRange();
                    if (this.longestCutoffRange = Math.max(t, this.longestCutoffRange), t > 0) {
                        const t = f(e1);
                        t && (this.minCutoffZoom = Math.max(t.minzoom, this.minCutoffZoom)), e1.minzoom && (this.minCutoffZoom = Math.max(e1.minzoom, this.minCutoffZoom));
                    }
                }
                this.opaquePassCutoff = 1 / 0;
                for(let e1 = 0; e1 < o.length; e1++)if (o[e1].is3D()) {
                    this.opaquePassCutoff = e1;
                    break;
                }
                const m = this.style && this.style.fog;
                m ? (this._fogVisible = 0 !== m.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = m.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(u), this.opaquePassCutoff = 0);
                const _ = this._shadowRenderer;
                if (_) {
                    _.updateShadowParameters(this.transform, this.style.directionalLight);
                    for(const e1 in s)for (const t of c[e1]){
                        let e1 = {
                            min: 0,
                            max: 0
                        };
                        this.terrain && (e1 = this.terrain.getMinMaxForTile(t) || e1), _.addShadowReceiver(t.toUnwrapped(), e1.min, e1.max);
                    }
                }
                "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new Gd(this.context));
                for (const t of o){
                    if (t.isHidden(this.transform.zoom)) continue;
                    const i = e1.getLayerSourceCache(t);
                    this.uploadLayer(this, t, i);
                }
                if (this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new EA), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), !Ye.has(this.context.gl)) return;
                this.renderPass = "offscreen";
                for (const t of o){
                    const i = e1.getLayerSourceCache(t);
                    if (!t.hasOffscreenPass() || t.isHidden(this.transform.zoom)) continue;
                    const r = i ? h[i.id] : void 0;
                    ("custom" === t.type || "raster" === t.type || t.isSky() || r && r.length) && this.renderLayer(this, i, t, r);
                }
                this.depthRangeFor3D = [
                    0,
                    1 - (o.length + 2) * this.numSublayers * this.depthEpsilon
                ];
                const g = this.terrain;
                g && (this.style.hasSymbolLayers() || this.style.hasCircleLayers()) && !this.transform.isOrthographic && g.drawDepth(), this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, d)), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]);
                const y = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), x = (()=>{
                    if (i.showOverdrawInspector) return hi.black;
                    if (this.style.fog && this.transform.projection.supportsFog && !y) {
                        const e1 = this.style.fog.properties.get("color").toArray01();
                        return new hi(...e1);
                    }
                    if (this.style.fog && this.transform.projection.supportsFog && y) {
                        const e1 = this.style.fog.properties.get("space-color").toArray01();
                        return new hi(...e1);
                    }
                    return hi.transparent;
                })();
                if (this.context.clear({
                    color: x,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && y && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for(this.currentLayer = n.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const t = o[this.currentLayer], i = e1.getLayerSourceCache(t);
                    if (t.isSky()) continue;
                    const r = i ? (t.is3D() ? p : h)[i.id] : void 0;
                    this._renderTileClippingMasks(t, i, r), this.renderLayer(this, i, t, r);
                }
                if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && y && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || Dd(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for(this.currentLayer = 0; this.currentLayer < n.length; this.currentLayer++){
                    const t = o[this.currentLayer], i = e1.getLayerSourceCache(t);
                    t.isSky() && this.renderLayer(this, i, t, i ? h[i.id] : void 0);
                }
                this.renderPass = "translucent", this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
                let v = 0;
                for(_ && (v = _.getShadowCastingLayerCount()); this.currentLayer < n.length;){
                    const t = o[this.currentLayer], i = e1.getLayerSourceCache(t);
                    if (t.isSky()) {
                        ++this.currentLayer;
                        continue;
                    }
                    if (g && this.style.isLayerDraped(t)) {
                        if (t.isHidden(this.transform.zoom)) {
                            ++this.currentLayer;
                            continue;
                        }
                        this.currentLayer = g.renderBatch(this.currentLayer);
                        continue;
                    }
                    let r;
                    if (i && (r = ("symbol" === t.type ? u : t.is3D() ? p : h)[i.id]), this._renderTileClippingMasks(t, i, i ? c[i.id] : void 0), this.renderLayer(this, i, t, r), !g && _ && v > 0 && t.hasShadowPass() && 0 == --v && (_.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer)) {
                        const t = this.currentLayer;
                        for(this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= t; this.currentLayer++){
                            const t = o[this.currentLayer];
                            if (!t.hasLightBeamPass()) continue;
                            const i = e1.getLayerSourceCache(t);
                            this.renderLayer(this, i, t, i ? h[i.id] : void 0);
                        }
                        this.currentLayer = t, this.renderPass = "translucent";
                    }
                    ++this.currentLayer;
                }
                if (this.terrain && this.terrain.postRender(), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                    let t = null;
                    o.forEach((i)=>{
                        const r = e1.getLayerSourceCache(i);
                        r && !i.isHidden(this.transform.zoom) && r.getVisibleCoordinates().length && (!t || t.getSource().maxzoom < r.getSource().maxzoom) && (t = r);
                    }), t && this.options.showTileBoundaries && FA.debug(this, t, t.getVisibleCoordinates());
                }
                this.options.showPadding && function(e1) {
                    const t = e1.transform.padding;
                    pA(e1, e1.transform.height - (t.top || 0), 3, aA), pA(e1, t.bottom || 0, 3, lA), fA(e1, t.left || 0, 3, cA), fA(e1, e1.transform.width - (t.right || 0), 3, hA);
                    const i = e1.transform.centerPoint;
                    !function(e1, t, i, r) {
                        mA(e1, t - 1, i - 10, 2, 20, r), mA(e1, t - 10, i - 1, 20, 2, r);
                    }(e1, i.x, e1.transform.height - i.y, uA);
                }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(t.performance.now()), this.saveCanvasCopy()), l || (this.conflationActive = !1);
            }
            uploadLayer(e1, t, i) {
                this.gpuTimingStart(t), (!e1.transform.projection.unsupportedLayers || !e1.transform.projection.unsupportedLayers.includes(t.type) || e1.terrain && "custom" === t.type) && NA[`${t.type}Upload`] && NA[`${t.type}Upload`](e1, i, t.scope), this.gpuTimingEnd();
            }
            renderLayer(e1, t, i, r) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || "model" === i.type || "raster" === i.type || r && r.length) && (this.id = i.id, this.gpuTimingStart(i), (!e1.transform.projection.unsupportedLayers || !e1.transform.projection.unsupportedLayers.includes(i.type) || e1.terrain && "custom" === i.type) && FA[i.type](e1, t, i, r, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
            }
            gpuTimingStart(e1) {
                if (!this.options.gpuTiming) return;
                const t = this.context.extTimerQuery, i = this.context.gl;
                let r = this.gpuTimers[e1.id];
                r || (r = this.gpuTimers[e1.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: i.createQuery()
                }), r.calls++, i.beginQuery(t.TIME_ELAPSED_EXT, r.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e1 = this.context.extTimerQuery, t = this.context.gl, i = t.createQuery();
                    this.deferredRenderGpuTimeQueries.push(i), t.beginQuery(e1.TIME_ELAPSED_EXT, i);
                }
            }
            gpuTimingDeferredRenderEnd() {
                this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e1 = this.gpuTimers;
                return this.gpuTimers = {}, e1;
            }
            collectDeferredRenderGpuQueries() {
                const e1 = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e1;
            }
            queryGpuTimers(e1) {
                const t = {};
                for(const i in e1){
                    const r = e1[i], n = this.context.extTimerQuery, o = n.getQueryParameter(r.query, this.context.gl.QUERY_RESULT) / 1e6;
                    n.deleteQueryEXT(r.query), t[i] = o;
                }
                return t;
            }
            queryGpuTimeDeferredRender(e1) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t = this.context.extTimerQuery, i = this.context.gl;
                let r = 0;
                for (const n of e1)r += t.getQueryParameter(n, i.QUERY_RESULT) / 1e6, t.deleteQueryEXT(n);
                return r;
            }
            translatePosMatrix(e1, t, i, r, n) {
                if (!i[0] && !i[1]) return e1;
                const o = n ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
                if (o) {
                    const e1 = Math.sin(o), t = Math.cos(o);
                    i = [
                        i[0] * t - i[1] * e1,
                        i[0] * e1 + i[1] * t
                    ];
                }
                const s = [
                    n ? i[0] : rv(t, i[0], this.transform.zoom),
                    n ? i[1] : rv(t, i[1], this.transform.zoom),
                    0
                ], a = new Float32Array(16);
                return Au.translate(a, e1, s), a;
            }
            saveTileTexture(e1) {
                const t = e1.size[0], i = this._tileTextures[t];
                i ? i.push(e1) : this._tileTextures[t] = [
                    e1
                ];
            }
            getTileTexture(e1) {
                const t = this._tileTextures[e1];
                return t && t.length > 0 ? t.pop() : null;
            }
            isPatternMissing(e1, t) {
                return null === e1 || void 0 !== e1 && !this.imageManager.getPattern(e1.toString(), t);
            }
            terrainRenderModeElevated() {
                return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture;
            }
            linearFloatFilteringSupported() {
                return null != this.context.extTextureFloatLinear;
            }
            currentGlobalDefines(e1, t, i) {
                const r = void 0 === i ? this.terrain && this.terrain.renderingToTexture : i, n = this.terrain && 0 === this.terrain.exaggeration(), o = [];
                return this.style && this.style.enable3dLights() && ("globeRaster" === e1 || "terrainRaster" === e1 ? (o.push("LIGHTING_3D_MODE"), o.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : r || o.push("LIGHTING_3D_MODE")), "shadow" === this.renderPass ? this._shadowMapDebug || o.push("DEPTH_TEXTURE") : this.shadowRenderer && (this.shadowRenderer.useNormalOffset ? o.push("RENDER_SHADOWS", "DEPTH_TEXTURE", "NORMAL_OFFSET") : o.push("RENDER_SHADOWS", "DEPTH_TEXTURE")), this.terrainRenderModeElevated() && (o.push("TERRAIN"), this.linearFloatFilteringSupported() && o.push("TERRAIN_DEM_FLOAT_FORMAT"), n && o.push("ZERO_EXAGGERATION")), "globe" === this.transform.projection.name && o.push("GLOBE"), !this._fogVisible || r || void 0 !== t && !t || o.push("FOG", "FOG_DITHERING"), r && o.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && o.push("OVERDRAW_INSPECTOR"), o;
            }
            getOrCreateProgram(e1, t) {
                this.cache = this.cache || {};
                const i = t && t.defines || [], r = t && t.config, n = this.currentGlobalDefines(e1, t && t.overrideFog, t && t.overrideRtt).concat(i), o = mM.cacheKey(GE[e1], e1, n, r);
                return this.cache[o] || (this.cache[o] = new mM(this.context, e1, GE[e1], r, GM[e1], n)), this.cache[o];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = t.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new My(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy();
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            uploadCommonLightUniforms(e1, t) {
                if (this.style.enable3dLights()) {
                    const i = this.style.directionalLight, r = this.style.ambientLight;
                    if (i && r) {
                        const n = ((e1, t)=>{
                            const i = e1.properties.get("direction"), r = e1.properties.get("color").toArray01(), n = e1.properties.get("intensity"), o = t.properties.get("color").toArray01(), s = t.properties.get("intensity"), a = [
                                i.x,
                                i.y,
                                i.z
                            ], l = se(o, s), c = se(r, n);
                            return {
                                u_lighting_ambient_color: l,
                                u_lighting_directional_dir: a,
                                u_lighting_directional_color: c,
                                u_ground_radiance: dM(a, c, l)
                            };
                        })(i, r);
                        t.setLightsUniformValues(e1, n);
                    }
                }
            }
            uploadCommonUniforms(e1, t, i, r, n) {
                if (this.uploadCommonLightUniforms(e1, t), this.terrain && this.terrain.renderingToTexture) return;
                const o = this.style.fog;
                if (o) {
                    const n = o.getOpacity(this.transform.pitch), s = ((e1, t, i, r, n, o, s, a, l, c, h, u)=>{
                        const d = e1.transform, p = t.properties.get("color").toArray01();
                        p[3] = r;
                        const f = e1.frameCounter / 1e3 % 1, [m, _] = t.properties.get("vertical-range");
                        return {
                            u_fog_matrix: i ? d.calculateFogTileMatrix(i) : u || e1.identityMat,
                            u_fog_range: t.getFovAdjustedRange(d._fov),
                            u_fog_color: p,
                            u_fog_horizon_blend: t.properties.get("horizon-blend"),
                            u_fog_vertical_limit: [
                                Math.min(m, _),
                                _
                            ],
                            u_fog_temporal_offset: f,
                            u_frustum_tl: n,
                            u_frustum_tr: o,
                            u_frustum_br: s,
                            u_frustum_bl: a,
                            u_globe_pos: l,
                            u_globe_radius: c,
                            u_viewport: h,
                            u_globe_transition: Dd(d.zoom),
                            u_is_globe: +("globe" === d.projection.name)
                        };
                    })(this, o, i, n, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [
                        this.transform.width * dt.devicePixelRatio,
                        this.transform.height * dt.devicePixelRatio
                    ], r);
                    t.setFogUniformValues(e1, s);
                }
                n && t.setCutoffUniformValues(e1, n.uniformValues);
            }
            setTileLoadedFlag(e1) {
                this.tileLoaded = e1;
            }
            saveCanvasCopy() {
                const e1 = this.canvasCopy();
                e1 && (this.frameCopies.push(e1), this.tileLoaded = !1);
            }
            canvasCopy() {
                const e1 = this.context.gl, t = e1.createTexture();
                return e1.bindTexture(e1.TEXTURE_2D, t), e1.copyTexImage2D(e1.TEXTURE_2D, 0, e1.RGBA, 0, 0, e1.drawingBufferWidth, e1.drawingBufferHeight, 0), t;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e1 = this.style && this.style.fog;
                return !!e1 && 0 !== e1.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const e1 = this._backgroundTiles, t = this._backgroundTiles = {}, i = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const r of i)t[r.key] = e1[r.key] || new Oy(r, 512, this.transform.tileZoom, this);
                return t;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
            layerUsedInConflation(e1, t) {
                return !(!e1.is3D() || e1.minzoom && e1.minzoom > this.transform.zoom || "building" !== e1.sourceLayer && (!t || "batched-model" !== t.type));
            }
            isTileAffectedByFog(e1) {
                if (!this.style || !this.style.fog) return !1;
                if ("globe" === this.transform.projection.name) return !0;
                let t = this._cachedTileFogOpacities[e1.key];
                return t || (this._cachedTileFogOpacities[e1.key] = t = this.style.fog.getOpacityForTile(e1)), t[0] >= fw || t[1] >= fw;
            }
            constructor(e1, t, i){
                this.context = new Rx(e1, t), this.transform = i, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this.setup(), this.numSublayers = Lx.maxUnderzooming + Lx.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = !1, this.replacementSource = new Xv, this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = {}, this._shadowRenderer = new qA(this), this._wireframeDebugCache = new BA, this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0;
            }
        }
        const VA = 2048;
        class jA {
            constructor(e1, t){
                this.aabb = e1, this.lastCascade = t;
            }
        }
        class GA {
            add(e1, t) {
                const i = this.receivers[e1.key];
                void 0 !== i ? (i.aabb.min[0] = Math.min(i.aabb.min[0], t.min[0]), i.aabb.min[1] = Math.min(i.aabb.min[1], t.min[1]), i.aabb.min[2] = Math.min(i.aabb.min[2], t.min[2]), i.aabb.max[0] = Math.max(i.aabb.max[0], t.max[0]), i.aabb.max[1] = Math.max(i.aabb.max[1], t.max[1]), i.aabb.max[2] = Math.max(i.aabb.max[2], t.max[2])) : this.receivers[e1.key] = new jA(t, null);
            }
            clear() {
                this.receivers = {};
            }
            get(e1) {
                return this.receivers[e1.key];
            }
            computeRequiredCascades(e1, t, i) {
                const r = ed.fromPoints(e1.points);
                let n = 0;
                for(const e1 in this.receivers){
                    const o = this.receivers[e1];
                    if (!o) continue;
                    if (!r.intersectsAabb(o.aabb)) continue;
                    o.aabb.min = r.closestPoint(o.aabb.min), o.aabb.max = r.closestPoint(o.aabb.max);
                    const s = o.aabb.getCorners();
                    for(let e1 = 0; e1 < i.length; e1++){
                        let r = !0;
                        for (const n of s){
                            const o = [
                                n[0] * t,
                                n[1] * t,
                                n[2]
                            ];
                            if (Du.transformMat4(o, o, i[e1].matrix), o[0] < -1 || o[0] > 1 || o[1] < -1 || o[1] > 1) {
                                r = !1;
                                break;
                            }
                        }
                        if (o.lastCascade = e1, n = Math.max(n, e1), r) break;
                    }
                }
                return n + 1;
            }
        }
        class qA {
            destroy() {
                for (const e1 of this._cascades)e1.texture.destroy(), e1.framebuffer.destroy();
                this._cascades = [];
            }
            updateShadowParameters(e1, t) {
                const i = this.painter;
                if (this._enabled = !1, this._shadowLayerCount = 0, this._receivers.clear(), !t || !t.properties) return;
                const r = t.properties.get("shadow-intensity");
                if (!t.shadowsEnabled() || r <= 0) return;
                if (this._shadowLayerCount = i.style.order.reduce((t, r)=>{
                    const n = i.style._mergedLayers[r];
                    return t + (n.hasShadowPass() && !n.isHidden(e1.zoom) ? 1 : 0);
                }, 0), this._enabled = this._shadowLayerCount > 0, !this._enabled) return;
                const n = i.context, o = VA, s = VA;
                if (0 === this._cascades.length) for(let e1 = 0; e1 < 2; ++e1){
                    const e1 = i._shadowMapDebug, t = n.gl, r = n.createFramebuffer(o, s, e1, "texture"), a = new My(n, {
                        width: o,
                        height: s,
                        data: null
                    }, t.DEPTH_COMPONENT);
                    if (r.depthAttachment.set(a.texture), e1) {
                        const e1 = new My(n, {
                            width: o,
                            height: s,
                            data: null
                        }, t.RGBA);
                        r.colorAttachment.set(e1.texture);
                    }
                    this._cascades.push({
                        framebuffer: r,
                        texture: a,
                        matrix: [],
                        far: 0,
                        boundingSphereRadius: 0,
                        frustum: new Qu,
                        scale: 0
                    });
                }
                this.shadowDirection = $A(t);
                let a = 0;
                if (e1.elevation) {
                    const t = e1.elevation, i = [
                        1e4,
                        -10000
                    ];
                    t.visibleDemTiles.filter((e1)=>e1.dem).forEach((e1)=>{
                        const t = e1.dem.tree;
                        i[0] = Math.min(i[0], t.minimums[0]), i[1] = Math.max(i[1], t.maximums[0]);
                    }), 1e4 !== i[0] && (a = (i[1] - i[0]) * t.exaggeration());
                }
                const l = 1.5 * e1.cameraToCenterDistance, c = 3 * l, h = new Float64Array(16);
                for(let t = 0; t < 2; ++t){
                    const i = this._cascades[t];
                    let r = e1.height / 50, n = 1;
                    0 === t ? n = l : (r = l, n = c);
                    const [o, s] = HA(e1, this.shadowDirection, r, n, VA, a);
                    i.scale = e1.scale, i.matrix = o, i.boundingSphereRadius = s, Au.invert(h, i.matrix), i.frustum = Qu.fromInvProjectionMatrix(h, 1, 0, !0), i.far = n;
                }
                this._uniformValues.u_fade_range = [
                    .75 * this._cascades[1].far,
                    this._cascades[1].far
                ], this._uniformValues.u_shadow_intensity = r, this._uniformValues.u_shadow_direction = [
                    this.shadowDirection[0],
                    this.shadowDirection[1],
                    this.shadowDirection[2]
                ], this._uniformValues.u_shadow_texel_size = .00048828125, this._uniformValues.u_shadow_map_resolution = VA, this._uniformValues.u_shadowmap_0 = NM.ShadowMap0, this._uniformValues.u_shadowmap_1 = NM.ShadowMap0 + 1, this._groundShadowTiles = i.transform.coveringTiles({
                    tileSize: 512,
                    renderWorldCopies: !0
                });
                const u = i.transform.elevation;
                for (const e1 of this._groundShadowTiles){
                    let t = {
                        min: 0,
                        max: 0
                    };
                    if (u) {
                        const i = u.getMinMaxForTile(e1);
                        i && (t = i);
                    }
                    this.addShadowReceiver(e1.toUnwrapped(), t.min, t.max);
                }
            }
            get enabled() {
                return this._enabled;
            }
            set enabled(e1) {
                this._enabled = e1;
            }
            drawShadowPass(e1, t) {
                if (!this._enabled) return;
                const i = this.painter, r = i.context;
                this._numCascadesToRender = this._receivers.computeRequiredCascades(i.transform.getFrustum(0), i.transform.worldSize, this._cascades), r.viewport.set([
                    0,
                    0,
                    VA,
                    VA
                ]);
                for(let n = 0; n < this._numCascadesToRender; ++n){
                    i.currentShadowCascade = n, r.bindFramebuffer.set(this._cascades[n].framebuffer.framebuffer), r.clear({
                        color: hi.white,
                        depth: 1
                    });
                    for (const r of e1.order){
                        const n = e1._mergedLayers[r];
                        if (!n.hasShadowPass() || n.isHidden(i.transform.zoom)) continue;
                        const o = e1.getLayerSourceCache(n), s = o ? t[o.id] : void 0;
                        ("model" === n.type || s && s.length) && i.renderLayer(i, o, n, s);
                    }
                }
                i.currentShadowCascade = 0;
            }
            drawGroundShadows() {
                if (!this._enabled) return;
                const e1 = this.painter, t = e1.style, i = e1.context, r = t.directionalLight, n = t.ambientLight;
                if (!r || !n) return;
                const o = [], s = eM(e1, e1.longestCutoffRange);
                s.shouldRenderCutoff && o.push("RENDER_CUTOFF");
                const a = WA(r, n), l = new Mx(i.gl.LEQUAL, Mx.ReadOnly, e1.depthRangeFor3D);
                for (const t of this._groundShadowTiles){
                    const r = t.toUnwrapped(), n = e1.isTileAffectedByFog(t), c = e1.getOrCreateProgram("groundShadow", {
                        defines: o,
                        overrideFog: n
                    });
                    this.setupShadows(r, c), e1.uploadCommonUniforms(i, c, r, null, s);
                    const h = {
                        u_matrix: e1.transform.calculateProjMatrix(r),
                        u_ground_shadow_factor: a
                    };
                    c.draw(e1, i.gl.TRIANGLES, l, Sx.disabled, Cx.multiply, Dx.disabled, h, "ground_shadow", e1.tileExtentBuffer, e1.quadTriangleIndexBuffer, e1.tileExtentSegments, {}, e1.transform.zoom, null, null);
                }
            }
            getShadowPassColorMode() {
                return this.painter._shadowMapDebug ? Cx.unblended : Cx.disabled;
            }
            getShadowPassDepthMode() {
                return this._depthMode;
            }
            getShadowCastingLayerCount() {
                return this._shadowLayerCount;
            }
            calculateShadowPassMatrixFromTile(e1) {
                const t = this.painter.transform, i = t.calculatePosMatrix(e1, t.worldSize);
                return Au.multiply(i, this._cascades[this.painter.currentShadowCascade].matrix, i), Float32Array.from(i);
            }
            calculateShadowPassMatrixFromMatrix(e1) {
                return Au.multiply(e1, this._cascades[this.painter.currentShadowCascade].matrix, e1), Float32Array.from(e1);
            }
            setupShadows(e1, t, i, r = 0) {
                if (!this._enabled) return;
                const n = this.painter.transform, o = this.painter.context, s = o.gl, a = this._uniformValues, l = new Float64Array(16), c = n.calculatePosMatrix(e1, n.worldSize);
                for(let e1 = 0; e1 < 2; e1++)Au.multiply(l, this._cascades[e1].matrix, c), a[0 === e1 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(l), o.activeTexture.set(s.TEXTURE0 + NM.ShadowMap0 + e1), this._cascades[e1].texture.bind(s.NEAREST, s.CLAMP_TO_EDGE);
                if (this.useNormalOffset = !!i, this.useNormalOffset) {
                    const t = ap(e1.canonical), o = 2 / n.tileSize * cr / VA, s = o * this._cascades[0].boundingSphereRadius, l = o * this._cascades[1].boundingSphereRadius, c = ("vector-tile" === i ? 1 : 3) / Math.pow(2, r - e1.canonical.z - (1 - n.zoom + Math.floor(n.zoom)));
                    a.u_shadow_normal_offset = [
                        t,
                        s * c,
                        l * c
                    ], a.u_shadow_bias = [
                        6e-5,
                        .0012,
                        .012
                    ];
                } else a.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                t.setShadowUniformValues(o, a);
            }
            setupShadowsFromMatrix(e1, t, i = !1) {
                if (!this._enabled) return;
                const r = this.painter.context, n = r.gl, o = this._uniformValues, s = new Float64Array(16);
                for(let t = 0; t < 2; t++)Au.multiply(s, this._cascades[t].matrix, e1), o[0 === t ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(s), r.activeTexture.set(n.TEXTURE0 + NM.ShadowMap0 + t), this._cascades[t].texture.bind(n.NEAREST, n.CLAMP_TO_EDGE);
                if (this.useNormalOffset = i, i) {
                    const e1 = 5;
                    o.u_shadow_normal_offset = [
                        1,
                        e1,
                        e1
                    ], o.u_shadow_bias = [
                        6e-5,
                        .0012,
                        .012
                    ];
                } else o.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                t.setShadowUniformValues(r, o);
            }
            getShadowUniformValues() {
                return this._uniformValues;
            }
            getCurrentCascadeFrustum() {
                return this._cascades[this.painter.currentShadowCascade].frustum;
            }
            computeSimplifiedTileShadowVolume(e1, t, i, r) {
                if (r[2] >= 0) return {};
                const n = (function(e1, t, i) {
                    const r = i / (1 << e1.canonical.z);
                    return new ed([
                        e1.canonical.x * r + e1.wrap * i,
                        e1.canonical.y * r + e1.wrap * i,
                        0
                    ], [
                        (e1.canonical.x + 1) * r + e1.wrap * i,
                        (e1.canonical.y + 1) * r + e1.wrap * i,
                        t
                    ]);
                })(e1, t, i).getCorners(), o = t / -r[2];
                r[0] < 0 ? (Du.add(n[0], n[0], [
                    r[0] * o,
                    0,
                    0
                ]), Du.add(n[3], n[3], [
                    r[0] * o,
                    0,
                    0
                ])) : r[0] > 0 && (Du.add(n[1], n[1], [
                    r[0] * o,
                    0,
                    0
                ]), Du.add(n[2], n[2], [
                    r[0] * o,
                    0,
                    0
                ])), r[1] < 0 ? (Du.add(n[0], n[0], [
                    0,
                    r[1] * o,
                    0
                ]), Du.add(n[1], n[1], [
                    0,
                    r[1] * o,
                    0
                ])) : r[1] > 0 && (Du.add(n[2], n[2], [
                    0,
                    r[1] * o,
                    0
                ]), Du.add(n[3], n[3], [
                    0,
                    r[1] * o,
                    0
                ]));
                const s = {};
                return s.vertices = n, s.planes = [
                    ZA(n[1], n[0], n[4]),
                    ZA(n[2], n[1], n[5]),
                    ZA(n[3], n[2], n[6]),
                    ZA(n[0], n[3], n[7])
                ], s;
            }
            addShadowReceiver(e1, t, i) {
                this._receivers.add(e1, ed.fromTileIdAndHeight(e1, t, i));
            }
            getMaxCascadeForTile(e1) {
                const t = this._receivers.get(e1);
                return t && t.lastCascade ? t.lastCascade : 0;
            }
            constructor(e1){
                this.painter = e1, this._enabled = !1, this._shadowLayerCount = 0, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new GA, this._depthMode = new Mx(e1.context.gl.LEQUAL, Mx.ReadWrite, [
                    0,
                    1
                ]), this._uniformValues = {
                    u_light_matrix_0: new Float32Array(16),
                    u_light_matrix_1: new Float32Array(16),
                    u_shadow_intensity: 0,
                    u_fade_range: [
                        0,
                        0
                    ],
                    u_shadow_normal_offset: [
                        1,
                        1,
                        1
                    ],
                    u_shadow_texel_size: 1,
                    u_shadow_map_resolution: 1,
                    u_shadow_direction: [
                        0,
                        0,
                        1
                    ],
                    u_shadow_bias: [
                        36e-5,
                        .0012,
                        .012
                    ],
                    u_shadowmap_0: 0,
                    u_shadowmap_1: 0
                }, this.useNormalOffset = !1;
            }
        }
        function ZA(e1, t, i) {
            const r = Du.sub([], i, t), n = Du.sub([], e1, t), o = Du.cross([], r, n), s = Du.length(o);
            return 0 === s ? [
                0,
                0,
                1,
                0
            ] : (Du.scale(o, o, 1 / s), [
                o[0],
                o[1],
                o[2],
                -Du.dot(o, t)
            ]);
        }
        function $A(e1) {
            const t = e1.properties.get("direction"), i = J(t.x, t.y, t.z);
            i[2] = z(i[2], 0, 75);
            const r = K([
                i[0],
                i[1],
                i[2]
            ]);
            return Du.fromValues(r.x, r.y, r.z);
        }
        function WA(e1, t) {
            const i = e1.properties.get("color"), r = e1.properties.get("intensity"), n = e1.properties.get("direction"), o = [
                n.x,
                n.y,
                n.z
            ], s = t.properties.get("color"), a = t.properties.get("intensity"), l = Math.max(Du.dot([
                0,
                0,
                1
            ], o), 0), c = [
                0,
                0,
                0
            ];
            Du.scale(c, s.toArray01Linear().slice(0, 3), a);
            const h = [
                0,
                0,
                0
            ];
            return Du.scale(h, i.toArray01Linear().slice(0, 3), l * r), ae([
                c[0] > 0 ? c[0] / (c[0] + h[0]) : 0,
                c[1] > 0 ? c[1] / (c[1] + h[1]) : 0,
                c[2] > 0 ? c[2] / (c[2] + h[2]) : 0
            ]);
        }
        function HA(e1, t, i, r, n, o) {
            const s = e1.zoom, a = e1.scale, l = e1.worldSize, c = 1 / l, h = e1.aspect, u = Math.sqrt(1 + h * h) * Math.tan(.5 * e1.fovX), d = u * u, p = r - i, f = r + i;
            let m, _;
            d > p / f ? (m = r, _ = r * u) : (m = .5 * f * (1 + d), _ = .5 * Math.sqrt(p * p + 2 * (r * r + i * i) * d + f * f * d * d));
            const g = e1.projection.pixelsPerMeter(e1.center.lat, l), y = e1._camera.getCameraToWorldMercator(), x = [
                0,
                0,
                -m * c
            ];
            Du.transformMat4(x, x, y);
            let v = _ * c;
            const b = e1._edgeInsets;
            if (!(0 === b.left && 0 === b.top && 0 === b.right && 0 === b.bottom || b.left === b.right && b.top === b.bottom)) {
                const t = e1._camera.getWorldToCamera(e1.worldSize, "meters" === e1.projection.zAxisUnit ? g : 1), n = e1._camera.getCameraToClipPerspective(e1._fov, e1.width / e1.height, i, r);
                n[8] = 2 * -e1.centerOffset.x / e1.width, n[9] = 2 * e1.centerOffset.y / e1.height;
                const o = new Float64Array(16);
                Au.mul(o, n, t);
                const c = new Float64Array(16);
                Au.invert(c, o);
                const h = Qu.fromInvProjectionMatrix(c, l, s, !0);
                for (const t of h.points){
                    const i = ((w = t)[0] /= a, w[1] /= a, w[2] = Qd(w[2], e1._center.lat), w);
                    v = Math.max(v, Du.len(Du.subtract([], x, i)));
                }
            }
            var w;
            v *= n / (n - 1);
            const T = Math.acos(t[2]), E = Math.atan2(-t[0], -t[1]), M = new Yx;
            M.position = x, M.setPitchBearing(T, E);
            const A = M.getWorldToCamera(l, g), S = v * l, I = Math.min(e1._mercatorZfromZoom(17) * l * -2, -2 * S), C = M.getCameraToClipOrthographic(-S, S, -S, S, I, (S + o * g) / t[2]), z = new Float64Array(16);
            Au.multiply(z, C, A);
            const P = Du.fromValues(Math.floor(1e6 * x[0]) / 1e6 * l, Math.floor(1e6 * x[1]) / 1e6 * l, 0), D = .5 * n, R = [
                0,
                0,
                0
            ];
            Du.transformMat4(R, P, z), Du.scale(R, R, D);
            const L = [
                Math.floor(R[0]),
                Math.floor(R[1]),
                Math.floor(R[2])
            ], k = [
                0,
                0,
                0
            ];
            Du.sub(k, R, L), Du.scale(k, k, -1 / D);
            const O = new Float64Array(16);
            return Au.identity(O), Au.translate(O, O, k), Au.multiply(z, O, z), [
                z,
                S
            ];
        }
        class XA extends zt {
            loadModel(e1, t) {
                return fT(this.requestManager.transformRequest(t, ye.Model).url).then((t)=>{
                    if (!t) return;
                    const i = TT(t), r = new Cv(e1, void 0, void 0, i);
                    return r.computeBoundsAndApplyParent(), r;
                }).catch((i)=>{
                    this.fire(new Ct(new Error(`Could not load model ${e1} from ${t}: ${i.message}`)));
                });
            }
            load(e1, t) {
                this.models[t] || (this.models[t] = {});
                const i = Object.keys(e1);
                this.numModelsLoading[t] = (this.numModelsLoading[t] || 0) + i.length;
                const r = [];
                for (const t of i)r.push(this.loadModel(t, e1[t]));
                Promise.allSettled(r).then((e1)=>{
                    for(let r = 0; r < e1.length; r++){
                        const { status: n, value: o } = e1[r];
                        "fulfilled" === n && o && (this.models[t][i[r]] = o);
                    }
                    this.numModelsLoading[t] -= i.length, this.fire(new It("data", {
                        dataType: "style"
                    }));
                }).catch((e1)=>{
                    this.fire(new Ct(new Error(`Could not load models: ${e1.message}`)));
                });
            }
            isLoaded() {
                for(const e1 in this.numModelsLoading)if (this.numModelsLoading[e1] > 0) return !1;
                return !0;
            }
            hasModel(e1, t) {
                return !!this.getModel(e1, t);
            }
            getModel(e1, t) {
                return this.models[t] || (this.models[t] = {}), this.models[t][e1];
            }
            addModel(e1, t, i) {
                this.models[i] || (this.models[i] = {}), this.hasModel(e1, i) && this.removeModel(e1, i), this.load({
                    [e1]: this.requestManager.normalizeModelURL(t)
                }, i);
            }
            addModels(e1, t) {
                const i = {};
                for(const t in e1)i[t] = this.requestManager.normalizeModelURL(e1[t]);
                this.load(i, t);
            }
            removeModel(e1, t) {
                this.models[t] || (this.models[t] = {});
                const i = this.models[t][e1];
                delete this.models[t][e1], i.destroy();
            }
            listModels(e1) {
                return this.models[e1] || (this.models[e1] = {}), Object.keys(this.models[e1]);
            }
            upload(e1, t) {
                this.models[t] || (this.models[t] = {});
                for(const i in this.models[t])this.models[t][i].upload(e1.context);
            }
            constructor(e1){
                super(), this.requestManager = e1, this.models = {
                    "": {}
                }, this.numModelsLoading = {};
            }
        }
        const YA = (e1, t)=>Ss(e1, t && t.filter((e1)=>"source.canvas" !== e1.identifier)), KA = O(OT, [
            "addLayer",
            "removeLayer",
            "setLights",
            "setPaintProperty",
            "setLayoutProperty",
            "setSlot",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setProjection",
            "setCamera",
            "addImport",
            "removeImport",
            "setImportUrl",
            "setImportData",
            "setImportConfig"
        ]), JA = O(OT, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), QA = {
            version: 8,
            layers: [],
            sources: {}
        }, eS = {
            duration: 300,
            delay: 0
        }, tS = new Set([
            "fill",
            "line",
            "background",
            "hillshade",
            "raster"
        ]);
        class iS extends zt {
            loadURL(e1, t = {}) {
                this.fire(new It("dataloading", {
                    dataType: "style"
                }));
                const i = "boolean" == typeof t.validate ? t.validate : !Pe(e1);
                e1 = this.map._requestManager.normalizeStyleURL(e1, t.accessToken), this.resolvedImports.add(e1);
                const r = this.importsCache.get(e1);
                if (r) return this._load(r, i);
                const n = this.map._requestManager.transformRequest(e1, ye.Style);
                this._request = we(n, (t, r)=>{
                    if (this._request = null, t) this.fire(new Ct(t));
                    else if (r) return this.importsCache.set(e1, r), this._load(r, i);
                });
            }
            loadJSON(e1, t = {}) {
                this.fire(new It("dataloading", {
                    dataType: "style"
                })), this._request = dt.frame(()=>{
                    this._request = null, this._load(e1, !1 !== t.validate);
                });
            }
            loadEmpty() {
                this.fire(new It("dataloading", {
                    dataType: "style"
                })), this._load(QA, !1);
            }
            _loadImports(e1, t) {
                if (this.importDepth >= 4) return H("Style doesn't support nesting deeper than 5"), Promise.resolve();
                const i = [];
                for (const r of e1){
                    const e1 = this._createFragmentStyle(r), n = new Promise((t)=>{
                        e1.once("style.import.load", t), e1.once("error", t);
                    }).then(()=>this.mergeAll());
                    if (i.push(n), this.resolvedImports.has(r.url)) {
                        e1.loadEmpty();
                        continue;
                    }
                    const o = r.data || this.importsCache.get(r.url);
                    o ? e1.loadJSON(o, {
                        validate: t
                    }) : r.url ? e1.loadURL(r.url, {
                        validate: t
                    }) : e1.loadEmpty(), this.fragments.push({
                        style: e1,
                        id: r.id,
                        config: r.config
                    });
                }
                return Promise.allSettled(i);
            }
            _createFragmentStyle(e1) {
                const t = this.scope ? va(e1.id, this.scope) : e1.id, i = new iS(this.map, {
                    scope: t,
                    styleChanges: this._changes,
                    importDepth: this.importDepth + 1,
                    importsCache: this.importsCache,
                    resolvedImports: new Set(this.resolvedImports),
                    dispatcher: this.dispatcher,
                    imageManager: this.imageManager,
                    glyphManager: this.glyphManager,
                    modelManager: this.modelManager,
                    config: e1.config
                });
                return i.setEventedParent(this.map, {
                    style: i
                }), i;
            }
            _reloadImports() {
                this.mergeAll(), this._updateMapProjection(), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                });
                const e1 = this.isRootStyle();
                this._shouldPrecompile = e1, this.fire(new It(e1 ? "style.load" : "style.import.load"));
            }
            _load(e1, t) {
                const i = e1.schema;
                if (this.isRootStyle() && (e1.fragment || i && !1 !== e1.fragment)) {
                    const i = k({}, QA, {
                        imports: [
                            {
                                id: "basemap",
                                data: e1,
                                url: ""
                            }
                        ]
                    });
                    return void this._load(i, t);
                }
                if (this.setConfig(this._config, i), t && YA(this, ms(e1))) return;
                this._loaded = !0, this.stylesheet = $(e1);
                for(const t in e1.sources)this.addSource(t, e1.sources[t], {
                    validate: !1,
                    isInitialLoad: !0
                });
                e1.sprite ? this._loadSprite(e1.sprite) : (this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                    scope: this.scope,
                    isLoaded: !0
                })), this.glyphManager.setURL(e1.glyphs, this.scope);
                const r = kT(this.stylesheet.layers);
                if (this._order = r.map((e1)=>e1.id), this.stylesheet.light && H("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) {
                    if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                        const e1 = this.stylesheet.lights[0];
                        this.light = new cw(e1.properties, e1.id);
                    } else this.setLights(this.stylesheet.lights);
                }
                this.light || (this.light = new cw(this.stylesheet.light)), this._layers = {}, this._serializedLayers = {};
                for (const e1 of r){
                    const t = ow(e1, this.options);
                    t.setScope(this.scope), t.isConfigDependent && this._configDependentLayers.add(t.fqid), t.setEventedParent(this, {
                        layer: {
                            id: t.id
                        }
                    }), this._layers[t.id] = t, this._serializedLayers[t.id] = t.serialize();
                    const i = this.getOwnLayerSourceCache(t), r = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                    i && t.canCastShadows() && r && (i.castsShadows = !0);
                }
                this.stylesheet.models && this.modelManager.addModels(this.stylesheet.models, this.scope);
                const n = this.stylesheet.terrain;
                n && (void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = dt.hasCanvasFingerprintNoise()), this.disableElevatedTerrain ? H("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode).") : this.terrainSetForDrapingOnly() || this._createTerrain(n, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new It("data", {
                    dataType: "style"
                })), e1.imports ? this._loadImports(e1.imports, t).then(()=>this._reloadImports()) : this._reloadImports();
            }
            isRootStyle() {
                return 0 === this.importDepth;
            }
            mergeAll() {
                let e1, t, i, r, n, o, s, a;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((l)=>{
                    if (l.stylesheet) {
                        if (null != l.light && (e1 = l.light), l.stylesheet.lights) for (const e1 of l.stylesheet.lights)"ambient" === e1.type && null != l.ambientLight && (t = l.ambientLight), "directional" === e1.type && null != l.directionalLight && (i = l.directionalLight);
                        r = this._prioritizeTerrain(r, l.terrain, l.stylesheet.terrain), l.stylesheet.fog && null != l.fog && (n = l.fog), null != l.stylesheet.camera && (a = l.stylesheet.camera), null != l.stylesheet.projection && (o = l.stylesheet.projection), null != l.stylesheet.transition && (s = l.stylesheet.transition);
                    }
                }), this.light = e1, this.ambientLight = t, this.directionalLight = i, this.fog = n, null === r ? delete this.terrain : this.terrain = r, this.camera = a || {
                    "camera-projection": "perspective"
                }, this.projection = o || {
                    name: "mercator"
                }, this.transition = k({}, eS, s), this.mergeSources(), this.mergeLayers();
            }
            forEachFragmentStyle(e1) {
                const t = (i)=>{
                    for (const e1 of i.fragments)t(e1.style);
                    e1(i);
                };
                t(this);
            }
            _prioritizeTerrain(e1, t, i) {
                const r = e1 && 0 === e1.drapeRenderMode;
                return null === i ? t && 0 === t.drapeRenderMode ? t : r ? e1 : null : null != t && (!e1 || r || t && 1 === t.drapeRenderMode) ? t : e1;
            }
            mergeTerrain() {
                let e1;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t)=>{
                    e1 = this._prioritizeTerrain(e1, t.terrain, t.stylesheet.terrain);
                }), null === e1 ? delete this.terrain : this.terrain = e1;
            }
            mergeProjection() {
                let e1;
                this.forEachFragmentStyle((t)=>{
                    null != t.stylesheet.projection && (e1 = t.stylesheet.projection);
                }), this.projection = e1 || {
                    name: "mercator"
                };
            }
            mergeSources() {
                const e1 = {}, t = {}, i = {};
                this.forEachFragmentStyle((r)=>{
                    for(const t in r._sourceCaches){
                        const i = va(t, r.scope);
                        e1[i] = r._sourceCaches[t];
                    }
                    for(const e1 in r._otherSourceCaches){
                        const i = va(e1, r.scope);
                        t[i] = r._otherSourceCaches[e1];
                    }
                    for(const e1 in r._symbolSourceCaches){
                        const t = va(e1, r.scope);
                        i[t] = r._symbolSourceCaches[e1];
                    }
                }), this._mergedSourceCaches = e1, this._mergedOtherSourceCaches = t, this._mergedSymbolSourceCaches = i;
            }
            mergeLayers() {
                const e1 = {}, t = [], i = {};
                this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle((i)=>{
                    for (const r of i._order){
                        const n = i._layers[r];
                        if ("slot" === n.type) {
                            const t = ba(r);
                            if (e1[t]) continue;
                            e1[t] = [];
                        }
                        n.slot && e1[n.slot] ? e1[n.slot].push(n) : t.push(n);
                    }
                }), this._mergedOrder = [];
                const r = (t = [])=>{
                    for (const n of t)if ("slot" === n.type) {
                        const t = ba(n.id);
                        e1[t] && r(e1[t]);
                    } else {
                        const e1 = va(n.id, n.scope);
                        this._mergedOrder.push(e1), i[e1] = n, n.is3D() && (this._has3DLayers = !0), "circle" === n.type && (this._hasCircleLayers = !0), "symbol" === n.type && (this._hasSymbolLayers = !0);
                    }
                };
                r(t), this._mergedLayers = i, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged();
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            getCamera() {
                return this.stylesheet.camera;
            }
            setCamera(e1) {
                return this.stylesheet.camera = k({}, this.stylesheet.camera, e1), this.camera = this.stylesheet.camera, this;
            }
            setProjection(e1) {
                e1 ? this.stylesheet.projection = e1 : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? this.getTerrain() || this.stylesheet.terrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null));
            }
            _updateMapProjection() {
                this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
            }
            _loadSprite(e1) {
                this._spriteRequest = function(e1, t, i) {
                    let r, n, o;
                    const s = dt.devicePixelRatio > 1 ? "@2x" : "";
                    let a = we(t.transformRequest(t.normalizeSpriteURL(e1, s, ".json"), ye.SpriteJSON), (e1, t)=>{
                        a = null, o || (o = e1, r = t, c());
                    }), l = Ie(t.transformRequest(t.normalizeSpriteURL(e1, s, ".png"), ye.SpriteImage), (e1, t)=>{
                        l = null, o || (o = e1, n = t, c());
                    });
                    function c() {
                        if (o) i(o);
                        else if (r && n) {
                            const e1 = dt.getImageData(n), t = {};
                            for(const i in r){
                                const { width: n, height: o, x: s, y: a, sdf: l, pixelRatio: c, stretchX: h, stretchY: u, content: d } = r[i], p = new ef({
                                    width: n,
                                    height: o
                                });
                                ef.copy(e1, p, {
                                    x: s,
                                    y: a
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: n,
                                    height: o
                                }), t[i] = {
                                    data: p,
                                    pixelRatio: c,
                                    sdf: l,
                                    stretchX: h,
                                    stretchY: u,
                                    content: d
                                };
                            }
                            i(null, t);
                        }
                    }
                    return {
                        cancel () {
                            a && (a.cancel(), a = null), l && (l.cancel(), l = null);
                        }
                    };
                }(e1, this.map._requestManager, (e1, t)=>{
                    if (this._spriteRequest = null, e1) this.fire(new Ct(e1));
                    else if (t) for(const e1 in t)this.imageManager.addImage(e1, this.scope, t[e1]);
                    this.imageManager.setLoaded(!0, this.scope), this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", {
                        scope: this.scope,
                        images: this._availableImages
                    }), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new It("data", {
                        dataType: "style"
                    }));
                });
            }
            _validateLayer(e1) {
                const t = this.getOwnSource(e1.source);
                if (!t) return;
                const i = e1.sourceLayer;
                i && ("geojson" === t.type || t.vectorLayerIds && -1 === t.vectorLayerIds.indexOf(i)) && this.fire(new Ct(new Error(`Source layer "${i}" does not exist on source "${t.id}" as specified by style layer "${e1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return !1;
                for(const e1 in this._sourceCaches)if (!this._sourceCaches[e1].loaded()) return !1;
                if (!this.imageManager.isLoaded()) return !1;
                if (!this.modelManager.isLoaded()) return !1;
                for (const { style: e1 } of this.fragments)if (!e1.loaded()) return !1;
                return !0;
            }
            _serializeImports() {
                if (this.stylesheet.imports) return this.stylesheet.imports.map((e1, t)=>{
                    const i = this.fragments[t];
                    return i && i.style && (e1.data = i.style.serialize()), e1;
                });
            }
            _serializeSources() {
                const e1 = {};
                for(const t in this._sourceCaches){
                    const i = this._sourceCaches[t].getSource();
                    e1[i.id] || (e1[i.id] = i.serialize());
                }
                return e1;
            }
            _serializeLayers(e1) {
                const t = [];
                for (const i of e1){
                    const e1 = this._layers[i];
                    e1 && "custom" !== e1.type && t.push(e1.serialize());
                }
                return t;
            }
            hasLightTransitions() {
                return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
            }
            hasFogTransition() {
                return !!this.fog && this.fog.hasTransition();
            }
            hasTransitions() {
                if (this.hasLightTransitions()) return !0;
                if (this.hasFogTransition()) return !0;
                for(const e1 in this._sourceCaches)if (this._sourceCaches[e1].hasTransition()) return !0;
                for(const e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                return !1;
            }
            get order() {
                return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
            }
            isLayerDraped(e1) {
                return !!this.terrain && ("function" == typeof e1.isLayerDraped ? e1.isLayerDraped(this.getLayerSourceCache(e1)) : tS.has(e1.type));
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            _checkLayer(e1) {
                const t = this.getOwnLayer(e1);
                if (t) return t;
                this.fire(new Ct(new Error(`The layer '${e1}' does not exist in the map's style.`)));
            }
            _checkSource(e1) {
                const t = this.getOwnSource(e1);
                if (t) return t;
                this.fire(new Ct(new Error(`The source '${e1}' does not exist in the map's style.`)));
            }
            update(e1) {
                if (!this._loaded) return;
                this.ambientLight && this.ambientLight.recalculate(e1), this.directionalLight && this.directionalLight.recalculate(e1);
                const t = this.calculateLightsBrightness();
                e1.brightness = t || 0, t !== this._brightness && (this._brightness = t, this.dispatcher.broadcast("setBrightness", t));
                const i = this._changes.isDirty();
                if (this._changes.isDirty()) {
                    const t = this._changes.getLayerUpdatesByScope();
                    for(const e1 in t){
                        const { updatedIds: i, removedIds: r } = t[e1];
                        (i || r) && this._updateWorkerLayers(e1, i, r);
                    }
                    this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(e1), this.light && this.light.updateTransitions(e1), this.ambientLight && this.ambientLight.updateTransitions(e1), this.directionalLight && this.directionalLight.updateTransitions(e1), this.fog && this.fog.updateTransitions(e1), this._changes.reset();
                }
                const r = {};
                for(const e1 in this._mergedSourceCaches){
                    const t = this._mergedSourceCaches[e1];
                    r[e1] = t.used, t.used = !1;
                }
                for (const t of this._mergedOrder){
                    const i = this._mergedLayers[t];
                    if (i.recalculate(e1, this._availableImages), !i.isHidden(e1.zoom)) {
                        const e1 = this.getLayerSourceCache(i);
                        e1 && (e1.used = !0);
                    }
                    if (!this._precompileDone && this._shouldPrecompile) for(let t = i.minzoom || 0; t < (i.maxzoom || 25.5); t++){
                        const t = this.map.painter;
                        if (t) {
                            const r = i.getProgramIds();
                            if (!r) continue;
                            for (const n of r){
                                const r = i.getDefaultProgramParams(n, e1.zoom);
                                r && (t.style = this, this.fog && (t._fogVisible = !0, r.overrideFog = !0, t.getOrCreateProgram(n, r)), t._fogVisible = !1, r.overrideFog = !1, t.getOrCreateProgram(n, r), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (r.overrideRtt = !0, t.getOrCreateProgram(n, r)));
                            }
                        }
                    }
                }
                this._shouldPrecompile && (this._precompileDone = !0);
                for(const e1 in r){
                    const t = this._mergedSourceCaches[e1];
                    r[e1] !== t.used && t.getSource().fire(new It("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: t.getSource().id
                    }));
                }
                this.light && this.light.recalculate(e1), this.terrain && this.terrain.recalculate(e1), this.fog && this.fog.recalculate(e1), this.z = e1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), i && this.fire(new It("data", {
                    dataType: "style"
                }));
            }
            _updateTilesForChangedImages() {
                const e1 = this._changes.getUpdatedImages();
                if (e1.length) {
                    for(const t in this._sourceCaches)this._sourceCaches[t].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e1);
                    this._changes.resetUpdatedImages();
                }
            }
            _updateWorkerLayers(e1, t, i) {
                const r = this.getFragmentStyle(e1);
                r && this.dispatcher.broadcast("updateLayers", {
                    layers: t ? r._serializeLayers(t) : [],
                    scope: e1,
                    removedIds: i || [],
                    options: r.options
                });
            }
            setState(e1) {
                if (this._checkLoaded(), YA(this, ms(e1))) return !1;
                (e1 = $(e1)).layers = kT(e1.layers);
                const t = (function(e1, t) {
                    if (!e1) return [
                        {
                            command: OT.setStyle,
                            args: [
                                t
                            ]
                        }
                    ];
                    let i = [];
                    try {
                        if (!x(e1.version, t.version)) return [
                            {
                                command: OT.setStyle,
                                args: [
                                    t
                                ]
                            }
                        ];
                        x(e1.center, t.center) || i.push({
                            command: OT.setCenter,
                            args: [
                                t.center
                            ]
                        }), x(e1.zoom, t.zoom) || i.push({
                            command: OT.setZoom,
                            args: [
                                t.zoom
                            ]
                        }), x(e1.bearing, t.bearing) || i.push({
                            command: OT.setBearing,
                            args: [
                                t.bearing
                            ]
                        }), x(e1.pitch, t.pitch) || i.push({
                            command: OT.setPitch,
                            args: [
                                t.pitch
                            ]
                        }), x(e1.sprite, t.sprite) || i.push({
                            command: OT.setSprite,
                            args: [
                                t.sprite
                            ]
                        }), x(e1.glyphs, t.glyphs) || i.push({
                            command: OT.setGlyphs,
                            args: [
                                t.glyphs
                            ]
                        }), x(e1.imports, t.imports) || function(e1 = [], t = [], i) {
                            t = t || [];
                            const r = (e1 = e1 || []).map(jT), n = t.map(jT), o = e1.reduce(GT, {}), s = t.reduce(GT, {}), a = r.slice();
                            let l, c, h, u;
                            for(l = 0, c = 0; l < r.length; l++)h = r[l], s.hasOwnProperty(h) ? c++ : (i.push({
                                command: OT.removeImport,
                                args: [
                                    h
                                ]
                            }), a.splice(a.indexOf(h, c), 1));
                            for(l = 0, c = 0; l < n.length; l++)h = n[n.length - 1 - l], a[a.length - 1 - l] !== h && (o.hasOwnProperty(h) ? (i.push({
                                command: OT.removeImport,
                                args: [
                                    h
                                ]
                            }), a.splice(a.lastIndexOf(h, a.length - c), 1)) : c++, u = a[a.length - l], i.push({
                                command: OT.addImport,
                                args: [
                                    s[h],
                                    u
                                ]
                            }), a.splice(a.length - l, 0, h));
                            for (const e1 of t){
                                const t = o[e1.id];
                                if (!t || x(t, e1)) continue;
                                x(t.config, e1.config) || i.push({
                                    command: OT.setImportConfig,
                                    args: [
                                        e1.id,
                                        e1.config
                                    ]
                                }), x(t.url, e1.url) || i.push({
                                    command: OT.setImportUrl,
                                    args: [
                                        e1.id,
                                        e1.url
                                    ]
                                });
                                const r = e1.data;
                                x(t && t.data, r) || i.push({
                                    command: OT.setImportData,
                                    args: [
                                        e1.id,
                                        r
                                    ]
                                });
                            }
                        }(e1.imports, t.imports, i), x(e1.transition, t.transition) || i.push({
                            command: OT.setTransition,
                            args: [
                                t.transition
                            ]
                        }), x(e1.light, t.light) || i.push({
                            command: OT.setLight,
                            args: [
                                t.light
                            ]
                        }), x(e1.fog, t.fog) || i.push({
                            command: OT.setFog,
                            args: [
                                t.fog
                            ]
                        }), x(e1.projection, t.projection) || i.push({
                            command: OT.setProjection,
                            args: [
                                t.projection
                            ]
                        }), x(e1.lights, t.lights) || i.push({
                            command: OT.setLights,
                            args: [
                                t.lights
                            ]
                        }), x(e1.camera, t.camera) || i.push({
                            command: OT.setCamera,
                            args: [
                                t.camera
                            ]
                        });
                        const r = {}, n = [];
                        !function(e1, t, i, r) {
                            let n;
                            for(n in t = t || {}, e1 = e1 || {})e1.hasOwnProperty(n) && (t.hasOwnProperty(n) || FT(n, i, r));
                            for(n in t){
                                if (!t.hasOwnProperty(n)) continue;
                                const o = t[n];
                                e1.hasOwnProperty(n) ? x(e1[n], o) || ("geojson" === e1[n].type && "geojson" === o.type && UT(e1, t, n) ? i.push({
                                    command: OT.setGeoJSONSourceData,
                                    args: [
                                        n,
                                        o.data
                                    ]
                                }) : NT(n, t, i, r)) : BT(n, t, i);
                            }
                        }(e1.sources, t.sources, n, r);
                        const o = [];
                        e1.layers && e1.layers.forEach((e1)=>{
                            e1.source && r[e1.source] ? i.push({
                                command: OT.removeLayer,
                                args: [
                                    e1.id
                                ]
                            }) : o.push(e1);
                        });
                        let s = e1.terrain;
                        s && r[s.source] && (i.push({
                            command: OT.setTerrain,
                            args: [
                                void 0
                            ]
                        }), s = void 0), i = i.concat(n), x(s, t.terrain) || i.push({
                            command: OT.setTerrain,
                            args: [
                                t.terrain
                            ]
                        }), function(e1, t, i) {
                            t = t || [];
                            const r = (e1 = e1 || []).map(jT), n = t.map(jT), o = e1.reduce(GT, {}), s = t.reduce(GT, {}), a = r.slice(), l = Object.create(null);
                            let c, h, u, d, p, f, m;
                            for(c = 0, h = 0; c < r.length; c++)u = r[c], s.hasOwnProperty(u) ? h++ : (i.push({
                                command: OT.removeLayer,
                                args: [
                                    u
                                ]
                            }), a.splice(a.indexOf(u, h), 1));
                            for(c = 0, h = 0; c < n.length; c++)u = n[n.length - 1 - c], a[a.length - 1 - c] !== u && (o.hasOwnProperty(u) ? (i.push({
                                command: OT.removeLayer,
                                args: [
                                    u
                                ]
                            }), a.splice(a.lastIndexOf(u, a.length - h), 1)) : h++, f = a[a.length - c], i.push({
                                command: OT.addLayer,
                                args: [
                                    s[u],
                                    f
                                ]
                            }), a.splice(a.length - c, 0, u), l[u] = !0);
                            for(c = 0; c < n.length; c++)if (u = n[c], d = o[u], p = s[u], !l[u] && !x(d, p)) {
                                if (x(d.source, p.source) && x(d["source-layer"], p["source-layer"]) && x(d.type, p.type)) {
                                    for(m in VT(d.layout, p.layout, i, u, null, OT.setLayoutProperty), VT(d.paint, p.paint, i, u, null, OT.setPaintProperty), x(d.slot, p.slot) || i.push({
                                        command: OT.setSlot,
                                        args: [
                                            u,
                                            p.slot
                                        ]
                                    }), x(d.filter, p.filter) || i.push({
                                        command: OT.setFilter,
                                        args: [
                                            u,
                                            p.filter
                                        ]
                                    }), x(d.minzoom, p.minzoom) && x(d.maxzoom, p.maxzoom) || i.push({
                                        command: OT.setLayerZoomRange,
                                        args: [
                                            u,
                                            p.minzoom,
                                            p.maxzoom
                                        ]
                                    }), d)d.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? VT(d[m], p[m], i, u, m.slice(6), OT.setPaintProperty) : x(d[m], p[m]) || i.push({
                                        command: OT.setLayerProperty,
                                        args: [
                                            u,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                    for(m in p)p.hasOwnProperty(m) && !d.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? VT(d[m], p[m], i, u, m.slice(6), OT.setPaintProperty) : x(d[m], p[m]) || i.push({
                                        command: OT.setLayerProperty,
                                        args: [
                                            u,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                } else i.push({
                                    command: OT.removeLayer,
                                    args: [
                                        u
                                    ]
                                }), f = a[a.lastIndexOf(u) + 1], i.push({
                                    command: OT.addLayer,
                                    args: [
                                        p,
                                        f
                                    ]
                                });
                            }
                        }(o, t.layers, i);
                    } catch (e1) {
                        console.warn("Unable to compute style diff:", e1), i = [
                            {
                                command: OT.setStyle,
                                args: [
                                    t
                                ]
                            }
                        ];
                    }
                    return i;
                })(this.serialize(), e1).filter((e1)=>!(e1.command in JA));
                if (0 === t.length) return !1;
                const i = t.filter((e1)=>!(e1.command in KA));
                if (i.length > 0) throw new Error(`Unimplemented: ${i.map((e1)=>e1.command).join(", ")}.`);
                return t.forEach((e1)=>{
                    this[e1.command].apply(this, e1.args);
                }), this.stylesheet = e1, this.mergeAll(), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), !0;
            }
            addImage(e1, t) {
                return this.getImage(e1) ? this.fire(new Ct(new Error("An image with this name already exists."))) : (this.imageManager.addImage(e1, this.scope, t), this._afterImageUpdated(e1), this);
            }
            updateImage(e1, t) {
                this.imageManager.updateImage(e1, this.scope, t);
            }
            getImage(e1) {
                return this.imageManager.getImage(e1, this.scope);
            }
            removeImage(e1) {
                return this.getImage(e1) ? (this.imageManager.removeImage(e1, this.scope), this._afterImageUpdated(e1), this) : this.fire(new Ct(new Error("No image with this name exists.")));
            }
            _afterImageUpdated(e1) {
                this._availableImages = this.imageManager.listImages(this.scope), this._changes.updateImage(e1), this.dispatcher.broadcast("setImages", {
                    scope: this.scope,
                    images: this._availableImages
                }), this.fire(new It("data", {
                    dataType: "style"
                }));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            addModel(e1, t, i = {}) {
                return this._checkLoaded(), this._validate(Ms, `models.${e1}`, t, null, i) || (this.modelManager.addModel(e1, t, this.scope), this._changes.setDirty()), this;
            }
            hasModel(e1) {
                return this.modelManager.hasModel(e1, this.scope);
            }
            removeModel(e1) {
                return this.hasModel(e1) ? (this.modelManager.removeModel(e1, this.scope), this) : this.fire(new Ct(new Error("No model with this ID exists.")));
            }
            listModels() {
                return this._checkLoaded(), this.modelManager.listModels(this.scope);
            }
            addSource(e1, t, i = {}) {
                if (this._checkLoaded(), void 0 !== this.getOwnSource(e1)) throw new Error(`There is already a source with ID "${e1}".`);
                if (!t.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(t).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(t.type) >= 0 && this._validate(_s, `sources.${e1}`, t, null, i)) return;
                this.map && this.map._collectResourceTiming && (t.collectResourceTiming = !0);
                const r = ST(e1, t, this.dispatcher, this);
                r.scope = this.scope, r.setEventedParent(this, ()=>({
                        isSourceLoaded: this._isSourceCacheLoaded(r.id),
                        source: r.serialize(),
                        sourceId: r.id
                    }));
                const n = (e1)=>{
                    const t = (e1 ? "symbol:" : "other:") + r.id, i = va(t, this.scope), n = this._sourceCaches[t] = new Lx(i, r, e1);
                    (e1 ? this._symbolSourceCaches : this._otherSourceCaches)[r.id] = n, n.onAdd(this.map);
                };
                n(!1), "vector" !== t.type && "geojson" !== t.type || n(!0), r.onAdd && r.onAdd(this.map), i.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
            }
            removeSource(e1) {
                this._checkLoaded();
                const t = this.getOwnSource(e1);
                if (!t) throw new Error("There is no source with this ID");
                for(const t in this._layers)if (this._layers[t].source === e1) return this.fire(new Ct(new Error(`Source "${e1}" cannot be removed while layer "${t}" is using it.`)));
                if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === e1) return this.fire(new Ct(new Error(`Source "${e1}" cannot be removed while terrain is using it.`)));
                const i = this.getOwnSourceCaches(e1);
                for (const e1 of i){
                    const t = ba(e1.id);
                    delete this._sourceCaches[t], this._changes.discardSourceCacheUpdate(e1.id), e1.fire(new It("data", {
                        sourceDataType: "metadata",
                        dataType: "source",
                        sourceId: e1.getSource().id
                    })), e1.setEventedParent(null), e1.clearTiles();
                }
                return delete this._otherSourceCaches[e1], delete this._symbolSourceCaches[e1], this.mergeSources(), t.setEventedParent(null), t.onRemove && t.onRemove(this.map), this._changes.setDirty(), this;
            }
            setGeoJSONSourceData(e1, t) {
                this._checkLoaded(), this.getOwnSource(e1).setData(t), this._changes.setDirty();
            }
            getOwnSource(e1) {
                const t = this.getOwnSourceCache(e1);
                return t && t.getSource();
            }
            getOwnSources() {
                const e1 = [];
                for(const t in this._otherSourceCaches){
                    const i = this.getOwnSourceCache(t);
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            setLights(e1) {
                if (this._checkLoaded(), !e1) return delete this.ambientLight, void delete this.directionalLight;
                const t = this._getTransitionParameters();
                for (const i of e1){
                    if (this._validate(ys, "lights", i)) return;
                    switch(i.type){
                        case "ambient":
                            if (this.ambientLight) {
                                const e1 = this.ambientLight;
                                e1.set(i), e1.updateTransitions(t);
                            } else this.ambientLight = new Mw(i, Aw, this.scope, this.options);
                            break;
                        case "directional":
                            if (this.directionalLight) {
                                const e1 = this.directionalLight;
                                e1.set(i), e1.updateTransitions(t);
                            } else this.directionalLight = new Mw(i, Sw, this.scope, this.options);
                    }
                }
                const i = new oa(this.z || 0, t);
                this.ambientLight && this.ambientLight.recalculate(i), this.directionalLight && this.directionalLight.recalculate(i), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
            }
            calculateLightsBrightness() {
                const e1 = this.directionalLight, t = this.ambientLight;
                if (!e1 || !t) return;
                const i = (e1)=>.2126 * (e1[0] <= .03928 ? e1[0] / 12.92 : Math.pow((e1[0] + .055) / 1.055, 2.4)) + .7152 * (e1[1] <= .03928 ? e1[1] / 12.92 : Math.pow((e1[1] + .055) / 1.055, 2.4)) + .0722 * (e1[2] <= .03928 ? e1[2] / 12.92 : Math.pow((e1[2] + .055) / 1.055, 2.4)), r = e1.properties.get("color").toArray01(), n = e1.properties.get("intensity"), o = e1.properties.get("direction"), s = 1 - J(o.x, o.y, o.z)[2] / 90, a = i(r) * n * s, l = t.properties.get("color").toArray01(), c = t.properties.get("intensity");
                return (a + i(l) * c) / 2;
            }
            getBrightness() {
                return this._brightness;
            }
            getLights() {
                if (!this.enable3dLights()) return null;
                const e1 = [];
                return this.directionalLight && e1.push(this.directionalLight.get()), this.ambientLight && e1.push(this.ambientLight.get()), e1;
            }
            enable3dLights() {
                return !!this.ambientLight && !!this.directionalLight;
            }
            getFragmentStyle(e1) {
                if (!e1) return this;
                if (xa(e1)) {
                    const t = function(e1) {
                        const t = e1.indexOf(ya);
                        return t >= 0 ? e1.slice(t + 1) : "";
                    }(e1), i = this.fragments.find(({ id: e1 })=>e1 === t);
                    if (!i) throw new Error(`Style import not found: ${e1}`);
                    const r = ba(e1);
                    return i.style.getFragmentStyle(r);
                }
                {
                    const t = this.fragments.find(({ id: t })=>t === e1);
                    if (!t) throw new Error(`Style import not found: ${e1}`);
                    return t.style;
                }
            }
            getConfigProperty(e1, t) {
                const i = this.getFragmentStyle(e1);
                if (!i) return null;
                const r = i.options.get(t), n = r ? r.value || r.default : null;
                return n ? n.serialize() : null;
            }
            setConfigProperty(e1, t, i) {
                const r = Eo(i);
                if ("success" !== r.result) return void YA(this, r.value);
                const n = r.value.expression, o = this.getFragmentStyle(e1);
                if (!o) return;
                const s = o.options.get(t);
                s && (o.options.set(t, {
                    ...s,
                    value: n
                }), o.updateConfigDependencies());
            }
            setConfig(e1, t) {
                if (this._config = e1, e1 || t) {
                    if (t) {
                        this.options.clear();
                        for(const i in t){
                            let r, n;
                            const o = Eo(t[i].default);
                            if ("success" === o.result && (r = o.value.expression), e1 && void 0 !== e1[i]) {
                                const t = Eo(e1[i]);
                                "success" === t.result && (n = t.value.expression);
                            }
                            const { minValue: s, maxValue: a, stepValue: l, type: c, values: h } = t[i];
                            r ? this.options.set(i, {
                                default: r,
                                value: n,
                                minValue: s,
                                maxValue: a,
                                stepValue: l,
                                type: c,
                                values: h
                            }) : this.fire(new Ct(new Error(`No schema defined for config option "${i}".`)));
                        }
                    } else this.fire(new Ct(new Error("Attempting to set config for a style without schema.")));
                }
            }
            updateConfigDependencies() {
                for (const e1 of this._configDependentLayers){
                    const t = this.getLayer(e1);
                    t && (t.possiblyEvaluateVisibility(), this._updateLayer(t));
                }
                this.ambientLight && this.ambientLight.scope === this.scope && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.scope === this.scope && this.directionalLight.updateConfig(this.options), this._changes.setDirty();
            }
            addLayer(e1, t, i = {}) {
                this._checkLoaded();
                const r = e1.id;
                if (this._layers[r]) return void this.fire(new Ct(new Error(`Layer with id "${r}" already exists on this map`)));
                let n;
                if ("custom" === e1.type) {
                    if (YA(this, function(e1) {
                        const t = [], i = e1.id;
                        return void 0 === i && t.push({
                            message: `layers.${i}: missing required property "id"`
                        }), void 0 === e1.render && t.push({
                            message: `layers.${i}: missing required method "render"`
                        }), e1.renderingMode && "2d" !== e1.renderingMode && "3d" !== e1.renderingMode && t.push({
                            message: `layers.${i}: property "renderingMode" must be either "2d" or "3d"`
                        }), t;
                    }(e1))) return;
                    n = ow(e1, this.options);
                } else {
                    if ("object" == typeof e1.source && (this.addSource(r, e1.source), e1 = k(e1 = $(e1), {
                        source: r
                    })), this._validate(bs, `layers.${r}`, e1, {
                        arrayIndex: -1
                    }, i)) return;
                    n = ow(e1, this.options), this._validateLayer(n), n.setEventedParent(this, {
                        layer: {
                            id: r
                        }
                    }), this._serializedLayers[n.id] = n.serialize();
                }
                n.isConfigDependent && this._configDependentLayers.add(n.fqid), n.setScope(this.scope);
                let o = this._order.length;
                if (t) {
                    const e1 = this._order.indexOf(t);
                    if (-1 === e1) return void this.fire(new Ct(new Error(`Layer with id "${t}" does not exist on this map.`)));
                    n.slot === this._layers[t].slot ? o = e1 : H(`Layer with id "${t}" has a different slot. Layers can only be rearranged within the same slot.`);
                }
                this._order.splice(o, 0, r), this._layerOrderChanged = !0, this._layers[r] = n;
                const s = this.getOwnLayerSourceCache(n), a = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                s && n.canCastShadows() && a && (s.castsShadows = !0);
                const l = this._changes.getRemovedLayer(n);
                if (l && n.source && s && "custom" !== n.type) {
                    this._changes.discardLayerRemoval(n);
                    const e1 = va(n.source, n.scope);
                    l.type !== n.type ? this._changes.updateSourceCache(e1, "clear") : (this._changes.updateSourceCache(e1, "reload"), s.pause());
                }
                this._updateLayer(n), n.onAdd && n.onAdd(this.map), n.scope = this.scope, this.mergeLayers();
            }
            moveLayer(e1, t) {
                this._checkLoaded();
                const i = this._checkLayer(e1);
                if (!i) return;
                if (e1 === t) return;
                const r = this._order.indexOf(e1);
                this._order.splice(r, 1);
                let n = this._order.length;
                if (t) {
                    const e1 = this._order.indexOf(t);
                    if (-1 === e1) return void this.fire(new Ct(new Error(`Layer with id "${t}" does not exist on this map.`)));
                    i.slot === this._layers[t].slot ? n = e1 : H(`Layer with id "${t}" has a different slot. Layers can only be rearranged within the same slot.`);
                }
                this._order.splice(n, 0, e1), this._changes.setDirty(), this._layerOrderChanged = !0, this.mergeLayers();
            }
            removeLayer(e1) {
                this._checkLoaded();
                const t = this._checkLayer(e1);
                if (!t) return;
                t.setEventedParent(null);
                const i = this._order.indexOf(e1);
                this._order.splice(i, 1), delete this._layers[e1], delete this._serializedLayers[e1], this._changes.setDirty(), this._layerOrderChanged = !0, this._configDependentLayers.delete(t.fqid), this._changes.removeLayer(t);
                const r = this.getOwnLayerSourceCache(t);
                if (r && r.castsShadows) {
                    let e1 = !1;
                    for(const i in this._layers)if (this._layers[i].source === t.source && this._layers[i].canCastShadows()) {
                        e1 = !0;
                        break;
                    }
                    r.castsShadows = e1;
                }
                t.onRemove && t.onRemove(this.map), this.mergeLayers();
            }
            getOwnLayer(e1) {
                return this._layers[e1];
            }
            hasLayer(e1) {
                return e1 in this._mergedLayers;
            }
            hasLayerType(e1) {
                for(const t in this._layers)if (this._layers[t].type === e1) return !0;
                return !1;
            }
            setLayerZoomRange(e1, t, i) {
                this._checkLoaded();
                const r = this._checkLayer(e1);
                r && (r.minzoom === t && r.maxzoom === i || (null != t && (r.minzoom = t), null != i && (r.maxzoom = i), this._updateLayer(r)));
            }
            setSlot(e1, t) {
                this._checkLoaded();
                const i = this._checkLayer(e1);
                i && i.slot !== t && (i.slot = t, this._updateLayer(i));
            }
            setFilter(e1, t, i = {}) {
                this._checkLoaded();
                const r = this._checkLayer(e1);
                if (r && !x(r.filter, t)) return null == t ? (r.filter = void 0, void this._updateLayer(r)) : void (this._validate(ws, `layers.${r.id}.filter`, t, {
                    layerType: r.type
                }, i) || (r.filter = $(t), this._updateLayer(r)));
            }
            getFilter(e1) {
                const t = this._checkLayer(e1);
                if (t) return $(t.filter);
            }
            setLayoutProperty(e1, t, i, r = {}) {
                this._checkLoaded();
                const n = this._checkLayer(e1);
                n && (x(n.getLayoutProperty(t), i) || (n.setLayoutProperty(t, i, r), n.isConfigDependent && this._configDependentLayers.add(n.fqid), this._updateLayer(n)));
            }
            getLayoutProperty(e1, t) {
                const i = this._checkLayer(e1);
                if (i) return i.getLayoutProperty(t);
            }
            setPaintProperty(e1, t, i, r = {}) {
                this._checkLoaded();
                const n = this._checkLayer(e1);
                if (!n) return;
                if (x(n.getPaintProperty(t), i)) return;
                const o = n.setPaintProperty(t, i, r);
                n.isConfigDependent && this._configDependentLayers.add(n.fqid), o && this._updateLayer(n), this._changes.updatePaintProperties(n);
            }
            getPaintProperty(e1, t) {
                const i = this._checkLayer(e1);
                if (i) return i.getPaintProperty(t);
            }
            setFeatureState(e1, t) {
                this._checkLoaded();
                const i = e1.source, r = e1.sourceLayer, n = this._checkSource(i);
                if (!n) return;
                const o = n.type;
                if ("geojson" === o && r) return void this.fire(new Ct(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === o && !r) return void this.fire(new Ct(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === e1.id && this.fire(new Ct(new Error("The feature id parameter must be provided.")));
                const s = this.getOwnSourceCaches(i);
                for (const i of s)i.setFeatureState(r, e1.id, t);
            }
            removeFeatureState(e1, t) {
                this._checkLoaded();
                const i = e1.source, r = this._checkSource(i);
                if (!r) return;
                const n = r.type, o = "vector" === n ? e1.sourceLayer : void 0;
                if ("vector" === n && !o) return void this.fire(new Ct(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (t && "string" != typeof e1.id && "number" != typeof e1.id) return void this.fire(new Ct(new Error("A feature id is required to remove its specific state property.")));
                const s = this.getOwnSourceCaches(i);
                for (const i of s)i.removeFeatureState(o, e1.id, t);
            }
            getFeatureState(e1) {
                this._checkLoaded();
                const t = e1.source, i = e1.sourceLayer, r = this._checkSource(t);
                if (r) {
                    if ("vector" !== r.type || i) return void 0 === e1.id && this.fire(new Ct(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(t)[0].getFeatureState(i, e1.id);
                    this.fire(new Ct(new Error("The sourceLayer parameter must be provided for vector source types.")));
                }
            }
            setTransition(e1) {
                return this.stylesheet.transition = k({}, this.stylesheet.transition, e1), this.transition = this.stylesheet.transition, this;
            }
            getTransition() {
                return k({}, this.stylesheet.transition);
            }
            serialize() {
                this._checkLoaded();
                const e1 = this.getTerrain(), t = e1 && this.terrain && this.terrain.scope === this.scope ? e1 : this.stylesheet.terrain;
                return Z({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    imports: this._serializeImports(),
                    schema: this.stylesheet.schema,
                    camera: this.stylesheet.camera,
                    light: this.stylesheet.light,
                    lights: this.stylesheet.lights,
                    terrain: t,
                    fog: this.stylesheet.fog,
                    center: this.stylesheet.center,
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: this._serializeSources(),
                    layers: this._serializeLayers(this._order)
                }, (e1)=>void 0 !== e1);
            }
            _updateLayer(e1) {
                this._changes.updateLayer(e1);
                const t = this.getLayerSourceCache(e1), i = va(e1.source, e1.scope), r = this._changes.getUpdatedSourceCaches();
                e1.source && !r[i] && t && "raster" !== t.getSource().type && (this._changes.updateSourceCache(i, "reload"), t.pause()), e1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e1) {
                const t = (e1)=>"fill-extrusion" === this._mergedLayers[e1].type, i = this.order, r = {}, n = [];
                for(let o = i.length - 1; o >= 0; o--){
                    const s = i[o];
                    if (t(s)) {
                        r[s] = o;
                        for (const t of e1){
                            const e1 = t[s];
                            if (e1) for (const t of e1)n.push(t);
                        }
                    }
                }
                n.sort((e1, t)=>t.intersectionZ - e1.intersectionZ);
                const o = [];
                for(let s = i.length - 1; s >= 0; s--){
                    const a = i[s];
                    if (t(a)) for(let e1 = n.length - 1; e1 >= 0; e1--){
                        const t = n[e1].feature;
                        if (r[t.layer.id] < s) break;
                        o.push(t), n.pop();
                    }
                    else for (const t of e1){
                        const e1 = t[a];
                        if (e1) for (const t of e1)o.push(t.feature);
                    }
                }
                return o;
            }
            queryRenderedFeatures(e1, t, i) {
                t && t.filter && this._validate(ws, "queryRenderedFeatures.filter", t.filter, null, t), t.scope = this.scope, t.availableImages = this._availableImages, t.serializedLayers = this._serializedLayers;
                const r = {};
                if (t && t.layers) {
                    if (!Array.isArray(t.layers)) return this.fire(new Ct(new Error("parameters.layers must be an Array."))), [];
                    for (const e1 of t.layers){
                        const t = this._mergedLayers[e1];
                        if (!t) return this.fire(new Ct(new Error(`The layer '${e1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        r[t.source] = !0;
                    }
                }
                const n = [], o = t.serializedLayers || {}, s = t && t.layers ? t.layers.some((e1)=>{
                    const t = this.getLayer(e1);
                    return t && t.is3D();
                }) : this.has3DLayers(), a = Iw.createFromScreenPoints(e1, i);
                for(const e1 in this._mergedSourceCaches){
                    const l = this._mergedSourceCaches[e1].getSource();
                    if (!l || l.scope !== t.scope) continue;
                    const c = this._mergedSourceCaches[e1].getSource().id;
                    t.layers && !r[c] || n.push(CT(this._mergedSourceCaches[e1], this._mergedLayers, o, a, t, i, s, !!this.map._showQueryGeometry));
                }
                return this.placement && n.push(function(e1, t, i, r, n, o, s) {
                    const a = {}, l = o.queryRenderedSymbols(r), c = [];
                    for (const e1 of Object.keys(l).map(Number))c.push(s[e1]);
                    c.sort(PT);
                    for (const i of c){
                        const r = i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId], t, i.bucketIndex, i.sourceLayerIndex, n.filter, n.layers, n.availableImages, e1);
                        for(const e1 in r){
                            const t = a[e1] = a[e1] || [], n = r[e1];
                            n.sort((e1, t)=>{
                                const r = i.featureSortOrder;
                                if (r) {
                                    const i = r.indexOf(e1.featureIndex);
                                    return r.indexOf(t.featureIndex) - i;
                                }
                                return t.featureIndex - e1.featureIndex;
                            });
                            for (const e1 of n)t.push(e1);
                        }
                    }
                    for(const t in a)a[t].forEach((r)=>{
                        const n = r.feature, o = i(e1[t]);
                        if (!o) return;
                        const s = o.getFeatureState(n.layer["source-layer"], n.id);
                        n.source = n.layer.source, n.layer["source-layer"] && (n.sourceLayer = n.layer["source-layer"]), n.state = s;
                    });
                    return a;
                }(this._mergedLayers, o, this.getLayerSourceCache.bind(this), a.screenGeometry, t, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(n);
            }
            querySourceFeatures(e1, t) {
                t && t.filter && this._validate(ws, "querySourceFeatures.filter", t.filter, null, t);
                const i = this.getOwnSourceCaches(e1);
                let r = [];
                for (const e1 of i)r = r.concat(zT(e1, t));
                return r;
            }
            addSourceType(e1, t, i) {
                return iS.getSourceType(e1) ? i(new Error(`A source type called "${e1}" already exists.`)) : (iS.setSourceType(e1, t), t.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: e1,
                    url: t.workerSourceURL
                }, i) : i(null, null));
            }
            getFlatLight() {
                return this.light.getLight();
            }
            setFlatLight(e1, t, i = {}) {
                this._checkLoaded();
                const r = this.light.getLight();
                let n = !1;
                for(const t in e1)if (!x(e1[t], r[t])) {
                    n = !0;
                    break;
                }
                if (!n) return;
                const o = this._getTransitionParameters();
                this.light.setLight(e1, t, i), this.light.updateTransitions(o);
            }
            getTerrain() {
                return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
                this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            setTerrain(e1, t = 1) {
                if (this._checkLoaded(), !e1) return delete this.terrain, null === e1 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                let i = e1;
                const r = null == e1.source;
                if (1 === t) {
                    if ("object" == typeof i.source) {
                        const e1 = "terrain-dem-src";
                        this.addSource(e1, i.source), i = $(i), i = k(i, {
                            source: e1
                        });
                    }
                    const e1 = k({}, i), t = {};
                    if (this.terrain && r) {
                        e1.source = this.terrain.get().source;
                        const i = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                        i && (t.style = i.serialize());
                    }
                    if (this._validate(xs, "terrain", e1, t)) return;
                }
                if (!this.terrain || this.terrain.scope !== this.scope && !r || this.terrain && t !== this.terrain.drapeRenderMode) {
                    if (!i) return;
                    this._createTerrain(i, t), this.fire(new It("data", {
                        dataType: "style"
                    }));
                } else {
                    const t = this.terrain, r = t.get();
                    for (const e1 of Object.keys(Pt.terrain))!i.hasOwnProperty(e1) && Pt.terrain[e1].default && (i[e1] = Pt.terrain[e1].default);
                    for(const i in e1)if (!x(e1[i], r[i])) {
                        t.set(e1, this.options), this.stylesheet.terrain = e1;
                        const i = this._getTransitionParameters({
                            duration: 0
                        });
                        t.updateTransitions(i), this.fire(new It("data", {
                            dataType: "style"
                        }));
                        break;
                    }
                }
                this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e1) {
                const t = this.fog = new vw(e1, this.map.transform);
                this.stylesheet.fog = t.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e1 of this.map._markers)e1._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(e1) {
                if (this._checkLoaded(), !e1) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
                if (this.fog) {
                    const t = this.fog;
                    if (!x(t.get(), e1)) {
                        t.set(e1), this.stylesheet.fog = t.get();
                        const i = this._getTransitionParameters({
                            duration: 0
                        });
                        t.updateTransitions(i);
                    }
                } else this._createFog(e1);
                this._markersNeedUpdate = !0;
            }
            _getTransitionParameters(e1) {
                return {
                    now: dt.now(),
                    transition: k(this.transition, e1)
                };
            }
            updateDrapeFirstLayers() {
                if (!this.terrain) return;
                const e1 = [], t = [];
                for(const i in this._mergedLayers)this.isLayerDraped(this._mergedLayers[i]) ? e1.push(i) : t.push(i);
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e1), this._drapedFirstOrder.push(...t);
            }
            _createTerrain(e1, t) {
                const i = this.terrain = new uw(e1, t, this.scope, this.options);
                1 === t && (this.stylesheet.terrain = e1), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
                const r = this._getTransitionParameters({
                    duration: 0
                });
                i.updateTransitions(r);
            }
            _force3DLayerUpdate() {
                for(const e1 in this._layers){
                    const t = this._layers[e1];
                    "fill-extrusion" === t.type && this._updateLayer(t);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e1 in this._layers){
                    const t = this._layers[e1];
                    "symbol" === t.type && this._updateLayer(t);
                }
            }
            _validate(e1, t, i, r, n = {}) {
                if (n && !1 === n.validate) return !1;
                const o = k({}, this.serialize());
                return YA(this, e1.call(ms, k({
                    key: t,
                    style: o,
                    value: i,
                    styleSpec: Pt
                }, r)));
            }
            _remove() {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), ta.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const e1 in this._mergedLayers)this._mergedLayers[e1].setEventedParent(null);
                for(const e1 in this._mergedSourceCaches)this._mergedSourceCaches[e1].clearTiles(), this._mergedSourceCaches[e1].setEventedParent(null);
                this.setEventedParent(null), delete this.fog, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.isRootStyle() && (this.imageManager.setEventedParent(null), this.modelManager.setEventedParent(null), this.dispatcher.remove());
            }
            clearSource(e1) {
                const t = this.getSourceCaches(e1);
                for (const e1 of t)e1.clearTiles();
            }
            clearSources() {
                for(const e1 in this._mergedSourceCaches)this._mergedSourceCaches[e1].clearTiles();
            }
            reloadSource(e1) {
                const t = this.getSourceCaches(e1);
                for (const e1 of t)e1.resume(), e1.reload();
            }
            reloadSources() {
                for (const e1 of this.getSources())e1.reload && e1.reload();
            }
            updateSources(e1) {
                let t;
                this.directionalLight && (t = $A(this.directionalLight));
                for(const i in this._mergedSourceCaches)this._mergedSourceCaches[i].update(e1, void 0, void 0, t);
            }
            _generateCollisionBoxes() {
                for(const e1 in this._sourceCaches){
                    const t = this._sourceCaches[e1];
                    t.resume(), t.reload();
                }
            }
            _updatePlacement(e1, t, i, r, n = !1) {
                let o = !1, s = !1;
                const a = {}, l = {};
                for (const t of this._mergedOrder){
                    const i = this._mergedLayers[t];
                    if ("symbol" !== i.type) continue;
                    const r = va(i.source, i.scope);
                    let n = a[r];
                    if (!n) {
                        const e1 = this.getLayerSourceCache(i);
                        if (!e1) continue;
                        const t = e1.getRenderableIds(!0).map((t)=>e1.getTileByID(t));
                        l[r] = t.slice(), n = a[r] = t.sort((e1, t)=>t.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t.tileID) ? -1 : 1));
                    }
                    const s = this.crossTileSymbolIndex.addLayer(i, n, e1.center.lng, e1.projection);
                    o = o || s;
                }
                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder), n = n || this._layerOrderChanged || 0 === i, this._layerOrderChanged && this.fire(new It("neworder")), (n || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(dt.now(), e1.zoom)) && (this.pauseablePlacement = new gE(e1, this._mergedOrder, n, t, i, r, this.placement, this.fog && e1.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, a, l), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(dt.now()), s = !0), o && this.pauseablePlacement.placement.setStale()), s || o) for (const e1 of this._mergedOrder){
                    const t = this._mergedLayers[e1];
                    "symbol" === t.type && this.placement.updateLayerOpacities(t, a[va(t.source, t.scope)]);
                }
                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(dt.now());
            }
            _releaseSymbolFadeTiles() {
                for(const e1 in this._sourceCaches)this._sourceCaches[e1].releaseSymbolFadeTiles();
            }
            addImport(e1) {
                this._checkLoaded();
                const t = this.stylesheet.imports = this.stylesheet.imports || [], i = t.findIndex(({ id: t })=>t === e1.id);
                return -1 !== i ? this.fire(new Ct(new Error(`Import with id '${e1.id}' already exists in the map's style.`))) : (t.push(e1), this._loadImports([
                    e1
                ], !0), this);
            }
            setImportUrl(e1, t) {
                this._checkLoaded();
                const i = this.stylesheet.imports || [], r = this.getImportIndex(e1);
                if (-1 === r) return this;
                i[r].url = t;
                const n = this.fragments[r];
                return n.style = this._createFragmentStyle(i[r]), n.style.on("style.import.load", ()=>this.mergeAll()), n.style.loadURL(t), this;
            }
            setImportData(e1, t) {
                this._checkLoaded();
                const i = this.getImportIndex(e1), r = this.stylesheet.imports || [];
                return -1 === i ? this : t ? (this.fragments[i].style.setState(t), this._reloadImports(), this) : (delete r[i].data, this.setImportUrl(e1, r[i].url));
            }
            setImportConfig(e1, t) {
                this._checkLoaded();
                const i = this.getImportIndex(e1), r = this.stylesheet.imports || [];
                if (-1 === i) return this;
                t ? r[i].config = t : delete r[i].config;
                const n = this.fragments[i], o = n.style.stylesheet && n.style.stylesheet.schema;
                return n.config = t, n.style.setConfig(t, o), n.style.updateConfigDependencies(), this;
            }
            removeImport(e1) {
                this._checkLoaded();
                const t = this.stylesheet.imports || [], i = this.getImportIndex(e1);
                return -1 === i || (t.splice(i, 1), this.fragments[i].style._remove(), this.fragments.splice(i, 1), this._reloadImports()), this;
            }
            getImportIndex(e1) {
                const t = (this.stylesheet.imports || []).findIndex((t)=>t.id === e1);
                return -1 === t && this.fire(new Ct(new Error(`Import '${e1}' does not exist in the map's style and cannot be updated.`))), t;
            }
            getLayer(e1) {
                return this._mergedLayers[e1];
            }
            getSources() {
                const e1 = [];
                for(const t in this._mergedOtherSourceCaches){
                    const i = this._mergedOtherSourceCaches[t];
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            getSource(e1, t) {
                const i = this.getSourceCache(e1, t);
                return i && i.getSource();
            }
            getLayerSource(e1) {
                const t = this.getLayerSourceCache(e1);
                return t && t.getSource();
            }
            getSourceCache(e1, t) {
                const i = va(e1, t);
                return this._mergedOtherSourceCaches[i];
            }
            getLayerSourceCache(e1) {
                const t = va(e1.source, e1.scope);
                return "symbol" === e1.type ? this._mergedSymbolSourceCaches[t] : this._mergedOtherSourceCaches[t];
            }
            getSourceCaches(e1) {
                const t = [];
                return this._mergedOtherSourceCaches[e1] && t.push(this._mergedOtherSourceCaches[e1]), this._mergedSymbolSourceCaches[e1] && t.push(this._mergedSymbolSourceCaches[e1]), t;
            }
            updateSourceCaches() {
                const e1 = this._changes.getUpdatedSourceCaches();
                for(const t in e1){
                    const i = e1[t];
                    "reload" === i ? this.reloadSource(t) : "clear" === i && this.clearSource(t);
                }
            }
            updateLayers(e1) {
                const t = this._changes.getUpdatedPaintProperties();
                for (const i of t){
                    const t = this.getLayer(i);
                    t && t.updateTransitions(e1);
                }
            }
            getImages(e1, t, i) {
                this.imageManager.getImages(t.icons, t.scope, i), this._updateTilesForChangedImages();
                const r = (e1)=>{
                    e1 && e1.setDependencies(t.tileID.key, t.type, t.icons);
                };
                r(this._otherSourceCaches[t.source]), r(this._symbolSourceCaches[t.source]);
            }
            getGlyphs(e1, t, i) {
                this.glyphManager.getGlyphs(t.stacks, t.scope, i);
            }
            getResource(e1, t, i) {
                return be(t, i);
            }
            getOwnSourceCache(e1) {
                return this._otherSourceCaches[e1];
            }
            getOwnLayerSourceCache(e1) {
                return "symbol" === e1.type ? this._symbolSourceCaches[e1.source] : this._otherSourceCaches[e1.source];
            }
            getOwnSourceCaches(e1) {
                const t = [];
                return this._otherSourceCaches[e1] && t.push(this._otherSourceCaches[e1]), this._symbolSourceCaches[e1] && t.push(this._symbolSourceCaches[e1]), t;
            }
            _isSourceCacheLoaded(e1) {
                const t = this.getOwnSourceCaches(e1);
                return 0 === t.length ? (this.fire(new Ct(new Error(`There is no source with ID '${e1}'`))), !1) : t.every((e1)=>e1.loaded());
            }
            has3DLayers() {
                return this._has3DLayers;
            }
            hasSymbolLayers() {
                return this._hasSymbolLayers;
            }
            hasCircleLayers() {
                return this._hasCircleLayers;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            destroy() {
                this._clearWorkerCaches(), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
            constructor(e1, t = {}){
                super(), this.map = e1, this.scope = t.scope || "", this.fragments = [], this.importDepth = t.importDepth || 0, this.importsCache = t.importsCache || new Map, this.resolvedImports = t.resolvedImports || new Set, this.transition = k({}, eS), this._buildingIndex = new DT(this), this.crossTileSymbolIndex = new CE, this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this._changes = t.styleChanges || new Ea, this.dispatcher = t.dispatcher ? t.dispatcher : new Ew(Ww(), this), t.imageManager ? this.imageManager = t.imageManager : (this.imageManager = new aw, this.imageManager.setEventedParent(this)), this.imageManager.createScope(this.scope), this.glyphManager = t.glyphManager ? t.glyphManager : new og(e1._requestManager, t.localFontFamily ? 2 : t.localIdeographFontFamily ? 1 : 0, t.localFontFamily || t.localIdeographFontFamily), t.modelManager ? this.modelManager = t.modelManager : (this.modelManager = new XA(e1._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._serializedLayers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._loaded = !1, this._precompileDone = !1, this._shouldPrecompile = !1, this._availableImages = [], this._order = [], this._markersNeedUpdate = !1, this.options = new Map, this._configDependentLayers = new Set, this._config = t.config, this.dispatcher.broadcast("setReferrer", ve());
                const i = this;
                this._rtlTextPluginCallback = iS.registerForPluginStateChange((e1)=>{
                    i.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: e1.pluginStatus,
                        pluginURL: e1.pluginURL
                    }, (e1, t)=>{
                        if (Qs(e1), t && t.every((e1)=>e1)) for(const e1 in i._sourceCaches){
                            const t = i._sourceCaches[e1], r = t.getSource().type;
                            "vector" !== r && "geojson" !== r || t.reload();
                        }
                    });
                }), this.on("data", (e1)=>{
                    if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
                    const t = this.getOwnSource(e1.sourceId);
                    if (t && t.vectorLayerIds) for(const e1 in this._layers){
                        const i = this._layers[e1];
                        i.source === t.id && this._validateLayer(i);
                    }
                });
            }
        }
        function rS(e1, t) {
            let i = !1, r = null;
            const n = ()=>{
                r = null, i && (e1(), r = setTimeout(n, t), i = !1);
            };
            return ()=>(i = !0, r || n(), r);
        }
        iS.getSourceType = function(e1) {
            return AT[e1];
        }, iS.setSourceType = function(e1, t) {
            AT[e1] = t;
        }, iS.registerForPluginStateChange = function(e1) {
            return e1({
                pluginStatus: Ks,
                pluginURL: Js
            }), ta.on("pluginStateChange", e1), e1;
        };
        class nS {
            addTo(e1) {
                return this._map = e1, t.addEventListener("hashchange", this._onHashChange, !1), e1.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), t.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const e1 = this._map;
                if (!e1) return "";
                const i = oS(e1);
                if (this._hashName) {
                    const e1 = this._hashName;
                    let r = !1;
                    const n = t.location.hash.slice(1).split("&").map((t)=>{
                        const n = t.split("=")[0];
                        return n === e1 ? (r = !0, `${n}=${i}`) : t;
                    }).filter((e1)=>e1);
                    return r || n.push(`${e1}=${i}`), `#${n.join("&")}`;
                }
                return `#${i}`;
            }
            _getCurrentHash() {
                const e1 = t.location.hash.replace("#", "");
                if (this._hashName) {
                    let t;
                    return e1.split("&").map((e1)=>e1.split("=")).forEach((e1)=>{
                        e1[0] === this._hashName && (t = e1);
                    }), (t && t[1] || "").split("/");
                }
                return e1.split("/");
            }
            _onHashChange() {
                const e1 = this._map;
                if (!e1) return !1;
                const t = this._getCurrentHash();
                if (t.length >= 3 && !t.some((e1)=>isNaN(e1))) {
                    const i = e1.dragRotate.isEnabled() && e1.touchZoomRotate.isEnabled() ? +(t[3] || 0) : e1.getBearing();
                    return e1.jumpTo({
                        center: [
                            +t[2],
                            +t[1]
                        ],
                        zoom: +t[0],
                        bearing: i,
                        pitch: +(t[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                const e1 = t.location.href.replace(/(#.+)?$/, this.getHashString());
                t.history.replaceState(t.history.state, null, e1);
            }
            constructor(e1){
                this._hashName = e1 && encodeURIComponent(e1), j([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = rS(this._updateHashUnthrottled.bind(this), 300);
            }
        }
        function oS(e1, t) {
            const i = e1.getCenter(), r = Math.round(100 * e1.getZoom()) / 100, n = Math.ceil((r * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), o = Math.pow(10, n), s = Math.round(i.lng * o) / o, a = Math.round(i.lat * o) / o, l = e1.getBearing(), c = e1.getPitch();
            let h = t ? `/${s}/${a}/${r}` : `${r}/${a}/${s}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const sS = {
            linearity: .3,
            easing: I(0, 0, .3, 1)
        }, aS = k({
            deceleration: 2500,
            maxSpeed: 1400
        }, sS), lS = k({
            deceleration: 20,
            maxSpeed: 1400
        }, sS), cS = k({
            deceleration: 1e3,
            maxSpeed: 360
        }, sS), hS = k({
            deceleration: 1e3,
            maxSpeed: 90
        }, sS);
        class uS {
            clear() {
                this._inertiaBuffer = [];
            }
            record(e1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: dt.now(),
                    settings: e1
                });
            }
            _drainInertiaBuffer() {
                const e1 = this._inertiaBuffer, t = dt.now();
                for(; e1.length > 0 && t - e1[0].time > 160;)e1.shift();
            }
            _onMoveEnd(e1) {
                if (this._map._prefersReducedMotion()) return;
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const t = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new y(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e1 } of this._inertiaBuffer)t.zoom += e1.zoomDelta || 0, t.bearing += e1.bearingDelta || 0, t.pitch += e1.pitchDelta || 0, e1.panDelta && t.pan._add(e1.panDelta), e1.around && (t.around = e1.around), e1.pinchAround && (t.pinchAround = e1.pinchAround);
                const i = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r = {};
                if (t.pan.mag()) {
                    const n = pS(t.pan.mag(), i, k({}, aS, e1 || {}));
                    r.offset = t.pan.mult(n.amount / t.pan.mag()), r.center = this._map.transform.center, dS(r, n);
                }
                if (t.zoom) {
                    const e1 = pS(t.zoom, i, lS);
                    r.zoom = this._map.transform.zoom + e1.amount, dS(r, e1);
                }
                if (t.bearing) {
                    const e1 = pS(t.bearing, i, cS);
                    r.bearing = this._map.transform.bearing + z(e1.amount, -179, 179), dS(r, e1);
                }
                if (t.pitch) {
                    const e1 = pS(t.pitch, i, hS);
                    r.pitch = this._map.transform.pitch + e1.amount, dS(r, e1);
                }
                if (r.zoom || r.bearing) {
                    const e1 = void 0 === t.pinchAround ? t.around : t.pinchAround;
                    r.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
                }
                return this.clear(), r.noMoveStart = !0, r;
            }
            constructor(e1){
                this._map = e1, this.clear();
            }
        }
        function dS(e1, t) {
            (!e1.duration || e1.duration < t.duration) && (e1.duration = t.duration, e1.easing = t.easing);
        }
        function pS(e1, t, i) {
            const { maxSpeed: r, linearity: n, deceleration: o } = i, s = z(e1 * n / (t / 1e3), -r, r), a = Math.abs(s) / (o * n);
            return {
                easing: i.easing,
                duration: 1e3 * a,
                amount: s * (a / 2)
            };
        }
        class fS extends It {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t, i, r = {}){
                const n = wt(t.getCanvasContainer(), i);
                super(e1, k({
                    point: n,
                    lngLat: t.unproject(n),
                    originalEvent: i
                }, r)), this._defaultPrevented = !1, this.target = t;
            }
        }
        class mS extends It {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t, i){
                const r = "touchend" === e1 ? i.changedTouches : i.touches, n = Tt(t.getCanvasContainer(), r), o = n.map((e1)=>t.unproject(e1)), s = n.reduce((e1, t, i, r)=>e1.add(t.div(r.length)), new y(0, 0));
                super(e1, {
                    points: n,
                    point: s,
                    lngLats: o,
                    lngLat: t.unproject(s),
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class _S extends It {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t, i){
                super(e1, {
                    originalEvent: i
                }), this._defaultPrevented = !1;
            }
        }
        class gS {
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e1) {
                return this._firePreventable(new _S(e1.type, this._map, e1));
            }
            mousedown(e1, t) {
                return this._mousedownPos = t, this._firePreventable(new fS(e1.type, this._map, e1));
            }
            mouseup(e1) {
                this._map.fire(new fS(e1.type, this._map, e1));
            }
            preclick(e1) {
                const t = k({}, e1);
                t.type = "preclick", this._map.fire(new fS(t.type, this._map, t));
            }
            click(e1, t) {
                this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || (this.preclick(e1), this._map.fire(new fS(e1.type, this._map, e1)));
            }
            dblclick(e1) {
                return this._firePreventable(new fS(e1.type, this._map, e1));
            }
            mouseover(e1) {
                this._map.fire(new fS(e1.type, this._map, e1));
            }
            mouseout(e1) {
                this._map.fire(new fS(e1.type, this._map, e1));
            }
            touchstart(e1) {
                return this._firePreventable(new mS(e1.type, this._map, e1));
            }
            touchmove(e1) {
                this._map.fire(new mS(e1.type, this._map, e1));
            }
            touchend(e1) {
                this._map.fire(new mS(e1.type, this._map, e1));
            }
            touchcancel(e1) {
                this._map.fire(new mS(e1.type, this._map, e1));
            }
            _firePreventable(e1) {
                if (this._map.fire(e1), e1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
            constructor(e1, t){
                this._map = e1, this._clickTolerance = t.clickTolerance;
            }
        }
        class yS {
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e1) {
                this._map.fire(new fS(e1.type, this._map, e1));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new fS("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e1) {
                this._delayContextMenu ? this._contextMenuEvent = e1 : this._map.fire(new fS(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
            constructor(e1){
                this._map = e1;
            }
        }
        class xS {
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e1, t) {
                this.isEnabled() && e1.shiftKey && 0 === e1.button && (yt(), this._startPos = this._lastPos = t, this._active = !0);
            }
            mousemoveWindow(e1, t) {
                if (!this._active) return;
                const i = t, r = this._startPos, n = this._lastPos;
                if (!r || !n || n.equals(i) || !this._box && i.dist(r) < this._clickTolerance) return;
                this._lastPos = i, this._box || (this._box = pt("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e1));
                const o = Math.min(r.x, i.x), s = Math.max(r.x, i.x), a = Math.min(r.y, i.y), l = Math.max(r.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${o}px,${a}px)`, this._box.style.width = s - o + "px", this._box.style.height = l - a + "px");
                });
            }
            mouseupWindow(e1, t) {
                if (!this._active) return;
                const i = this._startPos, r = t;
                if (i && 0 === e1.button) {
                    if (this.reset(), bt(), i.x !== r.x || i.y !== r.y) return this._map.fire(new It("boxzoomend", {
                        originalEvent: e1
                    })), {
                        cameraAnimation: (e1)=>e1.fitScreenCoordinates(i, r, this._map.getBearing(), {
                                linear: !1
                            })
                    };
                    this._fireEvent("boxzoomcancel", e1);
                }
            }
            keydown(e1) {
                this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), xt(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(e1, t) {
                return this._map.fire(new It(e1, {
                    originalEvent: t
                }));
            }
            constructor(e1, t){
                this._map = e1, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t.clickTolerance || 1;
            }
        }
        function vS(e1, t) {
            const i = {};
            for(let r = 0; r < e1.length; r++)i[e1[r].identifier] = t[r];
            return i;
        }
        class bS {
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(e1, t, i) {
                (this.centroid || i.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = e1.timeStamp), i.length === this.numTouches && (this.centroid = function(e1) {
                    const t = new y(0, 0);
                    for (const i of e1)t._add(i);
                    return t.div(e1.length);
                }(t), this.touches = vS(i, t)));
            }
            touchmove(e1, t, i) {
                if (this.aborted || !this.centroid) return;
                const r = vS(i, t);
                for(const e1 in this.touches){
                    const t = r[e1];
                    (!t || t.dist(this.touches[e1]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e1, t, i) {
                if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e1 = !this.aborted && this.centroid;
                    if (this.reset(), e1) return e1;
                }
            }
            constructor(e1){
                this.reset(), this.numTouches = e1.numTouches;
            }
        }
        class wS {
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e1, t, i) {
                this.singleTap.touchstart(e1, t, i);
            }
            touchmove(e1, t, i) {
                this.singleTap.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                const r = this.singleTap.touchend(e1, t, i);
                if (r) {
                    const t = e1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(r) < 30;
                    if (t && i || this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = r, this.count === this.numTaps) return this.reset(), r;
                }
            }
            constructor(e1){
                this.singleTap = new bS(e1), this.numTaps = e1.numTaps, this.reset();
            }
        }
        class TS {
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e1, t, i) {
                this._zoomIn.touchstart(e1, t, i), this._zoomOut.touchstart(e1, t, i);
            }
            touchmove(e1, t, i) {
                this._zoomIn.touchmove(e1, t, i), this._zoomOut.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                const r = this._zoomIn.touchend(e1, t, i), n = this._zoomOut.touchend(e1, t, i);
                return r ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t)=>t.easeTo({
                            duration: 300,
                            zoom: t.getZoom() + 1,
                            around: t.unproject(r)
                        }, {
                            originalEvent: e1
                        })
                }) : n ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t)=>t.easeTo({
                            duration: 300,
                            zoom: t.getZoom() - 1,
                            around: t.unproject(n)
                        }, {
                            originalEvent: e1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this._zoomIn = new wS({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new wS({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
        }
        const ES = {
            0: 1,
            2: 2
        };
        class MS {
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e1, t) {
                return !1;
            }
            _move(e1, t) {
                return {};
            }
            mousedown(e1, t) {
                if (this._lastPoint) return;
                const i = Et(e1);
                this._correctButton(e1, i) && (this._lastPoint = t, this._eventButton = i);
            }
            mousemoveWindow(e1, t) {
                const i = this._lastPoint;
                if (i) {
                    if (e1.preventDefault(), null != this._eventButton && function(e1, t) {
                        const i = ES[t];
                        return void 0 === e1.buttons || (e1.buttons & i) !== i;
                    }(e1, this._eventButton)) this.reset();
                    else if (this._moved || !(t.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t, this._move(i, t);
                }
            }
            mouseupWindow(e1) {
                this._lastPoint && Et(e1) === this._eventButton && (this._moved && bt(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(e1){
                this.reset(), this._clickTolerance = e1.clickTolerance || 1;
            }
        }
        class AS extends MS {
            mousedown(e1, t) {
                super.mousedown(e1, t), this._lastPoint && (this._active = !0);
            }
            _correctButton(e1, t) {
                return 0 === t && !e1.ctrlKey;
            }
            _move(e1, t) {
                return {
                    around: t,
                    panDelta: t.sub(e1)
                };
            }
        }
        class SS extends MS {
            _correctButton(e1, t) {
                return 0 === t && e1.ctrlKey || 2 === t;
            }
            _move(e1, t) {
                const i = .8 * (t.x - e1.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e1) {
                e1.preventDefault();
            }
        }
        class IS extends MS {
            _correctButton(e1, t) {
                return 0 === t && e1.ctrlKey || 2 === t;
            }
            _move(e1, t) {
                const i = -0.5 * (t.y - e1.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e1) {
                e1.preventDefault();
            }
        }
        class CS {
            reset() {
                this._active = !1, this._touches = {}, this._sum = new y(0, 0);
            }
            touchstart(e1, t, i) {
                return this._calculateTransform(e1, t, i);
            }
            touchmove(e1, t, i) {
                if (this._active && !(i.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === i.length && !ie()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return e1.cancelable && e1.preventDefault(), this._calculateTransform(e1, t, i);
                }
            }
            touchend(e1, t, i) {
                this._calculateTransform(e1, t, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(e1, t, i) {
                i.length > 0 && (this._active = !0);
                const r = vS(i, t), n = new y(0, 0), o = new y(0, 0);
                let s = 0;
                for(const e1 in r){
                    const t = r[e1], i = this._touches[e1];
                    i && (n._add(t), o._add(t.sub(i)), s++, r[e1] = t);
                }
                if (this._touches = r, s < this._minTouches || !o.mag()) return;
                const a = o.div(s);
                return this._sum._add(a), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: n.div(s),
                    panDelta: a
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = pt("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "null");
                }, 500);
            }
            constructor(e1, t){
                this._map = e1, this._el = e1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = t.clickTolerance || 1, this.reset(), j([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
        }
        class zS {
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e1) {}
            _move(e1, t, i) {
                return {};
            }
            touchstart(e1, t, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t[0],
                    t[1]
                ]));
            }
            touchmove(e1, t, i) {
                const r = this._firstTwoTouches;
                if (!r) return;
                e1.preventDefault();
                const [n, o] = r, s = PS(i, t, n), a = PS(i, t, o);
                if (!s || !a) return;
                const l = this._aroundCenter ? null : s.add(a).div(2);
                return this._move([
                    s,
                    a
                ], l, e1);
            }
            touchend(e1, t, i) {
                if (!this._firstTwoTouches) return;
                const [r, n] = this._firstTwoTouches, o = PS(i, t, r), s = PS(i, t, n);
                o && s || (this._active && bt(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e1) {
                this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this.reset();
            }
        }
        function PS(e1, t, i) {
            for(let r = 0; r < e1.length; r++)if (e1[r].identifier === i) return t[r];
        }
        function DS(e1, t) {
            return Math.log(e1 / t) / Math.LN2;
        }
        class RS extends zS {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e1) {
                this._startDistance = this._distance = e1[0].dist(e1[1]);
            }
            _move(e1, t) {
                const i = this._distance;
                if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs(DS(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: DS(this._distance, i),
                    pinchAround: t
                };
            }
        }
        function LS(e1, t) {
            return 180 * e1.angleWith(t) / Math.PI;
        }
        class kS extends zS {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e1) {
                this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
            }
            _move(e1, t) {
                const i = this._vector;
                if (this._vector = e1[0].sub(e1[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
                    bearingDelta: LS(this._vector, i),
                    pinchAround: t
                };
            }
            _isBelowThreshold(e1) {
                this._minDiameter = Math.min(this._minDiameter, e1.mag());
                const t = 25 / (Math.PI * this._minDiameter) * 360, i = this._startVector;
                if (!i) return !1;
                const r = LS(e1, i);
                return Math.abs(r) < t;
            }
        }
        function OS(e1) {
            return Math.abs(e1.y) > Math.abs(e1.x);
        }
        class BS extends zS {
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e1) {
                this._lastPoints = e1, OS(e1[0].sub(e1[1])) && (this._valid = !1);
            }
            _move(e1, t, i) {
                const r = this._lastPoints;
                if (!r) return;
                const n = e1[0].sub(r[0]), o = e1[1].sub(r[1]);
                return this._map._cooperativeGestures && !ie() && i.touches.length < 3 || (this._valid = this.gestureBeginsVertically(n, o, i.timeStamp), !this._valid) ? void 0 : (this._lastPoints = e1, this._active = !0, {
                    pitchDelta: (n.y + o.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e1, t, i) {
                if (void 0 !== this._valid) return this._valid;
                const r = e1.mag() >= 2, n = t.mag() >= 2;
                if (!r && !n) return;
                if (!r || !n) return null == this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const o = e1.y > 0 == t.y > 0;
                return OS(e1) && OS(t) && o;
            }
            constructor(e1){
                super(), this._map = e1;
            }
        }
        const FS = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class NS {
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e1) {
                if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
                let t = 0, i = 0, r = 0, n = 0, o = 0;
                switch(e1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t = -1;
                        break;
                    case 37:
                        e1.shiftKey ? i = -1 : (e1.preventDefault(), n = -1);
                        break;
                    case 39:
                        e1.shiftKey ? i = 1 : (e1.preventDefault(), n = 1);
                        break;
                    case 38:
                        e1.shiftKey ? r = 1 : (e1.preventDefault(), o = -1);
                        break;
                    case 40:
                        e1.shiftKey ? r = -1 : (e1.preventDefault(), o = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, r = 0), {
                    cameraAnimation: (s)=>{
                        const a = s.getZoom();
                        s.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: US,
                            zoom: t ? Math.round(a) + t * (e1.shiftKey ? 2 : 1) : a,
                            bearing: s.getBearing() + i * this._bearingStep,
                            pitch: s.getPitch() + r * this._pitchStep,
                            offset: [
                                -n * this._panStep,
                                -o * this._panStep
                            ],
                            center: s.getCenter()
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
            constructor(){
                const e1 = FS;
                this._panStep = e1.panStep, this._bearingStep = e1.bearingStep, this._pitchStep = e1.pitchStep, this._rotationDisabled = !1;
            }
        }
        function US(e1) {
            return e1 * (2 - e1);
        }
        const VS = 4.000244140625;
        class jS {
            setZoomRate(e1) {
                this._defaultZoomRate = e1;
            }
            setWheelZoomRate(e1) {
                this._wheelZoomRate = e1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(e1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(e1.ctrlKey || e1.metaKey || this.isZooming() || ie())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = e1.deltaMode === t.WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY;
                const r = dt.now(), n = r - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = r, 0 !== i && i % VS == 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : n > 400 ? (this._type = null, this._lastValue = i, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(n * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), e1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= i, this._active || this._start(e1)), e1.preventDefault();
            }
            _onTimeout(e1) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e1);
            }
            _start(e1) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t = wt(this._el, e1);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const e1 = this._map.transform;
                "wheel" === this._type && e1.projection.wrap && (e1._center.lng >= 180 || e1._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
                const t = ()=>e1._terrainEnabled() && this._aroundCoord ? e1.computeZoomRelativeTo(this._aroundCoord) : e1.zoom;
                if (0 !== this._delta) {
                    const i = "wheel" === this._type && Math.abs(this._delta) > VS ? this._wheelZoomRate : this._defaultZoomRate;
                    let r = 2 / (1 + Math.exp(-Math.abs(this._delta * i)));
                    this._delta < 0 && 0 !== r && (r = 1 / r);
                    const n = t(), o = Math.pow(2, n), s = "number" == typeof this._targetZoom ? e1.zoomScale(this._targetZoom) : o;
                    this._targetZoom = Math.min(e1.maxZoom, Math.max(e1.minZoom, e1.scaleZoom(s * r))), "wheel" === this._type && (this._startZoom = n, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
                }
                const i = "number" == typeof this._targetZoom ? this._targetZoom : t(), r = this._startZoom, n = this._easing;
                let o, s = !1;
                if ("wheel" === this._type && r && n) {
                    const e1 = Math.min((dt.now() - this._lastWheelEventTime) / 200, 1);
                    o = Kr(r, i, n(e1)), e1 < 1 ? this._frameId || (this._frameId = !0) : s = !0;
                } else o = i, s = !0;
                this._active = !0, s && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200));
                let a = o - t();
                return a * this._lastDelta < 0 && (a = 0), {
                    noInertia: !0,
                    needsRenderFrame: !s,
                    zoomDelta: a,
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(e1) {
                let t = C;
                if (this._prevEase) {
                    const e1 = this._prevEase, i = (dt.now() - e1.start) / e1.duration, r = e1.easing(i + .01) - e1.easing(i), n = .27 / Math.sqrt(r * r + 1e-4) * .01;
                    t = I(n, Math.sqrt(.0729 - n * n), .25, 1);
                }
                return this._prevEase = {
                    start: dt.now(),
                    duration: e1,
                    easing: t
                }, t;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = pt("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(t.navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "null");
                }, 200);
            }
            constructor(e1, t){
                this._map = e1, this._el = e1.getCanvasContainer(), this._handler = t, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222, j([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
        }
        class GS {
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
            constructor(e1, t){
                this._clickZoom = e1, this._tapZoom = t;
            }
        }
        class qS {
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e1, t) {
                return e1.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e1.shiftKey ? -1 : 1),
                            around: i.unproject(t)
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this.reset();
            }
        }
        class ZS {
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e1, t, i) {
                this._swipePoint || (this._tapTime && e1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e1, t, i));
            }
            touchmove(e1, t, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const r = t[0], n = r.y - this._swipePoint.y;
                        return this._swipePoint = r, e1.preventDefault(), this._active = !0, {
                            zoomDelta: n / 128
                        };
                    }
                } else this._tap.touchmove(e1, t, i);
            }
            touchend(e1, t, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e1, t, i) && (this._tapTime = e1.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            constructor(){
                this._tap = new wS({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
        }
        class $S {
            enable(e1) {
                this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
            constructor(e1, t, i){
                this._el = e1, this._mousePan = t, this._touchPan = i;
            }
        }
        class WS {
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
            constructor(e1, t, i){
                this._pitchWithRotate = e1.pitchWithRotate, this._mouseRotate = t, this._mousePitch = i;
            }
        }
        class HS {
            enable(e1) {
                this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
            constructor(e1, t, i, r){
                this._el = e1, this._touchZoom = t, this._touchRotate = i, this._tapDragZoom = r, this._rotationDisabled = !1, this._enabled = !0;
            }
        }
        const XS = (e1)=>e1.zoom || e1.drag || e1.pitch || e1.rotate;
        class YS extends It {
        }
        class KS {
            setup(e1, t) {
                const i = Du.sub([], t, e1);
                this.radius = Du.length(i[2] < 0 ? Du.div([], i, this.constants) : [
                    i[0],
                    i[1],
                    0
                ]);
            }
            projectRay(e1) {
                Du.div(e1, e1, this.constants), Du.normalize(e1, e1), Du.mul(e1, e1, this.constants);
                const t = Du.scale([], e1, this.radius);
                if (t[2] > 0) {
                    const e1 = Du.scale([], [
                        0,
                        0,
                        1
                    ], Du.dot(t, [
                        0,
                        0,
                        1
                    ])), i = Du.scale([], Du.normalize([], [
                        t[0],
                        t[1],
                        0
                    ]), this.radius), r = Du.add([], t, Du.scale([], Du.sub([], Du.add([], i, e1), t), 2));
                    t[0] = r[0], t[1] = r[1];
                }
                return t;
            }
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
        }
        function JS(e1) {
            return e1.panDelta && e1.panDelta.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta;
        }
        class QS {
            destroy() {
                for (const [e1, i, r] of this._listeners)e1.removeEventListener(i, e1 === t.document ? this.handleWindowEvent : this.handleEvent, r);
            }
            _addDefaultHandlers(e1) {
                const t = this._map, i = t.getCanvasContainer();
                this._add("mapEvent", new gS(t, e1));
                const r = t.boxZoom = new xS(t, e1);
                this._add("boxZoom", r);
                const n = new TS, o = new qS;
                t.doubleClickZoom = new GS(o, n), this._add("tapZoom", n), this._add("clickZoom", o);
                const s = new ZS;
                this._add("tapDragZoom", s);
                const a = t.touchPitch = new BS(t);
                this._add("touchPitch", a);
                const l = new SS(e1), c = new IS(e1);
                t.dragRotate = new WS(e1, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new AS(e1), u = new CS(t, e1);
                t.dragPan = new $S(i, h, u), this._add("mousePan", h), this._add("touchPan", u, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const d = new kS, p = new RS;
                t.touchZoomRotate = new HS(i, p, d, s), this._add("touchRotate", d, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", p, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new yS(t));
                const f = t.scrollZoom = new jS(t, this);
                this._add("scrollZoom", f, [
                    "mousePan"
                ]);
                const m = t.keyboard = new NS;
                this._add("keyboard", m);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e1.interactive && e1[i] && t[i].enable(e1[i]);
            }
            _add(e1, t, i) {
                this._handlers.push({
                    handlerName: e1,
                    handler: t,
                    allowed: i
                }), this._handlersById[e1] = t;
            }
            stop(e1) {
                if (!this._updatingCamera) {
                    for (const { handler: e1 } of this._handlers)e1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [], this._originalZoom = void 0;
                }
            }
            isActive() {
                for (const { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!XS(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
                return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e1, t, i) {
                for(const r in e1)if (r !== i && (!t || t.indexOf(r) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(e1) {
                this.handleEvent(e1, `${e1.type}Window`);
            }
            _getMapTouches(e1) {
                const t = [];
                for (const i of e1)this._el.contains(i.target) && t.push(i);
                return t;
            }
            handleEvent(e1, t) {
                this._updatingCamera = !0;
                const i = "renderFrame" === e1.type, r = i ? void 0 : e1, n = {
                    needsRenderFrame: !1
                }, o = {}, s = {}, a = e1.touches ? this._getMapTouches(e1.touches) : void 0, l = a ? Tt(this._el, a) : i ? void 0 : wt(this._el, e1);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let u;
                    this._blockedByActive(s, h, i) ? c.reset() : c[t || e1.type] && (u = c[t || e1.type](e1, l, a), this.mergeHandlerResult(n, o, u, i, r), u && u.needsRenderFrame && this._triggerRenderFrame()), (u || c.isActive()) && (s[i] = c);
                }
                const c = {};
                for(const e1 in this._previousActiveHandlers)s[e1] || (c[e1] = r);
                this._previousActiveHandlers = s, (Object.keys(c).length || JS(n)) && (this._changes.push([
                    n,
                    o,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(s).length || JS(n)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: h } = n;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(e1, t, i, r, n) {
                if (!i) return;
                k(e1, i);
                const o = {
                    handlerName: r,
                    originalEvent: i.originalEvent || n
                };
                void 0 !== i.zoomDelta && (t.zoom = o), void 0 !== i.panDelta && (t.drag = o), void 0 !== i.pitchDelta && (t.pitch = o), void 0 !== i.bearingDelta && (t.rotate = o);
            }
            _applyChanges() {
                const e1 = {}, t = {}, i = {};
                for (const [r, n, o] of this._changes)r.panDelta && (e1.panDelta = (e1.panDelta || new y(0, 0))._add(r.panDelta)), r.zoomDelta && (e1.zoomDelta = (e1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (e1.bearingDelta = (e1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (e1.pitchDelta = (e1.pitchDelta || 0) + r.pitchDelta), void 0 !== r.around && (e1.around = r.around), void 0 !== r.aroundCoord && (e1.aroundCoord = r.aroundCoord), void 0 !== r.pinchAround && (e1.pinchAround = r.pinchAround), r.noInertia && (e1.noInertia = r.noInertia), k(t, n), k(i, o);
                this._updateMapTransform(e1, t, i), this._changes = [];
            }
            _updateMapTransform(e1, t, i) {
                const r = this._map, n = r.transform, o = (e1)=>[
                        e1.x,
                        e1.y,
                        e1.z
                    ];
                if (((e1)=>{
                    const t = this._eventsInProgress.drag;
                    return t && !this._handlersById[t.handlerName].isActive();
                })() && !JS(e1)) {
                    const e1 = n.zoom;
                    n.cameraElevationReference = "sea", null != this._originalZoom && n._orthographicProjectionAtLowPitch && "globe" !== n.projection.name && 0 === n.pitch ? (n.cameraElevationReference = "ground", n.zoom = this._originalZoom) : (n.recenterOnTerrain(), n.cameraElevationReference = "ground"), e1 !== n.zoom && this._map._update(!0);
                }
                if (n._isCameraConstrained && r._stop(!0), !JS(e1)) return void this._fireEvents(t, i, !0);
                let { panDelta: s, zoomDelta: a, bearingDelta: l, pitchDelta: c, around: h, aroundCoord: u, pinchAround: d } = e1;
                n._isCameraConstrained && (a > 0 && (a = 0), n._isCameraConstrained = !1), void 0 !== d && (h = d), (a || ((e1)=>t[e1] && !this._eventsInProgress[e1])("drag")) && h && (this._dragOrigin = o(n.pointCoordinate3D(h)), this._originalZoom = n.zoom, this._trackingEllipsoid.setup(n._camera.position, this._dragOrigin)), n.cameraElevationReference = "sea", r._stop(!0), h = h || r.transform.centerPoint, l && (n.bearing += l), c && (n.pitch += c), n._updateCameraState();
                const p = [
                    0,
                    0,
                    0
                ];
                if (s) {
                    if ("mercator" === n.projection.name) {
                        const e1 = this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(h).dir), t = this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(h.sub(s)).dir);
                        p[0] = t[0] - e1[0], p[1] = t[1] - e1[1];
                    } else {
                        const e1 = n.pointCoordinate(h);
                        if ("globe" === n.projection.name) {
                            s = s.rotate(-n.angle);
                            const t = n._pixelsPerMercatorPixel / n.worldSize;
                            p[0] = -s.x * sp(tp(e1.y)) * t, p[1] = -s.y * sp(n.center.lat) * t;
                        } else {
                            const t = n.pointCoordinate(h.sub(s));
                            e1 && t && (p[0] = t.x - e1.x, p[1] = t.y - e1.y);
                        }
                    }
                }
                const f = n.zoom, m = [
                    0,
                    0,
                    0
                ];
                if (a) {
                    const e1 = o(u || n.pointCoordinate3D(h)), t = {
                        dir: Du.normalize([], Du.sub([], e1, n._camera.position))
                    };
                    if (t.dir[2] < 0) {
                        const i = n.zoomDeltaToMovement(e1, a);
                        Du.scale(m, t.dir, i);
                    }
                }
                const _ = Du.add(p, p, m);
                n._translateCameraConstrained(_), a && Math.abs(n.zoom - f) > 1e-4 && n.recenterOnTerrain(), n.cameraElevationReference = "ground", this._map._update(), e1.noInertia || this._inertia.record(e1), this._fireEvents(t, i, !0);
            }
            _fireEvents(e1, t, i) {
                const r = XS(this._eventsInProgress), n = XS(e1), o = {};
                for(const t in e1){
                    const { originalEvent: i } = e1[t];
                    this._eventsInProgress[t] || (o[`${t}start`] = i), this._eventsInProgress[t] = e1[t];
                }
                !r && n && this._fireEvent("movestart", n.originalEvent);
                for(const e1 in o)this._fireEvent(e1, o[e1]);
                n && this._fireEvent("move", n.originalEvent);
                for(const t in e1){
                    const { originalEvent: i } = e1[t];
                    this._fireEvent(t, i);
                }
                const s = {};
                let a;
                for(const e1 in this._eventsInProgress){
                    const { handlerName: i, originalEvent: r } = this._eventsInProgress[e1];
                    this._handlersById[i].isActive() || (delete this._eventsInProgress[e1], a = t[i] || r, s[`${e1}end`] = a);
                }
                for(const e1 in s)this._fireEvent(e1, s[e1]);
                const l = XS(this._eventsInProgress);
                if (i && (r || n) && !l) {
                    this._updatingCamera = !0;
                    const e1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), t = (e1)=>0 !== e1 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
                    e1 ? (t(e1.bearing || this._map.getBearing()) && (e1.bearing = 0), this._map.easeTo(e1, {
                        originalEvent: a
                    })) : (this._map.fire(new It("moveend", {
                        originalEvent: a
                    })), t(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(e1, t) {
                this._map.fire(new It(e1, t ? {
                    originalEvent: t
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
                    this._frameId = void 0, this.handleEvent(new YS("renderFrame", {
                        timeStamp: e1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
            constructor(e1, i){
                this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new uS(e1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new KS, this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i), j([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const r = this._el;
                this._listeners = [
                    [
                        r,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        r,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        r,
                        "touchend",
                        void 0
                    ],
                    [
                        r,
                        "touchcancel",
                        void 0
                    ],
                    [
                        r,
                        "mousedown",
                        void 0
                    ],
                    [
                        r,
                        "mousemove",
                        void 0
                    ],
                    [
                        r,
                        "mouseup",
                        void 0
                    ],
                    [
                        t.document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        t.document,
                        "mouseup",
                        void 0
                    ],
                    [
                        r,
                        "mouseover",
                        void 0
                    ],
                    [
                        r,
                        "mouseout",
                        void 0
                    ],
                    [
                        r,
                        "dblclick",
                        void 0
                    ],
                    [
                        r,
                        "click",
                        void 0
                    ],
                    [
                        r,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        r,
                        "keyup",
                        void 0
                    ],
                    [
                        r,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        r,
                        "contextmenu",
                        void 0
                    ],
                    [
                        t,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e1, i, r] of this._listeners)e1.addEventListener(i, e1 === t.document ? this.handleWindowEvent : this.handleEvent, r);
            }
        }
        const eI = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class tI extends zt {
            getCenter() {
                return new Wd(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e1, t) {
                return this.jumpTo({
                    center: e1
                }, t);
            }
            panBy(e1, t, i) {
                return e1 = y.convert(e1).mult(-1), this.panTo(this.transform.center, k({
                    offset: e1
                }, t), i);
            }
            panTo(e1, t, i) {
                return this.easeTo(k({
                    center: e1
                }, t), i);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e1, t) {
                return this.jumpTo({
                    zoom: e1
                }, t), this;
            }
            zoomTo(e1, t, i) {
                return this.easeTo(k({
                    zoom: e1
                }, t), i);
            }
            zoomIn(e1, t) {
                return this.zoomTo(this.getZoom() + 1, e1, t), this;
            }
            zoomOut(e1, t) {
                return this.zoomTo(this.getZoom() - 1, e1, t), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e1, t) {
                return this.jumpTo({
                    bearing: e1
                }, t), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e1, t) {
                return this.jumpTo({
                    padding: e1
                }, t), this;
            }
            rotateTo(e1, t, i) {
                return this.easeTo(k({
                    bearing: e1
                }, t), i);
            }
            resetNorth(e1, t) {
                return this.rotateTo(0, k({
                    duration: 1e3
                }, e1), t), this;
            }
            resetNorthPitch(e1, t) {
                return this.easeTo(k({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, e1), t), this;
            }
            snapToNorth(e1, t) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e1, t) {
                return this.jumpTo({
                    pitch: e1
                }, t), this;
            }
            cameraForBounds(e1, t) {
                e1 = sc.convert(e1);
                const i = t && t.bearing || 0, r = t && t.pitch || 0, n = e1.getNorthWest(), o = e1.getSouthEast();
                return this._cameraForBounds(this.transform, n, o, i, r, t);
            }
            _extendCameraOptions(e1) {
                const t = {
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0
                };
                if ("number" == typeof (e1 = k({
                    padding: t,
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, e1)).padding) {
                    const t = e1.padding;
                    e1.padding = {
                        top: t,
                        bottom: t,
                        right: t,
                        left: t
                    };
                }
                return e1.padding = k(t, e1.padding), e1;
            }
            _minimumAABBFrustumDistance(e1, t) {
                const i = t.max[0] - t.min[0], r = t.max[1] - t.min[1];
                return i / r > e1.aspect ? i / (2 * Math.tan(.5 * e1.fovX) * e1.aspect) : r / (2 * Math.tan(.5 * e1.fovY) * e1.aspect);
            }
            _cameraForBoundsOnGlobe(e1, t, i, r, n, o) {
                const s = e1.clone(), a = this._extendCameraOptions(o);
                s.bearing = r, s.pitch = n;
                const l = Wd.convert(t), c = Wd.convert(i), h = .5 * (l.lat + c.lat), u = .5 * (l.lng + c.lng), d = wd(h, u), p = Du.normalize([], d), f = Du.normalize([], Du.cross([], p, [
                    0,
                    1,
                    0
                ])), m = Du.cross([], f, p), _ = [
                    f[0],
                    f[1],
                    f[2],
                    0,
                    m[0],
                    m[1],
                    m[2],
                    0,
                    p[0],
                    p[1],
                    p[2],
                    0,
                    0,
                    0,
                    0,
                    1
                ], g = [
                    d,
                    wd(l.lat, l.lng),
                    wd(c.lat, l.lng),
                    wd(c.lat, c.lng),
                    wd(l.lat, c.lng),
                    wd(h, l.lng),
                    wd(h, c.lng),
                    wd(l.lat, u),
                    wd(c.lat, u)
                ];
                let y = ed.fromPoints(g.map((e1)=>[
                        Du.dot(f, e1),
                        Du.dot(m, e1),
                        Du.dot(p, e1)
                    ]));
                const x = Du.transformMat4([], y.center, _);
                0 === Du.squaredLength(x) && Du.set(x, 0, 0, 1), Du.normalize(x, x), Du.scale(x, x, rd), s.center = function([e1, t, i]) {
                    const r = Math.hypot(e1, t, i), n = Math.atan2(e1, i), o = .5 * Math.PI - Math.acos(-t / r);
                    return new Wd(T(n), T(o));
                }(x);
                const v = s.getWorldToCameraMatrix(), b = Au.invert(new Float64Array(16), v);
                y = ed.applyTransform(y, Au.multiply([], v, _)), Du.transformMat4(x, x, v);
                const w = .5 * (y.max[2] - y.min[2]), E = this._minimumAABBFrustumDistance(s, y), M = Du.scale([], [
                    0,
                    0,
                    1
                ], w), A = Du.add(M, x, M), S = E + (0 === s.pitch ? 0 : Du.distance(x, A)), I = s.globeCenterInViewSpace, C = Du.sub([], x, [
                    I[0],
                    I[1],
                    I[2]
                ]);
                Du.normalize(C, C), Du.scale(C, C, S);
                const z = Du.add([], x, C);
                Du.transformMat4(z, z, b);
                const P = qd / rd, D = Du.length(z), R = Qd(Math.max(D * P - qd, Number.EPSILON), 0), L = Math.min(s.zoomFromMercatorZAdjusted(R), a.maxZoom);
                return L > .5 * (td + id) ? (s.setProjection({
                    name: "mercator"
                }), s.zoom = L, this._cameraForBounds(s, t, i, r, n, o)) : {
                    center: s.center,
                    zoom: L,
                    bearing: r,
                    pitch: n
                };
            }
            queryTerrainElevation(e1, t) {
                const i = this.transform.elevation;
                return i ? (t = k({}, {
                    exaggerated: !0
                }, t), i.getAtPoint(lp.fromLngLat(e1), null, t.exaggerated)) : null;
            }
            _cameraForBounds(e1, t, i, r, n, o) {
                if ("globe" === e1.projection.name) return this._cameraForBoundsOnGlobe(e1, t, i, r, n, o);
                const s = e1.clone(), a = this._extendCameraOptions(o), l = s.padding;
                s.bearing = r, s.pitch = n;
                const c = Wd.convert(t), h = Wd.convert(i), u = new Wd(c.lng, h.lat), d = new Wd(h.lng, c.lat), p = s.project(c), f = s.project(h), m = this.queryTerrainElevation(c), _ = this.queryTerrainElevation(h), g = this.queryTerrainElevation(u), x = this.queryTerrainElevation(d), v = [
                    [
                        p.x,
                        p.y,
                        Math.min(m || 0, _ || 0, g || 0, x || 0)
                    ],
                    [
                        f.x,
                        f.y,
                        Math.max(m || 0, _ || 0, g || 0, x || 0)
                    ]
                ];
                let b = ed.fromPoints(v);
                const T = s.getWorldToCameraMatrix(), E = Au.invert(new Float64Array(16), T);
                b = ed.applyTransform(b, T);
                const M = Du.sub([], b.max, b.min), A = l.left || 0, S = l.right || 0, I = l.bottom || 0, C = l.top || 0, { left: z, right: P, top: D, bottom: R } = a.padding, L = .5 * (A + S), k = .5 * (C + I), O = Math.min(s.scaleZoom(s.scale * Math.min((s.width - (A + S + z + P)) / M[0], (s.height - (I + C + R + D)) / M[1])), a.maxZoom), B = s.scale / s.zoomScale(O);
                b = new ed([
                    b.min[0] - (z + L) * B,
                    b.min[1] - (R + k) * B,
                    b.min[2]
                ], [
                    b.max[0] + (P + L) * B,
                    b.max[1] + (D + k) * B,
                    b.max[2]
                ]);
                const F = .5 * M[2], N = this._minimumAABBFrustumDistance(s, b), U = [
                    0,
                    0,
                    1,
                    0
                ];
                yu.transformMat4(U, U, T), yu.normalize(U, U);
                const V = Du.scale([], U, N + F), j = Du.add([], b.center, V), G = ("number" == typeof a.offset.x && "number" == typeof a.offset.y ? new y(a.offset.x, a.offset.y) : y.convert(a.offset)).rotate(-w(r));
                b.center[0] -= G.x * B, b.center[1] += G.y * B, Du.transformMat4(b.center, b.center, E), Du.transformMat4(j, j, E);
                const q = [
                    b.center[0],
                    b.center[1],
                    j[2] * s.pixelsPerMeter
                ];
                Du.scale(q, q, 1 / s.worldSize);
                const Z = ep(q[0]), $ = tp(q[1]), W = Math.min(s._zoomFromMercatorZ(q[2]), a.maxZoom), H = new Wd(Z, $);
                return s.mercatorFromTransition && W < .5 * (td + id) ? (s.setProjection({
                    name: "globe"
                }), s.zoom = W, this._cameraForBounds(s, t, i, r, n, o)) : {
                    center: H,
                    zoom: W,
                    bearing: r,
                    pitch: n
                };
            }
            fitBounds(e1, t, i) {
                const r = this.cameraForBounds(e1, t);
                return this._fitInternal(r, t, i);
            }
            fitScreenCoordinates(e1, t, i, r, n) {
                const o = y.convert(e1), s = y.convert(t), a = new y(Math.min(o.x, s.x), Math.min(o.y, s.y)), l = new y(Math.max(o.x, s.x), Math.max(o.y, s.y));
                if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(o, s)) return this;
                const c = this.transform.pointLocation3D(a), h = this.transform.pointLocation3D(l), u = this.transform.pointLocation3D(new y(a.x, l.y)), d = this.transform.pointLocation3D(new y(l.x, a.y)), p = [
                    Math.min(c.lng, h.lng, u.lng, d.lng),
                    Math.min(c.lat, h.lat, u.lat, d.lat)
                ], f = [
                    Math.max(c.lng, h.lng, u.lng, d.lng),
                    Math.max(c.lat, h.lat, u.lat, d.lat)
                ], m = r && r.pitch ? r.pitch : this.getPitch(), _ = this._cameraForBounds(this.transform, p, f, i, m, r);
                return this._fitInternal(_, r, n);
            }
            _fitInternal(e1, t, i) {
                return e1 ? (delete (t = k(e1, t)).padding, t.linear ? this.easeTo(t, i) : this.flyTo(t, i)) : this;
            }
            jumpTo(e1, t) {
                this.stop();
                const i = e1.preloadOnly ? this.transform.clone() : this.transform;
                let r = !1, n = !1, o = !1;
                return "zoom" in e1 && i.zoom !== +e1.zoom && (r = !0, i.zoom = +e1.zoom), void 0 !== e1.center && (i.center = Wd.convert(e1.center)), "bearing" in e1 && i.bearing !== +e1.bearing && (n = !0, i.bearing = +e1.bearing), "pitch" in e1 && i.pitch !== +e1.pitch && (o = !0, i.pitch = +e1.pitch), null == e1.padding || i.isPaddingEqual(e1.padding) || (i.padding = e1.padding), e1.preloadOnly ? (this._preloadTiles(i), this) : (this.fire(new It("movestart", t)).fire(new It("move", t)), r && this.fire(new It("zoomstart", t)).fire(new It("zoom", t)).fire(new It("zoomend", t)), n && this.fire(new It("rotatestart", t)).fire(new It("rotate", t)).fire(new It("rotateend", t)), o && this.fire(new It("pitchstart", t)).fire(new It("pitch", t)).fire(new It("pitchend", t)), this.fire(new It("moveend", t)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || H(eI), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(e1, t) {
                const i = this.transform;
                if (!i.projection.supportsFreeCamera) return H(eI), this;
                this.stop();
                const r = i.zoom, n = i.pitch, o = i.bearing;
                i.setFreeCameraOptions(e1);
                const s = r !== i.zoom, a = n !== i.pitch, l = o !== i.bearing;
                return this.fire(new It("movestart", t)).fire(new It("move", t)), s && this.fire(new It("zoomstart", t)).fire(new It("zoom", t)).fire(new It("zoomend", t)), l && this.fire(new It("rotatestart", t)).fire(new It("rotate", t)).fire(new It("rotateend", t)), a && this.fire(new It("pitchstart", t)).fire(new It("pitch", t)).fire(new It("pitchend", t)), this.fire(new It("moveend", t)), this;
            }
            easeTo(e1, t) {
                this._stop(!1, e1.easeId), (!1 === (e1 = k({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: C
                }, e1)).animate || this._prefersReducedMotion(e1)) && (e1.duration = 0);
                const i = this.transform, r = this.getZoom(), n = this.getBearing(), o = this.getPitch(), s = this.getPadding(), a = "zoom" in e1 ? +e1.zoom : r, l = "bearing" in e1 ? this._normalizeBearing(e1.bearing, n) : n, c = "pitch" in e1 ? +e1.pitch : o, h = "padding" in e1 ? e1.padding : i.padding, u = y.convert(e1.offset);
                let d, p, f;
                if ("globe" === i.projection.name) {
                    const t = lp.fromLngLat(i.center), r = u.rotate(-i.angle);
                    t.x += r.x / i.worldSize, t.y += r.y / i.worldSize;
                    const n = t.toLngLat(), o = Wd.convert(e1.center || n);
                    this._normalizeCenter(o), d = i.centerPoint.add(r), p = new y(t.x, t.y).mult(i.worldSize), f = new y(Kd(o.lng), Jd(o.lat)).mult(i.worldSize).sub(p);
                } else {
                    d = i.centerPoint.add(u);
                    const t = i.pointLocation(d), r = Wd.convert(e1.center || t);
                    this._normalizeCenter(r), p = i.project(t), f = i.project(r).sub(p);
                }
                const m = i.zoomScale(a - r);
                let _, g;
                e1.around && (_ = Wd.convert(e1.around), g = i.locationPoint(_));
                const x = this._zooming || a !== r, v = this._rotating || n !== l, b = this._pitching || c !== o, w = !i.isPaddingEqual(h), T = (i)=>(y)=>{
                        if (x && (i.zoom = Kr(r, a, y)), v && (i.bearing = Kr(n, l, y)), b && (i.pitch = Kr(o, c, y)), w && (i.interpolatePadding(s, h, y), d = i.centerPoint.add(u)), _) i.setLocationAtPoint(_, g);
                        else {
                            const e1 = i.zoomScale(i.zoom - r), t = a > r ? Math.min(2, m) : Math.max(.5, m), n = Math.pow(t, 1 - y), o = i.unproject(p.add(f.mult(y * n)).mult(e1));
                            i.setLocationAtPoint(i.renderWorldCopies ? o.wrap() : o, d);
                        }
                        return e1.preloadOnly || this._fireMoveEvents(t), i;
                    };
                if (e1.preloadOnly) {
                    const t = this._emulate(T, e1.duration, i);
                    return this._preloadTiles(t), this;
                }
                const E = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = x, this._rotating = v, this._pitching = b, this._padding = w, this._easeId = e1.easeId, this._prepareEase(t, e1.noMoveStart, E), this._ease(T(i), (e1)=>{
                    "sea" === i.cameraElevationReference && i.recenterOnTerrain(), this._afterEase(t, e1);
                }, e1), this;
            }
            _prepareEase(e1, t, i = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), t || i.moving || this.fire(new It("movestart", e1)), this._zooming && !i.zooming && this.fire(new It("zoomstart", e1)), this._rotating && !i.rotating && this.fire(new It("rotatestart", e1)), this._pitching && !i.pitching && this.fire(new It("pitchstart", e1));
            }
            _fireMoveEvents(e1) {
                this.fire(new It("move", e1)), this._zooming && this.fire(new It("zoom", e1)), this._rotating && this.fire(new It("rotate", e1)), this._pitching && this.fire(new It("pitch", e1));
            }
            _afterEase(e1, t) {
                if (this._easeId && t && this._easeId === t) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const i = this._zooming, r = this._rotating, n = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, i && this.fire(new It("zoomend", e1)), r && this.fire(new It("rotateend", e1)), n && this.fire(new It("pitchend", e1)), this.fire(new It("moveend", e1));
            }
            flyTo(e1, t) {
                if (this._prefersReducedMotion(e1)) {
                    const i = O(e1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around"
                    ]);
                    return this.jumpTo(i, t);
                }
                this.stop(), e1 = k({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: C
                }, e1);
                const i = this.transform, r = this.getZoom(), n = this.getBearing(), o = this.getPitch(), s = this.getPadding(), a = "zoom" in e1 ? z(+e1.zoom, i.minZoom, i.maxZoom) : r, l = "bearing" in e1 ? this._normalizeBearing(e1.bearing, n) : n, c = "pitch" in e1 ? +e1.pitch : o, h = "padding" in e1 ? e1.padding : i.padding, u = i.zoomScale(a - r), d = y.convert(e1.offset);
                let p = i.centerPoint.add(d);
                const f = i.pointLocation(p), m = Wd.convert(e1.center || f);
                this._normalizeCenter(m);
                const _ = i.project(f), g = i.project(m).sub(_);
                let x = e1.curve;
                const v = Math.max(i.width, i.height), b = v / u, w = g.mag();
                if ("minZoom" in e1) {
                    const t = z(Math.min(e1.minZoom, r, a), i.minZoom, i.maxZoom), n = v / i.zoomScale(t - r);
                    x = Math.sqrt(n / w * 2);
                }
                const T = x * x;
                function E(e1) {
                    const t = (b * b - v * v + (e1 ? -1 : 1) * T * T * w * w) / (2 * (e1 ? b : v) * T * w);
                    return Math.log(Math.sqrt(t * t + 1) - t);
                }
                function M(e1) {
                    return (Math.exp(e1) - Math.exp(-e1)) / 2;
                }
                function A(e1) {
                    return (Math.exp(e1) + Math.exp(-e1)) / 2;
                }
                const S = E(0);
                let I = function(e1) {
                    return A(S) / A(S + x * e1);
                }, P = function(e1) {
                    var t;
                    return v * ((A(S) * (M(t = S + x * e1) / A(t)) - M(S)) / T) / w;
                }, D = (E(1) - S) / x;
                if (Math.abs(w) < 1e-6 || !isFinite(D)) {
                    if (Math.abs(v - b) < 1e-6) return this.easeTo(e1, t);
                    const i = b < v ? -1 : 1;
                    D = Math.abs(Math.log(b / v)) / x, P = function() {
                        return 0;
                    }, I = function(e1) {
                        return Math.exp(i * x * e1);
                    };
                }
                e1.duration = "duration" in e1 ? +e1.duration : 1e3 * D / ("screenSpeed" in e1 ? +e1.screenSpeed / x : +e1.speed), e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0);
                const R = n !== l, L = c !== o, B = !i.isPaddingEqual(h), F = (i)=>(u)=>{
                        const f = u * D, y = 1 / I(f);
                        i.zoom = 1 === u ? a : r + i.scaleZoom(y), R && (i.bearing = Kr(n, l, u)), L && (i.pitch = Kr(o, c, u)), B && (i.interpolatePadding(s, h, u), p = i.centerPoint.add(d));
                        const x = 1 === u ? m : i.unproject(_.add(g.mult(P(f))).mult(y));
                        return i.setLocationAtPoint(i.renderWorldCopies ? x.wrap() : x, p), i._updateCameraOnTerrain(), e1.preloadOnly || this._fireMoveEvents(t), i;
                    };
                if (e1.preloadOnly) {
                    const t = this._emulate(F, e1.duration, i);
                    return this._preloadTiles(t), this;
                }
                return this._zooming = !0, this._rotating = R, this._pitching = L, this._padding = B, this._prepareEase(t, !1), this._ease(F(i), ()=>this._afterEase(t), e1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _stop(e1, t) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const e1 = this._onEaseEnd;
                    this._onEaseEnd = void 0, e1.call(this, t);
                }
                if (!e1) {
                    const e1 = this.handlers;
                    e1 && e1.stop(!1);
                }
                return this;
            }
            _ease(e1, t, i) {
                !1 === i.animate || 0 === i.duration ? (e1(1), t()) : (this._easeStart = dt.now(), this._easeOptions = i, this._onEaseFrame = e1, this._onEaseEnd = t, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const e1 = Math.min((dt.now() - this._easeStart) / this._easeOptions.duration, 1), t = this._onEaseFrame;
                t && t(this._easeOptions.easing(e1)), e1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(e1, t) {
                e1 = D(e1, -180, 180);
                const i = Math.abs(e1 - t);
                return Math.abs(e1 - 360 - t) < i && (e1 -= 360), Math.abs(e1 + 360 - t) < i && (e1 += 360), e1;
            }
            _normalizeCenter(e1) {
                const t = this.transform;
                if (t.maxBounds) return;
                if ("globe" !== t.projection.name && !t.renderWorldCopies) return;
                const i = e1.lng - t.center.lng;
                e1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _prefersReducedMotion(e1) {
                return this._respectPrefersReducedMotion && dt.prefersReducedMotion && !(e1 && e1.essential);
            }
            _emulate(e1, t, i) {
                const r = Math.ceil(15 * t / 1e3), n = [], o = e1(i.clone());
                for(let e1 = 0; e1 <= r; e1++){
                    const t = o(e1 / r);
                    n.push(t.clone());
                }
                return n;
            }
            constructor(e1, t){
                super(), this._moving = !1, this._zooming = !1, this.transform = e1, this._bearingSnap = t.bearingSnap, this._respectPrefersReducedMotion = !1 !== t.respectPrefersReducedMotion, j([
                    "_renderFrameCallback"
                ], this);
            }
        }
        class iI {
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e1) {
                const t = this.options && this.options.compact;
                return this._map = e1, this._container = pt("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = pt("button", "mapboxgl-ctrl-attrib-button", this._container), pt("span", "mapboxgl-ctrl-icon", this._compactButton).setAttribute("aria-hidden", "true"), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = pt("div", "mapboxgl-ctrl-attrib-inner", this._container), t && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _setElementTitle(e1, t) {
                const i = this._map._getUIString(`AttributionControl.${t}`);
                e1.removeAttribute("title"), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let e1 = this._editLink;
                e1 || (e1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const t = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || n.ACCESS_TOKEN
                    }
                ];
                if (e1) {
                    const i = t.reduce((e1, i, r)=>(i.value && (e1 += `${i.key}=${i.value}${r < t.length - 1 ? "&" : ""}`), e1), "?");
                    e1.href = `${n.FEEDBACK_URL}/${i}#${oS(this._map, !0)}`, e1.rel = "noopener nofollow", this._setElementTitle(e1, "MapFeedback");
                }
            }
            _updateData(e1) {
                !e1 || "metadata" !== e1.sourceDataType && "visibility" !== e1.sourceDataType && "style" !== e1.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e1 = [];
                if (this._map.style.stylesheet) {
                    const e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                const t = this._map.style._mergedSourceCaches;
                for(const i in t){
                    const r = t[i];
                    if (r.used) {
                        const t = r.getSource();
                        t.attribution && e1.indexOf(t.attribution) < 0 && e1.push(t.attribution);
                    }
                }
                e1.sort((e1, t)=>e1.length - t.length), e1 = e1.filter((t, i)=>{
                    for(let r = i + 1; r < e1.length; r++)if (e1[r].indexOf(t) >= 0) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = [
                    ...this.options.customAttribution,
                    ...e1
                ] : e1.unshift(this.options.customAttribution));
                const i = e1.join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e1.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
            constructor(e1 = {}){
                this.options = e1, j([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
        }
        class rI {
            onAdd(e1) {
                this._map = e1, this._container = pt("div", "mapboxgl-ctrl");
                const t = pt("a", "mapboxgl-ctrl-logo");
                return t.target = "_blank", t.rel = "noopener nofollow", t.href = "https://www.mapbox.com/", t.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e1) {
                e1 && "metadata" !== e1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e1 = this._map.style._sourceCaches;
                if (0 === Object.entries(e1).length) return !0;
                for(const t in e1){
                    const i = e1[t].getSource();
                    if (i.hasOwnProperty("mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e1 = this._container.children;
                if (e1.length) {
                    const t = e1[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t.classList.add("mapboxgl-compact") : t.classList.remove("mapboxgl-compact");
                }
            }
            constructor(){
                j([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
        }
        class nI {
            add(e1) {
                const t = ++this._id;
                return this._queue.push({
                    callback: e1,
                    id: t,
                    cancelled: !1
                }), t;
            }
            remove(e1) {
                const t = this._currentlyRunning, i = t ? this._queue.concat(t) : this._queue;
                for (const t of i)if (t.id === e1) return void (t.cancelled = !0);
            }
            run(e1 = 0) {
                const t = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t)if (!i.cancelled && (i.callback(e1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
        }
        function oI(e1, t, i) {
            if (e1 = new Wd(e1.lng, e1.lat), t) {
                const r = new Wd(e1.lng - 360, e1.lat), n = new Wd(e1.lng + 360, e1.lat), o = 360 * Math.ceil(Math.abs(e1.lng - i.center.lng) / 360), s = i.locationPoint(e1).distSqr(t), a = t.x < 0 || t.y < 0 || t.x > i.width || t.y > i.height;
                i.locationPoint(r).distSqr(t) < s && (a || Math.abs(r.lng - i.center.lng) < o) ? e1 = r : i.locationPoint(n).distSqr(t) < s && (a || Math.abs(n.lng - i.center.lng) < o) && (e1 = n);
            }
            for(; Math.abs(e1.lng - i.center.lng) > 180;){
                const t = i.locationPoint(e1);
                if (t.x >= 0 && t.y >= 0 && t.x <= i.width && t.y <= i.height) break;
                e1.lng > i.center.lng ? e1.lng -= 360 : e1.lng += 360;
            }
            return e1;
        }
        const sI = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        class aI extends zt {
            addTo(e1) {
                return e1 === this._map || (this.remove(), this._map = e1, e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._updateMoving), e1.on("moveend", this._update), e1.on("remove", this._clearFadeTimer), e1._addMarker(this), this.setDraggable(this._draggable), this._update(), e1.on("click", this._onMapClick)), this;
            }
            remove() {
                const e1 = this._map;
                return e1 && (e1.off("click", this._onMapClick), e1.off("move", this._updateMoving), e1.off("moveend", this._update), e1.off("mousedown", this._addDragHandler), e1.off("touchstart", this._addDragHandler), e1.off("mouseup", this._onUp), e1.off("touchend", this._onUp), e1.off("mousemove", this._onMove), e1.off("touchmove", this._onMove), e1.off("remove", this._clearFadeTimer), e1._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(e1) {
                return this._lngLat = Wd.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            getElement() {
                return this._element;
            }
            setPopup(e1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e1) {
                    if (!("offset" in e1.options)) {
                        const t = 38.1, i = 13.5, r = Math.sqrt(Math.pow(i, 2) / 2);
                        e1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t
                            ],
                            "bottom-left": [
                                r,
                                -1 * (t - i + r)
                            ],
                            "bottom-right": [
                                -r,
                                -1 * (t - i + r)
                            ],
                            left: [
                                i,
                                -1 * (t - i)
                            ],
                            right: [
                                -i,
                                -1 * (t - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e1, e1._marker = this, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e1) {
                const t = e1.code, i = e1.charCode || e1.keyCode;
                "Space" !== t && "Enter" !== t && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e1) {
                const t = e1.originalEvent.target, i = this._element;
                this._popup && (t === i || i.contains(t)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e1 = this._popup;
                return e1 ? (e1.isOpen() ? (e1.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e1.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e1 = this._map, t = this._pos;
                if (!e1 || !t) return !1;
                const i = e1.unproject(t), r = e1.getFreeCameraOptions();
                if (!r.position) return !1;
                const n = r.position.toLngLat();
                return n.distanceTo(i) < .9 * n.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const e1 = this._map;
                if (!e1) return;
                const t = this._pos;
                if (!t || t.x < 0 || t.x > e1.transform.width || t.y < 0 || t.y > e1.transform.height) return void this._clearFadeTimer();
                const i = e1.unproject(t);
                let r;
                e1._showingGlobe() && Nd(e1.transform, this._lngLat) ? r = 0 : (r = 1 - e1._queryFogOpacity(i), e1.transform._terrainEnabled() && e1.getTerrain() && this._behindTerrain() && (r *= this._occludedOpacity)), this._element.style.opacity = `${r}`, this._element.style.pointerEvents = r > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(r), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e1 = this._pos;
                if (!e1 || !this._map) return;
                const t = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e1.x}px,${e1.y}px)\n            ${sI[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t.x}px,${t.y}px)\n        `;
            }
            _calculateXYTransform() {
                const e1 = this._pos, t = this._map, i = this.getPitchAlignment();
                if (!t || !e1 || "map" !== i) return "";
                if (!t._showingGlobe()) {
                    const e1 = t.getPitch();
                    return e1 ? `rotateX(${e1}deg)` : "";
                }
                const r = T(Fd(t.transform, this._lngLat)), n = e1.sub(Bd(t.transform)), o = Math.abs(n.x) + Math.abs(n.y);
                if (0 === o) return "";
                const s = r / o;
                return `rotateX(${-n.y * s}deg) rotateY(${n.x * s}deg)`;
            }
            _calculateZTransform() {
                const e1 = this._pos, t = this._map;
                if (!t || !e1) return "";
                let i = 0;
                const r = this.getRotationAlignment();
                if ("map" === r) {
                    if (t._showingGlobe()) {
                        const e1 = t.project(new Wd(this._lngLat.lng, this._lngLat.lat + .001)), r = t.project(new Wd(this._lngLat.lng, this._lngLat.lat - .001)).sub(e1);
                        i = T(Math.atan2(r.y, r.x)) - 90;
                    } else i = -t.getBearing();
                } else if ("horizon" === r) {
                    const r = P(4, 6, t.getZoom()), n = Bd(t.transform);
                    n.y += r * t.transform.height;
                    const o = e1.sub(n), s = T(Math.atan2(o.y, o.x));
                    i = (s > 90 ? s - 270 : s + 90) * (1 - r);
                }
                return i += this._rotation, i ? `rotateZ(${i}deg)` : "";
            }
            _update(e1) {
                t.cancelAnimationFrame(this._updateFrameId);
                const i = this._map;
                i && (i.transform.renderWorldCopies && (this._lngLat = oI(this._lngLat, this._pos, i.transform)), this._pos = i.project(this._lngLat), !0 === e1 ? this._updateFrameId = t.requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), i._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (i._showingGlobe() || i.getTerrain() || i.getFog()) && !this._fadeTimer && (this._fadeTimer = setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(e1) {
                return this._offset = y.convert(e1), this._update(), this;
            }
            addClassName(e1) {
                return this._element.classList.add(e1), this;
            }
            removeClassName(e1) {
                return this._element.classList.remove(e1), this;
            }
            toggleClassName(e1) {
                return this._element.classList.toggle(e1);
            }
            _onMove(e1) {
                const t = this._map;
                if (!t) return;
                const i = this._pointerdownPos, r = this._positionDelta;
                if (i && r) {
                    if (!this._isDragging) {
                        const r = this._clickTolerance || t._clickTolerance;
                        if (e1.point.dist(i) < r) return;
                        this._isDragging = !0;
                    }
                    this._pos = e1.point.sub(r), this._lngLat = t.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new It("dragstart"))), this.fire(new It("drag"));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const e1 = this._map;
                e1 && (e1.off("mousemove", this._onMove), e1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new It("dragend")), this._state = "inactive";
            }
            _addDragHandler(e1) {
                const t = this._map, i = this._pos;
                t && i && this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(i), this._pointerdownPos = e1.point, this._state = "pending", t.on("mousemove", this._onMove), t.on("touchmove", this._onMove), t.once("mouseup", this._onUp), t.once("touchend", this._onUp));
            }
            setDraggable(e1) {
                this._draggable = !!e1;
                const t = this._map;
                return t && (e1 ? (t.on("mousedown", this._addDragHandler), t.on("touchstart", this._addDragHandler)) : (t.off("mousedown", this._addDragHandler), t.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e1) {
                return this._rotation = e1 || 0, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e1) {
                return this._rotationAlignment = e1 || "auto", this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e1) {
                return this._pitchAlignment = e1 || "auto", this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e1) {
                return this._occludedOpacity = e1 || .2, this._update(), this;
            }
            getOccludedOpacity() {
                return this._occludedOpacity;
            }
            constructor(e1, i){
                if (super(), (e1 instanceof t.HTMLElement || i) && (e1 = k({
                    element: e1
                }, i)), j([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this), this._anchor = e1 && e1.anchor || "center", this._color = e1 && e1.color || "#3FB1CE", this._scale = e1 && e1.scale || 1, this._draggable = e1 && e1.draggable || !1, this._clickTolerance = e1 && e1.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = e1 && e1.rotation || 0, this._rotationAlignment = e1 && e1.rotationAlignment || "auto", this._pitchAlignment = e1 && e1.pitchAlignment && e1.pitchAlignment || "auto", this._updateMoving = ()=>this._update(!0), this._occludedOpacity = e1 && e1.occludedOpacity || .2, e1 && e1.element) this._element = e1.element, this._offset = y.convert(e1 && e1.offset || [
                    0,
                    0
                ]);
                else {
                    this._defaultMarker = !0, this._element = pt("div");
                    const t = 41, i = 27, r = ft("svg", {
                        display: "block",
                        height: t * this._scale + "px",
                        width: i * this._scale + "px",
                        viewBox: `0 0 ${i} ${t}`
                    }, this._element), n = ft("radialGradient", {
                        id: "shadowGradient"
                    }, ft("defs", {}, r));
                    ft("stop", {
                        offset: "10%",
                        "stop-opacity": .4
                    }, n), ft("stop", {
                        offset: "100%",
                        "stop-opacity": .05
                    }, n), ft("ellipse", {
                        cx: 13.5,
                        cy: 34.8,
                        rx: 10.5,
                        ry: 5.25,
                        fill: "url(#shadowGradient)"
                    }, r), ft("path", {
                        fill: this._color,
                        d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                    }, r), ft("path", {
                        opacity: .25,
                        d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                    }, r), ft("circle", {
                        fill: "white",
                        cx: 13.5,
                        cy: 13.5,
                        r: 5.5
                    }, r), this._offset = y.convert(e1 && e1.offset || [
                        0,
                        -14
                    ]);
                }
                this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e1)=>{
                    e1.preventDefault();
                }), this._element.addEventListener("mousedown", (e1)=>{
                    e1.preventDefault();
                });
                const r = this._element.classList;
                for(const e1 in sI)r.remove(`mapboxgl-marker-anchor-${e1}`);
                r.add(`mapboxgl-marker-anchor-${this._anchor}`);
                const n = e1 && e1.className ? e1.className.trim().split(/\s+/) : [];
                r.add(...n), this._popup = null;
            }
        }
        const lI = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px"
        }, cI = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function hI(e1 = new y(0, 0), t = "bottom") {
            if ("number" == typeof e1) {
                const i = Math.round(Math.sqrt(.5 * Math.pow(e1, 2)));
                switch(t){
                    case "top":
                        return new y(0, e1);
                    case "top-left":
                        return new y(i, i);
                    case "top-right":
                        return new y(-i, i);
                    case "bottom":
                        return new y(0, -e1);
                    case "bottom-left":
                        return new y(i, -i);
                    case "bottom-right":
                        return new y(-i, -i);
                    case "left":
                        return new y(e1, 0);
                    case "right":
                        return new y(-e1, 0);
                }
                return new y(0, 0);
            }
            return e1 instanceof y || Array.isArray(e1) ? y.convert(e1) : y.convert(e1[t] || [
                0,
                0
            ]);
        }
        class uI {
            getValue(e1) {
                if (e1 <= this._startTime) return this._start;
                if (e1 >= this._endTime) return this._end;
                const t = M((e1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - t) + this._end * t;
            }
            isEasing(e1) {
                return e1 >= this._startTime && e1 <= this._endTime;
            }
            jumpTo(e1) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e1, this._end = e1;
            }
            easeTo(e1, t, i) {
                this._start = this.getValue(t), this._end = e1, this._startTime = t, this._endTime = t + i;
            }
            constructor(e1){
                this.jumpTo(e1);
            }
        }
        const dI = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox logo",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        }, pI = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            performanceMetricsCollection: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            antialias: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            respectPrefersReducedMotion: !0,
            crossSourceCollisions: !0,
            collectResourceTiming: !1,
            testMode: !1
        }, fI = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class mI {
            down(e1, t) {
                this.mouseRotate.mousedown(e1, t), this.mousePitch && this.mousePitch.mousedown(e1, t), yt();
            }
            move(e1, t) {
                const i = this.map, r = this.mouseRotate.mousemoveWindow(e1, t), n = r && r.bearingDelta;
                if (n && i.setBearing(i.getBearing() + n), this.mousePitch) {
                    const r = this.mousePitch.mousemoveWindow(e1, t), n = r && r.pitchDelta;
                    n && i.setPitch(i.getPitch() + n);
                }
            }
            off() {
                const e1 = this.element;
                e1.removeEventListener("mousedown", this.mousedown), e1.removeEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), e1.removeEventListener("touchmove", this.touchmove), e1.removeEventListener("touchend", this.touchend), e1.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                xt(), t.removeEventListener("mousemove", this.mousemove), t.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(e1) {
                this.down(k({}, e1, {
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }), wt(this.element, e1)), t.addEventListener("mousemove", this.mousemove), t.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e1) {
                this.move(e1, wt(this.element, e1));
            }
            mouseup(e1) {
                this.mouseRotate.mouseupWindow(e1), this.mousePitch && this.mousePitch.mouseupWindow(e1), this.offTemp();
            }
            touchstart(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = Tt(this.element, e1.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }, this._startPos));
            }
            touchmove(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._lastPos = Tt(this.element, e1.targetTouches)[0], this.move({
                    preventDefault: ()=>e1.preventDefault()
                }, this._lastPos));
            }
            touchend(e1) {
                0 === e1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
            constructor(e1, t, i = !1){
                this._clickTolerance = 10, this.element = t, this.mouseRotate = new SS({
                    clickTolerance: e1.dragRotate._mouseRotate._clickTolerance
                }), this.map = e1, i && (this.mousePitch = new IS({
                    clickTolerance: e1.dragRotate._mousePitch._clickTolerance
                })), j([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), t.addEventListener("mousedown", this.mousedown), t.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), t.addEventListener("touchmove", this.touchmove), t.addEventListener("touchend", this.touchend), t.addEventListener("touchcancel", this.reset);
            }
        }
        const _I = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1
        }, gI = {
            maxWidth: 100,
            unit: "metric"
        }, yI = {
            kilometer: "km",
            meter: "m",
            mile: "mi",
            foot: "ft",
            "nautical-mile": "nm"
        }, xI = {
            version: i,
            supported: rt,
            setRTLTextPlugin: function(e1, t, i = !1) {
                if (Ks === Ws || Ks === Hs || Ks === Xs) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                Js = dt.resolveURL(e1), Ks = Ws, Ys = t, ea(), i || ra();
            },
            getRTLTextPluginStatus: ia,
            Map: class extends tI {
                _getMapId() {
                    return this._mapId;
                }
                addControl(e1, t) {
                    if (void 0 === t && (t = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !e1 || !e1.onAdd) return this.fire(new Ct(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = e1.onAdd(this);
                    this._controls.push(e1);
                    const r = this._controlPositions[t];
                    return -1 !== t.indexOf("bottom") ? r.insertBefore(i, r.firstChild) : r.appendChild(i), this;
                }
                removeControl(e1) {
                    if (!e1 || !e1.onRemove) return this.fire(new Ct(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const t = this._controls.indexOf(e1);
                    return t > -1 && this._controls.splice(t, 1), e1.onRemove(this), this;
                }
                hasControl(e1) {
                    return this._controls.indexOf(e1) > -1;
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(e1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const t = !this._moving;
                    return t && this.fire(new It("movestart", e1)).fire(new It("move", e1)), this.fire(new It("resize", e1)), t && this.fire(new It("moveend", e1)), this;
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(e1) {
                    return this.transform.setMaxBounds(sc.convert(e1)), this._update();
                }
                setMinZoom(e1) {
                    if ((e1 = null == e1 ? -2 : e1) >= -2 && e1 <= this.transform.maxZoom) return this.transform.minZoom = e1, this._update(), this.getZoom() < e1 ? this.setZoom(e1) : this.fire(new It("zoomstart")).fire(new It("zoom")).fire(new It("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(e1) {
                    if ((e1 = null == e1 ? 22 : e1) >= this.transform.minZoom) return this.transform.maxZoom = e1, this._update(), this.getZoom() > e1 ? this.setZoom(e1) : this.fire(new It("zoomstart")).fire(new It("zoom")).fire(new It("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(e1) {
                    if ((e1 = null == e1 ? 0 : e1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (e1 >= 0 && e1 <= this.transform.maxPitch) return this.transform.minPitch = e1, this._update(), this.getPitch() < e1 ? this.setPitch(e1) : this.fire(new It("pitchstart")).fire(new It("pitch")).fire(new It("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(e1) {
                    if ((e1 = null == e1 ? 85 : e1) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (e1 >= this.transform.minPitch) return this.transform.maxPitch = e1, this._update(), this.getPitch() > e1 ? this.setPitch(e1) : this.fire(new It("pitchstart")).fire(new It("pitch")).fire(new It("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e1) {
                    return this.transform.renderWorldCopies = e1, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
                }
                getLanguage() {
                    return this._language;
                }
                _parseLanguage(e1) {
                    return "auto" === e1 ? t.navigator.language : Array.isArray(e1) ? 0 === e1.length ? void 0 : e1.map((e1)=>"auto" === e1 ? t.navigator.language : e1) : e1;
                }
                setLanguage(e1) {
                    const t = this._parseLanguage(e1);
                    if (!this.style || t === this._language) return this;
                    this._language = t, this.style.reloadSources();
                    for (const e1 of this._controls)e1._setLanguage && e1._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e1) {
                    return this.style && e1 !== this._worldview ? (this._worldview = e1, this.style.reloadSources(), this) : this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e1) {
                    return this._lazyInitEmptyStyle(), e1 ? "string" == typeof e1 && (e1 = {
                        name: e1
                    }) : e1 = null, this._useExplicitProjection = !!e1, this._prioritizeAndUpdateProjection(e1, this.style.projection);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const e1 = this.transform, t = e1.projection.name;
                    let i;
                    "globe" === t && e1.zoom >= id ? (e1.setMercatorFromTransition(), i = !0) : "mercator" === t && e1.zoom < id && (e1.setProjection({
                        name: "globe"
                    }), i = !0), i && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate());
                }
                _prioritizeAndUpdateProjection(e1, t) {
                    return this._updateProjection(e1 || t || {
                        name: "mercator"
                    });
                }
                _updateProjection(e1) {
                    let t;
                    return t = "globe" === e1.name && this.transform.zoom >= id ? this.transform.setMercatorFromTransition() : this.transform.setProjection(e1), this.style.applyProjectionUpdate(), t && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
                }
                project(e1) {
                    return this.transform.locationPoint3D(Wd.convert(e1));
                }
                unproject(e1) {
                    return this.transform.pointLocation3D(y.convert(e1));
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _isDragging() {
                    return this.handlers && this.handlers._isDragging() || !1;
                }
                _createDelegatedListener(e1, t, i) {
                    if ("mouseenter" === e1 || "mouseover" === e1) {
                        let r = !1;
                        const n = (n)=>{
                            const o = t.filter((e1)=>this.getLayer(e1)), s = o.length ? this.queryRenderedFeatures(n.point, {
                                layers: o
                            }) : [];
                            s.length ? r || (r = !0, i.call(this, new fS(e1, this, n.originalEvent, {
                                features: s
                            }))) : r = !1;
                        }, o = ()=>{
                            r = !1;
                        };
                        return {
                            layers: new Set(t),
                            listener: i,
                            delegates: {
                                mousemove: n,
                                mouseout: o
                            }
                        };
                    }
                    if ("mouseleave" === e1 || "mouseout" === e1) {
                        let r = !1;
                        const n = (n)=>{
                            const o = t.filter((e1)=>this.getLayer(e1));
                            (o.length ? this.queryRenderedFeatures(n.point, {
                                layers: o
                            }) : []).length ? r = !0 : r && (r = !1, i.call(this, new fS(e1, this, n.originalEvent)));
                        }, o = (t)=>{
                            r && (r = !1, i.call(this, new fS(e1, this, t.originalEvent)));
                        };
                        return {
                            layers: new Set(t),
                            listener: i,
                            delegates: {
                                mousemove: n,
                                mouseout: o
                            }
                        };
                    }
                    {
                        const r = (e1)=>{
                            const r = t.filter((e1)=>this.getLayer(e1)), n = r.length ? this.queryRenderedFeatures(e1.point, {
                                layers: r
                            }) : [];
                            n.length && (e1.features = n, i.call(this, e1), delete e1.features);
                        };
                        return {
                            layers: new Set(t),
                            listener: i,
                            delegates: {
                                [e1]: r
                            }
                        };
                    }
                }
                on(e1, t, i) {
                    if (void 0 === i) return super.on(e1, t);
                    if (Array.isArray(t) || (t = [
                        t
                    ]), t) {
                        for (const e1 of t)if (!this._isValidId(e1)) return this;
                    }
                    const r = this._createDelegatedListener(e1, t, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e1] = this._delegatedListeners[e1] || [], this._delegatedListeners[e1].push(r);
                    for(const e1 in r.delegates)this.on(e1, r.delegates[e1]);
                    return this;
                }
                once(e1, t, i) {
                    if (void 0 === i) return super.once(e1, t);
                    if (Array.isArray(t) || (t = [
                        t
                    ]), t) {
                        for (const e1 of t)if (!this._isValidId(e1)) return this;
                    }
                    const r = this._createDelegatedListener(e1, t, i);
                    for(const e1 in r.delegates)this.once(e1, r.delegates[e1]);
                    return this;
                }
                off(e1, t, i) {
                    if (void 0 === i) return super.off(e1, t);
                    t = new Set(Array.isArray(t) ? t : [
                        t
                    ]);
                    for (const e1 of t)if (!this._isValidId(e1)) return this;
                    const r = (e1, t)=>{
                        if (e1.size !== t.size) return !1;
                        for (const i of e1)if (!t.has(i)) return !1;
                        return !0;
                    }, n = this._delegatedListeners ? this._delegatedListeners[e1] : void 0;
                    return n && ((e1)=>{
                        for(let n = 0; n < e1.length; n++){
                            const o = e1[n];
                            if (o.listener === i && r(o.layers, t)) {
                                for(const e1 in o.delegates)this.off(e1, o.delegates[e1]);
                                return e1.splice(n, 1), this;
                            }
                        }
                    })(n), this;
                }
                queryRenderedFeatures(e1, t) {
                    if (!this.style) return [];
                    if (void 0 !== t || void 0 === e1 || e1 instanceof y || Array.isArray(e1) || (t = e1, e1 = void 0), e1 = e1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], (t = t || {}).layers && Array.isArray(t.layers)) {
                        for (const e1 of t.layers)if (!this._isValidId(e1)) return [];
                    }
                    return this.style.queryRenderedFeatures(e1, t, this.transform);
                }
                querySourceFeatures(e1, t) {
                    return this._isValidId(e1) ? this.style.querySourceFeatures(e1, t) : [];
                }
                isPointOnSurface(e1) {
                    const { name: t } = this.transform.projection;
                    return "globe" !== t && "mercator" !== t && H(`${t} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(y.convert(e1));
                }
                setStyle(e1, t) {
                    return !1 !== (t = k({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily
                    }, t)).diff && t.localIdeographFontFamily === this._localIdeographFontFamily && t.localFontFamily === this._localFontFamily && this.style && e1 ? (this._diffStyle(e1, t), this) : (this._localIdeographFontFamily = t.localIdeographFontFamily, this._localFontFamily = t.localFontFamily, this._updateStyle(e1, t));
                }
                _getUIString(e1) {
                    const t = this._locale[e1];
                    if (null == t) throw new Error(`Missing UI string '${e1}'`);
                    return t;
                }
                _updateStyle(e1, t) {
                    return this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), e1 && (this.style = new iS(this, t || {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), "string" == typeof e1 ? this.style.loadURL(e1) : this.style.loadJSON(e1)), this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new iS(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                _diffStyle(e1, t) {
                    if ("string" == typeof e1) {
                        const i = this._requestManager.normalizeStyleURL(e1), r = this._requestManager.transformRequest(i, ye.Style);
                        we(r, (e1, i)=>{
                            e1 ? this.fire(new Ct(e1)) : i && this._updateDiff(i, t);
                        });
                    } else "object" == typeof e1 && this._updateDiff(e1, t);
                }
                _updateDiff(e1, t) {
                    try {
                        this.style.setState(e1) && this._update(!0);
                    } catch (i) {
                        H(`Unable to perform style diff: ${i.message || i.error || i}.  Rebuilding the style from scratch.`), this._updateStyle(e1, t);
                    }
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (H("There is no style added to the map."), !1);
                }
                _isValidId(e1) {
                    return null == e1 ? (this.fire(new Ct(new Error("IDs can't be empty."))), !1) : !xa(e1) || (this.fire(new Ct(new Error(`IDs can't contain special symbols: "${e1}".`))), !1);
                }
                addSource(e1, t) {
                    return this._isValidId(e1) ? (this._lazyInitEmptyStyle(), this.style.addSource(e1, t), this._update(!0)) : this;
                }
                isSourceLoaded(e1) {
                    return !!this._isValidId(e1) && !!this.style && this.style._isSourceCacheLoaded(e1);
                }
                areTilesLoaded() {
                    const e1 = this.style && this.style._sourceCaches;
                    for(const t in e1){
                        const i = e1[t]._tiles;
                        for(const e1 in i){
                            const t = i[e1];
                            if ("loaded" !== t.state && "errored" !== t.state) return !1;
                        }
                    }
                    return !0;
                }
                addSourceType(e1, t, i) {
                    this._lazyInitEmptyStyle(), this.style.addSourceType(e1, t, i);
                }
                removeSource(e1) {
                    return this._isValidId(e1) ? (this.style.removeSource(e1), this._updateTerrain(), this._update(!0)) : this;
                }
                getSource(e1) {
                    return this._isValidId(e1) ? this.style.getOwnSource(e1) : null;
                }
                addImage(e1, i, { pixelRatio: r = 1, sdf: n = !1, stretchX: o, stretchY: s, content: a } = {}) {
                    if (this._lazyInitEmptyStyle(), i instanceof t.HTMLImageElement || t.ImageBitmap && i instanceof t.ImageBitmap) {
                        const { width: t, height: l, data: c } = dt.getImageData(i);
                        this.style.addImage(e1, {
                            data: new ef({
                                width: t,
                                height: l
                            }, c),
                            pixelRatio: r,
                            stretchX: o,
                            stretchY: s,
                            content: a,
                            sdf: n,
                            version: 0
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new Ct(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: t, height: l } = i, c = i;
                        this.style.addImage(e1, {
                            data: new ef({
                                width: t,
                                height: l
                            }, new Uint8Array(c.data)),
                            pixelRatio: r,
                            stretchX: o,
                            stretchY: s,
                            content: a,
                            sdf: n,
                            version: 0,
                            userImage: c
                        }), c.onAdd && c.onAdd(this, e1);
                    }
                }
                updateImage(e1, i) {
                    this._lazyInitEmptyStyle();
                    const r = this.style.getImage(e1);
                    if (!r) return void this.fire(new Ct(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const n = i instanceof t.HTMLImageElement || t.ImageBitmap && i instanceof t.ImageBitmap ? dt.getImageData(i) : i, { width: o, height: s } = n;
                    void 0 !== o && void 0 !== s ? o === r.data.width && s === r.data.height ? (r.data.replace(n.data, !(i instanceof t.HTMLImageElement || t.ImageBitmap && i instanceof t.ImageBitmap)), this.style.updateImage(e1, r)) : this.fire(new Ct(new Error(`The width and height of the updated image (${o}, ${s})\n                must be that same as the previous version of the image\n                (${r.data.width}, ${r.data.height})`))) : this.fire(new Ct(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                }
                hasImage(e1) {
                    return e1 ? !!this.style && !!this.style.getImage(e1) : (this.fire(new Ct(new Error("Missing required image id"))), !1);
                }
                removeImage(e1) {
                    this.style.removeImage(e1);
                }
                loadImage(e1, i) {
                    Ie(this._requestManager.transformRequest(e1, ye.Image), (e1, r)=>{
                        i(e1, r instanceof t.HTMLImageElement ? dt.getImageData(r) : r);
                    });
                }
                listImages() {
                    return this.style.listImages();
                }
                addModel(e1, t) {
                    this._lazyInitEmptyStyle(), this.style.addModel(e1, t);
                }
                hasModel(e1) {
                    return e1 ? this.style.hasModel(e1) : (this.fire(new Ct(new Error("Missing required model id"))), !1);
                }
                removeModel(e1) {
                    this.style.removeModel(e1);
                }
                listModels() {
                    return this.style.listModels();
                }
                addLayer(e1, t) {
                    return this._isValidId(e1.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e1, t), this._update(!0)) : this;
                }
                moveLayer(e1, t) {
                    return this._isValidId(e1) ? (this.style.moveLayer(e1, t), this._update(!0)) : this;
                }
                removeLayer(e1) {
                    return this._isValidId(e1) ? (this.style.removeLayer(e1), this._update(!0)) : this;
                }
                getLayer(e1) {
                    return this._isValidId(e1) ? this.style.getOwnLayer(e1) : null;
                }
                setLayerZoomRange(e1, t, i) {
                    return this._isValidId(e1) ? (this.style.setLayerZoomRange(e1, t, i), this._update(!0)) : this;
                }
                setFilter(e1, t, i = {}) {
                    return this._isValidId(e1) ? (this.style.setFilter(e1, t, i), this._update(!0)) : this;
                }
                getFilter(e1) {
                    return this._isValidId(e1) ? this.style.getFilter(e1) : null;
                }
                setPaintProperty(e1, t, i, r = {}) {
                    return this._isValidId(e1) ? (this.style.setPaintProperty(e1, t, i, r), this._update(!0)) : this;
                }
                getPaintProperty(e1, t) {
                    return this._isValidId(e1) ? this.style.getPaintProperty(e1, t) : null;
                }
                setLayoutProperty(e1, t, i, r = {}) {
                    return this._isValidId(e1) ? (this.style.setLayoutProperty(e1, t, i, r), this._update(!0)) : this;
                }
                getLayoutProperty(e1, t) {
                    return this._isValidId(e1) ? this.style.getLayoutProperty(e1, t) : null;
                }
                getConfigProperty(e1, t) {
                    return this.style.getConfigProperty(e1, t);
                }
                setConfigProperty(e1, t, i) {
                    return this.style.setConfigProperty(e1, t, i), this._update(!0);
                }
                setLights(e1) {
                    if (this._lazyInitEmptyStyle(), e1 && 1 === e1.length && "flat" === e1[0].type) {
                        const t = e1[0];
                        t.properties ? this.style.setFlatLight(t.properties, t.id, {}) : this.style.setFlatLight({}, "flat");
                    } else this.style.setLights(e1), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
                    return this._update(!0);
                }
                getLights() {
                    const e1 = this.style.getLights() || [];
                    return 0 === e1.length && e1.push({
                        id: this.style.light.id,
                        type: "flat",
                        properties: this.style.getFlatLight()
                    }), e1;
                }
                setLight(e1, t = {}) {
                    return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([
                        {
                            id: "flat",
                            type: "flat",
                            properties: e1
                        }
                    ]);
                }
                getLight() {
                    return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
                }
                setTerrain(e1) {
                    return this._lazyInitEmptyStyle(), !e1 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e1), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e1), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                setCamera(e1) {
                    return this.style.setCamera(e1), this._triggerCameraUpdate(e1);
                }
                _triggerCameraUpdate(e1) {
                    return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e1["camera-projection"]));
                }
                getCamera() {
                    return this.style.camera;
                }
                _queryFogOpacity(e1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(Wd.convert(e1), this.transform) : 0;
                }
                setFeatureState(e1, t) {
                    return this._isValidId(e1.source) ? (this.style.setFeatureState(e1, t), this._update()) : this;
                }
                removeFeatureState(e1, t) {
                    return this._isValidId(e1.source) ? (this.style.removeFeatureState(e1, t), this._update()) : this;
                }
                getFeatureState(e1) {
                    return this._isValidId(e1.source) ? this.style.getFeatureState(e1) : null;
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const e1 = this._container.getBoundingClientRect().width || 400, i = this._container.getBoundingClientRect().height || 300;
                    let r, n, o, s = this._container;
                    for(; s && (!n || !o);){
                        const e1 = t.getComputedStyle(s).transform;
                        e1 && "none" !== e1 && (r = e1.match(/matrix.*\((.+)\)/)[1].split(", "), r[0] && "0" !== r[0] && "1" !== r[0] && (n = r[0]), r[3] && "0" !== r[3] && "1" !== r[3] && (o = r[3])), s = s.parentElement;
                    }
                    this._containerWidth = n ? Math.abs(e1 / n) : e1, this._containerHeight = o ? Math.abs(i / o) : i;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== t.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && H("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e1 = this._container;
                    e1.classList.add("mapboxgl-map"), (this._missingCSSCanary = pt("div", "mapboxgl-canary", e1)).style.visibility = "hidden", this._detectMissingCSS();
                    const t = this._canvasContainer = pt("div", "mapboxgl-canvas-container", e1);
                    this._canvas = pt("canvas", "mapboxgl-canvas", t), this._interactive && (t.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = pt("div", "mapboxgl-control-container", e1), r = this._controlPositions = {};
                    [
                        "top-left",
                        "top-right",
                        "bottom-left",
                        "bottom-right"
                    ].forEach((e1)=>{
                        r[e1] = pt("div", `mapboxgl-ctrl-${e1}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(e1, t) {
                    const i = dt.devicePixelRatio || 1;
                    this._canvas.width = i * Math.ceil(e1), this._canvas.height = i * Math.ceil(t), this._canvas.style.width = `${e1}px`, this._canvas.style.height = `${t}px`;
                }
                _addMarker(e1) {
                    this._markers.push(e1);
                }
                _removeMarker(e1) {
                    const t = this._markers.indexOf(e1);
                    -1 !== t && this._markers.splice(t, 1);
                }
                _addPopup(e1) {
                    this._popups.push(e1);
                }
                _removePopup(e1) {
                    const t = this._popups.indexOf(e1);
                    -1 !== t && this._popups.splice(t, 1);
                }
                _setupPainter() {
                    const e1 = k({}, rt.webGLContextAttributes, {
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }), t = this._canvas.getContext("webgl2", e1);
                    t ? (Ke(t, !0), this.painter = new UA(t, this._contextCreateOptions, this.transform), this.on("data", (e1)=>{
                        "source" === e1.dataType && this.painter.setTileLoadedFlag(!0);
                    }), o.testSupport(t)) : this.fire(new Ct(new Error("Failed to initialize WebGL")));
                }
                _contextLost(e1) {
                    e1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new It("webglcontextlost", {
                        originalEvent: e1
                    }));
                }
                _contextRestored(e1) {
                    this._setupPainter(), this.resize(), this._update(), this.fire(new It("webglcontextrestored", {
                        originalEvent: e1
                    }));
                }
                _onMapScroll(e1) {
                    if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                _update(e1) {
                    return this.style ? (this._styleDirty = this._styleDirty || e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e1) {
                    return this._update(), this._renderTaskQueue.add(e1);
                }
                _cancelRenderFrame(e1) {
                    this._renderTaskQueue.remove(e1);
                }
                _requestDomTask(e1) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e1() : this._domRenderTaskQueue.add(e1);
                }
                _render(e1) {
                    let i;
                    this.fire(new It("renderstart"));
                    const r = this.painter.context.extTimerQuery, n = dt.now(), o = this.painter.context.gl;
                    if (this.listens("gpu-timing-frame") && (i = o.createQuery(), o.beginQuery(r.TIME_ELAPSED_EXT, i)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], t.performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], t.performance.now())), this._renderTaskQueue.run(e1), this._domRenderTaskQueue.run(e1), this._removed) return;
                    this._updateProjectionTransition();
                    const s = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const e1 = this.transform.zoom, t = this.transform.pitch, i = dt.now(), r = new oa(e1, {
                            now: i,
                            fadeDuration: s,
                            pitch: t,
                            transition: this.style.transition
                        });
                        this.style.update(r);
                    }
                    this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let a = !1;
                    if (this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), a = this._updateAverageElevation(n), this.style.updateSources(this.transform), this._forceMarkerAndPopupUpdate()) : a = this._updateAverageElevation(n), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, s, this._crossSourceCollisions), this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        wireframe: {
                            terrain: this.showTerrainWireframe,
                            layers2D: this.showLayers2DWireframe,
                            layers3D: this.showLayers3DWireframe
                        },
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        showTileAABBs: this.showTileAABBs,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: s,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming
                    }), this.fire(new It("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new It("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), i) {
                        const e1 = dt.now() - n;
                        o.endQuery(r.TIME_ELAPSED_EXT), setTimeout(()=>{
                            const r = o.getQueryParameter(i, o.QUERY_RESULT) / 1e6;
                            o.deleteQuery(i), this.fire(new It("gpu-timing-frame", {
                                cpuTime: e1,
                                gpuTime: r
                            })), t.performance.mark("frame-gpu", {
                                startTime: n,
                                detail: {
                                    gpuTime: r
                                }
                            });
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const e1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const t = this.painter.queryGpuTimers(e1);
                            this.fire(new It("gpu-timing-layer", {
                                layerTimes: t
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const e1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const t = this.painter.queryGpuTimeDeferredRender(e1);
                            this.fire(new It("gpu-timing-deferred-render", {
                                gpuTime: t
                            }));
                        }, 50);
                    }
                    const l = this._sourcesDirty || this._styleDirty || this._placementDirty || a;
                    if (l || this._repaint) this.triggerRepaint();
                    else {
                        const e1 = !this.isMoving() && this.loaded();
                        if (e1 && (a = this._updateAverageElevation(n, !0)), a) this.triggerRepaint();
                        else if (this._triggerFrame(!1), e1 && (this.fire(new It("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                            const e1 = this._calculateSpeedIndex();
                            this.fire(new It("speedindexcompleted", {
                                speedIndex: e1
                            })), this.speedIndexTiming = !1;
                        }
                    }
                    !this._loaded || this._fullyLoaded || l || (this._fullyLoaded = !0, Qe.mark(Je.fullLoad), this._performanceMetricsCollection && We(this._requestManager._customAccessToken, {
                        width: this.painter.width,
                        height: this.painter.height,
                        interactionRange: this._interactionRange,
                        visibilityHidden: this._visibilityHidden,
                        terrainEnabled: !!this.painter.style.getTerrain(),
                        fogEnabled: !!this.painter.style.getFog(),
                        projection: this.getProjection().name,
                        zoom: this.transform.zoom,
                        renderer: this.painter.context.renderer,
                        vendor: this.painter.context.vendor
                    }), this._authenticate());
                }
                _forceMarkerAndPopupUpdate(e1) {
                    for (const t of this._markers)e1 && !this.getRenderWorldCopies() && (t._lngLat = t._lngLat.wrap()), t._update();
                    for (const t of this._popups)!e1 || this.getRenderWorldCopies() || t._trackPointer || (t._lngLat = t._lngLat.wrap()), t._update();
                }
                _updateAverageElevation(e1, t = !1) {
                    const i = (e1)=>(this.transform.averageElevation = e1, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    const r = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
                    if (r || (t || e1 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e1)) {
                        const t = this.transform.averageElevation;
                        let n = this.transform.sampleAverageElevation();
                        this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(n) ? n = 0 : this._averageElevationLastSampledAt = e1;
                        const o = Math.abs(t - n);
                        if (o > 1) {
                            if (this._isInitialLoad || r) return this._averageElevation.jumpTo(n), i(n);
                            this._averageElevation.easeTo(n, e1, 300);
                        } else if (o > 1e-4) return this._averageElevation.jumpTo(n), i(n);
                    }
                    return !!this._averageElevation.isEasing(e1) && i(this._averageElevation.getValue(e1));
                }
                _authenticate() {
                    Xe(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (e1)=>{
                        if (e1 && (e1.message === Ce || 401 === e1.status)) {
                            const e1 = this.painter.context.gl;
                            Ke(e1, !1), this._logoControl instanceof rI && this._logoControl._updateLogo(), e1 && e1.clear(e1.DEPTH_BUFFER_BIT | e1.COLOR_BUFFER_BIT | e1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new Ct(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                        }
                    }), Ze(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _updateTerrain() {
                    const e1 = this._isDragging();
                    this.painter.updateTerrain(this.style, e1);
                }
                _calculateSpeedIndex() {
                    const e1 = this.painter.canvasCopy(), t = this.painter.getCanvasCopiesAndTimestamps();
                    t.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, r = i.createFramebuffer();
                    function n(e1) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e1, 0);
                        const t = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t), t;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, r), this._canvasPixelComparison(n(e1), t.canvasCopies.map(n), t.timeStamps);
                }
                _canvasPixelComparison(e1, t, i) {
                    let r = i[1] - i[0];
                    const n = e1.length / 4;
                    for(let o = 0; o < t.length; o++){
                        const s = t[o];
                        let a = 0;
                        for(let t = 0; t < s.length; t += 4)s[t] === e1[t] && s[t + 1] === e1[t + 1] && s[t + 2] === e1[t + 2] && s[t + 3] === e1[t + 3] && (a += 1);
                        r += (i[o + 2] - i[o + 1]) * (1 - a / n);
                    }
                    return r;
                }
                remove() {
                    this._hash && this._hash.remove();
                    for (const e1 of this._controls)e1.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), void 0 !== t && (t.removeEventListener("resize", this._onWindowResize, !1), t.removeEventListener("orientationchange", this._onWindowResize, !1), t.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), t.removeEventListener("online", this._onWindowOnline, !1), t.removeEventListener("visibilitychange", this._onVisibilityChange, !1));
                    const e1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    e1 && e1.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), Ye.delete(this.painter.context.gl), this._removed = !0, this.fire(new It("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(e1) {
                    this._renderNextFrame = this._renderNextFrame || e1, this.style && !this._frame && (this._frame = dt.frame((e1)=>{
                        const t = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t && this._render(e1);
                    }));
                }
                _preloadTiles(e1) {
                    return R(this.style ? Object.values(this.style._sourceCaches) : [], (t, i)=>t._preloadTiles(e1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e1) {
                    this._trackResize && this.resize({
                        originalEvent: e1
                    })._update();
                }
                _onVisibilityChange() {
                    "hidden" === t.document.visibilityState && this._visibilityHidden++;
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e1) {
                    this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e1) {
                    this._showTerrainWireframe !== e1 && (this._showTerrainWireframe = e1, this._update());
                }
                get showLayers2DWireframe() {
                    return !!this._showLayers2DWireframe;
                }
                set showLayers2DWireframe(e1) {
                    this._showLayers2DWireframe !== e1 && (this._showLayers2DWireframe = e1, this._update());
                }
                get showLayers3DWireframe() {
                    return !!this._showLayers3DWireframe;
                }
                set showLayers3DWireframe(e1) {
                    this._showLayers3DWireframe !== e1 && (this._showLayers3DWireframe = e1, this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e1) {
                    this._speedIndexTiming !== e1 && (this._speedIndexTiming = e1, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e1) {
                    this._showPadding !== e1 && (this._showPadding = e1, this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e1) {
                    this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e1) {
                    this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e1) {
                    this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e1) {
                    this._vertices = e1, this._update();
                }
                get showTileAABBs() {
                    return !!this._showTileAABBs;
                }
                set showTileAABBs(e1) {
                    this._showTileAABBs !== e1 && (this._showTileAABBs = e1, e1 && this._update());
                }
                _setCacheLimits(e1, t) {
                    !function(e1, t) {
                        ce = e1, he = t;
                    }(e1, t);
                }
                get version() {
                    return i;
                }
                constructor(e1){
                    Qe.mark(Je.create);
                    const i = e1;
                    if (null != (e1 = k({}, pI, e1)).minZoom && null != e1.maxZoom && e1.minZoom > e1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != e1.minPitch && null != e1.maxPitch && e1.minPitch > e1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != e1.minPitch && e1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != e1.maxPitch && e1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (e1.antialias && function(e1) {
                        const t = e1.navigator ? e1.navigator.userAgent : null;
                        return !!function(e1) {
                            if (null == te) {
                                const t = e1.navigator ? e1.navigator.userAgent : null;
                                te = !!e1.safari || !(!t || !(/\b(iPad|iPhone|iPod)\b/.test(t) || t.match("Safari") && !t.match("Chrome")));
                            }
                            return te;
                        }(e1) && t && (t.match("Version/15.4") || t.match("Version/15.5") || t.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/));
                    }(t) && (e1.antialias = !1, H("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new Tv(e1.minZoom, e1.maxZoom, e1.minPitch, e1.maxPitch, e1.renderWorldCopies), e1), this._interactive = e1.interactive, this._minTileCacheSize = e1.minTileCacheSize, this._maxTileCacheSize = e1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = e1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = e1.preserveDrawingBuffer, this._antialias = e1.antialias, this._trackResize = e1.trackResize, this._bearingSnap = e1.bearingSnap, this._refreshExpiredTiles = e1.refreshExpiredTiles, this._fadeDuration = e1.fadeDuration, this._isInitialLoad = !0, this._crossSourceCollisions = e1.crossSourceCollisions, this._collectResourceTiming = e1.collectResourceTiming, this._language = this._parseLanguage(e1.language), this._worldview = e1.worldview, this._renderTaskQueue = new nI, this._domRenderTaskQueue = new nI, this._controls = [], this._markers = [], this._popups = [], this._mapId = F(), this._locale = k({}, dI, e1.locale), this._clickTolerance = e1.clickTolerance, this._cooperativeGestures = e1.cooperativeGestures, this._performanceMetricsCollection = e1.performanceMetricsCollection, this._containerWidth = 0, this._containerHeight = 0, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new uI(0), this._interactionRange = [
                        1 / 0,
                        -1 / 0
                    ], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._requestManager = new ze(e1.transformRequest, e1.accessToken, e1.testMode), this._silenceAuthErrors = !!e1.testMode, this._contextCreateOptions = e1.contextCreateOptions ? {
                        ...e1.contextCreateOptions
                    } : {}, "string" == typeof e1.container) {
                        if (this._container = t.document.getElementById(e1.container), !this._container) throw new Error(`Container '${e1.container.toString()}' not found.`);
                    } else {
                        if (!(e1.container instanceof t.HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = e1.container;
                    }
                    if (this._container.childNodes.length > 0 && H("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), e1.maxBounds && this.setMaxBounds(e1.maxBounds), j([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onVisibilityChange",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    if (this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), void 0 !== t && (this._fullscreenchangeEvent = "onfullscreenchange" in t.document ? "fullscreenchange" : "webkitfullscreenchange", t.addEventListener("online", this._onWindowOnline, !1), t.addEventListener("resize", this._onWindowResize, !1), t.addEventListener("orientationchange", this._onWindowResize, !1), t.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), t.addEventListener("visibilitychange", this._onVisibilityChange, !1)), this.handlers = new QS(this, e1), this._localFontFamily = e1.localFontFamily, this._localIdeographFontFamily = e1.localIdeographFontFamily, (e1.style || !e1.testMode) && this.setStyle(e1.style || n.DEFAULT_STYLE, {
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily
                    }), e1.projection && this.setProjection(e1.projection), e1.hash && (this._hash = new nS("string" == typeof e1.hash && e1.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
                        null == i.center && null == i.zoom || (this.transform._unmodified = !1), this.jumpTo({
                            center: e1.center,
                            zoom: e1.zoom,
                            bearing: e1.bearing,
                            pitch: e1.pitch
                        });
                        const t = e1.bounds;
                        t && (this.resize(), this.fitBounds(t, k({}, e1.fitBoundsOptions, {
                            duration: 0
                        })));
                    }
                    this.resize(), e1.attributionControl && this.addControl(new iI({
                        customAttribution: e1.customAttribution
                    })), this._logoControl = new rI, this.addControl(this._logoControl, e1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                    }), this.on("data", (e1)=>{
                        this._update("style" === e1.dataType), this.fire(new It(`${e1.dataType}data`, e1));
                    }), this.on("dataloading", (e1)=>{
                        this.fire(new It(`${e1.dataType}dataloading`, e1));
                    });
                }
            },
            NavigationControl: class {
                _updateZoomButtons() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t = e1.getZoom(), i = t === e1.getMaxZoom(), r = t === e1.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = r, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", r.toString());
                }
                _rotateCompassArrow() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e1.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e1.transform.pitch}deg) rotateZ(${e1.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e1.transform.angle * (180 / Math.PI)}deg)`;
                    e1._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t);
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e1.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e1.on("pitch", this._rotateCompassArrow), e1.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new mI(e1, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e1 = this._map;
                    e1 && (this._container.remove(), this.options.showZoom && e1.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e1.off("pitch", this._rotateCompassArrow), e1.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e1, t) {
                    const i = pt("button", e1, this._container);
                    return i.type = "button", i.addEventListener("click", t), i;
                }
                _setButtonTitle(e1, t) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t}`);
                    e1.setAttribute("aria-label", i), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
                }
                constructor(e1){
                    this.options = k({}, fI, e1), this._container = pt("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.options.showZoom && (j([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e1)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e1
                        });
                    }), pt("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e1)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e1
                        });
                    }), pt("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (j([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e1)=>{
                        const t = this._map;
                        t && (this.options.visualizePitch ? t.resetNorthPitch({}, {
                            originalEvent: e1
                        }) : t.resetNorth({}, {
                            originalEvent: e1
                        }));
                    }), this._compassIcon = pt("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
            },
            GeolocateControl: class extends zt {
                onAdd(e1) {
                    return this._map = e1, this._container = pt("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(e1) {
                    const i = (t = !!this.options.geolocation)=>{
                        this._supportsGeolocation = t, e1(t);
                    };
                    void 0 !== this._supportsGeolocation ? e1(this._supportsGeolocation) : void 0 !== t.navigator.permissions ? t.navigator.permissions.query({
                        name: "geolocation"
                    }).then((e1)=>i("denied" !== e1.state)).catch(()=>i()) : i();
                }
                _isOutOfMapMaxBounds(e1) {
                    const t = this._map.getMaxBounds(), i = e1.coords;
                    return !!t && (i.longitude < t.getWest() || i.longitude > t.getEast() || i.latitude < t.getSouth() || i.latitude > t.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                    }
                }
                _onSuccess(e1) {
                    if (this._map) {
                        if (this._isOutOfMapMaxBounds(e1)) return this._setErrorState(), this.fire(new It("outofmaxbounds", e1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = e1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(e1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(e1), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new It("geolocate", e1)), this._finish();
                    }
                }
                _updateCamera(e1) {
                    const t = new Wd(e1.coords.longitude, e1.coords.latitude), i = e1.coords.accuracy, r = k({
                        bearing: this._map.getBearing()
                    }, this.options.fitBoundsOptions);
                    this._map.fitBounds(t.toBounds(i), r, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(e1) {
                    if (e1) {
                        const t = new Wd(e1.coords.longitude, e1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(t).addTo(this._map), this._userLocationDotMarker.setLngLat(t).addTo(this._map), this._accuracy = e1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const e1 = this._map.transform, t = Qd(1, e1._center.lat) * e1.worldSize, i = Math.ceil(2 * this._accuracy * t);
                    this._circleElement.style.width = `${i}px`, this._circleElement.style.height = `${i}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(e1) {
                    if (this._map) {
                        if (this.options.trackUserLocation) {
                            if (1 === e1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === e1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new It("error", e1)), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _setupUI(e1) {
                    if (void 0 !== this._map) {
                        if (this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this._geolocateButton = pt("button", "mapboxgl-ctrl-geolocate", this._container), pt("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === e1) {
                            H("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1);
                        } else {
                            const e1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = pt("div", "mapboxgl-user-location"), this._dotElement.appendChild(pt("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(pt("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new aI({
                            element: this._dotElement,
                            rotationAlignment: "map",
                            pitchAlignment: "map"
                        }), this._circleElement = pt("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new aI({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (e1)=>{
                            e1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || e1.originalEvent && "resize" === e1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new It("trackuserlocationend")));
                        });
                    }
                }
                _onDeviceOrientation(e1) {
                    this._userLocationDotMarker && (e1.webkitCompassHeading ? this._heading = e1.webkitCompassHeading : !0 === e1.absolute && (this._heading = -1 * e1.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return H("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new It("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new It("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new It("trackuserlocationstart"));
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                break;
                            case "BACKGROUND":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                break;
                            case "BACKGROUND_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e1;
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e1 = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e1 = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e1), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                    return !0;
                }
                _addDeviceOrientationListener() {
                    const e1 = ()=>{
                        t.addEventListener("ondeviceorientationabsolute" in t ? "deviceorientationabsolute" : "deviceorientation", this._onDeviceOrientation);
                    };
                    void 0 !== t.DeviceMotionEvent && "function" == typeof t.DeviceMotionEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t)=>{
                        "granted" === t && e1();
                    }).catch(console.error) : e1();
                }
                _clearWatch() {
                    this.options.geolocation.clearWatch(this._geolocationWatchID), t.removeEventListener("deviceorientation", this._onDeviceOrientation), t.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
                constructor(e1){
                    super(), this.options = k({
                        geolocation: t.navigator.geolocation
                    }, _I, e1), j([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = rS(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
            },
            AttributionControl: iI,
            ScaleControl: class {
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e1 = this.options.maxWidth || 100, t = this._map, i = t._containerHeight / 2, r = t._containerWidth / 2 - e1 / 2, n = t.unproject([
                        r,
                        i
                    ]), o = t.unproject([
                        r + e1,
                        i
                    ]), s = n.distanceTo(o);
                    if ("imperial" === this.options.unit) {
                        const t = 3.2808 * s;
                        t > 5280 ? this._setScale(e1, t / 5280, "mile") : this._setScale(e1, t, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e1, s / 1852, "nautical-mile") : s >= 1e3 ? this._setScale(e1, s / 1e3, "kilometer") : this._setScale(e1, s, "meter");
                }
                _setScale(e1, t, i) {
                    this._map._requestDomTask(()=>{
                        const r = function(e1) {
                            const t = Math.pow(10, `${Math.floor(e1)}`.length - 1);
                            let i = e1 / t;
                            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e1) {
                                const t = Math.pow(10, Math.ceil(-Math.log(e1) / Math.LN10));
                                return Math.round(e1 * t) / t;
                            }(i), t * i;
                        }(t), n = r / t;
                        this._container.innerHTML = this._isNumberFormatSupported && "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "short",
                            unit: i
                        }).format(r) : `${r}&nbsp;${yI[i]}`, this._container.style.width = e1 * n + "px";
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this._language = e1.getLanguage(), this._container = pt("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e1.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e1) {
                    this._language = e1, this._update();
                }
                setUnit(e1) {
                    this.options.unit = e1, this._update();
                }
                constructor(e1){
                    this.options = k({}, gI, e1), this._isNumberFormatSupported = function() {
                        try {
                            return new Intl.NumberFormat("en", {
                                style: "unit",
                                unitDisplay: "short",
                                unit: "meter"
                            }), !0;
                        } catch (e1) {
                            return !1;
                        }
                    }(), j([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
            },
            FullscreenControl: class {
                onAdd(e1) {
                    return this._map = e1, this._container || (this._container = this._map.getContainer()), this._controlContainer = pt("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", H("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, t.document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!t.document.fullscreenEnabled && !t.document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const e1 = this._fullscreenButton = pt("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    pt("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), t.document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e1 = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e1), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e1);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (t.document.fullscreenElement || t.document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? t.document.exitFullscreen ? t.document.exitFullscreen() : t.document.webkitCancelFullScreen && t.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
                constructor(e1){
                    this._fullscreen = !1, e1 && e1.container && (e1.container instanceof t.HTMLElement ? this._container = e1.container : H("Full screen control 'container' must be a DOM element.")), j([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in t.document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in t.document && (this._fullscreenchange = "webkitfullscreenchange");
                }
            },
            Popup: class extends zt {
                addTo(e1) {
                    return this._map && this.remove(), this._map = e1, this.options.closeOnClick && e1.on("preclick", this._onClose), this.options.closeOnMove && e1.on("move", this._onClose), e1.on("remove", this.remove), this._update(), e1._addPopup(this), this._focusFirstElement(), this._trackPointer ? (e1.on("mousemove", this._onMouseEvent), e1.on("mouseup", this._onMouseEvent), e1._canvasContainer.classList.add("mapboxgl-track-pointer")) : e1.on("move", this._update), this.fire(new It("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const e1 = this._map;
                    return e1 && (e1.off("move", this._update), e1.off("move", this._onClose), e1.off("preclick", this._onClose), e1.off("click", this._onClose), e1.off("remove", this.remove), e1.off("mousemove", this._onMouseEvent), e1.off("mouseup", this._onMouseEvent), e1.off("drag", this._onMouseEvent), e1._canvasContainer && e1._canvasContainer.classList.remove("mapboxgl-track-pointer"), e1._removePopup(this), this._map = void 0), this.fire(new It("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(e1) {
                    this._lngLat = Wd.convert(e1), this._pos = null, this._trackPointer = !1, this._update();
                    const t = this._map;
                    return t && (t.on("move", this._update), t.off("mousemove", this._onMouseEvent), t._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e1 = this._map;
                    return e1 && (e1.off("move", this._update), e1.on("mousemove", this._onMouseEvent), e1.on("drag", this._onMouseEvent), e1._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(e1) {
                    return this.setDOMContent(t.document.createTextNode(e1));
                }
                setHTML(e1) {
                    const i = t.document.createDocumentFragment(), r = t.document.createElement("body");
                    let n;
                    for(r.innerHTML = e1; n = r.firstChild, n;)i.appendChild(n);
                    return this.setDOMContent(i);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e1) {
                    return this.options.maxWidth = e1, this._update(), this;
                }
                setDOMContent(e1) {
                    let t = this._content;
                    if (t) for(; t.hasChildNodes();)t.firstChild && t.removeChild(t.firstChild);
                    else t = this._content = pt("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t.appendChild(e1), this.options.closeButton) {
                        const e1 = this._closeButton = pt("button", "mapboxgl-popup-close-button", t);
                        e1.type = "button", e1.setAttribute("aria-label", "Close popup"), e1.setAttribute("aria-hidden", "true"), e1.innerHTML = "&#215;", e1.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e1) {
                    return this._classList.add(e1), this._updateClassList(), this;
                }
                removeClassName(e1) {
                    return this._classList.delete(e1), this._updateClassList(), this;
                }
                setOffset(e1) {
                    return this.options.offset = e1, this._update(), this;
                }
                toggleClassName(e1) {
                    let t;
                    return this._classList.delete(e1) ? t = !1 : (this._classList.add(e1), t = !0), this._updateClassList(), t;
                }
                _onMouseEvent(e1) {
                    this._update(e1.point);
                }
                _getAnchor(e1) {
                    if (this.options.anchor) return this.options.anchor;
                    const t = this._map, i = this._container, r = this._pos;
                    if (!t || !i || !r) return "bottom";
                    const n = i.offsetWidth, o = i.offsetHeight, s = r.x < n / 2, a = r.x > t.transform.width - n / 2;
                    if (r.y + e1 < o) return s ? "top-left" : a ? "top-right" : "top";
                    if (r.y > t.transform.height - o) {
                        if (s) return "bottom-left";
                        if (a) return "bottom-right";
                    }
                    return s ? "left" : a ? "right" : "bottom";
                }
                _updateClassList() {
                    const e1 = this._container;
                    if (!e1) return;
                    const t = [
                        ...this._classList
                    ];
                    t.push("mapboxgl-popup"), this._anchor && t.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t.push("mapboxgl-popup-track-pointer"), e1.className = t.join(" ");
                }
                _update(e1) {
                    const t = this._map, i = this._content;
                    if (!t || !this._lngLat && !this._trackPointer || !i) return;
                    let r = this._container;
                    if (r || (r = this._container = pt("div", "mapboxgl-popup", t.getContainer()), this._tip = pt("div", "mapboxgl-popup-tip", r), r.appendChild(i)), this.options.maxWidth && r.style.maxWidth !== this.options.maxWidth && (r.style.maxWidth = this.options.maxWidth), t.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = oI(this._lngLat, this._pos, t.transform)), !this._trackPointer || e1) {
                        const i = this._pos = this._trackPointer && e1 ? e1 : t.project(this._lngLat), r = hI(this.options.offset), n = this._anchor = this._getAnchor(r.y), o = hI(this.options.offset, n), s = i.add(o).round();
                        t._requestDomTask(()=>{
                            this._container && n && (this._container.style.transform = `${sI[n]} translate(${s.x}px,${s.y}px)`);
                        });
                    }
                    if (!this._marker && t._showingGlobe()) {
                        const e1 = Nd(t.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(e1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e1 = this._container.querySelector(cI);
                    e1 && e1.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e1) {
                    this._container && (this._container.style.opacity = `${e1}`), this._content && (this._content.style.pointerEvents = e1 ? "auto" : "none");
                }
                constructor(e1){
                    super(), this.options = k(Object.create(lI), e1), j([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(e1 && e1.className ? e1.className.trim().split(/\s+/) : []);
                }
            },
            Marker: aI,
            Style: iS,
            LngLat: Wd,
            LngLatBounds: sc,
            Point: y,
            MercatorCoordinate: lp,
            FreeCameraOptions: Xx,
            Evented: zt,
            config: n,
            prewarm: function() {
                Ww().acquire(qw);
            },
            clearPrewarmedResources: function() {
                const e1 = $w;
                e1 && (e1.isPreloaded() && 1 === e1.numActive() ? (e1.release(qw), $w = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get accessToken () {
                return n.ACCESS_TOKEN;
            },
            set accessToken (e){
                n.ACCESS_TOKEN = e;
            },
            get baseApiUrl () {
                return n.API_URL;
            },
            set baseApiUrl (e){
                n.API_URL = e;
            },
            get workerCount () {
                return Zw.workerCount;
            },
            set workerCount (e){
                Zw.workerCount = e;
            },
            get maxParallelImageRequests () {
                return n.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (e){
                n.MAX_PARALLEL_IMAGE_REQUESTS = e;
            },
            clearStorage (e1) {
                !function(e1) {
                    if (!pe()) return;
                    const i = t.caches.delete(le);
                    e1 && i.catch(e1).then(()=>e1());
                }(e1);
            },
            workerUrl: "",
            workerClass: null,
            get dracoUrl () {
                return Jw();
            },
            set dracoUrl (e){
                !function(e1) {
                    Xw = dt.resolveURL(e1), Kw || (Kw = new Ew(Ww(), new zt)), Kw.broadcast("setDracoUrl", Xw);
                }(e);
            },
            setNow: dt.setNow,
            restoreNow: dt.restoreNow
        };
        e1.A = Tw, e1.D = Ym, e1.E = cr, e1.F = Qm, e1.K = xE, e1.O = qu, e1.P = y, e1.T = Zv, e1.V = hm, e1.a = Kf, e1.b = fm, e1.c = ow, e1.d = class extends zt {
            loadTile(e1, t) {
                const i = e1.uid, r = e1 && e1.request, n = r && r.collectResourceTiming, o = this.loading[i] = new Bw(e1);
                o.abort = this.loadVectorData(e1, (s, a)=>{
                    const l = !this.loading[i];
                    if (delete this.loading[i], l || s || !a) return o.status = "done", l || (this.loaded[i] = o), t(s);
                    const c = a.rawData, h = {};
                    a.expires && (h.expires = a.expires), a.cacheControl && (h.cacheControl = a.cacheControl), o.vectorTile = a.vectorTile || new cm(new km(c));
                    const u = ()=>{
                        o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, (e1, i)=>{
                            if (e1 || !i) return t(e1);
                            const o = {};
                            if (n) {
                                const e1 = it(r);
                                e1.length > 0 && (o.resourceTiming = JSON.parse(JSON.stringify(e1)));
                            }
                            t(null, k({
                                rawTileData: c.slice(0)
                            }, i, h, o));
                        });
                    };
                    this.isSpriteLoaded ? u() : this.once("isSpriteLoaded", ()=>{
                        this.scheduler ? this.scheduler.add(u, {
                            type: "parseTile",
                            isSymbolTile: e1.isSymbolTile,
                            zoom: e1.tileZoom
                        }) : u();
                    }), this.loaded = this.loaded || {}, this.loaded[i] = o;
                });
            }
            reloadTile(e1, t) {
                const i = this.loaded, r = e1.uid, n = this;
                if (i && i[r]) {
                    const o = i[r];
                    o.showCollisionBoxes = e1.showCollisionBoxes, o.projection = e1.projection, o.brightness = e1.brightness, o.tileTransform = Pg(e1.tileID.canonical, e1.projection), o.extraShadowCaster = e1.extraShadowCaster;
                    const s = (e1, i)=>{
                        const r = o.reloadCallback;
                        r && (delete o.reloadCallback, o.parse(o.vectorTile, n.layerIndex, this.availableImages, n.actor, r)), t(e1, i);
                    };
                    "parsing" === o.status ? o.reloadCallback = s : "done" === o.status && (o.vectorTile ? o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.actor, s) : s());
                } else t(null, void 0);
            }
            abortTile(e1, t) {
                const i = e1.uid, r = this.loading[i];
                r && (r.abort && r.abort(), delete this.loading[i]), t();
            }
            removeTile(e1, t) {
                const i = this.loaded, r = e1.uid;
                i && i[r] && delete i[r], t();
            }
            constructor(e1, t, i, r, n, o){
                super(), this.actor = e1, this.layerIndex = t, this.availableImages = i, this.loadVectorData = n || Uw, this.loading = {}, this.loaded = {}, this.deduped = new Nw(e1.scheduler), this.isSpriteLoaded = r, this.scheduler = e1.scheduler, this.brightness = o;
            }
        }, e1.e = Eo, e1.f = it, e1.g = d, e1.h = we, e1.i = Te, e1.j = function(e1, t) {
            const i = TT(e1);
            for (const e1 of i){
                for (const t of e1.meshes)ET(t);
                e1.lights && (e1.lightMeshIndex = e1.meshes.length, e1.meshes.push(MT(e1.lights, t)));
            }
            return i;
        }, e1.k = oa, e1.l = function(e1) {
            let t = 0;
            if (new Uint32Array(e1, 0, 1)[0] !== aT) {
                const i = new Uint32Array(e1, 0, 7), [, , r, n, o, s] = i;
                t = i.byteLength + n + o + s + o, (r !== e1.byteLength || t >= e1.byteLength) && H("Invalid b3dm header information.");
            }
            return pT(e1, t);
        }, e1.m = ty, e1.n = na, e1.o = It, e1.p = _, e1.q = function(e1) {
            fe(), ue && ue.then((t)=>{
                t.keys().then((i)=>{
                    for(let r = 0; r < i.length - e1; r++)t.delete(i[r]);
                });
            });
        }, e1.r = RT, e1.s = xI, e1.t = ap, e1.v = L, e1.w = t;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        function t(e1) {
            if ("number" == typeof e1 || "boolean" == typeof e1 || "string" == typeof e1 || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                let r = "[";
                for (const o of e1)r += `${t(o)},`;
                return `${r}]`;
            }
            let r = "{";
            for (const o of Object.keys(e1).sort())r += `${o}:${t(e1[o])},`;
            return `${r}}`;
        }
        function r(r) {
            let o = "";
            for (const i of e1.r)o += `/${t(r[i])}`;
            return o;
        }
        class o {
            replace(e1, t) {
                this._layerConfigs = {}, this._layers = {}, this.update(e1, [], t);
            }
            update(t, o, i) {
                this._options = i;
                for (const r of t){
                    this._layerConfigs[r.id] = r;
                    const t = this._layers[r.id] = e1.c(r, this._options);
                    t.setScope(this.scope), t.compileFilter(), this.keyCache[r.id] && delete this.keyCache[r.id];
                }
                for (const e1 of o)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = {};
                const s = function(e1, t) {
                    const o = {};
                    for(let i = 0; i < e1.length; i++){
                        const s = t && t[e1[i].id] || r(e1[i]);
                        t && (t[e1[i].id] = s);
                        let n = o[s];
                        n || (n = o[s] = []), n.push(e1[i]);
                    }
                    const i = [];
                    for(const e1 in o)i.push(o[e1]);
                    return i;
                }(e1.v(this._layerConfigs), this.keyCache);
                for (const e1 of s){
                    const t = e1.map((e1)=>this._layers[e1.id]), r = t[0];
                    if ("none" === r.visibility) continue;
                    const o = r.source || "";
                    let i = this.familiesBySource[o];
                    i || (i = this.familiesBySource[o] = {});
                    const s = r.sourceLayer || "_geojsonTileLayer";
                    let n = i[s];
                    n || (n = i[s] = []), n.push(t);
                }
            }
            constructor(e1){
                this.keyCache = {}, this._layers = {}, this._layerConfigs = {}, e1 && this.replace(e1);
            }
        }
        class i {
            loadTile(t, r) {
                const { uid: o, encoding: i, rawImageData: s, padding: n } = t, a = e1.w.ImageBitmap && s instanceof e1.w.ImageBitmap ? this.getImageData(s, n) : s;
                r(null, new e1.D(o, a, i, n < 1));
            }
            getImageData(e1, t) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e1.width, e1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = e1.width, this.offscreenCanvas.height = e1.height, this.offscreenCanvasContext.drawImage(e1, 0, 0, e1.width, e1.height);
                const r = this.offscreenCanvasContext.getImageData(-t, -t, e1.width + 2 * t, e1.height + 2 * t);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), r;
            }
        }
        function s(e1, t) {
            if (0 !== e1.length) {
                n(e1[0], t);
                for(var r = 1; r < e1.length; r++)n(e1[r], !t);
            }
        }
        function n(e1, t) {
            for(var r = 0, o = 0, i = 0, s = e1.length, n = s - 1; i < s; n = i++){
                var a = (e1[i][0] - e1[n][0]) * (e1[n][1] + e1[i][1]), l = r + a;
                o += Math.abs(r) >= Math.abs(a) ? r - l + a : a - l + r, r = l;
            }
            r + o >= 0 != !!t && e1.reverse();
        }
        var a = e1.g(function e1(t, r) {
            var o, i = t && t.type;
            if ("FeatureCollection" === i) for(o = 0; o < t.features.length; o++)e1(t.features[o], r);
            else if ("GeometryCollection" === i) for(o = 0; o < t.geometries.length; o++)e1(t.geometries[o], r);
            else if ("Feature" === i) e1(t.geometry, r);
            else if ("Polygon" === i) s(t.coordinates, r);
            else if ("MultiPolygon" === i) for(o = 0; o < t.coordinates.length; o++)s(t.coordinates[o], r);
            return t;
        });
        const l = e1.V.prototype.toGeoJSON;
        var h = {
            exports: {}
        }, u = e1.p, c = e1.a.VectorTileFeature, f = d;
        function d(e1, t) {
            this.options = t || {}, this.features = e1, this.length = e1.length;
        }
        function p(e1, t) {
            this.id = "number" == typeof e1.id ? e1.id : void 0, this.type = e1.type, this.rawGeometry = 1 === e1.type ? [
                e1.geometry
            ] : e1.geometry, this.properties = e1.tags, this.extent = t || 4096;
        }
        d.prototype.feature = function(e1) {
            return new p(this.features[e1], this.options.extent);
        }, p.prototype.loadGeometry = function() {
            var e1 = this.rawGeometry;
            this.geometry = [];
            for(var t = 0; t < e1.length; t++){
                for(var r = e1[t], o = [], i = 0; i < r.length; i++)o.push(new u(r[i][0], r[i][1]));
                this.geometry.push(o);
            }
            return this.geometry;
        }, p.prototype.bbox = function() {
            this.geometry || this.loadGeometry();
            for(var e1 = this.geometry, t = 1 / 0, r = -1 / 0, o = 1 / 0, i = -1 / 0, s = 0; s < e1.length; s++)for(var n = e1[s], a = 0; a < n.length; a++){
                var l = n[a];
                t = Math.min(t, l.x), r = Math.max(r, l.x), o = Math.min(o, l.y), i = Math.max(i, l.y);
            }
            return [
                t,
                o,
                r,
                i
            ];
        }, p.prototype.toGeoJSON = c.prototype.toGeoJSON;
        var g = e1.b, m = f;
        function y(e1) {
            var t = new g;
            return function(e1, t) {
                for(var r in e1.layers)t.writeMessage(3, v, e1.layers[r]);
            }(e1, t), t.finish();
        }
        function v(e1, t) {
            var r;
            t.writeVarintField(15, e1.version || 1), t.writeStringField(1, e1.name || ""), t.writeVarintField(5, e1.extent || 4096);
            var o = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(r = 0; r < e1.length; r++)o.feature = e1.feature(r), t.writeMessage(2, w, o);
            var i = o.keys;
            for(r = 0; r < i.length; r++)t.writeStringField(3, i[r]);
            var s = o.values;
            for(r = 0; r < s.length; r++)t.writeMessage(4, I, s[r]);
        }
        function w(e1, t) {
            var r = e1.feature;
            void 0 !== r.id && t.writeVarintField(1, r.id), t.writeMessage(2, x, e1), t.writeVarintField(3, r.type), t.writeMessage(4, b, r);
        }
        function x(e1, t) {
            var r = e1.feature, o = e1.keys, i = e1.values, s = e1.keycache, n = e1.valuecache;
            for(var a in r.properties){
                var l = r.properties[a], h = s[a];
                if (null !== l) {
                    void 0 === h && (o.push(a), s[a] = h = o.length - 1), t.writeVarint(h);
                    var u = typeof l;
                    "string" !== u && "boolean" !== u && "number" !== u && (l = JSON.stringify(l));
                    var c = u + ":" + l, f = n[c];
                    void 0 === f && (i.push(l), n[c] = f = i.length - 1), t.writeVarint(f);
                }
            }
        }
        function S(e1, t) {
            return (t << 3) + (7 & e1);
        }
        function M(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function b(e1, t) {
            for(var r = e1.loadGeometry(), o = e1.type, i = 0, s = 0, n = r.length, a = 0; a < n; a++){
                var l = r[a], h = 1;
                1 === o && (h = l.length), t.writeVarint(S(1, h));
                for(var u = 3 === o ? l.length - 1 : l.length, c = 0; c < u; c++){
                    1 === c && 1 !== o && t.writeVarint(S(2, u - 1));
                    var f = l[c].x - i, d = l[c].y - s;
                    t.writeVarint(M(f)), t.writeVarint(M(d)), i += f, s += d;
                }
                3 === o && t.writeVarint(S(7, 1));
            }
        }
        function I(e1, t) {
            var r = typeof e1;
            "string" === r ? t.writeStringField(1, e1) : "boolean" === r ? t.writeBooleanField(7, e1) : "number" === r && (e1 % 1 != 0 ? t.writeDoubleField(3, e1) : e1 < 0 ? t.writeSVarintField(6, e1) : t.writeVarintField(5, e1));
        }
        h.exports = y, h.exports.fromVectorTileJs = y, h.exports.fromGeojsonVt = function(e1, t) {
            t = t || {};
            var r = {};
            for(var o in e1)r[o] = new m(e1[o].features, t), r[o].name = o, r[o].version = t.version, r[o].extent = t.extent;
            return y({
                layers: r
            });
        }, h.exports.GeoJSONWrapper = m;
        var k = e1.g(h.exports);
        const P = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e1)=>e1
        }, _ = Math.fround || (L = new Float32Array(1), (e1)=>(L[0] = +e1, L[0]));
        var L;
        const T = 3, C = 5, O = 6;
        class j {
            load(e1) {
                const { log: t, minZoom: r, maxZoom: o } = this.options;
                t && console.time("total time");
                const i = `prepare ${e1.length} points`;
                t && console.time(i), this.points = e1;
                const s = [];
                for(let t = 0; t < e1.length; t++){
                    const r = e1[t];
                    if (!r.geometry) continue;
                    const [o, i] = r.geometry.coordinates, n = _(z(o)), a = _(D(i));
                    s.push(n, a, 1 / 0, t, -1, 1), this.options.reduce && s.push(0);
                }
                let n = this.trees[o + 1] = this._createTree(s);
                t && console.timeEnd(i);
                for(let e1 = o; e1 >= r; e1--){
                    const r = +Date.now();
                    n = this.trees[e1] = this._createTree(this._cluster(n, e1)), t && console.log("z%d: %d clusters in %dms", e1, n.numItems, +Date.now() - r);
                }
                return t && console.timeEnd("total time"), this;
            }
            getClusters(e1, t) {
                let r = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                const o = Math.max(-90, Math.min(90, e1[1]));
                let i = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                const s = Math.max(-90, Math.min(90, e1[3]));
                if (e1[2] - e1[0] >= 360) r = -180, i = 180;
                else if (r > i) {
                    const e1 = this.getClusters([
                        r,
                        o,
                        180,
                        s
                    ], t), n = this.getClusters([
                        -180,
                        o,
                        i,
                        s
                    ], t);
                    return e1.concat(n);
                }
                const n = this.trees[this._limitZoom(t)], a = n.range(z(r), D(s), z(i), D(o)), l = n.data, h = [];
                for (const e1 of a){
                    const t = this.stride * e1;
                    h.push(l[t + C] > 1 ? F(l, t, this.clusterProps) : this.points[l[t + T]]);
                }
                return h;
            }
            getChildren(e1) {
                const t = this._getOriginId(e1), r = this._getOriginZoom(e1), o = "No cluster with the specified id.", i = this.trees[r];
                if (!i) throw new Error(o);
                const s = i.data;
                if (t * this.stride >= s.length) throw new Error(o);
                const n = this.options.radius / (this.options.extent * Math.pow(2, r - 1)), a = i.within(s[t * this.stride], s[t * this.stride + 1], n), l = [];
                for (const t of a){
                    const r = t * this.stride;
                    s[r + 4] === e1 && l.push(s[r + C] > 1 ? F(s, r, this.clusterProps) : this.points[s[r + T]]);
                }
                if (0 === l.length) throw new Error(o);
                return l;
            }
            getLeaves(e1, t, r) {
                const o = [];
                return this._appendLeaves(o, e1, t = t || 10, r = r || 0, 0), o;
            }
            getTile(e1, t, r) {
                const o = this.trees[this._limitZoom(e1)], i = Math.pow(2, e1), { extent: s, radius: n } = this.options, a = n / s, l = (r - a) / i, h = (r + 1 + a) / i, u = {
                    features: []
                };
                return this._addTileFeatures(o.range((t - a) / i, l, (t + 1 + a) / i, h), o.data, t, r, i, u), 0 === t && this._addTileFeatures(o.range(1 - a / i, l, 1, h), o.data, i, r, i, u), t === i - 1 && this._addTileFeatures(o.range(0, l, a / i, h), o.data, -1, r, i, u), u.features.length ? u : null;
            }
            getClusterExpansionZoom(e1) {
                let t = this._getOriginZoom(e1) - 1;
                for(; t <= this.options.maxZoom;){
                    const r = this.getChildren(e1);
                    if (t++, 1 !== r.length) break;
                    e1 = r[0].properties.cluster_id;
                }
                return t;
            }
            _appendLeaves(e1, t, r, o, i) {
                const s = this.getChildren(t);
                for (const t of s){
                    const s = t.properties;
                    if (s && s.cluster ? i + s.point_count <= o ? i += s.point_count : i = this._appendLeaves(e1, s.cluster_id, r, o, i) : i < o ? i++ : e1.push(t), e1.length === r) break;
                }
                return i;
            }
            _createTree(t) {
                const r = new e1.K(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let e1 = 0; e1 < t.length; e1 += this.stride)r.add(t[e1], t[e1 + 1]);
                return r.finish(), r.data = t, r;
            }
            _addTileFeatures(e1, t, r, o, i, s) {
                for (const n of e1){
                    const e1 = n * this.stride, a = t[e1 + C] > 1;
                    let l, h, u;
                    if (a) l = Z(t, e1, this.clusterProps), h = t[e1], u = t[e1 + 1];
                    else {
                        const r = this.points[t[e1 + T]];
                        l = r.properties;
                        const [o, i] = r.geometry.coordinates;
                        h = z(o), u = D(i);
                    }
                    const c = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (h * i - r)),
                                Math.round(this.options.extent * (u * i - o))
                            ]
                        ],
                        tags: l
                    };
                    let f;
                    f = a || this.options.generateId ? t[e1 + T] : this.points[t[e1 + T]].id, void 0 !== f && (c.id = f), s.features.push(c);
                }
            }
            _limitZoom(e1) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
            }
            _cluster(e1, t) {
                const { radius: r, extent: o, reduce: i, minPoints: s } = this.options, n = r / (o * Math.pow(2, t)), a = e1.data, l = [], h = this.stride;
                for(let r = 0; r < a.length; r += h){
                    if (a[r + 2] <= t) continue;
                    a[r + 2] = t;
                    const o = a[r], u = a[r + 1], c = e1.within(a[r], a[r + 1], n), f = a[r + C];
                    let d = f;
                    for (const e1 of c){
                        const r = e1 * h;
                        a[r + 2] > t && (d += a[r + C]);
                    }
                    if (d > f && d >= s) {
                        let e1, s = o * f, n = u * f, p = -1;
                        const g = ((r / h | 0) << 5) + (t + 1) + this.points.length;
                        for (const o of c){
                            const l = o * h;
                            if (a[l + 2] <= t) continue;
                            a[l + 2] = t;
                            const u = a[l + C];
                            s += a[l] * u, n += a[l + 1] * u, a[l + 4] = g, i && (e1 || (e1 = this._map(a, r, !0), p = this.clusterProps.length, this.clusterProps.push(e1)), i(e1, this._map(a, l)));
                        }
                        a[r + 4] = g, l.push(s / d, n / d, 1 / 0, g, -1, d), i && l.push(p);
                    } else {
                        for(let e1 = 0; e1 < h; e1++)l.push(a[r + e1]);
                        if (d > 1) for (const e1 of c){
                            const r = e1 * h;
                            if (!(a[r + 2] <= t)) {
                                a[r + 2] = t;
                                for(let e1 = 0; e1 < h; e1++)l.push(a[r + e1]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e1) {
                return e1 - this.points.length >> 5;
            }
            _getOriginZoom(e1) {
                return (e1 - this.points.length) % 32;
            }
            _map(e1, t, r) {
                if (e1[t + C] > 1) {
                    const o = this.clusterProps[e1[t + O]];
                    return r ? Object.assign({}, o) : o;
                }
                const o = this.points[e1[t + T]].properties, i = this.options.map(o);
                return r && i === o ? Object.assign({}, i) : i;
            }
            constructor(e1){
                this.options = Object.assign(Object.create(P), e1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
        }
        function F(e1, t, r) {
            var o;
            return {
                type: "Feature",
                id: e1[t + T],
                properties: Z(e1, t, r),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (o = e1[t], 360 * (o - .5)),
                        E(e1[t + 1])
                    ]
                }
            };
        }
        function Z(e1, t, r) {
            const o = e1[t + C], i = o >= 1e4 ? `${Math.round(o / 1e3)}k` : o >= 1e3 ? Math.round(o / 100) / 10 + "k" : o, s = e1[t + O], n = -1 === s ? {} : Object.assign({}, r[s]);
            return Object.assign(n, {
                cluster: !0,
                cluster_id: e1[t + T],
                point_count: o,
                point_count_abbreviated: i
            });
        }
        function z(e1) {
            return e1 / 360 + .5;
        }
        function D(e1) {
            const t = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return r < 0 ? 0 : r > 1 ? 1 : r;
        }
        function E(e1) {
            const t = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
        }
        var N = {
            exports: {}
        };
        N.exports = function() {
            function e1(r, o, i, s) {
                for(var n, a = s, l = i - o >> 1, h = i - o, u = r[o], c = r[o + 1], f = r[i], d = r[i + 1], p = o + 3; p < i; p += 3){
                    var g = t(r[p], r[p + 1], u, c, f, d);
                    if (g > a) n = p, a = g;
                    else if (g === a) {
                        var m = Math.abs(p - l);
                        m < h && (n = p, h = m);
                    }
                }
                a > s && (n - o > 3 && e1(r, o, n, s), r[n + 2] = a, i - n > 3 && e1(r, n, i, s));
            }
            function t(e1, t, r, o, i, s) {
                var n = i - r, a = s - o;
                if (0 !== n || 0 !== a) {
                    var l = ((e1 - r) * n + (t - o) * a) / (n * n + a * a);
                    l > 1 ? (r = i, o = s) : l > 0 && (r += n * l, o += a * l);
                }
                return (n = e1 - r) * n + (a = t - o) * a;
            }
            function r(e1, t, r, i) {
                var s = {
                    id: void 0 === e1 ? null : e1,
                    type: t,
                    geometry: r,
                    tags: i,
                    minX: 1 / 0,
                    minY: 1 / 0,
                    maxX: -1 / 0,
                    maxY: -1 / 0
                };
                return function(e1) {
                    var t = e1.geometry, r = e1.type;
                    if ("Point" === r || "MultiPoint" === r || "LineString" === r) o(e1, t);
                    else if ("Polygon" === r || "MultiLineString" === r) for(var i = 0; i < t.length; i++)o(e1, t[i]);
                    else if ("MultiPolygon" === r) for(i = 0; i < t.length; i++)for(var s = 0; s < t[i].length; s++)o(e1, t[i][s]);
                }(s), s;
            }
            function o(e1, t) {
                for(var r = 0; r < t.length; r += 3)e1.minX = Math.min(e1.minX, t[r]), e1.minY = Math.min(e1.minY, t[r + 1]), e1.maxX = Math.max(e1.maxX, t[r]), e1.maxY = Math.max(e1.maxY, t[r + 1]);
            }
            function i(e1, t, o, l) {
                if (t.geometry) {
                    var h = t.geometry.coordinates, u = t.geometry.type, c = Math.pow(o.tolerance / ((1 << o.maxZoom) * o.extent), 2), f = [], d = t.id;
                    if (o.promoteId ? d = t.properties[o.promoteId] : o.generateId && (d = l || 0), "Point" === u) s(h, f);
                    else if ("MultiPoint" === u) for(var p = 0; p < h.length; p++)s(h[p], f);
                    else if ("LineString" === u) n(h, f, c, !1);
                    else if ("MultiLineString" === u) {
                        if (o.lineMetrics) {
                            for(p = 0; p < h.length; p++)n(h[p], f = [], c, !1), e1.push(r(d, "LineString", f, t.properties));
                            return;
                        }
                        a(h, f, c, !1);
                    } else if ("Polygon" === u) a(h, f, c, !0);
                    else {
                        if ("MultiPolygon" !== u) {
                            if ("GeometryCollection" === u) {
                                for(p = 0; p < t.geometry.geometries.length; p++)i(e1, {
                                    id: d,
                                    geometry: t.geometry.geometries[p],
                                    properties: t.properties
                                }, o, l);
                                return;
                            }
                            throw new Error("Input data is not a valid GeoJSON object.");
                        }
                        for(p = 0; p < h.length; p++){
                            var g = [];
                            a(h[p], g, c, !0), f.push(g);
                        }
                    }
                    e1.push(r(d, u, f, t.properties));
                }
            }
            function s(e1, t) {
                t.push(l(e1[0])), t.push(h(e1[1])), t.push(0);
            }
            function n(t, r, o, i) {
                for(var s, n, a = 0, u = 0; u < t.length; u++){
                    var c = l(t[u][0]), f = h(t[u][1]);
                    r.push(c), r.push(f), r.push(0), u > 0 && (a += i ? (s * f - c * n) / 2 : Math.sqrt(Math.pow(c - s, 2) + Math.pow(f - n, 2))), s = c, n = f;
                }
                var d = r.length - 3;
                r[2] = 1, e1(r, 0, d, o), r[d + 2] = 1, r.size = Math.abs(a), r.start = 0, r.end = r.size;
            }
            function a(e1, t, r, o) {
                for(var i = 0; i < e1.length; i++){
                    var s = [];
                    n(e1[i], s, r, o), t.push(s);
                }
            }
            function l(e1) {
                return e1 / 360 + .5;
            }
            function h(e1) {
                var t = Math.sin(e1 * Math.PI / 180), r = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
                return r < 0 ? 0 : r > 1 ? 1 : r;
            }
            function u(e1, t, o, i, s, n, a, l) {
                if (i /= t, n >= (o /= t) && a < i) return e1;
                if (a < o || n >= i) return null;
                for(var h = [], u = 0; u < e1.length; u++){
                    var d = e1[u], g = d.geometry, m = d.type, y = 0 === s ? d.minX : d.minY, v = 0 === s ? d.maxX : d.maxY;
                    if (y >= o && v < i) h.push(d);
                    else if (!(v < o || y >= i)) {
                        var w = [];
                        if ("Point" === m || "MultiPoint" === m) c(g, w, o, i, s);
                        else if ("LineString" === m) f(g, w, o, i, s, !1, l.lineMetrics);
                        else if ("MultiLineString" === m) p(g, w, o, i, s, !1);
                        else if ("Polygon" === m) p(g, w, o, i, s, !0);
                        else if ("MultiPolygon" === m) for(var x = 0; x < g.length; x++){
                            var S = [];
                            p(g[x], S, o, i, s, !0), S.length && w.push(S);
                        }
                        if (w.length) {
                            if (l.lineMetrics && "LineString" === m) {
                                for(x = 0; x < w.length; x++)h.push(r(d.id, m, w[x], d.tags));
                                continue;
                            }
                            "LineString" !== m && "MultiLineString" !== m || (1 === w.length ? (m = "LineString", w = w[0]) : m = "MultiLineString"), "Point" !== m && "MultiPoint" !== m || (m = 3 === w.length ? "Point" : "MultiPoint"), h.push(r(d.id, m, w, d.tags));
                        }
                    }
                }
                return h.length ? h : null;
            }
            function c(e1, t, r, o, i) {
                for(var s = 0; s < e1.length; s += 3){
                    var n = e1[s + i];
                    n >= r && n <= o && (t.push(e1[s]), t.push(e1[s + 1]), t.push(e1[s + 2]));
                }
            }
            function f(e1, t, r, o, i, s, n) {
                for(var a, l, h = d(e1), u = 0 === i ? m : y, c = e1.start, f = 0; f < e1.length - 3; f += 3){
                    var p = e1[f], v = e1[f + 1], w = e1[f + 2], x = e1[f + 3], S = e1[f + 4], M = 0 === i ? p : v, b = 0 === i ? x : S, I = !1;
                    n && (a = Math.sqrt(Math.pow(p - x, 2) + Math.pow(v - S, 2))), M < r ? b > r && (l = u(h, p, v, x, S, r), n && (h.start = c + a * l)) : M > o ? b < o && (l = u(h, p, v, x, S, o), n && (h.start = c + a * l)) : g(h, p, v, w), b < r && M >= r && (l = u(h, p, v, x, S, r), I = !0), b > o && M <= o && (l = u(h, p, v, x, S, o), I = !0), !s && I && (n && (h.end = c + a * l), t.push(h), h = d(e1)), n && (c += a);
                }
                var k = e1.length - 3;
                p = e1[k], v = e1[k + 1], w = e1[k + 2], (M = 0 === i ? p : v) >= r && M <= o && g(h, p, v, w), k = h.length - 3, s && k >= 3 && (h[k] !== h[0] || h[k + 1] !== h[1]) && g(h, h[0], h[1], h[2]), h.length && t.push(h);
            }
            function d(e1) {
                var t = [];
                return t.size = e1.size, t.start = e1.start, t.end = e1.end, t;
            }
            function p(e1, t, r, o, i, s) {
                for(var n = 0; n < e1.length; n++)f(e1[n], t, r, o, i, s, !1);
            }
            function g(e1, t, r, o) {
                e1.push(t), e1.push(r), e1.push(o);
            }
            function m(e1, t, r, o, i, s) {
                var n = (s - t) / (o - t);
                return e1.push(s), e1.push(r + (i - r) * n), e1.push(1), n;
            }
            function y(e1, t, r, o, i, s) {
                var n = (s - r) / (i - r);
                return e1.push(t + (o - t) * n), e1.push(s), e1.push(1), n;
            }
            function v(e1, t) {
                for(var o = [], i = 0; i < e1.length; i++){
                    var s, n = e1[i], a = n.type;
                    if ("Point" === a || "MultiPoint" === a || "LineString" === a) s = w(n.geometry, t);
                    else if ("MultiLineString" === a || "Polygon" === a) {
                        s = [];
                        for(var l = 0; l < n.geometry.length; l++)s.push(w(n.geometry[l], t));
                    } else if ("MultiPolygon" === a) for(s = [], l = 0; l < n.geometry.length; l++){
                        for(var h = [], u = 0; u < n.geometry[l].length; u++)h.push(w(n.geometry[l][u], t));
                        s.push(h);
                    }
                    o.push(r(n.id, a, s, n.tags));
                }
                return o;
            }
            function w(e1, t) {
                var r = [];
                r.size = e1.size, void 0 !== e1.start && (r.start = e1.start, r.end = e1.end);
                for(var o = 0; o < e1.length; o += 3)r.push(e1[o] + t, e1[o + 1], e1[o + 2]);
                return r;
            }
            function x(e1, t) {
                if (e1.transformed) return e1;
                var r, o, i, s = 1 << e1.z, n = e1.x, a = e1.y;
                for(r = 0; r < e1.features.length; r++){
                    var l = e1.features[r], h = l.geometry, u = l.type;
                    if (l.geometry = [], 1 === u) for(o = 0; o < h.length; o += 2)l.geometry.push(S(h[o], h[o + 1], t, s, n, a));
                    else for(o = 0; o < h.length; o++){
                        var c = [];
                        for(i = 0; i < h[o].length; i += 2)c.push(S(h[o][i], h[o][i + 1], t, s, n, a));
                        l.geometry.push(c);
                    }
                }
                return e1.transformed = !0, e1;
            }
            function S(e1, t, r, o, i, s) {
                return [
                    Math.round(r * (e1 * o - i)),
                    Math.round(r * (t * o - s))
                ];
            }
            function M(e1, t, r, o, i) {
                for(var s = t === i.maxZoom ? 0 : i.tolerance / ((1 << t) * i.extent), n = {
                    features: [],
                    numPoints: 0,
                    numSimplified: 0,
                    numFeatures: 0,
                    source: null,
                    x: r,
                    y: o,
                    z: t,
                    transformed: !1,
                    minX: 2,
                    minY: 1,
                    maxX: -1,
                    maxY: 0
                }, a = 0; a < e1.length; a++){
                    n.numFeatures++, b(n, e1[a], s, i);
                    var l = e1[a].minX, h = e1[a].minY, u = e1[a].maxX, c = e1[a].maxY;
                    l < n.minX && (n.minX = l), h < n.minY && (n.minY = h), u > n.maxX && (n.maxX = u), c > n.maxY && (n.maxY = c);
                }
                return n;
            }
            function b(e1, t, r, o) {
                var i = t.geometry, s = t.type, n = [];
                if ("Point" === s || "MultiPoint" === s) for(var a = 0; a < i.length; a += 3)n.push(i[a]), n.push(i[a + 1]), e1.numPoints++, e1.numSimplified++;
                else if ("LineString" === s) I(n, i, e1, r, !1, !1);
                else if ("MultiLineString" === s || "Polygon" === s) for(a = 0; a < i.length; a++)I(n, i[a], e1, r, "Polygon" === s, 0 === a);
                else if ("MultiPolygon" === s) for(var l = 0; l < i.length; l++){
                    var h = i[l];
                    for(a = 0; a < h.length; a++)I(n, h[a], e1, r, !0, 0 === a);
                }
                if (n.length) {
                    var u = t.tags || null;
                    if ("LineString" === s && o.lineMetrics) {
                        for(var c in u = {}, t.tags)u[c] = t.tags[c];
                        u.mapbox_clip_start = i.start / i.size, u.mapbox_clip_end = i.end / i.size;
                    }
                    var f = {
                        geometry: n,
                        type: "Polygon" === s || "MultiPolygon" === s ? 3 : "LineString" === s || "MultiLineString" === s ? 2 : 1,
                        tags: u
                    };
                    null !== t.id && (f.id = t.id), e1.features.push(f);
                }
            }
            function I(e1, t, r, o, i, s) {
                var n = o * o;
                if (o > 0 && t.size < (i ? n : o)) r.numPoints += t.length / 3;
                else {
                    for(var a = [], l = 0; l < t.length; l += 3)(0 === o || t[l + 2] > n) && (r.numSimplified++, a.push(t[l]), a.push(t[l + 1])), r.numPoints++;
                    i && function(e1, t) {
                        for(var r = 0, o = 0, i = e1.length, s = i - 2; o < i; s = o, o += 2)r += (e1[o] - e1[s]) * (e1[o + 1] + e1[s + 1]);
                        if (r > 0 === t) for(o = 0, i = e1.length; o < i / 2; o += 2){
                            var n = e1[o], a = e1[o + 1];
                            e1[o] = e1[i - 2 - o], e1[o + 1] = e1[i - 1 - o], e1[i - 2 - o] = n, e1[i - 1 - o] = a;
                        }
                    }(a, s), e1.push(a);
                }
            }
            function k(e1, t) {
                var r = (t = this.options = function(e1, t) {
                    for(var r in t)e1[r] = t[r];
                    return e1;
                }(Object.create(this.options), t)).debug;
                if (r && console.time("preprocess data"), t.maxZoom < 0 || t.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t.promoteId && t.generateId) throw new Error("promoteId and generateId cannot be used together.");
                var o = function(e1, t) {
                    var r = [];
                    if ("FeatureCollection" === e1.type) for(var o = 0; o < e1.features.length; o++)i(r, e1.features[o], t, o);
                    else i(r, "Feature" === e1.type ? e1 : {
                        geometry: e1
                    }, t);
                    return r;
                }(e1, t);
                this.tiles = {}, this.tileCoords = [], r && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), (o = function(e1, t) {
                    var r = t.buffer / t.extent, o = e1, i = u(e1, 1, -1 - r, r, 0, -1, 2, t), s = u(e1, 1, 1 - r, 2 + r, 0, -1, 2, t);
                    return (i || s) && (o = u(e1, 1, -r, 1 + r, 0, -1, 2, t) || [], i && (o = v(i, 1).concat(o)), s && (o = o.concat(v(s, -1)))), o;
                }(o, t)).length && this.splitTile(o, 0, 0, 0), r && (o.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            function P(e1, t, r) {
                return 32 * ((1 << e1) * r + t) + e1;
            }
            return k.prototype.options = {
                maxZoom: 14,
                indexMaxZoom: 5,
                indexMaxPoints: 1e5,
                tolerance: 3,
                extent: 4096,
                buffer: 64,
                lineMetrics: !1,
                promoteId: null,
                generateId: !1,
                debug: 0
            }, k.prototype.splitTile = function(e1, t, r, o, i, s, n) {
                for(var a = [
                    e1,
                    t,
                    r,
                    o
                ], l = this.options, h = l.debug; a.length;){
                    o = a.pop(), r = a.pop(), t = a.pop(), e1 = a.pop();
                    var c = 1 << t, f = P(t, r, o), d = this.tiles[f];
                    if (!d && (h > 1 && console.time("creation"), d = this.tiles[f] = M(e1, t, r, o, l), this.tileCoords.push({
                        z: t,
                        x: r,
                        y: o
                    }), h)) {
                        h > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, r, o, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        var p = "z" + t;
                        this.stats[p] = (this.stats[p] || 0) + 1, this.total++;
                    }
                    if (d.source = e1, i) {
                        if (t === l.maxZoom || t === i) continue;
                        var g = 1 << i - t;
                        if (r !== Math.floor(s / g) || o !== Math.floor(n / g)) continue;
                    } else if (t === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    if (d.source = null, 0 !== e1.length) {
                        h > 1 && console.time("clipping");
                        var m, y, v, w, x, S, b = .5 * l.buffer / l.extent, I = .5 - b, k = .5 + b, _ = 1 + b;
                        m = y = v = w = null, x = u(e1, c, r - b, r + k, 0, d.minX, d.maxX, l), S = u(e1, c, r + I, r + _, 0, d.minX, d.maxX, l), e1 = null, x && (m = u(x, c, o - b, o + k, 1, d.minY, d.maxY, l), y = u(x, c, o + I, o + _, 1, d.minY, d.maxY, l), x = null), S && (v = u(S, c, o - b, o + k, 1, d.minY, d.maxY, l), w = u(S, c, o + I, o + _, 1, d.minY, d.maxY, l), S = null), h > 1 && console.timeEnd("clipping"), a.push(m || [], t + 1, 2 * r, 2 * o), a.push(y || [], t + 1, 2 * r, 2 * o + 1), a.push(v || [], t + 1, 2 * r + 1, 2 * o), a.push(w || [], t + 1, 2 * r + 1, 2 * o + 1);
                    }
                }
            }, k.prototype.getTile = function(e1, t, r) {
                var o = this.options, i = o.extent, s = o.debug;
                if (e1 < 0 || e1 > 24) return null;
                var n = 1 << e1, a = P(e1, t = (t % n + n) % n, r);
                if (this.tiles[a]) return x(this.tiles[a], i);
                s > 1 && console.log("drilling down to z%d-%d-%d", e1, t, r);
                for(var l, h = e1, u = t, c = r; !l && h > 0;)h--, u = Math.floor(u / 2), c = Math.floor(c / 2), l = this.tiles[P(h, u, c)];
                return l && l.source ? (s > 1 && console.log("found parent tile z%d-%d-%d", h, u, c), s > 1 && console.time("drilling down"), this.splitTile(l.source, h, u, c, e1, t, r), s > 1 && console.timeEnd("drilling down"), this.tiles[a] ? x(this.tiles[a], i) : null) : null;
            }, function(e1, t) {
                return new k(e1, t);
            };
        }();
        var J = e1.g(N.exports);
        function Y(t, r) {
            const o = t.tileID.canonical;
            if (!this._geoJSONIndex) return r(null, null);
            const i = this._geoJSONIndex.getTile(o.z, o.x, o.y);
            if (!i) return r(null, null);
            const s = new class {
                feature(t) {
                    return new class {
                        loadGeometry() {
                            if (1 === this._feature.type) {
                                const t = [];
                                for (const r of this._feature.geometry)t.push([
                                    new e1.P(r[0], r[1])
                                ]);
                                return t;
                            }
                            {
                                const t = [];
                                for (const r of this._feature.geometry){
                                    const o = [];
                                    for (const t of r)o.push(new e1.P(t[0], t[1]));
                                    t.push(o);
                                }
                                return t;
                            }
                        }
                        toGeoJSON(e1, t, r) {
                            return l.call(this, e1, t, r);
                        }
                        constructor(t){
                            this._feature = t, this.extent = e1.E, this.type = t.type, this.properties = t.tags, "id" in t && !isNaN(t.id) && (this.id = parseInt(t.id, 10));
                        }
                    }(this._features[t]);
                }
                constructor(t){
                    this.layers = {
                        _geojsonTileLayer: this
                    }, this.name = "_geojsonTileLayer", this.extent = e1.E, this.length = t.length, this._features = t;
                }
            }(i.features);
            let n = k(s);
            0 === n.byteOffset && n.byteLength === n.buffer.byteLength || (n = new Uint8Array(n)), r(null, {
                vectorTile: s,
                rawData: n.buffer
            });
        }
        class G extends e1.d {
            loadData(t, r) {
                const o = t && t.request, i = o && o.collectResourceTiming;
                this.loadGeoJSON(t, (s, n)=>{
                    if (s || !n) return r(s);
                    if ("object" != typeof n) return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    {
                        a(n, !0);
                        try {
                            if (t.filter) {
                                const r = e1.e(t.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === r.result) throw new Error(r.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                                const o = n.features.filter((e1)=>r.value.evaluate({
                                        zoom: 0
                                    }, e1));
                                n = {
                                    type: "FeatureCollection",
                                    features: o
                                };
                            }
                            this._geoJSONIndex = t.cluster ? new j(function({ superclusterOptions: t, clusterProperties: r }) {
                                if (!r || !t) return t;
                                const o = {}, i = {}, s = {
                                    accumulated: null,
                                    zoom: 0
                                }, n = {
                                    properties: null
                                }, a = Object.keys(r);
                                for (const t of a){
                                    const [s, n] = r[t], a = e1.e(n), l = e1.e("string" == typeof s ? [
                                        s,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            t
                                        ]
                                    ] : s);
                                    o[t] = a.value, i[t] = l.value;
                                }
                                return t.map = (e1)=>{
                                    n.properties = e1;
                                    const t = {};
                                    for (const e1 of a)t[e1] = o[e1].evaluate(s, n);
                                    return t;
                                }, t.reduce = (e1, t)=>{
                                    n.properties = t;
                                    for (const t of a)s.accumulated = e1[t], e1[t] = i[t].evaluate(s, n);
                                }, t;
                            }(t)).load(n.features) : J(n, t.geojsonVtOptions);
                        } catch (s) {
                            return r(s);
                        }
                        this.loaded = {};
                        const l = {};
                        if (i) {
                            const r = e1.f(o);
                            r && (l.resourceTiming = {}, l.resourceTiming[t.source] = JSON.parse(JSON.stringify(r)));
                        }
                        r(null, l);
                    }
                });
            }
            reloadTile(e1, t) {
                const r = this.loaded;
                return r && r[e1.uid] ? super.reloadTile(e1, t) : this.loadTile(e1, t);
            }
            loadGeoJSON(t, r) {
                if (t.request) e1.h(t.request, r);
                else {
                    if ("string" != typeof t.data) return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    try {
                        return r(null, JSON.parse(t.data));
                    } catch (e1) {
                        return r(new Error(`Input data given to '${t.source}' is not a valid GeoJSON object.`));
                    }
                }
            }
            getClusterExpansionZoom(e1, t) {
                try {
                    t(null, this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId));
                } catch (e1) {
                    t(e1);
                }
            }
            getClusterChildren(e1, t) {
                try {
                    t(null, this._geoJSONIndex.getChildren(e1.clusterId));
                } catch (e1) {
                    t(e1);
                }
            }
            getClusterLeaves(e1, t) {
                try {
                    t(null, this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset));
                } catch (e1) {
                    t(e1);
                }
            }
            constructor(e1, t, r, o, i, s){
                super(e1, t, r, o, Y, s), i && (this.loadGeoJSON = i);
            }
        }
        class W {
            parse(t, r, o, i) {
                this.status = "parsing";
                const s = new e1.O(o.tileID.overscaledZ, o.tileID.wrap, o.tileID.canonical.z, o.tileID.canonical.x, o.tileID.canonical.y), n = {}, a = r.familiesBySource[o.source], l = new e1.F(s, o.promoteId);
                return l.bucketLayerIDs = [], e1.l(t).then((t)=>{
                    if (!t) return i(new Error("Could not parse tile"));
                    const r = e1.j(t, 1 / e1.t(o.tileID.canonical)), h = t.json.extensionsUsed && t.json.extensionsUsed.includes("MAPBOX_mesh_features"), u = new e1.k(this.zoom, {
                        brightness: this.brightness
                    });
                    for(const o in a)for (const i of a[o]){
                        const o = i[0], a = t.json.extensionsUsed;
                        o.recalculate(u, []);
                        const l = new e1.T(r, s, a && a.includes("MAPBOX_mesh_features"), this.brightness);
                        h || (l.needsUpload = !0), n[o.fqid] = l, l.evaluate(o);
                    }
                    this.status = "done", i(null, {
                        buckets: n,
                        featureIndex: l
                    });
                }).catch((e1)=>i(new Error(e1.message)));
            }
            constructor(t, r){
                this.tileID = new e1.O(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.tileZoom = t.tileZoom, this.uid = t.uid, this.zoom = t.zoom, this.canonical = t.tileID.canonical, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = t.projection, this.brightness = r;
            }
        }
        class X {
            loadTile(t, r) {
                const o = t.uid, i = this.loading[o] = new W(t, this.brightness);
                e1.i(t.request, (e1, s)=>{
                    const n = !this.loading[o];
                    return delete this.loading[o], n || e1 ? (i.status = "done", n || (this.loaded[o] = i), r(e1)) : s && 0 !== s.byteLength ? void i.parse(s, this.layerIndex, t, (e1, t)=>{
                        i.status = "done", this.loaded = this.loaded || {}, this.loaded[o] = i, e1 || !t ? r(e1) : r(null, t);
                    }) : (i.status = "done", this.loaded[o] = i, r());
                });
            }
            reloadTile(e1, t) {
                const r = this.loaded, o = e1.uid;
                if (r && r[o]) {
                    const i = r[o];
                    i.projection = e1.projection, i.brightness = e1.brightness;
                    const s = (r, o)=>{
                        i.reloadCallback && (delete i.reloadCallback, this.loadTile(e1, t)), t(r, o);
                    };
                    "parsing" === i.status ? i.reloadCallback = s : "done" === i.status && this.loadTile(e1, t);
                }
            }
            abortTile(e1, t) {
                const r = e1.uid;
                this.loading[r] && delete this.loading[r], t();
            }
            removeTile(e1, t) {
                const r = this.loaded, o = e1.uid;
                r && r[o] && delete r[o], t();
            }
            constructor(e1, t, r, o, i, s){
                this.actor = e1, this.layerIndex = t, this.brightness = s, this.loading = {}, this.loaded = {};
            }
        }
        class V {
            clearCaches(e1, t, r) {
                delete this.layerIndexes[e1], delete this.availableImages[e1], delete this.workerSources[e1], delete this.demWorkerSources[e1], r();
            }
            checkIfReady(e1, t, r) {
                r();
            }
            setReferrer(e1, t) {
                this.referrer = t;
            }
            spriteLoaded(t, { scope: r, isLoaded: o }) {
                if (this.isSpriteLoaded[t] || (this.isSpriteLoaded[t] = {}), this.isSpriteLoaded[t][r] = o, this.workerSources[t] && this.workerSources[t][r]) for(const i in this.workerSources[t][r]){
                    const s = this.workerSources[t][r][i];
                    for(const t in s)s[t] instanceof e1.d && (s[t].isSpriteLoaded = o, s[t].fire(new e1.o("isSpriteLoaded")));
                }
            }
            setImages(e1, { scope: t, images: r }, o) {
                if (this.availableImages[e1] || (this.availableImages[e1] = {}), this.availableImages[e1][t] = r, this.workerSources[e1] && this.workerSources[e1][t]) {
                    for(const o in this.workerSources[e1][t]){
                        const i = this.workerSources[e1][t][o];
                        for(const e1 in i)i[e1].availableImages = r;
                    }
                    o();
                } else o();
            }
            setProjection(t, r) {
                this.projections[t] = e1.m(r);
            }
            setBrightness(e1, t, r) {
                this.brightness = t, r();
            }
            setLayers(e1, t, r) {
                this.getLayerIndex(e1, t.scope).replace(t.layers, t.options), r();
            }
            updateLayers(e1, t, r) {
                this.getLayerIndex(e1, t.scope).update(t.layers, t.removedIds, t.options), r();
            }
            loadTile(e1, t, r) {
                t.projection = this.projections[e1] || this.defaultProjection, this.getWorkerSource(e1, t.type, t.source, t.scope).loadTile(t, r);
            }
            loadDEMTile(e1, t, r) {
                this.getDEMWorkerSource(e1, t.source, t.scope).loadTile(t, r);
            }
            reloadTile(e1, t, r) {
                t.projection = this.projections[e1] || this.defaultProjection, this.getWorkerSource(e1, t.type, t.source, t.scope).reloadTile(t, r);
            }
            abortTile(e1, t, r) {
                this.getWorkerSource(e1, t.type, t.source, t.scope).abortTile(t, r);
            }
            removeTile(e1, t, r) {
                this.getWorkerSource(e1, t.type, t.source, t.scope).removeTile(t, r);
            }
            removeSource(e1, t, r) {
                if (!(this.workerSources[e1] && this.workerSources[e1][t.scope] && this.workerSources[e1][t.scope][t.type] && this.workerSources[e1][t.scope][t.type][t.source])) return;
                const o = this.workerSources[e1][t.scope][t.type][t.source];
                delete this.workerSources[e1][t.scope][t.type][t.source], void 0 !== o.removeSource ? o.removeSource(t, r) : r();
            }
            loadWorkerSource(e1, t, r) {
                try {
                    this.self.importScripts(t.url), r();
                } catch (e1) {
                    r(e1.toString());
                }
            }
            syncRTLPluginState(t, r, o) {
                try {
                    e1.n.setState(r);
                    const t = e1.n.getPluginURL();
                    if (e1.n.isLoaded() && !e1.n.isParsed() && null != t) {
                        this.self.importScripts(t);
                        const r = e1.n.isParsed();
                        o(r ? void 0 : new Error(`RTL Text Plugin failed to import scripts from ${t}`), r);
                    }
                } catch (e1) {
                    o(e1.toString());
                }
            }
            setDracoUrl(e1, t) {
                this.dracoUrl = t;
            }
            getAvailableImages(e1, t) {
                this.availableImages[e1] || (this.availableImages[e1] = {});
                let r = this.availableImages[e1][t];
                return r || (r = []), r;
            }
            getLayerIndex(e1, t) {
                this.layerIndexes[e1] || (this.layerIndexes[e1] = {});
                let r = this.layerIndexes[e1][t];
                return r || (r = this.layerIndexes[e1][t] = new o, r.scope = t), r;
            }
            getWorkerSource(e1, t, r, o) {
                if (this.workerSources[e1] || (this.workerSources[e1] = {}), this.workerSources[e1][o] || (this.workerSources[e1][o] = {}), this.workerSources[e1][o][t] || (this.workerSources[e1][o][t] = {}), this.isSpriteLoaded[e1] || (this.isSpriteLoaded[e1] = {}), !this.workerSources[e1][o][t][r]) {
                    const i = {
                        send: (t, r, o, i, s, n)=>{
                            this.actor.send(t, r, o, e1, s, n);
                        },
                        scheduler: this.actor.scheduler
                    };
                    this.workerSources[e1][o][t][r] = new this.workerSourceTypes[t](i, this.getLayerIndex(e1, o), this.getAvailableImages(e1, o), this.isSpriteLoaded[e1][o], void 0, this.brightness);
                }
                return this.workerSources[e1][o][t][r];
            }
            getDEMWorkerSource(e1, t, r) {
                return this.demWorkerSources[e1] || (this.demWorkerSources[e1] = {}), this.demWorkerSources[e1][r] || (this.demWorkerSources[e1][r] = {}), this.demWorkerSources[e1][r][t] || (this.demWorkerSources[e1][r][t] = new i), this.demWorkerSources[e1][r][t];
            }
            enforceCacheSizeLimit(t, r) {
                e1.q(r);
            }
            getWorkerPerformanceMetrics(e1, t, r) {
                r(void 0, void 0);
            }
            constructor(t){
                this.self = t, this.actor = new e1.A(t, this), this.layerIndexes = {}, this.availableImages = {}, this.isSpriteLoaded = {}, this.projections = {}, this.defaultProjection = e1.m({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: e1.d,
                    geojson: G,
                    "batched-model": X
                }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = (e1, t)=>{
                    if (this.workerSourceTypes[e1]) throw new Error(`Worker source with name "${e1}" already registered.`);
                    this.workerSourceTypes[e1] = t;
                }, this.self.registerRTLTextPlugin = (t)=>{
                    if (e1.n.isParsed()) throw new Error("RTL text plugin already registered.");
                    e1.n.applyArabicShaping = t.applyArabicShaping, e1.n.processBidirectionalText = t.processBidirectionalText, e1.n.processStyledBidirectionalText = t.processStyledBidirectionalText;
                };
            }
        }
        return "undefined" != typeof WorkerGlobalScope && "undefined" != typeof self && self instanceof WorkerGlobalScope && (self.worker = new V(self)), V;
    });
    define([
        "./shared"
    ], function(e1) {
        "use strict";
        return e1.s;
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'mapboxgl'
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});

});

parcelRegister("3iM0v", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $26784abf95613c7b$var$ReactIs, $26784abf95613c7b$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("58U8g"))();

});


var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");
var $bb838d9b4dec0cfe$export$882461b6382ed46c;
var $bb838d9b4dec0cfe$export$757ceba2d55c277e;
"use strict";
var $330fb34df360181f$exports = {};
"use strict";
function $330fb34df360181f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($330fb34df360181f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$330fb34df360181f$var$checkDCE();

$330fb34df360181f$exports = (parcelRequire("cbAyt"));


var $bb838d9b4dec0cfe$var$i;
$bb838d9b4dec0cfe$export$882461b6382ed46c = $330fb34df360181f$exports.createRoot;
$bb838d9b4dec0cfe$export$757ceba2d55c277e = $330fb34df360181f$exports.hydrateRoot;




var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $4Q3YJ = parcelRequire("4Q3YJ");

var $izf4p = parcelRequire("izf4p");
const $f34cc3f354a72d02$var$_excluded = [
    "localeText"
];
const $f34cc3f354a72d02$export$544976378534cf9 = /*#__PURE__*/ $4YNlq.createContext(null);
const $f34cc3f354a72d02$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    var _React$useContext;
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $g54n0.default)(inProps, $f34cc3f354a72d02$var$_excluded);
    const { utils: parentUtils, localeText: parentLocaleText } = (_React$useContext = $4YNlq.useContext($f34cc3f354a72d02$export$544976378534cf9)) != null ? _React$useContext : {
        utils: undefined,
        localeText: undefined
    };
    const props = (0, $4Q3YJ.default)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: "MuiLocalizationProvider"
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $4YNlq.useMemo(()=>(0, $lzDk3.default)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const utils = $4YNlq.useMemo(()=>{
        if (!DateAdapter) {
            if (parentUtils) return parentUtils;
            return null;
        }
        const adapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!adapter.isMUIAdapter) throw new Error([
            "MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`",
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"
        ].join(`\n`));
        return adapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentUtils
    ]);
    const defaultDates = $4YNlq.useMemo(()=>{
        if (!utils) return null;
        return {
            minDate: utils.date("1900-01-01T00:00:00.000"),
            maxDate: utils.date("2099-12-31T00:00:00.000")
        };
    }, [
        utils
    ]);
    const contextValue = $4YNlq.useMemo(()=>{
        return {
            utils: utils,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        utils,
        localeText
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)($f34cc3f354a72d02$export$544976378534cf9.Provider, {
        value: contextValue,
        children: children
    });
};



var $4YNlq = parcelRequire("4YNlq");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $3c0e653794cf487e$var$extendStatics = function(d, b) {
    $3c0e653794cf487e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3c0e653794cf487e$var$extendStatics(d, b);
};
function $3c0e653794cf487e$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3c0e653794cf487e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3c0e653794cf487e$var$__assign = function() {
    $3c0e653794cf487e$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3c0e653794cf487e$var$__assign.apply(this, arguments);
};
function $3c0e653794cf487e$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3c0e653794cf487e$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $3c0e653794cf487e$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
typeof SuppressedError === "function" && SuppressedError;
function $3c0e653794cf487e$var$e(e, t) {
    var i = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (i[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var n = 0;
        for(o = Object.getOwnPropertySymbols(e); n < o.length; n++)t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (i[o[n]] = e[o[n]]);
    }
    return i;
}
"function" == typeof SuppressedError && SuppressedError;
var $3c0e653794cf487e$var$t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function $3c0e653794cf487e$var$i(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function $3c0e653794cf487e$var$o(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
}
var $3c0e653794cf487e$var$n = $3c0e653794cf487e$var$o(function(e, t) {
    Object.defineProperty(t, "__esModule", {
        value: !0
    });
    var i = function() {
        function e() {
            var e = this;
            this.locked = new Map, this.addToLocked = function(t, i) {
                var o = e.locked.get(t);
                void 0 === o ? void 0 === i ? e.locked.set(t, []) : e.locked.set(t, [
                    i
                ]) : void 0 !== i && (o.unshift(i), e.locked.set(t, o));
            }, this.isLocked = function(t) {
                return e.locked.has(t);
            }, this.lock = function(t) {
                return new Promise(function(i, o) {
                    e.isLocked(t) ? e.addToLocked(t, i) : (e.addToLocked(t), i());
                });
            }, this.unlock = function(t) {
                var i = e.locked.get(t);
                if (void 0 !== i && 0 !== i.length) {
                    var o = i.pop();
                    e.locked.set(t, i), void 0 !== o && setTimeout(o, 0);
                } else e.locked.delete(t);
            };
        }
        return e.getInstance = function() {
            return void 0 === e.instance && (e.instance = new e), e.instance;
        }, e;
    }();
    t.default = function() {
        return i.getInstance();
    };
});
$3c0e653794cf487e$var$i($3c0e653794cf487e$var$n);
var $3c0e653794cf487e$var$a = $3c0e653794cf487e$var$i($3c0e653794cf487e$var$o(function(e, i) {
    var o = $3c0e653794cf487e$var$t && $3c0e653794cf487e$var$t.__awaiter || function(e, t, i, o) {
        return new (i || (i = Promise))(function(n, a) {
            function r(e) {
                try {
                    c(o.next(e));
                } catch (e) {
                    a(e);
                }
            }
            function s(e) {
                try {
                    c(o.throw(e));
                } catch (e) {
                    a(e);
                }
            }
            function c(e) {
                e.done ? n(e.value) : new i(function(t) {
                    t(e.value);
                }).then(r, s);
            }
            c((o = o.apply(e, t || [])).next());
        });
    }, a = $3c0e653794cf487e$var$t && $3c0e653794cf487e$var$t.__generator || function(e, t) {
        var i, o, n, a, r = {
            label: 0,
            sent: function() {
                if (1 & n[0]) throw n[1];
                return n[1];
            },
            trys: [],
            ops: []
        };
        return a = {
            next: s(0),
            throw: s(1),
            return: s(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
            return this;
        }), a;
        function s(a) {
            return function(s) {
                return function(a) {
                    if (i) throw new TypeError("Generator is already executing.");
                    for(; r;)try {
                        if (i = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                        switch(o = 0, n && (a = [
                            2 & a[0],
                            n.value
                        ]), a[0]){
                            case 0:
                            case 1:
                                n = a;
                                break;
                            case 4:
                                return r.label++, {
                                    value: a[1],
                                    done: !1
                                };
                            case 5:
                                r.label++, o = a[1], a = [
                                    0
                                ];
                                continue;
                            case 7:
                                a = r.ops.pop(), r.trys.pop();
                                continue;
                            default:
                                if (!(n = r.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                    r = 0;
                                    continue;
                                }
                                if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                    r.label = a[1];
                                    break;
                                }
                                if (6 === a[0] && r.label < n[1]) {
                                    r.label = n[1], n = a;
                                    break;
                                }
                                if (n && r.label < n[2]) {
                                    r.label = n[2], r.ops.push(a);
                                    break;
                                }
                                n[2] && r.ops.pop(), r.trys.pop();
                                continue;
                        }
                        a = t.call(e, r);
                    } catch (e) {
                        a = [
                            6,
                            e
                        ], o = 0;
                    } finally{
                        i = n = 0;
                    }
                    if (5 & a[0]) throw a[1];
                    return {
                        value: a[0] ? a[1] : void 0,
                        done: !0
                    };
                }([
                    a,
                    s
                ]);
            };
        }
    }, r = $3c0e653794cf487e$var$t;
    Object.defineProperty(i, "__esModule", {
        value: !0
    });
    var s = "browser-tabs-lock-key", c = {
        key: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        getItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        clear: function() {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    return [
                        2,
                        window.localStorage.clear()
                    ];
                });
            });
        },
        removeItem: function(e) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        setItem: function(e, t) {
            return o(r, void 0, void 0, function() {
                return a(this, function(e) {
                    throw new Error("Unsupported");
                });
            });
        },
        keySync: function(e) {
            return window.localStorage.key(e);
        },
        getItemSync: function(e) {
            return window.localStorage.getItem(e);
        },
        clearSync: function() {
            return window.localStorage.clear();
        },
        removeItemSync: function(e) {
            return window.localStorage.removeItem(e);
        },
        setItemSync: function(e, t) {
            return window.localStorage.setItem(e, t);
        }
    };
    function d(e) {
        return new Promise(function(t) {
            return setTimeout(t, e);
        });
    }
    function u(e) {
        for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", i = "", o = 0; o < e; o++)i += t[Math.floor(Math.random() * t.length)];
        return i;
    }
    var l = function() {
        function e(t) {
            this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + u(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
        }
        return e.prototype.acquireLock = function(t, i) {
            return void 0 === i && (i = 5e3), o(this, void 0, void 0, function() {
                var o, n, r, l, h, p, m;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            o = Date.now() + u(4), n = Date.now() + i, r = s + "-" + t, l = void 0 === this.storageHandler ? c : this.storageHandler, a.label = 1;
                        case 1:
                            return Date.now() < n ? [
                                4,
                                d(30)
                            ] : [
                                3,
                                8
                            ];
                        case 2:
                            return a.sent(), null !== l.getItemSync(r) ? [
                                3,
                                5
                            ] : (h = this.id + "-" + t + "-" + o, [
                                4,
                                d(Math.floor(25 * Math.random()))
                            ]);
                        case 3:
                            return a.sent(), l.setItemSync(r, JSON.stringify({
                                id: this.id,
                                iat: o,
                                timeoutKey: h,
                                timeAcquired: Date.now(),
                                timeRefreshed: Date.now()
                            })), [
                                4,
                                d(30)
                            ];
                        case 4:
                            return a.sent(), null !== (p = l.getItemSync(r)) && (m = JSON.parse(p)).id === this.id && m.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(r, o), [
                                2,
                                !0
                            ]) : [
                                3,
                                7
                            ];
                        case 5:
                            return e.lockCorrector(void 0 === this.storageHandler ? c : this.storageHandler), [
                                4,
                                this.waitForSomethingToChange(n)
                            ];
                        case 6:
                            a.sent(), a.label = 7;
                        case 7:
                            return o = Date.now() + u(4), [
                                3,
                                1
                            ];
                        case 8:
                            return [
                                2,
                                !1
                            ];
                    }
                });
            });
        }, e.prototype.refreshLockWhileAcquired = function(e, t) {
            return o(this, void 0, void 0, function() {
                var i = this;
                return a(this, function(r) {
                    return setTimeout(function() {
                        return o(i, void 0, void 0, function() {
                            var i, o, r;
                            return a(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return [
                                            4,
                                            $3c0e653794cf487e$var$n.default().lock(t)
                                        ];
                                    case 1:
                                        return a.sent(), this.acquiredIatSet.has(t) ? (i = void 0 === this.storageHandler ? c : this.storageHandler, null === (o = i.getItemSync(e)) ? ($3c0e653794cf487e$var$n.default().unlock(t), [
                                            2
                                        ]) : ((r = JSON.parse(o)).timeRefreshed = Date.now(), i.setItemSync(e, JSON.stringify(r)), $3c0e653794cf487e$var$n.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                            2
                                        ])) : ($3c0e653794cf487e$var$n.default().unlock(t), [
                                            2
                                        ]);
                                }
                            });
                        });
                    }, 1e3), [
                        2
                    ];
                });
            });
        }, e.prototype.waitForSomethingToChange = function(t) {
            return o(this, void 0, void 0, function() {
                return a(this, function(i) {
                    switch(i.label){
                        case 0:
                            return [
                                4,
                                new Promise(function(i) {
                                    var o = !1, n = Date.now(), a = !1;
                                    function r() {
                                        if (a || (window.removeEventListener("storage", r), e.removeFromWaiting(r), clearTimeout(s), a = !0), !o) {
                                            o = !0;
                                            var t = 50 - (Date.now() - n);
                                            t > 0 ? setTimeout(i, t) : i(null);
                                        }
                                    }
                                    window.addEventListener("storage", r), e.addToWaiting(r);
                                    var s = setTimeout(r, Math.max(0, t - Date.now()));
                                })
                            ];
                        case 1:
                            return i.sent(), [
                                2
                            ];
                    }
                });
            });
        }, e.addToWaiting = function(t) {
            this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
        }, e.removeFromWaiting = function(t) {
            void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
                return e !== t;
            }));
        }, e.notifyWaiters = function() {
            void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
                return e();
            });
        }, e.prototype.releaseLock = function(e) {
            return o(this, void 0, void 0, function() {
                return a(this, function(t) {
                    switch(t.label){
                        case 0:
                            return [
                                4,
                                this.releaseLock__private__(e)
                            ];
                        case 1:
                            return [
                                2,
                                t.sent()
                            ];
                    }
                });
            });
        }, e.prototype.releaseLock__private__ = function(t) {
            return o(this, void 0, void 0, function() {
                var i, o, r, d;
                return a(this, function(a) {
                    switch(a.label){
                        case 0:
                            return i = void 0 === this.storageHandler ? c : this.storageHandler, o = s + "-" + t, null === (r = i.getItemSync(o)) ? [
                                2
                            ] : (d = JSON.parse(r)).id !== this.id ? [
                                3,
                                2
                            ] : [
                                4,
                                $3c0e653794cf487e$var$n.default().lock(d.iat)
                            ];
                        case 1:
                            a.sent(), this.acquiredIatSet.delete(d.iat), i.removeItemSync(o), $3c0e653794cf487e$var$n.default().unlock(d.iat), e.notifyWaiters(), a.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
        }, e.lockCorrector = function(t) {
            for(var i = Date.now() - 5e3, o = t, n = [], a = 0;;){
                var r = o.keySync(a);
                if (null === r) break;
                n.push(r), a++;
            }
            for(var c = !1, d = 0; d < n.length; d++){
                var u = n[d];
                if (u.includes(s)) {
                    var l = o.getItemSync(u);
                    if (null !== l) {
                        var h = JSON.parse(l);
                        (void 0 === h.timeRefreshed && h.timeAcquired < i || void 0 !== h.timeRefreshed && h.timeRefreshed < i) && (o.removeItemSync(u), c = !0);
                    }
                }
            }
            c && e.notifyWaiters();
        }, e.waiters = void 0, e;
    }();
    i.default = l;
}));
const $3c0e653794cf487e$var$r = {
    timeoutInSeconds: 60
}, $3c0e653794cf487e$var$s = {
    name: "auth0-spa-js",
    version: "2.1.3"
}, $3c0e653794cf487e$var$c = ()=>Date.now();
class $3c0e653794cf487e$export$7d465be8efa67280 extends Error {
    static fromPayload({ error: e, error_description: t }) {
        return new $3c0e653794cf487e$export$7d465be8efa67280(e, t);
    }
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, $3c0e653794cf487e$export$7d465be8efa67280.prototype);
    }
}
class $3c0e653794cf487e$export$cf0c46b07324e9c5 extends $3c0e653794cf487e$export$7d465be8efa67280 {
    constructor(e, t, i, o = null){
        super(e, t), this.state = i, this.appState = o, Object.setPrototypeOf(this, $3c0e653794cf487e$export$cf0c46b07324e9c5.prototype);
    }
}
class $3c0e653794cf487e$export$66d311bf29d5c89c extends $3c0e653794cf487e$export$7d465be8efa67280 {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, $3c0e653794cf487e$export$66d311bf29d5c89c.prototype);
    }
}
class $3c0e653794cf487e$export$ebbb83fe03f719a4 extends $3c0e653794cf487e$export$66d311bf29d5c89c {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, $3c0e653794cf487e$export$ebbb83fe03f719a4.prototype);
    }
}
class $3c0e653794cf487e$export$f1f681f0fb26bb55 extends $3c0e653794cf487e$export$7d465be8efa67280 {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, $3c0e653794cf487e$export$f1f681f0fb26bb55.prototype);
    }
}
class $3c0e653794cf487e$export$c59494f4dae44ada extends $3c0e653794cf487e$export$7d465be8efa67280 {
    constructor(e, t, i){
        super(e, t), this.mfa_token = i, Object.setPrototypeOf(this, $3c0e653794cf487e$export$c59494f4dae44ada.prototype);
    }
}
class $3c0e653794cf487e$export$ac1d2a00f8e0a046 extends $3c0e653794cf487e$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_refresh_token", `Missing Refresh Token (audience: '${$3c0e653794cf487e$var$g(e, [
            "default"
        ])}', scope: '${$3c0e653794cf487e$var$g(t)}')`), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $3c0e653794cf487e$export$ac1d2a00f8e0a046.prototype);
    }
}
function $3c0e653794cf487e$var$g(e, t = []) {
    return e && !t.includes(e) ? e : "";
}
const $3c0e653794cf487e$var$w = ()=>window.crypto, $3c0e653794cf487e$var$y = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from($3c0e653794cf487e$var$w().getRandomValues(new Uint8Array(43))).forEach((i)=>t += e[i % e.length]), t;
}, $3c0e653794cf487e$var$k = (e)=>btoa(e), $3c0e653794cf487e$var$v = (t)=>{
    var { clientId: i } = t, o = $3c0e653794cf487e$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, i)=>Object.assign(Object.assign({}, t), {
                [i]: e[i]
            }), {}))(Object.assign({
        client_id: i
    }, o))).toString();
}, $3c0e653794cf487e$var$b = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), $3c0e653794cf487e$var$_ = async (e, t)=>{
    const i = await fetch(e, t);
    return {
        ok: i.ok,
        json: await i.json()
    };
}, $3c0e653794cf487e$var$I = async (e, t, i)=>{
    const o = new AbortController;
    let n;
    return t.signal = o.signal, Promise.race([
        $3c0e653794cf487e$var$_(e, t),
        new Promise((e, t)=>{
            n = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, i);
        })
    ]).finally(()=>{
        clearTimeout(n);
    });
}, $3c0e653794cf487e$var$S = async (e, t, i, o, n, a, r)=>{
    var s, c;
    return s = {
        auth: {
            audience: t,
            scope: i
        },
        timeout: n,
        fetchUrl: e,
        fetchOptions: o,
        useFormData: r
    }, c = a, new Promise(function(e, t) {
        const i = new MessageChannel;
        i.port1.onmessage = function(o) {
            o.data.error ? t(new Error(o.data.error)) : e(o.data), i.port1.close();
        }, c.postMessage(s, [
            i.port2
        ]);
    });
}, $3c0e653794cf487e$var$O = async (e, t, i, o, n, a, r = 1e4)=>n ? $3c0e653794cf487e$var$S(e, t, i, o, r, n, a) : $3c0e653794cf487e$var$I(e, o, r);
async function $3c0e653794cf487e$var$T(t, i) {
    var { baseUrl: o, timeout: n, audience: a, scope: r, auth0Client: c, useFormData: u } = t, l = $3c0e653794cf487e$var$e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData"
    ]);
    const h = u ? $3c0e653794cf487e$var$v(l) : JSON.stringify(l);
    return await async function(t, i, o, n, a, r, s) {
        let c, u = null;
        for(let e = 0; e < 3; e++)try {
            c = await $3c0e653794cf487e$var$O(t, o, n, a, r, s, i), u = null;
            break;
        } catch (e) {
            u = e;
        }
        if (u) throw u;
        const l = c.json, { error: h, error_description: p } = l, g = $3c0e653794cf487e$var$e(l, [
            "error",
            "error_description"
        ]), { ok: w } = c;
        if (!w) {
            const e = p || `HTTP error. Unable to fetch ${t}`;
            if ("mfa_required" === h) throw new $3c0e653794cf487e$export$c59494f4dae44ada(h, e, g.mfa_token);
            if ("missing_refresh_token" === h) throw new $3c0e653794cf487e$export$ac1d2a00f8e0a046(o, n);
            throw new $3c0e653794cf487e$export$7d465be8efa67280(h || "request_error", e);
        }
        return g;
    }(`${o}/oauth/token`, n, a || "default", r, {
        method: "POST",
        body: h,
        headers: {
            "Content-Type": u ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify(c || $3c0e653794cf487e$var$s))
        }
    }, i, u);
}
const $3c0e653794cf487e$var$j = (...e)=>{
    var t;
    return (t = e.filter(Boolean).join(" ").trim().split(/\s+/), Array.from(new Set(t))).join(" ");
};
class $3c0e653794cf487e$var$C {
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, i, o, n] = e.split("::");
        return new $3c0e653794cf487e$var$C({
            clientId: i,
            scope: n,
            audience: o
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: i, client_id: o } = e;
        return new $3c0e653794cf487e$var$C({
            scope: t,
            audience: i,
            clientId: o
        });
    }
    constructor(e, t = "@@auth0spajs@@", i){
        this.prefix = t, this.suffix = i, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
}
class $3c0e653794cf487e$export$40ef2cb682e70737 {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class $3c0e653794cf487e$export$467265324939f47f {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, i) {
                    e[t] = i;
                },
                get (t) {
                    const i = e[t];
                    if (i) return i;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class $3c0e653794cf487e$var$x {
    async setIdToken(e, t, i) {
        var o;
        const n = this.getIdTokenCacheKey(e);
        await this.cache.set(n, {
            id_token: t,
            decodedToken: i
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(n));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e, t = 0) {
        var i;
        let o = await this.cache.get(e.toKey());
        if (!o) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const i = this.matchExistingCacheKey(e, t);
            i && (o = await this.cache.get(i));
        }
        if (!o) return;
        const n = await this.nowProvider(), a = Math.floor(n / 1e3);
        return o.expiresAt - t < a ? o.body.refresh_token ? (o.body = {
            refresh_token: o.body.refresh_token
        }, await this.cache.set(e.toKey(), o), o.body) : (await this.cache.remove(e.toKey()), void await (null === (i = this.keyManifest) || void 0 === i ? void 0 : i.remove(e.toKey()))) : o.body;
    }
    async set(e) {
        var t;
        const i = new $3c0e653794cf487e$var$C({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(i.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(i.toKey()));
    }
    async clear(e) {
        var t;
        const i = await this.getCacheKeys();
        i && (await i.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new $3c0e653794cf487e$var$C({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var i;
            const o = $3c0e653794cf487e$var$C.fromKey(t), n = new Set(o.scope && o.scope.split(" ")), a = (null === (i = e.scope) || void 0 === i ? void 0 : i.split(" ")) || [], r = o.scope && a.reduce((e, t)=>e && n.has(t), !0);
            return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && r;
        })[0];
    }
    constructor(e, t, i){
        this.cache = e, this.keyManifest = t, this.nowProvider = i || $3c0e653794cf487e$var$c;
    }
}
class $3c0e653794cf487e$var$Z {
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
    constructor(e, t, i){
        this.storage = e, this.clientId = t, this.cookieDomain = i, this.storageKey = `a0.spajs.txs.${this.clientId}`;
    }
}
const $3c0e653794cf487e$var$K = (e)=>"number" == typeof e, $3c0e653794cf487e$var$W = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $3c0e653794cf487e$var$E = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [i, o, n] = t;
        if (3 !== t.length || !i || !o || !n) throw new Error("ID token could not be decoded");
        const a = JSON.parse($3c0e653794cf487e$var$b(o)), r = {
            __raw: e
        }, s = {};
        return Object.keys(a).forEach((e)=>{
            r[e] = a[e], $3c0e653794cf487e$var$W.includes(e) || (s[e] = a[e]);
        }), {
            encoded: {
                header: i,
                payload: o,
                signature: n
            },
            header: JSON.parse($3c0e653794cf487e$var$b(i)),
            claims: r,
            user: s
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error(`Issuer (iss) claim mismatch in the ID token; expected "${e.iss}", found "${t.claims.iss}"`);
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error(`Signature algorithm of "${t.header.alg}" is not supported. Expected the ID token to be signed with "RS256".`);
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but was not one of "${t.claims.aud.join(", ")}"`);
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error(`Authorized Party (azp) claim mismatch in the ID token; expected "${e.aud}", found "${t.claims.azp}"`);
        }
    } else if (t.claims.aud !== e.aud) throw new Error(`Audience (aud) claim mismatch in the ID token; expected "${e.aud}" but found "${t.claims.aud}"`);
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error(`Nonce (nonce) claim mismatch in the ID token; expected "${e.nonce}", found "${t.claims.nonce}"`);
    }
    if (e.max_age && !$3c0e653794cf487e$var$K(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$3c0e653794cf487e$var$K(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$3c0e653794cf487e$var$K(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const i = e.leeway || 60, o = new Date(e.now || Date.now()), n = new Date(0);
    if (n.setUTCSeconds(t.claims.exp + i), o > n) throw new Error(`Expiration Time (exp) claim error in the ID token; current time (${o}) is after expiration time (${n})`);
    if (null != t.claims.nbf && $3c0e653794cf487e$var$K(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - i), o < e) throw new Error(`Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (${o}) is before ${e}`);
    }
    if (null != t.claims.auth_time && $3c0e653794cf487e$var$K(t.claims.auth_time)) {
        const n = new Date(0);
        if (n.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + i), o > n) throw new Error(`Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (${o}) is after last auth at ${n}`);
    }
    if (e.organization) {
        const i = e.organization.trim();
        if (i.startsWith("org_")) {
            const e = i;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error(`Organization ID (org_id) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_id}"`);
        } else {
            const e = i.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error(`Organization Name (org_name) claim mismatch in the ID token; expected "${e}", found "${t.claims.org_name}"`);
        }
    }
    return t;
};
var $3c0e653794cf487e$var$R = $3c0e653794cf487e$var$o(function(e, i) {
    var o = $3c0e653794cf487e$var$t && $3c0e653794cf487e$var$t.__assign || function() {
        return o = Object.assign || function(e) {
            for(var t, i = 1, o = arguments.length; i < o; i++)for(var n in t = arguments[i])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            return e;
        }, o.apply(this, arguments);
    };
    function n(e, t) {
        if (!t) return "";
        var i = "; " + e;
        return !0 === t ? i : i + "=" + t;
    }
    function a(e, t, i) {
        return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
            if ("number" == typeof e.expires) {
                var t = new Date;
                t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
            }
            return n("Expires", e.expires ? e.expires.toUTCString() : "") + n("Domain", e.domain) + n("Path", e.path) + n("Secure", e.secure) + n("SameSite", e.sameSite);
        }(i);
    }
    function r(e) {
        for(var t = {}, i = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, n = 0; n < i.length; n++){
            var a = i[n].split("="), r = a.slice(1).join("=");
            '"' === r.charAt(0) && (r = r.slice(1, -1));
            try {
                t[a[0].replace(o, decodeURIComponent)] = r.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }
    function s() {
        return r(document.cookie);
    }
    function c(e, t, i) {
        document.cookie = a(e, t, o({
            path: "/"
        }, i));
    }
    i.__esModule = !0, i.encode = a, i.parse = r, i.getAll = s, i.get = function(e) {
        return s()[e];
    }, i.set = c, i.remove = function(e, t) {
        c(e, "", o(o({}, t), {
            expires: -1
        }));
    };
});
$3c0e653794cf487e$var$i($3c0e653794cf487e$var$R), $3c0e653794cf487e$var$R.encode, $3c0e653794cf487e$var$R.parse, $3c0e653794cf487e$var$R.getAll;
var $3c0e653794cf487e$var$U = $3c0e653794cf487e$var$R.get, $3c0e653794cf487e$var$L = $3c0e653794cf487e$var$R.set, $3c0e653794cf487e$var$D = $3c0e653794cf487e$var$R.remove;
const $3c0e653794cf487e$var$X = {
    get (e) {
        const t = $3c0e653794cf487e$var$U(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $3c0e653794cf487e$var$L(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $3c0e653794cf487e$var$D(e, i);
    }
}, $3c0e653794cf487e$var$N = {
    get (e) {
        const t = $3c0e653794cf487e$var$X.get(e);
        return t || $3c0e653794cf487e$var$X.get(`_legacy_${e}`);
    },
    save (e, t, i) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == i ? void 0 : i.daysUntilExpire) && (o.expires = i.daysUntilExpire), (null == i ? void 0 : i.cookieDomain) && (o.domain = i.cookieDomain), $3c0e653794cf487e$var$L(`_legacy_${e}`, JSON.stringify(t), o), $3c0e653794cf487e$var$X.save(e, t, i);
    },
    remove (e, t) {
        let i = {};
        (null == t ? void 0 : t.cookieDomain) && (i.domain = t.cookieDomain), $3c0e653794cf487e$var$D(e, i), $3c0e653794cf487e$var$X.remove(e, t), $3c0e653794cf487e$var$X.remove(`_legacy_${e}`, t);
    }
}, $3c0e653794cf487e$var$J = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
function $3c0e653794cf487e$var$F(e, t, i) {
    var o = void 0 === t ? null : t, n = function(e, t) {
        var i = atob(e);
        if (t) {
            for(var o = new Uint8Array(i.length), n = 0, a = i.length; n < a; ++n)o[n] = i.charCodeAt(n);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return i;
    }(e, void 0 !== i && i), a = n.indexOf("\n", 10) + 1, r = n.substring(a) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        r
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var $3c0e653794cf487e$var$H, $3c0e653794cf487e$var$Y, $3c0e653794cf487e$var$G, $3c0e653794cf487e$var$V, $3c0e653794cf487e$var$M = ($3c0e653794cf487e$var$H = "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", $3c0e653794cf487e$var$Y = null, $3c0e653794cf487e$var$G = !1, function(e) {
    return $3c0e653794cf487e$var$V = $3c0e653794cf487e$var$V || $3c0e653794cf487e$var$F($3c0e653794cf487e$var$H, $3c0e653794cf487e$var$Y, $3c0e653794cf487e$var$G), new Worker($3c0e653794cf487e$var$V, e);
});
const $3c0e653794cf487e$var$A = {};
class $3c0e653794cf487e$var$B {
    async add(e) {
        var t;
        const i = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        i.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...i
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const i = new Set(t.keys);
            return i.delete(e), i.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...i
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return `@@auth0spajs@@::${e}`;
    }
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
}
const $3c0e653794cf487e$var$$ = {
    memory: ()=>(new $3c0e653794cf487e$export$467265324939f47f).enclosedCache,
    localstorage: ()=>new $3c0e653794cf487e$export$40ef2cb682e70737
}, $3c0e653794cf487e$var$q = (e)=>$3c0e653794cf487e$var$$[e], $3c0e653794cf487e$var$Q = (t)=>{
    const { openUrl: i, onRedirect: o } = t, n = $3c0e653794cf487e$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, n), {
        openUrl: !1 === i || i ? i : o
    });
}, $3c0e653794cf487e$var$ee = new $3c0e653794cf487e$var$a;
class $3c0e653794cf487e$var$te {
    _url(e) {
        const t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || $3c0e653794cf487e$var$s)));
        return `${this.domainUrl}${e}&auth0Client=${t}`;
    }
    _authorizeUrl(e) {
        return this._url(`/authorize?${$3c0e653794cf487e$var$v(e)}`);
    }
    async _verifyIdToken(e, t, i) {
        const o = await this.nowProvider();
        var n;
        return $3c0e653794cf487e$var$E({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: i,
            leeway: this.options.leeway,
            max_age: (n = this.options.authorizationParams.max_age, "string" != typeof n ? n : parseInt(n, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, i) {
        const o = $3c0e653794cf487e$var$k($3c0e653794cf487e$var$y()), n = $3c0e653794cf487e$var$k($3c0e653794cf487e$var$y()), a = $3c0e653794cf487e$var$y(), r = ((e)=>{
            const t = new Uint8Array(e);
            return ((e)=>{
                const t = {
                    "+": "-",
                    "/": "_",
                    "=": ""
                };
                return e.replace(/[+/=]/g, (e)=>t[e]);
            })(window.btoa(String.fromCharCode(...Array.from(t))));
        })(await (async (e)=>{
            const t = $3c0e653794cf487e$var$w().subtle.digest({
                name: "SHA-256"
            }, (new TextEncoder).encode(e));
            return await t;
        })(a)), s = ((e, t, i, o, n, a, r, s)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), i), {
                scope: $3c0e653794cf487e$var$j(t, i.scope),
                response_type: "code",
                response_mode: s || "query",
                state: o,
                nonce: n,
                redirect_uri: r || e.authorizationParams.redirect_uri,
                code_challenge: a,
                code_challenge_method: "S256"
            }))(this.options, this.scope, e, o, n, r, e.redirect_uri || this.options.authorizationParams.redirect_uri || i, null == t ? void 0 : t.response_mode), c = this._authorizeUrl(s);
        return {
            nonce: n,
            code_verifier: a,
            scope: s.scope,
            audience: s.audience || "default",
            redirect_uri: s.redirect_uri,
            state: o,
            url: c
        };
    }
    async loginWithPopup(e, t) {
        var i;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, i = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", `left=${t},top=${i},width=400,height=600,resizable,scrollbars=yes,status=1`);
        })(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
        const o = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = o.url;
        const n = await ((e)=>new Promise((t, i)=>{
                let o;
                const n = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(n), clearTimeout(a), window.removeEventListener("message", o, !1), i(new $3c0e653794cf487e$export$f1f681f0fb26bb55(e.popup)));
                }, 1e3), a = setTimeout(()=>{
                    clearInterval(n), i(new $3c0e653794cf487e$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", o, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                o = function(r) {
                    if (r.data && "authorization_response" === r.data.type) {
                        if (clearTimeout(a), clearInterval(n), window.removeEventListener("message", o, !1), e.popup.close(), r.data.response.error) return i($3c0e653794cf487e$export$7d465be8efa67280.fromPayload(r.data.response));
                        t(r.data.response);
                    }
                }, window.addEventListener("message", o);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (o.state !== n.state) throw new $3c0e653794cf487e$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = (null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: o.audience,
            scope: o.scope,
            code_verifier: o.code_verifier,
            grant_type: "authorization_code",
            code: n.code,
            redirect_uri: o.redirect_uri
        }, {
            nonceIn: o.nonce,
            organization: a
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect(t = {}) {
        var i;
        const o = $3c0e653794cf487e$var$Q(t), { openUrl: n, fragment: a, appState: r } = o, s = $3c0e653794cf487e$var$e(o, [
            "openUrl",
            "fragment",
            "appState"
        ]), c = (null === (i = s.authorizationParams) || void 0 === i ? void 0 : i.organization) || this.options.authorizationParams.organization, d = await this._prepareAuthorizeUrl(s.authorizationParams || {}), { url: u } = d, l = $3c0e653794cf487e$var$e(d, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l), {
            appState: r
        }), c && {
            organization: c
        }));
        const h = a ? `${u}#${a}` : u;
        n ? await n(h) : window.location.assign(h);
    }
    async handleRedirectCallback(e = window.location.href) {
        const t = e.split("?").slice(1);
        if (0 === t.length) throw new Error("There are no query params available for parsing.");
        const { state: i, code: o, error: n, error_description: a } = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(t.join("")), r = this.transactionManager.get();
        if (!r) throw new $3c0e653794cf487e$export$7d465be8efa67280("missing_transaction", "Invalid state");
        if (this.transactionManager.remove(), n) throw new $3c0e653794cf487e$export$cf0c46b07324e9c5(n, a || n, i, r.appState);
        if (!r.code_verifier || r.state && r.state !== i) throw new $3c0e653794cf487e$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const s = r.organization, c = r.nonce, l = r.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: r.audience,
            scope: r.scope,
            code_verifier: r.code_verifier,
            grant_type: "authorization_code",
            code: o
        }, l ? {
            redirect_uri: l
        } : {}), {
            nonceIn: c,
            organization: s
        }), {
            appState: r.appState
        };
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently(e = {}) {
        var t;
        const i = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $3c0e653794cf487e$var$j(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope)
            })
        }), o = await ((e, t)=>{
            let i = $3c0e653794cf487e$var$A[t];
            return i || (i = e().finally(()=>{
                delete $3c0e653794cf487e$var$A[t], i = null;
            }), $3c0e653794cf487e$var$A[t] = i), i;
        })(()=>this._getTokenSilently(i), `${this.options.clientId}::${i.authorizationParams.audience}::${i.authorizationParams.scope}`);
        return e.detailedResponse ? o : null == o ? void 0 : o.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: i } = t, o = $3c0e653794cf487e$var$e(t, [
            "cacheMode"
        ]);
        if ("off" !== i) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId
            });
            if (e) return e;
        }
        if ("cache-only" !== i) {
            if (!await (async (e, t = 3)=>{
                for(let i = 0; i < t; i++)if (await e()) return !0;
                return !1;
            })(()=>$3c0e653794cf487e$var$ee.acquireLock("auth0.lock.getTokenSilently", 5e3), 10)) throw new $3c0e653794cf487e$export$66d311bf29d5c89c;
            try {
                if (window.addEventListener("pagehide", this._releaseLockOnPageHide), "off" !== i) {
                    const e = await this._getEntryFromCache({
                        scope: o.authorizationParams.scope,
                        audience: o.authorizationParams.audience || "default",
                        clientId: this.options.clientId
                    });
                    if (e) return e;
                }
                const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), { id_token: t, access_token: n, oauthTokenScope: a, expires_in: r } = e;
                return Object.assign(Object.assign({
                    id_token: t,
                    access_token: n
                }, a ? {
                    scope: a
                } : null), {
                    expires_in: r
                });
            } finally{
                await $3c0e653794cf487e$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
            }
        }
    }
    async getTokenWithPopup(e = {}, t = {}) {
        var i;
        const o = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $3c0e653794cf487e$var$j(this.scope, null === (i = e.authorizationParams) || void 0 === i ? void 0 : i.scope)
            })
        });
        t = Object.assign(Object.assign({}, $3c0e653794cf487e$var$r), t), await this.loginWithPopup(o, t);
        return (await this.cacheManager.get(new $3c0e653794cf487e$var$C({
            scope: o.authorizationParams.scope,
            audience: o.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }))).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const i = t.logoutParams || {}, { federated: o } = i, n = $3c0e653794cf487e$var$e(i, [
            "federated"
        ]), a = o ? "&federated" : "";
        return this._url(`/v2/logout?${$3c0e653794cf487e$var$v(Object.assign({
            clientId: t.clientId
        }, n))}`) + a;
    }
    async logout(t = {}) {
        const i = $3c0e653794cf487e$var$Q(t), { openUrl: o } = i, n = $3c0e653794cf487e$var$e(i, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@");
        const a = this._buildLogoutUrl(n);
        o ? await o(a) : !1 !== o && window.location.assign(a);
    }
    async _getTokenFromIFrame(e) {
        const t = Object.assign(Object.assign({}, e.authorizationParams), {
            prompt: "none"
        }), i = this.cookieStorage.get(this.orgHintCookieName);
        i && !t.organization && (t.organization = i);
        const { url: o, state: n, nonce: a, code_verifier: r, redirect_uri: s, scope: c, audience: u } = await this._prepareAuthorizeUrl(t, {
            response_mode: "web_message"
        }, window.location.origin);
        try {
            if (window.crossOriginIsolated) throw new $3c0e653794cf487e$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            const i = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, h = await ((e, t, i = 60)=>new Promise((o, n)=>{
                    const a = window.document.createElement("iframe");
                    a.setAttribute("width", "0"), a.setAttribute("height", "0"), a.style.display = "none";
                    const r = ()=>{
                        window.document.body.contains(a) && (window.document.body.removeChild(a), window.removeEventListener("message", s, !1));
                    };
                    let s;
                    const c = setTimeout(()=>{
                        n(new $3c0e653794cf487e$export$66d311bf29d5c89c), r();
                    }, 1e3 * i);
                    s = function(e) {
                        if (e.origin != t) return;
                        if (!e.data || "authorization_response" !== e.data.type) return;
                        const i = e.source;
                        i && i.close(), e.data.response.error ? n($3c0e653794cf487e$export$7d465be8efa67280.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(r, 2e3);
                    }, window.addEventListener("message", s, !1), window.document.body.appendChild(a), a.setAttribute("src", e);
                }))(o, this.domainUrl, i);
            if (n !== h.state) throw new $3c0e653794cf487e$export$7d465be8efa67280("state_mismatch", "Invalid state");
            const p = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: r,
                code: h.code,
                grant_type: "authorization_code",
                redirect_uri: s,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
            }), {
                nonceIn: a,
                organization: t.organization
            });
            return Object.assign(Object.assign({}, p), {
                scope: c,
                oauthTokenScope: p.scope,
                audience: u
            });
        } catch (e) {
            throw "login_required" === e.error && this.logout({
                openUrl: !1
            }), e;
        }
    }
    async _getTokenUsingRefreshToken(e) {
        const t = await this.cacheManager.get(new $3c0e653794cf487e$var$C({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }));
        if (!(t && t.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new $3c0e653794cf487e$export$ac1d2a00f8e0a046(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const i = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, o = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null;
        try {
            const n = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: i
            }), o && {
                timeout: o
            }));
            return Object.assign(Object.assign({}, n), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: n.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (t) {
            if ((t.message.indexOf("Missing Refresh Token") > -1 || t.message && t.message.indexOf("invalid refresh token") > -1) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw t;
        }
    }
    async _saveEntryInCache(t) {
        const { id_token: i, decodedToken: o } = t, n = $3c0e653794cf487e$var$e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: i,
            decodedToken: o
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(n);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = await this.cacheManager.getIdToken(new $3c0e653794cf487e$var$C({
            clientId: this.options.clientId,
            audience: e,
            scope: this.scope
        })), i = this.userCache.get("@@user@@");
        return t && t.id_token === (null == i ? void 0 : i.id_token) ? i : (this.userCache.set("@@user@@", t), t);
    }
    async _getEntryFromCache({ scope: e, audience: t, clientId: i }) {
        const o = await this.cacheManager.get(new $3c0e653794cf487e$var$C({
            scope: e,
            audience: t,
            clientId: i
        }), 60);
        if (o && o.access_token) {
            const { access_token: e, oauthTokenScope: t, expires_in: i } = o, n = await this._getIdTokenFromCache();
            return n && Object.assign(Object.assign({
                id_token: n.id_token,
                access_token: e
            }, t ? {
                scope: t
            } : null), {
                expires_in: i
            });
        }
    }
    async _requestToken(e, t) {
        const { nonceIn: i, organization: o } = t || {}, n = await $3c0e653794cf487e$var$T(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs
        }, e), this.worker), a = await this._verifyIdToken(n.id_token, i, o);
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, n), {
            decodedToken: a,
            scope: e.scope,
            audience: e.audience || "default"
        }), n.scope ? {
            oauthTokenScope: n.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(o || a.claims.org_id), Object.assign(Object.assign({}, n), {
            decodedToken: a
        });
    }
    constructor(e){
        let t, i;
        if (this.userCache = (new $3c0e653794cf487e$export$467265324939f47f).enclosedCache, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this._releaseLockOnPageHide = async ()=>{
            await $3c0e653794cf487e$var$ee.releaseLock("auth0.lock.getTokenSilently"), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!$3c0e653794cf487e$var$w()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $3c0e653794cf487e$var$w().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) i = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !$3c0e653794cf487e$var$q(t)) throw new Error(`Invalid cache location "${t}"`);
            i = $3c0e653794cf487e$var$q(t)();
        }
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? $3c0e653794cf487e$var$X : $3c0e653794cf487e$var$N, this.orgHintCookieName = `auth0.${this.options.clientId}.organization_hint`, this.isAuthenticatedCookieName = ((e)=>`auth0.${e}.is.authenticated`)(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const o = e.useCookiesForTransactions ? this.cookieStorage : $3c0e653794cf487e$var$J;
        var n;
        this.scope = $3c0e653794cf487e$var$j("openid", this.options.authorizationParams.scope, this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new $3c0e653794cf487e$var$Z(o, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $3c0e653794cf487e$var$c, this.cacheManager = new $3c0e653794cf487e$var$x(i, i.allKeys ? void 0 : new $3c0e653794cf487e$var$B(i, this.options.clientId), this.nowProvider), this.domainUrl = (n = this.options.domain, /^https?:\/\//.test(n) ? n : `https://${n}`), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : `https://${e}/` : `${t}/`)(this.options.issuer, this.domainUrl), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $3c0e653794cf487e$var$M);
    }
}
class $3c0e653794cf487e$export$1f44aaf2ec115b54 {
}
/**
 * The initial auth state.
 */ var $3c0e653794cf487e$var$initialAuthState = {
    isAuthenticated: false,
    isLoading: true
};
/**
 * @ignore
 */ var $3c0e653794cf487e$var$stub = function() {
    throw new Error("You forgot to wrap your component in <Auth0Provider>.");
};
/**
 * @ignore
 */ var $3c0e653794cf487e$export$1b5d8f0c33515521 = $3c0e653794cf487e$var$__assign($3c0e653794cf487e$var$__assign({}, $3c0e653794cf487e$var$initialAuthState), {
    buildAuthorizeUrl: $3c0e653794cf487e$var$stub,
    buildLogoutUrl: $3c0e653794cf487e$var$stub,
    getAccessTokenSilently: $3c0e653794cf487e$var$stub,
    getAccessTokenWithPopup: $3c0e653794cf487e$var$stub,
    getIdTokenClaims: $3c0e653794cf487e$var$stub,
    loginWithRedirect: $3c0e653794cf487e$var$stub,
    loginWithPopup: $3c0e653794cf487e$var$stub,
    logout: $3c0e653794cf487e$var$stub,
    handleRedirectCallback: $3c0e653794cf487e$var$stub
});
/**
 * The Auth0 Context
 */ var $3c0e653794cf487e$export$419e9d660c2a6030 = (0, $4YNlq.createContext)($3c0e653794cf487e$export$1b5d8f0c33515521);
/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */ var $3c0e653794cf487e$export$bdc0f363b754b88f = /** @class */ function(_super) {
    $3c0e653794cf487e$var$__extends(OAuthError, _super);
    function OAuthError(error, error_description) {
        var _this = _super.call(this, error_description || error) || this;
        _this.error = error;
        _this.error_description = error_description;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, OAuthError.prototype);
        return _this;
    }
    return OAuthError;
}(Error);
var $3c0e653794cf487e$var$CODE_RE = /[?&]code=[^&]+/;
var $3c0e653794cf487e$var$STATE_RE = /[?&]state=[^&]+/;
var $3c0e653794cf487e$var$ERROR_RE = /[?&]error=[^&]+/;
var $3c0e653794cf487e$var$hasAuthParams = function(searchParams) {
    if (searchParams === void 0) searchParams = window.location.search;
    return ($3c0e653794cf487e$var$CODE_RE.test(searchParams) || $3c0e653794cf487e$var$ERROR_RE.test(searchParams)) && $3c0e653794cf487e$var$STATE_RE.test(searchParams);
};
var $3c0e653794cf487e$var$normalizeErrorFn = function(fallbackMessage) {
    return function(error) {
        if (error instanceof Error) return error;
        // try to check errors of the following form: {error: string; error_description?: string}
        if (error !== null && typeof error === "object" && "error" in error && typeof error.error === "string") {
            if ("error_description" in error && typeof error.error_description === "string") return new $3c0e653794cf487e$export$bdc0f363b754b88f(error.error, error.error_description);
            return new $3c0e653794cf487e$export$bdc0f363b754b88f(error.error);
        }
        return new Error(fallbackMessage);
    };
};
var $3c0e653794cf487e$var$loginError = $3c0e653794cf487e$var$normalizeErrorFn("Login failed");
var $3c0e653794cf487e$var$tokenError = $3c0e653794cf487e$var$normalizeErrorFn("Get access token failed");
/**
 * @ignore
 * Helper function to map the v1 `redirectUri` option to the v2 `authorizationParams.redirect_uri`
 * and log a warning.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var $3c0e653794cf487e$var$deprecateRedirectUri = function(options) {
    var _a;
    if (options === null || options === void 0 ? void 0 : options.redirectUri) {
        console.warn("Using `redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `redirectUri` will be no longer supported in a future version");
        options.authorizationParams = options.authorizationParams || {};
        options.authorizationParams.redirect_uri = options.redirectUri;
        delete options.redirectUri;
    }
    if ((_a = options === null || options === void 0 ? void 0 : options.authorizationParams) === null || _a === void 0 ? void 0 : _a.redirectUri) {
        console.warn("Using `authorizationParams.redirectUri` has been deprecated, please use `authorizationParams.redirect_uri` instead as `authorizationParams.redirectUri` will be removed in a future version");
        options.authorizationParams.redirect_uri = options.authorizationParams.redirectUri;
        delete options.authorizationParams.redirectUri;
    }
};
/**
 * Handles how that state changes in the `useAuth0` hook.
 */ var $3c0e653794cf487e$var$reducer = function(state, action) {
    switch(action.type){
        case "LOGIN_POPUP_STARTED":
            return $3c0e653794cf487e$var$__assign($3c0e653794cf487e$var$__assign({}, state), {
                isLoading: true
            });
        case "LOGIN_POPUP_COMPLETE":
        case "INITIALISED":
            return $3c0e653794cf487e$var$__assign($3c0e653794cf487e$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user,
                isLoading: false,
                error: undefined
            });
        case "HANDLE_REDIRECT_COMPLETE":
        case "GET_ACCESS_TOKEN_COMPLETE":
            if (state.user === action.user) return state;
            return $3c0e653794cf487e$var$__assign($3c0e653794cf487e$var$__assign({}, state), {
                isAuthenticated: !!action.user,
                user: action.user
            });
        case "LOGOUT":
            return $3c0e653794cf487e$var$__assign($3c0e653794cf487e$var$__assign({}, state), {
                isAuthenticated: false,
                user: undefined
            });
        case "ERROR":
            return $3c0e653794cf487e$var$__assign($3c0e653794cf487e$var$__assign({}, state), {
                isLoading: false,
                error: action.error
            });
    }
};
/**
 * @ignore
 */ var $3c0e653794cf487e$var$toAuth0ClientOptions = function(opts) {
    $3c0e653794cf487e$var$deprecateRedirectUri(opts);
    return $3c0e653794cf487e$var$__assign($3c0e653794cf487e$var$__assign({}, opts), {
        auth0Client: {
            name: "auth0-react",
            version: "2.2.4"
        }
    });
};
/**
 * @ignore
 */ var $3c0e653794cf487e$var$defaultOnRedirectCallback = function(appState) {
    window.history.replaceState({}, document.title, (appState === null || appState === void 0 ? void 0 : appState.returnTo) || window.location.pathname);
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   authorizationParams={{ redirect_uri: window.location.origin }}}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 */ var $3c0e653794cf487e$export$6aefaad9cc4faf3c = function(opts) {
    var children = opts.children, skipRedirectCallback = opts.skipRedirectCallback, _a = opts.onRedirectCallback, onRedirectCallback = _a === void 0 ? $3c0e653794cf487e$var$defaultOnRedirectCallback : _a, _b = opts.context, context = _b === void 0 ? $3c0e653794cf487e$export$419e9d660c2a6030 : _b, clientOpts = $3c0e653794cf487e$var$__rest(opts, [
        "children",
        "skipRedirectCallback",
        "onRedirectCallback",
        "context"
    ]);
    var client = (0, $4YNlq.useState)(function() {
        return new $3c0e653794cf487e$var$te($3c0e653794cf487e$var$toAuth0ClientOptions(clientOpts));
    })[0];
    var _c = (0, $4YNlq.useReducer)($3c0e653794cf487e$var$reducer, $3c0e653794cf487e$var$initialAuthState), state = _c[0], dispatch = _c[1];
    var didInitialise = (0, $4YNlq.useRef)(false);
    (0, $4YNlq.useEffect)(function() {
        if (didInitialise.current) return;
        didInitialise.current = true;
        (function() {
            return $3c0e653794cf487e$var$__awaiter(void 0, void 0, void 0, function() {
                var user, appState, error_1;
                return $3c0e653794cf487e$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            _a.trys.push([
                                0,
                                7,
                                ,
                                8
                            ]);
                            user = void 0;
                            if (!($3c0e653794cf487e$var$hasAuthParams() && !skipRedirectCallback)) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                client.handleRedirectCallback()
                            ];
                        case 1:
                            appState = _a.sent().appState;
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 2:
                            user = _a.sent();
                            onRedirectCallback(appState, user);
                            return [
                                3 /*break*/ ,
                                6
                            ];
                        case 3:
                            return [
                                4 /*yield*/ ,
                                client.checkSession()
                            ];
                        case 4:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                client.getUser()
                            ];
                        case 5:
                            user = _a.sent();
                            _a.label = 6;
                        case 6:
                            dispatch({
                                type: "INITIALISED",
                                user: user
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            error_1 = _a.sent();
                            dispatch({
                                type: "ERROR",
                                error: $3c0e653794cf487e$var$loginError(error_1)
                            });
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        })();
    }, [
        client,
        onRedirectCallback,
        skipRedirectCallback
    ]);
    var loginWithRedirect = (0, $4YNlq.useCallback)(function(opts) {
        $3c0e653794cf487e$var$deprecateRedirectUri(opts);
        return client.loginWithRedirect(opts);
    }, [
        client
    ]);
    var loginWithPopup = (0, $4YNlq.useCallback)(function(options, config) {
        return $3c0e653794cf487e$var$__awaiter(void 0, void 0, void 0, function() {
            var error_2, user;
            return $3c0e653794cf487e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dispatch({
                            type: "LOGIN_POPUP_STARTED"
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.loginWithPopup(options, config)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        error_2 = _a.sent();
                        dispatch({
                            type: "ERROR",
                            error: $3c0e653794cf487e$var$loginError(error_2)
                        });
                        return [
                            2 /*return*/ 
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 5:
                        user = _a.sent();
                        dispatch({
                            type: "LOGIN_POPUP_COMPLETE",
                            user: user
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var logout = (0, $4YNlq.useCallback)(function(opts) {
        if (opts === void 0) opts = {};
        return $3c0e653794cf487e$var$__awaiter(void 0, void 0, void 0, function() {
            return $3c0e653794cf487e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            client.logout(opts)
                        ];
                    case 1:
                        _a.sent();
                        if (opts.openUrl || opts.openUrl === false) dispatch({
                            type: "LOGOUT"
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenSilently = (0, $4YNlq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    function(opts) {
        return $3c0e653794cf487e$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_3, _a;
            var _b;
            return $3c0e653794cf487e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenSilently(opts)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_3 = _c.sent();
                        throw $3c0e653794cf487e$var$tokenError(error_3);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "GET_ACCESS_TOKEN_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getAccessTokenWithPopup = (0, $4YNlq.useCallback)(function(opts, config) {
        return $3c0e653794cf487e$var$__awaiter(void 0, void 0, void 0, function() {
            var token, error_4, _a;
            var _b;
            return $3c0e653794cf487e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.getTokenWithPopup(opts, config)
                        ];
                    case 1:
                        token = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        error_4 = _c.sent();
                        throw $3c0e653794cf487e$var$tokenError(error_4);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "GET_ACCESS_TOKEN_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ ,
                            token
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var getIdTokenClaims = (0, $4YNlq.useCallback)(function() {
        return client.getIdTokenClaims();
    }, [
        client
    ]);
    var handleRedirectCallback = (0, $4YNlq.useCallback)(function(url) {
        return $3c0e653794cf487e$var$__awaiter(void 0, void 0, void 0, function() {
            var error_5, _a;
            var _b;
            return $3c0e653794cf487e$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _c.trys.push([
                            0,
                            2,
                            3,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            client.handleRedirectCallback(url)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _c.sent()
                        ];
                    case 2:
                        error_5 = _c.sent();
                        throw $3c0e653794cf487e$var$tokenError(error_5);
                    case 3:
                        _a = dispatch;
                        _b = {
                            type: "HANDLE_REDIRECT_COMPLETE"
                        };
                        return [
                            4 /*yield*/ ,
                            client.getUser()
                        ];
                    case 4:
                        _a.apply(void 0, [
                            (_b.user = _c.sent(), _b)
                        ]);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    }, [
        client
    ]);
    var contextValue = (0, $4YNlq.useMemo)(function() {
        return $3c0e653794cf487e$var$__assign($3c0e653794cf487e$var$__assign({}, state), {
            getAccessTokenSilently: getAccessTokenSilently,
            getAccessTokenWithPopup: getAccessTokenWithPopup,
            getIdTokenClaims: getIdTokenClaims,
            loginWithRedirect: loginWithRedirect,
            loginWithPopup: loginWithPopup,
            logout: logout,
            handleRedirectCallback: handleRedirectCallback
        });
    }, [
        state,
        getAccessTokenSilently,
        getAccessTokenWithPopup,
        getIdTokenClaims,
        loginWithRedirect,
        loginWithPopup,
        logout,
        handleRedirectCallback
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement(context.Provider, {
        value: contextValue
    }, children);
};
/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */ var $3c0e653794cf487e$export$f2b63d3ca66bb884 = function(context) {
    if (context === void 0) context = $3c0e653794cf487e$export$419e9d660c2a6030;
    return (0, $4YNlq.useContext)(context);
};
/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */ var $3c0e653794cf487e$export$bf0b363fae22b33f = function(Component, context) {
    if (context === void 0) context = $3c0e653794cf487e$export$419e9d660c2a6030;
    return function WithAuth(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement(context.Consumer, null, function(auth) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement(Component, $3c0e653794cf487e$var$__assign({}, props, {
                auth0: auth
            }));
        });
    };
};
/**
 * @ignore
 */ var $3c0e653794cf487e$var$defaultOnRedirecting = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).Fragment, null);
};
/**
* @ignore
*/ var $3c0e653794cf487e$var$defaultOnBeforeAuthentication = function() {
    return $3c0e653794cf487e$var$__awaiter(void 0, void 0, void 0, function() {
        return $3c0e653794cf487e$var$__generator(this, function(_a) {
            return [
                2 /*return*/ 
            ];
        });
    });
};
/**
 * @ignore
 */ var $3c0e653794cf487e$var$defaultReturnTo = function() {
    return "".concat(window.location.pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page; after login they will be returned to the page they were redirected from.
 */ var $3c0e653794cf487e$export$2cfd0b285ff12c70 = function(Component, options) {
    if (options === void 0) options = {};
    return function WithAuthenticationRequired(props) {
        var _this = this;
        var _a = options.returnTo, returnTo = _a === void 0 ? $3c0e653794cf487e$var$defaultReturnTo : _a, _b = options.onRedirecting, onRedirecting = _b === void 0 ? $3c0e653794cf487e$var$defaultOnRedirecting : _b, _c = options.onBeforeAuthentication, onBeforeAuthentication = _c === void 0 ? $3c0e653794cf487e$var$defaultOnBeforeAuthentication : _c, loginOptions = options.loginOptions, _d = options.context, context = _d === void 0 ? $3c0e653794cf487e$export$419e9d660c2a6030 : _d;
        var _e = $3c0e653794cf487e$export$f2b63d3ca66bb884(context), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, loginWithRedirect = _e.loginWithRedirect;
        (0, $4YNlq.useEffect)(function() {
            if (isLoading || isAuthenticated) return;
            var opts = $3c0e653794cf487e$var$__assign($3c0e653794cf487e$var$__assign({}, loginOptions), {
                appState: $3c0e653794cf487e$var$__assign($3c0e653794cf487e$var$__assign({}, loginOptions && loginOptions.appState), {
                    returnTo: typeof returnTo === "function" ? returnTo() : returnTo
                })
            });
            (function() {
                return $3c0e653794cf487e$var$__awaiter(_this, void 0, void 0, function() {
                    return $3c0e653794cf487e$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    onBeforeAuthentication()
                                ];
                            case 1:
                                _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    loginWithRedirect(opts)
                                ];
                            case 2:
                                _a.sent();
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            })();
        }, [
            isLoading,
            isAuthenticated,
            loginWithRedirect,
            onBeforeAuthentication,
            loginOptions,
            returnTo
        ]);
        return isAuthenticated ? (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement(Component, $3c0e653794cf487e$var$__assign({}, props)) : onRedirecting();
    };
};



var $hxzCU = parcelRequire("hxzCU");
var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");
parcelRequire("4YNlq");


var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");



var $4YNlq = parcelRequire("4YNlq");
const $dc5157e973b907f2$var$ThemeContext = /*#__PURE__*/ $4YNlq.createContext(null);
var $dc5157e973b907f2$export$2e2bcd8739ae039 = $dc5157e973b907f2$var$ThemeContext;



var $4YNlq = parcelRequire("4YNlq");

function $e7b21b3782833eea$export$2e2bcd8739ae039() {
    const theme = $4YNlq.useContext((0, $dc5157e973b907f2$export$2e2bcd8739ae039));
    return theme;
}


const $b164011c1f2194e4$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $b164011c1f2194e4$export$2e2bcd8739ae039 = $b164011c1f2194e4$var$hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";



var $izf4p = parcelRequire("izf4p");
function $7cdfbad9a7664cde$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === "function") {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $lzDk3.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $7cdfbad9a7664cde$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $e7b21b3782833eea$export$2e2bcd8739ae039)();
    const theme = $4YNlq.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $7cdfbad9a7664cde$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $b164011c1f2194e4$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $dc5157e973b907f2$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $7cdfbad9a7664cde$export$2e2bcd8739ae039 = $7cdfbad9a7664cde$var$ThemeProvider;



parcelRequire("8zt0d");
var $g89D5 = parcelRequire("g89D5");

var $7DeAN = parcelRequire("7DeAN");

var $izf4p = parcelRequire("izf4p");
"use client";
const $7bae1718ddec420f$var$EMPTY_THEME = {};
function $7bae1718ddec420f$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $4YNlq.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === "function") {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $lzDk3.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $lzDk3.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $lzDk3.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $7bae1718ddec420f$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $7DeAN.default)($7bae1718ddec420f$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $e7b21b3782833eea$export$2e2bcd8739ae039)() || $7bae1718ddec420f$var$EMPTY_THEME;
    const engineTheme = $7bae1718ddec420f$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $7bae1718ddec420f$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $7cdfbad9a7664cde$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $g89D5.T).Provider, {
            value: engineTheme,
            children: children
        })
    });
}
var $7bae1718ddec420f$export$2e2bcd8739ae039 = $7bae1718ddec420f$var$ThemeProvider;



var $dRtc1 = parcelRequire("dRtc1");

var $izf4p = parcelRequire("izf4p");
"use client";
const $d54b578cc0fa217b$var$_excluded = [
    "theme"
];
function $d54b578cc0fa217b$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $g54n0.default)(_ref, $d54b578cc0fa217b$var$_excluded);
    const scopedTheme = themeInput[0, $dRtc1.default];
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $7bae1718ddec420f$export$2e2bcd8739ae039), (0, $lzDk3.default)({}, props, {
        themeId: scopedTheme ? (0, $dRtc1.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}



var $lzDk3 = parcelRequire("lzDk3");
var $64d8998661a46a92$exports = {};
!function(t, e) {
    $64d8998661a46a92$exports = e();
}($64d8998661a46a92$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $42ba427175bbb309$exports = {};
!function(e, t) {
    $42ba427175bbb309$exports = t();
}($42ba427175bbb309$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});


var $b8883414ff998237$exports = {};
!function(e, t) {
    $b8883414ff998237$exports = t();
}($b8883414ff998237$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var a = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, f = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], h = function(e) {
        var t = o[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, u = function(e, t) {
        var n, r = o.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, d = {
        A: [
            i,
            function(e) {
                this.afternoon = u(e, !1);
            }
        ],
        a: [
            i,
            function(e) {
                this.afternoon = u(e, !0);
            }
        ],
        S: [
            /\d/,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            n,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            r,
            a("seconds")
        ],
        ss: [
            r,
            a("seconds")
        ],
        m: [
            r,
            a("minutes")
        ],
        mm: [
            r,
            a("minutes")
        ],
        H: [
            r,
            a("hours")
        ],
        h: [
            r,
            a("hours")
        ],
        HH: [
            r,
            a("hours")
        ],
        hh: [
            r,
            a("hours")
        ],
        D: [
            r,
            a("day")
        ],
        DD: [
            n,
            a("day")
        ],
        Do: [
            i,
            function(e) {
                var t = o.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        M: [
            r,
            a("month")
        ],
        MM: [
            n,
            a("month")
        ],
        MMM: [
            i,
            function(e) {
                var t = h("months"), n = (h("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            i,
            function(e) {
                var t = h("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            a("year")
        ],
        YY: [
            n,
            function(e) {
                this.year = s(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            a("year")
        ],
        Z: f,
        ZZ: f
    };
    function c(n) {
        var r, i;
        r = n, i = o && o.formats;
        for(var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = s.length, f = 0; f < a; f += 1){
            var h = s[f], u = d[h], c = u && u[0], l = u && u[1];
            s[f] = l ? {
                regex: c,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = s[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var o = i.regex, f = i.parser, h = e.slice(r), u = o.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, s = e.args;
            this.$u = r;
            var a = s[1];
            if ("string" == typeof a) {
                var f = !0 === s[2], h = !0 === s[3], u = f || h, d = s[2];
                h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function(e, t, n) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var r = c(t)(e), i = r.year, o = r.month, s = r.day, a = r.hours, f = r.minutes, h = r.seconds, u = r.milliseconds, d = r.zone, l = new Date, m = s || (i || o ? 1 : l.getDate()), M = i || l.getFullYear(), Y = 0;
                        i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
                        var p = a || 0, v = f || 0, D = h || 0, g = u || 0;
                        return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), o = {};
            } else if (a instanceof Array) for(var l = a.length, m = 1; m <= l; m += 1){
                s[1] = a[m - 1];
                var M = n.apply(this, s);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === l && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $1e0a209978779d8a$exports = {};
!function(e, t) {
    $1e0a209978779d8a$exports = t();
}($1e0a209978779d8a$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


var $d1b32576548b316c$exports = {};
!function(e, i) {
    $d1b32576548b316c$exports = i();
}($d1b32576548b316c$exports, function() {
    "use strict";
    return function(e, i, t) {
        i.prototype.isBetween = function(e, i, s, f) {
            var n = t(e), o = t(i), r = "(" === (f = f || "()")[0], u = ")" === f[1];
            return (r ? this.isAfter(n, s) : !this.isBefore(n, s)) && (u ? this.isBefore(o, s) : !this.isAfter(o, s)) || (r ? this.isBefore(n, s) : !this.isAfter(n, s)) && (u ? this.isAfter(o, s) : !this.isBefore(o, s));
        };
    };
});


const $0b4d48933acfd04c$export$be61413ca3629f52 = (message)=>{
    let alreadyWarned = false;
    var deprecatedProps;
    return ()=>{};
};
const $0b4d48933acfd04c$export$baf331755d84b871 = (message, gravity = "warning")=>{
    let alreadyWarned = false;
    const cleanMessage = Array.isArray(message) ? message.join("\n") : message;
    return ()=>{
        if (!alreadyWarned) {
            alreadyWarned = true;
            if (gravity === "error") console.error(cleanMessage);
            else console.warn(cleanMessage);
        }
    };
};


(0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($b8883414ff998237$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($1e0a209978779d8a$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($d1b32576548b316c$exports))));
const $45a0d1f63ab1e3be$var$localeNotFoundWarning = (0, $0b4d48933acfd04c$export$baf331755d84b871)([
    "Your locale has not been found.",
    "Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale",
    "Or you forget to import the locale from 'dayjs/locale/{localeUsed}'",
    "fallback on English locale"
]);
const $45a0d1f63ab1e3be$var$formatTokenMap = {
    // Year
    YY: "year",
    YYYY: {
        sectionType: "year",
        contentType: "digit",
        maxLength: 4
    },
    // Month
    M: {
        sectionType: "month",
        contentType: "digit",
        maxLength: 2
    },
    MM: "month",
    MMM: {
        sectionType: "month",
        contentType: "letter"
    },
    MMMM: {
        sectionType: "month",
        contentType: "letter"
    },
    // Day of the month
    D: {
        sectionType: "day",
        contentType: "digit",
        maxLength: 2
    },
    DD: "day",
    Do: {
        sectionType: "day",
        contentType: "digit-with-letter"
    },
    // Day of the week
    d: {
        sectionType: "weekDay",
        contentType: "digit",
        maxLength: 2
    },
    dd: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    ddd: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    dddd: {
        sectionType: "weekDay",
        contentType: "letter"
    },
    // Meridiem
    A: "meridiem",
    a: "meridiem",
    // Hours
    H: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    HH: "hours",
    h: {
        sectionType: "hours",
        contentType: "digit",
        maxLength: 2
    },
    hh: "hours",
    // Minutes
    m: {
        sectionType: "minutes",
        contentType: "digit",
        maxLength: 2
    },
    mm: "minutes",
    // Seconds
    s: {
        sectionType: "seconds",
        contentType: "digit",
        maxLength: 2
    },
    ss: "seconds"
};
const $45a0d1f63ab1e3be$var$defaultFormats = {
    year: "YYYY",
    month: "MMMM",
    monthShort: "MMM",
    dayOfMonth: "D",
    weekday: "dddd",
    weekdayShort: "dd",
    hours24h: "HH",
    hours12h: "hh",
    meridiem: "A",
    minutes: "mm",
    seconds: "ss",
    fullDate: "ll",
    fullDateWithWeekday: "dddd, LL",
    keyboardDate: "L",
    shortDate: "MMM D",
    normalDate: "D MMMM",
    normalDateWithWeekday: "ddd, MMM D",
    monthAndYear: "MMMM YYYY",
    monthAndDate: "MMMM D",
    fullTime: "LT",
    fullTime12h: "hh:mm A",
    fullTime24h: "HH:mm",
    fullDateTime: "lll",
    fullDateTime12h: "ll hh:mm A",
    fullDateTime24h: "ll HH:mm",
    keyboardDateTime: "L LT",
    keyboardDateTime12h: "L hh:mm A",
    keyboardDateTime24h: "L HH:mm"
};
const $45a0d1f63ab1e3be$var$MISSING_UTC_PLUGIN = [
    "Missing UTC plugin",
    "To be able to use UTC or timezones, you have to enable the `utc` plugin",
    "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc"
].join("\n");
const $45a0d1f63ab1e3be$var$MISSING_TIMEZONE_PLUGIN = [
    "Missing timezone plugin",
    "To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin",
    "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone"
].join("\n");
const $45a0d1f63ab1e3be$var$withLocale = (dayjs, locale)=>!locale ? dayjs : (...args)=>dayjs(...args).locale(locale);
class $45a0d1f63ab1e3be$export$33545c6a80bae043 {
    constructor({ locale: _locale, formats: formats, instance: instance } = {}){
        var _this$rawDayJsInstanc;
        this.isMUIAdapter = true;
        this.isTimezoneCompatible = true;
        this.lib = "dayjs";
        this.rawDayJsInstance = void 0;
        this.dayjs = void 0;
        this.locale = void 0;
        this.formats = void 0;
        this.escapedCharacters = {
            start: "[",
            end: "]"
        };
        this.formatTokenMap = $45a0d1f63ab1e3be$var$formatTokenMap;
        this.setLocaleToValue = (value)=>{
            const expectedLocale = this.getCurrentLocaleCode();
            if (expectedLocale === value.locale()) return value;
            return value.locale(expectedLocale);
        };
        this.hasUTCPlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).utc !== "undefined";
        this.hasTimezonePlugin = ()=>typeof (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).tz !== "undefined";
        this.isSame = (value, comparing, comparisonTemplate)=>{
            const comparingInValueTimezone = this.setTimezone(comparing, this.getTimezone(value));
            return value.format(comparisonTemplate) === comparingInValueTimezone.format(comparisonTemplate);
        };
        /**
     * Replaces "default" by undefined and "system" by the system timezone before passing it to `dayjs`.
     */ this.cleanTimezone = (timezone)=>{
            switch(timezone){
                case "default":
                    return undefined;
                case "system":
                    return (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).tz.guess();
                default:
                    return timezone;
            }
        };
        this.createSystemDate = (value)=>{
            // TODO v7: Stop using `this.rawDayJsInstance` (drop the `instance` param on the adapters)
            /* istanbul ignore next */ if (this.rawDayJsInstance) return this.rawDayJsInstance(value);
            if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
                const timezone = (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).tz.guess();
                // We can't change the system timezone in the tests
                /* istanbul ignore next */ if (timezone !== "UTC") return (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).tz(value, timezone);
                return (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports)))(value);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports)))(value);
        };
        this.createUTCDate = (value)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($45a0d1f63ab1e3be$var$MISSING_UTC_PLUGIN);
            return (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).utc(value);
        };
        this.createTZDate = (value, timezone)=>{
            /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($45a0d1f63ab1e3be$var$MISSING_UTC_PLUGIN);
            /* istanbul ignore next */ if (!this.hasTimezonePlugin()) throw new Error($45a0d1f63ab1e3be$var$MISSING_TIMEZONE_PLUGIN);
            const keepLocalTime = value !== undefined && !value.endsWith("Z");
            return (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports)))(value).tz(this.cleanTimezone(timezone), keepLocalTime);
        };
        this.getLocaleFormats = ()=>{
            const locales = (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).Ls;
            const locale = this.locale || "en";
            let localeObject = locales[locale];
            if (localeObject === undefined) {
                $45a0d1f63ab1e3be$var$localeNotFoundWarning();
                localeObject = locales.en;
            }
            return localeObject.formats;
        };
        /**
     * If the new day does not have the same offset as the old one (when switching to summer day time for example),
     * Then dayjs will not automatically adjust the offset (moment does).
     * We have to parse again the value to make sure the `fixOffset` method is applied.
     * See https://github.com/iamkun/dayjs/blob/b3624de619d6e734cd0ffdbbd3502185041c1b60/src/plugin/timezone/index.js#L72
     */ this.adjustOffset = (value)=>{
            if (!this.hasTimezonePlugin()) return value;
            const timezone = this.getTimezone(value);
            if (timezone !== "UTC") {
                var _fixedValue$$offset, _value$$offset;
                const fixedValue = value.tz(this.cleanTimezone(timezone), true);
                // @ts-ignore
                if (((_fixedValue$$offset = fixedValue.$offset) != null ? _fixedValue$$offset : 0) === ((_value$$offset = value.$offset) != null ? _value$$offset : 0)) return value;
                return fixedValue;
            }
            return value;
        };
        this.date = (value)=>{
            if (value === null) return null;
            return this.dayjs(value);
        };
        this.dateWithTimezone = (value, timezone)=>{
            if (value === null) return null;
            let parsedValue;
            if (timezone === "UTC") parsedValue = this.createUTCDate(value);
            else if (timezone === "system" || timezone === "default" && !this.hasTimezonePlugin()) parsedValue = this.createSystemDate(value);
            else parsedValue = this.createTZDate(value, timezone);
            if (this.locale === undefined) return parsedValue;
            return parsedValue.locale(this.locale);
        };
        this.getTimezone = (value)=>{
            if (this.hasTimezonePlugin()) {
                var _value$$x;
                // @ts-ignore
                const zone = (_value$$x = value.$x) == null ? void 0 : _value$$x.$timezone;
                if (zone) return zone;
            }
            if (this.hasUTCPlugin() && value.isUTC()) return "UTC";
            return "system";
        };
        this.setTimezone = (value, timezone)=>{
            if (this.getTimezone(value) === timezone) return value;
            if (timezone === "UTC") {
                /* istanbul ignore next */ if (!this.hasUTCPlugin()) throw new Error($45a0d1f63ab1e3be$var$MISSING_UTC_PLUGIN);
                return value.utc();
            }
            // We know that we have the UTC plugin.
            // Otherwise, the value timezone would always equal "system".
            // And it would be caught by the first "if" of this method.
            if (timezone === "system") return value.local();
            if (!this.hasTimezonePlugin()) {
                if (timezone === "default") return value;
                /* istanbul ignore next */ throw new Error($45a0d1f63ab1e3be$var$MISSING_TIMEZONE_PLUGIN);
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).tz(value, this.cleanTimezone(timezone));
        };
        this.toJsDate = (value)=>{
            return value.toDate();
        };
        this.parseISO = (isoString)=>{
            return this.dayjs(isoString);
        };
        this.toISO = (value)=>{
            return value.toISOString();
        };
        this.parse = (value, format)=>{
            if (value === "") return null;
            return this.dayjs(value, format, this.locale, true);
        };
        this.getCurrentLocaleCode = ()=>{
            return this.locale || "en";
        };
        this.is12HourCycleInCurrentLocale = ()=>{
            /* istanbul ignore next */ return /A|a/.test(this.getLocaleFormats().LT || "");
        };
        this.expandFormat = (format)=>{
            const localeFormats = this.getLocaleFormats();
            // @see https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js
            const t = (formatBis)=>formatBis.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (_, a, b)=>a || b.slice(1));
            return format.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (_, a, b)=>{
                const B = b && b.toUpperCase();
                return a || localeFormats[b] || t(localeFormats[B]);
            });
        };
        this.getFormatHelperText = (format)=>{
            return this.expandFormat(format).replace(/a/gi, "(a|p)m").toLocaleLowerCase();
        };
        this.isNull = (value)=>{
            return value === null;
        };
        this.isValid = (value)=>{
            return this.dayjs(value).isValid();
        };
        this.format = (value, formatKey)=>{
            return this.formatByString(value, this.formats[formatKey]);
        };
        this.formatByString = (value, formatString)=>{
            return this.dayjs(value).format(formatString);
        };
        this.formatNumber = (numberToFormat)=>{
            return numberToFormat;
        };
        this.getDiff = (value, comparing, unit)=>{
            return value.diff(comparing, unit);
        };
        this.isEqual = (value, comparing)=>{
            if (value === null && comparing === null) return true;
            return this.dayjs(value).toDate().getTime() === this.dayjs(comparing).toDate().getTime();
        };
        this.isSameYear = (value, comparing)=>{
            return this.isSame(value, comparing, "YYYY");
        };
        this.isSameMonth = (value, comparing)=>{
            return this.isSame(value, comparing, "YYYY-MM");
        };
        this.isSameDay = (value, comparing)=>{
            return this.isSame(value, comparing, "YYYY-MM-DD");
        };
        this.isSameHour = (value, comparing)=>{
            return value.isSame(comparing, "hour");
        };
        this.isAfter = (value, comparing)=>{
            return value > comparing;
        };
        this.isAfterYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, "year");
            return !this.isSameYear(value, comparing) && value.utc() > comparing.utc();
        };
        this.isAfterDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isAfter(comparing, "day");
            return !this.isSameDay(value, comparing) && value.utc() > comparing.utc();
        };
        this.isBefore = (value, comparing)=>{
            return value < comparing;
        };
        this.isBeforeYear = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, "year");
            return !this.isSameYear(value, comparing) && value.utc() < comparing.utc();
        };
        this.isBeforeDay = (value, comparing)=>{
            if (!this.hasUTCPlugin()) return value.isBefore(comparing, "day");
            return !this.isSameDay(value, comparing) && value.utc() < comparing.utc();
        };
        this.isWithinRange = (value, [start, end])=>{
            return value >= start && value <= end;
        };
        this.startOfYear = (value)=>{
            return this.adjustOffset(value.startOf("year"));
        };
        this.startOfMonth = (value)=>{
            return this.adjustOffset(value.startOf("month"));
        };
        this.startOfWeek = (value)=>{
            return this.adjustOffset(value.startOf("week"));
        };
        this.startOfDay = (value)=>{
            return this.adjustOffset(value.startOf("day"));
        };
        this.endOfYear = (value)=>{
            return this.adjustOffset(value.endOf("year"));
        };
        this.endOfMonth = (value)=>{
            return this.adjustOffset(value.endOf("month"));
        };
        this.endOfWeek = (value)=>{
            return this.adjustOffset(value.endOf("week"));
        };
        this.endOfDay = (value)=>{
            return this.adjustOffset(value.endOf("day"));
        };
        this.addYears = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "year") : value.add(amount, "year"));
        };
        this.addMonths = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "month") : value.add(amount, "month"));
        };
        this.addWeeks = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "week") : value.add(amount, "week"));
        };
        this.addDays = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "day") : value.add(amount, "day"));
        };
        this.addHours = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "hour") : value.add(amount, "hour"));
        };
        this.addMinutes = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "minute") : value.add(amount, "minute"));
        };
        this.addSeconds = (value, amount)=>{
            return this.adjustOffset(amount < 0 ? value.subtract(Math.abs(amount), "second") : value.add(amount, "second"));
        };
        this.getYear = (value)=>{
            return value.year();
        };
        this.getMonth = (value)=>{
            return value.month();
        };
        this.getDate = (value)=>{
            return value.date();
        };
        this.getHours = (value)=>{
            return value.hour();
        };
        this.getMinutes = (value)=>{
            return value.minute();
        };
        this.getSeconds = (value)=>{
            return value.second();
        };
        this.getMilliseconds = (value)=>{
            return value.millisecond();
        };
        this.setYear = (value, year)=>{
            return this.adjustOffset(value.set("year", year));
        };
        this.setMonth = (value, month)=>{
            return this.adjustOffset(value.set("month", month));
        };
        this.setDate = (value, date)=>{
            return this.adjustOffset(value.set("date", date));
        };
        this.setHours = (value, hours)=>{
            return this.adjustOffset(value.set("hour", hours));
        };
        this.setMinutes = (value, minutes)=>{
            return this.adjustOffset(value.set("minute", minutes));
        };
        this.setSeconds = (value, seconds)=>{
            return this.adjustOffset(value.set("second", seconds));
        };
        this.setMilliseconds = (value, milliseconds)=>{
            return this.adjustOffset(value.set("millisecond", milliseconds));
        };
        this.getDaysInMonth = (value)=>{
            return value.daysInMonth();
        };
        this.getNextMonth = (value)=>{
            return this.addMonths(value, 1);
        };
        this.getPreviousMonth = (value)=>{
            return this.addMonths(value, -1);
        };
        this.getMonthArray = (value)=>{
            const firstMonth = value.startOf("year");
            const monthArray = [
                firstMonth
            ];
            while(monthArray.length < 12){
                const prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(this.addMonths(prevMonth, 1));
            }
            return monthArray;
        };
        this.mergeDateAndTime = (dateParam, timeParam)=>{
            return dateParam.hour(timeParam.hour()).minute(timeParam.minute()).second(timeParam.second());
        };
        this.getWeekdays = ()=>{
            const start = this.dayjs().startOf("week");
            return [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map((diff)=>this.formatByString(this.addDays(start, diff), "dd"));
        };
        this.getWeekArray = (value)=>{
            const cleanValue = this.setLocaleToValue(value);
            const start = cleanValue.startOf("month").startOf("week");
            const end = cleanValue.endOf("month").endOf("week");
            let count = 0;
            let current = start;
            const nestedWeeks = [];
            while(current < end){
                const weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                nestedWeeks[weekNumber].push(current);
                current = this.addDays(current, 1);
                count += 1;
            }
            return nestedWeeks;
        };
        this.getWeekNumber = (value)=>{
            return value.week();
        };
        this.getYearRange = (start, end)=>{
            const startDate = start.startOf("year");
            const endDate = end.endOf("year");
            const years = [];
            let current = startDate;
            while(current < endDate){
                years.push(current);
                current = this.addYears(current, 1);
            }
            return years;
        };
        this.getMeridiemText = (ampm)=>{
            return ampm === "am" ? "AM" : "PM";
        };
        this.rawDayJsInstance = instance;
        this.dayjs = $45a0d1f63ab1e3be$var$withLocale((_this$rawDayJsInstanc = this.rawDayJsInstance) != null ? _this$rawDayJsInstanc : (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))), _locale);
        this.locale = _locale;
        this.formats = (0, $lzDk3.default)({}, $45a0d1f63ab1e3be$var$defaultFormats, formats);
        (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($42ba427175bbb309$exports))));
    }
}


/**
 * React Router DOM v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4YNlq = parcelRequire("4YNlq");

/**
 * @remix-run/router v1.15.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $ef999a33175c8291$var$_extends() {
    $ef999a33175c8291$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ef999a33175c8291$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $ef999a33175c8291$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($ef999a33175c8291$export$e19cd5f9376f8cee || ($ef999a33175c8291$export$e19cd5f9376f8cee = {}));
const $ef999a33175c8291$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $ef999a33175c8291$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $ef999a33175c8291$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $ef999a33175c8291$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $ef999a33175c8291$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $ef999a33175c8291$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $ef999a33175c8291$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $ef999a33175c8291$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $ef999a33175c8291$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $ef999a33175c8291$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $ef999a33175c8291$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $ef999a33175c8291$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $ef999a33175c8291$export$fe53371bee54353d(to);
    }
    return $ef999a33175c8291$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $ef999a33175c8291$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $ef999a33175c8291$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $ef999a33175c8291$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $ef999a33175c8291$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $ef999a33175c8291$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $ef999a33175c8291$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $ef999a33175c8291$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $ef999a33175c8291$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $ef999a33175c8291$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $ef999a33175c8291$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $ef999a33175c8291$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $ef999a33175c8291$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $ef999a33175c8291$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $ef999a33175c8291$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $ef999a33175c8291$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $ef999a33175c8291$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $ef999a33175c8291$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $ef999a33175c8291$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($ef999a33175c8291$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $ef999a33175c8291$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $ef999a33175c8291$export$e19cd5f9376f8cee.Push;
        let location = $ef999a33175c8291$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $ef999a33175c8291$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $ef999a33175c8291$export$e19cd5f9376f8cee.Replace;
        let location = $ef999a33175c8291$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $ef999a33175c8291$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $ef999a33175c8291$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $ef999a33175c8291$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($ef999a33175c8291$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($ef999a33175c8291$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $ef999a33175c8291$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($ef999a33175c8291$var$ResultType || ($ef999a33175c8291$var$ResultType = {}));
const $ef999a33175c8291$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $ef999a33175c8291$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $ef999a33175c8291$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $ef999a33175c8291$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $ef999a33175c8291$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($ef999a33175c8291$var$isIndexRoute(route)) {
            let indexRoute = $ef999a33175c8291$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $ef999a33175c8291$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $ef999a33175c8291$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $ef999a33175c8291$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $ef999a33175c8291$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $ef999a33175c8291$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $ef999a33175c8291$var$flattenRoutes(routes);
    $ef999a33175c8291$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $ef999a33175c8291$var$decodePath(pathname);
        matches = $ef999a33175c8291$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $ef999a33175c8291$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $ef999a33175c8291$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $ef999a33175c8291$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $ef999a33175c8291$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $ef999a33175c8291$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $ef999a33175c8291$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $ef999a33175c8291$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $ef999a33175c8291$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $ef999a33175c8291$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $ef999a33175c8291$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $ef999a33175c8291$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $ef999a33175c8291$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $ef999a33175c8291$var$paramRe = /^:[\w-]+$/;
const $ef999a33175c8291$var$dynamicSegmentValue = 3;
const $ef999a33175c8291$var$indexRouteValue = 2;
const $ef999a33175c8291$var$emptySegmentValue = 1;
const $ef999a33175c8291$var$staticSegmentValue = 10;
const $ef999a33175c8291$var$splatPenalty = -2;
const $ef999a33175c8291$var$isSplat = (s)=>s === "*";
function $ef999a33175c8291$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($ef999a33175c8291$var$isSplat)) initialScore += $ef999a33175c8291$var$splatPenalty;
    if (index) initialScore += $ef999a33175c8291$var$indexRouteValue;
    return segments.filter((s)=>!$ef999a33175c8291$var$isSplat(s)).reduce((score, segment)=>score + ($ef999a33175c8291$var$paramRe.test(segment) ? $ef999a33175c8291$var$dynamicSegmentValue : segment === "" ? $ef999a33175c8291$var$emptySegmentValue : $ef999a33175c8291$var$staticSegmentValue), initialScore);
}
function $ef999a33175c8291$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $ef999a33175c8291$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $ef999a33175c8291$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $ef999a33175c8291$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $ef999a33175c8291$export$a5c6d149b50c1d86($ef999a33175c8291$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $ef999a33175c8291$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $ef999a33175c8291$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $ef999a33175c8291$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $ef999a33175c8291$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $ef999a33175c8291$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $ef999a33175c8291$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $ef999a33175c8291$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $ef999a33175c8291$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $ef999a33175c8291$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $ef999a33175c8291$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $ef999a33175c8291$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $ef999a33175c8291$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $ef999a33175c8291$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $ef999a33175c8291$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $ef999a33175c8291$var$normalizeSearch(search),
        hash: $ef999a33175c8291$var$normalizeHash(hash)
    };
}
function $ef999a33175c8291$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $ef999a33175c8291$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $ef999a33175c8291$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $ef999a33175c8291$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $ef999a33175c8291$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $ef999a33175c8291$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $ef999a33175c8291$export$8ccf933b0513f8d0(toArg);
    else {
        to = $ef999a33175c8291$var$_extends({}, toArg);
        $ef999a33175c8291$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $ef999a33175c8291$var$getInvalidPathError("?", "pathname", "search", to));
        $ef999a33175c8291$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $ef999a33175c8291$var$getInvalidPathError("#", "pathname", "hash", to));
        $ef999a33175c8291$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $ef999a33175c8291$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $ef999a33175c8291$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $ef999a33175c8291$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $ef999a33175c8291$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $ef999a33175c8291$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $ef999a33175c8291$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $ef999a33175c8291$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $ef999a33175c8291$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $ef999a33175c8291$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $ef999a33175c8291$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $ef999a33175c8291$export$42a99a7a4bc0e76a extends Error {
}
class $ef999a33175c8291$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $ef999a33175c8291$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $ef999a33175c8291$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $ef999a33175c8291$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $ef999a33175c8291$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $ef999a33175c8291$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $ef999a33175c8291$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $ef999a33175c8291$var$unwrapTrackedPromise(value) {
    if (!$ef999a33175c8291$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $ef999a33175c8291$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $ef999a33175c8291$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $ef999a33175c8291$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $ef999a33175c8291$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $ef999a33175c8291$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $ef999a33175c8291$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $ef999a33175c8291$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $ef999a33175c8291$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $ef999a33175c8291$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $ef999a33175c8291$var$validMutationMethods = new Set($ef999a33175c8291$var$validMutationMethodsArr);
const $ef999a33175c8291$var$validRequestMethodsArr = [
    "get",
    ...$ef999a33175c8291$var$validMutationMethodsArr
];
const $ef999a33175c8291$var$validRequestMethods = new Set($ef999a33175c8291$var$validRequestMethodsArr);
const $ef999a33175c8291$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $ef999a33175c8291$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $ef999a33175c8291$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $ef999a33175c8291$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $ef999a33175c8291$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $ef999a33175c8291$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $ef999a33175c8291$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $ef999a33175c8291$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $ef999a33175c8291$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $ef999a33175c8291$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $ef999a33175c8291$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $ef999a33175c8291$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $ef999a33175c8291$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $ef999a33175c8291$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $ef999a33175c8291$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $ef999a33175c8291$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $ef999a33175c8291$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $ef999a33175c8291$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $ef999a33175c8291$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $ef999a33175c8291$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $ef999a33175c8291$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$ef999a33175c8291$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($ef999a33175c8291$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $ef999a33175c8291$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $ef999a33175c8291$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $ef999a33175c8291$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $ef999a33175c8291$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $ef999a33175c8291$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $ef999a33175c8291$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $ef999a33175c8291$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $ef999a33175c8291$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $ef999a33175c8291$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($ef999a33175c8291$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $ef999a33175c8291$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $ef999a33175c8291$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $ef999a33175c8291$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $ef999a33175c8291$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $ef999a33175c8291$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $ef999a33175c8291$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $ef999a33175c8291$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $ef999a33175c8291$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $ef999a33175c8291$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $ef999a33175c8291$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $ef999a33175c8291$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $ef999a33175c8291$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $ef999a33175c8291$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $ef999a33175c8291$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $ef999a33175c8291$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $ef999a33175c8291$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $ef999a33175c8291$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$ef999a33175c8291$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $ef999a33175c8291$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $ef999a33175c8291$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $ef999a33175c8291$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $ef999a33175c8291$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $ef999a33175c8291$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $ef999a33175c8291$var$ResultType.error,
            error: $ef999a33175c8291$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $ef999a33175c8291$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($ef999a33175c8291$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($ef999a33175c8291$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $ef999a33175c8291$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $ef999a33175c8291$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($ef999a33175c8291$var$isDeferredResult(result)) throw $ef999a33175c8291$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $ef999a33175c8291$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $ef999a33175c8291$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $ef999a33175c8291$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $ef999a33175c8291$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $ef999a33175c8291$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($ef999a33175c8291$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $ef999a33175c8291$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $ef999a33175c8291$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $ef999a33175c8291$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $ef999a33175c8291$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $ef999a33175c8291$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $ef999a33175c8291$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $ef999a33175c8291$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $ef999a33175c8291$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $ef999a33175c8291$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $ef999a33175c8291$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ef999a33175c8291$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $ef999a33175c8291$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $ef999a33175c8291$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($ef999a33175c8291$var$isRedirectResult(actionResult) || $ef999a33175c8291$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $ef999a33175c8291$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($ef999a33175c8291$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $ef999a33175c8291$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $ef999a33175c8291$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($ef999a33175c8291$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($ef999a33175c8291$var$isDeferredResult(actionResult)) throw $ef999a33175c8291$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $ef999a33175c8291$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $ef999a33175c8291$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $ef999a33175c8291$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $ef999a33175c8291$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $ef999a33175c8291$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $ef999a33175c8291$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $ef999a33175c8291$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $ef999a33175c8291$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $ef999a33175c8291$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $ef999a33175c8291$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $ef999a33175c8291$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $ef999a33175c8291$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $ef999a33175c8291$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $ef999a33175c8291$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($ef999a33175c8291$var$isDeferredResult(result)) result = await $ef999a33175c8291$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $ef999a33175c8291$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($ef999a33175c8291$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $ef999a33175c8291$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($ef999a33175c8291$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $ef999a33175c8291$export$3e9cee6b33872309(!$ef999a33175c8291$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $ef999a33175c8291$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $ef999a33175c8291$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $ef999a33175c8291$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($ef999a33175c8291$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $ef999a33175c8291$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $ef999a33175c8291$export$e19cd5f9376f8cee.Replace : $ef999a33175c8291$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $ef999a33175c8291$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($ef999a33175c8291$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $ef999a33175c8291$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $ef999a33175c8291$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $ef999a33175c8291$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$ef999a33175c8291$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $ef999a33175c8291$var$callLoaderOrAction("loader", $ef999a33175c8291$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $ef999a33175c8291$var$ResultType.error,
                        error: $ef999a33175c8291$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $ef999a33175c8291$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $ef999a33175c8291$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $ef999a33175c8291$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $ef999a33175c8291$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $ef999a33175c8291$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $ef999a33175c8291$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $ef999a33175c8291$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $ef999a33175c8291$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $ef999a33175c8291$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $ef999a33175c8291$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $ef999a33175c8291$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $ef999a33175c8291$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $ef999a33175c8291$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$ef999a33175c8291$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $ef999a33175c8291$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $ef999a33175c8291$export$4d0306f8f6a4585b = Symbol("deferred");
function $ef999a33175c8291$export$3336b097a6fbc59a(routes, opts) {
    $ef999a33175c8291$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $ef999a33175c8291$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $ef999a33175c8291$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $ef999a33175c8291$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $ef999a33175c8291$var$createLocation("", $ef999a33175c8291$export$fe53371bee54353d(url), null, "default");
        let matches = $ef999a33175c8291$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$ef999a33175c8291$var$isValidMethod(method) && method !== "HEAD") {
            let error = $ef999a33175c8291$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $ef999a33175c8291$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $ef999a33175c8291$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $ef999a33175c8291$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($ef999a33175c8291$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $ef999a33175c8291$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $ef999a33175c8291$var$createLocation("", $ef999a33175c8291$export$fe53371bee54353d(url), null, "default");
        let matches = $ef999a33175c8291$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$ef999a33175c8291$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $ef999a33175c8291$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $ef999a33175c8291$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $ef999a33175c8291$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $ef999a33175c8291$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $ef999a33175c8291$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($ef999a33175c8291$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$ef999a33175c8291$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $ef999a33175c8291$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($ef999a33175c8291$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $ef999a33175c8291$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $ef999a33175c8291$var$isResponse(result) ? result : $ef999a33175c8291$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($ef999a33175c8291$var$isQueryRouteResponse(e)) {
                if (e.type === $ef999a33175c8291$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($ef999a33175c8291$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $ef999a33175c8291$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $ef999a33175c8291$var$ResultType.error,
                error: error
            };
        } else {
            result = await $ef999a33175c8291$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $ef999a33175c8291$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($ef999a33175c8291$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($ef999a33175c8291$var$isDeferredResult(result)) {
            let error = $ef999a33175c8291$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $ef999a33175c8291$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($ef999a33175c8291$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($ef999a33175c8291$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $ef999a33175c8291$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $ef999a33175c8291$var$_extends({}, context, {
                statusCode: $ef999a33175c8291$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $ef999a33175c8291$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $ef999a33175c8291$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $ef999a33175c8291$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $ef999a33175c8291$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $ef999a33175c8291$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$ef999a33175c8291$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $ef999a33175c8291$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $ef999a33175c8291$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $ef999a33175c8291$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $ef999a33175c8291$export$fec11da027c70692(routes, context, error) {
    let newContext = $ef999a33175c8291$var$_extends({}, context, {
        statusCode: $ef999a33175c8291$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $ef999a33175c8291$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $ef999a33175c8291$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $ef999a33175c8291$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $ef999a33175c8291$export$cae722b0cc860f13(to ? to : ".", $ef999a33175c8291$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $ef999a33175c8291$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$ef999a33175c8291$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $ef999a33175c8291$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $ef999a33175c8291$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $ef999a33175c8291$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$ef999a33175c8291$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$ef999a33175c8291$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $ef999a33175c8291$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $ef999a33175c8291$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $ef999a33175c8291$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$ef999a33175c8291$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$ef999a33175c8291$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $ef999a33175c8291$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $ef999a33175c8291$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $ef999a33175c8291$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $ef999a33175c8291$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $ef999a33175c8291$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($ef999a33175c8291$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $ef999a33175c8291$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $ef999a33175c8291$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $ef999a33175c8291$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $ef999a33175c8291$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $ef999a33175c8291$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $ef999a33175c8291$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($ef999a33175c8291$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $ef999a33175c8291$var$shouldRevalidateLoader(match, $ef999a33175c8291$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $ef999a33175c8291$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $ef999a33175c8291$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $ef999a33175c8291$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $ef999a33175c8291$var$shouldRevalidateLoader(fetcherMatch, $ef999a33175c8291$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $ef999a33175c8291$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $ef999a33175c8291$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $ef999a33175c8291$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $ef999a33175c8291$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $ef999a33175c8291$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $ef999a33175c8291$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$ef999a33175c8291$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $ef999a33175c8291$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $ef999a33175c8291$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $ef999a33175c8291$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $ef999a33175c8291$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $ef999a33175c8291$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $ef999a33175c8291$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $ef999a33175c8291$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $ef999a33175c8291$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $ef999a33175c8291$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($ef999a33175c8291$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($ef999a33175c8291$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $ef999a33175c8291$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$ef999a33175c8291$var$ABSOLUTE_URL_REGEX.test(location)) location = $ef999a33175c8291$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $ef999a33175c8291$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $ef999a33175c8291$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $ef999a33175c8291$var$ResultType.error ? $ef999a33175c8291$var$ResultType.error : $ef999a33175c8291$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $ef999a33175c8291$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $ef999a33175c8291$var$ResultType.error) return {
            type: resultType,
            error: new $ef999a33175c8291$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $ef999a33175c8291$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $ef999a33175c8291$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($ef999a33175c8291$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $ef999a33175c8291$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $ef999a33175c8291$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $ef999a33175c8291$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($ef999a33175c8291$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $ef999a33175c8291$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $ef999a33175c8291$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $ef999a33175c8291$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $ef999a33175c8291$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $ef999a33175c8291$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $ef999a33175c8291$export$3e9cee6b33872309(!$ef999a33175c8291$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($ef999a33175c8291$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $ef999a33175c8291$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $ef999a33175c8291$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($ef999a33175c8291$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $ef999a33175c8291$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $ef999a33175c8291$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $ef999a33175c8291$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($ef999a33175c8291$var$isErrorResult(result)) {
            let boundaryMatch = $ef999a33175c8291$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $ef999a33175c8291$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($ef999a33175c8291$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $ef999a33175c8291$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($ef999a33175c8291$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $ef999a33175c8291$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $ef999a33175c8291$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $ef999a33175c8291$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $ef999a33175c8291$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $ef999a33175c8291$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $ef999a33175c8291$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $ef999a33175c8291$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $ef999a33175c8291$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $ef999a33175c8291$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($ef999a33175c8291$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $ef999a33175c8291$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $ef999a33175c8291$export$8ccf933b0513f8d0(path) : path;
    return $ef999a33175c8291$export$fe53371bee54353d($ef999a33175c8291$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $ef999a33175c8291$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $ef999a33175c8291$var$isDeferredResult(result) {
    return result.type === $ef999a33175c8291$var$ResultType.deferred;
}
function $ef999a33175c8291$var$isErrorResult(result) {
    return result.type === $ef999a33175c8291$var$ResultType.error;
}
function $ef999a33175c8291$var$isRedirectResult(result) {
    return (result && result.type) === $ef999a33175c8291$var$ResultType.redirect;
}
function $ef999a33175c8291$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $ef999a33175c8291$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $ef999a33175c8291$var$isRedirectResponse(result) {
    if (!$ef999a33175c8291$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $ef999a33175c8291$var$isQueryRouteResponse(obj) {
    return obj && $ef999a33175c8291$var$isResponse(obj.response) && (obj.type === $ef999a33175c8291$var$ResultType.data || obj.type === $ef999a33175c8291$var$ResultType.error);
}
function $ef999a33175c8291$var$isValidMethod(method) {
    return $ef999a33175c8291$var$validRequestMethods.has(method.toLowerCase());
}
function $ef999a33175c8291$var$isMutationMethod(method) {
    return $ef999a33175c8291$var$validMutationMethods.has(method.toLowerCase());
}
async function $ef999a33175c8291$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$ef999a33175c8291$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($ef999a33175c8291$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $ef999a33175c8291$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $ef999a33175c8291$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $ef999a33175c8291$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $ef999a33175c8291$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $ef999a33175c8291$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $ef999a33175c8291$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $ef999a33175c8291$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $ef999a33175c8291$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $ef999a33175c8291$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $ef999a33175c8291$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $ef999a33175c8291$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $ef999a33175c8291$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $ef999a33175c8291$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $ef999a33175c8291$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $ef999a33175c8291$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $ef999a33175c8291$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $ef999a33175c8291$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $ef999a33175c8291$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($ef999a33175c8291$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $ef999a33175c8291$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($ef999a33175c8291$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $ef999a33175c8291$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $4YNlq = parcelRequire("4YNlq");

function $4fd73b9fb5b80e1f$var$_extends() {
    $4fd73b9fb5b80e1f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4fd73b9fb5b80e1f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $4fd73b9fb5b80e1f$export$3add0d5dce533e2e = /*#__PURE__*/ $4YNlq.createContext(null);
const $4fd73b9fb5b80e1f$export$145dfa71566a64dc = /*#__PURE__*/ $4YNlq.createContext(null);
const $4fd73b9fb5b80e1f$var$AwaitContext = /*#__PURE__*/ $4YNlq.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $4fd73b9fb5b80e1f$export$26749e8557646306 = /*#__PURE__*/ $4YNlq.createContext(null);
const $4fd73b9fb5b80e1f$export$c7914228fb69b0f5 = /*#__PURE__*/ $4YNlq.createContext(null);
const $4fd73b9fb5b80e1f$export$9072aa6dd1f93057 = /*#__PURE__*/ $4YNlq.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $4fd73b9fb5b80e1f$var$RouteErrorContext = /*#__PURE__*/ $4YNlq.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $4fd73b9fb5b80e1f$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$4fd73b9fb5b80e1f$export$9c954a9d03d32f4a() && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $4fd73b9fb5b80e1f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $ef999a33175c8291$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $4fd73b9fb5b80e1f$export$9c954a9d03d32f4a() {
    return $4YNlq.useContext($4fd73b9fb5b80e1f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $4fd73b9fb5b80e1f$export$45d76561a5302f2b() {
    !$4fd73b9fb5b80e1f$export$9c954a9d03d32f4a() && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    return $4YNlq.useContext($4fd73b9fb5b80e1f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $4fd73b9fb5b80e1f$export$1b3f31771c5d07c() {
    return $4YNlq.useContext($4fd73b9fb5b80e1f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $4fd73b9fb5b80e1f$export$6c330e8992e8a295(pattern) {
    !$4fd73b9fb5b80e1f$export$9c954a9d03d32f4a() && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $4fd73b9fb5b80e1f$export$45d76561a5302f2b();
    return $4YNlq.useMemo(()=>(0, $ef999a33175c8291$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $4fd73b9fb5b80e1f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $4fd73b9fb5b80e1f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $4YNlq.useContext($4fd73b9fb5b80e1f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $4YNlq.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $4fd73b9fb5b80e1f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $4fd73b9fb5b80e1f$var$useNavigateStable() : $4fd73b9fb5b80e1f$var$useNavigateUnstable();
}
function $4fd73b9fb5b80e1f$var$useNavigateUnstable() {
    !$4fd73b9fb5b80e1f$export$9c954a9d03d32f4a() && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    let dataRouterContext = $4YNlq.useContext($4fd73b9fb5b80e1f$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$26749e8557646306);
    let { matches: matches } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4fd73b9fb5b80e1f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ef999a33175c8291$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $4YNlq.useRef(false);
    $4fd73b9fb5b80e1f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4YNlq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $ef999a33175c8291$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ef999a33175c8291$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $4fd73b9fb5b80e1f$var$OutletContext = /*#__PURE__*/ $4YNlq.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $4fd73b9fb5b80e1f$export$4138103a3ae699cc() {
    return $4YNlq.useContext($4fd73b9fb5b80e1f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $4fd73b9fb5b80e1f$export$a3be3530d8e40d0b(context) {
    let outlet = $4YNlq.useContext($4fd73b9fb5b80e1f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $4fd73b9fb5b80e1f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $4fd73b9fb5b80e1f$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$26749e8557646306);
    let { matches: matches } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4fd73b9fb5b80e1f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $ef999a33175c8291$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $4YNlq.useMemo(()=>(0, $ef999a33175c8291$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $4fd73b9fb5b80e1f$export$5d3fca4a98652595(routes, locationArg) {
    return $4fd73b9fb5b80e1f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $4fd73b9fb5b80e1f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$4fd73b9fb5b80e1f$export$9c954a9d03d32f4a() && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$26749e8557646306);
    let { matches: parentMatches } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $4fd73b9fb5b80e1f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $ef999a33175c8291$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $ef999a33175c8291$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $4fd73b9fb5b80e1f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $ef999a33175c8291$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $ef999a33175c8291$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $4fd73b9fb5b80e1f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $ef999a33175c8291$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $4fd73b9fb5b80e1f$var$DefaultErrorComponent() {
    let error = $4fd73b9fb5b80e1f$export$ed527bf60f6e05f2();
    let message = (0, $ef999a33175c8291$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $4YNlq.createElement($4YNlq.Fragment, null, /*#__PURE__*/ $4YNlq.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $4YNlq.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $4YNlq.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $4fd73b9fb5b80e1f$var$defaultErrorElement = /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$var$DefaultErrorComponent, null);
class $4fd73b9fb5b80e1f$var$RenderErrorBoundary extends $4YNlq.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $4fd73b9fb5b80e1f$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $4YNlq.useContext($4fd73b9fb5b80e1f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $4fd73b9fb5b80e1f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $4fd73b9fb5b80e1f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $4fd73b9fb5b80e1f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $4YNlq.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $4fd73b9fb5b80e1f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($4fd73b9fb5b80e1f$var$DataRouterHook || {});
var $4fd73b9fb5b80e1f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($4fd73b9fb5b80e1f$var$DataRouterStateHook || {});
function $4fd73b9fb5b80e1f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $4fd73b9fb5b80e1f$var$useDataRouterContext(hookName) {
    let ctx = $4YNlq.useContext($4fd73b9fb5b80e1f$export$3add0d5dce533e2e);
    !ctx && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    return ctx;
}
function $4fd73b9fb5b80e1f$var$useDataRouterState(hookName) {
    let state = $4YNlq.useContext($4fd73b9fb5b80e1f$export$145dfa71566a64dc);
    !state && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    return state;
}
function $4fd73b9fb5b80e1f$var$useRouteContext(hookName) {
    let route = $4YNlq.useContext($4fd73b9fb5b80e1f$export$9072aa6dd1f93057);
    !route && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $4fd73b9fb5b80e1f$var$useCurrentRouteId(hookName) {
    let route = $4fd73b9fb5b80e1f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $4fd73b9fb5b80e1f$export$5fc8298006ad9e58() {
    return $4fd73b9fb5b80e1f$var$useCurrentRouteId($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $4fd73b9fb5b80e1f$export$d0fd4b7106de2769() {
    let state = $4fd73b9fb5b80e1f$var$useDataRouterState($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $4fd73b9fb5b80e1f$export$600dc272ed516c15() {
    let dataRouterContext = $4fd73b9fb5b80e1f$var$useDataRouterContext($4fd73b9fb5b80e1f$var$DataRouterHook.UseRevalidator);
    let state = $4fd73b9fb5b80e1f$var$useDataRouterState($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseRevalidator);
    return $4YNlq.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $4fd73b9fb5b80e1f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $4fd73b9fb5b80e1f$var$useDataRouterState($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseMatches);
    return $4YNlq.useMemo(()=>matches.map((m)=>(0, $ef999a33175c8291$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $4fd73b9fb5b80e1f$export$1448a5050d252c4d() {
    let state = $4fd73b9fb5b80e1f$var$useDataRouterState($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseLoaderData);
    let routeId = $4fd73b9fb5b80e1f$var$useCurrentRouteId($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $4fd73b9fb5b80e1f$export$fd5d37484eab868d(routeId) {
    let state = $4fd73b9fb5b80e1f$var$useDataRouterState($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $4fd73b9fb5b80e1f$export$fdc00f3f26066d5e() {
    let state = $4fd73b9fb5b80e1f$var$useDataRouterState($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseActionData);
    let routeId = $4fd73b9fb5b80e1f$var$useCurrentRouteId($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $4fd73b9fb5b80e1f$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $4YNlq.useContext($4fd73b9fb5b80e1f$var$RouteErrorContext);
    let state = $4fd73b9fb5b80e1f$var$useDataRouterState($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseRouteError);
    let routeId = $4fd73b9fb5b80e1f$var$useCurrentRouteId($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $4fd73b9fb5b80e1f$export$78a72ddb39bdd145() {
    let value = $4YNlq.useContext($4fd73b9fb5b80e1f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $4fd73b9fb5b80e1f$export$17f53340677d5831() {
    let value = $4YNlq.useContext($4fd73b9fb5b80e1f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $4fd73b9fb5b80e1f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $4fd73b9fb5b80e1f$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $4fd73b9fb5b80e1f$var$useDataRouterContext($4fd73b9fb5b80e1f$var$DataRouterHook.UseBlocker);
    let state = $4fd73b9fb5b80e1f$var$useDataRouterState($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $4YNlq.useState("");
    let blockerFunction = $4YNlq.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $4fd73b9fb5b80e1f$var$_extends({}, currentLocation, {
                pathname: (0, $ef999a33175c8291$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $4fd73b9fb5b80e1f$var$_extends({}, nextLocation, {
                pathname: (0, $ef999a33175c8291$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $4YNlq.useEffect(()=>{
        let key = String(++$4fd73b9fb5b80e1f$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $4YNlq.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $ef999a33175c8291$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $4fd73b9fb5b80e1f$var$useNavigateStable() {
    let { router: router } = $4fd73b9fb5b80e1f$var$useDataRouterContext($4fd73b9fb5b80e1f$var$DataRouterHook.UseNavigateStable);
    let id = $4fd73b9fb5b80e1f$var$useCurrentRouteId($4fd73b9fb5b80e1f$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $4YNlq.useRef(false);
    $4fd73b9fb5b80e1f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $4YNlq.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $4fd73b9fb5b80e1f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $4fd73b9fb5b80e1f$var$alreadyWarned = {};
function $4fd73b9fb5b80e1f$var$warningOnce(key, cond, message) {
    if (!cond && !$4fd73b9fb5b80e1f$var$alreadyWarned[key]) $4fd73b9fb5b80e1f$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $4fd73b9fb5b80e1f$var$START_TRANSITION = "startTransition";
const $4fd73b9fb5b80e1f$var$startTransitionImpl = $4YNlq[$4fd73b9fb5b80e1f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $4fd73b9fb5b80e1f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4YNlq.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4YNlq.useCallback((newState)=>{
        if (v7_startTransition && $4fd73b9fb5b80e1f$var$startTransitionImpl) $4fd73b9fb5b80e1f$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4YNlq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $4YNlq.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4YNlq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4YNlq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4YNlq.createElement($4YNlq.Fragment, null, /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $4fd73b9fb5b80e1f$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $4fd73b9fb5b80e1f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $4fd73b9fb5b80e1f$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $4YNlq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ef999a33175c8291$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4YNlq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4YNlq.useCallback((newState)=>{
        v7_startTransition && $4fd73b9fb5b80e1f$var$startTransitionImpl ? $4fd73b9fb5b80e1f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4YNlq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $4fd73b9fb5b80e1f$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$4fd73b9fb5b80e1f$export$9c954a9d03d32f4a() && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$26749e8557646306);
    let { matches: matches } = $4YNlq.useContext($4fd73b9fb5b80e1f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $4fd73b9fb5b80e1f$export$45d76561a5302f2b();
    let navigate = $4fd73b9fb5b80e1f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $ef999a33175c8291$export$cae722b0cc860f13)(to, (0, $ef999a33175c8291$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $4YNlq.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $4fd73b9fb5b80e1f$export$910ae8079b2c2852(props) {
    return $4fd73b9fb5b80e1f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6(_props) {
    (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $4fd73b9fb5b80e1f$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $ef999a33175c8291$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$4fd73b9fb5b80e1f$export$9c954a9d03d32f4a() && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $4YNlq.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $4fd73b9fb5b80e1f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $ef999a33175c8291$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $4YNlq.useMemo(()=>{
        let trailingPathname = (0, $ef999a33175c8291$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $4fd73b9fb5b80e1f$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $4fd73b9fb5b80e1f$export$5d3fca4a98652595($4fd73b9fb5b80e1f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $4fd73b9fb5b80e1f$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$var$ResolveAwait, null, children));
}
var $4fd73b9fb5b80e1f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($4fd73b9fb5b80e1f$var$AwaitRenderStatus || {});
const $4fd73b9fb5b80e1f$var$neverSettledPromise = new Promise(()=>{});
class $4fd73b9fb5b80e1f$var$AwaitErrorBoundary extends $4YNlq.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $4fd73b9fb5b80e1f$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $4fd73b9fb5b80e1f$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $4fd73b9fb5b80e1f$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $4fd73b9fb5b80e1f$var$AwaitRenderStatus.error : promise._data !== undefined ? $4fd73b9fb5b80e1f$var$AwaitRenderStatus.success : $4fd73b9fb5b80e1f$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $4fd73b9fb5b80e1f$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $4fd73b9fb5b80e1f$var$AwaitRenderStatus.error && promise._error instanceof (0, $ef999a33175c8291$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $4fd73b9fb5b80e1f$var$neverSettledPromise;
        if (status === $4fd73b9fb5b80e1f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $4fd73b9fb5b80e1f$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $4fd73b9fb5b80e1f$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $4YNlq.createElement($4fd73b9fb5b80e1f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $4fd73b9fb5b80e1f$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $4fd73b9fb5b80e1f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $4YNlq.createElement($4YNlq.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $4fd73b9fb5b80e1f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $4YNlq.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $4YNlq.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $4YNlq.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $4fd73b9fb5b80e1f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6) && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $4fd73b9fb5b80e1f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $4fd73b9fb5b80e1f$export$daf73786167a7f72(matches) {
    return $4fd73b9fb5b80e1f$var$_renderMatches(matches);
}
function $4fd73b9fb5b80e1f$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $4YNlq.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $4YNlq.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $4YNlq.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $4fd73b9fb5b80e1f$export$f30f7e456d254e83(routes, opts) {
    return (0, $ef999a33175c8291$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $4fd73b9fb5b80e1f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ef999a33175c8291$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $4fd73b9fb5b80e1f$export$52b333d321859367
    }).initialize();
}



function $34a8b74366f8f95b$var$_extends() {
    $34a8b74366f8f95b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $34a8b74366f8f95b$var$_extends.apply(this, arguments);
}
function $34a8b74366f8f95b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $34a8b74366f8f95b$var$defaultMethod = "get";
const $34a8b74366f8f95b$var$defaultEncType = "application/x-www-form-urlencoded";
function $34a8b74366f8f95b$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $34a8b74366f8f95b$var$isButtonElement(object) {
    return $34a8b74366f8f95b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $34a8b74366f8f95b$var$isFormElement(object) {
    return $34a8b74366f8f95b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $34a8b74366f8f95b$var$isInputElement(object) {
    return $34a8b74366f8f95b$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $34a8b74366f8f95b$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $34a8b74366f8f95b$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$34a8b74366f8f95b$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $34a8b74366f8f95b$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $34a8b74366f8f95b$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $34a8b74366f8f95b$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $34a8b74366f8f95b$var$_formDataSupportsSubmitter = null;
function $34a8b74366f8f95b$var$isFormDataSubmitterSupported() {
    if ($34a8b74366f8f95b$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $34a8b74366f8f95b$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $34a8b74366f8f95b$var$_formDataSupportsSubmitter = true;
    }
    return $34a8b74366f8f95b$var$_formDataSupportsSubmitter;
}
const $34a8b74366f8f95b$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $34a8b74366f8f95b$var$getFormEncType(encType) {
    if (encType != null && !$34a8b74366f8f95b$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $34a8b74366f8f95b$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($34a8b74366f8f95b$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $ef999a33175c8291$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $34a8b74366f8f95b$var$defaultMethod;
        encType = $34a8b74366f8f95b$var$getFormEncType(target.getAttribute("enctype")) || $34a8b74366f8f95b$var$defaultEncType;
        formData = new FormData(target);
    } else if ($34a8b74366f8f95b$var$isButtonElement(target) || $34a8b74366f8f95b$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $ef999a33175c8291$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $34a8b74366f8f95b$var$defaultMethod;
        encType = $34a8b74366f8f95b$var$getFormEncType(target.getAttribute("formenctype")) || $34a8b74366f8f95b$var$getFormEncType(form.getAttribute("enctype")) || $34a8b74366f8f95b$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$34a8b74366f8f95b$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($34a8b74366f8f95b$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $34a8b74366f8f95b$var$defaultMethod;
        action = null;
        encType = $34a8b74366f8f95b$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $34a8b74366f8f95b$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $34a8b74366f8f95b$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $34a8b74366f8f95b$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $34a8b74366f8f95b$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $34a8b74366f8f95b$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $34a8b74366f8f95b$export$1f3f55432a00e06d(routes, opts) {
    return (0, $ef999a33175c8291$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $34a8b74366f8f95b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ef999a33175c8291$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $34a8b74366f8f95b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4fd73b9fb5b80e1f$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $34a8b74366f8f95b$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $ef999a33175c8291$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $34a8b74366f8f95b$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $ef999a33175c8291$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $34a8b74366f8f95b$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $4fd73b9fb5b80e1f$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $34a8b74366f8f95b$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $34a8b74366f8f95b$var$_extends({}, state, {
        errors: $34a8b74366f8f95b$var$deserializeErrors(state.errors)
    });
    return state;
}
function $34a8b74366f8f95b$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $ef999a33175c8291$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $34a8b74366f8f95b$export$7ad602f0e94e62d1 = /*#__PURE__*/ $4YNlq.createContext({
    isTransitioning: false
});
const $34a8b74366f8f95b$export$148fd98d095596d4 = /*#__PURE__*/ $4YNlq.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $34a8b74366f8f95b$var$START_TRANSITION = "startTransition";
const $34a8b74366f8f95b$var$startTransitionImpl = $4YNlq[$34a8b74366f8f95b$var$START_TRANSITION];
const $34a8b74366f8f95b$var$FLUSH_SYNC = "flushSync";
const $34a8b74366f8f95b$var$flushSyncImpl = $330fb34df360181f$exports[$34a8b74366f8f95b$var$FLUSH_SYNC];
const $34a8b74366f8f95b$var$USE_ID = "useId";
const $34a8b74366f8f95b$var$useIdImpl = $4YNlq[$34a8b74366f8f95b$var$USE_ID];
function $34a8b74366f8f95b$var$startTransitionSafe(cb) {
    if ($34a8b74366f8f95b$var$startTransitionImpl) $34a8b74366f8f95b$var$startTransitionImpl(cb);
    else cb();
}
function $34a8b74366f8f95b$var$flushSyncSafe(cb) {
    if ($34a8b74366f8f95b$var$flushSyncImpl) $34a8b74366f8f95b$var$flushSyncImpl(cb);
    else cb();
}
class $34a8b74366f8f95b$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $34a8b74366f8f95b$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $4YNlq.useState(router.state);
    let [pendingState, setPendingState] = $4YNlq.useState();
    let [vtContext, setVtContext] = $4YNlq.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $4YNlq.useState();
    let [transition, setTransition] = $4YNlq.useState();
    let [interruption, setInterruption] = $4YNlq.useState();
    let fetcherData = $4YNlq.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $4YNlq.useCallback((cb)=>{
        if (v7_startTransition) $34a8b74366f8f95b$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $4YNlq.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $34a8b74366f8f95b$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $34a8b74366f8f95b$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $34a8b74366f8f95b$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $34a8b74366f8f95b$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $34a8b74366f8f95b$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $4YNlq.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $4YNlq.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $34a8b74366f8f95b$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $4YNlq.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $4YNlq.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $4YNlq.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $4YNlq.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $4YNlq.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $4YNlq.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $4YNlq.createElement($4YNlq.Fragment, null, /*#__PURE__*/ $4YNlq.createElement((0, $4fd73b9fb5b80e1f$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $4YNlq.createElement((0, $4fd73b9fb5b80e1f$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $4YNlq.createElement($34a8b74366f8f95b$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $4YNlq.createElement($34a8b74366f8f95b$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $4YNlq.createElement((0, $4fd73b9fb5b80e1f$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $4YNlq.createElement($34a8b74366f8f95b$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $34a8b74366f8f95b$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $4fd73b9fb5b80e1f$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $34a8b74366f8f95b$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $4YNlq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ef999a33175c8291$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4YNlq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4YNlq.useCallback((newState)=>{
        v7_startTransition && $34a8b74366f8f95b$var$startTransitionImpl ? $34a8b74366f8f95b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4YNlq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4YNlq.createElement((0, $4fd73b9fb5b80e1f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $34a8b74366f8f95b$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $4YNlq.useRef();
    if (historyRef.current == null) historyRef.current = (0, $ef999a33175c8291$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $4YNlq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4YNlq.useCallback((newState)=>{
        v7_startTransition && $34a8b74366f8f95b$var$startTransitionImpl ? $34a8b74366f8f95b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4YNlq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4YNlq.createElement((0, $4fd73b9fb5b80e1f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $34a8b74366f8f95b$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $4YNlq.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $4YNlq.useCallback((newState)=>{
        v7_startTransition && $34a8b74366f8f95b$var$startTransitionImpl ? $34a8b74366f8f95b$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $4YNlq.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $4YNlq.createElement((0, $4fd73b9fb5b80e1f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $34a8b74366f8f95b$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $34a8b74366f8f95b$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $34a8b74366f8f95b$export$a6c7ac8248d6e38a = /*#__PURE__*/ $4YNlq.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $34a8b74366f8f95b$var$_objectWithoutPropertiesLoose(_ref7, $34a8b74366f8f95b$var$_excluded);
    let { basename: basename } = $4YNlq.useContext((0, $4fd73b9fb5b80e1f$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $34a8b74366f8f95b$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($34a8b74366f8f95b$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $ef999a33175c8291$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $4fd73b9fb5b80e1f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $34a8b74366f8f95b$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $4YNlq.createElement("a", $34a8b74366f8f95b$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $34a8b74366f8f95b$export$b0d92dbee9b5b60d = /*#__PURE__*/ $4YNlq.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $34a8b74366f8f95b$var$_objectWithoutPropertiesLoose(_ref8, $34a8b74366f8f95b$var$_excluded2);
    let path = (0, $4fd73b9fb5b80e1f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $4fd73b9fb5b80e1f$export$45d76561a5302f2b)();
    let routerState = $4YNlq.useContext((0, $4fd73b9fb5b80e1f$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $4YNlq.useContext((0, $4fd73b9fb5b80e1f$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $34a8b74366f8f95b$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $ef999a33175c8291$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $4YNlq.createElement($34a8b74366f8f95b$export$a6c7ac8248d6e38a, $34a8b74366f8f95b$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $34a8b74366f8f95b$export$a7fed597f4b8afd8 = /*#__PURE__*/ $4YNlq.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $34a8b74366f8f95b$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $34a8b74366f8f95b$var$_objectWithoutPropertiesLoose(_ref9, $34a8b74366f8f95b$var$_excluded3);
    let submit = $34a8b74366f8f95b$export$47c85c6e3a081d3();
    let formAction = $34a8b74366f8f95b$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $4YNlq.createElement("form", $34a8b74366f8f95b$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $34a8b74366f8f95b$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $34a8b74366f8f95b$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $34a8b74366f8f95b$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($34a8b74366f8f95b$var$DataRouterHook || ($34a8b74366f8f95b$var$DataRouterHook = {}));
var $34a8b74366f8f95b$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($34a8b74366f8f95b$var$DataRouterStateHook || ($34a8b74366f8f95b$var$DataRouterStateHook = {}));
// Internal hooks
function $34a8b74366f8f95b$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $34a8b74366f8f95b$var$useDataRouterContext(hookName) {
    let ctx = $4YNlq.useContext((0, $4fd73b9fb5b80e1f$export$3add0d5dce533e2e));
    !ctx && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    return ctx;
}
function $34a8b74366f8f95b$var$useDataRouterState(hookName) {
    let state = $4YNlq.useContext((0, $4fd73b9fb5b80e1f$export$145dfa71566a64dc));
    !state && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $34a8b74366f8f95b$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $4fd73b9fb5b80e1f$export$9770f232ac06a008)();
    let location = (0, $4fd73b9fb5b80e1f$export$45d76561a5302f2b)();
    let path = (0, $4fd73b9fb5b80e1f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $4YNlq.useCallback((event)=>{
        if ($34a8b74366f8f95b$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $ef999a33175c8291$export$fe53371bee54353d)(location) === (0, $ef999a33175c8291$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $34a8b74366f8f95b$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $4YNlq.useRef($34a8b74366f8f95b$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $4YNlq.useRef(false);
    let location = (0, $4fd73b9fb5b80e1f$export$45d76561a5302f2b)();
    let searchParams = $4YNlq.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $34a8b74366f8f95b$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $4fd73b9fb5b80e1f$export$9770f232ac06a008)();
    let setSearchParams = $4YNlq.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $34a8b74366f8f95b$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $34a8b74366f8f95b$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $34a8b74366f8f95b$var$fetcherId = 0;
let $34a8b74366f8f95b$var$getUniqueFetcherId = ()=>"__" + String(++$34a8b74366f8f95b$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $34a8b74366f8f95b$export$47c85c6e3a081d3() {
    let { router: router } = $34a8b74366f8f95b$var$useDataRouterContext($34a8b74366f8f95b$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $4YNlq.useContext((0, $4fd73b9fb5b80e1f$export$26749e8557646306));
    let currentRouteId = (0, $4fd73b9fb5b80e1f$export$5fc8298006ad9e58)();
    return $4YNlq.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $34a8b74366f8f95b$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $34a8b74366f8f95b$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $34a8b74366f8f95b$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $34a8b74366f8f95b$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $4YNlq.useContext((0, $4fd73b9fb5b80e1f$export$26749e8557646306));
    let routeContext = $4YNlq.useContext((0, $4fd73b9fb5b80e1f$export$9072aa6dd1f93057));
    !routeContext && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $34a8b74366f8f95b$var$_extends({}, (0, $4fd73b9fb5b80e1f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $4fd73b9fb5b80e1f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $ef999a33175c8291$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $ef999a33175c8291$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $34a8b74366f8f95b$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $34a8b74366f8f95b$var$useDataRouterContext($34a8b74366f8f95b$var$DataRouterHook.UseFetcher);
    let state = $34a8b74366f8f95b$var$useDataRouterState($34a8b74366f8f95b$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $4YNlq.useContext($34a8b74366f8f95b$export$148fd98d095596d4);
    let route = $4YNlq.useContext((0, $4fd73b9fb5b80e1f$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    !route && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $34a8b74366f8f95b$var$useIdImpl ? $34a8b74366f8f95b$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $4YNlq.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($34a8b74366f8f95b$var$getUniqueFetcherId());
    // Registration/cleanup
    $4YNlq.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $4YNlq.useCallback((href, opts)=>{
        !routeId && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $34a8b74366f8f95b$export$47c85c6e3a081d3();
    let submit = $4YNlq.useCallback((target, opts)=>{
        submitImpl(target, $34a8b74366f8f95b$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $4YNlq.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $4YNlq.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $4YNlq.createElement($34a8b74366f8f95b$export$a7fed597f4b8afd8, $34a8b74366f8f95b$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $ef999a33175c8291$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $4YNlq.useMemo(()=>$34a8b74366f8f95b$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $34a8b74366f8f95b$export$fa996778a3a31087() {
    let state = $34a8b74366f8f95b$var$useDataRouterState($34a8b74366f8f95b$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $34a8b74366f8f95b$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $34a8b74366f8f95b$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $34a8b74366f8f95b$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $34a8b74366f8f95b$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $34a8b74366f8f95b$var$useDataRouterContext($34a8b74366f8f95b$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $34a8b74366f8f95b$var$useDataRouterState($34a8b74366f8f95b$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $4YNlq.useContext((0, $4fd73b9fb5b80e1f$export$26749e8557646306));
    let location = (0, $4fd73b9fb5b80e1f$export$45d76561a5302f2b)();
    let matches = (0, $4fd73b9fb5b80e1f$export$2378eb7f5ff86053)();
    let navigation = (0, $4fd73b9fb5b80e1f$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $4YNlq.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $34a8b74366f8f95b$var$usePageHide($4YNlq.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $34a8b74366f8f95b$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $34a8b74366f8f95b$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($34a8b74366f8f95b$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4YNlq.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $34a8b74366f8f95b$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $34a8b74366f8f95b$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4YNlq.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($34a8b74366f8f95b$var$_extends({}, location, {
                    pathname: (0, $ef999a33175c8291$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($34a8b74366f8f95b$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $4YNlq.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $34a8b74366f8f95b$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $4YNlq.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $34a8b74366f8f95b$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $4YNlq.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $34a8b74366f8f95b$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $4fd73b9fb5b80e1f$export$b273b3273281a049)(when);
    $4YNlq.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $4YNlq.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $34a8b74366f8f95b$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $4YNlq.useContext($34a8b74366f8f95b$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $ef999a33175c8291$export$3e9cee6b33872309)(false);
    let { basename: basename } = $34a8b74366f8f95b$var$useDataRouterContext($34a8b74366f8f95b$var$DataRouterHook.useViewTransitionState);
    let path = (0, $4fd73b9fb5b80e1f$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $ef999a33175c8291$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $ef999a33175c8291$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $ef999a33175c8291$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $ef999a33175c8291$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");


var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");

var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $kvdFq = parcelRequire("kvdFq");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $2qCAA = parcelRequire("2qCAA");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $3350eee9d19e8b15$export$24c1f8f60cbac79e(slot) {
    return (0, $fx4gX.default)("MuiTypography", slot);
}
const $3350eee9d19e8b15$var$typographyClasses = (0, $auO16.default)("MuiTypography", [
    "root",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "subtitle1",
    "subtitle2",
    "body1",
    "body2",
    "inherit",
    "button",
    "caption",
    "overline",
    "alignLeft",
    "alignRight",
    "alignCenter",
    "alignJustify",
    "noWrap",
    "gutterBottom",
    "paragraph"
]);
var $3350eee9d19e8b15$export$2e2bcd8739ae039 = $3350eee9d19e8b15$var$typographyClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $af664934923ca384$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $af664934923ca384$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            ownerState.align !== "inherit" && `align${(0, $2qCAA.default)(align)}`,
            gutterBottom && "gutterBottom",
            noWrap && "noWrap",
            paragraph && "paragraph"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $3350eee9d19e8b15$export$24c1f8f60cbac79e), classes);
};
const $af664934923ca384$export$140e2f5526d3cad8 = (0, $JdaC3.default)("span", {
    name: "MuiTypography",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== "inherit" && styles[`align${(0, $2qCAA.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        margin: 0
    }, ownerState.variant === "inherit" && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit"
    }, ownerState.variant !== "inherit" && theme.typography[ownerState.variant], ownerState.align !== "inherit" && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    }, ownerState.gutterBottom && {
        marginBottom: "0.35em"
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $af664934923ca384$var$defaultVariantMapping = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    subtitle1: "h6",
    subtitle2: "h6",
    body1: "p",
    body2: "p",
    inherit: "p"
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $af664934923ca384$var$colorTransformations = {
    primary: "primary.main",
    textPrimary: "text.primary",
    secondary: "secondary.main",
    textSecondary: "text.secondary",
    error: "error.main"
};
const $af664934923ca384$var$transformDeprecatedColors = (color)=>{
    return $af664934923ca384$var$colorTransformations[color] || color;
};
const $af664934923ca384$var$Typography = /*#__PURE__*/ $4YNlq.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiTypography"
    });
    const color = $af664934923ca384$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $kvdFq.default)((0, $lzDk3.default)({}, themeProps, {
        color: color
    }));
    const { align: align = "inherit", className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = "body1", variantMapping: variantMapping = $af664934923ca384$var$defaultVariantMapping } = props, other = (0, $g54n0.default)(props, $af664934923ca384$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? "p" : variantMapping[variant] || $af664934923ca384$var$defaultVariantMapping[variant]) || "span";
    const classes = $af664934923ca384$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($af664934923ca384$export$140e2f5526d3cad8, (0, $lzDk3.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $fQQpK.default)(classes.root, className)
    }, other));
});
var $af664934923ca384$export$2e2bcd8739ae039 = $af664934923ca384$var$Typography;


var $778421b95220a899$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($778421b95220a899$exports, "__esModule", {
    value: true
});
$778421b95220a899$exports.default = void 0;

var $778421b95220a899$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $778421b95220a899$var$_default = $778421b95220a899$exports.default = (0, $778421b95220a899$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4"
}), "AttachMoney");


var $65a37757caade48b$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($65a37757caade48b$exports, "__esModule", {
    value: true
});
$65a37757caade48b$exports.default = void 0;

var $65a37757caade48b$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $65a37757caade48b$var$_default = $65a37757caade48b$exports.default = (0, $65a37757caade48b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m0 16H5V10h14zM9 14H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2zm-8 4H7v-2h2zm4 0h-2v-2h2zm4 0h-2v-2h2z"
}), "CalendarMonth");


var $caf321dae3eae9c7$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($caf321dae3eae9c7$exports, "__esModule", {
    value: true
});
$caf321dae3eae9c7$exports.default = void 0;

var $caf321dae3eae9c7$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $caf321dae3eae9c7$var$_default = $caf321dae3eae9c7$exports.default = (0, $caf321dae3eae9c7$var$_createSvgIcon.default)([
    /*#__PURE__*/ (0, $izf4p.jsx)("path", {
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    }, "0"),
    /*#__PURE__*/ (0, $izf4p.jsx)("path", {
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }, "1")
], "Schedule");



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $af94551ec12d5eb4$export$e28348cc2430497(element) {
    return typeof element === "string";
}



var $9JdRu = parcelRequire("9JdRu");



var $309LR = parcelRequire("309LR");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");



var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $4YNlq = parcelRequire("4YNlq");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $0aeecae1008ec90a$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}


"use client";
function $7a0503e87ff161dd$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $4YNlq.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $0aeecae1008ec90a$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


"use client";
var $4019772905761825$export$2e2bcd8739ae039 = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039);



var $4YNlq = parcelRequire("4YNlq");

var $4YNlq = parcelRequire("4YNlq");
"use client";
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $ff5d306a1114a428$var$useEnhancedEffect = typeof window !== "undefined" ? $4YNlq.useLayoutEffect : $4YNlq.useEffect;
var $ff5d306a1114a428$export$2e2bcd8739ae039 = $ff5d306a1114a428$var$useEnhancedEffect;


"use client";
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $2bc6807800e1e224$var$useEventCallback(fn) {
    const ref = $4YNlq.useRef(fn);
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $4YNlq.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $2bc6807800e1e224$export$2e2bcd8739ae039 = $2bc6807800e1e224$var$useEventCallback;


"use client";
var $ac8766c980630ed8$export$2e2bcd8739ae039 = (0, $2bc6807800e1e224$export$2e2bcd8739ae039);



var $4YNlq = parcelRequire("4YNlq");

var $4YNlq = parcelRequire("4YNlq");
"use client";
const $f0f7e63ca955d164$var$UNINITIALIZED = {};
function $f0f7e63ca955d164$export$2e2bcd8739ae039(init, initArg) {
    const ref = $4YNlq.useRef($f0f7e63ca955d164$var$UNINITIALIZED);
    if (ref.current === $f0f7e63ca955d164$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $4YNlq = parcelRequire("4YNlq");
"use client";
const $4078f6045bacb8ca$var$EMPTY = [];
function $4078f6045bacb8ca$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $4YNlq.useEffect(fn, $4078f6045bacb8ca$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


"use client";
class $973088a6538d1d0c$export$786b4da70f00938b {
    static create() {
        return new $973088a6538d1d0c$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = 0;
            fn();
        }, delay);
    }
    constructor(){
        this.currentId = 0;
        this.clear = ()=>{
            if (this.currentId !== 0) {
                clearTimeout(this.currentId);
                this.currentId = 0;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function $973088a6538d1d0c$export$2e2bcd8739ae039() {
    const timeout = (0, $f0f7e63ca955d164$export$2e2bcd8739ae039)($973088a6538d1d0c$export$786b4da70f00938b.create).current;
    (0, $4078f6045bacb8ca$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


"use client";
let $b0113b7ab57ecd2b$var$hadKeyboardEvent = true;
let $b0113b7ab57ecd2b$var$hadFocusVisibleRecently = false;
const $b0113b7ab57ecd2b$var$hadFocusVisibleRecentlyTimeout = new (0, $973088a6538d1d0c$export$786b4da70f00938b)();
const $b0113b7ab57ecd2b$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    "datetime-local": true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $b0113b7ab57ecd2b$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === "INPUT" && $b0113b7ab57ecd2b$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === "TEXTAREA" && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $b0113b7ab57ecd2b$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $b0113b7ab57ecd2b$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $b0113b7ab57ecd2b$var$handlePointerDown() {
    $b0113b7ab57ecd2b$var$hadKeyboardEvent = false;
}
function $b0113b7ab57ecd2b$var$handleVisibilityChange() {
    if (this.visibilityState === "hidden") // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($b0113b7ab57ecd2b$var$hadFocusVisibleRecently) $b0113b7ab57ecd2b$var$hadKeyboardEvent = true;
    }
}
function $b0113b7ab57ecd2b$var$prepare(doc) {
    doc.addEventListener("keydown", $b0113b7ab57ecd2b$var$handleKeyDown, true);
    doc.addEventListener("mousedown", $b0113b7ab57ecd2b$var$handlePointerDown, true);
    doc.addEventListener("pointerdown", $b0113b7ab57ecd2b$var$handlePointerDown, true);
    doc.addEventListener("touchstart", $b0113b7ab57ecd2b$var$handlePointerDown, true);
    doc.addEventListener("visibilitychange", $b0113b7ab57ecd2b$var$handleVisibilityChange, true);
}
function $b0113b7ab57ecd2b$export$4794d9b1949031cf(doc) {
    doc.removeEventListener("keydown", $b0113b7ab57ecd2b$var$handleKeyDown, true);
    doc.removeEventListener("mousedown", $b0113b7ab57ecd2b$var$handlePointerDown, true);
    doc.removeEventListener("pointerdown", $b0113b7ab57ecd2b$var$handlePointerDown, true);
    doc.removeEventListener("touchstart", $b0113b7ab57ecd2b$var$handlePointerDown, true);
    doc.removeEventListener("visibilitychange", $b0113b7ab57ecd2b$var$handleVisibilityChange, true);
}
function $b0113b7ab57ecd2b$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(":focus-visible");
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $b0113b7ab57ecd2b$var$hadKeyboardEvent || $b0113b7ab57ecd2b$var$focusTriggersKeyboardModality(target);
}
function $b0113b7ab57ecd2b$export$2e2bcd8739ae039() {
    const ref = $4YNlq.useCallback((node)=>{
        if (node != null) $b0113b7ab57ecd2b$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $4YNlq.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $b0113b7ab57ecd2b$var$hadFocusVisibleRecently = true;
            $b0113b7ab57ecd2b$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $b0113b7ab57ecd2b$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($b0113b7ab57ecd2b$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


"use client";
var $59cbe701edccf2bc$export$2e2bcd8739ae039 = (0, $b0113b7ab57ecd2b$export$2e2bcd8739ae039);



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $1uy3y = parcelRequire("1uy3y");

var $fQQpK = parcelRequire("fQQpK");

var $8zt0d = parcelRequire("8zt0d");


var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $izf4p = parcelRequire("izf4p");
"use client";
function $0cfe84929592473e$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $4YNlq.useState(false);
    const rippleClassName = (0, $fQQpK.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $fQQpK.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $4YNlq.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $izf4p.jsx)("span", {
            className: childClassName
        })
    });
}
var $0cfe84929592473e$export$2e2bcd8739ae039 = $0cfe84929592473e$var$Ripple;



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $c43c7f3549aa4b10$export$b464606f735ab902(slot) {
    return (0, $fx4gX.default)("MuiTouchRipple", slot);
}
const $c43c7f3549aa4b10$var$touchRippleClasses = (0, $auO16.default)("MuiTouchRipple", [
    "root",
    "ripple",
    "rippleVisible",
    "ripplePulsate",
    "child",
    "childLeaving",
    "childPulsate"
]);
var $c43c7f3549aa4b10$export$2e2bcd8739ae039 = $c43c7f3549aa4b10$var$touchRippleClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $b4510f7777139bec$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $b4510f7777139bec$var$_ = (t)=>t, $b4510f7777139bec$var$_t, $b4510f7777139bec$var$_t2, $b4510f7777139bec$var$_t3, $b4510f7777139bec$var$_t4;
const $b4510f7777139bec$var$DURATION = 550;
const $b4510f7777139bec$export$95d0c9356b2231a3 = 80;
const $b4510f7777139bec$var$enterKeyframe = (0, $8zt0d.keyframes)($b4510f7777139bec$var$_t || ($b4510f7777139bec$var$_t = $b4510f7777139bec$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $b4510f7777139bec$var$exitKeyframe = (0, $8zt0d.keyframes)($b4510f7777139bec$var$_t2 || ($b4510f7777139bec$var$_t2 = $b4510f7777139bec$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $b4510f7777139bec$var$pulsateKeyframe = (0, $8zt0d.keyframes)($b4510f7777139bec$var$_t3 || ($b4510f7777139bec$var$_t3 = $b4510f7777139bec$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $b4510f7777139bec$export$f6b7418508c72c25 = (0, $JdaC3.default)("span", {
    name: "MuiTouchRipple",
    slot: "Root"
})({
    overflow: "hidden",
    pointerEvents: "none",
    position: "absolute",
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "inherit"
});
const $b4510f7777139bec$export$676cfe7b12693c4b = (0, $JdaC3.default)((0, $0cfe84929592473e$export$2e2bcd8739ae039), {
    name: "MuiTouchRipple",
    slot: "Ripple"
})($b4510f7777139bec$var$_t4 || ($b4510f7777139bec$var$_t4 = $b4510f7777139bec$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).rippleVisible, $b4510f7777139bec$var$enterKeyframe, $b4510f7777139bec$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).child, (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).childLeaving, $b4510f7777139bec$var$exitKeyframe, $b4510f7777139bec$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).childPulsate, $b4510f7777139bec$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $b4510f7777139bec$var$TouchRipple = /*#__PURE__*/ $4YNlq.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiTouchRipple"
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $g54n0.default)(props, $b4510f7777139bec$var$_excluded);
    const [ripples, setRipples] = $4YNlq.useState([]);
    const nextKey = $4YNlq.useRef(0);
    const rippleCallback = $4YNlq.useRef(null);
    $4YNlq.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $4YNlq.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $973088a6538d1d0c$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $4YNlq.useRef(null);
    const container = $4YNlq.useRef(null);
    const startCommit = $4YNlq.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $izf4p.jsx)($b4510f7777139bec$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $fQQpK.default)(classes.ripple, (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $fQQpK.default)(classes.rippleVisible, (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $fQQpK.default)(classes.ripplePulsate, (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $fQQpK.default)(classes.child, (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $fQQpK.default)(classes.childLeaving, (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $fQQpK.default)(classes.childPulsate, (0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $b4510f7777139bec$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $4YNlq.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === "mousedown" && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === "touchstart") ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($b4510f7777139bec$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $4YNlq.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $4YNlq.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === "touchend" && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $4YNlq.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)($b4510f7777139bec$export$f6b7418508c72c25, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)((0, $c43c7f3549aa4b10$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $1uy3y.default), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $b4510f7777139bec$export$2e2bcd8739ae039 = $b4510f7777139bec$var$TouchRipple;



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $633e801e9b1d4442$export$fccb0498dcd99783(slot) {
    return (0, $fx4gX.default)("MuiButtonBase", slot);
}
const $633e801e9b1d4442$var$buttonBaseClasses = (0, $auO16.default)("MuiButtonBase", [
    "root",
    "disabled",
    "focusVisible"
]);
var $633e801e9b1d4442$export$2e2bcd8739ae039 = $633e801e9b1d4442$var$buttonBaseClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $7e17388639953587$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $7e17388639953587$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            focusVisible && "focusVisible"
        ]
    };
    const composedClasses = (0, $9JdRu.default)(slots, (0, $633e801e9b1d4442$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $7e17388639953587$export$7ec0dcc5e3cdcd36 = (0, $JdaC3.default)("button", {
    name: "MuiButtonBase",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    boxSizing: "border-box",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    MozAppearance: "none",
    // Reset
    WebkitAppearance: "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
        borderStyle: "none" // Remove Firefox dotted outline.
    },
    [`&.${(0, $633e801e9b1d4442$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: "none",
        // Disable link interactions
        cursor: "default"
    },
    "@media print": {
        colorAdjust: "exact"
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $7e17388639953587$var$ButtonBase = /*#__PURE__*/ $4YNlq.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiButtonBase"
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = "button", disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = "a", onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $g54n0.default)(props, $7e17388639953587$var$_excluded);
    const buttonRef = $4YNlq.useRef(null);
    const rippleRef = $4YNlq.useRef(null);
    const handleRippleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $59cbe701edccf2bc$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $4YNlq.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $4YNlq.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $4YNlq.useState(false);
    $4YNlq.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $4YNlq.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $ac8766c980630ed8$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler("start", onMouseDown);
    const handleContextMenu = useRippleHandler("stop", onContextMenu);
    const handleDragLeave = useRippleHandler("stop", onDragLeave);
    const handleMouseUp = useRippleHandler("stop", onMouseUp);
    const handleMouseLeave = useRippleHandler("stop", (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler("start", onTouchStart);
    const handleTouchEnd = useRippleHandler("stop", onTouchEnd);
    const handleTouchMove = useRippleHandler("stop", onTouchMove);
    const handleBlur = useRippleHandler("stop", (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $ac8766c980630ed8$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== "button" && !(button.tagName === "A" && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $4YNlq.useRef(false);
    const handleKeyDown = (0, $ac8766c980630ed8$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $ac8766c980630ed8$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === "button" && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === "button") {
        buttonProps.type = type === undefined ? "button" : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = "button";
        if (disabled) buttonProps["aria-disabled"] = disabled;
    }
    const handleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $lzDk3.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $7e17388639953587$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($7e17388639953587$export$7ec0dcc5e3cdcd36, (0, $lzDk3.default)({
        as: ComponentProp,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $izf4p.jsx)((0, $b4510f7777139bec$export$2e2bcd8739ae039), (0, $lzDk3.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $7e17388639953587$export$2e2bcd8739ae039 = $7e17388639953587$var$ButtonBase;



var $4YNlq = parcelRequire("4YNlq");
function $af281ee701e67602$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $4YNlq.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $1ab46a2a38c891ed$export$2e2bcd8739ae039 = (0, $af281ee701e67602$export$2e2bcd8739ae039);



"use client";
var $64a26410cabc30a1$export$2e2bcd8739ae039 = (0, $ff5d306a1114a428$export$2e2bcd8739ae039);




var $4YNlq = parcelRequire("4YNlq");
"use client";
/**
 * @ignore - internal component.
 */ const $055e0d2ec1c9fa19$var$ListContext = /*#__PURE__*/ $4YNlq.createContext({});
var $055e0d2ec1c9fa19$export$2e2bcd8739ae039 = $055e0d2ec1c9fa19$var$ListContext;



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $bb6968a1344cf6b1$export$5682c366c0c669d9(slot) {
    return (0, $fx4gX.default)("MuiListItem", slot);
}
const $bb6968a1344cf6b1$var$listItemClasses = (0, $auO16.default)("MuiListItem", [
    "root",
    "container",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "padding",
    "button",
    "secondaryAction",
    "selected"
]);
var $bb6968a1344cf6b1$export$2e2bcd8739ae039 = $bb6968a1344cf6b1$var$listItemClasses;



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $dfe9827538251805$export$c09531d8563c67a5(slot) {
    return (0, $fx4gX.default)("MuiListItemButton", slot);
}
const $dfe9827538251805$var$listItemButtonClasses = (0, $auO16.default)("MuiListItemButton", [
    "root",
    "focusVisible",
    "dense",
    "alignItemsFlexStart",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $dfe9827538251805$export$2e2bcd8739ae039 = $dfe9827538251805$var$listItemButtonClasses;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");


var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $68f11f28bd817928$export$ccdb26aeba48a86e(slot) {
    return (0, $fx4gX.default)("MuiListItemSecondaryAction", slot);
}
const $68f11f28bd817928$var$listItemSecondaryActionClasses = (0, $auO16.default)("MuiListItemSecondaryAction", [
    "root",
    "disableGutters"
]);
var $68f11f28bd817928$export$2e2bcd8739ae039 = $68f11f28bd817928$var$listItemSecondaryActionClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $72c24c10956a3a72$var$_excluded = [
    "className"
];
const $72c24c10956a3a72$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            disableGutters && "disableGutters"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $68f11f28bd817928$export$ccdb26aeba48a86e), classes);
};
const $72c24c10956a3a72$var$ListItemSecondaryActionRoot = (0, $JdaC3.default)("div", {
    name: "MuiListItemSecondaryAction",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        position: "absolute",
        right: 16,
        top: "50%",
        transform: "translateY(-50%)"
    }, ownerState.disableGutters && {
        right: 0
    }));
/**
 * Must be used as the last child of ListItem to function properly.
 */ const $72c24c10956a3a72$var$ListItemSecondaryAction = /*#__PURE__*/ $4YNlq.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiListItemSecondaryAction"
    });
    const { className: className } = props, other = (0, $g54n0.default)(props, $72c24c10956a3a72$var$_excluded);
    const context = $4YNlq.useContext((0, $055e0d2ec1c9fa19$export$2e2bcd8739ae039));
    const ownerState = (0, $lzDk3.default)({}, props, {
        disableGutters: context.disableGutters
    });
    const classes = $72c24c10956a3a72$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($72c24c10956a3a72$var$ListItemSecondaryActionRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
$72c24c10956a3a72$var$ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var $72c24c10956a3a72$export$2e2bcd8739ae039 = $72c24c10956a3a72$var$ListItemSecondaryAction;



var $izf4p = parcelRequire("izf4p");
"use client";
const $34b8ec6d79126c08$var$_excluded = [
    "className"
], $34b8ec6d79126c08$var$_excluded2 = [
    "alignItems",
    "autoFocus",
    "button",
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "ContainerComponent",
    "ContainerProps",
    "dense",
    "disabled",
    "disableGutters",
    "disablePadding",
    "divider",
    "focusVisibleClassName",
    "secondaryAction",
    "selected",
    "slotProps",
    "slots"
];
const $34b8ec6d79126c08$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.button && styles.button,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $34b8ec6d79126c08$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, button: button, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            !disablePadding && "padding",
            divider && "divider",
            disabled && "disabled",
            button && "button",
            alignItems === "flex-start" && "alignItemsFlexStart",
            hasSecondaryAction && "secondaryAction",
            selected && "selected"
        ],
        container: [
            "container"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $bb6968a1344cf6b1$export$5682c366c0c669d9), classes);
};
const $34b8ec6d79126c08$export$aed538f7519abe89 = (0, $JdaC3.default)("div", {
    name: "MuiListItem",
    slot: "Root",
    overridesResolver: $34b8ec6d79126c08$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        width: "100%",
        boxSizing: "border-box",
        textAlign: "left"
    }, !ownerState.disablePadding && (0, $lzDk3.default)({
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, !!ownerState.secondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }), !!ownerState.secondaryAction && {
        [`& > .${(0, $dfe9827538251805$export$2e2bcd8739ae039).root}`]: {
            paddingRight: 48
        }
    }, {
        [`&.${(0, $bb6968a1344cf6b1$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $bb6968a1344cf6b1$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $bb6968a1344cf6b1$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $bb6968a1344cf6b1$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.button && {
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $bb6968a1344cf6b1$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        }
    }, ownerState.hasSecondaryAction && {
        // Add some space to avoid collision as `ListItemSecondaryAction`
        // is absolutely positioned.
        paddingRight: 48
    }));
const $34b8ec6d79126c08$var$ListItemContainer = (0, $JdaC3.default)("li", {
    name: "MuiListItem",
    slot: "Container",
    overridesResolver: (props, styles)=>styles.container
})({
    position: "relative"
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $34b8ec6d79126c08$var$ListItem = /*#__PURE__*/ $4YNlq.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiListItem"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, button: button = false, children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = "li", ContainerProps: { className: ContainerClassName } = {}, dense: dense = false, disabled: disabled = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, secondaryAction: secondaryAction, selected: selected = false, slotProps: slotProps = {}, slots: slots = {} } = props, ContainerProps = (0, $g54n0.default)(props.ContainerProps, $34b8ec6d79126c08$var$_excluded), other = (0, $g54n0.default)(props, $34b8ec6d79126c08$var$_excluded2);
    const context = $4YNlq.useContext((0, $055e0d2ec1c9fa19$export$2e2bcd8739ae039));
    const childContext = $4YNlq.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $4YNlq.useRef(null);
    (0, $64a26410cabc30a1$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const children = $4YNlq.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v5, will be removed in v6
    const hasSecondaryAction = children.length && (0, $1ab46a2a38c891ed$export$2e2bcd8739ae039)(children[children.length - 1], [
        "ListItemSecondaryAction"
    ]);
    const ownerState = (0, $lzDk3.default)({}, props, {
        alignItems: alignItems,
        autoFocus: autoFocus,
        button: button,
        dense: childContext.dense,
        disabled: disabled,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction,
        selected: selected
    });
    const classes = $34b8ec6d79126c08$var$useUtilityClasses(ownerState);
    const handleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $34b8ec6d79126c08$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, rootProps.className, className),
        disabled: disabled
    }, other);
    let Component = componentProp || "li";
    if (button) {
        componentProps.component = componentProp || "div";
        componentProps.focusVisibleClassName = (0, $fQQpK.default)((0, $bb6968a1344cf6b1$export$2e2bcd8739ae039).focusVisible, focusVisibleClassName);
        Component = (0, $7e17388639953587$export$2e2bcd8739ae039);
    }
    // v4 implementation, deprecated in v5, will be removed in v6
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? "div" : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === "li") {
            if (Component === "li") Component = "div";
            else if (componentProps.component === "li") componentProps.component = "div";
        }
        return /*#__PURE__*/ (0, $izf4p.jsx)((0, $055e0d2ec1c9fa19$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $izf4p.jsxs)($34b8ec6d79126c08$var$ListItemContainer, (0, $lzDk3.default)({
                as: ContainerComponent,
                className: (0, $fQQpK.default)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState
            }, ContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)(Root, (0, $lzDk3.default)({}, rootProps, !(0, $af94551ec12d5eb4$export$e28348cc2430497)(Root) && {
                        as: Component,
                        ownerState: (0, $lzDk3.default)({}, ownerState, rootProps.ownerState)
                    }, componentProps, {
                        children: children
                    })),
                    children.pop()
                ]
            }))
        });
    }
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $055e0d2ec1c9fa19$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $izf4p.jsxs)(Root, (0, $lzDk3.default)({}, rootProps, {
            as: Component,
            ref: handleRef
        }, !(0, $af94551ec12d5eb4$export$e28348cc2430497)(Root) && {
            ownerState: (0, $lzDk3.default)({}, ownerState, rootProps.ownerState)
        }, componentProps, {
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $izf4p.jsx)((0, $72c24c10956a3a72$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        }))
    });
});
var $34b8ec6d79126c08$export$2e2bcd8739ae039 = $34b8ec6d79126c08$var$ListItem;


const $385dac4025c32ee1$export$4f13f83fd8bb1dac = ({ deposit: deposit, time: time, area: area, room: room })=>{
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
        alignItems: "center",
        sx: {
            pl: 0,
            justifyContent: "space-between",
            mt: 3
        },
        children: [
            time && /*#__PURE__*/ (0, $izf4p.jsx)($385dac4025c32ee1$var$Icon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($65a37757caade48b$exports))),
                title: "Min rental",
                description: `${time} days`
            }),
            room && /*#__PURE__*/ (0, $izf4p.jsx)($385dac4025c32ee1$var$Icon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($caf321dae3eae9c7$exports))),
                title: "Operating hours",
                description: room
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)($385dac4025c32ee1$var$Icon, {
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($778421b95220a899$exports))),
                title: "Deposit",
                description: deposit ? "required" : "not-required"
            })
        ]
    });
};
const $385dac4025c32ee1$var$Icon = ({ Icon: Icon, title: title, description: description })=>{
    return /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)(Icon, {
                fontSize: "medium",
                htmlColor: "#56596C"
            }),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "flex flex-col mx-4",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        component: "span",
                        variant: "body2",
                        color: "text.secondary",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        component: "span",
                        variant: "body2",
                        color: "text.primary",
                        children: description
                    })
                ]
            })
        ]
    });
};



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");


var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $a4577e39aef300ad$export$c6bd6795ed6e3203(slot) {
    return (0, $fx4gX.default)("MuiList", slot);
}
const $a4577e39aef300ad$var$listClasses = (0, $auO16.default)("MuiList", [
    "root",
    "padding",
    "dense",
    "subheader"
]);
var $a4577e39aef300ad$export$2e2bcd8739ae039 = $a4577e39aef300ad$var$listClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $a9f02ffffb31630e$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $a9f02ffffb31630e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            "root",
            !disablePadding && "padding",
            dense && "dense",
            subheader && "subheader"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $a4577e39aef300ad$export$c6bd6795ed6e3203), classes);
};
const $a9f02ffffb31630e$var$ListRoot = (0, $JdaC3.default)("ul", {
    name: "MuiList",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        listStyle: "none",
        margin: 0,
        padding: 0,
        position: "relative"
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $a9f02ffffb31630e$var$List = /*#__PURE__*/ $4YNlq.forwardRef(function List(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiList"
    });
    const { children: children, className: className, component: component = "ul", dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $g54n0.default)(props, $a9f02ffffb31630e$var$_excluded);
    const context = $4YNlq.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $lzDk3.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $a9f02ffffb31630e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $055e0d2ec1c9fa19$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $izf4p.jsxs)($a9f02ffffb31630e$var$ListRoot, (0, $lzDk3.default)({
            as: component,
            className: (0, $fQQpK.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $a9f02ffffb31630e$export$2e2bcd8739ae039 = $a9f02ffffb31630e$var$List;




var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $309LR = parcelRequire("309LR");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $c2eee4d171101174$export$46f01d01378ec5a2(slot) {
    return (0, $fx4gX.default)("MuiDivider", slot);
}
const $c2eee4d171101174$var$dividerClasses = (0, $auO16.default)("MuiDivider", [
    "root",
    "absolute",
    "fullWidth",
    "inset",
    "middle",
    "flexItem",
    "light",
    "vertical",
    "withChildren",
    "withChildrenVertical",
    "textAlignRight",
    "textAlignLeft",
    "wrapper",
    "wrapperVertical"
]);
var $c2eee4d171101174$export$2e2bcd8739ae039 = $c2eee4d171101174$var$dividerClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $1e9a9e12369b3b08$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $1e9a9e12369b3b08$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            absolute && "absolute",
            variant,
            light && "light",
            orientation === "vertical" && "vertical",
            flexItem && "flexItem",
            children && "withChildren",
            children && orientation === "vertical" && "withChildrenVertical",
            textAlign === "right" && orientation !== "vertical" && "textAlignRight",
            textAlign === "left" && orientation !== "vertical" && "textAlignLeft"
        ],
        wrapper: [
            "wrapper",
            orientation === "vertical" && "wrapperVertical"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $c2eee4d171101174$export$46f01d01378ec5a2), classes);
};
const $1e9a9e12369b3b08$var$DividerRoot = (0, $JdaC3.default)("div", {
    name: "MuiDivider",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === "vertical" && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === "vertical" && styles.withChildrenVertical,
            ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && styles.textAlignRight,
            ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: "thin"
    }, ownerState.absolute && {
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%"
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $309LR.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === "inset" && {
        marginLeft: 72
    }, ownerState.variant === "middle" && ownerState.orientation === "horizontal" && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === "middle" && ownerState.orientation === "vertical" && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === "vertical" && {
        height: "100%",
        borderBottomWidth: 0,
        borderRightWidth: "thin"
    }, ownerState.flexItem && {
        alignSelf: "stretch",
        height: "auto"
    }), ({ ownerState: ownerState })=>(0, $lzDk3.default)({}, ownerState.children && {
        display: "flex",
        whiteSpace: "nowrap",
        textAlign: "center",
        border: 0,
        "&::before, &::after": {
            content: '""',
            alignSelf: "center"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({}, ownerState.children && ownerState.orientation !== "vertical" && {
        "&::before, &::after": {
            width: "100%",
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({}, ownerState.children && ownerState.orientation === "vertical" && {
        flexDirection: "column",
        "&::before, &::after": {
            height: "100%",
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $lzDk3.default)({}, ownerState.textAlign === "right" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "90%"
        },
        "&::after": {
            width: "10%"
        }
    }, ownerState.textAlign === "left" && ownerState.orientation !== "vertical" && {
        "&::before": {
            width: "10%"
        },
        "&::after": {
            width: "90%"
        }
    }));
const $1e9a9e12369b3b08$var$DividerWrapper = (0, $JdaC3.default)("span", {
    name: "MuiDivider",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === "vertical" && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "inline-block",
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === "vertical" && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $1e9a9e12369b3b08$var$Divider = /*#__PURE__*/ $4YNlq.forwardRef(function Divider(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiDivider"
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? "div" : "hr", flexItem: flexItem = false, light: light = false, orientation: orientation = "horizontal", role: role = component !== "hr" ? "separator" : undefined, textAlign: textAlign = "center", variant: variant = "fullWidth" } = props, other = (0, $g54n0.default)(props, $1e9a9e12369b3b08$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $1e9a9e12369b3b08$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($1e9a9e12369b3b08$var$DividerRoot, (0, $lzDk3.default)({
        as: component,
        className: (0, $fQQpK.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $izf4p.jsx)($1e9a9e12369b3b08$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ $1e9a9e12369b3b08$var$Divider.muiSkipListHighlight = true;
var $1e9a9e12369b3b08$export$2e2bcd8739ae039 = $1e9a9e12369b3b08$var$Divider;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");



var $4Q3YJ = parcelRequire("4Q3YJ");

var $JdaC3 = parcelRequire("JdaC3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $cb707acaa7c08e99$export$1061006a0db3aeb5(slot) {
    return (0, $fx4gX.default)("MuiListItemText", slot);
}
const $cb707acaa7c08e99$var$listItemTextClasses = (0, $auO16.default)("MuiListItemText", [
    "root",
    "multiline",
    "dense",
    "inset",
    "primary",
    "secondary"
]);
var $cb707acaa7c08e99$export$2e2bcd8739ae039 = $cb707acaa7c08e99$var$listItemTextClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $9f9b47791fcb1adc$var$_excluded = [
    "children",
    "className",
    "disableTypography",
    "inset",
    "primary",
    "primaryTypographyProps",
    "secondary",
    "secondaryTypographyProps"
];
const $9f9b47791fcb1adc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            "root",
            inset && "inset",
            dense && "dense",
            primary && secondary && "multiline"
        ],
        primary: [
            "primary"
        ],
        secondary: [
            "secondary"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $cb707acaa7c08e99$export$1061006a0db3aeb5), classes);
};
const $9f9b47791fcb1adc$var$ListItemTextRoot = (0, $JdaC3.default)("div", {
    name: "MuiListItemText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $cb707acaa7c08e99$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $cb707acaa7c08e99$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        flex: "1 1 auto",
        minWidth: 0,
        marginTop: 4,
        marginBottom: 4
    }, ownerState.primary && ownerState.secondary && {
        marginTop: 6,
        marginBottom: 6
    }, ownerState.inset && {
        paddingLeft: 56
    }));
const $9f9b47791fcb1adc$var$ListItemText = /*#__PURE__*/ $4YNlq.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiListItemText"
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps } = props, other = (0, $g54n0.default)(props, $9f9b47791fcb1adc$var$_excluded);
    const { dense: dense } = $4YNlq.useContext((0, $055e0d2ec1c9fa19$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = (0, $lzDk3.default)({}, props, {
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    });
    const classes = $9f9b47791fcb1adc$var$useUtilityClasses(ownerState);
    if (primary != null && primary.type !== (0, $af664934923ca384$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), (0, $lzDk3.default)({
        variant: dense ? "body2" : "body1",
        className: classes.primary,
        component: primaryTypographyProps != null && primaryTypographyProps.variant ? undefined : "span",
        display: "block"
    }, primaryTypographyProps, {
        children: primary
    }));
    if (secondary != null && secondary.type !== (0, $af664934923ca384$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), (0, $lzDk3.default)({
        variant: "body2",
        className: classes.secondary,
        color: "text.secondary",
        display: "block"
    }, secondaryTypographyProps, {
        children: secondary
    }));
    return /*#__PURE__*/ (0, $izf4p.jsxs)($9f9b47791fcb1adc$var$ListItemTextRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            primary,
            secondary
        ]
    }));
});
var $9f9b47791fcb1adc$export$2e2bcd8739ae039 = $9f9b47791fcb1adc$var$ListItemText;




var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");



var $3d7dafec7aca2a49$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($3d7dafec7aca2a49$exports, "__esModule", {
    value: true
});
$3d7dafec7aca2a49$exports.default = void 0;

var $3d7dafec7aca2a49$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $3d7dafec7aca2a49$var$_default = $3d7dafec7aca2a49$exports.default = (0, $3d7dafec7aca2a49$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M3 21h18v-6H3zm7.33-2v-2h3.33v2zM19 19h-3.33v-2H19zM5 17h3.33v2H5zm1-7 1.42-1.42L5.83 7H17c1.1 0 2 .9 2 2s-.9 2-2 2H3v2h14c2.21 0 4-1.79 4-4s-1.79-4-4-4H5.83l1.59-1.59L6 2 2 6z"
}), "Repartition");


var $eb283db8820b12da$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($eb283db8820b12da$exports, "__esModule", {
    value: true
});
$eb283db8820b12da$exports.default = void 0;

var $eb283db8820b12da$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $eb283db8820b12da$var$_default = $eb283db8820b12da$exports.default = (0, $eb283db8820b12da$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "m9.4 10.5 4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2M8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15zm11.27 0-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35z"
}), "Camera");


var $c3fdadc72b5fc13b$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($c3fdadc72b5fc13b$exports, "__esModule", {
    value: true
});
$c3fdadc72b5fc13b$exports.default = void 0;

var $c3fdadc72b5fc13b$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $c3fdadc72b5fc13b$var$_default = $c3fdadc72b5fc13b$exports.default = (0, $c3fdadc72b5fc13b$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M21 12v-2h-2V7l-3-3-2 2-2-2-2 2-2-2-3 3v3H3v2h2v2H3v2h2v4h14v-4h2v-2h-2v-2zm-5-5.17 1 1V10h-2V7.83l.41-.41zm-4 0 .59.59.41.41V10h-2V7.83l.41-.41zM11 14v-2h2v2zm2 2v2h-2v-2zM7 7.83l1-1 .59.59.41.41V10H7zM7 12h2v2H7zm0 4h2v2H7zm10 2h-2v-2h2zm0-4h-2v-2h2z"
}), "Fence");


const $bf8df369c6741ee2$export$442a48e23d8e9d11 = ()=>{
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
        alignItems: "flex-start",
        sx: {
            pl: 0,
            mb: 5
        },
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
            primary: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                variant: "h6",
                children: "Facilities"
            }),
            secondary: /*#__PURE__*/ (0, $izf4p.jsx)((0, $izf4p.Fragment), {
                children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
                    alignItems: "center",
                    sx: {
                        pl: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $izf4p.jsx)($bf8df369c6741ee2$var$Icon, {
                            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3d7dafec7aca2a49$exports))),
                            title: "Partial load"
                        }),
                        /*#__PURE__*/ (0, $izf4p.jsx)($bf8df369c6741ee2$var$Icon, {
                            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eb283db8820b12da$exports))),
                            title: "CCTV"
                        }),
                        /*#__PURE__*/ (0, $izf4p.jsx)($bf8df369c6741ee2$var$Icon, {
                            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c3fdadc72b5fc13b$exports))),
                            title: "Guarded"
                        })
                    ]
                })
            })
        })
    });
};
const $bf8df369c6741ee2$var$Icon = ({ Icon: Icon, title: title })=>{
    return /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)(Icon, {
                fontSize: "medium",
                htmlColor: "#56596C"
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "flex flex-col ml-1 mr-6",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                    component: "span",
                    variant: "body2",
                    color: "text.secondary",
                    children: title
                })
            })
        ]
    });
};



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");
parcelRequire("4YNlq");

var $7ipzf = parcelRequire("7ipzf");

var $izf4p = parcelRequire("izf4p");
"use client";
var $98206a007030e7b4$export$2e2bcd8739ae039 = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $b119192203cf9fa8$export$ffd560f22c0ecf04(slot) {
    return (0, $fx4gX.default)("MuiAvatar", slot);
}
const $b119192203cf9fa8$var$avatarClasses = (0, $auO16.default)("MuiAvatar", [
    "root",
    "colorDefault",
    "circular",
    "rounded",
    "square",
    "img",
    "fallback"
]);
var $b119192203cf9fa8$export$2e2bcd8739ae039 = $b119192203cf9fa8$var$avatarClasses;



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");


var $lzDk3 = parcelRequire("lzDk3");

function $b8794f95cd574d7f$export$b089efb01a7bdf50(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $af94551ec12d5eb4$export$e28348cc2430497)(elementType)) return otherProps;
    return (0, $lzDk3.default)({}, otherProps, {
        ownerState: (0, $lzDk3.default)({}, otherProps.ownerState, ownerState)
    });
}


var $lzDk3 = parcelRequire("lzDk3");

var $fQQpK = parcelRequire("fQQpK");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $2dc08db820ff4928$export$24d5698b57eff81c(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === "function" && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $47b439e3eabc61a8$export$2ac0fa4d3a39be45(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === "function")).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $31f260d5a52cc518$export$b01d1e419b049226(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $fQQpK.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $lzDk3.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $lzDk3.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $2dc08db820ff4928$export$24d5698b57eff81c)((0, $lzDk3.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $47b439e3eabc61a8$export$2ac0fa4d3a39be45)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $47b439e3eabc61a8$export$2ac0fa4d3a39be45)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $fQQpK.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $lzDk3.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $lzDk3.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}

/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $2961338a1e0cb3f1$export$308c24034cde71de(componentProps, ownerState, slotState) {
    if (typeof componentProps === "function") return componentProps(ownerState, slotState);
    return componentProps;
}


"use client";
const $2baf81eecfc54562$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $2baf81eecfc54562$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $2baf81eecfc54562$var$_excluded3 = [
    "component"
];
function $2baf81eecfc54562$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $g54n0.default)(parameters, $2baf81eecfc54562$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $g54n0.default)(externalForwardedProps, $2baf81eecfc54562$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $2961338a1e0cb3f1$export$308c24034cde71de)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $31f260d5a52cc518$export$b01d1e419b049226)((0, $lzDk3.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === "root" ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $g54n0.default)(_mergeSlotProps.props, $2baf81eecfc54562$var$_excluded3);
    const ref = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $lzDk3.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === "root" ? slotComponent || rootComponent : slotComponent;
    const props = (0, $b8794f95cd574d7f$export$b089efb01a7bdf50)(elementType, (0, $lzDk3.default)({}, name === "root" && !rootComponent && !slots[name] && internalForwardedProps, name !== "root" && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $izf4p = parcelRequire("izf4p");
"use client";
const $48dff5681ca1c01f$var$_excluded = [
    "alt",
    "children",
    "className",
    "component",
    "slots",
    "slotProps",
    "imgProps",
    "sizes",
    "src",
    "srcSet",
    "variant"
];
const $48dff5681ca1c01f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            colorDefault && "colorDefault"
        ],
        img: [
            "img"
        ],
        fallback: [
            "fallback"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $b119192203cf9fa8$export$ffd560f22c0ecf04), classes);
};
const $48dff5681ca1c01f$var$AvatarRoot = (0, $JdaC3.default)("div", {
    name: "MuiAvatar",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})(({ theme: theme })=>({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: "50%",
        overflow: "hidden",
        userSelect: "none",
        variants: [
            {
                props: {
                    variant: "rounded"
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: "square"
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: (0, $lzDk3.default)({
                    color: (theme.vars || theme).palette.background.default
                }, theme.vars ? {
                    backgroundColor: theme.vars.palette.Avatar.defaultBg
                } : (0, $lzDk3.default)({
                    backgroundColor: theme.palette.grey[400]
                }, theme.applyStyles("dark", {
                    backgroundColor: theme.palette.grey[600]
                })))
            }
        ]
    }));
const $48dff5681ca1c01f$var$AvatarImg = (0, $JdaC3.default)("img", {
    name: "MuiAvatar",
    slot: "Img",
    overridesResolver: (props, styles)=>styles.img
})({
    width: "100%",
    height: "100%",
    textAlign: "center",
    // Handle non-square image. The property isn't supported by IE11.
    objectFit: "cover",
    // Hide alt text.
    color: "transparent",
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $48dff5681ca1c01f$var$AvatarFallback = (0, $JdaC3.default)((0, $98206a007030e7b4$export$2e2bcd8739ae039), {
    name: "MuiAvatar",
    slot: "Fallback",
    overridesResolver: (props, styles)=>styles.fallback
})({
    width: "75%",
    height: "75%"
});
function $48dff5681ca1c01f$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $4YNlq.useState(false);
    $4YNlq.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded("loaded");
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded("error");
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $48dff5681ca1c01f$var$Avatar = /*#__PURE__*/ $4YNlq.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiAvatar"
    });
    const { alt: alt, children: childrenProp, className: className, component: component = "div", slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = "circular" } = props, other = (0, $g54n0.default)(props, $48dff5681ca1c01f$var$_excluded);
    let children = null;
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $48dff5681ca1c01f$var$useLoaded((0, $lzDk3.default)({}, imgProps, {
        src: src,
        srcSet: srcSet
    }));
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== "error";
    const ownerState = (0, $lzDk3.default)({}, props, {
        colorDefault: !hasImgNotFailing,
        component: component,
        variant: variant
    });
    const classes = $48dff5681ca1c01f$var$useUtilityClasses(ownerState);
    const [ImgSlot, imgSlotProps] = (0, $2baf81eecfc54562$export$2e2bcd8739ae039)("img", {
        className: classes.img,
        elementType: $48dff5681ca1c01f$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: (0, $lzDk3.default)({}, imgProps, slotProps.img)
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $izf4p.jsx)(ImgSlot, (0, $lzDk3.default)({}, imgSlotProps));
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $izf4p.jsx)($48dff5681ca1c01f$var$AvatarFallback, {
        ownerState: ownerState,
        className: classes.fallback
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)($48dff5681ca1c01f$var$AvatarRoot, (0, $lzDk3.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fQQpK.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children
    }));
});
var $48dff5681ca1c01f$export$2e2bcd8739ae039 = $48dff5681ca1c01f$var$Avatar;


const $670a3c9067984895$export$393edc798c47379d = (ad)=>{
    const { description: description, name: name, longitude: longitude, latitude: latitude, city: city } = ad;
    return /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
        className: "max-w-[650px]",
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "mb-8 text-4xl lg:text-5xl",
                children: name
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                variant: "h5",
                mb: 5,
                color: "text.secondary",
                children: city
            }),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "mb-3 flex",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $48dff5681ca1c01f$export$2e2bcd8739ae039), {
                        alt: ad?.name,
                        src: ad?.images?.[0]
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                        className: "flex flex-col mx-4",
                        children: [
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                component: "span",
                                variant: "body2",
                                color: "text.primary",
                                sx: {
                                    textTransform: "capitalize"
                                },
                                children: ad?.storage_type
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsxs)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                component: "span",
                                variant: "body2",
                                color: "text.secondary",
                                children: [
                                    ad?.area,
                                    " square ft."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsxs)((0, $a9f02ffffb31630e$export$2e2bcd8739ae039), {
                sx: {
                    width: "100%",
                    bgcolor: "background.paper"
                },
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $1e9a9e12369b3b08$export$2e2bcd8739ae039), {
                        variant: "inset",
                        component: "li",
                        sx: {
                            ml: 0
                        }
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $385dac4025c32ee1$export$4f13f83fd8bb1dac), {
                        deposit: ad.deposit_required,
                        time: ad.minimum_rental,
                        area: ad.area,
                        room: ad.operating_hours
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
                        alignItems: "flex-start",
                        sx: {
                            pl: 0,
                            mt: 6
                        },
                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
                            primary: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                variant: "h4",
                                mb: 2,
                                children: "Description"
                            }),
                            secondary: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                sx: {
                                    display: "inline"
                                },
                                component: "span",
                                variant: "body2",
                                color: "text.primary",
                                children: [
                                    description,
                                    " "
                                ]
                            })
                        })
                    }),
                    ad?.price_includes?.length && /*#__PURE__*/ (0, $izf4p.jsx)((0, $izf4p.Fragment), {
                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
                            alignItems: "flex-start",
                            sx: {
                                pl: 0
                            },
                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
                                primary: "Price includes:",
                                secondary: /*#__PURE__*/ (0, $izf4p.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).Fragment, {
                                    children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: "inline"
                                        },
                                        variant: "body2",
                                        color: "text.primary",
                                        children: /*#__PURE__*/ (0, $izf4p.jsx)("ul", {
                                            children: ad?.price_includes?.map((incl, key)=>/*#__PURE__*/ (0, $izf4p.jsx)("li", {
                                                    children: incl
                                                }, key))
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    ad?.addons?.length && /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $1e9a9e12369b3b08$export$2e2bcd8739ae039), {
                                variant: "inset",
                                component: "li"
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
                                alignItems: "flex-start",
                                sx: {
                                    pl: 0
                                },
                                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
                                    primary: "Add-ons",
                                    secondary: /*#__PURE__*/ (0, $izf4p.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).Fragment, {
                                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: "inline"
                                            },
                                            component: "span",
                                            variant: "body2",
                                            color: "text.primary",
                                            children: /*#__PURE__*/ (0, $izf4p.jsx)("ul", {
                                                children: ad?.addons?.map((addon)=>/*#__PURE__*/ (0, $izf4p.jsx)("li", {
                                                        children: addon
                                                    }))
                                            })
                                        })
                                    })
                                })
                            }),
                            " "
                        ]
                    }),
                    ad?.addons?.length && /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
                        children: [
                            "  ",
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $1e9a9e12369b3b08$export$2e2bcd8739ae039), {
                                variant: "inset",
                                component: "li"
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
                                alignItems: "flex-start",
                                sx: {
                                    pl: 0
                                },
                                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
                                    primary: "Rules",
                                    secondary: /*#__PURE__*/ (0, $izf4p.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).Fragment, {
                                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: "inline"
                                            },
                                            component: "span",
                                            variant: "body2",
                                            color: "text.primary",
                                            children: /*#__PURE__*/ (0, $izf4p.jsx)("ul", {
                                                children: ad?.rules?.map((rule)=>/*#__PURE__*/ (0, $izf4p.jsx)("li", {
                                                        children: rule
                                                    }))
                                            })
                                        })
                                    })
                                })
                            }),
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $bf8df369c6741ee2$export$442a48e23d8e9d11), {})
                ]
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");



var $9JdRu = parcelRequire("9JdRu");

var $309LR = parcelRequire("309LR");

var $JdaC3 = parcelRequire("JdaC3");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $51466b81ec9e03b7$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $51466b81ec9e03b7$export$2e2bcd8739ae039 = $51466b81ec9e03b7$var$getOverlayAlpha;



var $4Q3YJ = parcelRequire("4Q3YJ");


var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $24e11b59b016b1c8$export$29cdb466b9b6f20b(slot) {
    return (0, $fx4gX.default)("MuiPaper", slot);
}
const $24e11b59b016b1c8$var$paperClasses = (0, $auO16.default)("MuiPaper", [
    "root",
    "rounded",
    "outlined",
    "elevation",
    "elevation0",
    "elevation1",
    "elevation2",
    "elevation3",
    "elevation4",
    "elevation5",
    "elevation6",
    "elevation7",
    "elevation8",
    "elevation9",
    "elevation10",
    "elevation11",
    "elevation12",
    "elevation13",
    "elevation14",
    "elevation15",
    "elevation16",
    "elevation17",
    "elevation18",
    "elevation19",
    "elevation20",
    "elevation21",
    "elevation22",
    "elevation23",
    "elevation24"
]);
var $24e11b59b016b1c8$export$2e2bcd8739ae039 = $24e11b59b016b1c8$var$paperClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $b622387df7e39ff3$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $b622387df7e39ff3$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            !square && "rounded",
            variant === "elevation" && `elevation${elevation}`
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $24e11b59b016b1c8$export$29cdb466b9b6f20b), classes);
};
const $b622387df7e39ff3$var$PaperRoot = (0, $JdaC3.default)("div", {
    name: "MuiPaper",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === "elevation" && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $lzDk3.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create("box-shadow")
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === "outlined" && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === "elevation" && (0, $lzDk3.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === "dark" && {
        backgroundImage: `linear-gradient(${(0, $309LR.alpha)("#fff", (0, $51466b81ec9e03b7$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $309LR.alpha)("#fff", (0, $51466b81ec9e03b7$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $b622387df7e39ff3$var$Paper = /*#__PURE__*/ $4YNlq.forwardRef(function Paper(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPaper"
    });
    const { className: className, component: component = "div", elevation: elevation = 1, square: square = false, variant: variant = "elevation" } = props, other = (0, $g54n0.default)(props, $b622387df7e39ff3$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $b622387df7e39ff3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($b622387df7e39ff3$var$PaperRoot, (0, $lzDk3.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fQQpK.default)(classes.root, className),
        ref: ref
    }, other));
});
var $b622387df7e39ff3$export$2e2bcd8739ae039 = $b622387df7e39ff3$var$Paper;



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $0b812417ce09e3ce$export$f3b76d2cce458caa(slot) {
    return (0, $fx4gX.default)("MuiCard", slot);
}
const $0b812417ce09e3ce$var$cardClasses = (0, $auO16.default)("MuiCard", [
    "root"
]);
var $0b812417ce09e3ce$export$2e2bcd8739ae039 = $0b812417ce09e3ce$var$cardClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $68fba4ffcff019c8$var$_excluded = [
    "className",
    "raised"
];
const $68fba4ffcff019c8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $0b812417ce09e3ce$export$f3b76d2cce458caa), classes);
};
const $68fba4ffcff019c8$var$CardRoot = (0, $JdaC3.default)((0, $b622387df7e39ff3$export$2e2bcd8739ae039), {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: "hidden"
    };
});
const $68fba4ffcff019c8$var$Card = /*#__PURE__*/ $4YNlq.forwardRef(function Card(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiCard"
    });
    const { className: className, raised: raised = false } = props, other = (0, $g54n0.default)(props, $68fba4ffcff019c8$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        raised: raised
    });
    const classes = $68fba4ffcff019c8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($68fba4ffcff019c8$var$CardRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $68fba4ffcff019c8$export$2e2bcd8739ae039 = $68fba4ffcff019c8$var$Card;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $ckn1w = parcelRequire("ckn1w");

var $9JdRu = parcelRequire("9JdRu");

var $309LR = parcelRequire("309LR");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");


var $2qCAA = parcelRequire("2qCAA");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $98f4f30a7ccae6ba$export$5a6f9035944c8119(slot) {
    return (0, $fx4gX.default)("MuiButton", slot);
}
const $98f4f30a7ccae6ba$var$buttonClasses = (0, $auO16.default)("MuiButton", [
    "root",
    "text",
    "textInherit",
    "textPrimary",
    "textSecondary",
    "textSuccess",
    "textError",
    "textInfo",
    "textWarning",
    "outlined",
    "outlinedInherit",
    "outlinedPrimary",
    "outlinedSecondary",
    "outlinedSuccess",
    "outlinedError",
    "outlinedInfo",
    "outlinedWarning",
    "contained",
    "containedInherit",
    "containedPrimary",
    "containedSecondary",
    "containedSuccess",
    "containedError",
    "containedInfo",
    "containedWarning",
    "disableElevation",
    "focusVisible",
    "disabled",
    "colorInherit",
    "textSizeSmall",
    "textSizeMedium",
    "textSizeLarge",
    "outlinedSizeSmall",
    "outlinedSizeMedium",
    "outlinedSizeLarge",
    "containedSizeSmall",
    "containedSizeMedium",
    "containedSizeLarge",
    "sizeMedium",
    "sizeSmall",
    "sizeLarge",
    "fullWidth",
    "startIcon",
    "endIcon",
    "iconSizeSmall",
    "iconSizeMedium",
    "iconSizeLarge"
]);
var $98f4f30a7ccae6ba$export$2e2bcd8739ae039 = $98f4f30a7ccae6ba$var$buttonClasses;



var $4YNlq = parcelRequire("4YNlq");
/**
 * @ignore - internal component.
 */ const $b7fbb8cf7b45d098$var$ButtonGroupContext = /*#__PURE__*/ $4YNlq.createContext({});
var $b7fbb8cf7b45d098$export$2e2bcd8739ae039 = $b7fbb8cf7b45d098$var$ButtonGroupContext;



var $4YNlq = parcelRequire("4YNlq");
/**
 * @ignore - internal component.
 */ const $17eb6b9b1624ec87$var$ButtonGroupButtonContext = /*#__PURE__*/ $4YNlq.createContext(undefined);
var $17eb6b9b1624ec87$export$2e2bcd8739ae039 = $17eb6b9b1624ec87$var$ButtonGroupButtonContext;



var $izf4p = parcelRequire("izf4p");
"use client";
const $2fd024bf1bf3be5d$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $2fd024bf1bf3be5d$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `${variant}${(0, $2qCAA.default)(color)}`,
            `size${(0, $2qCAA.default)(size)}`,
            `${variant}Size${(0, $2qCAA.default)(size)}`,
            color === "inherit" && "colorInherit",
            disableElevation && "disableElevation",
            fullWidth && "fullWidth"
        ],
        label: [
            "label"
        ],
        startIcon: [
            "startIcon",
            `iconSize${(0, $2qCAA.default)(size)}`
        ],
        endIcon: [
            "endIcon",
            `iconSize${(0, $2qCAA.default)(size)}`
        ]
    };
    const composedClasses = (0, $9JdRu.default)(slots, (0, $98f4f30a7ccae6ba$export$5a6f9035944c8119), classes);
    return (0, $lzDk3.default)({}, classes, composedClasses);
};
const $2fd024bf1bf3be5d$var$commonIconStyles = (ownerState)=>(0, $lzDk3.default)({}, ownerState.size === "small" && {
        "& > *:nth-of-type(1)": {
            fontSize: 18
        }
    }, ownerState.size === "medium" && {
        "& > *:nth-of-type(1)": {
            fontSize: 20
        }
    }, ownerState.size === "large" && {
        "& > *:nth-of-type(1)": {
            fontSize: 22
        }
    });
const $2fd024bf1bf3be5d$var$ButtonRoot = (0, $JdaC3.default)((0, $7e17388639953587$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $JdaC3.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $2qCAA.default)(ownerState.color)}`],
            styles[`size${(0, $2qCAA.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $2qCAA.default)(ownerState.size)}`],
            ownerState.color === "inherit" && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === "light" ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $lzDk3.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: "6px 16px",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            "background-color",
            "box-shadow",
            "border-color",
            "color"
        ], {
            duration: theme.transitions.duration.short
        }),
        "&:hover": (0, $lzDk3.default)({
            textDecoration: "none",
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $309LR.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $309LR.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $309LR.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }, ownerState.variant === "contained" && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        "&:active": (0, $lzDk3.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $98f4f30a7ccae6ba$export$2e2bcd8739ae039).focusVisible}`]: (0, $lzDk3.default)({}, ownerState.variant === "contained" && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $98f4f30a7ccae6ba$export$2e2bcd8739ae039).disabled}`]: (0, $lzDk3.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === "outlined" && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === "contained" && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === "text" && {
        padding: "6px 8px"
    }, ownerState.variant === "text" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === "outlined" && {
        padding: "5px 15px",
        border: "1px solid currentColor"
    }, ownerState.variant === "outlined" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $309LR.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === "contained" && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === "contained" && ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === "inherit" && {
        color: "inherit",
        borderColor: "currentColor"
    }, ownerState.size === "small" && ownerState.variant === "text" && {
        padding: "4px 5px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "text" && {
        padding: "8px 11px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        padding: "3px 9px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "outlined" && {
        padding: "7px 21px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === "small" && ownerState.variant === "contained" && {
        padding: "4px 10px",
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === "large" && ownerState.variant === "contained" && {
        padding: "8px 22px",
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: "100%"
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: "none",
        "&:hover": {
            boxShadow: "none"
        },
        [`&.${(0, $98f4f30a7ccae6ba$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: "none"
        },
        "&:active": {
            boxShadow: "none"
        },
        [`&.${(0, $98f4f30a7ccae6ba$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: "none"
        }
    });
const $2fd024bf1bf3be5d$var$ButtonStartIcon = (0, $JdaC3.default)("span", {
    name: "MuiButton",
    slot: "StartIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $2qCAA.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "inherit",
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === "small" && {
        marginLeft: -2
    }, $2fd024bf1bf3be5d$var$commonIconStyles(ownerState)));
const $2fd024bf1bf3be5d$var$ButtonEndIcon = (0, $JdaC3.default)("span", {
    name: "MuiButton",
    slot: "EndIcon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $2qCAA.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "inherit",
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === "small" && {
        marginRight: -2
    }, $2fd024bf1bf3be5d$var$commonIconStyles(ownerState)));
const $2fd024bf1bf3be5d$var$Button = /*#__PURE__*/ $4YNlq.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $4YNlq.useContext((0, $b7fbb8cf7b45d098$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $4YNlq.useContext((0, $17eb6b9b1624ec87$export$2e2bcd8739ae039));
    const resolvedProps = (0, $ckn1w.default)(contextProps, inProps);
    const props = (0, $4Q3YJ.default)({
        props: resolvedProps,
        name: "MuiButton"
    });
    const { children: children, color: color = "primary", component: component = "button", className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = "medium", startIcon: startIconProp, type: type, variant: variant = "text" } = props, other = (0, $g54n0.default)(props, $2fd024bf1bf3be5d$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $2fd024bf1bf3be5d$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $izf4p.jsx)($2fd024bf1bf3be5d$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $izf4p.jsx)($2fd024bf1bf3be5d$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || "";
    return /*#__PURE__*/ (0, $izf4p.jsxs)($2fd024bf1bf3be5d$var$ButtonRoot, (0, $lzDk3.default)({
        ownerState: ownerState,
        className: (0, $fQQpK.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $fQQpK.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $2fd024bf1bf3be5d$export$2e2bcd8739ae039 = $2fd024bf1bf3be5d$var$Button;




var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $1f0ab567ae2c5a87$export$964336739a8c7119(slot) {
    return (0, $fx4gX.default)("MuiCardContent", slot);
}
const $1f0ab567ae2c5a87$var$cardContentClasses = (0, $auO16.default)("MuiCardContent", [
    "root"
]);
var $1f0ab567ae2c5a87$export$2e2bcd8739ae039 = $1f0ab567ae2c5a87$var$cardContentClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $0ba30a51ef560ecb$var$_excluded = [
    "className",
    "component"
];
const $0ba30a51ef560ecb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $1f0ab567ae2c5a87$export$964336739a8c7119), classes);
};
const $0ba30a51ef560ecb$var$CardContentRoot = (0, $JdaC3.default)("div", {
    name: "MuiCardContent",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        "&:last-child": {
            paddingBottom: 24
        }
    };
});
const $0ba30a51ef560ecb$var$CardContent = /*#__PURE__*/ $4YNlq.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiCardContent"
    });
    const { className: className, component: component = "div" } = props, other = (0, $g54n0.default)(props, $0ba30a51ef560ecb$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        component: component
    });
    const classes = $0ba30a51ef560ecb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($0ba30a51ef560ecb$var$CardContentRoot, (0, $lzDk3.default)({
        as: component,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $0ba30a51ef560ecb$export$2e2bcd8739ae039 = $0ba30a51ef560ecb$var$CardContent;




var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");




"use client";
const $cd5c7983105a1366$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
function $cd5c7983105a1366$export$1e5c9e6e4e15efe3(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $g54n0.default)(parameters, $cd5c7983105a1366$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $2961338a1e0cb3f1$export$308c24034cde71de)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $31f260d5a52cc518$export$b01d1e419b049226)((0, $lzDk3.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $b8794f95cd574d7f$export$b089efb01a7bdf50)(elementType, (0, $lzDk3.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $064e4781f6b245d8$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

function $140200a3441aaff2$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $a28ff53af2082fda$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


function $33a8375cbc96cc03$export$2e2bcd8739ae039(node) {
    const doc = (0, $140200a3441aaff2$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


// Is a vertical scrollbar displayed?
function $7f07cbdceb970c06$var$isOverflowing(container) {
    const doc = (0, $140200a3441aaff2$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $33a8375cbc96cc03$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $7f07cbdceb970c06$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute("aria-hidden", "true");
    else element.removeAttribute("aria-hidden");
}
function $7f07cbdceb970c06$var$getPaddingRight(element) {
    return parseInt((0, $33a8375cbc96cc03$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $7f07cbdceb970c06$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        "TEMPLATE",
        "SCRIPT",
        "STYLE",
        "LINK",
        "MAP",
        "META",
        "NOSCRIPT",
        "PICTURE",
        "COL",
        "COLGROUP",
        "PARAM",
        "SLOT",
        "SOURCE",
        "TRACK"
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === "INPUT" && element.getAttribute("type") === "hidden";
    return isForbiddenTagName || isInputHidden;
}
function $7f07cbdceb970c06$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$7f07cbdceb970c06$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $7f07cbdceb970c06$export$e1bd0c6150f13d96(element, show);
    });
}
function $7f07cbdceb970c06$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $7f07cbdceb970c06$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($7f07cbdceb970c06$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $a28ff53af2082fda$export$2e2bcd8739ae039)((0, $140200a3441aaff2$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: "padding-right",
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$7f07cbdceb970c06$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $140200a3441aaff2$export$2e2bcd8739ae039)(container).querySelectorAll(".mui-fixed");
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: "padding-right",
                    el: element
                });
                element.style.paddingRight = `${$7f07cbdceb970c06$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $140200a3441aaff2$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $33a8375cbc96cc03$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === "HTML" && containerWindow.getComputedStyle(parent).overflowY === "scroll" ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: "overflow",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: "overflow-x",
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: "overflow-y",
            el: scrollContainer
        });
        scrollContainer.style.overflow = "hidden";
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $7f07cbdceb970c06$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute("aria-hidden") === "true") hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $7f07cbdceb970c06$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $7f07cbdceb970c06$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $7f07cbdceb970c06$var$getHiddenSiblings(container);
        $7f07cbdceb970c06$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $7f07cbdceb970c06$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $7f07cbdceb970c06$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $7f07cbdceb970c06$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $7f07cbdceb970c06$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $7f07cbdceb970c06$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $7f07cbdceb970c06$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $7f07cbdceb970c06$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}


"use client";
function $c03cfab5e7cd4cfe$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
function $c03cfab5e7cd4cfe$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty("in") : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $c03cfab5e7cd4cfe$var$defaultManager = new (0, $7f07cbdceb970c06$export$ce11c4ecd08cea67)();
function $c03cfab5e7cd4cfe$export$33ffd74ebf07f060(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $c03cfab5e7cd4cfe$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $4YNlq.useRef({});
    const mountNodeRef = $4YNlq.useRef(null);
    const modalRef = $4YNlq.useRef(null);
    const handleRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $4YNlq.useState(!open);
    const hasTransition = $c03cfab5e7cd4cfe$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters["aria-hidden"] === "false" || parameters["aria-hidden"] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $140200a3441aaff2$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $c03cfab5e7cd4cfe$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $4YNlq.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $7f07cbdceb970c06$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $4YNlq.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $4YNlq.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $4YNlq.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== "Escape" || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, "escapeKeyDown");
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, "backdropClick");
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $2dc08db820ff4928$export$24d5698b57eff81c)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $lzDk3.default)({}, propsEventHandlers, otherHandlers);
        return (0, $lzDk3.default)({
            role: "presentation"
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $lzDk3.default)({
            "aria-hidden": true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $064e4781f6b245d8$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $064e4781f6b245d8$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}



var $9JdRu = parcelRequire("9JdRu");

var $4YNlq = parcelRequire("4YNlq");



var $izf4p = parcelRequire("izf4p");
"use client";
// Inspired by https://github.com/focus-trap/tabbable
const $4a7d398b6a5739b9$var$candidatesSelector = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
].join(",");
function $4a7d398b6a5739b9$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute("tabindex") || "", 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === "true" || (node.nodeName === "AUDIO" || node.nodeName === "VIDEO" || node.nodeName === "DETAILS") && node.getAttribute("tabindex") === null) return 0;
    return node.tabIndex;
}
function $4a7d398b6a5739b9$var$isNonTabbableRadio(node) {
    if (node.tagName !== "INPUT" || node.type !== "radio") return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $4a7d398b6a5739b9$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === "INPUT" && node.type === "hidden" || $4a7d398b6a5739b9$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $4a7d398b6a5739b9$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($4a7d398b6a5739b9$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $4a7d398b6a5739b9$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$4a7d398b6a5739b9$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $4a7d398b6a5739b9$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base-ui/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base-ui/react-focus-trap/components-api/#focus-trap)
 */ function $4a7d398b6a5739b9$export$34eba2437817a67b(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $4a7d398b6a5739b9$var$defaultGetTabbable, isEnabled: isEnabled = $4a7d398b6a5739b9$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $4YNlq.useRef(false);
    const sentinelStart = $4YNlq.useRef(null);
    const sentinelEnd = $4YNlq.useRef(null);
    const nodeToRestore = $4YNlq.useRef(null);
    const reactFocusEventTarget = $4YNlq.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $4YNlq.useRef(false);
    const rootRef = $4YNlq.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $4YNlq.useRef(null);
    $4YNlq.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $4YNlq.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $140200a3441aaff2$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute("tabIndex")) rootRef.current.setAttribute("tabIndex", "-1");
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $4YNlq.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $140200a3441aaff2$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== "Tab") return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === "Tab");
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== "string" && typeof focusPrevious !== "string") {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener("focusin", contain);
        doc.addEventListener("keydown", loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === "BODY") contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener("focusin", contain);
            doc.removeEventListener("keydown", loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $4YNlq.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}



var $4YNlq = parcelRequire("4YNlq");




var $izf4p = parcelRequire("izf4p");
"use client";
function $8745ba6e45b81808$var$getContainer(container) {
    return typeof container === "function" ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */ const $8745ba6e45b81808$export$602eac185826482c = /*#__PURE__*/ $4YNlq.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $4YNlq.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(/*#__PURE__*/ $4YNlq.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($8745ba6e45b81808$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $0aeecae1008ec90a$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $0aeecae1008ec90a$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $4YNlq.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $4YNlq.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $izf4p.jsx)($4YNlq.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $izf4p.jsx)($4YNlq.Fragment, {
        children: mountNode ? /*#__PURE__*/ $330fb34df360181f$exports.createPortal(children, mountNode) : mountNode
    });
});



var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $g54n0 = parcelRequire("g54n0");

var $GxpsF = parcelRequire("GxpsF");


var $4YNlq = parcelRequire("4YNlq");

var $4defaa38fb9719fd$export$2e2bcd8739ae039 = {
    disabled: false
};




var $ksBFy = parcelRequire("ksBFy");
var $34dffbbb6f3c8e6c$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $c4b9c02358af45ec$export$bb38bb9a1161268 = "unmounted";
var $c4b9c02358af45ec$export$84cbff306f539230 = "exited";
var $c4b9c02358af45ec$export$df38205c966be359 = "entering";
var $c4b9c02358af45ec$export$78e9e6e3e014d60a = "entered";
var $c4b9c02358af45ec$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $c4b9c02358af45ec$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $GxpsF.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $c4b9c02358af45ec$export$84cbff306f539230;
                _this.appearStatus = $c4b9c02358af45ec$export$df38205c966be359;
            } else initialStatus = $c4b9c02358af45ec$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $c4b9c02358af45ec$export$bb38bb9a1161268;
        else initialStatus = $c4b9c02358af45ec$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $c4b9c02358af45ec$export$bb38bb9a1161268) return {
            status: $c4b9c02358af45ec$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $c4b9c02358af45ec$export$df38205c966be359 && status !== $c4b9c02358af45ec$export$78e9e6e3e014d60a) nextStatus = $c4b9c02358af45ec$export$df38205c966be359;
            } else if (status === $c4b9c02358af45ec$export$df38205c966be359 || status === $c4b9c02358af45ec$export$78e9e6e3e014d60a) nextStatus = $c4b9c02358af45ec$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $c4b9c02358af45ec$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($330fb34df360181f$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $34dffbbb6f3c8e6c$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $c4b9c02358af45ec$export$84cbff306f539230) this.setState({
            status: $c4b9c02358af45ec$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($330fb34df360181f$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $4defaa38fb9719fd$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $c4b9c02358af45ec$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $c4b9c02358af45ec$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $c4b9c02358af45ec$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($330fb34df360181f$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $4defaa38fb9719fd$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $c4b9c02358af45ec$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $c4b9c02358af45ec$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $c4b9c02358af45ec$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($330fb34df360181f$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $c4b9c02358af45ec$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $g54n0.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement((0, $ksBFy.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).Component);
$c4b9c02358af45ec$var$Transition.contextType = (0, $ksBFy.default);
$c4b9c02358af45ec$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $c4b9c02358af45ec$var$noop() {}
$c4b9c02358af45ec$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $c4b9c02358af45ec$var$noop,
    onEntering: $c4b9c02358af45ec$var$noop,
    onEntered: $c4b9c02358af45ec$var$noop,
    onExit: $c4b9c02358af45ec$var$noop,
    onExiting: $c4b9c02358af45ec$var$noop,
    onExited: $c4b9c02358af45ec$var$noop
};
$c4b9c02358af45ec$var$Transition.UNMOUNTED = $c4b9c02358af45ec$export$bb38bb9a1161268;
$c4b9c02358af45ec$var$Transition.EXITED = $c4b9c02358af45ec$export$84cbff306f539230;
$c4b9c02358af45ec$var$Transition.ENTERING = $c4b9c02358af45ec$export$df38205c966be359;
$c4b9c02358af45ec$var$Transition.ENTERED = $c4b9c02358af45ec$export$78e9e6e3e014d60a;
$c4b9c02358af45ec$var$Transition.EXITING = $c4b9c02358af45ec$export$4aacc83d4d59139f;
var $c4b9c02358af45ec$export$2e2bcd8739ae039 = $c4b9c02358af45ec$var$Transition;



parcelRequire("4YNlq");

var $6SUx4 = parcelRequire("6SUx4");

var $1w9Ux = parcelRequire("1w9Ux");

var $dRtc1 = parcelRequire("dRtc1");
"use client";
function $b637578efda8bead$export$2e2bcd8739ae039() {
    const theme = (0, $6SUx4.default)((0, $1w9Ux.default));
    return theme[0, $dRtc1.default] || theme;
}


const $2bb0265716437a48$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $2bb0265716437a48$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === "object" ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $izf4p = parcelRequire("izf4p");
"use client";
const $802113259dde0d55$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $802113259dde0d55$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $802113259dde0d55$var$Fade = /*#__PURE__*/ $4YNlq.forwardRef(function Fade(props, ref) {
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $c4b9c02358af45ec$export$2e2bcd8739ae039) } = props, other = (0, $g54n0.default)(props, $802113259dde0d55$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $4YNlq.useRef(null);
    const handleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $2bb0265716437a48$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $2bb0265716437a48$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $2bb0265716437a48$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
        node.style.transition = theme.transitions.create("opacity", transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $izf4p.jsx)(TransitionComponent, (0, $lzDk3.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $4YNlq.cloneElement(children, (0, $lzDk3.default)({
                style: (0, $lzDk3.default)({
                    opacity: 0,
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $802113259dde0d55$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $802113259dde0d55$export$2e2bcd8739ae039 = $802113259dde0d55$var$Fade;



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $2d8cff5ea507170b$export$9927a91fd93152bd(slot) {
    return (0, $fx4gX.default)("MuiBackdrop", slot);
}
const $2d8cff5ea507170b$var$backdropClasses = (0, $auO16.default)("MuiBackdrop", [
    "root",
    "invisible"
]);
var $2d8cff5ea507170b$export$2e2bcd8739ae039 = $2d8cff5ea507170b$var$backdropClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $6c2766c4f601db8a$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $6c2766c4f601db8a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            "root",
            invisible && "invisible"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $2d8cff5ea507170b$export$9927a91fd93152bd), classes);
};
const $6c2766c4f601db8a$var$BackdropRoot = (0, $JdaC3.default)("div", {
    name: "MuiBackdrop",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        position: "fixed",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        WebkitTapHighlightColor: "transparent"
    }, ownerState.invisible && {
        backgroundColor: "transparent"
    }));
const $6c2766c4f601db8a$var$Backdrop = /*#__PURE__*/ $4YNlq.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiBackdrop"
    });
    const { children: children, className: className, component: component = "div", components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $802113259dde0d55$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $g54n0.default)(props, $6c2766c4f601db8a$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $6c2766c4f601db8a$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $izf4p.jsx)(TransitionComponent, (0, $lzDk3.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)($6c2766c4f601db8a$var$BackdropRoot, (0, $lzDk3.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $fQQpK.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $lzDk3.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $6c2766c4f601db8a$export$2e2bcd8739ae039 = $6c2766c4f601db8a$var$Backdrop;



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $754b6bf4a617e2e8$export$67960e22b12a638d(slot) {
    return (0, $fx4gX.default)("MuiModal", slot);
}
const $754b6bf4a617e2e8$var$modalClasses = (0, $auO16.default)("MuiModal", [
    "root",
    "hidden",
    "backdrop"
]);
var $754b6bf4a617e2e8$export$2e2bcd8739ae039 = $754b6bf4a617e2e8$var$modalClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $0402d29e5e243355$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $0402d29e5e243355$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            !open && exited && "hidden"
        ],
        backdrop: [
            "backdrop"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $754b6bf4a617e2e8$export$67960e22b12a638d), classes);
};
const $0402d29e5e243355$var$ModalRoot = (0, $JdaC3.default)("div", {
    name: "MuiModal",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        position: "fixed",
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: "hidden"
    }));
const $0402d29e5e243355$var$ModalBackdrop = (0, $JdaC3.default)((0, $6c2766c4f601db8a$export$2e2bcd8739ae039), {
    name: "MuiModal",
    slot: "Backdrop",
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $0402d29e5e243355$var$Modal = /*#__PURE__*/ $4YNlq.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $4Q3YJ.default)({
        name: "MuiModal",
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $0402d29e5e243355$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $g54n0.default)(props, $0402d29e5e243355$var$_excluded);
    const propsWithDefaults = (0, $lzDk3.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $c03cfab5e7cd4cfe$export$33ffd74ebf07f060)((0, $lzDk3.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $lzDk3.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $0402d29e5e243355$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = "-1";
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $0402d29e5e243355$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $fQQpK.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $lzDk3.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $fQQpK.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $8745ba6e45b81808$export$602eac185826482c), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $izf4p.jsxs)(RootSlot, (0, $lzDk3.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $izf4p.jsx)(BackdropSlot, (0, $lzDk3.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $izf4p.jsx)((0, $4a7d398b6a5739b9$export$34eba2437817a67b), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $4YNlq.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $0402d29e5e243355$export$2e2bcd8739ae039 = $0402d29e5e243355$var$Modal;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");

var $8zt0d = parcelRequire("8zt0d");

var $2qCAA = parcelRequire("2qCAA");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $JdaC3 = parcelRequire("JdaC3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $612d7c6f0ee9801a$export$29cad1383b3f235d(slot) {
    return (0, $fx4gX.default)("MuiCircularProgress", slot);
}
const $612d7c6f0ee9801a$var$circularProgressClasses = (0, $auO16.default)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
var $612d7c6f0ee9801a$export$2e2bcd8739ae039 = $612d7c6f0ee9801a$var$circularProgressClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $ab006c7eeb942377$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $ab006c7eeb942377$var$_ = (t)=>t, $ab006c7eeb942377$var$_t, $ab006c7eeb942377$var$_t2, $ab006c7eeb942377$var$_t3, $ab006c7eeb942377$var$_t4;
const $ab006c7eeb942377$var$SIZE = 44;
const $ab006c7eeb942377$var$circularRotateKeyframe = (0, $8zt0d.keyframes)($ab006c7eeb942377$var$_t || ($ab006c7eeb942377$var$_t = $ab006c7eeb942377$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $ab006c7eeb942377$var$circularDashKeyframe = (0, $8zt0d.keyframes)($ab006c7eeb942377$var$_t2 || ($ab006c7eeb942377$var$_t2 = $ab006c7eeb942377$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $ab006c7eeb942377$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            `color${(0, $2qCAA.default)(color)}`
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            `circle${(0, $2qCAA.default)(variant)}`,
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $612d7c6f0ee9801a$export$29cad1383b3f235d), classes);
};
const $ab006c7eeb942377$var$CircularProgressRoot = (0, $JdaC3.default)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $2qCAA.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $lzDk3.default)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && (0, $8zt0d.css)($ab006c7eeb942377$var$_t3 || ($ab006c7eeb942377$var$_t3 = $ab006c7eeb942377$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $ab006c7eeb942377$var$circularRotateKeyframe));
const $ab006c7eeb942377$var$CircularProgressSVG = (0, $JdaC3.default)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: (props, styles)=>styles.svg
})({
    display: "block" // Keeps the progress centered
});
const $ab006c7eeb942377$var$CircularProgressCircle = (0, $JdaC3.default)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $2qCAA.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $lzDk3.default)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0, $8zt0d.css)($ab006c7eeb942377$var$_t4 || ($ab006c7eeb942377$var$_t4 = $ab006c7eeb942377$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $ab006c7eeb942377$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $ab006c7eeb942377$var$CircularProgress = /*#__PURE__*/ $4YNlq.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    const { className: className, color: color = "primary", disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = "indeterminate" } = props, other = (0, $g54n0.default)(props, $ab006c7eeb942377$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $ab006c7eeb942377$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === "determinate") {
        const circumference = 2 * Math.PI * (($ab006c7eeb942377$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0, $izf4p.jsx)($ab006c7eeb942377$var$CircularProgressRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        style: (0, $lzDk3.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)($ab006c7eeb942377$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$ab006c7eeb942377$var$SIZE / 2} ${$ab006c7eeb942377$var$SIZE / 2} ${$ab006c7eeb942377$var$SIZE} ${$ab006c7eeb942377$var$SIZE}`,
            children: /*#__PURE__*/ (0, $izf4p.jsx)($ab006c7eeb942377$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $ab006c7eeb942377$var$SIZE,
                cy: $ab006c7eeb942377$var$SIZE,
                r: ($ab006c7eeb942377$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $ab006c7eeb942377$export$2e2bcd8739ae039 = $ab006c7eeb942377$var$CircularProgress;




var $izf4p = parcelRequire("izf4p");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $4YNlq = parcelRequire("4YNlq");


var $20TjU = parcelRequire("20TjU");

var $7DeAN = parcelRequire("7DeAN");
"use client";
/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `MediaQueryList` from lib.dom.d.ts instead.
 */ /**
 * @deprecated Not used internally. Use `(event: MediaQueryListEvent) => void` instead.
 */ function $9648db6b3d91d1c6$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $4YNlq.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        let active = true;
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) setMatch(queryList.matches);
        };
        updateMatch();
        // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return ()=>{
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
const $9648db6b3d91d1c6$var$maybeReactUseSyncExternalStore = $4YNlq.useSyncExternalStore;
function $9648db6b3d91d1c6$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $4YNlq.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $4YNlq.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $4YNlq.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return ()=>{
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $9648db6b3d91d1c6$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $9648db6b3d91d1c6$export$2e2bcd8739ae039(queryInput, options = {}) {
    const theme = (0, $7DeAN.default)();
    // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    const supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
    const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $20TjU.default)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    });
    let query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, "");
    // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    const useMediaQueryImplementation = $9648db6b3d91d1c6$var$maybeReactUseSyncExternalStore !== undefined ? $9648db6b3d91d1c6$var$useMediaQueryNew : $9648db6b3d91d1c6$var$useMediaQueryOld;
    const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    return match;
}



var $4Q3YJ = parcelRequire("4Q3YJ");


var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $3iM0v = parcelRequire("3iM0v");


var $3iM0v = parcelRequire("3iM0v");
const $9ef1e9faa9036f72$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object
]);
var $9ef1e9faa9036f72$export$2e2bcd8739ae039 = $9ef1e9faa9036f72$var$refType;



var $g54n0 = parcelRequire("g54n0");
const $a7f52c7c1125a3f0$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $a7f52c7c1125a3f0$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views != null ? views : defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error("MUI: The `views` prop must contain at least one view");
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $5605199c124089a3$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, utils: utils, timezone: timezone })=>{
    const today = utils.startOfDay(utils.dateWithTimezone(undefined, timezone));
    if (disablePast && utils.isBefore(minDate, today)) minDate = today;
    if (disableFuture && utils.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (utils.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (utils.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && utils.isAfter(forward, maxDate)) forward = null;
        if (backward && utils.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = utils.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = utils.addDays(backward, -1);
        }
    }
    return null;
};
const $5605199c124089a3$export$36ca889e039badd5 = (utils, value)=>value == null || !utils.isValid(value) ? null : value;
const $5605199c124089a3$export$eb73579ccade48fd = (utils, value, defaultValue)=>{
    if (value == null || !utils.isValid(value)) return defaultValue;
    return value;
};
const $5605199c124089a3$export$8fabf9a4cbada414 = (utils, a, b)=>{
    if (!utils.isValid(a) && a != null && !utils.isValid(b) && b != null) return true;
    return utils.isEqual(a, b);
};
const $5605199c124089a3$export$62591b96a734eacd = (utils, year)=>{
    const firstMonth = utils.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(utils.addMonths(prevMonth, 1));
    }
    return months;
};
const $5605199c124089a3$export$a98b123b8f29e004 = (utils, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = utils.setHours(mergedDate, utils.getHours(timeParam));
    mergedDate = utils.setMinutes(mergedDate, utils.getMinutes(timeParam));
    mergedDate = utils.setSeconds(mergedDate, utils.getSeconds(timeParam));
    return mergedDate;
};
const $5605199c124089a3$export$1118e4272ea1e258 = (utils, timezone, valueType)=>valueType === "date" ? utils.startOfDay(utils.dateWithTimezone(undefined, timezone)) : utils.dateWithTimezone(undefined, timezone);
const $5605199c124089a3$export$fae94c0a662107ef = (utils, meridiem)=>{
    const date = utils.setHours(utils.date(), meridiem === "am" ? 2 : 14);
    return utils.format(date, "meridiem");
};
const $5605199c124089a3$var$dateViews = [
    "year",
    "month",
    "day"
];
const $5605199c124089a3$export$b32dfef9f07dea64 = (view)=>$5605199c124089a3$var$dateViews.includes(view);
const $5605199c124089a3$export$bb1c921f313ec928 = (utils, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $a7f52c7c1125a3f0$export$f07872cd524bec98)(views, [
        "year"
    ])) return formats.year;
    if ((0, $a7f52c7c1125a3f0$export$f07872cd524bec98)(views, [
        "month"
    ])) return formats.month;
    if ((0, $a7f52c7c1125a3f0$export$f07872cd524bec98)(views, [
        "day"
    ])) return formats.dayOfMonth;
    if ((0, $a7f52c7c1125a3f0$export$f07872cd524bec98)(views, [
        "month",
        "year"
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $a7f52c7c1125a3f0$export$f07872cd524bec98)(views, [
        "day",
        "month"
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(utils.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $5605199c124089a3$export$24c38139da66592d = (utils, date)=>{
    const start = utils.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>utils.addDays(start, diff));
};



const $3b49d946f7c9f4c7$var$timeViews = [
    "hours",
    "minutes",
    "seconds"
];
const $3b49d946f7c9f4c7$export$8f04d380cefd5a0d = (view)=>$3b49d946f7c9f4c7$var$timeViews.includes(view);
const $3b49d946f7c9f4c7$export$a3328136ac50623d = (view)=>$3b49d946f7c9f4c7$var$timeViews.includes(view) || view === "meridiem";
const $3b49d946f7c9f4c7$export$c3352ead7b032236 = (date, utils)=>{
    if (!date) return null;
    return utils.getHours(date) >= 12 ? "pm" : "am";
};
const $3b49d946f7c9f4c7$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? "pm" : "am";
        if (currentMeridiem !== meridiem) return meridiem === "am" ? value - 12 : value + 12;
    }
    return value;
};
const $3b49d946f7c9f4c7$export$c368d4ff66779998 = (time, meridiem, ampm, utils)=>{
    const newHoursAmount = $3b49d946f7c9f4c7$export$4159dc823695870e(utils.getHours(time), meridiem, ampm);
    return utils.setHours(time, newHoursAmount);
};
const $3b49d946f7c9f4c7$export$888a1ce13aa61986 = (date, utils)=>{
    return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
};
const $3b49d946f7c9f4c7$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, utils)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return utils.isAfter(dateLeft, dateRight);
        return $3b49d946f7c9f4c7$export$888a1ce13aa61986(dateLeft, utils) > $3b49d946f7c9f4c7$export$888a1ce13aa61986(dateRight, utils);
    };
const $3b49d946f7c9f4c7$export$3a6776b3863772fe = (utils, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = utils.formats;
    if ((0, $a7f52c7c1125a3f0$export$f07872cd524bec98)(views, [
        "hours"
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $a7f52c7c1125a3f0$export$f07872cd524bec98)(views, [
        "minutes"
    ])) return formats.minutes;
    if ((0, $a7f52c7c1125a3f0$export$f07872cd524bec98)(views, [
        "seconds"
    ])) return formats.seconds;
    if ((0, $a7f52c7c1125a3f0$export$f07872cd524bec98)(views, [
        "minutes",
        "seconds"
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $a7f52c7c1125a3f0$export$f07872cd524bec98)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $05c56d59c112b284$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $05c56d59c112b284$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>{
        var _SECTION_TYPE_GRANULA;
        return (_SECTION_TYPE_GRANULA = $05c56d59c112b284$export$8f74e8f4ed8ae0ac[section.type]) != null ? _SECTION_TYPE_GRANULA : 1;
    }));
const $05c56d59c112b284$export$e7c8ae702868847 = (views)=>Math.max(...views.map((view)=>{
        var _SECTION_TYPE_GRANULA2;
        return (_SECTION_TYPE_GRANULA2 = $05c56d59c112b284$export$8f74e8f4ed8ae0ac[view]) != null ? _SECTION_TYPE_GRANULA2 : 1;
    }));
const $05c56d59c112b284$var$roundDate = (utils, granularity, date)=>{
    if (granularity === $05c56d59c112b284$export$8f74e8f4ed8ae0ac.year) return utils.startOfYear(date);
    if (granularity === $05c56d59c112b284$export$8f74e8f4ed8ae0ac.month) return utils.startOfMonth(date);
    if (granularity === $05c56d59c112b284$export$8f74e8f4ed8ae0ac.day) return utils.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $05c56d59c112b284$export$8f74e8f4ed8ae0ac.minutes) roundedDate = utils.setMinutes(roundedDate, 0);
    if (granularity < $05c56d59c112b284$export$8f74e8f4ed8ae0ac.seconds) roundedDate = utils.setSeconds(roundedDate, 0);
    if (granularity < $05c56d59c112b284$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = utils.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $05c56d59c112b284$export$6a31d56794238e4e = ({ props: props, utils: utils, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    var _props$disableIgnorin;
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $05c56d59c112b284$var$roundDate(utils, granularity, (0, $5605199c124089a3$export$1118e4272ea1e258)(utils, timezone));
    if (props.minDate != null && utils.isAfterDay(props.minDate, referenceDate)) referenceDate = $05c56d59c112b284$var$roundDate(utils, granularity, props.minDate);
    if (props.maxDate != null && utils.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $05c56d59c112b284$var$roundDate(utils, granularity, props.maxDate);
    const isAfter = (0, $3b49d946f7c9f4c7$export$fb87c80b35a46b89)((_props$disableIgnorin = props.disableIgnoringDatePartForTimeValidation) != null ? _props$disableIgnorin : false, utils);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $05c56d59c112b284$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $5605199c124089a3$export$a98b123b8f29e004)(utils, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $05c56d59c112b284$var$roundDate(utils, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $5605199c124089a3$export$a98b123b8f29e004)(utils, referenceDate, props.maxTime));
    return referenceDate;
};



var $lzDk3 = parcelRequire("lzDk3");

const $09f11305fc9004b5$export$2f3c5fac7a2a65f6 = (utils, formatToken)=>{
    const config = utils.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."
    ].join("\n"));
    if (typeof config === "string") return {
        type: config,
        contentType: config === "meridiem" ? "letter" : "digit",
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $09f11305fc9004b5$var$getDeltaFromKeyCode = (keyCode)=>{
    switch(keyCode){
        case "ArrowUp":
            return 1;
        case "ArrowDown":
            return -1;
        case "PageUp":
            return 5;
        case "PageDown":
            return -5;
        default:
            return 0;
    }
};
const $09f11305fc9004b5$export$c65c7173f879039f = (utils, timezone, format)=>{
    const elements = [];
    const now = utils.dateWithTimezone(undefined, timezone);
    const startDate = utils.startOfWeek(now);
    const endDate = utils.endOfWeek(now);
    let current = startDate;
    while(utils.isBefore(current, endDate)){
        elements.push(current);
        current = utils.addDays(current, 1);
    }
    return elements.map((weekDay)=>utils.formatByString(weekDay, format));
};
const $09f11305fc9004b5$export$3ee1e7e19c2b047a = (utils, timezone, sectionType, format)=>{
    switch(sectionType){
        case "month":
            return (0, $5605199c124089a3$export$62591b96a734eacd)(utils, utils.dateWithTimezone(undefined, timezone)).map((month)=>utils.formatByString(month, format));
        case "weekDay":
            return $09f11305fc9004b5$export$c65c7173f879039f(utils, timezone, format);
        case "meridiem":
            {
                const now = utils.dateWithTimezone(undefined, timezone);
                return [
                    utils.startOfDay(now),
                    utils.endOfDay(now)
                ].map((date)=>utils.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $09f11305fc9004b5$export$713c6d756c12fc27 = (utils, valueStr, size)=>{
    let cleanValueStr = valueStr;
    // Remove the leading zeros
    cleanValueStr = Number(cleanValueStr).toString();
    // Add enough leading zeros to fill the section
    while(cleanValueStr.length < size)cleanValueStr = `0${cleanValueStr}`;
    return cleanValueStr;
};
const $09f11305fc9004b5$export$ef88db4bceade9fd = (utils, timezone, value, sectionBoundaries, section)=>{
    if (section.type === "day" && section.contentType === "digit-with-letter") {
        const date = utils.setDate(sectionBoundaries.longestMonth, value);
        return utils.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    const valueStr = value.toString();
    if (section.hasLeadingZerosInInput) return $09f11305fc9004b5$export$713c6d756c12fc27(utils, valueStr, section.maxLength);
    return valueStr;
};
const $09f11305fc9004b5$export$5ed0f22513e58fe3 = (utils, timezone, section, keyCode, sectionsValueBoundaries, activeDate, stepsAttributes)=>{
    const delta = $09f11305fc9004b5$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === "Home";
    const isEnd = keyCode === "End";
    const shouldSetAbsolute = section.value === "" || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>$09f11305fc9004b5$export$ef88db4bceade9fd(utils, timezone, value, sectionBoundaries, section);
        const step = section.type === "minutes" && stepsAttributes != null && stepsAttributes.minutesStep ? stepsAttributes.minutesStep : 1;
        const currentSectionValue = parseInt(section.value, 10);
        let newSectionValueNumber = currentSectionValue + delta * step;
        if (shouldSetAbsolute) {
            if (section.type === "year" && !isEnd && !isStart) return utils.formatByString(utils.dateWithTimezone(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = $09f11305fc9004b5$export$3ee1e7e19c2b047a(utils, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + options.length + delta) % options.length;
        return options[newOptionIndex];
    };
    if (section.contentType === "digit" || section.contentType === "digit-with-letter") return adjustDigitSection();
    return adjustLetterSection();
};
const $09f11305fc9004b5$export$85daa91f6c6e875f = (section, target)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === "non-input" ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === "non-input" && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number(value).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        "input-rtl",
        "input-ltr"
    ].includes(target) && section.contentType === "digit" && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === "input-rtl") value = `\u2068${value}\u2069`;
    return value;
};
const $09f11305fc9004b5$export$cb0bbc88c7f09596 = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, "");
const $09f11305fc9004b5$export$8bb5d1c9951d10ca = (sections, isRTL)=>{
    let position = 0;
    let positionInInput = isRTL ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = $09f11305fc9004b5$export$85daa91f6c6e875f(section, isRTL ? "input-rtl" : "input-ltr");
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $09f11305fc9004b5$export$cb0bbc88c7f09596(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $09f11305fc9004b5$export$cb0bbc88c7f09596(renderedValue);
        const startInInput = positionInInput + renderedValue.indexOf(cleanedValue[0]) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $lzDk3.default)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $09f11305fc9004b5$var$getSectionPlaceholder = (utils, timezone, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case "year":
            return localeText.fieldYearPlaceholder({
                digitAmount: utils.formatByString(utils.dateWithTimezone(undefined, timezone), sectionFormat).length,
                format: sectionFormat
            });
        case "month":
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case "day":
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case "weekDay":
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case "hours":
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case "minutes":
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case "seconds":
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case "meridiem":
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $09f11305fc9004b5$export$2816862a602354ce = (utils, valueStr, currentFormat, newFormat)=>{
    return utils.formatByString(utils.parse(valueStr, currentFormat), newFormat);
};
const $09f11305fc9004b5$var$isFourDigitYearFormat = (utils, timezone, format)=>utils.formatByString(utils.dateWithTimezone(undefined, timezone), format).length === 4;
const $09f11305fc9004b5$export$78b5830e2dd2de49 = (utils, timezone, contentType, sectionType, format)=>{
    if (contentType !== "digit") return false;
    const now = utils.dateWithTimezone(undefined, timezone);
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case "year":
            {
                if ($09f11305fc9004b5$var$isFourDigitYearFormat(utils, timezone, format)) {
                    const formatted0001 = utils.formatByString(utils.setYear(now, 1), format);
                    return formatted0001 === "0001";
                }
                const formatted2001 = utils.formatByString(utils.setYear(now, 2001), format);
                return formatted2001 === "01";
            }
        case "month":
            return utils.formatByString(utils.startOfYear(now), format).length > 1;
        case "day":
            return utils.formatByString(utils.startOfMonth(now), format).length > 1;
        case "weekDay":
            return utils.formatByString(utils.startOfWeek(now), format).length > 1;
        case "hours":
            return utils.formatByString(utils.setHours(now, 1), format).length > 1;
        case "minutes":
            return utils.formatByString(utils.setMinutes(now, 1), format).length > 1;
        case "seconds":
            return utils.formatByString(utils.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error("Invalid section type");
    }
};
const $09f11305fc9004b5$var$getEscapedPartsFromFormat = (utils, format)=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = utils.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, "g");
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(format))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $09f11305fc9004b5$export$fd71d82fe42bada1 = (utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)=>{
    let startSeparator = "";
    const sections = [];
    const now = utils.date();
    const commitToken = (token)=>{
        if (token === "") return null;
        const sectionConfig = $09f11305fc9004b5$export$2f3c5fac7a2a65f6(utils, token);
        const hasLeadingZerosInFormat = $09f11305fc9004b5$export$78b5830e2dd2de49(utils, timezone, sectionConfig.contentType, sectionConfig.type, token);
        const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === "digit";
        const isValidDate = date != null && utils.isValid(date);
        let sectionValue = isValidDate ? utils.formatByString(date, token) : "";
        let maxLength = null;
        if (hasLeadingZerosInInput) {
            if (hasLeadingZerosInFormat) maxLength = sectionValue === "" ? utils.formatByString(now, token).length : sectionValue.length;
            else {
                if (sectionConfig.maxLength == null) throw new Error(`MUI: The token ${token} should have a 'maxDigitNumber' property on it's adapter`);
                maxLength = sectionConfig.maxLength;
                if (isValidDate) sectionValue = $09f11305fc9004b5$export$713c6d756c12fc27(utils, sectionValue, maxLength);
            }
        }
        sections.push((0, $lzDk3.default)({}, sectionConfig, {
            format: token,
            maxLength: maxLength,
            value: sectionValue,
            placeholder: $09f11305fc9004b5$var$getSectionPlaceholder(utils, timezone, localeText, sectionConfig, token),
            hasLeadingZeros: hasLeadingZerosInFormat,
            hasLeadingZerosInFormat: hasLeadingZerosInFormat,
            hasLeadingZerosInInput: hasLeadingZerosInInput,
            startSeparator: sections.length === 0 ? startSeparator : "",
            endSeparator: "",
            modified: false
        }));
        return null;
    };
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = utils.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = utils.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error("MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component");
    }
    const expandedFormat = nextFormat;
    // Get start/end indexes of escaped sections
    const escapedParts = $09f11305fc9004b5$var$getEscapedPartsFromFormat(utils, expandedFormat);
    // This RegExp test if the beginning of a string correspond to a supported token
    const isTokenStartRegExp = new RegExp(`^(${Object.keys(utils.formatTokenMap).sort((a, b)=>b.length - a.length) // Sort to put longest word first
    .join("|")})`, "g") // used to get access to lastIndex state
    ;
    let currentTokenValue = "";
    for(let i = 0; i < expandedFormat.length; i += 1){
        const escapedPartOfCurrentChar = escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
        const char = expandedFormat[i];
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const potentialToken = `${currentTokenValue}${expandedFormat.slice(i)}`;
        const regExpMatch = isTokenStartRegExp.test(potentialToken);
        if (!isEscapedChar && char.match(/([A-Za-z]+)/) && regExpMatch) {
            currentTokenValue = potentialToken.slice(0, isTokenStartRegExp.lastIndex);
            i += isTokenStartRegExp.lastIndex - 1;
        } else {
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.start) === i || (escapedPartOfCurrentChar == null ? void 0 : escapedPartOfCurrentChar.end) === i;
            if (!isEscapeBoundary) {
                commitToken(currentTokenValue);
                currentTokenValue = "";
                if (sections.length === 0) startSeparator += char;
                else sections[sections.length - 1].endSeparator += char;
            }
        }
    }
    commitToken(currentTokenValue);
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRTL && cleanedSeparator !== null && cleanedSeparator.includes(" ")) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === "spacious" && [
                "/",
                ".",
                "-"
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $09f11305fc9004b5$export$b0c1bfd065bfe742 = (utils, sections)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === "day");
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === "weekDay";
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($09f11305fc9004b5$export$85daa91f6c6e875f(section, "non-input"));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(" ");
    const dateWithoutSeparatorStr = sectionValues.join(" ");
    return utils.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $09f11305fc9004b5$export$e990c4332a617e3d = (sections, isRTL)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $09f11305fc9004b5$export$85daa91f6c6e875f(section, isRTL ? "input-rtl" : "input-ltr");
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join("");
    if (!isRTL) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $09f11305fc9004b5$export$360600f456ea7d5f = (utils, timezone)=>{
    const today = utils.dateWithTimezone(undefined, timezone);
    const endOfYear = utils.endOfYear(today);
    const endOfDay = utils.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $5605199c124089a3$export$62591b96a734eacd)(utils, today).reduce((acc, month)=>{
        const daysInMonth = utils.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $09f11305fc9004b5$var$isFourDigitYearFormat(utils, timezone, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: utils.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: currentDate != null && utils.isValid(currentDate) ? utils.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === "digit") {
                const daysInWeek = $09f11305fc9004b5$export$c65c7173f879039f(utils, timezone, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = utils.getHours(endOfDay);
            const hasMeridiem = utils.formatByString(utils.endOfDay(today), format) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number(utils.formatByString(utils.startOfDay(today), format))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: utils.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: utils.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $09f11305fc9004b5$var$warnedOnceInvalidSection = false;
const $09f11305fc9004b5$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $09f11305fc9004b5$var$transferDateSectionValue = (utils, timezone, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case "year":
            return utils.setYear(dateToTransferTo, utils.getYear(dateToTransferFrom));
        case "month":
            return utils.setMonth(dateToTransferTo, utils.getMonth(dateToTransferFrom));
        case "weekDay":
            {
                const formattedDaysInWeek = $09f11305fc9004b5$export$c65c7173f879039f(utils, timezone, section.format);
                const dayInWeekStrOfActiveDate = utils.formatByString(dateToTransferFrom, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return utils.addDays(dateToTransferFrom, diff);
            }
        case "day":
            return utils.setDate(dateToTransferTo, utils.getDate(dateToTransferFrom));
        case "meridiem":
            {
                const isAM = utils.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = utils.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return utils.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return utils.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case "hours":
            return utils.setHours(dateToTransferTo, utils.getHours(dateToTransferFrom));
        case "minutes":
            return utils.setMinutes(dateToTransferTo, utils.getMinutes(dateToTransferFrom));
        case "seconds":
            return utils.setSeconds(dateToTransferTo, utils.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $09f11305fc9004b5$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8
};
const $09f11305fc9004b5$export$6c6df982c77f60a9 = (utils, timezone, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$09f11305fc9004b5$var$reliableSectionModificationOrder[a.type] - $09f11305fc9004b5$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $09f11305fc9004b5$var$transferDateSectionValue(utils, timezone, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $09f11305fc9004b5$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().indexOf("android") > -1;
const $09f11305fc9004b5$export$7725fd6fe0a2aadf = (sections, isRTL)=>{
    const neighbors = {};
    if (!isRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>{
            var _section$endSeparator;
            return index >= groupedSectionsStart && ((_section$endSeparator = section.endSeparator) == null ? void 0 : _section$endSeparator.includes(" ")) && // Special case where the spaces were not there in the initial input
            section.endSeparator !== " / ";
        });
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};


const $20065d9808d6bf8a$var$_excluded = [
    "value",
    "referenceDate"
];
const $20065d9808d6bf8a$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $5605199c124089a3$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $g54n0.default)(_ref, $20065d9808d6bf8a$var$_excluded);
        if (value != null && params.utils.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $05c56d59c112b284$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $5605199c124089a3$export$36ca889e039badd5),
    areValuesEqual: (0, $5605199c124089a3$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (utils, value)=>value == null || !utils.isValid(value) ? null : utils.getTimezone(value),
    setTimezone: (utils, timezone, value)=>value == null ? null : utils.setTimezone(value, timezone)
};
const $20065d9808d6bf8a$export$b602c94f557316b4 = {
    updateReferenceValue: (utils, value, prevReferenceValue)=>value == null || !utils.isValid(value) ? prevReferenceValue : value,
    getSectionsFromValue: (utils, date, prevSections, isRTL, getSectionsFromDate)=>{
        const shouldReUsePrevDateSections = !utils.isValid(date) && !!prevSections;
        if (shouldReUsePrevDateSections) return prevSections;
        return (0, $09f11305fc9004b5$export$8bb5d1c9951d10ca)(getSectionsFromDate(date), isRTL);
    },
    getValueStrFromSections: (0, $09f11305fc9004b5$export$e990c4332a617e3d),
    getActiveDateManager: (utils, state)=>({
            date: state.value,
            referenceDate: state.referenceValue,
            getSections: (sections)=>sections,
            getNewValuesFromNewActiveDate: (newActiveDate)=>({
                    value: newActiveDate,
                    referenceValue: newActiveDate == null || !utils.isValid(newActiveDate) ? state.referenceValue : newActiveDate
                })
        }),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue)
};



var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $lzDk3 = parcelRequire("lzDk3");
const $71b286f78ebdd0ee$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $lzDk3.default)({}, pickersTranslations)
                }
            }
        }
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $08b62976979fbbb3$var$enUSPickers = {
    // Calendar navigation
    previousMonth: "Previous month",
    nextMonth: "Next month",
    // View navigation
    openPreviousView: "open previous view",
    openNextView: "open next view",
    calendarViewSwitchingButtonAriaLabel: (view)=>view === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
    // DateRange placeholders
    start: "Start",
    end: "End",
    // Action bar
    cancelButtonLabel: "Cancel",
    clearButtonLabel: "Clear",
    okButtonLabel: "OK",
    todayButtonLabel: "Today",
    // Toolbar titles
    datePickerToolbarTitle: "Select date",
    dateTimePickerToolbarTitle: "Select date & time",
    timePickerToolbarTitle: "Select time",
    dateRangePickerToolbarTitle: "Select date range",
    // Clock labels
    clockLabelText: (view, time, adapter)=>`Select ${view}. ${time === null ? "No time selected" : `Selected time is ${adapter.format(time, "fullTime")}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: "Week number",
    calendarWeekNumberHeaderText: "#",
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open picker labels
    openDatePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose date, selected date is ${utils.format(value, "fullDate")}` : "Choose date",
    openTimePickerDialogue: (value, utils)=>value !== null && utils.isValid(value) ? `Choose time, selected time is ${utils.format(value, "fullTime")}` : "Choose time",
    fieldClearLabel: "Clear value",
    // Table labels
    timeTableLabel: "pick time",
    dateTableLabel: "pick date",
    // Field section placeholders
    fieldYearPlaceholder: (params)=>"Y".repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === "letter" ? "MMMM" : "MM",
    fieldDayPlaceholder: ()=>"DD",
    fieldWeekDayPlaceholder: (params)=>params.contentType === "letter" ? "EEEE" : "EE",
    fieldHoursPlaceholder: ()=>"hh",
    fieldMinutesPlaceholder: ()=>"mm",
    fieldSecondsPlaceholder: ()=>"ss",
    fieldMeridiemPlaceholder: ()=>"aa"
};
const $08b62976979fbbb3$export$1af4c7e47ad72f44 = $08b62976979fbbb3$var$enUSPickers;
const $08b62976979fbbb3$export$137380d9ce54f7f = (0, $71b286f78ebdd0ee$export$67c96d35a1b010b3)($08b62976979fbbb3$var$enUSPickers);


const $9faaabe544d2b9ed$export$4b5a24245de9f7f9 = ()=>{
    const localization = $4YNlq.useContext((0, $f34cc3f354a72d02$export$544976378534cf9));
    if (localization === null) throw new Error([
        "MUI: Can not find the date and time pickers localization context.",
        "It looks like you forgot to wrap your component in LocalizationProvider.",
        "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"
    ].join("\n"));
    if (localization.utils === null) throw new Error([
        "MUI: Can not find the date and time pickers adapter from its localization context.",
        "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."
    ].join("\n"));
    const localeText = $4YNlq.useMemo(()=>(0, $lzDk3.default)({}, (0, $08b62976979fbbb3$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $4YNlq.useMemo(()=>(0, $lzDk3.default)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $9faaabe544d2b9ed$export$1163b47e39508a46 = ()=>$9faaabe544d2b9ed$export$4b5a24245de9f7f9().utils;
const $9faaabe544d2b9ed$export$7c38da3a2e90fa83 = ()=>$9faaabe544d2b9ed$export$4b5a24245de9f7f9().defaultDates;
const $9faaabe544d2b9ed$export$24fdeaa0f591a73e = ()=>$9faaabe544d2b9ed$export$4b5a24245de9f7f9().localeText;
const $9faaabe544d2b9ed$export$3a404aece3dff2fa = (timezone)=>{
    const utils = $9faaabe544d2b9ed$export$1163b47e39508a46();
    const now = $4YNlq.useRef();
    if (now.current === undefined) now.current = utils.dateWithTimezone(undefined, timezone);
    return now.current;
};





var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");



var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");


var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $0a681dd9d02d3403$export$b109c489973c3d80(slot) {
    return (0, $fx4gX.default)("MuiPickersToolbar", slot);
}
const $0a681dd9d02d3403$export$59f09e5e2b3d9913 = (0, $auO16.default)("MuiPickersToolbar", [
    "root",
    "content"
]);



var $izf4p = parcelRequire("izf4p");
const $dbddef6c8f2cfe01$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        content: [
            "content"
        ],
        penIconButton: [
            "penIconButton",
            isLandscape && "penIconButtonLandscape"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $0a681dd9d02d3403$export$b109c489973c3d80), classes);
};
const $dbddef6c8f2cfe01$var$PickersToolbarRoot = (0, $JdaC3.default)("div", {
    name: "MuiPickersToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
        padding: theme.spacing(2, 3)
    }, ownerState.isLandscape && {
        height: "auto",
        maxWidth: 160,
        padding: 16,
        justifyContent: "flex-start",
        flexWrap: "wrap"
    }));
const $dbddef6c8f2cfe01$var$PickersToolbarContent = (0, $JdaC3.default)("div", {
    name: "MuiPickersToolbar",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})(({ ownerState: ownerState })=>{
    var _ownerState$landscape;
    return {
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
        justifyContent: ownerState.isLandscape ? "flex-start" : "space-between",
        flexDirection: ownerState.isLandscape ? (_ownerState$landscape = ownerState.landscapeDirection) != null ? _ownerState$landscape : "column" : "row",
        flex: 1,
        alignItems: ownerState.isLandscape ? "flex-start" : "center"
    };
});
const $dbddef6c8f2cfe01$export$eb3c4d84783d6feb = /*#__PURE__*/ $4YNlq.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersToolbar"
    });
    const { children: children, className: className, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId } = props;
    const ownerState = props;
    const classes = $dbddef6c8f2cfe01$var$useUtilityClasses(ownerState);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $izf4p.jsxs)($dbddef6c8f2cfe01$var$PickersToolbarRoot, {
        ref: ref,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)($dbddef6c8f2cfe01$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            })
        ]
    });
});




var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $e088ab30efa6afa6$export$a1c3879af2c3b694(slot) {
    return (0, $fx4gX.default)("MuiDatePickerToolbar", slot);
}
const $e088ab30efa6afa6$export$2e35fa7d24ef4179 = (0, $auO16.default)("MuiDatePickerToolbar", [
    "root",
    "title"
]);




var $izf4p = parcelRequire("izf4p");
const $529ed7be62c882f7$var$_excluded = [
    "value",
    "isLandscape",
    "onChange",
    "toolbarFormat",
    "toolbarPlaceholder",
    "views",
    "className"
];
const $529ed7be62c882f7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        title: [
            "title"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $e088ab30efa6afa6$export$a1c3879af2c3b694), classes);
};
const $529ed7be62c882f7$var$DatePickerToolbarRoot = (0, $JdaC3.default)((0, $dbddef6c8f2cfe01$export$eb3c4d84783d6feb), {
    name: "MuiDatePickerToolbar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
const $529ed7be62c882f7$var$DatePickerToolbarTitle = (0, $JdaC3.default)((0, $af664934923ca384$export$2e2bcd8739ae039), {
    name: "MuiDatePickerToolbar",
    slot: "Title",
    overridesResolver: (_, styles)=>styles.title
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({}, ownerState.isLandscape && {
        margin: "auto 16px auto auto"
    }));
const $529ed7be62c882f7$export$21b7f8ea763109eb = /*#__PURE__*/ $4YNlq.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiDatePickerToolbar"
    });
    const { value: value, isLandscape: isLandscape, toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", views: views, className: className } = props, other = (0, $g54n0.default)(props, $529ed7be62c882f7$var$_excluded);
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const classes = $529ed7be62c882f7$var$useUtilityClasses(props);
    const dateText = $4YNlq.useMemo(()=>{
        if (!value) return toolbarPlaceholder;
        const formatFromViews = (0, $5605199c124089a3$export$bb1c921f313ec928)(utils, {
            format: toolbarFormat,
            views: views
        }, true);
        return utils.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        utils,
        views
    ]);
    const ownerState = props;
    return /*#__PURE__*/ (0, $izf4p.jsx)($529ed7be62c882f7$var$DatePickerToolbarRoot, (0, $lzDk3.default)({
        ref: ref,
        toolbarTitle: localeText.datePickerToolbarTitle,
        isLandscape: isLandscape,
        className: (0, $fQQpK.default)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)($529ed7be62c882f7$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: isLandscape ? "left" : "center",
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});



var $lzDk3 = parcelRequire("lzDk3");
const $42fcfbc058f0ed42$export$ee17bc394843b249 = (capitalizedObject)=>{
    if (capitalizedObject === undefined) return undefined;
    return Object.keys(capitalizedObject).reduce((acc, key)=>(0, $lzDk3.default)({}, acc, {
            [`${key.slice(0, 1).toLowerCase()}${key.slice(1)}`]: capitalizedObject[key]
        }), {});
};


function $c7db6fbef166611f$export$a552c17ed3587731(props, name) {
    var _themeProps$slots, _themeProps$disableFu, _themeProps$disablePa, _themeProps$slotProps;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const defaultDates = (0, $9faaabe544d2b9ed$export$7c38da3a2e90fa83)();
    const themeProps = (0, $4Q3YJ.default)({
        props: props,
        name: name
    });
    const localeText = $4YNlq.useMemo(()=>{
        var _themeProps$localeTex;
        if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) return themeProps.localeText;
        return (0, $lzDk3.default)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : (0, $42fcfbc058f0ed42$export$ee17bc394843b249)(themeProps.components);
    return (0, $lzDk3.default)({}, themeProps, {
        localeText: localeText
    }, (0, $a7f52c7c1125a3f0$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            "year",
            "day"
        ],
        defaultOpenTo: "day"
    }), {
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        minDate: (0, $5605199c124089a3$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $5605199c124089a3$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate),
        slots: (0, $lzDk3.default)({
            toolbar: (0, $529ed7be62c882f7$export$21b7f8ea763109eb)
        }, slots),
        slotProps: (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps
    });
}



const $4ea09a213332970d$export$ffb3d0046ef3a2 = ({ props: props, value: value, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.dateWithTimezone(undefined, timezone);
    const minDate = (0, $5605199c124089a3$export$eb73579ccade48fd)(adapter.utils, props.minDate, adapter.defaultDates.minDate);
    const maxDate = (0, $5605199c124089a3$export$eb73579ccade48fd)(adapter.utils, props.maxDate, adapter.defaultDates.maxDate);
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return "shouldDisableDate";
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return "shouldDisableMonth";
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return "shouldDisableYear";
        case Boolean(disableFuture && adapter.utils.isAfterDay(value, now)):
            return "disableFuture";
        case Boolean(disablePast && adapter.utils.isBeforeDay(value, now)):
            return "disablePast";
        case Boolean(minDate && adapter.utils.isBeforeDay(value, minDate)):
            return "minDate";
        case Boolean(maxDate && adapter.utils.isAfterDay(value, maxDate)):
            return "maxDate";
        default:
            return null;
    }
};



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $2qCAA = parcelRequire("2qCAA");


var $4YNlq = parcelRequire("4YNlq");
/**
 * @ignore - internal component.
 */ const $d9e9a8e4dc077124$var$FormControlContext = /*#__PURE__*/ $4YNlq.createContext(undefined);
var $d9e9a8e4dc077124$export$2e2bcd8739ae039 = $d9e9a8e4dc077124$var$FormControlContext;



var $4YNlq = parcelRequire("4YNlq");

"use client";
function $cfa3bdf64b9b659c$export$2e2bcd8739ae039() {
    return $4YNlq.useContext((0, $d9e9a8e4dc077124$export$2e2bcd8739ae039));
}



var $JdaC3 = parcelRequire("JdaC3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $8e85ff6b894c24c6$export$4b135a4b3a6c4550(slot) {
    return (0, $fx4gX.default)("MuiInputAdornment", slot);
}
const $8e85ff6b894c24c6$var$inputAdornmentClasses = (0, $auO16.default)("MuiInputAdornment", [
    "root",
    "filled",
    "standard",
    "outlined",
    "positionStart",
    "positionEnd",
    "disablePointerEvents",
    "hiddenLabel",
    "sizeSmall"
]);
var $8e85ff6b894c24c6$export$2e2bcd8739ae039 = $8e85ff6b894c24c6$var$inputAdornmentClasses;



var $4Q3YJ = parcelRequire("4Q3YJ");

var $izf4p = parcelRequire("izf4p");
"use client";
var $d4adfbd348f78fa8$var$_span;
const $d4adfbd348f78fa8$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $d4adfbd348f78fa8$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $2qCAA.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $d4adfbd348f78fa8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            disablePointerEvents && "disablePointerEvents",
            position && `position${(0, $2qCAA.default)(position)}`,
            variant,
            hiddenLabel && "hiddenLabel",
            size && `size${(0, $2qCAA.default)(size)}`
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $8e85ff6b894c24c6$export$4b135a4b3a6c4550), classes);
};
const $d4adfbd348f78fa8$var$InputAdornmentRoot = (0, $JdaC3.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver: $d4adfbd348f78fa8$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "flex",
        height: "0.01em",
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: "2em",
        alignItems: "center",
        whiteSpace: "nowrap",
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === "filled" && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $8e85ff6b894c24c6$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $8e85ff6b894c24c6$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === "start" && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === "end" && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: "none"
    }));
const $d4adfbd348f78fa8$var$InputAdornment = /*#__PURE__*/ $4YNlq.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiInputAdornment"
    });
    const { children: children, className: className, component: component = "div", disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $g54n0.default)(props, $d4adfbd348f78fa8$var$_excluded);
    const muiFormControl = (0, $cfa3bdf64b9b659c$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $lzDk3.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $d4adfbd348f78fa8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $d9e9a8e4dc077124$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $izf4p.jsx)($d4adfbd348f78fa8$var$InputAdornmentRoot, (0, $lzDk3.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $fQQpK.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === "string" && !disableTypography ? /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
                children: [
                    position === "start" ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $d4adfbd348f78fa8$var$_span || ($d4adfbd348f78fa8$var$_span = /*#__PURE__*/ (0, $izf4p.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $d4adfbd348f78fa8$export$2e2bcd8739ae039 = $d4adfbd348f78fa8$var$InputAdornment;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");

var $309LR = parcelRequire("309LR");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");


var $2qCAA = parcelRequire("2qCAA");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $91e249a30682c3c3$export$5e8702d71474f093(slot) {
    return (0, $fx4gX.default)("MuiIconButton", slot);
}
const $91e249a30682c3c3$var$iconButtonClasses = (0, $auO16.default)("MuiIconButton", [
    "root",
    "disabled",
    "colorInherit",
    "colorPrimary",
    "colorSecondary",
    "colorError",
    "colorInfo",
    "colorSuccess",
    "colorWarning",
    "edgeStart",
    "edgeEnd",
    "sizeSmall",
    "sizeMedium",
    "sizeLarge"
]);
var $91e249a30682c3c3$export$2e2bcd8739ae039 = $91e249a30682c3c3$var$iconButtonClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $81fc785263d7b0b1$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $81fc785263d7b0b1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            color !== "default" && `color${(0, $2qCAA.default)(color)}`,
            edge && `edge${(0, $2qCAA.default)(edge)}`,
            `size${(0, $2qCAA.default)(size)}`
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $91e249a30682c3c3$export$5e8702d71474f093), classes);
};
const $81fc785263d7b0b1$var$IconButtonRoot = (0, $JdaC3.default)((0, $7e17388639953587$export$2e2bcd8739ae039), {
    name: "MuiIconButton",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== "default" && styles[`color${(0, $2qCAA.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $2qCAA.default)(ownerState.edge)}`],
            styles[`size${(0, $2qCAA.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        textAlign: "center",
        flex: "0 0 auto",
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: "50%",
        overflow: "visible",
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $309LR.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $lzDk3.default)({}, ownerState.color === "inherit" && {
        color: "inherit"
    }, ownerState.color !== "inherit" && ownerState.color !== "default" && (0, $lzDk3.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        "&:hover": (0, $lzDk3.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $309LR.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        })
    }), ownerState.size === "small" && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === "large" && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $91e249a30682c3c3$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: "transparent",
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $81fc785263d7b0b1$var$IconButton = /*#__PURE__*/ $4YNlq.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiIconButton"
    });
    const { edge: edge = false, children: children, className: className, color: color = "default", disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = "medium" } = props, other = (0, $g54n0.default)(props, $81fc785263d7b0b1$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $81fc785263d7b0b1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($81fc785263d7b0b1$var$IconButtonRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $81fc785263d7b0b1$export$2e2bcd8739ae039 = $81fc785263d7b0b1$var$IconButton;




var $4YNlq = parcelRequire("4YNlq");
"use client";
let $f7c9c9374bbf09f1$var$globalId = 0;
function $f7c9c9374bbf09f1$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $4YNlq.useState(idOverride);
    const id = idOverride || defaultId;
    $4YNlq.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $f7c9c9374bbf09f1$var$globalId += 1;
            setDefaultId(`mui-${$f7c9c9374bbf09f1$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $f7c9c9374bbf09f1$var$maybeReactUseId = $4YNlq["useId".toString()];
function $f7c9c9374bbf09f1$export$2e2bcd8739ae039(idOverride) {
    if ($f7c9c9374bbf09f1$var$maybeReactUseId !== undefined) {
        const reactId = $f7c9c9374bbf09f1$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $f7c9c9374bbf09f1$var$useGlobalId(idOverride);
}



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");








var $izf4p = parcelRequire("izf4p");
"use client";
const $4d0799980e60d657$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $4d0799980e60d657$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $4d0799980e60d657$var$styles = {
    entering: {
        opacity: 1,
        transform: $4d0799980e60d657$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: "none"
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $4d0799980e60d657$var$isWebKit154 = typeof navigator !== "undefined" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $4d0799980e60d657$var$Grow = /*#__PURE__*/ $4YNlq.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = "auto", TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $c4b9c02358af45ec$export$2e2bcd8739ae039) } = props, other = (0, $g54n0.default)(props, $4d0799980e60d657$var$_excluded);
    const timer = (0, $973088a6538d1d0c$export$2e2bcd8739ae039)();
    const autoTimeout = $4YNlq.useRef();
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    const nodeRef = $4YNlq.useRef(null);
    const handleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $2bb0265716437a48$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $2bb0265716437a48$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $4d0799980e60d657$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(",");
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $2bb0265716437a48$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        let duration;
        if (timeout === "auto") {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create("opacity", {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create("transform", {
                duration: $4d0799980e60d657$var$isWebKit154 ? duration : duration * 0.666,
                delay: $4d0799980e60d657$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(",");
        node.style.opacity = 0;
        node.style.transform = $4d0799980e60d657$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $izf4p.jsx)(TransitionComponent, (0, $lzDk3.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $4YNlq.cloneElement(children, (0, $lzDk3.default)({
                style: (0, $lzDk3.default)({
                    opacity: 0,
                    transform: $4d0799980e60d657$var$getScale(0.75),
                    visibility: state === "exited" && !inProp ? "hidden" : undefined
                }, $4d0799980e60d657$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$4d0799980e60d657$var$Grow.muiSupportAuto = true;
var $4d0799980e60d657$export$2e2bcd8739ae039 = $4d0799980e60d657$var$Grow;





var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");

function $417040ec8ad38107$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $de579400b7890438$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $417040ec8ad38107$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $de579400b7890438$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $417040ec8ad38107$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $de579400b7890438$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $417040ec8ad38107$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $cffbd8920f2ca018$export$8960430cfd85939f = Math.max;
var $cffbd8920f2ca018$export$96ec731ed4dcb222 = Math.min;
var $cffbd8920f2ca018$export$2077e0241d6afd3c = Math.round;



function $c3cf946f5b7abb11$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $5e9652ba6cc76879$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c3cf946f5b7abb11$export$2e2bcd8739ae039)());
}


function $bc28fc9a4bb56c1e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $de579400b7890438$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cffbd8920f2ca018$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cffbd8920f2ca018$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $de579400b7890438$export$45a5e7f76e0caa8d)(element) ? (0, $417040ec8ad38107$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $5e9652ba6cc76879$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $200931fd0202df78$export$2e2bcd8739ae039(node) {
    var win = (0, $417040ec8ad38107$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $6f0b6a4ad78fd401$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $9dded49e9077b2a5$export$2e2bcd8739ae039(node) {
    if (node === (0, $417040ec8ad38107$export$2e2bcd8739ae039)(node) || !(0, $de579400b7890438$export$1b3bfaa9684536aa)(node)) return (0, $200931fd0202df78$export$2e2bcd8739ae039)(node);
    else return (0, $6f0b6a4ad78fd401$export$2e2bcd8739ae039)(node);
}


function $608fc99871fb0d66$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}





function $90b174d3f0f2f520$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $de579400b7890438$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $e4c5d81cb186b2f0$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bc28fc9a4bb56c1e$export$2e2bcd8739ae039)((0, $90b174d3f0f2f520$export$2e2bcd8739ae039)(element)).left + (0, $200931fd0202df78$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $da82296b9fdfa79a$export$2e2bcd8739ae039(element) {
    return (0, $417040ec8ad38107$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $15da60e232c35e23$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $da82296b9fdfa79a$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $4b2692779813303c$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cffbd8920f2ca018$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cffbd8920f2ca018$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $4b2692779813303c$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $de579400b7890438$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $de579400b7890438$export$1b3bfaa9684536aa)(offsetParent) && $4b2692779813303c$var$isElementScaled(offsetParent);
    var documentElement = (0, $90b174d3f0f2f520$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $bc28fc9a4bb56c1e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $608fc99871fb0d66$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $15da60e232c35e23$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $9dded49e9077b2a5$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $de579400b7890438$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $bc28fc9a4bb56c1e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $e4c5d81cb186b2f0$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $26ffbc7202d7cd19$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bc28fc9a4bb56c1e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $de97611a73bc8928$export$2e2bcd8739ae039(element) {
    if ((0, $608fc99871fb0d66$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $de579400b7890438$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $90b174d3f0f2f520$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $545b524a3215f09f$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $608fc99871fb0d66$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $de579400b7890438$export$1b3bfaa9684536aa)(node) && (0, $15da60e232c35e23$export$2e2bcd8739ae039)(node)) return node;
    return $545b524a3215f09f$export$2e2bcd8739ae039((0, $de97611a73bc8928$export$2e2bcd8739ae039)(node));
}





function $39527e25946f4ae1$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $545b524a3215f09f$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $417040ec8ad38107$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $15da60e232c35e23$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($39527e25946f4ae1$export$2e2bcd8739ae039((0, $de97611a73bc8928$export$2e2bcd8739ae039)(target)));
}







function $6de77ecab8e4f132$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $608fc99871fb0d66$export$2e2bcd8739ae039)(element)) >= 0;
}




function $8855d58200f387af$var$getTrueOffsetParent(element) {
    if (!(0, $de579400b7890438$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $da82296b9fdfa79a$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $8855d58200f387af$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c3cf946f5b7abb11$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c3cf946f5b7abb11$export$2e2bcd8739ae039)());
    if (isIE && (0, $de579400b7890438$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $da82296b9fdfa79a$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $de97611a73bc8928$export$2e2bcd8739ae039)(element);
    if ((0, $de579400b7890438$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $de579400b7890438$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $608fc99871fb0d66$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $da82296b9fdfa79a$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $8855d58200f387af$export$2e2bcd8739ae039(element) {
    var window = (0, $417040ec8ad38107$export$2e2bcd8739ae039)(element);
    var offsetParent = $8855d58200f387af$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6de77ecab8e4f132$export$2e2bcd8739ae039)(offsetParent) && (0, $da82296b9fdfa79a$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $8855d58200f387af$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $608fc99871fb0d66$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $608fc99871fb0d66$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $da82296b9fdfa79a$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $8855d58200f387af$var$getContainingBlock(element) || window;
}


var $c58fe2c609279563$export$1e95b668f3b82d = "top";
var $c58fe2c609279563$export$40e543e69a8b3fbb = "bottom";
var $c58fe2c609279563$export$79ffe56a765070d2 = "right";
var $c58fe2c609279563$export$eabcd2c8791e7bf4 = "left";
var $c58fe2c609279563$export$dfb5619354ba860 = "auto";
var $c58fe2c609279563$export$aec2ce47c367b8c3 = [
    $c58fe2c609279563$export$1e95b668f3b82d,
    $c58fe2c609279563$export$40e543e69a8b3fbb,
    $c58fe2c609279563$export$79ffe56a765070d2,
    $c58fe2c609279563$export$eabcd2c8791e7bf4
];
var $c58fe2c609279563$export$b3571188c770cc5a = "start";
var $c58fe2c609279563$export$bd5df0f255a350f8 = "end";
var $c58fe2c609279563$export$390fd549c5303b4d = "clippingParents";
var $c58fe2c609279563$export$d7b7311ec04a3e8f = "viewport";
var $c58fe2c609279563$export$ae5ab1c730825774 = "popper";
var $c58fe2c609279563$export$ca50aac9f3ba507f = "reference";
var $c58fe2c609279563$export$368f9a87e87fa4e1 = /*#__PURE__*/ $c58fe2c609279563$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $c58fe2c609279563$export$b3571188c770cc5a,
        placement + "-" + $c58fe2c609279563$export$bd5df0f255a350f8
    ]);
}, []);
var $c58fe2c609279563$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($c58fe2c609279563$export$aec2ce47c367b8c3, [
    $c58fe2c609279563$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $c58fe2c609279563$export$b3571188c770cc5a,
        placement + "-" + $c58fe2c609279563$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $c58fe2c609279563$export$421679a7c3d56e = "beforeRead";
var $c58fe2c609279563$export$aafa59e2e03f2942 = "read";
var $c58fe2c609279563$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $c58fe2c609279563$export$c65e99957a05207c = "beforeMain";
var $c58fe2c609279563$export$f22da7240b7add18 = "main";
var $c58fe2c609279563$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $c58fe2c609279563$export$8d4d2d70e7d46032 = "beforeWrite";
var $c58fe2c609279563$export$68d8715fc104d294 = "write";
var $c58fe2c609279563$export$70a6e5159acce2e6 = "afterWrite";
var $c58fe2c609279563$export$d087d3878fdf71d5 = [
    $c58fe2c609279563$export$421679a7c3d56e,
    $c58fe2c609279563$export$aafa59e2e03f2942,
    $c58fe2c609279563$export$6964f6c886723980,
    $c58fe2c609279563$export$c65e99957a05207c,
    $c58fe2c609279563$export$f22da7240b7add18,
    $c58fe2c609279563$export$bab79516f2d662fe,
    $c58fe2c609279563$export$8d4d2d70e7d46032,
    $c58fe2c609279563$export$68d8715fc104d294,
    $c58fe2c609279563$export$70a6e5159acce2e6
];


function $27b73062ff01f2c7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $27b73062ff01f2c7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $27b73062ff01f2c7$var$order(modifiers); // order based on phase
    return (0, $c58fe2c609279563$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9c576a0f59ae478f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $4d571f4b3bb2fc72$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $eafbb3ba846a3869$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $eafbb3ba846a3869$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $eafbb3ba846a3869$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $eafbb3ba846a3869$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $eafbb3ba846a3869$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $de579400b7890438$export$45a5e7f76e0caa8d)(reference) ? (0, $39527e25946f4ae1$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $39527e25946f4ae1$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $39527e25946f4ae1$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $27b73062ff01f2c7$export$2e2bcd8739ae039)((0, $4d571f4b3bb2fc72$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$eafbb3ba846a3869$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $4b2692779813303c$export$2e2bcd8739ae039)(reference, (0, $8855d58200f387af$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $26ffbc7202d7cd19$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9c576a0f59ae478f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$eafbb3ba846a3869$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $eafbb3ba846a3869$export$8f7491d57c8f97a9 = /*#__PURE__*/ $eafbb3ba846a3869$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $187ee93cf2b8df64$var$passive = {
    passive: true
};
function $187ee93cf2b8df64$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $417040ec8ad38107$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $187ee93cf2b8df64$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $187ee93cf2b8df64$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $187ee93cf2b8df64$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $187ee93cf2b8df64$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $187ee93cf2b8df64$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $187ee93cf2b8df64$var$effect,
    data: {}
};



function $007b0192f5a7e7d0$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}


function $09449122cdc02e6a$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}


function $aa847f2837bd9a79$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $7d03e1d8394637ba$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $007b0192f5a7e7d0$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $09449122cdc02e6a$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $c58fe2c609279563$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $c58fe2c609279563$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $c58fe2c609279563$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $c58fe2c609279563$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $aa847f2837bd9a79$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $c58fe2c609279563$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $c58fe2c609279563$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $4ff0fbfd26b79679$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $7d03e1d8394637ba$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $4ff0fbfd26b79679$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $4ff0fbfd26b79679$var$popperOffsets,
    data: {}
};










var $8fcb438ba166265a$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $8fcb438ba166265a$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cffbd8920f2ca018$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $cffbd8920f2ca018$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $8fcb438ba166265a$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $c58fe2c609279563$export$eabcd2c8791e7bf4);
    var sideY = (0, $c58fe2c609279563$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $8855d58200f387af$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $417040ec8ad38107$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $90b174d3f0f2f520$export$2e2bcd8739ae039)(popper);
            if ((0, $da82296b9fdfa79a$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $c58fe2c609279563$export$1e95b668f3b82d) || (placement === (0, $c58fe2c609279563$export$eabcd2c8791e7bf4) || placement === (0, $c58fe2c609279563$export$79ffe56a765070d2)) && variation === (0, $c58fe2c609279563$export$bd5df0f255a350f8)) {
            sideY = (0, $c58fe2c609279563$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $c58fe2c609279563$export$eabcd2c8791e7bf4) || (placement === (0, $c58fe2c609279563$export$1e95b668f3b82d) || placement === (0, $c58fe2c609279563$export$40e543e69a8b3fbb)) && variation === (0, $c58fe2c609279563$export$bd5df0f255a350f8)) {
            sideX = (0, $c58fe2c609279563$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $8fcb438ba166265a$var$unsetSides);
    var _ref4 = roundOffsets === true ? $8fcb438ba166265a$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $417040ec8ad38107$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $8fcb438ba166265a$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $007b0192f5a7e7d0$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $09449122cdc02e6a$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $8fcb438ba166265a$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $8fcb438ba166265a$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8fcb438ba166265a$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $8fcb438ba166265a$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $ea26c34c2c3f0cc2$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $de579400b7890438$export$1b3bfaa9684536aa)(element) || !(0, $608fc99871fb0d66$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $ea26c34c2c3f0cc2$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $de579400b7890438$export$1b3bfaa9684536aa)(element) || !(0, $608fc99871fb0d66$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $ea26c34c2c3f0cc2$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $ea26c34c2c3f0cc2$var$applyStyles,
    effect: $ea26c34c2c3f0cc2$var$effect,
    requires: [
        "computeStyles"
    ]
};




function $0bceb1cb80ae031b$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $007b0192f5a7e7d0$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $c58fe2c609279563$export$eabcd2c8791e7bf4),
        (0, $c58fe2c609279563$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $c58fe2c609279563$export$eabcd2c8791e7bf4),
        (0, $c58fe2c609279563$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $0bceb1cb80ae031b$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $c58fe2c609279563$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $0bceb1cb80ae031b$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $0bceb1cb80ae031b$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $0bceb1cb80ae031b$var$offset
};


var $e7b09f4d355f7608$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $e7b09f4d355f7608$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $e7b09f4d355f7608$var$hash[matched];
    });
}



var $1a880eb0b20ab3b9$var$hash = {
    start: "end",
    end: "start"
};
function $1a880eb0b20ab3b9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $1a880eb0b20ab3b9$var$hash[matched];
    });
}







function $3acb83f511b6ef6c$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $417040ec8ad38107$export$2e2bcd8739ae039)(element);
    var html = (0, $90b174d3f0f2f520$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $5e9652ba6cc76879$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $e4c5d81cb186b2f0$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $9dd58b3193214692$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $90b174d3f0f2f520$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $200931fd0202df78$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cffbd8920f2ca018$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cffbd8920f2ca018$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $e4c5d81cb186b2f0$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $da82296b9fdfa79a$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $cffbd8920f2ca018$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $b1f456216fa04328$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $de579400b7890438$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $3e5f3f9845d9acc5$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $15ff68a2b2a6f265$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bc28fc9a4bb56c1e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $15ff68a2b2a6f265$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $c58fe2c609279563$export$d7b7311ec04a3e8f) ? (0, $3e5f3f9845d9acc5$export$2e2bcd8739ae039)((0, $3acb83f511b6ef6c$export$2e2bcd8739ae039)(element, strategy)) : (0, $de579400b7890438$export$45a5e7f76e0caa8d)(clippingParent) ? $15ff68a2b2a6f265$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $3e5f3f9845d9acc5$export$2e2bcd8739ae039)((0, $9dd58b3193214692$export$2e2bcd8739ae039)((0, $90b174d3f0f2f520$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $15ff68a2b2a6f265$var$getClippingParents(element) {
    var clippingParents = (0, $39527e25946f4ae1$export$2e2bcd8739ae039)((0, $de97611a73bc8928$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $da82296b9fdfa79a$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $de579400b7890438$export$1b3bfaa9684536aa)(element) ? (0, $8855d58200f387af$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $de579400b7890438$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $de579400b7890438$export$45a5e7f76e0caa8d)(clippingParent) && (0, $b1f456216fa04328$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $608fc99871fb0d66$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $15ff68a2b2a6f265$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $15ff68a2b2a6f265$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $15ff68a2b2a6f265$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cffbd8920f2ca018$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $cffbd8920f2ca018$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $cffbd8920f2ca018$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cffbd8920f2ca018$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $15ff68a2b2a6f265$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $a12b1294c52218d8$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $fd4c30f3bd73e35c$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $a12b1294c52218d8$export$2e2bcd8739ae039)(), paddingObject);
}


function $525b1f6f6f58bef3$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $29941961fb1fac76$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $c58fe2c609279563$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $c58fe2c609279563$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $c58fe2c609279563$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $fd4c30f3bd73e35c$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $525b1f6f6f58bef3$export$2e2bcd8739ae039)(padding, (0, $c58fe2c609279563$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $c58fe2c609279563$export$ae5ab1c730825774) ? (0, $c58fe2c609279563$export$ca50aac9f3ba507f) : (0, $c58fe2c609279563$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $15ff68a2b2a6f265$export$2e2bcd8739ae039)((0, $de579400b7890438$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $90b174d3f0f2f520$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bc28fc9a4bb56c1e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $7d03e1d8394637ba$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $3e5f3f9845d9acc5$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $c58fe2c609279563$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $c58fe2c609279563$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $c58fe2c609279563$export$79ffe56a765070d2),
                (0, $c58fe2c609279563$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $c58fe2c609279563$export$1e95b668f3b82d),
                (0, $c58fe2c609279563$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $8e0465fcdc68468a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $c58fe2c609279563$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $09449122cdc02e6a$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $c58fe2c609279563$export$368f9a87e87fa4e1) : (0, $c58fe2c609279563$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $09449122cdc02e6a$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $c58fe2c609279563$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $29941961fb1fac76$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $007b0192f5a7e7d0$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $7a550ae71cf70da9$var$getExpandedFallbackPlacements(placement) {
    if ((0, $007b0192f5a7e7d0$export$2e2bcd8739ae039)(placement) === (0, $c58fe2c609279563$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $e7b09f4d355f7608$export$2e2bcd8739ae039)(placement);
    return [
        (0, $1a880eb0b20ab3b9$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $1a880eb0b20ab3b9$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $7a550ae71cf70da9$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $007b0192f5a7e7d0$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $e7b09f4d355f7608$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $7a550ae71cf70da9$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $007b0192f5a7e7d0$export$2e2bcd8739ae039)(placement) === (0, $c58fe2c609279563$export$dfb5619354ba860) ? (0, $8e0465fcdc68468a$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $007b0192f5a7e7d0$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $09449122cdc02e6a$export$2e2bcd8739ae039)(placement) === (0, $c58fe2c609279563$export$b3571188c770cc5a);
        var isVertical = [
            (0, $c58fe2c609279563$export$1e95b668f3b82d),
            (0, $c58fe2c609279563$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $29941961fb1fac76$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $c58fe2c609279563$export$79ffe56a765070d2) : (0, $c58fe2c609279563$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $c58fe2c609279563$export$40e543e69a8b3fbb) : (0, $c58fe2c609279563$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $e7b09f4d355f7608$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $e7b09f4d355f7608$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7a550ae71cf70da9$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $7a550ae71cf70da9$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};





function $d4ea725dbef6657f$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}



function $1622b0e5d2465daa$export$f28d906d67a997f3(min, value, max) {
    return (0, $cffbd8920f2ca018$export$8960430cfd85939f)(min, (0, $cffbd8920f2ca018$export$96ec731ed4dcb222)(value, max));
}
function $1622b0e5d2465daa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $1622b0e5d2465daa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $abd8ab74041cde90$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $29941961fb1fac76$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $007b0192f5a7e7d0$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $09449122cdc02e6a$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $aa847f2837bd9a79$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d4ea725dbef6657f$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $c58fe2c609279563$export$1e95b668f3b82d) : (0, $c58fe2c609279563$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $c58fe2c609279563$export$40e543e69a8b3fbb) : (0, $c58fe2c609279563$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $c58fe2c609279563$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $c58fe2c609279563$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $26ffbc7202d7cd19$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $a12b1294c52218d8$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1622b0e5d2465daa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $8855d58200f387af$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1622b0e5d2465daa$export$f28d906d67a997f3)(tether ? (0, $cffbd8920f2ca018$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $cffbd8920f2ca018$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $c58fe2c609279563$export$1e95b668f3b82d) : (0, $c58fe2c609279563$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $c58fe2c609279563$export$40e543e69a8b3fbb) : (0, $c58fe2c609279563$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $c58fe2c609279563$export$1e95b668f3b82d),
            (0, $c58fe2c609279563$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1622b0e5d2465daa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $1622b0e5d2465daa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $abd8ab74041cde90$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $abd8ab74041cde90$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};











var $26c2cf023b75d63c$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $fd4c30f3bd73e35c$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $525b1f6f6f58bef3$export$2e2bcd8739ae039)(padding, (0, $c58fe2c609279563$export$aec2ce47c367b8c3)));
};
function $26c2cf023b75d63c$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $007b0192f5a7e7d0$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $aa847f2837bd9a79$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $c58fe2c609279563$export$eabcd2c8791e7bf4),
        (0, $c58fe2c609279563$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $26c2cf023b75d63c$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $26ffbc7202d7cd19$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $c58fe2c609279563$export$1e95b668f3b82d) : (0, $c58fe2c609279563$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $c58fe2c609279563$export$40e543e69a8b3fbb) : (0, $c58fe2c609279563$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $8855d58200f387af$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1622b0e5d2465daa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $26c2cf023b75d63c$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $b1f456216fa04328$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $26c2cf023b75d63c$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $26c2cf023b75d63c$var$arrow,
    effect: $26c2cf023b75d63c$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};




function $43592f6bbb44d162$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $43592f6bbb44d162$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $c58fe2c609279563$export$1e95b668f3b82d),
        (0, $c58fe2c609279563$export$79ffe56a765070d2),
        (0, $c58fe2c609279563$export$40e543e69a8b3fbb),
        (0, $c58fe2c609279563$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $43592f6bbb44d162$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $29941961fb1fac76$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $29941961fb1fac76$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $43592f6bbb44d162$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $43592f6bbb44d162$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $43592f6bbb44d162$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $43592f6bbb44d162$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $43592f6bbb44d162$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $43592f6bbb44d162$var$hide
};




var $255e7025b4463c41$export$d34966752335dd47 = [
    (0, $187ee93cf2b8df64$export$2e2bcd8739ae039),
    (0, $4ff0fbfd26b79679$export$2e2bcd8739ae039),
    (0, $8fcb438ba166265a$export$2e2bcd8739ae039),
    (0, $ea26c34c2c3f0cc2$export$2e2bcd8739ae039),
    (0, $0bceb1cb80ae031b$export$2e2bcd8739ae039),
    (0, $7a550ae71cf70da9$export$2e2bcd8739ae039),
    (0, $abd8ab74041cde90$export$2e2bcd8739ae039),
    (0, $26c2cf023b75d63c$export$2e2bcd8739ae039),
    (0, $43592f6bbb44d162$export$2e2bcd8739ae039)
];
var $255e7025b4463c41$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $eafbb3ba846a3869$export$ed5e13716264f202)({
    defaultModifiers: $255e7025b4463c41$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $9JdRu = parcelRequire("9JdRu");


var $fx4gX = parcelRequire("fx4gX");
const $4415830b5669d6f3$var$GLOBAL_CLASS_PREFIX = "base";
function $4415830b5669d6f3$var$buildStateClass(state) {
    return `${$4415830b5669d6f3$var$GLOBAL_CLASS_PREFIX}--${state}`;
}
function $4415830b5669d6f3$var$buildSlotClass(componentName, slot) {
    return `${$4415830b5669d6f3$var$GLOBAL_CLASS_PREFIX}-${componentName}-${slot}`;
}
function $4415830b5669d6f3$export$1d132570e11858b0(componentName, slot) {
    const globalStateClass = (0, $fx4gX.globalStateClasses)[slot];
    return globalStateClass ? $4415830b5669d6f3$var$buildStateClass(globalStateClass) : $4415830b5669d6f3$var$buildSlotClass(componentName, slot);
}
function $4415830b5669d6f3$export$34c0130b1f3e8ae3(slot) {
    return (0, $fx4gX.globalStateClasses)[slot] !== undefined;
}



function $7a26536918abccf3$export$de4f15803c389669(componentName, slots) {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4415830b5669d6f3$export$1d132570e11858b0)(componentName, slot);
    });
    return result;
}


const $1ffca948a04fcd21$var$COMPONENT_NAME = "Popper";
function $1ffca948a04fcd21$export$1b69b6cd0fa638a1(slot) {
    return (0, $4415830b5669d6f3$export$1d132570e11858b0)($1ffca948a04fcd21$var$COMPONENT_NAME, slot);
}
const $1ffca948a04fcd21$export$b6aa214021e734b0 = (0, $7a26536918abccf3$export$de4f15803c389669)($1ffca948a04fcd21$var$COMPONENT_NAME, [
    "root"
]);




var $4YNlq = parcelRequire("4YNlq");

var $izf4p = parcelRequire("izf4p");
"use client";
const $2c6609bcc483e58f$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $2c6609bcc483e58f$var$ClassNameConfiguratorContext = /*#__PURE__*/ $4YNlq.createContext($2c6609bcc483e58f$var$defaultContextValue);
function $2c6609bcc483e58f$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $4YNlq.useContext($2c6609bcc483e58f$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return "";
        return generateUtilityClass(slot);
    };
}
function $2c6609bcc483e58f$export$2efe1f5e70172ae9(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $4YNlq.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)($2c6609bcc483e58f$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $izf4p = parcelRequire("izf4p");
"use client";
const $f1776e52e15d570b$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $f1776e52e15d570b$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $f1776e52e15d570b$var$flipPlacement(placement, direction) {
    if (direction === "ltr") return placement;
    switch(placement){
        case "bottom-end":
            return "bottom-start";
        case "bottom-start":
            return "bottom-end";
        case "top-end":
            return "top-start";
        case "top-start":
            return "top-end";
        default:
            return placement;
    }
}
function $f1776e52e15d570b$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
function $f1776e52e15d570b$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $f1776e52e15d570b$var$isVirtualElement(element) {
    return !$f1776e52e15d570b$var$isHTMLElement(element);
}
const $f1776e52e15d570b$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $2c6609bcc483e58f$export$b0f7603cd2f9ee15)((0, $1ffca948a04fcd21$export$1b69b6cd0fa638a1)));
};
const $f1776e52e15d570b$var$defaultPopperOptions = {};
const $f1776e52e15d570b$var$PopperTooltip = /*#__PURE__*/ $4YNlq.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $g54n0.default)(props, $f1776e52e15d570b$var$_excluded);
    const tooltipRef = $4YNlq.useRef(null);
    const ownRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $4YNlq.useRef(null);
    const handlePopperRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $4YNlq.useRef(handlePopperRef);
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $4YNlq.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $f1776e52e15d570b$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $4YNlq.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $4YNlq.useState($f1776e52e15d570b$var$resolveAnchorEl(anchorEl));
    $4YNlq.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $4YNlq.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($f1776e52e15d570b$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: "preventOverflow",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "flip",
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: "onUpdate",
                enabled: true,
                phase: "afterWrite",
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $255e7025b4463c41$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $lzDk3.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $f1776e52e15d570b$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : "div";
    const rootProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: "tooltip",
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)(Root, (0, $lzDk3.default)({}, rootProps, {
        children: typeof children === "function" ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base-ui/react-popper/components-api/#popper)
 */ const $f1776e52e15d570b$export$badac9ada3a0bdf9 = /*#__PURE__*/ $4YNlq.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = "ltr", disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = "bottom", popperOptions: popperOptions = $f1776e52e15d570b$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $g54n0.default)(props, $f1776e52e15d570b$var$_excluded2);
    const [exited, setExited] = $4YNlq.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $f1776e52e15d570b$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $f1776e52e15d570b$var$isHTMLElement(resolvedAnchorEl) ? (0, $140200a3441aaff2$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $140200a3441aaff2$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? "none" : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $8745ba6e45b81808$export$602eac185826482c), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $izf4p.jsx)($f1776e52e15d570b$var$PopperTooltip, (0, $lzDk3.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $lzDk3.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: "fixed",
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});


var $e1fe181d43d1979c$exports = {};
"use strict";
"use client";
Object.defineProperty($e1fe181d43d1979c$exports, "__esModule", {
    value: true
});
$e1fe181d43d1979c$exports.default = void 0;

var $e1fe181d43d1979c$var$React = $e1fe181d43d1979c$var$_interopRequireWildcard((parcelRequire("4YNlq")));
parcelRequire("8zt0d");
var $g89D5 = parcelRequire("g89D5");
function $e1fe181d43d1979c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e1fe181d43d1979c$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $e1fe181d43d1979c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $e1fe181d43d1979c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $e1fe181d43d1979c$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $e1fe181d43d1979c$var$useTheme(defaultTheme = null) {
    const contextTheme = $e1fe181d43d1979c$var$React.useContext($g89D5.T);
    return !contextTheme || $e1fe181d43d1979c$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $e1fe181d43d1979c$var$_default = $e1fe181d43d1979c$exports.default = $e1fe181d43d1979c$var$useTheme;






var $4YNlq = parcelRequire("4YNlq");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $izf4p = parcelRequire("izf4p");
"use client";
const $ec4c3ea62d4dbe43$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $ec4c3ea62d4dbe43$var$PopperRoot = (0, $JdaC3.default)((0, $f1776e52e15d570b$export$badac9ada3a0bdf9), {
    name: "MuiPopper",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $ec4c3ea62d4dbe43$var$Popper = /*#__PURE__*/ $4YNlq.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, (/*@__PURE__*/$parcel$interopDefault($e1fe181d43d1979c$exports)))();
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPopper"
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $g54n0.default)(props, $ec4c3ea62d4dbe43$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $lzDk3.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $izf4p.jsx)($ec4c3ea62d4dbe43$var$PopperRoot, (0, $lzDk3.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $ec4c3ea62d4dbe43$export$2e2bcd8739ae039 = $ec4c3ea62d4dbe43$var$Popper;




var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $c07cbb53910d6d8d$export$5519b4d4bf80ce6f(slot) {
    return (0, $fx4gX.default)("MuiPickersPopper", slot);
}
const $c07cbb53910d6d8d$export$46e9184c9b1af0ce = (0, $auO16.default)("MuiPickersPopper", [
    "root",
    "paper"
]);


/* Use it instead of .includes method for IE support */ function $3887927531c6c329$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $3887927531c6c329$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === "Enter" || event.key === " ") {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $3887927531c6c329$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
const $3887927531c6c329$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $3887927531c6c329$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
const $3887927531c6c329$export$9ae5b19305db48ce = "@media (pointer: fine)";



const $1eecc46dae84482d$var$PREFERS_REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";
// detect if user agent has Android version < 10 or iOS version < 13
const $1eecc46dae84482d$var$mobileVersionMatches = typeof navigator !== "undefined" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $1eecc46dae84482d$var$androidVersion = $1eecc46dae84482d$var$mobileVersionMatches && $1eecc46dae84482d$var$mobileVersionMatches[1] ? parseInt($1eecc46dae84482d$var$mobileVersionMatches[1], 10) : null;
const $1eecc46dae84482d$var$iOSVersion = $1eecc46dae84482d$var$mobileVersionMatches && $1eecc46dae84482d$var$mobileVersionMatches[2] ? parseInt($1eecc46dae84482d$var$mobileVersionMatches[2], 10) : null;
const $1eecc46dae84482d$export$7e3b2a595fb375e5 = $1eecc46dae84482d$var$androidVersion && $1eecc46dae84482d$var$androidVersion < 10 || $1eecc46dae84482d$var$iOSVersion && $1eecc46dae84482d$var$iOSVersion < 13 || false;
const $1eecc46dae84482d$export$ce40fb97be7f02d9 = ()=>{
    const prefersReduced = (0, $9648db6b3d91d1c6$export$2e2bcd8739ae039)($1eecc46dae84482d$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    return prefersReduced || $1eecc46dae84482d$export$7e3b2a595fb375e5;
};



var $izf4p = parcelRequire("izf4p");
const $36d6225a6812ae9d$var$_excluded = [
    "PaperComponent",
    "popperPlacement",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $36d6225a6812ae9d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $c07cbb53910d6d8d$export$5519b4d4bf80ce6f), classes);
};
const $36d6225a6812ae9d$var$PickersPopperRoot = (0, $JdaC3.default)((0, $ec4c3ea62d4dbe43$export$2e2bcd8739ae039), {
    name: "MuiPickersPopper",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $36d6225a6812ae9d$var$PickersPopperPaper = (0, $JdaC3.default)((0, $b622387df7e39ff3$export$2e2bcd8739ae039), {
    name: "MuiPickersPopper",
    slot: "Paper",
    overridesResolver: (_, styles)=>styles.paper
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        outline: 0,
        transformOrigin: "top center"
    }, ownerState.placement.includes("top") && {
        transformOrigin: "bottom center"
    }));
function $36d6225a6812ae9d$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $36d6225a6812ae9d$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $4YNlq.useRef(false);
    const syntheticEventRef = $4YNlq.useRef(false);
    const nodeRef = $4YNlq.useRef(null);
    const activatedRef = $4YNlq.useRef(false);
    $4YNlq.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener("mousedown", armClickAwayListener, true);
        document.addEventListener("touchstart", armClickAwayListener, true);
        return ()=>{
            document.removeEventListener("mousedown", armClickAwayListener, true);
            document.removeEventListener("touchstart", armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $140200a3441aaff2$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        "clientX" in event && $36d6225a6812ae9d$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = ()=>{
        syntheticEventRef.current = true;
    };
    $4YNlq.useEffect(()=>{
        if (active) {
            const doc = (0, $140200a3441aaff2$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener("touchstart", handleClickAway);
            doc.addEventListener("touchmove", handleTouchMove);
            return ()=>{
                doc.removeEventListener("touchstart", handleClickAway);
                doc.removeEventListener("touchmove", handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $4YNlq.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (e.g. setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $140200a3441aaff2$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener("click", handleClickAway);
            return ()=>{
                doc.removeEventListener("click", handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $36d6225a6812ae9d$var$PickersPopperPaperWrapper = /*#__PURE__*/ $4YNlq.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, popperPlacement: popperPlacement, ownerState: inOwnerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $g54n0.default)(props, $36d6225a6812ae9d$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, inOwnerState, {
        placement: popperPlacement
    });
    const paperProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)(PaperComponent, (0, $lzDk3.default)({}, other, paperProps, {
        onClick: (event)=>{
            var _paperProps$onClick;
            onPaperClick(event);
            (_paperProps$onClick = paperProps.onClick) == null || _paperProps$onClick.call(paperProps, event);
        },
        onTouchStart: (event)=>{
            var _paperProps$onTouchSt;
            onPaperTouchStart(event);
            (_paperProps$onTouchSt = paperProps.onTouchStart) == null || _paperProps$onTouchSt.call(paperProps, event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $36d6225a6812ae9d$export$96ce8482474de8a5(inProps) {
    var _slots$desktopTransit, _slots$desktopTrapFoc, _slots$desktopPaper, _slots$popper;
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersPopper"
    });
    const { anchorEl: anchorEl, children: children, containerRef: containerRef = null, shouldRestoreFocus: shouldRestoreFocus, onBlur: onBlur, onDismiss: onDismiss, open: open, role: role, placement: placement, slots: slots, slotProps: slotProps, reduceAnimations: inReduceAnimations } = props;
    $4YNlq.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Blink?) use 'Esc'
            if (open && (nativeEvent.key === "Escape" || nativeEvent.key === "Esc")) onDismiss();
        }
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        onDismiss,
        open
    ]);
    const lastFocusedElementRef = $4YNlq.useRef(null);
    $4YNlq.useEffect(()=>{
        if (role === "tooltip" || shouldRestoreFocus && !shouldRestoreFocus()) return;
        if (open) lastFocusedElementRef.current = (0, $3887927531c6c329$export$cd4e5573fbe2b576)(document);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        role,
        shouldRestoreFocus
    ]);
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $36d6225a6812ae9d$var$useClickAwayListener(open, onBlur != null ? onBlur : onDismiss);
    const paperRef = $4YNlq.useRef(null);
    const handleRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(paperRef, containerRef);
    const handlePaperRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(handleRef, clickAwayRef);
    const ownerState = props;
    const classes = $36d6225a6812ae9d$var$useUtilityClasses(ownerState);
    const defaultReduceAnimations = (0, $1eecc46dae84482d$export$ce40fb97be7f02d9)();
    const reduceAnimations = inReduceAnimations != null ? inReduceAnimations : defaultReduceAnimations;
    const handleKeyDown = (event)=>{
        if (event.key === "Escape") {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            onDismiss();
        }
    };
    const Transition = ((_slots$desktopTransit = slots == null ? void 0 : slots.desktopTransition) != null ? _slots$desktopTransit : reduceAnimations) ? (0, $802113259dde0d55$export$2e2bcd8739ae039) : (0, $4d0799980e60d657$export$2e2bcd8739ae039);
    const FocusTrap = (_slots$desktopTrapFoc = slots == null ? void 0 : slots.desktopTrapFocus) != null ? _slots$desktopTrapFoc : (0, $4a7d398b6a5739b9$export$34eba2437817a67b);
    const Paper = (_slots$desktopPaper = slots == null ? void 0 : slots.desktopPaper) != null ? _slots$desktopPaper : $36d6225a6812ae9d$var$PickersPopperPaper;
    const Popper = (_slots$popper = slots == null ? void 0 : slots.popper) != null ? _slots$popper : $36d6225a6812ae9d$var$PickersPopperRoot;
    const popperProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: Popper,
        externalSlotProps: slotProps == null ? void 0 : slotProps.popper,
        additionalProps: {
            transition: true,
            role: role,
            open: open,
            anchorEl: anchorEl,
            placement: placement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: props
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)(Popper, (0, $lzDk3.default)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps, placement: popperPlacement })=>/*#__PURE__*/ (0, $izf4p.jsx)(FocusTrap, (0, $lzDk3.default)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: role === "tooltip",
                isEnabled: ()=>true
            }, slotProps == null ? void 0 : slotProps.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $izf4p.jsx)(Transition, (0, $lzDk3.default)({}, TransitionProps, slotProps == null ? void 0 : slotProps.desktopTransition, {
                    children: /*#__PURE__*/ (0, $izf4p.jsx)($36d6225a6812ae9d$var$PickersPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        popperPlacement: popperPlacement,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps == null ? void 0 : slotProps.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}




var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $4YNlq = parcelRequire("4YNlq");
"use client";
function $5327b1b36ff53449$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = "value" }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $4YNlq.useRef(controlled !== undefined);
    const [valueState, setValue] = $4YNlq.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $4YNlq.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}




var $4YNlq = parcelRequire("4YNlq");
const $a176d4a516d924eb$export$7d3a09d5141ab1f4 = ({ open: open, onOpen: onOpen, onClose: onClose })=>{
    const isControllingOpenProp = $4YNlq.useRef(typeof open === "boolean").current;
    const [openState, setIsOpenState] = $4YNlq.useState(false);
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)
    $4YNlq.useEffect(()=>{
        if (isControllingOpenProp) {
            if (typeof open !== "boolean") throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
            setIsOpenState(open);
        }
    }, [
        isControllingOpenProp,
        open
    ]);
    const setIsOpen = $4YNlq.useCallback((newIsOpen)=>{
        if (!isControllingOpenProp) setIsOpenState(newIsOpen);
        if (newIsOpen && onOpen) onOpen();
        if (!newIsOpen && onClose) onClose();
    }, [
        isControllingOpenProp,
        onOpen,
        onClose
    ]);
    return {
        isOpen: openState,
        setIsOpen: setIsOpen
    };
};




var $4YNlq = parcelRequire("4YNlq");

function $6b5f16085e462dbd$export$87fe492f99f25a20(props, validate, isSameError, defaultErrorState) {
    const { value: value, onError: onError } = props;
    const adapter = (0, $9faaabe544d2b9ed$export$4b5a24245de9f7f9)();
    const previousValidationErrorRef = $4YNlq.useRef(defaultErrorState);
    const validationError = validate({
        adapter: adapter,
        value: value,
        props: props
    });
    $4YNlq.useEffect(()=>{
        if (onError && !isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        isSameError,
        onError,
        previousValidationErrorRef,
        validationError,
        value
    ]);
    return validationError;
}



var $4YNlq = parcelRequire("4YNlq");



const $00e922e0bf6d2e8e$export$c7e050e908c1b2bc = ({ timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChange, valueManager: valueManager })=>{
    var _ref, _ref2;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const firstDefaultValue = $4YNlq.useRef(defaultValue);
    const inputValue = (_ref = valueProp != null ? valueProp : firstDefaultValue.current) != null ? _ref : valueManager.emptyValue;
    const inputTimezone = $4YNlq.useMemo(()=>valueManager.getTimezone(utils, inputValue), [
        utils,
        valueManager,
        inputValue
    ]);
    const setInputTimezone = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(utils, inputTimezone, newValue);
    });
    const timezoneToRender = (_ref2 = timezoneProp != null ? timezoneProp : inputTimezone) != null ? _ref2 : "default";
    const valueWithTimezoneToRender = $4YNlq.useMemo(()=>valueManager.setTimezone(utils, timezoneToRender, inputValue), [
        valueManager,
        utils,
        timezoneToRender,
        inputValue
    ]);
    const handleValueChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        onChange == null || onChange(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};
const $00e922e0bf6d2e8e$export$174d749f3b4c0f49 = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, onChange: onChangeProp, valueManager: valueManager })=>{
    const [valueWithInputTimezone, setValue] = (0, $5327b1b36ff53449$export$2e2bcd8739ae039)({
        name: name,
        state: "value",
        controlled: valueProp,
        default: defaultValue != null ? defaultValue : valueManager.emptyValue
    });
    const onChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        setValue(newValue);
        onChangeProp == null || onChangeProp(newValue, ...otherParams);
    });
    return $00e922e0bf6d2e8e$export$c7e050e908c1b2bc({
        timezone: timezoneProp,
        value: valueWithInputTimezone,
        defaultValue: undefined,
        onChange: onChange,
        valueManager: valueManager
    });
};


/**
 * Decide if the new value should be published
 * The published value will be passed to `onChange` if defined.
 */ const $4a004c306d3b1d55$var$shouldPublishValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    // The field is responsible for only calling `onChange` when needed.
    if (action.name === "setValueFromField") return true;
    if (action.name === "setValueFromAction") {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to publish the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            "accept",
            "today",
            "clear"
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === "setValueFromView" && action.selectionState !== "shallow") {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    if (action.name === "setValueFromShortcut") {
        // On the first view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onChange`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastPublishedValue);
    }
    return false;
};
/**
 * Decide if the new value should be committed.
 * The committed value will be passed to `onAccept` if defined.
 * It will also be used as a reset target when calling the `cancel` picker action (when clicking on the "Cancel" button).
 */ const $4a004c306d3b1d55$var$shouldCommitValue = (params)=>{
    const { action: action, hasChanged: hasChanged, dateState: dateState, isControlled: isControlled, closeOnSelect: closeOnSelect } = params;
    const isCurrentValueTheDefaultValue = !isControlled && !dateState.hasBeenModifiedSinceMount;
    if (action.name === "setValueFromAction") {
        // If the component is not controlled, and the value has not been modified since the mount,
        // Then we want to commit the default value whenever the user pressed the "Accept", "Today" or "Clear" button.
        if (isCurrentValueTheDefaultValue && [
            "accept",
            "today",
            "clear"
        ].includes(action.pickerAction)) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === "setValueFromView" && action.selectionState === "finish" && closeOnSelect) {
        // On picker where the 1st view is also the last view,
        // If the value is not controlled, then clicking on any value (including the one equal to `defaultValue`) should call `onAccept`
        if (isCurrentValueTheDefaultValue) return true;
        return hasChanged(dateState.lastCommittedValue);
    }
    if (action.name === "setValueFromShortcut") return action.changeImportance === "accept" && hasChanged(dateState.lastCommittedValue);
    return false;
};
/**
 * Decide if the picker should be closed after the value is updated.
 */ const $4a004c306d3b1d55$var$shouldClosePicker = (params)=>{
    const { action: action, closeOnSelect: closeOnSelect } = params;
    if (action.name === "setValueFromAction") return true;
    if (action.name === "setValueFromView") return action.selectionState === "finish" && closeOnSelect;
    if (action.name === "setValueFromShortcut") return action.changeImportance === "accept";
    return false;
};
const $4a004c306d3b1d55$export$799b22a7b7fffaa3 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, validator: validator })=>{
    const { onAccept: onAccept, onChange: onChange, value: inValue, defaultValue: inDefaultValue, closeOnSelect: closeOnSelect = wrapperVariant === "desktop", selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, timezone: timezoneProp } = props;
    const { current: defaultValue } = $4YNlq.useRef(inDefaultValue);
    const { current: isControlled } = $4YNlq.useRef(inValue !== undefined);
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const adapter = (0, $9faaabe544d2b9ed$export$4b5a24245de9f7f9)();
    const [selectedSections, setSelectedSections] = (0, $5327b1b36ff53449$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: "usePickerValue",
        state: "selectedSections"
    });
    const { isOpen: isOpen, setIsOpen: setIsOpen } = (0, $a176d4a516d924eb$export$7d3a09d5141ab1f4)(props);
    const [dateState, setDateState] = $4YNlq.useState(()=>{
        let initialValue;
        if (inValue !== undefined) initialValue = inValue;
        else if (defaultValue !== undefined) initialValue = defaultValue;
        else initialValue = valueManager.emptyValue;
        return {
            draft: initialValue,
            lastPublishedValue: initialValue,
            lastCommittedValue: initialValue,
            lastControlledValue: inValue,
            hasBeenModifiedSinceMount: false
        };
    });
    const { timezone: timezone, handleValueChange: handleValueChange } = (0, $00e922e0bf6d2e8e$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: inValue,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    (0, $6b5f16085e462dbd$export$87fe492f99f25a20)((0, $lzDk3.default)({}, props, {
        value: dateState.draft,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const updateDate = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((action)=>{
        const updaterParams = {
            action: action,
            dateState: dateState,
            hasChanged: (comparison)=>!valueManager.areValuesEqual(utils, action.value, comparison),
            isControlled: isControlled,
            closeOnSelect: closeOnSelect
        };
        const shouldPublish = $4a004c306d3b1d55$var$shouldPublishValue(updaterParams);
        const shouldCommit = $4a004c306d3b1d55$var$shouldCommitValue(updaterParams);
        const shouldClose = $4a004c306d3b1d55$var$shouldClosePicker(updaterParams);
        setDateState((prev)=>(0, $lzDk3.default)({}, prev, {
                draft: action.value,
                lastPublishedValue: shouldPublish ? action.value : prev.lastPublishedValue,
                lastCommittedValue: shouldCommit ? action.value : prev.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        if (shouldPublish) {
            const validationError = action.name === "setValueFromField" ? action.context.validationError : validator({
                adapter: adapter,
                value: action.value,
                props: (0, $lzDk3.default)({}, props, {
                    value: action.value,
                    timezone: timezone
                })
            });
            const context = {
                validationError: validationError
            };
            // TODO v7: Remove 2nd condition
            if (action.name === "setValueFromShortcut" && action.shortcut != null) context.shortcut = action.shortcut;
            handleValueChange(action.value, context);
        }
        if (shouldCommit && onAccept) onAccept(action.value);
        if (shouldClose) setIsOpen(false);
    });
    if (inValue !== undefined && (dateState.lastControlledValue === undefined || !valueManager.areValuesEqual(utils, dateState.lastControlledValue, inValue))) {
        const isUpdateComingFromPicker = valueManager.areValuesEqual(utils, dateState.draft, inValue);
        setDateState((prev)=>(0, $lzDk3.default)({}, prev, {
                lastControlledValue: inValue
            }, isUpdateComingFromPicker ? {} : {
                lastCommittedValue: inValue,
                lastPublishedValue: inValue,
                draft: inValue,
                hasBeenModifiedSinceMount: true
            }));
    }
    const handleClear = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.emptyValue,
            name: "setValueFromAction",
            pickerAction: "clear"
        });
    });
    const handleAccept = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: "setValueFromAction",
            pickerAction: "accept"
        });
    });
    const handleDismiss = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastPublishedValue,
            name: "setValueFromAction",
            pickerAction: "dismiss"
        });
    });
    const handleCancel = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: dateState.lastCommittedValue,
            name: "setValueFromAction",
            pickerAction: "cancel"
        });
    });
    const handleSetToday = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>{
        updateDate({
            value: valueManager.getTodayValue(utils, timezone, valueType),
            name: "setValueFromAction",
            pickerAction: "today"
        });
    });
    const handleOpen = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>setIsOpen(true));
    const handleClose = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>setIsOpen(false));
    const handleChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newValue, selectionState = "partial")=>updateDate({
            name: "setValueFromView",
            value: newValue,
            selectionState: selectionState
        }));
    // TODO v7: Make changeImportance and label mandatory.
    const handleSelectShortcut = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newValue, changeImportance, shortcut)=>updateDate({
            name: "setValueFromShortcut",
            value: newValue,
            changeImportance: changeImportance != null ? changeImportance : "accept",
            shortcut: shortcut
        }));
    const handleChangeFromField = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newValue, context)=>updateDate({
            name: "setValueFromField",
            value: newValue,
            context: context
        }));
    const handleFieldSelectedSectionsChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newSelectedSections)=>{
        setSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
    });
    const actions = {
        onClear: handleClear,
        onAccept: handleAccept,
        onDismiss: handleDismiss,
        onCancel: handleCancel,
        onSetToday: handleSetToday,
        onOpen: handleOpen,
        onClose: handleClose
    };
    const fieldResponse = {
        value: dateState.draft,
        onChange: handleChangeFromField,
        selectedSections: selectedSections,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const viewValue = $4YNlq.useMemo(()=>valueManager.cleanValue(utils, dateState.draft), [
        utils,
        valueManager,
        dateState.draft
    ]);
    const viewResponse = {
        value: viewValue,
        onChange: handleChange,
        onClose: handleClose,
        open: isOpen,
        onSelectedSectionsChange: handleFieldSelectedSectionsChange
    };
    const isValid = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            props: (0, $lzDk3.default)({}, props, {
                value: testedValue,
                timezone: timezone
            })
        });
        return !valueManager.hasError(error);
    };
    const layoutResponse = (0, $lzDk3.default)({}, actions, {
        value: viewValue,
        onChange: handleChange,
        onSelectShortcut: handleSelectShortcut,
        isValid: isValid
    });
    return {
        open: isOpen,
        fieldProps: fieldResponse,
        viewProps: viewResponse,
        layoutProps: layoutResponse,
        actions: actions
    };
};



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");



var $4YNlq = parcelRequire("4YNlq");


let $f1f366fa9605ebb5$var$warnedOnceNotValidView = false;
function $f1f366fa9605ebb5$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange }) {
    var _views, _views2;
    const previousOpenTo = $4YNlq.useRef(openTo);
    const previousViews = $4YNlq.useRef(views);
    const defaultView = $4YNlq.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $5327b1b36ff53449$export$2e2bcd8739ae039)({
        name: "useViews",
        state: "view",
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $4YNlq.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $5327b1b36ff53449$export$2e2bcd8739ae039)({
        name: "useViews",
        state: "focusedView",
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    $4YNlq.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = (_views = views[viewIndex - 1]) != null ? _views : null;
    const nextView = (_views2 = views[viewIndex + 1]) != null ? _views2 : null;
    const handleFocusedViewChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange == null || onFocusedViewChange(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === "finish";
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but we it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? "partial" : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // Detects if the selected view is not the active one.
        // Can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        if (selectedView && selectedView !== view) {
            const nextViewAfterSelected = views[views.indexOf(selectedView) + 1];
            if (nextViewAfterSelected) // move to next view after the selected one
            handleChangeView(nextViewAfterSelected);
        } else if (isSelectionFinishedOnCurrentView) goToNextView();
    });
    return {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up to date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    };
}



const $2edd4ea6e2c3cb61$var$_excluded = [
    "className",
    "sx"
];
const $2edd4ea6e2c3cb61$export$c0a71b697a2df210 = ({ props: props, propsFromPickerValue: propsFromPickerValue, additionalViewProps: additionalViewProps, inputRef: inputRef, autoFocusView: autoFocusView })=>{
    const { onChange: onChange, open: open, onSelectedSectionsChange: onSelectedSectionsChange, onClose: onClose } = propsFromPickerValue;
    const { views: views, openTo: openTo, onViewChange: onViewChange, disableOpenPicker: disableOpenPicker, viewRenderers: viewRenderers, timezone: timezone } = props;
    const propsToForwardToView = (0, $g54n0.default)(props, $2edd4ea6e2c3cb61$var$_excluded);
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $f1f366fa9605ebb5$export$9b46cba8f8ccd954)({
        view: undefined,
        views: views,
        openTo: openTo,
        onChange: onChange,
        onViewChange: onViewChange,
        autoFocus: autoFocusView
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup } = $4YNlq.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            let viewMode;
            if (disableOpenPicker) viewMode = "field";
            else if (viewRenderers[viewForReduce] != null) viewMode = "UI";
            else viewMode = "field";
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === "UI") acc.hasUIView = true;
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {}
        }), [
        disableOpenPicker,
        viewRenderers,
        views
    ]);
    const timeViewsCount = $4YNlq.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            if (viewRenderers[viewForReduce] != null && (0, $3b49d946f7c9f4c7$export$8f04d380cefd5a0d)(viewForReduce)) return acc + 1;
            return acc;
        }, 0), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const shouldRestoreFocus = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>currentViewMode === "UI");
    const [popperView, setPopperView] = $4YNlq.useState(currentViewMode === "UI" ? view : null);
    if (popperView !== view && viewModeLookup[view] === "UI") setPopperView(view);
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        // Handle case of `DateTimePicker` without time renderers
        if (currentViewMode === "field" && open) {
            onClose();
            setTimeout(()=>{
                // focusing the input before the range selection is done
                // calling `onSelectedSectionsChange` outside of timeout results in an inconsistent behavior between Safari And Chrome
                inputRef == null || inputRef.current.focus();
                onSelectedSectionsChange(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        if (!open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === "field" && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === "UI" && viewModeLookup[defaultView] === "UI") newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const layoutProps = {
        views: views,
        view: popperView,
        onViewChange: setView
    };
    return {
        hasUIView: hasUIView,
        shouldRestoreFocus: shouldRestoreFocus,
        layoutProps: layoutProps,
        renderCurrentView: ()=>{
            if (popperView == null) return null;
            const renderer = viewRenderers[popperView];
            if (renderer == null) return null;
            return renderer((0, $lzDk3.default)({}, propsToForwardToView, additionalViewProps, propsFromPickerValue, {
                views: views,
                timezone: timezone,
                onChange: setValueAndGoToNextView,
                view: popperView,
                onViewChange: setView,
                focusedView: focusedView,
                onFocusedViewChange: setFocusedView,
                showViewSwitcher: timeViewsCount > 1,
                timeViewsCount: timeViewsCount
            }));
        }
    };
};



var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


function $5c50b82b994df4a6$var$getOrientation() {
    if (typeof window === "undefined") return "portrait";
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait";
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
    return "portrait";
}
const $5c50b82b994df4a6$export$6f60b24e37af6448 = (views, customOrientation)=>{
    const [orientation, setOrientation] = $4YNlq.useState($5c50b82b994df4a6$var$getOrientation);
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($5c50b82b994df4a6$var$getOrientation());
        };
        window.addEventListener("orientationchange", eventHandler);
        return ()=>{
            window.removeEventListener("orientationchange", eventHandler);
        };
    }, []);
    if ((0, $3887927531c6c329$export$22012a5c726bef55)(views, [
        "hours",
        "minutes",
        "seconds"
    ])) // could not display 13:34:44 in landscape mode
    return false;
    const orientationToUse = customOrientation || orientation;
    return orientationToUse === "landscape";
};


const $a5ea8d5039178aff$export$4e5139e5825b7b27 = ({ props: props, propsFromPickerValue: propsFromPickerValue, propsFromPickerViews: propsFromPickerViews, wrapperVariant: wrapperVariant })=>{
    const { orientation: orientation } = props;
    const isLandscape = (0, $5c50b82b994df4a6$export$6f60b24e37af6448)(propsFromPickerViews.views, orientation);
    const layoutProps = (0, $lzDk3.default)({}, propsFromPickerViews, propsFromPickerValue, {
        isLandscape: isLandscape,
        wrapperVariant: wrapperVariant,
        disabled: props.disabled,
        readOnly: props.readOnly
    });
    return {
        layoutProps: layoutProps
    };
};



const $3b3101f0c69683a4$var$warnRenderInputIsDefined = (0, $0b4d48933acfd04c$export$baf331755d84b871)([
    "The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.",
    "You can replace it with the `textField` component slot in most cases.",
    "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."
]);
const $3b3101f0c69683a4$export$fc3313977ac596c4 = ({ props: props, valueManager: valueManager, valueType: valueType, wrapperVariant: wrapperVariant, inputRef: inputRef, additionalViewProps: additionalViewProps, validator: validator, autoFocusView: autoFocusView })=>{
    const pickerValueResponse = (0, $4a004c306d3b1d55$export$799b22a7b7fffaa3)({
        props: props,
        valueManager: valueManager,
        valueType: valueType,
        wrapperVariant: wrapperVariant,
        validator: validator
    });
    const pickerViewsResponse = (0, $2edd4ea6e2c3cb61$export$c0a71b697a2df210)({
        props: props,
        inputRef: inputRef,
        additionalViewProps: additionalViewProps,
        autoFocusView: autoFocusView,
        propsFromPickerValue: pickerValueResponse.viewProps
    });
    const pickerLayoutResponse = (0, $a5ea8d5039178aff$export$4e5139e5825b7b27)({
        props: props,
        wrapperVariant: wrapperVariant,
        propsFromPickerValue: pickerValueResponse.layoutProps,
        propsFromPickerViews: pickerViewsResponse.layoutProps
    });
    return {
        // Picker value
        open: pickerValueResponse.open,
        actions: pickerValueResponse.actions,
        fieldProps: pickerValueResponse.fieldProps,
        // Picker views
        renderCurrentView: pickerViewsResponse.renderCurrentView,
        hasUIView: pickerViewsResponse.hasUIView,
        shouldRestoreFocus: pickerViewsResponse.shouldRestoreFocus,
        // Picker layout
        layoutProps: pickerLayoutResponse.layoutProps
    };
};




var $4YNlq = parcelRequire("4YNlq");

var $3iM0v = parcelRequire("3iM0v");

var $fQQpK = parcelRequire("fQQpK");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $fx4gX = parcelRequire("fx4gX");

var $auO16 = parcelRequire("auO16");
function $33cc36e24544b34e$export$1671c31de798d429(slot) {
    return (0, $fx4gX.default)("MuiPickersLayout", slot);
}
const $33cc36e24544b34e$export$7a6dac186703fe4c = (0, $auO16.default)("MuiPickersLayout", [
    "root",
    "landscape",
    "contentWrapper",
    "toolbar",
    "actionBar",
    "tabs",
    "shortcuts"
]);



var $lzDk3 = parcelRequire("lzDk3");
parcelRequire("4YNlq");


var $9JdRu = parcelRequire("9JdRu");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");
parcelRequire("4YNlq");



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $e5ad325310acb8fa$export$5e57a444791c63be(slot) {
    return (0, $fx4gX.default)("MuiDialogActions", slot);
}
const $e5ad325310acb8fa$var$dialogActionsClasses = (0, $auO16.default)("MuiDialogActions", [
    "root",
    "spacing"
]);
var $e5ad325310acb8fa$export$2e2bcd8739ae039 = $e5ad325310acb8fa$var$dialogActionsClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $c5ca48cb44878d65$var$_excluded = [
    "className",
    "disableSpacing"
];
const $c5ca48cb44878d65$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $e5ad325310acb8fa$export$5e57a444791c63be), classes);
};
const $c5ca48cb44878d65$var$DialogActionsRoot = (0, $JdaC3.default)("div", {
    name: "MuiDialogActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "flex",
        alignItems: "center",
        padding: 8,
        justifyContent: "flex-end",
        flex: "0 0 auto"
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $c5ca48cb44878d65$var$DialogActions = /*#__PURE__*/ $4YNlq.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiDialogActions"
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $g54n0.default)(props, $c5ca48cb44878d65$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $c5ca48cb44878d65$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($c5ca48cb44878d65$var$DialogActionsRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $c5ca48cb44878d65$export$2e2bcd8739ae039 = $c5ca48cb44878d65$var$DialogActions;




var $izf4p = parcelRequire("izf4p");
const $350ea3155cf3bcde$var$_excluded = [
    "onAccept",
    "onClear",
    "onCancel",
    "onSetToday",
    "actions"
];
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $350ea3155cf3bcde$export$72ffda3bb7ecf665(props) {
    const { onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, actions: actions } = props, other = (0, $g54n0.default)(props, $350ea3155cf3bcde$var$_excluded);
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions == null ? void 0 : actions.map((actionType)=>{
        switch(actionType){
            case "clear":
                return /*#__PURE__*/ (0, $izf4p.jsx)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039), {
                    onClick: onClear,
                    children: localeText.clearButtonLabel
                }, actionType);
            case "cancel":
                return /*#__PURE__*/ (0, $izf4p.jsx)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039), {
                    onClick: onCancel,
                    children: localeText.cancelButtonLabel
                }, actionType);
            case "accept":
                return /*#__PURE__*/ (0, $izf4p.jsx)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039), {
                    onClick: onAccept,
                    children: localeText.okButtonLabel
                }, actionType);
            case "today":
                return /*#__PURE__*/ (0, $izf4p.jsx)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039), {
                    onClick: onSetToday,
                    children: localeText.todayButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $c5ca48cb44878d65$export$2e2bcd8739ae039), (0, $lzDk3.default)({}, other, {
        children: buttons
    }));
}




var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");
parcelRequire("4YNlq");




var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $309LR = parcelRequire("309LR");
parcelRequire("4YNlq");

var $7ipzf = parcelRequire("7ipzf");

var $izf4p = parcelRequire("izf4p");
"use client";
var $f6b379a753ddcc9b$export$2e2bcd8739ae039 = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");





var $2qCAA = parcelRequire("2qCAA");


var $4Q3YJ = parcelRequire("4Q3YJ");

var $JdaC3 = parcelRequire("JdaC3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $ced3f653e6f761e4$export$31444911e4ee6fdd(slot) {
    return (0, $fx4gX.default)("MuiChip", slot);
}
const $ced3f653e6f761e4$var$chipClasses = (0, $auO16.default)("MuiChip", [
    "root",
    "sizeSmall",
    "sizeMedium",
    "colorError",
    "colorInfo",
    "colorPrimary",
    "colorSecondary",
    "colorSuccess",
    "colorWarning",
    "disabled",
    "clickable",
    "clickableColorPrimary",
    "clickableColorSecondary",
    "deletable",
    "deletableColorPrimary",
    "deletableColorSecondary",
    "outlined",
    "filled",
    "outlinedPrimary",
    "outlinedSecondary",
    "filledPrimary",
    "filledSecondary",
    "avatar",
    "avatarSmall",
    "avatarMedium",
    "avatarColorPrimary",
    "avatarColorSecondary",
    "icon",
    "iconSmall",
    "iconMedium",
    "iconColorPrimary",
    "iconColorSecondary",
    "label",
    "labelSmall",
    "labelMedium",
    "deleteIcon",
    "deleteIconSmall",
    "deleteIconMedium",
    "deleteIconColorPrimary",
    "deleteIconColorSecondary",
    "deleteIconOutlinedColorPrimary",
    "deleteIconOutlinedColorSecondary",
    "deleteIconFilledColorPrimary",
    "deleteIconFilledColorSecondary",
    "focusVisible"
]);
var $ced3f653e6f761e4$export$2e2bcd8739ae039 = $ced3f653e6f761e4$var$chipClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $602fe3d1fce6d807$var$_excluded = [
    "avatar",
    "className",
    "clickable",
    "color",
    "component",
    "deleteIcon",
    "disabled",
    "icon",
    "label",
    "onClick",
    "onDelete",
    "onKeyDown",
    "onKeyUp",
    "size",
    "variant",
    "tabIndex",
    "skipFocusWhenDisabled"
];
const $602fe3d1fce6d807$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            "root",
            variant,
            disabled && "disabled",
            `size${(0, $2qCAA.default)(size)}`,
            `color${(0, $2qCAA.default)(color)}`,
            clickable && "clickable",
            clickable && `clickableColor${(0, $2qCAA.default)(color)}`,
            onDelete && "deletable",
            onDelete && `deletableColor${(0, $2qCAA.default)(color)}`,
            `${variant}${(0, $2qCAA.default)(color)}`
        ],
        label: [
            "label",
            `label${(0, $2qCAA.default)(size)}`
        ],
        avatar: [
            "avatar",
            `avatar${(0, $2qCAA.default)(size)}`,
            `avatarColor${(0, $2qCAA.default)(color)}`
        ],
        icon: [
            "icon",
            `icon${(0, $2qCAA.default)(size)}`,
            `iconColor${(0, $2qCAA.default)(iconColor)}`
        ],
        deleteIcon: [
            "deleteIcon",
            `deleteIcon${(0, $2qCAA.default)(size)}`,
            `deleteIconColor${(0, $2qCAA.default)(color)}`,
            `deleteIcon${(0, $2qCAA.default)(variant)}Color${(0, $2qCAA.default)(color)}`
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $ced3f653e6f761e4$export$31444911e4ee6fdd), classes);
};
const $602fe3d1fce6d807$var$ChipRoot = (0, $JdaC3.default)("div", {
    name: "MuiChip",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $2qCAA.default)(size)}`]
            },
            {
                [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $2qCAA.default)(color)}`]
            },
            {
                [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $2qCAA.default)(size)}`]
            },
            {
                [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $2qCAA.default)(iconColor)}`]
            },
            {
                [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $2qCAA.default)(size)}`]
            },
            {
                [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $2qCAA.default)(color)}`]
            },
            {
                [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $2qCAA.default)(variant)}Color${(0, $2qCAA.default)(color)}`]
            },
            styles.root,
            styles[`size${(0, $2qCAA.default)(size)}`],
            styles[`color${(0, $2qCAA.default)(color)}`],
            clickable && styles.clickable,
            clickable && color !== "default" && styles[`clickableColor${(0, $2qCAA.default)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== "default" && styles[`deletableColor${(0, $2qCAA.default)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $2qCAA.default)(color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const textColor = theme.palette.mode === "light" ? theme.palette.grey[700] : theme.palette.grey[300];
    return (0, $lzDk3.default)({
        maxWidth: "100%",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 32,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: "nowrap",
        transition: theme.transitions.create([
            "background-color",
            "box-shadow"
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: "unset",
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: "none",
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: "middle",
        boxSizing: "border-box",
        [`&.${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: "none"
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).icon}`]: (0, $lzDk3.default)({
            marginLeft: 5,
            marginRight: -6
        }, ownerState.size === "small" && {
            fontSize: 18,
            marginLeft: 4,
            marginRight: -4
        }, ownerState.iconColor === ownerState.color && (0, $lzDk3.default)({
            color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
        }, ownerState.color !== "default" && {
            color: "inherit"
        })),
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).deleteIcon}`]: (0, $lzDk3.default)({
            WebkitTapHighlightColor: "transparent",
            color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.26)` : (0, $309LR.alpha)(theme.palette.text.primary, 0.26),
            fontSize: 22,
            cursor: "pointer",
            margin: "0 5px 0 -6px",
            "&:hover": {
                color: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / 0.4)` : (0, $309LR.alpha)(theme.palette.text.primary, 0.4)
            }
        }, ownerState.size === "small" && {
            fontSize: 16,
            marginRight: 4,
            marginLeft: -4
        }, ownerState.color !== "default" && {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].contrastTextChannel} / 0.7)` : (0, $309LR.alpha)(theme.palette[ownerState.color].contrastText, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].contrastText
            }
        })
    }, ownerState.size === "small" && {
        height: 24
    }, ownerState.color !== "default" && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.onDelete && {
        [`&.${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $309LR.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        }
    }, ownerState.onDelete && ownerState.color !== "default" && {
        [`&.${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    });
}, ({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({}, ownerState.clickable && {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $309LR.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.selectedChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $309LR.alpha)(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
        },
        "&:active": {
            boxShadow: (theme.vars || theme).shadows[1]
        }
    }, ownerState.clickable && ownerState.color !== "default" && {
        [`&:hover, &.${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({}, ownerState.variant === "outlined" && {
        backgroundColor: "transparent",
        border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[700]}`,
        [`&.${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 4
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 4
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).iconSmall}`]: {
            marginLeft: 2
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).deleteIcon}`]: {
            marginRight: 5
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).deleteIconSmall}`]: {
            marginRight: 3
        }
    }, ownerState.variant === "outlined" && ownerState.color !== "default" && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: `1px solid ${theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $309LR.alpha)(theme.palette[ownerState.color].main, 0.7)}`,
        [`&.${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).clickable}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $309LR.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
        },
        [`&.${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $309LR.alpha)(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
        },
        [`& .${(0, $ced3f653e6f761e4$export$2e2bcd8739ae039).deleteIcon}`]: {
            color: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.7)` : (0, $309LR.alpha)(theme.palette[ownerState.color].main, 0.7),
            "&:hover, &:active": {
                color: (theme.vars || theme).palette[ownerState.color].main
            }
        }
    }));
const $602fe3d1fce6d807$var$ChipLabel = (0, $JdaC3.default)("span", {
    name: "MuiChip",
    slot: "Label",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $2qCAA.default)(size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        overflow: "hidden",
        textOverflow: "ellipsis",
        paddingLeft: 12,
        paddingRight: 12,
        whiteSpace: "nowrap"
    }, ownerState.variant === "outlined" && {
        paddingLeft: 11,
        paddingRight: 11
    }, ownerState.size === "small" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.size === "small" && ownerState.variant === "outlined" && {
        paddingLeft: 7,
        paddingRight: 7
    }));
function $602fe3d1fce6d807$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $602fe3d1fce6d807$var$Chip = /*#__PURE__*/ $4YNlq.forwardRef(function Chip(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiChip"
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = "default", component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = "medium", variant: variant = "filled", tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false // TODO v6: Rename to `focusableWhenDisabled`.
     } = props, other = (0, $g54n0.default)(props, $602fe3d1fce6d807$var$_excluded);
    const chipRef = $4YNlq.useRef(null);
    const handleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $602fe3d1fce6d807$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $602fe3d1fce6d807$var$isDeleteKeyboardEvent(event)) onDelete(event);
            else if (event.key === "Escape" && chipRef.current) chipRef.current.blur();
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $7e17388639953587$export$2e2bcd8739ae039) : ComponentProp || "div";
    const ownerState = (0, $lzDk3.default)({}, props, {
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $4YNlq.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    });
    const classes = $602fe3d1fce6d807$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $7e17388639953587$export$2e2bcd8739ae039) ? (0, $lzDk3.default)({
        component: ComponentProp || "div",
        focusVisibleClassName: classes.focusVisible
    }, onDelete && {
        disableRipple: true
    }) : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $4YNlq.isValidElement(deleteIconProp) ? /*#__PURE__*/ $4YNlq.cloneElement(deleteIconProp, {
        className: (0, $fQQpK.default)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $izf4p.jsx)((0, $f6b379a753ddcc9b$export$2e2bcd8739ae039), {
        className: (0, $fQQpK.default)(classes.deleteIcon),
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $4YNlq.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $4YNlq.cloneElement(avatarProp, {
        className: (0, $fQQpK.default)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $4YNlq.isValidElement(iconProp)) icon = /*#__PURE__*/ $4YNlq.cloneElement(iconProp, {
        className: (0, $fQQpK.default)(classes.icon, iconProp.props.className)
    });
    return /*#__PURE__*/ (0, $izf4p.jsxs)($602fe3d1fce6d807$var$ChipRoot, (0, $lzDk3.default)({
        as: component,
        className: (0, $fQQpK.default)(classes.root, className),
        disabled: clickable && disabled ? true : undefined,
        onClick: onClick,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: handleRef,
        tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
        ownerState: ownerState
    }, moreProps, other, {
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $izf4p.jsx)($602fe3d1fce6d807$var$ChipLabel, {
                className: (0, $fQQpK.default)(classes.label),
                ownerState: ownerState,
                children: label
            }),
            deleteIcon
        ]
    }));
});
var $602fe3d1fce6d807$export$2e2bcd8739ae039 = $602fe3d1fce6d807$var$Chip;


const $8723b6bc9525bc47$export$3f0060ce4cc8f4d0 = 36;
const $8723b6bc9525bc47$export$dde58b009b497666 = 2;
const $8723b6bc9525bc47$export$ee46b8a74d6c94d3 = 320;
const $8723b6bc9525bc47$export$73724491020e90c7 = 280;
const $8723b6bc9525bc47$export$f2fef360e2df0cb7 = 334;
const $8723b6bc9525bc47$export$1c2eabda4acea0e4 = 232;
const $8723b6bc9525bc47$export$a462ceb9cfdb5d71 = 48;



var $izf4p = parcelRequire("izf4p");
const $a5a0024dc05fb5c6$var$_excluded = [
    "items",
    "changeImportance",
    "isLandscape",
    "onChange",
    "isValid"
], $a5a0024dc05fb5c6$var$_excluded2 = [
    "getValue"
];
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $a5a0024dc05fb5c6$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance, onChange: onChange, isValid: isValid } = props, other = (0, $g54n0.default)(props, $a5a0024dc05fb5c6$var$_excluded);
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $g54n0.default)(_ref, $a5a0024dc05fb5c6$var$_excluded2);
        const newValue = getValue({
            isValid: isValid
        });
        return {
            label: item.label,
            onClick: ()=>{
                onChange(newValue, changeImportance, item);
            },
            disabled: !isValid(newValue)
        };
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $a9f02ffffb31630e$export$2e2bcd8739ae039), (0, $lzDk3.default)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $8723b6bc9525bc47$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: "auto"
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $izf4p.jsx)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $602fe3d1fce6d807$export$2e2bcd8739ae039), (0, $lzDk3.default)({}, item))
            }, item.label);
        })
    }));
}




var $izf4p = parcelRequire("izf4p");
function $b783e444921fd189$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $b783e444921fd189$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isLandscape: isLandscape } = ownerState;
    const slots = {
        root: [
            "root",
            isLandscape && "landscape"
        ],
        contentWrapper: [
            "contentWrapper"
        ],
        toolbar: [
            "toolbar"
        ],
        actionBar: [
            "actionBar"
        ],
        tabs: [
            "tabs"
        ],
        landscape: [
            "landscape"
        ],
        shortcuts: [
            "shortcuts"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $33cc36e24544b34e$export$1671c31de798d429), classes);
};
const $b783e444921fd189$var$usePickerLayout = (props)=>{
    var _slots$actionBar, _slots$shortcuts;
    const { wrapperVariant: wrapperVariant, onAccept: onAccept, onClear: onClear, onCancel: onCancel, onSetToday: onSetToday, view: view, views: views, onViewChange: onViewChange, value: value, onChange: onChange, onSelectShortcut: onSelectShortcut, isValid: isValid, isLandscape: isLandscape, disabled: disabled, readOnly: readOnly, children: children, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps } = props;
    const slots = innerSlots != null ? innerSlots : (0, $42fcfbc058f0ed42$export$ee17bc394843b249)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const classes = $b783e444921fd189$var$useUtilityClasses(props);
    // Action bar
    const ActionBar = (_slots$actionBar = slots == null ? void 0 : slots.actionBar) != null ? _slots$actionBar : (0, $350ea3155cf3bcde$export$72ffda3bb7ecf665);
    const actionBarProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: ActionBar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.actionBar,
        additionalProps: {
            onAccept: onAccept,
            onClear: onClear,
            onCancel: onCancel,
            onSetToday: onSetToday,
            actions: wrapperVariant === "desktop" ? [] : [
                "cancel",
                "accept"
            ],
            className: classes.actionBar
        },
        ownerState: (0, $lzDk3.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const actionBar = /*#__PURE__*/ (0, $izf4p.jsx)(ActionBar, (0, $lzDk3.default)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots == null ? void 0 : slots.toolbar;
    const toolbarProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: Toolbar,
        externalSlotProps: slotProps == null ? void 0 : slotProps.toolbar,
        additionalProps: {
            isLandscape: isLandscape,
            onChange: onChange,
            value: value,
            view: view,
            onViewChange: onViewChange,
            views: views,
            disabled: disabled,
            readOnly: readOnly,
            className: classes.toolbar
        },
        ownerState: (0, $lzDk3.default)({}, props, {
            wrapperVariant: wrapperVariant
        })
    });
    const toolbar = $b783e444921fd189$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $izf4p.jsx)(Toolbar, (0, $lzDk3.default)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots == null ? void 0 : slots.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $izf4p.jsx)(Tabs, (0, $lzDk3.default)({
        view: view,
        onViewChange: onViewChange,
        className: classes.tabs
    }, slotProps == null ? void 0 : slotProps.tabs)) : null;
    // Shortcuts
    const Shortcuts = (_slots$shortcuts = slots == null ? void 0 : slots.shortcuts) != null ? _slots$shortcuts : (0, $a5a0024dc05fb5c6$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: Shortcuts,
        externalSlotProps: slotProps == null ? void 0 : slotProps.shortcuts,
        additionalProps: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts
        },
        ownerState: {
            isValid: isValid,
            isLandscape: isLandscape,
            onChange: onSelectShortcut,
            className: classes.shortcuts,
            wrapperVariant: wrapperVariant
        }
    });
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $izf4p.jsx)(Shortcuts, (0, $lzDk3.default)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts
    };
};
var $b783e444921fd189$export$2e2bcd8739ae039 = $b783e444921fd189$var$usePickerLayout;



var $izf4p = parcelRequire("izf4p");
const $796538715ef9c40d$var$useUtilityClasses = (ownerState)=>{
    const { isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            isLandscape && "landscape"
        ],
        contentWrapper: [
            "contentWrapper"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $33cc36e24544b34e$export$1671c31de798d429), classes);
};
const $796538715ef9c40d$export$9a9363506c13836 = (0, $JdaC3.default)("div", {
    name: "MuiPickersLayout",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        display: "grid",
        gridAutoColumns: "max-content auto max-content",
        gridAutoRows: "max-content auto max-content",
        [`& .${(0, $33cc36e24544b34e$export$7a6dac186703fe4c).toolbar}`]: ownerState.isLandscape ? {
            gridColumn: theme.direction === "rtl" ? 3 : 1,
            gridRow: "2 / 3"
        } : {
            gridColumn: "2 / 4",
            gridRow: 1
        },
        [`.${(0, $33cc36e24544b34e$export$7a6dac186703fe4c).shortcuts}`]: ownerState.isLandscape ? {
            gridColumn: "2 / 4",
            gridRow: 1
        } : {
            gridColumn: theme.direction === "rtl" ? 3 : 1,
            gridRow: "2 / 3"
        },
        [`& .${(0, $33cc36e24544b34e$export$7a6dac186703fe4c).actionBar}`]: {
            gridColumn: "1 / 4",
            gridRow: 3
        }
    }));
$796538715ef9c40d$export$9a9363506c13836.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).shape({
        isLandscape: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool.isRequired
    }).isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object
    ])
};
const $796538715ef9c40d$export$bc1494d918129235 = (0, $JdaC3.default)("div", {
    name: "MuiPickersLayout",
    slot: "ContentWrapper",
    overridesResolver: (props, styles)=>styles.contentWrapper
})({
    gridColumn: 2,
    gridRow: 2,
    display: "flex",
    flexDirection: "column"
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $796538715ef9c40d$export$647f604ea2397c05 = function PickersLayout(inProps) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersLayout"
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts } = (0, $b783e444921fd189$export$2e2bcd8739ae039)(props);
    const { sx: sx, className: className, isLandscape: isLandscape, ref: ref, wrapperVariant: wrapperVariant } = props;
    const ownerState = props;
    const classes = $796538715ef9c40d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($796538715ef9c40d$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $fQQpK.default)(className, classes.root),
        ownerState: ownerState,
        children: [
            isLandscape ? shortcuts : toolbar,
            isLandscape ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $izf4p.jsx)($796538715ef9c40d$export$bc1494d918129235, {
                className: classes.contentWrapper,
                children: wrapperVariant === "desktop" ? /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
};



var $izf4p = parcelRequire("izf4p");
const $d093faa8b3894bf6$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
], $d093faa8b3894bf6$var$_excluded2 = [
    "ownerState"
], $d093faa8b3894bf6$var$_excluded3 = [
    "ownerState"
];
const $d093faa8b3894bf6$export$b1b70bc56ac5be0e = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$inputAdornment, _slots$openPickerButt, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $g54n0.default)(_ref, $d093faa8b3894bf6$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, localeText: localeText, reduceAnimations: reduceAnimations } = props;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const internalInputRef = $4YNlq.useRef(null);
    const containerRef = $4YNlq.useRef(null);
    const labelId = (0, $f7c9c9374bbf09f1$export$2e2bcd8739ae039)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, hasUIView: hasUIView, layoutProps: layoutProps, renderCurrentView: renderCurrentView, shouldRestoreFocus: shouldRestoreFocus, fieldProps: pickerFieldProps } = (0, $3b3101f0c69683a4$export$fc3313977ac596c4)((0, $lzDk3.default)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: "desktop"
    }));
    const InputAdornment = (_slots$inputAdornment = slots.inputAdornment) != null ? _slots$inputAdornment : (0, $d4adfbd348f78fa8$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: InputAdornment,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.inputAdornment,
        additionalProps: {
            position: "end"
        },
        ownerState: props
    }), inputAdornmentProps = (0, $g54n0.default)(_useSlotProps, $d093faa8b3894bf6$var$_excluded2);
    const OpenPickerButton = (_slots$openPickerButt = slots.openPickerButton) != null ? _slots$openPickerButt : (0, $81fc785263d7b0b1$export$2e2bcd8739ae039);
    const _useSlotProps2 = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: OpenPickerButton,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.openPickerButton,
        additionalProps: {
            disabled: disabled || readOnly,
            onClick: open ? actions.onClose : actions.onOpen,
            "aria-label": getOpenDialogAriaText(pickerFieldProps.value, utils),
            edge: inputAdornmentProps.position
        },
        ownerState: props
    }), openPickerButtonProps = (0, $g54n0.default)(_useSlotProps2, $d093faa8b3894bf6$var$_excluded3);
    const OpenPickerIcon = slots.openPickerIcon;
    const Field = slots.field;
    const fieldProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $lzDk3.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, {
            readOnly: readOnly,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label,
            name: name,
            autoFocus: autoFocus && !props.open,
            focused: open ? true : undefined
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    if (hasUIView) fieldProps.InputProps = (0, $lzDk3.default)({}, fieldProps.InputProps, {
        ref: containerRef,
        [`${inputAdornmentProps.position}Adornment`]: /*#__PURE__*/ (0, $izf4p.jsx)(InputAdornment, (0, $lzDk3.default)({}, inputAdornmentProps, {
            children: /*#__PURE__*/ (0, $izf4p.jsx)(OpenPickerButton, (0, $lzDk3.default)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $izf4p.jsx)(OpenPickerIcon, (0, $lzDk3.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.openPickerIcon))
            }))
        }))
    });
    const slotsForField = (0, $lzDk3.default)({
        textField: slots.textField,
        clearIcon: slots.clearIcon,
        clearButton: slots.clearButton
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $796538715ef9c40d$export$647f604ea2397c05);
    const handleInputRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $lzDk3.default)({}, innerSlotProps, {
        toolbar: (0, $lzDk3.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        popper: (0, $lzDk3.default)({
            "aria-labelledby": labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $izf4p.jsxs)((0, $f34cc3f354a72d02$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $izf4p.jsx)(Field, (0, $lzDk3.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $izf4p.jsx)((0, $36d6225a6812ae9d$export$96ce8482474de8a5), (0, $lzDk3.default)({
                    role: "dialog",
                    placement: "bottom-start",
                    anchorEl: containerRef.current
                }, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    shouldRestoreFocus: shouldRestoreFocus,
                    reduceAnimations: reduceAnimations,
                    children: /*#__PURE__*/ (0, $izf4p.jsx)(Layout, (0, $lzDk3.default)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};



var $7ipzf = parcelRequire("7ipzf");

var $4YNlq = parcelRequire("4YNlq");

var $izf4p = parcelRequire("izf4p");
const $bb40f620f6ea1524$export$ed0fe318cc298673 = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
const $bb40f620f6ea1524$export$8afed21ef5c2afa5 = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft");
const $bb40f620f6ea1524$export$9ca09caa9c849d9c = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight");
const $bb40f620f6ea1524$export$5fda1783bb83f57b = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
const $bb40f620f6ea1524$export$8099ab97743c966c = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
    children: [
        /*#__PURE__*/ (0, $izf4p.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $izf4p.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Clock");
const $bb40f620f6ea1524$export$90a8eab2a2411720 = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
const $bb40f620f6ea1524$export$7e95adcf912503e3 = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
    children: [
        /*#__PURE__*/ (0, $izf4p.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $izf4p.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), "Time");
const $bb40f620f6ea1524$export$cefbac224a47f32 = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");



var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $9JdRu = parcelRequire("9JdRu");

var $c4QxQ = parcelRequire("c4QxQ");


var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $7y3ET = parcelRequire("7y3ET");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $d13ef127cb1489af$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}



var $izf4p = parcelRequire("izf4p");
"use client";
const $e50c1a234620986e$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $e50c1a234620986e$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $e50c1a234620986e$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: "hidden",
        // Remove from the content flow
        position: "absolute",
        // Ignore the scrollbar width
        overflow: "hidden",
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: "translateZ(0)"
    }
};
function $e50c1a234620986e$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base-ui/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base-ui/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $e50c1a234620986e$export$d1710922ecaf577a = /*#__PURE__*/ $4YNlq.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $g54n0.default)(props, $e50c1a234620986e$var$_excluded);
    const { current: isControlled } = $4YNlq.useRef(value != null);
    const inputRef = $4YNlq.useRef(null);
    const handleRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $4YNlq.useRef(null);
    const calculateTextareaStyles = $4YNlq.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $33a8375cbc96cc03$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === "0px") return {
            outerHeightStyle: 0,
            overflowing: false
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || "x";
        if (inputShallow.value.slice(-1) === "\n") // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += " ";
        const boxSizing = computedStyle.boxSizing;
        const padding = $e50c1a234620986e$var$getStyleValue(computedStyle.paddingBottom) + $e50c1a234620986e$var$getStyleValue(computedStyle.paddingTop);
        const border = $e50c1a234620986e$var$getStyleValue(computedStyle.borderBottomWidth) + $e50c1a234620986e$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = "x";
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const syncHeight = $4YNlq.useCallback(()=>{
        const textareaStyles = calculateTextareaStyles();
        if ($e50c1a234620986e$var$isEmpty(textareaStyles)) return;
        const input = inputRef.current;
        input.style.height = `${textareaStyles.outerHeightStyle}px`;
        input.style.overflow = textareaStyles.overflowing ? "hidden" : "";
    }, [
        calculateTextareaStyles
    ]);
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        const handleResize = ()=>{
            syncHeight();
        };
        // Workaround a "ResizeObserver loop completed with undelivered notifications" error
        // in test.
        // Note that we might need to use this logic in production per https://github.com/WICG/resize-observer/issues/38
        // Also see https://github.com/mui/mui-x/issues/8733
        let rAF;
        const rAFHandleResize = ()=>{
            cancelAnimationFrame(rAF);
            rAF = requestAnimationFrame(()=>{
                handleResize();
            });
        };
        const debounceHandleResize = (0, $d13ef127cb1489af$export$2e2bcd8739ae039)(handleResize);
        const input = inputRef.current;
        const containerWindow = (0, $33a8375cbc96cc03$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener("resize", debounceHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            debounceHandleResize.clear();
            cancelAnimationFrame(rAF);
            containerWindow.removeEventListener("resize", debounceHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight
    ]);
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)("textarea", (0, $lzDk3.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows
            }, other)),
            /*#__PURE__*/ (0, $izf4p.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $lzDk3.default)({}, $e50c1a234620986e$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});




var $9JdRu = parcelRequire("9JdRu");
function $dd55e33f0dc69096$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === "undefined") acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}





var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $2qCAA = parcelRequire("2qCAA");



var $lzDk3 = parcelRequire("lzDk3");
parcelRequire("4YNlq");

parcelRequire("4YNlq");


var $hQFs4 = parcelRequire("hQFs4");

var $6SUx4 = parcelRequire("6SUx4");

var $izf4p = parcelRequire("izf4p");
"use client";
function $66196d8b6f6837d2$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $6SUx4.default)(defaultTheme);
    const globalStyles = typeof styles === "function" ? styles(themeId ? upperTheme[themeId] || upperTheme : upperTheme) : styles;
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $hQFs4.default), {
        styles: globalStyles
    });
}
var $66196d8b6f6837d2$export$2e2bcd8739ae039 = $66196d8b6f6837d2$var$GlobalStyles;



var $1w9Ux = parcelRequire("1w9Ux");

var $dRtc1 = parcelRequire("dRtc1");

var $izf4p = parcelRequire("izf4p");
"use client";
function $ce768c6bb73e0343$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $66196d8b6f6837d2$export$2e2bcd8739ae039), (0, $lzDk3.default)({}, props, {
        defaultTheme: (0, $1w9Ux.default),
        themeId: (0, $dRtc1.default)
    }));
}
var $ce768c6bb73e0343$export$2e2bcd8739ae039 = $ce768c6bb73e0343$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $6236975eac43573a$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $6236975eac43573a$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($6236975eac43573a$export$96bdbc84526f3739(obj.value) && obj.value !== "" || SSR && $6236975eac43573a$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== "");
}
function $6236975eac43573a$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $9427f503552dbd46$export$ef57d5c8ca2278f6(slot) {
    return (0, $fx4gX.default)("MuiInputBase", slot);
}
const $9427f503552dbd46$var$inputBaseClasses = (0, $auO16.default)("MuiInputBase", [
    "root",
    "formControl",
    "focused",
    "disabled",
    "adornedStart",
    "adornedEnd",
    "error",
    "sizeSmall",
    "multiline",
    "colorSecondary",
    "fullWidth",
    "hiddenLabel",
    "readOnly",
    "input",
    "inputSizeSmall",
    "inputMultiline",
    "inputTypeSearch",
    "inputAdornedStart",
    "inputAdornedEnd",
    "inputHiddenLabel"
]);
var $9427f503552dbd46$export$2e2bcd8739ae039 = $9427f503552dbd46$var$inputBaseClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $04b8378efe120e28$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $04b8378efe120e28$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === "small" && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $2qCAA.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $04b8378efe120e28$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === "small" && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === "search" && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $04b8378efe120e28$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $2qCAA.default)(color)}`,
            disabled && "disabled",
            error && "error",
            fullWidth && "fullWidth",
            focused && "focused",
            formControl && "formControl",
            size && size !== "medium" && `size${(0, $2qCAA.default)(size)}`,
            multiline && "multiline",
            startAdornment && "adornedStart",
            endAdornment && "adornedEnd",
            hiddenLabel && "hiddenLabel",
            readOnly && "readOnly"
        ],
        input: [
            "input",
            disabled && "disabled",
            type === "search" && "inputTypeSearch",
            multiline && "inputMultiline",
            size === "small" && "inputSizeSmall",
            hiddenLabel && "inputHiddenLabel",
            startAdornment && "inputAdornedStart",
            endAdornment && "inputAdornedEnd",
            readOnly && "readOnly"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $9427f503552dbd46$export$ef57d5c8ca2278f6), classes);
};
const $04b8378efe120e28$export$298a043133d72a38 = (0, $JdaC3.default)("div", {
    name: "MuiInputBase",
    slot: "Root",
    overridesResolver: $04b8378efe120e28$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: "1.4375em",
        // 23px
        boxSizing: "border-box",
        // Prevent padding issue with fullWidth.
        position: "relative",
        cursor: "text",
        display: "inline-flex",
        alignItems: "center",
        [`&.${(0, $9427f503552dbd46$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: "default"
        }
    }, ownerState.multiline && (0, $lzDk3.default)({
        padding: "4px 0 5px"
    }, ownerState.size === "small" && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: "100%"
    }));
const $04b8378efe120e28$export$a1ad29c901026019 = (0, $JdaC3.default)("input", {
    name: "MuiInputBase",
    slot: "Input",
    overridesResolver: $04b8378efe120e28$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    const placeholder = (0, $lzDk3.default)({
        color: "currentColor"
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: "0 !important"
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $lzDk3.default)({
        font: "inherit",
        letterSpacing: "inherit",
        color: "currentColor",
        padding: "4px 0 5px",
        border: 0,
        boxSizing: "content-box",
        background: "none",
        height: "1.4375em",
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: "transparent",
        display: "block",
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: "100%",
        // Fix IE11 width issue
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&::-webkit-input-placeholder": placeholder,
        "&::-moz-placeholder": placeholder,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholder,
        // IE11
        "&::-ms-input-placeholder": placeholder,
        // Edge
        "&:focus": {
            outline: 0
        },
        // Reset Firefox invalid required input style
        "&:invalid": {
            boxShadow: "none"
        },
        "&::-webkit-search-decoration": {
            // Remove the padding when type=search.
            WebkitAppearance: "none"
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $9427f503552dbd46$export$2e2bcd8739ae039).formControl} &`]: {
            "&::-webkit-input-placeholder": placeholderHidden,
            "&::-moz-placeholder": placeholderHidden,
            // Firefox 19+
            "&:-ms-input-placeholder": placeholderHidden,
            // IE11
            "&::-ms-input-placeholder": placeholderHidden,
            // Edge
            "&:focus::-webkit-input-placeholder": placeholderVisible,
            "&:focus::-moz-placeholder": placeholderVisible,
            // Firefox 19+
            "&:focus:-ms-input-placeholder": placeholderVisible,
            // IE11
            "&:focus::-ms-input-placeholder": placeholderVisible // Edge
        },
        [`&.${(0, $9427f503552dbd46$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        "&:-webkit-autofill": {
            animationDuration: "5000s",
            animationName: "mui-auto-fill"
        }
    }, ownerState.size === "small" && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
    }, ownerState.type === "search" && {
        // Improve type search style.
        MozAppearance: "textfield"
    });
});
const $04b8378efe120e28$var$inputGlobalStyles = /*#__PURE__*/ (0, $izf4p.jsx)((0, $ce768c6bb73e0343$export$2e2bcd8739ae039), {
    styles: {
        "@keyframes mui-auto-fill": {
            from: {
                display: "block"
            }
        },
        "@keyframes mui-auto-fill-cancel": {
            from: {
                display: "block"
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $04b8378efe120e28$var$InputBase = /*#__PURE__*/ $4YNlq.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiInputBase"
    });
    const { "aria-describedby": ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = "input", inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = "text", value: valueProp } = props, other = (0, $g54n0.default)(props, $04b8378efe120e28$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $4YNlq.useRef(value != null);
    const inputRef = $4YNlq.useRef();
    const handleInputRefWarning = $4YNlq.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $4019772905761825$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $4YNlq.useState(false);
    const muiFormControl = (0, $cfa3bdf64b9b659c$export$2e2bcd8739ae039)();
    const fcs = (0, $dd55e33f0dc69096$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "hiddenLabel",
            "size",
            "required",
            "filled"
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $4YNlq.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $4YNlq.useCallback((obj)=>{
        if ((0, $6236975eac43573a$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $64a26410cabc30a1$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $7y3ET.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $4YNlq.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === "input") {
        if (rows) inputProps = (0, $lzDk3.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $lzDk3.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $e50c1a234620986e$export$d1710922ecaf577a);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
            value: "x"
        });
    };
    $4YNlq.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $lzDk3.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $04b8378efe120e28$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $04b8378efe120e28$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $04b8378efe120e28$export$a1ad29c901026019;
    inputProps = (0, $lzDk3.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $04b8378efe120e28$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $izf4p.jsxs)(Root, (0, $lzDk3.default)({}, rootProps, !(0, $af94551ec12d5eb4$export$e28348cc2430497)(Root) && {
                ownerState: (0, $lzDk3.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $fQQpK.default)(classes.root, rootProps.className, className, readOnly && "MuiInputBase-readOnly"),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $d9e9a8e4dc077124$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $izf4p.jsx)(Input, (0, $lzDk3.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $af94551ec12d5eb4$export$e28348cc2430497)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $lzDk3.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $fQQpK.default)(classes.input, inputProps.className, readOnly && "MuiInputBase-readOnly"),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $lzDk3.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $04b8378efe120e28$export$2e2bcd8739ae039 = $04b8378efe120e28$var$InputBase;



var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $lzDk3 = parcelRequire("lzDk3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");

function $46c283e37f5fade4$export$cdb270390122322b(slot) {
    return (0, $fx4gX.default)("MuiInput", slot);
}
const $46c283e37f5fade4$var$inputClasses = (0, $lzDk3.default)({}, (0, $9427f503552dbd46$export$2e2bcd8739ae039), (0, $auO16.default)("MuiInput", [
    "root",
    "underline",
    "input"
]));
var $46c283e37f5fade4$export$2e2bcd8739ae039 = $46c283e37f5fade4$var$inputClasses;




var $izf4p = parcelRequire("izf4p");
"use client";
const $e7ed1b43ca2bbe28$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e7ed1b43ca2bbe28$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9JdRu.default)(slots, (0, $46c283e37f5fade4$export$cdb270390122322b), classes);
    return (0, $lzDk3.default)({}, classes, composedClasses);
};
const $e7ed1b43ca2bbe28$var$InputRoot = (0, $JdaC3.default)((0, $04b8378efe120e28$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $JdaC3.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $04b8378efe120e28$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === "light";
    let bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $lzDk3.default)({
        position: "relative"
    }, ownerState.formControl && {
        "label + &": {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $46c283e37f5fade4$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $46c283e37f5fade4$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $46c283e37f5fade4$export$2e2bcd8739ae039).disabled}, .${(0, $46c283e37f5fade4$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $46c283e37f5fade4$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    });
});
const $e7ed1b43ca2bbe28$var$InputInput = (0, $JdaC3.default)((0, $04b8378efe120e28$export$a1ad29c901026019), {
    name: "MuiInput",
    slot: "Input",
    overridesResolver: (0, $04b8378efe120e28$export$cf507b112810e72d)
})({});
const $e7ed1b43ca2bbe28$var$Input = /*#__PURE__*/ $4YNlq.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiInput"
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $g54n0.default)(props, $e7ed1b43ca2bbe28$var$_excluded);
    const classes = $e7ed1b43ca2bbe28$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $c4QxQ.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e7ed1b43ca2bbe28$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e7ed1b43ca2bbe28$var$InputInput;
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $04b8378efe120e28$export$2e2bcd8739ae039), (0, $lzDk3.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e7ed1b43ca2bbe28$var$Input.muiName = "Input";
var $e7ed1b43ca2bbe28$export$2e2bcd8739ae039 = $e7ed1b43ca2bbe28$var$Input;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $c4QxQ = parcelRequire("c4QxQ");



var $9JdRu = parcelRequire("9JdRu");


var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $lzDk3 = parcelRequire("lzDk3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");

function $938ab69807736126$export$3331e419f1a48437(slot) {
    return (0, $fx4gX.default)("MuiFilledInput", slot);
}
const $938ab69807736126$var$filledInputClasses = (0, $lzDk3.default)({}, (0, $9427f503552dbd46$export$2e2bcd8739ae039), (0, $auO16.default)("MuiFilledInput", [
    "root",
    "underline",
    "input"
]));
var $938ab69807736126$export$2e2bcd8739ae039 = $938ab69807736126$var$filledInputClasses;




var $izf4p = parcelRequire("izf4p");
"use client";
const $9fed50ab3714034f$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $9fed50ab3714034f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            "root",
            !disableUnderline && "underline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9JdRu.default)(slots, (0, $938ab69807736126$export$3331e419f1a48437), classes);
    return (0, $lzDk3.default)({}, classes, composedClasses);
};
const $9fed50ab3714034f$var$FilledInputRoot = (0, $JdaC3.default)((0, $04b8378efe120e28$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $JdaC3.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiFilledInput",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $04b8378efe120e28$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === "light";
    const bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
    const backgroundColor = light ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)";
    const hoverBackground = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)";
    const disabledBackground = light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
    return (0, $lzDk3.default)({
        position: "relative",
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        "&:hover": {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $938ab69807736126$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $938ab69807736126$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        "&::after": {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || "primary"]) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: "absolute",
            right: 0,
            transform: "scaleX(0)",
            transition: theme.transitions.create("transform", {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&.${(0, $938ab69807736126$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: "scaleX(1) translateX(0)"
        },
        [`&.${(0, $938ab69807736126$export$2e2bcd8739ae039).error}`]: {
            "&::before, &::after": {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        "&::before": {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: "absolute",
            right: 0,
            transition: theme.transitions.create("border-bottom-color", {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: "none" // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $938ab69807736126$export$2e2bcd8739ae039).disabled}, .${(0, $938ab69807736126$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $938ab69807736126$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: "dotted"
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $lzDk3.default)({
        padding: "25px 12px 8px"
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $9fed50ab3714034f$var$FilledInputInput = (0, $JdaC3.default)((0, $04b8378efe120e28$export$a1ad29c901026019), {
    name: "MuiFilledInput",
    slot: "Input",
    overridesResolver: (0, $04b8378efe120e28$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderTopLeftRadius: "inherit",
            borderTopRightRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === "small" && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $9fed50ab3714034f$var$FilledInput = /*#__PURE__*/ $4YNlq.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiFilledInput"
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = "input", multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = "text" } = props, other = (0, $g54n0.default)(props, $9fed50ab3714034f$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $9fed50ab3714034f$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $c4QxQ.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $9fed50ab3714034f$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $9fed50ab3714034f$var$FilledInputInput;
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $04b8378efe120e28$export$2e2bcd8739ae039), (0, $lzDk3.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$9fed50ab3714034f$var$FilledInput.muiName = "Input";
var $9fed50ab3714034f$export$2e2bcd8739ae039 = $9fed50ab3714034f$var$FilledInput;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");



var $9JdRu = parcelRequire("9JdRu");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");
parcelRequire("4YNlq");


var $JdaC3 = parcelRequire("JdaC3");

var $izf4p = parcelRequire("izf4p");
"use client";
var $9a2e0445dc744345$var$_span;
const $9a2e0445dc744345$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $9a2e0445dc744345$var$NotchedOutlineRoot = (0, $JdaC3.default)("fieldset", {
    shouldForwardProp: (0, $JdaC3.rootShouldForwardProp)
})({
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%"
});
const $9a2e0445dc744345$var$NotchedOutlineLegend = (0, $JdaC3.default)("legend", {
    shouldForwardProp: (0, $JdaC3.rootShouldForwardProp)
})(({ ownerState: ownerState, theme: theme })=>(0, $lzDk3.default)({
        float: "unset",
        // Fix conflict with bootstrap
        width: "auto",
        // Fix conflict with bootstrap
        overflow: "hidden"
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: "11px",
        // sync with `height` in `legend` styles
        transition: theme.transitions.create("width", {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $lzDk3.default)({
        display: "block",
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: "0.75em",
        visibility: "hidden",
        maxWidth: 0.01,
        transition: theme.transitions.create("max-width", {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: "nowrap",
        "& > span": {
            paddingLeft: 5,
            paddingRight: 5,
            display: "inline-block",
            opacity: 0,
            visibility: "visible"
        }
    }, ownerState.notched && {
        maxWidth: "100%",
        transition: theme.transitions.create("max-width", {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $9a2e0445dc744345$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $g54n0.default)(props, $9a2e0445dc744345$var$_excluded);
    const withLabel = label != null && label !== "";
    const ownerState = (0, $lzDk3.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)($9a2e0445dc744345$var$NotchedOutlineRoot, (0, $lzDk3.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)($9a2e0445dc744345$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $izf4p.jsx)("span", {
                children: label
            }) : $9a2e0445dc744345$var$_span || ($9a2e0445dc744345$var$_span = /*#__PURE__*/ (0, $izf4p.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $JdaC3 = parcelRequire("JdaC3");

var $lzDk3 = parcelRequire("lzDk3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");

function $678a0315cda03f90$export$89922944c7227687(slot) {
    return (0, $fx4gX.default)("MuiOutlinedInput", slot);
}
const $678a0315cda03f90$var$outlinedInputClasses = (0, $lzDk3.default)({}, (0, $9427f503552dbd46$export$2e2bcd8739ae039), (0, $auO16.default)("MuiOutlinedInput", [
    "root",
    "notchedOutline",
    "input"
]));
var $678a0315cda03f90$export$2e2bcd8739ae039 = $678a0315cda03f90$var$outlinedInputClasses;




var $4Q3YJ = parcelRequire("4Q3YJ");

var $izf4p = parcelRequire("izf4p");
"use client";
const $7242f64dbfae33b2$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $7242f64dbfae33b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        notchedOutline: [
            "notchedOutline"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9JdRu.default)(slots, (0, $678a0315cda03f90$export$89922944c7227687), classes);
    return (0, $lzDk3.default)({}, classes, composedClasses);
};
const $7242f64dbfae33b2$var$OutlinedInputRoot = (0, $JdaC3.default)((0, $04b8378efe120e28$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $JdaC3.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiOutlinedInput",
    slot: "Root",
    overridesResolver: (0, $04b8378efe120e28$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return (0, $lzDk3.default)({
        position: "relative",
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $678a0315cda03f90$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
            [`&:hover .${(0, $678a0315cda03f90$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $678a0315cda03f90$export$2e2bcd8739ae039).focused} .${(0, $678a0315cda03f90$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $678a0315cda03f90$export$2e2bcd8739ae039).error} .${(0, $678a0315cda03f90$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $678a0315cda03f90$export$2e2bcd8739ae039).disabled} .${(0, $678a0315cda03f90$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $lzDk3.default)({
        padding: "16.5px 14px"
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }));
});
const $7242f64dbfae33b2$var$NotchedOutlineRoot = (0, $JdaC3.default)((0, $9a2e0445dc744345$export$2e2bcd8739ae039), {
    name: "MuiOutlinedInput",
    slot: "NotchedOutline",
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $7242f64dbfae33b2$var$OutlinedInputInput = (0, $JdaC3.default)((0, $04b8378efe120e28$export$a1ad29c901026019), {
    name: "MuiOutlinedInput",
    slot: "Input",
    overridesResolver: (0, $04b8378efe120e28$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        padding: "16.5px 14px"
    }, !theme.vars && {
        "&:-webkit-autofill": {
            WebkitBoxShadow: theme.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
            WebkitTextFillColor: theme.palette.mode === "light" ? null : "#fff",
            caretColor: theme.palette.mode === "light" ? null : "#fff",
            borderRadius: "inherit"
        }
    }, theme.vars && {
        "&:-webkit-autofill": {
            borderRadius: "inherit"
        },
        [theme.getColorSchemeSelector("dark")]: {
            "&:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "#fff",
                caretColor: "#fff"
            }
        }
    }, ownerState.size === "small" && {
        padding: "8.5px 14px"
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $7242f64dbfae33b2$var$OutlinedInput = /*#__PURE__*/ $4YNlq.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiOutlinedInput"
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = "input", label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = "text" } = props, other = (0, $g54n0.default)(props, $7242f64dbfae33b2$var$_excluded);
    const classes = $7242f64dbfae33b2$var$useUtilityClasses(props);
    const muiFormControl = (0, $cfa3bdf64b9b659c$export$2e2bcd8739ae039)();
    const fcs = (0, $dd55e33f0dc69096$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "disabled",
            "error",
            "focused",
            "hiddenLabel",
            "size",
            "required"
        ]
    });
    const ownerState = (0, $lzDk3.default)({}, props, {
        color: fcs.color || "primary",
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $7242f64dbfae33b2$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $7242f64dbfae33b2$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $04b8378efe120e28$export$2e2bcd8739ae039), (0, $lzDk3.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $izf4p.jsx)($7242f64dbfae33b2$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== "" && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        "*"
                    ]
                })) : label,
                notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $lzDk3.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$7242f64dbfae33b2$var$OutlinedInput.muiName = "Input";
var $7242f64dbfae33b2$export$2e2bcd8739ae039 = $7242f64dbfae33b2$var$OutlinedInput;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $9JdRu = parcelRequire("9JdRu");

var $fQQpK = parcelRequire("fQQpK");



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");



var $2qCAA = parcelRequire("2qCAA");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $JdaC3 = parcelRequire("JdaC3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $9b86564285793d97$export$f7d501e40371cd17(slot) {
    return (0, $fx4gX.default)("MuiFormLabel", slot);
}
const $9b86564285793d97$var$formLabelClasses = (0, $auO16.default)("MuiFormLabel", [
    "root",
    "colorSecondary",
    "focused",
    "disabled",
    "error",
    "filled",
    "required",
    "asterisk"
]);
var $9b86564285793d97$export$2e2bcd8739ae039 = $9b86564285793d97$var$formLabelClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $b973ec2627563bc5$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $b973ec2627563bc5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            `color${(0, $2qCAA.default)(color)}`,
            disabled && "disabled",
            error && "error",
            filled && "filled",
            focused && "focused",
            required && "required"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $9b86564285793d97$export$f7d501e40371cd17), classes);
};
const $b973ec2627563bc5$export$aa5bc7f8a4705b27 = (0, $JdaC3.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $lzDk3.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: "1.4375em",
        padding: 0,
        position: "relative",
        [`&.${(0, $9b86564285793d97$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $9b86564285793d97$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $9b86564285793d97$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $b973ec2627563bc5$var$AsteriskComponent = (0, $JdaC3.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $9b86564285793d97$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $b973ec2627563bc5$var$FormLabel = /*#__PURE__*/ $4YNlq.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiFormLabel"
    });
    const { children: children, className: className, component: component = "label" } = props, other = (0, $g54n0.default)(props, $b973ec2627563bc5$var$_excluded);
    const muiFormControl = (0, $cfa3bdf64b9b659c$export$2e2bcd8739ae039)();
    const fcs = (0, $dd55e33f0dc69096$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "color",
            "required",
            "focused",
            "disabled",
            "error",
            "filled"
        ]
    });
    const ownerState = (0, $lzDk3.default)({}, props, {
        color: fcs.color || "primary",
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $b973ec2627563bc5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($b973ec2627563bc5$export$aa5bc7f8a4705b27, (0, $lzDk3.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fQQpK.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $izf4p.jsxs)($b973ec2627563bc5$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    "*"
                ]
            })
        ]
    }));
});
var $b973ec2627563bc5$export$2e2bcd8739ae039 = $b973ec2627563bc5$var$FormLabel;



var $4Q3YJ = parcelRequire("4Q3YJ");

var $2qCAA = parcelRequire("2qCAA");

var $JdaC3 = parcelRequire("JdaC3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $d7643405aea2210c$export$c1c4b4545ad2ea5f(slot) {
    return (0, $fx4gX.default)("MuiInputLabel", slot);
}
const $d7643405aea2210c$var$inputLabelClasses = (0, $auO16.default)("MuiInputLabel", [
    "root",
    "focused",
    "disabled",
    "error",
    "required",
    "asterisk",
    "formControl",
    "sizeSmall",
    "shrink",
    "animated",
    "standard",
    "filled",
    "outlined"
]);
var $d7643405aea2210c$export$2e2bcd8739ae039 = $d7643405aea2210c$var$inputLabelClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $24ba979eda50eb4f$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $24ba979eda50eb4f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            formControl && "formControl",
            !disableAnimation && "animated",
            shrink && "shrink",
            size && size !== "normal" && `size${(0, $2qCAA.default)(size)}`,
            variant
        ],
        asterisk: [
            required && "asterisk"
        ]
    };
    const composedClasses = (0, $9JdRu.default)(slots, (0, $d7643405aea2210c$export$c1c4b4545ad2ea5f), classes);
    return (0, $lzDk3.default)({}, classes, composedClasses);
};
const $24ba979eda50eb4f$var$InputLabelRoot = (0, $JdaC3.default)((0, $b973ec2627563bc5$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $JdaC3.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiInputLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $9b86564285793d97$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === "small" && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "block",
        transformOrigin: "top left",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%"
    }, ownerState.formControl && {
        position: "absolute",
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: "translate(0, 20px) scale(1)"
    }, ownerState.size === "small" && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: "translate(0, 17px) scale(1)"
    }, ownerState.shrink && {
        transform: "translate(0, -1.5px) scale(0.75)",
        transformOrigin: "top left",
        maxWidth: "133%"
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            "color",
            "transform",
            "max-width"
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === "filled" && (0, $lzDk3.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(12px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 13px) scale(1)"
    }, ownerState.shrink && (0, $lzDk3.default)({
        userSelect: "none",
        pointerEvents: "auto",
        transform: "translate(12px, 7px) scale(0.75)",
        maxWidth: "calc(133% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(12px, 4px) scale(0.75)"
    })), ownerState.variant === "outlined" && (0, $lzDk3.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: "none",
        transform: "translate(14px, 16px) scale(1)",
        maxWidth: "calc(100% - 24px)"
    }, ownerState.size === "small" && {
        transform: "translate(14px, 9px) scale(1)"
    }, ownerState.shrink && {
        userSelect: "none",
        pointerEvents: "auto",
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: "calc(133% - 32px)",
        transform: "translate(14px, -9px) scale(0.75)"
    })));
const $24ba979eda50eb4f$var$InputLabel = /*#__PURE__*/ $4YNlq.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        name: "MuiInputLabel",
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $g54n0.default)(props, $24ba979eda50eb4f$var$_excluded);
    const muiFormControl = (0, $cfa3bdf64b9b659c$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === "undefined" && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $dd55e33f0dc69096$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "size",
            "variant",
            "required",
            "focused"
        ]
    });
    const ownerState = (0, $lzDk3.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $24ba979eda50eb4f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($24ba979eda50eb4f$var$InputLabelRoot, (0, $lzDk3.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $fQQpK.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $24ba979eda50eb4f$export$2e2bcd8739ae039 = $24ba979eda50eb4f$var$InputLabel;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $JdaC3 = parcelRequire("JdaC3");


var $2qCAA = parcelRequire("2qCAA");



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $9dcb26355b8165bc$export$149c8b8bab2289d1(slot) {
    return (0, $fx4gX.default)("MuiFormControl", slot);
}
const $9dcb26355b8165bc$var$formControlClasses = (0, $auO16.default)("MuiFormControl", [
    "root",
    "marginNone",
    "marginNormal",
    "marginDense",
    "fullWidth",
    "disabled"
]);
var $9dcb26355b8165bc$export$2e2bcd8739ae039 = $9dcb26355b8165bc$var$formControlClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $f5057fce34544643$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $f5057fce34544643$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            "root",
            margin !== "none" && `margin${(0, $2qCAA.default)(margin)}`,
            fullWidth && "fullWidth"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $9dcb26355b8165bc$export$149c8b8bab2289d1), classes);
};
const $f5057fce34544643$var$FormControlRoot = (0, $JdaC3.default)("div", {
    name: "MuiFormControl",
    slot: "Root",
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $lzDk3.default)({}, styles.root, styles[`margin${(0, $2qCAA.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "inline-flex",
        flexDirection: "column",
        position: "relative",
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: "top"
    }, ownerState.margin === "normal" && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === "dense" && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: "100%"
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $f5057fce34544643$var$FormControl = /*#__PURE__*/ $4YNlq.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiFormControl"
    });
    const { children: children, className: className, color: color = "primary", component: component = "div", disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = "none", required: required = false, size: size = "medium", variant: variant = "outlined" } = props, other = (0, $g54n0.default)(props, $f5057fce34544643$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $f5057fce34544643$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $4YNlq.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $4YNlq.Children.forEach(children, (child)=>{
            if (!(0, $1ab46a2a38c891ed$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            const input = (0, $1ab46a2a38c891ed$export$2e2bcd8739ae039)(child, [
                "Select"
            ]) ? child.props.input : child;
            if (input && (0, $6236975eac43573a$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $4YNlq.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $4YNlq.Children.forEach(children, (child)=>{
            if (!(0, $1ab46a2a38c891ed$export$2e2bcd8739ae039)(child, [
                "Input",
                "Select"
            ])) return;
            if ((0, $6236975eac43573a$export$d652b828d7fdeff8)(child.props, true) || (0, $6236975eac43573a$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $4YNlq.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $4YNlq.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $d9e9a8e4dc077124$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $izf4p.jsx)($f5057fce34544643$var$FormControlRoot, (0, $lzDk3.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $fQQpK.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $f5057fce34544643$export$2e2bcd8739ae039 = $f5057fce34544643$var$FormControl;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");



var $JdaC3 = parcelRequire("JdaC3");

var $2qCAA = parcelRequire("2qCAA");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $3e649223a1652ac8$export$a394fa61b1d583a9(slot) {
    return (0, $fx4gX.default)("MuiFormHelperText", slot);
}
const $3e649223a1652ac8$var$formHelperTextClasses = (0, $auO16.default)("MuiFormHelperText", [
    "root",
    "error",
    "disabled",
    "sizeSmall",
    "sizeMedium",
    "contained",
    "focused",
    "filled",
    "required"
]);
var $3e649223a1652ac8$export$2e2bcd8739ae039 = $3e649223a1652ac8$var$formHelperTextClasses;



var $4Q3YJ = parcelRequire("4Q3YJ");

var $izf4p = parcelRequire("izf4p");
"use client";
var $840a78f2b8ba05ce$var$_span;
const $840a78f2b8ba05ce$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $840a78f2b8ba05ce$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            error && "error",
            size && `size${(0, $2qCAA.default)(size)}`,
            contained && "contained",
            focused && "focused",
            filled && "filled",
            required && "required"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $3e649223a1652ac8$export$a394fa61b1d583a9), classes);
};
const $840a78f2b8ba05ce$var$FormHelperTextRoot = (0, $JdaC3.default)("p", {
    name: "MuiFormHelperText",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $2qCAA.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: "left",
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $3e649223a1652ac8$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $3e649223a1652ac8$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === "small" && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $840a78f2b8ba05ce$var$FormHelperText = /*#__PURE__*/ $4YNlq.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiFormHelperText"
    });
    const { children: children, className: className, component: component = "p" } = props, other = (0, $g54n0.default)(props, $840a78f2b8ba05ce$var$_excluded);
    const muiFormControl = (0, $cfa3bdf64b9b659c$export$2e2bcd8739ae039)();
    const fcs = (0, $dd55e33f0dc69096$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "size",
            "disabled",
            "error",
            "filled",
            "focused",
            "required"
        ]
    });
    const ownerState = (0, $lzDk3.default)({}, props, {
        component: component,
        contained: fcs.variant === "filled" || fcs.variant === "outlined",
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $840a78f2b8ba05ce$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($840a78f2b8ba05ce$var$FormHelperTextRoot, (0, $lzDk3.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fQQpK.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === " " ? $840a78f2b8ba05ce$var$_span || ($840a78f2b8ba05ce$var$_span = /*#__PURE__*/ (0, $izf4p.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $840a78f2b8ba05ce$export$2e2bcd8739ae039 = $840a78f2b8ba05ce$var$FormHelperText;



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $c4QxQ = parcelRequire("c4QxQ");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $7y3ET = parcelRequire("7y3ET");

var $4YNlq = parcelRequire("4YNlq");
parcelRequire("dKCZL");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");



var $6042c5668b32e545$export$2e2bcd8739ae039 = (0, $140200a3441aaff2$export$2e2bcd8739ae039);



var $2qCAA = parcelRequire("2qCAA");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");
parcelRequire("dKCZL");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");
parcelRequire("dKCZL");




var $c053cf600236ba1e$export$2e2bcd8739ae039 = (0, $a28ff53af2082fda$export$2e2bcd8739ae039);





var $izf4p = parcelRequire("izf4p");
"use client";
const $f22b323971204dfd$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $f22b323971204dfd$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $f22b323971204dfd$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $f22b323971204dfd$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join("")) === 0;
}
function $f22b323971204dfd$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
        if (!nextFocus.hasAttribute("tabindex") || !$f22b323971204dfd$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $f22b323971204dfd$var$MenuList = /*#__PURE__*/ $4YNlq.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = "selectedMenu" } = props, other = (0, $g54n0.default)(props, $f22b323971204dfd$var$_excluded);
    const listRef = $4YNlq.useRef(null);
    const textCriteriaRef = $4YNlq.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $64a26410cabc30a1$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $4YNlq.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $c053cf600236ba1e$export$2e2bcd8739ae039)((0, $6042c5668b32e545$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $6042c5668b32e545$export$2e2bcd8739ae039)(list).activeElement;
        if (key === "ArrowDown") {
            // Prevent scroll of the page
            event.preventDefault();
            $f22b323971204dfd$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $f22b323971204dfd$var$nextItem);
        } else if (key === "ArrowUp") {
            event.preventDefault();
            $f22b323971204dfd$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $f22b323971204dfd$var$previousItem);
        } else if (key === "Home") {
            event.preventDefault();
            $f22b323971204dfd$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $f22b323971204dfd$var$nextItem);
        } else if (key === "End") {
            event.preventDefault();
            $f22b323971204dfd$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $f22b323971204dfd$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $f22b323971204dfd$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $f22b323971204dfd$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $f22b323971204dfd$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $4YNlq.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $4YNlq.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $4YNlq.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === "selectedMenu") newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $4YNlq.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $a9f02ffffb31630e$export$2e2bcd8739ae039), (0, $lzDk3.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $f22b323971204dfd$export$2e2bcd8739ae039 = $f22b323971204dfd$var$MenuList;



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");






var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $076940b60b7785d8$export$2e2bcd8739ae039 = (0, $d13ef127cb1489af$export$2e2bcd8739ae039);




var $a5bdded2e242da44$export$2e2bcd8739ae039 = (0, $33a8375cbc96cc03$export$2e2bcd8739ae039);







var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $fd96c244f4c51fd9$export$88f455dd56c95edb(slot) {
    return (0, $fx4gX.default)("MuiPopover", slot);
}
const $fd96c244f4c51fd9$var$popoverClasses = (0, $auO16.default)("MuiPopover", [
    "root",
    "paper"
]);
var $fd96c244f4c51fd9$export$2e2bcd8739ae039 = $fd96c244f4c51fd9$var$popoverClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $b61dbcfc76b23c84$var$_excluded = [
    "onEntering"
], $b61dbcfc76b23c84$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $b61dbcfc76b23c84$var$_excluded3 = [
    "slotProps"
];
function $b61dbcfc76b23c84$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === "number") offset = vertical;
    else if (vertical === "center") offset = rect.height / 2;
    else if (vertical === "bottom") offset = rect.height;
    return offset;
}
function $b61dbcfc76b23c84$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === "number") offset = horizontal;
    else if (horizontal === "center") offset = rect.width / 2;
    else if (horizontal === "right") offset = rect.width;
    return offset;
}
function $b61dbcfc76b23c84$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === "number" ? `${n}px` : n).join(" ");
}
function $b61dbcfc76b23c84$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
const $b61dbcfc76b23c84$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $fd96c244f4c51fd9$export$88f455dd56c95edb), classes);
};
const $b61dbcfc76b23c84$export$bcce13685275fc99 = (0, $JdaC3.default)((0, $0402d29e5e243355$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $b61dbcfc76b23c84$export$821346c38a2d9390 = (0, $JdaC3.default)((0, $b622387df7e39ff3$export$2e2bcd8739ae039), {
    name: "MuiPopover",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $b61dbcfc76b23c84$var$Popover = /*#__PURE__*/ $4YNlq.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPopover"
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: "top",
        horizontal: "left"
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = "anchorEl", children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: "top",
        horizontal: "left"
    }, TransitionComponent: TransitionComponent = (0, $4d0799980e60d657$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = "auto", TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $g54n0.default)(props.TransitionProps, $b61dbcfc76b23c84$var$_excluded), other = (0, $g54n0.default)(props, $b61dbcfc76b23c84$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $4YNlq.useRef();
    const handlePaperRef = (0, $4019772905761825$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $lzDk3.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $b61dbcfc76b23c84$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $4YNlq.useCallback(()=>{
        if (anchorReference === "anchorPosition") return anchorPosition;
        const resolvedAnchorEl = $b61dbcfc76b23c84$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $6042c5668b32e545$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $b61dbcfc76b23c84$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $b61dbcfc76b23c84$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $4YNlq.useCallback((elemRect)=>{
        return {
            vertical: $b61dbcfc76b23c84$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $b61dbcfc76b23c84$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $4YNlq.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === "none") return {
            top: null,
            left: null,
            transformOrigin: $b61dbcfc76b23c84$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $a5bdded2e242da44$export$2e2bcd8739ae039)($b61dbcfc76b23c84$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $b61dbcfc76b23c84$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $4YNlq.useState(open);
    const setPositioningStyles = $4YNlq.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $4YNlq.useEffect(()=>{
        if (disableScrollLock) window.addEventListener("scroll", setPositioningStyles);
        return ()=>window.removeEventListener("scroll", setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $4YNlq.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $4YNlq.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $4YNlq.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $076940b60b7785d8$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $a5bdded2e242da44$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener("resize", handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener("resize", handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $6042c5668b32e545$export$2e2bcd8739ae039)($b61dbcfc76b23c84$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $b61dbcfc76b23c84$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $b61dbcfc76b23c84$export$821346c38a2d9390;
    const paperProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: (0, $lzDk3.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $lzDk3.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $fQQpK.default)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $fQQpK.default)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $g54n0.default)(_useSlotProps, $b61dbcfc76b23c84$var$_excluded3);
    return /*#__PURE__*/ (0, $izf4p.jsx)(RootSlot, (0, $lzDk3.default)({}, rootProps, !(0, $af94551ec12d5eb4$export$e28348cc2430497)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)(TransitionComponent, (0, $lzDk3.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $izf4p.jsx)(PaperSlot, (0, $lzDk3.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $b61dbcfc76b23c84$export$2e2bcd8739ae039 = $b61dbcfc76b23c84$var$Popover;



var $JdaC3 = parcelRequire("JdaC3");


var $4Q3YJ = parcelRequire("4Q3YJ");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $aef5b17106106592$export$2cf86a63a84fe23d(slot) {
    return (0, $fx4gX.default)("MuiMenu", slot);
}
const $aef5b17106106592$var$menuClasses = (0, $auO16.default)("MuiMenu", [
    "root",
    "paper",
    "list"
]);
var $aef5b17106106592$export$2e2bcd8739ae039 = $aef5b17106106592$var$menuClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $e632428fbbde80d6$var$_excluded = [
    "onEntering"
], $e632428fbbde80d6$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $e632428fbbde80d6$var$RTL_ORIGIN = {
    vertical: "top",
    horizontal: "right"
};
const $e632428fbbde80d6$var$LTR_ORIGIN = {
    vertical: "top",
    horizontal: "left"
};
const $e632428fbbde80d6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        paper: [
            "paper"
        ],
        list: [
            "list"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $aef5b17106106592$export$2cf86a63a84fe23d), classes);
};
const $e632428fbbde80d6$var$MenuRoot = (0, $JdaC3.default)((0, $b61dbcfc76b23c84$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $JdaC3.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenu",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $e632428fbbde80d6$export$4f7c51a5920c9f33 = (0, $JdaC3.default)((0, $b61dbcfc76b23c84$export$821346c38a2d9390), {
    name: "MuiMenu",
    slot: "Paper",
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: "touch"
});
const $e632428fbbde80d6$var$MenuMenuList = (0, $JdaC3.default)((0, $f22b323971204dfd$export$2e2bcd8739ae039), {
    name: "MuiMenu",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $e632428fbbde80d6$var$Menu = /*#__PURE__*/ $4YNlq.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiMenu"
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = "auto", TransitionProps: { onEntering: onEntering } = {}, variant: variant = "selectedMenu", slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $g54n0.default)(props.TransitionProps, $e632428fbbde80d6$var$_excluded), other = (0, $g54n0.default)(props, $e632428fbbde80d6$var$_excluded2);
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === "rtl";
    const ownerState = (0, $lzDk3.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $e632428fbbde80d6$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $4YNlq.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === "Tab") {
            event.preventDefault();
            if (onClose) onClose(event, "tabKeyDown");
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $4YNlq.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $4YNlq.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === "selectedMenu" && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $e632428fbbde80d6$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)($e632428fbbde80d6$var$MenuRoot, (0, $lzDk3.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: isRtl ? "right" : "left"
        },
        transformOrigin: isRtl ? $e632428fbbde80d6$var$RTL_ORIGIN : $e632428fbbde80d6$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $lzDk3.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $izf4p.jsx)($e632428fbbde80d6$var$MenuMenuList, (0, $lzDk3.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $fQQpK.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $e632428fbbde80d6$export$2e2bcd8739ae039 = $e632428fbbde80d6$var$Menu;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");

var $2qCAA = parcelRequire("2qCAA");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $5f1768e9dfc6c5f3$export$1ee13051fd9e2ab5(slot) {
    return (0, $fx4gX.default)("MuiNativeSelect", slot);
}
const $5f1768e9dfc6c5f3$var$nativeSelectClasses = (0, $auO16.default)("MuiNativeSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $5f1768e9dfc6c5f3$export$2e2bcd8739ae039 = $5f1768e9dfc6c5f3$var$nativeSelectClasses;



var $JdaC3 = parcelRequire("JdaC3");

var $izf4p = parcelRequire("izf4p");
"use client";
const $0370f0fd2d66f778$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $0370f0fd2d66f778$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $2qCAA.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $5f1768e9dfc6c5f3$export$1ee13051fd9e2ab5), classes);
};
const $0370f0fd2d66f778$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $lzDk3.default)({
        MozAppearance: "none",
        // Reset
        WebkitAppearance: "none",
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: "none",
        borderRadius: 0,
        // Reset
        cursor: "pointer",
        "&:focus": (0, $lzDk3.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        "&::-ms-expand": {
            display: "none"
        },
        [`&.${(0, $5f1768e9dfc6c5f3$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        },
        "&[multiple]": {
            height: "auto"
        },
        "&:not([multiple]) option, &:not([multiple]) optgroup": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        "&&&": {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === "filled" && {
        "&&&": {
            paddingRight: 32
        }
    }, ownerState.variant === "outlined" && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        "&:focus": {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        "&&&": {
            paddingRight: 32
        }
    });
const $0370f0fd2d66f778$var$NativeSelectSelect = (0, $JdaC3.default)("select", {
    name: "MuiNativeSelect",
    slot: "Select",
    shouldForwardProp: (0, $JdaC3.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $5f1768e9dfc6c5f3$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($0370f0fd2d66f778$export$c1eccd1617458c87);
const $0370f0fd2d66f778$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $lzDk3.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: "absolute",
        right: 0,
        top: "calc(50% - .5em)",
        // Center vertically, height is 1em
        pointerEvents: "none",
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $5f1768e9dfc6c5f3$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: "rotate(180deg)"
    }, ownerState.variant === "filled" && {
        right: 7
    }, ownerState.variant === "outlined" && {
        right: 7
    });
const $0370f0fd2d66f778$var$NativeSelectIcon = (0, $JdaC3.default)("svg", {
    name: "MuiNativeSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $2qCAA.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($0370f0fd2d66f778$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $0370f0fd2d66f778$var$NativeSelectInput = /*#__PURE__*/ $4YNlq.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = "standard" } = props, other = (0, $g54n0.default)(props, $0370f0fd2d66f778$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $0370f0fd2d66f778$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)($0370f0fd2d66f778$var$NativeSelectSelect, (0, $lzDk3.default)({
                ownerState: ownerState,
                className: (0, $fQQpK.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $izf4p.jsx)($0370f0fd2d66f778$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $0370f0fd2d66f778$export$2e2bcd8739ae039 = $0370f0fd2d66f778$var$NativeSelectInput;




var $JdaC3 = parcelRequire("JdaC3");


"use client";
var $dcf7b233484e2a32$export$2e2bcd8739ae039 = (0, $5327b1b36ff53449$export$2e2bcd8739ae039);



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $ee22984c0eca1855$export$2c0c1ee5a3392e(slot) {
    return (0, $fx4gX.default)("MuiSelect", slot);
}
const $ee22984c0eca1855$var$selectClasses = (0, $auO16.default)("MuiSelect", [
    "root",
    "select",
    "multiple",
    "filled",
    "outlined",
    "standard",
    "disabled",
    "focused",
    "icon",
    "iconOpen",
    "iconFilled",
    "iconOutlined",
    "iconStandard",
    "nativeInput",
    "error"
]);
var $ee22984c0eca1855$export$2e2bcd8739ae039 = $ee22984c0eca1855$var$selectClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
var $a65edba6bd0a3a30$var$_span;
const $a65edba6bd0a3a30$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $a65edba6bd0a3a30$var$SelectSelect = (0, $JdaC3.default)("div", {
    name: "MuiSelect",
    slot: "Select",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $ee22984c0eca1855$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $ee22984c0eca1855$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $ee22984c0eca1855$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $ee22984c0eca1855$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $0370f0fd2d66f778$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $ee22984c0eca1855$export$2e2bcd8739ae039).select}`]: {
        height: "auto",
        // Resets for multiple select with chips
        minHeight: "1.4375em",
        // Required for select\text-field height consistency
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    }
});
const $a65edba6bd0a3a30$var$SelectIcon = (0, $JdaC3.default)("svg", {
    name: "MuiSelect",
    slot: "Icon",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $2qCAA.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $0370f0fd2d66f778$export$e7a817afd12a40d0));
const $a65edba6bd0a3a30$var$SelectNativeInput = (0, $JdaC3.default)("input", {
    shouldForwardProp: (prop)=>(0, $JdaC3.slotShouldForwardProp)(prop) && prop !== "classes",
    name: "MuiSelect",
    slot: "NativeInput",
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: "absolute",
    opacity: 0,
    pointerEvents: "none",
    width: "100%",
    boxSizing: "border-box"
});
function $a65edba6bd0a3a30$var$areEqualValues(a, b) {
    if (typeof b === "object" && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $a65edba6bd0a3a30$var$isEmpty(display) {
    return display == null || typeof display === "string" && !display.trim();
}
const $a65edba6bd0a3a30$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            "select",
            variant,
            disabled && "disabled",
            multiple && "multiple",
            error && "error"
        ],
        icon: [
            "icon",
            `icon${(0, $2qCAA.default)(variant)}`,
            open && "iconOpen",
            disabled && "disabled"
        ],
        nativeInput: [
            "nativeInput"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $ee22984c0eca1855$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $a65edba6bd0a3a30$var$SelectInput = /*#__PURE__*/ $4YNlq.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { "aria-describedby": ariaDescribedby, "aria-label": ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = "standard" } = props, other = (0, $g54n0.default)(props, $a65edba6bd0a3a30$var$_excluded);
    const [value, setValueState] = (0, $dcf7b233484e2a32$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: "Select"
    });
    const [openState, setOpenState] = (0, $dcf7b233484e2a32$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: "Select"
    });
    const inputRef = $4YNlq.useRef(null);
    const displayRef = $4YNlq.useRef(null);
    const [displayNode, setDisplayNode] = $4YNlq.useState(null);
    const { current: isOpenControlled } = $4YNlq.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $4YNlq.useState();
    const handleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $4YNlq.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $4YNlq.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $4YNlq.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $4YNlq.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $4YNlq.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $6042c5668b32e545$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener("click", handler);
            return ()=>{
                label.removeEventListener("click", handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $4YNlq.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute("tabindex")) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, "target", {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                " ",
                "ArrowUp",
                "ArrowDown",
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                "Enter"
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, "target", {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other["aria-invalid"];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $6236975eac43573a$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $4YNlq.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $7y3ET.default)(2));
            selected = value.some((v)=>$a65edba6bd0a3a30$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $a65edba6bd0a3a30$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $4YNlq.cloneElement(child, {
            "aria-selected": selected ? "true" : "false",
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === " ") // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: "option",
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            "data-value": child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(", ");
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== "undefined") tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $lzDk3.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $a65edba6bd0a3a30$var$useUtilityClasses(ownerState);
    const paperProps = (0, $lzDk3.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $f7c9c9374bbf09f1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)($a65edba6bd0a3a30$var$SelectSelect, (0, $lzDk3.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? "true" : undefined,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(" ") || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $fQQpK.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $a65edba6bd0a3a30$var$isEmpty(display) ? $a65edba6bd0a3a30$var$_span || ($a65edba6bd0a3a30$var$_span = /*#__PURE__*/ (0, $izf4p.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $izf4p.jsx)($a65edba6bd0a3a30$var$SelectNativeInput, (0, $lzDk3.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(",") : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $izf4p.jsx)($a65edba6bd0a3a30$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $e632428fbbde80d6$export$2e2bcd8739ae039), (0, $lzDk3.default)({
                id: `menu-${name || ""}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "center"
                },
                transformOrigin: {
                    vertical: "top",
                    horizontal: "center"
                }
            }, MenuProps, {
                MenuListProps: (0, $lzDk3.default)({
                    "aria-labelledby": labelId,
                    role: "listbox",
                    "aria-multiselectable": multiple ? "true" : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $lzDk3.default)({}, MenuProps.slotProps, {
                    paper: (0, $lzDk3.default)({}, paperProps, {
                        style: (0, $lzDk3.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $a65edba6bd0a3a30$export$2e2bcd8739ae039 = $a65edba6bd0a3a30$var$SelectInput;




parcelRequire("4YNlq");

var $7ipzf = parcelRequire("7ipzf");

var $izf4p = parcelRequire("izf4p");
"use client";
var $305e15f6d749771d$export$2e2bcd8739ae039 = (0, $7ipzf.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");







var $4Q3YJ = parcelRequire("4Q3YJ");


var $JdaC3 = parcelRequire("JdaC3");

var $izf4p = parcelRequire("izf4p");
"use client";
const $43185b97779b4aad$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $43185b97779b4aad$var$_excluded2 = [
    "root"
];
const $43185b97779b4aad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $43185b97779b4aad$var$styledRootConfig = {
    name: "MuiSelect",
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $JdaC3.rootShouldForwardProp)(prop) && prop !== "variant",
    slot: "Root"
};
const $43185b97779b4aad$var$StyledInput = (0, $JdaC3.default)((0, $e7ed1b43ca2bbe28$export$2e2bcd8739ae039), $43185b97779b4aad$var$styledRootConfig)("");
const $43185b97779b4aad$var$StyledOutlinedInput = (0, $JdaC3.default)((0, $7242f64dbfae33b2$export$2e2bcd8739ae039), $43185b97779b4aad$var$styledRootConfig)("");
const $43185b97779b4aad$var$StyledFilledInput = (0, $JdaC3.default)((0, $9fed50ab3714034f$export$2e2bcd8739ae039), $43185b97779b4aad$var$styledRootConfig)("");
const $43185b97779b4aad$var$Select = /*#__PURE__*/ $4YNlq.forwardRef(function Select(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        name: "MuiSelect",
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $305e15f6d749771d$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = "outlined" } = props, other = (0, $g54n0.default)(props, $43185b97779b4aad$var$_excluded);
    const inputComponent = native ? (0, $0370f0fd2d66f778$export$2e2bcd8739ae039) : (0, $a65edba6bd0a3a30$export$2e2bcd8739ae039);
    const muiFormControl = (0, $cfa3bdf64b9b659c$export$2e2bcd8739ae039)();
    const fcs = (0, $dd55e33f0dc69096$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "variant",
            "error"
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $lzDk3.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $43185b97779b4aad$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $g54n0.default)(classes, $43185b97779b4aad$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $izf4p.jsx)($43185b97779b4aad$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $izf4p.jsx)($43185b97779b4aad$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $izf4p.jsx)($43185b97779b4aad$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $4019772905761825$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $izf4p.jsx)($4YNlq.Fragment, {
        children: /*#__PURE__*/ $4YNlq.cloneElement(InputComponent, (0, $lzDk3.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $lzDk3.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $lzDk3.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $c4QxQ.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === "outlined" ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $fQQpK.default)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$43185b97779b4aad$var$Select.muiName = "Select";
var $43185b97779b4aad$export$2e2bcd8739ae039 = $43185b97779b4aad$var$Select;



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $8f3af40bef64af3d$export$c1bdcbaf0596aeda(slot) {
    return (0, $fx4gX.default)("MuiTextField", slot);
}
const $8f3af40bef64af3d$var$textFieldClasses = (0, $auO16.default)("MuiTextField", [
    "root"
]);
var $8f3af40bef64af3d$export$2e2bcd8739ae039 = $8f3af40bef64af3d$var$textFieldClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $c82f3019ce6db68b$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $c82f3019ce6db68b$var$variantComponent = {
    standard: (0, $e7ed1b43ca2bbe28$export$2e2bcd8739ae039),
    filled: (0, $9fed50ab3714034f$export$2e2bcd8739ae039),
    outlined: (0, $7242f64dbfae33b2$export$2e2bcd8739ae039)
};
const $c82f3019ce6db68b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $8f3af40bef64af3d$export$c1bdcbaf0596aeda), classes);
};
const $c82f3019ce6db68b$var$TextFieldRoot = (0, $JdaC3.default)((0, $f5057fce34544643$export$2e2bcd8739ae039), {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $c82f3019ce6db68b$var$TextField = /*#__PURE__*/ $4YNlq.forwardRef(function TextField(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiTextField"
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = "primary", defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = "outlined" } = props, other = (0, $g54n0.default)(props, $c82f3019ce6db68b$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $c82f3019ce6db68b$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
        if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore["aria-describedby"] = undefined;
    }
    const id = (0, $f7c9c9374bbf09f1$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $c82f3019ce6db68b$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $izf4p.jsx)(InputComponent, (0, $lzDk3.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $izf4p.jsxs)($c82f3019ce6db68b$var$TextFieldRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== "" && /*#__PURE__*/ (0, $izf4p.jsx)((0, $24ba979eda50eb4f$export$2e2bcd8739ae039), (0, $lzDk3.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $izf4p.jsx)((0, $43185b97779b4aad$export$2e2bcd8739ae039), (0, $lzDk3.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $izf4p.jsx)((0, $840a78f2b8ba05ce$export$2e2bcd8739ae039), (0, $lzDk3.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $c82f3019ce6db68b$export$2e2bcd8739ae039 = $c82f3019ce6db68b$var$TextField;



var $4Q3YJ = parcelRequire("4Q3YJ");



var $lzDk3 = parcelRequire("lzDk3");


var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");








var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");






const $5e4acfd83446e6c1$export$4e8d6353e50062e7 = (params)=>{
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const adapter = (0, $9faaabe544d2b9ed$export$4b5a24245de9f7f9)();
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    const { valueManager: valueManager, fieldValueManager: fieldValueManager, valueType: valueType, validator: validator, internalProps: internalProps, internalProps: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = "dense", selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp } } = params;
    const { timezone: timezone, value: valueFromTheOutside, handleValueChange: handleValueChange } = (0, $00e922e0bf6d2e8e$export$c7e050e908c1b2bc)({
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: valueManager
    });
    const sectionsValueBoundaries = $4YNlq.useMemo(()=>(0, $09f11305fc9004b5$export$360600f456ea7d5f)(utils, timezone), [
        utils,
        timezone
    ]);
    const getSectionsFromValue = $4YNlq.useCallback((value, fallbackSections = null)=>fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, isRTL, (date)=>(0, $09f11305fc9004b5$export$fd71d82fe42bada1)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL)), [
        fieldValueManager,
        format,
        localeText,
        isRTL,
        shouldRespectLeadingZeros,
        utils,
        formatDensity,
        timezone
    ]);
    const placeholder = $4YNlq.useMemo(()=>fieldValueManager.getValueStrFromSections(getSectionsFromValue(valueManager.emptyValue), isRTL), [
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        isRTL
    ]);
    const [state, setState] = $4YNlq.useState(()=>{
        const sections = getSectionsFromValue(valueFromTheOutside);
        (0, $09f11305fc9004b5$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            value: valueFromTheOutside,
            referenceValue: valueManager.emptyValue,
            tempValueStrAndroid: null
        };
        const granularity = (0, $05c56d59c112b284$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: valueFromTheOutside,
            utils: utils,
            props: internalProps,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $lzDk3.default)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $5327b1b36ff53449$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: "useField",
        state: "selectedSectionIndexes"
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange == null || onSelectedSectionsChange(newSelectedSections);
        setState((prevState)=>(0, $lzDk3.default)({}, prevState, {
                selectedSectionQuery: null
            }));
    };
    const selectedSectionIndexes = $4YNlq.useMemo(()=>{
        if (selectedSections == null) return null;
        if (selectedSections === "all") return {
            startIndex: 0,
            endIndex: state.sections.length - 1,
            shouldSelectBoundarySelectors: true
        };
        if (typeof selectedSections === "number") return {
            startIndex: selectedSections,
            endIndex: selectedSections
        };
        if (typeof selectedSections === "string") {
            const selectedSectionIndex = state.sections.findIndex((section)=>section.type === selectedSections);
            return {
                startIndex: selectedSectionIndex,
                endIndex: selectedSectionIndex
            };
        }
        return selectedSections;
    }, [
        selectedSections,
        state.sections
    ]);
    const publishValue = ({ value: value, referenceValue: referenceValue, sections: sections })=>{
        setState((prevState)=>(0, $lzDk3.default)({}, prevState, {
                sections: sections,
                value: value,
                referenceValue: referenceValue,
                tempValueStrAndroid: null
            }));
        if (valueManager.areValuesEqual(utils, state.value, value)) return;
        const context = {
            validationError: validator({
                adapter: adapter,
                value: value,
                props: (0, $lzDk3.default)({}, internalProps, {
                    value: value,
                    timezone: timezone
                })
            })
        };
        handleValueChange(value, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $lzDk3.default)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return (0, $09f11305fc9004b5$export$8bb5d1c9951d10ca)(newSections, isRTL);
    };
    const clearValue = ()=>{
        publishValue({
            value: valueManager.emptyValue,
            referenceValue: state.referenceValue,
            sections: getSectionsFromValue(valueManager.emptyValue)
        });
    };
    const clearActiveSection = ()=>{
        if (selectedSectionIndexes == null) return;
        const activeSection = state.sections[selectedSectionIndexes.startIndex];
        const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter((section)=>section.value !== "").length;
        const hasNoOtherNonEmptySections = nonEmptySectionCountBefore === (activeSection.value === "" ? 0 : 1);
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, "");
        const newActiveDate = hasNoOtherNonEmptySections ? null : utils.date(new Date(""));
        const newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
        if ((newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date))) publishValue((0, $lzDk3.default)({}, newValues, {
            sections: newSections
        }));
        else setState((prevState)=>(0, $lzDk3.default)({}, prevState, newValues, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = utils.parse(dateStr, format);
            if (date == null || !utils.isValid(date)) return null;
            const sections = (0, $09f11305fc9004b5$export$fd71d82fe42bada1)(utils, timezone, localeText, format, date, formatDensity, shouldRespectLeadingZeros, isRTL);
            return (0, $09f11305fc9004b5$export$6c6df982c77f60a9)(utils, timezone, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        const newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
        publishValue({
            value: newValue,
            referenceValue: newReferenceValue,
            sections: getSectionsFromValue(newValue, state.sections)
        });
    };
    const updateSectionValue = ({ activeSection: activeSection, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        /**
     * 1. Decide which section should be focused
     */ if (shouldGoToNextSection && selectedSectionIndexes && selectedSectionIndexes.startIndex < state.sections.length - 1) setSelectedSections(selectedSectionIndexes.startIndex + 1);
        else if (selectedSectionIndexes && selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
        /**
     * 2. Try to build a valid date from the new section value
     */ const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
        const newSections = setSectionValue(selectedSectionIndexes.startIndex, newSectionValue);
        const newActiveDateSections = activeDateManager.getSections(newSections);
        const newActiveDate = (0, $09f11305fc9004b5$export$b0c1bfd065bfe742)(utils, newActiveDateSections);
        let values;
        let shouldPublish;
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (newActiveDate != null && utils.isValid(newActiveDate)) {
            const mergedDate = (0, $09f11305fc9004b5$export$6c6df982c77f60a9)(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
            values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
            shouldPublish = true;
        } else {
            values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
            shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
        }
        /**
     * Publish or update the internal state with the new value and sections.
     */ if (shouldPublish) return publishValue((0, $lzDk3.default)({}, values, {
            sections: newSections
        }));
        return setState((prevState)=>(0, $lzDk3.default)({}, prevState, values, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prev)=>(0, $lzDk3.default)({}, prev, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    $4YNlq.useEffect(()=>{
        const sections = getSectionsFromValue(state.value);
        (0, $09f11305fc9004b5$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $lzDk3.default)({}, prevState, {
                sections: sections
            }));
    }, [
        format,
        utils.locale
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $4YNlq.useEffect(()=>{
        let shouldUpdate = false;
        if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) shouldUpdate = true;
        else shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
        if (shouldUpdate) setState((prevState)=>(0, $lzDk3.default)({}, prevState, {
                value: valueFromTheOutside,
                referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
                sections: getSectionsFromValue(valueFromTheOutside)
            }));
    }, [
        valueFromTheOutside
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        state: state,
        selectedSectionIndexes: selectedSectionIndexes,
        setSelectedSections: setSelectedSections,
        clearValue: clearValue,
        clearActiveSection: clearActiveSection,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        setTempAndroidValueStr: setTempAndroidValueStr,
        sectionsValueBoundaries: sectionsValueBoundaries,
        placeholder: placeholder,
        timezone: timezone
    };
};



var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");



/**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */ /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ const $33e7f7c7f1c6d595$var$QUERY_LIFE_DURATION_MS = 5000;
const $33e7f7c7f1c6d595$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $33e7f7c7f1c6d595$export$66d00048b8bb82f6 = ({ sections: sections, updateSectionValue: updateSectionValue, sectionsValueBoundaries: sectionsValueBoundaries, setTempAndroidValueStr: setTempAndroidValueStr, timezone: timezone })=>{
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const [query, setQuery] = $4YNlq.useState(null);
    const resetQuery = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)(()=>setQuery(null));
    $4YNlq.useEffect(()=>{
        var _sections$query$secti;
        if (query != null && ((_sections$query$secti = sections[query.sectionIndex]) == null ? void 0 : _sections$query$secti.type) !== query.sectionType) resetQuery();
    }, [
        sections,
        query,
        resetQuery
    ]);
    $4YNlq.useEffect(()=>{
        if (query != null) {
            const timeout = setTimeout(()=>resetQuery(), $33e7f7c7f1c6d595$var$QUERY_LIFE_DURATION_MS);
            return ()=>{
                window.clearTimeout(timeout);
            };
        }
        return ()=>{};
    }, [
        query,
        resetQuery
    ]);
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenated value
        if (query != null && (!isValidQueryValue || isValidQueryValue(query.value)) && query.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${query.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$33e7f7c7f1c6d595$var$isQueryResponseWithoutValue(queryResponse)) {
                setQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($33e7f7c7f1c6d595$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            resetQuery();
            return null;
        }
        setQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($33e7f7c7f1c6d595$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $09f11305fc9004b5$export$3ee1e7e19c2b047a)(utils, timezone, activeSection.type, format);
            if (activeSection.contentType === "letter") return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $09f11305fc9004b5$export$2f3c5fac7a2a65f6)(utils, fallbackFormat).contentType === "letter") {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($33e7f7c7f1c6d595$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $lzDk3.default)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case "month":
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $09f11305fc9004b5$export$2816862a602354ce)(utils, fallbackValue, utils.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.month, formatFallbackValue);
                    }
                case "weekDay":
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, utils.formats.weekday, formatFallbackValue);
                    }
                case "meridiem":
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = (queryValue, section)=>{
            const queryValueNumber = Number(`${queryValue}`);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = Number(`${queryValue}0`) > sectionBoundaries.maximum || queryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $09f11305fc9004b5$export$ef88db4bceade9fd)(utils, timezone, queryValueNumber, sectionBoundaries, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === "digit" || activeSection.contentType === "digit-with-letter") return getNewSectionValue(queryValue, activeSection);
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === "month") {
                const hasLeadingZerosInFormat = (0, $09f11305fc9004b5$export$78b5830e2dd2de49)(utils, timezone, "digit", "month", "MM");
                const response = getNewSectionValue(queryValue, {
                    type: activeSection.type,
                    format: "MM",
                    hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                    hasLeadingZerosInInput: true,
                    contentType: "digit",
                    maxLength: 2
                });
                if ($33e7f7c7f1c6d595$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $09f11305fc9004b5$export$2816862a602354ce)(utils, response.sectionValue, "MM", activeSection.format);
                return (0, $lzDk3.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === "weekDay") {
                const response = getNewSectionValue(queryValue, activeSection);
                if ($33e7f7c7f1c6d595$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $09f11305fc9004b5$export$c65c7173f879039f)(utils, timezone, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $lzDk3.default)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>!Number.isNaN(Number(queryValue)));
    };
    const applyCharacterEditing = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((params)=>{
        const activeSection = sections[params.sectionIndex];
        const isNumericEditing = !Number.isNaN(Number(params.keyPressed));
        const response = isNumericEditing ? applyNumericEditing(params) : applyLetterEditing(params);
        if (response == null) setTempAndroidValueStr(null);
        else updateSectionValue({
            activeSection: activeSection,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
    return {
        applyCharacterEditing: applyCharacterEditing,
        resetCharacterQuery: resetQuery
    };
};



const $3a95ffc7d6841493$var$_excluded = [
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onMouseUp",
    "onPaste",
    "error",
    "clearable",
    "onClear",
    "disabled"
];
const $3a95ffc7d6841493$export$294aa081a6c6f55d = (params)=>{
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const { state: state, selectedSectionIndexes: selectedSectionIndexes, setSelectedSections: setSelectedSections, clearValue: clearValue, clearActiveSection: clearActiveSection, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, setTempAndroidValueStr: setTempAndroidValueStr, sectionsValueBoundaries: sectionsValueBoundaries, placeholder: placeholder, timezone: timezone } = (0, $5e4acfd83446e6c1$export$4e8d6353e50062e7)(params);
    const { inputRef: inputRefProp, internalProps: internalProps, internalProps: { readOnly: readOnly = false, unstableFieldRef: unstableFieldRef, minutesStep: minutesStep }, forwardedProps: { onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onMouseUp: onMouseUp, onPaste: onPaste, error: error, clearable: clearable, onClear: onClear, disabled: disabled }, fieldValueManager: fieldValueManager, valueManager: valueManager, validator: validator } = params, otherForwardedProps = (0, $g54n0.default)(params.forwardedProps, $3a95ffc7d6841493$var$_excluded);
    const { applyCharacterEditing: applyCharacterEditing, resetCharacterQuery: resetCharacterQuery } = (0, $33e7f7c7f1c6d595$export$66d00048b8bb82f6)({
        sections: state.sections,
        updateSectionValue: updateSectionValue,
        sectionsValueBoundaries: sectionsValueBoundaries,
        setTempAndroidValueStr: setTempAndroidValueStr,
        timezone: timezone
    });
    const inputRef = $4YNlq.useRef(null);
    const handleRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(inputRefProp, inputRef);
    const focusTimeoutRef = $4YNlq.useRef(undefined);
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    const sectionOrder = $4YNlq.useMemo(()=>(0, $09f11305fc9004b5$export$7725fd6fe0a2aadf)(state.sections, isRTL), [
        state.sections,
        isRTL
    ]);
    const syncSelectionFromDOM = ()=>{
        var _selectionStart;
        if (readOnly) {
            setSelectedSections(null);
            return;
        }
        const browserStartIndex = (_selectionStart = inputRef.current.selectionStart) != null ? _selectionStart : 0;
        let nextSectionIndex;
        if (browserStartIndex <= state.sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= state.sections[state.sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    };
    const handleInputClick = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick == null || onClick(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputMouseUp = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event)=>{
        onMouseUp == null || onMouseUp(event);
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handleInputFocus = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((...args)=>{
        onFocus == null || onFocus(...args);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        window.clearTimeout(focusTimeoutRef.current);
        focusTimeoutRef.current = setTimeout(()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (selectedSectionIndexes != null || readOnly) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections("all");
            else syncSelectionFromDOM();
        });
    });
    const handleInputBlur = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((...args)=>{
        onBlur == null || onBlur(...args);
        setSelectedSections(null);
    });
    const handleInputPaste = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event)=>{
        onPaste == null || onPaste(event);
        if (readOnly) {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData("text");
        if (selectedSectionIndexes && selectedSectionIndexes.startIndex === selectedSectionIndexes.endIndex) {
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === "letter" && lettersOnly || activeSection.contentType === "digit" && digitsOnly || activeSection.contentType === "digit-with-letter" && digitsAndLetterOnly;
            if (isValidPastedValue) {
                resetCharacterQuery();
                updateSectionValue({
                    activeSection: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                // prevent default to avoid the input change handler being called
                event.preventDefault();
                return;
            }
            if (lettersOnly || digitsOnly) {
                // The pasted value correspond to a single section but not the expected type
                // skip the modification
                event.preventDefault();
                return;
            }
        }
        event.preventDefault();
        resetCharacterQuery();
        updateValueFromValueStr(pastedValue);
    });
    const handleInputChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === "") {
            resetCharacterQuery();
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = (0, $09f11305fc9004b5$export$cb0bbc88c7f09596)(valueStr);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (selectedSectionIndexes == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1 && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = (0, $09f11305fc9004b5$export$cb0bbc88c7f09596)(fieldValueManager.getValueStrFromSections(state.sections, isRTL));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = state.sections[selectedSectionIndexes.startIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - (0, $09f11305fc9004b5$export$cb0bbc88c7f09596)(activeSection.endSeparator || "").length;
            keyPressed = cleanValueStr.slice(activeSection.start + (0, $09f11305fc9004b5$export$cb0bbc88c7f09596)(activeSection.startSeparator || "").length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $09f11305fc9004b5$export$a11b0059900ceec8)()) setTempAndroidValueStr(valueStr);
            else {
                resetCharacterQuery();
                clearActiveSection();
            }
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: selectedSectionIndexes.startIndex
        });
    });
    const handleInputKeyDown = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event)=>{
        onKeyDown == null || onKeyDown(event);
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case event.key === "a" && (event.ctrlKey || event.metaKey):
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections("all");
                break;
            // Move selection to next section
            case event.key === "ArrowRight":
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.startIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === "ArrowLeft":
                event.preventDefault();
                if (selectedSectionIndexes == null) setSelectedSections(sectionOrder.endIndex);
                else if (selectedSectionIndexes.startIndex !== selectedSectionIndexes.endIndex) setSelectedSections(selectedSectionIndexes.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[selectedSectionIndexes.startIndex].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === "Delete":
                event.preventDefault();
                if (readOnly) break;
                if (selectedSectionIndexes == null || selectedSectionIndexes.startIndex === 0 && selectedSectionIndexes.endIndex === state.sections.length - 1) clearValue();
                else clearActiveSection();
                resetCharacterQuery();
                break;
            // Increment / decrement the selected section value
            case [
                "ArrowUp",
                "ArrowDown",
                "Home",
                "End",
                "PageUp",
                "PageDown"
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || selectedSectionIndexes == null) break;
                    const activeSection = state.sections[selectedSectionIndexes.startIndex];
                    const activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
                    const newSectionValue = (0, $09f11305fc9004b5$export$5ed0f22513e58fe3)(utils, timezone, activeSection, event.key, sectionsValueBoundaries, activeDateManager.date, {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        activeSection: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        if (!inputRef.current) return;
        if (selectedSectionIndexes == null) {
            if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
            // setting selection range to 0 causes issues in Safari.
            // https://bugs.webkit.org/show_bug.cgi?id=224425
            inputRef.current.scrollLeft = 0;
            return;
        }
        const firstSelectedSection = state.sections[selectedSectionIndexes.startIndex];
        const lastSelectedSection = state.sections[selectedSectionIndexes.endIndex];
        let selectionStart = firstSelectedSection.startInInput;
        let selectionEnd = lastSelectedSection.endInInput;
        if (selectedSectionIndexes.shouldSelectBoundarySelectors) {
            selectionStart -= firstSelectedSection.startSeparator.length;
            selectionEnd += lastSelectedSection.endSeparator.length;
        }
        if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            // On multi input range pickers we want to update selection range only for the active input
            // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current === (0, $3887927531c6c329$export$cd4e5573fbe2b576)(document)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
    });
    const validationError = (0, $6b5f16085e462dbd$export$87fe492f99f25a20)((0, $lzDk3.default)({}, internalProps, {
        value: state.value,
        timezone: timezone
    }), validator, valueManager.isSameError, valueManager.defaultErrorState);
    const inputError = $4YNlq.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (error !== undefined) return error;
        return valueManager.hasError(validationError);
    }, [
        valueManager,
        validationError,
        error
    ]);
    $4YNlq.useEffect(()=>{
        if (!inputError && !selectedSectionIndexes) resetCharacterQuery();
    }, [
        state.referenceValue,
        selectedSectionIndexes,
        inputError
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    $4YNlq.useEffect(()=>{
        // Select the right section when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === document.activeElement) setSelectedSections("all");
        return ()=>window.clearTimeout(focusTimeoutRef.current);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // If `state.tempValueStrAndroid` is still defined when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $4YNlq.useEffect(()=>{
        if (state.tempValueStrAndroid != null && selectedSectionIndexes != null) {
            resetCharacterQuery();
            clearActiveSection();
        }
    }, [
        state.tempValueStrAndroid
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const valueStr = $4YNlq.useMemo(()=>{
        var _state$tempValueStrAn;
        return (_state$tempValueStrAn = state.tempValueStrAndroid) != null ? _state$tempValueStrAn : fieldValueManager.getValueStrFromSections(state.sections, isRTL);
    }, [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        isRTL
    ]);
    const inputMode = $4YNlq.useMemo(()=>{
        if (selectedSectionIndexes == null) return "text";
        if (state.sections[selectedSectionIndexes.startIndex].contentType === "letter") return "text";
        return "numeric";
    }, [
        selectedSectionIndexes,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $3887927531c6c329$export$cd4e5573fbe2b576)(document);
    const areAllSectionsEmpty = valueManager.areValuesEqual(utils, state.value, valueManager.emptyValue);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    $4YNlq.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                var _selectionStart2, _selectionEnd;
                const browserStartIndex = (_selectionStart2 = inputRef.current.selectionStart) != null ? _selectionStart2 : 0;
                const browserEndIndex = (_selectionEnd = inputRef.current.selectionEnd) != null ? _selectionEnd : 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= state.sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : state.sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? state.sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (activeSectionIndex)=>setSelectedSections(activeSectionIndex)
        }));
    const handleClearValue = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, ...args)=>{
        var _inputRef$current;
        event.preventDefault();
        onClear == null || onClear(event, ...args);
        clearValue();
        inputRef == null || (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
        setSelectedSections(0);
    });
    return (0, $lzDk3.default)({
        placeholder: placeholder,
        autoComplete: "off",
        disabled: Boolean(disabled)
    }, otherForwardedProps, {
        value: shouldShowPlaceholder ? "" : valueStr,
        inputMode: inputMode,
        readOnly: readOnly,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onBlur: handleInputBlur,
        onPaste: handleInputPaste,
        onChange: handleInputChange,
        onKeyDown: handleInputKeyDown,
        onMouseUp: handleInputMouseUp,
        onClear: handleClearValue,
        error: inputError,
        ref: handleRef,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled)
    });
};






var $lzDk3 = parcelRequire("lzDk3");
const $5a2b0beb061d3a97$export$430d9fc64cf058d6 = [
    "disablePast",
    "disableFuture",
    "minDate",
    "maxDate",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear"
];
const $5a2b0beb061d3a97$export$fd5e0f8b4115a8c7 = [
    "disablePast",
    "disableFuture",
    "minTime",
    "maxTime",
    "shouldDisableClock",
    "shouldDisableTime",
    "minutesStep",
    "ampm",
    "disableIgnoringDatePartForTimeValidation"
];
const $5a2b0beb061d3a97$export$1df62d3ba2121371 = [
    "minDateTime",
    "maxDateTime"
];
const $5a2b0beb061d3a97$var$VALIDATION_PROP_NAMES = [
    ...$5a2b0beb061d3a97$export$430d9fc64cf058d6,
    ...$5a2b0beb061d3a97$export$fd5e0f8b4115a8c7,
    ...$5a2b0beb061d3a97$export$1df62d3ba2121371
];
const $5a2b0beb061d3a97$export$5890f750904acddb = (props)=>$5a2b0beb061d3a97$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});


const $660c563f49eb20a7$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    "value",
    "defaultValue",
    "referenceDate",
    "format",
    "formatDensity",
    "onChange",
    "timezone",
    "readOnly",
    "onError",
    "shouldRespectLeadingZeros",
    "selectedSections",
    "onSelectedSectionsChange",
    "unstableFieldRef"
];
const $660c563f49eb20a7$export$cdde224d2939fd84 = (props, valueType)=>{
    const forwardedProps = (0, $lzDk3.default)({}, props);
    const internalProps = {};
    const extractProp = (propName)=>{
        if (forwardedProps.hasOwnProperty(propName)) {
            // @ts-ignore
            internalProps[propName] = forwardedProps[propName];
            delete forwardedProps[propName];
        }
    };
    $660c563f49eb20a7$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
    if (valueType === "date") (0, $5a2b0beb061d3a97$export$430d9fc64cf058d6).forEach(extractProp);
    else if (valueType === "time") (0, $5a2b0beb061d3a97$export$fd5e0f8b4115a8c7).forEach(extractProp);
    else if (valueType === "date-time") {
        (0, $5a2b0beb061d3a97$export$430d9fc64cf058d6).forEach(extractProp);
        (0, $5a2b0beb061d3a97$export$fd5e0f8b4115a8c7).forEach(extractProp);
        (0, $5a2b0beb061d3a97$export$1df62d3ba2121371).forEach(extractProp);
    }
    return {
        forwardedProps: forwardedProps,
        internalProps: internalProps
    };
};


const $af803163ce7c7fdf$var$useDefaultizedDateField = (props)=>{
    var _props$disablePast, _props$disableFuture, _props$format;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const defaultDates = (0, $9faaabe544d2b9ed$export$7c38da3a2e90fa83)();
    return (0, $lzDk3.default)({}, props, {
        disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
        disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
        format: (_props$format = props.format) != null ? _props$format : utils.formats.keyboardDate,
        minDate: (0, $5605199c124089a3$export$eb73579ccade48fd)(utils, props.minDate, defaultDates.minDate),
        maxDate: (0, $5605199c124089a3$export$eb73579ccade48fd)(utils, props.maxDate, defaultDates.maxDate)
    });
};
const $af803163ce7c7fdf$export$5591b0b878c1a989 = ({ props: inProps, inputRef: inputRef })=>{
    const props = $af803163ce7c7fdf$var$useDefaultizedDateField(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $660c563f49eb20a7$export$cdde224d2939fd84)(props, "date");
    return (0, $3a95ffc7d6841493$export$294aa081a6c6f55d)({
        inputRef: inputRef,
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba),
        fieldValueManager: (0, $20065d9808d6bf8a$export$b602c94f557316b4),
        validator: (0, $4ea09a213332970d$export$ffb3d0046ef3a2),
        valueType: "date"
    });
};



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");






var $izf4p = parcelRequire("izf4p");
const $968f4be43e0364d3$var$_excluded = [
    "ownerState"
];
const $968f4be43e0364d3$export$db9644cdb7e3d432 = ({ clearable: clearable, fieldProps: forwardedFieldProps, InputProps: ForwardedInputProps, onClear: onClear, slots: slots, slotProps: slotProps, components: components, componentsProps: componentsProps })=>{
    var _ref, _slots$clearButton, _slotProps$clearButto, _ref2, _slots$clearIcon, _slotProps$clearIcon;
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const IconButton = (_ref = (_slots$clearButton = slots == null ? void 0 : slots.clearButton) != null ? _slots$clearButton : components == null ? void 0 : components.ClearButton) != null ? _ref : (0, $81fc785263d7b0b1$export$2e2bcd8739ae039);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: IconButton,
        externalSlotProps: (_slotProps$clearButto = slotProps == null ? void 0 : slotProps.clearButton) != null ? _slotProps$clearButto : componentsProps == null ? void 0 : componentsProps.clearButton,
        ownerState: {},
        className: "clearButton",
        additionalProps: {
            title: localeText.fieldClearLabel
        }
    }), iconButtonProps = (0, $g54n0.default)(_useSlotProps, $968f4be43e0364d3$var$_excluded);
    const EndClearIcon = (_ref2 = (_slots$clearIcon = slots == null ? void 0 : slots.clearIcon) != null ? _slots$clearIcon : components == null ? void 0 : components.ClearIcon) != null ? _ref2 : (0, $bb40f620f6ea1524$export$cefbac224a47f32);
    const endClearIconProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: EndClearIcon,
        externalSlotProps: (_slotProps$clearIcon = slotProps == null ? void 0 : slotProps.clearIcon) != null ? _slotProps$clearIcon : componentsProps == null ? void 0 : componentsProps.clearIcon,
        ownerState: {}
    });
    const InputProps = (0, $lzDk3.default)({}, ForwardedInputProps, {
        endAdornment: /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
            children: [
                clearable && /*#__PURE__*/ (0, $izf4p.jsx)((0, $d4adfbd348f78fa8$export$2e2bcd8739ae039), {
                    position: "end",
                    sx: {
                        marginRight: ForwardedInputProps != null && ForwardedInputProps.endAdornment ? -1 : -1.5
                    },
                    children: /*#__PURE__*/ (0, $izf4p.jsx)(IconButton, (0, $lzDk3.default)({}, iconButtonProps, {
                        onClick: onClear,
                        children: /*#__PURE__*/ (0, $izf4p.jsx)(EndClearIcon, (0, $lzDk3.default)({
                            fontSize: "small"
                        }, endClearIconProps))
                    }))
                }),
                ForwardedInputProps == null ? void 0 : ForwardedInputProps.endAdornment
            ]
        })
    });
    const fieldProps = (0, $lzDk3.default)({}, forwardedFieldProps, {
        sx: [
            {
                "& .clearButton": {
                    opacity: 1
                },
                "@media (pointer: fine)": {
                    "& .clearButton": {
                        opacity: 0
                    },
                    "&:hover, &:focus-within": {
                        ".clearButton": {
                            opacity: 1
                        }
                    }
                }
            },
            ...Array.isArray(forwardedFieldProps.sx) ? forwardedFieldProps.sx : [
                forwardedFieldProps.sx
            ]
        ]
    });
    return {
        InputProps: InputProps,
        fieldProps: fieldProps
    };
};



var $izf4p = parcelRequire("izf4p");
const $66478f725a38b5a3$var$_excluded = [
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "InputProps",
    "inputProps"
], $66478f725a38b5a3$var$_excluded2 = [
    "inputRef"
], $66478f725a38b5a3$var$_excluded3 = [
    "ref",
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "clearable",
    "onClear"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const $66478f725a38b5a3$export$d9781c7894a82487 = /*#__PURE__*/ $4YNlq.forwardRef(function DateField(inProps, ref) {
    var _ref, _slots$textField, _slotProps$textField;
    const themeProps = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiDateField"
    });
    const { components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $g54n0.default)(themeProps, $66478f725a38b5a3$var$_excluded);
    const ownerState = themeProps;
    const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : (0, $c82f3019ce6db68b$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: TextField,
        externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
        externalForwardedProps: other,
        ownerState: ownerState
    }), { inputRef: externalInputRef } = _useSlotProps, textFieldProps = (0, $g54n0.default)(_useSlotProps, $66478f725a38b5a3$var$_excluded2);
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $lzDk3.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $lzDk3.default)({}, InputProps, textFieldProps.InputProps);
    const _useDateField = (0, $af803163ce7c7fdf$export$5591b0b878c1a989)({
        props: textFieldProps,
        inputRef: externalInputRef
    }), { ref: inputRef, onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, clearable: clearable, onClear: onClear } = _useDateField, fieldProps = (0, $g54n0.default)(_useDateField, $66478f725a38b5a3$var$_excluded3);
    const { InputProps: ProcessedInputProps, fieldProps: processedFieldProps } = (0, $968f4be43e0364d3$export$db9644cdb7e3d432)({
        onClear: onClear,
        clearable: clearable,
        fieldProps: fieldProps,
        InputProps: fieldProps.InputProps,
        slots: slots,
        slotProps: slotProps,
        components: components,
        componentsProps: componentsProps
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)(TextField, (0, $lzDk3.default)({
        ref: ref
    }, processedFieldProps, {
        InputProps: (0, $lzDk3.default)({}, ProcessedInputProps, {
            readOnly: readOnly
        }),
        inputProps: (0, $lzDk3.default)({}, fieldProps.inputProps, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    }));
});



parcelRequire("4YNlq");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $4YNlq = parcelRequire("4YNlq");


const $44e7d3d5bd4ea732$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $9faaabe544d2b9ed$export$4b5a24245de9f7f9)();
    return $4YNlq.useCallback((day)=>(0, $4ea09a213332970d$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast,
                timezone: timezone
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};





const $91b4cab6dc3e4790$export$2aba07ea6b6cf430 = (reduceAnimations, disableSwitchToMonthOnDayFocus, utils)=>(state, action)=>{
        switch(action.type){
            case "changeMonth":
                return (0, $lzDk3.default)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.newMonth,
                    isMonthSwitchingAnimating: !reduceAnimations
                });
            case "finishMonthSwitchingAnimation":
                return (0, $lzDk3.default)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            case "changeFocusedDay":
                {
                    if (state.focusedDay != null && action.focusedDay != null && utils.isSameDay(action.focusedDay, state.focusedDay)) return state;
                    const needMonthSwitch = action.focusedDay != null && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
                    return (0, $lzDk3.default)({}, state, {
                        focusedDay: action.focusedDay,
                        isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations && !action.withoutMonthSwitchingAnimation,
                        currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
                        slideDirection: action.focusedDay != null && utils.isAfterDay(action.focusedDay, state.currentMonth) ? "left" : "right"
                    });
                }
            default:
                throw new Error("missing support");
        }
    };
const $91b4cab6dc3e4790$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, defaultCalendarMonth: defaultCalendarMonth, disableFuture: disableFuture, disablePast: disablePast, disableSwitchToMonthOnDayFocus: disableSwitchToMonthOnDayFocus = false, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone } = params;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const reducerFn = $4YNlq.useRef($91b4cab6dc3e4790$export$2aba07ea6b6cf430(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;
    const referenceDate = $4YNlq.useMemo(()=>{
        let externalReferenceDate = null;
        if (referenceDateProp) externalReferenceDate = referenceDateProp;
        else if (defaultCalendarMonth) // For `defaultCalendarMonth`, we just want to keep the month and the year to avoid a behavior change.
        externalReferenceDate = utils.startOfMonth(defaultCalendarMonth);
        return (0, $20065d9808d6bf8a$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            timezone: timezone,
            props: params,
            referenceDate: externalReferenceDate,
            granularity: (0, $05c56d59c112b284$export$8f74e8f4ed8ae0ac).day
        });
    }, [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const [calendarState, dispatch] = $4YNlq.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: utils.startOfMonth(referenceDate),
        slideDirection: "left"
    });
    const handleChangeMonth = $4YNlq.useCallback((payload)=>{
        dispatch((0, $lzDk3.default)({
            type: "changeMonth"
        }, payload));
        if (onMonthChange) onMonthChange(payload.newMonth);
    }, [
        onMonthChange
    ]);
    const changeMonth = $4YNlq.useCallback((newDate)=>{
        const newDateRequested = newDate;
        if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) return;
        handleChangeMonth({
            newMonth: utils.startOfMonth(newDateRequested),
            direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? "left" : "right"
        });
    }, [
        calendarState.currentMonth,
        handleChangeMonth,
        utils
    ]);
    const isDateDisabled = (0, $44e7d3d5bd4ea732$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    const onMonthSwitchingAnimationEnd = $4YNlq.useCallback(()=>{
        dispatch({
            type: "finishMonthSwitchingAnimation"
        });
    }, []);
    const changeFocusedDay = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newFocusedDate, withoutMonthSwitchingAnimation)=>{
        if (!isDateDisabled(newFocusedDate)) dispatch({
            type: "changeFocusedDay",
            focusedDay: newFocusedDate,
            withoutMonthSwitchingAnimation: withoutMonthSwitchingAnimation
        });
    });
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        changeMonth: changeMonth,
        changeFocusedDay: changeFocusedDay,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
        handleChangeMonth: handleChangeMonth
    };
};



parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");

var $1uy3y = parcelRequire("1uy3y");


var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
const $d1690af57a070719$export$5b0bb0174eb448ca = (slot)=>(0, $fx4gX.default)("MuiPickersFadeTransitionGroup", slot);
const $d1690af57a070719$export$1461f245817ac559 = (0, $auO16.default)("MuiPickersFadeTransitionGroup", [
    "root"
]);



var $izf4p = parcelRequire("izf4p");
const $d1b048259cdc864b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $d1690af57a070719$export$5b0bb0174eb448ca), classes);
};
const $d1b048259cdc864b$var$PickersFadeTransitionGroupRoot = (0, $JdaC3.default)((0, $1uy3y.default), {
    name: "MuiPickersFadeTransitionGroup",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "block",
    position: "relative"
});
function $d1b048259cdc864b$export$5262185daf493fee(inProps) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersFadeTransitionGroup"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props;
    const classes = $d1b048259cdc864b$var$useUtilityClasses(props);
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $izf4p.jsx)($d1b048259cdc864b$var$PickersFadeTransitionGroupRoot, {
        className: (0, $fQQpK.default)(classes.root, className),
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $802113259dde0d55$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");




var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $fQQpK = parcelRequire("fQQpK");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");

var $7y3ET = parcelRequire("7y3ET");

var $gA23F = parcelRequire("gA23F");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $c2fa6b3988feb883$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $gA23F.default)(value, min, max);
}
function $c2fa6b3988feb883$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, "g");
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? "a" : ""}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(", ")})` : "";
}
function $c2fa6b3988feb883$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $c2fa6b3988feb883$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === "#") return $c2fa6b3988feb883$export$677b39864803984e($c2fa6b3988feb883$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf("(");
    const type = color.substring(0, marker);
    if ([
        "rgb",
        "rgba",
        "hsl",
        "hsla",
        "color"
    ].indexOf(type) === -1) throw new Error((0, $7y3ET.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === "color") {
        values = values.split(" ");
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === "/") values[3] = values[3].slice(1);
        if ([
            "srgb",
            "display-p3",
            "a98-rgb",
            "prophoto-rgb",
            "rec-2020"
        ].indexOf(colorSpace) === -1) throw new Error((0, $7y3ET.default)(10, colorSpace));
    } else values = values.split(",");
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $c2fa6b3988feb883$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $c2fa6b3988feb883$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf("hsl") !== -1 && idx !== 0 ? `${val}%` : val).join(" ");
};
const $c2fa6b3988feb883$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $c2fa6b3988feb883$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $c2fa6b3988feb883$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf("rgb") !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf("hsl") !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf("color") !== -1) values = `${colorSpace} ${values.join(" ")}`;
    else values = `${values.join(", ")}`;
    return `${type}(${values})`;
}
function $c2fa6b3988feb883$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf("#") === 0) return color;
    const { values: values } = $c2fa6b3988feb883$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$c2fa6b3988feb883$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function $c2fa6b3988feb883$export$29fb7152bd3f781a(color) {
    color = $c2fa6b3988feb883$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = "rgb";
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === "hsla") {
        type += "a";
        rgb.push(values[3]);
    }
    return $c2fa6b3988feb883$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $c2fa6b3988feb883$export$c852d90bf7403b62(color) {
    color = $c2fa6b3988feb883$export$677b39864803984e(color);
    let rgb = color.type === "hsl" || color.type === "hsla" ? $c2fa6b3988feb883$export$677b39864803984e($c2fa6b3988feb883$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== "color") val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $c2fa6b3988feb883$export$d061e26956a60b0a(foreground, background) {
    const lumA = $c2fa6b3988feb883$export$c852d90bf7403b62(foreground);
    const lumB = $c2fa6b3988feb883$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $c2fa6b3988feb883$export$58f0f39f63f3cf42(color, value) {
    color = $c2fa6b3988feb883$export$677b39864803984e(color);
    value = $c2fa6b3988feb883$var$clampWrapper(value);
    if (color.type === "rgb" || color.type === "hsl") color.type += "a";
    if (color.type === "color") color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $c2fa6b3988feb883$export$211a73f2b8c10ce4(color);
}
function $c2fa6b3988feb883$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $c2fa6b3988feb883$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $c2fa6b3988feb883$export$4b073707ff63303(color, coefficient) {
    color = $c2fa6b3988feb883$export$677b39864803984e(color);
    coefficient = $c2fa6b3988feb883$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf("rgb") !== -1 || color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $c2fa6b3988feb883$export$211a73f2b8c10ce4(color);
}
function $c2fa6b3988feb883$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $c2fa6b3988feb883$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $c2fa6b3988feb883$export$c0816ed86df316af(color, coefficient) {
    color = $c2fa6b3988feb883$export$677b39864803984e(color);
    coefficient = $c2fa6b3988feb883$var$clampWrapper(coefficient);
    if (color.type.indexOf("hsl") !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf("rgb") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf("color") !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $c2fa6b3988feb883$export$211a73f2b8c10ce4(color);
}
function $c2fa6b3988feb883$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $c2fa6b3988feb883$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $c2fa6b3988feb883$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $c2fa6b3988feb883$export$c852d90bf7403b62(color) > 0.5 ? $c2fa6b3988feb883$export$4b073707ff63303(color, coefficient) : $c2fa6b3988feb883$export$c0816ed86df316af(color, coefficient);
}
function $c2fa6b3988feb883$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $c2fa6b3988feb883$export$11bb74ba10c85505(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $c2fa6b3988feb883$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $c2fa6b3988feb883$export$677b39864803984e(background);
    const overlayColor = $c2fa6b3988feb883$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $c2fa6b3988feb883$export$211a73f2b8c10ce4({
        type: "rgb",
        values: rgb
    });
}


var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");



var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $8ffbfbec965793af$export$4b25deb0350d3e53(slot) {
    return (0, $fx4gX.default)("MuiPickersDay", slot);
}
const $8ffbfbec965793af$export$68b221ad3c35e288 = (0, $auO16.default)("MuiPickersDay", [
    "root",
    "dayWithMargin",
    "dayOutsideMonth",
    "hiddenDaySpacingFiller",
    "today",
    "selected",
    "disabled"
]);



var $izf4p = parcelRequire("izf4p");
const $23cd93e462ff98f5$var$_excluded = [
    "autoFocus",
    "className",
    "day",
    "disabled",
    "disableHighlightToday",
    "disableMargin",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "outsideCurrentMonth",
    "selected",
    "showDaysOutsideCurrentMonth",
    "children",
    "today",
    "isFirstVisibleCell",
    "isLastVisibleCell"
];
const $23cd93e462ff98f5$var$useUtilityClasses = (ownerState)=>{
    const { selected: selected, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, today: today, disabled: disabled, outsideCurrentMonth: outsideCurrentMonth, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, classes: classes } = ownerState;
    const isHiddenDaySpacingFiller = outsideCurrentMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            "root",
            selected && !isHiddenDaySpacingFiller && "selected",
            disabled && "disabled",
            !disableMargin && "dayWithMargin",
            !disableHighlightToday && today && "today",
            outsideCurrentMonth && showDaysOutsideCurrentMonth && "dayOutsideMonth",
            isHiddenDaySpacingFiller && "hiddenDaySpacingFiller"
        ],
        hiddenDaySpacingFiller: [
            "hiddenDaySpacingFiller"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $8ffbfbec965793af$export$4b25deb0350d3e53), classes);
};
const $23cd93e462ff98f5$var$styleArg = ({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({}, theme.typography.caption, {
        width: (0, $8723b6bc9525bc47$export$3f0060ce4cc8f4d0),
        height: (0, $8723b6bc9525bc47$export$3f0060ce4cc8f4d0),
        borderRadius: "50%",
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: "transparent",
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        "@media (pointer: fine)": {
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $c2fa6b3988feb883$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $c2fa6b3988feb883$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $8ffbfbec965793af$export$68b221ad3c35e288).selected}`]: {
                willChange: "background-color",
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $8ffbfbec965793af$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            "&:hover": {
                willChange: "background-color",
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $8ffbfbec965793af$export$68b221ad3c35e288).disabled}:not(.${(0, $8ffbfbec965793af$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $8ffbfbec965793af$export$68b221ad3c35e288).disabled}&.${(0, $8ffbfbec965793af$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        }
    }, !ownerState.disableMargin && {
        margin: `0 ${0, $8723b6bc9525bc47$export$dde58b009b497666}px`
    }, ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && {
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableHighlightToday && ownerState.today && {
        [`&:not(.${(0, $8ffbfbec965793af$export$68b221ad3c35e288).selected})`]: {
            border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
        }
    });
const $23cd93e462ff98f5$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.today && styles.today,
        !ownerState.outsideCurrentMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.outsideCurrentMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $23cd93e462ff98f5$var$PickersDayRoot = (0, $JdaC3.default)((0, $7e17388639953587$export$2e2bcd8739ae039), {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $23cd93e462ff98f5$var$overridesResolver
})($23cd93e462ff98f5$var$styleArg);
const $23cd93e462ff98f5$var$PickersDayFiller = (0, $JdaC3.default)("div", {
    name: "MuiPickersDay",
    slot: "Root",
    overridesResolver: $23cd93e462ff98f5$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({}, $23cd93e462ff98f5$var$styleArg({
        theme: theme,
        ownerState: ownerState
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: "none"
    }));
const $23cd93e462ff98f5$var$noop = ()=>{};
const $23cd93e462ff98f5$var$PickersDayRaw = /*#__PURE__*/ $4YNlq.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersDay"
    });
    const { autoFocus: autoFocus = false, className: className, day: day, disabled: disabled = false, disableHighlightToday: disableHighlightToday = false, disableMargin: disableMargin = false, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $23cd93e462ff98f5$var$noop, onBlur: onBlur = $23cd93e462ff98f5$var$noop, onKeyDown: onKeyDown = $23cd93e462ff98f5$var$noop, onMouseDown: onMouseDown = $23cd93e462ff98f5$var$noop, onMouseEnter: onMouseEnter = $23cd93e462ff98f5$var$noop, outsideCurrentMonth: outsideCurrentMonth, selected: selected = false, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth = false, children: children, today: isToday = false } = props, other = (0, $g54n0.default)(props, $23cd93e462ff98f5$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        autoFocus: autoFocus,
        disabled: disabled,
        disableHighlightToday: disableHighlightToday,
        disableMargin: disableMargin,
        selected: selected,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        today: isToday
    });
    const classes = $23cd93e462ff98f5$var$useUtilityClasses(ownerState);
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const ref = $4YNlq.useRef(null);
    const handleRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For day outside of current month, move focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $izf4p.jsx)($23cd93e462ff98f5$var$PickersDayFiller, {
        className: (0, $fQQpK.default)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)($23cd93e462ff98f5$var$PickersDayRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: !children ? utils.format(day, "dayOfMonth") : children
    }));
});
const $23cd93e462ff98f5$export$d7378e6e864346fa = /*#__PURE__*/ $4YNlq.memo($23cd93e462ff98f5$var$PickersDayRaw);





var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $GxpsF = parcelRequire("GxpsF");

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $51c741818436d912$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $a95c22201fb7bbd4$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $51c741818436d912$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $5de85823db492f68$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $5de85823db492f68$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $5de85823db492f68$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $5de85823db492f68$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $4YNlq = parcelRequire("4YNlq");



var $7419303745b39b95$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $a95c22201fb7bbd4$export$2e2bcd8739ae039)(node, c);
    });
};
var $7419303745b39b95$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $5de85823db492f68$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $7419303745b39b95$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $GxpsF.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $34dffbbb6f3c8e6c$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $7419303745b39b95$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $7419303745b39b95$var$removeClass(node, baseClassName);
        if (activeClassName) $7419303745b39b95$var$removeClass(node, activeClassName);
        if (doneClassName) $7419303745b39b95$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $g54n0.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement((0, $c4b9c02358af45ec$export$2e2bcd8739ae039), (0, $lzDk3.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).Component);
$7419303745b39b95$var$CSSTransition.defaultProps = {
    classNames: ""
};
$7419303745b39b95$var$CSSTransition.propTypes = {};
var $7419303745b39b95$export$2e2bcd8739ae039 = $7419303745b39b95$var$CSSTransition;


var $1uy3y = parcelRequire("1uy3y");

var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
const $182870479573f267$export$e98c1b6c3bbc3c59 = (slot)=>(0, $fx4gX.default)("MuiPickersSlideTransition", slot);
const $182870479573f267$export$d251a58673156a67 = (0, $auO16.default)("MuiPickersSlideTransition", [
    "root",
    "slideEnter-left",
    "slideEnter-right",
    "slideEnterActive",
    "slideExit",
    "slideExitActiveLeft-left",
    "slideExitActiveLeft-right"
]);



var $izf4p = parcelRequire("izf4p");
const $05be77dca7d1b039$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $05be77dca7d1b039$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        exit: [
            "slideExit"
        ],
        enterActive: [
            "slideEnterActive"
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $182870479573f267$export$e98c1b6c3bbc3c59), classes);
};
const $05be77dca7d1b039$var$PickersSlideTransitionRoot = (0, $JdaC3.default)((0, $1uy3y.default), {
    name: "MuiPickersSlideTransition",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $182870479573f267$export$d251a58673156a67)["slideEnter-left"]}`]: styles["slideEnter-left"]
            },
            {
                [`.${(0, $182870479573f267$export$d251a58673156a67)["slideEnter-right"]}`]: styles["slideEnter-right"]
            },
            {
                [`.${(0, $182870479573f267$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $182870479573f267$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $182870479573f267$export$d251a58673156a67)["slideExitActiveLeft-left"]}`]: styles["slideExitActiveLeft-left"]
            },
            {
                [`.${(0, $182870479573f267$export$d251a58673156a67)["slideExitActiveLeft-right"]}`]: styles["slideExitActiveLeft-right"]
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create("transform", {
        duration: theme.transitions.duration.complex,
        easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
    });
    return {
        display: "block",
        position: "relative",
        overflowX: "hidden",
        "& > *": {
            position: "absolute",
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $182870479573f267$export$d251a58673156a67)["slideEnter-left"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            zIndex: 1
        },
        [`& .${(0, $182870479573f267$export$d251a58673156a67)["slideEnter-right"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            zIndex: 1
        },
        [`& .${(0, $182870479573f267$export$d251a58673156a67).slideEnterActive}`]: {
            transform: "translate(0%)",
            transition: slideTransition
        },
        [`& .${(0, $182870479573f267$export$d251a58673156a67).slideExit}`]: {
            transform: "translate(0%)"
        },
        [`& .${(0, $182870479573f267$export$d251a58673156a67)["slideExitActiveLeft-left"]}`]: {
            willChange: "transform",
            transform: "translate(-100%)",
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $182870479573f267$export$d251a58673156a67)["slideExitActiveLeft-right"]}`]: {
            willChange: "transform",
            transform: "translate(100%)",
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $05be77dca7d1b039$export$e868fcc7557d3a06(inProps) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersSlideTransition"
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, transKey: transKey } = props, other = (0, $g54n0.default)(props, $05be77dca7d1b039$var$_excluded);
    const classes = $05be77dca7d1b039$var$useUtilityClasses(props);
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $izf4p.jsx)("div", {
        className: (0, $fQQpK.default)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $izf4p.jsx)($05be77dca7d1b039$var$PickersSlideTransitionRoot, {
        className: (0, $fQQpK.default)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $4YNlq.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $7419303745b39b95$export$2e2bcd8739ae039), (0, $lzDk3.default)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}





var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
const $bec822a2bebeebcb$export$fbe827982a69894a = (slot)=>(0, $fx4gX.default)("MuiDayCalendar", slot);
const $bec822a2bebeebcb$export$e0770f35b28ac552 = (0, $auO16.default)("MuiDayCalendar", [
    "root",
    "header",
    "weekDayLabel",
    "loadingContainer",
    "slideTransition",
    "monthContainer",
    "weekContainer",
    "weekNumberLabel",
    "weekNumber"
]);



var $izf4p = parcelRequire("izf4p");
const $8d075bc3d174b71c$var$_excluded = [
    "parentProps",
    "day",
    "focusableDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $8d075bc3d174b71c$var$_excluded2 = [
    "ownerState"
];
const $8d075bc3d174b71c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        header: [
            "header"
        ],
        weekDayLabel: [
            "weekDayLabel"
        ],
        loadingContainer: [
            "loadingContainer"
        ],
        slideTransition: [
            "slideTransition"
        ],
        monthContainer: [
            "monthContainer"
        ],
        weekContainer: [
            "weekContainer"
        ],
        weekNumberLabel: [
            "weekNumberLabel"
        ],
        weekNumber: [
            "weekNumber"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $bec822a2bebeebcb$export$fbe827982a69894a), classes);
};
const $8d075bc3d174b71c$var$weeksContainerHeight = ((0, $8723b6bc9525bc47$export$3f0060ce4cc8f4d0) + (0, $8723b6bc9525bc47$export$dde58b009b497666) * 2) * 6;
const $8d075bc3d174b71c$var$PickersCalendarDayRoot = (0, $JdaC3.default)("div", {
    name: "MuiDayCalendar",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({});
const $8d075bc3d174b71c$var$PickersCalendarDayHeader = (0, $JdaC3.default)("div", {
    name: "MuiDayCalendar",
    slot: "Header",
    overridesResolver: (_, styles)=>styles.header
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
const $8d075bc3d174b71c$var$PickersCalendarWeekDayLabel = (0, $JdaC3.default)((0, $af664934923ca384$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekDayLabel",
    overridesResolver: (_, styles)=>styles.weekDayLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: (theme.vars || theme).palette.text.secondary
    }));
const $8d075bc3d174b71c$var$PickersCalendarWeekNumberLabel = (0, $JdaC3.default)((0, $af664934923ca384$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekNumberLabel",
    overridesResolver: (_, styles)=>styles.weekNumberLabel
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: "0 2px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: theme.palette.text.disabled
    }));
const $8d075bc3d174b71c$var$PickersCalendarWeekNumber = (0, $JdaC3.default)((0, $af664934923ca384$export$2e2bcd8739ae039), {
    name: "MuiDayCalendar",
    slot: "WeekNumber",
    overridesResolver: (_, styles)=>styles.weekNumber
})(({ theme: theme })=>(0, $lzDk3.default)({}, theme.typography.caption, {
        width: (0, $8723b6bc9525bc47$export$3f0060ce4cc8f4d0),
        height: (0, $8723b6bc9525bc47$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $8723b6bc9525bc47$export$dde58b009b497666)}px`,
        color: theme.palette.text.disabled,
        fontSize: "0.75rem",
        alignItems: "center",
        justifyContent: "center",
        display: "inline-flex"
    }));
const $8d075bc3d174b71c$var$PickersCalendarLoadingContainer = (0, $JdaC3.default)("div", {
    name: "MuiDayCalendar",
    slot: "LoadingContainer",
    overridesResolver: (_, styles)=>styles.loadingContainer
})({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: $8d075bc3d174b71c$var$weeksContainerHeight
});
const $8d075bc3d174b71c$var$PickersCalendarSlideTransition = (0, $JdaC3.default)((0, $05be77dca7d1b039$export$e868fcc7557d3a06), {
    name: "MuiDayCalendar",
    slot: "SlideTransition",
    overridesResolver: (_, styles)=>styles.slideTransition
})({
    minHeight: $8d075bc3d174b71c$var$weeksContainerHeight
});
const $8d075bc3d174b71c$var$PickersCalendarWeekContainer = (0, $JdaC3.default)("div", {
    name: "MuiDayCalendar",
    slot: "MonthContainer",
    overridesResolver: (_, styles)=>styles.monthContainer
})({
    overflow: "hidden"
});
const $8d075bc3d174b71c$var$PickersCalendarWeek = (0, $JdaC3.default)("div", {
    name: "MuiDayCalendar",
    slot: "WeekContainer",
    overridesResolver: (_, styles)=>styles.weekContainer
})({
    margin: `${(0, $8723b6bc9525bc47$export$dde58b009b497666)}px 0`,
    display: "flex",
    justifyContent: "center"
});
function $8d075bc3d174b71c$var$WrappedDay(_ref) {
    var _ref2, _slots$day, _slotProps$day;
    let { parentProps: parentProps, day: day, focusableDay: focusableDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $g54n0.default)(_ref, $8d075bc3d174b71c$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const now = (0, $9faaabe544d2b9ed$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusableDay !== null && utils.isSameDay(day, focusableDay);
    const isSelected = selectedDays.some((selectedDay)=>utils.isSameDay(selectedDay, day));
    const isToday = utils.isSameDay(day, now);
    const Day = (_ref2 = (_slots$day = slots == null ? void 0 : slots.day) != null ? _slots$day : components == null ? void 0 : components.Day) != null ? _ref2 : (0, $23cd93e462ff98f5$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: Day,
        externalSlotProps: (_slotProps$day = slotProps == null ? void 0 : slotProps.day) != null ? _slotProps$day : componentsProps == null ? void 0 : componentsProps.day,
        additionalProps: (0, $lzDk3.default)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: "gridcell",
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            "data-timestamp": utils.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $lzDk3.default)({}, parentProps, {
            day: day,
            selected: isSelected
        })
    }), dayProps = (0, $g54n0.default)(_useSlotProps, $8d075bc3d174b71c$var$_excluded2);
    const isDisabled = $4YNlq.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const outsideCurrentMonth = $4YNlq.useMemo(()=>utils.getMonth(day) !== currentMonthNumber, [
        utils,
        day,
        currentMonthNumber
    ]);
    const isFirstVisibleCell = $4YNlq.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, startOfMonth);
        return utils.isSameDay(day, utils.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    const isLastVisibleCell = $4YNlq.useMemo(()=>{
        const endOfMonth = utils.endOfMonth(utils.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return utils.isSameDay(day, endOfMonth);
        return utils.isSameDay(day, utils.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        utils
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)(Day, (0, $lzDk3.default)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: isViewFocused && isFocusableDay,
        today: isToday,
        outsideCurrentMonth: outsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? "date" : undefined
    }));
}
function $8d075bc3d174b71c$export$8fb56b32a5df6314(inProps) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiDayCalendar"
    });
    const { onFocusedDayChange: onFocusedDayChange, className: className, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $izf4p.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatterFromProps, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, autoFocus: autoFocus, timezone: timezone } = props;
    const now = (0, $9faaabe544d2b9ed$export$3a404aece3dff2fa)(timezone);
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const classes = $8d075bc3d174b71c$var$useUtilityClasses(props);
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    // before we could define this outside of the component scope, but now we need utils, which is only defined here
    const dayOfWeekFormatter = dayOfWeekFormatterFromProps || ((_day, date)=>utils.format(date, "weekdayShort").charAt(0).toUpperCase());
    const isDateDisabled = (0, $44e7d3d5bd4ea732$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const [internalHasFocus, setInternalHasFocus] = (0, $5327b1b36ff53449$export$2e2bcd8739ae039)({
        name: "DayCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const [internalFocusedDay, setInternalFocusedDay] = $4YNlq.useState(()=>focusedDay || now);
    const handleDaySelect = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            setInternalFocusedDay(day);
            onFocusedViewChange == null || onFocusedViewChange(true);
            setInternalHasFocus(true);
        }
    };
    const handleKeyDown = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case "ArrowUp":
                focusDay(utils.addDays(day, -7));
                event.preventDefault();
                break;
            case "ArrowDown":
                focusDay(utils.addDays(day, 7));
                event.preventDefault();
                break;
            case "ArrowLeft":
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? 1 : -1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? 1 : -1);
                    const closestDayToFocus = (0, $5605199c124089a3$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? newFocusedDayDefault : utils.startOfMonth(nextAvailableMonth),
                        maxDate: isRTL ? utils.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "ArrowRight":
                {
                    const newFocusedDayDefault = utils.addDays(day, isRTL ? -1 : 1);
                    const nextAvailableMonth = utils.addMonths(day, isRTL ? -1 : 1);
                    const closestDayToFocus = (0, $5605199c124089a3$export$ca1f317ae8db2ee8)({
                        utils: utils,
                        date: newFocusedDayDefault,
                        minDate: isRTL ? utils.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRTL ? newFocusedDayDefault : utils.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case "Home":
                focusDay(utils.startOfWeek(day));
                event.preventDefault();
                break;
            case "End":
                focusDay(utils.endOfWeek(day));
                event.preventDefault();
                break;
            case "PageUp":
                focusDay(utils.addMonths(day, 1));
                event.preventDefault();
                break;
            case "PageDown":
                focusDay(utils.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, day)=>{
        if (internalHasFocus && utils.isSameDay(internalFocusedDay, day)) onFocusedViewChange == null || onFocusedViewChange(false);
    });
    const currentMonthNumber = utils.getMonth(currentMonth);
    const validSelectedDays = $4YNlq.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>utils.startOfDay(day)), [
        utils,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: http://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = currentMonthNumber;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $4YNlq.useMemo(()=>/*#__PURE__*/ $4YNlq.createRef(), [
        transitionKey
    ]);
    const startOfCurrentWeek = utils.startOfWeek(now);
    const focusableDay = $4YNlq.useMemo(()=>{
        const startOfMonth = utils.startOfMonth(currentMonth);
        const endOfMonth = utils.endOfMonth(currentMonth);
        if (isDateDisabled(internalFocusedDay) || utils.isAfterDay(internalFocusedDay, endOfMonth) || utils.isBeforeDay(internalFocusedDay, startOfMonth)) return (0, $5605199c124089a3$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: internalFocusedDay,
            minDate: startOfMonth,
            maxDate: endOfMonth,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        });
        return internalFocusedDay;
    }, [
        currentMonth,
        disableFuture,
        disablePast,
        internalFocusedDay,
        isDateDisabled,
        utils,
        timezone
    ]);
    const weeksToDisplay = $4YNlq.useMemo(()=>{
        const currentMonthWithTimezone = utils.setTimezone(currentMonth, timezone);
        const toDisplay = utils.getWeekArray(currentMonthWithTimezone);
        let nextMonth = utils.addMonths(currentMonthWithTimezone, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = utils.getWeekArray(nextMonth);
            const hasCommonWeek = utils.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = utils.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        utils,
        timezone
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($8d075bc3d174b71c$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)($8d075bc3d174b71c$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $izf4p.jsx)($8d075bc3d174b71c$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": localeText.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: localeText.calendarWeekNumberHeaderText
                    }),
                    (0, $5605199c124089a3$export$24c38139da66592d)(utils, now).map((weekday, i)=>{
                        var _dayOfWeekFormatter;
                        const day = utils.format(weekday, "weekdayShort");
                        return /*#__PURE__*/ (0, $izf4p.jsx)($8d075bc3d174b71c$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": utils.format(utils.addDays(startOfCurrentWeek, i), "weekday"),
                            className: classes.weekDayLabel,
                            children: (_dayOfWeekFormatter = dayOfWeekFormatter == null ? void 0 : dayOfWeekFormatter(day, weekday)) != null ? _dayOfWeekFormatter : day
                        }, day + i.toString());
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $izf4p.jsx)($8d075bc3d174b71c$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $izf4p.jsx)($8d075bc3d174b71c$var$PickersCalendarSlideTransition, (0, $lzDk3.default)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $fQQpK.default)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $izf4p.jsx)($8d075bc3d174b71c$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $izf4p.jsxs)($8d075bc3d174b71c$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $izf4p.jsx)($8d075bc3d174b71c$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": localeText.calendarWeekNumberAriaLabelText(utils.getWeekNumber(week[0])),
                                    children: localeText.calendarWeekNumberText(utils.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $izf4p.jsx)($8d075bc3d174b71c$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        focusableDay: focusableDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        isViewFocused: internalHasFocus,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $fqQIZ = parcelRequire("fqQIZ");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $d17ac76011beaa7a$export$db90a620ac957a73(slot) {
    return (0, $fx4gX.default)("MuiPickersMonth", slot);
}
const $d17ac76011beaa7a$export$911e3973fa70a12b = (0, $auO16.default)("MuiPickersMonth", [
    "root",
    "monthButton",
    "disabled",
    "selected"
]);



var $izf4p = parcelRequire("izf4p");
const $038d975be3a71cd5$var$_excluded = [
    "autoFocus",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "aria-label",
    "monthsPerRow"
];
const $038d975be3a71cd5$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        monthButton: [
            "monthButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $d17ac76011beaa7a$export$db90a620ac957a73), classes);
};
const $038d975be3a71cd5$var$PickersMonthRoot = (0, $JdaC3.default)("div", {
    name: "MuiPickersMonth",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.monthsPerRow === 3 ? "33.3%" : "25%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }));
const $038d975be3a71cd5$var$PickersMonthButton = (0, $JdaC3.default)("button", {
    name: "MuiPickersMonth",
    slot: "MonthButton",
    overridesResolver: (_, styles)=>[
            styles.monthButton,
            {
                [`&.${(0, $d17ac76011beaa7a$export$911e3973fa70a12b).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $d17ac76011beaa7a$export$911e3973fa70a12b).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $lzDk3.default)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "8px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $c2fa6b3988feb883$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $c2fa6b3988feb883$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            cursor: "auto",
            pointerEvents: "none"
        },
        [`&.${(0, $d17ac76011beaa7a$export$911e3973fa70a12b).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $d17ac76011beaa7a$export$911e3973fa70a12b).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $038d975be3a71cd5$export$bc52fdb7f02f591a = /*#__PURE__*/ $4YNlq.memo(function PickersMonth(inProps) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersMonth"
    });
    const { autoFocus: autoFocus, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, "aria-current": ariaCurrent, "aria-label": ariaLabel } = props, other = (0, $g54n0.default)(props, $038d975be3a71cd5$var$_excluded);
    const ref = $4YNlq.useRef(null);
    const classes = $038d975be3a71cd5$var$useUtilityClasses(props);
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            var _ref$current;
            (_ref$current = ref.current) == null || _ref$current.focus();
        }
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)($038d975be3a71cd5$var$PickersMonthRoot, (0, $lzDk3.default)({
        className: classes.root,
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)($038d975be3a71cd5$var$PickersMonthButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            "aria-label": ariaLabel,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.monthButton,
            ownerState: props,
            children: children
        })
    }));
});




var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $e9aa3381904fa7ae$export$da0c97315339ebd9(slot) {
    return (0, $fx4gX.default)("MuiMonthCalendar", slot);
}
const $e9aa3381904fa7ae$export$edf77d5566c7007c = (0, $auO16.default)("MuiMonthCalendar", [
    "root"
]);








var $izf4p = parcelRequire("izf4p");
const $c24e0275b5f2c393$var$_excluded = [
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "autoFocus",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId"
];
const $c24e0275b5f2c393$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $e9aa3381904fa7ae$export$da0c97315339ebd9), classes);
};
function $c24e0275b5f2c393$export$5b6e066572408095(props, name) {
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const defaultDates = (0, $9faaabe544d2b9ed$export$7c38da3a2e90fa83)();
    const themeProps = (0, $4Q3YJ.default)({
        props: props,
        name: name
    });
    return (0, $lzDk3.default)({
        disableFuture: false,
        disablePast: false
    }, themeProps, {
        minDate: (0, $5605199c124089a3$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $5605199c124089a3$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $c24e0275b5f2c393$var$MonthCalendarRoot = (0, $JdaC3.default)("div", {
    name: "MuiMonthCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexWrap: "wrap",
    alignContent: "stretch",
    padding: "0 4px",
    width: (0, $8723b6bc9525bc47$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: "border-box"
});
const $c24e0275b5f2c393$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $4YNlq.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $c24e0275b5f2c393$export$5b6e066572408095(inProps, "MuiMonthCalendar");
    const { className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, disableHighlightToday: disableHighlightToday, autoFocus: autoFocus = false, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow = 3, timezone: timezoneProp, gridLabelId: gridLabelId } = props, other = (0, $g54n0.default)(props, $c24e0275b5f2c393$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $00e922e0bf6d2e8e$export$174d749f3b4c0f49)({
        name: "MonthCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba)
    });
    const now = (0, $9faaabe544d2b9ed$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $fqQIZ.default)();
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const referenceDate = $4YNlq.useMemo(()=>(0, $20065d9808d6bf8a$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $05c56d59c112b284$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $c24e0275b5f2c393$var$useUtilityClasses(ownerState);
    const todayMonth = $4YNlq.useMemo(()=>utils.getMonth(now), [
        utils,
        now
    ]);
    const selectedMonth = $4YNlq.useMemo(()=>{
        if (value != null) return utils.getMonth(value);
        if (disableHighlightToday) return null;
        return utils.getMonth(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedMonth, setFocusedMonth] = $4YNlq.useState(()=>selectedMonth || todayMonth);
    const [internalHasFocus, setInternalHasFocus] = (0, $5327b1b36ff53449$export$2e2bcd8739ae039)({
        name: "MonthCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $4YNlq.useCallback((dateToValidate)=>{
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = utils.startOfMonth(dateToValidate);
        if (utils.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (utils.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        utils
    ]);
    const handleMonthSelection = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, month)=>{
        if (readOnly) return;
        const newDate = utils.setMonth(value != null ? value : referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((month)=>{
        if (!isMonthDisabled(utils.setMonth(value != null ? value : referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $4YNlq.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case "ArrowUp":
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusMonth((monthsInYear + month + (theme.direction === "ltr" ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            case "ArrowRight":
                focusMonth((monthsInYear + month + (theme.direction === "ltr" ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)($c24e0275b5f2c393$var$MonthCalendarRoot, (0, $lzDk3.default)({
        ref: ref,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: (0, $5605199c124089a3$export$62591b96a734eacd)(utils, value != null ? value : referenceDate).map((month)=>{
            const monthNumber = utils.getMonth(month);
            const monthText = utils.format(month, "monthShort");
            const monthLabel = utils.format(month, "month");
            const isSelected = monthNumber === selectedMonth;
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $izf4p.jsx)((0, $038d975be3a71cd5$export$bc52fdb7f02f591a), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": todayMonth === monthNumber ? "date" : undefined,
                "aria-label": monthLabel,
                monthsPerRow: monthsPerRow,
                children: monthText
            }, monthText);
        })
    }));
});



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $fqQIZ = parcelRequire("fqQIZ");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $16cc454367a13004$export$183c9f339a61cd79(slot) {
    return (0, $fx4gX.default)("MuiPickersYear", slot);
}
const $16cc454367a13004$export$4ef58a3d9c6f4296 = (0, $auO16.default)("MuiPickersYear", [
    "root",
    "yearButton",
    "selected",
    "disabled"
]);



var $izf4p = parcelRequire("izf4p");
const $c6b7995dedfb336f$var$_excluded = [
    "autoFocus",
    "className",
    "children",
    "disabled",
    "selected",
    "value",
    "tabIndex",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "aria-current",
    "yearsPerRow"
];
const $c6b7995dedfb336f$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        yearButton: [
            "yearButton",
            disabled && "disabled",
            selected && "selected"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $16cc454367a13004$export$183c9f339a61cd79), classes);
};
const $c6b7995dedfb336f$var$PickersYearRoot = (0, $JdaC3.default)("div", {
    name: "MuiPickersYear",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root
        ]
})(({ ownerState: ownerState })=>({
        flexBasis: ownerState.yearsPerRow === 3 ? "33.3%" : "25%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }));
const $c6b7995dedfb336f$var$PickersYearButton = (0, $JdaC3.default)("button", {
    name: "MuiPickersYear",
    slot: "YearButton",
    overridesResolver: (_, styles)=>[
            styles.yearButton,
            {
                [`&.${(0, $16cc454367a13004$export$4ef58a3d9c6f4296).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $16cc454367a13004$export$4ef58a3d9c6f4296).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $lzDk3.default)({
        color: "unset",
        backgroundColor: "transparent",
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        margin: "6px 0",
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: "pointer",
        "&:focus": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $c2fa6b3988feb883$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $c2fa6b3988feb883$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        "&:disabled": {
            cursor: "auto",
            pointerEvents: "none"
        },
        [`&.${(0, $16cc454367a13004$export$4ef58a3d9c6f4296).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $16cc454367a13004$export$4ef58a3d9c6f4296).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            "&:focus, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $c6b7995dedfb336f$export$261f3fbd5fd5814d = /*#__PURE__*/ $4YNlq.memo(function PickersYear(inProps) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersYear"
    });
    const { autoFocus: autoFocus, className: className, children: children, disabled: disabled, selected: selected, value: value, tabIndex: tabIndex, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, "aria-current": ariaCurrent } = props, other = (0, $g54n0.default)(props, $c6b7995dedfb336f$var$_excluded);
    const ref = $4YNlq.useRef(null);
    const classes = $c6b7995dedfb336f$var$useUtilityClasses(props);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    $4YNlq.useEffect(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current.focus();
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)($c6b7995dedfb336f$var$PickersYearRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: props
    }, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)($c6b7995dedfb336f$var$PickersYearButton, {
            ref: ref,
            disabled: disabled,
            type: "button",
            role: "radio",
            tabIndex: disabled ? -1 : tabIndex,
            "aria-current": ariaCurrent,
            "aria-checked": selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value),
            className: classes.yearButton,
            ownerState: props,
            children: children
        })
    }));
});




var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $313a2865d3d5f3ce$export$4477acc520094dec(slot) {
    return (0, $fx4gX.default)("MuiYearCalendar", slot);
}
const $313a2865d3d5f3ce$export$e42d427cd9fe5fd7 = (0, $auO16.default)("MuiYearCalendar", [
    "root"
]);








var $izf4p = parcelRequire("izf4p");
const $4c8155ed96e63da4$var$_excluded = [
    "autoFocus",
    "className",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsPerRow",
    "timezone",
    "gridLabelId"
];
const $4c8155ed96e63da4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $313a2865d3d5f3ce$export$4477acc520094dec), classes);
};
function $4c8155ed96e63da4$var$useYearCalendarDefaultizedProps(props, name) {
    var _themeProps$yearsPerR;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const defaultDates = (0, $9faaabe544d2b9ed$export$7c38da3a2e90fa83)();
    const themeProps = (0, $4Q3YJ.default)({
        props: props,
        name: name
    });
    return (0, $lzDk3.default)({
        disablePast: false,
        disableFuture: false
    }, themeProps, {
        yearsPerRow: (_themeProps$yearsPerR = themeProps.yearsPerRow) != null ? _themeProps$yearsPerR : 3,
        minDate: (0, $5605199c124089a3$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $5605199c124089a3$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $4c8155ed96e63da4$var$YearCalendarRoot = (0, $JdaC3.default)("div", {
    name: "MuiYearCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    overflowY: "auto",
    height: "100%",
    padding: "0 4px",
    width: (0, $8723b6bc9525bc47$export$ee46b8a74d6c94d3),
    maxHeight: (0, $8723b6bc9525bc47$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: "border-box",
    position: "relative"
});
const $4c8155ed96e63da4$export$657f9200591b2b71 = /*#__PURE__*/ $4YNlq.forwardRef(function YearCalendar(inProps, ref) {
    const props = $4c8155ed96e63da4$var$useYearCalendarDefaultizedProps(inProps, "MuiYearCalendar");
    const { autoFocus: autoFocus, className: className, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, disableHighlightToday: disableHighlightToday, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId } = props, other = (0, $g54n0.default)(props, $4c8155ed96e63da4$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $00e922e0bf6d2e8e$export$174d749f3b4c0f49)({
        name: "YearCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba)
    });
    const now = (0, $9faaabe544d2b9ed$export$3a404aece3dff2fa)(timezone);
    const theme = (0, $fqQIZ.default)();
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const referenceDate = $4YNlq.useMemo(()=>(0, $20065d9808d6bf8a$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $05c56d59c112b284$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const ownerState = props;
    const classes = $4c8155ed96e63da4$var$useUtilityClasses(ownerState);
    const todayYear = $4YNlq.useMemo(()=>utils.getYear(now), [
        utils,
        now
    ]);
    const selectedYear = $4YNlq.useMemo(()=>{
        if (value != null) return utils.getYear(value);
        if (disableHighlightToday) return null;
        return utils.getYear(referenceDate);
    }, [
        value,
        utils,
        disableHighlightToday,
        referenceDate
    ]);
    const [focusedYear, setFocusedYear] = $4YNlq.useState(()=>selectedYear || todayYear);
    const [internalHasFocus, setInternalHasFocus] = (0, $5327b1b36ff53449$export$2e2bcd8739ae039)({
        name: "YearCalendar",
        state: "hasFocus",
        controlled: hasFocus,
        default: autoFocus != null ? autoFocus : false
    });
    const changeHasFocus = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $4YNlq.useCallback((dateToValidate)=>{
        if (disablePast && utils.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && utils.isAfterYear(dateToValidate, now)) return true;
        if (minDate && utils.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && utils.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = utils.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        utils
    ]);
    const handleYearSelection = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, year)=>{
        if (readOnly) return;
        const newDate = utils.setYear(value != null ? value : referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(utils.setYear(value != null ? value : referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus == null || onYearFocus(year);
        }
    });
    $4YNlq.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const handleKeyDown = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case "ArrowUp":
                focusYear(year - yearsPerRow);
                event.preventDefault();
                break;
            case "ArrowDown":
                focusYear(year + yearsPerRow);
                event.preventDefault();
                break;
            case "ArrowLeft":
                focusYear(year + (theme.direction === "ltr" ? -1 : 1));
                event.preventDefault();
                break;
            case "ArrowRight":
                focusYear(year + (theme.direction === "ltr" ? 1 : -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $4YNlq.useRef(null);
    const handleRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(ref, scrollerRef);
    $4YNlq.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)($4c8155ed96e63da4$var$YearCalendarRoot, (0, $lzDk3.default)({
        ref: handleRef,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId
    }, other, {
        children: utils.getYearRange(minDate, maxDate).map((year)=>{
            const yearNumber = utils.getYear(year);
            const isSelected = yearNumber === selectedYear;
            const isDisabled = disabled || isYearDisabled(year);
            return /*#__PURE__*/ (0, $izf4p.jsx)((0, $c6b7995dedfb336f$export$261f3fbd5fd5814d), {
                selected: isSelected,
                value: yearNumber,
                onClick: handleYearSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && yearNumber === focusedYear,
                disabled: isDisabled,
                tabIndex: yearNumber === focusedYear ? 0 : -1,
                onFocus: handleYearFocus,
                onBlur: handleYearBlur,
                "aria-current": todayYear === yearNumber ? "date" : undefined,
                yearsPerRow: yearsPerRow,
                children: utils.format(year, "year")
            }, utils.format(year, "year"));
        })
    }));
});




var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");


var $9JdRu = parcelRequire("9JdRu");





var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");


var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");




var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $13b550273c2368c0$export$cef978c25740de90(slot) {
    return (0, $fx4gX.default)("MuiPickersArrowSwitcher", slot);
}
const $13b550273c2368c0$export$f8819209558cd362 = (0, $auO16.default)("MuiPickersArrowSwitcher", [
    "root",
    "spacer",
    "button"
]);



var $izf4p = parcelRequire("izf4p");
const $d5b26e30be53473a$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel"
], $d5b26e30be53473a$var$_excluded2 = [
    "ownerState"
], $d5b26e30be53473a$var$_excluded3 = [
    "ownerState"
];
const $d5b26e30be53473a$var$PickersArrowSwitcherRoot = (0, $JdaC3.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex"
});
const $d5b26e30be53473a$var$PickersArrowSwitcherSpacer = (0, $JdaC3.default)("div", {
    name: "MuiPickersArrowSwitcher",
    slot: "Spacer",
    overridesResolver: (props, styles)=>styles.spacer
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $d5b26e30be53473a$var$PickersArrowSwitcherButton = (0, $JdaC3.default)((0, $81fc785263d7b0b1$export$2e2bcd8739ae039), {
    name: "MuiPickersArrowSwitcher",
    slot: "Button",
    overridesResolver: (props, styles)=>styles.button
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({}, ownerState.hidden && {
        visibility: "hidden"
    }));
const $d5b26e30be53473a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        spacer: [
            "spacer"
        ],
        button: [
            "button"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $13b550273c2368c0$export$cef978c25740de90), classes);
};
const $d5b26e30be53473a$export$597b7cbdb7b2a24c = /*#__PURE__*/ $4YNlq.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    var _slots$previousIconBu, _slots$nextIconButton, _slots$leftArrowIcon, _slots$rightArrowIcon;
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    const isRTL = theme.direction === "rtl";
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersArrowSwitcher"
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel } = props, other = (0, $g54n0.default)(props, $d5b26e30be53473a$var$_excluded);
    const ownerState = props;
    const classes = $d5b26e30be53473a$var$useUtilityClasses(ownerState);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = (_slots$previousIconBu = slots == null ? void 0 : slots.previousIconButton) != null ? _slots$previousIconBu : $d5b26e30be53473a$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.previousIconButton,
        additionalProps: {
            size: "medium",
            title: previousProps.label,
            "aria-label": previousProps.label,
            disabled: previousProps.isDisabled,
            edge: "end",
            onClick: previousProps.goTo
        },
        ownerState: (0, $lzDk3.default)({}, ownerState, {
            hidden: previousProps.isHidden
        }),
        className: classes.button
    });
    const NextIconButton = (_slots$nextIconButton = slots == null ? void 0 : slots.nextIconButton) != null ? _slots$nextIconButton : $d5b26e30be53473a$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: NextIconButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.nextIconButton,
        additionalProps: {
            size: "medium",
            title: nextProps.label,
            "aria-label": nextProps.label,
            disabled: nextProps.isDisabled,
            edge: "start",
            onClick: nextProps.goTo
        },
        ownerState: (0, $lzDk3.default)({}, ownerState, {
            hidden: nextProps.isHidden
        }),
        className: classes.button
    });
    const LeftArrowIcon = (_slots$leftArrowIcon = slots == null ? void 0 : slots.leftArrowIcon) != null ? _slots$leftArrowIcon : (0, $bb40f620f6ea1524$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.leftArrowIcon,
        additionalProps: {
            fontSize: "inherit"
        },
        ownerState: undefined
    }), leftArrowIconProps = (0, $g54n0.default)(_useSlotProps, $d5b26e30be53473a$var$_excluded2);
    const RightArrowIcon = (_slots$rightArrowIcon = slots == null ? void 0 : slots.rightArrowIcon) != null ? _slots$rightArrowIcon : (0, $bb40f620f6ea1524$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.rightArrowIcon,
        additionalProps: {
            fontSize: "inherit"
        },
        ownerState: undefined
    }), rightArrowIconProps = (0, $g54n0.default)(_useSlotProps2, $d5b26e30be53473a$var$_excluded3);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($d5b26e30be53473a$var$PickersArrowSwitcherRoot, (0, $lzDk3.default)({
        ref: ref,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)(PreviousIconButton, (0, $lzDk3.default)({}, previousIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $izf4p.jsx)(RightArrowIcon, (0, $lzDk3.default)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $izf4p.jsx)(LeftArrowIcon, (0, $lzDk3.default)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                children: children
            }) : /*#__PURE__*/ (0, $izf4p.jsx)($d5b26e30be53473a$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)(NextIconButton, (0, $lzDk3.default)({}, nextIconButtonProps, {
                children: isRTL ? /*#__PURE__*/ (0, $izf4p.jsx)(LeftArrowIcon, (0, $lzDk3.default)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $izf4p.jsx)(RightArrowIcon, (0, $lzDk3.default)({}, rightArrowIconProps))
            }))
        ]
    }));
});



var $4YNlq = parcelRequire("4YNlq");


function $c47d3ab1cf0a4934$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    return $4YNlq.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
        return !utils.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        utils,
        timezone
    ]);
}
function $c47d3ab1cf0a4934$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    return $4YNlq.useMemo(()=>{
        const now = utils.dateWithTimezone(undefined, timezone);
        const firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
        return !utils.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        utils,
        timezone
    ]);
}
function $c47d3ab1cf0a4934$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const meridiemMode = (0, $3b49d946f7c9f4c7$export$c3352ead7b032236)(date, utils);
    const handleMeridiemChange = $4YNlq.useCallback((mode)=>{
        const timeWithMeridiem = date == null ? null : (0, $3b49d946f7c9f4c7$export$c368d4ff66779998)(date, mode, Boolean(ampm), utils);
        onChange(timeWithMeridiem, selectionState != null ? selectionState : "partial");
    }, [
        ampm,
        date,
        onChange,
        selectionState,
        utils
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}



var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
const $294e25656cedc789$export$457ac4d3a1ad92b4 = (slot)=>(0, $fx4gX.default)("MuiPickersCalendarHeader", slot);
const $294e25656cedc789$export$63db7afb9247cb91 = (0, $auO16.default)("MuiPickersCalendarHeader", [
    "root",
    "labelContainer",
    "label",
    "switchViewButton",
    "switchViewIcon"
]);



var $izf4p = parcelRequire("izf4p");
const $554161dde38d595f$var$_excluded = [
    "slots",
    "slotProps",
    "components",
    "componentsProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "timezone"
], $554161dde38d595f$var$_excluded2 = [
    "ownerState"
];
const $554161dde38d595f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        labelContainer: [
            "labelContainer"
        ],
        label: [
            "label"
        ],
        switchViewButton: [
            "switchViewButton"
        ],
        switchViewIcon: [
            "switchViewIcon"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $294e25656cedc789$export$457ac4d3a1ad92b4), classes);
};
const $554161dde38d595f$var$PickersCalendarHeaderRoot = (0, $JdaC3.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    display: "flex",
    alignItems: "center",
    marginTop: 16,
    marginBottom: 8,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 30,
    minHeight: 30
});
const $554161dde38d595f$var$PickersCalendarHeaderLabelContainer = (0, $JdaC3.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "LabelContainer",
    overridesResolver: (_, styles)=>styles.labelContainer
})(({ theme: theme })=>(0, $lzDk3.default)({
        display: "flex",
        overflow: "hidden",
        alignItems: "center",
        cursor: "pointer",
        marginRight: "auto"
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $554161dde38d595f$var$PickersCalendarHeaderLabel = (0, $JdaC3.default)("div", {
    name: "MuiPickersCalendarHeader",
    slot: "Label",
    overridesResolver: (_, styles)=>styles.label
})({
    marginRight: 6
});
const $554161dde38d595f$var$PickersCalendarHeaderSwitchViewButton = (0, $JdaC3.default)((0, $81fc785263d7b0b1$export$2e2bcd8739ae039), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewButton",
    overridesResolver: (_, styles)=>styles.switchViewButton
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        marginRight: "auto"
    }, ownerState.view === "year" && {
        [`.${(0, $294e25656cedc789$export$63db7afb9247cb91).switchViewIcon}`]: {
            transform: "rotate(180deg)"
        }
    }));
const $554161dde38d595f$var$PickersCalendarHeaderSwitchViewIcon = (0, $JdaC3.default)((0, $bb40f620f6ea1524$export$ed0fe318cc298673), {
    name: "MuiPickersCalendarHeader",
    slot: "SwitchViewIcon",
    overridesResolver: (_, styles)=>styles.switchViewIcon
})(({ theme: theme })=>({
        willChange: "transform",
        transition: theme.transitions.create("transform"),
        transform: "rotate(0deg)"
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $554161dde38d595f$export$6801ffebb353f473 = /*#__PURE__*/ $4YNlq.forwardRef(function PickersCalendarHeader(inProps, ref) {
    var _ref, _slots$switchViewButt, _ref2, _slots$switchViewIcon;
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersCalendarHeader"
    });
    const { slots: slots, slotProps: slotProps, components: components, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, timezone: timezone } = props, other = (0, $g54n0.default)(props, $554161dde38d595f$var$_excluded);
    const ownerState = props;
    const classes = $554161dde38d595f$var$useUtilityClasses(props);
    const SwitchViewButton = (_ref = (_slots$switchViewButt = slots == null ? void 0 : slots.switchViewButton) != null ? _slots$switchViewButt : components == null ? void 0 : components.SwitchViewButton) != null ? _ref : $554161dde38d595f$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewButton,
        additionalProps: {
            size: "small",
            "aria-label": localeText.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: ownerState,
        className: classes.switchViewButton
    });
    const SwitchViewIcon = (_ref2 = (_slots$switchViewIcon = slots == null ? void 0 : slots.switchViewIcon) != null ? _slots$switchViewIcon : components == null ? void 0 : components.SwitchViewIcon) != null ? _ref2 : $554161dde38d595f$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps == null ? void 0 : slotProps.switchViewIcon,
        ownerState: undefined,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $g54n0.default)(_useSlotProps, $554161dde38d595f$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(utils.addMonths(month, 1), "left");
    const selectPreviousMonth = ()=>onMonthChange(utils.addMonths(month, -1), "right");
    const isNextMonthDisabled = (0, $c47d3ab1cf0a4934$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $c47d3ab1cf0a4934$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === "year") return null;
    return /*#__PURE__*/ (0, $izf4p.jsxs)($554161dde38d595f$var$PickersCalendarHeaderRoot, (0, $lzDk3.default)({}, other, {
        ownerState: ownerState,
        className: (0, $fQQpK.default)(className, classes.root),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)($554161dde38d595f$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $d1b048259cdc864b$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: utils.format(month, "monthAndYear"),
                        children: /*#__PURE__*/ (0, $izf4p.jsx)($554161dde38d595f$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: utils.format(month, "monthAndYear")
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $izf4p.jsx)(SwitchViewButton, (0, $lzDk3.default)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $izf4p.jsx)(SwitchViewIcon, (0, $lzDk3.default)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $802113259dde0d55$export$2e2bcd8739ae039), {
                in: view === "day",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $d5b26e30be53473a$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: localeText.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: localeText.nextMonth
                })
            })
        ]
    }));
});




var $JdaC3 = parcelRequire("JdaC3");

const $d626ddc70bd40290$export$512b066b8abdfde4 = (0, $JdaC3.default)("div")({
    overflow: "hidden",
    width: (0, $8723b6bc9525bc47$export$ee46b8a74d6c94d3),
    maxHeight: (0, $8723b6bc9525bc47$export$f2fef360e2df0cb7),
    display: "flex",
    flexDirection: "column",
    margin: "0 auto"
});




var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
const $c91d16f87c2f08fa$export$da8c2318897a6672 = (slot)=>(0, $fx4gX.default)("MuiDateCalendar", slot);
const $c91d16f87c2f08fa$export$d0237e2bb9598e8d = (0, $auO16.default)("MuiDateCalendar", [
    "root",
    "viewTransitionContainer"
]);






var $izf4p = parcelRequire("izf4p");
const $d5ae837102b4a3a2$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "defaultCalendarMonth",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $d5ae837102b4a3a2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        viewTransitionContainer: [
            "viewTransitionContainer"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $c91d16f87c2f08fa$export$da8c2318897a6672), classes);
};
function $d5ae837102b4a3a2$var$useDateCalendarDefaultizedProps(props, name) {
    var _themeProps$loading, _themeProps$disablePa, _themeProps$disableFu, _themeProps$openTo, _themeProps$views, _themeProps$reduceAni, _themeProps$renderLoa;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const defaultDates = (0, $9faaabe544d2b9ed$export$7c38da3a2e90fa83)();
    const defaultReduceAnimations = (0, $1eecc46dae84482d$export$ce40fb97be7f02d9)();
    const themeProps = (0, $4Q3YJ.default)({
        props: props,
        name: name
    });
    return (0, $lzDk3.default)({}, themeProps, {
        loading: (_themeProps$loading = themeProps.loading) != null ? _themeProps$loading : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        openTo: (_themeProps$openTo = themeProps.openTo) != null ? _themeProps$openTo : "day",
        views: (_themeProps$views = themeProps.views) != null ? _themeProps$views : [
            "year",
            "day"
        ],
        reduceAnimations: (_themeProps$reduceAni = themeProps.reduceAnimations) != null ? _themeProps$reduceAni : defaultReduceAnimations,
        renderLoading: (_themeProps$renderLoa = themeProps.renderLoading) != null ? _themeProps$renderLoa : ()=>/*#__PURE__*/ (0, $izf4p.jsx)("span", {
                children: "..."
            }),
        minDate: (0, $5605199c124089a3$export$eb73579ccade48fd)(utils, themeProps.minDate, defaultDates.minDate),
        maxDate: (0, $5605199c124089a3$export$eb73579ccade48fd)(utils, themeProps.maxDate, defaultDates.maxDate)
    });
}
const $d5ae837102b4a3a2$var$DateCalendarRoot = (0, $JdaC3.default)((0, $d626ddc70bd40290$export$512b066b8abdfde4), {
    name: "MuiDateCalendar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column",
    height: (0, $8723b6bc9525bc47$export$f2fef360e2df0cb7)
});
const $d5ae837102b4a3a2$var$DateCalendarViewTransitionContainer = (0, $JdaC3.default)((0, $d1b048259cdc864b$export$5262185daf493fee), {
    name: "MuiDateCalendar",
    slot: "ViewTransitionContainer",
    overridesResolver: (props, styles)=>styles.viewTransitionContainer
})({});
const $d5ae837102b4a3a2$export$68078fe5d2bf8909 = /*#__PURE__*/ $4YNlq.forwardRef(function DateCalendar(inProps, ref) {
    var _ref, _slots$calendarHeader, _slotProps$calendarHe;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const id = (0, $f7c9c9374bbf09f1$export$2e2bcd8739ae039)();
    const props = $d5ae837102b4a3a2$var$useDateCalendarDefaultizedProps(inProps, "MuiDateCalendar");
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, defaultCalendarMonth: defaultCalendarMonth, onChange: onChange, onYearChange: onYearChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $g54n0.default)(props, $d5ae837102b4a3a2$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $00e922e0bf6d2e8e$export$174d749f3b4c0f49)({
        name: "DateCalendar",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $f1f366fa9605ebb5$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, changeFocusedDay: changeFocusedDay, changeMonth: changeMonth, handleChangeMonth: handleChangeMonth, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $91b4cab6dc3e4790$export$6d095e787d2b5e1f)({
        value: value,
        defaultCalendarMonth: defaultCalendarMonth,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = (_ref = (_slots$calendarHeader = slots == null ? void 0 : slots.calendarHeader) != null ? _slots$calendarHeader : components == null ? void 0 : components.CalendarHeader) != null ? _ref : (0, $554161dde38d595f$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: CalendarHeader,
        externalSlotProps: (_slotProps$calendarHe = slotProps == null ? void 0 : slotProps.calendarHeader) != null ? _slotProps$calendarHe : componentsProps == null ? void 0 : componentsProps.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (newMonth, direction)=>handleChangeMonth({
                    newMonth: newMonth,
                    direction: direction
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId,
            slots: slots,
            slotProps: slotProps
        },
        ownerState: props
    });
    const handleDateMonthChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = utils.startOfMonth(newDate);
        const endOfMonth = utils.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $5605199c124089a3$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: utils.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, "finish");
            onMonthChange == null || onMonthChange(startOfMonth);
        } else {
            goToNextView();
            changeMonth(startOfMonth);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleDateYearChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = utils.startOfYear(newDate);
        const endOfYear = utils.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $5605199c124089a3$export$ca1f317ae8db2ee8)({
            utils: utils,
            date: newDate,
            minDate: utils.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: utils.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, "finish");
            onYearChange == null || onYearChange(closestEnabledDate);
        } else {
            goToNextView();
            changeMonth(startOfYear);
        }
        changeFocusedDay(closestEnabledDate, true);
    });
    const handleSelectedDayChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $5605199c124089a3$export$a98b123b8f29e004)(utils, day, value != null ? value : referenceDate), "finish", view);
        return handleValueChange(day, "finish", view);
    });
    $4YNlq.useEffect(()=>{
        if (value != null && utils.isValid(value)) changeMonth(value);
    }, [
        value
    ]); // eslint-disable-line
    const ownerState = props;
    const classes = $d5ae837102b4a3a2$var$useUtilityClasses(ownerState);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId
    };
    const prevOpenViewRef = $4YNlq.useRef(view);
    $4YNlq.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $4YNlq.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($d5ae837102b4a3a2$var$DateCalendarRoot, (0, $lzDk3.default)({
        ref: ref,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)(CalendarHeader, (0, $lzDk3.default)({}, calendarHeaderProps)),
            /*#__PURE__*/ (0, $izf4p.jsx)($d5ae837102b4a3a2$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                    children: [
                        view === "year" && /*#__PURE__*/ (0, $izf4p.jsx)((0, $4c8155ed96e63da4$export$657f9200591b2b71), (0, $lzDk3.default)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("year", isViewFocused),
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === "month" && /*#__PURE__*/ (0, $izf4p.jsx)((0, $c24e0275b5f2c393$export$d7a7c85c0f5afc4a), (0, $lzDk3.default)({}, baseDateValidationProps, commonViewProps, {
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("month", isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === "day" && /*#__PURE__*/ (0, $izf4p.jsx)((0, $8d075bc3d174b71c$export$8fb56b32a5df6314), (0, $lzDk3.default)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            onFocusedDayChange: changeFocusedDay,
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView("day", isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            components: components,
                            componentsProps: componentsProps,
                            slots: slots,
                            slotProps: slotProps,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




var $izf4p = parcelRequire("izf4p");
const $aac519a3cab41399$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsPerRow: yearsPerRow, defaultCalendarMonth: defaultCalendarMonth, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $d5ae837102b4a3a2$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $5605199c124089a3$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $5605199c124089a3$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsPerRow: yearsPerRow,
        defaultCalendarMonth: defaultCalendarMonth,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });



/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/x/api/date-pickers/desktop-date-picker/)
 */ const $7f582b3d8a420260$export$5a73641f0156e1e4 = /*#__PURE__*/ $4YNlq.forwardRef(function DesktopDatePicker(inProps, ref) {
    var _defaultizedProps$yea, _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $c7db6fbef166611f$export$a552c17ed3587731)(inProps, "MuiDesktopDatePicker");
    const viewRenderers = (0, $lzDk3.default)({
        day: (0, $aac519a3cab41399$export$69888ffe06193e5e),
        month: (0, $aac519a3cab41399$export$69888ffe06193e5e),
        year: (0, $aac519a3cab41399$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, $lzDk3.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $5605199c124089a3$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        yearsPerRow: (_defaultizedProps$yea = defaultizedProps.yearsPerRow) != null ? _defaultizedProps$yea : 4,
        slots: (0, $lzDk3.default)({
            openPickerIcon: (0, $bb40f620f6ea1524$export$5fda1783bb83f57b),
            field: (0, $66478f725a38b5a3$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $lzDk3.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $lzDk3.default)({}, (0, $2961338a1e0cb3f1$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $5a2b0beb061d3a97$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $lzDk3.default)({
                hidden: true
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $d093faa8b3894bf6$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba),
        valueType: "date",
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $4ea09a213332970d$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$7f582b3d8a420260$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $9ef1e9faa9036f72$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
            "all",
            "day",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "day",
        "month",
        "year"
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        3,
        4
    ])
};



var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $3iM0v = parcelRequire("3iM0v");



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");




var $lzDk3 = parcelRequire("lzDk3");
parcelRequire("4YNlq");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $20449462e09a16c0$export$61b0ee1f05fb344e(slot) {
    return (0, $fx4gX.default)("MuiDialogContent", slot);
}
const $20449462e09a16c0$var$dialogContentClasses = (0, $auO16.default)("MuiDialogContent", [
    "root",
    "dividers"
]);
var $20449462e09a16c0$export$2e2bcd8739ae039 = $20449462e09a16c0$var$dialogContentClasses;



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $b42cb7066ea45ee2$export$f5d2ec7e4c47e088(slot) {
    return (0, $fx4gX.default)("MuiDialogTitle", slot);
}
const $b42cb7066ea45ee2$var$dialogTitleClasses = (0, $auO16.default)("MuiDialogTitle", [
    "root"
]);
var $b42cb7066ea45ee2$export$2e2bcd8739ae039 = $b42cb7066ea45ee2$var$dialogTitleClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $52215407d34411a2$var$_excluded = [
    "className",
    "dividers"
];
const $52215407d34411a2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            "root",
            dividers && "dividers"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $20449462e09a16c0$export$61b0ee1f05fb344e), classes);
};
const $52215407d34411a2$var$DialogContentRoot = (0, $JdaC3.default)("div", {
    name: "MuiDialogContent",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        flex: "1 1 auto",
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: "touch",
        overflowY: "auto",
        padding: "20px 24px"
    }, ownerState.dividers ? {
        padding: "16px 24px",
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $b42cb7066ea45ee2$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $52215407d34411a2$var$DialogContent = /*#__PURE__*/ $4YNlq.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiDialogContent"
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $g54n0.default)(props, $52215407d34411a2$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        dividers: dividers
    });
    const classes = $52215407d34411a2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($52215407d34411a2$var$DialogContentRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $52215407d34411a2$export$2e2bcd8739ae039 = $52215407d34411a2$var$DialogContent;




var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");


var $2qCAA = parcelRequire("2qCAA");




var $4Q3YJ = parcelRequire("4Q3YJ");

var $JdaC3 = parcelRequire("JdaC3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $9251da9ed7cacf0c$export$2177af0aa15c34c2(slot) {
    return (0, $fx4gX.default)("MuiDialog", slot);
}
const $9251da9ed7cacf0c$var$dialogClasses = (0, $auO16.default)("MuiDialog", [
    "root",
    "scrollPaper",
    "scrollBody",
    "container",
    "paper",
    "paperScrollPaper",
    "paperScrollBody",
    "paperWidthFalse",
    "paperWidthXs",
    "paperWidthSm",
    "paperWidthMd",
    "paperWidthLg",
    "paperWidthXl",
    "paperFullWidth",
    "paperFullScreen"
]);
var $9251da9ed7cacf0c$export$2e2bcd8739ae039 = $9251da9ed7cacf0c$var$dialogClasses;



var $4YNlq = parcelRequire("4YNlq");
const $b6139abf4bf49dec$var$DialogContext = /*#__PURE__*/ $4YNlq.createContext({});
var $b6139abf4bf49dec$export$2e2bcd8739ae039 = $b6139abf4bf49dec$var$DialogContext;





var $izf4p = parcelRequire("izf4p");
"use client";
const $98741dd4bfdeaab5$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $98741dd4bfdeaab5$var$DialogBackdrop = (0, $JdaC3.default)((0, $6c2766c4f601db8a$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Backdrop",
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $98741dd4bfdeaab5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        container: [
            "container",
            `scroll${(0, $2qCAA.default)(scroll)}`
        ],
        paper: [
            "paper",
            `paperScroll${(0, $2qCAA.default)(scroll)}`,
            `paperWidth${(0, $2qCAA.default)(String(maxWidth))}`,
            fullWidth && "paperFullWidth",
            fullScreen && "paperFullScreen"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $9251da9ed7cacf0c$export$2177af0aa15c34c2), classes);
};
const $98741dd4bfdeaab5$var$DialogRoot = (0, $JdaC3.default)((0, $0402d29e5e243355$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
    }
});
const $98741dd4bfdeaab5$var$DialogContainer = (0, $JdaC3.default)("div", {
    name: "MuiDialog",
    slot: "Container",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $2qCAA.default)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        height: "100%",
        "@media print": {
            height: "auto"
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === "paper" && {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }, ownerState.scroll === "body" && {
        overflowY: "auto",
        overflowX: "hidden",
        textAlign: "center",
        "&::after": {
            content: '""',
            display: "inline-block",
            verticalAlign: "middle",
            height: "100%",
            width: "0"
        }
    }));
const $98741dd4bfdeaab5$var$DialogPaper = (0, $JdaC3.default)((0, $b622387df7e39ff3$export$2e2bcd8739ae039), {
    name: "MuiDialog",
    slot: "Paper",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $2qCAA.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $2qCAA.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        margin: 32,
        position: "relative",
        overflowY: "auto",
        // Fix IE11 issue, to remove at some point.
        "@media print": {
            overflowY: "visible",
            boxShadow: "none"
        }
    }, ownerState.scroll === "paper" && {
        display: "flex",
        flexDirection: "column",
        maxHeight: "calc(100% - 64px)"
    }, ownerState.scroll === "body" && {
        display: "inline-block",
        verticalAlign: "middle",
        textAlign: "left" // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: "calc(100% - 64px)"
    }, ownerState.maxWidth === "xs" && {
        maxWidth: theme.breakpoints.unit === "px" ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $9251da9ed7cacf0c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== "xs" && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $9251da9ed7cacf0c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: "calc(100% - 64px)"
            }
        }
    }, ownerState.fullWidth && {
        width: "calc(100% - 64px)"
    }, ownerState.fullScreen && {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        height: "100%",
        maxHeight: "none",
        borderRadius: 0,
        [`&.${(0, $9251da9ed7cacf0c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: "100%"
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $98741dd4bfdeaab5$var$Dialog = /*#__PURE__*/ $4YNlq.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiDialog"
    });
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { "aria-describedby": ariaDescribedby, "aria-labelledby": ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = "sm", onBackdropClick: onBackdropClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $b622387df7e39ff3$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = "paper", TransitionComponent: TransitionComponent = (0, $802113259dde0d55$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $g54n0.default)(props, $98741dd4bfdeaab5$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $98741dd4bfdeaab5$var$useUtilityClasses(ownerState);
    const backdropClick = $4YNlq.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, "backdropClick");
    };
    const ariaLabelledby = (0, $f7c9c9374bbf09f1$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $4YNlq.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)($98741dd4bfdeaab5$var$DialogRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $98741dd4bfdeaab5$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $lzDk3.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)(TransitionComponent, (0, $lzDk3.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $izf4p.jsx)($98741dd4bfdeaab5$var$DialogContainer, {
                className: (0, $fQQpK.default)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $izf4p.jsx)($98741dd4bfdeaab5$var$DialogPaper, (0, $lzDk3.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $fQQpK.default)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $b6139abf4bf49dec$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $98741dd4bfdeaab5$export$2e2bcd8739ae039 = $98741dd4bfdeaab5$var$Dialog;



var $JdaC3 = parcelRequire("JdaC3");


var $izf4p = parcelRequire("izf4p");
const $b1ee3467b1c4a235$var$PickersModalDialogRoot = (0, $JdaC3.default)((0, $98741dd4bfdeaab5$export$2e2bcd8739ae039))({
    [`& .${(0, $9251da9ed7cacf0c$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $9251da9ed7cacf0c$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $8723b6bc9525bc47$export$ee46b8a74d6c94d3)
    }
});
const $b1ee3467b1c4a235$var$PickersModalDialogContent = (0, $JdaC3.default)((0, $52215407d34411a2$export$2e2bcd8739ae039))({
    "&:first-of-type": {
        padding: 0
    }
});
function $b1ee3467b1c4a235$export$99f83c99e1491f77(props) {
    var _slots$dialog, _slots$mobileTransiti;
    const { children: children, onDismiss: onDismiss, open: open, slots: slots, slotProps: slotProps } = props;
    const Dialog = (_slots$dialog = slots == null ? void 0 : slots.dialog) != null ? _slots$dialog : $b1ee3467b1c4a235$var$PickersModalDialogRoot;
    const Transition = (_slots$mobileTransiti = slots == null ? void 0 : slots.mobileTransition) != null ? _slots$mobileTransiti : (0, $802113259dde0d55$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $izf4p.jsx)(Dialog, (0, $lzDk3.default)({
        open: open,
        onClose: onDismiss
    }, slotProps == null ? void 0 : slotProps.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps == null ? void 0 : slotProps.mobileTransition,
        PaperComponent: slots == null ? void 0 : slots.mobilePaper,
        PaperProps: slotProps == null ? void 0 : slotProps.mobilePaper,
        children: /*#__PURE__*/ (0, $izf4p.jsx)($b1ee3467b1c4a235$var$PickersModalDialogContent, {
            children: children
        })
    }));
}








var $izf4p = parcelRequire("izf4p");
const $7771c0bf8735da1e$var$_excluded = [
    "props",
    "getOpenDialogAriaText"
];
const $7771c0bf8735da1e$export$5ca0153a626a7dd7 = (_ref)=>{
    var _innerSlotProps$toolb, _innerSlotProps$toolb2, _slots$layout;
    let { props: props, getOpenDialogAriaText: getOpenDialogAriaText } = _ref, pickerParams = (0, $g54n0.default)(_ref, $7771c0bf8735da1e$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, className: className, sx: sx, format: format, formatDensity: formatDensity, timezone: timezone, name: name, label: label, inputRef: inputRef, readOnly: readOnly, disabled: disabled, localeText: localeText } = props;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const internalInputRef = $4YNlq.useRef(null);
    const labelId = (0, $f7c9c9374bbf09f1$export$2e2bcd8739ae039)();
    const isToolbarHidden = (_innerSlotProps$toolb = innerSlotProps == null || (_innerSlotProps$toolb2 = innerSlotProps.toolbar) == null ? void 0 : _innerSlotProps$toolb2.hidden) != null ? _innerSlotProps$toolb : false;
    const { open: open, actions: actions, layoutProps: layoutProps, renderCurrentView: renderCurrentView, fieldProps: pickerFieldProps } = (0, $3b3101f0c69683a4$export$fc3313977ac596c4)((0, $lzDk3.default)({}, pickerParams, {
        props: props,
        inputRef: internalInputRef,
        autoFocusView: true,
        additionalViewProps: {},
        wrapperVariant: "mobile"
    }));
    const Field = slots.field;
    const fieldProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: Field,
        externalSlotProps: innerSlotProps == null ? void 0 : innerSlotProps.field,
        additionalProps: (0, $lzDk3.default)({}, pickerFieldProps, isToolbarHidden && {
            id: labelId
        }, !(disabled || readOnly) && {
            onClick: actions.onOpen,
            onKeyDown: (0, $3887927531c6c329$export$4467fe8634707c85)(actions.onOpen)
        }, {
            readOnly: readOnly != null ? readOnly : true,
            disabled: disabled,
            className: className,
            sx: sx,
            format: format,
            formatDensity: formatDensity,
            timezone: timezone,
            label: label,
            name: name
        }),
        ownerState: props
    });
    // TODO: Move to `useSlotProps` when https://github.com/mui/material-ui/pull/35088 will be merged
    fieldProps.inputProps = (0, $lzDk3.default)({}, fieldProps.inputProps, {
        "aria-label": getOpenDialogAriaText(pickerFieldProps.value, utils)
    });
    const slotsForField = (0, $lzDk3.default)({
        textField: slots.textField
    }, fieldProps.slots);
    const Layout = (_slots$layout = slots.layout) != null ? _slots$layout : (0, $796538715ef9c40d$export$647f604ea2397c05);
    const handleInputRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(internalInputRef, fieldProps.inputRef, inputRef);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $lzDk3.default)({}, innerSlotProps, {
        toolbar: (0, $lzDk3.default)({}, innerSlotProps == null ? void 0 : innerSlotProps.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $lzDk3.default)({
            "aria-labelledby": labelledById
        }, innerSlotProps == null ? void 0 : innerSlotProps.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $izf4p.jsxs)((0, $f34cc3f354a72d02$export$dc45bdc734ce6f1e), {
            localeText: localeText,
            children: [
                /*#__PURE__*/ (0, $izf4p.jsx)(Field, (0, $lzDk3.default)({}, fieldProps, {
                    slots: slotsForField,
                    slotProps: slotProps,
                    inputRef: handleInputRef
                })),
                /*#__PURE__*/ (0, $izf4p.jsx)((0, $b1ee3467b1c4a235$export$99f83c99e1491f77), (0, $lzDk3.default)({}, actions, {
                    open: open,
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $izf4p.jsx)(Layout, (0, $lzDk3.default)({}, layoutProps, slotProps == null ? void 0 : slotProps.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                }))
            ]
        });
    return {
        renderPicker: renderPicker
    };
};









/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const $93e06602c508b23b$export$97b476d7a92fee62 = /*#__PURE__*/ $4YNlq.forwardRef(function MobileDatePicker(inProps, ref) {
    var _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $c7db6fbef166611f$export$a552c17ed3587731)(inProps, "MuiMobileDatePicker");
    const viewRenderers = (0, $lzDk3.default)({
        day: (0, $aac519a3cab41399$export$69888ffe06193e5e),
        month: (0, $aac519a3cab41399$export$69888ffe06193e5e),
        year: (0, $aac519a3cab41399$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $lzDk3.default)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $5605199c124089a3$export$bb1c921f313ec928)(utils, defaultizedProps, false),
        slots: (0, $lzDk3.default)({
            field: (0, $66478f725a38b5a3$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $lzDk3.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $lzDk3.default)({}, (0, $2961338a1e0cb3f1$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $5a2b0beb061d3a97$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $lzDk3.default)({
                hidden: false
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $7771c0bf8735da1e$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba),
        valueType: "date",
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openDatePickerDialogue) != null ? _props$localeText$ope : localeText.openDatePickerDialogue,
        validator: (0, $4ea09a213332970d$export$ffb3d0046ef3a2)
    });
    return renderPicker();
});
$93e06602c508b23b$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */ defaultCalendarMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $9ef1e9faa9036f72$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * Maximal selectable date.
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * Minimal selectable date.
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
            "all",
            "day",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number.isRequired
        })
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "day",
        "month",
        "year"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "day",
        "month",
        "year"
    ]).isRequired),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        3,
        4
    ])
};




var $izf4p = parcelRequire("izf4p");
const $9d1850e2214678f4$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/)
 */ const $9d1850e2214678f4$export$5109c6dd95d8fb00 = /*#__PURE__*/ $4YNlq.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiDatePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $3887927531c6c329$export$9ae5b19305db48ce) } = props, other = (0, $g54n0.default)(props, $9d1850e2214678f4$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $9648db6b3d91d1c6$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $izf4p.jsx)((0, $7f582b3d8a420260$export$5a73641f0156e1e4), (0, $lzDk3.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $93e06602c508b23b$export$97b476d7a92fee62), (0, $lzDk3.default)({
        ref: ref
    }, other));
});



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");



var $4Q3YJ = parcelRequire("4Q3YJ");


var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $3iM0v = parcelRequire("3iM0v");




var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");



var $4Q3YJ = parcelRequire("4Q3YJ");



var $lzDk3 = parcelRequire("lzDk3");



const $27c831a7a67b3d41$export$7bd013ac69eb590c = ({ adapter: adapter, value: value, props: props })=>{
    if (value === null) return null;
    const { minTime: minTime, maxTime: maxTime, minutesStep: minutesStep, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, disablePast: disablePast, disableFuture: disableFuture, timezone: timezone } = props;
    const now = adapter.utils.dateWithTimezone(undefined, timezone);
    const isAfter = (0, $3b49d946f7c9f4c7$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, adapter.utils);
    switch(true){
        case !adapter.utils.isValid(value):
            return "invalidDate";
        case Boolean(minTime && isAfter(minTime, value)):
            return "minTime";
        case Boolean(maxTime && isAfter(value, maxTime)):
            return "maxTime";
        case Boolean(disableFuture && adapter.utils.isAfter(value, now)):
            return "disableFuture";
        case Boolean(disablePast && adapter.utils.isBefore(value, now)):
            return "disablePast";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "hours")):
            return "shouldDisableTime-hours";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "minutes")):
            return "shouldDisableTime-minutes";
        case Boolean(shouldDisableTime && shouldDisableTime(value, "seconds")):
            return "shouldDisableTime-seconds";
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getHours(value), "hours")):
            return "shouldDisableClock-hours";
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getMinutes(value), "minutes")):
            return "shouldDisableClock-minutes";
        case Boolean(shouldDisableClock && shouldDisableClock(adapter.utils.getSeconds(value), "seconds")):
            return "shouldDisableClock-seconds";
        case Boolean(minutesStep && adapter.utils.getMinutes(value) % minutesStep !== 0):
            return "minutesStep";
        default:
            return null;
    }
};




const $42d87c82e8de57f5$var$useDefaultizedTimeField = (props)=>{
    var _props$ampm, _props$disablePast, _props$disableFuture, _props$format;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const ampm = (_props$ampm = props.ampm) != null ? _props$ampm : utils.is12HourCycleInCurrentLocale();
    const defaultFormat = ampm ? utils.formats.fullTime12h : utils.formats.fullTime24h;
    return (0, $lzDk3.default)({}, props, {
        disablePast: (_props$disablePast = props.disablePast) != null ? _props$disablePast : false,
        disableFuture: (_props$disableFuture = props.disableFuture) != null ? _props$disableFuture : false,
        format: (_props$format = props.format) != null ? _props$format : defaultFormat
    });
};
const $42d87c82e8de57f5$export$4c842f6a241dc825 = ({ props: inProps, inputRef: inputRef })=>{
    const props = $42d87c82e8de57f5$var$useDefaultizedTimeField(inProps);
    const { forwardedProps: forwardedProps, internalProps: internalProps } = (0, $660c563f49eb20a7$export$cdde224d2939fd84)(props, "time");
    return (0, $3a95ffc7d6841493$export$294aa081a6c6f55d)({
        inputRef: inputRef,
        forwardedProps: forwardedProps,
        internalProps: internalProps,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba),
        fieldValueManager: (0, $20065d9808d6bf8a$export$b602c94f557316b4),
        validator: (0, $27c831a7a67b3d41$export$7bd013ac69eb590c),
        valueType: "time"
    });
};




var $izf4p = parcelRequire("izf4p");
const $61ac5eed73d84851$var$_excluded = [
    "slots",
    "slotProps",
    "components",
    "componentsProps",
    "InputProps",
    "inputProps"
], $61ac5eed73d84851$var$_excluded2 = [
    "inputRef"
], $61ac5eed73d84851$var$_excluded3 = [
    "ref",
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "clearable",
    "onClear"
];
/**
 * Demos:
 *
 * - [TimeField](http://mui.com/x/react-date-pickers/time-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [TimeField API](https://mui.com/x/api/date-pickers/time-field/)
 */ const $61ac5eed73d84851$export$5eaee2322dd727eb = /*#__PURE__*/ $4YNlq.forwardRef(function TimeField(inProps, ref) {
    var _ref, _slots$textField, _slotProps$textField;
    const themeProps = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiTimeField"
    });
    const { slots: slots, slotProps: slotProps, components: components, componentsProps: componentsProps, InputProps: InputProps, inputProps: inputProps } = themeProps, other = (0, $g54n0.default)(themeProps, $61ac5eed73d84851$var$_excluded);
    const ownerState = themeProps;
    const TextField = (_ref = (_slots$textField = slots == null ? void 0 : slots.textField) != null ? _slots$textField : components == null ? void 0 : components.TextField) != null ? _ref : (0, $c82f3019ce6db68b$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: TextField,
        externalSlotProps: (_slotProps$textField = slotProps == null ? void 0 : slotProps.textField) != null ? _slotProps$textField : componentsProps == null ? void 0 : componentsProps.textField,
        externalForwardedProps: other,
        ownerState: ownerState
    }), { inputRef: externalInputRef } = _useSlotProps, textFieldProps = (0, $g54n0.default)(_useSlotProps, $61ac5eed73d84851$var$_excluded2);
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $lzDk3.default)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $lzDk3.default)({}, InputProps, textFieldProps.InputProps);
    const _useTimeField = (0, $42d87c82e8de57f5$export$4c842f6a241dc825)({
        props: textFieldProps,
        inputRef: externalInputRef
    }), { ref: inputRef, onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, clearable: clearable, onClear: onClear } = _useTimeField, fieldProps = (0, $g54n0.default)(_useTimeField, $61ac5eed73d84851$var$_excluded3);
    const { InputProps: ProcessedInputProps, fieldProps: processedFieldProps } = (0, $968f4be43e0364d3$export$db9644cdb7e3d432)({
        onClear: onClear,
        clearable: clearable,
        fieldProps: fieldProps,
        InputProps: fieldProps.InputProps,
        slots: slots,
        slotProps: slotProps,
        components: components,
        componentsProps: componentsProps
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)(TextField, (0, $lzDk3.default)({
        ref: ref
    }, processedFieldProps, {
        InputProps: (0, $lzDk3.default)({}, ProcessedInputProps, {
            readOnly: readOnly
        }),
        inputProps: (0, $lzDk3.default)({}, fieldProps.inputProps, {
            inputMode: inputMode,
            onPaste: onPaste,
            onKeyDown: onKeyDown,
            ref: inputRef
        })
    }));
});



var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $4Q3YJ = parcelRequire("4Q3YJ");


var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");
parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");

var $3iM0v = parcelRequire("3iM0v");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");


var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $0628b7a87eaa66d7$export$2aab7addfa1bc589(slot) {
    return (0, $fx4gX.default)("MuiPickersToolbarText", slot);
}
const $0628b7a87eaa66d7$export$4ca7b92014bf2e56 = (0, $auO16.default)("MuiPickersToolbarText", [
    "root",
    "selected"
]);



var $izf4p = parcelRequire("izf4p");
const $ad84dd3aff8f7c93$var$_excluded = [
    "className",
    "selected",
    "value"
];
const $ad84dd3aff8f7c93$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $0628b7a87eaa66d7$export$2aab7addfa1bc589), classes);
};
const $ad84dd3aff8f7c93$var$PickersToolbarTextRoot = (0, $JdaC3.default)((0, $af664934923ca384$export$2e2bcd8739ae039), {
    name: "MuiPickersToolbarText",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $0628b7a87eaa66d7$export$4ca7b92014bf2e56).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>({
        transition: theme.transitions.create("color"),
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $0628b7a87eaa66d7$export$4ca7b92014bf2e56).selected}`]: {
            color: (theme.vars || theme).palette.text.primary
        }
    }));
const $ad84dd3aff8f7c93$export$2006bc630443fa2 = /*#__PURE__*/ $4YNlq.forwardRef(function PickersToolbarText(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersToolbarText"
    });
    const { className: className, value: value } = props, other = (0, $g54n0.default)(props, $ad84dd3aff8f7c93$var$_excluded);
    const classes = $ad84dd3aff8f7c93$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $izf4p.jsx)($ad84dd3aff8f7c93$var$PickersToolbarTextRoot, (0, $lzDk3.default)({
        ref: ref,
        className: (0, $fQQpK.default)(className, classes.root),
        component: "span"
    }, other, {
        children: value
    }));
});



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");


var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");



var $izf4p = parcelRequire("izf4p");
const $b1d11b674cc7e7e3$var$_excluded = [
    "align",
    "className",
    "selected",
    "typographyClassName",
    "value",
    "variant",
    "width"
];
const $b1d11b674cc7e7e3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $0a681dd9d02d3403$export$b109c489973c3d80), classes);
};
const $b1d11b674cc7e7e3$var$PickersToolbarButtonRoot = (0, $JdaC3.default)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039), {
    name: "MuiPickersToolbarButton",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})({
    padding: 0,
    minWidth: 16,
    textTransform: "none"
});
const $b1d11b674cc7e7e3$export$614ed940168c780c = /*#__PURE__*/ $4YNlq.forwardRef(function PickersToolbarButton(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiPickersToolbarButton"
    });
    const { align: align, className: className, selected: selected, typographyClassName: typographyClassName, value: value, variant: variant, width: width } = props, other = (0, $g54n0.default)(props, $b1d11b674cc7e7e3$var$_excluded);
    const classes = $b1d11b674cc7e7e3$var$useUtilityClasses(props);
    return /*#__PURE__*/ (0, $izf4p.jsx)($b1d11b674cc7e7e3$var$PickersToolbarButtonRoot, (0, $lzDk3.default)({
        variant: "text",
        ref: ref,
        className: (0, $fQQpK.default)(className, classes.root)
    }, width ? {
        sx: {
            width: width
        }
    } : {}, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $ad84dd3aff8f7c93$export$2006bc630443fa2), {
            align: align,
            className: typographyClassName,
            variant: variant,
            value: value,
            selected: selected
        })
    }));
});







var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $a45f797e5d522a74$export$56e751cdf7deddcb(slot) {
    return (0, $fx4gX.default)("MuiTimePickerToolbar", slot);
}
const $a45f797e5d522a74$export$b6febfcac6caa550 = (0, $auO16.default)("MuiTimePickerToolbar", [
    "root",
    "separator",
    "hourMinuteLabel",
    "hourMinuteLabelLandscape",
    "hourMinuteLabelReverse",
    "ampmSelection",
    "ampmLandscape",
    "ampmLabel"
]);




var $izf4p = parcelRequire("izf4p");
const $788b11f1b81c392c$var$_excluded = [
    "ampm",
    "ampmInClock",
    "value",
    "isLandscape",
    "onChange",
    "view",
    "onViewChange",
    "views",
    "disabled",
    "readOnly",
    "className"
];
const $788b11f1b81c392c$var$useUtilityClasses = (ownerState)=>{
    const { theme: theme, isLandscape: isLandscape, classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        separator: [
            "separator"
        ],
        hourMinuteLabel: [
            "hourMinuteLabel",
            isLandscape && "hourMinuteLabelLandscape",
            theme.direction === "rtl" && "hourMinuteLabelReverse"
        ],
        ampmSelection: [
            "ampmSelection",
            isLandscape && "ampmLandscape"
        ],
        ampmLabel: [
            "ampmLabel"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $a45f797e5d522a74$export$56e751cdf7deddcb), classes);
};
const $788b11f1b81c392c$var$TimePickerToolbarRoot = (0, $JdaC3.default)((0, $dbddef6c8f2cfe01$export$eb3c4d84783d6feb), {
    name: "MuiTimePickerToolbar",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({});
const $788b11f1b81c392c$var$TimePickerToolbarSeparator = (0, $JdaC3.default)((0, $ad84dd3aff8f7c93$export$2006bc630443fa2), {
    name: "MuiTimePickerToolbar",
    slot: "Separator",
    overridesResolver: (props, styles)=>styles.separator
})({
    outline: 0,
    margin: "0 4px 0 2px",
    cursor: "default"
});
const $788b11f1b81c392c$var$TimePickerToolbarHourMinuteLabel = (0, $JdaC3.default)("div", {
    name: "MuiTimePickerToolbar",
    slot: "HourMinuteLabel",
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $a45f797e5d522a74$export$b6febfcac6caa550).hourMinuteLabelLandscape}`]: styles.hourMinuteLabelLandscape,
                [`&.${(0, $a45f797e5d522a74$export$b6febfcac6caa550).hourMinuteLabelReverse}`]: styles.hourMinuteLabelReverse
            },
            styles.hourMinuteLabel
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end"
    }, ownerState.isLandscape && {
        marginTop: "auto"
    }, theme.direction === "rtl" && {
        flexDirection: "row-reverse"
    }));
$788b11f1b81c392c$var$TimePickerToolbarHourMinuteLabel.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object
    ])
};
const $788b11f1b81c392c$var$TimePickerToolbarAmPmSelection = (0, $JdaC3.default)("div", {
    name: "MuiTimePickerToolbar",
    slot: "AmPmSelection",
    overridesResolver: (props, styles)=>[
            {
                [`.${(0, $a45f797e5d522a74$export$b6febfcac6caa550).ampmLabel}`]: styles.ampmLabel
            },
            {
                [`&.${(0, $a45f797e5d522a74$export$b6febfcac6caa550).ampmLandscape}`]: styles.ampmLandscape
            },
            styles.ampmSelection
        ]
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "flex",
        flexDirection: "column",
        marginRight: "auto",
        marginLeft: 12
    }, ownerState.isLandscape && {
        margin: "4px 0 auto",
        flexDirection: "row",
        justifyContent: "space-around",
        flexBasis: "100%"
    }, {
        [`& .${(0, $a45f797e5d522a74$export$b6febfcac6caa550).ampmLabel}`]: {
            fontSize: 17
        }
    }));
$788b11f1b81c392c$var$TimePickerToolbarAmPmSelection.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    as: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).elementType,
    ownerState: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object.isRequired,
    sx: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object
    ])
};
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Custom components](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [TimePickerToolbar API](https://mui.com/x/api/date-pickers/time-picker-toolbar/)
 */ function $788b11f1b81c392c$export$76f7aa019fd43cd9(inProps) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiTimePickerToolbar"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, value: value, isLandscape: isLandscape, onChange: onChange, view: view, onViewChange: onViewChange, views: views, disabled: disabled, readOnly: readOnly, className: className } = props, other = (0, $g54n0.default)(props, $788b11f1b81c392c$var$_excluded);
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    const showAmPmControl = Boolean(ampm && !ampmInClock && views.includes("hours"));
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $c47d3ab1cf0a4934$export$6aaabc31cb076d17)(value, ampm, onChange);
    const formatHours = (time)=>ampm ? utils.format(time, "hours12h") : utils.format(time, "hours24h");
    const ownerState = props;
    const classes = $788b11f1b81c392c$var$useUtilityClasses((0, $lzDk3.default)({}, ownerState, {
        theme: theme
    }));
    const separator = /*#__PURE__*/ (0, $izf4p.jsx)($788b11f1b81c392c$var$TimePickerToolbarSeparator, {
        tabIndex: -1,
        value: ":",
        variant: "h3",
        selected: false,
        className: classes.separator
    });
    return /*#__PURE__*/ (0, $izf4p.jsxs)($788b11f1b81c392c$var$TimePickerToolbarRoot, (0, $lzDk3.default)({
        landscapeDirection: "row",
        toolbarTitle: localeText.timePickerToolbarTitle,
        isLandscape: isLandscape,
        ownerState: ownerState,
        className: (0, $fQQpK.default)(classes.root, className)
    }, other, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)($788b11f1b81c392c$var$TimePickerToolbarHourMinuteLabel, {
                className: classes.hourMinuteLabel,
                ownerState: ownerState,
                children: [
                    (0, $3887927531c6c329$export$22012a5c726bef55)(views, "hours") && /*#__PURE__*/ (0, $izf4p.jsx)((0, $b1d11b674cc7e7e3$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>onViewChange("hours"),
                        selected: view === "hours",
                        value: value ? formatHours(value) : "--"
                    }),
                    (0, $3887927531c6c329$export$22012a5c726bef55)(views, [
                        "hours",
                        "minutes"
                    ]) && separator,
                    (0, $3887927531c6c329$export$22012a5c726bef55)(views, "minutes") && /*#__PURE__*/ (0, $izf4p.jsx)((0, $b1d11b674cc7e7e3$export$614ed940168c780c), {
                        tabIndex: -1,
                        variant: "h3",
                        onClick: ()=>onViewChange("minutes"),
                        selected: view === "minutes",
                        value: value ? utils.format(value, "minutes") : "--"
                    }),
                    (0, $3887927531c6c329$export$22012a5c726bef55)(views, [
                        "minutes",
                        "seconds"
                    ]) && separator,
                    (0, $3887927531c6c329$export$22012a5c726bef55)(views, "seconds") && /*#__PURE__*/ (0, $izf4p.jsx)((0, $b1d11b674cc7e7e3$export$614ed940168c780c), {
                        variant: "h3",
                        onClick: ()=>onViewChange("seconds"),
                        selected: view === "seconds",
                        value: value ? utils.format(value, "seconds") : "--"
                    })
                ]
            }),
            showAmPmControl && /*#__PURE__*/ (0, $izf4p.jsxs)($788b11f1b81c392c$var$TimePickerToolbarAmPmSelection, {
                className: classes.ampmSelection,
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $b1d11b674cc7e7e3$export$614ed940168c780c), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === "am",
                        typographyClassName: classes.ampmLabel,
                        value: (0, $5605199c124089a3$export$fae94c0a662107ef)(utils, "am"),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $b1d11b674cc7e7e3$export$614ed940168c780c), {
                        disableRipple: true,
                        variant: "subtitle2",
                        selected: meridiemMode === "pm",
                        typographyClassName: classes.ampmLabel,
                        value: (0, $5605199c124089a3$export$fae94c0a662107ef)(utils, "pm"),
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        disabled: disabled
                    })
                ]
            })
        ]
    }));
}




function $718d452a39283a49$export$586c31b46cc238ba(props, name) {
    var _themeProps$ampm, _themeProps$slots, _themeProps$slotProps, _themeProps$disableFu, _themeProps$disablePa;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const themeProps = (0, $4Q3YJ.default)({
        props: props,
        name: name
    });
    const ampm = (_themeProps$ampm = themeProps.ampm) != null ? _themeProps$ampm : utils.is12HourCycleInCurrentLocale();
    const localeText = $4YNlq.useMemo(()=>{
        var _themeProps$localeTex;
        if (((_themeProps$localeTex = themeProps.localeText) == null ? void 0 : _themeProps$localeTex.toolbarTitle) == null) return themeProps.localeText;
        return (0, $lzDk3.default)({}, themeProps.localeText, {
            timePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    const slots = (_themeProps$slots = themeProps.slots) != null ? _themeProps$slots : (0, $42fcfbc058f0ed42$export$ee17bc394843b249)(themeProps.components);
    const slotProps = (_themeProps$slotProps = themeProps.slotProps) != null ? _themeProps$slotProps : themeProps.componentsProps;
    return (0, $lzDk3.default)({}, themeProps, {
        ampm: ampm,
        localeText: localeText
    }, (0, $a7f52c7c1125a3f0$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            "hours",
            "minutes"
        ],
        defaultOpenTo: "hours"
    }), {
        disableFuture: (_themeProps$disableFu = themeProps.disableFuture) != null ? _themeProps$disableFu : false,
        disablePast: (_themeProps$disablePa = themeProps.disablePast) != null ? _themeProps$disablePa : false,
        slots: (0, $lzDk3.default)({
            toolbar: (0, $788b11f1b81c392c$export$76f7aa019fd43cd9)
        }, slots),
        slotProps: (0, $lzDk3.default)({}, slotProps, {
            toolbar: (0, $lzDk3.default)({
                ampm: ampm,
                ampmInClock: themeProps.ampmInClock
            }, slotProps == null ? void 0 : slotProps.toolbar)
        })
    });
}







parcelRequire("4YNlq");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");


var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");







var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $fa7561b27c4fa5c7$export$148b188041a720e4(slot) {
    return (0, $fx4gX.default)("MuiTimeClock", slot);
}
const $fa7561b27c4fa5c7$export$191dec874db3257b = (0, $auO16.default)("MuiTimeClock", [
    "root",
    "arrowSwitcher"
]);



var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");



var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");
const $a69a2e20c7410a5e$export$8c8ec20d3854d7e6 = 220;
const $a69a2e20c7410a5e$export$729c0e543e4dc21d = 36;
const $a69a2e20c7410a5e$var$clockCenter = {
    x: $a69a2e20c7410a5e$export$8c8ec20d3854d7e6 / 2,
    y: $a69a2e20c7410a5e$export$8c8ec20d3854d7e6 / 2
};
const $a69a2e20c7410a5e$var$baseClockPoint = {
    x: $a69a2e20c7410a5e$var$clockCenter.x,
    y: 0
};
const $a69a2e20c7410a5e$var$cx = $a69a2e20c7410a5e$var$baseClockPoint.x - $a69a2e20c7410a5e$var$clockCenter.x;
const $a69a2e20c7410a5e$var$cy = $a69a2e20c7410a5e$var$baseClockPoint.y - $a69a2e20c7410a5e$var$clockCenter.y;
const $a69a2e20c7410a5e$var$rad2deg = (rad)=>rad * (180 / Math.PI);
const $a69a2e20c7410a5e$var$getAngleValue = (step, offsetX, offsetY)=>{
    const x = offsetX - $a69a2e20c7410a5e$var$clockCenter.x;
    const y = offsetY - $a69a2e20c7410a5e$var$clockCenter.y;
    const atan = Math.atan2($a69a2e20c7410a5e$var$cx, $a69a2e20c7410a5e$var$cy) - Math.atan2(x, y);
    let deg = $a69a2e20c7410a5e$var$rad2deg(atan);
    deg = Math.round(deg / step) * step;
    deg %= 360;
    const value = Math.floor(deg / step) || 0;
    const delta = x ** 2 + y ** 2;
    const distance = Math.sqrt(delta);
    return {
        value: value,
        distance: distance
    };
};
const $a69a2e20c7410a5e$export$b7f1bc3ea3ac4145 = (offsetX, offsetY, step = 1)=>{
    const angleStep = step * 6;
    let { value: value } = $a69a2e20c7410a5e$var$getAngleValue(angleStep, offsetX, offsetY);
    value = value * step % 60;
    return value;
};
const $a69a2e20c7410a5e$export$257b40f71c07d58f = (offsetX, offsetY, ampm)=>{
    const { value: value, distance: distance } = $a69a2e20c7410a5e$var$getAngleValue(30, offsetX, offsetY);
    let hour = value || 12;
    if (!ampm) {
        if (distance < $a69a2e20c7410a5e$export$8c8ec20d3854d7e6 / 2 - $a69a2e20c7410a5e$export$729c0e543e4dc21d) {
            hour += 12;
            hour %= 24;
        }
    } else hour %= 12;
    return hour;
};



var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $0c138b49ddc631d9$export$12faa62796978e2f(slot) {
    return (0, $fx4gX.default)("MuiClockPointer", slot);
}
const $0c138b49ddc631d9$export$64afeec9352615cb = (0, $auO16.default)("MuiClockPointer", [
    "root",
    "thumb"
]);



var $izf4p = parcelRequire("izf4p");
const $9a876a00b3b8bcaa$var$_excluded = [
    "className",
    "hasSelected",
    "isInner",
    "type",
    "viewValue"
];
const $9a876a00b3b8bcaa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        thumb: [
            "thumb"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $0c138b49ddc631d9$export$12faa62796978e2f), classes);
};
const $9a876a00b3b8bcaa$var$ClockPointerRoot = (0, $JdaC3.default)("div", {
    name: "MuiClockPointer",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        width: 2,
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: "absolute",
        left: "calc(50% - 1px)",
        bottom: "50%",
        transformOrigin: "center bottom 0px"
    }, ownerState.shouldAnimate && {
        transition: theme.transitions.create([
            "transform",
            "height"
        ])
    }));
const $9a876a00b3b8bcaa$var$ClockPointerThumb = (0, $JdaC3.default)("div", {
    name: "MuiClockPointer",
    slot: "Thumb",
    overridesResolver: (_, styles)=>styles.thumb
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        width: 4,
        height: 4,
        backgroundColor: (theme.vars || theme).palette.primary.contrastText,
        borderRadius: "50%",
        position: "absolute",
        top: -21,
        left: `calc(50% - ${(0, $a69a2e20c7410a5e$export$729c0e543e4dc21d) / 2}px)`,
        border: `${((0, $a69a2e20c7410a5e$export$729c0e543e4dc21d) - 4) / 2}px solid ${(theme.vars || theme).palette.primary.main}`,
        boxSizing: "content-box"
    }, ownerState.hasSelected && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }));
function $9a876a00b3b8bcaa$export$f257f213e6c08f97(inProps) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiClockPointer"
    });
    const { className: className, isInner: isInner, type: type, viewValue: viewValue } = props, other = (0, $g54n0.default)(props, $9a876a00b3b8bcaa$var$_excluded);
    const previousType = $4YNlq.useRef(type);
    $4YNlq.useEffect(()=>{
        previousType.current = type;
    }, [
        type
    ]);
    const ownerState = (0, $lzDk3.default)({}, props, {
        shouldAnimate: previousType.current !== type
    });
    const classes = $9a876a00b3b8bcaa$var$useUtilityClasses(ownerState);
    const getAngleStyle = ()=>{
        const max = type === "hours" ? 12 : 60;
        let angle = 360 / max * viewValue;
        if (type === "hours" && viewValue > 12) angle -= 360; // round up angle to max 360 degrees
        return {
            height: Math.round((isInner ? 0.26 : 0.4) * (0, $a69a2e20c7410a5e$export$8c8ec20d3854d7e6)),
            transform: `rotateZ(${angle}deg)`
        };
    };
    return /*#__PURE__*/ (0, $izf4p.jsx)($9a876a00b3b8bcaa$var$ClockPointerRoot, (0, $lzDk3.default)({
        style: getAngleStyle(),
        className: (0, $fQQpK.default)(className, classes.root),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)($9a876a00b3b8bcaa$var$ClockPointerThumb, {
            ownerState: ownerState,
            className: classes.thumb
        })
    }));
}





var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $cc46f03f8c11485f$export$e44ecab24167799b(slot) {
    return (0, $fx4gX.default)("MuiClock", slot);
}
const $cc46f03f8c11485f$export$4626e3a61e161c64 = (0, $auO16.default)("MuiClock", [
    "root",
    "clock",
    "wrapper",
    "squareMask",
    "pin",
    "amButton",
    "pmButton",
    "meridiemText"
]);




var $izf4p = parcelRequire("izf4p");
const $8e99e1572866a0e5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        clock: [
            "clock"
        ],
        wrapper: [
            "wrapper"
        ],
        squareMask: [
            "squareMask"
        ],
        pin: [
            "pin"
        ],
        amButton: [
            "amButton"
        ],
        pmButton: [
            "pmButton"
        ],
        meridiemText: [
            "meridiemText"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $cc46f03f8c11485f$export$e44ecab24167799b), classes);
};
const $8e99e1572866a0e5$var$ClockRoot = (0, $JdaC3.default)("div", {
    name: "MuiClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: theme.spacing(2)
    }));
const $8e99e1572866a0e5$var$ClockClock = (0, $JdaC3.default)("div", {
    name: "MuiClock",
    slot: "Clock",
    overridesResolver: (_, styles)=>styles.clock
})({
    backgroundColor: "rgba(0,0,0,.07)",
    borderRadius: "50%",
    height: 220,
    width: 220,
    flexShrink: 0,
    position: "relative",
    pointerEvents: "none"
});
const $8e99e1572866a0e5$var$ClockWrapper = (0, $JdaC3.default)("div", {
    name: "MuiClock",
    slot: "Wrapper",
    overridesResolver: (_, styles)=>styles.wrapper
})({
    "&:focus": {
        outline: "none"
    }
});
const $8e99e1572866a0e5$var$ClockSquareMask = (0, $JdaC3.default)("div", {
    name: "MuiClock",
    slot: "SquareMask",
    overridesResolver: (_, styles)=>styles.squareMask
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        width: "100%",
        height: "100%",
        position: "absolute",
        pointerEvents: "auto",
        outline: 0,
        // Disable scroll capabilities.
        touchAction: "none",
        userSelect: "none"
    }, ownerState.disabled ? {} : {
        "@media (pointer: fine)": {
            cursor: "pointer",
            borderRadius: "50%"
        },
        "&:active": {
            cursor: "move"
        }
    }));
const $8e99e1572866a0e5$var$ClockPin = (0, $JdaC3.default)("div", {
    name: "MuiClock",
    slot: "Pin",
    overridesResolver: (_, styles)=>styles.pin
})(({ theme: theme })=>({
        width: 6,
        height: 6,
        borderRadius: "50%",
        backgroundColor: (theme.vars || theme).palette.primary.main,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)"
    }));
const $8e99e1572866a0e5$var$ClockAmButton = (0, $JdaC3.default)((0, $81fc785263d7b0b1$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "AmButton",
    overridesResolver: (_, styles)=>styles.amButton
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        zIndex: 1,
        position: "absolute",
        bottom: 8,
        left: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $a69a2e20c7410a5e$export$729c0e543e4dc21d)
    }, ownerState.meridiemMode === "am" && {
        backgroundColor: (theme.vars || theme).palette.primary.main,
        color: (theme.vars || theme).palette.primary.contrastText,
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.primary.light
        }
    }));
const $8e99e1572866a0e5$var$ClockPmButton = (0, $JdaC3.default)((0, $81fc785263d7b0b1$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "PmButton",
    overridesResolver: (_, styles)=>styles.pmButton
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        zIndex: 1,
        position: "absolute",
        bottom: 8,
        right: 8,
        paddingLeft: 4,
        paddingRight: 4,
        width: (0, $a69a2e20c7410a5e$export$729c0e543e4dc21d)
    }, ownerState.meridiemMode === "pm" && {
        backgroundColor: (theme.vars || theme).palette.primary.main,
        color: (theme.vars || theme).palette.primary.contrastText,
        "&:hover": {
            backgroundColor: (theme.vars || theme).palette.primary.light
        }
    }));
const $8e99e1572866a0e5$var$ClockMeridiemText = (0, $JdaC3.default)((0, $af664934923ca384$export$2e2bcd8739ae039), {
    name: "MuiClock",
    slot: "meridiemText",
    overridesResolver: (_, styles)=>styles.meridiemText
})({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});
function $8e99e1572866a0e5$export$9735c82c4bae3302(inProps) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiClock"
    });
    const { ampm: ampm, ampmInClock: ampmInClock, autoFocus: autoFocus, children: children, value: value, handleMeridiemChange: handleMeridiemChange, isTimeDisabled: isTimeDisabled, meridiemMode: meridiemMode, minutesStep: minutesStep = 1, onChange: onChange, selectedId: selectedId, type: type, viewValue: viewValue, disabled: disabled, readOnly: readOnly, className: className } = props;
    const ownerState = props;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const isMoving = $4YNlq.useRef(false);
    const classes = $8e99e1572866a0e5$var$useUtilityClasses(ownerState);
    const isSelectedTimeDisabled = isTimeDisabled(viewValue, type);
    const isPointerInner = !ampm && type === "hours" && (viewValue < 1 || viewValue > 12);
    const handleValueChange = (newValue, isFinish)=>{
        if (disabled || readOnly) return;
        if (isTimeDisabled(newValue, type)) return;
        onChange(newValue, isFinish);
    };
    const setTime = (event, isFinish)=>{
        let { offsetX: offsetX, offsetY: offsetY } = event;
        if (offsetX === undefined) {
            const rect = event.target.getBoundingClientRect();
            offsetX = event.changedTouches[0].clientX - rect.left;
            offsetY = event.changedTouches[0].clientY - rect.top;
        }
        const newSelectedValue = type === "seconds" || type === "minutes" ? (0, $a69a2e20c7410a5e$export$b7f1bc3ea3ac4145)(offsetX, offsetY, minutesStep) : (0, $a69a2e20c7410a5e$export$257b40f71c07d58f)(offsetX, offsetY, Boolean(ampm));
        handleValueChange(newSelectedValue, isFinish);
    };
    const handleTouchMove = (event)=>{
        isMoving.current = true;
        setTime(event, "shallow");
    };
    const handleTouchEnd = (event)=>{
        if (isMoving.current) {
            setTime(event, "finish");
            isMoving.current = false;
        }
    };
    const handleMouseMove = (event)=>{
        // event.buttons & PRIMARY_MOUSE_BUTTON
        if (event.buttons > 0) setTime(event.nativeEvent, "shallow");
    };
    const handleMouseUp = (event)=>{
        if (isMoving.current) isMoving.current = false;
        setTime(event.nativeEvent, "finish");
    };
    const hasSelected = $4YNlq.useMemo(()=>{
        if (type === "hours") return true;
        return viewValue % 5 === 0;
    }, [
        type,
        viewValue
    ]);
    const keyboardControlStep = type === "minutes" ? minutesStep : 1;
    const listboxRef = $4YNlq.useRef(null);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $ff5d306a1114a428$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // The ref not being resolved would be a bug in MUI.
        listboxRef.current.focus();
    }, [
        autoFocus
    ]);
    const handleKeyDown = (event)=>{
        // TODO: Why this early exit?
        if (isMoving.current) return;
        switch(event.key){
            case "Home":
                // annulate both hours and minutes
                handleValueChange(0, "partial");
                event.preventDefault();
                break;
            case "End":
                handleValueChange(type === "minutes" ? 59 : 23, "partial");
                event.preventDefault();
                break;
            case "ArrowUp":
                handleValueChange(viewValue + keyboardControlStep, "partial");
                event.preventDefault();
                break;
            case "ArrowDown":
                handleValueChange(viewValue - keyboardControlStep, "partial");
                event.preventDefault();
                break;
            default:
        }
    };
    return /*#__PURE__*/ (0, $izf4p.jsxs)($8e99e1572866a0e5$var$ClockRoot, {
        className: (0, $fQQpK.default)(className, classes.root),
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)($8e99e1572866a0e5$var$ClockClock, {
                className: classes.clock,
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)($8e99e1572866a0e5$var$ClockSquareMask, {
                        onTouchMove: handleTouchMove,
                        onTouchEnd: handleTouchEnd,
                        onMouseUp: handleMouseUp,
                        onMouseMove: handleMouseMove,
                        ownerState: {
                            disabled: disabled
                        },
                        className: classes.squareMask
                    }),
                    !isSelectedTimeDisabled && /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $izf4p.jsx)($8e99e1572866a0e5$var$ClockPin, {
                                className: classes.pin
                            }),
                            value != null && /*#__PURE__*/ (0, $izf4p.jsx)((0, $9a876a00b3b8bcaa$export$f257f213e6c08f97), {
                                type: type,
                                viewValue: viewValue,
                                isInner: isPointerInner,
                                hasSelected: hasSelected
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)($8e99e1572866a0e5$var$ClockWrapper, {
                        "aria-activedescendant": selectedId,
                        "aria-label": localeText.clockLabelText(type, value, utils),
                        ref: listboxRef,
                        role: "listbox",
                        onKeyDown: handleKeyDown,
                        tabIndex: 0,
                        className: classes.wrapper,
                        children: children
                    })
                ]
            }),
            ampm && ampmInClock && /*#__PURE__*/ (0, $izf4p.jsxs)($4YNlq.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)($8e99e1572866a0e5$var$ClockAmButton, {
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("am"),
                        disabled: disabled || meridiemMode === null,
                        ownerState: ownerState,
                        className: classes.amButton,
                        title: (0, $5605199c124089a3$export$fae94c0a662107ef)(utils, "am"),
                        children: /*#__PURE__*/ (0, $izf4p.jsx)($8e99e1572866a0e5$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $5605199c124089a3$export$fae94c0a662107ef)(utils, "am")
                        })
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)($8e99e1572866a0e5$var$ClockPmButton, {
                        disabled: disabled || meridiemMode === null,
                        onClick: readOnly ? undefined : ()=>handleMeridiemChange("pm"),
                        ownerState: ownerState,
                        className: classes.pmButton,
                        title: (0, $5605199c124089a3$export$fae94c0a662107ef)(utils, "pm"),
                        children: /*#__PURE__*/ (0, $izf4p.jsx)($8e99e1572866a0e5$var$ClockMeridiemText, {
                            variant: "caption",
                            className: classes.meridiemText,
                            children: (0, $5605199c124089a3$export$fae94c0a662107ef)(utils, "pm")
                        })
                    })
                ]
            })
        ]
    });
}


parcelRequire("4YNlq");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");
parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");


var $fx4gX = parcelRequire("fx4gX");
var $auO16 = parcelRequire("auO16");
function $06713cf95c115a24$export$527226d166658911(slot) {
    return (0, $fx4gX.default)("MuiClockNumber", slot);
}
const $06713cf95c115a24$export$c8efb3a779c9844a = (0, $auO16.default)("MuiClockNumber", [
    "root",
    "selected",
    "disabled"
]);



var $izf4p = parcelRequire("izf4p");
const $ba7e91bf1a8b225a$var$_excluded = [
    "className",
    "disabled",
    "index",
    "inner",
    "label",
    "selected"
];
const $ba7e91bf1a8b225a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            selected && "selected",
            disabled && "disabled"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $06713cf95c115a24$export$527226d166658911), classes);
};
const $ba7e91bf1a8b225a$var$ClockNumberRoot = (0, $JdaC3.default)("span", {
    name: "MuiClockNumber",
    slot: "Root",
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`&.${(0, $06713cf95c115a24$export$c8efb3a779c9844a).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $06713cf95c115a24$export$c8efb3a779c9844a).selected}`]: styles.selected
            }
        ]
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        height: (0, $a69a2e20c7410a5e$export$729c0e543e4dc21d),
        width: (0, $a69a2e20c7410a5e$export$729c0e543e4dc21d),
        position: "absolute",
        left: `calc((100% - ${(0, $a69a2e20c7410a5e$export$729c0e543e4dc21d)}px) / 2)`,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        color: (theme.vars || theme).palette.text.primary,
        fontFamily: theme.typography.fontFamily,
        "&:focused": {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        [`&.${(0, $06713cf95c115a24$export$c8efb3a779c9844a).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText
        },
        [`&.${(0, $06713cf95c115a24$export$c8efb3a779c9844a).disabled}`]: {
            pointerEvents: "none",
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.inner && (0, $lzDk3.default)({}, theme.typography.body2, {
        color: (theme.vars || theme).palette.text.secondary
    })));
function $ba7e91bf1a8b225a$export$6d5c4c748c9cc92c(inProps) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiClockNumber"
    });
    const { className: className, disabled: disabled, index: index, inner: inner, label: label, selected: selected } = props, other = (0, $g54n0.default)(props, $ba7e91bf1a8b225a$var$_excluded);
    const ownerState = props;
    const classes = $ba7e91bf1a8b225a$var$useUtilityClasses(ownerState);
    const angle = index % 12 / 12 * Math.PI * 2 - Math.PI / 2;
    const length = ((0, $a69a2e20c7410a5e$export$8c8ec20d3854d7e6) - (0, $a69a2e20c7410a5e$export$729c0e543e4dc21d) - 2) / 2 * (inner ? 0.65 : 1);
    const x = Math.round(Math.cos(angle) * length);
    const y = Math.round(Math.sin(angle) * length);
    return /*#__PURE__*/ (0, $izf4p.jsx)($ba7e91bf1a8b225a$var$ClockNumberRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(className, classes.root),
        "aria-disabled": disabled ? true : undefined,
        "aria-selected": selected ? true : undefined,
        role: "option",
        style: {
            transform: `translate(${x}px, ${y + ((0, $a69a2e20c7410a5e$export$8c8ec20d3854d7e6) - (0, $a69a2e20c7410a5e$export$729c0e543e4dc21d)) / 2}px`
        },
        ownerState: ownerState
    }, other, {
        children: label
    }));
}



var $izf4p = parcelRequire("izf4p");
const $19b4e860629e04c7$export$10850582eda9a8c7 = ({ ampm: ampm, value: value, getClockNumberText: getClockNumberText, isDisabled: isDisabled, selectedId: selectedId, utils: utils })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const hourNumbers = [];
    const startHour = ampm ? 1 : 0;
    const endHour = ampm ? 12 : 23;
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    for(let hour = startHour; hour <= endHour; hour += 1){
        let label = hour.toString();
        if (hour === 0) label = "00";
        const inner = !ampm && (hour === 0 || hour > 12);
        label = utils.formatNumber(label);
        const selected = isSelected(hour);
        hourNumbers.push(/*#__PURE__*/ (0, $izf4p.jsx)((0, $ba7e91bf1a8b225a$export$6d5c4c748c9cc92c), {
            id: selected ? selectedId : undefined,
            index: hour,
            inner: inner,
            selected: selected,
            disabled: isDisabled(hour),
            label: label,
            "aria-label": getClockNumberText(label)
        }, hour));
    }
    return hourNumbers;
};
const $19b4e860629e04c7$export$2c440057d7a731e4 = ({ utils: utils, value: value, isDisabled: isDisabled, getClockNumberText: getClockNumberText, selectedId: selectedId })=>{
    const f = utils.formatNumber;
    return [
        [
            5,
            f("05")
        ],
        [
            10,
            f("10")
        ],
        [
            15,
            f("15")
        ],
        [
            20,
            f("20")
        ],
        [
            25,
            f("25")
        ],
        [
            30,
            f("30")
        ],
        [
            35,
            f("35")
        ],
        [
            40,
            f("40")
        ],
        [
            45,
            f("45")
        ],
        [
            50,
            f("50")
        ],
        [
            55,
            f("55")
        ],
        [
            0,
            f("00")
        ]
    ].map(([numberValue, label], index)=>{
        const selected = numberValue === value;
        return /*#__PURE__*/ (0, $izf4p.jsx)((0, $ba7e91bf1a8b225a$export$6d5c4c748c9cc92c), {
            label: label,
            id: selected ? selectedId : undefined,
            index: index + 1,
            inner: false,
            disabled: isDisabled(numberValue),
            selected: selected,
            "aria-label": getClockNumberText(label)
        }, numberValue);
    });
};






var $4YNlq = parcelRequire("4YNlq");



const $c025b50655dcd12d$export$86ee3b7a301faaa3 = ({ value: value, referenceDate: referenceDateProp, utils: utils, props: props, timezone: timezone })=>{
    const referenceDate = $4YNlq.useMemo(()=>(0, $20065d9808d6bf8a$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            utils: utils,
            props: props,
            referenceDate: referenceDateProp,
            granularity: (0, $05c56d59c112b284$export$8f74e8f4ed8ae0ac).day,
            timezone: timezone,
            getTodayDate: ()=>(0, $5605199c124089a3$export$1118e4272ea1e258)(utils, timezone, "date")
        }), // We only want to compute the reference date on mount.
    [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    return value != null ? value : referenceDate;
};



var $izf4p = parcelRequire("izf4p");
const $be732f18ece5b541$var$_excluded = [
    "ampm",
    "ampmInClock",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "showViewSwitcher",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "timezone"
];
const $be732f18ece5b541$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        arrowSwitcher: [
            "arrowSwitcher"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $fa7561b27c4fa5c7$export$148b188041a720e4), classes);
};
const $be732f18ece5b541$var$TimeClockRoot = (0, $JdaC3.default)((0, $d626ddc70bd40290$export$512b066b8abdfde4), {
    name: "MuiTimeClock",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})({
    display: "flex",
    flexDirection: "column",
    position: "relative"
});
const $be732f18ece5b541$var$TimeClockArrowSwitcher = (0, $JdaC3.default)((0, $d5b26e30be53473a$export$597b7cbdb7b2a24c), {
    name: "MuiTimeClock",
    slot: "ArrowSwitcher",
    overridesResolver: (props, styles)=>styles.arrowSwitcher
})({
    position: "absolute",
    right: 12,
    top: 15
});
const $be732f18ece5b541$var$TIME_CLOCK_DEFAULT_VIEWS = [
    "hours",
    "minutes"
];
const $be732f18ece5b541$export$7e96244e18c4be57 = /*#__PURE__*/ $4YNlq.forwardRef(function TimeClock(inProps, ref) {
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiTimeClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), ampmInClock: ampmInClock = false, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: innerSlots, slotProps: innerSlotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, showViewSwitcher: showViewSwitcher, onChange: onChange, view: inView, views: views = $be732f18ece5b541$var$TIME_CLOCK_DEFAULT_VIEWS, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, timezone: timezoneProp } = props, other = (0, $g54n0.default)(props, $be732f18ece5b541$var$_excluded);
    const slots = innerSlots != null ? innerSlots : (0, $42fcfbc058f0ed42$export$ee17bc394843b249)(components);
    const slotProps = innerSlotProps != null ? innerSlotProps : componentsProps;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $00e922e0bf6d2e8e$export$174d749f3b4c0f49)({
        name: "TimeClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba)
    });
    const valueOrReferenceDate = (0, $c025b50655dcd12d$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const now = (0, $9faaabe544d2b9ed$export$3a404aece3dff2fa)(timezone);
    const { view: view, setView: setView, previousView: previousView, nextView: nextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $f1f366fa9605ebb5$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $c47d3ab1cf0a4934$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, setValueAndGoToNextView);
    const isTimeDisabled = $4YNlq.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $3b49d946f7c9f4c7$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === "hours" || viewType === "minutes" && views.includes("seconds");
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(timeValue, viewType)) return false;
            if (shouldDisableTime) switch(viewType){
                case "hours":
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), "hours");
                case "minutes":
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), "minutes");
                case "seconds":
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), "seconds");
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const valueWithMeridiem = (0, $3b49d946f7c9f4c7$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const selectedId = (0, $f7c9c9374bbf09f1$export$2e2bcd8739ae039)();
    const viewProps = $4YNlq.useMemo(()=>{
        switch(view){
            case "hours":
                {
                    const handleHoursChange = (hourValue, isFinish)=>{
                        const valueWithMeridiem = (0, $3b49d946f7c9f4c7$export$4159dc823695870e)(hourValue, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), isFinish);
                    };
                    return {
                        onChange: handleHoursChange,
                        viewValue: utils.getHours(valueOrReferenceDate),
                        children: (0, $19b4e860629e04c7$export$10850582eda9a8c7)({
                            value: value,
                            utils: utils,
                            ampm: ampm,
                            onChange: handleHoursChange,
                            getClockNumberText: localeText.hoursClockNumberText,
                            isDisabled: (hourValue)=>disabled || isTimeDisabled(hourValue, "hours"),
                            selectedId: selectedId
                        })
                    };
                }
            case "minutes":
                {
                    const minutesValue = utils.getMinutes(valueOrReferenceDate);
                    const handleMinutesChange = (minuteValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minuteValue), isFinish);
                    };
                    return {
                        viewValue: minutesValue,
                        onChange: handleMinutesChange,
                        children: (0, $19b4e860629e04c7$export$2c440057d7a731e4)({
                            utils: utils,
                            value: minutesValue,
                            onChange: handleMinutesChange,
                            getClockNumberText: localeText.minutesClockNumberText,
                            isDisabled: (minuteValue)=>disabled || isTimeDisabled(minuteValue, "minutes"),
                            selectedId: selectedId
                        })
                    };
                }
            case "seconds":
                {
                    const secondsValue = utils.getSeconds(valueOrReferenceDate);
                    const handleSecondsChange = (secondValue, isFinish)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, secondValue), isFinish);
                    };
                    return {
                        viewValue: secondsValue,
                        onChange: handleSecondsChange,
                        children: (0, $19b4e860629e04c7$export$2c440057d7a731e4)({
                            utils: utils,
                            value: secondsValue,
                            onChange: handleSecondsChange,
                            getClockNumberText: localeText.secondsClockNumberText,
                            isDisabled: (secondValue)=>disabled || isTimeDisabled(secondValue, "seconds"),
                            selectedId: selectedId
                        })
                    };
                }
            default:
                throw new Error("You must provide the type for ClockView");
        }
    }, [
        view,
        utils,
        value,
        ampm,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        isTimeDisabled,
        selectedId,
        disabled
    ]);
    const ownerState = props;
    const classes = $be732f18ece5b541$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($be732f18ece5b541$var$TimeClockRoot, (0, $lzDk3.default)({
        ref: ref,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $8e99e1572866a0e5$export$9735c82c4bae3302), (0, $lzDk3.default)({
                autoFocus: autoFocus != null ? autoFocus : !!focusedView,
                ampmInClock: ampmInClock && views.includes("hours"),
                value: value,
                type: view,
                ampm: ampm,
                minutesStep: minutesStep,
                isTimeDisabled: isTimeDisabled,
                meridiemMode: meridiemMode,
                handleMeridiemChange: handleMeridiemChange,
                selectedId: selectedId,
                disabled: disabled,
                readOnly: readOnly
            }, viewProps)),
            showViewSwitcher && /*#__PURE__*/ (0, $izf4p.jsx)($be732f18ece5b541$var$TimeClockArrowSwitcher, {
                className: classes.arrowSwitcher,
                slots: slots,
                slotProps: slotProps,
                onGoToPrevious: ()=>setView(previousView),
                isPreviousDisabled: !previousView,
                previousLabel: localeText.openPreviousView,
                onGoToNext: ()=>setView(nextView),
                isNextDisabled: !nextView,
                nextLabel: localeText.openNextView,
                ownerState: ownerState
            })
        ]
    }));
});



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");



var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");


var $9JdRu = parcelRequire("9JdRu");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $309LR = parcelRequire("309LR");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");






var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $fe1f28b87f9ad358$export$81478e24460c57f2(slot) {
    return (0, $fx4gX.default)("MuiListItemIcon", slot);
}
const $fe1f28b87f9ad358$var$listItemIconClasses = (0, $auO16.default)("MuiListItemIcon", [
    "root",
    "alignItemsFlexStart"
]);
var $fe1f28b87f9ad358$export$2e2bcd8739ae039 = $fe1f28b87f9ad358$var$listItemIconClasses;




var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $03fdc7cae99c2239$export$515f8c67b5305377(slot) {
    return (0, $fx4gX.default)("MuiMenuItem", slot);
}
const $03fdc7cae99c2239$var$menuItemClasses = (0, $auO16.default)("MuiMenuItem", [
    "root",
    "focusVisible",
    "dense",
    "disabled",
    "divider",
    "gutters",
    "selected"
]);
var $03fdc7cae99c2239$export$2e2bcd8739ae039 = $03fdc7cae99c2239$var$menuItemClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $2a1a9a6220709535$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $2a1a9a6220709535$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $2a1a9a6220709535$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            disabled && "disabled",
            !disableGutters && "gutters",
            divider && "divider",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $9JdRu.default)(slots, (0, $03fdc7cae99c2239$export$515f8c67b5305377), classes);
    return (0, $lzDk3.default)({}, classes, composedClasses);
};
const $2a1a9a6220709535$var$MenuItemRoot = (0, $JdaC3.default)((0, $7e17388639953587$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $JdaC3.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiMenuItem",
    slot: "Root",
    overridesResolver: $2a1a9a6220709535$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({}, theme.typography.body1, {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: "border-box",
        whiteSpace: "nowrap"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, {
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $03fdc7cae99c2239$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $03fdc7cae99c2239$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $03fdc7cae99c2239$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $03fdc7cae99c2239$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $03fdc7cae99c2239$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $c2eee4d171101174$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $c2eee4d171101174$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $cb707acaa7c08e99$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $cb707acaa7c08e99$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $fe1f28b87f9ad358$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up("sm")]: {
            minHeight: "auto"
        }
    }, ownerState.dense && (0, $lzDk3.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $fe1f28b87f9ad358$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: "1.25rem"
        }
    })));
const $2a1a9a6220709535$var$MenuItem = /*#__PURE__*/ $4YNlq.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiMenuItem"
    });
    const { autoFocus: autoFocus = false, component: component = "li", dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = "menuitem", tabIndex: tabIndexProp, className: className } = props, other = (0, $g54n0.default)(props, $2a1a9a6220709535$var$_excluded);
    const context = $4YNlq.useContext((0, $055e0d2ec1c9fa19$export$2e2bcd8739ae039));
    const childContext = $4YNlq.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $4YNlq.useRef(null);
    (0, $64a26410cabc30a1$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $lzDk3.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $2a1a9a6220709535$var$useUtilityClasses(props);
    const handleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $055e0d2ec1c9fa19$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $izf4p.jsx)($2a1a9a6220709535$var$MenuItemRoot, (0, $lzDk3.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $fQQpK.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $fQQpK.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $2a1a9a6220709535$export$2e2bcd8739ae039 = $2a1a9a6220709535$var$MenuItem;








var $fx4gX = parcelRequire("fx4gX");

var $auO16 = parcelRequire("auO16");
function $1e21e4bcfd9e44c0$export$aeb645018b209578(slot) {
    return (0, $fx4gX.default)("MuiDigitalClock", slot);
}
const $1e21e4bcfd9e44c0$export$baf91642e79c8163 = (0, $auO16.default)("MuiDigitalClock", [
    "root",
    "list",
    "item"
]);








var $izf4p = parcelRequire("izf4p");
const $8fab2a5cb66be4dc$var$_excluded = [
    "ampm",
    "timeStep",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "onChange",
    "view",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "views",
    "skipDisabled",
    "timezone"
];
const $8fab2a5cb66be4dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        list: [
            "list"
        ],
        item: [
            "item"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $1e21e4bcfd9e44c0$export$aeb645018b209578), classes);
};
const $8fab2a5cb66be4dc$var$DigitalClockRoot = (0, $JdaC3.default)((0, $d626ddc70bd40290$export$512b066b8abdfde4), {
    name: "MuiDigitalClock",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ ownerState: ownerState })=>({
        overflowY: "auto",
        width: "100%",
        "@media (prefers-reduced-motion: no-preference)": {
            scrollBehavior: ownerState.alreadyRendered ? "smooth" : "auto"
        },
        maxHeight: (0, $8723b6bc9525bc47$export$1c2eabda4acea0e4)
    }));
const $8fab2a5cb66be4dc$var$DigitalClockList = (0, $JdaC3.default)((0, $f22b323971204dfd$export$2e2bcd8739ae039), {
    name: "MuiDigitalClock",
    slot: "List",
    overridesResolver: (props, styles)=>styles.list
})({
    padding: 0
});
const $8fab2a5cb66be4dc$var$DigitalClockItem = (0, $JdaC3.default)((0, $2a1a9a6220709535$export$2e2bcd8739ae039), {
    name: "MuiDigitalClock",
    slot: "Item",
    overridesResolver: (props, styles)=>styles.item
})(({ theme: theme })=>({
        padding: "8px 16px",
        margin: "2px 4px",
        "&:first-of-type": {
            marginTop: 4
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $c2fa6b3988feb883$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        "&.Mui-selected": {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            "&:focus-visible, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        "&.Mui-focusVisible": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $c2fa6b3988feb883$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $8fab2a5cb66be4dc$export$9a2b219a5b06deb7 = /*#__PURE__*/ $4YNlq.forwardRef(function DigitalClock(inProps, ref) {
    var _ref, _slots$digitalClockIt, _slotProps$digitalClo;
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const containerRef = $4YNlq.useRef(null);
    const handleRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(ref, containerRef);
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiDigitalClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeStep: timeStep = 30, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, openTo: openTo, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, views: views = [
        "hours"
    ], skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $g54n0.default)(props, $8fab2a5cb66be4dc$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $00e922e0bf6d2e8e$export$174d749f3b4c0f49)({
        name: "DigitalClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba)
    });
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const now = (0, $9faaabe544d2b9ed$export$3a404aece3dff2fa)(timezone);
    const ownerState = $4YNlq.useMemo(()=>(0, $lzDk3.default)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $8fab2a5cb66be4dc$var$useUtilityClasses(ownerState);
    const ClockItem = (_ref = (_slots$digitalClockIt = slots == null ? void 0 : slots.digitalClockItem) != null ? _slots$digitalClockIt : components == null ? void 0 : components.DigitalClockItem) != null ? _ref : $8fab2a5cb66be4dc$var$DigitalClockItem;
    const clockItemProps = (0, $cd5c7983105a1366$export$1e5c9e6e4e15efe3)({
        elementType: ClockItem,
        externalSlotProps: (_slotProps$digitalClo = slotProps == null ? void 0 : slotProps.digitalClockItem) != null ? _slotProps$digitalClo : componentsProps == null ? void 0 : componentsProps.digitalClockItem,
        ownerState: {},
        className: classes.item
    });
    const valueOrReferenceDate = (0, $c025b50655dcd12d$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newValue)=>handleRawValueChange(newValue, "finish", "hours"));
    const { setValueAndGoToNextView: setValueAndGoToNextView } = (0, $f1f366fa9605ebb5$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleItemSelect = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newValue)=>{
        setValueAndGoToNextView(newValue, "finish");
    });
    $4YNlq.useEffect(()=>{
        if (containerRef.current === null) return;
        const selectedItem = containerRef.current.querySelector('[role="listbox"] [role="option"][aria-selected="true"]');
        if (!selectedItem) return;
        const offsetTop = selectedItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    const isTimeDisabled = $4YNlq.useCallback((valueToCheck)=>{
        const isAfter = (0, $3b49d946f7c9f4c7$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const containsValidTime = ()=>{
            if (minTime && isAfter(minTime, valueToCheck)) return false;
            if (maxTime && isAfter(valueToCheck, maxTime)) return false;
            if (disableFuture && isAfter(valueToCheck, now)) return false;
            if (disablePast && isAfter(now, valueToCheck)) return false;
            return true;
        };
        const isValidValue = ()=>{
            if (utils.getMinutes(valueToCheck) % minutesStep !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(utils.toJsDate(valueToCheck).getTime(), "hours")) return false;
            if (shouldDisableTime) return !shouldDisableTime(valueToCheck, "hours");
            return true;
        };
        return !containsValidTime() || !isValidValue();
    }, [
        disableIgnoringDatePartForTimeValidation,
        utils,
        minTime,
        maxTime,
        disableFuture,
        now,
        disablePast,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime
    ]);
    const timeOptions = $4YNlq.useMemo(()=>{
        const startOfDay = utils.startOfDay(valueOrReferenceDate);
        return [
            startOfDay,
            ...Array.from({
                length: Math.ceil(1440 / timeStep) - 1
            }, (_, index)=>utils.addMinutes(startOfDay, timeStep * (index + 1)))
        ];
    }, [
        valueOrReferenceDate,
        timeStep,
        utils
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsx)($8fab2a5cb66be4dc$var$DigitalClockRoot, (0, $lzDk3.default)({
        ref: handleRef,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $izf4p.jsx)($8fab2a5cb66be4dc$var$DigitalClockList, {
            autoFocusItem: autoFocus || !!focusedView,
            role: "listbox",
            "aria-label": localeText.timePickerToolbarTitle,
            className: classes.list,
            children: timeOptions.map((option)=>{
                if (skipDisabled && isTimeDisabled(option)) return null;
                const isSelected = utils.isEqual(option, value);
                return /*#__PURE__*/ (0, $izf4p.jsx)(ClockItem, (0, $lzDk3.default)({
                    onClick: ()=>!readOnly && handleItemSelect(option),
                    selected: isSelected,
                    disabled: disabled || isTimeDisabled(option),
                    disableRipple: readOnly,
                    role: "option",
                    "aria-disabled": readOnly,
                    "aria-selected": isSelected
                }, clockItemProps, {
                    children: utils.format(option, ampm ? "fullTime12h" : "fullTime24h")
                }), utils.toISO(option));
            })
        })
    }));
});



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");


var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");


var $9JdRu = parcelRequire("9JdRu");






var $fx4gX = parcelRequire("fx4gX");

var $auO16 = parcelRequire("auO16");
function $e97a7c4dfc009d63$export$b828b7724b7b2890(slot) {
    return (0, $fx4gX.default)("MuiMultiSectionDigitalClock", slot);
}
const $e97a7c4dfc009d63$export$f2277d947b8f7a8a = (0, $auO16.default)("MuiMultiSectionDigitalClock", [
    "root"
]);



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");

var $JdaC3 = parcelRequire("JdaC3");
var $4Q3YJ = parcelRequire("4Q3YJ");

var $9JdRu = parcelRequire("9JdRu");




var $fx4gX = parcelRequire("fx4gX");

var $auO16 = parcelRequire("auO16");
function $a9f3cad2165db714$export$ab23463cad6963ff(slot) {
    return (0, $fx4gX.default)("MuiMultiSectionDigitalClockSection", slot);
}
const $a9f3cad2165db714$export$eaf2b63fa45eff23 = (0, $auO16.default)("MuiMultiSectionDigitalClockSection", [
    "root",
    "item"
]);




var $izf4p = parcelRequire("izf4p");
const $af0e1efcc9572cc3$var$_excluded = [
    "autoFocus",
    "onChange",
    "className",
    "disabled",
    "readOnly",
    "items",
    "active",
    "slots",
    "slotProps",
    "skipDisabled"
];
const $af0e1efcc9572cc3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        item: [
            "item"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $a9f3cad2165db714$export$ab23463cad6963ff), classes);
};
const $af0e1efcc9572cc3$var$MultiSectionDigitalClockSectionRoot = (0, $JdaC3.default)((0, $f22b323971204dfd$export$2e2bcd8739ae039), {
    name: "MuiMultiSectionDigitalClockSection",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>({
        maxHeight: (0, $8723b6bc9525bc47$export$1c2eabda4acea0e4),
        width: 56,
        padding: 0,
        overflow: "hidden",
        "@media (prefers-reduced-motion: no-preference)": {
            scrollBehavior: ownerState.alreadyRendered ? "smooth" : "auto"
        },
        "@media (pointer: fine)": {
            "&:hover": {
                overflowY: "auto"
            }
        },
        "@media (pointer: none), (pointer: coarse)": {
            overflowY: "auto"
        },
        "&:not(:first-of-type)": {
            borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
        },
        "&:after": {
            display: "block",
            content: '""',
            // subtracting the height of one item, extra margin and borders to make sure the max height is correct
            height: "calc(100% - 40px - 6px)"
        }
    }));
const $af0e1efcc9572cc3$var$MultiSectionDigitalClockSectionItem = (0, $JdaC3.default)((0, $2a1a9a6220709535$export$2e2bcd8739ae039), {
    name: "MuiMultiSectionDigitalClockSection",
    slot: "Item",
    overridesResolver: (_, styles)=>styles.item
})(({ theme: theme })=>({
        padding: 8,
        margin: "2px 4px",
        width: (0, $8723b6bc9525bc47$export$a462ceb9cfdb5d71),
        justifyContent: "center",
        "&:first-of-type": {
            marginTop: 4
        },
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $c2fa6b3988feb883$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
        },
        "&.Mui-selected": {
            backgroundColor: (theme.vars || theme).palette.primary.main,
            color: (theme.vars || theme).palette.primary.contrastText,
            "&:focus-visible, &:hover": {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        "&.Mui-focusVisible": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $c2fa6b3988feb883$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity)
        }
    }));
const $af0e1efcc9572cc3$export$f971f93dc8464c = /*#__PURE__*/ $4YNlq.forwardRef(function MultiSectionDigitalClockSection(inProps, ref) {
    var _slots$digitalClockSe;
    const containerRef = $4YNlq.useRef(null);
    const handleRef = (0, $7a0503e87ff161dd$export$2e2bcd8739ae039)(ref, containerRef);
    const previousActive = $4YNlq.useRef(null);
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiMultiSectionDigitalClockSection"
    });
    const { autoFocus: autoFocus, onChange: onChange, className: className, disabled: disabled, readOnly: readOnly, items: items, active: active, slots: slots, slotProps: slotProps, skipDisabled: skipDisabled } = props, other = (0, $g54n0.default)(props, $af0e1efcc9572cc3$var$_excluded);
    const ownerState = $4YNlq.useMemo(()=>(0, $lzDk3.default)({}, props, {
            alreadyRendered: !!containerRef.current
        }), [
        props
    ]);
    const classes = $af0e1efcc9572cc3$var$useUtilityClasses(ownerState);
    const DigitalClockSectionItem = (_slots$digitalClockSe = slots == null ? void 0 : slots.digitalClockSectionItem) != null ? _slots$digitalClockSe : $af0e1efcc9572cc3$var$MultiSectionDigitalClockSectionItem;
    $4YNlq.useEffect(()=>{
        if (containerRef.current === null) return;
        const activeItem = containerRef.current.querySelector('[role="option"][aria-selected="true"]');
        if (active && autoFocus && activeItem) activeItem.focus();
        if (!activeItem || previousActive.current === activeItem) return;
        previousActive.current = activeItem;
        const offsetTop = activeItem.offsetTop;
        // Subtracting the 4px of extra margin intended for the first visible section item
        containerRef.current.scrollTop = offsetTop - 4;
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)($af0e1efcc9572cc3$var$MultiSectionDigitalClockSectionRoot, (0, $lzDk3.default)({
        ref: handleRef,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        autoFocusItem: autoFocus && active,
        role: "listbox"
    }, other, {
        children: items.map((option)=>{
            var _option$isDisabled, _option$isDisabled2;
            if (skipDisabled && (_option$isDisabled = option.isDisabled) != null && _option$isDisabled.call(option, option.value)) return null;
            const isSelected = option.isSelected(option.value);
            return /*#__PURE__*/ (0, $izf4p.jsx)(DigitalClockSectionItem, (0, $lzDk3.default)({
                onClick: ()=>!readOnly && onChange(option.value),
                selected: isSelected,
                disabled: disabled || ((_option$isDisabled2 = option.isDisabled) == null ? void 0 : _option$isDisabled2.call(option, option.value)),
                disableRipple: readOnly,
                role: "option",
                "aria-disabled": readOnly,
                "aria-label": option.ariaLabel,
                "aria-selected": isSelected,
                className: classes.item
            }, slotProps == null ? void 0 : slotProps.digitalClockSectionItem, {
                children: option.label
            }), option.label);
        })
    }));
});


const $4250f1ab1853da55$export$9101aa7ba362bb4e = ({ now: now, value: value, utils: utils, ampm: ampm, isDisabled: isDisabled, resolveAriaLabel: resolveAriaLabel, timeStep: timeStep })=>{
    const currentHours = value ? utils.getHours(value) : null;
    const result = [];
    const isSelected = (hour)=>{
        if (currentHours === null) return false;
        if (ampm) {
            if (hour === 12) return currentHours === 12 || currentHours === 0;
            return currentHours === hour || currentHours - 12 === hour;
        }
        return currentHours === hour;
    };
    const endHour = ampm ? 11 : 23;
    for(let hour = 0; hour <= endHour; hour += timeStep){
        let label = utils.format(utils.setHours(now, hour), ampm ? "hours12h" : "hours24h");
        const ariaLabel = resolveAriaLabel(parseInt(label, 10).toString());
        label = utils.formatNumber(label);
        result.push({
            value: hour,
            label: label,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaLabel: ariaLabel
        });
    }
    return result;
};
const $4250f1ab1853da55$export$e7b56db95f8a7b9c = ({ value: value, utils: utils, isDisabled: isDisabled, timeStep: timeStep, resolveLabel: resolveLabel, resolveAriaLabel: resolveAriaLabel, hasValue: hasValue = true })=>{
    const isSelected = (timeValue)=>{
        if (value === null) return false;
        return hasValue && value === timeValue;
    };
    return [
        ...Array.from({
            length: Math.ceil(60 / timeStep)
        }, (_, index)=>{
            const timeValue = timeStep * index;
            return {
                value: timeValue,
                label: utils.formatNumber(resolveLabel(timeValue)),
                isDisabled: isDisabled,
                isSelected: isSelected,
                ariaLabel: resolveAriaLabel(timeValue.toString())
            };
        })
    ];
};







var $izf4p = parcelRequire("izf4p");
const $359bedb13e4df9b7$var$_excluded = [
    "ampm",
    "timeSteps",
    "autoFocus",
    "components",
    "componentsProps",
    "slots",
    "slotProps",
    "value",
    "defaultValue",
    "referenceDate",
    "disableIgnoringDatePartForTimeValidation",
    "maxTime",
    "minTime",
    "disableFuture",
    "disablePast",
    "minutesStep",
    "shouldDisableClock",
    "shouldDisableTime",
    "onChange",
    "view",
    "views",
    "openTo",
    "onViewChange",
    "focusedView",
    "onFocusedViewChange",
    "className",
    "disabled",
    "readOnly",
    "skipDisabled",
    "timezone"
];
const $359bedb13e4df9b7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $e97a7c4dfc009d63$export$b828b7724b7b2890), classes);
};
const $359bedb13e4df9b7$var$MultiSectionDigitalClockRoot = (0, $JdaC3.default)((0, $d626ddc70bd40290$export$512b066b8abdfde4), {
    name: "MuiMultiSectionDigitalClock",
    slot: "Root",
    overridesResolver: (_, styles)=>styles.root
})(({ theme: theme })=>({
        display: "flex",
        flexDirection: "row",
        width: "100%",
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    }));
const $359bedb13e4df9b7$export$c48dada788ff933b = /*#__PURE__*/ $4YNlq.forwardRef(function MultiSectionDigitalClock(inProps, ref) {
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiMultiSectionDigitalClock"
    });
    const { ampm: ampm = utils.is12HourCycleInCurrentLocale(), timeSteps: inTimeSteps, autoFocus: autoFocus, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation = false, maxTime: maxTime, minTime: minTime, disableFuture: disableFuture, disablePast: disablePast, minutesStep: minutesStep = 1, shouldDisableClock: shouldDisableClock, shouldDisableTime: shouldDisableTime, onChange: onChange, view: inView, views: inViews = [
        "hours",
        "minutes"
    ], openTo: openTo, onViewChange: onViewChange, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, className: className, disabled: disabled, readOnly: readOnly, skipDisabled: skipDisabled = false, timezone: timezoneProp } = props, other = (0, $g54n0.default)(props, $359bedb13e4df9b7$var$_excluded);
    const { value: value, handleValueChange: handleRawValueChange, timezone: timezone } = (0, $00e922e0bf6d2e8e$export$174d749f3b4c0f49)({
        name: "MultiSectionDigitalClock",
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        onChange: onChange,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba)
    });
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const now = (0, $9faaabe544d2b9ed$export$3a404aece3dff2fa)(timezone);
    const timeSteps = $4YNlq.useMemo(()=>(0, $lzDk3.default)({
            hours: 1,
            minutes: 5,
            seconds: 5
        }, inTimeSteps), [
        inTimeSteps
    ]);
    const valueOrReferenceDate = (0, $c025b50655dcd12d$export$86ee3b7a301faaa3)({
        value: value,
        referenceDate: referenceDateProp,
        utils: utils,
        props: props,
        timezone: timezone
    });
    const handleValueChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newValue, selectionState, selectedView)=>handleRawValueChange(newValue, selectionState, selectedView));
    const views = $4YNlq.useMemo(()=>{
        if (!ampm || !inViews.includes("hours")) return inViews;
        return inViews.includes("meridiem") ? inViews : [
            ...inViews,
            "meridiem"
        ];
    }, [
        ampm,
        inViews
    ]);
    const { view: view, setValueAndGoToNextView: setValueAndGoToNextView, focusedView: focusedView } = (0, $f1f366fa9605ebb5$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onViewChange: onViewChange,
        onChange: handleValueChange,
        focusedView: inFocusedView,
        onFocusedViewChange: onFocusedViewChange
    });
    const handleMeridiemValueChange = (0, $2bc6807800e1e224$export$2e2bcd8739ae039)((newValue)=>{
        setValueAndGoToNextView(newValue, "finish", "meridiem");
    });
    const { meridiemMode: meridiemMode, handleMeridiemChange: handleMeridiemChange } = (0, $c47d3ab1cf0a4934$export$6aaabc31cb076d17)(valueOrReferenceDate, ampm, handleMeridiemValueChange, "finish");
    const isTimeDisabled = $4YNlq.useCallback((rawValue, viewType)=>{
        const isAfter = (0, $3b49d946f7c9f4c7$export$fb87c80b35a46b89)(disableIgnoringDatePartForTimeValidation, utils);
        const shouldCheckPastEnd = viewType === "hours" || viewType === "minutes" && views.includes("seconds");
        const containsValidTime = ({ start: start, end: end })=>{
            if (minTime && isAfter(minTime, end)) return false;
            if (maxTime && isAfter(start, maxTime)) return false;
            if (disableFuture && isAfter(start, now)) return false;
            if (disablePast && isAfter(now, shouldCheckPastEnd ? end : start)) return false;
            return true;
        };
        const isValidValue = (timeValue, step = 1)=>{
            if (timeValue % step !== 0) return false;
            if (shouldDisableClock != null && shouldDisableClock(timeValue, viewType)) return false;
            if (shouldDisableTime) switch(viewType){
                case "hours":
                    return !shouldDisableTime(utils.setHours(valueOrReferenceDate, timeValue), "hours");
                case "minutes":
                    return !shouldDisableTime(utils.setMinutes(valueOrReferenceDate, timeValue), "minutes");
                case "seconds":
                    return !shouldDisableTime(utils.setSeconds(valueOrReferenceDate, timeValue), "seconds");
                default:
                    return false;
            }
            return true;
        };
        switch(viewType){
            case "hours":
                {
                    const valueWithMeridiem = (0, $3b49d946f7c9f4c7$export$4159dc823695870e)(rawValue, meridiemMode, ampm);
                    const dateWithNewHours = utils.setHours(valueOrReferenceDate, valueWithMeridiem);
                    const start = utils.setSeconds(utils.setMinutes(dateWithNewHours, 0), 0);
                    const end = utils.setSeconds(utils.setMinutes(dateWithNewHours, 59), 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(valueWithMeridiem);
                }
            case "minutes":
                {
                    const dateWithNewMinutes = utils.setMinutes(valueOrReferenceDate, rawValue);
                    const start = utils.setSeconds(dateWithNewMinutes, 0);
                    const end = utils.setSeconds(dateWithNewMinutes, 59);
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue, minutesStep);
                }
            case "seconds":
                {
                    const dateWithNewSeconds = utils.setSeconds(valueOrReferenceDate, rawValue);
                    const start = dateWithNewSeconds;
                    const end = dateWithNewSeconds;
                    return !containsValidTime({
                        start: start,
                        end: end
                    }) || !isValidValue(rawValue);
                }
            default:
                throw new Error("not supported");
        }
    }, [
        ampm,
        valueOrReferenceDate,
        disableIgnoringDatePartForTimeValidation,
        maxTime,
        meridiemMode,
        minTime,
        minutesStep,
        shouldDisableClock,
        shouldDisableTime,
        utils,
        disableFuture,
        disablePast,
        now,
        views
    ]);
    const buildViewProps = $4YNlq.useCallback((viewToBuild)=>{
        switch(viewToBuild){
            case "hours":
                return {
                    onChange: (hours)=>{
                        const valueWithMeridiem = (0, $3b49d946f7c9f4c7$export$4159dc823695870e)(hours, meridiemMode, ampm);
                        setValueAndGoToNextView(utils.setHours(valueOrReferenceDate, valueWithMeridiem), "finish", "hours");
                    },
                    items: (0, $4250f1ab1853da55$export$9101aa7ba362bb4e)({
                        now: now,
                        value: value,
                        ampm: ampm,
                        utils: utils,
                        isDisabled: (hours)=>disabled || isTimeDisabled(hours, "hours"),
                        timeStep: timeSteps.hours,
                        resolveAriaLabel: localeText.hoursClockNumberText
                    })
                };
            case "minutes":
                return {
                    onChange: (minutes)=>{
                        setValueAndGoToNextView(utils.setMinutes(valueOrReferenceDate, minutes), "finish", "minutes");
                    },
                    items: (0, $4250f1ab1853da55$export$e7b56db95f8a7b9c)({
                        value: utils.getMinutes(valueOrReferenceDate),
                        utils: utils,
                        isDisabled: (minutes)=>disabled || isTimeDisabled(minutes, "minutes"),
                        resolveLabel: (minutes)=>utils.format(utils.setMinutes(now, minutes), "minutes"),
                        timeStep: timeSteps.minutes,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.minutesClockNumberText
                    })
                };
            case "seconds":
                return {
                    onChange: (seconds)=>{
                        setValueAndGoToNextView(utils.setSeconds(valueOrReferenceDate, seconds), "finish", "seconds");
                    },
                    items: (0, $4250f1ab1853da55$export$e7b56db95f8a7b9c)({
                        value: utils.getSeconds(valueOrReferenceDate),
                        utils: utils,
                        isDisabled: (seconds)=>disabled || isTimeDisabled(seconds, "seconds"),
                        resolveLabel: (seconds)=>utils.format(utils.setSeconds(now, seconds), "seconds"),
                        timeStep: timeSteps.seconds,
                        hasValue: !!value,
                        resolveAriaLabel: localeText.secondsClockNumberText
                    })
                };
            case "meridiem":
                {
                    const amLabel = (0, $5605199c124089a3$export$fae94c0a662107ef)(utils, "am");
                    const pmLabel = (0, $5605199c124089a3$export$fae94c0a662107ef)(utils, "pm");
                    return {
                        onChange: handleMeridiemChange,
                        items: [
                            {
                                value: "am",
                                label: amLabel,
                                isSelected: ()=>!!value && meridiemMode === "am",
                                ariaLabel: amLabel
                            },
                            {
                                value: "pm",
                                label: pmLabel,
                                isSelected: ()=>!!value && meridiemMode === "pm",
                                ariaLabel: pmLabel
                            }
                        ]
                    };
                }
            default:
                throw new Error(`Unknown view: ${viewToBuild} found.`);
        }
    }, [
        now,
        value,
        ampm,
        utils,
        timeSteps.hours,
        timeSteps.minutes,
        timeSteps.seconds,
        localeText.hoursClockNumberText,
        localeText.minutesClockNumberText,
        localeText.secondsClockNumberText,
        meridiemMode,
        setValueAndGoToNextView,
        valueOrReferenceDate,
        disabled,
        isTimeDisabled,
        handleMeridiemChange
    ]);
    const viewTimeOptions = $4YNlq.useMemo(()=>{
        return views.reduce((result, currentView)=>{
            return (0, $lzDk3.default)({}, result, {
                [currentView]: buildViewProps(currentView)
            });
        }, {});
    }, [
        views,
        buildViewProps
    ]);
    const ownerState = props;
    const classes = $359bedb13e4df9b7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($359bedb13e4df9b7$var$MultiSectionDigitalClockRoot, (0, $lzDk3.default)({
        ref: ref,
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        role: "group"
    }, other, {
        children: Object.entries(viewTimeOptions).map(([timeView, viewOptions])=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $af0e1efcc9572cc3$export$f971f93dc8464c), {
                items: viewOptions.items,
                onChange: viewOptions.onChange,
                active: view === timeView,
                autoFocus: autoFocus != null ? autoFocus : focusedView === timeView,
                disabled: disabled,
                readOnly: readOnly,
                slots: slots != null ? slots : components,
                slotProps: slotProps != null ? slotProps : componentsProps,
                skipDisabled: skipDisabled,
                "aria-label": localeText.selectViewText(timeView)
            }, timeView))
    }));
});




var $izf4p = parcelRequire("izf4p");
const $16c373b422e5d553$export$a3ad21a1b07c504f = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, ampmInClock: ampmInClock, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, showViewSwitcher: showViewSwitcher, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timezone: timezone })=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $be732f18ece5b541$export$7e96244e18c4be57), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView && (0, $3b49d946f7c9f4c7$export$8f04d380cefd5a0d)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $3b49d946f7c9f4c7$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        ampmInClock: ampmInClock,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        showViewSwitcher: showViewSwitcher,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timezone: timezone
    });
const $16c373b422e5d553$export$a2917c76dc0aa7e = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $8fab2a5cb66be4dc$export$9a2b219a5b06deb7), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $3b49d946f7c9f4c7$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeStep: timeSteps == null ? void 0 : timeSteps.minutes,
        skipDisabled: skipDisabled,
        timezone: timezone
    });
const $16c373b422e5d553$export$48a290886291c531 = ({ view: view, onViewChange: onViewChange, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, views: views, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minTime: minTime, maxTime: maxTime, shouldDisableTime: shouldDisableTime, shouldDisableClock: shouldDisableClock, minutesStep: minutesStep, ampm: ampm, components: components, componentsProps: componentsProps, slots: slots, slotProps: slotProps, readOnly: readOnly, disabled: disabled, sx: sx, autoFocus: autoFocus, disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation, timeSteps: timeSteps, skipDisabled: skipDisabled, timezone: timezone })=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $359bedb13e4df9b7$export$c48dada788ff933b), {
        view: view,
        onViewChange: onViewChange,
        focusedView: focusedView,
        onFocusedViewChange: onFocusedViewChange,
        views: views.filter((0, $3b49d946f7c9f4c7$export$8f04d380cefd5a0d)),
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minTime: minTime,
        maxTime: maxTime,
        shouldDisableTime: shouldDisableTime,
        shouldDisableClock: shouldDisableClock,
        minutesStep: minutesStep,
        ampm: ampm,
        components: components,
        componentsProps: componentsProps,
        slots: slots,
        slotProps: slotProps,
        readOnly: readOnly,
        disabled: disabled,
        sx: sx,
        autoFocus: autoFocus,
        disableIgnoringDatePartForTimeValidation: disableIgnoringDatePartForTimeValidation,
        timeSteps: timeSteps,
        skipDisabled: skipDisabled,
        timezone: timezone
    });




var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");


const $b597371db513c816$var$_excluded = [
    "views",
    "format"
];
const $b597371db513c816$export$ebf7b30b32db6f57 = (utils, _ref)=>{
    let { views: views, format: format } = _ref, other = (0, $g54n0.default)(_ref, $b597371db513c816$var$_excluded);
    if (format) return format;
    const dateViews = [];
    const timeViews = [];
    views.forEach((view)=>{
        if ((0, $3b49d946f7c9f4c7$export$8f04d380cefd5a0d)(view)) timeViews.push(view);
        else dateViews.push(view);
    });
    if (timeViews.length === 0) return (0, $5605199c124089a3$export$bb1c921f313ec928)(utils, (0, $lzDk3.default)({
        views: dateViews
    }, other), false);
    if (dateViews.length === 0) return (0, $3b49d946f7c9f4c7$export$3a6776b3863772fe)(utils, (0, $lzDk3.default)({
        views: timeViews
    }, other));
    const timeFormat = (0, $3b49d946f7c9f4c7$export$3a6776b3863772fe)(utils, (0, $lzDk3.default)({
        views: timeViews
    }, other));
    const dateFormat = (0, $5605199c124089a3$export$bb1c921f313ec928)(utils, (0, $lzDk3.default)({
        views: dateViews
    }, other), false);
    return `${dateFormat} ${timeFormat}`;
};
const $b597371db513c816$var$resolveViews = (ampm, views, shouldUseSingleColumn)=>{
    if (shouldUseSingleColumn) return views.filter((view)=>!(0, $3b49d946f7c9f4c7$export$a3328136ac50623d)(view) || view === "hours");
    return ampm ? [
        ...views,
        "meridiem"
    ] : views;
};
const $b597371db513c816$var$resolveShouldRenderTimeInASingleColumn = (timeSteps, threshold)=>{
    var _timeSteps$hours, _timeSteps$minutes;
    return 1440 / (((_timeSteps$hours = timeSteps.hours) != null ? _timeSteps$hours : 1) * ((_timeSteps$minutes = timeSteps.minutes) != null ? _timeSteps$minutes : 5)) <= threshold;
};
function $b597371db513c816$export$e2d664f2dd4d34bc({ thresholdToRenderTimeInASingleColumn: inThreshold, ampm: ampm, timeSteps: inTimeSteps, views: views }) {
    const thresholdToRenderTimeInASingleColumn = inThreshold != null ? inThreshold : 24;
    const timeSteps = (0, $lzDk3.default)({
        hours: 1,
        minutes: 5,
        seconds: 5
    }, inTimeSteps);
    const shouldRenderTimeInASingleColumn = $b597371db513c816$var$resolveShouldRenderTimeInASingleColumn(timeSteps, thresholdToRenderTimeInASingleColumn);
    return {
        thresholdToRenderTimeInASingleColumn: thresholdToRenderTimeInASingleColumn,
        timeSteps: timeSteps,
        shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn,
        views: $b597371db513c816$var$resolveViews(ampm, views, shouldRenderTimeInASingleColumn)
    };
}


/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopTimePicker API](https://mui.com/x/api/date-pickers/desktop-time-picker/)
 */ const $c72684f9e0c18ec7$export$c2eea9c279c6035b = /*#__PURE__*/ $4YNlq.forwardRef(function DesktopTimePicker(inProps, ref) {
    var _defaultizedProps$amp, _viewRenderers$hours, _defaultizedProps$slo2, _defaultizedProps$slo3, _props$localeText$ope, _props$localeText;
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    // Props with the default values common to all time pickers
    const defaultizedProps = (0, $718d452a39283a49$export$586c31b46cc238ba)(inProps, "MuiDesktopTimePicker");
    const { shouldRenderTimeInASingleColumn: shouldRenderTimeInASingleColumn, views: resolvedViews, timeSteps: timeSteps } = (0, $b597371db513c816$export$e2d664f2dd4d34bc)(defaultizedProps);
    const renderTimeView = shouldRenderTimeInASingleColumn ? (0, $16c373b422e5d553$export$a2917c76dc0aa7e) : (0, $16c373b422e5d553$export$48a290886291c531);
    const viewRenderers = (0, $lzDk3.default)({
        hours: renderTimeView,
        minutes: renderTimeView,
        seconds: renderTimeView,
        meridiem: renderTimeView
    }, defaultizedProps.viewRenderers);
    const ampmInClock = (_defaultizedProps$amp = defaultizedProps.ampmInClock) != null ? _defaultizedProps$amp : true;
    const actionBarActions = shouldRenderTimeInASingleColumn ? [] : [
        "accept"
    ];
    // Need to avoid adding the `meridiem` view when unexpected renderer is specified
    const shouldHoursRendererContainMeridiemView = ((_viewRenderers$hours = viewRenderers.hours) == null ? void 0 : _viewRenderers$hours.name) === (0, $16c373b422e5d553$export$48a290886291c531).name;
    const views = !shouldHoursRendererContainMeridiemView ? resolvedViews.filter((view)=>view !== "meridiem") : resolvedViews;
    // Props with the default values specific to the desktop variant
    const props = (0, $lzDk3.default)({}, defaultizedProps, {
        ampmInClock: ampmInClock,
        timeSteps: timeSteps,
        viewRenderers: viewRenderers,
        format: (0, $3b49d946f7c9f4c7$export$3a6776b3863772fe)(utils, defaultizedProps),
        // Setting only `hours` time view in case of single column time picker
        // Allows for easy view lifecycle management
        views: shouldRenderTimeInASingleColumn ? [
            "hours"
        ] : views,
        slots: (0, $lzDk3.default)({
            field: (0, $61ac5eed73d84851$export$5eaee2322dd727eb),
            openPickerIcon: (0, $bb40f620f6ea1524$export$8099ab97743c966c)
        }, defaultizedProps.slots),
        slotProps: (0, $lzDk3.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $lzDk3.default)({}, (0, $2961338a1e0cb3f1$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $5a2b0beb061d3a97$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $lzDk3.default)({
                hidden: true,
                ampmInClock: ampmInClock
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar),
            actionBar: (0, $lzDk3.default)({
                actions: actionBarActions
            }, (_defaultizedProps$slo3 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo3.actionBar)
        })
    });
    const { renderPicker: renderPicker } = (0, $d093faa8b3894bf6$export$b1b70bc56ac5be0e)({
        props: props,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba),
        valueType: "time",
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openTimePickerDialogue) != null ? _props$localeText$ope : localeText.openTimePickerDialogue,
        validator: (0, $27c831a7a67b3d41$export$7bd013ac69eb590c)
    });
    return renderPicker();
});
$c72684f9e0c18ec7$export$c2eea9c279c6035b.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $9ef1e9faa9036f72$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).node,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "hours",
        "meridiem",
        "minutes",
        "seconds"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
            "all",
            "day",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number.isRequired
        })
    ]),
    /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */ shouldDisableClock: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */ skipDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object
    ]),
    /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */ thresholdToRenderTimeInASingleColumn: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
    /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */ timeSteps: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number
    }),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "hours",
        "meridiem",
        "minutes",
        "seconds"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        meridiem: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]).isRequired)
};



var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $3iM0v = parcelRequire("3iM0v");











/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileTimePicker API](https://mui.com/x/api/date-pickers/mobile-time-picker/)
 */ const $dec70f4d5a517ccb$export$984018df37898b81 = /*#__PURE__*/ $4YNlq.forwardRef(function MobileTimePicker(inProps, ref) {
    var _defaultizedProps$amp, _defaultizedProps$slo2, _props$localeText$ope, _props$localeText;
    const localeText = (0, $9faaabe544d2b9ed$export$24fdeaa0f591a73e)();
    const utils = (0, $9faaabe544d2b9ed$export$1163b47e39508a46)();
    // Props with the default values common to all time pickers
    const defaultizedProps = (0, $718d452a39283a49$export$586c31b46cc238ba)(inProps, "MuiMobileTimePicker");
    const viewRenderers = (0, $lzDk3.default)({
        hours: (0, $16c373b422e5d553$export$a3ad21a1b07c504f),
        minutes: (0, $16c373b422e5d553$export$a3ad21a1b07c504f),
        seconds: (0, $16c373b422e5d553$export$a3ad21a1b07c504f)
    }, defaultizedProps.viewRenderers);
    const ampmInClock = (_defaultizedProps$amp = defaultizedProps.ampmInClock) != null ? _defaultizedProps$amp : false;
    // Props with the default values specific to the mobile variant
    const props = (0, $lzDk3.default)({}, defaultizedProps, {
        ampmInClock: ampmInClock,
        viewRenderers: viewRenderers,
        format: (0, $3b49d946f7c9f4c7$export$3a6776b3863772fe)(utils, defaultizedProps),
        slots: (0, $lzDk3.default)({
            field: (0, $61ac5eed73d84851$export$5eaee2322dd727eb)
        }, defaultizedProps.slots),
        slotProps: (0, $lzDk3.default)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>{
                var _defaultizedProps$slo;
                return (0, $lzDk3.default)({}, (0, $2961338a1e0cb3f1$export$308c24034cde71de)((_defaultizedProps$slo = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo.field, ownerState), (0, $5a2b0beb061d3a97$export$5890f750904acddb)(defaultizedProps), {
                    ref: ref
                });
            },
            toolbar: (0, $lzDk3.default)({
                hidden: false,
                ampmInClock: ampmInClock
            }, (_defaultizedProps$slo2 = defaultizedProps.slotProps) == null ? void 0 : _defaultizedProps$slo2.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $7771c0bf8735da1e$export$5ca0153a626a7dd7)({
        props: props,
        valueManager: (0, $20065d9808d6bf8a$export$2764b246aa3b75ba),
        valueType: "time",
        getOpenDialogAriaText: (_props$localeText$ope = (_props$localeText = props.localeText) == null ? void 0 : _props$localeText.openTimePickerDialogue) != null ? _props$localeText$ope : localeText.openTimePickerDialogue,
        validator: (0, $27c831a7a67b3d41$export$7bd013ac69eb590c)
    });
    return renderPicker();
});
$dec70f4d5a517ccb$export$984018df37898b81.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "yarn proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */ ampm: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */ ampmInClock: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Class name applied to the root element.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */ componentsProps: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */ disableIgnoringDatePartForTimeValidation: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "dense",
        "spacious"
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $9ef1e9faa9036f72$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).node,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ maxTime: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */ minTime: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * Step over minutes.
   * @default 1
   */ minutesStep: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "landscape",
        "portrait"
    ]),
    readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
            "all",
            "day",
            "hours",
            "meridiem",
            "minutes",
            "month",
            "seconds",
            "weekDay",
            "year"
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).shape({
            endIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number.isRequired,
            startIndex: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).number.isRequired
        })
    ]),
    /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */ shouldDisableClock: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */ shouldDisableTime: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).any,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).shape({
        hours: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        minutes: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func,
        seconds: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($3iM0v))).oneOf([
        "hours",
        "minutes",
        "seconds"
    ]).isRequired)
};




var $izf4p = parcelRequire("izf4p");
const $8fe0d93c91abcde6$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [TimePicker](https://mui.com/x/react-date-pickers/time-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [TimePicker API](https://mui.com/x/api/date-pickers/time-picker/)
 */ const $8fe0d93c91abcde6$export$5f876910ea565cd3 = /*#__PURE__*/ $4YNlq.forwardRef(function TimePicker(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiTimePicker"
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $3887927531c6c329$export$9ae5b19305db48ce) } = props, other = (0, $g54n0.default)(props, $8fe0d93c91abcde6$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $9648db6b3d91d1c6$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $izf4p.jsx)((0, $c72684f9e0c18ec7$export$c2eea9c279c6035b), (0, $lzDk3.default)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $dec70f4d5a517ccb$export$984018df37898b81), (0, $lzDk3.default)({
        ref: ref
    }, other));
});




var $4YNlq = parcelRequire("4YNlq");

var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");

var $JdaC3 = parcelRequire("JdaC3");

const $877e0720a3cd72fb$export$728b466dd72ac4f0 = (0, $JdaC3.default)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039))(()=>`
    background: rgb(200, 50, 50);
    text-transform: capitalize;
    height: 56px;
    width: 100%;
    border-radius: 2.5rem;
    &:hover {
        background: #D72542;
}`);
const $877e0720a3cd72fb$export$353f5b6fc5456de1 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $izf4p.jsx)($877e0720a3cd72fb$export$728b466dd72ac4f0, {
        ...rest,
        variant: "contained",
        children: children
    });
};


const $c39164f065ac711d$export$a7fed597f4b8afd8 = ({ ad: ad, onSubmit: onSubmit })=>{
    const [startDateValue, setStartDate] = (0, $4YNlq.useState)(null);
    const [endDateValue, setEndDate] = (0, $4YNlq.useState)(null);
    const [startTimeValue, setStartTime] = (0, $4YNlq.useState)(null);
    const [endTimeValue, setEndTime] = (0, $4YNlq.useState)(null);
    const [comment, changeComment] = (0, $4YNlq.useState)("");
    const [email, setEmail] = (0, $4YNlq.useState)("");
    const [isError, setError] = (0, $4YNlq.useState)(null);
    const onButtonPress = ()=>{
        const isFilledIn = startDateValue && endDateValue && startTimeValue && endTimeValue && email;
        if (!isFilledIn) return setError(true);
        onSubmit({
            startDate: startDateValue?.format("DD MMMM YYYY"),
            endDate: endDateValue?.format("DD MMMM YYYY"),
            startTime: startTimeValue?.format("HH:mm"),
            endTime: endTimeValue?.format("HH:mm"),
            total: endTimeValue.diff(startTimeValue, "hours"),
            comment: comment,
            venue: ad.name,
            url: `https://venuse.xyz/places/${ad.id}`,
            email: email
        });
    };
    return /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "mb-4 text-2xl font-bold",
                children: [
                    "Contact ",
                    ad.name
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "mb-4 text-lg text-secondary",
                children: "Rent period"
            }),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "flex justify-between mb-4",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $9d1850e2214678f4$export$5109c6dd95d8fb00), {
                        disablePast: true,
                        value: startDateValue,
                        // disableOpenPicker
                        slotProps: {},
                        onChange: (e)=>setStartDate(e),
                        sx: {
                            // width: '252px',
                            mr: 2
                        },
                        label: "Check in"
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $8fe0d93c91abcde6$export$5f876910ea565cd3), {
                        timeSteps: {
                            minutes: 60
                        },
                        value: startTimeValue,
                        onChange: (e)=>setStartTime(e),
                        sx: {
                        },
                        ampm: false,
                        label: "From"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "flex justify-between mb-4",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $9d1850e2214678f4$export$5109c6dd95d8fb00), {
                        disablePast: true,
                        value: endDateValue,
                        onChange: (e)=>setEndDate(e),
                        sx: {
                            // width: '252px',
                            mr: 2
                        },
                        label: "Check out"
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $8fe0d93c91abcde6$export$5f876910ea565cd3), {
                        ampm: false,
                        timeSteps: {
                            minutes: 60
                        },
                        value: endTimeValue,
                        onChange: (e)=>setEndTime(e),
                        sx: {
                        },
                        label: "To"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "mb-4 text-lg text-secondary",
                children: "Contact details"
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "mb-4",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $c82f3019ce6db68b$export$2e2bcd8739ae039), {
                    label: "Email",
                    type: "email",
                    placeholder: "sample@mail.com",
                    value: email,
                    onChange: (e)=>setEmail(e.target.value),
                    multiline: true,
                    sx: {
                        width: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "mb-8",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $c82f3019ce6db68b$export$2e2bcd8739ae039), {
                    label: "Comment",
                    value: comment,
                    placeholder: "Your preferences, questions and anything you consider important for this request",
                    onChange: (e)=>changeComment(e.target.value),
                    multiline: true,
                    rows: 2,
                    sx: {
                        width: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                    className: "w-[330px]",
                    children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $877e0720a3cd72fb$export$353f5b6fc5456de1), {
                        onClick: onButtonPress,
                        children: "Message host"
                    })
                })
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "text-orange-800 mt-4 text-center",
                children: isError && "Please fill in the date, interval and your email"
            })
        ]
    });
};


const $00535c25e851049c$export$3877e99530b0c773 = async (params)=>{
    try {
        const response = await fetch(`${"/"}api/booking`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        });
        const body = await response.json();
        console.log(body);
        return {
            status: "success",
            body: body
        };
    } catch (e) {
        console.log(e);
        return {
            status: "error"
        };
    }
};



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");



const $2d0749433b8b59df$export$ffa3d9fee6fd705a = ()=>{
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $68fba4ffcff019c8$export$2e2bcd8739ae039), {
        sx: {
            boxShadow: "none"
        },
        children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $0ba30a51ef560ecb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                    children: "Your message has been sent"
                }),
                /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                    color: "text.secondary",
                    children: "Your host will contact you shortly"
                })
            ]
        })
    });
};



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");



const $e3b59b8ea70d15ca$export$edf27be85e5f6da0 = ()=>{
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $68fba4ffcff019c8$export$2e2bcd8739ae039), {
        sx: {
            boxShadow: "none"
        },
        children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $0ba30a51ef560ecb$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                    color: "text.secondary",
                    children: "Please try sending the request again"
                })
            ]
        })
    });
};


const $b1a43924fe47e851$export$1327ceb49c2c80f0 = ({ isOpen: isOpen, setOpen: setOpen, ad: ad })=>{
    const [isLoading, setLoading] = (0, $4YNlq.useState)(false);
    const [isSuccess, setSuccess] = (0, $4YNlq.useState)(false);
    const [isError, setError] = (0, $4YNlq.useState)(false);
    const onSubmit = async (params)=>{
        setLoading(true);
        const response = await (0, $00535c25e851049c$export$3877e99530b0c773)(params);
        if (response.status === "success") {
            setLoading(false);
            setSuccess(true);
            return;
        }
        if (response.status === "error") {
            setLoading(false);
            setError(true);
        }
    };
    const onClose = ()=>{
        setOpen(false);
        setError(false);
        setLoading(false);
        setSuccess(false);
    };
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $0402d29e5e243355$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $802113259dde0d55$export$2e2bcd8739ae039), {
            in: isOpen,
            children: /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "flex flex-wrap rounded-3xl p-10 bg-white max-w-[550px] absolute top-2/4 left-2/4 translate-x-[-50%] translate-y-[-50%] ",
                children: [
                    !isLoading && !isSuccess && !isError && /*#__PURE__*/ (0, $izf4p.jsx)((0, $c39164f065ac711d$export$a7fed597f4b8afd8), {
                        ad: ad,
                        onSubmit: onSubmit
                    }),
                    isLoading && /*#__PURE__*/ (0, $izf4p.jsx)((0, $ab006c7eeb942377$export$2e2bcd8739ae039), {}),
                    isSuccess && /*#__PURE__*/ (0, $izf4p.jsx)((0, $2d0749433b8b59df$export$ffa3d9fee6fd705a), {}),
                    isError && /*#__PURE__*/ (0, $izf4p.jsx)((0, $e3b59b8ea70d15ca$export$edf27be85e5f6da0), {})
                ]
            })
        })
    });
};



var $JdaC3 = parcelRequire("JdaC3");
const $07a5e02d8487846c$export$9c6cc51b559b1e50 = (0, $JdaC3.default)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039))(()=>`
    background: rgb(200, 50, 50);
    height: 66px;
    width: 100%;
    border-radius: 2.5rem;
    &:hover {
        background: #D72542;
}`);
const $07a5e02d8487846c$export$ac3bdfe4cb17f64e = (props)=>{
    const { price: price, id: id, extraClass: extraClass = "", isFlatBottom: isFlatBottom } = props;
    const navigate = (0, $4fd73b9fb5b80e1f$export$9770f232ac06a008)();
    const [isOpenModel, setModelOpen] = (0, $4YNlq.useState)(false);
    const [isError, setError] = (0, $4YNlq.useState)(false);
    const [dateValue, setDate] = (0, $4YNlq.useState)(null);
    const [startTimeValue, setStartTime] = (0, $4YNlq.useState)(null);
    const [endTimeValue, setEndTime] = (0, $4YNlq.useState)(null);
    const onReserveClick = ()=>{
        const isFilledIn = dateValue && startTimeValue && endTimeValue;
        if (!isFilledIn) return setError(true);
        navigate(`/prebook/${id}`, {
            state: {
                date: dateValue?.format("DD MMMM YYYY"),
                ad: props,
                start: startTimeValue?.format("HH:mm"),
                end: endTimeValue?.format("HH:mm"),
                total: endTimeValue.diff(startTimeValue, "hours")
            }
        });
    };
    return /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
        className: `lg:w-auto w-full z-10 ${extraClass}`,
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $68fba4ffcff019c8$export$2e2bcd8739ae039), {
                className: "sticky top-0 ",
                variant: "outlined",
                sx: {
                    borderRadius: "1.5rem",
                    borderBottomLeftRadius: isFlatBottom ? 0 : "",
                    borderBottomRightRadius: isFlatBottom ? 0 : ""
                },
                children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $0ba30a51ef560ecb$export$2e2bcd8739ae039), {
                    sx: {
                        px: 3
                    },
                    children: [
                        /*#__PURE__*/ (0, $izf4p.jsxs)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                            mb: 3,
                            component: "div",
                            variant: "h5",
                            className: "mx-4 mb-5 ",
                            children: [
                                "\xa3 ",
                                price ? Math.floor(price / 30) : 0,
                                /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                    color: "text.secondary",
                                    component: "span",
                                    children: "/day"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $izf4p.jsx)($07a5e02d8487846c$export$9c6cc51b559b1e50, {
                            sx: {
                                minWidth: "100%",
                                height: "45px",
                                textTransform: "none"
                            },
                            variant: "contained",
                            color: "primary",
                            onClick: ()=>setModelOpen(true),
                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                children: "Message venue"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $b1a43924fe47e851$export$1327ceb49c2c80f0), {
                isOpen: isOpenModel,
                setOpen: setModelOpen,
                ad: props
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");
const $f6e406b36921f3db$export$a06f1c675e846f6f = ()=>{
    return /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
        className: "w-full flex  flex-col items-center bg-[#e3e5eb]  justify-between p-10 border-slate-200 border-t-2",
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "flex gap-5 pb-10 text-[#D91828]",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        children: "Contact us"
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        children: "FAQ"
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        children: "Terms of usage"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "text-gray-600 text-center",
                children: "Venuse Ltd. 2023-2024 Mo street, 1, 512-33-50"
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");
var $b2e1dd78821587b5$exports = {};
"use strict";
var $b2e1dd78821587b5$var$__importDefault = $b2e1dd78821587b5$exports && $b2e1dd78821587b5$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b2e1dd78821587b5$exports, "__esModule", {
    value: true
});

var $b2e1dd78821587b5$var$Carousel_1 = $b2e1dd78821587b5$var$__importDefault((parcelRequire("2T5UA")));
$b2e1dd78821587b5$exports.default = $b2e1dd78821587b5$var$Carousel_1.default;


const $6a898b0186900018$export$73051e5675ca1011 = ({ images: images })=>{
    return images && /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)($6a898b0186900018$var$DesktopCarousel, {
                images: images
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)($6a898b0186900018$export$d1db766a9490651f, {
                images: images
            })
        ]
    });
};
const $6a898b0186900018$var$DesktopCarousel = ({ images: images })=>/*#__PURE__*/ (0, $izf4p.jsxs)("div", {
        className: "lg:flex h-[600px] hidden",
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                style: {
                    backgroundImage: `url(${images[0]})`
                },
                className: "bg-cover bg-center h-full flex-1 border-white border-y-4 border-r-2"
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                style: {
                    backgroundImage: `url(${images[1]})`
                },
                className: "bg-cover bg-center h-full flex-1  border-4 border-white"
            })
        ]
    });
const $6a898b0186900018$export$d1db766a9490651f = ({ images: images = [] })=>{
    return images && /*#__PURE__*/ (0, $izf4p.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b2e1dd78821587b5$exports))), {
        animation: "slide",
        autoPlay: false,
        swipe: true,
        navButtonsAlwaysVisible: true,
        className: "lg:hidden",
        children: images.map((image, i)=>/*#__PURE__*/ (0, $izf4p.jsx)("div", {
                style: {
                    backgroundImage: `url(${image})`,
                    height: "500px"
                },
                className: "flex items-end justify-center pb-10 bg-cover bg-center h-full w-full border-white border-y-4 border-r-2"
            }, i))
    });
};



const $582954009696f0d6$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === "undefined") _fetch = (...args)=>Promise.resolve((parcelRequire("22Tpm"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};


class $2d4065776d49051d$export$738689d52335bb3c extends Error {
    constructor(message, name = "FunctionsError", context){
        super(message);
        this.name = name;
        this.context = context;
    }
}
class $2d4065776d49051d$export$14f2b6540d498ce extends $2d4065776d49051d$export$738689d52335bb3c {
    constructor(context){
        super("Failed to send a request to the Edge Function", "FunctionsFetchError", context);
    }
}
class $2d4065776d49051d$export$d08a45df86040161 extends $2d4065776d49051d$export$738689d52335bb3c {
    constructor(context){
        super("Relay Error invoking the Edge Function", "FunctionsRelayError", context);
    }
}
class $2d4065776d49051d$export$761f8c0e0fa4624f extends $2d4065776d49051d$export$738689d52335bb3c {
    constructor(context){
        super("Edge Function returned a non-2xx status code", "FunctionsHttpError", context);
    }
}


var $e37708465ea40745$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $e37708465ea40745$export$1d0b400bf8a0fa55 {
    /**
     * Updates the authorization header
     * @param token - the new jwt token sent in the authorisation header
     */ setAuth(token) {
        this.headers.Authorization = `Bearer ${token}`;
    }
    /**
     * Invokes a function
     * @param functionName - The name of the Function to invoke.
     * @param options - Options for invoking the Function.
     */ invoke(functionName, options = {}) {
        var _a;
        return $e37708465ea40745$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const { headers: headers, method: method, body: functionArgs } = options;
                let _headers = {};
                let body;
                if (functionArgs && (headers && !Object.prototype.hasOwnProperty.call(headers, "Content-Type") || !headers)) {
                    if (typeof Blob !== "undefined" && functionArgs instanceof Blob || functionArgs instanceof ArrayBuffer) {
                        // will work for File as File inherits Blob
                        // also works for ArrayBuffer as it is the same underlying structure as a Blob
                        _headers["Content-Type"] = "application/octet-stream";
                        body = functionArgs;
                    } else if (typeof functionArgs === "string") {
                        // plain string
                        _headers["Content-Type"] = "text/plain";
                        body = functionArgs;
                    } else if (typeof FormData !== "undefined" && functionArgs instanceof FormData) // don't set content-type headers
                    // Request will automatically add the right boundary value
                    body = functionArgs;
                    else {
                        // default, assume this is JSON
                        _headers["Content-Type"] = "application/json";
                        body = JSON.stringify(functionArgs);
                    }
                }
                const response = yield this.fetch(`${this.url}/${functionName}`, {
                    method: method || "POST",
                    // headers priority is (high to low):
                    // 1. invoke-level headers
                    // 2. client-level headers
                    // 3. default Content-Type header
                    headers: Object.assign(Object.assign(Object.assign({}, _headers), this.headers), headers),
                    body: body
                }).catch((fetchError)=>{
                    throw new (0, $2d4065776d49051d$export$14f2b6540d498ce)(fetchError);
                });
                const isRelayError = response.headers.get("x-relay-error");
                if (isRelayError && isRelayError === "true") throw new (0, $2d4065776d49051d$export$d08a45df86040161)(response);
                if (!response.ok) throw new (0, $2d4065776d49051d$export$761f8c0e0fa4624f)(response);
                let responseType = ((_a = response.headers.get("Content-Type")) !== null && _a !== void 0 ? _a : "text/plain").split(";")[0].trim();
                let data;
                if (responseType === "application/json") data = yield response.json();
                else if (responseType === "application/octet-stream") data = yield response.blob();
                else if (responseType === "multipart/form-data") data = yield response.formData();
                else // default to text
                data = yield response.text();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                return {
                    data: null,
                    error: error
                };
            }
        });
    }
    constructor(url, { headers: headers = {}, customFetch: customFetch } = {}){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $582954009696f0d6$export$98d92b1aa79f8cc7)(customFetch);
    }
}


// @ts-ignore

var $22Tpm = parcelRequire("22Tpm");
class $1ffbc31b6a3a711a$export$2e2bcd8739ae039 extends Error {
    constructor(context){
        super(context.message);
        this.name = "PostgrestError";
        this.details = context.details;
        this.hint = context.hint;
        this.code = context.code;
    }
}


class $3bcee95d40222176$export$2e2bcd8739ae039 {
    /**
     * If there's an error with the query, throwOnError will reject the promise by
     * throwing the error instead of returning it as part of a successful response.
     *
     * {@link https://github.com/supabase/supabase-js/issues/92}
     */ throwOnError() {
        this.shouldThrowOnError = true;
        return this;
    }
    then(onfulfilled, onrejected) {
        // https://postgrest.org/en/stable/api.html#switching-schemas
        if (this.schema === undefined) ;
        else if ([
            "GET",
            "HEAD"
        ].includes(this.method)) this.headers["Accept-Profile"] = this.schema;
        else this.headers["Content-Profile"] = this.schema;
        if (this.method !== "GET" && this.method !== "HEAD") this.headers["Content-Type"] = "application/json";
        // NOTE: Invoke w/o `this` to avoid illegal invocation error.
        // https://github.com/supabase/postgrest-js/pull/247
        const _fetch = this.fetch;
        let res = _fetch(this.url.toString(), {
            method: this.method,
            headers: this.headers,
            body: JSON.stringify(this.body),
            signal: this.signal
        }).then(async (res)=>{
            var _a, _b, _c;
            let error = null;
            let data = null;
            let count = null;
            let status = res.status;
            let statusText = res.statusText;
            if (res.ok) {
                if (this.method !== "HEAD") {
                    const body = await res.text();
                    if (body === "") ;
                    else if (this.headers["Accept"] === "text/csv") data = body;
                    else if (this.headers["Accept"] && this.headers["Accept"].includes("application/vnd.pgrst.plan+text")) data = body;
                    else data = JSON.parse(body);
                }
                const countHeader = (_a = this.headers["Prefer"]) === null || _a === void 0 ? void 0 : _a.match(/count=(exact|planned|estimated)/);
                const contentRange = (_b = res.headers.get("content-range")) === null || _b === void 0 ? void 0 : _b.split("/");
                if (countHeader && contentRange && contentRange.length > 1) count = parseInt(contentRange[1]);
                // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
                // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
                if (this.isMaybeSingle && this.method === "GET" && Array.isArray(data)) {
                    if (data.length > 1) {
                        error = {
                            // https://github.com/PostgREST/postgrest/blob/a867d79c42419af16c18c3fb019eba8df992626f/src/PostgREST/Error.hs#L553
                            code: "PGRST116",
                            details: `Results contain ${data.length} rows, application/vnd.pgrst.object+json requires 1 row`,
                            hint: null,
                            message: "JSON object requested, multiple (or no) rows returned"
                        };
                        data = null;
                        count = null;
                        status = 406;
                        statusText = "Not Acceptable";
                    } else if (data.length === 1) data = data[0];
                    else data = null;
                }
            } else {
                const body = await res.text();
                try {
                    error = JSON.parse(body);
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (Array.isArray(error) && res.status === 404) {
                        data = [];
                        error = null;
                        status = 200;
                        statusText = "OK";
                    }
                } catch (_d) {
                    // Workaround for https://github.com/supabase/postgrest-js/issues/295
                    if (res.status === 404 && body === "") {
                        status = 204;
                        statusText = "No Content";
                    } else error = {
                        message: body
                    };
                }
                if (error && this.isMaybeSingle && ((_c = error === null || error === void 0 ? void 0 : error.details) === null || _c === void 0 ? void 0 : _c.includes("0 rows"))) {
                    error = null;
                    status = 200;
                    statusText = "OK";
                }
                if (error && this.shouldThrowOnError) throw new (0, $1ffbc31b6a3a711a$export$2e2bcd8739ae039)(error);
            }
            const postgrestResponse = {
                error: error,
                data: data,
                count: count,
                status: status,
                statusText: statusText
            };
            return postgrestResponse;
        });
        if (!this.shouldThrowOnError) res = res.catch((fetchError)=>{
            var _a, _b, _c;
            return {
                error: {
                    message: `${(_a = fetchError === null || fetchError === void 0 ? void 0 : fetchError.name) !== null && _a !== void 0 ? _a : "FetchError"}: ${fetchError === null || fetchError === void 0 ? void 0 : fetchError.message}`,
                    details: `${(_b = fetchError === null || fetchError === void 0 ? void 0 : fetchError.stack) !== null && _b !== void 0 ? _b : ""}`,
                    hint: "",
                    code: `${(_c = fetchError === null || fetchError === void 0 ? void 0 : fetchError.code) !== null && _c !== void 0 ? _c : ""}`
                },
                data: null,
                count: null,
                status: 0,
                statusText: ""
            };
        });
        return res.then(onfulfilled, onrejected);
    }
    constructor(builder){
        this.shouldThrowOnError = false;
        this.method = builder.method;
        this.url = builder.url;
        this.headers = builder.headers;
        this.schema = builder.schema;
        this.body = builder.body;
        this.shouldThrowOnError = builder.shouldThrowOnError;
        this.signal = builder.signal;
        this.isMaybeSingle = builder.isMaybeSingle;
        if (builder.fetch) this.fetch = builder.fetch;
        else if (typeof fetch === "undefined") this.fetch = (0, $22Tpm.default);
        else this.fetch = fetch;
    }
}


class $eedf23a5329e268a$export$2e2bcd8739ae039 extends (0, $3bcee95d40222176$export$2e2bcd8739ae039) {
    /**
     * Perform a SELECT on the query result.
     *
     * By default, `.insert()`, `.update()`, `.upsert()`, and `.delete()` do not
     * return modified rows. By calling this method, modified rows are returned in
     * `data`.
     *
     * @param columns - The columns to retrieve, separated by commas
     */ select(columns) {
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === '"') quoted = !quoted;
            return c;
        }).join("");
        this.url.searchParams.set("select", cleanedColumns);
        if (this.headers["Prefer"]) this.headers["Prefer"] += ",";
        this.headers["Prefer"] += "return=representation";
        return this;
    }
    /**
     * Order the query result by `column`.
     *
     * You can call this method multiple times to order by multiple columns.
     *
     * You can order referenced tables, but it only affects the ordering of the
     * parent table if you use `!inner` in the query.
     *
     * @param column - The column to order by
     * @param options - Named parameters
     * @param options.ascending - If `true`, the result will be in ascending order
     * @param options.nullsFirst - If `true`, `null`s appear first. If `false`,
     * `null`s appear last.
     * @param options.referencedTable - Set this to order a referenced table by
     * its columns
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ order(column, { ascending: ascending = true, nullsFirst: nullsFirst, foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.order` : "order";
        const existingOrder = this.url.searchParams.get(key);
        this.url.searchParams.set(key, `${existingOrder ? `${existingOrder},` : ""}${column}.${ascending ? "asc" : "desc"}${nullsFirst === undefined ? "" : nullsFirst ? ".nullsfirst" : ".nullslast"}`);
        return this;
    }
    /**
     * Limit the query result by `count`.
     *
     * @param count - The maximum number of rows to return
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ limit(count, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(key, `${count}`);
        return this;
    }
    /**
     * Limit the query result by starting at an offset (`from`) and ending at the offset (`from + to`).
     * Only records within this range are returned.
     * This respects the query order and if there is no order clause the range could behave unexpectedly.
     * The `from` and `to` values are 0-based and inclusive: `range(1, 3)` will include the second, third
     * and fourth rows of the query.
     *
     * @param from - The starting index from which to limit the result
     * @param to - The last index to which to limit the result
     * @param options - Named parameters
     * @param options.referencedTable - Set this to limit rows of referenced
     * tables instead of the parent table
     * @param options.foreignTable - Deprecated, use `options.referencedTable`
     * instead
     */ range(from, to, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const keyOffset = typeof referencedTable === "undefined" ? "offset" : `${referencedTable}.offset`;
        const keyLimit = typeof referencedTable === "undefined" ? "limit" : `${referencedTable}.limit`;
        this.url.searchParams.set(keyOffset, `${from}`);
        // Range is inclusive, so add 1
        this.url.searchParams.set(keyLimit, `${to - from + 1}`);
        return this;
    }
    /**
     * Set the AbortSignal for the fetch request.
     *
     * @param signal - The AbortSignal to use for the fetch request
     */ abortSignal(signal) {
        this.signal = signal;
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be one row (e.g. using `.limit(1)`), otherwise this
     * returns an error.
     */ single() {
        this.headers["Accept"] = "application/vnd.pgrst.object+json";
        return this;
    }
    /**
     * Return `data` as a single object instead of an array of objects.
     *
     * Query result must be zero or one row (e.g. using `.limit(1)`), otherwise
     * this returns an error.
     */ maybeSingle() {
        // Temporary partial fix for https://github.com/supabase/postgrest-js/issues/361
        // Issue persists e.g. for `.insert([...]).select().maybeSingle()`
        if (this.method === "GET") this.headers["Accept"] = "application/json";
        else this.headers["Accept"] = "application/vnd.pgrst.object+json";
        this.isMaybeSingle = true;
        return this;
    }
    /**
     * Return `data` as a string in CSV format.
     */ csv() {
        this.headers["Accept"] = "text/csv";
        return this;
    }
    /**
     * Return `data` as an object in [GeoJSON](https://geojson.org) format.
     */ geojson() {
        this.headers["Accept"] = "application/geo+json";
        return this;
    }
    /**
     * Return `data` as the EXPLAIN plan for the query.
     *
     * You need to enable the
     * [db_plan_enabled](https://supabase.com/docs/guides/database/debugging-performance#enabling-explain)
     * setting before using this method.
     *
     * @param options - Named parameters
     *
     * @param options.analyze - If `true`, the query will be executed and the
     * actual run time will be returned
     *
     * @param options.verbose - If `true`, the query identifier will be returned
     * and `data` will include the output columns of the query
     *
     * @param options.settings - If `true`, include information on configuration
     * parameters that affect query planning
     *
     * @param options.buffers - If `true`, include information on buffer usage
     *
     * @param options.wal - If `true`, include information on WAL record generation
     *
     * @param options.format - The format of the output, can be `"text"` (default)
     * or `"json"`
     */ explain({ analyze: analyze = false, verbose: verbose = false, settings: settings = false, buffers: buffers = false, wal: wal = false, format: format = "text" } = {}) {
        var _a;
        const options = [
            analyze ? "analyze" : null,
            verbose ? "verbose" : null,
            settings ? "settings" : null,
            buffers ? "buffers" : null,
            wal ? "wal" : null
        ].filter(Boolean).join("|");
        // An Accept header can carry multiple media types but postgrest-js always sends one
        const forMediatype = (_a = this.headers["Accept"]) !== null && _a !== void 0 ? _a : "application/json";
        this.headers["Accept"] = `application/vnd.pgrst.plan+${format}; for="${forMediatype}"; options=${options};`;
        if (format === "json") return this;
        else return this;
    }
    /**
     * Rollback the query.
     *
     * `data` will still be returned, but the query is not committed.
     */ rollback() {
        var _a;
        if (((_a = this.headers["Prefer"]) !== null && _a !== void 0 ? _a : "").trim().length > 0) this.headers["Prefer"] += ",tx=rollback";
        else this.headers["Prefer"] = "tx=rollback";
        return this;
    }
    /**
     * Override the type of the returned `data`.
     *
     * @typeParam NewResult - The new result type to override with
     */ returns() {
        return this;
    }
}


class $f9f63325656a0504$export$2e2bcd8739ae039 extends (0, $eedf23a5329e268a$export$2e2bcd8739ae039) {
    /**
     * Match only rows where `column` is equal to `value`.
     *
     * To check if the value of `column` is NULL, you should use `.is()` instead.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ eq(column, value) {
        this.url.searchParams.append(column, `eq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is not equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ neq(column, value) {
        this.url.searchParams.append(column, `neq.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gt(column, value) {
        this.url.searchParams.append(column, `gt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is greater than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ gte(column, value) {
        this.url.searchParams.append(column, `gte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lt(column, value) {
        this.url.searchParams.append(column, `lt.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is less than or equal to `value`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ lte(column, value) {
        this.url.searchParams.append(column, `lte.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-sensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ like(column, pattern) {
        this.url.searchParams.append(column, `like.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAllOf(column, patterns) {
        this.url.searchParams.append(column, `like(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-sensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ likeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `like(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches `pattern` case-insensitively.
     *
     * @param column - The column to filter on
     * @param pattern - The pattern to match with
     */ ilike(column, pattern) {
        this.url.searchParams.append(column, `ilike.${pattern}`);
        return this;
    }
    /**
     * Match only rows where `column` matches all of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAllOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(all).{${patterns.join(",")}}`);
        return this;
    }
    /**
     * Match only rows where `column` matches any of `patterns` case-insensitively.
     *
     * @param column - The column to filter on
     * @param patterns - The patterns to match with
     */ ilikeAnyOf(column, patterns) {
        this.url.searchParams.append(column, `ilike(any).{${patterns.join(",")}}`);
        return this;
    }
    /**
     * Match only rows where `column` IS `value`.
     *
     * For non-boolean columns, this is only relevant for checking if the value of
     * `column` is NULL by setting `value` to `null`.
     *
     * For boolean columns, you can also set `value` to `true` or `false` and it
     * will behave the same way as `.eq()`.
     *
     * @param column - The column to filter on
     * @param value - The value to filter with
     */ is(column, value) {
        this.url.searchParams.append(column, `is.${value}`);
        return this;
    }
    /**
     * Match only rows where `column` is included in the `values` array.
     *
     * @param column - The column to filter on
     * @param values - The values array to filter with
     */ in(column, values) {
        const cleanedValues = values.map((s)=>{
            // handle postgrest reserved characters
            // https://postgrest.org/en/v7.0.0/api.html#reserved-characters
            if (typeof s === "string" && new RegExp("[,()]").test(s)) return `"${s}"`;
            else return `${s}`;
        }).join(",");
        this.url.searchParams.append(column, `in.(${cleanedValues})`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * `column` contains every element appearing in `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ contains(column, value) {
        if (typeof value === "string") // range types can be inclusive '[', ']' or exclusive '(', ')' so just
        // keep it simple and accept a string
        this.url.searchParams.append(column, `cs.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cs.{${value.join(",")}}`);
        else // json
        this.url.searchParams.append(column, `cs.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for jsonb, array, and range columns. Match only rows where
     * every element appearing in `column` is contained by `value`.
     *
     * @param column - The jsonb, array, or range column to filter on
     * @param value - The jsonb, array, or range value to filter with
     */ containedBy(column, value) {
        if (typeof value === "string") // range
        this.url.searchParams.append(column, `cd.${value}`);
        else if (Array.isArray(value)) // array
        this.url.searchParams.append(column, `cd.{${value.join(",")}}`);
        else // json
        this.url.searchParams.append(column, `cd.${JSON.stringify(value)}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is greater than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGt(column, range) {
        this.url.searchParams.append(column, `sr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or greater than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeGte(column, range) {
        this.url.searchParams.append(column, `nxl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is less than any element in `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLt(column, range) {
        this.url.searchParams.append(column, `sl.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where every element in
     * `column` is either contained in `range` or less than any element in
     * `range`.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeLte(column, range) {
        this.url.searchParams.append(column, `nxr.${range}`);
        return this;
    }
    /**
     * Only relevant for range columns. Match only rows where `column` is
     * mutually exclusive to `range` and there can be no element between the two
     * ranges.
     *
     * @param column - The range column to filter on
     * @param range - The range to filter with
     */ rangeAdjacent(column, range) {
        this.url.searchParams.append(column, `adj.${range}`);
        return this;
    }
    /**
     * Only relevant for array and range columns. Match only rows where
     * `column` and `value` have an element in common.
     *
     * @param column - The array or range column to filter on
     * @param value - The array or range value to filter with
     */ overlaps(column, value) {
        if (typeof value === "string") // range
        this.url.searchParams.append(column, `ov.${value}`);
        else // array
        this.url.searchParams.append(column, `ov.{${value.join(",")}}`);
        return this;
    }
    /**
     * Only relevant for text and tsvector columns. Match only rows where
     * `column` matches the query string in `query`.
     *
     * @param column - The text or tsvector column to filter on
     * @param query - The query text to match with
     * @param options - Named parameters
     * @param options.config - The text search configuration to use
     * @param options.type - Change how the `query` text is interpreted
     */ textSearch(column, query, { config: config, type: type } = {}) {
        let typePart = "";
        if (type === "plain") typePart = "pl";
        else if (type === "phrase") typePart = "ph";
        else if (type === "websearch") typePart = "w";
        const configPart = config === undefined ? "" : `(${config})`;
        this.url.searchParams.append(column, `${typePart}fts${configPart}.${query}`);
        return this;
    }
    /**
     * Match only rows where each column in `query` keys is equal to its
     * associated value. Shorthand for multiple `.eq()`s.
     *
     * @param query - The object to filter with, with column names as keys mapped
     * to their filter values
     */ match(query) {
        Object.entries(query).forEach(([column, value])=>{
            this.url.searchParams.append(column, `eq.${value}`);
        });
        return this;
    }
    /**
     * Match only rows which doesn't satisfy the filter.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to be negated to filter with, following
     * PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ not(column, operator, value) {
        this.url.searchParams.append(column, `not.${operator}.${value}`);
        return this;
    }
    /**
     * Match only rows which satisfy at least one of the filters.
     *
     * Unlike most filters, `filters` is used as-is and needs to follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure it's properly sanitized.
     *
     * It's currently not possible to do an `.or()` filter across multiple tables.
     *
     * @param filters - The filters to use, following PostgREST syntax
     * @param options - Named parameters
     * @param options.referencedTable - Set this to filter on referenced tables
     * instead of the parent table
     * @param options.foreignTable - Deprecated, use `referencedTable` instead
     */ or(filters, { foreignTable: foreignTable, referencedTable: referencedTable = foreignTable } = {}) {
        const key = referencedTable ? `${referencedTable}.or` : "or";
        this.url.searchParams.append(key, `(${filters})`);
        return this;
    }
    /**
     * Match only rows which satisfy the filter. This is an escape hatch - you
     * should use the specific filter methods wherever possible.
     *
     * Unlike most filters, `opearator` and `value` are used as-is and need to
     * follow [PostgREST
     * syntax](https://postgrest.org/en/stable/api.html#operators). You also need
     * to make sure they are properly sanitized.
     *
     * @param column - The column to filter on
     * @param operator - The operator to filter with, following PostgREST syntax
     * @param value - The value to filter with, following PostgREST syntax
     */ filter(column, operator, value) {
        this.url.searchParams.append(column, `${operator}.${value}`);
        return this;
    }
}


class $c3124267b00289f5$export$2e2bcd8739ae039 {
    /**
     * Perform a SELECT query on the table or view.
     *
     * @param columns - The columns to retrieve, separated by commas. Columns can be renamed when returned with `customName:columnName`
     *
     * @param options - Named parameters
     *
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     *
     * @param options.count - Count algorithm to use to count rows in the table or view.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ select(columns, { head: head = false, count: count } = {}) {
        const method = head ? "HEAD" : "GET";
        // Remove whitespaces except when quoted
        let quoted = false;
        const cleanedColumns = (columns !== null && columns !== void 0 ? columns : "*").split("").map((c)=>{
            if (/\s/.test(c) && !quoted) return "";
            if (c === '"') quoted = !quoted;
            return c;
        }).join("");
        this.url.searchParams.set("select", cleanedColumns);
        if (count) this.headers["Prefer"] = `count=${count}`;
        return new (0, $f9f63325656a0504$export$2e2bcd8739ae039)({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an INSERT into the table or view.
     *
     * By default, inserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to insert. Pass an object to insert a single row
     * or an array to insert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count inserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. Only applies for bulk
     * inserts.
     */ insert(values, { count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = "POST";
        const prefersHeaders = [];
        if (this.headers["Prefer"]) prefersHeaders.push(this.headers["Prefer"]);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push("missing=default");
        this.headers["Prefer"] = prefersHeaders.join(",");
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new (0, $f9f63325656a0504$export$2e2bcd8739ae039)({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPSERT on the table or view. Depending on the column(s) passed
     * to `onConflict`, `.upsert()` allows you to perform the equivalent of
     * `.insert()` if a row with the corresponding `onConflict` columns doesn't
     * exist, or if it does exist, perform an alternative action depending on
     * `ignoreDuplicates`.
     *
     * By default, upserted rows are not returned. To return it, chain the call
     * with `.select()`.
     *
     * @param values - The values to upsert with. Pass an object to upsert a
     * single row or an array to upsert multiple rows.
     *
     * @param options - Named parameters
     *
     * @param options.onConflict - Comma-separated UNIQUE column(s) to specify how
     * duplicate rows are determined. Two rows are duplicates if all the
     * `onConflict` columns are equal.
     *
     * @param options.ignoreDuplicates - If `true`, duplicate rows are ignored. If
     * `false`, duplicate rows are merged with existing rows.
     *
     * @param options.count - Count algorithm to use to count upserted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     *
     * @param options.defaultToNull - Make missing fields default to `null`.
     * Otherwise, use the default value for the column. This only applies when
     * inserting new rows, not when merging with existing rows under
     * `ignoreDuplicates: false`. This also only applies when doing bulk upserts.
     */ upsert(values, { onConflict: onConflict, ignoreDuplicates: ignoreDuplicates = false, count: count, defaultToNull: defaultToNull = true } = {}) {
        const method = "POST";
        const prefersHeaders = [
            `resolution=${ignoreDuplicates ? "ignore" : "merge"}-duplicates`
        ];
        if (onConflict !== undefined) this.url.searchParams.set("on_conflict", onConflict);
        if (this.headers["Prefer"]) prefersHeaders.push(this.headers["Prefer"]);
        if (count) prefersHeaders.push(`count=${count}`);
        if (!defaultToNull) prefersHeaders.push("missing=default");
        this.headers["Prefer"] = prefersHeaders.join(",");
        if (Array.isArray(values)) {
            const columns = values.reduce((acc, x)=>acc.concat(Object.keys(x)), []);
            if (columns.length > 0) {
                const uniqueColumns = [
                    ...new Set(columns)
                ].map((column)=>`"${column}"`);
                this.url.searchParams.set("columns", uniqueColumns.join(","));
            }
        }
        return new (0, $f9f63325656a0504$export$2e2bcd8739ae039)({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform an UPDATE on the table or view.
     *
     * By default, updated rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param values - The values to update with
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count updated rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ update(values, { count: count } = {}) {
        const method = "PATCH";
        const prefersHeaders = [];
        if (this.headers["Prefer"]) prefersHeaders.push(this.headers["Prefer"]);
        if (count) prefersHeaders.push(`count=${count}`);
        this.headers["Prefer"] = prefersHeaders.join(",");
        return new (0, $f9f63325656a0504$export$2e2bcd8739ae039)({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            body: values,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    /**
     * Perform a DELETE on the table or view.
     *
     * By default, deleted rows are not returned. To return it, chain the call
     * with `.select()` after filters.
     *
     * @param options - Named parameters
     *
     * @param options.count - Count algorithm to use to count deleted rows.
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ delete({ count: count } = {}) {
        const method = "DELETE";
        const prefersHeaders = [];
        if (count) prefersHeaders.push(`count=${count}`);
        if (this.headers["Prefer"]) prefersHeaders.unshift(this.headers["Prefer"]);
        this.headers["Prefer"] = prefersHeaders.join(",");
        return new (0, $f9f63325656a0504$export$2e2bcd8739ae039)({
            method: method,
            url: this.url,
            headers: this.headers,
            schema: this.schema,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    constructor(url, { headers: headers = {}, schema: schema, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.schema = schema;
        this.fetch = fetch;
    }
}



const $8c3ea039604dc42e$export$83d89fbfd8236492 = "1.9.2";


const $28e21e2ffbe3938a$export$88a84136db6a4b64 = {
    "X-Client-Info": `postgrest-js/${(0, $8c3ea039604dc42e$export$83d89fbfd8236492)}`
};


class $88a1bf785fa9e637$export$2e2bcd8739ae039 {
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        const url = new URL(`${this.url}/${relation}`);
        return new (0, $c3124267b00289f5$export$2e2bcd8739ae039)(url, {
            headers: Object.assign({}, this.headers),
            schema: this.schemaName,
            fetch: this.fetch
        });
    }
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return new $88a1bf785fa9e637$export$2e2bcd8739ae039(this.url, {
            headers: this.headers,
            schema: schema,
            fetch: this.fetch
        });
    }
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, { head: head = false, count: count } = {}) {
        let method;
        const url = new URL(`${this.url}/rpc/${fn}`);
        let body;
        if (head) {
            method = "HEAD";
            Object.entries(args).forEach(([name, value])=>{
                url.searchParams.append(name, `${value}`);
            });
        } else {
            method = "POST";
            body = args;
        }
        const headers = Object.assign({}, this.headers);
        if (count) headers["Prefer"] = `count=${count}`;
        return new (0, $f9f63325656a0504$export$2e2bcd8739ae039)({
            method: method,
            url: url,
            headers: headers,
            schema: this.schemaName,
            body: body,
            fetch: this.fetch,
            allowEmpty: false
        });
    }
    // TODO: Add back shouldThrowOnError once we figure out the typings
    /**
     * Creates a PostgREST client.
     *
     * @param url - URL of the PostgREST endpoint
     * @param options - Named parameters
     * @param options.headers - Custom headers
     * @param options.schema - Postgres schema to switch to
     * @param options.fetch - Custom fetch
     */ constructor(url, { headers: headers = {}, schema: schema, fetch: fetch } = {}){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $28e21e2ffbe3938a$export$88a84136db6a4b64)), headers);
        this.schemaName = schema;
        this.fetch = fetch;
    }
}








const $9b16639c182ae4ea$export$83d89fbfd8236492 = "2.9.3";


const $6c3d97496f0a6ce3$export$88a84136db6a4b64 = {
    "X-Client-Info": `realtime-js/${(0, $9b16639c182ae4ea$export$83d89fbfd8236492)}`
};
const $6c3d97496f0a6ce3$export$df3f558bb9a9c991 = "1.0.0";
const $6c3d97496f0a6ce3$export$7bd623b29ec8e1eb = 10000;
const $6c3d97496f0a6ce3$export$5e80cf62e56a877b = 1000;
var $6c3d97496f0a6ce3$export$a6d0320a1563d49e;
(function(SOCKET_STATES) {
    SOCKET_STATES[SOCKET_STATES["connecting"] = 0] = "connecting";
    SOCKET_STATES[SOCKET_STATES["open"] = 1] = "open";
    SOCKET_STATES[SOCKET_STATES["closing"] = 2] = "closing";
    SOCKET_STATES[SOCKET_STATES["closed"] = 3] = "closed";
})($6c3d97496f0a6ce3$export$a6d0320a1563d49e || ($6c3d97496f0a6ce3$export$a6d0320a1563d49e = {}));
var $6c3d97496f0a6ce3$export$b83816118db74fe7;
(function(CHANNEL_STATES) {
    CHANNEL_STATES["closed"] = "closed";
    CHANNEL_STATES["errored"] = "errored";
    CHANNEL_STATES["joined"] = "joined";
    CHANNEL_STATES["joining"] = "joining";
    CHANNEL_STATES["leaving"] = "leaving";
})($6c3d97496f0a6ce3$export$b83816118db74fe7 || ($6c3d97496f0a6ce3$export$b83816118db74fe7 = {}));
var $6c3d97496f0a6ce3$export$8db7548e65d6ea55;
(function(CHANNEL_EVENTS) {
    CHANNEL_EVENTS["close"] = "phx_close";
    CHANNEL_EVENTS["error"] = "phx_error";
    CHANNEL_EVENTS["join"] = "phx_join";
    CHANNEL_EVENTS["reply"] = "phx_reply";
    CHANNEL_EVENTS["leave"] = "phx_leave";
    CHANNEL_EVENTS["access_token"] = "access_token";
})($6c3d97496f0a6ce3$export$8db7548e65d6ea55 || ($6c3d97496f0a6ce3$export$8db7548e65d6ea55 = {}));
var $6c3d97496f0a6ce3$export$b2688bfb999f5751;
(function(TRANSPORTS) {
    TRANSPORTS["websocket"] = "websocket";
})($6c3d97496f0a6ce3$export$b2688bfb999f5751 || ($6c3d97496f0a6ce3$export$b2688bfb999f5751 = {}));
var $6c3d97496f0a6ce3$export$deda39003d27273;
(function(CONNECTION_STATE) {
    CONNECTION_STATE["Connecting"] = "connecting";
    CONNECTION_STATE["Open"] = "open";
    CONNECTION_STATE["Closing"] = "closing";
    CONNECTION_STATE["Closed"] = "closed";
})($6c3d97496f0a6ce3$export$deda39003d27273 || ($6c3d97496f0a6ce3$export$deda39003d27273 = {}));


/**
 * Creates a timer that accepts a `timerCalc` function to perform calculated timeout retries, such as exponential backoff.
 *
 * @example
 *    let reconnectTimer = new Timer(() => this.connect(), function(tries){
 *      return [1000, 5000, 10000][tries - 1] || 10000
 *    })
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 *    reconnectTimer.scheduleTimeout() // fires after 5000
 *    reconnectTimer.reset()
 *    reconnectTimer.scheduleTimeout() // fires after 1000
 */ class $a1e567373325082e$export$2e2bcd8739ae039 {
    reset() {
        this.tries = 0;
        clearTimeout(this.timer);
    }
    // Cancels any previous scheduleTimeout and schedules callback
    scheduleTimeout() {
        clearTimeout(this.timer);
        this.timer = setTimeout(()=>{
            this.tries = this.tries + 1;
            this.callback();
        }, this.timerCalc(this.tries + 1));
    }
    constructor(callback, timerCalc){
        this.callback = callback;
        this.timerCalc = timerCalc;
        this.timer = undefined;
        this.tries = 0;
        this.callback = callback;
        this.timerCalc = timerCalc;
    }
}


// This file draws heavily from https://github.com/phoenixframework/phoenix/commit/cf098e9cf7a44ee6479d31d911a97d3c7430c6fe
// License: https://github.com/phoenixframework/phoenix/blob/master/LICENSE.md
class $b819558905f4bfb4$export$2e2bcd8739ae039 {
    decode(rawPayload, callback) {
        if (rawPayload.constructor === ArrayBuffer) return callback(this._binaryDecode(rawPayload));
        if (typeof rawPayload === "string") return callback(JSON.parse(rawPayload));
        return callback({});
    }
    _binaryDecode(buffer) {
        const view = new DataView(buffer);
        const decoder = new TextDecoder();
        return this._decodeBroadcast(buffer, view, decoder);
    }
    _decodeBroadcast(buffer, view, decoder) {
        const topicSize = view.getUint8(1);
        const eventSize = view.getUint8(2);
        let offset = this.HEADER_LENGTH + 2;
        const topic = decoder.decode(buffer.slice(offset, offset + topicSize));
        offset = offset + topicSize;
        const event = decoder.decode(buffer.slice(offset, offset + eventSize));
        offset = offset + eventSize;
        const data = JSON.parse(decoder.decode(buffer.slice(offset, buffer.byteLength)));
        return {
            ref: null,
            topic: topic,
            event: event,
            payload: data
        };
    }
    constructor(){
        this.HEADER_LENGTH = 1;
    }
}




class $b0bbbfc32a2fda3f$export$2e2bcd8739ae039 {
    resend(timeout) {
        this.timeout = timeout;
        this._cancelRefEvent();
        this.ref = "";
        this.refEvent = null;
        this.receivedResp = null;
        this.sent = false;
        this.send();
    }
    send() {
        if (this._hasReceived("timeout")) return;
        this.startTimeout();
        this.sent = true;
        this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload,
            ref: this.ref,
            join_ref: this.channel._joinRef()
        });
    }
    updatePayload(payload) {
        this.payload = Object.assign(Object.assign({}, this.payload), payload);
    }
    receive(status, callback) {
        var _a;
        if (this._hasReceived(status)) callback((_a = this.receivedResp) === null || _a === void 0 ? void 0 : _a.response);
        this.recHooks.push({
            status: status,
            callback: callback
        });
        return this;
    }
    startTimeout() {
        if (this.timeoutTimer) return;
        this.ref = this.channel.socket._makeRef();
        this.refEvent = this.channel._replyEventName(this.ref);
        const callback = (payload)=>{
            this._cancelRefEvent();
            this._cancelTimeout();
            this.receivedResp = payload;
            this._matchReceive(payload);
        };
        this.channel._on(this.refEvent, {}, callback);
        this.timeoutTimer = setTimeout(()=>{
            this.trigger("timeout", {});
        }, this.timeout);
    }
    trigger(status, response) {
        if (this.refEvent) this.channel._trigger(this.refEvent, {
            status: status,
            response: response
        });
    }
    destroy() {
        this._cancelRefEvent();
        this._cancelTimeout();
    }
    _cancelRefEvent() {
        if (!this.refEvent) return;
        this.channel._off(this.refEvent, {});
    }
    _cancelTimeout() {
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = undefined;
    }
    _matchReceive({ status: status, response: response }) {
        this.recHooks.filter((h)=>h.status === status).forEach((h)=>h.callback(response));
    }
    _hasReceived(status) {
        return this.receivedResp && this.receivedResp.status === status;
    }
    /**
     * Initializes the Push
     *
     * @param channel The Channel
     * @param event The event, for example `"phx_join"`
     * @param payload The payload, for example `{user_id: 123}`
     * @param timeout The push timeout in milliseconds
     */ constructor(channel, event, payload = {}, timeout = (0, $6c3d97496f0a6ce3$export$7bd623b29ec8e1eb)){
        this.channel = channel;
        this.event = event;
        this.payload = payload;
        this.timeout = timeout;
        this.sent = false;
        this.timeoutTimer = undefined;
        this.ref = "";
        this.receivedResp = null;
        this.recHooks = [];
        this.refEvent = null;
    }
}



/*
  This file draws heavily from https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/assets/js/phoenix/presence.js
  License: https://github.com/phoenixframework/phoenix/blob/d344ec0a732ab4ee204215b31de69cf4be72e3bf/LICENSE.md
*/ var $deecd9ea7b989c66$export$f1ce049df2794fb4;
(function(REALTIME_PRESENCE_LISTEN_EVENTS) {
    REALTIME_PRESENCE_LISTEN_EVENTS["SYNC"] = "sync";
    REALTIME_PRESENCE_LISTEN_EVENTS["JOIN"] = "join";
    REALTIME_PRESENCE_LISTEN_EVENTS["LEAVE"] = "leave";
})($deecd9ea7b989c66$export$f1ce049df2794fb4 || ($deecd9ea7b989c66$export$f1ce049df2794fb4 = {}));
class $deecd9ea7b989c66$export$2e2bcd8739ae039 {
    /**
     * Used to sync the list of presences on the server with the
     * client's state.
     *
     * An optional `onJoin` and `onLeave` callback can be provided to
     * react to changes in the client's local presences across
     * disconnects and reconnects with the server.
     *
     * @internal
     */ static syncState(currentState, newState, onJoin, onLeave) {
        const state = this.cloneDeep(currentState);
        const transformedState = this.transformState(newState);
        const joins = {};
        const leaves = {};
        this.map(state, (key, presences)=>{
            if (!transformedState[key]) leaves[key] = presences;
        });
        this.map(transformedState, (key, newPresences)=>{
            const currentPresences = state[key];
            if (currentPresences) {
                const newPresenceRefs = newPresences.map((m)=>m.presence_ref);
                const curPresenceRefs = currentPresences.map((m)=>m.presence_ref);
                const joinedPresences = newPresences.filter((m)=>curPresenceRefs.indexOf(m.presence_ref) < 0);
                const leftPresences = currentPresences.filter((m)=>newPresenceRefs.indexOf(m.presence_ref) < 0);
                if (joinedPresences.length > 0) joins[key] = joinedPresences;
                if (leftPresences.length > 0) leaves[key] = leftPresences;
            } else joins[key] = newPresences;
        });
        return this.syncDiff(state, {
            joins: joins,
            leaves: leaves
        }, onJoin, onLeave);
    }
    /**
     * Used to sync a diff of presence join and leave events from the
     * server, as they happen.
     *
     * Like `syncState`, `syncDiff` accepts optional `onJoin` and
     * `onLeave` callbacks to react to a user joining or leaving from a
     * device.
     *
     * @internal
     */ static syncDiff(state, diff, onJoin, onLeave) {
        const { joins: joins, leaves: leaves } = {
            joins: this.transformState(diff.joins),
            leaves: this.transformState(diff.leaves)
        };
        if (!onJoin) onJoin = ()=>{};
        if (!onLeave) onLeave = ()=>{};
        this.map(joins, (key, newPresences)=>{
            var _a;
            const currentPresences = (_a = state[key]) !== null && _a !== void 0 ? _a : [];
            state[key] = this.cloneDeep(newPresences);
            if (currentPresences.length > 0) {
                const joinedPresenceRefs = state[key].map((m)=>m.presence_ref);
                const curPresences = currentPresences.filter((m)=>joinedPresenceRefs.indexOf(m.presence_ref) < 0);
                state[key].unshift(...curPresences);
            }
            onJoin(key, currentPresences, newPresences);
        });
        this.map(leaves, (key, leftPresences)=>{
            let currentPresences = state[key];
            if (!currentPresences) return;
            const presenceRefsToRemove = leftPresences.map((m)=>m.presence_ref);
            currentPresences = currentPresences.filter((m)=>presenceRefsToRemove.indexOf(m.presence_ref) < 0);
            state[key] = currentPresences;
            onLeave(key, currentPresences, leftPresences);
            if (currentPresences.length === 0) delete state[key];
        });
        return state;
    }
    /** @internal */ static map(obj, func) {
        return Object.getOwnPropertyNames(obj).map((key)=>func(key, obj[key]));
    }
    /**
     * Remove 'metas' key
     * Change 'phx_ref' to 'presence_ref'
     * Remove 'phx_ref' and 'phx_ref_prev'
     *
     * @example
     * // returns {
     *  abc123: [
     *    { presence_ref: '2', user_id: 1 },
     *    { presence_ref: '3', user_id: 2 }
     *  ]
     * }
     * RealtimePresence.transformState({
     *  abc123: {
     *    metas: [
     *      { phx_ref: '2', phx_ref_prev: '1' user_id: 1 },
     *      { phx_ref: '3', user_id: 2 }
     *    ]
     *  }
     * })
     *
     * @internal
     */ static transformState(state) {
        state = this.cloneDeep(state);
        return Object.getOwnPropertyNames(state).reduce((newState, key)=>{
            const presences = state[key];
            if ("metas" in presences) newState[key] = presences.metas.map((presence)=>{
                presence["presence_ref"] = presence["phx_ref"];
                delete presence["phx_ref"];
                delete presence["phx_ref_prev"];
                return presence;
            });
            else newState[key] = presences;
            return newState;
        }, {});
    }
    /** @internal */ static cloneDeep(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /** @internal */ onJoin(callback) {
        this.caller.onJoin = callback;
    }
    /** @internal */ onLeave(callback) {
        this.caller.onLeave = callback;
    }
    /** @internal */ onSync(callback) {
        this.caller.onSync = callback;
    }
    /** @internal */ inPendingSyncState() {
        return !this.joinRef || this.joinRef !== this.channel._joinRef();
    }
    /**
     * Initializes the Presence.
     *
     * @param channel - The RealtimeChannel
     * @param opts - The options,
     *        for example `{events: {state: 'state', diff: 'diff'}}`
     */ constructor(channel, opts){
        this.channel = channel;
        this.state = {};
        this.pendingDiffs = [];
        this.joinRef = null;
        this.caller = {
            onJoin: ()=>{},
            onLeave: ()=>{},
            onSync: ()=>{}
        };
        const events = (opts === null || opts === void 0 ? void 0 : opts.events) || {
            state: "presence_state",
            diff: "presence_diff"
        };
        this.channel._on(events.state, {}, (newState)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            this.joinRef = this.channel._joinRef();
            this.state = $deecd9ea7b989c66$export$2e2bcd8739ae039.syncState(this.state, newState, onJoin, onLeave);
            this.pendingDiffs.forEach((diff)=>{
                this.state = $deecd9ea7b989c66$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
            });
            this.pendingDiffs = [];
            onSync();
        });
        this.channel._on(events.diff, {}, (diff)=>{
            const { onJoin: onJoin, onLeave: onLeave, onSync: onSync } = this.caller;
            if (this.inPendingSyncState()) this.pendingDiffs.push(diff);
            else {
                this.state = $deecd9ea7b989c66$export$2e2bcd8739ae039.syncDiff(this.state, diff, onJoin, onLeave);
                onSync();
            }
        });
        this.onJoin((key, currentPresences, newPresences)=>{
            this.channel._trigger("presence", {
                event: "join",
                key: key,
                currentPresences: currentPresences,
                newPresences: newPresences
            });
        });
        this.onLeave((key, currentPresences, leftPresences)=>{
            this.channel._trigger("presence", {
                event: "leave",
                key: key,
                currentPresences: currentPresences,
                leftPresences: leftPresences
            });
        });
        this.onSync(()=>{
            this.channel._trigger("presence", {
                event: "sync"
            });
        });
    }
}


/**
 * Helpers to convert the change Payload into native JS types.
 */ // Adapted from epgsql (src/epgsql_binary.erl), this module licensed under
// 3-clause BSD found here: https://raw.githubusercontent.com/epgsql/epgsql/devel/LICENSE
var $7021628b0f03edf5$export$4d213a7d364021dc;
(function(PostgresTypes) {
    PostgresTypes["abstime"] = "abstime";
    PostgresTypes["bool"] = "bool";
    PostgresTypes["date"] = "date";
    PostgresTypes["daterange"] = "daterange";
    PostgresTypes["float4"] = "float4";
    PostgresTypes["float8"] = "float8";
    PostgresTypes["int2"] = "int2";
    PostgresTypes["int4"] = "int4";
    PostgresTypes["int4range"] = "int4range";
    PostgresTypes["int8"] = "int8";
    PostgresTypes["int8range"] = "int8range";
    PostgresTypes["json"] = "json";
    PostgresTypes["jsonb"] = "jsonb";
    PostgresTypes["money"] = "money";
    PostgresTypes["numeric"] = "numeric";
    PostgresTypes["oid"] = "oid";
    PostgresTypes["reltime"] = "reltime";
    PostgresTypes["text"] = "text";
    PostgresTypes["time"] = "time";
    PostgresTypes["timestamp"] = "timestamp";
    PostgresTypes["timestamptz"] = "timestamptz";
    PostgresTypes["timetz"] = "timetz";
    PostgresTypes["tsrange"] = "tsrange";
    PostgresTypes["tstzrange"] = "tstzrange";
})($7021628b0f03edf5$export$4d213a7d364021dc || ($7021628b0f03edf5$export$4d213a7d364021dc = {}));
const $7021628b0f03edf5$export$20ce708a1f594c5e = (columns, record, options = {})=>{
    var _a;
    const skipTypes = (_a = options.skipTypes) !== null && _a !== void 0 ? _a : [];
    return Object.keys(record).reduce((acc, rec_key)=>{
        acc[rec_key] = $7021628b0f03edf5$export$c054edfec1afa88d(rec_key, columns, record, skipTypes);
        return acc;
    }, {});
};
const $7021628b0f03edf5$export$c054edfec1afa88d = (columnName, columns, record, skipTypes)=>{
    const column = columns.find((x)=>x.name === columnName);
    const colType = column === null || column === void 0 ? void 0 : column.type;
    const value = record[columnName];
    if (colType && !skipTypes.includes(colType)) return $7021628b0f03edf5$export$3df02a362b86a91(colType, value);
    return $7021628b0f03edf5$var$noop(value);
};
const $7021628b0f03edf5$export$3df02a362b86a91 = (type, value)=>{
    // if data type is an array
    if (type.charAt(0) === "_") {
        const dataType = type.slice(1, type.length);
        return $7021628b0f03edf5$export$45b10814cc054894(value, dataType);
    }
    // If not null, convert to correct type.
    switch(type){
        case $7021628b0f03edf5$export$4d213a7d364021dc.bool:
            return $7021628b0f03edf5$export$3c2e6d1b7583eee6(value);
        case $7021628b0f03edf5$export$4d213a7d364021dc.float4:
        case $7021628b0f03edf5$export$4d213a7d364021dc.float8:
        case $7021628b0f03edf5$export$4d213a7d364021dc.int2:
        case $7021628b0f03edf5$export$4d213a7d364021dc.int4:
        case $7021628b0f03edf5$export$4d213a7d364021dc.int8:
        case $7021628b0f03edf5$export$4d213a7d364021dc.numeric:
        case $7021628b0f03edf5$export$4d213a7d364021dc.oid:
            return $7021628b0f03edf5$export$a0a81dc3380ce7d3(value);
        case $7021628b0f03edf5$export$4d213a7d364021dc.json:
        case $7021628b0f03edf5$export$4d213a7d364021dc.jsonb:
            return $7021628b0f03edf5$export$d5b7a8bf56ee1fe2(value);
        case $7021628b0f03edf5$export$4d213a7d364021dc.timestamp:
            return $7021628b0f03edf5$export$eccf8c5d91d19e3a(value); // Format to be consistent with PostgREST
        case $7021628b0f03edf5$export$4d213a7d364021dc.abstime:
        case $7021628b0f03edf5$export$4d213a7d364021dc.date:
        case $7021628b0f03edf5$export$4d213a7d364021dc.daterange:
        case $7021628b0f03edf5$export$4d213a7d364021dc.int4range:
        case $7021628b0f03edf5$export$4d213a7d364021dc.int8range:
        case $7021628b0f03edf5$export$4d213a7d364021dc.money:
        case $7021628b0f03edf5$export$4d213a7d364021dc.reltime:
        case $7021628b0f03edf5$export$4d213a7d364021dc.text:
        case $7021628b0f03edf5$export$4d213a7d364021dc.time:
        case $7021628b0f03edf5$export$4d213a7d364021dc.timestamptz:
        case $7021628b0f03edf5$export$4d213a7d364021dc.timetz:
        case $7021628b0f03edf5$export$4d213a7d364021dc.tsrange:
        case $7021628b0f03edf5$export$4d213a7d364021dc.tstzrange:
            return $7021628b0f03edf5$var$noop(value);
        default:
            // Return the value for remaining types
            return $7021628b0f03edf5$var$noop(value);
    }
};
const $7021628b0f03edf5$var$noop = (value)=>{
    return value;
};
const $7021628b0f03edf5$export$3c2e6d1b7583eee6 = (value)=>{
    switch(value){
        case "t":
            return true;
        case "f":
            return false;
        default:
            return value;
    }
};
const $7021628b0f03edf5$export$a0a81dc3380ce7d3 = (value)=>{
    if (typeof value === "string") {
        const parsedValue = parseFloat(value);
        if (!Number.isNaN(parsedValue)) return parsedValue;
    }
    return value;
};
const $7021628b0f03edf5$export$d5b7a8bf56ee1fe2 = (value)=>{
    if (typeof value === "string") try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON parse error: ${error}`);
        return value;
    }
    return value;
};
const $7021628b0f03edf5$export$45b10814cc054894 = (value, type)=>{
    if (typeof value !== "string") return value;
    const lastIdx = value.length - 1;
    const closeBrace = value[lastIdx];
    const openBrace = value[0];
    // Confirm value is a Postgres array by checking curly brackets
    if (openBrace === "{" && closeBrace === "}") {
        let arr;
        const valTrim = value.slice(1, lastIdx);
        // TODO: find a better solution to separate Postgres array data
        try {
            arr = JSON.parse("[" + valTrim + "]");
        } catch (_) {
            // WARNING: splitting on comma does not cover all edge cases
            arr = valTrim ? valTrim.split(",") : [];
        }
        return arr.map((val)=>$7021628b0f03edf5$export$3df02a362b86a91(type, val));
    }
    return value;
};
const $7021628b0f03edf5$export$eccf8c5d91d19e3a = (value)=>{
    if (typeof value === "string") return value.replace(" ", "T");
    return value;
};


var $4207c69ca85d6d3a$export$bc171c571098b6c4;
(function(REALTIME_POSTGRES_CHANGES_LISTEN_EVENT) {
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["ALL"] = "*";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["INSERT"] = "INSERT";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["UPDATE"] = "UPDATE";
    REALTIME_POSTGRES_CHANGES_LISTEN_EVENT["DELETE"] = "DELETE";
})($4207c69ca85d6d3a$export$bc171c571098b6c4 || ($4207c69ca85d6d3a$export$bc171c571098b6c4 = {}));
var $4207c69ca85d6d3a$export$9e3fe8e487ef792e;
(function(REALTIME_LISTEN_TYPES) {
    REALTIME_LISTEN_TYPES["BROADCAST"] = "broadcast";
    REALTIME_LISTEN_TYPES["PRESENCE"] = "presence";
    /**
     * listen to Postgres changes.
     */ REALTIME_LISTEN_TYPES["POSTGRES_CHANGES"] = "postgres_changes";
})($4207c69ca85d6d3a$export$9e3fe8e487ef792e || ($4207c69ca85d6d3a$export$9e3fe8e487ef792e = {}));
var $4207c69ca85d6d3a$export$a6885b926af646a2;
(function(REALTIME_SUBSCRIBE_STATES) {
    REALTIME_SUBSCRIBE_STATES["SUBSCRIBED"] = "SUBSCRIBED";
    REALTIME_SUBSCRIBE_STATES["TIMED_OUT"] = "TIMED_OUT";
    REALTIME_SUBSCRIBE_STATES["CLOSED"] = "CLOSED";
    REALTIME_SUBSCRIBE_STATES["CHANNEL_ERROR"] = "CHANNEL_ERROR";
})($4207c69ca85d6d3a$export$a6885b926af646a2 || ($4207c69ca85d6d3a$export$a6885b926af646a2 = {}));
const $4207c69ca85d6d3a$export$154db638d9c0559e = (0, $6c3d97496f0a6ce3$export$b83816118db74fe7);
class $4207c69ca85d6d3a$export$2e2bcd8739ae039 {
    /** Subscribe registers your client with the server */ subscribe(callback, timeout = this.timeout) {
        var _a, _b;
        if (!this.socket.isConnected()) this.socket.connect();
        if (this.joinedOnce) throw `tried to subscribe multiple times. 'subscribe' can only be called a single time per channel instance`;
        else {
            const { config: { broadcast: broadcast, presence: presence } } = this.params;
            this._onError((e)=>callback && callback("CHANNEL_ERROR", e));
            this._onClose(()=>callback && callback("CLOSED"));
            const accessTokenPayload = {};
            const config = {
                broadcast: broadcast,
                presence: presence,
                postgres_changes: (_b = (_a = this.bindings.postgres_changes) === null || _a === void 0 ? void 0 : _a.map((r)=>r.filter)) !== null && _b !== void 0 ? _b : []
            };
            if (this.socket.accessToken) accessTokenPayload.access_token = this.socket.accessToken;
            this.updateJoinPayload(Object.assign({
                config: config
            }, accessTokenPayload));
            this.joinedOnce = true;
            this._rejoin(timeout);
            this.joinPush.receive("ok", ({ postgres_changes: serverPostgresFilters })=>{
                var _a;
                this.socket.accessToken && this.socket.setAuth(this.socket.accessToken);
                if (serverPostgresFilters === undefined) {
                    callback && callback("SUBSCRIBED");
                    return;
                } else {
                    const clientPostgresBindings = this.bindings.postgres_changes;
                    const bindingsLen = (_a = clientPostgresBindings === null || clientPostgresBindings === void 0 ? void 0 : clientPostgresBindings.length) !== null && _a !== void 0 ? _a : 0;
                    const newPostgresBindings = [];
                    for(let i = 0; i < bindingsLen; i++){
                        const clientPostgresBinding = clientPostgresBindings[i];
                        const { filter: { event: event, schema: schema, table: table, filter: filter } } = clientPostgresBinding;
                        const serverPostgresFilter = serverPostgresFilters && serverPostgresFilters[i];
                        if (serverPostgresFilter && serverPostgresFilter.event === event && serverPostgresFilter.schema === schema && serverPostgresFilter.table === table && serverPostgresFilter.filter === filter) newPostgresBindings.push(Object.assign(Object.assign({}, clientPostgresBinding), {
                            id: serverPostgresFilter.id
                        }));
                        else {
                            this.unsubscribe();
                            callback && callback("CHANNEL_ERROR", new Error("mismatch between server and client bindings for postgres changes"));
                            return;
                        }
                    }
                    this.bindings.postgres_changes = newPostgresBindings;
                    callback && callback("SUBSCRIBED");
                    return;
                }
            }).receive("error", (error)=>{
                callback && callback("CHANNEL_ERROR", new Error(JSON.stringify(Object.values(error).join(", ") || "error")));
                return;
            }).receive("timeout", ()=>{
                callback && callback("TIMED_OUT");
                return;
            });
        }
        return this;
    }
    presenceState() {
        return this.presence.state;
    }
    async track(payload, opts = {}) {
        return await this.send({
            type: "presence",
            event: "track",
            payload: payload
        }, opts.timeout || this.timeout);
    }
    async untrack(opts = {}) {
        return await this.send({
            type: "presence",
            event: "untrack"
        }, opts);
    }
    on(type, filter, callback) {
        return this._on(type, filter, callback);
    }
    /**
     * Sends a message into the channel.
     *
     * @param args Arguments to send to channel
     * @param args.type The type of event to send
     * @param args.event The name of the event being sent
     * @param args.payload Payload to be sent
     * @param opts Options to be used during the send process
     */ async send(args, opts = {}) {
        var _a, _b;
        if (!this._canPush() && args.type === "broadcast") {
            const { event: event, payload: endpoint_payload } = args;
            const options = {
                method: "POST",
                headers: {
                    apikey: (_a = this.socket.apiKey) !== null && _a !== void 0 ? _a : "",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    messages: [
                        {
                            topic: this.subTopic,
                            event: event,
                            payload: endpoint_payload
                        }
                    ]
                })
            };
            try {
                const response = await this._fetchWithTimeout(this.broadcastEndpointURL, options, (_b = opts.timeout) !== null && _b !== void 0 ? _b : this.timeout);
                if (response.ok) return "ok";
                else return "error";
            } catch (error) {
                if (error.name === "AbortError") return "timed out";
                else return "error";
            }
        } else return new Promise((resolve)=>{
            var _a, _b, _c;
            const push = this._push(args.type, args, opts.timeout || this.timeout);
            if (args.type === "broadcast" && !((_c = (_b = (_a = this.params) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.broadcast) === null || _c === void 0 ? void 0 : _c.ack)) resolve("ok");
            push.receive("ok", ()=>resolve("ok"));
            push.receive("timeout", ()=>resolve("timed out"));
        });
    }
    updateJoinPayload(payload) {
        this.joinPush.updatePayload(payload);
    }
    /**
     * Leaves the channel.
     *
     * Unsubscribes from server events, and instructs channel to terminate on server.
     * Triggers onClose() hooks.
     *
     * To receive leave acknowledgements, use the a `receive` hook to bind to the server ack, ie:
     * channel.unsubscribe().receive("ok", () => alert("left!") )
     */ unsubscribe(timeout = this.timeout) {
        this.state = (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).leaving;
        const onClose = ()=>{
            this.socket.log("channel", `leave ${this.topic}`);
            this._trigger((0, $6c3d97496f0a6ce3$export$8db7548e65d6ea55).close, "leave", this._joinRef());
        };
        this.rejoinTimer.reset();
        // Destroy joinPush to avoid connection timeouts during unscription phase
        this.joinPush.destroy();
        return new Promise((resolve)=>{
            const leavePush = new (0, $b0bbbfc32a2fda3f$export$2e2bcd8739ae039)(this, (0, $6c3d97496f0a6ce3$export$8db7548e65d6ea55).leave, {}, timeout);
            leavePush.receive("ok", ()=>{
                onClose();
                resolve("ok");
            }).receive("timeout", ()=>{
                onClose();
                resolve("timed out");
            }).receive("error", ()=>{
                resolve("error");
            });
            leavePush.send();
            if (!this._canPush()) leavePush.trigger("ok", {});
        });
    }
    /** @internal */ _broadcastEndpointURL() {
        let url = this.socket.endPoint;
        url = url.replace(/^ws/i, "http");
        url = url.replace(/(\/socket\/websocket|\/socket|\/websocket)\/?$/i, "");
        return url.replace(/\/+$/, "") + "/api/broadcast";
    }
    async _fetchWithTimeout(url, options, timeout) {
        const controller = new AbortController();
        const id = setTimeout(()=>controller.abort(), timeout);
        const response = await this.socket.fetch(url, Object.assign(Object.assign({}, options), {
            signal: controller.signal
        }));
        clearTimeout(id);
        return response;
    }
    /** @internal */ _push(event, payload, timeout = this.timeout) {
        if (!this.joinedOnce) throw `tried to push '${event}' to '${this.topic}' before joining. Use channel.subscribe() before pushing events`;
        let pushEvent = new (0, $b0bbbfc32a2fda3f$export$2e2bcd8739ae039)(this, event, payload, timeout);
        if (this._canPush()) pushEvent.send();
        else {
            pushEvent.startTimeout();
            this.pushBuffer.push(pushEvent);
        }
        return pushEvent;
    }
    /**
     * Overridable message hook
     *
     * Receives all events for specialized message handling before dispatching to the channel callbacks.
     * Must return the payload, modified or unmodified.
     *
     * @internal
     */ _onMessage(_event, payload, _ref) {
        return payload;
    }
    /** @internal */ _isMember(topic) {
        return this.topic === topic;
    }
    /** @internal */ _joinRef() {
        return this.joinPush.ref;
    }
    /** @internal */ _trigger(type, payload, ref) {
        var _a, _b;
        const typeLower = type.toLocaleLowerCase();
        const { close: close, error: error, leave: leave, join: join } = (0, $6c3d97496f0a6ce3$export$8db7548e65d6ea55);
        const events = [
            close,
            error,
            leave,
            join
        ];
        if (ref && events.indexOf(typeLower) >= 0 && ref !== this._joinRef()) return;
        let handledPayload = this._onMessage(typeLower, payload, ref);
        if (payload && !handledPayload) throw "channel onMessage callbacks must return the payload, modified or unmodified";
        if ([
            "insert",
            "update",
            "delete"
        ].includes(typeLower)) (_a = this.bindings.postgres_changes) === null || _a === void 0 || _a.filter((bind)=>{
            var _a, _b, _c;
            return ((_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event) === "*" || ((_c = (_b = bind.filter) === null || _b === void 0 ? void 0 : _b.event) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) === typeLower;
        }).map((bind)=>bind.callback(handledPayload, ref));
        else (_b = this.bindings[typeLower]) === null || _b === void 0 || _b.filter((bind)=>{
            var _a, _b, _c, _d, _e, _f;
            if ([
                "broadcast",
                "presence",
                "postgres_changes"
            ].includes(typeLower)) {
                if ("id" in bind) {
                    const bindId = bind.id;
                    const bindEvent = (_a = bind.filter) === null || _a === void 0 ? void 0 : _a.event;
                    return bindId && ((_b = payload.ids) === null || _b === void 0 ? void 0 : _b.includes(bindId)) && (bindEvent === "*" || (bindEvent === null || bindEvent === void 0 ? void 0 : bindEvent.toLocaleLowerCase()) === ((_c = payload.data) === null || _c === void 0 ? void 0 : _c.type.toLocaleLowerCase()));
                } else {
                    const bindEvent = (_e = (_d = bind === null || bind === void 0 ? void 0 : bind.filter) === null || _d === void 0 ? void 0 : _d.event) === null || _e === void 0 ? void 0 : _e.toLocaleLowerCase();
                    return bindEvent === "*" || bindEvent === ((_f = payload === null || payload === void 0 ? void 0 : payload.event) === null || _f === void 0 ? void 0 : _f.toLocaleLowerCase());
                }
            } else return bind.type.toLocaleLowerCase() === typeLower;
        }).map((bind)=>{
            if (typeof handledPayload === "object" && "ids" in handledPayload) {
                const postgresChanges = handledPayload.data;
                const { schema: schema, table: table, commit_timestamp: commit_timestamp, type: type, errors: errors } = postgresChanges;
                const enrichedPayload = {
                    schema: schema,
                    table: table,
                    commit_timestamp: commit_timestamp,
                    eventType: type,
                    new: {},
                    old: {},
                    errors: errors
                };
                handledPayload = Object.assign(Object.assign({}, enrichedPayload), this._getPayloadRecords(postgresChanges));
            }
            bind.callback(handledPayload, ref);
        });
    }
    /** @internal */ _isClosed() {
        return this.state === (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).closed;
    }
    /** @internal */ _isJoined() {
        return this.state === (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).joined;
    }
    /** @internal */ _isJoining() {
        return this.state === (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).joining;
    }
    /** @internal */ _isLeaving() {
        return this.state === (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).leaving;
    }
    /** @internal */ _replyEventName(ref) {
        return `chan_reply_${ref}`;
    }
    /** @internal */ _on(type, filter, callback) {
        const typeLower = type.toLocaleLowerCase();
        const binding = {
            type: typeLower,
            filter: filter,
            callback: callback
        };
        if (this.bindings[typeLower]) this.bindings[typeLower].push(binding);
        else this.bindings[typeLower] = [
            binding
        ];
        return this;
    }
    /** @internal */ _off(type, filter) {
        const typeLower = type.toLocaleLowerCase();
        this.bindings[typeLower] = this.bindings[typeLower].filter((bind)=>{
            var _a;
            return !(((_a = bind.type) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === typeLower && $4207c69ca85d6d3a$export$2e2bcd8739ae039.isEqual(bind.filter, filter));
        });
        return this;
    }
    /** @internal */ static isEqual(obj1, obj2) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
        for(const k in obj1){
            if (obj1[k] !== obj2[k]) return false;
        }
        return true;
    }
    /** @internal */ _rejoinUntilConnected() {
        this.rejoinTimer.scheduleTimeout();
        if (this.socket.isConnected()) this._rejoin();
    }
    /**
     * Registers a callback that will be executed when the channel closes.
     *
     * @internal
     */ _onClose(callback) {
        this._on((0, $6c3d97496f0a6ce3$export$8db7548e65d6ea55).close, {}, callback);
    }
    /**
     * Registers a callback that will be executed when the channel encounteres an error.
     *
     * @internal
     */ _onError(callback) {
        this._on((0, $6c3d97496f0a6ce3$export$8db7548e65d6ea55).error, {}, (reason)=>callback(reason));
    }
    /**
     * Returns `true` if the socket is connected and the channel has been joined.
     *
     * @internal
     */ _canPush() {
        return this.socket.isConnected() && this._isJoined();
    }
    /** @internal */ _rejoin(timeout = this.timeout) {
        if (this._isLeaving()) return;
        this.socket._leaveOpenTopic(this.topic);
        this.state = (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).joining;
        this.joinPush.resend(timeout);
    }
    /** @internal */ _getPayloadRecords(payload) {
        const records = {
            new: {},
            old: {}
        };
        if (payload.type === "INSERT" || payload.type === "UPDATE") records.new = $7021628b0f03edf5$export$20ce708a1f594c5e(payload.columns, payload.record);
        if (payload.type === "UPDATE" || payload.type === "DELETE") records.old = $7021628b0f03edf5$export$20ce708a1f594c5e(payload.columns, payload.old_record);
        return records;
    }
    constructor(/** Topic name can be any string. */ topic, params = {
        config: {}
    }, socket){
        this.topic = topic;
        this.params = params;
        this.socket = socket;
        this.bindings = {};
        this.state = (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).closed;
        this.joinedOnce = false;
        this.pushBuffer = [];
        this.subTopic = topic.replace(/^realtime:/i, "");
        this.params.config = Object.assign({
            broadcast: {
                ack: false,
                self: false
            },
            presence: {
                key: ""
            }
        }, params.config);
        this.timeout = this.socket.timeout;
        this.joinPush = new (0, $b0bbbfc32a2fda3f$export$2e2bcd8739ae039)(this, (0, $6c3d97496f0a6ce3$export$8db7548e65d6ea55).join, this.params, this.timeout);
        this.rejoinTimer = new (0, $a1e567373325082e$export$2e2bcd8739ae039)(()=>this._rejoinUntilConnected(), this.socket.reconnectAfterMs);
        this.joinPush.receive("ok", ()=>{
            this.state = (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).joined;
            this.rejoinTimer.reset();
            this.pushBuffer.forEach((pushEvent)=>pushEvent.send());
            this.pushBuffer = [];
        });
        this._onClose(()=>{
            this.rejoinTimer.reset();
            this.socket.log("channel", `close ${this.topic} ${this._joinRef()}`);
            this.state = (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).closed;
            this.socket._remove(this);
        });
        this._onError((reason)=>{
            if (this._isLeaving() || this._isClosed()) return;
            this.socket.log("channel", `error ${this.topic}`, reason);
            this.state = (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this.joinPush.receive("timeout", ()=>{
            if (!this._isJoining()) return;
            this.socket.log("channel", `timeout ${this.topic}`, this.joinPush.timeout);
            this.state = (0, $6c3d97496f0a6ce3$export$b83816118db74fe7).errored;
            this.rejoinTimer.scheduleTimeout();
        });
        this._on((0, $6c3d97496f0a6ce3$export$8db7548e65d6ea55).reply, {}, (payload, ref)=>{
            this._trigger(this._replyEventName(ref), payload);
        });
        this.presence = new (0, $deecd9ea7b989c66$export$2e2bcd8739ae039)(this);
        this.broadcastEndpointURL = this._broadcastEndpointURL();
    }
}


const $d22abf3fb04a8208$var$noop = ()=>{};
const $d22abf3fb04a8208$var$NATIVE_WEBSOCKET_AVAILABLE = typeof WebSocket !== "undefined";


class $d22abf3fb04a8208$export$2e2bcd8739ae039 {
    /**
     * Connects the socket, unless already connected.
     */ connect() {
        if (this.conn) return;
        if (this.transport) {
            this.conn = new this.transport(this._endPointURL(), undefined, {
                headers: this.headers
            });
            return;
        }
        if ($d22abf3fb04a8208$var$NATIVE_WEBSOCKET_AVAILABLE) {
            this.conn = new WebSocket(this._endPointURL());
            this.setupConnection();
            return;
        }
        this.conn = new $d22abf3fb04a8208$var$WSWebSocketDummy(this._endPointURL(), undefined, {
            close: ()=>{
                this.conn = null;
            }
        });
        (parcelRequire("gtOsO")).then(({ default: WS })=>{
            this.conn = new WS(this._endPointURL(), undefined, {
                headers: this.headers
            });
            this.setupConnection();
        });
    }
    /**
     * Disconnects the socket.
     *
     * @param code A numeric status code to send on disconnect.
     * @param reason A custom reason for the disconnect.
     */ disconnect(code, reason) {
        if (this.conn) {
            this.conn.onclose = function() {}; // noop
            if (code) this.conn.close(code, reason !== null && reason !== void 0 ? reason : "");
            else this.conn.close();
            this.conn = null;
            // remove open handles
            this.heartbeatTimer && clearInterval(this.heartbeatTimer);
            this.reconnectTimer.reset();
        }
    }
    /**
     * Returns all created channels
     */ getChannels() {
        return this.channels;
    }
    /**
     * Unsubscribes and removes a single channel
     * @param channel A RealtimeChannel instance
     */ async removeChannel(channel) {
        const status = await channel.unsubscribe();
        if (this.channels.length === 0) this.disconnect();
        return status;
    }
    /**
     * Unsubscribes and removes all channels
     */ async removeAllChannels() {
        const values_1 = await Promise.all(this.channels.map((channel)=>channel.unsubscribe()));
        this.disconnect();
        return values_1;
    }
    /**
     * Logs the message.
     *
     * For customized logging, `this.logger` can be overridden.
     */ log(kind, msg, data) {
        this.logger(kind, msg, data);
    }
    /**
     * Returns the current state of the socket.
     */ connectionState() {
        switch(this.conn && this.conn.readyState){
            case (0, $6c3d97496f0a6ce3$export$a6d0320a1563d49e).connecting:
                return (0, $6c3d97496f0a6ce3$export$deda39003d27273).Connecting;
            case (0, $6c3d97496f0a6ce3$export$a6d0320a1563d49e).open:
                return (0, $6c3d97496f0a6ce3$export$deda39003d27273).Open;
            case (0, $6c3d97496f0a6ce3$export$a6d0320a1563d49e).closing:
                return (0, $6c3d97496f0a6ce3$export$deda39003d27273).Closing;
            default:
                return (0, $6c3d97496f0a6ce3$export$deda39003d27273).Closed;
        }
    }
    /**
     * Returns `true` is the connection is open.
     */ isConnected() {
        return this.connectionState() === (0, $6c3d97496f0a6ce3$export$deda39003d27273).Open;
    }
    channel(topic, params = {
        config: {}
    }) {
        const chan = new (0, $4207c69ca85d6d3a$export$2e2bcd8739ae039)(`realtime:${topic}`, params, this);
        this.channels.push(chan);
        return chan;
    }
    /**
     * Push out a message if the socket is connected.
     *
     * If the socket is not connected, the message gets enqueued within a local buffer, and sent out when a connection is next established.
     */ push(data) {
        const { topic: topic, event: event, payload: payload, ref: ref } = data;
        const callback = ()=>{
            this.encode(data, (result)=>{
                var _a;
                (_a = this.conn) === null || _a === void 0 || _a.send(result);
            });
        };
        this.log("push", `${topic} ${event} (${ref})`, payload);
        if (this.isConnected()) callback();
        else this.sendBuffer.push(callback);
    }
    /**
     * Sets the JWT access token used for channel subscription authorization and Realtime RLS.
     *
     * @param token A JWT string.
     */ setAuth(token) {
        this.accessToken = token;
        this.channels.forEach((channel)=>{
            token && channel.updateJoinPayload({
                access_token: token
            });
            if (channel.joinedOnce && channel._isJoined()) channel._push((0, $6c3d97496f0a6ce3$export$8db7548e65d6ea55).access_token, {
                access_token: token
            });
        });
    }
    /**
     * Return the next message ref, accounting for overflows
     *
     * @internal
     */ _makeRef() {
        let newRef = this.ref + 1;
        if (newRef === this.ref) this.ref = 0;
        else this.ref = newRef;
        return this.ref.toString();
    }
    /**
     * Unsubscribe from channels with the specified topic.
     *
     * @internal
     */ _leaveOpenTopic(topic) {
        let dupChannel = this.channels.find((c)=>c.topic === topic && (c._isJoined() || c._isJoining()));
        if (dupChannel) {
            this.log("transport", `leaving duplicate topic "${topic}"`);
            dupChannel.unsubscribe();
        }
    }
    /**
     * Removes a subscription from the socket.
     *
     * @param channel An open subscription.
     *
     * @internal
     */ _remove(channel) {
        this.channels = this.channels.filter((c)=>c._joinRef() !== channel._joinRef());
    }
    /**
     * Sets up connection handlers.
     *
     * @internal
     */ setupConnection() {
        if (this.conn) {
            this.conn.binaryType = "arraybuffer";
            this.conn.onopen = ()=>this._onConnOpen();
            this.conn.onerror = (error)=>this._onConnError(error);
            this.conn.onmessage = (event)=>this._onConnMessage(event);
            this.conn.onclose = (event)=>this._onConnClose(event);
        }
    }
    /**
     * Returns the URL of the websocket.
     *
     * @internal
     */ _endPointURL() {
        return this._appendParams(this.endPoint, Object.assign({}, this.params, {
            vsn: (0, $6c3d97496f0a6ce3$export$df3f558bb9a9c991)
        }));
    }
    /** @internal */ _onConnMessage(rawMessage) {
        this.decode(rawMessage.data, (msg)=>{
            let { topic: topic, event: event, payload: payload, ref: ref } = msg;
            if (ref && ref === this.pendingHeartbeatRef || event === (payload === null || payload === void 0 ? void 0 : payload.type)) this.pendingHeartbeatRef = null;
            this.log("receive", `${payload.status || ""} ${topic} ${event} ${ref && "(" + ref + ")" || ""}`, payload);
            this.channels.filter((channel)=>channel._isMember(topic)).forEach((channel)=>channel._trigger(event, payload, ref));
            this.stateChangeCallbacks.message.forEach((callback)=>callback(msg));
        });
    }
    /** @internal */ _onConnOpen() {
        this.log("transport", `connected to ${this._endPointURL()}`);
        this._flushSendBuffer();
        this.reconnectTimer.reset();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = setInterval(()=>this._sendHeartbeat(), this.heartbeatIntervalMs);
        this.stateChangeCallbacks.open.forEach((callback)=>callback());
    }
    /** @internal */ _onConnClose(event) {
        this.log("transport", "close", event);
        this._triggerChanError();
        this.heartbeatTimer && clearInterval(this.heartbeatTimer);
        this.reconnectTimer.scheduleTimeout();
        this.stateChangeCallbacks.close.forEach((callback)=>callback(event));
    }
    /** @internal */ _onConnError(error) {
        this.log("transport", error.message);
        this._triggerChanError();
        this.stateChangeCallbacks.error.forEach((callback)=>callback(error));
    }
    /** @internal */ _triggerChanError() {
        this.channels.forEach((channel)=>channel._trigger((0, $6c3d97496f0a6ce3$export$8db7548e65d6ea55).error));
    }
    /** @internal */ _appendParams(url, params) {
        if (Object.keys(params).length === 0) return url;
        const prefix = url.match(/\?/) ? "&" : "?";
        const query = new URLSearchParams(params);
        return `${url}${prefix}${query}`;
    }
    /** @internal */ _flushSendBuffer() {
        if (this.isConnected() && this.sendBuffer.length > 0) {
            this.sendBuffer.forEach((callback)=>callback());
            this.sendBuffer = [];
        }
    }
    /** @internal */ _sendHeartbeat() {
        var _a;
        if (!this.isConnected()) return;
        if (this.pendingHeartbeatRef) {
            this.pendingHeartbeatRef = null;
            this.log("transport", "heartbeat timeout. Attempting to re-establish connection");
            (_a = this.conn) === null || _a === void 0 || _a.close((0, $6c3d97496f0a6ce3$export$5e80cf62e56a877b), "hearbeat timeout");
            return;
        }
        this.pendingHeartbeatRef = this._makeRef();
        this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: this.pendingHeartbeatRef
        });
        this.setAuth(this.accessToken);
    }
    /**
     * Initializes the Socket.
     *
     * @param endPoint The string WebSocket endpoint, ie, "ws://example.com/socket", "wss://example.com", "/socket" (inherited host & protocol)
     * @param options.transport The Websocket Transport, for example WebSocket.
     * @param options.timeout The default timeout in milliseconds to trigger push timeouts.
     * @param options.params The optional params to pass when connecting.
     * @param options.headers The optional headers to pass when connecting.
     * @param options.heartbeatIntervalMs The millisec interval to send a heartbeat message.
     * @param options.logger The optional function for specialized logging, ie: logger: (kind, msg, data) => { console.log(`${kind}: ${msg}`, data) }
     * @param options.encode The function to encode outgoing messages. Defaults to JSON: (payload, callback) => callback(JSON.stringify(payload))
     * @param options.decode The function to decode incoming messages. Defaults to Serializer's decode.
     * @param options.reconnectAfterMs he optional function that returns the millsec reconnect interval. Defaults to stepped backoff off.
     */ constructor(endPoint, options){
        var _a;
        this.accessToken = null;
        this.apiKey = null;
        this.channels = [];
        this.endPoint = "";
        this.headers = (0, $6c3d97496f0a6ce3$export$88a84136db6a4b64);
        this.params = {};
        this.timeout = (0, $6c3d97496f0a6ce3$export$7bd623b29ec8e1eb);
        this.heartbeatIntervalMs = 30000;
        this.heartbeatTimer = undefined;
        this.pendingHeartbeatRef = null;
        this.ref = 0;
        this.logger = $d22abf3fb04a8208$var$noop;
        this.conn = null;
        this.sendBuffer = [];
        this.serializer = new (0, $b819558905f4bfb4$export$2e2bcd8739ae039)();
        this.stateChangeCallbacks = {
            open: [],
            close: [],
            error: [],
            message: []
        };
        /**
         * Use either custom fetch, if provided, or default fetch to make HTTP requests
         *
         * @internal
         */ this._resolveFetch = (customFetch)=>{
            let _fetch;
            if (customFetch) _fetch = customFetch;
            else if (typeof fetch === "undefined") _fetch = (...args)=>Promise.resolve((parcelRequire("22Tpm"))).then(({ default: fetch1 })=>fetch1(...args));
            else _fetch = fetch;
            return (...args)=>_fetch(...args);
        };
        this.endPoint = `${endPoint}/${(0, $6c3d97496f0a6ce3$export$b2688bfb999f5751).websocket}`;
        if (options === null || options === void 0 ? void 0 : options.transport) this.transport = options.transport;
        else this.transport = null;
        if (options === null || options === void 0 ? void 0 : options.params) this.params = options.params;
        if (options === null || options === void 0 ? void 0 : options.headers) this.headers = Object.assign(Object.assign({}, this.headers), options.headers);
        if (options === null || options === void 0 ? void 0 : options.timeout) this.timeout = options.timeout;
        if (options === null || options === void 0 ? void 0 : options.logger) this.logger = options.logger;
        if (options === null || options === void 0 ? void 0 : options.heartbeatIntervalMs) this.heartbeatIntervalMs = options.heartbeatIntervalMs;
        const accessToken = (_a = options === null || options === void 0 ? void 0 : options.params) === null || _a === void 0 ? void 0 : _a.apikey;
        if (accessToken) {
            this.accessToken = accessToken;
            this.apiKey = accessToken;
        }
        this.reconnectAfterMs = (options === null || options === void 0 ? void 0 : options.reconnectAfterMs) ? options.reconnectAfterMs : (tries)=>{
            return [
                1000,
                2000,
                5000,
                10000
            ][tries - 1] || 10000;
        };
        this.encode = (options === null || options === void 0 ? void 0 : options.encode) ? options.encode : (payload, callback)=>{
            return callback(JSON.stringify(payload));
        };
        this.decode = (options === null || options === void 0 ? void 0 : options.decode) ? options.decode : this.serializer.decode.bind(this.serializer);
        this.reconnectTimer = new (0, $a1e567373325082e$export$2e2bcd8739ae039)(async ()=>{
            this.disconnect();
            this.connect();
        }, this.reconnectAfterMs);
        this.fetch = this._resolveFetch(options === null || options === void 0 ? void 0 : options.fetch);
    }
}
class $d22abf3fb04a8208$var$WSWebSocketDummy {
    constructor(address, _protocols, options){
        this.binaryType = "arraybuffer";
        this.onclose = ()=>{};
        this.onerror = ()=>{};
        this.onmessage = ()=>{};
        this.onopen = ()=>{};
        this.readyState = (0, $6c3d97496f0a6ce3$export$a6d0320a1563d49e).connecting;
        this.send = ()=>{};
        this.url = null;
        this.url = address;
        this.close = options.close;
    }
}






class $ed0ba31cff255646$export$697502632950e9d3 extends Error {
    constructor(message){
        super(message);
        this.__isStorageError = true;
        this.name = "StorageError";
    }
}
function $ed0ba31cff255646$export$5a322e77e5eb0561(error) {
    return typeof error === "object" && error !== null && "__isStorageError" in error;
}
class $ed0ba31cff255646$export$ca9ecfd959b3871c extends $ed0ba31cff255646$export$697502632950e9d3 {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
    constructor(message, status){
        super(message);
        this.name = "StorageApiError";
        this.status = status;
    }
}
class $ed0ba31cff255646$export$29127ca2e1a271d extends $ed0ba31cff255646$export$697502632950e9d3 {
    constructor(message, originalError){
        super(message);
        this.name = "StorageUnknownError";
        this.originalError = originalError;
    }
}



var $e6ab48976e8fe906$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const $e6ab48976e8fe906$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === "undefined") _fetch = (...args)=>Promise.resolve((parcelRequire("22Tpm"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};

const $e6ab48976e8fe906$export$ace1d6afc438cf26 = ()=>$e6ab48976e8fe906$var$__awaiter(void 0, void 0, void 0, function*() {
        if (typeof Response === "undefined") // @ts-ignore
        return (yield Promise.resolve((parcelRequire("22Tpm")))).Response;
        return Response;
    });


var $043359cef9d1eef3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $043359cef9d1eef3$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $043359cef9d1eef3$var$handleError = (error, reject)=>$043359cef9d1eef3$var$__awaiter(void 0, void 0, void 0, function*() {
        const Res = yield (0, $e6ab48976e8fe906$export$ace1d6afc438cf26)();
        if (error instanceof Res) error.json().then((err)=>{
            reject(new (0, $ed0ba31cff255646$export$ca9ecfd959b3871c)($043359cef9d1eef3$var$_getErrorMessage(err), error.status || 500));
        }).catch((err)=>{
            reject(new (0, $ed0ba31cff255646$export$29127ca2e1a271d)($043359cef9d1eef3$var$_getErrorMessage(err), err));
        });
        else reject(new (0, $ed0ba31cff255646$export$29127ca2e1a271d)($043359cef9d1eef3$var$_getErrorMessage(error), error));
    });
const $043359cef9d1eef3$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET") return params;
    params.headers = Object.assign({
        "Content-Type": "application/json"
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
function $043359cef9d1eef3$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    return $043359cef9d1eef3$var$__awaiter(this, void 0, void 0, function*() {
        return new Promise((resolve, reject)=>{
            fetcher(url, $043359cef9d1eef3$var$_getRequestParams(method, options, parameters, body)).then((result)=>{
                if (!result.ok) throw result;
                if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
                return result.json();
            }).then((data)=>resolve(data)).catch((error)=>$043359cef9d1eef3$var$handleError(error, reject));
        });
    });
}
function $043359cef9d1eef3$export$3988ae62b71be9a3(fetcher, url, options, parameters) {
    return $043359cef9d1eef3$var$__awaiter(this, void 0, void 0, function*() {
        return $043359cef9d1eef3$var$_handleRequest(fetcher, "GET", url, options, parameters);
    });
}
function $043359cef9d1eef3$export$299ba2dee77727e9(fetcher, url, body, options, parameters) {
    return $043359cef9d1eef3$var$__awaiter(this, void 0, void 0, function*() {
        return $043359cef9d1eef3$var$_handleRequest(fetcher, "POST", url, options, parameters, body);
    });
}
function $043359cef9d1eef3$export$327f7b26ebf455db(fetcher, url, body, options, parameters) {
    return $043359cef9d1eef3$var$__awaiter(this, void 0, void 0, function*() {
        return $043359cef9d1eef3$var$_handleRequest(fetcher, "PUT", url, options, parameters, body);
    });
}
function $043359cef9d1eef3$export$cd7f480d6b8286c3(fetcher, url, body, options, parameters) {
    return $043359cef9d1eef3$var$__awaiter(this, void 0, void 0, function*() {
        return $043359cef9d1eef3$var$_handleRequest(fetcher, "DELETE", url, options, parameters, body);
    });
}



var $6db1d59808d6bbed$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $6db1d59808d6bbed$var$DEFAULT_SEARCH_OPTIONS = {
    limit: 100,
    offset: 0,
    sortBy: {
        column: "name",
        order: "asc"
    }
};
const $6db1d59808d6bbed$var$DEFAULT_FILE_OPTIONS = {
    cacheControl: "3600",
    contentType: "text/plain;charset=UTF-8",
    upsert: false
};
class $6db1d59808d6bbed$export$2e2bcd8739ae039 {
    /**
     * Uploads a file to an existing bucket or replaces an existing file at the specified path with a new one.
     *
     * @param method HTTP method.
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadOrUpdate(method, path, fileBody, fileOptions) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let body;
                const options = Object.assign(Object.assign({}, $6db1d59808d6bbed$var$DEFAULT_FILE_OPTIONS), fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), method === "POST" && {
                    "x-upsert": String(options.upsert)
                });
                if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append("cacheControl", options.cacheControl);
                    body.append("", fileBody);
                } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append("cacheControl", options.cacheControl);
                } else {
                    body = fileBody;
                    headers["cache-control"] = `max-age=${options.cacheControl}`;
                    headers["content-type"] = options.contentType;
                }
                const cleanPath = this._removeEmptyFolders(path);
                const _path = this._getFinalPath(cleanPath);
                const res = yield this.fetch(`${this.url}/object/${_path}`, Object.assign({
                    method: method,
                    body: body,
                    headers: headers
                }, (options === null || options === void 0 ? void 0 : options.duplex) ? {
                    duplex: options.duplex
                } : {}));
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        id: data.Id,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Uploads a file to an existing bucket.
     *
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param fileBody The body of the file to be stored in the bucket.
     */ upload(path, fileBody, fileOptions) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate("POST", path, fileBody, fileOptions);
        });
    }
    /**
     * Upload a file with a token generated from `createSignedUploadUrl`.
     * @param path The file path, including the file name. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to upload.
     * @param token The token generated from `createSignedUploadUrl`
     * @param fileBody The body of the file to be stored in the bucket.
     */ uploadToSignedUrl(path, token, fileBody, fileOptions) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            const cleanPath = this._removeEmptyFolders(path);
            const _path = this._getFinalPath(cleanPath);
            const url = new URL(this.url + `/object/upload/sign/${_path}`);
            url.searchParams.set("token", token);
            try {
                let body;
                const options = Object.assign({
                    upsert: $6db1d59808d6bbed$var$DEFAULT_FILE_OPTIONS.upsert
                }, fileOptions);
                const headers = Object.assign(Object.assign({}, this.headers), {
                    "x-upsert": String(options.upsert)
                });
                if (typeof Blob !== "undefined" && fileBody instanceof Blob) {
                    body = new FormData();
                    body.append("cacheControl", options.cacheControl);
                    body.append("", fileBody);
                } else if (typeof FormData !== "undefined" && fileBody instanceof FormData) {
                    body = fileBody;
                    body.append("cacheControl", options.cacheControl);
                } else {
                    body = fileBody;
                    headers["cache-control"] = `max-age=${options.cacheControl}`;
                    headers["content-type"] = options.contentType;
                }
                const res = yield this.fetch(url.toString(), {
                    method: "PUT",
                    body: body,
                    headers: headers
                });
                const data = yield res.json();
                if (res.ok) return {
                    data: {
                        path: cleanPath,
                        fullPath: data.Key
                    },
                    error: null
                };
                else {
                    const error = data;
                    return {
                        data: null,
                        error: error
                    };
                }
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed upload URL.
     * Signed upload URLs can be used to upload files to the bucket without further authentication.
     * They are valid for 2 hours.
     * @param path The file path, including the current file name. For example `folder/image.png`.
     */ createSignedUploadUrl(path) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                const data = yield (0, $043359cef9d1eef3$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/upload/sign/${_path}`, {}, {
                    headers: this.headers
                });
                const url = new URL(this.url + data.url);
                const token = url.searchParams.get("token");
                if (!token) throw new (0, $ed0ba31cff255646$export$697502632950e9d3)("No token returned by API");
                return {
                    data: {
                        signedUrl: url.toString(),
                        path: path,
                        token: token
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Replaces an existing file at the specified path with a new one.
     *
     * @param path The relative file path. Should be of the format `folder/subfolder/filename.png`. The bucket must already exist before attempting to update.
     * @param fileBody The body of the file to be stored in the bucket.
     */ update(path, fileBody, fileOptions) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            return this.uploadOrUpdate("PUT", path, fileBody, fileOptions);
        });
    }
    /**
     * Moves an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-new.png`.
     */ move(fromPath, toPath) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $043359cef9d1eef3$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/move`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Copies an existing file to a new path in the same bucket.
     *
     * @param fromPath The original file path, including the current file name. For example `folder/image.png`.
     * @param toPath The new file path, including the new file name. For example `folder/image-copy.png`.
     */ copy(fromPath, toPath) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $043359cef9d1eef3$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/copy`, {
                    bucketId: this.bucketId,
                    sourceKey: fromPath,
                    destinationKey: toPath
                }, {
                    headers: this.headers
                });
                return {
                    data: {
                        path: data.Key
                    },
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a signed URL. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param path The file path, including the current file name. For example `folder/image.png`.
     * @param expiresIn The number of seconds until the signed URL expires. For example, `60` for a URL which is valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ createSignedUrl(path, expiresIn, options) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            try {
                let _path = this._getFinalPath(path);
                let data = yield (0, $043359cef9d1eef3$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${_path}`, Object.assign({
                    expiresIn: expiresIn
                }, (options === null || options === void 0 ? void 0 : options.transform) ? {
                    transform: options.transform
                } : {}), {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? "" : options.download}` : "";
                const signedUrl = encodeURI(`${this.url}${data.signedURL}${downloadQueryParam}`);
                data = {
                    signedUrl: signedUrl
                };
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates multiple signed URLs. Use a signed URL to share a file for a fixed amount of time.
     *
     * @param paths The file paths to be downloaded, including the current file names. For example `['folder/image.png', 'folder2/image2.png']`.
     * @param expiresIn The number of seconds until the signed URLs expire. For example, `60` for URLs which are valid for one minute.
     * @param options.download triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     */ createSignedUrls(paths, expiresIn, options) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $043359cef9d1eef3$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/sign/${this.bucketId}`, {
                    expiresIn: expiresIn,
                    paths: paths
                }, {
                    headers: this.headers
                });
                const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `&download=${options.download === true ? "" : options.download}` : "";
                return {
                    data: data.map((datum)=>Object.assign(Object.assign({}, datum), {
                            signedUrl: datum.signedURL ? encodeURI(`${this.url}${datum.signedURL}${downloadQueryParam}`) : null
                        })),
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Downloads a file from a private bucket. For public buckets, make a request to the URL returned from `getPublicUrl` instead.
     *
     * @param path The full path and file name of the file to be downloaded. For example `folder/image.png`.
     * @param options.transform Transform the asset before serving it to the client.
     */ download(path, options) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== "undefined";
            const renderPath = wantsTransformation ? "render/image/authenticated" : "object";
            const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
            const queryString = transformationQuery ? `?${transformationQuery}` : "";
            try {
                const _path = this._getFinalPath(path);
                const res = yield (0, $043359cef9d1eef3$export$3988ae62b71be9a3)(this.fetch, `${this.url}/${renderPath}/${_path}${queryString}`, {
                    headers: this.headers,
                    noResolveJson: true
                });
                const data = yield res.blob();
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * A simple convenience function to get the URL for an asset in a public bucket. If you do not want to use this function, you can construct the public URL by concatenating the bucket URL with the path to the asset.
     * This function does not verify if the bucket is public. If a public URL is created for a bucket which is not public, you will not be able to download the asset.
     *
     * @param path The path and name of the file to generate the public URL for. For example `folder/image.png`.
     * @param options.download Triggers the file as a download if set to true. Set this parameter as the name of the file if you want to trigger the download with a different filename.
     * @param options.transform Transform the asset before serving it to the client.
     */ getPublicUrl(path, options) {
        const _path = this._getFinalPath(path);
        const _queryString = [];
        const downloadQueryParam = (options === null || options === void 0 ? void 0 : options.download) ? `download=${options.download === true ? "" : options.download}` : "";
        if (downloadQueryParam !== "") _queryString.push(downloadQueryParam);
        const wantsTransformation = typeof (options === null || options === void 0 ? void 0 : options.transform) !== "undefined";
        const renderPath = wantsTransformation ? "render/image" : "object";
        const transformationQuery = this.transformOptsToQueryString((options === null || options === void 0 ? void 0 : options.transform) || {});
        if (transformationQuery !== "") _queryString.push(transformationQuery);
        let queryString = _queryString.join("&");
        if (queryString !== "") queryString = `?${queryString}`;
        return {
            data: {
                publicUrl: encodeURI(`${this.url}/${renderPath}/public/${_path}${queryString}`)
            }
        };
    }
    /**
     * Deletes files within the same bucket
     *
     * @param paths An array of files to delete, including the path and file name. For example [`'folder/image.png'`].
     */ remove(paths) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $043359cef9d1eef3$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/object/${this.bucketId}`, {
                    prefixes: paths
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Get file metadata
     * @param id the file id to retrieve metadata
     */ // async getMetadata(
    //   id: string
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await get(this.fetch, `${this.url}/metadata/${id}`, { headers: this.headers })
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Update file metadata
     * @param id the file id to update metadata
     * @param meta the new file metadata
     */ // async updateMetadata(
    //   id: string,
    //   meta: Metadata
    // ): Promise<
    //   | {
    //       data: Metadata
    //       error: null
    //     }
    //   | {
    //       data: null
    //       error: StorageError
    //     }
    // > {
    //   try {
    //     const data = await post(
    //       this.fetch,
    //       `${this.url}/metadata/${id}`,
    //       { ...meta },
    //       { headers: this.headers }
    //     )
    //     return { data, error: null }
    //   } catch (error) {
    //     if (isStorageError(error)) {
    //       return { data: null, error }
    //     }
    //     throw error
    //   }
    // }
    /**
     * Lists all the files within a bucket.
     * @param path The folder path.
     */ list(path, options, parameters) {
        return $6db1d59808d6bbed$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const body = Object.assign(Object.assign(Object.assign({}, $6db1d59808d6bbed$var$DEFAULT_SEARCH_OPTIONS), options), {
                    prefix: path || ""
                });
                const data = yield (0, $043359cef9d1eef3$export$299ba2dee77727e9)(this.fetch, `${this.url}/object/list/${this.bucketId}`, body, {
                    headers: this.headers
                }, parameters);
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    _getFinalPath(path) {
        return `${this.bucketId}/${path}`;
    }
    _removeEmptyFolders(path) {
        return path.replace(/^\/|\/$/g, "").replace(/\/+/g, "/");
    }
    transformOptsToQueryString(transform) {
        const params = [];
        if (transform.width) params.push(`width=${transform.width}`);
        if (transform.height) params.push(`height=${transform.height}`);
        if (transform.resize) params.push(`resize=${transform.resize}`);
        if (transform.format) params.push(`format=${transform.format}`);
        if (transform.quality) params.push(`quality=${transform.quality}`);
        return params.join("&");
    }
    constructor(url, headers = {}, bucketId, fetch){
        this.url = url;
        this.headers = headers;
        this.bucketId = bucketId;
        this.fetch = (0, $e6ab48976e8fe906$export$98d92b1aa79f8cc7)(fetch);
    }
}


// generated by genversion
const $e9f4724399117a8c$export$83d89fbfd8236492 = "2.5.5";


const $726f07c708f51c4c$export$88a84136db6a4b64 = {
    "X-Client-Info": `storage-js/${(0, $e9f4724399117a8c$export$83d89fbfd8236492)}`
};





var $28ff6c6630a1165b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $28ff6c6630a1165b$export$2e2bcd8739ae039 {
    /**
     * Retrieves the details of all Storage buckets within an existing project.
     */ listBuckets() {
        return $28ff6c6630a1165b$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $043359cef9d1eef3$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Retrieves the details of an existing Storage bucket.
     *
     * @param id The unique identifier of the bucket you would like to retrieve.
     */ getBucket(id) {
        return $28ff6c6630a1165b$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $043359cef9d1eef3$export$3988ae62b71be9a3)(this.fetch, `${this.url}/bucket/${id}`, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Creates a new Storage bucket
     *
     * @param id A unique identifier for the bucket you are creating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations. By default, buckets are private.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     * @returns newly created bucket id
     */ createBucket(id, options = {
        public: false
    }) {
        return $28ff6c6630a1165b$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $043359cef9d1eef3$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Updates a Storage bucket
     *
     * @param id A unique identifier for the bucket you are updating.
     * @param options.public The visibility of the bucket. Public buckets don't require an authorization token to download objects, but still require a valid token for all other operations.
     * @param options.fileSizeLimit specifies the max file size in bytes that can be uploaded to this bucket.
     * The global file size limit takes precedence over this value.
     * The default value is null, which doesn't set a per bucket file size limit.
     * @param options.allowedMimeTypes specifies the allowed mime types that this bucket can accept during upload.
     * The default value is null, which allows files with all mime types to be uploaded.
     * Each mime type specified can be a wildcard, e.g. image/*, or a specific mime type, e.g. image/png.
     */ updateBucket(id, options) {
        return $28ff6c6630a1165b$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $043359cef9d1eef3$export$327f7b26ebf455db)(this.fetch, `${this.url}/bucket/${id}`, {
                    id: id,
                    name: id,
                    public: options.public,
                    file_size_limit: options.fileSizeLimit,
                    allowed_mime_types: options.allowedMimeTypes
                }, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Removes all objects inside a single bucket.
     *
     * @param id The unique identifier of the bucket you would like to empty.
     */ emptyBucket(id) {
        return $28ff6c6630a1165b$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $043359cef9d1eef3$export$299ba2dee77727e9)(this.fetch, `${this.url}/bucket/${id}/empty`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * Deletes an existing bucket. A bucket can't be deleted with existing objects inside it.
     * You must first `empty()` the bucket.
     *
     * @param id The unique identifier of the bucket you would like to delete.
     */ deleteBucket(id) {
        return $28ff6c6630a1165b$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const data = yield (0, $043359cef9d1eef3$export$cd7f480d6b8286c3)(this.fetch, `${this.url}/bucket/${id}`, {}, {
                    headers: this.headers
                });
                return {
                    data: data,
                    error: null
                };
            } catch (error) {
                if ((0, $ed0ba31cff255646$export$5a322e77e5eb0561)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    constructor(url, headers = {}, fetch){
        this.url = url;
        this.headers = Object.assign(Object.assign({}, (0, $726f07c708f51c4c$export$88a84136db6a4b64)), headers);
        this.fetch = (0, $e6ab48976e8fe906$export$98d92b1aa79f8cc7)(fetch);
    }
}


class $d97aa35004b44b3d$export$6c85f5032e75eff9 extends (0, $28ff6c6630a1165b$export$2e2bcd8739ae039) {
    /**
     * Perform file operation in a bucket.
     *
     * @param id The bucket id to operate on.
     */ from(id) {
        return new (0, $6db1d59808d6bbed$export$2e2bcd8739ae039)(this.url, this.headers, id, this.fetch);
    }
    constructor(url, headers = {}, fetch){
        super(url, headers, fetch);
    }
}


const $7cbd0a382cab1fcf$export$83d89fbfd8236492 = "2.39.7";


let $b86add62355d561a$var$JS_ENV = "";
// @ts-ignore
if (typeof Deno !== "undefined") $b86add62355d561a$var$JS_ENV = "deno";
else if (typeof document !== "undefined") $b86add62355d561a$var$JS_ENV = "web";
else if (typeof navigator !== "undefined" && navigator.product === "ReactNative") $b86add62355d561a$var$JS_ENV = "react-native";
else $b86add62355d561a$var$JS_ENV = "node";
const $b86add62355d561a$export$88a84136db6a4b64 = {
    "X-Client-Info": `supabase-js-${$b86add62355d561a$var$JS_ENV}/${(0, $7cbd0a382cab1fcf$export$83d89fbfd8236492)}`
};
const $b86add62355d561a$export$b63a5c3a2e5becd2 = {
    headers: $b86add62355d561a$export$88a84136db6a4b64
};
const $b86add62355d561a$export$b31378ae815bea6b = {
    schema: "public"
};
const $b86add62355d561a$export$af122550cc2345b3 = {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: "implicit"
};
const $b86add62355d561a$export$59685507ca0a3912 = {};



var $22Tpm = parcelRequire("22Tpm");
var $f9609ed505305e30$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $f9609ed505305e30$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === "undefined") _fetch = (0, $22Tpm.default);
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $f9609ed505305e30$export$3d2cf54f85b7fc8a = ()=>{
    if (typeof Headers === "undefined") return 0, $22Tpm.Headers;
    return Headers;
};
const $f9609ed505305e30$export$651dd5aef824521f = (supabaseKey, getAccessToken, customFetch)=>{
    const fetch1 = $f9609ed505305e30$export$98d92b1aa79f8cc7(customFetch);
    const HeadersConstructor = $f9609ed505305e30$export$3d2cf54f85b7fc8a();
    return (input, init)=>$f9609ed505305e30$var$__awaiter(void 0, void 0, void 0, function*() {
            var _a;
            const accessToken = (_a = yield getAccessToken()) !== null && _a !== void 0 ? _a : supabaseKey;
            let headers = new HeadersConstructor(init === null || init === void 0 ? void 0 : init.headers);
            if (!headers.has("apikey")) headers.set("apikey", supabaseKey);
            if (!headers.has("Authorization")) headers.set("Authorization", `Bearer ${accessToken}`);
            return fetch1(input, Object.assign(Object.assign({}, init), {
                headers: headers
            }));
        });
};


function $979ace8c9180b2e2$export$31b40729666a4ae0() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $979ace8c9180b2e2$export$d95b4586d238a081(url) {
    return url.replace(/\/$/, "");
}
const $979ace8c9180b2e2$export$4e09c449d6c407f7 = ()=>typeof window !== "undefined";
function $979ace8c9180b2e2$export$da186dc3f8eace71(options, defaults) {
    const { db: dbOptions, auth: authOptions, realtime: realtimeOptions, global: globalOptions } = options;
    const { db: DEFAULT_DB_OPTIONS, auth: DEFAULT_AUTH_OPTIONS, realtime: DEFAULT_REALTIME_OPTIONS, global: DEFAULT_GLOBAL_OPTIONS } = defaults;
    return {
        db: Object.assign(Object.assign({}, DEFAULT_DB_OPTIONS), dbOptions),
        auth: Object.assign(Object.assign({}, DEFAULT_AUTH_OPTIONS), authOptions),
        realtime: Object.assign(Object.assign({}, DEFAULT_REALTIME_OPTIONS), realtimeOptions),
        global: Object.assign(Object.assign({}, DEFAULT_GLOBAL_OPTIONS), globalOptions)
    };
}


function $61b424fb740c8c0b$export$e02d0a488392f690(expiresIn) {
    const timeNow = Math.round(Date.now() / 1000);
    return timeNow + expiresIn;
}
function $61b424fb740c8c0b$export$31b40729666a4ae0() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $61b424fb740c8c0b$export$4e09c449d6c407f7 = ()=>typeof document !== "undefined";
const $61b424fb740c8c0b$var$localStorageWriteTests = {
    tested: false,
    writable: false
};
const $61b424fb740c8c0b$export$9ec034ee80211814 = ()=>{
    if (!$61b424fb740c8c0b$export$4e09c449d6c407f7()) return false;
    try {
        if (typeof globalThis.localStorage !== "object") return false;
    } catch (e) {
        // DOM exception when accessing `localStorage`
        return false;
    }
    if ($61b424fb740c8c0b$var$localStorageWriteTests.tested) return $61b424fb740c8c0b$var$localStorageWriteTests.writable;
    const randomKey = `lswt-${Math.random()}${Math.random()}`;
    try {
        globalThis.localStorage.setItem(randomKey, randomKey);
        globalThis.localStorage.removeItem(randomKey);
        $61b424fb740c8c0b$var$localStorageWriteTests.tested = true;
        $61b424fb740c8c0b$var$localStorageWriteTests.writable = true;
    } catch (e) {
        // localStorage can't be written to
        // https://www.chromium.org/for-testers/bug-reporting-guidelines/uncaught-securityerror-failed-to-read-the-localstorage-property-from-window-access-is-denied-for-this-document
        $61b424fb740c8c0b$var$localStorageWriteTests.tested = true;
        $61b424fb740c8c0b$var$localStorageWriteTests.writable = false;
    }
    return $61b424fb740c8c0b$var$localStorageWriteTests.writable;
};
function $61b424fb740c8c0b$export$7a29392fb778224c(href) {
    const result = {};
    const url = new URL(href);
    if (url.hash && url.hash[0] === "#") try {
        const hashSearchParams = new URLSearchParams(url.hash.substring(1));
        hashSearchParams.forEach((value, key)=>{
            result[key] = value;
        });
    } catch (e) {
    // hash is not a query string
    }
    // search parameters take precedence over hash parameters
    url.searchParams.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}

const $61b424fb740c8c0b$export$98d92b1aa79f8cc7 = (customFetch)=>{
    let _fetch;
    if (customFetch) _fetch = customFetch;
    else if (typeof fetch === "undefined") _fetch = (...args)=>Promise.resolve((parcelRequire("22Tpm"))).then(({ default: fetch1 })=>fetch1(...args));
    else _fetch = fetch;
    return (...args)=>_fetch(...args);
};
const $61b424fb740c8c0b$export$e8ad6599be1036a7 = (maybeResponse)=>{
    return typeof maybeResponse === "object" && maybeResponse !== null && "status" in maybeResponse && "ok" in maybeResponse && "json" in maybeResponse && typeof maybeResponse.json === "function";
};
const $61b424fb740c8c0b$export$e82c36d29078a87f = async (storage, key, data)=>{
    await storage.setItem(key, JSON.stringify(data));
};
const $61b424fb740c8c0b$export$ba6fcb7c333d32c0 = async (storage, key)=>{
    const value = await storage.getItem(key);
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch (_a) {
        return value;
    }
};
const $61b424fb740c8c0b$export$d35c645d585317ec = async (storage, key)=>{
    await storage.removeItem(key);
};
function $61b424fb740c8c0b$export$f0d30a693d94f11c(value) {
    const key = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let base64 = "";
    let chr1, chr2, chr3;
    let enc1, enc2, enc3, enc4;
    let i = 0;
    value = value.replace("-", "+").replace("_", "/");
    while(i < value.length){
        enc1 = key.indexOf(value.charAt(i++));
        enc2 = key.indexOf(value.charAt(i++));
        enc3 = key.indexOf(value.charAt(i++));
        enc4 = key.indexOf(value.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        base64 = base64 + String.fromCharCode(chr1);
        if (enc3 != 64 && chr2 != 0) base64 = base64 + String.fromCharCode(chr2);
        if (enc4 != 64 && chr3 != 0) base64 = base64 + String.fromCharCode(chr3);
    }
    return base64;
}
class $61b424fb740c8c0b$export$85f6557964517f1a {
    constructor(){
        this.promise = new $61b424fb740c8c0b$export$85f6557964517f1a.promiseConstructor((res, rej)=>{
            this.resolve = res;
            this.reject = rej;
        });
    }
}
$61b424fb740c8c0b$export$85f6557964517f1a.promiseConstructor = Promise;
function $61b424fb740c8c0b$export$cc1c0b988f7b5577(token) {
    // Regex checks for base64url format
    const base64UrlRegex = /^([a-z0-9_-]{4})*($|[a-z0-9_-]{3}=?$|[a-z0-9_-]{2}(==)?$)$/i;
    const parts = token.split(".");
    if (parts.length !== 3) throw new Error("JWT is not valid: not a JWT structure");
    if (!base64UrlRegex.test(parts[1])) throw new Error("JWT is not valid: payload is not in base64url format");
    const base64Url = parts[1];
    return JSON.parse($61b424fb740c8c0b$export$f0d30a693d94f11c(base64Url));
}
async function $61b424fb740c8c0b$export$e772c8ff12451969(time) {
    return await new Promise((accept)=>{
        setTimeout(()=>accept(null), time);
    });
}
function $61b424fb740c8c0b$export$9e1b8e833f44ff21(fn, isRetryable) {
    const promise = new Promise((accept, reject)=>{
        (async ()=>{
            for(let attempt = 0; attempt < Infinity; attempt++)try {
                const result = await fn(attempt);
                if (!isRetryable(attempt, null, result)) {
                    accept(result);
                    return;
                }
            } catch (e) {
                if (!isRetryable(attempt, e)) {
                    reject(e);
                    return;
                }
            }
        })();
    });
    return promise;
}
function $61b424fb740c8c0b$var$dec2hex(dec) {
    return ("0" + dec.toString(16)).substr(-2);
}
function $61b424fb740c8c0b$export$b6c3b8498f152f15() {
    const verifierLength = 56;
    const array = new Uint32Array(verifierLength);
    if (typeof crypto === "undefined") {
        const charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        const charSetLen = charSet.length;
        let verifier = "";
        for(let i = 0; i < verifierLength; i++)verifier += charSet.charAt(Math.floor(Math.random() * charSetLen));
        return verifier;
    }
    crypto.getRandomValues(array);
    return Array.from(array, $61b424fb740c8c0b$var$dec2hex).join("");
}
async function $61b424fb740c8c0b$var$sha256(randomString) {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(randomString);
    const hash = await crypto.subtle.digest("SHA-256", encodedData);
    const bytes = new Uint8Array(hash);
    return Array.from(bytes).map((c)=>String.fromCharCode(c)).join("");
}
function $61b424fb740c8c0b$var$base64urlencode(str) {
    return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
async function $61b424fb740c8c0b$export$eb79e16bb8189148(verifier) {
    const hasCryptoSupport = typeof crypto !== "undefined" && typeof crypto.subtle !== "undefined" && typeof TextEncoder !== "undefined";
    if (!hasCryptoSupport) {
        console.warn("WebCrypto API is not supported. Code challenge method will default to use plain instead of sha256.");
        return verifier;
    }
    const hashed = await $61b424fb740c8c0b$var$sha256(verifier);
    return $61b424fb740c8c0b$var$base64urlencode(hashed);
}


class $ed750b1e7f729ff5$export$145273558d58e0ac extends Error {
    constructor(message, status){
        super(message);
        this.__isAuthError = true;
        this.name = "AuthError";
        this.status = status;
    }
}
function $ed750b1e7f729ff5$export$cde1786a482f9a1c(error) {
    return typeof error === "object" && error !== null && "__isAuthError" in error;
}
class $ed750b1e7f729ff5$export$45fde0b55b14f37b extends $ed750b1e7f729ff5$export$145273558d58e0ac {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
    constructor(message, status){
        super(message, status);
        this.name = "AuthApiError";
        this.status = status;
    }
}
function $ed750b1e7f729ff5$export$4fe744aeb810d543(error) {
    return $ed750b1e7f729ff5$export$cde1786a482f9a1c(error) && error.name === "AuthApiError";
}
class $ed750b1e7f729ff5$export$f7559805d4a50078 extends $ed750b1e7f729ff5$export$145273558d58e0ac {
    constructor(message, originalError){
        super(message);
        this.name = "AuthUnknownError";
        this.originalError = originalError;
    }
}
class $ed750b1e7f729ff5$export$823c745ae0673c5e extends $ed750b1e7f729ff5$export$145273558d58e0ac {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status
        };
    }
    constructor(message, name, status){
        super(message);
        this.name = name;
        this.status = status;
    }
}
class $ed750b1e7f729ff5$export$403b3fc0d3ad5f0c extends $ed750b1e7f729ff5$export$823c745ae0673c5e {
    constructor(){
        super("Auth session missing!", "AuthSessionMissingError", 400);
    }
}
class $ed750b1e7f729ff5$export$7e277b620449c1b4 extends $ed750b1e7f729ff5$export$823c745ae0673c5e {
    constructor(){
        super("Auth session or user missing", "AuthInvalidTokenResponseError", 500);
    }
}
class $ed750b1e7f729ff5$export$9ef583f0381b4cc extends $ed750b1e7f729ff5$export$823c745ae0673c5e {
    constructor(message){
        super(message, "AuthInvalidCredentialsError", 400);
    }
}
class $ed750b1e7f729ff5$export$bf5df8e043856ef5 extends $ed750b1e7f729ff5$export$823c745ae0673c5e {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
    constructor(message, details = null){
        super(message, "AuthImplicitGrantRedirectError", 500);
        this.details = null;
        this.details = details;
    }
}
class $ed750b1e7f729ff5$export$39583657eb2a7027 extends $ed750b1e7f729ff5$export$823c745ae0673c5e {
    toJSON() {
        return {
            name: this.name,
            message: this.message,
            status: this.status,
            details: this.details
        };
    }
    constructor(message, details = null){
        super(message, "AuthPKCEGrantCodeExchangeError", 500);
        this.details = null;
        this.details = details;
    }
}
class $ed750b1e7f729ff5$export$2423b763f68be1b4 extends $ed750b1e7f729ff5$export$823c745ae0673c5e {
    constructor(message, status){
        super(message, "AuthRetryableFetchError", status);
    }
}
function $ed750b1e7f729ff5$export$a77af358da5fb874(error) {
    return $ed750b1e7f729ff5$export$cde1786a482f9a1c(error) && error.name === "AuthRetryableFetchError";
}
class $ed750b1e7f729ff5$export$b034076aa04913a6 extends $ed750b1e7f729ff5$export$823c745ae0673c5e {
    constructor(message, status, reasons){
        super(message, "AuthWeakPasswordError", status);
        this.reasons = reasons;
    }
}
function $ed750b1e7f729ff5$export$dac36143fd8a46ef(error) {
    return $ed750b1e7f729ff5$export$cde1786a482f9a1c(error) && error.name === "AuthWeakPasswordError";
}


var $5d46668c284adf12$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5d46668c284adf12$var$_getErrorMessage = (err)=>err.msg || err.message || err.error_description || err.error || JSON.stringify(err);
const $5d46668c284adf12$var$NETWORK_ERROR_CODES = [
    502,
    503,
    504
];
async function $5d46668c284adf12$var$handleError(error) {
    if (!(0, $61b424fb740c8c0b$export$e8ad6599be1036a7)(error)) throw new (0, $ed750b1e7f729ff5$export$2423b763f68be1b4)($5d46668c284adf12$var$_getErrorMessage(error), 0);
    if ($5d46668c284adf12$var$NETWORK_ERROR_CODES.includes(error.status)) // status in 500...599 range - server had an error, request might be retryed.
    throw new (0, $ed750b1e7f729ff5$export$2423b763f68be1b4)($5d46668c284adf12$var$_getErrorMessage(error), error.status);
    let data;
    try {
        data = await error.json();
    } catch (e) {
        throw new (0, $ed750b1e7f729ff5$export$f7559805d4a50078)($5d46668c284adf12$var$_getErrorMessage(e), e);
    }
    if (typeof data === "object" && data && typeof data.weak_password === "object" && data.weak_password && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.reasons.reduce((a, i)=>a && typeof i === "string", true)) throw new (0, $ed750b1e7f729ff5$export$b034076aa04913a6)($5d46668c284adf12$var$_getErrorMessage(data), error.status, data.weak_password.reasons);
    throw new (0, $ed750b1e7f729ff5$export$45fde0b55b14f37b)($5d46668c284adf12$var$_getErrorMessage(data), error.status || 500);
}
const $5d46668c284adf12$var$_getRequestParams = (method, options, parameters, body)=>{
    const params = {
        method: method,
        headers: (options === null || options === void 0 ? void 0 : options.headers) || {}
    };
    if (method === "GET") return params;
    params.headers = Object.assign({
        "Content-Type": "application/json;charset=UTF-8"
    }, options === null || options === void 0 ? void 0 : options.headers);
    params.body = JSON.stringify(body);
    return Object.assign(Object.assign({}, params), parameters);
};
async function $5d46668c284adf12$export$8969b3850ca2cdfd(fetcher, method, url, options) {
    var _a;
    const headers = Object.assign({}, options === null || options === void 0 ? void 0 : options.headers);
    if (options === null || options === void 0 ? void 0 : options.jwt) headers["Authorization"] = `Bearer ${options.jwt}`;
    const qs = (_a = options === null || options === void 0 ? void 0 : options.query) !== null && _a !== void 0 ? _a : {};
    if (options === null || options === void 0 ? void 0 : options.redirectTo) qs["redirect_to"] = options.redirectTo;
    const queryString = Object.keys(qs).length ? "?" + new URLSearchParams(qs).toString() : "";
    const data = await $5d46668c284adf12$var$_handleRequest(fetcher, method, url + queryString, {
        headers: headers,
        noResolveJson: options === null || options === void 0 ? void 0 : options.noResolveJson
    }, {}, options === null || options === void 0 ? void 0 : options.body);
    return (options === null || options === void 0 ? void 0 : options.xform) ? options === null || options === void 0 ? void 0 : options.xform(data) : {
        data: Object.assign({}, data),
        error: null
    };
}
async function $5d46668c284adf12$var$_handleRequest(fetcher, method, url, options, parameters, body) {
    const requestParams = $5d46668c284adf12$var$_getRequestParams(method, options, parameters, body);
    let result;
    try {
        result = await fetcher(url, requestParams);
    } catch (e) {
        console.error(e);
        // fetch failed, likely due to a network or CORS error
        throw new (0, $ed750b1e7f729ff5$export$2423b763f68be1b4)($5d46668c284adf12$var$_getErrorMessage(e), 0);
    }
    if (!result.ok) await $5d46668c284adf12$var$handleError(result);
    if (options === null || options === void 0 ? void 0 : options.noResolveJson) return result;
    try {
        return await result.json();
    } catch (e) {
        await $5d46668c284adf12$var$handleError(e);
    }
}
function $5d46668c284adf12$export$273fe4673a018c2e(data) {
    var _a;
    let session = null;
    if ($5d46668c284adf12$var$hasSession(data)) {
        session = Object.assign({}, data);
        if (!data.expires_at) session.expires_at = (0, $61b424fb740c8c0b$export$e02d0a488392f690)(data.expires_in);
    }
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            session: session,
            user: user
        },
        error: null
    };
}
function $5d46668c284adf12$export$db83aade1c2922c7(data) {
    const response = $5d46668c284adf12$export$273fe4673a018c2e(data);
    if (!response.error && data.weak_password && typeof data.weak_password === "object" && Array.isArray(data.weak_password.reasons) && data.weak_password.reasons.length && data.weak_password.message && typeof data.weak_password.message === "string" && data.weak_password.reasons.reduce((a, i)=>a && typeof i === "string", true)) response.data.weak_password = data.weak_password;
    return response;
}
function $5d46668c284adf12$export$e20f488897843593(data) {
    var _a;
    const user = (_a = data.user) !== null && _a !== void 0 ? _a : data;
    return {
        data: {
            user: user
        },
        error: null
    };
}
function $5d46668c284adf12$export$b04785c46dcd8f8b(data) {
    return {
        data: data,
        error: null
    };
}
function $5d46668c284adf12$export$f5eaa950605b2146(data) {
    const { action_link: action_link, email_otp: email_otp, hashed_token: hashed_token, redirect_to: redirect_to, verification_type: verification_type } = data, rest = $5d46668c284adf12$var$__rest(data, [
        "action_link",
        "email_otp",
        "hashed_token",
        "redirect_to",
        "verification_type"
    ]);
    const properties = {
        action_link: action_link,
        email_otp: email_otp,
        hashed_token: hashed_token,
        redirect_to: redirect_to,
        verification_type: verification_type
    };
    const user = Object.assign({}, rest);
    return {
        data: {
            properties: properties,
            user: user
        },
        error: null
    };
}
function $5d46668c284adf12$export$7aed01df6e045e31(data) {
    return data;
}
/**
 * hasSession checks if the response object contains a valid session
 * @param data A response object
 * @returns true if a session is in the response
 */ function $5d46668c284adf12$var$hasSession(data) {
    return data.access_token && data.refresh_token && data.expires_in;
}




var $84c432169906c7b6$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $84c432169906c7b6$export$2e2bcd8739ae039 {
    /**
     * Removes a logged-in session.
     * @param jwt A valid, logged-in JWT.
     * @param scope The logout sope.
     */ async signOut(jwt, scope = "global") {
        try {
            await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/logout?scope=${scope}`, {
                headers: this.headers,
                jwt: jwt,
                noResolveJson: true
            });
            return {
                data: null,
                error: null
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends an invite link to an email address.
     * @param email The email address of the user.
     * @param options Additional options to be included when inviting.
     */ async inviteUserByEmail(email, options = {}) {
        try {
            return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/invite`, {
                body: {
                    email: email,
                    data: options.data
                },
                headers: this.headers,
                redirectTo: options.redirectTo,
                xform: (0, $5d46668c284adf12$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates email links and OTPs to be sent via a custom email provider.
     * @param email The user's email.
     * @param options.password User password. For signup only.
     * @param options.data Optional user metadata. For signup only.
     * @param options.redirectTo The redirect url which should be appended to the generated link
     */ async generateLink(params) {
        try {
            const { options: options } = params, rest = $84c432169906c7b6$var$__rest(params, [
                "options"
            ]);
            const body = Object.assign(Object.assign({}, rest), options);
            if ("newEmail" in rest) {
                // replace newEmail with new_email in request body
                body.new_email = rest === null || rest === void 0 ? void 0 : rest.newEmail;
                delete body["newEmail"];
            }
            return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/admin/generate_link`, {
                body: body,
                headers: this.headers,
                xform: (0, $5d46668c284adf12$export$f5eaa950605b2146),
                redirectTo: options === null || options === void 0 ? void 0 : options.redirectTo
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    properties: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    // User Admin API
    /**
     * Creates a new user.
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async createUser(attributes) {
        try {
            return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/admin/users`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $5d46668c284adf12$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get a list of users.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     * @param params An object which supports `page` and `perPage` as numbers, to alter the paginated results.
     */ async listUsers(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const pagination = {
                nextPage: null,
                lastPage: 0,
                total: 0
            };
            const response = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/admin/users`, {
                headers: this.headers,
                noResolveJson: true,
                query: {
                    page: (_b = (_a = params === null || params === void 0 ? void 0 : params.page) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "",
                    per_page: (_d = (_c = params === null || params === void 0 ? void 0 : params.perPage) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : ""
                },
                xform: (0, $5d46668c284adf12$export$7aed01df6e045e31)
            });
            if (response.error) throw response.error;
            const users = await response.json();
            const total = (_e = response.headers.get("x-total-count")) !== null && _e !== void 0 ? _e : 0;
            const links = (_g = (_f = response.headers.get("link")) === null || _f === void 0 ? void 0 : _f.split(",")) !== null && _g !== void 0 ? _g : [];
            if (links.length > 0) {
                links.forEach((link)=>{
                    const page = parseInt(link.split(";")[0].split("=")[1].substring(0, 1));
                    const rel = JSON.parse(link.split(";")[1].split("=")[1]);
                    pagination[`${rel}Page`] = page;
                });
                pagination.total = parseInt(total);
            }
            return {
                data: Object.assign(Object.assign({}, users), pagination),
                error: null
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    users: []
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Get user by id.
     *
     * @param uid The user's unique identifier
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async getUserById(uid) {
        try {
            return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/admin/users/${uid}`, {
                headers: this.headers,
                xform: (0, $5d46668c284adf12$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates the user data.
     *
     * @param attributes The data you want to update.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async updateUserById(uid, attributes) {
        try {
            return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "PUT", `${this.url}/admin/users/${uid}`, {
                body: attributes,
                headers: this.headers,
                xform: (0, $5d46668c284adf12$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Delete a user. Requires a `service_role` key.
     *
     * @param id The user id you want to remove.
     * @param shouldSoftDelete If true, then the user will be soft-deleted (setting `deleted_at` to the current timestamp and disabling their account while preserving their data) from the auth schema.
     * Defaults to false for backward compatibility.
     *
     * This function should only be called on a server. Never expose your `service_role` key in the browser.
     */ async deleteUser(id, shouldSoftDelete = false) {
        try {
            return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "DELETE", `${this.url}/admin/users/${id}`, {
                headers: this.headers,
                body: {
                    should_soft_delete: shouldSoftDelete
                },
                xform: (0, $5d46668c284adf12$export$e20f488897843593)
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    async _listFactors(params) {
        try {
            const { data: data, error: error } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/admin/users/${params.userId}/factors`, {
                headers: this.headers,
                xform: (factors)=>{
                    return {
                        data: {
                            factors: factors
                        },
                        error: null
                    };
                }
            });
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    async _deleteFactor(params) {
        try {
            const data = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "DELETE", `${this.url}/admin/users/${params.userId}/factors/${params.id}`, {
                headers: this.headers
            });
            return {
                data: data,
                error: null
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    constructor({ url: url = "", headers: headers = {}, fetch: fetch }){
        this.url = url;
        this.headers = headers;
        this.fetch = (0, $61b424fb740c8c0b$export$98d92b1aa79f8cc7)(fetch);
        this.mfa = {
            listFactors: this._listFactors.bind(this),
            deleteFactor: this._deleteFactor.bind(this)
        };
    }
}



// Generated by genversion.
const $8365389d8b4882a3$export$83d89fbfd8236492 = "0.0.0";


const $add40e847463bd8e$export$7fedf552187f0c3d = "http://localhost:9999";
const $add40e847463bd8e$export$86880b4b2e1a2384 = "supabase.auth.token";
const $add40e847463bd8e$export$2f9161bad044dacb = "";
const $add40e847463bd8e$export$88a84136db6a4b64 = {
    "X-Client-Info": `gotrue-js/${(0, $8365389d8b4882a3$export$83d89fbfd8236492)}`
};
const $add40e847463bd8e$export$7d4b3a66850dd9bd = 10; // in seconds
const $add40e847463bd8e$export$5615c708618ee858 = {
    MAX_RETRIES: 10,
    RETRY_INTERVAL: 2
};






const $7c8e26ffc62a7442$export$bba7b6c94612d04b = {
    getItem: (key)=>{
        if (!(0, $61b424fb740c8c0b$export$9ec034ee80211814)()) return null;
        return globalThis.localStorage.getItem(key);
    },
    setItem: (key, value)=>{
        if (!(0, $61b424fb740c8c0b$export$9ec034ee80211814)()) return;
        globalThis.localStorage.setItem(key, value);
    },
    removeItem: (key)=>{
        if (!(0, $61b424fb740c8c0b$export$9ec034ee80211814)()) return;
        globalThis.localStorage.removeItem(key);
    }
};
function $7c8e26ffc62a7442$export$d791f66d7e5710cf(store = {}) {
    return {
        getItem: (key)=>{
            return store[key] || null;
        },
        setItem: (key, value)=>{
            store[key] = value;
        },
        removeItem: (key)=>{
            delete store[key];
        }
    };
}


/**
 * https://mathiasbynens.be/notes/globalthis
 */ function $f7f5808dd5fa350e$export$ad067ce270531206() {
    if (typeof globalThis === "object") return;
    try {
        Object.defineProperty(Object.prototype, "__magic__", {
            get: function() {
                return this;
            },
            configurable: true
        });
        // @ts-expect-error 'Allow access to magic'
        __magic__.globalThis = __magic__;
        // @ts-expect-error 'Allow access to magic'
        delete Object.prototype.__magic__;
    } catch (e) {
        if (typeof self !== "undefined") // @ts-expect-error 'Allow access to globals'
        self.globalThis = self;
    }
}




const $f44b05b877efceaa$export$e368aba7747330f2 = {
    /**
     * @experimental
     */ debug: !!(globalThis && (0, $61b424fb740c8c0b$export$9ec034ee80211814)() && globalThis.localStorage && globalThis.localStorage.getItem("supabase.gotrue-js.locks.debug") === "true")
};
class $f44b05b877efceaa$export$23e9464cc010dff9 extends Error {
    constructor(message){
        super(message);
        this.isAcquireTimeout = true;
    }
}
class $f44b05b877efceaa$export$4aa56776043a4631 extends $f44b05b877efceaa$export$23e9464cc010dff9 {
}
async function $f44b05b877efceaa$export$f4ff21938fb7af3c(name, acquireTimeout, fn) {
    if ($f44b05b877efceaa$export$e368aba7747330f2.debug) console.log("@supabase/gotrue-js: navigatorLock: acquire lock", name, acquireTimeout);
    const abortController = new globalThis.AbortController();
    if (acquireTimeout > 0) setTimeout(()=>{
        abortController.abort();
        if ($f44b05b877efceaa$export$e368aba7747330f2.debug) console.log("@supabase/gotrue-js: navigatorLock acquire timed out", name);
    }, acquireTimeout);
    // MDN article: https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request
    return await globalThis.navigator.locks.request(name, acquireTimeout === 0 ? {
        mode: "exclusive",
        ifAvailable: true
    } : {
        mode: "exclusive",
        signal: abortController.signal
    }, async (lock)=>{
        if (lock) {
            if ($f44b05b877efceaa$export$e368aba7747330f2.debug) console.log("@supabase/gotrue-js: navigatorLock: acquired", name, lock.name);
            try {
                return await fn();
            } finally{
                if ($f44b05b877efceaa$export$e368aba7747330f2.debug) console.log("@supabase/gotrue-js: navigatorLock: released", name, lock.name);
            }
        } else if (acquireTimeout === 0) {
            if ($f44b05b877efceaa$export$e368aba7747330f2.debug) console.log("@supabase/gotrue-js: navigatorLock: not immediately available", name);
            throw new $f44b05b877efceaa$export$4aa56776043a4631(`Acquiring an exclusive Navigator LockManager lock "${name}" immediately failed`);
        } else {
            if ($f44b05b877efceaa$export$e368aba7747330f2.debug) try {
                const result = await globalThis.navigator.locks.query();
                console.log("@supabase/gotrue-js: Navigator LockManager state", JSON.stringify(result, null, "  "));
            } catch (e) {
                console.warn("@supabase/gotrue-js: Error when querying Navigator LockManager state", e);
            }
            // Browser is not following the Navigator LockManager spec, it
            // returned a null lock when we didn't use ifAvailable. So we can
            // pretend the lock is acquired in the name of backward compatibility
            // and user experience and just run the function.
            console.warn("@supabase/gotrue-js: Navigator LockManager returned a null lock when using #request without ifAvailable set to true, it appears this browser is not following the LockManager spec https://developer.mozilla.org/en-US/docs/Web/API/LockManager/request");
            return await fn();
        }
    });
}


(0, $f7f5808dd5fa350e$export$ad067ce270531206)(); // Make "globalThis" available
const $4bafa81c93278d71$var$DEFAULT_OPTIONS = {
    url: (0, $add40e847463bd8e$export$7fedf552187f0c3d),
    storageKey: (0, $add40e847463bd8e$export$86880b4b2e1a2384),
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    headers: (0, $add40e847463bd8e$export$88a84136db6a4b64),
    flowType: "implicit",
    debug: false
};
/** Current session will be checked for refresh at this interval. */ const $4bafa81c93278d71$var$AUTO_REFRESH_TICK_DURATION = 30000;
/**
 * A token refresh will be attempted this many ticks before the current session expires. */ const $4bafa81c93278d71$var$AUTO_REFRESH_TICK_THRESHOLD = 3;
async function $4bafa81c93278d71$var$lockNoOp(name, acquireTimeout, fn) {
    return await fn();
}
class $4bafa81c93278d71$export$2e2bcd8739ae039 {
    _debug(...args) {
        if (this.logDebugMessages) this.logger(`GoTrueClient@${this.instanceID} (${(0, $8365389d8b4882a3$export$83d89fbfd8236492)}) ${new Date().toISOString()}`, ...args);
        return this;
    }
    /**
     * Initializes the client session either from the url or from storage.
     * This method is automatically called when instantiating the client, but should also be called
     * manually when checking for an error from an auth redirect (oauth, magiclink, password recovery, etc).
     */ async initialize() {
        if (this.initializePromise) return await this.initializePromise;
        this.initializePromise = (async ()=>{
            return await this._acquireLock(-1, async ()=>{
                return await this._initialize();
            });
        })();
        return await this.initializePromise;
    }
    /**
     * IMPORTANT:
     * 1. Never throw in this method, as it is called from the constructor
     * 2. Never return a session from this method as it would be cached over
     *    the whole lifetime of the client
     */ async _initialize() {
        try {
            const isPKCEFlow = (0, $61b424fb740c8c0b$export$4e09c449d6c407f7)() ? await this._isPKCEFlow() : false;
            this._debug("#_initialize()", "begin", "is PKCE flow", isPKCEFlow);
            if (isPKCEFlow || this.detectSessionInUrl && this._isImplicitGrantFlow()) {
                const { data: data, error: error } = await this._getSessionFromURL(isPKCEFlow);
                if (error) {
                    this._debug("#_initialize()", "error detecting session from URL", error);
                    // hacky workaround to keep the existing session if there's an error returned from identity linking
                    // TODO: once error codes are ready, we should match against it instead of the message
                    if ((error === null || error === void 0 ? void 0 : error.message) === "Identity is already linked" || (error === null || error === void 0 ? void 0 : error.message) === "Identity is already linked to another user") return {
                        error: error
                    };
                    // failed login attempt via url,
                    // remove old session as in verifyOtp, signUp and signInWith*
                    await this._removeSession();
                    return {
                        error: error
                    };
                }
                const { session: session, redirectType: redirectType } = data;
                this._debug("#_initialize()", "detected session in URL", session, "redirect type", redirectType);
                await this._saveSession(session);
                setTimeout(async ()=>{
                    if (redirectType === "recovery") await this._notifyAllSubscribers("PASSWORD_RECOVERY", session);
                    else await this._notifyAllSubscribers("SIGNED_IN", session);
                }, 0);
                return {
                    error: null
                };
            }
            // no login attempt via callback url try to recover session from storage
            await this._recoverAndRefresh();
            return {
                error: null
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                error: error
            };
            return {
                error: new (0, $ed750b1e7f729ff5$export$f7559805d4a50078)("Unexpected error during initialization", error)
            };
        } finally{
            await this._handleVisibilityChange();
            this._debug("#_initialize()", "end");
        }
    }
    /**
     * Creates a new user.
     *
     * Be aware that if a user account exists in the system you may get back an
     * error message that attempts to hide this information from the user.
     * This method has support for PKCE via email signups. The PKCE flow cannot be used when autoconfirm is enabled.
     *
     * @returns A logged-in session if the server has "autoconfirm" ON
     * @returns A user if the server has "autoconfirm" OFF
     */ async signUp(credentials) {
        var _a, _b, _c;
        try {
            await this._removeSession();
            let res;
            if ("email" in credentials) {
                const { email: email, password: password, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === "pkce") {
                    const codeVerifier = (0, $61b424fb740c8c0b$export$b6c3b8498f152f15)();
                    await (0, $61b424fb740c8c0b$export$e82c36d29078a87f)(this.storage, `${this.storageKey}-code-verifier`, codeVerifier);
                    codeChallenge = await (0, $61b424fb740c8c0b$export$eb79e16bb8189148)(codeVerifier);
                    codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
                }
                res = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/signup`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: {
                        email: email,
                        password: password,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    xform: (0, $5d46668c284adf12$export$273fe4673a018c2e)
                });
            } else if ("phone" in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/signup`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        data: (_b = options === null || options === void 0 ? void 0 : options.data) !== null && _b !== void 0 ? _b : {},
                        channel: (_c = options === null || options === void 0 ? void 0 : options.channel) !== null && _c !== void 0 ? _c : "sms",
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $5d46668c284adf12$export$273fe4673a018c2e)
                });
            } else throw new (0, $ed750b1e7f729ff5$export$9ef583f0381b4cc)("You must provide either an email or phone number and a password");
            const { data: data, error: error } = res;
            if (error || !data) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            const session = data.session;
            const user = data.user;
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers("SIGNED_IN", session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user with an email and password or phone and password.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or that the
     * email/phone and password combination is wrong or that the account can only
     * be accessed via social login.
     */ async signInWithPassword(credentials) {
        try {
            await this._removeSession();
            let res;
            if ("email" in credentials) {
                const { email: email, password: password, options: options } = credentials;
                res = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $5d46668c284adf12$export$db83aade1c2922c7)
                });
            } else if ("phone" in credentials) {
                const { phone: phone, password: password, options: options } = credentials;
                res = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/token?grant_type=password`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        password: password,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    xform: (0, $5d46668c284adf12$export$db83aade1c2922c7)
                });
            } else throw new (0, $ed750b1e7f729ff5$export$9ef583f0381b4cc)("You must provide either an email or phone number and a password");
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $ed750b1e7f729ff5$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers("SIGNED_IN", data.session);
            }
            return {
                data: Object.assign({
                    user: data.user,
                    session: data.session
                }, data.weak_password ? {
                    weakPassword: data.weak_password
                } : null),
                error: error
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in an existing user via a third-party provider.
     * This method supports the PKCE flow.
     */ async signInWithOAuth(credentials) {
        var _a, _b, _c, _d;
        await this._removeSession();
        return await this._handleProviderSignIn(credentials.provider, {
            redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
            scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
            queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
            skipBrowserRedirect: (_d = credentials.options) === null || _d === void 0 ? void 0 : _d.skipBrowserRedirect
        });
    }
    /**
     * Log in an existing user by exchanging an Auth Code issued during the PKCE flow.
     */ async exchangeCodeForSession(authCode) {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._exchangeCodeForSession(authCode);
        });
    }
    async _exchangeCodeForSession(authCode) {
        const storageItem = await (0, $61b424fb740c8c0b$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        const [codeVerifier, redirectType] = (storageItem !== null && storageItem !== void 0 ? storageItem : "").split("/");
        const { data: data, error: error } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/token?grant_type=pkce`, {
            headers: this.headers,
            body: {
                auth_code: authCode,
                code_verifier: codeVerifier
            },
            xform: (0, $5d46668c284adf12$export$273fe4673a018c2e)
        });
        await (0, $61b424fb740c8c0b$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
        if (error) return {
            data: {
                user: null,
                session: null,
                redirectType: null
            },
            error: error
        };
        else if (!data || !data.session || !data.user) return {
            data: {
                user: null,
                session: null,
                redirectType: null
            },
            error: new (0, $ed750b1e7f729ff5$export$7e277b620449c1b4)()
        };
        if (data.session) {
            await this._saveSession(data.session);
            await this._notifyAllSubscribers("SIGNED_IN", data.session);
        }
        return {
            data: Object.assign(Object.assign({}, data), {
                redirectType: redirectType !== null && redirectType !== void 0 ? redirectType : null
            }),
            error: error
        };
    }
    /**
     * Allows signing in with an OIDC ID token. The authentication provider used
     * should be enabled and configured.
     */ async signInWithIdToken(credentials) {
        await this._removeSession();
        try {
            const { options: options, provider: provider, token: token, access_token: access_token, nonce: nonce } = credentials;
            const res = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/token?grant_type=id_token`, {
                headers: this.headers,
                body: {
                    provider: provider,
                    id_token: token,
                    access_token: access_token,
                    nonce: nonce,
                    gotrue_meta_security: {
                        captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                    }
                },
                xform: (0, $5d46668c284adf12$export$273fe4673a018c2e)
            });
            const { data: data, error: error } = res;
            if (error) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            else if (!data || !data.session || !data.user) return {
                data: {
                    user: null,
                    session: null
                },
                error: new (0, $ed750b1e7f729ff5$export$7e277b620449c1b4)()
            };
            if (data.session) {
                await this._saveSession(data.session);
                await this._notifyAllSubscribers("SIGNED_IN", data.session);
            }
            return {
                data: data,
                error: error
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user using magiclink or a one-time password (OTP).
     *
     * If the `{{ .ConfirmationURL }}` variable is specified in the email template, a magiclink will be sent.
     * If the `{{ .Token }}` variable is specified in the email template, an OTP will be sent.
     * If you're using phone sign-ins, only an OTP will be sent. You won't be able to send a magiclink for phone sign-ins.
     *
     * Be aware that you may get back an error message that will not distinguish
     * between the cases where the account does not exist or, that the account
     * can only be accessed via social login.
     *
     * Do note that you will need to configure a Whatsapp sender on Twilio
     * if you are using phone sign in with the 'whatsapp' channel. The whatsapp
     * channel is not supported on other providers
     * at this time.
     * This method supports PKCE when an email is passed.
     */ async signInWithOtp(credentials) {
        var _a, _b, _c, _d, _e;
        try {
            await this._removeSession();
            if ("email" in credentials) {
                const { email: email, options: options } = credentials;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === "pkce") {
                    const codeVerifier = (0, $61b424fb740c8c0b$export$b6c3b8498f152f15)();
                    await (0, $61b424fb740c8c0b$export$e82c36d29078a87f)(this.storage, `${this.storageKey}-code-verifier`, codeVerifier);
                    codeChallenge = await (0, $61b424fb740c8c0b$export$eb79e16bb8189148)(codeVerifier);
                    codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
                }
                const { error: error } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        email: email,
                        data: (_a = options === null || options === void 0 ? void 0 : options.data) !== null && _a !== void 0 ? _a : {},
                        create_user: (_b = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _b !== void 0 ? _b : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            }
            if ("phone" in credentials) {
                const { phone: phone, options: options } = credentials;
                const { data: data, error: error } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/otp`, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        data: (_c = options === null || options === void 0 ? void 0 : options.data) !== null && _c !== void 0 ? _c : {},
                        create_user: (_d = options === null || options === void 0 ? void 0 : options.shouldCreateUser) !== null && _d !== void 0 ? _d : true,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        },
                        channel: (_e = options === null || options === void 0 ? void 0 : options.channel) !== null && _e !== void 0 ? _e : "sms"
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $ed750b1e7f729ff5$export$9ef583f0381b4cc)("You must provide either an email or phone number.");
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Log in a user given a User supplied OTP or TokenHash received through mobile or email.
     */ async verifyOtp(params) {
        var _a, _b;
        try {
            if (params.type !== "email_change" && params.type !== "phone_change") // we don't want to remove the authenticated session if the user is performing an email_change or phone_change verification
            await this._removeSession();
            let redirectTo = undefined;
            let captchaToken = undefined;
            if ("options" in params) {
                redirectTo = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo;
                captchaToken = (_b = params.options) === null || _b === void 0 ? void 0 : _b.captchaToken;
            }
            const { data: data, error: error } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/verify`, {
                headers: this.headers,
                body: Object.assign(Object.assign({}, params), {
                    gotrue_meta_security: {
                        captcha_token: captchaToken
                    }
                }),
                redirectTo: redirectTo,
                xform: (0, $5d46668c284adf12$export$273fe4673a018c2e)
            });
            if (error) throw error;
            if (!data) throw new Error("An error occurred on token verification.");
            const session = data.session;
            const user = data.user;
            if (session === null || session === void 0 ? void 0 : session.access_token) {
                await this._saveSession(session);
                await this._notifyAllSubscribers(params.type == "recovery" ? "PASSWORD_RECOVERY" : "SIGNED_IN", session);
            }
            return {
                data: {
                    user: user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Attempts a single-sign on using an enterprise Identity Provider. A
     * successful SSO attempt will redirect the current page to the identity
     * provider authorization page. The redirect URL is implementation and SSO
     * protocol specific.
     *
     * You can use it by providing a SSO domain. Typically you can extract this
     * domain by asking users for their email address. If this domain is
     * registered on the Auth instance the redirect will use that organization's
     * currently active SSO Identity Provider for the login.
     *
     * If you have built an organization-specific login page, you can use the
     * organization's SSO Identity Provider UUID directly instead.
     */ async signInWithSSO(params) {
        var _a, _b, _c;
        try {
            await this._removeSession();
            let codeChallenge = null;
            let codeChallengeMethod = null;
            if (this.flowType === "pkce") {
                const codeVerifier = (0, $61b424fb740c8c0b$export$b6c3b8498f152f15)();
                await (0, $61b424fb740c8c0b$export$e82c36d29078a87f)(this.storage, `${this.storageKey}-code-verifier`, codeVerifier);
                codeChallenge = await (0, $61b424fb740c8c0b$export$eb79e16bb8189148)(codeVerifier);
                codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
            }
            return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/sso`, {
                body: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, "providerId" in params ? {
                    provider_id: params.providerId
                } : null), "domain" in params ? {
                    domain: params.domain
                } : null), {
                    redirect_to: (_b = (_a = params.options) === null || _a === void 0 ? void 0 : _a.redirectTo) !== null && _b !== void 0 ? _b : undefined
                }), ((_c = params === null || params === void 0 ? void 0 : params.options) === null || _c === void 0 ? void 0 : _c.captchaToken) ? {
                    gotrue_meta_security: {
                        captcha_token: params.options.captchaToken
                    }
                } : null), {
                    skip_http_redirect: true,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod
                }),
                headers: this.headers,
                xform: (0, $5d46668c284adf12$export$b04785c46dcd8f8b)
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Sends a reauthentication OTP to the user's email or phone number.
     * Requires the user to be signed-in.
     */ async reauthenticate() {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._reauthenticate();
        });
    }
    async _reauthenticate() {
        try {
            return await this._useSession(async (result)=>{
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!session) throw new (0, $ed750b1e7f729ff5$export$403b3fc0d3ad5f0c)();
                const { error: error } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/reauthenticate`, {
                    headers: this.headers,
                    jwt: session.access_token
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Resends an existing signup confirmation email, email change email, SMS OTP or phone change OTP.
     */ async resend(credentials) {
        try {
            if (credentials.type != "email_change" && credentials.type != "phone_change") await this._removeSession();
            const endpoint = `${this.url}/resend`;
            if ("email" in credentials) {
                const { email: email, type: type, options: options } = credentials;
                const { error: error } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", endpoint, {
                    headers: this.headers,
                    body: {
                        email: email,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    },
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo
                });
                return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
            } else if ("phone" in credentials) {
                const { phone: phone, type: type, options: options } = credentials;
                const { data: data, error: error } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", endpoint, {
                    headers: this.headers,
                    body: {
                        phone: phone,
                        type: type,
                        gotrue_meta_security: {
                            captcha_token: options === null || options === void 0 ? void 0 : options.captchaToken
                        }
                    }
                });
                return {
                    data: {
                        user: null,
                        session: null,
                        messageId: data === null || data === void 0 ? void 0 : data.message_id
                    },
                    error: error
                };
            }
            throw new (0, $ed750b1e7f729ff5$export$9ef583f0381b4cc)("You must provide either an email or phone number and a type");
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns the session, refreshing it if necessary.
     * The session returned can be null if the session is not detected which can happen in the event a user is not signed-in or has logged out.
     */ async getSession() {
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return this._useSession(async (result)=>{
                return result;
            });
        });
    }
    /**
     * Acquires a global lock based on the storage key.
     */ async _acquireLock(acquireTimeout, fn) {
        this._debug("#_acquireLock", "begin", acquireTimeout);
        try {
            if (this.lockAcquired) {
                const last = this.pendingInLock.length ? this.pendingInLock[this.pendingInLock.length - 1] : Promise.resolve();
                const result = (async ()=>{
                    await last;
                    return await fn();
                })();
                this.pendingInLock.push((async ()=>{
                    try {
                        await result;
                    } catch (e) {
                    // we just care if it finished
                    }
                })());
                return result;
            }
            return await this.lock(`lock:${this.storageKey}`, acquireTimeout, async ()=>{
                this._debug("#_acquireLock", "lock acquired for storage key", this.storageKey);
                try {
                    this.lockAcquired = true;
                    const result = fn();
                    this.pendingInLock.push((async ()=>{
                        try {
                            await result;
                        } catch (e) {
                        // we just care if it finished
                        }
                    })());
                    await result;
                    // keep draining the queue until there's nothing to wait on
                    while(this.pendingInLock.length){
                        const waitOn = [
                            ...this.pendingInLock
                        ];
                        await Promise.all(waitOn);
                        this.pendingInLock.splice(0, waitOn.length);
                    }
                    return await result;
                } finally{
                    this._debug("#_acquireLock", "lock released for storage key", this.storageKey);
                    this.lockAcquired = false;
                }
            });
        } finally{
            this._debug("#_acquireLock", "end");
        }
    }
    /**
     * Use instead of {@link #getSession} inside the library. It is
     * semantically usually what you want, as getting a session involves some
     * processing afterwards that requires only one client operating on the
     * session at once across multiple tabs or processes.
     */ async _useSession(fn) {
        this._debug("#_useSession", "begin");
        try {
            // the use of __loadSession here is the only correct use of the function!
            const result = await this.__loadSession();
            return await fn(result);
        } finally{
            this._debug("#_useSession", "end");
        }
    }
    /**
     * NEVER USE DIRECTLY!
     *
     * Always use {@link #_useSession}.
     */ async __loadSession() {
        this._debug("#__loadSession()", "begin");
        if (!this.lockAcquired) this._debug("#__loadSession()", "used outside of an acquired lock!", new Error().stack);
        try {
            let currentSession = null;
            const maybeSession = await (0, $61b424fb740c8c0b$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug("#getSession()", "session from storage", maybeSession);
            if (maybeSession !== null) {
                if (this._isValidSession(maybeSession)) currentSession = maybeSession;
                else {
                    this._debug("#getSession()", "session from storage is not valid");
                    await this._removeSession();
                }
            }
            if (!currentSession) return {
                data: {
                    session: null
                },
                error: null
            };
            const hasExpired = currentSession.expires_at ? currentSession.expires_at <= Date.now() / 1000 : false;
            this._debug("#__loadSession()", `session has${hasExpired ? "" : " not"} expired`, "expires_at", currentSession.expires_at);
            if (!hasExpired) return {
                data: {
                    session: currentSession
                },
                error: null
            };
            const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
            if (error) return {
                data: {
                    session: null
                },
                error: error
            };
            return {
                data: {
                    session: session
                },
                error: null
            };
        } finally{
            this._debug("#__loadSession()", "end");
        }
    }
    /**
     * Gets the current user details if there is an existing session.
     * @param jwt Takes in an optional access token jwt. If no jwt is provided, getUser() will attempt to get the jwt from the current session.
     */ async getUser(jwt) {
        if (jwt) return await this._getUser(jwt);
        await this.initializePromise;
        return this._acquireLock(-1, async ()=>{
            return await this._getUser();
        });
    }
    async _getUser(jwt) {
        try {
            if (jwt) return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/user`, {
                headers: this.headers,
                jwt: jwt,
                xform: (0, $5d46668c284adf12$export$e20f488897843593)
            });
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "GET", `${this.url}/user`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined,
                    xform: (0, $5d46668c284adf12$export$e20f488897843593)
                });
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Updates user data for a logged in user.
     */ async updateUser(attributes, options = {}) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._updateUser(attributes, options);
        });
    }
    async _updateUser(attributes, options = {}) {
        try {
            return await this._useSession(async (result)=>{
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) throw sessionError;
                if (!sessionData.session) throw new (0, $ed750b1e7f729ff5$export$403b3fc0d3ad5f0c)();
                const session = sessionData.session;
                let codeChallenge = null;
                let codeChallengeMethod = null;
                if (this.flowType === "pkce" && attributes.email != null) {
                    const codeVerifier = (0, $61b424fb740c8c0b$export$b6c3b8498f152f15)();
                    await (0, $61b424fb740c8c0b$export$e82c36d29078a87f)(this.storage, `${this.storageKey}-code-verifier`, codeVerifier);
                    codeChallenge = await (0, $61b424fb740c8c0b$export$eb79e16bb8189148)(codeVerifier);
                    codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
                }
                const { data: data, error: userError } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "PUT", `${this.url}/user`, {
                    headers: this.headers,
                    redirectTo: options === null || options === void 0 ? void 0 : options.emailRedirectTo,
                    body: Object.assign(Object.assign({}, attributes), {
                        code_challenge: codeChallenge,
                        code_challenge_method: codeChallengeMethod
                    }),
                    jwt: session.access_token,
                    xform: (0, $5d46668c284adf12$export$e20f488897843593)
                });
                if (userError) throw userError;
                session.user = data.user;
                await this._saveSession(session);
                await this._notifyAllSubscribers("USER_UPDATED", session);
                return {
                    data: {
                        user: session.user
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Decodes a JWT (without performing any validation).
     */ _decodeJWT(jwt) {
        return (0, $61b424fb740c8c0b$export$cc1c0b988f7b5577)(jwt);
    }
    /**
     * Sets the session data from the current session. If the current session is expired, setSession will take care of refreshing it to obtain a new session.
     * If the refresh token or access token in the current session is invalid, an error will be thrown.
     * @param currentSession The current session that minimally contains an access token and refresh token.
     */ async setSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._setSession(currentSession);
        });
    }
    async _setSession(currentSession) {
        try {
            if (!currentSession.access_token || !currentSession.refresh_token) throw new (0, $ed750b1e7f729ff5$export$403b3fc0d3ad5f0c)();
            const timeNow = Date.now() / 1000;
            let expiresAt = timeNow;
            let hasExpired = true;
            let session = null;
            const payload = (0, $61b424fb740c8c0b$export$cc1c0b988f7b5577)(currentSession.access_token);
            if (payload.exp) {
                expiresAt = payload.exp;
                hasExpired = expiresAt <= timeNow;
            }
            if (hasExpired) {
                const { session: refreshedSession, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!refreshedSession) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                session = refreshedSession;
            } else {
                const { data: data, error: error } = await this._getUser(currentSession.access_token);
                if (error) throw error;
                session = {
                    access_token: currentSession.access_token,
                    refresh_token: currentSession.refresh_token,
                    user: data.user,
                    token_type: "bearer",
                    expires_in: expiresAt - timeNow,
                    expires_at: expiresAt
                };
                await this._saveSession(session);
                await this._notifyAllSubscribers("SIGNED_IN", session);
            }
            return {
                data: {
                    user: session.user,
                    session: session
                },
                error: null
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Returns a new session, regardless of expiry status.
     * Takes in an optional current session. If not passed in, then refreshSession() will attempt to retrieve it from getSession().
     * If the current session's refresh token is invalid, an error will be thrown.
     * @param currentSession The current session. If passed in, it must contain a refresh token.
     */ async refreshSession(currentSession) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._refreshSession(currentSession);
        });
    }
    async _refreshSession(currentSession) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                if (!currentSession) {
                    const { data: data, error: error } = result;
                    if (error) throw error;
                    currentSession = (_a = data.session) !== null && _a !== void 0 ? _a : undefined;
                }
                if (!(currentSession === null || currentSession === void 0 ? void 0 : currentSession.refresh_token)) throw new (0, $ed750b1e7f729ff5$export$403b3fc0d3ad5f0c)();
                const { session: session, error: error } = await this._callRefreshToken(currentSession.refresh_token);
                if (error) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: error
                };
                if (!session) return {
                    data: {
                        user: null,
                        session: null
                    },
                    error: null
                };
                return {
                    data: {
                        user: session.user,
                        session: session
                    },
                    error: null
                };
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    user: null,
                    session: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets the session data from a URL string
     */ async _getSessionFromURL(isPKCEFlow) {
        try {
            if (!(0, $61b424fb740c8c0b$export$4e09c449d6c407f7)()) throw new (0, $ed750b1e7f729ff5$export$bf5df8e043856ef5)("No browser detected.");
            if (this.flowType === "implicit" && !this._isImplicitGrantFlow()) throw new (0, $ed750b1e7f729ff5$export$bf5df8e043856ef5)("Not a valid implicit grant flow url.");
            else if (this.flowType == "pkce" && !isPKCEFlow) throw new (0, $ed750b1e7f729ff5$export$39583657eb2a7027)("Not a valid PKCE flow url.");
            const params = (0, $61b424fb740c8c0b$export$7a29392fb778224c)(window.location.href);
            if (isPKCEFlow) {
                if (!params.code) throw new (0, $ed750b1e7f729ff5$export$39583657eb2a7027)("No code detected.");
                const { data: data, error: error } = await this._exchangeCodeForSession(params.code);
                if (error) throw error;
                const url = new URL(window.location.href);
                url.searchParams.delete("code");
                window.history.replaceState(window.history.state, "", url.toString());
                return {
                    data: {
                        session: data.session,
                        redirectType: null
                    },
                    error: null
                };
            }
            if (params.error || params.error_description || params.error_code) throw new (0, $ed750b1e7f729ff5$export$bf5df8e043856ef5)(params.error_description || "Error in URL with unspecified error_description", {
                error: params.error || "unspecified_error",
                code: params.error_code || "unspecified_code"
            });
            const { provider_token: provider_token, provider_refresh_token: provider_refresh_token, access_token: access_token, refresh_token: refresh_token, expires_in: expires_in, expires_at: expires_at, token_type: token_type } = params;
            if (!access_token || !expires_in || !refresh_token || !token_type) throw new (0, $ed750b1e7f729ff5$export$bf5df8e043856ef5)("No session defined in URL");
            const timeNow = Math.round(Date.now() / 1000);
            const expiresIn = parseInt(expires_in);
            let expiresAt = timeNow + expiresIn;
            if (expires_at) expiresAt = parseInt(expires_at);
            const actuallyExpiresIn = expiresAt - timeNow;
            if (actuallyExpiresIn * 1000 <= $4bafa81c93278d71$var$AUTO_REFRESH_TICK_DURATION) console.warn(`@supabase/gotrue-js: Session as retrieved from URL expires in ${actuallyExpiresIn}s, should have been closer to ${expiresIn}s`);
            const issuedAt = expiresAt - expiresIn;
            if (timeNow - issuedAt >= 120) console.warn("@supabase/gotrue-js: Session as retrieved from URL was issued over 120s ago, URL could be stale", issuedAt, expiresAt, timeNow);
            else if (timeNow - issuedAt < 0) console.warn("@supabase/gotrue-js: Session as retrieved from URL was issued in the future? Check the device clok for skew", issuedAt, expiresAt, timeNow);
            const { data: data, error: error } = await this._getUser(access_token);
            if (error) throw error;
            const session = {
                provider_token: provider_token,
                provider_refresh_token: provider_refresh_token,
                access_token: access_token,
                expires_in: expiresIn,
                expires_at: expiresAt,
                refresh_token: refresh_token,
                token_type: token_type,
                user: data.user
            };
            // Remove tokens from URL
            window.location.hash = "";
            this._debug("#_getSessionFromURL()", "clearing window.location.hash");
            return {
                data: {
                    session: session,
                    redirectType: params.type
                },
                error: null
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    redirectType: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Checks if the current URL contains parameters given by an implicit oauth grant flow (https://www.rfc-editor.org/rfc/rfc6749.html#section-4.2)
     */ _isImplicitGrantFlow() {
        const params = (0, $61b424fb740c8c0b$export$7a29392fb778224c)(window.location.href);
        return !!((0, $61b424fb740c8c0b$export$4e09c449d6c407f7)() && (params.access_token || params.error_description));
    }
    /**
     * Checks if the current URL and backing storage contain parameters given by a PKCE flow
     */ async _isPKCEFlow() {
        const params = (0, $61b424fb740c8c0b$export$7a29392fb778224c)(window.location.href);
        const currentStorageContent = await (0, $61b424fb740c8c0b$export$ba6fcb7c333d32c0)(this.storage, `${this.storageKey}-code-verifier`);
        return !!(params.code && currentStorageContent);
    }
    /**
     * Inside a browser context, `signOut()` will remove the logged in user from the browser session and log them out - removing all items from localstorage and then trigger a `"SIGNED_OUT"` event.
     *
     * For server-side management, you can revoke all refresh tokens for a user by passing a user's JWT through to `auth.api.signOut(JWT: string)`.
     * There is no way to revoke a user's access token jwt until it expires. It is recommended to set a shorter expiry on the jwt for this reason.
     *
     * If using `others` scope, no `SIGNED_OUT` event is fired!
     */ async signOut(options = {
        scope: "global"
    }) {
        await this.initializePromise;
        return await this._acquireLock(-1, async ()=>{
            return await this._signOut(options);
        });
    }
    async _signOut({ scope: scope } = {
        scope: "global"
    }) {
        return await this._useSession(async (result)=>{
            var _a;
            const { data: data, error: sessionError } = result;
            if (sessionError) return {
                error: sessionError
            };
            const accessToken = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token;
            if (accessToken) {
                const { error: error } = await this.admin.signOut(accessToken, scope);
                if (error) {
                    // ignore 404s since user might not exist anymore
                    // ignore 401s since an invalid or expired JWT should sign out the current session
                    if (!((0, $ed750b1e7f729ff5$export$4fe744aeb810d543)(error) && (error.status === 404 || error.status === 401))) return {
                        error: error
                    };
                }
            }
            if (scope !== "others") {
                await this._removeSession();
                await (0, $61b424fb740c8c0b$export$d35c645d585317ec)(this.storage, `${this.storageKey}-code-verifier`);
                await this._notifyAllSubscribers("SIGNED_OUT", null);
            }
            return {
                error: null
            };
        });
    }
    /**
     * Receive a notification every time an auth event happens.
     * @param callback A callback function to be invoked when an auth event happens.
     */ onAuthStateChange(callback) {
        const id = (0, $61b424fb740c8c0b$export$31b40729666a4ae0)();
        const subscription = {
            id: id,
            callback: callback,
            unsubscribe: ()=>{
                this._debug("#unsubscribe()", "state change callback with id removed", id);
                this.stateChangeEmitters.delete(id);
            }
        };
        this._debug("#onAuthStateChange()", "registered callback with id", id);
        this.stateChangeEmitters.set(id, subscription);
        (async ()=>{
            await this.initializePromise;
            await this._acquireLock(-1, async ()=>{
                this._emitInitialSession(id);
            });
        })();
        return {
            data: {
                subscription: subscription
            }
        };
    }
    async _emitInitialSession(id) {
        return await this._useSession(async (result)=>{
            var _a, _b;
            try {
                const { data: { session: session }, error: error } = result;
                if (error) throw error;
                await ((_a = this.stateChangeEmitters.get(id)) === null || _a === void 0 ? void 0 : _a.callback("INITIAL_SESSION", session));
                this._debug("INITIAL_SESSION", "callback id", id, "session", session);
            } catch (err) {
                await ((_b = this.stateChangeEmitters.get(id)) === null || _b === void 0 ? void 0 : _b.callback("INITIAL_SESSION", null));
                this._debug("INITIAL_SESSION", "callback id", id, "error", err);
                console.error(err);
            }
        });
    }
    /**
     * Sends a password reset request to an email address. This method supports the PKCE flow.
     *
     * @param email The email address of the user.
     * @param options.redirectTo The URL to send the user to after they click the password reset link.
     * @param options.captchaToken Verification token received when the user completes the captcha on the site.
     */ async resetPasswordForEmail(email, options = {}) {
        let codeChallenge = null;
        let codeChallengeMethod = null;
        if (this.flowType === "pkce") {
            const codeVerifier = (0, $61b424fb740c8c0b$export$b6c3b8498f152f15)();
            await (0, $61b424fb740c8c0b$export$e82c36d29078a87f)(this.storage, `${this.storageKey}-code-verifier`, `${codeVerifier}/PASSWORD_RECOVERY`);
            codeChallenge = await (0, $61b424fb740c8c0b$export$eb79e16bb8189148)(codeVerifier);
            codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
        }
        try {
            return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/recover`, {
                body: {
                    email: email,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                    gotrue_meta_security: {
                        captcha_token: options.captchaToken
                    }
                },
                headers: this.headers,
                redirectTo: options.redirectTo
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Gets all the identities linked to a user.
     */ async getUserIdentities() {
        var _a;
        try {
            const { data: data, error: error } = await this.getUser();
            if (error) throw error;
            return {
                data: {
                    identities: (_a = data.user.identities) !== null && _a !== void 0 ? _a : []
                },
                error: null
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Links an oauth identity to an existing user.
     * This method supports the PKCE flow.
     */ async linkIdentity(credentials) {
        var _a;
        try {
            const { data: data, error: error } = await this._useSession(async (result)=>{
                var _a, _b, _c, _d, _e;
                const { data: data, error: error } = result;
                if (error) throw error;
                const url = await this._getUrlForProvider(`${this.url}/user/identities/authorize`, credentials.provider, {
                    redirectTo: (_a = credentials.options) === null || _a === void 0 ? void 0 : _a.redirectTo,
                    scopes: (_b = credentials.options) === null || _b === void 0 ? void 0 : _b.scopes,
                    queryParams: (_c = credentials.options) === null || _c === void 0 ? void 0 : _c.queryParams,
                    skipBrowserRedirect: true
                });
                return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "GET", url, {
                    headers: this.headers,
                    jwt: (_e = (_d = data.session) === null || _d === void 0 ? void 0 : _d.access_token) !== null && _e !== void 0 ? _e : undefined
                });
            });
            if (error) throw error;
            if ((0, $61b424fb740c8c0b$export$4e09c449d6c407f7)() && !((_a = credentials.options) === null || _a === void 0 ? void 0 : _a.skipBrowserRedirect)) window.location.assign(data === null || data === void 0 ? void 0 : data.url);
            return {
                data: {
                    provider: credentials.provider,
                    url: data === null || data === void 0 ? void 0 : data.url
                },
                error: null
            };
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    provider: credentials.provider,
                    url: null
                },
                error: error
            };
            throw error;
        }
    }
    /**
     * Unlinks an identity from a user by deleting it. The user will no longer be able to sign in with that identity once it's unlinked.
     */ async unlinkIdentity(identity) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: data, error: error } = result;
                if (error) throw error;
                return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "DELETE", `${this.url}/user/identities/${identity.identity_id}`, {
                    headers: this.headers,
                    jwt: (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : undefined
                });
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * Generates a new JWT.
     * @param refreshToken A valid refresh token that was returned on login.
     */ async _refreshAccessToken(refreshToken) {
        const debugName = `#_refreshAccessToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, "begin");
        try {
            const startedAt = Date.now();
            // will attempt to refresh the token with exponential backoff
            return await (0, $61b424fb740c8c0b$export$9e1b8e833f44ff21)(async (attempt)=>{
                await (0, $61b424fb740c8c0b$export$e772c8ff12451969)(attempt * 200); // 0, 200, 400, 800, ...
                this._debug(debugName, "refreshing attempt", attempt);
                return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/token?grant_type=refresh_token`, {
                    body: {
                        refresh_token: refreshToken
                    },
                    headers: this.headers,
                    xform: (0, $5d46668c284adf12$export$273fe4673a018c2e)
                });
            }, (attempt, _, result)=>result && result.error && (0, $ed750b1e7f729ff5$export$a77af358da5fb874)(result.error) && // retryable only if the request can be sent before the backoff overflows the tick duration
                Date.now() + (attempt + 1) * 200 - startedAt < $4bafa81c93278d71$var$AUTO_REFRESH_TICK_DURATION);
        } catch (error) {
            this._debug(debugName, "error", error);
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: {
                    session: null,
                    user: null
                },
                error: error
            };
            throw error;
        } finally{
            this._debug(debugName, "end");
        }
    }
    _isValidSession(maybeSession) {
        const isValidSession = typeof maybeSession === "object" && maybeSession !== null && "access_token" in maybeSession && "refresh_token" in maybeSession && "expires_at" in maybeSession;
        return isValidSession;
    }
    async _handleProviderSignIn(provider, options) {
        const url = await this._getUrlForProvider(`${this.url}/authorize`, provider, {
            redirectTo: options.redirectTo,
            scopes: options.scopes,
            queryParams: options.queryParams
        });
        this._debug("#_handleProviderSignIn()", "provider", provider, "options", options, "url", url);
        // try to open on the browser
        if ((0, $61b424fb740c8c0b$export$4e09c449d6c407f7)() && !options.skipBrowserRedirect) window.location.assign(url);
        return {
            data: {
                provider: provider,
                url: url
            },
            error: null
        };
    }
    /**
     * Recovers the session from LocalStorage and refreshes
     * Note: this method is async to accommodate for AsyncStorage e.g. in React native.
     */ async _recoverAndRefresh() {
        var _a;
        const debugName = "#_recoverAndRefresh()";
        this._debug(debugName, "begin");
        try {
            const currentSession = await (0, $61b424fb740c8c0b$export$ba6fcb7c333d32c0)(this.storage, this.storageKey);
            this._debug(debugName, "session from storage", currentSession);
            if (!this._isValidSession(currentSession)) {
                this._debug(debugName, "session is not valid");
                if (currentSession !== null) await this._removeSession();
                return;
            }
            const timeNow = Math.round(Date.now() / 1000);
            const expiresWithMargin = ((_a = currentSession.expires_at) !== null && _a !== void 0 ? _a : Infinity) < timeNow + (0, $add40e847463bd8e$export$7d4b3a66850dd9bd);
            this._debug(debugName, `session has${expiresWithMargin ? "" : " not"} expired with margin of ${(0, $add40e847463bd8e$export$7d4b3a66850dd9bd)}s`);
            if (expiresWithMargin) {
                if (this.autoRefreshToken && currentSession.refresh_token) {
                    const { error: error } = await this._callRefreshToken(currentSession.refresh_token);
                    if (error) {
                        console.error(error);
                        if (!(0, $ed750b1e7f729ff5$export$a77af358da5fb874)(error)) {
                            this._debug(debugName, "refresh failed with a non-retryable error, removing the session", error);
                            await this._removeSession();
                        }
                    }
                }
            } else // no need to persist currentSession again, as we just loaded it from
            // local storage; persisting it again may overwrite a value saved by
            // another client with access to the same local storage
            await this._notifyAllSubscribers("SIGNED_IN", currentSession);
        } catch (err) {
            this._debug(debugName, "error", err);
            console.error(err);
            return;
        } finally{
            this._debug(debugName, "end");
        }
    }
    async _callRefreshToken(refreshToken) {
        var _a, _b;
        if (!refreshToken) throw new (0, $ed750b1e7f729ff5$export$403b3fc0d3ad5f0c)();
        // refreshing is already in progress
        if (this.refreshingDeferred) return this.refreshingDeferred.promise;
        const debugName = `#_callRefreshToken(${refreshToken.substring(0, 5)}...)`;
        this._debug(debugName, "begin");
        try {
            this.refreshingDeferred = new (0, $61b424fb740c8c0b$export$85f6557964517f1a)();
            const { data: data, error: error } = await this._refreshAccessToken(refreshToken);
            if (error) throw error;
            if (!data.session) throw new (0, $ed750b1e7f729ff5$export$403b3fc0d3ad5f0c)();
            await this._saveSession(data.session);
            await this._notifyAllSubscribers("TOKEN_REFRESHED", data.session);
            const result = {
                session: data.session,
                error: null
            };
            this.refreshingDeferred.resolve(result);
            return result;
        } catch (error) {
            this._debug(debugName, "error", error);
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) {
                const result = {
                    session: null,
                    error: error
                };
                if (!(0, $ed750b1e7f729ff5$export$a77af358da5fb874)(error)) {
                    await this._removeSession();
                    await this._notifyAllSubscribers("SIGNED_OUT", null);
                }
                (_a = this.refreshingDeferred) === null || _a === void 0 || _a.resolve(result);
                return result;
            }
            (_b = this.refreshingDeferred) === null || _b === void 0 || _b.reject(error);
            throw error;
        } finally{
            this.refreshingDeferred = null;
            this._debug(debugName, "end");
        }
    }
    async _notifyAllSubscribers(event, session, broadcast = true) {
        const debugName = `#_notifyAllSubscribers(${event})`;
        this._debug(debugName, "begin", session, `broadcast = ${broadcast}`);
        try {
            if (this.broadcastChannel && broadcast) this.broadcastChannel.postMessage({
                event: event,
                session: session
            });
            const errors = [];
            const promises = Array.from(this.stateChangeEmitters.values()).map(async (x)=>{
                try {
                    await x.callback(event, session);
                } catch (e) {
                    errors.push(e);
                }
            });
            await Promise.all(promises);
            if (errors.length > 0) {
                for(let i = 0; i < errors.length; i += 1)console.error(errors[i]);
                throw errors[0];
            }
        } finally{
            this._debug(debugName, "end");
        }
    }
    /**
     * set currentSession and currentUser
     * process to _startAutoRefreshToken if possible
     */ async _saveSession(session) {
        this._debug("#_saveSession()", session);
        await (0, $61b424fb740c8c0b$export$e82c36d29078a87f)(this.storage, this.storageKey, session);
    }
    async _removeSession() {
        this._debug("#_removeSession()");
        await (0, $61b424fb740c8c0b$export$d35c645d585317ec)(this.storage, this.storageKey);
    }
    /**
     * Removes any registered visibilitychange callback.
     *
     * {@see #startAutoRefresh}
     * {@see #stopAutoRefresh}
     */ _removeVisibilityChangedCallback() {
        this._debug("#_removeVisibilityChangedCallback()");
        const callback = this.visibilityChangedCallback;
        this.visibilityChangedCallback = null;
        try {
            if (callback && (0, $61b424fb740c8c0b$export$4e09c449d6c407f7)() && (window === null || window === void 0 ? void 0 : window.removeEventListener)) window.removeEventListener("visibilitychange", callback);
        } catch (e) {
            console.error("removing visibilitychange callback failed", e);
        }
    }
    /**
     * This is the private implementation of {@link #startAutoRefresh}. Use this
     * within the library.
     */ async _startAutoRefresh() {
        await this._stopAutoRefresh();
        this._debug("#_startAutoRefresh()");
        const ticker = setInterval(()=>this._autoRefreshTokenTick(), $4bafa81c93278d71$var$AUTO_REFRESH_TICK_DURATION);
        this.autoRefreshTicker = ticker;
        if (ticker && typeof ticker === "object" && typeof ticker.unref === "function") // ticker is a NodeJS Timeout object that has an `unref` method
        // https://nodejs.org/api/timers.html#timeoutunref
        // When auto refresh is used in NodeJS (like for testing) the
        // `setInterval` is preventing the process from being marked as
        // finished and tests run endlessly. This can be prevented by calling
        // `unref()` on the returned object.
        ticker.unref();
        else if (typeof Deno !== "undefined" && typeof Deno.unrefTimer === "function") // similar like for NodeJS, but with the Deno API
        // https://deno.land/api@latest?unstable&s=Deno.unrefTimer
        // @ts-ignore
        Deno.unrefTimer(ticker);
        // run the tick immediately, but in the next pass of the event loop so that
        // #_initialize can be allowed to complete without recursively waiting on
        // itself
        setTimeout(async ()=>{
            await this.initializePromise;
            await this._autoRefreshTokenTick();
        }, 0);
    }
    /**
     * This is the private implementation of {@link #stopAutoRefresh}. Use this
     * within the library.
     */ async _stopAutoRefresh() {
        this._debug("#_stopAutoRefresh()");
        const ticker = this.autoRefreshTicker;
        this.autoRefreshTicker = null;
        if (ticker) clearInterval(ticker);
    }
    /**
     * Starts an auto-refresh process in the background. The session is checked
     * every few seconds. Close to the time of expiration a process is started to
     * refresh the session. If refreshing fails it will be retried for as long as
     * necessary.
     *
     * If you set the {@link GoTrueClientOptions#autoRefreshToken} you don't need
     * to call this function, it will be called for you.
     *
     * On browsers the refresh process works only when the tab/window is in the
     * foreground to conserve resources as well as prevent race conditions and
     * flooding auth with requests. If you call this method any managed
     * visibility change callback will be removed and you must manage visibility
     * changes on your own.
     *
     * On non-browser platforms the refresh process works *continuously* in the
     * background, which may not be desirable. You should hook into your
     * platform's foreground indication mechanism and call these methods
     * appropriately to conserve resources.
     *
     * {@see #stopAutoRefresh}
     */ async startAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._startAutoRefresh();
    }
    /**
     * Stops an active auto refresh process running in the background (if any).
     *
     * If you call this method any managed visibility change callback will be
     * removed and you must manage visibility changes on your own.
     *
     * See {@link #startAutoRefresh} for more details.
     */ async stopAutoRefresh() {
        this._removeVisibilityChangedCallback();
        await this._stopAutoRefresh();
    }
    /**
     * Runs the auto refresh token tick.
     */ async _autoRefreshTokenTick() {
        this._debug("#_autoRefreshTokenTick()", "begin");
        try {
            await this._acquireLock(0, async ()=>{
                try {
                    const now = Date.now();
                    try {
                        return await this._useSession(async (result)=>{
                            const { data: { session: session } } = result;
                            if (!session || !session.refresh_token || !session.expires_at) {
                                this._debug("#_autoRefreshTokenTick()", "no session");
                                return;
                            }
                            // session will expire in this many ticks (or has already expired if <= 0)
                            const expiresInTicks = Math.floor((session.expires_at * 1000 - now) / $4bafa81c93278d71$var$AUTO_REFRESH_TICK_DURATION);
                            this._debug("#_autoRefreshTokenTick()", `access token expires in ${expiresInTicks} ticks, a tick lasts ${$4bafa81c93278d71$var$AUTO_REFRESH_TICK_DURATION}ms, refresh threshold is ${$4bafa81c93278d71$var$AUTO_REFRESH_TICK_THRESHOLD} ticks`);
                            if (expiresInTicks <= $4bafa81c93278d71$var$AUTO_REFRESH_TICK_THRESHOLD) await this._callRefreshToken(session.refresh_token);
                        });
                    } catch (e) {
                        console.error("Auto refresh tick failed with error. This is likely a transient error.", e);
                    }
                } finally{
                    this._debug("#_autoRefreshTokenTick()", "end");
                }
            });
        } catch (e) {
            if (e.isAcquireTimeout || e instanceof (0, $f44b05b877efceaa$export$23e9464cc010dff9)) this._debug("auto refresh token tick lock not available");
            else throw e;
        }
    }
    /**
     * Registers callbacks on the browser / platform, which in-turn run
     * algorithms when the browser window/tab are in foreground. On non-browser
     * platforms it assumes always foreground.
     */ async _handleVisibilityChange() {
        this._debug("#_handleVisibilityChange()");
        if (!(0, $61b424fb740c8c0b$export$4e09c449d6c407f7)() || !(window === null || window === void 0 ? void 0 : window.addEventListener)) {
            if (this.autoRefreshToken) // in non-browser environments the refresh token ticker runs always
            this.startAutoRefresh();
            return false;
        }
        try {
            this.visibilityChangedCallback = async ()=>await this._onVisibilityChanged(false);
            window === null || window === void 0 || window.addEventListener("visibilitychange", this.visibilityChangedCallback);
            // now immediately call the visbility changed callback to setup with the
            // current visbility state
            await this._onVisibilityChanged(true); // initial call
        } catch (error) {
            console.error("_handleVisibilityChange", error);
        }
    }
    /**
     * Callback registered with `window.addEventListener('visibilitychange')`.
     */ async _onVisibilityChanged(calledFromInitialize) {
        const methodName = `#_onVisibilityChanged(${calledFromInitialize})`;
        this._debug(methodName, "visibilityState", document.visibilityState);
        if (document.visibilityState === "visible") {
            if (this.autoRefreshToken) // in browser environments the refresh token ticker runs only on focused tabs
            // which prevents race conditions
            this._startAutoRefresh();
            if (!calledFromInitialize) {
                // called when the visibility has changed, i.e. the browser
                // transitioned from hidden -> visible so we need to see if the session
                // should be recovered immediately... but to do that we need to acquire
                // the lock first asynchronously
                await this.initializePromise;
                await this._acquireLock(-1, async ()=>{
                    if (document.visibilityState !== "visible") {
                        this._debug(methodName, "acquired the lock to recover the session, but the browser visibilityState is no longer visible, aborting");
                        // visibility has changed while waiting for the lock, abort
                        return;
                    }
                    // recover the session
                    await this._recoverAndRefresh();
                });
            }
        } else if (document.visibilityState === "hidden") {
            if (this.autoRefreshToken) this._stopAutoRefresh();
        }
    }
    /**
     * Generates the relevant login URL for a third-party provider.
     * @param options.redirectTo A URL or mobile address to send the user to after they are confirmed.
     * @param options.scopes A space-separated list of scopes granted to the OAuth application.
     * @param options.queryParams An object of key-value pairs containing query parameters granted to the OAuth application.
     */ async _getUrlForProvider(url, provider, options) {
        const urlParams = [
            `provider=${encodeURIComponent(provider)}`
        ];
        if (options === null || options === void 0 ? void 0 : options.redirectTo) urlParams.push(`redirect_to=${encodeURIComponent(options.redirectTo)}`);
        if (options === null || options === void 0 ? void 0 : options.scopes) urlParams.push(`scopes=${encodeURIComponent(options.scopes)}`);
        if (this.flowType === "pkce") {
            const codeVerifier = (0, $61b424fb740c8c0b$export$b6c3b8498f152f15)();
            await (0, $61b424fb740c8c0b$export$e82c36d29078a87f)(this.storage, `${this.storageKey}-code-verifier`, codeVerifier);
            const codeChallenge = await (0, $61b424fb740c8c0b$export$eb79e16bb8189148)(codeVerifier);
            const codeChallengeMethod = codeVerifier === codeChallenge ? "plain" : "s256";
            this._debug("PKCE", "code verifier", `${codeVerifier.substring(0, 5)}...`, "code challenge", codeChallenge, "method", codeChallengeMethod);
            const flowParams = new URLSearchParams({
                code_challenge: `${encodeURIComponent(codeChallenge)}`,
                code_challenge_method: `${encodeURIComponent(codeChallengeMethod)}`
            });
            urlParams.push(flowParams.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.queryParams) {
            const query = new URLSearchParams(options.queryParams);
            urlParams.push(query.toString());
        }
        if (options === null || options === void 0 ? void 0 : options.skipBrowserRedirect) urlParams.push(`skip_http_redirect=${options.skipBrowserRedirect}`);
        return `${url}?${urlParams.join("&")}`;
    }
    async _unenroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "DELETE", `${this.url}/factors/${params.factorId}`, {
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#enroll}
     */ async _enroll(params) {
        try {
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: sessionData, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                const { data: data, error: error } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/factors`, {
                    body: {
                        friendly_name: params.friendlyName,
                        factor_type: params.factorType,
                        issuer: params.issuer
                    },
                    headers: this.headers,
                    jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                });
                if (error) return {
                    data: null,
                    error: error
                };
                if ((_b = data === null || data === void 0 ? void 0 : data.totp) === null || _b === void 0 ? void 0 : _b.qr_code) data.totp.qr_code = `data:image/svg+xml;utf-8,${data.totp.qr_code}`;
                return {
                    data: data,
                    error: null
                };
            });
        } catch (error) {
            if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                data: null,
                error: error
            };
            throw error;
        }
    }
    /**
     * {@see GoTrueMFAApi#verify}
     */ async _verify(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    const { data: data, error: error } = await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/factors/${params.factorId}/verify`, {
                        body: {
                            code: params.code,
                            challenge_id: params.challengeId
                        },
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                    if (error) return {
                        data: null,
                        error: error
                    };
                    await this._saveSession(Object.assign({
                        expires_at: Math.round(Date.now() / 1000) + data.expires_in
                    }, data));
                    await this._notifyAllSubscribers("MFA_CHALLENGE_VERIFIED", data);
                    return {
                        data: data,
                        error: error
                    };
                });
            } catch (error) {
                if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challenge}
     */ async _challenge(params) {
        return this._acquireLock(-1, async ()=>{
            try {
                return await this._useSession(async (result)=>{
                    var _a;
                    const { data: sessionData, error: sessionError } = result;
                    if (sessionError) return {
                        data: null,
                        error: sessionError
                    };
                    return await (0, $5d46668c284adf12$export$8969b3850ca2cdfd)(this.fetch, "POST", `${this.url}/factors/${params.factorId}/challenge`, {
                        headers: this.headers,
                        jwt: (_a = sessionData === null || sessionData === void 0 ? void 0 : sessionData.session) === null || _a === void 0 ? void 0 : _a.access_token
                    });
                });
            } catch (error) {
                if ((0, $ed750b1e7f729ff5$export$cde1786a482f9a1c)(error)) return {
                    data: null,
                    error: error
                };
                throw error;
            }
        });
    }
    /**
     * {@see GoTrueMFAApi#challengeAndVerify}
     */ async _challengeAndVerify(params) {
        // both _challenge and _verify independently acquire the lock, so no need
        // to acquire it here
        const { data: challengeData, error: challengeError } = await this._challenge({
            factorId: params.factorId
        });
        if (challengeError) return {
            data: null,
            error: challengeError
        };
        return await this._verify({
            factorId: params.factorId,
            challengeId: challengeData.id,
            code: params.code
        });
    }
    /**
     * {@see GoTrueMFAApi#listFactors}
     */ async _listFactors() {
        // use #getUser instead of #_getUser as the former acquires a lock
        const { data: { user: user }, error: userError } = await this.getUser();
        if (userError) return {
            data: null,
            error: userError
        };
        const factors = (user === null || user === void 0 ? void 0 : user.factors) || [];
        const totp = factors.filter((factor)=>factor.factor_type === "totp" && factor.status === "verified");
        return {
            data: {
                all: factors,
                totp: totp
            },
            error: null
        };
    }
    /**
     * {@see GoTrueMFAApi#getAuthenticatorAssuranceLevel}
     */ async _getAuthenticatorAssuranceLevel() {
        return this._acquireLock(-1, async ()=>{
            return await this._useSession(async (result)=>{
                var _a, _b;
                const { data: { session: session }, error: sessionError } = result;
                if (sessionError) return {
                    data: null,
                    error: sessionError
                };
                if (!session) return {
                    data: {
                        currentLevel: null,
                        nextLevel: null,
                        currentAuthenticationMethods: []
                    },
                    error: null
                };
                const payload = this._decodeJWT(session.access_token);
                let currentLevel = null;
                if (payload.aal) currentLevel = payload.aal;
                let nextLevel = currentLevel;
                const verifiedFactors = (_b = (_a = session.user.factors) === null || _a === void 0 ? void 0 : _a.filter((factor)=>factor.status === "verified")) !== null && _b !== void 0 ? _b : [];
                if (verifiedFactors.length > 0) nextLevel = "aal2";
                const currentAuthenticationMethods = payload.amr || [];
                return {
                    data: {
                        currentLevel: currentLevel,
                        nextLevel: nextLevel,
                        currentAuthenticationMethods: currentAuthenticationMethods
                    },
                    error: null
                };
            });
        });
    }
    /**
     * Create a new client for use in the browser.
     */ constructor(options){
        var _a, _b;
        this.memoryStorage = null;
        this.stateChangeEmitters = new Map();
        this.autoRefreshTicker = null;
        this.visibilityChangedCallback = null;
        this.refreshingDeferred = null;
        /**
         * Keeps track of the async client initialization.
         * When null or not yet resolved the auth state is `unknown`
         * Once resolved the the auth state is known and it's save to call any further client methods.
         * Keep extra care to never reject or throw uncaught errors
         */ this.initializePromise = null;
        this.detectSessionInUrl = true;
        this.lockAcquired = false;
        this.pendingInLock = [];
        /**
         * Used to broadcast state change events to other tabs listening.
         */ this.broadcastChannel = null;
        this.logger = console.log;
        this.instanceID = $4bafa81c93278d71$export$2e2bcd8739ae039.nextInstanceID;
        $4bafa81c93278d71$export$2e2bcd8739ae039.nextInstanceID += 1;
        if (this.instanceID > 0 && (0, $61b424fb740c8c0b$export$4e09c449d6c407f7)()) console.warn("Multiple GoTrueClient instances detected in the same browser context. It is not an error, but this should be avoided as it may produce undefined behavior when used concurrently under the same storage key.");
        const settings = Object.assign(Object.assign({}, $4bafa81c93278d71$var$DEFAULT_OPTIONS), options);
        this.logDebugMessages = !!settings.debug;
        if (typeof settings.debug === "function") this.logger = settings.debug;
        this.persistSession = settings.persistSession;
        this.storageKey = settings.storageKey;
        this.autoRefreshToken = settings.autoRefreshToken;
        this.admin = new (0, $84c432169906c7b6$export$2e2bcd8739ae039)({
            url: settings.url,
            headers: settings.headers,
            fetch: settings.fetch
        });
        this.url = settings.url;
        this.headers = settings.headers;
        this.fetch = (0, $61b424fb740c8c0b$export$98d92b1aa79f8cc7)(settings.fetch);
        this.lock = settings.lock || $4bafa81c93278d71$var$lockNoOp;
        this.detectSessionInUrl = settings.detectSessionInUrl;
        this.flowType = settings.flowType;
        if (settings.lock) this.lock = settings.lock;
        else if ((0, $61b424fb740c8c0b$export$4e09c449d6c407f7)() && ((_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.navigator) === null || _a === void 0 ? void 0 : _a.locks)) this.lock = (0, $f44b05b877efceaa$export$f4ff21938fb7af3c);
        else this.lock = $4bafa81c93278d71$var$lockNoOp;
        this.mfa = {
            verify: this._verify.bind(this),
            enroll: this._enroll.bind(this),
            unenroll: this._unenroll.bind(this),
            challenge: this._challenge.bind(this),
            listFactors: this._listFactors.bind(this),
            challengeAndVerify: this._challengeAndVerify.bind(this),
            getAuthenticatorAssuranceLevel: this._getAuthenticatorAssuranceLevel.bind(this)
        };
        if (this.persistSession) {
            if (settings.storage) this.storage = settings.storage;
            else if ((0, $61b424fb740c8c0b$export$9ec034ee80211814)()) this.storage = (0, $7c8e26ffc62a7442$export$bba7b6c94612d04b);
            else {
                this.memoryStorage = {};
                this.storage = (0, $7c8e26ffc62a7442$export$d791f66d7e5710cf)(this.memoryStorage);
            }
        } else {
            this.memoryStorage = {};
            this.storage = (0, $7c8e26ffc62a7442$export$d791f66d7e5710cf)(this.memoryStorage);
        }
        if ((0, $61b424fb740c8c0b$export$4e09c449d6c407f7)() && globalThis.BroadcastChannel && this.persistSession && this.storageKey) {
            try {
                this.broadcastChannel = new globalThis.BroadcastChannel(this.storageKey);
            } catch (e) {
                console.error("Failed to create a new BroadcastChannel, multi-tab state changes will not be available", e);
            }
            (_b = this.broadcastChannel) === null || _b === void 0 || _b.addEventListener("message", async (event)=>{
                this._debug("received broadcast notification from other tab or client", event);
                await this._notifyAllSubscribers(event.data.event, event.data.session, false); // broadcast = false so we don't get an endless loop of messages
            });
        }
        this.initialize();
    }
}
$4bafa81c93278d71$export$2e2bcd8739ae039.nextInstanceID = 0;



const $c480771c45ee3be2$var$AuthAdminApi = (0, $84c432169906c7b6$export$2e2bcd8739ae039);
var $c480771c45ee3be2$export$2e2bcd8739ae039 = $c480771c45ee3be2$var$AuthAdminApi;



const $86fd08b211f3afe9$var$AuthClient = (0, $4bafa81c93278d71$export$2e2bcd8739ae039);
var $86fd08b211f3afe9$export$2e2bcd8739ae039 = $86fd08b211f3afe9$var$AuthClient;








class $b2ec71a8a392f999$export$8199a418bb09bd56 extends (0, $4bafa81c93278d71$export$2e2bcd8739ae039) {
    constructor(options){
        super(options);
    }
}


var $25d59b6b60e44594$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $25d59b6b60e44594$export$2e2bcd8739ae039 {
    /**
     * Supabase Functions allows you to deploy and invoke edge functions.
     */ get functions() {
        return new (0, $e37708465ea40745$export$1d0b400bf8a0fa55)(this.functionsUrl, {
            headers: this.headers,
            customFetch: this.fetch
        });
    }
    /**
     * Supabase Storage allows you to manage user-generated content, such as photos or videos.
     */ get storage() {
        return new (0, $d97aa35004b44b3d$export$6c85f5032e75eff9)(this.storageUrl, this.headers, this.fetch);
    }
    /**
     * Perform a query on a table or a view.
     *
     * @param relation - The table or view name to query
     */ from(relation) {
        return this.rest.from(relation);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.schema
    /**
     * Select a schema to query or perform an function (rpc) call.
     *
     * The schema needs to be on the list of exposed schemas inside Supabase.
     *
     * @param schema - The schema to query
     */ schema(schema) {
        return this.rest.schema(schema);
    }
    // NOTE: signatures must be kept in sync with PostgrestClient.rpc
    /**
     * Perform a function call.
     *
     * @param fn - The function name to call
     * @param args - The arguments to pass to the function call
     * @param options - Named parameters
     * @param options.head - When set to `true`, `data` will not be returned.
     * Useful if you only need the count.
     * @param options.count - Count algorithm to use to count rows returned by the
     * function. Only applicable for [set-returning
     * functions](https://www.postgresql.org/docs/current/functions-srf.html).
     *
     * `"exact"`: Exact but slow count algorithm. Performs a `COUNT(*)` under the
     * hood.
     *
     * `"planned"`: Approximated but fast count algorithm. Uses the Postgres
     * statistics under the hood.
     *
     * `"estimated"`: Uses exact count for low numbers and planned count for high
     * numbers.
     */ rpc(fn, args = {}, options = {}) {
        return this.rest.rpc(fn, args, options);
    }
    /**
     * Creates a Realtime channel with Broadcast, Presence, and Postgres Changes.
     *
     * @param {string} name - The name of the Realtime channel.
     * @param {Object} opts - The options to pass to the Realtime channel.
     *
     */ channel(name, opts = {
        config: {}
    }) {
        return this.realtime.channel(name, opts);
    }
    /**
     * Returns all Realtime channels.
     */ getChannels() {
        return this.realtime.getChannels();
    }
    /**
     * Unsubscribes and removes Realtime channel from Realtime client.
     *
     * @param {RealtimeChannel} channel - The name of the Realtime channel.
     *
     */ removeChannel(channel) {
        return this.realtime.removeChannel(channel);
    }
    /**
     * Unsubscribes and removes all Realtime channels from Realtime client.
     */ removeAllChannels() {
        return this.realtime.removeAllChannels();
    }
    _getAccessToken() {
        var _a, _b;
        return $25d59b6b60e44594$var$__awaiter(this, void 0, void 0, function*() {
            const { data: data } = yield this.auth.getSession();
            return (_b = (_a = data.session) === null || _a === void 0 ? void 0 : _a.access_token) !== null && _b !== void 0 ? _b : null;
        });
    }
    _initSupabaseAuthClient({ autoRefreshToken: autoRefreshToken, persistSession: persistSession, detectSessionInUrl: detectSessionInUrl, storage: storage, storageKey: storageKey, flowType: flowType, debug: debug }, headers, fetch) {
        const authHeaders = {
            Authorization: `Bearer ${this.supabaseKey}`,
            apikey: `${this.supabaseKey}`
        };
        return new (0, $b2ec71a8a392f999$export$8199a418bb09bd56)({
            url: this.authUrl,
            headers: Object.assign(Object.assign({}, authHeaders), headers),
            storageKey: storageKey,
            autoRefreshToken: autoRefreshToken,
            persistSession: persistSession,
            detectSessionInUrl: detectSessionInUrl,
            storage: storage,
            flowType: flowType,
            debug: debug,
            fetch: fetch
        });
    }
    _initRealtimeClient(options) {
        return new (0, $d22abf3fb04a8208$export$2e2bcd8739ae039)(this.realtimeUrl, Object.assign(Object.assign({}, options), {
            params: Object.assign({
                apikey: this.supabaseKey
            }, options === null || options === void 0 ? void 0 : options.params)
        }));
    }
    _listenForAuthEvents() {
        let data = this.auth.onAuthStateChange((event, session)=>{
            this._handleTokenChanged(event, "CLIENT", session === null || session === void 0 ? void 0 : session.access_token);
        });
        return data;
    }
    _handleTokenChanged(event, source, token) {
        if ((event === "TOKEN_REFRESHED" || event === "SIGNED_IN") && this.changedAccessToken !== token) {
            // Token has changed
            this.realtime.setAuth(token !== null && token !== void 0 ? token : null);
            this.changedAccessToken = token;
        } else if (event === "SIGNED_OUT") {
            // Token is removed
            this.realtime.setAuth(this.supabaseKey);
            if (source == "STORAGE") this.auth.signOut();
            this.changedAccessToken = undefined;
        }
    }
    /**
     * Create a new client for use in the browser.
     * @param supabaseUrl The unique Supabase URL which is supplied when you create a new project in your project dashboard.
     * @param supabaseKey The unique Supabase Key which is supplied when you create a new project in your project dashboard.
     * @param options.db.schema You can switch in between schemas. The schema needs to be on the list of exposed schemas inside Supabase.
     * @param options.auth.autoRefreshToken Set to "true" if you want to automatically refresh the token before expiring.
     * @param options.auth.persistSession Set to "true" if you want to automatically save the user session into local storage.
     * @param options.auth.detectSessionInUrl Set to "true" if you want to automatically detects OAuth grants in the URL and signs in the user.
     * @param options.realtime Options passed along to realtime-js constructor.
     * @param options.global.fetch A custom fetch implementation.
     * @param options.global.headers Any additional headers to send with each network request.
     */ constructor(supabaseUrl, supabaseKey, options){
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.supabaseUrl = supabaseUrl;
        this.supabaseKey = supabaseKey;
        if (!supabaseUrl) throw new Error("supabaseUrl is required.");
        if (!supabaseKey) throw new Error("supabaseKey is required.");
        const _supabaseUrl = (0, $979ace8c9180b2e2$export$d95b4586d238a081)(supabaseUrl);
        this.realtimeUrl = `${_supabaseUrl}/realtime/v1`.replace(/^http/i, "ws");
        this.authUrl = `${_supabaseUrl}/auth/v1`;
        this.storageUrl = `${_supabaseUrl}/storage/v1`;
        this.functionsUrl = `${_supabaseUrl}/functions/v1`;
        // default storage key uses the supabase project ref as a namespace
        const defaultStorageKey = `sb-${new URL(this.authUrl).hostname.split(".")[0]}-auth-token`;
        const DEFAULTS = {
            db: (0, $b86add62355d561a$export$b31378ae815bea6b),
            realtime: (0, $b86add62355d561a$export$59685507ca0a3912),
            auth: Object.assign(Object.assign({}, (0, $b86add62355d561a$export$af122550cc2345b3)), {
                storageKey: defaultStorageKey
            }),
            global: (0, $b86add62355d561a$export$b63a5c3a2e5becd2)
        };
        const settings = (0, $979ace8c9180b2e2$export$da186dc3f8eace71)(options !== null && options !== void 0 ? options : {}, DEFAULTS);
        this.storageKey = (_b = (_a = settings.auth) === null || _a === void 0 ? void 0 : _a.storageKey) !== null && _b !== void 0 ? _b : "";
        this.headers = (_d = (_c = settings.global) === null || _c === void 0 ? void 0 : _c.headers) !== null && _d !== void 0 ? _d : {};
        this.auth = this._initSupabaseAuthClient((_e = settings.auth) !== null && _e !== void 0 ? _e : {}, this.headers, (_f = settings.global) === null || _f === void 0 ? void 0 : _f.fetch);
        this.fetch = (0, $f9609ed505305e30$export$651dd5aef824521f)(supabaseKey, this._getAccessToken.bind(this), (_g = settings.global) === null || _g === void 0 ? void 0 : _g.fetch);
        this.realtime = this._initRealtimeClient(Object.assign({
            headers: this.headers
        }, settings.realtime));
        this.rest = new (0, $88a1bf785fa9e637$export$2e2bcd8739ae039)(`${_supabaseUrl}/rest/v1`, {
            headers: this.headers,
            schema: (_h = settings.db) === null || _h === void 0 ? void 0 : _h.schema,
            fetch: this.fetch
        });
        this._listenForAuthEvents();
    }
}





const $0b9acb7426aa7a40$export$5d730b7aed1a3eb0 = (supabaseUrl, supabaseKey, options)=>{
    return new (0, $25d59b6b60e44594$export$2e2bcd8739ae039)(supabaseUrl, supabaseKey, options);
};


const $4f7ae60590f65051$var$supabase = (0, $0b9acb7426aa7a40$export$5d730b7aed1a3eb0)("https://lwkddtfcziuoegvqkwsk.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx3a2RkdGZjeml1b2VndnFrd3NrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDk4ODkxMTIsImV4cCI6MjAyNTQ2NTExMn0.kBzJBbJ9uXHM7LnMkpwojKmWnsbbP6-kQPZb4OWa58k");
const $4f7ae60590f65051$export$5d530f106b547ae9 = async (email)=>{
    let { data: data, error: error } = await $4f7ae60590f65051$var$supabase.from("storage").select("*").eq("email", email);
    console.log(data, error);
    return data;
};
const $4f7ae60590f65051$export$10bf54e825e44464 = async ()=>{
    let { data: data, error: error } = await $4f7ae60590f65051$var$supabase.from("storage").select("*");
    console.log(data, error);
    return data;
};
const $4f7ae60590f65051$export$e335e813e295bb79 = async (id)=>{
    let { data: data, error: error } = await $4f7ae60590f65051$var$supabase.from("storage").select("*").eq("id", id);
    console.log(data, error);
    return data[0];
};
const $4f7ae60590f65051$export$7cbf767827cd68ba = async ()=>{
    const { data: { user: user } } = await $4f7ae60590f65051$var$supabase.auth.getUser();
    console.log({
        user: user
    });
    return user;
};
const $4f7ae60590f65051$export$2e4019edd7004f7d = async ()=>{
// let { data, error } = await supabase
//     .from('storage')
//     .insert({name: 'Test Venue', city: 'Mishaton'})
//
// console.log(data)
// console.log(error)
};
const $4f7ae60590f65051$export$9670d83f11d4b64a = async ({ email: email, password: password })=>{
    await $4f7ae60590f65051$var$supabase.auth.signInWithPassword({
        email: email,
        password: password
    });
};



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");

var $1134fac7f29bf356$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($1134fac7f29bf356$exports, "__esModule", {
    value: true
});
$1134fac7f29bf356$exports.default = void 0;

var $1134fac7f29bf356$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $1134fac7f29bf356$var$_default = $1134fac7f29bf356$exports.default = (0, $1134fac7f29bf356$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");






var $ab2358b520ec479c$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($ab2358b520ec479c$exports, "__esModule", {
    value: true
});
$ab2358b520ec479c$exports.default = void 0;

var $ab2358b520ec479c$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $ab2358b520ec479c$var$_default = $ab2358b520ec479c$exports.default = (0, $ab2358b520ec479c$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), "Menu");






var $4YNlq = parcelRequire("4YNlq");

const $111bbe0853276303$export$885b49729b9cab84 = ()=>{
    const { user: user, getIdTokenClaims: getIdTokenClaims } = (0, $3c0e653794cf487e$export$f2b63d3ca66bb884)();
    (0, $4YNlq.useEffect)(()=>{
        if (user) {
            console.log("Loginning in", user);
            getIdTokenClaims().then((claims)=>{
                (0, $4f7ae60590f65051$export$9670d83f11d4b64a)({
                    email: user.email,
                    password: claims.nonce_2
                });
            });
        }
    }, [
        user
    ]);
};


const $9d82f76a3c0c5ef6$export$21a94553ffa41578 = ()=>{
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).useState(null);
    const { loginWithRedirect: loginWithRedirect, user: user, isLoading: isLoading, logout: logout } = (0, $3c0e653794cf487e$export$f2b63d3ca66bb884)();
    (0, $111bbe0853276303$export$885b49729b9cab84)();
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            user ? /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "border-2 border-gray-300 rounded-2xl gap-2 ml-3",
                children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039), {
                    sx: {
                        display: "flex",
                        gap: 2
                    },
                    onClick: handleClick,
                    children: [
                        /*#__PURE__*/ (0, $izf4p.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab2358b520ec479c$exports))), {
                            color: "disabled"
                        }),
                        /*#__PURE__*/ (0, $izf4p.jsx)((0, $48dff5681ca1c01f$export$2e2bcd8739ae039), {
                            alt: user?.name,
                            src: user?.picture,
                            sx: {
                                bgcolor: "#56596C"
                            }
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                onClick: ()=>loginWithRedirect(),
                className: "border border-black rounded-2xl px-5 py-[7px] cursor-pointer",
                children: "Log in"
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $b61dbcfc76b23c84$export$2e2bcd8739ae039), {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $a9f02ffffb31630e$export$2e2bcd8739ae039), {
                    children: [
                        !isLoading && !user && /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                            className: "hover:bg-gray-100 cursor-pointer",
                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
                                onClick: ()=>loginWithRedirect(),
                                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                    children: "Sign in"
                                })
                            })
                        }),
                        !isLoading && user && /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                                    className: "hover:bg-gray-100 cursor-pointer",
                                    children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$a6c7ac8248d6e38a), {
                                        to: "/account",
                                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                                children: "Account"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                                    className: "hover:bg-gray-100 cursor-pointer",
                                    children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$a6c7ac8248d6e38a), {
                                        to: "/account/listings",
                                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                                children: "My properties"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                                    className: "hover:bg-gray-100 cursor-pointer",
                                    children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $34b8ec6d79126c08$export$2e2bcd8739ae039), {
                                        onClick: ()=>logout(),
                                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                            children: "Log out"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");




const $3ea308a360486b9f$export$19564607473c61cd = (params)=>{
    const { title: title, selectedDate: selectedDate = null, onChange: onChange, minDate: minDate = null } = params;
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).useState(null);
    const formattedDate = (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports)))(selectedDate);
    const formattedMinDate = minDate ? (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports)))(minDate) : null;
    const [date, setDate] = (0, $4YNlq.useState)(selectedDate ? formattedDate : null);
    console.log({
        title: title,
        formattedDate: formattedDate,
        date: date
    });
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const onDateChange = (value)=>{
        setDate(value);
        handleClose();
        onChange(value.format());
    };
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                onClick: handleClick,
                className: "hover:bg-slate-100 rounded-3xl py-4 px-6 cursor-pointer flex-1",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        color: "text.secondary",
                        children: date?.format("D MMM") || "Select a date"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $b61dbcfc76b23c84$export$2e2bcd8739ae039), {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $d5ae837102b4a3a2$export$68078fe5d2bf8909), {
                    value: date,
                    onChange: onDateChange,
                    disablePast: true,
                    minDate: formattedMinDate
                })
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");


var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $309LR = parcelRequire("309LR");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");






var $izf4p = parcelRequire("izf4p");
"use client";
const $190bb6882c0535f8$var$_excluded = [
    "alignItems",
    "autoFocus",
    "component",
    "children",
    "dense",
    "disableGutters",
    "divider",
    "focusVisibleClassName",
    "selected",
    "className"
];
const $190bb6882c0535f8$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === "flex-start" && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $190bb6882c0535f8$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disabled: disabled, disableGutters: disableGutters, divider: divider, selected: selected } = ownerState;
    const slots = {
        root: [
            "root",
            dense && "dense",
            !disableGutters && "gutters",
            divider && "divider",
            disabled && "disabled",
            alignItems === "flex-start" && "alignItemsFlexStart",
            selected && "selected"
        ]
    };
    const composedClasses = (0, $9JdRu.default)(slots, (0, $dfe9827538251805$export$c09531d8563c67a5), classes);
    return (0, $lzDk3.default)({}, classes, composedClasses);
};
const $190bb6882c0535f8$var$ListItemButtonRoot = (0, $JdaC3.default)((0, $7e17388639953587$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $JdaC3.rootShouldForwardProp)(prop) || prop === "classes",
    name: "MuiListItemButton",
    slot: "Root",
    overridesResolver: $190bb6882c0535f8$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "flex",
        flexGrow: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        position: "relative",
        textDecoration: "none",
        minWidth: 0,
        boxSizing: "border-box",
        textAlign: "left",
        paddingTop: 8,
        paddingBottom: 8,
        transition: theme.transitions.create("background-color", {
            duration: theme.transitions.duration.shortest
        }),
        "&:hover": {
            textDecoration: "none",
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        },
        [`&.${(0, $dfe9827538251805$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $dfe9827538251805$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $dfe9827538251805$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $309LR.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $dfe9827538251805$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $dfe9827538251805$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: "padding-box"
    }, ownerState.alignItems === "flex-start" && {
        alignItems: "flex-start"
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.dense && {
        paddingTop: 4,
        paddingBottom: 4
    }));
const $190bb6882c0535f8$var$ListItemButton = /*#__PURE__*/ $4YNlq.forwardRef(function ListItemButton(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiListItemButton"
    });
    const { alignItems: alignItems = "center", autoFocus: autoFocus = false, component: component = "div", children: children, dense: dense = false, disableGutters: disableGutters = false, divider: divider = false, focusVisibleClassName: focusVisibleClassName, selected: selected = false, className: className } = props, other = (0, $g54n0.default)(props, $190bb6882c0535f8$var$_excluded);
    const context = $4YNlq.useContext((0, $055e0d2ec1c9fa19$export$2e2bcd8739ae039));
    const childContext = $4YNlq.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $4YNlq.useRef(null);
    (0, $64a26410cabc30a1$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (listItemRef.current) listItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $lzDk3.default)({}, props, {
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        divider: divider,
        selected: selected
    });
    const classes = $190bb6882c0535f8$var$useUtilityClasses(ownerState);
    const handleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(listItemRef, ref);
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $055e0d2ec1c9fa19$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $izf4p.jsx)($190bb6882c0535f8$var$ListItemButtonRoot, (0, $lzDk3.default)({
            ref: handleRef,
            href: other.href || other.to,
            component: (other.href || other.to) && component === "div" ? "button" : component,
            focusVisibleClassName: (0, $fQQpK.default)(classes.focusVisible, focusVisibleClassName),
            ownerState: ownerState,
            className: (0, $fQQpK.default)(classes.root, className)
        }, other, {
            classes: classes,
            children: children
        }))
    });
});
var $190bb6882c0535f8$export$2e2bcd8739ae039 = $190bb6882c0535f8$var$ListItemButton;




const $8764b44c6db7f006$export$e2c8d905f04ab1ab = ({ cities: cities, onCityChange: onCityChange, selectedCity: selectedCity = null })=>{
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).useState(null);
    const [city, setCity] = (0, $4YNlq.useState)(selectedCity);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const onTypeSelect = (city)=>{
        setCity(city);
        handleClose();
        onCityChange(city);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                onClick: handleClick,
                className: "hover:bg-slate-100 rounded-3xl py-4 px-6 flex-1 cursor-pointer",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        children: "Where"
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        color: "text.secondary",
                        children: city || "Select a city"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $b61dbcfc76b23c84$export$2e2bcd8739ae039), {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $a9f02ffffb31630e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $izf4p.jsx)((0, $190bb6882c0535f8$export$2e2bcd8739ae039), {
                            onClick: ()=>onTypeSelect(""),
                            sx: {
                                px: 5
                            },
                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
                                primary: "All"
                            })
                        }),
                        cities.map((city)=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $190bb6882c0535f8$export$2e2bcd8739ae039), {
                                onClick: ()=>onTypeSelect(city),
                                sx: {
                                    px: 5
                                },
                                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
                                    primary: city
                                })
                            }, city))
                    ]
                })
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");




const $469d14c492963346$export$7b50b404012bbcea = ({ onTypeChange: onTypeChange, selectedType: selectedType = null })=>{
    console.log(selectedType);
    const [anchorEl, setAnchorEl] = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).useState(null);
    const [type, setType] = (0, $4YNlq.useState)(selectedType);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const onTypeSelect = (type)=>{
        setType(type);
        handleClose();
        onTypeChange(type);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                onClick: handleClick,
                className: "hover:bg-slate-100 rounded-3xl py-4 px-6 cursor-pointer flex-1",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        children: "Storage type"
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        color: "text.secondary",
                        children: type || "Select type"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $b61dbcfc76b23c84$export$2e2bcd8739ae039), {
                id: id,
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $a9f02ffffb31630e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $izf4p.jsx)((0, $190bb6882c0535f8$export$2e2bcd8739ae039), {
                            onClick: ()=>onTypeSelect(""),
                            sx: {
                                px: 5
                            },
                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
                                primary: "All"
                            })
                        }),
                        /*#__PURE__*/ (0, $izf4p.jsx)((0, $190bb6882c0535f8$export$2e2bcd8739ae039), {
                            onClick: ()=>onTypeSelect("warehouse"),
                            sx: {
                                px: 5
                            },
                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
                                primary: "Warehouse"
                            })
                        }),
                        /*#__PURE__*/ (0, $izf4p.jsx)((0, $190bb6882c0535f8$export$2e2bcd8739ae039), {
                            onClick: ()=>onTypeSelect("self-storage"),
                            sx: {
                                px: 5
                            },
                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
                                primary: "Self-storage"
                            })
                        }),
                        /*#__PURE__*/ (0, $izf4p.jsx)((0, $190bb6882c0535f8$export$2e2bcd8739ae039), {
                            onClick: ()=>onTypeSelect("garage"),
                            sx: {
                                px: 5
                            },
                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f9b47791fcb1adc$export$2e2bcd8739ae039), {
                                primary: "Garage"
                            })
                        })
                    ]
                })
            })
        ]
    });
};



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");

var $k91z8 = parcelRequire("k91z8");

var $5eyOE = parcelRequire("5eyOE");
var $kvdFq = parcelRequire("kvdFq");

var $6SUx4 = parcelRequire("6SUx4");

var $izf4p = parcelRequire("izf4p");
"use client";
const $d5d043494392feda$var$_excluded = [
    "className",
    "component"
];
function $d5d043494392feda$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = "MuiBox-root", generateClassName: generateClassName } = options;
    const BoxRoot = (0, $k91z8.default)("div", {
        shouldForwardProp: (prop)=>prop !== "theme" && prop !== "sx" && prop !== "as"
    })((0, $5eyOE.default));
    const Box = /*#__PURE__*/ $4YNlq.forwardRef(function Box(inProps, ref) {
        const theme = (0, $6SUx4.default)(defaultTheme);
        const _extendSxProp = (0, $kvdFq.default)(inProps), { className: className, component: component = "div" } = _extendSxProp, other = (0, $g54n0.default)(_extendSxProp, $d5d043494392feda$var$_excluded);
        return /*#__PURE__*/ (0, $izf4p.jsx)(BoxRoot, (0, $lzDk3.default)({
            as: component,
            ref: ref,
            className: (0, $fQQpK.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $3GMww = parcelRequire("3GMww");

var $hxzCU = parcelRequire("hxzCU");

var $dRtc1 = parcelRequire("dRtc1");

var $auO16 = parcelRequire("auO16");
const $708b385d8e60012b$var$boxClasses = (0, $auO16.default)("MuiBox", [
    "root"
]);
var $708b385d8e60012b$export$2e2bcd8739ae039 = $708b385d8e60012b$var$boxClasses;


"use client";
const $0b501b058bbd36d0$var$defaultTheme = (0, $hxzCU.default)();
const $0b501b058bbd36d0$var$Box = (0, $d5d043494392feda$export$2e2bcd8739ae039)({
    themeId: (0, $dRtc1.default),
    defaultTheme: $0b501b058bbd36d0$var$defaultTheme,
    defaultClassName: (0, $708b385d8e60012b$export$2e2bcd8739ae039).root,
    generateClassName: (0, $3GMww.default).generate
});
var $0b501b058bbd36d0$export$2e2bcd8739ae039 = $0b501b058bbd36d0$var$Box;



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");


var $izf4p = parcelRequire("izf4p");

var $JdaC3 = parcelRequire("JdaC3");

var $c26a805c261ae8b2$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($c26a805c261ae8b2$exports, "__esModule", {
    value: true
});
$c26a805c261ae8b2$exports.default = void 0;

var $c26a805c261ae8b2$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $c26a805c261ae8b2$var$_default = $c26a805c261ae8b2$exports.default = (0, $c26a805c261ae8b2$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), "Search");


parcelRequire("4YNlq");
const $3e208ec7d2c849fb$export$690bcf3a1f1e9f2f = (0, $JdaC3.default)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039))(()=>`
    background: rgb(200, 50, 50);
    border-radius: 100%;
    height: 66px;
    transform: scale(0.8);
    margin-right: 16px;
    &:hover {
        background: #D72542;
}`);
const $3e208ec7d2c849fb$export$728b466dd72ac4f0 = (0, $JdaC3.default)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039))(()=>`
    background: rgb(200, 50, 50);
    height: 66px;
    width: 100%;
    border-radius: 2.5rem;
    &:hover {
        background: #D72542;
}`);
const $3e208ec7d2c849fb$export$e1b2d0703bd8122c = ()=>{
    return /*#__PURE__*/ (0, $izf4p.jsx)($3e208ec7d2c849fb$export$690bcf3a1f1e9f2f, {
        variant: "contained",
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c26a805c261ae8b2$exports))), {
            fontSize: "large"
        })
    });
};
const $3e208ec7d2c849fb$export$9fc39db3f1913c24 = ()=>/*#__PURE__*/ (0, $izf4p.jsx)($3e208ec7d2c849fb$export$728b466dd72ac4f0, {
        style: {
            textTransform: "none",
            fontSize: 18
        },
        variant: "contained",
        children: "Search"
    });







const $49f8547bc2409ec7$export$494cf78290fbe4c7 = (params)=>{
    const { isOpen: isOpen, setOpen: setOpen, cities: cities, onCityChange: onCityChange, onTypeChange: onTypeChange, selectedCity: selectedCity, selectedType: selectedType, checkOutDate: checkOutDate, checkInDate: checkInDate, onCheckInDateChange: onCheckInDateChange, onCheckOutDateChange: onCheckOutDateChange } = params;
    return isOpen ? /*#__PURE__*/ (0, $izf4p.jsx)($49f8547bc2409ec7$var$ExtendedHeader, {
        selectedCity: selectedCity,
        onCityChange: onCityChange,
        onTypeChange: onTypeChange,
        selectedType: selectedType,
        checkOutDate: checkOutDate,
        checkInDate: checkInDate,
        onCheckInDateChange: onCheckInDateChange,
        onCheckOutDateChange: onCheckOutDateChange,
        cities: cities
    }) : /*#__PURE__*/ (0, $izf4p.jsx)($49f8547bc2409ec7$var$CollapsedHeader, {
        selectedCity: selectedCity,
        selectedType: selectedType,
        checkOutDate: checkOutDate,
        checkInDate: checkInDate,
        onClick: ()=>setOpen(true)
    });
};
const $49f8547bc2409ec7$var$ExtendedHeader = ({ cities: cities, onCityChange: onCityChange, onTypeChange: onTypeChange, selectedCity: selectedCity, selectedType: selectedType, checkOutDate: checkOutDate, checkInDate: checkInDate, onCheckInDateChange: onCheckInDateChange, onCheckOutDateChange: onCheckOutDateChange })=>/*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "border border-gray-400  rounded-3xl w-full mb-4",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $8764b44c6db7f006$export$e2c8d905f04ab1ab), {
                    cities: cities,
                    onCityChange: onCityChange,
                    selectedCity: selectedCity
                })
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "border border-gray-400  rounded-3xl w-full mb-4",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $3ea308a360486b9f$export$19564607473c61cd), {
                    title: "Check in",
                    selectedDate: checkInDate,
                    onChange: onCheckInDateChange
                })
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "border border-gray-400  rounded-3xl w-full mb-4",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $3ea308a360486b9f$export$19564607473c61cd), {
                    title: "Check out",
                    selectedDate: checkOutDate,
                    onChange: onCheckOutDateChange
                })
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "border border-gray-400  rounded-3xl w-full mb-4",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $469d14c492963346$export$7b50b404012bbcea), {
                    onTypeChange: onTypeChange,
                    selectedType: selectedType
                })
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$a6c7ac8248d6e38a), {
                to: "/search",
                state: {
                    selectedCity: selectedCity,
                    selectedType: selectedType,
                    checkInDate: checkInDate,
                    checkOutDate: checkOutDate
                },
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $3e208ec7d2c849fb$export$9fc39db3f1913c24), {})
            })
        ]
    });
const $49f8547bc2409ec7$var$CollapsedHeader = ({ onClick: onClick, selectedCity: selectedCity, selectedType: selectedType, checkInDate: checkInDate, checkOutDate: checkOutDate })=>{
    const title = `${selectedType ? $49f8547bc2409ec7$var$capitalizeFirstLetter(selectedType) : "All types"} ${selectedCity ? `in ${selectedCity}` : "everywhere"}`;
    const titleWithDefault = selectedType || selectedCity ? title : "Let's find you a storage";
    const checkInFormatted = (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports)))(checkInDate);
    const checkInReady = checkInFormatted.isValid() ? checkInFormatted.format("DD MMM") : "";
    const checkOutFormatted = (0, (/*@__PURE__*/$parcel$interopDefault($64d8998661a46a92$exports)))(checkOutDate);
    const checkOutReady = checkOutFormatted.isValid() ? checkOutFormatted.format("DD MMM") : "";
    const isDate = checkInDate && checkOutDate && checkInFormatted.isValid() && checkOutFormatted.isValid();
    const dateSubtitle = `${checkInReady} - ${checkOutReady}`;
    return /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
        className: "shadow shadow-gray-300 rounded-3xl w-full py-4 px-6 flex items-center justify-between",
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                onClick: onClick,
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        children: titleWithDefault
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        color: "text.secondary",
                        children: isDate ? dateSubtitle : /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $izf4p.jsx)("span", {
                                    className: "mr-3",
                                    children: "Select:"
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsx)("span", {
                                    className: "mr-3",
                                    children: "City "
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsx)("span", {
                                    className: "mr-3",
                                    children: "Date"
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsx)("span", {
                                    className: "mr-3",
                                    children: "Type"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$a6c7ac8248d6e38a), {
                to: "/search",
                state: {
                    selectedCity: selectedCity,
                    selectedType: selectedType,
                    checkInDate: checkInDate,
                    checkOutDate: checkOutDate
                },
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $3e208ec7d2c849fb$export$e1b2d0703bd8122c), {})
            })
        ]
    });
};
function $49f8547bc2409ec7$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}



const $fd3fcc825e3c65de$export$8b251419efc915eb = (params)=>{
    const { onTypeChange: onTypeChange, cities: cities = [], onCityChange: onCityChange, selectedCity: selectedCity, selectedType: selectedType, checkOutDate: checkOutDate, checkInDate: checkInDate, onCheckInDateChange: onCheckInDateChange, onCheckOutDateChange: onCheckOutDateChange } = params;
    const [isMobileSearchOpen, setMobileSearchOpen] = (0, $4YNlq.useState)(false);
    return /*#__PURE__*/ (0, $izf4p.jsxs)("header", {
        className: "min-h-20 shadow shadow-gray-10 px-8 py-3",
        children: [
            /*#__PURE__*/ (0, $izf4p.jsxs)("nav", {
                className: "items-center flex w-full justify-between",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                            className: "flex-1",
                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $0b501b058bbd36d0$export$2e2bcd8739ae039), {
                                component: "img",
                                sx: {
                                    height: 90,
                                    width: 180
                                },
                                alt: "logo",
                                src: "https://res.cloudinary.com/dhlzvktzj/image/upload/v1714217409/sunni/b_xc7mqh.png"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        id: "search-bar-holder",
                        className: "lg:block hidden",
                        children: /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                            id: "search-bar",
                            className: "shadow shadow-gray-300 rounded-3xl w-[700px] h-[76px] flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $izf4p.jsx)((0, $8764b44c6db7f006$export$e2c8d905f04ab1ab), {
                                    cities: cities,
                                    onCityChange: onCityChange,
                                    selectedCity: selectedCity
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsx)((0, $3ea308a360486b9f$export$19564607473c61cd), {
                                    title: "Check in",
                                    selectedDate: checkInDate,
                                    onChange: onCheckInDateChange
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsx)((0, $3ea308a360486b9f$export$19564607473c61cd), {
                                    title: "Check out",
                                    selectedDate: checkOutDate,
                                    onChange: onCheckOutDateChange,
                                    minDate: checkInDate
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsx)((0, $469d14c492963346$export$7b50b404012bbcea), {
                                    onTypeChange: onTypeChange,
                                    selectedType: selectedType
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$a6c7ac8248d6e38a), {
                                    to: "/search",
                                    state: {
                                        selectedCity: selectedCity,
                                        selectedType: selectedType,
                                        checkInDate: checkInDate,
                                        checkOutDate: checkOutDate
                                    },
                                    children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $3e208ec7d2c849fb$export$e1b2d0703bd8122c), {})
                                })
                            ]
                        })
                    }),
                    isMobileSearchOpen ? /*#__PURE__*/ (0, $izf4p.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1134fac7f29bf356$exports))), {
                        fontSize: "large",
                        onClick: ()=>setMobileSearchOpen(false)
                    }) : /*#__PURE__*/ (0, $izf4p.jsx)((0, $9d82f76a3c0c5ef6$export$21a94553ffa41578), {})
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "lg:hidden block",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $49f8547bc2409ec7$export$494cf78290fbe4c7), {
                    onCityChange: onCityChange,
                    onTypeChange: onTypeChange,
                    cities: cities,
                    isOpen: isMobileSearchOpen,
                    setOpen: setMobileSearchOpen,
                    selectedCity: selectedCity,
                    selectedType: selectedType,
                    checkOutDate: checkOutDate,
                    checkInDate: checkInDate,
                    onCheckInDateChange: onCheckInDateChange,
                    onCheckOutDateChange: onCheckOutDateChange
                })
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");

var $4YNlq = parcelRequire("4YNlq");

var $4YNlq = parcelRequire("4YNlq");

var $4YNlq = parcelRequire("4YNlq");

const $c630b00dd7fbe00a$export$c6c68f6e4db55944 = $4YNlq.createContext(null);
const $c630b00dd7fbe00a$export$507c997ee09bb471 = (props)=>{
    const [maps, setMaps] = (0, $4YNlq.useState)({});
    const onMapMount = (0, $4YNlq.useCallback)((map, id = "default")=>{
        setMaps((currMaps)=>{
            if (id === "current") throw new Error("'current' cannot be used as map id");
            if (currMaps[id]) throw new Error(`Multiple maps with the same id: ${id}`);
            return {
                ...currMaps,
                [id]: map
            };
        });
    }, []);
    const onMapUnmount = (0, $4YNlq.useCallback)((id = "default")=>{
        setMaps((currMaps)=>{
            if (currMaps[id]) {
                const nextMaps = {
                    ...currMaps
                };
                delete nextMaps[id];
                return nextMaps;
            }
            return currMaps;
        });
    }, []);
    return $4YNlq.createElement($c630b00dd7fbe00a$export$c6c68f6e4db55944.Provider, {
        value: {
            maps: maps,
            onMapMount: onMapMount,
            onMapUnmount: onMapUnmount
        }
    }, props.children);
};
function $c630b00dd7fbe00a$export$86f8f9f08863e403() {
    var _a;
    const maps = (_a = (0, $4YNlq.useContext)($c630b00dd7fbe00a$export$c6c68f6e4db55944)) === null || _a === void 0 ? void 0 : _a.maps;
    const currentMap = (0, $4YNlq.useContext)((0, $78be752643b8750f$export$dc7344301ae78f85));
    const mapsWithCurrent = (0, $4YNlq.useMemo)(()=>{
        return {
            ...maps,
            current: currentMap === null || currentMap === void 0 ? void 0 : currentMap.map
        };
    }, [
        maps,
        currentMap
    ]);
    return mapsWithCurrent;
}


/**
 * Compare two points
 * @param a
 * @param b
 * @returns true if the points are equal
 */ function $09c39994fff64b32$export$cb7477365ef68362(a, b) {
    const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
    const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
    const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
    const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
    return ax === bx && ay === by;
}
function $09c39994fff64b32$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$09c39994fff64b32$export$9cb4719e2e525b7a(a[i], b[i])) return false;
        }
        return true;
    } else if (Array.isArray(b)) return false;
    if (typeof a === "object" && typeof b === "object") {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!$09c39994fff64b32$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}


function $9b63e86f1f7b6a39$export$dd516654c5f598fb(tr) {
    const newTransform = tr.clone();
    // Work around mapbox bug - this value is not assigned in clone(), only in resize()
    newTransform.pixelsToGLUnits = tr.pixelsToGLUnits;
    return newTransform;
}
function $9b63e86f1f7b6a39$export$7bd220dfde473c56(src, dest) {
    if (!src.getProjection) return;
    const srcProjection = src.getProjection();
    const destProjection = dest.getProjection();
    if (!(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(srcProjection, destProjection)) dest.setProjection(srcProjection);
}
function $9b63e86f1f7b6a39$export$6a605c5aa5bd97a8(tr) {
    return {
        longitude: tr.center.lng,
        latitude: tr.center.lat,
        zoom: tr.zoom,
        pitch: tr.pitch,
        bearing: tr.bearing,
        padding: tr.padding
    };
}
function $9b63e86f1f7b6a39$export$5cf06eaeb862e3ce(tr, props) {
    const v = props.viewState || props;
    let changed = false;
    if ("longitude" in v && "latitude" in v) {
        const center = tr.center;
        // @ts-ignore
        tr.center = new center.constructor(v.longitude, v.latitude);
        changed = changed || center !== tr.center;
    }
    if ("zoom" in v) {
        const zoom = tr.zoom;
        tr.zoom = v.zoom;
        changed = changed || zoom !== tr.zoom;
    }
    if ("bearing" in v) {
        const bearing = tr.bearing;
        tr.bearing = v.bearing;
        changed = changed || bearing !== tr.bearing;
    }
    if ("pitch" in v) {
        const pitch = tr.pitch;
        tr.pitch = v.pitch;
        changed = changed || pitch !== tr.pitch;
    }
    if (v.padding && !tr.isPaddingEqual(v.padding)) {
        changed = true;
        tr.padding = v.padding;
    }
    return changed;
}


const $b4aad8c0384cf2b8$var$refProps = [
    "type",
    "source",
    "source-layer",
    "minzoom",
    "maxzoom",
    "filter",
    "layout"
];
function $b4aad8c0384cf2b8$export$8756898546458274(style) {
    if (!style) return null;
    if (typeof style === "string") return style;
    if ("toJS" in style) style = style.toJS();
    if (!style.layers) return style;
    const layerIndex = {};
    for (const layer of style.layers)layerIndex[layer.id] = layer;
    const layers = style.layers.map((layer)=>{
        let normalizedLayer = null;
        if ("interactive" in layer) {
            normalizedLayer = Object.assign({}, layer);
            // Breaks style diffing :(
            // @ts-ignore legacy field not typed
            delete normalizedLayer.interactive;
        }
        // Style diffing doesn't work with refs so expand them out manually before diffing.
        // @ts-ignore legacy field not typed
        const layerRef = layerIndex[layer.ref];
        if (layerRef) {
            normalizedLayer = normalizedLayer || Object.assign({}, layer);
            // @ts-ignore
            delete normalizedLayer.ref;
            // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/deref.js
            for (const propName of $b4aad8c0384cf2b8$var$refProps)if (propName in layerRef) normalizedLayer[propName] = layerRef[propName];
        }
        return normalizedLayer || layer;
    });
    // Do not mutate the style object provided by the user
    return {
        ...style,
        layers: layers
    };
}



const $619b9f8377bec2c6$var$DEFAULT_STYLE = {
    version: 8,
    sources: {},
    layers: []
};
const $619b9f8377bec2c6$var$pointerEvents = {
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    click: "onClick",
    dblclick: "onDblClick",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    mouseout: "onMouseOut",
    contextmenu: "onContextMenu",
    touchstart: "onTouchStart",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchcancel: "onTouchCancel"
};
const $619b9f8377bec2c6$var$cameraEvents = {
    movestart: "onMoveStart",
    move: "onMove",
    moveend: "onMoveEnd",
    dragstart: "onDragStart",
    drag: "onDrag",
    dragend: "onDragEnd",
    zoomstart: "onZoomStart",
    zoom: "onZoom",
    zoomend: "onZoomEnd",
    rotatestart: "onRotateStart",
    rotate: "onRotate",
    rotateend: "onRotateEnd",
    pitchstart: "onPitchStart",
    pitch: "onPitch",
    pitchend: "onPitchEnd"
};
const $619b9f8377bec2c6$var$otherEvents = {
    wheel: "onWheel",
    boxzoomstart: "onBoxZoomStart",
    boxzoomend: "onBoxZoomEnd",
    boxzoomcancel: "onBoxZoomCancel",
    resize: "onResize",
    load: "onLoad",
    render: "onRender",
    idle: "onIdle",
    remove: "onRemove",
    data: "onData",
    styledata: "onStyleData",
    sourcedata: "onSourceData",
    error: "onError"
};
const $619b9f8377bec2c6$var$settingNames = [
    "minZoom",
    "maxZoom",
    "minPitch",
    "maxPitch",
    "maxBounds",
    "projection",
    "renderWorldCopies"
];
const $619b9f8377bec2c6$var$handlerNames = [
    "scrollZoom",
    "boxZoom",
    "dragRotate",
    "dragPan",
    "keyboard",
    "doubleClickZoom",
    "touchZoomRotate",
    "touchPitch"
];
class $619b9f8377bec2c6$export$2e2bcd8739ae039 {
    get map() {
        return this._map;
    }
    get transform() {
        return this._renderTransform;
    }
    setProps(props) {
        const oldProps = this.props;
        this.props = props;
        const settingsChanged = this._updateSettings(props, oldProps);
        if (settingsChanged) this._createShadowTransform(this._map);
        const sizeChanged = this._updateSize(props);
        const viewStateChanged = this._updateViewState(props, true);
        this._updateStyle(props, oldProps);
        this._updateStyleComponents(props, oldProps);
        this._updateHandlers(props, oldProps);
        // If 1) view state has changed to match props and
        //    2) the props change is not triggered by map events,
        // it's driven by an external state change. Redraw immediately
        if (settingsChanged || sizeChanged || viewStateChanged && !this._map.isMoving()) this.redraw();
    }
    static reuse(props, container) {
        const that = $619b9f8377bec2c6$export$2e2bcd8739ae039.savedMaps.pop();
        if (!that) return null;
        const map = that.map;
        // When reusing the saved map, we need to reparent the map(canvas) and other child nodes
        // intoto the new container from the props.
        // Step 1: reparenting child nodes from old container to new container
        const oldContainer = map.getContainer();
        container.className = oldContainer.className;
        while(oldContainer.childNodes.length > 0)container.appendChild(oldContainer.childNodes[0]);
        // Step 2: replace the internal container with new container from the react component
        // @ts-ignore
        map._container = container;
        // With maplibre-gl as mapLib, map uses ResizeObserver to observe when its container resizes.
        // When reusing the saved map, we need to disconnect the observer and observe the new container.
        // Step 3: telling the ResizeObserver to disconnect and observe the new container
        // @ts-ignore
        const resizeObserver = map._resizeObserver;
        if (resizeObserver) {
            resizeObserver.disconnect();
            resizeObserver.observe(container);
        }
        // Step 4: apply new props
        that.setProps({
            ...props,
            styleDiffing: false
        });
        map.resize();
        const { initialViewState: initialViewState } = props;
        if (initialViewState) {
            if (initialViewState.bounds) map.fitBounds(initialViewState.bounds, {
                ...initialViewState.fitBoundsOptions,
                duration: 0
            });
            else that._updateViewState(initialViewState, false);
        }
        // Simulate load event
        if (map.isStyleLoaded()) map.fire("load");
        else map.once("styledata", ()=>map.fire("load"));
        // Force reload
        // @ts-ignore
        map._update();
        return that;
    }
    /* eslint-disable complexity,max-statements */ _initialize(container) {
        const { props: props } = this;
        const { mapStyle: mapStyle = $619b9f8377bec2c6$var$DEFAULT_STYLE } = props;
        const mapOptions = {
            ...props,
            ...props.initialViewState,
            accessToken: props.mapboxAccessToken || $619b9f8377bec2c6$var$getAccessTokenFromEnv() || null,
            container: container,
            style: (0, $b4aad8c0384cf2b8$export$8756898546458274)(mapStyle)
        };
        const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
        Object.assign(mapOptions, {
            center: [
                viewState.longitude || 0,
                viewState.latitude || 0
            ],
            zoom: viewState.zoom || 0,
            pitch: viewState.pitch || 0,
            bearing: viewState.bearing || 0
        });
        if (props.gl) {
            // eslint-disable-next-line
            const getContext = HTMLCanvasElement.prototype.getContext;
            // Hijack canvas.getContext to return our own WebGLContext
            // This will be called inside the mapboxgl.Map constructor
            // @ts-expect-error
            HTMLCanvasElement.prototype.getContext = ()=>{
                // Unhijack immediately
                HTMLCanvasElement.prototype.getContext = getContext;
                return props.gl;
            };
        }
        const map = new this._MapClass(mapOptions);
        // Props that are not part of constructor options
        if (viewState.padding) map.setPadding(viewState.padding);
        if (props.cursor) map.getCanvas().style.cursor = props.cursor;
        this._createShadowTransform(map);
        // Hack
        // Insert code into map's render cycle
        const renderMap = map._render;
        map._render = (arg)=>{
            this._inRender = true;
            renderMap.call(map, arg);
            this._inRender = false;
        };
        const runRenderTaskQueue = map._renderTaskQueue.run;
        map._renderTaskQueue.run = (arg)=>{
            runRenderTaskQueue.call(map._renderTaskQueue, arg);
            this._onBeforeRepaint();
        };
        map.on("render", ()=>this._onAfterRepaint());
        // Insert code into map's event pipeline
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const fireEvent = map.fire;
        map.fire = this._fireEvent.bind(this, fireEvent);
        // add listeners
        map.on("resize", ()=>{
            this._renderTransform.resize(map.transform.width, map.transform.height);
        });
        map.on("styledata", ()=>{
            this._updateStyleComponents(this.props, {});
            // Projection can be set in stylesheet
            (0, $9b63e86f1f7b6a39$export$7bd220dfde473c56)(map.transform, this._renderTransform);
        });
        map.on("sourcedata", ()=>this._updateStyleComponents(this.props, {}));
        for(const eventName in $619b9f8377bec2c6$var$pointerEvents)map.on(eventName, this._onPointerEvent);
        for(const eventName in $619b9f8377bec2c6$var$cameraEvents)map.on(eventName, this._onCameraEvent);
        for(const eventName in $619b9f8377bec2c6$var$otherEvents)map.on(eventName, this._onEvent);
        this._map = map;
    }
    /* eslint-enable complexity,max-statements */ recycle() {
        // Clean up unnecessary elements before storing for reuse.
        const container = this.map.getContainer();
        const children = container.querySelector("[mapboxgl-children]");
        children === null || children === void 0 || children.remove();
        $619b9f8377bec2c6$export$2e2bcd8739ae039.savedMaps.push(this);
    }
    destroy() {
        this._map.remove();
    }
    // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
    // render cycle, which is managed by Mapbox's animation loop.
    // This removes the synchronization issue caused by requestAnimationFrame.
    redraw() {
        const map = this._map;
        // map._render will throw error if style does not exist
        // https://github.com/mapbox/mapbox-gl-js/blob/fb9fc316da14e99ff4368f3e4faa3888fb43c513
        //   /src/ui/map.js#L1834
        if (!this._inRender && map.style) {
            // cancel the scheduled update
            if (map._frame) {
                map._frame.cancel();
                map._frame = null;
            }
            // the order is important - render() may schedule another update
            map._render();
        }
    }
    _createShadowTransform(map) {
        const renderTransform = (0, $9b63e86f1f7b6a39$export$dd516654c5f598fb)(map.transform);
        map.painter.transform = renderTransform;
        this._renderTransform = renderTransform;
    }
    /* Trigger map resize if size is controlled
       @param {object} nextProps
       @returns {bool} true if size has changed
     */ _updateSize(nextProps) {
        // Check if size is controlled
        const { viewState: viewState } = nextProps;
        if (viewState) {
            const map = this._map;
            if (viewState.width !== map.transform.width || viewState.height !== map.transform.height) {
                map.resize();
                return true;
            }
        }
        return false;
    }
    // Adapted from map.jumpTo
    /* Update camera to match props
       @param {object} nextProps
       @param {bool} triggerEvents - should fire camera events
       @returns {bool} true if anything is changed
     */ _updateViewState(nextProps, triggerEvents) {
        if (this._internalUpdate) return false;
        const map = this._map;
        const tr = this._renderTransform;
        // Take a snapshot of the transform before mutation
        const { zoom: zoom, pitch: pitch, bearing: bearing } = tr;
        const isMoving = map.isMoving();
        if (isMoving) // All movement of the camera is done relative to the sea level
        tr.cameraElevationReference = "sea";
        const changed = (0, $9b63e86f1f7b6a39$export$5cf06eaeb862e3ce)(tr, {
            ...(0, $9b63e86f1f7b6a39$export$6a605c5aa5bd97a8)(map.transform),
            ...nextProps
        });
        if (isMoving) // Reset camera reference
        tr.cameraElevationReference = "ground";
        if (changed && triggerEvents) {
            const deferredEvents = this._deferredEvents;
            // Delay DOM control updates to the next render cycle
            deferredEvents.move = true;
            deferredEvents.zoom || (deferredEvents.zoom = zoom !== tr.zoom);
            deferredEvents.rotate || (deferredEvents.rotate = bearing !== tr.bearing);
            deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
        }
        // Avoid manipulating the real transform when interaction/animation is ongoing
        // as it would interfere with Mapbox's handlers
        if (!isMoving) (0, $9b63e86f1f7b6a39$export$5cf06eaeb862e3ce)(map.transform, nextProps);
        return changed;
    }
    /* Update camera constraints and projection settings to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateSettings(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of $619b9f8377bec2c6$var$settingNames)if (propName in nextProps && !(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(nextProps[propName], currProps[propName])) {
            changed = true;
            const setter = map[`set${propName[0].toUpperCase()}${propName.slice(1)}`];
            setter === null || setter === void 0 || setter.call(map, nextProps[propName]);
        }
        return changed;
    }
    /* Update map style to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if style is changed
     */ _updateStyle(nextProps, currProps) {
        if (nextProps.cursor !== currProps.cursor) this._map.getCanvas().style.cursor = nextProps.cursor || "";
        if (nextProps.mapStyle !== currProps.mapStyle) {
            const { mapStyle: mapStyle = $619b9f8377bec2c6$var$DEFAULT_STYLE, styleDiffing: styleDiffing = true } = nextProps;
            const options = {
                diff: styleDiffing
            };
            if ("localIdeographFontFamily" in nextProps) // @ts-ignore Mapbox specific prop
            options.localIdeographFontFamily = nextProps.localIdeographFontFamily;
            this._map.setStyle((0, $b4aad8c0384cf2b8$export$8756898546458274)(mapStyle), options);
            return true;
        }
        return false;
    }
    /* Update fog, light and terrain to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateStyleComponents(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        if (map.isStyleLoaded()) {
            if ("light" in nextProps && map.setLight && !(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(nextProps.light, currProps.light)) {
                changed = true;
                map.setLight(nextProps.light);
            }
            if ("fog" in nextProps && map.setFog && !(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(nextProps.fog, currProps.fog)) {
                changed = true;
                map.setFog(nextProps.fog);
            }
            if ("terrain" in nextProps && map.setTerrain && !(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(nextProps.terrain, currProps.terrain)) {
                if (!nextProps.terrain || map.getSource(nextProps.terrain.source)) {
                    changed = true;
                    map.setTerrain(nextProps.terrain);
                }
            }
        }
        return changed;
    }
    /* Update interaction handlers to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateHandlers(nextProps, currProps) {
        var _a, _b;
        const map = this._map;
        let changed = false;
        for (const propName of $619b9f8377bec2c6$var$handlerNames){
            const newValue = (_a = nextProps[propName]) !== null && _a !== void 0 ? _a : true;
            const oldValue = (_b = currProps[propName]) !== null && _b !== void 0 ? _b : true;
            if (!(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(newValue, oldValue)) {
                changed = true;
                if (newValue) map[propName].enable(newValue);
                else map[propName].disable();
            }
        }
        return changed;
    }
    _queryRenderedFeatures(point) {
        const map = this._map;
        const tr = map.transform;
        const { interactiveLayerIds: interactiveLayerIds = [] } = this.props;
        try {
            map.transform = this._renderTransform;
            return map.queryRenderedFeatures(point, {
                layers: interactiveLayerIds.filter(map.getLayer.bind(map))
            });
        } catch (_a) {
            // May fail if style is not loaded
            return [];
        } finally{
            map.transform = tr;
        }
    }
    _updateHover(e) {
        var _a;
        const { props: props } = this;
        const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
        if (shouldTrackHoveredFeatures) {
            const eventType = e.type;
            const wasHovering = ((_a = this._hoveredFeatures) === null || _a === void 0 ? void 0 : _a.length) > 0;
            const features = this._queryRenderedFeatures(e.point);
            const isHovering = features.length > 0;
            if (!isHovering && wasHovering) {
                e.type = "mouseleave";
                this._onPointerEvent(e);
            }
            this._hoveredFeatures = features;
            if (isHovering && !wasHovering) {
                e.type = "mouseenter";
                this._onPointerEvent(e);
            }
            e.type = eventType;
        } else this._hoveredFeatures = null;
    }
    _fireEvent(baseFire, event, properties) {
        const map = this._map;
        const tr = map.transform;
        const eventType = typeof event === "string" ? event : event.type;
        if (eventType === "move") this._updateViewState(this.props, false);
        if (eventType in $619b9f8377bec2c6$var$cameraEvents) {
            if (typeof event === "object") event.viewState = (0, $9b63e86f1f7b6a39$export$6a605c5aa5bd97a8)(tr);
            if (this._map.isMoving()) {
                // Replace map.transform with ours during the callbacks
                map.transform = this._renderTransform;
                baseFire.call(map, event, properties);
                map.transform = tr;
                return map;
            }
        }
        baseFire.call(map, event, properties);
        return map;
    }
    // All camera manipulations are complete, ready to repaint
    _onBeforeRepaint() {
        const map = this._map;
        // If there are camera changes driven by props, invoke camera events so that DOM controls are synced
        this._internalUpdate = true;
        for(const eventType in this._deferredEvents)if (this._deferredEvents[eventType]) map.fire(eventType);
        this._internalUpdate = false;
        const tr = this._map.transform;
        // Make sure camera matches the current props
        map.transform = this._renderTransform;
        this._onAfterRepaint = ()=>{
            // Mapbox transitions between non-mercator projection and mercator during render time
            // Copy it back to the other
            (0, $9b63e86f1f7b6a39$export$7bd220dfde473c56)(this._renderTransform, tr);
            // Restores camera state before render/load events are fired
            map.transform = tr;
        };
    }
    constructor(MapClass, props, container){
        // mapboxgl.Map instance
        this._map = null;
        // Internal states
        this._internalUpdate = false;
        this._inRender = false;
        this._hoveredFeatures = null;
        this._deferredEvents = {
            move: false,
            zoom: false,
            pitch: false,
            rotate: false
        };
        this._onEvent = (e)=>{
            // @ts-ignore
            const cb = this.props[$619b9f8377bec2c6$var$otherEvents[e.type]];
            if (cb) cb(e);
            else if (e.type === "error") console.error(e.error); // eslint-disable-line
        };
        this._onPointerEvent = (e)=>{
            if (e.type === "mousemove" || e.type === "mouseout") this._updateHover(e);
            // @ts-ignore
            const cb = this.props[$619b9f8377bec2c6$var$pointerEvents[e.type]];
            if (cb) {
                if (this.props.interactiveLayerIds && e.type !== "mouseover" && e.type !== "mouseout") e.features = this._hoveredFeatures || this._queryRenderedFeatures(e.point);
                cb(e);
                delete e.features;
            }
        };
        this._onCameraEvent = (e)=>{
            if (!this._internalUpdate) {
                // @ts-ignore
                const cb = this.props[$619b9f8377bec2c6$var$cameraEvents[e.type]];
                if (cb) cb(e);
            }
            if (e.type in this._deferredEvents) this._deferredEvents[e.type] = false;
        };
        this._MapClass = MapClass;
        this.props = props;
        this._initialize(container);
    }
}
$619b9f8377bec2c6$export$2e2bcd8739ae039.savedMaps = [];
/**
 * Access token can be provided via one of:
 *   mapboxAccessToken prop
 *   access_token query parameter
 *   MapboxAccessToken environment variable
 *   REACT_APP_MAPBOX_ACCESS_TOKEN environment variable
 * @returns access token
 */ function $619b9f8377bec2c6$var$getAccessTokenFromEnv() {
    let accessToken = null;
    /* global location, process */ if (typeof location !== "undefined") {
        const match = /access_token=([^&\/]*)/.exec(location.search);
        accessToken = match && match[1];
    }
    // Note: This depends on bundler plugins (e.g. webpack) importing environment correctly
    try {
        accessToken = accessToken || undefined;
    } catch (_a) {
    // ignore
    }
    try {
        accessToken = accessToken || undefined;
    } catch (_b) {
    // ignore
    }
    return accessToken;
}


/** These methods may break the react binding if called directly */ const $5a10e093a8bdbc41$var$skipMethods = [
    "setMaxBounds",
    "setMinZoom",
    "setMaxZoom",
    "setMinPitch",
    "setMaxPitch",
    "setRenderWorldCopies",
    "setProjection",
    "setStyle",
    "addSource",
    "removeSource",
    "addLayer",
    "removeLayer",
    "setLayerZoomRange",
    "setFilter",
    "setPaintProperty",
    "setLayoutProperty",
    "setLight",
    "setTerrain",
    "setFog",
    "remove"
];
function $5a10e093a8bdbc41$export$2e2bcd8739ae039(mapInstance) {
    if (!mapInstance) return null;
    const map = mapInstance.map;
    const result = {
        getMap: ()=>map,
        // Overwrite getters to use our shadow transform
        getCenter: ()=>mapInstance.transform.center,
        getZoom: ()=>mapInstance.transform.zoom,
        getBearing: ()=>mapInstance.transform.bearing,
        getPitch: ()=>mapInstance.transform.pitch,
        getPadding: ()=>mapInstance.transform.padding,
        getBounds: ()=>mapInstance.transform.getBounds(),
        project: (lnglat)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.project(lnglat);
            map.transform = tr;
            return result;
        },
        unproject: (point)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.unproject(point);
            map.transform = tr;
            return result;
        },
        // options diverge between mapbox and maplibre
        queryTerrainElevation: (lnglat, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryTerrainElevation(lnglat, options);
            map.transform = tr;
            return result;
        },
        queryRenderedFeatures: (geometry, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryRenderedFeatures(geometry, options);
            map.transform = tr;
            return result;
        }
    };
    for (const key of $5a10e093a8bdbc41$var$getMethodNames(map))// @ts-expect-error
    if (!(key in result) && !$5a10e093a8bdbc41$var$skipMethods.includes(key)) result[key] = map[key].bind(map);
    return result;
}
function $5a10e093a8bdbc41$var$getMethodNames(obj) {
    const result = new Set();
    let proto = obj;
    while(proto){
        for (const key of Object.getOwnPropertyNames(proto))if (key[0] !== "_" && typeof obj[key] === "function" && key !== "fire" && key !== "setEventedParent") result.add(key);
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(result);
}


// From https://github.com/streamich/react-use/blob/master/src/useIsomorphicLayoutEffect.ts
// useLayoutEffect but does not trigger warning in server-side rendering

var $4YNlq = parcelRequire("4YNlq");
const $3e5c366e8d61cdd2$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? (0, $4YNlq.useLayoutEffect) : (0, $4YNlq.useEffect);
var $3e5c366e8d61cdd2$export$2e2bcd8739ae039 = $3e5c366e8d61cdd2$var$useIsomorphicLayoutEffect;


const $1063df59c2f0f1a3$var$globalSettings = [
    "baseApiUrl",
    "maxParallelImageRequests",
    "workerClass",
    "workerCount",
    "workerUrl"
];
function $1063df59c2f0f1a3$export$2e2bcd8739ae039(mapLib, props) {
    for (const key of $1063df59c2f0f1a3$var$globalSettings)if (key in props) mapLib[key] = props[key];
    const { RTLTextPlugin: RTLTextPlugin = "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js" } = props;
    if (RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === "unavailable") mapLib.setRTLTextPlugin(RTLTextPlugin, (error)=>{
        if (error) // eslint-disable-next-line
        console.error(error);
    }, true);
}


const $78be752643b8750f$export$dc7344301ae78f85 = $4YNlq.createContext(null);
function $78be752643b8750f$export$2e2bcd8739ae039(props, ref, defaultLib) {
    const mountedMapsContext = (0, $4YNlq.useContext)((0, $c630b00dd7fbe00a$export$c6c68f6e4db55944));
    const [mapInstance, setMapInstance] = (0, $4YNlq.useState)(null);
    const containerRef = (0, $4YNlq.useRef)();
    const { current: contextValue } = (0, $4YNlq.useRef)({
        mapLib: null,
        map: null
    });
    (0, $4YNlq.useEffect)(()=>{
        const mapLib = props.mapLib;
        let isMounted = true;
        let mapbox;
        Promise.resolve(mapLib || defaultLib).then((module)=>{
            if (!isMounted) return;
            if (!module) throw new Error("Invalid mapLib");
            const mapboxgl = "Map" in module ? module : module.default;
            if (!mapboxgl.Map) throw new Error("Invalid mapLib");
            // workerUrl & workerClass may change the result of supported()
            // https://github.com/visgl/react-map-gl/discussions/2027
            (0, $1063df59c2f0f1a3$export$2e2bcd8739ae039)(mapboxgl, props);
            if (!mapboxgl.supported || mapboxgl.supported(props)) {
                if (props.reuseMaps) mapbox = (0, $619b9f8377bec2c6$export$2e2bcd8739ae039).reuse(props, containerRef.current);
                if (!mapbox) mapbox = new (0, $619b9f8377bec2c6$export$2e2bcd8739ae039)(mapboxgl.Map, props, containerRef.current);
                contextValue.map = (0, $5a10e093a8bdbc41$export$2e2bcd8739ae039)(mapbox);
                contextValue.mapLib = mapboxgl;
                setMapInstance(mapbox);
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapMount(contextValue.map, props.id);
            } else throw new Error("Map is not supported by this browser");
        }).catch((error)=>{
            const { onError: onError } = props;
            if (onError) onError({
                type: "error",
                target: null,
                originalEvent: null,
                error: error
            });
            else console.error(error); // eslint-disable-line
        });
        return ()=>{
            isMounted = false;
            if (mapbox) {
                mountedMapsContext === null || mountedMapsContext === void 0 || mountedMapsContext.onMapUnmount(props.id);
                if (props.reuseMaps) mapbox.recycle();
                else mapbox.destroy();
            }
        };
    }, []);
    (0, $3e5c366e8d61cdd2$export$2e2bcd8739ae039)(()=>{
        if (mapInstance) mapInstance.setProps(props);
    });
    (0, $4YNlq.useImperativeHandle)(ref, ()=>contextValue.map, [
        mapInstance
    ]);
    const style = (0, $4YNlq.useMemo)(()=>({
            position: "relative",
            width: "100%",
            height: "100%",
            ...props.style
        }), [
        props.style
    ]);
    const CHILD_CONTAINER_STYLE = {
        height: "100%"
    };
    return $4YNlq.createElement("div", {
        id: props.id,
        ref: containerRef,
        style: style
    }, mapInstance && $4YNlq.createElement($78be752643b8750f$export$dc7344301ae78f85.Provider, {
        value: contextValue
    }, $4YNlq.createElement("div", {
        "mapboxgl-children": "",
        style: CHILD_CONTAINER_STYLE
    }, props.children)));
}


/* global document */ 
var $4YNlq = parcelRequire("4YNlq");

// This is a simplified version of
// https://github.com/facebook/react/blob/4131af3e4bf52f3a003537ec95a1655147c81270/src/renderers/dom/shared/CSSPropertyOperations.js#L62
const $870457c87aef05a8$var$unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function $870457c87aef05a8$export$cd93e47e6d398387(element, styles) {
    if (!element || !styles) return;
    const style = element.style;
    for(const key in styles){
        const value = styles[key];
        if (Number.isFinite(value) && !$870457c87aef05a8$var$unitlessNumber.test(key)) style[key] = `${value}px`;
        else style[key] = value;
    }
}




/* eslint-disable complexity,max-statements */ function $8474a65e2e0adc88$var$Marker(props, ref) {
    const { map: map, mapLib: mapLib } = (0, $4YNlq.useContext)((0, $78be752643b8750f$export$dc7344301ae78f85));
    const thisRef = (0, $4YNlq.useRef)({
        props: props
    });
    thisRef.current.props = props;
    const marker = (0, $4YNlq.useMemo)(()=>{
        let hasChildren = false;
        $4YNlq.Children.forEach(props.children, (el)=>{
            if (el) hasChildren = true;
        });
        const options = {
            ...props,
            element: hasChildren ? document.createElement("div") : null
        };
        const mk = new mapLib.Marker(options);
        mk.setLngLat([
            props.longitude,
            props.latitude
        ]);
        mk.getElement().addEventListener("click", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClick) === null || _b === void 0 || _b.call(_a, {
                type: "click",
                target: mk,
                originalEvent: e
            });
        });
        mk.on("dragstart", (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragStart) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on("drag", (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDrag) === null || _b === void 0 || _b.call(_a, evt);
        });
        mk.on("dragend", (e)=>{
            var _a, _b;
            const evt = e;
            evt.lngLat = marker.getLngLat();
            (_b = (_a = thisRef.current.props).onDragEnd) === null || _b === void 0 || _b.call(_a, evt);
        });
        return mk;
    }, []);
    (0, $4YNlq.useEffect)(()=>{
        marker.addTo(map.getMap());
        return ()=>{
            marker.remove();
        };
    }, []);
    const { longitude: longitude, latitude: latitude, offset: offset, style: style, draggable: draggable = false, popup: popup = null, rotation: rotation = 0, rotationAlignment: rotationAlignment = "auto", pitchAlignment: pitchAlignment = "auto" } = props;
    (0, $4YNlq.useEffect)(()=>{
        (0, $870457c87aef05a8$export$cd93e47e6d398387)(marker.getElement(), style);
    }, [
        style
    ]);
    (0, $4YNlq.useImperativeHandle)(ref, ()=>marker, []);
    if (marker.getLngLat().lng !== longitude || marker.getLngLat().lat !== latitude) marker.setLngLat([
        longitude,
        latitude
    ]);
    if (offset && !(0, $09c39994fff64b32$export$cb7477365ef68362)(marker.getOffset(), offset)) marker.setOffset(offset);
    if (marker.isDraggable() !== draggable) marker.setDraggable(draggable);
    if (marker.getRotation() !== rotation) marker.setRotation(rotation);
    if (marker.getRotationAlignment() !== rotationAlignment) marker.setRotationAlignment(rotationAlignment);
    if (marker.getPitchAlignment() !== pitchAlignment) marker.setPitchAlignment(pitchAlignment);
    if (marker.getPopup() !== popup) marker.setPopup(popup);
    return (0, $330fb34df360181f$exports.createPortal)(props.children, marker.getElement());
}
var $8474a65e2e0adc88$export$2e2bcd8739ae039 = (0, $4YNlq.memo)((0, $4YNlq.forwardRef)($8474a65e2e0adc88$var$Marker));




var $4YNlq = parcelRequire("4YNlq");



// Adapted from https://github.com/mapbox/mapbox-gl-js/blob/v1.13.0/src/ui/popup.js
function $3499c3c5c0920a99$var$getClassList(className) {
    return new Set(className ? className.trim().split(/\s+/) : []);
}
/* eslint-disable complexity,max-statements */ function $3499c3c5c0920a99$var$Popup(props, ref) {
    const { map: map, mapLib: mapLib } = (0, $4YNlq.useContext)((0, $78be752643b8750f$export$dc7344301ae78f85));
    const container = (0, $4YNlq.useMemo)(()=>{
        return document.createElement("div");
    }, []);
    const thisRef = (0, $4YNlq.useRef)({
        props: props
    });
    thisRef.current.props = props;
    const popup = (0, $4YNlq.useMemo)(()=>{
        const options = {
            ...props
        };
        const pp = new mapLib.Popup(options);
        pp.setLngLat([
            props.longitude,
            props.latitude
        ]);
        pp.once("open", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOpen) === null || _b === void 0 || _b.call(_a, e);
        });
        return pp;
    }, []);
    (0, $4YNlq.useEffect)(()=>{
        const onClose = (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onClose) === null || _b === void 0 || _b.call(_a, e);
        };
        popup.on("close", onClose);
        popup.setDOMContent(container).addTo(map.getMap());
        return ()=>{
            // https://github.com/visgl/react-map-gl/issues/1825
            // onClose should not be fired if the popup is removed by unmounting
            // When using React strict mode, the component is mounted twice.
            // Firing the onClose callback here would be a false signal to remove the component.
            popup.off("close", onClose);
            if (popup.isOpen()) popup.remove();
        };
    }, []);
    (0, $4YNlq.useEffect)(()=>{
        (0, $870457c87aef05a8$export$cd93e47e6d398387)(popup.getElement(), props.style);
    }, [
        props.style
    ]);
    (0, $4YNlq.useImperativeHandle)(ref, ()=>popup, []);
    if (popup.isOpen()) {
        if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) popup.setLngLat([
            props.longitude,
            props.latitude
        ]);
        if (props.offset && !(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(popup.options.offset, props.offset)) popup.setOffset(props.offset);
        if (popup.options.anchor !== props.anchor || popup.options.maxWidth !== props.maxWidth) {
            popup.options.anchor = props.anchor;
            popup.setMaxWidth(props.maxWidth);
        }
        if (popup.options.className !== props.className) {
            const prevClassList = $3499c3c5c0920a99$var$getClassList(popup.options.className);
            const nextClassList = $3499c3c5c0920a99$var$getClassList(props.className);
            for (const c of prevClassList)if (!nextClassList.has(c)) popup.removeClassName(c);
            for (const c of nextClassList)if (!prevClassList.has(c)) popup.addClassName(c);
            popup.options.className = props.className;
        }
    }
    return (0, $330fb34df360181f$exports.createPortal)(props.children, container);
}
var $3499c3c5c0920a99$export$2e2bcd8739ae039 = (0, $4YNlq.memo)((0, $4YNlq.forwardRef)($3499c3c5c0920a99$var$Popup));



var $4YNlq = parcelRequire("4YNlq");


var $4YNlq = parcelRequire("4YNlq");

function $3ebaf8f57c0d3e8d$var$useControl(onCreate, arg1, arg2, arg3) {
    const context = (0, $4YNlq.useContext)((0, $78be752643b8750f$export$dc7344301ae78f85));
    const ctrl = (0, $4YNlq.useMemo)(()=>onCreate(context), []);
    (0, $4YNlq.useEffect)(()=>{
        const opts = arg3 || arg2 || arg1;
        const onAdd = typeof arg1 === "function" && typeof arg2 === "function" ? arg1 : null;
        const onRemove = typeof arg2 === "function" ? arg2 : typeof arg1 === "function" ? arg1 : null;
        const { map: map } = context;
        if (!map.hasControl(ctrl)) {
            map.addControl(ctrl, opts === null || opts === void 0 ? void 0 : opts.position);
            if (onAdd) onAdd(context);
        }
        return ()=>{
            if (onRemove) onRemove(context);
            // Map might have been removed (parent effects are destroyed before child ones)
            if (map.hasControl(ctrl)) map.removeControl(ctrl);
        };
    }, []);
    return ctrl;
}
var $3ebaf8f57c0d3e8d$export$2e2bcd8739ae039 = $3ebaf8f57c0d3e8d$var$useControl;


function $cb6199b3bf1ddcd3$var$AttributionControl(props) {
    const ctrl = (0, $3ebaf8f57c0d3e8d$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.AttributionControl(props), {
        position: props.position
    });
    (0, $4YNlq.useEffect)(()=>{
        (0, $870457c87aef05a8$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $cb6199b3bf1ddcd3$export$2e2bcd8739ae039 = (0, $4YNlq.memo)($cb6199b3bf1ddcd3$var$AttributionControl);



var $4YNlq = parcelRequire("4YNlq");


function $9eed95a30b15d949$var$FullscreenControl(props) {
    const ctrl = (0, $3ebaf8f57c0d3e8d$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.FullscreenControl({
            container: props.containerId && document.getElementById(props.containerId)
        }), {
        position: props.position
    });
    (0, $4YNlq.useEffect)(()=>{
        (0, $870457c87aef05a8$export$cd93e47e6d398387)(ctrl._controlContainer, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $9eed95a30b15d949$export$2e2bcd8739ae039 = (0, $4YNlq.memo)($9eed95a30b15d949$var$FullscreenControl);



var $4YNlq = parcelRequire("4YNlq");


function $0284e0132deefab4$var$GeolocateControl(props, ref) {
    const thisRef = (0, $4YNlq.useRef)({
        props: props
    });
    const ctrl = (0, $3ebaf8f57c0d3e8d$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>{
        const gc = new mapLib.GeolocateControl(props);
        // Hack: fix GeolocateControl reuse
        // When using React strict mode, the component is mounted twice.
        // GeolocateControl's UI creation is asynchronous. Removing and adding it back causes the UI to be initialized twice.
        // @ts-expect-error private method
        const setupUI = gc._setupUI;
        // @ts-expect-error private method
        gc._setupUI = (args)=>{
            if (!gc._container.hasChildNodes()) setupUI(args);
        };
        gc.on("geolocate", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onGeolocate) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on("error", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onError) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on("outofmaxbounds", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onOutOfMaxBounds) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on("trackuserlocationstart", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationStart) === null || _b === void 0 || _b.call(_a, e);
        });
        gc.on("trackuserlocationend", (e)=>{
            var _a, _b;
            (_b = (_a = thisRef.current.props).onTrackUserLocationEnd) === null || _b === void 0 || _b.call(_a, e);
        });
        return gc;
    }, {
        position: props.position
    });
    thisRef.current.props = props;
    (0, $4YNlq.useImperativeHandle)(ref, ()=>ctrl, []);
    (0, $4YNlq.useEffect)(()=>{
        (0, $870457c87aef05a8$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $0284e0132deefab4$export$2e2bcd8739ae039 = (0, $4YNlq.memo)((0, $4YNlq.forwardRef)($0284e0132deefab4$var$GeolocateControl));



var $4YNlq = parcelRequire("4YNlq");


function $44ed3fab4f31a97b$var$NavigationControl(props) {
    const ctrl = (0, $3ebaf8f57c0d3e8d$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.NavigationControl(props), {
        position: props.position
    });
    (0, $4YNlq.useEffect)(()=>{
        (0, $870457c87aef05a8$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
var $44ed3fab4f31a97b$export$2e2bcd8739ae039 = (0, $4YNlq.memo)($44ed3fab4f31a97b$var$NavigationControl);



var $4YNlq = parcelRequire("4YNlq");


function $f4eda87e82c7ea4d$var$ScaleControl(props) {
    const ctrl = (0, $3ebaf8f57c0d3e8d$export$2e2bcd8739ae039)(({ mapLib: mapLib })=>new mapLib.ScaleControl(props), {
        position: props.position
    });
    const propsRef = (0, $4YNlq.useRef)(props);
    const prevProps = propsRef.current;
    propsRef.current = props;
    const { style: style } = props;
    if (props.maxWidth !== undefined && props.maxWidth !== prevProps.maxWidth) ctrl.options.maxWidth = props.maxWidth;
    if (props.unit !== undefined && props.unit !== prevProps.unit) ctrl.setUnit(props.unit);
    (0, $4YNlq.useEffect)(()=>{
        (0, $870457c87aef05a8$export$cd93e47e6d398387)(ctrl._container, style);
    }, [
        style
    ]);
    return null;
}
var $f4eda87e82c7ea4d$export$2e2bcd8739ae039 = (0, $4YNlq.memo)($f4eda87e82c7ea4d$var$ScaleControl);



var $4YNlq = parcelRequire("4YNlq");

function $f1355a1dd24a0d69$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message);
}



/* eslint-disable complexity, max-statements */ function $cbfdacc2d54c4dd6$var$updateLayer(map, id, props, prevProps) {
    (0, $f1355a1dd24a0d69$export$2e2bcd8739ae039)(props.id === prevProps.id, "layer id changed");
    (0, $f1355a1dd24a0d69$export$2e2bcd8739ae039)(props.type === prevProps.type, "layer type changed");
    if (props.type === "custom" || prevProps.type === "custom") return;
    const { layout: layout = {}, paint: paint = {}, filter: filter, minzoom: minzoom, maxzoom: maxzoom, beforeId: beforeId } = props;
    if (beforeId !== prevProps.beforeId) map.moveLayer(id, beforeId);
    if (layout !== prevProps.layout) {
        const prevLayout = prevProps.layout || {};
        for(const key in layout)if (!(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(layout[key], prevLayout[key])) map.setLayoutProperty(id, key, layout[key]);
        for(const key in prevLayout)if (!layout.hasOwnProperty(key)) map.setLayoutProperty(id, key, undefined);
    }
    if (paint !== prevProps.paint) {
        const prevPaint = prevProps.paint || {};
        for(const key in paint)if (!(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(paint[key], prevPaint[key])) map.setPaintProperty(id, key, paint[key]);
        for(const key in prevPaint)if (!paint.hasOwnProperty(key)) map.setPaintProperty(id, key, undefined);
    }
    if (!(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(filter, prevProps.filter)) map.setFilter(id, filter);
    if (minzoom !== prevProps.minzoom || maxzoom !== prevProps.maxzoom) map.setLayerZoomRange(id, minzoom, maxzoom);
}
function $cbfdacc2d54c4dd6$var$createLayer(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded && (!("source" in props) || map.getSource(props.source))) {
        const options = {
            ...props,
            id: id
        };
        delete options.beforeId;
        // @ts-ignore
        map.addLayer(options, props.beforeId);
    }
}
/* eslint-enable complexity, max-statements */ let $cbfdacc2d54c4dd6$var$layerCounter = 0;
function $cbfdacc2d54c4dd6$var$Layer(props) {
    const map = (0, $4YNlq.useContext)((0, $78be752643b8750f$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $4YNlq.useRef)(props);
    const [, setStyleLoaded] = (0, $4YNlq.useState)(0);
    const id = (0, $4YNlq.useMemo)(()=>props.id || `jsx-layer-${$cbfdacc2d54c4dd6$var$layerCounter++}`, []);
    (0, $4YNlq.useEffect)(()=>{
        if (map) {
            const forceUpdate = ()=>setStyleLoaded((version)=>version + 1);
            map.on("styledata", forceUpdate);
            forceUpdate();
            return ()=>{
                map.off("styledata", forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getLayer(id)) map.removeLayer(id);
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    const layer = map && map.style && map.getLayer(id);
    if (layer) try {
        $cbfdacc2d54c4dd6$var$updateLayer(map, id, props, propsRef.current);
    } catch (error) {
        console.warn(error); // eslint-disable-line
    }
    else $cbfdacc2d54c4dd6$var$createLayer(map, id, props);
    // Store last rendered props
    propsRef.current = props;
    return null;
}
var $cbfdacc2d54c4dd6$export$2e2bcd8739ae039 = $cbfdacc2d54c4dd6$var$Layer;



var $4YNlq = parcelRequire("4YNlq");



let $5a9d4c7270bc31ad$var$sourceCounter = 0;
function $5a9d4c7270bc31ad$var$createSource(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded) {
        const options = {
            ...props
        };
        delete options.id;
        delete options.children;
        // @ts-ignore
        map.addSource(id, options);
        return map.getSource(id);
    }
    return null;
}
/* eslint-disable complexity */ function $5a9d4c7270bc31ad$var$updateSource(source, props, prevProps) {
    (0, $f1355a1dd24a0d69$export$2e2bcd8739ae039)(props.id === prevProps.id, "source id changed");
    (0, $f1355a1dd24a0d69$export$2e2bcd8739ae039)(props.type === prevProps.type, "source type changed");
    let changedKey = "";
    let changedKeyCount = 0;
    for(const key in props)if (key !== "children" && key !== "id" && !(0, $09c39994fff64b32$export$9cb4719e2e525b7a)(prevProps[key], props[key])) {
        changedKey = key;
        changedKeyCount++;
    }
    if (!changedKeyCount) return;
    const type = props.type;
    if (type === "geojson") source.setData(props.data);
    else if (type === "image") source.updateImage({
        url: props.url,
        coordinates: props.coordinates
    });
    else if ("setCoordinates" in source && changedKeyCount === 1 && changedKey === "coordinates") source.setCoordinates(props.coordinates);
    else if ("setUrl" in source) // Added in 1.12.0:
    // vectorTileSource.setTiles
    // vectorTileSource.setUrl
    switch(changedKey){
        case "url":
            source.setUrl(props.url);
            break;
        case "tiles":
            source.setTiles(props.tiles);
            break;
        default:
    }
    else // eslint-disable-next-line
    console.warn(`Unable to update <Source> prop: ${changedKey}`);
}
/* eslint-enable complexity */ function $5a9d4c7270bc31ad$var$Source(props) {
    const map = (0, $4YNlq.useContext)((0, $78be752643b8750f$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $4YNlq.useRef)(props);
    const [, setStyleLoaded] = (0, $4YNlq.useState)(0);
    const id = (0, $4YNlq.useMemo)(()=>props.id || `jsx-source-${$5a9d4c7270bc31ad$var$sourceCounter++}`, []);
    (0, $4YNlq.useEffect)(()=>{
        if (map) {
            /* global setTimeout */ const forceUpdate = ()=>setTimeout(()=>setStyleLoaded((version)=>version + 1), 0);
            map.on("styledata", forceUpdate);
            forceUpdate();
            return ()=>{
                var _a;
                map.off("styledata", forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getSource(id)) {
                    // Parent effects are destroyed before child ones, see
                    // https://github.com/facebook/react/issues/16728
                    // Source can only be removed after all child layers are removed
                    const allLayers = (_a = map.getStyle()) === null || _a === void 0 ? void 0 : _a.layers;
                    if (allLayers) {
                        for (const layer of allLayers)// @ts-ignore (2339) source does not exist on all layer types
                        if (layer.source === id) map.removeLayer(layer.id);
                    }
                    map.removeSource(id);
                }
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    let source = map && map.style && map.getSource(id);
    if (source) $5a9d4c7270bc31ad$var$updateSource(source, props, propsRef.current);
    else source = $5a9d4c7270bc31ad$var$createSource(map, id, props);
    propsRef.current = props;
    return source && $4YNlq.Children.map(props.children, (child)=>child && (0, $4YNlq.cloneElement)(child, {
            source: id
        })) || null;
}
var $5a9d4c7270bc31ad$export$2e2bcd8739ae039 = $5a9d4c7270bc31ad$var$Source;








function $cdc123c2f2fe89f8$export$86f8f9f08863e403() {
    return (0, $c630b00dd7fbe00a$export$86f8f9f08863e403)();
}

const $cdc123c2f2fe89f8$var$mapLib = Promise.resolve((parcelRequire("7Dpty")));
const $cdc123c2f2fe89f8$export$a5c7b93649eaf8f8 = (()=>{
    return $4YNlq.forwardRef(function Map(props, ref) {
        return (0, $78be752643b8750f$export$2e2bcd8739ae039)(props, ref, $cdc123c2f2fe89f8$var$mapLib);
    });
})();
const $cdc123c2f2fe89f8$export$e98856a975cab58e = (0, $8474a65e2e0adc88$export$2e2bcd8739ae039);
const $cdc123c2f2fe89f8$export$129a32eedafa97c5 = (0, $3499c3c5c0920a99$export$2e2bcd8739ae039);
const $cdc123c2f2fe89f8$export$5af5c3cc9905683 = (0, $cb6199b3bf1ddcd3$export$2e2bcd8739ae039);
const $cdc123c2f2fe89f8$export$91e8ffb52c2b32c5 = (0, $9eed95a30b15d949$export$2e2bcd8739ae039);
const $cdc123c2f2fe89f8$export$49a437922edc1bd9 = (0, $44ed3fab4f31a97b$export$2e2bcd8739ae039);
const $cdc123c2f2fe89f8$export$15e4ff48f7e9d8e0 = (0, $0284e0132deefab4$export$2e2bcd8739ae039);
const $cdc123c2f2fe89f8$export$1fb16e435eedcce9 = (0, $f4eda87e82c7ea4d$export$2e2bcd8739ae039);
const $cdc123c2f2fe89f8$export$936d0764594b6eb3 = (0, $cbfdacc2d54c4dd6$export$2e2bcd8739ae039);
const $cdc123c2f2fe89f8$export$1d2df86270c81ecb = (0, $5a9d4c7270bc31ad$export$2e2bcd8739ae039);
var $cdc123c2f2fe89f8$export$2e2bcd8739ae039 = $cdc123c2f2fe89f8$export$a5c7b93649eaf8f8;





var $7Dpty = parcelRequire("7Dpty");

const $b39332a859acac8b$export$b1289b5cf6bef983 = ({ longitude: longitude, latitude: latitude, title: title })=>{
    const popup = (text)=>{
        return new (0, (/*@__PURE__*/$parcel$interopDefault($7Dpty))).Popup().setText(text);
    };
    return longitude && latitude && /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "font-500 mb-4",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                    variant: "h6",
                    children: "Location on map"
                })
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "w-full h-[400px] bg-amber-500",
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $cdc123c2f2fe89f8$export$2e2bcd8739ae039), {
                    mapboxAccessToken: "pk.eyJ1IjoibWlraGV5cm9qbyIsImEiOiJjbHN0NnNxaXowbzZhMmxxc2pkN2FsaWJ5In0.OTcPpx4BlZlCR4VF4FofAg",
                    cooperativeGestures: true,
                    initialViewState: {
                        longitude: longitude,
                        latitude: latitude,
                        zoom: 12
                    },
                    // style={{height: '50%'}}
                    mapStyle: "mapbox://styles/mapbox/streets-v9",
                    children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $cdc123c2f2fe89f8$export$e98856a975cab58e), {
                        longitude: longitude,
                        latitude: latitude,
                        popup: popup(title),
                        color: "red",
                        onClick: (args)=>console.log(args)
                    }, title)
                })
            })
        ]
    });
};


const $09577d8d20c5576a$export$7c799e71f5549651 = ()=>{
    const { id: id } = (0, $4fd73b9fb5b80e1f$export$99eaa27ddbbb95ef)();
    const [ads, setAdds] = (0, $4YNlq.useState)([]);
    const [ad, setAdd] = (0, $4YNlq.useState)();
    const [type, onTypeChange] = (0, $4YNlq.useState)();
    const [city, onCityChange] = (0, $4YNlq.useState)();
    const allCities = [
        ...new Set(ads.map((ad)=>ad.city))
    ].sort();
    console.log({
        allCities: allCities
    });
    (0, $4YNlq.useEffect)(()=>{
        if (!id) return;
        const fetchAds = async ()=>{
            const ad = await (0, $4f7ae60590f65051$export$e335e813e295bb79)(id);
            const ads = await (0, $4f7ae60590f65051$export$10bf54e825e44464)();
            setAdds(ads);
            setAdd(ad);
        };
        fetchAds().catch(console.error);
    }, []);
    return /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $fd3fcc825e3c65de$export$8b251419efc915eb), {
                onCityChange: onCityChange,
                onTypeChange: onTypeChange,
                cities: allCities
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $6a898b0186900018$export$73051e5675ca1011), {
                images: ad?.images
            }),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "max-w-[1024px] w-auto m-auto my-5 lg:my-20 relative p-5",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                        className: "flex gap-x-16 flex-wrap",
                        children: [
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $670a3c9067984895$export$393edc798c47379d), {
                                ...ad
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $07a5e02d8487846c$export$ac3bdfe4cb17f64e), {
                                ...ad,
                                extraClass: "lg:block hidden"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $b39332a859acac8b$export$b1289b5cf6bef983), {
                        title: ad?.name,
                        latitude: ad?.latitude,
                        longitude: ad?.longitude
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $07a5e02d8487846c$export$ac3bdfe4cb17f64e), {
                ...ad,
                extraClass: "block lg:hidden mt-5 sticky bottom-0",
                isFlatBottom: true
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $f6e406b36921f3db$export$a06f1c675e846f6f), {})
        ]
    });
};



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");






var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $f2bfea1e53ca6930$export$2a5c27c211442e3c(slot) {
    return (0, $fx4gX.default)("MuiCardActions", slot);
}
const $f2bfea1e53ca6930$var$cardActionsClasses = (0, $auO16.default)("MuiCardActions", [
    "root",
    "spacing"
]);
var $f2bfea1e53ca6930$export$2e2bcd8739ae039 = $f2bfea1e53ca6930$var$cardActionsClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $e9e97778f869c04e$var$_excluded = [
    "disableSpacing",
    "className"
];
const $e9e97778f869c04e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            "root",
            !disableSpacing && "spacing"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $f2bfea1e53ca6930$export$2a5c27c211442e3c), classes);
};
const $e9e97778f869c04e$var$CardActionsRoot = (0, $JdaC3.default)("div", {
    name: "MuiCardActions",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "flex",
        alignItems: "center",
        padding: 8
    }, !ownerState.disableSpacing && {
        "& > :not(style) ~ :not(style)": {
            marginLeft: 8
        }
    }));
const $e9e97778f869c04e$var$CardActions = /*#__PURE__*/ $4YNlq.forwardRef(function CardActions(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiCardActions"
    });
    const { disableSpacing: disableSpacing = false, className: className } = props, other = (0, $g54n0.default)(props, $e9e97778f869c04e$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $e9e97778f869c04e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($e9e97778f869c04e$var$CardActionsRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $e9e97778f869c04e$export$2e2bcd8739ae039 = $e9e97778f869c04e$var$CardActions;


var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $JdaC3 = parcelRequire("JdaC3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $49528c4fe28c62c8$export$5f5333fe417019a7(slot) {
    return (0, $fx4gX.default)("MuiCardMedia", slot);
}
const $49528c4fe28c62c8$var$cardMediaClasses = (0, $auO16.default)("MuiCardMedia", [
    "root",
    "media",
    "img"
]);
var $49528c4fe28c62c8$export$2e2bcd8739ae039 = $49528c4fe28c62c8$var$cardMediaClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $e73702f2d5dd25fc$var$_excluded = [
    "children",
    "className",
    "component",
    "image",
    "src",
    "style"
];
const $e73702f2d5dd25fc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
    const slots = {
        root: [
            "root",
            isMediaComponent && "media",
            isImageComponent && "img"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $49528c4fe28c62c8$export$5f5333fe417019a7), classes);
};
const $e73702f2d5dd25fc$var$CardMediaRoot = (0, $JdaC3.default)("div", {
    name: "MuiCardMedia",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { isMediaComponent: isMediaComponent, isImageComponent: isImageComponent } = ownerState;
        return [
            styles.root,
            isMediaComponent && styles.media,
            isImageComponent && styles.img
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "block",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
    }, ownerState.isMediaComponent && {
        width: "100%"
    }, ownerState.isImageComponent && {
        // ⚠️ object-fit is not supported by IE11.
        objectFit: "cover"
    }));
const $e73702f2d5dd25fc$var$MEDIA_COMPONENTS = [
    "video",
    "audio",
    "picture",
    "iframe",
    "img"
];
const $e73702f2d5dd25fc$var$IMAGE_COMPONENTS = [
    "picture",
    "img"
];
const $e73702f2d5dd25fc$var$CardMedia = /*#__PURE__*/ $4YNlq.forwardRef(function CardMedia(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiCardMedia"
    });
    const { children: children, className: className, component: component = "div", image: image, src: src, style: style } = props, other = (0, $g54n0.default)(props, $e73702f2d5dd25fc$var$_excluded);
    const isMediaComponent = $e73702f2d5dd25fc$var$MEDIA_COMPONENTS.indexOf(component) !== -1;
    const composedStyle = !isMediaComponent && image ? (0, $lzDk3.default)({
        backgroundImage: `url("${image}")`
    }, style) : style;
    const ownerState = (0, $lzDk3.default)({}, props, {
        component: component,
        isMediaComponent: isMediaComponent,
        isImageComponent: $e73702f2d5dd25fc$var$IMAGE_COMPONENTS.indexOf(component) !== -1
    });
    const classes = $e73702f2d5dd25fc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($e73702f2d5dd25fc$var$CardMediaRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        as: component,
        role: !isMediaComponent && image ? "img" : undefined,
        ref: ref,
        style: composedStyle,
        ownerState: ownerState,
        src: isMediaComponent ? image || src : undefined
    }, other, {
        children: children
    }));
});
var $e73702f2d5dd25fc$export$2e2bcd8739ae039 = $e73702f2d5dd25fc$var$CardMedia;



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");

var $JdaC3 = parcelRequire("JdaC3");

const $03f584aa618b156a$export$728b466dd72ac4f0 = (0, $JdaC3.default)((0, $2fd024bf1bf3be5d$export$2e2bcd8739ae039))(()=>`
    background: #56596C;
    text-transform: capitalize;
    height: 40px;
    width: 142px;
    border-radius: 2.5rem;
    font-size: 16px;
    line-height: 24px;
    &:hover {
        background: #56596D;
}`);
const $03f584aa618b156a$export$353f5b6fc5456de1 = ({ children: children, ...rest })=>{
    return /*#__PURE__*/ (0, $izf4p.jsx)($03f584aa618b156a$export$728b466dd72ac4f0, {
        ...rest,
        variant: "contained",
        children: children
    });
};




const $6e6e2197a139a572$export$1ed4b10e4aba04a7 = ()=>{
    const { user: user } = (0, $3c0e653794cf487e$export$f2b63d3ca66bb884)();
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $fd3fcc825e3c65de$export$8b251419efc915eb), {
                onTypeChange: console.log,
                cities: [],
                onCityChange: console.log,
                selectedCity: "",
                selectedType: "",
                checkOutDate: "",
                checkInDate: "",
                onCheckInDateChange: console.log,
                onCheckOutDateChange: console.log
            }),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "max-w-screen-lg mx-auto mt-8 flex",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                        className: "w-[600px] mr-[66px]",
                        children: [
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                variant: "h1",
                                sx: {
                                    my: 4
                                },
                                children: "My account"
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $48dff5681ca1c01f$export$2e2bcd8739ae039), {
                                        alt: user?.name,
                                        src: user?.picture
                                    }),
                                    /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                                        className: "ml-3",
                                        children: [
                                            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                                                children: user?.name
                                            }),
                                            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                                                className: "text-secondary",
                                                children: user?.email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                                className: "my-10",
                                children: [
                                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                        variant: "h3",
                                        children: "My bookings"
                                    }),
                                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                                        className: "text-secondary",
                                        children: "No bookings so far"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                                className: "my-10",
                                children: [
                                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                        variant: "h4",
                                        children: "My properties"
                                    }),
                                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                                        className: "text-secondary",
                                        children: "No properties so far"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        className: "mt-[47px]",
                        children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $68fba4ffcff019c8$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $izf4p.jsx)((0, $e73702f2d5dd25fc$export$2e2bcd8739ae039), {
                                    sx: {
                                        height: 140
                                    },
                                    image: "https://res.cloudinary.com/dhlzvktzj/image/upload/v1716189084/sunni/Untitleddesign-slimC1_kvzlw0.jpg",
                                    title: "green iguana"
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsxs)((0, $0ba30a51ef560ecb$export$2e2bcd8739ae039), {
                                    sx: {
                                        textAlign: "center",
                                        py: 3
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                            variant: "h5",
                                            component: "div",
                                            children: "Rent out your property"
                                        }),
                                        /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                            variant: "body2",
                                            children: "Increase your revenue"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $izf4p.jsx)((0, $e9e97778f869c04e$export$2e2bcd8739ae039), {
                                    sx: {
                                        justifyContent: "center",
                                        pb: 3
                                    },
                                    children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$a6c7ac8248d6e38a), {
                                        to: "/new",
                                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $03f584aa618b156a$export$353f5b6fc5456de1), {
                                            children: "Add property"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");


const $b6b72ebce52e7004$export$2eefd1d1c1af32ea = ()=>{
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $fd3fcc825e3c65de$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "max-w-screen-lg mx-auto mt-10",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        variant: "h3",
                        mb: 3,
                        children: "My bookings"
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                            color: "text.secondary",
                            children: "No booking found so far"
                        })
                    })
                ]
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");






const $1bbfa55c44f1ea29$export$3965927bf7a81700 = ()=>{
    const { user: user } = (0, $3c0e653794cf487e$export$f2b63d3ca66bb884)();
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $fd3fcc825e3c65de$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "max-w-screen-lg mx-auto mt-10 flex",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        className: "mr-10",
                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $68fba4ffcff019c8$export$2e2bcd8739ae039), {
                            sx: {
                                py: 2,
                                px: 4
                            },
                            children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $0ba30a51ef560ecb$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $48dff5681ca1c01f$export$2e2bcd8739ae039), {
                                        alt: "user avatar",
                                        src: user?.picture,
                                        sx: {
                                            height: "100px",
                                            width: "100px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                        children: user.name
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0, $izf4p.jsxs)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                variant: "h4",
                                mb: 3,
                                children: [
                                    "About ",
                                    user?.given_name
                                ]
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                    color: "text.secondary",
                                    children: "No description so far"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");



const $f5c06aafec330880$export$93b569af380b484c = ()=>{
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $fd3fcc825e3c65de$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "max-w-screen-lg mx-auto mt-10",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        variant: "h3",
                        mb: 3,
                        children: "Help Center"
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $f5057fce34544643$export$2e2bcd8739ae039), {
                            defaultValue: "",
                            required: true,
                            children: /*#__PURE__*/ (0, $izf4p.jsx)("input", {
                                placeholder: "Describe your problem"
                            })
                        })
                    })
                ]
            })
        ]
    });
};



var $4YNlq = parcelRequire("4YNlq");
function $cf9f81c2bcfba224$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $d9c0aa3d82976bec$var$e = [
    {
        code: "AD",
        emoji: "\uD83C\uDDE6\uD83C\uDDE9",
        unicode: "U+1F1E6 U+1F1E9",
        name: "Andorra",
        title: "flag for Andorra",
        dialCode: "+376"
    },
    {
        code: "AE",
        emoji: "\uD83C\uDDE6\uD83C\uDDEA",
        unicode: "U+1F1E6 U+1F1EA",
        name: "United Arab Emirates",
        title: "flag for United Arab Emirates",
        dialCode: "+971"
    },
    {
        code: "AF",
        emoji: "\uD83C\uDDE6\uD83C\uDDEB",
        unicode: "U+1F1E6 U+1F1EB",
        name: "Afghanistan",
        title: "flag for Afghanistan",
        dialCode: "+93"
    },
    {
        code: "AG",
        emoji: "\uD83C\uDDE6\uD83C\uDDEC",
        unicode: "U+1F1E6 U+1F1EC",
        name: "Antigua and Barbuda",
        title: "flag for Antigua and Barbuda",
        dialCode: "+1268"
    },
    {
        code: "AI",
        emoji: "\uD83C\uDDE6\uD83C\uDDEE",
        unicode: "U+1F1E6 U+1F1EE",
        name: "Anguilla",
        title: "flag for Anguilla",
        dialCode: "+1 264"
    },
    {
        code: "AL",
        emoji: "\uD83C\uDDE6\uD83C\uDDF1",
        unicode: "U+1F1E6 U+1F1F1",
        name: "Albania",
        title: "flag for Albania",
        dialCode: "+355"
    },
    {
        code: "AM",
        emoji: "\uD83C\uDDE6\uD83C\uDDF2",
        unicode: "U+1F1E6 U+1F1F2",
        name: "Armenia",
        title: "flag for Armenia",
        dialCode: "+374"
    },
    {
        code: "AO",
        emoji: "\uD83C\uDDE6\uD83C\uDDF4",
        unicode: "U+1F1E6 U+1F1F4",
        name: "Angola",
        title: "flag for Angola",
        dialCode: "+244"
    },
    {
        code: "AQ",
        emoji: "\uD83C\uDDE6\uD83C\uDDF6",
        unicode: "U+1F1E6 U+1F1F6",
        name: "Antarctica",
        title: "flag for Antarctica",
        dialCode: null
    },
    {
        code: "AR",
        emoji: "\uD83C\uDDE6\uD83C\uDDF7",
        unicode: "U+1F1E6 U+1F1F7",
        name: "Argentina",
        title: "flag for Argentina",
        dialCode: "+54"
    },
    {
        code: "AS",
        emoji: "\uD83C\uDDE6\uD83C\uDDF8",
        unicode: "U+1F1E6 U+1F1F8",
        name: "American Samoa",
        title: "flag for American Samoa",
        dialCode: "+1 684"
    },
    {
        code: "AT",
        emoji: "\uD83C\uDDE6\uD83C\uDDF9",
        unicode: "U+1F1E6 U+1F1F9",
        name: "Austria",
        title: "flag for Austria",
        dialCode: "+43"
    },
    {
        code: "AU",
        emoji: "\uD83C\uDDE6\uD83C\uDDFA",
        unicode: "U+1F1E6 U+1F1FA",
        name: "Australia",
        title: "flag for Australia",
        dialCode: "+61"
    },
    {
        code: "AW",
        emoji: "\uD83C\uDDE6\uD83C\uDDFC",
        unicode: "U+1F1E6 U+1F1FC",
        name: "Aruba",
        title: "flag for Aruba",
        dialCode: "+297"
    },
    {
        code: "AX",
        emoji: "\uD83C\uDDE6\uD83C\uDDFD",
        unicode: "U+1F1E6 U+1F1FD",
        name: "\xc5land Islands",
        title: "flag for \xc5land Islands",
        dialCode: ""
    },
    {
        code: "AZ",
        emoji: "\uD83C\uDDE6\uD83C\uDDFF",
        unicode: "U+1F1E6 U+1F1FF",
        name: "Azerbaijan",
        title: "flag for Azerbaijan",
        dialCode: "+994"
    },
    {
        code: "BA",
        emoji: "\uD83C\uDDE7\uD83C\uDDE6",
        unicode: "U+1F1E7 U+1F1E6",
        name: "Bosnia and Herzegovina",
        title: "flag for Bosnia and Herzegovina",
        dialCode: "+387"
    },
    {
        code: "BB",
        emoji: "\uD83C\uDDE7\uD83C\uDDE7",
        unicode: "U+1F1E7 U+1F1E7",
        name: "Barbados",
        title: "flag for Barbados",
        dialCode: "+1 246"
    },
    {
        code: "BD",
        emoji: "\uD83C\uDDE7\uD83C\uDDE9",
        unicode: "U+1F1E7 U+1F1E9",
        name: "Bangladesh",
        title: "flag for Bangladesh",
        dialCode: "+880"
    },
    {
        code: "BE",
        emoji: "\uD83C\uDDE7\uD83C\uDDEA",
        unicode: "U+1F1E7 U+1F1EA",
        name: "Belgium",
        title: "flag for Belgium",
        dialCode: "+32"
    },
    {
        code: "BF",
        emoji: "\uD83C\uDDE7\uD83C\uDDEB",
        unicode: "U+1F1E7 U+1F1EB",
        name: "Burkina Faso",
        title: "flag for Burkina Faso",
        dialCode: "+226"
    },
    {
        code: "BG",
        emoji: "\uD83C\uDDE7\uD83C\uDDEC",
        unicode: "U+1F1E7 U+1F1EC",
        name: "Bulgaria",
        title: "flag for Bulgaria",
        dialCode: "+359"
    },
    {
        code: "BH",
        emoji: "\uD83C\uDDE7\uD83C\uDDED",
        unicode: "U+1F1E7 U+1F1ED",
        name: "Bahrain",
        title: "flag for Bahrain",
        dialCode: "+973"
    },
    {
        code: "BI",
        emoji: "\uD83C\uDDE7\uD83C\uDDEE",
        unicode: "U+1F1E7 U+1F1EE",
        name: "Burundi",
        title: "flag for Burundi",
        dialCode: "+257"
    },
    {
        code: "BJ",
        emoji: "\uD83C\uDDE7\uD83C\uDDEF",
        unicode: "U+1F1E7 U+1F1EF",
        name: "Benin",
        title: "flag for Benin",
        dialCode: "+229"
    },
    {
        code: "BL",
        emoji: "\uD83C\uDDE7\uD83C\uDDF1",
        unicode: "U+1F1E7 U+1F1F1",
        name: "Saint Barth\xe9lemy",
        title: "flag for Saint Barth\xe9lemy",
        dialCode: "+590"
    },
    {
        code: "BM",
        emoji: "\uD83C\uDDE7\uD83C\uDDF2",
        unicode: "U+1F1E7 U+1F1F2",
        name: "Bermuda",
        title: "flag for Bermuda",
        dialCode: "+1 441"
    },
    {
        code: "BN",
        emoji: "\uD83C\uDDE7\uD83C\uDDF3",
        unicode: "U+1F1E7 U+1F1F3",
        name: "Brunei Darussalam",
        title: "flag for Brunei Darussalam",
        dialCode: "+673"
    },
    {
        code: "BO",
        emoji: "\uD83C\uDDE7\uD83C\uDDF4",
        unicode: "U+1F1E7 U+1F1F4",
        name: "Bolivia",
        title: "flag for Bolivia",
        dialCode: "+591"
    },
    {
        code: "BQ",
        emoji: "\uD83C\uDDE7\uD83C\uDDF6",
        unicode: "U+1F1E7 U+1F1F6",
        name: "Bonaire, Sint Eustatius and Saba",
        title: "flag for Bonaire, Sint Eustatius and Saba"
    },
    {
        code: "BR",
        emoji: "\uD83C\uDDE7\uD83C\uDDF7",
        unicode: "U+1F1E7 U+1F1F7",
        name: "Brazil",
        title: "flag for Brazil",
        dialCode: "+55"
    },
    {
        code: "BS",
        emoji: "\uD83C\uDDE7\uD83C\uDDF8",
        unicode: "U+1F1E7 U+1F1F8",
        name: "Bahamas",
        title: "flag for Bahamas",
        dialCode: "+1 242"
    },
    {
        code: "BT",
        emoji: "\uD83C\uDDE7\uD83C\uDDF9",
        unicode: "U+1F1E7 U+1F1F9",
        name: "Bhutan",
        title: "flag for Bhutan",
        dialCode: "+975"
    },
    {
        code: "BV",
        emoji: "\uD83C\uDDE7\uD83C\uDDFB",
        unicode: "U+1F1E7 U+1F1FB",
        name: "Bouvet Island",
        title: "flag for Bouvet Island"
    },
    {
        code: "BW",
        emoji: "\uD83C\uDDE7\uD83C\uDDFC",
        unicode: "U+1F1E7 U+1F1FC",
        name: "Botswana",
        title: "flag for Botswana",
        dialCode: "+267"
    },
    {
        code: "BY",
        emoji: "\uD83C\uDDE7\uD83C\uDDFE",
        unicode: "U+1F1E7 U+1F1FE",
        name: "Belarus",
        title: "flag for Belarus",
        dialCode: "+375"
    },
    {
        code: "BZ",
        emoji: "\uD83C\uDDE7\uD83C\uDDFF",
        unicode: "U+1F1E7 U+1F1FF",
        name: "Belize",
        title: "flag for Belize",
        dialCode: "+501"
    },
    {
        code: "CA",
        emoji: "\uD83C\uDDE8\uD83C\uDDE6",
        unicode: "U+1F1E8 U+1F1E6",
        name: "Canada",
        title: "flag for Canada",
        dialCode: "+1"
    },
    {
        code: "CC",
        emoji: "\uD83C\uDDE8\uD83C\uDDE8",
        unicode: "U+1F1E8 U+1F1E8",
        name: "Cocos (Keeling) Islands",
        title: "flag for Cocos (Keeling) Islands",
        dialCode: "+61"
    },
    {
        code: "CD",
        emoji: "\uD83C\uDDE8\uD83C\uDDE9",
        unicode: "U+1F1E8 U+1F1E9",
        name: "Congo",
        title: "flag for Congo",
        dialCode: "+243"
    },
    {
        code: "CF",
        emoji: "\uD83C\uDDE8\uD83C\uDDEB",
        unicode: "U+1F1E8 U+1F1EB",
        name: "Central African Republic",
        title: "flag for Central African Republic",
        dialCode: "+236"
    },
    {
        code: "CG",
        emoji: "\uD83C\uDDE8\uD83C\uDDEC",
        unicode: "U+1F1E8 U+1F1EC",
        name: "Congo",
        title: "flag for Congo",
        dialCode: "+242"
    },
    {
        code: "CH",
        emoji: "\uD83C\uDDE8\uD83C\uDDED",
        unicode: "U+1F1E8 U+1F1ED",
        name: "Switzerland",
        title: "flag for Switzerland",
        dialCode: "+41"
    },
    {
        code: "CI",
        emoji: "\uD83C\uDDE8\uD83C\uDDEE",
        unicode: "U+1F1E8 U+1F1EE",
        name: "C\xf4te D'Ivoire",
        title: "flag for C\xf4te D'Ivoire",
        dialCode: "+225"
    },
    {
        code: "CK",
        emoji: "\uD83C\uDDE8\uD83C\uDDF0",
        unicode: "U+1F1E8 U+1F1F0",
        name: "Cook Islands",
        title: "flag for Cook Islands",
        dialCode: "+682"
    },
    {
        code: "CL",
        emoji: "\uD83C\uDDE8\uD83C\uDDF1",
        unicode: "U+1F1E8 U+1F1F1",
        name: "Chile",
        title: "flag for Chile",
        dialCode: "+56"
    },
    {
        code: "CM",
        emoji: "\uD83C\uDDE8\uD83C\uDDF2",
        unicode: "U+1F1E8 U+1F1F2",
        name: "Cameroon",
        title: "flag for Cameroon",
        dialCode: "+237"
    },
    {
        code: "CN",
        emoji: "\uD83C\uDDE8\uD83C\uDDF3",
        unicode: "U+1F1E8 U+1F1F3",
        name: "China",
        title: "flag for China",
        dialCode: "+86"
    },
    {
        code: "CO",
        emoji: "\uD83C\uDDE8\uD83C\uDDF4",
        unicode: "U+1F1E8 U+1F1F4",
        name: "Colombia",
        title: "flag for Colombia",
        dialCode: "+57"
    },
    {
        code: "CR",
        emoji: "\uD83C\uDDE8\uD83C\uDDF7",
        unicode: "U+1F1E8 U+1F1F7",
        name: "Costa Rica",
        title: "flag for Costa Rica",
        dialCode: "+506"
    },
    {
        code: "CU",
        emoji: "\uD83C\uDDE8\uD83C\uDDFA",
        unicode: "U+1F1E8 U+1F1FA",
        name: "Cuba",
        title: "flag for Cuba",
        dialCode: "+53"
    },
    {
        code: "CV",
        emoji: "\uD83C\uDDE8\uD83C\uDDFB",
        unicode: "U+1F1E8 U+1F1FB",
        name: "Cape Verde",
        title: "flag for Cape Verde",
        dialCode: "+238"
    },
    {
        code: "CW",
        emoji: "\uD83C\uDDE8\uD83C\uDDFC",
        unicode: "U+1F1E8 U+1F1FC",
        name: "Cura\xe7ao",
        title: "flag for Cura\xe7ao"
    },
    {
        code: "CX",
        emoji: "\uD83C\uDDE8\uD83C\uDDFD",
        unicode: "U+1F1E8 U+1F1FD",
        name: "Christmas Island",
        title: "flag for Christmas Island",
        dialCode: "+61"
    },
    {
        code: "CY",
        emoji: "\uD83C\uDDE8\uD83C\uDDFE",
        unicode: "U+1F1E8 U+1F1FE",
        name: "Cyprus",
        title: "flag for Cyprus",
        dialCode: "+537"
    },
    {
        code: "CZ",
        emoji: "\uD83C\uDDE8\uD83C\uDDFF",
        unicode: "U+1F1E8 U+1F1FF",
        name: "Czech Republic",
        title: "flag for Czech Republic",
        dialCode: "+420"
    },
    {
        code: "DE",
        emoji: "\uD83C\uDDE9\uD83C\uDDEA",
        unicode: "U+1F1E9 U+1F1EA",
        name: "Germany",
        title: "flag for Germany",
        dialCode: "+49"
    },
    {
        code: "DJ",
        emoji: "\uD83C\uDDE9\uD83C\uDDEF",
        unicode: "U+1F1E9 U+1F1EF",
        name: "Djibouti",
        title: "flag for Djibouti",
        dialCode: "+253"
    },
    {
        code: "DK",
        emoji: "\uD83C\uDDE9\uD83C\uDDF0",
        unicode: "U+1F1E9 U+1F1F0",
        name: "Denmark",
        title: "flag for Denmark",
        dialCode: "+45"
    },
    {
        code: "DM",
        emoji: "\uD83C\uDDE9\uD83C\uDDF2",
        unicode: "U+1F1E9 U+1F1F2",
        name: "Dominica",
        title: "flag for Dominica",
        dialCode: "+1 767"
    },
    {
        code: "DO",
        emoji: "\uD83C\uDDE9\uD83C\uDDF4",
        unicode: "U+1F1E9 U+1F1F4",
        name: "Dominican Republic",
        title: "flag for Dominican Republic",
        dialCode: "+1 849"
    },
    {
        code: "DZ",
        emoji: "\uD83C\uDDE9\uD83C\uDDFF",
        unicode: "U+1F1E9 U+1F1FF",
        name: "Algeria",
        title: "flag for Algeria",
        dialCode: "+213"
    },
    {
        code: "EC",
        emoji: "\uD83C\uDDEA\uD83C\uDDE8",
        unicode: "U+1F1EA U+1F1E8",
        name: "Ecuador",
        title: "flag for Ecuador",
        dialCode: "+593"
    },
    {
        code: "EE",
        emoji: "\uD83C\uDDEA\uD83C\uDDEA",
        unicode: "U+1F1EA U+1F1EA",
        name: "Estonia",
        title: "flag for Estonia",
        dialCode: "+372"
    },
    {
        code: "EG",
        emoji: "\uD83C\uDDEA\uD83C\uDDEC",
        unicode: "U+1F1EA U+1F1EC",
        name: "Egypt",
        title: "flag for Egypt",
        dialCode: "+20"
    },
    {
        code: "EH",
        emoji: "\uD83C\uDDEA\uD83C\uDDED",
        unicode: "U+1F1EA U+1F1ED",
        name: "Western Sahara",
        title: "flag for Western Sahara"
    },
    {
        code: "ER",
        emoji: "\uD83C\uDDEA\uD83C\uDDF7",
        unicode: "U+1F1EA U+1F1F7",
        name: "Eritrea",
        title: "flag for Eritrea",
        dialCode: "+291"
    },
    {
        code: "ES",
        emoji: "\uD83C\uDDEA\uD83C\uDDF8",
        unicode: "U+1F1EA U+1F1F8",
        name: "Spain",
        title: "flag for Spain",
        dialCode: "+34"
    },
    {
        code: "ET",
        emoji: "\uD83C\uDDEA\uD83C\uDDF9",
        unicode: "U+1F1EA U+1F1F9",
        name: "Ethiopia",
        title: "flag for Ethiopia",
        dialCode: "+251"
    },
    {
        code: "EU",
        emoji: "\uD83C\uDDEA\uD83C\uDDFA",
        unicode: "U+1F1EA U+1F1FA",
        name: "European Union",
        title: "flag for European Union"
    },
    {
        code: "FI",
        emoji: "\uD83C\uDDEB\uD83C\uDDEE",
        unicode: "U+1F1EB U+1F1EE",
        name: "Finland",
        title: "flag for Finland",
        dialCode: "+358"
    },
    {
        code: "FJ",
        emoji: "\uD83C\uDDEB\uD83C\uDDEF",
        unicode: "U+1F1EB U+1F1EF",
        name: "Fiji",
        title: "flag for Fiji",
        dialCode: "+679"
    },
    {
        code: "FK",
        emoji: "\uD83C\uDDEB\uD83C\uDDF0",
        unicode: "U+1F1EB U+1F1F0",
        name: "Falkland Islands (Malvinas)",
        title: "flag for Falkland Islands (Malvinas)",
        dialCode: "+500"
    },
    {
        code: "FM",
        emoji: "\uD83C\uDDEB\uD83C\uDDF2",
        unicode: "U+1F1EB U+1F1F2",
        name: "Micronesia",
        title: "flag for Micronesia",
        dialCode: "+691"
    },
    {
        code: "FO",
        emoji: "\uD83C\uDDEB\uD83C\uDDF4",
        unicode: "U+1F1EB U+1F1F4",
        name: "Faroe Islands",
        title: "flag for Faroe Islands",
        dialCode: "+298"
    },
    {
        code: "FR",
        emoji: "\uD83C\uDDEB\uD83C\uDDF7",
        unicode: "U+1F1EB U+1F1F7",
        name: "France",
        title: "flag for France",
        dialCode: "+33"
    },
    {
        code: "GA",
        emoji: "\uD83C\uDDEC\uD83C\uDDE6",
        unicode: "U+1F1EC U+1F1E6",
        name: "Gabon",
        title: "flag for Gabon",
        dialCode: "+241"
    },
    {
        code: "GB",
        emoji: "\uD83C\uDDEC\uD83C\uDDE7",
        unicode: "U+1F1EC U+1F1E7",
        name: "United Kingdom",
        title: "flag for United Kingdom",
        dialCode: "+44"
    },
    {
        code: "GD",
        emoji: "\uD83C\uDDEC\uD83C\uDDE9",
        unicode: "U+1F1EC U+1F1E9",
        name: "Grenada",
        title: "flag for Grenada",
        dialCode: "+1 473"
    },
    {
        code: "GE",
        emoji: "\uD83C\uDDEC\uD83C\uDDEA",
        unicode: "U+1F1EC U+1F1EA",
        name: "Georgia",
        title: "flag for Georgia",
        dialCode: "+995"
    },
    {
        code: "GF",
        emoji: "\uD83C\uDDEC\uD83C\uDDEB",
        unicode: "U+1F1EC U+1F1EB",
        name: "French Guiana",
        title: "flag for French Guiana",
        dialCode: "+594"
    },
    {
        code: "GG",
        emoji: "\uD83C\uDDEC\uD83C\uDDEC",
        unicode: "U+1F1EC U+1F1EC",
        name: "Guernsey",
        title: "flag for Guernsey",
        dialCode: "+44"
    },
    {
        code: "GH",
        emoji: "\uD83C\uDDEC\uD83C\uDDED",
        unicode: "U+1F1EC U+1F1ED",
        name: "Ghana",
        title: "flag for Ghana",
        dialCode: "+233"
    },
    {
        code: "GI",
        emoji: "\uD83C\uDDEC\uD83C\uDDEE",
        unicode: "U+1F1EC U+1F1EE",
        name: "Gibraltar",
        title: "flag for Gibraltar",
        dialCode: "+350"
    },
    {
        code: "GL",
        emoji: "\uD83C\uDDEC\uD83C\uDDF1",
        unicode: "U+1F1EC U+1F1F1",
        name: "Greenland",
        title: "flag for Greenland",
        dialCode: "+299"
    },
    {
        code: "GM",
        emoji: "\uD83C\uDDEC\uD83C\uDDF2",
        unicode: "U+1F1EC U+1F1F2",
        name: "Gambia",
        title: "flag for Gambia",
        dialCode: "+220"
    },
    {
        code: "GN",
        emoji: "\uD83C\uDDEC\uD83C\uDDF3",
        unicode: "U+1F1EC U+1F1F3",
        name: "Guinea",
        title: "flag for Guinea",
        dialCode: "+224"
    },
    {
        code: "GP",
        emoji: "\uD83C\uDDEC\uD83C\uDDF5",
        unicode: "U+1F1EC U+1F1F5",
        name: "Guadeloupe",
        title: "flag for Guadeloupe",
        dialCode: "+590"
    },
    {
        code: "GQ",
        emoji: "\uD83C\uDDEC\uD83C\uDDF6",
        unicode: "U+1F1EC U+1F1F6",
        name: "Equatorial Guinea",
        title: "flag for Equatorial Guinea",
        dialCode: "+240"
    },
    {
        code: "GR",
        emoji: "\uD83C\uDDEC\uD83C\uDDF7",
        unicode: "U+1F1EC U+1F1F7",
        name: "Greece",
        title: "flag for Greece",
        dialCode: "+30"
    },
    {
        code: "GS",
        emoji: "\uD83C\uDDEC\uD83C\uDDF8",
        unicode: "U+1F1EC U+1F1F8",
        name: "South Georgia",
        title: "flag for South Georgia",
        dialCode: "+500"
    },
    {
        code: "GT",
        emoji: "\uD83C\uDDEC\uD83C\uDDF9",
        unicode: "U+1F1EC U+1F1F9",
        name: "Guatemala",
        title: "flag for Guatemala",
        dialCode: "+502"
    },
    {
        code: "GU",
        emoji: "\uD83C\uDDEC\uD83C\uDDFA",
        unicode: "U+1F1EC U+1F1FA",
        name: "Guam",
        title: "flag for Guam",
        dialCode: "+1 671"
    },
    {
        code: "GW",
        emoji: "\uD83C\uDDEC\uD83C\uDDFC",
        unicode: "U+1F1EC U+1F1FC",
        name: "Guinea-Bissau",
        title: "flag for Guinea-Bissau",
        dialCode: "+245"
    },
    {
        code: "GY",
        emoji: "\uD83C\uDDEC\uD83C\uDDFE",
        unicode: "U+1F1EC U+1F1FE",
        name: "Guyana",
        title: "flag for Guyana",
        dialCode: "+595"
    },
    {
        code: "HK",
        emoji: "\uD83C\uDDED\uD83C\uDDF0",
        unicode: "U+1F1ED U+1F1F0",
        name: "Hong Kong",
        title: "flag for Hong Kong",
        dialCode: "+852"
    },
    {
        code: "HM",
        emoji: "\uD83C\uDDED\uD83C\uDDF2",
        unicode: "U+1F1ED U+1F1F2",
        name: "Heard Island and Mcdonald Islands",
        title: "flag for Heard Island and Mcdonald Islands"
    },
    {
        code: "HN",
        emoji: "\uD83C\uDDED\uD83C\uDDF3",
        unicode: "U+1F1ED U+1F1F3",
        name: "Honduras",
        title: "flag for Honduras",
        dialCode: "+504"
    },
    {
        code: "HR",
        emoji: "\uD83C\uDDED\uD83C\uDDF7",
        unicode: "U+1F1ED U+1F1F7",
        name: "Croatia",
        title: "flag for Croatia",
        dialCode: "+385"
    },
    {
        code: "HT",
        emoji: "\uD83C\uDDED\uD83C\uDDF9",
        unicode: "U+1F1ED U+1F1F9",
        name: "Haiti",
        title: "flag for Haiti",
        dialCode: "+509"
    },
    {
        code: "HU",
        emoji: "\uD83C\uDDED\uD83C\uDDFA",
        unicode: "U+1F1ED U+1F1FA",
        name: "Hungary",
        title: "flag for Hungary",
        dialCode: "+36"
    },
    {
        code: "ID",
        emoji: "\uD83C\uDDEE\uD83C\uDDE9",
        unicode: "U+1F1EE U+1F1E9",
        name: "Indonesia",
        title: "flag for Indonesia",
        dialCode: "+62"
    },
    {
        code: "IE",
        emoji: "\uD83C\uDDEE\uD83C\uDDEA",
        unicode: "U+1F1EE U+1F1EA",
        name: "Ireland",
        title: "flag for Ireland",
        dialCode: "+353"
    },
    {
        code: "IL",
        emoji: "\uD83C\uDDEE\uD83C\uDDF1",
        unicode: "U+1F1EE U+1F1F1",
        name: "Israel",
        title: "flag for Israel",
        dialCode: "+972"
    },
    {
        code: "IM",
        emoji: "\uD83C\uDDEE\uD83C\uDDF2",
        unicode: "U+1F1EE U+1F1F2",
        name: "Isle of Man",
        title: "flag for Isle of Man",
        dialCode: "+44"
    },
    {
        code: "IN",
        emoji: "\uD83C\uDDEE\uD83C\uDDF3",
        unicode: "U+1F1EE U+1F1F3",
        name: "India",
        title: "flag for India",
        dialCode: "+91"
    },
    {
        code: "IO",
        emoji: "\uD83C\uDDEE\uD83C\uDDF4",
        unicode: "U+1F1EE U+1F1F4",
        name: "British Indian Ocean Territory",
        title: "flag for British Indian Ocean Territory",
        dialCode: "+246"
    },
    {
        code: "IQ",
        emoji: "\uD83C\uDDEE\uD83C\uDDF6",
        unicode: "U+1F1EE U+1F1F6",
        name: "Iraq",
        title: "flag for Iraq",
        dialCode: "+964"
    },
    {
        code: "IR",
        emoji: "\uD83C\uDDEE\uD83C\uDDF7",
        unicode: "U+1F1EE U+1F1F7",
        name: "Iran",
        title: "flag for Iran",
        dialCode: "+98"
    },
    {
        code: "IS",
        emoji: "\uD83C\uDDEE\uD83C\uDDF8",
        unicode: "U+1F1EE U+1F1F8",
        name: "Iceland",
        title: "flag for Iceland",
        dialCode: "+354"
    },
    {
        code: "IT",
        emoji: "\uD83C\uDDEE\uD83C\uDDF9",
        unicode: "U+1F1EE U+1F1F9",
        name: "Italy",
        title: "flag for Italy",
        dialCode: "+39"
    },
    {
        code: "JE",
        emoji: "\uD83C\uDDEF\uD83C\uDDEA",
        unicode: "U+1F1EF U+1F1EA",
        name: "Jersey",
        title: "flag for Jersey",
        dialCode: "+44"
    },
    {
        code: "JM",
        emoji: "\uD83C\uDDEF\uD83C\uDDF2",
        unicode: "U+1F1EF U+1F1F2",
        name: "Jamaica",
        title: "flag for Jamaica",
        dialCode: "+1 876"
    },
    {
        code: "JO",
        emoji: "\uD83C\uDDEF\uD83C\uDDF4",
        unicode: "U+1F1EF U+1F1F4",
        name: "Jordan",
        title: "flag for Jordan",
        dialCode: "+962"
    },
    {
        code: "JP",
        emoji: "\uD83C\uDDEF\uD83C\uDDF5",
        unicode: "U+1F1EF U+1F1F5",
        name: "Japan",
        title: "flag for Japan",
        dialCode: "+81"
    },
    {
        code: "KE",
        emoji: "\uD83C\uDDF0\uD83C\uDDEA",
        unicode: "U+1F1F0 U+1F1EA",
        name: "Kenya",
        title: "flag for Kenya",
        dialCode: "+254"
    },
    {
        code: "KG",
        emoji: "\uD83C\uDDF0\uD83C\uDDEC",
        unicode: "U+1F1F0 U+1F1EC",
        name: "Kyrgyzstan",
        title: "flag for Kyrgyzstan",
        dialCode: "+996"
    },
    {
        code: "KH",
        emoji: "\uD83C\uDDF0\uD83C\uDDED",
        unicode: "U+1F1F0 U+1F1ED",
        name: "Cambodia",
        title: "flag for Cambodia",
        dialCode: "+855"
    },
    {
        code: "KI",
        emoji: "\uD83C\uDDF0\uD83C\uDDEE",
        unicode: "U+1F1F0 U+1F1EE",
        name: "Kiribati",
        title: "flag for Kiribati",
        dialCode: "+686"
    },
    {
        code: "KM",
        emoji: "\uD83C\uDDF0\uD83C\uDDF2",
        unicode: "U+1F1F0 U+1F1F2",
        name: "Comoros",
        title: "flag for Comoros",
        dialCode: "+269"
    },
    {
        code: "KN",
        emoji: "\uD83C\uDDF0\uD83C\uDDF3",
        unicode: "U+1F1F0 U+1F1F3",
        name: "Saint Kitts and Nevis",
        title: "flag for Saint Kitts and Nevis",
        dialCode: "+1 869"
    },
    {
        code: "KP",
        emoji: "\uD83C\uDDF0\uD83C\uDDF5",
        unicode: "U+1F1F0 U+1F1F5",
        name: "North Korea",
        title: "flag for North Korea",
        dialCode: "+850"
    },
    {
        code: "KR",
        emoji: "\uD83C\uDDF0\uD83C\uDDF7",
        unicode: "U+1F1F0 U+1F1F7",
        name: "South Korea",
        title: "flag for South Korea",
        dialCode: "+82"
    },
    {
        code: "KW",
        emoji: "\uD83C\uDDF0\uD83C\uDDFC",
        unicode: "U+1F1F0 U+1F1FC",
        name: "Kuwait",
        title: "flag for Kuwait",
        dialCode: "+965"
    },
    {
        code: "KY",
        emoji: "\uD83C\uDDF0\uD83C\uDDFE",
        unicode: "U+1F1F0 U+1F1FE",
        name: "Cayman Islands",
        title: "flag for Cayman Islands",
        dialCode: "+ 345"
    },
    {
        code: "KZ",
        emoji: "\uD83C\uDDF0\uD83C\uDDFF",
        unicode: "U+1F1F0 U+1F1FF",
        name: "Kazakhstan",
        title: "flag for Kazakhstan",
        dialCode: "+7 7"
    },
    {
        code: "LA",
        emoji: "\uD83C\uDDF1\uD83C\uDDE6",
        unicode: "U+1F1F1 U+1F1E6",
        name: "Lao People's Democratic Republic",
        title: "flag for Lao People's Democratic Republic",
        dialCode: "+856"
    },
    {
        code: "LB",
        emoji: "\uD83C\uDDF1\uD83C\uDDE7",
        unicode: "U+1F1F1 U+1F1E7",
        name: "Lebanon",
        title: "flag for Lebanon",
        dialCode: "+961"
    },
    {
        code: "LC",
        emoji: "\uD83C\uDDF1\uD83C\uDDE8",
        unicode: "U+1F1F1 U+1F1E8",
        name: "Saint Lucia",
        title: "flag for Saint Lucia",
        dialCode: "+1 758"
    },
    {
        code: "LI",
        emoji: "\uD83C\uDDF1\uD83C\uDDEE",
        unicode: "U+1F1F1 U+1F1EE",
        name: "Liechtenstein",
        title: "flag for Liechtenstein",
        dialCode: "+423"
    },
    {
        code: "LK",
        emoji: "\uD83C\uDDF1\uD83C\uDDF0",
        unicode: "U+1F1F1 U+1F1F0",
        name: "Sri Lanka",
        title: "flag for Sri Lanka",
        dialCode: "+94"
    },
    {
        code: "LR",
        emoji: "\uD83C\uDDF1\uD83C\uDDF7",
        unicode: "U+1F1F1 U+1F1F7",
        name: "Liberia",
        title: "flag for Liberia",
        dialCode: "+231"
    },
    {
        code: "LS",
        emoji: "\uD83C\uDDF1\uD83C\uDDF8",
        unicode: "U+1F1F1 U+1F1F8",
        name: "Lesotho",
        title: "flag for Lesotho",
        dialCode: "+266"
    },
    {
        code: "LT",
        emoji: "\uD83C\uDDF1\uD83C\uDDF9",
        unicode: "U+1F1F1 U+1F1F9",
        name: "Lithuania",
        title: "flag for Lithuania",
        dialCode: "+370"
    },
    {
        code: "LU",
        emoji: "\uD83C\uDDF1\uD83C\uDDFA",
        unicode: "U+1F1F1 U+1F1FA",
        name: "Luxembourg",
        title: "flag for Luxembourg",
        dialCode: "+352"
    },
    {
        code: "LV",
        emoji: "\uD83C\uDDF1\uD83C\uDDFB",
        unicode: "U+1F1F1 U+1F1FB",
        name: "Latvia",
        title: "flag for Latvia",
        dialCode: "+371"
    },
    {
        code: "LY",
        emoji: "\uD83C\uDDF1\uD83C\uDDFE",
        unicode: "U+1F1F1 U+1F1FE",
        name: "Libya",
        title: "flag for Libya",
        dialCode: "+218"
    },
    {
        code: "MA",
        emoji: "\uD83C\uDDF2\uD83C\uDDE6",
        unicode: "U+1F1F2 U+1F1E6",
        name: "Morocco",
        title: "flag for Morocco",
        dialCode: "+212"
    },
    {
        code: "MC",
        emoji: "\uD83C\uDDF2\uD83C\uDDE8",
        unicode: "U+1F1F2 U+1F1E8",
        name: "Monaco",
        title: "flag for Monaco",
        dialCode: "+377"
    },
    {
        code: "MD",
        emoji: "\uD83C\uDDF2\uD83C\uDDE9",
        unicode: "U+1F1F2 U+1F1E9",
        name: "Moldova",
        title: "flag for Moldova",
        dialCode: "+373"
    },
    {
        code: "ME",
        emoji: "\uD83C\uDDF2\uD83C\uDDEA",
        unicode: "U+1F1F2 U+1F1EA",
        name: "Montenegro",
        title: "flag for Montenegro",
        dialCode: "+382"
    },
    {
        code: "MF",
        emoji: "\uD83C\uDDF2\uD83C\uDDEB",
        unicode: "U+1F1F2 U+1F1EB",
        name: "Saint Martin (French Part)",
        title: "flag for Saint Martin (French Part)",
        dialCode: "+590"
    },
    {
        code: "MG",
        emoji: "\uD83C\uDDF2\uD83C\uDDEC",
        unicode: "U+1F1F2 U+1F1EC",
        name: "Madagascar",
        title: "flag for Madagascar",
        dialCode: "+261"
    },
    {
        code: "MH",
        emoji: "\uD83C\uDDF2\uD83C\uDDED",
        unicode: "U+1F1F2 U+1F1ED",
        name: "Marshall Islands",
        title: "flag for Marshall Islands",
        dialCode: "+692"
    },
    {
        code: "MK",
        emoji: "\uD83C\uDDF2\uD83C\uDDF0",
        unicode: "U+1F1F2 U+1F1F0",
        name: "Macedonia",
        title: "flag for Macedonia",
        dialCode: "+389"
    },
    {
        code: "ML",
        emoji: "\uD83C\uDDF2\uD83C\uDDF1",
        unicode: "U+1F1F2 U+1F1F1",
        name: "Mali",
        title: "flag for Mali",
        dialCode: "+223"
    },
    {
        code: "MM",
        emoji: "\uD83C\uDDF2\uD83C\uDDF2",
        unicode: "U+1F1F2 U+1F1F2",
        name: "Myanmar",
        title: "flag for Myanmar",
        dialCode: "+95"
    },
    {
        code: "MN",
        emoji: "\uD83C\uDDF2\uD83C\uDDF3",
        unicode: "U+1F1F2 U+1F1F3",
        name: "Mongolia",
        title: "flag for Mongolia",
        dialCode: "+976"
    },
    {
        code: "MO",
        emoji: "\uD83C\uDDF2\uD83C\uDDF4",
        unicode: "U+1F1F2 U+1F1F4",
        name: "Macao",
        title: "flag for Macao",
        dialCode: "+853"
    },
    {
        code: "MP",
        emoji: "\uD83C\uDDF2\uD83C\uDDF5",
        unicode: "U+1F1F2 U+1F1F5",
        name: "Northern Mariana Islands",
        title: "flag for Northern Mariana Islands",
        dialCode: "+1 670"
    },
    {
        code: "MQ",
        emoji: "\uD83C\uDDF2\uD83C\uDDF6",
        unicode: "U+1F1F2 U+1F1F6",
        name: "Martinique",
        title: "flag for Martinique",
        dialCode: "+596"
    },
    {
        code: "MR",
        emoji: "\uD83C\uDDF2\uD83C\uDDF7",
        unicode: "U+1F1F2 U+1F1F7",
        name: "Mauritania",
        title: "flag for Mauritania",
        dialCode: "+222"
    },
    {
        code: "MS",
        emoji: "\uD83C\uDDF2\uD83C\uDDF8",
        unicode: "U+1F1F2 U+1F1F8",
        name: "Montserrat",
        title: "flag for Montserrat",
        dialCode: "+1664"
    },
    {
        code: "MT",
        emoji: "\uD83C\uDDF2\uD83C\uDDF9",
        unicode: "U+1F1F2 U+1F1F9",
        name: "Malta",
        title: "flag for Malta",
        dialCode: "+356"
    },
    {
        code: "MU",
        emoji: "\uD83C\uDDF2\uD83C\uDDFA",
        unicode: "U+1F1F2 U+1F1FA",
        name: "Mauritius",
        title: "flag for Mauritius",
        dialCode: "+230"
    },
    {
        code: "MV",
        emoji: "\uD83C\uDDF2\uD83C\uDDFB",
        unicode: "U+1F1F2 U+1F1FB",
        name: "Maldives",
        title: "flag for Maldives",
        dialCode: "+960"
    },
    {
        code: "MW",
        emoji: "\uD83C\uDDF2\uD83C\uDDFC",
        unicode: "U+1F1F2 U+1F1FC",
        name: "Malawi",
        title: "flag for Malawi",
        dialCode: "+265"
    },
    {
        code: "MX",
        emoji: "\uD83C\uDDF2\uD83C\uDDFD",
        unicode: "U+1F1F2 U+1F1FD",
        name: "Mexico",
        title: "flag for Mexico",
        dialCode: "+52"
    },
    {
        code: "MY",
        emoji: "\uD83C\uDDF2\uD83C\uDDFE",
        unicode: "U+1F1F2 U+1F1FE",
        name: "Malaysia",
        title: "flag for Malaysia",
        dialCode: "+60"
    },
    {
        code: "MZ",
        emoji: "\uD83C\uDDF2\uD83C\uDDFF",
        unicode: "U+1F1F2 U+1F1FF",
        name: "Mozambique",
        title: "flag for Mozambique",
        dialCode: "+258"
    },
    {
        code: "NA",
        emoji: "\uD83C\uDDF3\uD83C\uDDE6",
        unicode: "U+1F1F3 U+1F1E6",
        name: "Namibia",
        title: "flag for Namibia",
        dialCode: "+264"
    },
    {
        code: "NC",
        emoji: "\uD83C\uDDF3\uD83C\uDDE8",
        unicode: "U+1F1F3 U+1F1E8",
        name: "New Caledonia",
        title: "flag for New Caledonia",
        dialCode: "+687"
    },
    {
        code: "NE",
        emoji: "\uD83C\uDDF3\uD83C\uDDEA",
        unicode: "U+1F1F3 U+1F1EA",
        name: "Niger",
        title: "flag for Niger",
        dialCode: "+227"
    },
    {
        code: "NF",
        emoji: "\uD83C\uDDF3\uD83C\uDDEB",
        unicode: "U+1F1F3 U+1F1EB",
        name: "Norfolk Island",
        title: "flag for Norfolk Island",
        dialCode: "+672"
    },
    {
        code: "NG",
        emoji: "\uD83C\uDDF3\uD83C\uDDEC",
        unicode: "U+1F1F3 U+1F1EC",
        name: "Nigeria",
        title: "flag for Nigeria",
        dialCode: "+234"
    },
    {
        code: "NI",
        emoji: "\uD83C\uDDF3\uD83C\uDDEE",
        unicode: "U+1F1F3 U+1F1EE",
        name: "Nicaragua",
        title: "flag for Nicaragua",
        dialCode: "+505"
    },
    {
        code: "NL",
        emoji: "\uD83C\uDDF3\uD83C\uDDF1",
        unicode: "U+1F1F3 U+1F1F1",
        name: "Netherlands",
        title: "flag for Netherlands",
        dialCode: "+31"
    },
    {
        code: "NO",
        emoji: "\uD83C\uDDF3\uD83C\uDDF4",
        unicode: "U+1F1F3 U+1F1F4",
        name: "Norway",
        title: "flag for Norway",
        dialCode: "+47"
    },
    {
        code: "NP",
        emoji: "\uD83C\uDDF3\uD83C\uDDF5",
        unicode: "U+1F1F3 U+1F1F5",
        name: "Nepal",
        title: "flag for Nepal",
        dialCode: "+977"
    },
    {
        code: "NR",
        emoji: "\uD83C\uDDF3\uD83C\uDDF7",
        unicode: "U+1F1F3 U+1F1F7",
        name: "Nauru",
        title: "flag for Nauru",
        dialCode: "+674"
    },
    {
        code: "NU",
        emoji: "\uD83C\uDDF3\uD83C\uDDFA",
        unicode: "U+1F1F3 U+1F1FA",
        name: "Niue",
        title: "flag for Niue",
        dialCode: "+683"
    },
    {
        code: "NZ",
        emoji: "\uD83C\uDDF3\uD83C\uDDFF",
        unicode: "U+1F1F3 U+1F1FF",
        name: "New Zealand",
        title: "flag for New Zealand",
        dialCode: "+64"
    },
    {
        code: "OM",
        emoji: "\uD83C\uDDF4\uD83C\uDDF2",
        unicode: "U+1F1F4 U+1F1F2",
        name: "Oman",
        title: "flag for Oman",
        dialCode: "+968"
    },
    {
        code: "PA",
        emoji: "\uD83C\uDDF5\uD83C\uDDE6",
        unicode: "U+1F1F5 U+1F1E6",
        name: "Panama",
        title: "flag for Panama",
        dialCode: "+507"
    },
    {
        code: "PE",
        emoji: "\uD83C\uDDF5\uD83C\uDDEA",
        unicode: "U+1F1F5 U+1F1EA",
        name: "Peru",
        title: "flag for Peru",
        dialCode: "+51"
    },
    {
        code: "PF",
        emoji: "\uD83C\uDDF5\uD83C\uDDEB",
        unicode: "U+1F1F5 U+1F1EB",
        name: "French Polynesia",
        title: "flag for French Polynesia",
        dialCode: "+689"
    },
    {
        code: "PG",
        emoji: "\uD83C\uDDF5\uD83C\uDDEC",
        unicode: "U+1F1F5 U+1F1EC",
        name: "Papua New Guinea",
        title: "flag for Papua New Guinea",
        dialCode: "+675"
    },
    {
        code: "PH",
        emoji: "\uD83C\uDDF5\uD83C\uDDED",
        unicode: "U+1F1F5 U+1F1ED",
        name: "Philippines",
        title: "flag for Philippines",
        dialCode: "+63"
    },
    {
        code: "PK",
        emoji: "\uD83C\uDDF5\uD83C\uDDF0",
        unicode: "U+1F1F5 U+1F1F0",
        name: "Pakistan",
        title: "flag for Pakistan",
        dialCode: "+92"
    },
    {
        code: "PL",
        emoji: "\uD83C\uDDF5\uD83C\uDDF1",
        unicode: "U+1F1F5 U+1F1F1",
        name: "Poland",
        title: "flag for Poland",
        dialCode: "+48"
    },
    {
        code: "PM",
        emoji: "\uD83C\uDDF5\uD83C\uDDF2",
        unicode: "U+1F1F5 U+1F1F2",
        name: "Saint Pierre and Miquelon",
        title: "flag for Saint Pierre and Miquelon",
        dialCode: "+508"
    },
    {
        code: "PN",
        emoji: "\uD83C\uDDF5\uD83C\uDDF3",
        unicode: "U+1F1F5 U+1F1F3",
        name: "Pitcairn",
        title: "flag for Pitcairn",
        dialCode: "+872"
    },
    {
        code: "PR",
        emoji: "\uD83C\uDDF5\uD83C\uDDF7",
        unicode: "U+1F1F5 U+1F1F7",
        name: "Puerto Rico",
        title: "flag for Puerto Rico",
        dialCode: "+1 939"
    },
    {
        code: "PS",
        emoji: "\uD83C\uDDF5\uD83C\uDDF8",
        unicode: "U+1F1F5 U+1F1F8",
        name: "Palestinian Territory",
        title: "flag for Palestinian Territory",
        dialCode: "+970"
    },
    {
        code: "PT",
        emoji: "\uD83C\uDDF5\uD83C\uDDF9",
        unicode: "U+1F1F5 U+1F1F9",
        name: "Portugal",
        title: "flag for Portugal",
        dialCode: "+351"
    },
    {
        code: "PW",
        emoji: "\uD83C\uDDF5\uD83C\uDDFC",
        unicode: "U+1F1F5 U+1F1FC",
        name: "Palau",
        title: "flag for Palau",
        dialCode: "+680"
    },
    {
        code: "PY",
        emoji: "\uD83C\uDDF5\uD83C\uDDFE",
        unicode: "U+1F1F5 U+1F1FE",
        name: "Paraguay",
        title: "flag for Paraguay",
        dialCode: "+595"
    },
    {
        code: "QA",
        emoji: "\uD83C\uDDF6\uD83C\uDDE6",
        unicode: "U+1F1F6 U+1F1E6",
        name: "Qatar",
        title: "flag for Qatar",
        dialCode: "+974"
    },
    {
        code: "RE",
        emoji: "\uD83C\uDDF7\uD83C\uDDEA",
        unicode: "U+1F1F7 U+1F1EA",
        name: "R\xe9union",
        title: "flag for R\xe9union",
        dialCode: "+262"
    },
    {
        code: "RO",
        emoji: "\uD83C\uDDF7\uD83C\uDDF4",
        unicode: "U+1F1F7 U+1F1F4",
        name: "Romania",
        title: "flag for Romania",
        dialCode: "+40"
    },
    {
        code: "RS",
        emoji: "\uD83C\uDDF7\uD83C\uDDF8",
        unicode: "U+1F1F7 U+1F1F8",
        name: "Serbia",
        title: "flag for Serbia",
        dialCode: "+381"
    },
    {
        code: "RU",
        emoji: "\uD83C\uDDF7\uD83C\uDDFA",
        unicode: "U+1F1F7 U+1F1FA",
        name: "Russia",
        title: "flag for Russia",
        dialCode: "+7"
    },
    {
        code: "RW",
        emoji: "\uD83C\uDDF7\uD83C\uDDFC",
        unicode: "U+1F1F7 U+1F1FC",
        name: "Rwanda",
        title: "flag for Rwanda",
        dialCode: "+250"
    },
    {
        code: "SA",
        emoji: "\uD83C\uDDF8\uD83C\uDDE6",
        unicode: "U+1F1F8 U+1F1E6",
        name: "Saudi Arabia",
        title: "flag for Saudi Arabia",
        dialCode: "+966"
    },
    {
        code: "SB",
        emoji: "\uD83C\uDDF8\uD83C\uDDE7",
        unicode: "U+1F1F8 U+1F1E7",
        name: "Solomon Islands",
        title: "flag for Solomon Islands",
        dialCode: "+677"
    },
    {
        code: "SC",
        emoji: "\uD83C\uDDF8\uD83C\uDDE8",
        unicode: "U+1F1F8 U+1F1E8",
        name: "Seychelles",
        title: "flag for Seychelles",
        dialCode: "+248"
    },
    {
        code: "SD",
        emoji: "\uD83C\uDDF8\uD83C\uDDE9",
        unicode: "U+1F1F8 U+1F1E9",
        name: "Sudan",
        title: "flag for Sudan",
        dialCode: "+249"
    },
    {
        code: "SE",
        emoji: "\uD83C\uDDF8\uD83C\uDDEA",
        unicode: "U+1F1F8 U+1F1EA",
        name: "Sweden",
        title: "flag for Sweden",
        dialCode: "+46"
    },
    {
        code: "SG",
        emoji: "\uD83C\uDDF8\uD83C\uDDEC",
        unicode: "U+1F1F8 U+1F1EC",
        name: "Singapore",
        title: "flag for Singapore",
        dialCode: "+65"
    },
    {
        code: "SH",
        emoji: "\uD83C\uDDF8\uD83C\uDDED",
        unicode: "U+1F1F8 U+1F1ED",
        name: "Saint Helena, Ascension and Tristan Da Cunha",
        title: "flag for Saint Helena, Ascension and Tristan Da Cunha",
        dialCode: "+290"
    },
    {
        code: "SI",
        emoji: "\uD83C\uDDF8\uD83C\uDDEE",
        unicode: "U+1F1F8 U+1F1EE",
        name: "Slovenia",
        title: "flag for Slovenia",
        dialCode: "+386"
    },
    {
        code: "SJ",
        emoji: "\uD83C\uDDF8\uD83C\uDDEF",
        unicode: "U+1F1F8 U+1F1EF",
        name: "Svalbard and Jan Mayen",
        title: "flag for Svalbard and Jan Mayen",
        dialCode: "+47"
    },
    {
        code: "SK",
        emoji: "\uD83C\uDDF8\uD83C\uDDF0",
        unicode: "U+1F1F8 U+1F1F0",
        name: "Slovakia",
        title: "flag for Slovakia",
        dialCode: "+421"
    },
    {
        code: "SL",
        emoji: "\uD83C\uDDF8\uD83C\uDDF1",
        unicode: "U+1F1F8 U+1F1F1",
        name: "Sierra Leone",
        title: "flag for Sierra Leone",
        dialCode: "+232"
    },
    {
        code: "SM",
        emoji: "\uD83C\uDDF8\uD83C\uDDF2",
        unicode: "U+1F1F8 U+1F1F2",
        name: "San Marino",
        title: "flag for San Marino",
        dialCode: "+378"
    },
    {
        code: "SN",
        emoji: "\uD83C\uDDF8\uD83C\uDDF3",
        unicode: "U+1F1F8 U+1F1F3",
        name: "Senegal",
        title: "flag for Senegal",
        dialCode: "+221"
    },
    {
        code: "SO",
        emoji: "\uD83C\uDDF8\uD83C\uDDF4",
        unicode: "U+1F1F8 U+1F1F4",
        name: "Somalia",
        title: "flag for Somalia",
        dialCode: "+252"
    },
    {
        code: "SR",
        emoji: "\uD83C\uDDF8\uD83C\uDDF7",
        unicode: "U+1F1F8 U+1F1F7",
        name: "Suriname",
        title: "flag for Suriname",
        dialCode: "+597"
    },
    {
        code: "SS",
        emoji: "\uD83C\uDDF8\uD83C\uDDF8",
        unicode: "U+1F1F8 U+1F1F8",
        name: "South Sudan",
        title: "flag for South Sudan"
    },
    {
        code: "ST",
        emoji: "\uD83C\uDDF8\uD83C\uDDF9",
        unicode: "U+1F1F8 U+1F1F9",
        name: "Sao Tome and Principe",
        title: "flag for Sao Tome and Principe",
        dialCode: "+239"
    },
    {
        code: "SV",
        emoji: "\uD83C\uDDF8\uD83C\uDDFB",
        unicode: "U+1F1F8 U+1F1FB",
        name: "El Salvador",
        title: "flag for El Salvador",
        dialCode: "+503"
    },
    {
        code: "SX",
        emoji: "\uD83C\uDDF8\uD83C\uDDFD",
        unicode: "U+1F1F8 U+1F1FD",
        name: "Sint Maarten (Dutch Part)",
        title: "flag for Sint Maarten (Dutch Part)"
    },
    {
        code: "SY",
        emoji: "\uD83C\uDDF8\uD83C\uDDFE",
        unicode: "U+1F1F8 U+1F1FE",
        name: "Syrian Arab Republic",
        title: "flag for Syrian Arab Republic",
        dialCode: "+963"
    },
    {
        code: "SZ",
        emoji: "\uD83C\uDDF8\uD83C\uDDFF",
        unicode: "U+1F1F8 U+1F1FF",
        name: "Swaziland",
        title: "flag for Swaziland",
        dialCode: "+268"
    },
    {
        code: "TC",
        emoji: "\uD83C\uDDF9\uD83C\uDDE8",
        unicode: "U+1F1F9 U+1F1E8",
        name: "Turks and Caicos Islands",
        title: "flag for Turks and Caicos Islands",
        dialCode: "+1 649"
    },
    {
        code: "TD",
        emoji: "\uD83C\uDDF9\uD83C\uDDE9",
        unicode: "U+1F1F9 U+1F1E9",
        name: "Chad",
        title: "flag for Chad",
        dialCode: "+235"
    },
    {
        code: "TF",
        emoji: "\uD83C\uDDF9\uD83C\uDDEB",
        unicode: "U+1F1F9 U+1F1EB",
        name: "French Southern Territories",
        title: "flag for French Southern Territories"
    },
    {
        code: "TG",
        emoji: "\uD83C\uDDF9\uD83C\uDDEC",
        unicode: "U+1F1F9 U+1F1EC",
        name: "Togo",
        title: "flag for Togo",
        dialCode: "+228"
    },
    {
        code: "TH",
        emoji: "\uD83C\uDDF9\uD83C\uDDED",
        unicode: "U+1F1F9 U+1F1ED",
        name: "Thailand",
        title: "flag for Thailand",
        dialCode: "+66"
    },
    {
        code: "TJ",
        emoji: "\uD83C\uDDF9\uD83C\uDDEF",
        unicode: "U+1F1F9 U+1F1EF",
        name: "Tajikistan",
        title: "flag for Tajikistan",
        dialCode: "+992"
    },
    {
        code: "TK",
        emoji: "\uD83C\uDDF9\uD83C\uDDF0",
        unicode: "U+1F1F9 U+1F1F0",
        name: "Tokelau",
        title: "flag for Tokelau",
        dialCode: "+690"
    },
    {
        code: "TL",
        emoji: "\uD83C\uDDF9\uD83C\uDDF1",
        unicode: "U+1F1F9 U+1F1F1",
        name: "Timor-Leste",
        title: "flag for Timor-Leste",
        dialCode: "+670"
    },
    {
        code: "TM",
        emoji: "\uD83C\uDDF9\uD83C\uDDF2",
        unicode: "U+1F1F9 U+1F1F2",
        name: "Turkmenistan",
        title: "flag for Turkmenistan",
        dialCode: "+993"
    },
    {
        code: "TN",
        emoji: "\uD83C\uDDF9\uD83C\uDDF3",
        unicode: "U+1F1F9 U+1F1F3",
        name: "Tunisia",
        title: "flag for Tunisia",
        dialCode: "+216"
    },
    {
        code: "TO",
        emoji: "\uD83C\uDDF9\uD83C\uDDF4",
        unicode: "U+1F1F9 U+1F1F4",
        name: "Tonga",
        title: "flag for Tonga",
        dialCode: "+676"
    },
    {
        code: "TR",
        emoji: "\uD83C\uDDF9\uD83C\uDDF7",
        unicode: "U+1F1F9 U+1F1F7",
        name: "Turkey",
        title: "flag for Turkey",
        dialCode: "+90"
    },
    {
        code: "TT",
        emoji: "\uD83C\uDDF9\uD83C\uDDF9",
        unicode: "U+1F1F9 U+1F1F9",
        name: "Trinidad and Tobago",
        title: "flag for Trinidad and Tobago",
        dialCode: "+1 868"
    },
    {
        code: "TV",
        emoji: "\uD83C\uDDF9\uD83C\uDDFB",
        unicode: "U+1F1F9 U+1F1FB",
        name: "Tuvalu",
        title: "flag for Tuvalu",
        dialCode: "+688"
    },
    {
        code: "TW",
        emoji: "\uD83C\uDDF9\uD83C\uDDFC",
        unicode: "U+1F1F9 U+1F1FC",
        name: "Taiwan",
        title: "flag for Taiwan",
        dialCode: "+886"
    },
    {
        code: "TZ",
        emoji: "\uD83C\uDDF9\uD83C\uDDFF",
        unicode: "U+1F1F9 U+1F1FF",
        name: "Tanzania",
        title: "flag for Tanzania",
        dialCode: "+255"
    },
    {
        code: "UA",
        emoji: "\uD83C\uDDFA\uD83C\uDDE6",
        unicode: "U+1F1FA U+1F1E6",
        name: "Ukraine",
        title: "flag for Ukraine",
        dialCode: "+380"
    },
    {
        code: "UG",
        emoji: "\uD83C\uDDFA\uD83C\uDDEC",
        unicode: "U+1F1FA U+1F1EC",
        name: "Uganda",
        title: "flag for Uganda",
        dialCode: "+256"
    },
    {
        code: "UM",
        emoji: "\uD83C\uDDFA\uD83C\uDDF2",
        unicode: "U+1F1FA U+1F1F2",
        name: "United States Minor Outlying Islands",
        title: "flag for United States Minor Outlying Islands"
    },
    {
        code: "US",
        emoji: "\uD83C\uDDFA\uD83C\uDDF8",
        unicode: "U+1F1FA U+1F1F8",
        name: "United States",
        title: "flag for United States",
        dialCode: "+1"
    },
    {
        code: "UY",
        emoji: "\uD83C\uDDFA\uD83C\uDDFE",
        unicode: "U+1F1FA U+1F1FE",
        name: "Uruguay",
        title: "flag for Uruguay",
        dialCode: "+598"
    },
    {
        code: "UZ",
        emoji: "\uD83C\uDDFA\uD83C\uDDFF",
        unicode: "U+1F1FA U+1F1FF",
        name: "Uzbekistan",
        title: "flag for Uzbekistan",
        dialCode: "+998"
    },
    {
        code: "VA",
        emoji: "\uD83C\uDDFB\uD83C\uDDE6",
        unicode: "U+1F1FB U+1F1E6",
        name: "Vatican City",
        title: "flag for Vatican City",
        dialCode: "+379"
    },
    {
        code: "VC",
        emoji: "\uD83C\uDDFB\uD83C\uDDE8",
        unicode: "U+1F1FB U+1F1E8",
        name: "Saint Vincent and The Grenadines",
        title: "flag for Saint Vincent and The Grenadines",
        dialCode: "+1 784"
    },
    {
        code: "VE",
        emoji: "\uD83C\uDDFB\uD83C\uDDEA",
        unicode: "U+1F1FB U+1F1EA",
        name: "Venezuela",
        title: "flag for Venezuela",
        dialCode: "+58"
    },
    {
        code: "VG",
        emoji: "\uD83C\uDDFB\uD83C\uDDEC",
        unicode: "U+1F1FB U+1F1EC",
        name: "Virgin Islands, British",
        title: "flag for Virgin Islands, British",
        dialCode: "+1 284"
    },
    {
        code: "VI",
        emoji: "\uD83C\uDDFB\uD83C\uDDEE",
        unicode: "U+1F1FB U+1F1EE",
        name: "Virgin Islands, U.S.",
        title: "flag for Virgin Islands, U.S.",
        dialCode: "+1 340"
    },
    {
        code: "VN",
        emoji: "\uD83C\uDDFB\uD83C\uDDF3",
        unicode: "U+1F1FB U+1F1F3",
        name: "Viet Nam",
        title: "flag for Viet Nam",
        dialCode: "+84"
    },
    {
        code: "VU",
        emoji: "\uD83C\uDDFB\uD83C\uDDFA",
        unicode: "U+1F1FB U+1F1FA",
        name: "Vanuatu",
        title: "flag for Vanuatu",
        dialCode: "+678"
    },
    {
        code: "WF",
        emoji: "\uD83C\uDDFC\uD83C\uDDEB",
        unicode: "U+1F1FC U+1F1EB",
        name: "Wallis and Futuna",
        title: "flag for Wallis and Futuna",
        dialCode: "+681"
    },
    {
        code: "WS",
        emoji: "\uD83C\uDDFC\uD83C\uDDF8",
        unicode: "U+1F1FC U+1F1F8",
        name: "Samoa",
        title: "flag for Samoa",
        dialCode: "+685"
    },
    {
        code: "XK",
        emoji: "\uD83C\uDDFD\uD83C\uDDF0",
        unicode: "U+1F1FD U+1F1F0",
        name: "Kosovo",
        title: "flag for Kosovo",
        dialCode: "+383"
    },
    {
        code: "YE",
        emoji: "\uD83C\uDDFE\uD83C\uDDEA",
        unicode: "U+1F1FE U+1F1EA",
        name: "Yemen",
        title: "flag for Yemen",
        dialCode: "+967"
    },
    {
        code: "YT",
        emoji: "\uD83C\uDDFE\uD83C\uDDF9",
        unicode: "U+1F1FE U+1F1F9",
        name: "Mayotte",
        title: "flag for Mayotte",
        dialCode: "+262"
    },
    {
        code: "ZA",
        emoji: "\uD83C\uDDFF\uD83C\uDDE6",
        unicode: "U+1F1FF U+1F1E6",
        name: "South Africa",
        title: "flag for South Africa",
        dialCode: "+27"
    },
    {
        code: "ZM",
        emoji: "\uD83C\uDDFF\uD83C\uDDF2",
        unicode: "U+1F1FF U+1F1F2",
        name: "Zambia",
        title: "flag for Zambia",
        dialCode: "+260"
    },
    {
        code: "ZW",
        emoji: "\uD83C\uDDFF\uD83C\uDDFC",
        unicode: "U+1F1FF U+1F1FC",
        name: "Zimbabwe",
        title: "flag for Zimbabwe",
        dialCode: "+263"
    }
];
class $d9c0aa3d82976bec$export$daceba3f0189cd12 {
    setType(e) {
        this.options.type = e;
    }
    setLang(e) {
        this.options.lang = e;
    }
    setCountryCodes(e) {
        console.warn("WARNING! Obsolete function called. Function setCountryCodes() has been deprecated, please use the new addFilterByCountry() function instead!"), this.options.countryCodes = e;
    }
    setPosition(e) {
        console.warn("WARNING! Obsolete function called. Function setPosition() has been deprecated, please use the new addBiasByProximity() function instead!"), this.options.position = e;
    }
    setLimit(e) {
        this.options.limit = e;
    }
    setValue(e) {
        e ? this.inputClearButton.classList.add("visible") : this.inputClearButton.classList.remove("visible"), this.inputElement.value = e;
    }
    getValue() {
        return this.inputElement.value;
    }
    addFilterByCountry(e) {
        this.options.filter[this.BY_COUNTRYCODE] = e;
    }
    addFilterByCircle(e) {
        this.options.filter[this.BY_CIRCLE] = e;
    }
    addFilterByRect(e) {
        this.options.filter[this.BY_RECT] = e;
    }
    addFilterByPlace(e) {
        this.options.filter[this.BY_PLACE] = e;
    }
    clearFilters() {
        this.options.filter = {};
    }
    addBiasByCountry(e) {
        this.options.bias[this.BY_COUNTRYCODE] = e;
    }
    addBiasByCircle(e) {
        this.options.bias[this.BY_CIRCLE] = e;
    }
    addBiasByRect(e) {
        this.options.bias[this.BY_RECT] = e;
    }
    addBiasByProximity(e) {
        this.options.bias[this.BY_PROXIMITY] = e;
    }
    clearBias() {
        this.options.bias = {};
    }
    on(e, i) {
        "select" === e && this.changeCallbacks.indexOf(i) < 0 && this.changeCallbacks.push(i), "suggestions" === e && this.suggestionsChangeCallbacks.indexOf(i) < 0 && this.suggestionsChangeCallbacks.push(i), "input" === e && this.inputCallbacks.indexOf(i) < 0 && this.inputCallbacks.push(i), "close" === e && this.closeCallbacks.indexOf(i) < 0 && this.closeCallbacks.push(i), "open" === e && this.openCallbacks.indexOf(i) < 0 && this.openCallbacks.push(i);
    }
    off(e, i) {
        "select" === e && this.changeCallbacks.indexOf(i) >= 0 ? this.changeCallbacks.splice(this.changeCallbacks.indexOf(i), 1) : "select" !== e || i || (this.changeCallbacks = []), "suggestions" === e && this.suggestionsChangeCallbacks.indexOf(i) >= 0 ? this.suggestionsChangeCallbacks.splice(this.suggestionsChangeCallbacks.indexOf(i), 1) : "suggestions" !== e || i || (this.suggestionsChangeCallbacks = []), "input" === e && this.inputCallbacks.indexOf(i) >= 0 ? this.inputCallbacks.splice(this.inputCallbacks.indexOf(i), 1) : "input" !== e || i || (this.inputCallbacks = []), "close" === e && this.closeCallbacks.indexOf(i) >= 0 ? this.closeCallbacks.splice(this.closeCallbacks.indexOf(i), 1) : "close" !== e || i || (this.closeCallbacks = []), "open" === e && this.openCallbacks.indexOf(i) >= 0 ? this.openCallbacks.splice(this.openCallbacks.indexOf(i), 1) : "open" !== e || i || (this.openCallbacks = []);
    }
    once(e, i) {
        this.on(e, i);
        const o = this, a = ()=>{
            o.off(e, i), o.off(e, a);
        };
        this.on(e, a);
    }
    setSuggestionsFilter(e) {
        this.suggestionsFilter = e && "function" == typeof e ? e : null;
    }
    setPreprocessHook(e) {
        this.preprocessHook = e && "function" == typeof e ? e : null;
    }
    setPostprocessHook(e) {
        this.postprocessHook = e && "function" == typeof e ? e : null;
    }
    setSendGeocoderRequestFunc(e) {
        this.sendGeocoderRequestAlt = e && "function" == typeof e ? e : null;
    }
    setSendPlaceDetailsRequestFunc(e) {
        this.sendPlaceDetailsRequestAlt = e && "function" == typeof e ? e : null;
    }
    isOpen() {
        return !!this.autocompleteItemsElement;
    }
    close() {
        this.closeDropDownList();
    }
    open() {
        this.isOpen() || this.openDropdownAgain();
    }
    sendGeocoderRequest(e) {
        return new Promise((i, o)=>{
            this.currentPromiseReject = o;
            let a = this.generateUrl(e);
            fetch(a).then((e)=>{
                e.ok ? e.json().then((e)=>i(e)) : e.json().then((e)=>o(e));
            });
        });
    }
    sendPlaceDetailsRequest(e) {
        return new Promise((i, o)=>{
            if ("openstreetmap" !== e.properties.datasource?.sourcename || !e.properties.place_id) return void i(e);
            this.currentPlaceDetailsPromiseReject = o;
            let a = this.generatePlacesUrlUrl(e.properties.place_id);
            fetch(a).then((a)=>{
                a.ok ? a.json().then((o)=>{
                    o.features.length || i(e), i(o.features[0]);
                }) : a.json().then((e)=>o(e));
            });
        });
    }
    onUserInput(e) {
        let i = this.inputElement.value, o = this.inputElement.value;
        if (this.inputCallbacks.forEach((e)=>e(i)), this.closeDropDownList(), this.focusedItemIndex = -1, this.currentPromiseReject && (this.currentPromiseReject({
            canceled: !0
        }), this.currentPromiseReject = null), this.currentTimeout && (window.clearTimeout(this.currentTimeout), this.currentTimeout = null), !i) return this.inputClearButton.classList.remove("visible"), !1;
        this.inputClearButton.classList.add("visible"), this.currentTimeout = window.setTimeout(()=>{
            let a;
            this.preprocessHook && "function" == typeof this.preprocessHook && (i = this.preprocessHook(i)), a = this.sendGeocoderRequestAlt ? this.sendGeocoderRequestAlt(i, this) : this.sendGeocoderRequest(i), a.then((i)=>{
                i.features && i.features.length && i?.query?.parsed && (this.options.allowNonVerifiedHouseNumber || this.options.allowNonVerifiedStreet) && this.extendByNonVerifiedValues(i.features, i?.query?.parsed), this.currentItems = i.features, this.currentItems && this.currentItems.length && this.suggestionsFilter && "function" == typeof this.suggestionsFilter && (this.currentItems = this.suggestionsFilter(this.currentItems)), this.notifySuggestions(this.currentItems), this.currentItems.length && (this.autocompleteItemsElement = document.createElement("div"), this.autocompleteItemsElement.setAttribute("class", "geoapify-autocomplete-items"), this.notifyOpened(), this.container.appendChild(this.autocompleteItemsElement), this.currentItems.forEach((i, a)=>{
                    const t = document.createElement("div");
                    if (t.classList.add("geoapify-autocomplete-item"), !this.options.skipIcons) {
                        const e = document.createElement("span");
                        e.classList.add("icon"), this.addFeatureIcon(e, i.properties.result_type, i.properties.country_code), t.appendChild(e);
                    }
                    const n = document.createElement("span");
                    if (n.classList.add("address"), this.postprocessHook && "function" == typeof this.postprocessHook) {
                        const e = this.postprocessHook(i);
                        n.innerHTML = this.getStyledAddressSingleValue(e, o);
                    } else n.innerHTML = this.getStyledAddress(i.properties, o);
                    t.appendChild(n), t.addEventListener("click", (i)=>{
                        e.stopPropagation(), this.setValueAndNotify(this.currentItems[a]);
                    }), this.autocompleteItemsElement.appendChild(t);
                }));
            }, (e)=>{
                e.canceled || console.log(e);
            });
        }, this.options.debounceDelay);
    }
    addHouseNumberToFormatted(e, i, o) {
        const a = {
            "{{{road}}} {{{house_number}}}": [
                "af",
                "ai",
                "al",
                "ao",
                "ar",
                "at",
                "aw",
                "ax",
                "ba",
                "be",
                "bg",
                "bi",
                "bo",
                "bq",
                "br",
                "bs",
                "bt",
                "bv",
                "bw",
                "cf",
                "ch",
                "cl",
                "cm",
                "co",
                "cr",
                "cu",
                "cv",
                "cw",
                "cy",
                "cz",
                "de",
                "dk",
                "do",
                "ec",
                "ee",
                "eh",
                "er",
                "et",
                "fi",
                "fo",
                "gd",
                "ge",
                "gl",
                "gq",
                "gr",
                "gt",
                "gw",
                "hn",
                "hr",
                "ht",
                "hu",
                "id",
                "il",
                "ir",
                "is",
                "jo",
                "ki",
                "km",
                "kp",
                "kw",
                "lc",
                "li",
                "lr",
                "lt",
                "lv",
                "ly",
                "me",
                "mk",
                "ml",
                "mn",
                "mo",
                "mx",
                "ni",
                "nl",
                "no",
                "np",
                "pa",
                "pe",
                "pl",
                "ps",
                "pt",
                "pw",
                "py",
                "qa",
                "ro",
                "rs",
                "ru",
                "sb",
                "sd",
                "se",
                "si",
                "sj",
                "sk",
                "so",
                "sr",
                "ss",
                "st",
                "sv",
                "sx",
                "sz",
                "td",
                "tj",
                "tl",
                "tr",
                "um",
                "uz",
                "uy",
                "vc",
                "ve",
                "vu",
                "ws"
            ],
            "{{{house_number}}} {{{road}}}": [
                "ad",
                "ae",
                "ag",
                "am",
                "as",
                "au",
                "az",
                "bb",
                "bd",
                "bf",
                "bh",
                "bl",
                "bm",
                "bz",
                "ca",
                "cc",
                "ci",
                "ck",
                "cn",
                "cx",
                "dj",
                "dm",
                "dz",
                "eg",
                "fj",
                "fk",
                "fm",
                "fr",
                "ga",
                "gb",
                "gf",
                "gg",
                "gh",
                "gi",
                "gm",
                "gn",
                "gp",
                "gs",
                "gu",
                "gy",
                "hk",
                "hm",
                "ie",
                "im",
                "io",
                "iq",
                "je",
                "jm",
                "jp",
                "ke",
                "kh",
                "kn",
                "kr",
                "ky",
                "lb",
                "lk",
                "ls",
                "lu",
                "ma",
                "mc",
                "mf",
                "mh",
                "mg",
                "mm",
                "mp",
                "ms",
                "mt",
                "mq",
                "mv",
                "mw",
                "my",
                "na",
                "nc",
                "ne",
                "nf",
                "ng",
                "nr",
                "nu",
                "nz",
                "om",
                "pf",
                "pg",
                "ph",
                "pk",
                "pm",
                "pr",
                "re",
                "rw",
                "sa",
                "sc",
                "sg",
                "sh",
                "sl",
                "sn",
                "tc",
                "tf",
                "th",
                "tk",
                "tn",
                "to",
                "tt",
                "tv",
                "tw",
                "tz",
                "ug",
                "us",
                "vg",
                "vi",
                "wf",
                "yt",
                "za",
                "zm",
                "zw"
            ],
            "{{{road}}}, {{{house_number}}}": [
                "by",
                "es",
                "it",
                "kg",
                "kz",
                "md",
                "mz",
                "sm",
                "sy",
                "ua",
                "va"
            ],
            "{{{house_number}}}, {{{road}}}": [
                "bj",
                "bn",
                "cd",
                "cg",
                "in",
                "la",
                "mr",
                "mu",
                "tg",
                "tm",
                "vn",
                "ye"
            ]
        }, t = Object.keys(a).find((i)=>a[i].indexOf(e.country_code) >= 0) || "{{{road}}} {{{house_number}}}";
        if (i) {
            e.street = i.replace(/(^\w|\s\w|[-]\w)/g, (e)=>e.toUpperCase()), e.housenumber = o;
            const a = t.replace("{{{road}}}", e.street).replace("{{{house_number}}}", o);
            e.address_line1 = a, e.address_line2 = e.formatted, e.formatted = a + ", " + e.formatted;
        } else {
            e.housenumber = o;
            const i = t.replace("{{{road}}}", e.street).replace("{{{house_number}}}", o);
            e.address_line1 = e.address_line1.replace(e.street, i), e.formatted = e.formatted.replace(e.street, i);
        }
    }
    extendByNonVerifiedValues(e, i) {
        e.forEach((e)=>{
            i.housenumber && this.options.allowNonVerifiedHouseNumber && "match_by_street" === e.properties.rank.match_type ? (this.addHouseNumberToFormatted(e.properties, null, i.housenumber), e.properties.nonVerifiedParts = [
                "housenumber"
            ]) : i.street && i.housenumber && this.options.allowNonVerifiedStreet && ("match_by_city_or_disrict" === e.properties.rank.match_type || "match_by_postcode" === e.properties.rank.match_type) ? (this.addHouseNumberToFormatted(e.properties, i.street, i.housenumber), e.properties.nonVerifiedParts = [
                "housenumber",
                "street"
            ]) : i.street && this.options.allowNonVerifiedStreet && ("match_by_city_or_disrict" === e.properties.rank.match_type || "match_by_postcode" === e.properties.rank.match_type) && (e.properties.street = i.street.replace(/(^\w|\s\w|[-]\w)/g, (e)=>e.toUpperCase()), e.properties.address_line1 = e.properties.street, e.properties.address_line2 = e.properties.formatted, e.properties.formatted = e.properties.street + ", " + e.properties.formatted, e.properties.nonVerifiedParts = [
                "street"
            ]);
        });
    }
    getStyledAddressSingleValue(e, i) {
        let o = e;
        const a = (o || "").toLowerCase().indexOf(i.toLowerCase());
        return a >= 0 && (o = o.substring(0, a) + `<strong>${o.substring(a, a + i.length)}</strong>` + o.substring(a + i.length)), `<span class="main-part">${o}</span>`;
    }
    getStyledAddress(e, i) {
        let o, a;
        const t = e.formatted.split(",").map((e)=>e.trim());
        if (e.name) o = t[0], a = t.slice(1).join(", ");
        else {
            const e = Math.min(2, Math.max(t.length - 2, 1));
            o = t.slice(0, e).join(", "), a = t.slice(e).join(", ");
        }
        if (e.nonVerifiedParts && e.nonVerifiedParts.length) e.nonVerifiedParts.forEach((i)=>{
            o = o.replace(e[i], `<span class="non-verified">${e[i]}</span>`);
        });
        else {
            const e = o.toLowerCase().indexOf(i.toLowerCase());
            e >= 0 && (o = o.substring(0, e) + `<strong>${o.substring(e, e + i.length)}</strong>` + o.substring(e + i.length));
        }
        return `<span class="main-part">${o}</span><span class="secondary-part">${a}</span>`;
    }
    onUserKeyPress(e) {
        if (this.autocompleteItemsElement) {
            const i = this.autocompleteItemsElement.getElementsByTagName("div");
            "ArrowDown" === e.code ? (e.preventDefault(), this.focusedItemIndex++, this.focusedItemIndex >= i.length && (this.focusedItemIndex = 0), this.setActive(i, this.focusedItemIndex)) : "ArrowUp" === e.code ? (e.preventDefault(), this.focusedItemIndex--, this.focusedItemIndex < 0 && (this.focusedItemIndex = i.length - 1), this.setActive(i, this.focusedItemIndex)) : "Enter" === e.code ? (e.preventDefault(), this.focusedItemIndex > -1 && (this.options.skipSelectionOnArrowKey ? this.setValueAndNotify(this.currentItems[this.focusedItemIndex]) : this.closeDropDownList())) : "Escape" === e.code && this.closeDropDownList();
        } else "ArrowDown" == e.code && this.openDropdownAgain();
    }
    setActive(e, i) {
        if (!e || !e.length) return !1;
        for(var o = 0; o < e.length; o++)e[o].classList.remove("active");
        e[i].classList.add("active"), this.options.skipSelectionOnArrowKey || (this.inputElement.value = this.postprocessHook && "function" == typeof this.postprocessHook ? this.postprocessHook(this.currentItems[i]) : this.currentItems[i].properties.formatted, this.notifyValueSelected(this.currentItems[i]));
    }
    setValueAndNotify(e) {
        this.inputElement.value = this.postprocessHook && "function" == typeof this.postprocessHook ? this.postprocessHook(e) : e.properties.formatted, this.notifyValueSelected(e), this.closeDropDownList();
    }
    clearFieldAndNotify(e) {
        e.stopPropagation(), this.inputElement.value = "", this.inputClearButton.classList.remove("visible"), this.currentPromiseReject && (this.currentPromiseReject({
            canceled: !0
        }), this.currentPromiseReject = null), this.currentTimeout && (window.clearTimeout(this.currentTimeout), this.currentTimeout = null), this.closeDropDownList(), this.notifyValueSelected(null);
    }
    closeDropDownList() {
        this.autocompleteItemsElement && (this.container.removeChild(this.autocompleteItemsElement), this.autocompleteItemsElement = null, this.notifyClosed());
    }
    addIcon(e, i) {
        const o = {
            close: {
                path: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
                viewbox: "0 0 24 24"
            },
            "map-marker": {
                path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
                viewbox: "0 0 384 512"
            },
            road: {
                path: "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z",
                viewbox: "0 0 576 512"
            },
            city: {
                path: "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z",
                viewbox: "0 0 640 512"
            }
        };
        var a = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        a.setAttribute("viewBox", o[i].viewbox), a.setAttribute("height", "24");
        var t = document.createElementNS("http://www.w3.org/2000/svg", "path");
        t.setAttribute("d", o[i].path), t.setAttribute("fill", "currentColor"), a.appendChild(t), e.appendChild(a);
    }
    addFeatureIcon(i, o, a) {
        const t = {
            unknown: "map-marker",
            amenity: "map-marker",
            building: "map-marker",
            street: "road",
            suburb: "city",
            district: "city",
            postcode: "city",
            city: "city",
            county: "city",
            state: "city"
        }, n = $d9c0aa3d82976bec$var$e.find((e)=>a && e.code.toLowerCase() === a.toLowerCase());
        if ("country" === o && n) {
            i.classList.add("emoji");
            const e = document.createElement("span");
            e.innerText = n.emoji, i.appendChild(e);
        } else this.addIcon(i, t[o] ? t[o] : "map-marker");
    }
    notifyValueSelected(e) {
        if (this.currentPlaceDetailsPromiseReject && (this.currentPlaceDetailsPromiseReject({
            canceled: !0
        }), this.currentPlaceDetailsPromiseReject = null), this.options.addDetails && e && !e.properties.nonVerifiedParts?.length) {
            let i;
            i = this.sendPlaceDetailsRequestAlt ? this.sendPlaceDetailsRequestAlt(e, this) : this.sendPlaceDetailsRequest(e), i.then((e)=>{
                this.changeCallbacks.forEach((i)=>i(e)), this.currentPlaceDetailsPromiseReject = null;
            }, (i)=>{
                i.canceled || (console.log(i), this.changeCallbacks.forEach((i)=>i(e)), this.currentPlaceDetailsPromiseReject = null);
            });
        } else this.changeCallbacks.forEach((i)=>i(e));
    }
    notifySuggestions(e) {
        this.suggestionsChangeCallbacks.forEach((i)=>i(e));
    }
    notifyOpened() {
        this.openCallbacks.forEach((e)=>e(!0));
    }
    notifyClosed() {
        this.closeCallbacks.forEach((e)=>e(!1));
    }
    openDropdownAgain() {
        const e = document.createEvent("Event");
        e.initEvent("input", !0, !0), this.inputElement.dispatchEvent(e);
    }
    generatePlacesUrlUrl(e) {
        let i = `${this.placeDetailsUrl}?id=${e}&apiKey=${this.apiKey}`;
        return this.options.lang && (i += `&lang=${this.options.lang}`), i;
    }
    generateUrl(e) {
        let i = `${this.geocoderUrl}?text=${encodeURIComponent(e)}&apiKey=${this.apiKey}`;
        this.options.type && (i += `&type=${this.options.type}`), this.options.limit && (i += `&limit=${this.options.limit}`), this.options.lang && (i += `&lang=${this.options.lang}`);
        const o = [], a = this.options.filter[this.BY_COUNTRYCODE], t = this.options.filter[this.BY_CIRCLE], n = this.options.filter[this.BY_RECT], d = this.options.filter[this.BY_PLACE];
        a && a.length && o.push(`countrycode:${a.join(",").toLowerCase()}`), t && this.isLatitude(t.lat) && this.isLongitude(t.lon) && t.radiusMeters > 0 && o.push(`circle:${t.lon},${t.lat},${t.radiusMeters}`), n && this.isLatitude(n.lat1) && this.isLongitude(n.lon1) && this.isLatitude(n.lat2) && this.isLongitude(n.lon2) && o.push(`rect:${n.lon1},${n.lat1},${n.lon2},${n.lat2}`), d && o.push(`place:${d}`), i += o.length ? `&filter=${o.join("|")}` : "";
        const l = [], s = this.options.bias[this.BY_COUNTRYCODE], c = this.options.bias[this.BY_CIRCLE], r = this.options.bias[this.BY_RECT], F = this.options.bias[this.BY_PROXIMITY];
        return s && s.length && l.push(`countrycode:${s.join(",").toLowerCase()}`), c && this.isLatitude(c.lat) && this.isLongitude(c.lon) && c.radiusMeters > 0 && l.push(`circle:${c.lon},${c.lat},${c.radiusMeters}`), r && this.isLatitude(r.lat1) && this.isLongitude(r.lon1) && this.isLatitude(r.lat2) && this.isLongitude(r.lon2) && l.push(`rect:${r.lon1},${r.lat1},${r.lon2},${r.lat2}`), F && this.isLatitude(F.lat) && this.isLongitude(F.lon) && l.push(`proximity:${F.lon},${F.lat}`), i += l.length ? `&bias=${l.join("|")}` : "", i;
    }
    isLatitude(e) {
        return "" !== e && null !== e && isFinite(e) && Math.abs(e) <= 90;
    }
    isLongitude(e) {
        return "" !== e && null !== e && isFinite(e) && Math.abs(e) <= 180;
    }
    constructor(e, i, o){
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "container", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "apiKey", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "inputElement", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "inputClearButton", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "autocompleteItemsElement", null);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "focusedItemIndex", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "currentItems", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "currentPromiseReject", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "currentPlaceDetailsPromiseReject", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "currentTimeout", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "changeCallbacks", []);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "suggestionsChangeCallbacks", []);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "inputCallbacks", []);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "openCallbacks", []);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "closeCallbacks", []);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "preprocessHook", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "postprocessHook", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "suggestionsFilter", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "sendGeocoderRequestAlt", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "sendPlaceDetailsRequestAlt", void 0);
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "geocoderUrl", "https://api.geoapify.com/v1/geocode/autocomplete");
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "placeDetailsUrl", "https://api.geoapify.com/v2/place-details");
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "options", {
            limit: 5,
            debounceDelay: 100
        });
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "BY_COUNTRYCODE", "countrycode");
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "BY_RECT", "rect");
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "BY_CIRCLE", "circle");
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "BY_PROXIMITY", "proximity");
        (0, $cf9f81c2bcfba224$export$1e71eb4bef00f6b0)(this, "BY_PLACE", "place");
        this.container = e, this.apiKey = i, this.options = o ? {
            ...this.options,
            ...o
        } : this.options, this.options.filter = this.options.filter || {}, this.options.bias = this.options.bias || {}, this.options.countryCodes && this.addFilterByCountry(this.options.countryCodes), this.options.position && this.addBiasByProximity(this.options.position), this.inputElement = document.createElement("input"), this.inputElement.classList.add("geoapify-autocomplete-input"), this.inputElement.setAttribute("type", "text"), this.inputElement.setAttribute("placeholder", this.options.placeholder || "Enter an address here"), this.container.appendChild(this.inputElement), this.inputClearButton = document.createElement("div"), this.inputClearButton.classList.add("geoapify-close-button"), this.addIcon(this.inputClearButton, "close"), this.inputClearButton.addEventListener("click", this.clearFieldAndNotify.bind(this), !1), this.container.appendChild(this.inputClearButton), this.inputElement.addEventListener("input", this.onUserInput.bind(this), !1), this.inputElement.addEventListener("keydown", this.onUserKeyPress.bind(this), !1), document.addEventListener("click", (e)=>{
            e.target !== this.inputElement ? this.closeDropDownList() : this.autocompleteItemsElement || this.openDropdownAgain();
        });
    }
}


var $7743edd5d01c3bfe$export$768fd58360e6509c = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createContext("");
var $7743edd5d01c3bfe$export$d6a9fecd57633387 = function GeoapifyContext(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement($7743edd5d01c3bfe$export$768fd58360e6509c.Provider, {
        value: props.apiKey
    }, props.children);
};
var $7743edd5d01c3bfe$export$823aa13963464457 = function GeoapifyGeocoderAutocomplete(_ref) {
    var placeholderValue = _ref.placeholder, typeValue = _ref.type, langValue = _ref.lang, limitValue = _ref.limit, valueValue = _ref.value, filterByCountryCodeValue = _ref.filterByCountryCode, filterByCircleValue = _ref.filterByCircle, filterByRectValue = _ref.filterByRect, filterByPlaceValue = _ref.filterByPlace, biasByCountryCodeValue = _ref.biasByCountryCode, biasByCircleValue = _ref.biasByCircle, biasByRectValue = _ref.biasByRect, biasByProximityValue = _ref.biasByProximity, positionValue = _ref.position, countryCodesValue = _ref.countryCodes, debounceDelayValue = _ref.debounceDelay, skipIconsValue = _ref.skipIcons, skipSelectionOnArrowKeyValue = _ref.skipSelectionOnArrowKey, allowNonVerifiedHouseNumberValue = _ref.allowNonVerifiedHouseNumber, allowNonVerifiedStreetValue = _ref.allowNonVerifiedStreet, addDetailsValue = _ref.addDetails, preprocessHookValue = _ref.preprocessHook, postprocessHookValue = _ref.postprocessHook, suggestionsFilterValue = _ref.suggestionsFilter, sendGeocoderRequestFuncValue = _ref.sendGeocoderRequestFunc, sendPlaceDetailsRequestFuncValue = _ref.sendPlaceDetailsRequestFunc, placeSelectCallback = _ref.placeSelect, suggestionsChangeCallback = _ref.suggestionsChange, userInputCallback = _ref.onUserInput, openCallback = _ref.onOpen, closeCallback = _ref.onClose;
    var apiKey = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).useContext($7743edd5d01c3bfe$export$768fd58360e6509c);
    var geocoderContainer;
    var initialized = false;
    var geocoderAutocomplete = (0, $4YNlq.useRef)();
    var placeSelectCallbackRef = (0, $4YNlq.useRef)();
    var suggestionsChangeCallbackRef = (0, $4YNlq.useRef)();
    var userInputCallbackRef = (0, $4YNlq.useRef)();
    var openCallbackRef = (0, $4YNlq.useRef)();
    var closeCallbackRef = (0, $4YNlq.useRef)();
    placeSelectCallbackRef.current = placeSelectCallback;
    suggestionsChangeCallbackRef.current = suggestionsChangeCallback;
    userInputCallbackRef.current = userInputCallback;
    openCallbackRef.current = openCallback;
    closeCallbackRef.current = closeCallback;
    var onSelect = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).useCallback(function(value) {
        if (placeSelectCallbackRef.current) placeSelectCallbackRef.current(value);
    }, []);
    var onSuggestions = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).useCallback(function(value) {
        if (suggestionsChangeCallbackRef.current) suggestionsChangeCallbackRef.current(value);
    }, []);
    var onUserInput = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).useCallback(function(input) {
        if (userInputCallbackRef.current) userInputCallbackRef.current(input);
    }, []);
    var onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).useCallback(function(opened) {
        if (openCallbackRef.current) openCallbackRef.current(opened);
    }, []);
    var onClose = (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).useCallback(function(opened) {
        if (closeCallbackRef.current) closeCallbackRef.current(opened);
    }, []);
    (0, $4YNlq.useEffect)(function() {
        if (initialized) {
            if (geocoderAutocomplete.current) {
                geocoderAutocomplete.current.off("select", onSelect);
                geocoderAutocomplete.current.off("suggestions", onSuggestions);
                geocoderAutocomplete.current.off("input", onUserInput);
                geocoderAutocomplete.current.off("close", onClose);
                geocoderAutocomplete.current.off("open", onOpen);
            }
            return;
        }
        initialized = true;
        geocoderAutocomplete.current = new (0, $d9c0aa3d82976bec$export$daceba3f0189cd12)(geocoderContainer, apiKey, {
            placeholder: placeholderValue || "",
            addDetails: addDetailsValue,
            skipIcons: skipIconsValue,
            skipSelectionOnArrowKey: skipSelectionOnArrowKeyValue,
            allowNonVerifiedHouseNumber: allowNonVerifiedHouseNumberValue,
            allowNonVerifiedStreet: allowNonVerifiedStreetValue,
            debounceDelay: debounceDelayValue || 100
        });
        geocoderAutocomplete.current.on("select", onSelect);
        geocoderAutocomplete.current.on("suggestions", onSuggestions);
        geocoderAutocomplete.current.on("input", onUserInput);
        geocoderAutocomplete.current.on("close", onClose);
        geocoderAutocomplete.current.on("open", onOpen);
        if (sendGeocoderRequestFuncValue) geocoderAutocomplete.current.setSendGeocoderRequestFunc(sendGeocoderRequestFuncValue);
    }, []);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.setType(typeValue);
    }, [
        typeValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.setLang(langValue);
    }, [
        langValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) {
            console.warn("WARNING! Obsolete function called. The  'position' input has been deprecated, please use the new 'biasByLocation' input instead!");
            geocoderAutocomplete.current.addBiasByProximity(positionValue);
        }
    }, [
        positionValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) {
            console.warn("WARNING! Obsolete function called. The  'countryCodes' input has been deprecated, please use the new 'filterByCountryCode' input instead!");
            geocoderAutocomplete.current.addFilterByCountry(countryCodesValue);
        }
    }, [
        countryCodesValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.setLimit(limitValue);
    }, [
        limitValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.setValue(valueValue || "");
    }, [
        valueValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.addFilterByCountry(filterByCountryCodeValue);
    }, [
        filterByCountryCodeValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.addFilterByCircle(filterByCircleValue);
    }, [
        filterByCircleValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.addFilterByRect(filterByRectValue);
    }, [
        filterByRectValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.addFilterByPlace(filterByPlaceValue);
    }, [
        filterByRectValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.addBiasByCountry(biasByCountryCodeValue);
    }, [
        biasByCountryCodeValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.addBiasByCircle(biasByCircleValue);
    }, [
        biasByCircleValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.addBiasByRect(biasByRectValue);
    }, [
        biasByRectValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.addBiasByProximity(biasByProximityValue);
    }, [
        biasByProximityValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.setPreprocessHook(preprocessHookValue);
    }, [
        preprocessHookValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.setPostprocessHook(postprocessHookValue);
    }, [
        postprocessHookValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current) geocoderAutocomplete.current.setSuggestionsFilter(suggestionsFilterValue);
    }, [
        suggestionsFilterValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current && sendGeocoderRequestFuncValue) geocoderAutocomplete.current.setSendGeocoderRequestFunc(sendGeocoderRequestFuncValue);
    }, [
        sendGeocoderRequestFuncValue
    ]);
    (0, $4YNlq.useEffect)(function() {
        if (geocoderAutocomplete.current && sendPlaceDetailsRequestFuncValue) geocoderAutocomplete.current.setSendPlaceDetailsRequestFunc(sendPlaceDetailsRequestFuncValue);
    }, [
        sendPlaceDetailsRequestFuncValue
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($4YNlq))).createElement("div", {
        className: "geocoder-container",
        style: {
            position: "relative"
        },
        ref: function ref(el) {
            return geocoderContainer = el;
        }
    });
};



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");


var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");


var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $JdaC3 = parcelRequire("JdaC3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $5e2ae37e202d75ed$export$ee5828fb8c43a48e(slot) {
    return (0, $fx4gX.default)("MuiCardActionArea", slot);
}
const $5e2ae37e202d75ed$var$cardActionAreaClasses = (0, $auO16.default)("MuiCardActionArea", [
    "root",
    "focusVisible",
    "focusHighlight"
]);
var $5e2ae37e202d75ed$export$2e2bcd8739ae039 = $5e2ae37e202d75ed$var$cardActionAreaClasses;




var $izf4p = parcelRequire("izf4p");
"use client";
const $3f6ce3e8366756b4$var$_excluded = [
    "children",
    "className",
    "focusVisibleClassName"
];
const $3f6ce3e8366756b4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ],
        focusHighlight: [
            "focusHighlight"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $5e2ae37e202d75ed$export$ee5828fb8c43a48e), classes);
};
const $3f6ce3e8366756b4$var$CardActionAreaRoot = (0, $JdaC3.default)((0, $7e17388639953587$export$2e2bcd8739ae039), {
    name: "MuiCardActionArea",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        display: "block",
        textAlign: "inherit",
        borderRadius: "inherit",
        // for Safari to work https://github.com/mui/material-ui/issues/36285.
        width: "100%",
        [`&:hover .${(0, $5e2ae37e202d75ed$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.hoverOpacity,
            "@media (hover: none)": {
                opacity: 0
            }
        },
        [`&.${(0, $5e2ae37e202d75ed$export$2e2bcd8739ae039).focusVisible} .${(0, $5e2ae37e202d75ed$export$2e2bcd8739ae039).focusHighlight}`]: {
            opacity: (theme.vars || theme).palette.action.focusOpacity
        }
    }));
const $3f6ce3e8366756b4$var$CardActionAreaFocusHighlight = (0, $JdaC3.default)("span", {
    name: "MuiCardActionArea",
    slot: "FocusHighlight",
    overridesResolver: (props, styles)=>styles.focusHighlight
})(({ theme: theme })=>({
        overflow: "hidden",
        pointerEvents: "none",
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        borderRadius: "inherit",
        opacity: 0,
        backgroundColor: "currentcolor",
        transition: theme.transitions.create("opacity", {
            duration: theme.transitions.duration.short
        })
    }));
const $3f6ce3e8366756b4$var$CardActionArea = /*#__PURE__*/ $4YNlq.forwardRef(function CardActionArea(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiCardActionArea"
    });
    const { children: children, className: className, focusVisibleClassName: focusVisibleClassName } = props, other = (0, $g54n0.default)(props, $3f6ce3e8366756b4$var$_excluded);
    const ownerState = props;
    const classes = $3f6ce3e8366756b4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($3f6ce3e8366756b4$var$CardActionAreaRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        focusVisibleClassName: (0, $fQQpK.default)(focusVisibleClassName, classes.focusVisible),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            children,
            /*#__PURE__*/ (0, $izf4p.jsx)($3f6ce3e8366756b4$var$CardActionAreaFocusHighlight, {
                className: classes.focusHighlight,
                ownerState: ownerState
            })
        ]
    }));
});
var $3f6ce3e8366756b4$export$2e2bcd8739ae039 = $3f6ce3e8366756b4$var$CardActionArea;





const $418964c551f99742$export$b56e55a3645a3ec = ({ id: id, title: title, price: price, place: place, image: image, to: to = `/places/${id}`, is_published: is_published, showStatus: showStatus })=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$a6c7ac8248d6e38a), {
        className: "flex-1 relative",
        to: to,
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $68fba4ffcff019c8$export$2e2bcd8739ae039), {
            sx: {
                border: "none"
            },
            variant: "outlined",
            children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $3f6ce3e8366756b4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $e73702f2d5dd25fc$export$2e2bcd8739ae039), {
                        sx: {
                            height: 320,
                            width: "100%",
                            borderRadius: "12px"
                        },
                        component: "img",
                        image: image
                    }),
                    showStatus && /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        className: "absolute top-5 left-5",
                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $602fe3d1fce6d807$export$2e2bcd8739ae039), {
                            label: is_published ? "published" : "unpublished",
                            color: is_published ? "success" : "warning",
                            size: "small"
                        })
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsxs)((0, $0ba30a51ef560ecb$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                sx: {
                                    fontWeight: 600
                                },
                                className: "font-bold",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsxs)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                children: [
                                    "\xa3 ",
                                    price,
                                    " per month",
                                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                        sx: {
                                            ml: 1
                                        },
                                        color: "text.secondary",
                                        component: "span",
                                        children: place
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });





var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");



var $36abc2fd75a93025$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($36abc2fd75a93025$exports, "__esModule", {
    value: true
});
$36abc2fd75a93025$exports.default = void 0;

var $36abc2fd75a93025$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $36abc2fd75a93025$var$_default = $36abc2fd75a93025$exports.default = (0, $36abc2fd75a93025$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add");


const $156e1ec0c89cc70d$export$df6ba04d914b0c0a = ()=>{
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$a6c7ac8248d6e38a), {
        className: "flex-1 relative",
        to: "new",
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $68fba4ffcff019c8$export$2e2bcd8739ae039), {
            sx: {
                border: "none",
                height: 320,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            },
            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $3f6ce3e8366756b4$export$2e2bcd8739ae039), {
                sx: {
                    display: "flex",
                    transform: "scale(5)"
                },
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($36abc2fd75a93025$exports))), {
                    fontSize: "inherit"
                })
            })
        })
    });
};



const $f2e4f439a83b539c$export$ba6d244036e50401 = ()=>{
    const { user: user } = (0, $3c0e653794cf487e$export$f2b63d3ca66bb884)();
    const [ads, setAdds] = (0, $4YNlq.useState)([]);
    (0, $4YNlq.useEffect)(()=>{
        const fetchAds = async ()=>{
            const ads = await (0, $4f7ae60590f65051$export$5d530f106b547ae9)(user.email);
            setAdds(ads);
        };
        if (user) fetchAds().catch(console.error);
    }, [
        user
    ]);
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $fd3fcc825e3c65de$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "max-w-screen-lg mx-auto mt-10",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        variant: "h3",
                        mb: 3,
                        children: "My listings"
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-3 gap-5",
                        children: [
                            ads.length ? ads.map(({ place: place, name: name, price: price, id: id, images: images, is_published: is_published })=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $418964c551f99742$export$b56e55a3645a3ec), {
                                    id: id,
                                    image: images[0],
                                    title: name,
                                    place: place,
                                    price: price,
                                    to: `${id}`,
                                    is_published: is_published,
                                    showStatus: true
                                }, id)) : /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                children: "No listings yet"
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $156e1ec0c89cc70d$export$df6ba04d914b0c0a), {})
                        ]
                    })
                ]
            })
        ]
    });
};


parcelRequire("4YNlq");
const $6ec5c2253820aee9$export$6b4e54eafd8bbce5 = ()=>{
    return "hello";
};



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");


var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");

var $izf4p = parcelRequire("izf4p");
parcelRequire("4YNlq");





const $fb82f650831f01fb$export$b56e55a3645a3ec = ({ id: id, title: title, price: price, place: place, image: image, onClick: onClick, city: city })=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$a6c7ac8248d6e38a), {
        className: "flex-1",
        to: `/places/${id}`,
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $68fba4ffcff019c8$export$2e2bcd8739ae039), {
            sx: {
                borderRadius: "12px"
            },
            children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $3f6ce3e8366756b4$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $e73702f2d5dd25fc$export$2e2bcd8739ae039), {
                        sx: {
                            height: 216,
                            width: "100%"
                        },
                        component: "div",
                        image: image
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsxs)((0, $0ba30a51ef560ecb$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                                className: "font-bold truncate text-bold mb-1",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                                className: "truncate text-thin text-gray-600 text-xs mb-2",
                                children: city
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsxs)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $izf4p.jsxs)("span", {
                                        className: "text-bold text-2xl",
                                        children: [
                                            "\xa3",
                                            price
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $izf4p.jsx)("span", {
                                        className: "text-gray-400 text-thin text-xs",
                                        children: "/month"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });




var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");

var $309LR = parcelRequire("309LR");

var $2qCAA = parcelRequire("2qCAA");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");

var $2qCAA = parcelRequire("2qCAA");

var $JdaC3 = parcelRequire("JdaC3");




var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $45a5b996cc1f43c2$export$baa0faa0c7ad8085(slot) {
    return (0, $fx4gX.default)("PrivateSwitchBase", slot);
}
const $45a5b996cc1f43c2$var$switchBaseClasses = (0, $auO16.default)("PrivateSwitchBase", [
    "root",
    "checked",
    "disabled",
    "input",
    "edgeStart",
    "edgeEnd"
]);
var $45a5b996cc1f43c2$export$2e2bcd8739ae039 = $45a5b996cc1f43c2$var$switchBaseClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $5db4dc7bb6fec95d$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $5db4dc7bb6fec95d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            "root",
            checked && "checked",
            disabled && "disabled",
            edge && `edge${(0, $2qCAA.default)(edge)}`
        ],
        input: [
            "input"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $45a5b996cc1f43c2$export$baa0faa0c7ad8085), classes);
};
const $5db4dc7bb6fec95d$var$SwitchBaseRoot = (0, $JdaC3.default)((0, $7e17388639953587$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        padding: 9,
        borderRadius: "50%"
    }, ownerState.edge === "start" && {
        marginLeft: ownerState.size === "small" ? -3 : -12
    }, ownerState.edge === "end" && {
        marginRight: ownerState.size === "small" ? -3 : -12
    }));
const $5db4dc7bb6fec95d$var$SwitchBaseInput = (0, $JdaC3.default)("input", {
    shouldForwardProp: (0, $JdaC3.rootShouldForwardProp)
})({
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $5db4dc7bb6fec95d$var$SwitchBase = /*#__PURE__*/ $4YNlq.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $g54n0.default)(props, $5db4dc7bb6fec95d$var$_excluded);
    const [checked, setCheckedState] = (0, $dcf7b233484e2a32$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: "SwitchBase",
        state: "checked"
    });
    const muiFormControl = (0, $cfa3bdf64b9b659c$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === "undefined") disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === "checkbox" || type === "radio";
    const ownerState = (0, $lzDk3.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $5db4dc7bb6fec95d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($5db4dc7bb6fec95d$var$SwitchBaseRoot, (0, $lzDk3.default)({
        component: "span",
        className: (0, $fQQpK.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)($5db4dc7bb6fec95d$var$SwitchBaseInput, (0, $lzDk3.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === "checkbox" && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $5db4dc7bb6fec95d$export$2e2bcd8739ae039 = $5db4dc7bb6fec95d$var$SwitchBase;



var $4Q3YJ = parcelRequire("4Q3YJ");

var $JdaC3 = parcelRequire("JdaC3");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $174d70c8dbed0f61$export$39f6debbec19b3ba(slot) {
    return (0, $fx4gX.default)("MuiSwitch", slot);
}
const $174d70c8dbed0f61$var$switchClasses = (0, $auO16.default)("MuiSwitch", [
    "root",
    "edgeStart",
    "edgeEnd",
    "switchBase",
    "colorPrimary",
    "colorSecondary",
    "sizeSmall",
    "sizeMedium",
    "checked",
    "disabled",
    "input",
    "thumb",
    "track"
]);
var $174d70c8dbed0f61$export$2e2bcd8739ae039 = $174d70c8dbed0f61$var$switchClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $ff64c408e1f1d34d$var$_excluded = [
    "className",
    "color",
    "edge",
    "size",
    "sx"
];
const $ff64c408e1f1d34d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            "root",
            edge && `edge${(0, $2qCAA.default)(edge)}`,
            `size${(0, $2qCAA.default)(size)}`
        ],
        switchBase: [
            "switchBase",
            `color${(0, $2qCAA.default)(color)}`,
            checked && "checked",
            disabled && "disabled"
        ],
        thumb: [
            "thumb"
        ],
        track: [
            "track"
        ],
        input: [
            "input"
        ]
    };
    const composedClasses = (0, $9JdRu.default)(slots, (0, $174d70c8dbed0f61$export$39f6debbec19b3ba), classes);
    return (0, $lzDk3.default)({}, classes, composedClasses);
};
const $ff64c408e1f1d34d$var$SwitchRoot = (0, $JdaC3.default)("span", {
    name: "MuiSwitch",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $2qCAA.default)(ownerState.edge)}`],
            styles[`size${(0, $2qCAA.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "inline-flex",
        width: 58,
        height: 38,
        overflow: "hidden",
        padding: 12,
        boxSizing: "border-box",
        position: "relative",
        flexShrink: 0,
        zIndex: 0,
        // Reset the stacking context.
        verticalAlign: "middle",
        // For correct alignment with the text.
        "@media print": {
            colorAdjust: "exact"
        }
    }, ownerState.edge === "start" && {
        marginLeft: -8
    }, ownerState.edge === "end" && {
        marginRight: -8
    }, ownerState.size === "small" && {
        width: 40,
        height: 24,
        padding: 7,
        [`& .${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).thumb}`]: {
            width: 16,
            height: 16
        },
        [`& .${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).switchBase}`]: {
            padding: 4,
            [`&.${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).checked}`]: {
                transform: "translateX(16px)"
            }
        }
    }));
const $ff64c408e1f1d34d$var$SwitchSwitchBase = (0, $JdaC3.default)((0, $5db4dc7bb6fec95d$export$2e2bcd8739ae039), {
    name: "MuiSwitch",
    slot: "SwitchBase",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== "default" && styles[`color${(0, $2qCAA.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === "light" ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            "left",
            "transform"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).checked}`]: {
            transform: "translateX(20px)"
        },
        [`&.${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).checked} + .${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).disabled} + .${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === "light" ? 0.12 : 0.2}`
        },
        [`& .${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).input}`]: {
            left: "-100%",
            width: "300%"
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        "&:hover": {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $309LR.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            "@media (hover: none)": {
                backgroundColor: "transparent"
            }
        }
    }, ownerState.color !== "default" && {
        [`&.${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).checked}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main,
            "&:hover": {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $309LR.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
                "@media (hover: none)": {
                    backgroundColor: "transparent"
                }
            },
            [`&.${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).disabled}`]: {
                color: theme.vars ? theme.vars.palette.Switch[`${ownerState.color}DisabledColor`] : `${theme.palette.mode === "light" ? (0, $309LR.lighten)(theme.palette[ownerState.color].main, 0.62) : (0, $309LR.darken)(theme.palette[ownerState.color].main, 0.55)}`
            }
        },
        [`&.${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).checked} + .${(0, $174d70c8dbed0f61$export$2e2bcd8739ae039).track}`]: {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].main
        }
    }));
const $ff64c408e1f1d34d$var$SwitchTrack = (0, $JdaC3.default)("span", {
    name: "MuiSwitch",
    slot: "Track",
    overridesResolver: (props, styles)=>styles.track
})(({ theme: theme })=>({
        height: "100%",
        width: "100%",
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            "opacity",
            "background-color"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === "light" ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === "light" ? 0.38 : 0.3}`
    }));
const $ff64c408e1f1d34d$var$SwitchThumb = (0, $JdaC3.default)("span", {
    name: "MuiSwitch",
    slot: "Thumb",
    overridesResolver: (props, styles)=>styles.thumb
})(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: "currentColor",
        width: 20,
        height: 20,
        borderRadius: "50%"
    }));
const $ff64c408e1f1d34d$var$Switch = /*#__PURE__*/ $4YNlq.forwardRef(function Switch(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiSwitch"
    });
    const { className: className, color: color = "primary", edge: edge = false, size: size = "medium", sx: sx } = props, other = (0, $g54n0.default)(props, $ff64c408e1f1d34d$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        color: color,
        edge: edge,
        size: size
    });
    const classes = $ff64c408e1f1d34d$var$useUtilityClasses(ownerState);
    const icon = /*#__PURE__*/ (0, $izf4p.jsx)($ff64c408e1f1d34d$var$SwitchThumb, {
        className: classes.thumb,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $izf4p.jsxs)($ff64c408e1f1d34d$var$SwitchRoot, {
        className: (0, $fQQpK.default)(classes.root, className),
        sx: sx,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)($ff64c408e1f1d34d$var$SwitchSwitchBase, (0, $lzDk3.default)({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other, {
                classes: (0, $lzDk3.default)({}, classes, {
                    root: classes.switchBase
                })
            })),
            /*#__PURE__*/ (0, $izf4p.jsx)($ff64c408e1f1d34d$var$SwitchTrack, {
                className: classes.track,
                ownerState: ownerState
            })
        ]
    });
});
var $ff64c408e1f1d34d$export$2e2bcd8739ae039 = $ff64c408e1f1d34d$var$Switch;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $c4QxQ = parcelRequire("c4QxQ");

var $fx4gX = parcelRequire("fx4gX");

var $9JdRu = parcelRequire("9JdRu");

var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $k91z8 = parcelRequire("k91z8");

var $c4QxQ = parcelRequire("c4QxQ");



var $3U7IY = parcelRequire("3U7IY");

var $5eyOE = parcelRequire("5eyOE");
const $71be0ab98190e040$var$_excluded = [
    "ownerState"
], $71be0ab98190e040$var$_excluded2 = [
    "variants"
], $71be0ab98190e040$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $71be0ab98190e040$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $71be0ab98190e040$var$isStringTag(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $71be0ab98190e040$export$3ba67b570e26eea0(prop) {
    return prop !== "ownerState" && prop !== "theme" && prop !== "sx" && prop !== "as";
}
const $71be0ab98190e040$export$35e57303dbd8a66 = (0, $3U7IY.default)();
const $71be0ab98190e040$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $71be0ab98190e040$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $71be0ab98190e040$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $71be0ab98190e040$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $71be0ab98190e040$var$processStyleArg(callableStyle, _ref) {
    let { ownerState: ownerState } = _ref, props = (0, $g54n0.default)(_ref, $71be0ab98190e040$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === "function" ? callableStyle((0, $lzDk3.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$71be0ab98190e040$var$processStyleArg(resolvedStyle, (0, $lzDk3.default)({
            ownerState: ownerState
        }, props)));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === "object" && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $g54n0.default)(resolvedStylesArg, $71be0ab98190e040$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === "function") isMatch = variant.props((0, $lzDk3.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                result.push(typeof variant.style === "function" ? variant.style((0, $lzDk3.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style);
            }
        });
        return result;
    }
    return resolvedStylesArg;
}
function $71be0ab98190e040$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $71be0ab98190e040$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $71be0ab98190e040$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $71be0ab98190e040$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $5eyOE.default)((0, $lzDk3.default)({}, props, {
            theme: $71be0ab98190e040$var$resolveTheme((0, $lzDk3.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $k91z8.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $71be0ab98190e040$var$defaultOverridesResolver($71be0ab98190e040$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $g54n0.default)(inputOptions, $71be0ab98190e040$var$_excluded3);
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== "Root" && componentSlot !== "root" || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $71be0ab98190e040$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === "Root" || componentSlot === "root") shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($71be0ab98190e040$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $k91z8.default)(tag, (0, $lzDk3.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === "function" && stylesArg.__emotion_real !== stylesArg || (0, $c4QxQ.isPlainObject)(stylesArg)) return (props)=>$71be0ab98190e040$var$processStyleArg(stylesArg, (0, $lzDk3.default)({}, props, {
                    theme: $71be0ab98190e040$var$resolveTheme({
                        theme: props.theme,
                        defaultTheme: defaultTheme,
                        themeId: themeId
                    })
                }));
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $71be0ab98190e040$var$resolveTheme((0, $lzDk3.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $71be0ab98190e040$var$processStyleArg(slotStyle, (0, $lzDk3.default)({}, props, {
                        theme: theme
                    }));
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $71be0ab98190e040$var$resolveTheme((0, $lzDk3.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $71be0ab98190e040$var$processStyleArg({
                    variants: themeVariants
                }, (0, $lzDk3.default)({}, props, {
                    theme: theme
                }));
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill("");
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $8ca286f3531338e6$var$styled = (0, $71be0ab98190e040$export$2e2bcd8739ae039)();
var $8ca286f3531338e6$export$2e2bcd8739ae039 = $8ca286f3531338e6$var$styled;



var $isLaZ = parcelRequire("isLaZ");

var $kvdFq = parcelRequire("kvdFq");

var $3U7IY = parcelRequire("3U7IY");

var $eY9ud = parcelRequire("eY9ud");

var $5UW2l = parcelRequire("5UW2l");

var $izf4p = parcelRequire("izf4p");
const $efea281a7468ffb4$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $efea281a7468ffb4$var$defaultTheme = (0, $3U7IY.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $efea281a7468ffb4$var$defaultCreateStyledComponent = (0, $8ca286f3531338e6$export$2e2bcd8739ae039)("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
});
function $efea281a7468ffb4$var$useThemePropsDefault(props) {
    return (0, $isLaZ.default)({
        props: props,
        name: "MuiStack",
        defaultTheme: $efea281a7468ffb4$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $efea281a7468ffb4$var$joinChildren(children, separator) {
    const childrenArray = $4YNlq.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $4YNlq.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $efea281a7468ffb4$var$getSideFromDirection = (direction)=>{
    return ({
        row: "Left",
        "row-reverse": "Right",
        column: "Top",
        "column-reverse": "Bottom"
    })[direction];
};
const $efea281a7468ffb4$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $lzDk3.default)({
        display: "flex",
        flexDirection: "column"
    }, (0, $eY9ud.handleBreakpoints)({
        theme: theme
    }, (0, $eY9ud.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $5UW2l.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === "object" && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === "object" && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $eY9ud.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $eY9ud.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === "object") Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : "column";
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $5UW2l.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                "& > :not(style):not(style)": {
                    margin: 0
                },
                "& > :not(style) ~ :not(style)": {
                    [`margin${$efea281a7468ffb4$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $5UW2l.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $c4QxQ.default)(styles, (0, $eY9ud.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $eY9ud.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $efea281a7468ffb4$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $efea281a7468ffb4$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $efea281a7468ffb4$var$useThemePropsDefault, componentName: componentName = "MuiStack" } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                "root"
            ]
        };
        return (0, $9JdRu.default)(slots, (slot)=>(0, $fx4gX.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($efea281a7468ffb4$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $4YNlq.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $kvdFq.default)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = "div", direction: direction = "column", spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $g54n0.default)(props, $efea281a7468ffb4$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $izf4p.jsx)(StackRoot, (0, $lzDk3.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $fQQpK.default)(classes.root, className)
        }, other, {
            children: divider ? $efea281a7468ffb4$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");
"use client";
const $bbebf27f88e63be0$var$Stack = (0, $efea281a7468ffb4$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $JdaC3.default)("div", {
        name: "MuiStack",
        slot: "Root",
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $4Q3YJ.default)({
            props: inProps,
            name: "MuiStack"
        })
});
var $bbebf27f88e63be0$export$2e2bcd8739ae039 = $bbebf27f88e63be0$var$Stack;




var $2qCAA = parcelRequire("2qCAA");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $faaa9dd73c062b21$export$717666c39ec07e12(slot) {
    return (0, $fx4gX.default)("MuiFormControlLabel", slot);
}
const $faaa9dd73c062b21$var$formControlLabelClasses = (0, $auO16.default)("MuiFormControlLabel", [
    "root",
    "labelPlacementStart",
    "labelPlacementTop",
    "labelPlacementBottom",
    "disabled",
    "label",
    "error",
    "required",
    "asterisk"
]);
var $faaa9dd73c062b21$export$2e2bcd8739ae039 = $faaa9dd73c062b21$var$formControlLabelClasses;




var $izf4p = parcelRequire("izf4p");
"use client";
const $45a4ac56987046a9$var$_excluded = [
    "checked",
    "className",
    "componentsProps",
    "control",
    "disabled",
    "disableTypography",
    "inputRef",
    "label",
    "labelPlacement",
    "name",
    "onChange",
    "required",
    "slotProps",
    "value"
];
const $45a4ac56987046a9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            "root",
            disabled && "disabled",
            `labelPlacement${(0, $2qCAA.default)(labelPlacement)}`,
            error && "error",
            required && "required"
        ],
        label: [
            "label",
            disabled && "disabled"
        ],
        asterisk: [
            "asterisk",
            error && "error"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $faaa9dd73c062b21$export$717666c39ec07e12), classes);
};
const $45a4ac56987046a9$export$1b479270917a5676 = (0, $JdaC3.default)("label", {
    name: "MuiFormControlLabel",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $faaa9dd73c062b21$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $2qCAA.default)(ownerState.labelPlacement)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "inline-flex",
        alignItems: "center",
        cursor: "pointer",
        // For correct alignment with the text.
        verticalAlign: "middle",
        WebkitTapHighlightColor: "transparent",
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $faaa9dd73c062b21$export$2e2bcd8739ae039).disabled}`]: {
            cursor: "default"
        }
    }, ownerState.labelPlacement === "start" && {
        flexDirection: "row-reverse",
        marginLeft: 16,
        // used for row presentation of radio/checkbox
        marginRight: -11
    }, ownerState.labelPlacement === "top" && {
        flexDirection: "column-reverse",
        marginLeft: 16
    }, ownerState.labelPlacement === "bottom" && {
        flexDirection: "column",
        marginLeft: 16
    }, {
        [`& .${(0, $faaa9dd73c062b21$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $faaa9dd73c062b21$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        }
    }));
const $45a4ac56987046a9$var$AsteriskComponent = (0, $JdaC3.default)("span", {
    name: "MuiFormControlLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $faaa9dd73c062b21$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $45a4ac56987046a9$var$FormControlLabel = /*#__PURE__*/ $4YNlq.forwardRef(function FormControlLabel(inProps, ref) {
    var _ref, _slotProps$typography;
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiFormControlLabel"
    });
    const { className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, label: labelProp, labelPlacement: labelPlacement = "end", required: requiredProp, slotProps: slotProps = {} } = props, other = (0, $g54n0.default)(props, $45a4ac56987046a9$var$_excluded);
    const muiFormControl = (0, $cfa3bdf64b9b659c$export$2e2bcd8739ae039)();
    const disabled = (_ref = disabledProp != null ? disabledProp : control.props.disabled) != null ? _ref : muiFormControl == null ? void 0 : muiFormControl.disabled;
    const required = requiredProp != null ? requiredProp : control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        "checked",
        "name",
        "onChange",
        "value",
        "inputRef"
    ].forEach((key)=>{
        if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") controlProps[key] = props[key];
    });
    const fcs = (0, $dd55e33f0dc69096$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            "error"
        ]
    });
    const ownerState = (0, $lzDk3.default)({}, props, {
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    });
    const classes = $45a4ac56987046a9$var$useUtilityClasses(ownerState);
    const typographySlotProps = (_slotProps$typography = slotProps.typography) != null ? _slotProps$typography : componentsProps.typography;
    let label = labelProp;
    if (label != null && label.type !== (0, $af664934923ca384$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), (0, $lzDk3.default)({
        component: "span"
    }, typographySlotProps, {
        className: (0, $fQQpK.default)(classes.label, typographySlotProps == null ? void 0 : typographySlotProps.className),
        children: label
    }));
    return /*#__PURE__*/ (0, $izf4p.jsxs)($45a4ac56987046a9$export$1b479270917a5676, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ $4YNlq.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $izf4p.jsxs)((0, $bbebf27f88e63be0$export$2e2bcd8739ae039), {
                display: "block",
                children: [
                    label,
                    /*#__PURE__*/ (0, $izf4p.jsxs)($45a4ac56987046a9$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            "*"
                        ]
                    })
                ]
            }) : label
        ]
    }));
});
var $45a4ac56987046a9$export$2e2bcd8739ae039 = $45a4ac56987046a9$var$FormControlLabel;


const $9984ef906dde2255$export$51d95724e2f95a4d = ({ ads: ads, totalAdNumber: totalAdNumber, setShowMap: setShowMap, showMap: showMap, showTitle: showTitle })=>{
    const areNoResults = ads.length === 0;
    return /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
        className: "px-4 max-w-[1120px] w-full pb-20 hide md:block",
        children: [
            showTitle && !areNoResults && /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "text-[40px] flex justify-center pt-10 bold text-center",
                children: "Storage nearby"
            }),
            !areNoResults && /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "py-5 justify-between flex text-gray-500",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsxs)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                        children: [
                            "Showing ",
                            ads.length,
                            " out of ",
                            totalAdNumber,
                            " locations"
                        ]
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        className: "hidden lg:block",
                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $af664934923ca384$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $45a4ac56987046a9$export$2e2bcd8739ae039), {
                                control: /*#__PURE__*/ (0, $izf4p.jsx)((0, $ff64c408e1f1d34d$export$2e2bcd8739ae039), {
                                    value: showMap,
                                    onChange: (e)=>setShowMap(e.target.checked)
                                }),
                                label: "Show map",
                                labelPlacement: "start"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-10  gap-x-8",
                children: ads.map(({ place: place, name: name, price: price, id: id, images: images, city: city })=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $fb82f650831f01fb$export$b56e55a3645a3ec), {
                        onClick: ()=>console.log(id),
                        id: id,
                        image: images[0],
                        title: name,
                        place: place,
                        price: price,
                        city: city
                    }, id))
            }),
            areNoResults && /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        className: "font-bold text-3xl text-center mb-8",
                        children: "O results"
                    }),
                    /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        className: "text-secondary text-center",
                        children: "Try to change your request"
                    })
                ]
            })
        ]
    });
};





var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");
parcelRequire("dKCZL");


var $fQQpK = parcelRequire("fQQpK");


var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");

var $fQQpK = parcelRequire("fQQpK");





var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $abQbA = parcelRequire("abQbA");




var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $71d6ffbc107179e8$export$5162da8f798e0959(slot) {
    return (0, $fx4gX.default)("MuiCollapse", slot);
}
const $71d6ffbc107179e8$var$collapseClasses = (0, $auO16.default)("MuiCollapse", [
    "root",
    "horizontal",
    "vertical",
    "entered",
    "hidden",
    "wrapper",
    "wrapperInner"
]);
var $71d6ffbc107179e8$export$2e2bcd8739ae039 = $71d6ffbc107179e8$var$collapseClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $5fe8799dda5c4338$var$_excluded = [
    "addEndListener",
    "children",
    "className",
    "collapsedSize",
    "component",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "orientation",
    "style",
    "timeout",
    "TransitionComponent"
];
const $5fe8799dda5c4338$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            "root",
            `${orientation}`
        ],
        entered: [
            "entered"
        ],
        hidden: [
            "hidden"
        ],
        wrapper: [
            "wrapper",
            `${orientation}`
        ],
        wrapperInner: [
            "wrapperInner",
            `${orientation}`
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $71d6ffbc107179e8$export$5162da8f798e0959), classes);
};
const $5fe8799dda5c4338$var$CollapseRoot = (0, $JdaC3.default)("div", {
    name: "MuiCollapse",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === "entered" && styles.entered,
            ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        height: 0,
        overflow: "hidden",
        transition: theme.transitions.create("height")
    }, ownerState.orientation === "horizontal" && {
        height: "auto",
        width: 0,
        transition: theme.transitions.create("width")
    }, ownerState.state === "entered" && (0, $lzDk3.default)({
        height: "auto",
        overflow: "visible"
    }, ownerState.orientation === "horizontal" && {
        width: "auto"
    }), ownerState.state === "exited" && !ownerState.in && ownerState.collapsedSize === "0px" && {
        visibility: "hidden"
    }));
const $5fe8799dda5c4338$var$CollapseWrapper = (0, $JdaC3.default)("div", {
    name: "MuiCollapse",
    slot: "Wrapper",
    overridesResolver: (props, styles)=>styles.wrapper
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        // Hack to get children with a negative margin to not falsify the height computation.
        display: "flex",
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
const $5fe8799dda5c4338$var$CollapseWrapperInner = (0, $JdaC3.default)("div", {
    name: "MuiCollapse",
    slot: "WrapperInner",
    overridesResolver: (props, styles)=>styles.wrapperInner
})(({ ownerState: ownerState })=>(0, $lzDk3.default)({
        width: "100%"
    }, ownerState.orientation === "horizontal" && {
        width: "auto",
        height: "100%"
    }));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5fe8799dda5c4338$var$Collapse = /*#__PURE__*/ $4YNlq.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiCollapse"
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = "0px", component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = "vertical", style: style, timeout: timeout = (0, $abQbA.duration).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $c4b9c02358af45ec$export$2e2bcd8739ae039) } = props, other = (0, $g54n0.default)(props, $5fe8799dda5c4338$var$_excluded);
    const ownerState = (0, $lzDk3.default)({}, props, {
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    });
    const classes = $5fe8799dda5c4338$var$useUtilityClasses(ownerState);
    const theme = (0, $b637578efda8bead$export$2e2bcd8739ae039)();
    const timer = (0, $973088a6538d1d0c$export$2e2bcd8739ae039)();
    const wrapperRef = $4YNlq.useRef(null);
    const autoTransitionDuration = $4YNlq.useRef();
    const collapsedSize = typeof collapsedSizeProp === "number" ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === "horizontal";
    const size = isHorizontal ? "width" : "height";
    const nodeRef = $4YNlq.useRef(null);
    const handleRef = (0, $4019772905761825$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? "clientWidth" : "clientHeight"] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = "absolute";
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = "";
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $2bb0265716437a48$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "enter"
        });
        if (timeout === "auto") {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = "auto";
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $2bb0265716437a48$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: "exit"
        });
        if (timeout === "auto") {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === "auto") timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $izf4p.jsx)(TransitionComponent, (0, $lzDk3.default)({
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === "auto" ? null : timeout
    }, other, {
        children: (state, childProps)=>/*#__PURE__*/ (0, $izf4p.jsx)($5fe8799dda5c4338$var$CollapseRoot, (0, $lzDk3.default)({
                as: component,
                className: (0, $fQQpK.default)(classes.root, className, {
                    "entered": classes.entered,
                    "exited": !inProp && collapsedSize === "0px" && classes.hidden
                }[state]),
                style: (0, $lzDk3.default)({
                    [isHorizontal ? "minWidth" : "minHeight"]: collapsedSize
                }, style),
                ref: handleRef
            }, childProps, {
                // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
                // that might have been forwarded from the Transition component.
                ownerState: (0, $lzDk3.default)({}, ownerState, {
                    state: state
                }),
                children: /*#__PURE__*/ (0, $izf4p.jsx)($5fe8799dda5c4338$var$CollapseWrapper, {
                    ownerState: (0, $lzDk3.default)({}, ownerState, {
                        state: state
                    }),
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $izf4p.jsx)($5fe8799dda5c4338$var$CollapseWrapperInner, {
                        ownerState: (0, $lzDk3.default)({}, ownerState, {
                            state: state
                        }),
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            }))
    }));
});
$5fe8799dda5c4338$var$Collapse.muiSupportAuto = true;
var $5fe8799dda5c4338$export$2e2bcd8739ae039 = $5fe8799dda5c4338$var$Collapse;




var $4YNlq = parcelRequire("4YNlq");
"use client";
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $fbe3c9e654b76cc4$var$AccordionContext = /*#__PURE__*/ $4YNlq.createContext({});
var $fbe3c9e654b76cc4$export$2e2bcd8739ae039 = $fbe3c9e654b76cc4$var$AccordionContext;





var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $492c40ef89957df9$export$80fb6a2cb3f13b8b(slot) {
    return (0, $fx4gX.default)("MuiAccordion", slot);
}
const $492c40ef89957df9$var$accordionClasses = (0, $auO16.default)("MuiAccordion", [
    "root",
    "rounded",
    "expanded",
    "disabled",
    "gutters",
    "region"
]);
var $492c40ef89957df9$export$2e2bcd8739ae039 = $492c40ef89957df9$var$accordionClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $925c00a3f4e6584d$var$_excluded = [
    "children",
    "className",
    "defaultExpanded",
    "disabled",
    "disableGutters",
    "expanded",
    "onChange",
    "square",
    "slots",
    "slotProps",
    "TransitionComponent",
    "TransitionProps"
];
const $925c00a3f4e6584d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            "root",
            !square && "rounded",
            expanded && "expanded",
            disabled && "disabled",
            !disableGutters && "gutters"
        ],
        region: [
            "region"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $492c40ef89957df9$export$80fb6a2cb3f13b8b), classes);
};
const $925c00a3f4e6584d$var$AccordionRoot = (0, $JdaC3.default)((0, $b622387df7e39ff3$export$2e2bcd8739ae039), {
    name: "MuiAccordion",
    slot: "Root",
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $492c40ef89957df9$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: "relative",
        transition: theme.transitions.create([
            "margin"
        ], transition),
        overflowAnchor: "none",
        // Keep the same scrolling position
        "&::before": {
            position: "absolute",
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                "opacity",
                "background-color"
            ], transition)
        },
        "&:first-of-type": {
            "&::before": {
                display: "none"
            }
        },
        [`&.${(0, $492c40ef89957df9$export$2e2bcd8739ae039).expanded}`]: {
            "&::before": {
                opacity: 0
            },
            "&:first-of-type": {
                marginTop: 0
            },
            "&:last-of-type": {
                marginBottom: 0
            },
            "& + &": {
                "&::before": {
                    display: "none"
                }
            }
        },
        [`&.${(0, $492c40ef89957df9$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}, ({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({}, !ownerState.square && {
        borderRadius: 0,
        "&:first-of-type": {
            borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
            borderTopRightRadius: (theme.vars || theme).shape.borderRadius
        },
        "&:last-of-type": {
            borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
            borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
            // Fix a rendering issue on Edge
            "@supports (-ms-ime-align: auto)": {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0
            }
        }
    }, !ownerState.disableGutters && {
        [`&.${(0, $492c40ef89957df9$export$2e2bcd8739ae039).expanded}`]: {
            margin: "16px 0"
        }
    }));
const $925c00a3f4e6584d$var$Accordion = /*#__PURE__*/ $4YNlq.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiAccordion"
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp } = props, other = (0, $g54n0.default)(props, $925c00a3f4e6584d$var$_excluded);
    const [expanded, setExpandedState] = (0, $dcf7b233484e2a32$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: "Accordion",
        state: "expanded"
    });
    const handleChange = $4YNlq.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $4YNlq.Children.toArray(childrenProp);
    const contextValue = $4YNlq.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = (0, $lzDk3.default)({}, props, {
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    });
    const classes = $925c00a3f4e6584d$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = (0, $lzDk3.default)({
        transition: TransitionComponentProp
    }, slots);
    const backwardCompatibleSlotProps = (0, $lzDk3.default)({
        transition: TransitionPropsProp
    }, slotProps);
    const [TransitionSlot, transitionProps] = (0, $2baf81eecfc54562$export$2e2bcd8739ae039)("transition", {
        elementType: (0, $5fe8799dda5c4338$export$2e2bcd8739ae039),
        externalForwardedProps: {
            slots: backwardCompatibleSlots,
            slotProps: backwardCompatibleSlotProps
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $izf4p.jsxs)($925c00a3f4e6584d$var$AccordionRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        square: square
    }, other, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $fbe3c9e654b76cc4$export$2e2bcd8739ae039).Provider, {
                value: contextValue,
                children: summary
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)(TransitionSlot, (0, $lzDk3.default)({
                in: expanded,
                timeout: "auto"
            }, transitionProps, {
                children: /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                    "aria-labelledby": summary.props.id,
                    id: summary.props["aria-controls"],
                    role: "region",
                    className: classes.region,
                    children: children
                })
            }))
        ]
    }));
});
var $925c00a3f4e6584d$export$2e2bcd8739ae039 = $925c00a3f4e6584d$var$Accordion;



var $g54n0 = parcelRequire("g54n0");

var $lzDk3 = parcelRequire("lzDk3");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");



var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $0f9b90bedf3c9b27$export$282216ad123d6580(slot) {
    return (0, $fx4gX.default)("MuiAccordionSummary", slot);
}
const $0f9b90bedf3c9b27$var$accordionSummaryClasses = (0, $auO16.default)("MuiAccordionSummary", [
    "root",
    "expanded",
    "focusVisible",
    "disabled",
    "gutters",
    "contentGutters",
    "content",
    "expandIconWrapper"
]);
var $0f9b90bedf3c9b27$export$2e2bcd8739ae039 = $0f9b90bedf3c9b27$var$accordionSummaryClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $e04d59ed156ff918$var$_excluded = [
    "children",
    "className",
    "expandIcon",
    "focusVisibleClassName",
    "onClick"
];
const $e04d59ed156ff918$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            "root",
            expanded && "expanded",
            disabled && "disabled",
            !disableGutters && "gutters"
        ],
        focusVisible: [
            "focusVisible"
        ],
        content: [
            "content",
            expanded && "expanded",
            !disableGutters && "contentGutters"
        ],
        expandIconWrapper: [
            "expandIconWrapper",
            expanded && "expanded"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $0f9b90bedf3c9b27$export$282216ad123d6580), classes);
};
const $e04d59ed156ff918$var$AccordionSummaryRoot = (0, $JdaC3.default)((0, $7e17388639953587$export$2e2bcd8739ae039), {
    name: "MuiAccordionSummary",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme, ownerState: ownerState })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return (0, $lzDk3.default)({
        display: "flex",
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            "min-height",
            "background-color"
        ], transition),
        [`&.${(0, $0f9b90bedf3c9b27$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $0f9b90bedf3c9b27$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $0f9b90bedf3c9b27$export$2e2bcd8739ae039).disabled})`]: {
            cursor: "pointer"
        }
    }, !ownerState.disableGutters && {
        [`&.${(0, $0f9b90bedf3c9b27$export$2e2bcd8739ae039).expanded}`]: {
            minHeight: 64
        }
    });
});
const $e04d59ed156ff918$var$AccordionSummaryContent = (0, $JdaC3.default)("div", {
    name: "MuiAccordionSummary",
    slot: "Content",
    overridesResolver: (props, styles)=>styles.content
})(({ theme: theme, ownerState: ownerState })=>(0, $lzDk3.default)({
        display: "flex",
        flexGrow: 1,
        margin: "12px 0"
    }, !ownerState.disableGutters && {
        transition: theme.transitions.create([
            "margin"
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $0f9b90bedf3c9b27$export$2e2bcd8739ae039).expanded}`]: {
            margin: "20px 0"
        }
    }));
const $e04d59ed156ff918$var$AccordionSummaryExpandIconWrapper = (0, $JdaC3.default)("div", {
    name: "MuiAccordionSummary",
    slot: "ExpandIconWrapper",
    overridesResolver: (props, styles)=>styles.expandIconWrapper
})(({ theme: theme })=>({
        display: "flex",
        color: (theme.vars || theme).palette.action.active,
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $0f9b90bedf3c9b27$export$2e2bcd8739ae039).expanded}`]: {
            transform: "rotate(180deg)"
        }
    }));
const $e04d59ed156ff918$var$AccordionSummary = /*#__PURE__*/ $4YNlq.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiAccordionSummary"
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick } = props, other = (0, $g54n0.default)(props, $e04d59ed156ff918$var$_excluded);
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $4YNlq.useContext((0, $fbe3c9e654b76cc4$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = (0, $lzDk3.default)({}, props, {
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    });
    const classes = $e04d59ed156ff918$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsxs)($e04d59ed156ff918$var$AccordionSummaryRoot, (0, $lzDk3.default)({
        focusRipple: false,
        disableRipple: true,
        disabled: disabled,
        component: "div",
        "aria-expanded": expanded,
        className: (0, $fQQpK.default)(classes.root, className),
        focusVisibleClassName: (0, $fQQpK.default)(classes.focusVisible, focusVisibleClassName),
        onClick: handleChange,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)($e04d59ed156ff918$var$AccordionSummaryContent, {
                className: classes.content,
                ownerState: ownerState,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $izf4p.jsx)($e04d59ed156ff918$var$AccordionSummaryExpandIconWrapper, {
                className: classes.expandIconWrapper,
                ownerState: ownerState,
                children: expandIcon
            })
        ]
    }));
});
var $e04d59ed156ff918$export$2e2bcd8739ae039 = $e04d59ed156ff918$var$AccordionSummary;



var $lzDk3 = parcelRequire("lzDk3");

var $g54n0 = parcelRequire("g54n0");

var $4YNlq = parcelRequire("4YNlq");


var $fQQpK = parcelRequire("fQQpK");

var $9JdRu = parcelRequire("9JdRu");

var $JdaC3 = parcelRequire("JdaC3");

var $4Q3YJ = parcelRequire("4Q3YJ");

var $auO16 = parcelRequire("auO16");

var $fx4gX = parcelRequire("fx4gX");
function $7d37555534c86cf4$export$a6afb527becfac26(slot) {
    return (0, $fx4gX.default)("MuiAccordionDetails", slot);
}
const $7d37555534c86cf4$var$accordionDetailsClasses = (0, $auO16.default)("MuiAccordionDetails", [
    "root"
]);
var $7d37555534c86cf4$export$2e2bcd8739ae039 = $7d37555534c86cf4$var$accordionDetailsClasses;



var $izf4p = parcelRequire("izf4p");
"use client";
const $d9afc544482555c5$var$_excluded = [
    "className"
];
const $d9afc544482555c5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            "root"
        ]
    };
    return (0, $9JdRu.default)(slots, (0, $7d37555534c86cf4$export$a6afb527becfac26), classes);
};
const $d9afc544482555c5$var$AccordionDetailsRoot = (0, $JdaC3.default)("div", {
    name: "MuiAccordionDetails",
    slot: "Root",
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    }));
const $d9afc544482555c5$var$AccordionDetails = /*#__PURE__*/ $4YNlq.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $4Q3YJ.default)({
        props: inProps,
        name: "MuiAccordionDetails"
    });
    const { className: className } = props, other = (0, $g54n0.default)(props, $d9afc544482555c5$var$_excluded);
    const ownerState = props;
    const classes = $d9afc544482555c5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $izf4p.jsx)($d9afc544482555c5$var$AccordionDetailsRoot, (0, $lzDk3.default)({
        className: (0, $fQQpK.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $d9afc544482555c5$export$2e2bcd8739ae039 = $d9afc544482555c5$var$AccordionDetails;


var $71a57bd631b48b24$exports = {};
"use strict";
"use client";

var $2NJ2K = parcelRequire("2NJ2K");
Object.defineProperty($71a57bd631b48b24$exports, "__esModule", {
    value: true
});
$71a57bd631b48b24$exports.default = void 0;

var $71a57bd631b48b24$var$_createSvgIcon = $2NJ2K((parcelRequire("5o1nK")));

var $izf4p = parcelRequire("izf4p");
var $71a57bd631b48b24$var$_default = $71a57bd631b48b24$exports.default = (0, $71a57bd631b48b24$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $izf4p.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");


const $288b7cccfea587eb$var$FAQ_CONTENT = [
    {
        question: "I have only a few pallets. Can I find a place for them only",
        answer: "Absolutely, our partners have storage solutions for all shapes and sizes. From single items all the way through to whole warehouses."
    },
    {
        question: "How I can extend my storage period",
        answer: "Depending on availability of the partner you may be able to extend your storage. Extra costs might be incurred, alternatively you can chose another partner."
    },
    {
        question: "What if I don't want to rent the whole warehouse",
        answer: "That\u2019s fine, just search for the size you want. Venuse was set up with growing businesses in mind so we understand at this time you might only need a small space."
    },
    {
        question: "How can I rent my own place (e.g. a garage)",
        answer: "To rent you own space simply register as a landlord at the top of our page"
    }
];
const $288b7cccfea587eb$export$690878eeeaffbdc8 = ()=>{
    return /*#__PURE__*/ (0, $izf4p.jsx)("div", {
        className: "flex justify-center pt-10 pb-20 bg-[#f9f9fe]",
        children: /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
            className: "max-w-[560px]",
            children: [
                /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                    className: "flex justify-center text-4xl lg:text-3xl text-[#c83232] font-bold mb-8 text-center",
                    children: "Frequently asked questions"
                }),
                /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                    children: $288b7cccfea587eb$var$FAQ_CONTENT.map((content, key)=>/*#__PURE__*/ (0, $4YNlq.createElement)($288b7cccfea587eb$var$Question, {
                            ...content,
                            key: key
                        }))
                })
            ]
        })
    });
};
const $288b7cccfea587eb$var$Question = ({ question: question, answer: answer })=>{
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $925c00a3f4e6584d$export$2e2bcd8739ae039), {
        elevation: 0,
        sx: {
            "&:before": {
                height: "0px"
            }
        },
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $e04d59ed156ff918$export$2e2bcd8739ae039), {
                sx: {
                    backgroundColor: "#f9f9fe",
                    fontWeight: "bold"
                },
                expandIcon: /*#__PURE__*/ (0, $izf4p.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71a57bd631b48b24$exports))), {
                    sx: {}
                }),
                children: question
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $d9afc544482555c5$export$2e2bcd8739ae039), {
                sx: {
                    backgroundColor: "#f9f9fe"
                },
                children: answer
            })
        ]
    });
};



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");


var $7Dpty = parcelRequire("7Dpty");
const $ae2e13e3a3ac0fb0$export$8e56b8ae6a483118 = ({ ads: ads })=>{
    const mapRef = (0, $4YNlq.useRef)();
    const bounds = new (0, (/*@__PURE__*/$parcel$interopDefault($7Dpty))).LngLatBounds();
    const popup = (text)=>{
        return new (0, (/*@__PURE__*/$parcel$interopDefault($7Dpty))).Popup().setText(text);
    };
    ads.forEach((ad)=>{
        bounds.extend([
            ad.longitude,
            ad.latitude
        ]);
    });
    mapRef.current?.fitBounds(bounds, {
        padding: 100,
        duration: 1000
    });
    return /*#__PURE__*/ (0, $izf4p.jsx)((0, $cdc123c2f2fe89f8$export$2e2bcd8739ae039), {
        ref: mapRef,
        cooperativeGestures: true,
        mapboxAccessToken: "pk.eyJ1IjoibWlraGV5cm9qbyIsImEiOiJjbHN0NnNxaXowbzZhMmxxc2pkN2FsaWJ5In0.OTcPpx4BlZlCR4VF4FofAg",
        initialViewState: {
            longitude: -2.5,
            latitude: 54,
            zoom: 5.8
        },
        style: {
            height: "100%"
        },
        mapStyle: "mapbox://styles/mapbox/streets-v9",
        children: ads.map(({ name: name, longitude: longitude, latitude: latitude }, index)=>/*#__PURE__*/ (0, $izf4p.jsx)((0, $cdc123c2f2fe89f8$export$e98856a975cab58e), {
                longitude: longitude,
                latitude: latitude,
                popup: popup(name),
                color: "red",
                onClick: (args)=>console.log(args)
            }, index))
    });
};


const $0d0e184f80d05400$export$12449a31c6671d53 = ()=>{
    const [ads, setAdds] = (0, $4YNlq.useState)([]);
    const [showMap, setShowMap] = (0, $4YNlq.useState)(false);
    const [type, onTypeChange] = (0, $4YNlq.useState)();
    const [city, onCityChange] = (0, $4YNlq.useState)();
    const [checkInDate, onCheckInDateChange] = (0, $4YNlq.useState)();
    const [checkOutDate, onCheckOutDateChange] = (0, $4YNlq.useState)();
    (0, $4YNlq.useEffect)(()=>{
        const fetchAds = async ()=>{
            const ads = await (0, $4f7ae60590f65051$export$10bf54e825e44464)();
            setAdds(ads);
        };
        fetchAds().catch(console.error);
    }, []);
    const filteredAds = ads.filter((ad)=>{
        const typeFilter = Boolean(type) ? ad?.storage_type.includes(type) : true;
        const cityFilter = Boolean(city) ? ad?.city === city : true;
        return typeFilter && cityFilter;
    });
    const allCities = [
        ...new Set(ads.map((ad)=>ad.city))
    ].sort();
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $fd3fcc825e3c65de$export$8b251419efc915eb), {
                onCityChange: onCityChange,
                onTypeChange: onTypeChange,
                cities: allCities,
                selectedCity: city,
                selectedType: type,
                checkInDate: checkInDate,
                checkOutDate: checkOutDate,
                onCheckInDateChange: onCheckInDateChange,
                onCheckOutDateChange: onCheckOutDateChange
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                style: {
                    width: "100%",
                    height: "333px",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundImage: "url(https://res.cloudinary.com/dhlzvktzj/image/upload/v1714218099/sunni/hero-short_x7vvfx.jpg)"
                },
                className: "relative hidden lg:block bg-no-repeat bg-cover",
                children: /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                    className: "h-full absolute top-0 bottom-0 flex justify-center items-center flex-col pl-[150px]",
                    children: [
                        /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                            className: "bg-white  px-10 rounded-2xl mb-10",
                            children: /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                                className: "text-[64px]  font-bold py-4 leading-[80px]",
                                children: [
                                    "Space for",
                                    /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                                        children: [
                                            "your ",
                                            "\xa0",
                                            /*#__PURE__*/ (0, $izf4p.jsx)("span", {
                                                className: "text-[#c83232]",
                                                children: "growth"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                            className: "text-white text-[21px]",
                            children: "Find a short-term storage that fits your size"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "flex justify-center pt-4",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $9984ef906dde2255$export$51d95724e2f95a4d), {
                        showTitle: true,
                        showMap: showMap,
                        setShowMap: setShowMap,
                        ads: filteredAds,
                        totalAdNumber: ads.length
                    }),
                    showMap && /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        className: "w-[30%] h-auto",
                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $ae2e13e3a3ac0fb0$export$8e56b8ae6a483118), {
                            ads: filteredAds
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $288b7cccfea587eb$export$690878eeeaffbdc8), {}),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $f6e406b36921f3db$export$a06f1c675e846f6f), {})
        ]
    });
};



var $izf4p = parcelRequire("izf4p");

var $4YNlq = parcelRequire("4YNlq");






const $9f381c7225dd5629$export$6b319031325f309a = ()=>{
    const { state: state } = (0, $4fd73b9fb5b80e1f$export$45d76561a5302f2b)();
    console.log(state);
    const [ads, setAdds] = (0, $4YNlq.useState)([]);
    const [showMap, setShowMap] = (0, $4YNlq.useState)(false);
    const [type, onTypeChange] = (0, $4YNlq.useState)(state?.selectedType);
    const [city, onCityChange] = (0, $4YNlq.useState)(state?.selectedCity);
    const [checkInDate, onCheckInDateChange] = (0, $4YNlq.useState)(state?.checkInDate);
    const [checkOutDate, onCheckOutDateChange] = (0, $4YNlq.useState)(state?.checkOutDate);
    (0, $4YNlq.useEffect)(()=>{
        const fetchAds = async ()=>{
            const ads = await (0, $4f7ae60590f65051$export$10bf54e825e44464)();
            setAdds(ads);
        };
        fetchAds().catch(console.error);
    }, []);
    const filteredAds = ads.filter((ad)=>{
        const typeFilter = Boolean(type) ? ad?.storage_type.includes(type) : true;
        const cityFilter = Boolean(city) ? ad?.city === city : true;
        return typeFilter && cityFilter;
    });
    const allCities = [
        ...new Set(ads.map((ad)=>ad.city))
    ].sort();
    return /*#__PURE__*/ (0, $izf4p.jsxs)((0, $izf4p.Fragment), {
        children: [
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $fd3fcc825e3c65de$export$8b251419efc915eb), {
                onCityChange: onCityChange,
                onTypeChange: onTypeChange,
                cities: allCities,
                selectedCity: city,
                selectedType: type,
                checkInDate: checkInDate,
                checkOutDate: checkOutDate,
                onCheckInDateChange: onCheckInDateChange,
                onCheckOutDateChange: onCheckOutDateChange
            }),
            /*#__PURE__*/ (0, $izf4p.jsxs)("div", {
                className: "flex justify-center pt-4",
                children: [
                    /*#__PURE__*/ (0, $izf4p.jsx)((0, $9984ef906dde2255$export$51d95724e2f95a4d), {
                        showMap: showMap,
                        setShowMap: setShowMap,
                        ads: filteredAds,
                        totalAdNumber: ads.length
                    }),
                    showMap && /*#__PURE__*/ (0, $izf4p.jsx)("div", {
                        className: "w-[30%] h-auto",
                        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $ae2e13e3a3ac0fb0$export$8e56b8ae6a483118), {
                            ads: filteredAds
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $izf4p.jsx)((0, $f6e406b36921f3db$export$a06f1c675e846f6f), {})
        ]
    });
};


const $1781cf7bcb3e2b12$var$root = (0, $bb838d9b4dec0cfe$export$882461b6382ed46c)(document.getElementById("root"));
const $1781cf7bcb3e2b12$var$theme = (0, $hxzCU.default)({
    typography: {
        h1: {
            fontSize: "40px",
            lineHeight: "52px",
            fontWeight: "bold"
        },
        h3: {
            fontSize: "24px",
            lineHeight: "36px",
            fontWeight: "bold"
        },
        h4: {
            fontSize: "18px",
            lineHeight: "27px",
            fontWeight: "bold"
        },
        fontFamily: [
            "Lato",
            "-apple-system",
            "BlinkMacSystemFont",
            '"Segoe UI"',
            "Roboto",
            '"Helvetica Neue"',
            "Arial",
            "sans-serif",
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"'
        ].join(",")
    }
});
$1781cf7bcb3e2b12$var$root.render(/*#__PURE__*/ (0, $izf4p.jsx)((0, $d54b578cc0fa217b$export$2e2bcd8739ae039), {
    theme: $1781cf7bcb3e2b12$var$theme,
    children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $3c0e653794cf487e$export$6aefaad9cc4faf3c), {
        domain: "dev-lbynap1sf554nq75.us.auth0.com",
        clientId: "q81K21psa8h6Wjzym9HnZw2PvlUbz6Lb",
        authorizationParams: {
            redirect_uri: window.location.origin + "/account"
        },
        children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $7743edd5d01c3bfe$export$d6a9fecd57633387), {
            apiKey: undefined,
            children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $f34cc3f354a72d02$export$dc45bdc734ce6f1e), {
                dateAdapter: (0, $45a0d1f63ab1e3be$export$33545c6a80bae043),
                children: /*#__PURE__*/ (0, $izf4p.jsx)((0, $34a8b74366f8f95b$export$9ba4e89fdfa1fc54), {
                    children: /*#__PURE__*/ (0, $izf4p.jsxs)((0, $4fd73b9fb5b80e1f$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $izf4p.jsx)((0, $0d0e184f80d05400$export$12449a31c6671d53), {})
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6), {
                                path: "/search",
                                element: /*#__PURE__*/ (0, $izf4p.jsx)((0, $9f381c7225dd5629$export$6b319031325f309a), {})
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6), {
                                path: "places/:id",
                                element: /*#__PURE__*/ (0, $izf4p.jsx)((0, $09577d8d20c5576a$export$7c799e71f5549651), {})
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6), {
                                path: "account",
                                element: /*#__PURE__*/ (0, $izf4p.jsx)((0, $6e6e2197a139a572$export$1ed4b10e4aba04a7), {})
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6), {
                                path: "account/personal",
                                element: /*#__PURE__*/ (0, $izf4p.jsx)((0, $1bbfa55c44f1ea29$export$3965927bf7a81700), {})
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6), {
                                path: "account/bookings",
                                element: /*#__PURE__*/ (0, $izf4p.jsx)((0, $b6b72ebce52e7004$export$2eefd1d1c1af32ea), {})
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6), {
                                path: "account/listings",
                                element: /*#__PURE__*/ (0, $izf4p.jsx)((0, $f2e4f439a83b539c$export$ba6d244036e50401), {})
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6), {
                                path: "account/listings/new",
                                element: /*#__PURE__*/ (0, $izf4p.jsx)((0, $6ec5c2253820aee9$export$6b4e54eafd8bbce5), {})
                            }),
                            /*#__PURE__*/ (0, $izf4p.jsx)((0, $4fd73b9fb5b80e1f$export$e7b0ac011bb776c6), {
                                path: "account/help",
                                element: /*#__PURE__*/ (0, $izf4p.jsx)((0, $f5c06aafec330880$export$93b569af380b484c), {})
                            })
                        ]
                    })
                })
            })
        })
    })
}));

})();
//# sourceMappingURL=index.a96ac9ea.js.map
